webpackJsonp([89],{

/***/ "+3eL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(208);

/***/ }),

/***/ "+3of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EmailEditCard__ = __webpack_require__("BCsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TinyEditor__ = __webpack_require__("wfRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("qrgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_constants__ = __webpack_require__("st9j");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var DelayPrompt = function DelayPrompt(_ref) {
  var isMarketingSequencePlaybook = _ref.isMarketingSequencePlaybook,
      delay = _ref.delay,
      _ref$first = _ref.first,
      first = _ref$first === undefined ? false : _ref$first,
      onDelayChange = _ref.onDelayChange,
      onThreadedWithPreviousClick = _ref.onThreadedWithPreviousClick,
      threadedWithPrevious = _ref.threadedWithPrevious;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-email-delay drift-form' },
    !isMarketingSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-email-delay-thread' },
      'Thread with previous',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], {
        checked: threadedWithPrevious,
        onClick: onThreadedWithPreviousClick,
        className: 'playbook-email-delay-thread-toggle'
      })
    ),
    isMarketingSequencePlaybook ? 'Delay ' + (first ? 'first' : 'next') + ' email for ' : 'If no reply after ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', min: first ? 0 : 1, required: true, value: delay, onChange: onDelayChange, className: 'small' }),
    Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(delay, 'day'),
    isMarketingSequencePlaybook ? '' : ' then send...'
  );
};

var Email = function Email(_ref2) {
  var index = _ref2.index,
      email = _ref2.email,
      onDelayChange = _ref2.onDelayChange,
      onDeleteClick = _ref2.onDeleteClick,
      isMarketingSequencePlaybook = _ref2.isMarketingSequencePlaybook,
      isOutboundSequencePlaybook = _ref2.isOutboundSequencePlaybook,
      isLastEmail = _ref2.isLastEmail,
      hideDelay = _ref2.hideDelay,
      _ref2$showPersonaliza = _ref2.showPersonalization,
      showPersonalization = _ref2$showPersonaliza === undefined ? true : _ref2$showPersonaliza,
      onTitleChange = _ref2.onTitleChange,
      narrowHeader = _ref2.narrowHeader,
      onMessageChange = _ref2.onMessageChange,
      _ref2$actions = _ref2.actions,
      setSenderName = _ref2$actions.setSenderName,
      setAuthorId = _ref2$actions.setAuthorId,
      setEmailOverride = _ref2$actions.setEmailOverride,
      setSequenceIndividualEmailOverride = _ref2$actions.setSequenceIndividualEmailOverride,
      setSequenceIndividualSenderName = _ref2$actions.setSequenceIndividualSenderName,
      setEmailDelay = _ref2$actions.setEmailDelay,
      senderEmailOverride = _ref2.senderEmailOverride,
      sendFromOverride = _ref2.sendFromOverride,
      authorId = _ref2.authorId,
      onHeadlineChange = _ref2.onHeadlineChange,
      onCardMessageChange = _ref2.onCardMessageChange,
      dynamicAccountSendAttribute = _ref2.dynamicAccountSendAttribute,
      dynamicSenderFormat = _ref2.dynamicSenderFormat,
      onSendTestEmailClick = _ref2.onSendTestEmailClick,
      sendTestEmailLoading = _ref2.sendTestEmailLoading,
      sendTestEmailId = _ref2.sendTestEmailId,
      id = _ref2.id,
      isGoogleScopesPending = _ref2.isGoogleScopesPending,
      onThreadedWithPreviousClick = _ref2.onThreadedWithPreviousClick,
      showOneClickScheduling = _ref2.showOneClickScheduling,
      editSenderLevel = _ref2.editSenderLevel;

  var setSequenceSenderName = editSenderLevel === __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL ? function (name) {
    return setSequenceIndividualSenderName({ data: name, emailId: id });
  } : setSenderName;
  var setSequenceEmailOverride = editSenderLevel === __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL ? function (email) {
    return setSequenceIndividualEmailOverride({ data: email, emailId: id });
  } : setEmailOverride;
  var cardProps = {
    title: 'Email ' + (index + 1),
    description: email.title,
    bannerImageUrl: email.bannerImageUrl,
    onDeleteClick: (index || !isLastEmail) && onDeleteClick,
    onSequenceBodyChange: onMessageChange,
    onSequenceSubjectChange: onTitleChange,
    narrowHeader: narrowHeader,
    headline: email.title,
    onTitleChange: onTitleChange,
    body: email.message,
    includeSenderSelect: true,
    emailMessage: email,
    setSenderName: setSequenceSenderName,
    setAuthorId: setAuthorId,
    setEmailOverride: setSequenceEmailOverride,
    senderEmailOverride: senderEmailOverride,
    sendFromOverride: sendFromOverride,
    dynamicAccountSendAttribute: dynamicAccountSendAttribute,
    dynamicSenderFormat: dynamicSenderFormat,
    authorId: authorId,
    setHeadline: onHeadlineChange,
    setMessage: onCardMessageChange,
    onSendTestEmailClick: onSendTestEmailClick,
    sendTestLoading: id === sendTestEmailId && sendTestEmailLoading,
    id: id,
    showInlineTestEmail: isMarketingSequencePlaybook
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-email' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
      { condition: !hideDelay },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DelayPrompt, {
        delay: email.delay,
        first: index === 0,
        onDelayChange: onDelayChange,
        isMarketingSequencePlaybook: isMarketingSequencePlaybook,
        onThreadedWithPreviousClick: onThreadedWithPreviousClick,
        threadedWithPrevious: email.threadedWithPrevious
      })
    ),
    isMarketingSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'sequence-full-email-message' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__EmailEditCard__["a" /* default */], _extends({}, cardProps, { includeSenderSelect: isMarketingSequencePlaybook }))
    ),
    !isMarketingSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__Card__["a" /* default */],
      cardProps,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-email-headline' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
          className: email.threadedWithPrevious ? '' : 'playbook-email-headline-error',
          placeholder: email.threadedWithPrevious ? email.title : '[No Subject] - Required',
          value: email.threadedWithPrevious ? '' : email.title,
          onChange: onTitleChange,
          disabled: email.threadedWithPrevious
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', size: 'small', disabled: isGoogleScopesPending, onClick: onSendTestEmailClick, loading: id === sendTestEmailId && sendTestEmailLoading },
          'Send Test Email'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TinyEditor__["a" /* default */], {
        className: 'playbook-email-message',
        initialContent: email.message,
        onChange: onMessageChange,
        showPersonalization: showPersonalization,
        showOneClickScheduling: showOneClickScheduling,
        isOutboundSequencePlaybook: isOutboundSequencePlaybook
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Email);

/***/ }),

/***/ "+570":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 40C8.973 40 0 31.03 0 20 0 8.973 8.973 0 20 0s20 8.973 20 20c0 11.03-8.973 20-20 20zm0-37.5C10.35 2.5 2.5 10.35 2.5 20S10.35 37.5 20 37.5 37.5 29.65 37.5 20 29.65 2.5 20 2.5zm-1.505 24.63c-.242.245-.565.37-.887.37-.288 0-.577-.098-.81-.297L9.19 20.735c-.525-.446-.59-1.236-.143-1.76.448-.53 1.236-.593 1.763-.145l6.725 5.718L29.113 12.87c.485-.49 1.277-.495 1.767-.007.49.486.494 1.277.008 1.767l-12.393 12.5z\" fill=\"#13CB6E\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "+5bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox__ = __webpack_require__("cbHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("X5js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Divider = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
  style: {
    borderBottom: "1px solid #EEEEEE",
    marginBottom: 10,
    width: 145
  }
});

var BlueCaret = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
  src: __webpack_require__("Unpx"),
  style: { marginLeft: 3 }
});

var Filters = function (_Component) {
  _inherits(Filters, _Component);

  function Filters(props) {
    _classCallCheck(this, Filters);

    var _this = _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));

    _this.hideTypeFilters = function () {
      _this.setState({ showTypeFilters: false });
    };

    _this.toggleTypeFilters = function () {
      _this.setState({ showTypeFilters: !_this.state.showTypeFilters });
    };

    _this.onAllActivityClick = function () {
      _this.props.updateFilter(_this.props.filter.clear());
    };

    _this.onFilterClick = function (id, checked) {
      if (checked) {
        _this.props.updateFilter(_this.props.filter.set(id, true));
      } else {
        _this.props.updateFilter(_this.props.filter.delete(id));
      }
    };

    _this.state = {
      showTypeFilters: false
    };
    return _this;
  }

  _createClass(Filters, [{
    key: 'renderTypeFilterRow',
    value: function renderTypeFilterRow(key, display) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex dsg-Regular' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox___default.a, {
          checked: this.props.filter.get(key),
          id: key,
          onChange: this.onFilterClick
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'dsg-Body' },
          '\xA0\xA0',
          display
        )
      );
    }
  }, {
    key: 'renderDropDown',
    value: function renderDropDown() {
      if (!this.state.showTypeFilters) return;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components_DropDown__["a" /* default */],
        {
          onClickOutside: this.hideTypeFilters,
          className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.Dropdown
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex dsg-Regular' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox___default.a, {
            checked: this.props.filter.size === 0,
            id: 'all-activity',
            onChange: this.onAllActivityClick
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'dsg-Body' },
            '\xA0\xA0All activity'
          )
        ),
        Divider,
        this.renderTypeFilterRow('NOTE', 'Notes'),
        this.renderTypeFilterRow('CONVERSATION', 'Conversations'),
        this.renderTypeFilterRow('CAMPAIGN', 'Campaigns'),
        this.renderTypeFilterRow('PROPERTY', 'Properties'),
        this.renderTypeFilterRow('EVENT', 'Triggered Activities')
      );
    }
  }, {
    key: 'renderSelectionPhrase',
    value: function renderSelectionPhrase() {
      if (this.props.filter.size) {
        return this.props.filter.size + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(this.props.filter.size, 'activity type', 'activity types');
      } else {
        return 'all activity';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'dsg-Body', style: { marginBottom: 10 } },
        'Displaying\xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            style: {
              position: 'relative'
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              onClick: this.toggleTypeFilters,
              className: 'link'
            },
            this.renderSelectionPhrase(),
            BlueCaret
          ),
          this.renderDropDown()
        )
      );
    }
  }]);

  return Filters;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),

/***/ "+5q1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+65o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchUserProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchUserPropertiesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchUserPropertiesCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchUserPropertiesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return updateUserPropertiesTheRightWay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateUserProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateExtensionUserProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateClassificationsNotificationProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateUserPropertiesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateUserPropertiesCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateUserPropertiesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveUserProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchUsersByPropertyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchUsersByPropertyNamePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchUsersByPropertyNameSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchUsersByPropertyNameFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return userAtConversationLimitUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("7QUA");



var fetchUserProperties = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_USER_PROPERTIES */]);
var fetchUserPropertiesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_USER_PROPERTIES_PENDING */]);
var fetchUserPropertiesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_USER_PROPERTIES_CANCELLED */]);
var fetchUserPropertiesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_USER_PROPERTIES_FAILED */]);

var updateUserPropertiesTheRightWay = function updateUserPropertiesTheRightWay(properties, doNotify) {
  return function (dispatch) {
    return dispatch({
      type: __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UPDATE_USER_PROPERTIES */],
      payload: {
        notify: !!doNotify,
        properties: properties
      }
    });
  };
};

var updateUserProperties = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UPDATE_USER_PROPERTIES */]);
var updateExtensionUserProperty = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* UPDATE_EXTENSION_USER_PROPERTIES */]);
var updateClassificationsNotificationProperties = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES */]);

var updateUserPropertiesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* UPDATE_USER_PROPERTIES_PENDING */]);
var updateUserPropertiesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* UPDATE_USER_PROPERTIES_CANCELLED */]);
var updateUserPropertiesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* UPDATE_USER_PROPERTIES_FAILED */]);

var receiveUserProperties = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* RECEIVE_USER_PROPERTIES */]);

var fetchUsersByPropertyName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_USERS_BY_PROPERTY_NAME */]);
var fetchUsersByPropertyNamePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_USERS_BY_PROPERTY_NAME_PENDING */]);
var fetchUsersByPropertyNameSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_USERS_BY_PROPERTY_NAME_SUCCESS */]);
var fetchUsersByPropertyNameFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_USERS_BY_PROPERTY_NAME_FAILURE */]);

var userAtConversationLimitUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* USER_AT_CONVERSATION_LIMIT */]);

/***/ }),

/***/ "+7L0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RuleFilters__ = __webpack_require__("UAvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RuleActions__ = __webpack_require__("OeZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("G8qF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var RulesEditorOverview = function (_Component) {
  _inherits(RulesEditorOverview, _Component);

  function RulesEditorOverview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RulesEditorOverview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RulesEditorOverview.__proto__ || Object.getPrototypeOf(RulesEditorOverview)).call.apply(_ref, [this].concat(args))), _this), _this.saveTitleChange = function (event) {
      _this.props.updateTitle(event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RulesEditorOverview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rule = _props.rule,
          activeFilter = _props.activeFilter,
          isActionOnlyField = _props.isActionOnlyField;
      var _rule$data$item = rule.data.item,
          conditions = _rule$data$item.conditions,
          action = _rule$data$item.action,
          id = _rule$data$item.id;

      var noFilters = (conditions.length === 0 || conditions[0].length === 0) && !!id || isActionOnlyField(activeFilter.field);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-editor-overview' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text',
            value: this.props.rule.data.item.name,
            onChange: this.saveTitleChange,
            placeholder: 'Name your rule',
            id: 'title-input'
          })
        ),
        !noFilters && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RuleFilters__["a" /* default */], {
          conditions: conditions,
          setActivePage: this.props.setActivePage,
          activePage: this.props.activePage,
          activeFilter: this.props.activeFilter,
          setActiveFilter: this.props.setActiveFilter,
          currentPageIsValid: this.props.currentPageIsValid,
          saveActiveFilter: this.props.saveActiveFilter,
          removeFilter: this.props.removeFilter,
          isActionOnlyField: this.props.isActionOnlyField
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RuleActions__["a" /* default */], { action: action, setActivePage: this.props.setActivePage, users: this.props.users, activePage: this.props.activePage, noFilters: noFilters })
      );
    }
  }]);

  return RulesEditorOverview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RulesEditorOverview);

/***/ }),

/***/ "+8Qt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs__);







var ContactsApi = Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["createAuthedHttpClient"])({
  baseConfig: {
    baseURL: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["h" /* CONTACTS_API */]
  },
  paramsSerializer: function paramsSerializer(params) {
    return __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params, { arrayFormat: 'repeat' });
  }
});

var api = {
  fetchRevealDataByIp: function fetchRevealDataByIp(ip) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/reveal', { ip: ip }, { headers: { 'x-version': '2' } }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"]);
  },
  fetchRevealData: function fetchRevealData() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/reveal', options, { headers: { 'x-version': '2' } }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"]);
  },
  fetchRevealDataBySourceProperties: function fetchRevealDataBySourceProperties() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var endUserId = options.endUserId;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + endUserId, { sourceProperties: true }, { headers: { 'x-version': '2' } }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"]);
  },
  fetchDriftContactDerivationByEndUserId: function fetchDriftContactDerivationByEndUserId(_ref) {
    var endUserId = _ref.endUserId,
        orgId = _ref.orgId;

    var derivationRequestData = {
      orgId: orgId,
      endUserId: endUserId,
      targets: [1],
      allowExternalEnrichment: true,
      maxDepth: 2
    };

    return __WEBPACK_IMPORTED_MODULE_5_rxjs__["Observable"].from(ContactsApi.post('/derivation', derivationRequestData).then(function (res) {
      return res.data.derivedObjects['1'];
    }));
  }
};

/***/ }),

/***/ "+Fsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_middleware_rootEpic__ = __webpack_require__("5edS");



var rootEpicMiddleware = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["createEpicMiddleware"])(__WEBPACK_IMPORTED_MODULE_1_store_middleware_rootEpic__["a" /* default */]);

// if (module.hot) {
//   module.hot.accept('store/middleware/rootEpic', () => {
//     rootEpicMiddleware.replaceEpic(rootEpic)
//   })
// }

/* harmony default export */ __webpack_exports__["a"] = (rootEpicMiddleware);

/***/ }),

/***/ "+GRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conversationChanged */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__("a5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("dMZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_SortConversationsConstants__ = __webpack_require__("/Ggu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__("ly6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_enrichment_actions__ = __webpack_require__("SKr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_reveal_constants__ = __webpack_require__("BGpS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_conversation_models__ = __webpack_require__("5bKX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__bulkUpdate_actions__ = __webpack_require__("rpEm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__demodata__ = __webpack_require__("cKlu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cache_filters__ = __webpack_require__("lWyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_modules_notification_constants__ = __webpack_require__("Jq9o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_modules_endUser_api__ = __webpack_require__("Qfgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_modules_tracking_actions__ = __webpack_require__("mMZi");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



































function conversationChanged(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["LOCATION_CHANGE"]).pluck('payload').filter(function (_ref) {
    var pathname = _ref.pathname;
    return __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* CONVERSATIONS_REGEX */].test(pathname);
  }).map(function (_ref2) {
    var pathname = _ref2.pathname;
    return Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["a" /* conversationIdFromPathname */])(pathname);
  }).map(function (conversationId) {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["a" /* conversationChanged */]({ conversationId: conversationId });
  });
}

var INVALID_TIMESTAMP = 9223372036854776000;

function fetchConversation(action$, _ref3) {
  var getState = _ref3.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["h" /* fetchConversation */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (_ref4) {
    var conversationId = _ref4.conversationId,
        force = _ref4.force;

    var conversationLoaded = __WEBPACK_IMPORTED_MODULE_12__selectors__["o" /* makeConversationLoadedSelector */]();
    return !conversationLoaded(getState(), { conversationId: conversationId }) || force;
  }).mergeMap(function (_ref5) {
    var conversationId = _ref5.conversationId;


    if (__WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      var paginatedConversationDataSelector = __WEBPACK_IMPORTED_MODULE_12__selectors__["r" /* makePaginatedConversationData */]();
      var paginatedConversationData = paginatedConversationDataSelector(getState(), { conversationId: conversationId });

      var conversation = Object(__WEBPACK_IMPORTED_MODULE_19_app_modules_conversation_models__["a" /* parseConversation */])(_extends({
        id: conversationId
      }, __WEBPACK_IMPORTED_MODULE_27__demodata__["a" /* conversation */]({ conversationId: conversationId, endUserId: paginatedConversationData && paginatedConversationData.endUserId })));
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */]({ conversation: conversation }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetch(conversationId).map(function (conversation) {
        // NOTE: Some conversations mistakenly had `lastSentMessageTimestamp`
        // set to INVALID_TIMESTAMP. This logic overwrites that value to
        // `undefined` so that the invalid value is ignored in reducer logic.
        var validConversation = conversation;

        if (conversation.get('lastSentMessageTimestamp') === INVALID_TIMESTAMP) {
          validConversation = validConversation.set('lastSentMessageTimestamp', undefined);
        }

        return validConversation;
      }).map(function (conversation) {
        return __WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */]({ conversation: conversation });
      }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["n" /* fetchConversationPending */]({ conversationId: conversationId })).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["i" /* fetchConversationFailed */]({ conversationId: conversationId, error: error }));
      });
    }
  });
}

function getInfluencingPlaybookForConversation(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */].toString()).pluck('payload').filter(function (_ref6) {
    var conversation = _ref6.conversation;
    return !!conversation.getIn(['context', 'influencingCampaignId'], 0);
  }).mergeMap(function (_ref7) {
    var conversation = _ref7.conversation;

    var influencingCampaignId = conversation.getIn(['context', 'influencingCampaignId'], 0);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_23_app_modules_playbook_actions__["_68" /* getPlaybookByCampaignId */]({ campaignId: influencingCampaignId }));
  });
}

var extractQueryParams = function extractQueryParams(_ref8) {
  var query = _ref8.query;

  return {
    limit: 25,
    status: query.get('statusFilter'),
    tag: query.get('conversationTagFilter'),
    participantId: query.get('participantFilter'),
    sortBy: query.get('sortBy'),
    inboxId: query.get('inboxId')
  };
};

var fetchConversationsByInbox = function fetchConversationsByInbox(action$, _ref9) {
  var getState = _ref9.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["X" /* setQuery */].toString()).map(function () {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["j" /* fetchConversationList */]({ query: __WEBPACK_IMPORTED_MODULE_12__selectors__["d" /* activeQuery */](getState()) });
  });
};

var fetchConversationListClassic = function fetchConversationListClassic(_ref10) {
  var getState = _ref10.getState;
  return function (_ref11) {
    var query = _ref11.query,
        queryParams = _ref11.queryParams;

    var fetchConversations$ = (__WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState()) ? __WEBPACK_IMPORTED_MODULE_7__api__["d" /* demoApi */] : __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */]).fetchConversationsByInbox(queryParams);

    return fetchConversations$.map(function (paginatedConversations) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["m" /* fetchConversationListSuccess */]({ query: query, paginatedConversations: paginatedConversations });
    });
  };
};

// Using the new expanded ConversationClientAPI, we now short-circuit the need
// for additional round-trips to fetch endUsers and enrichmentData. Since we
// have access to multiple collections in a single response, we dispatch
// fetchSuccess actions for the respective collections.
var fetchConversationListExpanded = function fetchConversationListExpanded(_ref12) {
  var getState = _ref12.getState;
  return function (_ref13) {
    var query = _ref13.query,
        queryParams = _ref13.queryParams;

    var fetchEnrichedConversations$ = (__WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState()) ? __WEBPACK_IMPORTED_MODULE_7__api__["d" /* demoApi */] : __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */]).fetchEnrichedConversationsByInbox(queryParams);

    return fetchEnrichedConversations$.mergeMap(function (_ref14) {
      var paginatedConversations = _ref14.paginatedConversations,
          endUsers = _ref14.endUsers,
          enrichedCompanyDataByEndUserId = _ref14.enrichedCompanyDataByEndUserId;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of.apply(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"], [__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* fetchConversationListSuccess */]({ query: query, paginatedConversations: paginatedConversations }), __WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__["q" /* fetchEndUserListSuccess */]({ ids: endUsers.map(function (endUser) {
          return endUser.id;
        }).toArray(), data: endUsers })].concat(_toConsumableArray(enrichedCompanyDataByEndUserId.entrySeq().toArray().map(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
            endUserId = _ref16[0],
            data = _ref16[1];

        return Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_enrichment_actions__["l" /* receiveEndUserCompanyData */])({ endUserId: endUserId, data: data });
      }))));
    });
  };
};

var fetchBulkConversationEnrichmentData = function fetchBulkConversationEnrichmentData(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* fetchConversationListSuccess */].toString()).pluck('payload').filter(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_21_app_modules_user_properties_selectors__["b" /* hasCompactViewEnabled */])(store.getState());
  }).mergeMap(function (_ref17) {
    var paginatedConversations = _ref17.paginatedConversations;

    var convoEndUser = paginatedConversations.get('data').map(function (c) {
      return { endUserId: c.endUserId, conversationId: c.id };
    }).toArray();
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchBulkConversationEnrichmentData(convoEndUser).map(function (data) {
      return Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_enrichment_actions__["a" /* fetchBulkConversationEnrichmentDataSuccess */])({ data: data });
    });
  }).catch(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
  });
};

// Abstract away fetching conversations via the classic or expanded APIs.
// Fires off a PENDING action and gracefully handles errors by cleaning the
// filter cache and redirecting to the inboxes root route.
var fetchConversationList = function fetchConversationList(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* fetchConversationList */].toString()).pluck('payload').mergeMap(function (_ref18) {
    var query = _ref18.query,
        _ref18$queryParams = _ref18.queryParams,
        queryParams = _ref18$queryParams === undefined ? extractQueryParams({ query: query }) : _ref18$queryParams;

    var fetchConversationList$ = fetchConversationListClassic(store)({ query: query, queryParams: queryParams });

    return fetchConversationList$.startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["l" /* fetchConversationListPending */]({ query: query })).catch(function (error) {
      if (error.status > 400 && error.status < 500) {
        Object(__WEBPACK_IMPORTED_MODULE_28__cache_filters__["a" /* clearAll */])();
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])({ pathname: '/inboxes' }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["k" /* fetchConversationListFailed */]({ query: query, error: error }));
    });
  });
};

// Fire off an action to fetch the next page of results by hooking into the
// existing `fetchConversationsByInbox` epic, threading through an additional
// query param to represent the pagination offset.
var fetchNextConversationsByInbox = function fetchNextConversationsByInbox(action$, _ref19) {
  var getState = _ref19.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["w" /* fetchNextConversationList */].toString()).pluck('payload').mergeMap(function () {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { query: __WEBPACK_IMPORTED_MODULE_12__selectors__["d" /* activeQuery */](getState()) };
    var query = payload.query;

    var queryParams = extractQueryParams({ query: query });
    var cursorQueryParam = queryParams.sortBy === __WEBPACK_IMPORTED_MODULE_9_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].OLDEST.value ? 'before' : 'after';

    var fetchNextFailed$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["k" /* fetchConversationListFailed */].toString()).pluck('payload').filter(function (payload) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["is"])(query, payload.query);
    }).first();

    var fetchNextSuccess$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* fetchConversationListSuccess */].toString()).pluck('payload').filter(function (payload) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["is"])(query, payload.query);
    }).first().map(__WEBPACK_IMPORTED_MODULE_11__actions__["x" /* fetchNextConversationListSuccess */]);

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].race(fetchNextFailed$, fetchNextSuccess$).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* fetchConversationList */]({ query: query, queryParams: _extends({}, queryParams, _defineProperty({}, cursorQueryParam, __WEBPACK_IMPORTED_MODULE_12__selectors__["t" /* nextCursor */](getState(), { query: query }))) }));
  });
};

function fetchEndUsersForConversationsList(action$, _ref20) {
  var getState = _ref20.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["m" /* fetchConversationListSuccess */].toString(), __WEBPACK_IMPORTED_MODULE_11__actions__["x" /* fetchNextConversationListSuccess */].toString()).pluck('payload', 'paginatedConversations', 'data').mergeMap(function (conversations) {
    return __WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__["p" /* hasSplitEndUserChannel */](getState()) ? __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__["n" /* fetchEndUserList */]({ ids: conversations.map(function (_ref21) {
        var endUserId = _ref21.endUserId;
        return endUserId;
      }).toArray() })) // TODO: Remove after socket auth fixed
    : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__["n" /* fetchEndUserList */]({ ids: conversations.map(function (_ref22) {
        var endUserId = _ref22.endUserId;
        return endUserId;
      }).toArray() }));
  });
}

function fetchConversationsCountForEndUserId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["o" /* fetchConversationsCountForEndUserId */].toString()).pluck('payload').mergeMap(function (_ref23) {
    var id = _ref23.id;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchConversationsCountForEndUserId(id).map(function (count) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["r" /* fetchConversationsCountForEndUserIdSuccess */]({ id: id, count: count });
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["q" /* fetchConversationsCountForEndUserIdPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["p" /* fetchConversationsCountForEndUserIdFailed */](error));
    });
  });
}

function patchConversation(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["G" /* patchConversation */].toString()).pluck('payload').mergeMap(function (_ref24) {
    var id = _ref24.id,
        update = _ref24.update;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].patch(id, update).map(function (conversation) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */]({ conversation: conversation });
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["I" /* patchConversationPending */]({ id: id })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["H" /* patchConversationFailed */]({ id: id }));
    });
  });
}

function createConversation(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["b" /* createConversation */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref25) {
    var message = _ref25.message;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].create(message).map(function (conversation) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */]({ conversation: conversation });
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["d" /* createConversationPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["c" /* createConversationFailed */]({ error: error }));
    });
  });
}

function fetchCurrentConversation(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["a" /* conversationChanged */].toString()).pluck('payload', 'conversationId').filter(function (conversationId) {
    return !!conversationId;
  }).map(function (conversationId) {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["h" /* fetchConversation */]({ conversationId: conversationId });
  });
}

function fetchConversationEndUser(action$, _ref26) {
  var getState = _ref26.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */].toString()).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_26_app_modules_gates_selectors__["p" /* hasSplitEndUserChannel */](getState()) ? __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__["k" /* fetchEndUser */]({ id: action.payload.conversation.endUserId })) // TODO: Remove after socket auth fixed
    : __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_13_app_modules_endUser_actions__["k" /* fetchEndUser */]({ id: action.payload.conversation.endUserId }));
  });
}

function sendConversationTranscriptEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["M" /* sendConversationTranscript */].toString()).pluck('payload').mergeMap(function (payload) {
    var _payload$emails = payload.emails,
        emails = _payload$emails === undefined ? [] : _payload$emails,
        conversationId = payload.conversationId;

    var requests = emails.map(function (email) {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].sendConversationTranscript({ conversationId: conversationId, email: email });
    });
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].forkJoin(requests).map(function () {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["O" /* sendConversationTranscriptSuccess */](payload);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["N" /* sendConversationTranscriptFailure */](_extends({}, payload, { error: error })));
    });
  });
}

function sendConversationTranscriptSuccessNotifyEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["O" /* sendConversationTranscriptSuccess */].toString()).pluck('payload').filter(function (_ref27) {
    var _ref27$emails = _ref27.emails,
        emails = _ref27$emails === undefined ? [] : _ref27$emails;
    return emails.length > 0;
  }).do(function (_ref28) {
    var emails = _ref28.emails;

    __WEBPACK_IMPORTED_MODULE_6_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
      content: 'This chat transcript was successfully sent to ' + Object(__WEBPACK_IMPORTED_MODULE_4_humanize_plus__["oxford"])(emails, 4) + '!',
      variant: "green"
    });
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
  });
}

function sendConversationTranscriptFailureNotifyEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["N" /* sendConversationTranscriptFailure */].toString()).do(function () {
    __WEBPACK_IMPORTED_MODULE_6_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
      content: "We were unable to send a transcript for this conversation.",
      variant: "red"
    });
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
  });
}

function pushConversation(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_16_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_16_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref29) {
    var channel = _ref29.channel,
        leaveChannel$ = _ref29.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      var conversationDispatchHandler = function conversationDispatchHandler(currentUser, conversation) {
        if (conversation.status === 'BULK_SENT') {
          return;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_access_helpers__["b" /* hasConversationAccess */])(conversation.participantIds, currentUser)) {
          observer.next(__WEBPACK_IMPORTED_MODULE_11__actions__["J" /* receiveConversation */]({
            inboxId: conversation.inboxId,
            conversation: conversation
          }));
        }
      };

      channel.on('conversation-new', function (payload) {
        var conversation = Object(__WEBPACK_IMPORTED_MODULE_19_app_modules_conversation_models__["a" /* parseConversation */])(payload);
        var currentUser = __WEBPACK_IMPORTED_MODULE_17_app_modules_user_selectors__["currentUser"](store.getState());
        var currentInboxId = __WEBPACK_IMPORTED_MODULE_20_app_modules_inbox_selectors__["b" /* currentInboxId */](store.getState());

        conversationDispatchHandler(currentUser, conversation);

        if (conversation.inboxId === currentInboxId && Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_access_helpers__["b" /* hasConversationAccess */])(conversation.participantIds, currentUser)) {
          observer.next(__WEBPACK_IMPORTED_MODULE_22_app_modules_inbox_actions__["i" /* changeStatus */]({
            id: currentInboxId,
            status: conversation.status,
            currentParticipants: conversation.participantIds,
            currentUserId: currentUser.id
          }));
        }
      });

      channel.on('conversation-updated', function (payload) {
        var conversation = Object(__WEBPACK_IMPORTED_MODULE_19_app_modules_conversation_models__["a" /* parseConversation */])(payload);
        var currentUser = __WEBPACK_IMPORTED_MODULE_17_app_modules_user_selectors__["currentUser"](store.getState());
        conversationDispatchHandler(currentUser, conversation);
      });
    }).takeUntil(leaveChannel$);
  });
}

var setContactTabIndexOnShowRevealData = function setContactTabIndexOnShowRevealData(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_15_app_modules_reveal_constants__["n" /* SHOW_REVEAL_DATA */]).map(function () {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["Q" /* setActiveConversationContactTabIndex */](1);
  });
};

var fetchRoutingAuditLog = function fetchRoutingAuditLog(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["y" /* fetchRoutingAuditLog */].toString()).pluck('payload').filter(function (_ref30) {
    var routingGroupId = _ref30.routingGroupId;
    return __WEBPACK_IMPORTED_MODULE_12__selectors__["j" /* getRoutingAuditLogNeverLoaded */](store.getState(), routingGroupId);
  }).mergeMap(function (_ref31) {
    var conversationId = _ref31.conversationId,
        routingGroupId = _ref31.routingGroupId;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchRoutingAuditLog({ conversationId: conversationId, routingGroupId: routingGroupId }).map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["B" /* fetchRoutingAuditLogSuccess */]({ data: data, routingGroupId: routingGroupId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["A" /* fetchRoutingAuditLogPending */]({ routingGroupId: routingGroupId })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["z" /* fetchRoutingAuditLogFailed */]({ err: err, routingGroupId: routingGroupId }));
    });
  });
};

var deselectAllConversationsOnReceiveBulkUpdate = function deselectAllConversationsOnReceiveBulkUpdate(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_25__bulkUpdate_actions__["d" /* receiveBulkUpdateSuccess */].toString()).pluck('payload').map(function (_ref32) {
    var conversationDiffs = _ref32.conversationDiffs;

    var conversationIds = conversationDiffs.map(function (conversationDiff) {
      return conversationDiff.conversationId;
    });

    return __WEBPACK_IMPORTED_MODULE_11__actions__["g" /* deselectConversations */]({ conversationIds: conversationIds });
  });
};

var updateConversationsOnReceiveBulkUpdateSuccess = function updateConversationsOnReceiveBulkUpdateSuccess(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_25__bulkUpdate_actions__["d" /* receiveBulkUpdateSuccess */].toString()).pluck('payload').map(function (_ref33) {
    var conversationDiffs = _ref33.conversationDiffs;

    var updates = conversationDiffs.map(function (_ref34) {
      var conversationId = _ref34.conversationId,
          currentStatus = _ref34.currentStatus,
          currentParticipantIds = _ref34.currentParticipantIds;

      return {
        conversationId: conversationId,
        conversationStatus: currentStatus,
        participantIds: currentParticipantIds
      };
    });

    return __WEBPACK_IMPORTED_MODULE_11__actions__["Z" /* updateConversations */]({ updates: updates });
  });
};

var setConversationLimit = function setConversationLimit(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["S" /* setConversationLimit */].toString()).pluck('payload').mergeMap(function (_ref35) {
    var limitNumChatsEnabled = _ref35.limitNumChatsEnabled,
        limitNumChats = _ref35.limitNumChats;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].setConversationLimit(limitNumChatsEnabled, limitNumChats).switchMap(function (result) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
        observer.next(__WEBPACK_IMPORTED_MODULE_11__actions__["V" /* setConversationLimitSuccess */]({ limitNumChatsEnabled: limitNumChatsEnabled, limitNumChats: limitNumChats }));
        observer.next(__WEBPACK_IMPORTED_MODULE_24_app_modules_org_actions__["receiveOrgProperties"](result.response));
      });
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["U" /* setConversationLimitPending */]({ limitNumChatsEnabled: limitNumChatsEnabled, limitNumChats: limitNumChats })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["T" /* setConversationLimitFailure */]({ err: err, limitNumChatsEnabled: limitNumChatsEnabled, limitNumChats: limitNumChats }));
    });
  });
};

var fetchGlobalAutoCloseConfiguration = function fetchGlobalAutoCloseConfiguration(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["s" /* fetchGlobalAutoCloseConfiguration */].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchGlobalAutoCloseConfiguration().map(function (configuration) {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["v" /* fetchGlobalAutoCloseConfigurationSuccess */](configuration);
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["u" /* fetchGlobalAutoCloseConfigurationPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["t" /* fetchGlobalAutoCloseConfigurationFailure */](error));
    });
  });
};

var updateGlobalAutoCloseConfiguration = function updateGlobalAutoCloseConfiguration(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["_0" /* updateGlobalAutoCloseConfiguration */].toString()).pluck('payload').mergeMap(function (configuration) {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].updateGlobalAutoCloseConfiguration(configuration).map(function () {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["_3" /* updateGlobalAutoCloseConfigurationSuccess */](configuration);
    }).startWith(__WEBPACK_IMPORTED_MODULE_11__actions__["_2" /* updateGlobalAutoCloseConfigurationPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["_1" /* updateGlobalAutoCloseConfigurationFailure */](error));
    });
  });
};

var showComposeModalOnAbmNotificationClick = function showComposeModalOnAbmNotificationClick(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_29_app_modules_notification_constants__["e" /* SHOW_ABM_MODAL */]).pluck('payload').mergeMap(function (endUserIdAndAttributes) {
    var endUser$ = __WEBPACK_IMPORTED_MODULE_30_app_modules_endUser_api__["a" /* api */].fetch(endUserIdAndAttributes.endUserId);
    return endUser$.map(function (endUser) {
      return { endUser: endUser, companyName: endUserIdAndAttributes.companyName, page: endUserIdAndAttributes.page };
    });
  }).map(function (endUserAndAttributes) {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["R" /* setComposeModalStatus */]({
      status: true,
      endUser: endUserAndAttributes.endUser,
      composeType: "ABM",
      companyName: endUserAndAttributes.companyName,
      page: endUserAndAttributes.page
    });
  });
};

var fetchSuggestedArticles = function fetchSuggestedArticles(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__actions__["C" /* fetchSuggestedArticles */].toString()).pluck('payload').switchMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchSuggestedArticles(payload.lastMessageText).map(function (response) {
      if (response.suggestedActions.length > 0) {
        var conversationId = payload.conversationId;

        Object(__WEBPACK_IMPORTED_MODULE_31_app_modules_tracking_actions__["track"])('Got suggested articles', { conversationId: conversationId });
      }
      return __WEBPACK_IMPORTED_MODULE_11__actions__["F" /* fetchSuggestedArticlesSuccess */](response);
    }).startWith(function () {
      return __WEBPACK_IMPORTED_MODULE_11__actions__["E" /* fetchSuggestedArticlesPending */]();
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_11__actions__["D" /* fetchSuggestedArticlesFailed */](err));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchConversation, fetchConversationList, getInfluencingPlaybookForConversation, fetchConversationsByInbox, fetchNextConversationsByInbox, fetchEndUsersForConversationsList, fetchCurrentConversation, createConversation, fetchConversationEndUser, fetchConversationsCountForEndUserId, conversationChanged, sendConversationTranscriptEpic, sendConversationTranscriptSuccessNotifyEpic, sendConversationTranscriptFailureNotifyEpic, patchConversation, pushConversation, setContactTabIndexOnShowRevealData, fetchRoutingAuditLog, deselectAllConversationsOnReceiveBulkUpdate, updateConversationsOnReceiveBulkUpdateSuccess, setConversationLimit, showComposeModalOnAbmNotificationClick, fetchSuggestedArticles, fetchBulkConversationEnrichmentData, fetchGlobalAutoCloseConfiguration, updateGlobalAutoCloseConfiguration);

/***/ }),

/***/ "+H3u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TinyEditorModal__ = __webpack_require__("+qeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_utils__ = __webpack_require__("PIqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_female_placeholder_svg__ = __webpack_require__("Q8nZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_female_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_female_placeholder_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_team_2_svg__ = __webpack_require__("H439");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_team_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_team_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("87SI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm'
};

var DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR';

var CalendarPopoverSelect = function (_React$Component) {
  _inherits(CalendarPopoverSelect, _React$Component);

  function CalendarPopoverSelect() {
    _classCallCheck(this, CalendarPopoverSelect);

    return _possibleConstructorReturn(this, (CalendarPopoverSelect.__proto__ || Object.getPrototypeOf(CalendarPopoverSelect)).apply(this, arguments));
  }

  _createClass(CalendarPopoverSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          usersWithCalendar = _props.usersWithCalendar,
          usersWithoutCalendar = _props.usersWithoutCalendar,
          onDynamicCalSelect = _props.onDynamicCalSelect,
          search = _props.search,
          onSearchChange = _props.onSearchChange,
          onPropertySelect = _props.onPropertySelect,
          currentUser = _props.currentUser,
          currentUserHasCalendarConnected = _props.currentUserHasCalendarConnected,
          enableDynamicCalendarLink = _props.enableDynamicCalendarLink,
          disableDynamicCalendarLink = _props.disableDynamicCalendarLink,
          showCurrentUser = _props.showCurrentUser,
          isSearching = _props.isSearching;


      return React.createElement(
        'div',
        { className: 'modal-selector-container' },
        React.createElement(
          'div',
          { className: 'modal-selector-section modal-selector-section-top drift-form' },
          React.createElement('input', {
            className: 'modal-selector-search-input',
            type: 'text',
            value: search,
            onChange: onSearchChange,
            placeholder: 'Search'
          })
        ),
        React.createElement(
          'div',
          { className: 'tiny-calendar-modal-options' },
          !!enableDynamicCalendarLink && !disableDynamicCalendarLink && !isSearching && React.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tiny-calendar-modal-option'), onClick: onDynamicCalSelect },
            React.createElement(
              'div',
              { className: 'tiny-calendar-dynamic-option-icon' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_team_2_svg___default.a })
            ),
            React.createElement(
              'span',
              { className: 'tiny-calendar-modal-option-name' },
              'Insert dynamic calendar based email sender'
            )
          ),
          showCurrentUser && React.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tiny-calendar-modal-option', {
                'tiny-calendar-modal-option-disabled': !currentUserHasCalendarConnected
              }),
              onClick: function onClick() {
                return currentUserHasCalendarConnected ? onPropertySelect(currentUser) : null;
              }
            },
            React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: currentUser }),
            React.createElement(
              'span',
              { className: 'tiny-calendar-modal-option-name' },
              Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_utils__["a" /* getUserDisplayName */])(currentUser)
            ),
            !currentUserHasCalendarConnected && React.createElement(
              'a',
              { href: '/meetings/?source=email-playbook-editor', className: 'link dsg-Regular' },
              'Connect your calendar'
            )
          ),
          usersWithCalendar.map(function (user) {
            return React.createElement(
              'div',
              { key: user, className: 'tiny-calendar-modal-option', onClick: function onClick() {
                  return onPropertySelect(user);
                } },
              React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
              React.createElement(
                'span',
                { className: 'tiny-calendar-modal-option-name' },
                Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_utils__["a" /* getUserDisplayName */])(user)
              )
            );
          }),
          usersWithoutCalendar.size > 0 && React.createElement(
            'div',
            { className: 'tiny-calendar-modal-options-header' },
            'These calendars are not connected.'
          ),
          usersWithoutCalendar.map(function (user) {
            return React.createElement(
              'div',
              { key: user, className: 'tiny-calendar-modal-option tiny-calendar-modal-option-disabled' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
              React.createElement(
                'span',
                { className: 'tiny-calendar-modal-option-name' },
                Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_utils__["a" /* getUserDisplayName */])(user)
              )
            );
          }),
          usersWithoutCalendar.size === 0 && usersWithCalendar.size === 0 && !showCurrentUser && React.createElement(
            'div',
            { className: 'modal-selector-empty-options' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_female_placeholder_svg___default.a }),
            React.createElement(
              'p',
              null,
              'There is no one on your team by that name.'
            )
          )
        )
      );
    }
  }]);

  return CalendarPopoverSelect;
}(React.Component);

var CalendarPopoverConfirm = function CalendarPopoverConfirm(_ref) {
  var onDefaultCancel = _ref.onDefaultCancel,
      onDefaultConfirm = _ref.onDefaultConfirm,
      selectedUser = _ref.selectedUser,
      linkText = _ref.linkText,
      onDefaultChange = _ref.onDefaultChange,
      calendarProfileLoading = _ref.calendarProfileLoading,
      isOutboundSequencePlaybook = _ref.isOutboundSequencePlaybook;
  return React.createElement(
    'div',
    { className: 'modal-selector-container' },
    React.createElement(
      'div',
      { className: 'modal-selector-section modal-selector-section-top' },
      selectedUser === DYNAMIC_CALENDAR && React.createElement(
        'div',
        { className: 'modal-selector-user-preview' },
        React.createElement(
          'span',
          { className: 'tiny-calendar-dynamic-option-icon' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_team_2_svg___default.a })
        ),
        React.createElement(
          'span',
          { className: 'modal-selector-user-preview-name' },
          'Dynamic based on email sender'
        )
      ),
      selectedUser !== DYNAMIC_CALENDAR && React.createElement(
        'div',
        { className: 'modal-selector-user-preview' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: selectedUser }),
        React.createElement(
          'span',
          { className: 'modal-selector-user-preview-name' },
          Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_utils__["a" /* getUserDisplayName */])(selectedUser)
        )
      ),
      !isOutboundSequencePlaybook && React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'link preview-edit-link' },
        'Change'
      )
    ),
    React.createElement(
      'div',
      { className: 'drift-form modal-calendar-confirm-form' },
      React.createElement(
        'label',
        { className: 'default-form-label' },
        'Link text:'
      ),
      React.createElement('input', { type: 'text', value: linkText, onChange: onDefaultChange }),
      React.createElement(
        'p',
        { className: 'default-form-extra-details' },
        'Choose what text should appear for this link'
      )
    ),
    React.createElement(
      'div',
      { className: 'modal-selector-section modal-selector-section-bottom' },
      React.createElement(
        'div',
        {
          onClick: onDefaultConfirm,
          disabled: !!calendarProfileLoading,
          className: 'modal-selector-section-button drift-button drift-button-primary'
        },
        'Insert'
      ),
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'modal-selector-section-button drift-button drift-button-secondary' },
        'Cancel'
      )
    )
  );
};

var CalendarLinkModal = function CalendarLinkModal(_ref2) {
  var popoverStep = _ref2.popoverStep,
      hideCalendarLinkModal = _ref2.hideCalendarLinkModal,
      rest = _objectWithoutProperties(_ref2, ['popoverStep', 'hideCalendarLinkModal']);

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__TinyEditorModal__["a" /* default */],
    { title: "Insert Calendar Link", onClose: hideCalendarLinkModal },
    React.createElement(
      'div',
      { className: 'playbook-calendar-link-modal' },
      React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tiny-calendar-modal') },
        popoverStep === CalendarPopoverSteps.SELECT && React.createElement(CalendarPopoverSelect, rest),
        popoverStep === CalendarPopoverSteps.CONFIRM && React.createElement(CalendarPopoverConfirm, rest)
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarLinkModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "+Hgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return didPatchErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPatchLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
    return state.get('pardot');
};

var getMappings = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.integrationMappings;
});

var getFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.integrationFields;
});

var didPatchErr = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.integrationMappingsErr;
});

var isPatchLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.integrationPatchLoading;
});

/***/ }),

/***/ "+Juk":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.63 8L1.19 2.56A1.5 1.5 0 1 1 3.31.44l5.44 5.44L14.19.44a1.5 1.5 0 1 1 2.12 2.12L10.87 8l5.44 5.44a1.5 1.5 0 1 1-2.12 2.12l-5.44-5.44-5.44 5.44a1.5 1.5 0 1 1-2.12-2.12L6.63 8z\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "+KTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+KdC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(459);

/***/ }),

/***/ "+Q8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("pOjB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("FFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__demodata__ = __webpack_require__("2AxG");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var fetchDemandbaseCompanyData = function fetchDemandbaseCompanyData(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchDemandbaseCompanyData */].toString()).pluck('payload').mergeMap(function (options) {
    if (__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      return __WEBPACK_IMPORTED_MODULE_5__demodata__["a" /* companyData */].map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchDemandbaseCompanyDataSuccess */](_extends({ data: data }, options));
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchDemandbaseCompanyData(options).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchDemandbaseCompanyDataCancelled */]())).map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchDemandbaseCompanyDataSuccess */](_extends({ data: data }, options));
      }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchDemandbaseCompanyDataPending */]()).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchDemandbaseCompanyDataFailed */]({ error: error, options: options }));
      });
    }
  });
};

var fetchDemandbaseTargetingIndustries = function fetchDemandbaseTargetingIndustries(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchDemandbaseTargetingIndustries */].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchDemandbaseIndustries().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* fetchDemandbaseTargetingIndustriesSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchDemandbaseTargetingIndustriesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchDemandbaseTargetingIndustriesFailed */]({ error: error }));
    });
  });
};

var fetchDemandbaseTargetingSubIndustries = function fetchDemandbaseTargetingSubIndustries(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* fetchDemandbaseTargetingSubIndustries */].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchDemandbaseSubIndustries().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* fetchDemandbaseTargetingSubIndustriesSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* fetchDemandbaseTargetingSubIndustriesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* fetchDemandbaseTargetingSubIndustriesFailed */]({ error: error }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetchDemandbaseCompanyData, fetchDemandbaseTargetingIndustries, fetchDemandbaseTargetingSubIndustries);

/***/ }),

/***/ "+YYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__ = __webpack_require__("rFuW");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var NotificationStore = Marty.createStore({
  id: 'NotificationStore',

  getInitialState: function getInitialState() {
    return {
      currentNotifications: []
    };
  },


  handlers: {
    notificationDisplayed: __WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].NOTIFICATION_DISPLAY_DONE,
    pushNotification: __WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].NOTIFICATION_PUSH,
    clearNotifications: __WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].CLEAR_NOTIFICATIONS
  },

  pushNotification: function pushNotification(notification) {
    var currentNotifications = _.cloneDeep(this.state.currentNotifications);
    currentNotifications.push(notification);
    return this.setState({ currentNotifications: currentNotifications });
  },
  getNotifications: function getNotifications() {
    return this.state.currentNotifications;
  },
  notificationDisplayed: function notificationDisplayed() {
    var currentNotifications = _.cloneDeep(this.state.currentNotifications);
    currentNotifications.shift();
    return this.setState({ currentNotifications: currentNotifications });
  },
  clearNotifications: function clearNotifications() {
    return this.setState({ currentNotifications: [] });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NotificationStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "+YfV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Action__ = __webpack_require__("hgXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("2FY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var OutboundSendFrom = function OutboundSendFrom(_ref) {
  var onEditClick = _ref.onEditClick,
      isOutreachConnected = _ref.isOutreachConnected;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__Action__["a" /* default */],
    { onEditClick: onEditClick },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.OutboundSendFrom },
      isOutreachConnected ? React.createElement(
        'div',
        null,
        React.createElement(
          'p',
          null,
          'This Welcome Message will send from the teammate who sent the email using Drift, or who enrolled them in an ',
          React.createElement(
            'a',
            { href: 'https://app.drift.com/settings/setup/outreach' },
            'Outreach sequence'
          ),
          '.'
        ),
        React.createElement('br', null),
        React.createElement(
          'p',
          null,
          React.createElement(
            'a',
            { onClick: onEditClick },
            'Invite your teammates to use the extension.'
          )
        )
      ) : React.createElement(
        'p',
        null,
        'This Welcome Message will send from the teammate who sent the Drift Sequence or the tracked email from the Drift Extension. ',
        React.createElement(
          'a',
          { onClick: onEditClick },
          'Invite your teammates to use the extension.'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OutboundSendFrom);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "+Z1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseUser;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__("TL61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("aJZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_web_auth__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









function parseUser(data) {
  var gates = data.gates,
      avatars = data.avatars,
      rest = _objectWithoutProperties(data, ['gates', 'avatars']);

  return Object(__WEBPACK_IMPORTED_MODULE_3__models__["d" /* User */])(_extends({
    gates: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(gates),
    avatars: Object(__WEBPACK_IMPORTED_MODULE_3__models__["a" /* Avatars */])(avatars)
  }, rest));
}

var api = {
  create: function create(orgId, user) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/users', user).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(parseUser);
  },
  createByEmail: function createByEmail(email, password) {
    var body = { email: email };
    if (password) {
      _extends(body, { password: password });
    }

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/users', body, { auth: false, clientId: true }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
  },
  fetchCurrent: function fetchCurrent() {
    var _this = this;

    return _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/users/me').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).catch(function (error) {
                if (error.status === 401 || error.status === 403) {
                  Object(__WEBPACK_IMPORTED_MODULE_7__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */]);
                }
              }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(parseUser));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  fetch: function fetch(userId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/users/' + userId).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(parseUser);
  },
  fetchEmailSignature: function fetchEmailSignature(userId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/users/' + userId + '/email_signature').checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  fetchOrgSignature: function fetchOrgSignature(_ref) {
    var userId = _ref.userId;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/users/' + userId + '/email_signature/v2').checkStatus().retryWithBackoff(1).map(function (res) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(res.response);
    });
  },
  fetchOrgMultiSignature: function fetchOrgMultiSignature(_ref2) {
    var userId = _ref2.userId;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/users/' + userId + '/email_signature/all').checkStatus().retryWithBackoff(1).map(function (res) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(res.response);
    });
  },
  setEmailSignature: function setEmailSignature(userId, emailSignature) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/users/' + userId + '/email_signature', { emailSignature: emailSignature }).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  fetchUsers: function fetchUsers(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/organizations/' + orgId + '/users', {
      status: [__WEBPACK_IMPORTED_MODULE_4__constants__["_9" /* UserStatus */].INVITED, __WEBPACK_IMPORTED_MODULE_4__constants__["_9" /* UserStatus */].ENABLED, __WEBPACK_IMPORTED_MODULE_4__constants__["_9" /* UserStatus */].ARCHIVED]
    }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(function (data) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(data).map(parseUser);
    });
  },
  update: function update(userId, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/users/' + userId, updates).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  fetchClearbitForEmail: function fetchClearbitForEmail(email) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/enrichment/single/' + email).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  enrichEmail: function enrichEmail(email) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/enrichment/single/' + email).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  patchUser: function patchUser(userId, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/users/' + userId + '/patch', updates).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(parseUser);
  },
  setOrgUserStatus: function setOrgUserStatus(userId, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/users/' + userId + '/patch', updates).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
  },
  archive: function archive(userId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/users/' + userId, { status: __WEBPACK_IMPORTED_MODULE_4__constants__["_9" /* UserStatus */].ARCHIVED }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
  },
  changePassword: function changePassword(userId, currentPassword, newPassword) {
    var handleErrorWithJson = function handleErrorWithJson(err) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"])(err).then(function (parsedResponse) {
        return Promise.reject(parsedResponse);
      });
    };

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/users/' + userId + '/password2?clientId=' + __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["f" /* CLIENT_ID */], {
      currentPassword: currentPassword,
      newPassword: newPassword
    }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"], handleErrorWithJson);
  },
  uploadAvatar: function uploadAvatar(userId, file) {
    var data = new FormData();
    data.append('file', file);

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/users/' + userId + '/avatar', data).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  checkUserExistsByEmail: function checkUserExistsByEmail(email) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].head('/users', { email: email }, { auth: false });
  },
  checkUserExistsByEmailAndOrgHandle: function checkUserExistsByEmailAndOrgHandle(email, orgHandle) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].head('/users', { email: email, orgHandle: orgHandle }, { auth: false });
  },
  sendWelcomeEmail: function sendWelcomeEmail() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/users/welcome?isMobile=' + isMobile).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
  },
  turnOffManualAway: function turnOffManualAway(_ref3) {
    var userId = _ref3.userId;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/agents/' + userId + '/turn-off-manual-away').checkStatus().retryWithBackoff().mapResponse(parseUser);
  },
  fetchGoogleScopes: function fetchGoogleScopes() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxMeetingsAPI"].get('/google/calendar/oauth/scopes').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  disconnectGmailAccount: function disconnectGmailAccount() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/google/calendar/disconnect/').checkStatus();
  },
  resetEmailSignature: function resetEmailSignature(userId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/users/' + userId + '/email_signature', { default: true }).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  fetchIndividualConvoLimit: function fetchIndividualConvoLimit() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/users/convo-limit').checkStatus().map(function (res) {
      return res.response;
    });
  },
  updateIndividualConvoLimit: function updateIndividualConvoLimit(limit, remove) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/users/convo-limit?limit=' + limit + '&remove=' + remove).checkStatus().map(function (res) {
      return res.response;
    });
  },
  updateUser: function updateUser(user) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].patch('/users/v2/' + user.id, user).checkStatus().map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "+aVH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_playbook_components_Editor__ = __webpack_require__("eJtH");


var BotFollowUp = function BotFollowUp(_ref) {
  var showFollowUpPrompt = _ref.showFollowUpPrompt,
      questionIndex = _ref.questionIndex,
      response = _ref.response,
      onResponseChange = _ref.onResponseChange;
  return React.createElement(
    "div",
    null,
    showFollowUpPrompt && React.createElement(
      "div",
      null,
      React.createElement(
        "strong",
        null,
        "Enter the Bot\u2019s Follow Up Response"
      ),
      React.createElement(
        "p",
        null,
        "Your lead has answered Question ",
        questionIndex + 1,
        ". How do you want the bot to respond?"
      )
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_playbook_components_Editor__["a" /* default */], {
      value: response,
      onChange: onResponseChange,
      placeholder: "Add your follow up text",
      popoverAnchorBottom: true
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BotFollowUp);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "+c5p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");



var Routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
  { path: '/internal/drift-admin-panel', component: function component() {
      return window.location.replace('/settings2/deal-admin');
    } },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'deal-admin', component: function component() {
      return window.location.replace('/settings2/deal-admin');
    } })
);

/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),

/***/ "+cTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_renderComponent__ = __webpack_require__("N71h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_renderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_renderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("mVBF");














var mapStateToProps = function mapStateToProps(state) {
  return {
    playbookStatus: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_99" /* status */](state),
    isSaving: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_47" /* isSaving */](state),
    isSaved: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_46" /* isSaved */](state),
    isArchived: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_29" /* isArchived */](state),
    isPlaybookChangePending: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_57" /* pendingPlaybookChanges */](state),
    isOneTimeEmailPlaybook: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_4" /* getIsOneTimeEmailPlaybook */](state),
    isAutosaveActive: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_30" /* isAutosaveActive */](state),
    saveFailed: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_68" /* saveFailed */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      disablePlaybookAutosave: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["O" /* disablePlaybookAutosave */],
      savePlaybookDraft: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_110" /* savePlaybookDraft */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (_ref) {
  var isArchived = _ref.isArchived;
  return isArchived;
}, __WEBPACK_IMPORTED_MODULE_2_recompose_renderComponent___default()(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* ArchivedStatus */])), __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default()(function (props) {
  return {
    isEnabled: props.playbookStatus === __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  handleSavePlaybookDraft: function handleSavePlaybookDraft(props) {
    return function () {
      props.actions.savePlaybookDraft();
    };
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (_ref2) {
  var isAutosaveActive = _ref2.isAutosaveActive;
  return !isAutosaveActive;
}, __WEBPACK_IMPORTED_MODULE_2_recompose_renderComponent___default()(__WEBPACK_IMPORTED_MODULE_10__component__["c" /* SaveStatus */])))(__WEBPACK_IMPORTED_MODULE_10__component__["b" /* AutoSaveStatus */]));

/***/ }),

/***/ "+dPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export root */
/* unused harmony export rules */
/* unused harmony export onCall */
/* unused harmony export rulesLoading */
/* unused harmony export activeRule */
/* unused harmony export flatRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return userIdsForRules; });
/* unused harmony export rulesLoaded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeRule; });
/* unused harmony export getRuleById */
/* unused harmony export getIsRoundRobinLoadPending */
/* unused harmony export getRoundRobinLoadFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRoundRobinData; });
/* unused harmony export hasVisualRoutingBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_gates_selectors__ = __webpack_require__("OWv3");


var root = function root(state) {
  return state.get('rules');
};

var rules = function rules(state) {
  return root(state).get('rules');
};
var onCall = function onCall(state) {
  return root(state).get('onCall');
};
var rulesLoading = function rulesLoading(state) {
  return root(state).get('rulesLoading');
};
var activeRule = function activeRule(state) {
  return root(state).get('activeRule');
};
var flatRules = function flatRules(state) {
  return root(state).get('flatRules');
};
var userIdsForRules = function userIdsForRules(state) {
  return root(state).get('userIdsForRules');
};
var rulesLoaded = function rulesLoaded(state) {
  return root(state).get('rulesLoaded');
};

var makeRule = function makeRule() {
  return function (state, props) {
    var result = _.find(rules(state), function (rule) {
      return rule.id === props.ruleId;
    });
    if (result) {
      return result.item;
    }
  };
};

var getRuleById = function getRuleById(state, props) {
  var result = _.find(rules(state), function (rule) {
    return rule.id === props.ruleId;
  });
  if (result) {
    return result;
  }
};
var roundRobinStatusByKey = function roundRobinStatusByKey(state) {
  return root(state).get('roundRobinStatusByKey');
};

var getRoundRobinByKey = function getRoundRobinByKey(state, key) {
  return roundRobinStatusByKey(state).get(key, new Map());
};

var getIsRoundRobinLoadPending = function getIsRoundRobinLoadPending(state, key) {
  return getRoundRobinByKey(state, key).get('loading');
};

var getRoundRobinLoadFailed = function getRoundRobinLoadFailed(state, key) {
  return !!getRoundRobinByKey(state, key).get('err');
};

var getRoundRobinData = function getRoundRobinData(state, key) {
  return getRoundRobinByKey(state, key).get('data');
};

var hasVisualRoutingBuilder = function hasVisualRoutingBuilder(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_gates_selectors__["u" /* makeHasGate */])('HAS_VISUAL_ROUTING_BUILDER')(state);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "+ecq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_INTEGRATION_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_INTEGRATION_STATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_INTEGRATION_STATES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_INTEGRATION_STATES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_INTEGRATION_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_INTEGRATION_STATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_INTEGRATION_STATE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_INTEGRATION_STATE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_PAGINATED_INTEGRATION_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return POST_BUSINESS_EVENT_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return POST_BUSINESS_EVENT_CSV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return POST_BUSINESS_EVENT_CSV_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_INTEGRATION_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_INTEGRATION_EVENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_INTEGRATION_EVENTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_INTEGRATION_EVENTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DESTORY_INTEGRATION_EVENTS; });
/* unused harmony export FETCH_FACEBOOK_SETTINGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_FACEBOOK_SETTINGS_PENDING; });
/* unused harmony export FETCH_FACEBOOK_SETTINGS_FAILED */
/* unused harmony export FETCH_FACEBOOK_SETTINGS_SUCCESS */
/* unused harmony export FETCH_FACEBOOK_SETTINGS_CANCELLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_OUTREACH_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_OUTREACH_STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_OUTREACH_STATUS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_OUTREACH_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_ACCESS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_ACCESS_TOKEN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ACCESS_TOKEN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_ACCESS_TOKEN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_SLACKBOT_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_WORDPRESS_V2_INTEGRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SET_WORDPRESS_V2_INTEGRATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SET_WORDPRESS_V2_INTEGRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_WORDPRESS_V2_INTEGRATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_WORDPRESS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_WORDPRESS_DOMAIN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_WORDPRESS_DOMAIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_WORDPRESS_DOMAIN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_WORDPRESS_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_WORDPRESS_DOMAIN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_WORDPRESS_DOMAIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_WORDPRESS_DOMAIN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_STRIPE_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_STRIPE_KEYS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_STRIPE_KEYS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_STRIPE_KEYS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_STRIPE_KEYS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_SANDBOX_ACCESS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_LEANDATA_AUTH_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_LEANDATA_AUTH_STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_LEANDATA_AUTH_STATUS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_LEANDATA_AUTH_STATUS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_LEANDATA_AUTH_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return LeanDataAuthStatuses; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('integrations');

var FETCH_INTEGRATION_STATES = makeConstant('FETCH_INTEGRATION_STATES');
var FETCH_INTEGRATION_STATES_SUCCESS = makeConstant('FETCH_INTEGRATION_STATES_SUCCESS');
var FETCH_INTEGRATION_STATES_FAILED = makeConstant('FETCH_INTEGRATION_STATES_FAILED');
var FETCH_INTEGRATION_STATES_PENDING = makeConstant('FETCH_INTEGRATION_STATES_PENDING');

var UPDATE_INTEGRATION_STATE = makeConstant('UPDATE_INTEGRATION_STATE');
var UPDATE_INTEGRATION_STATE_SUCCESS = makeConstant('UPDATE_INTEGRATION_STATE_SUCCESS');
var UPDATE_INTEGRATION_STATE_FAILED = makeConstant('UPDATE_INTEGRATION_STATE_FAILED');
var UPDATE_INTEGRATION_STATE_PENDING = makeConstant('UPDATE_INTEGRATION_STATE_PENDING');

var FETCH_PAGINATED_INTEGRATION_EVENTS = makeConstant('FETCH_PAGINATED_INTEGRATION_EVENTS');
var FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS = makeConstant('FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS');

var POST_BUSINESS_EVENT_CSV = makeConstant('POST_BUSINESS_EVENT_CSV');
var POST_BUSINESS_EVENT_CSV_SUCCESS = makeConstant('POST_BUSINESS_EVENT_CSV_SUCCESS');
var POST_BUSINESS_EVENT_CSV_FAILED = makeConstant('POST_BUSINESS_EVENT_CSV_FAILED');

var FETCH_INTEGRATION_EVENTS = makeConstant('FETCH_INTEGRATION_EVENTS');
var FETCH_INTEGRATION_EVENTS_SUCCESS = makeConstant('FETCH_INTEGRATION_EVENTS_SUCCESS');
var FETCH_INTEGRATION_EVENTS_FAILED = makeConstant('FETCH_INTEGRATION_EVENTS_FAILED');
var FETCH_INTEGRATION_EVENTS_PENDING = makeConstant('FETCH_INTEGRATION_EVENTS_PENDING');

var DESTORY_INTEGRATION_EVENTS = makeConstant('DESTORY_INTEGRATION_EVENTS');

var FETCH_FACEBOOK_SETTINGS = makeConstant('FETCH_FACEBOOK_SETTINGS');
var FETCH_FACEBOOK_SETTINGS_PENDING = makeConstant('FETCH_FACEBOOK_SETTINGS_PENDING');
var FETCH_FACEBOOK_SETTINGS_FAILED = makeConstant('FETCH_FACEBOOK_SETTINGS_FAILED');
var FETCH_FACEBOOK_SETTINGS_SUCCESS = makeConstant('FETCH_FACEBOOK_SETTINGS_SUCCESS');
var FETCH_FACEBOOK_SETTINGS_CANCELLED = makeConstant('FETCH_FACEBOOK_SETTINGS_CANCELLED');

var FETCH_OUTREACH_STATUS = makeConstant('FETCH_OUTREACH_STATUS');
var FETCH_OUTREACH_STATUS_PENDING = makeConstant('FETCH_OUTREACH_STATUS_PENDING');
var FETCH_OUTREACH_STATUS_FAILED = makeConstant('FETCH_OUTREACH_STATUS_FAILED');
var FETCH_OUTREACH_STATUS_SUCCESS = makeConstant('FETCH_OUTREACH_STATUS_SUCCESS');

var CREATE_ACCESS_TOKEN = makeConstant('CREATE_ACCESS_TOKEN');
var CREATE_ACCESS_TOKEN_PENDING = makeConstant('CREATE_ACCESS_TOKEN_PENDING');
var CREATE_ACCESS_TOKEN_FAILED = makeConstant('CREATE_ACCESS_TOKEN_FAILED');
var CREATE_ACCESS_TOKEN_SUCCESS = makeConstant('CREATE_ACCESS_TOKEN_SUCCESS');

var CREATE_SLACKBOT_TOKEN = makeConstant('CREATE_SLACKBOT_TOKEN');

var SET_WORDPRESS_V2_INTEGRATION = makeConstant('SET_WORDPRESS_V2_INTEGRATION');
var SET_WORDPRESS_V2_INTEGRATION_PENDING = makeConstant('SET_WORDPRESS_V2_INTEGRATION_PENDING');
var SET_WORDPRESS_V2_INTEGRATION_SUCCESS = makeConstant('SET_WORDPRESS_V2_INTEGRATION_SUCCESS');
var SET_WORDPRESS_V2_INTEGRATION_FAILED = makeConstant('SET_WORDPRESS_V2_INTEGRATION_FAILED');

var SET_WORDPRESS_DOMAIN = makeConstant('SET_WORDPRESS_DOMAIN');
var SET_WORDPRESS_DOMAIN_PENDING = makeConstant('SET_WORDPRESS_DOMAIN_PENDING');
var SET_WORDPRESS_DOMAIN_SUCCESS = makeConstant('SET_WORDPRESS_DOMAIN_SUCCESS');
var SET_WORDPRESS_DOMAIN_FAILED = makeConstant('SET_WORDPRESS_DOMAIN_FAILED');

var FETCH_WORDPRESS_DOMAIN = makeConstant('FETCH_WORDPRESS_DOMAIN');
var FETCH_WORDPRESS_DOMAIN_PENDING = makeConstant('FETCH_WORDPRESS_DOMAIN_PENDING');
var FETCH_WORDPRESS_DOMAIN_SUCCESS = makeConstant('FETCH_WORDPRESS_DOMAIN_SUCCESS');
var FETCH_WORDPRESS_DOMAIN_FAILED = makeConstant('FETCH_WORDPRESS_DOMAIN_FAILED');

var FETCH_STRIPE_KEYS = makeConstant('FETCH_STRIPE_KEYS');
var FETCH_STRIPE_KEYS_PENDING = makeConstant('FETCH_STRIPE_KEYS_PENDING');
var FETCH_STRIPE_KEYS_FAILED = makeConstant('FETCH_STRIPE_KEYS_FAILED');
var FETCH_STRIPE_KEYS_SUCCESS = makeConstant('FETCH_STRIPE_KEYS_SUCCESS');
var FETCH_STRIPE_KEYS_CANCELLED = makeConstant('FETCH_STRIPE_KEYS_CANCELLED');

var CREATE_SANDBOX_ACCESS_TOKEN = makeConstant('CREATE_SANDBOX_ACCESS_TOKEN');

var GET_LEANDATA_AUTH_STATUS = makeConstant('GET_LEANDATA_AUTH_STATUS');
var GET_LEANDATA_AUTH_STATUS_PENDING = makeConstant('GET_LEANDATA_AUTH_STATUS_PENDING');
var GET_LEANDATA_AUTH_STATUS_FAILED = makeConstant('GET_LEANDATA_AUTH_STATUS_FAILED');
var GET_LEANDATA_AUTH_STATUS_CANCELLED = makeConstant('GET_LEANDATA_AUTH_STATUS_CANCELLED');
var GET_LEANDATA_AUTH_STATUS_SUCCESS = makeConstant('GET_LEANDATA_AUTH_STATUS_SUCCESS');

var GoogleScopes = Object.freeze({
  CALENDAR: 'https://www.googleapis.com/auth/calendar',
  READ: 'https://www.googleapis.com/auth/gmail.readonly',
  SEND: 'https://www.googleapis.com/auth/gmail.send'
});

var LeanDataAuthStatuses = Object.freeze({
  UNSUCCESSFUL_API_REQUEST: "UNSUCCESSFUL_API_REQUEST",
  SALESFORCE_AUTHENTICATION_ISSUE: "SALESFORCE_AUTHENTICATION_ISSUE",
  LEANDATA_USER_PERMISSIONS: "LEANDATA_USER_PERMISSIONS",
  LEANDATA_ORGANIZATION_PERMISSIONS: "LEANDATA_ORGANIZATION_PERMISSIONS",
  NO_ERROR: "NO_ERROR"
});

/***/ }),

/***/ "+f5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SalesforcePlaybookCampaignSelect__ = __webpack_require__("a3xq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaybookInboxSelect__ = __webpack_require__("MiBH");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var PlaybookSelects = function (_Component) {
    _inherits(PlaybookSelects, _Component);

    function PlaybookSelects(props) {
        var _this2 = this;

        _classCallCheck(this, PlaybookSelects);

        var _this = _possibleConstructorReturn(this, (PlaybookSelects.__proto__ || Object.getPrototypeOf(PlaybookSelects)).call(this, props));

        _this.fetchSFDCConnection = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var data;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].fetchSFDCConnection();

                        case 3:
                            data = _context.sent;

                            _this.setState({
                                isSalesforceConnected: data
                            });
                            _context.next = 10;
                            break;

                        case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            console.log(_context.t0);

                        case 10:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 7]]);
        }));

        _this.renderForPlaybookByType = function (type) {
            return type === "ABM" || type === "EMPTY_WELCOME_MESSAGE" || type === "TALK_TO_YOUR_OUTBOUND_PROSPECTS";
        };

        _this.state = {
            isSalesforceConnected: false
        };
        return _this;
    }

    _createClass(PlaybookSelects, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchSFDCConnection();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                playbookId = _props.playbookId,
                reportType = _props.reportType;
            var isSalesforceConnected = this.state.isSalesforceConnected;


            return isSalesforceConnected && this.renderForPlaybookByType(reportType) ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'inbox-select-wrapper' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PlaybookInboxSelect__["a" /* default */], null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SalesforcePlaybookCampaignSelect__["a" /* default */], {
                    playbookId: playbookId,
                    description: 'Associate leads/contacts from this playbook with a Salesforce Campaign',
                    defaultSelectLabelText: "Search for a Salesforce Campaign" })
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PlaybookInboxSelect__["a" /* default */], null)
            );
        }
    }]);

    return PlaybookSelects;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PlaybookSelects);

/***/ }),

/***/ "+gtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMapURL;
/* unused harmony export getMapByCity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");



function getMapURL(lat, lng, width, height) {
  var query = {
    center: lat + ',' + lng,
    key: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["u" /* GOOGLE_API_KEY */],
    size: width + 'x' + height,
    zoom: 12,
    style: 'element:labels|visibility:off&feature:administrative.neighborhood|visibility:off'
  };
  return 'https://maps.googleapis.com/maps/api/staticmap?' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])(query);
}

function getMapByCity(city) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 360;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;

  var query = {
    center: city,
    key: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["u" /* GOOGLE_API_KEY */],
    size: width + 'x' + height,
    zoom: 8,
    style: 'element:labels|visibility:off&feature:administrative.neighborhood|visibility:off'
  };
  return 'https://maps.googleapis.com/maps/api/staticmap?' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])(query);
}

/***/ }),

/***/ "+lmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymirror__);


var ConversationTypes = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  EMAIL: null,
  CHAT: null,
  PRIVATE_NOTE: null,
  PRIVATE_PROMPT: null
});

/* harmony default export */ __webpack_exports__["a"] = (ConversationTypes);

/***/ }),

/***/ "+qeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("pcjm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])()(function (_ref) {
  var _cx;

  var onClose = _ref.onClose,
      title = _ref.title,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$long = _ref.long,
      long = _ref$long === undefined ? false : _ref$long;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tiny-editor-modal', { 'tiny-editor-modal-long': long }) },
    React.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tiny-editor-modal-overlay', { 'tiny-editor-modal-long': long }), onClick: onClose }),
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tiny-editor-modal-content', (_cx = {}, _defineProperty(_cx, className, !!className), _defineProperty(_cx, 'tiny-editor-modal-long', long), _cx)) },
      React.createElement(
        'header',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tiny-editor-modal-header', { 'tiny-editor-modal-long': long }) },
        React.createElement(
          'span',
          { className: 'tiny-editor-modal-title' },
          title
        ),
        React.createElement(
          'span',
          { className: 'drift-button tiny-editor-modal-close-button', onClick: onClose },
          '\xD7'
        )
      ),
      React.createElement(
        'div',
        { className: 'tiny-editor-modal-body' },
        children
      )
    )
  );
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "+st4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/* harmony default export */ __webpack_exports__["default"] = (Marty.createActionCreators({
  // Add action helpers here for server resources
  saveMessageUserDraft: function saveMessageUserDraft(draft) {
    return this.app.stores.DraftStore.saveMessageUserDraft(draft);
  },
  saveEmailCaptureDraft: function saveEmailCaptureDraft(draft) {
    return this.app.stores.DraftStore.saveEmailCaptureDraft(draft);
  },


  // Add action helpers here for server resources
  saveNPSDraft: function saveNPSDraft(draft) {
    return this.app.stores.DraftStore.saveNPSDraft(draft);
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "+xIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("hJjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("WpOi");
var _handleActions, _handleActions2, _handleActions3;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* uploadCsv */], __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* uploadCsvPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* uploadCsvFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* uploadCsvCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* uploadCsvSuccess */]), function (state, action) {
  return state.set('upload', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* startCsvImport */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* startCsvImportPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* startCsvImportFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* startCsvImportSuccess */]), function (state, action) {
  return state.set('start', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearCsv */], function () {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var selected = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* setSelected */], function (state, action) {
  return action.payload.filter(function (attribute) {
    return !!attribute;
  }).keySeq().toSet();
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* toggleColumn */], function (state, action) {
  var column = action.payload.column;

  if (state.has(column)) {
    return state.delete(column);
  } else {
    return state.add(column);
  }
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearCsv */], function () {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])());

var data = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* uploadCsv */], function (state, action) {
  return state.set('fileName', action.payload.file.name);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* uploadCsvSuccess */], function (state, action) {
  return state.set('csvImport', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* setMapping */], function (state, action) {
  return state.setIn(['csvImport', 'attributeMapping'], action.payload);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearCsv */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* uploadCsvCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* uploadCsvFailed */]), function (state) {
  return state.delete('fileName').set('csvImport', Object(__WEBPACK_IMPORTED_MODULE_4__models__["a" /* CsvImport */])());
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ status: status, data: data, selected: selected }));

/***/ }),

/***/ "+xoI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"WelcomeLayoutContainer":"WelcomeLayoutContainer---2hjV2","WelcomeLayout":"WelcomeLayout---dwttv","NavButtons":"NavButtons---3efYg","BreadCrumbContainer":"BreadCrumbContainer---1lGW8","WelcomeLayoutNav":"WelcomeLayoutNav---JCJzf","WelcomePreview":"WelcomePreview---3INBp","WelcomeTitle":"WelcomeTitle---twGU6","WelcomeTip":"WelcomeTip---1XDcs","WelcomeBreadCrumbs":"WelcomeBreadCrumbs---3GFGD","WelcomeContainer":"WelcomeContainer---1YBSi","Welcome":"Welcome---2PUAH","ProfileDetails":"ProfileDetails---7Amdw","Integration":"Integration---2L8S2"};

/***/ }),

/***/ "+xoY":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 11 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.44 0A5.19 5.19 0 0 0 .495 6.767v.003c.163.508.402.982.703 1.41l4.263 8.548 4.23-8.56c.302-.432.543-.91.704-1.426A5.19 5.19 0 0 0 5.44 0zm0 7.724a2.607 2.607 0 1 1 0-5.215 2.607 2.607 0 0 1 0 5.214z\" fill=\"#9A9A9A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "+xz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component__ = __webpack_require__("3MHh");



















var mapStateToProps = function mapStateToProps(state) {
  var draft = __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["n" /* draft */](state);
  return {
    goals: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_56" /* orderedGoals */](state),
    userListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    excludedUserListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["A" /* excludedUserListIds */](state),
    questions: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_66" /* questions */](state),
    numQuestions: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_55" /* numQuestions */](state),
    audience: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["d" /* audience */](state),
    classifications: __WEBPACK_IMPORTED_MODULE_14_app_modules_classification_selectors__["a" /* classificationOptions */](state),
    isLeadBot: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_40" /* isLeadBot */](state),
    isSignaturePlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_48" /* isSignaturePlaybook */](state),
    interaction: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_27" /* interaction */](state),
    isDriftLinkOnly: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_35" /* isDriftLinkOnly */](state),
    isMessageTypePlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_42" /* isMessageTypePlaybook */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    isSequencePlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_7" /* getIsSequencePlaybook */](state),
    reportType: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_67" /* reportType */](state),
    targetingConditionsCount: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_10" /* getNumConditions */](state),
    isOneTimeMarketingSequencePlaybook: draft.reportType === __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_ONE_TIME_SEQUENCE,
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state),
    hasSegmentDisplayTargeting: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__["u" /* makeHasGate */])('has_segment_display_targeting')(state),
    hasModularizedAudienceBuilder: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__["u" /* makeHasGate */])('has_modularized_audience_builder')(state),
    hasAccountSegmentation: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__["u" /* makeHasGate */])('ACCOUNTS_SEGMENTATION')(state) // TODO: unused for now, we'll use it once the backend is ready for account segmentation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      addGoal: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["h" /* addGoal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_7_react_router__["h" /* withRouter */], __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function (props) {
  return {
    hasOnlyExclusionTargeting: props.isSequencePlaybook && !props.isMarketingSequencePlaybook
  };
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function (props) {
  var targetingIconLink = 'audience';
  if (props.hasOnlyExclusionTargeting) {
    targetingIconLink = 'exclude';
  } else if (props.isLeadBot) {
    targetingIconLink = 'driftLink';
  } else if (props.isOnFreePlan) {
    targetingIconLink = 'display';
  }
  var audiencePreview = __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["u" /* AudienceDisplay */][props.audience || 'NONE'];
  var audienceInclusionPreview = audiencePreview;
  if (props.userListIds.size > 0 && props.audience == __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["w" /* AudienceType */].SEGMENT) {
    audienceInclusionPreview = props.userListIds.size + ' ' + Object(__WEBPACK_IMPORTED_MODULE_6_humanize_plus__["pluralize"])(props.userListIds.size, 'Segment');
  } else if (props.isEmailPlaybook) {
    audienceInclusionPreview = 'Segment';
  }

  var enablePlaybookLabelText = props.isSignaturePlaybook || props.isOutboundSequencePlaybook ? 'Enable' : props.isEmailPlaybook ? 'Send Email' : 'Enable Playbook';

  return {
    driftLink: !!props.interaction && props.interaction.get('slug'),
    audiencePreview: audiencePreview,
    audienceInclusionPreview: audienceInclusionPreview,
    targetingGroupTitle: props.isEmailPlaybook ? 'Audience' : 'Targeting',
    targetingIconLink: targetingIconLink,
    classificationsByGoalId: props.goals.reduce(function (acc, goal) {
      var result = props.classifications.find(function (classification) {
        return classification.value === goal.classification.get('classificationId');
      });
      return !!result ? acc.set(goal.id, result.label) : acc;
    }, Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()),
    hasDriftLink: props.isLeadBot,
    viewConfig: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["_142" /* PlaybookViewConfig */][props.reportType] || {},
    baseUrl: '/playbooks/' + props.playbookId + '/edit',
    reviewText: enablePlaybookLabelText
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  renderDisplayPreview: function renderDisplayPreview(props) {
    return function () {
      var targetingConditionsCount = props.targetingConditionsCount;

      if (!targetingConditionsCount) {
        return __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["_287" /* TargetingDisplay */].ALWAYS;
      }
      return targetingConditionsCount + ' ' + Object(__WEBPACK_IMPORTED_MODULE_6_humanize_plus__["pluralize"])(targetingConditionsCount, 'Condition');
    };
  },
  onAddGoalClick: function onAddGoalClick(props) {
    return function () {
      var addGoal = props.actions.addGoal,
          playbookId = props.playbookId,
          classifications = props.classifications;

      var classificationId = _.get(classifications, '[0].value');
      var goalId = Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])();
      addGoal({
        goal: __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_models__["g" /* Goal */]({
          id: goalId,
          classification: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({ classificationId: classificationId }),
          routing: __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_models__["n" /* RoutingOption */]({ type: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL })
        }),
        playbookId: playbookId
      });
      props.router.push({ pathname: '/playbooks/' + playbookId + '/edit/goal/' + goalId });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_15__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "+zL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ON24 = function ON24() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "ON24 customer? Deploy Drift on your ON24 Engagement Hub and Target pages to start personalized conversations like you would on your website. Now, you can pair the right content experience with the right conversation."
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "h3",
      null,
      "Adding Drift to an ON24 Target Page"
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      "To take advantage of this new functionality, navigate to the Attributes tab and enter your Drift widget ID into the designated field. For Engagement Hub, you\u2019ll need to do this only once. For Target, after you enter the Drift widget ID for your initial page, the Drift widget ID will be available for all subsequent Target pages."
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "p",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "span",
        null,
        "Need some help? "
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "a",
        { href: "//gethelp.drift.com/hc/en-us/articles/360051178713-How-to-Add-Drift-to-your-ON24-Audience-Console-Engagement-Hub-and-Target-Pages", target: "_blank" },
        "Learn more here!"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ON24);

/***/ }),

/***/ "/1Fz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg__ = __webpack_require__("FZ6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_minus_svg__ = __webpack_require__("3iND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_minus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("80MG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);












var CQLBar = function CQLBar(_ref) {
  var score = _ref.score,
      onClick = _ref.onClick,
      isPlaceholder = _ref.isPlaceholder;

  if (isPlaceholder) {
    var placeholderShape = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0', y: '0', width: '229', height: '27', rx: '2' });

    var options = {
      height: 27,
      width: 229,
      primaryColor: __WEBPACK_IMPORTED_MODULE_4_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
      secondaryColor: __WEBPACK_IMPORTED_MODULE_4_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
      primaryOpacity: __WEBPACK_IMPORTED_MODULE_4_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
      secondaryOpacity: __WEBPACK_IMPORTED_MODULE_4_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'conversation-cql-bar-container placeholder' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 })
    );
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'conversation-cql-bar-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'conversation-cql-bar-title' },
      'mark as cql'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'conversation-cql-bar' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: onClick(-1),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('conversation-cql-bar-option', 'cql-bar-unqualified', { selected: score === -1 }),
          flow: 'up',
          tooltip: 'Unqualified'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-minus-icon', src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_minus_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: onClick(1),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('conversation-cql-bar-option', 'cql-bar-good', { selected: score === 1 }),
          flow: 'up',
          tooltip: 'Good CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: onClick(2),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('conversation-cql-bar-option', 'cql-bar-better', { selected: score === 2 }),
          flow: 'up',
          tooltip: 'Better CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: onClick(3),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('conversation-cql-bar-option', 'cql-bar-best', { selected: score === 3 }),
          flow: 'up',
          tooltip: 'Best CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'conversation-cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CQLBar);

/***/ }),

/***/ "/1Nw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3JQ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 28 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.45 23H2.33C1.055 23 .017 21.968.017 20.7V2.3C.018 1.032 1.056 0 2.33 0h23.12c1.274 0 2.514 1.032 2.514 2.3v18.4c0 1.268-1.24 2.3-2.514 2.3zm.18-20.7H2.33v10.15l6.183-5.273c.457-.39 1.142-.366 1.57.06l6.227 6.195 3.822-2.852c.492-.367 1.188-.286 1.58.184l3.92 4.676L25.63 2.3zm0 16.732l-4.99-5.957-3.745 2.795c-.46.344-1.104.298-1.51-.107l-6.18-6.147L2.33 15.48v5.22h23.3v-1.668zM18.515 6.9c0-1.268 1.037-2.3 2.313-2.3 1.274 0 2.31 1.032 2.31 2.3 0 1.268-1.036 2.3-2.31 2.3-1.276 0-2.313-1.032-2.313-2.3zm2.31 0l.003 1.15V6.9h-.003z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "/3M9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Integration_components_OauthConnector__ = __webpack_require__("YIzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Template__ = __webpack_require__("xI2r");



// import { captureException, captureResponseException } from 'utils/SentryHelpers'

var SLACK_OAUTH_PAYLOAD = {
  client_id: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["Z" /* SLACK_CLIENT_ID */],
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/slack',
  state: ''
};
var SLACK_AUTH_URL = 'https://slack.com/oauth/authorize';

var CONNECT_COPY = ["Did you know you can talk to your customers on the go right from", React.createElement('img', { style: { width: 61, height: 18, marginLeft: 5, marginRight: 5, verticalAlign: "middle" }, src: __webpack_require__("88BI") }), "?"];

var ConnectButton = React.createElement(
  'button',
  {
    className: 'dsg-LargeButton color-teal',
    onClick: function onClick() {
      var path = Object(__WEBPACK_IMPORTED_MODULE_1_components_Integration_components_OauthConnector__["b" /* makeOauthUrl */])(SLACK_AUTH_URL, SLACK_OAUTH_PAYLOAD);
      window.location.href = path;
    }
  },
  'CONNECT TO SLACK'
);

var mailToHref = "mailto:?subject=Drift%20%3C%3E%20Slack&body=Hey!%20Do%20you%20mind%20helping%20me%20integrate%20Drift%20with%20our%20Slack%20account%20so%20we%20can%20talk%20to%20customers%20on%20the%20go?";
var ContactTeam = React.createElement(
  'a',
  { style: { marginTop: 20, textDecoration: "underline" }, href: mailToHref, className: 'color-gray-dark' },
  'Or ask a technical co-worker to'
);

var ConnectedToSlack = React.createElement(__WEBPACK_IMPORTED_MODULE_2__Template__["a" /* default */], {
  title: 'Looks like you\u2019re on a mobile device.',
  copy: CONNECT_COPY,
  button: [ConnectButton, ContactTeam]
});

/* harmony default export */ __webpack_exports__["a"] = (ConnectedToSlack);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "/40Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/5zg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/896":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_CookieHelpers__ = __webpack_require__("WB5i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccountStatusPane__ = __webpack_require__("eYyn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountCallToActionPane__ = __webpack_require__("UZTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_DriftAPI__ = __webpack_require__("f9kp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TEAM_TRIAL_DAYS = 14;
var TRIAL_DAILY_SUGGESTION = 'DriftTrialDaily';
var TRIAL_EXPIRED_COPY = React.createElement(
  'span',
  null,
  'Your trial has ended. We hope it was a radical experience.'
);

function pluralizeDays(dayCount) {
  return dayCount + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(dayCount, 'day');
}

var TrialMessaging = function (_Component) {
  _inherits(TrialMessaging, _Component);

  function TrialMessaging(props) {
    _classCallCheck(this, TrialMessaging);

    var _this = _possibleConstructorReturn(this, (TrialMessaging.__proto__ || Object.getPrototypeOf(TrialMessaging)).call(this, props));

    _this.handleDismiss = function () {
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_CookieHelpers__["b" /* setCookie */])(TRIAL_DAILY_SUGGESTION, true, { expires: __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('day').toDate() });
      _this.setState({ dismissed: true });
    };

    _this.openChatWidget = function () {
      var chatPayload = {
        message: 'Hey there - have any questions about moving forward with the trial? Let me know.'
      };
      if (__WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */] && __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["R" /* SALES_USER_ID */]) {
        chatPayload.inboxId = __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */];
        chatPayload.sender = { id: __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["R" /* SALES_USER_ID */] };
      }
      __WEBPACK_IMPORTED_MODULE_6_components_shared_DriftAPI__["a" /* default */].showWelcomeMessage(chatPayload);
    };

    _this.getDaysRemaining = function () {
      var expirationMoment = _this.getExpiration();
      var remainingDuration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(expirationMoment.diff(__WEBPACK_IMPORTED_MODULE_1_moment___default()()));
      return Math.floor(remainingDuration.asDays());
    };

    _this.state = {
      dismissed: false
    };
    return _this;
  }

  _createClass(TrialMessaging, [{
    key: 'getExpiration',
    value: function getExpiration() {
      var trialExpiresAt = this.props.orgProperties.trialExpiresAt;

      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(+trialExpiresAt);
    }
  }, {
    key: 'isTrialExpired',
    value: function isTrialExpired() {
      var expirationMoment = this.getExpiration();
      return expirationMoment.isBefore();
    }
  }, {
    key: 'renderTrialInProgressCopy',
    value: function renderTrialInProgressCopy() {
      var daysLeft = this.getDaysRemaining();
      return React.createElement(
        'span',
        null,
        'You have ',
        daysLeft,
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(daysLeft, 'day'),
        ' remaining in your free trial.'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var dismissed = this.state.dismissed;
      var currentPath = this.props.currentPath;

      if (currentPath !== '/home' || dismissed) {
        return false;
      }
      var daysSoFar = TEAM_TRIAL_DAYS - this.getDaysRemaining();
      var quotaPercentage = Math.floor(daysSoFar / TEAM_TRIAL_DAYS * 100);
      var callToActionCopy = this.isTrialExpired() ? TRIAL_EXPIRED_COPY : this.renderTrialInProgressCopy();
      return React.createElement(
        'div',
        { className: 'notification-bar' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4__AccountStatusPane__["a" /* default */], {
          planTitle: 'Trial Plan',
          planDescription: 'Free Trial',
          counters: [{
            title: pluralizeDays(TEAM_TRIAL_DAYS - daysSoFar) + ' to go!',
            description: quotaPercentage
          }]
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_5__AccountCallToActionPane__["a" /* default */], {
          ctaTitle: callToActionCopy,
          ctaDescription: 'You currently have access to everything in the Pro plan. Loving it so far? Talk to us to upgrade your account. ',
          buttonLabel: 'Talk to us',
          handleClick: this.openChatWidget,
          handleDismiss: this.handleDismiss
        })
      );
    }
  }]);

  return TrialMessaging;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TrialMessaging);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "/8Kr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/marketo-logo-text.6ebd6566.png";

/***/ }),

/***/ "/Abo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseEndUser;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_user_models__ = __webpack_require__("TL61");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function parseEndUser(data) {
  var attributes = data.attributes,
      tags = data.tags,
      avatars = data.avatars,
      rest = _objectWithoutProperties(data, ['attributes', 'tags', 'avatars']);

  return EndUser(_extends({
    avatars: Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_user_models__["a" /* Avatars */])(avatars),
    attributes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(attributes),
    tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(tags)
  }, rest));
}

var EndUser = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  avatars: Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_user_models__["a" /* Avatars */])(),
  id: undefined,
  orgId: undefined,
  customerId: undefined,
  status: undefined,
  name: undefined,
  alias: null,
  email: undefined,
  phone: null,
  locale: null,
  timeZone: null,
  avatarUrl: null,
  primaryIdentity: undefined,
  createdAt: undefined,
  externalId: undefined,
  socialProfile: null,
  attributes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  happiness: undefined,
  type: undefined
});

/***/ }),

/***/ "/EMc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProfileIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DismissIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("XydC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var PROFILE_ICON_SVG = __webpack_require__("mQlq");
var DISMISS_ICON_SVG = __webpack_require__("9zaA");

var ProfileIconPropTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
function iconComponentFactory(name, src, defaultProps) {
  if (name && src === undefined) {
    src = name;
    name = null;
  }
  var Icon = function Icon(_ref) {
    var className = _ref.className,
        style = _ref.style,
        onClick = _ref.onClick,
        rest = _objectWithoutProperties(_ref, ['className', 'style', 'onClick']);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, _extends({}, rest, {
      style: style,
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.Icon, className),
      element: 'div',
      onClick: onClick,
      src: src
    }));
  };
  if (name) {
    Icon.displayName = 'Icon(' + name + ')';
  }
  Icon.defaultProps = _extends({}, defaultProps);
  Icon.propTypes = _extends({}, ProfileIconPropTypes);
  return Icon;
}

var ProfileIcon = iconComponentFactory('Profile', PROFILE_ICON_SVG);
var DismissIcon = iconComponentFactory('Dismiss', DISMISS_ICON_SVG, { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.DismissIcon });

/***/ }),

/***/ "/Ggu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SortConversationsEnum; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);


var SortConversationsEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a({
  'NEWEST': 'newest',
  'OLDEST': 'oldest'
});

/***/ }),

/***/ "/Iz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CloseButton__ = __webpack_require__("xmq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("NiPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("3NcN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var TakeoverPreview = function TakeoverPreview(_ref) {
  var message = _ref.message,
      headline = _ref.headline,
      ctaCopy = _ref.ctaCopy,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? "000000" : _ref$backgroundColor,
      _ref$showCta = _ref.showCta,
      showCta = _ref$showCta === undefined ? true : _ref$showCta,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === undefined ? 'Arial' : _ref$fontFamily;
  return React.createElement(
    'div',
    { className: 'takeover-preview--root', style: { fontFamily: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FontFamilies */][fontFamily] } },
    React.createElement(
      'div',
      { className: 'takeover-preview--content' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0__CloseButton__["a" /* default */], null),
      React.createElement(
        'div',
        { className: 'takeover-preview--text' },
        React.createElement(
          'h2',
          { className: 'takeover-preview--headline' },
          headline
        ),
        React.createElement('p', { className: 'takeover-preview--copy', dangerouslySetInnerHTML: { __html: message } })
      ),
      showCta && React.createElement(
        'div',
        { className: 'takeover-preview--cta', style: { background: '#' + backgroundColor } },
        ctaCopy
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TakeoverPreview);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "/POY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var OrgPropertiesConstants = Marty.createConstants(['FETCH_ORG_PROPERTIES', 'UPDATE_ORG_PROPERTIES', 'UPLOAD_ORG_LOGO', 'UPLOAD_ORG_IMAGE']);

/* harmony default export */ __webpack_exports__["a"] = (OrgPropertiesConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "/SsX":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNTgiIHZpZXdCb3g9IjAgMCA1OCA1OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDI5YzAgMTYuMDE3IDEyLjgzMyAyOSAyOC42NjMgMjlzMjguNjYzLTEyLjk4MyAyOC42NjMtMjlTNDQuNDkzIDAgMjguNjYzIDAgMCAxMi45ODMgMCAyOXptMjcuMTYyIDguMzVjLS4zNy4yMi0uODI2LjIyLTEuMi4wMDYtLjAwMiAwLTUuMDk2LTMuMDA1LTUuMDk2LTMuMDA1djExLjE0YzAgLjQ0LS4yMy44NS0uNjA0IDEuMDctLjE4OC4xMS0uMzk2LjE2Ni0uNjA1LjE2Ni0uMjEgMC0uNDE3LS4wNTYtLjYwNS0uMTY1bC0zLjA0LTEuNzkyYy0uMzc1LS4yMi0uNjA2LS42My0uNjA2LTEuMDdWMzEuMTMybC00LjkxMy0yLjg5NmMtLjM3NS0uMjItLjYwNS0uNjMtLjYwNS0xLjA3di00LjgwMmMwLS40NC4yMy0uODQ4LjYwNS0xLjA3LjM3NS0uMjIuODM1LS4yMiAxLjIxIDBsMTUuNDYgOS4xMTNjLjM3NC4yMjIuNjA0LjYzLjYwNCAxLjA3djQuODA2YzAgLjQ0My0uMjMuODUtLjYwNSAxLjA3em0uMDIzLTE4LjgyOEwyMi41MSAyMS4yOHYzLjYzYzAgLjM3LS4zOS42MDItLjcwNy40MTYtMS44ODQtMS4xMS03LjAxLTQuMTI3LTguODg2LTUuMjI3LS4zMTQtLjE4NS0uMzA3LS42NC4wMDYtLjgyNGwxMy4yOS03LjgzNmMuMzc1LS4yMi44MzYtLjIyIDEuMjEgMCAuMzc1LjIyLjYwNi42My42MDYgMS4wN3Y0LjUyNmMwIC42MTItLjMyMiAxLjE3Ny0uODQ1IDEuNDg2em0yLjk4LTcuMDgyYy4zNzItLjIyLjgzNC0uMjIgMS4yMDggMGwxMy4yODQgNy44M2MuMzE3LjE4OC4zMjIuNjQ4LjAwNS44MzQtMS44NzcgMS4xLTYuOTcyIDQuMS04Ljg2NCA1LjIxNC0uMzIuMTktLjcyLS4wNDgtLjcyLS40MjR2LTMuNTY3YzAtLjAzLS4wMTYtLjA1OC0uMDQyLS4wNzNsLTQuODcyLTIuODcyYy0uMzc1LS4yMjItLjYwNi0uNjMtLjYwNi0xLjA3VjEyLjUxYzAtLjQ0LjIzLS44NS42MDYtMS4wN3ptMTYuNjY4IDE2Ljc5NEw0MS45MiAzMS4xM1Y0My43YzAgLjQ0LS4yMy44NDctLjYwNSAxLjA2OGwtMy4wNCAxLjc5M2MtLjE5LjExLS4zOTcuMTY2LS42MDYuMTY2LS4yMSAwLS40MTgtLjA1Ni0uNjA2LS4xNjUtLjM3NS0uMjItLjYwNS0uNjMtLjYwNS0xLjA3VjM0LjM1bC01LjA4NyAzYy0uMzgzLjIyLS44MzguMjItMS4yMSAwLS4zNzQtLjIyLS42MDUtLjYyNy0uNjA1LTEuMDd2LTQuODA0YzAtLjQ0LjIzLS44NS42MDYtMS4wN2wxNS40Ni05LjExM2MuMzczLS4yMi44MzQtLjIyIDEuMjEgMCAuMzc0LjIyLjYwNC42MjguNjA0IDEuMDd2NC44YzAgLjQ0Mi0uMjMuODUtLjYwNSAxLjA3eiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ "/Txf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_NotificationHelper__ = __webpack_require__("a56C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("HLzC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_message_actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__("fvUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__("21sf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__selectors__ = __webpack_require__("LEIz");




















function fetchParticipants(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_15__actions__["e" /* fetchParticipants */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (_ref2) {
    var conversationId = _ref2.conversationId;
    return !__WEBPACK_IMPORTED_MODULE_16__selectors__["b" /* participantsLoaded */](conversationId)(getState());
  }).switchMap(function (_ref3) {
    var conversationId = _ref3.conversationId;


    if (__WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_15__actions__["i" /* receiveParticipants */]({ participants: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(), conversationId: conversationId }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* api */].fetch(conversationId).map(function (participants) {
        return __WEBPACK_IMPORTED_MODULE_15__actions__["i" /* receiveParticipants */]({ participants: participants, conversationId: conversationId });
      }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_15__actions__["f" /* fetchParticipantsCancelled */].toString())).startWith(__WEBPACK_IMPORTED_MODULE_15__actions__["h" /* fetchParticipantsPending */]({ conversationId: conversationId })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_15__actions__["g" /* fetchParticipantsFailed */]({ conversationId: conversationId, error: error }));
      });
    }
  });
}

function addParticipants(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_15__actions__["a" /* addParticipants */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref4) {
    var conversationId = _ref4.conversationId,
        participants = _ref4.participants,
        teams = _ref4.teams;

    return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* api */].add({ conversationId: conversationId, participants: participants, teams: teams }).map(function (_ref5) {
      var participants = _ref5.participants;
      return __WEBPACK_IMPORTED_MODULE_15__actions__["d" /* addParticipantsSuccess */]({ conversationId: conversationId, participants: participants });
    }).startWith(__WEBPACK_IMPORTED_MODULE_15__actions__["c" /* addParticipantsPending */]({ conversationId: conversationId, participants: participants })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_15__actions__["b" /* addParticipantsFailed */]({ conversationId: conversationId, participants: participants, error: error }));
    });
  });
}

function removeParticipants(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_15__actions__["j" /* removeParticipants */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref6) {
    var conversationId = _ref6.conversationId,
        participants = _ref6.participants;

    return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* api */].remove(conversationId, participants).map(function (_ref7) {
      var participants = _ref7.participants;
      return __WEBPACK_IMPORTED_MODULE_15__actions__["m" /* removeParticipantsSuccess */]({ conversationId: conversationId, participants: participants });
    }).startWith(__WEBPACK_IMPORTED_MODULE_15__actions__["l" /* removeParticipantsPending */]({ conversationId: conversationId, participants: participants })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_15__actions__["k" /* removeParticipantsFailed */]({ conversationId: conversationId, participants: participants, error: error }));
    });
  });
}

function conversationEvent(action$, _ref8) {
  var getState = _ref8.getState;

  var participantEvent$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_6_app_modules_message_actions__["v" /* receiveMessage */].toString()).pluck('payload', 'message').filter(function (_ref9) {
    var type = _ref9.type;
    return type === 'CONVERSATION_EVENT';
  }).filter(function (_ref10) {
    var type = _ref10.conversationEvent.type;

    return type === 'ADDED_PARTICIPANTS' || type === 'REMOVED_PARTICIPANTS';
  });

  var fetchConversationsToNotify$ = participantEvent$.filter(function (event) {
    var state = getState();
    var _event$conversationEv = event.conversationEvent,
        authorUserId = _event$conversationEv.authorUserId,
        currentParticipantIds = _event$conversationEv.currentParticipantIds;

    var currentUser = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state);
    var userProperties = __WEBPACK_IMPORTED_MODULE_12_app_modules_user_properties_selectors__["g" /* properties */](state);
    var hasCentralizedRouting = __WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__["g" /* hasCentralizedRouting */](state);
    return Object(__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* showParticipantsNotification */])(currentUser, authorUserId, currentParticipantIds, userProperties, hasCentralizedRouting);
  }).map(function (_ref11) {
    var conversationId = _ref11.conversationId;
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__["h" /* fetchConversation */]({ conversationId: conversationId });
  });

  var participantUpdate$ = participantEvent$.filter(function (_ref12) {
    var conversationId = _ref12.conversationId;
    return __WEBPACK_IMPORTED_MODULE_16__selectors__["a" /* currentConversationId */](getState()) === conversationId;
  }).map(function (_ref13) {
    var _ref13$conversationEv = _ref13.conversationEvent,
        type = _ref13$conversationEv.type,
        participantIds = _ref13$conversationEv.participantIds,
        conversationId = _ref13.conversationId;

    switch (type) {
      case 'ADDED_PARTICIPANTS':
        return __WEBPACK_IMPORTED_MODULE_15__actions__["c" /* addParticipantsPending */]({ participants: participantIds, conversationId: conversationId });
      case 'REMOVED_PARTICIPANTS':
        return __WEBPACK_IMPORTED_MODULE_15__actions__["l" /* removeParticipantsPending */]({ participants: participantIds, conversationId: conversationId });
    }
  });

  return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(fetchConversationsToNotify$, participantUpdate$);
}

function fetchCurrentParticipants(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__["a" /* conversationChanged */].toString()).pluck('payload', 'conversationId').filter(function (conversationId) {
    return !!conversationId;
  }).map(function (conversationId) {
    return __WEBPACK_IMPORTED_MODULE_15__actions__["e" /* fetchParticipants */]({ conversationId: conversationId });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchParticipants, addParticipants, removeParticipants, conversationEvent, fetchCurrentParticipants);

/***/ }),

/***/ "/dss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/fzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_actions__ = __webpack_require__("M9ma");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var WordPressPayload = {
  client_id: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["_4" /* WORDPRESS_CLIENT_ID */],
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/wordpress'
};
var WordPressAuthUrl = 'https://public-api.wordpress.com/oauth2/authorize';

var WordPress = function (_Component) {
  _inherits(WordPress, _Component);

  function WordPress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WordPress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WordPress.__proto__ || Object.getPrototypeOf(WordPress)).call.apply(_ref, [this].concat(args))), _this), _this.setWordpressDomain = function (value) {
      _this.props.setWordpressDomain({ rootUrl: value });
    }, _this.handleInputChange = function (e) {
      var value = e.target.value;

      _this.setWordpressDomain(value);
      _this.handleConnect(value);
    }, _this.handleConnect = function (value) {
      var payload = value === '' ? {
        integration: 'wordpressV2',
        connected: false
      } : {
        integration: 'wordpressV2',
        connected: true
      };

      _this.props.setWordpressV2Integration(payload);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WordPress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchWordpressDomain();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rootUrl = _props.rootUrl,
          hasWordpressIntegrationV1 = _props.hasWordpressIntegrationV1,
          hasWordpressIntegrationV2 = _props.hasWordpressIntegrationV2;

      var errorMessage = 'Error connecting. Please check that you have a valid wordpress URL.';
      var hasNeitherWordpressVersionIntegration = !hasWordpressIntegrationV1 && !hasWordpressIntegrationV2;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Use Drift\u2019s intelligent messaging to answer your visitors questions using your Wordpress knowledge base.'
        ),
        !this.props.isConnected && hasWordpressIntegrationV1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'connect-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_IntegrationConnector__["a" /* default */], {
            integrationId: 'wordpress',
            isOauth: true,
            oauthLink: WordPressAuthUrl,
            oauthQueryParams: WordPressPayload,
            title: 'Connect Account',
            connectorType: 'button',
            buttonType: 'primary',
            className: 'wordpress-integration-connector'
          })
        ),
        (hasWordpressIntegrationV2 || hasNeitherWordpressVersionIntegration) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
              placeholder: 'http://link-to-knowledgebase.com',
              label: 'Wordpress knowledge base URL:',
              value: rootUrl,
              className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('wordpress-input'),
              onChange: this.handleInputChange,
              size: 'large',
              description: !!this.props.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'input-error-message' },
                errorMessage,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'a',
                  { href: 'https://help.drift.com/article/knowledge-base-and-help-doc-integrations/' },
                  ' Learn more'
                )
              )
            })
          )
        )
      );
    }
  }]);

  return WordPress;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasWordpressIntegrationV1: state.getIn(['integrations', 'connections']).wordpress,
    hasWordpressIntegrationV2: state.getIn(['integrations', 'connections']).wordpressV2,
    error: state.getIn(['wordpressIntegrationDomain', 'error']),
    rootUrl: state.getIn(['wordpressIntegrationDomain', 'rootUrl'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
    setWordpressV2Integration: __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_actions__["P" /* setWordpressV2Integration */],
    setWordpressDomain: __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_actions__["L" /* setWordpressDomain */],
    fetchWordpressDomain: __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_actions__["A" /* fetchWordpressDomain */]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(WordPress));

/***/ }),

/***/ "/g2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export savedReplies */
/* unused harmony export selectedSavedReplyId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return savedReplyToPopulate; });
/* unused harmony export composerTextToInsert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('composer');
};
var savedReplies = function savedReplies(state) {
  return root(state).get('savedReplies').sortBy(function (reply) {
    return reply.get('updatedAt');
  }).reverse();
};
var selectedSavedReplyId = function selectedSavedReplyId(state) {
  return root(state).get('selectedSavedReplyId');
};

var savedReplyToPopulate = function savedReplyToPopulate(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(savedReplies, function (savedReplies) {
    return savedReplies.find(function (reply) {
      return reply.get('id') === id;
    });
  });
};

var composerTextToInsert = function composerTextToInsert(state) {
  return root(state).get('composerTextToInsert');
};

/***/ }),

/***/ "/gEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_EmbedConfigurationConstants__ = __webpack_require__("ZDyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_OnlineToggle__ = __webpack_require__("Vn0U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__ = __webpack_require__("DhfJ");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Toggle = function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.onToggled = _this.onToggled.bind(_this);
    return _this;
  }

  _createClass(Toggle, [{
    key: 'onToggled',
    value: function onToggled(event) {
      var isChecked = event.target.checked;
      var updatedWidgetStatus = isChecked ? __WEBPACK_IMPORTED_MODULE_2_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON : __WEBPACK_IMPORTED_MODULE_2_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].AWAY;
      var updatedWidgetMode = __WEBPACK_IMPORTED_MODULE_2_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].MANUAL;

      this.update(updatedWidgetStatus, updatedWidgetMode);
    }
  }, {
    key: 'update',
    value: function update(updatedWidgetStatus, updatedWidgetMode) {
      var _props = this.props,
          widgetStatus = _props.widgetStatus,
          widgetMode = _props.widgetMode;


      var initialObject = {
        widgetStatus: widgetStatus,
        widgetMode: widgetMode
      };
      var updatedObject = {
        widgetStatus: updatedWidgetStatus,
        widgetMode: updatedWidgetMode
      };
      var changes = Object(__WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__["a" /* patchOperations */])(updatedObject, initialObject);
      this.props.updateStatus(changes);
    }
  }, {
    key: 'render',
    value: function render() {
      var widgetStatus = this.props.widgetStatus;

      var isChecked = widgetStatus === __WEBPACK_IMPORTED_MODULE_2_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'manualToggle' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_OnlineToggle__["a" /* default */], { checked: isChecked, onChange: this.onToggled })
      );
    }
  }]);

  return Toggle;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Toggle.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Toggle);

/***/ }),

/***/ "/giV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Customize_Preview_Widget__ = __webpack_require__("bYpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SliderMessagePreview__ = __webpack_require__("q8El");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__("dfnn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SliderMessageBuilder = function (_Component) {
  _inherits(SliderMessageBuilder, _Component);

  function SliderMessageBuilder() {
    _classCallCheck(this, SliderMessageBuilder);

    return _possibleConstructorReturn(this, (SliderMessageBuilder.__proto__ || Object.getPrototypeOf(SliderMessageBuilder)).apply(this, arguments));
  }

  _createClass(SliderMessageBuilder, [{
    key: 'renderPASlider',
    value: function renderPASlider() {
      var isExpanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _props = this.props,
          _props$widgetContent = _props.widgetContent,
          message = _props$widgetContent.message,
          headline = _props$widgetContent.headline,
          ctaCopy = _props$widgetContent.ctaCopy,
          selectedUser = _props$widgetContent.selectedUser,
          _props$defaultEmbed$t = _props.defaultEmbed.theme,
          backgroundColor = _props$defaultEmbed$t.backgroundColor,
          foregroundColor = _props$defaultEmbed$t.foregroundColor,
          iconUrl = _props$defaultEmbed$t.iconUrl,
          _props$defaultEmbed$t2 = _props$defaultEmbed$t.iconStyle,
          iconStyle = _props$defaultEmbed$t2 === undefined ? __WEBPACK_IMPORTED_MODULE_1_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID1 : _props$defaultEmbed$t2,
          hideCta = _props.hideCta;

      var primaryColor = typeof backgroundColor === "string" && !backgroundColor.startsWith('#') && backgroundColor.length === 6 ? '#' + backgroundColor : backgroundColor;
      var secondaryColor = typeof foregroundColor === "string" && !foregroundColor.startsWith('#') && foregroundColor.length === 6 ? '#' + foregroundColor : foregroundColor;
      var content = React.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_5__style__["Content"], dangerouslySetInnerHTML: { __html: message } });
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style__["SliderPreview"] },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4__SliderMessagePreview__["a" /* default */], {
          headline: headline,
          content: content,
          isExpanded: isExpanded,
          ctaCopy: ctaCopy,
          hideCta: hideCta,
          primaryColor: primaryColor,
          secondaryColor: secondaryColor
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Customize_Preview_Widget__["a" /* default */], {
          iconType: __WEBPACK_IMPORTED_MODULE_1_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].announcementSrc,
          iconStyle: iconStyle,
          avatarUrl: Object(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["b" /* getUserAvatarUrl */])(selectedUser),
          iconUrl: iconUrl,
          backgroundColor: backgroundColor,
          foregroundColor: foregroundColor
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style__["Wrapper"], style: { overflowY: 'auto' }, key: 'slider-previews' },
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__style__["SliderPreviewsWrapper"] },
          this.renderPASlider(false),
          this.renderPASlider(true)
        )
      );
    }
  }]);

  return SliderMessageBuilder;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SliderMessageBuilder);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "/h/G":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 19 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"color\" transform=\"translate(-884.000000, -407.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(772.000000, 358.000000)\"><g id=\"cancel-square\" transform=\"translate(112.000000, 49.000000)\"><path d=\"M18.2083333,19 L0.791666667,19 C0.354666667,19 0,18.6453333 0,18.2083333 L0,0.791666667 C0,0.354666667 0.354666667,0 0.791666667,0 L18.2083333,0 C18.6453333,0 19,0.354666667 19,0.791666667 L19,18.2083333 C19,18.6453333 18.6453333,19 18.2083333,19 Z M17.4166667,1.58333333 L1.58333333,1.58333333 L1.58333333,17.4166667 L17.4166667,17.4166667 L17.4166667,1.58333333 Z M5.773625,5.773625 C6.08316667,5.46408333 6.5835,5.46408333 6.89304167,5.773625 L9.5,8.38058333 L12.1069583,5.773625 C12.4165,5.46408333 12.9168333,5.46408333 13.226375,5.773625 C13.5359167,6.082375 13.5359167,6.58429167 13.226375,6.89304167 L10.6194167,9.5 L13.226375,12.1069583 C13.5359167,12.4157083 13.5359167,12.917625 13.226375,13.226375 C13.072,13.38075 12.8693333,13.4583333 12.6666667,13.4583333 C12.464,13.4583333 12.2613333,13.38075 12.1069583,13.226375 L9.5,10.6194167 L6.89304167,13.226375 C6.73866667,13.38075 6.536,13.4583333 6.33333333,13.4583333 C6.13066667,13.4583333 5.928,13.38075 5.773625,13.226375 C5.46408333,12.917625 5.46408333,12.4157083 5.773625,12.1069583 L8.38058333,9.5 L5.773625,6.89304167 C5.46408333,6.58429167 5.46408333,6.082375 5.773625,5.773625 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "/hXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");



var SelectContainer = Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
  return {
    clearable: false,
    placeholder: 'Enter value'
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onChange: function onChange(props) {
    return function (_ref) {
      var value = _ref.value;
      return props.onChange(value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_0_react_select_plus__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SelectContainer);

/***/ }),

/***/ "/k6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Tag = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  orgId: null,
  color: null,
  name: undefined,
  createdAt: undefined,
  targetType: undefined,
  status: undefined
});

/***/ }),

/***/ "/mUT":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.833 14H1.167C.523 14 0 13.477 0 12.833v-10.5c0-.643.523-1.166 1.167-1.166H3.5V.583C3.5.26 3.76 0 4.083 0c.323 0 .584.26.584.583v.584h4.666V.583c0-.322.26-.583.584-.583.322 0 .583.26.583.583v.584h2.333c.643 0 1.167.523 1.167 1.166v10.5c0 .644-.524 1.167-1.167 1.167zM10.5 2.333v.584c0 .322-.26.583-.583.583-.323 0-.584-.26-.584-.583v-.584H4.667v.584c0 .322-.26.583-.584.583-.322 0-.583-.26-.583-.583v-.584H1.167v10.5h11.665v-10.5H10.5zm-3.732 7.964c-.107.125-.263.2-.428.202h-.014c-.16 0-.314-.066-.424-.183l-1.66-1.76c-.22-.233-.21-.603.024-.824.235-.22.604-.21.825.024l1.216 1.288 2.585-3.01c.212-.243.58-.27.823-.06.245.21.273.578.063.822l-3.008 3.5z\" fill=\"#7795A4\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "/sFR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container---1nMBX"};

/***/ }),

/***/ "/ub6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"integrationLander":"integrationLander---1Nqm_"};

/***/ }),

/***/ "/vZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_profile_actions__ = __webpack_require__("9Gfy");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _handleActions4, _handleActions5, _handleActions9, _handleActions10, _handleActions11, _handleActions12, _handleActions13, _handleActions15, _handleActions17, _handleActions18, _handleActions19, _handleActions20;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var updateEntities = function updateEntities(model) {
  return function (entities) {
    return entities ? entities.map(function (entity) {
      return new model(entity);
    }) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  };
};

var sendTestEmailStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_128" /* sendTestEmailSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_127" /* sendTestEmailPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_126" /* sendTestEmailFailed */]), function (state, action) {
  return action.type;
}), false);

var sendTestEmailId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__actions__["_125" /* sendTestEmail */], function (state, action) {
  return action.payload.emailId || false;
}), false);

var endUserEmail = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__actions__["_169" /* setEndUserEmail */], function (state, action) {
  return action.payload;
}), '');

var enrolledPlaybookId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions4 = {}, _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_7__actions__["_12" /* fetchEnrolledPlaybookIdSuccess */], function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_7__actions__["_245" /* unenrollSuccess */], function () {
  return false;
}), _handleActions4), false);

var normalized = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_7__actions__["_122" /* searchPlaybooksSuccess */], function (state, action) {
  var processedEntities = action.payload.updateIn(['entities', 'playbooks'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["k" /* Playbook */])).updateIn(['entities', 'conditionSets'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["c" /* ConditionSet */])).updateIn(['entities', 'conditions'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* Condition */]));

  action.payload.get('result').map(function (playbookId) {
    return processedEntities.updateIn(['entities', 'playbooks', '' + playbookId, 'targeting'], function (targeting) {
      return __WEBPACK_IMPORTED_MODULE_5__models__["s" /* Targeting */](targeting);
    });
  });

  // mergeDeep doesn't concat Lists properly...
  return state.mergeDeep(processedEntities).updateIn(['result'], function (result) {
    return result.concat(action.payload.get('result')).toSet().toList();
  });
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_7__actions__["_215" /* setStatus */], function (state, action) {
  var playbookId = action.payload.id;
  var status = action.payload.status;
  return state.setIn(['entities', 'playbooks', '' + playbookId, 'status'], status);
}), _handleActions5), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var normalizedStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_121" /* searchPlaybooksPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_119" /* searchPlaybooks */], __WEBPACK_IMPORTED_MODULE_7__actions__["_122" /* searchPlaybooksSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_120" /* searchPlaybooksFailed */]), function (state, action) {
  return action.type;
}), false);

var enrolledSequenceCount = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__actions__["_16" /* fetchEnrolledSequenceCountSuccess */], function (state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var fetchEnrolledSequenceCountStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_16" /* fetchEnrolledSequenceCountSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_13" /* fetchEnrolledSequenceCount */], __WEBPACK_IMPORTED_MODULE_7__actions__["_15" /* fetchEnrolledSequenceCountPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_14" /* fetchEnrolledSequenceCountFailed */]), function (state, action) {
  return action.type;
}), false);

var enrollingPlaybookId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions9 = {}, _defineProperty(_handleActions9, __WEBPACK_IMPORTED_MODULE_7__actions__["U" /* enroll */], function (state, action) {
  return action.payload.playbookId;
}), _defineProperty(_handleActions9, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["V" /* enrollFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["X" /* enrollSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* clearEnrollModalState */]), function () {
  return false;
}), _handleActions9), false);

var editingPlaybookId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions10 = {}, _defineProperty(_handleActions10, __WEBPACK_IMPORTED_MODULE_7__actions__["_40" /* fetchPlaybookForEndUser */], function (state, action) {
  return action.payload.playbookId;
}), _defineProperty(_handleActions10, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_43" /* fetchPlaybookForEndUserSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_41" /* fetchPlaybookForEndUserFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* clearEnrollModalState */]), function () {
  return false;
}), _handleActions10), false);

var playbookForEndUser = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions11 = {}, _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_7__actions__["_43" /* fetchPlaybookForEndUserSuccess */], function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_7__actions__["_186" /* setPlaybookForEndUserSubject */], function (state, action) {
  var _action$payload = action.payload,
      index = _action$payload.index,
      subject = _action$payload.subject;

  return state.setIn(['actions', 0, 'action', 'emails', index, 'title'], subject);
}), _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_7__actions__["_185" /* setPlaybookForEndUserMessage */], function (state, action) {
  var _action$payload2 = action.payload,
      index = _action$payload2.index,
      message = _action$payload2.message;

  return state.setIn(['actions', 0, 'action', 'emails', index, 'message'], message);
}), _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* clearEnrollModalState */], function (state, action) {
  return false;
}), _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_7__actions__["_184" /* setPlaybookForEndUserDelay */], function (state, action) {
  var delay = action.payload;
  return state.setIn(['actions', 0, 'action', 'emails', 0, 'delay'], delay).setIn(['actions', 0, 'action', 'emails', 0, 'smartSendingOverride'], true).setIn(['actions', 0, 'action', 'emails', 0, 'delayUnit'], 'MILLIS');
}), _handleActions11), false);

var enrollStatusByEmail = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions12 = {}, _defineProperty(_handleActions12, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["U" /* enroll */], __WEBPACK_IMPORTED_MODULE_7__actions__["V" /* enrollFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["X" /* enrollSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["W" /* enrollPending */]), function (state, action) {
  return state.set(action.payload.email, action.type);
}), _defineProperty(_handleActions12, __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* clearEnrollModalState */], function (state, action) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
}), _handleActions12), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var enrollErrorsByEmail = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions13 = {}, _defineProperty(_handleActions13, __WEBPACK_IMPORTED_MODULE_7__actions__["V" /* enrollFailed */], function (state, action) {
  return state.set(action.payload.email, action.payload.error);
}), _defineProperty(_handleActions13, __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* clearEnrollModalState */], function (state, action) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
}), _handleActions13), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var fetchPlaybookForEndUserStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_40" /* fetchPlaybookForEndUser */], __WEBPACK_IMPORTED_MODULE_7__actions__["_43" /* fetchPlaybookForEndUserSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_42" /* fetchPlaybookForEndUserPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_41" /* fetchPlaybookForEndUserFailed */]), function (state, action) {
  return action.type;
}), false);

var draft = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions15 = {}, _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["r" /* clearDraft */], function () {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* acceptPlaybookDraft */], function (state, action) {
  return action.payload.updateIn(['entities', 'signatureActions'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */])).updateIn(['entities', 'questions'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["m" /* Question */])).updateIn(['entities', 'answers'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* Answer */])).updateIn(['entities', 'keywords'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["j" /* Keyword */])).updateIn(['entities', 'emails'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["e" /* Email */])).updateIn(['entities', 'playbooks'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["k" /* Playbook */])).updateIn(['entities', 'goals'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["g" /* Goal */])).updateIn(['entities', 'conditionSets'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["c" /* ConditionSet */])).updateIn(['entities', 'conditions'], updateEntities(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* Condition */])).updateIn(['entities', 'playbooks', '' + action.payload.get('result'), 'targeting'], function (targeting) {
    return __WEBPACK_IMPORTED_MODULE_5__models__["s" /* Targeting */](targeting);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_182" /* setMetaAttribute */], function (state, action) {
  // expects { attr: value }, will be masked by the PlaybookMeta Record()
  // also, merging records is sticky
  var draftId = state.get('result');
  var oldMeta = state.getIn(['entities', 'playbooks', '' + draftId, 'meta']);
  return state.setIn(['entities', 'playbooks', '' + draftId, 'meta'], __WEBPACK_IMPORTED_MODULE_5__models__["l" /* PlaybookMeta */](_extends({}, oldMeta, action.payload)));
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_183" /* setName */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'name'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_151" /* setDraftStatus */], function (state, action) {
  var playbookId = state.get('result');
  var status = action.payload.status;
  return state.setIn(['entities', 'playbooks', '' + playbookId, 'status'], status);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["N" /* disablePlaybook */], function (state) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'status'], __WEBPACK_IMPORTED_MODULE_6__constants__["_141" /* PlaybookStatus */].DISABLED);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_210" /* setSlug */], function (state, action) {
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var slug = action.payload.toLowerCase().replace(' ', '').replace('/', '');
  return state.setIn(['entities', 'actionTypes', '' + interactionId, 'action', 'slug'], slug);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_176" /* setGreeting */], function (state, action) {
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var greeting = action.payload.greeting;

  return state.setIn(['entities', 'actionTypes', '' + interactionId, 'action', 'greeting'], greeting);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_180" /* setMarketingEmailLayout */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'marketingEmailLayout'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_192" /* setSequenceDynamicSenderFormat */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'dynamicSenderFormat'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_191" /* setSequenceDynamicAccountSendAttribute */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'dynamicAccountSendAttribute'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_193" /* setSequenceEmailOverride */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'senderEmailOverride'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_197" /* setSequenceIndividualSenderName */], function (state, action) {
  var _action$payload3 = action.payload,
      data = _action$payload3.data,
      emailId = _action$payload3.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'sendFromOverride'], data);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_196" /* setSequenceIndividualEmailOverride */], function (state, action) {
  var _action$payload4 = action.payload,
      data = _action$payload4.data,
      emailId = _action$payload4.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'senderEmailOverride'], data);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_194" /* setSequenceIndividualDynamicAttr */], function (state, action) {
  var _action$payload5 = action.payload,
      data = _action$payload5.data,
      emailId = _action$payload5.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'dynamicAccountSendAttribute'], data);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_195" /* setSequenceIndividualDynamicFormat */], function (state, action) {
  var _action$payload6 = action.payload,
      data = _action$payload6.data,
      emailId = _action$payload6.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'dynamicSenderFormat'], data);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_198" /* setSequenceSenderName */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'sendFromOverride'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_157" /* setDynamicSenderFormat */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'dynamicSenderFormat'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_156" /* setDynamicAccountSendAttribute */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'dynamicAccountSendAttribute'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_165" /* setEmailOverride */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'senderEmailOverride'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_189" /* setSenderName */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'sendFromOverride'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_135" /* setActionInboxId */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'inboxId'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_181" /* setMessage */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'message'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_222" /* setVideoUrl */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'videoUrl'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_217" /* setThankYouMessage */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'thankYouMessage'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_190" /* setSequenceAuthorId */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'authorId'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_138" /* setAuthorId */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'authorId'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_177" /* setHeadline */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'title'], action.payload.value);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_216" /* setThankYouHeadline */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'thankYouHeadline'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_146" /* setCtaType */], function (state, action) {
  var actionType = state.getIn(['entities', 'actionTypes']).first();
  var actionTypeId = actionType.get('id');
  var stateWithCta = state;
  if (actionType.getIn(['action', 'cta']) === null) {
    stateWithCta = stateWithCta.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta'], __WEBPACK_IMPORTED_MODULE_5__models__["d" /* Cta */]());
  }
  return stateWithCta.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta', 'type'], action.payload).setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'goalTriggers', '0', 'conditions'], [[{
    value: __WEBPACK_IMPORTED_MODULE_6__constants__["U" /* CtaGoalTypes */][action.payload],
    action: 'CAMPAIGN_EVENT',
    operator: 'OCCURRED'
  }]]);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_145" /* setCtaLink */], function (state, action) {
  var actionType = state.getIn(['entities', 'actionTypes']).first();
  var actionTypeId = actionType.get('id');
  if (actionType.getIn(['action', 'cta']) === null) {
    return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta'], __WEBPACK_IMPORTED_MODULE_5__models__["d" /* Cta */]({ url: action.payload }));
  }
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta', 'url'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_144" /* setCtaCopy */], function (state, action) {
  var actionType = state.getIn(['entities', 'actionTypes']).first();
  var actionTypeId = actionType.get('id');
  if (actionType.getIn(['action', 'cta']) === null) {
    return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta'], __WEBPACK_IMPORTED_MODULE_5__models__["d" /* Cta */]({ copy: action.payload }));
  }
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'cta', 'copy'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_167" /* setEmailTheme */], function (state, action) {
  var emailTheme = action.payload;
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'emailTheme'], emailTheme);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_164" /* setEmailMessage */], function (state, action) {
  var _action$payload7 = action.payload,
      message = _action$payload7.message,
      emailId = _action$payload7.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'message'], message);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_168" /* setEmailTitle */], function (state, action) {
  var _action$payload8 = action.payload,
      title = _action$payload8.title,
      emailId = _action$payload8.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'title'], title);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_214" /* setSmartSending */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'smartSending'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_224" /* setWeekdaysOnly */], function (state, action) {
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'options', 'weekdaysOnly'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_219" /* setUnenrollOnReply */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'unenrollOnReply'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_220" /* setUnenrollOnReplyByDomain */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'unenrollOnReplyByDomain'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_218" /* setThreadedWithPrevious */], function (state, action) {
  var _action$payload9 = action.payload,
      emailId = _action$payload9.emailId,
      threadedWithPrevious = _action$payload9.threadedWithPrevious;

  return state.setIn(['entities', 'emails', '' + emailId, 'threadedWithPrevious'], threadedWithPrevious);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_163" /* setEmailDelay */], function (state, action) {
  var _action$payload10 = action.payload,
      delay = _action$payload10.delay,
      emailId = _action$payload10.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'delay'], delay);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["e" /* addEmail */], function (state, action) {
  var email = action.payload.email;

  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'emails', email.id], email).updateIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'emails'], function (emails) {
    return emails.push(email.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["J" /* deleteEmail */], function (state, action) {
  var emailId = action.payload;
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.deleteIn(['entities', 'emails', emailId]).updateIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'emails'], function (emails) {
    return emails.filter(function (id) {
      return id !== emailId;
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_94" /* moveEmailUp */], function (state, action) {
  var emailIndex = action.payload;
  var actionTypeId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var emailId = state.getIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'emails', emailIndex]);
  return state.updateIn(['entities', 'actionTypes', '' + actionTypeId, 'action', 'emails'], function (emails) {
    return emails.delete(emailIndex).insert(emailIndex - 1, emailId);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_143" /* setConditionValue */], function (state, action) {
  var _action$payload11 = action.payload,
      id = _action$payload11.id,
      value = _action$payload11.value;

  return state.setIn(['entities', 'conditions', '' + id, 'value'], value);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_166" /* setEmailPlaybookConditionValue */], function (state, action) {
  var _action$payload12 = action.payload,
      conditionId = _action$payload12.conditionId,
      playbook = _action$payload12.playbook;

  var campaignIds = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["values"])(
  // get the campaign IDs from playbooks that have emails
  playbook.getIn(['entities', 'emails'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).map(function (e) {
    return e.get('campaignId');
  }).merge(
  // get the campaign IDs from playbooks that only have actions
  playbook.getIn(['entities', 'actionTypes'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).map(function (at) {
    return at.getIn(['action', 'campaignId']);
  })).toJS())
  // filter out falsy values
  .filter(function (x) {
    return !!x;
  });
  return state.updateIn(['entities', 'conditions', '' + conditionId], function (condition) {
    return condition.set('value', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(campaignIds.map(function (cid) {
      return 'd_campaign=' + cid;
    }))).set('operator', 'isAnyOf').set('field', 'urlQuery');
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_141" /* setConditionField */], function (state, action) {
  var _action$payload13 = action.payload,
      field = _action$payload13.field,
      id = _action$payload13.id;

  var conditionType = __WEBPACK_IMPORTED_MODULE_6__constants__["S" /* ConditionTypes */].get(field);
  return state.updateIn(['entities', 'conditions', '' + id], function (condition) {
    return condition.set('field', field).set('operator', conditionType.operators[0]).set('value', conditionType.defaultValue);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_142" /* setConditionOperator */], function (state, action) {
  var _action$payload14 = action.payload,
      operator = _action$payload14.operator,
      id = _action$payload14.id;

  return state.setIn(['entities', 'conditions', '' + id, 'operator'], operator);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["H" /* deleteCondition */], function (state, action) {
  var id = action.payload;
  var conditionSet = state.getIn(['entities', 'conditionSets']).find(function (_ref) {
    var conditions = _ref.conditions;
    return conditions.some(function (condition) {
      return condition === id;
    });
  });
  return state.withMutations(function (_state) {
    _state.deleteIn(['entities', 'conditions', id]);
    if (conditionSet.conditions.size === 1) {
      _state.deleteIn(['entities', 'conditionSets', conditionSet.id]);
      _state.updateIn(['entities', 'playbooks', '' + _state.get('result'), 'targeting', 'display'], function (display) {
        return display.filter(function (id) {
          return id !== conditionSet.id;
        });
      });
    } else {
      _state.updateIn(['entities', 'conditionSets', conditionSet.id, 'conditions'], function (conditions) {
        return conditions.filter(function (condition) {
          return condition !== id;
        });
      });
    }
    return _state;
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["c" /* addCondition */], function (state, action) {
  var _action$payload15 = action.payload,
      condition = _action$payload15.condition,
      conditionSetId = _action$payload15.conditionSetId;

  return state.setIn(['entities', 'conditions', '' + condition.id], condition).updateIn(['entities', 'conditionSets', '' + conditionSetId, 'conditions'], function (conditions) {
    return conditions.push(condition.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["I" /* deleteConditionSet */], function (state, action) {
  var id = action.payload;
  var playbookId = state.get('result');
  var removeConditionIds = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(state.getIn(['entities', 'conditionSets', '' + id, 'conditions']));
  return state.deleteIn(['entities', 'conditionSets', '' + id]).updateIn(['entities', 'playbooks', '' + playbookId, 'targeting', 'display'], function (display) {
    return display.filter(function (conditionSet) {
      return conditionSet !== id;
    });
  }).updateIn(['entities', 'conditions'], function (conditions) {
    return conditions.filterNot(function (condition) {
      return removeConditionIds.has(condition.id);
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["d" /* addConditionSet */], function (state, action) {
  var conditionSet = action.payload.conditionSet;

  var playbookId = state.get('result');
  return state.setIn(['entities', 'conditionSets', '' + conditionSet.id], conditionSet).updateIn(['entities', 'playbooks', '' + playbookId, 'targeting', 'display'], function (display) {
    return display.push(conditionSet.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["h" /* addGoal */], function (state, action) {
  var _action$payload16 = action.payload,
      playbookId = _action$payload16.playbookId,
      goal = _action$payload16.goal;

  return state.setIn(['entities', 'goals', goal.id], goal).updateIn(['entities', 'playbooks', '' + playbookId, 'goals'], function (goals) {
    return goals.push(goal.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_106" /* saveGoalAction */], function (state, action) {
  var _action$payload17 = action.payload,
      goalId = _action$payload17.goalId,
      goalAction = _action$payload17.goalAction;

  var goal = state.getIn(['entities', 'goals', '' + goalId]);
  return state.setIn(['entities', 'goals', '' + goalId], goal.merge(goalAction));
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_107" /* saveGoalRoutingOption */], function (state, action) {
  var _action$payload18 = action.payload,
      goalId = _action$payload18.goalId,
      goalRoutingOption = _action$payload18.goalRoutingOption;

  var goal = state.getIn(['entities', 'goals', '' + goalId]);
  return state.setIn(['entities', 'goals', '' + goalId], goal.merge({ routing: goalRoutingOption.type ? goalRoutingOption : null }));
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["K" /* deleteGoal */], function (state, action) {
  var _action$payload19 = action.payload,
      goalId = _action$payload19.goalId,
      playbookId = _action$payload19.playbookId;

  return state.deleteIn(['entities', 'goals', goalId]).updateIn(['entities', 'playbooks', '' + playbookId, 'goals'], function (goals) {
    return goals.filter(function (id) {
      return id !== goalId;
    });
  }).updateIn(['entities', 'answers'], function (answers) {
    if (!answers) {
      return;
    }
    return answers.map(function (answer) {
      return answer.update('skipToGoal', function (skipToGoal) {
        if (skipToGoal) {
          if (skipToGoal.get('goalId') === goalId) {
            return null;
          } else {
            return skipToGoal;
          }
        } else {
          return null;
        }
      });
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_103" /* removeGoalAction */], function (state, action) {
  var _action$payload20 = action.payload,
      goalId = _action$payload20.goalId,
      goalActionProperty = _action$payload20.goalActionProperty;

  return state.deleteIn(['entities', 'goals', '' + goalId, goalActionProperty]);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_174" /* setGoalMessage */], function (state, action) {
  var _action$payload21 = action.payload,
      goalId = _action$payload21.goalId,
      body = _action$payload21.body;

  return state.setIn(['entities', 'goals', '' + goalId, 'message', 'body'], body);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_173" /* setGoalClassification */], function (state, action) {
  var _action$payload22 = action.payload,
      classificationId = _action$payload22.classificationId,
      goalId = _action$payload22.goalId;

  return state.setIn(['entities', 'goals', '' + goalId, 'classification', 'classificationId'], classificationId);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_187" /* setQuestionPrompt */], function (state, action) {
  var _action$payload23 = action.payload,
      prompt = _action$payload23.prompt,
      questionId = _action$payload23.questionId;

  return state.setIn(['entities', 'questions', '' + questionId, 'prompt'], prompt);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["b" /* addAnswer */], function (state, action) {
  var answer = action.payload.answer;

  return state.setIn(['entities', 'answers', answer.id], answer).updateIn(['entities', 'questions', answer.questionId, 'answers'], function (answers) {
    return answers.push(answer.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_66" /* flagAnswer */], function (state, action) {
  var _action$payload24 = action.payload,
      answerId = _action$payload24.answerId,
      questionId = _action$payload24.questionId;

  return state.setIn(['entities', 'questions', questionId, 'defaultAnswerId'], answerId);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_209" /* setSkipTo */], function (state, action) {
  var _action$payload25 = action.payload,
      answerId = _action$payload25.answerId,
      isGoal = _action$payload25.isGoal,
      skipToId = _action$payload25.skipToId;

  return state.setIn(['entities', 'answers', answerId, 'skipTo'], isGoal ? null : skipToId).setIn(['entities', 'answers', answerId, 'skipToGoal'], isGoal ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ goalId: skipToId }) : null);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["G" /* deleteAnswer */], function (state, action) {
  var _action$payload26 = action.payload,
      questionId = _action$payload26.questionId,
      answerId = _action$payload26.answerId;

  return state.deleteIn(['entities', 'answers', answerId]).updateIn(['entities', 'questions', questionId, 'answers'], function (answers) {
    return answers.filter(function (id) {
      return id !== answerId;
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_149" /* setDraftFrequency */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'campaignReenrollmentType'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["l" /* addQuestion */], function (state, action) {
  var question = action.payload.question;

  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.setIn(['entities', 'questions', question.id], question).updateIn(['entities', 'actionTypes', '' + interactionId, 'action', 'questions'], function (questions) {
    return questions.push(question.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["k" /* addPhoneCaptureQuestion */], function (state, action) {
  var questionId = action.payload;
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');

  var matchAnswer = __WEBPACK_IMPORTED_MODULE_5__models__["a" /* Answer */]({
    id: Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])(),
    response: 'Got it! Thanks for entering your phone number.',
    type: __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* AnswerType */].VALIDATE,
    validationType: __WEBPACK_IMPORTED_MODULE_6__constants__["_292" /* ValidationType */].PHONE,
    questionId: questionId
  });

  var nonMatchAnswerId = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])();
  var nonMatchAnswer = __WEBPACK_IMPORTED_MODULE_5__models__["a" /* Answer */]({
    id: nonMatchAnswerId,
    response: 'Sorry, I didn\'t understand that. Please enter your phone number to continue.',
    skipTo: questionId,
    questionId: questionId
  });

  var question = __WEBPACK_IMPORTED_MODULE_5__models__["m" /* Question */]({
    id: questionId,
    interactionId: interactionId,
    prompt: 'What\'s your phone number?',
    defaultAnswerId: nonMatchAnswerId,
    answers: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(matchAnswer.id, nonMatchAnswer.id),
    fieldConfiguration: __WEBPACK_IMPORTED_MODULE_5__models__["f" /* FieldConfiguration */]({ fieldName: 'phone' })
  });

  return state.setIn(['entities', 'answers', matchAnswer.id], matchAnswer).setIn(['entities', 'answers', nonMatchAnswer.id], nonMatchAnswer).setIn(['entities', 'questions', question.id], question).updateIn(['entities', 'actionTypes', '' + question.interactionId, 'action', 'questions'], function (questions) {
    return questions.push(question.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["f" /* addEmailCaptureQuestion */], function (state, action) {
  var questionId = action.payload;
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');

  var matchAnswer = __WEBPACK_IMPORTED_MODULE_5__models__["a" /* Answer */]({
    id: Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])(),
    response: 'Got it! Thanks for entering your email address.',
    type: __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* AnswerType */].VALIDATE,
    validationType: __WEBPACK_IMPORTED_MODULE_6__constants__["_292" /* ValidationType */].EMAIL,
    questionId: questionId
  });

  var nonMatchAnswerId = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])();
  var nonMatchAnswer = __WEBPACK_IMPORTED_MODULE_5__models__["a" /* Answer */]({
    id: nonMatchAnswerId,
    response: 'Sorry, I didn\'t understand that. Please enter your email address to continue.',
    skipTo: questionId,
    questionId: questionId
  });

  var question = __WEBPACK_IMPORTED_MODULE_5__models__["m" /* Question */]({
    id: questionId,
    interactionId: interactionId,
    prompt: 'What\'s your email?',
    defaultAnswerId: nonMatchAnswerId,
    answers: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(matchAnswer.id, nonMatchAnswer.id),
    fieldConfiguration: __WEBPACK_IMPORTED_MODULE_5__models__["f" /* FieldConfiguration */]({ fieldName: 'email' })
  });

  return state.setIn(['entities', 'answers', matchAnswer.id], matchAnswer).setIn(['entities', 'answers', nonMatchAnswer.id], nonMatchAnswer).setIn(['entities', 'questions', question.id], question).updateIn(['entities', 'actionTypes', '' + question.interactionId, 'action', 'questions'], function (questions) {
    return questions.push(question.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["M" /* deleteQuestion */], function (state, action) {
  var questionId = action.payload;
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.deleteIn(['entities', 'questions', questionId]).updateIn(['entities', 'actionTypes', '' + interactionId, 'action', 'questions'], function (questions) {
    return questions.filter(function (id) {
      return id !== questionId;
    });
  }).updateIn(['entities', 'answers'], function (answers) {
    if (!answers) {
      return;
    }
    return answers.map(function (answer) {
      return answer.update('skipTo', function (skipTo) {
        return skipTo === questionId ? null : skipTo;
      });
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_95" /* moveQuestionUp */], function (state, action) {
  var questionIndex = action.payload;
  var interactionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var questionId = state.getIn(['entities', 'actionTypes', '' + interactionId, 'action', 'questions', questionIndex]);
  return state.updateIn(['entities', 'actionTypes', '' + interactionId, 'action', 'questions'], function (questions) {
    return questions.delete(questionIndex).insert(questionIndex - 1, questionId);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["i" /* addKeyword */], function (state, action) {
  var _action$payload27 = action.payload,
      keyword = _action$payload27.keyword,
      answerId = _action$payload27.answerId;

  return state.setIn(['entities', 'keywords', keyword.id], keyword).updateIn(['entities', 'answers', answerId, 'keywords'], function (keywords) {
    return keywords.push(keyword.id);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["L" /* deleteKeyword */], function (state, action) {
  var keywordId = action.payload;
  return state.deleteIn(['entities', 'keywords', keywordId]).updateIn(['entities', 'answers'], function (answers) {
    return answers.map(function (answer) {
      return answer.update('keywords', function (keywords) {
        return keywords.filter(function (keyword) {
          return keyword !== keywordId;
        });
      });
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_178" /* setKeywordText */], function (state, action) {
  var _action$payload28 = action.payload,
      keywordId = _action$payload28.keywordId,
      text = _action$payload28.text;

  return state.setIn(['entities', 'keywords', keywordId, 'text'], text);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_179" /* setKeywordType */], function (state, action) {
  var _action$payload29 = action.payload,
      keywordId = _action$payload29.keywordId,
      type = _action$payload29.type;

  return state.setIn(['entities', 'keywords', keywordId, 'type'], type);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_136" /* setAnswerType */], function (state, action) {
  var _action$payload30 = action.payload,
      answerId = _action$payload30.answerId,
      type = _action$payload30.type;

  return state.setIn(['entities', 'answers', answerId, 'type'], type);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_140" /* setButtonText */], function (state, action) {
  var _action$payload31 = action.payload,
      answerId = _action$payload31.answerId,
      buttonText = _action$payload31.buttonText;

  return state.setIn(['entities', 'answers', answerId, 'buttonText'], buttonText);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_148" /* setDefaultPhoneCountryCode */], function (state, action) {
  var _action$payload32 = action.payload,
      answerId = _action$payload32.answerId,
      countryCode = _action$payload32.countryCode;

  return state.setIn(['entities', 'answers', answerId, 'validationConfig', 'phoneCountryCode'], countryCode);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_188" /* setResponse */], function (state, action) {
  var _action$payload33 = action.payload,
      answerId = _action$payload33.answerId,
      response = _action$payload33.response;

  return state.setIn(['entities', 'answers', answerId, 'response'], response);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_139" /* setButtonOnlyResponses */], function (state, action) {
  var _action$payload34 = action.payload,
      questionId = _action$payload34.questionId,
      value = _action$payload34.value;

  return state.setIn(['entities', 'questions', questionId, 'isButtonOnly'], value);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_172" /* setFieldAttributeName */], function (state, action) {
  var _action$payload35 = action.payload,
      questionId = _action$payload35.questionId,
      attribute = _action$payload35.attribute;

  return state.setIn(['entities', 'questions', questionId, 'fieldConfiguration'], attribute ? __WEBPACK_IMPORTED_MODULE_5__models__["f" /* FieldConfiguration */]({ fieldName: attribute }) : null);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_105" /* resetDisplayConditions */], function (state) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'display'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).setIn(['entities', 'conditionSets'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).setIn(['entities', 'conditions'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_137" /* setAudience */], function (state, action) {
  var draftId = state.get('result');
  if (action.payload !== __WEBPACK_IMPORTED_MODULE_6__constants__["w" /* AudienceType */].SEGMENT) {
    return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'audience'], action.payload).setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'userListIds'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
  }
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'audience'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_150" /* setDraftSchedule */], function (state, action) {
  var draftId = state.get('result');
  var dueAt = !action.payload ? null : action.payload.clone().tz('UTC').startOf('minute').unix() * 1000;
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'dueAt'], dueAt);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_221" /* setUserListIds */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'userListIds'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_171" /* setExcludedUserListIds */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'excludedUserListIds'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_134" /* setAccountListIds */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'accountListIds'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_170" /* setExcludedAccountListIds */], function (state, action) {
  var draftId = state.get('result');
  return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'excludedAccountListIds'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_212" /* setSmartFilterEngagedContacts */], function (state, action) {
  var draftId = state.get('result');
  var hasSmartFilters = !!state.getIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters']);
  if (!hasSmartFilters) {
    var filters = new __WEBPACK_IMPORTED_MODULE_5__models__["r" /* SmartFilters */]({
      meetingScheduled: action.payload,
      salesSequenceEngaged: action.payload
    });
    return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters'], filters);
  } else {
    return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters', 'meetingScheduled'], action.payload).setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters', 'salesSequenceEngaged'], action.payload);
  }
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_211" /* setSmartFilterChatEngagedContacts */], function (state, action) {
  var draftId = state.get('result');
  var hasSmartFilters = !!state.getIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters']);
  if (!hasSmartFilters) {
    var filters = new __WEBPACK_IMPORTED_MODULE_5__models__["r" /* SmartFilters */]({
      chatEngaged: action.payload
    });
    return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters'], filters);
  } else {
    return state.setIn(['entities', 'playbooks', '' + draftId, 'targeting', 'smartFilters', 'chatEngaged'], action.payload);
  }
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_213" /* setSmartFilters */], function (state, action) {
  return state.setIn(['entities', 'playbooks', '' + state.get('result'), 'targeting', 'smartFilters'], action.payload);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["s" /* clearEmailBanner */], function (state, action) {
  var emailId = action.payload.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'bannerImageUrl'], null);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_162" /* setEmailBannerSuccess */], function (state, action) {
  var _action$payload36 = action.payload,
      res = _action$payload36.res,
      emailId = _action$payload36.emailId;

  return state.setIn(['entities', 'emails', '' + emailId, 'bannerImageUrl'], res.url);
}), _defineProperty(_handleActions15, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_206" /* setSignatureIncludeAvatar */], __WEBPACK_IMPORTED_MODULE_7__actions__["_208" /* setSignatureIncludeSocial */], __WEBPACK_IMPORTED_MODULE_7__actions__["_207" /* setSignatureIncludeBanner */], __WEBPACK_IMPORTED_MODULE_7__actions__["_205" /* setSignatureBody */]), function (state, action) {
  var attribute = null;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_7__actions__["_206" /* setSignatureIncludeAvatar */].toString():
      attribute = 'includeAvatar';
      break;
    case __WEBPACK_IMPORTED_MODULE_7__actions__["_208" /* setSignatureIncludeSocial */].toString():
      attribute = 'includeCompanySocialMedia';
      break;
    case __WEBPACK_IMPORTED_MODULE_7__actions__["_207" /* setSignatureIncludeBanner */].toString():
      attribute = 'hasCampaignGraphic';
      break;
    case __WEBPACK_IMPORTED_MODULE_7__actions__["_205" /* setSignatureBody */].toString():
      attribute = 'signatureBody';
      break;
  }

  if (attribute === null) {
    return state;
  }

  return state.updateIn(['entities', 'signatureActions'], function (sigs) {
    return sigs.map(function (sig) {
      return sig.set(attribute, action.payload);
    });
  });
}), _defineProperty(_handleActions15, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_204" /* setSignatureBannerSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_202" /* setSignatureBannerLinkURL */]), function (state, action) {
  var _action$payload37 = action.payload,
      signatureId = _action$payload37.signatureId,
      value = _action$payload37.value;


  var attribute = action.type === __WEBPACK_IMPORTED_MODULE_7__actions__["_204" /* setSignatureBannerSuccess */].toString() ? 'campaignGraphic' : 'campaignGraphicLink';

  return state.setIn(['entities', 'signatureActions', '' + signatureId, '' + attribute], value);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["u" /* clearSignatureBanner */], function (state, action) {
  var signatureId = action.payload;
  return state.setIn(['entities', 'signatureActions', '' + signatureId, 'campaignGraphic'], null);
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["j" /* addNewSignatureToPlaybook */], function (state) {
  var signatureId = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])();
  var signature = state.getIn(['entities', 'signatureActions'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).first() || __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */]();
  var actionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var newSignature = _extends({}, signature.toJS(), { id: signatureId, signatureId: null, campaignGraphic: null, campaignGraphicLink: null });
  return state.setIn(['entities', 'signatureActions', signatureId], __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */](newSignature)).updateIn(['entities', 'actionTypes', '' + actionId, 'action', 'signatureActions'], function (ids) {
    return ids.concat([signatureId]);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["g" /* addEmptyBannerSignature */], function (state) {
  var signatureId = Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* weakUuid */])();
  var signature = state.getIn(['entities', 'signatureActions'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).first() || __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */]();
  var actionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  var newSignature = _extends({}, signature.toJS(), { id: signatureId, signatureId: null, campaignGraphic: null, campaignGraphicLink: null, hasCampaignGraphic: false });
  return state.setIn(['entities', 'signatureActions', signatureId], __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */](newSignature)).updateIn(['entities', 'actionTypes', '' + actionId, 'action', 'signatureActions'], function (ids) {
    return ids.concat([signatureId]);
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_104" /* removeSignature */], function (state, action) {
  var signatureId = action.payload;
  var actionId = state.getIn(['entities', 'actionTypes']).first().get('id');
  return state.updateIn(['entities', 'signatureActions'], function (sigs) {
    return sigs.filterNot(function (sig) {
      return sig.id === signatureId;
    });
  }).updateIn(['entities', 'actionTypes', '' + actionId, 'action', 'signatureActions'], function (ids) {
    return ids.filter(function (id) {
      return id !== signatureId;
    });
  });
}), _defineProperty(_handleActions15, __WEBPACK_IMPORTED_MODULE_7__actions__["_102" /* removeEmptyBannerSignature */], function (state) {
  var signatureHasNoBanner = function signatureHasNoBanner(sig) {
    return !sig.hasCampaignGraphic;
  };
  var sigWithoutBanner = (state.getIn(['entities', 'signatureActions'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).filter(signatureHasNoBanner) || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).first();
  if (sigWithoutBanner) {
    var sigId = sigWithoutBanner.id;
    var actionId = state.getIn(['entities', 'actionTypes']).first().get('id');
    return state.updateIn(['entities', 'signatureActions'], function (sigs) {
      return sigs.filterNot(function (sig) {
        return sig.id === sigId;
      });
    }).updateIn(['entities', 'actionTypes', '' + actionId, 'action', 'signatureActions'], function (ids) {
      return ids.filter(function (id) {
        return id !== sigId;
      });
    });
  } else {
    return state;
  }
}), _handleActions15), null);

var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_17" /* fetchPlaybook */], __WEBPACK_IMPORTED_MODULE_7__actions__["_44" /* fetchPlaybookPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_24" /* fetchPlaybookCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_34" /* fetchPlaybookFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_108" /* savePlaybook */], __WEBPACK_IMPORTED_MODULE_7__actions__["_115" /* savePlaybookPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_109" /* savePlaybookCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_116" /* savePlaybookSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_114" /* savePlaybookFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_110" /* savePlaybookDraft */], __WEBPACK_IMPORTED_MODULE_7__actions__["_113" /* savePlaybookDraftPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_111" /* savePlaybookDraftCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_112" /* savePlaybookDraftFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_100" /* receivePlaybookDraft */], __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* acceptPlaybookDraft */]), function (state, action) {
  return action.type;
}), false);

var ui = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions17 = {}, _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_62" /* fetchSignatureMultiBannerPreview */], __WEBPACK_IMPORTED_MODULE_7__actions__["_64" /* fetchSignatureMultiBannerPreviewPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_63" /* fetchSignatureMultiBannerPreviewFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_65" /* fetchSignatureMultiBannerPreviewSuccess */]), function (state, action) {
  return state.setIn(['signatures', 'previewAll', 'status'], action.type);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_63" /* fetchSignatureMultiBannerPreviewFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_65" /* fetchSignatureMultiBannerPreviewSuccess */]), function (state, action) {
  return state.setIn(['signatures', 'previewAll', 'data'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload));
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_223" /* setViewingSignatureId */], function (state, action) {
  return state.set('signatures', 'viewing', action.payload.id);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["O" /* disablePlaybookAutosave */], function (state) {
  return state.set('autosave', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["T" /* enablePlaybookAutosave */], function (state) {
  return state.set('autosave', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_93" /* markDraftUnsaved */], function (state) {
  return state.set('saved', false).set('doPlaybookChanges', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_100" /* receivePlaybookDraft */], function (state) {
  return state.set('saved', true).set('doPlaybookChanges', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_154" /* setDraftStatusPending */], function (state) {
  return state.set('statusLoading', true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_155" /* setDraftStatusSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_152" /* setDraftStatusCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_153" /* setDraftStatusFailed */]), function (state) {
  return state.set('statusLoading', false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_133" /* sendTestSequenceSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_132" /* sendTestSequencePending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_131" /* sendTestSequenceFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_130" /* sendTestSequenceCancelled */]), function (state, action) {
  return state.set('sendTestSequenceStatus', action.type);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_33" /* fetchPlaybookCountsSuccess */], function (state, _ref2) {
  var payload = _ref2.payload;

  return state.set('counts', payload);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_108" /* savePlaybook */], __WEBPACK_IMPORTED_MODULE_7__actions__["_110" /* savePlaybookDraft */], __WEBPACK_IMPORTED_MODULE_7__actions__["_115" /* savePlaybookPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_113" /* savePlaybookDraftPending */]), function (state) {
  return state.set('saving', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_28" /* fetchPlaybookCardinalityPending */], function (state) {
  return state.set('cardinalityLoading', true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_29" /* fetchPlaybookCardinalitySuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_26" /* fetchPlaybookCardinalityCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_27" /* fetchPlaybookCardinalityFailed */]), function (state) {
  return state.set('cardinalityLoading', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_29" /* fetchPlaybookCardinalitySuccess */], function (state, action) {
  return state.set('targetingCardinality', action.payload.cardinality);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_2" /* fetchDataPreviewEmailPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_7" /* fetchDataPreviewSequenceEmailPending */]), function (state) {
  return state.set('templateContactPreviewLoading', true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_199" /* setSignatureBanner */], __WEBPACK_IMPORTED_MODULE_7__actions__["_203" /* setSignatureBannerPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_201" /* setSignatureBannerFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_204" /* setSignatureBannerSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_200" /* setSignatureBannerCancelled */]), function (state, action) {
  return state.set('signatureBannerUploadStatus', action.type);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_161" /* setEmailBannerPending */], function (state, action) {
  var emailId = action.payload.emailId;

  return state.setIn(['bannerUploadPending', emailId], true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_162" /* setEmailBannerSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_160" /* setEmailBannerFailed */]), function (state, action) {
  var emailId = action.payload.emailId;

  return state.setIn(['bannerUploadPending', emailId], false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_0" /* fetchDataPreviewEmailCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_1" /* fetchDataPreviewEmailFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_3" /* fetchDataPreviewEmailSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_5" /* fetchDataPreviewSequenceEmailCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_6" /* fetchDataPreviewSequenceEmailFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_8" /* fetchDataPreviewSequenceEmailSuccess */]), function (state) {
  return state.set('templateContactPreviewLoading', false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_112" /* savePlaybookDraftFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_111" /* savePlaybookDraftCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_100" /* receivePlaybookDraft */], __WEBPACK_IMPORTED_MODULE_7__actions__["_114" /* savePlaybookFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_116" /* savePlaybookSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_109" /* savePlaybookCancelled */]), function (state) {
  return state.set('saving', false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_17" /* fetchPlaybook */], __WEBPACK_IMPORTED_MODULE_7__actions__["C" /* createPlaybook */], __WEBPACK_IMPORTED_MODULE_7__actions__["_44" /* fetchPlaybookPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_119" /* searchPlaybooks */], __WEBPACK_IMPORTED_MODULE_7__actions__["_121" /* searchPlaybooksPending */]), function (state) {
  return state.set('fetching', true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_100" /* receivePlaybookDraft */], __WEBPACK_IMPORTED_MODULE_7__actions__["_122" /* searchPlaybooksSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_122" /* searchPlaybooksSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_120" /* searchPlaybooksFailed */]), function (state) {
  return state.set('fetching', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_61" /* fetchPlaybooksPrioritySuccess */], function (state, action) {
  var orderedIds = action.payload.sortBy(function (playbook) {
    return playbook.get('priority');
  }).map(function (playbook) {
    return playbook.get('id');
  }).toArray();
  return state.set('priorityOrderedPlaybookIds', orderedIds);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_3" /* fetchDataPreviewEmailSuccess */], function (state, action) {
  return state.setIn(['emailRenderedPreviews', action.payload.playbookId], action.payload.template);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_8" /* fetchDataPreviewSequenceEmailSuccess */], function (state, action) {
  return state.setIn(['emailRenderedPreviews', action.payload.emailId], action.payload.template);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_147" /* setCurrentGoalId */], function (state, action) {
  return state.set('currentGoalId', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_238" /* showSendEmailConfirmModal */], function (state) {
  return state.set('sendEmailConfirmModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_89" /* hideSendEmailConfirmModal */], function (state) {
  return state.set('sendEmailConfirmModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_231" /* showExtensionInviteModal */], function (state) {
  return state.set('extensionInviteModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_82" /* hideExtensionInviteModal */], function (state) {
  return state.set('extensionInviteModalVisible', false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_83" /* hideGoalActionModal */], __WEBPACK_IMPORTED_MODULE_7__actions__["_84" /* hideGoalRoutingModal */]), function (state) {
  return state.set('selectedGoalAction', null).set('goalActionModalVisible', false).set('goalRoutingModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_232" /* showGoalActionModal */], function (state) {
  return state.set('goalActionModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_233" /* showGoalRoutingModal */], function (state) {
  return state.set('goalRoutingModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_123" /* selectGoalAction */], function (state, action) {
  return state.set('selectedGoalAction', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_124" /* selectGoalRoutingOptionUI */], function (state, action) {
  return state.set('selectedGoalRoutingOption', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_175" /* setGoalRoutingView */], function (state, action) {
  return state.set('goalRoutingView', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_225" /* showAnswerModal */], function (state, action) {
  return state.set('answerModalVisible', true).set('currentAnswerId', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_236" /* showScheduleModal */], function (state) {
  return state.set('scheduleModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_87" /* hideScheduleModal */], function (state) {
  return state.set('scheduleModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_76" /* hideAnswerModal */], function (state) {
  return state.set('answerModalVisible', false).set('currentAnswerId', null);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_235" /* showQuestionAdvancedModal */], function (state, action) {
  return state.set('QuestionAdvancedModalVisible', true).set('currentQuestionId', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_86" /* hideQuestionAdvancedModal */], function (state) {
  return state.set('QuestionAdvancedModalVisible', false).set('currentQuestionId', null);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_227" /* showConditionModal */], function (state, action) {
  return state.set('conditionModalVisible', true).set('currentConditionId', action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_78" /* hideConditionModal */], function (state) {
  return state.set('conditionModalVisible', false).set('currentConditionId', null);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_230" /* showEditSenderModal */], function (state, action) {
  return state.setIn(['editSenderModal', 'visible'], true).setIn(['editSenderModal', 'editingEmailId'], action.payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_81" /* hideEditSenderModal */], function (state) {
  return state.setIn(['editSenderModal', 'visible'], false).setIn(['editSenderModal', 'editingEmailId'], null);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_239" /* showSequenceInviteModal */], function (state) {
  return state.set('sequenceInviteModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_90" /* hideSequenceInviteModal */], function (state) {
  return state.set('sequenceInviteModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_240" /* showTokenModal */], function (state) {
  return state.set('tokenModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_91" /* hideTokenModal */], function (state) {
  return state.set('tokenModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_228" /* showCtaButtonModal */], function (state) {
  return state.set('ctaButtonModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_79" /* hideCtaButtonModal */], function (state) {
  return state.set('ctaButtonModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_226" /* showCalendarLinkModal */], function (state) {
  return state.set('calendarLinkVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_77" /* hideCalendarLinkModal */], function (state) {
  return state.set('calendarLinkVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_234" /* showGoogleAuthModal */], function (state) {
  return state.set('googleAuthModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_85" /* hideGoogleAuthModal */], function (state) {
  return state.set('googleAuthModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_229" /* showDisableSalesSequenceModal */], function (state) {
  return state.set('disableSalesSequenceModalVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_80" /* hideDisableSalesSequenceModal */], function (state) {
  return state.set('disableSalesSequenceModalVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_237" /* showSegmentSelect */], function (state) {
  return state.set('segmentSelectVisible', true);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_88" /* hideSegmentSelect */], function (state) {
  return state.set('segmentSelectVisible', false);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_8_app_modules_profile_actions__["fetchUserProfilePending"], function (state) {
  return state.set('calendarProfileLoading', true);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_8_app_modules_profile_actions__["fetchUserProfileSuccess"], __WEBPACK_IMPORTED_MODULE_8_app_modules_profile_actions__["fetchUserProfileFailed"]), function (state) {
  return state.set('calendarProfileLoading', false);
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_69" /* getPlaybookByCampaignIdCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_70" /* getPlaybookByCampaignIdFailed */]), function (state, action) {
  var campaignId = action.payload.campaignId;

  return state.setIn(['campaignIdToPlaybookIdMap', campaignId], null);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_71" /* getPlaybookByCampaignIdPending */], function (state, action) {
  var campaignId = action.payload.campaignId;

  return state.setIn(['campaignIdToPlaybookIdMap', campaignId], 'PENDING');
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_72" /* getPlaybookByCampaignIdSuccess */], function (state, action) {
  var _action$payload38 = action.payload,
      playbook = _action$payload38.playbook,
      campaignId = _action$payload38.campaignId;

  return state.setIn(['campaignIdToPlaybookIdMap', campaignId], playbook.get('result').first());
}), _defineProperty(_handleActions17, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["o" /* asyncButtonPressFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["p" /* asyncButtonPressPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["q" /* asyncButtonPressSuccess */]), function (state, action) {
  var payload = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    at: action.payload.at,
    meta: action.payload.meta,
    status: action.type.toString()
  });
  return state.setIn(['asyncButtonPress', '' + action.payload.clickId], payload);
}), _defineProperty(_handleActions17, __WEBPACK_IMPORTED_MODULE_7__actions__["_158" /* setEditSenderLevel */], function (state, action) {
  return state.set('editSenderLevel', action.payload);
}), _handleActions17), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var byIds = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions18 = {}, _defineProperty(_handleActions18, __WEBPACK_IMPORTED_MODULE_7__actions__["_53" /* fetchPlaybooksByIdsSuccess */], function (state, action) {
  var playbooksById = action.payload.reduce(function (acc, playbook) {
    return acc.set(playbook.id, playbook);
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  return state.merge(playbooksById);
}), _defineProperty(_handleActions18, __WEBPACK_IMPORTED_MODULE_7__actions__["_74" /* getPlaybookPending */], function (state, action) {
  var playbookId = action.playbookId;

  return state.set(playbookId, 'PENDING');
}), _defineProperty(_handleActions18, __WEBPACK_IMPORTED_MODULE_7__actions__["_75" /* getPlaybookSuccess */], function (state, action) {
  var payload = action.payload;

  var playbookId = payload.get('result');
  return state.set(playbookId, payload.getIn(['entities', 'playbooks', playbookId]));
}), _handleActions18), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var playbookReportTypesByGate = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions19 = {}, _defineProperty(_handleActions19, __WEBPACK_IMPORTED_MODULE_7__actions__["_47" /* fetchPlaybooksByGatedPlanFailed */], function (state) {
  return state.set('loading', true);
}), _defineProperty(_handleActions19, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_46" /* fetchPlaybooksByGatedPlanCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["_47" /* fetchPlaybooksByGatedPlanFailed */]), function (state) {
  return state.set('loading', false);
}), _defineProperty(_handleActions19, __WEBPACK_IMPORTED_MODULE_7__actions__["_49" /* fetchPlaybooksByGatedPlanSuccess */], function (state, action) {
  return state.set('loading', false).set('types', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(action.payload)).set('loaded', true);
}), _handleActions19), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var campaignIdToPlaybook = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions20 = {}, _defineProperty(_handleActions20, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_38" /* fetchPlaybookForCampaignIdPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_36" /* fetchPlaybookForCampaignIdCancelled */]), function (state, action) {
  var payload = state.get(action.payload.campaignId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    status: action.type
  }));
  return state.set(action.payload.campaignId, payload);
}), _defineProperty(_handleActions20, __WEBPACK_IMPORTED_MODULE_7__actions__["_39" /* fetchPlaybookForCampaignIdSuccess */], function (state, action) {
  return state.setIn([action.payload.campaignId, 'data'], action.payload.data).setIn([action.payload.campaignId, 'status'], action.type);
}), _defineProperty(_handleActions20, __WEBPACK_IMPORTED_MODULE_7__actions__["_37" /* fetchPlaybookForCampaignIdFailed */], function (state, action) {
  return state.setIn([action.payload.campaignId, 'err'], action.payload.err).setIn([action.payload.campaignId, 'status'], action.type);
}), _handleActions20), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var playbooksByReportType = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__actions__["_57" /* fetchPlaybooksByReportTypeSuccess */], function (state, action) {
  return state.setIn(['data', action.payload.reportType, 'disabled'], action.payload.playbooks.filter(function (playbook) {
    return 'DISABLED' === playbook.status;
  }));
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  status: status,
  normalized: normalized,
  draft: draft,
  ui: ui,
  normalizedStatus: normalizedStatus,
  sendTestEmailStatus: sendTestEmailStatus,
  sendTestEmailId: sendTestEmailId,
  enrolledPlaybookId: enrolledPlaybookId,
  enrolledSequenceCount: enrolledSequenceCount,
  fetchEnrolledSequenceCountStatus: fetchEnrolledSequenceCountStatus,
  playbookForEndUser: playbookForEndUser,
  fetchPlaybookForEndUserStatus: fetchPlaybookForEndUserStatus,
  enrollErrorsByEmail: enrollErrorsByEmail,
  enrollStatusByEmail: enrollStatusByEmail,
  enrollingPlaybookId: enrollingPlaybookId,
  editingPlaybookId: editingPlaybookId,
  byIds: byIds,
  playbookReportTypesByGate: playbookReportTypesByGate,
  endUserEmail: endUserEmail,
  campaignIdToPlaybook: campaignIdToPlaybook,
  playbooksByReportType: playbooksByReportType
}));

/***/ }),

/***/ "/xdp":
/***/ (function(module, exports) {

module.exports = "<svg width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.988 7.173l6.13 6.153a.599.599 0 0 1-.42 1.02.594.594 0 0 1-.422-.175l-6.13-6.153-6.13 6.153a.591.591 0 0 1-.841 0 .599.599 0 0 1 0-.845l6.13-6.153L.174 1.02a.599.599 0 0 1 0-.845.594.594 0 0 1 .841 0l6.13 6.152 6.13-6.152a.594.594 0 0 1 .842 0 .6.6 0 0 1 0 .845l-6.13 6.153z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("NOUr");


/***/ }),

/***/ "0/Ul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__ = __webpack_require__("XmeL");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SlackTeamStore = function (_Marty$Store) {
  _inherits(SlackTeamStore, _Marty$Store);

  function SlackTeamStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SlackTeamStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlackTeamStore.__proto__ || Object.getPrototypeOf(SlackTeamStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = false, _this.handlers = {
      slackTeamFetched: __WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].FETCH_SLACK_TEAM_FINISHED
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SlackTeamStore, [{
    key: 'getOrFetchSlackTeam',
    value: function getOrFetchSlackTeam() {
      return this.fetch({
        id: 'getOrFetchSlackTeam',
        locally: function locally() {
          if (this.state) {
            return this.state;
          }
        },
        remotely: function remotely() {
          return this.app.actions.SlackTeamActions.fetchSlackTeam();
        }
      });
    }
  }, {
    key: 'slackTeamFetched',
    value: function slackTeamFetched(users) {
      this.state = users;
    }
  }]);

  return SlackTeamStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (SlackTeamStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "044x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StartConversation__ = __webpack_require__("kfQv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_conversation_ContactSideBar_Person_ActivitySection__ = __webpack_require__("HGzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_customer_EndUserAttributesCard__ = __webpack_require__("OnKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_customer_SegmentsCard__ = __webpack_require__("Joq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_conversation_ContactSideBar_Person_SalesforceSection__ = __webpack_require__("uwH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar_Person_HubSpotSection__ = __webpack_require__("WTSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("jBdL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ContactHeader__ = __webpack_require__("pM3z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_Integrations__ = __webpack_require__("CCiW");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











//replace these











var ContactRecordLite = function (_Component) {
  _inherits(ContactRecordLite, _Component);

  function ContactRecordLite() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactRecordLite);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactRecordLite.__proto__ || Object.getPrototypeOf(ContactRecordLite)).call.apply(_ref, [this].concat(args))), _this), _this.updateFollow = function () {
      _this.props.actions.updateFollowing({
        following: !_this.props.following,
        id: _this.props.user.id
      });
    }, _this.renderSalesforceEnrichment = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'section',
        { className: 'lite-contact-about' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_conversation_ContactSideBar_Person_SalesforceSection__["a" /* default */], { email: _this.props.user.email })
      );
    }, _this.renderHubSpotEnrichment = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'section',
        { className: 'lite-contact-about' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar_Person_HubSpotSection__["a" /* default */], { email: _this.props.user.email })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactRecordLite, [{
    key: 'renderActivity',
    value: function renderActivity() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'section',
        { className: 'lite-contact-activity' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_conversation_ContactSideBar_Person_ActivitySection__["a" /* default */], { endUserId: this.props.user.id })
      );
    }
  }, {
    key: 'renderAbout',
    value: function renderAbout() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'section',
        { className: 'lite-contact-about' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_customer_EndUserAttributesCard__["a" /* default */], { hideAllAttributesModal: true, endUser: this.props.user })
      );
    }
  }, {
    key: 'renderSegments',
    value: function renderSegments() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'section',
        { className: 'lite-contact-segments' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_customer_SegmentsCard__["a" /* default */], { endUserId: this.props.user.id })
      );
    }
  }, {
    key: 'renderInfoSection',
    value: function renderInfoSection() {
      var _props = this.props,
          user = _props.user,
          userStatus = _props.userStatus,
          following = _props.following;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ContactHeader__["a" /* default */], {
        user: user,
        userStatus: userStatus,
        hasFollowing: this.props.hasFollowing,
        following: following,
        updateFollowing: this.updateFollow });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          listenForMessageSent = _props2.listenForMessageSent,
          user = _props2.user,
          hasSalesforce = _props2.hasSalesforce,
          hasHubSpot = _props2.hasHubSpot;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'contact-record-lite' },
        this.renderInfoSection(),
        user && user.id ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StartConversation__["a" /* default */], { userId: user.id, userType: this.props.user.type, listenForMessageSent: listenForMessageSent }),
          this.renderActivity(),
          hasSalesforce && this.renderSalesforceEnrichment(),
          hasHubSpot && this.renderHubSpotEnrichment(),
          this.renderAbout(),
          this.renderSegments()
        ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex-center', style: { marginTop: '75px' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Loading__["a" /* default */], { size: 'large', color: '#7695A5' })
        )
      );
    }
  }]);

  return ContactRecordLite;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ContactRecordLite.propTypes = {
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  listenForSideBarClose: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  listenForMessageSent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  userStatus: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    lastUpdateAt: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    onlineAt: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    isConnected: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    geo: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
  })
};
ContactRecordLite.defaultProps = {
  userStatus: {}
};


var makeMapStateToProps = function makeMapStateToProps() {
  return function (state, props) {
    return {
      following: props.user.id && __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_selectors__["b" /* followingId */](props.user.id)(state),
      hasFollowing: __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates('has_following'),
      hasSalesforce: Object(__WEBPACK_IMPORTED_MODULE_16_utils_Integrations__["b" /* isIntegrationConnected */])('salesforce'),
      hasHubSpot: Object(__WEBPACK_IMPORTED_MODULE_16_utils_Integrations__["b" /* isIntegrationConnected */])('hubspot')
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchFollowing: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__["s" /* fetchFollowing */],
      updateFollowing: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__["_7" /* updateFollowing */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(ContactRecordLite));

/***/ }),

/***/ "08hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Application; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getApplication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marty_lib_modules_core_warnings__ = __webpack_require__("3dYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_marty_lib_modules_core_warnings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_marty_lib_modules_core_warnings__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// From Marty documentation
// (http://martyjs.org/guides/application/automatic-registration.html)


__WEBPACK_IMPORTED_MODULE_0_marty_lib_modules_core_warnings___default.a.parseJSONDeprecated = false;

// "It's easy to forget to register a type in the application after you create
// it. Fortunately if you're using webpack or browserify we can automate the
// registration process."
var SINGLETON_APPLICATION = false;

var context = __webpack_require__("ZbBQ");

var Application = Marty.createApplication(function () {
  var _this = this;

  _.each(context.keys(), function (key) {
    var id = void 0;
    if (/\.js/.test(key)) {
      id = key.slice(0, -'.js'.length).replace('./', '').replace(/\//g, '.');
      _this.register(id, context(key).default);
    }

    if (/\.coffee/.test(key)) {
      id = key.slice(0, -'.coffee'.length).replace('./', '').replace(/\//g, '.');
      return _this.register(id, context(key));
    }
  });

  return SINGLETON_APPLICATION = this;
});

var getApplication = function getApplication() {
  return SINGLETON_APPLICATION;
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "093v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middleware__ = __webpack_require__("chwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__("GUao");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["a"] = (function () {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var history = arguments[1];

  var enhancers = [__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */].apply(undefined, _toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_2__middleware__["a" /* default */])(history)))];

  var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: "Drift Web App",
    actionsBlacklist: ['@@app/presence/SET_BUFFERED_USERS', '@@app/presence/ADD_USER_PROCESSED', '@@app/presence/REMOVE_USER_PROCESSED', '@@app/presence/REMOVE_USER_PROCESSED_DELAYED']
  }) : __WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */];

  var store = Object(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */])(Object(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* makeRootReducer */])(), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(initialState), composeEnhancers.apply(undefined, enhancers));

  store.asyncReducers = {};

  if (false) {
    module.hot.accept('./reducers', function () {
      var reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
});

/***/ }),

/***/ "0AcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_segment_models__ = __webpack_require__("1uBT");






var api = {
  fetchList: function fetchList() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/user_lists').checkStatus().retryWithBackoff().mapResponse(function (segments) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(segments).map(__WEBPACK_IMPORTED_MODULE_3_app_modules_segment_models__["b" /* parseSegment */]);
    });
  },
  fetchSegmentSetCardinality: function fetchSegmentSetCardinality(userListIds) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/user_lists/member-cardinality?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])({ userListIds: userListIds.toJS() })).checkStatus().retryWithBackoff();
  },
  fetchEndUserMembership: function fetchEndUserMembership(endUserId, orgId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + endUserId + '/memberships?orgId=' + orgId).checkStatus().retryWithBackoff();
  }
};

/***/ }),

/***/ "0HTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {function makeInputChangeHandler(stateKeyPath, callback) {
  var _this = this;

  return function (newValue) {
    var newState = _.cloneDeep(_this.state);
    _.set(newState, stateKeyPath, newValue);
    _this.setState(newState);
    if (callback) {
      return callback(newValue);
    }
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({ makeInputChangeHandler: makeInputChangeHandler });
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "0Ikz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__ = __webpack_require__("xMS5");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


var NoteActions = Marty.createActionCreators({
  createNoteForEndUserId: function createNoteForEndUserId(endUserId, note) {
    return this.app.queries.NoteQueries.createNoteForEndUserId(endUserId, note);
  },
  createNoteForCompanyId: function createNoteForCompanyId(companyId, note) {
    return this.app.queries.NoteQueries.createNoteForCompanyId(companyId, note);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NoteActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "0KWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_PlaybookPreviews_Takeover__ = __webpack_require__("/Iz4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Editor__ = __webpack_require__("eJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageCta__ = __webpack_require__("K2hD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Card__ = __webpack_require__("ExgD");









var TakeoverMessage = function TakeoverMessage(_ref) {
  var message = _ref.message,
      onMessageChange = _ref.onMessageChange,
      headline = _ref.headline,
      onHeadlineChange = _ref.onHeadlineChange,
      ctaCopy = _ref.ctaCopy,
      selectedUser = _ref.selectedUser,
      onAuthorChange = _ref.onAuthorChange,
      defaultEmbed = _ref.defaultEmbed,
      hideCta = _ref.hideCta;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Customize the message your users will see.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'What do you want to say? Keep it short and sweet, be personal and human!'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__Card__["a" /* default */],
      { title: 'Takeover Message', description: headline, className: 'drift-form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_PlaybookPreviews_Takeover__["a" /* default */], {
        message: message,
        headline: headline,
        ctaCopy: ctaCopy,
        showCta: !hideCta,
        fontFamily: defaultEmbed.theme.fontFamily,
        backgroundColor: defaultEmbed.theme.backgroundColor }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Headline'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: onHeadlineChange, value: headline }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Takeover Message Copy'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Editor__["a" /* default */], { value: message, onChange: onMessageChange }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MessageCta__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Send From'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_UserSelect__["a" /* default */], { selectedUserId: selectedUser ? selectedUser.id : null, onUserIdChange: onAuthorChange, clearable: true, restrictCalendarUsers: true })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TakeoverMessage);

/***/ }),

/***/ "0Mws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_actions__ = __webpack_require__("SKr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_selectors__ = __webpack_require__("XmtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_Integrations__ = __webpack_require__("CCiW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var mapStateToProps = function mapStateToProps(state, props) {
  var ip = props.ip;
  var email = props.email;

  var revealContext = Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state);

  return {
    ip: ip,
    email: email,
    revealContext: revealContext,
    companyData: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_selectors__["b" /* companyDataJS */])(state, { ip: ip, email: email }),
    hasDemandbase: Object(__WEBPACK_IMPORTED_MODULE_6_utils_Integrations__["b" /* isIntegrationConnected */])('demandbase'),
    isCompanyDataLoaded: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_selectors__["c" /* isCompanyDataLoaded */])(state, { ip: ip, email: email }),
    isCompanyDataLoading: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_selectors__["d" /* isCompanyDataLoading */])(state, { ip: ip, email: email })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])(_extends({
      fetchEnrichedCompanyData: __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_actions__["f" /* fetchEnrichedCompanyData */]
    }, props.actions), dispatch)
  };
};

var tryFetchCompanyData = function tryFetchCompanyData(props) {
  var ip = props.ip,
      email = props.email,
      actions = props.actions,
      companyData = props.companyData,
      revealContext = props.revealContext,
      hasDemandbase = props.hasDemandbase,
      conversationId = props.conversationId,
      isCompanyDataLoaded = props.isCompanyDataLoaded,
      isCompanyDataLoading = props.isCompanyDataLoading;


  function hasMandatoryDataForFetch(ip, email) {
    return !!ip || !!email;
  }

  if (!!companyData || !hasMandatoryDataForFetch(ip, email)) {
    return;
  }

  if ((hasDemandbase || revealContext.conversationsReveal) && !isCompanyDataLoaded && !isCompanyDataLoading) {
    actions.fetchEnrichedCompanyData({ ip: ip, email: email, conversationId: conversationId, keepEmpty: true, ignoreForwardingFor: true });
  }
};

var withEnrichedCompanyData = function withEnrichedCompanyData(WrappedComponent) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
    componentDidUpdate: function componentDidUpdate(prevProps) {
      if (prevProps.ip !== this.props.ip || prevProps.email !== this.props.email) {
        tryFetchCompanyData(this.props);
      }
    },
    componentDidMount: function componentDidMount() {
      tryFetchCompanyData(this.props);
    }
  }))(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (withEnrichedCompanyData);

/***/ }),

/***/ "0NJA":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 163 128\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M9.78 15.595l1.33 4.504c.113.386.416.687.802.801l4.518 1.326c1.136.333 1.136 1.937 0 2.27l-4.518 1.326c-.386.114-.69.415-.802.8l-1.33 4.504c-.334 1.132-1.943 1.132-2.277 0l-1.33-4.503a1.188 1.188 0 0 0-.803-.801L.85 24.496c-1.134-.333-1.134-1.937 0-2.27L5.37 20.9c.386-.114.689-.415.803-.8l1.33-4.505c.334-1.131 1.943-1.131 2.277 0\" fill=\"#7695A5\"></path><path d=\"M136.152 42.585H36.366V31.413c0-3.895 3.167-7.051 7.075-7.051h85.636c3.908 0 7.075 3.156 7.075 7.051v11.172zm0 .014V98.04c0 3.896-3.167 7.053-7.075 7.053H43.441c-3.908 0-7.075-3.157-7.075-7.053V42.6h99.786z\" fill=\"#B4C3D8\" filter=\"url(#a)\" transform=\"translate(0 1)\"></path><path d=\"M157.699 65.47l.89 3.013a.791.791 0 0 0 .538.536l3.022.886c.759.224.759 1.296 0 1.52l-3.022.888a.784.784 0 0 0-.537.534l-.891 3.013c-.223.758-1.299.758-1.523 0l-.89-3.013a.784.784 0 0 0-.536-.534l-3.023-.888c-.76-.224-.76-1.296 0-1.52l3.023-.886a.792.792 0 0 0 .535-.536l.891-3.013c.224-.758 1.3-.758 1.523 0\" fill=\"#B4C3D8\"></path><path d=\"M70.88 5.196a3.2 3.2 0 0 1-3.205 3.196 3.201 3.201 0 0 1-3.207-3.196 3.201 3.201 0 0 1 3.207-3.197 3.2 3.2 0 0 1 3.204 3.197z\" stroke=\"#B4C3D8\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M117.08 122.84a3.201 3.201 0 0 1-3.206 3.197 3.2 3.2 0 0 1-3.205-3.196 3.2 3.2 0 0 1 3.205-3.197 3.201 3.201 0 0 1 3.206 3.197z\" stroke=\"#7695A5\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.472 89.86a2.309 2.309 0 0 1-2.313 2.305 2.308 2.308 0 0 1-2.31-2.306 2.307 2.307 0 0 1 2.31-2.304 2.307 2.307 0 0 1 2.313 2.304\" fill=\"#B4C3D8\"></path><path d=\"M136.152 41.585H36.366V30.413c0-3.895 3.167-7.051 7.075-7.051h85.636c3.908 0 7.075 3.156 7.075 7.051v11.172z\" fill=\"#7695A5\"></path><path d=\"M136.152 41.599H36.366V97.04c0 3.896 3.167 7.053 7.075 7.053h85.636c3.908 0 7.075-3.157 7.075-7.053V41.6z\" fill=\"#FFF\"></path><path d=\"M47.422 32.668a2.547 2.547 0 0 1-2.552 2.544 2.547 2.547 0 0 1-2.55-2.545 2.546 2.546 0 0 1 2.55-2.542 2.546 2.546 0 0 1 2.552 2.543M55.825 32.668a2.547 2.547 0 0 1-2.55 2.544 2.547 2.547 0 0 1-2.552-2.545 2.546 2.546 0 0 1 2.552-2.542 2.546 2.546 0 0 1 2.55 2.543M64.23 32.668a2.547 2.547 0 0 1-2.552 2.544 2.548 2.548 0 0 1-2.552-2.545 2.547 2.547 0 0 1 2.552-2.542 2.546 2.546 0 0 1 2.552 2.543\" fill=\"#ECF0F5\"></path><path d=\"M80.162 90.815c-.565.436-1.158.855-1.77 1.236a26.28 26.28 0 0 1-1.215.71l-.247.137a5.713 5.713 0 0 1-.346.173 22.526 22.526 0 0 1-10.279 2.466c-3.807 0-7.384-.938-10.534-2.594-.064-.037-.118-.063-.183-.1-.21-.11-.429-.227-.629-.345a12.636 12.636 0 0 1-.722-.437c-.045-.028-.081-.055-.128-.082-.63-.4-1.232-.83-1.816-1.283-5.268-4.141-8.655-10.557-8.655-17.766 0-12.475 10.152-22.596 22.667-22.596 12.524 0 22.676 10.12 22.676 22.596 0 7.281-3.45 13.752-8.819 17.885z\" fill=\"#E1EEF4\"></path><path d=\"M149.387 11.021l-7.904 7.881\" fill=\"#FFF\"></path><path d=\"M149.387 11.021l-7.904 7.881\" stroke=\"#7695A5\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M136.216 8.776l-.814 6.489\" fill=\"#FFF\"></path><path d=\"M136.216 8.776l-.814 6.489\" stroke=\"#7695A5\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M152.76 23.751l-7.63 1.212\" fill=\"#FFF\"></path><path d=\"M152.76 23.751l-7.63 1.212\" stroke=\"#7695A5\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M99.669 63.55h16.68M123.121 63.55h4.013M99.669 72.403h6.41M112.78 72.403h14.353M99.669 81.256h11.666M118.21 81.256h1.602\" stroke=\"#B4C3D8\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><g fill=\"#7695A5\"><path d=\"M78.172 71.694h-1.573v8.573h1.558c.43 0 .779.349.779.78v3.117a.78.78 0 0 1-.779.78H54.79a.78.78 0 0 1-.78-.78v-3.117c0-.431.35-.78.78-.78h1.558v-8.573H54.79a.78.78 0 0 1-.51-1.369l11.701-10.132a.777.777 0 0 1 1.02 0l11.58 10.058a.779.779 0 0 1-.409 1.443zm-15.625 8.573h3.148v-8.573h-3.148v8.573zm4.705 0h3.116v-8.573h-3.116v8.573zm4.674 0h3.115v-8.573h-3.115v8.573zm-16.357 3.117h21.81v-1.558h-21.81v1.558zm5.452-3.117v-8.573H57.86v8.573h3.162zm5.469-18.453l-9.61 8.321H76.07l-9.581-8.32z\"></path></g></g></svg>"

/***/ }),

/***/ "0OV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__ = __webpack_require__("GoMo");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var upload = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file) {
    var data;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = new FormData();

            data.append('file', file);
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["FileAPI"].post('/upload', data, {
              raw: true,
              headers: {}
            }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function upload(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "0PwQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(52);

/***/ }),

/***/ "0RUX":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Goal-Action-Route\" transform=\"translate(-421.000000, -371.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(397.000000, 352.000000)\"><g id=\"user\" transform=\"translate(24.000000, 19.000000)\"><path d=\"M15.2,19.2 L0.8,19.2 C0.3584,19.2 0,18.8416 0,18.4 L0,17.8664 C0,14.548 2.464,11.656 5.7416,10.72 C3.776,9.8496 2.4,7.884 2.4,5.6 C2.4,2.512 4.912,0 8,0 C11.088,0 13.6,2.512 13.6,5.6 C13.6,7.884 12.224,9.8496 10.2584,10.72 C13.536,11.656 16,14.548 16,17.8664 L16,18.4 C16,18.8416 15.6416,19.2 15.2,19.2 Z M12,5.6 C12,3.3944 10.2056,1.6 8,1.6 C5.7944,1.6 4,3.3944 4,5.6 C4,7.8056 5.7944,9.6 8,9.6 C10.2056,9.6 12,7.8056 12,5.6 Z M8,12 C4.628,12 1.7648,14.5384 1.6072,17.6 L14.3928,17.6 C14.2352,14.5384 11.372,12 8,12 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "0WCR":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 23 16\" xmlns=\"http://www.w3.org/2000/svg\"><title>Check Mark</title><path d=\"M8.5 11.64L19.7.44a1.5 1.5 0 1 1 2.12 2.12L9.81 14.57c-.034.036-.07.07-.108.1a1.5 1.5 0 0 1-2.258.156L1.19 8.57a1.5 1.5 0 1 1 2.12-2.12l5.19 5.19z\" id=\"color\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "0WTh":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "0fRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ConversationConstants__ = __webpack_require__("pIAZ");




var ConversationStore = Marty.createStore({
  id: 'ConversationStore',

  getInitialState: function getInitialState() {
    return {
      conversationsById: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),

      searchResults: {},

      lastQueryByInboxId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
      hasMoreGroupsByInboxId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
      cursorByInboxId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
    };
  },


  handlers: {
    getOrFetchConversation: __WEBPACK_IMPORTED_MODULE_1_constants_ConversationConstants__["a" /* default */].CONVERSATION_FETCH,
    fetchConversationDone: __WEBPACK_IMPORTED_MODULE_1_constants_ConversationConstants__["a" /* default */].CONVERSATION_FETCH_DONE,

    searchAllConversationsDone: __WEBPACK_IMPORTED_MODULE_1_constants_ConversationConstants__["a" /* default */].SEARCH_ALL_CONVERSATIONS_DONE
  },

  fetchConversationsByIdDone: function fetchConversationsByIdDone(conversationsById) {
    conversationsById = this.state.conversationsById.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(conversationsById).mapKeys(parseInt));
    return this.setState({ conversationsById: conversationsById });
  },
  getOrFetchConversation: function getOrFetchConversation(conversationId) {
    return this.fetch({
      id: 'getConversation' + conversationId,
      locally: function locally() {
        return this.getConversationById(conversationId);
      },
      remotely: function remotely() {
        return this.app.queries.ConversationQueries.fetchConversation(conversationId);
      }
    });
  },
  getConversationById: function getConversationById(conversationId) {
    return this.state.conversationsById.get(conversationId);
  },
  fetchConversationDone: function fetchConversationDone(conversationId, conversation) {
    return this.setState({ conversationsById: this.state.conversationsById.set(conversationId, conversation) });
  },
  getConversationUpdateStateById: function getConversationUpdateStateById() {
    return this.state.conversationUpdateStateById;
  },
  searchAllConversationsDone: function searchAllConversationsDone(query, searchResult) {
    var searchResults = _.cloneDeep(this.state.searchResults);
    searchResults[query] = searchResult;
    return this.setState({ searchResults: searchResults });
  },
  getSearchResults: function getSearchResults() {
    return this.state.searchResults;
  },
  resetSearchResults: function resetSearchResults() {
    return this.setState({ searchResults: {} });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ConversationStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "0h7c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"activitySectionPlaceholder":"activitySectionPlaceholder---219MJ"};

/***/ }),

/***/ "0hmb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var NoteAPI = Marty.createStateSource({
  id: 'NoteAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  fetchNotesForEndUserId: function fetchNotesForEndUserId(endUserId) {
    return this.get({
      url: '/end_users/' + endUserId + '/notes',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchNotesForCompanyId: function fetchNotesForCompanyId(companyId) {
    return this.get({
      url: '/companies/' + companyId + '/notes',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createNoteForEndUserId: function createNoteForEndUserId(endUserId, note) {
    return this.post({
      url: '/end_users/' + endUserId + '/notes',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(note)
    });
  },
  createNoteForCompanyId: function createNoteForCompanyId(companyId, note) {
    return this.post({
      url: '/companies/' + companyId + '/notes',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(note)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NoteAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "0l4V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__botFollowUp__ = __webpack_require__("+aVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("ZWQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var MatchAnswerBody = function MatchAnswerBody(_ref) {
  var skipToOptions = _ref.skipToOptions,
      currentSkipToOption = _ref.currentSkipToOption,
      onSkipToChange = _ref.onSkipToChange,
      targetCopy = _ref.targetCopy,
      shortTargetCopy = _ref.shortTargetCopy,
      botFollowUpProps = _ref.botFollowUpProps;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.AnswerModalContent },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__botFollowUp__["a" /* default */], botFollowUpProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'drift-form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Trigger On Successful Capture'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'When a user responds with a valid ',
        targetCopy,
        ', we\u2019ll trigger this follow up and add this',
        ' ',
        shortTargetCopy,
        ' to their contact record. If we already know their ',
        shortTargetCopy,
        ', we\u2019ll automatically skip to the Next Step!'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'drift-form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Next Step'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'If user matches this follow up, end the conversation or skip them to a different question or goal. You can only skip ahead.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__["b" /* default */], {
        className: 'skip-select',
        options: skipToOptions,
        clearable: true,
        value: currentSkipToOption,
        onChange: onSkipToChange
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MatchAnswerBody);

/***/ }),

/***/ "0lGI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UserSelectionSection":"UserSelectionSection---2LNac"};

/***/ }),

/***/ "0mIB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0qK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__ = __webpack_require__("wFBz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("QkC9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TeamAvatarList = function (_PureComponent) {
  _inherits(TeamAvatarList, _PureComponent);

  function TeamAvatarList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TeamAvatarList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamAvatarList.__proto__ || Object.getPrototypeOf(TeamAvatarList)).call.apply(_ref, [this].concat(args))), _this), _this.getUserTitle = function (user) {
      return user.name || user.email || user.alias;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TeamAvatarList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'selected-team-members' },
        this.props.teamMembers.map(function (member, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index, className: 'team-list-member' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Avatar"], { user: member }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'choice-option-value' },
              _this2.getUserTitle(member)
            )
          );
        })
      );
    }
  }]);

  return TeamAvatarList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    teamMembers: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["c" /* teamMembers */])(state, { teamId: props.teamId })
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(TeamAvatarList));

/***/ }),

/***/ "0t1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AddButton_index__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("aiMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ALLOWED_TYPES = Object.freeze(["STRING", "NUMERIC", "DATE", "DATETIME"]);

var conversationMetrics = { 'Agent average response time': "Duration",
  'Agent max response time': "Duration",
  'Agent message count': "Integer",
  'End time': "Date Time",
  'Request time': "Date Time",
  'Response time': "Duration",
  'Start time': "Date Time",
  'Time to close': "Duration",
  'Visitor average response time': "Duration",
  'Visitor max response time': "Duration",
  'Visitor message count': "Integer",
  'Conversation Id': "Integer"
};

var SalesforceMetricsMapping = function (_Component) {
  _inherits(SalesforceMetricsMapping, _Component);

  function SalesforceMetricsMapping(props) {
    var _this2 = this;

    _classCallCheck(this, SalesforceMetricsMapping);

    var _this = _possibleConstructorReturn(this, (SalesforceMetricsMapping.__proto__ || Object.getPrototypeOf(SalesforceMetricsMapping)).call(this, props));

    _this.componentDidMount = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var fetchedProps;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__["a" /* api */].fetchSFDCProperties('task');

            case 3:
              fetchedProps = _context.sent;

              _this.setState({
                sfdcTaskFields: fetchedProps.properties,
                isLoading: false
              });
              _context.next = 12;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.error(_context.t0);
              _this.props.notifications.error("Failed to retrieve SFDC Task Fields. If this problem persists, chat in");
              _this.setState({
                isLoading: false
              });

            case 12:
              _this.props.actions.fetchSFDCMetricsMappings();
              if (!_this.state.mappings.length) {
                _this.addNewMapping();
              }

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }));

    _this.addNewMapping = function () {
      _this.setState(function (prevState) {
        return {
          mappings: [].concat(_toConsumableArray(prevState.mappings), [{}])
        };
      });
    };

    _this.removeMapping = function (index) {
      _this.setState(function (prevState) {
        var updatedMappings = [].concat(_toConsumableArray(prevState.mappings));
        updatedMappings.splice(index, 1);

        return { mappings: updatedMappings };
      });
    };

    _this.isClean = function () {
      if (!_this.state.isLoading && !!_this.state.sfdcTaskFields.length && _this.state.sfdcTaskFields.length === 0) {
        notifications.error("Failed to retrieve task fields from Salesforce. This is likely due to a lack of read permissions on task fields.");
      }

      var validMappings = _this.getValidMappings();
      return _.isEqual(validMappings, _this.props.sfdcMetricMappings);
    };

    _this.getValidMappings = function () {
      return _.filter(_this.state.mappings, function (map) {
        return _this.isMappingValid(map);
      });
    };

    _this.saveUpdatedMappings = function () {
      if (!_this.isClean()) {
        var _notifications = _this.props.notifications;

        _this.props.actions.patchSFDCMetricsMappings(_this.getValidMappings(), function () {
          return _notifications.success("You successfully updated your Salesforce App!");
        });
      }
    };

    _this.state = {
      mappings: _.cloneDeep(props.sfdcMetricMappings),
      sfdcTaskFields: [],
      isLoading: true
    };
    return _this;
  }

  _createClass(SalesforceMetricsMapping, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var _props = this.props,
          sfdcMetricMappings = _props.sfdcMetricMappings,
          sfdcPatchMetricsErr = _props.sfdcPatchMetricsErr;

      if (!_.isEqual(prevProps.sfdcMetricMappings, sfdcMetricMappings)) {
        this.setState({
          mappings: _.cloneDeep(sfdcMetricMappings)
        });
      }

      if (sfdcPatchMetricsErr) {
        sfdcPatchMetricsErr.json().then(function (resp) {
          resp.message && _this3.props.notifications.error(resp.message);
        });
      }
    }
  }, {
    key: 'getSalesforceTaskFieldOptions',
    value: function getSalesforceTaskFieldOptions(fieldName) {
      var _this4 = this;

      var mappedFields = this.state.mappings.map(function (mapping) {
        return mapping.integrationAttribute;
      }).filter(function (name) {
        return name !== fieldName;
      });
      if (!fieldName) {
        var unMappedFields = this.state.mappings.filter(function (mapping) {
          return mapping.driftAttribute && !mapping.integrationAttribute;
        }).map(function (mapping) {
          return mapping.driftAttribute;
        });
        if (unMappedFields[0]) {
          return this.state.sfdcTaskFields.filter(function (mapping) {
            return _this4.checkType(conversationMetrics[unMappedFields[0]], mapping.type);
          }).map(function (mapping) {
            return { label: mapping.displayName, value: mapping.name };
          });
        }
      }

      return this.state.sfdcTaskFields.filter(function (mapping) {
        return !mappedFields.includes(mapping.name) && ALLOWED_TYPES.includes(mapping.type);
      }).map(function (mapping) {
        return { label: mapping.displayName, value: mapping.name };
      });
    }
  }, {
    key: 'getFormattedMetricOptions',
    value: function getFormattedMetricOptions() {
      return Object.keys(conversationMetrics).map(function (metric) {
        return { value: metric, label: metric };
      });
    }
  }, {
    key: 'saveSalesforceOption',
    value: function saveSalesforceOption(value, index) {
      this.setState(function (prevState) {
        var newMappings = [].concat(_toConsumableArray(prevState.mappings));
        newMappings[index].integrationAttribute = value ? value.value : null;
        return { newMappings: newMappings };
      });
    }
  }, {
    key: 'saveDriftMetricOption',
    value: function saveDriftMetricOption(value, index) {
      this.setState(function (prevState) {
        var newMappings = [].concat(_toConsumableArray(prevState.mappings));
        newMappings[index].driftAttribute = value ? value.value : null;
        return { newMappings: newMappings };
      });
    }
  }, {
    key: 'renderSalesforceDropdown',
    value: function renderSalesforceDropdown(value, index) {
      var _this5 = this;

      var selectOptions = {
        placeholder: "Select Salesforce task field..",
        value: value,
        options: this.getSalesforceTaskFieldOptions(value),
        searchable: true,
        clearable: false,
        pageSize: 10,
        onChange: function onChange(value) {
          return _this5.saveSalesforceOption(value, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], selectOptions);
    }
  }, {
    key: 'renderDriftMetricDropdown',
    value: function renderDriftMetricDropdown(id, index) {
      var _this6 = this;

      var selectOptions = {
        value: id,
        pageSize: 10,
        searchable: true,
        clearable: false,
        placeholder: "Select conversation metric..",
        options: this.getFormattedMetricOptions(),
        onChange: function onChange(value) {
          return _this6.saveDriftMetricOption(value, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], selectOptions);
    }
  }, {
    key: 'renderMappingRows',
    value: function renderMappingRows() {
      var _this7 = this;

      return this.state.mappings.map(function (mapping, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'tr',
          { key: index },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'td',
            null,
            _this7.renderDriftMetricDropdown(mapping.driftAttribute || mapping.defaultValue, index)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td', { className: 'salesforce-metric-mapping-table-separator' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'td',
            { className: 'salesforce-metric-mapping-table-separator-type' },
            conversationMetrics[mapping.driftAttribute]
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td', { className: 'salesforce-metric-mapping-table-separator' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'td',
            null,
            _this7.renderSalesforceDropdown(mapping.integrationAttribute, index)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'td',
            { className: 'salesforce-metric-mapping-actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { onClick: function onClick() {
                  return _this7.removeMapping(index);
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 15, name: 'close' })
            )
          )
        );
      });
    }
  }, {
    key: 'checkType',
    value: function checkType(driftType, salesforceType) {
      if (driftType === "Date Time" && (salesforceType === "DATE" || salesforceType === "DATETIME" || salesforceType === "STRING")) {
        return true;
      }
      if (driftType === "Duration" && salesforceType === "STRING") {
        return true;
      }
      if (driftType === "Integer" && (salesforceType === "NUMERIC" || salesforceType === "STRING")) {
        return true;
      }
      // Returns whether the drift type is compatible with the salesforce type.
      return false;
    }
  }, {
    key: 'isMappingTypeConsistent',
    value: function isMappingTypeConsistent(mapping) {
      var notifications = this.props.notifications;
      var sfdcTaskFields = this.state.sfdcTaskFields;

      var field = sfdcTaskFields.filter(function (field) {
        return field.name === mapping.integrationAttribute;
      })[0];
      if (!field) {
        notifications.error('The Salesforce task field ' + mapping.integrationAttribute + ' was not found in your Salesforce instance. Remove the blank mapping below for task attachment to succeed');
        return true;
      }
      if (field.type && this.checkType(conversationMetrics[mapping.driftAttribute], field.type)) {
        return true;
      }
      notifications.error('Metric ' + mapping.driftAttribute + '\'s type, ' + conversationMetrics[mapping.driftAttribute] + ', cannot be mapped to ' + field.displayName + '\'s type, ' + field.type);
      mapping.integrationAttribute = null;
      return false;
    }
  }, {
    key: 'isMappingValid',
    value: function isMappingValid(mapping) {
      return !_.isEmpty(mapping) && (!!mapping.driftAttribute || !!mapping.defaultValue) && !!mapping.integrationAttribute && this.isMappingTypeConsistent(mapping);
    }
  }, {
    key: 'render',
    value: function render() {
      var sfdcPatchMetricsLoading = this.props.sfdcPatchMetricsLoading;

      if (this.state.isLoading) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'mapping-actions' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
            {
              onClick: this.saveUpdatedMappings,
              size: 'medium',
              loading: sfdcPatchMetricsLoading,
              disabled: this.isClean()
            },
            'Update'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'salesforce-metric-mapping' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'table',
            { className: 'drift-table' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'td',
                  null,
                  'Conversation Metric'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td', { className: 'salesforce-metric-mapping-table-separator' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'td',
                  null,
                  'type'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td', { className: 'salesforce-metric-mapping-table-separator' }),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'td',
                  null,
                  'Salesforce Attribute'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td', { className: 'salesforce-metric-mapping-actions' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'tbody',
              null,
              this.renderMappingRows()
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AddButton_index__["a" /* default */], {
            addButtonLabel: 'Map New Conversation Metric',
            type: 'tertiary',
            onClick: this.addNewMapping
          })
        )
      );
    }
  }]);

  return SalesforceMetricsMapping;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(SalesforceMetricsMapping));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "0vKZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NPS_ICON_SRC = __webpack_require__("Cyhm");

var NPSCampaignEvent = function (_Component) {
  _inherits(NPSCampaignEvent, _Component);

  function NPSCampaignEvent() {
    _classCallCheck(this, NPSCampaignEvent);

    return _possibleConstructorReturn(this, (NPSCampaignEvent.__proto__ || Object.getPrototypeOf(NPSCampaignEvent)).apply(this, arguments));
  }

  _createClass(NPSCampaignEvent, [{
    key: 'render',
    value: function render() {
      var campaign = this.props.event.body.campaign;

      var eventProps = _extends({
        iconSrc: NPS_ICON_SRC,
        eventLabel: 'submitted an NPS response'
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
        eventProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/campaigns/' + campaign.id },
          campaign.name
        )
      );
    }
  }]);

  return NPSCampaignEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NPSCampaignEvent);

/***/ }),

/***/ "0y2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_check_in_box_svg__ = __webpack_require__("5XQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_check_in_box_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_check_in_box_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_infinite_svg__ = __webpack_require__("oG2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_infinite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_infinite_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__component__ = __webpack_require__("DJtO");























var SegmentTypeToLabel = {
  ID_LIST: 'Static segment',
  QUERY: 'Dynamic segment'
};
var SegmentTypeToIcon = {
  ID_LIST: __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_check_in_box_svg___default.a,
  QUERY: __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_infinite_svg___default.a
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userListIds: __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    segments: __WEBPACK_IMPORTED_MODULE_12_app_modules_segment_selectors__["e" /* segments */](state),
    orgUsersById: __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["orgUsersById"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      setUserListIds: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["_221" /* setUserListIds */],
      setAudience: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["_137" /* setAudience */],
      hideSegmentSelect: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["_88" /* hideSegmentSelect */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onChange: function onChange(props) {
    return function (selectedSegments) {
      var selectedSegmentIds = Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])(selectedSegments).map(function (selection) {
        return selection.value;
      });
      props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_14_app_modules_playbook_constants__["w" /* AudienceType */].SEGMENT);
      props.actions.setUserListIds(selectedSegmentIds);
    };
  },
  onCancel: function onCancel(props) {
    return function () {
      props.actions.hideSegmentSelect();
    };
  }
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (props) {
  return {
    options: (props.extraOptions || Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])()).concat(props.segments).map(function (segment) {
      var name = segment.name,
          id = segment.id,
          authorId = segment.authorId,
          type = segment.type;

      var author = props.orgUsersById.get(authorId);
      return {
        value: id,
        name: name,
        label: React.createElement(
          'div',
          { className: 'flex' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('icon segment-option-icon', 'icon-type-' + type.toLowerCase()),
            src: SegmentTypeToIcon[type]
          }),
          React.createElement(
            'div',
            { className: 'segment-option-meta' },
            React.createElement(
              'div',
              { className: 'segment-option-name' },
              name
            ),
            React.createElement(
              'div',
              { className: 'segment-option-description' },
              SegmentTypeToLabel[type],
              ' ',
              !!author ? 'created by ' + (author.name || author.email) : ''
            )
          )
        )
      };
    }).toArray(),
    value: props.value || props.userListIds.toJS()
  };
}))(__WEBPACK_IMPORTED_MODULE_17__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "0yFz":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 36 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M36 13.984c0 .035-.016.065-.02.1v31.824c0 1.114-.908 2.023-2.024 2.023H2.036A2.038 2.038 0 0 1 0 45.897V2.04C0 .92.913.007 2.037.007h19.95c.046 0 .085.02.13.026a.937.937 0 0 1 .127.026c.17.046.33.12.45.24l12.885 12.87c.03.024.046.062.075.088.03.027.052.057.077.088.155.175.27.387.27.64zM2 1.94v43.956l32 .044v-31H22c-.552 0-1.01-.405-1.01-.956V1.94H2zm20.988 1.475v9.57h9.58l-9.58-9.57zm-8.29 34.238a.993.993 0 0 1-.706.293.993.993 0 0 1-.706-.293l-5.997-5.99a.995.995 0 0 1 0-1.412l5.996-5.99a.998.998 0 0 1 1.413 1.412l-5.29 5.285 5.29 5.284a.998.998 0 0 1 0 1.413zm6.583-13.39a1 1 0 0 1 1.415 0l5.997 5.99a.998.998 0 0 1 0 1.412l-5.997 5.99a.993.993 0 0 1-.707.293.997.997 0 0 1-.707-1.704l5.292-5.285-5.29-5.286a.997.997 0 0 1 0-1.41z\" fill=\"#9A9A9A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1+QT":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE4IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE2LjUgMTZoLTE1Qy42NzMgMTYgMCAxNS4zNDcgMCAxNC41NDVWMS40NTVDMCAuNjUzLjY3MyAwIDEuNSAwaDE1Yy44MjcgMCAxLjUuNjUzIDEuNSAxLjQ1NXYxMy4wOWMwIC44MDItLjY3MyAxLjQ1NS0xLjUgMS40NTV6bS0xNS0xLjQ1NWgxNC45OThsLjAwMS0xMC4xODJIMS41djEwLjE4MnptMC0xMy4wOXYxLjQ1NGgxNVYxLjQ1NWgtMTV6bTkuNTMgMTAuNjk2YS43Ni43NiAwIDAgMS0uNTMuMjE0Ljc1OS43NTkgMCAwIDEtLjUzLS4yMTQuNzEuNzEgMCAwIDEgMC0xLjAyOGwxLjcyLTEuNjY4LTEuNzItMS42NjdhLjcxLjcxIDAgMCAxIDAtMS4wMjkuNzY4Ljc2OCAwIDAgMSAxLjA2IDBsMi4yNTEgMi4xODJhLjcxLjcxIDAgMCAxIDAgMS4wMjlsLTIuMjUgMi4xODJ6bS0zIDBhLjc2Ljc2IDAgMCAxLS41My4yMTMuNzU5Ljc1OSAwIDAgMS0uNTMtLjIxM0w0LjcyIDkuOTY5YS43MS43MSAwIDAgMSAwLTEuMDI5bDIuMjUtMi4xODJhLjc2Ni43NjYgMCAwIDEgMS4wNiAwIC43MS43MSAwIDAgMSAwIDEuMDI5TDYuMzEyIDkuNDU0bDEuNzIgMS42NjdhLjcxLjcxIDAgMCAxIDAgMS4wMjlIOC4wM3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "1/7D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/F1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_settings_GlobalCalendarSettings_OfficeLogo__ = __webpack_require__("3Z2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_meetings_tease_calendar_connect_png__ = __webpack_require__("ovfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_meetings_tease_calendar_connect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_meetings_tease_calendar_connect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("mNi5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var GlobalCalendarInfo = function GlobalCalendarInfo() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'settings-meeting-globally-managed' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'settings-meeting-globally-managed info' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_settings_GlobalCalendarSettings_OfficeLogo__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'settings-meeting-globally-managed-title' },
        'Your org\u2019s calendars are managed by a Drift Admin'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'settings-meeting-globally-managed-description' },
        'To start booking meetings with your leads and customers directly through Drift, contact your admin and ask to have your work calendar connected.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_2_images_meetings_tease_calendar_connect_png___default.a })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalCalendarInfo);

/***/ }),

/***/ "109c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("CZZ5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__("2KeS");










var mapStateToProps = function mapStateToProps(state, props) {
  return {
    embed: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["h" /* getEmbedConfig */](state),
    inbox: props.params.inboxId !== 'new' && __WEBPACK_IMPORTED_MODULE_3_app_modules_inbox_selectors__["c" /* inbox */](props.params.inboxId)(state),
    createdInboxId: __WEBPACK_IMPORTED_MODULE_3_app_modules_inbox_selectors__["a" /* createdInboxId */](state),
    inboxesById: __WEBPACK_IMPORTED_MODULE_3_app_modules_inbox_selectors__["f" /* inboxes */](state).toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__["A" /* fetchInboxList */],
      patchInbox: __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__["O" /* patchInbox */],
      createInbox: __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__["j" /* createInbox */],
      fetchEmbed: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__["a" /* fetchEmbed */],
      archiveInbox: __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__["a" /* archiveInbox */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchInboxList();
    this.props.actions.fetchEmbed();
  }
}))(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),

/***/ "13Mi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("4PhQ");





function fetchRules(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRules"].toString()).throttleTime(5000).exhaustMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].rxfetchRules().mapResponse(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRulesSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRulesPending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRulesFailed"]({ error: error }));
    });
  });
}

var fetchRoundRobinByKey = function fetchRoundRobinByKey(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRoundRobinByKey"].toString()).pluck('payload').mergeMap(function (_ref) {
    var roundRobinKey = _ref.roundRobinKey;
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchRoundRobin(roundRobinKey).map(function (_ref2) {
      var response = _ref2.response;
      return __WEBPACK_IMPORTED_MODULE_2__actions__["fetchRoundRobinByKeySuccess"]({ data: response, roundRobinKey: roundRobinKey });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRoundRobinByKeyPending"]({ roundRobinKey: roundRobinKey })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchRoundRobinByKeyFailed"]({ roundRobinKey: roundRobinKey, err: err }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetchRules, fetchRoundRobinByKey);

/***/ }),

/***/ "13R5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SectionItem":"SectionItem---323qD"};

/***/ }),

/***/ "13uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OrgSwitcherSection__ = __webpack_require__("VjwN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AgentStatusSection__ = __webpack_require__("4Vm/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_hocs_withTracking__ = __webpack_require__("xq94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__("wfBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var DRIFT_ORG_ID = 1;

var getAppLink = function getAppLink(path) {
  return '' + __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["c" /* APP_URL */] + path;
};

var driftLogo = __webpack_require__("TZYG");

var DriftStatus = function DriftStatus() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
    { href: getAppLink('/settings/widget') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('agent-flyout-link-container', 'agent-flyout-status-logo') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'widget-online', height: '18' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Span"],
        { className: 'agent-status-flyout-settings-nav-link', role: 'button' },
        'Drift status'
      )
    )
  );
};

var DriftSettings = function DriftSettings() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
    { href: getAppLink('/settings2/account') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
      { className: 'agent-flyout-link-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'settings-1', height: '18' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Span"],
        { className: 'agent-status-flyout-settings-nav-link' },
        'Settings'
      )
    )
  );
};

var DriftHelp = function DriftHelp() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
    { href: getAppLink('/help') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("agent-flyout-link-container", "agent-flyout-help-logo") },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'knowledgebase-book', height: '18' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Span"],
        { className: 'agent-status-flyout-settings-nav-link' },
        'Drift Help'
      )
    )
  );
};

var DriftNotifications = function DriftNotifications() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
    { href: getAppLink('/settings2/notifications') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("agent-flyout-link-container", "agent-flyout-notification-logo") },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'notification', height: '18' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Span"],
        { className: 'agent-status-flyout-settings-nav-link' },
        'Notifications'
      )
    )
  );
};

var DriftAdminPanel = function DriftAdminPanel() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
    { href: getAppLink('/settings2/deal-admin') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("agent-flyout-link-container", "agent-flyout-admin-panel") },
      Object(__WEBPACK_IMPORTED_MODULE_11__Integration_helpers__["d" /* renderLogoSVG */])(driftLogo),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Span"],
        { className: 'agent-status-flyout-settings-nav-link' },
        'Drift Admin Panel'
      )
    )
  );
};

var DriftAgentFlyout = function (_Component) {
  _inherits(DriftAgentFlyout, _Component);

  function DriftAgentFlyout(props) {
    _classCallCheck(this, DriftAgentFlyout);

    var _this = _possibleConstructorReturn(this, (DriftAgentFlyout.__proto__ || Object.getPrototypeOf(DriftAgentFlyout)).call(this, props));

    _this.canAccessDriftHelp = function () {
      return _this.props.hasDriftHelpCutover && __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasScopes('org_admin');
    };

    _this.canAccessDriftAdminPanel = function () {
      var user = _this.props.user;

      return user.orgId === DRIFT_ORG_ID;
    };

    _this.toggleOrgSwitcher = function (event) {
      var showOrgSwitcher = _this.state.showOrgSwitcher;

      event.preventDefault();
      _this.setState({ showOrgSwitcher: !showOrgSwitcher });
    };

    _this.logoutUser = function () {
      _this.props.track("User logged out");
      Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */]);
    };

    _this.state = {
      displayableIdentities: Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["getDisplayableIdentities"])()
    };
    return _this;
  }

  _createClass(DriftAgentFlyout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          trafficControlConfig = _props.trafficControlConfig;
      var showOrgSwitcher = this.state.showOrgSwitcher;

      var hasAgentStatus = Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["pathOr"])(false, ['hasAgentStatus'], trafficControlConfig);
      var hasNotifications = Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["pathOr"])(false, ['hasNotifications'], trafficControlConfig);
      var hasDriftStatus = Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["pathOr"])(false, ['hasDriftStatus'], trafficControlConfig);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
        { className: 'drift-status-flyout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
          { className: 'agent-status-flyout-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
            { className: 'agent-status-flyout-header-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Avatar"], {
              withPresence: true,
              availability: user.availability === 'AVAILABLE' ? 'available' : 'away',
              withBorder: false,
              user: user,
              size: 'small'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["H4"],
              { className: 'agent-status-flyout-header-name' },
              ' ',
              user.name || user.email,
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["P"],
              { className: 'agent-status-flyout-profile-url' },
              ' ',
              user.email,
              ' '
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
          { className: 'drift-status-options-wrapper' },
          hasAgentStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AgentStatusSection__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Nav"],
            null,
            hasDriftStatus && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DriftStatus, null),
            hasNotifications && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DriftNotifications, null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DriftSettings, null),
            this.canAccessDriftHelp() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DriftHelp, null),
            this.canAccessDriftAdminPanel() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DriftAdminPanel, null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
          { className: 'agent-status-section drift-status-options-wrapper drift-status-options-switch-account' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["A"],
            { className: 'agent-status-flyout-settings-nav-action', onClick: this.toggleOrgSwitcher, href: '/', role: 'button' },
            'Switch account'
          ),
          showOrgSwitcher && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__OrgSwitcherSection__["a" /* default */], { onChange: function onChange() {
              return _this2.setState({ displayableIdentities: Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["getDisplayableIdentities"])() });
            } }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Div"],
            { className: 'agent-status-flyout-settings-nav-action', onClick: this.logoutUser },
            'Sign out'
          )
        )
      );
    }
  }]);

  return DriftAgentFlyout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_hocs_withTracking__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default()(DriftAgentFlyout)));

/***/ }),

/***/ "14CA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var api = {
  /**
   * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
   */
  fetchEnrichedCompanyData: function fetchEnrichedCompanyData() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  },


  /**
  * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
  */
  fetchDecodedCondition: function fetchDecodedCondition(provider) {
    var conditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var ip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '127.0.0.1';
    var orgId = arguments[3];

    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  }
};

/***/ }),

/***/ "17LC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dizzy_bot_404_json__ = __webpack_require__("Yalu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dizzy_bot_404_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__dizzy_bot_404_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("qHbA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);






var BODYMOVIN_OPTIONS = {
  loop: true,
  autoplay: true,
  prerender: true,
  renderer: 'svg',
  animationData: __WEBPACK_IMPORTED_MODULE_2__dizzy_bot_404_json___default.a
};

var NotFoundPage = function NotFoundPage() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Div"],
    { className: 'not-found-page' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Div"],
      { className: 'not-found-animation' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["BodyMovin"], { options: BODYMOVIN_OPTIONS })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["H1"],
      { className: 'not-found-header' },
      'Oh man, you stumped DriftBot!'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["P"],
      { className: 'not-found-subtext' },
      'We can\u2019t seem to find what you\u2019re looking for\u2026maybe it\u2019s time for a reboot \uD83D\uDE48'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),

/***/ "18cF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_SFDC_containers_UserMapping__ = __webpack_require__("e7xn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("ha7b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MAPPED_SALESFORCE_USERS_URL = '/settings/salesforce/mapping/users';

var SalesforceAction = function (_Component) {
  _inherits(SalesforceAction, _Component);

  function SalesforceAction() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SalesforceAction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SalesforceAction.__proto__ || Object.getPrototypeOf(SalesforceAction)).call.apply(_ref, [this].concat(args))), _this), _this.onMappingsChange = function (_ref2) {
      var isValid = _ref2.isValid;

      _this.props.setPageValidity(isValid);
      if (isValid) {
        _this.props.updateAction(_extends({}, __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_models__["y" /* salesforceAction */], {
          options: {}
        }));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SalesforceAction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.setPageValidity(true);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice rules-url-filter salesforce-user-mapping-rules' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Add Participants'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'We\u2019ll add the mapped Lead or Account Owner in Salesforce as a participant in the conversation.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'To map a new Salesforce user to Drift, head to your',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: MAPPED_SALESFORCE_USERS_URL },
              ' Mapped Salesforce Users.'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-content drift-form salesforce-user-mappings-read-only' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_SFDC_containers_UserMapping__["a" /* default */], {
              readOnly: true,
              onChange: this.onMappingsChange
            })
          )
        )
      );
    }
  }]);

  return SalesforceAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceAction);

/***/ }),

/***/ "19Z2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1BrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* unused harmony export newConversation */
/* unused harmony export notifyOffline */
/* unused harmony export notifyOnline */
/* harmony export (immutable) */ __webpack_exports__["b"] = installSegment;
/* harmony export (immutable) */ __webpack_exports__["c"] = installWidgetStub;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideWelcomeMessage;
/* harmony export (immutable) */ __webpack_exports__["d"] = waitForUserJwt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_makeSegmentSnippet__ = __webpack_require__("Jnvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_icons_refresh_icon_svg__ = __webpack_require__("CU4V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_icons_refresh_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_icons_refresh_icon_svg__);





function newConversation() {
  if (typeof window.drift === 'undefined' || window.drift === null) {
    return;
  }
  return window.drift.on('ready', function (api) {
    return api.sidebar.open();
  });
}

function notifyOffline(app) {
  app.actions.NotificationActions.pushNotification({
    content: 'Looks like you’re offline? Just hit refresh when you’re back.',
    sticky: true,
    actioNode: React.createElement(
      'a',
      { href: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["c" /* APP_URL */], className: 'dsg-SmallButton' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_icons_refresh_icon_svg___default.a,
        style: { marginRight: 3, height: 12, width: 12 }
      }),
      'Refresh'
    ),
    variant: 'red'
  });
}

function notifyOnline(app) {
  app.actions.NotificationActions.pushNotification({
    content: 'You are back online!',
    variant: 'green'
  });
}

function installSegment() {
  var scriptTag = document.createElement("script");
  scriptTag.id = "segment-container";
  scriptTag.innerHTML = Object(__WEBPACK_IMPORTED_MODULE_2_constants_makeSegmentSnippet__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["S" /* SEGMENT_ID */]);
  document.body.appendChild(scriptTag);
}

function installWidgetStub() {
  var drift = window.drift = window.driftt = window.drift || window.driftt || [];

  var methods = ['identify', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on', 'config', 'setUserJwt', 'waitForUserJwt'];
  methods.forEach(function (key) {
    if (!drift[key]) {
      drift[key] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        drift.push([key].concat(args));
      };
    }
  });
}

function hideWelcomeMessage() {
  window.drift.config({
    enableWelcomeMessage: false
  });
}

function waitForUserJwt() {
  if (!window.drift) {
    console.warn('widget stub is not installed yet, you need to call installWidgetStub() first');
    return;
  }

  window.drift.waitForUserJwt();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "1C73":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1CGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_HelpDocConstants__ = __webpack_require__("fBam");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FullStory = function (_Component) {
  _inherits(FullStory, _Component);

  function FullStory() {
    _classCallCheck(this, FullStory);

    return _possibleConstructorReturn(this, (FullStory.__proto__ || Object.getPrototypeOf(FullStory)).apply(this, arguments));
  }

  _createClass(FullStory, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'FullStory Customer? Drift will automatically detect FullStory on your site and FullStory session URLs will begin appearing inside of Drift. It\u2019s like magic.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Want more information? ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: __WEBPACK_IMPORTED_MODULE_1_constants_HelpDocConstants__["b" /* FULLSTORY_HELPDOC_URL */], target: '_blank' },
            'Learn more.'
          )
        )
      );
    }
  }]);

  return FullStory;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FullStory);

/***/ }),

/***/ "1CT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component__ = __webpack_require__("CIRE");


















var mapStateToProps = function mapStateToProps(state) {
  var question = __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["M" /* getCurrentQuestion */](state);
  return {
    questionIndex: question && __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_14" /* getQuestionIndex */](state, { id: question.id }),
    FieldAttributes: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_attribute_selectors__["d" /* propertiesOptions */])(state).toJS(),
    isCreateAttributePending: function isCreateAttributePending(attr) {
      return __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_selectors__["c" /* isCreateAttributePending */](state, attr);
    },
    question: question,
    buttonOnlyResponses: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["g" /* buttonOnlyResponses */](state, question.id),
    questionHasKeywordAnswers: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_65" /* questionHasKeywordAnswers */](state, question.id),
    numKeywordsInQuestion: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_54" /* numKeywordsInQuestion */](state, question.id),
    keywordAnswersForQuestion: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_52" /* keywordAnswersForQuestion */](state, question.id)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideQuestionAdvancedModal: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_86" /* hideQuestionAdvancedModal */],
      setResponse: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_188" /* setResponse */],
      setFieldAttributeName: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_172" /* setFieldAttributeName */],
      createPropertyDefinition: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__["f" /* createPropertyDefinition */],
      setButtonOnlyResponses: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_139" /* setButtonOnlyResponses */],
      deleteAnswer: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["G" /* deleteAnswer */],
      fetchAttributes: __WEBPACK_IMPORTED_MODULE_12_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default()('confirmKeywordsDelete', 'setConfirmKeywordsDelete', false), __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default()('selectedFieldAttribute', 'selectFieldAttribute', undefined), __WEBPACK_IMPORTED_MODULE_6_recompose_withProps___default()(function (props) {
  return {
    isSelectedAttributeCreatePending: props.isCreateAttributePending(props.selectFieldAttribute)
  };
}), __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle___default()({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        fetchAttributes = _props.actions.fetchAttributes,
        selectFieldAttribute = _props.selectFieldAttribute,
        question = _props.question;

    fetchAttributes();
    if (!_.isEmpty(question.fieldConfiguration)) {
      selectFieldAttribute(question.fieldConfiguration.get('fieldName'));
    }
  }
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onNewOptionClick: function onNewOptionClick(props) {
    return function (option) {
      var createPropertyDefinition = props.actions.createPropertyDefinition;

      if (option) {
        createPropertyDefinition({ name: option.value });
      }
    };
  },
  onCloseClick: function onCloseClick(props) {
    return function () {
      var hideQuestionAdvancedModal = props.actions.hideQuestionAdvancedModal;

      hideQuestionAdvancedModal();
    };
  },
  onSelectFieldAttribute: function onSelectFieldAttribute(props) {
    return function (selection) {
      var value = _.get(selection, 'value', '').toLowerCase().replace(/\s/g, '_').replace(/[^a-z0-9\_]+/g, '');
      if (!!value && value[0] === '_') return false;
      var selectFieldAttribute = props.selectFieldAttribute,
          setFieldAttributeName = props.actions.setFieldAttributeName,
          questionId = props.question.id;

      selectFieldAttribute(value);
      setFieldAttributeName({ questionId: questionId, attribute: value });
    };
  },
  onDeleteAllKeywordResponses: function onDeleteAllKeywordResponses(_ref) {
    var deleteAnswer = _ref.actions.deleteAnswer,
        keywordAnswersForQuestion = _ref.keywordAnswersForQuestion,
        question = _ref.question;
    return function () {
      keywordAnswersForQuestion.forEach(function (answer) {
        return deleteAnswer({ answerId: answer.id, questionId: question.id });
      });
    };
  },
  onToggleButtonOnlyResponse: function onToggleButtonOnlyResponse(_ref2) {
    var setButtonOnlyResponses = _ref2.actions.setButtonOnlyResponses,
        questionId = _ref2.question.id;
    return function (evt) {
      setButtonOnlyResponses({ value: evt.target.checked, questionId: questionId });
    };
  },
  onFirstDeleteKeywordClick: function onFirstDeleteKeywordClick(_ref3) {
    var deleteAnswer = _ref3.actions.deleteAnswer,
        numKeywordsInQuestion = _ref3.numKeywordsInQuestion,
        setConfirmKeywordsDelete = _ref3.setConfirmKeywordsDelete,
        question = _ref3.question,
        keywordAnswersForQuestion = _ref3.keywordAnswersForQuestion;
    return function () {
      if (numKeywordsInQuestion) {
        setConfirmKeywordsDelete(true);
      } else {
        keywordAnswersForQuestion.forEach(function (answer) {
          return deleteAnswer({ answerId: answer.id, questionId: question.id });
        });
      }
    };
  }
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onNewOptionClick: function onNewOptionClick(props) {
    return function (option) {
      var createPropertyDefinition = props.actions.createPropertyDefinition;

      if (option) {
        createPropertyDefinition({ name: option.value });
        props.onSelectFieldAttribute(option);
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_13__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "1FFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");



var DefaultEmbedAPI = Marty.createStateSource({
  id: 'DefaultEmbedAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["_3" /* WIDGET_CACHE_API */],

  fetchDefaultEmbed: function fetchDefaultEmbed() {
    return this.get({
      url: '/embeds/_default',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  patchDefaultEmbed: function patchDefaultEmbed(operations) {
    return this.patch({
      url: '/embeds/_default/configuration',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(operations)
    });
  },
  refreshDefaultEmbed: function refreshDefaultEmbed() {
    return this.put({
      url: '/embeds/_default/refresh',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (DefaultEmbedAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "1Hoc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamAvailabilitySettings; });
/* unused harmony export AvailabilitySlotTime */
/* unused harmony export AvailabilitySlot */
/* unused harmony export DEFAULT_AVAILABILITY_SLOT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var TeamAvailabilitySettings = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  updatedAt: Date.now() * 1000,
  openHours: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  name: undefined,
  timezone: 'America/New_York'
});

var AvailabilitySlotTime = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  hour: 0,
  minutes: 0
});

var AvailabilitySlot = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  dayOfWeek: undefined,
  startTime: AvailabilitySlotTime(),
  endTime: AvailabilitySlotTime()
});

var DEFAULT_AVAILABILITY_SLOT = AvailabilitySlot({
  dayOfWeek: 'WEEKDAYS',
  startTime: AvailabilitySlotTime({
    hour: 9,
    minutes: 0
  }),
  endTime: AvailabilitySlotTime({
    hour: 17,
    minutes: 0
  })
});

/***/ }),

/***/ "1Ihb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);



var api = {
  fetch: function fetch() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxWidgetCacheAPI"].get('/embeds/_default').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchById: function fetchById(embedId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxWidgetCacheAPI"].get('/embeds/' + embedId).checkStatus().retryWithBackoff(1).mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  updateEmbedSettings: function updateEmbedSettings(operations) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["WidgetCacheAPI"].patch('/embeds/_default/configuration', operations).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "1JRE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1KjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoteInput__ = __webpack_require__("WJ2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("ep7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var style = {
  width: 120,
  height: 37.5
};

var ActionToComponent = {
  note: __WEBPACK_IMPORTED_MODULE_2__NoteInput__["a" /* Option */]
};

var Inputs = function (_Component) {
  _inherits(Inputs, _Component);

  function Inputs(props) {
    _classCallCheck(this, Inputs);

    var _this = _possibleConstructorReturn(this, (Inputs.__proto__ || Object.getPrototypeOf(Inputs)).call(this, props));

    _this.makeOnActionSelect = function (key) {
      return function () {
        _this.setState({ selectedAction: key });
      };
    };

    _this.state = {
      selectedAction: 'note'
    };
    return _this;
  }

  _createClass(Inputs, [{
    key: 'renderActions',
    value: function renderActions() {
      var _this2 = this;

      return _.map(ActionToComponent, function (value, key) {
        var selected = key === _this2.state.selectedAction;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            style: style,
            className: (selected ? __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.SelectedAction : __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.Action) + ' flex-center',
            onClick: _this2.makeOnActionSelect(key),
            key: key
          },
          value.display
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var selectedComponent = ActionToComponent[this.state.selectedAction].component;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: { padding: '0 1rem' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex' },
          this.renderActions()
        ),
        Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(selectedComponent, { endUser: this.props.endUser })
      );
    }
  }]);

  return Inputs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Inputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "1MSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DisconnectButton__ = __webpack_require__("8UUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_markdown__ = __webpack_require__("bckq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExternalIntegrationInstallModal__ = __webpack_require__("dAuv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_EloquaIntegrationPage__ = __webpack_require__("Ko7A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_DisconnectConfirmModal__ = __webpack_require__("T45g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_PardotIntegrationPage__ = __webpack_require__("dUGx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl__ = __webpack_require__("z7IT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var INSTALL_STATUS_POLL_LIMIT = 6;
var CONNECTED_TEXT = 'You are connected to this integration!';

var ExternalIntegration = function (_Component) {
  _inherits(ExternalIntegration, _Component);

  function ExternalIntegration(props) {
    _classCallCheck(this, ExternalIntegration);

    var _this = _possibleConstructorReturn(this, (ExternalIntegration.__proto__ || Object.getPrototypeOf(ExternalIntegration)).call(this, props));

    _this.onCancelConnectIntegration = function () {
      _this.setState({
        isInstallModalOpen: false
      });
    };

    _this.disconnectIntegration = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          actions = _this$props.actions;


      var onDone = function onDone() {
        actions.track('Integration Disconnected', { integration: data.name, connected: false });
        window.location.href = window.location.origin + '/settings2/integrations';
      };

      var onError = function onError() {
        _this.props.notifications.error('Ooops, something went wrong. Plese try again.');
      };

      var onStateSet = function onStateSet() {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["_2" /* uninstallInstalledApp */])(_this.props.data.id).then(onDone).catch(onError);
      };

      _this.setState({ isDisconnecting: true }, onStateSet);
    };

    _this.closeModal = function () {
      _this.setState({ isInstallModalOpen: false });
    };

    _this.handleClickSSOInstall = function () {
      // reload page because auth has been done for both sso and dev plat on the backend
      location.reload();
    };

    _this.onInstallClick = function () {
      var _this$state = _this.state,
          isFetchingScopes = _this$state.isFetchingScopes,
          scopes = _this$state.scopes;
      var _this$props2 = _this.props,
          data = _this$props2.data,
          notifications = _this$props2.notifications;


      if (isFetchingScopes) {
        return;
      }

      var onScopesFetched = function onScopesFetched(scopes) {
        _this.setState({
          scopes: scopes,
          isInstallModalOpen: true,
          isFetchingScopes: false
        });
      };

      var onError = function onError() {
        var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Ooops, something went wrong. Plese try again.';

        notifications.error(text);
        _this.setState({ isFetchingScopes: false });
      };

      var fetchScopes = function fetchScopes() {
        return Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["i" /* fetchAppScopes */])(data.id).then(onScopesFetched).catch(onError);
      };

      var integrationWillInstall = function integrationWillInstall() {
        if (data.id !== __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */]) {
          fetchScopes();
        }
      };

      if (Object(__WEBPACK_IMPORTED_MODULE_16_ramda__["isEmpty"])(scopes)) {
        _this.setState({ isFetchingScopes: true }, integrationWillInstall);
      } else {
        _this.setState({ isInstallModalOpen: true });
      }
    };

    _this.pollForInstallStatus = function () {
      var _this$state2 = _this.state,
          isInstalling = _this$state2.isInstalling,
          installStatusPollCount = _this$state2.installStatusPollCount;
      var data = _this.props.data;


      var onDone = function onDone(_ref) {
        var installed = _ref.installed;

        if (installed) {
          _this.setState({
            isInstalled: true,
            isInstalling: false
          });
        }
      };

      Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["h" /* fetchApp */])(data.id).then(onDone);

      if (isInstalling && installStatusPollCount < INSTALL_STATUS_POLL_LIMIT) {
        var pollingTimeout = setTimeout(_this.pollForInstallStatus, 5000);
        _this.setState({
          pollingTimeout: pollingTimeout,
          installStatusPollCount: installStatusPollCount + 1
        });
      } else if (isInstalling && installStatusPollCount >= INSTALL_STATUS_POLL_LIMIT) {
        _this.setState({
          isInstalling: false,
          pollCountLimitReached: true
        });
      }
    };

    _this.stopPollingForInstallStatus = function () {
      var pollingTimeout = _this.state.pollingTimeout;


      if (pollingTimeout) {
        clearTimeout(pollingTimeout);
      }
    };

    _this.onAuthorized = function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          actions = _this$props3.actions;

      actions.track('Integration Connected', { integration: data.name, connected: true });
      var onStateSet = function onStateSet() {
        return _this.pollForInstallStatus();
      };
      _this.setState({
        isInstallModalOpen: false,
        isInstalling: true,
        installStatusPollCount: 1,
        pollCountLimitReached: false
      }, onStateSet);
    };

    _this.showDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: true
      });
    };

    _this.hideDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: false
      });
    };

    _this.state = {
      isDisconnecting: false,
      isInstallModalOpen: false,
      isFetchingScopes: false,
      scopes: [],
      isInstalling: false,
      isInstalled: props.data && props.data.installed,
      installStatusPollCount: 0,
      pollCountLimitReached: false,
      showDisconnectModal: false,
      isConnectDisabled: false,
      hasSalesforceSSO: false
    };
    return _this;
  }

  _createClass(ExternalIntegration, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      switch (this.props.data.name) {
        case "Pardot":
          this.setState({
            isConnectDisabled: true
          });
          return;
        default:
          return;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopPollingForInstallStatus();
    }
  }, {
    key: 'renderIntegrationContent',
    value: function renderIntegrationContent(data) {
      var appId = data.id;

      // Render either default third party app page or use a custom component.
      switch (appId) {
        case __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["r" /* ELOQUA_APP_ID */]:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_12__pages_EloquaIntegrationPage__["a" /* default */], { data: data });
        case __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */]:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_14__pages_PardotIntegrationPage__["a" /* default */], {
            data: data,
            onClickSSO: this.handleClickSSOInstall
          });
        default:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_3_react_markdown___default.a, { source: data.longDescription });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var externalUrl = data.externalUrl;
      var externalUrlEnabled = !!data.externalUrlEnabled && externalUrl;

      var _state = this.state,
          isDisconnecting = _state.isDisconnecting,
          isInstallModalOpen = _state.isInstallModalOpen,
          isFetchingScopes = _state.isFetchingScopes,
          scopes = _state.scopes,
          isInstalled = _state.isInstalled,
          isInstalling = _state.isInstalling,
          pollCountLimitReached = _state.pollCountLimitReached,
          isConnectDisabled = _state.isConnectDisabled;

      return React.createElement(
        'div',
        { className: 'app-integration-page' },
        React.createElement(
          'div',
          { className: 'app-integration-page-description' },
          this.renderIntegrationContent(data)
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: isInstalled },
          React.createElement(
            'div',
            { className: 'common-integration-page-connection-indicator' },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy__["ToolTip"],
              { className: 'common-integratin-page-connection-indicator-text', component: CONNECTED_TEXT, flow: 'down' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy__["Icon"], { name: 'check-circle' }),
              React.createElement(
                'span',
                null,
                'Connected!'
              )
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: data.distributionStatus === 'INTERNAL' },
          React.createElement(
            'div',
            { className: 'app-integration-page-private' },
            React.createElement(
              'span',
              { className: 'app-integration-page-private-label' },
              'Private'
            ),
            React.createElement(
              'p',
              { className: 'app-integration-page-private-description' },
              'This integration is currently only available to your Drift organization.'
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: isInstalled },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__components_DisconnectButton__["a" /* default */], {
            onClick: this.showDisconnectModal,
            isProcessing: isDisconnecting
          })
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: pollCountLimitReached },
          React.createElement(
            'div',
            { className: 'app-integration-page-timeout' },
            React.createElement(
              'span',
              { className: 'app-integration-page-timeout-label' },
              'Timeout'
            ),
            React.createElement(
              'p',
              { className: 'app-integration-page-timeout-description' },
              'Hmm, it looks like this app is experiencing some issues at the moment. Please try again.'
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: !externalUrlEnabled && data.id !== __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */] },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
            { condition: isInstalling },
            React.createElement(
              'button',
              { className: 'drift-button drift-button-primary app-integration-page-install-button' },
              'Connecting...'
            )
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
            { condition: !isInstalled && !isInstalling },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_19__driftt_tide_core_legacy__["Button"],
              {
                onClick: this.onInstallClick,
                className: 'drift-button app-integration-page-install-button',
                disabled: isConnectDisabled
              },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
                { condition: !isFetchingScopes },
                'Connect'
              ),
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
                { condition: isFetchingScopes },
                React.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_CircleOfWaiting__["a" /* default */], null)
              )
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: externalUrlEnabled },
          React.createElement(
            'a',
            { href: externalUrl, target: '_blank' },
            React.createElement(
              'button',
              { className: 'drift-button drift-button-primary app-integration-page-install-button' },
              'Go to Integration Page'
            )
          ),
          React.createElement(
            'p',
            null,
            'This button will open a new tab.'
          )
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_10__ExternalIntegrationInstallModal__["a" /* default */], {
          isOpen: isInstallModalOpen,
          closeModal: this.closeModal,
          appId: data.id,
          appName: data.name,
          appIconSrc: data.iconUrl,
          scopes: scopes,
          onAuthorized: this.onAuthorized
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_13__components_DisconnectConfirmModal__["a" /* default */], {
          integrationName: data.name,
          onDisconnect: this.disconnectIntegration,
          onClose: this.hideDisconnectModal,
          open: this.state.showDisconnectModal
        })
      );
    }
  }]);

  return ExternalIntegration;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ExternalIntegration.defaultProps = {
  description: ''
};
ExternalIntegration.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    orgId: __WEBPACK_IMPORTED_MODULE_15_app_modules_org_selectors__["orgId"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_7_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ExternalIntegration)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "1PZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hydrateModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__ = __webpack_require__("QM6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var model = [{
  type: 'createNewHubSpotLeadsEnabled',
  value: false,
  label: 'Sync leads from Drift to Hubspot',
  description: 'New leads from Drift will be created in HubSpot'
}, {
  type: 'leadOwnerMappingEnabled',
  value: false,
  label: 'Set Lead Owner in Hubspot',
  description: 'For each contact that Drift creates, set the Lead Owner in HubSpot based on who had a meeting booked, who was routed, or who closed the conversation in that order. Requires Drift user mappings.',
  children: {
    label: 'Overwrite existing HubSpot owner if present',
    description: 'If there is an existing lead owner in Hubspot, overwrite with the latest person involved from Drift',
    topLevelAdvancedItems: [],
    items: [{
      type: 'leadOwnerOverwriteEnabled',
      label: 'Enable overwrite',
      value: false
    }]
  }
}, {
  type: 'hasTimelineEnabled',
  value: false,
  label: 'Send Drift activity data to HubSpot',
  description: 'When a contact has a conversation with you in Drift, it’ll be logged in HubSpot'
}, {
  type: 'hasTranscriptPushEnabled',
  value: false,
  label: 'Send Conversation Transcripts to HubSpot',
  description: 'When conversation closes in Drift, send a contact timeline activity which includes the conversation transcript to HubSpot'
}, {
  type: 'shouldOnlySyncQualifiedLeads',
  value: false,
  label: 'Set a minimum CQL score for synced contacts and conversations',
  description: 'This option will enable filtering of data pushes into HubSpot based on the most recent CQL score.',
  children: {
    autoExpand: true,
    label: 'Minimum CQL score',
    description: 'Drift will only sync conversations that have the selected CQL score or higher.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      integrationName: 'hubspot',
      setMinimumCQLScore: function setMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["W" /* setMinimumCqlScore */])(data);
      },
      getMinimumCQLScore: function getMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["A" /* getMinimumCqlScore */])(data);
      }
    })(__WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__["a" /* default */]),
    items: []
  }
}, {
  type: 'createOnlyOnCloseEnabled', // conditionally rendered on toggle 0 in index.js (should sync contacts).
  value: false,
  label: 'Create Contact only on Conversation Closed',
  description: 'This will delay creation of contacts from Drift to Hubspot until a conversation closes'
}, {
  type: 'hasCookieIntegrationEnabled',
  value: false,
  label: 'Identify Drift visitors with the HubSpot cookie',
  description: 'If someone was already identified by HubSpot, Drift will automatically recognize them as a known contact. We\'ll only check HubSpot if the visitor has a HubSpot cookie set.'
}];

var addValuesToToggles = function addValuesToToggles(toggles, fullToggles) {
  return toggles.map(function (secondLevel) {
    var updatedSecondaryToggle = _extends({}, secondLevel);
    updatedSecondaryToggle.value = !!fullToggles[secondLevel.type];
    return updatedSecondaryToggle;
  });
};

var hydrateModel = function hydrateModel(toggles) {
  return [].concat(model).map(function (topLevel) {
    var updatedToggle = _extends({}, topLevel);
    updatedToggle.value = toggles[topLevel.type];
    if (!!topLevel.children && topLevel.children.items.length > 0) {
      updatedToggle.children.items = addValuesToToggles(topLevel.children.items, toggles);
    }
    return updatedToggle;
  });
};

/***/ }),

/***/ "1Pxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Row; });
/* unused harmony export Section */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subsection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_TitleCard__ = __webpack_require__("JUti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_styl__ = __webpack_require__("sYT3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Row = function Row(_ref) {
  var children = _ref.children,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: 'settings-section-row', style: _extends({}, style) },
    children
  );
};

var Title = function Title(_ref2) {
  var title = _ref2.title,
      action = _ref2.action;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__styles_styl___default.a.Title },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'dsg-h3 card-section-title' },
      title
    ),
    action
  );
};

var Section = function (_PureComponent) {
  _inherits(Section, _PureComponent);

  function Section() {
    _classCallCheck(this, Section);

    return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
  }

  _createClass(Section, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          subtitle = _props.subtitle,
          action = _props.action,
          children = _props.children,
          className = _props.className;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components_shared_TitleCard__["a" /* default */],
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_styl___default.a.Section, className),
          title: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Title, { title: title, action: action }),
          subtitle: subtitle
        },
        children
      );
    }
  }]);

  return Section;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var Subsection = function (_PureComponent2) {
  _inherits(Subsection, _PureComponent2);

  function Subsection() {
    _classCallCheck(this, Subsection);

    return _possibleConstructorReturn(this, (Subsection.__proto__ || Object.getPrototypeOf(Subsection)).apply(this, arguments));
  }

  _createClass(Subsection, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          children = _props2.children,
          _props2$loading = _props2.loading,
          loading = _props2$loading === undefined ? false : _props2$loading,
          className = _props2.className,
          innerClassName = _props2.innerClassName;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_styl___default.a.Subsection, className, { loading: loading }) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_styl___default.a.Subsection__Title) },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__styles_styl___default.a.Subsection__Body, innerClassName) },
          children
        ),
        this.renderSave()
      );
    }
  }, {
    key: 'renderSave',
    value: function renderSave() {
      var _props3 = this.props,
          canSubmit = _props3.canSubmit,
          isValid = _props3.isValid,
          _props3$loading = _props3.loading,
          loading = _props3$loading === undefined ? false : _props3$loading,
          onSubmit = _props3.onSubmit,
          onCancel = _props3.onCancel;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'action-controls shown' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
          {
            size: 'medium',
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('save', { loading: loading }),
            onClick: onSubmit,
            disabled: loading || !isValid || !canSubmit
          },
          loading ? 'Saving...' : 'Save'
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'cancel', onClick: onCancel },
          'Cancel'
        )
      );
    }
  }]);

  return Subsection;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);
Subsection.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isValid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  canSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  innerClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),

/***/ "1Sae":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 21 21\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Goal-Action-Route\" transform=\"translate(-418.000000, -520.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(397.000000, 352.000000)\"><g id=\"ban\" transform=\"translate(21.000000, 168.000000)\"><path d=\"M10.5,21 C4.710125,21 0,16.289875 0,10.5 C0,4.710125 4.710125,0 10.5,0 C16.289875,0 21,4.710125 21,10.5 C21,16.289875 16.289875,21 10.5,21 Z M1.75,10.5 C1.75,15.32475 5.67525,19.25 10.5,19.25 C12.59825,19.25 14.525,18.50625 16.034375,17.27075 L3.72925,4.965625 C2.49375,6.475 1.75,8.40175 1.75,10.5 Z M10.5,1.75 C8.40175,1.75 6.475875,2.492875 4.9665,3.728375 L17.27075,16.0335 C18.50625,14.524125 19.25,12.597375 19.25,10.5 C19.25,5.67525 15.32475,1.75 10.5,1.75 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "1Vzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SalesforceLeadRoutingRadioDisplay = function (_Component) {
  _inherits(SalesforceLeadRoutingRadioDisplay, _Component);

  function SalesforceLeadRoutingRadioDisplay() {
    _classCallCheck(this, SalesforceLeadRoutingRadioDisplay);

    return _possibleConstructorReturn(this, (SalesforceLeadRoutingRadioDisplay.__proto__ || Object.getPrototypeOf(SalesforceLeadRoutingRadioDisplay)).apply(this, arguments));
  }

  _createClass(SalesforceLeadRoutingRadioDisplay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          accountLookupChecked = _props.accountLookupChecked,
          contactLookupChecked = _props.contactLookupChecked,
          accountLookupOnClick = _props.accountLookupOnClick,
          contactLookupOnClick = _props.contactLookupOnClick;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'table',
        { className: 'account-radio-options-table' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tbody',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tr',
            { className: 'account-radio-options-table account-lookup-radio-options-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'How should we look up this Account?'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tr',
            { className: 'account-lookup-radio-options-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], {
                type: 'radio',
                label: 'Find contact by email, then find Account associated with that Contact',
                className: 'sfdc-contact-lookup-radio',
                checked: contactLookupChecked,
                onClick: contactLookupOnClick
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tr',
            { className: 'account-radio-options-table account-lookup-radio-options-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], {
                type: 'radio',
                label: 'Find the Account whose website matches the email domain',
                className: 'sfdc-account-lookup-radio',
                checked: accountLookupChecked,
                onClick: accountLookupOnClick
              })
            )
          )
        )
      );
    }
  }]);

  return SalesforceLeadRoutingRadioDisplay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceLeadRoutingRadioDisplay);

/***/ }),

/***/ "1WKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var ApiKeyConstants = Marty.createConstants(['GET_API_KEY', 'CREATE_API_KEY']);

/* harmony default export */ __webpack_exports__["a"] = (ApiKeyConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "1ZNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EventDetail = function (_Component) {
  _inherits(EventDetail, _Component);

  function EventDetail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventDetail.__proto__ || Object.getPrototypeOf(EventDetail)).call.apply(_ref, [this].concat(args))), _this), _this.renderPageSeparator = function () {
      var eventBody = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_this.props, 'event.body');
      var pageUrl = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(_this.props, 'event.body.attributes.url');
      if (pageUrl) {
        var pageTitle = eventBody.attributes.pageName || eventBody.attributes.title || pageUrl;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: 'page-sep' },
            ' - '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { key: 'page-link', href: pageUrl, target: '_blank' },
            pageTitle
          )
        );
      }
    }, _this.renderEventBody = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        _this.props.event.body.event
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          eventLabel = _props.eventLabel,
          _props$event = _props.event,
          body = _props$event.body,
          createdAt = _props$event.createdAt,
          endUser = _props.endUser,
          actionTaker = _props.actionTaker;

      var timeCreatedLabel = __WEBPACK_IMPORTED_MODULE_4_moment___default()(createdAt).format('LLL');
      var eventSource = body && body.source || __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.props, 'event.body.context.source') || 'Drift';
      var eventBody = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(this.props, 'event.body.event');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: actionTaker || endUser }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginLeft: 12 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dsg-Body' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'dsg-medium-weight' },
              Object(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(actionTaker || endUser)
            ),
            '\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'color-navy-dark' },
              eventLabel
            ),
            '\xA0',
            eventBody && this.renderEventBody(),
            children,
            this.renderPageSeparator()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dsg-Regular color-navy-dark' },
            timeCreatedLabel,
            ' via ',
            eventSource
          )
        )
      );
    }
  }]);

  return EventDetail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EventDetail.defaultProps = {
  eventLabel: 'triggered event'
};
/* harmony default export */ __webpack_exports__["a"] = (EventDetail);

/***/ }),

/***/ "1ayq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_renderComponent__ = __webpack_require__("N71h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_renderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_renderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_Application__ = __webpack_require__("08hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SignatureEnable__ = __webpack_require__("lgUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__component__ = __webpack_require__("Uu++");

































var APP = Object(__WEBPACK_IMPORTED_MODULE_21_app_Application__["b" /* getApplication */])();
var GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';



var mapStateToProps = function mapStateToProps(state) {
  return {
    userListIds: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    excludedUserListIds: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["A" /* excludedUserListIds */](state),
    draft: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["n" /* draft */](state),
    orgId: __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__["orgId"](state),
    reportType: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_67" /* reportType */](state),
    isOneTimeEmailPlaybook: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_4" /* getIsOneTimeEmailPlaybook */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state),
    draftScheduledTimestamp: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["s" /* dueAt */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    audience: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["d" /* audience */](state),
    numConditions: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_10" /* getNumConditions */](state),
    isCardinalityLoading: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["i" /* cardinalityLoading */](state),
    targetingCardinality: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_102" /* targetingCardinality */](state),
    smartFilters: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_98" /* smartFilters */](state),
    isGmailConnected: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_selectors__["isGmailConnected"])(state),
    userProperties: __WEBPACK_IMPORTED_MODULE_26_app_modules_user_properties_selectors__["g" /* properties */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    isSignaturePlaybook: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_48" /* isSignaturePlaybook */](state),
    hasInboxPicker: Object(__WEBPACK_IMPORTED_MODULE_19_app_modules_gates_selectors__["u" /* makeHasGate */])('has_playbook_inbox_picker')(state),
    senderEmailOverride: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_selectors__["_80" /* sequenceSenderEmailOverride */](state),
    sendingDomains: __WEBPACK_IMPORTED_MODULE_17_app_modules_inbox_selectors__["j" /* sendingDomains */](state),
    isSendingDomainsLoading: __WEBPACK_IMPORTED_MODULE_17_app_modules_inbox_selectors__["i" /* isSendingDomainsLoading */](state),
    hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__["hasLimitedContactsMktEmail"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchPlaybookCardinality: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_25" /* fetchPlaybookCardinality */],
      showScheduleModal: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_236" /* showScheduleModal */],
      setDraftSchedule: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_150" /* setDraftSchedule */],
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_151" /* setDraftStatus */],
      showSequenceInviteModal: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_239" /* showSequenceInviteModal */],
      showGoogleAuthModal: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_234" /* showGoogleAuthModal */],
      showSendEmailConfirmModal: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_actions__["_238" /* showSendEmailConfirmModal */],
      fetchGoogleScopes: __WEBPACK_IMPORTED_MODULE_25_app_modules_user_actions__["fetchGoogleScopes"],
      fetchSendingDomains: __WEBPACK_IMPORTED_MODULE_16_app_modules_inbox_actions__["F" /* fetchSendingDomains */],
      fetchGoogleScopesSuccess: __WEBPACK_IMPORTED_MODULE_25_app_modules_user_actions__["fetchGoogleScopesSuccess"],
      hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_14_app_modules_org_actions__["hasLimitedContactsMktEmail"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_8_recompose_branch___default()(function (props) {
  return props.isSignaturePlaybook;
}, __WEBPACK_IMPORTED_MODULE_9_recompose_renderComponent___default()(__WEBPACK_IMPORTED_MODULE_27__SignatureEnable__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_4_recompose_lifecycle___default()({
  componentWillMount: function componentWillMount() {
    this.props.actions.fetchGoogleScopes();
    this.props.actions.fetchSendingDomains();
    this.props.actions.hasLimitedContactsMktEmail();
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        userListIds = _props.userListIds,
        excludedUserListIds = _props.excludedUserListIds,
        orgId = _props.orgId,
        smartFilters = _props.smartFilters,
        isEmailPlaybook = _props.isEmailPlaybook;

    this.props.actions.fetchPlaybookCardinality({ orgId: orgId, userListIds: userListIds, excludedUserListIds: excludedUserListIds, smartFilters: smartFilters, isEmailPlaybook: isEmailPlaybook });
  }
}), __WEBPACK_IMPORTED_MODULE_7_recompose_withState___default()('selectedEmailSendMode', 'setEmailSendMode', function (props) {
  return !!props.draftScheduledTimestamp ? __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].SCHEDULE : __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].NOW;
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function (props) {

  var doGmailConnect = function doGmailConnect() {
    var scope = __WEBPACK_IMPORTED_MODULE_24_app_modules_integrations_constants__["K" /* GoogleScopes */].READ + ' ' + __WEBPACK_IMPORTED_MODULE_24_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND;
    var params = {
      scope: scope,
      redirect_uri: __WEBPACK_IMPORTED_MODULE_23_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/google-calendar',
      client_id: __WEBPACK_IMPORTED_MODULE_23_constants_ResourcesConstants__["v" /* GOOGLE_CLIENT_ID */],
      response_type: 'code',
      access_type: 'offline',
      include_granted_scopes: true
    };

    Object(__WEBPACK_IMPORTED_MODULE_20_components_Integration_helpers__["b" /* popUp */])({
      path: GOOGLE_AUTH_URL + '?' + Object(__WEBPACK_IMPORTED_MODULE_22_utils_Helpers__["d" /* encodeQueryData */])(params),
      onMessage: handlePostMessage
    });
  };

  var handlePostMessage = function handlePostMessage(e) {
    var success = e.data.status === 'success';

    if (success) {
      APP.actions.NotificationActions.pushNotification({
        content: 'Your Google account was successfully connected.'
      });
      props.actions.fetchGoogleScopesSuccess(__WEBPACK_IMPORTED_MODULE_10_immutable__["List"].of(__WEBPACK_IMPORTED_MODULE_24_app_modules_integrations_constants__["K" /* GoogleScopes */].READ, __WEBPACK_IMPORTED_MODULE_24_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND));
    } else {
      APP.actions.NotificationActions.pushNotification({
        content: React.createElement(
          'span',
          null,
          'Your Google account may be connected to a different Drift account. Please review your',
          ' ',
          React.createElement(
            'a',
            {
              style: { color: '#EFEFEF', textDecoration: 'underline' },
              href: 'https://myaccount.google.com/permissions',
              target: '_blank'
            },
            'Google app permissions'
          ),
          '.'
        ),
        variant: 'red',
        sticky: true
      });
    }
  };

  var sendFromDomain = !!props.senderEmailOverride && props.senderEmailOverride.split('@').length > 1 ? props.senderEmailOverride.split('@')[1] : null;
  var isDkimSetUp = props.sendingDomains.find(function (sendingDomain) {
    return sendingDomain.domain === sendFromDomain;
  });
  var isDkimVerified = isDkimSetUp && isDkimSetUp.status === 'VERIFIED';

  return {
    hasSegmentSelected: !!props.userListIds && props.userListIds.size > 0,
    isSendNow: props.selectedEmailSendMode === __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].NOW,
    isScheduled: props.selectedEmailSendMode === __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].SCHEDULE,
    copy: __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_297" /* playbooksCopy */][props.reportType].review,
    draftScheduledMoment: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(props.draftScheduledTimestamp).tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()),
    isDkimSetUp: !!isDkimSetUp || props.isSendingDomainsLoading,
    isDkimVerified: !!isDkimVerified || props.isSendingDomainsLoading,
    handlePostMessage: handlePostMessage,
    doGmailConnect: doGmailConnect
  };
}), __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers___default()({
  handleShowScheduleModal: function handleShowScheduleModal(props) {
    return function () {
      props.actions.showScheduleModal();
    };
  },
  handleSetNow: function handleSetNow(props) {
    return function () {
      props.setEmailSendMode(__WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].NOW);
      props.actions.setDraftSchedule(null);
      if (props.draft.status !== __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT) props.actions.setDraftStatus({ status: __WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED }); // in case we're editing
    };
  },
  handleSetScheduled: function handleSetScheduled(props) {
    return function () {
      props.setEmailSendMode(__WEBPACK_IMPORTED_MODULE_18_app_modules_playbook_constants__["_294" /* emailSendModes */].SCHEDULE);
      if (!props.draftScheduledTimestamp) {
        // set a default when the user selects
        // option if no date available
        props.actions.setDraftSchedule(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().add(2, 'days').tz(__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()));
      }
    };
  },
  onEnableConfirm: function onEnableConfirm(props) {
    return function () {
      var showSendEmailConfirmModal = props.actions.showSendEmailConfirmModal;

      if (props.isEmailPlaybook && !props.isOutboundSequencePlaybook && !props.checked) {
        showSendEmailConfirmModal();
      }
    };
  },
  isExtensionInstalled: function isExtensionInstalled(props) {
    return props.userProperties.get('extensionInstalled');
  },
  onShareClick: function onShareClick(props) {
    return function () {
      return props.actions.showSequenceInviteModal();
    };
  },
  onConnectGmailClick: function onConnectGmailClick(props) {
    return function () {
      return props.doGmailConnect();
    };
  },
  onInstallExtensionClick: function onInstallExtensionClick() {
    return function () {
      window.open(__WEBPACK_IMPORTED_MODULE_23_constants_ResourcesConstants__["e" /* CHROME_EXTENSION_LINK */], '_blank');
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_28__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "1brp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("/40Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);




var GDPRMessage = function GDPRMessage() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'gdpr-message' },
    'Drift respects privacy rights and data protection laws. You may only share other people\'s personal information with Drift, whether directly or through third-party integrations, if you are permitted to do so under applicable law.',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { rel: 'noopener noreferrer', target: '_blank', href: 'https://www.drift.com/privacy-policy/' },
      ' View our Privacy Policy.'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GDPRMessage);

/***/ }),

/***/ "1cd8":
/***/ (function(module, exports) {

module.exports = "<svg width=\"26\" height=\"23\" viewBox=\"0 0 26 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.348 17.854H10.56l-3.78 4.72a1.02 1.02 0 0 1-1.136.327 1.02 1.02 0 0 1-.683-.962v-4.084H2.92a2.044 2.044 0 0 1-2.043-2.04V2.54C.875 1.416 1.79.5 2.918.5h20.43c1.127 0 2.043.916 2.043 2.042v13.27a2.044 2.044 0 0 1-2.042 2.042zm0-15.312H2.918v13.27h3.064c.564 0 1.022.458 1.022 1.02v2.196l2.267-2.832c.013-.015.03-.02.043-.035.048-.053.105-.093.163-.136.05-.037.098-.077.154-.103.055-.026.114-.038.175-.054.07-.02.138-.038.21-.042.02 0 .034-.01.053-.01h13.28V2.54zM5.982 10.708c0-.563.458-1.02 1.022-1.02h8.172a1.022 1.022 0 0 1 0 2.04H7.004a1.022 1.022 0 0 1-1.022-1.02zm0-3.062c0-.564.458-1.02 1.022-1.02h12.258a1.022 1.022 0 0 1 0 2.04H7.004a1.022 1.022 0 0 1-1.022-1.02z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "1eL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAttributeMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAttributeFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return didAttributePatchErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isAttributePatchLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHubspotUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isUserMappingLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isUserMappingLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isHubspotUsersSearchLoading; });
/* unused harmony export isHubspotUsersSearchLoaded */
/* unused harmony export getHubspotByEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isAllowAttributeDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isUseCountryAcronyms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isUseStateAcronyms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return makeGetHubspotByEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);



var root = function root(state) {
  return state.get('hubspot');
};

var getAttributeMappings = function getAttributeMappings(state) {
  return root(state).hubspotAttributeMappings;
};

var getAttributeFields = function getAttributeFields(state) {
  return root(state).hubspotAttributeFields;
};

var didAttributePatchErr = function didAttributePatchErr(state) {
  return root(state).hubspotAttributeMappingsErr;
};

var isAttributePatchLoading = function isAttributePatchLoading(state) {
  return root(state).hubspotAttributePatching;
};

var getUserMappings = function getUserMappings(state) {
  return root(state).hubspotUserMappings;
};

var getHubspotUsers = function getHubspotUsers(state) {
  return root(state).hubspotUsers;
};

var isUserMappingLoading = function isUserMappingLoading(state) {
  return root(state).hubspotUserMappingLoading;
};

var isUserMappingLoaded = function isUserMappingLoaded(state) {
  return root(state).hubspotUserMappingLoaded;
};

var isHubspotUsersSearchLoading = function isHubspotUsersSearchLoading(state) {
  return root(state).hubspotUsersSearchLoading;
};

var isHubspotUsersSearchLoaded = function isHubspotUsersSearchLoaded(state) {
  return root(state).hubspotUsersSearchLoaded;
};

var getHubspotByEmail = function getHubspotByEmail(state, email) {
  return root(state).hubspotResponse[email];
};

var isAllowAttributeDefaults = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.allowAttributeDefaults;
});

var isUseCountryAcronyms = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.useCountryAcronyms;
});

var isUseStateAcronyms = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.useStateAcronyms;
});

var makeGetHubspotByEmail = function makeGetHubspotByEmail() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getHubspotByEmail, function (hubSpotEnrichment) {
    return hubSpotEnrichment;
  });
};

/***/ }),

/***/ "1hGQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__ = __webpack_require__("zyQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var FAIL_MESSAGE = "Something went wrong! Your test email couldn't be sent";
var SUCCESS_MESSAGE = 'Your test email has been sent!';

var CampaignActions = Marty.createActionCreators({
  createCampaign: function createCampaign(body, requestId) {
    return this.app.queries.CampaignQueries.createCampaign(body, requestId);
  },
  updateCampaign: function updateCampaign(id, update) {
    return this.app.queries.CampaignQueries.updateCampaign(id, update);
  },
  updateCampaignOld: function updateCampaignOld(id, update) {
    return this.app.queries.CampaignQueries.updateCampaignOld(id, update);
  },
  pushCampaign: function pushCampaign(campaign) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_DONE, campaign.id, campaign);
  },


  /**
   * Sends a test email campaign to a list of users.
   * @param {Object} campaign - The email campaign to send
   * @param {string[]} emails - A list of recipients' email addresses
  */
  sendTestCampaign: function sendTestCampaign(campaign, emails) {
    var _this = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_STARTING, campaign, emails);

    var promise = this.app.sources.CampaignAPI.sendTestCampaign(campaign, emails);

    promise.then(function (res) {
      if (res.status === 200) {
        _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_DONE, res.body, campaign, emails);
        return _this.app.actions.NotificationActions.pushNotification({
          content: SUCCESS_MESSAGE
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_FAILED, campaign, emails, res);
        return _this.notifyTestCampaignFailed();
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_FAILED, requestId, error);
      return _this.notifyTestCampaignFailed();
    });
  },
  notifyTestCampaignFailed: function notifyTestCampaignFailed() {
    return this.app.actions.NotificationActions.pushNotification({
      content: FAIL_MESSAGE,
      variant: 'red'
    });
  },
  saveAnnouncementDraft: function saveAnnouncementDraft(update) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SAVE_ANNOUNCEMENT_DRAFT, update);
  },
  saveNPSDraft: function saveNPSDraft(update) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].SAVE_NPS_DRAFT, update);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CampaignActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "1jik":
/***/ (function(module, exports) {

module.exports = "<!-- ************* Copyright (c) 2015 Pareto Softare, LLC DBA Simplemaps.com ******************* ************* Offered under the MIT License http://opensource.org/licenses/MIT ************ ************* Attribution is appreciated! http://simplemaps.com *************************** --><svg xmlns:dc=\"http://purl.org/dc/elements/1.1/\" xmlns:cc=\"http://creativecommons.org/ns#\" xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\" xmlns:svg=\"http://www.w3.org/2000/svg\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\" xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\" enable_background=\"new 0 0 1000 589\" pretty_print=\"False\" style=\"stroke-linejoin: round; stroke:#000; fill: none;\" version=\"1.1\" viewBox=\"0 0 1000 589\" id=\"us-map\"><defs id=\"defs4\"><style type=\"text/css\" id=\"style6\">path { fill-rule: evenodd; }</style></defs><metadata id=\"metadata8\"><views id=\"views10\"><view h=\"589.235294118\" padding=\"0\" w=\"1000\" id=\"view12\"><proj id=\"laea-usa\" lat0=\"45\" lon0=\"-100\"></proj><bbox h=\"321.97\" w=\"589.33\" x=\"690.09\" y=\"918.69\" id=\"bbox15\"></bbox></view></views></metadata><path inkscape:connector-curvature=\"0\" id=\"MA\" data-name=\"Massachusetts\" data-id=\"MA\" d=\"m 956.31178,153.05085 -0.29118,-0.19412 0,0.29119 0.29118,-0.0971 z m -2.91189,-2.6207 0.67944,-0.29119 0,-0.38825 -0.67944,0.67944 z m 12.03583,-7.57092 -0.0971,-1.35889 -0.19412,-0.7765 0.29119,2.13539 z m -42.41659,-9.9975 -0.67944,0.29119 -5.5326,1.65007 -1.94126,0.67944 -2.23245,0.67944 -0.7765,0.29119 0,0.29119 0.29118,5.04728 0.29119,4.65903 0.29119,4.27078 0.48532,0.29119 1.74714,-0.48532 7.86211,-2.32951 0.19412,0.48531 13.97709,-5.33847 0.0971,0.19413 1.26182,-0.48532 4.4649,-1.74713 4.27078,5.14434 0,0 0.58238,-0.48531 0.29119,-1.45595 -0.0971,2.32952 0,0 0.97063,0 0.29119,1.16475 0.87357,1.65008 0,0 4.56197,-5.5326 3.78546,1.26182 0.87357,-1.94126 6.21204,-3.30015 -2.62071,-5.14435 0.67945,3.30015 -3.20309,2.42658 -3.59133,0.29119 -7.18267,-7.66799 -3.20309,-4.85315 3.20309,-3.39721 -3.30015,-0.19413 -1.35888,-3.20308 -0.0971,-0.19413 -5.53259,6.01791 -12.22996,4.07666 -3.97959,1.26182 0,0 z\"><title>Massachusetts</title></path><path inkscape:connector-curvature=\"0\" id=\"MN\" data-name=\"Minnesota\" data-id=\"MN\" d=\"m 558.54712,73.847349 1.94126,6.891482 4.07665,24.848159 1.94126,9.90044 0.58238,8.73568 2.23246,5.24141 0.48531,4.4649 0.38825,1.45595 -0.0971,0.29119 -3.88252,6.40616 2.52364,4.27078 4.85315,34.16622 0.19413,4.4649 4.85315,-0.29119 19.12144,-1.06769 47.75505,-3.97959 4.7561,-0.48532 0,-0.48531 -1.35889,-7.47386 -5.92085,-3.00896 -4.65903,-4.85315 -7.37679,-4.46491 -2.32952,-0.19412 -3.59133,-2.71777 0.97063,-13.39471 -3.39721,-3.10602 1.16476,-5.43554 6.21204,-5.62966 -1.0677,-11.64757 2.23245,-2.52364 0,0 7.57093,-7.95918 8.63861,-11.065195 3.30015,-2.329514 5.82379,-2.814831 6.11497,-4.561967 -4.07665,0.776505 -2.42658,-1.844199 -9.31806,1.261821 -1.45594,-1.747136 -8.34743,3.397209 -6.69736,-2.814831 -1.84419,-2.232452 -5.33848,0.388253 -3.59133,-1.844199 1.16476,-1.358884 -4.56197,-1.455947 -4.07665,0 -6.50323,2.814831 -1.26182,-1.941263 -10.28869,-1.455947 -3.49427,-8.73568 -0.38826,-2.620705 -4.4649,-1.26182 0.38825,7.47386 -11.8417,0.873568 -14.65653,0.582379 -0.97063,0.09706 z\"><title>Minnesota</title></path><path inkscape:connector-curvature=\"0\" id=\"MT\" data-name=\"Montana\" data-id=\"MT\" d=\"m 465.65771,72.973781 -32.12789,-2.135389 -23.39221,-2.232451 -23.29515,-2.717768 -14.46241,-1.941262 -23.10102,-3.591336 -11.55051,-1.941262 -25.81879,-4.950219 -2.71777,-0.582379 -4.17371,19.800877 1.8442,3.591335 1.45595,5.532598 -0.87357,0.776505 1.8442,5.047282 2.52364,2.135389 7.18267,12.035829 0.67944,2.03832 2.91189,-0.19412 -3.39721,15.91835 -1.35888,0.38825 -1.8442,5.33847 9.60925,0.67944 0.77651,4.46491 5.43553,13.29765 0.97063,0.7765 3.78546,7.76505 0.97063,-0.7765 8.05624,-0.0971 10.19163,1.0677 2.52364,-3.30015 3.00896,5.43553 0.58238,0.29119 0.0971,-0.58237 1.35888,-9.51219 33.19559,4.07665 26.49823,2.52364 13.97709,1.16476 24.94522,1.45595 1.26182,0.0971 0.29119,0 0.0971,-1.35888 0.29119,-6.69736 0.38825,-8.83274 0.0971,-2.23246 0.19413,-3.88252 1.55301,-30.47782 1.26182,-23.683401 0.0971,-3.882525 -1.8442,-0.09706 z\"><title>Montana</title></path><path inkscape:connector-curvature=\"0\" id=\"ND\" data-name=\"North Dakota\" data-id=\"ND\" d=\"m 556.50879,73.847349 -29.31306,0.582379 -20.48032,-0.09706 -17.56842,-0.388253 -20.57738,-0.776505 -1.0677,-0.09706 -0.0971,3.882525 -1.26182,23.683405 -1.55301,30.47782 -0.19413,3.88252 3.78546,0.19413 42.80484,1.16476 39.50469,-0.29119 16.40367,-0.48532 3.30014,-0.19412 -0.38825,-1.45595 -0.48531,-4.4649 -2.23246,-5.24141 -0.58238,-8.73568 -1.94126,-9.90044 -4.07665,-24.848163 -1.94126,-6.891482 -2.03833,0 z\"><title>North Dakota</title></path><path inkscape:connector-curvature=\"0\" id=\"HI\" data-name=\"Hawaii\" data-id=\"HI\" d=\"m 416.34965,514.99923 -3.00896,-2.23245 -2.6207,0.67944 0.58238,5.43553 -3.59134,4.46491 3.10602,7.08561 0.87357,7.27973 3.59133,2.32951 2.23246,-3.59133 3.97958,-2.91189 4.85316,-1.26183 5.33847,-4.56196 -5.24141,-4.46491 -0.0971,-2.71776 -9.9975,-5.5326 z m -17.66549,-7.86211 -1.45595,-1.26182 -1.35888,1.8442 2.81483,-0.58238 z m -7.27973,-4.17372 0.38825,-3.59133 -1.8442,-0.29119 1.45595,3.88252 z m 6.11497,-5.92085 -1.65007,0.77651 1.16476,3.6884 2.52364,0.19412 0.7765,3.20308 2.71777,1.16476 6.01791,-2.81483 -5.62966,-4.65903 -5.92085,-1.55301 z m -12.42408,-3.97959 -0.87356,2.62071 4.17371,-0.0971 3.88252,0.97063 -2.03832,-3.20309 -5.14435,-0.29119 z m -12.22995,-7.66798 -2.23245,-2.13539 -4.27078,3.30015 2.71777,5.04728 1.94126,-2.03833 5.5326,1.16476 -0.48532,-2.32952 -3.20308,-3.00895 z m -43.48428,-4.27078 0.58238,-1.35888 1.65007,-0.87357 -2.23245,2.23245 z m 15.43304,-8.83274 -6.79442,2.52364 -0.67944,1.8442 2.71777,1.94126 3.78546,0.97063 2.71776,-5.33847 -1.74713,-1.94126 z m -47.07561,-17.85962 0,-0.0971 -0.19413,0 0.19413,0.0971 z m -51.44346,-12.71527 0,0.19413 0.0971,0 -0.0971,-0.19413 z m -26.98355,-4.4649 0.0971,0.0971 0,0 -0.0971,-0.0971 z m -1.06769,-1.94126 0,0 0,0 0,0 z m -0.87357,-0.97063 -0.19412,0 0,0.0971 0.19412,-0.0971 z m 0.67944,0 -0.0971,0 0.0971,0 0,0 z m -0.0971,-0.0971 0,0 0,0.0971 0,-0.0971 z m -30.47782,-25.04228 -0.0971,-0.29119 0,0.0971 0.0971,0.19413 z m -66.48824,-21.25682 -0.29119,0.29118 0.19413,0.0971 0.0971,-0.38825 z m -70.370758,-49.01688 0,0 0,0 0,0 z m 2.426578,0.0971 -0.09706,0 0,0 0.09706,0 z m -0.485316,-0.0971 0,0 0,0 0,0 z m -41.445952,-18.1508 0.291189,-0.0971 0,-0.19412 -0.291189,0.29119 z\"><title>Hawaii</title></path><path inkscape:connector-curvature=\"0\" id=\"ID\" data-name=\"Idaho\" data-id=\"ID\" d=\"m 309.0949,52.881715 -8.63862,-1.747136 -2.81483,-0.679442 -1.26182,-0.291189 -11.25932,50.666952 0.48532,4.17371 -0.38826,4.36784 0.19413,0.97063 0,0.0971 0.0971,1.84419 3.30015,3.59134 -4.75609,11.93876 -10.09457,13.20059 -0.29119,2.42658 2.62071,6.21204 -9.221,38.24287 -0.38825,2.03832 2.71776,0.58238 27.46887,5.43553 10.96813,2.03833 2.81483,0.48532 2.71777,0.48531 13.97709,2.23245 25.04228,3.78546 2.81483,0.38826 0.38825,-3.20309 0.87357,-6.3091 3.30015,-25.23641 1.74714,-12.52114 0.38825,-3.20309 -0.58238,-0.29119 -3.00896,-5.43553 -2.52364,3.30015 -10.19163,-1.0677 -8.05624,0.0971 -0.97063,0.7765 -3.78546,-7.76505 -0.97063,-0.7765 -5.43553,-13.29765 -0.77651,-4.46491 -9.60925,-0.67944 1.8442,-5.33847 1.35888,-0.38825 3.39721,-15.91835 -2.91189,0.19412 -0.67944,-2.03832 -7.18267,-12.035829 -2.52364,-2.135389 -1.8442,-5.047282 0.87357,-0.776505 -1.45595,-5.532598 -1.8442,-3.591335 4.17371,-19.800877 -0.0971,0 z\"><title>Idaho</title></path><path inkscape:connector-curvature=\"0\" id=\"WA\" data-name=\"Washington\" data-id=\"WA\" d=\"m 192.13384,77.050432 0.0971,-1.650073 -0.19412,0.09706 0.0971,1.55301 z m 20.67445,-8.832744 0.58237,-0.970631 -0.67944,-0.09706 0.0971,1.067694 z m -1.8442,-1.747136 0.58237,-1.941262 -0.58237,-0.194127 0,2.135389 z m 7.0856,-2.814831 -0.0971,-1.941262 -1.65007,2.523641 1.74713,-0.582379 z m 0.19413,-4.076651 0.29119,-1.941262 -0.19413,-0.485316 -0.0971,2.426578 z m 0.29119,-9.512185 -0.0971,-1.067695 -0.38826,-0.09706 0.48532,1.164758 z m 3.10602,-6.406166 -0.87357,-0.09706 -1.74713,2.717767 2.6207,-2.620704 z m -2.42658,-2.620705 0.48532,-0.388252 0.0971,-0.291189 -0.58238,0.679441 z m -0.48531,0.29119 -0.29119,-1.941263 -0.87357,1.650073 1.16476,0.29119 z m -0.48532,-2.717768 -0.87357,-0.388252 0.67944,0.970631 0.19413,-0.582379 z m 2.91189,1.650074 0,-1.261821 -0.29119,0.485316 0.29119,0.776505 z m 0.87357,-1.261821 -0.38825,-0.291189 -0.0971,0 0.48531,0.291189 z m -5.5326,-2.135389 -0.48531,-0.388252 -0.19413,-0.09706 0.67944,0.485315 z m 3.59134,-0.388252 -2.6207,0.679442 0.67944,0.194126 1.94126,-0.873568 z m -2.13539,-0.194126 -0.48531,-0.582379 -0.0971,0.09706 0.58238,0.485316 z m 2.03833,-1.164758 -0.38826,0 0.48532,0.194126 -0.0971,-0.194126 z m -19.02438,49.793381 3.49428,3.785461 -0.58238,7.279734 0.67944,1.8442 5.24141,2.81483 14.75359,1.35888 0.58238,1.74714 6.98855,0.0971 6.60029,0.87357 10.774,-1.16476 5.33848,0.87357 1.45594,-0.67944 27.27474,6.21204 1.8442,0.38825 -0.19413,-0.97063 0.38826,-4.36784 -0.48532,-4.17371 11.25932,-50.666952 -1.55301,-0.29119 -22.71277,-5.338471 -19.80087,-5.047282 -22.42159,-6.21204 -6.69735,-1.650073 1.55301,8.444491 -1.45595,2.717768 -2.6207,-1.358884 2.52364,11.744637 -2.71777,3.882525 -1.26182,3.591336 0,3.688398 -5.72672,3.979588 -2.42658,-1.55301 -2.32952,1.164758 4.27078,-5.532598 -1.06769,3.785462 2.42658,-2.620705 1.94126,0.388253 -0.58238,-4.853156 1.26182,0.194126 2.6207,-5.823787 -0.87356,-0.873568 -3.39721,4.36784 -2.23246,0.09706 2.42658,-2.717767 2.71777,-0.679442 -0.97063,-4.950219 -2.71777,-0.679442 -1.35888,-2.329515 -1.65008,0.873568 -8.9298,-3.882524 -7.86211,-6.114977 -2.13539,5.92085 -0.19413,2.523641 1.65007,4.464904 -1.06769,14.462405 -0.77651,2.232452 4.36784,0.388252 -4.36784,3.10602 2.32952,1.164757 -1.8442,6.21204 -0.87357,-4.853156 -1.65007,5.629661 2.23245,2.717767 2.42658,-0.194126 2.91189,1.747136 1.45595,2.814831 1.74713,0 0,0 z\"><title>Washington</title></path><path inkscape:connector-curvature=\"0\" id=\"AZ\" data-name=\"Arizona\" data-id=\"AZ\" d=\"m 372.18593,309.90486 -32.71027,-4.07665 -17.56843,-2.52365 -25.04228,-3.97958 -2.52364,-0.38826 0,0.19413 -4.27078,18.83025 -2.23245,-0.0971 -3.39721,-3.00895 -4.27078,3.59133 -0.0971,15.43304 -1.55301,3.30014 0,0.29119 0,0.0971 -0.19413,2.42657 3.39721,9.12394 3.00896,4.07665 -5.43554,3.20308 -2.13539,3.97959 -3.49427,8.54155 -1.74713,0.38826 -0.0971,7.0856 3.00896,2.23246 -1.55301,4.27077 -3.49427,0.19413 0,0 -2.03833,3.78546 6.98855,4.36784 13.20058,7.3768 40.76651,21.64507 34.55447,4.27078 0.38825,0 2.71777,-28.63362 0.67944,-7.08561 7.27974,-75.12685 0.38825,-3.49427 -2.52364,-0.29119 z\"><title>Arizona</title></path><path inkscape:connector-curvature=\"0\" id=\"CA\" data-name=\"California\" data-id=\"CA\" d=\"m 206.01387,363.77489 0.38825,2.13539 0,0.38825 -0.38825,-2.52364 z m -14.26828,-8.34743 0.67944,1.45595 0.38825,-0.0971 -1.06769,-1.35888 z m 16.98604,-0.29119 0.29119,2.52364 1.74714,1.26182 -2.03833,-3.78546 z m -11.74463,-13.78296 -1.0677,-0.29119 0.87357,0.38825 0.19413,-0.0971 z m -10.77401,-2.9119 -2.6207,1.55301 0.67944,0.67945 1.94126,-2.23246 z m -5.04728,-1.8442 -0.19413,0.77651 0.87357,0.19413 -0.67944,-0.97064 z m 8.54155,1.94127 4.27078,2.42658 0.77651,-0.67945 -5.04729,-1.74713 z m -33.09852,-85.51261 -0.0971,0.0971 0.0971,-0.0971 0,0 z m 10.38575,0.48531 -0.0971,-0.29119 0,0.38826 0.0971,-0.0971 z m 56.00542,-73.6709 -3.78546,-0.97064 -41.54301,-11.45344 -15.43304,-4.65903 0,0.38825 -0.87357,9.60925 -4.07665,11.35638 -6.79442,8.44449 -0.19412,4.27078 3.30014,5.92085 1.65008,7.76505 -2.32952,6.3091 0.38825,6.30911 -1.16475,2.6207 3.97958,8.63862 2.52364,3.30015 -0.19412,9.41512 6.01791,5.72672 3.49427,-5.82378 3.78547,3.00895 1.45594,-1.35888 -5.24141,0.97063 -0.0971,4.95022 1.0677,6.21204 -2.9119,-2.81483 -1.65007,-3.78546 -0.48532,5.2414 1.35889,10.38576 5.43553,6.69735 -3.59133,4.65903 0.58237,5.92085 3.88253,6.01792 6.79442,18.63612 2.13539,1.16475 -0.67945,12.9094 1.0677,1.55301 14.55947,5.24141 4.4649,4.75609 1.55301,3.10602 4.27078,2.42658 4.65903,0.87357 1.94126,5.33847 3.88252,1.8442 5.82379,6.89148 5.43554,9.02687 -0.38826,8.34743 3.00896,3.97958 39.69882,3.88253 0,0 3.49427,-0.19413 1.55301,-4.27077 -3.00896,-2.23246 0.0971,-7.0856 1.74713,-0.38826 3.49427,-8.54155 2.13539,-3.97959 5.43554,-3.20308 -3.00896,-4.07665 -3.39721,-9.12394 0.19413,-2.42657 0,-0.0971 -2.52364,-3.39721 -7.76505,-10.38575 -15.04479,-21.15976 -20.96563,-30.08957 -11.8417,-16.40366 -11.45345,-16.50074 13.20058,-56.00542 0.87357,-3.68839 z\"><title>California</title></path><path inkscape:connector-curvature=\"0\" id=\"CO\" data-name=\"Colorado\" data-id=\"CO\" d=\"m 489.6323,255.54951 0.38826,-19.02437 -4.65903,-0.19413 -23.6834,-0.87357 -2.32952,-0.0971 -1.94126,-0.0971 -28.82775,-1.8442 -19.2185,-1.55301 -23.97459,-2.32952 -2.32951,-0.29119 -0.29119,2.52365 -5.24141,50.56988 -1.8442,17.66549 -0.7765,7.66799 -0.19413,2.52364 3.00896,0.29119 48.91981,4.27077 21.54801,1.35889 21.45095,0.97063 3.10602,0.0971 1.94126,0.0971 4.07665,0.0971 1.94127,0.0971 6.11497,0.19413 1.55301,0 0,-1.94127 1.0677,-51.34639 0.0971,-5.72672 0,-1.8442 0.0971,-1.26182 z\"><title>Colorado</title></path><path inkscape:connector-curvature=\"0\" id=\"NV\" data-name=\"Nevada\" data-id=\"NV\" d=\"m 294.82662,295.8307 10.09457,-62.79983 5.14434,-31.44846 0.58238,-3.10601 -2.81483,-0.48532 -10.96813,-2.03833 -27.46887,-5.43553 -2.71776,-0.58238 -2.71777,-0.58238 -13.6859,-3.00895 -24.55697,-5.82379 -2.71777,-0.67944 -0.87357,3.68839 -13.20058,56.00542 11.45345,16.50074 11.8417,16.40366 20.96563,30.08957 15.04479,21.15976 7.76505,10.38575 2.52364,3.39721 0,-0.29119 1.55301,-3.30014 0.0971,-15.43304 4.27078,-3.59133 3.39721,3.00895 2.23245,0.0971 4.27078,-18.83025 0,-0.19413 0.48531,-3.10602 z\"><title>Nevada</title></path><path inkscape:connector-curvature=\"0\" id=\"NM\" data-name=\"New Mexico\" data-id=\"NM\" d=\"m 472.45213,324.75551 0.0971,-2.52364 0.0971,-2.52364 0.0971,-2.52364 -3.10602,-0.0971 -21.45095,-0.97063 -21.54801,-1.35889 -48.91981,-4.27077 -3.00896,-0.29119 -0.38825,3.49427 -7.27974,75.12685 -0.67944,7.08561 -2.71777,28.63362 0.38826,0.0971 13.39471,1.26183 1.26182,-6.79442 2.42658,-1.94127 27.17767,2.42658 0.19413,0 -2.42658,-4.75609 12.32701,0.87357 30.76901,1.74713 19.2185,0.87357 3.30015,-91.0452 0.67944,0.0971 0.0971,-2.62071 z\"><title>New Mexico</title></path><path inkscape:connector-curvature=\"0\" id=\"OR\" data-name=\"Oregon\" data-id=\"OR\" d=\"m 162.2384,162.75717 15.43304,4.65903 41.54301,11.45344 3.78546,0.97064 2.71777,0.67944 24.55697,5.82379 13.6859,3.00895 2.71777,0.58238 0.38825,-2.03832 9.221,-38.24287 -2.62071,-6.21204 0.29119,-2.42658 10.09457,-13.20059 4.75609,-11.93876 -3.30015,-3.59134 -0.0971,-1.84419 0,-0.0971 -1.8442,-0.38825 -27.27474,-6.21204 -1.45594,0.67944 -5.33848,-0.87357 -10.774,1.16476 -6.60029,-0.87357 -6.98855,-0.0971 -0.58238,-1.74714 -14.75359,-1.35888 -5.24141,-2.81483 -0.67944,-1.8442 0.58238,-7.279734 -3.49428,-3.785461 -0.29118,0.09706 -0.67945,0.485315 -4.85315,-2.523641 -2.9119,0.873568 -1.94126,-0.970631 -2.03832,8.347429 -1.35889,2.329514 -6.01791,14.656531 -1.74714,8.05624 -1.06769,0.0971 -5.62966,13.39471 -3.78546,5.72672 -1.35889,0.97063 -3.49427,6.79442 -0.67944,7.18267 -2.13539,6.40617 1.26182,5.82378 0,0.0971 z m 35.5251,-79.688825 -0.29119,-0.873568 -0.0971,0.679442 0.38825,0.194126 z\"><title>Oregon</title></path><path inkscape:connector-curvature=\"0\" id=\"UT\" data-name=\"Utah\" data-id=\"UT\" d=\"m 352.38505,204.97962 -25.04228,-3.78546 -13.97709,-2.23245 -2.71777,-0.48531 -0.58238,3.10601 -5.14434,31.44846 -10.09457,62.79983 -0.48531,3.10602 2.52364,0.38826 25.04228,3.97958 17.56843,2.52365 32.71027,4.07665 2.52364,0.29119 0.19413,-2.52364 0.7765,-7.66799 1.8442,-17.66549 5.24141,-50.56988 0.29119,-2.52365 -1.94126,-0.19412 -24.7511,-3.00896 -3.78546,-0.48531 2.42658,-18.92731 0.19412,-1.26182 -2.81483,-0.38826 z\"><title>Utah</title></path><path inkscape:connector-curvature=\"0\" id=\"WY\" data-name=\"Wyoming\" data-id=\"WY\" d=\"m 461.38694,192.16729 0.7765,-15.14184 0.97063,-20.38326 0.0971,-2.52364 -1.26182,-0.0971 -24.94522,-1.45595 -13.97709,-1.16476 -26.49823,-2.52364 -33.19559,-4.07665 -1.35888,9.51219 -0.0971,0.58237 -0.38825,3.20309 -1.74714,12.52114 -3.30015,25.23641 -0.87357,6.3091 -0.38825,3.20309 -0.19412,1.26182 -2.42658,18.92731 3.78546,0.48531 24.7511,3.00896 1.94126,0.19412 2.32951,0.29119 23.97459,2.32952 19.2185,1.55301 28.82775,1.8442 1.94126,0.0971 0.0971,-2.52364 0.48532,-10.19163 0.87357,-17.76255 0.38825,-7.57092 0.0971,-2.52364 0.0971,-2.62071 z\"><title>Wyoming</title></path><path inkscape:connector-curvature=\"0\" id=\"AR\" data-name=\"Arkansas\" data-id=\"AR\" d=\"m 690.4559,328.05566 -10.48282,1.55301 4.27078,-6.79442 -1.8442,-3.78546 -36.98105,3.59134 -31.25432,2.52364 -4.56197,0.29119 0.58238,2.71776 3.78546,19.60675 0.0971,4.36784 1.0677,26.40117 0.0971,4.36784 0.29119,0.0971 1.45595,1.55301 5.82378,-0.19413 0.58238,8.54155 0.19413,2.42658 3.00896,-0.29119 9.22099,-0.67944 36.5928,-3.39721 0.19412,0 -0.0971,-2.13539 0.97063,-0.67944 -1.74713,-3.30014 3.6884,-15.5301 -1.45595,-1.74714 5.5326,-6.11498 -0.38826,-5.2414 4.07665,-6.79442 0,-0.0971 -0.19412,-0.19412 3.49427,-3.20309 -0.97063,-3.88252 2.71777,-4.27078 -0.58238,-3.97959 2.91189,-5.62966 0,-0.0971 -0.0971,0 z\"><title>Arkansas</title></path><path inkscape:connector-curvature=\"0\" id=\"IA\" data-name=\"Iowa\" data-id=\"IA\" d=\"m 661.53109,197.69989 -5.33847,-2.81483 -2.9119,-3.97959 -0.97063,-5.72672 0.77651,-2.62071 -2.81483,-3.39721 0,0 -4.7561,0.48532 -47.75505,3.97959 -19.12144,1.06769 -4.85315,0.29119 -2.03833,0.0971 1.65008,10.77401 -1.35889,5.14435 2.13539,3.20308 0,0.67944 0.67944,0.0971 3.10602,9.12394 3.00896,4.75609 0.19413,5.43554 3.30014,4.56196 -0.58238,1.94126 3.00896,12.22996 0,0.29119 0,0 19.89794,-0.58238 21.25682,-1.8442 20.86857,-2.62071 4.7561,4.17372 0.19412,0.19412 0.87357,-0.38825 -0.67944,-3.78546 3.59133,-2.23245 1.45595,-9.90044 -1.45595,-0.67944 0.87357,-5.04728 4.36784,-0.87357 4.85316,-3.49427 2.13539,-6.11498 0.0971,-3.10602 -3.88252,-3.6884 -1.16476,-2.32951 -3.6884,-2.32952 0.19413,-0.48531 0.0971,-0.48532 z\"><title>Iowa</title></path><path inkscape:connector-curvature=\"0\" id=\"KS\" data-name=\"Kansas\" data-id=\"KS\" d=\"m 608.92288,312.71969 -2.42658,-41.0577 -4.36784,-2.52364 -0.38825,-1.94127 -3.49428,-3.10602 3.39721,-4.17371 -1.35888,-2.42658 -2.52364,0.0971 -2.32952,-1.65008 -0.97063,-0.7765 -3.30014,0.19412 -35.81629,1.35889 -16.40367,0.38825 -32.61321,0 -13.10352,-0.19413 -3.6884,-0.0971 0,1.8442 -0.0971,5.72672 -1.0677,51.34639 0,1.94127 4.17372,0.0971 22.51864,0.29119 52.70528,-0.77651 37.56342,-1.74713 3.6884,-0.29119 -0.0971,-2.52364 z\"><title>Kansas</title></path><path inkscape:connector-curvature=\"0\" id=\"MO\" data-name=\"Missouri\" data-id=\"MO\" d=\"m 653.66898,242.44599 -4.7561,-4.17372 -20.86857,2.62071 -21.25682,1.8442 -19.89794,0.58238 0,0 -0.0971,0.58238 2.42657,4.65903 2.23246,1.553 2.6207,4.65903 0.38825,0.38826 0.97063,0.7765 2.32952,1.65008 2.52364,-0.0971 1.35888,2.42658 -3.39721,4.17371 3.49428,3.10602 0.38825,1.94127 4.36784,2.52364 2.42658,41.0577 0.0971,2.52364 0.19413,2.52364 0.0971,2.52364 0.19413,2.6207 0.0971,2.52365 4.56197,-0.29119 31.25432,-2.52364 36.98105,-3.59134 1.8442,3.78546 -4.27078,6.79442 10.48282,-1.55301 0.0971,0 0,-0.7765 0.19413,-4.46491 1.94126,-2.42658 -0.58238,-2.71776 -0.0971,-0.0971 -0.0971,-0.0971 0.38825,-1.26182 0.58238,0.19413 0.29119,0.7765 -0.0971,0.29119 0,0.0971 0,0.77651 0.38826,0.0971 0.7765,-0.97063 0,-0.0971 0.0971,-0.29119 2.52364,-1.55301 0.38826,-0.19413 0.87357,-7.95917 -0.19413,-0.38826 -0.29119,-0.0971 -6.89148,-5.62966 1.06769,-2.03833 -1.94126,-5.53259 -3.49427,-2.71777 -6.60029,-2.9119 -4.17372,-3.3972 0.48532,-6.98855 1.26182,-6.50323 -6.98855,0.38825 -2.13539,-2.23245 -0.97063,-4.4649 -11.06519,-9.31806 -3.10602,-8.63862 0.7765,-4.27078 0,0 -0.19412,-0.19412 z\"><title>Missouri</title></path><path inkscape:connector-curvature=\"0\" id=\"NE\" data-name=\"Nebraska\" data-id=\"NE\" d=\"m 572.33008,204.68843 -3.00895,-3.00895 -10.57988,-3.10602 -3.39721,-0.0971 -5.14435,1.45594 -6.11498,-3.88252 -19.12143,0.19412 -27.85712,-0.29119 -32.90439,-1.06769 -2.9119,-0.0971 -0.0971,2.52364 -0.38825,7.57092 -0.87357,17.76255 -0.48532,10.19163 -0.0971,2.52364 2.32952,0.0971 23.6834,0.87357 4.65903,0.19413 -0.38826,19.02437 -0.0971,1.26182 3.6884,0.0971 13.10352,0.19413 32.61321,0 16.40367,-0.38825 35.81629,-1.35889 3.30014,-0.19412 -0.38825,-0.38826 -2.6207,-4.65903 -2.23246,-1.553 -2.42657,-4.65903 0.0971,-0.58238 0,-0.29119 -3.00896,-12.22996 0.58238,-1.94126 -3.30014,-4.56196 -0.19413,-5.43554 -3.00896,-4.75609 -3.10602,-9.12394 -0.67944,-0.0971 -1.8442,-0.19413 z\"><title>Nebraska</title></path><path inkscape:connector-curvature=\"0\" id=\"OK\" data-name=\"Oklahoma\" data-id=\"OK\" d=\"m 609.50526,322.91131 -0.19413,-2.6207 -0.0971,-2.52364 -0.19413,-2.52364 -3.6884,0.29119 -37.56342,1.74713 -52.70528,0.77651 -22.51864,-0.29119 -4.17372,-0.0971 -1.55301,0 -6.11497,-0.19413 -1.94127,-0.0971 -4.07665,-0.0971 -1.94126,-0.0971 -0.0971,2.52364 -0.0971,2.52364 -0.0971,2.52364 -0.0971,2.62071 0.58238,0 23.48927,0.58238 24.84816,0.29119 0.29119,33.19558 1.74714,5.82379 3.88252,3.6884 4.17372,0.19413 0.87356,-1.74714 5.72673,5.24141 7.47386,0.7765 1.35888,1.55301 2.71777,-1.26182 6.79442,3.20309 0,1.84419 2.52364,-0.0971 2.6207,-2.23245 4.85316,3.10602 4.56197,1.65007 3.10601,-4.27077 9.90044,4.65902 3.6884,-3.00895 3.00896,-1.16476 2.42658,0.58238 9.12393,-2.6207 4.85316,2.03832 4.36784,2.81483 3.78546,0.67944 0.0971,0 -0.0971,-4.36784 -1.0677,-26.40117 -0.0971,-4.36784 -3.78546,-19.60675 -0.58238,-2.71776 -0.0971,-2.52365 z\"><title>Oklahoma</title></path><path inkscape:connector-curvature=\"0\" id=\"SD\" data-name=\"South Dakota\" data-id=\"SD\" d=\"m 566.89455,135.57949 -16.40367,0.48532 -39.50469,0.29119 -42.80484,-1.16476 -3.78546,-0.19413 -0.0971,2.23246 -0.38825,8.83274 -0.29119,6.69736 -0.0971,1.35888 -0.29119,0 -0.0971,2.52364 -0.97063,20.38326 -0.7765,15.14184 -0.0971,2.62071 2.9119,0.0971 32.90439,1.06769 27.85712,0.29119 19.12143,-0.19412 6.11498,3.88252 5.14435,-1.45594 3.39721,0.0971 10.57988,3.10602 3.00895,3.00895 1.8442,0.19413 0,-0.67944 -2.13539,-3.20308 1.35889,-5.14435 -1.65008,-10.77401 2.03833,-0.0971 -0.19413,-4.4649 -4.85315,-34.16622 -2.52364,-4.27078 3.88252,-6.40616 0.0971,-0.29119 -3.30014,0.19412 z\"><title>South Dakota</title></path><path inkscape:connector-curvature=\"0\" id=\"LA\" data-name=\"Louisiana\" data-id=\"LA\" d=\"m 688.99995,469.2825 -1.26182,0.29119 -0.58238,0.58238 1.8442,-0.87357 z m 4.07665,0 -0.67944,-0.29119 -0.19412,0.29119 0.87356,0 z m 2.32952,-0.77651 -0.67944,0 -0.38826,0.48532 1.0677,-0.48532 z m -1.16476,-0.67944 -0.19413,-0.29119 -0.0971,0.29119 0.29119,0 z m 7.76505,-5.14434 -0.29119,0.19412 0.48532,0 -0.19413,-0.19412 z m 13.58884,-5.72673 0.58238,-0.7765 -0.67945,0.87357 0.0971,-0.0971 z m 1.94126,-2.52364 -0.19413,0.0971 0,0.0971 0.19413,-0.19413 z m -49.89044,8.54156 1.45594,-1.8442 -3.97959,-1.0677 -1.74713,1.45595 4.27078,1.45595 z m 40.28119,-8.44449 -0.38825,-0.38826 -0.0971,0.19413 0.48532,0.19413 z m 1.06769,-1.74714 -0.97063,-0.29119 0.29119,0.97063 0.67944,-0.67944 z m 7.95918,-1.65007 0,-0.29119 0,0.0971 0,0.19413 z m 1.94126,-1.26182 -0.0971,-0.0971 0.0971,0.19413 0,-0.0971 z m -0.7765,-0.19413 -0.19413,-0.0971 -0.0971,0.29119 0.29119,-0.19413 z m -6.79442,-0.29119 0.87357,-0.29119 0,-0.29119 -0.87357,0.58238 z m 0.48532,-0.48532 0.48531,-0.48531 -0.0971,-0.0971 -0.38825,0.58237 z m -3.39721,-3.59133 -0.19413,0.19413 0.0971,0 0.0971,-0.19413 z m -35.8163,-54.35535 -0.19412,0 -36.5928,3.39721 -9.22099,0.67944 -3.00896,0.29119 0.0971,2.32952 1.94126,18.73318 3.20309,4.4649 0.0971,2.62071 3.10602,5.43553 2.52364,7.95918 -0.87357,4.4649 -0.67944,11.0652 -1.45594,3.59133 0.19412,0 0.29119,2.52364 -1.65007,2.32952 12.03582,-1.35889 9.41513,2.62071 6.69735,0.87357 3.39721,-2.42658 -1.8442,-2.42658 6.21204,-1.94126 -0.19412,2.13539 3.20308,-0.77651 2.6207,4.07665 2.23245,-0.7765 5.82379,3.97959 -3.59133,1.26182 8.25036,2.42657 3.10602,0 1.8442,-2.23245 3.97959,-2.13539 2.81483,4.07666 1.94126,-3.6884 -0.58238,-5.82379 5.24141,2.03833 0.58238,1.74713 6.21204,0.77651 3.10602,2.52364 -0.38825,2.03832 4.36784,-4.07665 -1.65008,-2.13539 -7.27973,-1.8442 -2.71777,-1.55301 -0.0971,-2.91189 3.00896,0.38825 2.32951,-4.75609 -3.00896,-4.17371 -1.65007,3.97958 -3.78546,-0.67944 2.6207,-4.27078 -1.74713,-0.48531 -4.27078,3.00896 -6.11498,0.38825 -1.74713,-1.35889 2.81483,-4.95021 3.30014,-0.0971 5.62967,1.8442 4.07665,0.38825 0,0 -2.23245,-2.81483 -4.27078,-8.34742 1.16476,-4.65903 -33.48678,3.68839 1.26182,-1.26182 -1.35888,-3.49427 2.03832,-3.00896 1.16476,-7.57092 7.3768,-12.6182 -3.59134,-4.36784 0.19413,-3.20309 -2.23246,-5.24141 0,-0.67944 z\"><title>Louisiana</title></path><path inkscape:connector-curvature=\"0\" id=\"TX\" data-name=\"Texas\" data-id=\"TX\" d=\"m 573.98015,536.93549 -4.65902,-17.56842 0,3.30015 4.65902,14.26827 z m -1.06769,-30.86607 -3.30015,6.21204 -0.38825,2.03833 3.6884,-8.25037 z m 2.6207,-4.56196 3.10602,-4.07666 -2.23245,1.35889 -0.87357,2.71777 z m 10.96814,-9.90044 -7.27974,3.78546 2.03833,-0.38825 5.24141,-3.39721 z m 0.97063,-1.35889 2.03832,-1.65007 -0.7765,0.19413 -1.26182,1.45594 z m -115.11686,-162.87191 -0.67944,-0.0971 -3.30015,91.0452 -19.2185,-0.87357 -30.76901,-1.74713 -12.32701,-0.87357 2.42658,4.75609 0.0971,0.0971 10.48282,10.48281 6.01791,7.08561 7.95917,5.92085 5.62967,10.28869 2.13538,10.77401 4.56197,3.00895 3.59134,3.97959 5.14434,1.8442 7.47386,4.75609 3.39721,1.26183 4.65903,-4.65903 1.45595,-4.95022 2.42658,-4.7561 7.57092,-3.00895 2.91189,1.45594 8.44449,0.67945 7.66799,4.75609 5.24141,0.97063 -1.45595,2.71777 3.00896,1.94126 2.81483,3.39721 0.58238,3.59133 1.8442,2.42658 4.27077,10.28869 4.27078,3.59134 3.30015,5.43553 4.17371,4.27078 1.8442,0.58238 1.55301,11.06519 4.56197,2.52365 0.19412,3.49427 1.16476,-0.29119 7.95918,9.70631 3.97959,0.87357 5.04728,3.00896 7.76505,0 5.62966,3.10601 6.69735,-1.45594 -3.00895,-2.81483 -2.71777,-8.1533 -1.06769,-7.08561 -1.55301,-2.32952 0.67944,-4.75609 -2.03833,-0.19413 -2.71777,-4.4649 3.10602,3.30015 3.59134,-1.26182 1.94126,-5.14435 -3.88252,-5.24141 5.82378,0.67944 2.71777,-4.17371 -0.38825,-1.45595 2.42658,-3.20308 -0.58238,2.81483 2.71777,-2.13539 -1.0677,-3.78546 3.49427,1.8442 4.46491,-2.52364 -4.36784,-4.56197 2.71776,1.0677 5.04729,0.29119 6.60029,-1.45595 7.3768,-4.95022 4.4649,-3.6884 0.67944,-2.71777 2.71777,-2.81483 -1.45595,-4.65903 0.29119,-2.91189 4.85316,-2.13539 -0.38826,5.14435 2.9119,0 -3.20308,2.71776 12.90939,-6.79441 2.13539,-0.0971 1.35888,-6.21204 0.38826,0 1.45594,-3.59133 0.67944,-11.0652 0.87357,-4.4649 -2.52364,-7.95918 -3.10602,-5.43553 -0.0971,-2.62071 -3.20309,-4.4649 -1.94126,-18.73318 -0.0971,-2.32952 -0.19413,-2.42658 -0.58238,-8.54155 -5.82378,0.19413 -1.45595,-1.55301 -0.29119,-0.0971 -0.0971,0 -3.78546,-0.67944 -4.36784,-2.81483 -4.85316,-2.03832 -9.12393,2.6207 -2.42658,-0.58238 -3.00896,1.16476 -3.6884,3.00895 -9.90044,-4.65902 -3.10601,4.27077 -4.56197,-1.65007 -4.85316,-3.10602 -2.6207,2.23245 -2.52364,0.0971 0,-1.84419 -6.79442,-3.20309 -2.71777,1.26182 -1.35888,-1.55301 -7.47386,-0.7765 -5.72673,-5.24141 -0.87356,1.74714 -4.17372,-0.19413 -3.88252,-3.6884 -1.74714,-5.82379 -0.29119,-33.19558 -24.84816,-0.29119 -23.48927,-0.58238 -0.58238,0 z\" <title>Texas&quot;</path>&gt;<path inkscape:connector-curvature=\"0\" id=\"CT\" data-name=\"Connecticut\" data-id=\"CT\" d=\"m 936.99622,143.34454 -13.97709,5.33847 -0.19412,-0.48531 -7.86211,2.32951 -1.74714,0.48532 0.19413,0.97063 3.68839,14.26828 1.16476,1.45595 -2.52364,3.10602 1.74714,1.65007 0,0 5.62966,-5.43554 3.00895,-4.17371 0.58238,1.16476 14.17122,-6.30911 0.29119,-0.29118 -0.0971,-2.32952 -0.58237,-2.03833 -3.00896,-8.44449 -0.38825,-1.06769 -0.0971,-0.19413 z\"><title>Connecticut</title></path><path inkscape:connector-curvature=\"0\" id=\"NH\" data-name=\"New Hampshire\" data-id=\"NH\" d=\"m 923.8927,75.982738 -1.26182,1.55301 -1.45594,-0.29119 -0.77651,6.406166 0,0.09706 2.32952,8.735681 -0.19413,1.747136 -4.17372,5.532598 1.0677,5.047281 0,6.30911 -0.77651,5.82378 4.36784,15.91836 0,0 0,0 3.97959,-1.26182 12.22996,-4.07666 5.53259,-6.01791 0,0 0,-1.55301 0.29119,-2.52364 -0.67944,0.29119 -0.0971,-0.58238 -6.11498,-7.47386 -0.19413,-0.67944 -14.07415,-33.001465 0,0 z\"><title>New Hampshire</title></path><path inkscape:connector-curvature=\"0\" id=\"RI\" data-name=\"Rhode Island\" data-id=\"RI\" d=\"m 946.50841,152.08022 -0.0971,-2.03832 -0.29119,0.7765 0.38825,1.26182 z m 1.94126,-1.55301 -1.26182,-2.42657 -0.0971,2.52364 1.35888,-0.0971 z m -0.58238,-3.00895 0.67944,1.74713 0.87357,1.55301 0.58238,-1.16475 -0.87357,-1.65008 -0.29119,-1.16475 -0.97063,0 0,0.67944 z m -10.774,-3.97959 0.38825,1.06769 3.00896,8.44449 0.58237,2.03833 0.0971,2.32952 0.19412,-0.29119 4.65903,-3.6884 -0.87356,-6.60029 1.94126,-0.38826 0,0 -4.27078,-5.14434 -4.4649,1.74713 -1.26182,0.48532 z\"><title>Rhode Island</title></path><path inkscape:connector-curvature=\"0\" id=\"VT\" data-name=\"Vermont\" data-id=\"VT\" d=\"m 923.01913,132.86173 -4.36784,-15.91836 0.77651,-5.82378 0,-6.30911 -1.0677,-5.047278 4.17372,-5.532598 0.19413,-1.747136 -2.32952,-8.735681 -1.26182,0.485316 -5.33847,1.941262 -5.24141,2.038326 -12.03583,4.36784 -0.67944,0.194126 4.36784,10.191633 1.45595,9.60924 5.14434,8.05624 4.85316,15.91835 0.19413,-0.0971 0.7765,-0.29119 2.23245,-0.67944 1.94126,-0.67944 5.5326,-1.65007 0.67944,-0.29119 0,0 z\"><title>Vermont</title></path><path inkscape:connector-curvature=\"0\" id=\"AL\" data-name=\"Alabama\" data-id=\"AL\" d=\"m 718.31301,344.84758 0.38826,0.77651 1.35888,0.87356 0.58238,39.79588 0.19413,21.8392 4.95021,29.89545 0.38826,-0.0971 4.36784,0.87357 1.16475,-8.63862 1.94127,4.85316 3.30014,3.00896 6.30911,-3.6884 -0.67945,-0.58238 0.19413,0.0971 -4.36784,-9.9975 41.93127,-6.79442 2.81483,-0.48531 0,-0.0971 -2.62071,-4.95022 -0.19412,-7.0856 -2.13539,-3.88253 1.06769,-7.57092 1.74714,-1.94126 -7.18267,-12.81234 -13.00646,-39.60175 -0.0971,-0.19413 -2.9119,0.48532 -15.5301,2.52364 -7.76504,0.97063 -16.30661,2.23245 0.0971,0.19413 z\"><title>Alabama</title></path><path inkscape:connector-curvature=\"0\" id=\"FL\" data-name=\"Florida\" data-id=\"FL\" d=\"m 854.6867,535.28542 -0.19413,0 0.0971,0.0971 0.0971,-0.0971 z m -0.87357,-0.0971 0,0.0971 0.0971,0 -0.0971,-0.0971 z m 0.19413,-0.0971 0,-0.0971 0,0.0971 0,0 z m -13.20059,1.45594 0,0 0,0.0971 0,-0.0971 z m -0.19412,0.0971 0,-0.0971 0,0.0971 0,0 z m 0.0971,-0.0971 0,0 0,0 0,0 z m -0.97063,0.0971 -0.0971,0 0,0.0971 0.0971,-0.0971 z m 27.56592,-6.11498 -0.0971,0 0.0971,0.19412 0,-0.19412 z m 2.62071,-0.67944 0,-0.19413 -0.19413,0.29119 0.19413,-0.0971 z m -0.97063,-0.19413 -0.38826,-0.38825 -0.0971,0.0971 0.48532,0.29119 z m -0.29119,0.77651 -1.16476,-1.45595 0.67944,1.26182 0.48532,0.19413 z m 9.22099,-5.72673 0,0.38825 0.19413,-0.19412 -0.19413,-0.19413 z m 1.35889,-0.97063 0.29119,-0.48532 -0.38826,0.38826 0.0971,0.0971 z m 0.29119,-0.97063 -0.0971,0 0,0.0971 0.0971,-0.0971 z m -1.74714,-0.29119 -0.0971,-0.0971 0.0971,0.0971 0,0 z m 0.87357,-1.45595 -0.0971,-0.0971 0,0.19413 0.0971,-0.0971 z m -2.62071,-0.0971 -0.0971,-0.0971 0.0971,0.0971 0,0 z m 3.30015,-2.23245 -0.19413,0.0971 0.29119,0.0971 -0.0971,-0.19412 z m 0.38825,0 -0.19412,-0.19413 0.0971,0.29119 0.0971,-0.0971 z m -0.67944,-0.19413 -0.0971,-0.0971 0,0.19412 0.0971,-0.0971 z m 3.59134,-0.67944 0,-0.0971 -0.19413,0.38825 0.19413,-0.29119 z m -4.07665,0.38825 -0.19413,0 0.19413,0.0971 0,-0.0971 z m 2.03832,-1.16476 -0.29119,0 -0.0971,0.0971 0.38825,-0.0971 z m 0.77651,-0.48531 0,0 -0.0971,0 0.0971,0 z m -8.15331,0.38825 0,-0.19412 -0.0971,0.19412 0.0971,0 z m 0.87357,-0.29119 -0.29119,0 0.29119,0.58238 0,-0.58238 z m -2.32951,0.0971 0,-0.58238 -0.48532,0.0971 0.48532,0.48532 z m -1.35889,-0.97064 0.48532,0.48532 0,-0.19413 -0.48532,-0.29119 z m 14.26828,0.58238 -1.74713,0.77651 0.58237,0.0971 1.16476,-0.87357 z m -13.58883,-0.87356 -0.58238,0 0,0.19412 0.58238,-0.19412 z m 15.33597,-4.85316 0.0971,-0.48532 0.0971,-1.26182 -0.19412,1.74714 z m 0.0971,-5.43554 -0.38825,-0.97063 -0.19413,0.38826 0.58238,0.58237 z m -22.42158,2.42658 -0.19413,0.29119 0.48532,0.0971 -0.29119,-0.38825 z m -1.8442,-0.87357 -0.87357,0.29119 0.67945,0.0971 0.19412,-0.38826 z m -1.94126,0.19413 0,-0.29119 -0.0971,0.0971 0.0971,0.19413 z m -2.03833,-0.0971 -0.58238,0.38825 0.77651,0.38825 -0.19413,-0.7765 z m 2.71777,0.0971 -0.0971,-0.29119 -0.48532,-0.0971 0.58238,0.38825 z m -12.71527,-9.51219 -0.58238,0.29119 1.16476,0.38826 -0.58238,-0.67945 z m -2.32951,-3.10602 -0.77651,-1.16475 0.29119,0.87357 0.48532,0.29118 z m 3.00895,1.94127 -1.35888,-3.10602 -0.97063,-0.29119 2.32951,3.39721 z m -3.88252,-3.88253 -0.29119,-0.7765 -0.19413,-0.48532 0.48532,1.26182 z m -8.05624,-10.774 -1.74714,-1.26182 0.67945,0.67944 1.06769,0.58238 z m 43.6784,-6.50323 -7.0856,-11.8417 -0.38826,0 7.47386,11.8417 z m -49.01687,-18.92731 -0.29119,-0.0971 0.29119,0.19412 0,-0.0971 z m -0.58238,-0.67944 -0.0971,0.0971 0.0971,0.0971 0,-0.19412 z m -0.67944,-0.97063 0,-0.0971 -0.0971,0.0971 0.0971,0 z m 0.38825,-0.38826 0.29119,0.19413 0,-0.19413 -0.29119,0 z m 0.58238,-0.38825 -0.38825,0.0971 0.0971,0 0.29119,-0.0971 z m -0.67944,-0.0971 -0.29119,-0.29119 0.0971,0.0971 0.19413,0.19413 z m -0.67944,-1.0677 -0.19413,0 0.29119,0.0971 -0.0971,-0.0971 z m 0.67944,-1.16475 -0.38826,0 -0.0971,0.0971 0.48532,-0.0971 z m 0.38825,0.19412 -0.48532,-0.48531 0.19413,0.0971 0.29119,0.38825 z m -3.6884,-4.17371 -0.19413,-0.0971 0,0.0971 0.19413,0 z m -4.17371,0 -0.29119,-0.38825 0.0971,0.48531 0.19413,-0.0971 z m -35.33098,-3.20309 2.91189,-2.23245 -3.20308,2.13539 0.29119,0.0971 z m 5.82379,-4.65902 0.29119,-0.29119 -1.16476,0.48531 0.87357,-0.19412 z m -36.88399,-6.50323 -10.57988,3.39721 5.82379,-1.65008 4.75609,-1.74713 z m 26.30411,-16.50073 -2.81483,0.48531 -41.93127,6.79442 4.36784,9.9975 0.29119,0.0971 -1.06769,3.97959 3.10602,-1.35888 3.3972,-3.00896 5.82379,-0.19412 6.69736,-2.42658 4.56196,0.67944 -1.06769,1.65007 8.34743,2.81483 7.18267,3.49428 1.65007,3.88252 5.33847,-1.16476 12.61821,-10.28869 4.65903,0.19413 19.02437,14.36534 3.88252,-0.77651 4.07666,5.43554 0.7765,8.63862 -1.26182,5.43553 0.58238,2.71777 3.39721,6.79442 -1.55301,-5.33847 4.36784,-0.0971 0.38825,3.88253 -2.32951,6.01791 8.05624,11.0652 3.00895,0.0971 -2.52364,-3.39721 3.10602,0.38825 1.8442,-1.16475 -0.7765,6.21204 4.17371,3.30014 2.81483,7.57093 3.78546,2.32951 4.85316,1.26182 6.69735,8.54156 3.49428,1.84419 -4.65903,0.29119 2.13538,2.42658 7.66799,-2.52364 3.78546,-2.13539 3.49427,-12.22995 -1.74713,-19.02437 -0.38825,-1.94127 -9.31806,-15.53009 -7.95918,-11.25933 -4.4649,-9.22099 3.78546,3.20308 0.7765,-0.58238 1.65008,8.05624 4.27077,6.11498 -4.17371,-8.1533 0.19413,-3.88253 -12.52115,-15.23891 -3.00895,-4.75609 -3.97959,-8.05624 -2.71777,-6.79442 -2.13539,-2.42658 -0.48531,-3.10602 -0.0971,-0.0971 -6.69735,-0.38825 -2.62071,2.03832 -1.45594,7.47386 -1.35889,-3.49427 -45.81379,5.72672 -3.30014,-5.14434 0.0971,-0.0971 z\"><title>Florida</title></path><path inkscape:connector-curvature=\"0\" id=\"GA\" data-name=\"Georgia\" data-id=\"GA\" d=\"m 845.85395,396.09691 -0.0971,-2.9119 -0.67944,2.52364 0.7765,0.38826 z m 1.0677,-4.46491 -0.38825,-2.23245 -0.29119,1.35889 0.67944,0.87356 z m -45.42554,-61.14976 -1.26182,0.29119 -3.6884,0.7765 -13.58884,2.81483 -1.26182,0.29119 -1.35888,0.19413 -7.57093,1.45595 -2.03832,0.38825 -8.25037,1.55301 -1.74713,0.19412 0.0971,0.19413 13.00646,39.60175 7.18267,12.81234 -1.74714,1.94126 -1.06769,7.57092 2.13539,3.88253 0.19412,7.0856 2.62071,4.95022 0,0.0971 -0.0971,0.0971 3.30014,5.14434 45.81379,-5.72672 1.35889,3.49427 1.45594,-7.47386 2.62071,-2.03832 6.69735,0.38825 0,0 -0.58237,-10.48282 1.26182,-2.23245 -0.67945,-4.17371 1.35889,-3.97959 2.03832,-2.23245 -1.45594,-1.35889 3.39721,-4.17371 -0.0971,0 -5.82378,-5.43554 -7.95918,-11.35638 -4.36784,-2.03833 -18.73318,-15.72422 -4.56197,-5.82379 -8.83274,-3.6884 -0.48532,-1.94126 2.71777,-5.33847 0,0 z\"><title>Georgia</title></path><path inkscape:connector-curvature=\"0\" id=\"MS\" data-name=\"Mississippi\" data-id=\"MS\" d=\"m 716.76,442.78427 -0.48531,0.0971 0,0.0971 0.48531,-0.19412 z m 9.02687,-1.16476 -1.35888,0 1.26182,0.0971 0.0971,-0.0971 z m -11.25932,0.97063 -0.38825,0.38825 0.0971,0.0971 0.29119,-0.48532 z m 9.12394,-0.7765 -3.6884,0 3.49427,0.0971 0.19413,-0.0971 z m -40.47533,-92.50116 0,0.0971 -4.07665,6.79442 0.38826,5.2414 -5.5326,6.11498 1.45595,1.74714 -3.6884,15.5301 1.74713,3.30014 -0.97063,0.67944 0.0971,2.13539 0,0.67944 2.23246,5.24141 -0.19413,3.20309 3.59134,4.36784 -7.3768,12.6182 -1.16476,7.57092 -2.03832,3.00896 1.35888,3.49427 -1.26182,1.26182 33.48678,-3.68839 -1.16476,4.65903 4.27078,8.34742 2.23245,2.81483 0,-0.0971 3.59133,-4.07665 7.57093,-1.65007 6.98854,0.7765 1.06769,-1.35888 0,-0.0971 -4.95021,-29.89545 -0.19413,-21.8392 -0.58238,-39.79588 -1.35888,-0.87356 -0.38826,-0.77651 -0.19412,0 -4.85316,0.67944 -8.54155,1.16476 -19.41263,2.42658 -2.13539,0.19412 z\"><title>Mississippi</title></path><path inkscape:connector-curvature=\"0\" id=\"SC\" data-name=\"South Carolina\" data-id=\"SC\" d=\"m 801.49611,330.48224 0,0 -2.71777,5.33847 0.48532,1.94126 8.83274,3.6884 4.56197,5.82379 18.73318,15.72422 4.36784,2.03833 7.95918,11.35638 5.82378,5.43554 0,0 0.97063,-4.4649 -1.55301,-4.27078 4.17372,3.10602 2.32951,-1.8442 -3.97959,-3.30015 4.85316,-0.29119 7.57092,-6.40616 -0.87356,-1.65008 4.65903,-3.59133 -0.48532,-1.74714 3.39721,-2.13539 0.19413,-4.95022 5.33847,-9.90043 3.59133,-4.56197 0.38826,-0.19413 -21.64508,-13.6859 -8.05624,1.55301 -10.96813,-0.38825 -5.43554,-2.81483 -32.22495,10.19163 -0.29119,0 z\"><title>South Carolina</title></path><path inkscape:connector-curvature=\"0\" id=\"IL\" data-name=\"Illinois\" data-id=\"IL\" d=\"m 661.43403,198.18521 -0.19413,0.48531 3.6884,2.32952 1.16476,2.32951 3.88252,3.6884 -0.0971,3.10602 -2.13539,6.11498 -4.85316,3.49427 -4.36784,0.87357 -0.87357,5.04728 1.45595,0.67944 -1.45595,9.90044 -3.59133,2.23245 0.67944,3.78546 -0.87357,0.38825 0,0 -0.7765,4.27078 3.10602,8.63862 11.06519,9.31806 0.97063,4.4649 2.13539,2.23245 6.98855,-0.38825 -1.26182,6.50323 -0.48532,6.98855 4.17372,3.3972 6.60029,2.9119 3.49427,2.71777 1.94126,5.53259 -1.06769,2.03833 6.89148,5.62966 0.29119,0.0971 -0.58238,-0.58238 1.94126,-4.56196 7.47386,2.03832 1.8442,-2.13539 -1.45594,-4.27077 6.11497,-3.59134 -1.65007,-2.32951 1.45595,-3.30015 0,-0.29119 -0.38826,-0.0971 0.0971,-8.63862 2.13539,-1.55301 3.68839,-8.63862 -0.7765,-3.78546 -2.42658,-4.56196 1.35888,-5.14435 -6.79441,-47.85212 -0.97064,-1.06769 -2.52364,-5.72673 -2.03832,-2.13539 -0.87357,-5.62966 0,-0.19412 -13.10352,1.8442 -7.86211,0.97063 -21.15976,2.42658 0,0 z\"><title>Illinois</title></path><path inkscape:connector-curvature=\"0\" id=\"IN\" data-name=\"Indiana\" data-id=\"IN\" d=\"m 750.34384,200.22353 -14.85065,2.62071 -3.39721,0.67944 -12.03583,1.94126 -2.52364,2.03833 -3.78546,1.74713 -1.45595,-0.0971 -1.74714,-0.87357 -0.58237,-0.58238 6.79441,47.85212 -1.35888,5.14435 2.42658,4.56196 0.7765,3.78546 -3.68839,8.63862 -2.13539,1.55301 -0.0971,8.63862 0.38826,0.0971 0.38825,-0.0971 1.45595,-2.71777 3.59133,0 4.36784,-1.45595 5.43554,2.03833 0.58237,-2.23245 3.10602,-2.32952 4.65903,0.67945 2.52365,-4.95022 6.89148,0.58237 -0.0971,-2.81483 6.11498,-8.05623 -0.97063,-3.6884 4.27078,-0.0971 5.2414,-4.17371 -1.26182,-4.75609 0.19413,-0.19413 -0.19413,-1.65007 -5.82378,-34.36035 -2.62071,-14.65653 -0.29119,-1.55301 -0.29119,-1.26182 z\"><title>Indiana</title></path><path inkscape:connector-curvature=\"0\" id=\"KY\" data-name=\"Kentucky\" data-id=\"KY\" d=\"m 693.17367,317.18459 -0.29119,-0.7765 -0.58238,-0.19413 -0.38825,1.26182 0.0971,0.0971 1.06769,-0.0971 0.0971,-0.29119 z m 66.39117,-63.47928 -0.19413,0.19413 1.26182,4.75609 -5.2414,4.17371 -4.27078,0.0971 0.97063,3.6884 -6.11498,8.05623 0.0971,2.81483 -6.89148,-0.58237 -2.52365,4.95022 -4.65903,-0.67945 -3.10602,2.32952 -0.58237,2.23245 -5.43554,-2.03833 -4.36784,1.45595 -3.59133,0 -1.45595,2.71777 -0.38825,0.0971 0,0.29119 -1.45595,3.30015 1.65007,2.32951 -6.11497,3.59134 1.45594,4.27077 -1.8442,2.13539 -7.47386,-2.03832 -1.94126,4.56196 0.58238,0.58238 0.19413,0.38826 -0.87357,7.95917 -0.38826,0.19413 -2.52364,1.55301 -0.0971,0.29119 2.81483,-0.38826 19.60675,-2.6207 -0.97063,-3.88252 3.30015,-0.0971 39.50469,-5.24141 27.76005,-4.65903 0.38825,-0.29119 0.67944,-0.7765 7.27974,-3.88252 5.62966,-7.3768 0.7765,-2.52364 3.6884,-2.9119 4.65903,-5.92085 0.67944,-0.97063 -0.29119,-0.0971 -2.42657,0 -3.10602,-1.74714 -5.5326,-6.69735 -1.94126,-6.79442 0,-0.19413 -0.19413,-0.19412 -4.07665,-2.32952 -1.8442,-3.10602 -3.6884,3.59134 -2.32951,0.58238 -2.9119,-1.16476 -2.52364,1.94126 -5.24141,-2.32951 -1.35888,0.58237 -4.95022,-4.27077 -2.52364,-1.26182 -4.75609,0.58238 -0.77651,0.7765 z\"><title>Kentucky</title></path><path inkscape:connector-curvature=\"0\" id=\"NC\" data-name=\"North Carolina\" data-id=\"NC\" d=\"m 890.2118,332.22937 -1.06769,1.0677 0.19412,0.19413 0.87357,-1.26183 z m 0.7765,-5.62966 -0.48531,0.77651 0.19413,0.7765 0.29118,-1.55301 z m 5.82379,-9.02687 -1.45594,0.97063 -0.77651,1.16476 2.23245,-2.13539 z m 12.52114,-6.11497 -0.58237,-0.38826 -1.26182,-0.0971 1.84419,0.48532 z m -2.6207,-0.58238 -0.87357,0 -1.45594,0.7765 2.32951,-0.7765 z m 3.00896,1.06769 2.81483,-6.98854 -1.94126,2.91189 -0.87357,4.07665 z m 4.17371,-9.22099 1.26182,-1.8442 -0.67944,0 -0.58238,1.8442 z m 8.1533,-7.57093 -2.13539,-10.774 1.8442,5.62966 0.29119,5.14434 z m -11.8417,-24.55697 -0.19412,0.0971 -0.29119,0.0971 0,0 0.0971,0 5.33847,9.02687 4.17372,4.17371 -9.12394,-13.39471 0,0 z m -1.74713,0.58238 -0.77651,0.19413 0,0 0.19413,0.0971 1.65007,0 -0.19413,-0.58238 0,0 -0.29118,0.0971 -0.29119,0 0,0 0,0.19412 -0.19413,0.0971 -0.0971,-0.0971 0,0 z m -89.78339,22.13039 -0.48532,1.45595 0.0971,4.17371 -1.0677,-0.0971 -2.52364,5.14435 -2.81483,0.29119 -5.24141,5.14434 -2.32951,-0.87357 -3.00896,4.46491 -7.95917,7.18267 -3.88253,0.97063 -4.07665,3.78546 -0.19413,2.52364 -3.59133,1.94126 0.0971,4.27078 0,0.97063 1.26182,-0.29119 13.58884,-2.81483 3.6884,-0.7765 1.26182,-0.29119 0.29119,0 32.22495,-10.19163 5.43554,2.81483 10.96813,0.38825 8.05624,-1.55301 21.64508,13.6859 0.38825,-0.29119 9.9975,-4.07665 0.0971,-5.33847 3.59134,-6.50323 3.88252,-3.6884 8.05624,-5.33847 1.0677,-1.94126 2.13538,0.97063 0.97064,-6.40616 -1.16476,2.23245 -4.07665,1.35888 -3.88253,0.0971 4.7561,-3.49427 -1.45595,-1.55301 1.65007,-3.49427 -9.12393,-1.45595 -0.38825,-0.48531 7.76505,-1.45595 2.52364,1.26182 3.20308,-0.29119 2.6207,-1.94126 1.94127,-3.78546 1.74713,-0.48532 -0.29119,-5.33847 -2.23245,-2.13539 -2.23245,2.03833 0.48531,5.14434 -1.65007,-6.3091 -1.26182,-0.29119 -9.60925,3.97959 4.27078,-4.17372 0.19413,-1.65007 4.4649,-1.06769 1.26182,-3.30015 3.00896,1.74714 -3.20309,-4.7561 -2.23245,-1.94126 0,0 -38.82525,11.0652 -24.75109,6.3091 -25.04229,4.65903 -0.0971,-0.19413 z\"><title>North Carolina</title></path><path inkscape:connector-curvature=\"0\" id=\"OH\" data-name=\"Ohio\" data-id=\"OH\" d=\"m 818.19096,206.6297 -2.42657,-10.48282 -0.48532,-2.13539 -2.71777,-11.93876 -3.49427,2.23245 -7.47386,5.72672 -4.85315,5.92085 -3.78547,0.58238 -6.98854,3.97959 -3.88253,-2.32951 -11.74463,-1.35889 0,0 -6.21204,1.55301 -6.11498,1.45595 -6.40617,1.35888 -0.97063,0.29119 0.29119,1.55301 2.62071,14.65653 5.82378,34.36035 0.19413,1.65007 0.77651,-0.7765 4.75609,-0.58238 2.52364,1.26182 4.95022,4.27077 1.35888,-0.58237 5.24141,2.32951 2.52364,-1.94126 2.9119,1.16476 2.32951,-0.58238 3.6884,-3.59134 1.8442,3.10602 4.07665,2.32952 0.19413,0.19412 0,0 4.17371,-2.03832 1.45595,-3.20309 -1.16476,-3.30014 3.30014,-5.04728 2.42658,-0.38826 -0.29119,-4.27077 3.97959,-5.43554 0.67944,0.77651 3.59134,-2.71777 3.10602,-4.65903 0.48531,-21.25682 0.19413,-0.0971 -0.48532,-2.03832 z\"><title>Ohio</title></path><path inkscape:connector-curvature=\"0\" id=\"TN\" data-name=\"Tennessee\" data-id=\"TN\" d=\"m 786.2572,300.48973 -27.76005,4.65903 -39.50469,5.24141 -3.30015,0.0971 0.97063,3.88252 -19.60675,2.6207 -2.81483,0.38826 0,0.0971 -0.7765,0.97063 -0.38826,-0.0971 0,-0.77651 0,-0.0971 -1.06769,0.0971 0.0971,0.0971 0.58238,2.71776 -1.94126,2.42658 -0.19413,4.46491 0,0.7765 0,0.0971 -2.91189,5.62966 0.58238,3.97959 -2.71777,4.27078 0.97063,3.88252 -3.49427,3.20309 0.19412,0.19412 2.13539,-0.19412 19.41263,-2.42658 8.54155,-1.16476 4.85316,-0.67944 0.19412,0 -0.0971,-0.19413 16.30661,-2.23245 7.76504,-0.97063 15.5301,-2.52364 2.9119,-0.48532 1.74713,-0.19412 8.25037,-1.55301 2.03832,-0.38825 7.57093,-1.45595 1.35888,-0.19413 0,-0.97063 -0.0971,-4.27078 3.59133,-1.94126 0.19413,-2.52364 4.07665,-3.78546 3.88253,-0.97063 7.95917,-7.18267 3.00896,-4.46491 2.32951,0.87357 5.24141,-5.14434 2.81483,-0.29119 2.52364,-5.14435 1.0677,0.0971 -0.0971,-4.17371 0.48532,-1.45595 -1.55301,0.29119 -5.5326,1.55301 -6.60029,1.35889 -16.59779,3.39721 -1.74714,0.29118 -0.38825,0.29119 z\" <title>Tennessee&quot;</path>/&gt;<path inkscape:connector-curvature=\"0\" id=\"VA\" data-name=\"Virginia\" data-id=\"VA\" d=\"m 908.75086,270.98255 0.29119,0 0.29118,-0.0971 0,0 -0.19412,-0.48531 -0.38825,0.58238 0,0 z m -3.30015,-10.87107 0,0.48531 0.48532,-0.29119 -0.48532,-0.19412 z m 1.74714,-3.39721 -0.0971,-0.77651 0,0 0.0971,0.77651 z m -0.58238,1.16475 -0.19413,1.26183 -0.29119,0.48531 0.48532,-1.74714 z m 0.87357,-2.52364 0.0971,-0.58238 -0.19413,0.58238 0.0971,0 z m 0.58237,-2.6207 0.29119,-0.67944 -0.48531,1.74713 0.19412,-1.06769 z m 0.0971,-1.45595 0.38825,-2.13539 -0.48532,0.48532 0.0971,1.65007 z m 1.74713,-9.60925 0.19413,-0.87356 -0.0971,0.19412 -0.0971,0.67944 z m -0.38825,-2.23245 -1.26182,0.48532 -1.94126,0.87357 -0.67944,0.87356 0.29119,0.0971 -2.32952,14.4624 0.87357,2.32952 1.35888,-6.01792 2.52364,-7.86211 1.16476,-5.14435 0,-0.0971 z m 1.94126,-0.7765 -0.29119,0.0971 -0.0971,0.38825 -0.48531,3.00896 0.38825,-1.0677 0.48531,-2.42657 z m -101.43096,37.17517 -0.67944,0.97063 -4.65903,5.92085 -3.6884,2.9119 -0.7765,2.52364 -5.62966,7.3768 -7.27974,3.88252 -0.67944,0.7765 1.74714,-0.29118 16.59779,-3.39721 6.60029,-1.35889 5.5326,-1.55301 1.55301,-0.29119 0.0971,0.19413 25.04229,-4.65903 24.75109,-6.3091 38.82525,-11.0652 0,0 -0.29119,-0.48531 -0.0971,-0.29119 0.67944,0.67944 0,0 0,0 0.77651,-0.19413 -0.0971,-0.0971 -0.67944,-3.30015 0.48532,0.0971 1.55301,2.91189 0,0 0,0 0.29119,-0.0971 0.19412,-0.0971 -0.38825,-0.7765 -3.97959,-6.11498 -4.95022,0.87357 -2.23245,1.8442 -2.13539,-1.94126 -7.27973,-2.42658 -5.04728,-0.19413 9.80337,-0.87357 5.43554,3.6884 1.55301,-2.42658 -4.36784,-5.53259 3.10602,0.19412 -1.65008,-4.4649 -3.88252,0.19413 -9.221,-7.47386 -1.16476,0 13.00646,6.40616 -0.87357,-4.4649 0.87357,-1.45595 -6.60029,-2.52364 -5.72672,-0.38825 -2.81483,-2.52364 -2.32952,1.45594 -0.87357,-6.69735 0.97063,0.19412 -0.19412,-5.43553 -0.19413,-0.19413 -0.19413,0.0971 -0.19412,-0.0971 -0.48532,-0.38825 -0.29119,-0.29119 -3.10602,-1.35888 -3.20308,-2.32952 -4.4649,-1.16475 -0.29119,-0.0971 0,0.0971 -0.58238,4.07665 -9.02687,-3.88253 0.19413,5.62966 -4.95022,9.41513 -3.00896,3.30014 -1.94126,5.72673 -5.92085,-2.03833 -2.9119,13.20058 -2.32951,4.46491 -0.38825,5.82379 -1.74714,2.81483 -6.50323,1.94126 -5.33847,4.17371 -2.52364,0.38825 -2.42658,2.13539 -6.11498,-2.23245 -1.06769,-3.00896 -0.19413,-0.0971 z\"><title>Virginia</title></path><path inkscape:connector-curvature=\"0\" id=\"WI\" data-name=\"Wisconsin\" data-id=\"WI\" d=\"m 705.79187,134.80299 -2.42658,3.00896 -1.45594,4.36784 0.67944,2.42657 3.20308,-9.80337 z m -55.71423,-22.80983 1.45595,-2.03833 -1.0677,0.97063 -0.38825,1.0677 z m 2.23245,-3.20309 -0.48531,-0.58238 -1.0677,0.67945 1.55301,-0.0971 z m -21.15976,5.43554 -2.23245,2.52364 1.0677,11.64757 -6.21204,5.62966 -1.16476,5.43554 3.39721,3.10602 -0.97063,13.39471 3.59133,2.71777 2.32952,0.19412 7.37679,4.46491 4.65903,4.85315 5.92085,3.00896 1.35889,7.47386 0,0.48531 0,0 2.81483,3.39721 -0.77651,2.62071 0.97063,5.72672 2.9119,3.97959 5.33847,2.81483 -0.0971,0.48532 0,0 21.15976,-2.42658 7.86211,-0.97063 13.10352,-1.8442 -0.38825,-1.45595 0,-4.56197 -2.62071,-4.85315 -0.67944,-6.11498 1.26182,-6.79442 -0.67944,-5.24141 2.32952,-6.50322 -0.87357,-1.0677 0.19412,-6.01791 1.26182,-4.56197 -1.45594,-1.55301 -2.81483,0.97063 -1.55301,4.07665 -3.6884,2.13539 1.16476,-5.14434 3.30014,-4.36784 0.19413,-1.94127 0.0971,-0.0971 -4.65903,-4.65903 0,-6.60029 -5.24141,-4.27078 -7.18267,-0.48531 -7.3768,-1.94127 -15.91835,-4.85315 -3.10602,-1.74714 -0.29119,0.29119 -4.95022,-0.67944 -1.65007,0.97063 0.67944,-7.08561 -7.95917,4.07665 -9.70631,1.55301 -0.0971,-0.19412 z m 19.02437,-5.14435 -0.19412,-0.67944 -0.67944,0.29119 0.87356,0.38825 z m -3.49427,-0.67944 0.29119,-0.58238 -0.19413,-0.19413 -0.0971,0.77651 z m 7.08561,-1.65007 -0.29119,-1.35889 -0.29119,1.65008 0.58238,-0.29119 z\"><title>Wisconsin</title></path><path inkscape:connector-curvature=\"0\" id=\"WV\" data-name=\"West Virginia\" data-id=\"WV\" d=\"m 836.73002,223.71281 -13.78296,3.39721 -4.27078,-18.442 0,0 -0.19413,0.0971 -0.48531,21.25682 -3.10602,4.65903 -3.59134,2.71777 -0.67944,-0.77651 -3.97959,5.43554 0.29119,4.27077 -2.42658,0.38826 -3.30014,5.04728 1.16476,3.30014 -1.45595,3.20309 -4.17371,2.03832 0,0 0,0.19413 1.94126,6.79442 5.5326,6.69735 3.10602,1.74714 2.42657,0 0.29119,0.0971 0.19413,0.0971 1.06769,3.00896 6.11498,2.23245 2.42658,-2.13539 2.52364,-0.38825 5.33847,-4.17371 6.50323,-1.94126 1.74714,-2.81483 0.38825,-5.82379 2.32951,-4.46491 2.9119,-13.20058 5.92085,2.03833 1.94126,-5.72673 3.00896,-3.30014 4.95022,-9.41513 -0.19413,-5.62966 9.02687,3.88253 0.58238,-4.07665 0,-0.0971 0,0 -2.81483,-4.85315 -5.82379,-0.67945 -3.39721,2.62071 0,1.94126 -2.91189,0.67944 -4.27078,3.00896 -2.23245,0.48532 -4.46491,6.3091 -2.23245,-10.19163 -1.94126,0.48532 z\"><title>West Virginia</title></path><path inkscape:connector-curvature=\"0\" id=\"DE\" data-name=\"Delaware\" data-id=\"DE\" d=\"m 893.80314,207.69739 0.38825,1.45595 8.05624,23.00396 9.22099,-2.71777 -0.0971,-0.19413 0.19413,0 0.29119,0.0971 0,0 0.19412,-0.0971 -0.19412,-0.38825 -2.32952,-6.21204 -11.35638,-10.774 0.48531,-7.47386 0,0 -2.32951,0 -1.74714,1.35888 -0.7765,1.94126 0,0 z\"><title>Delaware</title></path><path inkscape:connector-curvature=\"0\" id=\"DC\" data-name=\"District of Columbia\" data-id=\"DC\" d=\"m 878.17597,229.14834 0.48532,0.38825 0.19412,0.0971 0.19413,-0.0971 0.19413,0.0971 0.67944,0.38825 0.19413,0.29119 0,0.67944 0.19412,0.38825 1.26182,-2.32951 -1.35888,-0.77651 -1.65007,0.0971 -0.38826,0.7765 z\"><title>District of Columbia</title></path><path inkscape:connector-curvature=\"0\" id=\"MD\" data-name=\"Maryland\" data-id=\"MD\" d=\"m 911.56569,238.27227 0.67944,-5.2414 -0.58238,3.88252 -0.38825,1.65007 -0.0971,0.19413 0.29119,-0.0971 0.0971,-0.38826 z m 0.48531,-9.02687 -0.19412,0.0971 0.19412,0.58238 0,1.16475 0,-1.8442 0,0 z m -73.37972,-6.01791 2.23245,10.19163 4.46491,-6.3091 2.23245,-0.48532 4.27078,-3.00896 2.91189,-0.67944 0,-1.94126 3.39721,-2.62071 5.82379,0.67945 2.81483,4.85315 0,0 0.29119,0.0971 4.4649,1.16475 3.20308,2.32952 3.10602,1.35888 0.29119,0.29119 0.38826,-0.7765 1.65007,-0.0971 1.35888,0.77651 -1.26182,2.32951 0,0.0971 -1.8442,5.62966 6.01792,3.88252 6.01791,0.29119 3.97959,1.8442 -1.65008,-4.65903 -5.14434,-1.74714 -1.26182,-3.97958 3.20308,4.27077 2.62071,0.38826 -2.32952,-2.32952 -1.8442,-6.89148 0.48532,-3.97959 -2.03833,-4.36784 2.13539,-1.74713 1.55301,-5.62967 -0.58238,8.34743 1.65007,2.81483 1.55301,-3.30014 0.87357,5.43553 -1.65007,3.97959 4.75609,1.74714 -4.07665,1.35888 2.13539,3.97959 3.49427,1.16475 1.94126,-3.3972 -0.19412,4.75609 3.30014,-0.0971 2.13539,2.42657 0.0971,0 0.67944,-0.87356 1.94126,-0.87357 1.26182,-0.48532 -0.0971,-0.19412 2.52364,-7.47386 0,-0.29119 -0.48532,-1.94127 0,-0.0971 -9.22099,2.71777 -8.05624,-23.00396 -0.38825,-1.45595 -1.65008,0.48532 -6.89148,2.13539 -37.95168,10.57988 -6.89148,1.8442 -1.74714,0.48531 z\"><title>Maryland</title></path><path inkscape:connector-curvature=\"0\" id=\"NJ\" data-name=\"New Jersey\" data-id=\"NJ\" d=\"m 916.80709,207.30914 -0.48531,-1.16476 0,1.16476 0.48531,0 z m 0.97064,-3.59134 0.29119,-2.91189 -0.58238,2.52364 0.29119,0.38825 z m -3.97959,-29.79837 -10.19163,-2.52365 -1.74714,-0.48531 -1.65007,-0.38825 0,0 -4.07665,9.02687 1.74714,2.13539 -0.0971,6.50322 1.8442,0.29119 3.78546,9.90044 -0.19412,0.29119 -4.75609,6.98855 0.48531,5.33847 11.45345,3.88252 0.0971,4.46491 2.62071,-3.6884 0.38825,-5.33847 2.71777,-1.8442 -1.0677,-3.97959 2.03833,-4.75609 0,-10.38576 -0.67944,-3.39721 -4.56197,0.0971 1.16476,-4.65903 0.67944,-7.47386 0,0 z\"><title>New Jersey</title></path><path inkscape:connector-curvature=\"0\" id=\"NY\" data-name=\"New York\" data-id=\"NY\" d=\"m 913.50695,181.78154 -1.45595,2.03832 -0.38825,0.58238 1.8442,-2.6207 z m 13.39471,-4.75609 4.85316,-4.27078 0,-0.19413 -4.85316,4.46491 z m -12.71527,3.00895 0,-3.30014 -0.29119,1.74713 0.29119,1.55301 z m 22.51864,-15.5301 -1.16475,-0.29119 -0.19413,0.87357 1.35888,-0.58238 z m 2.62071,-1.74713 -0.0971,0.97063 0.19412,-0.58238 -0.0971,-0.38825 z m -2.71777,0.0971 -6.50323,6.01791 -9.9975,4.27078 -2.6207,2.23245 -0.19413,2.13539 -2.71777,2.23245 0.38826,2.9119 4.17371,-1.65008 6.11498,-4.95022 6.79441,-3.59133 10.2887,-9.70631 -7.27974,5.53259 -2.32951,0.97064 3.88252,-6.40617 z m 3.00896,-4.07665 0.38825,-0.58238 -1.16476,1.35888 0.77651,-0.7765 z m -109.09895,-3.59134 -1.55301,-0.19412 1.16476,1.55301 0.38825,-1.35889 z m 32.22496,-29.70131 0.19412,-1.0677 -0.7765,0.97064 0.58238,0.0971 z m 0.48531,-6.98855 -0.38825,0.19413 -0.48532,1.06769 0.87357,-1.26182 z m -41.0577,55.13186 0.67944,2.91189 5.14435,1.26182 29.50719,-8.05624 29.70131,-8.92981 5.43554,4.17372 1.06769,2.42658 6.3091,2.71776 0.19413,0.38826 1.65007,0.38825 1.74714,0.48531 10.19163,2.52365 -0.19413,-0.48532 0.87357,3.97959 1.94126,-0.48532 1.0677,-4.36784 0,-0.0971 -1.74714,-1.65007 2.52364,-3.10602 -1.16476,-1.45595 -3.68839,-14.26828 -0.19413,-0.97063 -0.48532,-0.29119 -0.29119,-4.27078 -0.29119,-4.65903 -0.29118,-5.04728 0,-0.29119 -0.19413,0.0971 -4.85316,-15.91835 -5.14434,-8.05624 -1.45595,-9.60924 -4.36784,-10.191633 -0.58238,0.29119 -20.28619,6.794418 -4.07665,4.367845 -4.56197,8.73568 0.19413,1.94126 -6.01791,9.12393 3.68839,1.26182 1.0677,6.89148 -4.27078,5.62967 -12.81233,7.76504 -2.42658,-0.97063 -9.51218,1.35889 -8.83275,5.33847 0.48532,2.81483 3.10602,2.71777 -1.74714,8.54155 -6.98854,8.1533 -0.0971,0.0971 z\"><title>New York</title></path><path inkscape:connector-curvature=\"0\" id=\"PA\" data-name=\"Pennsylvania\" data-id=\"PA\" d=\"m 900.01517,170.13396 -6.3091,-2.71776 -1.06769,-2.42658 -5.43554,-4.17372 -29.70131,8.92981 -29.50719,8.05624 -5.14435,-1.26182 -0.67944,-2.91189 -1.65007,1.26182 -2.6207,1.8442 -4.7561,4.85315 -0.58238,0.48532 2.71777,11.93876 0.48532,2.13539 2.42657,10.48282 0.48532,2.03832 0,0 4.27078,18.442 13.78296,-3.39721 1.94126,-0.48532 1.74714,-0.48531 6.89148,-1.8442 37.95168,-10.57988 6.89148,-2.13539 1.65008,-0.48532 0,0 0.7765,-1.94126 1.74714,-1.35888 2.32951,0 0.29119,-0.87357 3.78546,-4.27078 0.38825,-0.67944 0.29119,-0.19413 -3.78546,-9.90044 -1.8442,-0.29119 0.0971,-6.50322 -1.74714,-2.13539 4.07665,-9.02687 0,0 -0.19413,-0.38826 z\"><title>Pennsylvania</title></path><path inkscape:connector-curvature=\"0\" id=\"ME\" data-name=\"Maine\" data-id=\"ME\" d=\"m 946.7996,118.39932 -0.0971,0 0.19412,0.0971 -0.0971,-0.0971 z m 7.18267,-20.674443 -0.77651,-1.164758 0,0.582379 0.77651,0.582379 z m -1.35888,-1.067695 0,-0.970631 -0.0971,-0.582379 0.0971,1.55301 z m 3.49427,-4.076651 -0.19413,-0.09706 0.0971,0.291189 0.0971,-0.194126 z m 9.70631,-4.853156 -0.19413,-1.455947 -0.38825,0.679442 0.58238,0.776505 z m -2.42658,0.582379 0.0971,-1.067694 -1.16476,0.194126 1.06769,0.873568 z m 3.59134,-3.203083 -0.38825,0 0,0.194126 0.38825,-0.194126 z m -4.85316,1.455947 -0.87357,-0.194126 -0.0971,0.873568 0.97063,-0.679442 z m 4.95022,-3.008957 0.87357,0.679442 -0.29119,-0.776505 -0.58238,0.09706 z m -2.6207,0.09706 -0.87357,1.650073 1.16476,-0.582379 -0.29119,-1.067694 z m -4.17372,0.09706 -0.38825,0.582379 0.29119,0.873568 0.0971,-1.455947 z m 5.72673,-3.203083 -0.0971,-0.776505 -0.29119,0.485316 0.38826,0.291189 z m -0.48532,0.388253 -0.87357,-0.776505 0,0.679442 0.87357,0.09706 z m -5.43553,2.232452 -0.19413,-1.067695 -0.38825,0.873568 0.58238,0.194127 z m 9.22099,-3.39721 -1.45594,2.135389 -0.0971,-1.55301 1.55301,-0.582379 z m 7.08561,-6.503229 -0.67944,-0.970631 -0.38825,0.194126 1.06769,0.776505 z m 2.6207,-4.36784 -0.58237,-0.291189 -0.0971,0.291189 0.67944,0 z m 1.26183,-7.570923 -0.87357,0 0.97063,0.291189 -0.0971,-0.291189 z m 1.45594,0.970631 -0.29119,-1.747136 -0.7765,-0.09706 1.06769,1.8442 z m -1.55301,-1.55301 -0.19412,-1.844199 -0.67945,1.26182 0.87357,0.582379 z m -56.29661,15.23891 14.07415,33.001458 0.19413,0.67944 6.11498,7.47386 0,-0.0971 0.97063,-0.29119 0.19413,-5.5326 1.55301,-1.94126 0.97063,-5.14435 -0.87357,-0.87357 1.65007,-5.047274 5.62966,-2.620704 3.6884,-4.464904 1.35888,-7.765049 5.92085,-0.388253 -0.7765,-3.979588 7.3768,-2.81483 0.48531,-4.36784 1.74714,0.388252 4.85315,-3.979588 2.13539,-5.144345 -4.95022,-4.950219 -5.2414,-1.067695 -1.94127,-3.979588 0,-2.329515 -3.20308,0.970632 -3.59134,-1.261821 0,-3.979588 -9.70631,-20.965634 -7.0856,-3.688398 -7.86212,6.600292 -2.13539,-0.388253 -1.8442,-3.397209 -2.52364,0.970631 -3.59133,17.859614 1.26182,5.823788 1.06769,11.8417 -2.81483,9.123934 1.94126,1.455946 -2.32951,4.464904 -2.52364,-0.388253 -0.19413,0.194127 z\"><title>Maine</title></path><path inkscape:connector-curvature=\"0\" id=\"MI\" data-name=\"Michigan\" data-id=\"MI\" d=\"m 719.96309,138.2002 -0.48532,-0.77651 -0.0971,0.97063 0.58238,-0.19412 z m 1.55301,-1.74714 -1.16476,-1.55301 -0.19413,0.67944 1.35889,0.87357 z m 0.97063,-6.98854 -0.97063,-0.87357 0,0.19412 0.97063,0.67945 z m -2.42658,76.00042 12.03583,-1.94126 3.39721,-0.67944 14.85065,-2.62071 0.29119,1.26182 0.97063,-0.29119 6.40617,-1.35888 6.11498,-1.45595 6.21204,-1.55301 -0.0971,-0.29119 3.20309,-6.3091 -0.29119,-5.24141 3.59133,-9.02687 2.81483,1.65007 1.0677,-2.03832 -0.29119,-7.76505 -2.62071,-4.85316 -3.88252,-10.28869 -3.39721,-3.78546 -1.74714,-0.48531 -6.3091,4.36784 0.67944,0.87356 -3.30014,6.21204 -3.20309,-0.58238 -0.97063,-6.50322 1.35889,-0.48532 2.81483,-6.50323 0.29119,-11.45345 -4.36784,-9.70631 -9.70632,-1.65007 -0.97063,-1.45595 -9.02687,-2.6207 -4.07665,5.04728 0.38825,4.36784 -3.10602,3.88252 0.67945,6.01792 -3.00896,2.13539 0,-7.57093 -2.71777,5.72673 -3.20308,5.04728 -2.13539,1.65007 1.06769,5.33847 -1.35888,5.5326 0.77651,6.89148 -0.97064,3.39721 6.98855,13.39471 0.87357,5.14435 -0.87357,9.51218 -4.65903,10.67695 -0.58238,0.38825 z m 20.77151,-87.45387 -2.52364,0.19412 1.55301,1.16476 0.97063,-1.35888 z m -14.7536,2.52364 -0.7765,0 0.87357,0.38825 -0.0971,-0.38825 z m 16.98605,-12.32702 -0.97063,-1.55301 -0.38825,0.0971 1.35888,1.45594 z m -87.93919,7.08561 3.10602,1.74714 15.91835,4.85315 7.3768,1.94127 7.18267,0.48531 5.24141,4.27078 0,6.60029 4.65903,4.65903 0,-0.0971 3.78546,-10.96814 4.56197,-3.20308 3.49427,-3.88252 0.58238,3.49427 3.59134,-5.5326 8.63861,-3.30014 0.67945,-1.35889 8.73568,1.0677 3.39721,1.74713 1.65007,-4.27077 1.55301,0.97063 6.79442,-1.0677 -1.65008,-2.71777 -3.00895,-1.74713 0.58238,-6.3091 -5.92085,3.30014 -5.43554,-0.67944 -1.74714,-4.17371 0.58238,-1.358888 -7.37679,3.494268 -4.7561,0.29119 -8.54155,5.24141 -0.97063,1.94126 -5.24141,-1.26182 -3.30015,1.45595 -6.60029,-5.72672 -14.65653,-4.46491 -0.29119,-1.747133 -9.41512,9.026873 -5.33847,1.35888 -7.57093,5.72673 -0.29119,0.19412 z m 34.36035,-22.033327 -11.35639,5.629661 3.78546,3.688396 1.45595,-3.688396 3.88253,-4.756093 2.23245,-0.873568 z M 676.77,79.962326 l -7.76505,5.338471 -0.38825,2.620704 6.11497,-4.464903 2.03833,-3.494272 z\"><title>Michigan</title></path><path inkscape:connector-curvature=\"0\" id=\"AK\" data-name=\"Alaska\" data-id=\"AK\" d=\"m 101.28276,542.95341 -0.48532,0.19412 0.38826,0.0971 0.0971,-0.29119 z m 3.59134,0.58238 0,0 0,0.0971 0,-0.0971 z m -1.74714,-1.65008 0,0.29119 0.19413,-0.0971 -0.19413,-0.19413 z m -0.87357,-0.48531 0,-0.0971 0,0 0,0.0971 z m 1.8442,0.97063 0,-0.19413 -0.0971,0.0971 0.0971,0.0971 z m -0.19413,-0.19413 0,-0.0971 -0.19412,0 0.19412,0.0971 z m -75.709229,-63.77047 -0.09706,0.67945 0.194126,1.94126 -0.09706,-2.62071 z m -0.485315,-2.6207 0.09706,0.87357 0.09706,-0.29119 -0.194126,-0.58238 z m 76.194544,65.22642 0.0971,-0.58238 -0.38825,0.19412 0.29118,0.38826 z m 11.0652,4.75609 -0.0971,-0.0971 0.19412,0.38825 -0.0971,-0.29119 z m -7.18267,-3.39721 -1.06769,-0.97063 0,2.32951 1.06769,-1.35888 z m 2.42658,2.13539 -0.0971,-0.67944 -1.65007,-0.0971 1.74714,0.77651 z m 5.82378,1.35888 -0.0971,0.19413 0.19413,0 -0.0971,-0.19413 z m 0.38826,0.0971 -0.19413,0 0.38825,0.0971 -0.19412,-0.0971 z m 1.16475,0.38826 -0.0971,0 -0.0971,0 0.19412,0 z m -85.70673,-65.8088 0.388252,0.0971 0.29119,-0.0971 -0.679442,0 z m 83.57135,64.44991 -0.77651,-0.0971 0.29119,0.29119 0.48532,-0.19413 z m -88.812759,-72.02083 -1.358883,-0.58238 -0.09706,0.29119 1.455947,0.29119 z m 91.239329,72.21496 -0.19412,-0.0971 0,0.0971 0.19412,0 z m 5.92085,1.16476 -3.78546,0.29119 -0.87357,0.38825 4.65903,-0.67944 z m -104.05166,-88.61863 -1.067695,0 0.194127,0.29119 0.873568,-0.29119 z m 115.7963,93.08353 0,-0.38825 -0.19412,0 0.19412,0.38825 z m 5.04728,0.0971 0.19413,-0.19412 -0.19413,-0.19413 0,0.38825 z m 3.78547,1.0677 0.19412,-0.0971 -0.0971,0 -0.0971,0.0971 z m -3.10602,-1.74714 -0.0971,-0.38825 -0.19412,0 0.29119,0.38825 z m 6.50322,1.45595 -0.0971,0.0971 0.0971,0 0,-0.0971 z m -127.443872,-98.90732 -1.455946,0.19413 1.844199,1.65007 -0.388253,-1.8442 z m 122.299532,97.45137 0.19413,-0.58238 -0.0971,0 -0.0971,0.58238 z m 16.40367,-1.45594 0.0971,-0.19413 -0.19413,-0.0971 0.0971,0.29119 z m -2.42658,-0.87357 -3.39721,3.00895 2.42658,-0.19412 2.81483,-2.23245 -1.8442,-0.58238 z m 6.11498,1.06769 -0.67945,-0.19412 0.48532,0.38825 0.19413,-0.19413 z m 1.35888,0.0971 -1.0677,-0.29118 -0.19412,0.0971 1.26182,0.19412 z m -3.6884,-1.35888 -1.06769,0 1.8442,0.48532 -0.77651,-0.48532 z m 4.4649,0.97063 -0.0971,-0.19412 -0.38825,0.0971 0.48531,0.0971 z m -2.91189,-1.16476 -0.38825,-0.19412 0,1.06769 0.38825,-0.87357 z m 12.42408,2.42658 -0.0971,-0.0971 -0.19413,0 0.29119,0.0971 z m 0.19413,-0.0971 0,-0.0971 -0.19413,-0.0971 0.19413,0.19413 z m -1.65008,-0.58238 0.19413,0.38825 0,-0.0971 -0.19413,-0.29119 z m 0.87357,0 -0.87357,-0.29119 1.0677,0.77651 -0.19413,-0.48532 z m 1.26182,-0.97063 0,0 0,0.0971 0,-0.0971 z m 11.55051,1.45595 -0.19412,-0.38826 -0.0971,0 0.29119,0.38826 z m 104.43992,-6.50323 -0.19413,-0.19413 0.0971,0.19413 0.0971,0 z m -117.6405,3.00895 0,-0.0971 -0.0971,0.0971 0.0971,0 z m 120.45533,-4.75609 0.29119,0.38825 0.19413,0 -0.48532,-0.38825 z m -106.08999,7.27974 -0.0971,0.0971 0,0.29119 0.0971,-0.38825 z m -12.03583,-1.74714 0.19413,-0.77651 -0.0971,0 -0.0971,0.77651 z m 123.75548,-7.76505 -0.87357,0.48532 0.77651,0.38825 0.0971,-0.87357 z m -122.00834,7.27973 -0.0971,-0.19412 0.0971,0.19412 0,0 z m -7.27973,-2.13539 -2.42658,0.48532 -2.13539,2.81483 4.56197,-3.30015 z m 17.37429,3.6884 -0.58237,0.48532 0.58237,-0.0971 0,-0.38826 z m 111.91378,-9.31806 -0.19412,-0.38825 -0.0971,0.19413 0.29119,0.19412 z m -121.23184,6.79442 -0.67944,-0.0971 0.67944,0.67944 0,-0.58238 z m 114.82568,-5.5326 -0.19413,0.19413 0.19413,0.67944 0,-0.87357 z m -113.27267,5.43554 -0.29118,0.0971 0.38825,0.29119 -0.0971,-0.38825 z m 7.18268,2.03832 -0.29119,0 -0.19413,-0.19412 0.48532,0.19412 z m -7.95918,-2.03832 -0.48532,-0.29119 0.19413,0.29119 0.29119,0 z m 6.50323,1.06769 -0.87357,0.29119 -0.58238,1.55301 1.45595,-1.8442 z m 105.41055,-6.79441 0,0.67944 0.38825,-0.48532 -0.38825,-0.19412 z m -116.864,3.68839 0.77651,-0.19412 -0.0971,0 -0.67944,0.19412 z m -0.97063,-0.58238 -0.19413,-0.19412 0,0.0971 0.19413,0.0971 z m 117.83463,-3.78546 -0.19413,-0.0971 -0.0971,0.29119 0.29119,-0.19413 z m -106.47825,5.82379 -0.19412,-0.0971 -0.19413,0.29119 0.38825,-0.19413 z m 105.50762,-5.62966 0.0971,-0.48532 -0.19413,-0.0971 0.0971,0.58238 z m -0.77651,-0.48532 -0.29119,0.38826 0.48532,0.0971 -0.19413,-0.48532 z m -100.65445,4.7561 -0.19413,-0.19413 -0.0971,0 0.29119,0.19413 z m 100.36326,-6.50323 0.77651,0.29119 0.29119,-0.38826 -1.0677,0.0971 z m 1.16476,-0.67944 -0.29119,0.19412 0.48532,0.29119 -0.19413,-0.48531 z m -2.23245,0.58237 -0.19413,-0.38825 -0.19413,0.19413 0.38826,0.19412 z m 9.70631,-3.59133 -1.26182,3.59133 1.26182,-0.7765 0,-2.81483 z m -115.0198,7.47386 -0.0971,0 0,0 0.0971,0 z m 106.47824,-6.11498 -0.87356,0.87357 0.19412,0.97063 0.67944,-1.8442 z m -90.36576,7.76505 0,-0.38825 -0.0971,0.19413 0.0971,0.19412 z m 89.29807,-8.73568 2.81483,4.27078 6.3091,3.97959 -1.45594,-3.39721 -6.01792,-5.14435 -1.65007,0.29119 z m -93.18059,7.18267 -0.0971,-0.29119 -0.19412,0.0971 0.29119,0.19412 z m 96.48074,-8.83274 -0.38826,1.45595 0.67945,-0.48532 -0.29119,-0.97063 z m 2.03832,0 -0.0971,0.97063 0.87357,0.29119 -0.77651,-1.26182 z m -95.41305,7.57092 -0.48531,-0.0971 -0.48532,0.19413 0.97063,-0.0971 z m 9.99751,0.77651 -0.38826,0.67944 0.19413,-0.58238 0.19413,-0.0971 z m 1.45594,0.0971 -0.87357,0.0971 0.48532,0.58238 0.38825,-0.67944 z m -58.82025,-12.42408 0.97063,0.48532 -0.19412,-0.19413 -0.77651,-0.29119 z m 38.53406,9.60925 0.0971,-0.0971 -0.0971,0.0971 0,0 z m 0.29119,-0.0971 0.0971,0 0,-0.0971 -0.0971,0.0971 z m 100.36327,-7.47386 0.48531,1.8442 0.97063,-0.58238 -1.45594,-1.26182 z m -97.74257,6.40616 0.0971,-0.0971 0,0 -0.0971,0.0971 z m 93.56885,-5.62966 0.48532,4.4649 0.97063,-0.97063 -1.45595,-3.49427 z m 0.48532,-1.45595 2.23245,3.10602 -0.29119,-2.03832 -1.94126,-1.0677 z m -6.89148,0.77651 -0.58238,1.8442 0.7765,-1.26182 -0.19412,-0.58238 z m -77.6505,4.75609 -0.0971,-0.0971 0.0971,0.0971 0,0 z m 9.221,0.19413 -0.19413,-0.29119 0.19413,0.38825 0,-0.0971 z m 68.62362,-6.40617 3.88253,6.40617 -0.58238,-4.36784 -3.30015,-2.03833 z m -63.18809,3.39721 -0.29119,0.29119 0.48532,0.19413 -0.19413,-0.48532 z m -1.26182,0.19413 0.0971,-0.29119 -0.38825,0 0.29119,0.29119 z m -0.97063,0 -2.52364,1.65007 -3.10602,4.07665 1.55301,1.65008 7.18267,-5.33848 -3.10602,-2.03832 z m 61.24683,-6.3091 -0.67944,-0.38826 0,0.58238 0.67944,-0.19412 z m -61.82921,5.14434 0.0971,0.38825 0.67945,0.38826 -0.77651,-0.77651 z m 63.67341,-6.98854 -1.94126,0.97063 1.84419,0.58238 0.0971,-1.55301 z m -1.26182,0 -0.19413,-0.19413 -0.0971,0.19413 0.29119,0 z m 5.92085,-1.55301 -0.77651,-0.29119 -0.19412,0.58238 0.97063,-0.29119 z m -4.17372,0.67944 -0.67944,-0.0971 0,0.19413 0.67944,-0.0971 z m 2.13539,-0.77651 3.97959,5.82379 -1.06769,-5.33847 -2.9119,-0.48532 z m -64.06166,6.30911 -2.32951,1.74713 1.06769,1.16476 3.10602,-2.32952 -1.8442,-0.58237 z m -26.40117,-3.6884 -0.0971,-0.0971 0,0.0971 0.0971,0 z m -1.06769,-0.48532 -0.0971,-0.48531 0,0.19412 0.0971,0.29119 z m 29.79838,1.26182 -0.19413,0.0971 0,0.0971 0.19413,-0.19413 z m -0.97063,-0.19412 -0.0971,0 -0.19412,0.29119 0.29119,-0.29119 z m 2.32951,-0.77651 -0.29119,-0.19413 0,0.0971 0.29119,0.0971 z m 0.77651,-0.0971 -0.29119,-0.19413 0,0.0971 0.29119,0.0971 z m -1.26182,-0.29119 -0.38826,0 0,0.0971 0.38826,-0.0971 z m 19.31556,-1.94126 0.0971,-0.29119 -0.19413,0.19412 0.0971,0.0971 z m 5.92085,-3.10602 1.16475,-1.45595 -0.38825,0.29119 -0.7765,1.16476 z m -11.8417,-0.19413 0.38825,-0.29119 0.0971,-0.38825 -0.48531,0.67944 z m 0,-1.06769 -0.38826,0.29118 0.67945,-0.19412 -0.29119,-0.0971 z m -15.91836,0 -0.0971,-0.38826 -0.0971,0 0.19412,0.38826 z m 15.5301,-0.0971 -0.38825,0.38825 -0.19412,0.38826 0.58237,-0.77651 z m 10.67695,-1.16476 0.0971,0 0.0971,0 -0.19412,0 z m 0.48531,0 -0.19412,-0.0971 0,0.0971 0.19412,0 z m -1.16475,-0.0971 0.0971,0.0971 0,-0.0971 -0.0971,0 z m -7.95918,0.58238 0.38825,-0.38825 -0.48531,0.38825 0.0971,0 z m 5.92085,-1.16476 0,0 0,0 0,0 z m -4.75609,0.29119 -2.32952,3.78546 3.00896,-3.49427 -0.67944,-0.29119 z m -3.00896,0.48532 -0.29119,-0.38825 -0.0971,0.19412 0.38825,0.19413 z m 7.3768,-0.87357 -0.19413,-0.0971 0.0971,0.0971 0.0971,0 z m 2.52364,0.19413 0,-0.67945 -0.19413,0.29119 0.19413,0.38826 z m -71.24433,-7.47386 -4.65903,-0.19413 3.20308,3.39721 1.45595,-3.20308 z m 66.29411,6.89148 0.19413,0.67944 0.48531,-0.77651 -0.67944,0.0971 z m -3.88253,-0.0971 -0.29119,2.13539 0.48532,-1.35888 -0.19413,-0.77651 z m -84.25078,-16.11247 0.0971,-0.38826 0,0 -0.0971,0.38826 z m 83.28015,14.75359 0.0971,0.29119 0.19412,-0.0971 -0.29119,-0.19413 z m -0.48531,0.38825 -0.19413,-0.58238 -0.29119,0.19413 0.48532,0.38825 z m 4.56196,-1.16475 0,-0.38826 -0.29119,0.19413 0.29119,0.19413 z m -4.36784,-0.58238 0,0.97063 0.29119,-0.67944 -0.29119,-0.29119 z m -7.37679,-1.16476 0,-0.29119 0,0 0,0.29119 z m -50.66695,-12.03583 0.19412,-0.58238 -0.0971,0.0971 -0.0971,0.48531 z m 0.29119,-0.97063 -0.0971,-0.0971 -0.0971,0.0971 0.19413,0 z m 4.27077,-2.32951 0,-0.0971 0,0 0,0.0971 z m 0,-0.38826 -0.0971,-0.19412 0,0 0.0971,0.19412 z m 1.74714,-2.52364 0,0 -0.0971,0 0.0971,0 z m 0.58238,0.19413 -0.38825,-0.19413 0,0.0971 0.38825,0.0971 z m -0.58238,-0.38825 0,-0.19413 -0.19413,0.19413 0.19413,0 z m -15.5301,-4.56197 -0.19412,-0.48532 -0.0971,-0.29118 0.29119,0.7765 z m 1.45595,-1.74714 0.0971,0 0.0971,0.0971 -0.19412,-0.0971 z m -2.62071,-0.48531 -0.7765,-0.97063 0.58238,0.7765 0.19412,0.19413 z m -1.55301,-1.55301 -0.19412,0 0.29119,0.0971 -0.0971,-0.0971 z m 0.19413,-1.0677 0,0 0,0 0,0 z m -0.19413,-0.0971 0,0 0.19413,0.0971 -0.19413,-0.0971 z m 25.72173,7.66799 -1.06769,0.0971 0.58238,0.29119 0.48531,-0.38825 z m -26.78942,-9.41513 -0.77651,2.9119 2.42658,0.38825 3.20309,3.30015 1.94126,-0.87357 -6.79442,-5.72673 z m 16.98605,1.16476 0,-0.19412 0,0.0971 0,0.0971 z m -4.85316,-10.28869 -0.19413,-0.0971 0.0971,0.0971 0.0971,0 z m 2.81483,0.97063 0.29119,-0.0971 -0.0971,0 -0.19413,0.0971 z m 1.94126,-0.58238 0.29119,0 0.87357,-0.38825 -1.16476,0.38825 z m 3.49428,-1.06769 0.19412,-0.19413 -0.29119,0.19413 0.0971,0 z m 0.48531,-0.0971 0.58238,-0.29119 -0.48532,0.0971 -0.0971,0.19413 z m 1.45595,-0.58238 -0.48532,0.0971 0,0.0971 0.48532,-0.19412 z m 0.58238,-0.0971 0,0 0,0 0,0 z m 61.73214,-17.47136 -0.38825,-0.29119 -0.67944,-0.29119 1.06769,0.58238 z m -50.86107,-2.13539 0.87356,-1.16475 -0.48531,0.38825 -0.38825,0.7765 z m 1.16475,-1.35888 0.38826,-0.58238 -0.19413,0.19413 -0.19413,0.38825 z m 0.58238,-0.7765 0.67944,-0.58238 -0.38825,0.19412 -0.29119,0.38826 z m 30.57488,0.19412 0.48532,0.48532 0.29119,0 -0.77651,-0.48532 z m -15.62716,-6.40616 -3.97959,3.30014 -2.42657,-0.67944 -5.62966,3.20308 -1.0677,-0.67944 -6.40616,7.18267 -6.50323,1.45595 0.58237,3.49427 2.9119,3.97959 5.43553,5.24141 -0.87356,2.03832 4.07665,1.74714 -2.13539,0.38825 -2.62071,-2.03832 1.35889,3.00895 -1.74714,1.0677 -5.5326,-5.04728 -4.36784,0.7765 -7.47386,2.81483 3.39721,3.78546 -0.48531,2.32952 2.23245,2.71776 7.37679,2.9119 5.33848,-2.71777 0.87356,2.03833 -1.45594,6.11497 -4.46491,0 -5.2414,2.32952 -0.29119,-1.65008 -2.71777,1.0677 -1.26182,2.81483 -4.46491,3.39721 0,4.95022 1.74714,0.7765 -1.35888,4.17372 5.82378,5.04728 3.6884,-1.55301 -0.7765,6.21204 1.06769,1.35888 4.46491,0.97063 1.65007,1.8442 3.88252,0.29119 1.8442,1.94127 3.97959,-1.16476 -1.8442,2.52364 -1.45595,5.14434 -11.8417,7.66799 -1.55301,1.55301 -2.23245,-0.87357 -3.59133,0.87357 -5.14435,3.39721 8.05624,-2.32952 1.16476,1.74714 10.38575,-3.39721 0.29119,1.35889 4.07665,-4.07666 8.54156,-5.92085 0.67944,0.38826 7.47386,-5.92085 -1.94126,-2.32952 2.52364,-4.17371 6.60029,-7.86212 5.04728,-0.97063 1.55301,1.0677 -6.11497,1.74713 -1.65008,6.50323 0.19413,3.49428 2.13539,-0.19413 10.28869,-6.21204 0.7765,-2.32952 -0.87356,-3.59133 3.10601,0.7765 2.23246,-1.45594 6.40616,3.88252 -0.48531,1.0677 14.55946,1.8442 3.39721,-1.0677 0.97064,1.45595 12.6182,6.01791 2.13539,-1.26182 0.19413,-7.27973 1.65007,3.30014 8.1533,5.92085 0.67944,2.42658 7.08561,3.97959 1.8442,5.14434 1.74714,-3.97958 3.59133,6.98854 2.42658,-3.97959 -1.94126,-4.95022 -7.47386,-0.7765 -11.45345,-10.96813 -6.21204,-4.56197 -4.75609,4.65903 -2.81483,0 -6.50323,-4.27078 -6.40617,-0.29119 -9.12393,-57.55843 -1.55301,-2.71776 -3.6884,-2.23246 -5.5326,1.0677 -4.27078,-0.87357 -5.43553,-2.13539 -5.72673,0.38825 -1.45594,-2.71776 -4.56197,-0.67945 -0.7765,-1.65007 -2.03833,2.32952 -0.58238,-4.36784 z\"><title>Alaska</title></path></svg>"

/***/ }),

/***/ "1lot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("WZzu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_down_caret_svg__ = __webpack_require__("a5ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_down_caret_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_down_caret_svg__);








var Accordion = function Accordion(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className,
      rightContent = _ref.rightContent,
      open = _ref.open,
      onToggle = _ref.onToggle,
      locked = _ref.locked;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.Accordion, className, { 'is-open': open, 'is-locked': locked }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'header flex-space-between', onClick: onToggle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          description
        )
      ),
      !!rightContent && rightContent,
      !rightContent && !!onToggle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_down_caret_svg___default.a, className: 'down-caret-icon' })
    ),
    open && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'content' },
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),

/***/ "1obw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UIDropArea__ = __webpack_require__("o4YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_payments_Gates__ = __webpack_require__("G69f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Customize_Styling_GatedIconPicker__ = __webpack_require__("t8Ll");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("eH3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);








var customIconPickerFeatureText = "Custom Widget Images";
var customIconPlan = "Standard";

var CustomIconPicker = function CustomIconPicker(_ref) {
  var onDrop = _ref.onDrop,
      onClear = _ref.onClear,
      preview = _ref.preview,
      iconStyle = _ref.iconStyle;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_payments_Gates__["a" /* PremiumGate */],
    {
      FallbackComponent: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Customize_Styling_GatedIconPicker__["a" /* default */], { iconStyle: iconStyle }),
      useModal: true,
      modalText: customIconPickerFeatureText,
      modalPlan: customIconPlan,
      feature: 'widget-custom-icon'
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_shared_UIDropArea__["a" /* default */],
      { onDrop: onDrop, onClear: onClear, preview: preview },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'CustomIconPicker' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          'Want to add your own image?'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          'Drag and Drop or ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'link' },
            'Upload'
          )
        )
      )
    )
  );
};

CustomIconPicker.propTypes = {
  onDrop: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  onClear: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  preview: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (CustomIconPicker);

/***/ }),

/***/ "1pyT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1q/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var api = {
  fetchAssistantOrgSettings: function fetchAssistantOrgSettings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/assistant/settings/org').checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  createAssistantOrgSettings: function createAssistantOrgSettings(assistantOrgSettings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/assistant/settings/org', assistantOrgSettings).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  patchAssistantOrgSettings: function patchAssistantOrgSettings(assistantOrgSettings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].patch('/assistant/settings/org', assistantOrgSettings).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]).delayWhen(function () {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].timer(1000);
    });
  },
  fetchAssistantAgentSettings: function fetchAssistantAgentSettings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/assistant/settings/agent').checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  createAssistantAgentSettings: function createAssistantAgentSettings(assistantAgentSettings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/assistant/settings/agent', assistantAgentSettings).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  patchAssistantAgentSettings: function patchAssistantAgentSettings(assistantAgentSettings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].patch('/assistant/settings/agent', assistantAgentSettings).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"]);
  },
  fetchSalesforceSettings: function fetchSalesforceSettings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/assistant/settings/salesforce_settings').checkStatus().map(function (res) {
      return res.response;
    });
  },
  fetchPersonalizationTags: function fetchPersonalizationTags() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/assistant/settings/email_context').checkStatus().map(function (res) {
      return res.response;
    });
  },
  sendTestEmail: function sendTestEmail(taskType) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/assistant/settings/test_email', taskType).checkStatus().map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "1rl7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var UserConstants = Marty.createConstants(['USER_CREATE', 'USER_CREATE_WITH_EMAIL', 'SEND_WELCOME_EMAIL', 'USER_FETCH', 'USER_UPDATE', 'FETCH_USERS_FOR_ORG_ID', 'FETCH_CURRENT_USER', 'CHANGE_PASSWORD', 'CLEAR_PASSWORD_VALIDATION_ERRORS', 'CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL', 'CHECK_USER_EXISTENCE_BY_EMAIL', 'USER_AVATAR_UPLOAD', 'LOGOUT_USER', 'EMAIL_ALREADY_REGISTERED', 'USER_ARCHIVE', 'ARCHIVE_USERS', 'FETCH_OAUTH_CODE', 'FETCH_OAUTH_APP']);

/* harmony default export */ __webpack_exports__["a"] = (UserConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "1t2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {var TWITTER_ICON = __webpack_require__("c1G0");
var LINKEDIN_ICON = __webpack_require__("HBi2");

var Social = function Social(_ref) {
  var handle = _ref.handle,
      type = _ref.type,
      className = _ref.className;

  var primaryEl = null;

  var style = 'social-content ' + className;
  if (type === "linkedin") {
    var linkedin = 'https://linkedin.com/' + handle;
    primaryEl = React.createElement(
      'a',
      { href: linkedin, className: 'social-primary-social' },
      React.createElement('img', { src: LINKEDIN_ICON })
    );
  } else if (type === "twitter") {
    var twitterUrl = 'https://twitter.com/' + handle;
    primaryEl = React.createElement(
      'a',
      { href: twitterUrl, className: 'social-primary-social' },
      React.createElement('img', { src: TWITTER_ICON })
    );
  }

  return React.createElement(
    'span',
    { className: style },
    primaryEl
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Social);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "1uBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SegmentStatus; });
/* unused harmony export SegmentType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseSegment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var SegmentStatus = Object.freeze({
  HIDDEN: 'HIDDEN',
  ENABLED: 'ENABLED',
  ARCHIVED: 'ARCHIVED'
});

var SegmentType = Object.freeze({
  QUERY: 'QUERY',
  ID_LIST: 'ID_LIST'
});

var Segment = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  authorId: null,
  createdAt: null,
  name: 'Your Segment',
  orgId: null,
  query: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  status: SegmentStatus.ENABLED,
  type: SegmentType.ID_LIST,
  updatedAt: null
});

var parseSegment = function parseSegment(_ref) {
  var query = _ref.query,
      rest = _objectWithoutProperties(_ref, ['query']);

  return new Segment(_extends({}, rest, {
    query: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(query)
  }));
};


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+Aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return root; });
/* unused harmony export endUsersById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return makeEndUserSelector; });
/* unused harmony export makeFetchEndUserStatusSelector */
/* unused harmony export makeFetchEndUserFailedSelector */
/* unused harmony export makeFetchEndUserLoadingSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return unsubscribed; });
/* unused harmony export unsubscribedStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return unsubscribePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return unsubscribeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return unsubscribeErrorMessage; });
/* unused harmony export unsubscribedCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return unsubRequestDeleteStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resubscribed; });
/* unused harmony export resubscribedStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return resubscribePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resubscribeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resubscribeErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeEndUserForConversationIdSelector; });
/* unused harmony export makeEndUserIdFromConversationSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makeFetchEndUserForConversationIdFailedSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return followingId; });
/* unused harmony export fetchFollowingStatus */
/* unused harmony export updateFollowingStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeEndUserForConversationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCreateAttributePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activeEndUserChannels; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("bNDg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("iL8b");





var root = function root(state) {
  return state.get('endUser');
};

var endUsersById = function endUsersById(state) {
  return root(state).get('byId');
};
var fetchStatusById = function fetchStatusById(state) {
  return root(state).get('statusById');
};

var makeEndUserSelector = function makeEndUserSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([root, function (state, props) {
    return props.id;
  }], function (root, id) {
    return root.getIn(['byId', id]);
  });
};

var makeFetchEndUserStatusSelector = function makeFetchEndUserStatusSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([fetchStatusById, function (_, props) {
    return props.endUserId;
  }], function (fetchStatusById, endUserId) {
    return fetchStatusById.get(endUserId);
  });
};

var makeFetchEndUserFailedSelector = function makeFetchEndUserFailedSelector() {
  var fetchEndUserStatusSelector = makeFetchEndUserStatusSelector();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([fetchEndUserStatusSelector], function (endUserStatus) {
    return endUserStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* FETCH_END_USER_FAILED */] || endUserStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* FETCH_END_USER_LIST_FAILED */];
  });
};

var makeFetchEndUserLoadingSelector = function makeFetchEndUserLoadingSelector() {
  var fetchEndUserStatusSelector = makeFetchEndUserStatusSelector();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([fetchEndUserStatusSelector], function (endUserStatus) {
    return endUserStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* FETCH_END_USER_PENDING */] || endUserStatus === __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* FETCH_END_USER_LIST_PENDING */];
  });
};

var unsubscribed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['unsubscribed', 'value']);
});
var unsubscribedStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['unsubscribed', 'status']);
});
var unsubscribePending = function unsubscribePending(state) {
  return unsubscribedStatus(state) === __WEBPACK_IMPORTED_MODULE_3__actions__["Y" /* unsubscribePending */].toString();
};
var unsubscribeError = function unsubscribeError(state) {
  return unsubscribedStatus(state) === __WEBPACK_IMPORTED_MODULE_3__actions__["X" /* unsubscribeFailed */].toString();
};
var unsubscribeErrorMessage = function unsubscribeErrorMessage(state) {
  return root(state).getIn(['unsubscribed', 'errorMessage']);
};
var unsubscribedCount = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('unsubscribedCount');
});
var unsubRequestDeleteStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['unsubscribed', 'requestUnsubDeleteDataStatus']);
});

var resubscribed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['resubscribed', 'value']);
});
var resubscribedStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['resubscribed', 'status']);
});
var resubscribePending = function resubscribePending(state) {
  return resubscribedStatus(state) === __WEBPACK_IMPORTED_MODULE_3__actions__["R" /* resubscribePending */].toString();
};
var resubscribeError = function resubscribeError(state) {
  return resubscribedStatus(state) === __WEBPACK_IMPORTED_MODULE_3__actions__["Q" /* resubscribeFailed */].toString();
};
var resubscribeErrorMessage = function resubscribeErrorMessage(state) {
  return root(state).getIn(['resubscribed', 'errorMessage']);
};

var isFetched = function isFetched(state, props) {
  return root(state).hasIn(['byId', props.id]);
};

var makeEndUserForConversationIdSelector = function makeEndUserForConversationIdSelector() {
  var conversationSelector = __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([root, conversationSelector], function (root, conversation) {
    return conversation && root.getIn(['byId', conversation.endUserId]);
  });
};

var makeEndUserIdFromConversationSelector = function makeEndUserIdFromConversationSelector() {
  var conversationSelector = __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([conversationSelector], function (conversation) {
    return conversation && conversation.endUserId;
  });
};

var makeFetchEndUserForConversationIdFailedSelector = function makeFetchEndUserForConversationIdFailedSelector() {
  var conversationSelector = __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
  var fetchEndUserFailedSelector = makeFetchEndUserFailedSelector();

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state, props) {
    var conversation = conversationSelector(state, { conversationId: props.conversationId });
    return conversation && fetchEndUserFailedSelector(state, { endUserId: conversation.endUserId });
  }], function (fetchEndUserFailed) {
    return fetchEndUserFailed;
  });
};

var following = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('following');
});

var followingId = function followingId(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(following, function (following) {
    return following.getIn(['data', id]);
  });
};

var fetchFollowingStatus = function fetchFollowingStatus(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(following, function (following) {
    return following.getIn(['fetchFollowingState', id]);
  });
};

var updateFollowingStatus = function updateFollowingStatus(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(following, function (following) {
    return following.getIn(['updateFollowingState', id]);
  });
};

var makeEndUserForConversationId = function makeEndUserForConversationId() {
  var conversation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_selectors__["n" /* makeConversation */]();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, conversation, function (root, conversation) {
    return conversation && root.getIn(['byId', conversation.endUserId]);
  });
};

var isCreateAttributePending = function isCreateAttributePending(state, attribute) {
  return state.getIn(['endUser', 'propDefs', 'newlyCreated', attribute]) === 'PENDING';
};

var activeEndUserChannels = function activeEndUserChannels(state) {
  return root(state).get('activeEndUserChannels');
};

/***/ }),

/***/ "2+SW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchReplies; });
/* unused harmony export fetchReply */
/* unused harmony export createReply */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateReply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);



var fetchReplies = function fetchReplies() {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/snippets').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
};

var fetchReply = function fetchReply(replyId) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/snippets/' + replyId).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
};

var createReply = function createReply(reply) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/snippets', reply).checkStatus().retryWithBackoff();
};

var updateReply = function updateReply(replyId, reply) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/snippets/' + replyId, reply).checkStatus().retryWithBackoff();
};

/***/ }),

/***/ "20V9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPLOAD_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPLOAD_CSV_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPLOAD_CSV_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPLOAD_CSV_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPLOAD_CSV_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return START_CSV_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return START_CSV_IMPORT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return START_CSV_IMPORT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return START_CSV_IMPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_CSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_MAPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_COLUMN; });
/* unused harmony export RequiredOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_constantsHelper__ = __webpack_require__("Ac9J");


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_1_utils_constantsHelper__["a" /* makeConstantFactory */])('endUser/csv');

var UPLOAD_CSV = makeConstant('UPLOAD_CSV');
var UPLOAD_CSV_PENDING = makeConstant('UPLOAD_CSV_PENDING');
var UPLOAD_CSV_FAILED = makeConstant('UPLOAD_CSV_FAILED');
var UPLOAD_CSV_CANCELLED = makeConstant('UPLOAD_CSV_CANCELLED');
var UPLOAD_CSV_SUCCESS = makeConstant('UPLOAD_CSV_SUCCESS');

var START_CSV_IMPORT = makeConstant('START_CSV_IMPORT');
var START_CSV_IMPORT_PENDING = makeConstant('START_CSV_IMPORT_PENDING');
var START_CSV_IMPORT_FAILED = makeConstant('START_CSV_IMPORT_FAILED');
var START_CSV_IMPORT_SUCCESS = makeConstant('START_CSV_IMPORT_SUCCESS');

var CLEAR_CSV = makeConstant('CLEAR_CSV');
var SET_MAPPING = makeConstant('SET_MAPPING');

var SET_SELECTED = makeConstant('SET_SELECTED');
var TOGGLE_COLUMN = makeConstant('TOGGLE_COLUMN');

var RequiredOptions = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(['email', 'user_id']);

/***/ }),

/***/ "21sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchParticipantsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchParticipantsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchParticipantsCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addParticipantsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addParticipantsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addParticipantsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return removeParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return removeParticipantsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return removeParticipantsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return removeParticipantsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return setModalVisibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("At/u");



var fetchParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_PARTICIPANTS */]);
var fetchParticipantsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_PARTICIPANTS_PENDING */]);
var fetchParticipantsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_PARTICIPANTS_FAILED */]);
var fetchParticipantsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_PARTICIPANTS_CANCELLED */]);
var receiveParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* RECEIVE_PARTICIPANTS */]);

var addParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ADD_PARTICIPANTS */]);
var addParticipantsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ADD_PARTICIPANTS_PENDING */]);
var addParticipantsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ADD_PARTICIPANTS_FAILED */]);
var addParticipantsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ADD_PARTICIPANTS_SUCCESS */]);

var removeParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* REMOVE_PARTICIPANTS */]);
var removeParticipantsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* REMOVE_PARTICIPANTS_PENDING */]);
var removeParticipantsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* REMOVE_PARTICIPANTS_FAILED */]);
var removeParticipantsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* REMOVE_PARTICIPANTS_SUCCESS */]);

var setModalVisibility = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SET_MODAL_VISIBILITY */]);

/***/ }),

/***/ "2712":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("+8Qt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demodata__ = __webpack_require__("miXC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("tHDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var fetchRevealDataByIp = function fetchRevealDataByIp(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* fetchRevealDataByIp */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref2) {
    var ip = _ref2.ip;

    if (__WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      return __WEBPACK_IMPORTED_MODULE_3__demodata__["a" /* demoReveal */].map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* fetchRevealDataByIpSuccess */]({ data: data, ip: ip });
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchRevealDataByIp(ip).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* fetchRevealDataByIpCancelled */]({ ip: ip }))).map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* fetchRevealDataByIpSuccess */]({ data: data, ip: ip });
      }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* fetchRevealDataByIpPending */]({ ip: ip })).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* fetchRevealDataByIpFailed */]({ error: error, ip: ip }));
      });
    }
  });
};

var fetchRevealData = function fetchRevealData(action$, _ref3) {
  var getState = _ref3.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* fetchRevealData */].toString()).pluck('payload').mergeMap(function (revealOptions) {
    if (__WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      return __WEBPACK_IMPORTED_MODULE_3__demodata__["a" /* demoReveal */].map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchRevealDataSuccess */](_extends({ data: data }, revealOptions));
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchRevealData(revealOptions).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchRevealDataCancelled */]())).map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchRevealDataSuccess */](_extends({ data: data }, revealOptions));
      }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchRevealDataPending */]()).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchRevealDataFailed */]({ error: error, revealOptions: revealOptions }));
      });
    }
  });
};

var fetchRevealDataBySourceProperties = function fetchRevealDataBySourceProperties(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchRevealDataBySourceProperties */].toString()).pluck('payload').mergeMap(function (revealOptions) {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchDriftContactDerivationByEndUserId(revealOptions).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchRevealDataCancelled */]())).map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchRevealDataSuccess */](_extends({ data: data }, revealOptions));
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* fetchRevealDataBySourcePropertiesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchRevealDataFailed */]({ error: error, revealOptions: revealOptions }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetchRevealData, fetchRevealDataByIp, fetchRevealDataBySourceProperties);

/***/ }),

/***/ "27RM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return classifications; });
/* unused harmony export isLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return classificationOptions; });
/* unused harmony export classificationListOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);


var root = function root(state) {
  return state.get('classification');
};

var classifications = function classifications(state) {
  return root(state).get('classifications');
};

var status = function status(state) {
  return root(state).get('status');
};
var isLoading = function isLoading(state) {
  return status(state).get('loading', false);
};
var isLoaded = function isLoaded(state) {
  return status(state).get('loaded', false);
};

var classificationOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(classifications, function (classifications) {
  return classifications.map(function (classification) {
    return { label: classification.name, value: classification.id };
  }).toJS();
});

var classificationListOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(classifications, function (classifications) {
  return classifications.map(function (classification) {
    return { id: classification.id, color: 'EFEEFC', status: 'ENABLED', name: classification.name };
  }).reduce(function (result, classification) {
    return result.set(classification.id, classification);
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});

/***/ }),

/***/ "288j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"header---23dwT"};

/***/ }),

/***/ "2AqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__("/g2I");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("4VmE");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("JzR3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("MSOi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });









/***/ }),

/***/ "2AxG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var companyData = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([{
  "registry_company_name": "Level 3 Communications",
  "registry_city": "San Francisco",
  "registry_state": "CA",
  "registry_zip_code": "94108",
  "registry_area_code": 415,
  "registry_dma_code": 807,
  "registry_country": "United States",
  "registry_country_code": "US",
  "registry_country_code3": "USA",
  "registry_latitude": 37.791500091552734,
  "registry_longitude": -122.40889739990234,
  "company_name": "Demandbase Inc",
  "demandbase_sid": 3415304,
  "marketing_alias": "Demandbase",
  "industry": "Software & Technology",
  "sub_industry": "Software Applications",
  "employee_count": 200,
  "isp": false,
  "primary_sic": "7372",
  "primary_naics": null,
  "street_address": "680 Folsom St Suite 400",
  "city": "San Francisco",
  "state": "CA",
  "zip": "94107",
  "country": "US",
  "country_name": "United States",
  "phone": "415-683-2660",
  "stock_ticker": null,
  "web_site": "demandbase.com",
  "annual_sales": 40000000,
  "revenue_range": "$25M - $50M",
  "employee_range": "Mid-Market",
  "b2b": true,
  "b2c": false,
  "traffic": "Medium",
  "latitude": 37.7894,
  "longitude": -122.394,
  "fortune_1000": false,
  "forbes_2000": false,
  "information_level": "Detailed",
  "audience": "SMB",
  "audience_segment": "Software & Technology",
  "watch_list": {
    "Group_Id": "362",
    "Is_Primary": "1",
    "account_id": "001AL",
    "ao": "Brian",
    "mdr": "Leah",
    "asr": "Brian",
    "csm": "Anthony",
    "account_type": "Customer",
    "partner_owner": null,
    "demandbase_qualification_score": null,
    "ae_top_30": null
  },
  "access_type": "remote",
  "ip": "69.181.105.169",
  "region_name": "California"
}]);

/***/ }),

/***/ "2B9T":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(483);

/***/ }),

/***/ "2BXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmptyActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DriftActivityType; });
var EmptyActivity = {
  marketoName: null,
  marketoId: null,
  activityType: null
};

var DriftActivityType = {
  SYNC_CONVERSATIONS: 'SYNC_CONVERSATIONS',
  SYNC_MEETINGS: 'SYNC_MEETINGS',
  SYNC_CQL_SCORE: 'SYNC_CQL_SCORE'
};

/***/ }),

/***/ "2ERK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateHrefs; });
/* unused harmony export fetchCards */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCardSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCardFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("AO70");



var updateHrefs = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* UPDATE_HREFS */]);
var fetchCards = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_CARDS */]);
var fetchCard = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_CARD */]);
var fetchCardSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_CARD_SUCCESS */]);
var fetchCardFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_CARD_FAILURE */]);

/***/ }),

/***/ "2Est":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__ = __webpack_require__("ySI2");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var UserPropertiesStore = Marty.createStore({
  id: 'UserPropertiesStore',

  getInitialState: function getInitialState() {
    return {
      settingsByUserId: {},
      userPropertiesUpdateState: {}
    };
  },


  handlers: {
    fetchSettingsDone: __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].FETCH_USER_PROPERTIES_DONE,
    updateSettingsDone: __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_DONE
  },

  updateUserProperties: function updateUserProperties(userId, settings) {
    this.app.actions.UserPropertiesActions.updateProperties(userId, settings);
    var userPropertiesUpdateState = _.cloneDeep(this.state.userPropertiesUpdateState);
    userPropertiesUpdateState[userId] = __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_STARTING;
    return this.setState({ userPropertiesUpdateState: userPropertiesUpdateState });
  },
  setSettingForUserId: function setSettingForUserId(userId, settings) {
    var settingsByUserId = _.cloneDeep(this.state.settingsByUserId);
    settingsByUserId[userId] = settings;
    return this.setState({ settingsByUserId: settingsByUserId });
  },
  fetchSettingsDone: function fetchSettingsDone(userId, settings) {
    return this.setSettingForUserId(userId, settings);
  },
  updateSettingsDone: function updateSettingsDone(userId, settings) {
    this.setSettingForUserId(userId, settings);
    var userPropertiesUpdateState = _.cloneDeep(this.state.userPropertiesUpdateState);
    userPropertiesUpdateState[userId] = __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_DONE;
    return this.setState({ userPropertiesUpdateState: userPropertiesUpdateState });
  },
  getUserPropertiesUpdateState: function getUserPropertiesUpdateState() {
    return this.state.userPropertiesUpdateState;
  },


  defaultUserProperties: {
    'humane-notifications-browser': 'mine',
    'humane-notifications-browser-with-sound': true,
    'humane-notifications-push': 'mine',
    'humane-notifications-push-with-sound': true,
    'humane-notifications-email': 'mine'
  },

  fetchPropertiesForUser: function fetchPropertiesForUser(userId) {
    return this.fetch({
      id: 'fetchPropertiesForUser' + userId,
      locally: function locally() {
        var properties = this.state.settingsByUserId[userId];

        if (!properties) {
          return;
        }

        return _.defaults(properties, this.defaultUserProperties);
      },
      remotely: function remotely() {
        return this.app.queries.UserPropertiesQueries.fetchProperties(userId);
      }
    });
  },
  fetchPropertiesForCurrentUser: function fetchPropertiesForCurrentUser() {
    return this.fetch({
      id: 'fetchPropertiesForCurrentUser',
      dependsOn: this.app.stores.UserStore.getOrFetchCurrentUser(),
      locally: function locally() {
        var properties = this.state.settingsByUserId[this.app.stores.UserStore.getCurrentUser().id];

        if (!properties) {
          return;
        }

        return _.defaults(properties, this.defaultUserProperties);
      },
      remotely: function remotely() {
        return this.app.queries.UserPropertiesQueries.fetchProperties(this.app.stores.UserStore.getCurrentUser().id);
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserPropertiesStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "2FY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OutboundSendFrom":"OutboundSendFrom---ga98w"};

/***/ }),

/***/ "2Fuj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MultiSegmentSelect":"MultiSegmentSelect---6ANJ8","SegmentSelect":"SegmentSelect---2q6z2"};

/***/ }),

/***/ "2GLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetingOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("6Ni/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var TargetingOption = function TargetingOption(_ref) {
  var iconSrc = _ref.iconSrc,
      isSelected = _ref.isSelected,
      handleClick = _ref.handleClick,
      label = _ref.label,
      description = _ref.description;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-targeting-choice-card', { selected: isSelected }), onClick: handleClick },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: iconSrc }),
    React.createElement(
      'div',
      { className: 'playbook-targeting-choice-meta' },
      React.createElement(
        'div',
        { className: 'playbook-targeting-choice-label' },
        label
      ),
      React.createElement(
        'div',
        { className: 'playbook-targeting-choice-description' },
        description
      )
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "2JjV":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 24 18\"><path d=\"M23.038,15.353 C22.575,16.383 21.385,17.315 20.268,17.522 C20.160,17.541 17.598,18.000 12.005,18.000 L11.990,18.000 C6.398,18.000 3.837,17.541 3.730,17.522 C2.609,17.315 1.419,16.382 0.959,15.351 C0.920,15.264 -0.000,13.166 -0.000,9.000 C-0.000,4.834 0.920,2.735 0.960,2.646 C1.420,1.616 2.611,0.684 3.730,0.478 C3.837,0.459 6.398,-0.000 11.990,-0.000 C17.598,-0.000 20.160,0.459 20.267,0.478 C21.383,0.683 22.574,1.615 23.038,2.646 C23.077,2.733 23.998,4.834 23.998,9.000 C23.998,13.166 23.077,15.266 23.038,15.353 ZM21.209,3.460 C21.018,3.036 20.371,2.531 19.905,2.445 C19.882,2.441 17.382,2.000 12.005,2.000 C6.613,2.000 4.115,2.441 4.091,2.445 C3.624,2.531 2.978,3.035 2.786,3.464 C2.780,3.477 2.001,5.313 2.001,9.000 C2.001,12.686 2.780,14.522 2.788,14.540 C2.977,14.964 3.625,15.468 4.093,15.555 C4.115,15.559 6.613,16.000 11.990,16.000 L12.005,16.000 C17.382,16.000 19.882,15.559 19.906,15.555 C20.371,15.469 21.019,14.963 21.212,14.534 C21.217,14.522 21.997,12.686 21.997,9.000 C21.997,5.313 21.217,3.477 21.209,3.460 ZM10.502,12.857 C10.344,12.952 10.165,13.000 9.987,13.000 C9.817,13.000 9.647,12.957 9.494,12.870 C9.180,12.692 8.987,12.360 8.987,12.000 L8.987,6.000 C8.987,5.640 9.180,5.308 9.494,5.130 C9.807,4.952 10.192,4.957 10.502,5.143 L15.506,8.142 C15.807,8.323 15.992,8.649 15.992,9.000 C15.992,9.351 15.807,9.677 15.506,9.857 L10.502,12.857 Z\" class=\"cls-1\"></path></svg>"

/***/ }),

/***/ "2MPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bannedIPs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bannedIPStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("Cb8u");
var _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var bannedIPs = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* fetchBannedIPsSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* banIPSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* unbanIPSuccess */]), function (state, action) {
  return state.set('ips', action.payload);
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var bannedIPStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* fetchBannedIPsFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* fetchBannedIPsPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* fetchBannedIPsSuccess */]), function (state, action) {
  return state.setIn(['status', 'fetch'], action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* banIPFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* banIPPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* banIPSuccess */]), function (state, action) {
  return state.setIn(['status', 'ban'], action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* unbanIPFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* unbanIPPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* unbanIPSuccess */]), function (state, action) {
  return state.setIn(['status', 'unban'], action.type);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

/***/ }),

/***/ "2MvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var ModalData = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  title: "",
  description: "",
  confirm: "Yes, Continue",
  buttonProps: {},
  onConfirm: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.noop,
  onCancel: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.noop
});

/***/ }),

/***/ "2OsS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2Pw7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Logout = function (_Component) {
  _inherits(Logout, _Component);

  function Logout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Logout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Logout.__proto__ || Object.getPrototypeOf(Logout)).call.apply(_ref, [this].concat(args))), _this), _this.removeServiceWorkers = function () {
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        return navigator.serviceWorker.getRegistrations().then(function (registrations) {
          return Promise.all(registrations.map(function (registration) {
            return registration.unregister().catch(function (err) {
              return console.error('Unable to unsubscribe service worker', registration, err);
            });
          }));
        });
      } else {
        return Promise.resolve();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Logout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var params = new URLSearchParams(window.location.search);
      var timeout = params.get("timeout") === "true";
      this.removeServiceWorkers().then(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */], timeout);
      }).catch(function (err) {
        console.error('Unable to unregister service worker', err);
        Object(__WEBPACK_IMPORTED_MODULE_1__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */]);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return Logout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Logout);

/***/ }),

/***/ "2RWv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2XIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Button__ = __webpack_require__("1iW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_MessagePreviews_WelcomeMessage_WelcomeMessageBuilder__ = __webpack_require__("Oe5r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Editor__ = __webpack_require__("eJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MessageCta__ = __webpack_require__("K2hD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OutboundSendFrom__ = __webpack_require__("+YfV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ABMSendFrom__ = __webpack_require__("nhTC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_api__ = __webpack_require__("a5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl__ = __webpack_require__("2FY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ramda__ = __webpack_require__("ivXw");


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




























var fetchVideoEmbed = function fetchVideoEmbed(videoUrlInput, _ref) {
  var setVideoUrl = _ref.setVideoUrl,
      setVideoEmbed = _ref.setVideoEmbed;

  return Object(__WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_api__["e" /* getIframelyVideoEmbed */])(videoUrlInput).then(function (data) {
    // only persist valid video url's to redux
    if (data.isValid) {
      setVideoUrl(data.url);
    } else {
      setVideoUrl(null);
    }

    setVideoEmbed(!Object(__WEBPACK_IMPORTED_MODULE_19_ramda__["isNil"])(data.embed) ? data.embed : null);
  });
};

var validateUrl = function () {
  var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(videoUrlInput, _ref3) {
    var setVideoUrlInput = _ref3.setVideoUrlInput,
        setVideoUrl = _ref3.setVideoUrl,
        setVideoEmbed = _ref3.setVideoEmbed;
    var urlIsEligibleForEmbedCheck;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // only perform check if url has changed
            urlIsEligibleForEmbedCheck = Object(__WEBPACK_IMPORTED_MODULE_18_validator__["isURL"])(videoUrlInput);

            if (!urlIsEligibleForEmbedCheck) {
              _context.next = 12;
              break;
            }

            _context.prev = 2;
            _context.next = 5;
            return fetchVideoEmbedDebounced(videoUrlInput, { setVideoUrl: setVideoUrl, setVideoEmbed: setVideoEmbed });

          case 5:
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](2);

            console.warn('Failed to fetch embed for ' + videoUrlInput);

          case 10:
            _context.next = 14;
            break;

          case 12:
            // reset video url in redux because the current input is invalid
            setVideoUrl(null);
            setVideoEmbed(null);

          case 14:

            // set local state of video url input text
            setVideoUrlInput(videoUrlInput);

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[2, 7]]);
  }));

  return function validateUrl(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var handleVideoUrlChange = function handleVideoUrlChange(event, handlers) {
  var value = event.target.value;
  validateUrl(value, handlers);
};

var fetchVideoEmbedDebounced = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function (value, handlers) {
  return fetchVideoEmbed(value, handlers);
}, 1000);

var WelcomeMessage = function WelcomeMessage(_ref4) {
  var backgroundColor = _ref4.backgroundColor,
      foregroundColor = _ref4.foregroundColor,
      selectedUser = _ref4.selectedUser,
      message = _ref4.message,
      onMessageChange = _ref4.onMessageChange,
      videoEmbed = _ref4.videoEmbed,
      videoUrlInput = _ref4.videoUrlInput,
      setVideoUrlInput = _ref4.setVideoUrlInput,
      videoCutoverStatus = _ref4.videoCutoverStatus,
      onUserIdChange = _ref4.onUserIdChange,
      cta = _ref4.cta,
      isOutboundPlaybook = _ref4.isOutboundPlaybook,
      isABMPlaybook = _ref4.isABMPlaybook,
      usersWithExtension = _ref4.usersWithExtension,
      isOutreachConnected = _ref4.isOutreachConnected,
      setVideoEmbed = _ref4.setVideoEmbed,
      _ref4$actions = _ref4.actions,
      showExtensionInviteModal = _ref4$actions.showExtensionInviteModal,
      setVideoUrl = _ref4$actions.setVideoUrl;

  var sendFromComponent = function sendFromComponent() {
    return isABMPlaybook ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ABMSendFrom__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__OutboundSendFrom__["a" /* default */], {
      isOutreachConnected: isOutreachConnected,
      usersWithExtension: usersWithExtension,
      onEditClick: showExtensionInviteModal
    });
  };

  var isVideoUrlInputValid = function isVideoUrlInputValid() {
    return !Object(__WEBPACK_IMPORTED_MODULE_19_ramda__["isNil"])(videoEmbed) || videoUrlInput === '';
  };

  var buildDescription = function buildDescription() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      !isVideoUrlInputValid() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'video-url-input-description-invalid' },
        'Whoops, looks like you\'ve added an invalid link!'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'video-url-input-description left' },
          'Embed a video in your welcome message to engage site visitors!'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__["ToolTip"],
          {
            flow: 'up',
            component: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              'We support video URLs from Youtube, Vimeo, ViewdIt, Vidyard, Vidyard GoVideo, Wistia, Giphy, thehippovideo, and Hyfy'
            ),
            className: 'overwrite-info-button' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__["Icon"], { className: 'video-url-input-description tooltip-icon', width: 15, height: 15, name: 'info' })
        )
      )
    );
  };

  var videoEmbedWithTitle = message + ' ' + (!Object(__WEBPACK_IMPORTED_MODULE_19_ramda__["isNil"])(videoEmbed) ? videoEmbed : '');

  var handleVideoUrlChangeEvent = function handleVideoUrlChangeEvent(event) {
    return handleVideoUrlChange(event, { setVideoUrlInput: setVideoUrlInput, setVideoUrl: setVideoUrl, setVideoEmbed: setVideoEmbed, videoUrlInput: videoUrlInput });
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'playbook-message' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'header',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'h2',
        null,
        isOutboundPlaybook || isABMPlaybook ? 'Customize the message your users will see.' : 'Create a Welcome Message'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'p',
        null,
        'What do you want to say? Keep it short and sweet, be personal and human!'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Card__["a" /* default */],
      { title: 'Welcome Message', className: 'drift-form', hideDescription: true },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'playbook-message-preview' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_components_shared_MessagePreviews_WelcomeMessage_WelcomeMessageBuilder__["a" /* default */],
          {
            backgroundColor: backgroundColor,
            foregroundColor: foregroundColor,
            showProfileIcon: true,
            users: __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of(selectedUser),
            title: Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(selectedUser),
            message: videoEmbedWithTitle,
            isHTMLPreview: true,
            callToAction: cta
          },
          cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'playbook-welcome-message-composer' },
            'Type your message...'
          ),
          (cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING || cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].URL) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Button__["a" /* default */],
            {
              className: 'playbook-welcome-message-button',
              block: true,
              hollow: true,
              brandPrimary: backgroundColor,
              style: { borderWidth: '0px' }
            },
            cta.copy
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Welcome Message Copy'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Editor__["a" /* default */], { value: message, onChange: onMessageChange }),
      videoCutoverStatus && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__["Input"], {
        placeholder: 'eg. https://www.youtube.com/watch?v=3028oDEKZo4',
        label: 'Video URL (optional)',
        value: videoUrlInput,
        type: 'text',
        className: __WEBPACK_IMPORTED_MODULE_15_classnames___default()('playbook-edit-message-heading', { 'video-url-input-invalid': isVideoUrlInputValid() }),
        onChange: function onChange(event) {
          return handleVideoUrlChangeEvent(event);
        },
        size: 'large',
        description: buildDescription()
      }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Send From'
      ),
      isOutboundPlaybook || isABMPlaybook ? sendFromComponent() : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_UserSelect__["a" /* default */], {
        selectedUserId: selectedUser ? selectedUser.id : null,
        includeRandom: true,
        restrictCalendarUsers: cta && cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING ? false : cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT ? true : false,
        excludeBot: cta && cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING,
        onUserIdChange: onUserIdChange
      }),
      !isOutboundPlaybook && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__MessageCta__["a" /* default */], { hideCopy: cta.type === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT, isABMPlaybook: isABMPlaybook })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (WelcomeMessage);

/***/ }),

/***/ "2cpB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");


var RuleLink = function RuleLink(_ref) {
  var rule = _ref.rule;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
    { to: '/settings/rules/' + rule.id },
    rule.name
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "2g0C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2lG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus_dist_react_select_plus_css__ = __webpack_require__("/XUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus_dist_react_select_plus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_select_plus_dist_react_select_plus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("ZAIb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.






var SelectWrapper = function SelectWrapper(props) {
  var className = __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.SelectWrapper;
  return React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_select_plus__["b" /* default */], _.extend({ className: className }, props));
};

SelectWrapper.displayName = 'SelectWrapper';

/* harmony default export */ __webpack_exports__["a"] = (SelectWrapper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "2m6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__ = __webpack_require__("W8CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_queries_DefaultEmbedQueries__ = __webpack_require__("TSCa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var DefaultEmbedStore = Marty.createStore({
  id: 'DefaultEmbedStore',

  getInitialState: function getInitialState() {
    return {
      embedByOrgId: {},
      patchStatus: null
    };
  },


  handlers: {
    fetchDefaultEmbedDone: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_FETCH_DONE,
    patchDefaultEmbedDone: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_DONE,
    refreshDefaultEmbedDone: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_REFRESH_DONE,
    updateDefaultEmbed: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].UPDATE_CURRENT_EMBED,
    patchDefaultEmbedFailed: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_FAILED,
    patchDefaultEmbedStart: __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_START
  },

  updateDefaultEmbed: function updateDefaultEmbed(update, message) {
    var currentOrgId = this.app.stores.OrgStore.getCurrentOrg().id;
    var operations = Object(__WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__["a" /* patchOperations */])(update, this.state.embedByOrgId[currentOrgId].configuration);
    if (!_.isEmpty(operations)) {
      return this.app.queries.DefaultEmbedQueries.patchDefaultEmbed(operations, message);
    }
  },
  getOrFetchCurrentDefaultEmbed: function getOrFetchCurrentDefaultEmbed() {
    return this.fetch({
      id: 'fetchDefaultEmbed',
      dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
      locally: function locally() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        if (this.hasAlreadyFetched('fetchDefaultEmbed')) {
          return this.state.embedByOrgId[orgId];
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.DefaultEmbedQueries.fetchDefaultEmbed(orgId);
      }
    });
  },
  getCurrentDefaultEmbed: function getCurrentDefaultEmbed(orgId) {
    return this.state.embedByOrgId[orgId];
  },
  getLogoUrl: function getLogoUrl() {
    return this.fetch({
      id: 'getLogoUrl',
      dependsOn: [this.getOrFetchCurrentDefaultEmbed()],
      locally: function locally() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return (this.state.embedByOrgId[orgId].configuration.theme != null ? this.state.embedByOrgId[orgId].configuration.theme.logoUrl : undefined) || '';
      }
    });
  },
  getDefaultEmbedForOrgId: function getDefaultEmbedForOrgId(orgId) {
    return this.fetch({
      id: 'getDefaultEmbedForOrgId' + orgId,
      locally: function locally() {
        if (this.hasAlreadyFetched('getDefaultEmbedForOrgId' + orgId)) {
          return this.state.embedByOrgId[orgId];
        }
      },
      remotely: function remotely() {
        return this.app.queries.DefaultEmbedQueries.fetchDefaultEmbed(orgId);
      }
    });
  },
  getPatchStatus: function getPatchStatus() {
    return this.state.patchStatus;
  },
  patchDefaultEmbedStart: function patchDefaultEmbedStart() {
    return this.state.patchStatus = 'PENDING';
  },
  fetchDefaultEmbedDone: function fetchDefaultEmbedDone(orgId, embed) {
    return this.updateEmbed(orgId, embed);
  },
  patchDefaultEmbedDone: function patchDefaultEmbedDone(embed) {
    this.updateEmbed(embed.orgId, embed);
    return this.state.patchStatus = 'DONE';
  },
  patchDefaultEmbedFailed: function patchDefaultEmbedFailed(embed) {
    this.updateEmbed(embed.orgId, embed);
    return this.state.patchStatus = 'DONE';
  },
  refreshDefaultEmbedDone: function refreshDefaultEmbedDone(embed) {
    return this.updateEmbed(embed.orgId, embed);
  },
  updateEmbed: function updateEmbed(orgId, embed) {
    var embedByOrgId = _.cloneDeep(this.state.embedByOrgId);
    embedByOrgId[orgId] = embed;
    return this.setState({ embedByOrgId: embedByOrgId });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (DefaultEmbedStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "2oiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Editor__ = __webpack_require__("eJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ActionError__ = __webpack_require__("euoy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Action__ = __webpack_require__("hgXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("o9mc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_minus_svg__ = __webpack_require__("3iND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_minus_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var LEADBOT_QUALIFIED_OPTION = {
  label: 'LeadBot Qualified',
  value: 'LEADBOT_QUALIFIED'
};

var Goal = function (_React$Component) {
  _inherits(Goal, _React$Component);

  function Goal() {
    _classCallCheck(this, Goal);

    return _possibleConstructorReturn(this, (Goal.__proto__ || Object.getPrototypeOf(Goal)).apply(this, arguments));
  }

  _createClass(Goal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          goal = _props.goal,
          classificationDetails = _props.classificationDetails,
          classificationOptions = _props.classificationOptions,
          onClassificationChange = _props.onClassificationChange,
          onNewClassificationClick = _props.onNewClassificationClick,
          onMessageActionBodyChange = _props.onMessageActionBodyChange,
          onAddActionClick = _props.onAddActionClick,
          onEditActionClick = _props.onEditActionClick,
          onDeleteActionClick = _props.onDeleteActionClick,
          onGoalDeleteClick = _props.onGoalDeleteClick,
          onEditRoutingClick = _props.onEditRoutingClick,
          isGlobalRouting = _props.isGlobalRouting,
          isSingleRouting = _props.isSingleRouting,
          isGroupRouting = _props.isGroupRouting,
          isNoRouting = _props.isNoRouting,
          isMessage = _props.isMessage,
          isCQL = _props.isCQL,
          isScheduling = _props.isScheduling,
          isStatusChange = _props.isStatusChange,
          isLastGoal = _props.isLastGoal,
          singleRoutingTargetUser = _props.singleRoutingTargetUser,
          groupRoutingTargetUsers = _props.groupRoutingTargetUsers,
          usersForRules = _props.usersForRules,
          singleRoutingInvalidUsers = _props.singleRoutingInvalidUsers,
          globalRoutingInvalidUsers = _props.globalRoutingInvalidUsers,
          isCaptureTypePlaybook = _props.isCaptureTypePlaybook,
          isCtaTypePlaybook = _props.isCtaTypePlaybook,
          isChatTypePlaybook = _props.isChatTypePlaybook,
          isOutboundPlaybook = _props.isOutboundPlaybook,
          isABMPlaybook = _props.isABMPlaybook,
          hasRoutingAction = _props.hasRoutingAction,
          isMeetingCta = _props.isMeetingCta,
          cqlScore = _props.cqlScore,
          copy = _props.copy;


      var defaultClassificationOption = !!classificationDetails ? classificationOptions.find(function (c) {
        return c.value === classificationDetails.value;
      }) || LEADBOT_QUALIFIED_OPTION : _.head(classificationOptions);
      var groupRoutingDisplayUsers = groupRoutingTargetUsers ? Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(groupRoutingTargetUsers.slice(0, 8)) : Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])();
      var numRoutingUsersLeft = groupRoutingTargetUsers ? Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(groupRoutingTargetUsers).size - groupRoutingDisplayUsers.size : 0;

      return React.createElement(
        'div',
        { key: goal.id, className: __WEBPACK_IMPORTED_MODULE_11__style_styl___default.a.Goal },
        React.createElement(
          'header',
          { className: 'playbook-title-header' },
          React.createElement(
            'h2',
            null,
            'Create a Goal for this Playbook.'
          ),
          React.createElement(
            'p',
            null,
            copy
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_10__Card__["a" /* default */],
          {
            className: 'drift-form goal-card',
            title: 'Goal',
            description: _.get(classificationDetails, 'label', '...'),
            onDeleteClick: !isLastGoal && onGoalDeleteClick
          },
          React.createElement(
            'div',
            { className: 'goal-action goal-classification-content' },
            React.createElement(
              'div',
              { className: 'goal-action-label' },
              'What is the Lead Stage tied to this goal?'
            ),
            React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["a" /* Creatable */], {
              placeholder: 'Enter Lead Stage (required)',
              value: defaultClassificationOption,
              options: classificationOptions,
              onChange: onClassificationChange,
              onNewOptionClick: onNewClassificationClick,
              clearable: false,
              valueRenderer: function valueRenderer(option) {
                return React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Tag___default.a, { className: 'classification-tag', tag: { name: option.label } });
              }
            })
          ),
          isCtaTypePlaybook && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'What criteria should trigger this goal?' },
            'Lead clicked CTA'
          ),
          (isChatTypePlaybook || isOutboundPlaybook || isABMPlaybook) && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'What criteria should trigger this goal?' },
            'Lead starts a Conversation'
          ),
          isCaptureTypePlaybook && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'What criteria should trigger this goal?' },
            'Submitted Email'
          ),
          isABMPlaybook && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Route Conversation' },
            React.createElement(
              'p',
              null,
              'This conversation will route to Account Owner for this contact.',
              React.createElement('br', null),
              React.createElement(
                'a',
                { href: '/accounts' },
                'View your team\'s accounts'
              )
            )
          ),
          isOutboundPlaybook && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Route Conversation' },
            React.createElement(
              'p',
              null,
              'This conversation will route to the teammate who sent the Drift Tracked email'
            )
          ),
          isMeetingCta && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Route Conversation' },
            React.createElement(
              'p',
              null,
              'Routing for the purpose of scheduling meetings is available with ',
              React.createElement(
                'a',
                { href: '/marketplace/playbooks/BOOK_MORE_MEETINGS', target: '_blank' },
                'DriftBot'
              )
            )
          ),
          !isOutboundPlaybook && !isABMPlaybook && !isMeetingCta && hasRoutingAction && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Route Conversation', onEditClick: onEditRoutingClick },
            isNoRouting && React.createElement(
              'p',
              null,
              'none -',
              ' ',
              React.createElement(
                'span',
                { className: 'edit-routing-rules-link', onClick: onEditRoutingClick },
                'set up now'
              )
            ),
            isSingleRouting && !!singleRoutingTargetUser && React.createElement(
              'div',
              { className: 'flex' },
              singleRoutingTargetUser.avatarUrl && React.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: singleRoutingTargetUser }),
              React.createElement(
                'p',
                null,
                singleRoutingTargetUser.name
              )
            ),
            isGlobalRouting && React.createElement(
              'div',
              null,
              React.createElement(
                'p',
                null,
                'Route lead based on your Lead Routing rules.'
              ),
              React.createElement(
                'div',
                { className: 'flex' },
                usersForRules && usersForRules.map(function (user) {
                  return user && React.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Avatar__["a" /* default */], { key: user, size: 'small', user: user });
                })
              )
            ),
            isGroupRouting && React.createElement(
              'div',
              { className: 'flex' },
              React.createElement(
                'p',
                { className: 'routing-option-title' },
                'Round robin between: '
              ),
              React.createElement(
                'div',
                { className: 'flex routing-option-value-container' },
                groupRoutingTargetUsers && groupRoutingDisplayUsers.map(function (user) {
                  return user && React.createElement(
                    'div',
                    { key: user, className: 'flex routing-option' },
                    React.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user })
                  );
                }),
                numRoutingUsersLeft > 0 && React.createElement(
                  'p',
                  { className: 'more-users-label' },
                  '+',
                  numRoutingUsersLeft,
                  ' more'
                )
              )
            )
          ),
          isMessage && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Send Message', onDeleteClick: onDeleteActionClick.bind(this, 'message') },
            React.createElement(
              'p',
              null,
              'Create a special message to end the bot conversation for contacts who hit this goal.'
            ),
            React.createElement(__WEBPACK_IMPORTED_MODULE_7__Editor__["a" /* default */], { value: goal.message.get('body'), onChange: onMessageActionBodyChange, noPersonalization: true })
          ),
          isScheduling && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            { label: 'Send Calendar', onDeleteClick: onDeleteActionClick.bind(this, 'schedule') },
            React.createElement(
              'p',
              null,
              'Calendar will be sent based on the routing chosen above.'
            )
          ),
          isCQL && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            {
              label: 'Mark as CQL',
              onEditClick: onEditActionClick.bind(this, 'markCQL'),
              onDeleteClick: onDeleteActionClick.bind(this, 'markCQL')
            },
            cqlScore === -1 && React.createElement(
              'p',
              null,
              React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { title: 'Unqualified', className: 'cql-bar-minus-icon', src: __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_minus_svg___default.a })
            ),
            cqlScore > 0 && React.createElement(
              'p',
              null,
              _.times(cqlScore, function () {
                return '\u26A1';
              })
            )
          ),
          isStatusChange && React.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Action__["a" /* default */],
            {
              label: 'Auto-close Conversation',
              onDeleteClick: onDeleteActionClick.bind(this, 'statusChange')
            },
            React.createElement(
              'p',
              null,
              'Conversations will be automatically closed in inbox.'
            )
          ),
          isSingleRouting && singleRoutingInvalidUsers().length > 0 && React.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ActionError__["a" /* default */],
            null,
            React.createElement(
              'p',
              null,
              'You have a schedule action, but the agent in your Single Routing rule (',
              singleRoutingInvalidUsers().map(function (user) {
                return user && (user.name || user.email);
              }),
              ') does not have their calendar connected. If a lead gets routed to them, the bot will not send a calendar.'
            )
          ),
          isGlobalRouting && globalRoutingInvalidUsers().length > 0 && React.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ActionError__["a" /* default */],
            null,
            React.createElement(
              'div',
              null,
              React.createElement(
                'p',
                null,
                globalRoutingInvalidUsers().length,
                ' ',
                Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(globalRoutingInvalidUsers().length, 'agent'),
                ' in your Lead Routing rules do not have their calendars connected. If a lead gets routed to them, the bot will not send a calendar. They can connect their calendar',
                ' ',
                React.createElement(
                  'a',
                  { href: '/meetings', target: '_blank' },
                  'here.'
                )
              ),
              React.createElement(
                'p',
                null,
                '(',
                globalRoutingInvalidUsers().map(function (user) {
                  return user.name || user.email;
                }).join(', '),
                ')'
              )
            )
          ),
          isNoRouting && isScheduling && React.createElement(
            __WEBPACK_IMPORTED_MODULE_8__ActionError__["a" /* default */],
            null,
            React.createElement(
              'p',
              null,
              'You have a schedule action selected, but no routing rules applied. If a lead triggers this goal, the bot will not send a calendar.'
            )
          ),
          React.createElement(
            'button',
            {
              className: 'drift-button drift-button-secondary goal-action-add-button',
              onClick: onAddActionClick
            },
            'Add Action'
          )
        )
      );
    }
  }]);

  return Goal;
}(React.Component);

/* harmony default export */ __webpack_exports__["a"] = (Goal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "2olE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_paging__ = __webpack_require__("Prq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("7IUX");
var _handleActions, _handleActions2, _handleActions3;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var ui = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5__actions__["k" /* searchCampaigns */], function (state, action) {
  return state.set('query', action.payload.query);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5__actions__["p" /* setDraft */], function (state, action) {
  return state.set('draft', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5__actions__["j" /* resetDraft */], function (state) {
  return state.delete('draft');
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var searchResults = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_5__actions__["o" /* searchCampaignsSuccess */], function (state, action) {
  return state.merge(action.payload);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* loadMoreCampaignsSuccess */], function (state, action) {
  var _action$payload = action.payload,
      data = _action$payload.data,
      cursor = _action$payload.cursor,
      hasMore = _action$payload.hasMore;

  return state.update(function (searchResults) {
    return searchResults.withMutations(function (result) {
      return result.set('cursor', cursor).set('hasMore', hasMore).set('status', action.type).updateIn(['data'], function (campaigns) {
        return campaigns.concat(data);
      });
    });
  });
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_5__actions__["k" /* searchCampaigns */], __WEBPACK_IMPORTED_MODULE_5__actions__["n" /* searchCampaignsPending */], __WEBPACK_IMPORTED_MODULE_5__actions__["m" /* searchCampaignsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_4_utils_paging__["b" /* PagedData */])());

var byId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* receiveCampaign */], function (state, action) {
  return state.set(action.payload.get('id'), action.payload);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* searchCampaignsSuccess */], __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* loadMoreCampaignsSuccess */]), function (state, action) {
  var data = action.payload.data;

  // Keep campaigns that were already fetched

  return state.mergeWith(function (prev, next) {
    return prev;
  }, Object(__WEBPACK_IMPORTED_MODULE_3_utils_immutable__["a" /* keyBy */])(data));
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var statusById = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* fetchCampaign */], __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* fetchCampaignPending */], __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* fetchCampaignCancelled */], __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* fetchCampaignFailed */], __WEBPACK_IMPORTED_MODULE_5__actions__["q" /* updateCampaign */], __WEBPACK_IMPORTED_MODULE_5__actions__["t" /* updateCampaignPending */], __WEBPACK_IMPORTED_MODULE_5__actions__["r" /* updateCampaignCancelled */], __WEBPACK_IMPORTED_MODULE_5__actions__["s" /* updateCampaignFailed */], __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* receiveCampaign */]), function (state, action) {
  var id = action.payload.id;

  return state.set(id, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({ ui: ui, searchResults: searchResults, byId: byId, statusById: statusById }));

/***/ }),

/***/ "2phg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("JMAf");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("hTEi");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__selectors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("+Z1b");
/* unused harmony reexport api */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epic__ = __webpack_require__("pTKS");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("TL61");
/* unused harmony reexport User */









/***/ }),

/***/ "2qRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__("n5J5");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("rpEm");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("aiLn");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("om6H");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });









/***/ }),

/***/ "2qcA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2qzf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "2rb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CLASSIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CLASSIFICATIONS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CLASSIFICATIONS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CLASSIFICATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_CLASSIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CLASSIFICATIONS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_CLASSIFICATIONS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_CLASSIFICATIONS_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('classification');

var FETCH_CLASSIFICATIONS = makeConstant('FETCH_CLASSIFICATIONS');
var FETCH_CLASSIFICATIONS_PENDING = makeConstant('FETCH_CLASSIFICATIONS_PENDING');
var FETCH_CLASSIFICATIONS_FAILED = makeConstant('FETCH_CLASSIFICATIONS_FAILED');
var FETCH_CLASSIFICATIONS_SUCCESS = makeConstant('RECEIVE_CLASSIFICATIONS_SUCCESS');

var CREATE_CLASSIFICATIONS = makeConstant('CREATE_CLASSIFICATIONS');
var CREATE_CLASSIFICATIONS_PENDING = makeConstant('CREATE_CLASSIFICATIONS_PENDING');
var CREATE_CLASSIFICATIONS_FAILED = makeConstant('CREATE_CLASSIFICATIONS_FAILED');
var CREATE_CLASSIFICATIONS_SUCCESS = makeConstant('CREATE_CLASSIFICATIONS_SUCCESS');

/***/ }),

/***/ "2ty1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_fonts__ = __webpack_require__("FOd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("Pe/P");














var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    emailCaptureMessage: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["v" /* emailCaptureMessage */](state),
    selectedFont: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__["u" /* selectedWidgetFont */])(state) || 'Brandon'
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_181" /* setMessage */],
      setHeadline: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_177" /* setHeadline */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_138" /* setAuthorId */],
      setThankYouMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_217" /* setThankYouMessage */],
      setThankYouHeadline: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_216" /* setThankYouHeadline */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var orgUsers = _ref.orgUsers;
  return !orgUsers.size;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    userObjForAuthor: props.orgUsers.toJS().find(function (user) {
      return user.id === props.emailCaptureMessage.authorId;
    })
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    Object(__WEBPACK_IMPORTED_MODULE_8_utils_fonts__["a" /* loadMissingFonts */])();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    message: props.emailCaptureMessage.message,
    headline: props.emailCaptureMessage.title,
    thankYouMessage: props.emailCaptureMessage.thankYouMessage,
    thankYouHeadline: props.emailCaptureMessage.thankYouHeadline,
    selectedUser: props.userObjForAuthor || props.orgUsers.first().toJS(),
    selectedFont: props.selectedFont
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onMessageChange: function onMessageChange(props) {
    return function (message) {
      props.actions.setMessage(message);
    };
  },
  onHeadlineChange: function onHeadlineChange(props) {
    return function (event) {
      props.actions.setHeadline({ value: event.target.value });
    };
  },
  onThankYouMessageChange: function onThankYouMessageChange(props) {
    return function (message) {
      props.actions.setThankYouMessage(message);
    };
  },
  onThankYouHeadlineChange: function onThankYouHeadlineChange(props) {
    return function (event) {
      props.actions.setThankYouHeadline(event.target.value);
    };
  },
  onAuthorChange: function onAuthorChange(props) {
    return function (_ref2) {
      var value = _ref2.value;

      props.actions.setAuthorId(value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),

/***/ "2uII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__("TWPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__ = __webpack_require__("hTEi");





var mapStateToProps = function mapStateToProps(state) {
  return {
    options: __WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["nonBotOrgUsersAlphabetical"](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]));

/***/ }),

/***/ "2x/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_renderNothing__ = __webpack_require__("c4Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_renderNothing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_renderNothing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component__ = __webpack_require__("PUQf");



















var mapStateToProps = function mapStateToProps(state) {
  return {
    draft: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["n" /* draft */](state),
    isDraftEnabled: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_37" /* isEnabled */](state),
    isAutosaveActive: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_30" /* isAutosaveActive */](state),
    isStatusLoading: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_50" /* isStatusLoading */](state),
    isSaved: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_46" /* isSaved */](state),
    classifications: __WEBPACK_IMPORTED_MODULE_7_app_modules_classification_selectors__["b" /* classifications */](state),
    draftLoading: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["q" /* draftLoading */](state),
    editSenderModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["R" /* getEditSenderModalVisible */](state),
    tokenModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_21" /* getTokenModalVisible */](state),
    goalRoutingModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["Y" /* getGoalRoutingModalVisible */](state),
    goalActionModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["X" /* getGoalActionModalVisible */](state),
    sendEmailConfirmModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_17" /* getSendEmailConfirmModalVisible */](state),
    conditionModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["G" /* getConditionModalVisible */](state),
    answerModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["D" /* getAnswerModalVisible */](state),
    calendarLinkModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["E" /* getCalendarLinkModalVisible */](state),
    scheduleModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_16" /* getScheduleModalVisible */](state),
    ctaButtonModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["I" /* getCtaButtonModalVisible */](state),
    questionAdvancedModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_13" /* getQuestionAdvancedModalVisible */](state),
    extensionInviteModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["U" /* getExtensionInviteModalVisible */](state),
    sequenceInviteModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_78" /* sequenceInviteModalVisible */](state),
    isLeadBot: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_40" /* isLeadBot */](state),
    isSequencePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_7" /* getIsSequencePlaybook */](state),
    isSignaturePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_48" /* isSignaturePlaybook */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    reportType: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_67" /* reportType */](state),
    isOneTimeEmailPlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_4" /* getIsOneTimeEmailPlaybook */](state),
    isOneTimeMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_5" /* getIsOneTimeMarketingSequencePlaybook */](state),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state),
    googleAuthModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["Z" /* getGoogleAuthModalVisible */](state),
    disableSalesSequenceModalVisible: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["O" /* getDisableSalesSequenceModalVisible */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({
      clearDraft: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["r" /* clearDraft */],
      setName: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_183" /* setName */],
      fetchRules: __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_actions__["fetchRules"],
      fetchConnectedCalendars: __WEBPACK_IMPORTED_MODULE_12_app_modules_meetings_actions__["y" /* fetchConnectedCalendars */],
      fetchSegmentList: __WEBPACK_IMPORTED_MODULE_8_app_modules_segment_actions__["d" /* fetchSegmentList */],
      fetchEmbed: __WEBPACK_IMPORTED_MODULE_14_app_modules_embed_actions__["a" /* fetchEmbed */],
      enablePlaybookAutosave: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["T" /* enablePlaybookAutosave */],
      disablePlaybookAutosave: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["O" /* disablePlaybookAutosave */],
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_151" /* setDraftStatus */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_2_recompose_branch___default()(function (_ref) {
  var draftLoading = _ref.draftLoading,
      classifications = _ref.classifications;
  return draftLoading || !classifications;
}, __WEBPACK_IMPORTED_MODULE_4_recompose_renderNothing___default.a), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onNameChange: function onNameChange(props) {
    return function (event) {
      props.actions.setName(event.target.value);
    };
  },
  onExitAttempt: function onExitAttempt(props) {
    return function (nextRoute) {
      if (!nextRoute) return true; // this may not always return a route, TODO: debug - pk2
      var isSaved = props.isSaved;
      var pathname = nextRoute.pathname;

      if (!isSaved && !/^\/playbooks\/\d+/.test(pathname)) {
        return 'You have unsaved changes in your playbook. Would you like to exit without saving?';
      }
      return true;
    };
  },
  onUnload: function onUnload(props) {
    return function (event) {
      var isSaved = props.isSaved;

      if (!isSaved) {
        event.returnValue = true;
      }
    };
  }
}), __WEBPACK_IMPORTED_MODULE_1_recompose_lifecycle___default()({
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        router = _props.router,
        reportType = _props.reportType,
        location = _props.location,
        draft = _props.draft,
        isLeadBot = _props.isLeadBot,
        isSequencePlaybook = _props.isSequencePlaybook,
        isSignaturePlaybook = _props.isSignaturePlaybook,
        _props$actions = _props.actions,
        fetchRules = _props$actions.fetchRules,
        fetchConnectedCalendars = _props$actions.fetchConnectedCalendars,
        fetchSegmentList = _props$actions.fetchSegmentList,
        fetchEmbed = _props$actions.fetchEmbed,
        enablePlaybookAutosave = _props$actions.enablePlaybookAutosave,
        disablePlaybookAutosave = _props$actions.disablePlaybookAutosave;

    fetchRules();
    fetchConnectedCalendars();
    fetchSegmentList();
    fetchEmbed();

    var status = draft.status;


    var playbooksPath = '/playbooks/' + draft.id + '/edit';
    var viewConfig = __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_constants__["_142" /* PlaybookViewConfig */][reportType] || {};
    if (status === __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED) {
      enablePlaybookAutosave();
    } else {
      disablePlaybookAutosave();
    }

    if (location.pathname === playbooksPath) {
      if (isLeadBot) {
        router.replace(playbooksPath + '/leadbot');
      } else if (isSignaturePlaybook) {
        router.replace(playbooksPath + '/message/signature');
      } else if (isSequencePlaybook) {
        router.replace(playbooksPath + '/sequence');
      } else if (viewConfig && viewConfig.messageUrlPath) {
        router.replace(playbooksPath + '/message/' + viewConfig.messageUrlPath);
      }
    }
  },
  componentDidMount: function componentDidMount() {
    var _props2 = this.props,
        router = _props2.router,
        route = _props2.route,
        onExitAttempt = _props2.onExitAttempt,
        onUnload = _props2.onUnload;

    router.setRouteLeaveHook(route, onExitAttempt);
    window.addEventListener('beforeunload', onUnload);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props.actions.clearDraft();
    window.removeEventListener('beforeunload', this.props.onUnload);
  }
}))(__WEBPACK_IMPORTED_MODULE_15__component__["a" /* default */]));

/***/ }),

/***/ "2xWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_upsell_upsell_logos_2x_png__ = __webpack_require__("vaNF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_upsell_upsell_logos_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_upsell_upsell_logos_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upsell_cal_connect_png__ = __webpack_require__("yLox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_upsell_cal_connect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_upsell_cal_connect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_upsell_sequences_upsell_header_svg__ = __webpack_require__("cH6z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_upsell_sequences_upsell_header_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_upsell_sequences_upsell_header_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_onboarding_close_svg__ = __webpack_require__("fIl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_onboarding_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_onboarding_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_styl__ = __webpack_require__("TXHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__styles_styl__);









var MeetingTripWireModal = function MeetingTripWireModal(_ref) {
  var setShowTripwire = _ref.setShowTripwire;
  return React.createElement(
    'div',
    { className: 'tripwire-modal-lightbox' },
    React.createElement(
      'div',
      { className: 'two-panel-modal' },
      React.createElement(
        'div',
        { className: 'left-panel-content' },
        React.createElement(
          'div',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { className: 'info', src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_upsell_sequences_upsell_header_svg___default.a }),
          React.createElement(
            'div',
            { className: 'helper-text' },
            'Book meetings faster right from this email sequence. Share your calendar in this automated sequence and let people book meetings with you in 1-click.'
          ),
          React.createElement(
            'div',
            { className: 'education-button-wrapper' },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
              { href: '/settings/billing', target: '_blank', className: 'upgrade-button' },
              'Upgrade Account'
            ),
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
              { className: 'learn-more', href: 'https://www.drift.com/meetings', target: '_blank', type: 'subtle' },
              'Learn More'
            )
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'right-panel-content' },
        React.createElement(
          'div',
          { className: 'calendar-preview' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { className: 'onboarding-close', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_onboarding_close_svg___default.a, onClick: function onClick() {
              return setShowTripwire(false);
            } }),
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_3_images_upsell_cal_connect_png___default.a, alt: 'calendar' })
        )
      ),
      React.createElement('img', { className: 'upsell-logos', src: __WEBPACK_IMPORTED_MODULE_2_images_upsell_upsell_logos_2x_png___default.a })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MeetingTripWireModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3/+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_actions__ = __webpack_require__("GsgS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_eloqua_selectors__ = __webpack_require__("Zisu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_eloqua_models__ = __webpack_require__("b+Ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("DoXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var HELP_DOC_URL = "https://gethelp.drift.com/hc/en-us/articles/360019666973-How-to-Connect-Drift-and-Eloqua";
var integrationName = "Eloqua";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};

var EloquaAttributeMapping = function (_Component) {
  _inherits(EloquaAttributeMapping, _Component);

  function EloquaAttributeMapping(props) {
    var _this2 = this;

    _classCallCheck(this, EloquaAttributeMapping);

    var _this = _possibleConstructorReturn(this, (EloquaAttributeMapping.__proto__ || Object.getPrototypeOf(EloquaAttributeMapping)).call(this, props));

    _this.patchDecorator = function (strippedMappings, successCB) {
      var payload = { mappings: strippedMappings };
      _this.props.actions.patchEloquaMappings(payload, successCB);
    };

    _this.getEloquaConfigValues = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var eloquaConfig;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              eloquaConfig = void 0;
              _context.prev = 1;
              _context.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_api__["q" /* getEloquaConfig */])();

            case 4:
              eloquaConfig = _context.sent;
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](1);

              console.warn(_context.t0);

            case 10:

              _this.setState({
                useCountryAcronyms: eloquaConfig.abbreviateCountryNames,
                useStateAcronyms: eloquaConfig.abbreviateStateNames
              });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 7]]);
    }));

    _this.onCountryUpdated = function (newValue) {
      var notifications = _this.props.notifications;

      var payload = {
        "abbreviateCountryNames": newValue
      };

      try {
        Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_api__["G" /* patchEloquaConfig */])(payload);
        notifications.success(getSuccessMessage(integrationName));
      } catch (e) {
        console.warn(e);
      }
    };

    _this.onStateUpdated = function (newValue) {
      var notifications = _this.props.notifications;

      var payload = {
        "abbreviateStateNames": newValue
      };

      try {
        Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_api__["G" /* patchEloquaConfig */])(payload);
        notifications.success(getSuccessMessage(integrationName));
      } catch (e) {
        console.warn(e);
      }
    };

    _this.state = {
      mappings: props.mappings,
      specialFields: [{ "label": "Lead Owner", "type": "STRING", value: "_integrations_lead_owner" }]
    };
    return _this;
  }

  _createClass(EloquaAttributeMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.mappings !== nextProps.mappings) {
        this.setState({ mappings: nextProps.mappings });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchDriftProperties();
      this.props.actions.fetchEloquaFields();
      this.props.actions.fetchEloquaMappings();
      this.getEloquaConfigValues();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          patchLoading = _props.patchLoading,
          driftProperties = _props.driftProperties,
          eloquaFields = _props.eloquaFields,
          actions = _props.actions,
          notifications = _props.notifications;
      var _state = this.state,
          mappings = _state.mappings,
          useCountryAcronyms = _state.useCountryAcronyms,
          useStateAcronyms = _state.useStateAcronyms,
          specialFields = _state.specialFields;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'eloqua-mapping common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Eloqua Integration',
          backLinkUrl: '/settings/setup/eloqua'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Mapped Eloqua Contact Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Map which fields you want to add to new Eloqua Leads. These Drift attributes will be added to new Eloqua Leads when they\u2019re created.',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: HELP_DOC_URL },
              ' Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_AttributeMapper__["a" /* default */], {
          integrationName: 'Eloqua',
          mappings: mappings,
          driftAttributes: specialFields.concat(driftProperties),
          integrationAttributes: eloquaFields,
          mappingModel: __WEBPACK_IMPORTED_MODULE_10_app_modules_eloqua_models__["a" /* EloquaMapping */],
          patchMappings: this.patchDecorator,
          patchLoading: patchLoading,
          allowAttributeDefaults: true }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'eloqua-toggle-row' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Input"], {
            className: 'eloqua-default-checkbox',
            type: 'checkbox',
            checked: useCountryAcronyms,
            onChange: this.onCountryUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: 'eloqua-toggle-text' },
            'Send abbreviated country names to Eloqua (i.e. US instead of United States)'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'eloqua-toggle-row' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Input"], {
            className: 'eloqua-default-checkbox',
            type: 'checkbox',
            checked: useStateAcronyms,
            onChange: this.onStateUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            { className: 'eloqua-toggle-text' },
            'Send abbreviated state names to Eloqua (i.e. NY instead of New York)'
          )
        )
      );
    }
  }]);

  return EloquaAttributeMapping;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EloquaAttributeMapping.defaultProps = {
  allowAttributeDefaults: false
};

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state),
    mappings: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_eloqua_selectors__["c" /* getMappings */])(state),
    eloquaFields: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_eloqua_selectors__["b" /* getFields */])(state),
    patchError: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_eloqua_selectors__["a" /* didPatchErr */])(state),
    patchLoading: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_eloqua_selectors__["d" /* isPatchLoading */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      fetchEloquaMappings: __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_actions__["b" /* fetchEloquaMappings */],
      fetchEloquaFields: __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_actions__["a" /* fetchEloquaFields */],
      patchEloquaMappings: __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_actions__["c" /* patchEloquaMappings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(EloquaAttributeMapping)));

/***/ }),

/***/ "358Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(535);

/***/ }),

/***/ "37s/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__ = __webpack_require__("aLj5");



var UserSelect = function UserSelect(_ref) {
  var selectedValue = _ref.selectedValue,
      onUserIdChange = _ref.onUserIdChange,
      options = _ref.options,
      filter = _ref.filter,
      _ref$renderSelectedVa = _ref.renderSelectedValue,
      renderSelectedValue = _ref$renderSelectedVa === undefined ? undefined : _ref$renderSelectedVa,
      className = _ref.className,
      clearable = _ref.clearable;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__["b" /* default */], {
    value: selectedValue,
    options: options,
    filterOption: filter,
    valueComponent: renderSelectedValue,
    onChange: onUserIdChange,
    className: className,
    clearable: clearable
  });
};

/* harmony default export */ __webpack_exports__["a"] = (UserSelect);

/***/ }),

/***/ "385t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unreadConversationIds; });
/* unused harmony export makeLastMessageUnread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('unread');
};
var byConversationId = function byConversationId(state) {
  return root(state).get('lastMessageByConversationId');
};

var unreadConversationIds = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(byConversationId, function (byConversationId) {
  return byConversationId.filter(function (lastMessage) {
    var sentAt = lastMessage.get('sentAt');
    var readAt = lastMessage.get('readAt');

    if (sentAt && !readAt) {
      return true;
    }

    return readAt < sentAt;
  }).keySeq();
});

var makeLastMessageUnread = function makeLastMessageUnread() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(byConversationId, function (state, _ref) {
    var conversationId = _ref.conversationId;
    return conversationId;
  }, function (byConversationId, conversationId) {
    var sentAt = byConversationId.getIn([conversationId, 'sentAt']);
    var readAt = byConversationId.getIn([conversationId, 'readAt']);

    if (sentAt && !readAt) {
      return true;
    }

    return readAt < sentAt;
  });
};

/***/ }),

/***/ "3CEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* unused harmony export DeviceTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTargetCondition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__("L8MQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__ = __webpack_require__("KOTG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NumericInputs__ = __webpack_require__("MD73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimeInputs__ = __webpack_require__("cE9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClearbitNumericInputs__ = __webpack_require__("HF11");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DemandbaseWatchlistInputs__ = __webpack_require__("faNi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__OnlineInputs__ = __webpack_require__("GM+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StringInputs__ = __webpack_require__("ea2+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TeamSelectInputs__ = __webpack_require__("60LJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RegexInputs__ = __webpack_require__("WX5J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScrollPercentageInput__ = __webpack_require__("SW2R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ExitIntentInput__ = __webpack_require__("BWTS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutboundSessionInput__ = __webpack_require__("ICyl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_ISOCountries__ = __webpack_require__("dzDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_constants_UspsStates__ = __webpack_require__("f/uQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_constants_DemandbaseAudiences__ = __webpack_require__("R9hW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_constants_DemandbaseEmployeeRanges__ = __webpack_require__("ZPDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_constants_DemandbaseRevenueRanges__ = __webpack_require__("bxiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_constants_ClearbitTags__ = __webpack_require__("SAet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_constants_ClearbitTech__ = __webpack_require__("JpL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_constants_ClearbitRevenueRanges__ = __webpack_require__("BqSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_playbook_components_TargetingDisplay_Inputs__ = __webpack_require__("rS5j");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




























var DeviceTypes = [{ value: 'mobile', label: 'mobile' }, { value: 'tablet', label: 'tablet' }, { value: 'desktop', label: 'desktop' }];

var Browser = {
  display: 'Device',
  default: { field: 'device', operator: 'isAnyOf', value: [DeviceTypes[0].value] },
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: DeviceTypes }, props));
  }
};

var OutboundSession = {
  display: 'Outbound Session',
  default: { field: 'outboundSession', operator: 'is', value: true },
  component: __WEBPACK_IMPORTED_MODULE_14__OutboundSessionInput__["a" /* default */]
};

var CountryCodeOptions = _.map(__WEBPACK_IMPORTED_MODULE_15_constants_ISOCountries__["a" /* IsoToCountriesNames */], function (label, value) {
  return { value: value, label: label };
});

var CountryNameOptions = _.map(__WEBPACK_IMPORTED_MODULE_15_constants_ISOCountries__["a" /* IsoToCountriesNames */], function (label, value) {
  return { label: label, value: label };
});

var DemandbaseEmployeeRangeOptions = _.map(__WEBPACK_IMPORTED_MODULE_18_constants_DemandbaseEmployeeRanges__["a" /* default */], function (value) {
  return { label: value, value: value };
});

var DemandbaseRevenueRangeOptions = _.map(__WEBPACK_IMPORTED_MODULE_19_constants_DemandbaseRevenueRanges__["a" /* default */], function (value) {
  return { label: value, value: value };
});

var CountryCode = {
  display: 'Country',
  default: { field: 'geoCountryCode', operator: 'isAnyOf', value: [CountryCodeOptions[0].value] },
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: CountryCodeOptions }, props));
  }
};

var UsStateValues = _.map(__WEBPACK_IMPORTED_MODULE_16_constants_UspsStates__["a" /* UspsCodesToStateName */], function (label) {
  return { value: label, label: label };
});

var UsState = {
  display: 'US States',
  default: { field: 'geoState', operator: 'isAnyOf', value: [UsStateValues[0].value] },
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: UsStateValues }, props));
  }
};

var IpAddress = {
  display: 'IP Address',
  default: {
    field: 'geoIp',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: 192.0.2.2'
  },
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */], _extends({ optionTypes: ['isAnyOf', 'notIsAnyOf'] }, props));
  }
};

var SiteVisits = {
  display: '# Site Visits',
  default: { field: 'siteVisits', operator: 'is', value: 1 },
  component: __WEBPACK_IMPORTED_MODULE_4__NumericInputs__["a" /* default */]
};

var DaysSinceLastVisit = {
  display: '# Days Since Last Visit',
  default: { field: 'daysSinceLastVisit', operator: 'is', value: 1 },
  component: __WEBPACK_IMPORTED_MODULE_4__NumericInputs__["a" /* default */]
};

var UrlRegex = {
  display: 'URL (Regex)',
  default: {
    field: 'url',
    operator: 'isMatch',
    value: [''],
    placeholder: 'example: drift\\.com\\/blog$'
  },
  component: __WEBPACK_IMPORTED_MODULE_11__RegexInputs__["b" /* default */]
};

var Url = {
  display: 'URL',
  default: {
    field: 'url',
    operator: 'includesAnyOf',
    value: [''],
    placeholder: 'example: drift.com/blog'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var UrlPath = {
  display: 'URL Path',
  default: {
    field: 'urlPath',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: /index.html'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var UrlHost = {
  display: 'URL Host',
  default: {
    field: 'urlHost',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: app.drift.com'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var UrlQuery = {
  display: 'URL Query Param',
  default: {
    field: 'urlQuery',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: query=value'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var Cookie = {
  display: 'Cookie Name=Value',
  default: {
    field: 'cookie',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: cookieName=value'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var Referrer = {
  display: 'Referrer',
  default: {
    field: 'referrer',
    operator: 'includesAnyOf',
    value: [''],
    placeholder: 'example: http://www.drift.com/'
  },
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var ScrollPercentage = {
  display: 'Scroll Percentage',
  default: { field: 'scrollPct', operator: 'greaterThan', value: 75 },
  component: __WEBPACK_IMPORTED_MODULE_12__ScrollPercentageInput__["a" /* default */]
};

var SecondsOnPage = {
  display: 'Time on Page (seconds)',
  default: { field: 'secondsOnPage', operator: 'greaterThan', value: 30 },
  component: __WEBPACK_IMPORTED_MODULE_5__TimeInputs__["a" /* default */]
};

var SecondsOnSite = {
  display: 'Time on Site (seconds)',
  default: { field: 'secondsOnSite', operator: 'greaterThan', value: 30 },
  component: __WEBPACK_IMPORTED_MODULE_5__TimeInputs__["a" /* default */]
};

var Team = {
  display: 'Team',
  default: { field: 'teamAvailability', operator: 'isAvailable', value: [''] },
  component: __WEBPACK_IMPORTED_MODULE_10__TeamSelectInputs__["a" /* default */]
};

var IsOnline = {
  display: 'Drift Widget Status',
  default: { field: 'online', operator: 'is', value: true },
  component: __WEBPACK_IMPORTED_MODULE_8__OnlineInputs__["a" /* default */]
};

var OnExitIntent = {
  display: 'On Exit Intent',
  default: { field: 'exitIntent', operator: 'is', value: true },
  component: __WEBPACK_IMPORTED_MODULE_13__ExitIntentInput__["a" /* default */]
};

var DemandbaseAudience = {
  display: 'Demandbase - Audience',
  default: {
    field: 'demandbase_audience',
    operator: 'isAnyOf',
    value: [__WEBPACK_IMPORTED_MODULE_17_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */][0].value]
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: __WEBPACK_IMPORTED_MODULE_17_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */] }, props));
  }
};

var DemandbaseWatchlist = {
  display: 'Demandbase - Watch List',
  default: {
    field: 'demandbase_watchlist',
    operator: 'isInWatchlist',
    value: [''],
    placeholder: 'example: accounts_owner:dave'
  },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_7__DemandbaseWatchlistInputs__["a" /* default */]
};

var DemandbaseCompanyName = {
  display: 'Demandbase - Company Name',
  default: {
    field: 'demandbase_company_name',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var DemandbaseIndustry = {
  display: 'Demandbase - Industry',
  default: {
    field: 'demandbase_industry',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    var industryOptions = _.map(props.demandbaseIndustries, function (industry) {
      return { label: industry, value: industry };
    });

    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({
      options: industryOptions,
      isCreatable: true,
      placeholder: 'Type to create custom value'
    }, props));
  }
};

var DemandbaseEmployeeRange = {
  display: 'Demandbase - Employee Range',
  default: {
    field: 'demandbase_employee_range',
    operator: 'isAnyOf',
    value: [DemandbaseEmployeeRangeOptions[0].value]
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({
      options: DemandbaseEmployeeRangeOptions,
      isCreatable: true,
      placeholder: 'Type to create custom value'
    }, props));
  }
};

var DemandbaseEmployeeCount = {
  display: 'Demandbase - Employee Count',
  default: {
    field: 'demandbase_employee_count',
    operator: 'greaterThan',
    value: 50
  },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_4__NumericInputs__["a" /* default */]
};

var DemandbaseCity = {
  display: 'Demandbase - City',
  default: {
    field: 'demandbase_city',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var DemandbaseState = {
  display: 'Demandbase - State',
  default: {
    field: 'demandbase_state',
    operator: 'isAnyOf',
    value: [UsStateValues[0].value]
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: UsStateValues }, props));
  }
};

var DemandbaseCountryCode = {
  display: 'Demandbase - Country Code',
  default: {
    field: 'demandbase_country_code',
    operator: 'isAnyOf',
    value: [CountryCodeOptions[0].value]
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: CountryCodeOptions }, props));
  }
};

var DemandbaseMarketingAlias = {
  display: 'Demandbase - Marketing Alias',
  default: {
    field: 'demandbase_marketing_alias',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var DemandbaseSubIndustry = {
  display: 'Demandbase - Sub Industry',
  default: {
    field: 'demandbase_sub_industry',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    var subIndustryOptions = _.map(props.demandbaseSubIndustries, function (industry) {
      return { label: industry, value: industry };
    });

    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({
      options: subIndustryOptions,
      isCreatable: true,
      placeholder: 'Type to create custom value'
    }, props));
  }
};

var DemandbaseAnnualSales = {
  display: 'Demandbase - Annual Sales',
  default: { field: 'demandbase_annual_sales', operator: 'greaterThan', value: 400000 },
  requiredIntegration: 'demandbase',
  component: __WEBPACK_IMPORTED_MODULE_4__NumericInputs__["a" /* default */]
};

var DemandbaseRevenueRange = {
  display: 'Demandbase - Revenue Range',
  default: {
    field: 'demandbase_revenue_range',
    operator: 'isAnyOf',
    value: ['']
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({
      options: DemandbaseRevenueRangeOptions
    }, props, {
      isCreatable: true,
      placeholder: 'Type to create custom value' }));
  }
};

var DemandbaseCountryName = {
  display: 'Demandbase - Country Name',
  default: {
    field: 'demandbase_country_name',
    operator: 'isAnyOf',
    value: [CountryNameOptions[0].value]
  },
  requiredIntegration: 'demandbase',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: CountryNameOptions }, props));
  }
};

var ClearbitName = {
  display: 'Drift Intel - Name',
  default: {
    field: 'clearbit_name',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: Drift'
  },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var ClearbitDomain = {
  display: 'Drift Intel - Domain',
  default: {
    field: 'clearbit_domain',
    operator: 'isAnyOf',
    value: [''],
    placeholder: 'example: drift.com'
  },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var ClearbitRevenueOptions = __WEBPACK_IMPORTED_MODULE_22_constants_ClearbitRevenueRanges__["a" /* default */].map(function (range) {
  return { value: range, label: range };
});
var ClearbitRevenue = {
  display: 'Drift Intel - Revenue',
  default: { field: 'clearbit_revenue', operator: 'isAnyOf', value: [__WEBPACK_IMPORTED_MODULE_22_constants_ClearbitRevenueRanges__["a" /* default */][0]] },
  gates: 'premium_enterprise',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: ClearbitRevenueOptions }, props));
  }
};

var ClearbitTagOptions = _.map(__WEBPACK_IMPORTED_MODULE_20_constants_ClearbitTags__["a" /* default */], function (label) {
  return { value: label, label: label };
});

var ClearbitTechOptions = _.map(__WEBPACK_IMPORTED_MODULE_21_constants_ClearbitTech__["a" /* default */], function (_ref) {
  var value = _ref.value,
      label = _ref.label;

  return { value: value, label: label };
});

var ClearbitTags = {
  display: 'Drift Intel - Tags',
  default: { field: 'clearbit_tags', operator: 'isAnyOf', value: [__WEBPACK_IMPORTED_MODULE_20_constants_ClearbitTags__["a" /* default */][0]] },
  gates: 'premium_enterprise',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: ClearbitTagOptions }, props));
  }
};

var ClearbitTech = {
  display: 'Drift Intel - Technology',
  default: { field: 'clearbit_tech', operator: 'isAnyOf', value: [__WEBPACK_IMPORTED_MODULE_21_constants_ClearbitTech__["a" /* default */][0].value] },
  gates: 'premium_enterprise',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: ClearbitTechOptions }, props));
  }
};

var ClearbitEmployees = {
  display: 'Drift Intel - # of Employees',
  default: { field: 'clearbit_employees', operator: 'greaterThan', value: 50 },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_6__ClearbitNumericInputs__["a" /* default */]
};

var ClearbitRaised = {
  display: 'Drift Intel - Amount Raised',
  default: { field: 'clearbit_raised', operator: 'greaterThan', value: 1000000 },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_6__ClearbitNumericInputs__["a" /* default */]
};

var ClearbitAlexaGlobal = {
  display: 'Drift Intel - Alexa Global Ranking',
  default: { field: 'clearbit_alexa_global', operator: 'lessThan', value: 300000 },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_6__ClearbitNumericInputs__["a" /* default */]
};

var ClearbitAlexaUS = {
  display: 'Drift Intel - Alexa US Ranking',
  default: { field: 'clearbit_alexa_us', operator: 'lessThan', value: 300000 },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_6__ClearbitNumericInputs__["a" /* default */]
};

var ClearbitHeadquarterState = {
  display: 'Drift Intel - Headquarter State',
  default: { field: 'clearbit_state', operator: 'isAnyOf', value: [UsStateValues[0].value] },
  gates: 'premium_enterprise',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: UsStateValues }, props));
  }
};

var ClearbitHeadquarterCountry = {
  display: 'Drift Intel - Headquarter Country',
  default: { field: 'clearbit_country', operator: 'isAnyOf', value: [CountryCodeOptions[0].value] },
  gates: 'premium_enterprise',
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["d" /* default */], _extends({ options: CountryCodeOptions }, props));
  }
};

var ClearbitHeadquarterPostalCode = {
  display: 'Drift Intel - Headquarter Postal Code',
  default: { field: 'clearbit_postal_code', operator: 'isAnyOf', value: [''] },
  gates: 'premium_enterprise',
  component: __WEBPACK_IMPORTED_MODULE_9__StringInputs__["a" /* default */]
};

var TargetConditionTypeMap = {
  Browser: Browser,
  OutboundSession: OutboundSession,
  SiteVisits: SiteVisits,
  DaysSinceLastVisit: DaysSinceLastVisit,
  Url: Url,
  UrlPath: UrlPath,
  UrlHost: UrlHost,
  UrlQuery: UrlQuery,
  UrlRegex: UrlRegex,
  Referrer: Referrer,
  Cookie: Cookie,
  CountryCode: CountryCode,
  UsState: UsState,
  IpAddress: IpAddress,
  ScrollPercentage: ScrollPercentage,
  SecondsOnPage: SecondsOnPage,
  SecondsOnSite: SecondsOnSite,
  Team: Team,
  IsOnline: IsOnline,
  ClearbitName: ClearbitName,
  ClearbitDomain: ClearbitDomain,
  ClearbitRevenue: ClearbitRevenue,
  ClearbitTags: ClearbitTags,
  ClearbitTech: ClearbitTech,
  ClearbitEmployees: ClearbitEmployees,
  ClearbitRaised: ClearbitRaised,
  ClearbitAlexaGlobal: ClearbitAlexaGlobal,
  ClearbitAlexaUS: ClearbitAlexaUS,
  ClearbitHeadquarterState: ClearbitHeadquarterState,
  ClearbitHeadquarterCountry: ClearbitHeadquarterCountry,
  ClearbitHeadquarterPostalCode: ClearbitHeadquarterPostalCode,
  DemandbaseAudience: DemandbaseAudience,
  DemandbaseWatchlist: DemandbaseWatchlist,
  DemandbaseCompanyName: DemandbaseCompanyName,
  DemandbaseIndustry: DemandbaseIndustry,
  DemandbaseEmployeeCount: DemandbaseEmployeeCount,
  DemandbaseCity: DemandbaseCity,
  DemandbaseState: DemandbaseState,
  DemandbaseCountryCode: DemandbaseCountryCode,
  DemandbaseCountryName: DemandbaseCountryName,
  DemandbaseAnnualSales: DemandbaseAnnualSales,
  DemandbaseMarketingAlias: DemandbaseMarketingAlias,
  DemandbaseSubIndustry: DemandbaseSubIndustry,
  DemandbaseRevenueRange: DemandbaseRevenueRange,
  DemandbaseEmployeeRange: DemandbaseEmployeeRange,
  OnExitIntent: OnExitIntent
};

var TargetConditionTypesByFieldName = __WEBPACK_IMPORTED_MODULE_0_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_values___default()(TargetConditionTypeMap), 'default.field');

var getTargetCondition = function getTargetCondition(fieldName, operator) {
  if (fieldName === 'url') {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_11__RegexInputs__["a" /* OPERATORS */], operator)) {
      return UrlRegex;
    } else {
      return Url;
    }
  }

  return TargetConditionTypesByFieldName[fieldName];
};

/* harmony default export */ __webpack_exports__["a"] = (TargetConditionTypeMap);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "3DHs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/advancedRoutingOptIn.1c8f9dad.jpg";

/***/ }),

/***/ "3F5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__("/fEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hotkeys__ = __webpack_require__("S+6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_body_classname__ = __webpack_require__("xqoo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_body_classname___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_body_classname__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_Modal_styl__ = __webpack_require__("jQzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_Modal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_components_Modal_styl__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.











var ModalContent = React.createClass({
  displayName: 'ModalContent',

  mixins: [__webpack_require__("aCGJ")],

  propTypes: {
    onClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    modalContentClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  },

  componentDidMount: function componentDidMount() {
    return this.enableOnClickOutside();
  },
  handleClickOutside: function handleClickOutside(event) {
    if (!this.props.ignoreCloseOnClickOutside) {
      return this.props.onClose();
    }
  },
  closeModal: function closeModal() {
    return this.props.onClose();
  },
  render: function render() {
    var _this = this;

    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
      { style: { size: Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(1, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].gentle) }, defaultStyle: { size: .9 } },
      function (interpolated) {
        return React.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('modal-content', _this.props.modalContentClassName),
            onClick: _this.props.onContentClick,
            ref: function ref(modalContent) {
              return _this.modalContentRef = modalContent;
            },
            style: { transform: 'scale3d(' + interpolated.size + ', ' + interpolated.size + ', 1)' } },
          _this.props.children
        );
      }
    );
  }
});

var Modal = React.createClass({
  displayName: 'Modal',

  propTypes: {
    fullScreen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    glassMode: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    ignoreCloseOnClickOutside: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  },

  renderCloseButton: function renderCloseButton() {
    return React.createElement(
      'div',
      { className: 'close-button', onClick: this.props.onClose },
      React.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, {
        src: __webpack_require__("/xdp") })
    );
  },
  render: function render() {
    var _this2 = this;

    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_hotkeys__["HotKeys"],
      {
        keyMap: {
          doClose: 'esc'
        },
        handlers: {
          doClose: this.props.onClose
        } },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_body_classname___default.a,
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('modal-visible', {
            'modal-full-screen': this.props.fullScreen,
            'glass-mode-full-screen': this.props.glassMode
          }) },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
          {
            style: { opacity: Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(1, __WEBPACK_IMPORTED_MODULE_1_react_motion__["presets"].noWobble) },
            defaultStyle: { opacity: 0 } },
          function (interpolated) {
            return React.createElement(
              'div',
              { className: 'Modal', style: { opacity: interpolated.opacity }, tabIndex: 0 },
              _this2.props.fullScreen ? _this2.renderCloseButton() : undefined,
              React.createElement(
                ModalContent,
                _this2.props,
                _this2.props.children,
                !_this2.props.fullScreen ? _this2.renderCloseButton() : undefined
              )
            );
          }
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Modal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "3IRH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(517);

/***/ }),

/***/ "3Jc0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3JoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("LAZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);







var ToggleSection = function ToggleSection(_ref) {
  var title = _ref.title,
      description = _ref.description,
      className = _ref.className,
      isChecked = _ref.isChecked,
      onToggled = _ref.onToggled,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('toggle-section', className) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Section__["a" /* SectionItem */], {
      title: title,
      description: description,
      className: 'section-item'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toggle__["a" /* default */], {
      checked: isChecked,
      onChange: onToggled,
      className: 'section-toggle'
    }),
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ToggleSection);

/***/ }),

/***/ "3Jsy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3LZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("N6zH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var typeOptions = Object.keys(__WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */]).map(function (type) {
  return { value: __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */][type], label: __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["W" /* URL_FILTER_TYPE_LABELS */][type] };
});
var operatorOptions = Object.keys(__WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["T" /* URL_FILTER_OPERATORS */]).map(function (type) {
  return { value: __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["T" /* URL_FILTER_OPERATORS */][type], label: __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["U" /* URL_FILTER_OPERATOR_LABELS */][type] };
});

var UrlFilter = function (_Component) {
  _inherits(UrlFilter, _Component);

  function UrlFilter(props) {
    _classCallCheck(this, UrlFilter);

    var _this = _possibleConstructorReturn(this, (UrlFilter.__proto__ || Object.getPrototypeOf(UrlFilter)).call(this, props));

    _this.onTypeSelect = function (type) {
      _this.props.updateModel(type.value);
      _this.setState({ fieldType: type.value, urlValue: [''] }, _this.updateParent);
    };

    _this.onOperatorSelect = function (type) {
      _this.setState({ operatorType: type.value }, _this.updateParent);
    };

    _this.updateParent = function () {
      var isValid = !!_this.state.urlValue[0];
      _this.props.setPageValidity(isValid);
      if (isValid) {
        _this.props.setActiveFilter({
          field: _this.state.fieldType,
          operator: _this.state.operatorType,
          value: _this.state.urlValue
        });
      }
    };

    _this.updateUrlValue = function (event, index) {
      event.persist();
      _this.setState(function (prevState) {
        return { urlValue: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["update"])(index, event.target.value, prevState.urlValue) };
      }, _this.updateParent);
    };

    _this.renderTypeSelect = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], { options: typeOptions, onChange: _this.onTypeSelect, value: _this.state.fieldType, searchable: false, clearable: false });
    };

    _this.renderOperatorType = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], { options: operatorOptions, onChange: _this.onOperatorSelect, value: _this.state.operatorType, searchable: false, clearable: false });
    };

    _this.renderTypeComponent = function (entry, index) {
      var _components;

      var _CONSTANTS$URL_FILTER = __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */],
          URL_PATH = _CONSTANTS$URL_FILTER.URL_PATH,
          URL_HOST = _CONSTANTS$URL_FILTER.URL_HOST,
          URL_QUERY = _CONSTANTS$URL_FILTER.URL_QUERY;

      var components = (_components = {}, _defineProperty(_components, URL_PATH, _this.renderPathInput), _defineProperty(_components, URL_HOST, _this.renderHostInput), _defineProperty(_components, URL_QUERY, _this.renderQueryInput), _components);

      return components[_this.state.fieldType](entry, index);
    };

    _this.parseQueryParamName = function (entry) {
      return entry.split('=')[0] || '';
    };

    _this.parseQueryParamValue = function (entry) {
      return entry.split('=')[1] || '';
    };

    _this.updateQueryParamName = function (event, index) {
      event.persist();
      var updatedEntry = [event.target.value, _this.parseQueryParamValue(_this.state.urlValue[index])].join('=');
      _this.setState(function (prevState) {
        return { urlValue: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["update"])(index, updatedEntry, prevState.urlValue) };
      });
    };

    _this.updateQueryParamValue = function (event, index) {
      event.persist();
      var updatedEntry = [_this.parseQueryParamName(_this.state.urlValue[index]), event.target.value].join('=');
      _this.setState(function (prevState) {
        return { urlValue: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["update"])(index, updatedEntry, prevState.urlValue) };
      });
    };

    _this.renderQueryInput = function (entry, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-url-query-filter' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rule-url-query-input' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { type: 'text', value: _this.parseQueryParamName(entry), onChange: function onChange(event) {
              return _this.updateQueryParamName(event, index);
            }, placeholder: 'query param' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'equals-icon' },
          '='
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rule-url-query-input' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { type: 'text', value: _this.parseQueryParamValue(entry), onChange: function onChange(event) {
              return _this.updateQueryParamValue(event, index);
            }, placeholder: 'value' })
        )
      );
    };

    _this.renderHostInput = function (entry, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { type: 'text', value: entry, placeholder: 'example: app.drift.com', onChange: function onChange(event) {
          return _this.updateUrlValue(event, index);
        } });
    };

    _this.renderPathInput = function (entry, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { type: 'text', value: entry, placeholder: 'example: /pricing', onChange: function onChange(event) {
          return _this.updateUrlValue(event, index);
        } });
    };

    _this.addEntryToUrlValue = function () {
      return _this.setState(function (prevState) {
        return { urlValue: [].concat(_toConsumableArray(prevState.urlValue), ['']) };
      }, _this.updateParent);
    };

    _this.removeEntryFromUrlValue = function (index) {
      return _this.setState(function (prevState) {
        return { urlValue: Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["remove"])(index, 1, prevState.urlValue) };
      }, _this.updateParent);
    };

    _this.renderMultiEntryInputs = function () {
      var entries = _this.state.urlValue.map(function (entry, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'url-filter-multi-entry-item', key: 'url-value-' + index },
          _this.renderTypeComponent(entry, index),
          index > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'url-filter-multi-entry-remove', onClick: function onClick() {
                return _this.removeEntryFromUrlValue(index);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { name: 'close', height: 12, width: 12 })
          )
        );
      });
      return entries;
    };

    _this.state = {
      fieldType: props.activeFilter.field,
      operatorType: props.activeFilter.operator,
      urlValue: props.activeFilter.value
    };
    return _this;
  }

  _createClass(UrlFilter, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice rules-url-filter' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose a URL'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Match on a number of URL parameters such as, Path, Host, and Query Param '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'url-rules-editor-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'url-rules-editor-item' },
            this.renderTypeSelect()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'url-rules-editor-item' },
            this.renderOperatorType()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'url-rules-editor-item' },
            this.renderMultiEntryInputs(),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
                { className: 'url-filter-multi-entry-add', size: 'small', type: 'subtle', onClick: this.addEntryToUrlValue },
                '+'
              )
            )
          )
        )
      );
    }
  }]);

  return UrlFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UrlFilter);

/***/ }),

/***/ "3MHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_flag_long_svg__ = __webpack_require__("oSV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_flag_long_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_flag_long_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_user_outline_svg__ = __webpack_require__("ORV9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_user_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_user_outline_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_circle_svg__ = __webpack_require__("F13r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_bot_svg__ = __webpack_require__("epiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_bot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_bot_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_welcome_message_svg__ = __webpack_require__("eJSL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_welcome_message_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_welcome_message_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_svg_email_svg__ = __webpack_require__("KPF2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_svg_email_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_svg_email_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__("xmI2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















/**
 * WARNING: this file is a time suck, please double and triple check your logic when changing conditionals here
 *
 * TODO: we should rewrite this and re-evaluate the logic to be clearer
 */

var shouldNotShowSegmentInclusion = function shouldNotShowSegmentInclusion(isDriftLinkOnly, hasOnlyExclusionTargeting, hasSegmentDisplayTargeting) {
  return isDriftLinkOnly || hasOnlyExclusionTargeting || hasSegmentDisplayTargeting;
};

var Group = function Group(_ref) {
  var iconSrc = _ref.iconSrc,
      to = _ref.to,
      title = _ref.title,
      children = _ref.children,
      iconClassName = _ref.iconClassName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
    { className: 'nav-group' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
      { to: to, className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('icon-container', iconClassName) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: iconSrc })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      title
    ),
    children
  );
};

var ActiveLink = function ActiveLink(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */], _extends({}, props, { activeClassName: 'active' }));
};

var MessageGroup = function MessageGroup(_ref2) {
  var baseUrl = _ref2.baseUrl,
      isMessageTypePlaybook = _ref2.isMessageTypePlaybook,
      _ref2$viewConfig = _ref2.viewConfig,
      messageUrlPath = _ref2$viewConfig.messageUrlPath,
      label = _ref2$viewConfig.label,
      previewUrlPath = _ref2$viewConfig.previewUrlPath;
  return isMessageTypePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    {
      to: baseUrl + '/message/' + messageUrlPath,
      title: 'Message',
      iconSrc: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_welcome_message_svg___default.a,
      iconClassName: 'action-group'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/message/' + messageUrlPath },
      label
    ),
    previewUrlPath && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/message/' + previewUrlPath },
      'Preview & Template'
    )
  );
};

var SequenceGroup = function SequenceGroup(_ref3) {
  var baseUrl = _ref3.baseUrl,
      isSequencePlaybook = _ref3.isSequencePlaybook,
      isMarketingSequencePlaybook = _ref3.isMarketingSequencePlaybook,
      isOneTimeMarketingSequencePlaybook = _ref3.isOneTimeMarketingSequencePlaybook;
  return isSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    { to: baseUrl + '/sequence', title: isMarketingSequencePlaybook ? "Email" : "Sequence", iconSrc: __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_svg_email_svg___default.a, iconClassName: 'sequence-group' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/sequence' },
      'Compose your email',
      isOneTimeMarketingSequencePlaybook ? '' : 's'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/sequence/preview' },
      'Preview'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/sequence/options' },
      'Advanced options'
    )
  );
};

var GoalsGroup = function GoalsGroup(_ref4) {
  var baseUrl = _ref4.baseUrl,
      goals = _ref4.goals,
      onAddGoalClick = _ref4.onAddGoalClick,
      classificationsByGoalId = _ref4.classificationsByGoalId,
      isMessageTypePlaybook = _ref4.isMessageTypePlaybook;
  return !goals.isEmpty() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    { title: 'Goals', iconSrc: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_flag_long_svg___default.a, iconClassName: 'goals-group', to: baseUrl + '/goal/' + goals.first().id },
    goals.toArray().map(function (goal, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ActiveLink,
        { key: 'link-' + goal.id, to: baseUrl + '/goal/' + goal.id },
        classificationsByGoalId.get(goal.id, 'Goal ' + (index + 1))
      );
    }),
    !isMessageTypePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
      { className: 'add-goal-link', onClick: onAddGoalClick },
      '+add new goal'
    )
  );
};

var LeadBotGroup = function LeadBotGroup(_ref5) {
  var baseUrl = _ref5.baseUrl,
      numQuestions = _ref5.numQuestions,
      isLeadBot = _ref5.isLeadBot;
  return isLeadBot && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    { to: baseUrl + '/leadbot', title: 'LeadBot', iconSrc: __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_bot_svg___default.a, iconClassName: 'action-group' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/leadbot' },
      numQuestions,
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(numQuestions, 'question')
    )
  );
};

var TargetingDriftLink = function TargetingDriftLink(_ref6) {
  var driftLink = _ref6.driftLink,
      baseUrl = _ref6.baseUrl,
      hasDriftLink = _ref6.hasDriftLink,
      hasOnlyExclusionTargeting = _ref6.hasOnlyExclusionTargeting,
      isSignaturePlaybook = _ref6.isSignaturePlaybook;

  if (!hasDriftLink || hasOnlyExclusionTargeting || isSignaturePlaybook) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ActiveLink,
    { key: 'playbook-nav-targeting-driftlink', to: baseUrl + '/targeting/driftlink' },
    '#DriftLink',
    !!driftLink && ' - #' + driftLink
  );
};

var TargetingSegmentInclude = function TargetingSegmentInclude(_ref7) {
  var isDriftLinkOnly = _ref7.isDriftLinkOnly,
      hasOnlyExclusionTargeting = _ref7.hasOnlyExclusionTargeting,
      hasSegmentDisplayTargeting = _ref7.hasSegmentDisplayTargeting,
      audiencePreview = _ref7.audiencePreview,
      audienceInclusionPreview = _ref7.audienceInclusionPreview,
      baseUrl = _ref7.baseUrl,
      isSignaturePlaybook = _ref7.isSignaturePlaybook,
      isOnFreePlan = _ref7.isOnFreePlan;

  if (shouldNotShowSegmentInclusion(isDriftLinkOnly, hasOnlyExclusionTargeting, hasSegmentDisplayTargeting) || isSignaturePlaybook) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ActiveLink,
    { key: 'playbook-nav-targeting-' + audiencePreview, to: !isOnFreePlan && baseUrl + '/targeting/audience', className: '' + (isOnFreePlan ? 'playbook-nav-targeting-link-disabled' : '') },
    'Audience - ',
    audienceInclusionPreview
  );
};

var TargetingSegmentExclude = function TargetingSegmentExclude(_ref8) {
  var audiencePreview = _ref8.audiencePreview,
      baseUrl = _ref8.baseUrl,
      excludedUserListIds = _ref8.excludedUserListIds,
      userListIds = _ref8.userListIds,
      hasOnlyExclusionTargeting = _ref8.hasOnlyExclusionTargeting,
      isSignaturePlaybook = _ref8.isSignaturePlaybook;

  if (!hasOnlyExclusionTargeting || isSignaturePlaybook) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ActiveLink,
    { key: 'playbook-nav-targeting-exclusion-' + audiencePreview, to: baseUrl + '/targeting/exclude' },
    'Exclusion',
    excludedUserListIds.size > 0 ? ' - ' + excludedUserListIds.size + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(userListIds.size, 'Segment') : ''
  );
};

var TargetingDisplayConditions = function TargetingDisplayConditions(_ref9) {
  var isDriftLinkOnly = _ref9.isDriftLinkOnly,
      isEmailPlaybook = _ref9.isEmailPlaybook,
      hasOnlyExclusionTargeting = _ref9.hasOnlyExclusionTargeting,
      resetTargetingView = _ref9.resetTargetingView,
      baseUrl = _ref9.baseUrl,
      targetingConditionsCount = _ref9.targetingConditionsCount,
      renderDisplayPreview = _ref9.renderDisplayPreview,
      isSignaturePlaybook = _ref9.isSignaturePlaybook;

  if (isDriftLinkOnly || isEmailPlaybook || hasOnlyExclusionTargeting || isSignaturePlaybook) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ActiveLink,
    {
      key: 'playbook-nav-targeting-display-' + renderDisplayPreview(),
      onClick: resetTargetingView,
      to: baseUrl + '/targeting/' + (targetingConditionsCount > 0 ? 'displaywhen' : 'display')
    },
    'Display - ',
    renderDisplayPreview()
  );
};

var TargetingAdvanced = function TargetingAdvanced(_ref10) {
  var isDriftLinkOnly = _ref10.isDriftLinkOnly,
      hasOnlyExclusionTargeting = _ref10.hasOnlyExclusionTargeting,
      isEmailPlaybook = _ref10.isEmailPlaybook,
      baseUrl = _ref10.baseUrl,
      isSignaturePlaybook = _ref10.isSignaturePlaybook;

  if (isDriftLinkOnly || hasOnlyExclusionTargeting || isEmailPlaybook || isSignaturePlaybook) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    ActiveLink,
    {
      className: 'playbook-nav-targeting-advanced',
      key: 'playbook-nav-targeting-advanced',
      to: baseUrl + '/targeting/advanced'
    },
    'Frequency'
  );
};

var TargetingGroup = function TargetingGroup(props) {
  return !props.isSignaturePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    {
      title: props.targetingGroupTitle,
      iconSrc: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_user_outline_svg___default.a,
      iconClassName: 'targeting-group',
      to: props.baseUrl + '/targeting/' + props.targetingIconLink
    },
    TargetingDriftLink(props),
    TargetingSegmentInclude(props),
    TargetingSegmentExclude(props),
    TargetingDisplayConditions(props),
    TargetingAdvanced(props)
  );
};

var ReviewGroup = function ReviewGroup(_ref11) {
  var reviewText = _ref11.reviewText,
      baseUrl = _ref11.baseUrl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    { title: 'Review', iconSrc: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_circle_svg___default.a, iconClassName: 'review-group', to: baseUrl + '/review' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { key: 'playbook-nav-enable', to: baseUrl + '/review' },
      reviewText
    )
  );
};

var SignatureGroup = function SignatureGroup(_ref12) {
  var isSignaturePlaybook = _ref12.isSignaturePlaybook,
      baseUrl = _ref12.baseUrl;
  return !!isSignaturePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Group,
    { to: baseUrl + '/message/signature', title: 'Signature', iconSrc: __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_svg_email_svg___default.a, iconClassName: 'sequence-group' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/message/signature' },
      'Compose template'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      ActiveLink,
      { to: baseUrl + '/message/signature-preview' },
      'Preview team signatures'
    )
  );
};

var Nav = function Nav(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'nav',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SignatureGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MessageGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SequenceGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LeadBotGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GoalsGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TargetingGroup, props),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ReviewGroup, props)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Nav);

/***/ }),

/***/ "3NcN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3O7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("RBcE");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var apiKey = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getApiKeyForOrgSuccess */]), function (state, action) {
  return action.payload[0];
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createApiKeyForOrgSuccess */]), function (state, action) {
  return action.payload;
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
  apiKey: apiKey
}));

/***/ }),

/***/ "3UPu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var companyData = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
    "source": "DEMANDBASE",
    "name": "Wayfair",
    "url": "http://wayfair.com",
    "logo": "https://logo.clearbit.com/wayfair.com",
    "location": "4 Copley Pl, Boston, MA 02116, USA",
    "social": {
        "twitter": {
            "handle": "Wayfair"
        },
        "linkedin": {
            "handle": "company/wayfair"
        }
    },
    "category": {
        "industry": "Internet Software & Services",
        "subIndustry": "Internet Software & Services"
    },
    "metrics": {
        "raised": 0,
        "revenueRange": null,
        "employees": 7030
    },
    "geography": {
        "city": "Boston",
        "state": "Massachusetts",
        "country": "United States",
        "countryCode": "US"
    }
});

/***/ }),

/***/ "3WI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__ = __webpack_require__("lzSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__ = __webpack_require__("xIgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var InboxQueries = Marty.createQueries({
  id: 'InboxQueries',

  fetchInboxes: function fetchInboxes() {
    var _this = this;

    var inboxesPromise = this.app.sources.InboxAPI.fetchInboxes();

    inboxesPromise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_LIST_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_LIST_FETCH_FAILED, res);
      }
    });

    return inboxesPromise.catch(function (error) {
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_LIST_FETCH_FAILED, error);
    });
  },
  fetchInbox: function fetchInbox(inboxId) {
    var _this2 = this;

    var inboxPromise = this.app.sources.InboxAPI.fetchInbox(inboxId);

    inboxPromise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_FETCH_DONE, inboxId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_FETCH_FAILED, inboxId, res);
      }
    });

    return inboxPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_FETCH_FAILED, inboxId, error);
    });
  },
  archiveInbox: function archiveInbox(inboxId) {
    var _this3 = this;

    var inboxPromise = this.app.sources.InboxAPI.archiveInbox(inboxId);

    inboxPromise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE_DONE, inboxId);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE_FAILED, inboxId);
      }
    });

    return inboxPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE_FAILED, inboxId, error);
    });
  },
  fetchInboxMetrics: function fetchInboxMetrics(inboxId, startDate, endDate) {
    var _this4 = this;

    var dashboardPromise = this.app.sources.InboxAPI.fetchInboxMetrics(inboxId, startDate, endDate);

    return dashboardPromise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__["a" /* default */].INBOX_FETCH_STATS_DONE, inboxId, startDate, endDate, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__["a" /* default */].INBOX_FETCH_STATS_FAILED, inboxId, startDate, endDate, res.body);
      }
    });
  },
  updateInbox: function updateInbox(inboxId, params) {
    var _this5 = this;

    var updateInboxPromise = this.app.sources.InboxAPI.updateInbox(inboxId, params);
    updateInboxPromise.then(function (res) {
      if (res.status === 200) {
        _this5.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_UPDATE_DONE, inboxId, res.body);
        return _this5.app.actions.NotificationActions.pushNotification({
          content: 'Your ' + res.body.name + ' inbox has been updated!'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_UPDATE_FAILED, inboxId, res);
      }
    });

    return updateInboxPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_UPDATE_FAILED, inboxId, error);
    });
  },
  createInbox: function createInbox(params) {
    var _this6 = this;

    var createInboxPromise = this.app.sources.InboxAPI.createInbox(params);
    createInboxPromise.then(function (res) {
      if (res.status === 200) {
        _this6.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_CREATE_DONE, res.body);
        return _this6.app.actions.NotificationActions.pushNotification({
          content: res.body.name + ' has been created as a new inbox!'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_CREATE_FAILED, res);
      }
    });

    return createInboxPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_CREATE_FAILED, error);
    });
  },
  checkInboxExistsForEmail: function checkInboxExistsForEmail(email) {
    var _this7 = this;

    return this.app.sources.InboxAPI.checkInboxExistsForEmail(email).then(function (res) {
      if (res.status === 200 && res.body.length) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE, email, true);
      } else if (res.body.length === 0) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE, email, false);
      } else {
        _this7.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL_FAILED, email, res);
        return Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(CustomerConstants.CHECK_INBOX_EXISTENCE_BY_EMAIL_FAILED, email, orgHandle, error);
    });
  },
  createWhiteListLabels: function createWhiteListLabels(domain) {
    var _this8 = this;

    var createWhiteListLabelsPromise = this.app.sources.InboxAPI.createWhiteLabelConfiguration(domain);
    return createWhiteListLabelsPromise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_CREATE_DONE, domain, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_CREATE_FAILED, res);
      }
    });
  },
  fetchWhiteListLabelsByDomain: function fetchWhiteListLabelsByDomain(domain) {
    var _this9 = this;

    return this.app.sources.InboxAPI.fetchWhiteListLabels(domain).then(function (res) {
      if (res.status === 200) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_FETCH_DONE, domain, res.body);
      } else if (res.status === 404) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE, domain, {});
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_FETCH_DONE, domain, {});
      }
    });
  },
  validateWhiteListLabels: function validateWhiteListLabels(domain) {
    var _this10 = this;

    return this.app.sources.InboxAPI.validateWhiteListLabels(domain).then(function (res) {
      if (res.status === 200) {
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE, domain, res.body);
      } else if (res.status === 404) {
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE, domain, {});
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_FAILED, domain, {});
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (InboxQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "3Z2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony default export */ __webpack_exports__["a"] = (function () {
    return React.createElement(
        "svg",
        { width: "100px", height: "32px", viewBox: "0 0 100 32", version: "1.1" },
        React.createElement("defs", null),
        React.createElement(
            "g",
            { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement(
                "g",
                { id: "ADMIN-connect", transform: "translate(-369.000000, -336.000000)", fill: "#EB3C00", fillRule: "nonzero" },
                React.createElement(
                    "g",
                    { id: "microsoft-office-2013", transform: "translate(369.000000, 336.000000)" },
                    React.createElement("path", { d: "M0.248,25.805 L0.248,6.547 L17.284,0.251 L26.5425,3.213 L26.5425,29.138 L17.284,31.929 L0.248,25.805 L17.284,27.855 L17.284,5.4365 L6.1735,8.029 L6.1735,23.2135 L0.2485,25.805 L0.248,25.805 Z M44.6865,25.94 C42.0055,25.94 39.8575,25.0555 38.244,23.288 C36.63,21.5215 35.824,19.2215 35.824,16.39 C35.824,13.348 36.646,10.921 38.29,9.11 C39.934,7.299 42.172,6.3935 45.0025,6.3935 C47.614,6.3935 49.7175,7.273 51.3135,9.031 C52.9095,10.79 53.7075,13.089 53.7075,15.929 C53.7075,19.015 52.889,21.4545 51.254,23.249 C49.619,25.0435 47.4305,25.9395 44.6865,25.9395 L44.6865,25.94 Z M44.8445,8.3985 C42.8575,8.3985 41.2445,9.1155 40.0045,10.5485 C38.7645,11.9815 38.1445,13.8635 38.1445,16.193 C38.1445,18.5225 38.7495,20.398 39.958,21.818 C41.1665,23.238 42.743,23.948 44.686,23.948 C46.7605,23.948 48.3965,23.271 49.592,21.917 C50.7875,20.563 51.386,18.6685 51.386,16.233 C51.386,13.7355 50.805,11.806 49.6445,10.443 C48.485,9.0805 46.8845,8.398 44.8445,8.398 L44.8445,8.3985 Z M61.5885,5.3375 C60.366,5.3375 59.3505,5.754 58.5335,6.576 C57.716,7.3975 57.3065,8.5165 57.3065,9.932 L57.3065,12.12 L55.0035,12.12 L55.0035,13.9715 L57.3065,13.9715 L57.3065,25.625 L59.4595,25.625 L59.4595,13.9715 L64.7245,13.9715 L64.7245,25.625 L66.8775,25.625 L66.8775,13.9715 L70.0375,13.9715 L70.0375,12.12 L66.8775,12.12 L66.8775,10.0365 C66.8775,8.129 67.634,7.1785 69.146,7.1785 C69.6825,7.1785 70.1595,7.2885 70.581,7.5255 L70.581,5.5815 C70.1945,5.4235 69.678,5.338 69.019,5.338 C67.7965,5.338 66.7695,5.755 65.952,6.5765 C65.134,7.3985 64.725,8.5175 64.725,9.9325 L64.725,12.1205 L59.4595,12.1205 L59.4595,10.0375 C59.4595,8.1295 60.2145,7.179 61.7275,7.179 C62.2635,7.179 62.7405,7.289 63.1625,7.526 L63.1625,5.582 C62.7755,5.4225 62.248,5.3375 61.5885,5.3375 Z M73.1825,8.6875 C72.8127684,8.6942961 72.4559592,8.5515003 72.193,8.2915 C71.9205,8.0275 71.784,7.694 71.784,7.2895 C71.784,6.885 71.9205,6.549 72.193,6.281 C72.4540322,6.01734254 72.8115422,5.87191781 73.1825,5.8785 C73.578,5.8785 73.914,6.012 74.1915,6.281 C74.469,6.549 74.6065,6.885 74.6065,7.2895 C74.612639,7.66285722 74.4621302,8.02172082 74.1915,8.279 C73.9145,8.551 73.578,8.6875 73.1825,8.6875 Z M74.2375,25.621 L72.0745,25.621 L72.0745,12.116 L74.237,12.116 L74.237,25.621 L74.2375,25.621 Z M86.5255,25.0015 C85.4885,25.6255 84.2565,25.938 82.833,25.938 C80.9075,25.938 79.3535,25.3115 78.1715,24.058 C76.9895,22.8045 76.3965,21.1815 76.3965,19.185 C76.3965,16.96 77.034,15.1735 78.309,13.824 C79.5845,12.474 81.2855,11.7995 83.4135,11.7995 C84.5995,11.7995 85.6465,12.0195 86.552,12.4595 L86.552,14.6745 C85.55,13.9715 84.477,13.6195 83.3345,13.6195 C81.9535,13.6195 80.8215,14.1145 79.9375,15.1035 C79.054,16.093 78.6125,17.3915 78.6125,19.0005 C78.6125,20.5835 79.0275,21.832 79.858,22.7465 C80.6895,23.6605 81.803,24.1175 83.202,24.1175 C84.3795,24.1175 85.4885,23.726 86.5255,22.944 L86.5255,25.0015 Z M99.747,19.41 L90.212,19.41 C90.247,20.913 90.6515,22.0735 91.4245,22.8915 C92.1995,23.7085 93.2625,24.1175 94.617,24.1175 C96.138,24.1175 97.5365,23.6165 98.8105,22.614 L98.8105,24.645 C97.624,25.5065 96.0545,25.9375 94.1025,25.9375 C92.1945,25.9375 90.695,25.3245 89.6055,24.0975 C88.515,22.8705 87.97,21.146 87.97,18.921 C87.97,16.8195 88.5655,15.107 89.7565,13.7835 C90.948,12.46 92.4275,11.799 94.1945,11.799 C95.9615,11.799 97.329,12.3705 98.296,13.5135 C99.263,14.6565 99.746,16.2435 99.746,18.2745 L99.746,19.4095 L99.747,19.41 Z M97.532,17.5765 C97.523,16.328 97.222,15.3565 96.628,14.662 C96.0345,13.967 95.21,13.62 94.1555,13.62 C93.135,13.62 92.2695,13.9855 91.557,14.715 C90.845,15.445 90.4055,16.399 90.239,17.5765 L97.5315,17.5765 L97.532,17.5765 Z", id: "Shape" })
                )
            )
        )
    );
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "3cP2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3d7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_enrichment_demandbase_selectors__ = __webpack_require__("OtCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_enrichment_demandbase_actions__ = __webpack_require__("FFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TargetConditionTypes__ = __webpack_require__("3CEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style__ = __webpack_require__("MShG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_targeting_actions__ = __webpack_require__("hKIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_targeting_selectors__ = __webpack_require__("bqmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_Integrations__ = __webpack_require__("CCiW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























function DeleteButton(_ref) {
  var onClick = _ref.onClick;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    {
      onClick: onClick,
      className: 'delete-button'
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, {
      className: 'gray-icon',
      style: { width: 12, height: 16 },
      element: 'div',
      src: __webpack_require__("fZJU")
    })
  );
}

function AddConditionCta(_ref2) {
  var onClick = _ref2.onClick;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetConditions, 'flex-center') },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'a',
      {
        className: 'dsg-Link',
        onClick: onClick
      },
      'Click here to add a new condition'
    )
  );
}

function AddConditionButton(_ref3) {
  var onClick = _ref3.onClick;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    {
      className: 'dsg-IconButton2 add-condition',
      style: { backgroundColor: __WEBPACK_IMPORTED_MODULE_15_styles_colors___default.a["color-green"] },
      onClick: onClick
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, {
      style: { width: 8, height: 8, marginRight: 6 },
      element: 'div',
      src: __webpack_require__("EI0t")
    }),
    'AND'
  );
}

function AddConditionSetButton(_ref4) {
  var onClick = _ref4.onClick;

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    {
      className: 'dsg-IconButton2 add-condition-set',
      style: { backgroundColor: __WEBPACK_IMPORTED_MODULE_15_styles_colors___default.a["color-green"] },
      onClick: onClick
    },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, {
      style: { width: 8, height: 8, marginRight: 6 },
      element: 'div',
      src: __webpack_require__("EI0t")
    }),
    'OR'
  );
}

var TargetConditionEditModal = function (_Component) {
  _inherits(TargetConditionEditModal, _Component);

  function TargetConditionEditModal(props) {
    _classCallCheck(this, TargetConditionEditModal);

    var _this = _possibleConstructorReturn(this, (TargetConditionEditModal.__proto__ || Object.getPrototypeOf(TargetConditionEditModal)).call(this, props));

    _initialiseProps.call(_this);

    var target = {};
    if (props.editTarget) {
      target = props.editTarget;
    }
    target = __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.fromJS(target);
    _this.state = { target: target, ogTarget: target };
    return _this;
  }

  _createClass(TargetConditionEditModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          actions = _props.actions,
          hasDemandbase = _props.hasDemandbase;


      if (hasDemandbase) {
        actions.fetchDemandbaseTargetingIndustries();
        actions.fetchDemandbaseTargetingSubIndustries();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.wasTargetUpdated !== prevProps.wasTargetUpdated) {
        this.context.app.queries.DefaultEmbedQueries.refreshDefaultEmbed(this.props.org.id).then(function () {
          _this2.props.onSave(_this2.props.lastUpdatedTargetId);
          _this2.props.onClose();
        });
      }

      if (this.props.wasTargetCreated !== prevProps.wasTargetCreated) {
        this.props.onSave(this.props.lastCreatedTargetId);
        this.props.onClose();
      }
    }
  }, {
    key: 'makeChangeHandler',
    value: function makeChangeHandler(key) {
      var _this3 = this;

      return function (input) {
        var target = _this3.state.target.set(key, input);
        _this3.setState({ target: target });
      };
    }
  }, {
    key: 'updateTarget',
    value: function updateTarget(target) {
      this.setState({ target: target });
    }
  }, {
    key: 'updateConditions',
    value: function updateConditions(conditions) {
      this.updateTarget(this.state.target.set('conditions', conditions));
    }
  }, {
    key: 'makeOnConditionSelection',
    value: function makeOnConditionSelection(innerIndex, outerIndex) {
      var _this4 = this;

      return function (value) {
        if (value !== null) {
          var selected = _this4.getTargetConditionTypes()[value.value];
          var target = _this4.state.target.setIn(['conditions', outerIndex, innerIndex], __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.fromJS(selected.default));
          _this4.updateTarget(target);
        }
      };
    }
  }, {
    key: 'makeConditionUpdater',
    value: function makeConditionUpdater(innerIndex, outerIndex) {
      var _this5 = this;

      return function (key, value) {
        var target = _this5.state.target.setIn(['conditions', outerIndex, innerIndex, key], value);
        _this5.updateTarget(target);
      };
    }
  }, {
    key: 'renderConditions',
    value: function renderConditions() {
      var _this6 = this;

      var conditions = this.state.target.get('conditions');
      return conditions.map(function (condition, outerIndex) {
        return [!!outerIndex && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'or-condition' },
          'OR'
        ), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetConditions },
          condition.map(function (_condition, innerIndex) {
            var isLastCondition = innerIndex === condition.size - 1;
            return [!!innerIndex && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'and-condition' },
              'AND'
            ), _this6.renderCondition(_condition, innerIndex, outerIndex), isLastCondition && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(AddConditionButton, { onClick: function onClick() {
                return _this6.handleAddCondition(outerIndex);
              } })];
          })
        )];
      });
    }
  }, {
    key: 'renderCondition',
    value: function renderCondition(condition, innerIndex, outerIndex) {
      var _this7 = this;

      var selectedCondition = Object(__WEBPACK_IMPORTED_MODULE_16__TargetConditionTypes__["b" /* getTargetCondition */])(condition.get('field'), condition.get('operator'));
      if (!selectedCondition) {
        throw new Error('target condtion type not found for ' + JSON.stringify(condition.toJS()));
      }
      var options = _.sortBy(_.map(this.getTargetConditionTypes(), function (value, key) {
        return { value: key, label: value.display };
      }), function (_ref5) {
        var text = _ref5.text;
        return text;
      });
      var filteredOptions = _.filter(options, function (option) {
        return option.value !== 'TeamHours' || !!_this7.props.hasTeamHours;
      });
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetCondition },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__driftt_tide_core_legacy__["Select"], {
          size: 'small',
          onChange: this.makeOnConditionSelection(innerIndex, outerIndex),
          options: filteredOptions,
          value: { value: selectedCondition.default.field, label: selectedCondition.display },
          clearable: false
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(selectedCondition.component, _extends({
          conditionValue: condition,
          conditionUpdater: this.makeConditionUpdater(innerIndex, outerIndex)
        }, this.props)),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(DeleteButton, { onClick: function onClick() {
            var conditions = _this7.state.target.get('conditions');
            var newInnerCondition = conditions.get(outerIndex).delete(innerIndex);
            var newConditions = newInnerCondition.size === 0 ? conditions.delete(outerIndex) : conditions.set(outerIndex, conditions.get(outerIndex).delete(innerIndex));
            _this7.updateConditions(newConditions);
          } })
      );
    }
  }, {
    key: 'canSave',
    value: function canSave() {
      return !this.validateName() && this.state.ogTarget !== this.state.target && this.areConditionsValid();
    }
  }, {
    key: 'validateName',


    /**
     * return a validation error if any for the name
     * @returns {string}
     */
    value: function validateName() {
      var name = this.state.target.get('name');
      if (!name) {
        return 'Need a name';
      }
      var isItsOwnName = this.props.editTarget && name === this.props.editTarget.name;
      if (!this.props.targets || isItsOwnName) return;
      var nameTaken = __WEBPACK_IMPORTED_MODULE_7_lodash_keyBy___default()(this.props.targets, 'name')[name];
      if (nameTaken) return 'Name taken';
    }
  }, {
    key: 'areConditionsValid',
    value: function areConditionsValid() {
      var conditions = this.state.target.get('conditions');
      if (!conditions || !conditions.size) return false;
      return true;
    }
  }, {
    key: 'renderNameInput',
    value: function renderNameInput() {
      var invalidLabel = this.validateName();
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Input___default.a, {
        valueLink: {
          requestChange: this.makeChangeHandler('name'),
          value: this.state.target.get('name')
        },
        isValid: !invalidLabel,
        invalidLabel: invalidLabel,
        label: 'Name condition set'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var conditions = this.state.target.get('conditions');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_17_components_shared_Modal__["a" /* default */],
        {
          onRequestClose: this.props.onClose,
          modalContentClassName: __WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetModal,
          isOpen: true,
          style: {
            overlay: {
              maxHeight: '100vh',
              overflowY: 'auto'
            },
            content: {
              padding: 0,
              width: 850,
              maxHeight: '90%',
              overflow: 'auto',
              minHeight: 500
            }
          }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("flex-space-between", __WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetModal__Header) },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'dsg-h3' },
            'Display When...'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'flex-space-between' },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'a',
              { className: 'dsg-Label--gray', style: { marginRight: '1rem' }, onClick: this.props.onClose },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'button',
              {
                className: 'dsg-MediumButton',
                disabled: !this.canSave(),
                onClick: this.handleSaveClick
              },
              'Save'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_18__style___default.a.TargetModal__Content },
          this.renderNameInput(),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'flex-space-between helper-text' },
            'Display to visitors who match the following conditions:'
          ),
          conditions && conditions.size ? this.renderConditions() : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(AddConditionCta, { onClick: function onClick() {
              return _this8.handleAddNewOrCondition();
            } }),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(AddConditionSetButton, { onClick: this.handleAddNewOrCondition })
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'widget-targeting-help-link', target: '_blank', href: 'https://gethelp.drift.com/hc/en-us/articles/360019350874-How-to-Target-Playbooks-Using-Targeting-Conditions' },
          'Learn more about targeting with Drift'
        )
      );
    }
  }]);

  return TargetConditionEditModal;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

TargetConditionEditModal.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.getTargetConditionTypes = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_16__TargetConditionTypes__["a" /* default */]).filter(function (condition) {
      return _this9.isValidCondition(condition);
    }).toJS();
  };

  this.isValidCondition = function (condition) {
    if (!!condition.gates && !__WEBPACK_IMPORTED_MODULE_8_utils_Access__["c" /* default */].hasGates(condition.gates)) {
      return false;
    } else if (!!condition.requiredIntegration && !Object(__WEBPACK_IMPORTED_MODULE_22_utils_Integrations__["b" /* isIntegrationConnected */])(condition.requiredIntegration)) {
      return false;
    }

    return true;
  };

  this.handleAddNewOrCondition = function () {
    var conditions = _this9.state.target.get('conditions');
    var types = _.values(_this9.getTargetConditionTypes());
    var typeToAdd = types && types[0];
    if (!typeToAdd) return;
    conditions = conditions || __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.List();
    conditions = conditions.push(__WEBPACK_IMPORTED_MODULE_4_immutable___default.a.List([__WEBPACK_IMPORTED_MODULE_4_immutable___default.a.fromJS(typeToAdd.default)]));
    _this9.updateConditions(conditions);
  };

  this.handleAddCondition = function (outerIndex) {
    var conditions = _this9.state.target.get('conditions');
    var types = _.values(_this9.getTargetConditionTypes());
    var typeToAdd = types && types[0];
    if (!typeToAdd) return;
    conditions = conditions.set(outerIndex, (conditions.get(outerIndex) || __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.List()).push(__WEBPACK_IMPORTED_MODULE_4_immutable___default.a.fromJS(typeToAdd.default)));
    _this9.updateConditions(conditions);
  };

  this.handleSaveClick = function () {
    if (!_this9.canSave()) return;
    var target = _this9.state.target.toJS();

    if (!_this9.props.editTarget) {
      _this9.props.actions.createTarget(target);
    } else {
      var operations = Object(__WEBPACK_IMPORTED_MODULE_13_utils_PatchHelper__["a" /* patchOperations */])(target, _this9.props.editTarget);
      if (_.isEmpty(operations)) return;
      _this9.props.actions.updateTarget({ operations: operations, targetId: target.id });
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      createTarget: __WEBPACK_IMPORTED_MODULE_19_app_modules_targeting_actions__["a" /* createTarget */],
      updateTarget: __WEBPACK_IMPORTED_MODULE_19_app_modules_targeting_actions__["i" /* updateTarget */],
      fetchDemandbaseTargetingIndustries: __WEBPACK_IMPORTED_MODULE_12_app_modules_enrichment_demandbase_actions__["f" /* fetchDemandbaseTargetingIndustries */],
      fetchDemandbaseTargetingSubIndustries: __WEBPACK_IMPORTED_MODULE_12_app_modules_enrichment_demandbase_actions__["j" /* fetchDemandbaseTargetingSubIndustries */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasTeamHours: __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__["r" /* hasTeamHours */](state),
    hasDemandbase: Object(__WEBPACK_IMPORTED_MODULE_21_app_modules_integrations_selectors__["l" /* isConnectedTo */])(state, 'demandbase'),
    wasTargetCreated: Object(__WEBPACK_IMPORTED_MODULE_20_app_modules_targeting_selectors__["d" /* wasTargetCreated */])(state),
    wasTargetUpdated: Object(__WEBPACK_IMPORTED_MODULE_20_app_modules_targeting_selectors__["e" /* wasTargetUpdated */])(state),
    lastCreatedTargetId: Object(__WEBPACK_IMPORTED_MODULE_20_app_modules_targeting_selectors__["b" /* lastCreatedTargetId */])(state),
    lastUpdatedTargetId: Object(__WEBPACK_IMPORTED_MODULE_20_app_modules_targeting_selectors__["c" /* lastUpdatedTargetId */])(state),
    demandbaseIndustries: __WEBPACK_IMPORTED_MODULE_11_app_modules_enrichment_demandbase_selectors__["a" /* demandbaseTargetingIndustries */](state),
    demandbaseSubIndustries: __WEBPACK_IMPORTED_MODULE_11_app_modules_enrichment_demandbase_selectors__["b" /* demandbaseTargetingSubIndustries */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(TargetConditionEditModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "3eLe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3iND":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 5\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.333 3.667h9.334a1.333 1.333 0 0 0 0-2.667H2.333a1.333 1.333 0 0 0 0 2.667z\" stroke=\"#394F5A\" stroke-width=\"0.55\" fill=\"#EB5735\" fill-rule=\"nonzero\"></path></svg>"

/***/ }),

/***/ "3iTR":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.583 14.605s-.06-1.714 0-1.953l.645-2.58c.006-.022.02-.038.028-.059.02-.06.05-.114.08-.17a.986.986 0 0 1 .105-.156c.014-.016.02-.038.035-.054L10 1.11c.026-.027.062-.038.091-.06a.86.86 0 0 1 .16-.106.893.893 0 0 1 .18-.064c.035-.01.065-.032.102-.037.2-.029 1.982-.247 3.069.92 1.064 1.133.86 2.796.834 2.982-.007.043-.028.077-.04.116-.014.052-.027.101-.05.151a.974.974 0 0 1-.123.186c-.021.025-.03.056-.054.08l-8.523 8.523c-.016.016-.038.021-.054.035a.921.921 0 0 1-.157.104.875.875 0 0 1-.17.082c-.021.007-.036.022-.058.028l-2.216.554H.583zm11.64-11.551c-.27-.29-.8-.35-1.143-.353l-.935.935 1.498 1.498.936-.936c-.004-.34-.073-.841-.356-1.144zM4.496 12.28l5.812-5.812L8.81 4.972l-5.812 5.811-.5 1.998 1.998-.5z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "3inQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__ = __webpack_require__("c4Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component__ = __webpack_require__("uXhd");















var mapStateToProps = function mapStateToProps(state) {
  return {
    draftScheduledTimestamp: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["s" /* dueAt */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setDraftSchedule: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_150" /* setDraftSchedule */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_8_recompose_withState___default()('selectedDateTime', 'setDateTime', function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(props.draftScheduledTimestamp).tz(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess());
}), __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default()(function (props) {
  return {
    selectedDateTimeFormatted: React.createElement(
      'span',
      null,
      props.selectedDateTime.format('ddd MMM D, YYYY'),
      ' at',
      ' ',
      React.createElement(
        'div',
        null,
        props.selectedDateTime.format('h:mmA zz')
      )
    )
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  handleSetDateTime: function handleSetDateTime(props) {
    return function (m) {
      props.setDateTime(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(m).tz(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()));
      props.actions.setDraftSchedule(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(m).tz(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()));
    };
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (props) {
  return !props.selectedDateTime;
}, __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default.a))(__WEBPACK_IMPORTED_MODULE_11__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "3j7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getColor;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSeatColor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_colors__);


function getColor(percent) {
  if (percent >= 90) {
    return __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-orange'];
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green'];
  }
}

function getSeatColor(percent) {
  if (percent > 100) {
    return __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-orange'];
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green'];
  }
}

/***/ }),

/***/ "3kMP":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Routing-/-Calendar-Edge-States\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Default\" transform=\"translate(-520.000000, -762.000000)\" fill=\"#D0011B\"><path d=\"M528.5,779 C523.812958,779 520,775.187042 520,770.5 C520,765.812958 523.812958,762 528.5,762 C533.187042,762 537,765.812958 537,770.5 C537,775.187042 533.187042,779 528.5,779 Z M528.5,763.416667 C524.59425,763.416667 521.416667,766.59425 521.416667,770.5 C521.416667,774.40575 524.59425,777.583333 528.5,777.583333 C532.40575,777.583333 535.583333,774.40575 535.583333,770.5 C535.583333,766.59425 532.40575,763.416667 528.5,763.416667 Z M528.5,775.458333 C528.315833,775.458333 528.131667,775.380417 527.997083,775.252917 C527.868875,775.118333 527.791667,774.934167 527.791667,774.75 C527.791667,774.55875 527.868875,774.381667 527.997083,774.247083 C528.259167,773.985 528.73375,773.985 529.002917,774.247083 C529.130417,774.381667 529.208333,774.55875 529.208333,774.75 C529.208333,774.934167 529.130417,775.118333 529.002917,775.252917 C528.868333,775.380417 528.684167,775.458333 528.5,775.458333 Z M528.5,772.625 C528.108292,772.625 527.791667,772.307667 527.791667,771.916667 L527.791667,766.25 C527.791667,765.859 528.108292,765.541667 528.5,765.541667 C528.891708,765.541667 529.208333,765.859 529.208333,766.25 L529.208333,771.916667 C529.208333,772.307667 528.891708,772.625 528.5,772.625 Z\" id=\"Shape\"></path></g></g></svg>"

/***/ }),

/***/ "3kop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AssistantConfigOrgSettings__ = __webpack_require__("jGIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SFDCValues__ = __webpack_require__("OBXZ");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var closeSRC = __webpack_require__("+Juk");

var AssistantConfigSalesforceMapping = function (_React$Component) {
  _inherits(AssistantConfigSalesforceMapping, _React$Component);

  function AssistantConfigSalesforceMapping(props) {
    _classCallCheck(this, AssistantConfigSalesforceMapping);

    var _this = _possibleConstructorReturn(this, (AssistantConfigSalesforceMapping.__proto__ || Object.getPrototypeOf(AssistantConfigSalesforceMapping)).call(this, props));

    _this.getLeadField = function () {
      return _this.state.orgSettings.get('sfLeadFields').keySeq().first();
    };

    _this.handleSalesforceLeadObjectChange = function (_ref) {
      var value = _ref.value;

      var sfLeadField = _this.getLeadField();
      if (sfLeadField) {
        var newSettings = _this.state.orgSettings.get('sfLeadFields').delete(sfLeadField);
        _this.setState({
          orgSettings: _this.state.orgSettings.set('sfLeadFields', newSettings).set('salesforceLeadObject', value)
        });
      } else {
        _this.setState({ orgSettings: _this.state.orgSettings.set('salesforceLeadObject', value) });
      }
    };

    _this.handleSalesforceLeadFieldChange = function (_ref2) {
      var value = _ref2.value;

      var sfLeadField = _this.getLeadField();
      if (sfLeadField) {
        var newSettings = _this.state.orgSettings.get('sfLeadFields').delete(sfLeadField);
        _this.setState({
          orgSettings: _this.state.orgSettings.set('sfLeadFields', newSettings).setIn(['sfLeadFields', value], __WEBPACK_IMPORTED_MODULE_4_immutable__["List"].of(''))
        });
      } else {
        _this.setState({
          orgSettings: _this.state.orgSettings.setIn(['sfLeadFields', value], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])())
        });
      }
    };

    _this.removeSalesforceLeadField = function () {
      var sfLeadField = _this.getLeadField();
      if (sfLeadField) {
        var newSettings = _this.state.orgSettings.get('sfLeadFields').delete(sfLeadField);
        _this.setState({ orgSettings: _this.state.orgSettings.set('sfLeadFields', newSettings) });
      }
    };

    _this.handleSalesforceLeadFieldValueChange = function (value, index, sfLeadField) {
      _this.setState({
        orgSettings: _this.state.orgSettings.setIn(['sfLeadFields', sfLeadField, index], value)
      });
    };

    _this.removeSalesforceLeadFieldValue = function (index, sfLeadField) {
      var filteredSelectionList = _this.state.orgSettings.getIn(['sfLeadFields', sfLeadField]).filter(function (v) {
        return v !== '';
      });
      if (filteredSelectionList.size === 1) {
        _this.setState({
          orgSettings: _this.state.orgSettings.deleteIn(['sfLeadFields', sfLeadField]).setIn(['sfLeadFields', sfLeadField], __WEBPACK_IMPORTED_MODULE_4_immutable__["List"].of(''))
        });
      } else {
        _this.setState({
          orgSettings: _this.state.orgSettings.deleteIn(['sfLeadFields', sfLeadField, index])
        });
      }
    };

    _this.handleOpenOpsChange = function (value) {
      _this.setState({ orgSettings: _this.state.orgSettings.set('followUpWithOpenOps', value) });
    };

    _this.getFilteredOrgSettings = function () {
      var sfLeadField = _this.getLeadField();
      if (sfLeadField) {
        var filteredSelectionList = _this.state.orgSettings.getIn(['sfLeadFields', sfLeadField]).filter(function (v) {
          return v !== '';
        });
        return _this.state.orgSettings.setIn(['sfLeadFields', sfLeadField], filteredSelectionList);
      } else {
        return _this.state.orgSettings;
      }
    };

    _this.isChanged = function () {
      return !Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["is"])(_this.props.orgSettings, _this.state.orgSettings);
    };

    _this.handleSave = function () {
      _this.props.actions.patchAssistantOrgSettings({
        newSettings: _this.getFilteredOrgSettings().toJS(),
        settingName: 'MAPPING'
      });
      if (!_this.props.hasPassedOnboarding) {
        _this.props.actions.patchOrgProperties([{
          operation: 'set',
          property: 'hasCustomizedAssistantSFDCMapping',
          value: true
        }]);
      }
    };

    _this.handleCancel = function () {
      if (!_this.props.hasPassedOnboarding) {
        _this.props.actions.patchOrgProperties([{
          operation: 'set',
          property: 'hasCustomizedAssistantSFDCMapping',
          value: true
        }]);
      }
      _this.setState({ orgSettings: _this.props.orgSettings });
      _this.props.handleEdit(false);
    };

    _this.state = {
      isEditing: false,
      orgSettings: _this.props.orgSettings
    };
    return _this;
  }

  _createClass(AssistantConfigSalesforceMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.orgSettings != this.props.orgSettings) {
        this.setState({ orgSettings: nextProps.orgSettings });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var orgSettings = this.state.orgSettings;
      var _props = this.props,
          salesforceLeadSettings = _props.salesforceLeadSettings,
          salesforceContactSettings = _props.salesforceContactSettings,
          hasPassedOnboarding = _props.hasPassedOnboarding,
          salesforceOutOfSync = _props.salesforceOutOfSync,
          patchAssistantOrgSettingsPending = _props.patchAssistantOrgSettingsPending;


      var sfLeadObject = orgSettings.get('salesforceLeadObject');
      var sfLeadField = this.getLeadField();
      var sfLeadFieldValues = sfLeadField ? orgSettings.getIn(['sfLeadFields', sfLeadField]) : Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])();
      var filteredSelectionList = sfLeadFieldValues.filter(function (v) {
        return v !== '';
      });
      var openOps = orgSettings.get('followUpWithOpenOps');

      var salesforceLeadObjectOptions = {
        multi: false,
        searchable: false,
        autoFocus: false,
        clearable: false,
        placeholder: 'Lead object',
        value: sfLeadObject,
        options: [{ label: 'Lead', value: 'LEAD' }, { label: 'Contact', value: 'CONTACT' }],
        onChange: this.handleSalesforceLeadObjectChange
      };

      var salesforceLeadFieldOptions = {
        multi: false,
        autoFocus: false,
        clearable: false,
        placeholder: 'SFDC field...',
        value: sfLeadField,
        options: sfLeadObject === 'LEAD' ? salesforceLeadSettings.get('leadFields') : salesforceContactSettings.get('contactFields'),
        onChange: this.handleSalesforceLeadFieldChange
      };

      var currentConfigIsValid = sfLeadObject === 'LEAD' && !sfLeadField || sfLeadField && filteredSelectionList.size > 0;

      var saveEnabled = !hasPassedOnboarding && currentConfigIsValid || salesforceOutOfSync && currentConfigIsValid || hasPassedOnboarding && this.isChanged() && currentConfigIsValid;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'assistant-config-settings-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'What should your team get reminders for?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-settings-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-subheader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'People'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Field ',
              sfLeadObject === 'LEAD' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '(optional)'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Value'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Select"], salesforceLeadObjectOptions),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'micro-copy' },
                'with'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Select"], salesforceLeadFieldOptions),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'micro-copy' },
                'is'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SFDCValues__["a" /* default */], {
              orgSettings: orgSettings,
              sfObjectType: sfLeadObject,
              sfField: sfLeadField,
              sfValueSelections: sfLeadFieldValues,
              filteredSelections: filteredSelectionList,
              inputHandler: this.handleSalesforceLeadFieldValueChange,
              removeHandler: this.removeSalesforceLeadFieldValue,
              removeFieldHandler: this.removeSalesforceLeadField
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-settings-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-subheader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Opportunity'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Stage'
            )
          ),
          openOps ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-content assistant-settings-opportunity-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Input"], { value: 'Opportunity', disabled: 'true' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'micro-copy' },
                'is'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Input"], { value: 'Open', disabled: 'true' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column flex' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'empty-remove-column' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'remove-value-button' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, { src: closeSRC, onClick: function onClick() {
                      return _this2.handleOpenOpsChange(false);
                    } })
                )
              )
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
              {
                type: 'subtle',
                className: 'empty-state-button',
                onClick: function onClick() {
                  return _this2.handleOpenOpsChange(true);
                }
              },
              '+ Add Opportunity'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-settings-cta-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            {
              onClick: this.handleSave,
              disabled: !saveEnabled && !patchAssistantOrgSettingsPending,
              type: 'primary',
              loading: patchAssistantOrgSettingsPending
            },
            'Save'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            { onClick: this.handleCancel, type: 'subtle' },
            'Cancel'
          )
        )
      );
    }
  }]);

  return AssistantConfigSalesforceMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var AssistantConfigSalesforceMappingView = function AssistantConfigSalesforceMappingView(props) {
  var sfLeadObject = props.orgSettings.get('salesforceLeadObject');
  var sfLeadField = props.orgSettings.get('sfLeadFields').keySeq().first();

  var fieldValues = null;
  if (sfLeadObject === 'LEAD' && sfLeadField) {
    fieldValues = props.salesforceLeadSettings.get('leadFieldValues');
  } else if (sfLeadField) {
    fieldValues = props.salesforceContactSettings.get('contactFieldValues');
  }

  var sfFieldLabel = _.get(fieldValues, [sfLeadField, 'fieldLabel'], '');

  var salesforceOutOfSync = sfFieldLabel === '' && !!sfLeadField;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AssistantConfigOrgSettings__["a" /* default */], {
    assistantSetting: 'salesforceMapping',
    sfFieldTitle: sfFieldLabel,
    orgSettings: props.orgSettings,
    handleEdit: props.handleEdit,
    hasPassedOnboarding: props.hasPassedOnboarding,
    salesforceOutOfSync: salesforceOutOfSync
  });
};

var LoadingState = function LoadingState() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'SFDC-config-loading-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Loading__["a" /* default */], { color: '#CCCCCC' })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    salesforceLeadSettings: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["r" /* salesforceLeadSettings */])(state),
    salesforceContactSettings: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["p" /* salesforceContactSettings */])(state),
    fetchSalesforceSettingsSuccess: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["i" /* fetchSalesforceSettingsSuccess */])(state),
    patchAssistantOrgSettingsPending: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["m" /* patchAssistantOrgSettingsPending */])(state),
    patchAssistantOrgSettingsSuccess: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["n" /* patchAssistantOrgSettingsSuccess */])(state),
    patchAssistantOrgSettingsFailed: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_assistantSettings_selectors__["l" /* patchAssistantOrgSettingsFailed */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      patchAssistantOrgSettings: __WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_actions__["H" /* patchAssistantOrgSettings */],
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_actions__["patchOrgProperties"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.orgSettings || !props.fetchSalesforceSettingsSuccess;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(LoadingState)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.isEditing;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(AssistantConfigSalesforceMappingView)))(AssistantConfigSalesforceMapping));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "3lFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment__ = __webpack_require__("7WJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dot_fragment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_marketo_video_png__ = __webpack_require__("hPkC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_marketo_video_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_marketo_video_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("2RWv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MARKETO_EDU_URL = 'https://insider.drift.com/lessons/marketo-and-drift/';

function mapStateToProps(state) {
  return {
    hasSeenEduNudge: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */])(state).get('hasSeenMarketoEduNudge') || false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchUserProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__["a" /* fetchUserProperties */],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */],
      track: __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
}

var MarketoEduTooltip = function (_Component) {
  _inherits(MarketoEduTooltip, _Component);

  function MarketoEduTooltip(props) {
    _classCallCheck(this, MarketoEduTooltip);

    var _this = _possibleConstructorReturn(this, (MarketoEduTooltip.__proto__ || Object.getPrototypeOf(MarketoEduTooltip)).call(this, props));

    _this.componentDidMount = function () {
      _this.props.actions.fetchUserProperties();
      setTimeout(function () {
        _this.setState({ showEduNudgeTimed: true });
        _this.props.actions.track("In App Education - Viewed", { page: "marketo", nudge: !_this.props.hasSeenEduNudge });
      }, 5000);
    };

    _this.componentWillUnmount = function () {
      _this.updateUserProps();
    };

    _this.updateUserProps = function () {
      if (!_this.props.hasSeenEduNudge) {
        _this.props.actions.updateUserProperties({ hasSeenMarketoEduNudge: true }, false);
      }
    };

    _this.onToggleEduTooltip = function () {
      var showEduTooltip = _this.state.showEduTooltip;

      if (!!showEduTooltip) {
        _this.updateUserProps();
        _this.props.actions.track("In App Education - Closed", { page: "marketo", nudge: !_this.props.hasSeenEduNudge });
      } else {
        _this.props.actions.track("In App Education - Opened", { page: "marketo", nudge: !_this.props.hasSeenEduNudge });
      }
      _this.setState({ showEduTooltip: !showEduTooltip, showEduNudgeTimed: false });
    };

    _this.onWatchEduTooltip = function (link) {
      window.open(MARKETO_EDU_URL, '_blank');
      _this.props.actions.track("In App Education - Watched", { page: "marketo", nudge: !_this.props.hasSeenEduNudge, link: link });
      _this.setState({ showEduTooltip: false });
    };

    _this.state = {
      showEduNudgeTimed: false,
      showEduTooltip: false
    };
    return _this;
  }

  _createClass(MarketoEduTooltip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showEduNudgeTimed = _state.showEduNudgeTimed,
          showEduTooltip = _state.showEduTooltip;
      var hasSeenEduNudge = this.props.hasSeenEduNudge;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'marketo-integration-edu-nudge-animation-container' },
        !!showEduNudgeTimed && !hasSeenEduNudge && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__["FeatureTooltip"],
          {
            className: 'marketo-integration-edu-tooltip',
            onClose: function onClose() {
              return _this2.onToggleEduTooltip();
            },
            showTooltip: !!showEduTooltip,
            ribbonType: 'how',
            orientation: 'vertical',
            tooltipSide: 'bottom',
            tooltipCaretLocation: 'center',
            headerCopy: 'Learn how to set up your Marketo integration',
            bodyCopy: 'Sync data and use munchkin cookies to target and personalize your site visitors\u2019 experience!',
            mediaComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: "marketo-integration-edu-tooltip-img", src: __WEBPACK_IMPORTED_MODULE_9_images_marketo_video_png___default.a, onClick: function onClick() {
                  _this2.onWatchEduTooltip("img");
                }, alt: 'Marketo how-to video' })
            ),
            buttonInfoArray: [{
              copy: 'Watch on Drift Insider',
              func: function func() {
                _this2.onWatchEduTooltip("button");
              }
            }] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'marketo-integration-edu-tooltip-container', onClick: this.onToggleEduTooltip },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'marketo-integration-edu-nudge-icon', name: 'video-play' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'marketo-integration-edu-nudge-copy' },
              'How to set up Marketo'
            )
          )
        )
      );
    }
  }]);

  return MarketoEduTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MarketoEduTooltip));

/***/ }),

/***/ "3mvR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3n1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAttachments; });
/* unused harmony export fetchAttachmentsPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAttachmentsFailed; });
/* unused harmony export fetchAttachmentsCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveAttachments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return uploadAttachment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return uploadAttachmentPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return uploadAttachmentFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return uploadAttachmentSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("X/M4");



var fetchAttachments = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_ATTACHMENTS */]);
var fetchAttachmentsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_ATTACHMENTS_PENDING */]);
var fetchAttachmentsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_ATTACHMENTS_FAILED */]);
var fetchAttachmentsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_ATTACHMENTS_CANCELLED */]);
var receiveAttachments = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* RECEIVE_ATTACHMENTS */]);

var uploadAttachment = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* UPLOAD_ATTACHMENT */]);
var uploadAttachmentPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* UPLOAD_ATTACHMENT_PENDING */]);
var uploadAttachmentFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* UPLOAD_ATTACHMENT_FAILED */]);
var uploadAttachmentSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* UPLOAD_ATTACHMENT_SUCCESS */]);

/***/ }),

/***/ "3nos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3p/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AutoSyncCallout__ = __webpack_require__("fysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model__ = __webpack_require__("1PZ4");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.';
var PATCH_ERROR_MESSAGE = 'We could not save your changes.';

var HubspotConfig = function (_Component) {
  _inherits(HubspotConfig, _Component);

  function HubspotConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HubspotConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HubspotConfig.__proto__ || Object.getPrototypeOf(HubspotConfig)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      toggles: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */]
    }, _this.onError = function () {
      var router = _this.context.router;


      _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
      router.push({ pathname: '/settings/setup/hubspot' });
    }, _this.onPatchError = function () {
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.receiveToggles = function (resp) {
      _this.setState({
        toggles: Object(__WEBPACK_IMPORTED_MODULE_9__model__["a" /* hydrateModel */])(resp)
      });
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('HubSpot settings are updated!');
    }, _this.patchToggle = function (event, toggle) {
      var data = _defineProperty({}, toggle.type, event);

      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["H" /* patchHubspotToggles */])(data).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HubspotConfig, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["s" /* getHubspotToggles */])().then(this.receiveToggles).catch(this.onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var toggles = this.state.toggles;

      var numToggles = toggles.length;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout ' },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Hubspot Integration',
          backLinkUrl: '/settings/setup/hubspot'
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Synced Hubspot Data'
          ),
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Hubspot and Drift.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Drift',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Hubspot'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AutoSyncCallout__["a" /* default */], { integrationName: 'Hubspot' }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["take"])(numToggles - 2, toggles),
          onChange: this.patchToggle
        }),
        toggles[0].value === true && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: [toggles[numToggles - 2]],
          onChange: this.patchToggle
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Hubspot',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Drift'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: [toggles[numToggles - 1]],
          onChange: this.patchToggle
        })
      );
    }
  }]);

  return HubspotConfig;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

HubspotConfig.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(HubspotConfig));

/***/ }),

/***/ "3t0E":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3tUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNormalizedTagColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeColor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var NORMALIZED_FALLBACK_COLOR = 'D6DDE1';

var NORMALIZED_COLORS = {
  'FF876B': 'FFEDB8',
  '13CB6E': 'FFC29E',
  '00E0FF': 'CCFFE6',
  '2D8EFF': 'CCFFE6',
  'EA81FF': 'C7E1FF',
  '7695A5': 'B8E9EF',
  'E95330': 'B8E9EF',
  '1F9A57': 'B8E9EF',
  '009AB0': 'FEA29A',
  '0960C5': 'DDBCF0',
  'A60087': 'D6DDE1',
  '394F5A': 'D6DDE1',
  'EFEEFC': 'DDBCF0'
};

var getNormalizedTagColor = function getNormalizedTagColor(tagColor) {
  var normalizedTagColor = NORMALIZED_COLORS[tagColor];
  return normalizedTagColor ? normalizedTagColor : NORMALIZED_FALLBACK_COLOR;
};

/**
 * Returns a copy of the original tag with a normalized color value
 */
var normalizeColor = function normalizeColor(tag) {
  if (tag && tag.color) {
    var normalizedColor = getNormalizedTagColor(tag.color);

    if (__WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Iterable.isIterable(tag)) {
      return tag.set('color', normalizedColor);
    } else {
      return _extends({}, tag, { color: normalizedColor });
    }
  }

  return tag;
};

/***/ }),

/***/ "3ujL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Bot = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  botId: undefined,
  enabled: false,
  name: "",
  orgId: undefined,
  avatarUrl: undefined
});

var BotAPI = {
  fetchOrCreate: function fetchOrCreate(orgId) {
    var _this = this;

    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/bots', {
      method: 'GET',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    }).then(function (res) {
      if (res.ok) {
        return res.json().then(Bot);
      } else {
        if (res.status === 404) {
          return _this.create(orgId);
        } else {
          throw new Error('Failed to fetch bot settings for org ' + orgId + ': [' + res.status + '] ' + res.statusText);
        }
      }
    });
  },
  create: function create(orgId) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/bots', {
      method: 'POST',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    }).then(function (res) {
      if (res.ok) {
        return res.json().then(Bot);
      } else {
        throw new Error('Failed to create bot for org ' + orgId);
      }
    });
  },
  enable: function enable(orgId, enabled) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/bots', {
      method: 'PATCH',
      body: JSON.stringify({ enabled: enabled }),
      headers: new Headers(_extends({}, __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["a" /* PostJsonHeaders */], Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()))
    }).then(function (res) {
      if (res.ok) {
        return res.json().then(Bot);
      } else {
        throw new Error('Failed to set bot for org ' + orgId + ' to ' + enabled + ': [' + res.status + '] ' + res.statusText);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["b"] = (BotAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V")))

/***/ }),

/***/ "3vYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var emptyCustomValue = { label: 'Custom', value: { min: null, max: null } };

var EmployeeFilter = function (_Component) {
  _inherits(EmployeeFilter, _Component);

  function EmployeeFilter(props) {
    _classCallCheck(this, EmployeeFilter);

    var _this = _possibleConstructorReturn(this, (EmployeeFilter.__proto__ || Object.getPrototypeOf(EmployeeFilter)).call(this, props));

    _this.updateMin = function (event) {
      var currentValue = event.target.value;
      var parsedValue = currentValue.replace(/[\.,]/g, '');
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { min: parsedValue }) };
      }, _this.updateCondition);
    };

    _this.updateMax = function (event) {
      var currentValue = event.target.value;
      var parsedValue = currentValue.replace(/[\.,]/g, '');
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { max: parsedValue }) };
      }, _this.updateCondition);
    };

    _this.updateCondition = function () {
      var updatedCondition = {
        operator: __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["l" /* EMPLOYEES_FILTER_OPERATORS */].BTW,
        value: _this.state.selectedValue
      };

      _this.isValid() && _this.props.onUpdateCondition(updatedCondition);
    };

    _this.onSelect = function (group) {
      if (group.value === 'CUSTOM') {
        return _this.setState({
          selectedValue: emptyCustomValue,
          isCustom: true
        });
      }

      return _this.setState({
        selectedValue: group.value,
        isCustom: false
      }, _this.updateCondition);
    };

    var initialValue = props.activeFilter.value;

    _this.state = {
      selectedValue: initialValue,
      isCustom: !_this.hasMatchedGroup(initialValue)
    };
    return _this;
  }

  _createClass(EmployeeFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateCondition();
    }
  }, {
    key: 'hasMatchedGroup',
    value: function hasMatchedGroup(isMatchedGroup) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["m" /* EMPLOYEE_NUMBER_GROUPS */], function (group) {
        return _.isEqual(group, isMatchedGroup);
      });

      return !!matched ? { value: matched, label: matched.min + ' - ' + matched.max + ' employees' } : null;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return !!this.state.selectedValue.min && !!this.state.selectedValue.max;
    }
  }, {
    key: 'renderEmployeeDropdown',
    value: function renderEmployeeDropdown() {
      var selectOptions = {
        multi: false,
        autoFocus: true,
        value: this.hasMatchedGroup(this.state.selectedValue) || emptyCustomValue,
        onChange: this.onSelect,
        clearable: false,
        options: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["m" /* EMPLOYEE_NUMBER_GROUPS */].map(function (group) {
          return { value: group, label: group.min + ' - ' + group.max + ' employees' };
        })), [{ label: 'Custom', value: 'CUSTOM' }])
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderCustomInput',
    value: function renderCustomInput() {
      if (!this.state.isCustom) return;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-filter-custom-input drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '0', onChange: this.updateMin, defaultValue: this.state.selectedValue.min }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'to'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '0', onChange: this.updateMax, defaultValue: this.state.selectedValue.max }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'employees'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          this.renderEmployeeDropdown(),
          this.renderCustomInput()
        )
      );
    }
  }]);

  return EmployeeFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EmployeeFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "3wYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("xJzF");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var Section = function Section(props) {
  return React.createElement('div', _extends({}, props, { className: props.className }));
};

var BufferSettings = function BufferSettings(_ref) {
  var meetingSettings = _ref.meetingSettings,
      handleSelectBufferTime = _ref.handleSelectBufferTime,
      handleSelectMinimumNoticeTime = _ref.handleSelectMinimumNoticeTime;

  return React.createElement(
    'div',
    { className: 'meeting-settings' },
    React.createElement(
      Section,
      null,
      React.createElement(
        'form',
        { className: 'drift-form advanced-meeting-settings' },
        React.createElement(
          'fieldset',
          null,
          React.createElement(
            'label',
            { className: 'settings-label' },
            'Minimum Notice Time',
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_select_plus__["b" /* default */], {
              value: meetingSettings.minimumNoticeTime,
              searchable: false,
              clearable: false,
              options: __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* NOTICE_TIME_OPTIONS */],
              onChange: handleSelectMinimumNoticeTime
            }),
            React.createElement(
              'div',
              { className: 'description' },
              'This is the minimum amount of time before a meeting can be scheduled.'
            )
          )
        ),
        React.createElement(
          'fieldset',
          null,
          React.createElement(
            'label',
            { className: 'settings-label' },
            'Buffer Time',
            React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_select_plus__["b" /* default */], {
              value: meetingSettings.bufferTime,
              searchable: false,
              clearable: false,
              options: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* BUFFER_LENGTH_OPTIONS */],
              onChange: handleSelectBufferTime
            }),
            React.createElement(
              'div',
              { className: 'description' },
              'Drift will make sure you have enough time between your meetings.'
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BufferSettings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "3wjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchGeolocationEpic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("KtIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("UEdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("MuiX");







var fetchGeolocationEpic = function fetchGeolocationEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* FETCH_GEOLOCATION */]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* fetchGeolocation */]().map(function (geolocation) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchGeolocationSuccess */](geolocation);
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchGeolocationPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchGeolocationFailure */](error));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchGeolocationEpic);

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4/Uo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("na0B");











var mapStateToProps = function mapStateToProps(state) {
  return {
    answer: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["J" /* getCurrentAnswer */](state),
    question: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["N" /* getCurrentQuestionByAnswer */](state),
    theme: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["h" /* getEmbedConfig */])(state), 'theme')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setSkipTo: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_209" /* setSkipTo */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "4/vI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("XfFy");




var api = {
  create: function create(settings) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations', settings, { auth: false, clientId: true }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Org */]);
  },
  fetch: function fetch(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/organizations/' + id).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Org */]);
  },
  fetchProperties: function fetchProperties(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/organizations/' + id + '/all_properties').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  patchProperties: function patchProperties(id, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].patch('/organizations/' + id + '/properties2', updates).checkStatus().map(function (res) {
      return res.response;
    });
  },
  update: function update(id, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/organizations/' + id, updates).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Org */]);
  },
  checkHandle: function checkHandle(handle) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].head('/organizations/handle_check', { handle: handle });
  },
  batchUpdateUserScopes: function batchUpdateUserScopes(id, updates) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/organizations/' + id + '/users/scopes', updates).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  sendExistingInvitationsViaEmail: function sendExistingInvitationsViaEmail(orgId, invitations) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/users/plugin-invite', invitations);
  },
  sendInvitationsViaEmail: function sendInvitationsViaEmail(orgId, invitations) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/users/invitations2', invitations).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  sendInvitationsViaSlack: function sendInvitationsViaSlack(orgId, invitations) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/users/invitations2/slack', invitations).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  getLeaderboardUrl: function getLeaderboardUrl() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/leaderboard/url').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  toggleChillbot: function toggleChillbot(chillbotStatus) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["ConversationAPI"].put('/chill', { enabled: chillbotStatus });
  },
  fetchEndUserCount: function fetchEndUserCount(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/organizations/' + orgId + '/end_users/search?from=0&size=1', {}).checkStatus().map(function (res) {
      return res.response;
    });
  },
  createEndUser: function createEndUser(orgId, endUser) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/end_users', endUser).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  getDriftHelpStatus: function getDriftHelpStatus(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/organizations/' + orgId + '/bots/support').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  },
  getHasLimitedContactsMktEmail: function getHasLimitedContactsMktEmail(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/cutover/organizations/' + orgId + '?namespace=HAS_LIMITED_CONTACTS_MKTING_EMAIL').checkStatus().map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "46ps":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_shared_ToolTipOnHover_styl__ = __webpack_require__("feRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_shared_ToolTipOnHover_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_shared_ToolTipOnHover_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.






var ToolTipOnHover = React.createClass({
  displayName: 'ToolTipOnHover',

  propTypes: {
    toolTip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
    debounceHoverTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  },

  getInitialState: function getInitialState() {
    return {};
  },
  renderToolTip: function renderToolTip() {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('tool-tip', this.props.variant) },
      this.props.toolTip
    );
  },
  onMouseOver: function onMouseOver() {
    var _this = this;

    if (this.debouncedSetShowTooltip) {
      this.debouncedSetShowTooltip.cancel();
    }

    if (this.props.debounceHoverTime) {
      this.debouncedSetShowTooltip = _.debounce(function () {
        return _this.setState({ showTooltip: true });
      }, this.props.debounceHoverTime);
      return this.debouncedSetShowTooltip();
    } else {
      return this.setState({ showTooltip: true });
    }
  },
  onMouseOut: function onMouseOut() {
    if (this.debouncedSetShowTooltip != null) {
      this.debouncedSetShowTooltip.cancel();
    }
    return this.setState({ showTooltip: false });
  },
  render: function render() {
    return React.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('ToolTipOnHover', this.props.className),
        onMouseOver: this.onMouseOver,
        onMouseOut: this.onMouseOut },
      this.props.children,
      this.state.showTooltip || this.props.showTooltip ? this.renderToolTip() : undefined
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ToolTipOnHover);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "47rT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4CQX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_access_api__ = __webpack_require__("T2nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_navConfig_api__ = __webpack_require__("Mh5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UpgradeStatus__ = __webpack_require__("F517");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NewAgentStatus__ = __webpack_require__("G3Uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppSwitcher__ = __webpack_require__("rIPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Settings__ = __webpack_require__("fIG5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Help__ = __webpack_require__("MMge");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Onboarding__ = __webpack_require__("wjrm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_drift_icon_2020_svg__ = __webpack_require__("e4AA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_drift_icon_2020_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_drift_icon_2020_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("Ad2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var MAX_UNGROUPED_NAV_ITEMS = 4;

var MainNav = function (_Component) {
  _inherits(MainNav, _Component);

  function MainNav(props) {
    _classCallCheck(this, MainNav);

    var _this = _possibleConstructorReturn(this, (MainNav.__proto__ || Object.getPrototypeOf(MainNav)).call(this, props));

    _this.renderNavItems = function () {
      var availableNavItems = _this.resolveAvailableNavItems();

      var ungroupedItems = __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isRbacUser() ? availableNavItems.slice(0, MAX_UNGROUPED_NAV_ITEMS) : availableNavItems;
      var groupedItems = __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isRbacUser() ? availableNavItems.slice(MAX_UNGROUPED_NAV_ITEMS) : [];

      var expanded = _this.state.groupedNavItemsExpanded;

      var setExpanded = function setExpanded(setter) {
        return _this.setState(function (prevState) {
          var nextValue = setter(prevState.groupedNavItemsExpanded);

          if (window.localStorage) {
            window.localStorage.setItem('traffic-control_salesToolsExpanded', nextValue);
          }

          return {
            groupedNavItemsExpanded: nextValue
          };
        });
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "nav",
        { className: "main-navigation--nav-items" },
        ungroupedItems.map(function (item) {
          return _this.renderNavItem(item);
        }),
        groupedItems.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "navigation-sales-tools" },
          expanded && groupedItems.map(function (item) {
            return _this.renderNavItem(item);
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["ToolTip"],
            { key: expanded, component: expanded ? 'Collapse navigation' : 'Expand navigation', tethered: true },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "button",
              { className: "nav-item sales-tools-expand-button",
                onClick: function onClick() {
                  return setExpanded(function (expanded) {
                    return !expanded;
                  });
                } },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                "div",
                { className: "sales-tools-expand-button-icon-wrapper" },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], {
                  className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ expanded: expanded }), name: expanded ? 'chevron-up' : 'chevron-down',
                  width: 8, height: 8 })
              )
            )
          )
        )
      );
    };

    _this.renderNavItem = function (item) {
      var isActiveNavPath = function isActiveNavPath(path) {
        var additionalPaths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var exclusionPaths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        return [path].concat(_toConsumableArray(additionalPaths)).some(function (pathItem) {
          var isInPath = function isInPath(path) {
            return window.location.pathname.startsWith(path) && pathItem.includes(path);
          };

          var hasExcludedPaths = exclusionPaths.length;
          var isPartOfExclusionPath = hasExcludedPaths ? exclusionPaths.some(function (excludedPath) {
            return window.location.pathname.startsWith(excludedPath);
          }) : false;

          return isInPath(pathItem) && !isPartOfExclusionPath;
        });
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "a",
        {
          href: "https://" + (item.domain || 'app') + "." + __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["l" /* DRIFT_APP_DOMAIN */] + item.path,
          target: item.external ? '_blank' : '_self',
          key: item.label + "-" + item.path,
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('menu-item', 'nav-item', { active: isActiveNavPath(item.path, item.additionalPaths, item.exclusionPaths) })
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["ToolTip"],
          { className: "navigation-hover-tooltip--wrapper", component: item.label,
            flow: "right" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { name: item.iconSRC, className: "menu-item-icon",
            height: item.height, width: item.width })
        )
      );
    };

    var groupedNavItemsExpanded = window.localStorage ? window.localStorage.getItem('traffic-control_salesToolsExpanded') === 'true' : false;

    _this.state = {
      isPendingCutover: true,
      hasDriftHelpCutover: false,
      hasVideoIconCutover: false,
      scrollContainerHovered: false,
      groupedNavItemsExpanded: groupedNavItemsExpanded
    };
    return _this;
  }

  _createClass(MainNav, [{
    key: "componentWillMount",
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this2 = this;

        var hasDriftHelpCutoverGate, hasDriftVideoCutoverGate, fetchNavConfig, _ref5, hasHelpCutoverGate, _ref6, hasVideoIconCutoverGate, _ref7, NAV_CONFIG;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                hasDriftHelpCutoverGate = function () {
                  var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_access_api__["a" /* getDriftCutover */])({ orgId: _this2.props.orgId, cutoverName: 'DRIFT_HELP' });

                          case 2:
                            return _context.abrupt("return", _context.sent);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2);
                  }));

                  return function hasDriftHelpCutoverGate() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                hasDriftVideoCutoverGate = function () {
                  var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_access_api__["a" /* getDriftCutover */])({ orgId: _this2.props.orgId, cutoverName: 'DRIFT_VIDEO_IN_NAV' });

                          case 2:
                            return _context2.abrupt("return", _context2.sent);

                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function hasDriftVideoCutoverGate() {
                    return _ref3.apply(this, arguments);
                  };
                }();

                fetchNavConfig = function () {
                  var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_navConfig_api__["a" /* getConfig */])('/nav-config/index.json');

                          case 2:
                            return _context3.abrupt("return", _context3.sent);

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this2);
                  }));

                  return function fetchNavConfig() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context4.prev = 3;
                _context4.next = 6;
                return hasDriftHelpCutoverGate();

              case 6:
                _ref5 = _context4.sent;
                hasHelpCutoverGate = _ref5.DRIFT_HELP;
                _context4.next = 10;
                return hasDriftVideoCutoverGate();

              case 10:
                _ref6 = _context4.sent;
                hasVideoIconCutoverGate = _ref6.DRIFT_VIDEO_IN_NAV;
                _context4.next = 14;
                return fetchNavConfig();

              case 14:
                _ref7 = _context4.sent;
                NAV_CONFIG = _ref7.data;

                this.setState({
                  hasDriftHelpCutover: hasHelpCutoverGate,
                  hasVideoIconCutover: hasVideoIconCutoverGate,
                  isPendingCutover: false,
                  navConfig: NAV_CONFIG
                });
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](3);

                console.warn(_context4.t0);
                this.setState({ isPendingCutover: false });

              case 23:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 19]]);
      }));

      function componentWillMount() {
        return _ref.apply(this, arguments);
      }

      return componentWillMount;
    }()
  }, {
    key: "hideNav",
    value: function hideNav() {
      return this.props.location.pathname.includes("welcome/") || this.props.location.pathname.includes("install/verify") || this.props.location.pathname.includes("setup-slack") || this.props.location.pathname == "/oauth" || this.props.location.pathname.includes("/install/") && !this.props.location.pathname.includes("/settings/setup");
    }
  }, {
    key: "isHomePath",
    value: function isHomePath() {
      return this.props.location.pathname === "/" || this.props.location.pathname.startsWith("/home") || this.props.location.pathname.startsWith("/dashboard");
    }
  }, {
    key: "resolveHomePath",
    value: function resolveHomePath() {
      var navConfig = this.state.navConfig;

      var availableHomePaths = navConfig.HOME_PATH_RULES.filter(this.checkPathCriteria);

      return availableHomePaths[0] ? availableHomePaths[0].path : '/';
    }
  }, {
    key: "checkPathCriteria",
    value: function checkPathCriteria(item) {
      var userHasImpliedAccess = __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAnyScope(item.requiredScopes) && !__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAnyScope(item.rejectIfHasScopes) || __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAnyRole(item.requiredRoles) || __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAllGates(item.hasAllUserGates);

      var userHasRbacAccess = __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasFeatures(item.requiredFeatures) || __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAnyFeature(item.hasAnyFeature);

      var orgHasAccess = (item.requiredGates ? __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates(item.requiredGates) : true) && (item.rejectIfHasGates ? !__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates(item.rejectIfHasGates) : true) && (item.hasAllGates ? __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAllGates.apply(__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */], _toConsumableArray(item.hasAllGates)) : true);

      return (userHasImpliedAccess || userHasRbacAccess) && orgHasAccess;
    }
  }, {
    key: "resolveAvailableNavItems",
    value: function resolveAvailableNavItems() {
      var navConfig = this.state.navConfig;


      var navCollection = navConfig.NAV_COLLECTIONS.DEFAULT;
      if (__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('has_unified_nav') && navConfig.NAV_COLLECTIONS.UNIFIED) {
        navCollection = navConfig.NAV_COLLECTIONS.UNIFIED;
      }
      if (__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isRbacUser() && navConfig.NAV_COLLECTIONS.RBAC) {
        navCollection = navConfig.NAV_COLLECTIONS.RBAC;
      }

      if (__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasAnyDefaultRole('Sales Rep') && navConfig.NAV_COLLECTIONS.RBAC_REP) {
        navCollection = navConfig.NAV_COLLECTIONS.RBAC_REP;
      }

      var navItems = _.pick(navConfig.NAV_ITEMS, navCollection);

      return Object.values(navItems).filter(this.checkPathCriteria);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          orgId = _props.orgId,
          orgProperties = _props.orgProperties;


      if (this.hideNav()) {
        return null;
      }

      if (this.state.isPendingCutover) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("main-navigation", "new-main-nav", {
            darkMode: false,
            "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
          })
        });
      }

      var hovered = this.state.scrollContainerHovered;
      var setHovered = function setHovered(hovered) {
        return _this3.setState({ scrollContainerHovered: hovered });
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("main-navigation", "new-main-nav", {
            darkMode: false,
            "main-navigation--qa": window.__ENV__ !== "PRODUCTION"
          })
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["A"],
          {
            href: this.resolveHomePath(),
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()("main-navigation-home logo", {
              active: this.isHomePath()
            })
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "span",
            { is: true, tooltip: "Home", flow: "right" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], {
              name: "lightning-bolt-filled",
              className: "logo-hover-bolt large",
              height: 16,
              width: 12
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], {
              name: "lightning-bolt-filled",
              className: "logo-hover-bolt small1",
              height: 15,
              width: 11
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], {
              name: "lightning-bolt-filled",
              className: "logo-hover-bolt small2",
              height: 16,
              width: 12
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_drift_icon_2020_svg___default.a, className: "tide-icon drift-logo" })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('navigation-scroll-container', {
              'navigation-scroll-container--hovered': hovered
            }) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "div",
            {
              className: "navigation-scroll-container-content",
              onMouseEnter: function onMouseEnter() {
                return setHovered(true);
              },
              onMouseLeave: function onMouseLeave() {
                return setHovered(false);
              } },
            this.renderNavItems(),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: "navigation-scroll-container-spacer" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              "div",
              { className: "status-section" },
              __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isAdmin() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Onboarding__["a" /* default */], { orgId: orgId, orgProperties: orgProperties }),
              __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isAdmin() && !__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasPaidGates() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UpgradeStatus__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AppSwitcher__["a" /* default */], { showVideoOption: __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isAdmin() || !this.state.hasVideoIconCutover }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Help__["a" /* default */], null),
              __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isAdmin() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Settings__["a" /* default */], null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          "div",
          { className: "agent-status-container" },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NewAgentStatus__["a" /* default */], { hasDriftHelpCutover: this.state.hasDriftHelpCutover })
        )
      );
    }
  }]);

  return MainNav;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MainNav);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "4JBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areWeOpenForBusiness; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__("mGzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__("q+Dy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);




var ISO_DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
var WEEKENDS = ['SATURDAY', 'SUNDAY'];
var WEEKDAYS = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
var DEFAULT_TZ = 'America/New_York';
var EMPTY_HOURS = [];
var HOURS_FORMAT = 'HH:mm:ss';
var VALIDATE_PARSING = true;

var areWeOpenForBusiness = function areWeOpenForBusiness() {
  var tz = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TZ;
  var openHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_HOURS;
  var momentTzNowFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a;

  return _areWeOpenForBusiness(tz, openHours, momentTzNowFunc);
};

var includesToday = function includesToday(today, dayOfWeek) {
  return dayOfWeek === today || dayOfWeek === 'EVERYDAY' || dayOfWeek === 'WEEKENDS' && __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(WEEKENDS, today) || dayOfWeek === 'WEEKDAYS' && __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(WEEKDAYS, today);
};

var _areWeOpenForBusiness = function _areWeOpenForBusiness(tz, openHours, momentTzNowFunc) {
  var now = momentTzNowFunc(); // injected for testing: a moment-timezone() object
  var isoToday = now.tz(tz).isoWeekday();
  var isoTodayName = ISO_DAYS_OF_WEEK[isoToday - 1];
  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(openHours, function (_ref) {
    var dayOfWeek = _ref.dayOfWeek,
        opens = _ref.opens,
        closes = _ref.closes;

    if (!includesToday(isoTodayName, dayOfWeek)) {
      return false;
    }

    var tzOpens = convertHourToFullDate(tz, opens, momentTzNowFunc);
    var tzCloses = convertHourToFullDate(tz, closes, momentTzNowFunc);
    return tzOpens && tzCloses && now.isBetween(tzOpens, tzCloses);
  });
};

/*

Initalize now locally and convert to desired timezone (our customer's timezone).
Then use momentTz to parse our hours, but just to get hours/minutes/seconds
Finally, modify the local time in customer's timezone to match those hours.

This is done so the comparison actually falls on the same day as the local computer.

*/
var convertHourToFullDate = function convertHourToFullDate(tz, hours, momentTzNowFunc) {
  var nowInTz = momentTzNowFunc().tz(tz);
  var tzParsed = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz(hours, HOURS_FORMAT, VALIDATE_PARSING, tz);
  if (!tzParsed.isValid()) {
    return;
  } else {
    return nowInTz.hours(tzParsed.hours()).minutes(tzParsed.minutes()).seconds(tzParsed.seconds());
  }
};

/***/ }),

/***/ "4Nf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_tags_ManageTagDropdown_styl__ = __webpack_require__("9jpW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_tags_ManageTagDropdown_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_settings_tags_ManageTagDropdown_styl__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var ManageTagDropdown = React.createClass({
  displayName: 'ManageTagDropdown',

  mixins: [__webpack_require__("aCGJ")],

  propTypes: {
    editTagClicked: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  },

  componentDidMount: function componentDidMount() {
    return this.enableOnClickOutside();
  },
  handleClickOutside: function handleClickOutside(event) {
    return this.props.handleClickOutside();
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'ManageTagDropdown' },
      React.createElement(
        'div',
        { onClick: this.props.editTagClicked },
        'Edit'
      ),
      React.createElement(
        'div',
        { onClick: this.props.deleteTagClicked },
        'Delete'
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ManageTagDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "4ODQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CounterContainer":"CounterContainer---2MS_t","Counter":"Counter---1486f"};

/***/ }),

/***/ "4PhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4PhQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  rxfetchRules: function rxfetchRules() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxRoutingAPI"].get('/rules/all').checkStatus();
  },
  fetchRules: function fetchRules() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].get('/rules/all').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchRoundRobin: function fetchRoundRobin(roundRobinKey) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/organizations/round-robin/' + roundRobinKey).checkStatus();
  },
  createRule: function createRule(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].post('/rules?doBackfill=' + true, data);
  },
  editRule: function editRule(data, id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].patch('/rules/' + id + '?doBackfill=' + true, data);
  },
  editOncall: function editOncall(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].patch('/rules/on_call', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
  },
  fetchRule: function fetchRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].get('/rules/' + id).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  deleteRule: function deleteRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].patch('/rules/' + id + '?doBackfill=' + true, { status: 'ARCHIVED' });
  },
  undoDeleteRule: function undoDeleteRule(id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RoutingAPI"].patch('/rules/' + id + '?doBackfill=' + true, { status: 'ENABLED' });
  }
};

/***/ }),

/***/ "4PhW":
/***/ (function(module, exports) {

module.exports = "data:image/x-icon;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI0M2Y0N2ViNTYzOTJhOTFlMTA1MmI1MWZhNjRkY2E3YS5pY28iOw=="

/***/ }),

/***/ "4Rfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("MphB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SALESFORCE_REVENUE_ORG_PROPERTY = 'salesforceRevenueMetricsEnabled';

var RevenueDashboardToggle = function (_Component) {
  _inherits(RevenueDashboardToggle, _Component);

  function RevenueDashboardToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RevenueDashboardToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RevenueDashboardToggle.__proto__ || Object.getPrototypeOf(RevenueDashboardToggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isToggled: _this.props.hasSalesforceRevenueEnabled
    }, _this.toggleRevenueDashboard = function () {
      var isToggled = _this.state.isToggled;


      var patchedProperties = Object(__WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__["a" /* patchOperations */])(_defineProperty({}, [SALESFORCE_REVENUE_ORG_PROPERTY], !isToggled));

      _this.props.actions.patchOrgProperties(patchedProperties);
      _this.setState({ isToggled: !isToggled });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RevenueDashboardToggle, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.hasSalesforceRevenueEnabled !== this.props.hasSalesforceRevenueEnabled) {
        this.setState({ isToggled: nextProps.hasSalesforceRevenueEnabled });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isToggled = this.state.isToggled;
      var hasSalesforceRevenueEnabled = this.props.hasSalesforceRevenueEnabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-revenue-setting' },
        _.isUndefined(hasSalesforceRevenueEnabled) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"], null),
        !_.isUndefined(hasSalesforceRevenueEnabled) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Salesforce revenue dashboard'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-revenue-toggle' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'salesforce-revenue-description' },
              'Your Salesforce revenue dashboard helps you understand exactly how much Drift is helping your business.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Toggle"], {
              checked: isToggled,
              onChange: this.toggleRevenueDashboard
            })
          )
        )
      );
    }
  }]);

  return RevenueDashboardToggle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["patchOrgProperties"]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasSalesforceRevenueEnabled: __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__["properties"](state)[SALESFORCE_REVENUE_ORG_PROPERTY]
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(RevenueDashboardToggle));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "4Vm/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_AgentStatusPane__ = __webpack_require__("CV/U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_styl__ = __webpack_require__("OOF1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AgentStatusSection = function (_Component) {
  _inherits(AgentStatusSection, _Component);

  function AgentStatusSection() {
    _classCallCheck(this, AgentStatusSection);

    return _possibleConstructorReturn(this, (AgentStatusSection.__proto__ || Object.getPrototypeOf(AgentStatusSection)).apply(this, arguments));
  }

  _createClass(AgentStatusSection, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'agent-status-toggle-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_AgentStatusPane__["a" /* default */], { source: 'AgentStatusPopover', renderAgentName: false })
      );
    }
  }]);

  return AgentStatusSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AgentStatusSection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "4VmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSavedReplies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSavedRepliesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchSavedRepliesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSavedRepliesFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateSavedReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateSavedReplyPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateSavedReplySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateSavedReplyFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectSavedReply; });
/* unused harmony export clearSelectedSavedReply */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setComposerTextToInsert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearComposerTextToInsert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("PjwL");




var fetchSavedReplies = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_SAVED_REPLIES */]);
var fetchSavedRepliesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_SAVED_REPLIES_PENDING */]);
var fetchSavedRepliesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_SAVED_REPLIES_SUCCESS */]);
var fetchSavedRepliesFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_SAVED_REPLIES_FAILURE */]);

var updateSavedReply = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* UPDATE_SAVED_REPLY */]);
var updateSavedReplyPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* UPDATE_SAVED_REPLY_PENDING */]);
var updateSavedReplySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UPDATE_SAVED_REPLY_SUCCESS */]);
var updateSavedReplyFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* UPDATE_SAVED_REPLY_FAILURE */]);

var selectSavedReply = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SELECT_SAVED_REPLY */]);
var clearSelectedSavedReply = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CLEAR_SELECTED_SAVED_REPLY */]);

var setComposerTextToInsert = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* SET_COMPOSER_TEXT_TO_INSERT */]);
var clearComposerTextToInsert = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CLEAR_COMPOSER_TEXT_TO_INSERT */]);

/***/ }),

/***/ "4Vxp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTextColorForBackground;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function getTextColorForBackground() {
  var hexBackgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'FFFFFF';
  var lightTextColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'FFFFFF';
  var darkTextColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '333333';

  var _hexColorToRGB = hexColorToRGB(hexBackgroundColor),
      _hexColorToRGB2 = _slicedToArray(_hexColorToRGB, 3),
      r = _hexColorToRGB2[0],
      g = _hexColorToRGB2[1],
      b = _hexColorToRGB2[2];

  if (colorIsLight(r, g, b)) {
    return darkTextColor;
  }
  return lightTextColor;
}

/* Perceptive Luminance function. See:
 - http://codepen.io/WebSeed/pen/pvgqEq
 - http://stackoverflow.com/a/1855903/186965 */
function colorIsLight(r, g, b) {
  return 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
}

function scrubHexColor(hexString) {
  var hexColorString = ('' + hexString).replace(/#/, '');
  if (hexColorString.length !== 3 && hexColorString.length !== 6) {
    console.warn(hexString + ' is not a valid hex color value');
    return '9EDCF7';
  }
  return hexColorString;
}

/* Converts a hex color string to a list of RGB color values */
function hexColorToRGB(hexColor) {
  var hexColorString = scrubHexColor(hexColor);

  var r = void 0,
      g = void 0,
      b = void 0;
  if (hexColorString.length === 3) {
    var _Array$prototype$map$ = Array.prototype.map.call(hexColorString, function (x) {
      return x + x;
    });

    var _Array$prototype$map$2 = _slicedToArray(_Array$prototype$map$, 3);

    r = _Array$prototype$map$2[0];
    g = _Array$prototype$map$2[1];
    b = _Array$prototype$map$2[2];
  } else {
    r = hexColorString.slice(0, 2);
    g = hexColorString.slice(2, 4);
    b = hexColorString.slice(4, 6);
  }

  return [r, g, b].map(function (hexValue) {
    return parseInt(hexValue, 16);
  });
}

/***/ }),

/***/ "4Wgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_AddButton_index__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_sfdc_models__ = __webpack_require__("iRcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("N6sL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var SalesforceUserMapping = function (_Component) {
  _inherits(SalesforceUserMapping, _Component);

  function SalesforceUserMapping(props) {
    _classCallCheck(this, SalesforceUserMapping);

    var _this = _possibleConstructorReturn(this, (SalesforceUserMapping.__proto__ || Object.getPrototypeOf(SalesforceUserMapping)).call(this, props));

    _this.isValid = function () {
      var isValid = true;

      _this.state.mappings.forEach(function (mapping) {
        if (!mapping.salesforceId || !mapping.userId) {
          isValid = false;
        }
      });

      return isValid;
    };

    _this.onMappingsChange = function () {
      var isValid = _this.isValid();
      var _this$state = _this.state,
          mappings = _this$state.mappings,
          size = _this$state.size,
          index = _this$state.index;
      var sfdcUserMappings = _this.props.sfdcUserMappings;


      if (isValid) {
        if (sfdcUserMappings.length < mappings.length) {
          _this.saveNewMappings();
        } else if (sfdcUserMappings.length === mappings.length) {
          _this.saveChangedMapping();
        } else {
          // removed a mapping
          _this.saveDeleteMappings();
        }
      }
      _this.setState({
        totalPages: Math.ceil(mappings.length / size),
        index: index * size >= mappings.length ? Math.max(0, Math.ceil(mappings.length / size) - 1) : index
      });
      _this.props.onChange({
        isValid: isValid
      });
    };

    _this.searchSFDCUsers = function (query, index) {
      _this.setState({
        hasActiveSearch: query.length ? index : null
      });

      !!query.length && _this.debouncedSearch(query);

      return query;
    };

    _this.debouncedSearch = _.debounce(function (query) {
      _this.props.actions.searchSFDCUsers(query);
    }, 500);

    _this.addNewMapping = function () {
      _this.setState(function (prevState) {
        return {
          mappings: [].concat(_toConsumableArray(prevState.mappings), [_extends({}, __WEBPACK_IMPORTED_MODULE_6_app_modules_sfdc_models__["b" /* SFDCUserMapping */])]),
          index: Math.ceil((prevState.mappings.length + 1) / prevState.size) - 1
        };
      }, _this.onMappingsChange);
    };

    _this.removeMapping = function (index) {
      _this.setState(function (prevState) {
        var updatedMappings = [].concat(_toConsumableArray(prevState.mappings));
        updatedMappings.splice(index + prevState.size * prevState.index, 1);

        return {
          mappings: updatedMappings
        };
      }, _this.onMappingsChange);
    };

    _this.renderSalesforceLoader = function (index) {
      var shouldShow = _this.state.hasActiveSearch === index && _this.props.sfdcUserMappingLoading;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: shouldShow && 'inline-loading' });
    };

    _this.hasMappings = function () {
      return _this.state.mappings.length > 0;
    };

    _this.state = {
      mappings: props.sfdcUserMappings,
      sfdcUsers: props.sfdcUsers,
      pendingInvites: null,
      invitedIndex: null,
      waitingForInvitedUsers: false,
      hasActiveSearch: null,
      index: 0,
      totalPages: 0,
      size: 25
    };
    return _this;
  }

  _createClass(SalesforceUserMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          sfdcUserMappings = _props.sfdcUserMappings,
          sfdcUsers = _props.sfdcUsers,
          users = _props.users;
      var _state = this.state,
          waitingForInvitedUsers = _state.waitingForInvitedUsers,
          pendingInvites = _state.pendingInvites,
          invitedIndex = _state.invitedIndex;


      if (!_.isEqual(sfdcUserMappings, nextProps.sfdcUserMappings)) {
        this.setState({
          mappings: nextProps.sfdcUserMappings
        }, this.onMappingsChange);
      }

      if (!_.isEqual(sfdcUsers, nextProps.sfdcUsers)) {
        this.setState({
          sfdcUsers: nextProps.sfdcUsers
        });
      }

      if (waitingForInvitedUsers) {
        var pendingUser = Object.values(users).filter(function (user) {
          return user.email === pendingInvites[0];
        });
        if (!pendingUser.length) {
          this.props.actions.fetchOrgUsers();
        } else {
          this.saveDriftUserOption({ value: pendingUser[0].id }, invitedIndex);
          this.setState({
            pendingInvites: null,
            invitedIndex: null,
            waitingForInvitedUsers: false
          });
        }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchSFDCUserMappings();
      this.onMappingsChange();
    }
  }, {
    key: 'getSalesforceUserOptions',
    value: function getSalesforceUserOptions(id) {
      var mappedIds = this.state.mappings.map(function (mapping) {
        return mapping.salesforceId;
      }).filter(function (sfId) {
        return sfId !== id;
      });

      return this.state.sfdcUsers.filter(function (user) {
        return !mappedIds.includes(user.id);
      }).map(function (user) {
        return { label: user.name, value: user.id };
      });
    }
  }, {
    key: 'getFormattedUserOptions',
    value: function getFormattedUserOptions() {
      return Object.values(this.props.users).map(function (user) {
        return { value: user.id, label: Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user) };
      });
    }
  }, {
    key: 'saveSalesforceOption',
    value: function saveSalesforceOption(value, index) {
      this.setState(function (prevState) {
        var newMappings = [].concat(_toConsumableArray(prevState.mappings));
        newMappings[index + prevState.index * prevState.size].salesforceId = value ? value.value : null;
        return {
          newMappings: newMappings,
          hasActiveSearch: null
        };
      }, this.onMappingsChange);
    }
  }, {
    key: 'saveDriftUserOption',
    value: function saveDriftUserOption(value, index) {
      this.setState(function (prevState) {
        var newMappings = [].concat(_toConsumableArray(prevState.mappings));
        newMappings[index + prevState.index * prevState.size].userId = value ? value.value : null;
        return { newMappings: newMappings };
      }, this.onMappingsChange);
    }
  }, {
    key: 'saveNewMappings',
    value: function saveNewMappings() {
      var mappings = this.state.mappings;

      this.props.actions.patchSFDCUserMappings({ set: mappings });
    }
  }, {
    key: 'saveChangedMapping',
    value: function saveChangedMapping() {
      var mappings = this.state.mappings;
      var sfdcUserMappings = this.props.sfdcUserMappings;


      var orig = sfdcUserMappings.map(JSON.stringify);
      var updated = mappings.map(JSON.stringify);

      // Length of list is the same so the item changed in place, find this index.
      var changedPos = -1;
      for (var pos in orig) {
        if (orig[pos] !== updated[pos]) {
          changedPos = pos;
          break;
        }
      }

      if (changedPos >= 0) {
        this.props.actions.patchSFDCUserMappings({ remove: [sfdcUserMappings[changedPos]], set: [mappings[changedPos]] });
      } else {
        // Revert to delete behavior.
        this.saveDeleteMappings();
      }
    }
  }, {
    key: 'saveDeleteMappings',
    value: function saveDeleteMappings() {
      var mappings = this.state.mappings;
      var sfdcUserMappings = this.props.sfdcUserMappings;


      var mappingsToRemove = sfdcUserMappings.map(JSON.stringify).filter(function (mapping) {
        return !mappings.map(JSON.stringify).includes(mapping);
      }).map(JSON.parse);

      this.props.actions.patchSFDCUserMappings({ remove: mappingsToRemove });
    }
  }, {
    key: 'renderSelectOption',
    value: function renderSelectOption(_ref) {
      var label = _ref.label;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        label
      );
    }
  }, {
    key: 'renderSalesforceDropdown',
    value: function renderSalesforceDropdown(id, index, disabled) {
      var _this2 = this;

      var selectOptions = {
        disabled: disabled,
        placeholder: "Search Salesforce Users..",
        className: "sfdc-user-map-select",
        value: id,
        options: this.getSalesforceUserOptions(id),
        searchable: true,
        isOpen: this.state.hasActiveSearch === index,
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        arrowRenderer: function arrowRenderer() {
          return _this2.renderSalesforceLoader(index);
        },
        onBlur: function onBlur() {
          return _this2.setState({ hasActiveSearch: null });
        },
        onChange: function onChange(value) {
          return _this2.saveSalesforceOption(value, index);
        },
        onInputChange: function onInputChange(query) {
          return _this2.searchSFDCUsers(query, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderDriftUserDropdown',
    value: function renderDriftUserDropdown(id, index, disabled) {
      var _this3 = this;

      var selectOptions = {
        disabled: disabled,
        value: id,
        pageSize: 10,
        searchable: true,
        placeholder: "Select Drift User..",
        className: "sfdc-user-map-select",
        options: this.getFormattedUserOptions(),
        optionRenderer: this.renderSelectOption,
        onChange: function onChange(value) {
          return _this3.saveDriftUserOption(value, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderMappingRows',
    value: function renderMappingRows(readOnly) {
      var _this4 = this;

      return this.state.mappings.slice(this.state.index * this.state.size, (this.state.index + 1) * this.state.size).map(function (mapping, index) {

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'salesforce-user-mapping-salesforce-user' },
            _this4.renderSalesforceDropdown(mapping.salesforceId, index, readOnly)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'salesforce-user-mapping-table-seperator' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            null,
            _this4.renderDriftUserDropdown(mapping.userId, index, readOnly)
          ),
          !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'salesforce-user-mapping-actions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
              { className: 'salesforce-mapping-remove-tooltip', component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  'Remove override'
                ), flow: 'up' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"], {
                type: 'utility',
                size: 'medium',
                icon: 'cancel-circle',
                className: 'salesforce-auto-mapping-button medium',
                onClick: function onClick() {
                  return _this4.removeMapping(index);
                }
              })
            )
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var readOnly = this.props.readOnly;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-user-mapping' },
          !readOnly && this.hasMappings() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_AddButton_index__["a" /* default */], {
            addButtonLabel: 'Add override',
            type: 'tertiary',
            onClick: this.addNewMapping,
            className: 'sfdc-mapping-add-override'
          }),
          this.hasMappings() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'drift-table salesforce-user-mapping-table' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'header-text' },
                    'Salesforce user'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'salesforce-user-mapping-actions' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'header-text' },
                    'Drift teammate'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'salesforce-user-mapping-table-seperator' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                this.renderMappingRows(readOnly)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Paginator"], {
              index: this.state.index,
              size: this.state.size,
              totalPages: this.state.totalPages,
              position: 'static',
              goForward: function goForward() {
                return _this5.setState(_extends({}, _this5.state, { index: _this5.state.index + 1 }));
              },
              goBackward: function goBackward() {
                return _this5.setState(_extends({}, _this5.state, { index: _this5.state.index - 1 }));
              },
              changeSize: function changeSize(event) {
                return _this5.setState(_extends({}, _this5.state, {
                  index: 0,
                  size: event.value,
                  totalPages: Math.ceil(_this5.state.mappings.length / event.value)
                }));
              }
            })
          ),
          !this.hasMappings() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__["ColorWay"],
              { className: 'empty-state-icon', type: '2' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__["Icon"], { name: 'cw-empty-search' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'empty-state-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'empty-state-title' },
                'Override mapped Salesforce users'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'You currently have no overrides'
              ),
              !readOnly && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_AddButton_index__["a" /* default */], {
                addButtonLabel: 'Add override',
                type: 'tertiary',
                onClick: this.addNewMapping,
                className: 'sfdc-mapping-add-override'
              })
            )
          )
        )
      );
    }
  }]);

  return SalesforceUserMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceUserMapping);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "4XJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("+3of");











var mapStateToProps = function mapStateToProps(state, props) {
  return {
    email: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["S" /* getEmail */](state, props),
    lastEmailId: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_9" /* getLastEmailId */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state),
    senderEmailOverride: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_80" /* sequenceSenderEmailOverride */](state),
    sendFromOverride: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_79" /* sequenceSendFromOverride */](state),
    authorId: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_75" /* sequenceAuthorId */](state),
    dynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_76" /* sequenceDynamicSendAttribute */](state),
    dynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_77" /* sequenceDynamicSenderFormat */](state),
    sendTestEmailLoading: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_19" /* getSendTestEmailLoading */](state),
    sendTestEmailId: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_18" /* getSendTestEmailId */](state),
    isGoogleScopesPending: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["isGoogleScopesPending"])(state),
    isGmailConnected: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["isGmailConnected"])(state),
    editSenderLevel: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["P" /* getEditSenderLevel */](state),
    isAutomatedMarketingEmail: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_1" /* getIsAutomatedMarketingEmailPlaybook */](state),
    showOneClickScheduling: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__["g" /* properties */](state).get('hasSequenceCalendarInjection', false)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_181" /* setMessage */],
      setEmailDelay: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_163" /* setEmailDelay */],
      deleteEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["J" /* deleteEmail */],
      moveEmailUp: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_94" /* moveEmailUp */],
      setEmailMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_164" /* setEmailMessage */],
      setEmailTitle: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_168" /* setEmailTitle */],
      setSenderName: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_198" /* setSequenceSenderName */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_190" /* setSequenceAuthorId */],
      setEmailOverride: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_193" /* setSequenceEmailOverride */],
      sendTestEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_125" /* sendTestEmail */],
      showGoogleAuthModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_234" /* showGoogleAuthModal */],
      setThreadedWithPrevious: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_218" /* setThreadedWithPrevious */],
      setSequenceIndividualSenderName: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_197" /* setSequenceIndividualSenderName */],
      setSequenceIndividualEmailOverride: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_196" /* setSequenceIndividualEmailOverride */],
      savePlaybookFailed: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_114" /* savePlaybookFailed */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    isLastEmail: props.id === props.lastEmailId,
    hideDelay: !props.index && !props.isAutomatedMarketingEmail
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onDelayChange: function onDelayChange(props) {
    return function (event) {
      var value = Number(event.target.value);
      // TODO: change this back to min=1 one we have
      // "send me the entire test sequence" button
      var delay = Math.max(0, value);
      props.actions.setEmailDelay({ emailId: props.id, delay: delay });
    };
  },
  onMessageChange: function onMessageChange(props) {
    return function (content) {
      props.actions.setEmailMessage({ emailId: props.email.id, message: content });
    };
  },
  onThreadedWithPreviousClick: function onThreadedWithPreviousClick(props) {
    return function () {
      props.actions.setThreadedWithPrevious({
        emailId: props.email.id,
        threadedWithPrevious: !props.email.threadedWithPrevious
      });
    };
  },
  onDeleteClick: function onDeleteClick(props) {
    return function () {
      props.actions.deleteEmail(props.id);
    };
  },
  // TODO: pass onMove*Click to the child components once the bug with
  // TinyMCE is fixed where it wipes the contents of the iframe
  onMoveDownClick: function onMoveDownClick(props) {
    return function () {
      var moveEmailUp = props.actions.moveEmailUp,
          index = props.index;

      moveEmailUp(index + 1);
    };
  },
  onMoveUpClick: function onMoveUpClick(props) {
    return function () {
      var moveEmailUp = props.actions.moveEmailUp,
          index = props.index;

      moveEmailUp(index);
    };
  },
  onTitleChange: function onTitleChange(props) {
    return function (event) {
      // If the title is empty or is only spaces, do not allow it to save.
      var isInvalid = !event.target.value || !event.target.value.trim();

      if (isInvalid) {
        props.actions.savePlaybookFailed();
      }

      props.actions.setEmailTitle({ emailId: props.email.id, title: event.target.value, dontSave: isInvalid });
    };
  },
  onHeadlineChange: function onHeadlineChange(props) {
    return function (newTitle) {
      // If the title is empty or is only spaces, do not allow it to save.
      var isInvalid = !newTitle || !newTitle.trim();

      if (isInvalid) {
        props.actions.savePlaybookFailed();
      }

      props.actions.setEmailTitle({ emailId: props.email.id, title: newTitle, dontSave: isInvalid });
    };
  },
  onCardMessageChange: function onCardMessageChange(props) {
    return function (newMessage) {
      props.actions.setEmailMessage({ emailId: props.email.id, message: newMessage });
    };
  },
  onSendTestEmailClick: function onSendTestEmailClick(props) {
    return function () {
      if (props.isGmailConnected) {
        props.actions.sendTestEmail({ emailId: props.id });
      } else {
        props.actions.showGoogleAuthModal();
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "4YZ8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionConstants__ = __webpack_require__("h6+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_NotificationHelper__ = __webpack_require__("a56C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__ = __webpack_require__("1rl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_passwordUtils__ = __webpack_require__("7U93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_tracking__ = __webpack_require__("jAlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("ivXw");









var UserStore = Marty.createStore({
  id: 'UserStore',

  getInitialState: function getInitialState() {
    return {
      usersById: {},
      userExistenceByOrgHandle: {},
      userExistenceByEmail: {},
      emailsAlreadyRegistered: {},
      userUpdateState: {},
      passwordChangeState: {},
      passwordErrorMessage: '',
      oAuthCodes: {},
      oAuthAppInfo: {},
      oAuthFailures: {}
    };
  },


  handlers: {
    refreshUsers: __WEBPACK_IMPORTED_MODULE_1_constants_ActionConstants__["default"].REFRESH_ALL_PLZ,
    fetchUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_FETCH_DONE,
    fetchUsersForOrgIdDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].FETCH_USERS_FOR_ORG_ID_DONE,
    fetchCurrentUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_DONE,

    createUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_CREATE_DONE,
    createUserWithEmailDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_DONE,
    emailAlreadyRegistered: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].EMAIL_ALREADY_REGISTERED,

    checkUserExistenceByOrgHandle: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL,
    checkUserExistenceByOrgHandleDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_DONE,
    checkUserExistenceByEmailDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_EMAIL_DONE,

    updateUser: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_UPDATE,
    updateUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_UPDATE_DONE,

    changePassword: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD,
    changePasswordDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_DONE,
    changePasswordFailed: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_FAILED,
    clearPasswordValidationErrors: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CLEAR_PASSWORD_VALIDATION_ERRORS,
    uploadUserAvatar: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_AVATAR_UPLOAD,

    archiveUser: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_ARCHIVE,
    archiveUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_ARCHIVE_DONE,
    archiveUserFailed: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_ARCHIVE_FAILED,

    archiveUsers: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].ARCHIVE_USERS,
    archiveUsersDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].ARCHIVE_USERS_DONE,
    archiveUsersFailed: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].ARCHIVE_USERS_FAILED,

    fetchOAuthCodeDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].FETCH_OAUTH_CODE_DONE,
    fetchOAuthCodeFailed: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].FETCH_OAUTH_CODE_FAILED,

    fetchOauthAppInfoDone: __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].FETCH_OAUTH_APP_DONE
  },

  refreshUsers: function refreshUsers() {
    return this.app.queries.UserQueries.fetchUsersForOrgId(this.getCurrentUser().orgId);
  },
  emailAlreadyRegistered: function emailAlreadyRegistered(email) {
    return this.setEmailAlreadyRegistered(email);
  },
  getEmailsAlreadyRegistered: function getEmailsAlreadyRegistered() {
    return this.state.emailsAlreadyRegistered;
  },
  setEmailAlreadyRegistered: function setEmailAlreadyRegistered(email, registered) {
    if (registered == null) {
      registered = true;
    }
    var emailsAlreadyRegistered = _.cloneDeep(this.state.emailsAlreadyRegistered);
    emailsAlreadyRegistered[email] = registered;
    return this.setState({ emailsAlreadyRegistered: emailsAlreadyRegistered });
  },
  getUsersById: function getUsersById() {
    return this.state.usersById;
  },
  getOrFetchUser: function getOrFetchUser(userId) {
    return this.fetch({
      id: 'fetchUser' + userId,
      locally: function locally() {
        return this.state.usersById[userId];
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.fetchUser(userId);
      }
    });
  },
  getOrFetchUsersForCurrentUserOrg: function getOrFetchUsersForCurrentUserOrg() {
    return this.fetch({
      id: 'getOrFetchUsersForCurrentUserOrg',
      dependsOn: [this.getOrFetchCurrentUser()],
      locally: function locally() {
        if (this.hasAlreadyFetched('getOrFetchUsersForCurrentUserOrg')) {
          return this.getUsersForOrgId(this.getCurrentUser().orgId);
        }
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.fetchUsersForOrgId(this.getCurrentUser().orgId);
      }
    });
  },
  getOrFetchOnCallUsersForCurrentUserOrg: function getOrFetchOnCallUsersForCurrentUserOrg() {
    return this.fetch({
      id: 'getOrFetchOnCallUsersForCurrentUserOrg',
      dependsOn: [this.getOrFetchUsersForCurrentUserOrg()],
      locally: function locally() {
        return this.getOnCallUsersForOrgId(this.getCurrentUser().orgId);
      }
    });
  },
  getOrFetchActiveUsersForCurrentUserOrg: function getOrFetchActiveUsersForCurrentUserOrg() {
    return this.fetch({
      id: 'getOrFetchActiveUsersForCurrentUserOrg',
      dependsOn: [this.getOrFetchUsersForCurrentUserOrg()],
      locally: function locally() {
        return this.getActiveUsersForOrgId(this.getCurrentUser().orgId);
      }
    });
  },
  getOrFetchNonBotUsersForCurrentUserOrg: function getOrFetchNonBotUsersForCurrentUserOrg() {
    return this.fetch({
      id: 'getOrFetchNonBotUsersForCurrentUserOrg',
      dependsOn: [this.getOrFetchUsersForCurrentUserOrg()],
      locally: function locally() {
        return this.getNonBotUsersForOrgId(this.getCurrentUser().orgId);
      }
    });
  },
  getUsersForOrgId: function getUsersForOrgId(orgId) {
    return _.pickBy(this.state.usersById, function (user) {
      return user.orgId === orgId;
    });
  },
  getOnCallUsersForOrgId: function getOnCallUsersForOrgId(orgId) {
    return _.pickBy(this.state.usersById, function (user) {
      return user.orgId === orgId && user.availability === 'ON_CALL';
    });
  },
  getActiveUsersForOrgId: function getActiveUsersForOrgId(orgId) {
    return _.pickBy(this.state.usersById, function (user) {
      return user.orgId === orgId && user.status === 'ENABLED';
    });
  },
  getNonBotUsersForOrgId: function getNonBotUsersForOrgId(orgId) {
    return _.pickBy(this.state.usersById, function (user) {
      return user.orgId === orgId && !user.bot;
    });
  },
  fetchUserDone: function fetchUserDone(userId, user) {
    var usersById = _.cloneDeep(this.state.usersById);
    usersById[userId] = user;
    return this.setState({ usersById: usersById });
  },
  fetchUsersForOrgIdDone: function fetchUsersForOrgIdDone(orgId, users) {
    var usersById = _.cloneDeep(this.state.usersById);
    _.each(users, function (user) {
      return usersById[user.id] = user;
    });
    return this.setState({ usersById: usersById });
  },
  getOrFetchCurrentUser: function getOrFetchCurrentUser() {
    return this.fetch({
      id: 'getCurrentUser',
      cacheError: false,
      locally: function locally() {
        return this.getCurrentUser();
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.fetchCurrentLoggedInUser();
      }
    });
  },
  fetchOauthCode: function fetchOauthCode(_ref) {
    var redirect_uri = _ref.redirect_uri,
        client_id = _ref.client_id;

    var id = 'OauthCode' + JSON.stringify({ redirect_uri: redirect_uri, client_id: client_id });
    return this.fetch({
      id: id,
      locally: function locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.state.oAuthCodes[id];
        }
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.fetchOauthCode({ redirect_uri: redirect_uri, client_id: client_id });
      }
    });
  },
  fetchOAuthCodeDone: function fetchOAuthCodeDone(_ref2) {
    var redirect_uri = _ref2.redirect_uri,
        client_id = _ref2.client_id,
        body = _ref2.body;

    var id = this.getOAuthId({ redirect_uri: redirect_uri, client_id: client_id });
    var oAuthCodes = _.cloneDeep(this.state.oAuthCodes);
    oAuthCodes[id] = body.code;
    return this.setState({ oAuthCodes: oAuthCodes });
  },
  getOAuthId: function getOAuthId(_ref3) {
    var redirect_uri = _ref3.redirect_uri,
        client_id = _ref3.client_id;

    return 'OauthCode' + JSON.stringify({ redirect_uri: redirect_uri, client_id: client_id });
  },
  fetchOAuthCodeFailed: function fetchOAuthCodeFailed(_ref4) {
    var redirect_uri = _ref4.redirect_uri,
        client_id = _ref4.client_id,
        body = _ref4.body;

    var id = this.getOAuthId({ redirect_uri: redirect_uri, client_id: client_id });
    var oAuthFailures = _.cloneDeep(this.state.oAuthFailures);
    oAuthFailures[id] = body;
    return this.setState({ oAuthFailures: oAuthFailures });
  },
  getOAuthFailures: function getOAuthFailures(_ref5) {
    var redirect_uri = _ref5.redirect_uri,
        client_id = _ref5.client_id;

    var id = this.getOAuthId({ redirect_uri: redirect_uri, client_id: client_id });
    return this.state.oAuthFailures[id];
  },
  fetchOauthAppInfo: function fetchOauthAppInfo(client_id) {
    var id = 'fetchOauthApp' + client_id;
    return this.fetch({
      id: id,
      locally: function locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.state.oAuthAppInfo[client_id];
        }
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.fetchOauthAppInfo(client_id);
      }
    });
  },
  fetchOauthAppInfoDone: function fetchOauthAppInfoDone(_ref6) {
    var client_id = _ref6.client_id,
        app = _ref6.app;

    var oAuthAppInfo = _.cloneDeep(this.state.oAuthAppInfo);
    oAuthAppInfo[client_id] = app;
    return this.setState({ oAuthAppInfo: oAuthAppInfo });
  },
  fetchCurrentUserDone: function fetchCurrentUserDone(user) {
    var ravenClient = Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["d" /* getRavenClient */])();
    if (ravenClient != null) {
      ravenClient.setUserContext(user);
    }
    if (Marty.isBrowser) {
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_tracking__["a" /* identifyUser */])(user);
    }
    this.fetchUserDone(user.id, user);
    return this.setState({ currentUserId: user.id });
  },
  setCurrentUser: function setCurrentUser(email, user, accessToken) {
    this.setEmailAlreadyRegistered(email);
    this.fetchCurrentUserDone(user);
    return Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["setAccessToken"])({ token: accessToken.accessToken });
  },
  createUserDone: function createUserDone(email, user, accessToken) {
    return this.setCurrentUser(email, user, accessToken);
  },
  createUserWithEmailDone: function createUserWithEmailDone(email, user, accessToken) {
    return this.setCurrentUser(email, user, accessToken);
  },
  getCurrentUser: function getCurrentUser() {
    return this.state.usersById[this.state.currentUserId];
  },
  fetchUserExistenceByEmail: function fetchUserExistenceByEmail(email) {
    return this.fetch({
      id: 'fetchUserExistenceByEmail' + email,
      locally: function locally() {
        return this.state.userExistenceByEmail[email];
      },
      remotely: function remotely() {
        return this.app.queries.UserQueries.checkUserEmailExistence(email);
      }
    });
  },
  getUserExistenceByEmail: function getUserExistenceByEmail() {
    return this.state.userExistenceByEmail || {};
  },
  checkUserExistenceByEmailDone: function checkUserExistenceByEmailDone(email, exists) {
    var userExistenceByEmail = _.cloneDeep(this.state.userExistenceByEmail);
    userExistenceByEmail[email] = exists;
    return this.setState({ userExistenceByEmail: userExistenceByEmail });
  },
  checkUserExistenceByOrgHandle: function checkUserExistenceByOrgHandle(email, orgHandle) {
    if ((this.state.userExistenceByOrgHandle[orgHandle] != null ? this.state.userExistenceByOrgHandle[orgHandle][email] : undefined) == null) {
      return this.app.queries.UserQueries.getUserExistenceByEmailAndOrgHandle(email, orgHandle);
    }
  },
  checkUserExistenceByOrgHandleDone: function checkUserExistenceByOrgHandleDone(email, orgHandle, exists) {
    var userExistenceByOrgHandle = _.cloneDeep(this.state.userExistenceByOrgHandle);
    userExistenceByOrgHandle[orgHandle] = userExistenceByOrgHandle[orgHandle] || {};
    userExistenceByOrgHandle[orgHandle][email] = exists;
    return this.setState({ userExistenceByOrgHandle: userExistenceByOrgHandle });
  },
  getUserExistenceByOrgHandle: function getUserExistenceByOrgHandle() {
    return this.state.userExistenceByOrgHandle;
  },


  // Update User

  updateUser: function updateUser(userId, params) {
    this.app.queries.UserQueries.updateUser({
      userId: userId,
      params: params,
      isCurrentUser: this.state.currentUserId === userId,
      notify: true
    });
    var userUpdateState = _.cloneDeep(this.state.userUpdateState);
    userUpdateState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_UPDATE_STARTING;
    return this.setState({
      userUpdateState: userUpdateState
    });
  },
  updateUserDone: function updateUserDone(userId, user) {
    var usersById = _.cloneDeep(this.state.usersById);
    var oldUser = usersById[userId];
    if (user.status === 'ENABLED' && (oldUser != null ? oldUser.status : undefined) === 'INVITED') {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_NotificationHelper__["b" /* notifyAcceptedInvitation */])(user);
    }

    usersById[userId] = user;
    var userUpdateState = _.cloneDeep(this.state.userUpdateState);
    userUpdateState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_UPDATE_DONE;
    return this.setState({
      userUpdateState: userUpdateState,
      usersById: usersById
    });
  },
  changePassword: function changePassword(userId, password) {
    this.app.queries.UserQueries.changePassword(userId, password);
    var passwordChangeState = _.cloneDeep(this.state.passwordChangeState);
    passwordChangeState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_STARTING;
    return this.setState({
      passwordChangeState: passwordChangeState
    });
  },
  changePasswordDone: function changePasswordDone(userId, response) {
    Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["setAccessToken"])({ token: response.access_token });
    var passwordChangeState = _.cloneDeep(this.state.passwordChangeState);
    passwordChangeState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_DONE;
    return this.setState({
      passwordChangeState: passwordChangeState,
      passwordErrorMessage: ''
    });
  },
  changePasswordFailed: function changePasswordFailed(userId, validationErrors) {
    var passwordErrorMessage = '';
    if (validationErrors && validationErrors[0]) {
      passwordErrorMessage = Object(__WEBPACK_IMPORTED_MODULE_4_utils_passwordUtils__["a" /* resolvePasswordErrorMessage */])(validationErrors[0].message);
    }

    var passwordChangeState = _.cloneDeep(this.state.passwordChangeState);
    passwordChangeState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_FAILED;
    return this.setState({
      passwordChangeState: passwordChangeState,
      passwordErrorMessage: passwordErrorMessage
    });
  },
  clearPasswordValidationErrors: function clearPasswordValidationErrors() {
    return this.setState({
      passwordErrorMessage: ''
    });
  },
  getPasswordChangeState: function getPasswordChangeState() {
    return this.state.passwordChangeState;
  },
  getPasswordErrorMessage: function getPasswordErrorMessage() {
    return this.fetch({
      id: 'getPasswordErrorMessage',
      locally: function locally() {
        return this.state.passwordErrorMessage;
      },
      remotely: function remotely() {
        return this.state.passwordErrorMessage;
      }
    });
  },
  resetPasswordChangeState: function resetPasswordChangeState() {
    return this.setState({ passwordChangeState: {} });
  },
  getUserUpdateState: function getUserUpdateState() {
    return this.state.userUpdateState;
  },
  resetUserUpdateState: function resetUserUpdateState() {
    return this.setState({ userUpdateState: {} });
  },
  uploadUserAvatar: function uploadUserAvatar(userId, file) {
    var userUpdateState = _.cloneDeep(this.state.userUpdateState);
    userUpdateState[userId] = __WEBPACK_IMPORTED_MODULE_3_constants_UserConstants__["a" /* default */].USER_UPDATE_STARTING;
    this.setState({
      userUpdateState: userUpdateState
    });
    return this.app.queries.UserQueries.uploadUserAvatar(userId, file);
  },
  archiveUser: function archiveUser(userId) {
    return this.app.queries.UserQueries.archiveUser(userId);
  },
  archiveUserDone: function archiveUserDone(userId) {
    var usersById = _.cloneDeep(this.state.usersById);
    delete usersById[userId];
    return this.setState({ usersById: usersById });
  },
  archiveUserFailed: function archiveUserFailed() {},
  archiveUsers: function archiveUsers(userIds) {
    return this.app.queries.UserQueries.archiveUsers(userIds);
  },
  archiveUsersFailed: function archiveUsersFailed() {},
  archiveUsersDone: function archiveUsersDone(userIds) {
    return Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["pick"])(userIds, this.state.usersById);
  },
  onHydrate: function onHydrate() {
    var currentUser = this.getCurrentUser();
    if (currentUser) {
      var ravenClient = Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["d" /* getRavenClient */])();
      if (ravenClient != null) {
        ravenClient.setUserContext(currentUser);
      }
      return SegmentHelpers.identifyUser(currentUser);
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "4aFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("7WAT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CONNECT_ERROR_MESSAGE = 'Oops, there was an error connecting to Marketo. Are your credentials correct? Please try again.';
var CONNECT_SUCCESS_MESSAGE = 'Marketo was successfully connected!';
var STATUS_PAGE_URL = '/settings/setup/marketo';

var InputGroup = function InputGroup(_ref) {
  var title = _ref.title,
      description = _ref.description,
      setValue = _ref.setValue;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'marketo-config-input-group drift-form' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'marketo-config-input-group-title' },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: setValue }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'marketo-config-input-group-description' },
      description
    )
  );
};

var MarketoConfigPage = function (_Component) {
  _inherits(MarketoConfigPage, _Component);

  function MarketoConfigPage(props) {
    _classCallCheck(this, MarketoConfigPage);

    var _this = _possibleConstructorReturn(this, (MarketoConfigPage.__proto__ || Object.getPrototypeOf(MarketoConfigPage)).call(this, props));

    _this.setMunchkinId = function (event) {
      _this.setState({
        munchkinId: event.target.value
      });
    };

    _this.setClientId = function (event) {
      _this.setState({
        clientId: event.target.value
      });
    };

    _this.setClientSecret = function (event) {
      _this.setState({
        clientSecret: event.target.value
      });
    };

    _this.isConnectDisabled = function () {
      var _this$state = _this.state,
          munchkinId = _this$state.munchkinId,
          clientId = _this$state.clientId,
          clientSecret = _this$state.clientSecret;

      return Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["any"])(__WEBPACK_IMPORTED_MODULE_2_ramda__["isEmpty"])([munchkinId, clientId, clientSecret]);
    };

    _this.connectMarketo = function () {
      var _this$state2 = _this.state,
          munchkinId = _this$state2.munchkinId,
          clientId = _this$state2.clientId,
          clientSecret = _this$state2.clientSecret;
      var router = _this.context.router;


      var onSuccess = function onSuccess() {
        _this.setState({ isConnecting: false });
        _this.props.notifications.success(CONNECT_SUCCESS_MESSAGE);
        router.push({ pathname: STATUS_PAGE_URL, query: { expanded: true } });
      };

      var onError = function onError() {
        _this.setState({ isConnecting: false });
        _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
        Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["O" /* postLoginFailure */])('marketo');
      };

      _this.setState({ isConnecting: true });

      Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["b" /* connectMarketo */])({ munchkinId: munchkinId, clientId: clientId, clientSecret: clientSecret }).then(function () {
        return _this.props.actions.fetchIntegrationStates();
      }).then(onSuccess).catch(onError);
    };

    _this.state = {
      munchkinId: '',
      clientId: '',
      clientSecret: '',
      isConnecting: false
    };
    return _this;
  }

  _createClass(MarketoConfigPage, [{
    key: 'render',
    value: function render() {
      var isConnecting = this.state.isConnecting;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'marketo-config-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'marketo-config-page-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'marketo-config-page-title' },
            'Connect Drift and Marketo V2'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'marketo-config-page-description' },
            'Connect your Drift to Marketo V2 integration here. Need some help? Feel free to talk to us or view our',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://gethelp.drift.com/hc/en-us/sections/360003545713-Marketo-and-Drift', target: '_blank' },
              'Setup Guide'
            ),
            '.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'marketo-config-input-groups' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, {
            title: 'Munchkin Account ID',
            description: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'munchkin-account-id-description' },
              'You can find your Account ID under',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                'Admin > Integration > Munchkin > Tracking Code'
              ),
              'in your',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://gethelp.drift.com/hc/en-us/articles/360019503974-How-to-Connect-Drift-and-Marketo', target: '_blank' },
                'Marketo Account'
              )
            ),
            setValue: this.setMunchkinId
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, {
            title: 'Client ID',
            description: 'This is your Marketo REST API Client ID',
            setValue: this.setClientId
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputGroup, {
            title: 'Client Secret',
            description: 'This is your Marketo REST API Client Secret',
            setValue: this.setClientSecret
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.connectMarketo,
            className: 'marketo-config-connect-button drift-button drift-button-primary',
            disabled: this.isConnectDisabled() },
          isConnecting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_CircleOfWaiting__["a" /* default */], null),
          !isConnecting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Connect Marketo V2'
          )
        )
      );
    }
  }]);

  return MarketoConfigPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MarketoConfigPage.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({ fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__["l" /* fetchIntegrationStates */] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(null, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(MarketoConfigPage)));

/***/ }),

/***/ "4f8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unsubscribeChoices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Confirm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chroma_js__ = __webpack_require__("4SWg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chroma_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chroma_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emoji_mart__ = __webpack_require__("TuRI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emoji_mart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emoji_mart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("oFXL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);









var REASONS = [{
  emoji: ':broken_heart:',
  description: 'Your emails are not relevant to me'
}, {
  emoji: ':man-facepalming:',
  description: 'Your emails are sent too frequently'
}, {
  emoji: ':no_entry_sign:',
  description: 'I no longer want to receive these emails'
}, {
  emoji: ':woman-shrugging:',
  description: 'I don\'t remember signing up for this'
}, {
  emoji: ':speech_balloon:',
  description: 'Other reason'
}];

var unsubscribeChoices = {
  UNSUB: 'UNSUB',
  UNSUB_AND_REQUEST_DELETE: 'UNSUB_AND_REQUEST_DELETE'
};

var powerByDriftLinkParams = {
  utm_source: 'email',
  utm_campaign: 'email-unsubscribed'
};

var POWERED_BY_URL = 'https://www.drift.com/powered-by?' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["d" /* encodeQueryData */])(powerByDriftLinkParams);

var Loading = function Loading() {
  return React.createElement(
    'div',
    { className: 'unsubscribe-confirm-loader-container' },
    React.createElement(
      'div',
      null,
      React.createElement(
        'h2',
        null,
        'Fetching your details...'
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Loader"], { className: 'unsubscribe-confirm-loader' })
    )
  );
};

var Confirm = function Confirm(_ref) {
  var backgroundColor = _ref.backgroundColor,
      logoUrl = _ref.logoUrl,
      responded = _ref.responded,
      emailInput = _ref.emailInput,
      onEmailConfirmChange = _ref.onEmailConfirmChange,
      unsubscribed = _ref.unsubscribed,
      handleResponseClick = _ref.handleResponseClick,
      onConfirmClick = _ref.onConfirmClick,
      onResubscribeClick = _ref.onResubscribeClick,
      unsubscribeError = _ref.unsubscribeError,
      unsubscribeErrorMessage = _ref.unsubscribeErrorMessage,
      resubscribed = _ref.resubscribed,
      resubscribeError = _ref.resubscribeError,
      resubscribeErrorMessage = _ref.resubscribeErrorMessage,
      cantUnsub = _ref.cantUnsub,
      cantResub = _ref.cantResub,
      organizationName = _ref.organizationName,
      embedLoaded = _ref.embedLoaded,
      embedLoadFailed = _ref.embedLoadFailed,
      isGdprConsentRequired = _ref.isGdprConsentRequired,
      unsubscribeChoice = _ref.unsubscribeChoice,
      onUnsubChoiceChange = _ref.onUnsubChoiceChange,
      confirmDisabled = _ref.confirmDisabled,
      unsubRequestDeleteSuccess = _ref.unsubRequestDeleteSuccess,
      unsubPending = _ref.unsubPending,
      requestDeleteFailed = _ref.requestDeleteFailed;
  return React.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("unsubscribe-confirm", { 'unsubscribe-confirm-whitelabel-container': embedLoadFailed }),
      style: !!embedLoaded ? {
        background: 'linear-gradient(to bottom, ' + backgroundColor + ', ' + __WEBPACK_IMPORTED_MODULE_0_chroma_js___default()(backgroundColor).darken().hex() + ')'
      } : undefined
    },
    React.createElement(
      'div',
      { className: 'unsubscribe-confirm-card' },
      logoUrl && React.createElement('img', { src: logoUrl }),
      unsubscribed && !unsubPending && !responded && React.createElement(
        'div',
        null,
        React.createElement(
          'h1',
          null,
          'Unsubscribe Successful!'
        ),
        React.createElement(
          'p',
          null,
          'You will no longer receive email communication at ',
          React.createElement(
            'strong',
            null,
            emailInput
          ),
          '.'
        )
      ),
      unsubRequestDeleteSuccess && !resubscribed && !responded && React.createElement(
        'p',
        null,
        'An admin has received your request to delete your data and will be processed within 30 days.'
      ),
      requestDeleteFailed && !resubscribed && !responded && React.createElement(
        'p',
        { className: 'subscription-confirm-error-message' },
        'We were unable to request data deletion, please contact an admin.'
      ),
      (resubscribed || responded) && React.createElement(ResubRespondedEmail, {
        emailInput: emailInput,
        responded: responded,
        resubscribed: resubscribed,
        isGdprConsentRequired: isGdprConsentRequired,
        requestDeleteFailed: requestDeleteFailed }),
      (!unsubscribed || unsubPending) && !resubscribed && React.createElement(ConfirmEmail, {
        emailInput: emailInput,
        onEmailConfirmChange: onEmailConfirmChange,
        unsubscribePending: unsubPending,
        unsubscribeError: unsubscribeError,
        unsubscribeErrorMessage: unsubscribeErrorMessage,
        cantUnsub: cantUnsub,
        isGdprConsentRequired: isGdprConsentRequired,
        unsubscribeChoice: unsubscribeChoice,
        onUnsubChoiceChange: onUnsubChoiceChange,
        confirmDisabled: confirmDisabled,
        onConfirmClick: onConfirmClick }),
      unsubscribed && !unsubPending && !responded && !resubscribed && React.createElement(SelectReason, { handleResponseClick: handleResponseClick }),
      resubscribeError && React.createElement(
        'p',
        { className: 'subscription-confirm-error-message' },
        resubscribeErrorMessage
      ),
      unsubscribed && cantResub && React.createElement(
        'p',
        { className: 'subscription-confirm-error-message' },
        'There was a problem when trying to resubscribe you, please contact support to resubscribe.'
      ),
      unsubscribed && !unsubPending && !responded && React.createElement(
        'span',
        { onClick: onResubscribeClick },
        React.createElement(
          'a',
          null,
          'Oops, resubscribe me'
        )
      ),
      React.createElement(
        'p',
        null,
        'Email ',
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_emoji_mart__["Emoji"], { emoji: ':zap:', size: 16 }),
        ' by ',
        React.createElement(
          'a',
          { href: POWERED_BY_URL, target: '_blank' },
          'Drift'
        )
      )
    )
  );
};

var ResubRespondedEmail = function ResubRespondedEmail(_ref2) {
  var emailInput = _ref2.emailInput,
      resubscribed = _ref2.resubscribed,
      responded = _ref2.responded,
      isGdprConsentRequired = _ref2.isGdprConsentRequired;
  return React.createElement(
    'div',
    null,
    resubscribed && React.createElement(
      'div',
      null,
      React.createElement(
        'h1',
        null,
        'Resubscribe Successful!'
      ),
      React.createElement(
        'p',
        null,
        'You will receive email communication at ',
        React.createElement(
          'strong',
          null,
          emailInput
        )
      )
    ),
    responded && React.createElement(
      'div',
      null,
      React.createElement(
        'h1',
        null,
        'Thanks for the feedback!'
      ),
      React.createElement(
        'p',
        null,
        'You will no longer receive email communication at ',
        React.createElement(
          'strong',
          null,
          emailInput
        ),
        '.'
      ),
      React.createElement(
        'p',
        null,
        'We appreciate you helping us get better.'
      )
    ),
    React.createElement(
      'div',
      { className: "unsubscribe-responded" + (isGdprConsentRequired ? ' unsubscribe-responded-gdpr' : ' unsubscribe-responded-not-gdpr') },
      React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { name: 'check-circle' })
    )
  );
};

var ConfirmEmail = function ConfirmEmail(_ref3) {
  var emailInput = _ref3.emailInput,
      onEmailConfirmChange = _ref3.onEmailConfirmChange,
      unsubscribePending = _ref3.unsubscribePending,
      onConfirmClick = _ref3.onConfirmClick,
      unsubscribeError = _ref3.unsubscribeError,
      unsubscribeErrorMessage = _ref3.unsubscribeErrorMessage,
      cantUnsub = _ref3.cantUnsub,
      isGdprConsentRequired = _ref3.isGdprConsentRequired,
      unsubscribeChoice = _ref3.unsubscribeChoice,
      onUnsubChoiceChange = _ref3.onUnsubChoiceChange,
      confirmDisabled = _ref3.confirmDisabled;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'h1',
      null,
      'Confirm unsubscribing from emails'
    ),
    React.createElement(
      'p',
      null,
      'Please take a moment to confirm that you no longer wish to receive email communication at ',
      React.createElement(
        'strong',
        null,
        emailInput
      ),
      '.'
    ),
    unsubscribeError && React.createElement(
      'p',
      { className: 'subscription-confirm-error-message' },
      unsubscribeErrorMessage
    ),
    cantUnsub && React.createElement(
      'p',
      { className: 'subscription-confirm-error-message' },
      'There was a problem when trying to unsubscribe you, please contact support to unsubscribe.'
    ),
    React.createElement(
      'div',
      { className: 'subscription-confirm-input-container' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { value: emailInput, onChange: onEmailConfirmChange, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("subscription-confirm-input-email", { 'subscription-confirm-input-gdpr': isGdprConsentRequired }) }),
      isGdprConsentRequired && React.createElement(
        'div',
        { className: 'subscription-radio-choices' },
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("subscription-radio-choice", { 'subscription-radio-choice-selected': unsubscribeChoice === unsubscribeChoices.UNSUB }), onClick: function onClick() {
              return onUnsubChoiceChange(unsubscribeChoices.UNSUB);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], {
            type: 'radio',
            className: 'subscription-radio-input',
            name: 'unsub',
            checked: unsubscribeChoice === unsubscribeChoices.UNSUB
          }),
          React.createElement(
            'label',
            null,
            'Unsubscribe Me'
          )
        ),
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("subscription-radio-choice", { 'subscription-radio-choice-selected': unsubscribeChoice === unsubscribeChoices.UNSUB_AND_REQUEST_DELETE }), onClick: function onClick() {
              return onUnsubChoiceChange(unsubscribeChoices.UNSUB_AND_REQUEST_DELETE);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], {
            type: 'radio',
            className: 'subscription-radio-input',
            name: 'unsub',
            checked: unsubscribeChoice === unsubscribeChoices.UNSUB_AND_REQUEST_DELETE
          }),
          React.createElement(
            'label',
            null,
            'Unsubscribe and request my data be deleted'
          )
        )
      ),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
        {
          type: 'primary',
          disabled: confirmDisabled,
          loading: unsubscribePending,
          onClick: onConfirmClick,
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("subscription-confirm-button", { 'subscription-confirm-button-gdpr': isGdprConsentRequired })
        },
        'Confirm'
      )
    )
  );
};

var SelectReason = function SelectReason(_ref4) {
  var handleResponseClick = _ref4.handleResponseClick;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'p',
      null,
      'If you have a moment, can you tell us why you unsubscribed?'
    ),
    React.createElement(
      'div',
      { className: 'unsubscribe-confirm-reasons' },
      REASONS.map(function (reason) {
        return React.createElement(
          'button',
          { key: reason.emoji, className: 'drift-button drift-button-secondary', onClick: handleResponseClick(reason.description) },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_emoji_mart__["Emoji"], { emoji: reason.emoji, size: 16 }),
          reason.description
        );
      })
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "4g/L":
/***/ (function(module, exports) {

module.exports = "<svg width=\"60\" height=\"52\" xmlns=\"http://www.w3.org/2000/svg\"><defs><linearGradient x1=\"100%\" y1=\"100%\" x2=\"0%\" y2=\"-4.824%\" id=\"a\"><stop stop-color=\"#AA55D5\" offset=\"0%\"></stop><stop stop-color=\"#FF5A39\" offset=\"100%\"></stop></linearGradient></defs><g fill=\"none\" fill-rule=\"evenodd\"><ellipse fill=\"#DAEAF1\" cx=\"27.299\" cy=\"26\" rx=\"26.365\" ry=\"26\"></ellipse><g transform=\"translate(0 4.571)\"><polygon fill=\"#FFF\" fill-rule=\"nonzero\" points=\"0.78974359 4.67281106 0.78974359 39.718894 53.6307692 39.718894 53.6307692 4.67281106\"></polygon><path d=\"M0 4.86c0-.534.439-.966.98-.966h52.46c.541 0 .98.432.98.966v34.672a.973.973 0 0 1-.98.966H.98a.973.973 0 0 1-.98-.966V4.86zm1.961.966v32.74H52.46V5.826H1.961z\" fill=\"#2C3E48\" fill-rule=\"nonzero\"></path><rect fill=\"#2A3E4A\" x=\"38.985\" width=\"3.159\" height=\"7.788\" rx=\".505\"></rect><rect fill=\"#2A3E4A\" x=\"12.636\" width=\"3.159\" height=\"7.788\" rx=\".505\"></rect></g><ellipse fill=\"url(#a)\" cx=\"47.266\" cy=\"39.947\" rx=\"8.64\" ry=\"8.567\"></ellipse><rect fill=\"#5E65E2\" x=\"42\" y=\"24\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"5\" y=\"24\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"15\" y=\"24\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"24\" y=\"24\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"33\" y=\"24\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"42\" y=\"14\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"5\" y=\"14\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"15\" y=\"14\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"24\" y=\"14\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"33\" y=\"14\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"5\" y=\"33\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"15\" y=\"33\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#A7C8DA\" x=\"24\" y=\"33\" width=\"7\" height=\"7\" rx=\".887\"></rect><rect fill=\"#5E65E2\" x=\"33\" y=\"33\" width=\"7\" height=\"7\" rx=\".887\"></rect><g transform=\"translate(34 24)\"><circle fill=\"#D3578A\" cx=\"12\" cy=\"12\" r=\"12\"></circle><circle stroke=\"#2C3E49\" stroke-width=\"2.5\" cx=\"12\" cy=\"12\" r=\"12\"></circle></g><g fill=\"#FFF\" stroke=\"#FFF\" stroke-width=\".713\"><path d=\"M52.5 30.526c.354.356.523.706.498 1.04-.028.393-.306.748-.535.976v.001l-.247.247-2.013-2.016.246-.246.001-.002c.226-.226.579-.501.974-.524.347-.02.708.155 1.076.524zm-8.48 10.467L41 42l1.007-3.023 7.094-7.1 2.014 2.015-7.094 7.101z\"></path></g></g></svg>"

/***/ }),

/***/ "4gqt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("n24L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);






var MultiSignatureTemplate = function MultiSignatureTemplate(_ref) {
  var multiSignaturePreviewFetchPending = _ref.multiSignaturePreviewFetchPending,
      multiSignaturePreviewFetchFailed = _ref.multiSignaturePreviewFetchFailed,
      onRefetchClick = _ref.onRefetchClick,
      viewingSignatureNumber = _ref.viewingSignatureNumber,
      onNextSignatureClick = _ref.onNextSignatureClick,
      onPreviousSignatureClick = _ref.onPreviousSignatureClick,
      currentlyViewingSignature = _ref.currentlyViewingSignature,
      doCycle = _ref.doCycle;
  return multiSignaturePreviewFetchPending ? React.createElement(
    'div',
    { className: 'multiple-signature-loading' },
    React.createElement(
      'p',
      null,
      'Fetching your signature'
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_shared_LoadingDots__["a" /* default */], null)
  ) : multiSignaturePreviewFetchFailed ? React.createElement(
    'div',
    { className: 'multiple-signature-failed' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { className: 'fetch-failed-warning', name: 'warning-circle' }),
    React.createElement(
      'div',
      null,
      'We could not get your signature. ',
      React.createElement(
        'a',
        { onClick: onRefetchClick },
        'Try again'
      ),
      '?'
    )
  ) : React.createElement(
    'div',
    { className: 'multiple-signature-container' },
    doCycle && React.createElement(
      'div',
      { className: 'multiple-signature-cycle-container' },
      React.createElement(
        'div',
        { className: 'multiple-signature-cycle-dir', onClick: onPreviousSignatureClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { className: 'multiple-signature-cycle-dir-icon', name: 'arrow-1-left', width: 12, height: 12 })
      ),
      React.createElement(
        'div',
        { className: 'multiple-signature-cycle-num' },
        viewingSignatureNumber
      ),
      React.createElement(
        'div',
        { className: 'multiple-signature-cycle-dir', onClick: onNextSignatureClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { className: 'multiple-signature-cycle-dir-icon', name: 'arrow-1-right', width: 12, height: 12 })
      )
    ),
    React.createElement('div', { dangerouslySetInnerHTML: { __html: currentlyViewingSignature } })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MultiSignatureTemplate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "4hUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericEvent__ = __webpack_require__("8wCm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TAG_ICON_SRC = __webpack_require__("Jtxw");

var TagEvent = function (_Component) {
  _inherits(TagEvent, _Component);

  function TagEvent() {
    _classCallCheck(this, TagEvent);

    return _possibleConstructorReturn(this, (TagEvent.__proto__ || Object.getPrototypeOf(TagEvent)).apply(this, arguments));
  }

  _createClass(TagEvent, [{
    key: 'render',
    value: function render() {
      var eventType = this.props.event.eventType;
      var _props$event$body = this.props.event.body,
          tag = _props$event$body.tag,
          author = _props$event$body.author;

      var eventLabel = eventType === 'TAG_REMOVE' ? 'removed tag from this contact' : 'added tag to this contact';
      var eventProps = _extends({
        actionTaker: author,
        iconSrc: TAG_ICON_SRC,
        eventLabel: eventLabel
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__GenericEvent__["a" /* default */],
        eventProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'tag', style: {
              backgroundColor: '#' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_TagAppearanceHelper__["a" /* getNormalizedTagColor */])(tag.color),
              color: 'var(--main-navy-extra-dark)'
            } },
          tag.name
        )
      );
    }
  }]);

  return TagEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TagEvent.defaultProps = {
  author: { name: 'Drift' }
};
/* harmony default export */ __webpack_exports__["a"] = (TagEvent);

/***/ }),

/***/ "4hbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("ZjNn");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]);

/***/ }),

/***/ "4iEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export status */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasNext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isLoadingMore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("9QV1");




var root = function root(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["m" /* root */])(state).get('timeline');
};

var status = function status(state) {
  return root(state).get('status');
};
var events = function events(state) {
  return root(state).getIn(['events', 'data'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
};
var cursor = function cursor(state) {
  return root(state).getIn(['events', 'cursor']);
};
var hasNext = function hasNext(state) {
  return root(state).getIn(['events', 'hasNext']);
};

var isLoading = function isLoading(state) {
  return status(state) === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING */];
};
var isLoadingMore = function isLoadingMore(state) {
  return status(state) === __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING */];
};

/***/ }),

/***/ "4kPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ConnectButton__ = __webpack_require__("sCN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("lBcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CONTACT_UPDATE_MESSAGE = 'Create and update contacts in Marketo when they interact with Drift';
var ACTIVITY_PUSH_MESSAGE = 'Push conversation, qualification score updates, and new meeting activities to Marketo';
var IDENTIFY_CONTACT_MESSAGE = 'Identify unknown visitors using Marketo Munchkin Cookies';

var MarketoIntegrationPage = function (_Component) {
  _inherits(MarketoIntegrationPage, _Component);

  function MarketoIntegrationPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarketoIntegrationPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarketoIntegrationPage.__proto__ || Object.getPrototypeOf(MarketoIntegrationPage)).call.apply(_ref, [this].concat(args))), _this), _this.refreshProperties = function () {
      return _this.props.actions.fetchOrgProperties();
    }, _this.refreshGates = function () {
      return _this.props.actions.refreshCurrentUser();
    }, _this.onConnectClicked = function () {
      _this.context.router.push('/settings/setup/marketo-config');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarketoIntegrationPage, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'marketo-integration-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'marketo-overview-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'marketo-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Icon"], { className: 'anonymous-visitor-icon', width: 50, height: 22, name: 'rolodex' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              CONTACT_UPDATE_MESSAGE
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'marketo-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Icon"], { className: 'activity-icon', width: 50, name: 'activity' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              ACTIVITY_PUSH_MESSAGE
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'marketo-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Icon"], { className: 'user-target-icon', width: 50, name: 'user-target' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              IDENTIFY_CONTACT_MESSAGE
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'integration-page-description' },
            'Need some help? ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://gethelp.drift.com/hc/en-us/articles/360041782994-Marketo-Integration', target: '_blank' },
              'Learn more here!'
            )
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/marketo/config', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Synced Marketo Data'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Marketo and Drift.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_10_utils_Access__["c" /* default */].hasGates('MARKETO_MAPPING') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/marketo/mapping/attributes', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Mapped Marketo Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map which fields you want to sync between Drift and Marketo.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_10_utils_Access__["c" /* default */].hasGates('HAS_MARKETO_SYNC_LIST') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'integration-config-section' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'integration-section-title' },
              'Import Lists from Marketo'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Sync Marketo Lists into Drift to use as segments.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', href: '/contacts/imports', target: '_blank' },
            'Go to Imports'
          )
        ),
        !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'marketo-connect-button' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ConnectButton__["a" /* default */], { onClick: this.onConnectClicked })
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/marketo/event-log', className: 'integration-config-link' },
          'View Marketo Event Log'
        )
      );
    }
  }]);

  return MarketoIntegrationPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MarketoIntegrationPage.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    orgProperties: __WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__["properties"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["b" /* bindActionCreators */])({ fetchOrg: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["fetchOrg"], fetchOrgProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["fetchOrgProperties"], refreshCurrentUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_actions__["refreshCurrentUser"] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(MarketoIntegrationPage)));

/***/ }),

/***/ "4lSx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_eloqua_api__ = __webpack_require__("tYz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("k0xy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var integrationName = "Eloqua";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};
var getErrorMessage = function getErrorMessage(integrationName) {
  return 'There was an error when updating your ' + integrationName + ' App!';
};

var EloquaCdoSelect = function (_Component) {
  _inherits(EloquaCdoSelect, _Component);

  function EloquaCdoSelect(props) {
    var _this2 = this;

    _classCallCheck(this, EloquaCdoSelect);

    var _this = _possibleConstructorReturn(this, (EloquaCdoSelect.__proto__ || Object.getPrototypeOf(EloquaCdoSelect)).call(this, props));

    _this._updateSelectOptions = function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(query) {
        var selectedValue, eloquaCDOs, selectOptions, cdoIds;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectedValue = _this.state.selectedValue;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_app_modules_eloqua_api__["a" /* api */].fetchEloquaCDOs(query);

              case 4:
                eloquaCDOs = _context.sent;
                selectOptions = eloquaCDOs.map(function (cdo) {
                  return { label: cdo.name, value: cdo.id };
                });
                cdoIds = new Set(eloquaCDOs.map(function (cdo) {
                  return cdo.id;
                }));


                if (selectedValue != null && !cdoIds.has(selectedValue.id)) {
                  selectOptions.push({ label: selectedValue.name, value: selectedValue.id });
                }

                _this.setState({
                  selectOptions: selectOptions
                });
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.warn(_context.t0);

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.getSelectedCdo = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var toggleAttributeMapper, cdoConfig, cdoId, cdoName;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              toggleAttributeMapper = _this.props.toggleAttributeMapper;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_app_modules_eloqua_api__["a" /* api */].fetchEloquaCdoConfig();

            case 4:
              cdoConfig = _context2.sent;
              cdoId = cdoConfig.objectId;
              cdoName = cdoConfig.objectName;


              if (cdoId != undefined) {
                _this.setState({ selectedValue: { name: cdoName, id: cdoId } });
                toggleAttributeMapper(true);
              }
              _context2.next = 13;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](1);

              console.warn(_context2.t0);

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 10]]);
    }));
    _this.saveSelectedCdo = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var notifications, selectedValue, objectId, objectName;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              notifications = _this.props.notifications;
              selectedValue = _this.state.selectedValue;
              _context3.prev = 2;
              objectId = selectedValue ? selectedValue.id : null;
              objectName = selectedValue ? selectedValue.name : null;
              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_3_app_modules_eloqua_api__["a" /* api */].patchEloquaCdoConfig({ objectId: objectId, objectName: objectName });

            case 7:
              notifications.success(getSuccessMessage(integrationName));
              _context3.next = 14;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](2);

              console.warn(_context3.t0);
              notifications.error(getErrorMessage(integrationName));

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[2, 10]]);
    }));
    _this.onSelectStateChange = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this$props, refreshEloquaFields, toggleAttributeMapper;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props = _this.props, refreshEloquaFields = _this$props.refreshEloquaFields, toggleAttributeMapper = _this$props.toggleAttributeMapper;
              _context4.next = 3;
              return _this.saveSelectedCdo();

            case 3:
              _context4.next = 5;
              return refreshEloquaFields();

            case 5:
              toggleAttributeMapper(_this.state.selectedValue != null);

            case 6:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    _this.handleSelectChange = function (selectedOption) {
      var newValue = void 0;

      var selectionCleared = !selectedOption;
      if (selectionCleared) {
        newValue = null;
      } else {
        newValue = { id: selectedOption.value, name: selectedOption.label };
      }

      _this.setState({
        selectedValue: newValue
      }, _this.onSelectStateChange);
    };

    _this.state = {
      selectOptions: [],
      selectedValue: null
    };

    _this.updateSelectOptions = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(_this._updateSelectOptions, 1000);
    return _this;
  }

  _createClass(EloquaCdoSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getSelectedCdo();
      this.updateSelectOptions("");
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectOptions = _state.selectOptions,
          selectedValue = _state.selectedValue;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
        className: 'eloqua-cdo-select',
        options: selectOptions,
        value: selectedValue ? selectedValue.id : null,
        disabled: false,
        onChange: this.handleSelectChange,
        onInputChange: this.updateSelectOptions
      });
    }
  }]);

  return EloquaCdoSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(EloquaCdoSelect));

/***/ }),

/***/ "4pGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("pgka");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("hKIp");


// import { push } from 'react-router-redux'


// import * as models from './models'

// import * as selectors from './selectors'

var fetchTargets = function fetchTargets(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchTargets */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchTargets().mapResponse(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchTargetsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchTargetsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchTargetsFailed */]({ error: error }));
    });
  });
};

var updateTarget = function updateTarget(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* updateTarget */].toString()).pluck('payload').mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].patchTarget(payload.operations, payload.targetId).mapResponse(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* updateTargetSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* updateTargetPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* updateTargetFailed */]({ error: error }));
    });
  });
};

var createTarget = function createTarget(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* createTarget */].toString()).pluck('payload').mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].createTarget(payload).mapResponse(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createTargetSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* createTargetPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* createTargetFailed */]({ error: error }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchTargets, createTarget, updateTarget);

/***/ }),

/***/ "4rKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActivitySection__ = __webpack_require__("HGzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConversationSection__ = __webpack_require__("pzWC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesforceSection__ = __webpack_require__("uwH+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LinkedinSection__ = __webpack_require__("mxgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HubSpotSection__ = __webpack_require__("WTSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Profile__ = __webpack_require__("MmXj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CQLBar__ = __webpack_require__("pPBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScoringSection__ = __webpack_require__("Qoum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_customer_EndUserAttributesCard__ = __webpack_require__("OnKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_customer_SegmentsCard__ = __webpack_require__("Joq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("EtIs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_Integrations__ = __webpack_require__("CCiW");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Person = function (_Component) {
  _inherits(Person, _Component);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          conversationId = _props.conversationId,
          endUser = _props.endUser,
          hasMadKudu = _props.hasMadKudu,
          hasSalesforce = _props.hasSalesforce,
          hasLinkedin = _props.hasLinkedin,
          hasHubSpot = _props.hasHubSpot,
          ip = _props.ip;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_15__style_styl__["Sidebar"] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Profile__["a" /* default */], { endUser: endUser, conversationId: conversationId }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CQLBar__["a" /* default */], {
          score: endUser ? endUser.getIn(['attributes', '_cql_score']) : undefined,
          endUserId: endUser ? endUser.id : undefined,
          conversationId: conversationId,
          isPlaceholder: !endUser
        }),
        hasMadKudu && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ScoringSection__["a" /* default */], { endUser: endUser }),
        canDisplayLinkedinSectionContact(hasLinkedin, endUser) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LinkedinSection__["a" /* default */], { endUser: endUser }),
        canDisplaySalesforceSection(hasSalesforce, endUser) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SalesforceSection__["a" /* default */], { email: endUser.email, ip: ip }),
        canDisplayHubSpotSection(hasHubSpot, endUser) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HubSpotSection__["a" /* default */], { email: endUser.email }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ConversationSection__["a" /* default */], { conversationId: conversationId }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ActivitySection__["a" /* default */], {
          key: endUser ? 'activity-section-' + endUser.id : undefined,
          endUserId: endUser ? endUser.id : undefined
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_customer_EndUserAttributesCard__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_15__style_styl__["AboutCard"], hideAllAttributesModal: true, endUser: endUser }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_customer_SegmentsCard__["a" /* default */], {
          className: __WEBPACK_IMPORTED_MODULE_15__style_styl__["AboutCard"],
          endUserId: endUser ? endUser.id : undefined,
          segmentClassName: __WEBPACK_IMPORTED_MODULE_15__style_styl__["SegmentRow"]
        })
      );
    }
  }]);

  return Person;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var canDisplayLinkedinSectionContact = function canDisplayLinkedinSectionContact(hasLinkedin, endUser) {
  return hasLinkedin && !!endUser;
};

var canDisplaySalesforceSection = function canDisplaySalesforceSection(hasSalesforce, endUser) {
  return hasSalesforce && endUser;
};

var canDisplayHubSpotSection = function canDisplayHubSpotSection(hasHubSpot, endUser) {
  return hasHubSpot && endUser && endUser.email;
};

var makeMapStateToProps = function makeMapStateToProps() {
  var endUserForConversationId = __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_selectors__["f" /* makeEndUserForConversationIdSelector */]();
  var fetchEndUserForConversationIdFailed = __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_selectors__["h" /* makeFetchEndUserForConversationIdFailedSelector */]();

  return function (state, props) {
    var conversationId = props.conversationId;


    return {
      endUser: endUserForConversationId(state, { conversationId: conversationId }),
      endUserNotFound: fetchEndUserForConversationIdFailed(state, { conversationId: conversationId }),
      hasMadKudu: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_gates_selectors__["u" /* makeHasGate */])('has_madkudu')(state),
      hasSalesforce: Object(__WEBPACK_IMPORTED_MODULE_16_utils_Integrations__["b" /* isIntegrationConnected */])('salesforce'),
      hasHubSpot: Object(__WEBPACK_IMPORTED_MODULE_16_utils_Integrations__["b" /* isIntegrationConnected */])('hubspot'),
      hasLinkedin: Object(__WEBPACK_IMPORTED_MODULE_16_utils_Integrations__["b" /* isIntegrationConnected */])('linkedin')
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return props.endUserNotFound;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]))(Person));

/***/ }),

/***/ "4tyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CompanyDisplayNameMap = Object.freeze({
  'location': 'Location',
  'employeeCount': 'Employees',
  'industry': 'Category',
  'subIndustry': 'Sub-Category',
  'moneyRaised': 'Raised',
  'marketCap': 'Revenue Range',
  'tags': 'Tags',
  'description': 'About'
});

/* harmony default export */ __webpack_exports__["a"] = (CompanyDisplayNameMap);

/***/ }),

/***/ "4ulW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_CheckBox__ = __webpack_require__("cbHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_colors__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var AttributeList = function AttributeList(_ref) {
  var title = _ref.title,
      rows = _ref.rows,
      editing = _ref.editing;

  var attributes = rows.map(function (_ref2) {
    var value = _ref2.value,
        rest = _objectWithoutProperties(_ref2, ['value']);

    return _extends({
      value: typeof value === 'boolean' ? '' + value : value
    }, rest);
  }).map(function (props, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Attribute, _extends({
      key: i
    }, props, {
      offWhiteBackground: i % 2 !== 0,
      editing: editing
    }));
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { style: { padding: '15px 0' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'dsg-Title' },
      title
    ),
    attributes
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AttributeList);

var Attribute = function (_Component) {
  _inherits(Attribute, _Component);

  function Attribute(props) {
    _classCallCheck(this, Attribute);

    var _this = _possibleConstructorReturn(this, (Attribute.__proto__ || Object.getPrototypeOf(Attribute)).call(this, props));

    _this.state = {
      isInput: null
    };
    return _this;
  }

  _createClass(Attribute, [{
    key: 'getInputValue',
    value: function getInputValue() {
      var _props = this.props,
          value = _props.value,
          handleChange = _props.handleChange;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        className: 'flex-1',
        isValid: value ? value.length > 0 : true,
        valueLink: { value: value, requestChange: handleChange },
        size: 'small'
      });
    }
  }, {
    key: 'getReadOnlyValue',
    value: function getReadOnlyValue() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1 dsg-body color-navy-dark' },
        this.props.value
      );
    }
  }, {
    key: 'getLinkValue',
    value: function getLinkValue() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { className: 'flex-1', href: this.props.href, target: '_blank' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body truncate' },
          this.props.value
        )
      );
    }
  }, {
    key: 'getNormalValue',
    value: function getNormalValue() {
      var value = this.props.value;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-1 dsg-Body' },
        typeof value === 'boolean' ? JSON.stringify(value) : value
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          label = _props2.label,
          offWhiteBackground = _props2.offWhiteBackground,
          href = _props2.href,
          editing = _props2.editing,
          handleChange = _props2.handleChange,
          handleCheckBoxChange = _props2.handleCheckBoxChange,
          checked = _props2.checked;

      var displayValue = editing ? handleChange ? this.getInputValue() : this.getReadOnlyValue() : href ? this.getLinkValue() : this.getNormalValue();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'flex-start',
          style: {
            padding: (editing && handleChange ? 0 : 12) + 'px 10px',
            alignItems: 'center',
            backgroundColor: offWhiteBackground ? __WEBPACK_IMPORTED_MODULE_3_styles_colors___default.a['color-navy-off-white'] : undefined
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'dsg-Small color-navy-dark dsg-medium-weight',
            style: { width: 150, paddingRight: 10, wordWrap: 'break-word' }
          },
          label
        ),
        displayValue,
        editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingLeft: 5 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_CheckBox___default.a, {
            id: label,
            checked: checked,
            onChange: handleCheckBoxChange
          })
        )
      );
    }
  }]);

  return Attribute;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "4yb5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(506);

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5/UP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "50R4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGQ9Ik00NyAuMDg1MzIwM2MtMjUuOTM0MTk1NSAwLTQ2Ljk1NjcwNzMgMjEuMDIzMDUyLTQ2Ljk1NjcwNzMgNDYuOTU3OTE0MUMuMDQzMjkyNyA3Mi45NzY5NDggMjEuMDY1ODA0NSA5NCA0NyA5NGMyNS45MzMwNDcxIDAgNDYuOTU2NzA3My0yMS4wMjMwNTIgNDYuOTU2NzA3My00Ni45NTY3NjU2QzkzLjk1NjcwNzMgMjEuMTA4MzcyMyA3Mi45MzMwNDcxLjA4NTMyMDMgNDcgLjA4NTMyMDN6bS0xLjQ2NzY0ODMgNTguNzQ3NjM2MWMwIC43MTQzMTk4LS4zNzc4MjE4IDEuMzc0NjYzNy0uOTkxMDY0NiAxLjczMTgyMzYtLjYwODY0OTEuMzUzNzE0Ni0xLjM1Mzk1NzIuMzU0ODYzMS0xLjk2Mzc1NDguMDA4MDM5LS4wMDU3NDE5LS4wMDM0NDUzLS4wMTI2MzIzLS4wMDU3NDIxLS4wMTgzNzQzLS4wMDkxODc0bC04LjMzMjc1MTMtNC44NTY2ODU2djE4LjAzNzE0OTNjMCAuNzE0MzE5OC0uMzc2NjczNCAxLjM3NTgxMjEtLjk4OTkxNjEgMS43MzI5NzItLjMwNzc2OTguMTc2ODU3My0uNjQ4ODQzLjI2NzU4MjgtLjk5MTA2NDYuMjY3NTgyOC0uMzQxMDczMiAwLS42ODMyOTQ4LS4wOTA3MjU1LS45OTEwNjQ1LS4yNjc1ODI4bC00Ljk4MDU4NzUtMi45MDMyMTYyYy0uNjEzMjQyNy0uMzU3MTU5OS0uOTkxMDY0NS0xLjAxNzUwMzgtLjk5MTA2NDUtMS43MzA2NzUyVjUwLjQ5MzEwMDRsLTguMDUwMjQ2My00LjY5MTMxMjVjLS42MTMyNDI3LS4zNTcxNTk5LS45OTEwNjQ1LTEuMDE3NTAzOC0uOTkxMDY0NS0xLjczMTgyMzZ2LTcuNzc1OTc5N2MwLS43MTQzMTk4LjM3NzgyMTgtMS4zNzQ2NjM3Ljk5MTA2NDUtMS43MzA2NzUyLjYxMzI0MjgtLjM1ODMwODMgMS4zNjg4ODY0LS4zNTgzMDgzIDEuOTgyMTI5MSAwbDI1LjMyNjY5NDggMTQuNzU0OTUzMmMuNjEzMjQyOC4zNTgzMDgzLjk5MTA2NDYgMS4wMTk4MDA2Ljk5MTA2NDYgMS43MzQxMjA0djcuNzgwNTczNHptLjQyODM1MTItMzEuMTYyNDg4NmMwIC45OTEwOS0uNTI1OTY0OCAxLjkwNjM4NC0xLjM4MTUxODcgMi40MDU5NDg1bC03LjY1OTc5MjEgNC40NjM5MjQ2djUuODc4NzgzMWMwIC41OTgzMjktLjY0MDgwNDIuOTc1MDEyMS0xLjE1NzU4MTguNjc1MjczNC0zLjA4NTczNjMtMS43OTYxMzUzLTExLjQ4NTA5NDUtNi42ODI2OC0xNC41NTcwNTAxLTguNDYzODg1OC0uNTE0NDgwOC0uMjk4NTkwMy0uNTA1MjkzNi0xLjAzNDczMDEuMDA5MTg3Mi0xLjMzNDQ2ODhMNDIuOTg3NTA5MiAxOC42MDgyNTNjLjYxMzI0MjctLjM1NjAxMTUgMS4zNjc3MzgtLjM1NjAxMTUgMS45ODIxMjkxIDAgLjYxMzI0MjcuMzU4MzA4NC45OTEwNjQ2IDEuMDE4NjUyMi45OTEwNjQ2IDEuNzMyOTcydjcuMzI5MjQyOHptMi41MDU3OTctNy4zMjkyNDI4YzAtLjcxNDMxOTguMzc3ODIxOC0xLjM3NDY2MzYuOTkyMjEzLTEuNzMyOTcyLjYxMjA5NDMtLjM1NjAxMTUgMS4zNjc3Mzc5LS4zNTYwMTE1IDEuOTgwOTgwNyAwbDIxLjc2MjA3NzkgMTIuNjgwODk5MmMuNTE5MDc0My4zMDMxODQuNTI4MjYxNSAxLjA0NzM2MjguMDA4MDM4NyAxLjM0ODI0OTktMy4wNzU0MDA3IDEuNzgzNTAyNy0xMS40MjA3ODQ0IDYuNjM5MDM5OS0xNC41MjE0NDk4IDguNDQzMjE0Mi0uNTI1OTY0OC4zMDU0ODA4LTEuMTgwNTQ5Ny0uMDc2OTQ0NC0xLjE4MDU0OTctLjY4Njc1NzZ2LTUuNzc1NDI0OWMwLS4wNDgyMzM5LS4wMjUyNjQ3LS4wOTQxNzA4LS4wNjc3NTUzLS4xMTgyODc3bC03Ljk4MTM0MjUtNC42NTIyNjYyYy0uNjE0MzkxMi0uMzU3MTU5OS0uOTkyMjEzLTEuMDE3NTAzNy0uOTkyMjEzLTEuNzMxODIzNVYyMC4zNDEyMjV6bTI5LjI5MDk1MyAyMy43Mjg3MzkzYzAgLjcxNDMxOTgtLjM3NzgyMTggMS4zNzQ2NjM3LS45OTEwNjQ1IDEuNzMxODIzNmwtOC4wNTAyNDYzIDQuNjkxMzEyNXYyMC4zNTAwNzU1YzAgLjcxMzE3MTQtLjM3NzgyMTggMS4zNzM1MTUzLS45OTEwNjQ1IDEuNzMwNjc1MmwtNC45ODA1ODc1IDIuOTAzMjE2MmMtLjMwNzc2OTcuMTc2ODU3My0uNjQ4ODQyOS4yNjc1ODI4LS45OTEwNjQ1LjI2NzU4MjhzLS42ODMyOTQ4LS4wOTA3MjU1LS45ODk5MTYyLS4yNjc1ODI4Yy0uNjE0MzkxMS0uMzU3MTU5OS0uOTkxMDY0NS0xLjAxODY1MjItLjk5MTA2NDUtMS43MzI5NzJWNTUuNzA2OTQ2bC04LjMzMjc1MTMgNC44NTY2ODU2Yy0uMDA1NzQyLjAwMzQ0NTMtLjAxMjYzMjQuMDA1NzQyMS0uMDE3MjI1OS4wMDkxODc0LS42MTA5NDYuMzQ2ODI0MS0xLjM1NjI1NDEuMzQ1Njc1Ni0xLjk2Mzc1NDgtLjAwODAzOS0uNjE0MzkxMi0uMzU3MTU5OS0uOTkyMjEzLTEuMDE3NTAzOC0uOTkyMjEzLTEuNzMxODIzNlY1MS4wNTIzODNjMC0uNzE0MzE5OC4zNzc4MjE4LTEuMzc1ODEyMS45OTIyMTMtMS43MzQxMjA0bDI1LjMyNTU0NjQtMTQuNzU0OTUzMmMuNjEzMjQyNy0uMzU4MzA4MyAxLjM2ODg4NjMtLjM1ODMwODMgMS45ODIxMjkxIDAgLjYxMzI0MjcuMzU2MDExNS45OTEwNjQ1IDEuMDE2MzU1NC45OTEwNjQ1IDEuNzMwNjc1MnY3Ljc3NTk3OTd6IiBmaWxsPSIjMzMzIi8+CiAgICA8ZWxsaXBzZSBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0iIzAwNzVGRiIgY3g9Ijc5IiBjeT0iNzkiIHJ4PSIxOSIgcnk9IjE5Ii8+CiAgICA8cGF0aCBkPSJNOTAuNzA3IDc5LjY0MWwtNS4wMDEgNC45NzhjLS4xOTUuMTk0LS40NTEuMjkxLS43MDcuMjkxLS4yNTYgMC0uNTEyLS4wOTctLjcwNy0uMjkxLS4zOTEtLjM4OS0uMzkxLTEuMDE5IDAtMS40MDdsNC4yOTQtNC4yNzUtNC4yOTQtNC4yNjljLS4zOTEtLjM4OC0uMzkxLTEuMDE5IDAtMS40MDguMzkxLS4zODggMS4wMjMtLjM4OCAxLjQxNCAwbDUuMDAxIDQuOTc0Yy4xODguMTg3LjI5My40MzkuMjkzLjcwMyAwIC4yNjQtLjEwNS41MTgtLjI5My43MDR6bS0xMy43NDkgOS41MzRjLS4xMy40MzEtLjUyNy43MDgtLjk1OC43MDgtLjA5NSAwLS4xOTEtLjAxMy0uMjg3LS4wNDEtLjUyOS0uMTU4LS44MjktLjcxNC0uNjcxLTEuMjM5bDYtMTkuOTAyYy4xNTgtLjUyNi43MTMtLjgyNyAxLjI0NS0uNjY3LjUyOS4xNTguODI5LjcxMi42NzEgMS4yMzhsLTYgMTkuOTAzem0tMy4yNS00LjU1OGMtLjE5NS4xOTQtLjQ1MS4yOTEtLjcwNy4yOTEtLjI1NiAwLS41MTItLjA5Ny0uNzA3LS4yOTFsLTUuMDAxLTQuOTc0Yy0uMTg3LS4xODYtLjI5My0uNDM5LS4yOTMtLjcwMyAwLS4yNjMuMTA2LS41MTcuMjkzLS43MDRsNS4wMDEtNC45NzdjLjM5MS0uMzg5IDEuMDIzLS4zODkgMS40MTQgMCAuMzkxLjM4OC4zOTEgMS4wMTggMCAxLjQwN2wtNC4yOTQgNC4yNzQgNC4yOTQgNC4yNjljLjM5MS4zODguMzkxIDEuMDE5IDAgMS40MDh6IiBzdHJva2U9IiNGRkYiIGZpbGw9IiNGRkYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "52d9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52zG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("YWXU");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("wFBz");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("uTQz");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });







/***/ }),

/***/ "55QV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MCIgaGVpZ2h0PSIzNSIgdmlld0JveD0iMCAwIDYzLjMzIDMwLjI2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzIzMjMyMzt9LmNscy0ye2ZpbGw6IzQ0NzdiZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmRyaXAtbG9nby1mdWxsPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zLjE5LDdoOUMxOC4xNiw3LDIyLjU5LDEwLjUsMjIuNTksMTdzLTQuNDQsMTAtMTAuMzgsMTBoLTlabTUsNC4zMlYyMi43NUgxMmMzLjI1LDAsNS40Ny0yLDUuNDctNS43MVMxNS4yNiwxMS4yNywxMiwxMS4yN1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjE5IC0yLjM3KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTI2LjUsMTYuOTJjMC0uOC0uMTUtMS40Mi0uOTUtMS40MmEzLjg1LDMuODUsMCwwLDAtMS41MS4zOEwyMy45LDEyYTkuMzMsOS4zMywwLDAsMSwzLjY3LS42NWMxLjgzLDAsMy4wOC42OCwzLjYxLDIuMjhhMy44NywzLjg3LDAsMCwxLDMuNzYtMi4yOCw0LjU2LDQuNTYsMCwwLDEsMi43NS43NGwtLjYyLDQuNTNhNS42Nyw1LjY3LDAsMCwwLTMtLjY4Yy0xLjgzLDAtMi40OCwxLjQ4LTIuNjMsMy4wOHY4LjA4aC01WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMTkgLTIuMzcpIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNTAsMzIuNjNWMTYuOTJjMC0uODMtLjE1LTEuNDItLjk1LTEuNDJhMywzLDAsMCwwLTEuNTEuNDFsLS4xNS00YTEwLjUsMTAuNSwwLDAsMSwzLjY3LS42NWMxLjc1LDAsMywuNTksMy41NSwyLjFhNS43NCw1Ljc0LDAsMCwxLDQuNzMtMi4wN2M0LjIzLDAsNy4xNiwzLjM0LDcuMTYsOHMtMi45Myw4LTcuMTYsOEE2LjMxLDYuMzEsMCwwLDEsNTUsMjUuNzd2Ni44NlptNS0xNS44NnY1LjE4YTQuNjUsNC42NSwwLDAsMCwzLDEuMDksMy4zNiwzLjM2LDAsMCwwLDMuNTItMy42NywzLjM4LDMuMzgsMCwwLDAtMy41Mi0zLjczQTQuNDYsNC40NiwwLDAsMCw1NSwxNi43N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjE5IC0yLjM3KSIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTQ2LjU4LDIyLjc4YTMuMTMsMy4xMywwLDAsMS0xLjQ1LjQxYy0uOCwwLS45NS0uNjUtLjk1LTEuNDJWMTEuNmgtNVYyM2MwLDMuMTQsMS40Miw0LjM4LDMuODgsNC4zOGExMCwxMCwwLDAsMCwzLjctLjY1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuMTkgLTIuMzcpIi8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNNDMuNTUsNC44OWExNC45MiwxNC45MiwwLDAsMS0xLjg0LTIuNTIsMTUsMTUsMCwwLDEtMS44NCwyLjUyQTQsNCwwLDAsMCwzOSw3LjA5YzAsMS42NCwxLjA4LDIuMjIsMi42OSwyLjIyczIuNjktLjU4LDIuNjktMi4yMkE0LDQsMCwwLDAsNDMuNTUsNC44OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjE5IC0yLjM3KSIvPjwvc3ZnPg=="

/***/ }),

/***/ "57/x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5BTZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Geolocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Geolocation = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  gdprApplicable: undefined
});

/***/ }),

/***/ "5CRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("Ldfl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("nu3i");





function fetchAttributes(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchAttributes */].toString()).exhaustMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetch(Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(getState())).map(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* receiveAttributes */]).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchAttributesCancelled */].toString())).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchAttributesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchAttributesFailed */]({ error: error }));
    });
  });
}

var epic = fetchAttributes;

/***/ }),

/***/ "5JuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_OAUTH_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_OAUTH_CODE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_OAUTH_CODE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_OAUTH_CODE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_OAUTH_APP_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_OAUTH_APP_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_OAUTH_APP_INFO_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_OAUTH_APP_INFO_PENDING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('externalApp');

var FETCH_OAUTH_CODE = makeConstant('FETCH_OAUTH_CODE');
var FETCH_OAUTH_CODE_SUCCESS = makeConstant('FETCH_OAUTH_CODE_SUCCESS');
var FETCH_OAUTH_CODE_FAILED = makeConstant('FETCH_OAUTH_CODE_FAILED');
var FETCH_OAUTH_CODE_PENDING = makeConstant('FETCH_OAUTH_CODE_PENDING');

var FETCH_OAUTH_APP_INFO = makeConstant('FETCH_OAUTH_APP_INFO');
var FETCH_OAUTH_APP_INFO_SUCCESS = makeConstant('FETCH_OAUTH_APP_INFO_SUCCESS');
var FETCH_OAUTH_APP_INFO_FAILED = makeConstant('FETCH_OAUTH_APP_INFO_FAILED');
var FETCH_OAUTH_APP_INFO_PENDING = makeConstant('FETCH_OAUTH_APP_INFO_PENDING');

/***/ }),

/***/ "5Knv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("6g2e");









var mapStateToProps = function mapStateToProps(state) {
  var id = __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["L" /* getCurrentConditionId */](state);
  return {
    id: id,
    condition: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["F" /* getCondition */](state, { id: id }),
    playbooks: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["x" /* emailPlaybooks */](state),
    getPlaybookIdForCampaignId: function getPlaybookIdForCampaignId(campaignId) {
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_60" /* playbookIdForCampaignId */](state, campaignId);
    },
    getIsPlaybookIdForCampaignIdLoading: function getIsPlaybookIdForCampaignIdLoading(campaignId) {
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_62" /* playbookIdForCampaignIdLoading */](state, campaignId);
    },
    getIsPlaybookIdForCampaignIdFailed: function getIsPlaybookIdForCampaignIdFailed(campaignId) {
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_61" /* playbookIdForCampaignIdFailed */](state, campaignId);
    },
    getPlaybookIsPending: function getPlaybookIsPending(playbookId) {
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_12" /* getPlaybookIsPending */](state, playbookId);
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setValue: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_166" /* setEmailPlaybookConditionValue */],
      getPlaybook: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_67" /* getPlaybook */],
      getPlaybookByCampaignId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_68" /* getPlaybookByCampaignId */],
      searchPlaybooks: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_119" /* searchPlaybooks */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  var playbookOptions = props.playbooks.map(function (playbook) {
    return { value: playbook.id, label: playbook.name };
  }).toJS();
  try {
    var campaignId = parseInt(props.condition.value.first().split('=')[1]);
    var selectedPlaybookId = props.getPlaybookIdForCampaignId(campaignId);
    if (!selectedPlaybookId && campaignId) {
      props.actions.getPlaybookByCampaignId({ campaignId: campaignId });
    }

    return {
      campaignId: campaignId,
      playbookOptions: playbookOptions,
      selectedPlaybookId: selectedPlaybookId
    };
  } catch (err) {
    // couldn't get the playbookId
    return {
      playbookOptions: playbookOptions
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedPlaybookId', 'setSelectedPlaybookId', function (props) {
  return props.selectedPlaybookId;
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    isLoading: props.getPlaybookIsPending(props.selectedPlaybookId) || props.getIsPlaybookIdForCampaignIdLoading(props.campaignId)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var searchPlaybooks = this.props.actions.searchPlaybooks;

    searchPlaybooks();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onValueChange: function onValueChange(_ref) {
    var id = _ref.id,
        setSelectedPlaybookId = _ref.setSelectedPlaybookId,
        _ref$actions = _ref.actions,
        setValue = _ref$actions.setValue,
        getPlaybook = _ref$actions.getPlaybook;
    return function (value) {
      if (value) {
        getPlaybook({ playbookId: value.value, nextAction: function nextAction(playbook) {
            return setValue({ playbook: playbook, conditionId: id });
          } });
        setSelectedPlaybookId(value.value);
      } else {
        setSelectedPlaybookId(null);
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "5KxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime__ = __webpack_require__("8ijy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("VNK0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__picker_styl__ = __webpack_require__("G2Mo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__picker_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__picker_styl__);






var ScheduleModal = function ScheduleModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      selectedDateTime = _ref.selectedDateTime,
      handleSaveDateTime = _ref.handleSaveDateTime,
      selectedDateTimeFormatted = _ref.selectedDateTimeFormatted,
      handleSetDateTime = _ref.handleSetDateTime;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__PlaybookModal__["a" /* default */],
    {
      onCloseClick: onCloseClick,
      closeLabel: React.createElement(
        'div',
        null,
        'X'
      ),
      hideTitle: true,
      description: 'Schedule Playbook',
      className: 'playbook-schedule-modal',
      contentClassName: 'playbook-schedule-modal-content drift-form',
      headerClassName: 'playbook-schedule-modal-header'
    },
    React.createElement(
      'div',
      { className: 'playbook-schedule-modal-calendar-panes' },
      React.createElement(
        'div',
        { className: 'playbook-schedule-modal-calendar-pane playbook-schedule-modal-calendar-date' },
        React.createElement(
          'div',
          { className: 'schedule-modal-label' },
          'Pick a Date'
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime__, {
          onChange: handleSetDateTime,
          value: selectedDateTime,
          input: false,
          timeFormat: false,
          isValidDate: function isValidDate(current) {
            return current.isAfter(__WEBPACK_IMPORTED_MODULE_1_react_datetime__["moment"]().subtract(1, 'day'));
          },
          className: 'playbook-schedule-modal-calendar-picker'
        })
      ),
      React.createElement(
        'div',
        { className: 'playbook-schedule-modal-calendar-pane playbook-schedule-modal-calendar-time' },
        React.createElement(
          'div',
          { className: 'schedule-modal-label' },
          'Pick a Time'
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_datetime__, {
          onChange: handleSetDateTime,
          value: selectedDateTime,
          input: false,
          dateFormat: false,
          isValidDate: function isValidDate(current) {
            return current.isAfter(__WEBPACK_IMPORTED_MODULE_1_react_datetime__["moment"]().subtract(1, 'day'));
          },
          className: 'playbook-schedule-modal-time-picker'
        }),
        React.createElement('hr', null),
        React.createElement(
          'div',
          { className: 'playbook-schedule-modal-summary' },
          React.createElement(
            'div',
            { className: 'playbook-schedule-modal-summary-heading' },
            'Schedule this playbook for'
          ),
          ' ',
          selectedDateTimeFormatted
        )
      )
    ),
    React.createElement(
      'button',
      {
        onClick: handleSaveDateTime,
        className: 'drift-button drift-button-primary playbook-schedule-modal-button'
      },
      'Schedule'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduleModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "5LTE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(199);

/***/ }),

/***/ "5MaG":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.814 12.25h-1.362v3.063a1.02 1.02 0 0 1-1.744.72L15.92 12.25H11.92c-.94 0-1.703-.785-1.703-1.75V1.75c0-.965.764-1.75 1.703-1.75h10.896c.938 0 1.702.785 1.702 1.75v8.75c0 .965-.764 1.75-1.702 1.75zm-.34-10.208H12.257v8.166h4.086a1.032 1.032 0 0 1 .723.3l2.342 2.34v-1.62c0-.562.456-1.02 1.02-1.02h2.043V2.042zM8.17 10.208h-6.13v8.167h2.044c.564 0 1.022.457 1.022 1.02v1.62l2.34-2.34a1.022 1.022 0 0 1 .724-.3h4.086V14.29a1.02 1.02 0 0 1 2.043 0v4.377c0 .965-.763 1.75-1.702 1.75H8.595L4.808 24.2a1.022 1.022 0 0 1-1.743-.72v-3.063H1.702c-.938 0-1.702-.785-1.702-1.75v-8.75c0-.965.764-1.75 1.702-1.75h6.47a1.022 1.022 0 0 1 0 2.04z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "5TTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasConversationAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ensureIsAdmin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Access__ = __webpack_require__("6k1g");



var hasConversationAccess = function hasConversationAccess() {
  var participants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var currentUser = arguments[1];


  return __WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].isAdmin() || __WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].hasAnyScope('convo-ALL') || !__WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].hasAnyScope('convo-ONLY_MINE', 'convo-WITH_NO_PARTICIPANTS', 'convo-ALL') || participants.includes(currentUser.id) || participants.isEmpty() && __WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].hasAnyScope('convo-WITH_NO_PARTICIPANTS');
};

var ensureIsAdmin = function ensureIsAdmin(Component) {
  return function (props) {
    if (__WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].isAdmin() || __WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].isVideoAdmin()) {
      return React.createElement(Component, props);
    } else {
      window.location.replace('/');
      return null;
    }
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "5WN7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(229);

/***/ }),

/***/ "5XQI":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Targeting-Iteration\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"aud-segments\" transform=\"translate(-527.000000, -547.000000)\" fill=\"#3A4F59\"><g id=\"Group-5\" transform=\"translate(505.000000, 284.000000)\"><g transform=\"translate(0.000000, 22.000000)\" id=\"List\"><g transform=\"translate(0.000000, 164.000000)\"><g id=\"Group\" transform=\"translate(22.000000, 74.391156)\"><g id=\"check-square\" transform=\"translate(0.500000, 2.608844)\"><path d=\"M18.2083333,19 L0.791666667,19 C0.354666667,19 0,18.6453333 0,18.2083333 L0,0.791666667 C0,0.354666667 0.354666667,0 0.791666667,0 L18.2083333,0 C18.6453333,0 19,0.354666667 19,0.791666667 L19,18.2083333 C19,18.6453333 18.6453333,19 18.2083333,19 Z M17.4166667,1.58333333 L1.58333333,1.58333333 L1.58333333,17.4166667 L17.4166667,17.4166667 L17.4166667,1.58333333 Z M5.244,8.88170833 L8.61095833,11.5749583 L13.6546667,5.81241667 C13.9420417,5.48308333 14.442375,5.44983333 14.7717083,5.73720833 C15.10025,6.025375 15.1335,6.52570833 14.8453333,6.85504167 L9.30366667,13.1875833 C9.14770833,13.3665 8.92841667,13.4583333 8.70833333,13.4583333 C8.53416667,13.4583333 8.36,13.4013333 8.21433333,13.2849583 L4.25520833,10.1182917 C3.914,9.84516667 3.85858333,9.34641667 4.13170833,9.00520833 C4.40404167,8.664 4.90358333,8.60858333 5.244,8.88170833 Z\" id=\"Shape\"></path></g></g></g></g></g></g></g></svg>"

/***/ }),

/***/ "5YaI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMCA0MEM4Ljk3MyA0MCAwIDMxLjAzIDAgMjAgMCA4Ljk3MyA4Ljk3MyAwIDIwIDBzMjAgOC45NzMgMjAgMjBjMCAxMS4wMy04Ljk3MyAyMC0yMCAyMHptMC0zNy41QzEwLjM1IDIuNSAyLjUgMTAuMzUgMi41IDIwUzEwLjM1IDM3LjUgMjAgMzcuNSAzNy41IDI5LjY1IDM3LjUgMjAgMjkuNjUgMi41IDIwIDIuNXptLTEuNTA1IDI0LjYzYy0uMjQyLjI0NS0uNTY1LjM3LS44ODcuMzctLjI4OCAwLS41NzctLjA5OC0uODEtLjI5N0w5LjE5IDIwLjczNWMtLjUyNS0uNDQ2LS41OS0xLjIzNi0uMTQzLTEuNzYuNDQ4LS41MyAxLjIzNi0uNTkzIDEuNzYzLS4xNDVsNi43MjUgNS43MThMMjkuMTEzIDEyLjg3Yy40ODUtLjQ5IDEuMjc3LS40OTUgMS43NjctLjAwNy40OS40ODYuNDk0IDEuMjc3LjAwOCAxLjc2N2wtMTIuMzkzIDEyLjV6IiBmaWxsPSIjMTNDQjZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "5a3S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_SFDC_containers_MetricsMapping__ = __webpack_require__("dQ2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");




var SalesforceMetricsMapping = function SalesforceMetricsMapping() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "common-integration-page-layout" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
      backLinkText: "Salesforce Integration",
      backLinkUrl: "/settings/setup/salesforce"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "header",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { className: "integration-header" },
        "Send Chat Metrics to Salesforce"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Map conversation metrics to Salesforce task fields"
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_SFDC_containers_MetricsMapping__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SalesforceMetricsMapping);

/***/ }),

/***/ "5acZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AdvancedChatWidgetSettings":"AdvancedChatWidgetSettings---oC4xt"};

/***/ }),

/***/ "5bKX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseEnrichedConversations; });
/* harmony export (immutable) */ __webpack_exports__["a"] = parseConversation;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseRoutingAuditLogEntry;
/* unused harmony export Conversation */
/* unused harmony export Inbox */
/* unused harmony export RoutingAuditLogEntry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_endUser_models__ = __webpack_require__("/Abo");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




// Normalize the enriched conversations by separating out the nested, hydrated
// models into top-level collections for each model
var parseEnrichedConversations = function parseEnrichedConversations(conversations) {
  return conversations.reduce(function (reduction, conversation) {
    var endUser = conversation.endUser;
    var enrichmentData = endUser.enrichmentData;


    return reduction.update('conversations', function (conversations) {
      return conversations.push(parseConversation(conversation));
    }).update('endUsers', function (endUsers) {
      return endUsers.push(Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_endUser_models__["b" /* parseEndUser */])(endUser));
    }).update('enrichedCompanyDataByEndUserId', function (enrichedCompanyDataByEndUserId) {
      return enrichedCompanyDataByEndUserId.set(endUser.id, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(enrichmentData));
    });
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    conversations: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
    endUsers: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
    enrichedCompanyDataByEndUserId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
  }));
};

function parseConversation(data) {
  var tags = data.tags,
      cc = data.cc,
      bcc = data.bcc,
      collaborators = data.collaborators,
      context = data.context,
      user = data.user,
      participantIds = data.participantIds,
      rest = _objectWithoutProperties(data, ['tags', 'cc', 'bcc', 'collaborators', 'context', 'user', 'participantIds']);

  var endUserType = data.endUserType || user && user.type;

  return Conversation(_extends({
    tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(tags),
    cc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(cc),
    bcc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(bcc),
    collaborators: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(collaborators),
    participantIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(participantIds),
    context: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(context),
    user: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(user),
    endUserType: endUserType
  }, rest));
}

function parseRoutingAuditLogEntry(_ref) {
  var usersAdded = _ref.usersAdded,
      routingAvailabilityDynamoEntries = _ref.routingAvailabilityDynamoEntries,
      rest = _objectWithoutProperties(_ref, ['usersAdded', 'routingAvailabilityDynamoEntries']);

  return RoutingAuditLogEntry(_extends({
    usersAdded: usersAdded,
    userAvailabilityList: routingAvailabilityDynamoEntries
  }, rest));
}

var Conversation = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  displayId: undefined,
  type: undefined,
  status: undefined,
  orgId: undefined,
  inboxId: undefined,
  endUserId: undefined,
  endUserType: undefined,
  customerId: undefined,
  campaignId: undefined,
  subject: null,
  uuid: undefined,
  slackChannel: "",
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  cc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  bcc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  source: null,
  collaborators: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  preview: undefined,
  agentOnlyPreview: undefined,
  lastMessageAuthorId: undefined,
  lastMessageAuthorType: undefined,
  lastMessageContentType: undefined,
  lastMessageType: undefined,
  lastSentMessageTimestamp: undefined,
  lastReadMessageTimestamp: undefined,
  participantIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  imported: false,
  createdAt: 0,
  updatedAt: 0,
  closedAt: 0,
  layerUrl: undefined,
  defaultMessageDeliveryChannel: undefined,
  context: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  slackAnnTimestamp: undefined,
  slackAnnChannelId: undefined,
  unreadMessageCount: undefined,
  user: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

var Inbox = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  name: undefined,
  address: undefined,
  forwardAddress: undefined,
  status: undefined,
  createdAt: 0,
  totalConversationCount: 0,
  openConversationCount: 0
});

var RoutingAuditLogEntry = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  orgId: undefined,
  conversationId: undefined,
  routingGroupId: undefined,
  executedAt: undefined,
  routingEntryType: undefined,
  ruleId: undefined,
  matchedTargetingConditions: undefined,
  usersAdded: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  rangeKey: undefined,
  routingRule: undefined,
  errorType: undefined,
  userAvailabilityList: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
});

/***/ }),

/***/ "5d52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__ = __webpack_require__("c4Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component__ = __webpack_require__("5KxE");















var mapStateToProps = function mapStateToProps(state) {
  return {
    draftScheduledTimestamp: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["s" /* dueAt */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideScheduleModal: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_87" /* hideScheduleModal */],
      setDraftSchedule: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_150" /* setDraftSchedule */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_8_recompose_withState___default()('selectedDateTime', 'setDateTime', function (props) {
  return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(props.draftScheduledTimestamp).tz(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess());
}), __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default()(function (props) {
  return {
    selectedDateTimeFormatted: React.createElement(
      'span',
      null,
      props.selectedDateTime.format('ddd MMM D, YYYY'),
      ' at',
      ' ',
      React.createElement(
        'div',
        null,
        props.selectedDateTime.format('h:mmA zz')
      )
    )
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      props.actions.hideScheduleModal();
    };
  },
  handleSetDateTime: function handleSetDateTime(props) {
    return function (m) {
      props.setDateTime(m.tz(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()));
    };
  },
  handleSaveDateTime: function handleSaveDateTime(props) {
    return function () {
      props.actions.setDraftSchedule(props.selectedDateTime);
      props.actions.hideScheduleModal();
    };
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (props) {
  return !props.selectedDateTime;
}, __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default.a))(__WEBPACK_IMPORTED_MODULE_11__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "5edS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_account_epic__ = __webpack_require__("bwbc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_apiKey_epic__ = __webpack_require__("a/xs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_epic__ = __webpack_require__("lnLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_ban__ = __webpack_require__("rNbS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_campaigns__ = __webpack_require__("OTri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_cards__ = __webpack_require__("tB4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_classification__ = __webpack_require__("Jkun");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_composer__ = __webpack_require__("2AqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_conversation__ = __webpack_require__("l/4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_csv__ = __webpack_require__("wWmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_driftAppMetrics__ = __webpack_require__("Ovcf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_embed__ = __webpack_require__("D3Al");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_endUser__ = __webpack_require__("YITf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_gates__ = __webpack_require__("pal8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_geolocation__ = __webpack_require__("ipNP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_integrations__ = __webpack_require__("y7VK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_inbox__ = __webpack_require__("U0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_meetings__ = __webpack_require__("b54Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_message__ = __webpack_require__("qJND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_notification__ = __webpack_require__("XQR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_org__ = __webpack_require__("rDli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_org_overview__ = __webpack_require__("yynn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_participants__ = __webpack_require__("lq9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_playbook__ = __webpack_require__("DCxr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_modules_presence__ = __webpack_require__("eUvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_modules_reveal__ = __webpack_require__("TNwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_modules_rules__ = __webpack_require__("QOQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_modules_segment__ = __webpack_require__("g3z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_modules_socket__ = __webpack_require__("9WSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_modules_tags__ = __webpack_require__("yvKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_modules_targeting__ = __webpack_require__("xAgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_app_modules_typing__ = __webpack_require__("plGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_modules_teams__ = __webpack_require__("52zG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_app_modules_enrichment__ = __webpack_require__("McSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_app_modules_experiment__ = __webpack_require__("mX/6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_app_modules_externalApp__ = __webpack_require__("o6GD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_app_modules_conversation_bulkUpdate__ = __webpack_require__("2qRO");








































var rootEpic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(__WEBPACK_IMPORTED_MODULE_1_app_modules_account_epic__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_2_app_modules_apiKey_epic__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_epic__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_4_app_modules_ban__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_5_app_modules_campaigns__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_6_app_modules_cards__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_7_app_modules_classification__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_8_app_modules_composer__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_9_app_modules_conversation__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_10_app_modules_csv__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_11_app_modules_driftAppMetrics__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_12_app_modules_embed__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_13_app_modules_endUser__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_35_app_modules_enrichment__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_14_app_modules_gates__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_15_app_modules_geolocation__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_17_app_modules_inbox__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_16_app_modules_integrations__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_18_app_modules_meetings__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_19_app_modules_message__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_20_app_modules_notification__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_21_app_modules_org__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_22_app_modules_org_overview__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_23_app_modules_participants__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_24_app_modules_playbook__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_25_app_modules_presence__["c" /* epic */], __WEBPACK_IMPORTED_MODULE_26_app_modules_reveal__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_27_app_modules_rules__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_28_app_modules_segment__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_29_app_modules_socket__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_30_app_modules_tags__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_31_app_modules_targeting__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_34_app_modules_teams__["a" /* epic */], __WEBPACK_IMPORTED_MODULE_32_app_modules_typing__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_33_app_modules_user__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_36_app_modules_experiment__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_37_app_modules_externalApp__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_38_app_modules_conversation_bulkUpdate__["b" /* epic */]);

/* harmony default export */ __webpack_exports__["a"] = (rootEpic);

/***/ }),

/***/ "5ib6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_constants__ = __webpack_require__("aJZK");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var patchProperties = function patchProperties(userId, patchOperation) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].patch('/users/' + userId + '/properties2', patchOperation).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
};

var api = {
  fetch: function fetch(userId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/users/' + userId + '/properties').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  update: function update(userId, properties) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].patch('/users/' + userId + '/properties', properties).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  patchClassificationNotificationProperties: function patchClassificationNotificationProperties(userId, properties) {
    var patchOperation = [{ "property": "classifications-to-notify-on", "operation": "set", "value": properties['classifications-to-notify-on'] }];
    return patchProperties(userId, patchOperation);
  },
  patchExtensionProperties: function patchExtensionProperties(userId, _ref) {
    var newProperties = _ref.newProperties,
        existingExtensionUserProperties = _ref.existingExtensionUserProperties;

    var mergedProperties = existingExtensionUserProperties ? _extends({}, existingExtensionUserProperties.toJS(), newProperties) : _extends({}, newProperties);
    var patchOperation = [{ "property": "extensionSettings", "operation": "set", "value": mergedProperties }];
    return patchProperties(userId, patchOperation);
  },
  fetchUsersByPropertyName: function fetchUsersByPropertyName(orgId, properties) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/organizations/' + orgId + '/users/properties', { name: properties, status: [__WEBPACK_IMPORTED_MODULE_2__user_constants__["_9" /* UserStatus */].INVITED, __WEBPACK_IMPORTED_MODULE_2__user_constants__["_9" /* UserStatus */].ENABLED] }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]).map(function (entries) {
      return entries.reduce(function (result, entry) {
        return result.update(entry.get('name'), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), function (value) {
          return value.set(entry.get('objectId'), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
            value: entry.get('value'),
            updatedAt: entry.get('updatedAt')
          }));
        });
      }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
    });
  }
};

/***/ }),

/***/ "5lNH":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 14.25C0 11.25 3.067 9 6.92 9c3.852 0 6.882 2.382 6.882 5.25v2.25c0 .75-.769 1.5-1.52 1.5H1.533C.767 18 0 17.25 0 16.5v-2.25zm1.55 0v2.25h10.717v-2.25c0-1.5-2.3-3.752-5.367-3.752S1.55 12.75 1.55 14.25zM6.9 6c1.27 0 2.3-1.007 2.3-2.25S8.17 1.5 6.9 1.5c-1.27 0-2.3 1.007-2.3 2.25S5.63 6 6.9 6zm0 1.5c-2.117 0-3.833-1.679-3.833-3.75C3.067 1.679 4.783 0 6.9 0s3.833 1.679 3.833 3.75c0 2.071-1.716 3.75-3.833 3.75zM16.1 6c1.27 0 2.3-1.007 2.3-2.25S17.37 1.5 16.1 1.5c-1.27 0-2.3 1.007-2.3 2.25S14.83 6 16.1 6zm0 1.5c-2.117 0-3.833-1.679-3.833-3.75C12.267 1.679 13.983 0 16.1 0s3.833 1.679 3.833 3.75c0 2.071-1.716 3.75-3.833 3.75zm.78 6.75v2.25h4.603c-.003 0-.007-.75-.013-2.25 0-1.974-2.301-3.75-5.338-3.75-.214 0-.426.008-.634.025.88 1.074 1.382 2.357 1.382 3.725zM16.132 9C19.976 9 23 11.382 23 14.25v2.25c0 .75-.767 1.5-1.517 1.5h-4.622a1.512 1.512 0 0 1-1.512-1.512V14.25c0-1.817-1.214-3.44-3.082-4.385C13.366 9.315 14.694 9 16.132 9z\" fill=\"#0176FF\" fill-rule=\"nonzero\"></path></svg>"

/***/ }),

/***/ "5nY2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(194);

/***/ }),

/***/ "5pXZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 29 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28 13h-3v3c0 .552-.448 1-1 1s-1-.448-1-1v-3h-3c-.552 0-1-.448-1-1s.448-1 1-1h3V8c0-.552.448-1 1-1s1 .448 1 1v3h3c.552 0 1 .448 1 1s-.448 1-1 1zm-15.177.4C16.92 14.57 20 18.186 20 22.334V23c0 .552-.448 1-1 1H1c-.552 0-1-.448-1-1v-.666c0-4.148 3.08-7.764 7.177-8.934C4.72 12.312 3 9.855 3 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.01 22h15.98c-.196-3.827-3.776-7-7.99-7s-7.793 3.173-7.99 7zM10 2C7.243 2 5 4.243 5 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "5qtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__("hnkb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_dapper__);









var mapStateToProps = function mapStateToProps(state) {
  return {
    orgId: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedTab', 'selectTab', function () {
  return __WEBPACK_IMPORTED_MODULE_3__component__["a" /* MappingType */].LEAD;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('hasCaseCutover', 'setHasCaseCutover', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('hasContactCreationSynced', 'setContactCreationSynced', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onTabClick: function onTabClick(_ref) {
    var selectTab = _ref.selectTab;
    return function (tab) {
      selectTab(tab);
    };
  },
  receiveToggles: function receiveToggles(_ref2) {
    var setContactCreationSynced = _ref2.setContactCreationSynced;
    return function (resp) {
      setContactCreationSynced(resp.hasContactCreationSynced || false);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _this = this;

    document.getElementsByClassName('app-content-container')[0].scrollTo(0, 0);
    Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_api__["E" /* getSalesforceToggles */])().then(this.props.receiveToggles).catch(function (err) {
      return console.warn(err);
    });

    __WEBPACK_IMPORTED_MODULE_6__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/' + this.props.orgId + '?namespace=ORG_HAS_SALESFORCE_TICKETING').then(__WEBPACK_IMPORTED_MODULE_6__driftt_dapper__["json"]).then(function (_ref3) {
      var ORG_HAS_SALESFORCE_TICKETING = _ref3.ORG_HAS_SALESFORCE_TICKETING;

      _this.props.setHasCaseCutover(ORG_HAS_SALESFORCE_TICKETING);
    });
  }
}))(__WEBPACK_IMPORTED_MODULE_3__component__["b" /* default */]));

/***/ }),

/***/ "5u7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);



var ConnectedIcon = function ConnectedIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
    className: 'connected-icon',
    src: __webpack_require__("D+mY")
  });
};

/* harmony default export */ __webpack_exports__["a"] = (ConnectedIcon);

/***/ }),

/***/ "5vEd":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"8\" viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.396 7.396c.478.478 1.252.482 1.735.008l5.39-5.294A1.232 1.232 0 0 0 11.792.353L7.257 4.788 2.853.36A1.232 1.232 0 1 0 1.11 2.103l5.286 5.294z\" fill=\"#E1EEF4\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "5xWb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "5xnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model__ = __webpack_require__("j8vl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SalesforceOwnerRouting = function (_Component) {
  _inherits(SalesforceOwnerRouting, _Component);

  function SalesforceOwnerRouting() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SalesforceOwnerRouting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SalesforceOwnerRouting.__proto__ || Object.getPrototypeOf(SalesforceOwnerRouting)).call.apply(_ref, [this].concat(args))), _this), _this.initialToggles = {}, _this.toggles = {}, _this.state = {
      canSave: false,
      togglesLoaded: false
    }, _this.togglesChanged = function (checked, _ref2) {
      var type = _ref2.type;

      _this.toggles = _extends({}, _this.toggles, _defineProperty({}, type, checked));
      _this.setState({ canSave: _this.togglesAreDifferent() });
    }, _this.togglesAreDifferent = function () {
      return !!__WEBPACK_IMPORTED_MODULE_3__model__["a" /* OWNER_TOGGLES */].find(function (_ref3) {
        var type = _ref3.type;
        return _this.initialToggles[type] !== _this.toggles[type];
      });
    }, _this.pickOnlyOwnerRoutingToggles = function (toggles) {
      return _.pick(toggles, __WEBPACK_IMPORTED_MODULE_3__model__["a" /* OWNER_TOGGLES */].map(function (ot) {
        return ot.type;
      }));
    }, _this.receiveToggles = function (toggles) {
      var selectedToggles = _this.pickOnlyOwnerRoutingToggles(toggles);
      _this.initialToggles = selectedToggles;
      _this.toggles = selectedToggles;
      _this.setState({ togglesLoaded: true });
    }, _this.handleSaveSuccess = function () {
      _this.props.notifications.success('Successfully updated Salesforce Owner Routings!');
      _this.initialToggles = _extends({}, _this.toggles);
      _this.setState({ canSave: false });
    }, _this.handleSaveFailure = function () {
      return _this.props.notifications.error('Failed to update Salesforce Owner Routings');
    }, _this.onSave = function () {
      Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_integrations_api__["L" /* patchSalesforceToggles */])(_this.toggles).then(_this.handleSaveSuccess).catch(_this.handleSaveFailure);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SalesforceOwnerRouting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_integrations_api__["E" /* getSalesforceToggles */])().then(this.receiveToggles);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.togglesLoaded) return null;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_IntegrationToggles__["a" /* default */], {
          toggles: !this.state.canSave ? Object(__WEBPACK_IMPORTED_MODULE_3__model__["c" /* hydrateOwnerToggles */])(this.initialToggles) : Object(__WEBPACK_IMPORTED_MODULE_3__model__["c" /* hydrateOwnerToggles */])(this.toggles),
          onChange: this.togglesChanged
        }),
        this.state.canSave && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'drift-button drift-button-primary', onClick: this.onSave },
          'Save Changes'
        )
      );
    }
  }]);

  return SalesforceOwnerRouting;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(SalesforceOwnerRouting));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "5y4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_SendFromEdit__ = __webpack_require__("zvkJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("0lGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);








function UserSelectionSection(_ref) {
  var user = _ref.user,
      onSelect = _ref.onSelect,
      noUserText = _ref.noUserText,
      _ref$enableClear = _ref.enableClear,
      enableClear = _ref$enableClear === undefined ? true : _ref$enableClear;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.UserSelectionSection },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], { user: user }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'dsg-Regular' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'dsg-Body' },
        user ? user.name || user.email : noUserText
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_SendFromEdit__["a" /* default */], {
        user: user,
        onSenderSelect: onSelect,
        enableClear: enableClear
      })
    )
  );
}
UserSelectionSection.propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  noUserText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

UserSelectionSection.defaultProps = {
  noUserText: 'No user selected'
};
/* harmony default export */ __webpack_exports__["a"] = (UserSelectionSection);

/***/ }),

/***/ "5yt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__ = __webpack_require__("zrFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_states__ = __webpack_require__("PawR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__ = __webpack_require__("qQ9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__ = __webpack_require__("cTDj");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var closeSRC = __webpack_require__("+Juk");
var mapSRC = __webpack_require__("1jik");
var fullSRC = __webpack_require__("pzVx");

var SCALE_INCREMENT = .5;

var COUNTRY_FILTER_TYPES = Object.freeze([__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY]);

var STATE_FILTER_TYPES = Object.freeze([__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE]);

var ClearbitGeoFilter = function (_Component) {
  _inherits(ClearbitGeoFilter, _Component);

  _createClass(ClearbitGeoFilter, [{
    key: 'generateDefaultState',
    value: function generateDefaultState(props) {
      var defaultOptions = props.activeFilter.value;
      var ifEmptyRegionDefault = defaultOptions.length || this.isCountryFilterType(props.activeFilter.field) ? defaultOptions : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */].northeast;

      return {
        selectedGeoOptions: ifEmptyRegionDefault,
        fieldType: props.activeFilter.field,
        mapScale: 1,
        dragX: 0,
        dragY: 0,
        dragStartX: 0,
        dragStartY: 0,
        isPressed: false
      };
    }
  }]);

  function ClearbitGeoFilter(props) {
    _classCallCheck(this, ClearbitGeoFilter);

    var _this = _possibleConstructorReturn(this, (ClearbitGeoFilter.__proto__ || Object.getPrototypeOf(ClearbitGeoFilter)).call(this, props));

    _this.updateParent = function () {
      if (_this.props.onUpdateCondition) {
        return _this.props.onUpdateCondition({
          operator: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["A" /* GEO_FILTER_OPERATORS */].IS_ANY,
          value: _this.state.selectedGeoOptions
        });
      }
      var canSave = _this.state.fieldType && _this.state.selectedGeoOptions.length;
      _this.props.setPageValidity(!!canSave);
      if (canSave) {
        _this.props.setActiveFilter({
          field: _this.state.fieldType,
          operator: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["A" /* GEO_FILTER_OPERATORS */].IS_ANY,
          value: _this.state.selectedGeoOptions
        });
      }
    };

    _this.zoomIn = function () {
      _this.setState(function (prevState) {
        if (prevState.mapScale >= 3) return;
        return {
          mapScale: prevState.mapScale + SCALE_INCREMENT
        };
      });
    };

    _this.zoomOut = function () {
      _this.setState(function (prevState) {
        if (prevState.mapScale <= 1) return;
        return {
          mapScale: prevState.mapScale - SCALE_INCREMENT
        };
      });
    };

    _this.fullScreen = function () {
      _this.setState(function (prevState) {
        return {
          fullScreen: !prevState.fullScreen
        };
      });
    };

    _this.dragMap = function (event) {
      if (_this.state.mapScale <= 1 || !_this.state.isPressed) return;
      var x = event.pageX - _this.state.dragStartX;
      var y = event.pageY - _this.state.dragStartY;

      _this.setState({
        dragX: event.pageX,
        dragY: event.pageY
      });
    };

    _this.pressTimer = function () {
      setTimeout(function () {
        _this.setState({
          isPressed: true
        });
      }, 2000);
    };

    _this.handleMousePress = function (event) {
      _this.setState({
        dragStartX: event.pageX,
        dragStartY: event.pageY
      });

      _this.pressTimer();
    };

    _this.handleMouseUp = function () {
      clearTimeout(_this.pressTimer);
      _this.setState({
        isPressed: false
      });
    };

    _this.getFormattedCountryOptions = function () {
      var _ref;

      var unusedCountries = (_ref = _).without.apply(_ref, [Object.keys(__WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */])].concat(_toConsumableArray(_this.state.selectedGeoOptions)));
      return unusedCountries.map(function (country) {
        return { label: __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */][country], value: country };
      });
    };

    _this.getFormattedStateOptions = function () {
      var _ref2;

      var unusedStates = (_ref2 = _).without.apply(_ref2, [__WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_states__["a" /* states */]].concat(_toConsumableArray(_this.state.selectedGeoOptions)));
      return unusedStates.map(function (state) {
        return { label: state, value: state };
      });
    };

    _this.addStateFromMap = function (event) {
      var stateName = document.elementFromPoint(event.clientX, event.clientY).dataset.name;
      if (!!stateName) {
        if (_this.state.selectedGeoOptions.includes(stateName)) {
          _this.removeGeoOption(stateName);
        } else {
          _this.setState(function (prevState) {
            var newOptions = prevState.selectedGeoOptions.slice(0);
            newOptions.push(stateName);
            newOptions.sort();

            return {
              selectedGeoOptions: newOptions
            };
          }, _this.updateParent);
        }
      }
    };

    _this.isCountryFilterType = function (field) {
      return COUNTRY_FILTER_TYPES.includes(field);
    };

    _this.isStateFilterType = function (field) {
      return STATE_FILTER_TYPES.includes(field);
    };

    _this.removeGeoOption = function (value) {
      _this.setState(function (prevState) {
        return {
          selectedGeoOptions: _.without(prevState.selectedGeoOptions, value)
        };
      }, _this.updateParent);
    };

    _this.saveGeoOption = function (values) {
      _this.setState(function (prevState) {
        var newOptions = prevState.selectedGeoOptions.slice(0);
        var onlyValues = values.map(function (option) {
          return option.value;
        });
        newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
        newOptions.sort();

        return {
          selectedGeoOptions: newOptions
        };
      }, _this.updateParent);
    };

    _this.bucketSelect = function (value) {
      var geoType = _this.isCountryFilterType(_this.state.fieldType) ? __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */] : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */];

      _this.setState({ selectedGeoOptions: geoType[value.value] || [] }, _this.updateParent);
    };

    _this.chooseCountry = function () {
      _this.setState({ fieldType: _this.state.fieldType, selectedGeoOptions: [] }, _this.updateParent);
    };

    _this.chooseState = function () {
      _this.setState({ fieldType: _this.state.fieldType, selectedGeoOptions: [] }, _this.updateParent);
    };

    _this.renderSelectOption = function (_ref3) {
      var label = _ref3.label;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'geo-option choice-dropdown-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-value' },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-add' },
          '+Add'
        )
      );
    };

    _this.renderStateSelectionList = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: _this.state.selectedGeoOptions.length * 75 / 2 + 75 + 'px' } },
        _this.state.selectedGeoOptions.map(function (option) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: option },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              option
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
                return _this.removeGeoOption(option);
              } })
          );
        })
      );
    };

    _this.renderCountrySelectionList = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: _this.state.selectedGeoOptions.length * 75 / 2 + 75 + 'px' } },
        _this.state.selectedGeoOptions.map(function (option) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: option },
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */][option]
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
                return _this.removeGeoOption(option);
              } })
          );
        })
      );
    };

    _this.state = _this.generateDefaultState(props);
    return _this;
  }

  _createClass(ClearbitGeoFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.activeFilter.field !== nextProps.activeFilter.field) {
        this.setState(this.generateDefaultState(nextProps));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateParent();
    }
  }, {
    key: 'getStateOrCountries',
    value: function getStateOrCountries() {
      var _types;

      var types = (_types = {}, _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, this.getFormattedStateOptions), _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, this.getFormattedStateOptions), _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, this.getFormattedCountryOptions), _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, this.getFormattedCountryOptions), _types);
      return types[this.state.fieldType]();
    }
  }, {
    key: 'getFormattedRegionOptions',
    value: function getFormattedRegionOptions() {
      return [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */]).map(function (region) {
        return { label: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["H" /* REGION_LABELS */][region], value: region };
      })), [{ label: 'Custom', value: 'custom' }]);
    }
  }, {
    key: 'getFormattedContinentOptions',
    value: function getFormattedContinentOptions() {
      return [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */]).map(function (continent) {
        return { label: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["h" /* CONTINENT_LABELS */][continent], value: continent };
      })), [{ label: 'Custom', value: 'custom' }]);
    }
  }, {
    key: 'stateOrCountryListItems',
    value: function stateOrCountryListItems() {
      var _types2;

      var types = (_types2 = {}, _defineProperty(_types2, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, this.renderStateSelectionList), _defineProperty(_types2, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, this.renderStateSelectionList), _defineProperty(_types2, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, this.renderCountrySelectionList), _defineProperty(_types2, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, this.renderCountrySelectionList), _types2);
      return types[this.state.fieldType]();
    }
  }, {
    key: 'renderBucketSelect',
    value: function renderBucketSelect() {
      var _this2 = this;

      var formattedGeoOptions = this.isCountryFilterType(this.state.fieldType) ? this.getFormattedContinentOptions() : this.getFormattedRegionOptions();
      var geoType = this.isCountryFilterType(this.state.fieldType) ? __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */] : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */];

      var matchedBucket = _.find(formattedGeoOptions, function (value) {
        return _.isEqual(geoType[value.value], _this2.state.selectedGeoOptions);
      });

      var bselectOptions = {
        multi: false,
        autoFocus: false,
        options: formattedGeoOptions,
        onChange: this.bucketSelect,
        clearable: false,
        searchable: false,
        value: matchedBucket ? matchedBucket : { label: 'Custom', value: 'custom' }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], bselectOptions);
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var placeholders = {
        'geoCountryCode': 'Add a country...',
        'geoState': 'Add a state...'
      };
      var selectOptions = {
        multi: true,
        autoFocus: true,
        options: this.getStateOrCountries(),
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        onChange: this.saveGeoOption,
        placeholder: placeholders[this.state.fieldType]
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderGeoTypeSelect',
    value: function renderGeoTypeSelect() {
      var stateSelected = this.isCountryFilterType(this.state.fieldType) ? 'selected' : '';
      var countrySelected = this.isStateFilterType(this.state.fieldType) ? 'selected' : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'fieldset',
        { className: 'drift-pill-set' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button large ' + countrySelected, onClick: this.chooseCountry },
          'Countries'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button large ' + stateSelected, onClick: this.chooseState },
          'US States'
        )
      );
    }
  }, {
    key: 'renderStateMap',
    value: function renderStateMap() {
      var _this3 = this;

      var fullScreen = this.state.fullScreen ? 'full-screen-map' : '';

      if (!this.state.isPressed) {
        setTimeout(function () {
          var map = document.getElementById('us-map');
          if (!map) return;

          var paths = map.querySelectorAll(':scope > path');
          paths.forEach(function (path) {
            path.style = '';
          });

          _this3.state.selectedGeoOptions.map(function (state) {
            var path = document.querySelectorAll('[data-name="' + state + '"]')[0];
            path.style = 'fill: #b5d2e1; stroke: #fff; stroke-width: 1px;';
            path.class = 'active';
          });
        }, 200);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'geo-filter-us-map ' + fullScreen,
          onClick: this.addStateFromMap,
          onMouseOver: this.dragMap
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'close-map', onClick: this.fullScreen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'geo-filter-us-map-controls' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button', onClick: this.zoomIn },
            '+'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button', onClick: this.zoomOut },
            '-'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button full', onClick: this.fullScreen },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: fullSRC })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'map-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
            src: mapSRC,
            style: { transform: 'scale(' + this.state.mapScale + ') translateZ(0) translateX(' + (this.state.dragX - this.state.dragStartX) + 'px) translateY(' + (this.state.dragY - this.state.dragStartY) + 'px)' }
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-sidebar drift-form clearbit-state-buckets' },
          this.renderBucketSelect()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          this.renderSearchBar()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-selection rules-choice-selection-multi-column' },
          this.isStateFilterType(this.state.fieldType) && this.renderStateMap(),
          this.stateOrCountryListItems()
        )
      );
    }
  }]);

  return ClearbitGeoFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ClearbitGeoFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "6+Vu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GoalActionModalContent":"GoalActionModalContent---IUUKk","GoalActionModalHeader":"GoalActionModalHeader---hG9xL"};

/***/ }),

/***/ "60LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_SelectWrapper__ = __webpack_require__("2lG1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OPTIONS = [{ value: 'isAvailable', text: 'is online' }, { value: 'isNotAvailable', text: 'is offline' }];

var TeamSelectInputs = function (_Component) {
  _inherits(TeamSelectInputs, _Component);

  function TeamSelectInputs() {
    _classCallCheck(this, TeamSelectInputs);

    return _possibleConstructorReturn(this, (TeamSelectInputs.__proto__ || Object.getPrototypeOf(TeamSelectInputs)).apply(this, arguments));
  }

  _createClass(TeamSelectInputs, [{
    key: 'makeOnRemove',
    value: function makeOnRemove(index) {
      var _this2 = this;

      return function () {
        var options = _this2.props.conditionValue.get('value');
        _this2.props.conditionUpdater('value', options.splice(index, 1));
      };
    }
  }, {
    key: 'getTeamOptions',
    value: function getTeamOptions() {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(this.props.teams, function (team) {
        return {
          value: parseInt(team.id),
          label: team.name
        };
      });
    }
  }, {
    key: 'getAvailableOptions',
    value: function getAvailableOptions() {
      var options = this.props.conditionValue.get('value');
      return __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(this.getTeamOptions(), function (_ref) {
        var value = _ref.value;

        var found = options.find(function (option) {
          return option === value;
        });
        return !found;
      });
    }
  }, {
    key: 'makeOnOptionSelect',
    value: function makeOnOptionSelect(index) {
      var _this3 = this;

      return function (option) {
        var options = _this3.props.conditionValue.get('value');
        _this3.props.conditionUpdater('value', options.set(index, option.value));
      };
    }
  }, {
    key: 'renderStringInput',
    value: function renderStringInput(value, index, placeholder) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        valueLink: {
          requestChange: this.makeStringInputChange(index),
          value: value
        },
        placeholder: placeholder,
        isValid: value
      });
    }
  }, {
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      var conditionValue = this.props.conditionValue;

      return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text;
    }
  }, {
    key: 'renderSelect',
    value: function renderSelect() {
      var _this4 = this;

      var options = this.props.conditionValue.get('value');
      return options.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_SelectWrapper__["a" /* default */], {
          className: 'team-select',
          value: option,
          options: _this4.getTeamOptions(),
          onChange: _this4.makeOnOptionSelect(index),
          clearable: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var optionTypes = this.props.optionTypes;


      var options = _.filter(OPTIONS, function (_ref2) {
        var value = _ref2.value;
        return optionTypes.includes(value);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-space-around flex-1 flex-wrap' },
        this.renderSelect(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__["a" /* default */], {
          onSelection: this.onOperatorSelect.bind(this),
          options: options,
          selectedValue: this.getSelectedValue()
        })
      );
    }
  }]);

  return TeamSelectInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TeamSelectInputs.defaultProps = {
  optionTypes: ['isAvailable', 'isNotAvailable']
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_teams_hoc_withOrgTeams__["a" /* default */])(TeamSelectInputs));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "60Pi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "60ou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return captureExceptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return captureException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return captureResponseException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRavenClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable
    no-var,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
var Raven = void 0;


if (__WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["V" /* SENTRY_KEY */]) {
  var ravenOptions = {
    ignoreErrors: [
    // Network errors
    'TypeError: Network request failed',
    // TOOD: we might want to remove these later, but as of Jan. 30, 2018 they're SUPER noisy
    'ajax error 404', 'ajax error 403', 'ajax error 401', 'ajax error 0'],
    release: 'SNAPSHOT',
    environment: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["U" /* SENTRY_ENVIRONMENT */]
  };
  Raven = __webpack_require__("/Hyb");
  Raven.config(__WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["V" /* SENTRY_KEY */], ravenOptions).install();
}

var captureExceptions = function captureExceptions(errors) {
  return _.each(errors, function (error, errorKey) {
    if (!error) {
      return;
    }
    // don't mess with NotFoundError from marty.js
    if (error.name != null && error.name === 'Not found') {
      console.warn(errorKey, error);
      return;
    } else {
      return captureException(error);
    }
  });
};

var captureResponseException = function captureResponseException(res) {
  var ravenData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (res.status === 403 || res.status === 401) {
    return;
  }
  var error = new Error(JSON.stringify(res.body));
  return captureException(error, _extends({}, ravenData, { level: 'error' }));
};

var logError = function logError(error) {
  console.error(error);
  if (error.stack) {
    return console.error(error.stack);
  }
};

var getRavenClient = function getRavenClient() {
  var isEnabled = (__ENV__ === 'PRODUCTION' || __ENV__ === 'MASTER') && window.location.hostname !== 'localhost';
  if (isEnabled) {
    return Raven;
  }
};

var captureException = function captureException(error, ravenData) {
  __guard__(getRavenClient(), function (x) {
    return x.captureException(error, ravenData);
  });
  return logError(error);
};



function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "60pu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("e6/c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conversation_bulkUpdate_selectors__ = __webpack_require__("n5J5");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
  integrationProperties: [],
  integrationMappings: [],
  integrationMappingsErr: null,
  integrationPatchLoading: false
};

var sortedByStatic = function sortedByStatic(mappings) {
  return _.sortBy(mappings, function (mapping) {
    return !mapping.static;
  });
};

var integrationMappings = function integrationMappings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_ELOQUA_FIELDS_SUCCESS */]:
      return _extends({}, state, { integrationFields: action.fields });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_ELOQUA_MAPPINGS_SUCCESS */]:
      var clonedState = _extends({}, state);
      clonedState.integrationMappings = sortedByStatic(action.mappings);
      return clonedState;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_ELOQUA_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {
        integrationMappings: sortedByStatic(action.mappings),
        integrationMappingsErr: null,
        integrationPatchLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_ELOQUA_MAPPINGS_ERROR */]:
      return _extends({}, state, { integrationMappingsErr: action.err, integrationPatchLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_ELOQUA_MAPPINGS_START */]:
      return _extends({}, state, { integrationPatchLoading: true });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (integrationMappings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "69aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__ = __webpack_require__("EP6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__);




var SizeToModifierClass = {
  "small": "AriaMenuButton--small",
  "large": "AriaMenuButton--large"

  /*
    SimpleSelect
    A wrapper for https://github.com/davidtheclark/react-aria-menubutton
  
    Props:
    onSelection   (Function) called when select item is selected. Parameters: value, SyntheticEvent
    options       (object) object with "value" and "text" keys to fill select box
    selectedValue (any) The "value" field of the selected item
    displayFormat (Function) A function that returns the selected item and renders it. Default is _.identity
    style         (object) css style
    className     (string) css class
    size          (string) one of SizeToModifierClass keys
    disabled      (bool) Whether disabled or not
  */
};function SimpleSelect(_ref) {
  var onSelection = _ref.onSelection,
      options = _ref.options,
      selectedValue = _ref.selectedValue,
      displayFormat = _ref.displayFormat,
      itemFormat = _ref.itemFormat,
      style = _ref.style,
      size = _ref.size,
      className = _ref.className,
      disabled = _ref.disabled;

  var selected = void 0;
  if (!itemFormat) {
    itemFormat = _.identity;
  }
  var items = options.map(function (_ref2) {
    var value = _ref2.value,
        text = _ref2.text;

    if (selectedValue === value) selected = value;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__["MenuItem"],
      {
        key: value,
        value: value,
        text: text || value
      },
      itemFormat(text || value)
    );
  });
  if (!displayFormat) {
    displayFormat = _.identity;
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__["Wrapper"],
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("AriaMenuButton", SizeToModifierClass[size], className),
      onSelection: onSelection,
      style: style
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__["Button"],
      { disabled: disabled || false,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ 'AriaMenuButton--disabled': disabled }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content' },
        displayFormat(selectedValue)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_aria_menubutton__["Menu"],
      null,
      items
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (SimpleSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "6Cv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("/k6p");
var _api;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function parseTags(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(data).map(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Tag */]);
}

var api = (_api = {
  fetchList: function fetchList(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/organizations/' + orgId + '/tags').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(parseTags);
  },
  create: function create(orgId, tag) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/tags', tag.toJS()).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Tag */]);
  },
  update: function update(orgId, tag) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/organizations/' + orgId + '/tags/' + tag.id, tag.toJS()).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Tag */]);
  }
}, _defineProperty(_api, 'delete', function _delete(orgId, tagId) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].delete('/organizations/' + orgId + '/tags/' + tagId).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'tagConversation', function tagConversation(conversationId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["ConversationAPI"].post('/conversations/' + conversationId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'untagConversation', function untagConversation(conversationId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["ConversationAPI"].delete('/conversations/' + conversationId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'tagCompany', function tagCompany(companyId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/companies/' + companyId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'untagCompany', function untagCompany(companyId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].delete('/companies/' + companyId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'tagEndUser', function tagEndUser(endUserId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/end_users/' + endUserId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'untagEndUser', function untagEndUser(endUserId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].delete('/end_users/' + endUserId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]);
}), _defineProperty(_api, 'setResponseTags', function setResponseTags(responseId, tagIds) {
  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].patch('/interactions/responses/' + responseId + '/tags', tagIds).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(function (data) {
    return parseTags(data.tags);
  });
}), _api);

/***/ }),

/***/ "6DhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("Y9Yz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Sidesheet = function (_Component) {
  _inherits(Sidesheet, _Component);

  function Sidesheet(props) {
    _classCallCheck(this, Sidesheet);

    var _this = _possibleConstructorReturn(this, (Sidesheet.__proto__ || Object.getPrototypeOf(Sidesheet)).call(this, props));

    _this.closeBar = function () {
      var closeBarDelay = function closeBarDelay() {
        return setTimeout(_this.props.onClose, 600);
      };

      _this.setState({
        closed: true
      }, closeBarDelay);
    };

    _this.renderModal = function () {

      var closedClass = _this.state.closed ? 'closed' : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'sidesheet ' + closedClass },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'sidesheet-click-area', onClick: _this.closeBar }),
        _this.renderContent()
      );
    };

    _this.renderContent = function () {
      var hasTitle = !!_this.props.title;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'sidesheet-content' },
        hasTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'sidesheet-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'sidesheet-header-title' },
            _this.props.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'sidesheet-close', onClick: _this.closeBar },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { name: 'close', width: 15 })
          )
        ),
        _this.props.children
      );
    };

    _this.state = {
      closed: true
    };
    return _this;
  }

  _createClass(Sidesheet, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // animate open
      setTimeout(function () {
        _this2.setState({ closed: false });
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.isModal ? this.renderModal() : this.renderContent();
    }
  }]);

  return Sidesheet;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Sidesheet);

/***/ }),

/***/ "6EYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OrgSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AgentSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var OrgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  salesforceLeadObject: undefined,
  salesforceEventObject: undefined,
  sfLeadFields: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  sfEventFields: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

var AgentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  taskConfigMap: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

/***/ }),

/***/ "6Fjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PardotMapping; });
var PardotMapping = {
    static: false,
    defaultValue: null,
    driftAttribute: null,
    integrationAttribute: null,
    isOverwritable: null
};

/***/ }),

/***/ "6IBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MultiTimeSelect__ = __webpack_require__("PJ2g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("eKzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var OnlineHours = function (_Component) {
  _inherits(OnlineHours, _Component);

  function OnlineHours(props) {
    _classCallCheck(this, OnlineHours);

    var _this = _possibleConstructorReturn(this, (OnlineHours.__proto__ || Object.getPrototypeOf(OnlineHours)).call(this, props));

    _this.handleTimeSelect = function (index, key, value) {
      var openHours = _this.state.openHours;

      var updatedOpenHours = openHours.setIn([index, key], value);
      _this.submitHours(updatedOpenHours);
    };

    _this.handleAddTime = function () {
      var openHours = _this.state.openHours;

      var updatedOpenHours = openHours.push(Object(__WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__["f" /* Hours */])());
      _this.submitHours(updatedOpenHours);
    };

    _this.handleRemoveTime = function (index) {
      var openHours = _this.state.openHours;

      var updatedOpenHours = openHours.delete(index);
      _this.submitHours(updatedOpenHours);
    };

    _this.submitHours = function (updatedOpenHours) {
      var initialOpenHours = _this.props.initialOpenHours;


      var updatedObject = {
        theme: {
          openHours: updatedOpenHours.toJS()
        }
      };
      var initialObject = {
        theme: {
          openHours: initialOpenHours.toJS()
        }
      };

      _this.setState({ openHours: updatedOpenHours });

      var changes = Object(__WEBPACK_IMPORTED_MODULE_6_utils_PatchHelper__["a" /* patchOperations */])(updatedObject, initialObject);
      _this.props.updateEmbed(changes);
    };

    _this.handleToggleTeamAvailability = function (event) {
      var availabilityBasedOnline = event.target.checked;
      var initialAvailabilityBasedOnline = _this.props.initialAvailabilityBasedOnline;


      var updatedObject = {
        theme: {
          availabilityBasedOnline: availabilityBasedOnline
        }
      };
      var initialObject = {
        theme: {
          availabilityBasedOnline: initialAvailabilityBasedOnline
        }
      };

      _this.setState({ availabilityBasedOnline: availabilityBasedOnline });
      var changes = Object(__WEBPACK_IMPORTED_MODULE_6_utils_PatchHelper__["a" /* patchOperations */])(updatedObject, initialObject);
      _this.props.updateEmbed(changes);
    };

    _this.state = {
      openHours: _this.props.initialOpenHours,
      availabilityBasedOnline: _this.props.initialAvailabilityBasedOnline
    };
    return _this;
  }

  _createClass(OnlineHours, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          openHours = _state.openHours,
          availabilityBasedOnline = _state.availabilityBasedOnline;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__style_styl___default.a.OnlineHours },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__Section__["a" /* SectionItem */],
          { title: 'Online Hours' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MultiTimeSelect__["a" /* default */], {
            openHours: openHours,
            onSelection: this.handleTimeSelect,
            onAddTime: this.handleAddTime,
            onRemoveTime: this.handleRemoveTime
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'team-availability-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Section__["a" /* SectionItem */], {
            title: 'Go Offline when all users in ' + (this.props.orgName || 'your company') + ' are Away',
            description: 'Drift will automatically go offline when all users in your organization are Away. Scheduled hours will resume when a user becomes Active.' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'team-availability-toggle' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Toggle__["a" /* default */], { checked: availabilityBasedOnline, onChange: this.handleToggleTeamAvailability })
          )
        )
      );
    }
  }]);

  return OnlineHours;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OnlineHours.propTypes = {
  initialOpenHours: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__["f" /* Hours */]).isRequired,
  initialAvailabilityBasedOnline: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
OnlineHours.defaultProps = {
  initialAvailabilityBasedOnline: false
};


/* harmony default export */ __webpack_exports__["a"] = (OnlineHours);

/***/ }),

/***/ "6N1b":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 101 29.3\" enable-background=\"new 0 0 101 29.3\" xml:space=\"preserve\"><g><path fill=\"none\" d=\"M87.8,15.1c-0.4-0.6-0.9-1-1.4-1.3c-0.6-0.3-1.2-0.4-1.8-0.4c0,0,0,0-0.1,0c-0.7,0-1.4,0.2-2,0.6 c-0.6,0.4-1.1,0.9-1.4,1.5c-0.3,0.6-0.5,1.2-0.5,1.9c0,0.1,0,0.1,0,0.2c0,0.7,0.2,1.3,0.6,1.8c0.4,0.6,0.9,1,1.5,1.4 c0.6,0.3,1.1,0.4,1.7,0.4c0.1,0,0.1,0,0.2,0c1,0,1.9-0.5,2.7-1.4c0.7-0.8,1-1.6,1-2.5c0-0.1,0-0.3,0-0.4 C88.4,16.3,88.2,15.7,87.8,15.1z\"></path><path fill=\"none\" d=\"M68.3,13.1c-2.3,0-4,1.9-4,4.1s1.7,4.1,4,4.1c1.9,0,3.7-1.9,3.7-4.1C71.9,15,70.2,13.1,68.3,13.1z\"></path><path fill=\"none\" d=\"M38.4,13.3c-2.3,0-4,1.9-4,4.1s1.7,4.1,4,4.1c1.9,0,3.7-1.9,3.7-4.1C42,15.2,40.3,13.3,38.4,13.3z\"></path><polygon fill=\"#4F4F4F\" points=\"11,13.3 3.5,13.3 3.5,5.5 0,5.5 0,24.7 3.5,24.7 3.5,16.7 11,16.7 11,24.7 14.5,24.7 14.5,5.5 11,5.5 \"></polygon><path fill=\"#4F4F4F\" d=\"M25.6,18.4c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9v-8.3h-3.3v8.3c0,3.4,2.8,6.3,6.3,6.3 c3.4,0,6.3-2.8,6.3-6.3v-8.3h-3.3v8.3H25.6z\"></path><path fill=\"#4F4F4F\" d=\"M38.3,10.2c-1.7,0-2.8,0.5-3.9,1.6V5.5H31v11.8c0,4.4,3.2,7.4,6.8,7.4c4,0,7.5-3.1,7.5-7.2 S42,10.2,38.3,10.2z M38.4,21.6c-2.3,0-4-1.9-4-4.1s1.7-4.1,4-4.1c1.9,0,3.7,1.9,3.7,4.1C42,19.7,40.3,21.6,38.4,21.6z\"></path><path fill=\"#4F4F4F\" d=\"M50.9,11.1c0-1.7,1.1-2.2,2.4-2.2c1,0,2.3,0.7,3.2,1.7L58.6,8c-1.1-1.5-3.3-2.5-5.1-2.5 c-3.6,0-6.3,2.1-6.3,5.6c0,6.5,8,4.4,8,8.1c0,1.1-1.1,2.1-2.4,2.1c-2,0-2.6-1-3.5-2l-2.4,2.5c1.6,1.9,3.5,2.9,5.8,2.9 c3.4,0,6.2-2.1,6.2-5.5C58.9,12,50.9,14.2,50.9,11.1z\"></path><path fill=\"#4F4F4F\" d=\"M75.2,17.3c0-4.1-3.5-7.2-7.5-7.2c-3.6,0-6.8,3-6.8,7.4v11.8h3.4v-6.4c1.1,1.1,2.3,1.6,3.9,1.6 C71.9,24.5,75.2,21.4,75.2,17.3z M68.3,21.4c-2.3,0-4-1.9-4-4.1s1.7-4.1,4-4.1c1.9,0,3.7,1.9,3.7,4.1 C71.9,19.5,70.2,21.4,68.3,21.4z\"></path><path fill=\"#4F4F4F\" d=\"M99.8,21.6c-2,0-2.5-0.9-2.5-2.2v-5.8h3.1v-2.9h-3.1V6.8l-3.4,1.5v11.8c0,3,2.1,4.5,4.9,4.5 c0.4,0,1,0,1.3-0.1l0.8-3C100.6,21.5,100.2,21.6,99.8,21.6z\"></path><path fill=\"#F37622\" d=\"M88.3,11.1c-0.8-0.5-1.7-0.8-2.7-0.9V6.7c1-0.4,1.6-1.3,1.6-2.4c0-1.5-1.2-2.7-2.7-2.7s-2.6,1.2-2.6,2.7 c0,1.1,0.6,2,1.6,2.4v3.5c-0.9,0.1-1.6,0.4-2.4,0.7c-1.5-1.2-6.5-5-9.5-7.2c0.1-0.3,0.1-0.5,0.1-0.8c0-1.6-1.3-3-3-3 c-1.6,0-3,1.3-3,3c0,1.6,1.3,3,3,3c0.6,0,1.1-0.2,1.5-0.4L70.8,6l8.5,6.1c-0.4,0.4-0.8,0.9-1.2,1.4C77.4,14.6,77,15.8,77,17 c0,0.1,0,0.2,0,0.3c0,0.9,0.1,1.8,0.4,2.6c0.3,0.7,0.6,1.3,1.1,1.9l-2.8,2.8c-0.2-0.1-0.5-0.1-0.8-0.1c-0.6,0-1.2,0.2-1.6,0.7 c-0.4,0.4-0.7,1-0.7,1.6s0.2,1.2,0.7,1.6c0.4,0.4,1,0.7,1.6,0.7s1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.6c0-0.2,0-0.5-0.1-0.7 l2.9-2.9c0.4,0.3,0.8,0.5,1.3,0.7c0.9,0.4,1.9,0.6,3,0.6c0.1,0,0.1,0,0.2,0c1.2,0,2.4-0.3,3.5-0.9s2-1.5,2.7-2.5 c0.7-1.1,1.1-2.3,1.1-3.6c0,0,0,0,0-0.1c0-1.3-0.3-2.5-0.9-3.6C90.4,12.7,89.5,11.8,88.3,11.1z M87.4,19.8 c-0.8,0.9-1.7,1.4-2.7,1.4c-0.1,0-0.1,0-0.2,0c-0.6,0-1.2-0.1-1.7-0.4c-0.6-0.3-1.1-0.8-1.5-1.4s-0.6-1.2-0.6-1.8 c0-0.1,0-0.1,0-0.2c0-0.7,0.1-1.3,0.5-1.9c0.3-0.6,0.8-1.1,1.4-1.5s1.2-0.6,2-0.6c0,0,0,0,0.1,0c0.6,0,1.3,0.1,1.8,0.4 c0.6,0.3,1.1,0.7,1.4,1.3c0.4,0.6,0.6,1.2,0.6,1.8c0,0.1,0,0.3,0,0.4C88.5,18.3,88.1,19.1,87.4,19.8z\"></path></g></svg>"

/***/ }),

/***/ "6Ni/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6QfC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6RZ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_InstallSnippetCard__ = __webpack_require__("q/Xv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("Lkyf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_icons_file_code_icon_svg__ = __webpack_require__("0yFz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_icons_file_code_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_icons_file_code_icon_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Step = function Step(_ref) {
  var icon = _ref.icon,
      className = _ref.className,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.StepContainer },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: className },
      icon
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.StepContent },
      children
    )
  );
};

var JavaScriptInstaller = function (_Component) {
  _inherits(JavaScriptInstaller, _Component);

  function JavaScriptInstaller() {
    _classCallCheck(this, JavaScriptInstaller);

    return _possibleConstructorReturn(this, (JavaScriptInstaller.__proto__ || Object.getPrototypeOf(JavaScriptInstaller)).apply(this, arguments));
  }

  _createClass(JavaScriptInstaller, [{
    key: 'getSnippet',
    value: function getSnippet() {
      var snippet = this.props.defaultEmbed.snippet;

      return '<!-- Start of Async Drift Code -->\n' + snippet.trim() + '\n<!-- End of Async Drift Code -->';
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.InstallSnippetContent },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Step,
          { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.FileIcon, icon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_icons_file_code_icon_svg___default.a }) },
          '1. Paste the code below before the </head> tag on every page you want Drift to appear.',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
          'Need some help? Click ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Link, href: 'https://gethelp.drift.com/hc/en-us/articles/360019349154-How-To-Install-Drift-On-Your-Website-Using-Javascript-' },
            'here'
          ),
          ' for more details!',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_InstallSnippetCard__["a" /* default */], { snippet: this.getSnippet() })
        )
      );
    }
  }]);

  return JavaScriptInstaller;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

JavaScriptInstaller.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
JavaScriptInstaller.propTypes = {
  defaultEmbed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var JavaScriptInstallerContainer = Object(__WEBPACK_IMPORTED_MODULE_3_components_container__["a" /* makeDefaultFailedContainer */])(JavaScriptInstaller, {
  listenTo: ['stores.DefaultEmbedStore'],
  fetch: {
    defaultEmbed: function defaultEmbed() {
      return this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (JavaScriptInstallerContainer);

/***/ }),

/***/ "6THR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_immutable__ = __webpack_require__("QRWD");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var endUserMembership = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* receiveEndUserMembership */], function (state, _ref) {
  var payload = _ref.payload;
  return state.set(payload.endUserId, payload.membership);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var byId = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* receiveSegmentList */], function (state, action) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_utils_immutable__["a" /* keyBy */])(action.payload);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var segmentStatus = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* receiveSegmentList */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchSegmentListPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchSegmentListFailed */]), function (state, action) {
  return action.type;
}), false);

var cardinalityByIdSet = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* receiveSegmentSetCardinality */], function (state, _ref2) {
  var _ref2$payload = _ref2.payload,
      segmentSet = _ref2$payload.segmentSet,
      cardinality = _ref2$payload.cardinality;

  return state.set(segmentSet, cardinality);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ endUserMembership: endUserMembership, byId: byId, segmentStatus: segmentStatus, cardinalityByIdSet: cardinalityByIdSet }));

/***/ }),

/***/ "6g2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("p3Di");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var EmailPlaybookSelect = function EmailPlaybookSelect(_ref) {
  var playbookOptions = _ref.playbookOptions,
      onValueChange = _ref.onValueChange,
      selectedPlaybookId = _ref.selectedPlaybookId,
      isLoading = _ref.isLoading;
  return React.createElement(
    'div',
    { className: 'playbook-condition-modal-email-select' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Select"], {
      className: 'playbook-condition-modal-email-select-box',
      options: playbookOptions,
      value: selectedPlaybookId,
      onChange: onValueChange,
      isLoading: isLoading
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailPlaybookSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "6hwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__ = __webpack_require__("O04e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var GateQueries = Marty.createQueries({
  id: 'GateQueries',

  setGate: function setGate(orgId, gateName, value) {
    var _this = this;

    var promise = this.app.sources.GateAPI.setGate(orgId, gateName, value);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__["a" /* default */].SET_GATE_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__["a" /* default */].SET_GATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__["a" /* default */].SET_GATE_FAILED, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (GateQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "6iaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PardotProspectFieldSelect = function (_Component) {
  _inherits(PardotProspectFieldSelect, _Component);

  function PardotProspectFieldSelect(props) {
    var _this2 = this;

    _classCallCheck(this, PardotProspectFieldSelect);

    var _this = _possibleConstructorReturn(this, (PardotProspectFieldSelect.__proto__ || Object.getPrototypeOf(PardotProspectFieldSelect)).call(this, props));

    _this.getInitialState = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var selectedFieldValue, fieldOptions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getSelectedFieldValue();

            case 2:
              selectedFieldValue = _context.sent;
              _context.next = 5;
              return _this.getFieldOptions();

            case 5:
              fieldOptions = _context.sent;


              _this.setState({
                selectedFieldValue: selectedFieldValue,
                fieldOptions: fieldOptions
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.getSelectedFieldValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var getSelectedField, fieldName;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getSelectedField = _this.props.getSelectedField;
              fieldName = void 0;
              _context2.prev = 2;
              _context2.next = 5;
              return getSelectedField();

            case 5:
              fieldName = _context2.sent;
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](2);

              console.warn(_context2.t0);

            case 11:
              return _context2.abrupt('return', fieldName || '');

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 8]]);
    }));
    _this.getFieldOptions = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var fetchFields, data, formatField, options;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fetchFields = _this.props.fetchFields;
              data = void 0;
              _context3.prev = 2;
              _context3.next = 5;
              return fetchFields();

            case 5:
              data = _context3.sent;
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](2);

              console.warn(_context3.t0);

            case 11:
              formatField = function formatField(field) {
                return { label: field.displayName, value: field.name };
              };

              options = data.fields.filter(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["propEq"])('type', 'STRING')).map(formatField);
              return _context3.abrupt('return', options);

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[2, 8]]);
    }));
    _this._saveSelectedValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this$props, onSuccess, setSelectedField, selectedFieldValue;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props = _this.props, onSuccess = _this$props.onSuccess, setSelectedField = _this$props.setSelectedField;
              selectedFieldValue = _this.state.selectedFieldValue;
              _context4.prev = 2;
              _context4.next = 5;
              return setSelectedField(selectedFieldValue);

            case 5:
              onSuccess();
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](2);

              console.warn(_context4.t0);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2, [[2, 8]]);
    }));

    _this.handleSelectChange = function (selectedOption) {
      var newValue = void 0;

      var selectionCleared = !selectedOption;
      if (selectionCleared) {
        newValue = '';
      } else {
        newValue = selectedOption.value;
      }

      _this.setState({
        selectedFieldValue: newValue
      }, _this.saveSelectedValue);
    };

    _this.state = {
      selectedFieldValue: '',
      fieldOptions: []
    };

    _this.saveSelectedValue = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(_this._saveSelectedValue, 1000);
    return _this;
  }

  _createClass(PardotProspectFieldSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInitialState();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedFieldValue = _state.selectedFieldValue,
          fieldOptions = _state.fieldOptions;

      var disabled = !this.props.isEnabled;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Select"], {
        className: 'pardot-prospect-field-select',
        options: fieldOptions,
        value: selectedFieldValue,
        disabled: disabled,
        onChange: this.handleSelectChange
      });
    }
  }]);

  return PardotProspectFieldSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

PardotProspectFieldSelect.propTypes = {
  fetchFields: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getSelectedField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setSelectedField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  isEnabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (PardotProspectFieldSelect);

/***/ }),

/***/ "6k1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Gates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DriftDevIntegrationGates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_store__ = __webpack_require__("Tvnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _this = this;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var Gates = {
  PREMIUM: 'premium_drift',
  PREMIUM_TEAM: 'premium_team',
  PREMIUM_ENTERPRISE: 'premium_enterprise',
  PLAYBOOKS: 'PLAYBOOKS',
  LEGACY_ROUTINGBOT: 'has_legacy_routingbot',
  PLAYBOOKS_DEV: 'has_playbooks_dev',
  MARKETO: 'marketo',
  ELOQUA: 'HAS_ELOQUA',
  PARDOT: 'HAS_PARDOT',
  DEMANDBASE: 'demandbase',
  UNLIMITED_SEATS: 'hasUnlimitedSeats',
  SALESFORCE_EVENTS: 'hasSalesforceEvents',
  KNOWLEDGE_BASE: 'has_grandfathered_knowledgebase',
  STANDARD_APRIL_2018: 'standard_04_2018',
  CLEARBIT_SETTINGS: 'clearbit_settings',
  SAVED_REPLIES: 'saved_replies',
  CALENDAR_DROP: 'calendar_drop',
  CALENDAR_INTEGRATION: 'calendar_integration',
  GRANDFATHERED_CALENDAR_INTEGRATION: 'has_meetings',
  HUBSPOT_INSTALL: 'has_hubspot_install',
  OUTREACH_BETA: 'has_outreach_beta',
  OUTREACH: 'has_outreach',
  HAS_MADKUDU: 'HAS_MADKUDU',
  HAS_PIESYNC: 'HAS_PIESYNC',
  LEANDATA: 'has_leandata',
  STRIPE: 'has_transaction_in_conversation',
  TEAM_VIDEO_LICENSE: 'has_team_video_license',
  ROUTING_API_CUTOVER: 'has_routing_api_cutover'
};

var createDevDriftMap = function createDevDriftMap() {
  var gateMap = {};
  gateMap[__WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["r" /* ELOQUA_APP_ID */]] = 'HAS_ELOQUA';
  gateMap[__WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */]] = 'HAS_PARDOT';
  gateMap[__WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["L" /* PIESYNC_APP_ID */]] = 'HAS_PIESYNC';
  return gateMap;
};

var DriftDevIntegrationGates = createDevDriftMap();

var FEATURE_ACCESS_LEVELS = Object.freeze({
  'READ': 0,
  'WRITE': 1
});

var NO_ARG_ERROR = 'No arguments were provided.';
var ROUTE_BLACK_LIST = {
  org_admin: [],
  user: ['/settings/rules', '/settings/billing', '/settings/team'],
  agent: ['/settings/rules', '/settings/billing', '/settings/team', '/dashboard', '/customize', '/integrations', '/settings/manage-inboxes', '/install', '/routing', '/bot', '/leadbots'],

  member: [] // hidden
};

var GATE_BLACK_LIST = {
  org_admin: [],
  user: ['rules_routing'],
  agent: ['rules_routing'],

  member: [] // hidden
};

var checkGateBlackList = function checkGateBlackList(gate) {
  var availableScopes = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user'], {}).scopes;

  for (var scope in availableScopes) {
    var isBlackListed = _.includes(GATE_BLACK_LIST[availableScopes[scope]], gate);
    if (isBlackListed) {
      return false;
    }
  }

  return true;
};

var checkRouteBlackList = function checkRouteBlackList(location) {
  var state = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState();
  var availableScopes = state.getIn(['currentUser', 'user'], {}).scopes;

  for (var scope in availableScopes) {
    var isBlackListed = _.includes(ROUTE_BLACK_LIST[availableScopes[scope]], location);
    if (isBlackListed) {
      return false;
    }
  }

  return true;
};

var isOwner = function isOwner() {
  var userRole = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user'], {}).role;
  return userRole === 'OWNER';
};

var checkRole = function checkRole(role) {
  var availableRoles = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user'], {}).roles;
  return _.includes(availableRoles, role);
};

var hasAnyRole = function hasAnyRole(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  for (var arg in args) {
    if (checkRole(args[arg])) {
      return true;
    }
  }
  return false;
};

var checkScope = function checkScope(scope) {
  var availableScopes = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user'], {}).scopes;
  return _.includes(availableScopes, scope);
};

var checkScopes = function checkScopes(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  if (!args.length) {
    throw NO_ARG_ERROR;
  }

  for (var arg in args) {
    if (!checkScope(args[arg])) {
      return false;
    }
  }
  return true;
};

var checkAnyScopes = function checkAnyScopes(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  if (!args.length) {
    throw NO_ARG_ERROR;
  }

  for (var arg in args) {
    if (checkScope(args[arg])) {
      return true;
    }
  }
  return false;
};

var checkGate = function checkGate(gate) {
  var gates = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user'], {}).gates || Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  return !!gates.get(gate);
};

var checkGates = function checkGates(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  if (!args.length) {
    throw NO_ARG_ERROR;
  }

  for (var arg in args) {
    if (checkGate(args[arg])) {
      return true;
    }
  }

  return false;
};

var checkAllGates = function checkAllGates() {
  for (var _len = arguments.length, Args = Array(_len), _key = 0; _key < _len; _key++) {
    Args[_key] = arguments[_key];
  }

  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(Args);

  if (!args.length) {
    return true;
  }

  for (var arg in args) {
    if (!checkGate(args[arg])) {
      return false;
    }
  }

  return true;
};

var checkFeature = function checkFeature(feature) {
  if (!feature) {
    return false;
  }

  var featureName = feature.featureName,
      accessLevel = feature.accessLevel;

  var userFeatures = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user', 'features']) || {};

  var featureLevelMap = userFeatures[featureName];

  if (!featureLevelMap) {
    return false;
  }

  var levelsForFeature = Object.keys(featureLevelMap);
  return levelsForFeature.some(function (level) {
    return FEATURE_ACCESS_LEVELS[level] >= FEATURE_ACCESS_LEVELS[accessLevel];
  });
};

var checkFeatures = function checkFeatures(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  for (var arg in args) {
    if (!checkFeature(args[arg])) {
      return false;
    }
  }
  return true;
};

var checkAnyFeatures = function checkAnyFeatures(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  for (var arg in args) {
    if (checkFeature(args[arg])) {
      return true;
    }
  }
  return false;
};

var checkDefaultRole = function checkDefaultRole(roleName) {
  var workspaceRoles = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user', 'workspaceRoles']) || [];

  if (!workspaceRoles || !workspaceRoles.length) {
    return false;
  }

  var defaultRoleNames = workspaceRoles.filter(function (wsRole) {
    return wsRole.role.isGlobal;
  }).map(function (wsRole) {
    return wsRole.role.name;
  });
  return defaultRoleNames.includes(roleName);
};

var checkAnyDefaultRoles = function checkAnyDefaultRoles(Args) {
  var args = Array.isArray(Args[0]) ? Args[0] : [].concat(_toConsumableArray(Args));

  for (var arg in args) {
    if (checkDefaultRole(args[arg])) {
      return true;
    }
  }
  return false;
};

var hasAnyWorkspaceRoles = function hasAnyWorkspaceRoles() {
  var workspaceRoles = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['currentUser', 'user', 'workspaceRoles']) || [];

  return workspaceRoles && workspaceRoles.length > 0;
};

var ACCESS = {};
ACCESS.hasScopes = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return checkScopes(args);
};
ACCESS.hasAnyScope = function () {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return checkAnyScopes(args);
};
ACCESS.hasAnyRole = function () {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return hasAnyRole(args);
};

ACCESS.hasGates = function () {
  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return checkGates(args);
};
ACCESS.hasAllGates = function () {
  for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  return checkAllGates(args);
}, ACCESS.hasNonBlacklistedGate = function () {
  for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  return checkGates(args) && checkGateBlackList(args);
};
ACCESS.hasAccess = function (location) {
  return checkRouteBlackList.call(_this, location);
};

ACCESS.hasFeatures = function () {
  for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  return checkFeatures(args);
};
ACCESS.hasAnyFeature = function () {
  for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  return checkAnyFeatures(args);
};
ACCESS.hasAnyDefaultRole = function () {
  for (var _len10 = arguments.length, args = Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    args[_key10] = arguments[_key10];
  }

  return checkAnyDefaultRoles(args);
}, ACCESS.hasPaidGates = function () {
  return checkGates([Gates.PREMIUM, Gates.PREMIUM_TEAM, Gates.PREMIUM_ENTERPRISE]);
};
ACCESS.isAtLeastProPlan = function () {
  return checkGates([Gates.PREMIUM_TEAM, Gates.PREMIUM_ENTERPRISE]);
};
ACCESS.isCompanyPlan = function () {
  return checkGates([Gates.PREMIUM_ENTERPRISE]);
};
ACCESS.isAdmin = function () {
  return checkScope('org_admin') || checkDefaultRole('Admin');
};
ACCESS.isAgent = function () {
  return checkScope('agent');
};
ACCESS.isUser = function () {
  return checkScope('user');
};
ACCESS.isAccountOwner = function () {
  return isOwner();
};
ACCESS.isCalendarUser = function () {
  return checkGate('has_calendar_user_license');
};
ACCESS.isMultiOrg = function () {
  return checkScope('multi_org');
};
ACCESS.isVideoOnlyUser = function () {
  return checkScope('video') && !checkScope('member') && !checkGate('has_calendar_user_license');
};
ACCESS.isChatUser = function () {
  return !checkScope('org_admin') && checkScope('member') && checkAnyScopes(['convo-ONLY_MINE', 'convo-WITH_NO_PARTICIPANTS', 'convo-ALL']);
};
ACCESS.isPlaybooksUser = function () {
  return checkRole('Playbooks');
};
ACCESS.isVideoAdmin = function () {
  return checkRole('Video Admin') && checkGate(Gates.TEAM_VIDEO_LICENSE);
};
ACCESS.isAnyAdmin = function () {
  return ACCESS.isAdmin() || ACCESS.isVideoAdmin();
};
ACCESS.isRbacUser = function () {
  return checkScope('rbac_user');
};

ACCESS.hasAllOrgIntegrations = function () {
  return ACCESS.isAnyAdmin() || ACCESS.hasFeatures({
    featureName: "org_integrations",
    accessLevel: "READ"
  });
};

/* harmony default export */ __webpack_exports__["c"] = (ACCESS);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "6lcD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* unused harmony default export */ var _unused_webpack_default_export = (function (_ref) {
  var headline = _ref.headline,
      message = _ref.message,
      selectedUser = _ref.selectedUser,
      _ref$isThankYou = _ref.isThankYou,
      isThankYou = _ref$isThankYou === undefined ? false : _ref$isThankYou;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "email-capture-slider-preview-unsubmitted" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "email-capture-slider-preview" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "flex-column flex-1" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "slider-text" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "email-capture-text" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "headline" },
              headline
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "message", dangerouslySetInnerHTML: { __html: message } })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "email-capture-preview-avatar",
              style: { backgroundImage: "url(" + selectedUser.avatarUrl + ")" } })
          )
        ),
        !isThankYou && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "email", placeholder: "name@example.com" })
      )
    )
  );
});

/***/ }),

/***/ "6maG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("qV5s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);






var MINUTE = 60 * 1000;
var HOUR = 60 * MINUTE;

var DelayTime = function DelayTime(_ref) {
  var value = _ref.value,
      onUpdate = _ref.onUpdate,
      unit = _ref.unit,
      pickUnits = _ref.pickUnits,
      delayCopy = _ref.delayCopy;

  var humanizedValue = value / (unit === 'hour' ? HOUR : MINUTE);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'meeting-email-template-modal-delay-editor' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'We\u2019ll send this email'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'delay-time-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: humanizedValue, onChange: function onChange(e) {
          if (e.target.value >= 0) onUpdate(e.target.value * (unit === 'hour' ? HOUR : MINUTE));
        } }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Select"], {
        className: 'units',
        options: [{
          value: 'hour',
          label: Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(humanizedValue, 'Hour', 'Hours')
        }, {
          value: 'minute',
          label: Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(humanizedValue, 'Minute', 'Minutes')
        }],
        value: unit,
        onChange: pickUnits,
        clearable: false,
        searchable: false
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      delayCopy
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('unit', 'setUnit', function (props) {
  return _.isInteger(props.value / HOUR) ? 'hour' : 'minute';
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  pickUnits: function pickUnits(props) {
    return function (_ref2) {
      var value = _ref2.value;

      props.setUnit(value);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (this.props.selectedSettingName !== nextProps.selectedSettingName) {
      nextProps.setUnit(_.isInteger(nextProps.value / HOUR) ? 'hour' : 'minute');
    }
  }
}))(DelayTime));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "6rnP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_InboxStatusEnum__ = __webpack_require__("AnnE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.






var InboxAPI = Marty.createStateSource({
  id: 'InboxAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["i" /* CONVERSATION_API */],

  fetchInboxes: function fetchInboxes() {
    return this.get({
      url: '/inboxes',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  checkInboxExistsForEmail: function checkInboxExistsForEmail(email) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["h" /* serializeObject */])({ address: email });
    return this.get({
      url: '/inboxes?' + queryParams,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchInbox: function fetchInbox(inboxId) {
    return this.get({
      url: '/inboxes/' + inboxId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateInbox: function updateInbox(inboxId, params) {
    return this.patch({
      url: '/inboxes/' + inboxId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(params)
    });
  },
  createInbox: function createInbox(params) {
    return this.post({
      url: '/inboxes',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(params)
    });
  },
  archiveInbox: function archiveInbox(inboxId) {
    return this.patch({
      url: '/inboxes/' + inboxId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify({ status: __WEBPACK_IMPORTED_MODULE_1_constants_InboxStatusEnum__["a" /* default */].ARCHIVED.key })
    });
  },
  fetchInboxMetrics: function fetchInboxMetrics(inboxId, startDate, endDate) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["h" /* serializeObject */])({
      startDate: startDate,
      endDate: endDate
    });
    return this.get({
      url: '/inboxes/' + inboxId + '/metrics?' + queryParams,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchWhiteListLabels: function fetchWhiteListLabels(domain) {
    return this.get({
      url: '/whitelabels/' + domain,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  validateWhiteListLabels: function validateWhiteListLabels(domain) {
    return this.post({
      url: '/whitelabels/' + domain + '/validate',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON
    });
  },
  createWhiteLabelConfiguration: function createWhiteLabelConfiguration(domain) {
    return this.post({
      url: '/whitelabels/' + domain,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (InboxAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "6sJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var ConvoRevealIcon = function ConvoRevealIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "180", height: "291", viewBox: "0 0 180 291", xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "defs",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-25.7%", y: "-25.5%", width: "151.4%", height: "151.1%", filterUnits: "objectBoundingBox",
          id: "a" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "2.546", "in": "SourceGraphic" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-50.6%", y: "-28%", width: "201.2%", height: "156.1%", filterUnits: "objectBoundingBox",
          id: "b" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "1.152", "in": "SourceGraphic" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "c", d: "M.384.361h5.002v5.026H.384V.36z" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "e", d: "M3.59.041v3.362H.245V.041H3.59z" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M76.176 19.192c-3.072 0-5.52-2.24-5.52-5.52 0-3.28 2.448-5.52 5.52-5.52 1.712 0 2.896.656 3.744 1.584a.85.85 0 0 1 .224.592c0 .48-.4.88-.88.88a.861.861 0 0 1-.672-.304 3.185 3.185 0 0 0-2.416-1.088c-2.032 0-3.6 1.616-3.6 3.856 0 2.24 1.568 3.856 3.6 3.856a3.19 3.19 0 0 0 2.432-1.088.88.88 0 0 1 .656-.304c.48 0 .88.4.88.88a.85.85 0 0 1-.224.592c-.848.928-2.016 1.584-3.744 1.584zm5.344 2.192c0-.416.384-.736.8-.736h.08c.528 0 .88-.16 1.104-.672l.384-.88-2.752-6.784a.932.932 0 0 1-.048-.304c0-.464.368-.832.816-.832.352 0 .672.224.784.528l2.08 5.36 2.08-5.36a.843.843 0 0 1 .784-.528c.464 0 .832.368.832.832 0 .112-.032.224-.064.32l-3.296 8.064c-.528 1.312-1.456 1.728-2.656 1.744-.064 0-.144 0-.24-.016a.736.736 0 0 1-.688-.736zM94.048 11.08c1.984 0 3.424 1.568 3.424 4.064 0 2.544-1.456 4.048-3.424 4.048-1.008 0-1.888-.48-2.48-1.248v.304a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V9.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.264c.608-.816 1.504-1.264 2.48-1.264zm-.496 6.624c1.344 0 2.192-1.056 2.192-2.56s-.848-2.576-2.192-2.576c-.784 0-1.616.48-1.984 1.056v3.056c.368.576 1.2 1.024 1.984 1.024zm9.12 1.488c-2.448 0-3.968-1.84-3.968-4.064 0-2.208 1.52-4.048 3.968-4.048 2.48 0 3.984 1.84 3.984 4.048 0 2.224-1.504 4.064-3.984 4.064zm0-1.488c1.44 0 2.24-1.2 2.24-2.576 0-1.36-.8-2.56-2.24-2.56-1.424 0-2.224 1.2-2.224 2.56 0 1.376.8 2.576 2.224 2.576zm8.848-.048c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048zm8 1.44a.85.85 0 0 1-.832-.848v-4.112c0-1.2-.624-1.568-1.568-1.568-.848 0-1.584.512-1.984 1.04v4.64a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V9.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.248c.512-.608 1.52-1.248 2.736-1.248 1.664 0 2.496.864 2.496 2.448v4.72a.854.854 0 0 1-.848.848zm6.64-7.952c.48 0 .688.368.688.784 0 .384-.288.72-.864.8-.576.08-1.424.464-1.76 1.008v4.512a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848v-6.224a.85.85 0 0 1 .832-.848c.464 0 .848.384.848.848v.384c.416-.544.992-1.008 1.488-1.168.192-.064.304-.096.448-.096zm1.456 3.984c0-2.24 1.632-4.048 3.92-4.048 2.32 0 3.808 1.776 3.808 3.824 0 .496-.352.784-.992.784h-4.976c.128 1.168 1.008 2.128 2.464 2.128.56 0 1.216-.176 1.76-.512a.663.663 0 0 1 .368-.096c.368 0 .672.304.672.672a.69.69 0 0 1-.304.56c-.768.512-1.696.752-2.672.752-2.32 0-4.048-1.616-4.048-4.064zm3.92-2.672c-1.44 0-2.096 1.104-2.176 2.048h4.352c-.032-.912-.656-2.048-2.176-2.048zm8.656-1.376c1.712 0 3.216.72 3.216 2.8v4.368a.854.854 0 0 1-.848.848.85.85 0 0 1-.832-.848v-.08c-.576.656-1.472 1.024-2.496 1.024-1.264 0-2.688-.848-2.688-2.56 0-1.776 1.424-2.512 2.688-2.512 1.04 0 1.936.336 2.496.992V13.96c0-.896-.736-1.44-1.808-1.44-.656 0-1.232.176-1.808.576a.724.724 0 0 1-.384.112.676.676 0 0 1-.672-.672c0-.224.128-.432.288-.544.848-.624 1.808-.912 2.848-.912zm-.304 6.96c.736 0 1.456-.272 1.84-.8v-1.168c-.384-.528-1.104-.8-1.84-.8-.944 0-1.648.544-1.648 1.392 0 .832.704 1.376 1.648 1.376zm8.864-.384c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M76.36 35.048a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm2.64-.588c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm5.964 4.836c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm9.048-7.872c1.512 0 2.58 1.2 2.58 3.048 0 1.884-1.068 3.036-2.58 3.036-.816 0-1.512-.42-1.956-1.008v.468a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.7a2.387 2.387 0 0 1 1.956-1.032zm-.228 5.28c1.176 0 1.872-.948 1.872-2.232 0-1.284-.696-2.244-1.872-2.244-.708 0-1.416.432-1.728.936v2.628c.312.504 1.02.912 1.728.912zm6.804.804c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm6.456-.108c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm5.772.816a.45.45 0 0 1-.444-.444v-3.42c0-1.02-.528-1.32-1.308-1.32-.696 0-1.368.432-1.716.9v3.84a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.652c.408-.48 1.2-.984 2.076-.984 1.212 0 1.848.588 1.848 1.848v3.696c0 .24-.204.444-.456.444zm4.74-5.94c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V29.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm6.528-.744c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.224.228c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.808 3.048c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm10.608-5.28c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V29.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08z",
        fill: "#0176FF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M87.23 52.745V60h2.29v-7.255h-2.29zm5.958 3.042c0-.936.585-1.404 1.273-1.404.687 0 1.247.468 1.247 1.638V60H98v-4.213c0-2.106-1.146-3.276-2.75-3.276-.917 0-1.604.533-2.063 1.235l-.076-1.001h-2.253c0 .247.038 1.638.038 1.638V60h2.292v-4.213zm-4.826-4.213c.853 0 1.388-.572 1.388-1.287-.013-.728-.535-1.287-1.362-1.287-.84 0-1.388.56-1.388 1.287 0 .715.535 1.287 1.35 1.287h.012zM80 51.182c-.37.2-.764.342-1.18.4.428-.314.752-.813.902-1.397a3.754 3.754 0 0 1-1.296.613c-.382-.485-.914-.798-1.505-.798-1.134 0-2.048 1.125-2.048 2.521 0 .2.011.4.046.584-1.701-.114-3.206-1.068-4.225-2.592-.173.37-.277.755-.277 1.225 0 .869.358 1.638.914 2.094a1.799 1.799 0 0 1-.926-.313v.028c0 1.225.706 2.25 1.644 2.479a1.75 1.75 0 0 1-.926.042c.254.998 1.018 1.738 1.91 1.753-.695.683-1.586 1.196-2.547 1.196-.162 0-.324-.014-.486-.043.903.713 1.99 1.026 3.148 1.026 3.773 0 5.833-3.846 5.833-7.18v-.327c.394-.356.741-.798 1.019-1.31z",
        fill: "#0176FF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { fill: "#F2F6F8", width: "62", height: "62", rx: "2.4" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M29.891 16.094a14.944 14.944 0 0 1-6.944 12.654l-.042.024c-.245.157-.496.301-.754.445-.054.03-.108.062-.162.09-.077.044-.15.08-.227.116a14.68 14.68 0 0 1-6.74 1.632c-2.498 0-4.844-.62-6.909-1.717l-.12-.066a9.388 9.388 0 0 1-.412-.23 7.006 7.006 0 0 1-.474-.288c-.03-.018-.053-.036-.084-.054A14.97 14.97 0 0 1 .157 16.094C.157 7.837 6.814 1.14 15.022 1.14c8.213 0 14.87 6.697 14.87 14.954",
        fill: "#B4C3D8", filter: "url(#a)", transform: "translate(13.82 15.701)" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M43.71 31.147a14.944 14.944 0 0 1-6.943 12.654l-.042.024c-.245.157-.497.302-.755.446l-.161.09c-.077.043-.15.079-.227.115a14.68 14.68 0 0 1-6.74 1.632c-2.498 0-4.844-.62-6.91-1.717l-.119-.066a9.388 9.388 0 0 1-.413-.23 7.006 7.006 0 0 1-.473-.288c-.03-.018-.053-.036-.084-.054a14.97 14.97 0 0 1-6.866-12.606c0-8.257 6.657-14.954 14.864-14.954 8.214 0 14.87 6.697 14.87 14.954",
        fill: "#4D9EFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M35.83 39.398H22.035a2.367 2.367 0 0 1-2.368-2.353v-7.51a2.367 2.367 0 0 1 2.368-2.354H35.83a2.367 2.367 0 0 1 2.369 2.353v7.511a2.367 2.367 0 0 1-2.369 2.353",
        fill: "#ECF0F5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M33.556 35.185h-9.247c-1.659 0-3.016-1.349-3.016-2.998 0-1.648 1.357-2.997 3.016-2.997h9.247c1.66 0 3.017 1.349 3.017 2.997 0 1.649-1.358 2.998-3.017 2.998",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M26.744 32.187c0 .924-.753 1.672-1.682 1.672-.93 0-1.682-.748-1.682-1.672 0-.923.753-1.671 1.682-1.671.929 0 1.682.748 1.682 1.671M34.486 32.187c0 .924-.753 1.672-1.682 1.672-.93 0-1.683-.748-1.683-1.672 0-.923.753-1.671 1.683-1.671.929 0 1.682.748 1.682 1.671",
        fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M29.076 19.481c.62 0 1.121.499 1.121 1.115s-.502 1.111-1.121 1.111c-.62 0-1.121-.495-1.121-1.111s.501-1.115 1.121-1.115M33.122 26.973v.208h-8.378v-.208c0-.87.71-1.576 1.588-1.576H31.536a1.58 1.58 0 0 1 1.586 1.576",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M29.556 25.537v-5.135c0-.157-.215-.285-.48-.285s-.48.128-.48.285v5.135c0 .158.215.285.48.285s.48-.127.48-.285z",
        fill: "#B4C3D8", fillRule: "nonzero" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M8.897-1.889H3.685a.816.816 0 0 0-.813.814v9.402c0 .447.362.81.809.81h4.377l1.195 1.221c.165.17.453.052.453-.185V-1.079",
        fill: "#B4C3D8", filter: "url(#b)", transform: "rotate(90 15.75 31.763)" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M49.402 19.117a.816.816 0 0 0-.813-.813h-9.403a.809.809 0 0 0-.81.808v4.378l-1.22 1.194a.264.264 0 0 0 .184.453h11.252c.448 0 .81-.362.81-.808v-5.212z",
        fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M45.836 21.506a.581.581 0 1 0 1.162 0 .581.581 0 0 0-1.162 0M43.942 22.087a.58.58 0 1 0-.001-1.161.58.58 0 0 0 .001 1.161zM40.887 21.506a.581.581 0 1 0 1.162 0 .581.581 0 0 0-1.162 0",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(35.883 10.468)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "mask",
          { id: "d", fill: "#fff" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#c" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M3.215.608L3.6 1.922c.032.113.12.2.232.234l1.308.387c.328.097.328.565 0 .662l-1.308.387a.345.345 0 0 0-.232.233L3.215 5.14a.343.343 0 0 1-.66 0l-.384-1.314a.345.345 0 0 0-.233-.233L.631 3.205c-.329-.097-.329-.565 0-.662l1.307-.387a.345.345 0 0 0 .233-.234L2.556.608a.343.343 0 0 1 .659 0",
          fill: "#4D9EFF", mask: "url(#d)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(18.465 48.558)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "mask",
          { id: "f", fill: "#fff" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#e" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M2.138.207l.257.879a.23.23 0 0 0 .156.156l.875.259c.22.064.22.378 0 .443l-.875.258a.23.23 0 0 0-.156.157l-.257.879a.23.23 0 0 1-.44 0l-.259-.88a.23.23 0 0 0-.155-.156L.41 1.944c-.22-.065-.22-.379 0-.443l.875-.259a.23.23 0 0 0 .155-.156l.258-.88a.23.23 0 0 1 .44 0",
          fill: "#B4C3D8", mask: "url(#f)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M14.805 13.435a.93.93 0 0 1-.928.933.93.93 0 0 1-.928-.933.93.93 0 0 1 .928-.932.93.93 0 0 1 .928.932z",
        stroke: "#B4C3D8", strokeWidth: "0.864", strokeLinecap: "round", strokeLinejoin: "round"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M13.934 46.001a.93.93 0 0 1-.928.932.93.93 0 0 1-.928-.932.93.93 0 0 1 .928-.932.93.93 0 0 1 .928.932z",
        stroke: "#4D9EFF", strokeWidth: "0.864", strokeLinecap: "round", strokeLinejoin: "round"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M48.745 34.783a.67.67 0 0 1-.669-.673c0-.371.3-.672.669-.672.37 0 .67.301.67.672a.67.67 0 0 1-.67.673z",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M53.622 14.29l-2.287 2.3", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M53.622 14.29l-2.287 2.3", stroke: "#BAC9DE", strokeWidth: "0.864",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M49.81 13.492l-.235 1.893", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M49.81 13.492l-.235 1.893", stroke: "#BAC9DE", strokeWidth: "0.864",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M54.453 17.846l-2.208.353", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M54.453 17.846l-2.208.353", stroke: "#BAC9DE", strokeWidth: "0.864",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M45.889 42.492c.018-.066.009-.141-.038-.188l-4.74-4.749c-.048-.047-.123-.056-.19-.037a.174.174 0 0 0-.103.16v6.783c0 .066.038.132.104.16a.198.198 0 0 0 .188-.038l1.449-1.46 1.175 2.431a.161.161 0 0 0 .226.076l.762-.387a.162.162 0 0 0 .075-.226l-1.185-2.421h2.117a.174.174 0 0 0 .16-.104z",
        fill: "#384F5B" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M1.356 94.048a.453.453 0 0 1-.456-.444v-7.212a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036C7.896 88.06 9 89.416 9 91.096s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm3.996-2.244c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.556-3.036c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.848-6.204a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V88.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm4.788.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V88.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M1.708 112c-.392 0-.616-.224-.616-.616v-8.106c0-.392.224-.616.616-.616H5.25c1.624 0 2.618.98 2.618 2.38 0 1.176-.784 1.96-1.638 2.142.994.154 1.82 1.176 1.82 2.296 0 1.498-.994 2.52-2.702 2.52h-3.64zm.546-5.292h2.8c1.05 0 1.61-.644 1.61-1.498 0-.84-.56-1.512-1.61-1.512h-2.8v3.01zm0 4.256H5.11c1.092 0 1.736-.616 1.736-1.61 0-.854-.588-1.61-1.736-1.61H2.254v3.22zm10.556 1.204c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm4.774.14a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798zm9.268-.266c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm4.592 1.064c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm8.512-6.16c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V105.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm4.704 8.568a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm14.98-1.582a.586.586 0 0 1-.574-.574v-7.252l-3.094 7.588c-.056.154-.168.238-.322.238a.34.34 0 0 1-.322-.238l-3.08-7.588v7.252a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-7.896c0-.532.434-.98.98-.98.42 0 .77.252.91.616l2.674 6.594 2.688-6.594a.964.964 0 0 1 .91-.616c.546 0 .98.448.98.98v7.896a.58.58 0 0 1-.588.574zm10.458-.826c.014.07.042.154.042.224a.595.595 0 0 1-1.148.224l-.672-1.75h-4.802l-.672 1.75a.565.565 0 0 1-.546.378.595.595 0 0 1-.602-.588.83.83 0 0 1 .056-.238l3.22-7.98c.154-.378.518-.644.952-.644.434 0 .798.266.938.644l3.234 7.98zm-6.174-2.338h4.004l-2.002-5.194-2.002 5.194zm8.106 4.746a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm6.426-5.264v-5.194a.58.58 0 0 1 .588-.574c.322 0 .574.266.574.574v5.166c0 1.708.924 2.786 2.646 2.786s2.646-1.078 2.646-2.786v-5.166a.58.58 0 0 1 .588-.574c.322 0 .574.266.574.574v5.18c0 2.324-1.274 3.808-3.808 3.808s-3.808-1.498-3.808-3.794zm9.604 2.66a.588.588 0 0 1-.21-.434c0-.322.252-.574.56-.574.126 0 .266.042.35.126.63.546 1.484.98 2.562.98 1.666 0 2.198-.896 2.198-1.61 0-1.12-1.134-1.428-2.366-1.764-1.498-.392-3.164-.812-3.164-2.646 0-1.54 1.372-2.59 3.29-2.59 1.176 0 2.072.336 2.884.966a.522.522 0 0 1 .238.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126c-.672-.56-1.498-.812-2.324-.812-1.204 0-2.002.602-2.002 1.484 0 .938 1.078 1.218 2.268 1.54 1.526.406 3.262.882 3.262 2.842 0 1.358-.924 2.744-3.444 2.744-1.372 0-2.45-.448-3.22-1.134z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M.564 135.096c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456H1.512c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm10.524-.744c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V132.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm6.276 0c1.524 0 2.58 1.152 2.58 3.036 0 1.872-1.056 3.048-2.58 3.048-.78 0-1.476-.372-1.956-1.032v2.7a.45.45 0 0 1-.9 0V132.6a.45.45 0 0 1 .9 0v.468a2.423 2.423 0 0 1 1.956-1.008zm-.228 5.28c1.164 0 1.86-.96 1.86-2.244 0-1.284-.696-2.232-1.86-2.232-.708 0-1.416.42-1.728.924v2.616c.312.504 1.02.936 1.728.936zm4.716.708a.453.453 0 0 1-.456-.444v-7.212a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm4.02 2.592c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm5.856-4.836c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932H44.1c-.012-.864-.588-1.932-1.908-1.932zm3.912 2.292c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm4.008 4.656a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.08 156.056a.58.58 0 0 1-.588-.574v-7.28l-1.19 1.26a.508.508 0 0 1-.35.154.502.502 0 0 1-.504-.504c0-.14.056-.266.14-.35l1.904-1.96a.684.684 0 0 1 1.162.476v8.204a.577.577 0 0 1-.574.574zm3.164 1.582a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.384 176.108c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V176.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456H5.472c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.532-.648c.264 0 .456.204.456.456 0 .06-.024.132-.036.18l-2.016 4.824a.689.689 0 0 1-.636.432.697.697 0 0 1-.66-.432l-2.016-4.824c-.012-.06-.036-.12-.036-.18 0-.252.192-.456.444-.456.192 0 .36.12.42.276l1.836 4.536 1.824-4.536a.466.466 0 0 1 .42-.276zm1.26 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm7.212-.744c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V176.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm8.004.096c.252 0 .456.204.456.444v5.004a.45.45 0 0 1-.9 0v-.408c-.444.492-1.188.948-2.064.948-1.212 0-1.848-.588-1.848-1.848V176.6a.45.45 0 0 1 .9 0v3.42c0 1.02.516 1.32 1.296 1.32.708 0 1.38-.408 1.716-.876V176.6a.45.45 0 0 1 .444-.444zm1.92 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M7.616 197.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.9-.056a.608.608 0 0 1-.182-.406c0-.294.252-.532.546-.532.126 0 .252.042.35.126.574.602 1.288.91 2.254.91 1.274 0 2.156-.868 2.156-2.002 0-1.232-.882-2.016-2.142-2.016-.714 0-1.33.21-1.918.686a.62.62 0 0 1-.42.154.672.672 0 0 1-.672-.672v-4.004c0-.392.224-.616.616-.616h4.634c.28 0 .518.238.518.518s-.238.518-.518.518h-4.088v3.248c.448-.448 1.246-.84 2.184-.84 1.554 0 2.968 1.064 2.968 2.982 0 1.904-1.442 3.08-3.318 3.08-1.344 0-2.268-.42-2.968-1.134zm8.512 2.604a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm8.624-5.026c.28 0 .518.224.518.504a.517.517 0 0 1-.518.518h-.854v1.848a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-1.848H20.86a.675.675 0 0 1-.574-1.05l3.696-5.516a1 1 0 0 1 .84-.462c.546 0 1.008.448 1.008 1.008v4.998h.854zm-5.292 0h3.276v-4.872l-3.276 4.872zm6.916-1.274c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.024 269.232c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792H.468a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396H1.98v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm3.684-5.172c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm8.94-5.34a.45.45 0 0 1 .444.444v5.232c0 1.92-1.344 2.52-2.76 2.52-.852 0-1.464-.144-2.1-.66a.416.416 0 0 1-.156-.312.4.4 0 0 1 .396-.396c.084 0 .168.036.228.084.456.384.948.54 1.632.54.96 0 1.86-.468 1.86-1.74v-.816c-.432.588-1.14 1.02-1.944 1.02-1.512 0-2.58-1.128-2.58-3 0-1.86 1.056-3.012 2.58-3.012.78 0 1.476.384 1.944 1.032v-.492c0-.24.204-.444.456-.444zm-2.184 5.124c.72 0 1.416-.444 1.728-.948V265.8c-.312-.504-1.008-.936-1.728-.936-1.164 0-1.86.924-1.86 2.208 0 1.272.696 2.208 1.86 2.208zm4.188.18a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.528 287.104c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424H.546a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462H2.31v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm1.246-2.492c0-1.96 1.4-3.542 3.332-3.542 2.044 0 3.248 1.596 3.248 3.36 0 .336-.224.532-.616.532H5.88c.084 1.274.98 2.338 2.436 2.338.658 0 1.288-.224 1.82-.644a.46.46 0 0 1 .238-.056c.238 0 .434.182.434.42 0 .14-.07.266-.182.35-.672.518-1.47.798-2.408.798-2.002 0-3.444-1.442-3.444-3.556zm3.318-2.674c-1.442 0-2.156 1.218-2.212 2.254h4.438c-.014-1.008-.686-2.254-2.226-2.254zm4.564 2.674c0-2.002 1.358-3.542 3.374-3.542.98 0 1.638.322 2.17.84.084.084.154.21.154.35 0 .266-.21.476-.476.476a.444.444 0 0 1-.308-.126c-.434-.434-.91-.602-1.484-.602-1.442 0-2.338 1.106-2.338 2.604s.896 2.618 2.338 2.618c.574 0 1.05-.168 1.47-.602a.444.444 0 0 1 .322-.126c.266 0 .476.21.476.476 0 .14-.07.28-.154.35-.532.518-1.19.84-2.17.84-2.016 0-3.374-1.54-3.374-3.556zm12.418 3.444a.526.526 0 0 1-.518-.518v-3.99c0-1.19-.616-1.54-1.526-1.54-.812 0-1.596.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v3.094c.476-.56 1.4-1.148 2.422-1.148 1.414 0 2.156.686 2.156 2.156v4.312c0 .28-.238.518-.532.518zm6.09-6.986c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V281.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm7.21 7.098c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm5.586.826a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v8.414c0 .28-.238.518-.518.518zm5.572.112c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm10.472-6.048c.28 0 .518.238.518.518v6.104c0 2.24-1.568 2.94-3.22 2.94-.994 0-1.708-.168-2.45-.77a.486.486 0 0 1-.182-.364c0-.252.21-.462.462-.462.098 0 .196.042.266.098.532.448 1.106.63 1.904.63 1.12 0 2.17-.546 2.17-2.03v-.952c-.504.686-1.33 1.19-2.268 1.19-1.764 0-3.01-1.316-3.01-3.5 0-2.17 1.232-3.514 3.01-3.514.91 0 1.722.448 2.268 1.204v-.574c0-.28.238-.518.532-.518zm-2.548 5.978c.84 0 1.652-.518 2.016-1.106V283.1c-.364-.588-1.176-1.092-2.016-1.092-1.358 0-2.17 1.078-2.17 2.576 0 1.484.812 2.576 2.17 2.576zm4.802 3.094c0-.266.238-.462.504-.462.042 0 .112.014.224.014.462 0 .77-.154 1.008-.714l.448-1.022-2.548-6.16a.52.52 0 0 1 .476-.728c.224 0 .42.14.49.322l2.142 5.278 2.128-5.278a.543.543 0 0 1 .49-.322c.308 0 .532.238.532.532 0 .07-.014.14-.042.21l-3.108 7.448c-.406.98-1.092 1.358-1.988 1.372-.098 0-.196 0-.308-.028-.266-.028-.448-.224-.448-.462zm6.874-.616a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm6.104-2.268a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798zm6.398-2.758c0-1.96 1.4-3.542 3.332-3.542 2.044 0 3.248 1.596 3.248 3.36 0 .336-.224.532-.616.532H82.74c.084 1.274.98 2.338 2.436 2.338.658 0 1.288-.224 1.82-.644a.46.46 0 0 1 .238-.056c.238 0 .434.182.434.42 0 .14-.07.266-.182.35-.672.518-1.47.798-2.408.798-2.002 0-3.444-1.442-3.444-3.556zm3.318-2.674c-1.442 0-2.156 1.218-2.212 2.254h4.438c-.014-1.008-.686-2.254-2.226-2.254zm4.564 2.674c0-2.002 1.358-3.542 3.374-3.542.98 0 1.638.322 2.17.84.084.084.154.21.154.35 0 .266-.21.476-.476.476a.444.444 0 0 1-.308-.126c-.434-.434-.91-.602-1.484-.602-1.442 0-2.338 1.106-2.338 2.604s.896 2.618 2.338 2.618c.574 0 1.05-.168 1.47-.602a.444.444 0 0 1 .322-.126c.266 0 .476.21.476.476 0 .14-.07.28-.154.35-.532.518-1.19.84-2.17.84-2.016 0-3.374-1.54-3.374-3.556zm12.404-3.43c.294 0 .532.238.532.518v5.838c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518v-.476c-.518.574-1.386 1.106-2.408 1.106-1.414 0-2.156-.686-2.156-2.156V281.7c0-.28.238-.518.532-.518.28 0 .518.238.518.518v3.99c0 1.19.602 1.54 1.512 1.54.826 0 1.61-.476 2.002-1.022V281.7c0-.28.238-.518.518-.518zm5.53-.056c.308 0 .476.238.476.504 0 .252-.21.476-.574.518-.616.042-1.442.518-1.75 1.064v4.326c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V281.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.63c.406-.546.966-.994 1.512-1.134.14-.042.224-.07.336-.07zm2.24-1.26a.702.702 0 0 1-.7-.7c0-.392.322-.714.7-.714.392 0 .714.322.714.714 0 .392-.322.7-.714.7zm0 8.19a.526.526 0 0 1-.518-.518V281.7c0-.28.238-.518.532-.518.28 0 .518.238.518.518v5.838c0 .28-.238.518-.532.518zm5.11-.952c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm1.274 3.15c0-.266.238-.462.504-.462.042 0 .112.014.224.014.462 0 .77-.154 1.008-.714l.448-1.022-2.548-6.16a.52.52 0 0 1 .476-.728c.224 0 .42.14.49.322l2.142 5.278 2.128-5.278a.543.543 0 0 1 .49-.322c.308 0 .532.238.532.532 0 .07-.014.14-.042.21l-3.108 7.448c-.406.98-1.092 1.358-1.988 1.372-.098 0-.196 0-.308-.028-.266-.028-.448-.224-.448-.462z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M7.176 220.06c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V220.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm5.952 6.084c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V220.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm3.312 3.036c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.936 7.128c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm11.772-7.824c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V220.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm3.756-.048c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm4.74-6.468a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V220.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm2.016-.588a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684zm5.484-2.364c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456H58.98c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.892-2.856c.252 0 .456.204.456.444v7.212a.45.45 0 0 1-.9 0v-.468a2.44 2.44 0 0 1-1.956 1.008c-1.512 0-2.58-1.152-2.58-3.036 0-1.848 1.056-3.048 2.58-3.048.78 0 1.476.384 1.956 1.032v-2.7a.45.45 0 0 1 .444-.444zm-2.184 7.392c.72 0 1.416-.408 1.74-.912V221.8c-.324-.504-1.02-.936-1.74-.936-1.164 0-1.86.96-1.86 2.244 0 1.284.696 2.232 1.86 2.232z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M7.616 241.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.788.91a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518H9.436zm8.148 0a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm8.428 1.638a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConvoRevealIcon);

/***/ }),

/***/ "6uMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_svg_default_app_icon_svg__ = __webpack_require__("ceBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_svg_default_app_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_svg_default_app_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_integrations_IntegrationCard_styl__ = __webpack_require__("GIkC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_integrations_IntegrationCard_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_components_integrations_IntegrationCard_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Integration_pages_CommonIntegrationPage_api_js__ = __webpack_require__("ew+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var orDefaultIconSrc = function orDefaultIconSrc(src) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["defaultTo"])(__WEBPACK_IMPORTED_MODULE_5_images_svg_default_app_icon_svg___default.a)(src);
};

var Active = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'div',
  { className: 'active-integration' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__("5YaI"), style: { width: 15, height: 15 } }),
  'Connected'
);

var Incomplete = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'div',
  { className: 'incomplete-integration' },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Icon"], { name: 'warning-triangle', style: { width: 15, height: 15 } }),
  'Incomplete'
);

var AnchorLink = function AnchorLink(_ref) {
  var url = _ref.url,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'a',
    { href: url, target: '_blank' },
    children
  );
};

var IntegrationCard = function (_Component) {
  _inherits(IntegrationCard, _Component);

  function IntegrationCard(props) {
    _classCallCheck(this, IntegrationCard);

    var _this = _possibleConstructorReturn(this, (IntegrationCard.__proto__ || Object.getPrototypeOf(IntegrationCard)).call(this, props));

    _this.getIncompleteInstallStatus = function () {
      __WEBPACK_IMPORTED_MODULE_8_components_Integration_pages_CommonIntegrationPage_api_js__["a" /* api */].integrationAPICall(_this.props.incompleteInstallEndpoint).then(function (res) {
        _this.setState({
          isIntegrationStarted: res.installed
        });
      });
    };

    _this.renderDetails = function () {
      var _this$props = _this.props,
          title = _this$props.title,
          description = _this$props.description,
          logoSrc = _this$props.logoSrc,
          isActive = _this$props.isActive,
          hasAccess = _this$props.hasAccess,
          isGatedByPlan = _this$props.isGatedByPlan,
          upgradeRibbonText = _this$props.upgradeRibbonText,
          _this$props$detail = _this$props.detail,
          detail = _this$props$detail === undefined ? 'View Details' : _this$props$detail,
          incompleteInstallEndpoint = _this$props.incompleteInstallEndpoint;
      var isIntegrationStarted = _this.state.isIntegrationStarted;


      var isIncomplete = incompleteInstallEndpoint && (!isActive && isIntegrationStarted || isActive && !isIntegrationStarted);
      var detailComponent = isIncomplete && Incomplete || isActive && Active || (hasAccess ? 'View Details' : detail);
      var ribbonText = !hasAccess && isGatedByPlan ? upgradeRibbonText : false;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6_styles_components_integrations_IntegrationCard_styl___default.a.IntegrationCard, { disabled: !hasAccess }) },
        ribbonText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'upgrade-ribbon' },
          ribbonText
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'logo' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: orDefaultIconSrc(logoSrc) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          { className: 'title dsg-h3' },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'description' },
          description
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'filler' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'detail' },
          detailComponent
        )
      );
    };

    _this.state = {
      isIntegrationStarted: false
    };

    if (props.incompleteInstallEndpoint) {
      _this.getIncompleteInstallStatus();
    }
    return _this;
  }

  _createClass(IntegrationCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          path = _props.path,
          hasAccess = _props.hasAccess,
          gatedUrl = _props.gatedUrl,
          external = _props.external,
          externalUrl = _props.externalUrl;

      var IntegrationLinkType = hasAccess && external ? AnchorLink : hasAccess ? __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */] : AnchorLink;
      var linkProps = hasAccess && external ? { url: externalUrl } : hasAccess ? { to: path } : { url: gatedUrl || '/settings/billing' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        IntegrationLinkType,
        linkProps,
        this.renderDetails()
      );
    }
  }]);

  return IntegrationCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

IntegrationCard.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  logoSrc: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  path: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  external: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (IntegrationCard);

/***/ }),

/***/ "6xuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var SIX_SENSE = function SIX_SENSE() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "71", height: "24", viewBox: "0 0 71 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "70.3485", height: "24", fill: "url(#pattern0)" }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "defs",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "pattern",
        { id: "pattern0", patternContentUnits: "objectBoundingBox", width: "1", height: "1" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { href: "#image0", transform: "scale(0.000378644 0.00110988)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image", { id: "image0", width: "2641", height: "901", href: "data:image/png;base64,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" })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SIX_SENSE);

/***/ }),

/***/ "6y6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("H2ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);




var PremiumOverlay = function PremiumOverlay(_ref) {
  var className = _ref.className,
      style = _ref.style,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('PremiumOverlay', className), style: style },
    children,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'PremiumOverlay__Banner' },
      'Upgrade'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PremiumOverlay);

/***/ }),

/***/ "6y75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var IntegrationBreadcrumb = function (_Component) {
  _inherits(IntegrationBreadcrumb, _Component);

  function IntegrationBreadcrumb() {
    _classCallCheck(this, IntegrationBreadcrumb);

    return _possibleConstructorReturn(this, (IntegrationBreadcrumb.__proto__ || Object.getPrototypeOf(IntegrationBreadcrumb)).apply(this, arguments));
  }

  _createClass(IntegrationBreadcrumb, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backLinkText = _props.backLinkText,
          backLinkUrl = _props.backLinkUrl;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'integration-back' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["A"],
          { href: backLinkUrl },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'down-arrow', width: 15, height: 10, name: 'arrow-1-left' }),
          backLinkText
        )
      );
    }
  }]);

  return IntegrationBreadcrumb;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IntegrationBreadcrumb.defaultProps = {
  backLinkText: '',
  backLinkUrl: ''
};
/* harmony default export */ __webpack_exports__["a"] = (IntegrationBreadcrumb);

/***/ }),

/***/ "6z1Y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "7+AP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/* harmony default export */ __webpack_exports__["a"] = ({
  detailedSameDay: {
    sameDay: 'LT',
    lastDay: '[Yesterday]',
    lastWeek: 'L'
  }
});

/***/ }),

/***/ "7/el":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 35 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.313 19.94h-1.376a.682.682 0 0 1-.687-.675c0-.374.308-.677.688-.677h.687V2.352H6.5v.677a.682.682 0 0 1-.688.677.682.682 0 0 1-.687-.677V1.676c0-.374.308-.676.688-.676h27.5c.379 0 .687.302.687.676v17.589a.682.682 0 0 1-.688.675zM29.875 5.736v17.588a.683.683 0 0 1-.688.677h-27.5A.683.683 0 0 1 1 23.323V5.735c0-.374.308-.677.688-.677h27.5c.379 0 .687.303.687.677zm-1.375.676H2.375v16.236H28.5V6.411zM5.173 16.986c.016-.04.042-.075.065-.112.023-.037.042-.074.073-.106.034-.037.077-.062.119-.09.026-.02.046-.045.077-.06l2.062-1.006a3.788 3.788 0 0 1-.38-1.747l-.002-.013.001-2.03c0-.02.01-.036.012-.055.002-.024-.006-.046 0-.07.007-.044.028-.084.04-.127.002-.004.002-.01.005-.014.306-1.089 1.6-1.76 2.692-1.76h.004c1.092 0 2.383.671 2.689 1.76l.004.014c.012.043.033.083.041.128.005.023-.003.045 0 .069.002.02.011.036.011.056l.002 2.03-.003.012c.009.22.004.968-.376 1.74l2.06 1.014c.033.016.054.043.083.063.039.027.079.051.111.086.032.033.052.072.076.11.022.036.047.068.062.108.018.047.023.096.03.146.005.032.019.06.019.092v.677c0 .746-.617 1.354-1.375 1.354H6.499A1.366 1.366 0 0 1 5.124 17.9v-.677c0-.033.015-.063.02-.096.007-.048.011-.096.03-.142zm1.326.915h6.876v-.258l-2.28-1.122c-.03-.01-.059-.03-.088-.044h-.002v-.001c-.05-.025-.1-.046-.144-.083-.022-.019-.032-.045-.051-.066-.016-.017-.028-.036-.043-.054a.665.665 0 0 1-.09-.157c-.012-.031-.018-.063-.025-.095a.66.66 0 0 1-.02-.141c0-.047.009-.092.018-.138.008-.036.015-.07.029-.105.009-.023.007-.046.018-.068.02-.038.051-.063.076-.095.009-.011.01-.025.02-.036.573-.648.518-1.525.517-1.533 0-.013.005-.025.005-.038l-.002-.014-.002-1.929c-.093-.356-.725-.778-1.374-.778-.65.002-1.281.423-1.374.779l-.001 1.928c0 .005-.003.009-.003.013 0 .013.006.026.005.039-.002.024-.05.89.518 1.533.02.022.026.05.042.073.017.025.041.043.055.07.008.016.006.032.013.048a.636.636 0 0 1 .036.132c.008.042.016.082.016.124a.674.674 0 0 1-.018.128.626.626 0 0 1-.033.123.67.67 0 0 1-.063.109.65.65 0 0 1-.086.109c-.011.012-.017.028-.03.038-.026.023-.057.033-.085.05-.022.014-.037.035-.06.046l-2.37 1.156v.257zm10.314-8.107h8.25c.379 0 .687.303.687.677a.682.682 0 0 1-.688.675h-8.25a.682.682 0 0 1-.687-.675c0-.374.308-.677.688-.677zm0 4.058h4.125c.379 0 .687.304.687.677a.682.682 0 0 1-.688.676h-4.125a.682.682 0 0 1-.687-.676c0-.373.308-.677.688-.677z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "75Yw":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.396 7.396c.478.478 1.252.482 1.735.008l5.39-5.294A1.232 1.232 0 0 0 11.792.353L7.257 4.788 2.853.36A1.232 1.232 0 1 0 1.11 2.103l5.286 5.294z\" fill=\"#E1EEF4\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "7BP3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("dyHG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "7FVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__ = __webpack_require__("lsaV");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ArticleLink = "https://apidocs.helpdocs.io/article/qVqI4u0iqG-managing-api-keys";

var HelpDocs = function (_Component) {
  _inherits(HelpDocs, _Component);

  function HelpDocs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HelpDocs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpDocs.__proto__ || Object.getPrototypeOf(HelpDocs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      key: ''
    }, _this.getConnectionPayload = function () {
      var key = _this.state.key;

      return { key: key };
    }, _this.renderInput = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
          placeholder: 'Enter your HelpDocs API Key',
          label: 'DOCS API KEY',
          valueLink: {
            requestChange: function requestChange(input) {
              _this.setState({ key: input });
            },
            value: _this.state.key
          },
          isValid: !!_this.state.key
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body color-gray-dark' },
          'Need help finding your Docs API key? Here\u2019s ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: ArticleLink },
            ' an article from HelpDocs'
          ),
          '.'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HelpDocs, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Use Drift\u2019s intelligent messaging to answer your visitors questions using your Help Docs knowledge base.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Just plugin your Docs API key and connect.'
        ),
        isConnected ? null : this.renderInput(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__["a" /* default */], {
          integrationId: 'helpdocsio',
          isConnected: isConnected,
          connectionPayload: this.getConnectionPayload() })
      );
    }
  }]);

  return HelpDocs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HelpDocs);

/***/ }),

/***/ "7G/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("uatQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var SectionItem = function SectionItem(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.SectionItem, className) },
    title && React.createElement(
      'span',
      { className: 'title' },
      title
    ),
    description && React.createElement(
      'div',
      { className: 'description' },
      description
    ),
    React.createElement(
      'div',
      { className: 'content' },
      children
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "7IUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchCampaignPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCampaignCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchCampaignFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateCampaignPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateCampaignCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateCampaignFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveCampaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return searchCampaigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return searchCampaignsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return searchCampaignsCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return searchCampaignsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return searchCampaignsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadMoreCampaigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadMoreCampaignsPending; });
/* unused harmony export loadMoreCampaignsCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadMoreCampaignsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadMoreCampaignsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return setDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetDraft; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("7MmB");



var fetchCampaign = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_CAMPAIGN */]);
var fetchCampaignPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_CAMPAIGN_PENDING */]);
var fetchCampaignCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_CAMPAIGN_CANCELLED */]);
var fetchCampaignFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_CAMPAIGN_FAILED */]);

var updateCampaign = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* UPDATE_CAMPAIGN */]);
var updateCampaignPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* UPDATE_CAMPAIGN_PENDING */]);
var updateCampaignCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* UPDATE_CAMPAIGN_CANCELLED */]);
var updateCampaignFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* UPDATE_CAMPAIGN_FAILED */]);

var receiveCampaign = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* RECEIVE_CAMPAIGN */]);

var searchCampaigns = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SEARCH_CAMPAIGNS */]);
var searchCampaignsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SEARCH_CAMPAIGNS_PENDING */]);
var searchCampaignsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SEARCH_CAMPAIGNS_CANCELLED */]);
var searchCampaignsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SEARCH_CAMPAIGNS_FAILED */]);
var searchCampaignsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SEARCH_CAMPAIGNS_SUCCESS */]);

var loadMoreCampaigns = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* LOAD_MORE_CAMPAIGNS */]);
var loadMoreCampaignsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* LOAD_MORE_CAMPAIGNS_PENDING */]);
var loadMoreCampaignsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* LOAD_MORE_CAMPAIGNS_CANCELLED */]);
var loadMoreCampaignsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LOAD_MORE_CAMPAIGNS_FAILED */]);
var loadMoreCampaignsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* LOAD_MORE_CAMPAIGNS_SUCCESS */]);

var setDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SET_DRAFT */]);
var resetDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* RESET_DRAFT */]);

/***/ }),

/***/ "7KbR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ClickThroughAccordion":"ClickThroughAccordion---1UCwF"};

/***/ }),

/***/ "7LNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_Card__ = __webpack_require__("RkbX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("esK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);








var IconSet = function IconSet(_ref) {
  var iconStyle = _ref.iconStyle,
      selectedIconStyle = _ref.selectedIconStyle,
      foregroundColor = _ref.foregroundColor,
      backgroundColor = _ref.backgroundColor,
      onSelection = _ref.onSelection,
      iconPickerConfig = _ref.iconPickerConfig;
  var _iconPickerConfig$ico = iconPickerConfig[iconStyle],
      chatSrc = _iconPickerConfig$ico.chatSrc,
      feedbackSrc = _iconPickerConfig$ico.feedbackSrc,
      announcementSrc = _iconPickerConfig$ico.announcementSrc,
      npsSrc = _iconPickerConfig$ico.npsSrc;

  var selected = iconStyle === selectedIconStyle;
  var customStyle = selected ? { color: '#' + foregroundColor,
    backgroundColor: '#' + backgroundColor } : undefined;
  var handleSelection = selected ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.noop : onSelection;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { onClick: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.partial(handleSelection, iconStyle) },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_shared_Card__["a" /* default */],
      { style: customStyle, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.IconSet, { selected: selected }) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'flex-space-around' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: chatSrc }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: feedbackSrc })
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'flex-space-around' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: announcementSrc }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: npsSrc })
      )
    )
  );
};

var IconPicker = function IconPicker(_ref2) {
  var selectedIconStyle = _ref2.selectedIconStyle,
      foregroundColor = _ref2.foregroundColor,
      backgroundColor = _ref2.backgroundColor,
      onSelection = _ref2.onSelection,
      iconPickerConfig = _ref2.iconPickerConfig;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.IconPicker },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.IconPickerRow },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconSet, { iconStyle: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* IconStyles */].SOLID1,
        selectedIconStyle: selectedIconStyle,
        foregroundColor: foregroundColor,
        backgroundColor: backgroundColor,
        onSelection: onSelection,
        iconPickerConfig: iconPickerConfig
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconSet, {
        iconStyle: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* IconStyles */].SOLID2,
        selectedIconStyle: selectedIconStyle,
        foregroundColor: foregroundColor,
        backgroundColor: backgroundColor,
        onSelection: onSelection,
        iconPickerConfig: iconPickerConfig
      })
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.IconPickerRow },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconSet, {
        iconStyle: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* IconStyles */].OUTLINE1,
        selectedIconStyle: selectedIconStyle,
        foregroundColor: foregroundColor,
        backgroundColor: backgroundColor,
        onSelection: onSelection,
        iconPickerConfig: iconPickerConfig
      }),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconSet, {
        iconStyle: __WEBPACK_IMPORTED_MODULE_5__Constants__["b" /* IconStyles */].OUTLINE2,
        selectedIconStyle: selectedIconStyle,
        foregroundColor: foregroundColor,
        backgroundColor: backgroundColor,
        onSelection: onSelection,
        iconPickerConfig: iconPickerConfig
      })
    )
  );
};

IconPicker.defaultProps = {
  iconPickerConfig: __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* IconPickerConfig */]
};

/* harmony default export */ __webpack_exports__["a"] = (IconPicker);

/***/ }),

/***/ "7MmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CAMPAIGN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CAMPAIGN_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CAMPAIGN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_CAMPAIGN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_CAMPAIGN_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_CAMPAIGN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RECEIVE_CAMPAIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SEARCH_CAMPAIGNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SEARCH_CAMPAIGNS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SEARCH_CAMPAIGNS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SEARCH_CAMPAIGNS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SEARCH_CAMPAIGNS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_MORE_CAMPAIGNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_MORE_CAMPAIGNS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_MORE_CAMPAIGNS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_MORE_CAMPAIGNS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_MORE_CAMPAIGNS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CampaignTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('campaigns');

var FETCH_CAMPAIGN = makeConstant('FETCH_CAMPAIGN');
var FETCH_CAMPAIGN_PENDING = makeConstant('FETCH_CAMPAIGN_PENDING');
var FETCH_CAMPAIGN_CANCELLED = makeConstant('FETCH_CAMPAIGN_CANCELLED');
var FETCH_CAMPAIGN_FAILED = makeConstant('FETCH_CAMPAIGN_FAILED');

var UPDATE_CAMPAIGN = makeConstant('UPDATE_CAMPAIGN');
var UPDATE_CAMPAIGN_PENDING = makeConstant('UPDATE_CAMPAIGN_PENDING');
var UPDATE_CAMPAIGN_CANCELLED = makeConstant('UPDATE_CAMPAIGN_CANCELLED');
var UPDATE_CAMPAIGN_FAILED = makeConstant('UPDATE_CAMPAIGN_FAILED');

var RECEIVE_CAMPAIGN = makeConstant('RECEIVE_CAMPAIGN');

var SEARCH_CAMPAIGNS = makeConstant('SEARCH_CAMPAIGNS');
var SEARCH_CAMPAIGNS_PENDING = makeConstant('SEARCH_CAMPAIGNS_PENDING');
var SEARCH_CAMPAIGNS_CANCELLED = makeConstant('SEARCH_CAMPAIGNS_CANCELLED');
var SEARCH_CAMPAIGNS_FAILED = makeConstant('SEARCH_CAMPAIGNS_FAILED');
var SEARCH_CAMPAIGNS_SUCCESS = makeConstant('SEARCH_CAMPAIGNS_SUCCESS');

var LOAD_MORE_CAMPAIGNS = makeConstant('LOAD_MORE_CAMPAIGNS');
var LOAD_MORE_CAMPAIGNS_PENDING = makeConstant('LOAD_MORE_CAMPAIGNS_PENDING');
var LOAD_MORE_CAMPAIGNS_CANCELLED = makeConstant('LOAD_MORE_CAMPAIGNS_CANCELLED');
var LOAD_MORE_CAMPAIGNS_FAILED = makeConstant('LOAD_MORE_CAMPAIGNS_FAILED');
var LOAD_MORE_CAMPAIGNS_SUCCESS = makeConstant('LOAD_MORE_CAMPAIGNS_SUCCESS');

var SET_DRAFT = makeConstant('SET_DRAFT');
var RESET_DRAFT = makeConstant('RESET_DRAFT');

var CampaignTypes = Object.freeze({
  ANNOUNCEMENT_ONE_TIME: 'ANNOUNCEMENT_ONE_TIME',
  NPS_ONE_TIME: 'NPS_ONE_TIME',
  NPS_RECURRING: 'NPS_RECURRING',
  EMAIL_CAPTURE: 'EMAIL_CAPTURE',
  BOT: 'BOT'
});

/***/ }),

/***/ "7OAZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.942 9.224l-3.438 3.494a.972.972 0 0 1-1.39 0 1.01 1.01 0 0 1 0-1.413l3.438-3.493a3.42 3.42 0 0 0 .985-2.414c0-.912-.35-1.77-.985-2.415-1.27-1.29-3.483-1.29-4.752 0l-5.032 5.11a3.46 3.46 0 0 0 0 4.83c.173.175.364.33.57.466.457.296.59.914.297 1.38a.975.975 0 0 1-1.358.3 5.34 5.34 0 0 1-.9-.736c-2.075-2.108-2.075-5.54 0-7.653l5.033-5.11a5.25 5.25 0 0 1 3.766-1.584 5.25 5.25 0 0 1 3.766 1.585 5.415 5.415 0 0 1 1.56 3.828 5.416 5.416 0 0 1-1.56 3.826zM7.69 20.994l5.03-5.113a3.42 3.42 0 0 0 .986-2.413 3.42 3.42 0 0 0-1.528-2.862 1.01 1.01 0 0 1-.286-1.383.976.976 0 0 1 1.36-.29 5.418 5.418 0 0 1 2.42 4.536 5.414 5.414 0 0 1-1.56 3.825l-5.033 5.113a5.27 5.27 0 0 1-7.533 0c-2.078-2.11-2.078-5.545 0-7.654l3.426-3.482a.972.972 0 0 1 1.39 0 1.01 1.01 0 0 1 0 1.413l-3.426 3.48a3.418 3.418 0 0 0-.984 2.415c0 .913.35 1.77.984 2.415a3.328 3.328 0 0 0 4.752 0z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "7QUA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_USER_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_USER_PROPERTIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_USER_PROPERTIES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_USER_PROPERTIES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_USER_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_EXTENSION_USER_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES; });
/* unused harmony export UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_USER_PROPERTIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_USER_PROPERTIES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_USER_PROPERTIES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_USER_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_USERS_BY_PROPERTY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_USERS_BY_PROPERTY_NAME_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_USERS_BY_PROPERTY_NAME_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_USERS_BY_PROPERTY_NAME_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return USER_AT_CONVERSATION_LIMIT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('user/properties');

var FETCH_USER_PROPERTIES = makeConstant('FETCH_USER_PROPERTIES');
var FETCH_USER_PROPERTIES_PENDING = makeConstant('FETCH_USER_PROPERTIES_PENDING');
var FETCH_USER_PROPERTIES_CANCELLED = makeConstant('FETCH_USER_PROPERTIES_CANCELLED');
var FETCH_USER_PROPERTIES_FAILED = makeConstant('FETCH_USER_PROPERTIES_FAILED');

var UPDATE_USER_PROPERTIES = makeConstant('UPDATE_USER_PROPERTIES');
var UPDATE_EXTENSION_USER_PROPERTIES = makeConstant('UPDATE_EXTENSION_USER_PROPERTIES');
var UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES = makeConstant('UPDATE_CLASSIFICATIONS_NOTIFICATION_PROPERTIES');
var UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES = makeConstant('UPDATE_OUTBOUND_NOTIFICATION_PROPERTIES');
var UPDATE_USER_PROPERTIES_PENDING = makeConstant('UPDATE_USER_PROPERTIES_PENDING');
var UPDATE_USER_PROPERTIES_CANCELLED = makeConstant('UPDATE_USER_PROPERTIES_CANCELLED');
var UPDATE_USER_PROPERTIES_FAILED = makeConstant('UPDATE_USER_PROPERTIES_FAILED');

var RECEIVE_USER_PROPERTIES = makeConstant('RECEIVE_USER_PROPERTIES');

var FETCH_USERS_BY_PROPERTY_NAME = makeConstant('FETCH_USERS_BY_PROPERTY_NAME');
var FETCH_USERS_BY_PROPERTY_NAME_PENDING = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_PENDING');
var FETCH_USERS_BY_PROPERTY_NAME_SUCCESS = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_SUCCESS');
var FETCH_USERS_BY_PROPERTY_NAME_FAILURE = makeConstant('FETCH_USERS_BY_PROPERTY_NAME_FAILURE');

var USER_AT_CONVERSATION_LIMIT = makeConstant('USER_AT_CONVERSATION_LIMIT');

/***/ }),

/***/ "7RA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("OnEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("Cb8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("t+vb");








var fetchBannedIPsEpic = function fetchBannedIPsEpic(action$, _ref) {
  var getState = _ref.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* fetchBannedIPs */].toString()).pluck('payload').filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["a" /* fetchBannedIPsSuccess */])(getState());
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchBannedIPs().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* fetchBannedIPsSuccess */](response.bannedIps);
    }).startWith(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchBannedIPsPending */]();
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* fetchBannedIPsFailed */](error));
    });
  });
};

function banIPEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* banIP */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref2) {
    var ip = _ref2.ip,
        conversationId = _ref2.conversationId;
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].banIP(ip, conversationId).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'This user has been blocked, they can no longer see Drift.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* banIPSuccess */](response.response.bannedIps);
    }).startWith(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* banIPPending */]({ ip: ip });
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'We were unable to block this user. Please try again.',
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* banIPFailed */]({ ip: ip, error: error }));
    });
  });
}

function unbanIPEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* unbanIP */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref3) {
    var ip = _ref3.ip,
        conversationId = _ref3.conversationId;
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].unbanIP(ip, conversationId).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'This user has been unblocked, they can now see Drift.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* unbanIPSuccess */](response.response.bannedIps);
    }).startWith(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* unbanIPPending */]({ ip: ip });
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'We were unable to unblock this user. Please try again.',
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* unbanIPFailed */]({ ip: ip, error: error }));
    });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchBannedIPsEpic, banIPEpic, unbanIPEpic);

/***/ }),

/***/ "7Sbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PROPERTY_ICON_SRC = __webpack_require__("PnwF");

var UserPropertyUpdateEvents = function (_Component) {
  _inherits(UserPropertyUpdateEvents, _Component);

  function UserPropertyUpdateEvents() {
    _classCallCheck(this, UserPropertyUpdateEvents);

    return _possibleConstructorReturn(this, (UserPropertyUpdateEvents.__proto__ || Object.getPrototypeOf(UserPropertyUpdateEvents)).apply(this, arguments));
  }

  _createClass(UserPropertyUpdateEvents, [{
    key: 'render',
    value: function render() {
      var eventProps = _extends({
        iconSrc: PROPERTY_ICON_SRC,
        eventLabel: "updated user properties"
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GenericEvent__["a" /* default */], eventProps);
    }
  }]);

  return UserPropertyUpdateEvents;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UserPropertyUpdateEvents);

/***/ }),

/***/ "7TTE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColoredMail":"ColoredMail---3g8v3","HiddenMail":"HiddenMail---243Ca"};

/***/ }),

/***/ "7U93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolvePasswordErrorMessage; });
var STRENGTH_ERRORS = {
  LENGTH: 'Your password must be between 10 - 72 characters',
  SPECIAL_CHAR: 'Your password must have at least one special character',
  MATCHES_USERNAME: 'Your password cannot be your name',
  ENTROPY: 'Your password must have at least 4 unique characters',
  MATCHES_EMAIL: 'Your password cannot be your email'
};

var resolvePasswordErrorMessage = function resolvePasswordErrorMessage(error) {
  return STRENGTH_ERRORS[error];
};

/***/ }),

/***/ "7Ub3":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 28 27\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"targeting-audience\" transform=\"translate(-642.000000, -361.000000)\" fill=\"#394F5A\"><g id=\"Group-2\" transform=\"translate(546.000000, 330.000000)\"><g id=\"map-location-3\" transform=\"translate(96.000000, 31.000000)\"><path d=\"M27.8494746,26.6049 C27.6862286,26.8524 27.4159074,27 27.1253998,27 L0.875276604,27 C0.584769038,27 0.313570132,26.8524 0.150324189,26.6049 C-0.0120440882,26.3565 -0.04539541,26.0424 0.0625575526,25.7652 L3.56269101,16.7652 C3.69609629,16.4241 4.01732218,16.2 4.37541006,16.2 L7.00051015,16.2 C7.48410431,16.2 7.87554351,16.6032 7.87554351,17.1 C7.87554351,17.5968 7.48410431,18 7.00051015,18 L4.96695718,18 L2.16720149,25.2 L25.8334749,25.2 L23.0328416,18 L21.0001663,18 C20.5165721,18 20.1251329,17.5968 20.1251329,17.1 C20.1251329,16.6032 20.5165721,16.2 21.0001663,16.2 L23.6252664,16.2 C23.9833543,16.2 24.3045801,16.4241 24.4379854,16.7652 L27.9381189,25.7652 C28.0451942,26.0424 28.0118429,26.3565 27.8494746,26.6049 Z M14.5703825,21.3831 C14.4062589,21.5271 14.203518,21.6 13.9998994,21.6 C13.7971585,21.6 13.5944175,21.5271 13.4302939,21.3831 C13.1318874,21.1194 6.12547678,14.8536 6.12547678,8.1387 C6.12547678,3.6513 9.65720622,0 13.9998994,0 C18.3425925,0 21.8751997,3.6513 21.8751997,8.1387 C21.8751997,14.8536 14.8679114,21.1194 14.5703825,21.3831 Z M13.9998994,1.8 C10.6235169,1.8 7.87554351,4.644 7.87554351,8.1387 C7.87554351,13.0005 12.3797273,17.8794 13.9990217,19.476 C15.6183162,17.8776 20.1251329,12.9915 20.1251329,8.1387 C20.1251329,4.644 17.3771595,1.8 13.9998994,1.8 Z M10.4997659,8.1675 C10.4997659,6.1821 12.0699111,4.5675 13.9998994,4.5675 C15.9307654,4.5675 17.5000328,6.1821 17.5000328,8.1675 C17.5000328,10.1529 15.9307654,11.7675 13.9998994,11.7675 C12.0699111,11.7675 10.4997659,10.1529 10.4997659,8.1675 Z M13.9998994,9.9675 C14.9644547,9.9675 15.7499661,9.1602 15.7499661,8.1675 C15.7499661,7.1748 14.9644547,6.3684 13.9998994,6.3684 C13.0353441,6.3684 12.2498327,7.1748 12.2498327,8.1675 C12.2498327,9.1602 13.0353441,9.9675 13.9998994,9.9675 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "7WAT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7X7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEVER_SHOW; });
/* unused harmony export HIDE_INTEGRATION_NOTICE */
var NEVER_SHOW = 'never-show-enable-notifications';
var HIDE_INTEGRATION_NOTICE = 'hide-integration-notice';

/***/ }),

/***/ "7XD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['ENABLED', 'INVITED', 'ARCHIVED']));

/***/ }),

/***/ "7e6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_BotAPI__ = __webpack_require__("3ujL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_BotConstants__ = __webpack_require__("tTLk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BotStore = function (_Marty$Store) {
  _inherits(BotStore, _Marty$Store);

  function BotStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BotStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BotStore.__proto__ || Object.getPrototypeOf(BotStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = false, _this.handlers = {
      botFetched: __WEBPACK_IMPORTED_MODULE_2_constants_BotConstants__["a" /* default */].FETCH_BOT_FINISHED,
      updateBotEnabled: __WEBPACK_IMPORTED_MODULE_2_constants_BotConstants__["a" /* default */].ENABLE_BOT_FINISHED,
      updateBot: __WEBPACK_IMPORTED_MODULE_2_constants_BotConstants__["a" /* default */].UPDATE_BOT_FINISHED,
      updateBotAvatar: __WEBPACK_IMPORTED_MODULE_2_constants_BotConstants__["a" /* default */].UPLOAD_BOT_AVATAR_FINISHED
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BotStore, [{
    key: 'dehydrate',
    value: function dehydrate() {
      if (!this.state) {
        return this.state;
      }
      return this.state.toJS();
    }
  }, {
    key: 'rehydrate',
    value: function rehydrate(dehydratedState) {
      if (!!dehydratedState) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_app_api_BotAPI__["a" /* Bot */])(_extends({}, dehydratedState));
      }
      return dehydratedState;
    }
  }, {
    key: 'getBot',
    value: function getBot() {
      return this.fetch({
        id: 'getBot',
        dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
        locally: function locally() {
          if (!!this.state) {
            return this.state;
          }
        },
        remotely: function remotely() {
          var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
          return this.app.actions.BotActions.fetchBot(orgId);
        }
      });
    }
  }, {
    key: 'botFetched',
    value: function botFetched(bot) {
      this.state = bot;
    }
  }, {
    key: 'updateBotEnabled',
    value: function updateBotEnabled(enabled) {
      this.state = this.state.set("enabled", enabled);
    }
  }, {
    key: 'updateBot',
    value: function updateBot(properties) {
      this.state = this.state.withMutations(function (state) {
        __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(properties, function (value, key) {
          return state.set(key, value);
        });
      });
    }
  }, {
    key: 'updateBotAvatar',
    value: function updateBotAvatar(file) {
      this.state = this.state.set("avatarUrl", file.preview);
    }
  }]);

  return BotStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (BotStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "7hyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IGNORED_ATTRIBUTES; });
var IGNORED_ATTRIBUTES = ['referrer', 'title', 'url', 'createdAt', 'endedAt', 'sessionId'];

/***/ }),

/***/ "7i7C":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hubspot-logo.091fc77b.png";

/***/ }),

/***/ "7rdi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7tSm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Table":"Table---2eJXA","SectionBody":"SectionBody---3tAfm","ViewTimeLine":"ViewTimeLine---22BXS"};

/***/ }),

/***/ "7uC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("UEdl");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* fetchGeolocation */], __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* fetchGeolocationPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* fetchGeolocationSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* fetchGeolocationFailure */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* fetchGeolocationSuccess */], function (state, action) {
  return state.set('data', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(action.payload));
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()));

/***/ }),

/***/ "7vo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);

// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.




var InboxDropdown = React.createClass({
  displayName: 'InboxDropdown',
  propTypes: {
    inboxes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired,
    onClickOutside: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    onSelectInbox: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  },

  clickInbox: function clickInbox(inbox) {
    this.props.onSelectInbox(inbox);
    return this.props.onClickOutside();
  },
  createInboxDropdown: function createInboxDropdown() {
    var _this = this;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'selection-header' },
        'Inboxes'
      ),
      _.map(this.props.inboxes, function (inbox, i) {
        return React.createElement(
          'div',
          { key: i, className: 'row', onClick: _this.clickInbox.bind(_this, inbox) },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
            className: 'mailbox-icon',
            src: __webpack_require__("EETw") }),
          React.createElement(
            'div',
            null,
            inbox.name
          )
        );
      })
    );
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'InboxDropdown', onClick: this.handleOnClick },
      this.createInboxDropdown()
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (InboxDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "7zgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keymirror__);




var constants = __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_2_keymirror___default()({
  CREATE_ORG_STARTED: null,
  CREATE_ORG_FAILED: null,

  FETCH_ORG_STARTED: null,
  FETCH_ORG_FAILED: null,

  UPDATE_ORG_STARTED: null,
  UPDATE_ORG_FAILED: null,

  RECEIVE_ORG: null,

  CHECK_ORG_HANDLE_EXISTENCE_STARTED: null,
  CHECK_ORG_HANDLE_EXISTENCE_FAILED: null,
  RECEIVE_ORG_HANDLE_EXISTENCE: null,

  SET_ORG_HANDLE_UI: null,

  RECEIVE_USER_SCOPES: null,

  RECEIVE_ORG_PROPERTIES: null,

  RECEIVE_ORG_CUTOVER: null,

  SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_STARTED: null,
  SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_COMPLETED: null,
  SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_FAILED: null,

  SEND_INVITATIONS_VIA_EMAIL_STARTED: null,
  SEND_INVITATIONS_VIA_EMAIL_COMPLETED: null,
  SEND_INVITATIONS_VIA_EMAIL_FAILED: null,

  FETCH_END_USER_COUNT: null,
  FETCH_END_USER_COUNT_PENDING: null,
  FETCH_END_USER_COUNT_SUCCESS: null,
  FETCH_END_USER_COUNT_FAILED: null,

  SEND_INVITATIONS_VIA_SLACK_STARTED: null,
  SEND_INVITATIONS_VIA_SLACK_COMPLETED: null,
  SEND_INVITATIONS_VIA_SLACK_FAILED: null,

  TOGGLE_CHILLBOT: null,
  TOGGLE_CHILLBOT_COMPLETED: null,
  TOGGLE_CHILLBOT_FAILED: null,

  PATCH_ORG_PROPERTIES: null,
  PATCH_ORG_PROPERTIES_PENDING: null,
  PATCH_ORG_PROPERTIES_SUCCESS: null,
  PATCH_ORG_PROPERTIES_FAILURE: null,

  HAS_LIMITED_CONTACT_MKT_EMAIL: null,
  HAS_LIMITED_CONTACT_MKT_EMAIL_PENDING: null,
  HAS_LIMITED_CONTACT_MKT_EMAIL_SUCCESS: null,
  HAS_LIMITED_CONTACT_MKT_EMAIL_FAILED: null
}), __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default.a);

/***/ }),

/***/ "8/TF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"endUserAvatar":"endUserAvatar---2ZhvH","placeholderAvatar":"placeholderAvatar---2BOyW"};

/***/ }),

/***/ "8/nX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);


// based on `oxford` from humanize-plus
var Oxford = function Oxford(_ref) {
  var items = _ref.items,
      limit = _ref.limit,
      limitStr = _ref.limitStr,
      _ref$conjunction = _ref.conjunction,
      conjunction = _ref$conjunction === undefined ? 'and' : _ref$conjunction;

  var numItems = items.length;
  if (numItems < 2) return React.createElement(
    'span',
    null,
    items[0]
  );
  if (numItems === 2) return React.createElement(
    'span',
    null,
    items[0],
    ' ',
    conjunction,
    ' ',
    items[1]
  );

  if (!!limit && numItems > limit) {
    var delta = numItems - limit;
    limitStr = !!limitStr ? limitStr : ', ' + conjunction + ' ' + delta + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(delta, 'other');
  } else {
    limitStr = React.createElement(
      'span',
      null,
      ', ',
      conjunction,
      ' ',
      items[numItems - 1]
    );
  }

  var sliceSize = !!limit && numItems > limit ? limit : -1;

  return React.createElement(
    'span',
    null,
    items.slice(1, sliceSize).reduce(function (oxfordArr, displayValue) {
      return oxfordArr.concat([', ', displayValue]);
    }, [items[0]]),
    limitStr
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Oxford);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "80MG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "85Tc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "879Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_reply_ReplyEditDropDown_styl__ = __webpack_require__("rtN9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_reply_ReplyEditDropDown_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_settings_reply_ReplyEditDropDown_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ReplyEditDropDown = function (_Component) {
  _inherits(ReplyEditDropDown, _Component);

  function ReplyEditDropDown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReplyEditDropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReplyEditDropDown.__proto__ || Object.getPrototypeOf(ReplyEditDropDown)).call.apply(_ref, [this].concat(args))), _this), _this.onDeleteClick = function (event) {
      event.stopPropagation();
      _this.props.onDelete(_this.props.replyId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReplyEditDropDown, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components_DropDown__["a" /* default */],
        { className: 'ReplyEditDropDown', onClickOutside: this.props.onClickOutside },
        React.createElement(
          'div',
          { className: 'options', onClick: this.onDeleteClick },
          'Delete'
        )
      );
    }
  }]);

  return ReplyEditDropDown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReplyEditDropDown.propTypes = {
  replyId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onDelete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (ReplyEditDropDown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "87IZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__("jLuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("l8Pp");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _linkTypeToWebLabel;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideCtaButtonModal: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_79" /* hideCtaButtonModal */],
      allChanges: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["m" /* allChanges */]
    }, dispatch)
  };
};

/*
 * takes a string that looks like:
 * rgb(155, 209, 71)
 * and returns a string that looks like:
 * #e1aa00
 */
var rgbStringToHexString = function rgbStringToHexString(rgbString) {
  var hexString = rgbString
  // now we have:
  // "rgb(155, 209, 71)""
  .split(', ')
  // ["rgb(155", "209", "71)"]
  .map(function (val) {
    return val.replace(/(rgb\()?(\))?/g, '');
  })
  // ["155", "209", "71"]
  .map(Number)
  // [155, 209, 71]
  .map(function (i) {
    return i.toString(16);
  })
  // ["9b", "d1", "47"]
  .join('');
  // "9bd147"
  return '#' + hexString;
};

var coerceColor = function coerceColor(colorString) {
  var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#eeeeee';

  if (!colorString) {
    return defaultColor;
  } else if (colorString.startsWith('#')) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__component__["b" /* coerceToValidHex */])(colorString);
  } else if (colorString.startsWith('rgb(')) {
    return rgbStringToHexString(colorString);
  } else {
    return defaultColor;
  }
};

var linkTypeToWebLabel = (_linkTypeToWebLabel = {}, _defineProperty(_linkTypeToWebLabel, __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LinkToTypes */].EMAIL, { label: 'Email', placeholder: 'steve@apple.com' }), _defineProperty(_linkTypeToWebLabel, __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LinkToTypes */].WEB_ADDRESS, { label: 'Web Address (URL)', placeholder: 'https://www.drift.com' }), _linkTypeToWebLabel);

var camelCaseToDashCase = function camelCaseToDashCase(camelStr) {
  return camelStr.replace(/([A-Z])/g, function (g) {
    return '-' + g[0].toLowerCase();
  });
};

var reactStyleToCssStyle = function reactStyleToCssStyle(reactStyle) {
  return _.map(reactStyle, function (val, key) {
    return [camelCaseToDashCase(key), val];
  }).reduce(function (prev, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        styleName = _ref2[0],
        styleVal = _ref2[1];

    return '' + prev + styleName + ':' + styleVal + ';';
  }, '');
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["i" /* withProps */])(function () {
  // attempt to pull the button out of the email content
  var oldBtnContainer = window.tinymce.activeEditor.getBody().querySelector('div[data-drift-bui]');
  var btnContainer = window.tinymce.activeEditor.getBody().querySelector('div[data-drift-cta-container]');
  if (!btnContainer && !oldBtnContainer) return {
    existingBtnFound: false
  };
  var btnElt = !!oldBtnContainer ? oldBtnContainer.children[0] : btnContainer.children[0];
  return {
    existingBtnFound: true,
    initialBtnContainerElt: !!btnContainer ? btnContainer : oldBtnContainer,
    initialBtnStyle: btnElt.style,
    initialBtnContainerStyle: !!btnContainer ? btnContainer.style : oldBtnContainer.style,
    initialBtnCopy: btnElt.innerText,
    initialBtnLink: btnElt.href
  };
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('buttonAlignment', 'setButtonAlignment', function (props) {
  var alignment = _.get(props, 'initialBtnContainerStyle.textAlign', __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* Alignments */][0]);
  return '' + alignment[0].toUpperCase() + alignment.slice(1);
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('buttonWidth', 'setButtonWidth', function (props) {
  return _.get(props, 'initialBtnStyle.width', __WEBPACK_IMPORTED_MODULE_5__constants__["f" /* Widths */]['No Change']);
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('buttonCopy', 'setButtonCopy', function (props) {
  return props.initialBtnCopy || 'Click Me!';
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('linkValue', 'setLinkValue', function (props) {
  return props.initialBtnLink || '';
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('linkToType', 'setLinkToType', function (props) {
  return _.get(props, 'initialBtnLink', '').toLowerCase().startsWith('mailto:') ? __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LinkToTypes */].EMAIL : __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LinkToTypes */].WEB_ADDRESS;
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('borderRadius', 'setBorderRadius', function (props) {
  return _.get(props, 'initialBtnStyle.borderTopRightRadius', '3px').replace('px', '');
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('bgColorHex', 'setBgColorHex', function (props) {
  return coerceColor(_.get(props, 'initialBtnStyle.backgroundColor'));
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('textColorHex', 'setTextColorHex', function (props) {
  return coerceColor(_.get(props, 'initialBtnStyle.color'), '#000000');
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('textSize', 'setTextSize', function (props) {
  return _.get(props, 'initialBtnStyle.fontSize', __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* PixelSizes */][2]);
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('letterSpacing', 'setLetterSpacing', function (props) {
  return _.get(props, 'initialBtnStyle.letterSpacing', __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* SpacingSizes */].Normal);
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('paddingSize', 'setPaddingSize', function (props) {
  return _.get(props, 'initialBtnStyle.paddingRight', __WEBPACK_IMPORTED_MODULE_5__constants__["d" /* PixelSizes */][2]);
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('activeEditTab', 'setActiveEditTab', __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ButtonEditTabs */].CONTENT), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('displayBgColorPicker', 'setDisplayBgColorPicker', false), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('displayTextColorPicker', 'setDisplayTextColorPicker', false), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["i" /* withProps */])(function (props) {
  var previewButtonLink = props.linkValue;
  if (props.linkToType === __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* LinkToTypes */].EMAIL) {
    previewButtonLink = 'mailto:' + previewButtonLink;
  } else {
    var protocolRe = RegExp('^https?:\/\/*');
    if (!protocolRe.test(props.linkValue)) {
      previewButtonLink = 'https://' + previewButtonLink;
    }
  }
  return {
    onContentTabClick: function onContentTabClick() {
      return props.setActiveEditTab(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ButtonEditTabs */].CONTENT);
    },
    onStyleTabClick: function onStyleTabClick() {
      return props.setActiveEditTab(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ButtonEditTabs */].STYLE);
    },
    onSettingsTabClick: function onSettingsTabClick() {
      return props.setActiveEditTab(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* ButtonEditTabs */].SETTINGS);
    },
    previewButtonLink: previewButtonLink,
    urlInputSetup: linkTypeToWebLabel[props.linkToType],
    buttonStyle: {
      borderRadius: props.borderRadius + 'px',
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_4__component__["b" /* coerceToValidHex */])(props.bgColorHex),
      color: props.textColorHex,
      padding: props.paddingSize,
      fontSize: props.textSize,
      letterSpacing: props.letterSpacing,
      width: props.buttonWidth,
      textAlign: 'center',
      display: 'inline-block',
      textDecoration: 'none'
    },
    buttonContainerStyle: { textAlign: props.buttonAlignment }
  };
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["h" /* withHandlers */])({
  hideCtaButtonModal: function hideCtaButtonModal(props) {
    return function () {
      // clear out the state
      props.actions.hideCtaButtonModal();
    };
  },
  onInsert: function onInsert(props) {
    return function () {
      var editor = window.tinymce.activeEditor;
      var buttonStyle = reactStyleToCssStyle(props.buttonStyle);
      var buttonContainerStyle = reactStyleToCssStyle(props.buttonContainerStyle);
      var btn = '<a target="_blank" data-drift-bui href=' + props.previewButtonLink + ' style="' + buttonStyle + '">' + props.buttonCopy + '</a>';

      if (props.existingBtnFound) {
        var wrapperElt = document.createElement('div');
        wrapperElt.style = buttonContainerStyle;
        wrapperElt.classList.add('drift-cta-button');
        wrapperElt.setAttribute('data-drift-cta-container', null);
        wrapperElt.innerHTML = btn;
        editor.dom.replace(wrapperElt, props.initialBtnContainerElt);
      } else {
        var insertedContent = '<div class="mceNonEditable"><div class="drift-cta-button" data-drift-cta-container style="' + buttonContainerStyle + '">' + btn + '</div></div>';
        editor.execCommand('mceInsertContent', false, insertedContent);
      }
      props.actions.allChanges();
      props.actions.hideCtaButtonModal();
    };
  },
  openBgColorPicker: function openBgColorPicker(props) {
    return function () {
      props.setDisplayBgColorPicker(true);
    };
  },
  closeBgColorPicker: function closeBgColorPicker(props) {
    return function () {
      props.setDisplayBgColorPicker(false);
    };
  },
  openTextColorPicker: function openTextColorPicker(props) {
    return function () {
      props.setDisplayTextColorPicker(true);
    };
  },
  closeTextColorPicker: function closeTextColorPicker(props) {
    return function () {
      props.setDisplayTextColorPicker(false);
    };
  }

}))(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* EditorCtaButtonModal */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "87SI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "88BI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "88Th":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+bGlua2VkaW48L3RpdGxlPjxwYXRoIGQ9Ik0xMiAwYzYuNjM5IDAgMTIgNS4zNjEgMTIgMTJTMTguNjQgMjQgMTIgMjQgMCAxOC42NCAwIDEyIDUuMzYxIDAgMTIgMHpNOC41IDE4VjkuNWgtM1YxOGgzek03IDhjMS4yMjIgMCAyLS43NzggMi0xLjc1LS4wMjgtMS0uNzc4LTEuNzUtMi0xLjc1LTEuMTk0IDAtMiAuNzUtMiAxLjc1QzUgNy4yMjIgNS43NzggOCA2Ljk3MiA4SDd6bTEyLjUgMTB2LTQuNUMxOS41IDEwLjc1IDE4LjE0IDkgMTYgOWMtMS4yMjIgMC0yLjExMS43MjItMi41IDEuODA2TDEzLjM4OSA5LjVoLTIuOTcyYy4wMjcuMzMzLjA4MyAyIC4wODMgMlYxOGgzdi00LjVjMC0xLjIyMi41NTYtMiAxLjQ3Mi0yIC45MTcgMCAxLjUyOC40NzIgMS41MjggMlYxOGgzeiIgZmlsbD0iI0I2RDNFMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "89IP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SnippetCard__container":"SnippetCard__container---Oj7Vr","SnippetCard__snippet":"SnippetCard__snippet---2Pxu0"};

/***/ }),

/***/ "8B31":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.444 10.357l8.173 8.204a.8.8 0 0 1-.56 1.36.792.792 0 0 1-.563-.232l-8.173-8.204-8.172 8.204a.792.792 0 0 1-1.122 0 .8.8 0 0 1 0-1.126l8.172-8.203-8.172-8.203a.8.8 0 0 1 0-1.128.79.79 0 0 1 1.122 0L10.32 9.23l8.174-8.204a.792.792 0 0 1 1.123 0 .8.8 0 0 1 0 1.128l-8.173 8.203z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "8BMD":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.825 12.38a.5.5 0 0 1-.65 0C4.003 12.232 0 8.752 0 5.02 0 2.53 2.018.5 4.5.5 6.981.5 9 2.529 9 5.021c0 3.731-4.004 7.212-4.175 7.359zM4.5 1.5C2.57 1.5 1 3.08 1 5.021c0 2.702 2.574 5.412 3.5 6.299.925-.888 3.5-3.603 3.5-6.299C8 3.08 6.43 1.5 4.5 1.5zm0 5.537c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1a1.001 1.001 0 1 0 1-1z\" fill=\"#49626D\" fill-rule=\"nonzero\"></path></svg>"

/***/ }),

/***/ "8COE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8DYL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_withTags__ = __webpack_require__("Zl59");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("Yf0l");




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_1_components_shared_withTags__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["a" /* branch */])(function (_ref) {
  var isTagsByIdLoaded = _ref.isTagsByIdLoaded;
  return !isTagsByIdLoaded;
}, __WEBPACK_IMPORTED_MODULE_0_recompose__["g" /* renderNothing */]))(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),

/***/ "8Eel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Calendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvailabilitySlotTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvailabilitySlot; });
/* unused harmony export Meeting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MeetingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeMeeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return makeMeetingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return processCalendlyMeetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultNewMeetingType; });
/* unused harmony export defaultProfileAccountSettings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var Calendar = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  name: undefined,
  description: undefined
});

var AvailabilitySlotTime = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  hour: 0,
  minutes: 0
});

var AvailabilitySlot = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  dayOfWeek: undefined,
  startTime: AvailabilitySlotTime(),
  endTime: AvailabilitySlotTime()
});

var Meeting = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  allowNewAppointments: true,
  allowMeetingManagement: false,
  availability: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  bufferTime: 0,
  name: '',
  slug: '',
  oldSlug: '', // does not get saved in BE...
  duration: 15,
  inviteDescription: '',
  location: '',
  minimumNoticeTime: 30,
  timezone: undefined
});

var MeetingState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  connected: false,
  scopes: [],
  googleAuthed: false,
  googleAuthedError: false,
  microsoftAuthed: false,
  zoomAuthed: false,
  zoomAuthedError: false,
  isTokenRevoked: false,
  microsoftCalendarAdminError: false,
  fetchMicrosoftAdminConsentStatus: undefined,
  fetchMicrosoftGlobalCalendarStatus: undefined,

  meetingTypes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  meetingTypesStatus: undefined,

  calendlyMeetingTypes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  calendlyMeetingTypesStatus: undefined,

  calendar: Calendar(),
  calendars: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),

  meeting: Meeting(),
  meetingStatus: undefined,

  agentIdsWithConnectedCalendarsStatus: undefined,
  agentIdsWithConnectedCalendars: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),

  calendarStatusFetchStatus: undefined,
  googleCalendarsFetchStatus: undefined,
  microsoftCalendarsFetchStatus: undefined,

  microsoftCalendarAdminManaged: undefined,
  microsoftCalendarAdminIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  shareRoutedCalendarLoading: false
});

var makeMeeting = function makeMeeting(response) {
  return Meeting(_extends({}, response, response.meetingTemplate, {
    availability: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(response.availability.map(function (slot) {
      return AvailabilitySlot({
        dayOfWeek: slot.dayOfWeek,
        startTime: AvailabilitySlotTime({
          hour: slot.startTimeHour,
          minutes: slot.startTimeMinutes
        }),
        endTime: AvailabilitySlotTime({
          hour: slot.endTimeHour,
          minutes: slot.endTimeMinutes
        })
      });
    }))
  }));
};

var makeMeetingTypes = function makeMeetingTypes(response) {
  return _.map(response, function (meetingType, slug) {
    return makeMeeting(_extends({}, meetingType, { slug: slug }));
  });
};

var convertCalendlyMeeting = function convertCalendlyMeeting(calendlyMeeting) {
  var _calendlyMeeting$attr = calendlyMeeting.attributes,
      name = _calendlyMeeting$attr.name,
      duration = _calendlyMeeting$attr.duration,
      slug = _calendlyMeeting$attr.slug,
      location = _calendlyMeeting$attr.location,
      description = _calendlyMeeting$attr.description;

  return Meeting({ name: name, duration: duration, slug: slug, location: location, description: description });
};

var processCalendlyMeetings = function processCalendlyMeetings(calendlyMeetings) {
  return _.map(calendlyMeetings, function (calendlyMeeting) {
    return convertCalendlyMeeting(calendlyMeeting);
  });
};

var defaultNewMeetingType = Meeting({
  name: '',
  allowNewAppointments: true,
  allowMeetingManagement: true,
  duration: 60,
  minimumNoticeTime: 0,
  bufferTime: 0,
  timezone: 'America/New_York',
  availability: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([AvailabilitySlot({
    dayOfWeek: 'WEEKDAYS',
    startTime: AvailabilitySlotTime({
      hour: 9,
      minutes: 0
    }),
    endTime: AvailabilitySlotTime({
      hour: 17,
      minutes: 0
    })
  })])
});

var defaultProfileAccountSettings = Meeting({
  name: 'New Meeting',
  allowNewAppointments: true,
  allowMeetingManagement: true,
  duration: 60,
  minimumNoticeTime: 0,
  bufferTime: 0,
  timezone: 'America/New_York',
  availability: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([AvailabilitySlot({
    dayOfWeek: 'WEEKDAYS',
    startTime: AvailabilitySlotTime({
      hour: 9,
      minutes: 0
    }),
    endTime: AvailabilitySlotTime({
      hour: 17,
      minutes: 0
    })
  })])
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "8NIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GoogleOAuthConnect__ = __webpack_require__("Zmw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MicrosoftOAuthConnect__ = __webpack_require__("dUcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AvailabilitySettings__ = __webpack_require__("JYhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MeetingEmailSettings__ = __webpack_require__("tiT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_meetings_CalendarTabHeader__ = __webpack_require__("ACOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_Section__ = __webpack_require__("r8Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__page__ = __webpack_require__("Ybad");











var CalendarAdvanced = function CalendarAdvanced(_ref) {
  var googleAuthed = _ref.googleAuthed,
      router = _ref.router,
      isGoogleOrMicrosoftConnected = _ref.isGoogleOrMicrosoftConnected,
      isGloballyManagedAndInBeta = _ref.isGloballyManagedAndInBeta,
      calendar = _ref.calendar;

  var CalendarConnector = googleAuthed ? __WEBPACK_IMPORTED_MODULE_1__GoogleOAuthConnect__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__MicrosoftOAuthConnect__["a" /* default */];
  var connected = (isGoogleOrMicrosoftConnected || isGloballyManagedAndInBeta) && !!calendar.id;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_8__page__["a" /* default */],
    { showHeaderBorder: false },
    React.createElement(__WEBPACK_IMPORTED_MODULE_5_components_settings_meetings_CalendarTabHeader__["a" /* default */], { router: router, view: 'CALENDARS' }),
    React.createElement(
      'div',
      { className: 'subsection top' },
      React.createElement(
        'div',
        { className: 'settings-section-header' },
        'Your Availability'
      )
    ),
    React.createElement(
      'p',
      { className: 'settings-body-copy' },
      'Decide when and how people can book time for you. Your Drift Assistant will automatically check your calendar for existing events so you don\u2019t get double booked.'
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_3__AvailabilitySettings__["a" /* default */], null),
    React.createElement(
      'div',
      { className: 'subsection' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4__MeetingEmailSettings__["a" /* default */], null)
    ),
    React.createElement(
      'div',
      { className: 'subsection connected-calendar' },
      React.createElement(
        'div',
        { className: 'settings-section-header' },
        'Your Connected Calendar'
      ),
      React.createElement(
        'p',
        { className: 'settings-body-copy' },
        'We\u2019ll check this calendar for any conflicts when new meetings are being scheduled, and add new calendar events to it.'
      ),
      React.createElement(CalendarConnector, {
        title: 'Your Connected Calendar',
        withDisconnect: true,
        autoSaveSelect: true,
        minimalUI: true,
        disconnectCallback: function disconnectCallback() {
          setTimeout(function () {
            router.replace('/settings/calendar');
          }, 300);
        }
      })
    ),
    React.createElement('hr', { className: 'advanced-calendar-hr' }),
    connected && React.createElement(
      __WEBPACK_IMPORTED_MODULE_6_components_shared_Section__["a" /* SectionItem */],
      {
        title: 'Your Drift Assistant is connected to your calendar',
        description: 'The Drift Assistant helps you close more deals by preparing you for your meetings and sending you reminders for important deals so you never accidentally lose an opportunity again.',
        className: 'assistant-config-footer-section'
      },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_router__["c" /* Link */],
        { to: '/settings2/assistant' },
        'Manage your Drift Assistant'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarAdvanced);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "8NQ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionConfigCQL__ = __webpack_require__("q680");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_calendar_action_svg__ = __webpack_require__("VRwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_calendar_action_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_calendar_action_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_comment_action_svg__ = __webpack_require__("ETAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_comment_action_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_comment_action_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_close_action_svg__ = __webpack_require__("/h/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_close_action_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_close_action_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_bolt_outline_svg__ = __webpack_require__("Z4Hx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_bolt_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_bolt_outline_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("6+Vu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);

















var ActionCard = function ActionCard(_ref) {
  var children = _ref.children,
      isSelected = _ref.isSelected,
      disabled = _ref.disabled,
      title = _ref.title,
      description = _ref.description,
      handleClick = _ref.handleClick,
      iconSrc = _ref.iconSrc;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({ selected: isSelected }, { disabled: disabled }, 'goal-action-choice'),
      onClick: !disabled ? handleClick : null
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { element: 'div', className: 'action-icon', src: iconSrc }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      description
    ),
    children
  );
};

var ConfigureAction = function ConfigureAction(_ref2) {
  var children = _ref2.children,
      handleCancel = _ref2.handleCancel,
      title = _ref2.title,
      description = _ref2.description;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'goal-action-config-wrapper drift-form flex-column' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'goal-action-config-cancel', onClick: handleCancel },
      '< Back to Actions'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'goal-action-config' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'goal-action-cta' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'goal-action-description' },
        description
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        children
      )
    )
  );
};

var GoalActionModal = function GoalActionModal(_ref3) {
  var classificationDetails = _ref3.classificationDetails,
      onCloseClick = _ref3.onCloseClick,
      onCancelClick = _ref3.onCancelClick,
      handleSelectCalendar = _ref3.handleSelectCalendar,
      handleSelectMessage = _ref3.handleSelectMessage,
      handleSelectAutoClose = _ref3.handleSelectAutoClose,
      handleSelectCql = _ref3.handleSelectCql,
      isCalendarSelected = _ref3.isCalendarSelected,
      isMessageSelected = _ref3.isMessageSelected,
      isAutoCloseSelected = _ref3.isAutoCloseSelected,
      isCqlSelected = _ref3.isCqlSelected,
      isLeadBotPlaybook = _ref3.isLeadBotPlaybook,
      disableCalendar = _ref3.disableCalendar,
      disableMessage = _ref3.disableMessage,
      disableAutoClose = _ref3.disableAutoClose,
      hasCalendarAction = _ref3.hasCalendarAction,
      hasAutoCloseAction = _ref3.hasAutoCloseAction,
      onResetViewClick = _ref3.onResetViewClick,
      onConfigureCqlClick = _ref3.onConfigureCqlClick,
      viewMode = _ref3.viewMode;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__PlaybookModal__["a" /* default */],
    {
      title: 'Goal Action',
      description: _.get(classificationDetails, 'label', '...'),
      onCancelClick: onCancelClick,
      cancelLabel: 'Cancel',
      onCloseClick: onCloseClick,
      closeLabel: 'Add',
      showSaveStatus: false,
      contentClassName: __WEBPACK_IMPORTED_MODULE_11__style_styl___default.a.GoalActionModalContent,
      headerClassName: __WEBPACK_IMPORTED_MODULE_11__style_styl___default.a.GoalActionModalHeader
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_11__style_styl___default.a.GoalActionModal },
      viewMode === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["s" /* ActionViewConfig */].CQL && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        ConfigureAction,
        {
          handleCancel: onResetViewClick,
          title: 'How should these leads be marked?',
          description: 'Mark leads as either \u201Cnot qualified\u201D or as a CQL (conversation qualified lead.) You can even indicate CQL quality by assigning more \u26A1\uFE0F.'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ActionConfigCQL__["a" /* default */], { handleSelectCql: handleSelectCql })
      ),
      viewMode === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'goal-action-wrapper drift-form flex-column' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'goal-action-cta' },
          'Select an action to add:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'goal-action-card-wrapper flex' },
          isLeadBotPlaybook && hasCalendarAction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionCard, {
            isSelected: isCalendarSelected,
            disabled: disableCalendar,
            iconSrc: __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_calendar_action_svg___default.a,
            handleClick: handleSelectCalendar,
            title: 'Send Calendar',
            description: 'Send the calendar of the person selected during routing at the end of the conversation to book a meeting.'
          }),
          isLeadBotPlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionCard, {
            isSelected: isMessageSelected,
            disabled: disableMessage,
            handleClick: handleSelectMessage,
            iconSrc: __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_comment_action_svg___default.a,
            title: 'Send Message',
            description: 'Send a closing message from the bot to anyone who hits this goal.'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionCard, {
            isSelected: isCqlSelected,
            handleClick: onConfigureCqlClick,
            iconSrc: __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_bolt_outline_svg___default.a,
            title: 'Mark as CQL',
            description: 'Qualify (or disqualify) leads by marking your best leads as CQLs (or Conversation Qualified Leads).'
          }),
          isLeadBotPlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            ActionCard,
            {
              isSelected: isAutoCloseSelected,
              disabled: !hasAutoCloseAction || disableAutoClose,
              handleClick: handleSelectAutoClose,
              iconSrc: __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_close_action_svg___default.a,
              title: 'Auto Close Conversation',
              description: 'Automatically close the conversation associated with this goal.'
            },
            !hasAutoCloseAction && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { className: 'enterprise-tag', tag: { name: 'Available in Enterprise Plan' } })
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GoalActionModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "8Roc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return integrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wordpressIntegrationDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var integrations = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_0__actions__["n" /* fetchIntegrationStatesPending */], __WEBPACK_IMPORTED_MODULE_0__actions__["V" /* updateIntegrationStatePending */]), function (state, action) {
  return state.set('connectionsStatus', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["m" /* fetchIntegrationStatesFailed */], function (state, action) {
  return state.set('connectionsStatus', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["o" /* fetchIntegrationStatesSuccess */], function (state, action) {
  return state.set('connections', action.payload).set('connectionsStatus', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["W" /* updateIntegrationStateSuccess */], function (state, action) {
  return state.set('connections', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["S" /* setWordpressV2IntegrationSuccess */], function (state, action) {
  return state.set('connections', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* fetchIntegrationEventsSuccess */], function (state, action) {
  return state.setIn(['events', action.payload.integrationType, 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(action.payload.data)).setIn(['events', action.payload.integrationType, 'paginationLink'], action.payload.link).setIn(['events', action.payload.integrationType, 'status'], __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* fetchIntegrationEventsSuccess */].toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["u" /* fetchPaginatedIntegrationEventsSuccess */], function (state, action) {
  var existingEvents = state.getIn(['events', action.payload.integrationType, 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());
  var updatedEvents = action.payload.data.length ? existingEvents.push.apply(existingEvents, _toConsumableArray(action.payload.data)) : existingEvents;

  return state.setIn(['events', action.payload.integrationType, 'data'], updatedEvents).setIn(['events', action.payload.integrationType, 'paginationLink'], action.payload.link).setIn(['events', action.payload.integrationType, 'status'], __WEBPACK_IMPORTED_MODULE_0__actions__["k" /* fetchIntegrationEventsSuccess */].toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["g" /* destroyIntegrationEvents */], function (state, action) {
  return state.removeIn(['events', action.payload]);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* fetchIntegrationEventsPending */], function (state, action) {
  return state.setIn(['events', action.payload.integrationType, 'status'], __WEBPACK_IMPORTED_MODULE_0__actions__["j" /* fetchIntegrationEventsPending */].toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* fetchIntegrationEventsFailed */], function (state, action) {
  return state.setIn(['events', action.payload.integrationType, 'status'], __WEBPACK_IMPORTED_MODULE_0__actions__["i" /* fetchIntegrationEventsFailed */].toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["K" /* postBusinessEventCsvSuccess */], function (state, action) {
  return state.setIn(['events', action.payload.integrationName, 'csvstatus'], __WEBPACK_IMPORTED_MODULE_0__actions__["K" /* postBusinessEventCsvSuccess */].toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["J" /* postBusinessEventCsvFailed */], function (state, action) {
  return state.setIn(['events', action.payload.integrationName, 'csvstatus'], __WEBPACK_IMPORTED_MODULE_0__actions__["J" /* postBusinessEventCsvFailed */].toString());
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_0__actions__["d" /* createAccessTokenSuccess */], __WEBPACK_IMPORTED_MODULE_0__actions__["c" /* createAccessTokenPending */], __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* createAccessTokenFailed */]), function (state, action) {
  return state.setIn(['accessToken', action.payload.integrationName, 'status'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["b" /* createAccessTokenFailed */], function (state, action) {
  return state.setIn(['accessToken', action.payload.integrationName, 'error'], action.payload.err);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_0__actions__["v" /* fetchStripeKeys */], __WEBPACK_IMPORTED_MODULE_0__actions__["w" /* fetchStripeKeysCancelled */], __WEBPACK_IMPORTED_MODULE_0__actions__["x" /* fetchStripeKeysFailed */], __WEBPACK_IMPORTED_MODULE_0__actions__["y" /* fetchStripeKeysPending */], __WEBPACK_IMPORTED_MODULE_0__actions__["z" /* fetchStripeKeysSuccess */]), function (state, action) {
  return state.setIn(['stripeKeys', 'status'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["z" /* fetchStripeKeysSuccess */], function (state, action) {
  return state.setIn(['stripeKeys', 'data'], action.payload);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_0__actions__["p" /* fetchOutreachStatus */], __WEBPACK_IMPORTED_MODULE_0__actions__["q" /* fetchOutreachStatusFailed */], __WEBPACK_IMPORTED_MODULE_0__actions__["r" /* fetchOutreachStatusPending */], __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* fetchOutreachStatusSuccess */]), function (state, action) {
  return state.setIn(['outreachStatus', 'status'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["s" /* fetchOutreachStatusSuccess */], function (state, action) {
  return state.setIn(['outreachStatus', 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(action.payload));
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_0__actions__["F" /* getLeanDataAuthStatusFailed */], __WEBPACK_IMPORTED_MODULE_0__actions__["G" /* getLeanDataAuthStatusPending */]), function (state, action) {
  return state.setIn(['leanDataAuthStatus', 'status'], action.type.toString());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["H" /* getLeanDataAuthStatusSuccess */], function (state, action) {
  return state.setIn(['leanDataAuthStatus', 'status'], action.type.toString()).setIn(['leanDataAuthStatus', 'value'], action.payload.authStatus);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_0__actions__["E" /* getLeanDataAuthStatus */], function (state, action) {
  return state;
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var wordpressIntegrationDomain = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_0__actions__["O" /* setWordpressDomainSuccess */], function (state) {
  return state.setIn(['error'], false);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_0__actions__["L" /* setWordpressDomain */], function (state, action) {
  return state.setIn(['rootUrl'], action.payload.rootUrl).setIn(['error'], false);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_0__actions__["D" /* fetchWordpressDomainSuccess */], function (state, action) {
  return state.setIn(['rootUrl'], action.payload.rootUrl);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_0__actions__["M" /* setWordpressDomainFailed */], function (state, action) {
  return state.setIn(['error'], action.payload.error);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  rootUrl: '',
  error: false
}));

/***/ }),

/***/ "8UUf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);


var DisconnectButton = function DisconnectButton(_ref) {
  var isProcessing = _ref.isProcessing,
      onClick = _ref.onClick;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
    { type: "tertiary", className: "disconnect-integration-button", onClick: onClick, loading: isProcessing },
    "Disconnect"
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DisconnectButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "8VAy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Ziy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MarketoMapping; });
var MarketoMapping = {
  static: false,
  defaultValue: null,
  driftAttribute: null,
  integrationAttribute: null,
  isOverwritable: null
};

/***/ }),

/***/ "8d3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("2ERK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("wpQG");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["d" /* updateHrefs */], function (state, action) {
  return state.mergeIn(['hrefsByMessageId'], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* fetchCard */], function (state, action) {
  return state.setIn(['cardsByHref', action.payload], new __WEBPACK_IMPORTED_MODULE_2__models__["a" /* CardAndStatus */]({
    href: action.payload
  }));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["c" /* fetchCardSuccess */], function (state, action) {
  return state.mergeIn(['cardsByHref', action.payload.href], {
    card: action.payload.card,
    status: 'success'
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["b" /* fetchCardFailure */], function (state, action) {
  return state.setIn(['cardsByHref', action.payload.href, 'status'], 'failure');
}), _handleActions), new __WEBPACK_IMPORTED_MODULE_2__models__["b" /* CardState */]()));

/***/ }),

/***/ "8dTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getParticipants; });
/* unused harmony export typingUsers */
/* unused harmony export typingEndUsers */
/* unused harmony export typingAgents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_models__ = __webpack_require__("TL61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_UserTypes__ = __webpack_require__("p1Ml");







var getParticipants = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2_app_modules_conversation_selectors__["a" /* activeConversation */], function (conversation) {
  if (conversation) {
    return [{ id: conversation.endUserId, type: conversation.endUserType }];
  }
  return [];
});

var root = function root(state) {
  return state.get('typing');
};

var typingUserIds = function typingUserIds(state, conversationId) {
  return root(state).typingUsersByConversationId.get(conversationId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])());
};

var typingUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(typingUserIds, __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["currentUser"], function (typingUsersIds, currentUser) {
  return typingUsersIds.map(function (userTypeAndId) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_models__["b" /* BareUser */])({ type: userTypeAndId.first(), id: userTypeAndId.last() });
  }).filter(function (user) {
    return !(user.id === currentUser.id && user.type === currentUser.type);
  }).toList();
});

var typingEndUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(typingUserIds, __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["currentUser"], function (typingUsersIds, currentUser) {
  return typingUsersIds.map(function (userTypeAndId) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_models__["b" /* BareUser */])({ type: userTypeAndId.first(), id: userTypeAndId.last() });
  }).filter(function (user) {
    return user.type === __WEBPACK_IMPORTED_MODULE_5_utils_UserTypes__["b" /* UserTypes */].END_USER || user.type === __WEBPACK_IMPORTED_MODULE_5_utils_UserTypes__["b" /* UserTypes */].LEAD;
  }).map(function (user) {
    return user.id;
  }).toList();
});

var typingAgents = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(typingUserIds, __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["currentUser"], function (typingUsersIds, currentUser) {
  return typingUsersIds.map(function (userTypeAndId) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_models__["b" /* BareUser */])({ type: userTypeAndId.first(), id: userTypeAndId.last() });
  }).filter(function (user) {
    return user.type === currentUser.type && user.id !== currentUser.id;
  }) // excludes current user
  .map(function (user) {
    return user.id;
  }).toList();
});

/***/ }),

/***/ "8dyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("KNDM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var PlaybookInboxSelect = function PlaybookInboxSelect(_ref) {
  var onSelectChange = _ref.onSelectChange,
      selectedInboxId = _ref.selectedInboxId,
      inboxOptions = _ref.inboxOptions,
      isLoading = _ref.isLoading;

  return React.createElement(
    'div',
    { className: 'playbook-inbox-select' },
    React.createElement(
      'div',
      { className: 'playbook-inbox-select-title' },
      'Target inbox'
    ),
    React.createElement(
      'div',
      { className: 'playbook-inbox-select-description' },
      'We will direct conversations created by this playbook to the selected inbox.'
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Select"], {
      className: 'playbook-inbox-select-box',
      options: inboxOptions,
      value: selectedInboxId,
      onChange: onSelectChange,
      isLoading: isLoading
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PlaybookInboxSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "8dzO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_actions_js__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("b5sd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var makeExportConfig = function makeExportConfig(sourceId, startDate, endDate) {
  var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(startDate).startOf("day");
  var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(endDate).endOf("day");
  var offset = start.unix() - end.unix();
  var recentTime = end.unix() * 1000;
  var timezoneMinutesOffsetFromGMT = __WEBPACK_IMPORTED_MODULE_3_moment___default()().utcOffset();

  return { sourceId: sourceId, start: recentTime, offset: offset, chronoUnit: "seconds", timezone: timezoneMinutesOffsetFromGMT };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      postBusinessCsvRequest: __WEBPACK_IMPORTED_MODULE_4_app_modules_integrations_actions_js__["I" /* postBusinessEventCsv */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('focusedInput', 'updateFocusedInput', null), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('timePeriod', 'setTimePeriod', null), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('startDate', 'setStartDate', __WEBPACK_IMPORTED_MODULE_3_moment___default()()), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('endDate', 'setEndDate', __WEBPACK_IMPORTED_MODULE_3_moment___default()()), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onChangeTimePeriod: function onChangeTimePeriod(_ref) {
    var setTimePeriod = _ref.setTimePeriod;
    return function (period) {
      setTimePeriod(period);
    };
  },
  onDatePickerFocus: function onDatePickerFocus(_ref2) {
    var updateFocusedInput = _ref2.updateFocusedInput;
    return function (type) {
      updateFocusedInput(type);
    };
  },
  onDateChange: function onDateChange(props) {
    return function (timePeriod) {
      props.setStartDate(timePeriod.startDate);
      props.setEndDate(timePeriod.endDate);
    };
  },

  onClickExportButton: function onClickExportButton(props) {
    return function () {
      props.actions.postBusinessCsvRequest(_extends({}, makeExportConfig(props.sourceId, props.startDate.format('YYYY-MM-DD'), props.endDate.format('YYYY-MM-DD'), props.timePeriod)));
      setTimeout(props.onClose, 800);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  if (!!props.endDate && props.endDate.diff(props.startDate, 'days') < 0) {
    return {
      disabledReason: 'End date must be after start date'
    };
  }
  return {
    disabledReason: ''
  };
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "8ejE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("tp7+");




var api = {
  fetchInbox: function fetchInbox(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/inboxes/' + id).checkStatus().retryWithBackoff().map(function (_ref) {
      var response = _ref.response;
      return Object(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Inbox */])(response);
    });
  },
  patchInbox: function patchInbox(_ref2) {
    var id = _ref2.id,
        name = _ref2.name,
        address = _ref2.address;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/inboxes/' + id, {
      name: name,
      address: address
    }).checkStatus().retryWithBackoff().map(function (_ref3) {
      var response = _ref3.response;
      return Object(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Inbox */])(response);
    });
  },
  fetchInboxList: function fetchInboxList() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/inboxes').checkStatus().retryWithBackoff().map(function (_ref4) {
      var response = _ref4.response;
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(response).map(function (data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Inbox */])(data);
      });
    });
  },
  bulkCloseForInbox: function bulkCloseForInbox(inboxId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/bulk_close/bulk_close_inbox_admin?inboxId=' + inboxId).checkStatus();
  },
  fetchCounts: function fetchCounts(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/inboxes/' + id + '/conversations/counts').checkStatus().retryWithBackoff(3, function (count) {
      return Math.pow(2, count) * 1000;
    }, [403, 404]).mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchCounts2: function fetchCounts2(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/inboxes/' + id + '/conversations/counts/v2').checkStatus().retryWithBackoff(3, function (count) {
      return Math.pow(2, count) * 1000;
    }, [403, 404]).mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchSendingDomains: function fetchSendingDomains() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxEmailApi"].get('/sending_domains').checkStatus().retryWithBackoff().map(function (_ref5) {
      var response = _ref5.response;
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(response).map(function (data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* SendingDomain */])(data);
      });
    });
  },
  fetchWhitelabel: function fetchWhitelabel(domain) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/whitelabels/' + domain).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  verifyWhitelabel: function verifyWhitelabel(domain) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/whitelabels/' + domain + '/validate').checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  createWhitelabel: function createWhitelabel(domain) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/whitelabels/' + domain).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  createInbox: function createInbox(params) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/inboxes', params).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  archiveInbox: function archiveInbox(_ref6) {
    var id = _ref6.id;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/inboxes/' + id, {
      status: 'ARCHIVED'
    }).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  }
};

/***/ }),

/***/ "8fh2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return profileUI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("sAia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("9Gfy");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ignoreUndefined = function ignoreUndefined(prev, next) {
  return typeof next !== 'undefined' ? next : prev;
};

var profile = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["fetchCurrentProfileStarted"], __WEBPACK_IMPORTED_MODULE_3__actions__["fetchCurrentProfileFailed"], __WEBPACK_IMPORTED_MODULE_3__actions__["receiveProfile"]), function (state, action) {
  return state.setIn(['status', 'fetch'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["updateProfileStarted"], __WEBPACK_IMPORTED_MODULE_3__actions__["updateProfileFailed"], __WEBPACK_IMPORTED_MODULE_3__actions__["updateProfileSuccess"]), function (state, action) {
  return state.setIn(['status', 'update'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["receiveProfile"], function (state, action) {
  var _action$payload = action.payload,
      profile = _action$payload.profile,
      visibility = _action$payload.visibility;

  return state.updateIn(['data'], Object(__WEBPACK_IMPORTED_MODULE_2__models__["d" /* Profile */])(), function (data) {
    return data.mergeWith(ignoreUndefined, profile);
  }).set('visibility', visibility);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["setVisibilityStarted"], function (state, action) {
  return state.set('visibility', action.payload);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var profileUI = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["setProfileUI"], function (state, action) {
  return state.updateIn(['data'], Object(__WEBPACK_IMPORTED_MODULE_2__models__["d" /* Profile */])(), function (data) {
    return data.mergeWith(ignoreUndefined, action.payload);
  });
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["setProfileUIData"], function (state, action) {
  var _action$payload2 = action.payload,
      key = _action$payload2.key,
      value = _action$payload2.value;

  return state.setIn(['data', key], value);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["checkUserHandleExistenceStarted"], __WEBPACK_IMPORTED_MODULE_3__actions__["receiveUserHandleExistence"], __WEBPACK_IMPORTED_MODULE_3__actions__["receiveUserGlobalHandleExistence"]), function (state, action) {
  return state.setIn(['handle', 'status'], action.type);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["receiveUserHandleExistence"], function (state, action) {
  return state.setIn(['valid', 'handle'], action.payload.valid);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["receiveUserGlobalHandleExistence"], function (state, action) {
  return state.setIn(['valid', 'globalHandle'], action.payload.valid);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["uploadCoverPhotoStarted"], function (state, action) {
  var oldCoverPhoto = state.getIn(['data', 'coverPhotoUrl']);
  return state.setIn(['data', 'coverPhotoUrl'], action.payload.file.preview).setIn(['coverPhotoUpload', 'pending'], true).setIn(['coverPhotoUpload', 'previousCoverPhoto'], oldCoverPhoto).deleteIn(['coverPhotoUpload', 'error']);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["clearCoverPhoto"], function (state) {
  return state.setIn(['data', 'coverPhotoUrl'], undefined);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["uploadCoverPhotoSuccess"], function (state, action) {
  return state.setIn(['data', 'coverPhotoUrl'], action.payload.url).setIn(['coverPhotoUpload', 'pending'], false).deleteIn(['coverPhotoUpload', 'error']);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["uploadCoverPhotoFailed"], function (state, action) {
  var previousCoverPhoto = state.getIn(['coverPhotoUpload', 'previousCoverPhoto']);
  return state.setIn(['data', 'coverPhotoUrl'], previousCoverPhoto).setIn(['coverPhotoUpload', 'pending'], false).setIn(['coverPhotoUpload', 'error'], action.payload);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({ coverPhotoUpload: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])() }));

/***/ }),

/***/ "8g3x":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1 1)\" fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#FFF\" stroke-width=\".778\" fill=\"#E6314F\" cx=\"8\" cy=\"8\" r=\"8\"></circle><g fill=\"#FFF\" fill-rule=\"nonzero\"><path d=\"M8.21 3.386c.298-.479.966-.108.804.445L8.024 7H9.84c.375 0 .588.48.36.812l-3.374 4.933c-.316.461-.967.062-.786-.482l1.077-3.307H5.605c-.366 0-.582-.46-.373-.794L8.21 3.386z\"></path><path d=\"M8.582 3.674L5.605 8.45h2.183l-1.323 3.988L9.84 7.505H7.457z\"></path></g></g></svg>"

/***/ }),

/***/ "8hLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["a"] = pickObjects;
/**
 * Give an Id to Object map and a list of ids, return all matched objects only if all are matched
 * @param objectById
 * @param ids
 * @returns {*}
 */
function pickObjects(objectById, ids) {
  var allIdsAreInObject = _.every(ids, function (id) {
    return parseInt(id) === 0 || !!objectById[id];
  });
  if (allIdsAreInObject) {
    return _.pick(objectById, ids);
  } else {
    return undefined;
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "8hab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


/**
 * Thunk decorator for thunks that return promises.
 *
 * It takes a thunk and returns a thunk that memoizes the returned promise until it resolves.
 * The main advantage of this is that other thunks can call thunks they depend on without need
 * for explicit coordination.
 *
 * This is particularly useful for idempotent actions (e.g. join conversation, fetch a token, etc).
 */

var _promiseMap = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();

var memoize = function memoize(thunk) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return function (dispatch) {
      var key = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([thunk].concat(args));

      var existingPromise = _promiseMap.get(key);
      if (existingPromise) {
        return existingPromise;
      }

      var promise = dispatch(thunk.apply(undefined, args));
      _promiseMap = _promiseMap.set(key, promise);

      promise.then(function () {
        _promiseMap = _promiseMap.delete(key);
      }).catch(function () {
        _promiseMap = _promiseMap.delete(key);
      });

      return promise;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (memoize);

/***/ }),

/***/ "8pQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SFDC_containers_UserMapping__ = __webpack_require__("e7xn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("SrDK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);








var SalesforceUserMapping = function SalesforceUserMapping() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { className: "common-integration-page-layout" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
      backLinkText: "Salesforce integration",
      backLinkUrl: "/settings/setup/salesforce"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "header",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h2",
        { className: "integration-header" },
        "Mapped Salesforce users"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "p",
        null,
        "Drift automatically maps Salesforce users to Drift teammates when the user email in Salesforce matches the teammate email in Drift. You can override this by adding a mapping below."
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { className: "salesforce-mapping-description" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "h3",
        { className: "integration-header" },
        "Use these mappings to:"
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "salesforce-mapping-reason" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 20, name: "user" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Route conversations to an identified contact's Salesforce account, contact, or lead owner. Just add a",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: "/settings/rules" },
              " conversation routing rule."
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "salesforce-mapping-reason" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 20, name: "team-2" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Set the lead owner for new Drift leads that are created in Salesforce. You can set that up in your",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: "/settings/salesforce/config" },
              " synced Salesforce data."
            )
          )
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SFDC_containers_UserMapping__["a" /* default */], { onChange: function onChange() {} })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SalesforceUserMapping);

/***/ }),

/***/ "8sd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconPickerConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymirror__);
var _IconStyles$SOLID, _IconStyles$SOLID2, _IconStyles$OUTLINE, _IconStyles$OUTLINE2, _IconPickerConfig;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var IconStyles = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  SOLID1: null,
  SOLID2: null,
  OUTLINE1: null,
  OUTLINE2: null
});

var IconTypes = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  chatSrc: null,
  feedbackSrc: null,
  announcementSrc: null,
  npsSrc: null,
  dismiss: null
});

var IconPickerConfig = (_IconPickerConfig = {}, _defineProperty(_IconPickerConfig, IconStyles.SOLID1, (_IconStyles$SOLID = {}, _defineProperty(_IconStyles$SOLID, IconTypes.chatSrc, __webpack_require__("YlRO")), _defineProperty(_IconStyles$SOLID, IconTypes.feedbackSrc, __webpack_require__("Q5Ik")), _defineProperty(_IconStyles$SOLID, IconTypes.announcementSrc, __webpack_require__("wL4R")), _defineProperty(_IconStyles$SOLID, IconTypes.npsSrc, __webpack_require__("Ai5H")), _IconStyles$SOLID)), _defineProperty(_IconPickerConfig, IconStyles.SOLID2, (_IconStyles$SOLID2 = {}, _defineProperty(_IconStyles$SOLID2, IconTypes.chatSrc, __webpack_require__("a1ge")), _defineProperty(_IconStyles$SOLID2, IconTypes.feedbackSrc, __webpack_require__("uHcq")), _defineProperty(_IconStyles$SOLID2, IconTypes.announcementSrc, __webpack_require__("hmRH")), _defineProperty(_IconStyles$SOLID2, IconTypes.npsSrc, __webpack_require__("ZDAe")), _IconStyles$SOLID2)), _defineProperty(_IconPickerConfig, IconStyles.OUTLINE1, (_IconStyles$OUTLINE = {}, _defineProperty(_IconStyles$OUTLINE, IconTypes.chatSrc, __webpack_require__("5MaG")), _defineProperty(_IconStyles$OUTLINE, IconTypes.feedbackSrc, __webpack_require__("1cd8")), _defineProperty(_IconStyles$OUTLINE, IconTypes.announcementSrc, __webpack_require__("zo08")), _defineProperty(_IconStyles$OUTLINE, IconTypes.npsSrc, __webpack_require__("bOG0")), _IconStyles$OUTLINE)), _defineProperty(_IconPickerConfig, IconStyles.OUTLINE2, (_IconStyles$OUTLINE2 = {}, _defineProperty(_IconStyles$OUTLINE2, IconTypes.chatSrc, __webpack_require__("ynYZ")), _defineProperty(_IconStyles$OUTLINE2, IconTypes.feedbackSrc, __webpack_require__("mvSl")), _defineProperty(_IconStyles$OUTLINE2, IconTypes.announcementSrc, __webpack_require__("slDV")), _defineProperty(_IconStyles$OUTLINE2, IconTypes.npsSrc, __webpack_require__("Clx7")), _IconStyles$OUTLINE2)), _IconPickerConfig);

/***/ }),

/***/ "8tbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("WpOi");



var api = {
  upload: function upload(file) {
    var data = new FormData();
    data.append('file', file);
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/csvimport', data, { file: true }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_1__models__["b" /* parseCsvImport */]);
  },
  start: function start(id, mapping, createSegment, csvName) {
    var name = csvName ? encodeURIComponent(csvName) : '';

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/csvimport/' + id + '/start' + (createSegment ? '?csvName=' + name + '&createSegment=true' : ''), mapping).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_1__models__["b" /* parseCsvImport */]);
  }
};

/***/ }),

/***/ "8uTn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__ = __webpack_require__("4PhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_DriftAPI__ = __webpack_require__("f9kp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OnCallModal__ = __webpack_require__("K5FN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OptInModal__ = __webpack_require__("s15K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AdvancedRoutingOptInModal__ = __webpack_require__("WjK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_SFDC_containers_MappedUsers__ = __webpack_require__("prel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__ = __webpack_require__("gBvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_TetheredToolTip__ = __webpack_require__("XA3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_tracking__ = __webpack_require__("jAlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_settings_Rules_constants_regions__ = __webpack_require__("zrFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_settings_Rules_constants_continents__ = __webpack_require__("cTDj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_styl__ = __webpack_require__("47rT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_pencil_svg__ = __webpack_require__("pDST");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__svg_inline_removeTags_true_images_svg_new_item_svg__ = __webpack_require__("iOLK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__svg_inline_removeTags_true_images_svg_new_item_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__svg_inline_removeTags_true_images_svg_new_item_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__svg_inline_removeTags_true_images_svg_delete_svg__ = __webpack_require__("fZJU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__svg_inline_removeTags_true_images_svg_delete_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__svg_inline_removeTags_true_images_svg_delete_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__svg_inline_images_svg_rules_chat_svg__ = __webpack_require__("TSnc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__svg_inline_images_svg_rules_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__svg_inline_images_svg_rules_chat_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__svg_inline_images_svg_rules_blank_table_svg__ = __webpack_require__("mws/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__svg_inline_images_svg_rules_blank_table_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__svg_inline_images_svg_rules_blank_table_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__svg_inline_removeTags_true_images_svg_cql_bolt_svg__ = __webpack_require__("FZ6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__svg_inline_removeTags_true_images_svg_cql_bolt_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



































var TOTAL_AVATARS = 4;

var RulesHomeLayout = function (_Component) {
  _inherits(RulesHomeLayout, _Component);

  function RulesHomeLayout(props) {
    _classCallCheck(this, RulesHomeLayout);

    var _this = _possibleConstructorReturn(this, (RulesHomeLayout.__proto__ || Object.getPrototypeOf(RulesHomeLayout)).call(this, props));

    _this.openOptInModal = function () {
      _this.setState({ optInModalOpen: true });
    };

    _this.closeOptInModal = function () {
      _this.setState({ optInModalOpen: false });

      _this.context.app.actions.NotificationActions.pushNotification({
        content: 'You successfully updated your Lead Routing \uD83C\uDF89',
        variant: 'green',
        displayTime: 1500
      });
    };

    _this.openAdvancedRoutingOptInModal = function () {
      _this.setState({ advancedRoutingOptInModalOpen: true });
    };

    _this.closeAdvancedRoutingOptInModal = function () {
      _this.setState({ advancedRoutingOptInModalOpen: false });
    };

    _this.openOnCallModal = function () {
      _this.setState({ onCallModalOpen: true });
    };

    _this.closeOnCallModal = function () {
      _this.setState({ onCallModalOpen: false });
    };

    _this.fetchRules = function () {
      __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].fetchRules().then(function (resp) {
        _this.setState({
          order: _.range(resp.rules.length),
          count: resp.rules.length
        });

        _this.props.actions.fetchRulesSuccess(resp);
      });
    };

    _this.notifyDelete = function (rule) {
      _this.context.app.actions.NotificationActions.pushNotification({
        content: 'You successfully deleted a rule',
        variant: 'gray',
        displayTime: 5000,
        undoAction: function undoAction() {
          return __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].undoDeleteRule(rule.id).then(_this.fetchRules);
        }
      });
    };

    _this.deleteRule = function (rule) {
      _this.setState({
        deletedId: rule.id
      }, function () {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].deleteRule(rule.id).then(function () {
            return _this.notifyDelete(rule);
          }).then(_this.fetchRules);
        }, 200);
      });
    };

    _this.openChatWidget = function (e) {
      e.preventDefault();
      var chatPayload = {};
      if (__WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */] && __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["R" /* SALES_USER_ID */]) {
        chatPayload.inboxId = __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */];
        chatPayload.sender = { id: __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["R" /* SALES_USER_ID */] };
      }
      __WEBPACK_IMPORTED_MODULE_7_components_shared_DriftAPI__["a" /* default */].showWelcomeMessage(chatPayload);
    };

    _this.renderParticipantAction = function (action) {
      var _this$props = _this.props,
          users = _this$props.users,
          teams = _this$props.teams;

      var hasUserIds = !!action.options.userIds && action.options.userIds.length > 0;
      var userIdsToRender = hasUserIds ? action.options.userIds.slice(0, TOTAL_AVATARS) : [];
      var team = action.options.teamId && teams.find(function (x) {
        return x.id === action.options.teamId;
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        action.options.teamId && team && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__["a" /* default */], { type: 'team', flow: 'up', tooltipName: team.name, team: team })
        ),
        hasUserIds && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-participants-avatars-list' },
          userIdsToRender.map(function (id) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__["a" /* default */], { key: id, tooltipName: users[id].name, type: 'user', user: users[id] });
          }),
          action.options.userIds.length - TOTAL_AVATARS > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'rule-participants-more' },
            '+ ',
            action.options.userIds.length - TOTAL_AVATARS,
            ' more'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Add Participant'
        )
      );
    };

    _this.renderLeandataAction = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-participants-avatars' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__["a" /* default */], { key: 'LeanData Owner', tooltipName: "LeanData Owner", type: 'user' })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Add LeanData Owner'
        )
      );
    };

    _this.renderTargetedAccountsAction = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-participants-avatars' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__["a" /* default */], { key: 'ABM', tooltipName: "ABM", type: 'user' })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Add Drift Account Owner'
        )
      );
    };

    _this.renderSalesforceParticipantAction = function () {
      var users = _this.props.users;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-participants-avatars-list' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_SFDC_containers_MappedUsers__["a" /* default */], { users: users, max: TOTAL_AVATARS })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Add Salesforce Participant'
        )
      );
    };

    _this.optIntoAdvancedRouting = function () {
      _this.props.actions.patchOrgProperties([{
        operation: 'set',
        property: 'advancedRoutingOptIn',
        value: true
      }]);
    };

    _this.state = {
      order: _.range(0),
      count: 0,
      isLoading: props.rulesLoading,
      onCallModalOpen: false,
      optInModalOpen: false
    };
    return _this;
  }

  _createClass(RulesHomeLayout, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.rulesLoading !== this.props.rulesLoading) {
        setTimeout(function () {
          _this2.setState({ isLoading: nextProps.rulesLoading });
        }, 1500);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchRules();
      this.props.actions.fetchOrgUsers();

      Object(__WEBPACK_IMPORTED_MODULE_15_utils_tracking__["b" /* trackEvent */])('Legacy Routing Builder - Opened');
    }
  }, {
    key: 'displayActionType',
    value: function displayActionType(type) {
      var _ACTION_TYPE;

      var ACTION_TYPE = (_ACTION_TYPE = {}, _defineProperty(_ACTION_TYPE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["a" /* ACTION_TYPES */].PARTICIPANT, this.renderParticipantAction), _defineProperty(_ACTION_TYPE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["a" /* ACTION_TYPES */].SALESFORCE_PARTICIPANT, this.renderSalesforceParticipantAction), _defineProperty(_ACTION_TYPE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["a" /* ACTION_TYPES */].ABM_PARTICIPANT, this.renderTargetedAccountsAction), _defineProperty(_ACTION_TYPE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["a" /* ACTION_TYPES */].LEANDATA_PARTICIPANT, this.renderLeandataAction), _ACTION_TYPE);

      return ACTION_TYPE[type] || function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null);
      };
    }
  }, {
    key: 'displayUrlFilterValue',
    value: function displayUrlFilterValue(value) {
      return Array.isArray(value) ? Object(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__["oxford"])(value, 2, ' and ' + (value.length - 2) + ' more') : '';
    }
  }, {
    key: 'displayConditionType',
    value: function displayConditionType(item) {
      var _VALUE_RENDER, _TOOLTIP_VALUE;

      if (item.conditions.length === 0 || item.conditions[0].length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Match Always'
          )
        );
      }
      var _item$conditions$0$ = item.conditions[0][0],
          field = _item$conditions$0$.field,
          value = _item$conditions$0$.value;

      var VALUE_RENDER = (_VALUE_RENDER = {}, _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_POSTAL_CODE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, this.displayVisitsValue(value)), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */], __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */], __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["C" /* LEANDATA_FILTER */], __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["e" /* CONDITION_SUB_TYPE_LABELS */][field]), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH, this.displayUrlFilterValue(field, value)), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_HOST, this.displayUrlFilterValue(field, value)), _defineProperty(_VALUE_RENDER, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_QUERY, this.displayUrlFilterValue(field, value)), _VALUE_RENDER);

      var TOOLTIP_VALUE = (_TOOLTIP_VALUE = {}, _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, this.displayGeoValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, this.displayGeoValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, this.displayEmployeeValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, this.displayMoneyValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, this.displayListValues(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, this.displayListValues(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, this.displayListValues(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, this.displayRevenueValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, this.displayVisitsValue(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH, this.displayListValues(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_HOST, this.displayListValues(value)), _defineProperty(_TOOLTIP_VALUE, __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_QUERY, this.displayListValues(value)), _TOOLTIP_VALUE);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        VALUE_RENDER[field] && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
          { to: '/settings/rules/' + item.id },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { is: true, tooltip: TOOLTIP_VALUE[field], flow: 'right' },
            VALUE_RENDER[field]
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["g" /* CONDITION_TYPE_LABELS */][field]
        )
      );
    }
  }, {
    key: 'displayListValues',
    value: function displayListValues(value) {
      return Array.isArray(value) ? value.join(', ') : '';
    }
  }, {
    key: 'displayGeoValue',
    value: function displayGeoValue(value) {
      var geoBuckets = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_16_components_settings_Rules_constants_regions__["a" /* regions */])), _toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_17_components_settings_Rules_constants_continents__["a" /* continents */])));
      var matchedBucket = _.find(geoBuckets, function (region) {
        return _.isEqual(__WEBPACK_IMPORTED_MODULE_16_components_settings_Rules_constants_regions__["a" /* regions */][region], value);
      });

      return matchedBucket ? matchedBucket : 'Custom';
    }
  }, {
    key: 'displayRevenueValue',
    value: function displayRevenueValue(value) {
      return value + ' in annual revenue';
    }
  }, {
    key: 'displayEmployeeValue',
    value: function displayEmployeeValue(value) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["m" /* EMPLOYEE_NUMBER_GROUPS */], function (group) {
        return _.isEqual(group, value);
      });

      return matched ? matched.min + ' - ' + matched.max + ' employees' : 'Custom';
    }
  }, {
    key: 'displayMoneyValue',
    value: function displayMoneyValue(value) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["E" /* MONEY_RAISED_GROUPS */], function (group) {
        return _.isEqual(group, value);
      });

      return matched ? '$' + matched.min + ' - $' + matched.max + ' million' : 'Custom';
    }
  }, {
    key: 'displayVisitsValue',
    value: function displayVisitsValue(value) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_19_app_modules_rules_constants__["O" /* SITE_VISITS_GROUPS */], function (group) {
        return _.isEqual(group, value);
      });

      return matched ? matched.min + ' - ' + matched.max + ' site visits' : 'Custom';
    }
  }, {
    key: 'rowStyle',
    value: function rowStyle(index) {
      var order = this.state.order;

      var rowY = order.indexOf(index) * 80;

      var style = {
        scale: 1,
        shadow: 0,
        y: rowY,
        x: 0,
        opacity: 1
      };

      var rowStyle = {
        boxShadow: 'rgba(0, 0, 0, 0.2) 0px ' + style.shadow + 'px ' + 2 * style.shadow + 'px 0px',
        transform: 'translate3d(' + style.x + 'px, ' + style.y + 'px, 0) scale(' + style.scale + ')',
        zIndex: index,
        opacity: style.opacity
      };

      return { rowStyle: rowStyle, style: style };
    }
  }, {
    key: 'getAuthorDisplayName',
    value: function getAuthorDisplayName(authorId) {
      var users = this.props.users;

      var hasBeenUpdated = !!authorId;
      var hasAuthor = hasBeenUpdated && !!users[authorId];
      var displayDeletedOrBlank = hasBeenUpdated ? '[Deleted User]' : '';
      var displayAuthor = hasAuthor ? users[authorId].name : displayDeletedOrBlank;

      return displayAuthor;
    }
  }, {
    key: 'renderOnCallRow',
    value: function renderOnCallRow() {
      var _props = this.props,
          users = _props.users,
          onCall = _props.onCall;

      var author = this.getAuthorDisplayName(onCall.lastUpdatedBy);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'rule-row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-priority-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'rule-priority' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-title-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-title' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'rule-title-link', onClick: this.openOnCallModal },
              'Default Rule'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'last edited by ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                author && Object(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__["truncate"])(author, 15)
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-condition' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'rules-oncall-condition-title' },
                'Drift Routing'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'Default Rule'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-participants' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'rule-participants-avatars-list' },
              onCall.userIds && onCall.userIds.map(function (id, index) {
                if (index === TOTAL_AVATARS) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'rule-participants-more', key: id },
                    '+ ',
                    onCall.userIds.length - TOTAL_AVATARS,
                    ' more'
                  );
                }
                if (index > TOTAL_AVATARS) {
                  return null;
                }
                return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_TooltipAvatar__["a" /* default */], { key: id, tooltipName: users[id].name, user: users[id] });
              }),
              !onCall.userIds.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'rules-no-participants' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'Add Participant'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rules-actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { onClick: this.openOnCallModal },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_pencil_svg___default.a })
            )
          )
        )
      );
    }
  }, {
    key: 'renderDisabledRow',
    value: function renderDisabledRow() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { upgrade: true, priority: 1, title: "USA Territory", filter: { title: "Country", subtitle: "Geolocation" } };

      var hasAccess = __WEBPACK_IMPORTED_MODULE_8_utils_Access__["c" /* default */].hasNonBlacklistedGate('rules_routing');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'rule-row disabled-rule-row' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-priority-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'rule-priority' },
              opts.priority
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-title-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-title' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
              { to: '' },
              opts.title
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'last edited by ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null)
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-condition' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                { className: 'rules-oncall-condition-title' },
                opts.filter.title
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                opts.filter.subtitle
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-participants' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'rule-participants-avatars-list' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'rules-no-participants' })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'Add Participant'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'rules-actions' })
        ),
        opts.upgrade && !hasAccess && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'upgrade-ribbon' },
          'Upgrade'
        )
      );
    }
  }, {
    key: 'renderTableHeader',
    value: function renderTableHeader() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'rules-table-header' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-row' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-drag-wrap' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                { className: 'rules-table-header-cell' },
                'ORDER'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-priority-wrap' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'rule-priority' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-title-wrap' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'rule-title' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                { className: 'rules-table-header-cell' },
                'NAME'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'rule-condition' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                { className: 'rules-table-header-cell' },
                'RULE'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'rule-participants' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'strong',
                { className: 'rules-table-header-cell' },
                'ACTION'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'rules-actions' })
          )
        )
      );
    }
  }, {
    key: 'renderTableRows',
    value: function renderTableRows() {
      var _this3 = this;

      var _state = this.state,
          order = _state.order,
          deletedId = _state.deletedId;


      return this.props.rules.map(function (rule, i) {
        return _this3.renderRow(rule, i, deletedId, order);
      });
    }
  }, {
    key: 'renderRow',
    value: function renderRow(rule, i, deletedId, order) {
      var _this4 = this;

      var isPressed = this.state.isPressed;

      var style = this.rowStyle(i);
      var draggedOver = isPressed ? 'rule-row-dragged-over' : '';
      var willRemove = rule.id === deletedId ? 'will-remove-row' : '';
      var author = this.getAuthorDisplayName(rule.authorId);
      var priority = order.indexOf(i) + 1;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: 'rule-row ' + willRemove + ' ' + draggedOver,
          style: style.rowStyle,
          key: rule.id
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-priority-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'rule-priority' },
              priority || '#'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-title-wrap' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-title' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_14_components_TetheredToolTip__["a" /* default */],
              {
                className: 'rule-title-tooltip',
                flow: 'up',
                component: rule.name,
                disabled: rule.name.length <= 31 },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
                { href: '/settings2/rules/' + rule.id + '/edit' },
                rule.name
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'last edited by ',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                author && Object(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__["truncate"])(author, 15),
                ' ',
                __WEBPACK_IMPORTED_MODULE_4_moment___default()(rule.updatedAt).format('MM/DD/YYYY')
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-condition' },
            this.displayConditionType(rule)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rule-participants' },
            this.displayActionType(rule.action.type)(rule.action)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rules-actions' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
              { href: '/settings2/rules/' + rule.id + '/edit' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_pencil_svg___default.a })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_23__svg_inline_removeTags_true_images_svg_delete_svg___default.a, onClick: function onClick() {
                return _this4.deleteRule(rule);
              } })
          )
        )
      );
    }
  }, {
    key: 'renderUpsell',
    value: function renderUpsell() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'routing-rules' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rules-gate' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'rules-gated-content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h2',
              null,
              'Want to 10x your Lead Routing?'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              null,
              'Use smart lead routing to get anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'drift-button drift-button-primary large', onClick: this.openChatWidget },
              'Upgrade'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { className: 'drift-button large', target: '_blank', href: '//help.drift.com/setup/rules' },
              'Learn More'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_24__svg_inline_images_svg_rules_chat_svg___default.a })
        )
      );
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'routing-rules loading' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Use smart lead routing to route anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { target: '_blank', href: '//help.drift.com/setup/rules' },
              'Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'section',
          { className: 'routing-rule-table' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_25__svg_inline_images_svg_rules_blank_table_svg___default.a })
        )
      );
    }
  }, {
    key: 'renderAdvancedRoutingOptIn',
    value: function renderAdvancedRoutingOptIn() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'advanced-routing-opt-in-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'advanced-routing-opt-in-fake-border' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'advanced-routing-opt-in' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'advanced-routing-opt-in-new-badge' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'advanced-routing-opt-in-new-bolt', src: __WEBPACK_IMPORTED_MODULE_26__svg_inline_removeTags_true_images_svg_cql_bolt_svg___default.a }),
              'NEW!'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h4',
              { className: 'advanced-routing-header' },
              'A more powerful way to set up routing rules'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'advanced-routing-opt-in-content' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'Drift\u2019s new Advanced Routing allows you to create powerful routing rules to support your organization. Branch based on conditions, set up fallbacks, and more!',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  { target: '_blank', href: 'https://gethelp.drift.com/hc/en-us/articles/360024875354-How-to-Use-Advanced-Routing' },
                  ' Learn More'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'drift-button medium advanced-routing-opt-in-button', onClick: this.openAdvancedRoutingOptInModal },
              'Try it out!'
            )
          )
        )
      );
    }
  }, {
    key: 'renderPageHeader',
    value: function renderPageHeader() {
      var hasAccess = __WEBPACK_IMPORTED_MODULE_8_utils_Access__["c" /* default */].hasNonBlacklistedGate('rules_routing');
      var description = hasAccess ? function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Use rules to route anonymous leads to the right person on your team based on filters such as their location, company size, URL and more.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            '* Please note: Routing rules in playbooks take precedence over Conversation Routing rules.',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { target: '_blank', href: '//help.drift.com/setup/rules' },
              ' Learn More'
            )
          )
        );
      } : function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Use Rules to automatically add participants to conversations and make sure no lead goes unanswered. Just add your teammembers to these rules, and your Drift chats will be directed to them.'
        );
      };

      var newRuleButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        {
          href: '/settings2/rules/new',
          className: 'new-rule-button drift-button drift-button-primary' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_22__svg_inline_removeTags_true_images_svg_new_item_svg___default.a }),
        'Create New Rule'
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.props.hasVisualRoutingBuilder && this.renderAdvancedRoutingOptIn(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          { className: !hasAccess && 'no-access' },
          hasAccess && newRuleButton,
          description()
        )
      );
    }
  }, {
    key: 'renderBottomSection',
    value: function renderBottomSection() {
      var hasAccess = __WEBPACK_IMPORTED_MODULE_8_utils_Access__["c" /* default */].hasNonBlacklistedGate('rules_routing');

      if (!hasAccess) {
        return this.renderUpsell();
      }
      if (this.props.rules.length) {
        return null;
      }

      var newRuleButton = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        {
          href: '/settings2/rules/new',
          className: 'new-rule-button drift-button drift-button-primary' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_22__svg_inline_removeTags_true_images_svg_new_item_svg___default.a }),
        'Create New Rule'
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'rules-empty-table-state' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h2',
          null,
          'You don\u2019t have any supercharged rules yet!'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Create your first rule based on filters like geolocation, URL and company information.'
        ),
        newRuleButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.state.isLoading;
      var _props2 = this.props,
          rules = _props2.rules,
          onCall = _props2.onCall,
          users = _props2.users;

      var onCallRuleTop = rules.length ? rules.length * 80 + 'px' : '80px';
      var hasOptInAccess = __WEBPACK_IMPORTED_MODULE_8_utils_Access__["c" /* default */].hasGates('ROUTING_OPT_IN');
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'routing-rules ' + (isLoading && 'loading') },
        this.renderPageHeader(),
        this.renderTableHeader(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'section',
          { className: 'routing-rule-table' },
          isLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_25__svg_inline_images_svg_rules_blank_table_svg___default.a }),
          !isLoading && !rules.length && this.renderDisabledRow(),
          !isLoading && this.renderTableRows()
        ),
        !isLoading && hasOptInAccess && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'section',
          { className: 'routing-rule-table', style: { top: onCallRuleTop } },
          this.renderOnCallRow()
        ),
        this.renderBottomSection(),
        this.state.onCallModalOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__OnCallModal__["a" /* default */], { onClose: this.closeOnCallModal, fetchRules: this.fetchRules, onCall: onCall, users: users }),
        this.state.optInModalOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__OptInModal__["a" /* default */], { onClose: this.closeOptInModal }),
        this.state.advancedRoutingOptInModalOpen && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AdvancedRoutingOptInModal__["a" /* default */], { onClose: this.closeAdvancedRoutingOptInModal, optIntoAdvancedRouting: this.optIntoAdvancedRouting })
      );
    }
  }]);

  return RulesHomeLayout;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

RulesHomeLayout.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (RulesHomeLayout);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "8uzH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history__ = __webpack_require__("lCwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history__);




// based off https://github.com/mjackson/history/pull/171
function stringifyQuery(query) {
  return __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(query, { arrayFormat: 'brackets' }).replace(/%20/g, '+');
}

function parseQueryString(queryString) {
  return __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(queryString.replace(/\+/g, '%20'));
}

var appHistory = Object(__WEBPACK_IMPORTED_MODULE_2_history__["useBeforeUnload"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["g" /* useRouterHistory */])(__WEBPACK_IMPORTED_MODULE_2_history__["createHistory"]))({
  stringifyQuery: stringifyQuery,
  parseQueryString: parseQueryString
});

/***/ }),

/***/ "8v82":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var EventAPI = Marty.createStateSource({
  id: 'EventAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["s" /* EVENT_API */],

  fetchEvents: function fetchEvents() {
    return this.get({
      url: '/events',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchEventsForEndUserId: function fetchEventsForEndUserId(endUserId) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["h" /* serializeObject */])({ endUserId: endUserId });
    return this.get({
      url: '/events?' + queryParams,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  identifyMulti: function identifyMulti(endUsers, orgId) {
    return this.post({
      url: '/identify/multi',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(endUsers)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EventAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "8wCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventCard__ = __webpack_require__("QNLA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventDetail__ = __webpack_require__("1ZNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventData__ = __webpack_require__("BeI0");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var GenericEvent = function (_Component) {
  _inherits(GenericEvent, _Component);

  function GenericEvent() {
    _classCallCheck(this, GenericEvent);

    return _possibleConstructorReturn(this, (GenericEvent.__proto__ || Object.getPrototypeOf(GenericEvent)).apply(this, arguments));
  }

  _createClass(GenericEvent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isNote = _props.isNote,
          iconSrc = _props.iconSrc,
          eventLabel = _props.eventLabel,
          event = _props.event,
          endUser = _props.endUser,
          actionTaker = _props.actionTaker,
          campaign = _props.campaign;

      var cardProps = { isNote: isNote, iconSrc: iconSrc };
      var detailProps = { eventLabel: eventLabel, event: event, endUser: endUser, actionTaker: actionTaker };
      var dataProps = { isNote: isNote, event: event, campaign: campaign };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__EventCard__["a" /* default */],
        cardProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__EventDetail__["a" /* default */],
          detailProps,
          this.props.children
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__EventData__["a" /* default */], dataProps)
      );
    }
  }]);

  return GenericEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (GenericEvent);

/***/ }),

/***/ "8xQt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_RevenueDashboardToggle__ = __webpack_require__("4Rfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__ = __webpack_require__("hTEi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var SALESFORCE_REVENUE_ORG_PROPERTY = 'salesforceRevenueMetricsEnabled';
var ANONYMOUS_VISITOR_OVERVIEW_MESSAGE = 'Create new leads and contacts in Salesforce when they interact with Drift';
var ACTIVITY_OVERVIEW_MESSAGE = 'Add Drift activity and attach chat transcripts to new and existing lead and contact records in Salesforce';
var CONTACT_OVERVIEW_MESSAGE = 'Route Salesforce owners into Drift conversations with their known accounts, contacts, and leads';
var CONTACT_LINK_TEXT = 'conversation routing rules';

var Salesforce = function (_Component) {
  _inherits(Salesforce, _Component);

  function Salesforce() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Salesforce);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Salesforce.__proto__ || Object.getPrototypeOf(Salesforce)).call.apply(_ref, [this].concat(args))), _this), _this.onIntegrationConnected = function () {
      __WEBPACK_IMPORTED_MODULE_12_containers_app__["a" /* default */].queries.IntegrationsQueries.fetchIntegrationStates();
      _this.enableRevenueDashboard();
    }, _this.enableRevenueDashboard = function () {
      var patchedProperties = Object(__WEBPACK_IMPORTED_MODULE_8_utils_PatchHelper__["a" /* patchOperations */])(_defineProperty({}, [SALESFORCE_REVENUE_ORG_PROPERTY], true));

      _this.props.actions.patchOrgProperties(patchedProperties);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Salesforce, [{
    key: 'renderSalesforceMappingLink',
    value: function renderSalesforceMappingLink() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        { to: '/settings/salesforce/mapping/attributes', className: 'integration-config-link' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'integration-section-title' },
          'Mapped Salesforce attributes'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Map which fields you want to sync between Drift and Salesforce'
        )
      );
    }
  }, {
    key: 'renderSalesforceTogglesLink',
    value: function renderSalesforceTogglesLink() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        { to: '/settings/salesforce/config', className: 'integration-config-link' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'integration-section-title' },
          'Sync settings'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Choose which Salesforce objects are sent between Drift and Salesforce'
        )
      );
    }
  }, {
    key: 'renderSalesforceUserMappingLink',
    value: function renderSalesforceUserMappingLink() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        { to: '/settings/salesforce/mapping/users', className: 'integration-config-link' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'integration-section-title' },
          'Mapped Salesforce users'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Map your Drift teammates to your Salesforce teammates'
        )
      );
    }
  }, {
    key: 'renderSalesforceChatMetricsLink',
    value: function renderSalesforceChatMetricsLink() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        { to: '/settings/salesforce/mapping/attributes/metrics', className: 'integration-config-link' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          { className: 'integration-section-title' },
          'Send chat metrics to Salesforce'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Send metrics about your conversations to your Salesforce conversation activities'
        )
      );
    }
  }, {
    key: 'renderSalesforceSandboxConnector',
    value: function renderSalesforceSandboxConnector() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-sandbox-connector' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button' },
          'Connect to Sandbox'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;
      var _props$settingsAppCon = this.props.settingsAppConfig,
          hasSalesforce = _props$settingsAppCon.hasSalesforce,
          hasSalesforceRouting = _props$settingsAppCon.hasSalesforceRouting,
          hasSalesforceRevenueDashboard = _props$settingsAppCon.hasSalesforceRevenueDashboard,
          hasSalesforceContactSync = _props$settingsAppCon.hasSalesforceContactSync,
          hasSalesforceUserMapping = _props$settingsAppCon.hasSalesforceUserMapping,
          hasSalesforceAttributesMapping = _props$settingsAppCon.hasSalesforceAttributesMapping;


      var hasAccess = hasSalesforce;
      var SalesforcePayload = {
        client_id: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["O" /* SALESFORCE_CLIENT_ID */],
        response_type: 'code',
        redirect_uri: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/salesforce'
      };

      var SandboxPayload = {
        client_id: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["O" /* SALESFORCE_CLIENT_ID */],
        response_type: 'code',
        redirect_uri: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/salesforceSandbox'
      };

      var SaleseforceAuthUrl = 'https://login.salesforce.com/services/oauth2/authorize';
      var SandboxURL = 'https://test.salesforce.com/services/oauth2/authorize';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-integration-connector' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-overview-container' },
          hasSalesforceContactSync && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__["Icon"], { className: 'anonymous-visitor-icon', width: 28, name: 'rolodex' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              ANONYMOUS_VISITOR_OVERVIEW_MESSAGE
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__["Icon"], { className: 'activity-icon', width: 28, height: 22, name: 'activity' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              ACTIVITY_OVERVIEW_MESSAGE
            )
          ),
          hasSalesforceRouting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-overview-description' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__["Icon"], { className: 'user-target-icon', width: 50, name: 'user-target' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              CONTACT_OVERVIEW_MESSAGE,
              ' (\uD83D\uDC49 you can set this up in your ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: '/settings/rules' },
                CONTACT_LINK_TEXT
              ),
              ').'
            )
          ),
          !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'salesforce-overview-description' },
            'Having permission issues?\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://gethelp.drift.com/hc/en-us/articles/360019665113-How-to-Grant-the-Proper-Salesforce-User-and-Object-Permissions-for-Drift-and-Salesforce', target: '_blank' },
              'Check out this help doc!'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'salesforce-overview-description' },
            'Learn more about our Salesforce integration\xA0',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://gethelp.drift.com/hc/en-us/articles/360018794974-How-To-Integrate-Drift-With-Salesforce', target: '_blank' },
              'here!'
            )
          )
        ),
        !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'connect-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_IntegrationConnector__["a" /* default */], {
            onIntegrationConnected: this.onIntegrationConnected,
            integrationId: 'salesforce',
            isOauth: true,
            oauthLink: SaleseforceAuthUrl,
            title: 'Connect account',
            connectorType: 'button',
            buttonType: 'primary',
            className: 'salesforce-integration-connector',
            oauthQueryParams: SalesforcePayload,
            logLoginFail: true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_IntegrationConnector__["a" /* default */], {
            onIntegrationConnected: this.onIntegrationConnected,
            integrationId: 'salesforceSandbox',
            isOauth: true,
            oauthLink: SandboxURL,
            title: 'Connect sandbox account',
            connectorType: 'button',
            className: 'salesforce-integration-connector',
            oauthQueryParams: SandboxPayload,
            logLoginFail: true })
        ),
        isConnected && hasAccess && this.renderSalesforceTogglesLink(),
        isConnected && hasAccess && hasSalesforceAttributesMapping && this.renderSalesforceMappingLink(),
        isConnected && hasAccess && hasSalesforceUserMapping && this.renderSalesforceUserMappingLink(),
        isConnected && hasAccess && this.renderSalesforceChatMetricsLink(),
        isConnected && hasAccess && hasSalesforceRevenueDashboard && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_RevenueDashboardToggle__["a" /* default */], null),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
          { to: '/settings/salesforce/event-log', className: 'integration-config-link' },
          'View Salesforce event log'
        )
      );
    }
  }]);

  return Salesforce;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Salesforce.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    settingsAppConfig: Object(__WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__["settingsAppConfig"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      refreshCurrentUser: __WEBPACK_IMPORTED_MODULE_10_app_modules_user_actions__["refreshCurrentUser"],
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_11_app_modules_org_actions__["patchOrgProperties"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_9_components_shared_notifications__["a" /* default */])(Salesforce)));

/***/ }),

/***/ "8zkG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("cCgd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_caret_icon_svg__ = __webpack_require__("75Yw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_caret_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_caret_icon_svg__);









var HeaderBackButton = function HeaderBackButton(_ref) {
  var _ref$target = _ref.target,
      target = _ref$target === undefined ? "" : _ref$target,
      to = _ref.to,
      text = _ref.text,
      query = _ref.query;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
    { target: target, to: { pathname: to, query: query },
      className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.HeaderBackButton },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'back', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_caret_icon_svg___default.a }),
    text
  );
};

HeaderBackButton.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  query: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  text: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderBackButton);

/***/ }),

/***/ "90gJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvailabilityStatus; });
/* unused harmony export NotificationSnoozeStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AvailabilityStatusIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg__ = __webpack_require__("baVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg__ = __webpack_require__("pB77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg__ = __webpack_require__("NrfI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg__ = __webpack_require__("PDo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg__);





var AvailabilityStatus = {
  ACTIVE: 'AVAILABLE',
  AWAY: 'OFFLINE',
  ON_CALL: 'ON_CALL'
};

var NotificationSnoozeStatus = {
  ON: 'SNOOZE_ON',
  OFF: 'SNOOZE_OFF'
};

var AvailabilityStatusIcons = [{
  availabilityStatus: AvailabilityStatus.ACTIVE,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ACTIVE,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ON_CALL,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ON_CALL,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.AWAY,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.AWAY,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg___default.a
}];

/***/ }),

/***/ "913P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__driftt_dapper__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PATCH_SUCCESS_MESSAGE = 'We saved your changes.';
var PATCH_ERROR_MESSAGE = 'We could not save your changes.';

var SlackPayload = {
  client_id: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["Z" /* SLACK_CLIENT_ID */],
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/slack'
};
var SlackAuthUrl = 'https://slack.com/oauth/authorize';

var Slack = function (_Component) {
  _inherits(Slack, _Component);

  function Slack() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Slack);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Slack.__proto__ || Object.getPrototypeOf(Slack)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      slackState: null,
      slackNotificationMode: null,
      slackChannelName: ''
    }, _this.fetchSlack = function () {
      _this.context.app.actions.SlackTeamActions.fetchSlackTeam();
    }, _this.getStateParam = function () {
      var promise = _this.context.app.sources.IntegrationsAPI.getStateParam();

      promise.then(function (res) {
        if (res.status === 200) {
          _this.setState({ slackState: res.body.state });
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        }
      });
    }, _this.renderSlackChannelInput = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default.a, {
          label: 'SLACK CHANNEL',
          value: _this.props.integrationStates.slackChannelName || _this.state.slackChannelName,
          readOnly: true
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'slack-disconnect-info' },
          'Change your slack channel by disconnecting and reconnecting with a new channel selection.'
        )
      );
    }, _this.renderSlackNotificationToggle = function () {
      var slackNotificationMode = _this.state.slackNotificationMode;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'slack-notification-setting' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Limit Channel Creation'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'slack-notification-setting-toggle' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'p',
              { className: 'slack-notification-setting-description' },
              'Don\'t want us to create a new channel for every new Drift conversation? No worries! Turn this setting on and we won\'t create any new channels. Instead, you\'ll continue to receive a new conversation message in your designated Slack channel with a link to that conversation on Drift.'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Toggle"], {
              checked: slackNotificationMode,
              onChange: _this.setSlackNotificationMode
            })
          )
        )
      );
    }, _this.setSlackNotificationMode = function (event) {
      _this.setState({
        slackNotificationMode: event.target.checked
      });

      Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_api__["M" /* patchSlackNotificationToggle */])({ notificationsOnlyOn: event.target.checked }).then(_this.onPatchSuccess).catch(_this.onPatchError);
    }, _this.onPatchError = function (e) {
      console.log(e);
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.onPatchSuccess = function () {
      _this.props.notifications.success(PATCH_SUCCESS_MESSAGE);
    }, _this.getSlackPayload = function () {
      return _extends({ state: _this.state.slackState }, SlackPayload);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Slack, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.getStateParam();
      Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_api__["F" /* getSlackNotificationToggle */])().then(function (res) {
        _this2.setState({
          slackNotificationMode: res.status,
          slackChannelName: res.slackChannelName
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          integrationStates = _props.integrationStates,
          suppressUI = _props.suppressUI;

      var isConnected = integrationStates && integrationStates.slackBot;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Get notifications in Slack for new Drift messages so you don\'t miss out on any conversations! With this integration, you can also chat with your site visitors right from Slack. '
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: 'http://help.drift.com/article/slack-integration-respond-to-chats-right-from-slack', target: '_blank' },
            'Learn more here!'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          this.renderSlackChannelInput(),
          this.renderSlackNotificationToggle()
        ),
        !suppressUI && this.state.slackState && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'connect-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_IntegrationConnector__["a" /* default */], {
            integrationId: 'slackBot',
            isOauth: true,
            oauthLink: SlackAuthUrl,
            oauthQueryParams: this.getSlackPayload(),
            postSuccessCB: this.fetchSlack,
            title: 'Connect Account',
            connectorType: 'button',
            buttonType: 'primary',
            className: 'slack-integration-connector'
          })
        )
      );
    }
  }]);

  return Slack;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Slack.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_components_shared_notifications__["a" /* default */])(Slack));

/***/ }),

/***/ "92wV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "94Ok":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("5CRk");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("jQsl");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "95qH":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 18c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zM9 1.5C4.865 1.5 1.5 4.865 1.5 9s3.365 7.5 7.5 7.5 7.5-3.365 7.5-7.5S13.135 1.5 9 1.5zm0 12.75a.789.789 0 0 1-.533-.217.785.785 0 0 1-.217-.533c0-.202.082-.39.217-.533.278-.277.78-.277 1.066 0 .135.143.217.33.217.533 0 .195-.082.39-.217.533A.789.789 0 0 1 9 14.25zm0-3a.75.75 0 0 1-.75-.75v-6a.75.75 0 1 1 1.5 0v6a.75.75 0 0 1-.75.75z\" fill=\"#E6314F\" fill-rule=\"nonzero\"></path></svg>"

/***/ }),

/***/ "96TJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__ = __webpack_require__("JMAf");








function pushGates(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref) {
    var channel = _ref.channel,
        leaveChannel$ = _ref.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('gates-updated', function (payload) {
        __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.GateActions.gatesUpdated(payload);
        observer.next(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__["receiveGates"](Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(payload)));
      });
    }).takeUntil(leaveChannel$);
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(pushGates);

/***/ }),

/***/ "97t2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NO_DELTA_CHANGE; });
/* unused harmony export areSameImmutableTimePeriods */
/* unused harmony export millisecondsToMinutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateChangePercentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return millisecondsToDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toISOLocalDateString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var NO_DELTA_CHANGE = '--';

var millisecondsToMinutes = function millisecondsToMinutes(milliseconds) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(milliseconds, 'milliseconds').asMinutes().toFixed(0);
};

var calculateChangePercentage = function calculateChangePercentage(previousValue, newValue) {
  if (!!!previousValue && !!!newValue) {
    return 0;
  }
  if (!!!previousValue) {
    return NO_DELTA_CHANGE;
  }
  return ((newValue - previousValue) / previousValue * 100).toFixed(1);
};

var millisecondsToDuration = function millisecondsToDuration(milliseconds) {
  var duration = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(milliseconds, 'milliseconds');
  var minutes = duration.asMinutes().toFixed(0);

  if (minutes > 24 * 60) {
    return (minutes / (24 * 60)).toFixed(1) + ' days';
  } else if (minutes > 60) {
    return (minutes / 60).toFixed(1) + ' hours';
  } else {
    return minutes + 'm ' + duration.seconds() + 's';
  }
};

var toISOLocalDateString = function toISOLocalDateString(date) {
  return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
};

var compareSameImmutableTimePeriods = function compareSameImmutableTimePeriods(timePeriodA, timePeriodB) {
  return function (key) {
    return timePeriodA !== null && timePeriodB !== null && timePeriodA.get(key).isSame(timePeriodB.get(key));
  };
};

var areSameImmutableTimePeriods = function areSameImmutableTimePeriods(timePeriodA, timePeriodB) {
  var isSame = compareSameImmutableTimePeriods(timePeriodA, timePeriodB);
  return isSame('startDate') && isSame('endDate') && isSame('prevStart') && isSame('prevEnd');
};



/***/ }),

/***/ "98WB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_I18n__ = __webpack_require__("K6LP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("MdQU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__ = __webpack_require__("/xdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__);







var CustomizeTemplate = function CustomizeTemplate(_ref) {
  var main = _ref.main,
      preview = _ref.preview;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.CustomizeTemplate },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components_I18n__["a" /* default */],
      { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.CustomizeSidebar },
      main
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'CustomizePreview' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
        { to: '/settings/widget' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'close-button', src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_components_I18n__["a" /* default */],
        null,
        preview
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CustomizeTemplate);

/***/ }),

/***/ "99XN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "99ZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? '9' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? '16' : _ref$height,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    { width: width, height: height, className: className, viewBox: '0 0 9 16' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      {
        id: 'GOOD',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          id: 'sidebar-cards',
          transform: 'translate(-3699.000000, -430.000000)',
          fill: '#FFEFBE',
          stroke: '#E6B420',
          strokeWidth: '0.75'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { id: 'Group-14', transform: 'translate(3700.000000, 431.000000)' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            d: 'M3.56696484,5.74476048 L7.72489136,5.74476048 L0.219201082,16.3480792 L3.08413575,8.00374251 L-0.688214461,8.00374251 L6.06109097,-2.45745637 L3.56696484,5.74476048 Z',
            id: 'Path-106'
          })
        )
      )
    )
  );
});

/***/ }),

/***/ "9Cjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators__ = __webpack_require__("W+Sr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_visibility__ = __webpack_require__("snL0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_UserTypes__ = __webpack_require__("p1Ml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_socket_actions__ = __webpack_require__("cRAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_conversation_bulkUpdate_actions__ = __webpack_require__("rpEm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_api__ = __webpack_require__("a5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__attachment__ = __webpack_require__("kMz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__api__ = __webpack_require__("FOl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_modules_composer_actions__ = __webpack_require__("4VmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__models__ = __webpack_require__("Jy8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__selectors__ = __webpack_require__("bWf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__demodata__ = __webpack_require__("K5ht");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



































function fetchFirstMessagesForContext(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["e" /* fetchConversationMessages */].toString()).pluck('payload').filter(function (_ref2) {
    var conversationId = _ref2.conversationId,
        force = _ref2.force;

    if (!!force) {
      return true;
    }
    return __WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState()) || !Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["d" /* firstPaginatedListLoaded */])(getState(), { conversationId: conversationId });
  }).mergeMap(function (_ref3) {
    var conversationId = _ref3.conversationId;


    if (__WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      var conversation = __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["n" /* makeConversation */]()(getState(), { conversationId: conversationId });

      var messages = Object(__WEBPACK_IMPORTED_MODULE_1_utils_immutable__["a" /* keyBy */])(__WEBPACK_IMPORTED_MODULE_32__demodata__["a" /* messages */](__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState()).toJS(), __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentOrgUsersAlphabetical"](getState()).toJS(), conversationId, conversation && conversation.endUserId).map(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */]));

      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["u" /* receiveFirstMessages */]({ conversationId: conversationId, messages: messages }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].fetch(conversationId, 10).map(function (messages) {
        return __WEBPACK_IMPORTED_MODULE_27__actions__["u" /* receiveFirstMessages */]({ conversationId: conversationId, messages: messages });
      }).startWith(__WEBPACK_IMPORTED_MODULE_27__actions__["g" /* fetchFirstMessagesPending */]({ conversationId: conversationId })).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["f" /* fetchFirstMessagesFailed */]({ conversationId: conversationId, error: error }));
      });
    }
  });
}

function fetchPaginatedConversationMessages(action$, _ref4) {
  var getState = _ref4.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["e" /* fetchConversationMessages */].toString()).pluck('payload').filter(function (_ref5) {
    var conversationId = _ref5.conversationId,
        force = _ref5.force;

    if (!!force) {
      return true;
    }
    return __WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState()) || !Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["d" /* firstPaginatedListLoaded */])(getState(), { conversationId: conversationId });
  }).mergeMap(function (_ref6) {
    var conversationId = _ref6.conversationId;

    if (__WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      var conversation = __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["n" /* makeConversation */]()(getState(), { conversationId: conversationId });

      var messages = Object(__WEBPACK_IMPORTED_MODULE_1_utils_immutable__["a" /* keyBy */])(__WEBPACK_IMPORTED_MODULE_32__demodata__["a" /* messages */](__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState()).toJS(), __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentOrgUsersAlphabetical"](getState()).toJS(), conversationId, conversation && conversation.endUserId).reverse().map(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */]), { acc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])() });
      var more = false,
          next = false;

      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["y" /* receivePaginatedMessageList */]({ conversationId: conversationId, messages: messages, more: more, next: next }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].fetchPaginated(conversationId).map(function (_ref7) {
        var messages = _ref7.messages,
            _ref7$pagination = _ref7.pagination,
            more = _ref7$pagination.more,
            next = _ref7$pagination.next;

        return __WEBPACK_IMPORTED_MODULE_27__actions__["y" /* receivePaginatedMessageList */]({ conversationId: conversationId, messages: messages, more: more, next: next });
      }).startWith(__WEBPACK_IMPORTED_MODULE_27__actions__["l" /* fetchPaginatedConversationMessagesPending */]({ conversationId: conversationId })).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["k" /* fetchPaginatedConversationMessagesFailed */]({ conversationId: conversationId, error: error }));
      });
    }
  });
}

function fetchNextPaginatedConversationMessages(action$, _ref8) {
  var getState = _ref8.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["h" /* fetchNextPaginatedConversationMessages */].toString()).pluck('payload').filter(function (_ref9) {
    var conversationId = _ref9.conversationId;
    return !Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["j" /* nextListPendingForConversation */])(getState(), { conversationId: conversationId });
  }).mergeMap(function (_ref10) {
    var conversationId = _ref10.conversationId;

    var nextPageId = Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["e" /* getNextPageId */])(getState(), { conversationId: conversationId });
    return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].fetchPaginated(conversationId, nextPageId).map(function (_ref11) {
      var messages = _ref11.messages,
          _ref11$pagination = _ref11.pagination,
          more = _ref11$pagination.more,
          next = _ref11$pagination.next;
      return __WEBPACK_IMPORTED_MODULE_27__actions__["x" /* receiveNextMessageList */]({ conversationId: conversationId, messages: messages, more: more, next: next });
    }).startWith(__WEBPACK_IMPORTED_MODULE_27__actions__["j" /* fetchNextPaginatedConversationMessagesPending */]({ conversationId: conversationId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["i" /* fetchNextPaginatedConversationMessagesFailed */]({ conversationId: conversationId, error: error }));
    });
  });
}

function fetchPlaybookContext(action$, _ref12) {
  var getState = _ref12.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["m" /* fetchPlaybookContext */].toString()).pluck('payload').filter(function (_ref13) {
    var conversationId = _ref13.conversationId;
    return !__WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["u" /* playbookIdByConversationId */](getState()).has(conversationId);
  }).mergeMap(function (_ref14) {
    var conversationId = _ref14.conversationId;

    var messages = Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["h" /* makeConversationMessages */])()(getState(), { conversationId: conversationId });
    var messageWithPartId = messages.find(function (m) {
      return !!m.getIn(['attributes', 'campaignId']) || !!m.getIn(['attributes', 'relatedCampaignId']) || !!m.getIn(['attributes', 'interactionId']);
    });
    if (messageWithPartId) {
      var campaignId = messageWithPartId.getIn(['attributes', 'relatedCampaignId']) || messageWithPartId.getIn(['attributes', 'campaignId']);
      var interactionId = messageWithPartId.getIn(['attributes', 'interactionId']);
      return campaignId ? __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_28_app_modules_playbook_actions__["_18" /* fetchPlaybookByCampaignId */]({ campaignId: campaignId, conversationId: conversationId })) : interactionId ? __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_28_app_modules_playbook_actions__["_21" /* fetchPlaybookByInteractionId */]({ interactionId: interactionId, conversationId: conversationId })) : __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].empty();
    }
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].empty();
  });
}

function sendMessageThroughApi(conversationId, messageWithId) {
  return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].create(conversationId, messageWithId).map(function (message) {
    return __WEBPACK_IMPORTED_MODULE_27__actions__["v" /* receiveMessage */]({ conversationId: conversationId, message: message });
  }).startWith(__WEBPACK_IMPORTED_MODULE_27__actions__["d" /* createMessagePending */]({ conversationId: conversationId, message: messageWithId })).catch(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_9_utils_SentryHelpers__["a" /* captureException */])(error);
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["c" /* createMessageFailed */]({ conversationId: conversationId, message: messageWithId, error: error }));
  });
}

function createMessage(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["b" /* createMessage */].toString()).pluck('payload').mergeMap(function (_ref15) {
    var message = _ref15.message,
        _ref15$isRetry = _ref15.isRetry,
        isRetry = _ref15$isRetry === undefined ? false : _ref15$isRetry;
    var conversationId = message.conversationId;

    var messageWithId = isRetry ? message.set('failed', false) : message.setIn(__WEBPACK_IMPORTED_MODULE_30__models__["b" /* TEMP_ID_KEY_PATH */], __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default()()).set('createdAt', Date.now());
    return sendMessageThroughApi(conversationId, messageWithId);
  });
}

function selectBotActionEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["A" /* selectBotAction */].toString()).pluck('payload').filter(function (_ref16) {
    var selectedButton = _ref16.selectedButton;
    return selectedButton.get('type') !== 'action' || !!selectedButton.getIn(['reaction', 'type']);
  }).mergeMap(function (actionParams) {
    var button = actionParams.selectedButton;
    var conversationId = actionParams.conversationId;
    var messageWithId = {
      type: "EDIT",
      contentType: "EDIT",
      body: actionParams.body,
      attributes: {
        selectedBotAction: button,
        editedMessageId: actionParams.editedMessageId
      }
    };

    return sendMessageThroughApi(conversationId, Object(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */])(button.getIn(['reaction', 'type']) === 'delete' || button.get('type') === 'noop' ? _extends({}, messageWithId, { attributes: _extends({}, messageWithId.attributes, { editType: 'delete' }) }) : messageWithId));
  });
}

function selectBotActionResultEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["A" /* selectBotAction */].toString()).pluck('payload').mergeMap(function (actionParams) {
    var button = actionParams.selectedButton;
    var conversationId = actionParams.conversationId;
    switch (button.get('type')) {
      case 'compose':
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_29_app_modules_composer_actions__["g" /* setComposerTextToInsert */]({ text: button.get('value') }));
      case 'action':
        __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_api__["a" /* api */].buttonAction(conversationId, { button: button, sourceMessageId: actionParams.editedMessageId }).subscribe();
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].empty();
      case 'noop':
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].empty();
      case 'reply':
      default:
        var messageWithId = Object(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */])({
          type: "CHAT",
          contentType: "CHAT",
          buttonResponse: {
            label: button.get('label'),
            value: button.get('value')
          },
          body: button.get('value')
        });
        return sendMessageThroughApi(conversationId, messageWithId);
    }
  });
}

function fetchEndUserForMessages(action$, _ref17) {
  var getState = _ref17.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["u" /* receiveFirstMessages */].toString()).pluck('payload').mergeMap(function (_ref18) {
    var messages = _ref18.messages;

    var ids = messages.filter(function (message) {
      return message.authorType === __WEBPACK_IMPORTED_MODULE_8_utils_UserTypes__["b" /* UserTypes */].END_USER || message.authorType === __WEBPACK_IMPORTED_MODULE_8_utils_UserTypes__["b" /* UserTypes */].LEAD;
    }).map(function (message) {
      return message.authorId;
    }).toSet().toJS();
    return __WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["p" /* hasSplitEndUserChannel */](getState()) ? __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_actions__["n" /* fetchEndUserList */]({ ids: ids })) // TODO: Cleanup after socket
    : __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_actions__["n" /* fetchEndUserList */]({ ids: ids }));
  });
}

function markMessageRead(action$, _ref19) {
  var getState = _ref19.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["o" /* messageRead */].toString()).filter(function () {
    return !__WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["f" /* hasBulkMessageRead */](getState());
  }).pluck('payload').filter(function (_ref20) {
    var messageId = _ref20.messageId;
    return __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(messageId);
  }) // filter pre-messages
  .filter(function (_ref21) {
    var messageId = _ref21.messageId;
    return !Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["f" /* isReadByCurrentUser */])(messageId)(getState());
  }).mergeMap(function (message) {
    if (!document.hidden) {
      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(message);
    } else {
      return __WEBPACK_IMPORTED_MODULE_7_utils_visibility__["a" /* visibility$ */].filter(function (visible) {
        return visible;
      }).map(function () {
        return message;
      }).first();
    }
  }).mergeMap(function (_ref22) {
    var messageId = _ref22.messageId,
        messageCreatedAt = _ref22.messageCreatedAt,
        conversationId = _ref22.conversationId;

    var user = __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState());
    var recipientId = user.id;
    var recipientType = user.type;
    return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].markRead(messageId).map(function () {
      return __WEBPACK_IMPORTED_MODULE_27__actions__["q" /* messageReadSuccess */]({ messageId: messageId, messageCreatedAt: messageCreatedAt, conversationId: conversationId, recipientId: recipientId, recipientType: recipientType });
    }).startWith(__WEBPACK_IMPORTED_MODULE_27__actions__["s" /* optimisticMessageReadSuccess */]({ messageId: messageId, messageCreatedAt: messageCreatedAt, conversationId: conversationId, recipientId: recipientId, recipientType: recipientType })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["p" /* messageReadFailed */]({ messageId: messageId, error: error }));
    });
  }, 10);
}

function bufferedMarkMessageRead(action$, _ref23) {
  var getState = _ref23.getState,
      dispatch = _ref23.dispatch;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["o" /* messageRead */].toString()).filter(function () {
    return __WEBPACK_IMPORTED_MODULE_20_app_modules_gates_selectors__["f" /* hasBulkMessageRead */](getState());
  }).pluck('payload').filter(function (_ref24) {
    var messageId = _ref24.messageId;
    return __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(messageId);
  }) // filter pre-messages
  .filter(function (_ref25) {
    var messageId = _ref25.messageId;
    return !Object(__WEBPACK_IMPORTED_MODULE_31__selectors__["f" /* isReadByCurrentUser */])(messageId)(getState());
  }).mergeMap(function (message) {
    if (!document.hidden) {
      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(message);
    } else {
      return __WEBPACK_IMPORTED_MODULE_7_utils_visibility__["a" /* visibility$ */].filter(function (visible) {
        return visible;
      }).map(function () {
        return message;
      }).first();
    }
  }).map(function (payload) {
    var messageId = payload.messageId,
        messageCreatedAt = payload.messageCreatedAt,
        conversationId = payload.conversationId;

    var user = __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState());
    var recipientId = user.id;
    var recipientType = user.type;

    dispatch(__WEBPACK_IMPORTED_MODULE_27__actions__["s" /* optimisticMessageReadSuccess */]({ messageId: messageId, messageCreatedAt: messageCreatedAt, conversationId: conversationId, recipientId: recipientId, recipientType: recipientType }));

    return payload;
  }).bufferTime(5000).map(function (messages) {
    return _(messages).groupBy('conversationId').value();
  }).mergeMap(function (messagesGroupedByConversationid) {
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].from(_.map(messagesGroupedByConversationid, function (messages, conversationId) {
      return __WEBPACK_IMPORTED_MODULE_27__actions__["n" /* markMessageReadByConversation */]({ messages: messages, conversationId: parseInt(conversationId) });
    }));
  });
}

function markMessageReadByConversation(action$, _ref26) {
  var getState = _ref26.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["n" /* markMessageReadByConversation */].toString()).pluck('payload').mergeMap(function (_ref27) {
    var messages = _ref27.messages,
        conversationId = _ref27.conversationId;

    var user = __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState());
    var recipientId = user.id;
    var recipientType = user.type;
    var messageIds = _.map(messages, 'messageId');
    return __WEBPACK_IMPORTED_MODULE_26__api__["a" /* api */].bulkMarkRead(conversationId, messageIds).map(function () {
      return __WEBPACK_IMPORTED_MODULE_27__actions__["a" /* bulkMessageReadSuccess */]({ messages: messages, conversationId: conversationId, recipientId: recipientId, recipientType: recipientType });
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["p" /* messageReadFailed */]({ messageIds: messageIds, error: error }));
    });
  });
}

function fetchConversationToNotify(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["v" /* receiveMessage */].toString()).pluck('payload', 'message').map(function (message) {
    return __WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_actions__["h" /* fetchConversation */]({ conversationId: message.conversationId });
  });
}

function notifyMessage(action$, _ref28) {
  var getState = _ref28.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["v" /* receiveMessage */].toString()).pluck('payload', 'message').groupBy(function (message) {
    return message.conversationId;
  }).mergeMap(function (conversationMessage$) {
    var conversationFetched$ = !!__WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["n" /* makeConversation */]()(getState(), { conversationId: conversationMessage$.key }) ? __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(true) : action$.ofType(__WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_actions__["J" /* receiveConversation */].toString()).pluck('payload', 'conversation').filter(function (conversation) {
      return conversation.id === conversationMessage$.key;
    }).first();

    var userSettingsFetched$ = __WEBPACK_IMPORTED_MODULE_19_app_modules_user_properties_selectors__["h" /* propertiesLoaded */](getState()) ? __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(true) : action$.ofType(__WEBPACK_IMPORTED_MODULE_18_app_modules_user_properties_actions__["i" /* receiveUserProperties */].toString()).first();

    // Wait for the conversation and userProperties to be fetched before notifying
    var isNotifiable$ = __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].forkJoin(conversationFetched$, userSettingsFetched$);

    return conversationMessage$.skipUntil(isNotifiable$).map(__WEBPACK_IMPORTED_MODULE_27__actions__["r" /* notifyUser */]);
  });
}

var createConversationEventMessageOnReceiveBulkUpdateSuccess = function createConversationEventMessageOnReceiveBulkUpdateSuccess(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14_app_modules_conversation_bulkUpdate_actions__["d" /* receiveBulkUpdateSuccess */].toString()).pluck('payload').map(function (_ref29) {
    var inboxId = _ref29.inboxId,
        updaterId = _ref29.updaterId,
        conversationDiffs = _ref29.conversationDiffs;

    var filteredConversationDiffs = conversationDiffs.filter(function (_ref30) {
      var previousStatus = _ref30.previousStatus,
          currentStatus = _ref30.currentStatus;

      return previousStatus !== currentStatus;
    });

    var timestamp = Date.now();

    var messages = filteredConversationDiffs.map(function (_ref31) {
      var conversationId = _ref31.conversationId,
          currentStatus = _ref31.currentStatus;

      return Object(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */])({
        inboxId: inboxId,
        type: 'CONVERSATION_EVENT',
        conversationId: conversationId,
        authorId: updaterId,
        authorType: __WEBPACK_IMPORTED_MODULE_8_utils_UserTypes__["b" /* UserTypes */].USER,
        conversationEvent: {
          type: 'CHANGED_STATUS',
          conversationStatus: currentStatus
        },
        createdAt: timestamp,
        attributes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_30__models__["a" /* TEMP_ID_KEY */], __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default()())),
        deliveryChannel: 'CHAT',
        contentType: 'CONVERSATION_EVENT'
      });
    });

    return __WEBPACK_IMPORTED_MODULE_27__actions__["t" /* receiveBulkUpdateMessages */]({ messages: messages });
  });
};

function pushMessage(action$, _ref32) {
  var getState = _ref32.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref33) {
    var channel = _ref33.channel,
        leaveChannel$ = _ref33.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('message-new', function (payload) {
        var state = getState();

        observer.next(__WEBPACK_IMPORTED_MODULE_27__actions__["v" /* receiveMessage */]({
          message: Object(__WEBPACK_IMPORTED_MODULE_30__models__["c" /* parseMessage */])(payload),
          conversationId: payload.conversationId
        }));

        var currentInboxId = __WEBPACK_IMPORTED_MODULE_23_app_modules_inbox_selectors__["b" /* currentInboxId */](state);
        var currentUser = __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](state);

        if (payload.type === 'CONVERSATION_EVENT' && payload.conversationEvent.type === 'CHANGED_STATUS' && payload.inboxId === currentInboxId) {
          if (Object(__WEBPACK_IMPORTED_MODULE_24_app_modules_access_helpers__["b" /* hasConversationAccess */])(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(payload.conversationEvent.participantIds), currentUser)) {
            observer.next(__WEBPACK_IMPORTED_MODULE_22_app_modules_inbox_actions__["i" /* changeStatus */]({
              id: currentInboxId,
              status: payload.conversationEvent.conversationStatus,
              previousStatus: payload.conversationEvent.previousStatus,
              currentParticipants: payload.conversationEvent.currentParticipantIds,
              currentUserId: currentUser.id
            }));
          }
        }
      });
    }).takeUntil(leaveChannel$);
  });
}

function pushMessageReadReceipt(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref34) {
    var channel = _ref34.channel,
        leaveChannel$ = _ref34.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('message-recipient-status', function (payload) {
        observer.next(__WEBPACK_IMPORTED_MODULE_27__actions__["w" /* receiveMessageRead */](payload));
      });
    }).takeUntil(leaveChannel$);
  });
}

function receiveReadReceiptForCurrentUser(action$, _ref35) {
  var getState = _ref35.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_27__actions__["w" /* receiveMessageRead */].toString()).pluck('payload').filter(function (payload) {
    return payload.status === 'Read';
  }).filter(function (_ref36) {
    var recipientType = _ref36.recipientType,
        recipientId = _ref36.recipientId;

    var currentUser = __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](getState());
    return recipientType === currentUser.type && recipientId === currentUser.id;
  }).mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_27__actions__["q" /* messageReadSuccess */](payload));
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_6_redux_observable__["combineEpics"])(fetchFirstMessagesForContext, fetchPaginatedConversationMessages, fetchNextPaginatedConversationMessages, createMessage, markMessageRead, bufferedMarkMessageRead, markMessageReadByConversation, fetchEndUserForMessages, notifyMessage, fetchConversationToNotify, pushMessage, pushMessageReadReceipt, __WEBPACK_IMPORTED_MODULE_25__attachment__["b" /* epic */], fetchPlaybookContext, selectBotActionEpic, selectBotActionResultEpic, receiveReadReceiptForCurrentUser, createConversationEventMessageOnReceiveBulkUpdateSuccess);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "9FFE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_HelpDocConstants__ = __webpack_require__("fBam");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var FindIntercomIdLink = "https://developers.intercom.io/reference#authorization";

var Intercom = function (_Component) {
  _inherits(Intercom, _Component);

  function Intercom() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Intercom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Intercom.__proto__ || Object.getPrototypeOf(Intercom)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      appId: '',
      apiKey: ''
    }, _this.getConnectionPayload = function () {
      var _this$state = _this.state,
          appId = _this$state.appId,
          apiKey = _this$state.apiKey;

      return { appId: appId, apiKey: apiKey };
    }, _this.renderInputs = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
          placeholder: 'e.g. 123456',
          label: 'APP ID',
          valueLink: {
            requestChange: function requestChange(input) {
              _this.setState({ appId: input });
            },
            value: _this.state.appId
          },
          isValid: !!_this.state.appId
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body color-gray-dark' },
          'Need help finding your Intercom API ID? Here\u2019s a ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: FindIntercomIdLink },
            ' handy guide'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Want more information? ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: __WEBPACK_IMPORTED_MODULE_3_constants_HelpDocConstants__["e" /* INTERCOM_HELPDOC_URL */], target: '_blank' },
            'Learn More.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
          placeholder: 'e.g. 123456',
          label: 'API KEY',
          valueLink: {
            requestChange: function requestChange(input) {
              _this.setState({ apiKey: input });
            },
            value: _this.state.apiKey
          },
          isValid: !!_this.state.apiKey
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body color-gray-dark' },
          'Please use a "Read Only" API Key. Need help finding it? Check out Intercom\u2019s ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: FindIntercomIdLink },
            'helpful instructions'
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Intercom, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Connect your Intercom account to Drift so you can sync your contacts automatically.'
        ),
        isConnected ? null : this.renderInputs(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__["a" /* default */], {
          integrationId: 'intercom',
          isConnected: isConnected,
          connectionPayload: this.getConnectionPayload() })
      );
    }
  }]);

  return Intercom;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Intercom);

/***/ }),

/***/ "9Gfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProfileUI", function() { return setProfileUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProfileUIData", function() { return setProfileUIData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentProfileStarted", function() { return fetchCurrentProfileStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentProfileFailed", function() { return fetchCurrentProfileFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfileStarted", function() { return updateProfileStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfileFailed", function() { return updateProfileFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfileSuccess", function() { return updateProfileSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkUserHandleExistenceStarted", function() { return checkUserHandleExistenceStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkUserHandleExistenceFailed", function() { return checkUserHandleExistenceFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveUserHandleExistence", function() { return receiveUserHandleExistence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveUserGlobalHandleExistence", function() { return receiveUserGlobalHandleExistence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVisibilityStarted", function() { return setVisibilityStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVisibilityFailed", function() { return setVisibilityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveProfile", function() { return receiveProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserProfile", function() { return fetchUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserProfilePending", function() { return fetchUserProfilePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserProfileSuccess", function() { return fetchUserProfileSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserProfileFailed", function() { return fetchUserProfileFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentProfile", function() { return fetchCurrentProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfile", function() { return updateProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOverview", function() { return updateOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateContact", function() { return updateContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateDetails", function() { return updateDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMessaging", function() { return updateMessaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTheme", function() { return updateTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createQuickProfile", function() { return createQuickProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkGlobalUserHandle", function() { return checkGlobalUserHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkUserHandle", function() { return checkUserHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVisibility", function() { return setVisibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearCoverPhoto", function() { return clearCoverPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCoverPhotoStarted", function() { return uploadCoverPhotoStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCoverPhotoSuccess", function() { return uploadCoverPhotoSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCoverPhotoFailed", function() { return uploadCoverPhotoFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCoverPhoto", function() { return uploadCoverPhoto; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_org__ = __webpack_require__("rDli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_FileAPI__ = __webpack_require__("0OV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__("Iz1I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("QF6P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectorsUI__ = __webpack_require__("vTSr");














var setProfileUI = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].SET_PROFILE_UI);
var setProfileUIData = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].SET_PROFILE_UI_DATA);

var fetchCurrentProfileStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_CURRENT_PROFILE_STARTED);
var fetchCurrentProfileFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_CURRENT_PROFILE_FAILED);

var updateProfileStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPDATE_PROFILE_STARTED);
var updateProfileFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPDATE_PROFILE_FAILED);
var updateProfileSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPDATE_PROFILE_SUCCESS);

var checkUserHandleExistenceStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].CHECK_USER_HANDLE_EXISTENCE_STARTED);
var checkUserHandleExistenceFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].CHECK_USER_HANDLE_EXISTENCE_FAILED);
var receiveUserHandleExistence = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].RECEIVE_USER_HANDLE_EXISTENCE);
var receiveUserGlobalHandleExistence = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].RECEIVE_USER_GLOBAL_HANDLE_EXISTENCE);

var setVisibilityStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].SET_VISIBILITY_STARTED);
var setVisibilityFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].SET_VISIBILITY_FAILED);

var receiveProfile = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].RECEIVE_PROFILE);

var fetchUserProfile = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_USER_PROFILE);
var fetchUserProfilePending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_USER_PROFILE_PENDING);
var fetchUserProfileSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_USER_PROFILE_SUCCESS);
var fetchUserProfileFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].FETCH_USER_PROFILE_FAILED);

var fetchCurrentProfile = function fetchCurrentProfile() {
  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_3_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      var state = getState();
      if (shouldFetchProfile(state)) {
        var user = __WEBPACK_IMPORTED_MODULE_3_app_modules_user__["c" /* selectors */].currentUser(state);

        dispatch(fetchCurrentProfileStarted());
        return Promise.all([_fetchCurrentProfile(user.id, dispatch), dispatch(__WEBPACK_IMPORTED_MODULE_2_app_modules_org__["a" /* actions */].fetchOrg())]);
      }
    });
  };
};

function _fetchCurrentProfile(userId, dispatch) {
  return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetch(userId).then(function (data) {
    return dispatch(receiveProfile(data));
  }).catch(function (error) {
    Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
    dispatch(fetchCurrentProfileFailed());
    throw error;
  });
}

function shouldFetchProfile(state) {
  return __WEBPACK_IMPORTED_MODULE_11__selectors__["profileFetchStatus"](state) !== __WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].RECEIVE_PROFILE;
}

var updateSectionFactory = function updateSectionFactory(uiSelector, selector) {
  return function () {
    return function (dispatch, getState) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_3_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
        var state = getState();
        var user = __WEBPACK_IMPORTED_MODULE_3_app_modules_user__["c" /* selectors */].currentUser(state);
        var oldProfile = selector(state).toJS();
        var newProfile = uiSelector(state).toJS();
        return _updateProfile(user.id, newProfile, oldProfile, dispatch, state);
      });
    };
  };
};

var updateProfile = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["k" /* profile */], __WEBPACK_IMPORTED_MODULE_11__selectors__["profile"]);
var updateOverview = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["j" /* overview */], __WEBPACK_IMPORTED_MODULE_11__selectors__["overview"]);
var updateContact = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["l" /* social */], __WEBPACK_IMPORTED_MODULE_11__selectors__["social"]);
var updateDetails = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["b" /* details */], __WEBPACK_IMPORTED_MODULE_11__selectors__["details"]);
var updateMessaging = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["i" /* messaging */], __WEBPACK_IMPORTED_MODULE_11__selectors__["messaging"]);
var updateTheme = updateSectionFactory(__WEBPACK_IMPORTED_MODULE_12__selectorsUI__["m" /* theme */], __WEBPACK_IMPORTED_MODULE_11__selectors__["theme"]);

var createQuickProfile = function createQuickProfile() {
  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_3_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      var state = getState();
      var user = __WEBPACK_IMPORTED_MODULE_3_app_modules_user__["c" /* selectors */].currentUser(state);

      // should be action --> reducer --> thunk
      var operations = [{
        operation: 'set',
        property: 'layout',
        value: 'WIDE'
      }, {
        operation: 'set',
        property: 'visibility',
        value: 'PUBLIC'
      }];

      __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].update(user.id, operations).then(function (data) {
        dispatch(updateProfileSuccess(data));
        dispatch(receiveProfile(data));
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
        dispatch(updateProfileFailed());
        throw error;
      });
    });
  };
};

function _updateProfile(userId, profileUI, profile, dispatch, state) {
  var operations = Object(__WEBPACK_IMPORTED_MODULE_7_utils_PatchHelper__["a" /* patchOperations */])(profileUI, profile);
  dispatch(updateProfileStarted());
  if (operations.length > 0) {
    __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].update(userId, operations).then(function (data) {
      dispatch(updateProfileSuccess(data));
      dispatch(receiveProfile(data));
      if (!Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_router_selectors__["c" /* onOnboarding */])(state)) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Your Drift Profile has been saved!',
          variant: 'green'
        });
      }
      if (!profile.handle && profileUI.handle) {
        dispatch(__WEBPACK_IMPORTED_MODULE_4_app_modules_tracking__["a" /* actions */].track('Created Profile', {
          context: 'existing-user',
          handle: profileUI.handle
        }));
      } else {
        dispatch(__WEBPACK_IMPORTED_MODULE_4_app_modules_tracking__["a" /* actions */].track('Updated Profile', { operations: operations }));
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'An error occurred while updating your profile settings. Please try again later.',
        variant: 'red'
      });
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      dispatch(updateProfileFailed());
      throw error;
    });
  }
}

var checkGlobalUserHandle = function checkGlobalUserHandle(globalHandle) {
  return function (dispatch, getState) {
    var handle = globalHandle || __WEBPACK_IMPORTED_MODULE_12__selectorsUI__["e" /* handle */](getState());
    if (!handle.length > 0) return;
    dispatch(checkUserHandleExistenceStarted());
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].checkGlobalHandle(handle).then(function (res) {
      if (res.status === 404) {
        return dispatch(receiveUserGlobalHandleExistence({ globalHandle: globalHandle, valid: true }));
      } else if (res.status === 200) {
        return dispatch(receiveUserGlobalHandleExistence({ valid: false }));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to check handle existence for global handle ' + handle));
      }
    });
  };
};

var checkUserHandle = function checkUserHandle(handle) {
  return function (dispatch, getState) {
    var newHandle = handle || __WEBPACK_IMPORTED_MODULE_12__selectorsUI__["e" /* handle */](getState());
    if (!newHandle.length > 0) return;
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].checkUserHandle(newHandle).then(function (res) {
      if (res.status === 404) {
        return dispatch(receiveUserHandleExistence({ valid: true }));
      } else if (res.status === 200) {
        return dispatch(receiveUserHandleExistence({ valid: false }));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to check org handle existence for handle ' + newHandle));
      }
    });
  };
};

var setVisibility = function setVisibility(visible) {
  var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (dispatch, getState) {
    var state = getState();
    var user = __WEBPACK_IMPORTED_MODULE_3_app_modules_user__["c" /* selectors */].currentUser(state);
    var originalVisibility = __WEBPACK_IMPORTED_MODULE_11__selectors__["visibility"](state);

    dispatch(setVisibilityStarted(visible));
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].update(user.id, getOperations(visible)).then(function () {
      if (notify) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Your profile’s privacy has been saved!',
          variant: 'green'
        });
      }
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'An error occurred while updating your profile visibility. Please try again later.',
        variant: 'red'
      });
      dispatch(setVisibilityFailed(originalVisibility));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

function getOperations(visible) {
  return [{
    operation: 'set',
    property: 'visibility',
    value: visible
  }];
}

var clearCoverPhoto = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].CLEAR_COVER_PHOTO);
var uploadCoverPhotoStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPLOAD_COVER_PHOTO_STARTED);
var uploadCoverPhotoSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPLOAD_COVER_PHOTO_SUCCESS);
var uploadCoverPhotoFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_10__constants__["c" /* constants */].UPLOAD_COVER_PHOTO_FAILED);
var uploadCoverPhoto = function uploadCoverPhoto(file) {
  return function (dispatch) {
    dispatch(uploadCoverPhotoStarted({ file: file }));
    __WEBPACK_IMPORTED_MODULE_8_app_api_FileAPI__["a" /* upload */](file).then(function (response) {
      dispatch(uploadCoverPhotoSuccess(response));
      dispatch(updateProfile());
    }).catch(function (error) {
      dispatch(uploadCoverPhotoFailed(error));
    });
  };
};

/***/ }),

/***/ "9I79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demandbase__ = __webpack_require__("aVRA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("SKr3");
var _handleActions3, _handleActions4, _handleActions5;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var companyByEndUserId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* receiveEndUserCompanyData */], function (state, action) {
  var _action$payload = action.payload,
      endUserId = _action$payload.endUserId,
      data = _action$payload.data;

  return state.set(endUserId, data);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchEnrichedCompanyDataPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchEnrichedCompanyDataNoResult */], __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchEnrichedCompanyDataSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* fetchEnrichedCompanyDataFailed */], __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchEnrichedCompanyDataCancelled */]), function (state, action) {
  var _action$payload2 = action.payload,
      ip = _action$payload2.ip,
      email = _action$payload2.email;

  return state.set(ip + '-' + email, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var company = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchEnrichedCompanyDataSuccess */], function (state, action) {
  var _action$payload3 = action.payload,
      data = _action$payload3.data,
      ip = _action$payload3.ip,
      email = _action$payload3.email;

  return state.set(ip + '-' + email, data);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* fetchBulkConversationEnrichmentDataSuccess */], function (state, action) {
  var data = action.payload.data;

  var map = {};
  Object.keys(data).forEach(function (conversationId) {
    var user = data[conversationId];
    var enrichmentSources = user.enrichmentSources,
        enrichmentData = user.enrichmentData;

    var ip = enrichmentSources.ip || undefined;
    var email = enrichmentSources.email || undefined;
    map[ip + '-' + email] = enrichmentData;
  });
  return state.merge(map);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var enrichmentSourcesByConversationId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions4 = {}, _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchEnrichedCompanyDataSuccess */], function (state, action) {
  var _action$payload4 = action.payload,
      ip = _action$payload4.ip,
      email = _action$payload4.email,
      conversationId = _action$payload4.conversationId;

  return state.set('' + conversationId, ip + '-' + email);
}), _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* fetchBulkConversationEnrichmentDataSuccess */], function (state, action) {
  var data = action.payload.data;

  var map = {};
  Object.keys(data).forEach(function (conversationId) {
    var user = data[conversationId];
    var enrichmentSources = user.enrichmentSources;

    var email = enrichmentSources.email || undefined;
    var ip = enrichmentSources.ip || undefined;
    map[conversationId] = ip + '-' + email;
  });
  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(map));
}), _handleActions4), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var decodedConditions = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* fetchDecodedConditionPending */], function (state, action) {
  var conditions = action.payload.conditions;

  var map = {};
  conditions.forEach(function (condition) {
    return map[condition] = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ status: action.type, data: null, error: null });
  });
  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(map));
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* fetchDecodedConditionSuccess */], function (state, action) {
  var conditions = action.payload.conditions;

  var map = {};
  conditions.forEach(function (decrypted, encrypted) {
    return map[encrypted] = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ status: action.type, data: decrypted, error: null });
  });
  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(map));
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* fetchDecodedConditionFailed */], function (state, action) {
  var _action$payload5 = action.payload,
      conditions = _action$payload5.conditions,
      err = _action$payload5.err;

  var map = {};
  conditions.forEach(function (encrypted) {
    return map[encrypted] = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ status: action.type, error: err, data: null });
  });
  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(map));
}), _handleActions5), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
  status: status,
  company: company,
  demandbase: __WEBPACK_IMPORTED_MODULE_3__demandbase__["b" /* reducer */],
  decodedConditions: decodedConditions,
  enrichmentSourcesByConversationId: enrichmentSourcesByConversationId,
  companyByEndUserId: companyByEndUserId
}));

/***/ }),

/***/ "9MpX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("3Jc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var PlaybookDraftToggle = function PlaybookDraftToggle(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return React.createElement(
    'span',
    { className: 'playbook-toggle-container' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toggle__["a" /* default */], {
      className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('playbook-toggle', className),
      icons: {
        checked: React.createElement(
          'span',
          null,
          'On'
        ),
        unchecked: React.createElement(
          'span',
          null,
          'Off'
        )
      },
      defaultValue: props.defaultValue,
      checked: props.checked,
      onChange: props.onChange
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PlaybookDraftToggle);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "9Myh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_DefaultEmbedConstants__ = __webpack_require__("W8CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_OrgSettingsConstants__ = __webpack_require__("rc0/");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OrgSettingsStore = function (_Marty$Store) {
  _inherits(OrgSettingsStore, _Marty$Store);

  function OrgSettingsStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OrgSettingsStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrgSettingsStore.__proto__ || Object.getPrototypeOf(OrgSettingsStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = false, _this.handlers = {
      updateOrgSettingsFromEmbed: [__WEBPACK_IMPORTED_MODULE_2_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_DONE],
      updateOrgSettings: [__WEBPACK_IMPORTED_MODULE_3_constants_OrgSettingsConstants__["a" /* default */].ORG_SETTINGS_UPDATED],
      updateProperty: [__WEBPACK_IMPORTED_MODULE_3_constants_OrgSettingsConstants__["a" /* default */].UPLOAD_WIDGET_ICON_FINISHED]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OrgSettingsStore, [{
    key: 'dehydrate',
    value: function dehydrate() {
      if (!!this.state) {
        return this.state.toJS();
      }
      return this.state;
    }
  }, {
    key: 'rehydrate',
    value: function rehydrate(dehydratedState) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(dehydratedState);
    }
  }, {
    key: 'getOrgSettings',
    value: function getOrgSettings() {
      return this.fetch({
        id: 'getOrgSettings',
        dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg(), this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed()],
        locally: function locally() {
          if (!this.state) {
            var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
            var embed = this.app.stores.DefaultEmbedStore.state.embedByOrgId[orgId];

            this.state = Object(__WEBPACK_IMPORTED_MODULE_1_components_Customize_OrgSettings_Helpers__["c" /* getOrgSettingsFromEmbed */])(embed);
          }

          return this.state;
        }
      });
    }
  }, {
    key: 'updateOrgSettings',
    value: function updateOrgSettings(orgSettings) {
      this.state = orgSettings;
    }
  }, {
    key: 'updateOrgSettingsFromEmbed',
    value: function updateOrgSettingsFromEmbed(embed) {
      this.state = Object(__WEBPACK_IMPORTED_MODULE_1_components_Customize_OrgSettings_Helpers__["c" /* getOrgSettingsFromEmbed */])(embed);
    }
  }, {
    key: 'updateProperty',
    value: function updateProperty(key, value) {
      this.state = this.state.setIn(key, value);
    }
  }]);

  return OrgSettingsStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (OrgSettingsStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "9NS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__("6DhX");



var ModalSidesheet = function ModalSidesheet(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      title = _ref.title;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */],
    { isModal: true, onClose: onClose, title: title },
    children
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ModalSidesheet);

/***/ }),

/***/ "9QV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TIMELINE_EVENTS_FOR_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_TIMELINE_EVENTS_FOR_END_USER_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_TIMELINE_EVENTS_FOR_END_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_TIMELINE_EVENTS_FOR_END_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('endUser/timeline');

var FETCH_TIMELINE_EVENTS_FOR_END_USER = makeConstant('FETCH_TIMELINE_EVENTS_FOR_END_USER');
var FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING = makeConstant('FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING');
var FETCH_TIMELINE_EVENTS_FOR_END_USER_CANCELLED = makeConstant('FETCH_TIMELINE_EVENTS_FOR_END_USER_CANCELLED');
var FETCH_TIMELINE_EVENTS_FOR_END_USER_FAILED = makeConstant('FETCH_TIMELINE_EVENTS_FOR_END_USER_FAILED');
var FETCH_TIMELINE_EVENTS_FOR_END_USER_SUCCESS = makeConstant('FETCH_TIMELINE_EVENTS_FOR_END_USER_SUCCESS');

var LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER = makeConstant('LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER');
var LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING = makeConstant('LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING');
var LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_CANCELLED = makeConstant('LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_CANCELLED');
var LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_FAILED = makeConstant('LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_FAILED');
var LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_SUCCESS = makeConstant('LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_SUCCESS');

/***/ }),

/***/ "9SVm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTIyIiBoZWlnaHQ9Ijc5NCIgdmlld0JveD0iMCAwIDExMjIgNzk0Ij48cGF0aCBkPSJNNDMzLjQ2NCA2NjcuMDVjLTEyLjE0My00Mi4xNDItNDQuMDA3LTc3LjQ5MS03OC44MzUtMTAzLjExLTQ2LjY5LTMzLjQ3LTEwNy41MDItMjYuMzk2LTE1OS4wOS00NS44NzctNDIuMDI2LTMxLjIyNS0xLjgzMy02NS42NzIgMjYuNDI0LTg3LjA0OCA2My4xMzItNTQuNzY1IDU1LjM3Ni0xNTYuODg4IDUuMTAzLTIxNy40My0zMy41OC00My4zOTktMTA0LjYtNzIuNTI2LTEzOS42Mi04NC44NzYtNTIuNzc2LTUyLjc3OSAxNDAuNjY5LTk4Ljk2MiA3Ni44LTYzLjA3NS0yMS41OTcgOS4yNS00My43MyAyNi41MjUtMy44MzggMzYuOTQ2IDQ2LjYwOCAxNC40NDUgMTU3LjAwMiAxMDQuNjM0IDE2OS43NiAxOTQuMTI1IDkuNzk0IDQ3LjQ4NS0zLjQ0MyAxMDEuMTk5LTIxLjA0IDE0NS4zNEM0MjQuMDUgNDc4LjM4OCA0NzMuNDE0IDU2MC4yMSA1MjguMjY0IDY2Ni4wNjJjLS4yMjMtLjE4LTI2LjAwNSAxLjU3Mi05NC44Ljk5em0yMTUuNjI2IDMuMzk2YzEyLjE0My00Mi4xNDIgNDQuMDA3LTc3LjQ5MSA3OC44MzYtMTAzLjExIDQ2LjY4OS0zMy40NzEgMTA3LjUwMS0yNi4zOTYgMTU5LjA5LTQ1Ljg3NyA0Mi4wMjUtMzEuMjI1IDEuODMzLTY1LjY3My0yNi40MjUtODcuMDQ4LTYzLjEzMi01NC43NjUtNTUuMzc1LTE1Ni44ODgtNS4xMDMtMjE3LjQzMSAzMy41OC00My4zOTggMTA0LjYtNzIuNTI1IDEzOS42Mi04NC44NzUgNTIuNzc3LTUyLjc3OC0xNDAuNjY3LTk4Ljk2Mi03Ni43OTktNjMuMDc1IDIxLjU5OCA5LjI1IDQzLjczIDI2LjUyNCAzLjgzOCAzNi45NDYtNDYuNjA4IDE0LjQ0NS0xNTcuMDAyIDEwNC42MzQtMTY5Ljc2IDE5NC4xMjUtOS43OTMgNDcuNDg1IDMuNDQzIDEwMS4xOTkgMjEuMDQgMTQ1LjM0LTExNC45MjIgMzYuMzQyLTE2NC4yODYgMTE4LjE2NC0yMTkuMTM3IDIyNC4wMTYuMjIzLS4xOCAyNi4wMDUgMS41NzIgOTQuOC45OXoiLz48L3N2Zz4K"

/***/ }),

/***/ "9SsH":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA0NyA0NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTIzLjUgNDdDMTAuNTQyNjg3NSA0NyAwIDM2LjQ1ODc4MTIgMCAyMy41IDAgMTAuNTQyNjg3NSAxMC41NDI2ODc1IDAgMjMuNSAwUzQ3IDEwLjU0MjY4NzUgNDcgMjMuNUM0NyAzNi40NTg3ODEyIDM2LjQ1NzMxMjUgNDcgMjMuNSA0N3oiIGZpbGw9IiMxM0NCNkUiLz4KICAgIDxwYXRoIGQ9Ik0zNi44ODg4MzQ1IDE5LjQ1OTcxNzZjLjg5NzU1MDItLjkwNDQ3Mi44OTExMjYxLTIuMzY1NTkyOS0uMDEzNjUzOS0zLjI2MzQ0ODUtLjkwNDI5ODEtLjg5OTY4NTQtMi4zNjg2NDk1LS44OTMyNTAyLTMuMjY1MjQ0OS4wMTQ4OTkyTDIwLjU0NjkxMSAyOS4zNzIwNTI5bC03LjMwMTUyOTktNi4yMDc2NTc2Yy0uOTczOTgxLS44MjYyNjg5LTIuNDI4OTE3MS0uNzA3ODc3LTMuMjU0NTc2OTcuMjY1Mzg2OS0uODI1MzQ4NjIuOTY4MjgyNS0uNzA2NzE2MjQgMi40MjY4ODkuMjYzODgzNzcgMy4yNTE4OTlsOC45Mzg3NTc2IDcuNTk5MjY1OGMuNDE5MjMxOS4zNTg3MDY2Ljk0OTcwMTUuNTQ5NDEwMSAxLjQ5NTM2Ny41NDk0MTAxLjYxMDkxMzcgMCAxLjIwMjAxMTQtLjI0MTgxMjYgMS42MzkzMTI3LS42ODM2MjIybDE0LjU2MDcwOTMtMTQuNjg3MDE3M3oiIGZpbGw9IiNGRkYiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "9U7y":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(202);

/***/ }),

/***/ "9WSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("O2cg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("e/xQ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "9ZnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagType; });
/* unused harmony export TagStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__);




var TagType = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  ANY: null,
  CONVERSATION: null
});

var TagStatus = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  ENABLED: null,
  ARCHIVED: null
});

var constants = __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  FETCH_TAG_LIST_PENDING: null,
  FETCH_TAG_LIST_FAILED: null,
  RECEIVE_TAG_LIST: null,

  CREATE_TAG_PENDING: null,
  CREATE_TAG_FAILED: null,

  UPDATE_TAG_PENDING: null,
  UPDATE_TAG_FAILED: null,
  RECEIVE_TAG: null,

  DELETE_TAG_PENDING: null,
  DELETE_TAG_FAILED: null,
  DELETE_TAG_SUCCESS: null,

  TAG_CONVERSATION_PENDING: null,
  TAG_CONVERSATION_FAILED: null,
  TAG_CONVERSATION_SUCCESS: null,

  UNTAG_CONVERSATION_PENDING: null,
  UNTAG_CONVERSATION_FAILED: null,
  UNTAG_CONVERSATION_SUCCESS: null,

  TAG_COMPANY_PENDING: null,
  TAG_COMPANY_FAILED: null,
  TAG_COMPANY_SUCCESS: null,

  UNTAG_COMPANY_PENDING: null,
  UNTAG_COMPANY_FAILED: null,
  UNTAG_COMPANY_SUCCESS: null,

  TAG_END_USER_PENDING: null,
  TAG_END_USER_FAILED: null,
  TAG_END_USER_SUCCESS: null,

  UNTAG_END_USER_PENDING: null,
  UNTAG_END_USER_FAILED: null,
  UNTAG_END_USER_SUCCESS: null,

  SET_RESPONSE_TAGS_PENDING: null,
  SET_RESPONSE_TAGS_FAILED: null,
  SET_RESPONSE_TAGS_SUCCESS: null
}), __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default.a);

/***/ }),

/***/ "9b51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_plus_svg__ = __webpack_require__("EI0t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_close_svg__ = __webpack_require__("DHpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_close_svg__);







var SelectsContainer = function SelectsContainer(_ref) {
  var options = _ref.options,
      _onChange = _ref.onChange,
      value = _ref.value,
      className = _ref.className,
      placeholder = _ref.placeholder,
      _ref$creatable = _ref.creatable,
      creatable = _ref$creatable === undefined ? false : _ref$creatable,
      _ref$getValueDisplay = _ref.getValueDisplay,
      getValueDisplay = _ref$getValueDisplay === undefined ? function (x) {
    return x;
  } : _ref$getValueDisplay;
  return React.createElement(
    'div',
    { className: className },
    React.createElement(
      'div',
      null,
      (value || __WEBPACK_IMPORTED_MODULE_1_immutable__["List"].of('')).map(function (innerValue, index) {
        return React.createElement(
          'div',
          { className: 'flex', style: { marginBottom: 10 }, key: index },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Select"], {
            key: index,
            clearable: false,
            value: value.get(index) === '' ? null : { value: value.get(index), label: getValueDisplay(value.get(index)) },
            onChange: function onChange(event) {
              return event && _onChange(value.set(index, event.value));
            },
            placeholder: placeholder,
            options: options,
            creatable: creatable
          }),
          index === 0 ? React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_plus_svg___default.a, onClick: function onClick() {
              return _onChange(value.push(''));
            } }) : React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_close_svg___default.a, onClick: function onClick() {
              return _onChange(value.delete(index));
            } })
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SelectsContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "9eSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var EndUserConstants = Marty.createConstants(['END_USER_FETCH', 'END_USERS_FETCH', 'END_USER_ATTRIBUTES_FETCH', 'SEARCH_END_USER', 'ELASTIC_SEARCH_END_USER', 'END_USER_LIST_FETCH', 'END_USER_UPDATE', 'END_USER_UNSUBSCRIBE', 'CREATE_USER_FOR_ORG_ID', 'SET_END_USER_FROM_PUSHER', 'DELETE_END_USERS', 'DELETE_END_USERS_BULK', 'END_USER_SEGMENTS_FETCH']);

/* harmony default export */ __webpack_exports__["a"] = (EndUserConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "9eyw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(531);

/***/ }),

/***/ "9gNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presenceDiff", function() { return presenceDiff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "presenceDiffLeaves", function() { return presenceDiffLeaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendWelcomeMessage", function() { return sendWelcomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendWelcomeMessageSuccess", function() { return sendWelcomeMessageSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendWelcomeMessageFailure", function() { return sendWelcomeMessageFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFilters", function() { return setFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewFilters", function() { return setNewFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewSorts", function() { return setNewSorts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFilterKnownUsers", function() { return setFilterKnownUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPagination", function() { return setPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomInterval", function() { return setCustomInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShowMore", function() { return setShowMore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initializePresenceForUsers", function() { return initializePresenceForUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPresenceIsReceiving", function() { return setPresenceIsReceiving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bootstrapUser", function() { return bootstrapUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bootstrapUserSuccess", function() { return bootstrapUserSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bootstrapUserError", function() { return bootstrapUserError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBufferedUsers", function() { return setBufferedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProcessAllUsers", function() { return setProcessAllUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUserProcessed", function() { return addUserProcessed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeUserProcessed", function() { return removeUserProcessed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeUserProcessedDelayed", function() { return removeUserProcessedDelayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendActiveStatus", function() { return sendActiveStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPresenceProblems", function() { return setPresenceProblems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPresenceLoading", function() { return setPresenceLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewLiveUsers", function() { return setNewLiveUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPresenceStateOnInterval", function() { return getPresenceStateOnInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelPresenceInterval", function() { return cancelPresenceInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHasProcessedUsers", function() { return setHasProcessedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messageSent", function() { return messageSent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("a2hK");



var presenceDiff = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* PRESENCE_DIFF */]);
var presenceDiffLeaves = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* PRESENCE_DIFF_LEAVES */]);

var sendWelcomeMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SEND_WELCOME_MESSAGE */]);
var sendWelcomeMessageSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SEND_WELCOME_MESSAGE_SUCCESS */]);
var sendWelcomeMessageFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SEND_WELCOME_MESSAGE_FAILURE */]);

var setFilters = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* SET_FILTERS */]);
var setNewFilters = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SET_NEW_FILTERS */]);
var setNewSorts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* SET_NEW_SORTS */]);
var setFilterKnownUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_FILTER_KNOWN_USERS */]);
var setPagination = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_PAGINATION */]);
var setCustomInterval = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* SET_CUSTOM_INTERVAL */]);

var setShowMore = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* SET_SHOW_MORE */]);

var initializePresenceForUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* INITIALIZE_PRESENCE_FOR_USERS */]);
var setPresenceIsReceiving = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_PRESENCE_IS_RECEIVING */]);

var bootstrapUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BOOTSTRAP_USER */]);
var bootstrapUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BOOTSTRAP_USER_SUCCESS */]);
var bootstrapUserError = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BOOTSTRAP_USER_ERROR */]);

var setBufferedUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SET_BUFFERED_USERS */]);

var setProcessAllUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* SET_PROCESS_ALL_USERS */]);
var addUserProcessed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ADD_USER_PROCESSED */]);
var removeUserProcessed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* REMOVE_USER_PROCESSED */]);
var removeUserProcessedDelayed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* REMOVE_USER_PROCESSED_DELAYED */]);

var sendActiveStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SEND_ACTIVE_STATUS */]);
var setPresenceProblems = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* SET_PRESENCE_PROBLEMS */]);
var setPresenceLoading = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* SET_PRESENCE_LOADING */]);

var setNewLiveUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_NEW_LIVE_USERS */]);

var getPresenceStateOnInterval = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* GET_PRESENCE_STATE_ON_INTERVAL */]);
var cancelPresenceInterval = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CANCEL_PRESENCE_INTERVAL */]);

var setHasProcessedUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_HAS_PROCESSED_USERS */]);
var messageSent = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* MESSAGE_SENT */]);

/***/ }),

/***/ "9hk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("aae1");










function makeMapStateToProps() {
  return function (state) {
    return {
      profileUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["profileUrl"](state),
      profileUrlHandle: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["profileUrlHandle"](state),
      profileVisibility: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["visibility"](state)
    };
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      deleteMeetingType: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["b" /* deleteMeetingType */],
      updateSettings: props.isDefault ? __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["a" /* debounceUpdateMeetingSettings */] : __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["_31" /* updateMeetingType */],
      fetchMeetingTypes: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["O" /* fetchMeetingTypes */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('isDeleting', 'setIsDeleting', false), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('isCopied', 'setIsCopied', false), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  handleCopyMeetingLink: function handleCopyMeetingLink(props) {
    return function () {
      props.setIsCopied(true);

      setTimeout(function () {
        props.setIsCopied(false);
      }, 2000);
    };
  },
  handleDeleteMeetingType: function handleDeleteMeetingType(_ref) {
    var actions = _ref.actions,
        setIsDeleting = _ref.setIsDeleting,
        settings = _ref.settings;
    return function () {
      setIsDeleting(true);
      actions.deleteMeetingType(settings.slug);
    };
  }
}), __WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "9jpW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9omE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(533);

/***/ }),

/***/ "9pOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9tpJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__ = __webpack_require__("dZeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_UserConstants__ = __webpack_require__("1rl7");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var OrgStore = Marty.createStore({
  id: 'OrgStore',

  getInitialState: function getInitialState() {
    return {
      orgsById: {},
      resendInvitationState: {},
      orgUpdateState: {},
      billingState: null
    };
  },


  handlers: {
    handleOrgCreateDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_CREATE_DONE,
    handleOrgFetchDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_FETCH_DONE,

    handleOrgUpdateStarting: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_STARTING,
    handleOrgUpdateDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_DONE,

    shareEmailSnippet: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET,
    shareEmailSnippetDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_DONE,

    // fetch current org as soon as current user available
    getOrFetchCurrentOrg: __WEBPACK_IMPORTED_MODULE_1_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_DONE
  },

  setOrg: function setOrg(org) {
    var orgsById = _.cloneDeep(this.state.orgsById);
    orgsById[org.id] = org;
    this.setState({ orgsById: orgsById });
  },
  handleOrgCreateDone: function handleOrgCreateDone(org) {
    return this.setOrg(org);
  },
  handleOrgFetchDone: function handleOrgFetchDone(org) {
    return this.setOrg(org);
  },
  handleOrgUpdateStarting: function handleOrgUpdateStarting(orgId) {
    this.state.orgUpdateState[orgId] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_STARTING;
    return this.setState({
      orgUpdateState: this.state.orgUpdateState
    });
  },
  handleOrgUpdateDone: function handleOrgUpdateDone(orgId, org) {
    this.state.orgUpdateState[orgId] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_DONE;
    this.setState({
      orgUpdateState: this.state.orgUpdateState
    });
    return this.setOrg(org);
  },
  getOrgUpdateState: function getOrgUpdateState() {
    return this.state.orgUpdateState;
  },
  shareEmailSnippet: function shareEmailSnippet(email, orgId) {
    this.setState({ invitationState: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_STARTING });
    return this.app.queries.OrgQueries.shareSnippet(email, orgId);
  },
  shareEmailSnippetDone: function shareEmailSnippetDone(email, orgId) {
    // TODO remove when new-user pushes invited users
    // if the emails has just been invited, we need to refresh the userStore to include them
    this.app.queries.UserQueries.fetchUsersForOrgId(orgId);
    return this.setState({ invitationState: __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_DONE });
  },
  getInvitationState: function getInvitationState() {
    return this.state.invitationState;
  },
  getResendInvitationState: function getResendInvitationState() {
    return this.state.resendInvitationState;
  },
  resetResendInvitationState: function resetResendInvitationState() {
    return this.setState({ resendInvitationState: {} });
  },
  getOrFetchCurrentOrg: function getOrFetchCurrentOrg() {
    return this.fetch({
      id: 'getOrFetchCurrentOrg',
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally: function locally() {
        return this.state.orgsById[this.app.stores.UserStore.getCurrentUser().orgId];
      },
      remotely: function remotely() {
        return this.app.queries.OrgQueries.fetchOrgById(this.app.stores.UserStore.getCurrentUser().orgId);
      }
    });
  },
  getCurrentOrg: function getCurrentOrg() {
    if (!this.app.stores.UserStore.getCurrentUser()) {
      return;
    }
    return this.state.orgsById[this.app.stores.UserStore.getCurrentUser().orgId];
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "9uhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_demandbase_selectors__ = __webpack_require__("OtCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_demandbase_actions__ = __webpack_require__("FFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectFilter__ = __webpack_require__("ANGi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var mapToOptions = function mapToOptions(values) {
  return !!values ? values.map(function (value) {
    return { label: value, value: value };
  }) : [];
};

var DemandbaseSubIndustryFilter = function (_PureComponent) {
  _inherits(DemandbaseSubIndustryFilter, _PureComponent);

  function DemandbaseSubIndustryFilter() {
    _classCallCheck(this, DemandbaseSubIndustryFilter);

    return _possibleConstructorReturn(this, (DemandbaseSubIndustryFilter.__proto__ || Object.getPrototypeOf(DemandbaseSubIndustryFilter)).apply(this, arguments));
  }

  _createClass(DemandbaseSubIndustryFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var actions = this.props.actions;


      actions.fetchDemandbaseTargetingSubIndustries();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSubIndustry = _props.isSubIndustry,
          demandbaseSubIndustries = _props.demandbaseSubIndustries,
          onUpdateCondition = _props.onUpdateCondition,
          activeFilter = _props.activeFilter;

      var options = mapToOptions(demandbaseSubIndustries);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SelectFilter__["a" /* default */], { options: options, onUpdateCondition: onUpdateCondition, activeFilter: activeFilter, creatable: true });
    }
  }]);

  return DemandbaseSubIndustryFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDemandbaseTargetingSubIndustries: __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_demandbase_actions__["j" /* fetchDemandbaseTargetingSubIndustries */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    demandbaseSubIndustries: __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_demandbase_selectors__["b" /* demandbaseTargetingSubIndustries */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DemandbaseSubIndustryFilter));

/***/ }),

/***/ "9zaA":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"-389.8 299 18.8 18.8\" style=\"enable-background:new -389.8 299 18.8 18.8;\" xml:space=\"preserve\"><g id=\"Product-Announcement\" sketch:type=\"MSPage\"><g id=\"PA-clicked\" transform=\"translate(-247.000000, -1623.000000)\" sketch:type=\"MSArtboardGroup\"><g id=\"Oval-28-_x2B_-Emily-Wade\" transform=\"translate(236.000000, 1612.000000)\" sketch:type=\"MSLayerGroup\"><path id=\"Add-Copy-4\" sketch:type=\"MSShapeGroup\" class=\"st0\" d=\"M-374.3,327.2c-0.8,0.8-2.1,0.8-3,0c-0.8-0.8-0.8-2.1,0-3 l4.4-4.4l-4.4-4.4c-0.8-0.8-0.8-2.1,0-3c0.8-0.8,2.1-0.8,3,0l4.4,4.4l4.4-4.4c0.8-0.8,2.1-0.8,3,0c0.8,0.8,0.8,2.1,0,3l-4.4,4.4 l4.4,4.4c0.8,0.8,0.8,2.1,0,3c-0.8,0.8-2.1,0.8-3,0l-4.4-4.4L-374.3,327.2z\"></path></g></g></g></svg>"

/***/ }),

/***/ "A1a6":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 13 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-886.000000, -742.000000)\" fill-rule=\"nonzero\" fill=\"#13CB6E\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"check-circle\" transform=\"translate(17.000000, 294.000000)\"><path d=\"M1.70710678,64.783298 C1.31658249,64.3927737 0.683417511,64.3927737 0.292893219,64.783298 C-0.0976310729,65.1738223 -0.0976310729,65.8069872 0.292893219,66.1975115 L3.55249442,69.4571127 C3.94301871,69.847637 4.57618369,69.847637 4.96670798,69.4571127 L12.7167139,61.7071068 C13.1072382,61.3165825 13.1072382,60.6834175 12.7167139,60.2928932 C12.3261896,59.9023689 11.6930247,59.9023689 11.3025004,60.2928932 L4.2596012,67.3357924 L1.70710678,64.783298 Z\" id=\"check\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "A38K":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 28\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Targeting-Iteration\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"dis-targeting\" transform=\"translate(-529.000000, -347.000000)\" fill=\"#394F5A\"><g id=\"window\" transform=\"translate(529.000000, 347.000000)\"><path d=\"M30,27.332 L2,27.332 C0.897333333,27.332 0,26.4353333 0,25.3333333 L0,2.666 C0,1.56333333 0.897333333,0.666 2,0.666 L30,0.666 C31.1026667,0.666 32,1.56333333 32,2.666 L32,25.3333333 C32,26.4353333 31.1026667,27.332 30,27.332 Z M30.6666667,2.666 C30.6666667,2.298 30.3673333,1.99933333 30,1.99933333 L2,1.99933333 C1.63266667,1.99933333 1.33333333,2.298 1.33333333,2.666 L1.33333333,5.99933333 L30.6666667,5.99933333 L30.6666667,2.666 Z M30.6666667,7.33266667 L1.33333333,7.33266667 L1.33333333,25.3333333 C1.33333333,25.7006667 1.63266667,25.9993333 2,25.9993333 L30,25.9993333 C30.3673333,25.9993333 30.6666667,25.7006667 30.6666667,25.3333333 L30.6666667,7.33266667 Z M3.34666667,3.36133333 L3.35333333,3.36133333 C3.722,3.36133333 4.02,3.65933333 4.02,4.028 C4.02,4.396 3.722,4.69466667 3.35333333,4.69466667 C2.98466667,4.69466667 2.68333333,4.396 2.68333333,4.028 C2.68333333,3.65933333 2.97866667,3.36133333 3.34666667,3.36133333 Z M5.34666667,3.36133333 L5.35333333,3.36133333 C5.72133333,3.36133333 6.02,3.65933333 6.02,4.028 C6.02,4.396 5.72133333,4.69466667 5.35333333,4.69466667 C4.98533333,4.69466667 4.68333333,4.396 4.68333333,4.028 C4.68333333,3.65933333 4.97866667,3.36133333 5.34666667,3.36133333 Z M7.34666667,3.36133333 L7.35333333,3.36133333 C7.722,3.36133333 8.02,3.65933333 8.02,4.028 C8.02,4.396 7.722,4.69466667 7.35333333,4.69466667 C6.98466667,4.69466667 6.68333333,4.396 6.68333333,4.028 C6.68333333,3.65933333 6.97866667,3.36133333 7.34666667,3.36133333 Z M16.442,22.4986667 C16.4066667,22.53 16.364,22.5466667 16.3246667,22.5693333 C16.2993333,22.584 16.2773333,22.6026667 16.2506667,22.614 C16.17,22.6466667 16.086,22.6666667 16,22.6666667 C16,22.6666667 16,22.666 16,22.666 C16,22.666 16,22.6666667 15.9993333,22.6666667 C15.914,22.6666667 15.83,22.6466667 15.7493333,22.614 C15.7226667,22.6026667 15.7006667,22.584 15.6753333,22.5693333 C15.636,22.5466667 15.5933333,22.53 15.5573333,22.4986667 L9.952,17.528 C9.13733333,16.7233333 8.66666667,15.6466667 8.66666667,14.6233333 C8.66666667,12.4413333 10.4606667,10.6666667 12.6666667,10.6666667 C14.058,10.6666667 15.2833333,11.3746667 16,12.444 C16.7166667,11.3746667 17.942,10.6666667 19.3333333,10.6666667 C21.5386667,10.6666667 23.3333333,12.4413333 23.3333333,14.6233333 C23.3333333,15.6466667 22.8626667,16.7233333 22.074,17.504 L16.442,22.4986667 Z M19.3333333,12 C17.8626667,12 16.6666667,13.1766667 16.6666667,14.6233333 C16.6666667,14.9913333 16.368,15.2893333 16,15.2893333 C15.632,15.2893333 15.3333333,14.9913333 15.3333333,14.6233333 C15.3333333,13.1766667 14.1373333,12 12.6666667,12 C11.196,12 10,13.1766667 10,14.6233333 C10,15.288 10.3306667,16.0286667 10.8633333,16.5546667 L16,21.1093333 L21.1633333,16.5306667 C21.6693333,16.0286667 22,15.288 22,14.6233333 C22,13.1766667 20.804,12 19.3333333,12 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "A3PM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InboxDropdown__ = __webpack_require__("7vo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_InboxButton__ = __webpack_require__("IhB6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_InboxButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_InboxButton__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// TODO -- refactor this to be reused for the inbox selector in the conversation header









var InboxButton = React.createClass({
  displayName: 'InboxButton',
  mixins: [__webpack_require__("aCGJ")],

  getInitialState: function getInitialState() {
    return { showInboxDropdown: false };
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'InboxButton' },
      React.createElement(
        'button',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()({ selected: this.state.showInboxDropdown }),
          onClick: this.handleOnClick },
        React.createElement(
          'div',
          null,
          this.props.selectedInbox != null ? this.props.selectedInbox.name : undefined
        ),
        React.createElement('img', { src: __webpack_require__("yhLl") })
      ),
      this.state.showInboxDropdown ? React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_components_DropDown__["a" /* default */],
        { className: 'inbox-dropdown', onClickOutside: this.handleClickOutside },
        React.createElement(__WEBPACK_IMPORTED_MODULE_2__InboxDropdown__["a" /* default */], {
          inboxes: this.props.inboxes,
          onSelectInbox: this.props.onSelectInbox,
          onClickOutside: this.handleClickOutside })
      ) : undefined
    );
  },
  handleClickOutside: function handleClickOutside() {
    return this.setState({ showInboxDropdown: false });
  },
  handleOnClick: function handleOnClick() {
    return this.setState({ showInboxDropdown: !this.state.showInboxDropdown });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (InboxButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "A9xC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_container__ = __webpack_require__("mKU3");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.




var WhoAmI = React.createClass({
  displayName: 'WhoAmI',
  render: function render() {
    var me = this.props.me;

    return React.createElement(
      'div',
      null,
      React.createElement(
        'h1',
        null,
        'You are'
      ),
      React.createElement(
        'pre',
        null,
        JSON.stringify(me, null, "\t")
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_components_container__["a" /* makeDefaultFailedContainer */])(WhoAmI, {
  listenTo: ['stores.UserStore'],
  fetch: {
    me: function me() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    }
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ACOC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_styl__ = __webpack_require__("agXk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var CalendarTabHeader = function CalendarTabHeader(_ref) {
  var view = _ref.view,
      closeTooltip = _ref.closeTooltip,
      hasSeenCalendarTooltip = _ref.hasSeenCalendarTooltip,
      hasSeenPersonalizeMeetingEmailsTooltip = _ref.hasSeenPersonalizeMeetingEmailsTooltip;

  var meetingsView = view === "MEETINGS";
  var calendarsView = view === "CALENDARS";

  var header = !hasSeenCalendarTooltip ? "Manage your calendar settings" : "Personalize your meeting emails";

  var body = !hasSeenCalendarTooltip ? "Here’s where you can customize when and how people can book meetings with you." : "Here’s where you can customize the emails that get sent when someone books a meeting with you.";

  var closeTooltipFunc = !hasSeenCalendarTooltip ? function () {
    return closeTooltip('HAS_SEEN_NEW_CALENDARS_SETTINGS_TAB');
  } : function () {
    return closeTooltip('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_TOOLTIP');
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'meeting-nav-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'meeting-nav' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('link', { selected: meetingsView }) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
            { to: '/settings/calendar' },
            'Meeting Types'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('link', { selected: calendarsView }) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8__driftt_tide_tooltips_legacy__["EducationTooltip"],
            {
              className: 'outreach-enable-tooltip',
              onClose: function onClose() {
                return closeTooltipFunc();
              },
              showTooltip: !hasSeenCalendarTooltip || !hasSeenPersonalizeMeetingEmailsTooltip,
              tooltipSide: 'right',
              tooltipCaretLocation: 'middle',
              headerCopy: header,
              bodyCopy: body
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
              { onClick: function onClick() {
                  return closeTooltipFunc();
                }, to: '/settings/calendar/advanced' },
              'Calendar Settings'
            )
          )
        )
      )
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProperties: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__["g" /* properties */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({
      fetchUserProperties: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__["a" /* fetchUserProperties */],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchUserProperties();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    hasSeenCalendarTooltip: props.userProperties && props.userProperties.get('HAS_SEEN_NEW_CALENDARS_SETTINGS_TAB', false),
    hasSeenPersonalizeMeetingEmailsTooltip: props.userProperties && props.userProperties.get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_TOOLTIP', false)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  closeTooltip: function closeTooltip(props) {
    return function (property) {
      return props.actions.updateUserProperties(_defineProperty({}, property, true), false);
    };
  }
}))(CalendarTabHeader));

/***/ }),

/***/ "AGXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_component_with_partials__ = __webpack_require__("Fbwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_component_with_partials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_component_with_partials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_translations_messages__ = __webpack_require__("nAcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Customize_InputWithLimit__ = __webpack_require__("hHEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_settings_UserProfile_Section__ = __webpack_require__("1Pxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl__ = __webpack_require__("xZDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var MessagingInfo = function (_Component) {
  _inherits(MessagingInfo, _Component);

  function MessagingInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MessagingInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessagingInfo.__proto__ || Object.getPrototypeOf(MessagingInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      valid: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()
    }, _this.handleChange = function (key, value, isValid) {
      var valid = _this.state.valid.set(key, isValid);
      _this.setState({ valid: valid });
      _this.props.actions.setProfileUIData({ key: key, value: value });
    }, _this.handleSave = function () {
      if (!_this.canSubmit()) return;

      _this.props.actions.updateMessaging();
    }, _this.handleCancel = function () {
      _this.props.actions.setProfileUI(_this.props.messaging);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MessagingInfo, [{
    key: 'renderDeprecated',
    value: function renderDeprecated() {
      var _props = this.props,
          intl = _props.intl,
          partial = _props.partial,
          messagingUI = _props.messagingUI,
          orgSettings = _props.orgSettings;
      var _orgSettings$theme = orgSettings.theme,
          welcomeMessagePlaceholder = _orgSettings$theme.welcomeMessage,
          awayMessagePlaceholder = _orgSettings$theme.awayMessage;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_components_settings_UserProfile_Section__["b" /* Subsection */],
        { title: 'Welcome Message',
          isValid: this.isValid(),
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel

        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { width: "100%" } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'color-navy-dark dsg-Body' },
            'You can customize the welcome message that appears on your profile page. These messages will respect the ',
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Link */],
              { to: '/settings/widget/hours-and-targeting' },
              'online hours'
            ),
            ' set by your company.'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.MessagingInfo },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'flex-1', style: { marginRight: "4rem" } },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Customize_InputWithLimit__["a" /* default */], {
                title: 'Online message',
                text: messagingUI.welcomeMessage || "",
                isTextAreaAutosize: false,
                isTextArea: true,
                placeholder: welcomeMessagePlaceholder || intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__driftt_translations_messages__["a" /* default */].welcomeMessage),
                maxLength: 164,
                invalidLabel: 'You have entered too many characters',
                onChange: partial(this.handleChange, 'welcomeMessage'),
                className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.WelcomeMessage
              })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'flex-1' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Customize_InputWithLimit__["a" /* default */], {
                title: 'Offline message',
                text: messagingUI.awayMessage,
                placeholder: awayMessagePlaceholder || intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__driftt_translations_messages__["a" /* default */].defaultAwayMessageCopy),
                isTextAreaAutosize: false,
                isTextArea: true,
                maxLength: 164,
                invalidLabel: 'You have entered too many characters',
                onChange: partial(this.handleChange, 'awayMessage'),
                className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.WelcomeMessage
              })
            )
          )
        )
      );
    }
  }, {
    key: 'renderNew',
    value: function renderNew() {
      var _props2 = this.props,
          intl = _props2.intl,
          partial = _props2.partial,
          messagingUI = _props2.messagingUI,
          orgSettings = _props2.orgSettings;
      var _orgSettings$theme2 = orgSettings.theme,
          welcomeMessagePlaceholder = _orgSettings$theme2.welcomeMessage,
          awayMessagePlaceholder = _orgSettings$theme2.awayMessage;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_components_settings_UserProfile_Section__["b" /* Subsection */],
        { title: 'Your default greeting',
          isValid: this.isValid(),
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel

        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { width: "100%" } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: 'color-navy-dark dsg-Body' },
            'Customize how you greet visitors when they start a conversation from the widget on your Drift Profile'
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.MessagingInfo },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'flex-1', style: { marginRight: "4rem" } },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Customize_InputWithLimit__["a" /* default */], {
                title: 'Online message',
                text: messagingUI.welcomeMessage || "",
                isTextAreaAutosize: false,
                isTextArea: true,
                placeholder: welcomeMessagePlaceholder || intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__driftt_translations_messages__["a" /* default */].welcomeMessage),
                maxLength: 164,
                invalidLabel: 'You have entered too many characters',
                onChange: partial(this.handleChange, 'welcomeMessage'),
                className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.WelcomeMessage
              })
            ),
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              'div',
              { className: 'flex-1' },
              __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Customize_InputWithLimit__["a" /* default */], {
                title: 'Offline message',
                text: messagingUI.awayMessage,
                placeholder: awayMessagePlaceholder || intl.formatMessage(__WEBPACK_IMPORTED_MODULE_7__driftt_translations_messages__["a" /* default */].defaultAwayMessageCopy),
                isTextAreaAutosize: false,
                isTextArea: true,
                maxLength: 164,
                invalidLabel: 'You have entered too many characters',
                onChange: partial(this.handleChange, 'awayMessage'),
                className: __WEBPACK_IMPORTED_MODULE_12__styles_styl___default.a.WelcomeMessage
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var hasConsolidatedWelcomeMsg = this.props.hasConsolidatedWelcomeMsg;


      if (hasConsolidatedWelcomeMsg) {
        return this.renderNew();
      } else {
        return this.renderDeprecated();
      }
    }
  }, {
    key: 'canSubmit',
    value: function canSubmit() {
      return !Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["is"])(this.props.messagingUI, this.props.messaging);
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return this.state.valid.every(function (value) {
        return !!value;
      });
    }
  }]);

  return MessagingInfo;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

MessagingInfo.propTypes = {
  welcomeMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  awayMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasConsolidatedWelcomeMsg: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["u" /* makeHasGate */])('has_consolidated_welcome_msg')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_container__["a" /* makeDefaultFailedContainer */])(__WEBPACK_IMPORTED_MODULE_6_react_component_with_partials___default()(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(MessagingInfo))), {
  listenTo: ['stores.OrgSettingsStore', 'stores.DefaultEmbedStore'],
  fetch: {
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    }
  }
}));

/***/ }),

/***/ "AJef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_Application__ = __webpack_require__("08hf");


// Application singleton that can be imported anywhere
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_app_Application__["a" /* Application */]());

/***/ }),

/***/ "AJjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("DeyL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var MadKuduTag = function MadKuduTag(_ref) {
  var _scoreToclassNameMap;

  var score = _ref.score;

  var scoreToclassNameMap = (_scoreToclassNameMap = {}, _defineProperty(_scoreToclassNameMap, 'very good', 'madkudu-tag-vg'), _defineProperty(_scoreToclassNameMap, 'good', 'madkudu-tag-g'), _defineProperty(_scoreToclassNameMap, 'medium', 'madkudu-tag-med'), _defineProperty(_scoreToclassNameMap, 'low', 'madkudu-tag-low'), _scoreToclassNameMap);
  var scoreLabel = __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["_129" /* MadkuduLabelMap */][score];
  return React.createElement(
    'div',
    { key: score, className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('Tag', 'madkudu-tag', scoreToclassNameMap[score]) },
    scoreLabel
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MadKuduTag);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ANGi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SelectFilter = function (_PureComponent) {
  _inherits(SelectFilter, _PureComponent);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));

    _this.hydrateOptions = function () {
      var activeFilter = _this.props.activeFilter;


      var options = _this.props.options;
      var optionValues = options.map(function (option) {
        return option.value;
      });

      // If the value is custom and doesn't exist in the list upon instantiation, make it
      if (!!activeFilter && activeFilter.value !== '' && !optionValues.find(function (value) {
        return value === activeFilter.value;
      })) {
        options = [].concat(_toConsumableArray(options), [{ label: activeFilter.value, value: activeFilter.value }]);
      }

      _this.setState({ options: options });
    };

    _this.updateValue = function (_ref) {
      var value = _ref.value;
      var _this$props = _this.props,
          onUpdateCondition = _this$props.onUpdateCondition,
          activeFilter = _this$props.activeFilter;


      var newFilter = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["clone"])(activeFilter);

      newFilter.value = [value];

      _this.setState({
        selected: value
      });

      onUpdateCondition(newFilter);
    };

    _this.onNewOptionClick = function (option) {
      var updatedOptions = [].concat(_toConsumableArray(_this.state.options), [option]);

      _this.setState({
        options: updatedOptions,
        selected: option
      });

      _this.updateValue(option);
    };

    _this.state = {
      selected: props.activeFilter.value,
      creatable: props.creatable
    };
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.hydrateOptions();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.options !== prevProps.options) {
        this.hydrateOptions();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selected = _state.selected,
          creatable = _state.creatable,
          options = _state.options;


      var selectOptions = {
        options: options,
        creatable: !Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["isNil"])(creatable) ? creatable : false,
        onChange: this.updateValue,
        clearable: false,
        placeholder: !Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["isNil"])(creatable) ? 'Type to create custom value' : 'Select an option...',
        multi: false,
        autoFocus: true,
        value: selected !== '' ? selected : null
      };

      if (!!creatable) {
        selectOptions.onNewOptionClick = this.onNewOptionClick;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], selectOptions)
        )
      );
    }
  }]);

  return SelectFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (SelectFilter);

/***/ }),

/***/ "ANOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKET_CATEGORIES; });
var MARKET_CATEGORIES = ['B2B', 'B2C', 'E-Commerce', 'Enterprise', 'ISP', 'Marketplace', 'Mobile', 'SAAS'];

/***/ }),

/***/ "AO70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_HREFS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CARD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CARD_FAILURE; });
var ACTION_PREFIX = '@@app/cards';
var makeConstant = function makeConstant(constant) {
  return ACTION_PREFIX + '/' + constant;
};

var UPDATE_HREFS = makeConstant('UPDATE_HREFS');
var FETCH_CARDS = makeConstant('FETCH_CARDS');
var FETCH_CARD = makeConstant('FETCH_CARD');
var FETCH_CARD_SUCCESS = makeConstant('FETCH_CARD_SUCCESS');
var FETCH_CARD_FAILURE = makeConstant('FETCH_CARD_FAILURE');

/***/ }),

/***/ "APD3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(455);

/***/ }),

/***/ "APMr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ContactSideBar":"ContactSideBar---1_TJw","hideContactSidebarButton":"hideContactSidebarButton---1-C8l"};

/***/ }),

/***/ "AQ+G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return typingFinished; });
/* unused harmony export userTyping */
/* unused harmony export userTypingFinished */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("qK29");



var typing = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* TYPING */]);
var typingFinished = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* TYPING_FINISHED */]);

var userTyping = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* USER_TYPING */]);
var userTypingFinished = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* USER_TYPING_FINISHED */]);

/***/ }),

/***/ "AUaw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "AW3I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_rules_actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layouts_RulesEditor__ = __webpack_require__("uHIU");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var salesforceIsAlreadyPresent = function salesforceIsAlreadyPresent(rules) {
  rules.find(function (rule) {
    return rule.conditions.length && rule.conditions[0].find(function (cond) {
      return cond.field === 'salesforceOwner';
    });
  });
};

function mapStateToProps(state) {
  var rules = state.get('rules').get('rules');
  var showSalesforceOption = !salesforceIsAlreadyPresent(rules);
  return {
    activeRule: state.get('rules').get('activeRule'),
    users: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["unfilteredOrgUsersByIdJS"])(state),
    showSalesforceOption: showSalesforceOption,
    hasABM: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["u" /* makeHasGate */])('ABM')(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_0_app_modules_rules_actions__, { fetchOrgUsers: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_actions__["fetchOrgUsers"] }), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_6__layouts_RulesEditor__["a" /* default */]));

/***/ }),

/***/ "AXIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchHubspotMappings: function fetchHubspotMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/hubspot/mappings/attributes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchHubspotMappings: function patchHubspotMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/hubspot/mappings/attributes', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchHubspotFields: function fetchHubspotFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/hubspot/lead/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  searchHubspotUsers: function searchHubspotUsers(query) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/hubspot/users?query=' + query).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchHubspotUserMappings: function fetchHubspotUserMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/hubspot/mappings/users').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchHubspotUserMappings: function patchHubspotUserMappings(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/hubspot/mappings/users', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchHubSpotContactByEmail: function fetchHubSpotContactByEmail(_ref) {
    var email = _ref.email;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/hubspot/contact/enrichment?email=' + encodeURIComponent(email)).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "AYv3":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 33 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M26.06 28.664c-.09.11-.208.192-.338.254C23.08 30.848 19.835 32 16.32 32c-3.517 0-6.763-1.155-9.407-3.086-.125-.06-.237-.14-.326-.244C2.785 25.742.32 21.16.32 16c0-8.823 7.178-16 16-16s16 7.177 16 16c0 5.155-2.46 9.736-6.26 12.664zm-1.86-1.1c-.583-3.515-3.978-6.298-7.88-6.298-3.902 0-7.298 2.783-7.878 6.297C10.688 29.098 13.4 30 16.32 30s5.633-.902 7.88-2.437zm-2.88-14.298c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zM16.32 2c-7.72 0-14 6.28-14 14 0 3.986 1.683 7.58 4.365 10.13.927-3.108 3.53-5.56 6.8-6.477-2.448-1.09-4.165-3.538-4.165-6.387 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.85-1.717 5.296-4.165 6.387 3.27.915 5.873 3.368 6.8 6.478 2.682-2.55 4.365-6.144 4.365-10.13 0-7.72-6.28-14-14-14z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Ac9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeConstantFactory; });
var makeConstantFactory = function makeConstantFactory(prefix) {
  return function (constant) {
    return "@@app/" + prefix + "/" + constant;
  };
};

/***/ }),

/***/ "Ad2P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AdSi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Adja":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 12 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.44 5.75h2.473c.196 0 .375.11.464.284.09.174.074.384-.04.543l-7.825 10.98c-.1.14-.26.22-.425.22-.074 0-.148-.018-.22-.05-.226-.105-.347-.358-.286-.6L3.507 9.41H.522c-.167 0-.325-.08-.423-.215-.1-.137-.126-.312-.074-.47L2.768.36c.07-.215.27-.36.496-.36h8.214c.207 0 .394.12.477.31.084.19.048.41-.09.564L7.44 5.75zM3.67 1.02L1.243 8.365h2.932c.16 0 .312.073.41.2.1.128.135.293.096.45l-1.42 5.693L8.9 6.796H6.26c-.206 0-.392-.122-.476-.31-.083-.19-.048-.41.09-.565l4.61-4.902H3.67z\" fill=\"#FFF9B3\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "AeAH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var TargetingRevealIcon = function TargetingRevealIcon(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "svg",
            { width: "551", height: "77", viewBox: "0 0 551 77", xmlns: "http://www.w3.org/2000/svg",
                  xmlnsXlink: "http://www.w3.org/1999/xlink" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "defs",
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "filter",
                        { x: "-25.9%", y: "-25.7%", width: "151.7%", height: "151.4%", filterUnits: "objectBoundingBox",
                              id: "a" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "3.182", "in": "SourceGraphic" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "filter",
                        { x: "-50.9%", y: "-28.2%", width: "201.8%", height: "156.4%", filterUnits: "objectBoundingBox",
                              id: "b" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "1.44", "in": "SourceGraphic" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "c", d: "M.477.448H6.69V6.69H.477V.448z" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "e", d: "M4.459.05v4.177H.304V.05h4.155z" })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  "g",
                  { fill: "none", fillRule: "evenodd" },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M91.176 25.192c-3.072 0-5.52-2.24-5.52-5.52 0-3.28 2.448-5.52 5.52-5.52 1.712 0 2.896.656 3.744 1.584a.85.85 0 0 1 .224.592c0 .48-.4.88-.88.88a.861.861 0 0 1-.672-.304 3.185 3.185 0 0 0-2.416-1.088c-2.032 0-3.6 1.616-3.6 3.856 0 2.24 1.568 3.856 3.6 3.856a3.19 3.19 0 0 0 2.432-1.088.88.88 0 0 1 .656-.304c.48 0 .88.4.88.88a.85.85 0 0 1-.224.592c-.848.928-2.016 1.584-3.744 1.584zm5.344 2.192c0-.416.384-.736.8-.736h.08c.528 0 .88-.16 1.104-.672l.384-.88-2.752-6.784a.932.932 0 0 1-.048-.304c0-.464.368-.832.816-.832.352 0 .672.224.784.528l2.08 5.36 2.08-5.36a.843.843 0 0 1 .784-.528c.464 0 .832.368.832.832 0 .112-.032.224-.064.32l-3.296 8.064c-.528 1.312-1.456 1.728-2.656 1.744-.064 0-.144 0-.24-.016a.736.736 0 0 1-.688-.736zm12.528-10.304c1.984 0 3.424 1.568 3.424 4.064 0 2.544-1.456 4.048-3.424 4.048-1.008 0-1.888-.48-2.48-1.248v.304a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V15.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.264c.608-.816 1.504-1.264 2.48-1.264zm-.496 6.624c1.344 0 2.192-1.056 2.192-2.56s-.848-2.576-2.192-2.576c-.784 0-1.616.48-1.984 1.056v3.056c.368.576 1.2 1.024 1.984 1.024zm9.12 1.488c-2.448 0-3.968-1.84-3.968-4.064 0-2.208 1.52-4.048 3.968-4.048 2.48 0 3.984 1.84 3.984 4.048 0 2.224-1.504 4.064-3.984 4.064zm0-1.488c1.44 0 2.24-1.2 2.24-2.576 0-1.36-.8-2.56-2.24-2.56-1.424 0-2.224 1.2-2.224 2.56 0 1.376.8 2.576 2.224 2.576zm8.848-.048c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048zm8 1.44a.85.85 0 0 1-.832-.848v-4.112c0-1.2-.624-1.568-1.568-1.568-.848 0-1.584.512-1.984 1.04v4.64a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V15.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.248c.512-.608 1.52-1.248 2.736-1.248 1.664 0 2.496.864 2.496 2.448v4.72a.854.854 0 0 1-.848.848zm6.64-7.952c.48 0 .688.368.688.784 0 .384-.288.72-.864.8-.576.08-1.424.464-1.76 1.008v4.512a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848v-6.224a.85.85 0 0 1 .832-.848c.464 0 .848.384.848.848v.384c.416-.544.992-1.008 1.488-1.168.192-.064.304-.096.448-.096zm1.456 3.984c0-2.24 1.632-4.048 3.92-4.048 2.32 0 3.808 1.776 3.808 3.824 0 .496-.352.784-.992.784h-4.976c.128 1.168 1.008 2.128 2.464 2.128.56 0 1.216-.176 1.76-.512a.663.663 0 0 1 .368-.096c.368 0 .672.304.672.672a.69.69 0 0 1-.304.56c-.768.512-1.696.752-2.672.752-2.32 0-4.048-1.616-4.048-4.064zm3.92-2.672c-1.44 0-2.096 1.104-2.176 2.048h4.352c-.032-.912-.656-2.048-2.176-2.048zm8.656-1.376c1.712 0 3.216.72 3.216 2.8v4.368a.854.854 0 0 1-.848.848.85.85 0 0 1-.832-.848v-.08c-.576.656-1.472 1.024-2.496 1.024-1.264 0-2.688-.848-2.688-2.56 0-1.776 1.424-2.512 2.688-2.512 1.04 0 1.936.336 2.496.992V19.96c0-.896-.736-1.44-1.808-1.44-.656 0-1.232.176-1.808.576a.724.724 0 0 1-.384.112.676.676 0 0 1-.672-.672c0-.224.128-.432.288-.544.848-.624 1.808-.912 2.848-.912zm-.304 6.96c.736 0 1.456-.272 1.84-.8v-1.168c-.384-.528-1.104-.8-1.84-.8-.944 0-1.648.544-1.648 1.392 0 .832.704 1.376 1.648 1.376zm8.864-.384c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M91.36 41.048a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm2.64-.588c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm5.964 4.836c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm9.048-7.872c1.512 0 2.58 1.2 2.58 3.048 0 1.884-1.068 3.036-2.58 3.036-.816 0-1.512-.42-1.956-1.008v.468a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.7a2.387 2.387 0 0 1 1.956-1.032zm-.228 5.28c1.176 0 1.872-.948 1.872-2.232 0-1.284-.696-2.244-1.872-2.244-.708 0-1.416.432-1.728.936v2.628c.312.504 1.02.912 1.728.912zm6.804.804c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm6.456-.108c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm5.772.816a.45.45 0 0 1-.444-.444v-3.42c0-1.02-.528-1.32-1.308-1.32-.696 0-1.368.432-1.716.9v3.84a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.652c.408-.48 1.2-.984 2.076-.984 1.212 0 1.848.588 1.848 1.848v3.696c0 .24-.204.444-.456.444zm4.74-5.94c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V35.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm6.528-.744c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.224.228c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.808 3.048c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm10.608-5.28c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V35.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zM102.23 58.745V66h2.29v-7.255h-2.29zm5.958 3.042c0-.936.585-1.404 1.273-1.404.687 0 1.247.468 1.247 1.638V66H113v-4.213c0-2.106-1.146-3.276-2.75-3.276-.917 0-1.604.533-2.063 1.235l-.076-1.001h-2.253c0 .247.038 1.638.038 1.638V66h2.292v-4.213zm-4.826-4.213c.853 0 1.388-.572 1.388-1.287-.013-.728-.535-1.287-1.362-1.287-.84 0-1.388.56-1.388 1.287 0 .715.535 1.287 1.35 1.287h.012zM95 57.182c-.37.2-.764.342-1.18.4.428-.314.752-.813.902-1.397a3.754 3.754 0 0 1-1.296.613c-.382-.485-.914-.798-1.505-.798-1.134 0-2.048 1.125-2.048 2.521 0 .2.011.4.046.584-1.701-.114-3.206-1.068-4.225-2.592-.173.37-.277.755-.277 1.225 0 .869.358 1.638.914 2.094a1.799 1.799 0 0 1-.926-.313v.028c0 1.225.706 2.25 1.644 2.479a1.75 1.75 0 0 1-.926.042c.254.998 1.018 1.738 1.91 1.753-.695.683-1.586 1.196-2.547 1.196-.162 0-.324-.014-.486-.043.903.713 1.99 1.026 3.148 1.026 3.773 0 5.833-3.846 5.833-7.18v-.327A4.933 4.933 0 0 0 95 57.183z",
                        fill: "#0176FF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M221.356 11.048a.453.453 0 0 1-.456-.444V3.392a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm3.996-2.244c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.556-3.036c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792V7.064c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72V8.684c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356V5.996h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612V4.016a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.848-6.204a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V5.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm4.788.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0V7.208c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V5.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M221.708 29c-.392 0-.616-.224-.616-.616v-8.106c0-.392.224-.616.616-.616h3.542c1.624 0 2.618.98 2.618 2.38 0 1.176-.784 1.96-1.638 2.142.994.154 1.82 1.176 1.82 2.296 0 1.498-.994 2.52-2.702 2.52h-3.64zm.546-5.292h2.8c1.05 0 1.61-.644 1.61-1.498 0-.84-.56-1.512-1.61-1.512h-2.8v3.01zm0 4.256h2.856c1.092 0 1.736-.616 1.736-1.61 0-.854-.588-1.61-1.736-1.61h-2.856v3.22zm10.556 1.204c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm4.774.14a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798zm9.268-.266c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm4.592 1.064c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm8.512-6.16c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V22.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm4.704 8.568a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm14.98-1.582a.586.586 0 0 1-.574-.574V21.23l-3.094 7.588c-.056.154-.168.238-.322.238a.34.34 0 0 1-.322-.238l-3.08-7.588v7.252a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-7.896c0-.532.434-.98.98-.98.42 0 .77.252.91.616l2.674 6.594 2.688-6.594a.964.964 0 0 1 .91-.616c.546 0 .98.448.98.98v7.896a.58.58 0 0 1-.588.574zm10.458-.826c.014.07.042.154.042.224a.595.595 0 0 1-1.148.224l-.672-1.75h-4.802l-.672 1.75a.565.565 0 0 1-.546.378.595.595 0 0 1-.602-.588c0-.07.028-.154.056-.238l3.22-7.98c.154-.378.518-.644.952-.644.434 0 .798.266.938.644l3.234 7.98zm-6.174-2.338h4.004l-2.002-5.194-2.002 5.194z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M330.564 8.096c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm10.524-.744c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V5.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm6.276 0c1.524 0 2.58 1.152 2.58 3.036 0 1.872-1.056 3.048-2.58 3.048-.78 0-1.476-.372-1.956-1.032v2.7a.45.45 0 0 1-.9 0V5.6a.45.45 0 0 1 .9 0v.468a2.423 2.423 0 0 1 1.956-1.008zm-.228 5.28c1.164 0 1.86-.96 1.86-2.244 0-1.284-.696-2.232-1.86-2.232-.708 0-1.416.42-1.728.924v2.616c.312.504 1.02.936 1.728.936zm4.716.708a.453.453 0 0 1-.456-.444V3.392a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm4.02 2.592c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm5.856-4.836c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.912 2.292c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm4.008 4.656a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M333.08 29.056a.58.58 0 0 1-.588-.574v-7.28l-1.19 1.26a.508.508 0 0 1-.35.154.502.502 0 0 1-.504-.504c0-.14.056-.266.14-.35l1.904-1.96a.684.684 0 0 1 1.162.476v8.204a.577.577 0 0 1-.574.574zm3.164 1.582a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M223.384 49.108c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V49.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.532-.648c.264 0 .456.204.456.456 0 .06-.024.132-.036.18l-2.016 4.824a.689.689 0 0 1-.636.432.697.697 0 0 1-.66-.432l-2.016-4.824c-.012-.06-.036-.12-.036-.18 0-.252.192-.456.444-.456.192 0 .36.12.42.276l1.836 4.536 1.824-4.536a.466.466 0 0 1 .42-.276zm1.26 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm7.212-.744c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V49.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm8.004.096c.252 0 .456.204.456.444v5.004a.45.45 0 0 1-.9 0v-.408c-.444.492-1.188.948-2.064.948-1.212 0-1.848-.588-1.848-1.848V49.6a.45.45 0 0 1 .9 0v3.42c0 1.02.516 1.32 1.296 1.32.708 0 1.38-.408 1.716-.876V49.6a.45.45 0 0 1 .444-.444zm1.92 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M227.616 70.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.9-.056a.608.608 0 0 1-.182-.406c0-.294.252-.532.546-.532.126 0 .252.042.35.126.574.602 1.288.91 2.254.91 1.274 0 2.156-.868 2.156-2.002 0-1.232-.882-2.016-2.142-2.016-.714 0-1.33.21-1.918.686a.62.62 0 0 1-.42.154.672.672 0 0 1-.672-.672v-4.004c0-.392.224-.616.616-.616h4.634c.28 0 .518.238.518.518s-.238.518-.518.518h-4.088v3.248c.448-.448 1.246-.84 2.184-.84 1.554 0 2.968 1.064 2.968 2.982 0 1.904-1.442 3.08-3.318 3.08-1.344 0-2.268-.42-2.968-1.134zm8.512 2.604a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm8.624-5.026c.28 0 .518.224.518.504a.517.517 0 0 1-.518.518h-.854v1.848a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-1.848h-3.808a.675.675 0 0 1-.574-1.05l3.696-5.516a1 1 0 0 1 .84-.462c.546 0 1.008.448 1.008 1.008v4.998h.854zm-5.292 0h3.276V64.74l-3.276 4.872zm6.916-1.274c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { fill: "#F2F6F8", width: "77", height: "77", rx: "3" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M37.123 19.988c0 5.984-2.81 11.302-7.182 14.698-.46.359-.944.703-1.443 1.017-.014.007-.037.022-.051.03-.305.194-.617.374-.938.553a7.842 7.842 0 0 1-.2.112 4.413 4.413 0 0 1-.282.143 18.231 18.231 0 0 1-8.371 2.027c-3.101 0-6.015-.77-8.58-2.132-.053-.03-.097-.052-.149-.082-.17-.09-.35-.187-.512-.285a8.58 8.58 0 0 1-.589-.359c-.037-.022-.066-.045-.104-.066A18.592 18.592 0 0 1 .195 19.988c0-10.255 8.268-18.572 18.46-18.572 10.201 0 18.468 8.317 18.468 18.572",
                        fill: "#B4C3D8", filter: "url(#a)", transform: "translate(17.163 19.5)" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M54.286 38.683c0 5.984-2.81 11.302-7.182 14.698a17.7 17.7 0 0 1-1.442 1.017c-.015.007-.038.022-.052.03a18.44 18.44 0 0 1-.937.553 7.842 7.842 0 0 1-.2.112 4.413 4.413 0 0 1-.283.143 18.231 18.231 0 0 1-8.37 2.027c-3.102 0-6.016-.77-8.58-2.132-.054-.03-.098-.052-.15-.082-.17-.09-.349-.187-.512-.285-.2-.111-.395-.23-.588-.359-.037-.022-.066-.045-.105-.066a18.592 18.592 0 0 1-8.527-15.656c0-10.255 8.268-18.572 18.461-18.572 10.2 0 18.467 8.317 18.467 18.572",
                        fill: "#4D9EFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M44.5 48.93H27.365c-1.618 0-2.941-1.315-2.941-2.922V36.68c0-1.608 1.323-2.922 2.94-2.922H44.5c1.618 0 2.941 1.314 2.941 2.922v9.328c0 1.607-1.323 2.922-2.94 2.922",
                        fill: "#ECF0F5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M41.674 43.697H30.191c-2.06 0-3.747-1.675-3.747-3.722 0-2.048 1.686-3.723 3.747-3.723h11.483c2.06 0 3.747 1.675 3.747 3.723 0 2.047-1.686 3.722-3.747 3.722",
                        fill: "#B4C3D8" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M33.215 39.975a2.083 2.083 0 0 1-2.09 2.075 2.083 2.083 0 0 1-2.09-2.075c0-1.147.936-2.076 2.09-2.076s2.09.93 2.09 2.076m9.615 0a2.083 2.083 0 0 1-2.09 2.075 2.083 2.083 0 0 1-2.09-2.075c0-1.147.936-2.076 2.09-2.076s2.09.93 2.09 2.076",
                        fill: "#FFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M36.11 24.194c.77 0 1.393.62 1.393 1.385s-.623 1.38-1.393 1.38a1.384 1.384 0 0 1-1.392-1.38c0-.765.623-1.385 1.392-1.385m5.025 9.305v.258H30.73V33.5c0-1.082.881-1.957 1.973-1.957h6.462c1.089 0 1.97.875 1.97 1.957",
                        fill: "#B4C3D8" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M36.707 31.716v-6.378c0-.195-.267-.354-.597-.354-.33 0-.596.159-.596.354v6.378c0 .195.267.353.596.353.33 0 .597-.158.597-.353z",
                        fill: "#B4C3D8", fillRule: "nonzero" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M11.05-2.345H4.577c-.555 0-1.01.454-1.01 1.01v11.677c0 .555.45 1.005 1.004 1.005h5.437l1.483 1.517c.206.21.563.065.563-.23V-1.34",
                        fill: "#B4C3D8", filter: "url(#b)", transform: "rotate(90 19.56 39.448)" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M61.354 23.742c0-.555-.455-1.01-1.01-1.01H48.667c-.555 0-1.006.45-1.006 1.004v5.437l-1.517 1.483a.328.328 0 0 0 .23.563H60.35c.555 0 1.005-.45 1.005-1.004v-6.473z",
                        fill: "#FFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M56.925 26.709a.722.722 0 1 0 1.443.001.722.722 0 0 0-1.443-.001m-2.352.722a.721.721 0 1 0-.001-1.442.721.721 0 0 0 .001 1.442zm-3.794-.722a.722.722 0 1 0 1.443.001.722.722 0 0 0-1.443-.001",
                        fill: "#B4C3D8" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "g",
                        { transform: "translate(44.565 13)" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "mask",
                              { id: "d", fill: "#fff" },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#c" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M3.993.756l.478 1.631c.04.14.15.25.288.29l1.624.481c.408.12.408.702 0 .822l-1.624.48a.428.428 0 0 0-.288.29l-.478 1.632a.426.426 0 0 1-.819 0l-.478-1.631a.429.429 0 0 0-.289-.29L.783 3.98c-.407-.121-.407-.702 0-.823l1.624-.48a.429.429 0 0 0 .29-.29L3.173.755c.12-.41.698-.41.819 0",
                              fill: "#4D9EFF", mask: "url(#d)" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        "g",
                        { transform: "translate(22.932 60.306)" },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              "mask",
                              { id: "f", fill: "#fff" },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#e" })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M2.655.257l.32 1.091c.027.094.1.167.193.194l1.087.322c.272.08.272.47 0 .55l-1.087.321a.285.285 0 0 0-.193.194l-.32 1.092a.285.285 0 0 1-.547 0l-.32-1.092a.285.285 0 0 0-.193-.194l-1.086-.32c-.274-.082-.274-.47 0-.551l1.086-.322a.286.286 0 0 0 .193-.194l.32-1.091a.285.285 0 0 1 .547 0",
                              fill: "#B4C3D8", mask: "url(#f)" })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M18.387 16.686c0 .64-.516 1.158-1.153 1.158a1.155 1.155 0 0 1-1.152-1.158c0-.64.516-1.158 1.152-1.158.637 0 1.153.518 1.153 1.158z",
                        stroke: "#B4C3D8", strokeWidth: "1.08", strokeLinecap: "round", strokeLinejoin: "round"
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M17.305 57.13c0 .64-.516 1.158-1.153 1.158A1.155 1.155 0 0 1 15 57.13c0-.64.516-1.158 1.152-1.158.637 0 1.153.519 1.153 1.158z",
                        stroke: "#4D9EFF", strokeWidth: "1.08", strokeLinecap: "round", strokeLinejoin: "round"
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M60.538 43.198a.833.833 0 0 1-.83-.835c0-.461.372-.835.83-.835.46 0 .831.374.831.835a.833.833 0 0 1-.83.835z",
                        fill: "#B4C3D8" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M66.595 17.748l-2.84 2.855", fill: "#FFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M66.595 17.748l-2.84 2.855", stroke: "#BAC9DE", strokeWidth: "1.08",
                        strokeLinecap: "round", strokeLinejoin: "round" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M61.862 16.756l-.293 2.35", fill: "#FFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M61.862 16.756l-.293 2.35", stroke: "#BAC9DE", strokeWidth: "1.08",
                        strokeLinecap: "round", strokeLinejoin: "round" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M67.627 22.164l-2.742.44", fill: "#FFF" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M67.627 22.164l-2.742.44", stroke: "#BAC9DE", strokeWidth: "1.08",
                        strokeLinecap: "round", strokeLinejoin: "round" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M56.99 52.773c.024-.082.012-.176-.046-.234l-5.888-5.898c-.058-.058-.152-.07-.234-.046a.216.216 0 0 0-.128.199v8.424c0 .082.047.164.128.199a.246.246 0 0 0 .234-.047l1.8-1.813 1.46 3.018a.2.2 0 0 0 .28.094l.946-.48a.2.2 0 0 0 .094-.28L54.164 52.9h2.628a.216.216 0 0 0 .199-.128z",
                        fill: "#384F5B" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M337.176 49.06c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V49.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm5.952 6.084c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V49.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm3.312 3.036c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.936 7.128c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm11.772-7.824c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V49.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm3.756-.048c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm4.74-6.468a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V49.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm2.016-.588a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684zm5.484-2.364c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.892-2.856c.252 0 .456.204.456.444v7.212a.45.45 0 0 1-.9 0v-.468a2.44 2.44 0 0 1-1.956 1.008c-1.512 0-2.58-1.152-2.58-3.036 0-1.848 1.056-3.048 2.58-3.048.78 0 1.476.384 1.956 1.032v-2.7a.45.45 0 0 1 .444-.444zm-2.184 7.392c.72 0 1.416-.408 1.74-.912V50.8c-.324-.504-1.02-.936-1.74-.936-1.164 0-1.86.96-1.86 2.244 0 1.284.696 2.232 1.86 2.232z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M337.616 70.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.788.91a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm8.148 0a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm8.428 1.638a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M454.524 10.34c.012.06.036.132.036.192a.51.51 0 0 1-.984.192l-.576-1.5h-4.116l-.576 1.5a.484.484 0 0 1-.468.324.51.51 0 0 1-.516-.504c0-.06.024-.132.048-.204l2.76-6.84a.879.879 0 0 1 .816-.552.85.85 0 0 1 .804.552l2.772 6.84zm-5.292-2.004h3.432l-1.716-4.452-1.716 4.452zm7.02 2.712a.453.453 0 0 1-.456-.444V3.392a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm1.908-2.952c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.34 4.572c.06.06.096.156.096.252 0 .192-.144.42-.42.42a.448.448 0 0 1-.324-.144l-1.812-2.292-1.8 2.268a.436.436 0 0 1-.336.168.416.416 0 0 1-.42-.42c0-.096.036-.192.096-.252L466.368 8l-1.812-2.148a.462.462 0 0 1-.108-.264c0-.228.192-.432.432-.432.108 0 .216.036.3.144l1.704 2.088 1.704-2.088a.369.369 0 0 1 .312-.144.428.428 0 0 1 .324.696L467.412 8l1.932 2.376zm3.636-5.316c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792V7.064c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72V8.684c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm7.428-2.604V3.44c0-.264.216-.492.504-.492.276 0 .492.228.492.492v4.428c0 1.464.792 2.388 2.268 2.388 1.476 0 2.268-.924 2.268-2.388V3.44c0-.264.216-.492.504-.492.276 0 .492.228.492.492v4.44c0 1.992-1.092 3.264-3.264 3.264-2.172 0-3.264-1.284-3.264-3.252zm8.232 2.28a.504.504 0 0 1-.18-.372c0-.276.216-.492.48-.492.108 0 .228.036.3.108.54.468 1.272.84 2.196.84 1.428 0 1.884-.768 1.884-1.38 0-.96-.972-1.224-2.028-1.512-1.284-.336-2.712-.696-2.712-2.268 0-1.32 1.176-2.22 2.82-2.22 1.008 0 1.776.288 2.472.828a.447.447 0 0 1 .204.384c0 .252-.216.48-.468.48a.444.444 0 0 1-.288-.108c-.576-.48-1.284-.696-1.992-.696-1.032 0-1.716.516-1.716 1.272 0 .804.924 1.044 1.944 1.32 1.308.348 2.796.756 2.796 2.436 0 1.164-.792 2.352-2.952 2.352-1.176 0-2.1-.384-2.76-.972zm15.948.108a.505.505 0 0 1 .096.312.485.485 0 0 1-.48.456.512.512 0 0 1-.42-.204l-2.088-3.024h-1.764v2.736a.497.497 0 1 1-.996 0V3.524c0-.336.192-.528.528-.528h2.688c1.464 0 2.508.936 2.508 2.412 0 1.368-.888 2.148-1.908 2.304l1.836 2.568zm-4.656-6.396v3.06h2.1c.948 0 1.596-.636 1.596-1.536s-.648-1.524-1.596-1.524h-2.1zm8.304 1.176c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792V7.064c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72V8.684c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm7.26-5.436c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0V7.208c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V5.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm8.34 5.232a.485.485 0 0 1 .108.3.446.446 0 0 1-.444.456.438.438 0 0 1-.348-.144l-2.124-2.496-.984.912v1.284a.45.45 0 0 1-.9 0V3.392a.45.45 0 0 1 .9 0V8.3l3.132-3.036a.378.378 0 0 1 .288-.108.415.415 0 0 1 .288.708l-2.076 1.992 2.16 2.436zm1.92-6.264a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V5.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm5.22-5.988c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0V7.208c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V5.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm8.292.096a.45.45 0 0 1 .444.444v5.232c0 1.92-1.344 2.52-2.76 2.52-.852 0-1.464-.144-2.1-.66a.416.416 0 0 1-.156-.312.4.4 0 0 1 .396-.396c.084 0 .168.036.228.084.456.384.948.54 1.632.54.96 0 1.86-.468 1.86-1.74v-.816c-.432.588-1.14 1.02-1.944 1.02-1.512 0-2.58-1.128-2.58-3 0-1.86 1.056-3.012 2.58-3.012.78 0 1.476.384 1.944 1.032V5.6c0-.24.204-.444.456-.444zm-2.184 5.124c.72 0 1.416-.444 1.728-.948V6.8c-.312-.504-1.008-.936-1.728-.936-1.164 0-1.86.924-1.86 2.208 0 1.272.696 2.208 1.86 2.208z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M448.218 32a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm13.244-3.388c.28 0 .518.224.518.504a.517.517 0 0 1-.518.518h-.854v1.848a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-1.848h-3.808a.675.675 0 0 1-.574-1.05l3.696-5.516a1 1 0 0 1 .84-.462c.546 0 1.008.448 1.008 1.008v4.998h.854zm-5.292 0h3.276V23.74l-3.276 4.872zm9.114 3.444a.58.58 0 0 1-.588-.574v-7.28l-1.19 1.26a.508.508 0 0 1-.35.154.502.502 0 0 1-.504-.504c0-.14.056-.266.14-.35l1.904-1.96a.684.684 0 0 1 1.162.476v8.204a.577.577 0 0 1-.574.574z",
                        fill: "#394F5A" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M450.024 54.232c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.068-2.136c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.912 2.292c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm10.644 2.952a.45.45 0 0 1-.444-.444v-3.42c0-1.02-.528-1.32-1.308-1.32-.696 0-1.368.432-1.716.9v3.84a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.652c.408-.48 1.2-.984 2.076-.984 1.212 0 1.848.588 1.848 1.848v3.696c0 .24-.204.444-.456.444z",
                        fill: "#7695A5" }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M455.568 68.198c.392 0 .616.224.616.63v2.282c0 .322-.07.56-.308.77a4.905 4.905 0 0 1-3.36 1.302c-2.66 0-4.802-1.946-4.802-4.844 0-2.898 2.142-4.83 4.802-4.83 1.372 0 2.408.476 3.22 1.288a.495.495 0 0 1 .154.378.523.523 0 0 1-.532.532.55.55 0 0 1-.392-.154 3.458 3.458 0 0 0-2.45-1.008c-2.044 0-3.598 1.568-3.598 3.794 0 2.212 1.554 3.808 3.598 3.808 1.12 0 2.044-.546 2.506-1.008v-1.904h-2.744a.526.526 0 0 1-.518-.518c0-.28.238-.518.518-.518h3.29zm5.418 4.97c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm8.008.938c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm10.472-6.048c.28 0 .518.238.518.518v6.104c0 2.24-1.568 2.94-3.22 2.94-.994 0-1.708-.168-2.45-.77a.486.486 0 0 1-.182-.364c0-.252.21-.462.462-.462.098 0 .196.042.266.098.532.448 1.106.63 1.904.63 1.12 0 2.17-.546 2.17-2.03v-.952c-.504.686-1.33 1.19-2.268 1.19-1.764 0-3.01-1.316-3.01-3.5 0-2.17 1.232-3.514 3.01-3.514.91 0 1.722.448 2.268 1.204V66.7c0-.28.238-.518.532-.518zm-2.548 5.978c.84 0 1.652-.518 2.016-1.106V68.1c-.364-.588-1.176-1.092-2.016-1.092-1.358 0-2.17 1.078-2.17 2.576 0 1.484.812 2.576 2.17 2.576zm5.698.896a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v8.414c0 .28-.238.518-.518.518zm2.226-3.444c0-1.96 1.4-3.542 3.332-3.542 2.044 0 3.248 1.596 3.248 3.36 0 .336-.224.532-.616.532h-4.858c.084 1.274.98 2.338 2.436 2.338.658 0 1.288-.224 1.82-.644a.46.46 0 0 1 .238-.056c.238 0 .434.182.434.42 0 .14-.07.266-.182.35-.672.518-1.47.798-2.408.798-2.002 0-3.444-1.442-3.444-3.556zm3.318-2.674c-1.442 0-2.156 1.218-2.212 2.254h4.438c-.014-1.008-.686-2.254-2.226-2.254zm16.296 5.292c.014.07.042.154.042.224a.595.595 0 0 1-1.148.224l-.672-1.75h-4.802l-.672 1.75a.565.565 0 0 1-.546.378.595.595 0 0 1-.602-.588.83.83 0 0 1 .056-.238l3.22-7.98c.154-.378.518-.644.952-.644.434 0 .798.266.938.644l3.234 7.98zm-6.174-2.338h4.004l-2.002-5.194-2.002 5.194zm11.116-3.822c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V66.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm6.916 0c1.428 0 2.618.644 2.618 2.282v4.186c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-.308c-.532.616-1.316.938-2.24.938-1.148 0-2.366-.77-2.366-2.24 0-1.512 1.218-2.226 2.366-2.226.924 0 1.694.294 2.24.924v-1.218c0-.91-.728-1.428-1.708-1.428-.672 0-1.232.196-1.764.672a.552.552 0 0 1-.28.084.436.436 0 0 1-.434-.434c0-.14.084-.28.182-.35.686-.602 1.47-.882 2.436-.882zm-.294 6.342c.742 0 1.456-.28 1.862-.84v-1.274c-.406-.56-1.12-.84-1.862-.84-.98 0-1.666.616-1.666 1.484 0 .854.686 1.47 1.666 1.47zm5.544.644a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v8.414c0 .28-.238.518-.518.518zm2.254 2.198c0-.266.238-.462.504-.462.042 0 .112.014.224.014.462 0 .77-.154 1.008-.714l.448-1.022-2.548-6.16a.52.52 0 0 1 .476-.728c.224 0 .42.14.49.322l2.142 5.278 2.128-5.278a.543.543 0 0 1 .49-.322c.308 0 .532.238.532.532 0 .07-.014.14-.042.21l-3.108 7.448c-.406.98-1.092 1.358-1.988 1.372-.098 0-.196 0-.308-.028-.266-.028-.448-.224-.448-.462zm9.702-3.15c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm2.156-7.238a.702.702 0 0 1-.7-.7c0-.392.322-.714.7-.714.392 0 .714.322.714.714 0 .392-.322.7-.714.7zm0 8.19a.526.526 0 0 1-.518-.518V66.7c0-.28.238-.518.532-.518.28 0 .518.238.518.518v5.838c0 .28-.238.518-.532.518zm2.24-3.444c0-2.002 1.358-3.542 3.374-3.542.98 0 1.638.322 2.17.84.084.084.154.21.154.35 0 .266-.21.476-.476.476a.444.444 0 0 1-.308-.126c-.434-.434-.91-.602-1.484-.602-1.442 0-2.338 1.106-2.338 2.604s.896 2.618 2.338 2.618c.574 0 1.05-.168 1.47-.602a.444.444 0 0 1 .322-.126c.266 0 .476.21.476.476 0 .14-.07.28-.154.35-.532.518-1.19.84-2.17.84-2.016 0-3.374-1.54-3.374-3.556zm7.042 2.758a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798z",
                        fill: "#394F5A" })
            )
      );
};

/* harmony default export */ __webpack_exports__["a"] = (TargetingRevealIcon);

/***/ }),

/***/ "Ai5H":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22\" height=\"23\" viewBox=\"0 0 22 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.792 15.365a1.23 1.23 0 0 0 1.807.014l8.25-8.69c.48-.506.468-1.315-.027-1.807a1.23 1.23 0 0 0-1.768.027l-7.345 7.723L8.612 9.27a1.23 1.23 0 0 0-1.767-.056 1.298 1.298 0 0 0-.053 1.806l4 4.345zM1.45.178C.76.178.2.75.2 1.456v20.19c0 .704.56 1.276 1.25 1.276h19.004c.69 0 1.25-.572 1.25-1.277v-5.878c0-.706-.56-1.278-1.25-1.278s-1.25.57-1.25 1.277v4.6L2.7 20.36l.004-17.626h8.498c.69 0 1.25-.572 1.25-1.278 0-.706-.56-1.278-1.25-1.278H1.45z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Ala6":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 12 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.333 15H.667C.299 15 0 14.72 0 14.375s.299-.625.667-.625h10.666c.368 0 .667.28.667.625s-.299.625-.667.625zM6 12.5c-2.791 0-4.667-1.758-4.667-4.375v-7.5C1.333.28 1.632 0 2 0c.368 0 .667.28.667.625v7.5c0 1.928 1.277 3.125 3.333 3.125s3.333-1.197 3.333-3.125v-7.5C9.333.28 9.632 0 10 0c.368 0 .667.28.667.625v7.5C10.667 10.742 8.79 12.5 6 12.5z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "AmoF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SearchConstants__ = __webpack_require__("p7KC");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var SearchActions = Marty.createActionCreators({
  searchUsers: function searchUsers(searchString) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SearchConstants__["a" /* default */].SEARCH_USERS, searchString);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SearchActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "An2l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_VidyardModal__ = __webpack_require__("b/iu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_api_FileAPI__ = __webpack_require__("0OV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tinymce_tinymce_react__ = __webpack_require__("gX8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Ds5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);








var CALENDAR_INJECTION_STYLES = '\n  .calendar-injection {\n    height: 158px;\n    width: 350px;\n  }\n  .calendar-injection ~ .calendar-injection {\n    height: auto;\n    width: auto;\n  }\n  .calendar-preview::after {\n    background-image: url(https://s3.amazonaws.com/drift-prod-static/assets/calendar-injection.png);\n    z-index: 4000;\n    position: absolute;\n    height: 158px;\n    width: 350px;\n    content: " ";\n    left: 8px;\n    visibility: visible;\n  }\n';

// bg is color-violet
var TINY_INLINE_STYLE_HIGHLIGHTING = '\n  .drift-editor-tag {\n    display: inline-block;\n    border: 1px solid #F2F6F8;\n    background-color: rgba(112,67,213,0.2);\n    color: #7043d5;\n    border-radius: 2px;\n    padding: 2px 3px;\n  }\n  .mce-content-body *[contentEditable=false][data-mce-selected] {\n    color: #394F5A;\n    border: 1px solid #B5D2E1;\n    outline: none !important;\n  }\n';

var uploadToDrift = function uploadToDrift(file, success, failure) {
  return __WEBPACK_IMPORTED_MODULE_2_app_api_FileAPI__["a" /* upload */](file.blob()).then(function (res) {
    success(res.url);
  });
};

var tinyFilePicker = function tinyFilePicker(cb, value) {
  var input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.onchange = function () {
    var file = this.files[0];
    var reader = new FileReader();
    reader.onload = function () {
      var id = 'blobid' + new Date().getTime();
      var blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
      var base64 = reader.result.split(',')[1];
      var blobInfo = blobCache.create(id, file, base64);
      blobCache.add(blobInfo);
      cb(blobInfo.blobUri(), { title: file.name });
    };
    reader.readAsDataURL(file);
  };
  input.click();
};

var insertSignature = function insertSignature() {
  var signatureSpan = ' <span class="drift-editor-tag mceNonEditable">{{ sender.email_signature }}</span> ';
  var editor = window.tinymce.activeEditor;
  editor.insertContent(signatureSpan);
};

var makeInsertVidyardHandler = function makeInsertVidyardHandler(setVidyardModalOpen) {
  var editor = window.tinymce.activeEditor;

  return function (embed) {
    // I've only ever seen the thumbnail url start with //, never with a protocol
    var thumbnailUrl = embed.thumbnail.startsWith('https') ? embed.thumbnail : 'https:' + embed.thumbnail;
    var anchor = '<div><img src=' + thumbnailUrl + ' width="400" /><br /><a href=' + embed.sharing_page + '>' + embed.sharing_page + '</a></div>';
    editor.insertContent(anchor);
    setVidyardModalOpen(false);
  };
};

var insertOneClickScheduling = function insertOneClickScheduling() {
  var oneClickSchedulingSpan = ' <span class="drift-editor-tag mceNonEditable">{{ sender.upcoming_availability }}</span> ';
  var editor = window.tinymce.activeEditor;
  editor.insertContent(oneClickSchedulingSpan);
};

var returnUrlAsRecieved = function returnUrlAsRecieved(url, node, on_save, name) {
  return url;
};

var buildMenuItems = function buildMenuItems(_ref) {
  var showTokenPicker = _ref.showTokenPicker,
      showPersonalization = _ref.showPersonalization,
      showSignature = _ref.showSignature,
      showCalendarLinkPicker = _ref.showCalendarLinkPicker,
      showCtaInsert = _ref.showCtaInsert,
      showCtaButtonModal = _ref.showCtaButtonModal,
      initialContent = _ref.initialContent,
      setVidyardModalOpen = _ref.setVidyardModalOpen,
      isOutboundSequencePlaybook = _ref.isOutboundSequencePlaybook,
      showMeetingInsert = _ref.showMeetingInsert,
      isVidyardEnabled = _ref.isVidyardEnabled;

  var menu = [];

  if (showPersonalization) menu.push({
    text: 'Personalization',
    onclick: showTokenPicker
  });

  if (showSignature) menu.push({
    text: 'Email Signature',
    onclick: insertSignature
  });

  if (showCtaInsert) {
    var alreadyHasButton = !!initialContent && initialContent.includes('data-drift-bui');
    var buttonText = alreadyHasButton ? 'Edit Button' : 'Button';
    menu.push({
      text: buttonText,
      onclick: showCtaButtonModal
    });
  }

  if (isVidyardEnabled) {
    menu.push({
      text: 'Video from Vidyard',
      onclick: function onclick() {
        return setVidyardModalOpen(true);
      }
    });
  }

  if (showMeetingInsert) {
    if (isOutboundSequencePlaybook) {
      menu.push({
        text: 'Next Meeting Times',
        onclick: function onclick() {
          return insertOneClickScheduling();
        }
      });
    }
    menu.push({
      text: 'Calendar Link',
      onclick: showCalendarLinkPicker
    });
  }

  return menu;
};

var TinyEditor = function TinyEditor(_ref2) {
  var initialContent = _ref2.initialContent,
      onChange = _ref2.onChange,
      showTokenPicker = _ref2.showTokenPicker,
      showCalendarLinkPicker = _ref2.showCalendarLinkPicker,
      showCtaButtonModal = _ref2.actions.showCtaButtonModal,
      _ref2$showPersonaliza = _ref2.showPersonalization,
      showPersonalization = _ref2$showPersonaliza === undefined ? true : _ref2$showPersonaliza,
      _ref2$showDriftAttrib = _ref2.showDriftAttributes,
      showDriftAttributes = _ref2$showDriftAttrib === undefined ? true : _ref2$showDriftAttrib,
      _ref2$showSignature = _ref2.showSignature,
      showSignature = _ref2$showSignature === undefined ? true : _ref2$showSignature,
      _ref2$noOuterBorder = _ref2.noOuterBorder,
      noOuterBorder = _ref2$noOuterBorder === undefined ? false : _ref2$noOuterBorder,
      _ref2$showCtaInsert = _ref2.showCtaInsert,
      showCtaInsert = _ref2$showCtaInsert === undefined ? false : _ref2$showCtaInsert,
      _ref2$noHighlighting = _ref2.noHighlighting,
      noHighlighting = _ref2$noHighlighting === undefined ? false : _ref2$noHighlighting,
      _ref2$isOutboundSeque = _ref2.isOutboundSequencePlaybook,
      isOutboundSequencePlaybook = _ref2$isOutboundSeque === undefined ? false : _ref2$isOutboundSeque,
      _ref2$showMeetingInse = _ref2.showMeetingInsert,
      showMeetingInsert = _ref2$showMeetingInse === undefined ? true : _ref2$showMeetingInse,
      isVidyardEnabled = _ref2.isVidyardEnabled,
      vidyardModalOpen = _ref2.vidyardModalOpen,
      setVidyardModalOpen = _ref2.setVidyardModalOpen,
      setShowTripwire = _ref2.setShowTripwire,
      hasMeetings = _ref2.hasMeetings,
      _ref2$includeAlignmen = _ref2.includeAlignment,
      includeAlignment = _ref2$includeAlignmen === undefined ? true : _ref2$includeAlignmen,
      _ref2$includeColorAnd = _ref2.includeColorAndSize,
      includeColorAndSize = _ref2$includeColorAnd === undefined ? false : _ref2$includeColorAnd;

  var insertMenuItems = buildMenuItems({
    showTokenPicker: showTokenPicker,
    showPersonalization: showPersonalization,
    showSignature: showSignature,
    showCalendarLinkPicker: showCalendarLinkPicker,
    showCtaInsert: showCtaInsert,
    showCtaButtonModal: showCtaButtonModal,
    initialContent: initialContent,
    setShowTripwire: setShowTripwire,
    hasMeetings: hasMeetings,
    isVidyardEnabled: isVidyardEnabled,
    setVidyardModalOpen: setVidyardModalOpen,
    isOutboundSequencePlaybook: isOutboundSequencePlaybook,
    showMeetingInsert: showMeetingInsert
  });
  var alignment = includeAlignment ? '| alignleft aligncenter alignright ' : '';
  var sizeAndColor = includeColorAndSize ? '| fontsizeselect forecolor ' : '';
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('tiny-editor-container', { 'tiny-editor-container-without-border': noOuterBorder }) },
    React.createElement(
      'div',
      null,
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_VidyardModal__["a" /* default */], {
        onClosed: function onClosed() {
          return setVidyardModalOpen(false);
        },
        onVideoInserted: makeInsertVidyardHandler(setVidyardModalOpen),
        insertFull: true,
        isOpen: vidyardModalOpen
      })
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_3__tinymce_tinymce_react__["Editor"], {
      value: initialContent,
      apiKey: 'nozb66xx8bd4ng55xzewb7obn09fln14zbh0rjyi4ip3rbf7',
      onEditorChange: onChange,
      init: {
        setup: function setup(editor) {
          if (showDriftAttributes && insertMenuItems.length !== 0) {
            editor.addButton('driftattrs', {
              type: 'menubutton',
              text: 'Insert',
              icon: false,
              style: 'max-height: 24px;',
              menu: insertMenuItems
            });
          }
        },
        paste_webkit_styles: 'all',
        content_style: CALENDAR_INJECTION_STYLES + (noHighlighting ? '' : TINY_INLINE_STYLE_HIGHLIGHTING),
        height: 350,
        file_picker_types: 'image',
        image_title: false,
        browser_spellcheck: true,
        plugins: 'autoresize lists autolink link image preview paste noneditable code textcolor',
        toolbar: 'undo redo | fontselect bold italic | numlist bullist ' + alignment + sizeAndColor + '| link image | code | driftattrs',
        file_picker_callback: tinyFilePicker,
        fontsize_formats: '10pt 12pt 14pt 24pt',
        images_upload_handler: uploadToDrift,
        default_link_target: '_blank',
        paste_data_images: true,
        forced_root_block: 'div',
        // tinymce likes to dynamically change the url, this overrides that and returns the url excatly as it is inputted
        urlconverter_callback: returnUrlAsRecieved,
        remove_script_host: false,
        branding: false,
        menubar: false
      }
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TinyEditor);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "AnnE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['ENABLED', 'ARCHIVED']));

/***/ }),

/***/ "ArDQ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyOCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQuMjM4IDEzLjY5MnY1Ljk5YzAgLjMwOC0uMTYzLjU5Mi0uNDI3Ljc0NC0uMTMuMDc0LS4yNzIuMTEyLS40MTUuMTEyLS4xNSAwLS4zLS4wNDItLjQzNS0uMTIzbC04LjIzNy01LjAxM2gtNy4zNnY2Ljg0NmMwIC40NzQtLjM3OC44NTctLjg0My44NTctLjQ2NiAwLS44NDQtLjM4My0uODQ0LS44NTd2LTYuODQ2SDIuM2MtLjkzIDAtMS42ODctLjc2Ny0xLjY4Ny0xLjcxVjYuODQ2YzAtLjk0NC43NTctMS43MTIgMS42ODgtMS43MTJoMTIuNDI0TDIyLjk2LjEyMmMuMjYtLjE2LjU4Ni0uMTYzLjg1LS4wMS4yNjUuMTUyLjQyOC40MzUuNDI4Ljc0NHY1Ljk5YzEuODYyIDAgMy4zNzUgMS41MzYgMy4zNzUgMy40MjMgMCAxLjg4Ni0xLjUxMyAzLjQyMi0zLjM3NSAzLjQyMnpNNS42NzYgNi44NDZIMi4zdjYuODQ2aDMuMzc2VjYuODQ2em0xNi44NzUtNC40OGwtNy4xNTggNC4zNThjLS4wMTguMDEtLjAzOC4wMS0uMDU1LjAyLS4wNS4wMjUtLjEwMy4wNC0uMTYuMDU2LS4wNTQuMDE2LS4xMDcuMDMtLjE2My4wMzQtLjAyIDAtLjAzNy4wMTItLjA1Ny4wMTJINy4zNjN2Ni44NDZoNy41OTRjLjAyIDAgLjAzNi4wMS4wNTYuMDEuMDU2LjAwNS4xMS4wMi4xNjYuMDM1LjA1NC4wMTUuMTA3LjAzLjE1Ny4wNTcuMDE3LjAxLjAzNy4wMS4wNTUuMDJsNy4xNiA0LjM1N1YyLjM2OHptMS42ODggNi4xOXYzLjQyNWMuOTMgMCAxLjY4OC0uNzY3IDEuNjg4LTEuNzEgMC0uOTQ1LS43NTctMS43MTMtMS42ODgtMS43MTN6IiBmaWxsPSIjNzY5NUE1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "Ars9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(502);

/***/ }),

/***/ "Asl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routeReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);



var initialRouterState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  locationBeforeTransitions: null
});

function routeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["LOCATION_CHANGE"]:
      return state.merge({ locationBeforeTransitions: action.payload });
    default:
      return state;
  }
}

/***/ }),

/***/ "At/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_PARTICIPANTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_PARTICIPANTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_PARTICIPANTS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_PARTICIPANTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_PARTICIPANTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_PARTICIPANTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return REMOVE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_PARTICIPANTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REMOVE_PARTICIPANTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return REMOVE_PARTICIPANTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_MODAL_VISIBILITY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('conversation/participants');

var FETCH_PARTICIPANTS = makeConstant('FETCH_PARTICIPANTS');
var FETCH_PARTICIPANTS_PENDING = makeConstant('FETCH_PARTICIPANTS_PENDING');
var FETCH_PARTICIPANTS_FAILED = makeConstant('FETCH_PARTICIPANTS_FAILED');
var FETCH_PARTICIPANTS_CANCELLED = makeConstant('FETCH_PARTICIPANTS_CANCELLED');
var RECEIVE_PARTICIPANTS = makeConstant('RECEIVE_PARTICIPANTS');

var ADD_PARTICIPANTS = makeConstant('ADD_PARTICIPANTS');
var ADD_PARTICIPANTS_PENDING = makeConstant('ADD_PARTICIPANTS_PENDING');
var ADD_PARTICIPANTS_SUCCESS = makeConstant('ADD_PARTICIPANTS_SUCCESS');
var ADD_PARTICIPANTS_FAILED = makeConstant('ADD_PARTICIPANTS_FAILED');

var REMOVE_PARTICIPANTS = makeConstant('REMOVE_PARTICIPANTS');
var REMOVE_PARTICIPANTS_PENDING = makeConstant('REMOVE_PARTICIPANTS_PENDING');
var REMOVE_PARTICIPANTS_SUCCESS = makeConstant('REMOVE_PARTICIPANTS_SUCCESS');
var REMOVE_PARTICIPANTS_FAILED = makeConstant('REMOVE_PARTICIPANTS_FAILED');

var SET_MODAL_VISIBILITY = makeConstant('SET_MODAL_VISIBILITY');

/***/ }),

/***/ "Atam":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B00U":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(526);

/***/ }),

/***/ "B9fz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9jE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_install_widget_video_png__ = __webpack_require__("GeoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_install_widget_video_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_install_widget_video_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl__ = __webpack_require__("3eLe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var INSTALL_EDU_URL = 'https://insider.drift.com/lessons/lesson-1/';

function mapStateToProps(state) {
  return {
    hasSeenEduNudge: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_selectors__["g" /* properties */])(state).get('hasSeenInstallEduNudge') || false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchUserProperties: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__["a" /* fetchUserProperties */],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */],
      track: __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
}

var InstallEduTooltip = function (_Component) {
  _inherits(InstallEduTooltip, _Component);

  function InstallEduTooltip(props) {
    _classCallCheck(this, InstallEduTooltip);

    var _this = _possibleConstructorReturn(this, (InstallEduTooltip.__proto__ || Object.getPrototypeOf(InstallEduTooltip)).call(this, props));

    _this.componentDidMount = function () {
      _this.props.actions.fetchUserProperties();
      setTimeout(function () {
        _this.setState({ showEduNudgeTimed: true });
        _this.props.actions.track("In App Education - Viewed", { page: "widget install", nudge: !_this.props.hasSeenEduNudge });
      }, 5000);
    };

    _this.componentWillUnmount = function () {
      _this.updateUserProps();
    };

    _this.updateUserProps = function () {
      if (!_this.props.hasSeenEduNudge) {
        _this.props.actions.updateUserProperties({ hasSeenInstallEduNudge: true }, false);
      }
    };

    _this.onToggleEduTooltip = function () {
      var showEduTooltip = _this.state.showEduTooltip;

      if (!!showEduTooltip) {
        _this.updateUserProps();
        _this.props.actions.track("In App Education - Closed", { page: "widget install", nudge: !_this.props.hasSeenEduNudge });
      } else {
        _this.props.actions.track("In App Education - Opened", { page: "widget install", nudge: !_this.props.hasSeenEduNudge });
      }
      _this.setState({ showEduTooltip: !showEduTooltip, showEduNudgeTimed: false });
    };

    _this.onWatchEduTooltip = function (link) {
      window.open(INSTALL_EDU_URL, '_blank');
      _this.props.actions.track("In App Education - Watched", { page: "widget install", nudge: !_this.props.hasSeenEduNudge, link: link });
      _this.setState({ showEduTooltip: false });
    };

    _this.state = {
      showEduNudgeTimed: false,
      showEduTooltip: false
    };
    return _this;
  }

  _createClass(InstallEduTooltip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showEduNudgeTimed = _state.showEduNudgeTimed,
          showEduTooltip = _state.showEduTooltip;
      var hasSeenEduNudge = this.props.hasSeenEduNudge;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'install-edu-nudge-animation-container' },
        !!showEduNudgeTimed && !hasSeenEduNudge && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'install-edu-nudge-bolt-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { className: 'install-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { className: 'install-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { className: 'install-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { className: 'install-edu-nudge-bolt', name: 'lightning-bolt-filled' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__driftt_tide_tooltips_legacy__["FeatureTooltip"],
          {
            className: 'install-edu-tooltip',
            onClose: function onClose() {
              return _this2.onToggleEduTooltip();
            },
            showTooltip: !!showEduTooltip,
            ribbonType: 'how',
            orientation: 'vertical',
            tooltipSide: 'bottom',
            tooltipCaretLocation: 'center',
            headerCopy: 'Learn how to install Drift in a couple quick steps',
            bodyCopy: 'You can add Drift to your website in about 2 minutes by embedding a few lines of JavaScript on your website or using Drift\u2019s WordPress, or Segment integrations.',
            mediaComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: "install-edu-tooltip-img", src: __WEBPACK_IMPORTED_MODULE_8_images_install_widget_video_png___default.a, onClick: function onClick() {
                  _this2.onWatchEduTooltip("img");
                }, alt: 'Drift install how-to video' })
            ),
            buttonInfoArray: [{
              copy: 'Watch on Drift Insider',
              func: function func() {
                _this2.onWatchEduTooltip("button");
              }
            }] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'install-edu-tooltip-container', onClick: this.onToggleEduTooltip },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { className: 'install-edu-nudge-icon', name: 'video-play' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'install-edu-nudge-copy' },
              'How to install Drift'
            )
          )
        )
      );
    }
  }]);

  return InstallEduTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(InstallEduTooltip));

/***/ }),

/***/ "BAeu":
/***/ (function(module, exports) {

module.exports = drifthq_3e18020ec824d68e3f85;

/***/ }),

/***/ "BCsj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component__ = __webpack_require__("fdnL");



















var mapStateToProps = function mapStateToProps(state, props) {
  return {
    orgUsers: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    marketingEmailLayout: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_53" /* marketingEmailLayout */](state),
    currentUser: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state),
    inboxes: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["f" /* inboxes */](state),
    isInboxListLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["h" /* isInboxListLoading */](state),
    isInboxListLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["g" /* isInboxListLoaded */](state),
    orgName: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["orgName"](state),
    orgLogoUrl: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["orgLogoUrl"](state),
    orgTwitterUrl: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["t" /* orgTwitterLink */](state),
    orgLinkedinUrl: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["r" /* orgLinkedinLink */](state),
    orgFacebookUrl: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["q" /* orgFacebookLink */](state),
    orgAddress: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["p" /* orgAddress */](state),
    embedFetchPending: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["c" /* embedFetchPending */](state),
    playbookId: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["p" /* draftId */](state),
    isOrgLoaded: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["isLoaded"](state),
    isBannerUploadPending: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_31" /* isBannerUploadPending */](state, props.id),
    hasDynamicSenderEnabled: __WEBPACK_IMPORTED_MODULE_14_utils_Access__["c" /* default */].isAtLeastProPlan()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_5_app_modules_inbox_actions__["A" /* fetchInboxList */],
      sendTestEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_125" /* sendTestEmail */],
      showEditSenderModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_230" /* showEditSenderModal */],
      fetchEmbed: __WEBPACK_IMPORTED_MODULE_12_app_modules_embed_actions__["a" /* fetchEmbed */],
      fetchOrg: __WEBPACK_IMPORTED_MODULE_10_app_modules_org_actions__["fetchOrg"],
      setEmailBanner: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_159" /* setEmailBanner */],
      clearEmailBanner: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["s" /* clearEmailBanner */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        actions = _props.actions,
        isInboxListLoaded = _props.isInboxListLoaded,
        isInboxListLoading = _props.isInboxListLoading,
        includeSenderSelect = _props.includeSenderSelect;

    if (!isInboxListLoaded && !isInboxListLoading && includeSenderSelect) {
      actions.fetchInboxList();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var orgUsers = _ref.orgUsers,
      isInboxListLoaded = _ref.isInboxListLoaded,
      includeSenderSelect = _ref.includeSenderSelect;
  return !orgUsers.size || !isInboxListLoaded && includeSenderSelect;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    authorId: props.authorId || _.get(props, 'emailMessage.authorId'),
    senderName: props.sendFromOverride || _.get(props, 'emailMessage.sendFromOverride') || '',
    emailOverride: props.senderEmailOverride || _.get(props, 'emailMessage.senderEmailOverride') || '',
    dynamicAccountSendAttribute: props.dynamicAccountSendAttribute || _.get(props, 'emailMessage.dynamicAccountSendAttribute'),
    showCompanyLogo: props.marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_COMPANY_LOGO,
    showHeroImage: props.marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_HERO_IMAGE,
    showCompanyFooter: [__WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_COMPANY_LOGO, __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_HERO_IMAGE].includes(props.marketingEmailLayout),
    defaultUser: props.orgUsers.toJS().find(function (user) {
      return [props.emailMessage.authorId, props.authorId].includes(user.id) || user.email === props.authorId;
    }) || props.orgUsers.first().toJS()
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (!this.props.emailOverride) {
      this.props.setAuthorId(this.props.defaultUser.id);
      this.props.setEmailOverride(this.props.defaultUser.email);
      this.props.setSenderName(this.props.defaultUser.name);
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  var inboxEmailIsOverride = props.inboxes.find(function (inbox) {
    return inbox.get('address') === props.emailOverride;
  });
  return {
    placeholderName: Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(props.defaultUser),
    message: props.emailMessage.message,
    headline: props.emailMessage.title,
    selectedUserId: inboxEmailIsOverride ? props.emailOverride : props.authorId
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onSenderNameChange: function onSenderNameChange(props) {
    return function (e) {
      props.setSenderName(e.target.value);
    };
  },
  onMessageChange: function onMessageChange(props) {
    return function (content) {
      props.setMessage(content);
    };
  },
  onHeadlineChange: function onHeadlineChange(props) {
    return function (event) {
      props.setHeadline(event.target.value);
    };
  },
  onEditSenderClick: function onEditSenderClick(props) {
    return function () {
      props.actions.showEditSenderModal(props.id);
    };
  },
  onUserIdChange: function onUserIdChange(props) {
    return function (_ref2) {
      var isInbox = _ref2.isInbox,
          value = _ref2.value;

      if (isInbox) {
        props.setAuthorId(props.currentUser.get('id', 0));
        props.setEmailOverride(value);
      } else {
        props.setAuthorId(value);
        var sendFromAuthor = props.orgUsers.find(function (user) {
          return user.id === value;
        });
        sendFromAuthor && props.setEmailOverride(sendFromAuthor.email);
      }
    };
  },
  onSendTestEmailClick: function onSendTestEmailClick(props) {
    return function () {
      props.actions.sendTestEmail({ emailId: props.id });
    };
  },
  onBannerUpload: function onBannerUpload(props) {
    return function (files) {
      var setEmailBanner = props.actions.setEmailBanner;

      setEmailBanner({ file: files[0], emailId: props.id });
    };
  },
  onBannerClear: function onBannerClear(props) {
    return function () {
      var clearEmailBanner = props.actions.clearEmailBanner;

      clearEmailBanner({ emailId: props.id });
    };
  },
  renderSelectedUser: function renderSelectedUser(props) {
    return function (option) {
      var selectedValueIsInbox = !!props.inboxes.find(function (inbox) {
        return inbox.get('address') === props.emailOverride;
      });
      var selectedUser = props.orgUsers.find(function (user) {
        return user.id === props.authorId;
      });
      var selectedEmail = selectedUser ? selectedUser.email : option.value.value;
      return React.createElement(
        'div',
        { className: 'Select-value' },
        React.createElement(
          'span',
          { className: 'Select-value-label' },
          selectedValueIsInbox ? props.emailOverride : selectedEmail
        )
      );
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_15__component__["a" /* EmailEditCard */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "BEQ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(6);

/***/ }),

/***/ "BEyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export question */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playbook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return playbookNormalizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return playbookListNormalizer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__("JeHt");


var keyword = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('keywords');

var answer = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('answers', {
  keywords: [keyword]
});

var question = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('questions', {
  answers: [answer]
});

var email = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('emails');

var signature = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('signatureActions');

var actionType = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('actionTypes', {
  action: {
    questions: [question],
    emails: [email],
    signatureActions: [signature]
  }
});

var goal = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('goals');

var condition = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('conditions');

var conditionSet = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('conditionSets', {
  conditions: [condition]
});

var playbook = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["c" /* schema */].Entity('playbooks', {
  goals: [goal],
  actions: [actionType],
  targeting: {
    display: [conditionSet]
  }
});

var playbookList = [playbook];

var playbookNormalizer = function playbookNormalizer(playbookResponse) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(playbookResponse, playbook);
};
var playbookListNormalizer = function playbookListNormalizer(playbookListResponse) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["b" /* normalize */])(playbookListResponse, playbookList);
};

/***/ }),

/***/ "BFyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_LocationSearch__ = __webpack_require__("D1sA");




var InformationEdit = function InformationEdit(_ref) {
  var name = _ref.name,
      displayLocation = _ref.displayLocation,
      handleNameChange = _ref.handleNameChange,
      handleLocationChange = _ref.handleLocationChange;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { className: 'drift-form', style: { paddingTop: 25 } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dsg-Label color-navy-dark' },
      'name'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      style: { width: '100%', marginBottom: 10, marginTop: 3 },
      required: true,
      value: name,
      onChange: handleNameChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dsg-Label color-navy-dark', style: { marginBottom: 3 } },
      'location'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_LocationSearch__["a" /* default */], {
      placeholder: '',
      initialValue: displayLocation,
      types: ['(cities)'],
      onSuggestSelect: handleLocationChange
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (InformationEdit);

/***/ }),

/***/ "BGpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_REVEAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_REVEAL_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_REVEAL_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_REVEAL_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_REVEAL_DATA_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_REVEAL_DATA_BY_IP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_REVEAL_DATA_BY_IP_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_REVEAL_DATA_BY_IP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_REVEAL_DATA_BY_IP_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_REVEAL_DATA_BY_IP_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SHOW_REVEAL_DATA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('conversation/reveal');

var FETCH_REVEAL_DATA = makeConstant('FETCH_REVEAL_DATA');
var FETCH_REVEAL_DATA_PENDING = makeConstant('FETCH_REVEAL_DATA_PENDING');
var FETCH_REVEAL_DATA_SUCCESS = makeConstant('FETCH_REVEAL_DATA_SUCCESS');
var FETCH_REVEAL_DATA_FAILED = makeConstant('FETCH_REVEAL_DATA_FAILED');
var FETCH_REVEAL_DATA_CANCELLED = makeConstant('FETCH_REVEAL_DATA_CANCELLED');

var FETCH_REVEAL_DATA_BY_IP = makeConstant('FETCH_REVEAL_DATA_BY_IP');
var FETCH_REVEAL_DATA_BY_IP_PENDING = makeConstant('FETCH_REVEAL_DATA_BY_IP_PENDING');
var FETCH_REVEAL_DATA_BY_IP_SUCCESS = makeConstant('FETCH_REVEAL_DATA_BY_IP_SUCCESS');
var FETCH_REVEAL_DATA_BY_IP_FAILED = makeConstant('FETCH_REVEAL_DATA_BY_IP_FAILED');
var FETCH_REVEAL_DATA_BY_IP_CANCELLED = makeConstant('FETCH_REVEAL_DATA_BY_IP_CANCELLED');
var FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES = makeConstant('FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES');
var FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_PENDING = makeConstant('FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_PENDING');
var FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_SUCCESS = makeConstant('FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_SUCCESS');

var SHOW_REVEAL_DATA = makeConstant('SHOW_REVEAL_DATA');

/***/ }),

/***/ "BIem":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFilters; });
/* unused harmony export clearFilters */
var LIVE_FILTERS_CACHE_KEY = 'Drift.Live.filters';

var setFilters = function setFilters(filters) {
  if (!filters) {
    return;
  }
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.setItem(LIVE_FILTERS_CACHE_KEY, JSON.stringify(filters));
  return filters;
};

var getFilters = function getFilters() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  var filters = localStorage.getItem(LIVE_FILTERS_CACHE_KEY);
  return filters && JSON.parse(filters);
};

var clearFilters = function clearFilters() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.removeItem(LIVE_FILTERS_CACHE_KEY);
};

/***/ }),

/***/ "BK43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardLayoutPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WideLayoutPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar_images_default_avatar_svg__ = __webpack_require__("i+XW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar_images_default_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar_images_default_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styl__ = __webpack_require__("K9D0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_styl__);





var CardLayoutPreview = function CardLayoutPreview(_ref) {
  var user = _ref.user;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a.CardLayoutPreviewContainer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a.CardLayoutPreview },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'header',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__["a" /* default */], { shape: 'circle', user: user }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'bg-gray-extra-light' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null)
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null)
      )
    )
  );
};

var WideLayoutPreview = function WideLayoutPreview(_ref2) {
  var coverPhotoUrl = _ref2.coverPhotoUrl;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a.WideLayoutPreviewContainer },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      {
        className: __WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a['WideLayoutPreview__Header'],
        style: { backgroundImage: coverPhotoUrl ? 'url(' + coverPhotoUrl + ')' : undefined }
      },
      !coverPhotoUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar_images_default_avatar_svg___default.a }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null)
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a['WideLayoutPreview__Content'] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex flex-space-between' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: {
            width: '48%',
            border: '1px solid currentColor',
            background: 'currentColor'
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: {
            width: '48%',
            border: '1px solid currentColor',
            background: 'none'
          } })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null)
    )
  );
};

/***/ }),

/***/ "BO9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_constants__ = __webpack_require__("rrQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_payments_Gates__ = __webpack_require__("G69f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_EmbedConfigurationConstants__ = __webpack_require__("ZDyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Segment__ = __webpack_require__("NivL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Target__ = __webpack_require__("ryZ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OnlineHours__ = __webpack_require__("6IBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BackButton__ = __webpack_require__("h2eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TimezonePicker__ = __webpack_require__("R33K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__WidgetModeSelector__ = __webpack_require__("o7yj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_shared_PremiumOverlay__ = __webpack_require__("6y6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PageTitle__ = __webpack_require__("dtTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__driftt_drift_tour__ = __webpack_require__("358Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__driftt_drift_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__driftt_drift_tour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tourInfo__ = __webpack_require__("GMSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tourInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__tourInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__style_styl__ = __webpack_require__("eugp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
































var HasSeenTargetingHours = 'onboardingHasSeenTargetingHours';

var DisabledAudienceAndTargeting = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_18_components_shared_PremiumOverlay__["a" /* default */],
  { className: __WEBPACK_IMPORTED_MODULE_27__style_styl___default.a.DisabledAudienceAndTargeting },
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */],
    { title: 'Targeting' },
    'Reach the right people at exactly the right time with targeting. Target by segment, URL, time on page, and more.'
  )
);

var HoursAndTargeting = function (_Component) {
  _inherits(HoursAndTargeting, _Component);

  function HoursAndTargeting() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HoursAndTargeting);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HoursAndTargeting.__proto__ || Object.getPrototypeOf(HoursAndTargeting)).call.apply(_ref, [this].concat(args))), _this), _this.setOrgHasSeenProperty = function () {
      var patchedProperties = Object(__WEBPACK_IMPORTED_MODULE_20_utils_PatchHelper__["a" /* patchOperations */])(_defineProperty({}, HasSeenTargetingHours, true));

      _this.props.actions.patchOrgProperties(patchedProperties);
    }, _this.orgIsNewEnoughForTour = function () {
      var orgCreatedAt = _this.props.orgCreatedAt;

      var now = new Date();
      now.setMonth(now.getMonth() - 1);

      return orgCreatedAt > now;
    }, _this.userHasSeenTour = function () {
      var userProperties = _this.props.userProperties;


      return !!userProperties.get('tour--' + __WEBPACK_IMPORTED_MODULE_23__tourInfo___default.a.scope);
    }, _this.startTourAndMarkComplete = function () {
      var updateUserProperties = _this.props.actions.updateUserProperties;


      setTimeout(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_22__driftt_drift_tour__["startTour"])('settings');
      }, __WEBPACK_IMPORTED_MODULE_23__tourInfo___default.a.delay);
      updateUserProperties(_defineProperty({}, 'tour--' + __WEBPACK_IMPORTED_MODULE_23__tourInfo___default.a.scope, true));
    }, _this.updateEmbed = function (changes) {
      _this.props.actions.patchEmbed(changes);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HoursAndTargeting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          userPropertiesLoaded = _props.userPropertiesLoaded,
          isOrgDataLoaded = _props.isOrgDataLoaded,
          orgProperties = _props.orgProperties,
          actions = _props.actions;

      actions.fetchEmbed();

      if (userPropertiesLoaded && isOrgDataLoaded && !this.userHasSeenTour() && this.orgIsNewEnoughForTour()) {
        this.startTourAndMarkComplete();
      }

      if (!orgProperties[HasSeenTargetingHours]) {
        this.setOrgHasSeenProperty();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (_.isEqual(nextProps.embed, this.props.embed)) return;

      var isPatchSuccess = nextProps.embedStatus === __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_constants__["i" /* PATCH_EMBED_SUCCESS */];
      var isPatchError = nextProps.embedStatus === __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_constants__["g" /* PATCH_EMBED_ERROR */];

      isPatchSuccess && this.context.app.actions.NotificationActions.pushNotification({
        content: 'Your changes have been saved!'
      });

      isPatchError && this.context.app.actions.NotificationActions.pushNotification({
        content: 'Something went wrong saving your changes.',
        variant: 'red'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.embed) return null;

      var _props2 = this.props,
          segments = _props2.segments,
          users = _props2.users,
          gates = _props2.gates,
          orgSettings = _props2.orgSettings,
          embed = _props2.embed,
          Tooltip = _props2.Tooltip;

      var isInAutoMode = embed.widgetMode === __WEBPACK_IMPORTED_MODULE_11_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].AUTO;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_27__style_styl___default.a.HoursAndTargeting },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__BackButton__["a" /* default */], { title: 'Drift Widget Settings', url: '/settings/widget' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PageTitle__["a" /* default */], {
          title: 'Hours & Targeting',
          description: 'Customize when your Drift Widget displays to your customers and visitors'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Tooltip,
          { tooltipId: 'status' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */],
            { title: 'Drift Widget Online / Offline Status', className: 'radios' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__WidgetModeSelector__["a" /* default */], { embed: embed, updateEmbed: this.updateEmbed })
          )
        ),
        isInAutoMode && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OnlineHours__["a" /* default */], {
          orgName: orgSettings.orgName,
          initialOpenHours: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(embed.theme.openHours),
          initialAvailabilityBasedOnline: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(embed.theme.availabilityBasedOnline),
          updateEmbed: this.updateEmbed
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Tooltip,
          { tooltipId: 'timezone' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */],
            { title: 'Timezone', className: 'timezone' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TimezonePicker__["a" /* default */], { orgSettings: orgSettings })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_components_payments_Gates__["a" /* PremiumGate */],
          {
            requiredGates: ['has_11_2016_targeting'],
            FallbackComponent: DisabledAudienceAndTargeting
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */], {
            title: 'Targeting',
            description: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                'The Drift Widget is available to everyone who visits your website.'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'a',
                { href: 'https://help.drift.com/article/displaying-the-chat-widget/', target: '_blank' },
                ' ',
                'Learn More'
              )
            ),
            className: 'targeting'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Tooltip,
            { tooltipId: 'audience' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */],
              { className: 'segment' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Segment__["a" /* default */], { segments: segments, users: users, gates: gates, orgSettings: orgSettings })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Tooltip,
            { tooltipId: 'displaywhen' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9__Section__["a" /* SectionItem */],
              { className: 'target' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Target__["a" /* default */], { orgSettings: orgSettings })
            )
          )
        )
      );
    }
  }]);

  return HoursAndTargeting;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

HoursAndTargeting.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


function mapStateToProps(state) {
  return {
    embed: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["h" /* getEmbedConfig */])(state),
    embedStatus: state.get('embed').get('status'),
    userPropertiesLoaded: Object(__WEBPACK_IMPORTED_MODULE_25_app_modules_user_properties_selectors__["h" /* propertiesLoaded */])(state),
    userProperties: Object(__WEBPACK_IMPORTED_MODULE_25_app_modules_user_properties_selectors__["g" /* properties */])(state),
    isOrgDataLoaded: Object(__WEBPACK_IMPORTED_MODULE_26_app_modules_org_selectors__["isLoaded"])(state),
    orgCreatedAt: Object(__WEBPACK_IMPORTED_MODULE_26_app_modules_org_selectors__["getDateCreatedAt"])(state),
    orgProperties: Object(__WEBPACK_IMPORTED_MODULE_26_app_modules_org_selectors__["properties"])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(_extends({
      fetchEmbed: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__["a" /* fetchEmbed */],
      patchEmbedSuccess: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__["i" /* patchEmbedSuccess */],
      patchEmbed: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__["f" /* patchEmbed */],
      fetchUserProperties: __WEBPACK_IMPORTED_MODULE_24_app_modules_user_properties_actions__["a" /* fetchUserProperties */],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_24_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */]
    }, __WEBPACK_IMPORTED_MODULE_21_app_modules_org_actions__), dispatch)
  };
}

var ReduxHoursAndTargeting = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(HoursAndTargeting);

var HoursAndTargetingContainer = Object(__WEBPACK_IMPORTED_MODULE_10_components_container__["a" /* makeDefaultFailedContainer */])(ReduxHoursAndTargeting, {
  listenTo: ['stores.AvailabilityStore', 'stores.SegmentStore', 'stores.UserStore', 'stores.GateStore', 'stores.OrgSettingsStore', 'stores.DefaultEmbedStore'],
  fetch: {
    segments: function segments() {
      return this.app.stores.SegmentStore.getOrFetchSegments();
    },
    users: function users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg();
    },
    gates: function gates() {
      return this.app.stores.GateStore.getOrFetchGates();
    },
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22__driftt_drift_tour__["WithTour"])(__WEBPACK_IMPORTED_MODULE_23__tourInfo___default.a)(HoursAndTargetingContainer));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "BP1X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEND_DRIFT_APP_METRIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEND_DRIFT_APP_METRIC_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEND_DRIFT_APP_METRIC_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEND_DRIFT_APP_METRIC_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTER_ROOT_APP_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return START_CONVERSATIONS_APP_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECORD_CONVERSATIONS_APP_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TRACK_PRESENCE_LOAD_TIME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('metrics');

var SEND_DRIFT_APP_METRIC = makeConstant('SEND_DRIFT_APP_METRIC');
var SEND_DRIFT_APP_METRIC_PENDING = makeConstant('SEND_DRIFT_APP_METRIC_PENDING');
var SEND_DRIFT_APP_METRIC_FAILED = makeConstant('SEND_DRIFT_APP_METRIC_FAILED');
var SEND_DRIFT_APP_METRIC_SUCCESS = makeConstant('SEND_DRIFT_APP_METRIC_SUCCESS');

var ENTER_ROOT_APP_ROUTE = makeConstant('ENTER_ROOT_APP_ROUTE');
var START_CONVERSATIONS_APP_TIMER = makeConstant('START_CONVERSATIONS_APP_TIMER');
var RECORD_CONVERSATIONS_APP_TIMER = makeConstant('RECORD_CONVERSATIONS_APP_TIMER');
var HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT = makeConstant('HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT');

var TRACK_PRESENCE_LOAD_TIME = makeConstant('TRACK_PRESENCE_LOAD_TIME');

/***/ }),

/***/ "BV35":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_renderComponent__ = __webpack_require__("N71h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_renderComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_renderComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda_src_prop__ = __webpack_require__("xf7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda_src_prop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_ramda_src_prop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__driftt_audience_builder__ = __webpack_require__("DZSL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__driftt_audience_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__driftt_audience_builder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_account_actions__ = __webpack_require__("j4fR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_account_selectors__ = __webpack_require__("nGBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SegmentSelect__ = __webpack_require__("0y2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AudienceBuilderContainer__ = __webpack_require__("qkXX");






























var mapStateToProps = function mapStateToProps(state) {
  return {
    audience: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["d" /* audience */](state),
    segmentSelectVisible: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_69" /* segmentSelectVisible */](state),
    isMessageTypePlaybook: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_42" /* isMessageTypePlaybook */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    orgId: __WEBPACK_IMPORTED_MODULE_19_app_modules_org_selectors__["orgId"](state),
    endUserCount: __WEBPACK_IMPORTED_MODULE_19_app_modules_org_selectors__["endUserCount"](state),
    isCardinalityLoading: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["i" /* cardinalityLoading */](state),
    targetingCardinality: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_102" /* targetingCardinality */](state),
    segments: __WEBPACK_IMPORTED_MODULE_18_app_modules_segment_selectors__["a" /* byId */](state),
    userListIds: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    excludedUserListIds: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["A" /* excludedUserListIds */](state),
    accountListIds: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["a" /* accountListIds */](state),
    excludedAccountListIds: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["z" /* excludedAccountListIds */](state),
    accountSegments: __WEBPACK_IMPORTED_MODULE_20_app_modules_account_selectors__["a" /* getAccountSegments */](state),
    smartFilters: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["f" /* builderSmartFilters */](state),
    accountSegmentsIsLoading: __WEBPACK_IMPORTED_MODULE_20_app_modules_account_selectors__["b" /* getAccountSegmentsIsLoading */](state),
    hasSmartFilterInclusion: !__WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    hasAccountSegmentation: Object(__WEBPACK_IMPORTED_MODULE_23_app_modules_gates_selectors__["u" /* makeHasGate */])('ABM')(state) && !__WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    hasAbandonedMeetingSmartFilter: __WEBPACK_IMPORTED_MODULE_24_utils_Access__["c" /* default */].isAtLeastProPlan(),
    hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_19_app_modules_org_selectors__["hasLimitedContactsMktEmail"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchSegmentList: __WEBPACK_IMPORTED_MODULE_14_app_modules_segment_actions__["d" /* fetchSegmentList */],
      setAudience: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_137" /* setAudience */],
      showSegmentSelect: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_237" /* showSegmentSelect */],
      fetchEndUserCount: __WEBPACK_IMPORTED_MODULE_16_app_modules_org_actions__["fetchEndUserCount"],
      fetchAccountSegments: __WEBPACK_IMPORTED_MODULE_15_app_modules_account_actions__["f" /* fetchAccountSegments */],
      setAccountListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_134" /* setAccountListIds */],
      setExcludedAccountListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_170" /* setExcludedAccountListIds */],
      setUserListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_221" /* setUserListIds */],
      fetchPlaybookCardinality: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_25" /* fetchPlaybookCardinality */],
      setExcludedUserListIds: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_171" /* setExcludedUserListIds */],
      setSmartFilters: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_actions__["_213" /* setSmartFilters */],
      hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_16_app_modules_org_actions__["hasLimitedContactsMktEmail"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default()({
  componentDidMount: function componentDidMount() {
    // TODO: this takes `index` and `size` because it's paginated, we should figure this out later
    if (this.props.hasAccountSegmentation) {
      // don't fetch accounts unless there is accounts segmentation
      this.props.actions.fetchAccountSegments({ index: 0, size: 200 });
    }
    this.props.actions.fetchEndUserCount(this.props.orgId);

    if (this.props.isEmailPlaybook) {
      var _props = this.props,
          userListIds = _props.userListIds,
          excludedUserListIds = _props.excludedUserListIds,
          orgId = _props.orgId,
          smartFilters = _props.smartFilters,
          isEmailPlaybook = _props.isEmailPlaybook;

      this.props.actions.fetchPlaybookCardinality({ orgId: orgId, userListIds: userListIds, excludedUserListIds: excludedUserListIds, smartFilters: smartFilters, isEmailPlaybook: isEmailPlaybook });
      this.props.actions.hasLimitedContactsMktEmail();
    }
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function (props) {
  return {
    everyoneSelected: props.audience === __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].EVERYONE,
    segmentSelected: props.audience === __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].SEGMENT,
    usersSelected: props.audience === __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].USERS,
    visitorsSelected: props.audience === __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].VISITORS,
    noneSelected: props.audience === __WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].NONE,
    onSegmentChange: function onSegmentChange(userListIds, excludedUserListIds, smartFilters) {
      var orgId = props.orgId,
          isEmailPlaybook = props.isEmailPlaybook;


      props.actions.fetchPlaybookCardinality({ orgId: orgId, userListIds: userListIds, excludedUserListIds: excludedUserListIds, smartFilters: smartFilters, isEmailPlaybook: isEmailPlaybook });
    },
    clearInclusiveSegments: function clearInclusiveSegments() {
      props.actions.setUserListIds(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])([]));
      props.actions.setAccountListIds(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])([]));
    }
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  onEveryoneClick: function onEveryoneClick(props) {
    return function () {
      props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].EVERYONE);
      props.clearInclusiveSegments();
    };
  },
  onSegmentClick: function onSegmentClick(props) {
    return function () {
      props.actions.showSegmentSelect();
    };
  },
  onUsersClick: function onUsersClick(props) {
    return function () {
      props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].USERS);
      props.clearInclusiveSegments();
    };
  },
  onVisitorsClick: function onVisitorsClick(props) {
    return function () {
      props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].VISITORS);
      props.clearInclusiveSegments();
    };
  },
  onNoneClick: function onNoneClick(props) {
    return function () {
      props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].NONE);
      props.clearInclusiveSegments();
    };
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withProps___default()(function (props) {
  return {
    loading: props.accountSegmentsIsLoading || props.segments.size === 0 && (!props.userListIds || !props.excludedUserListIds),
    saveAudience: function saveAudience(selections) {
      var selectedSendContacts = selections.selectedSendContacts,
          selectedDontSendAccounts = selections.selectedDontSendAccounts,
          selectedDontSendContacts = selections.selectedDontSendContacts,
          selectedAccounts = selections.selectedAccounts,
          selectedFilters = selections.selectedFilters;

      var includedUserListIds = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(selectedSendContacts);
      var excludedUserListIds = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(selectedDontSendContacts);
      props.actions.setSmartFilters(selectedFilters);

      var sendSegmentsAreEmpty = Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["isEmpty"])(selectedSendContacts) && Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["isEmpty"])(selectedAccounts) && Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["isEmpty"])(Object(__WEBPACK_IMPORTED_MODULE_10_lodash__["pickBy"])(selectedFilters, function (value) {
        return value === __WEBPACK_IMPORTED_MODULE_12__driftt_audience_builder__["SmartFilterValues"].INCLUDE;
      }));

      // always set excluded
      props.actions.setExcludedUserListIds(excludedUserListIds);
      props.actions.setExcludedAccountListIds(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(selectedDontSendAccounts));

      // Special case these as they map to specific actions
      if (!props.isEmailPlaybook && sendSegmentsAreEmpty) {
        props.onEveryoneClick();
      } else if (Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["contains"])(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].USERS, selectedSendContacts)) {
        props.onUsersClick();
      } else if (Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["contains"])(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].VISITORS, selectedSendContacts)) {
        props.onVisitorsClick();
      } else {
        props.actions.setAudience(__WEBPACK_IMPORTED_MODULE_21_app_modules_playbook_constants__["w" /* AudienceType */].SEGMENT);
        props.actions.setUserListIds(includedUserListIds);
        props.actions.setAccountListIds(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(selectedAccounts));
        props.onSegmentChange(includedUserListIds, excludedUserListIds, selectedFilters);
      }
    }
  };
}), __WEBPACK_IMPORTED_MODULE_7_recompose_branch___default()(__WEBPACK_IMPORTED_MODULE_11_ramda_src_prop___default()('segmentSelectVisible'), __WEBPACK_IMPORTED_MODULE_8_recompose_renderComponent___default()(__WEBPACK_IMPORTED_MODULE_22__SegmentSelect__["a" /* default */])))(__WEBPACK_IMPORTED_MODULE_25__AudienceBuilderContainer__["a" /* default */]));

/***/ }),

/***/ "BWTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("Yqpn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var ICON_SRC = __webpack_require__("gYUb");

var HELP_TEXT = 'Exit intent is a best-effort attempt to determine when a user is about to leave the page. Currently this condition only works on desktop browsers.';

/* harmony default export */ __webpack_exports__["a"] = (function () {
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.ExitIntent },
    React.createElement(
      'div',
      { is: true, tooltip: HELP_TEXT, flow: 'right' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: ICON_SRC, style: { display: 'block' } })
    )
  );
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "BX9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Modal__ = __webpack_require__("3F5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Button__ = __webpack_require__("1iW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("dIjX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var GlobalModal = function (_Component) {
  _inherits(GlobalModal, _Component);

  function GlobalModal() {
    _classCallCheck(this, GlobalModal);

    return _possibleConstructorReturn(this, (GlobalModal.__proto__ || Object.getPrototypeOf(GlobalModal)).apply(this, arguments));
  }

  _createClass(GlobalModal, [{
    key: 'render',
    value: function render() {
      var _props$modalState = this.props.modalState,
          show = _props$modalState.show,
          _props$modalState$dat = _props$modalState.data,
          title = _props$modalState$dat.title,
          description = _props$modalState$dat.description,
          confirm = _props$modalState$dat.confirm,
          onConfirm = _props$modalState$dat.onConfirm,
          onCancel = _props$modalState$dat.onCancel,
          buttonProps = _props$modalState$dat.buttonProps;


      if (show) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_Modal__["a" /* default */],
          {
            onClose: onCancel,
            modalContentClassName: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.GlobalModal + ' flex-column flex-center'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.GlobalModalContent + ' flex-column flex-space-around flex-1' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'h3',
              { className: 'dsg-h3' },
              title
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'color-gray-dark' },
              description
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.GlobalModalButtonContainer + ' flex-center' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Button__["a" /* default */],
              _extends({ onClick: onConfirm, size: 'medium', cta: true }, buttonProps),
              confirm
            )
          )
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null);
      }
    }
  }]);

  return GlobalModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

GlobalModal.propTypes = {
  modalState: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.recordOf({
    show: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired,
    data: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.recordOf({
      title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      confirm: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      onConfirm: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
      onCancel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


var GlobalModalContainer = Object(__WEBPACK_IMPORTED_MODULE_4_components_container__["a" /* makeDefaultFailedContainer */])(GlobalModal, {
  listenTo: ['stores.GlobalModalStore'],
  fetch: {
    modalState: function modalState() {
      return this.app.stores.GlobalModalStore.getModalState();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (GlobalModalContainer);

/***/ }),

/***/ "BaCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__ = __webpack_require__("ut3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanyInfoProvider__ = __webpack_require__("Kxxm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_ContactRecordLite_Social__ = __webpack_require__("1t2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_live_default_company_logo_svg__ = __webpack_require__("lZSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_live_default_company_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_live_default_company_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("Wuyk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__ = __webpack_require__("tQfr");












var CompanyInfoModal = function CompanyInfoModal(_ref) {
  var companyInfo = _ref.companyInfo,
      canUseCompanyTags = _ref.canUseCompanyTags;


  var location = _.get(companyInfo, 'location', '-');
  var category = _.get(companyInfo, 'category.industry', '-');
  var subCategory = _.get(companyInfo, 'category.subIndustry', '-') || '-';
  var linkedin = _.get(companyInfo, 'linkedin.handle');
  var employees = _.get(companyInfo, 'metrics.employees', '-');
  var raised = _.get(companyInfo, 'metrics.raised', '-');
  var twitter = _.get(companyInfo, 'twitter.handle');
  var about = _.get(companyInfo, 'about', _.get(companyInfo, 'description', '-')) || '-';
  var tags = _.get(companyInfo, 'tags', []);
  var revenueRange = _.get(companyInfo, 'metrics.revenueRange', '-');
  var source = _.get(companyInfo, 'source');

  var companyLogo = !!companyInfo.logo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__["a" /* AvatarCompat */], { company: { name: companyInfo.name, logo: companyInfo.logo }, type: 'company', size: 'small' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'contact-info-header-logo' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_live_default_company_logo_svg___default.a })
  );
  var companyProvider = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoProvider__["a" /* default */], { provider: source });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'scrolly-content' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-info-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-header-left' },
        companyLogo
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-header-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'company-info-title' },
          companyInfo.name
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: companyInfo.url || 'http://www.' + companyInfo.domain, target: '_blank', className: 'company-info-url' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            companyInfo.domain
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'company-info-social' },
          !!twitter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_ContactRecordLite_Social__["a" /* default */], { type: 'twitter', handle: twitter, className: 'company-info-social-icon' }),
          !!linkedin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shared_ContactRecordLite_Social__["a" /* default */], { type: 'linkedin', handle: linkedin, className: 'company-info-social-icon' })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-info-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-content-left' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: location, secondary: 'location' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: category, secondary: 'category' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: subCategory, secondary: 'subcategory' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
          { condition: canUseCompanyTags },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: tags.join(', '), secondary: 'tags' })
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: "company-info-content-right" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: employees, secondary: 'employees' }),
        source === 'DEMANDBASE' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: revenueRange, secondary: 'revenue range' }),
        source === 'CLEARBIT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: '$' + Object(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__["intComma"])(raised), secondary: 'money raised' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'company-info-content-divider' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyInfoField__["a" /* default */], { primary: about, secondary: 'about' })
    ),
    !!companyProvider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-info-footer' },
      companyProvider
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyInfoModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Bb29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_classification_actions__ = __webpack_require__("khns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Playbook__ = __webpack_require__("2x/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Goal__ = __webpack_require__("qKuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Sequence__ = __webpack_require__("kCfH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SequenceOptions__ = __webpack_require__("oxzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SequencePreview__ = __webpack_require__("kKL1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Review__ = __webpack_require__("1ayq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_WelcomeMessage__ = __webpack_require__("yC2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_TargetedMessage__ = __webpack_require__("VQvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_TakeoverMessage__ = __webpack_require__("zH4g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_EmailCaptureMessage__ = __webpack_require__("2ty1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_EmailMessage__ = __webpack_require__("fkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_EmailMessagePreview__ = __webpack_require__("fUPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TargetingAudience__ = __webpack_require__("BV35");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_TargetingDisplay__ = __webpack_require__("D4+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_TargetingDisplayWhen__ = __webpack_require__("SuxC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_TargetingAdvanced__ = __webpack_require__("WsFt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_TargetingExcludes__ = __webpack_require__("cFHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_DriftLink__ = __webpack_require__("XhSY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SignatureEditor__ = __webpack_require__("tKK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_SignaturePreview__ = __webpack_require__("s0m3");




























var Routes = function Routes(store) {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
    {
      path: '/playbooks/:playbookId',
      onEnter: function onEnter(_ref) {
        var playbookId = _ref.params.playbookId;

        var state = store.getState();
        if (!__WEBPACK_IMPORTED_MODULE_4_app_modules_classification_selectors__["c" /* isLoaded */](state)) {
          store.dispatch(__WEBPACK_IMPORTED_MODULE_3_app_modules_classification_actions__["d" /* fetchClassifications */]());
        }

        var draft = __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["n" /* draft */](state);
        var draftId = __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["p" /* draftId */](state);
        if (!draft || '' + draftId !== playbookId) {
          store.dispatch(__WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_actions__["_17" /* fetchPlaybook */]({ id: playbookId }));
        }
      }
    },
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
      {
        path: 'edit',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Playbook__["a" /* default */],
        onEnter: function onEnter() {
          var cardContainer = document.getElementsByClassName('subcontent');
          cardContainer.length ? cardContainer[0].scrollTop = 0 : null;
        }
      },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
        { path: 'goal' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], {
          path: ':goalId',
          component: __WEBPACK_IMPORTED_MODULE_6__components_Goal__["a" /* default */],
          onEnter: function onEnter(_ref2) {
            var goalId = _ref2.params.goalId;

            var state = store.getState();
            var goal = __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["j" /* currentGoal */](state);
            if (goal.id !== goalId) {
              store.dispatch(__WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_actions__["_147" /* setCurrentGoalId */](goalId));
            }
          }
        })
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'sequence', component: __WEBPACK_IMPORTED_MODULE_7__components_Sequence__["a" /* default */] }),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'sequence/preview', component: __WEBPACK_IMPORTED_MODULE_9__components_SequencePreview__["a" /* default */] }),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'sequence/options', component: __WEBPACK_IMPORTED_MODULE_8__components_SequenceOptions__["a" /* default */] }),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
        { path: 'message' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'welcome', component: __WEBPACK_IMPORTED_MODULE_11__components_WelcomeMessage__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'targeted', component: __WEBPACK_IMPORTED_MODULE_12__components_TargetedMessage__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'takeover', component: __WEBPACK_IMPORTED_MODULE_13__components_TakeoverMessage__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'capture', component: __WEBPACK_IMPORTED_MODULE_14__components_EmailCaptureMessage__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'email', component: __WEBPACK_IMPORTED_MODULE_15__components_EmailMessage__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'email-preview', component: __WEBPACK_IMPORTED_MODULE_16__components_EmailMessagePreview__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'signature', component: __WEBPACK_IMPORTED_MODULE_23__components_SignatureEditor__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'signature-preview', component: __WEBPACK_IMPORTED_MODULE_24__components_SignaturePreview__["a" /* default */] })
      ),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
        { path: 'targeting' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'build-segment', render: function render(_ref3) {
            var location = _ref3.location,
                router = _ref3.router;
            return router.push({ pathname: location.pathname.split('/').slice(0, -1).concat(['audience']).join('/') });
          } }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'audience', component: __WEBPACK_IMPORTED_MODULE_17__components_TargetingAudience__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'display', component: __WEBPACK_IMPORTED_MODULE_18__components_TargetingDisplay__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'displaywhen', component: __WEBPACK_IMPORTED_MODULE_19__components_TargetingDisplayWhen__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'driftlink', component: __WEBPACK_IMPORTED_MODULE_22__components_DriftLink__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'advanced', component: __WEBPACK_IMPORTED_MODULE_20__components_TargetingAdvanced__["a" /* default */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'exclude', component: __WEBPACK_IMPORTED_MODULE_21__components_TargetingExcludes__["a" /* default */] })
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'review', component: __WEBPACK_IMPORTED_MODULE_10__components_Review__["a" /* default */] })
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Bbe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("QYDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_svg_magnifying_glass_svg__ = __webpack_require__("Ctet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_svg_magnifying_glass_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_svg_magnifying_glass_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dates__ = __webpack_require__("OjkW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BusinessEventExportModal__ = __webpack_require__("8dzO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_TeamsConstants__ = __webpack_require__("p9md");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var momentFormat = 'MMM Do, YYYY  h:mm a';

var severityOptions = [{ label: 'All', value: 'ALL' }, { label: 'Info', value: 'INFO' }, { label: 'Warn', value: 'WARN' }, { label: 'Error', value: 'ERROR' }, { label: 'Severe', value: 'SEVERE' }];

var typeOptions = [{ label: 'All', value: 'ALL' }, { label: 'User', value: 'USER' }, { label: 'Playbook', value: 'PLAYBOOK' }, { label: 'Widget', value: 'WIDGET' }, { label: 'Team', value: 'TEAM' }, { label: 'Password', value: 'PASSWORD' }];

var SeverityRowItem = function SeverityRowItem(_ref) {
  var level = _ref.level;

  switch (level) {
    case 'WARN':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'warning-triangle', width: 18, height: 18 });
    case 'ERROR':
    case 'SEVERE':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'cancel-circle', width: 18, height: 18 });
    default:
      return null;
  }
};

var EventTable = function (_Component) {
  _inherits(EventTable, _Component);

  function EventTable(props) {
    _classCallCheck(this, EventTable);

    var _this = _possibleConstructorReturn(this, (EventTable.__proto__ || Object.getPrototypeOf(EventTable)).call(this, props));

    _initialiseProps.call(_this);

    var search = window.location.search;
    var params = new URLSearchParams(search);
    var epochFromQueryParam = params.get('epoch');
    var fromEpoch = __WEBPACK_IMPORTED_MODULE_7_moment___default()(epochFromQueryParam, "x");
    var startTime = !!epochFromQueryParam ? { label: _this.formatMoment(fromEpoch), value: 'epoch' } : { label: _this.formatMoment(__WEBPACK_IMPORTED_MODULE_7_moment___default()()), value: 'now' };
    var startDate = !!epochFromQueryParam ? fromEpoch : __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('day');

    _this.state = {
      loaded: false,
      severityFilter: 'ALL',
      referenceToFilter: 'ALL',
      typeFilter: 'ALL',
      timeFrame: '1',
      startTime: startTime,
      startDate: startDate,
      exportModalOpen: false
    };
    return _this;
  }

  _createClass(EventTable, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getData();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actions.destroyIntegrationEvents(this.props.sourceId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.isLoaded) {
        if (!this.state.loaded) {
          this.setState({ loaded: true });
        }

        if (this.state.paginationResolve) {
          this.state.paginationResolve();
          this.setState({ paginationResolve: null });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'event-table-wrapper' },
        this.renderFilterArea(),
        this.state.loaded ? this.renderLoadedState() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__BusinessEventExportModal__["a" /* default */], {
          open: this.state.exportModalOpen,
          onClose: this.closeExportModal,
          sourceId: this.props.sourceId })
      );
    }
  }]);

  return EventTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.formatMoment = function (moment) {
    return moment.format('h:mma');
  };

  this.getMoreData = function () {
    _this2.props.actions.fetchPaginatedIntegrationEvents({ sourceId: _this2.props.sourceId, queryStr: _this2.props.paginationQuery });
    return new Promise(function (res) {
      return _this2.setState({ paginationResolve: res });
    });
  };

  this.getData = function () {
    var sourceId = _this2.props.sourceId;
    var _state = _this2.state,
        timeFrame = _state.timeFrame,
        startTime = _state.startTime,
        startDate = _state.startDate;


    var baseTime = __WEBPACK_IMPORTED_MODULE_7_moment___default()(startDate);

    if (startTime.value === 'now') {
      var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
      baseTime.hours(now.hours());
      baseTime.minutes(now.minutes());
    } else if (startTime.value === 'epoch') {
      baseTime.hours(startTime);
    } else {
      baseTime.hours(startTime.value);
      baseTime.startOf('hour');
    }

    // Capture end of minute for inclusive query.
    baseTime.endOf('minute');

    var endTime = baseTime.unix();
    var start = baseTime.subtract(timeFrame, 'hours').unix();
    var offset = start - endTime;

    var query = {
      sourceId: sourceId,
      unit: 'seconds',
      start: endTime * 1000,
      offset: offset
    };

    _this2.props.actions.fetchIntegrationEvents(query);
    _this2.setState({ loaded: false });
  };

  this.createTableColumns = function () {
    return [{ label: '', width: '50px' }, { label: 'TIME', width: '200px' }, { label: 'EVENT', width: '70%' }];
  };

  this.createTableRow = function (item) {
    return {
      className: 'event-table-row--' + item.level.toLowerCase(),
      data: [{ content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SeverityRowItem, { level: item.level })
        ) }, { content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_7_moment___default()(item.timestamp).format(momentFormat)
        ) }, { content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          item.message
        ) }]
    };
  };

  this.onSeverityFilterChange = function (filter) {
    return _this2.setState({ severityFilter: filter ? filter.value : 'ALL' });
  };

  this.onTypeFilterChange = function (filter) {
    return _this2.setState({ typeFilter: filter ? filter.value : 'ALL' });
  };

  this.onReferenceToFilterChange = function (filter) {
    return _this2.setState({ referenceToFilter: filter ? filter.value : 'ALL' });
  };

  this.filterEvents = function () {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var eventsFilteredBySeverity = _this2.filterEventsBySeverity(events);
    var eventsFilteredBySeverityAndType = _this2.filterEventsByType(eventsFilteredBySeverity);
    return _this2.filterEventsByReferenceTo(eventsFilteredBySeverityAndType);
  };

  this.getEventTypeFromMessage = function (message) {
    if (_this2.messageMatchesStatements(message, __WEBPACK_IMPORTED_MODULE_12_constants_TeamsConstants__["d" /* LOG_WIDGET_STATEMENTS */])) {
      return 'WIDGET';
    } else if (_this2.messageMatchesStatements(message, __WEBPACK_IMPORTED_MODULE_12_constants_TeamsConstants__["a" /* LOG_PASSWORD_STATEMENTS */])) {
      return 'PASSWORD';
    } else if (_this2.messageMatchesStatements(message, __WEBPACK_IMPORTED_MODULE_12_constants_TeamsConstants__["b" /* LOG_PLAYBOOK_STATEMENTS */])) {
      return 'PLAYBOOK';
    } else if (_this2.messageMatchesStatements(message, __WEBPACK_IMPORTED_MODULE_12_constants_TeamsConstants__["c" /* LOG_TEAM_STATEMENTS */])) {
      return 'TEAM';
    } else {
      return 'USER';
    }
  };

  this.messageMatchesStatements = function (message, statements) {
    return statements.some(function (statement) {
      return message.match(statement);
    });
  };

  this.filterEventsByType = function () {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var typeFilter = _this2.state.typeFilter;


    return typeFilter === 'ALL' ? events : events.filter(function (_ref2) {
      var message = _ref2.message;
      return _this2.getEventTypeFromMessage(message) === typeFilter;
    });
  };

  this.filterEventsBySeverity = function () {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var severityFilter = _this2.state.severityFilter;


    return severityFilter === 'ALL' ? events : events.filter(function (_ref3) {
      var level = _ref3.level;
      return level === severityFilter;
    });
  };

  this.filterEventsByReferenceTo = function () {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var referenceToFilter = _this2.state.referenceToFilter;


    return referenceToFilter === 'ALL' ? events : events.filter(function (_ref4) {
      var referenceId = _ref4.referenceId;
      return referenceId === referenceToFilter;
    });
  };

  this.onTimeFrameChange = function (timeFrame) {
    return _this2.setState({ timeFrame: timeFrame ? timeFrame.value : '1' }, _this2.getData);
  };

  this.createHourOptions = function () {
    var hourOptions = [];
    var hrIterator = __WEBPACK_IMPORTED_MODULE_7_moment___default()().startOf('day');
    var iteratorEnd = __WEBPACK_IMPORTED_MODULE_7_moment___default()().endOf('day');
    var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()();

    while (hrIterator < iteratorEnd) {
      hourOptions.push({ value: hrIterator.hour(), label: _this2.formatMoment(hrIterator) });

      var next = __WEBPACK_IMPORTED_MODULE_7_moment___default()(hrIterator).add(1, 'hour');
      if (hrIterator < now && now < next) {
        hourOptions.push({ value: 'now', label: _this2.formatMoment(now) });
      }

      hrIterator = next;
    }

    return hourOptions;
  };

  this.onDateChange = function (startDate) {
    return _this2.setState({ startDate: startDate }, _this2.getData);
  };

  this.onStartTimeChange = function (startTime) {
    return _this2.setState({ startTime: startTime }, _this2.getData);
  };

  this.onPickerFocusChange = function () {
    return _this2.setState(function (prevState) {
      return { pickerFocused: !prevState.pickerFocused };
    });
  };

  this.openExportModal = function () {
    _this2.setState({
      exportModalOpen: true
    });
  };

  this.closeExportModal = function () {
    _this2.setState({
      exportModalOpen: false
    });
  };

  this.typeFilter = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'event-log-type-filter' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        'Type'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select_plus__["b" /* default */], {
        className: 'event-log-selector type-select',
        value: _this2.state.typeFilter,
        options: typeOptions,
        onChange: _this2.onTypeFilterChange,
        clearable: false
      })
    );
  };

  this.severityFilter = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'event-log-severity-filter' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        'Show'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select_plus__["b" /* default */], {
        className: 'event-log-selector type-select',
        value: _this2.state.severityFilter,
        options: severityOptions,
        onChange: _this2.onSeverityFilterChange,
        clearable: false
      })
    );
  };

  this.referenceToFilter = function () {
    var referenceToFilterOptions = _this2.props.referenceToFilterOptions;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'event-log-reference-filter' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        'Filter by'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select_plus__["b" /* default */], {
        className: 'event-log-selector type-select',
        value: _this2.state.referenceToFilter,
        options: referenceToFilterOptions,
        onChange: _this2.onReferenceToFilterChange,
        clearable: false
      })
    );
  };

  this.renderFilterArea = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'event-log-filter' },
      !_this2.props.hideSeverityFilter && _this2.severityFilter(),
      _this2.props.showReferenceToFilter && _this2.referenceToFilter(),
      _this2.props.showTypeFilter && _this2.typeFilter(),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        ' activity from the'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select_plus__["b" /* default */], {
        className: 'event-log-selector timeframe-select',
        value: _this2.state.timeFrame,
        options: [{ label: 'Previous Hour', value: '1' }, { label: 'Previous 6 Hours', value: '6' }, { label: 'Previous 12 Hours', value: '12' }, { label: 'Previous 24 Hours', value: '24' }],
        onChange: _this2.onTimeFrameChange,
        clearable: false
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        ' starting on'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_dates__["SingleDatePicker"], {
        date: _this2.state.startDate,
        onDateChange: _this2.onDateChange,
        focused: _this2.state.pickerFocused,
        onFocusChange: _this2.onPickerFocusChange,
        numberOfMonths: 1,
        isOutsideRange: function isOutsideRange(date) {
          return date.startOf('day') > __WEBPACK_IMPORTED_MODULE_7_moment___default()() || date.isBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()().subtract(60, 'day'));
        }
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'filter-log-copy' },
        ' at'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select_plus__["b" /* default */], {
        className: 'event-log-selector hour-select',
        value: _this2.state.startTime,
        onChange: _this2.onStartTimeChange,
        options: _this2.createHourOptions(),
        clearable: false
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
        { type: 'tertiary', onClick: _this2.openExportModal },
        'Export CSV'
      )
    );
  };

  this.renderLoadedState = function () {
    var events = _this2.filterEvents(_this2.props.events);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Table"], {
        className: 'event-table',
        columns: _this2.createTableColumns(),
        data: events.map(_this2.createTableRow)
      }),
      events && !events.size && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'event-table-empty-state' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8_images_svg_magnifying_glass_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          ' Hmmm... there\u2019s nothing here. Try expanding your timeframe to see data in this log! '
        )
      ),
      _this2.props.paginationQuery && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["AsyncButton"],
        {
          delay: 1,
          className: 'get-paginated-events-button',
          type: 'secondary',
          promise: _this2.getMoreData
        },
        'Load More Events'
      )
    );
  };
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    events: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_selectors__["i" /* getEvents */])(state, props.sourceId),
    paginationQuery: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_selectors__["k" /* getPaginationQuery */])(state, props.sourceId),
    isLoaded: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_selectors__["m" /* isLoaded */])(state, props.sourceId),
    csvRequestSent: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_selectors__["f" /* csvRequestSent */])(state, props.sourceId)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchIntegrationEvents: __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_actions__["h" /* fetchIntegrationEvents */],
      destroyIntegrationEvents: __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_actions__["g" /* destroyIntegrationEvents */],
      fetchPaginatedIntegrationEvents: __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_actions__["t" /* fetchPaginatedIntegrationEvents */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps, null)(EventTable));

/***/ }),

/***/ "BcoS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 47 9\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-1039.000000, -519.000000)\" fill-rule=\"nonzero\" fill=\"#7F9CAB\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"main-logo-madkudu\" transform=\"translate(170.000000, 131.000000)\"><path d=\"M2.20110208,0.946768099 C2.33057857,1.19771867 2.47983617,1.50760458 2.64887488,1.87642589 C2.81791404,2.24524714 2.99414596,2.6444867 3.1775711,3.07414451 C3.36099624,3.50380227 3.54262329,3.94296579 3.72245182,4.39163498 C3.90228035,4.84030417 4.07131906,5.26235742 4.2295684,5.65779466 C4.38781729,5.26235742 4.55685645,4.84030417 4.73668498,4.39163498 C4.91651351,3.94296579 5.09814057,3.50380227 5.28156571,3.07414451 C5.46499084,2.6444867 5.64122277,2.24524714 5.81026148,1.87642589 C5.97930063,1.50760458 6.12855823,1.19771867 6.25803472,0.946768099 L7.79017428,0.946768099 C7.86210596,1.47148289 7.92864251,2.05893535 7.98978392,2.70912548 C8.05092578,3.35931561 8.10487443,4.03612166 8.15162987,4.73954374 C8.1983853,5.44296578 8.24154413,6.14828897 8.28110635,6.85551328 C8.32066858,7.56273763 8.35483611,8.22813686 8.38360897,8.85171101 L6.74357211,8.85171101 C6.72199247,8.08365015 6.69322007,7.24714828 6.65725445,6.34220531 C6.62128839,5.43726234 6.56734019,4.52471482 6.49540851,3.60456274 C6.36593202,3.92395437 6.22206911,4.27756652 6.06381977,4.66539925 C5.90557087,5.05323193 5.74912006,5.44106461 5.59446733,5.82889734 C5.4398146,6.21673003 5.290557,6.58745244 5.14669408,6.94106465 C5.00283117,7.2946768 4.8805479,7.59695816 4.77984381,7.84790873 L3.60376471,7.84790873 C3.50306062,7.59695816 3.38077735,7.2946768 3.23691443,6.94106465 C3.09305152,6.58745244 2.94379392,6.21673003 2.78914119,5.82889734 C2.6344889,5.44106461 2.47803809,5.05323193 2.31978875,4.66539925 C2.16153941,4.27756652 2.0176765,3.92395437 1.88820001,3.60456274 C1.81626878,4.52471482 1.76232013,5.43726234 1.72635451,6.34220531 C1.69038845,7.24714828 1.66161605,8.08365015 1.64003686,8.85171101 L7.46069873e-14,8.85171101 C0.0287724034,8.22813686 0.0629399406,7.56273763 0.102502163,6.85551328 C0.142064386,6.14828897 0.185223215,5.44296578 0.231978651,4.73954374 C0.278734087,4.03612166 0.332682735,3.35931561 0.393824597,2.70912548 C0.454966458,2.05893535 0.521503006,1.47148289 0.593434238,0.946768099 L2.20110208,0.946768099 Z M11.9550047,7.66539922 C12.1132536,7.66539922 12.2643097,7.66159694 12.4081726,7.65399239 C12.5520355,7.64638784 12.6671256,7.63498097 12.7534437,7.61977186 L12.7534437,6.33079848 C12.6887052,6.31558933 12.5915977,6.30038023 12.4621212,6.28517108 C12.3326448,6.26996198 12.2139576,6.26235743 12.1060603,6.26235743 C11.9550047,6.26235743 11.8129398,6.27186309 11.6798667,6.29087452 C11.5467936,6.30988594 11.4299051,6.34600759 11.329201,6.39923954 C11.2284969,6.45247149 11.1493724,6.52471483 11.0918272,6.61596958 C11.0342819,6.70722434 11.0055095,6.82129275 11.0055095,6.95817491 C11.0055095,7.22433458 11.0900291,7.40874526 11.2590678,7.51140684 C11.428107,7.61406843 11.6600856,7.66539922 11.9550047,7.66539922 Z M11.8255277,2.69201522 C12.3002753,2.69201522 12.6958984,2.74904945 13.0123967,2.86311786 C13.3288949,2.97718631 13.5824532,3.1406844 13.7730715,3.35361217 C13.9636899,3.56653994 14.0985615,3.82509506 14.1776859,4.12927758 C14.2568104,4.43346006 14.2963726,4.77186311 14.2963726,5.14448669 L14.2963726,8.68060833 C14.066192,8.73384028 13.7460972,8.79657795 13.3360881,8.86882128 C12.926079,8.94106461 12.4297518,8.9771863 11.8471074,8.9771863 C11.4802571,8.9771863 11.1475744,8.94296577 10.8490587,8.87452471 C10.5505431,8.80608361 10.2933882,8.69391632 10.077594,8.53802278 C9.86179988,8.38212924 9.69635732,8.17870719 9.58126726,7.92775666 C9.46617675,7.67680609 9.4086315,7.36882129 9.4086315,7.00380227 C9.4086315,6.65399239 9.47516849,6.35741446 9.60824159,6.11406844 C9.74131468,5.87072242 9.91934468,5.67680608 10.1423325,5.53231937 C10.3653198,5.38783271 10.6206762,5.28326996 10.908402,5.21863118 C11.1961279,5.1539924 11.4946435,5.12167299 11.8039485,5.12167299 C12.0125495,5.12167299 12.1977731,5.1311787 12.3596186,5.15019013 C12.5214646,5.1692015 12.6527396,5.19391637 12.7534437,5.22433462 L12.7534437,5.06463876 C12.7534437,4.77566539 12.6707222,4.54372624 12.5052801,4.36882128 C12.3398375,4.19391636 12.0521121,4.10646388 11.6421026,4.10646388 C11.3687632,4.10646388 11.0990204,4.12737642 10.8328742,4.16920155 C10.566728,4.21102663 10.3365474,4.26996197 10.1423325,4.34600762 L9.93732772,2.97718631 C10.0308386,2.94676806 10.1477272,2.9144487 10.2879935,2.88022817 C10.4282598,2.84600759 10.581114,2.81558934 10.7465565,2.78897341 C10.9119987,2.76235743 11.0864325,2.73954373 11.2698576,2.72053231 C11.4532828,2.70152093 11.638506,2.69201522 11.8255277,2.69201522 L11.8255277,2.69201522 Z M17.1232784,5.80608364 C17.1232784,6.33079848 17.2347718,6.75285169 17.4577592,7.07224332 C17.680747,7.39163495 18.0116312,7.55133081 18.4504132,7.55133081 C18.5942761,7.55133081 18.7273492,7.54562737 18.8496325,7.5342205 C18.9719162,7.52281367 19.0726203,7.50950568 19.1517447,7.49429658 L19.1517447,4.40304181 C19.0510406,4.33460075 18.9197656,4.27756652 18.7579201,4.23193917 C18.5960742,4.18631181 18.4324301,4.16349811 18.266988,4.16349811 C17.5045146,4.16349811 17.1232784,4.71102661 17.1232784,5.80608364 L17.1232784,5.80608364 Z M20.7594121,8.65779467 C20.6155492,8.70342203 20.4501071,8.74714827 20.2630853,8.78897335 C20.0760636,8.83079847 19.8800506,8.86692012 19.6750458,8.89733837 C19.4700415,8.92775662 19.2614401,8.95247148 19.0492425,8.97148286 C18.8370446,8.99049429 18.6338383,9 18.4396234,9 C17.972069,9 17.5548667,8.92775662 17.1880164,8.78326996 C16.8211661,8.63878325 16.5118611,8.43155892 16.2601009,8.16159692 C16.0083411,7.89163497 15.8159243,7.56463875 15.6828512,7.18060834 C15.5497781,6.79657794 15.4832415,6.36501901 15.4832415,5.88593157 C15.4832415,5.39923954 15.5407868,4.96007606 15.6558768,4.56844106 C15.7709674,4.1768061 15.9364095,3.84410648 16.1522036,3.57034221 C16.3679982,3.29657794 16.6323463,3.0874525 16.9452479,2.94296579 C17.2581496,2.79847908 17.6160085,2.72623574 18.0188244,2.72623574 C18.2418118,2.72623574 18.4414219,2.74904945 18.6176538,2.7946768 C18.7938857,2.8403042 18.9719162,2.90494298 19.1517447,2.98859314 L19.1517447,0.273764271 L20.7594121,-1.77635684e-15 L20.7594121,8.65779467 Z M26.7908633,8.85171101 C26.6398072,8.59315589 26.4617767,8.31368818 26.2567724,8.01330798 C26.0517676,7.71292774 25.8287803,7.41254753 25.5878099,7.11216729 C25.3468395,6.81178709 25.0968778,6.52281366 24.8379248,6.24524716 C24.5789714,5.96768062 24.3200184,5.72243344 24.061065,5.50950572 L24.061065,8.85171101 L22.3778693,8.85171101 L22.3778693,0.946768099 L24.061065,0.946768099 L24.061065,3.93536124 C24.499847,3.4486692 24.940427,2.94106463 25.3828051,2.41254756 C25.8251837,1.88403044 26.2369908,1.39543729 26.6182275,0.946768099 L28.6143249,0.946768099 C28.1036117,1.58555135 27.5911004,2.2015209 27.0767906,2.7946768 C26.5624808,3.3878327 26.0211967,3.98479087 25.4529383,4.58555132 C26.0499695,5.11026616 26.6272193,5.73384031 27.1846879,6.45627377 C27.7421565,7.17870723 28.2762474,7.97718629 28.7869606,8.85171101 L26.7908633,8.85171101 Z M34.1278697,8.6463878 C33.8545303,8.730038 33.502066,8.80798477 33.0704772,8.8802281 C32.6388889,8.95247148 32.185721,8.98859313 31.7109734,8.98859313 C31.2290326,8.98859313 30.8280148,8.92015207 30.50792,8.78326996 C30.1878252,8.6463878 29.9342669,8.45437262 29.7472451,8.20722432 C29.5602234,7.96007603 29.4271503,7.66539922 29.3480258,7.32319389 C29.2689009,6.98098856 29.2293387,6.60456271 29.2293387,6.19391633 L29.2293387,2.85171103 L30.8370066,2.85171103 L30.8370066,5.98859316 C30.8370066,6.53612165 30.9053412,6.93155893 31.0420109,7.17490495 C31.1786806,7.41825092 31.4340374,7.53992393 31.8080809,7.53992393 C31.923171,7.53992393 32.0454547,7.5342205 32.1749312,7.52281367 C32.3044077,7.51140684 32.4194977,7.49809885 32.5202018,7.4828897 L32.5202018,2.85171103 L34.1278697,2.85171103 L34.1278697,8.6463878 Z M37.0087236,5.80608364 C37.0087236,6.33079848 37.1202171,6.75285169 37.3432049,7.07224332 C37.5661923,7.39163495 37.8970769,7.55133081 38.3358584,7.55133081 C38.4797213,7.55133081 38.6127944,7.54562737 38.7350782,7.5342205 C38.8573614,7.52281367 38.9580655,7.50950568 39.03719,7.49429658 L39.03719,4.40304181 C38.9364859,4.33460075 38.8052113,4.27756652 38.6433654,4.23193917 C38.4815199,4.18631181 38.3178758,4.16349811 38.1524333,4.16349811 C37.3899603,4.16349811 37.0087236,4.71102661 37.0087236,5.80608364 L37.0087236,5.80608364 Z M40.6448578,8.65779467 C40.5009949,8.70342203 40.3355523,8.74714827 40.1485306,8.78897335 C39.9615088,8.83079847 39.7654958,8.86692012 39.560491,8.89733837 C39.3554867,8.92775662 39.1468853,8.95247148 38.9346878,8.97148286 C38.7224898,8.99049429 38.5192836,9 38.3250686,9 C37.8575147,9 37.4403119,8.92775662 37.0734617,8.78326996 C36.7066114,8.63878325 36.3973064,8.43155892 36.1455462,8.16159692 C35.8937864,7.89163497 35.7013695,7.56463875 35.5682964,7.18060834 C35.4352233,6.79657794 35.3686868,6.36501901 35.3686868,5.88593157 C35.3686868,5.39923954 35.426232,4.96007606 35.5413221,4.56844106 C35.6564126,4.1768061 35.8218547,3.84410648 36.0376493,3.57034221 C36.2534435,3.29657794 36.5177916,3.0874525 36.8306932,2.94296579 C37.1435948,2.79847908 37.5014538,2.72623574 37.9042701,2.72623574 C38.1272575,2.72623574 38.3268671,2.74904945 38.5030991,2.7946768 C38.679331,2.8403042 38.8573614,2.90494298 39.03719,2.98859314 L39.03719,0.273764271 L40.6448578,-1.77635684e-15 L40.6448578,8.65779467 Z M47,8.6463878 C46.7266606,8.730038 46.3741963,8.80798477 45.942608,8.8802281 C45.5110193,8.95247148 45.0578513,8.98859313 44.5831038,8.98859313 C44.101163,8.98859313 43.7001452,8.92015207 43.3800503,8.78326996 C43.0599555,8.6463878 42.8063972,8.45437262 42.6193755,8.20722432 C42.4323537,7.96007603 42.2992806,7.66539922 42.2201562,7.32319389 C42.1410313,6.98098856 42.1014691,6.60456271 42.1014691,6.19391633 L42.1014691,2.85171103 L43.7091369,2.85171103 L43.7091369,5.98859316 C43.7091369,6.53612165 43.7774715,6.93155893 43.9141412,7.17490495 C44.0508109,7.41825092 44.3061678,7.53992393 44.6802112,7.53992393 C44.7953013,7.53992393 44.917585,7.5342205 45.0470615,7.52281367 C45.176538,7.51140684 45.2916285,7.49809885 45.3923322,7.4828897 L45.3923322,2.85171103 L47,2.85171103 L47,8.6463878 Z\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "Bdop":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Avatar_index__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("rVLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var CurrentTeamMembers = function CurrentTeamMembers(_ref) {
  var usersAndProperties = _ref.usersAndProperties,
      sendExistingUsersInvitationsViaEmail = _ref.sendExistingUsersInvitationsViaEmail,
      sendInvitationsViaEmail = _ref.sendInvitationsViaEmail;
  return React.createElement(
    "div",
    { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.CurrentTeamMembers },
    React.createElement(
      "div",
      { className: "dsg-Title container-header" },
      "Send the Drift extension to your teammates "
    ),
    React.createElement(
      "div",
      { className: "team-members-table" },
      React.createElement(
        "div",
        { className: "team-members-table-header" },
        "Team Member"
      ),
      React.createElement(
        "div",
        { className: "team-members-table-body" },
        usersAndProperties.filter(function (_ref2) {
          var installed = _ref2.installed;
          return !installed;
        }).map(function (_ref3) {
          var user = _ref3.user,
              invited = _ref3.invited;
          return React.createElement(
            "div",
            { className: "team-members-table-row", key: user.id },
            React.createElement(
              "div",
              { className: "team-members-table-row-avatar" },
              React.createElement(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Avatar_index__["a" /* default */], { className: "existing-extension-avatar", user: user })
            ),
            React.createElement(
              "div",
              { className: "flex-column" },
              user.name && React.createElement(
                "div",
                { className: "dsg-Title name" },
                user.name
              ),
              React.createElement(
                "div",
                { className: "dsg-Title email" },
                user.email
              )
            ),
            React.createElement(
              "button",
              {
                className: "team-members-table-row-send drift-button medium",
                onClick: function onClick() {
                  user.status === 'INVITED' ? sendInvitationsViaEmail(user.email) : sendExistingUsersInvitationsViaEmail(user.id);
                }
              },
              invited ? 'Resend Extension' : 'Send Invitation'
            )
          );
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CurrentTeamMembers);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "BeI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__("M+Z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CampaignIconLink__ = __webpack_require__("nLH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__("kj23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("7hyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("i4Ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










function getScoreClass(score) {
  if (score > 8) return 'promoter';
  if (score <= 6) return 'detractor';
  return 'passive';
}

var EventData = function (_Component) {
  _inherits(EventData, _Component);

  function EventData() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventData);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventData.__proto__ || Object.getPrototypeOf(EventData)).call.apply(_ref, [this].concat(args))), _this), _this.getAttributeSource = function () {
      var event = _this.props.event;

      if (event.eventType === 'PROPERTY') {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_this.props, 'event.body', {});
      }
      return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(_this.props, 'event.body.attributes', {});
    }, _this.filterAttributes = function () {
      var attributes = _this.getAttributeSource();
      return __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(attributes, function (attrs, attr, key) {
        if (!__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* IGNORED_ATTRIBUTES */].includes(key)) {
          attrs[key] = attr;
        }
        return attrs;
      }, {});
    }, _this.renderNPSResponse = function () {
      var _this$props$event$bod = _this.props.event.body,
          textResponse = _this$props$event$bod.textResponse,
          numericResponse = _this$props$event$bod.numericResponse;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'color-navy-dark flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'dsg-medium-weight ' + __WEBPACK_IMPORTED_MODULE_7__style_styl___default.a.NPSEvent + ' ' + getScoreClass(numericResponse) },
          numericResponse
        ),
        textResponse ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body' },
          '\u201C',
          textResponse,
          '\u201D'
        ) : null
      );
    }, _this.renderNote = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'dsg-Body ' + __WEBPACK_IMPORTED_MODULE_7__style_styl___default.a.NoteBody,
        dangerouslySetInnerHTML: { __html: _this.props.event.body.note.body }
      });
    }, _this.renderAttributes = function () {
      var allowedAttributes = _this.filterAttributes();
      if (_.isEmpty(allowedAttributes)) return;
      var attrList = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(allowedAttributes, _this.renderAttr);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        attrList
      );
    }, _this.renderCode = function (val) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'code',
        null,
        JSON.stringify(val)
      );
    }, _this.renderAttr = function (val, key) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        { key: key },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'attributeKey' },
          key
        ),
        ':',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'attributeValue' },
          typeof val === 'string' ? val : _this.renderCode(val)
        )
      );
    }, _this.renderCampaign = function () {
      var _this$props = _this.props,
          author = _this$props.author,
          campaign = _this$props.campaign;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* default */])(author, _this.props.endUser, _this.props.event.createdAt),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CampaignIconLink__["a" /* default */], { campaign: campaign })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventData, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isNote = _props.isNote,
          campaign = _props.campaign;

      var numericResponse = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(this.props, 'event.body.numericResponse');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__style_styl___default.a.TimelineAttributes },
        isNote && this.renderNote(),
        campaign && this.renderCampaign(),
        numericResponse && this.renderNPSResponse(),
        this.renderAttributes()
      );
    }
  }]);

  return EventData;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EventData);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "BmH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_single_routing_svg__ = __webpack_require__("0RUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_single_routing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_single_routing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_global_routing_svg__ = __webpack_require__("o59j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_global_routing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_global_routing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_group_routing_svg__ = __webpack_require__("GirZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_group_routing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_group_routing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_no_routing_svg__ = __webpack_require__("1Sae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_no_routing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_no_routing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("y5US");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);















var GoalRoutingModal = function GoalRoutingModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      onCancelClick = _ref.onCancelClick,
      onSingleRouteUserSelect = _ref.onSingleRouteUserSelect,
      onGroupRouteUserSelect = _ref.onGroupRouteUserSelect,
      handleSelectSingle = _ref.handleSelectSingle,
      handleSelectGlobal = _ref.handleSelectGlobal,
      handleSelectGroup = _ref.handleSelectGroup,
      handleSelectNoRouting = _ref.handleSelectNoRouting,
      isSingleRoutingSelected = _ref.isSingleRoutingSelected,
      isGroupRoutingSelected = _ref.isGroupRoutingSelected,
      isGlobalRoutingSelected = _ref.isGlobalRoutingSelected,
      isNoRoutingSelected = _ref.isNoRoutingSelected,
      resetRoutingView = _ref.resetRoutingView,
      viewSingleRoutingOptions = _ref.viewSingleRoutingOptions,
      viewGroupRoutingOptions = _ref.viewGroupRoutingOptions,
      viewGlobalRoutingOptions = _ref.viewGlobalRoutingOptions,
      classificationDetails = _ref.classificationDetails,
      orgUsersOptions = _ref.orgUsersOptions,
      selectedGoalRoutingOption = _ref.selectedGoalRoutingOption,
      selectedRoutingUsers = _ref.selectedRoutingUsers,
      firstUser = _ref.firstUser;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__PlaybookModal__["a" /* default */],
    {
      title: 'Goal Routing',
      onCancelClick: onCancelClick,
      cancelLabel: 'Cancel',
      onCloseClick: onCloseClick,
      closeLabel: 'Update',
      showSaveStatus: false,
      description: _.get(classificationDetails, 'label', '...'),
      contentClassName: __WEBPACK_IMPORTED_MODULE_10__style_styl___default.a.GoalRoutingModalContent,
      headerClassName: __WEBPACK_IMPORTED_MODULE_10__style_styl___default.a.GoalRoutingModalHeader
    },
    (viewSingleRoutingOptions || viewGlobalRoutingOptions || viewGroupRoutingOptions) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'return-to-routing-link', onClick: resetRoutingView },
      '< Back to Routing'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'goal-routing-wrapper drift-form flex-column' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'goal-routing-cta' },
        'How would you like to route conversations?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !viewGroupRoutingOptions && !viewGlobalRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: isSingleRoutingSelected }, 'goal-routing-choice', 'flex'),
            onClick: handleSelectSingle
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'action-icon', src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_single_routing_svg___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'To a single teammate'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Select a single teammate to be added to and notified of each conversation once this goal is met.'
            )
          )
        ),
        !viewSingleRoutingOptions && !viewGlobalRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: isGroupRoutingSelected }, 'goal-routing-choice', 'flex'),
            onClick: handleSelectGroup
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'action-icon', src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_group_routing_svg___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Round robin within a group'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Select a group of teammates to alternate between when adding participants to a conversation.'
            )
          )
        ),
        !viewSingleRoutingOptions && !viewGroupRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: isGlobalRoutingSelected }, 'goal-routing-choice', 'flex'),
            onClick: handleSelectGlobal
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'action-icon', src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_images_svg_global_routing_svg___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Based on Conversation routing rules'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Determine who is added to a conversation by referencing your Conversation routing rules.'
            )
          )
        ),
        !viewGlobalRoutingOptions && !viewSingleRoutingOptions && !viewGroupRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: isNoRoutingSelected }, 'goal-routing-choice', 'flex'),
            onClick: handleSelectNoRouting
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'action-icon', src: __WEBPACK_IMPORTED_MODULE_9__svg_inline_images_svg_no_routing_svg___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-column' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Do not route this conversation'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Don\u2019t add anyone from my team to this conversation.'
            )
          )
        ),
        viewSingleRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'routing-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'goal-routing-cta' },
            'Who would you like to route to?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_UISelect__["b" /* default */], {
            className: 'skip-select',
            options: orgUsersOptions,
            value: selectedGoalRoutingOption.userId || 0,
            onChange: onSingleRouteUserSelect,
            filterOption: function filterOption(option, filterText) {
              return Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(option.user).toLowerCase().includes(filterText);
            }
          })
        ),
        viewGroupRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'routing-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'goal-routing-cta' },
            'Who would you like to route to?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_UISelect__["b" /* default */], {
            multi: true,
            className: 'skip-select',
            options: orgUsersOptions,
            value: selectedRoutingUsers || [firstUser.id],
            onChange: onGroupRouteUserSelect,
            filterOption: function filterOption(option, filterText) {
              return Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(option.user).toLowerCase().includes(filterText);
            }
          })
        ),
        viewGlobalRoutingOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'routing-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'goal-routing-cta' },
            'Here are your current routing rules:'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            '[regions, etc. here!]'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GoalRoutingModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Bo3U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bo47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__ = __webpack_require__("xIgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var InboxActions = Marty.createActionCreators({
  updateInbox: function updateInbox(inboxId, params) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].INBOX_UPDATE, inboxId, params);
  },
  createInbox: function createInbox(params) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].INBOX_CREATE, params);
  },
  checkIfInboxExistsForEmail: function checkIfInboxExistsForEmail(email) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_validator__["isEmail"])(email)) {
      return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL, email);
    }
  },
  createWhiteLabelConfiguration: function createWhiteLabelConfiguration(domain) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_CREATE, domain);
  },
  validateWhiteLabelConfiguration: function validateWhiteLabelConfiguration(domain) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE, domain);
  },
  archiveInbox: function archiveInbox(inboxId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE, inboxId);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (InboxActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "BqSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['$0-$1M', '$1M-$10M', '$10M-$50M', '$50M-$100M', '$100M-$250M', '$250M-$500M', '$500M-$1B', '$1B-$10B', '$10B+']);

/***/ }),

/***/ "Bqo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return immutableSelector; });
/* harmony export (immutable) */ __webpack_exports__["a"] = applySelectors;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var immutableSelector = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelectorCreator"])(__WEBPACK_IMPORTED_MODULE_0_reselect__["defaultMemoize"], __WEBPACK_IMPORTED_MODULE_1_immutable__["is"]);

function applySelectors(selectors, state) {
  var appliedSelectors = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(selectors)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var selector = selectors[key];
      appliedSelectors[key] = selector(state);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return appliedSelectors;
}

/***/ }),

/***/ "C2XB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("wpQG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");





var fetchCard = function fetchCard(url) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$key = _ref.key,
      key = _ref$key === undefined ? __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["z" /* IFRAMELY_KEY */] : _ref$key,
      _ref$omitScript = _ref.omitScript,
      omitScript = _ref$omitScript === undefined ? true : _ref$omitScript,
      _ref$iframe = _ref.iframe,
      iframe = _ref$iframe === undefined ? true : _ref$iframe;

  var params = {
    key: key,
    url: url,
    omit_script: omitScript ? 1 : 0,
    iframe: iframe ? 1 : 0
  };
  return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].ajax({
    url: '//iframe.ly/api/iframely?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])(params),
    method: 'GET',
    crossDomain: true,
    responseType: 'json'
  }).retryWithBackoff().map(function (data) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__models__["c" /* makeCard */])(data.response);
  });
};

/***/ }),

/***/ "C8Tf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCVr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CCiW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLinkedinIFrameUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIntegrationConnected; });
/* unused harmony export getAllIntegrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_store__ = __webpack_require__("Tvnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");





var getAllIntegrations = function getAllIntegrations() {
  return __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['integrations', 'connections'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
};

var isIntegrationConnected = function isIntegrationConnected(integration) {
  var integrationStatuses = __WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState().getIn(['integrations', 'connections'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
  return !!integrationStatuses[integration];
};

var getLinkedinIFrameUrl = function getLinkedinIFrameUrl(endUser, name, website) {
  var profile = void 0;
  endUser = endUser || {};
  if (endUser) {
    profile = 'lead';
  } else {
    profile = 'account';
  }

  var email = _.get(endUser, 'email', '');
  var firstName = _.get(endUser, 'firstName', '');
  var lastName = _.get(endUser, 'lastName', '');

  var orgId = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__["orgId"])(__WEBPACK_IMPORTED_MODULE_0_containers_store__["a" /* default */].getState());

  return 'https://www.linkedin.com/sales/widget/profile-matching?\n  apiKey=' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["A" /* LINKEDIN_KEY */] + '&\n  profile=' + profile + '&\n  firstName=' + firstName + '&\n  lastName=' + lastName + '&\n  email=' + email + '&\n  companyName=' + (name || '') + '&\n  companyWebsite=' + (website || '') + '&\n  crmRecordId=ddccbbAA&\n  crmOrgId=' + orgId + '&\n  crmSourceType=PARTNER&\n  modules=TopCard2,RelatedLeads&\n  version=2.0.0&\n  isInlineMode=true';
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "CGW9":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.352 7.613H5.857a.621.621 0 0 1-.606-.633c0-.35.246-.578.58-.578h8.523c.334 0 .605.228.605.578a.62.62 0 0 1-.607.633zm0-5.068H5.857a.62.62 0 0 1-.606-.633c0-.351.246-.601.58-.601h8.523c.334 0 .605.25.605.6a.62.62 0 0 1-.607.634zM2.532 13.61c-.432.334-1.047.4-1.462.4-.198 0-.35-.016-.416-.024-.41-.048-.699-.38-.644-.743.055-.361.428-.617.838-.57.13.014.283.014.415.002l-.082-.006c-.04.002-.072.001-.092.001-.405-.007-.73-.297-.734-.655-.005-.358.314-.653.72-.668l.089-.001c.017 0 .034-.002.052-.004a2.25 2.25 0 0 0-.385 0c-.405.036-.78-.228-.822-.59-.043-.363.252-.688.663-.727.203-.02 1.247-.093 1.875.405a1.136 1.136 0 0 1 .242 1.575c.141.193.214.42.214.665 0 .376-.163.702-.47.94zm.471-5.268c0 .369-.336.667-.75.667h-1.5c-.303 0-.576-.163-.692-.412a.611.611 0 0 1 .162-.725C.847 7.317 1.447 6.6 1.502 6.347a11 11 0 0 0-.477-.004l-.272.001c-.414 0-.75-.299-.75-.666 0-.368.336-.667.75-.667h.263c.674-.003 1.21-.007 1.607.344.34.3.38.709.38.989 0 .413-.283.898-.633 1.341.358.05.633.326.633.658zM1.328 4.01a.671.671 0 0 1-.676-.667V2.01a.676.676 0 0 1-.442-.186.66.66 0 0 1-.018-.943l.65-.666A.68.68 0 0 1 1.58.058a.667.667 0 0 1 .423.62v2.665a.671.671 0 0 1-.675.667zm4.504 7.483h8.522c.334 0 .605.205.605.555 0 .35-.27.717-.605.717H5.832c-.335 0-.581-.367-.581-.717s.246-.555.58-.555z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "CIRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("kWes");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);







var AttributeCreatePendingLabel = function AttributeCreatePendingLabel(_ref) {
  var selectedFieldAttribute = _ref.selectedFieldAttribute;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'span',
      null,
      selectedFieldAttribute
    ),
    React.createElement(
      'span',
      { className: 'playbook-question-advanced-attribute-create-loading' },
      '(creating ',
      React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_LoadingDots__["a" /* default */], null),
      ')'
    )
  );
};

var QuestionAdvancedModal = function QuestionAdvancedModal(_ref2) {
  var onCloseClick = _ref2.onCloseClick,
      FieldAttributes = _ref2.FieldAttributes,
      selectedFieldAttribute = _ref2.selectedFieldAttribute,
      onSelectFieldAttribute = _ref2.onSelectFieldAttribute,
      onNewOptionClick = _ref2.onNewOptionClick,
      isSelectedAttributeCreatePending = _ref2.isSelectedAttributeCreatePending,
      buttonOnlyResponses = _ref2.buttonOnlyResponses,
      onToggleButtonOnlyResponse = _ref2.onToggleButtonOnlyResponse,
      questionHasKeywordAnswers = _ref2.questionHasKeywordAnswers,
      numKeywordsInQuestion = _ref2.numKeywordsInQuestion,
      confirmKeywordsDelete = _ref2.confirmKeywordsDelete,
      setConfirmKeywordsDelete = _ref2.setConfirmKeywordsDelete,
      onDeleteAllKeywordResponses = _ref2.onDeleteAllKeywordResponses,
      onFirstDeleteKeywordClick = _ref2.onFirstDeleteKeywordClick;

  var userPropertiesOptions = FieldAttributes.filter(function (attr) {
    return attr.value[0] !== '_' || attr.value === selectedFieldAttribute;
  });
  !!selectedFieldAttribute && // show custom tag if recently created...
  userPropertiesOptions.unshift({
    label: isSelectedAttributeCreatePending ? React.createElement(AttributeCreatePendingLabel, { selectedFieldAttribute: selectedFieldAttribute }) : selectedFieldAttribute,
    value: selectedFieldAttribute });
  userPropertiesOptions.unshift({ label: 'No Mapping', value: undefined });
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__PlaybookModal__["a" /* default */],
    {
      onCloseClick: onCloseClick,
      title: 'Advanced Settings',
      hideDescription: true,
      contentClassName: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.QuestionAdvancedModal
    },
    React.createElement(
      'div',
      { className: 'playbook-question-advanced-modal-heading' },
      React.createElement(
        'div',
        null,
        React.createElement(
          'strong',
          null,
          'Map Customer Response to Drift Attribute (Optional)'
        ),
        React.createElement(
          'p',
          null,
          'Drift can add this response to a new or existing attribute on the User\u2019s Profile. This is helpful for creating segments, and syncing to your integrations.',
          ' ',
          React.createElement(
            'a',
            {
              className: 'link',
              href: 'https://help.drift.com/playbooks/attribute-mapping-in-playbooks',
              target: '_blank'
            },
            'Learn More.'
          )
        ),
        React.createElement(
          'p',
          { className: 'helptext' },
          'The property will be converted into lowercase and spaces replaced with underscores. Like "',
          React.createElement(
            'code',
            null,
            'zip_code'
          ),
          '".'
        )
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_UISelect__["a" /* Creatable */], {
        clearable: true,
        className: 'attribute-select',
        options: userPropertiesOptions,
        value: selectedFieldAttribute,
        onChange: onSelectFieldAttribute,
        onNewOptionClick: onNewOptionClick
      })
    ),
    React.createElement(
      'div',
      { className: 'playbook-question-advanced-modal-buttons-only-section' },
      React.createElement(
        'div',
        { className: 'playbook-question-advanced-button-label' },
        React.createElement(
          'strong',
          null,
          'Limit Customer Response To Buttons Only'
        ),
        questionHasKeywordAnswers && React.createElement(
          'div',
          null,
          React.createElement(
            'p',
            { className: 'playbook-question-advanced-button-disabled' },
            'Remove keyword answers to enable'
          ),
          !confirmKeywordsDelete ? React.createElement(
            'p',
            { className: 'playbook-question-advanced-button-disabled' },
            React.createElement(
              'span',
              { className: 'link', onClick: onFirstDeleteKeywordClick },
              'Click here'
            ),
            ' ',
            'to delete all keywords on this question'
          ) : React.createElement(
            'p',
            { className: 'playbook-question-advanced-button-disabled' },
            'Are you sure you want to delete ',
            numKeywordsInQuestion,
            ' keywords?',
            ' ',
            React.createElement(
              'span',
              { className: 'playbook-question-advanced-button-confirm' },
              React.createElement(
                'span',
                { className: 'link', onClick: onDeleteAllKeywordResponses },
                'Yes'
              ),
              '|',
              React.createElement(
                'span',
                { className: 'link', onClick: function onClick() {
                    return setConfirmKeywordsDelete(false);
                  } },
                'No'
              )
            )
          )
        ),
        React.createElement(
          'p',
          null,
          'When this feature is on, the text input on the chat widget will be disabled and end users will be encouraged to select one of the available button responses from the bot'
        )
      ),
      React.createElement(
        'div',
        { className: 'playbook-question-advanced-button-input' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], {
          disabled: questionHasKeywordAnswers,
          onChange: onToggleButtonOnlyResponse,
          className: 'playbook-toggle',
          checked: buttonOnlyResponses || false,
          icons: {
            checked: React.createElement(
              'span',
              null,
              'On'
            ),
            unchecked: React.createElement(
              'span',
              null,
              'Off'
            )
          }
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (QuestionAdvancedModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "CKnD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TokenModalSteps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PropertyNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorTokenModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TinyEditorModal__ = __webpack_require__("+qeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_social_splash_svg__ = __webpack_require__("yOq8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_social_splash_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_social_splash_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("/dss");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }












// todo: move to constants
var TokenModalSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm'
};

var PropertyNamespaces = {
  USER: 'user',
  CLEARBIT: 'clearbit',
  ACCOUNT: 'account',
  SENDER: 'sender'
};

var TokenModalSelect = function TokenModalSelect(_ref) {
  var userProperties = _ref.userProperties,
      clearbitProperties = _ref.clearbitProperties,
      senderProperties = _ref.senderProperties,
      search = _ref.search,
      onSearchChange = _ref.onSearchChange,
      onPropertySelect = _ref.onPropertySelect,
      selectedTab = _ref.selectedTab,
      onClearbitTabClick = _ref.onClearbitTabClick,
      onUserTabClick = _ref.onUserTabClick,
      noPropertiesShown = _ref.noPropertiesShown,
      hideClearbitTab = _ref.hideClearbitTab,
      hasClearbitEnabled = _ref.hasClearbitEnabled;
  return React.createElement(
    'div',
    { className: 'modal-selector-container' },
    React.createElement(
      'div',
      { className: 'modal-selector-section modal-selector-section-top drift-form' },
      React.createElement('input', {
        className: 'modal-selector-search-input',
        type: 'text',
        value: search,
        onChange: onSearchChange,
        placeholder: 'Search'
      })
    ),
    !hideClearbitTab && hasClearbitEnabled && React.createElement(
      'div',
      { className: 'modal-selector-tab-container' },
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('modal-selector-tab-option', { active: selectedTab === PropertyNamespaces.USER }), onClick: onUserTabClick },
        'User'
      ),
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('modal-selector-tab-option', { active: selectedTab === PropertyNamespaces.CLEARBIT }), onClick: onClearbitTabClick },
        'Clearbit'
      )
    ),
    React.createElement(
      'div',
      { className: 'tiny-token-modal-options' },
      selectedTab === PropertyNamespaces.USER && userProperties.map(function (_ref2) {
        var displayName = _ref2.displayName,
            name = _ref2.name,
            namespaceOverride = _ref2.namespaceOverride;
        return React.createElement(
          'div',
          { key: name, className: 'tiny-token-modal-option', onClick: function onClick() {
              return onPropertySelect(name, namespaceOverride || PropertyNamespaces.USER);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { className: 'tiny-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'tiny-token-modal-option-name' },
            displayName
          )
        );
      }),
      selectedTab === PropertyNamespaces.CLEARBIT && clearbitProperties.map(function (_ref3) {
        var displayName = _ref3.displayName,
            name = _ref3.name;
        return React.createElement(
          'div',
          { key: name, className: 'tiny-token-modal-option', onClick: function onClick() {
              return onPropertySelect(name, PropertyNamespaces.CLEARBIT);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { className: 'tiny-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'tiny-token-modal-option-name' },
            displayName
          )
        );
      }),
      selectedTab === PropertyNamespaces.SENDER && senderProperties.map(function (_ref4) {
        var displayName = _ref4.displayName,
            name = _ref4.name;
        return React.createElement(
          'div',
          { key: name, className: 'tiny-token-modal-option', onClick: function onClick() {
              return onPropertySelect(name, PropertyNamespaces.SENDER);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { className: 'tiny-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'tiny-token-modal-option-name' },
            displayName
          )
        );
      }),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
        { className: 'modal-selector-empty-options', condition: noPropertiesShown },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_social_splash_svg___default.a }),
        React.createElement(
          'p',
          null,
          'There are no personalization attributes matching your search.'
        )
      )
    )
  );
};

var TokenModalConfirm = function TokenModalConfirm(_ref5) {
  var onDefaultCancel = _ref5.onDefaultCancel,
      onDefaultConfirm = _ref5.onDefaultConfirm,
      selectedProperty = _ref5.selectedProperty,
      onDefaultChange = _ref5.onDefaultChange;
  return React.createElement(
    'div',
    { className: 'modal-selector-container' },
    React.createElement(
      'div',
      { className: 'modal-selector-section modal-selector-section-top' },
      React.createElement(
        'span',
        { className: 'modal-selector-property-preview' },
        selectedProperty.name
      ),
      React.createElement(
        'span',
        { onClick: onDefaultCancel, className: 'link preview-edit-link' },
        'Change'
      )
    ),
    React.createElement(
      'div',
      { className: 'drift-form modal-token-confirm-form' },
      React.createElement(
        'label',
        { className: 'default-form-label' },
        'Default Value:'
      ),
      React.createElement('input', { type: 'text', placeholder: 'enter default...', onChange: onDefaultChange }),
      React.createElement(
        'p',
        { className: 'default-form-extra-details' },
        'Default values display when a contact doesn\u2018t have a value for this variable'
      )
    ),
    React.createElement(
      'div',
      { className: 'modal-selector-section modal-selector-section-bottom' },
      React.createElement(
        'div',
        { onClick: onDefaultConfirm, className: 'modal-selector-section-button drift-button drift-button-primary' },
        'Insert'
      ),
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'modal-selector-section-button drift-button drift-button-secondary' },
        'Cancel'
      )
    )
  );
};

var EditorTokenModal = function EditorTokenModal(_ref6) {
  var modalStep = _ref6.modalStep,
      hideTokenModal = _ref6.hideTokenModal,
      rest = _objectWithoutProperties(_ref6, ['modalStep', 'hideTokenModal']);

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2__TinyEditorModal__["a" /* default */],
    { title: "Insert Personalization", onClose: hideTokenModal },
    React.createElement(
      'div',
      { className: 'playbook-token-modal' },
      React.createElement(
        'div',
        { className: 'tiny-token-modal' },
        modalStep === TokenModalSteps.SELECT && React.createElement(TokenModalSelect, rest),
        modalStep === TokenModalSteps.CONFIRM && React.createElement(TokenModalConfirm, rest)
      )
    )
  );
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "CL+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var ReportAPI = Marty.createStateSource({
  id: 'ReportAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["i" /* CONVERSATION_API */],

  fetchUsersActivity: function fetchUsersActivity() {
    return this.get({
      url: '/reports/users/activity',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ReportAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "CLoi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header---qYa0f","leftColumn":"leftColumn---33H_G","rightColumn":"rightColumn---2KvEk","centerColumn":"centerColumn---1rKiF","RestContent":"RestContent---3TIJR","headerClose":"headerClose---3MMUD","headerTitle":"headerTitle---3R6Ia"};

/***/ }),

/***/ "CM6b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var LiveRevealIcon = function LiveRevealIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "255", height: "211", viewBox: "0 0 255 211", xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "defs",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-25.9%", y: "-25.7%", width: "151.7%", height: "151.4%", filterUnits: "objectBoundingBox",
          id: "a" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "3.182", "in": "SourceGraphic" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "filter",
        { x: "-50.9%", y: "-28.2%", width: "201.8%", height: "156.4%", filterUnits: "objectBoundingBox",
          id: "b" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur", { stdDeviation: "1.44", "in": "SourceGraphic" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "c", d: "M.477.448H6.69V6.69H.477V.448z" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "e", d: "M4.459.05v4.177H.304V.05h4.155z" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M91.176 25.192c-3.072 0-5.52-2.24-5.52-5.52 0-3.28 2.448-5.52 5.52-5.52 1.712 0 2.896.656 3.744 1.584a.85.85 0 0 1 .224.592c0 .48-.4.88-.88.88a.861.861 0 0 1-.672-.304 3.185 3.185 0 0 0-2.416-1.088c-2.032 0-3.6 1.616-3.6 3.856 0 2.24 1.568 3.856 3.6 3.856a3.19 3.19 0 0 0 2.432-1.088.88.88 0 0 1 .656-.304c.48 0 .88.4.88.88a.85.85 0 0 1-.224.592c-.848.928-2.016 1.584-3.744 1.584zm5.344 2.192c0-.416.384-.736.8-.736h.08c.528 0 .88-.16 1.104-.672l.384-.88-2.752-6.784a.932.932 0 0 1-.048-.304c0-.464.368-.832.816-.832.352 0 .672.224.784.528l2.08 5.36 2.08-5.36a.843.843 0 0 1 .784-.528c.464 0 .832.368.832.832 0 .112-.032.224-.064.32l-3.296 8.064c-.528 1.312-1.456 1.728-2.656 1.744-.064 0-.144 0-.24-.016a.736.736 0 0 1-.688-.736zm12.528-10.304c1.984 0 3.424 1.568 3.424 4.064 0 2.544-1.456 4.048-3.424 4.048-1.008 0-1.888-.48-2.48-1.248v.304a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V15.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.264c.608-.816 1.504-1.264 2.48-1.264zm-.496 6.624c1.344 0 2.192-1.056 2.192-2.56s-.848-2.576-2.192-2.576c-.784 0-1.616.48-1.984 1.056v3.056c.368.576 1.2 1.024 1.984 1.024zm9.12 1.488c-2.448 0-3.968-1.84-3.968-4.064 0-2.208 1.52-4.048 3.968-4.048 2.48 0 3.984 1.84 3.984 4.048 0 2.224-1.504 4.064-3.984 4.064zm0-1.488c1.44 0 2.24-1.2 2.24-2.576 0-1.36-.8-2.56-2.24-2.56-1.424 0-2.224 1.2-2.224 2.56 0 1.376.8 2.576 2.224 2.576zm8.848-.048c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048zm8 1.44a.85.85 0 0 1-.832-.848v-4.112c0-1.2-.624-1.568-1.568-1.568-.848 0-1.584.512-1.984 1.04v4.64a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848V15.08c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v3.248c.512-.608 1.52-1.248 2.736-1.248 1.664 0 2.496.864 2.496 2.448v4.72a.854.854 0 0 1-.848.848zm6.64-7.952c.48 0 .688.368.688.784 0 .384-.288.72-.864.8-.576.08-1.424.464-1.76 1.008v4.512a.85.85 0 0 1-.832.848.854.854 0 0 1-.848-.848v-6.224a.85.85 0 0 1 .832-.848c.464 0 .848.384.848.848v.384c.416-.544.992-1.008 1.488-1.168.192-.064.304-.096.448-.096zm1.456 3.984c0-2.24 1.632-4.048 3.92-4.048 2.32 0 3.808 1.776 3.808 3.824 0 .496-.352.784-.992.784h-4.976c.128 1.168 1.008 2.128 2.464 2.128.56 0 1.216-.176 1.76-.512a.663.663 0 0 1 .368-.096c.368 0 .672.304.672.672a.69.69 0 0 1-.304.56c-.768.512-1.696.752-2.672.752-2.32 0-4.048-1.616-4.048-4.064zm3.92-2.672c-1.44 0-2.096 1.104-2.176 2.048h4.352c-.032-.912-.656-2.048-2.176-2.048zm8.656-1.376c1.712 0 3.216.72 3.216 2.8v4.368a.854.854 0 0 1-.848.848.85.85 0 0 1-.832-.848v-.08c-.576.656-1.472 1.024-2.496 1.024-1.264 0-2.688-.848-2.688-2.56 0-1.776 1.424-2.512 2.688-2.512 1.04 0 1.936.336 2.496.992V19.96c0-.896-.736-1.44-1.808-1.44-.656 0-1.232.176-1.808.576a.724.724 0 0 1-.384.112.676.676 0 0 1-.672-.672c0-.224.128-.432.288-.544.848-.624 1.808-.912 2.848-.912zm-.304 6.96c.736 0 1.456-.272 1.84-.8v-1.168c-.384-.528-1.104-.8-1.84-.8-.944 0-1.648.544-1.648 1.392 0 .832.704 1.376 1.648 1.376zm8.864-.384c.432 0 .704.304.704.704 0 .32-.176.544-.448.64-.272.112-.64.192-1.104.192-1.296 0-1.984-.704-1.984-1.984v-4.464h-.64a.744.744 0 0 1-.736-.736c0-.4.336-.736.736-.736h.64v-1.36c0-.464.384-.848.848-.848a.85.85 0 0 1 .832.848v1.36h.928c.4 0 .736.336.736.736 0 .4-.336.736-.736.736h-.928v4.048c0 .528.256.912.736.912.192 0 .288-.048.416-.048z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M91.36 41.048a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm8.808 0a.58.58 0 0 1-.564-.42l-1.392-4.284-1.392 4.284a.58.58 0 0 1-.564.42.594.594 0 0 1-.576-.42l-1.56-4.884a.443.443 0 0 1 .42-.588c.204 0 .384.132.432.312l1.332 4.356 1.416-4.32a.504.504 0 0 1 .492-.348c.228 0 .42.132.492.348l1.416 4.32 1.332-4.356a.443.443 0 0 1 .432-.312.45.45 0 0 1 .42.6l-1.56 4.872a.594.594 0 0 1-.576.42zm2.64-.588c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm5.964 4.836c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm9.048-7.872c1.512 0 2.58 1.2 2.58 3.048 0 1.884-1.068 3.036-2.58 3.036-.816 0-1.512-.42-1.956-1.008v.468a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.7a2.387 2.387 0 0 1 1.956-1.032zm-.228 5.28c1.176 0 1.872-.948 1.872-2.232 0-1.284-.696-2.244-1.872-2.244-.708 0-1.416.432-1.728.936v2.628c.312.504 1.02.912 1.728.912zm6.804.804c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm6.456-.108c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm5.772.816a.45.45 0 0 1-.444-.444v-3.42c0-1.02-.528-1.32-1.308-1.32-.696 0-1.368.432-1.716.9v3.84a.45.45 0 0 1-.9 0v-7.212a.45.45 0 0 1 .9 0v2.652c.408-.48 1.2-.984 2.076-.984 1.212 0 1.848.588 1.848 1.848v3.696c0 .24-.204.444-.456.444zm4.74-5.94c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V35.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm6.528-.744c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.224.228c0-.36.3-.66.66-.66.36 0 .66.3.66.66 0 .36-.3.66-.66.66-.36 0-.66-.3-.66-.66zm2.52-2.364c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.808 3.048c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm10.608-5.28c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V35.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08z",
        fill: "#0176FF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M102.23 58.745V66h2.29v-7.255h-2.29zm5.958 3.042c0-.936.585-1.404 1.273-1.404.687 0 1.247.468 1.247 1.638V66H113v-4.213c0-2.106-1.146-3.276-2.75-3.276-.917 0-1.604.533-2.063 1.235l-.076-1.001h-2.253c0 .247.038 1.638.038 1.638V66h2.292v-4.213zm-4.826-4.213c.853 0 1.388-.572 1.388-1.287-.013-.728-.535-1.287-1.362-1.287-.84 0-1.388.56-1.388 1.287 0 .715.535 1.287 1.35 1.287h.012zM95 57.182c-.37.2-.764.342-1.18.4.428-.314.752-.813.902-1.397a3.754 3.754 0 0 1-1.296.613c-.382-.485-.914-.798-1.505-.798-1.134 0-2.048 1.125-2.048 2.521 0 .2.011.4.046.584-1.701-.114-3.206-1.068-4.225-2.592-.173.37-.277.755-.277 1.225 0 .869.358 1.638.914 2.094a1.799 1.799 0 0 1-.926-.313v.028c0 1.225.706 2.25 1.644 2.479a1.75 1.75 0 0 1-.926.042c.254.998 1.018 1.738 1.91 1.753-.695.683-1.586 1.196-2.547 1.196-.162 0-.324-.014-.486-.043.903.713 1.99 1.026 3.148 1.026 3.773 0 5.833-3.846 5.833-7.18v-.327c.394-.356.741-.798 1.019-1.31z",
        fill: "#0176FF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { fill: "#F2F6F8", width: "77", height: "77", rx: "3" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M37.123 19.988c0 5.984-2.81 11.302-7.182 14.698-.46.359-.944.703-1.443 1.017-.014.007-.037.022-.051.03-.305.194-.617.374-.938.553-.066.038-.133.076-.2.112a4.413 4.413 0 0 1-.282.143 18.231 18.231 0 0 1-8.371 2.027c-3.101 0-6.015-.77-8.58-2.132-.053-.03-.097-.052-.149-.082-.17-.09-.35-.187-.512-.285-.2-.111-.395-.23-.589-.359-.037-.022-.066-.045-.104-.066A18.592 18.592 0 0 1 .195 19.988c0-10.255 8.268-18.572 18.46-18.572 10.201 0 18.468 8.317 18.468 18.572",
        fill: "#B4C3D8", filter: "url(#a)", transform: "translate(17.163 19.5)" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M54.286 38.683c0 5.984-2.81 11.302-7.182 14.698-.46.359-.944.703-1.442 1.017-.015.007-.038.022-.052.03-.305.195-.617.374-.937.553-.066.038-.133.076-.2.112a4.413 4.413 0 0 1-.283.143 18.231 18.231 0 0 1-8.37 2.027c-3.102 0-6.016-.77-8.58-2.132-.054-.03-.098-.052-.15-.082-.17-.09-.349-.187-.512-.285-.2-.111-.395-.23-.588-.359-.037-.022-.066-.045-.105-.066a18.592 18.592 0 0 1-8.527-15.656c0-10.255 8.268-18.572 18.461-18.572 10.2 0 18.467 8.317 18.467 18.572",
        fill: "#4D9EFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M44.5 48.93H27.365c-1.618 0-2.941-1.315-2.941-2.922V36.68c0-1.608 1.323-2.922 2.94-2.922H44.5c1.618 0 2.941 1.314 2.941 2.922v9.328c0 1.607-1.323 2.922-2.94 2.922",
        fill: "#ECF0F5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M41.674 43.697H30.191c-2.06 0-3.747-1.675-3.747-3.722 0-2.048 1.686-3.723 3.747-3.723h11.483c2.06 0 3.747 1.675 3.747 3.723 0 2.047-1.686 3.722-3.747 3.722",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M33.215 39.975a2.083 2.083 0 0 1-2.09 2.075c-1.154 0-2.09-.929-2.09-2.075 0-1.147.936-2.076 2.09-2.076s2.09.93 2.09 2.076M42.83 39.975a2.083 2.083 0 0 1-2.09 2.075c-1.154 0-2.09-.929-2.09-2.075 0-1.147.936-2.076 2.09-2.076s2.09.93 2.09 2.076",
        fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M36.11 24.194c.77 0 1.393.62 1.393 1.385s-.623 1.38-1.393 1.38c-.769 0-1.392-.615-1.392-1.38 0-.765.623-1.385 1.392-1.385M41.135 33.499v.258H30.73V33.5c0-1.082.881-1.957 1.973-1.957h6.462c1.089 0 1.97.875 1.97 1.957",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M36.707 31.716v-6.378c0-.195-.267-.354-.597-.354-.33 0-.596.159-.596.354v6.378c0 .195.267.353.596.353.33 0 .597-.158.597-.353z",
        fill: "#B4C3D8", fillRule: "nonzero" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M11.05-2.345H4.577c-.555 0-1.01.454-1.01 1.01v11.677c0 .555.45 1.005 1.004 1.005h5.437l1.483 1.517c.206.21.563.065.563-.23V-1.34",
        fill: "#B4C3D8", filter: "url(#b)", transform: "rotate(90 19.56 39.448)" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M61.354 23.742c0-.555-.455-1.01-1.01-1.01H48.667c-.555 0-1.006.45-1.006 1.004v5.437l-1.517 1.483a.328.328 0 0 0 .23.563H60.35c.555 0 1.005-.45 1.005-1.004v-6.473z",
        fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M56.925 26.709a.722.722 0 1 0 1.443.001.722.722 0 0 0-1.443-.001M54.573 27.431a.721.721 0 1 0-.001-1.442.721.721 0 0 0 .001 1.442zM50.779 26.709a.722.722 0 1 0 1.443.001.722.722 0 0 0-1.443-.001",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(44.565 13)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "mask",
          { id: "d", fill: "#fff" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#c" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M3.993.756l.478 1.631c.04.14.15.25.288.29l1.624.481c.408.12.408.702 0 .822l-1.624.48a.428.428 0 0 0-.288.29l-.478 1.632a.426.426 0 0 1-.819 0l-.478-1.631a.429.429 0 0 0-.289-.29L.783 3.98c-.407-.121-.407-.702 0-.823l1.624-.48a.429.429 0 0 0 .29-.29L3.173.755c.12-.41.698-.41.819 0",
          fill: "#4D9EFF", mask: "url(#d)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(22.932 60.306)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "mask",
          { id: "f", fill: "#fff" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#e" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          d: "M2.655.257l.32 1.091c.027.094.1.167.193.194l1.087.322c.272.08.272.47 0 .55l-1.087.321a.285.285 0 0 0-.193.194l-.32 1.092a.285.285 0 0 1-.547 0l-.32-1.092a.285.285 0 0 0-.193-.194l-1.086-.32c-.274-.082-.274-.47 0-.551l1.086-.322a.286.286 0 0 0 .193-.194l.32-1.091a.285.285 0 0 1 .547 0",
          fill: "#B4C3D8", mask: "url(#f)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M18.387 16.686c0 .64-.516 1.158-1.153 1.158a1.155 1.155 0 0 1-1.152-1.158c0-.64.516-1.158 1.152-1.158.637 0 1.153.518 1.153 1.158z",
        stroke: "#B4C3D8", strokeWidth: "1.08", strokeLinecap: "round", strokeLinejoin: "round"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M17.305 57.13c0 .64-.516 1.158-1.153 1.158A1.155 1.155 0 0 1 15 57.13c0-.64.516-1.158 1.152-1.158.637 0 1.153.519 1.153 1.158z",
        stroke: "#4D9EFF", strokeWidth: "1.08", strokeLinecap: "round", strokeLinejoin: "round"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M60.538 43.198a.833.833 0 0 1-.83-.835c0-.461.372-.835.83-.835.46 0 .831.374.831.835a.833.833 0 0 1-.83.835z",
        fill: "#B4C3D8" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M66.595 17.748l-2.84 2.855", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M66.595 17.748l-2.84 2.855", stroke: "#BAC9DE", strokeWidth: "1.08",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M61.862 16.756l-.293 2.35", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M61.862 16.756l-.293 2.35", stroke: "#BAC9DE", strokeWidth: "1.08",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M67.627 22.164l-2.742.44", fill: "#FFF" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M67.627 22.164l-2.742.44", stroke: "#BAC9DE", strokeWidth: "1.08",
        strokeLinecap: "round", strokeLinejoin: "round" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M56.99 52.773c.024-.082.012-.176-.046-.234l-5.888-5.898c-.058-.058-.152-.07-.234-.046a.216.216 0 0 0-.128.199v8.424c0 .082.047.164.128.199a.246.246 0 0 0 .234-.047l1.8-1.813 1.46 3.018a.2.2 0 0 0 .28.094l.946-.48a.2.2 0 0 0 .094-.28L54.164 52.9h2.628a.216.216 0 0 0 .199-.128z",
        fill: "#384F5B" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M1.356 102.048a.453.453 0 0 1-.456-.444v-7.212a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036C7.896 96.06 9 97.416 9 99.096s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm3.996-2.244c0-1.716 1.164-3.036 2.892-3.036.84 0 1.404.276 1.86.72.072.072.132.18.132.3 0 .228-.18.408-.408.408a.38.38 0 0 1-.264-.108c-.372-.372-.78-.516-1.272-.516-1.236 0-2.004.948-2.004 2.232 0 1.284.768 2.244 2.004 2.244.492 0 .9-.144 1.26-.516a.38.38 0 0 1 .276-.108c.228 0 .408.18.408.408 0 .12-.06.24-.132.3-.456.444-1.02.72-1.86.72-1.728 0-2.892-1.32-2.892-3.048zm8.556-3.036c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm6.42-.264c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792h-.612a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396h-.828v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm1.848-6.204a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V96.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm4.788.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V96.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M1.708 120c-.392 0-.616-.224-.616-.616v-8.106c0-.392.224-.616.616-.616H5.25c1.624 0 2.618.98 2.618 2.38 0 1.176-.784 1.96-1.638 2.142.994.154 1.82 1.176 1.82 2.296 0 1.498-.994 2.52-2.702 2.52h-3.64zm.546-5.292h2.8c1.05 0 1.61-.644 1.61-1.498 0-.84-.56-1.512-1.61-1.512h-2.8v3.01zm0 4.256H5.11c1.092 0 1.736-.616 1.736-1.61 0-.854-.588-1.61-1.736-1.61H2.254v3.22zm10.556 1.204c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm4.774.14a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798zm9.268-.266c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm4.592 1.064c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm8.512-6.16c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V113.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm4.704 8.568a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm14.98-1.582a.586.586 0 0 1-.574-.574v-7.252l-3.094 7.588c-.056.154-.168.238-.322.238a.34.34 0 0 1-.322-.238l-3.08-7.588v7.252a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-7.896c0-.532.434-.98.98-.98.42 0 .77.252.91.616l2.674 6.594 2.688-6.594a.964.964 0 0 1 .91-.616c.546 0 .98.448.98.98v7.896a.58.58 0 0 1-.588.574zm10.458-.826c.014.07.042.154.042.224a.595.595 0 0 1-1.148.224l-.672-1.75h-4.802l-.672 1.75a.565.565 0 0 1-.546.378.595.595 0 0 1-.602-.588.83.83 0 0 1 .056-.238l3.22-7.98c.154-.378.518-.644.952-.644.434 0 .798.266.938.644l3.234 7.98zm-6.174-2.338h4.004l-2.002-5.194-2.002 5.194zm8.106 4.746a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm6.426-5.264v-5.194a.58.58 0 0 1 .588-.574c.322 0 .574.266.574.574v5.166c0 1.708.924 2.786 2.646 2.786s2.646-1.078 2.646-2.786v-5.166a.58.58 0 0 1 .588-.574c.322 0 .574.266.574.574v5.18c0 2.324-1.274 3.808-3.808 3.808s-3.808-1.498-3.808-3.794zm9.604 2.66a.588.588 0 0 1-.21-.434c0-.322.252-.574.56-.574.126 0 .266.042.35.126.63.546 1.484.98 2.562.98 1.666 0 2.198-.896 2.198-1.61 0-1.12-1.134-1.428-2.366-1.764-1.498-.392-3.164-.812-3.164-2.646 0-1.54 1.372-2.59 3.29-2.59 1.176 0 2.072.336 2.884.966a.522.522 0 0 1 .238.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126c-.672-.56-1.498-.812-2.324-.812-1.204 0-2.002.602-2.002 1.484 0 .938 1.078 1.218 2.268 1.54 1.526.406 3.262.882 3.262 2.842 0 1.358-.924 2.744-3.444 2.744-1.372 0-2.45-.448-3.22-1.134z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M173.564 99.096c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm10.524-.744c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V96.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm6.276 0c1.524 0 2.58 1.152 2.58 3.036 0 1.872-1.056 3.048-2.58 3.048-.78 0-1.476-.372-1.956-1.032v2.7a.45.45 0 0 1-.9 0V96.6a.45.45 0 0 1 .9 0v.468a2.423 2.423 0 0 1 1.956-1.008zm-.228 5.28c1.164 0 1.86-.96 1.86-2.244 0-1.284-.696-2.232-1.86-2.232-.708 0-1.416.42-1.728.924v2.616c.312.504 1.02.936 1.728.936zm4.716.708a.453.453 0 0 1-.456-.444v-7.212a.45.45 0 0 1 .9 0v7.212a.45.45 0 0 1-.444.444zm4.776.096c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm4.02 2.592c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm5.856-4.836c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.912 2.292c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm4.008 4.656a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M176.08 120.056a.58.58 0 0 1-.588-.574v-7.28l-1.19 1.26a.508.508 0 0 1-.35.154.502.502 0 0 1-.504-.504c0-.14.056-.266.14-.35l1.904-1.96a.684.684 0 0 1 1.162.476v8.204a.577.577 0 0 1-.574.574zm3.164 1.582a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.384 140.108c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V140.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm1.14 2.988c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456H5.472c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.532-.648c.264 0 .456.204.456.456 0 .06-.024.132-.036.18l-2.016 4.824a.689.689 0 0 1-.636.432.697.697 0 0 1-.66-.432l-2.016-4.824c-.012-.06-.036-.12-.036-.18 0-.252.192-.456.444-.456.192 0 .36.12.42.276l1.836 4.536 1.824-4.536a.466.466 0 0 1 .42-.276zm1.26 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm7.212-.744c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V140.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm8.004.096c.252 0 .456.204.456.444v5.004a.45.45 0 0 1-.9 0v-.408c-.444.492-1.188.948-2.064.948-1.212 0-1.848-.588-1.848-1.848V140.6a.45.45 0 0 1 .9 0v3.42c0 1.02.516 1.32 1.296 1.32.708 0 1.38-.408 1.716-.876V140.6a.45.45 0 0 1 .444-.444zm1.92 2.94c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M7.616 161.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.9-.056a.608.608 0 0 1-.182-.406c0-.294.252-.532.546-.532.126 0 .252.042.35.126.574.602 1.288.91 2.254.91 1.274 0 2.156-.868 2.156-2.002 0-1.232-.882-2.016-2.142-2.016-.714 0-1.33.21-1.918.686a.62.62 0 0 1-.42.154.672.672 0 0 1-.672-.672v-4.004c0-.392.224-.616.616-.616h4.634c.28 0 .518.238.518.518s-.238.518-.518.518h-4.088v3.248c.448-.448 1.246-.84 2.184-.84 1.554 0 2.968 1.064 2.968 2.982 0 1.904-1.442 3.08-3.318 3.08-1.344 0-2.268-.42-2.968-1.134zm8.512 2.604a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm8.624-5.026c.28 0 .518.224.518.504a.517.517 0 0 1-.518.518h-.854v1.848a.586.586 0 0 1-.574.574.58.58 0 0 1-.588-.574v-1.848H20.86a.675.675 0 0 1-.574-1.05l3.696-5.516a1 1 0 0 1 .84-.462c.546 0 1.008.448 1.008 1.008v4.998h.854zm-5.292 0h3.276v-4.872l-3.276 4.872zm6.916-1.274c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.024 189.232c.228 0 .384.156.384.384a.34.34 0 0 1-.228.336c-.204.12-.456.192-.816.192-.852 0-1.284-.492-1.284-1.356v-3.792H.468a.4.4 0 0 1-.396-.396.4.4 0 0 1 .396-.396h.612v-1.188a.45.45 0 0 1 .9 0v1.188h.828a.41.41 0 0 1 .408.396.41.41 0 0 1-.408.396H1.98v3.6c0 .432.192.744.588.744.252 0 .336-.108.456-.108zm3.684-5.172c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm8.94-5.34a.45.45 0 0 1 .444.444v5.232c0 1.92-1.344 2.52-2.76 2.52-.852 0-1.464-.144-2.1-.66a.416.416 0 0 1-.156-.312.4.4 0 0 1 .396-.396c.084 0 .168.036.228.084.456.384.948.54 1.632.54.96 0 1.86-.468 1.86-1.74v-.816c-.432.588-1.14 1.02-1.944 1.02-1.512 0-2.58-1.128-2.58-3 0-1.86 1.056-3.012 2.58-3.012.78 0 1.476.384 1.944 1.032v-.492c0-.24.204-.444.456-.444zm-2.184 5.124c.72 0 1.416-.444 1.728-.948V185.8c-.312-.504-1.008-.936-1.728-.936-1.164 0-1.86.924-1.86 2.208 0 1.272.696 2.208 1.86 2.208zm4.188.18a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M3.528 207.104c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424H.546a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462H2.31v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm1.246-2.492c0-1.96 1.4-3.542 3.332-3.542 2.044 0 3.248 1.596 3.248 3.36 0 .336-.224.532-.616.532H5.88c.084 1.274.98 2.338 2.436 2.338.658 0 1.288-.224 1.82-.644a.46.46 0 0 1 .238-.056c.238 0 .434.182.434.42 0 .14-.07.266-.182.35-.672.518-1.47.798-2.408.798-2.002 0-3.444-1.442-3.444-3.556zm3.318-2.674c-1.442 0-2.156 1.218-2.212 2.254h4.438c-.014-1.008-.686-2.254-2.226-2.254zm4.564 2.674c0-2.002 1.358-3.542 3.374-3.542.98 0 1.638.322 2.17.84.084.084.154.21.154.35 0 .266-.21.476-.476.476a.444.444 0 0 1-.308-.126c-.434-.434-.91-.602-1.484-.602-1.442 0-2.338 1.106-2.338 2.604s.896 2.618 2.338 2.618c.574 0 1.05-.168 1.47-.602a.444.444 0 0 1 .322-.126c.266 0 .476.21.476.476 0 .14-.07.28-.154.35-.532.518-1.19.84-2.17.84-2.016 0-3.374-1.54-3.374-3.556zm12.418 3.444a.526.526 0 0 1-.518-.518v-3.99c0-1.19-.616-1.54-1.526-1.54-.812 0-1.596.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v3.094c.476-.56 1.4-1.148 2.422-1.148 1.414 0 2.156.686 2.156 2.156v4.312c0 .28-.238.518-.532.518zm6.09-6.986c1.414 0 2.156.714 2.156 2.184v4.284c0 .28-.238.518-.532.518a.526.526 0 0 1-.518-.518v-3.962c0-1.19-.602-1.568-1.512-1.568-.826 0-1.61.504-2.002 1.05v4.48c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V201.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.532c.462-.56 1.372-1.162 2.408-1.162zm7.21 7.098c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm5.586.826a.529.529 0 0 1-.532-.518v-8.414c0-.28.238-.518.532-.518.28 0 .518.238.518.518v8.414c0 .28-.238.518-.518.518zm5.572.112c-2.058 0-3.346-1.596-3.346-3.556s1.288-3.542 3.346-3.542 3.346 1.582 3.346 3.542c0 1.96-1.288 3.556-3.346 3.556zm0-.938c1.442 0 2.24-1.232 2.24-2.618 0-1.372-.798-2.604-2.24-2.604-1.442 0-2.254 1.232-2.254 2.604 0 1.386.812 2.618 2.254 2.618zm10.472-6.048c.28 0 .518.238.518.518v6.104c0 2.24-1.568 2.94-3.22 2.94-.994 0-1.708-.168-2.45-.77a.486.486 0 0 1-.182-.364c0-.252.21-.462.462-.462.098 0 .196.042.266.098.532.448 1.106.63 1.904.63 1.12 0 2.17-.546 2.17-2.03v-.952c-.504.686-1.33 1.19-2.268 1.19-1.764 0-3.01-1.316-3.01-3.5 0-2.17 1.232-3.514 3.01-3.514.91 0 1.722.448 2.268 1.204v-.574c0-.28.238-.518.532-.518zm-2.548 5.978c.84 0 1.652-.518 2.016-1.106V203.1c-.364-.588-1.176-1.092-2.016-1.092-1.358 0-2.17 1.078-2.17 2.576 0 1.484.812 2.576 2.17 2.576zm4.802 3.094c0-.266.238-.462.504-.462.042 0 .112.014.224.014.462 0 .77-.154 1.008-.714l.448-1.022-2.548-6.16a.52.52 0 0 1 .476-.728c.224 0 .42.14.49.322l2.142 5.278 2.128-5.278a.543.543 0 0 1 .49-.322c.308 0 .532.238.532.532 0 .07-.014.14-.042.21l-3.108 7.448c-.406.98-1.092 1.358-1.988 1.372-.098 0-.196 0-.308-.028-.266-.028-.448-.224-.448-.462zm6.874-.616a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm6.104-2.268a.446.446 0 0 1-.196-.378c0-.252.21-.462.462-.462.098 0 .196.028.28.084.49.406 1.162.7 1.918.7 1.036 0 1.596-.462 1.596-1.12 0-.742-.826-.98-1.736-1.204-1.148-.266-2.45-.574-2.45-1.974 0-1.05.91-1.946 2.52-1.946.966 0 1.694.308 2.24.742.098.084.182.21.182.35a.46.46 0 0 1-.448.448.436.436 0 0 1-.252-.098c-.42-.364-1.022-.588-1.722-.588-.924 0-1.498.42-1.498 1.022 0 .658.77.868 1.652 1.078 1.176.266 2.534.602 2.534 2.1 0 1.134-.91 2.044-2.66 2.044-.938 0-1.75-.252-2.422-.798zm6.398-2.758c0-1.96 1.4-3.542 3.332-3.542 2.044 0 3.248 1.596 3.248 3.36 0 .336-.224.532-.616.532H82.74c.084 1.274.98 2.338 2.436 2.338.658 0 1.288-.224 1.82-.644a.46.46 0 0 1 .238-.056c.238 0 .434.182.434.42 0 .14-.07.266-.182.35-.672.518-1.47.798-2.408.798-2.002 0-3.444-1.442-3.444-3.556zm3.318-2.674c-1.442 0-2.156 1.218-2.212 2.254h4.438c-.014-1.008-.686-2.254-2.226-2.254zm4.564 2.674c0-2.002 1.358-3.542 3.374-3.542.98 0 1.638.322 2.17.84.084.084.154.21.154.35 0 .266-.21.476-.476.476a.444.444 0 0 1-.308-.126c-.434-.434-.91-.602-1.484-.602-1.442 0-2.338 1.106-2.338 2.604s.896 2.618 2.338 2.618c.574 0 1.05-.168 1.47-.602a.444.444 0 0 1 .322-.126c.266 0 .476.21.476.476 0 .14-.07.28-.154.35-.532.518-1.19.84-2.17.84-2.016 0-3.374-1.54-3.374-3.556zm12.404-3.43c.294 0 .532.238.532.518v5.838c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518v-.476c-.518.574-1.386 1.106-2.408 1.106-1.414 0-2.156-.686-2.156-2.156V201.7c0-.28.238-.518.532-.518.28 0 .518.238.518.518v3.99c0 1.19.602 1.54 1.512 1.54.826 0 1.61-.476 2.002-1.022V201.7c0-.28.238-.518.518-.518zm5.53-.056c.308 0 .476.238.476.504 0 .252-.21.476-.574.518-.616.042-1.442.518-1.75 1.064v4.326c0 .28-.238.518-.518.518a.529.529 0 0 1-.532-.518V201.7c0-.28.238-.518.518-.518.294 0 .532.238.532.518v.63c.406-.546.966-.994 1.512-1.134.14-.042.224-.07.336-.07zm2.24-1.26a.702.702 0 0 1-.7-.7c0-.392.322-.714.7-.714.392 0 .714.322.714.714 0 .392-.322.7-.714.7zm0 8.19a.526.526 0 0 1-.518-.518V201.7c0-.28.238-.518.532-.518.28 0 .518.238.518.518v5.838c0 .28-.238.518-.532.518zm5.11-.952c.266 0 .448.182.448.448a.396.396 0 0 1-.266.392c-.238.14-.532.224-.952.224-.994 0-1.498-.574-1.498-1.582v-4.424h-.714a.466.466 0 0 1-.462-.462c0-.252.21-.462.462-.462h.714v-1.386c0-.28.238-.518.532-.518.28 0 .518.238.518.518v1.386h.966c.252 0 .476.21.476.462a.478.478 0 0 1-.476.462h-.966v4.2c0 .504.224.868.686.868.294 0 .392-.126.532-.126zm1.274 3.15c0-.266.238-.462.504-.462.042 0 .112.014.224.014.462 0 .77-.154 1.008-.714l.448-1.022-2.548-6.16a.52.52 0 0 1 .476-.728c.224 0 .42.14.49.322l2.142 5.278 2.128-5.278a.543.543 0 0 1 .49-.322c.308 0 .532.238.532.532 0 .07-.014.14-.042.21l-3.108 7.448c-.406.98-1.092 1.358-1.988 1.372-.098 0-.196 0-.308-.028-.266-.028-.448-.224-.448-.462z",
        fill: "#394F5A" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M180.176 140.06c1.056 0 1.62.588 1.62 1.752v3.792c0 .24-.216.444-.456.444a.45.45 0 0 1-.444-.444v-3.54c0-.732-.324-1.2-1.068-1.2-.6 0-1.236.432-1.536.888v3.852a.45.45 0 0 1-.444.444.461.461 0 0 1-.456-.444v-3.54c0-.732-.312-1.2-1.068-1.2-.588 0-1.212.432-1.524.9v3.84a.45.45 0 0 1-.9 0V140.6a.45.45 0 0 1 .9 0v.444c.228-.36 1.008-.984 1.872-.984.888 0 1.392.48 1.56 1.08.324-.528 1.104-1.08 1.944-1.08zm5.952 6.084c-1.764 0-2.868-1.368-2.868-3.048s1.104-3.036 2.868-3.036c1.764 0 2.868 1.356 2.868 3.036s-1.104 3.048-2.868 3.048zm0-.804c1.236 0 1.92-1.056 1.92-2.244 0-1.176-.684-2.232-1.92-2.232-1.236 0-1.932 1.056-1.932 2.232 0 1.188.696 2.244 1.932 2.244zm7.296-5.28c1.212 0 1.848.612 1.848 1.872v3.672a.45.45 0 0 1-.9 0v-3.396c0-1.02-.516-1.344-1.296-1.344-.708 0-1.38.432-1.716.9v3.84a.45.45 0 0 1-.9 0V140.6a.45.45 0 0 1 .9 0v.456c.396-.48 1.176-.996 2.064-.996zm3.312 3.036c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm3.936 7.128c0-.228.204-.396.432-.396.036 0 .096.012.192.012.396 0 .66-.132.864-.612l.384-.876-2.184-5.28a.446.446 0 0 1 .408-.624c.192 0 .36.12.42.276l1.836 4.524 1.824-4.524a.466.466 0 0 1 .42-.276c.264 0 .456.204.456.456 0 .06-.012.12-.036.18l-2.664 6.384c-.348.84-.936 1.164-1.704 1.176-.084 0-.168 0-.264-.024-.228-.024-.384-.192-.384-.396zm11.772-7.824c.264 0 .408.204.408.432 0 .216-.18.408-.492.444-.528.036-1.236.444-1.5.912v3.708a.45.45 0 0 1-.9 0V140.6a.45.45 0 0 1 .9 0v.54c.348-.468.828-.852 1.296-.972.12-.036.192-.06.288-.06zm3.756-.048c1.224 0 2.244.552 2.244 1.956v3.588a.45.45 0 0 1-.9 0v-.264c-.456.528-1.128.804-1.92.804-.984 0-2.028-.66-2.028-1.92 0-1.296 1.044-1.908 2.028-1.908.792 0 1.452.252 1.92.792v-1.044c0-.78-.624-1.224-1.464-1.224-.576 0-1.056.168-1.512.576a.473.473 0 0 1-.24.072.374.374 0 0 1-.372-.372c0-.12.072-.24.156-.3.588-.516 1.26-.756 2.088-.756zm-.252 5.436c.636 0 1.248-.24 1.596-.72v-1.092c-.348-.48-.96-.72-1.596-.72-.84 0-1.428.528-1.428 1.272 0 .732.588 1.26 1.428 1.26zm4.74-6.468a.602.602 0 0 1-.6-.6c0-.336.276-.612.6-.612.336 0 .612.276.612.612 0 .336-.276.6-.612.6zm0 7.02a.45.45 0 0 1-.444-.444V140.6a.45.45 0 0 1 .9 0v5.004c0 .24-.204.444-.456.444zm2.016-.588a.383.383 0 0 1-.168-.324.4.4 0 0 1 .396-.396c.084 0 .168.024.24.072.42.348.996.6 1.644.6.888 0 1.368-.396 1.368-.96 0-.636-.708-.84-1.488-1.032-.984-.228-2.1-.492-2.1-1.692 0-.9.78-1.668 2.16-1.668.828 0 1.452.264 1.92.636.084.072.156.18.156.3 0 .204-.18.384-.384.384a.374.374 0 0 1-.216-.084c-.36-.312-.876-.504-1.476-.504-.792 0-1.284.36-1.284.876 0 .564.66.744 1.416.924 1.008.228 2.172.516 2.172 1.8 0 .972-.78 1.752-2.28 1.752-.804 0-1.5-.216-2.076-.684zm5.484-2.364c0-1.68 1.2-3.036 2.856-3.036 1.752 0 2.784 1.368 2.784 2.88 0 .288-.192.456-.528.456h-4.164c.072 1.092.84 2.004 2.088 2.004.564 0 1.104-.192 1.56-.552a.394.394 0 0 1 .204-.048c.204 0 .372.156.372.36 0 .12-.06.228-.156.3-.576.444-1.26.684-2.064.684-1.716 0-2.952-1.236-2.952-3.048zm2.844-2.292c-1.236 0-1.848 1.044-1.896 1.932h3.804c-.012-.864-.588-1.932-1.908-1.932zm8.892-2.856c.252 0 .456.204.456.444v7.212a.45.45 0 0 1-.9 0v-.468a2.44 2.44 0 0 1-1.956 1.008c-1.512 0-2.58-1.152-2.58-3.036 0-1.848 1.056-3.048 2.58-3.048.78 0 1.476.384 1.956 1.032v-2.7a.45.45 0 0 1 .444-.444zm-2.184 7.392c.72 0 1.416-.408 1.74-.912V141.8c-.324-.504-1.02-.936-1.74-.936-1.164 0-1.86.96-1.86 2.244 0 1.284.696 2.232 1.86 2.232z",
        fill: "#7695A5" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
        d: "M180.616 161.424c0 1.26-.798 2.562-2.968 2.716v.896c0 .224-.196.42-.434.42a.421.421 0 0 1-.42-.42v-.882c-1.19-.056-2.142-.504-2.842-1.12a.594.594 0 0 1-.21-.448c0-.308.252-.56.56-.56.14 0 .266.042.35.126a3.794 3.794 0 0 0 2.142.952v-3.402c-1.428-.378-2.912-.868-2.912-2.59 0-1.456 1.232-2.478 2.912-2.59v-.91c0-.224.182-.42.42-.42s.434.196.434.42v.938c.952.07 1.736.406 2.366.938a.584.584 0 0 1 .224.448c0 .294-.252.56-.546.56a.518.518 0 0 1-.336-.126 3.203 3.203 0 0 0-1.708-.756v3.038c1.442.406 2.968.938 2.968 2.772zm-5.53-4.382c0 .798.77 1.12 1.708 1.386v-2.856c-1.008.056-1.708.644-1.708 1.47zm2.562 6.048c1.344-.112 1.778-.924 1.778-1.568 0-.952-.812-1.302-1.778-1.596v3.164zm4.788.91a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm8.148 0a.63.63 0 0 1-.616-.616c0-.21.098-.378.252-.504 3.248-2.52 4.998-4.046 4.998-5.614 0-1.19-.98-1.708-1.946-1.708-.924 0-1.68.336-2.226.868a.626.626 0 0 1-.35.126.52.52 0 0 1-.518-.532.52.52 0 0 1 .182-.392c.742-.714 1.778-1.106 2.912-1.106 1.554 0 3.136.882 3.136 2.744 0 1.904-1.932 3.64-4.536 5.698h4.116c.28 0 .518.238.518.518s-.238.518-.518.518h-5.404zm8.428 1.638a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.968 6.3a.285.285 0 0 1-.21.084.317.317 0 0 1-.322-.322c0-.098.028-.182.098-.238.336-.336.602-.756.644-1.12a.73.73 0 0 1-.196.028c-.392 0-.672-.294-.672-.714a.75.75 0 0 1 .742-.756c.462 0 .882.392.882 1.064 0 .77-.392 1.484-.966 1.974zm2.436-6.3c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794zm2.618 0c0-2.282 1.008-4.816 3.57-4.816 2.548 0 3.57 2.534 3.57 4.816 0 2.268-1.022 4.83-3.57 4.83-2.562 0-3.57-2.562-3.57-4.83zm5.95 0c0-1.862-.602-3.78-2.38-3.78s-2.38 1.918-2.38 3.78c0 1.862.602 3.794 2.38 3.794s2.38-1.932 2.38-3.794z",
        fill: "#394F5A" })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LiveRevealIcon);

/***/ }),

/***/ "COe1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConnectedIcon__ = __webpack_require__("5u7d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DisconnectLink__ = __webpack_require__("WwTB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("ndOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);





var Connected = function Connected(_ref) {
  var integrationId = _ref.integrationId,
      handleDisconnect = _ref.handleDisconnect;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'Connected' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex ' + __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.IntegrationControl },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ConnectedIcon__["a" /* default */], null),
      'Account Connected'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DisconnectLink__["a" /* default */], {
      serviceName: integrationId,
      handleDisconnect: handleDisconnect })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Connected);

/***/ }),

/***/ "CQR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EmailCapture":"EmailCapture---17AWK"};

/***/ }),

/***/ "CR44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrgStarted", function() { return createOrgStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrgFailed", function() { return createOrgFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgStarted", function() { return fetchOrgStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgFailed", function() { return fetchOrgFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrgStarted", function() { return updateOrgStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrgFailed", function() { return updateOrgFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrg", function() { return receiveOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrgProperties", function() { return receiveOrgProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrgCutover", function() { return receiveOrgCutover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkOrgHandleExistenceStarted", function() { return checkOrgHandleExistenceStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkOrgHandleExistenceFailed", function() { return checkOrgHandleExistenceFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrgHandleExistence", function() { return receiveOrgHandleExistence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOrgHandleUI", function() { return setOrgHandleUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveUserScopes", function() { return receiveUserScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchOrgProperties", function() { return patchOrgProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchOrgPropertiesPending", function() { return patchOrgPropertiesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchOrgPropertiesSuccess", function() { return patchOrgPropertiesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchOrgPropertiesFailure", function() { return patchOrgPropertiesFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendExistingUsersInvitationsViaEmailStarted", function() { return sendExistingUsersInvitationsViaEmailStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendExistingUsersInvitationsViaEmailCompleted", function() { return sendExistingUsersInvitationsViaEmailCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendExistingUsersInvitationsViaEmailFailed", function() { return sendExistingUsersInvitationsViaEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaEmailStarted", function() { return sendInvitationsViaEmailStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaEmailCompleted", function() { return sendInvitationsViaEmailCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaEmailFailed", function() { return sendInvitationsViaEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaSlackStarted", function() { return sendInvitationsViaSlackStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaSlackCompleted", function() { return sendInvitationsViaSlackCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaSlackFailed", function() { return sendInvitationsViaSlackFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleChillbotCompleted", function() { return toggleChillbotCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleChillbotFailed", function() { return toggleChillbotFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEndUserCount", function() { return fetchEndUserCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEndUserCountPending", function() { return fetchEndUserCountPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEndUserCountSuccess", function() { return fetchEndUserCountSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEndUserCountFailed", function() { return fetchEndUserCountFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLimitedContactsMktEmail", function() { return hasLimitedContactsMktEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLimitedContactsMktEmailPending", function() { return hasLimitedContactsMktEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLimitedContactsMktEmailSuccess", function() { return hasLimitedContactsMktEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLimitedContactsMktEmailFailed", function() { return hasLimitedContactsMktEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrg", function() { return createOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrg", function() { return fetchOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgProperties", function() { return fetchOrgProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgCutover", function() { return fetchOrgCutover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrg", function() { return updateOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUpdateUserScopes", function() { return batchUpdateUserScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkOrgHandle", function() { return checkOrgHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendExistingUsersInvitationsViaEmail", function() { return sendExistingUsersInvitationsViaEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaEmail", function() { return sendInvitationsViaEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendInvitationsViaSlack", function() { return sendInvitationsViaSlack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleChillbot", function() { return toggleChillbot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDriftHelpStatus", function() { return fetchDriftHelpStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("7zgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("4/vI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorsUI__ = __webpack_require__("k6b5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_api_memoize__ = __webpack_require__("8hab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_access_api__ = __webpack_require__("T2nj");












var createOrgStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].CREATE_ORG_STARTED);
var createOrgFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].CREATE_ORG_FAILED);
var fetchOrgStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_ORG_STARTED);
var fetchOrgFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_ORG_FAILED);
var updateOrgStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].UPDATE_ORG_STARTED);
var updateOrgFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].UPDATE_ORG_FAILED);
var receiveOrg = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].RECEIVE_ORG);
var receiveOrgProperties = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].RECEIVE_ORG_PROPERTIES);
var receiveOrgCutover = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].RECEIVE_ORG_CUTOVER, function (payload) {
  return payload;
}, function (_, meta) {
  return meta;
});
var checkOrgHandleExistenceStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].CHECK_ORG_HANDLE_EXISTENCE_STARTED);
var checkOrgHandleExistenceFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].CHECK_ORG_HANDLE_EXISTENCE_FAILED);
var receiveOrgHandleExistence = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].RECEIVE_ORG_HANDLE_EXISTENCE);
var setOrgHandleUI = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SET_ORG_HANDLE_UI);
var receiveUserScopes = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].RECEIVE_USER_SCOPES);

var patchOrgProperties = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].PATCH_ORG_PROPERTIES);
var patchOrgPropertiesPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].PATCH_ORG_PROPERTIES_PENDING);
var patchOrgPropertiesSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].PATCH_ORG_PROPERTIES_SUCCESS);
var patchOrgPropertiesFailure = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].PATCH_ORG_PROPERTIES_FAILURE);

var sendExistingUsersInvitationsViaEmailStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_STARTED);
var sendExistingUsersInvitationsViaEmailCompleted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_COMPLETED);
var sendExistingUsersInvitationsViaEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_EXISTING_USERS_INVITATIONS_VIA_EMAIL_FAILED);

var sendInvitationsViaEmailStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_EMAIL_STARTED);
var sendInvitationsViaEmailCompleted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_EMAIL_COMPLETED);
var sendInvitationsViaEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_EMAIL_FAILED);

var sendInvitationsViaSlackStarted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_SLACK_STARTED);
var sendInvitationsViaSlackCompleted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_SLACK_COMPLETED);
var sendInvitationsViaSlackFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].SEND_INVITATIONS_VIA_SLACK_FAILED);

var toggleChillbotCompleted = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].TOGGLE_CHILLBOT_COMPLETED);
var toggleChillbotFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].TOGGLE_CHILLBOT_FAILED);

var fetchEndUserCount = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_END_USER_COUNT);
var fetchEndUserCountPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_END_USER_COUNT_PENDING);
var fetchEndUserCountSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_END_USER_COUNT_SUCCESS);
var fetchEndUserCountFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].FETCH_END_USER_COUNT_FAILED);

var hasLimitedContactsMktEmail = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].HAS_LIMITED_CONTACT_MKT_EMAIL);
var hasLimitedContactsMktEmailPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].HAS_LIMITED_CONTACT_MKT_EMAIL_PENDING);
var hasLimitedContactsMktEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].HAS_LIMITED_CONTACT_MKT_EMAIL_SUCCESS);
var hasLimitedContactsMktEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* constants */].HAS_LIMITED_CONTACT_MKT_EMAIL_FAILED);

var createOrg = function createOrg() {
  return function (dispatch) {
    dispatch(createOrgStarted());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].create().then(function (data) {
      return dispatch(receiveOrg(data));
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
      dispatch(createOrgFailed(error));
      throw error;
    });
  };
};

var fetchOrg = Object(__WEBPACK_IMPORTED_MODULE_8_app_api_memoize__["a" /* default */])(function () {
  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
      dispatch(fetchOrgStarted(orgId));
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetch(orgId).then(function (data) {
        return dispatch(receiveOrg(data));
      }).then(function () {
        return dispatch(fetchOrgProperties(orgId));
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
        dispatch(fetchOrgFailed(error));
        throw error;
      });
    });
  };
});

var fetchOrgProperties = Object(__WEBPACK_IMPORTED_MODULE_8_app_api_memoize__["a" /* default */])(function () {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchProperties(orgId).then(function (data) {
      dispatch(receiveOrgProperties(Object(__WEBPACK_IMPORTED_MODULE_9_ramda__["mergeAll"])([data.orgProperties, data.authOrgProperties])));
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
      dispatch(fetchOrgFailed(error));
      throw error;
    });
  };
});

var fetchOrgCutover = Object(__WEBPACK_IMPORTED_MODULE_8_app_api_memoize__["a" /* default */])(function (cutoverName) {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
    return Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_access_api__["a" /* getDriftCutover */])({ orgId: orgId, cutoverName: cutoverName }).then(function (data) {
      return dispatch(receiveOrgCutover(data[cutoverName], cutoverName));
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
});

var updateOrg = function updateOrg(updates) {
  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
      dispatch(updateOrgStarted(orgId));
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].update(orgId, updates).then(function (data) {
        dispatch(receiveOrg(data));
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Your company information has been saved!',
          variant: 'green'
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'An error ocurred while updating your company information. Please try again later.',
          variant: 'red'
        });
        dispatch(updateOrgFailed(error));
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
        throw error;
      });
    });
  };
};

var batchUpdateUserScopes = function batchUpdateUserScopes(updates) {
  return function (dispatch, getState) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].batchUpdateUserScopes(orgId, updates).then(function () {
        dispatch(receiveUserScopes(updates));
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Your updates have been saved!',
          variant: 'green'
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'An error ocurred while updating your user information. Please try again later.',
          variant: 'red'
        });
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(error);
        throw error;
      });
    });
  };
};

var checkOrgHandle = function checkOrgHandle() {
  return function (dispatch, getState) {
    var orgHandle = __WEBPACK_IMPORTED_MODULE_7__selectorsUI__["a" /* orgHandle */](getState());
    if (!orgHandle.length > 0) return;
    dispatch(checkOrgHandleExistenceStarted());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].checkHandle(orgHandle).then(function (res) {
      if (res.status === 404) {
        return dispatch(receiveOrgHandleExistence({ valid: true }));
      } else if (res.status === 200) {
        return dispatch(receiveOrgHandleExistence({ valid: false }));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to check org handle existence for handle ' + orgHandle));
        dispatch(checkOrgHandleExistenceFailed());
      }
    });
  };
};

var sendExistingUsersInvitationsViaEmail = function sendExistingUsersInvitationsViaEmail(userId) {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
    var payload = { invitedUsers: [userId] };
    dispatch(sendExistingUsersInvitationsViaEmailStarted());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].sendExistingInvitationsViaEmail(orgId, payload).then(function (res) {
      if (res.ok) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({ content: 'Your invitations have been sent!' });
        return dispatch(sendExistingUsersInvitationsViaEmailCompleted());
      } else {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          variant: 'red',
          content: res.message
        });
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to invite users'));
        dispatch(sendExistingUsersInvitationsViaEmailFailed());
      }
    });
  };
};

var sendInvitationsViaEmail = function sendInvitationsViaEmail(invitations) {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
    dispatch(sendInvitationsViaEmailStarted());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].sendInvitationsViaEmail(orgId, invitations).then(function (res) {
      if (res.ok) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({ content: 'Your invitations have been sent!' });
        return dispatch(sendInvitationsViaEmailCompleted());
      } else {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          variant: 'red',
          content: res.message
        });
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to invite users'));
        dispatch(sendInvitationsViaEmailFailed());
      }
    });
  };
};

var sendInvitationsViaSlack = function sendInvitationsViaSlack(invitations) {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());
    dispatch(sendInvitationsViaSlackStarted());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].sendInvitationsViaSlack(orgId, invitations).then(function (res) {
      if (res.ok) {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Your invites have been sent!'
        });
        return dispatch(sendInvitationsViaSlackCompleted());
      } else {
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: res.message,
          variant: 'red'
        });
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(new Error('Unable to invite users via slack'));
        dispatch(sendInvitationsViaSlackFailed());
      }
    });
  };
};

var toggleChillbot = function toggleChillbot(chillbotStatus) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].toggleChillbot(chillbotStatus).then(function (res) {
      if (res.ok) {
        dispatch(toggleChillbotCompleted());
      } else {
        dispatch(toggleChillbotFailed());
      }
      return dispatch(fetchOrgProperties());
    });
  };
};

var fetchDriftHelpStatus = function fetchDriftHelpStatus() {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_6__selectors__["orgId"](getState());

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].getDriftHelpStatus(orgId).then(function (response) {
      return response.enabled;
    });
  };
};

/***/ }),

/***/ "CU4V":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 37 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M35.27 23.84c-.2.1-.44.16-.66.16-.53 0-1.06-.3-1.32-.83l-1.24-2.5C29.84 26.23 24.54 30 18.3 30 11.5 30 5.4 25.56 3.5 19.2c-.22-.78.22-1.62 1-1.86s1.62.2 1.85 1C7.88 23.45 12.8 27 18.3 27c5.15 0 9.34-3.05 11.04-7.66l-2.97 1.5c-.73.37-1.62.07-2-.67-.36-.74-.06-1.64.67-2l5.94-3c.73-.38 1.62-.08 2 .66l2.96 6c.37.74.07 1.64-.67 2zm-3.2-11.18c-.78.24-1.6-.2-1.85-1C28.7 6.55 23.8 3 18.3 3 13.1 3 8.92 6.05 7.23 10.66l2.96-1.5c.74-.37 1.63-.07 2 .67.36.74.07 1.64-.67 2l-5.93 3c-.22.12-.44.17-.66.17-.55 0-1.07-.3-1.33-.83l-2.96-6c-.37-.74-.07-1.64.66-2 .74-.38 1.63-.08 2 .66l1.24 2.5C6.74 3.76 12.04 0 18.29 0c6.78 0 12.86 4.44 14.76 10.79.24.78-.2 1.62-1 1.86z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "CV/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("GPw3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_withAgentStatus__ = __webpack_require__("UnnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_3_components_withAgentStatus__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (_ref) {
  var isAgentStatusLoaded = _ref.isAgentStatusLoaded;
  return !isAgentStatusLoaded;
}, __WEBPACK_IMPORTED_MODULE_1_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (_ref2) {
  var renderAgentName = _ref2.renderAgentName;
  return renderAgentName;
}, Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
  return {
    displayName: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["currentUser"](state).name
  };
})))(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),

/***/ "CZZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_inboxes_ManageInbox_styl__ = __webpack_require__("F7h3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_inboxes_ManageInbox_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_components_settings_inboxes_ManageInbox_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_settings_DeleteConfirmModal__ = __webpack_require__("hlzs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_MakeInputChangeHandler__ = __webpack_require__("0HTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_DrifttHelpers__ = __webpack_require__("Ycog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HelpModal__ = __webpack_require__("P5ci");















var ManageInbox = React.createClass({
  displayName: 'ManageInbox',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4_mixins_MakeInputChangeHandler__["a" /* default */]],

  getInitialState: function getInitialState() {
    var _props = this.props,
        inbox = _props.inbox,
        params = _props.params,
        embed = _props.embed;


    var isNew = params.inboxId === 'new';
    return {
      name: !!inbox ? inbox.name : isNew && embed && embed.organizationName ? '' + embed.organizationName : undefined,
      address: !!inbox ? inbox.address : undefined,
      showModal: false,
      isCreating: false,
      showDeleteModal: false
    };
  },
  handleNewInbox: function handleNewInbox(props) {
    var inbox = props.inbox,
        params = props.params,
        embed = props.embed;

    var isNew = params.inboxId === 'new';
    this.setState({
      name: !!inbox ? inbox.name : isNew ? '' + embed.organizationName : undefined,
      address: !!inbox ? inbox.address : undefined,
      showModal: false,
      isCreating: false,
      showDeleteModal: false
    });
  },
  getAddressInputError: function getAddressInputError() {
    if (this.state.address) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_10_validator__["isEmail"])(this.state.address)) {
        return 'Sorry, that email is not valid.';
      } else if (this.isAddressTaken()) {
        return 'Email is taken!';
      }
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (!this.props.createdInboxId && nextProps.createdInboxId) {
      var path = '/settings/manage-inboxes/' + nextProps.createdInboxId;
      return this.context.router.push(path);
    }

    //handling going from not recieving an inbox from props and later getting one (for example, when clicking from main settings page)
    if (!this.props.inbox && nextProps.inbox && nextProps.inbox.id) {
      this.handleNewInbox(nextProps);
    } else if (this.props.inbox && this.props.inbox.name != nextProps.inbox.name || this.props.inbox.address != nextProps.inbox.address) {
      //handle patch requests
      this.handleNewInbox(nextProps);
    }
  },
  isAddressValid: function isAddressValid() {
    return Object(__WEBPACK_IMPORTED_MODULE_10_validator__["isEmail"])(this.state.address) && !this.isAddressTaken();
  },
  isAddressTaken: function isAddressTaken() {
    if (this.state.address !== (this.props.inbox != null ? this.props.inbox.address : undefined)) {
      return _.includes(_.map(this.props.inboxesById, 'address'), this.state.address);
    } else {
      return false;
    }
  },
  isNameValid: function isNameValid() {
    if (!this.state.name) {
      return false;
    }
    if (this.isNew()) {
      return !this.isNameTaken();
    } else {
      return this.state.name === (this.props.inbox != null ? this.props.inbox.name : undefined) || !this.isNameTaken();
    }
  },
  isNameTaken: function isNameTaken() {
    return _.includes(_.map(this.props.inboxesById, 'name'), this.state.name);
  },
  isNew: function isNew() {
    return this.props.params.inboxId === 'new';
  },
  getNameInputError: function getNameInputError() {
    if (this.isNameTaken()) {
      return 'You already have an inbox with this name';
    }
  },
  renderForwardingInfo: function renderForwardingInfo() {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('forward-container', { shown: !this.isNew() }) },
      React.createElement(
        'div',
        { className: 'forward-to-title' },
        'Forward your emails to the following address:'
      ),
      React.createElement(
        'div',
        { className: 'forward-address-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, { src: __webpack_require__("EETw") }),
        React.createElement(
          'div',
          { className: 'forward-to' },
          this.props.inbox != null ? this.props.inbox.forwardAddress : undefined
        )
      ),
      React.createElement(
        'div',
        { className: 'micro-copy' },
        'Emails forwarded to the above email address will appear as a conversation in this inbox. ',
        React.createElement(
          'a',
          { href: 'https://help.drift.com/article/inboxes-for-conversations', rel: 'noopener norefferer' },
          'Learn more'
        )
      )
    );
  },
  renderInputs: function renderInputs() {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'inbox-name' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, {
          className: 'inbox-icon',
          src: __webpack_require__("EETw")
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Input___default.a, {
          placeholder: 'Enter inbox name',
          autoFocus: this.isNew(),
          valueLink: {
            value: this.state.name,
            requestChange: this.makeInputChangeHandler('name')
          },
          isValid: this.isNameValid(),
          errorLabel: this.getNameInputError()
        }),
        React.createElement(
          'div',
          { className: 'micro-copy' },
          'This name will be seen by your visitors when you email them. Ours is named ',
          React.createElement(
            'em',
            null,
            'Drift Support'
          ),
          '.'
        )
      ),
      React.createElement(
        'div',
        { className: 'section-header' },
        React.createElement(
          'div',
          { className: 'input-title' },
          'Public Email Address'
        )
      ),
      React.createElement(
        'div',
        { className: 'email-address' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, {
          className: 'forward-to-icon',
          src: __webpack_require__("ZWSh")
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Input___default.a, {
          placeholder: 'e.g support@company.com',
          valueLink: {
            value: this.state.address,
            requestChange: this.makeInputChangeHandler('address', this.onAddressInputChange)
          },
          isValid: this.isAddressValid(),
          errorLabel: this.getAddressInputError()
        }),
        React.createElement(
          'div',
          { className: 'micro-copy' },
          'This is the address your visitors will get replies from. We recommend a generic address like',
          ' ',
          React.createElement(
            'em',
            null,
            'hello@',
            this.props.embed && this.props.embed.organizationUrl || 'drift.com'
          )
        ),
        React.createElement(
          'div',
          { className: 'micro-copy' },
          'Heads up! In order for messages to be sent from this email address, it needs to be associated with a ',
          React.createElement(
            'a',
            { href: '/settings/dkim', rel: 'noopner norefferer' },
            ' specific email sending domain'
          ),
          '. You can do this by updating its DNS records.'
        )
      )
    );
  },
  renderConfigSectionHeader: function renderConfigSectionHeader(header, helpModalType, help) {
    var _this = this;

    if (help == null) {
      help = true;
    }
    return React.createElement(
      'div',
      { className: 'config-header' },
      React.createElement(
        'div',
        { className: 'title-container' },
        React.createElement(
          'div',
          { className: 'title' },
          header
        ),
        help ? React.createElement(
          'a',
          { className: 'help', onClick: function onClick() {
              return _this.setState({ showModal: helpModalType });
            } },
          'Need help?'
        ) : undefined
      ),
      React.createElement('div', { className: 'divider' })
    );
  },
  getDomain: function getDomain() {
    return __WEBPACK_IMPORTED_MODULE_9_utils_Helpers__["g" /* getDomainFromEmail */](this.props.inbox != null ? this.props.inbox.address : undefined);
  },
  onClickDeleteInbox: function onClickDeleteInbox() {
    return this.setState({ showDeleteModal: true });
  },
  onConfirmDelete: function onConfirmDelete() {
    this.props.actions.archiveInbox({ id: this.props.inbox.id });
    this.props.notifications.success('Deleted inbox ' + this.props.inbox.name);
    return this.context.router.replace('/settings2/conversations');
  },
  renderDeleteModal: function renderDeleteModal() {
    var _this2 = this;

    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_settings_DeleteConfirmModal__["a" /* default */],
      {
        title: 'Delete Inbox',
        onClose: function onClose() {
          return _this2.setState({ showDeleteModal: false });
        },
        onConfirm: this.onConfirmDelete,
        confirmLabel: 'I understand, delete.'
      },
      React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'text-section' },
          'You\'re about to delete the inbox \'',
          React.createElement(
            'b',
            null,
            this.props.inbox.name
          ),
          '.\''
        ),
        React.createElement(
          'div',
          { className: 'text-section' },
          'You\'ll lose access to messages in this inbox, and potentially miss new ones. We recommend chatting with us before deleting.'
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'span',
            { className: 'link', onClick: __WEBPACK_IMPORTED_MODULE_8_utils_DrifttHelpers__["a" /* newConversation */] },
            'Talk to us.'
          )
        )
      )
    );
  },
  renderInboxSettings: function renderInboxSettings() {
    return React.createElement(
      'div',
      { className: 'config-inbox-settings' },
      this.renderConfigSectionHeader('Forwarding', 'forward'),
      this.renderForwardingInfo(),
      Object.keys(this.props.inboxesById).length > 1 ? this.renderDangerZone() : undefined,
      this.state.showDeleteModal ? this.renderDeleteModal() : undefined
    );
  },
  renderDangerZone: function renderDangerZone() {
    return [this.renderConfigSectionHeader('Danger Zone', null, false), React.createElement(
      'button',
      { className: 'color-red btn-settings', onClick: this.onClickDeleteInbox },
      'Delete Inbox'
    )];
  },
  onClickReset: function onClickReset() {
    if (this.canSubmit()) {
      return this.setState(_.cloneDeep(this.getInitialState()));
    }
  },
  getSaveButtonText: function getSaveButtonText() {
    if (this.state.isCreating) {
      return 'Creating...';
    }
    if (this.isNew()) {
      return 'Create';
    } else {
      return 'Save';
    }
  },
  render: function render() {
    var _this3 = this;

    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ManageInbox', { 'move-back': this.state.movingBack }) },
      React.createElement(
        'div',
        { className: 'manage-inbox' },
        React.createElement(
          'div',
          null,
          React.createElement(
            'a',
            { href: '/settings2/conversations' },
            '< Conversations Settings'
          )
        ),
        React.createElement(
          'div',
          { className: 'inbox-settings section' },
          React.createElement(
            'div',
            { className: 'section-header' },
            React.createElement(
              'div',
              { className: 'input-title' },
              'Inbox name'
            )
          ),
          this.renderInputs()
        ),
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('action-controls', { shown: this.canSubmit() }) },
          React.createElement(
            'button',
            {
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('save disabled action btn-settings', {
                'color-teal': !this.state.isCreating
              }),
              disabled: !this.canSubmit(),
              onClick: this.saveClicked
            },
            this.getSaveButtonText()
          ),
          React.createElement(
            'div',
            { className: 'reset', onClick: this.onClickReset },
            'Cancel'
          )
        ),
        !this.isNew() ? this.renderInboxSettings() : undefined,
        this.state.showModal ? React.createElement(__WEBPACK_IMPORTED_MODULE_11__HelpModal__["a" /* default */], {
          inbox: this.props.inbox,
          type: this.state.showModal,
          onClose: function onClose() {
            return _this3.setState({ showModal: false });
          }
        }) : undefined
      )
    );
  },
  hasChanged: function hasChanged() {
    return this.state.name !== (this.props.inbox != null ? this.props.inbox.name : undefined) || this.state.address !== (this.props.inbox != null ? this.props.inbox.address : undefined);
  },
  canSubmit: function canSubmit() {
    return this.state.name && this.hasChanged() && this.isAddressValid() && this.isNameValid();
  },
  saveClicked: function saveClicked() {
    if (this.canSubmit()) {
      if (this.isNew()) {
        this.setState({ isCreating: true });
        this.props.actions.createInbox({ name: this.state.name, address: this.state.address });
      } else {
        this.props.actions.patchInbox({
          id: this.props.inbox.id,
          name: this.state.name,
          address: this.state.address
        });
      }
    }
  },
  onAddressInputChange: function onAddressInputChange(newAddress) {
    if (Object(__WEBPACK_IMPORTED_MODULE_10_validator__["isEmail"])(newAddress) && newAddress !== (this.props.inbox != null ? this.props.inbox.address : undefined)) {
      return false;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(ManageInbox));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "CaRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("o9R1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);




var LoadingDots = function LoadingDots(_ref) {
  var className = _ref.className;

  var dots = [0, 1, 2].map(function (n) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: n,
      className: 'loading-dot',
      style: { animationDelay: n * .2 + 's' } });
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('LoadingDots', className) },
    dots
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LoadingDots);

/***/ }),

/***/ "Cb8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchBannedIPs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchBannedIPsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchBannedIPsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchBannedIPsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return banIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return banIPSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return banIPFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return banIPPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return unbanIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return unbanIPSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unbanIPFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return unbanIPPending; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("o/OB");




var fetchBannedIPs = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_BANNED_IPS */]);
var fetchBannedIPsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_BANNED_IPS_SUCCESS */]);
var fetchBannedIPsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_BANNED_IPS_FAILED */]);
var fetchBannedIPsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_BANNED_IPS_PENDING */]);

var banIP = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* BAN_IP */]);
var banIPSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BAN_IP_SUCCESS */]);
var banIPFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BAN_IP_FAILED */]);
var banIPPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BAN_IP_PENDING */]);

var unbanIP = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* UNBAN_IP */]);
var unbanIPSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UNBAN_IP_SUCCESS */]);
var unbanIPFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* UNBAN_IP_FAILED */]);
var unbanIPPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* UNBAN_IP_PENDING */]);

/***/ }),

/***/ "CdFk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cfau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"InputWithLimit":"InputWithLimit---1AU7l","InputWithLimit__Label":"InputWithLimit__Label---UaGm2","TextInput":"TextInput---3qjPW"};

/***/ }),

/***/ "ChgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_TabbedView_styl__ = __webpack_require__("cj8B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_TabbedView_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_TabbedView_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.






var TabbedView = React.createClass({
  displayName: 'TabbedView',

  propTypes: {
    tabs: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array
  },

  getInitialState: function getInitialState() {
    return {
      selectedTab: _.head(this.props.tabs)
    };
  },
  render: function render() {
    var _this = this;

    return React.createElement(
      'div',
      { className: 'TabbedView-wrapper' },
      React.createElement(
        'div',
        { className: 'TabbedView' },
        _.map(this.props.tabs, function (tab) {
          return React.createElement(
            'div',
            {
              key: tab.display,
              className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('tab', { isSelected: _this.state.selectedTab.display === tab.display }),
              onClick: _this.tabClicked.bind(_this, tab) },
            tab.display
          );
        })
      ),
      this.state.selectedTab.render()
    );
  },
  tabClicked: function tabClicked(tab) {
    return this.setState({ selectedTab: tab });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TabbedView);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "ClL2":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 10 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-887.000000, -772.000000)\" fill=\"#E95531\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"check-circle\" transform=\"translate(17.000000, 294.000000)\"><path d=\"M10.70725,99.70725 C10.51225,99.90225 10.25625,100.00025 10.00025,100.00025 C9.74425,100.00025 9.48825,99.90225 9.29325,99.70725 L6.00025,96.41425 L2.70725,99.70725 C2.51225,99.90225 2.25625,100.00025 2.00025,100.00025 C1.74425,100.00025 1.48825,99.90225 1.29325,99.70725 C0.90225,99.31725 0.90225,98.68325 1.29325,98.29325 L4.58625,95.00025 L1.29325,91.70725 C0.90225,91.31725 0.90225,90.68425 1.29325,90.29325 C1.68425,89.90225 2.31625,89.90225 2.70725,90.29325 L6.00025,93.58625 L9.29325,90.29325 C9.68425,89.90225 10.31625,89.90225 10.70725,90.29325 C11.09825,90.68425 11.09825,91.31725 10.70725,91.70725 L7.41425,95.00025 L10.70725,98.29325 C11.09825,98.68325 11.09825,99.31725 10.70725,99.70725 Z\" id=\"redx\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "Cloq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SequencePreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_FakeEmailWindow__ = __webpack_require__("jwya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_svg_twitter_svg__ = __webpack_require__("bQtw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_svg_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_svg_twitter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_linkedin_svg__ = __webpack_require__("88Th");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_svg_linkedin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_facebook_svg__ = __webpack_require__("kTiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_svg_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg__ = __webpack_require__("gYUb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("Hpl3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















var HELP_DOC_LINK = 'https://help.drift.com/article/personalization-tokens/';
var HELP_LINK_TEXT = 'Click here to learn more about using personalization attributes in a Drift playbook.';



var EmailFrom = function EmailFrom(_ref) {
  var isOutboundSequencePlaybook = _ref.isOutboundSequencePlaybook,
      currentUserName = _ref.currentUserName,
      fromName = _ref.fromName,
      fromEmail = _ref.fromEmail,
      isDynamicSender = _ref.isDynamicSender;

  var name = isOutboundSequencePlaybook ? currentUserName : fromName;
  if (isDynamicSender) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag___default.a, {
      className: 'playbook-email-edit-dynamic-sender-attrib',
      tag: { name: '{{ account.' + fromName + ' }}' }
    });
  } else {
    return React.createElement(
      'span',
      null,
      name
    );
  }
};

var MarketingEmailFooter = function MarketingEmailFooter(_ref2) {
  var orgTwitterUrl = _ref2.orgTwitterUrl,
      orgLinkedinUrl = _ref2.orgLinkedinUrl,
      orgFacebookUrl = _ref2.orgFacebookUrl,
      orgName = _ref2.orgName,
      orgAddress = _ref2.orgAddress,
      showBranding = _ref2.showBranding;
  return React.createElement(
    'div',
    { className: 'playbook-email-template-footer' },
    React.createElement(
      'div',
      { className: 'playbook-email-edit-footer' },
      React.createElement(
        'div',
        { className: 'playbook-email-edit-social-links' },
        !!orgTwitterUrl && React.createElement(
          'a',
          { target: '_blank', href: orgTwitterUrl },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8_images_svg_twitter_svg___default.a })
        ),
        !!orgLinkedinUrl && React.createElement(
          'a',
          { target: '_blank', href: orgLinkedinUrl },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_9_images_svg_linkedin_svg___default.a })
        ),
        !!orgFacebookUrl && React.createElement(
          'a',
          { target: '_blank', href: orgFacebookUrl },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_10_images_svg_facebook_svg___default.a })
        )
      ),
      React.createElement(
        'div',
        { className: 'playbook-email-edit-footer-text' },
        orgName
      ),
      React.createElement(
        'div',
        { className: 'playbook-email-edit-footer-text-small playbook-email-edit-footer-text' },
        orgAddress
      ),
      React.createElement(
        'div',
        { className: 'playbook-email-edit-footer-text-muted' },
        React.createElement(
          'a',
          null,
          'Click here to unsubscribe'
        )
      ),
      showBranding && React.createElement(
        'p',
        { className: 'playbook-email-edit-footer-poweredby' },
        'Email \u26A1\uFE0F by Drift'
      )
    )
  );
};

var EmailWithLogoBody = function EmailWithLogoBody(_ref3) {
  var message = _ref3.message,
      orgName = _ref3.orgName,
      orgLogoUrl = _ref3.orgLogoUrl,
      orgTwitterUrl = _ref3.orgTwitterUrl,
      orgLinkedinUrl = _ref3.orgLinkedinUrl,
      orgFacebookUrl = _ref3.orgFacebookUrl,
      orgAddress = _ref3.orgAddress,
      backgroundColor = _ref3.backgroundColor,
      getPreviewMessage = _ref3.getPreviewMessage,
      emailId = _ref3.emailId,
      showBranding = _ref3.showBranding;
  return React.createElement(
    'div',
    { className: 'playbook-email-template-with_logo-preview' },
    React.createElement(
      'div',
      { className: 'playbook-email-template-header' },
      React.createElement('img', { src: orgLogoUrl })
    ),
    React.createElement('div', { className: 'playbook-email-template-body', dangerouslySetInnerHTML: { __html: getPreviewMessage(emailId, message) }, style: { borderTopColor: backgroundColor } }),
    React.createElement(MarketingEmailFooter, {
      orgName: orgName,
      orgAddress: orgAddress,
      orgTwitterUrl: orgTwitterUrl,
      orgLinkedinUrl: orgLinkedinUrl,
      orgFacebookUrl: orgFacebookUrl,
      showBranding: showBranding
    })
  );
};

var EmailWithHeroBody = function EmailWithHeroBody(_ref4) {
  var message = _ref4.message,
      orgName = _ref4.orgName,
      bannerImageUrl = _ref4.bannerImageUrl,
      orgTwitterUrl = _ref4.orgTwitterUrl,
      orgLinkedinUrl = _ref4.orgLinkedinUrl,
      orgFacebookUrl = _ref4.orgFacebookUrl,
      orgAddress = _ref4.orgAddress,
      getPreviewMessage = _ref4.getPreviewMessage,
      emailId = _ref4.emailId;
  return React.createElement(
    'div',
    { className: 'playbook-email-template-with_hero-preview' },
    React.createElement(
      'div',
      { className: 'playbook-email-template-with_hero-body' },
      React.createElement(
        'div',
        { className: 'playbook-email-template-header' },
        React.createElement('img', { src: bannerImageUrl })
      ),
      React.createElement('div', { className: 'playbook-email-template-body', dangerouslySetInnerHTML: { __html: getPreviewMessage(emailId, message) } })
    ),
    React.createElement(MarketingEmailFooter, {
      orgName: orgName,
      orgAddress: orgAddress,
      orgTwitterUrl: orgTwitterUrl,
      orgLinkedinUrl: orgLinkedinUrl,
      orgFacebookUrl: orgFacebookUrl
    })
  );
};

var EmailBody = function EmailBody(_ref5) {
  var isMarketingSequencePlaybook = _ref5.isMarketingSequencePlaybook,
      isOutboundSequencePlaybook = _ref5.isOutboundSequencePlaybook,
      marketingEmailLayout = _ref5.marketingEmailLayout,
      selectedPreview = _ref5.selectedPreview,
      isTemplateContactPreviewLoading = _ref5.isTemplateContactPreviewLoading,
      props = _objectWithoutProperties(_ref5, ['isMarketingSequencePlaybook', 'isOutboundSequencePlaybook', 'marketingEmailLayout', 'selectedPreview', 'isTemplateContactPreviewLoading']);

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('playbook-email-template-content', { 'playbook-email-template-preview': selectedPreview !== __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE, 'playbook-email-template-preview-loading': isTemplateContactPreviewLoading }) },
    isTemplateContactPreviewLoading && React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"], null),
    isMarketingSequencePlaybook && marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_COMPANY_LOGO && React.createElement(EmailWithLogoBody, props),
    (isOutboundSequencePlaybook || isMarketingSequencePlaybook && marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].SIMPLE || marketingEmailLayout === null) && React.createElement('div', { dangerouslySetInnerHTML: { __html: props.getPreviewMessage(props.emailId, props.message) } }),
    isMarketingSequencePlaybook && marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_HERO_IMAGE && React.createElement(EmailWithHeroBody, props)
  );
};

var EmailPreview = function EmailPreview(_ref6) {
  var email = _ref6.email,
      index = _ref6.index,
      currentUserName = _ref6.currentUserName,
      currentUserEmail = _ref6.currentUserEmail,
      isOutboundSequencePlaybook = _ref6.isOutboundSequencePlaybook,
      getFromName = _ref6.getFromName,
      getFromEmail = _ref6.getFromEmail,
      getIsDynamicSender = _ref6.getIsDynamicSender,
      props = _objectWithoutProperties(_ref6, ['email', 'index', 'currentUserName', 'currentUserEmail', 'isOutboundSequencePlaybook', 'getFromName', 'getFromEmail', 'getIsDynamicSender']);

  var isFirstEmail = index === 0;
  return React.createElement(
    'div',
    null,
    !isFirstEmail && email.delay > 0 && React.createElement(
      'div',
      { className: 'playbook-email-preview-sequence-delay' },
      'After ',
      email.delay,
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(email.delay, 'day', 'days'),
      ', send:'
    ),
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_6_components_shared_FakeEmailWindow__["a" /* default */],
      {
        from: React.createElement(EmailFrom, {
          currentUserName: currentUserName,
          currentUserEmail: currentUserEmail,
          isOutboundSequencePlaybook: isOutboundSequencePlaybook,
          fromName: getFromName(email),
          fromEmail: getFromEmail(email),
          isDynamicSender: getIsDynamicSender(email)
        }),
        address: isOutboundSequencePlaybook ? currentUserEmail : getFromEmail(email),
        subject: email.title
      },
      React.createElement(EmailBody, _extends({
        className: 'playbook-email-template-content',
        message: email.message,
        emailId: email.id,
        bannerImageUrl: email.bannerImageUrl,
        isOutboundSequencePlaybook: isOutboundSequencePlaybook
      }, props))
    )
  );
};

var SequenceRenderPreview = function SequenceRenderPreview(_ref7) {
  var onTemplatePreviewClick = _ref7.onTemplatePreviewClick,
      isMarketingSequencePlaybook = _ref7.isMarketingSequencePlaybook,
      selectedPreview = _ref7.selectedPreview,
      onDefaultPreviewClick = _ref7.onDefaultPreviewClick,
      onRenderedPreviewClick = _ref7.onRenderedPreviewClick,
      userListIdOptions = _ref7.userListIdOptions,
      selectedUserListOption = _ref7.selectedUserListOption,
      handleChangeUserListOption = _ref7.handleChangeUserListOption,
      isTemplateContactPreviewLoading = _ref7.isTemplateContactPreviewLoading,
      onRefreshPreviewClick = _ref7.onRefreshPreviewClick,
      hasLimitedContactsMktEmail = _ref7.hasLimitedContactsMktEmail;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'sequence-playbook-extra-option' },
      React.createElement(
        'div',
        { className: 'sequence-playbook-preview-options' },
        React.createElement(
          'label',
          { className: 'sequence-playbook-preview-options-label' },
          'Preview Sample Data',
          ' ',
          React.createElement(
            'a',
            { is: true, href: HELP_DOC_LINK, tooltip: HELP_LINK_TEXT, flow: 'down', target: '_blank' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg___default.a })
          )
        ),
        React.createElement(
          'div',
          { className: 'tide-pill-set sequence-playbook-preview-data-pills' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
            { onClick: onTemplatePreviewClick, type: 'subtle', selected: selectedPreview === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE },
            'Template'
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
            { onClick: onDefaultPreviewClick, type: 'subtle', selected: selectedPreview === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_19" /* EmailPreviewView */].DEFAULTS },
            'Defaults'
          ),
          isMarketingSequencePlaybook && hasLimitedContactsMktEmail && React.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
            { onClick: onRenderedPreviewClick, type: 'subtle', selected: selectedPreview === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA },
            'Contact'
          )
        )
      )
    ),
    selectedPreview === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA && React.createElement(
      'div',
      { className: 'sequence-playbook-segment-option' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_UISelect__["b" /* default */], {
        className: 'playbook-email-preview-segment-select',
        options: userListIdOptions,
        value: selectedUserListOption,
        onChange: handleChangeUserListOption,
        placeholder: 'choose a segment..'
      }),
      React.createElement(
        'div',
        null,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          { type: 'subtle', onClick: onRefreshPreviewClick, disabled: isTemplateContactPreviewLoading, loading: isTemplateContactPreviewLoading },
          'Refresh'
        )
      )
    )
  );
};

var SequencePreview = function SequencePreview(_ref8) {
  var sequence = _ref8.sequence,
      emails = _ref8.emails,
      props = _objectWithoutProperties(_ref8, ['sequence', 'emails']);

  return React.createElement(
    'div',
    { className: 'playbook-edit-sequence-preview' },
    React.createElement(SequenceRenderPreview, props),
    sequence.emails.map(function (emailId, index) {
      var email = emails.get(emailId);
      return React.createElement(EmailPreview, _extends({ key: email.id, email: email, options: sequence.options, index: index }, props));
    })
  );
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Clx7":
/***/ (function(module, exports) {

module.exports = "<svg width=\"26\" height=\"25\" viewBox=\"0 0 26 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.987 24.98H1.514a1.03 1.03 0 0 1-1.022-1.04V1.06C.492.484.95.02 1.514.02h22.473a1.03 1.03 0 0 1 1.02 1.04v22.88a1.03 1.03 0 0 1-1.02 1.04zM22.965 2.1H2.535v20.8h20.43V2.1zM7.26 11.687l4.343 3.538 6.508-7.57a1.01 1.01 0 0 1 1.443-.1c.424.38.466 1.036.095 1.47l-7.15 8.32a1.01 1.01 0 0 1-1.407.127l-5.107-4.16a1.054 1.054 0 0 1-.16-1.463 1.01 1.01 0 0 1 1.436-.162z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Cn+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logos_office_365_svg__ = __webpack_require__("Qb1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_images_logos_office_365_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_images_logos_office_365_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_magnifying_glass_svg__ = __webpack_require__("Ctet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_magnifying_glass_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_svg_magnifying_glass_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("uNah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var REFRESH_TOOLTIP = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
  'div',
  null,
  'If new email accounts are ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  ' added after you initially ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  ' connected, refresh to add ',
  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
  ' them to the list.'
);

var GlobalConnectedCalendars = function (_PureComponent) {
  _inherits(GlobalConnectedCalendars, _PureComponent);

  function GlobalConnectedCalendars() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalConnectedCalendars);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalConnectedCalendars.__proto__ || Object.getPrototypeOf(GlobalConnectedCalendars)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      calendarUsers: []
    }, _this.mapUsers = function () {
      var _this$props = _this.props,
          orgUsers = _this$props.orgUsers,
          globalCalendarUserIds = _this$props.globalCalendarUserIds;

      var users = globalCalendarUserIds.map(function (userId) {
        return orgUsers[userId];
      });
      _this.setState({ calendarUsers: users });
    }, _this.onDisconnectClicked = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this$props2, actions, onDisconnect;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, actions = _this$props2.actions, onDisconnect = _this$props2.onDisconnect;
              _context.t0 = Promise;
              _context.next = 4;
              return actions.disconnectMicrosoftAdminConsent();

            case 4:
              _context.t1 = _context.sent;
              _context.next = 7;
              return onDisconnect();

            case 7:
              _context.t2 = _context.sent;
              _context.t3 = [_context.t1, _context.t2];
              return _context.abrupt('return', _context.t0.all.call(_context.t0, _context.t3));

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _this.onRefreshClicked = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.props.actions.fetchMicrosoftManagedCalendars();

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    })), _this.createTableColumns = function () {
      return [{ label: 'NAME', width: '40%' }, { label: 'EMAIL', width: '60%' }];
    }, _this.createTableRow = function (user) {
      return {
        className: 'connected-calendar-table-row',
        data: [{ content: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            user.name
          ) }, { content: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            user.email
          ) }]
      };
    }, _this.renderTable = function (users) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'settings-global-calendar--calendar-table-content' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Table"], {
          className: 'settings-global-calendar-table',
          columns: _this.createTableColumns(),
          data: users.map(_this.createTableRow)
        }),
        users && !users.length && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'settings-global-calendar--calendar-table-empty' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_9_images_svg_magnifying_glass_svg___default.a }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Hmmm... there\u2019s nothing here ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
            ' Once you have users in your Microsoft domain, refresh and they should appear here! '
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalConnectedCalendars, [{
    key: 'componentDidMount',
    value: function () {
      var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.actions.fetchMicrosoftManagedCalendars();

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref4.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.globalCalendarUserIds !== this.props.globalCalendarUserIds) {
        this.mapUsers();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var calendarUsers = this.state.calendarUsers;
      var _props = this.props,
          isLoadingUsers = _props.isLoadingUsers,
          hasLoadedUsers = _props.hasLoadedUsers;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'settings-global-calendar--calendar-table' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'settings-global-calendar--calendar-content' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'settings-global-calendar--calendar-header' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8_images_logos_office_365_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'settings-global-calendar--calendar-header-description' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h2',
                null,
                'Connected Calendars'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                null,
                'We\u2019ll use these calendars to check for any conflicts when new meetings are being scheduled, add new calendar events to them'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'settings-global-calendar--calendar-header-button-container' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["ToolTip"],
                { flow: 'up', component: REFRESH_TOOLTIP },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["AsyncButton"],
                  { icon: 'refresh-2', iconAlignment: 'left', type: 'tertiary', promise: this.onRefreshClicked },
                  'Refresh Accounts'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["AsyncButton"],
                { type: 'danger', onClick: this.onDisconnectClicked },
                'Disconnect All'
              )
            )
          ),
          isLoadingUsers && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["TextLoader"], { className: 'settings-global-calendar--loader', text: 'Fetching your calendars...', size: 250 }),
          hasLoadedUsers && this.renderTable(calendarUsers)
        )
      );
    }
  }]);

  return GlobalConnectedCalendars;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchMicrosoftManagedCalendars: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["_0" /* fetchMicrosoftManagedCalendars */],
      disconnectMicrosoftAdminConsent: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["j" /* disconnectMicrosoftAdminConsent */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    globalCalendarUserIds: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["p" /* getMicrosoftAdminConsentUsers */])(state),
    isLoadingUsers: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["B" /* isMicrosoftGlobalCalendarsLoading */])(state),
    hasLoadedUsers: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["A" /* isMicrosoftGlobalCalendarsLoaded */])(state),
    orgUsers: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["nonBotUsers"])(state).toJS()
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(GlobalConnectedCalendars));

/***/ }),

/***/ "CoDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export createDimension */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMetric; });
/* unused harmony export MetricTimer */
/* unused harmony export getDateRangeDimension */
/* unused harmony export bucketMetric */
/* unused harmony export loadTimeBucketMetric */
/* unused harmony export chartLoadTimeBucketMetric */
/* unused harmony export socketMessageCountMetric */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reduxActionCount; });
/* unused harmony export sequenceEnrollCount */
/* unused harmony export playbookHomeLoaded */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var createDimension = function createDimension(value, key) {
  return key + '=' + value;
};

var createMetric = function createMetric(name, dimensions) {
  return name + ':' + _.map(_.pickBy(dimensions, _.negate(_.isUndefined)), createDimension).join(';');
};

var MetricTimer = function () {
  function MetricTimer() {
    _classCallCheck(this, MetricTimer);

    this._startTime = undefined;
    this._elapsedTime = 0;
  }

  _createClass(MetricTimer, [{
    key: 'start',
    value: function start() {
      this._startTime = Date.now();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (this._startTime) {
        this._elapsedTime = Date.now() - this._startTime;
      }
    }
  }, {
    key: 'getElapsedTime',
    value: function getElapsedTime() {
      return this._elapsedTime;
    }
  }], [{
    key: 'start',
    value: function start() {
      var timer = new MetricTimer();
      timer.start();
      return timer;
    }
  }]);

  return MetricTimer;
}();

var getDateRangeDimension = function getDateRangeDimension(startDate, endDate) {
  var daysDiff = endDate.diff(startDate, 'days');
  if (daysDiff <= 1) {
    return '1d';
  } else if (daysDiff <= 7) {
    return '7d';
  } else if (daysDiff > 7 && daysDiff <= 14) {
    return '14d';
  } else if (daysDiff > 14 && daysDiff <= 31) {
    return '30d';
  } else if (daysDiff > 31 && daysDiff <= 92) {
    return '90d';
  } else if (daysDiff > 92 && daysDiff <= 183) {
    return '6m';
  } else if (daysDiff > 183 && daysDiff <= 366) {
    return '1y';
  }
  return 'gt_1y';
};

var bucketMetric = function bucketMetric(bucketName, dimensions, value) {
  return {
    metric: createMetric(bucketName, _extends({}, dimensions, {
      app: 'customer-web'
    })),
    value: value,
    dimensions: {
      type: 'bucket',
      buckets: '1000, 5000, 10000, 15000, 30000, 60000'
    }
  };
};

var loadTimeBucketMetric = function loadTimeBucketMetric(bucketName, chart, view, startDate, endDate, duration) {
  return bucketMetric(bucketName, {
    chart: chart,
    view: view,
    date_range: getDateRangeDimension(startDate, endDate)
  }, duration);
};

var chartLoadTimeBucketMetric = function chartLoadTimeBucketMetric(chart, view, startDate, endDate, duration) {
  return loadTimeBucketMetric('chart.loadTime.buckets', chart, view, startDate, endDate, duration);
};

var socketMessageCountMetric = function socketMessageCountMetric(topic, count) {
  return {
    metric: 'socket-message-count',
    value: count,
    dimensions: {
      topic: topic,
      type: 'counter'
    }
  };
};

var reduxActionCount = function reduxActionCount(count) {
  return {
    metric: 'redux-action-count',
    value: count,
    dimensions: {
      type: 'counter'
    }
  };
};

var sequenceEnrollCount = function sequenceEnrollCount(playbookForEndUser) {
  return {
    metric: 'sequence-enroll:edited=' + (playbookForEndUser ? 'true' : 'false') + ';source=customer-web',
    value: 1,
    dimensions: {
      type: 'counter'
    }
  };
};

var playbookHomeLoaded = function playbookHomeLoaded() {
  var plan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'FREE';
  return {
    metric: 'playbook-home-visit:plan=' + plan,
    value: 1,
    dimensions: {
      type: 'counter'
    }
  };
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "CpSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APP_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return ZENDESK_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return IFRAMELY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return TINY_EDITOR_SCRIPT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SALESFORCE_AUTH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SALESFORCE_PAYLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return OUTREACH_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PIESYNC_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ELOQUA_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PARDOT_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DRIFT_DEV_INTEGRATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DRIFT_APP_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return LOGIN_APP_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CONVERSATION_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CUSTOMER_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return WIDGET_CACHE_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EVENT_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SENTRY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SENTRY_ENVIRONMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLIENT_ID; });
/* unused harmony export DEFAULT_CLIENT_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return ORG_PROFILE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PROFILE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return HUBSPOT_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SALESFORCE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SLACK_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SEGMENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SPLIT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DRIP_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return LINKEDIN_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GOOGLE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GOOGLE_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return MICROSOFT_CALENDAR_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return MICROSOFT_ADMIN_CONSENT_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return WORDPRESS_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SHOPIFY_INTEGRATION_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DRUPAL_PLUGIN_URL; });
/* unused harmony export FREE_SUPPORT_INBOX_ID */
/* unused harmony export PRESENCE_API_BASE */
/* unused harmony export PRESENCE_WSS_BASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MESSAGES_API_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MESSAGES_WSS_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return WS_CHAT_USE_SHARDS; });
/* unused harmony export WS_LIVE_USE_SHARDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return WS_CHAT_BASE; });
/* unused harmony export WS_LIVE_BASE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return WS_PUSH_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return WS_NUM_SHARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return WS_WSS_PROTOCOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return WS_API_PROTOCOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SEGMENT_TRACKING_BLACKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SALES_INBOX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SALES_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_CLIENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SEQUENCE_ENROLL_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHROME_EXTENSION_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SUPPORT_TICKET_INTERACTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return HAS_INTEGRATED_HELP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FREE_USER_INTEGRATED_HELP_INTERACTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PAID_USER_INTEGRATED_HELP_INTERACTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return HELP_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return METRICS_API_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DEVELOPERS_WEB_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DRIFT_VIDEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DRIFT_INSIDER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SIFTROCK_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTACTS_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONFIG_API; });
var ResourcesConstants = void 0;
if (__ENV__ === 'PRODUCTION') {
  // set production variables the app needs here
  ResourcesConstants = {
    LOGIN_APP_URL: 'https://start.drift.com',
    CONVERSATION_API: 'https://conversation.api.drift.com',
    CUSTOMER_API: 'https://customer.api.drift.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.drift.com',
    EVENT_API: 'https://event.api.drift.com',
    EMAIL_API: 'https://email.api.drift.com',
    SENTRY_KEY: 'https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073',
    SENTRY_ENVIRONMENT: 'production',
    CLIENT_ID: 'iVxHr9naeG4gMm',
    DEFAULT_CLIENT_ID: '1UDhLV0zBBVZo3',
    APP_URL: 'https://app.drift.com',
    API_URL: 'https://api.drift.com',
    ORG_PROFILE_DOMAIN: '.drift.com',
    PROFILE_DOMAIN: 'drift.me',
    HUBSPOT_CLIENT_ID: '85983271-b649-11e5-8278-55034748c042',
    SLACK_CLIENT_ID: '207155666705.19007622051',
    SEGMENT_ID: 'YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX',
    SPLIT_ID: 'sgqrbfcfvcomh9u28tb74rbp8ioriq1hi9em',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID: '3MVG9szVa2RxsqBZFCVv80STGhsUljVx0NU6Rbhd3XRpRDgLUHOPMrukSA5h8XTJQE58gWrOASyz1_5BKDgqm',
    ELOQUA_APP_ID: '7b9eb6eb-05fc-4fb1-bae9-7aac8807e5d8',
    PARDOT_APP_ID: '8792ea99-b42e-476f-aca3-dc2de106de41',
    DRIP_CLIENT_ID: '421340432347708342c81a2825bcc8fe7c202a67cffc37597fb92bc21acd9bff',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID: '87492603950-u124kma19e32jh963uc9s3vsuujpm53k.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '57aa99b9-8cd2-4c0e-9498-2d6749d33f3b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '57aa99b9-8cd2-4c0e-9498-2d6749d33f3b',
    WORDPRESS_CLIENT_ID: '49621',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.drift.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 21653, // assumes org 1
    PRESENCE_API_BASE: 'https://ws.api.drift.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.drift.com',
    MESSAGES_API_BASE: 'https://chat.api.drift.com',
    MESSAGES_WSS_BASE: 'wss://chat.api.drift.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.drift.com',
    WS_LIVE_BASE: 'live.api.drift.com',
    WS_PUSH_BASE: 'push.api.drift.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SALES_INBOX_ID: 44, // assumes org 1
    SALES_USER_ID: 46894, // assumes org 1
    SEGMENT_TRACKING_BLACKLIST: [42653],
    AUTH_CLIENT_ID: 'adMFuOx4OVWsZa',
    SEQUENCE_ENROLL_URL: 'https://app.drift.com/sequence-enroll-modal',
    HELP_URL: 'http://help.drift.com',
    METRICS_API_BASE: 'https://metrics.api.drift.com',
    HAS_INTEGRATED_HELP: true,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 54308,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 53556,
    SUPPORT_TICKET_INTERACTION_ID: 51833,
    INTEGRATION_INTERACTION_ID: 62594,
    DEVELOPERS_WEB_URL: "https://dev.drift.com",
    DRIFT_VIDEO_URL: "https://video.drift.com",
    CONTACTS_API: "https://contacts.api.drift.com",
    CONFIG_API: "https://static.drift.com/config",
    DRIFT_APP_DOMAIN: "drift.com"
  };
} else if (__ENV__ === 'MASTER') {
  ResourcesConstants = {
    LOGIN_APP_URL: 'https://start.driftqa.com',
    CONVERSATION_API: 'https://conversation2.api.driftqa.com',
    CUSTOMER_API: 'https://customer2.api.driftqa.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.driftqa.com',
    EVENT_API: 'https://event2.api.driftqa.com',
    EMAIL_API: 'https://email.api.driftqa.com',
    SENTRY_KEY: 'https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073',
    SENTRY_ENVIRONMENT: 'qa',
    CLIENT_ID: 'HcVEwgp9wDnDvd',
    DEFAULT_CLIENT_ID: 'W41NvthhICG4VC',
    APP_URL: 'https://app.driftqa.com',
    API_URL: 'https://api.driftqa.com',
    ORG_PROFILE_DOMAIN: '.driftqa.com',
    PROFILE_DOMAIN: 'driftqa.me',
    HUBSPOT_CLIENT_ID: 'deca04e8-ba11-11e5-a2bf-bd028721085c',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID: '3MVG9ROcrWLs7Uy.IfGSef7LAlZZI7K5B1xDWHzS8bDALn6HjimzYTitkVJKQnLvM6SYlrptGd1m7mvVPreSc',
    ELOQUA_APP_ID: 'bd860ed3-837c-4117-8d2d-ee69261c7c52',
    PARDOT_APP_ID: '19e929a2-4213-4745-b022-24fe2aec81fc',
    SLACK_CLIENT_ID: '2411874785.19011013270',
    SEGMENT_ID: '26F56Q24FYGhT79jXwkS3Ax002VxcoCN',
    SPLIT_ID: 'ncjqpiao38jfrada4mtntpt0emgilspe6tqo',
    DRIP_CLIENT_ID: '12f96245a2bf6246f6cde672e000f543d97973be5a0569557adb050eb1557d66',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID: '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    WORDPRESS_CLIENT_ID: '49620',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.driftqa.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 10617,
    PRESENCE_API_BASE: 'https://ws.api.driftqa.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.driftqa.com',
    MESSAGES_API_BASE: 'https://ws.api.driftqa.com',
    MESSAGES_WSS_BASE: 'wss://ws.api.driftqa.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.driftqa.com',
    WS_LIVE_BASE: 'live.api.driftqa.com',
    WS_PUSH_BASE: 'push.api.driftqa.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SEGMENT_TRACKING_BLACKLIST: [],
    AUTH_CLIENT_ID: '9nuLTG38lZhx6E',
    SEQUENCE_ENROLL_URL: 'https://app.driftqa.com/sequence-enroll-modal',
    SUPPORT_TICKET_INTERACTION_ID: 303381,
    METRICS_API_BASE: 'https://metrics.api.driftqa.com',
    HELP_URL: 'http://help.drift.com',
    HAS_INTEGRATED_HELP: false,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
    INTEGRATION_INTERACTION_ID: 304300,
    DEVELOPERS_WEB_URL: "https://dev.driftqa.com",
    DRIFT_VIDEO_URL: "https://app-qa.video.drift.com",
    CONTACTS_API: "https://contacts.api.driftqa.com",
    CONFIG_API: "https://static.driftqa.com/config",
    DRIFT_APP_DOMAIN: "driftqa.com"
    // Set whatever you want if you need to talk to other services.
  };
} else {
  ResourcesConstants = {
    LOGIN_APP_URL: 'https://start.driftqa.com',
    CONVERSATION_API: 'https://conversation2.api.driftqa.com',
    CUSTOMER_API: 'https://customer2.api.driftqa.com',
    WIDGET_CACHE_API: 'https://widget-cache.api.driftqa.com',
    EVENT_API: 'https://event2.api.driftqa.com',
    CLIENT_ID: 'HcVEwgp9wDnDvd',
    DEFAULT_CLIENT_ID: 'W41NvthhICG4VC',
    APP_URL: 'http://localhost:8005', //set to https://localhost to run on https://localhost
    API_URL: 'http://localhost:8005', //set to https://localhost to run on https://localhost
    ORG_PROFILE_DOMAIN: '.driftqa.com',
    PROFILE_DOMAIN: 'driftqa.me',
    HUBSPOT_CLIENT_ID: '4eedba23-b951-11e5-a2bf-bd028721085c',
    LINKEDIN_KEY: 'f4D5eGo195C5',
    SALESFORCE_CLIENT_ID: '3MVG9ROcrWLs7Uy.IfGSef7LAlZZI7K5B1xDWHzS8bDALn6HjimzYTitkVJKQnLvM6SYlrptGd1m7mvVPreSc',
    ELOQUA_APP_ID: 'bd860ed3-837c-4117-8d2d-ee69261c7c52',
    PARDOT_APP_ID: '19e929a2-4213-4745-b022-24fe2aec81fc',
    SLACK_CLIENT_ID: '2411874785.19011013270',
    SEGMENT_ID: '26F56Q24FYGhT79jXwkS3Ax002VxcoCN',
    SPLIT_ID: 'ncjqpiao38jfrada4mtntpt0emgilspe6tqo',
    DRIP_CLIENT_ID: '12f96245a2bf6246f6cde672e000f543d97973be5a0569557adb050eb1557d66',
    GOOGLE_API_KEY: 'AIzaSyCPuZY6GnyM06cW3r5x1f0ryQPuezi1rxg',
    GOOGLE_CLIENT_ID: '519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com',
    MICROSOFT_CALENDAR_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    MICROSOFT_ADMIN_CONSENT_CLIENT_ID: '14eeaf85-cfbb-45c6-84fb-0541d2121f9b',
    WORDPRESS_CLIENT_ID: '49619',
    SHOPIFY_INTEGRATION_URL: 'https://shopify-integration.driftqa.com',
    DRUPAL_PLUGIN_URL: 'https://www.drupal.org/project/drift',
    FREE_SUPPORT_INBOX_ID: 10617,
    PRESENCE_API_BASE: 'https://ws.api.driftqa.com',
    PRESENCE_WSS_BASE: 'wss://ws.api.driftqa.com',
    MESSAGES_API_BASE: 'https://ws.api.driftqa.com',
    MESSAGES_WSS_BASE: 'wss://ws.api.driftqa.com',
    WS_CHAT_USE_SHARDS: true,
    WS_LIVE_USE_SHARDS: true,
    WS_CHAT_BASE: 'chat.api.driftqa.com',
    WS_LIVE_BASE: 'live.api.driftqa.com',
    WS_PUSH_BASE: 'push.api.driftqa.com',
    WS_NUM_SHARDS: 50,
    WS_WSS_PROTOCOL: 'wss',
    WS_API_PROTOCOL: 'https',
    SEGMENT_TRACKING_BLACKLIST: [],
    AUTH_CLIENT_ID: 'HcVEwgp9wDnDvd',
    SEQUENCE_ENROLL_URL: 'https://app.driftqa.com/sequence-enroll-modal',
    SUPPORT_TICKET_INTERACTION_ID: 303381,
    METRICS_API_BASE: 'https://metrics.api.driftqa.com',
    HELP_URL: 'http://help.drift.com',
    HAS_INTEGRATED_HELP: false,
    FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
    PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
    INTEGRATION_INTERACTION_ID: 304300,
    DEVELOPERS_WEB_URL: "https://dev.driftqa.com",
    DRIFT_VIDEO_URL: "https://localhost:8000",
    CONTACTS_API: "https://contacts.api.driftqa.com",
    CONFIG_API: "https://static.driftqa.com/config",
    DRIFT_APP_DOMAIN: "driftqa.com"
  };
}

var APP_TITLE = 'Drift';
var ZENDESK_CLIENT_ID = 'drift-faq';
var IFRAMELY_KEY = 'f0f2cc6ba50c77794e5c5eb2930f3fd5';
var TINY_EDITOR_SCRIPT_URL = 'https://cdn.tiny.cloud/1/nozb66xx8bd4ng55xzewb7obn09fln14zbh0rjyi4ip3rbf7/tinymce/stable/tinymce.min.js';
var SALESFORCE_AUTH_URL = 'https://login.salesforce.com/services/oauth2/authorize';
var SALESFORCE_PAYLOAD = {
  client_id: ResourcesConstants.SALESFORCE_CLIENT_ID,
  response_type: 'code',
  redirect_uri: ResourcesConstants.APP_URL + '/accept-integration/salesforce'
};

var OUTREACH_CLIENT_ID = "08745ef78bd1fbe782f7b8317fd988201da78385ac3761d2dfe2d33a566f7c22";
var PIESYNC_APP_ID = "ace8bfec-1fd2-4372-ba33-5792ce72e5af";

var ELOQUA_APP_ID = ResourcesConstants.ELOQUA_APP_ID;
var PARDOT_APP_ID = ResourcesConstants.PARDOT_APP_ID;
// Drift made integrations on the developer platform (integration titles).
var DRIFT_DEV_INTEGRATIONS = new Set(["Eloqua", "Pardot", "PieSync"]);

var DRIFT_APP_DOMAIN = ResourcesConstants.DRIFT_APP_DOMAIN;
var LOGIN_APP_URL = ResourcesConstants.LOGIN_APP_URL;
var CONVERSATION_API = ResourcesConstants.CONVERSATION_API;
var CUSTOMER_API = ResourcesConstants.CUSTOMER_API;
var WIDGET_CACHE_API = ResourcesConstants.WIDGET_CACHE_API;
var EVENT_API = ResourcesConstants.EVENT_API;
var SENTRY_KEY = ResourcesConstants.SENTRY_KEY;
var SENTRY_ENVIRONMENT = ResourcesConstants.SENTRY_ENVIRONMENT;
var CLIENT_ID = ResourcesConstants.CLIENT_ID;
var DEFAULT_CLIENT_ID = ResourcesConstants.DEFAULT_CLIENT_ID;
var APP_URL = ResourcesConstants.APP_URL;
var API_URL = ResourcesConstants.API_URL;
var ORG_PROFILE_DOMAIN = ResourcesConstants.ORG_PROFILE_DOMAIN;
var PROFILE_DOMAIN = ResourcesConstants.PROFILE_DOMAIN;
var HUBSPOT_CLIENT_ID = ResourcesConstants.HUBSPOT_CLIENT_ID;
var SALESFORCE_CLIENT_ID = ResourcesConstants.SALESFORCE_CLIENT_ID;
var SLACK_CLIENT_ID = ResourcesConstants.SLACK_CLIENT_ID;
var SEGMENT_ID = ResourcesConstants.SEGMENT_ID;
var SPLIT_ID = ResourcesConstants.SPLIT_ID;
var DRIP_CLIENT_ID = ResourcesConstants.DRIP_CLIENT_ID;
var LINKEDIN_KEY = ResourcesConstants.LINKEDIN_KEY;
var GOOGLE_API_KEY = ResourcesConstants.GOOGLE_API_KEY;
var GOOGLE_CLIENT_ID = ResourcesConstants.GOOGLE_CLIENT_ID;
var MICROSOFT_CALENDAR_CLIENT_ID = ResourcesConstants.MICROSOFT_CALENDAR_CLIENT_ID;
var MICROSOFT_ADMIN_CONSENT_CLIENT_ID = ResourcesConstants.MICROSOFT_ADMIN_CONSENT_CLIENT_ID;
var WORDPRESS_CLIENT_ID = ResourcesConstants.WORDPRESS_CLIENT_ID;
var SHOPIFY_INTEGRATION_URL = ResourcesConstants.SHOPIFY_INTEGRATION_URL;
var DRUPAL_PLUGIN_URL = ResourcesConstants.DRUPAL_PLUGIN_URL;
var FREE_SUPPORT_INBOX_ID = ResourcesConstants.FREE_SUPPORT_INBOX_ID;
var PRESENCE_API_BASE = ResourcesConstants.PRESENCE_API_BASE;
var PRESENCE_WSS_BASE = ResourcesConstants.PRESENCE_WSS_BASE;
var MESSAGES_API_BASE = ResourcesConstants.MESSAGES_API_BASE;
var MESSAGES_WSS_BASE = ResourcesConstants.MESSAGES_WSS_BASE;

var WS_CHAT_USE_SHARDS = ResourcesConstants.WS_CHAT_USE_SHARDS;
var WS_LIVE_USE_SHARDS = ResourcesConstants.WS_LIVE_USE_SHARDS;
var WS_CHAT_BASE = ResourcesConstants.WS_CHAT_BASE;
var WS_LIVE_BASE = ResourcesConstants.WS_LIVE_BASE;
var WS_PUSH_BASE = ResourcesConstants.WS_PUSH_BASE;
var WS_NUM_SHARDS = ResourcesConstants.WS_NUM_SHARDS;
var WS_WSS_PROTOCOL = ResourcesConstants.WS_WSS_PROTOCOL;
var WS_API_PROTOCOL = ResourcesConstants.WS_API_PROTOCOL;

var SEGMENT_TRACKING_BLACKLIST = ResourcesConstants.SEGMENT_TRACKING_BLACKLIST;

var SALES_INBOX_ID = ResourcesConstants.SALES_INBOX_ID || false;
var SALES_USER_ID = ResourcesConstants.SALES_USER_ID || false;

var AUTH_CLIENT_ID = ResourcesConstants.AUTH_CLIENT_ID;

var SEQUENCE_ENROLL_URL = ResourcesConstants.SEQUENCE_ENROLL_URL;

var CHROME_EXTENSION_LINK = "https://chrome.google.com/webstore/detail/drift/obpicmhmbfddhkcbiapfeginbafnjmmm";

var SUPPORT_TICKET_INTERACTION_ID = ResourcesConstants.SUPPORT_TICKET_INTERACTION_ID;
var HAS_INTEGRATED_HELP = ResourcesConstants.HAS_INTEGRATED_HELP;
var FREE_USER_INTEGRATED_HELP_INTERACTION_ID = ResourcesConstants.FREE_USER_INTEGRATED_HELP_INTERACTION_ID;
var PAID_USER_INTEGRATED_HELP_INTERACTION_ID = ResourcesConstants.PAID_USER_INTEGRATED_HELP_INTERACTION_ID;

var HELP_URL = ResourcesConstants.HELP_URL;

var METRICS_API_BASE = ResourcesConstants.METRICS_API_BASE;

var DEVELOPERS_WEB_URL = ResourcesConstants.DEVELOPERS_WEB_URL;
var DRIFT_VIDEO_URL = ResourcesConstants.DRIFT_VIDEO_URL;
var DRIFT_INSIDER_URL = "https://insider.drift.com/login/";
var SIFTROCK_URL = "https://app.siftrock.com/";

var CONTACTS_API = ResourcesConstants.CONTACTS_API;

var CONFIG_API = ResourcesConstants.CONFIG_API;

/***/ }),

/***/ "Cr9k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usersAndProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_constants__ = __webpack_require__("aJZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__);






var usersAndProperties = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__["orgUsersById"], __WEBPACK_IMPORTED_MODULE_3_app_modules_user_properties_selectors__["i" /* usersByPropertyName */]], function (usersById, usersByPropertyName) {
  return usersById.valueSeq().filter(function (user) {
    return user.status !== __WEBPACK_IMPORTED_MODULE_2_app_modules_user_constants__["_9" /* UserStatus */].ARCHIVED;
  }).filter(function (user) {
    return !user.bot;
  }).map(function (user) {
    return {
      user: user,
      installed: !!usersByPropertyName.getIn(['extensionInstalled', user.id, 'value']),
      invited: !!usersByPropertyName.getIn(['extensionInvited', user.id, 'value'])
    };
  }).sortBy(function (_ref) {
    var user = _ref.user;
    return Object(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user);
  }).toArray();
});

/***/ }),

/***/ "Ctet":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/magnifying-glass.bc712f85.svg";

/***/ }),

/***/ "CwoY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CyFg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_SendMessageButton__ = __webpack_require__("e1hw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_PresenceIndicator__ = __webpack_require__("fMSb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_customer_EnrollButton__ = __webpack_require__("m9HF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_DriftModal__ = __webpack_require__("xyae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_enduser_following_svg__ = __webpack_require__("Lb/h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_enduser_following_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_enduser_following_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_enduser_follow_svg__ = __webpack_require__("5pXZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_enduser_follow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_enduser_follow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_profile_svg__ = __webpack_require__("AYv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_profile_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_profile_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var Information = function (_Component) {
  _inherits(Information, _Component);

  function Information() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Information);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Information.__proto__ || Object.getPrototypeOf(Information)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      unsubscribeModalVisible: false
    }, _this.handleFollowClick = function () {
      var _this$props = _this.props,
          endUser = _this$props.endUser,
          actions = _this$props.actions,
          following = _this$props.following;

      actions.updateFollowing({ id: endUser.id, following: !following });
    }, _this.handleUnenrollClick = function () {
      _this.props.actions.unenroll({ endUserId: _this.props.endUser.id });
    }, _this.toggleUnsubscribeModal = function () {
      _this.setState({ unsubscribeModalVisible: !_this.state.unsubscribeModalVisible });
    }, _this.handleUnsubscribeClick = function () {
      _this.props.actions.unsubscribe({ email: _this.props.endUser.email });
      _this.toggleUnsubscribeModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Information, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.endUser.email) {
        this.props.actions.checkUnsubscribed({ email: this.props.endUser.email });
        this.props.actions.fetchEnrolledPlaybookId({ email: this.props.endUser.email });
      }
      this.props.actions.fetchFollowing({ id: this.props.endUser.id });
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      return typeof this.props.following === 'undefined';
    }
  }, {
    key: 'getFollowButtonText',
    value: function getFollowButtonText() {
      var following = this.props.following;

      if (this.isLoading()) return '...';
      if (following) return 'Following';
      return 'Follow';
    }
  }, {
    key: 'renderFollowButton',
    value: function renderFollowButton() {
      if (!__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('has_following')) return;

      var _props = this.props,
          isPremiumTeam = _props.isPremiumTeam,
          showTooltip = _props.showTooltip,
          showProfileLink = _props.showProfileLink,
          following = _props.following;

      var loading = this.isLoading();

      var sharedProps = {
        style: showProfileLink ? { width: '48%', position: 'relative' } : { marginTop: 10, width: '100%', position: 'relative' },
        tooltip: showTooltip ? 'Follow users to be notified when they’re live on your site.' : undefined,
        flow: 'down',
        class: 'drift-button'
      };

      var children = [!loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { key: 'follow-icon', src: following ? __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_enduser_following_svg___default.a : __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_enduser_follow_svg___default.a }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { key: 'follow-text' },
        this.getFollowButtonText()
      )];

      if (isPremiumTeam) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          _extends({ is: true }, sharedProps, { onClick: !loading && this.handleFollowClick }),
          children
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
          _extends({ is: true }, sharedProps, { to: '/live' }),
          children
        );
      }
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _props2 = this.props,
          inboxId = _props2.inboxId,
          showProfileLink = _props2.showProfileLink,
          endUser = _props2.endUser,
          enrolledPlaybookId = _props2.enrolledPlaybookId,
          playbookList = _props2.playbookList,
          unsubscribed = _props2.unsubscribed;

      var enrolledPlaybook = playbookList.find(function (_ref2) {
        var id = _ref2.id;
        return id === enrolledPlaybookId;
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { padding: '20px 0px 5px' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_SendMessageButton__["a" /* default */], { endUserId: endUser.id, inboxId: inboxId, disabled: !inboxId }),
        !showProfileLink && !!endUser.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_customer_EnrollButton__["a" /* default */], {
          emails: [endUser.email],
          style: {
            marginTop: 10,
            width: '100%'
          }
        }),
        !!endUser.email && !showProfileLink && enrolledPlaybookId && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.handleUnenrollClick,
            className: 'drift-button',
            style: {
              marginTop: 10,
              width: '100%'
            }
          },
          'Unenroll from ',
          enrolledPlaybook && enrolledPlaybook.name
        ),
        !!endUser.email && !showProfileLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: this.toggleUnsubscribeModal,
            className: 'drift-button',
            style: {
              marginTop: 10,
              width: '100%'
            },
            disabled: unsubscribed
          },
          unsubscribed ? 'Unsubscribed' : 'Unsubscribe'
        ),
        showProfileLink ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-space-between', style: { marginTop: 10 } },
          this.renderFollowButton(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
            {
              to: '/contacts/details/' + endUser.id,
              className: 'drift-button',
              style: { width: '48%' },
              target: '_self'
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_profile_svg___default.a }),
            'Profile'
          )
        ) : this.renderFollowButton(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_14_components_shared_DriftModal__["a" /* default */],
          {
            isOpen: this.state.unsubscribeModalVisible,
            onRequestClose: this.toggleUnsubscribeModal,
            primaryCTA: 'Unsubscribe',
            secondaryCTA: 'Cancel',
            onPrimaryClick: this.handleUnsubscribeClick,
            isDanger: true,
            onSecondaryClick: this.toggleUnsubscribeModal,
            title: 'Unsubscribing a contact is permanent'
          },
          'Are you sure you want to unsubscribe?'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          name = _props3.name,
          endUser = _props3.endUser,
          employmentTitle = _props3.employmentTitle,
          editable = _props3.editable,
          handleEdit = _props3.handleEdit;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '5px 0px 0 100px', height: '50px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'dsg-h3 ' + (name ? 'color-black' : 'color-navy') + ' truncate',
              onClick: !name && editable && handleEdit
            },
            name || (editable ? 'Add Name' : 'Site Visitor')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'flex dsg-Regular ' + (employmentTitle ? 'color-navy-dark' : 'color-navy') + ' truncate',
              onClick: editable && !employmentTitle && handleEdit
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_shared_PresenceIndicator__["a" /* default */], { endUser: endUser })
          )
        ),
        this.renderButtons()
      );
    }
  }]);

  return Information;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Information.defaultProps = {
  showProfileLink: false,
  showTooltip: false
};


var makeMapStateToProps = function makeMapStateToProps() {
  return function (state, props) {
    return {
      hasPresence: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["u" /* makeHasGate */])('has_presence')(state),
      isPremiumTeam: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["u" /* makeHasGate */])('premium_team')(state),
      enrolledPlaybookId: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["T" /* getEnrolledPlaybookId */](state),
      playbookList: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_63" /* playbookList */](state),
      following: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["b" /* followingId */](props.endUser.id)(state),
      unsubscribed: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["r" /* unsubscribed */](state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      fetchFollowing: __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_actions__["s" /* fetchFollowing */],
      updateFollowing: __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_actions__["_7" /* updateFollowing */],
      fetchEnrolledPlaybookId: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["_9" /* fetchEnrolledPlaybookId */],
      unenroll: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_actions__["_242" /* unenroll */],
      checkUnsubscribed: __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_actions__["a" /* checkUnsubscribed */],
      unsubscribe: __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_actions__["T" /* unsubscribe */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(Information));

/***/ }),

/***/ "CyMx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cyhm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNTkgMjEuODdjLS4yNTggMC0uNTE4LS4wODgtLjc3NC0uMjYzbC01LjgzNC00LS4xMjMuMDEtNS44MiAzLjk5Yy0uNTkuNDAzLTEuMjYyLjMxNC0xLjYxMi0uMTUtLjE1OC0uMjEtLjMxMy0uNTczLS4xNTctMS4xMjVsMS43NjItNi4yMzhjLjAxLS4wNjUtLjAyOC0uMjItLjA3Mi0uMjcyTC40MjcgOS4yMDFDLjA1IDguODE1LS4wOCA4LjMyLjA4MiA3Ljg4Yy4xNi0uNDQyLjU3Ny0uNzM1IDEuMTE0LS43ODRsNi0uNTYyYy4wNTctLjAxLjE4Mi0uMTAzLjIxMy0uMTZMOS44Mi44MUMxMC4wMzcuMyAxMC40NSAwIDEwLjkyNyAwYy40NzUgMCAuODkuMzA0IDEuMTA4LjgxM2wyLjQxMiA1LjU3Yy4wMy4wNTIuMTU0LjE0Mi4yMTcuMTU0bDUuOTk2LjU2Yy41NC4wNS45NTQuMzQ1IDEuMTE0Ljc4Ni4xNi40NC4wMy45MzMtLjM0NyAxLjMxOGwtNC41MzUgNC42MjNjLS4wNC4wNS0uMDguMjA2LS4wNjcuMjcybDEuNzYgNi4yMzdjLjE1NS41NTIgMCAuOTE2LS4xNTggMS4xMjUtLjE5OC4yNjItLjUwMy40MTQtLjgzOC40MTR6bS02LjY2My02LjA4N2MuMzk4IDAgLjc4My4xMTUgMS4wODMuMzIzbDQuMzI4IDIuOTY1LTEuMjY0LTQuNDhjLS4xOTYtLjY3OC4wMjQtMS41NC41MjItMi4wNDVsMy42NzctMy43NDgtNC43ODMtLjQ0N2MtLjcxMi0uMDY3LTEuNDMtLjU5LTEuNzEyLTEuMjQ1bC0xLjg1LTQuMjc0TDkuMDc0IDcuMTFjLS4yODQuNjUzLTEgMS4xNzUtMS43MSAxLjI0MmwtNC43ODIuNDQ4IDMuNjc3IDMuNzQ4Yy40OTcuNTA1LjcxNyAxLjM2Ni41MiAyLjA0N0w1LjUxOCAxOS4wN2w0LjMyOC0yLjk2NWMuMy0uMjA3LjY4NC0uMzIyIDEuMDgyLS4zMjJ6IiBmaWxsPSIjNzY5NUE1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "D+Oo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(452);

/***/ }),

/***/ "D+mY":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 47 47\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M23.5 47C10.5426875 47 0 36.4587812 0 23.5 0 10.5426875 10.5426875 0 23.5 0S47 10.5426875 47 23.5C47 36.4587812 36.4573125 47 23.5 47z\" fill=\"#13CB6E\"></path><path d=\"M36.8888345 19.4597176c.8975502-.904472.8911261-2.3655929-.0136539-3.2634485-.9042981-.8996854-2.3686495-.8932502-3.2652449.0148992L20.546911 29.3720529l-7.3015299-6.2076576c-.973981-.8262689-2.4289171-.707877-3.25457697.2653869-.82534862.9682825-.70671624 2.426889.26388377 3.251899l8.9387576 7.5992658c.4192319.3587066.9497015.5494101 1.495367.5494101.6109137 0 1.2020114-.2418126 1.6393127-.6836222l14.5607093-14.6870173z\" fill=\"#FFF\"></path></g></svg>"

/***/ }),

/***/ "D1sA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest__ = __webpack_require__("3nRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_async_script_loader__ = __webpack_require__("Jzd5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_async_script_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_async_script_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






__webpack_require__("knub");

var LocationSearch = function (_Component) {
  _inherits(LocationSearch, _Component);

  function LocationSearch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocationSearch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocationSearch.__proto__ || Object.getPrototypeOf(LocationSearch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ready: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocationSearch, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var isScriptLoaded = _ref2.isScriptLoaded,
          isScriptLoadSucceed = _ref2.isScriptLoadSucceed;

      if (isScriptLoaded && !this.props.isScriptLoaded) {
        // load finished
        if (isScriptLoadSucceed) {
          this.setState({ ready: true });
        }
        // Else I dunno bro shit is broken that is what else
        else {}
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.state.ready ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_geosuggest___default.a, _extends({}, this.props, {
        onChange: function onChange(label) {
          if (label === '') {
            _this2.props.selectDefault();
          }
        }
      })) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return LocationSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_async_script_loader___default()('https://maps.googleapis.com/maps/api/js?key=' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["u" /* GOOGLE_API_KEY */] + '&libraries=places')(LocationSearch));

/***/ }),

/***/ "D3Al":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("lV/k");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("ujHX");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "D4+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component__ = __webpack_require__("gFEw");















var mapStateToProps = function mapStateToProps(state) {
  return {
    org: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__["org"](state),
    targetingConditionsCount: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_10" /* getNumConditions */](state),
    firstCondition: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["W" /* getFirstCondition */](state),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      addConditionSet: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["d" /* addConditionSet */],
      addCondition: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["c" /* addCondition */],
      resetDisplayConditions: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_105" /* resetDisplayConditions */],
      setConditionValue: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_143" /* setConditionValue */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["i" /* withProps */])(function (props) {
  return {
    alwaysSelected: props.targetingConditionsCount === 0,
    displayTargetingSelected: props.targetingConditionsCount > 0 && !props.isOnFreePlan,
    displayOnlineSelected: props.isOnFreePlan && !!props.firstCondition && !!props.firstCondition.value,
    displayOfflineSelected: props.isOnFreePlan && !!props.firstCondition && !props.firstCondition.value
  };
}), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["h" /* withHandlers */])({
  onAlwaysClick: function onAlwaysClick(props) {
    return function () {
      if (props.targetingConditionsCount > 1 && confirm('Are you sure you want to set to Always? This will delete ' + props.targetingConditionsCount + ' targeting ' + Object(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__["pluralize"])(props.targetingConditionsCount, 'condition') + '.')) {
        props.actions.resetDisplayConditions();
      } else if (props.targetingConditionsCount === 1) {
        // just delete if only one...
        props.actions.resetDisplayConditions();
      }
    };
  },
  onDisplayClick: function onDisplayClick(props) {
    return function () {
      var conditionSetId = Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])();
      if (props.targetingConditionsCount === 0 && !!props.org.properties.verificationUrl) {
        props.actions.addConditionSet({
          conditionSet: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["c" /* ConditionSet */]({
            id: conditionSetId
          })
        });
        var defaultUrl = props.org.properties.verificationUrl;
        props.actions.addCondition({
          conditionSetId: conditionSetId,
          condition: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["b" /* Condition */]({
            id: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])(),
            value: __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of(defaultUrl)
          })
        });
      }
      props.router.replace('/playbooks/' + props.params.playbookId + '/edit/targeting/displaywhen');
    };
  },
  onDisplayOnlineClick: function onDisplayOnlineClick(props) {
    return function () {
      if (!props.firstCondition) {
        var conditionSetId = Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])();
        props.actions.addConditionSet({
          conditionSet: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["c" /* ConditionSet */]({
            id: conditionSetId
          })
        });
        props.actions.addCondition({
          conditionSetId: conditionSetId,
          condition: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["b" /* Condition */]({
            id: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])(),
            value: true,
            field: 'online',
            operator: 'is'
          })
        });
      } else {
        props.actions.setConditionValue({ id: props.firstCondition.id, value: true });
      }
    };
  },
  onDisplayOfflineClick: function onDisplayOfflineClick(props) {
    return function () {
      if (!props.firstCondition) {
        var conditionSetId = Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])();
        props.actions.addConditionSet({
          conditionSet: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["c" /* ConditionSet */]({
            id: conditionSetId
          })
        });
        props.actions.addCondition({
          conditionSetId: conditionSetId,
          condition: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_models__["b" /* Condition */]({
            id: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_helpers__["a" /* weakUuid */])(),
            value: false,
            field: 'online',
            operator: 'is'
          })
        });
      } else {
        props.actions.setConditionValue({ id: props.firstCondition.id, value: false });
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_11__component__["a" /* default */]));

/***/ }),

/***/ "D4Fr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__ = __webpack_require__("mrzB");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LocaleActions = function (_Marty$ActionCreators) {
  _inherits(LocaleActions, _Marty$ActionCreators);

  function LocaleActions() {
    _classCallCheck(this, LocaleActions);

    return _possibleConstructorReturn(this, (LocaleActions.__proto__ || Object.getPrototypeOf(LocaleActions)).apply(this, arguments));
  }

  _createClass(LocaleActions, [{
    key: 'loadLocale',
    value: function loadLocale(locale) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (!Intl) {
          switch (locale) {
            case 'en':
              __webpack_require__.e/* require.ensure */(0).then((function (require) {
                __webpack_require__("OYzX");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TCl6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'es':
              __webpack_require__.e/* require.ensure */(28).then((function (require) {
                __webpack_require__("fZXc");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("oCUd"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'et':
              __webpack_require__.e/* require.ensure */(27).then((function (require) {
                __webpack_require__("7FjG");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("4yqw"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'de':
            case 'de-DE':
            case 'de-DE-formal':
              __webpack_require__.e/* require.ensure */(29).then((function (require) {
                __webpack_require__("6suA");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("DaKT"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hi':
              __webpack_require__.e/* require.ensure */(24).then((function (require) {
                __webpack_require__("OPEv");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("fcUk"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'nl':
              __webpack_require__.e/* require.ensure */(15).then((function (require) {
                __webpack_require__("Gcr4");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("zr8v"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'pt':
            case 'pt-PT':
            case 'pt-BR':
              __webpack_require__.e/* require.ensure */(13).then((function (require) {
                __webpack_require__("QYvX");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("jJow"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sv':
              __webpack_require__.e/* require.ensure */(8).then((function (require) {
                __webpack_require__("eCwI");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("daoM"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'zh':
              __webpack_require__.e/* require.ensure */(4).then((function (require) {
                __webpack_require__("Xs6E");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("BDH0"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'fr':
              __webpack_require__.e/* require.ensure */(25).then((function (require) {
                __webpack_require__("6gIW");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("xWUK"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'it':
              __webpack_require__.e/* require.ensure */(20).then((function (require) {
                __webpack_require__("sGoT");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Ah8R"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'tr':
              __webpack_require__.e/* require.ensure */(6).then((function (require) {
                __webpack_require__("kDAr");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("dYTe"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ru':
              __webpack_require__.e/* require.ensure */(11).then((function (require) {
                __webpack_require__("5YWx");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("uGy5"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'pl':
              __webpack_require__.e/* require.ensure */(14).then((function (require) {
                __webpack_require__("ZFhO");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Nqtf"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sl':
              __webpack_require__.e/* require.ensure */(10).then((function (require) {
                __webpack_require__("OGCP");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("0mLK"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'da':
              __webpack_require__.e/* require.ensure */(30).then((function (require) {
                __webpack_require__("oabk");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("VDeJ"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'fi':
              __webpack_require__.e/* require.ensure */(26).then((function (require) {
                __webpack_require__("sihT");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("BbZh"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hr':
              __webpack_require__.e/* require.ensure */(23).then((function (require) {
                __webpack_require__("0PFA");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("hCq6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ko':
              __webpack_require__.e/* require.ensure */(17).then((function (require) {
                __webpack_require__("W4YR");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("vPOC"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'nb':
              __webpack_require__.e/* require.ensure */(16).then((function (require) {
                __webpack_require__("Db1h");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("lM+A"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ro':
              __webpack_require__.e/* require.ensure */(12).then((function (require) {
                __webpack_require__("EkaT");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Nl11"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sr':
              __webpack_require__.e/* require.ensure */(9).then((function (require) {
                __webpack_require__("oVcQ");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("5sN8"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'th':
              __webpack_require__.e/* require.ensure */(7).then((function (require) {
                __webpack_require__("3pU1");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TpfL"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'vi':
              __webpack_require__.e/* require.ensure */(5).then((function (require) {
                __webpack_require__("uwnx");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("U3g9"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hu':
              __webpack_require__.e/* require.ensure */(22).then((function (require) {
                __webpack_require__("k1oR");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("gN8K"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'is':
              __webpack_require__.e/* require.ensure */(21).then((function (require) {
                __webpack_require__("p69C");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("0yeX"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ja':
              __webpack_require__.e/* require.ensure */(19).then((function (require) {
                __webpack_require__("TZgD");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("g7Yk"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ka':
              __webpack_require__.e/* require.ensure */(18).then((function (require) {
                __webpack_require__("JLkx");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Glu3"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            default:
              __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
                __webpack_require__("OYzX");
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TCl6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
          }
        } else {
          switch (locale) {
            case 'en':
              __webpack_require__.e/* require.ensure */(1).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TCl6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'es':
              __webpack_require__.e/* require.ensure */(56).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("oCUd"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'et':
              __webpack_require__.e/* require.ensure */(55).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("4yqw"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'de':
            case 'de-DE':
            case 'de-DE-formal':
              __webpack_require__.e/* require.ensure */(57).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("DaKT"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hi':
              __webpack_require__.e/* require.ensure */(52).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("fcUk"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'nl':
              __webpack_require__.e/* require.ensure */(43).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("zr8v"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'pt':
            case 'pt-PT':
            case 'pt-BR':
              __webpack_require__.e/* require.ensure */(41).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("jJow"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sv':
              __webpack_require__.e/* require.ensure */(36).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("daoM"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'zh':
              __webpack_require__.e/* require.ensure */(32).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("BDH0"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'fr':
              __webpack_require__.e/* require.ensure */(53).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("xWUK"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'it':
              __webpack_require__.e/* require.ensure */(48).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Ah8R"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'tr':
              __webpack_require__.e/* require.ensure */(34).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("dYTe"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ru':
              __webpack_require__.e/* require.ensure */(39).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("uGy5"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'pl':
              __webpack_require__.e/* require.ensure */(42).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Nqtf"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sl':
              __webpack_require__.e/* require.ensure */(38).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("0mLK"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'da':
              __webpack_require__.e/* require.ensure */(58).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("VDeJ"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'fi':
              __webpack_require__.e/* require.ensure */(54).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("BbZh"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hr':
              __webpack_require__.e/* require.ensure */(51).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("hCq6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ko':
              __webpack_require__.e/* require.ensure */(45).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("vPOC"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'nb':
              __webpack_require__.e/* require.ensure */(44).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("lM+A"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ro':
              __webpack_require__.e/* require.ensure */(40).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Nl11"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'sr':
              __webpack_require__.e/* require.ensure */(37).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("5sN8"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'th':
              __webpack_require__.e/* require.ensure */(35).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TpfL"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'vi':
              __webpack_require__.e/* require.ensure */(33).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("U3g9"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'hu':
              __webpack_require__.e/* require.ensure */(50).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("gN8K"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'is':
              __webpack_require__.e/* require.ensure */(49).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("0yeX"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ja':
              __webpack_require__.e/* require.ensure */(47).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("g7Yk"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            case 'ka':
              __webpack_require__.e/* require.ensure */(46).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("Glu3"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
            default:
              __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
                Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* addLocaleData */])([].concat(_toConsumableArray(__webpack_require__("TCl6"))));
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED, locale);
                resolve();
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
              break;
          }
        }
      });
    }
  }]);

  return LocaleActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (LocaleActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "D5Pz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SettingsPageTitle":"SettingsPageTitle---3Q6BG"};

/***/ }),

/***/ "D5er":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




function getAvailabilityFromEmbed(embed) {
  var openHours = embed.configuration.theme.openHours;

  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(openHours).map(function (hours) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_components_Customize_Availability_Constants__["f" /* Hours */])({
      opens: hours.get('opens'),
      closes: hours.get('closes'),
      dayOfWeek: hours.get('dayOfWeek')
    });
  });
}

var AvailabilityStore = function (_Marty$Store) {
  _inherits(AvailabilityStore, _Marty$Store);

  function AvailabilityStore(options) {
    _classCallCheck(this, AvailabilityStore);

    var _this = _possibleConstructorReturn(this, (AvailabilityStore.__proto__ || Object.getPrototypeOf(AvailabilityStore)).call(this, options));

    _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
    return _this;
  }

  _createClass(AvailabilityStore, [{
    key: 'getAvailability',
    value: function getAvailability() {
      return this.fetch({
        id: 'getAvailability',
        dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg(), this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed()],
        locally: function locally() {
          var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
          var embed = this.app.stores.DefaultEmbedStore.state.embedByOrgId[orgId];
          return getAvailabilityFromEmbed(embed);
        }
      });
    }
  }]);

  return AvailabilityStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (AvailabilityStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "D6+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InlineEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server__ = __webpack_require__("pqdH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom_server__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

__webpack_require__("wy6Z");
__webpack_require__("KuRs");




var BOLD_ICON = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 8, height: 12 },
  element: 'div',
  src: __webpack_require__("jzIA")
}));
var ITALIC_OPTION = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 7, height: 12 },
  element: 'div',
  src: __webpack_require__("hjbO")
}));
var UNDERLINE_ICON = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 9, height: 12 },
  element: 'div',
  src: __webpack_require__("NOHI")
}));

var ANCHOR_ICON = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 12.5, height: 12.5 },
  element: 'div',
  src: __webpack_require__("7OAZ")
}));

var QUOTE_ICON = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 12, height: 11 },
  element: 'div',
  src: __webpack_require__("Rbbe")
}));

var CHECK_MARK = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 11, height: 8.5 },
  element: 'div',
  src: __webpack_require__("UAZS")
}));

var CROSS = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 10, height: 10 },
  element: 'div',
  src: __webpack_require__("8B31")
}));

var PLAYER_ICON = __WEBPACK_IMPORTED_MODULE_1_react_dom_server___default.a.renderToString(React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
  style: { width: 12, height: 10 },
  element: 'div',
  src: __webpack_require__("2JjV")
}));

var buttonsForSavedReply = [{ name: 'bold', contentDefault: BOLD_ICON }, { name: 'italic', contentDefault: ITALIC_OPTION }, {
  name: 'anchor',
  placeholderText: 'URL',
  contentDefault: ANCHOR_ICON,
  formSaveLabel: CHECK_MARK,
  formCloseLabel: CROSS,
  linkValidation: true
}];

var defaultButtons = [{ name: 'bold', contentDefault: BOLD_ICON }, { name: 'italic', contentDefault: ITALIC_OPTION }, { name: 'underline', contentDefault: UNDERLINE_ICON }, {
  name: 'anchor',
  placeholderText: 'URL',
  contentDefault: ANCHOR_ICON,
  formSaveLabel: CHECK_MARK,
  formCloseLabel: CROSS,
  linkValidation: true
}, { name: 'quote', contentDefault: QUOTE_ICON }];

var DEFAULT_OPTIONS = function DEFAULT_OPTIONS(isSavedReplyEditor) {
  return {
    autoLink: false,
    targetBlank: true,
    extensions: {},
    toolbar: {
      buttons: isSavedReplyEditor ? buttonsForSavedReply : defaultButtons
    }
  };
};

var InlineEditor = function (_React$Component) {
  _inherits(InlineEditor, _React$Component);

  function InlineEditor(props) {
    _classCallCheck(this, InlineEditor);

    var _this = _possibleConstructorReturn(this, (InlineEditor.__proto__ || Object.getPrototypeOf(InlineEditor)).call(this, props));

    _this.state = { text: props.text };
    return _this;
  }

  _createClass(InlineEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      __webpack_require__.e/* require.ensure */(3).then((function (require) {/* WEBPACK VAR INJECTION */(function(_) {
        // TODO Temp hack, should really cancel this callback on componentWillUnmount
        // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
        if (!_this2.inputNode) return;
        var MediumEditor = __webpack_require__("kLCq");
        window.MediumEditor = MediumEditor; // this is a horrible hack for the embed plugin to work

        var _require = __webpack_require__("OoyB"),
            FileDragging = _require.FileDragging;

        var extensions = {};

        if (_this2.props.options && _this2.props.options.noImageDragging) {
          extensions = { imageDragging: {} };
        } else {
          extensions = { fileDragging: new FileDragging() };
        }

        if (_this2.props.options && _this2.props.options.videoEmbedding) {
          var EmbedButtonExtension = __webpack_require__("HrKQ");
          extensions.embedButton = new EmbedButtonExtension({
            contentDefault: PLAYER_ICON,
            embedOpts: {
              oembedProxy: 'https://iframe.ly/api/iframely?key=' + __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["z" /* IFRAMELY_KEY */] + '&iframe=true&omit_script=true&url='
            }
          });
        }

        var dom = _this2.inputNode;
        _this2.medium = new MediumEditor(dom, _extends({}, DEFAULT_OPTIONS(_this2.props.isSavedReplyEditor), { extensions: extensions }, _this2.props.options));
        _this2.medium.subscribe('editableClick', function () {
          if (_this2.medium) _this2.medium.saveSelection.bind(_this2.medium)();
        });
        _this2.medium.subscribe('focus', function () {
          setTimeout(function () {
            if (_this2.medium) _this2.medium.restoreSelection.bind(_this2.medium)();
          }, 1);
        });
        _this2.medium.subscribe('editableInput', function (e) {
          _this2._updated = true;
          _.each(dom.querySelectorAll('span[style]'), function (sp) {
            sp.removeAttribute('style');
          });
          _this2.change(dom.innerHTML);
          if (_this2.medium) _this2.medium.saveSelection();
        });
      
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("M4fF")))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.medium && this.medium.destroy();
      delete window.MediumEditor;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // Horrible hack to get placeholders to change
      // we should figure out a better way somehow
      var placeholderElement = document.getElementsByClassName('medium-editor-placeholder');
      if (placeholderElement && placeholderElement[0]) {
        placeholderElement[0].setAttribute('data-placeholder', this.props.options && this.props.options.placeholder ? this.props.options.placeholder.text : '');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Not proud of this whole hack but it is needed for some control on when this component needs to update
      // its text from prop
      if (nextProps.text === '' || nextProps.text !== this.props.text && !this._updated) {
        this.setState({ text: nextProps.text });
        this.medium && this.medium.setContent(nextProps.text);
      }

      if (this._updated) this._updated = false;
    }
  }, {
    key: 'change',
    value: function change(text) {
      if (this.props.onChange) this.props.onChange(text, this.medium);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          tag = _props.tag,
          dangerouslySetInnerHTML = _props.dangerouslySetInnerHTML,
          text = _props.text,
          options = _props.options,
          props = _objectWithoutProperties(_props, ['tag', 'dangerouslySetInnerHTML', 'text', 'options']);

      var newProps = _extends(props, {
        dangerouslySetInnerHTML: { __html: this.state.text }
      });
      return React.createElement('div', _extends({ contentEditable: true, ref: function ref(c) {
          return _this3.inputNode = c;
        } }, newProps));
    }
  }]);

  return InlineEditor;
}(React.Component);

InlineEditor.defaultProps = { tag: 'div' };
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "D7Qt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("fCHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var OnlineIndicator = function (_Component) {
  _inherits(OnlineIndicator, _Component);

  function OnlineIndicator() {
    _classCallCheck(this, OnlineIndicator);

    return _possibleConstructorReturn(this, (OnlineIndicator.__proto__ || Object.getPrototypeOf(OnlineIndicator)).apply(this, arguments));
  }

  _createClass(OnlineIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hasPresence = _props.hasPresence;


      if (!hasPresence) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style__["onlineIndicator"], className) });
    }
  }]);

  return OnlineIndicator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state) {
    return {
      hasPresence: __WEBPACK_IMPORTED_MODULE_3_app_modules_gates_selectors__["n" /* hasPresence */](state)
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps)(OnlineIndicator));

/***/ }),

/***/ "DCOM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BackButtonContainer":"BackButtonContainer---2o-cg","BackButton":"BackButton---aDwNN"};

/***/ }),

/***/ "DCxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("Pga6");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("/vZv");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "DEsL":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "DHpE":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.7 13.13c.4.428.4 1.114.002 1.54-.198.214-.465.33-.743.33-.28 0-.546-.116-.745-.328L7 9.07l-5.215 5.6c-.197.214-.465.33-.743.33-.278 0-.545-.116-.743-.328-.4-.428-.4-1.114 0-1.54L5.54 7.5.3 1.87C-.1 1.442-.1.756.3.33c.407-.44 1.077-.44 1.485 0L7 5.93l5.215-5.6c.408-.44 1.078-.44 1.487 0 .397.427.397 1.112 0 1.54L8.46 7.5l5.24 5.63z\" fill-rule=\"nonzero\" fill=\"none\"></path></svg>"

/***/ }),

/***/ "DJjn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DJtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__ = __webpack_require__("dLe+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("Ipqy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);






var SegmentSelect = function SegmentSelect(_ref) {
  var value = _ref.value,
      options = _ref.options,
      onNext = _ref.onNext,
      onCancel = _ref.onCancel,
      onChange = _ref.onChange,
      isEmailPlaybook = _ref.isEmailPlaybook,
      _ref$showCancel = _ref.showCancel,
      showCancel = _ref$showCancel === undefined ? true : _ref$showCancel;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-segment-select' },
    showCancel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'link playbook-segment-cancel', onClick: onCancel },
      '< Audiences'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'Which segments should ',
      isEmailPlaybook ? 'receive this email' : 'see this Playbook',
      '?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      isEmailPlaybook ? 'Send' : 'Display',
      ' to people in the following segments:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__["a" /* default */], {
      onChange: onChange,
      value: value,
      options: options,
      optionRenderer: function optionRenderer(_ref2) {
        var label = _ref2.label;
        return label;
      },
      valueRenderer: function valueRenderer(_ref3) {
        var label = _ref3.label;
        return label;
      },
      selectOptions: { filterOption: function filterOption(option, filterText) {
          return option.name.toLowerCase().includes(filterText);
        } },
      showInviteTips: false,
      shouldSelectAutofocus: false
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SegmentSelect);

/***/ }),

/***/ "DLlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_Integrations__ = __webpack_require__("CCiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_PageTitle__ = __webpack_require__("d76z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_Section__ = __webpack_require__("r8Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AssistantOrgSalesforceConnect__ = __webpack_require__("mX/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssistantConfigSalesforceMapping__ = __webpack_require__("3kop");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AssistantConfigSalesforceActivity__ = __webpack_require__("LMde");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("XPGI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var defaultConfigSettings = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])({
  salesforceLeadObject: 'LEAD',
  salesforceEventObject: 'EVENT',
  sfLeadFields: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(),
  sfEventFields: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(),
  followUpWithOpenOps: true
});

var AssistantConfigOrg = function (_React$Component) {
  _inherits(AssistantConfigOrg, _React$Component);

  function AssistantConfigOrg(props) {
    _classCallCheck(this, AssistantConfigOrg);

    var _this = _possibleConstructorReturn(this, (AssistantConfigOrg.__proto__ || Object.getPrototypeOf(AssistantConfigOrg)).call(this, props));

    _this.handleEditMapping = function (_ref) {
      var isEditingValue = _ref.isEditingValue,
          isSFDCOutOfSyncValue = _ref.isSFDCOutOfSyncValue;

      _this.setState({ salesforceMappingOutOfSync: isSFDCOutOfSyncValue });
      _this.props.actions.handleEditConfig({ settingName: 'MAPPING', value: isEditingValue });
    };

    _this.handleEditActivity = function (_ref2) {
      var isEditingValue = _ref2.isEditingValue,
          isSFDCOutOfSyncValue = _ref2.isSFDCOutOfSyncValue;

      _this.setState({ salesforceMappingOutOfSync: isSFDCOutOfSyncValue });
      _this.props.actions.handleEditConfig({ settingName: 'ACTIVITY', value: isEditingValue });
    };

    _this.state = {
      salesforceMappingOutOfSync: false,
      salesforceActivityOutOfSync: false
    };
    return _this;
  }

  _createClass(AssistantConfigOrg, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchOrgSettings();
      this.props.actions.fetchSalesforceSettings();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          orgSettings = _props.orgSettings,
          hasCustomizedAssistantSFDCMapping = _props.hasCustomizedAssistantSFDCMapping,
          hasCustomizedAssistantSFDCActivity = _props.hasCustomizedAssistantSFDCActivity,
          isEditingMapping = _props.isEditingMapping,
          isEditingActivity = _props.isEditingActivity;
      var _state = this.state,
          salesforceMappingOutOfSync = _state.salesforceMappingOutOfSync,
          salesforceActivityOutOfSync = _state.salesforceActivityOutOfSync;

      var hasCompletedOnboarding = hasCustomizedAssistantSFDCMapping && hasCustomizedAssistantSFDCActivity;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_15__style_styl___default.a.AssistantConfigOrg },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Link */],
          { to: '/settings2/assistant', className: 'assistant-nav-link' },
          '< View my Drift Assistant'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_PageTitle__["a" /* default */], {
          title: 'The Drift Assistant',
          description: 'The Drift Assistant will match how your team identifies qualified leads and demos held. That way, your team is only reminded about the right people at the right time.',
          className: 'assistant-config-title'
        }),
        !hasCompletedOnboarding && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_Section__["a" /* SectionItem */], {
          title: 'Configure the Drift Assistant for your Team',
          description: 'Make sure your team never lets a lead or opportunity fall through the cracks again. Help them succeed by configuring your team\'s Drift Assistant with your Salesforce account below.',
          className: 'assistant-educational-banner'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_components_shared_Section__["a" /* SectionItem */],
          {
            title: 'Send reminders for the leads that matter most',
            description: 'The Drift Assistant will only send reminders to your team about people who match the following Salesforce mapping. For example, you can configure the assistant so your team only receives meeting reminder emails for people who are qualified leads.'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AssistantConfigSalesforceMapping__["a" /* default */], {
            orgSettings: salesforceMappingOutOfSync ? defaultConfigSettings : orgSettings,
            isEditing: isEditingMapping || !hasCustomizedAssistantSFDCMapping,
            handleEdit: this.handleEditMapping,
            hasPassedOnboarding: hasCustomizedAssistantSFDCMapping,
            salesforceOutOfSync: salesforceMappingOutOfSync
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11_components_shared_Section__["a" /* SectionItem */],
          {
            title: 'Send reminders after a demo\u2019s been held',
            description: 'When the Drift Assistant sends a reminder for your team to follow up after a meeting, it\u2019ll use Salesforce to make sure the demo\u2019s been held. Customize what the Drift Assistant uses to identify a held demo below.'
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__AssistantConfigSalesforceActivity__["a" /* default */], {
            orgSettings: salesforceActivityOutOfSync ? defaultConfigSettings : orgSettings,
            isEditing: isEditingActivity || !hasCustomizedAssistantSFDCActivity,
            handleEdit: this.handleEditActivity,
            hasPassedOnboarding: hasCustomizedAssistantSFDCActivity,
            salesforceOutOfSync: salesforceActivityOutOfSync
          })
        )
      );
    }
  }]);

  return AssistantConfigOrg;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isSalesforceConnected: Object(__WEBPACK_IMPORTED_MODULE_6_utils_Integrations__["b" /* isIntegrationConnected */])('salesforce'),
    orgSettings: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_selectors__["c" /* assistantOrgSettings */])(state),
    hasCustomizedAssistantSFDCMapping: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["hasCustomizedAssistantSFDCMapping"])(state),
    hasCustomizedAssistantSFDCActivity: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["hasCustomizedAssistantSFDCActivity"])(state),
    isEditingMapping: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_selectors__["k" /* isEditingMapping */])(state),
    isEditingActivity: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_assistantSettings_selectors__["j" /* isEditingActivity */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchOrgSettings: __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__["m" /* fetchAssistantOrgSettings */],
      fetchSalesforceSettings: __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__["u" /* fetchSalesforceSettings */],
      handleEditConfig: __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__["y" /* handleEditConfig */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.isSalesforceConnected;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_12__AssistantOrgSalesforceConnect__["a" /* default */])))(AssistantConfigOrg));

/***/ }),

/***/ "DN+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ManageTagsList__ = __webpack_require__("Vc6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_TagTypeEnum__ = __webpack_require__("gC8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_ManageTags_styl__ = __webpack_require__("Qlga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_ManageTags_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_ManageTags_styl__);








var ManageTags = React.createClass({
  displayName: 'ManageTags',
  getInitialState: function getInitialState() {
    return {};
  },
  render: function render() {
    var filteredConversationTagsList = this.props.conversationTagList.filter(function (tag) {
      return tag.status === 'ENABLED';
    });
    var filteredCustomerTagsList = this.props.customerTagList.filter(function (tag) {
      return tag.status === 'ENABLED';
    });
    return React.createElement(
      'div',
      { className: 'ManageTags' },
      React.createElement(
        'p',
        null,
        'Tags organize your inboxes and customer base. Use tags to help visualize who you are helping and what you are helping them with.'
      ),
      React.createElement(
        'div',
        { className: 'tag-sections' },
        React.createElement(
          'div',
          { className: 'section' },
          React.createElement(
            'div',
            { className: 'section-header' },
            React.createElement(
              'div',
              { className: 'tag-section-title' },
              'Customer Tags'
            )
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_1__ManageTagsList__["a" /* default */], {
            app: this.app,
            className: 'customer-tag-list',
            tagType: __WEBPACK_IMPORTED_MODULE_2_constants_TagTypeEnum__["a" /* default */].ANY.key,
            tagList: filteredCustomerTagsList })
        ),
        React.createElement(
          'div',
          { className: 'section' },
          React.createElement(
            'div',
            { className: 'section-header' },
            React.createElement(
              'div',
              { className: 'tag-section-title' },
              'Conversation Tags'
            )
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_1__ManageTagsList__["a" /* default */], {
            app: this.app,
            className: 'conversation-tag-list',
            tagList: filteredConversationTagsList,
            tagType: __WEBPACK_IMPORTED_MODULE_2_constants_TagTypeEnum__["a" /* default */].CONVERSATION.key })
        )
      )
    );
  }
});

var ManageTagsContainer = Marty.createContainer(ManageTags, {
  listenTo: ['stores.TagStore'],

  fetch: {
    customerTagList: function customerTagList() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList();
    },
    conversationTagList: function conversationTagList() {
      return this.app.stores.TagStore.getOrFetchConversationTagList();
    }
  },
  pending: function pending() {
    return React.createElement('div', { className: 'loader-rotating' });
  },
  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ManageTagsContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "DPIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var encodeQueryData = function encodeQueryData(data) {
  var ret = [];
  for (var key in data) {
    var value = data[key];
    ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  }
  return ret.join('&');
};

var EndUserTokenAPI = Marty.createStateSource({
  id: 'EndUserTokenAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  getEndUserToken: function getEndUserToken(orgId, email, leadId, userId, version) {
    var payload = void 0;
    if (version === 2) {
      payload = {
        org_id: orgId,
        grant_type: 'sdk',
        client_id: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["f" /* CLIENT_ID */],
        redirect_uri: 'http://localhost:3000/'
      };

      if (email != null) {
        _extends(payload, { email: email });
      }

      if (leadId != null) {
        _extends(payload, { lead_id: leadId });
      }

      if (userId != null) {
        _extends(payload, { user_id: userId });
      }
    } else {
      payload = {
        username: email,
        orgId: orgId,
        grant_type: 'end_user',
        client_id: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["f" /* CLIENT_ID */],
        redirect_uri: 'http://localhost:3000/'
      };
    }

    return this.post({
      url: '/oauth/token',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].X_WWW_FORM,
      body: encodeQueryData(payload)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserTokenAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "DTGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_TARGETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_TARGETS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_TARGETS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_TARGETS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_TARGET_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_TARGET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_TARGET_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_TARGET_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_TARGET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_TARGET_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_TARGET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('targeting');

var FETCH_TARGETS = makeConstant('FETCH_TARGETS');
var FETCH_TARGETS_PENDING = makeConstant('FETCH_TARGETS_PENDING');
var FETCH_TARGETS_SUCCESS = makeConstant('FETCH_TARGETS_SUCCESS');
var FETCH_TARGETS_FAILED = makeConstant('FETCH_TARGETS_FAILED');

var UPDATE_TARGET = makeConstant('UPDATE_TARGET');
var UPDATE_TARGET_PENDING = makeConstant('UPDATE_TARGET_PENDING');
var UPDATE_TARGET_SUCCESS = makeConstant('UPDATE_TARGET_SUCCESS');
var UPDATE_TARGET_FAILED = makeConstant('UPDATE_TARGET_FAILED');

var CREATE_TARGET = makeConstant('CREATE_TARGET');
var CREATE_TARGET_PENDING = makeConstant('CREATE_TARGET_PENDING');
var CREATE_TARGET_SUCCESS = makeConstant('CREATE_TARGET_SUCCESS');
var CREATE_TARGET_FAILED = makeConstant('CREATE_TARGET_FAILED');

var SET_TARGET = makeConstant('SET_TARGET');

/***/ }),

/***/ "DVR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__ = __webpack_require__("dLe+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("lDiE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);






var TargetingExcludes = function TargetingExcludes(_ref) {
  var value = _ref.value,
      options = _ref.options,
      onChange = _ref.onChange,
      isEmailPlaybook = _ref.isEmailPlaybook;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-segment-select' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Which segments should ',
        isEmailPlaybook ? 'be excluded' : 'be excluded from this Playbook',
        '?'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        isEmailPlaybook ? 'When you enroll contacts in this sales sequence from Drift, Salesforce, or our Gmail extension, any contacts in the following segments will be excluded.' : 'Never show or allow contacts in the following segments to be enrolled in this Playbook:'
      )
    ),
    isEmailPlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'playbook-email-exclusion-description' },
      'Never send this email to the following segments:'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__["a" /* default */], {
      onChange: onChange,
      value: value,
      options: options,
      optionRenderer: function optionRenderer(_ref2) {
        var label = _ref2.label;
        return label;
      },
      valueRenderer: function valueRenderer(_ref3) {
        var label = _ref3.label;
        return label;
      },
      selectOptions: { filterOption: function filterOption(option, filterText) {
          return option.name.toLowerCase().includes(filterText);
        } },
      showInviteTips: false,
      shouldSelectAutofocus: false
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TargetingExcludes);

/***/ }),

/***/ "DYVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__ = __webpack_require__("1WKC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var ApiKeyQueries = Marty.createQueries({
  id: 'ApiKeyQueries',

  getApiKeyByOrgId: function getApiKeyByOrgId(orgId) {
    var _this = this;

    var promise = this.app.sources.ApiKeyAPI.getApiKeyByOrgId(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].GET_API_KEY_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].GET_API_KEY_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].GET_API_KEY_FAILED, error);
    });
  },
  createApiKeyForOrgId: function createApiKeyForOrgId(orgId) {
    var _this2 = this;

    var promise = this.app.sources.ApiKeyAPI.createApiKeyForOrgId(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].CREATE_API_KEY_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].CREATE_API_KEY_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].CREATE_API_KEY_FAILED, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ApiKeyQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "DZDw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubSpot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_HelpDocConstants__ = __webpack_require__("fBam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_app__ = __webpack_require__("AJef");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AUTH_LINK = "https://app.hubspot.com/oauth/authorize";
var INSTALL_PAGE_LINK = __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings/setup/install';
var HUBSPOT_INSTALL_DOC = 'https://knowledge.hubspot.com/articles/kcs_article/cos-general/add-a-javascript-file-to-hubspot';

var HUBSPOT_PAYLOAD = {
  client_id: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["y" /* HUBSPOT_CLIENT_ID */],
  redirect_uri: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/hubspot'
};

var RAW_PARAM_PAYLOAD = '&scope=content crm.schemas.deals.read timeline oauth crm.objects.owners.read forms crm.objects.contacts.write crm.objects.companies.write crm.lists.read crm.schemas.contacts.read crm.objects.deals.write crm.objects.contacts.read crm.schemas.companies.read';

var HubSpot = function (_Component) {
  _inherits(HubSpot, _Component);

  function HubSpot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HubSpot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HubSpot.__proto__ || Object.getPrototypeOf(HubSpot)).call.apply(_ref, [this].concat(args))), _this), _this.handleTimelineStateChange = function (_ref2) {
      var target = _ref2.target;

      _this.app.queries.IntegrationsQueries.updateHubspotTimelineState(target.checked);
      _this.app.queries.IntegrationsQueries.fetchIntegrationStates();
    }, _this.handleCookieTrackingStateChange = function (_ref3) {
      var target = _ref3.target;

      _this.app.queries.IntegrationsQueries.updateHubspotCookieState(target.checked).then(function () {
        _this.app.queries.IntegrationsQueries.fetchIntegrationStates();
      });
    }, _this.onIntegrationConnected = function () {
      __WEBPACK_IMPORTED_MODULE_8_containers_app__["a" /* default */].queries.IntegrationsQueries.fetchIntegrationStates();
    }, _this.renderEmbedToggle = function () {
      var _this$props = _this.props,
          hubspotTimelineState = _this$props.hubspotTimelineState,
          hubspotCookieState = _this$props.hubspotCookieState;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex', style: { paddingBottom: '1rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], { defaultChecked: hubspotTimelineState,
            id: 'hubspot-timeline-state',
            onChange: _this.handleTimelineStateChange.bind(_this)
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: '1rem' } },
            'Sync activities from Drift to my HubSpot contact database'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex', style: { paddingBottom: '1rem' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], { defaultChecked: hubspotCookieState,
            id: 'hubspot-cookie-state',
            onChange: _this.handleCookieTrackingStateChange.bind(_this)
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingLeft: '1rem' } },
            'Identify visitors using the HubSpot cookie'
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HubSpot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref4) {
      var hubspotTimelineState = _ref4.hubspotTimelineState,
          hubspotCookieState = _ref4.hubspotCookieState,
          orgProps = _ref4.orgProps;

      var currentTimelineState = this.props.hubspotTimelineState;
      var currentHubspotCookieState = this.props.hubspotCookieState;
      var orgActivated = this.props.orgProps.orgActivated;

      if (currentTimelineState !== hubspotTimelineState || currentHubspotCookieState !== hubspotCookieState) {
        this.app.actions.NotificationActions.pushNotification({ content: 'Your settings were successfully updated.' });
      }

      if (orgActivated !== orgProps.orgActivated && orgProps.orgActivated) {
        this.app.actions.NotificationActions.pushNotification({
          content: 'Drift is successfully set up and ready to go!'
        });
        this.app.queries.IntegrationsQueries.fetchIntegrationStates();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Using HubSpot as your Marketing Automation Platform? Great! Toggling the options below will allow you to send conversation events into HubSpot as well as automatically identify visitors using the HubSpot cookie.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'To install Drift on your Hubspot hosted site, copy the Drift Javascript snippet from our ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: INSTALL_PAGE_LINK, target: '_blank' },
            'install page'
          ),
          ', then follow Hubspot\'s directions ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: HUBSPOT_INSTALL_DOC, target: '_blank' },
            'here'
          ),
          '.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Want more information? ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: __WEBPACK_IMPORTED_MODULE_6_constants_HelpDocConstants__["d" /* HUBSPOT_HELPDOC_URL */], target: '_blank' },
            'Learn more.'
          )
        ),
        !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'connect-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_IntegrationConnector__["a" /* default */], {
            onIntegrationConnected: this.onIntegrationConnected,
            integrationId: 'hubspot',
            isOauth: true,
            oauthLink: AUTH_LINK,
            title: 'Connect Account',
            connectorType: 'button',
            buttonType: 'primary',
            className: 'hubspot-integration-connector',
            oauthQueryParams: HUBSPOT_PAYLOAD,
            oauthRawParams: RAW_PARAM_PAYLOAD })
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/hubspot/config', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Synced Hubspot Data'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Hubspot and Drift.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('HUBSPOT_MAPPING') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/hubspot/mapping/attributes', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Mapped Hubspot Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map which fields you want to sync between Drift and Hubspot.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('HUBSPOT_USER_MAPPING') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/hubspot/mapping/users', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Mapped Hubspot Users'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map your Drift Teammates to your Hubspot Teammates.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/hubspot/event-log', className: 'integration-config-link' },
          'View Hubspot Event Log'
        )
      );
    }
  }]);

  return HubSpot;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HubSpotContainer = Object(__WEBPACK_IMPORTED_MODULE_2_components_container__["a" /* makeDefaultFailedContainer */])(HubSpot, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates: function integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates();
    },
    hubspotTimelineState: function hubspotTimelineState() {
      return this.app.stores.IntegrationsStore.fetchHubspotTimelineState();
    },
    hubspotCookieState: function hubspotCookieState() {
      return this.app.stores.IntegrationsStore.fetchHubspotCookieState();
    },
    orgProps: function orgProps() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    },
    org: function org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (HubSpotContainer);

/***/ }),

/***/ "DZSL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(213);

/***/ }),

/***/ "DZms":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 11 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.586 6.81C10.05 7.538 11 8.94 11 10.625 11 13.16 8.995 15 6.233 15H.688C.307 15 0 14.72 0 14.375V.625C0 .28.308 0 .688 0h5.545c2.326 0 4.08 1.612 4.08 3.75 0 1.28-.678 2.386-1.727 3.06zm1.039 3.815c0-1.543-1.174-3.106-3.416-3.106-.037 0-.07-.014-.106-.019H1.375v6.25h4.858c2.33 0 3.392-1.62 3.392-3.125zM6.233 1.25H1.375v5h4.813c1.567 0 2.75-1.075 2.75-2.5 0-1.449-1.138-2.5-2.705-2.5z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "DaXa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vidyard-logo.14d7f48e.svg";

/***/ }),

/***/ "DbKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_DemandbaseAudiences__ = __webpack_require__("R9hW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectFilter__ = __webpack_require__("ANGi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DemandbaseAudienceFilter = function (_PureComponent) {
  _inherits(DemandbaseAudienceFilter, _PureComponent);

  function DemandbaseAudienceFilter(props) {
    _classCallCheck(this, DemandbaseAudienceFilter);

    var _this = _possibleConstructorReturn(this, (DemandbaseAudienceFilter.__proto__ || Object.getPrototypeOf(DemandbaseAudienceFilter)).call(this, props));

    _this.state = {
      options: __WEBPACK_IMPORTED_MODULE_1_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */]
    };
    return _this;
  }

  _createClass(DemandbaseAudienceFilter, [{
    key: 'render',
    value: function render() {
      var options = this.state.options;
      var _props = this.props,
          onUpdateCondition = _props.onUpdateCondition,
          activeFilter = _props.activeFilter;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SelectFilter__["a" /* default */], { options: options, onUpdateCondition: onUpdateCondition, activeFilter: activeFilter });
    }
  }]);

  return DemandbaseAudienceFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (DemandbaseAudienceFilter);

/***/ }),

/***/ "Dc2k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(523);

/***/ }),

/***/ "De0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AnswerModalStandardBody__ = __webpack_require__("TJAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnswerModalMatchBody__ = __webpack_require__("sNnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AnswerModalNonMatchBody__ = __webpack_require__("4/Uo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("ZWQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);










var AnswerModal = function AnswerModal(_ref) {
  var _ref$answer = _ref.answer,
      response = _ref$answer.response,
      type = _ref$answer.type,
      questionIndex = _ref.questionIndex,
      isEmailCaptureQuestion = _ref.isEmailCaptureQuestion,
      isPhoneCaptureQuestion = _ref.isPhoneCaptureQuestion,
      onCloseClick = _ref.onCloseClick,
      onResponseChange = _ref.onResponseChange,
      targetCopy = _ref.targetCopy,
      shortTargetCopy = _ref.shortTargetCopy;

  var title = isEmailCaptureQuestion ? 'Email Capture ' + (questionIndex + 1) : isPhoneCaptureQuestion ? 'Phone Capture ' + (questionIndex + 1) : 'Question ' + (questionIndex + 1);

  var botFollowUpProps = { response: response, questionIndex: questionIndex, onResponseChange: onResponseChange };

  var modalBody = isEmailCaptureQuestion || isPhoneCaptureQuestion ? type === __WEBPACK_IMPORTED_MODULE_0_app_modules_playbook_constants__["t" /* AnswerType */].VALIDATE ? React.createElement(__WEBPACK_IMPORTED_MODULE_3__AnswerModalMatchBody__["a" /* default */], { botFollowUpProps: botFollowUpProps, targetCopy: targetCopy, shortTargetCopy: shortTargetCopy }) : React.createElement(__WEBPACK_IMPORTED_MODULE_4__AnswerModalNonMatchBody__["a" /* default */], { botFollowUpProps: botFollowUpProps, targetCopy: targetCopy, shortTargetCopy: shortTargetCopy }) : React.createElement(__WEBPACK_IMPORTED_MODULE_2__AnswerModalStandardBody__["a" /* default */], { botFollowUpProps: botFollowUpProps });

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_1__PlaybookModal__["a" /* default */],
    {
      onCloseClick: onCloseClick,
      hideDescription: true,
      title: '' + title,
      contentClassName: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.AnswerModalContent
    },
    React.createElement(
      'div',
      null,
      modalBody
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AnswerModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "De6q":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxIiBoZWlnaHQ9IjYzIiB2aWV3Qm94PSIwIDAgMTAxIDYzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGU+VGFrZW92ZXIgSWNvbjwvdGl0bGU+PHJlY3QgaWQ9ImEiIHdpZHRoPSIxMDAuMzgzIiBoZWlnaHQ9IjYyLjM4MiIgcng9IjMuOCIvPjxtYXNrIGlkPSJjIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwLjM4MyIgaGVpZ2h0PSI2Mi4zODIiIGZpbGw9IiNGRkZGRkYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHJlY3QgaWQ9ImIiIHdpZHRoPSIxMDAuMzgzIiBoZWlnaHQ9IjEyLjM3NyIgcng9IjkuNSIvPjxtYXNrIGlkPSJkIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTAwLjM4MyIgaGVpZ2h0PSIxMi4zNzciIGZpbGw9IiNGRkZGRkYiPjx1c2UgeGxpbms6aHJlZj0iI2IiLz48L21hc2s+PGcgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJldmVub2RkIj48dXNlIHN0cm9rZT0iI0NDQ0NDQyIgbWFzaz0idXJsKCNjKSIgc3Ryb2tlLXdpZHRoPSI3LjYiIHhsaW5rOmhyZWY9IiNhIi8+PHVzZSBzdHJva2U9IiNDQ0NDQ0MiIG1hc2s9InVybCgjZCkiIHN0cm9rZS13aWR0aD0iNy42IiBmaWxsPSIjZmZmIiB4bGluazpocmVmPSIjYiIvPjxyZWN0IGZpbGw9IiNDQ0NDQ0MiIHg9IjE1LjQ1IiB5PSIyMy40MSIgd2lkdGg9IjQxLjQzMSIgaGVpZ2h0PSIzLjIyMyIgcng9IjQiLz48cmVjdCBmaWxsPSIjQ0NDQ0NDIiB4PSIxNS40NSIgeT0iMzQuODE5IiB3aWR0aD0iNjkuNTkyIiBoZWlnaHQ9IjMuMjIzIiByeD0iNCIvPjxyZWN0IGZpbGw9IiNDQ0NDQ0MiIHg9IjE1LjQ1IiB5PSI0My4wOTEiIHdpZHRoPSI2MS4zMTUiIGhlaWdodD0iMy4yMjMiIHJ4PSI0Ii8+PC9nPjwvc3ZnPgo="

/***/ }),

/***/ "DeDJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("Asl5");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "DeWp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("Z6Zx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var PlaybookModal = function PlaybookModal(_ref) {
  var className = _ref.className,
      children = _ref.children,
      description = _ref.description,
      hideDescription = _ref.hideDescription,
      hideTitle = _ref.hideTitle,
      title = _ref.title,
      onCancelClick = _ref.onCancelClick,
      cancelLabel = _ref.cancelLabel,
      onCloseClick = _ref.onCloseClick,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === undefined ? 'Close' : _ref$closeLabel,
      contentClassName = _ref.contentClassName,
      headerClassName = _ref.headerClassName,
      rest = _objectWithoutProperties(_ref, ['className', 'children', 'description', 'hideDescription', 'hideTitle', 'title', 'onCancelClick', 'cancelLabel', 'onCloseClick', 'closeLabel', 'contentClassName', 'headerClassName']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__["a" /* default */],
    _extends({ onRequestClose: onCloseClick, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-modal', className), isOpen: true }, rest),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('flex-space-between', 'playbook-modal-header', headerClassName) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !hideTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'playbook-modal-title' },
          title,
          !hideDescription && ': '
        ),
        !hideDescription && (description || '...')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        !!onCancelClick && cancelLabel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'playbook-modal-cancel-button', onClick: onCancelClick },
          cancelLabel
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'playbook-modal-close-button', onClick: onCloseClick },
          closeLabel
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-modal-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: contentClassName },
        children
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PlaybookModal);

/***/ }),

/***/ "DeyL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Df95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


// lower case becauase these match the _type in Elasticsearch
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['conversation', 'endUser']));

/***/ }),

/***/ "DgN1":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 25 25\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>layers-2</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Artboard\" transform=\"translate(-69.000000, -55.000000)\"><g id=\"layers-2\" transform=\"translate(69.000000, 55.000000)\"><path d=\"M24.425,8.84 L13.444,14.831 C13.295,14.912 13.131,14.953 12.966,14.953 C12.801,14.953 12.636,14.912 12.488,14.831 L1.506,8.84 C1.186,8.665 0.986,8.329 0.986,7.963 C0.986,7.598 1.186,7.262 1.506,7.087 L12.488,1.097 C12.785,0.934 13.147,0.934 13.444,1.097 L24.425,7.087 C24.746,7.262 24.946,7.598 24.946,7.963 C24.946,8.329 24.746,8.665 24.425,8.84 Z M12.966,3.11 L4.07,7.963 L12.966,12.817 L21.863,7.963 L12.966,3.11 Z M2.433,12.123 C2.892,11.819 3.51,11.945 3.815,12.405 C4.023,12.719 4.029,13.107 3.868,13.418 L12.966,17.837 L22.065,13.419 C21.902,13.108 21.909,12.72 22.116,12.406 C22.42,11.946 23.038,11.819 23.499,12.123 L24.498,12.782 C24.797,12.979 24.968,13.322 24.944,13.68 C24.921,14.039 24.706,14.357 24.383,14.513 L13.402,19.845 C13.264,19.912 13.115,19.945 12.966,19.945 C12.817,19.945 12.668,19.912 12.53,19.845 L1.548,14.513 C1.225,14.357 1.011,14.039 0.988,13.68 C0.964,13.322 1.135,12.979 1.434,12.782 L2.433,12.123 Z M2.433,17.115 C2.892,16.812 3.51,16.937 3.815,17.398 C4.023,17.711 4.029,18.1 3.868,18.411 L12.966,22.829 L22.065,18.412 C21.902,18.1 21.909,17.712 22.116,17.398 C22.42,16.938 23.038,16.811 23.499,17.115 L24.498,17.774 C24.797,17.972 24.968,18.315 24.944,18.673 C24.921,19.031 24.706,19.349 24.383,19.506 L13.402,24.837 C13.264,24.904 13.115,24.937 12.966,24.937 C12.817,24.937 12.668,24.904 12.53,24.837 L1.548,19.506 C1.225,19.349 1.011,19.031 0.988,18.673 C0.964,18.315 1.135,17.972 1.434,17.774 L2.433,17.115 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "DhfJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = patchOperations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__("NGEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isObject__ = __webpack_require__("yCNF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union__ = __webpack_require__("gszD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_each__ = __webpack_require__("9uKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keys__ = __webpack_require__("ktak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__("w9Mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);







function makePrefix(prefix, property) {
  return prefix ? prefix + '.' + property : property;
}

function removeOperation(prefix, property) {
  return {
    operation: 'remove',
    property: makePrefix(prefix, property)
  };
}

function setOperation(prefix, property, value) {
  return {
    operation: 'set',
    property: makePrefix(prefix, property),
    value: value
  };
}

/**
 * Diffs `obj` and `initialObj` and returns a list of patch operations
 * required to update the existing object to the new values.
 *
 * @param obj the "new" object
 * @param initialObj the initial value of the object
 * @param prefix the key prefix for nested operations
 * @returns {Array} a list of patch operations
 */
function patch(obj, initialObj, prefix) {
  var ops = [];
  var keys = __WEBPACK_IMPORTED_MODULE_2_lodash_union___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_keys___default()(obj), __WEBPACK_IMPORTED_MODULE_4_lodash_keys___default()(initialObj));
  __WEBPACK_IMPORTED_MODULE_3_lodash_each___default()(keys, function (key) {
    var value = obj[key];
    var isValueObject = __WEBPACK_IMPORTED_MODULE_1_lodash_isObject___default()(value) && !__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(value);

    // null-ish values are transformed into "remove" operations
    if (value == null && value != initialObj[key]) {
      ops.push(removeOperation(prefix, key));
    } else if (value != null && !isValueObject && value !== initialObj[key]) {
      // non-object values (including arrays) are transformed into "set" operations
      ops.push(setOperation(prefix, key, value));
    } else if (isValueObject) {
      // object values are traversed, appending the key to the current prefix
      ops = ops.concat(patch(value, initialObj[key] || {}, makePrefix(prefix, key)));
    }
  });
  return ops;
}

function _patchOperations(obj, initialObj, prefix) {
  return patch(obj, initialObj || {}, prefix || '');
}

function patchOperations(obj, initialObj, prefix) {
  var normalizedOldObj = __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(initialObj, __WEBPACK_IMPORTED_MODULE_4_lodash_keys___default()(obj));
  return _patchOperations(obj, normalizedOldObj, prefix);
}

/***/ }),

/***/ "Dhnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_reply_ManageSavedReplies_styl__ = __webpack_require__("PqDO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_reply_ManageSavedReplies_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_components_settings_reply_ManageSavedReplies_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_blank_table_svg__ = __webpack_require__("ewCN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_blank_table_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_blank_table_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_reply_ReplyTable__ = __webpack_require__("dO+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ManageSavedReplies = function (_Component) {
  _inherits(ManageSavedReplies, _Component);

  function ManageSavedReplies() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ManageSavedReplies);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManageSavedReplies.__proto__ || Object.getPrototypeOf(ManageSavedReplies)).call.apply(_ref, [this].concat(args))), _this), _this.onNewReplyClick = function () {
      return _this.context.router.push('/settings/replies/compose/new');
    }, _this.onModalClose = function () {
      _this.context.router.push('/settings/replies');
    }, _this.onReplySaved = function () {
      _this.context.app.queries.SavedReplyQueries.fetchReplies();
      _this.context.router.push('/settings/replies');
    }, _this.onDeleteReply = function (replyId) {
      _this.app.actions.SavedReplyActions.deleteReply(replyId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ManageSavedReplies, [{
    key: 'render',
    value: function render() {
      var replies = this.props.replies;

      var hasReplies = !Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["isEmpty"])(replies);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        { className: 'ManageSavedReplies' },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'a',
          { to: '/settings2/conversations' },
          '< Conversations Settings'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h1',
          { className: 'settings-saved-replies-title' },
          'Saved Replies'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'p',
          { className: 'settings-saved-replies-description' },
          'Saved replies are great for a quick response to questions that you get often. Write something up and send it to a visitor with one click.',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'a',
            { href: 'https://help.drift.com/article/how-to-create-saved-replies-/', target: '_blank' },
            'Learn More'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          {
            className: 'settings-saved-replies-new',
            onClick: this.onNewReplyClick },
          'New Reply'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionalRender__["a" /* default */],
          {
            condition: !hasReplies,
            className: 'settings-saved-replies-empty' },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_blank_table_svg___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_components_shared_ConditionalRender__["a" /* default */],
          {
            condition: hasReplies,
            className: 'settings-saved-replies-table' },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_settings_reply_ReplyTable__["a" /* default */], {
            replies: replies,
            onDeleteReply: this.onDeleteReply
          })
        ),
        this.props.children && __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(this.props.children, {
          onClose: this.onModalClose,
          onSave: this.onReplySaved
        })
      );
    }
  }]);

  return ManageSavedReplies;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

ManageSavedReplies.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_container__["a" /* makeDefaultFailedContainer */])(ManageSavedReplies, {
  listenTo: ['stores.SavedReplyStore'],
  fetch: {
    replies: function replies() {
      return this.app.stores.SavedReplyStore.fetchReplyListSorted();
    }
  }
}));

/***/ }),

/***/ "Dlon":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dm7V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__ = __webpack_require__("Y7j0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("1Hoc");







var api = {
  fetchTeams: function fetchTeams() {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__["b" /* CustomerAPIAuthEnabled */].get('/teams').then(function (res) {
      return res.data;
    }));
  },
  fetchTeamsForUser: function fetchTeamsForUser(_ref) {
    var userId = _ref.userId;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/teams?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ userId: userId })).checkStatus().map(function (res) {
      return res.response;
    });
  },
  createTeam: function createTeam(_ref2) {
    var team = _ref2.team;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/teams', team).checkStatus().map(function (res) {
      return res.response;
    });
  },
  patchTeam: function patchTeam(_ref3) {
    var teamId = _ref3.teamId,
        properties = _ref3.properties;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].patch('/teams/' + teamId, properties).checkStatus().map(function (res) {
      return res.response;
    });
  },
  updateAvailabilityForTeam: function updateAvailabilityForTeam(_ref4) {
    var teamId = _ref4.teamId,
        teamAvailabilitySettings = _ref4.teamAvailabilitySettings;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].put('/availabilities/team/' + teamId, Object(__WEBPACK_IMPORTED_MODULE_4__models__["a" /* TeamAvailabilitySettings */])(teamAvailabilitySettings).toJS()).checkStatus().map(function (res) {
      return res.response;
    });
  },
  fetchTeamAvailabilities: function fetchTeamAvailabilities() {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__["b" /* CustomerAPIAuthEnabled */].get('/availabilities').then(function (res) {
      return res.data;
    }));
  },
  fetchAvailabilityById: function fetchAvailabilityById(_ref5) {
    var teamAvailabilityId = _ref5.teamAvailabilityId;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/availabilities/' + teamAvailabilityId).checkStatus().map(function (res) {
      return res.response;
    });
  },
  createTeamAvailability: function createTeamAvailability(_ref6) {
    var teamAvailabilitySettings = _ref6.teamAvailabilitySettings;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/availabilities', teamAvailabilitySettings).checkStatus().map(function (res) {
      return res.response;
    });
  },
  updateTeamAvailability: function updateTeamAvailability(_ref7) {
    var teamAvailabilityId = _ref7.teamAvailabilityId,
        teamAvailabilitySettings = _ref7.teamAvailabilitySettings;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/availabilities/' + teamAvailabilityId, teamAvailabilitySettings).checkStatus().map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "DoXl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ds5W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(113);

/***/ }),

/***/ "DvTU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify__ = __webpack_require__("OvQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DefaultBotAvatar__ = __webpack_require__("fdBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__("NiPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("sumM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var WelcomeMessageFooter = function WelcomeMessageFooter(_ref) {
  var _ref$showBranding = _ref.showBranding,
      showBranding = _ref$showBranding === undefined ? true : _ref$showBranding;
  return React.createElement(
    'div',
    { className: 'welcome-message-preview--footer' },
    showBranding && React.createElement(
      'p',
      { className: 'welcome-message-preview--poweredby' },
      'Chat \u26A1\uFE0F by ',
      React.createElement(
        'span',
        { className: 'welcome-message-preview-powered-by-drift' },
        'Drift'
      )
    ),
    showBranding && React.createElement(
      'span',
      { className: 'welcome-message-preview--privacy-spacer' },
      '|'
    ),
    React.createElement(
      'span',
      { className: 'welcome-message-preview--privacy-policy' },
      'Privacy Policy'
    )
  );
};

var ButtonCallToAction = function ButtonCallToAction(_ref2) {
  var ctaCopy = _ref2.ctaCopy,
      backgroundColorStyle = _ref2.backgroundColorStyle;
  return React.createElement(
    'div',
    { className: 'welcome-message-preview--link-container' },
    React.createElement(
      'div',
      { className: 'welcome-message-preview--ctaButton', style: backgroundColorStyle },
      ctaCopy || 'Chat With Us'
    )
  );
};

var ChatCallToAction = function ChatCallToAction(_ref3) {
  var _ref3$userName = _ref3.userName,
      userName = _ref3$userName === undefined ? null : _ref3$userName;
  return React.createElement(
    'div',
    { className: 'welcome-message-preview--composer-container' },
    React.createElement(
      'div',
      { className: 'welcome-message-preview--composer' },
      'Reply to ' + (userName || 'Agent')
    )
  );
};

var WelcomeMessagePreview = function (_PureComponent) {
  _inherits(WelcomeMessagePreview, _PureComponent);

  function WelcomeMessagePreview() {
    _classCallCheck(this, WelcomeMessagePreview);

    return _possibleConstructorReturn(this, (WelcomeMessagePreview.__proto__ || Object.getPrototypeOf(WelcomeMessagePreview)).apply(this, arguments));
  }

  _createClass(WelcomeMessagePreview, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          message = _props.message,
          backgroundColor = _props.backgroundColor,
          users = _props.users,
          orgName = _props.orgName,
          fontFamily = _props.fontFamily,
          callToAction = _props.callToAction,
          showBranding = _props.showBranding;

      if (!users.get(0)) {
        return null;
      }

      var backgroundColorStyle = {
        backgroundColor: '#' + backgroundColor
      };

      var hasChatCta = callToAction.type === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT;
      var hasButtonCta = callToAction.type === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["V" /* CtaTypes */].URL || callToAction.type === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING;

      var isDefaultBotAvatar = users.getIn([0, 'bot']) && users.getIn([0, 'avatarUrl']) === null;

      return React.createElement(
        'div',
        { className: 'welcome-message-preview--container', style: { fontFamily: __WEBPACK_IMPORTED_MODULE_10__constants__["a" /* FontFamilies */][fontFamily] } },
        React.createElement('div', { className: 'welcome-message-preview--top-line', style: backgroundColorStyle }),
        React.createElement(
          'div',
          { className: 'welcome-message-preview--content' },
          React.createElement(
            'div',
            { className: 'welcome-message-preview--header' },
            React.createElement(
              'div',
              { className: 'welcome-message-preview--header-content' },
              React.createElement(
                'div',
                { className: 'welcome-message-preview--avatar-container' },
                isDefaultBotAvatar && React.createElement(__WEBPACK_IMPORTED_MODULE_9__DefaultBotAvatar__["a" /* default */], { backgroundColor: backgroundColor }),
                !isDefaultBotAvatar && React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_AvatarCompat__["a" /* AvatarCompat */], { size: 'small', user: users.get(0) })
              ),
              React.createElement(
                'span',
                { className: 'welcome-message-preview--user-name' },
                (users.getIn([0, 'name']) || 'Agent') + ' from ' + orgName
              )
            )
          ),
          React.createElement('div', { className: 'welcome-message-preview--body', dangerouslySetInnerHTML: { __html: __WEBPACK_IMPORTED_MODULE_3_dompurify___default.a.sanitize(message) } })
        ),
        hasChatCta && React.createElement(ChatCallToAction, { userName: users.getIn([0, 'name']) }),
        hasButtonCta && React.createElement(ButtonCallToAction, { ctaCopy: callToAction.copy, backgroundColorStyle: backgroundColorStyle }),
        React.createElement(WelcomeMessageFooter, { showBranding: showBranding })
      );
    }
  }]);

  return WelcomeMessagePreview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    botUser: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["botUser"])(state),
    orgName: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["k" /* getOrgName */])(state),
    fontFamily: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["u" /* selectedWidgetFont */])(state),
    showBranding: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["l" /* getOrgShowBranding */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WelcomeMessagePreview));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Dvx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profile", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileFetchStatus", function() { return profileFetchStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileUpdateStatus", function() { return profileUpdateStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileUpdateStatusPending", function() { return profileUpdateStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileUpdateStatusSuccess", function() { return profileUpdateStatusSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoaded", function() { return isLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "overview", function() { return overview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "social", function() { return social; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "details", function() { return details; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messaging", function() { return messaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "theme", function() { return theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handle", function() { return handle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalHandle", function() { return globalHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isHandleSet", function() { return isHandleSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyUrl", function() { return companyUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyProfileUrl", function() { return companyProfileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileUrlHandle", function() { return profileUrlHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileUrl", function() { return profileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visibility", function() { return visibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_selectors__ = __webpack_require__("Bqo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("QF6P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("sAia");








var profile = function profile(state) {
  return state.getIn(['profile', 'data']);
};
var profileFetchStatus = function profileFetchStatus(state) {
  return state.getIn(['profile', 'status', 'fetch']);
};
var profileUpdateStatus = function profileUpdateStatus(state) {
  return state.getIn(['profile', 'status', 'update']);
};
var profileUpdateStatusPending = function profileUpdateStatusPending(state) {
  return state.getIn(['profile', 'status', 'update']) === __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* constants */].UPDATE_PROFILE_STARTED;
};
var profileUpdateStatusSuccess = function profileUpdateStatusSuccess(state) {
  return state.getIn(['profile', 'status', 'update']) === __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* constants */].UPDATE_PROFILE_SUCCESS;
};

var isLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(profileFetchStatus, function (profileFetchstatus) {
  return profileFetchstatus === __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* constants */].RECEIVE_PROFILE;
});

var overview = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(isLoaded, profile, function (isLoaded, profile) {
  return isLoaded ? Object(__WEBPACK_IMPORTED_MODULE_5__models__["c" /* Overview */])(profile) : undefined;
});
var social = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(isLoaded, profile, function (isLoaded, profile) {
  return isLoaded ? Object(__WEBPACK_IMPORTED_MODULE_5__models__["e" /* Social */])(profile) : undefined;
});
var details = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(isLoaded, profile, function (isLoaded, profile) {
  return isLoaded ? Object(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* Details */])(profile) : undefined;
});
var messaging = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(isLoaded, profile, function (isLoaded, profile) {
  return isLoaded ? Object(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* Messaging */])(profile) : undefined;
});
var theme = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(isLoaded, profile, function (isLoaded, profile) {
  return isLoaded ? Object(__WEBPACK_IMPORTED_MODULE_5__models__["f" /* Theme */])(profile) : undefined;
});

var handle = function handle(state) {
  return state.getIn(['profile', 'data', 'handle']);
};
var globalHandle = function globalHandle(state) {
  return state.getIn(['profile', 'data', 'globalHandle']);
};

var isHandleSet = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(handle, globalHandle, function (handle, globalHandle) {
  return !!handle || !!globalHandle;
});
var companyUrl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__["orgHandle"], function (handle) {
  return '' + handle + __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["H" /* ORG_PROFILE_DOMAIN */];
});

var companyProfileUrl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(companyUrl, handle, function (companyUrl, handle) {
  return 'https://' + companyUrl + '/' + handle;
});

var profileUrlHandle = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(handle, globalHandle, function (handle, globalHandle) {
  return globalHandle || handle;
});
var profileUrl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(globalHandle, function (globalHandle) {
  if (!globalHandle) {
    return '';
  }
  return 'https://' + __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */] + '/' + globalHandle;
});

var visibility = function visibility(state) {
  return state.getIn(['profile', 'visibility']);
};

/***/ }),

/***/ "E/eJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("JmgY");











var usersWithExtension = __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["f" /* makeUsersWithProperty */]('extensionInstalled');

var mapStateToProps = function mapStateToProps(state) {
  return {
    usersWithExtension: usersWithExtension(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideExtensionInviteModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_82" /* hideExtensionInviteModal */],
      sendInvitationsViaEmail: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["sendInvitationsViaEmail"],
      sendInvitationsViaSlack: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["sendInvitationsViaSlack"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      var hideExtensionInviteModal = props.actions.hideExtensionInviteModal;

      hideExtensionInviteModal();
    };
  },
  sendInvitationsViaEmail: function sendInvitationsViaEmail(props) {
    return function (emails, scopes) {
      var sendInvitationsViaEmail = props.actions.sendInvitationsViaEmail;

      var invitations = {
        invitations: _.map(emails, function (email) {
          return { user: { email: email, scopes: scopes }, properties: { extensionInvited: true } };
        })
      };
      sendInvitationsViaEmail(invitations);
    };
  },
  sendInvitationsViaSlack: function sendInvitationsViaSlack(props) {
    return function (users, scopes) {
      var sendInvitationsViaSlack = props.actions.sendInvitationsViaSlack;

      var invitations = {
        invitations: _.map(users, function (user) {
          return { user: { email: user.email, slackUserId: user.slackUserId, scopes: scopes }, properties: { extensionInvited: true } };
        })
      };
      sendInvitationsViaSlack(invitations);
    };
  }

}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "E3/D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_ASSISTANT_ORG_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_ASSISTANT_ORG_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_ASSISTANT_ORG_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_ASSISTANT_ORG_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_ASSISTANT_ORG_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_ASSISTANT_ORG_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PATCH_ASSISTANT_ORG_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PATCH_ASSISTANT_ORG_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PATCH_ASSISTANT_ORG_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ASSISTANT_AGENT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_ASSISTANT_AGENT_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_ASSISTANT_AGENT_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_ASSISTANT_AGENT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_ASSISTANT_AGENT_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ASSISTANT_AGENT_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PATCH_ASSISTANT_AGENT_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PATCH_ASSISTANT_AGENT_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PATCH_ASSISTANT_AGENT_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_SALESFORCE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_SALESFORCE_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_SALESFORCE_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_SALESFORCE_SETTINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_PERSONALIZATION_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_PERSONALIZATION_TAGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_PERSONALIZATION_TAGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_PERSONALIZATION_TAGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_INITIAL_ORG_EDIT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_INITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ON_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ON_WARM_LEAD_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ON_WARM_LEAD_UPDATE_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ON_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SEND_TEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SEND_TEST_EMAIL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SEND_TEST_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SEND_TEST_EMAIL_FAILED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('classification');

// Org level settings
var FETCH_ASSISTANT_ORG_SETTINGS = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS');
var FETCH_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_PENDING');
var FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS');
var FETCH_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('FETCH_ASSISTANT_ORG_SETTINGS_FAILED');

var CREATE_ASSISTANT_ORG_SETTINGS = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS');
var CREATE_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_PENDING');
var CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS');
var CREATE_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('CREATE_ASSISTANT_ORG_SETTINGS_FAILED');

var PATCH_ASSISTANT_ORG_SETTINGS = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS');
var PATCH_ASSISTANT_ORG_SETTINGS_PENDING = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_PENDING');
var PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS');
var PATCH_ASSISTANT_ORG_SETTINGS_FAILED = makeConstant('PATCH_ASSISTANT_ORG_SETTINGS_FAILED');

// Agent level settings
var FETCH_ASSISTANT_AGENT_SETTINGS = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS');
var FETCH_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_PENDING');
var FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS');
var FETCH_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('FETCH_ASSISTANT_AGENT_SETTINGS_FAILED');

var CREATE_ASSISTANT_AGENT_SETTINGS = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS');
var CREATE_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_PENDING');
var CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS');
var CREATE_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('CREATE_ASSISTANT_AGENT_SETTINGS_FAILED');

var PATCH_ASSISTANT_AGENT_SETTINGS = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS');
var PATCH_ASSISTANT_AGENT_SETTINGS_PENDING = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_PENDING');
var PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS');
var PATCH_ASSISTANT_AGENT_SETTINGS_FAILED = makeConstant('PATCH_ASSISTANT_AGENT_SETTINGS_FAILED');

// Salesforce settings
var FETCH_SALESFORCE_SETTINGS = makeConstant('FETCH_SALESFORCE_SETTINGS');
var FETCH_SALESFORCE_SETTINGS_PENDING = makeConstant('FETCH_SALESFORCE_SETTINGS_PENDING');
var FETCH_SALESFORCE_SETTINGS_SUCCESS = makeConstant('FETCH_SALESFORCE_SETTINGS_SUCCESS');
var FETCH_SALESFORCE_SETTINGS_FAILED = makeConstant('FETCH_SALESFORCE_SETTINGS_FAILED');

// Personalization tags
var FETCH_PERSONALIZATION_TAGS = makeConstant('FETCH_PERSONALIZATION_TAGS');
var FETCH_PERSONALIZATION_TAGS_PENDING = makeConstant('FETCH_PERSONALIZATION_TAGS_PENDING');
var FETCH_PERSONALIZATION_TAGS_SUCCESS = makeConstant('FETCH_PERSONALIZATION_TAGS_SUCCESS');
var FETCH_PERSONALIZATION_TAGS_FAILED = makeConstant('FETCH_PERSONALIZATION_TAGS_FAILED');

// Editing state constants
var SET_INITIAL_ORG_EDIT_STATE = makeConstant('SET_INTITIAL_ORG_EDIT_STATE');

var SET_INITIAL = makeConstant('SET_INITIAL');
var ON_UPDATE = makeConstant('ON_UPDATE');
var ON_WARM_LEAD_UPDATE = makeConstant('ON_WARM_LEAD_UPDATE');
var ON_WARM_LEAD_UPDATE_TEMPLATE = makeConstant('ON_WARM_LEAD_UPDATE_TEMPLATE');
var ON_CANCEL = makeConstant('ON_CANCEL');

var SEND_TEST_EMAIL = makeConstant('SEND_TEST_EMAIL');
var SEND_TEST_EMAIL_PENDING = makeConstant('SEND_TEST_EMAIL_PENDING');
var SEND_TEST_EMAIL_SUCCESS = makeConstant('SEND_TEST_EMAIL_SUCCESS');
var SEND_TEST_EMAIL_FAILED = makeConstant('SEND_TEST_EMAIL_FAILED');

/***/ }),

/***/ "E4DR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("Fyqd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DEFAULT_SELECT_OPTIONS = {
  multi: false,
  searchable: true,
  autoFocus: false,
  clearable: false
};

var getCustomValuePrompt = function getCustomValuePrompt(label) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'drift-select-option-create' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Set static value "',
      label,
      '"'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'This is ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'not'
      ),
      ' a Drift Attribute'
    )
  );
};

var resolveSelectOptionForIntegration = function resolveSelectOptionForIntegration(selectProperty) {
  return { label: selectProperty.displayName, value: selectProperty.name };
};
var resolveSelectOptionForDrift = function resolveSelectOptionForDrift(selectProperty) {
  return { label: selectProperty.label, value: selectProperty.value };
};

var resolveSelectOptions = function resolveSelectOptions(selectProperties, resolveSelectOption) {

  var reducer = function reducer(accumulator, currentValue) {
    if (!currentValue) return accumulator;
    var typeArray = accumulator[currentValue.type] || { label: currentValue.type, options: [] };
    typeArray.options.push(resolveSelectOption(currentValue));
    accumulator[currentValue.type] = typeArray;
    return accumulator;
  };

  var initialValue = {};
  return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["flatMap"])(selectProperties.reduce(reducer, initialValue));
};

var AttributeMappingRow = function (_Component) {
  _inherits(AttributeMappingRow, _Component);

  function AttributeMappingRow(props) {
    _classCallCheck(this, AttributeMappingRow);

    var _this = _possibleConstructorReturn(this, (AttributeMappingRow.__proto__ || Object.getPrototypeOf(AttributeMappingRow)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      driftAttributes: _.cloneDeep(props.driftAttributes),
      staticValues: _this.setupStaticValues(props),
      isTypeDirty: false
    };

    _this.setupStaticValues(props);
    return _this;
  }

  _createClass(AttributeMappingRow, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ staticValues: this.setupStaticValues(nextProps) });
    }
  }, {
    key: 'isMappingEditable',
    value: function isMappingEditable(mapping) {
      return !_.isUndefined(mapping.editable) ? mapping.editable : true;
    }
  }, {
    key: 'renderIntegrationLabel',
    value: function renderIntegrationLabel(property) {
      if (!property) return;

      var displayName = property.displayName,
          required = property.required;

      var formatDisplayName = function formatDisplayName() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'integration-mapping-display-name' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: required && 'required' },
            '* '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            displayName
          )
        );
      };

      return displayName ? formatDisplayName() : '';
    }
  }, {
    key: 'renderDefaultAttributeTextBox',
    value: function renderDefaultAttributeTextBox(defaultValue, driftValue, disabled) {
      return driftValue && !disabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { type: 'text', placeholder: 'Optional', defaultValue: defaultValue || "", value: this.state.value, onChange: this.handleInputChange }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { className: 'uneditable', placeholder: 'N/A', disabled: true });
    }
  }, {
    key: 'clearDriftAttributeSelectionIfTypeChanged',
    value: function clearDriftAttributeSelectionIfTypeChanged(value) {
      var _props = this.props,
          mapping = _props.mapping,
          integrationAttributes = _props.integrationAttributes;


      var currentIntegrationAttribute = _.find(integrationAttributes, { name: mapping.integrationAttribute });

      if (currentIntegrationAttribute) {
        var newIntegrationAttribute = _.find(integrationAttributes, { displayName: value.label });
        if (currentIntegrationAttribute.type !== newIntegrationAttribute.type) {
          this.setState({ isTypeDirty: true });
        }
      }
    }
  }, {
    key: 'renderDriftAttributeSelect',
    value: function renderDriftAttributeSelect(selectedProperty, disabled) {
      var _this2 = this;

      var _state = this.state,
          staticValues = _state.staticValues,
          isTypeDirty = _state.isTypeDirty;
      var driftAttributes = this.props.driftAttributes;

      var availableAttributes = [].concat(_toConsumableArray(driftAttributes), _toConsumableArray(staticValues));
      var selectedValue = !isTypeDirty && !!selectedProperty ? availableAttributes.filter(function (property) {
        return property.value == selectedProperty;
      })[0] : null;

      selectedValue && delete selectedValue.className;

      var reducedProps = resolveSelectOptions(availableAttributes, resolveSelectOptionForDrift);

      var options = {
        value: selectedValue,
        options: reducedProps,
        className: "drift-attribute-mapping",
        disabled: disabled,
        promptTextCreator: function promptTextCreator(label) {
          return getCustomValuePrompt(label);
        },
        onNewOptionClick: function onNewOptionClick(value) {
          return _this2.createStaticPropertyMapping(value.value);
        },
        onChange: function onChange(value) {
          return _this2.updateDriftPropertyInMapping(value.value);
        }
      };

      var selectOptions = _.assign({}, options, DEFAULT_SELECT_OPTIONS);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["a" /* Creatable */], selectOptions);
    }
  }, {
    key: 'renderIntegrationAttributeSelect',
    value: function renderIntegrationAttributeSelect(selectedProperty) {
      var _this3 = this;

      var integrationAttributes = this.props.integrationAttributes;

      var attributes = integrationAttributes || [];

      var supportedProperties = attributes.filter(function (property) {
        return !property.unsupported && !property.required;
      });

      var reducedProps = resolveSelectOptions(supportedProperties, resolveSelectOptionForIntegration);

      var options = {
        value: selectedProperty,
        options: reducedProps,
        onChange: function onChange(value) {
          return _this3.updateIntegrationFieldInMapping(value);
        }
      };
      var selectOptions = _.assign({}, options, DEFAULT_SELECT_OPTIONS);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          mapping = _props2.mapping,
          index = _props2.index,
          integrationAttributes = _props2.integrationAttributes,
          allowAttributeDefaults = _props2.allowAttributeDefaults,
          allowAttributeOverwrites = _props2.allowAttributeOverwrites;
      var integrationAttribute = mapping.integrationAttribute,
          driftAttribute = mapping.driftAttribute,
          defaultValue = mapping.defaultValue,
          isOverwritable = mapping.isOverwritable;


      var matchedIntegrationAttribute = _.find(integrationAttributes, { name: integrationAttribute });
      var isRequired = matchedIntegrationAttribute ? matchedIntegrationAttribute.required : false;
      var isUneditable = !this.isMappingEditable(mapping);
      var staticOrDriftProperty = driftAttribute || defaultValue;

      var integrationProperty = isRequired || isUneditable ? this.renderIntegrationLabel(matchedIntegrationAttribute) : this.renderIntegrationAttributeSelect(integrationAttribute, index);

      var typeValue = this.renderMappingType({ driftAttribute: driftAttribute, defaultValue: defaultValue, matchedIntegrationAttribute: matchedIntegrationAttribute });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { className: isUneditable && 'un-editable' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'delete-mapping-checkbox' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: isUneditable || isRequired, value: index, type: 'checkbox', onChange: this.props.updateDeleteProperties })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'mapping-drift-attribute' },
          isUneditable ? this.renderDriftAttributeSelect(staticOrDriftProperty, true, index) : this.renderDriftAttributeSelect(staticOrDriftProperty, false, index)
        ),
        allowAttributeDefaults && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'mapping-drift-attribute' },
          this.renderDefaultAttributeTextBox(defaultValue, driftAttribute, isUneditable)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'type-column' },
          typeValue
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          integrationProperty
        ),
        allowAttributeOverwrites != false && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'overwrite-column' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Toggle"], { checked: isOverwritable, onChange: this.updateIsOverwritableInMapping })
        )
      );
    }
  }]);

  return AttributeMappingRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setupStaticValues = function (props) {
    if (!!props.mapping.defaultValue && !props.mapping.driftAttribute) {
      return [{ label: props.mapping.defaultValue.toString(), value: props.mapping.defaultValue }];
    }
    return [];
  };

  this.createDefaultPropertyMapping = function (value) {
    var _props3 = _this4.props,
        mapping = _props3.mapping,
        index = _props3.index;

    var staticValues = [].concat(_toConsumableArray(_this4.state.staticValues));
    staticValues.push(value);

    _this4.setState({ staticValues: staticValues });

    mapping.defaultValue = value;
    mapping.static = true;

    _this4.props.updateMapping(index, mapping);
  };

  this.createStaticPropertyMapping = function (value) {
    var _props4 = _this4.props,
        mapping = _props4.mapping,
        index = _props4.index;

    var staticValues = [].concat(_toConsumableArray(_this4.state.staticValues));
    staticValues.push(value);

    _this4.setState({ staticValues: staticValues });

    mapping.driftAttribute = null;
    mapping.defaultValue = value;
    mapping.static = true;

    _this4.props.updateMapping(index, mapping);
  };

  this.handleInputChange = function (e) {
    return _this4.createDefaultPropertyMapping(e.target.value);
  };

  this.updateDriftPropertyInMapping = function (value) {
    var _props5 = _this4.props,
        mapping = _props5.mapping,
        index = _props5.index;

    if (!!_.find(_this4.state.staticValues, { value: value })) {
      mapping.defaultValue = value;
      mapping.driftAttribute = null;
    } else {
      mapping.driftAttribute = value;
    }

    if (_this4.state.isTypeDirty) {
      _this4.setState({ isTypeDirty: false });
    }
    _this4.props.updateMapping(index, mapping);
  };

  this.updateIntegrationFieldInMapping = function (value) {
    var _props6 = _this4.props,
        mapping = _props6.mapping,
        index = _props6.index;


    _this4.clearDriftAttributeSelectionIfTypeChanged(value);
    mapping.integrationAttribute = value ? value.value : null;

    _this4.props.updateMapping(index, mapping);
  };

  this.updateIsOverwritableInMapping = function () {
    var _props7 = _this4.props,
        mapping = _props7.mapping,
        index = _props7.index;

    mapping.isOverwritable = !mapping.isOverwritable;
    _this4.props.updateMapping(index, mapping);
  };

  this.renderMappingType = function (_ref) {
    var driftAttribute = _ref.driftAttribute,
        defaultValue = _ref.defaultValue,
        matchedIntegrationAttribute = _ref.matchedIntegrationAttribute;


    if (driftAttribute && matchedIntegrationAttribute && matchedIntegrationAttribute.type) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'type-field' },
        matchedIntegrationAttribute.type.toLowerCase()
      );
    }

    if (!driftAttribute && defaultValue) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'static-value' },
        'Static Value'
      );
    }

    return null;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (AttributeMappingRow);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "E6DY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(445);

/***/ }),

/***/ "EBDq":
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70 72\"><g id=\"ld_x5F_logo\"><path class=\"st0\" d=\"M64.47 35.56c0 15.83-13.14 28.66-29.36 28.66S5.77 51.39 5.77 35.56 18.91 6.89 35.12 6.89s29.35 12.84 29.35 28.67\"></path><path class=\"st1\" d=\"M32.78 24.57H48v20.54H32.78z\"></path><path class=\"st2\" d=\"M38.44 44.42h-3.76V26.24h3.81c3.9 0 5.66 1.56 6.68 3.03 1.25 1.87 1.67 4.23 1.67 6.1 0 4.68-1.86 9.05-8.4 9.05m14.01-19.43c-4.46-6.15-11.32-6.15-15.18-6.15H25.91v32.31c2.58.47 5.25.12 7.85.11.18 0 .32.07.41.17h.02c.29 0 .46.17.52.38h3.23c13.04 0 17.68-7.57 17.68-16.57-.01-3.61-.8-7.13-3.17-10.25\"></path><path class=\"st1\" d=\"M17.58 18.85h8.45v25.54l8.59.03.01 7.34-17.06-.05z\"></path></g><g id=\"ld_x5F_logo_1_\"><path class=\"st0\" d=\"M-248.53 35.56c0 15.83-13.14 28.66-29.36 28.66-16.21 0-29.35-12.83-29.35-28.66S-294.1 6.9-277.89 6.9c16.22-.01 29.36 12.83 29.36 28.66\"></path><path class=\"st1\" d=\"M-280.22 24.57H-265v20.54h-15.22z\"></path><path class=\"st2\" d=\"M-274.56 44.42h-3.76V26.24h3.81c3.9 0 5.66 1.56 6.68 3.03 1.25 1.87 1.67 4.23 1.67 6.1 0 4.68-1.86 9.05-8.4 9.05m14.01-19.43c-4.46-6.15-11.32-6.15-15.18-6.15h-11.37v32.31c2.58.47 5.25.12 7.85.11.18 0 .32.07.41.17h.02c.29 0 .46.17.52.38h3.23c13.04 0 17.68-7.57 17.68-16.57 0-3.61-.79-7.13-3.16-10.25\"></path><path class=\"st1\" d=\"M-295.42 18.85h8.45v25.54l8.59.03.01 7.34-17.06-.05zM-241.81 18.79h3.49v29.87h13.42v3.19h-16.91zM-200.63 37.15c-.44-1.68-1.09-3.02-1.93-4.02-.85-1-1.97-1.81-3.36-2.43-1.39-.61-2.86-.92-4.39-.92-2.53 0-4.71.77-6.53 2.32-1.33 1.12-2.33 2.81-3.01 5.06h19.22zm0 6.59l2.8 1.39c-.92 1.71-1.98 3.09-3.18 4.14a12.51 12.51 0 0 1-4.06 2.39c-1.5.55-3.2.82-5.1.82-4.21 0-7.5-1.31-9.87-3.92-2.37-2.61-3.56-5.57-3.56-8.87 0-3.1 1-5.87 3.01-8.29 2.55-3.09 5.96-4.63 10.23-4.63 4.4 0 7.91 1.58 10.54 4.74 1.87 2.23 2.82 5.02 2.85 8.36h-23.21c.06 2.84 1.02 5.17 2.87 6.98 1.85 1.82 4.14 2.72 6.86 2.72 1.31 0 2.59-.22 3.83-.65 1.24-.43 2.3-1.01 3.17-1.72.86-.71 1.8-1.86 2.82-3.46M-180.79 29.8c-1.85 0-3.55.43-5.12 1.29a9.703 9.703 0 0 0-3.73 3.63c-.92 1.56-1.38 3.2-1.38 4.94 0 1.72.47 3.37 1.4 4.94.93 1.57 2.18 2.8 3.75 3.67 1.57.88 3.26 1.31 5.06 1.31 1.82 0 3.54-.43 5.16-1.3 1.63-.87 2.88-2.04 3.75-3.52.88-1.48 1.31-3.15 1.31-5.01 0-2.83-.98-5.19-2.95-7.09-1.96-1.91-4.38-2.86-7.25-2.86m13.27-2.4v24.45h-3.27v-4.2c-1.39 1.6-2.95 2.81-4.68 3.62-1.73.81-3.62 1.21-5.68 1.21-3.65 0-6.77-1.25-9.35-3.76s-3.88-5.56-3.88-9.16c0-3.52 1.3-6.53 3.91-9.03 2.61-2.5 5.74-3.75 9.41-3.75 2.12 0 4.03.43 5.75 1.28 1.71.85 3.22 2.14 4.52 3.84v-4.5h3.27zM-162.97 27.4h3.32v4.38c1.33-1.68 2.8-2.93 4.41-3.76 1.61-.83 3.37-1.25 5.26-1.25 1.93 0 3.64.46 5.13 1.39 1.49.93 2.6 2.18 3.31 3.75.71 1.57 1.07 4.02 1.07 7.35v12.59h-3.32V40.19c0-2.82-.12-4.7-.37-5.64-.38-1.62-1.12-2.84-2.21-3.65-1.09-.82-2.51-1.22-4.27-1.22-2.01 0-3.81.63-5.39 1.89-1.59 1.26-2.64 2.82-3.14 4.68-.32 1.21-.47 3.43-.47 6.65v8.97h-3.32V27.4z\"></path><path class=\"st0\" d=\"M-129.87 25.02v20.86h3.2c3.15 0 5.44-.33 6.86-.99 1.42-.66 2.58-1.77 3.49-3.33.9-1.56 1.35-3.48 1.35-5.76 0-3.51-1.08-6.23-3.23-8.17-1.94-1.74-5.05-2.61-9.33-2.61h-2.34zm-6.85-6.07h8.17c5.27 0 9.18.6 11.74 1.79 2.56 1.19 4.67 3.13 6.32 5.81 1.66 2.68 2.49 5.81 2.49 9.39 0 2.55-.46 4.89-1.39 7.02-.93 2.13-2.21 3.91-3.84 5.32-1.63 1.41-3.4 2.38-5.3 2.92s-5.2.81-9.89.81h-8.29V18.95zM-92.48 32.59c-2.08 0-3.81.67-5.18 2.01-1.37 1.34-2.06 3.06-2.06 5.16 0 2.11.7 3.85 2.1 5.21 1.4 1.36 3.12 2.05 5.17 2.05 2.11 0 3.86-.67 5.25-2.01 1.39-1.34 2.09-3.1 2.09-5.27 0-2.13-.7-3.85-2.09-5.17-1.4-1.32-3.15-1.98-5.28-1.98m7.07-5.03h6.72v24.45h-6.72v-2.59c-1.31 1.14-2.63 1.96-3.95 2.46-1.32.5-2.75.75-4.29.75-3.46 0-6.45-1.22-8.98-3.67-2.53-2.45-3.79-5.49-3.79-9.14 0-3.78 1.22-6.87 3.67-9.28 2.44-2.41 5.41-3.62 8.91-3.62 1.61 0 3.12.28 4.53.83 1.41.55 2.71 1.39 3.91 2.49v-2.68zM-72.34 18.54h6.72v9.02h3.99v5.28h-3.99v19.17h-6.72V32.84h-3.45v-5.28h3.45zM-47.09 32.59c-2.08 0-3.81.67-5.18 2.01-1.37 1.34-2.06 3.06-2.06 5.16 0 2.11.7 3.85 2.1 5.21 1.4 1.36 3.12 2.05 5.17 2.05 2.11 0 3.86-.67 5.25-2.01 1.39-1.34 2.09-3.1 2.09-5.27 0-2.13-.7-3.85-2.09-5.17-1.39-1.32-3.15-1.98-5.28-1.98m7.07-5.03h6.72v24.45h-6.72v-2.59c-1.31 1.14-2.63 1.96-3.95 2.46-1.32.5-2.75.75-4.29.75-3.46 0-6.45-1.22-8.98-3.67-2.53-2.45-3.79-5.49-3.79-9.14 0-3.78 1.22-6.87 3.67-9.28 2.44-2.41 5.41-3.62 8.91-3.62 1.61 0 3.12.28 4.53.83 1.41.55 2.71 1.39 3.91 2.49v-2.68z\"></path><path d=\"M-29.95 22.85c0-.52.13-1 .4-1.45.26-.45.63-.81 1.09-1.07.46-.26.96-.39 1.49-.39s1.02.13 1.48.39c.46.26.83.61 1.09 1.06.27.45.4.94.4 1.46 0 .51-.13.98-.38 1.43-.26.45-.61.8-1.08 1.07-.46.27-.97.4-1.52.4s-1.05-.13-1.51-.4-.82-.62-1.08-1.07a2.76 2.76 0 0 1-.38-1.43zm.41 0c0 .45.11.86.34 1.25.23.39.54.69.94.92.4.22.82.33 1.28.33.46 0 .89-.11 1.28-.34.39-.22.71-.53.94-.91.23-.38.35-.8.35-1.25 0-.45-.12-.86-.34-1.25-.23-.38-.54-.69-.93-.91-.39-.23-.82-.34-1.28-.34-.46 0-.89.11-1.28.34-.39.22-.71.53-.94.91s-.36.8-.36 1.25zm3.77-.7a.932.932 0 0 1-.64.9l.94 1.53h-.67l-.82-1.37h-.53v1.37h-.59v-3.44h1.03c.44 0 .76.08.96.25.22.16.32.42.32.76zm-1.72.58h.43c.21 0 .38-.05.51-.16s.19-.24.19-.41c0-.19-.06-.33-.17-.42-.11-.08-.29-.13-.54-.13h-.42v1.12z\" fill=\"#2db670\"></path></g></svg>"

/***/ }),

/***/ "EBU2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("oaic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var getCalendarUserMicrocopy = function getCalendarUserMicrocopy(ctaType) {
  if (ctaType === __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT) {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["P"],
      { className: 'calendar-user-microcopy' },
      'Note: Calendar Users will be skipped because they don\u2019t have permissions to respond to conversations.\xA0',
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["A"],
        { href: 'https://gethelp.drift.com/hc/en-us/articles/360021492813-The-Calendar-Seat' },
        'Learn more'
      )
    );
  }
  if (ctaType === __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING) {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["P"],
      { className: 'calendar-user-microcopy' },
      'Note: Calendar users don\'t have permissions to reply to conversations.\xA0',
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["A"],
        { href: 'https://gethelp.drift.com/hc/en-us/articles/360021492813-The-Calendar-Seat' },
        'Learn more'
      )
    );
  }
};

var MessageCta = function MessageCta(_ref) {
  var showCtaCopy = _ref.showCtaCopy,
      showCtaUrl = _ref.showCtaUrl,
      onCtaChange = _ref.onCtaChange,
      onCtaCopyChange = _ref.onCtaCopyChange,
      onCtaLinkChange = _ref.onCtaLinkChange,
      CtaTypeOptions = _ref.CtaTypeOptions,
      cta = _ref.cta,
      _ref$hideUrl = _ref.hideUrl,
      hideUrl = _ref$hideUrl === undefined ? false : _ref$hideUrl,
      _ref$hideCopy = _ref.hideCopy,
      hideCopy = _ref$hideCopy === undefined ? false : _ref$hideCopy,
      isOnFreePlan = _ref.isOnFreePlan,
      isABMPlaybook = _ref.isABMPlaybook;
  return React.createElement(
    'span',
    { className: 'playbook-message-cta-fields' },
    React.createElement(
      'div',
      { className: 'playbook-edit-message-heading' },
      'CTA Type'
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__["b" /* default */], { options: CtaTypeOptions, value: cta.type, onChange: onCtaChange, disabled: isOnFreePlan }),
    isABMPlaybook && getCalendarUserMicrocopy(cta.type),
    !!showCtaCopy && !hideCopy && React.createElement(
      'span',
      null,
      React.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'CTA Copy'
      ),
      React.createElement('input', { type: 'text', onChange: onCtaCopyChange, value: cta.copy || '' })
    ),
    !!showCtaUrl && !hideUrl && React.createElement(
      'span',
      null,
      React.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'CTA Link'
      ),
      React.createElement('input', { type: 'url', onChange: onCtaLinkChange, value: cta.url || '' }),
      !cta.url && React.createElement(
        'div',
        { className: 'warning' },
        'Please enter a fully-qualified URL, ex: https://drift.com'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MessageCta);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "EETw":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 53 39\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#CCC\" fill-rule=\"evenodd\"><path d=\"M0 6.067c0-3.313 2.683-6 6.002-6h40.996a6.002 6.002 0 0 1 6.002 6v26c0 3.314-2.683 6-6.002 6H6.002a6.002 6.002 0 0 1-6.002-6v-26zm5.994-3h41.012A2.99 2.99 0 0 1 50 6.063V32.07a2.997 2.997 0 0 1-2.994 2.997H5.994A2.99 2.99 0 0 1 3 32.07V6.064a2.997 2.997 0 0 1 2.994-2.996z\"></path><path d=\"M22.47 21.15L1.554 6.84a1.277 1.277 0 0 1-.334-1.772c.397-.58 1.283-1.274 1.867-.877L24 18.5a4.566 4.566 0 0 0 5.184 0L50.098 4.19c.584-.394 1.28.3 1.68.878.397.58.25 1.374-.333 1.772L30.532 21.15a7.12 7.12 0 0 1-4.032 1.256 7.12 7.12 0 0 1-4.03-1.257z\"></path></g></svg>"

/***/ }),

/***/ "EGTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("qdP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DEFAULT_LABEL = "Don't set type";
var UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.';
var DEFAULT_OPTION = { id: null, name: DEFAULT_LABEL };

var taskToSelectOption = function taskToSelectOption(name) {
  return {
    id: name,
    name: name
  };
};

var SalesforceTaskTypeSelect = function (_Component) {
  _inherits(SalesforceTaskTypeSelect, _Component);

  function SalesforceTaskTypeSelect(props) {
    _classCallCheck(this, SalesforceTaskTypeSelect);

    var _this = _possibleConstructorReturn(this, (SalesforceTaskTypeSelect.__proto__ || Object.getPrototypeOf(SalesforceTaskTypeSelect)).call(this, props));

    _this.getInitialValue = function () {
      var promises = [__WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceTaskTypeList(), __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceTaskTypePhone()];

      var onDone = function onDone(_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ref2$ = _ref2[0],
            taskTypes = _ref2$ === undefined ? [] : _ref2$,
            taskType = _ref2[1];

        _this.setState({
          isLoading: false,
          selectOptions: taskTypes.map(taskToSelectOption),
          selectValue: taskType
        });
      };

      Promise.all(promises).then(onDone).catch(_this.handleUnknownError);
    };

    _this.handleUnknownError = function () {
      _this.setState({
        isLoading: false,
        hasError: true,
        errorText: UNKNOWN_ERROR
      });
    };

    _this.hideToast = function () {
      _this.setState({ showSuccessToast: false });
    };

    _this.onChange = function (_ref3) {
      var id = _ref3.id,
          name = _ref3.name;

      var onDone = function onDone() {
        _this.setState({ isLoading: false, showSuccessToast: true });
      };

      var patch = __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].patchSalesforceTaskTypePhone({ taskType: id }).then(onDone).then(function () {
        return setTimeout(_this.hideToast, 3500);
      }).catch(_this.handleUnknownError);

      _this.setState({
        selectValue: id,
        selectLabel: name,
        isLoading: true
      }, patch);
    };

    _this.resolveSelectOptions = function () {
      var selectOptions = _this.state.selectOptions;

      return [DEFAULT_OPTION].concat(_toConsumableArray(selectOptions));
    };

    _this.state = {
      isLoading: true,
      hasError: false,
      selectValue: null,
      selectLabel: null,
      selectOptions: [],
      showSuccessToast: false
    };
    return _this;
  }

  _createClass(SalesforceTaskTypeSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInitialValue();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectValue = _state.selectValue,
          selectLabel = _state.selectLabel,
          isLoading = _state.isLoading;

      var options = this.resolveSelectOptions();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-activity-select-container' },
        this.state.showSuccessToast && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-activity-select--toast' },
          'Your integration settings have been updated.',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: this.hideToast, className: 'salesforce-activity-select--toast-dismiss' },
            'Dismiss'
          ),
          ' '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'salesforce-activity-select-input',
          labelKey: 'name',
          valueKey: 'id',
          autosize: false,
          clearable: false,
          placeholder: DEFAULT_LABEL,
          value: selectValue,
          label: selectLabel,
          options: options,
          isLoading: isLoading,
          onChange: this.onChange,
          resetValue: DEFAULT_OPTION
        }),
        this.state.hasError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'salesforce-task-error-text' },
          this.state.errorText
        )
      );
    }
  }]);

  return SalesforceTaskTypeSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceTaskTypeSelect);

/***/ }),

/***/ "EI0t":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 24 24\"><path d=\"M23 13H13v10a1 1 0 0 1-2 0V13H1a1 1 0 0 1 0-2h10V1a1 1 0 0 1 2 0v10h10a1 1 0 0 1 0 2z\" class=\"cls-1\"></path></svg>"

/***/ }),

/***/ "ENVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Crunchbase = function Crunchbase() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    {
      width: "30",
      height: "30",
      version: "1.1",
      viewBox: "0 0 64 64",
      xmlns: "http://www.w3.org/2000/svg"
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "m64 8c0-4.4174-3.5826-8-8-8h-48c-4.4174 0-8 3.5826-8 8v48c0 4.4174 3.5826 8 8 8h48c4.4174 0 8-3.5826 8-8z",
      "clip-rule": "evenodd",
      fill: "#445cff",
      "fill-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.414",
      "stroke-width": ".10475"
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      {
        transform: "matrix(2.3849 0 0 2.3849 -9.545 -43.547)",
        fill: "#fff",
        "stroke-width": ".57409"
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m13.94 33.658a2.9623 2.9623 0 1 1 0.03444-2.4399h2.2963a5.1668 5.1668 0 1 0 0 2.4399h-2.2963z" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "m23.511 27.257h-0.3789a5.0979 5.0979 0 0 0-2.526 0.88983v-5.7523h-2.0954v14.794h2.1069v-0.53964a5.1668 5.1668 0 1 0 2.8934-9.392zm2.9623 5.5342v0.09185a2.9393 2.9393 0 0 1-0.08037 0.36167 2.9336 2.9336 0 0 1-0.14352 0.37316v0.04593a2.9795 2.9795 0 0 1-2.0724 1.6247l-0.2813 0.04593h-0.06315a2.9164 2.9164 0 0 1-0.32149 0 2.9623 2.9623 0 0 1-0.40186-0.02871h-0.09185a2.9336 2.9336 0 0 1-0.75205-0.22963h-0.05741a2.9738 2.9738 0 0 1-0.66594-0.44779 2.991 2.991 0 0 1-0.52242-0.62575 2.9623 2.9623 0 0 1-0.18945-0.36741 2.9451 2.9451 0 0 1 0.03445-2.4399 2.968 2.968 0 0 1 2.3767-1.6821 2.9336 2.9336 0 0 1 0.30426 0 2.968 2.968 0 0 1 2.9278 2.8819 2.9565 2.9565 0 0 1 0 0.39612z" })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Crunchbase);

/***/ }),

/***/ "EOku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return randomChoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return recentDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pastDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return companyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return jobTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return avatar; });
// copied from faker
// import faker from 'faker'

var randomChoice = function randomChoice(array) {
  return array[Math.floor(Math.random() * array.length)];
};

var recentDate = function recentDate(days) {
  var date = new Date();
  var range = {
    min: 1000,
    max: (days || 1) * 24 * 3600 * 1000
  };

  var future = date.getTime();
  future -= Math.random() * (range.max - range.min) + range.min;
  date.setTime(future);

  return date;
};

var pastDate = function pastDate(years, refDate) {
  var date = refDate ? new Date(Date.parse(refDate)) : new Date();
  var range = {
    min: 1000,
    max: (years || 1) * 365 * 24 * 3600 * 1000
  };

  var past = date.getTime();
  past -= Math.random() * (range.max - range.min) + range.min;
  date.setTime(past);

  return date;
};

var fullName = function fullName() {
  return randomChoice(firstNames) + " " + randomChoice(lastNames);
};

var companyName = function companyName() {
  return randomChoice(lastNames) + " " + randomChoice(companySuffix);
};

var jobTitle = function jobTitle() {
  return randomChoice(jobDescriptor) + " " + randomChoice(jobLevels) + " " + randomChoice(jobs);
};

var email = function email() {
  return "" + randomChoice(firstNames)[0] + randomChoice(lastNames) + "@" + randomChoice(emailProviders);
};

var avatar = function avatar() {
  return randomChoice(avatarUris);
};

var avatarUris = ["https://s3.amazonaws.com/uifaces/faces/twitter/jarjan/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mahdif/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/sprayaga/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ruzinav/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/Skyhartman/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/moscoz/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kurafire/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/91bilal/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/igorgarybaldi/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/calebogden/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/malykhinv/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joelhelin/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kushsolitary/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/coreyweb/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/snowshade/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/areus/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/holdenweb/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/heyimjuani/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/envex/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/unterdreht/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/collegeman/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/peejfancher/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/andyisonline/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ultragex/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/fuck_you_two/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/adellecharles/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ateneupopular/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetalpbalkan/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/Stievius/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kerem/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/osvaldas/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/angelceballos/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/thierrykoblentz/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/peterlandt/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/catarino/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/weglov/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/brandclay/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ahmetsulek/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/nicolasfolliot/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jayrobinson/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/victorerixon/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kolage/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/michzen/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/markjenkins/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/nicolai_larsen/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/gt/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/noxdzine/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/alagoon/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/idiot/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mizko/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/chadengle/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mutlu82/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/simobenso/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/vocino/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/guiiipontes/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/soyjavi/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joshaustin/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/tomaslau/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/VinThomas/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ManikRathee/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/langate/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/cemshid/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/leemunroe/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/_shahedk/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/enda/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/BillSKenney/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/divya/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joshhemsley/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/sindresorhus/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/soffes/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/9lessons/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/linux29/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/Chakintosh/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/anaami/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joreira/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/shadeed9/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/scottkclark/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jedbridges/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/salleedesign/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/marakasina/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ariil/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/BrianPurkiss/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/michaelmartinho/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/bublienko/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/devankoshal/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ZacharyZorbas/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/timmillwood/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joshuasortino/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/tomas_janousek/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/herrhaase/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/RussellBishop/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/brajeshwar/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/cbracco/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/bermonpainter/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/abdullindenis/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/isacosta/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/suprb/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/yalozhkin/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/chandlervdw/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/iamgarth/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/_victa/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/commadelimited/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/roybarberuk/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/axel/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/vladarbatov/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ffbel/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/syropian/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ankitind/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/traneblow/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/flashmurphy/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ChrisFarina78/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/baliomega/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/saschamt/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jm_denis/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/anoff/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kennyadr/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/chatyrko/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/dingyi/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mds/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/terryxlife/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/aaroni/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kinday/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/prrstn/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/eduardostuart/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/dhilipsiva/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/GavicoInd/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/baires/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/rohixx/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/bigmancho/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/blakesimkins/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/leeiio/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/tjrus/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/uberschizo/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/kylefoundry/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/claudioguglieri/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/ripplemdk/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/exentrich/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jakemoore/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/joaoedumedeiros/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/poormini/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/tereshenkov/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/keryilmaz/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/haydn_woods/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/rude/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/llun/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/sgaurav_baghel/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jamiebrittain/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/badlittleduck/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/pifagor/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/agromov/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/benefritz/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/erwanhesry/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/diesellaws/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jeremiaha/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/koridhandy/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/chaensel/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/andrewcohen/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/smaczny/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/gonzalorobaina/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/nandini_m/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/sydlawrence/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/cdharrison/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/tgerken/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/lewisainslie/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/charliecwaite/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/robbschiller/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/flexrs/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mattdetails/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/raquelwilson/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/karsh/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/mrmartineau/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/opnsrce/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/hgharrygo/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/maximseshuk/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/uxalex/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/samihah/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/chanpory/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/sharvin/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/josemarques/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/jefffis/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/krystalfister/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/lokesh_coder/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/thedamianhdez/128.jpg", "https://s3.amazonaws.com/uifaces/faces/twitter/dpmachado/128.jpg"];

var emailProviders = ["gmail.com", "yahoo.com", "hotmail.com"];

var jobLevels = ["Solutions", "Program", "Brand", "Security", "Research", "Marketing", "Directives", "Implementation", "Integration", "Functionality", "Response", "Paradigm", "Tactics", "Identity", "Markets", "Group", "Division", "Applications", "Optimization", "Operations", "Infrastructure", "Intranet", "Communications", "Web", "Branding", "Quality", "Assurance", "Mobility", "Accounts", "Data", "Creative", "Configuration", "Accountability", "Interactions", "Factors", "Usability", "Metrics"];

var jobs = ["Supervisor", "Associate", "Executive", "Liaison", "Officer", "Manager", "Engineer", "Specialist", "Director", "Coordinator", "Administrator", "Architect", "Analyst", "Designer", "Planner", "Orchestrator", "Technician", "Developer", "Producer", "Consultant", "Assistant", "Facilitator", "Agent", "Representative", "Strategist"];

var jobDescriptor = ["Lead", "Senior", "Direct", "Corporate", "Dynamic", "Future", "Product", "National", "Regional", "District", "Central", "Global", "Customer", "Investor", "Dynamic", "International", "Legacy", "Forward", "Internal", "Human", "Chief", "Principal"];

var companySuffix = ["Inc", "and Sons", "LLC", "Group"];

var lastNames = ["Altenwerth", "Armstrong", "Auer", "Aufderhar", "Bahringer", "Bailey", "Balistreri", "Bashirian", "Batz", "Beatty", "Bechtelar", "Becker", "Bednar", "Beer", "Beier", "Berge", "Bins", "Blanda", "Blick", "Bruen", "Buckridge", "Carroll", "Cole", "Collier", "Considine", "Crist", "Crona", "Cummings", "Dach", "D'Amore", "Deckow", "Denesik", "Dibbert", "Donnelly", "Dooley", "Douglas", "Doyle", "DuBuque", "Durgan", "Ebert", "Feest", "Feil", "Ferry", "Fisher", "Flatley", "Frami", "Gislason", "Gleason", "Goldner", "Goodwin", "Gorczany", "Hahn", "Hansen", "Harber", "Harris", "Hartmann", "Harvey", "Hauck", "Hayes", "Heaney", "Herman", "Hermann", "Hodkiewicz", "Hoeger", "Homenick", "Hyatt", "Jacobi", "Jacobs", "Jaskolski", "Jast", "Jenkins", "Jerde", "Johns", "Johnson", "Johnston", "Keeling", "Kemmer", "Kerluke", "Kertzmann", "Kessler", "Kirlin", "Klein", "Kling", "Klocko", "Koch", "Koelpin", "Koepp", "Kohler", "Krajcik", "Kreiger", "Kris", "Kshlerin", "Kulas", "Lakin", "Lang", "Langosh", "Langworth", "Larkin", "Larson", "Legros", "Lehner", "Lemke", "Lesch", "Leuschke", "Lind", "Lindgren", "Littel", "Lynch", "Macejkovic", "MacGyver", "Maggio", "Mann", "Mante", "Marks", "McClure", "McCullough", "McDermott", "Mohr", "Monahan", "Moore", "Morar", "Muller", "Murazik", "Murphy", "Murray", "O'Keefe", "O'Kon", "Okuneva", "Olson", "Ondricka", "O'Reilly", "Padberg", "Pagac", "Pouros", "Powlowski", "Predovic", "Rath", "Ratke", "Rau", "Raynor", "Reichel", "Reichert", "Runolfsdottir", "Sanford", "Sawayn", "Schaden", "Schaefer", "Schmeler", "Schmidt", "Schmitt", "Schowalter", "Schroeder", "Schulist", "Schultz", "Stamm", "Stanton", "Stark", "Stehr", "Terry", "Thiel", "Thompson", "Tillman", "Trantow", "Von", "VonRueden", "West", "White", "Williamson", "Wintheiser", "Wisoky", "Wisozk", "Wolf", "Wolff", "Wuckert", "Wunsch", "Wyman", "Ziemann", "Zieme", "Zulauf"];

var firstNames = ["Abdullah", "Abe", "Abel", "Abelardo", "Abigail", "Abigale", "Abigayle", "Abner", "Aiden", "Aileen", "Aimee", "Aisha", "Aiyana", "Akeem", "Al", "Alaina", "Alan", "Alana", "Alexandrea", "Alexandria", "Alexandrine", "Alexandro", "Alexane", "Alexanne", "Alexie", "Alexis", "Alexys", "Alexzander", "Amani", "Amara", "Amari", "Amaya", "Amber", "Anibal", "Anika", "Anissa", "Anita", "Aniya", "Aniyah", "Anjali", "Anna", "Annabel", "Annalise", "Annamae", "Annamarie", "Anne", "Annetta", "Annette", "Annie", "Ansel", "Arlo", "Assunta", "Astrid", "Athena", "Aubree", "Aubrey", "Audie", "Audra", "Audreanne", "Audrey", "August", "Augusta", "Augustine", "Bell", "Bella", "Belle", "Ben", "Benedict", "Benjamin", "Bennett", "Bennie", "Bettie", "Betty", "Bettye", "Beulah", "Beverly", "Bianka", "Bill", "Billie", "Billy", "Birdie", "Blair", "Blaise", "Blake", "Blanca", "Brandyn", "Brannon", "Branson", "Brant", "Braulio", "Braxton", "Brayan", "Breana", "Breanna", "Breanne", "Brenda", "Brendan", "Brock", "Broderick", "Brody", "Brook", "Brooke", "Brooklyn", "Brooks", "Brown", "Bruce", "Bryana", "Bryce", "Carlo", "Carlos", "Carlotta", "Carmel", "Carmela", "Carmella", "Carmelo", "Carmen", "Carmine", "Cesar", "Chad", "Chadd", "Chadrick", "Chaim", "Chance", "Chandler", "Chanel", "Chyna", "Ciara", "Cicero", "Cielo", "Cierra", "Cindy", "Citlalli", "Clair", "Claire", "Clara", "Cody", "Colby", "Cole", "Coleman", "Colin", "Colleen", "Collin", "Colt", "Colten", "Colton", "Columbus", "Concepcion", "Conner", "Connie", "Connor", "Conor", "Cullen", "Curt", "Curtis", "Cydney", "Cynthia", "Cyril", "Cyrus", "Dagmar", "Dahlia", "Daija", "Daisha", "Daisy", "Dakota", "Dale", "Dallas", "Dallin", "Darlene", "Daron", "Darrel", "Darrell", "Darren", "Darrick", "Darrin", "Darrion", "Darron", "Darryl", "Darwin", "Daryl", "Dashawn", "Delphia", "Delphine", "Delta", "Demarco", "Demarcus", "Demario", "Demetris", "Demetrius", "Demond", "Domenick", "Domenico", "Domingo", "Dominic", "Dominique", "Don", "Donald", "Donato", "Donavon", "Donna", "Donnell", "Donnie", "Edwin", "Edwina", "Edyth", "Edythe", "Effie", "Efrain", "Efren", "Eileen", "Einar", "Eino", "Eladio", "Elaina", "Elbert", "Elda", "Eldon", "Eldora", "Eldred", "Emanuel", "Emelia", "Emelie", "Emely", "Emerald", "Emerson", "Emery", "Emie", "Emil", "Emile", "Emilia", "Emiliano", "Emilie", "Emilio", "Emily", "Emma", "Emmalee", "Ervin", "Erwin", "Eryn", "Esmeralda", "Esperanza", "Esta", "Esteban", "Estefania", "Estel", "Estell", "Estella", "Ezekiel", "Ezequiel", "Ezra", "Florine", "Flossie", "Floy", "Floyd", "Ford", "Forest", "Forrest", "Foster", "Frances", "Francesca", "Francesco", "Francis", "Garrick", "Garrison", "Garry", "Garth", "Gaston", "Gavin", "Gay", "Gayle", "Gaylord", "Gene", "General", "Genesis", "Genevieve", "Gennaro", "Greg", "Gregg", "Gregoria", "Gregorio", "Gregory", "Greta", "Gretchen", "Greyson", "Griffin", "Grover", "Guadalupe", "Gudrun", "Guido", "Guillermo", "Guiseppe", "Haven", "Hayden", "Haylee", "Hayley", "Haylie", "Hazel", "Hazle", "Heath", "Heather", "Heaven", "Heber", "Hector", "Heidi", "Holden", "Hollie", "Hollis", "Holly", "Hope", "Horace", "Horacio", "Hortense", "Hosea", "Houston", "Howard", "Howell", "Hoyt", "Hubert", "Hudson", "Hugh", "Hulda", "Humberto", "Hunter", "Isac", "Isadore", "Isai", "Isaiah", "Isaias", "Isidro", "Ismael", "Isobel", "Isom", "Israel", "Issac", "Itzel", "Iva", "Jakayla", "Jake", "Jakob", "Jaleel", "Jalen", "Jalon", "Jalyn", "Jamaal", "Jamal", "Jamar", "Jamarcus", "Jamel", "Jameson", "Jamey", "Jamie", "Javon", "Javonte", "Jay", "Jayce", "Jaycee", "Jayda", "Jayde", "Jayden", "Jaydon", "Jaylan", "Jaylen", "Jaylin", "Jaylon", "Jayme", "Jayne", "Jerel", "Jeremie", "Jeremy", "Jermain", "Jermaine", "Jermey", "Jerod", "Jerome", "Jeromy", "Jerrell", "Jerrod", "Jerrold", "Jerry", "Jess", "Jesse", "Jessica", "Johathan", "John", "Johnathan", "Johnathon", "Johnnie", "Johnny", "Johnpaul", "Johnson", "Jolie", "Jon", "Jonas", "Jonatan", "Jonathan", "Jonathon", "Julian", "Juliana", "Julianne", "Julie", "Julien", "Juliet", "Julio", "Julius", "June", "Junior", "Junius", "Justen", "Justice", "Justina", "Justine", "Karl", "Karlee", "Karley", "Karli", "Karlie", "Karolann", "Karson", "Kasandra", "Kasey", "Kassandra", "Katarina", "Katelin", "Katelyn", "Katelynn", "Katharina", "Ken", "Kendall", "Kendra", "Kendrick", "Kenna", "Kennedi", "Kennedy", "Kenneth", "Kennith", "Kenny", "Kenton", "Kolby", "Kole", "Korbin", "Korey", "Kory", "Kraig", "Kris", "Krista", "Kristian", "Kristin", "Kristina", "Kristofer", "Kristoffer", "Kristopher", "Kristy", "Lauren", "Laurence", "Lauretta", "Lauriane", "Laurianne", "Laurie", "Laurine", "Laury", "Lauryn", "Lavada", "Lavern", "Laverna", "Laverne", "Lavina", "Leo", "Leola", "Leon", "Leonard", "Leonardo", "Leone", "Leonel", "Linwood", "Lionel", "Lisa", "Lisandro", "Lisette", "Litzy", "Liza", "Lizeth", "Lizzie", "Llewellyn", "Lloyd", "Logan", "Lois", "Lola", "Lolita", "Loma", "Lon", "Lucile", "Lucinda", "Lucio", "Lucious", "Lucius", "Lucy", "Ludie", "Ludwig", "Lue", "Luella", "Luigi", "Luis", "Luisa", "Lukas", "Lula", "Magdalena", "Maggie", "Magnolia", "Magnus", "Maia", "Maida", "Maiya", "Major", "Makayla", "Makenna", "Makenzie", "Malachi", "Malcolm", "Malika", "Malinda", "Mallie", "Mallory", "Malvina", "Mandy", "Manley", "Maud", "Maude", "Maudie", "Maureen", "Maurice", "Mauricio", "Maurine", "Maverick", "Mavis", "Max", "Maxie", "Maxime", "Maximilian", "Maximillia", "Maximillian", "Maximo", "Milo", "Milton", "Mina", "Minerva", "Minnie", "Miracle", "Mireille", "Mireya", "Misael", "Missouri", "Misty", "Mitchel", "Mitchell", "Mittie", "Modesta", "Modesto", "Mohamed", "Myles", "Myra", "Myriam", "Myrl", "Myrna", "Myron", "Myrtice", "Myrtie", "Myrtis", "Myrtle", "Nadia", "Nakia", "Name", "Nannie", "Naomi", "Naomie", "Napoleon", "Narciso", "Nash", "Nasir", "Nat", "Natalia", "Nichole", "Nick", "Nicklaus", "Nickolas", "Nico", "Nicola", "Nicolas", "Nicole", "Nicolette", "Nigel", "Nikita", "Nikki", "Nikko", "Niko", "Nikolas", "Nils", "Nina", "Noah", "Noble", "Noe", "Noel", "Odie", "Ofelia", "Okey", "Ola", "Olaf", "Ole", "Olen", "Oleta", "Olga", "Olin", "Oliver", "Ollie", "Oma", "Omari", "Omer", "Ona", "Otilia", "Otis", "Ottilie", "Ottis", "Otto", "Ova", "Owen", "Ozella", "Pablo", "Paige", "Palma", "Pamela", "Pansy", "Paolo", "Paris", "Parker", "Pascale", "Philip", "Phoebe", "Phyllis", "Pierce", "Pierre", "Pietro", "Pink", "Pinkie", "Piper", "Polly", "Porter", "Precious", "Ramiro", "Ramon", "Ramona", "Randal", "Randall", "Randi", "Randy", "Ransom", "Raoul", "Raphael", "Raphaelle", "Raquel", "Rashad", "Rashawn", "Rasheed", "Raul", "Raven", "Ray", "Raymond", "Rex", "Rey", "Reyes", "Reymundo", "Reyna", "Reynold", "Rhea", "Rhett", "Rhianna", "Rhiannon", "Roger", "Rogers", "Rolando", "Rollin", "Roma", "Romaine", "Roman", "Rozella", "Ruben", "Rubie", "Ruby", "Rubye", "Rudolph", "Rudy", "Rupert", "Russ", "Russel", "Russell", "Rusty", "Salvatore", "Sam", "Samanta", "Samantha", "Samara", "Samir", "Serenity", "Seth", "Shad", "Shaina", "Shakira", "Shana", "Shane", "Shanel", "Shanelle", "Shania", "Shanie", "Shaniya", "Susan", "Susana", "Susanna", "Susie", "Suzanne", "Sven", "Syble", "Sydnee", "Sydney", "Titus", "Tobin", "Toby", "Tod", "Tom", "Tomas", "Tomasa", "Tommie", "Toney", "Toni", "Tristian", "Tristin", "Triston", "Troy", "Trudie", "Trycia", "Trystan", "Turner", "Twila", "Vance", "Vanessa", "Vaughn", "Veda", "Velda", "Vella", "Vinnie", "Viola", "Violet", "Violette", "Virgie", "Virginie", "Vita", "Vito", "Viva", "Vivian", "Viviane", "Vivianne", "Vivien", "Wendell", "Wendy", "Werner", "Westley", "Weston", "Whitney", "Wilber", "Wilbert", "Wilburn", "Wiley", "Winona", "Winston", "Woodrow", "Wyatt", "Wyman", "Xander", "Xavier", "Xzavier", "Zachary", "Zachery", "Zack", "Zackary", "Zackery", "Zakary", "Zander", "Zane", "Zion", "Zita", "Zoe", "Zoey", "Zoie", "Zoila", "Zola", "Zora"];

/***/ }),

/***/ "ETAZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"color\" transform=\"translate(-620.000000, -408.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(512.000000, 358.000000)\"><g id=\"comment-1\" transform=\"translate(108.000000, 50.000000)\"><path d=\"M11,17.2727273 L9.68366667,17.2727273 C7.89066667,19.8581818 3.87108333,19.9945455 3.6905,19.9990909 C3.68316667,20 3.67491667,20 3.66666667,20 C3.32016667,20 3.00208333,19.8054545 2.84716667,19.4963636 C2.68766667,19.18 2.72891667,18.8009091 2.94983333,18.5245455 C2.9645,18.5063636 4.26708333,16.8618182 4.52466667,15.1418182 C2.24216667,14.0081818 0,11.6127273 0,8.60090909 C0,3.85818182 4.93441667,0 11,0 C17.0655833,0 22,3.85818182 22,8.60090909 C22,13.3827273 17.0655833,17.2727273 11,17.2727273 Z M11,1.81818182 C5.9455,1.81818182 1.83333333,4.86090909 1.83333333,8.60090909 C1.83333333,10.9309091 3.84175,12.9445455 5.82541667,13.73 C6.17375,13.8672727 6.402,14.2018182 6.402,14.5736364 C6.402,15.78 5.96933333,16.96 5.50366667,17.88 C6.56241667,17.5909091 7.788,17.0309091 8.35175,15.9463636 C8.50941667,15.6436364 8.82383333,15.4545455 9.16666667,15.4545455 L11,15.4545455 C16.0545,15.4545455 20.1666667,12.38 20.1666667,8.60090909 C20.1666667,4.86090909 16.0545,1.81818182 11,1.81818182 Z M15.5833333,8.18181818 L6.41666667,8.18181818 C5.91066667,8.18181818 5.5,7.77454545 5.5,7.27272727 C5.5,6.77090909 5.91066667,6.36363636 6.41666667,6.36363636 L15.5833333,6.36363636 C16.0893333,6.36363636 16.5,6.77090909 16.5,7.27272727 C16.5,7.77454545 16.0893333,8.18181818 15.5833333,8.18181818 Z M6.41666667,9.09090909 L12.8333333,9.09090909 C13.3393333,9.09090909 13.75,9.49818182 13.75,10 C13.75,10.5018182 13.3393333,10.9090909 12.8333333,10.9090909 L6.41666667,10.9090909 C5.91066667,10.9090909 5.5,10.5018182 5.5,10 C5.5,9.49818182 5.91066667,9.09090909 6.41666667,9.09090909 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "Eaba":
/***/ (function(module, exports) {

module.exports = "<svg width=\"117\" height=\"92\" viewBox=\"0 0 117 92\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#CCC\" stroke-width=\"4\" stroke-linejoin=\"round\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M2 51h26.04v38.592H2zM44 2h26.04v87.056H44zM88 34h26.04v54.746H88z\"></path></g></svg>"

/***/ }),

/***/ "Eapw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("hk2c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_live_enduser_follow_live_svg__ = __webpack_require__("VOtq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_live_enduser_follow_live_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_live_enduser_follow_live_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_live_enduser_following_live_svg__ = __webpack_require__("oRn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_live_enduser_following_live_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_live_enduser_following_live_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





















var FollowButton = function (_Component) {
  _inherits(FollowButton, _Component);

  function FollowButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FollowButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FollowButton.__proto__ || Object.getPrototypeOf(FollowButton)).call.apply(_ref, [this].concat(args))), _this), _this.updateFollowingStatus = function () {
      var _this$props = _this.props,
          endUser = _this$props.endUser,
          isFollowing = _this$props.isFollowing;


      Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_tracking_actions__["track"])('Conversation Sidebar - Clicked Contact Follow');

      _this.props.actions.updateFollowing({
        following: !isFollowing,
        id: endUser.id
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FollowButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isFollowing = _props.isFollowing,
          hasPremiumTeam = _props.hasPremiumTeam;


      return hasPremiumTeam ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__style_styl__["followButton"], className, 'link'), onClick: this.updateFollowingStatus },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, { className: 'follow-icon', src: isFollowing ? __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_live_enduser_following_live_svg___default.a : __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_live_enduser_follow_live_svg___default.a }),
        isFollowing ? 'Following' : 'Follow'
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__style_styl__["followButton"], className), to: '/live' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, { className: 'follow-icon', src: isFollowing ? __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_live_enduser_following_live_svg___default.a : __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_live_enduser_follow_live_svg___default.a }),
        isFollowing ? 'Following' : 'Follow'
      );
    }
  }]);

  return FollowButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state, props) {
    var endUser = props.endUser;


    return {
      hasFollowing: __WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('has_following'),
      isFollowing: endUser && __WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_selectors__["b" /* followingId */](endUser.id)(state),
      hasPremiumTeam: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_gates_selectors__["u" /* makeHasGate */])('premium_team')(state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchFollowing: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_actions__["s" /* fetchFollowing */],
      updateFollowing: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_actions__["_7" /* updateFollowing */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* branch */])(function (props) {
  return !props.endUser;
}, __WEBPACK_IMPORTED_MODULE_4_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* branch */])(function (props) {
  return !props.hasFollowing;
}, __WEBPACK_IMPORTED_MODULE_4_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props2 = this.props,
        endUser = _props2.endUser,
        actions = _props2.actions;

    actions.fetchFollowing({ id: endUser.id });
  }
}))(FollowButton));

/***/ }),

/***/ "EfR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_settings_ChatWidget_components_Advanced_components_ToggleSection__ = __webpack_require__("3JoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditConfiguration__ = __webpack_require__("ehLV");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AutoCloseConfiguration = function (_Component) {
  _inherits(AutoCloseConfiguration, _Component);

  function AutoCloseConfiguration() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutoCloseConfiguration);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutoCloseConfiguration.__proto__ || Object.getPrototypeOf(AutoCloseConfiguration)).call.apply(_ref, [this].concat(args))), _this), _this.handleIsEnabledToggled = function (event) {
      _this.props.setIsEnabled(event.target.checked);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutoCloseConfiguration, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          timeoutValue = _props.timeoutValue,
          timeoutUnit = _props.timeoutUnit,
          hasUnsavedChanges = _props.hasUnsavedChanges,
          setTimeoutUnit = _props.setTimeoutUnit,
          setTimeoutValue = _props.setTimeoutValue,
          saveChanges = _props.saveChanges,
          discardUnsavedChanged = _props.discardUnsavedChanged,
          minTimeoutValue = _props.minTimeoutValue,
          maxTimeoutValue = _props.maxTimeoutValue,
          exceedsLimitText = _props.exceedsLimitText,
          filters = _props.filters,
          setFilters = _props.setFilters;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_components_settings_ChatWidget_components_Advanced_components_ToggleSection__["a" /* default */],
        {
          title: 'Auto-close conversations after a period of inactivity',
          description: 'Automatically close conversations where participants are unresponsive.',
          isChecked: isEnabled,
          className: 'advanced-settings-toggle',
          onToggled: this.handleIsEnabledToggled
        },
        isEnabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__EditConfiguration__["a" /* default */], {
          timeoutValue: timeoutValue,
          timeoutUnit: timeoutUnit,
          hasUnsavedChanges: hasUnsavedChanges,
          setTimeoutUnit: setTimeoutUnit,
          setTimeoutValue: setTimeoutValue,
          saveChanges: saveChanges,
          discardUnsavedChanged: discardUnsavedChanged,
          minTimeoutValue: minTimeoutValue,
          maxTimeoutValue: maxTimeoutValue,
          exceedsLimitText: exceedsLimitText,
          filters: filters,
          setFilters: setFilters })
      );
    }
  }]);

  return AutoCloseConfiguration;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AutoCloseConfiguration);

/***/ }),

/***/ "EjAY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EkEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTHENTICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTHENTICATE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTHENTICATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTHENTICATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISCONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return JOIN_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return JOIN_CHANNEL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return JOIN_CHANNEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return JOIN_CHANNEL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LEAVE_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SOCKET_OPEN_EVENT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SOCKET_CLOSE_EVENT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SOCKET_ERROR_EVENT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SOCKET_RECONNECT_ATTEMPT_QUEUED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SOCKET_RECONNECT_TIMER_TICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHANNEL_ERROR_EVENT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANNEL_CLOSE_EVENT_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SOCKET_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANNEL_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SocketCluster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SocketChannel; });
var SOCKET_ACTION_PREFIX = '@@app/socket';
var makeConstant = function makeConstant(constant) {
  return SOCKET_ACTION_PREFIX + '/' + constant;
};

var AUTHENTICATE = makeConstant('AUTHENTICATE');
var AUTHENTICATE_PENDING = makeConstant('AUTHENTICATE_PENDING');
var AUTHENTICATE_SUCCESS = makeConstant('AUTHENTICATE_SUCCESS');
var AUTHENTICATE_FAILURE = makeConstant('AUTHENTICATE_FAILURE');

var CONNECT = makeConstant('CONNECT');

var DISCONNECT = makeConstant('DISCONNECT');

var JOIN_CHANNEL = makeConstant('JOIN_CHANNEL');
var JOIN_CHANNEL_PENDING = makeConstant('JOIN_CHANNEL_PENDING');
var JOIN_CHANNEL_SUCCESS = makeConstant('JOIN_CHANNEL_SUCCESS');
var JOIN_CHANNEL_FAILURE = makeConstant('JOIN_CHANNEL_FAILURE');

var LEAVE_CHANNEL = makeConstant('LEAVE_CHANNEL');

var SOCKET_OPEN_EVENT_RECEIVED = makeConstant('SOCKET_OPEN_EVENT_RECEIVED');
var SOCKET_CLOSE_EVENT_RECEIVED = makeConstant('SOCKET_CLOSE_EVENT_RECEIVED');
var SOCKET_ERROR_EVENT_RECEIVED = makeConstant('SOCKET_ERROR_EVENT_RECEIVED');

var SOCKET_RECONNECT_ATTEMPT_QUEUED = makeConstant('SOCKET_RECONNECT_ATTEMPT_QUEUED');
var SOCKET_RECONNECT_TIMER_TICKED = makeConstant('SOCKET_RECONNECT_TIMER_TICKED');

var CHANNEL_ERROR_EVENT_RECEIVED = makeConstant('CHANNEL_ERROR_EVENT_RECEIVED');
var CHANNEL_CLOSE_EVENT_RECEIVED = makeConstant('CHANNEL_CLOSE_EVENT_RECEIVED');

var SOCKET_STATES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
  ERRORED: 4
};

var CHANNEL_STATES = {
  CLOSED: "closed",
  ERRORED: "errored",
  JOINED: "joined",
  JOINING: "joining",
  LEAVING: "leaving"
};

var SocketCluster = Object.freeze({
  MESSAGES: 'MESSAGES',
  PUSH: 'PUSH'
});

var SocketChannel = Object.freeze({
  USER: 'USER',
  ORG_PUBLIC: 'ORG_PUBLIC',
  ORG_PRIVATE: 'ORG_PRIVATE'
});

/***/ }),

/***/ "ElC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defaults__ = __webpack_require__("Lpou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_defaults__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_paging__ = __webpack_require__("Prq2");




var api = {
  fetch: function fetch(id, options) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + id + '/timeline', __WEBPACK_IMPORTED_MODULE_0_lodash_defaults___default()(options, {
      paginated: true,
      size: 20
    })).checkStatus().retryWithBackoff().map(Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["d" /* parseBidirectionalPagedData */])());
  }
};

/***/ }),

/***/ "ElMV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conversationSection":"conversationSection---244sV"};

/***/ }),

/***/ "EoEX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inboxQueryChanged */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_SearchViews__ = __webpack_require__("F5ih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__("8ejE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers__ = __webpack_require__("sWN9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("Y4lW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_message_actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__models__ = __webpack_require__("tp7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__cache_filters__ = __webpack_require__("lWyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__conversation_bulkUpdate_actions__ = __webpack_require__("rpEm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
























function inboxIdFromPathName(pathname) {
  var result = __WEBPACK_IMPORTED_MODULE_11__constants__["S" /* INBOX_REGEX */].exec(pathname);

  if (result) {
    return parseInt(result[1]);
  }
}

function inboxQueryChanged(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["LOCATION_CHANGE"]).mergeMap(function (action) {
    var inboxId = inboxIdFromPathName(action.payload.pathname);
    if (inboxId) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of({ inboxId: inboxId, query: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload.query) });
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
    }
  }).map(__WEBPACK_IMPORTED_MODULE_12__actions__["M" /* inboxChanged */]);
}

var patchInbox = function patchInbox(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["O" /* patchInbox */].toString()).pluck('payload').mergeMap(function (_ref) {
    var id = _ref.id,
        name = _ref.name,
        address = _ref.address;

    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].patchInbox({ id: id, name: name, address: address }).map(__WEBPACK_IMPORTED_MODULE_12__actions__["Q" /* patchInboxSuccess */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["P" /* patchInboxFailed */]({ id: id, error: error }));
    });
  });
};

var archiveInbox = function archiveInbox(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* archiveInbox */].toString()).pluck('payload').mergeMap(function (_ref2) {
    var id = _ref2.id;

    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].archiveInbox({ id: id }).map(__WEBPACK_IMPORTED_MODULE_12__actions__["c" /* archiveInboxSuccess */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["b" /* archiveInboxFailed */]({ id: id, error: error }));
    });
  });
};

function bulkCloseForInbox(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["e" /* bulkCloseForInbox */].toString()).pluck('payload').mergeMap(function (inboxId) {
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].bulkCloseForInbox(inboxId).map(__WEBPACK_IMPORTED_MODULE_12__actions__["g" /* bulkCloseForInboxRequested */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["f" /* bulkCloseForInboxFailed */]({ inboxId: inboxId, error: error }));
    });
  });
}

function fetchInbox(action$, _ref3) {
  var getState = _ref3.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["x" /* fetchInbox */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (_ref4) {
    var id = _ref4.id,
        force = _ref4.force;
    return !__WEBPACK_IMPORTED_MODULE_13__selectors__["c" /* inbox */](id)(getState()) || force;
  }).mergeMap(function (_ref5) {
    var id = _ref5.id;

    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchInbox(id).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["y" /* fetchInboxCancelled */].toString()).filter(function (action) {
      return action.payload.id === id;
    })).map(__WEBPACK_IMPORTED_MODULE_12__actions__["T" /* receiveInbox */]).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["E" /* fetchInboxPending */]({ inboxId: id })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["z" /* fetchInboxFailed */]({ inboxId: id, error: error }));
    });
  });
}

var fetchWhitelabel = function fetchWhitelabel(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["H" /* fetchWhitelabel */].toString()).pluck('payload').mergeMap(function (_ref6) {
    var domain = _ref6.domain;

    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchWhitelabel(domain).map(__WEBPACK_IMPORTED_MODULE_12__actions__["L" /* fetchWhitelabelSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["K" /* fetchWhitelabelPending */]({ domain: domain })).catch(function (err) {
      if (err && err.status && err.status === 404) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["J" /* fetchWhitelabelFailed */]({ domain: domain, missing: true }));
      }
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(err);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["J" /* fetchWhitelabelFailed */]({ domain: domain, missing: false }));
    });
  });
};

var createInboxBeforeWhitelabel = function createInboxBeforeWhitelabel(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["k" /* createInboxBeforeWhitelabel */].toString()).pluck('payload').mergeMap(function (_ref7) {
    var address = _ref7.address,
        name = _ref7.name,
        domain = _ref7.domain,
        _ref7$onSuccess = _ref7.onSuccess,
        onSuccess = _ref7$onSuccess === undefined ? function () {} : _ref7$onSuccess,
        _ref7$onFail = _ref7.onFail,
        onFail = _ref7$onFail === undefined ? function () {} : _ref7$onFail;
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].createInbox({ address: address, name: name }).map(function () {
      return __WEBPACK_IMPORTED_MODULE_12__actions__["o" /* createWhitelabel */]({ domain: domain, onSuccess: onSuccess, onFail: onFail });
    }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["r" /* createWhitelabelPending */]({ domain: domain })).catch(function (err) {
      onFail();
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(err, { extra: { address: address, name: name, domain: domain } });
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["q" /* createWhitelabelFailed */]({ domain: domain, err: err }));
    });
  });
};

var createWhitelabel = function createWhitelabel(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["o" /* createWhitelabel */].toString()).pluck('payload').mergeMap(function (_ref8) {
    var domain = _ref8.domain,
        onSuccess = _ref8.onSuccess,
        onFail = _ref8.onFail;
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].createWhitelabel(domain).map(function (res) {
      onSuccess();
      return __WEBPACK_IMPORTED_MODULE_12__actions__["s" /* createWhitelabelSuccess */](res);
    }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["r" /* createWhitelabelPending */]({ domain: domain })).catch(function (err) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(err, { extra: { domain: domain } });
      onFail();
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["q" /* createWhitelabelFailed */]({ domain: domain, err: err }));
    });
  });
};

var verifyWhitelabel = function verifyWhitelabel(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["V" /* verifyWhitelabel */].toString()).pluck('payload').mergeMap(function (_ref9) {
    var domain = _ref9.domain;
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].verifyWhitelabel(domain).map(function (res) {
      var success = res.get('dns').every(function (record) {
        return record.get('valid');
      });
      if (success) {
        return __WEBPACK_IMPORTED_MODULE_12__actions__["Z" /* verifyWhitelabelSuccess */]({ domain: domain, whitelabel: res });
      } else {
        return __WEBPACK_IMPORTED_MODULE_12__actions__["X" /* verifyWhitelabelFailed */]({ domain: domain, whitelabel: res });
      }
    }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["Y" /* verifyWhitelabelPending */]({ domain: domain })).catch(function (err) {
      // TODO: should this be different..?
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["X" /* verifyWhitelabelFailed */]({ domain: domain, err: err }));
    });
  });
};

var createInbox = function createInbox(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["j" /* createInbox */].toString()).pluck('payload').mergeMap(function (_ref10) {
    var address = _ref10.address,
        name = _ref10.name;
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].createInbox({ address: address, name: name }).map(function (res) {
      return __WEBPACK_IMPORTED_MODULE_12__actions__["n" /* createInboxSuccess */](Object(__WEBPACK_IMPORTED_MODULE_18__models__["a" /* Inbox */])(res));
    }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["m" /* createInboxPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["l" /* createInboxFailed */]({ err: err, address: address, name: name }));
    });
  });
};

function fetchCounts(action$, _ref11) {
  var getState = _ref11.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["t" /* fetchCounts */].toString()).pluck('payload').switchMap(function (_ref12) {
    var id = _ref12.id;

    var state = getState();
    if (__WEBPACK_IMPORTED_MODULE_16_app_modules_gates_selectors__["j" /* hasInboxFilterSidebar */](state) && __WEBPACK_IMPORTED_MODULE_20_app_modules_user_properties_selectors__["g" /* properties */](state).get('is_opted_in_to_modern_conversation_ui')) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchCounts2(id).map(function (counts) {
        return __WEBPACK_IMPORTED_MODULE_12__actions__["S" /* receiveCounts2 */]({ id: id, counts: counts });
      }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["w" /* fetchCountsPending */]({ id: id })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
        if (error.status > 400 && error.status < 500) {
          Object(__WEBPACK_IMPORTED_MODULE_19__cache_filters__["a" /* clearAll */])();
          return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])({ pathname: '/inboxes' }));
        }

        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["u" /* fetchCountsFailed */]({ id: id, error: error }));
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchCounts(id).map(function (counts) {
        return __WEBPACK_IMPORTED_MODULE_12__actions__["R" /* receiveCounts */]({ id: id, counts: counts });
      }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["w" /* fetchCountsPending */]({ id: id })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
        if (error.status > 400 && error.status < 500) {
          Object(__WEBPACK_IMPORTED_MODULE_19__cache_filters__["a" /* clearAll */])();
          return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])({ pathname: '/inboxes' }));
        }

        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["u" /* fetchCountsFailed */]({ id: id, error: error }));
      });
    }
  });
}

function fetchCountsForInboxIds(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["v" /* fetchCountsForInboxIds */].toString()).pluck('payload').switchMap(function (_ref13) {
    var ids = _ref13.ids;

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].from(ids).mergeMap(function (id) {
      return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchCounts(id).map(function (counts) {
        return __WEBPACK_IMPORTED_MODULE_12__actions__["R" /* receiveCounts */]({ id: id, counts: counts });
      }).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["w" /* fetchCountsPending */]({ id: id })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["u" /* fetchCountsFailed */]({ id: id, error: error }));
      });
    });
  });
}

function fetchInboxList(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["A" /* fetchInboxList */].toString()).exhaustMap(function () {
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchInboxList().takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["B" /* fetchInboxListCancelled */].toString())).map(__WEBPACK_IMPORTED_MODULE_12__actions__["U" /* receiveInboxList */]).startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["D" /* fetchInboxListPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_12__actions__["C" /* fetchInboxListFailed */](error));
    });
  });
}

function fetchSendingDomains(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["F" /* fetchSendingDomains */].toString()).exhaustMap(function () {
    return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* api */].fetchSendingDomains().startWith(__WEBPACK_IMPORTED_MODULE_12__actions__["G" /* fetchSendingDomainsPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
    });
  });
}

function conversationEvent(action$, _ref14) {
  var getState = _ref14.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14_app_modules_message_actions__["v" /* receiveMessage */].toString()).pluck('payload', 'message').filter(function (_ref15) {
    var type = _ref15.type;
    return type === 'CONVERSATION_EVENT';
  }).filter(function (_ref16) {
    var type = _ref16.conversationEvent.type;

    return type === 'ADDED_PARTICIPANTS' || type === 'REMOVED_PARTICIPANTS';
  }).filter(function (message) {
    var currentUser = __WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__["currentUser"](getState());
    var _message$conversation = message.conversationEvent,
        currentParticipants = _message$conversation.currentParticipantIds,
        participants = _message$conversation.participantIds;

    return Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_access_helpers__["b" /* hasConversationAccess */])(currentUser, participants) || Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_access_helpers__["b" /* hasConversationAccess */])(currentUser, currentParticipants);
  }).map(function (message) {
    var inboxId = message.inboxId,
        _message$conversation2 = message.conversationEvent,
        currentParticipants = _message$conversation2.currentParticipantIds,
        participants = _message$conversation2.participantIds,
        conversationStatus = _message$conversation2.conversationStatus,
        type = _message$conversation2.type;

    return __WEBPACK_IMPORTED_MODULE_12__actions__["h" /* changeParticipants */]({
      inboxId: inboxId,
      currentParticipants: currentParticipants,
      participants: participants,
      conversationStatus: conversationStatus,
      isAdd: type === 'ADDED_PARTICIPANTS',
      currentUserId: __WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__["currentUser"](getState()).id
    });
  });
}

function defaultInboxRedirect(action$, _ref17) {
  var getState = _ref17.getState;

  var originalQueryParams = null;
  var navigatedToInboxesWithoutId$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["LOCATION_CHANGE"]).pluck('payload').filter(function (_ref18) {
    var pathname = _ref18.pathname;
    return Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["a" /* shouldRedirectToInbox */])(pathname);
  });

  var fetchEmbed$ = navigatedToInboxesWithoutId$.first().map(function (payload) {
    originalQueryParams = payload.query;
    return __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_actions__["a" /* fetchEmbed */]();
  });

  var redirectOnEmbedSuccess$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_embed_actions__["e" /* fetchEmbedSuccess */].toString()).map(function () {
    return __WEBPACK_IMPORTED_MODULE_12__actions__["N" /* inboxRedirect */]();
  });

  var redirectToDefaultInbox$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_12__actions__["N" /* inboxRedirect */].toString()).switchMap(function () {
    if (!Object(__WEBPACK_IMPORTED_MODULE_10__helpers__["a" /* shouldRedirectToInbox */])(__WEBPACK_IMPORTED_MODULE_5_app_modules_router_selectors__["d" /* pathname */](getState()))) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
    }

    var defaultInboxId = __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["b" /* defaultInboxId */](getState());
    var savedInbox = Object(__WEBPACK_IMPORTED_MODULE_19__cache_filters__["c" /* getInboxId */])();
    var inboxId = savedInbox || defaultInboxId;

    var pathname = '/inboxes/' + inboxId + '/conversations';

    var storedFiltersQuery = Object(__WEBPACK_IMPORTED_MODULE_19__cache_filters__["b" /* getFilters */])();
    var defaultFiltersQuery = __WEBPACK_IMPORTED_MODULE_6_constants_SearchViews__["a" /* SearchViewEnum */].open.value.getQuery();
    var query = storedFiltersQuery || defaultFiltersQuery;

    var mergedQueryParams = _extends({}, query, originalQueryParams);
    originalQueryParams = null;
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])({ pathname: pathname, query: mergedQueryParams }));
  });

  return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].merge(fetchEmbed$, redirectOnEmbedSuccess$, redirectToDefaultInbox$);
}

var receiveBulkUpdateSuccess = function receiveBulkUpdateSuccess(action$, _ref19) {
  var getState = _ref19.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_21__conversation_bulkUpdate_actions__["d" /* receiveBulkUpdateSuccess */].toString()).pluck('payload').filter(function (_ref20) {
    var inboxId = _ref20.inboxId;
    return inboxId === __WEBPACK_IMPORTED_MODULE_13__selectors__["b" /* currentInboxId */](getState());
  }).map(function (_ref21) {
    var inboxId = _ref21.inboxId,
        conversationDiffs = _ref21.conversationDiffs;

    var currentUser = __WEBPACK_IMPORTED_MODULE_15_app_modules_user_selectors__["currentUser"](getState());

    var filteredConversationDiffs = conversationDiffs.filter(function (_ref22) {
      var currentParticipantIds = _ref22.currentParticipantIds;

      return Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_access_helpers__["b" /* hasConversationAccess */])(currentParticipantIds, currentUser);
    });

    var updates = filteredConversationDiffs.map(function (_ref23) {
      var currentStatus = _ref23.currentStatus,
          previousStatus = _ref23.previousStatus,
          currentParticipantIds = _ref23.currentParticipantIds;
      return {
        currentParticipants: currentParticipantIds,
        previousStatus: previousStatus,
        status: currentStatus
      };
    });

    return __WEBPACK_IMPORTED_MODULE_12__actions__["d" /* bulkChangeStatus */]({
      id: inboxId,
      currentUserId: currentUser.id,
      conversationDiffs: updates
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(fetchInbox, fetchInboxList, defaultInboxRedirect, fetchCounts, fetchCountsForInboxIds, fetchSendingDomains, bulkCloseForInbox, inboxQueryChanged, conversationEvent, fetchWhitelabel, createWhitelabel, verifyWhitelabel, createInbox, createInboxBeforeWhitelabel, receiveBulkUpdateSuccess, patchInbox, archiveInbox);

/***/ }),

/***/ "EoOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return assistantOrgSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchAssistantOrgSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchAssistantOrgSettingsSuccess; });
/* unused harmony export fetchAssistantOrgSettingsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return patchAssistantOrgSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return patchAssistantOrgSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return patchAssistantOrgSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assistantAgentSettings; });
/* unused harmony export fetchAssistantAgentSettingsPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchAssistantAgentSettingsSuccess; });
/* unused harmony export fetchAssistantAgentSettingsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return salesforceLeadSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return salesforceContactSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return salesforceEventSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return salesforceTaskSettings; });
/* unused harmony export fetchSalesforceSettingsPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchSalesforceSettingsSuccess; });
/* unused harmony export fetchSalesforceSettingsFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchPersonalizationTagsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return personalizationTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isEditingMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isEditingActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return editingAssistantAgentSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return assistantConfigHasEdits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sendTestEmailPending; });
/* unused harmony export sendTestEmailSuccess */
/* unused harmony export sendTestEmailFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("E3/D");




// Org settings selectors
var assistantOrgSettings = function assistantOrgSettings(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'data']);
};

var fetchAssistantOrgSettingsPending = function fetchAssistantOrgSettingsPending(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_ASSISTANT_ORG_SETTINGS_PENDING */];
};

var fetchAssistantOrgSettingsSuccess = function fetchAssistantOrgSettingsSuccess(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS */];
};

var fetchAssistantOrgSettingsFailed = function fetchAssistantOrgSettingsFailed(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_ASSISTANT_ORG_SETTINGS_FAILED */];
};

var patchAssistantOrgSettingsPending = function patchAssistantOrgSettingsPending(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["I" /* PATCH_ASSISTANT_ORG_SETTINGS_PENDING */];
};

var patchAssistantOrgSettingsSuccess = function patchAssistantOrgSettingsSuccess(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS */];
};

var patchAssistantOrgSettingsFailed = function patchAssistantOrgSettingsFailed(state) {
  return state.getIn(['assistantSettings', 'orgSettings', 'status']) === __WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PATCH_ASSISTANT_ORG_SETTINGS_FAILED */];
};

// Agent settings selectors
var assistantAgentSettings = function assistantAgentSettings(state) {
  return state.getIn(['assistantSettings', 'agentSettings', 'data', 'taskConfigMap']);
};

var fetchAssistantAgentSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']);
}, function (fetchAssistantAgentSettingsStatus) {
  return fetchAssistantAgentSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_ASSISTANT_AGENT_SETTINGS_PENDING */];
});

var fetchAssistantAgentSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']);
}, function (fetchAssistantAgentSettingsStatus) {
  return fetchAssistantAgentSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS */];
});

var fetchAssistantAgentSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'AgentSettings', 'status', 'fetch']);
}, function (fetchAssistantAgentSettingsStatus) {
  return fetchAssistantAgentSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_ASSISTANT_AGENT_SETTINGS_FAILED */];
});

// Salesforce settings selectors
var salesforceLeadSettings = function salesforceLeadSettings(state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'LEAD']);
};
var salesforceContactSettings = function salesforceContactSettings(state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'CONTACT']);
};
var salesforceEventSettings = function salesforceEventSettings(state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'EVENT']);
};
var salesforceTaskSettings = function salesforceTaskSettings(state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'data', 'TASK']);
};

var fetchSalesforceSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'status']);
}, function (fetchSalesforceSettingsStatus) {
  return fetchSalesforceSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_SALESFORCE_SETTINGS_PENDING */];
});

var fetchSalesforceSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'status']);
}, function (fetchSalesforceSettingsStatus) {
  return fetchSalesforceSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_SALESFORCE_SETTINGS_SUCCESS */];
});

var fetchSalesforceSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'salesforceMappings', 'status']);
}, function (fetchSalesforceSettingsStatus) {
  return fetchSalesforceSettingsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_SALESFORCE_SETTINGS_FAILED */];
});

var fetchPersonalizationTagsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['assistantSettings', 'personalizationTags', 'status']);
}, function (fetchPersonalizationTagsStatus) {
  return fetchPersonalizationTagsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_PERSONALIZATION_TAGS_SUCCESS */];
});

var personalizationTags = function personalizationTags(state) {
  return state.getIn(['assistantSettings', 'personalizationTags', 'data']);
};

// Editing selectors
var isEditingMapping = function isEditingMapping(state) {
  return state.getIn(['assistantSettings', 'editingOrgSettings', 'MAPPING']);
};
var isEditingActivity = function isEditingActivity(state) {
  return state.getIn(['assistantSettings', 'editingOrgSettings', 'ACTIVITY']);
};

var editingAssistantAgentSettings = function editingAssistantAgentSettings(state) {
  return state.getIn(['assistantSettings', 'editingAgentSettings']);
};

var assistantConfigHasEdits = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([assistantAgentSettings, editingAssistantAgentSettings], function (assistantAgentSettings, editingAssistantAgentSettings) {
  return !assistantAgentSettings.equals(editingAssistantAgentSettings);
});

var sendTestEmailPending = function sendTestEmailPending(state) {
  return state.getIn(['assistantSettings', 'sendingTestEmailStatus']) === __WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SEND_TEST_EMAIL_PENDING */];
};

var sendTestEmailSuccess = function sendTestEmailSuccess(state) {
  return state.getIn(['assistantSettings', 'sendingTestEmailStatus']) === __WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SEND_TEST_EMAIL_SUCCESS */];
};

var sendTestEmailFailed = function sendTestEmailFailed(state) {
  return state.getIn(['assistantSettings', 'sendingTestEmailStatus']) === __WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SEND_TEST_EMAIL_FAILED */];
};

/***/ }),

/***/ "Ep/z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_inboxes_ManageInboxes_styl__ = __webpack_require__("/5zg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_inboxes_ManageInboxes_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_components_settings_inboxes_ManageInboxes_styl__);















var ManageInboxes = React.createClass({
  displayName: 'ManageInboxes',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      moveForward: false
    };
  },
  render: function render() {
    var _this = this;

    if (this.props.children) {
      return this.props.children;
    }
    var hasPremiumDrift = this.props.hasPremiumDrift;


    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ManageInboxes', { 'move-forward': this.state.moveForward }) },
      hasPremiumDrift && React.createElement(
        'button',
        {
          className: 'drift-button drift-button-primary new-inbox-button',
          onClick: this.createInboxClicked
        },
        'New Inbox'
      ),
      React.createElement(
        'div',
        { className: 'inboxes' },
        _.map(this.props.inboxesById, function (inbox, i) {
          return React.createElement(
            'div',
            { className: 'inbox', key: i, onClick: _this.inboxClicked.bind(_this, inbox) },
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, { src: __webpack_require__("EETw") }),
            React.createElement(
              'div',
              { className: 'name' },
              inbox.name
            ),
            React.createElement(
              'div',
              { className: 'reply-email' },
              inbox.address
            )
          );
        })
      )
    );
  },
  inboxClicked: function inboxClicked(inbox) {
    window.location = '/settings2/inbox/' + inbox.id;
  },
  createInboxClicked: function createInboxClicked() {
    window.location = '/settings2/inbox/new';
  }
});

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    inboxesById: __WEBPACK_IMPORTED_MODULE_1_app_modules_inbox_selectors__["f" /* inboxes */](state).toJS(),
    hasPremiumDrift: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["q" /* hasStarterPlan */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_2_app_modules_inbox_actions__["A" /* fetchInboxList */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchInboxList();
  }
}))(ManageInboxes));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "EpRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);



var InnerDisableSalesSequenceModal = function InnerDisableSalesSequenceModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      onDisableClick = _ref.onDisableClick,
      playbook = _ref.playbook;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Modal"],
    {
      type: 'error',
      title: 'All enrolled contacts will be unenrolled from ' + playbook.name,
      size: 'small',
      open: true,
      className: 'playbook-list-disable-warning',
      onClose: onCloseClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-list-disable-warning--body' },
      'All enrolled contacts in this playbook will be unenrolled if this playbook is disabled. Are you sure you want to disable it?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'footer',
      { className: 'playbook-list-disable-warning-footer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
        { type: 'secondary', onClick: onDisableClick },
        'Disable playbook'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
        { type: 'tertiary', onClick: onCloseClick },
        'Cancel'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (InnerDisableSalesSequenceModal);

/***/ }),

/***/ "EqrF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addhttps; });
var addhttps = function addhttps(url) {
  var pattern = /^((http|https):\/\/)/;

  if (!pattern.test(url)) {
    return "https://" + url;
  }

  return url;
};

/***/ }),

/***/ "EtIs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar---1SmoN","AboutCard":"AboutCard---2xsSa","SegmentRow":"SegmentRow---9Pr_L"};

/***/ }),

/***/ "ExgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_close_svg__ = __webpack_require__("IOh1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_paragraph_up_svg__ = __webpack_require__("h/k+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_paragraph_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_paragraph_up_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_paragraph_down_svg__ = __webpack_require__("ovcL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_paragraph_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_paragraph_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_pencil_svg__ = __webpack_require__("3iTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("ipDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);











var Card = function Card(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      onMoveUpClick = _ref.onMoveUpClick,
      onMoveDownClick = _ref.onMoveDownClick,
      onDeleteClick = _ref.onDeleteClick,
      onEditClick = _ref.onEditClick,
      narrowHeader = _ref.narrowHeader;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-card', className) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-card-header', 'flex-space-between', { narrow: narrowHeader }) },
      !narrowHeader && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'color-white dsg-Body dsg-medium-weight truncate' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        onMoveUpClick && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
          className: 'playbook-card-action',
          onClick: onMoveUpClick,
          src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_paragraph_up_svg___default.a
        }),
        onMoveDownClick && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
          className: 'playbook-card-action',
          onClick: onMoveDownClick,
          src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_paragraph_down_svg___default.a
        }),
        onEditClick && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
          className: 'playbook-card-action',
          onClick: onEditClick,
          src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_images_svg_pencil_svg___default.a
        }),
        onDeleteClick && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
          className: 'playbook-card-action',
          onClick: onDeleteClick,
          src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_close_svg___default.a
        })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { onClick: onEditClick, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-card-content', { editable: !!onEditClick }) },
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),

/***/ "Eys3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchConversationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchConversationFailed; });
/* unused harmony export fetchConversationCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return receiveConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return patchConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return patchConversationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return patchConversationFailed; });
/* unused harmony export patchConversationCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchConversationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchConversationListPending; });
/* unused harmony export fetchConversationListCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchConversationListFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchConversationListSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchNextConversationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchNextConversationListSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchConversationsCountForEndUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchConversationsCountForEndUserIdPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchConversationsCountForEndUserIdFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchConversationsCountForEndUserIdSuccess; });
/* unused harmony export fetchConversationsForEndUser */
/* unused harmony export fetchConversationsForEndUserPending */
/* unused harmony export fetchConversationsForEndUserSuccess */
/* unused harmony export fetchConversationsForEndUserFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return setPlaybookIdForConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createConversationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createConversationFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return setActiveConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return unsetActiveConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return setActiveConversationContactTabIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conversationChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return sendConversationTranscript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return sendConversationTranscriptSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return sendConversationTranscriptFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return setComposeModalStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchRoutingAuditLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchRoutingAuditLogPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchRoutingAuditLogFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchRoutingAuditLogSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return selectConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deselectConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return selectConversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deselectConversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deselectAllConversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return updateConversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return setConversationLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return setConversationLimitPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return setConversationLimitFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return setConversationLimitSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchGlobalAutoCloseConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchGlobalAutoCloseConfigurationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchGlobalAutoCloseConfigurationFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchGlobalAutoCloseConfigurationSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return updateGlobalAutoCloseConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return updateGlobalAutoCloseConfigurationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return updateGlobalAutoCloseConfigurationFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return updateGlobalAutoCloseConfigurationSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchSuggestedArticles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return fetchSuggestedArticlesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return fetchSuggestedArticlesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fetchSuggestedArticlesFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("dMZj");




var fetchConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_CONVERSATION */]);
var fetchConversationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* FETCH_CONVERSATION_PENDING */]);
var fetchConversationFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_CONVERSATION_FAILED */]);
var fetchConversationCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_CONVERSATION_CANCELLED */]);
var receiveConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* RECEIVE_CONVERSATION */]);

var patchConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* PATCH_CONVERSATION */]);
var patchConversationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* PATCH_CONVERSATION_PENDING */]);
var patchConversationFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* PATCH_CONVERSATION_FAILED */]);
var patchConversationCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* PATCH_CONVERSATION_CANCELLED */]);

var fetchConversationList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_CONVERSATION_LIST */]);
var fetchConversationListPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_CONVERSATION_LIST_PENDING */]);
var fetchConversationListCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_CONVERSATION_LIST_CANCELLED */]);
var fetchConversationListFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_CONVERSATION_LIST_FAILED */]);
var fetchConversationListSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_CONVERSATION_LIST_SUCCESS */]);
var fetchNextConversationList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* FETCH_NEXT_CONVERSATION_LIST */]);
var fetchNextConversationListSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* FETCH_NEXT_CONVERSATION_LIST_SUCCESS */]);

var fetchConversationsCountForEndUserId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID */]);
var fetchConversationsCountForEndUserIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING */]);
var fetchConversationsCountForEndUserIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED */]);
var fetchConversationsCountForEndUserIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS */]);

var fetchConversationsForEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_CONVERSATIONS_FOR_END_USER */]);
var fetchConversationsForEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_CONVERSATIONS_FOR_END_USER_PENDING */]);
var fetchConversationsForEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS */]);
var fetchConversationsForEndUserFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_CONVERSATIONS_FOR_END_USER_FAILURE */]);

var setPlaybookIdForConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* SET_PLAYBOOK_ID_FOR_CONVERSATION */]);

var createConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_CONVERSATION */]);
var createConversationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CREATE_CONVERSATION_PENDING */]);
var createConversationFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_CONVERSATION_FAILED */]);

var setActiveConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* SET_ACTIVE_CONVERSATION */]);
var unsetActiveConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* UNSET_ACTIVE_CONVERSATION */]);

var setActiveConversationContactTabIndex = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX */]);

var conversationChanged = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CONVERSATION_CHANGED */]);

var sendConversationTranscript = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* SEND_CONVERSATION_TRANSCRIPT */]);
var sendConversationTranscriptSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SEND_CONVERSATION_TRANSCRIPT_SUCCESS */]);
var sendConversationTranscriptFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["W" /* SEND_CONVERSATION_TRANSCRIPT_FAILURE */]);

var setQuery = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* SET_QUERY */]);
var setComposeModalStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* SET_COMPOSE_MODAL_STATUS */]);

var fetchRoutingAuditLog = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* FETCH_ROUTING_AUDIT_LOG */]);
var fetchRoutingAuditLogPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* FETCH_ROUTING_AUDIT_LOG_PENDING */]);
var fetchRoutingAuditLogFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* FETCH_ROUTING_AUDIT_LOG_FAILED */]);
var fetchRoutingAuditLogSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* FETCH_ROUTING_AUDIT_LOG_SUCCESS */]);

var selectConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* SELECT_CONVERSATION */]);
var deselectConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* DESELECT_CONVERSATION */]);
var selectConversations = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* SELECT_CONVERSATIONS */]);
var deselectConversations = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* DESELECT_CONVERSATIONS */]);
var deselectAllConversations = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* DESELECT_ALL_CONVERSATIONS */]);

var updateConversations = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* UPDATE_CONVERSATIONS */]);

var setConversationLimit = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* SET_CONVERSATION_LIMIT */]);
var setConversationLimitPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* SET_CONVERSATION_LIMIT_PENDING */]);
var setConversationLimitFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* SET_CONVERSATION_LIMIT_FAILURE */]);
var setConversationLimitSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* SET_CONVERSATION_LIMIT_SUCCESS */]);

var fetchGlobalAutoCloseConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION */]);
var fetchGlobalAutoCloseConfigurationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING */]);
var fetchGlobalAutoCloseConfigurationFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE */]);
var fetchGlobalAutoCloseConfigurationSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS */]);

var updateGlobalAutoCloseConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION */]);
var updateGlobalAutoCloseConfigurationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING */]);
var updateGlobalAutoCloseConfigurationFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE */]);
var updateGlobalAutoCloseConfigurationSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS */]);

var fetchSuggestedArticles = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* FETCH_SUGGESTED_ARTICLES */]);
var fetchSuggestedArticlesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* FETCH_SUGGESTED_ARTICLES_PENDING */]);
var fetchSuggestedArticlesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* FETCH_SUGGESTED_ARTICLES_SUCCESS */]);
var fetchSuggestedArticlesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* FETCH_SUGGESTED_ARTICLES_FAILED */]);

/***/ }),

/***/ "Ezlc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CalendarSettings":"CalendarSettings---1Fo9l"};

/***/ }),

/***/ "F13r":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.5 21C4.71 21 0 16.29 0 10.5S4.71 0 10.5 0 21 4.71 21 10.5 16.29 21 10.5 21zm0-19.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75-3.925-8.75-8.75-8.75zm-.217 12.826a.871.871 0 0 1-1.204.107l-4.376-3.5a.876.876 0 0 1 1.093-1.366l3.721 2.976 5.575-6.369a.875.875 0 1 1 1.316 1.152l-6.125 7z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "F3N0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_empty__ = __webpack_require__("AGQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_dom_ajax__ = __webpack_require__("1Nls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_dom_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_dom_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_skipWhile__ = __webpack_require__("VaQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_skipWhile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_operator_skipWhile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_message_actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("AO70");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__("2ERK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__("C2XB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__("vt/k");













function extractLinks(action$, _ref) {
  var getState = _ref.getState;

  var message$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_message_actions__["v" /* receiveMessage */].toString()).map(function (action) {
    return { messages: __WEBPACK_IMPORTED_MODULE_1_immutable__["List"].of(action.payload.message) };
  });

  var messageList$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_message_actions__["y" /* receivePaginatedMessageList */].toString(), __WEBPACK_IMPORTED_MODULE_7_app_modules_message_actions__["x" /* receiveNextMessageList */].toString()).map(function (action) {
    return action.payload;
  });

  return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].merge(message$, messageList$).map(function (_ref2) {
    var messages = _ref2.messages;

    var hrefsByMessageId = Object(__WEBPACK_IMPORTED_MODULE_11__selectors__["b" /* getHrefsByMessageId */])(getState());
    var hrefsByMessageIdToFetch = messages.filter(function (message) {
      return !hrefsByMessageId.has(message.id);
    }).filter(function (message) {
      return typeof message.body === 'string';
    }).filter(function (message) {
      return message.type === 'CHAT' || message.contentType === 'PRIVATE_NOTE' || message.type === 'PRIVATE_PROMPT' || message.type === 'EDIT';
    }).reduce(function (result, message) {
      if (message.getIn(['attributes', 'supportBotLinks'])) {
        return result;
      }

      var parser = new DOMParser();
      var doc = parser.parseFromString(message.body, "text/html");

      var hrefs = [];
      __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(doc.getElementsByTagName('a'), function (link) {
        if (link.href && link.href.startsWith('http')) {
          hrefs.push(link.href);
        }
      });

      return result.set(message.id, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(hrefs));
    }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

    return Object(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* updateHrefs */])(hrefsByMessageIdToFetch);
  });
}

function fetchCards(action$, _ref3) {
  var getState = _ref3.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* updateHrefs */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (payload) {
    return !payload.isEmpty();
  }).mergeMap(function (hrefsByMessageId) {
    return hrefsByMessageId.valueSeq().flatten().filter(function (href) {
      return !Object(__WEBPACK_IMPORTED_MODULE_11__selectors__["a" /* getCardsByHref */])(getState()).has(href);
    }).toSet().toJS();
  }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* fetchCard */]);
}

function fetchCardEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* FETCH_CARD */]).mergeMap(function (action) {
    var href = action.payload;
    return __WEBPACK_IMPORTED_MODULE_10__api__["a" /* fetchCard */](href).map(function (card) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__actions__["c" /* fetchCardSuccess */])({ href: href, card: card });
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_3_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* fetchCardFailure */])({ href: href, error: error }));
    });
  }, 1);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(fetchCards, fetchCardEpic, extractLinks));

/***/ }),

/***/ "F4+Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ExtensionInviteModalContent":"ExtensionInviteModalContent---XqnVe","ExtensionInviteModalHeader":"ExtensionInviteModalHeader---oevAX","invite-user-wizard-modal":"invite-user-wizard-modal---PoCrD"};

/***/ }),

/***/ "F517":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StatusPopOver__ = __webpack_require__("waWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_icons_bolt_svg__ = __webpack_require__("Adja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_icons_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_icons_bolt_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("Ri9E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var UpgradeStatus = function (_Component) {
  _inherits(UpgradeStatus, _Component);

  function UpgradeStatus(props) {
    _classCallCheck(this, UpgradeStatus);

    var _this = _possibleConstructorReturn(this, (UpgradeStatus.__proto__ || Object.getPrototypeOf(UpgradeStatus)).call(this, props));

    _this.toggleClick = function () {
      var wrapperRect = _this.wrapperRef.getBoundingClientRect();

      _this.setState(function (prevState) {
        return {
          displayMenu: !prevState.displayMenu,
          flyoutPosition: window.innerHeight - wrapperRect.bottom
        };
      });
    };

    _this.handleClose = function () {
      _this.setState({ isOpen: false });
    };

    _this.handleOpen = function () {
      _this.setState({ isOpen: true });
    };

    _this.togglePopover = function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    };

    _this.state = {
      displayMenu: false,
      isOpen: false,
      flyoutPosition: 0
    };
    return _this;
  }

  _createClass(UpgradeStatus, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].hasGates('premium_drift')) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-status-bar', ref: function ref(_ref) {
            return _this2.wrapperRef = _ref;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { onClick: this.toggleClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_icons_bolt_svg___default.a })
        ),
        this.state.displayMenu && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { position: 'fixed', bottom: this.state.flyoutPosition } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__StatusPopOver__["a" /* default */], { onClickOutside: this.toggleClick })
        )
      );
    }
  }]);

  return UpgradeStatus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UpgradeStatus);

/***/ }),

/***/ "F5ih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export isSearchViewActive */
/* unused harmony export SearchView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchViewEnum; });
/* unused harmony export getCurrentView */
/* unused harmony export PrimarySearchView */
/* unused harmony export PrimarySearchViewEnum */
/* unused harmony export getCurrentPrimaryView */
/* unused harmony export SecondarySearchView */
/* unused harmony export SecondarySearchViewEnum */
/* unused harmony export getCurrentSecondaryView */
/* unused harmony export SortView */
/* unused harmony export SortViewEnum */
/* unused harmony export sortViewFromQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styles_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__ = __webpack_require__("U98Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_SortConversationsConstants__ = __webpack_require__("/Ggu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__ = __webpack_require__("l071");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var FILTER_KEYS = [__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["b" /* CONVERSATION_TAG_KEY */], __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */], __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]];
var SORT_KEYS = [__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]];
var OPEN_AND_PENDING = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key, __WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key];

var OPEN_VIEW_QUERY = {};
OPEN_VIEW_QUERY[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key];

var PENDING_VIEW_QUERY = {};
PENDING_VIEW_QUERY[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key];

var CLOSED_VIEW_QUERY = {};
CLOSED_VIEW_QUERY[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key];

var NO_PARTICIPANTS_QUERY = {};
NO_PARTICIPANTS_QUERY[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]] = '0';
NO_PARTICIPANTS_QUERY[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = OPEN_AND_PENDING;

var ALL_QUERY = {};

// set any filter key that is unset to undefined
var makeQuery = function makeQuery(query) {
  var newQuery = _.cloneDeep(query);

  _.each([].concat(FILTER_KEYS, SORT_KEYS), function (key) {
    if (newQuery[key] == null) {
      newQuery[key] = undefined;
    }
    return true;
  });

  return newQuery;
};

var makeParticipatingQuery = function makeParticipatingQuery(currentUserId) {
  var query = {};
  query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]] = [currentUserId.toString()];
  query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = OPEN_AND_PENDING;
  return query;
};

var isSearchViewActive = function isSearchViewActive(query) {
  return query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] || query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["b" /* CONVERSATION_TAG_KEY */]] || query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]];
};

var SearchView = {
  participating: {
    name: 'Your Conversations',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['open-status-color'],
    isActive: function isActive(query, currentUserId) {
      return _.isEqual(_.pick(query, FILTER_KEYS), makeParticipatingQuery(currentUserId));
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), makeParticipatingQuery(currentUserId)));
    }
  },
  noParticipants: {
    name: 'No Participants',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['open-status-color'],
    isActive: function isActive(query) {
      return _.isEqual(_.pick(query, FILTER_KEYS), NO_PARTICIPANTS_QUERY);
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), NO_PARTICIPANTS_QUERY));
    }
  },
  open: {
    name: 'Open',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['open-status-color'],
    isActive: function isActive(query) {
      return _.isEqual(_.pick(query, FILTER_KEYS), OPEN_VIEW_QUERY);
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), OPEN_VIEW_QUERY));
    }
  },
  pending: {
    name: 'Pending',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['pending-status-color'],
    isActive: function isActive(query) {
      return _.isEqual(_.pick(query, FILTER_KEYS), PENDING_VIEW_QUERY);
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), PENDING_VIEW_QUERY));
    }
  },
  closed: {
    name: 'Closed',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['closed-status-color'],
    isActive: function isActive(query) {
      return _.isEqual(_.pick(query, FILTER_KEYS), CLOSED_VIEW_QUERY);
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), CLOSED_VIEW_QUERY));
    }
  },
  all: {
    name: 'All',
    color: __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['color-navy-dark'],
    isActive: function isActive(query) {
      return _.isEmpty(_.pick(query, FILTER_KEYS));
    },
    getQuery: function getQuery(currentUserId, currentQuery) {
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), ALL_QUERY));
    }
  }
};

var SearchViewEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(SearchView);

var getCurrentView = function getCurrentView(query, currentUserId) {
  var activeView = _.chain(SearchView).map(function (value, key) {
    return { value: value, key: key };
  }).filter(function (_ref) {
    var value = _ref.value;
    return value.isActive(query, currentUserId);
  }).map(function (_ref2) {
    var key = _ref2.key;
    return key;
  }).first().value();

  return activeView || __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["a" /* ADVANCED_SEARCH_KEY */];
};

var hasAdvancedConversationStatusFilters = function hasAdvancedConversationStatusFilters(query) {
  var activeSecondaryView = _.chain(SecondarySearchView).map(function (value, key) {
    return { value: value, key: key };
  }).filter(function (_ref3) {
    var value = _ref3.value;
    return value.isActive(query);
  }).map(function (_ref4) {
    var key = _ref4.key;
    return key;
  }).value();

  return _.isEmpty(activeSecondaryView);
};

var PrimarySearchView = {
  participating: {
    name: 'My Conversations',
    isActive: function isActive(query, currentUserId) {
      var filters = _.pick(query, FILTER_KEYS);
      var primaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]];
      var customFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["b" /* CONVERSATION_TAG_KEY */]];

      return _.isEqual(primaryFilters, [currentUserId.toString()]) && _.isEmpty(customFilters) && !hasAdvancedConversationStatusFilters(query);
    },
    getQuery: function getQuery(_ref5) {
      var currentUserId = _ref5.currentUserId,
          currentQuery = _ref5.currentQuery,
          statusFilters = _ref5.statusFilters;

      var query = {};
      query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]] = [currentUserId.toString()];
      query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = statusFilters;
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), query));
    }
  },
  noParticipants: {
    name: 'Unassigned',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var primaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]];
      var customFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["b" /* CONVERSATION_TAG_KEY */]];

      return (_.isEqual(primaryFilters, '0') || _.isEqual(primaryFilters, ['0'])) && _.isEmpty(customFilters) && !hasAdvancedConversationStatusFilters(query);
    },
    getQuery: function getQuery(_ref6) {
      var currentQuery = _ref6.currentQuery,
          statusFilters = _ref6.statusFilters;

      var query = {};
      query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]] = '0';
      query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = statusFilters;
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), query));
    }
  },
  all: {
    name: 'All Conversations',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var primaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["c" /* PARTICIPANT_FILTER_KEY */]];
      var customFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["b" /* CONVERSATION_TAG_KEY */]];

      return _.isEmpty(primaryFilters) && _.isEmpty(customFilters) && !hasAdvancedConversationStatusFilters(query);
    },
    getQuery: function getQuery(_ref7) {
      var currentQuery = _ref7.currentQuery,
          statusFilters = _ref7.statusFilters;

      var query = {};
      query[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = statusFilters;
      return makeQuery(_extends({}, _.pick(currentQuery, __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]), query));
    }
  }
};

var PrimarySearchViewEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(PrimarySearchView);

var getCurrentPrimaryView = function getCurrentPrimaryView(query, currentUserId) {
  var activeView = _.chain(PrimarySearchView).map(function (value, key) {
    return { value: value, key: key };
  }).filter(function (_ref8) {
    var value = _ref8.value;
    return value.isActive(query, currentUserId);
  }).map(function (_ref9) {
    var key = _ref9.key;
    return key;
  }).first().value();

  return activeView || __WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["a" /* ADVANCED_SEARCH_KEY */];
};

var SecondarySearchView = {
  open: {
    name: 'Open',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var secondaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]];

      return _.isEqual(secondaryFilters, [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key]);
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key];
      return makeQuery(nextQuery);
    }
  },
  pending: {
    name: 'Pending',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var secondaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]];

      return _.isEqual(secondaryFilters, [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key]);
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key];
      return makeQuery(nextQuery);
    }
  },
  closed: {
    name: 'Closed',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var secondaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]];

      return _.isEqual(secondaryFilters, [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key]);
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = [__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key];
      return makeQuery(nextQuery);
    }
  },
  all: {
    name: 'All',
    isActive: function isActive(query) {
      var filters = _.pick(query, FILTER_KEYS);
      var secondaryFilters = filters[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]];

      return _.isEmpty(secondaryFilters) || _.isEqual(new Set(secondaryFilters), new Set([__WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key, __WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key, __WEBPACK_IMPORTED_MODULE_2_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key]));
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["e" /* STATUS_FILTER_KEY */]] = undefined;
      return makeQuery(nextQuery);
    }
  }
};

var SecondarySearchViewEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(SecondarySearchView);

var getCurrentSecondaryView = function getCurrentSecondaryView(query) {
  var activeView = _.chain(SecondarySearchView).map(function (value, key) {
    return { value: value, key: key };
  }).filter(function (_ref10) {
    var value = _ref10.value;
    return value.isActive(query);
  }).map(function (_ref11) {
    var key = _ref11.key;
    return key;
  }).first().value();

  return activeView;
};

var SortView = {
  newest: {
    name: 'Newest',
    isActive: function isActive(query) {
      var sortKeys = _.pick(query, SORT_KEYS);
      var sortKey = sortKeys[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]];
      return _.isEmpty(sortKey) || _.isEqual(sortKey, __WEBPACK_IMPORTED_MODULE_3_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].NEWEST.value);
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]] = undefined;
      return makeQuery(nextQuery);
    }
  },
  oldest: {
    name: 'Oldest',
    isActive: function isActive(query) {
      var sortKeys = _.pick(query, SORT_KEYS);
      var sortKey = sortKeys[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]];
      return _.isEqual(sortKey, __WEBPACK_IMPORTED_MODULE_3_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].OLDEST.value);
    },
    getQuery: function getQuery(currentQuery) {
      var nextQuery = _extends({}, currentQuery);
      nextQuery[__WEBPACK_IMPORTED_MODULE_4_constants_FilterConstants__["d" /* SORT_KEY */]] = __WEBPACK_IMPORTED_MODULE_3_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].OLDEST.value;
      return makeQuery(nextQuery);
    }
  }
};

var SortViewEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(SortView);

var sortViewFromQuery = function sortViewFromQuery(query) {
  var activeView = _.chain(SortView).map(function (value, key) {
    return { value: value, key: key };
  }).filter(function (_ref12) {
    var value = _ref12.value;
    return value.isActive(query);
  }).map(function (_ref13) {
    var key = _ref13.key;
    return key;
  }).first().value();

  return activeView;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "F6Ot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationState; });
/* unused harmony export search */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onOnboarding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_selectors__ = __webpack_require__("Bqo0");


var root = function root(state) {
  return state.get('router');
};
var locationState = Object(__WEBPACK_IMPORTED_MODULE_0_utils_selectors__["b" /* immutableSelector */])(root, function (root) {
  return root.toJS();
});
var search = function search(state) {
  return root(state).getIn(['locationBeforeTransitions', 'search']);
};
var getQueryParams = Object(__WEBPACK_IMPORTED_MODULE_0_utils_selectors__["b" /* immutableSelector */])(root, function (root) {
  return root.getIn(['locationBeforeTransitions', 'query']);
});

var pathname = Object(__WEBPACK_IMPORTED_MODULE_0_utils_selectors__["b" /* immutableSelector */])(root, function (root) {
  return root.getIn(['locationBeforeTransitions', 'pathname']);
});
var onOnboarding = Object(__WEBPACK_IMPORTED_MODULE_0_utils_selectors__["b" /* immutableSelector */])(pathname, function (pathname) {
  return pathname.indexOf('/welcome') !== -1;
});

/***/ }),

/***/ "F7h3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FAbD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FBvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isFetchGeolocationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFetchGeolocationFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isGeolocationLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getIsGdprApplicable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("KtIW");


var root = function root(state) {
  return state.get('geolocation');
};

var isFetchGeolocationPending = function isFetchGeolocationPending(state) {
  return root(state).get('status') === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FETCH_GEOLOCATION_PENDING */];
};

var isFetchGeolocationFailure = function isFetchGeolocationFailure(state) {
  return root(state).get('status') === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_GEOLOCATION_FAILURE */];
};

var isGeolocationLoaded = function isGeolocationLoaded(state) {
  var status = root(state).get('status');
  return status === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FETCH_GEOLOCATION_SUCCESS */] || status === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_GEOLOCATION_FAILURE */];
};

var getIsGdprApplicable = function getIsGdprApplicable(state) {
  return root(state).getIn(['data', 'gdprApplicable']);
};

/***/ }),

/***/ "FFPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchDemandbaseCompanyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchDemandbaseCompanyDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchDemandbaseCompanyDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDemandbaseCompanyDataFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDemandbaseCompanyDataCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchDemandbaseTargetingIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchDemandbaseTargetingIndustriesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchDemandbaseTargetingIndustriesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchDemandbaseTargetingIndustriesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchDemandbaseTargetingSubIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchDemandbaseTargetingSubIndustriesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchDemandbaseTargetingSubIndustriesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchDemandbaseTargetingSubIndustriesFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Tz40");



var fetchDemandbaseCompanyData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_DEMANDBASE_COMPANY_DATA */]);
var fetchDemandbaseCompanyDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_DEMANDBASE_COMPANY_DATA_PENDING */]);
var fetchDemandbaseCompanyDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS */]);
var fetchDemandbaseCompanyDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_DEMANDBASE_COMPANY_DATA_FAILED */]);
var fetchDemandbaseCompanyDataCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED */]);

var fetchDemandbaseTargetingIndustries = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_DEMANDBASE_TARGETING_INDUSTRIES */]);
var fetchDemandbaseTargetingIndustriesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING */]);
var fetchDemandbaseTargetingIndustriesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS */]);
var fetchDemandbaseTargetingIndustriesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED */]);

var fetchDemandbaseTargetingSubIndustries = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES */]);
var fetchDemandbaseTargetingSubIndustriesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING */]);
var fetchDemandbaseTargetingSubIndustriesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS */]);
var fetchDemandbaseTargetingSubIndustriesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED */]);

/***/ }),

/***/ "FOd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadMissingFonts; });
var MissingFonts = ['Lato', 'Open+Sans', 'Roboto+Slab', 'Overpass'];
var loadMissingFonts = function loadMissingFonts() {
  MissingFonts.forEach(function (font) {
    var $linkTag = document.createElement('link');
    $linkTag.rel = 'stylesheet';
    $linkTag.href = 'https://fonts.googleapis.com/css?family=' + font + '|' + font + ':bold&display=swap';
    document.body && document.body.appendChild($linkTag);
  });
};

/***/ }),

/***/ "FOl0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("Jy8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);





var api = {
  fetch: function fetch(conversationId, limit) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].get('/conversations/' + conversationId + '/messages', limit ? { withReceipts: true, limit: limit } : { withReceipts: true }).checkStatus().retryWithBackoff().mapResponse(function (data) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_utils_immutable__["a" /* keyBy */])(data.map(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* parseMessage */]), { acc: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["OrderedMap"])() });
    });
  },
  fetchPaginated: function fetchPaginated(conversationId, from) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].get('/conversations/' + conversationId + '/messages/page', from ? { limit: 35, from: from } : { limit: 35 }).checkStatus().retryWithBackoff().mapResponse(function (data) {
      return {
        messages: Object(__WEBPACK_IMPORTED_MODULE_1_utils_immutable__["a" /* keyBy */])(data.data.reverse().map(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* parseMessage */]), { acc: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["OrderedMap"])() }),
        pagination: data.pagination
      };
    });
  },
  create: function create(conversationId, message) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMessagingAPI"].post('/conversations/' + conversationId + '/messages', message).checkStatus().retryWithBackoff(1).mapResponse(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* parseMessage */]);
  },
  markRead: function markRead(messageId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/messages/' + messageId + '/read').checkStatus().retryWithBackoff();
  },
  bulkMarkRead: function bulkMarkRead(conversationId, messageIds) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/messages/read-bulk', { conversationId: conversationId, messageIds: messageIds }).checkStatus().retryWithBackoff();
  },
  markReadUntil: function markReadUntil(messageId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/messages/' + messageId + '/read-until').checkStatus().retryWithBackoff();
  },
  createMessageForNewConversation2: function createMessageForNewConversation2(message) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["MessagingAPI"].post('/messages', message).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "FRFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var EndNode = function EndNode(_ref) {
  var label = _ref.label,
      path = _ref.path,
      icon = _ref.icon,
      className = _ref.className,
      _onClick = _ref.onClick,
      _ref$exact = _ref.exact,
      exact = _ref$exact === undefined ? true : _ref$exact,
      _ref$external = _ref.external,
      external = _ref$external === undefined ? typeof path === 'string' && path.match(/^http/) : _ref$external,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ['label', 'path', 'icon', 'className', 'onClick', 'exact', 'external', 'disabled']);

  var LinkProps = {
    exact: exact,
    to: path,
    activeClassName: "tc-subnav-link--active"
  };
  var AnchorTagProps = {
    href: path
  };

  var Link = !external ? __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */] : __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["A"];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Link,
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('tc-subnav-link', { 'tc-subnav-link--disabled': disabled }, className),
      onClick: function onClick() {
        return _onClick && _onClick();
      }
    }, external ? AnchorTagProps : LinkProps, rest),
    icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: icon, height: '12', width: '12' }),
    label
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EndNode);

/***/ }),

/***/ "FRQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FVGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_sfdc_models__ = __webpack_require__("iRcY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_access_api__ = __webpack_require__("T2nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorState__ = __webpack_require__("z78L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("FRQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var successMessage = 'You successfully updated your Salesforce configuration!';

var LeadContactPropertyMapping = function (_Component) {
  _inherits(LeadContactPropertyMapping, _Component);

  function LeadContactPropertyMapping(props) {
    _classCallCheck(this, LeadContactPropertyMapping);

    var _this = _possibleConstructorReturn(this, (LeadContactPropertyMapping.__proto__ || Object.getPrototypeOf(LeadContactPropertyMapping)).call(this, props));

    _initialiseProps.call(_this);

    setTimeout(function () {
      return _this.setState({ loaded: _this.allDataHasLoaded(_this.props) });
    }, 750);

    _this.state = {
      loaded: false,
      useStateAcronyms: _this.props.useStateAcronyms,
      useCountryAcronyms: _this.props.useCountryAcronyms,
      allowAttributeDefaults: _this.props.allowAttributeDefaults,
      createContactOnCaseCreation: _this.props.createContactOnCaseCreation,
      hasSalesforceCases: false,
      isPendingCutover: true
    };
    return _this;
  }

  _createClass(LeadContactPropertyMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.useCountryAcronyms !== nextProps.useCountryAcronyms) {
        this.setState({ useCountryAcronyms: nextProps.useCountryAcronyms });
      }

      if (this.props.useStateAcronyms !== nextProps.useStateAcronyms) {
        this.setState({ useStateAcronyms: nextProps.useStateAcronyms });
      }
      if (this.props.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
        this.setState({ allowAttributeDefaults: nextProps.allowAttributeDefaults });
      }
      if (this.props.createContactOnCaseCreation !== nextProps.createContactOnCaseCreation) {
        this.setState({ createContactOnCaseCreation: nextProps.createContactOnCaseCreation });
      }

      if (!this.state.loaded && this.allDataHasLoaded(nextProps) && !this.state.isPendingCutover) {
        setTimeout(function () {
          return _this2.setState({ loaded: true });
        }, 750);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var hasAccess = __WEBPACK_IMPORTED_MODULE_3_utils_Access__["c" /* default */].hasGates('SALESFORCE_MAPPING');
      !hasAccess && window.location.replace('/settings/setup/salesforce/');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.props.actions.fetchDriftProperties();
      this.props.actions.fetchSFDCProperties(this.props.type);
      this.props.actions.fetchSFDCMappings();

      Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_access_api__["a" /* getDriftCutover */])({ orgId: this.props.orgId, cutoverName: 'ORG_HAS_SALESFORCE_TICKETING' }).then(function (_ref) {
        var hasSalesforceCases = _ref.ORG_HAS_SALESFORCE_TICKETING;

        _this3.setState({
          hasSalesforceCases: hasSalesforceCases,
          isPendingCutover: false
        });
      }).catch(function (err) {
        console.warn(err);
        _this3.setState({ isPendingCutover: false });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var mappings = this.props.mappings;


      if (this.props.mappingsError || this.props.attributesError) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ErrorState__["a" /* default */], null);
      }

      if (!this.state.loaded) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Loader"], { className: 'salesforce-mapping-loader' });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_AttributeMapper__["a" /* default */], {
          integrationName: 'Salesforce',
          mappings: mappings.filter(function (mapping) {
            return _.find(_this4.props.sfdcProperties, { name: mapping.integrationAttribute });
          }),
          driftAttributes: this.props.driftProperties,
          integrationAttributes: this.props.sfdcProperties,
          mappingModel: __WEBPACK_IMPORTED_MODULE_8_app_modules_sfdc_models__["a" /* SFDCMapping */],
          patchMappings: this.patchDecorator,
          patchLoading: this.props.sfdcPatchLoading,
          allowAttributeDefaults: this.state.allowAttributeDefaults
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-toggle-table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-toggle-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], { className: 'salesforce-acronym-toggle',
              type: 'checkbox',
              checked: this.state.allowAttributeDefaults,
              onChange: this.onDefaultToggled }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'salesforce-toggle-text' },
              'Set default values that will send when a Drift Attribute is empty'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-toggle-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], { className: 'salesforce-acronym-toggle',
              type: 'checkbox',
              checked: this.state.useCountryAcronyms,
              onChange: this.onCountryToggled }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'salesforce-toggle-text' },
              'Send abbreviated country names to Salesforce (i.e. US instead of United States)'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-toggle-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], { className: 'salesforce-acronym-toggle',
              type: 'checkbox',
              checked: this.state.useStateAcronyms,
              onChange: this.onStateToggled }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              { className: 'salesforce-toggle-text' },
              'Send abbreviated state names to Salesforce (i.e. NY instead of New York)'
            )
          ),
          this.state.hasSalesforceCases && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-toggle-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], { className: 'salesforce-acronym-toggle',
              type: 'checkbox',
              checked: this.state.createContactOnCaseCreation,
              onChange: this.handleCaseToggled }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'salesforce-toggle-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'salesforce-toggle-text' },
                'Create a new contact to attach cases to if no associated contact exists'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'salesforce-toggle-subtext' },
                'New contacts will be floating if there is no associated account. Unchecked, cases will not be created if no associated contact exists. Cases are created regardless of CQL score settings.'
              )
            )
          )
        )
      );
    }
  }]);

  return LeadContactPropertyMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.onDefaultToggled = function () {
    var allowAttributeDefaults = _this5.state.allowAttributeDefaults;
    var _props = _this5.props,
        mappings = _props.mappings,
        notifications = _props.notifications;

    var defaultMapping = {
      mappings: _this5.convertMappingFromIntegrationToSfdc(mappings),
      allowAttributeDefaults: !allowAttributeDefaults
    };
    _this5.setState({ allowAttributeDefaults: !allowAttributeDefaults });
    _this5.props.actions.patchSFDCMappings(defaultMapping, true, function () {
      return notifications.success(successMessage);
    });
  };

  this.onCountryToggled = function () {
    var useCountryAcronyms = _this5.state.useCountryAcronyms;
    var _props2 = _this5.props,
        mappings = _props2.mappings,
        notifications = _props2.notifications;

    var countryMapping = {
      mappings: _this5.convertMappingFromIntegrationToSfdc(mappings),
      useCountryAcronyms: !useCountryAcronyms
    };
    _this5.setState({ useCountryAcronyms: !useCountryAcronyms });
    _this5.props.actions.patchSFDCMappings(countryMapping, true, function () {
      return notifications.success(successMessage);
    });
  };

  this.onStateToggled = function () {
    var useStateAcronyms = _this5.state.useStateAcronyms;
    var _props3 = _this5.props,
        mappings = _props3.mappings,
        notifications = _props3.notifications;

    var stateMapping = {
      mappings: _this5.convertMappingFromIntegrationToSfdc(mappings),
      useStateAcronyms: !useStateAcronyms
    };
    _this5.setState({ useStateAcronyms: !useStateAcronyms });
    _this5.props.actions.patchSFDCMappings(stateMapping, true, function () {
      return notifications.success(successMessage);
    });
  };

  this.handleCaseToggled = function () {
    var createContactOnCaseCreation = _this5.state.createContactOnCaseCreation;
    var _props4 = _this5.props,
        mappings = _props4.mappings,
        notifications = _props4.notifications;

    var caseMapping = {
      mappings: _this5.convertMappingFromIntegrationToSfdc(mappings),
      createContactOnCaseCreation: !createContactOnCaseCreation
    };
    _this5.setState({ createContactOnCaseCreation: !createContactOnCaseCreation }, function () {
      return _this5.props.actions.patchSFDCMappings(caseMapping, true, function () {
        return notifications.success(successMessage);
      });
    });
  };

  this.allDataHasLoaded = function (props) {
    return props.mappings && props.driftProperties && props.driftProperties.length > 0 && props.sfdcProperties && props.sfdcProperties.length > 0;
  };

  this.patchDecorator = function (strippedMappings, successCB) {
    var _props5 = _this5.props,
        mappings = _props5.mappings,
        sfdcProperties = _props5.sfdcProperties;

    var hiddenMappings = mappings.filter(function (mapping) {
      return !_.find(sfdcProperties, { name: mapping.integrationAttribute });
    });
    _this5.props.actions.patchSFDCMappings(_this5.convertMappingFromIntegrationToSfdc(strippedMappings.concat(hiddenMappings)), false, successCB);
  };

  this.convertMappingFromIntegrationToSfdc = function (mappings) {
    return mappings.map(function (entry) {
      var defaultValue = entry.defaultValue,
          driftAttribute = entry.driftAttribute,
          editable = entry.editable,
          integrationAttribute = entry.integrationAttribute,
          isOverwritable = entry.isOverwritable;

      return {
        defaultValue: defaultValue, driftAttribute: driftAttribute, isOverwritable: isOverwritable,
        salesforceAttribute: integrationAttribute,
        "static": undefined === editable ? false : !editable
      };
    });
  };
};

LeadContactPropertyMapping.defaultProps = {
  mappings: [],
  useCountryAcronyms: false,
  useStateAcronyms: false,
  allowAttributeDefaults: false,
  createContactOnCaseCreation: false
};

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state),
    mappings: state.get('sfdc').mappings,
    sfdcProperties: state.get('sfdc').sfdcProperties,
    mappingsError: state.get('sfdc').sfdcMappingsErr,
    attributesError: state.get('sfdc').sfdcAttributesErr,
    sfdcPatchLoading: state.get('sfdc').sfdcPatchLoading,
    useCountryAcronyms: state.get('sfdc').useCountryAcronyms,
    useStateAcronyms: state.get('sfdc').useStateAcronyms,
    allowAttributeDefaults: state.get('sfdc').allowAttributeDefaults,
    createContactOnCaseCreation: state.get('sfdc').createContactOnCaseCreation,
    orgId: __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__["orgId"](state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      fetchSFDCMappings: __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_actions__["fetchSFDCMappings"],
      fetchSFDCProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_actions__["fetchSFDCProperties"],
      patchSFDCMappings: __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_actions__["patchSFDCMappings"]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(LeadContactPropertyMapping)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "FZ6g":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 9 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><g id=\"Artboard\" transform=\"translate(-323.000000, -106.000000)\"><g id=\"Hollow_1\" transform=\"translate(248.000000, 97.000000)\"><g id=\"Group-14\" transform=\"translate(76.000000, 10.000000)\"><g id=\"Path-106\"><use fill=\"#FDED15\" fill-rule=\"evenodd\" xlink:href=\"#path-1\"></use><path stroke=\"#394F5A\" fill=\"#FDED15\" stroke-width=\"0.75\" d=\"M3.56696484,5.74476048 L7.72489136,5.74476048 L0.219201082,16.3480792 L3.08413575,8.00374251 L-0.688214461,8.00374251 L6.06109097,-2.45745637 L3.56696484,5.74476048 Z\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "FaLI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var CampaignAPI = Marty.createStateSource({
  id: 'CampaignAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["i" /* CONVERSATION_API */],

  createCampaign: function createCampaign(body) {
    return this.post({
      url: '/campaigns',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(body)
    });
  },
  getCampaignsForSegment: function getCampaignsForSegment(segmentId) {
    return this.get({
      url: '/user_lists/' + segmentId + '/campaigns',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateCampaign: function updateCampaign(id, operations) {
    return this.patch({
      url: '/campaigns/' + id + '/patch',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(operations)
    });
  },


  // Temporary endpoint that preserves legacy functionality
  updateCampaignOld: function updateCampaignOld(id, operations) {
    return this.patch({
      url: '/campaigns/' + id + '/old',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(operations)
    });
  },
  fetchCampaigns: function fetchCampaigns() {
    return this.get({
      url: '/campaigns?size=500&no_results=true',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCampaign: function fetchCampaign(id) {
    var accessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return this.get({
      url: '/campaigns/' + id,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(accessToken)
    });
  },
  fetchCampaignsForEndUserId: function fetchCampaignsForEndUserId(endUserId) {
    return this.get({
      url: '/campaigns?endUserId=' + endUserId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchLatestCampaignStats: function fetchLatestCampaignStats(size, type) {
    return this.get({
      url: '/campaigns/latest?' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])({ size: size, type: type }),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCampaignResults: function fetchCampaignResults(campaignId, query) {
    return this.get({
      url: '/campaigns/' + campaignId + '/results' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])(query),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCampaignMembers: function fetchCampaignMembers(campaignId, query) {
    return this.get({
      url: '/campaigns/' + campaignId + '/members2?' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])(query),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  sendTestCampaign: function sendTestCampaign(campaign, emails) {
    return this.post({
      url: '/campaigns/test',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify({ campaign: campaign, emails: emails })
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CampaignAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "FaTt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "FgcT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClearbitRevealConvoPreview */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClearbitRevealLivePreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClearbitRevealTargetingPreview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_payments_Gates__ = __webpack_require__("G69f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_SalesforceLeadEnrichmentIcon__ = __webpack_require__("Hxpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_ConvoRevealIcon__ = __webpack_require__("6sJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_LiveRevealIcon__ = __webpack_require__("CM6b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_TargetingRevealIcon__ = __webpack_require__("AeAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("rNMR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);











var UpgradeRibbon = function UpgradeRibbon() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { className: 'clearbit-reveal-upgrade-ribbon' },
    'Upgrade'
  );
};

var TopPane = function TopPane(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    { className: 'clearbit-reveal-upgrade-description' },
    props.message,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], {
      className: 'right-arrow',
      width: 15,
      height: 10,
      name: 'arrow-2-right'
    })
  );
};

var BottomPane = function BottomPane(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'clearbit-reveal-upgrade-view-widget' },
    props.icon
  );
};

var ClearbitRevealPreview = function ClearbitRevealPreview(_ref) {
  var title = _ref.title,
      message = _ref.message,
      icon = _ref.icon;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'clearbit-reveal-upgrade-view' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpgradeRibbon, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'clearbit-accordion-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'clearbit-accordion-header-top' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'clearbit-accordion-header-title' },
          title
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopPane, { message: message }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'border-div' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomPane, { icon: icon })
    )
  );
};

var Upgrade = function Upgrade(_ref2) {
  var component = _ref2.component,
      featureText = _ref2.featureText,
      featurePlan = _ref2.featurePlan,
      featureTag = _ref2.featureTag;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_payments_Gates__["c" /* default */], {
    FallbackComponent: component,
    requiredGates: ['NO_GATES'],
    useModal: true,
    modalText: featureText,
    modalPlan: featurePlan,
    feature: featureTag
  });
};

var ClearbitRevealConvoPreview = function ClearbitRevealConvoPreview() {
  var convoTitle = 'Want to see company data here?';
  var message = 'Reveal full company data for anonymous site visitors in Live View, conversations, and playbook targeting with Drift\'s Pro Plan\n';
  var component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearbitRevealPreview, { title: convoTitle, message: message, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_ConvoRevealIcon__["a" /* default */], null) });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Upgrade, { component: component, featureText: 'Company data in conversations', featurePlan: 'Pro', featureTag: 'clearbit-reveal-convo-view' });
};

var ClearbitRevealLivePreview = function ClearbitRevealLivePreview() {
  var convoTitle = 'Want to see company data here?';
  var message = 'Reveal full company data for anonymous site visitors in Live View, conversations, and playbook targeting with Drift\'s Company Plan\n';
  var component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearbitRevealPreview, { title: convoTitle, message: message, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_LiveRevealIcon__["a" /* default */], null) });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Upgrade, { component: component, featureText: 'Company data in Live', featurePlan: 'Company', featureTag: 'clearbit-reveal-live-view' });
};

var ClearbitRevealTargetingPreview = function ClearbitRevealTargetingPreview() {
  var convoTitle = 'Want to target based on enriched company data?';
  var message = 'Target playbooks based on Clearbit company data like Alexa Ranking, Revenue, Amount Raised, and more with Drift’s Company Plan.';
  var component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClearbitRevealPreview, { title: convoTitle, message: message, icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_TargetingRevealIcon__["a" /* default */], null) });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Upgrade, { component: component, featureText: 'Clearbit Firmographics', featurePlan: 'Company', featureTag: 'clearbit-reveal-firmographics-view' });
};

/* unused harmony default export */ var _unused_webpack_default_export = (ClearbitRevealPreview);

/***/ }),

/***/ "Fhyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_hubspot_actions__ = __webpack_require__("vCIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__ = __webpack_require__("1eL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_hubspot_models__ = __webpack_require__("kvsP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("Tpy9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var HELP_DOC_URL = 'https://help.drift.com/integrations/hubspot-attribute-mapping';
var integrationName = "Hubspot";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};

var HubspotAttributeMapping = function (_Component) {
  _inherits(HubspotAttributeMapping, _Component);

  function HubspotAttributeMapping(props) {
    _classCallCheck(this, HubspotAttributeMapping);

    var _this = _possibleConstructorReturn(this, (HubspotAttributeMapping.__proto__ || Object.getPrototypeOf(HubspotAttributeMapping)).call(this, props));

    _this.createDefaultMapping = function (mappings) {
      return mappings.map(function (mapping) {
        return mapping.driftAttribute && mapping.defaultValue ? _extends(mapping, { defaultValue: null }) : mapping;
      });
    };

    _this.onCountryUpdated = function () {
      var _this$state = _this.state,
          mappings = _this$state.mappings,
          allowAttributeDefaults = _this$state.allowAttributeDefaults,
          useStateAcronyms = _this$state.useStateAcronyms,
          useCountryAcronyms = _this$state.useCountryAcronyms;


      var payload = {
        mappings: mappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useStateAcronyms: useStateAcronyms,
        useCountryAcronyms: !useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.onStateUpdated = function () {
      var _this$state2 = _this.state,
          mappings = _this$state2.mappings,
          allowAttributeDefaults = _this$state2.allowAttributeDefaults,
          useStateAcronyms = _this$state2.useStateAcronyms,
          useCountryAcronyms = _this$state2.useCountryAcronyms;


      var payload = {
        mappings: mappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useStateAcronyms: !useStateAcronyms,
        useCountryAcronyms: useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.onDefaultUpdated = function () {
      var _this$state3 = _this.state,
          mappings = _this$state3.mappings,
          allowAttributeDefaults = _this$state3.allowAttributeDefaults,
          useStateAcronyms = _this$state3.useStateAcronyms,
          useCountryAcronyms = _this$state3.useCountryAcronyms;


      var payload = {
        mappings: _this.createDefaultMapping(mappings),
        allowAttributeDefaults: !allowAttributeDefaults,
        useStateAcronyms: useStateAcronyms,
        useCountryAcronyms: useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.updateMappings = function (payload) {
      var notifications = _this.props.notifications;


      _this.props.actions.patchHubspotAttributeMappings(payload, function () {
        notifications.success(getSuccessMessage(integrationName));
        // Update UI with the new state after success.
        _this.setState(_extends({}, payload));
      });
    };

    _this.patchDecorator = function (strippedMappings, successCB) {
      var _this$state4 = _this.state,
          allowAttributeDefaults = _this$state4.allowAttributeDefaults,
          useCountryAcronyms = _this$state4.useCountryAcronyms,
          useStateAcronyms = _this$state4.useStateAcronyms;

      var payload = {
        mappings: strippedMappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useCountryAcronyms: useCountryAcronyms,
        useStateAcronyms: useStateAcronyms
      };
      _this.props.actions.patchHubspotAttributeMappings(payload, successCB);
    };

    _this.state = {
      mappings: props.mappings,
      useCountryAcronyms: props.useCountryAcronyms,
      useStateAcronyms: props.useStateAcronyms,
      allowAttributeDefaults: props.allowAttributeDefaults
    };
    return _this;
  }

  _createClass(HubspotAttributeMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
        this.setState({ allowAttributeDefaults: nextProps.allowAttributeDefaults });
      }
      if (this.state.mappings !== nextProps.mappings) {
        this.setState({ mappings: nextProps.mappings });
      }
      if (this.state.useCountryAcronyms !== nextProps.useCountryAcronyms) {
        this.setState({ useCountryAcronyms: nextProps.useCountryAcronyms });
      }
      if (this.state.useStateAcronyms !== nextProps.useStateAcronyms) {
        this.setState({ useStateAcronyms: nextProps.useStateAcronyms });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchDriftProperties();
      this.props.actions.fetchHubspotFields();
      this.props.actions.fetchHubspotAttributeMappings();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          patchLoading = _props.patchLoading,
          driftProperties = _props.driftProperties,
          hubspotFields = _props.hubspotFields;
      var _state = this.state,
          mappings = _state.mappings,
          allowAttributeDefaults = _state.allowAttributeDefaults,
          useCountryAcronyms = _state.useCountryAcronyms,
          useStateAcronyms = _state.useStateAcronyms;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'hubspot-mapping common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Hubspot Integration',
          backLinkUrl: '/settings/setup/hubspot'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Mapped Hubspot Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map which fields you want to add to new Hubspot Leads. These Drift attributes will be added to new Hubspot Leads when they\u2019re created.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: HELP_DOC_URL },
              ' Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__["a" /* default */], {
          integrationName: 'Hubspot',
          mappings: mappings,
          driftAttributes: driftProperties,
          integrationAttributes: hubspotFields,
          mappingModel: __WEBPACK_IMPORTED_MODULE_9_app_modules_hubspot_models__["a" /* HubspotMapping */],
          patchMappings: this.patchDecorator,
          patchLoading: patchLoading,
          allowAttributeDefaults: allowAttributeDefaults }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'hubspot-toggle-row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], { className: 'hubspot-default-checkbox',
            type: 'checkbox',
            checked: allowAttributeDefaults,
            onChange: this.onDefaultUpdated }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'hubspot-toggle-text' },
            'Set default values that will send when a Drift Attribute is empty'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'hubspot-toggle-row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
            className: 'hubspot-default-checkbox',
            type: 'checkbox',
            checked: useCountryAcronyms,
            onChange: this.onCountryUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'hubspot-toggle-text' },
            'Send abbreviated country names to HubSpot (i.e. US instead of United States)'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'hubspot-toggle-row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
            className: 'hubspot-default-checkbox',
            type: 'checkbox',
            checked: useStateAcronyms,
            onChange: this.onStateUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'hubspot-toggle-text' },
            'Send abbreviated state names to HubSpot (i.e. NY instead of New York)'
          )
        )
      );
    }
  }]);

  return HubspotAttributeMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

HubspotAttributeMapping.defaultProps = {
  allowAttributeDefaults: false,
  useStateAcronyms: false,
  useCountryAcronyms: false
};

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state),
    mappings: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["c" /* getAttributeMappings */])(state),
    hubspotFields: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["b" /* getAttributeFields */])(state),
    patchError: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["a" /* didAttributePatchErr */])(state),
    patchLoading: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["g" /* isAttributePatchLoading */])(state),
    allowAttributeDefaults: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["f" /* isAllowAttributeDefaults */])(state),
    useCountryAcronyms: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["i" /* isUseCountryAcronyms */])(state),
    useStateAcronyms: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_selectors__["j" /* isUseStateAcronyms */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      fetchHubspotAttributeMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_hubspot_actions__["b" /* fetchHubspotAttributeMappings */],
      fetchHubspotFields: __WEBPACK_IMPORTED_MODULE_4_app_modules_hubspot_actions__["c" /* fetchHubspotFields */],
      patchHubspotAttributeMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_hubspot_actions__["e" /* patchHubspotAttributeMappings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(HubspotAttributeMapping)));

/***/ }),

/***/ "Fpp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_countdown_now__ = __webpack_require__("hdfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("Vxfn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var countdownRenderer = function countdownRenderer(_ref) {
  var seconds = _ref.seconds,
      minutes = _ref.minutes;

  if (minutes <= 0) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Span"],
      { className: 'timeout-modal-seconds-countdown-span' },
      seconds,
      ' second',
      seconds > 1 ? 's' : ''
    );
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Span"],
      { className: 'timeout-modal-minutes-countdown-span' },
      minutes,
      ' minute',
      minutes > 1 ? 's' : ''
    );
  }
};

var TimeoutModal = function (_Component) {
  _inherits(TimeoutModal, _Component);

  function TimeoutModal() {
    _classCallCheck(this, TimeoutModal);

    return _possibleConstructorReturn(this, (TimeoutModal.__proto__ || Object.getPrototypeOf(TimeoutModal)).apply(this, arguments));
  }

  _createClass(TimeoutModal, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      //don't update after initial render so we don't reset the modal timer once it's started
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancel = _props.cancel,
          logOut = _props.logOut,
          modalTime = _props.modalTime;

      var countDown = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_countdown_now__["a" /* default */], { onComplete: function onComplete() {
          return logOut(true);
        }, date: Date.now() + modalTime, renderer: countdownRenderer });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Div"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Modal"],
          { className: 'session-timeout-modal', size: 'small', type: 'warning', open: true, onClose: cancel },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["H3"],
            { className: 'session-timeout-modal-heading' },
            'Still here?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["P"],
            null,
            'For your security, your session will expire in ',
            countDown,
            ' due to inactivity and you will be logged out. '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["P"],
            null,
            'Click \u201Ccontinue\u201D to keep using Drift or \u201Clog out\u201D to end your session'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Footer"],
            { className: 'session-timeout-modal-footer' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
              { className: 'session-timeout-modal-continue-button', type: 'secondary', onClick: cancel },
              'Continue'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
              { className: 'session-timeout-modal-logout-button', type: 'tertiary', onClick: function onClick() {
                  return logOut(false);
                } },
              'Log out'
            )
          )
        )
      );
    }
  }]);

  return TimeoutModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "FvBW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__ = __webpack_require__("Wr1c");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var CompanyActions = Marty.createActionCreators({
  updateCompany: function updateCompany(companyId, companyParams) {
    return this.app.queries.CompanyQueries.updateCompany(companyId, companyParams);
  },
  setCompanyFromPusher: function setCompanyFromPusher(company) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].SET_COMPANY_FROM_PUSHER, company);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CompanyActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "FxSa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Table":"Table---yWERk","SectionHeader":"SectionHeader---zYa_O","SectionBody":"SectionBody---1Wmtp","ViewTimeLine":"ViewTimeLine---9OqKC"};

/***/ }),

/***/ "Fyqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G/PM":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "G1ow":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(30);

/***/ }),

/***/ "G20T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Playbook":"Playbook---264o-"};

/***/ }),

/***/ "G2IJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_object__ = __webpack_require__("1Rfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_svg_green_check_circle_svg__ = __webpack_require__("9SsH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_svg_green_check_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_svg_green_check_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_logos_stripe_png__ = __webpack_require__("5xWb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_logos_stripe_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_logos_stripe_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var STRIPE_SETTINGS_ID_SAVE = 'stripe-integration-settings-save';

var Stripe = function (_Component) {
  _inherits(Stripe, _Component);

  function Stripe(props) {
    _classCallCheck(this, Stripe);

    var _this = _possibleConstructorReturn(this, (Stripe.__proto__ || Object.getPrototypeOf(Stripe)).call(this, props));

    _this.isEditedKeyDirty = function () {
      return _this.state.editingPublicKey !== Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(_this.props, 'stripeKeys.publicKey') || _this.state.editingPrivateKey !== Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(_this.props, 'stripeKeys.privateKey');
    };

    _this.onChangePrivateKey = function (e) {
      _this.setState({
        editingPrivateKey: e.target.value
      });
    };

    _this.onChangePublicKey = function (e) {
      _this.setState({
        editingPublicKey: e.target.value
      });
    };

    _this.onSaveStripeSettings = function () {
      _this.props.actions.asyncButtonPress({
        url: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/integrations/stripe/keys',
        method: 'patch',
        data: {
          enabled: true,
          publicKey: _this.state.editingPublicKey,
          privateKey: _this.state.editingPrivateKey
        },
        successMessage: 'Successfully saved your Stripe settings!',
        errorMessage: 'Something went wrong and we couldn\u2019t save your Stripe settings',
        clickId: STRIPE_SETTINGS_ID_SAVE,
        successCallback: _this.onSuccessfulSave
      });
    };

    _this.onDisconnectStripe = function () {
      _this.props.actions.asyncButtonPress({
        url: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/integrations/stripe/keys',
        method: 'patch',
        data: {
          enabled: false,
          publicKey: '',
          privateKey: ''
        },
        successMessage: 'Successfully disconnected your Stripe account!',
        errorMessage: 'Something went wrong and we couldn\u2019t disconnect your Stripe account',
        clickId: STRIPE_SETTINGS_ID_SAVE
      });
    };

    _this.state = {
      editingPublicKey: Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(props, 'stripeKeys.publicKey'),
      editingPrivateKey: Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(props, 'stripeKeys.privateKey')
    };
    return _this;
  }

  _createClass(Stripe, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.stripeKeys !== this.props.stripeKeys) {
        this.setState({
          editingPrivateKey: Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(this.props, 'stripeKeys.privateKey'),
          editingPublicKey: Object(__WEBPACK_IMPORTED_MODULE_1_lodash_object__["get"])(this.props, 'stripeKeys.publicKey')
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.stripeKeysNeverFetched) {
        this.props.actions.fetchStripeKeys();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          editingPrivateKey = _state.editingPrivateKey,
          editingPublicKey = _state.editingPublicKey;
      var _props = this.props,
          saveStripeSettingsPending = _props.saveStripeSettingsPending,
          stripeKeys = _props.stripeKeys;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'integration-facebook-title-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'integration-facebook-title-image', src: __WEBPACK_IMPORTED_MODULE_7_images_logos_stripe_png___default.a }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            stripeKeys && stripeKeys.publicKey && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'integration-facebook-title-connected' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6_images_svg_green_check_circle_svg___default.a }),
              'Connected'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Process payments in Drift conversations with Stripe.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'connect-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], { type: 'text', disabled: saveStripeSettingsPending, value: editingPublicKey, onChange: this.onChangePublicKey, placeholder: 'Your Stripe public key', label: 'Stripe Public Key', className: 'integration-facebook-pixel-id-input' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], { type: 'text', disabled: saveStripeSettingsPending, value: editingPrivateKey, onChange: this.onChangePrivateKey, placeholder: 'Your Stripe private key', label: 'Stripe Private Key', className: 'integration-facebook-pixel-id-input' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { disabled: !this.isEditedKeyDirty() || saveStripeSettingsPending, className: 'integration-facebook-pixel-save-button', onClick: this.onSaveStripeSettings },
            'Connect'
          ),
          stripeKeys && stripeKeys.publicKey && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { disabled: saveStripeSettingsPending, onClick: this.onDisconnectStripe, type: 'secondary' },
            'Disconnect'
          )
        )
      );
    }
  }]);

  return Stripe;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    saveStripeSettingsPending: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["c" /* asyncButtonPending */](state, STRIPE_SETTINGS_ID_SAVE),
    stripeKeysNeverFetched: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__["r" /* stripeKeysNeverFetched */](state),
    fetchStripeKeysPending: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__["p" /* isStripeKeysPending */](state),
    stripeKeys: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__["q" /* stripeKeysData */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      asyncButtonPress: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["n" /* asyncButtonPress */],
      fetchStripeKeys: __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_actions__["v" /* fetchStripeKeys */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Stripe));

/***/ }),

/***/ "G2Mo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G3Uo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Popover__ = __webpack_require__("13uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AgentStatusAvatar__ = __webpack_require__("lIGH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__("ZBOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ramda_src_values__ = __webpack_require__("JWJY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ramda_src_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_ramda_src_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ramda_src_contains__ = __webpack_require__("wPla");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ramda_src_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_ramda_src_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("JbjM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var NewAgentStatus = function (_Component) {
  _inherits(NewAgentStatus, _Component);

  function NewAgentStatus(props) {
    _classCallCheck(this, NewAgentStatus);

    var _this = _possibleConstructorReturn(this, (NewAgentStatus.__proto__ || Object.getPrototypeOf(NewAgentStatus)).call(this, props));

    _this.toggleOpen = function () {
      _this.setState(function (prevState) {
        return {
          flyoutOpen: !prevState.flyoutOpen
        };
      });
    };

    _this.resolveNotificationSnoozeStatus = function () {
      var notificationsSnoozed = _this.props.settings.get('notifications-snoozed');
      return !!notificationsSnoozed ? __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* NotificationSnoozeStatus */].ON : __WEBPACK_IMPORTED_MODULE_12__constants__["b" /* NotificationSnoozeStatus */].OFF;
    };

    _this.isActive = function () {
      var currentUser = _this.props.currentUser;

      return currentUser.availability === __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* AvailabilityStatus */].ACTIVE || currentUser.availability === __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* AvailabilityStatus */].ON_CALL;
    };

    _this.resolveStatusIcon = function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          orgProperties = _this$props.orgProperties,
          isUserAtConversationLimit = _this$props.isUserAtConversationLimit;

      var isValidAgentStatus = __WEBPACK_IMPORTED_MODULE_14_ramda_src_contains___default()(currentUser.availability, __WEBPACK_IMPORTED_MODULE_13_ramda_src_values___default()(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* AvailabilityStatus */]));
      var agentAvailability = isValidAgentStatus ? currentUser.availability : __WEBPACK_IMPORTED_MODULE_12__constants__["a" /* AvailabilityStatus */].AWAY;
      var notificationSnoozeStatus = _this.resolveNotificationSnoozeStatus();
      var limitNumChatsEnabled = orgProperties && orgProperties.limitNumChatsEnabled;

      return Object(__WEBPACK_IMPORTED_MODULE_12__constants__["c" /* getStatusIcon */])(agentAvailability, notificationSnoozeStatus, limitNumChatsEnabled && isUserAtConversationLimit);
    };

    _this.state = {
      flyoutOpen: false
    };

    _this.onClickOutside = _this.toggleOpen;
    return _this;
  }

  _createClass(NewAgentStatus, [{
    key: 'renderFlyOut',
    value: function renderFlyOut() {
      var flyoutOpen = this.state.flyoutOpen;
      var _props = this.props,
          currentUser = _props.currentUser,
          globalHandle = _props.globalHandle,
          actions = _props.actions,
          settings = _props.settings,
          defaultInboxId = _props.defaultInboxId,
          isUserAtConversationLimit = _props.isUserAtConversationLimit,
          _props$orgProperties = _props.orgProperties,
          limitNumChats = _props$orgProperties.limitNumChats,
          limitNumChatsEnabled = _props$orgProperties.limitNumChatsEnabled,
          hasDriftHelpCutover = _props.hasDriftHelpCutover,
          trafficControlConfig = _props.trafficControlConfig;


      if (!flyoutOpen) return null;

      var autoAway = settings && settings.get('auto-away');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Popover__["a" /* default */], {
        user: currentUser,
        isActive: this.isActive(),
        onClickOutside: this.toggleOpen,
        notificationSnoozeStatus: this.resolveNotificationSnoozeStatus(),
        globalHandle: globalHandle,
        updateCurrentUser: actions.updateCurrentUser,
        updateUserProperties: actions.updateUserProperties,
        turnOffManualAway: actions.turnOffManualAway,
        limitNumChats: limitNumChats,
        limitNumChatsEnabled: limitNumChatsEnabled,
        atConversationLimit: isUserAtConversationLimit,
        autoAway: autoAway,
        defaultInboxId: defaultInboxId,
        hasDriftHelpCutover: hasDriftHelpCutover,
        trafficControlConfig: trafficControlConfig
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var currentUserLoaded = this.props.currentUserLoaded;

      if (!currentUserLoaded) return null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'new-agent-status with-new-status-avatar' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AgentStatusAvatar__["a" /* default */], { onClick: this.toggleOpen }),
        this.renderFlyOut()
      );
    }
  }]);

  return NewAgentStatus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state) {
    return {
      currentUser: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"](state),
      currentUserLoaded: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUserLoaded"](state),
      settings: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_selectors__["g" /* properties */](state),
      orgProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["properties"](state),
      globalHandle: __WEBPACK_IMPORTED_MODULE_6_app_modules_profile_selectors__["globalHandle"](state),
      defaultInboxId: __WEBPACK_IMPORTED_MODULE_9_app_modules_embed_selectors__["b" /* defaultInboxId */](state),
      isUserAtConversationLimit: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_selectors__["e" /* isUserAtConversationLimit */](state),
      trafficControlConfig: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["trafficControlConfig"](state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      updateCurrentUser: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateCurrentUser"],
      turnOffManualAway: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAway"],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_actions__["l" /* updateUserProperties */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(NewAgentStatus));

/***/ }),

/***/ "G4FV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("kuIf");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var loaded = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* setLoaded */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* timedOut */]), function () {
  return true;
}), false);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({
  loaded: loaded
}));

/***/ }),

/***/ "G4vU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompanyTab__ = __webpack_require__("rdCL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidesheet_modal__ = __webpack_require__("9NS/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContactInfo__ = __webpack_require__("Kv7O");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var PresenceSidesheet = function PresenceSidesheet(_ref) {
  var onClose = _ref.onClose,
      user = _ref.user,
      props = _objectWithoutProperties(_ref, ['onClose', 'user']);

  var tabData = [{
    title: 'Contact',
    component: function component() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContactInfo__["a" /* default */], _extends({ user: user, anonymousId: _.get(user, 'meta.anonymousId', '') }, props));
    }
  }, {
    title: 'Account',
    component: function component() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CompanyTab__["a" /* default */], { orgId: user.orgId, company: user.company, endUserId: user.endUserId });
    }
  }];
  var content = props.revealContext.liveReveal || props.revealContext.isEligibleForLiveRevealUpgradeFlow ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Tabs"], { data: tabData }) : tabData[0].component();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Sidesheet_modal__["a" /* default */],
    { onClose: onClose, title: 'Start a Conversation' },
    content
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PresenceSidesheet);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "G57K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchTimelineEventsForEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchTimelineEventsForEndUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTimelineEventsForEndUserCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchTimelineEventsForEndUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchTimelineEventsForEndUserSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadMoreTimelineEventsForEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return loadMoreTimelineEventsForEndUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return loadMoreTimelineEventsForEndUserCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return loadMoreTimelineEventsForEndUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loadMoreTimelineEventsForEndUserSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("9QV1");



var fetchTimelineEventsForEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_TIMELINE_EVENTS_FOR_END_USER */]);
var fetchTimelineEventsForEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_TIMELINE_EVENTS_FOR_END_USER_PENDING */]);
var fetchTimelineEventsForEndUserCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_TIMELINE_EVENTS_FOR_END_USER_CANCELLED */]);
var fetchTimelineEventsForEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_TIMELINE_EVENTS_FOR_END_USER_FAILED */]);
var fetchTimelineEventsForEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_TIMELINE_EVENTS_FOR_END_USER_SUCCESS */]);

var loadMoreTimelineEventsForEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER */]);
var loadMoreTimelineEventsForEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_PENDING */]);
var loadMoreTimelineEventsForEndUserCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_CANCELLED */]);
var loadMoreTimelineEventsForEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_FAILED */]);
var loadMoreTimelineEventsForEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* LOAD_MORE_TIMELINE_EVENTS_FOR_END_USER_SUCCESS */]);

/***/ }),

/***/ "G69f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PremiumGate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PremiumTeamGate; });
/* unused harmony export EnterpriseGate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__ = __webpack_require__("oNNb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_billing_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("tT6b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__ = __webpack_require__("OWv3");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Gate = function (_Component) {
  _inherits(Gate, _Component);

  function Gate(props) {
    _classCallCheck(this, Gate);

    var _this = _possibleConstructorReturn(this, (Gate.__proto__ || Object.getPrototypeOf(Gate)).call(this, props));

    _this.handleClick = function () {
      var _this$props = _this.props,
          disableOverlayClick = _this$props.disableOverlayClick,
          actions = _this$props.actions,
          feature = _this$props.feature;

      if (disableOverlayClick) {
        return;
      }
      if (feature) {
        actions.track('Gated CTA Clicked', { feature: feature });
      }
      if (_this.props.useModal) {
        _this.openUpgradeModal();
        return;
      }
      _this.context.router.push('/settings/billing');
    };

    _this.closeUpgradeModal = function () {
      _this.setState({ isUpgradeModalOpen: false });
    };

    _this.openUpgradeModal = function () {
      _this.setState({ isUpgradeModalOpen: true });
    };

    _this.state = {
      isUpgradeModalOpen: false
    };
    return _this;
  }

  _createClass(Gate, [{
    key: 'hasAccess',
    value: function hasAccess() {
      var _props = this.props,
          requiredGates = _props.requiredGates,
          alternativeGates = _props.alternativeGates,
          gates = _props.gates;

      var hasAlternativeAccess = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.some(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(alternativeGates, function (gate) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(gates, gate, false);
      }));
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.some(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(requiredGates, function (gate) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(gates, gate, false);
      })) || hasAlternativeAccess;
    }
  }, {
    key: 'getBillingStep',
    value: function getBillingStep() {
      return this.context.location.query.billingStep;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          FallbackComponent = _props2.FallbackComponent;
      var isUpgradeModalOpen = this.state.isUpgradeModalOpen;

      var step = this.getBillingStep();

      if (this.hasAccess() && __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isUndefined(step)) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          null,
          children
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'drift-gated-content', onClick: this.handleClick },
          FallbackComponent || __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__["a" /* default */],
            { condition: isUpgradeModalOpen },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__["UpgradeModal"], {
              onCloseInitiated: this.closeUpgradeModal,
              headLineFeatureText: this.props.modalText,
              planName: this.props.modalPlan,
              isMonthlyBilling: true
            })
          )
        );
      }
    }
  }]);

  return Gate;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

Gate.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  gates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  requiredGates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  alternativeGates: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  FallbackComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  useModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modalText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  modalPlan: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  feature: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
Gate.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    gates: __WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["c" /* getGates */](state).toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
};

var GateContainer = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Gate);

var PREMIUM_GATE = 'premium_drift';
var ENTERPRISE_GATE = 'premium_enterprise';

var PremiumGate = function PremiumGate(_ref) {
  var _ref$requiredGates = _ref.requiredGates,
      requiredGates = _ref$requiredGates === undefined ? [] : _ref$requiredGates,
      _ref$alternativeGates = _ref.alternativeGates,
      alternativeGates = _ref$alternativeGates === undefined ? [] : _ref$alternativeGates,
      rest = _objectWithoutProperties(_ref, ['requiredGates', 'alternativeGates']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(GateContainer, _extends({
    requiredGates: [PREMIUM_GATE].concat(_toConsumableArray(requiredGates)),
    alternativeGates: alternativeGates
  }, rest));
};


var PremiumTeamGate = function PremiumTeamGate(_ref2) {
  var _ref2$requiredGates = _ref2.requiredGates,
      requiredGates = _ref2$requiredGates === undefined ? [] : _ref2$requiredGates,
      _ref2$alternativeGate = _ref2.alternativeGates,
      alternativeGates = _ref2$alternativeGate === undefined ? [] : _ref2$alternativeGate,
      rest = _objectWithoutProperties(_ref2, ['requiredGates', 'alternativeGates']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(GateContainer, _extends({
    requiredGates: [__WEBPACK_IMPORTED_MODULE_4_utils_Access__["b" /* Gates */].PREMIUM_TEAM].concat(_toConsumableArray(requiredGates)),
    alternativeGates: alternativeGates
  }, rest));
};


var EnterpriseGate = function EnterpriseGate(_ref3) {
  var _ref3$requiredGates = _ref3.requiredGates,
      requiredGates = _ref3$requiredGates === undefined ? [] : _ref3$requiredGates,
      _ref3$alternativeGate = _ref3.alternativeGates,
      alternativeGates = _ref3$alternativeGate === undefined ? [] : _ref3$alternativeGate,
      rest = _objectWithoutProperties(_ref3, ['requiredGates', 'alternativeGates']);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(GateContainer, _extends({
    requiredGates: [ENTERPRISE_GATE].concat(_toConsumableArray(requiredGates)),
    alternativeGates: alternativeGates
  }, rest));
};


/* harmony default export */ __webpack_exports__["c"] = (GateContainer);

/***/ }),

/***/ "G8qF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GHRo":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 256 180\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\"><path d=\"M106.55 19.65c8.25-8.6 19.73-13.92 32.43-13.92 16.9 0 31.6 9.4 39.46 23.4 6.8-3.06 14.36-4.75 22.3-4.75 30.45 0 55.13 24.9 55.13 55.6 0 30.73-24.68 55.63-55.13 55.63-3.72 0-7.35-.36-10.86-1.07-6.9 12.32-20.07 20.64-35.18 20.64-6.32 0-12.3-1.46-17.63-4.05-7 16.47-23.32 28-42.33 28-19.8 0-36.68-12.5-43.15-30.08-2.84.6-5.78.9-8.8.9-23.56 0-42.67-19.3-42.67-43.12 0-15.96 8.58-29.9 21.34-37.36-2.62-6.04-4.08-12.7-4.08-19.73 0-27.4 22.23-49.6 49.66-49.6 16.1 0 30.42 7.66 39.5 19.52\" fill=\"#00A1E0\"></path><path d=\"M37.17 92.96c-.16.42.06.5.1.58.5.35.98.6 1.47.88 2.6 1.38 5.07 1.8 7.65 1.8 5.23 0 8.5-2.8 8.5-7.3v-.08c0-4.16-3.7-5.67-7.14-6.75l-.44-.16c-2.6-.85-4.85-1.57-4.85-3.3v-.08c0-1.46 1.3-2.54 3.35-2.54 2.25 0 4.94.75 6.66 1.7 0 0 .5.33.7-.16l1.06-2.87c.1-.3-.07-.5-.25-.6-1.98-1.2-4.7-2.02-7.53-2.02h-.52c-4.8 0-8.16 2.9-8.16 7.06v.1c0 4.37 3.7 5.8 7.16 6.78l.55.17c2.54.77 4.7 1.44 4.7 3.22v.08c0 1.63-1.4 2.84-3.68 2.84-.9 0-3.7-.02-6.76-1.95-.37-.22-.58-.38-.87-.55-.16-.1-.53-.26-.7.24l-1.03 2.86zM113.97 92.96c-.16.42.06.5.1.58.5.35.98.6 1.47.88 2.6 1.38 5.07 1.8 7.65 1.8 5.23 0 8.5-2.8 8.5-7.3v-.08c0-4.16-3.7-5.67-7.14-6.75l-.44-.16c-2.6-.85-4.85-1.57-4.85-3.3v-.08c0-1.46 1.3-2.54 3.34-2.54 2.27 0 4.95.75 6.68 1.7 0 0 .5.33.7-.16l1.06-2.87c.1-.3-.08-.5-.25-.6-1.98-1.2-4.7-2.02-7.53-2.02h-.52c-4.8 0-8.16 2.9-8.16 7.06v.1c0 4.37 3.7 5.8 7.16 6.78l.55.17c2.54.77 4.72 1.44 4.72 3.22v.08c0 1.63-1.42 2.84-3.7 2.84-.9 0-3.7-.02-6.76-1.95-.37-.22-.6-.37-.86-.55-.1-.06-.54-.23-.7.24l-1.03 2.86zM166.4 84.16c0 2.54-.47 4.54-1.4 5.95-.93 1.4-2.32 2.1-4.27 2.1-1.95 0-3.34-.7-4.24-2.1-.93-1.4-1.4-3.4-1.4-5.94 0-2.54.47-4.53 1.4-5.93.9-1.4 2.28-2.06 4.23-2.06 1.95 0 3.34.67 4.27 2.06.93 1.4 1.4 3.4 1.4 5.93m4.38-4.7c-.43-1.46-1.1-2.75-2-3.8-.9-1.08-2.02-1.94-3.36-2.57-1.33-.63-2.92-.95-4.7-.95-1.77 0-3.35.32-4.7.94-1.33.62-2.46 1.48-3.35 2.55-.9 1.07-1.56 2.35-2 3.8-.42 1.45-.64 3.03-.64 4.7 0 1.7.22 3.27.65 4.7.43 1.46 1.1 2.75 2 3.82.88 1.07 2.02 1.92 3.35 2.53 1.34.6 2.92.92 4.7.92 1.77 0 3.35-.3 4.7-.92 1.33-.6 2.46-1.46 3.35-2.53.9-1.07 1.57-2.35 2-3.8.43-1.45.64-3.04.64-4.7 0-1.7-.2-3.27-.64-4.72M206.74 91.5c-.15-.4-.56-.25-.56-.25-.64.24-1.32.47-2.04.58-.73.1-1.53.17-2.4.17-2.12 0-3.8-.63-5-1.88-1.22-1.24-1.9-3.26-1.9-5.98.02-2.48.62-4.35 1.7-5.77 1.06-1.4 2.7-2.14 4.85-2.14 1.8 0 3.18.2 4.62.67 0 0 .35.15.5-.3.4-1.07.68-1.83 1.08-3 .12-.33-.16-.47-.27-.5-.56-.24-1.9-.6-2.92-.75-.93-.15-2.04-.22-3.27-.22-1.84 0-3.48.3-4.88.94-1.4.62-2.6 1.48-3.53 2.55-.94 1.07-1.66 2.35-2.13 3.8-.5 1.45-.73 3.04-.73 4.72 0 3.63.98 6.57 2.92 8.72 1.93 2.15 4.84 3.25 8.63 3.25 2.25 0 4.55-.45 6.2-1.1 0 0 .32-.15.18-.52l-1.06-2.97zM214.4 81.72c.2-1.4.6-2.58 1.2-3.5.9-1.38 2.3-2.14 4.23-2.14 1.95 0 3.24.76 4.16 2.15.6.9.87 2.14.97 3.5H214.4zm14.74-3.1c-.37-1.4-1.3-2.82-1.9-3.46-.95-1.03-1.88-1.75-2.8-2.15-1.22-.5-2.67-.85-4.26-.85-1.85 0-3.53.3-4.9.95-1.35.64-2.5 1.52-3.4 2.6-.9 1.1-1.58 2.4-2 3.85-.44 1.46-.66 3.06-.66 4.74 0 1.7.22 3.3.67 4.72.44 1.44 1.17 2.7 2.14 3.77.97 1.05 2.23 1.88 3.73 2.46 1.5.57 3.3.87 5.38.87 4.28-.02 6.54-.97 7.46-1.5.18-.08.34-.24.14-.7l-.97-2.7c-.15-.42-.56-.27-.56-.27-1.05.4-2.56 1.1-6.07 1.1-2.3 0-4-.68-5.07-1.74-1.1-1.1-1.64-2.7-1.73-4.94l14.82.02s.4 0 .43-.4c.02-.15.5-3.03-.44-6.38zM95.68 81.72c.2-1.4.6-2.58 1.2-3.5.9-1.38 2.3-2.14 4.24-2.14 1.94 0 3.23.76 4.16 2.15.6.9.87 2.14.98 3.5H95.68zm14.74-3.1c-.37-1.4-1.3-2.82-1.9-3.46-.95-1.03-1.88-1.75-2.8-2.15-1.2-.5-2.66-.85-4.25-.85-1.85 0-3.53.3-4.9.95-1.36.64-2.5 1.52-3.4 2.6-.9 1.1-1.6 2.4-2.02 3.85-.43 1.46-.65 3.06-.65 4.74 0 1.7.23 3.3.68 4.72.45 1.44 1.17 2.7 2.15 3.77.97 1.05 2.22 1.88 3.72 2.46 1.5.57 3.3.87 5.38.87 4.28-.02 6.54-.97 7.47-1.5.16-.08.32-.24.12-.7l-.96-2.7c-.15-.42-.56-.27-.56-.27-1.06.4-2.57 1.1-6.1 1.1-2.3 0-4-.68-5.06-1.74-1.1-1.1-1.63-2.7-1.73-4.94l14.84.02s.4 0 .43-.4c0-.15.5-3.03-.45-6.38zM63.64 91.43c-.58-.46-.66-.58-.85-.88-.3-.45-.46-1.1-.46-1.92 0-1.3.43-2.24 1.33-2.87 0 0 1.27-1.12 4.3-1.08 2.12.03 4.02.35 4.02.35v6.74s-1.9.4-4 .53c-3.03.18-4.37-.87-4.36-.87m5.9-10.4c-.6-.06-1.38-.08-2.3-.08-1.28 0-2.5.16-3.66.47-1.16.3-2.2.8-3.1 1.43-.9.65-1.63 1.47-2.15 2.45-.52.97-.8 2.12-.8 3.4 0 1.32.24 2.47.7 3.4.44.93 1.1 1.7 1.92 2.3.83.62 1.84 1.06 3.02 1.32 1.16.27 2.48.4 3.93.4 1.5 0 3.03-.12 4.5-.37 1.45-.25 3.24-.6 3.73-.72l1.04-.27c.37-.1.34-.48.34-.48V80.72c0-2.97-.8-5.18-2.35-6.54-1.56-1.36-3.85-2.05-6.8-2.05-1.12 0-2.9.15-3.98.36 0 0-3.24.62-4.58 1.66 0 0-.3.2-.14.6l1.05 2.8c.14.38.5.25.5.25s.1-.03.24-.1c2.85-1.56 6.46-1.5 6.46-1.5 1.6 0 2.83.3 3.66.95.8.62 1.22 1.55 1.22 3.53v.62c-1.27-.18-2.44-.28-2.44-.28M189.1 73.38c.1-.34-.12-.5-.22-.53-.25-.1-1.5-.37-2.5-.43-1.85-.1-2.88.2-3.8.62-.93.4-1.95 1.08-2.52 1.84v-1.8c0-.25-.17-.45-.42-.45h-3.8c-.25 0-.43.2-.43.45v22.1c0 .26.22.46.46.46h3.9c.25 0 .45-.2.45-.45V84.13c0-1.48.17-2.96.5-3.9.32-.9.76-1.64 1.3-2.17.54-.52 1.15-.9 1.83-1.1.7-.2 1.45-.28 2-.28.76 0 1.62.2 1.62.2.28.02.44-.15.53-.4l1.12-3.12\" fill=\"#FFF\"></path><path d=\"M152.54 63.13c-.47-.15-.9-.24-1.46-.35-.57-.1-1.25-.15-2.02-.15-2.68 0-4.8.76-6.27 2.25-1.5 1.5-2.5 3.75-3 6.72l-.17 1h-3.37s-.4 0-.5.44l-.55 3.08c-.03.3.1.48.5.48h3.27l-3.32 18.55c-.26 1.5-.56 2.72-.9 3.65-.32.92-.63 1.6-1.03 2.1-.38.5-.73.85-1.35 1.06-.5.17-1.1.25-1.75.25-.35 0-.83-.05-1.18-.12-.35-.07-.54-.15-.8-.26 0 0-.4-.15-.54.24l-1.1 3c-.1.3.04.53.23.6.44.16.76.26 1.35.4.83.2 1.52.2 2.17.2 1.37 0 2.6-.2 3.64-.56 1.03-.38 1.93-1.03 2.73-1.9.87-.96 1.4-1.96 1.93-3.33.5-1.35.95-3.02 1.3-4.97l3.34-18.9h4.88s.42 0 .5-.43l.55-3.1c.04-.28-.08-.46-.48-.46h-4.74c.03-.1.25-1.77.8-3.34.23-.67.66-1.2 1.03-1.58.36-.36.78-.62 1.24-.77.47-.14 1-.22 1.6-.22.44 0 .88.05 1.2.12.47.1.65.15.77.2.48.13.55 0 .64-.24l1.14-3.1c.1-.35-.17-.5-.28-.53M86.32 95.2c0 .24-.18.44-.42.44h-3.94c-.24 0-.42-.2-.42-.45V63.54c0-.24.18-.44.42-.44h3.94c.24 0 .42.2.42.45V95.2z\" fill=\"#FFF\"></path></svg>"

/***/ }),

/***/ "GHhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchOAuthCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchOAuthCodePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchOAuthCodeFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchOAuthCodeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchOAuthAppInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchOAuthAppInfoSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchOAuthAppInfoFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchOAuthAppInfoPending; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("5JuT");




var fetchOAuthCode = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_OAUTH_CODE */]);
var fetchOAuthCodePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_OAUTH_CODE_PENDING */]);
var fetchOAuthCodeFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_OAUTH_CODE_FAILED */]);
var fetchOAuthCodeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_OAUTH_CODE_SUCCESS */]);

var fetchOAuthAppInfo = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_OAUTH_APP_INFO */]);
var fetchOAuthAppInfoSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_OAUTH_APP_INFO_SUCCESS */]);
var fetchOAuthAppInfoFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_OAUTH_APP_INFO_FAILED */]);
var fetchOAuthAppInfoPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_OAUTH_APP_INFO_PENDING */]);

/***/ }),

/***/ "GI14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_idle_timer__ = __webpack_require__("asCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TimeoutModal__ = __webpack_require__("Fpp5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_hocs_withTracking__ = __webpack_require__("xq94");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SESSION_TIMEOUT_MODAL_TIME = 120000;

var IdleTimeout = function (_Component) {
  _inherits(IdleTimeout, _Component);

  function IdleTimeout(props) {
    _classCallCheck(this, IdleTimeout);

    var _this = _possibleConstructorReturn(this, (IdleTimeout.__proto__ || Object.getPrototypeOf(IdleTimeout)).call(this, props));

    _this.tabCloseHandler = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["decreaseOpenTabCount"])({ tokenExpirationInMillis: _this.state.sessionLength });
    };

    _this.applySessionTimeoutSettings = function (data) {
      if (data > 0) {
        _this.setState({
          timeoutEnabled: true,
          sessionLength: data
        });
        Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["removeAccessTokenExpiration"])();
      }
    };

    _this.onIdle = function () {
      _this.setState({
        isIdle: true
      });
    };

    _this.onContinue = function () {
      _this.setState({
        isIdle: false
      });
    };

    _this.onLogOut = function (showTimeoutBanner) {
      _this.props.track("User session timed out");
      Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */], showTimeoutBanner);
    };

    _this.state = {
      sessionLength: 0,
      timeoutEnabled: false,
      isIdle: false
    };
    return _this;
  }

  _createClass(IdleTimeout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["increaseOpenTabCount"])();
      window.addEventListener("beforeunload", this.tabCloseHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.tabCloseHandler);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.sessionLengthMillis != this.props.sessionLengthMillis) {
        this.applySessionTimeoutSettings(this.props.sessionLengthMillis);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          timeoutEnabled = _state.timeoutEnabled,
          sessionLength = _state.sessionLength;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
        null,
        timeoutEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_idle_timer__["a" /* default */], { onIdle: this.onIdle, timeout: sessionLength - SESSION_TIMEOUT_MODAL_TIME }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
              null,
              children
            ),
            this.state.isIdle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TimeoutModal__["a" /* TimeoutModal */], {
              cancel: this.onContinue,
              logOut: this.onLogOut,
              modalTime: SESSION_TIMEOUT_MODAL_TIME })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Div"],
              null,
              children
            )
          )
        )
      );
    }
  }]);

  return IdleTimeout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_components_hocs_withTracking__["a" /* default */])(IdleTimeout));

/***/ }),

/***/ "GIEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorState__ = __webpack_require__("z78L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("FRQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var DEFAULT_PROPERTIES = ['DOMAIN', 'OWNER', 'NAME'];
var EMPTY_MAPPING = { toAttribute: null, fromKey: null, type: 'SALESFORCEACCOUNT' };
var DRIFT_DEFAULT_PROPERTY_LABELS = {
  "DOMAIN": "Domain",
  "OWNER": "Account Owner",
  "NAME": "Name"
};
var DEFAULT_PROPERTY_DEFINITIONS = [{
  "label": "Domain",
  "name": "DOMAIN",
  "type": "URL"
}, {
  "label": "Name",
  "name": "NAME",
  "type": "STRING"
}, {
  "label": "Account Owner",
  "name": "OWNER",
  "type": "TEAMMEMBER"
}];
var SFDC_ACCOUNT_PROPERTY_TYPE_MAPPING = {
  "STRING": ["base64", "byte", "string", "time", "address", "anyType", "combobox", "encryptedstring", "ID", "reference", "textarea", "boolean"],
  "NUMBER": ["double", "int", "currency", "percent"],
  "ENUM": ["picklist"],
  "DATE": "date",
  "DATETIME": "dateTime",
  "EMAIL": "email",
  "PHONE": "phone",
  "ENUMARRAY": "multipicklist",
  "URL": "url",
  "TEAMMEMBER": ["ID", "email", "reference"]
};

var AccountPropertyMapping = function (_Component) {
  _inherits(AccountPropertyMapping, _Component);

  function AccountPropertyMapping(props) {
    _classCallCheck(this, AccountPropertyMapping);

    var _this = _possibleConstructorReturn(this, (AccountPropertyMapping.__proto__ || Object.getPrototypeOf(AccountPropertyMapping)).call(this, props));

    _this.fetchSFDCProperties = function () {
      __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountProperties().then(function (data) {
        _this.setState({
          SFDCAccountProperties: data
        });
      }).catch(function (err) {
        _this.setState({
          error: err
        });
      });
    };

    _this.fetchDriftProperties = function () {
      __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__["a" /* api */].fetchDriftAccountProperties().then(function (data) {
        data = data.concat(DEFAULT_PROPERTY_DEFINITIONS);
        _this.setState({
          driftAccountProperties: data
        });
      }).catch(function (err) {
        _this.setState({
          error: err
        });
      });
    };

    _this.fetchMappings = function () {
      __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountPropertyMappings().then(function (data) {
        _this.setState({
          mappings: data,
          initialMappings: data
        });
      }).catch(function (err) {
        _this.setState({
          error: err
        });
      });
    };

    _this.setSuccess = function () {
      _this.setState(function (prevState) {
        return {
          initialMappings: prevState.mappings
        };
      }, _this.forceUpdate);
    };

    _this.isClean = function () {
      return _.isEqual(_this.state.mappings, _this.state.initialMappings);
    };

    _this.isValid = function () {
      if (!_this.state.mappings.length) return false;
      var isValid = true;

      _this.state.mappings.forEach(function (mapping) {
        if (!mapping.toAttribute || !mapping.fromKey) {
          isValid = false;
        }
      });

      return isValid;
    };

    _this.deleteMappings = function () {
      var updatedMappings = [].concat(_toConsumableArray(_this.state.mappings));
      var mappingsToDelete = _this.state.toDelete.map(function (index) {
        var id = updatedMappings[index] || null;
        updatedMappings.splice(index, 1);
        if (!!id) {
          return id;
        }
      });

      _this.setState({
        mappings: updatedMappings,
        toDelete: []
      }, function () {
        return _this.saveDeleteMappings(mappingsToDelete);
      });
    };

    _this.patchMappings = function () {
      var successCB = function successCB() {
        return _this.props.notifications.success('Salesforce mapping updated!');
      };
      var errorCB = function errorCB() {
        return _this.props.notifications.error('We encountered an error saving your mappings.');
      };
      __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__["a" /* api */].patchSFDCAccountPropertyMappings(_this.state.mappings).then(_this.fetchMappings).then(successCB).catch(errorCB);
    };

    _this.saveDeleteMappings = function (mappingsToDelete) {
      var successCB = function successCB() {
        return _this.props.notifications.success('Salesforce mapping updated!');
      };
      var errorCB = function errorCB() {
        return _this.props.notifications.error('We encountered an error deleting your mappings.');
      };
      __WEBPACK_IMPORTED_MODULE_4_app_modules_sfdc_api__["a" /* api */].deleteSFDCAccountPropertyMappings(mappingsToDelete).then(_this.setSuccess).then(successCB).catch(errorCB);
    };

    _this.addNewMapping = function () {
      var updatedMappings = [].concat(_toConsumableArray(_this.state.mappings));
      updatedMappings.push(_extends({}, EMPTY_MAPPING));

      _this.setState({ mappings: updatedMappings });
    };

    _this.updateDeleteProperties = function (_ref) {
      var target = _ref.target;

      _this.setState(function (prevState) {
        var value = target.value,
            checked = target.checked;

        var updatedToDelete = checked ? [].concat(_toConsumableArray(prevState.toDelete), [value]) : Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["without"])(value, prevState.toDelete);

        return {
          toDelete: updatedToDelete
        };
      });
    };

    _this.state = {
      driftAccountProperties: [],
      SFDCAccountProperties: [],

      usedDriftProperties: [],
      usedSFDCProperties: [],

      error: null,
      loadingPreviews: false,
      editingSFDCProperty: null,
      staticValues: [{ label: 'N/A', value: 'N/A' }],
      mappings: [],
      initialMappings: [],
      previews: [],
      toDelete: []
    };
    return _this;
  }

  _createClass(AccountPropertyMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchMappings();
      this.fetchDriftProperties();
      this.fetchSFDCProperties();
    }
  }, {
    key: 'updateDriftPropertyInMapping',
    value: function updateDriftPropertyInMapping(value, mappingIndex) {
      var updatedMappings = _.cloneDeep(this.state.mappings);
      updatedMappings[mappingIndex].toAttribute = value.value;

      this.setState({
        mappings: updatedMappings
      });
    }
  }, {
    key: 'updateSFDCPropertyInMapping',
    value: function updateSFDCPropertyInMapping(value, mappingIndex) {
      var updatedMappings = _.cloneDeep(this.state.mappings);
      updatedMappings[mappingIndex].fromKey = value.value;

      this.setState({ mappings: updatedMappings });
    }
  }, {
    key: 'renderDriftPropertiesSelect',
    value: function renderDriftPropertiesSelect(driftProperty, mappingIndex) {
      var _this2 = this;

      var combinedOptions = [].concat(_toConsumableArray(this.state.driftAccountProperties)).map(function (_ref2) {
        var label = _ref2.label,
            name = _ref2.name;
        return { label: label, value: name };
      });
      var selectedValue = driftProperty ? combinedOptions.filter(function (property) {
        return property.value == driftProperty;
      })[0] : null;

      var selectOptions = {
        multi: false,
        searchable: true,
        autoFocus: false,
        clearable: false,
        value: selectedValue,
        options: combinedOptions,
        className: "salesforce-mapping-drift-attribute-select",
        onChange: function onChange(value) {
          return _this2.updateDriftPropertyInMapping(value, mappingIndex);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderSFDCSelect',
    value: function renderSFDCSelect(mappingIndex, fromKey) {
      var _this3 = this;

      var supportedProperties = this.state.SFDCAccountProperties.filter(function (property) {
        var driftProperty = _this3.state.mappings[mappingIndex].toAttribute;
        var driftPropertyDefinition = [].concat(_toConsumableArray(_this3.state.driftAccountProperties)).filter(function (accountProperty) {
          return accountProperty.name === driftProperty;
        })[0] || {};

        var driftType = driftPropertyDefinition.type || null;
        var isSupportedType = driftType && SFDC_ACCOUNT_PROPERTY_TYPE_MAPPING[driftType].includes(property.type);

        return isSupportedType || !driftType;
      });
      var formattedOptions = supportedProperties.map(function (property) {
        return { label: property.label, value: property.name };
      });
      var selectedValue = fromKey ? formattedOptions.filter(function (property) {
        return property.value == fromKey;
      })[0] : null;

      var selectOptions = {
        multi: false,
        searchable: true,
        autoFocus: false,
        clearable: false,
        value: selectedValue,
        options: formattedOptions,
        onChange: function onChange(value) {
          return _this3.updateSFDCPropertyInMapping(value, mappingIndex);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderRequiredTableRows',
    value: function renderRequiredTableRows() {
      var _this4 = this;

      return this.state.mappings.map(function (mapping, index) {
        var fromKey = mapping.fromKey,
            toAttribute = mapping.toAttribute;

        var setIsEditing = function setIsEditing() {
          return _this4.setState({ editingSFDCProperty: index });
        };
        var isUneditable = DEFAULT_PROPERTIES.includes(toAttribute);
        var salesforceProperty = _this4.renderSFDCSelect(index, fromKey);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'tr',
          { key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { disabled: isUneditable, value: index, type: 'checkbox', onChange: _this4.updateDeleteProperties })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { className: 'salesforce-mapping-drift-attribute' },
            isUneditable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: DRIFT_DEFAULT_PROPERTY_LABELS[toAttribute], type: 'text', disabled: true }) : _this4.renderDriftPropertiesSelect(toAttribute, index)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { onClick: setIsEditing },
            salesforceProperty
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.error) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorState__["a" /* default */], null);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-mapping-actions' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'salesforce-mapping-account-custom' },
            'Head over to',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/accounts' },
              ' your Accounts page '
            ),
            'to create custom properties pulled from Salesforce.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              '*'
            ),
            'These are your required Salesforce Fields'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            {
              disabled: !this.state.toDelete.length,
              onClick: this.deleteMappings },
            'Delete'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            {
              disabled: this.isClean() || !this.isValid(),
              onClick: this.patchMappings },
            'Update'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'drift-table salesforce-mapping-table drift-form' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'salesforce-mapping-drift-attribute' },
                'Drift Attribute or Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                'Salesforce Field'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            this.renderRequiredTableRows()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button salesforce-mapping-add-field', onClick: this.addNewMapping },
          'Add New Field'
        )
      );
    }
  }]);

  return AccountPropertyMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_components_shared_notifications__["a" /* default */])(AccountPropertyMapping));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "GIjk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(529);

/***/ }),

/***/ "GIkC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IntegrationCard":"IntegrationCard---3a3EH"};

/***/ }),

/***/ "GM+L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__ = __webpack_require__("69aq");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OnlineInputs = function (_Component) {
  _inherits(OnlineInputs, _Component);

  function OnlineInputs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OnlineInputs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OnlineInputs.__proto__ || Object.getPrototypeOf(OnlineInputs)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (value) {
      _this.props.conditionUpdater('value', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OnlineInputs, [{
    key: 'render',
    value: function render() {
      var conditionValue = this.props.conditionValue;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__["a" /* default */], {
        className: 'AriaMenuButton--small',
        onSelection: this.onSelect,
        options: [{ value: true, text: 'is Online' }, { value: false, text: 'is Offline' }],
        selectedValue: conditionValue.get('value') ? 'is Online' : 'is Offline'
      });
    }
  }]);

  return OnlineInputs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OnlineInputs.propTypes = {
  conditionUpdater: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  conditionValue: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.map
};


/* harmony default export */ __webpack_exports__["a"] = (OnlineInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "GMSp":
/***/ (function(module, exports) {

module.exports = {"scope":"settings.chatwidget.hoursandtargeting","delay":3000,"tooltips":{"start":{"headline":"Need help with targeting?","body":"Take a tour to learn more about how to set up your chat widget hours and targeting."},"status":{"headline":"Online Status","body":"First, set the hours when your chat widget will be visible.","tourStep":1,"flow":"up"},"timezone":{"headline":"Timezone","body":"Make sure you set the right timezone for your business here.","tourStep":2,"flow":"up"},"audience":{"headline":"Audience Targeting","body":"Use the audience selector to decide which segment of users see the chat widget.","tourStep":3,"flow":"up"},"displaywhen":{"headline":"Display Targeting","body":"Setting display when criteria will allow you to show the chat widget to the right people, at the right time, and on the right page.","tourStep":4,"flow":"up"}}}

/***/ }),

/***/ "GN7/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__("KTM0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Button__ = __webpack_require__("1iW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__ = __webpack_require__("QF6P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_UserProfile_Section__ = __webpack_require__("1Pxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FakeBrowser__ = __webpack_require__("t2Y1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProfileLayoutPreview__ = __webpack_require__("BK43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_styl__ = __webpack_require__("rfXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var ProfileLayoutInput = function ProfileLayoutInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$checked = _ref.checked,
      checked = _ref$checked === undefined ? false : _ref$checked,
      children = _ref.children;
  return React.createElement(
    'label',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a.ProfileLayoutInput, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a['ProfileLayoutInput--checked'], checked))
    },
    React.createElement('input', {
      className: __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a.ProfileLayoutInput__radio,
      type: 'radio',
      name: 'profile-layout-choice',
      value: value,
      onChange: onChange,
      checked: checked
    }),
    children
  );
};

var ThemeInfo = function (_PureComponent) {
  _inherits(ThemeInfo, _PureComponent);

  function ThemeInfo() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ThemeInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ThemeInfo.__proto__ || Object.getPrototypeOf(ThemeInfo)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLayoutChange = function (event) {
      _this.props.actions.setProfileUIData({
        key: 'layout',
        value: event.currentTarget.value
      });
    }, _this.handleSave = function () {
      if (!_this.canSubmit() || !_this.isValid()) return;
      _this.props.actions.updateTheme();
    }, _this.handleCancel = function () {
      _this.props.actions.setProfileUI(_this.props.theme);
    }, _this.handleCoverPhotoUploadClick = function () {
      _this._dropZoneRef.open();
    }, _this.handleClearCoverPhotoClick = function () {
      _this.props.actions.setProfileUIData({
        key: 'coverPhotoUrl',
        value: ''
      });
      return false;
    }, _this.handleCoverPhotoChange = function (files) {
      var file = files[0];
      _this.props.actions.uploadCoverPhoto(file);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ThemeInfo, [{
    key: 'canSubmit',
    value: function canSubmit() {
      return !Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["is"])(this.props.theme, this.props.themeUI);
    }
  }, {
    key: 'getIsUploadPending',
    value: function getIsUploadPending() {
      return this.props.coverPhotoUpload.get('pending');
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      var notUploading = !this.getIsUploadPending();
      var layoutIsValid = this.props.themeUI.layout === __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].CARD || this.props.themeUI.layout === __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].WIDE && !!this.props.themeUI.coverPhotoUrl;
      return notUploading && layoutIsValid;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          themeUI = _props.themeUI,
          user = _props.user;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_6_components_settings_UserProfile_Section__["b" /* Subsection */],
        {
          title: 'Theme',
          isValid: this.isValid(),
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel
        },
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('profile-settings', __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a.ThemeSettings) },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_6_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            React.createElement(
              'ul',
              { style: {
                  listStyleType: 'none',
                  display: 'flex',
                  flexFlow: 'row wrap',
                  margin: 0,
                  padding: 0,
                  flex: '3 1 auto',
                  minWidth: 0,
                  minHeight: 0
                } },
              React.createElement(
                'li',
                null,
                React.createElement(
                  ProfileLayoutInput,
                  {
                    value: __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].CARD,
                    checked: themeUI.layout === __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].CARD,
                    onChange: this.handleLayoutChange
                  },
                  React.createElement(
                    __WEBPACK_IMPORTED_MODULE_7__FakeBrowser__["a" /* default */],
                    null,
                    React.createElement(__WEBPACK_IMPORTED_MODULE_8__ProfileLayoutPreview__["a" /* CardLayoutPreview */], { user: user })
                  )
                )
              ),
              React.createElement(
                'li',
                null,
                React.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_dropzone___default.a,
                  {
                    className: __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a.DropZone,
                    ref: function ref(c) {
                      _this2._dropZoneRef = c;
                    },
                    activeClassName: __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a['DropZone--active'],
                    disableClick: true,
                    onDrop: this.handleCoverPhotoChange,
                    multiple: false
                  },
                  React.createElement(
                    ProfileLayoutInput,
                    {
                      value: __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].WIDE,
                      checked: themeUI.layout === __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].WIDE,
                      onChange: this.handleLayoutChange,
                      invalid: !!themeUI.coverPhotoUrl
                    },
                    React.createElement(
                      __WEBPACK_IMPORTED_MODULE_7__FakeBrowser__["a" /* default */],
                      null,
                      React.createElement(__WEBPACK_IMPORTED_MODULE_8__ProfileLayoutPreview__["b" /* WideLayoutPreview */], { coverPhotoUrl: themeUI.coverPhotoUrl })
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { style: {
                  minWidth: 200,
                  maxWidth: 300
                } },
              themeUI.layout === __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_constants__["a" /* Layout */].WIDE && React.createElement(
                'div',
                null,
                React.createElement(
                  'p',
                  { className: 'dsg-Body color-navy-dark' },
                  'Upload a high-resolution profile photo to use this ',
                  React.createElement(
                    'b',
                    null,
                    '2-column'
                  ),
                  ' theme. Your photo should be at least 800px tall.'
                ),
                themeUI.coverPhotoUrl ? React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'a',
                    { onClick: this.handleClearCoverPhotoClick },
                    'Clear Photo'
                  )
                ) : React.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Button__["a" /* default */],
                  {
                    className: __WEBPACK_IMPORTED_MODULE_9__styles_styl___default.a.CoverPhotoUploadButton,
                    onClick: this.handleCoverPhotoUploadClick
                  },
                  'Upload photo'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ThemeInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ThemeInfo);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "GPw3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__("uP6L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var resolveAgentStatus = function resolveAgentStatus(_ref) {
  var isActive = _ref.isActive,
      limitNumChatsEnabled = _ref.limitNumChatsEnabled,
      isUserAtConversationLimit = _ref.isUserAtConversationLimit;

  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return 'chat-limit';
  }

  if (isActive) {
    return 'available';
  }

  return 'away';
};

var resolveStatusDetails = function resolveStatusDetails(_ref2) {
  var isActive = _ref2.isActive,
      limitNumChatsEnabled = _ref2.limitNumChatsEnabled,
      limitNumChats = _ref2.limitNumChats,
      isUserAtConversationLimit = _ref2.isUserAtConversationLimit;

  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return 'Conversation limit reached (' + limitNumChats + ')';
  }

  if (isActive) {
    return 'Accepting new conversations';
  }

  return 'Not accepting new conversations';
};

var resolveStatusLabel = function resolveStatusLabel(_ref3) {
  var isActive = _ref3.isActive;

  return isActive ? 'Available' : 'Away';
};

var AgentStatusPane = function (_Component) {
  _inherits(AgentStatusPane, _Component);

  function AgentStatusPane() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, AgentStatusPane);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = AgentStatusPane.__proto__ || Object.getPrototypeOf(AgentStatusPane)).call.apply(_ref4, [this].concat(args))), _this), _this.resolveStatusLabel = function () {
      var isActive = _this.props.isActive;


      return resolveStatusLabel({ isActive: isActive });
    }, _this.resolveStatusDetails = function () {
      var _this$props = _this.props,
          isActive = _this$props.isActive,
          limitNumChatsEnabled = _this$props.limitNumChatsEnabled,
          limitNumChats = _this$props.limitNumChats,
          isUserAtConversationLimit = _this$props.isUserAtConversationLimit;


      return resolveStatusDetails({
        isActive: isActive,
        limitNumChatsEnabled: limitNumChatsEnabled,
        limitNumChats: limitNumChats,
        isUserAtConversationLimit: isUserAtConversationLimit
      });
    }, _this.resolveAgentStatus = function () {
      var _this$props2 = _this.props,
          isActive = _this$props2.isActive,
          limitNumChatsEnabled = _this$props2.limitNumChatsEnabled,
          isUserAtConversationLimit = _this$props2.isUserAtConversationLimit;


      return resolveAgentStatus({
        isActive: isActive,
        limitNumChatsEnabled: limitNumChatsEnabled,
        isUserAtConversationLimit: isUserAtConversationLimit
      });
    }, _this.handleAgentStatusToggled = function () {
      _this.props.toggleStatus({ source: _this.props.source });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AgentStatusPane, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          displayName = _props.displayName,
          isActive = _props.isActive;


      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2__styles___default.a['agent-status-pane'] },
        React.createElement(
          'div',
          { className: 'agent-status-information' },
          React.createElement(
            'div',
            { className: 'agent-identifier' },
            displayName && React.createElement(
              'div',
              { className: 'agent-display-name' },
              displayName
            ),
            React.createElement(
              'div',
              { className: 'agent-status-label' },
              this.resolveStatusLabel()
            )
          ),
          React.createElement(
            'div',
            { className: 'agent-status-details' },
            this.resolveStatusDetails()
          )
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["AgentStatusToggle"], {
          className: 'agent-status-toggle',
          agentStatus: this.resolveAgentStatus(),
          checked: isActive,
          onChange: this.handleAgentStatusToggled })
      );
    }
  }]);

  return AgentStatusPane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AgentStatusPane);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "GUao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeRootReducer; });
/* unused harmony export injectReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_account_reducer__ = __webpack_require__("RWmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_apiKey_reducer__ = __webpack_require__("3O7d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_reducer__ = __webpack_require__("kJAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_ban_reducer__ = __webpack_require__("2MPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_campaigns__ = __webpack_require__("OTri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_cards__ = __webpack_require__("tB4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_classification__ = __webpack_require__("Jkun");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_composer__ = __webpack_require__("2AqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_conversation__ = __webpack_require__("l/4N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_csv__ = __webpack_require__("wWmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_embed__ = __webpack_require__("D3Al");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_endUser__ = __webpack_require__("YITf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_geolocation__ = __webpack_require__("ipNP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_inbox__ = __webpack_require__("U0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_reducers__ = __webpack_require__("8Roc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_hubspot__ = __webpack_require__("JuPD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_meetings__ = __webpack_require__("b54Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_message__ = __webpack_require__("qJND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_org_overview__ = __webpack_require__("yynn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_org_reducers__ = __webpack_require__("or1p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_teams_reducer__ = __webpack_require__("dgdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_participants__ = __webpack_require__("lq9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_playbook__ = __webpack_require__("DCxr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_profile_reducers__ = __webpack_require__("8fh2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_app_modules_presence__ = __webpack_require__("eUvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_app_modules_reveal__ = __webpack_require__("TNwo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_app_modules_router__ = __webpack_require__("DeDJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_app_modules_rules__ = __webpack_require__("QOQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_app_modules_segment__ = __webpack_require__("g3z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_app_modules_sfdc__ = __webpack_require__("7BP3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_modules_marketo__ = __webpack_require__("quQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_app_modules_eloqua__ = __webpack_require__("jqrc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_app_modules_pardot__ = __webpack_require__("pyNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_app_modules_socket__ = __webpack_require__("9WSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_app_modules_tags__ = __webpack_require__("yvKM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_app_modules_targeting__ = __webpack_require__("xAgo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_app_modules_typing__ = __webpack_require__("plGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_app_modules_unread__ = __webpack_require__("YkI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_app_modules_user_properties__ = __webpack_require__("MDpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_app_modules_user_reducers__ = __webpack_require__("w2j9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_app_modules_enrichment__ = __webpack_require__("McSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_app_modules_externalApp__ = __webpack_require__("o6GD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_app_modules_conversation_bulkUpdate__ = __webpack_require__("2qRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_app_modules_experiment__ = __webpack_require__("mX/6");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
















































var makeRootReducer = function makeRootReducer(asyncReducers) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])(_extends({
    account: __WEBPACK_IMPORTED_MODULE_1_app_modules_account_reducer__["a" /* default */],
    apiKey: __WEBPACK_IMPORTED_MODULE_2_app_modules_apiKey_reducer__["a" /* default */],
    assistantSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_reducer__["a" /* default */],
    bannedIPs: __WEBPACK_IMPORTED_MODULE_4_app_modules_ban_reducer__["b" /* bannedIPs */],
    bannedIPStatus: __WEBPACK_IMPORTED_MODULE_4_app_modules_ban_reducer__["a" /* bannedIPStatus */],
    campaigns: __WEBPACK_IMPORTED_MODULE_5_app_modules_campaigns__["a" /* default */],
    cards: __WEBPACK_IMPORTED_MODULE_6_app_modules_cards__["a" /* default */],
    classification: __WEBPACK_IMPORTED_MODULE_7_app_modules_classification__["a" /* default */],
    composer: __WEBPACK_IMPORTED_MODULE_8_app_modules_composer__["a" /* default */],
    conversations: __WEBPACK_IMPORTED_MODULE_9_app_modules_conversation__["a" /* default */],
    csv: __WEBPACK_IMPORTED_MODULE_10_app_modules_csv__["a" /* default */],
    currentUser: __WEBPACK_IMPORTED_MODULE_40_app_modules_user_reducers__["a" /* currentUser */],
    embed: __WEBPACK_IMPORTED_MODULE_11_app_modules_embed__["a" /* default */],
    endUser: __WEBPACK_IMPORTED_MODULE_12_app_modules_endUser__["a" /* default */],
    enrichment: __WEBPACK_IMPORTED_MODULE_41_app_modules_enrichment__["a" /* default */],
    geolocation: __WEBPACK_IMPORTED_MODULE_13_app_modules_geolocation__["a" /* default */],
    hubspot: __WEBPACK_IMPORTED_MODULE_16_app_modules_hubspot__["a" /* default */],
    inbox: __WEBPACK_IMPORTED_MODULE_14_app_modules_inbox__["a" /* default */],
    integrations: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_reducers__["a" /* integrations */],
    wordpressIntegrationDomain: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_reducers__["b" /* wordpressIntegrationDomain */],
    marketo: __WEBPACK_IMPORTED_MODULE_31_app_modules_marketo__["a" /* default */],
    eloqua: __WEBPACK_IMPORTED_MODULE_32_app_modules_eloqua__["a" /* default */],
    meetings: __WEBPACK_IMPORTED_MODULE_17_app_modules_meetings__["a" /* default */],
    messages: __WEBPACK_IMPORTED_MODULE_18_app_modules_message__["a" /* default */],
    org: __WEBPACK_IMPORTED_MODULE_20_app_modules_org_reducers__["a" /* org */],
    teams: __WEBPACK_IMPORTED_MODULE_21_app_modules_teams_reducer__["a" /* teams */],
    orgUI: __WEBPACK_IMPORTED_MODULE_20_app_modules_org_reducers__["b" /* orgUI */],
    overview: __WEBPACK_IMPORTED_MODULE_19_app_modules_org_overview__["a" /* default */],
    participants: __WEBPACK_IMPORTED_MODULE_22_app_modules_participants__["a" /* default */],
    playbooks: __WEBPACK_IMPORTED_MODULE_23_app_modules_playbook__["a" /* default */],
    presence: __WEBPACK_IMPORTED_MODULE_25_app_modules_presence__["b" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_24_app_modules_profile_reducers__["a" /* profile */],
    profileUI: __WEBPACK_IMPORTED_MODULE_24_app_modules_profile_reducers__["b" /* profileUI */],
    reveal: __WEBPACK_IMPORTED_MODULE_26_app_modules_reveal__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_27_app_modules_router__["a" /* default */],
    rules: __WEBPACK_IMPORTED_MODULE_28_app_modules_rules__["a" /* default */],
    segment: __WEBPACK_IMPORTED_MODULE_29_app_modules_segment__["a" /* default */],
    sfdc: __WEBPACK_IMPORTED_MODULE_30_app_modules_sfdc__["a" /* default */],
    socket: __WEBPACK_IMPORTED_MODULE_34_app_modules_socket__["a" /* default */],
    tags: __WEBPACK_IMPORTED_MODULE_35_app_modules_tags__["a" /* default */],
    targeting: __WEBPACK_IMPORTED_MODULE_36_app_modules_targeting__["a" /* default */],
    typing: __WEBPACK_IMPORTED_MODULE_37_app_modules_typing__["a" /* default */],
    unread: __WEBPACK_IMPORTED_MODULE_38_app_modules_unread__["a" /* default */],
    userProperties: __WEBPACK_IMPORTED_MODULE_39_app_modules_user_properties__["a" /* default */],
    externalApp: __WEBPACK_IMPORTED_MODULE_42_app_modules_externalApp__["a" /* default */],
    conversationBulkUpdate: __WEBPACK_IMPORTED_MODULE_43_app_modules_conversation_bulkUpdate__["a" /* default */],
    experiment: __WEBPACK_IMPORTED_MODULE_44_app_modules_experiment__["a" /* default */],
    pardot: __WEBPACK_IMPORTED_MODULE_33_app_modules_pardot__["a" /* default */]
  }, asyncReducers));
};

var injectReducer = function injectReducer(store, _ref) {
  var key = _ref.key,
      reducer = _ref.reducer;

  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

/* unused harmony default export */ var _unused_webpack_default_export = (makeRootReducer);

/***/ }),

/***/ "GVZL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_BotAvatar__ = __webpack_require__("8Ti+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("N7zt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var BotAvatarPreview = function BotAvatarPreview(_ref) {
  var color = _ref.color,
      preview = _ref.preview,
      style = _ref.style,
      _ref$loading = _ref.loading,
      loading = _ref$loading === undefined ? false : _ref$loading;

  if (loading) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("bot-avatar", __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.BotAvatarPicker__Loading) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__["a" /* default */], null)
    );
  } else if (!!preview) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("bot-avatar", __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.BotAvatarPicker__Preview),
      style: _extends({
        backgroundImage: 'url(' + preview + ')',
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "50%"
      }, style)
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_BotAvatar__["a" /* default */], { className: 'bot-avatar',
      color: '#' + color,
      style: style
    });
  }
};
BotAvatarPreview.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  preview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  loading: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (BotAvatarPreview);

/***/ }),

/***/ "GX2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gaye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("khns");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var classifications = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchClassificationsSuccess */], function (state, action) {
  return state.merge(action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* createClassificationsSuccess */], function (state, action) {
  return state.concat(action.payload);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());

var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchClassificationsSuccess */], function (state) {
  return state.set('loaded', true).set('loading', false);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchClassificationsPending */], function (state) {
  return state.set('loading', true).set('loaded', false);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchClassificationsFailed */], function (state) {
  return state.set('loading', false);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({ classifications: classifications, status: status }));

/***/ }),

/***/ "Gdnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__ = __webpack_require__("1mHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_settings_ClickThroughAccordion__ = __webpack_require__("PkvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Integration_pages_install__ = __webpack_require__("KBK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("vPMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var CHANGE_SUCCESS_NOTIFICATION_MESSAGE = 'Your changes have been saved';

var ChatWidgetSettings = function (_Component) {
  _inherits(ChatWidgetSettings, _Component);

  function ChatWidgetSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChatWidgetSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatWidgetSettings.__proto__ || Object.getPrototypeOf(ChatWidgetSettings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isInstallOpen: false
    }, _this.handleInstallToggle = function () {
      _this.setState({ isInstallOpen: !_this.state.isInstallOpen });
    }, _this.onAllowIncomingChatsToggled = function (event) {
      var actions = _this.props.actions;

      var isEnabled = event.target.checked;
      var operations = [{
        operation: 'set',
        property: 'chatEnabled',
        value: isEnabled
      }];
      actions.patchEmbed(operations);
    }, _this.onAllowShowIfChatHistory = function () {
      var _this$props = _this.props,
          actions = _this$props.actions,
          isShowWidgetIfConvoHistoryEnabled = _this$props.isShowWidgetIfConvoHistoryEnabled;


      var isEnabled = !isShowWidgetIfConvoHistoryEnabled;
      var operations = [{
        operation: 'set',
        property: 'theme.enableChatIfConversationHistory',
        value: isEnabled
      }];
      actions.patchEmbed(operations);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChatWidgetSettings, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.embedPatchSuccess && !!this.props.embedPatchSuccess) {
        this.props.notifications.success(CHANGE_SUCCESS_NOTIFICATION_MESSAGE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isInstallOpen = this.state.isInstallOpen;
      var _props = this.props,
          isChatEnabledInEmbed = _props.isChatEnabledInEmbed,
          isShowWidgetIfConvoHistoryEnabled = _props.isShowWidgetIfConvoHistoryEnabled;


      return this.props.children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_14__style_styl___default.a.ChatWidget) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'chat-widget-section-title' },
          'Drift Widget'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'chat-widget-display' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chat-widget-display-option--container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'chat-widget-display--copy-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                { className: 'chat-widget-display--title' },
                'Display the Drift Widget Icon'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'chat-widget-display--description' },
                'Allow incoming chats by displaying the Drift icon on your site. If you turn this setting off, you can still trigger conversations with playbooks, but users will not be able to open new conversations by clicking the icon.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Toggle__["a" /* default */], {
              checked: isChatEnabledInEmbed,
              onChange: this.onAllowIncomingChatsToggled,
              className: 'chat-widget-display--section-toggle'
            })
          ),
          !isChatEnabledInEmbed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'chat-widget-display-option--container chat-widget-display--second-option' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], {
              type: 'checkbox',
              checked: isShowWidgetIfConvoHistoryEnabled,
              onChange: this.onAllowShowIfChatHistory,
              className: 'chat-widget-display--section-toggle'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              { className: 'chat-widget-display--description' },
              'Display the Drift Widget Icon if the visitor has had a previous conversation or if they have been targeted by a bot.'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */], {
          className: 'chat-widget-settings--new',
          title: 'Hours & targeting',
          description: 'Customize when your Drift Widget displays to your customers and visitors',
          rightContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'View'
          ),
          locked: true,
          onToggle: function onToggle() {
            return window.location = '/settings2/widget/hours-and-targeting';
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */], {
          className: 'chat-widget-settings--new',
          title: 'Default greeting',
          description: 'Customize how you greet your site visitors when they click on your Drift Widget',
          rightContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'View'
          ),
          locked: true,
          onToggle: function onToggle() {
            return window.location = '/settings2/widget/default-greeting';
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */], {
          className: 'chat-widget-settings--new',
          title: 'Design',
          description: 'Stylize your design elements',
          rightContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'View'
          ),
          locked: true,
          onToggle: function onToggle() {
            return window.location = '/settings2/widget/design';
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */], {
          className: 'chat-widget-settings--new',
          title: 'Advanced',
          description: 'Customize advanced settings like emails',
          rightContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'View'
          ),
          locked: true,
          onToggle: function onToggle() {
            return window.location = '/settings2/widget/advanced';
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */], {
          className: 'chat-widget-settings--new',
          title: 'Cookie Sharing',
          description: 'Customize which domains on which Drift will share your site visitor\'s information',
          rightContent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'View'
          ),
          locked: true,
          onToggle: function onToggle() {
            return window.location = '/settings2/cookie-sharing';
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_components_settings_Accordion__["a" /* default */],
          {
            title: 'Install',
            description: 'Get Drift on your website in minutes!',
            open: isInstallOpen,
            onToggle: this.handleInstallToggle
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Integration_pages_install__["a" /* default */], null)
        )
      );
    }
  }]);

  return ChatWidgetSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      patchEmbed: __WEBPACK_IMPORTED_MODULE_13_app_modules_embed_actions__["f" /* patchEmbed */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isChatEnabledInEmbed: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["m" /* isChatEnabled */])(state),
    embedPatchSuccess: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["g" /* embedPatchSuccess */])(state),
    isShowWidgetIfConvoHistoryEnabled: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_embed_selectors__["n" /* isShowWidgetIfConvoHistoryEnabled */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_access_helpers__["a" /* ensureIsAdmin */])(ChatWidgetSettings))));

/***/ }),

/***/ "GeoU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/install-widget-video.91aebb2f.png";

/***/ }),

/***/ "Ghb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch, _) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__ = __webpack_require__("GoMo");





var api = {
  fetchOAuthCode: function fetchOAuthCode(_ref) {
    var redirect_uri = _ref.redirect_uri,
        client_id = _ref.client_id;

    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/oauth/auth', {
      method: 'POST',
      headers: _.extend({ 'Content-Type': __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["b" /* X_WWW_FORM */] }, Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()),
      body: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["h" /* serializeObject */])({
        response_type: 'code',
        client_id: client_id,
        access_type: 'offline',
        redirect_uri: redirect_uri
      })
    }).then(function (res) {
      return res.json();
    });
  },
  fetchOAuthAppInfo: function fetchOAuthAppInfo(_ref2) {
    var client_id = _ref2.client_id;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/oauth/applications?clientId=' + client_id).map(function (res) {
      return res.response;
    });
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V"), __webpack_require__("M4fF")))

/***/ }),

/***/ "GirZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 23 20\" xmlns=\"http://www.w3.org/2000/svg\"><title>Shape</title><path d=\"M20.857 6.735A3.572 3.572 0 0 1 23 9.997a.717.717 0 0 1-.719.715h-5.75a.717.717 0 0 1-.718-.715c0-1.456.883-2.706 2.142-3.262a2.846 2.846 0 0 1-1.424-2.453 2.87 2.87 0 0 1 2.875-2.858 2.87 2.87 0 0 1 2.875 2.858 2.845 2.845 0 0 1-1.424 2.453zm-3.484 2.548h4.067a2.159 2.159 0 0 0-2.034-1.429c-.937 0-1.736.597-2.033 1.429zm2.033-6.43c-.793 0-1.437.64-1.437 1.43 0 .786.644 1.427 1.437 1.427s1.438-.64 1.438-1.428c0-.789-.645-1.43-1.438-1.43zm-4.811-.202c-1.706-1.635-4.483-1.635-6.19 0a.718.718 0 0 1-1.016-.017.71.71 0 0 1 .018-1.01c2.257-2.165 5.929-2.165 8.186-.001a.712.712 0 0 1 .018 1.01.722.722 0 0 1-1.016.018zM7.184 9.838a.717.717 0 0 1-.715.874H.719A.717.717 0 0 1 0 9.997c0-1.456.883-2.706 2.143-3.262A2.845 2.845 0 0 1 .72 4.282a2.87 2.87 0 0 1 2.875-2.858 2.87 2.87 0 0 1 2.875 2.858 2.847 2.847 0 0 1-1.427 2.454 3.574 3.574 0 0 1 2.142 3.102zm-3.59-6.985c-.793 0-1.438.64-1.438 1.43 0 .786.645 1.427 1.438 1.427.793 0 1.437-.64 1.437-1.428 0-.789-.644-1.43-1.437-1.43zm0 5.001c-.938 0-1.737.597-2.034 1.429h4.067a2.159 2.159 0 0 0-2.033-1.429zm.13 3.725a.722.722 0 0 1 .974.288c.811 1.49 1.824 2.636 2.85 3.229a.712.712 0 0 1-.361 1.331.716.716 0 0 1-.36-.097c-1.69-.974-2.85-2.788-3.393-3.782a.713.713 0 0 1 .29-.969zm6.326 4.444a2.845 2.845 0 0 1-1.425-2.453 2.869 2.869 0 0 1 2.875-2.858 2.869 2.869 0 0 1 2.875 2.858 2.845 2.845 0 0 1-1.425 2.453 3.574 3.574 0 0 1 2.144 3.262.717.717 0 0 1-.719.715h-5.75a.717.717 0 0 1-.719-.715c0-1.455.884-2.706 2.144-3.262zm1.45-3.882c-.793 0-1.438.64-1.438 1.429 0 .788.645 1.429 1.438 1.429.793 0 1.438-.641 1.438-1.43 0-.787-.645-1.428-1.438-1.428zm2.033 6.43a2.159 2.159 0 0 0-2.033-1.429c-.937 0-1.736.597-2.033 1.43h4.066zm1.919-3.475c1.047-.606 2.074-1.78 2.892-3.304a.72.72 0 0 1 .972-.294c.35.185.483.618.297.966-.546 1.017-1.718 2.872-3.44 3.866a.72.72 0 0 1-.983-.258.712.712 0 0 1 .262-.976z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "GoMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return X_WWW_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSON; });
/* unused harmony export FORM_DATA */

var X_WWW_FORM = 'application/x-www-form-urlencoded';
var JSON = 'application/json';
var FORM_DATA = 'multipart/form-data';

/***/ }),

/***/ "GpqP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GsgS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchEloquaFieldsSuccess */
/* unused harmony export fetchEloquaMappingsSuccess */
/* unused harmony export patchEloquaMappingsSuccess */
/* unused harmony export patchEloquaMappingsError */
/* unused harmony export patchEloquaMappingsStart */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchEloquaFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchEloquaMappings;
/* harmony export (immutable) */ __webpack_exports__["c"] = patchEloquaMappings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("e6/c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_eloqua_api__ = __webpack_require__("tYz+");



function fetchEloquaFieldsSuccess(_ref) {
  var fields = _ref.fields;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_ELOQUA_FIELDS_SUCCESS */],
    fields: fields
  };
}

function fetchEloquaMappingsSuccess(_ref2) {
  var mappings = _ref2.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_ELOQUA_MAPPINGS_SUCCESS */],
    mappings: mappings
  };
}

function patchEloquaMappingsSuccess(_ref3) {
  var mappings = _ref3.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_ELOQUA_MAPPINGS_SUCCESS */],
    mappings: mappings
  };
}

function patchEloquaMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_ELOQUA_MAPPINGS_ERROR */],
    err: err
  };
}

function patchEloquaMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_ELOQUA_MAPPINGS_START */]
  };
}

function fetchEloquaFields() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_eloqua_api__["a" /* api */].fetchEloquaFields().then(function (response) {
      dispatch(fetchEloquaFieldsSuccess(response));
    });
  };
}

function fetchEloquaMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_eloqua_api__["a" /* api */].fetchEloquaMappings().then(function (response) {
      dispatch(fetchEloquaMappingsSuccess(response));
    });
  };
}

function patchEloquaMappings(mappings) {
  var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch) {
    dispatch(patchEloquaMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_eloqua_api__["a" /* api */].patchEloquaMappings(mappings).then(function (response) {
      successCB();
      dispatch(patchEloquaMappingsSuccess(response));
    }).catch(function (err) {
      dispatch(patchEloquaMappingsError(err));
    });
  };
}

/***/ }),

/***/ "GtGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_api__ = __webpack_require__("tYz+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_eloqua_models__ = __webpack_require__("b+Ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EloquaCdoSelect__ = __webpack_require__("4lSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("k0xy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var HELP_DOC_URL = "https://gethelp.drift.com/hc/en-us/articles/360019666973-How-to-Connect-Drift-and-Eloqua";
var integrationName = "Eloqua";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};
var getErrorMessage = function getErrorMessage(integrationName) {
  return 'There was an error when updating your ' + integrationName + ' App!';
};

var EloquaAttributeMappingCdo = function (_Component) {
  _inherits(EloquaAttributeMappingCdo, _Component);

  function EloquaAttributeMappingCdo(props) {
    var _this2 = this;

    _classCallCheck(this, EloquaAttributeMappingCdo);

    var _this = _possibleConstructorReturn(this, (EloquaAttributeMappingCdo.__proto__ || Object.getPrototypeOf(EloquaAttributeMappingCdo)).call(this, props));

    _this.getEloquaCdoFields = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var eloquaCdoFields;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_api__["a" /* api */].fetchEloquaCdoFields();

            case 3:
              eloquaCdoFields = _context.sent;


              _this.setState({
                eloquaCdoFields: eloquaCdoFields.fields
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.warn(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }));

    _this.patchEloquaCdoMappings = function (mappings) {
      var notifications = _this.props.notifications;

      var payload = { integrationAttributeMappings: { mappings: mappings } };

      try {
        __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_api__["a" /* api */].patchEloquaCdoConfig(payload);
        _this.setState({ cdoMappings: mappings });
        notifications.success(getSuccessMessage(integrationName));
      } catch (e) {
        console.warn(e);
        notifications.error(getErrorMessage(integrationName));
      }
    };

    _this.getEloquaCdoMappings = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var eloquaCdoConfig, cdoMappings;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              eloquaCdoConfig = void 0;
              _context2.prev = 1;
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5_app_modules_eloqua_api__["a" /* api */].fetchEloquaCdoConfig();

            case 4:
              eloquaCdoConfig = _context2.sent;
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](1);

              console.warn(_context2.t0);

            case 10:
              cdoMappings = eloquaCdoConfig.integrationAttributeMappings.mappings;


              if (cdoMappings != undefined) {
                _this.setState({
                  cdoMappings: cdoMappings
                });
              }

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 7]]);
    }));

    _this.toggleAttributeMapper = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(shouldShow) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this.setState({ showAttributeMapper: shouldShow });

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.state = {
      mappings: [],
      showAttributeMapper: false,
      cdoMappings: [],
      eloquaCdoFields: [],
      specialFields: [{ "label": "Conversation Id", "type": "STRING", value: "_integrations_conversation_id" }, { "label": "Conversation Transcript", "type": "STRING", value: "_integrations_conversation_transcript" }, { "label": "Conversation URL", "type": "STRING", value: "_integrations_conversation_url" }, { "label": "Lead Owner", "type": "STRING", value: "_integrations_lead_owner" }]
    };
    return _this;
  }

  _createClass(EloquaAttributeMappingCdo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchDriftProperties();
      this.getEloquaCdoMappings();
      this.getEloquaCdoFields();
    }
  }, {
    key: 'render',
    value: function render() {
      var driftProperties = this.props.driftProperties;
      var _state = this.state,
          cdoMappings = _state.cdoMappings,
          eloquaCdoFields = _state.eloquaCdoFields,
          specialFields = _state.specialFields,
          showAttributeMapper = _state.showAttributeMapper;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'eloqua-cdo-mapping common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Eloqua Integration',
          backLinkUrl: '/settings/setup/eloqua'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          { className: 'eloqua-cdo-mapping-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Mapped Eloqua CDO Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Map which fields you want to configure to your Eloqua CDO. These Drift attributes will be added to the selected Eloqua CDO.',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: HELP_DOC_URL },
              ' Learn More'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'b',
              null,
              'Eloqua CDO'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EloquaCdoSelect__["a" /* default */], {
            refreshEloquaFields: this.getEloquaCdoFields,
            toggleAttributeMapper: this.toggleAttributeMapper })
        ),
        showAttributeMapper && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__["a" /* default */], {
          integrationName: 'Eloqua',
          mappings: cdoMappings,
          driftAttributes: specialFields.concat(driftProperties),
          integrationAttributes: eloquaCdoFields,
          mappingModel: __WEBPACK_IMPORTED_MODULE_9_app_modules_eloqua_models__["a" /* EloquaMapping */],
          patchMappings: this.patchEloquaCdoMappings,
          patchLoading: false,
          allowAttributeDefaults: true,
          allowAttributeOverwrites: false })
      );
    }
  }]);

  return EloquaAttributeMappingCdo;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(EloquaAttributeMappingCdo)));

/***/ }),

/***/ "GwZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchOverviewPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchOverviewFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return receiveOverview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("mLwC");



var fetchOverview = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_OVERVIEW */]);
var fetchOverviewPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_OVERVIEW_PENDING */]);
var fetchOverviewFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_OVERVIEW_FAILED */]);
var receiveOverview = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* RECEIVE_OVERVIEW */]);

/***/ }),

/***/ "Gx+F":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzNCAzOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjguNjg4IDIyLjQyOHY2LjY5NmMwIC4zNDUtLjE4NS42NjMtLjQ4NC44MzItLjE0Ni4wODMtLjMwOC4xMjUtLjQ3LjEyNS0uMTcgMC0uMzQtLjA0NS0uNDktLjEzNmwtOS4zMDYtNS42MDNIOS42MjV2Ny42NTNjMCAuNTMtLjQyNy45NTgtLjk1My45NThzLS45NTMtLjQyOC0uOTUzLS45NTdWMjQuMzRIMy45MDVDMi44NTYgMjQuMzQgMiAyMy40ODQgMiAyMi40M3YtNy42NTJjMC0xLjA1NS44NTUtMS45MTQgMS45MDYtMS45MTRIMTcuOTRsOS4zMDQtNS42MDJjLjI5NC0uMTc4LjY2Mi0uMTgyLjk2LS4wMS4zLjE2OC40ODMuNDg1LjQ4My44M3Y2LjY5NmMyLjEwMyAwIDMuODEzIDEuNzE3IDMuODEzIDMuODI3cy0xLjcxIDMuODI1LTMuODEzIDMuODI1em0tMjAuOTctNy42NTJIMy45MDd2Ny42NTJINy43MnYtNy42NTJ6TTI2Ljc4MiA5Ljc3bC04LjA4NiA0Ljg3Yy0uMDIuMDEtLjA0Mi4wMS0uMDYyLjAyMi0uMDU2LjAyOC0uMTE2LjA0Ni0uMTguMDYzLS4wNi4wMTctLjEyLjAzMy0uMTg1LjAzOC0uMDIyIDAtLjA0LjAxMy0uMDY0LjAxM0g5LjYyNXY3LjY1Mmg4LjU3OGMuMDIyIDAgLjA0LjAxMi4wNjMuMDEzLjA2NC4wMDYuMTI1LjAyMi4xODguMDQuMDYyLjAxNi4xMjIuMDM0LjE3OC4wNjIuMDIuMDEuMDQyLjAxLjA2Mi4wMjJsOC4wODcgNC44NzJWOS43N3ptMS45MDcgNi45MnYzLjgyNmMxLjA1MiAwIDEuOTA3LS44NiAxLjkwNy0xLjkxMyAwLTEuMDU1LS44NTUtMS45MTQtMS45MDctMS45MTR6IiBmaWxsPSIjQjVEMkUxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "H+ql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchConvoForParticipantNotification; });
/* unused harmony export subscribed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return serviceWorkerRegistered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return failedToRegisterServiceWorker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return serviceWorkerMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return soundPlayed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return soundPlayFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showAbmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showAbmModalFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Jq9o");



var fetchConvoForParticipantNotification = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION */]);

var subscribed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION */]);

var serviceWorkerRegistered = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* SW_REGISTRATION_SUCCESS */]);
var failedToRegisterServiceWorker = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SW_REGISTRATION_FAILED */]);

var serviceWorkerMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SERVICE_WORKER_MESSAGE */]);

var soundPlayed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* NOTIFICATION_SOUND_SUCCESS */]);
var soundPlayFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* NOTIFICATION_SOUND_FAILED */]);

var showAbmModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SHOW_ABM_MODAL */]);
var showAbmModalFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* SHOW_ABM_MODAL_FAILED */]);

/***/ }),

/***/ "H24R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(498);

/***/ }),

/***/ "H2ry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H439":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 19.167c0 .46-.373.833-.833.833H12.5a.834.834 0 0 1-.833-.833 4.167 4.167 0 0 1 2.64-3.869 2.488 2.488 0 0 1-.974-1.965c0-1.378 1.122-2.5 2.5-2.5 1.379 0 2.5 1.122 2.5 2.5 0 .801-.385 1.508-.973 1.965A4.167 4.167 0 0 1 20 19.167zM15.833 12.5a.835.835 0 0 0-.833.833c0 .46.374.834.833.834a.835.835 0 0 0 0-1.667zm0 4.167a2.505 2.505 0 0 0-2.357 1.666h4.715a2.505 2.505 0 0 0-2.358-1.666zm-2.483-7.5H6.667a.834.834 0 0 1-.834-.834 4.165 4.165 0 0 1 2.64-3.867A2.49 2.49 0 0 1 7.5 2.5C7.5 1.122 8.622 0 10 0s2.5 1.122 2.5 2.5c0 .8-.384 1.505-.97 1.963a4.172 4.172 0 0 1 2.633 3.685.834.834 0 0 1-.813 1.02zM10 1.667a.835.835 0 0 0-.833.833c0 .46.374.833.833.833.46 0 .833-.374.833-.833A.835.835 0 0 0 10 1.667zm0 4.166A2.505 2.505 0 0 0 7.643 7.5h4.715A2.505 2.505 0 0 0 10 5.833zm-3.333 7.5c0 .801-.386 1.508-.974 1.965a4.167 4.167 0 0 1 2.64 3.869c0 .46-.373.833-.833.833H.833A.834.834 0 0 1 0 19.167a4.167 4.167 0 0 1 2.64-3.869 2.488 2.488 0 0 1-.973-1.965c0-1.378 1.121-2.5 2.5-2.5 1.378 0 2.5 1.122 2.5 2.5zm-4.858 5h4.715a2.505 2.505 0 0 0-2.357-1.666 2.505 2.505 0 0 0-2.358 1.666zM4.167 12.5a.835.835 0 0 0-.834.833.835.835 0 0 0 1.667 0 .835.835 0 0 0-.833-.833zm3.421 1.207a.833.833 0 0 1 .373-1.119l1.206-.603v-1.152a.834.834 0 0 1 1.666 0v1.152l1.206.603a.834.834 0 1 1-.745 1.49L10 13.432l-1.294.646a.833.833 0 0 1-1.118-.372z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "H6An":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H6K0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("eupy");









var mapStateToProps = function mapStateToProps(state) {
  return {
    embedId: __WEBPACK_IMPORTED_MODULE_4_app_modules_embed_selectors__["i" /* getEmbedId */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('endUserEmail', 'setEndUserEmail', ''), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isCopied', 'setIsCopied', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onEndUserEmailChange: function onEndUserEmailChange(props) {
    return function (e) {
      props.setEndUserEmail(e.target.value);
    };
  },
  handleCopyUnsubLink: function handleCopyUnsubLink(props) {
    return function () {
      props.setIsCopied(true);

      setTimeout(function () {
        props.setIsCopied(false);
      }, 1800);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    unsubLink: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["c" /* APP_URL */] + '/unsubscribe?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({ embedId: props.embedId, identifier: window.btoa(props.endUserEmail) })
  };
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "H7KV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__("EqrF");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var fetchIntegrationStates = function fetchIntegrationStates(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchIntegrationStates */].toString()).pluck('payload').mergeMap(function () {
    __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* fetchIntegrationStatesPending */]();

    try {
      return __WEBPACK_IMPORTED_MODULE_3__api__["w" /* getIntegrationStates */]().then(function (response) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["o" /* fetchIntegrationStatesSuccess */](response);
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* fetchIntegrationStatesFailed */](err);
      });
    } catch (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* fetchIntegrationStatesFailed */](error));
    }
  });
};

var fetchIntegrationEvents = function fetchIntegrationEvents(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* fetchIntegrationEvents */].toString()).pluck('payload').switchMap(function (query) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["t" /* getIntegrationEventLog */](query)).map(function (result) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchIntegrationEventsSuccess */](_extends({}, result, {
        integrationType: query.sourceId
      }));
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchIntegrationEventsPending */]({ integrationType: query.sourceId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchIntegrationEventsFailed */]({ error: error, integrationType: query.sourceId }));
    });
  });
};

var fetchPaginatedIntegrationEvents = function fetchPaginatedIntegrationEvents(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["t" /* fetchPaginatedIntegrationEvents */].toString()).pluck('payload').switchMap(function (_ref) {
    var queryStr = _ref.queryStr,
        sourceId = _ref.sourceId;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["u" /* getIntegrationEventLogQueryStr */](queryStr)).map(function (result) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["u" /* fetchPaginatedIntegrationEventsSuccess */](_extends({}, result, {
        integrationType: sourceId
      }));
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchIntegrationEventsPending */]({ integrationType: sourceId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchIntegrationEventsFailed */]({ error: error, integrationType: sourceId }));
    });
  });
};

var postBusinessEventCsv = function postBusinessEventCsv(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["I" /* postBusinessEventCsv */].toString()).pluck('payload').mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["g" /* emailBusinessCsvExport */](payload)).map(function () {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'We successfully started your CSV export! Check your email for a CSV in a few minutes.'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["K" /* postBusinessEventCsvSuccess */]({ integrationName: payload.sourceId });
    }).catch(function (error) {
      error.json().then(function (readableError) {
        return __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          variant: "red",
          content: readableError.message
        });
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["J" /* postBusinessEventCsvFailed */]({ integrationName: payload.sourceId, error: error }));
    });
  });
};

var fetchStripeKeys = function fetchStripeKeys(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["v" /* fetchStripeKeys */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["n" /* fetchStripeKeys */]()).map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["z" /* fetchStripeKeysSuccess */](data);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["y" /* fetchStripeKeysPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["x" /* fetchStripeKeysFailed */]({ err: err }));
    });
  });
};

var fetchOutreachStatus = function fetchOutreachStatus(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["p" /* fetchOutreachStatus */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["m" /* fetchOutreachStatus */]()).map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["s" /* fetchOutreachStatusSuccess */](data);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["r" /* fetchOutreachStatusPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["q" /* fetchOutreachStatusFailed */]({ err: err }));
    });
  });
};

var createAccessToken = function createAccessToken(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* createAccessToken */].toString()).pluck('payload').mergeMap(function (_ref2) {
    var integrationName = _ref2.integrationName,
        body = _ref2.body;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["c" /* createAccessToken */](integrationName, body)).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createAccessTokenSuccess */]({ integrationName: integrationName });
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createAccessTokenPending */]({ integrationName: integrationName })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(err.json().then(function (readableError) {
        var error = readableError.message;
        return __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: error, integrationName: integrationName });
      })).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: err, integrationName: integrationName }));
      });
    });
  });
};
var createSandBoxAccessToken = function createSandBoxAccessToken(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* createSandBoxAccessToken */].toString()).pluck('payload').mergeMap(function (_ref3) {
    var integrationName = _ref3.integrationName,
        body = _ref3.body;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["c" /* createAccessToken */]("salesforce", body)).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createAccessTokenSuccess */]({ integrationName: integrationName });
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createAccessTokenPending */]({ integrationName: integrationName })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(err.json().then(function (readableError) {
        var error = readableError.message;
        return __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: error, integrationName: integrationName });
      })).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: err, integrationName: integrationName }));
      });
    });
  });
};

var createSlackbotToken = function createSlackbotToken(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* createSlackbotToken */].toString()).pluck('payload').mergeMap(function (_ref4) {
    var code = _ref4.code,
        href = _ref4.href;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["d" /* createSlackbotToken */](code, href)).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createAccessTokenSuccess */]({ integrationName: 'slack' });
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createAccessTokenPending */]({ integrationName: 'slack' })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(err.json().then(function (readableError) {
        var error = readableError.message;
        return __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: error, integrationName: 'slack' });
      })).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAccessTokenFailed */]({ err: err, integrationName: 'slack' }));
      });
    });
  });
};

var updateIntegrationStatus = function updateIntegrationStatus(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["T" /* updateIntegrationState */].toString()).pluck('payload').mergeMap(function (_ref5) {
    var integration = _ref5.integration,
        connected = _ref5.connected;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["_3" /* updateIntegrationState */]({ integration: integration, connected: connected })).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["W" /* updateIntegrationStateSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["V" /* updateIntegrationStatePending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["U" /* updateIntegrationStateFailed */]({ err: err }));
    });
  });
};

var setWordpressV2Integration = function setWordpressV2Integration(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["P" /* setWordpressV2Integration */].toString()).debounceTime(1000).pluck('payload').mergeMap(function (_ref6) {
    var integration = _ref6.integration,
        connected = _ref6.connected;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["_3" /* updateIntegrationState */]({ integration: integration, connected: connected })).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["S" /* setWordpressV2IntegrationSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* setWordpressV2IntegrationPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* setWordpressV2IntegrationFailed */]({ err: err }));
    });
  });
};

var setWordpressDomain = function setWordpressDomain(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["L" /* setWordpressDomain */].toString()).debounceTime(600).pluck('payload').mergeMap(function (_ref7) {
    var rootUrl = _ref7.rootUrl;

    var url = Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* addhttps */])(rootUrl);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["Z" /* setWordpressDomain */](url)).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["O" /* setWordpressDomainSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["N" /* setWordpressDomainPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* setWordpressDomainFailed */]({ err: err, error: true }));
    });
  });
};

var fetchWordpressDomain = function fetchWordpressDomain(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["A" /* fetchWordpressDomain */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["o" /* fetchWordpressDomain */]()).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["D" /* fetchWordpressDomainSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["C" /* fetchWordpressDomainPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["B" /* fetchWordpressDomainFailed */]({ err: err }));
    });
  });
};

var getLeanDataAuthStatus = function getLeanDataAuthStatus(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["E" /* getLeanDataAuthStatus */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3__api__["x" /* getLeanDataAuthorizationStatus */]()).map(function (res) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["H" /* getLeanDataAuthStatusSuccess */]({ authStatus: res });
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["G" /* getLeanDataAuthStatusPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["F" /* getLeanDataAuthStatusFailed */]({ authStatus: "UNSUCCESSFUL_API_REQUEST" }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchIntegrationStates, fetchOutreachStatus, fetchIntegrationEvents, fetchPaginatedIntegrationEvents, updateIntegrationStatus, createAccessToken, createSlackbotToken, setWordpressV2Integration, setWordpressDomain, fetchWordpressDomain, postBusinessEventCsv, createSandBoxAccessToken, fetchStripeKeys, getLeanDataAuthStatus);

/***/ }),

/***/ "H7wK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("GHhY");
var _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var appInfo = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchOAuthAppInfoSuccess */]), function (state, action) {
  return state.set(action.payload.client_id, action.payload.app);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchOAuthAppInfoFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchOAuthAppInfoPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchOAuthAppInfoSuccess */]), function (state, action) {
  return state.setIn(['appInfo', action.payload.client_id], action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchOAuthCodeFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchOAuthCodePending */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchOAuthCodeSuccess */]), function (state, action) {
  return state.setIn(['appCode', action.payload.client_id], action.type);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var appCodes = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchOAuthCodeSuccess */]), function (state, action) {
  return state.set(action.payload.client_id, action.payload.code);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])({
  appInfo: appInfo,
  appCodes: appCodes,
  status: status
}));

/***/ }),

/***/ "H8Rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("VlbN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("sMXN");





var fetchSegments = function fetchSegments(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchSegments */].toString()).pluck('payload').mergeMap(function (_ref2) {
    var id = _ref2.id;

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchSegments(id, Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(getState())).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchSegmentsSuccess */]({ id: id, endUserSegments: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchSegmentsPending */]({ id: id })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchSegmentsFailed */]({ id: id, error: error }));
    });
  });
};

var epic = fetchSegments;

/***/ }),

/***/ "H8TN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select_plus_dist_react_select_plus_css__ = __webpack_require__("/XUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select_plus_dist_react_select_plus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_select_plus_dist_react_select_plus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg__ = __webpack_require__("iv9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg__ = __webpack_require__("PK/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_AgentStatusAvatar__ = __webpack_require__("L7W3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl__ = __webpack_require__("N748");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var InviteTips = function InviteTips() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'invite-select-tips' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'dsg-Body color-navy-dark' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'color-navy-extra-dark' },
        'Key ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg___default.a })
      ),
      ' ',
      'to navigate'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'dsg-Body color-navy-dark' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'color-navy-extra-dark' },
        'Return ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg___default.a })
      ),
      ' ',
      'to select'
    )
  );
};

var InviteSelect = function (_PureComponent) {
  _inherits(InviteSelect, _PureComponent);

  function InviteSelect(props) {
    _classCallCheck(this, InviteSelect);

    var _this = _possibleConstructorReturn(this, (InviteSelect.__proto__ || Object.getPrototypeOf(InviteSelect)).call(this, props));

    _this.findUser = function (_ref) {
      var users = _ref.users,
          id = _ref.id;

      if (users.has(id)) {
        return users.get(id).toJS();
      }
    };

    _this.findTeam = function (_ref2) {
      var teams = _ref2.teams,
          id = _ref2.id;

      return teams.find(function (team) {
        return team.id === id;
      });
    };

    _this.renderUserOption = function (_ref3) {
      var id = _ref3.id;

      var user = _this.findUser({ users: _this.props.users, id: id });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex agent-status-avatar-wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { className: 'agent-status-avatar', size: 'small', user: user }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'agent-status-indicator agent-status-indicator-conversations' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: Object(__WEBPACK_IMPORTED_MODULE_11_components_shared_AgentStatusAvatar__["b" /* resolveStatusIcon */])(user) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'user-label' },
          Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user)
        )
      );
    };

    _this.renderTeamOption = function (_ref4) {
      var id = _ref4.id;

      var team = _this.findTeam({ teams: _this.props.teams, id: id });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex team-option' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'team-label' },
          team.name
        )
      );
    };

    _this.renderUserValue = function (_ref5) {
      var id = _ref5.id;

      var user = _this.findUser({ users: _this.props.users, id: id });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex agent-status-avatar-wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { className: 'agent-status-avatar', size: 'small', user: user }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'agent-status-indicator agent-status-indicator-conversations' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: Object(__WEBPACK_IMPORTED_MODULE_11_components_shared_AgentStatusAvatar__["b" /* resolveStatusIcon */])(user) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'user-label' },
          Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user)
        )
      );
    };

    _this.renderTeamValue = function (_ref6) {
      var id = _ref6.id;

      var team = _this.findTeam({ teams: _this.props.teams, id: id });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex team-wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'team-label' },
          team.name
        )
      );
    };

    _this.renderTeamsSectionHeader = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'section-header with-subtitle' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'section-title' },
          'Team'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'section-subtitle' },
          'When you add a Team, we\u2019ll round robin the conversation to someone in that group'
        )
      );
    };

    _this.renderTeammatesSectionHeader = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'section-header' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'section-title' },
          'Teammate'
        )
      );
    };

    _this.renderOptionGroupHeader = function (_ref7) {
      var label = _ref7.label;

      if (label === 'Teams') {
        return _this.renderTeamsSectionHeader();
      }

      if (label === 'Teammates') {
        return _this.renderTeammatesSectionHeader();
      }

      return null;
    };

    _this.renderValue = function (_ref8) {
      var value = _ref8.value;

      if (value.type === 'USER') {
        return _this.renderUserValue({ id: value.id });
      }

      if (value.type === 'TEAM') {
        return _this.renderTeamValue({ id: value.id });
      }

      return null;
    };

    _this.renderOption = function (_ref9) {
      var value = _ref9.value,
          label = _ref9.label;

      if (!value) {
        return _this.renderOptionGroupHeader({ label: label });
      }

      if (value.type === 'USER') {
        return _this.renderUserOption({ id: value.id });
      }

      if (value.type === 'TEAM') {
        return _this.renderTeamOption({ id: value.id });
      }

      return null;
    };

    _this.handleSelect = function (selectedOptions) {
      var consumerChangeEvent = _this.props.onChange || function () {};

      _this.setState({
        selectedOptions: selectedOptions
      }, consumerChangeEvent.bind(null, selectedOptions));
    };

    _this.handleClick = function () {
      var onNext = _this.props.onNext;

      onNext && onNext(_this.state.selectedOptions);
    };

    _this.state = {
      selectedOptions: props.value || []
    };
    return _this;
  }

  _createClass(InviteSelect, [{
    key: 'selectDefaults',
    value: function selectDefaults() {
      var defaults = {
        isOpen: true,
        multi: true,
        autofocus: this.props.shouldSelectAutofocus,
        value: this.state.selectedOptions,
        options: this.props.options || this.selectOptions.options,
        onChange: this.handleSelect,
        clearable: false,
        optionRenderer: this.props.optionRenderer || this.renderOption,
        valueRenderer: this.props.valueRenderer || this.renderValue,
        className: 'InviteSelect',
        placeholder: 'Search team or teammate…'
      };

      return _extends({}, defaults, this.props.selectOptions);
    }

    // TODO: Clicking the "X" on one of the values clears all of them. In Prod,
    // we can click the "X" and only remove that value. Worth fixing.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showInviteTips = _props.showInviteTips,
          CTA = _props.CTA;
      var selectedOptions = this.state.selectedOptions;

      var disabledCTA = Boolean(selectedOptions.length);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'InviteSelectContainer users-and-teams' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'invite-select-wrapper' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], this.selectDefaults()),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_components_shared_ConditionalRender__["a" /* default */],
            { condition: showInviteTips },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InviteTips, null)
          ),
          !!CTA && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            { disabled: !disabledCTA, className: 'invite-submit-button', onClick: this.handleClick },
            CTA
          )
        )
      );
    }
  }]);

  return InviteSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

InviteSelect.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array /* Currently chosen value */
  , CTA: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string /* text for cta */
  , options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired /* All the options to be displayed */
  , onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func /* fires on input additions and deletes */
  , onNext: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func /* what to do on cta click */
  , className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string /* Optional class name to set on the select component */
  , arrow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool /* Whether to display an arrow for the dropdown */
  , showInviteTips: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  CustomButton: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element
};
InviteSelect.defaultProps = {
  showInviteTips: true,
  shouldSelectAutofocus: true
};


/* harmony default export */ __webpack_exports__["a"] = (InviteSelect);

/***/ }),

/***/ "HBi2":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNLjI1IDQuMDg1VjEyaDIuNVY0LjA4NUguMjV6bTYuNSAzLjMyYzAtMS4wMjIuNjM5LTEuNTMzIDEuMzg5LTEuNTMzUzkuNSA2LjM4MyA5LjUgNy42NlYxMkgxMlY3LjQwNGMwLTIuMjk4LTEuMjUtMy41NzQtMy0zLjU3NC0xIDAtMS43NS41ODEtMi4yNSAxLjM0N2wtLjA4My0xLjA5Mkg0LjIwOGMwIC4yNy4wNDIgMS43ODcuMDQyIDEuNzg3VjEyaDIuNVY3LjQwNHpNMS40ODYgMi44MDhDMi40MTYgMi44MDkgMyAyLjE4NCAzIDEuNDA0IDIuOTg2LjYxIDIuNDE3IDAgMS41MTQgMCAuNTk3IDAgMCAuNjEgMCAxLjQwNGMwIC43OC41ODMgMS40MDUgMS40NzIgMS40MDVoLjAxNHoiIGZpbGw9IiMwQTVCRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "HF11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OperatorOptions = [{ value: "lessThan", text: "is less than" }, { value: "greaterThan", text: "is greater than" }];

var OperatorByValue = __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default()(OperatorOptions, 'value');

var ClearbitNumericInputs = function (_Component) {
  _inherits(ClearbitNumericInputs, _Component);

  function ClearbitNumericInputs() {
    _classCallCheck(this, ClearbitNumericInputs);

    return _possibleConstructorReturn(this, (ClearbitNumericInputs.__proto__ || Object.getPrototypeOf(ClearbitNumericInputs)).apply(this, arguments));
  }

  _createClass(ClearbitNumericInputs, [{
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'onNumberChange',
    value: function onNumberChange(value) {
      this.props.conditionUpdater('value', parseInt(value));
    }
  }, {
    key: 'renderOperatorSelection',
    value: function renderOperatorSelection() {
      var operator = this.props.conditionValue.get('operator');
      var selectedValue = OperatorByValue[operator];
      var text = selectedValue.text,
          value = selectedValue.value;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__["a" /* default */], {
        onSelection: this.onOperatorSelect.bind(this),
        options: OperatorOptions,
        selectedValue: text || value
      });
    }
  }, {
    key: 'renderNumericInput',
    value: function renderNumericInput() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default.a, {
        type: 'number',
        min: 0,
        valueLink: {
          requestChange: this.onNumberChange.bind(this),
          value: this.props.conditionValue.get('value')
        },
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'flex-space-around flex-1' },
        this.renderOperatorSelection(),
        this.renderNumericInput(),
        React.createElement('div', { style: { width: 16 } })
      );
    }
  }]);

  return ClearbitNumericInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ClearbitNumericInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "HFS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Attrib; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Attrib = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  orgId: undefined,
  deleted: false,
  createdDateTime: undefined,
  updatedDateTime: undefined,
  label: 'Account Attribute',
  name: 'account_attribute',
  options: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  type: undefined,
  userId: undefined
});

/***/ }),

/***/ "HGQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"companyAvatar":"companyAvatar---3isk8","placeholderAvatar":"placeholderAvatar---3Nuym"};

/***/ }),

/***/ "HGzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RolodexIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_conversation_api__ = __webpack_require__("a5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_styles_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SectionHeader_styl__ = __webpack_require__("klvG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SectionHeader_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__SectionHeader_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SectionBody_styl__ = __webpack_require__("7tSm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SectionBody_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__SectionBody_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl__ = __webpack_require__("0h7c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var RolodexIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, {
  style: {
    width: 16,
    height: 11,
    marginRight: 8
  },
  element: 'div',
  src: __webpack_require__("kk7P")
});

var Selection = function Selection(_ref) {
  var onClick = _ref.onClick,
      count = _ref.count,
      noun = _ref.noun,
      isSelected = _ref.isSelected;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('flex-column flex-center', { 'bg-navy-light': isSelected }),
      onClick: onClick,
      style: {
        border: '1px solid ' + __WEBPACK_IMPORTED_MODULE_15_styles_colors_json___default.a['color-navy-light'],
        borderRadius: 3,
        height: 60,
        width: 110,
        cursor: 'pointer',
        marginBottom: 16,
        transition: 'all .3s'
      }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      {
        className: 'dsg-h2 color-blue',
        style: {
          lineHeight: '30px'
        }
      },
      count
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'dsg-Small color-navy-dark' },
      noun
    )
  );
};

var ActivitySectionPlaceholder = function ActivitySectionPlaceholder() {
  var placeholderShape = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 0, x: '0', y: '0', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 1, x: '0', y: '47', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 2, x: '0', y: '94', width: '229', height: '27', rx: '2' })];

  var options = {
    height: 131,
    width: 229,
    primaryColor: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
    secondaryColor: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
    primaryOpacity: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
    secondaryOpacity: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_18__style_styl__["activitySectionPlaceholder"] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 })
  );
};

var ActivitySection = function (_Component) {
  _inherits(ActivitySection, _Component);

  function ActivitySection(props) {
    _classCallCheck(this, ActivitySection);

    var _this = _possibleConstructorReturn(this, (ActivitySection.__proto__ || Object.getPrototypeOf(ActivitySection)).call(this, props));

    _this.state = {
      showChats: true,
      conversations: []
    };
    return _this;
  }

  _createClass(ActivitySection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.actions.fetchConversationsCountForEndUserId({ id: this.props.endUserId });
      __WEBPACK_IMPORTED_MODULE_13_app_modules_conversation_api__["c" /* default */].fetchConversationsForEndUser(this.props.endUserId).then(function (conversations) {
        _this2.setState({ conversations: conversations });
      });
    }
  }, {
    key: 'getChatRows',
    value: function getChatRows() {
      return this.state.conversations.map(function (_ref2) {
        var inboxId = _ref2.inboxId,
            id = _ref2.id,
            preview = _ref2.preview,
            updatedAt = _ref2.updatedAt;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Link */],
          { to: '/inboxes/' + inboxId + '/conversations/' + id, key: id, onClick: function onClick() {
              return Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_tracking_actions__["track"])('Conversation Sidebar - Go To Conversation Clicked');
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'flex-1' },
            preview
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { width: 55 } },
            __WEBPACK_IMPORTED_MODULE_5_moment___default()(updatedAt).format('M/D/YY')
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var showChats = this.state.showChats;
      var _props = this.props,
          conversationCount = _props.conversationCount,
          endUserId = _props.endUserId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_16__SectionHeader_styl__["SectionHeader"] },
          RolodexIcon,
          'Activity'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_17__SectionBody_styl__["SectionBody"] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-space-between' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Selection, {
              onClick: this.showChatRows,
              count: conversationCount,
              noun: Object(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__["pluralize"])(conversationCount, 'chat', 'chats'),
              isSelected: showChats
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_17__SectionBody_styl__["Table"] },
            this.getChatRows()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Link */],
            { className: __WEBPACK_IMPORTED_MODULE_17__SectionBody_styl__["ViewTimeLine"] + ' flex-center', to: '/contacts/details/' + endUserId, target: '_blank' },
            'View Full Timeline'
          )
        )
      );
    }
  }]);

  return ActivitySection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    conversationCount: __WEBPACK_IMPORTED_MODULE_10_app_modules_conversation_selectors__["e" /* conversationCountForEndUser */](state, { endUserId: props.endUserId })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchConversationsCountForEndUserId: __WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__["o" /* fetchConversationsCountForEndUserId */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["a" /* branch */])(function (props) {
  return !props.endUserId;
}, Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["f" /* renderComponent */])(ActivitySectionPlaceholder)), Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(ActivitySection));

/***/ }),

/***/ "HH7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var emptyCustomValue = { label: 'Custom', value: { min: null, max: null } };

var MoneyRaisedFilter = function (_Component) {
  _inherits(MoneyRaisedFilter, _Component);

  function MoneyRaisedFilter(props) {
    _classCallCheck(this, MoneyRaisedFilter);

    var _this = _possibleConstructorReturn(this, (MoneyRaisedFilter.__proto__ || Object.getPrototypeOf(MoneyRaisedFilter)).call(this, props));

    _this.updateMin = function (event) {
      var currentValue = event.target.value;
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { min: currentValue }) };
      }, _this.updateCondition);
    };

    _this.updateMax = function (event) {
      var currentValue = event.target.value;
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { max: currentValue }) };
      }, _this.updateCondition);
    };

    _this.updateCondition = function () {
      var updatedCondition = {
        operator: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["D" /* MONEY_RAISED_FILTER_OPERATORS */].BTW,
        value: _this.state.selectedValue
      };

      _this.isValid() && _this.props.onUpdateCondition(updatedCondition);
    };

    _this.onSelect = function (group) {
      if (group.value === 'CUSTOM') {
        return _this.setState({
          selectedValue: emptyCustomValue,
          isCustom: true
        });
      }

      return _this.setState({
        selectedValue: group.value,
        isCustom: false
      }, _this.updateCondition);
    };

    var initialValue = props.activeFilter.value;

    _this.state = {
      selectedValue: initialValue,
      isCustom: !_this.hasMatchedGroup(initialValue)
    };
    return _this;
  }

  _createClass(MoneyRaisedFilter, [{
    key: 'hasMatchedGroup',
    value: function hasMatchedGroup(isMatchedGroup) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["E" /* MONEY_RAISED_GROUPS */], function (group) {
        return _.isEqual(group, isMatchedGroup);
      });

      return !!matched ? { value: matched, label: '$' + matched.min + ' - $' + matched.max + ' million' } : null;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return !!this.state.selectedValue.min && !!this.state.selectedValue.max;
    }
  }, {
    key: 'renderMoneyDropdown',
    value: function renderMoneyDropdown() {
      var selectOptions = {
        multi: false,
        autoFocus: true,
        value: this.hasMatchedGroup(this.state.selectedValue) || emptyCustomValue,
        onChange: this.onSelect,
        clearable: false,
        options: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["E" /* MONEY_RAISED_GROUPS */].map(function (group) {
          return { value: group, label: '$' + group.min + ' - $' + group.max + ' million' };
        })), [{ label: 'Custom', value: 'CUSTOM' }])
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderCustomInput',
    value: function renderCustomInput() {
      if (!this.state.isCustom) return;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-filter-custom-input drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '$0', onChange: this.updateMin, defaultValue: this.state.selectedValue.min }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'to'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '$0', onChange: this.updateMax, defaultValue: this.state.selectedValue.max }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'million'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          this.renderMoneyDropdown(),
          this.renderCustomInput()
        )
      );
    }
  }]);

  return MoneyRaisedFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MoneyRaisedFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "HHjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("kbde");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var SuggestIntegrationModal = function (_Component) {
  _inherits(SuggestIntegrationModal, _Component);

  function SuggestIntegrationModal(props) {
    var _this2 = this;

    _classCallCheck(this, SuggestIntegrationModal);

    var _this = _possibleConstructorReturn(this, (SuggestIntegrationModal.__proto__ || Object.getPrototypeOf(SuggestIntegrationModal)).call(this, props));

    _this.handleChange = function (e) {
      _this.setState({ integrationSuggestion: e.target.value });
    };

    _this.sendSuggestion = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this$props, onClose, notifications;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onClose = _this$props.onClose, notifications = _this$props.notifications;
              _context.prev = 1;
              _context.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["N" /* postIntegrationSuggestion */])(_this.state.integrationSuggestion);

            case 4:
              _this.setState({ integrationSuggestion: "" }, function () {
                notifications.success("We received your request. Thanks for suggesting an integration!");
                onClose();
              });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);

              console.error(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 7]]);
    }));

    _this.state = {
      integrationSuggestion: ""
    };
    return _this;
  }

  _createClass(SuggestIntegrationModal, [{
    key: "render",
    value: function render() {
      var integrationSuggestion = this.state.integrationSuggestion;

      var hasSuggestion = integrationSuggestion && integrationSuggestion.length > 0;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Modal"],
          {
            className: "integration-suggestion-modal",
            open: this.props.open,
            size: this.props.size,
            onClose: this.props.onClose
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            "h1",
            { className: "integration-suggestion-header" },
            "What integration do you want to see in Drift?"
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
            className: "integration-suggestion-input",
            type: "text",
            placeholder: "Integration name",
            onChange: this.handleChange
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
            {
              className: "integration-suggestion-button",
              disabled: !hasSuggestion,
              onClick: this.sendSuggestion
            },
            "Suggest integration"
          )
        )
      );
    }
  }]);

  return SuggestIntegrationModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(SuggestIntegrationModal));

/***/ }),

/***/ "HKYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("8NQ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_constants__ = __webpack_require__("st9j");















var mapStateToProps = function mapStateToProps(state) {
  return {
    goal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["j" /* currentGoal */](state),
    classificationOptions: __WEBPACK_IMPORTED_MODULE_8_app_modules_classification_selectors__["a" /* classificationOptions */](state),
    selectedGoalAction: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_70" /* selectedGoalAction */](state),
    hasCalendarAction: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_25" /* hasCalendarAction */](state),
    hasAutoCloseAction: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_24" /* hasAutoCloseAction */](state),
    isLeadBotPlaybook: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_40" /* isLeadBot */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideGoalActionModal: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_83" /* hideGoalActionModal */],
      selectGoalAction: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_123" /* selectGoalAction */],
      saveGoalAction: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_106" /* saveGoalAction */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_5_recompose_withState___default()('viewMode', 'setViewMode', null), __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default()(function (props) {
  return {
    isCalendarSelected: _.has(props.selectedGoalAction, 'schedule'),
    isMessageSelected: _.has(props.selectedGoalAction, 'message'),
    isAutoCloseSelected: _.has(props.selectedGoalAction, 'statusChange'),
    isCqlSelected: _.has(props.selectedGoalAction, 'markCQL'),
    disableCalendar: props.goal.get('schedule'),
    disableMessage: props.goal.get('message'),
    disableAutoClose: props.goal.get('statusChange'),
    classificationDetails: props.classificationOptions.find(function (classification) {
      return classification.value === props.goal.classification.get('classificationId');
    })
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      var id = props.goal.id,
          _props$actions = props.actions,
          saveGoalAction = _props$actions.saveGoalAction,
          hideGoalActionModal = _props$actions.hideGoalActionModal,
          selectedGoalAction = props.selectedGoalAction;

      if (!!selectedGoalAction) saveGoalAction({ goalId: id, goalAction: selectedGoalAction });
      hideGoalActionModal();
    };
  },
  onCancelClick: function onCancelClick(props) {
    return function () {
      props.actions.hideGoalActionModal();
    };
  },
  onResetViewClick: function onResetViewClick(props) {
    return function () {
      props.setViewMode(null);
    };
  },
  onConfigureCqlClick: function onConfigureCqlClick(props) {
    return function () {
      props.setViewMode(__WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_constants__["s" /* ActionViewConfig */].CQL);
    };
  },
  handleSelectCql: function handleSelectCql(props) {
    return function (score) {
      var selectGoalAction = props.actions.selectGoalAction;

      selectGoalAction({
        markCQL: { score: score }
      });
    };
  },
  handleSelectCalendar: function handleSelectCalendar(props) {
    return function () {
      var selectGoalAction = props.actions.selectGoalAction;

      selectGoalAction({
        schedule: { calendarId: 'placeholder' }
      });
    };
  },
  handleSelectMessage: function handleSelectMessage(props) {
    return function () {
      var selectGoalAction = props.actions.selectGoalAction;

      selectGoalAction({
        message: { authorId: null, body: 'Thanks! See you again soon.' }
      });
    };
  },
  handleSelectAutoClose: function handleSelectAutoClose(props) {
    return function () {
      var selectGoalAction = props.actions.selectGoalAction;

      selectGoalAction({
        statusChange: { status: 'CLOSED' }
      });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "HL4s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HLzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);



function parseParticipants(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(data.participants);
}

var api = {
  fetch: function fetch(conversationId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/conversations/' + conversationId + '/participants').checkStatus().retryWithBackoff().mapResponse(parseParticipants);
  },
  add: function add(_ref) {
    var conversationId = _ref.conversationId,
        participants = _ref.participants,
        teams = _ref.teams;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/conversations/' + conversationId + '/participants', { participants: participants, teams: teams }).checkStatus().retryWithBackoff().mapResponse(parseParticipants);
  },
  remove: function remove(conversationId, participants) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].delete('/conversations/' + conversationId + '/participants', { participants: participants }).checkStatus().retryWithBackoff().mapResponse(parseParticipants);
  }
};

/***/ }),

/***/ "HRBm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AvailabilitySlotSelect__ = __webpack_require__("RH6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BufferSettings__ = __webpack_require__("Im5/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var Section = function Section(props) {
  return React.createElement('div', _extends({}, props, { className: props.className }));
};

var MeetingSettings = function MeetingSettings(_ref) {
  var meetingSettings = _ref.meetingSettings,
      handleAddSlotClick = _ref.handleAddSlotClick,
      handleRemoveSlotClick = _ref.handleRemoveSlotClick,
      handleSelectDayOfWeek = _ref.handleSelectDayOfWeek,
      handleSelectStartTime = _ref.handleSelectStartTime,
      handleSelectEndTime = _ref.handleSelectEndTime,
      errorMessageKey = _ref.errorMessageKey,
      settingsErrorMessages = _ref.settingsErrorMessages,
      showRemoveSlotUI = _ref.showRemoveSlotUI,
      handleSelectTimezone = _ref.handleSelectTimezone;

  return React.createElement(
    'div',
    { className: 'meeting-settings' },
    React.createElement(
      Section,
      null,
      React.createElement(
        'div',
        { className: 'drift-form' },
        !!errorMessageKey && React.createElement(
          'div',
          { className: 'error-messages' },
          settingsErrorMessages[errorMessageKey]
        ),
        React.createElement(
          'div',
          { className: 'meeting-subsettings' },
          meetingSettings.availability.map(function (value, slot) {
            var _value$toJS = value.toJS(),
                dayOfWeek = _value$toJS.dayOfWeek,
                startTime = _value$toJS.startTime,
                endTime = _value$toJS.endTime;

            return React.createElement(__WEBPACK_IMPORTED_MODULE_2__AvailabilitySlotSelect__["a" /* default */], {
              key: value + '-' + slot,
              index: slot,
              dayOfWeek: dayOfWeek,
              startTime: startTime,
              endTime: endTime,
              onSelectDayOfWeek: handleSelectDayOfWeek,
              onSelectStartTime: handleSelectStartTime,
              onSelectEndTime: handleSelectEndTime,
              onRemove: handleRemoveSlotClick,
              hideRemove: !showRemoveSlotUI
            });
          }),
          React.createElement(
            'div',
            { className: 'add-time-slot' },
            React.createElement(
              'a',
              { onClick: handleAddSlotClick },
              '+ Add Time Slot'
            )
          )
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_3__BufferSettings__["a" /* default */], null),
        React.createElement(
          'div',
          { className: 'flex' },
          React.createElement(
            'div',
            { className: 'timezone-picker' },
            React.createElement(
              'label',
              { className: 'settings-label' },
              'Your Timezone',
              React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
                value: meetingSettings.timezone,
                searchable: true,
                clearable: false,
                options: __WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__["h" /* TIMEZONE_OPTIONS */],
                onChange: handleSelectTimezone
              })
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MeetingSettings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "HRTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("H8Rx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("U1mr");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "HSWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page__ = __webpack_require__("Ybad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeetingTypesList__ = __webpack_require__("pXZX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_Section__ = __webpack_require__("r8Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__ = __webpack_require__("oNNb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_billing_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GlobalCalendarInfo__ = __webpack_require__("1/F1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_settings_meetings_CalendarTabHeader__ = __webpack_require__("ACOC");











var CalendarSettings = function CalendarSettings(_ref) {
  var isGoogleAuthed = _ref.isGoogleAuthed,
      isMicrosoftAuthed = _ref.isMicrosoftAuthed,
      calendar = _ref.calendar,
      isCreatingNew = _ref.isCreatingNew,
      handleCreateMeetingType = _ref.handleCreateMeetingType,
      router = _ref.router,
      isTokenRevoked = _ref.isTokenRevoked,
      hasBetaGlobalCalendars = _ref.hasBetaGlobalCalendars,
      isGlobalCalendarManaged = _ref.isGlobalCalendarManaged,
      isUpgradeModalOpen = _ref.isUpgradeModalOpen,
      setUpgradeModal = _ref.setUpgradeModal,
      isOnFreePlan = _ref.isOnFreePlan,
      hasMeetings = _ref.hasMeetings,
      meetingTypes = _ref.meetingTypes;

  var isGloballyManagedAndInBeta = hasBetaGlobalCalendars && isGlobalCalendarManaged;
  var connected = (isGoogleAuthed || isMicrosoftAuthed || isGloballyManagedAndInBeta) && !!calendar.id;
  var totalMeetingTypesLength = (meetingTypes && meetingTypes.length) + 1; // add one for default meeting type
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2__page__["a" /* default */],
    {
      isTokenRevoked: isTokenRevoked,
      showHeaderBorder: !connected,
      hasBetaGlobalCalendars: hasBetaGlobalCalendars,
      isGlobalCalendarManaged: isGlobalCalendarManaged
    },
    React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_settings_meetings_CalendarTabHeader__["a" /* default */], { router: router, view: 'MEETINGS' }),
    !connected && isGloballyManagedAndInBeta && React.createElement(__WEBPACK_IMPORTED_MODULE_6__GlobalCalendarInfo__["a" /* default */], null),
    React.createElement(
      'div',
      { className: 'subsection top' },
      React.createElement(
        'div',
        { className: 'flex-space-between' },
        React.createElement(
          'div',
          { className: 'subheader' },
          totalMeetingTypesLength,
          ' Meeting ',
          Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(totalMeetingTypesLength, 'Type')
        ),
        React.createElement(
          'button',
          {
            className: 'tide-button tide-button--secondary',
            disabled: isCreatingNew,
            onClick: function onClick() {
              return !isOnFreePlan || hasMeetings ? handleCreateMeetingType() : setUpgradeModal(true);
            }
          },
          isCreatingNew ? 'Creating...' : '+ New Meeting Type'
        )
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_3__MeetingTypesList__["a" /* default */], { gatedOnClick: function gatedOnClick() {
          return setUpgradeModal(true);
        } }),
      isUpgradeModalOpen && React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_billing_components__["UpgradeModal"], {
        onCloseInitiated: function onCloseInitiated() {
          return setUpgradeModal(false);
        },
        headLineFeatureText: 'Custom Drift Meeting Types',
        planName: 'Standard',
        isMonthlyBilling: true
      })
    ),
    connected && React.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_shared_Section__["a" /* SectionItem */],
      {
        title: 'Your Drift Assistant is connected to your calendar',
        description: 'The Drift Assistant helps you close more deals by preparing you for your meetings and sending you reminders for important deals so you never accidentally lose an opportunity again.',
        className: 'assistant-config-footer-section'
      },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
        { to: '/settings2/assistant' },
        'Manage your Drift Assistant'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* withRouter */])(CalendarSettings));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "HZdP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ColorInput__ = __webpack_require__("RjrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("fhvE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ICON_SRC = __webpack_require__("gYUb");

var VALID_COLOR_REGEX = /^[a-fA-F0-9]{6}$/;

var isValidColor = function isValidColor(hex) {
  return VALID_COLOR_REGEX.test(hex);
};

var makeTitle = function makeTitle(titleText, toolTipComponent) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'color-input-title' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      titleText
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["ToolTip"],
        {
          flow: 'up',
          component: toolTipComponent
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { className: 'icon-image', src: ICON_SRC })
      )
    )
  );
};

var ColorPicker = function (_Component) {
  _inherits(ColorPicker, _Component);

  function ColorPicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call.apply(_ref, [this].concat(args))), _this), _this.isValidScheme = function () {
      var _this$props$colors = _this.props.colors,
          backgroundColor = _this$props$colors.backgroundColor,
          foregroundColor = _this$props$colors.foregroundColor,
          activeColor = _this$props$colors.activeColor,
          textColor = _this$props$colors.textColor,
          widgetBackgroundColor = _this$props$colors.widgetBackgroundColor;

      return !Object.keys(_this.props.colors).some(function (key) {
        return !isValidColor(_this.props.colors[key]);
      }) && backgroundColor.toLowerCase() !== foregroundColor.toLowerCase() && backgroundColor.toLowerCase() !== textColor.toLowerCase() && activeColor.toLowerCase() !== 'ffffff';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ColorPicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$colors = this.props.colors,
          backgroundColor = _props$colors.backgroundColor,
          foregroundColor = _props$colors.foregroundColor,
          activeColor = _props$colors.activeColor,
          textColor = _props$colors.textColor,
          widgetBackgroundColor = _props$colors.widgetBackgroundColor;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('flex-column', __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.ColorPicker) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-column', style: { paddingBottom: this.props.hasChanged() ? 0 : 24 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ColorInput__["a" /* default */], {
            label: makeTitle("Primary Color", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'tooltip-text' },
              'Background color for widget header and ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'visitor message bubbles, embedded button',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'colors, text and border color for button',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'responses, and background color of chat',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'button when widget is closed.'
            )),
            valid: isValidColor(backgroundColor),
            color: backgroundColor,
            size: 'medium',
            onChange: function onChange(hex) {
              return _this2.props.onChange("backgroundColor", hex);
            },
            className: 'color-input'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-description' },
            'Use a dark brand color that\u2019s recognizable and stands out on your website'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ColorInput__["a" /* default */], {
            label: makeTitle("Secondary Color", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'tooltip-text' },
              'Foreground color for text/icons in widget',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'header and visitor message bubbles, text in',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'embedded buttons, background color for',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'button responses, and icon of chat button',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'when widget is closed.'
            )),
            valid: isValidColor(foregroundColor),
            color: foregroundColor,
            size: 'medium',
            onChange: function onChange(hex) {
              return _this2.props.onChange("foregroundColor", hex);
            },
            className: 'color-input'
          }),
          foregroundColor.toLowerCase() === backgroundColor.toLowerCase() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-error' },
            'Cannot be same as Primary Color'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-description' },
            'Use a lighter color that will be legible on the Primary Color'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ColorInput__["a" /* default */], {
            label: makeTitle("Send Button Color", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'tooltip-text' },
              'Color for text and icon of the Send',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'button that appears when visitor has',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'entered text into the Drift widget.'
            )),
            valid: isValidColor(activeColor),
            color: activeColor,
            size: 'medium',
            onChange: function onChange(hex) {
              return _this2.props.onChange("activeColor", hex);
            },
            className: 'color-input'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-description' },
            'Use a strong color with a clear call to action'
          ),
          activeColor.toLowerCase() === 'ffffff' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'hyperlink-color-error' },
            'Sorry, this color can\u2019t be white because buttons and links will disappear!'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ColorInput__["a" /* default */], {
            label: makeTitle("Chat Text Color", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'tooltip-text' },
              'Text color for visitor messages'
            )),
            valid: isValidColor(textColor),
            color: textColor,
            size: 'medium',
            onChange: function onChange(hex) {
              return _this2.props.onChange("textColor", hex);
            },
            className: 'color-input'
          }),
          textColor.toLowerCase() === backgroundColor.toLowerCase() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-error' },
            'Cannot be same as Primary Color'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-description' },
            'Use a light color similar to the Secondary Color'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ColorInput__["a" /* default */], {
            label: makeTitle("Widget Background Color", __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'tooltip-text' },
              'Background color for the',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'main widget container.'
            )),
            valid: isValidColor(widgetBackgroundColor),
            color: widgetBackgroundColor,
            size: 'medium',
            onChange: function onChange(hex) {
              return _this2.props.onChange("widgetBackgroundColor", hex);
            },
            className: 'color-input'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'color-input-description' },
            'Use a very light color for good contrast'
          ),
          this.props.hasChanged() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'save-buttons-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
              { onClick: this.props.onSubmit, type: 'primary', disabled: !this.isValidScheme() },
              'Save'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
              { onClick: this.props.onCancel, type: 'tertiary' },
              'Cancel'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'color-gray-dark dsg-Regular applies-to-info' },
          'These colors apply to Campaigns, Emails, Chat and Icons. See more',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'http://docs.drift.com/articles/customizing-your-colors/', target: '_blank' },
            'details here'
          ),
          '.'
        )
      );
    }
  }]);

  return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);

/***/ }),

/***/ "HaDl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HbAe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTE0IDg2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTEwNi44NzUgMEg3LjEyNUMzLjE2NjY2NyAwIDAgMy4xNzQ2MDMgMCA3LjE0Mjg1N1Y3OC41NzE0M2MwIDMuOTY4MjUzIDMuMTY2NjY3IDcuMTQyODU2IDcuMTI1IDcuMTQyODU2aDk5Ljc1YzMuOTU4MzMzIDAgNy4xMjUtMy4xNzQ2MDMgNy4xMjUtNy4xNDI4NTdWNy4xNDI4NTZDMTE0IDMuMTc0NjAzIDExMC44MzMzMzMgMCAxMDYuODc1IDB6TTI0LjkzNzUgMTQuMjg1NzE0QzMwLjg3NSAxNC4yODU3MTQgMzUuNjI1IDE5LjA0NzYyIDM1LjYyNSAyNWMwIDUuOTUyMzgtNC43NSAxMC43MTQyODYtMTAuNjg3NSAxMC43MTQyODZTMTQuMjUgMzAuOTUyMzggMTQuMjUgMjVjMC01Ljk1MjM4IDQuNzUtMTAuNzE0Mjg2IDEwLjY4NzUtMTAuNzE0Mjg2ek05OS43NSA3MS40Mjg1N2gtODUuNUwyOC41IDUwbDE2LjYyNSAxMS45MDQ3NjJMNzEuMjUgMjguNTcxNDNsMjguNSA0Mi44NTcxNHoiCiAgICAgICAgICBmaWxsPSIjRUVFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "HbY0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConditionSet__ = __webpack_require__("VpnU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("3mvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var TargetingDisplayWhen = function TargetingDisplayWhen(_ref) {
  var display = _ref.display,
      onBackClick = _ref.onBackClick,
      onAddConditionSetClick = _ref.onAddConditionSetClick,
      isOnFreePlan = _ref.isOnFreePlan;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-display-when' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: 'link playbook-display-when-cancel', onClick: onBackClick },
      '< Display Options'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Create your display conditions\u2026'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Display to visitors when the following conditions are met:'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      display.map(function (conditionSetId) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ConditionSet__["a" /* default */], { key: conditionSetId, id: conditionSetId });
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
      {
        onClick: !isOnFreePlan && onAddConditionSetClick,
        disabled: isOnFreePlan,
        className: 'playbook-targeting-displaywhen-add-condition drift-button drift-button-secondary'
      },
      '+ Add Condition Set'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TargetingDisplayWhen);

/***/ }),

/***/ "Hbft":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31 22H1c-.552 0-1-.448-1-1V1c0-.552.448-1 1-1h30c.552 0 1 .448 1 1v20c0 .552-.448 1-1 1zM30 2H2v18h4.002v-1c0-.552.447-1 1-1 .552 0 1 .448 1 1v1H24v-1c0-.552.448-1 1-1 .553 0 1 .448 1 1v1h4V2zm-4 10h-8c-.55 0-1-.448-1-1s.45-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1zm0-4h-8c-.55 0-1-.448-1-1s.45-1 1-1h8c.553 0 1 .448 1 1s-.447 1-1 1zm-12.665 8H6.668c-.92 0-1.666-.786-1.666-1.75v-.752c0-.03.015-.057.017-.087.005-.068.02-.133.04-.2.018-.06.04-.117.068-.173.03-.055.065-.104.104-.154.043-.054.088-.1.14-.145.025-.02.04-.048.065-.065l1.9-1.303c-.32-.73-.342-1.352-.333-1.605l-.002-.012V7.5c0-.025.014-.047.016-.072.002-.03-.008-.06-.003-.09C7.257 5.893 8.753 5 10 5h.007c1.243 0 2.736.89 2.98 2.333.005.03-.005.06-.003.09.002.027.015.05.015.076v2.263c.008.25-.016.87-.333 1.6l1.9 1.31c.027.02.04.046.063.065.053.044.1.093.142.147.04.05.074.098.103.153.03.056.05.114.07.176.02.065.032.128.04.197 0 .03.016.057.016.088v.75c0 .966-.746 1.752-1.665 1.752zm-2.546-3.502c-.02-.013-.045-.02-.065-.034-.09-.07-.153-.156-.212-.245-.007-.01-.017-.017-.023-.027-.05-.08-.078-.17-.103-.262-.01-.035-.03-.068-.035-.105-.01-.06 0-.123.002-.186 0-.07-.003-.14.013-.208.008-.032.028-.06.04-.092.028-.084.052-.17.105-.247.008-.012.02-.018.03-.03.484-.63.46-1.203.46-1.21-.002-.02.007-.04.006-.062 0-.01-.007-.022-.007-.034v-2.12C10.92 7.35 10.45 7 10 7c-.447 0-.92.35-.997.636L9 9.756c0 .01-.004.018-.004.028 0 .02.007.036.006.055-.003.046-.017.606.457 1.22.006.01.006.02.012.028s.015.01.02.02c.034.048.043.103.067.155.027.06.062.12.076.183.016.065.01.13.013.196 0 .062.01.123 0 .184-.01.065-.04.124-.06.186-.023.058-.037.118-.07.173-.034.057-.085.1-.13.15-.04.043-.065.093-.112.128-.008.007-.02.01-.028.015-.007.006-.01.014-.018.02L7.038 14h5.93l-2.18-1.502zM18 14h4c.553 0 1 .448 1 1s-.447 1-1 1h-4c-.55 0-1-.448-1-1s.45-1 1-1z\" fill=\"#9A9A9A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "HkY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export ChatWidgetDesign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackButton__ = __webpack_require__("h2eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_MessagePreviews_WelcomeMessage__ = __webpack_require__("jbeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Customize_Styling_ColorPicker__ = __webpack_require__("HZdP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Customize_Styling_IconPicker__ = __webpack_require__("7LNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Customize_Styling_CustomIconPicker__ = __webpack_require__("1obw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Customize_Styling_FontPicker__ = __webpack_require__("de+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Customize_Styling_WidgetSizePicker__ = __webpack_require__("mvlj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Customize_Styling_DriftBranding__ = __webpack_require__("qNox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MessengerBuilder__ = __webpack_require__("yVUJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_I18n_Constants__ = __webpack_require__("waKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PageTitle__ = __webpack_require__("dtTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_styl__ = __webpack_require__("v/lX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__style_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ICON_PICKER_CHAT_SRC;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





























var DELAY_IN_MS = 1000;
var NOTIFICATION_MESSAGE = 'The style of your Drift Widget has been updated!';
var sendIconSvg = __webpack_require__("lWre");

var tryTrimValue = function tryTrimValue(value) {
  return typeof value === 'string' ? value.trim() : value;
};

var ICON_PICKER_CHAT_SRC_CONFIG = (_ICON_PICKER_CHAT_SRC = {}, _defineProperty(_ICON_PICKER_CHAT_SRC, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID1, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID1][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc])), _defineProperty(_ICON_PICKER_CHAT_SRC, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID2, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID2][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc])), _defineProperty(_ICON_PICKER_CHAT_SRC, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].OUTLINE1, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].OUTLINE1][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc])), _defineProperty(_ICON_PICKER_CHAT_SRC, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].OUTLINE2, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc, __WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].OUTLINE2][__WEBPACK_IMPORTED_MODULE_18_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc])), _ICON_PICKER_CHAT_SRC);

var ButtonsDescription = function ButtonsDescription() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'buttons-description' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      'You can make the Drift Widget open when somebody clicks on a button or link. '
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      {
        href: 'https://help.drift.com/article/changing-the-drift-icon-to-a-logo-face-or-custom-image/',
        target: '_blank'
      },
      'Here\'s how.'
    )
  );
};

var ChatWidgetDesign = function (_Component) {
  _inherits(ChatWidgetDesign, _Component);

  function ChatWidgetDesign(props) {
    _classCallCheck(this, ChatWidgetDesign);

    var _this = _possibleConstructorReturn(this, (ChatWidgetDesign.__proto__ || Object.getPrototypeOf(ChatWidgetDesign)).call(this, props));

    _this.handleThemeChange = _this.handleThemeChange.bind(_this);
    _this.submitThemeChangeForManualSave = _this.submitThemeChangeForManualSave.bind(_this);
    _this.onChangeThemeColor = _this.onChangeThemeColor.bind(_this);
    _this.colorsHaveChanged = _this.colorsHaveChanged.bind(_this);
    _this.revertToOriginalColorScheme = _this.revertToOriginalColorScheme.bind(_this);
    _this.handleCustomIconChange = _this.handleCustomIconChange.bind(_this);
    _this.handleClearIcon = _this.handleClearIcon.bind(_this);
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    _this.handleToggleBranding = _this.handleToggleBranding.bind(_this);
    _this.patchOrgSettingsDebounced = _.debounce(_this.patchOrgSettings, DELAY_IN_MS);

    _this.state = {
      theme: props.orgSettings.theme,
      tmpColors: {
        backgroundColor: props.orgSettings.theme.backgroundColor,
        foregroundColor: props.orgSettings.theme.foregroundColor,
        textColor: props.orgSettings.theme.textColor,
        activeColor: props.orgSettings.theme.activeColor,
        widgetBackgroundColor: props.orgSettings.theme.widgetBackgroundColor
      }
    };
    return _this;
  }

  _createClass(ChatWidgetDesign, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hasChanged = !nextProps.orgSettings.theme.equals(this.props.orgSettings.theme);

      if (hasChanged) {
        this.setState({ theme: nextProps.orgSettings.theme });
      }
    }
  }, {
    key: 'handleThemeChange',
    value: function handleThemeChange(key) {
      var _this2 = this;

      return function (value, isValid) {
        var theme = _this2.state.theme;

        var themePropertyName = key[1];
        var updatedTheme = theme.merge(_defineProperty({}, themePropertyName, tryTrimValue(value)));
        _this2.setState({ theme: updatedTheme });

        if (themePropertyName === 'activeColor') {
          if (isValid && value.toLowerCase() !== 'ffffff') {
            var orgSettings = _this2.props.orgSettings;

            var updatedOrgSettings = orgSettings.merge({ theme: updatedTheme });
            _this2.patchOrgSettingsDebounced(updatedOrgSettings, orgSettings);
          }
        } else {
          if (isValid) {
            var _orgSettings = _this2.props.orgSettings;

            var _updatedOrgSettings = _orgSettings.merge({ theme: updatedTheme });
            _this2.patchOrgSettingsDebounced(_updatedOrgSettings, _orgSettings);
          }
        }
      };
    }
  }, {
    key: 'submitThemeChangeForManualSave',
    value: function submitThemeChangeForManualSave() {
      var _state = this.state,
          theme = _state.theme,
          tmpColors = _state.tmpColors;

      var updatedTheme = theme.merge(tmpColors);
      this.setState({ theme: updatedTheme });

      var orgSettings = this.props.orgSettings;

      var updatedOrgSettings = orgSettings.merge({ theme: updatedTheme });
      this.patchOrgSettings(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'onChangeThemeColor',
    value: function onChangeThemeColor(key, hex) {
      this.setState({
        tmpColors: _extends({}, this.state.tmpColors, _defineProperty({}, key, hex))
      });
    }
  }, {
    key: 'colorsHaveChanged',
    value: function colorsHaveChanged() {
      var _state2 = this.state,
          theme = _state2.theme,
          tmpColors = _state2.tmpColors;

      return Object.keys(tmpColors).some(function (key) {
        return theme[key].toLowerCase() !== tmpColors[key].toLowerCase();
      });
    }
  }, {
    key: 'revertToOriginalColorScheme',
    value: function revertToOriginalColorScheme() {
      this.setState({
        tmpColors: {
          backgroundColor: this.props.orgSettings.theme.backgroundColor,
          foregroundColor: this.props.orgSettings.theme.foregroundColor,
          textColor: this.props.orgSettings.theme.textColor,
          activeColor: this.props.orgSettings.theme.activeColor,
          widgetBackgroundColor: this.props.orgSettings.theme.widgetBackgroundColor
        }
      });
    }
  }, {
    key: 'handleCustomIconChange',
    value: function handleCustomIconChange(_ref) {
      var _this3 = this;

      var _ref2 = _slicedToArray(_ref, 1),
          icon = _ref2[0];

      var _props = this.props,
          embed = _props.embed,
          orgSettings = _props.orgSettings;
      var actions = this.context.app.actions;


      var iconUrl = function iconUrl() {
        return _this3.state.theme.iconUrl;
      };

      var patchChanged = function patchChanged() {
        var updatedOrgSettings = orgSettings.setIn(['theme', 'iconUrl'], iconUrl());
        _this3.patchOrgSettings(updatedOrgSettings, orgSettings);
      };

      actions.OrgSettingsActions.updateIcon(embed.orgId, icon).then(patchChanged);
    }
  }, {
    key: 'handleClearIcon',
    value: function handleClearIcon() {
      var orgSettings = this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'iconUrl'], null);

      this.setState({ theme: updatedOrgSettings.theme });
      this.patchOrgSettings(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(key) {
      var _this4 = this;

      return function (_ref3) {
        var value = _ref3.value;
        var orgSettings = _this4.props.orgSettings;

        var updatedOrgSettings = orgSettings.setIn(key, value);

        _this4.updateOrgSettings(updatedOrgSettings);
        _this4.patchOrgSettings(updatedOrgSettings, orgSettings);
      };
    }
  }, {
    key: 'handleToggleBranding',
    value: function handleToggleBranding(event) {
      var orgSettings = this.props.orgSettings;

      var showBranding = event.target.checked;
      var updatedOrgSettings = orgSettings.merge({ showBranding: showBranding });

      this.updateOrgSettings(updatedOrgSettings);
      this.patchOrgSettings(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'updateOrgSettings',
    value: function updateOrgSettings(updatedOrgSettings) {
      var actions = this.context.app.actions;

      actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'patchOrgSettings',
    value: function patchOrgSettings(updatedOrgSettings, orgSettings) {
      var changes = Object(__WEBPACK_IMPORTED_MODULE_7_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(updatedOrgSettings, orgSettings);

      var actions = this.context.app.actions;

      actions.DefaultEmbedActions.patchDefaultEmbed(changes, NOTIFICATION_MESSAGE);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currentUser = _props2.currentUser,
          botUser = _props2.botUser,
          orgSettings = _props2.orgSettings;
      var _state3 = this.state,
          theme = _state3.theme,
          tmpColors = _state3.tmpColors;


      var name = currentUser.name || orgSettings.orgName;

      var hasBotInfo = botUser && botUser.get('name') && botUser.get('avatarUrl');

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_23__style_styl___default.a.ChatWidgetDesign },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BackButton__["a" /* default */], { title: 'Drift Widget Settings', url: '/settings/widget' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__PageTitle__["a" /* default */], {
          title: 'Design',
          description: 'Stylize your design elements',
          className: 'design-settings-page-title'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          { className: 'widget-settings-section-header-title' },
          'Widget Style - Colors, Icon and Font'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'widget-settings-section-header-desc' },
          'These colors are also used in playbooks and emails.',
          ' ',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'a',
            { href: 'https://help.drift.com/article/customizing-your-drift-colors/', target: '_blank' },
            'Learn More.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'widget-settings-protip info-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__driftt_tide_core_legacy__["Icon"], { className: 'widget-icon info-icon', name: 'info' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'widget-settings-info-text' },
            'Pro Tip: To satisfy web accessibility requirements, ensure that there is at least a',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: 'https://webaim.org/resources/contrastchecker/', target: '_blank' },
              ' ',
              '3:1 contrast ratio',
              ' '
            ),
            'between all combinations of foreground and background colors.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'top-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'welcome-message-container', style: { fontFamily: theme.fontFamily } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_components_shared_MessagePreviews_WelcomeMessage__["a" /* default */],
              {
                backgroundColor: tmpColors.backgroundColor,
                foregroundColor: tmpColors.foregroundColor,
                showProfileIcon: true,
                users: __WEBPACK_IMPORTED_MODULE_8_immutable__["List"].of(currentUser),
                title: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'span',
                  null,
                  name
                ),
                message: theme.welcomeMessage
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'composer', style: { backgroundColor: tmpColors.widgetBackgroundColor } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'composer-prompt' },
                  'Type your message\u2026'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'composer-input' },
                  'Hey |'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'composer-actions', style: { color: tmpColors.activeColor } },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_svg_inline_react___default.a, { src: sendIconSvg, style: { color: tmpColors.activeColor } }),
                  'Send Message'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MessengerBuilder__["a" /* default */], {
              themeColors: tmpColors,
              avatarUrl: hasBotInfo ? botUser.get('avatarUrl') : currentUser.avatarUrl,
              name: hasBotInfo ? botUser.get('name') : name
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'color-scheme' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'color-picker' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Customize_Styling_ColorPicker__["a" /* default */], {
                colors: tmpColors,
                onChange: this.onChangeThemeColor,
                onSubmit: this.submitThemeChangeForManualSave,
                onCancel: this.revertToOriginalColorScheme,
                hasChanged: this.colorsHaveChanged
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'buttons' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'icon-container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'icon-picker' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Customize_Styling_IconPicker__["a" /* default */], {
                selectedIconStyle: theme.iconStyle,
                foregroundColor: theme.foregroundColor,
                backgroundColor: theme.backgroundColor,
                onSelection: this.handleThemeChange(['theme', 'iconStyle']),
                iconPickerConfig: ICON_PICKER_CHAT_SRC_CONFIG
              })
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'icon-uploader' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Customize_Styling_CustomIconPicker__["a" /* default */], {
                onDrop: this.handleCustomIconChange,
                onClear: this.handleClearIcon,
                preview: theme.iconUrl,
                iconStyle: theme.iconStyle
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'buttons-info' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* SectionItem */], { title: 'Want to use your own button?', description: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ButtonsDescription, null) })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'dropdowns' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'typeface-dropdown' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'label' },
              'Widget Font'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Customize_Styling_FontPicker__["a" /* default */], {
              fontFamily: theme.fontFamily,
              onSelection: this.handleSelectChange(['theme', 'fontFamily'])
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'language-dropdown' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { className: 'label' },
              'Language'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_shared_UISelect__["b" /* default */], {
              value: orgSettings.locale,
              options: __WEBPACK_IMPORTED_MODULE_17_components_I18n_Constants__["a" /* LOCALE_OPTIONS */],
              onSelection: this.handleSelectChange(['locale'])
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'widget-size' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h3',
            { className: 'widget-settings-section-header-title' },
            'Widget Size'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'widget-settings-section-header-desc' },
            'Choose how Drift Widget is displayed on your website.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Customize_Styling_WidgetSizePicker__["a" /* default */], {
            widgetHalfHeight: theme.widgetHalfHeight,
            onSelection: this.handleThemeChange(['theme', 'widgetHalfHeight'])
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'drift-branding' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_Customize_Styling_DriftBranding__["a" /* default */], { value: orgSettings.showBranding, onChange: this.handleToggleBranding })
        )
      );
    }
  }]);

  return ChatWidgetDesign;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ChatWidgetDesign.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
var ChatWidgetDesignContainer = Object(__WEBPACK_IMPORTED_MODULE_5_components_container__["a" /* makeDefaultFailedContainer */])(ChatWidgetDesign, {
  listenTo: ['stores.OrgSettingsStore', 'stores.UserStore', 'stores.DefaultEmbedStore'],
  fetch: {
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    },
    currentUser: function currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    embed: function embed() {
      return this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed();
    }
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    botUser: Object(__WEBPACK_IMPORTED_MODULE_22_app_modules_user_selectors__["botUser"])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ChatWidgetDesignContainer));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "HmKA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/oauth-modal-header-toggle.629792ae.svg";

/***/ }),

/***/ "HnAN":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Notifs_3.0_final\" transform=\"translate(-633.000000, -668.000000)\" fill=\"#7695A5\"><g id=\"Group\" transform=\"translate(519.000000, 217.000000)\"><g id=\"Desktop\"><g id=\"desktop_notification_selectors\"><g id=\"Group-4\" transform=\"translate(0.000000, 448.000000)\"><g id=\"sound\"><g id=\"volume-2-copy-2\" transform=\"translate(114.000000, 3.000000)\"><path d=\"M10.4919079,11.2365217 C10.4334731,11.2551739 10.3733197,11.2642174 10.3148849,11.2642174 C10.0731253,11.2642174 9.84797954,11.1127391 9.76892072,10.8747826 C9.67152941,10.5786087 9.83652174,10.2603913 10.1378619,10.1643043 C11.6107621,9.69517391 12.6001432,8.32678261 12.6001432,6.75830435 C12.6001432,5.20904348 11.5844092,3.80673913 10.1292685,3.34778261 C9.82792839,3.25226087 9.66179028,2.93517391 9.7586087,2.63843478 C9.85485422,2.34226087 10.1768184,2.17891304 10.4804501,2.275 C12.4351509,2.89165217 13.7476419,4.69356522 13.7476419,6.75830435 C13.7476419,8.81626087 12.4391611,10.6164783 10.4919079,11.2365217 Z M11.4818619,6.75830435 C11.4818619,8.00121739 10.4518056,9.0123913 9.18629156,9.0123913 C8.86948338,9.0123913 8.61225575,8.76030435 8.61225575,8.44886957 C8.61225575,8.13743478 8.86948338,7.88534783 9.18629156,7.88534783 C9.81933504,7.88534783 10.3337903,7.37947826 10.3337903,6.75830435 C10.3337903,6.13656522 9.81933504,5.63069565 9.18629156,5.63069565 C8.86948338,5.63069565 8.61225575,5.3786087 8.61225575,5.06717391 C8.61225575,4.75630435 8.86948338,4.50365217 9.18629156,4.50365217 C10.4518056,4.50365217 11.4818619,5.5153913 11.4818619,6.75830435 Z M7.70021483,12.9056087 C7.62344757,12.940087 7.5415243,12.9570435 7.46017391,12.9570435 C7.32554476,12.9570435 7.19320716,12.9106957 7.08664962,12.8213913 L3.23109974,9.57591304 L1.14807161,9.57591304 C0.515028133,9.57591304 0.000572890026,9.0706087 0.000572890026,8.44886957 L0.000572890026,5.06717391 C0.000572890026,4.446 0.515028133,3.94069565 1.14807161,3.94069565 L3.23109974,3.94069565 L7.08664962,0.694652174 C7.25737084,0.552217391 7.49626598,0.518869565 7.70021483,0.611 C7.90359079,0.703130435 8.03420972,0.902652174 8.03420972,1.12308696 L8.03420972,12.3935217 C8.03420972,12.6133913 7.90359079,12.812913 7.70021483,12.9056087 Z M6.886711,2.34791304 L3.81716624,4.93208696 C3.79539642,4.95017391 3.76904348,4.9563913 3.74555499,4.97108696 C3.71175448,4.992 3.67967263,5.01404348 3.641289,5.02817391 C3.60233248,5.04230435 3.56337596,5.04626087 3.52327366,5.05134783 C3.49577494,5.05530435 3.47171355,5.06717391 3.44364194,5.06717391 L1.14807161,5.06717391 L1.14807161,8.44886957 L3.44364194,8.44886957 C3.47285934,8.44886957 3.49749361,8.46073913 3.52556522,8.46526087 C3.56509463,8.47034783 3.60290537,8.47430435 3.64071611,8.48786957 C3.67967263,8.502 3.71175448,8.52404348 3.74612788,8.54552174 C3.76904348,8.55965217 3.79539642,8.56643478 3.81716624,8.58452174 L6.886711,11.1681304 L6.886711,2.34791304 Z\" id=\"Shape\"></path></g></g></g></g></g></g></g></g></svg>"

/***/ }),

/***/ "Hpl3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hxpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var SalesforceLeadEnrichmentIcon = function SalesforceLeadEnrichmentIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "534", height: "65", viewBox: "0 0 534 65", xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "defs",
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { id: "d", width: "25.9", height: "26.026", rx: "2.1" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "pattern",
        { id: "e", x: "-.243%", width: "100.243%", height: "100%" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#a", transform: "scale(.43376)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image", { id: "a", width: "60", height: "60", xlinkHref: "data:image/png;base64,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"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "pattern",
        { id: "f", x: "-.243%", width: "100.243%", height: "100%" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#b", transform: "scale(.43376)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image", { id: "b", width: "60", height: "60", xlinkHref: "data:image/png;base64,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"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "pattern",
        { id: "g", x: "-.243%", width: "100.243%", height: "100%" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#c", transform: "scale(.43376)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image", { id: "c", width: "60", height: "60", xlinkHref: "data:image/png;base64,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"
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "linearGradient",
        { x1: "100%", y1: "100%", x2: "50%", y2: "0%", id: "h" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#157AFB", offset: "0%" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#0750A8", offset: "100%" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.767 13.6H.567A.567.567 0 0 1 0 13.033v-.378c0-2.35 1.745-4.399 4.067-5.062A3.97 3.97 0 0 1 1.7 3.967 3.971 3.971 0 0 1 5.667 0a3.971 3.971 0 0 1 3.966 3.967 3.97 3.97 0 0 1-2.367 3.626c2.322.663 4.067 2.712 4.067 5.062v.378a.567.567 0 0 1-.566.567zM8.5 3.967a2.837 2.837 0 0 0-2.833-2.834 2.837 2.837 0 0 0-2.834 2.834A2.837 2.837 0 0 0 5.667 6.8 2.837 2.837 0 0 0 8.5 3.967zM5.667 8.5c-2.389 0-4.417 1.798-4.529 3.967h9.057C10.083 10.298 8.055 8.5 5.667 8.5z",
        id: "i" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "linearGradient",
        { x1: "100%", y1: "100%", x2: "0%", y2: "0%", id: "k" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#FAD961", offset: "0%" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#F76B1C", offset: "100%" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.767 13.6H.567A.567.567 0 0 1 0 13.033v-.378c0-2.35 1.745-4.399 4.067-5.062A3.97 3.97 0 0 1 1.7 3.967 3.971 3.971 0 0 1 5.667 0a3.971 3.971 0 0 1 3.966 3.967 3.97 3.97 0 0 1-2.367 3.626c2.322.663 4.067 2.712 4.067 5.062v.378a.567.567 0 0 1-.566.567zM8.5 3.967a2.837 2.837 0 0 0-2.833-2.834 2.837 2.837 0 0 0-2.834 2.834A2.837 2.837 0 0 0 5.667 6.8 2.837 2.837 0 0 0 8.5 3.967zM5.667 8.5c-2.389 0-4.417 1.798-4.529 3.967h9.057C10.083 10.298 8.055 8.5 5.667 8.5z",
        id: "l" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "linearGradient",
        { x1: "64.067%", y1: "50%", x2: "0%", y2: "0%", id: "n" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#27C971", offset: "0%" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", { stopColor: "#029847", offset: "100%" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M10.767 13.6H.567A.567.567 0 0 1 0 13.033v-.378c0-2.35 1.745-4.399 4.067-5.062A3.97 3.97 0 0 1 1.7 3.967 3.971 3.971 0 0 1 5.667 0a3.971 3.971 0 0 1 3.966 3.967 3.97 3.97 0 0 1-2.367 3.626c2.322.663 4.067 2.712 4.067 5.062v.378a.567.567 0 0 1-.566.567zM8.5 3.967a2.837 2.837 0 0 0-2.833-2.834 2.837 2.837 0 0 0-2.834 2.834A2.837 2.837 0 0 0 5.667 6.8 2.837 2.837 0 0 0 8.5 3.967zM5.667 8.5c-2.389 0-4.417 1.798-4.529 3.967h9.057C10.083 10.298 8.055 8.5 5.667 8.5z",
        id: "o" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { id: "q", d: "M0 .121h61.988V43H0" })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "rotate(4 -148.9 3125.35)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "144.2", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M42.823 16.734c-2.15 0-3.864-1.568-3.864-3.864s1.714-3.864 3.864-3.864c1.199 0 2.027.46 2.621 1.11.1.1.157.257.157.414a.621.621 0 0 1-1.087.403 2.23 2.23 0 0 0-1.69-.762c-1.423 0-2.52 1.131-2.52 2.7 0 1.567 1.097 2.699 2.52 2.699.694 0 1.287-.292 1.702-.762a.617.617 0 0 1 .459-.213.621.621 0 0 1 .459 1.03c-.594.65-1.411 1.11-2.62 1.11zm6.194-5.678c1.198 0 2.251.504 2.251 1.96v3.058a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-.056c-.403.459-1.03.716-1.747.716-.885 0-1.882-.593-1.882-1.792 0-1.243.997-1.758 1.882-1.758.728 0 1.355.235 1.747.694v-.806c0-.627-.515-1.008-1.266-1.008-.459 0-.862.123-1.265.403a.507.507 0 0 1-.269.079.473.473 0 0 1-.47-.47c0-.158.09-.303.201-.382a3.282 3.282 0 0 1 1.994-.638zm-.213 4.872c.515 0 1.02-.19 1.288-.56v-.818c-.269-.37-.773-.56-1.288-.56-.66 0-1.154.381-1.154.975 0 .582.493.963 1.154.963zm10.237-4.872c.997 0 1.557.538 1.557 1.635v3.383a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-3.002c0-.582-.258-.974-.885-.974-.527 0-1.02.37-1.255.716v3.26a.598.598 0 0 1-.593.593.595.595 0 0 1-.583-.593v-3.002c0-.582-.257-.974-.896-.974-.515 0-.996.37-1.243.728v3.248a.595.595 0 0 1-.582.593.598.598 0 0 1-.594-.593v-4.357c0-.325.269-.594.583-.594.324 0 .593.269.593.594v.213c.224-.325.941-.874 1.759-.874.806 0 1.299.403 1.478.997.314-.493 1.03-.997 1.837-.997zm3.662-.918a.734.734 0 0 1-.728-.728c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.582-.594v-4.357c0-.325.269-.594.593-.594.314 0 .583.269.583.594v4.357a.598.598 0 0 1-.594.593zm2.71 0a.598.598 0 0 1-.593-.594V9.656c0-.325.269-.594.594-.594.313 0 .582.27.582.594v6.418a.595.595 0 0 1-.582.593zm2.7 0a.598.598 0 0 1-.594-.594V9.656c0-.325.269-.594.594-.594.313 0 .582.27.582.594v6.418a.595.595 0 0 1-.582.593zm4.334-5.612c1.199 0 2.251.504 2.251 1.96v3.058a.598.598 0 0 1-.593.593.595.595 0 0 1-.583-.593v-.056c-.403.459-1.03.716-1.747.716-.885 0-1.881-.593-1.881-1.792 0-1.243.996-1.758 1.881-1.758.728 0 1.355.235 1.747.694v-.806c0-.627-.515-1.008-1.265-1.008-.46 0-.863.123-1.266.403a.507.507 0 0 1-.269.079.473.473 0 0 1-.47-.47c0-.158.09-.303.202-.382a3.282 3.282 0 0 1 1.993-.638zm-.213 4.872c.516 0 1.02-.19 1.288-.56v-.818c-.268-.37-.772-.56-1.288-.56-.66 0-1.153.381-1.153.975 0 .582.493.963 1.153.963zm12.87-3.338c.447 0 .694.247.694.695v1.601c0 .348-.09.616-.359.852a4.04 4.04 0 0 1-2.721 1.008c-2.162 0-3.92-1.535-3.92-3.876 0-2.34 1.758-3.864 3.92-3.864 1.12 0 1.937.404 2.542 1.008.112.112.18.27.18.437a.602.602 0 0 1-.606.605.618.618 0 0 1-.436-.18 2.359 2.359 0 0 0-1.68-.705c-1.479 0-2.576 1.131-2.576 2.7 0 1.567 1.097 2.71 2.576 2.71.761 0 1.433-.359 1.77-.672v-1.165h-1.714a.586.586 0 0 1-.583-.582c0-.314.269-.572.583-.572h2.33zm6.26-1.467c.325 0 .594.269.594.594v4.357a.595.595 0 0 1-.583.593.598.598 0 0 1-.593-.593v-.18a2.628 2.628 0 0 1-1.916.84c-1.164 0-1.736-.604-1.736-1.713v-3.304c0-.325.27-.594.594-.594.314 0 .582.269.582.594v2.878c0 .84.426 1.098 1.087 1.098.593 0 1.109-.336 1.389-.706v-3.27c0-.325.268-.594.582-.594zm4.558 5.611c-1.713 0-2.777-1.288-2.777-2.844 0-1.546 1.064-2.834 2.777-2.834 1.736 0 2.79 1.288 2.79 2.834 0 1.556-1.054 2.844-2.79 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.996 0-1.556.84-1.556 1.792 0 .963.56 1.803 1.556 1.803z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M39.508 30.034a.348.348 0 0 1-.353-.345v-4.922c0-.235.135-.37.37-.37h1.881c1.126 0 1.756.773 1.756 1.689 0 .915-.647 1.688-1.756 1.688h-1.554v1.915c0 .185-.16.345-.344.345zm2.932-3.948c0-.63-.454-1.067-1.118-1.067h-1.47v2.133h1.47c.664 0 1.118-.436 1.118-1.066zm3.36-.21c.184 0 .285.142.285.302 0 .151-.126.286-.344.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V26.22a.316.316 0 0 1 .63 0v.378c.243-.328.58-.596.907-.68.084-.026.134-.042.202-.042zm2.805 4.225c-1.235 0-2.007-.958-2.007-2.134s.772-2.125 2.007-2.125 2.008.95 2.008 2.125c0 1.176-.773 2.134-2.008 2.134zm0-.563c.865 0 1.344-.74 1.344-1.57 0-.824-.479-1.563-1.344-1.563-.865 0-1.352.739-1.352 1.562 0 .832.487 1.571 1.352 1.571zm6.283-5.174c.177 0 .32.142.32.31v5.049a.316.316 0 0 1-.63 0v-.328a1.708 1.708 0 0 1-1.37.706c-1.058 0-1.806-.807-1.806-2.125 0-1.294.74-2.134 1.806-2.134.546 0 1.034.269 1.37.722v-1.89c0-.168.142-.31.31-.31zm-1.528 5.174c.504 0 .99-.286 1.218-.638v-1.84a1.523 1.523 0 0 0-1.218-.655c-.815 0-1.302.672-1.302 1.57 0 .9.487 1.563 1.302 1.563zm6.157-3.629c.176 0 .319.143.319.311v3.503a.316.316 0 0 1-.63 0v-.286c-.31.345-.832.664-1.445.664-.848 0-1.293-.412-1.293-1.294V26.22a.316.316 0 0 1 .63 0v2.394c0 .714.36.924.907.924.495 0 .966-.286 1.201-.613V26.22c0-.168.143-.31.31-.31zm1.344 2.058c0-1.201.815-2.125 2.024-2.125.588 0 .983.193 1.302.504.05.05.093.126.093.21 0 .16-.126.286-.286.286a.266.266 0 0 1-.185-.076 1.179 1.179 0 0 0-.89-.361c-.865 0-1.403.663-1.403 1.562s.538 1.571 1.403 1.571c.344 0 .63-.1.882-.361a.266.266 0 0 1 .193-.076c.16 0 .286.126.286.286a.29.29 0 0 1-.093.21c-.319.31-.714.504-1.302.504-1.21 0-2.024-.924-2.024-2.134zm5.88 1.495c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.32.135-.571.135-.597 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.278-.277.28.28 0 0 1 .278-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.15 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.134.521.412.521.176 0 .235-.076.319-.076zm7.131.034c.034.05.068.11.068.218a.34.34 0 0 1-.336.32.358.358 0 0 1-.294-.143l-1.462-2.117h-1.235v1.915a.348.348 0 1 1-.697 0v-4.922c0-.235.134-.37.37-.37h1.881c1.025 0 1.756.655 1.756 1.689 0 .957-.622 1.503-1.336 1.612l1.285 1.798zm-3.259-4.477v2.142h1.47c.664 0 1.117-.445 1.117-1.075 0-.63-.453-1.067-1.117-1.067h-1.47zm3.898 2.948c0-1.176.84-2.125 1.999-2.125 1.226 0 1.949.958 1.949 2.016 0 .202-.135.32-.37.32h-2.915c.05.764.588 1.402 1.462 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.042.16-.109.21a2.3 2.3 0 0 1-1.445.479c-1.201 0-2.066-.865-2.066-2.134zm1.99-1.604c-.865 0-1.293.73-1.327 1.352h2.663c-.008-.605-.411-1.352-1.335-1.352zm2.806 3.259a.268.268 0 0 1-.117-.227.28.28 0 0 1 .277-.277c.059 0 .117.017.168.05.294.244.697.42 1.15.42.622 0 .958-.277.958-.672 0-.445-.495-.588-1.041-.722-.69-.16-1.47-.344-1.47-1.184 0-.63.546-1.168 1.512-1.168.58 0 1.016.185 1.344.445.058.05.109.126.109.21a.276.276 0 0 1-.269.269.262.262 0 0 1-.151-.059c-.252-.218-.613-.353-1.033-.353-.555 0-.9.252-.9.614 0 .394.463.52.992.646.706.16 1.52.362 1.52 1.26 0 .68-.546 1.227-1.596 1.227-.562 0-1.05-.151-1.453-.479zm3.839-1.655c0-1.176.84-2.125 2-2.125 1.226 0 1.948.958 1.948 2.016 0 .202-.134.32-.37.32H83.81c.05.764.588 1.402 1.461 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.042.16-.109.21a2.3 2.3 0 0 1-1.445.479c-1.2 0-2.066-.865-2.066-2.134zm1.99-1.604c-.864 0-1.293.73-1.326 1.352h2.662c-.008-.605-.411-1.352-1.335-1.352zm4.57-.521c.857 0 1.571.386 1.571 1.37v2.51c0 .169-.143.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.689 0-1.42-.462-1.42-1.344 0-.907.731-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.437-.857-1.025-.857-.403 0-.739.118-1.058.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.411-.361.882-.529 1.461-.529zm-.176 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm4.746-3.771c.185 0 .286.142.286.302 0 .151-.126.286-.345.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V26.22a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm.798 2.091c0-1.201.815-2.125 2.024-2.125.588 0 .983.193 1.302.504.05.05.093.126.093.21 0 .16-.126.286-.286.286a.266.266 0 0 1-.185-.076 1.179 1.179 0 0 0-.89-.361c-.865 0-1.403.663-1.403 1.562s.538 1.571 1.403 1.571c.344 0 .63-.1.882-.361a.266.266 0 0 1 .193-.076c.16 0 .286.126.286.286a.29.29 0 0 1-.093.21c-.319.31-.714.504-1.302.504-1.21 0-2.024-.924-2.024-2.134zm7.45 2.067a.316.316 0 0 1-.31-.311v-2.394c0-.714-.37-.924-.916-.924-.487 0-.957.302-1.2.63v2.688a.316.316 0 0 1-.63 0v-5.049c0-.168.142-.31.318-.31.168 0 .311.142.311.31v1.857c.286-.336.84-.689 1.453-.689.849 0 1.294.412 1.294 1.294v2.587c0 .168-.143.31-.32.31zm1.345-2.067c0-1.176.84-2.125 1.999-2.125 1.226 0 1.949.958 1.949 2.016 0 .202-.135.32-.37.32h-2.915c.05.764.588 1.402 1.462 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.042.16-.109.21a2.3 2.3 0 0 1-1.445.479c-1.201 0-2.066-.865-2.066-2.134zm1.99-1.604c-.865 0-1.293.73-1.327 1.352h2.663c-.008-.605-.411-1.352-1.335-1.352zm4.713-.487c.185 0 .286.142.286.302 0 .151-.126.286-.345.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V26.22a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm4.796-.034c.857 0 1.571.386 1.571 1.37v2.51c0 .169-.143.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.689 0-1.42-.462-1.42-1.344 0-.907.731-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.437-.857-1.025-.857-.403 0-.739.118-1.058.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.411-.361.882-.529 1.461-.529zm-.176 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm4.494-.185c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076zm3.545.538c-.235 0-.37-.134-.37-.37v-4.863c0-.235.135-.37.37-.37h1.545c1.74 0 2.873 1.218 2.873 2.806 0 1.596-1.134 2.797-2.873 2.797h-1.545zm.327-.622h1.218c1.361 0 2.15-.974 2.15-2.175 0-1.21-.764-2.184-2.15-2.184h-1.218v4.36zm6.897-3.502c.185 0 .285.142.285.302 0 .151-.126.286-.344.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V26.22a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm1.344-.756a.421.421 0 0 1-.42-.42c0-.236.193-.429.42-.429a.43.43 0 0 1 .428.429c0 .235-.193.42-.428.42zm0 4.914a.316.316 0 0 1-.311-.311V26.22a.316.316 0 0 1 .63 0v3.503c0 .168-.143.31-.32.31zm3.326-5.67c.11.033.193.126.193.252 0 .142-.084.252-.252.252-.058 0-.142-.034-.243-.034-.412 0-.639.286-.639.798v.31h.58a.28.28 0 0 1 .277.278.28.28 0 0 1-.277.277h-.58v3.226a.316.316 0 0 1-.63 0v-3.226h-.428a.287.287 0 0 1-.286-.277c0-.151.135-.277.286-.277h.428v-.311c0-.84.47-1.319 1.176-1.319.143 0 .27.017.395.05zm2.117 5.098c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076z",
          fill: "#7695A5" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "url(#e)", xlinkHref: "#d", transform: "translate(5.6 5.6)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "rotate(-3 267.377 -4523.427)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "142.8", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M39.99 16.6c-.448 0-.695-.246-.695-.694V9.723c0-.358.291-.66.661-.66a.66.66 0 0 1 .65.66v5.723h2.777c.314 0 .583.258.583.572a.586.586 0 0 1-.583.582H39.99zm4.558-2.71c0-1.568 1.142-2.834 2.744-2.834 1.624 0 2.666 1.243 2.666 2.677 0 .347-.247.549-.695.549H45.78c.09.817.706 1.49 1.725 1.49.392 0 .851-.124 1.232-.36a.464.464 0 0 1 .257-.066c.258 0 .47.212.47.47 0 .168-.089.302-.212.392-.538.358-1.187.526-1.87.526-1.624 0-2.834-1.13-2.834-2.844zm2.744-1.87c-1.008 0-1.467.772-1.523 1.433h3.046c-.022-.639-.459-1.434-1.523-1.434zm10.08-.964c.997 0 1.557.538 1.557 1.635v3.383a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-3.002c0-.582-.258-.974-.885-.974-.526 0-1.02.37-1.254.716v3.26a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-3.002c0-.582-.258-.974-.896-.974-.516 0-.997.37-1.244.728v3.248a.595.595 0 0 1-.582.593.598.598 0 0 1-.594-.593v-4.357c0-.325.27-.594.583-.594.325 0 .593.269.593.594v.213c.224-.325.941-.874 1.759-.874.806 0 1.299.403 1.478.997.314-.493 1.03-.997 1.837-.997zm3.662-.918a.734.734 0 0 1-.728-.728c0-.404.336-.728.728-.728.404 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.582-.594v-4.357c0-.325.269-.594.594-.594.313 0 .582.269.582.594v4.357a.598.598 0 0 1-.594.593zm5.724-.068c-.448 0-.695-.246-.695-.694V9.824c0-.448.247-.694.695-.694h2.979c1.366 0 2.128.85 2.128 1.904 0 .94-.605 1.568-1.3 1.713.796.123 1.445.919 1.445 1.837 0 1.154-.772 2.016-2.172 2.016h-3.08zm.616-4.38h2.094c.672 0 1.053-.402 1.053-.962 0-.56-.381-.975-1.053-.975h-2.094v1.938zm0 3.226h2.15c.717 0 1.142-.392 1.142-1.041 0-.56-.392-1.03-1.142-1.03h-2.15v2.071zm8.355 1.288c-1.714 0-2.778-1.288-2.778-2.844 0-1.546 1.064-2.834 2.778-2.834 1.736 0 2.789 1.288 2.789 2.834 0 1.556-1.053 2.844-2.79 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.997 0-1.557.84-1.557 1.792 0 .963.56 1.803 1.557 1.803zm3.752 2.576c0-.291.269-.515.56-.515h.056c.37 0 .616-.112.773-.47l.268-.617-1.926-4.749a.652.652 0 0 1-.034-.212c0-.325.258-.583.572-.583a.59.59 0 0 1 .548.37l1.456 3.752 1.456-3.752a.59.59 0 0 1 .55-.37.578.578 0 0 1 .537.807l-2.307 5.644c-.37.919-1.02 1.21-1.86 1.221-.044 0-.1 0-.168-.011a.515.515 0 0 1-.481-.515zm5.521-4.38c0-1.635 1.154-2.833 2.8-2.833.762 0 1.31.235 1.714.582a.526.526 0 0 1-.336.93.525.525 0 0 1-.347-.123 1.444 1.444 0 0 0-.975-.347c-.985 0-1.635.739-1.635 1.792 0 1.052.65 1.803 1.635 1.803.381 0 .695-.112.975-.347a.517.517 0 0 1 .336-.124c.302 0 .537.236.537.527a.534.534 0 0 1-.19.403c-.403.347-.952.582-1.714.582-1.646 0-2.8-1.198-2.8-2.844zm5.567 0c0-1.567 1.142-2.833 2.744-2.833 1.624 0 2.665 1.243 2.665 2.677 0 .347-.246.549-.694.549h-3.483c.09.817.705 1.49 1.725 1.49.392 0 .85-.124 1.232-.36a.464.464 0 0 1 .257-.066c.258 0 .47.212.47.47 0 .168-.089.302-.212.392-.538.358-1.187.526-1.87.526-1.625 0-2.834-1.13-2.834-2.844zm2.744-1.87c-1.008 0-1.467.773-1.523 1.434h3.046c-.022-.639-.46-1.434-1.523-1.434z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M39.038 28.72a.353.353 0 0 1-.126-.26c0-.193.15-.344.336-.344.075 0 .16.025.21.075.378.328.89.588 1.537.588 1 0 1.319-.537 1.319-.966 0-.672-.68-.857-1.42-1.058-.899-.235-1.898-.487-1.898-1.588 0-.924.823-1.554 1.974-1.554.705 0 1.243.202 1.73.58.092.059.143.16.143.269a.341.341 0 0 1-.328.336.31.31 0 0 1-.201-.076 2.157 2.157 0 0 0-1.395-.487c-.722 0-1.201.361-1.201.89 0 .563.647.731 1.36.924.916.244 1.958.53 1.958 1.705 0 .815-.554 1.647-2.066 1.647-.824 0-1.47-.269-1.932-.68zm6.787.68c-1.235 0-2.008-.957-2.008-2.133 0-1.176.773-2.125 2.008-2.125 1.235 0 2.007.95 2.007 2.125 0 1.176-.772 2.134-2.007 2.134zm0-.562c.865 0 1.344-.74 1.344-1.57 0-.824-.479-1.563-1.344-1.563-.865 0-1.353.739-1.353 1.562 0 .832.488 1.571 1.353 1.571zm4.78-5.174c.109.033.193.126.193.252 0 .142-.084.252-.252.252-.06 0-.143-.034-.244-.034-.412 0-.638.286-.638.798v.31h.58a.28.28 0 0 1 .276.278.28.28 0 0 1-.277.277h-.58v3.226a.316.316 0 0 1-.63 0v-3.226h-.428a.287.287 0 0 1-.285-.277c0-.151.134-.277.285-.277h.429v-.311c0-.84.47-1.319 1.176-1.319.142 0 .268.017.394.05zm2.116 5.098c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.142.084-.319.135-.57.135-.597 0-.9-.345-.9-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .286.126.286.277a.287.287 0 0 1-.286.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.32-.076zm4.805.572a.406.406 0 0 1-.395-.294l-.974-3-.975 3a.406.406 0 0 1-.394.294.416.416 0 0 1-.404-.294l-1.092-3.42c-.008-.033-.016-.066-.016-.1a.31.31 0 0 1 .31-.31.31.31 0 0 1 .303.218l.932 3.049.991-3.024a.353.353 0 0 1 .345-.244c.16 0 .294.093.344.244l.991 3.024.933-3.05a.31.31 0 0 1 .302-.218.316.316 0 0 1 .294.42l-1.092 3.41a.416.416 0 0 1-.403.295zm3.94-4.192c.856 0 1.57.386 1.57 1.37v2.51c0 .169-.142.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.688 0-1.42-.462-1.42-1.344 0-.907.732-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.436-.857-1.024-.857-.404 0-.74.118-1.059.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.412-.361.882-.529 1.462-.529zm-.177 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm4.746-3.771c.185 0 .286.142.286.302 0 .151-.126.286-.345.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.908-.68.084-.026.134-.042.201-.042zm.798 2.091c0-1.176.84-2.125 2-2.125 1.226 0 1.948.958 1.948 2.016 0 .202-.134.32-.37.32h-2.914c.05.764.588 1.402 1.461 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.041.16-.109.21a2.3 2.3 0 0 1-1.444.479c-1.202 0-2.067-.865-2.067-2.134zm1.991-1.604c-.865 0-1.294.73-1.327 1.352h2.663c-.009-.605-.412-1.352-1.336-1.352zM74.36 29.3c-.236 0-.37-.134-.37-.37v-4.863c0-.235.134-.37.37-.37h3.024c.168 0 .319.143.319.311s-.151.31-.32.31h-2.696v1.807h2.638c.168 0 .319.143.319.31 0 .169-.151.311-.32.311h-2.637v1.932h2.697c.168 0 .319.143.319.311s-.151.311-.32.311H74.36zm6.46-4.158c.848 0 1.293.428 1.293 1.31v2.57a.316.316 0 0 1-.63 0v-2.376c0-.714-.361-.941-.907-.941-.496 0-.966.302-1.202.63v2.688a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.32c.278-.337.824-.698 1.445-.698zm5.804.067c.168 0 .31.143.31.311v3.662c0 1.344-.94 1.764-1.932 1.764-.596 0-1.024-.1-1.47-.462a.292.292 0 0 1-.109-.218.28.28 0 0 1 .277-.277c.06 0 .118.025.16.059.32.268.664.378 1.142.378.672 0 1.302-.328 1.302-1.218v-.572c-.302.412-.798.714-1.36.714-1.059 0-1.806-.79-1.806-2.1 0-1.302.739-2.108 1.806-2.108.546 0 1.033.269 1.36.722v-.344c0-.168.143-.31.32-.31zm-1.53 3.587c.505 0 .992-.31 1.21-.664V26.36c-.218-.353-.705-.655-1.21-.655-.814 0-1.301.647-1.301 1.545 0 .89.487 1.546 1.302 1.546zm3.411-4.376a.421.421 0 0 1-.42-.42c0-.236.193-.429.42-.429a.43.43 0 0 1 .429.429c0 .235-.194.42-.429.42zm0 4.914a.316.316 0 0 1-.31-.311V25.52a.316.316 0 0 1 .63 0v3.503c0 .168-.143.31-.32.31zm3.654-4.192c.849 0 1.294.428 1.294 1.31v2.57a.316.316 0 0 1-.63 0v-2.376c0-.714-.361-.941-.907-.941-.496 0-.966.302-1.202.63v2.688a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.32c.278-.337.824-.698 1.445-.698zm2.319 2.125c0-1.176.84-2.125 1.999-2.125 1.226 0 1.949.958 1.949 2.016 0 .202-.135.32-.37.32h-2.915c.05.764.588 1.402 1.462 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.142 0 .26.11.26.252 0 .084-.042.16-.11.21a2.3 2.3 0 0 1-1.444.479c-1.201 0-2.066-.865-2.066-2.134zm1.99-1.604c-.865 0-1.293.73-1.327 1.352h2.663c-.008-.605-.412-1.352-1.336-1.352zm2.739 1.604c0-1.176.84-2.125 1.999-2.125 1.226 0 1.949.958 1.949 2.016 0 .202-.135.32-.37.32H99.87c.05.764.588 1.402 1.462 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.042.16-.109.21a2.3 2.3 0 0 1-1.445.479c-1.201 0-2.066-.865-2.066-2.134zm1.99-1.604c-.865 0-1.293.73-1.327 1.352h2.663c-.008-.605-.411-1.352-1.335-1.352zm4.713-.487c.185 0 .286.142.286.302 0 .151-.126.286-.345.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm4.796-.034c.857 0 1.571.386 1.571 1.37v2.51c0 .169-.143.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.689 0-1.42-.462-1.42-1.344 0-.907.731-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.437-.857-1.025-.857-.403 0-.739.118-1.058.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.411-.361.882-.529 1.461-.529zm-.176 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm4.494-.185c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076zm3.545.538c-.235 0-.37-.134-.37-.37v-4.863c0-.235.135-.37.37-.37h1.545c1.74 0 2.873 1.218 2.873 2.806 0 1.596-1.134 2.797-2.873 2.797h-1.545zm.327-.622h1.218c1.361 0 2.15-.974 2.15-2.175 0-1.21-.764-2.184-2.15-2.184h-1.218v4.36zm6.897-3.502c.185 0 .285.142.285.302 0 .151-.126.286-.344.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm1.344-.756a.421.421 0 0 1-.42-.42c0-.236.193-.429.42-.429a.43.43 0 0 1 .428.429c0 .235-.193.42-.428.42zm0 4.914a.316.316 0 0 1-.311-.311V25.52a.316.316 0 0 1 .63 0v3.503c0 .168-.143.31-.32.31zm3.326-5.67c.11.033.193.126.193.252 0 .142-.084.252-.252.252-.058 0-.142-.034-.243-.034-.412 0-.639.286-.639.798v.31h.58a.28.28 0 0 1 .277.278.28.28 0 0 1-.277.277h-.58v3.226a.316.316 0 0 1-.63 0v-3.226h-.428a.287.287 0 0 1-.286-.277c0-.151.135-.277.286-.277h.428v-.311c0-.84.47-1.319 1.176-1.319.143 0 .27.017.395.05zm2.117 5.098c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076z",
          fill: "#7695A5" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "25.9", height: "26.026", rx: "2.1", transform: "translate(5.6 5.6)",
          fill: "url(#f)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(261 23)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "142.1", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M39.99 16.6c-.448 0-.695-.246-.695-.694V9.824c0-.448.247-.694.695-.694h2.083c2.33 0 3.909 1.545 3.909 3.74 0 2.196-1.58 3.73-3.91 3.73H39.99zm.616-1.154h1.467c1.624 0 2.565-1.164 2.565-2.576 0-1.444-.896-2.587-2.565-2.587h-1.467v5.163zm8.836-4.39c1.199 0 2.252.504 2.252 1.96v3.058a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-.056c-.404.459-1.03.716-1.748.716-.884 0-1.881-.593-1.881-1.792 0-1.243.997-1.758 1.881-1.758.728 0 1.356.235 1.748.694v-.806c0-.627-.516-1.008-1.266-1.008-.46 0-.862.123-1.266.403a.507.507 0 0 1-.268.079.473.473 0 0 1-.47-.47c0-.158.089-.303.2-.382a3.282 3.282 0 0 1 1.994-.638zm-.212 4.872c.515 0 1.019-.19 1.288-.56v-.818c-.27-.37-.773-.56-1.288-.56-.661 0-1.154.381-1.154.975 0 .582.493.963 1.154.963zm7.067-4.872c1.165 0 1.747.627 1.747 1.736v3.282a.598.598 0 0 1-.594.593.595.595 0 0 1-.582-.593v-2.856c0-.84-.426-1.12-1.086-1.12-.605 0-1.12.358-1.39.728v3.248a.595.595 0 0 1-.582.593.598.598 0 0 1-.593-.593v-4.357c0-.325.269-.594.582-.594.325 0 .594.269.594.594v.213a2.56 2.56 0 0 1 1.904-.874zm12.029 5.611a.66.66 0 0 1-.65-.66V13.34H63.79v2.665a.66.66 0 0 1-.65.661.662.662 0 0 1-.66-.66V9.722a.66.66 0 0 1 .649-.66c.37 0 .66.302.66.66v2.464h3.887V9.723c0-.358.291-.66.66-.66a.66.66 0 0 1 .65.66v6.283c0 .359-.29.661-.66.661zm4.659.067c-1.714 0-2.778-1.288-2.778-2.844 0-1.546 1.064-2.834 2.778-2.834 1.736 0 2.789 1.288 2.789 2.834 0 1.556-1.053 2.844-2.79 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.997 0-1.557.84-1.557 1.792 0 .963.56 1.803 1.557 1.803zm4.57.974a.598.598 0 0 1-.594-.593V9.656c0-.325.269-.594.593-.594.314 0 .583.27.583.594v6.418a.595.595 0 0 1-.583.593zm2.699 0a.598.598 0 0 1-.594-.593V9.656c0-.325.269-.594.594-.594.313 0 .582.27.582.594v6.418a.595.595 0 0 1-.582.593zm1.77-2.777c0-1.568 1.142-2.834 2.743-2.834 1.624 0 2.666 1.243 2.666 2.677 0 .347-.247.549-.695.549h-3.483c.09.817.706 1.49 1.725 1.49.392 0 .851-.124 1.232-.36a.464.464 0 0 1 .258-.066c.257 0 .47.212.47.47 0 .168-.09.302-.213.392-.537.358-1.187.526-1.87.526-1.624 0-2.834-1.13-2.834-2.844zm2.743-1.87c-1.008 0-1.467.772-1.523 1.433h3.046c-.022-.639-.459-1.434-1.523-1.434zm3.607 6.249c0-.291.268-.515.56-.515h.056c.37 0 .616-.112.772-.47l.27-.617-1.927-4.749a.652.652 0 0 1-.034-.212c0-.325.258-.583.571-.583a.59.59 0 0 1 .55.37l1.455 3.752 1.456-3.752a.59.59 0 0 1 .549-.37.578.578 0 0 1 .538.807l-2.308 5.644c-.37.919-1.019 1.21-1.859 1.221-.045 0-.1 0-.168-.011a.515.515 0 0 1-.481-.515z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M39.508 29.334a.348.348 0 0 1-.353-.345v-4.922c0-.235.135-.37.37-.37h1.881c1.126 0 1.756.773 1.756 1.689 0 .915-.647 1.688-1.756 1.688h-1.554v1.915c0 .185-.16.345-.344.345zm2.932-3.948c0-.63-.454-1.067-1.118-1.067h-1.47v2.133h1.47c.664 0 1.118-.436 1.118-1.066zm3.36-.21c.184 0 .285.142.285.302 0 .151-.126.286-.344.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.243-.328.58-.596.907-.68.084-.026.134-.042.202-.042zm2.805 4.225c-1.235 0-2.007-.958-2.007-2.134s.772-2.125 2.007-2.125 2.008.95 2.008 2.125c0 1.176-.773 2.134-2.008 2.134zm0-.563c.865 0 1.344-.74 1.344-1.57 0-.824-.479-1.563-1.344-1.563-.865 0-1.352.739-1.352 1.562 0 .832.487 1.571 1.352 1.571zm6.283-5.174c.177 0 .32.142.32.31v5.049a.316.316 0 0 1-.63 0v-.328a1.708 1.708 0 0 1-1.37.706c-1.058 0-1.806-.807-1.806-2.125 0-1.294.74-2.134 1.806-2.134.546 0 1.034.269 1.37.722v-1.89c0-.168.142-.31.31-.31zm-1.528 5.174c.504 0 .99-.286 1.218-.638v-1.84a1.523 1.523 0 0 0-1.218-.655c-.815 0-1.302.672-1.302 1.57 0 .9.487 1.563 1.302 1.563zm6.157-3.629c.176 0 .319.143.319.311v3.503a.316.316 0 0 1-.63 0v-.286c-.31.345-.832.664-1.445.664-.848 0-1.293-.412-1.293-1.294V25.52a.316.316 0 0 1 .63 0v2.394c0 .714.36.924.907.924.495 0 .966-.286 1.201-.613V25.52c0-.168.143-.31.31-.31zm1.344 2.058c0-1.201.815-2.125 2.024-2.125.588 0 .983.193 1.302.504.05.05.093.126.093.21 0 .16-.126.286-.286.286a.266.266 0 0 1-.185-.076 1.179 1.179 0 0 0-.89-.361c-.865 0-1.403.663-1.403 1.562s.538 1.571 1.403 1.571c.344 0 .63-.1.882-.361a.266.266 0 0 1 .193-.076c.16 0 .286.126.286.286a.29.29 0 0 1-.093.21c-.319.31-.714.504-1.302.504-1.21 0-2.024-.924-2.024-2.134zm5.88 1.495c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.32.135-.571.135-.597 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.278-.277.28.28 0 0 1 .278-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.15 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.134.521.412.521.176 0 .235-.076.319-.076zm8.307.572a.352.352 0 0 1-.344-.345v-4.351l-1.856 4.553c-.034.092-.101.143-.194.143a.204.204 0 0 1-.193-.143l-1.848-4.553v4.351a.348.348 0 1 1-.697 0v-4.737c0-.32.26-.588.588-.588.252 0 .462.15.546.37l1.604 3.956 1.613-3.957a.578.578 0 0 1 .546-.37.59.59 0 0 1 .588.589v4.737a.348.348 0 0 1-.353.345zm3.234-4.192c.857 0 1.571.386 1.571 1.37v2.51c0 .169-.143.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.689 0-1.42-.462-1.42-1.344 0-.907.731-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.437-.857-1.025-.857-.403 0-.739.118-1.058.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.411-.361.882-.529 1.461-.529zm-.176 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm5.082-3.805c.848 0 1.294.428 1.294 1.31v2.57a.316.316 0 0 1-.63 0v-2.376c0-.714-.362-.941-.908-.941-.495 0-.966.302-1.2.63v2.688a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.32c.276-.337.822-.698 1.444-.698zm4.15 0c.856 0 1.57.386 1.57 1.37v2.51c0 .169-.142.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.688 0-1.42-.462-1.42-1.344 0-.907.732-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.436-.857-1.024-.857-.404 0-.74.118-1.059.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.412-.361.882-.529 1.462-.529zm-.177 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm6.258-3.738c.168 0 .311.143.311.311v3.662c0 1.344-.94 1.764-1.932 1.764-.596 0-1.025-.1-1.47-.462a.292.292 0 0 1-.11-.218.28.28 0 0 1 .278-.277c.059 0 .118.025.16.059.319.268.663.378 1.142.378.672 0 1.302-.328 1.302-1.218v-.572c-.302.412-.798.714-1.36.714-1.06 0-1.807-.79-1.807-2.1 0-1.302.74-2.108 1.806-2.108.546 0 1.033.269 1.361.722v-.344c0-.168.143-.31.32-.31zm-1.529 3.587c.504 0 .992-.31 1.21-.664V26.36c-.218-.353-.706-.655-1.21-.655-.814 0-1.302.647-1.302 1.545 0 .89.488 1.546 1.302 1.546zm2.865-1.529c0-1.176.84-2.125 1.999-2.125 1.226 0 1.949.958 1.949 2.016 0 .202-.135.32-.37.32h-2.915c.05.764.588 1.402 1.462 1.402.395 0 .773-.134 1.092-.386a.276.276 0 0 1 .143-.034c.143 0 .26.11.26.252 0 .084-.042.16-.109.21a2.3 2.3 0 0 1-1.445.479c-1.201 0-2.066-.865-2.066-2.134zm1.99-1.604c-.865 0-1.293.73-1.327 1.352h2.663c-.008-.605-.411-1.352-1.335-1.352zm4.713-.487c.185 0 .286.142.286.302 0 .151-.126.286-.345.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm4.796-.034c.857 0 1.571.386 1.571 1.37v2.51c0 .169-.143.312-.319.312a.316.316 0 0 1-.31-.311v-.185c-.32.37-.79.563-1.345.563-.689 0-1.42-.462-1.42-1.344 0-.907.731-1.336 1.42-1.336.555 0 1.017.177 1.344.555v-.731c0-.546-.437-.857-1.025-.857-.403 0-.739.118-1.058.403a.331.331 0 0 1-.168.05.262.262 0 0 1-.26-.26c0-.084.05-.168.109-.21.411-.361.882-.529 1.461-.529zm-.176 3.805c.445 0 .874-.168 1.117-.504v-.764c-.243-.336-.672-.504-1.117-.504-.588 0-1 .37-1 .89 0 .513.412.882 1 .882zm4.494-.185c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076zm3.545.538c-.235 0-.37-.134-.37-.37v-4.863c0-.235.135-.37.37-.37h1.545c1.74 0 2.873 1.218 2.873 2.806 0 1.596-1.134 2.797-2.873 2.797h-1.545zm.327-.622h1.218c1.361 0 2.15-.974 2.15-2.175 0-1.21-.764-2.184-2.15-2.184h-1.218v4.36zm6.897-3.502c.185 0 .285.142.285.302 0 .151-.126.286-.344.31-.37.026-.865.312-1.05.64v2.595a.316.316 0 0 1-.63 0V25.52a.316.316 0 0 1 .63 0v.378c.244-.328.58-.596.907-.68.084-.026.135-.042.202-.042zm1.344-.756a.421.421 0 0 1-.42-.42c0-.236.193-.429.42-.429a.43.43 0 0 1 .428.429c0 .235-.193.42-.428.42zm0 4.914a.316.316 0 0 1-.311-.311V25.52a.316.316 0 0 1 .63 0v3.503c0 .168-.143.31-.32.31zm3.326-5.67c.11.033.193.126.193.252 0 .142-.084.252-.252.252-.058 0-.142-.034-.243-.034-.412 0-.639.286-.639.798v.31h.58a.28.28 0 0 1 .277.278.28.28 0 0 1-.277.277h-.58v3.226a.316.316 0 0 1-.63 0v-3.226h-.428a.287.287 0 0 1-.286-.277c0-.151.135-.277.286-.277h.428v-.311c0-.84.47-1.319 1.176-1.319.143 0 .27.017.395.05zm2.117 5.098c.16 0 .269.11.269.27a.238.238 0 0 1-.16.234c-.143.084-.319.135-.571.135-.596 0-.899-.345-.899-.95v-2.654h-.428a.28.28 0 0 1-.277-.277.28.28 0 0 1 .277-.277h.428v-.832a.316.316 0 0 1 .63 0v.832h.58c.151 0 .285.126.285.277a.287.287 0 0 1-.285.277h-.58v2.52c0 .303.135.521.412.521.176 0 .235-.076.319-.076z",
          fill: "#7695A5" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "25.9", height: "26.026", rx: "2.1", transform: "translate(5.6 5.6)",
          fill: "url(#g)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(0 13.457)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "142.1", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M38.717 22.317a.624.624 0 1 1 .75-.997c.515.38 1.154.65 1.938.65 1.075 0 1.5-.527 1.5-1.02 0-.672-.795-.873-1.702-1.108-1.22-.303-2.654-.661-2.654-2.24 0-1.232 1.086-2.184 2.833-2.184.874 0 1.58.224 2.308.683.168.1.28.291.28.504 0 .336-.28.616-.616.616a.584.584 0 0 1-.348-.112 3.173 3.173 0 0 0-1.736-.527c-.884 0-1.377.37-1.377.93 0 .582.761.773 1.646.997 1.232.313 2.7.694 2.7 2.318 0 1.243-.874 2.307-2.89 2.307-1.109 0-1.971-.313-2.632-.817zm7.28-5.78a.734.734 0 0 1-.728-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.008a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm1.02-1.77c0-1.567 1.142-2.833 2.743-2.833 1.624 0 2.666 1.243 2.666 2.677 0 .347-.246.549-.694.549h-3.484c.09.817.706 1.49 1.725 1.49.392 0 .851-.124 1.232-.36a.464.464 0 0 1 .258-.066c.257 0 .47.212.47.47 0 .168-.09.302-.213.392-.537.358-1.187.526-1.87.526-1.624 0-2.834-1.13-2.834-2.844zm2.743-1.87c-1.008 0-1.467.773-1.523 1.434h3.047c-.023-.639-.46-1.434-1.524-1.434zm9.71 4.648c-.492 0-.918-.313-1.086-.739L60.4 16.403a.61.61 0 0 1-.056-.246c0-.381.314-.695.694-.695.292 0 .55.18.65.448l2.117 5.668 2.117-5.668a.692.692 0 0 1 .65-.448c.38 0 .694.314.694.695a.61.61 0 0 1-.056.246l-2.319 5.925c-.168.426-.593.74-1.086.74zm5.12-6.53a.734.734 0 0 1-.729-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.269-.594.593-.594.314 0 .583.269.583.594v4.357a.598.598 0 0 1-.594.593zm1.97-.504a.502.502 0 0 1 .28-.918c.101 0 .202.033.28.078.426.28.964.482 1.49.482.706 0 1.064-.258 1.064-.661 0-.47-.571-.638-1.232-.784-.93-.202-2.038-.448-2.038-1.658 0-.884.761-1.646 2.128-1.646.728 0 1.321.202 1.803.526.123.09.213.224.213.392 0 .258-.213.47-.47.47a.498.498 0 0 1-.258-.078 2.376 2.376 0 0 0-1.277-.37c-.616 0-1.008.225-1.008.606 0 .414.537.56 1.176.705.94.202 2.094.47 2.094 1.747 0 .952-.795 1.68-2.251 1.68-.74 0-1.434-.19-1.994-.57zm6.015-6.025a.734.734 0 0 1-.728-.728c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.594v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.009a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm3.797 1.075c-1.714 0-2.778-1.288-2.778-2.844 0-1.546 1.064-2.834 2.778-2.834 1.736 0 2.789 1.288 2.789 2.834 0 1.556-1.053 2.844-2.789 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.997 0-1.557.84-1.557 1.792 0 .963.56 1.803 1.557 1.803zm6.507-4.592c.336 0 .482.257.482.549 0 .268-.202.504-.605.56-.403.056-.997.324-1.232.705v3.159a.595.595 0 0 1-.582.593.598.598 0 0 1-.594-.593v-4.357c0-.325.269-.594.582-.594.325 0 .594.269.594.594v.269c.291-.381.694-.706 1.042-.818a.93.93 0 0 1 .313-.067z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "25.9", height: "26.026", rx: "2.1", transform: "translate(5.6 5.6)",
          fill: "url(#h)" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(12.833 11.7)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "mask",
            { id: "j", fill: "#fff" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#i" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#000", fillRule: "nonzero", xlinkHref: "#i" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { mask: "url(#j)", fill: "#FFF" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M-2.833-1.7h17v17h-17z" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "rotate(10 -.846 187.802)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "120.3", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M38.717 22.317a.624.624 0 1 1 .75-.997c.515.38 1.154.65 1.938.65 1.075 0 1.5-.527 1.5-1.02 0-.672-.795-.873-1.702-1.108-1.22-.303-2.654-.661-2.654-2.24 0-1.232 1.086-2.184 2.833-2.184.874 0 1.58.224 2.308.683.168.1.28.291.28.504 0 .336-.28.616-.616.616a.584.584 0 0 1-.348-.112 3.173 3.173 0 0 0-1.736-.527c-.884 0-1.377.37-1.377.93 0 .582.761.773 1.646.997 1.232.313 2.7.694 2.7 2.318 0 1.243-.874 2.307-2.89 2.307-1.109 0-1.971-.313-2.632-.817zm7.28-5.78a.734.734 0 0 1-.728-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.008a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm1.02-1.77c0-1.567 1.142-2.833 2.743-2.833 1.624 0 2.666 1.243 2.666 2.677 0 .347-.246.549-.694.549h-3.484c.09.817.706 1.49 1.725 1.49.392 0 .851-.124 1.232-.36a.464.464 0 0 1 .258-.066c.257 0 .47.212.47.47 0 .168-.09.302-.213.392-.537.358-1.187.526-1.87.526-1.624 0-2.834-1.13-2.834-2.844zm2.743-1.87c-1.008 0-1.467.773-1.523 1.434h3.047c-.023-.639-.46-1.434-1.524-1.434zm9.71 4.648c-.492 0-.918-.313-1.086-.739L60.4 16.403a.61.61 0 0 1-.056-.246c0-.381.314-.695.694-.695.292 0 .55.18.65.448l2.117 5.668 2.117-5.668a.692.692 0 0 1 .65-.448c.38 0 .694.314.694.695a.61.61 0 0 1-.056.246l-2.319 5.925c-.168.426-.593.74-1.086.74zm5.12-6.53a.734.734 0 0 1-.729-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.269-.594.593-.594.314 0 .583.269.583.594v4.357a.598.598 0 0 1-.594.593zm1.97-.504a.502.502 0 0 1 .28-.918c.101 0 .202.033.28.078.426.28.964.482 1.49.482.706 0 1.064-.258 1.064-.661 0-.47-.571-.638-1.232-.784-.93-.202-2.038-.448-2.038-1.658 0-.884.761-1.646 2.128-1.646.728 0 1.321.202 1.803.526.123.09.213.224.213.392 0 .258-.213.47-.47.47a.498.498 0 0 1-.258-.078 2.376 2.376 0 0 0-1.277-.37c-.616 0-1.008.225-1.008.606 0 .414.537.56 1.176.705.94.202 2.094.47 2.094 1.747 0 .952-.795 1.68-2.251 1.68-.74 0-1.434-.19-1.994-.57zm6.015-6.025a.734.734 0 0 1-.728-.728c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.594v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.009a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm3.797 1.075c-1.714 0-2.778-1.288-2.778-2.844 0-1.546 1.064-2.834 2.778-2.834 1.736 0 2.789 1.288 2.789 2.834 0 1.556-1.053 2.844-2.789 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.997 0-1.557.84-1.557 1.792 0 .963.56 1.803 1.557 1.803zm6.507-4.592c.336 0 .482.257.482.549 0 .268-.202.504-.605.56-.403.056-.997.324-1.232.705v3.159a.595.595 0 0 1-.582.593.598.598 0 0 1-.594-.593v-4.357c0-.325.269-.594.582-.594.325 0 .594.269.594.594v.269c.291-.381.694-.706 1.042-.818a.93.93 0 0 1 .313-.067z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "25.9", height: "26.026", rx: "2.1", transform: "translate(5.6 5.6)",
          fill: "url(#k)" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(12.833 11.7)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "mask",
            { id: "m", fill: "#fff" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#l" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#000", fillRule: "nonzero", xlinkHref: "#l" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { mask: "url(#m)", fill: "#FFF" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M-2.833-1.7h17v17h-17z" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "rotate(-6 263.815 -254.044)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { stroke: "#E1EEF4", strokeWidth: "0.7", fill: "#FFF", x: "0.35", y: "0.35",
          width: "106.3", height: "36.4", rx: "2.1" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M38.717 22.317a.624.624 0 1 1 .75-.997c.515.38 1.154.65 1.938.65 1.075 0 1.5-.527 1.5-1.02 0-.672-.795-.873-1.702-1.108-1.22-.303-2.654-.661-2.654-2.24 0-1.232 1.086-2.184 2.833-2.184.874 0 1.58.224 2.308.683.168.1.28.291.28.504 0 .336-.28.616-.616.616a.584.584 0 0 1-.348-.112 3.173 3.173 0 0 0-1.736-.527c-.884 0-1.377.37-1.377.93 0 .582.761.773 1.646.997 1.232.313 2.7.694 2.7 2.318 0 1.243-.874 2.307-2.89 2.307-1.109 0-1.971-.313-2.632-.817zm7.28-5.78a.734.734 0 0 1-.728-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.008a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm1.02-1.77c0-1.567 1.142-2.833 2.743-2.833 1.624 0 2.666 1.243 2.666 2.677 0 .347-.246.549-.694.549h-3.484c.09.817.706 1.49 1.725 1.49.392 0 .851-.124 1.232-.36a.464.464 0 0 1 .258-.066c.257 0 .47.212.47.47 0 .168-.09.302-.213.392-.537.358-1.187.526-1.87.526-1.624 0-2.834-1.13-2.834-2.844zm2.743-1.87c-1.008 0-1.467.773-1.523 1.434h3.047c-.023-.639-.46-1.434-1.524-1.434zm9.71 4.648c-.492 0-.918-.313-1.086-.739L60.4 16.403a.61.61 0 0 1-.056-.246c0-.381.314-.695.694-.695.292 0 .55.18.65.448l2.117 5.668 2.117-5.668a.692.692 0 0 1 .65-.448c.38 0 .694.314.694.695a.61.61 0 0 1-.056.246l-2.319 5.925c-.168.426-.593.74-1.086.74zm5.12-6.53a.734.734 0 0 1-.729-.727c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.593v-4.357c0-.325.269-.594.593-.594.314 0 .583.269.583.594v4.357a.598.598 0 0 1-.594.593zm1.97-.504a.502.502 0 0 1 .28-.918c.101 0 .202.033.28.078.426.28.964.482 1.49.482.706 0 1.064-.258 1.064-.661 0-.47-.571-.638-1.232-.784-.93-.202-2.038-.448-2.038-1.658 0-.884.761-1.646 2.128-1.646.728 0 1.321.202 1.803.526.123.09.213.224.213.392 0 .258-.213.47-.47.47a.498.498 0 0 1-.258-.078 2.376 2.376 0 0 0-1.277-.37c-.616 0-1.008.225-1.008.606 0 .414.537.56 1.176.705.94.202 2.094.47 2.094 1.747 0 .952-.795 1.68-2.251 1.68-.74 0-1.434-.19-1.994-.57zm6.015-6.025a.734.734 0 0 1-.728-.728c0-.404.336-.728.728-.728.403 0 .728.324.728.728a.727.727 0 0 1-.728.728zm0 6.53a.595.595 0 0 1-.583-.594v-4.357c0-.325.27-.594.594-.594.314 0 .582.269.582.594v4.357a.598.598 0 0 1-.593.593zm4.334-1.009a.47.47 0 0 1 .493.493c0 .224-.123.38-.314.448-.19.078-.448.134-.772.134-.908 0-1.39-.492-1.39-1.388V18.62h-.447a.521.521 0 0 1-.515-.515c0-.28.235-.516.515-.516h.448v-.952c0-.324.269-.593.593-.593.314 0 .583.269.583.593v.952h.65c.28 0 .515.236.515.516s-.236.515-.516.515h-.65v2.833c0 .37.18.639.516.639.134 0 .202-.034.291-.034zm3.797 1.075c-1.714 0-2.778-1.288-2.778-2.844 0-1.546 1.064-2.834 2.778-2.834 1.736 0 2.789 1.288 2.789 2.834 0 1.556-1.053 2.844-2.789 2.844zm0-1.041c1.008 0 1.568-.84 1.568-1.803 0-.952-.56-1.792-1.568-1.792-.997 0-1.557.84-1.557 1.792 0 .963.56 1.803 1.557 1.803zm6.507-4.592c.336 0 .482.257.482.549 0 .268-.202.504-.605.56-.403.056-.997.324-1.232.705v3.159a.595.595 0 0 1-.582.593.598.598 0 0 1-.594-.593v-4.357c0-.325.269-.594.582-.594.325 0 .594.269.594.594v.269c.291-.381.694-.706 1.042-.818a.93.93 0 0 1 .313-.067z",
          fill: "#394F5A" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect", { width: "25.9", height: "26.026", rx: "2.1", transform: "translate(5.6 5.6)",
          fill: "url(#n)" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { transform: "translate(12.833 11.7)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "mask",
            { id: "p", fill: "#fff" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#o" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { fill: "#000", fillRule: "nonzero", xlinkHref: "#o" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            { mask: "url(#p)", fill: "#FFF" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M-2.833-1.7h17v17h-17z" })
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(136 28)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { strokeOpacity: "0.265", stroke: "#7695A5", strokeWidth: "3", fill: "#394F5A",
          cx: "2.5", cy: "4.5", r: "4" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M2.323 4.5H65.68", stroke: "#394F5A", strokeLinecap: "square" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { stroke: "#394F5A", strokeLinecap: "round", strokeLinejoin: "round", d: "M61 0l5.625 4.5L61 9"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(393 28)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { strokeOpacity: "0.265", stroke: "#7695A5", strokeWidth: "3", fill: "#394F5A",
          cx: "2.5", cy: "4.5", r: "4" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M2.323 4.5H65.68", stroke: "#394F5A", strokeLinecap: "square" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { stroke: "#394F5A", strokeLinecap: "round", strokeLinejoin: "round", d: "M61 0l5.625 4.5L61 9"
        })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { transform: "translate(472 11)" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "mask",
          { id: "r", fill: "#fff" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("use", { xlinkHref: "#q" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M25.795 4.798a10.924 10.924 0 0 1 7.86-3.335c4.093 0 7.663 2.254 9.564 5.602a13.356 13.356 0 0 1 5.405-1.136c7.38 0 13.364 5.965 13.364 13.323 0 7.358-5.983 13.323-13.364 13.323-.9 0-1.78-.09-2.633-.26a9.785 9.785 0 0 1-8.526 4.945 9.81 9.81 0 0 1-4.274-.972A11.15 11.15 0 0 1 22.932 43c-4.8 0-8.89-3-10.46-7.21-.686.143-1.397.219-2.126.219C4.632 36.009 0 31.384 0 25.679c0-3.825 2.08-7.164 5.173-8.95a11.712 11.712 0 0 1-.99-4.726c0-6.562 5.39-11.882 12.04-11.882 3.903 0 7.372 1.834 9.572 4.677",
          fill: "#129CD8", fillRule: "nonzero", mask: "url(#r)" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M480.978 33.357c-.04.1.014.121.026.139.117.083.234.144.354.211.632.331 1.23.428 1.854.428 1.272 0 2.061-.668 2.061-1.744v-.02c0-.996-.891-1.358-1.727-1.619l-.11-.034c-.63-.203-1.173-.377-1.173-.788v-.02c0-.352.317-.61.81-.61.548 0 1.197.18 1.616.409 0 0 .123.078.168-.04l.259-.688c.024-.065-.018-.115-.062-.141a3.64 3.64 0 0 0-1.822-.484l-.127.001c-1.164 0-1.977.695-1.977 1.691v.02c0 1.05.897 1.391 1.737 1.628l.135.041c.612.186 1.14.346 1.14.77v.023c0 .388-.344.678-.896.678-.215 0-.9-.003-1.638-.465-.09-.052-.14-.09-.21-.13-.036-.023-.127-.062-.168.056l-.25.688zM499.593 33.357c-.04.1.014.121.026.139.117.083.234.144.354.211.632.331 1.23.428 1.854.428 1.272 0 2.061-.668 2.061-1.744v-.02c0-.996-.891-1.358-1.727-1.619l-.11-.034c-.63-.203-1.173-.377-1.173-.788v-.02c0-.352.317-.61.81-.61.548 0 1.197.18 1.616.409 0 0 .123.078.168-.04l.259-.688c.024-.065-.018-.115-.062-.141a3.638 3.638 0 0 0-1.822-.484l-.127.001c-1.164 0-1.977.695-1.977 1.691v.02c0 1.05.898 1.391 1.737 1.628l.135.041c.612.186 1.14.346 1.14.77v.023c0 .388-.343.678-.896.678a3.03 3.03 0 0 1-1.638-.465c-.09-.052-.142-.087-.21-.13-.023-.015-.13-.057-.167.056l-.251.688zM512.3 31.249c0 .608-.114 1.088-.34 1.426-.224.335-.562.499-1.033.499-.472 0-.808-.164-1.028-.499-.224-.338-.337-.818-.337-1.426 0-.607.113-1.086.336-1.42.221-.332.557-.493 1.03-.493.47 0 .808.161 1.032.492.226.335.34.814.34 1.421m1.062-1.127a2.514 2.514 0 0 0-.482-.911 2.319 2.319 0 0 0-.816-.613 2.704 2.704 0 0 0-1.137-.226c-.43 0-.814.077-1.139.226-.324.15-.598.356-.814.614a2.504 2.504 0 0 0-.483.91 3.923 3.923 0 0 0-.157 1.127c0 .402.053.782.157 1.127.104.348.266.655.483.911.216.257.49.462.815.608.325.146.707.22 1.138.22.43 0 .812-.074 1.137-.22.324-.146.599-.351.816-.608.215-.255.378-.562.482-.91.104-.347.157-.726.157-1.128 0-.402-.053-.78-.157-1.127M522.078 33.01c-.034-.1-.135-.062-.135-.062a2.426 2.426 0 0 1-.494.139 3.754 3.754 0 0 1-.581.04c-.513 0-.922-.15-1.215-.448-.292-.3-.457-.782-.455-1.435.002-.593.146-1.04.407-1.38.259-.34.653-.513 1.178-.513.437 0 .772.05 1.121.158 0 0 .084.036.123-.072.094-.255.163-.436.262-.716.028-.08-.041-.114-.067-.124a4.177 4.177 0 0 0-.708-.177 5.466 5.466 0 0 0-.796-.052c-.445 0-.842.075-1.182.225-.34.149-.627.355-.856.611-.228.257-.4.564-.515.911a3.564 3.564 0 0 0-.174 1.13c0 .87.237 1.573.707 2.087.47.518 1.175.78 2.095.78a4.38 4.38 0 0 0 1.503-.265s.077-.037.043-.125l-.26-.711zM523.936 30.666c.05-.337.144-.618.29-.837.22-.332.555-.516 1.027-.516.472 0 .783.184 1.007.516.148.22.213.512.238.838h-2.562zm3.573-.741a2.2 2.2 0 0 0-.46-.831c-.23-.247-.458-.42-.682-.515a2.643 2.643 0 0 0-1.03-.206c-.447 0-.855.075-1.185.228-.331.153-.61.363-.828.624-.217.26-.381.57-.486.922a3.94 3.94 0 0 0-.158 1.133c0 .41.055.791.163 1.133.11.347.285.65.52.903.237.254.54.452.904.592.362.137.801.21 1.305.208 1.038-.003 1.584-.232 1.81-.355.04-.023.077-.06.03-.17l-.236-.65c-.035-.097-.135-.062-.135-.062-.257.095-.622.264-1.475.262-.557 0-.97-.163-1.229-.417-.265-.26-.396-.641-.418-1.18l3.592.002s.095 0 .105-.093c.004-.037.123-.729-.107-1.528zM495.16 30.666c.052-.337.145-.618.29-.837.222-.332.556-.516 1.028-.516s.783.184 1.008.516c.147.22.212.512.237.838h-2.562zm3.574-.741a2.2 2.2 0 0 0-.46-.831c-.23-.247-.457-.42-.682-.515a2.645 2.645 0 0 0-1.028-.206c-.45 0-.857.075-1.188.228-.33.153-.608.363-.827.624-.218.26-.382.57-.486.922a3.94 3.94 0 0 0-.158 1.133c0 .41.055.791.163 1.133.11.347.284.65.52.903.237.254.54.452.904.592.362.137.8.21 1.305.208 1.037-.003 1.584-.232 1.81-.355.04-.023.077-.06.03-.17l-.236-.65c-.035-.097-.135-.062-.135-.062-.258.095-.622.264-1.475.262-.556 0-.97-.163-1.229-.417-.265-.26-.396-.641-.418-1.18l3.592.002s.095 0 .105-.093c.004-.037.123-.729-.107-1.528zM487.394 32.991c-.14-.11-.16-.138-.206-.21-.072-.11-.109-.264-.109-.462 0-.312.105-.537.32-.687-.001 0 .31-.267 1.043-.257.515.007.976.082.976.082v1.615s-.457.096-.97.127c-.731.044-1.056-.208-1.054-.208m1.43-2.494a7.87 7.87 0 0 0-.56-.017c-.308 0-.606.038-.886.113-.28.075-.533.19-.75.343a1.72 1.72 0 0 0-.52.586 1.69 1.69 0 0 0-.193.818c0 .315.055.588.165.81.109.225.267.412.468.556.2.144.446.25.732.314.282.064.602.096.952.096.369 0 .735-.03 1.091-.09.353-.06.785-.146.905-.174.12-.027.251-.063.251-.063.09-.022.082-.116.082-.116l-.002-3.247c0-.713-.192-1.24-.57-1.568-.377-.326-.933-.49-1.65-.49-.27 0-.703.035-.964.087 0 0-.784.15-1.107.4 0 0-.07.044-.032.142l.254.675c.032.087.118.058.118.058s.028-.011.06-.03c.69-.371 1.565-.36 1.565-.36.388 0 .687.078.888.23.196.149.295.372.295.846v.15c-.308-.044-.592-.07-.592-.07M517.803 28.667a.096.096 0 0 0-.054-.128 3.293 3.293 0 0 0-.602-.102c-.452-.027-.702.048-.926.148-.223.1-.47.26-.607.443v-.433c0-.06-.044-.107-.104-.107h-.92c-.061 0-.104.048-.104.107v5.297c0 .06.048.107.11.107h.943c.06 0 .109-.048.109-.107v-2.646c0-.356.04-.71.12-.932.077-.22.182-.396.313-.522.131-.127.28-.215.445-.264.167-.05.352-.068.48-.068.19 0 .395.049.395.049.07.007.109-.035.133-.097.06-.162.236-.649.27-.745",
        fill: "#FEFEFE", fillRule: "nonzero" }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M508.943 26.212a2.881 2.881 0 0 0-.844-.12c-.65 0-1.161.182-1.521.54-.357.356-.6.898-.723 1.61l-.043.24h-.816s-.1-.003-.12.104l-.134.738c-.01.07.021.114.117.114h.794l-.806 4.444a5.487 5.487 0 0 1-.215.876c-.079.22-.156.385-.25.505a.668.668 0 0 1-.33.25c-.124.041-.267.06-.422.06-.087 0-.203-.014-.288-.031-.086-.016-.13-.035-.194-.062 0 0-.093-.035-.13.057-.03.076-.241.651-.267.722-.025.07.01.125.056.142.106.037.184.06.328.094.2.047.369.05.526.05.331 0 .633-.046.882-.135.252-.09.47-.247.665-.458.208-.228.34-.468.466-.795a6.74 6.74 0 0 0 .316-1.193l.81-4.526h1.183s.1.004.12-.103l.134-.739c.009-.07-.021-.114-.117-.114h-1.149c.006-.025.058-.425.19-.8.056-.161.162-.29.252-.38a.754.754 0 0 1 .3-.185 1.28 1.28 0 0 1 .386-.054c.109 0 .214.013.295.029.111.024.155.036.184.044.117.036.133.002.156-.054l.274-.745c.029-.08-.04-.115-.065-.125M492.891 33.892c0 .06-.042.108-.103.108h-.953c-.06 0-.102-.049-.102-.108v-7.579c0-.059.042-.107.102-.107h.953c.06 0 .103.048.103.107v7.579z",
        fill: "#FEFEFE", fillRule: "nonzero" })
    )
  );
};

/* unused harmony default export */ var _unused_webpack_default_export = (SalesforceLeadEnrichmentIcon);

/***/ }),

/***/ "Hysi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("1JRE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var EnrollButtonConvo = function (_Component) {
  _inherits(EnrollButtonConvo, _Component);

  function EnrollButtonConvo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EnrollButtonConvo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnrollButtonConvo.__proto__ || Object.getPrototypeOf(EnrollButtonConvo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalVisible: false,
      googleScopesFetched: false,
      googleScopes: []
    }, _this.messageEventHandler = function (event) {
      var frame = document.getElementById("contact-sequence-enroll-frame");
      if (event.source !== frame && !event.data.type) {
        return;
      }
      if (event.data.type === '@@driftext/hide_enroll_modal') {
        _this.setState({
          modalVisible: false
        });
      }
    }, _this.receiveScopes = function (data) {
      _this.setState({
        googleScopes: data,
        googleScopesFetched: true
      });
    }, _this.handleButtonClick = function () {
      _this.setState({ modalVisible: true });
    }, _this.handleCloseClick = function () {
      _this.setState({
        modalVisible: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnrollButtonConvo, [{
    key: 'componendWillUnmount',
    value: function componendWillUnmount() {
      window.removeEventListener('message', this.messageEventHandler, false);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('message', this.messageEventHandler, false);
      Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_api__["r" /* getGoogleScopes */])().then(this.receiveScopes);
    }
  }, {
    key: 'render',
    value: function render() {
      var endUser = this.props.endUser;
      var _state = this.state,
          modalVisible = _state.modalVisible,
          googleScopesFetched = _state.googleScopesFetched,
          googleScopes = _state.googleScopes;


      var enrollEmail = endUser.getIn(['email'], false) || endUser.getIn(['attributes', 'email'], false);

      if (!googleScopesFetched) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          ' '
        );
      }
      if ((!googleScopes.includes(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_constants__["K" /* GoogleScopes */].READ) || !googleScopes.includes(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND)) && enrollEmail) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: '/settings/email', target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'contact-sidebar-enroll-button' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'email-send', width: 30 }),
            ' Enroll'
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
          {
            hover: !enrollEmail,
            flow: 'up',
            component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'You can\'t enroll someone who ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              ' doesn\'t have an email address'
            ) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('contact-sidebar-enroll-button', { 'contact-sidebar-enroll-button--disabled': !enrollEmail }), onClick: enrollEmail ? this.handleButtonClick : undefined },
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'email-send', width: 20 }),
            'Enroll'
          )
        ),
        modalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-sequence-enroll-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'contact-sequence-enroll' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { id: 'contact-sequence-enroll-frame', title: 'Enroll your sequence', src: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["W" /* SEQUENCE_ENROLL_URL */] + '?email=' + enrollEmail })
          )
        )
      );
    }
  }]);

  return EnrollButtonConvo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EnrollButtonConvo);

/***/ }),

/***/ "I+r9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"delayTimeWrapper":"delayTimeWrapper---30cxN"};

/***/ }),

/***/ "ICoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_playbook_components_Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaybookDraftToggle__ = __webpack_require__("vd8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("92wV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);







var SignatureEnable = function SignatureEnable(_ref) {
  var draft = _ref.draft,
      isActive = _ref.isActive;
  return React.createElement(
    'div',
    { className: 'signature-enable-wrapper' },
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_playbook_components_Card__["a" /* default */],
      { title: 'Ready to turn on your playbook?' },
      React.createElement(
        'h2',
        null,
        'Your playbook is ready.'
      ),
      React.createElement(
        'div',
        null,
        React.createElement(
          'ol',
          { className: 'signature-enable-instructions-list' },
          React.createElement(
            'li',
            null,
            'Make sure your team has installed ',
            React.createElement(
              'a',
              { href: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["e" /* CHROME_EXTENSION_LINK */], target: '_blank', rel: 'nofollow noopener' },
              'Drift\u2019s Chrome extension'
            ),
            '.'
          ),
          React.createElement(
            'li',
            null,
            'Once you turn this on, your email signature will be inserted into any new email created by your team in Gmail.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'signature-enable-toggle-container' },
        'Toggle your playbook on/off ',
        React.createElement(__WEBPACK_IMPORTED_MODULE_3__PlaybookDraftToggle__["a" /* default */], null)
      )
    ),
    isActive && React.createElement(
      'div',
      { className: 'signature-review-report-wrapper' },
      React.createElement(
        'div',
        { className: 'signature-review-report-information' },
        React.createElement(
          'h3',
          null,
          'Check your stats!'
        ),
        React.createElement(
          'p',
          null,
          'Don\'t forget to check out the Reports page for stats on:',
          React.createElement(
            'ul',
            null,
            React.createElement(
              'li',
              null,
              'Number of views'
            ),
            React.createElement(
              'li',
              null,
              'Total clicks'
            ),
            React.createElement(
              'li',
              null,
              'Number of conversations started from signatures'
            ),
            React.createElement(
              'li',
              null,
              'Stats by teammate'
            )
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
            {
              type: 'tertiary',
              href: '/reports/playbooks/' + draft.id },
            'View Report'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SignatureEnable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ICpg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(528);

/***/ }),

/***/ "ICyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__ = __webpack_require__("69aq");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OutboundSessionInput = function (_Component) {
  _inherits(OutboundSessionInput, _Component);

  function OutboundSessionInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OutboundSessionInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundSessionInput.__proto__ || Object.getPrototypeOf(OutboundSessionInput)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (value) {
      _this.props.conditionUpdater('value', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OutboundSessionInput, [{
    key: 'render',
    value: function render() {
      var conditionValue = this.props.conditionValue;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_SimpleSelect__["a" /* default */], {
        className: 'AriaMenuButton--small',
        onSelection: this.onSelect,
        options: [{ value: true, text: 'is true' }, { value: false, text: 'is false' }],
        selectedValue: conditionValue.get('value') ? 'is true' : 'is false'
      });
    }
  }]);

  return OutboundSessionInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OutboundSessionInput.propTypes = {
  conditionUpdater: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  conditionValue: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.map
};


/* harmony default export */ __webpack_exports__["a"] = (OutboundSessionInput);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "IDPS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConditionPreview__ = __webpack_require__("Q72M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("HL4s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var ConditionSet = function ConditionSet(_ref) {
  var conditions = _ref.conditionSet.conditions,
      onAddConditionClick = _ref.onAddConditionClick,
      isOnFreePlan = _ref.isOnFreePlan;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-condition-set' },
    conditions.map(function (id, index, arr) {
      var lastIndex = arr.size - 1;
      var conditionComponents = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ConditionPreview__["a" /* default */], { key: id, id: id })];
      if (index !== lastIndex) conditionComponents.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-condition-set-and-copy' },
        'and'
      ));
      return conditionComponents;
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-targeting-display-add-condition-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
        { className: 'drift-button drift-button-secondary', onClick: !isOnFreePlan && onAddConditionClick, disabled: isOnFreePlan },
        '+ Add Condition'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-set-or-copy' },
      'or'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConditionSet);

/***/ }),

/***/ "IDni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__ = __webpack_require__("xMS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var NoteQueries = Marty.createQueries({
  id: 'NoteQueries',

  fetchNotesForEndUserId: function fetchNotesForEndUserId(endUserId) {
    var _this = this;

    var promise = this.app.sources.NoteAPI.fetchNotesForEndUserId(endUserId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_END_USER_FETCH_DONE, endUserId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_END_USER_FETCH_FAILED, endUserId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_END_USER_FETCH_FAILED, endUserId, error);
    });
  },
  fetchNotesForCompanyId: function fetchNotesForCompanyId(companyId) {
    var _this2 = this;

    var promise = this.app.sources.NoteAPI.fetchNotesForCompanyId(companyId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_COMPANY_FETCH_DONE, companyId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_COMPANY_FETCH_FAILED, companyId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_COMPANY_FETCH_FAILED, companyId, error);
    });
  },
  notifyNoteCreation: function notifyNoteCreation() {
    return this.app.actions.NotificationActions.pushNotification({
      content: 'Note has been saved!'
    });
  },
  createNoteForEndUserId: function createNoteForEndUserId(endUserId, note) {
    var _this3 = this;

    var promise = this.app.sources.NoteAPI.createNoteForEndUserId(endUserId, note);
    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_END_USER_CREATE_STARTING, endUserId, note);
    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_END_USER_CREATE_DONE, endUserId, res.body);
        return _this3.notifyNoteCreation();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_END_USER_CREATE_FAILED, endUserId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_END_USER_CREATE_FAILED, endUserId, error);
    });
  },
  createNoteForCompanyId: function createNoteForCompanyId(companyId, note) {
    var _this4 = this;

    var promise = this.app.sources.NoteAPI.createNoteForCompanyId(companyId, note);

    promise.then(function (res) {
      if (res.status === 200) {
        _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_COMPANY_CREATE_DONE, companyId, res.body);
        return _this4.notifyNoteCreation();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_COMPANY_CREATE_FAILED, companyId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_COMPANY_CREATE_FAILED, companyId, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NoteQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "IHje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("21sf");
var _handleActions2, _handleActions3;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var ui = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* setModalVisibility */], function (state, action) {
  return action.payload;
}), false);

var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveParticipants */], function (state, action) {
  return state.set('conversationId', action.payload.conversationId);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchParticipants */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchParticipantsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchParticipantsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchParticipantsCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveParticipants */]), function (state, action) {
  return state.set('fetch', action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* addParticipants */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* addParticipantsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* addParticipantsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* addParticipantsSuccess */]), function (state, action) {
  return state.set('add', action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* removeParticipants */], __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* removeParticipantsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* removeParticipantsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* removeParticipantsSuccess */]), function (state, action) {
  return state.set('remove', action.type);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var data = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveParticipants */], function (state, action) {
  return action.payload.participants;
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* addParticipantsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* removeParticipantsFailed */]), function (state, action) {
  return state.union(action.payload.participants);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* removeParticipantsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* addParticipantsFailed */]), function (state, action) {
  return state.subtract(action.payload.participants);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ status: status, data: data, ui: ui }));

/***/ }),

/***/ "IIdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_TranslationConstants__ = __webpack_require__("zMog");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
* Store mapping locale key to messages
*/

var TranslationStore = function (_Marty$Store) {
  _inherits(TranslationStore, _Marty$Store);

  function TranslationStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TranslationStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranslationStore.__proto__ || Object.getPrototypeOf(TranslationStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), _this.handlers = {
      updateTranslations: [__WEBPACK_IMPORTED_MODULE_1_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TranslationStore, [{
    key: 'dehydrate',
    value: function dehydrate() {
      return this.state.toJS();
    }
  }, {
    key: 'rehydrate',
    value: function rehydrate(dehydratedState) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(dehydratedState);
    }
  }, {
    key: 'getTranslationsForLocale',
    value: function getTranslationsForLocale() {
      return this.fetch({
        id: 'getTranslations',
        dependsOn: [this.app.stores.OrgSettingsStore.getOrgSettings(), this.app.stores.LocaleStore.loadLocale()],
        locally: function locally() {
          var locale = this.app.stores.OrgSettingsStore.state.locale;

          return this.state.get(locale);
        },
        remotely: function remotely() {
          var locale = this.app.stores.OrgSettingsStore.state.locale;

          return this.app.actions.TranslationActions.loadTranslations(locale);
        }
      });
    }
  }, {
    key: 'updateTranslations',
    value: function updateTranslations(locale, messages) {
      this.state = this.state.set(locale, messages);
    }
  }]);

  return TranslationStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (TranslationStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "IJHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IJhC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SocketState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var SocketState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  userId: undefined,
  userIpAddress: undefined,
  sessionToken: undefined,
  socket: undefined,
  channels: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  state: undefined,
  authenticateStatus: undefined,
  hasConnected: false,
  reconnectStatus: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    prevState: null
  }),
  timeUntilReconnect: 0
});

var ChannelState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  channel: undefined,
  onMessageSubject: undefined,
  state: undefined
});

/***/ }),

/***/ "IOh1":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.7 13.13c.4.428.4 1.114.002 1.54-.198.214-.465.33-.743.33-.28 0-.546-.116-.745-.328L7 9.07l-5.215 5.6c-.197.214-.465.33-.743.33-.278 0-.545-.116-.743-.328-.4-.428-.4-1.114 0-1.54L5.54 7.5.3 1.87C-.1 1.442-.1.756.3.33c.407-.44 1.077-.44 1.485 0L7 5.93l5.215-5.6c.408-.44 1.078-.44 1.487 0 .397.427.397 1.112 0 1.54L8.46 7.5l5.24 5.63z\" fill-rule=\"nonzero\" fill=\"none\"></path></svg>"

/***/ }),

/***/ "IQRA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DriftLink":"DriftLink---hI2ZX"};

/***/ }),

/***/ "IRT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__ = __webpack_require__("zrFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_states__ = __webpack_require__("PawR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__ = __webpack_require__("qQ9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__ = __webpack_require__("cTDj");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var closeSRC = __webpack_require__("+Juk");
var mapSRC = __webpack_require__("1jik");
var fullSRC = __webpack_require__("pzVx");

var SCALE_INCREMENT = .5;

var GeoFilter = function (_Component) {
  _inherits(GeoFilter, _Component);

  function GeoFilter(props) {
    _classCallCheck(this, GeoFilter);

    var _this = _possibleConstructorReturn(this, (GeoFilter.__proto__ || Object.getPrototypeOf(GeoFilter)).call(this, props));

    _this.updateParent = function () {
      var canSave = _this.state.fieldType && _this.state.selectedGeoOptions.length;
      _this.props.setPageValidity(!!canSave);
      if (canSave) {
        _this.props.setActiveFilter({
          field: _this.state.fieldType,
          operator: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["A" /* GEO_FILTER_OPERATORS */].IS_ANY,
          value: _this.state.selectedGeoOptions
        });
      }
    };

    _this.zoomIn = function () {
      _this.setState(function (prevState) {
        if (prevState.mapScale >= 3) return;
        return {
          mapScale: prevState.mapScale + SCALE_INCREMENT
        };
      });
    };

    _this.zoomOut = function () {
      _this.setState(function (prevState) {
        if (prevState.mapScale <= 1) return;
        return {
          mapScale: prevState.mapScale - SCALE_INCREMENT
        };
      });
    };

    _this.fullScreen = function () {
      _this.setState(function (prevState) {
        return {
          fullScreen: !prevState.fullScreen
        };
      });
    };

    _this.dragMap = function (event) {
      if (_this.state.mapScale <= 1 || !_this.state.isPressed) return;
      var x = event.pageX - _this.state.dragStartX;
      var y = event.pageY - _this.state.dragStartY;

      _this.setState({
        dragX: event.pageX,
        dragY: event.pageY
      });
    };

    _this.pressTimer = function () {
      setTimeout(function () {
        _this.setState({
          isPressed: true
        });
      }, 2000);
    };

    _this.handleMousePress = function (event) {
      _this.setState({
        dragStartX: event.pageX,
        dragStartY: event.pageY
      });

      _this.pressTimer();
    };

    _this.handleMouseUp = function () {
      clearTimeout(_this.pressTimer);
      _this.setState({
        isPressed: false
      });
    };

    _this.getFormattedCountryOptions = function () {
      var _ref;

      var unusedCountries = (_ref = _).without.apply(_ref, [Object.keys(__WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */])].concat(_toConsumableArray(_this.state.selectedGeoOptions)));
      return unusedCountries.map(function (country) {
        return { label: __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */][country], value: country };
      });
    };

    _this.getFormattedStateOptions = function () {
      var _ref2;

      var unusedStates = (_ref2 = _).without.apply(_ref2, [__WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_states__["a" /* states */]].concat(_toConsumableArray(_this.state.selectedGeoOptions)));
      return unusedStates.map(function (state) {
        return { label: state, value: state };
      });
    };

    _this.addStateFromMap = function (event) {
      var stateName = document.elementFromPoint(event.clientX, event.clientY).dataset.name;
      if (!!stateName) {
        if (_this.state.selectedGeoOptions.includes(stateName)) {
          _this.removeGeoOption(stateName);
        } else {
          _this.setState(function (prevState) {
            var newOptions = prevState.selectedGeoOptions.slice(0);
            newOptions.push(stateName);
            newOptions.sort();

            return {
              selectedGeoOptions: newOptions
            };
          }, _this.updateParent);
        }
      }
    };

    _this.removeGeoOption = function (value) {
      _this.setState(function (prevState) {
        return {
          selectedGeoOptions: _.without(prevState.selectedGeoOptions, value)
        };
      }, _this.updateParent);
    };

    _this.saveGeoOption = function (values) {
      _this.setState(function (prevState) {
        var newOptions = prevState.selectedGeoOptions.slice(0);
        var onlyValues = values.map(function (option) {
          return option.value;
        });
        newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
        newOptions.sort();

        return {
          selectedGeoOptions: newOptions
        };
      }, _this.updateParent);
    };

    _this.bucketSelect = function (value) {
      var geoType = _this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY ? __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */] : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */];

      _this.setState({ selectedGeoOptions: geoType[value.value] || [] }, _this.updateParent);
    };

    _this.chooseCountry = function () {
      _this.setState({ fieldType: 'geoCountryCode', selectedGeoOptions: [] }, _this.updateParent);
    };

    _this.chooseState = function () {
      _this.setState({ fieldType: 'geoState', selectedGeoOptions: [] }, _this.updateParent);
    };

    _this.renderSelectOption = function (_ref3) {
      var label = _ref3.label;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'geo-option choice-dropdown-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-value' },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-add' },
          '+Add'
        )
      );
    };

    _this.renderStateSelectionList = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: _this.state.selectedGeoOptions.length * 75 / 2 + 75 + 'px' } },
        _this.state.selectedGeoOptions.map(function (option) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: option },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              option
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
                return _this.removeGeoOption(option);
              } })
          );
        })
      );
    };

    _this.renderCountrySelectionList = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: _this.state.selectedGeoOptions.length * 75 / 2 + 75 + 'px' } },
        _this.state.selectedGeoOptions.map(function (option) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: option },
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_countries__["a" /* countries */][option]
            ),
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
                return _this.removeGeoOption(option);
              } })
          );
        })
      );
    };

    var defaultOptions = props.activeFilter.value;
    var ifEmptyRegionDefault = defaultOptions.length ? defaultOptions : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */].northeast;

    _this.state = {
      selectedGeoOptions: ifEmptyRegionDefault,
      fieldType: props.activeFilter.field,
      mapScale: 1,
      dragX: 0,
      dragY: 0,
      dragStartX: 0,
      dragStartY: 0,
      isPressed: false,
      fullScreen: false
    };
    return _this;
  }

  _createClass(GeoFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateParent();
    }
  }, {
    key: 'getStateOrCountries',
    value: function getStateOrCountries() {
      var _types;

      var types = (_types = {}, _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, this.getFormattedStateOptions), _defineProperty(_types, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, this.getFormattedCountryOptions), _types);

      return types[this.state.fieldType]();
    }
  }, {
    key: 'getFormattedRegionOptions',
    value: function getFormattedRegionOptions() {
      return [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */]).map(function (region) {
        return { label: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["H" /* REGION_LABELS */][region], value: region };
      })), [{ label: 'Custom', value: 'custom' }]);
    }
  }, {
    key: 'getFormattedContinentOptions',
    value: function getFormattedContinentOptions() {
      return [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */]).map(function (continent) {
        return { label: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["h" /* CONTINENT_LABELS */][continent], value: continent };
      })), [{ label: 'Custom', value: 'custom' }]);
    }
  }, {
    key: 'stateOrCountryListItems',
    value: function stateOrCountryListItems() {
      var types = {
        "geoState": this.renderStateSelectionList,
        "geoCountryCode": this.renderCountrySelectionList
      };

      return types[this.state.fieldType]();
    }
  }, {
    key: 'renderBucketSelect',
    value: function renderBucketSelect() {
      var _this2 = this;

      var formattedGeoOptions = this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY ? this.getFormattedContinentOptions() : this.getFormattedRegionOptions();
      var geoType = this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY ? __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_constants_continents__["a" /* continents */] : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */];

      var matchedBucket = _.find(formattedGeoOptions, function (value) {
        return _.isEqual(geoType[value.value], _this2.state.selectedGeoOptions);
      });

      var bselectOptions = {
        multi: false,
        autoFocus: false,
        options: formattedGeoOptions,
        onChange: this.bucketSelect,
        clearable: false,
        searchable: false,
        value: matchedBucket ? matchedBucket : { label: 'Custom', value: 'custom' }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], bselectOptions);
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var placeholders = {
        'geoCountryCode': 'Add a country...',
        'geoState': 'Add a state...'
      };
      var selectOptions = {
        multi: true,
        autoFocus: true,
        options: this.getStateOrCountries(),
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        onChange: this.saveGeoOption,
        placeholder: placeholders[this.state.fieldType]
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderGeoTypeSelect',
    value: function renderGeoTypeSelect() {
      var stateSelected = this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE ? 'selected' : '';
      var countrySelected = this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY ? 'selected' : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'fieldset',
        { className: 'drift-pill-set' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button large ' + countrySelected, onClick: this.chooseCountry },
          'Countries'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button large ' + stateSelected, onClick: this.chooseState },
          'US States'
        )
      );
    }
  }, {
    key: 'renderStateMap',
    value: function renderStateMap() {
      var _this3 = this;

      var fullScreen = this.state.fullScreen ? 'full-screen-map' : '';

      if (!this.state.isPressed) {
        setTimeout(function () {
          var map = document.getElementById('us-map');
          if (!map) return;

          var paths = map.querySelectorAll(':scope > path');
          paths.forEach(function (path) {
            path.style = '';
          });

          _this3.state.selectedGeoOptions.map(function (state) {
            var path = document.querySelectorAll('[data-name="' + state + '"]')[0];
            path.style = 'fill: #b5d2e1; stroke: #fff; stroke-width: 1px;';
            path.class = 'active';
          });
        }, 200);
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'geo-filter-us-map ' + fullScreen,
          onClick: this.addStateFromMap,
          onMouseOver: this.dragMap
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'close-map', onClick: this.fullScreen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'geo-filter-us-map-controls' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button', onClick: this.zoomIn },
            '+'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button', onClick: this.zoomOut },
            '-'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button full', onClick: this.fullScreen },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: fullSRC })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'map-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
            src: mapSRC,
            style: { transform: 'scale(' + this.state.mapScale + ') translateZ(0) translateX(' + (this.state.dragX - this.state.dragStartX) + 'px) translateY(' + (this.state.dragY - this.state.dragStartY) + 'px)' }
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice rules-geo-filter' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose a Location'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Match certain countries, or states using our pre-made buckets'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-geo-filter rules-choice-content drift-form' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-sidebar rules-geo-filter drift-form' },
            this.renderGeoTypeSelect(),
            this.renderBucketSelect()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-options' },
            this.renderSearchBar()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-selection rules-choice-selection-multi-column' },
            this.state.fieldType === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE && this.renderStateMap(),
            this.stateOrCountryListItems()
          )
        )
      );
    }
  }]);

  return GeoFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (GeoFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "ISL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__ = __webpack_require__("Or1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var EmbedQueries = Marty.createQueries({
  id: 'EmbedQueries',

  fetchEmbedList: function fetchEmbedList() {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var listPromise = _this.app.sources.EmbedAPI.fetchEmbedList();

      listPromise.then(function (res) {
        if (res.status === 200) {
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_FETCH_DONE, res.body);
          return resolve(true);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_FETCH_FAILED, res);
          return reject(res);
        }
      });

      return listPromise.catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
        _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_FETCH_FAILED, inboxId, error);
        return reject(error);
      });
    });
  },
  createEmbedForInboxId: function createEmbedForInboxId(inboxId) {
    var _this2 = this;

    var promise = this.app.sources.EmbedAPI.createEmbedForInboxId(inboxId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_CREATE_DONE, inboxId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_CREATE_FAILED, inboxId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_CREATE_FAILED, inboxId, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EmbedQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ITIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("JK9z");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchTagListPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchTagListFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* receiveTagList */]), function (state, action) {
  return state.setIn(['tags', 'fetch'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* createTagPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* createTagFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveTag */]), function (state, action) {
  return state.setIn(['tag', 'create'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* updateTagPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* updateTagFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveTag */]), function (state, action) {
  return state.setIn(['tag', 'update'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* deleteTagPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* deleteTagFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* deleteTagSuccess */]), function (state, action) {
  return state.setIn(['tag', 'delete'], action.type);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var data = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* receiveTagList */], function (state, action) {
  return action.payload.reduce(function (tagsById, tag) {
    return tagsById.set(tag.id, tag);
  }, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
}), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  status: status,
  data: data
}));

/***/ }),

/***/ "IX9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var EndUserTokenConstants = Marty.createConstants(['GET_END_USER_TOKEN']);

/* harmony default export */ __webpack_exports__["a"] = (EndUserTokenConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "IXNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("kk8i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assistantSettings_constants__ = __webpack_require__("E3/D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__("dJC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models__ = __webpack_require__("8Eel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_Application__ = __webpack_require__("08hf");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var googleOauthAcceptEpic = function googleOauthAcceptEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_5" /* GOOGLE_OAUTH_ACCEPT */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["o" /* googleOauthAccept */](action.payload).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_6" /* googleOauthAcceptSuccess */]();
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_5" /* googleOauthAcceptFailure */]());
    });
  });
};

var microsoftOauthAcceptEpic = function microsoftOauthAcceptEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_11" /* MICROSOFT_OAUTH_ACCEPT */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["q" /* microsoftOauthAccept */](action.payload).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_12" /* microsoftOauthAcceptSuccess */]();
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_11" /* microsoftOauthAcceptFailure */]());
    });
  });
};

var zoomOauthAcceptEpic = function zoomOauthAcceptEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_42" /* ZOOM_OAUTH_ACCEPT */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["x" /* zoomOauthAccept */](action.payload).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_41" /* zoomOauthAcceptSuccess */]();
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_40" /* zoomOauthAcceptFailure */]());
    });
  });
};

var fetchCalendarStatusEpic = function fetchCalendarStatusEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* FETCH_CALENDAR_STATUS */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["e" /* fetchCalendarStatus */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["u" /* fetchCalendarStatusSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["t" /* fetchCalendarStatusPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["s" /* fetchCalendarStatusFailure */]());
    });
  });
};

var triggerFetchGoogleCalendarsEpic = function triggerFetchGoogleCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* FETCH_CALENDAR_STATUS_SUCCESS */]).filter(function (action) {
    return action.payload.googleAuthed;
  }).map(function () {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["C" /* fetchGoogleCalendars */]();
  });
};

var fetchGoogleCalendarsEpic = function fetchGoogleCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["D" /* FETCH_GOOGLE_CALENDARS */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["h" /* fetchGoogleCalendars */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["F" /* fetchGoogleCalendarsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["E" /* fetchGoogleCalendarsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["D" /* fetchGoogleCalendarsFailure */]());
    });
  });
};

var fetchGoogleScopesEpic = function fetchGoogleScopesEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["H" /* FETCH_GOOGLE_SCOPES */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["i" /* fetchGoogleScopes */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["J" /* fetchGoogleScopesSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["I" /* fetchGoogleScopesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["H" /* fetchGoogleScopesFailure */](error));
    });
  });
};

var fetchMicrosoftAdminConsent = function fetchMicrosoftAdminConsent(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["T" /* FETCH_MICROSOFT_ADMIN_CONSENT */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["l" /* fetchMicrosoftAdminConsent */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["V" /* fetchMicrosoftAdminConsentSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["U" /* fetchMicrosoftAdminConsentPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["T" /* fetchMicrosoftAdminConsentFailure */](error));
    });
  });
};

var disconnectMicrosoftAdminConsentEpic = function disconnectMicrosoftAdminConsentEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* DISCONNECT_MICROSOFT_ADMIN_CONSENT */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["c" /* disconnectMicrosoftAdminConsent */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["m" /* disconnectMicrosoftAdminConsentSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* disconnectMicrosoftAdminConsentPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* disconnectMicrosoftAdminConsentFailure */](error));
    });
  });
};

var fetchMicrosoftManagedCalendarsEpic = function fetchMicrosoftManagedCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_1" /* FETCH_MICROSOFT_MANAGED_CALENDARS */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["n" /* fetchMicrosoftManagedCalendars */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_3" /* fetchMicrosoftManagedCalendarsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_2" /* fetchMicrosoftManagedCalendarsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_1" /* fetchMicrosoftManagedCalendarsFailure */](error));
    });
  });
};

var microsoftAdminManagedAccept = function microsoftAdminManagedAccept(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_8" /* MICROSOFT_ADMIN_MANAGED_ACCEPT */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["p" /* microsoftAdminConsentAccept */](action.payload).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_9" /* microsoftAdminManagedAcceptSuccess */](response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_8" /* microsoftAdminManagedAcceptFailure */](error));
    });
  });
};

var triggerFetchMicrosoftCalendarsEpic = function triggerFetchMicrosoftCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["u" /* FETCH_CALENDAR_STATUS_SUCCESS */]).filter(function (action) {
    return action.payload.microsoftAuthed;
  }).map(function () {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["W" /* fetchMicrosoftCalendars */]();
  });
};

var fetchMicrosoftCalendarsEpic = function fetchMicrosoftCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["X" /* FETCH_MICROSOFT_CALENDARS */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["m" /* fetchMicrosoftCalendars */]().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["Z" /* fetchMicrosoftCalendarsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["Y" /* fetchMicrosoftCalendarsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["X" /* fetchMicrosoftCalendarsFailure */]());
    });
  });
};

var updateGoogleCalendarEpic = function updateGoogleCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_22" /* UPDATE_GOOGLE_CALENDAR */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["t" /* updateGoogleCalendar */](action.payload).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_22" /* updateGoogleCalendarSuccess */](action.payload);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_21" /* updateGoogleCalendarPending */](action.payload)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_20" /* updateGoogleCalendarFailure */]());
    });
  });
};

var updateMicrosoftCalendarEpic = function updateMicrosoftCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_38" /* UPDATE_MICROSOFT_CALENDAR */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["w" /* updateMicrosoftCalendar */](action.payload).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_38" /* updateMicrosoftCalendarSuccess */](action.payload);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_37" /* updateMicrosoftCalendarPending */](action.payload)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_36" /* updateMicrosoftCalendarFailure */]());
    });
  });
};

var disconnectGoogleCalendarEpic = function disconnectGoogleCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* DISCONNECT_GOOGLE_CALENDAR */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["b" /* disconnectGoogleCalendar */]().map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* disconnectGoogleCalendarSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* disconnectGoogleCalendarPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* disconnectGoogleCalendarFailure */](error));
    });
  });
};

var disconnectMicrosoftCalendarEpic = function disconnectMicrosoftCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* DISCONNECT_MICROSOFT_CALENDAR */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["d" /* disconnectMicrosoftCalendar */]().map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* disconnectMicrosoftCalendarSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["p" /* disconnectMicrosoftCalendarPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["o" /* disconnectMicrosoftCalendarFailure */](error));
    });
  });
};

var fetchMeetingSettingsEpic = function fetchMeetingSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["L" /* FETCH_MEETING_SETTINGS */]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["j" /* fetchMeetingSettings */]().map(function (meeting) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["N" /* fetchMeetingSettingsSuccess */](meeting);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* fetchMeetingSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["L" /* fetchMeetingSettingsFailure */](error));
    });
  });
};

var debouncedUpdateMeetingSettingsEpic = function debouncedUpdateMeetingSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DEBOUNCE_UPDATE_MEETING_SETTINGS */]).debounceTime(500).pluck('payload').switchMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["u" /* updateMeetingSettings */](payload).map(function (meeting) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_30" /* updateMeetingSettingsSuccess */](meeting);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_29" /* updateMeetingSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_24" /* updateMeetingSettingsFailure */](error));
    });
  });
};

var updateMeetingSettingsEpic = function updateMeetingSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_26" /* UPDATE_MEETING_SETTINGS */]).pluck('payload').switchMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["u" /* updateMeetingSettings */](payload).map(function (meeting) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_30" /* updateMeetingSettingsSuccess */](meeting);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_29" /* updateMeetingSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_24" /* updateMeetingSettingsFailure */](error));
    });
  });
};

var updateMeetingSettingsNewAppointmentsEpic = function updateMeetingSettingsNewAppointmentsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_28" /* UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["v" /* updateMeetingSettingsNewAppointments */](action.payload).map(function (meeting) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_28" /* updateMeetingSettingsNewAppointmentsSuccess */](meeting);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_27" /* updateMeetingSettingsNewAppointmentsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_26" /* updateMeetingSettingsNewAppointmentsFailure */](error));
    });
  });
};

var triggerUpdateSettingsSuccessNotificationEpic = function triggerUpdateSettingsSuccessNotificationEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_33" /* UPDATE_MEETING_SETTINGS_SUCCESS */], __WEBPACK_IMPORTED_MODULE_2__constants__["_37" /* UPDATE_MEETING_TYPE_SUCCESS */]).switchMap(function () {
    Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
      content: 'Your meeting settings have been updated.'
    });
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
  });
};

var triggerUpdateSettingsFailureNotificationEpic = function triggerUpdateSettingsFailureNotificationEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_27" /* UPDATE_MEETING_SETTINGS_FAILURE */]).switchMap(function () {
    Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
      content: 'Sorry, there was an error and we weren’t able to save your changes. Please try again.',
      variant: 'red'
    });
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
  });
};

var deleteMeetingTypeEpic = function deleteMeetingTypeEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* DELETE_MEETING_TYPE */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* deleteMeetingType */](action.payload).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* deleteMeetingTypeSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* deleteMeetingTypePending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* deleteMeetingTypeFailure */](error));
    });
  });
};

var triggerDeleteMeetingTypeSuccessNotificationEpic = function triggerDeleteMeetingTypeSuccessNotificationEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* DELETE_MEETING_TYPE_SUCCESS */]).do(function () {
    Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
      content: 'Your meeting type was deleted.'
    });
  }).map(function () {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["O" /* fetchMeetingTypes */]();
  });
};

var triggerDeleteMeetingTypeFailureNotificationEpic = function triggerDeleteMeetingTypeFailureNotificationEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* DELETE_MEETING_TYPE_FAILURE */]).mergeMap(function () {
    Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
      content: 'Your meeting type could not be deleted. Please chat with us to report this issue.'
    });
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
  });
};

var shareCalendarEpic = function shareCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_16" /* SHARE_CALENDAR */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["r" /* sendShareCalendarMessage */](action.payload).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_15" /* shareCalendarSuccess */](response);
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
        content: 'Sorry, there was an error sharing this calendar. Please try again.',
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_14" /* shareCalendarFailure */](error));
    });
  });
};

var shareRoutedCalendarEpic = function shareRoutedCalendarEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_19" /* SHARE_ROUTED_CALENDAR */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["s" /* sendShareRoutedCalendarMessage */](action.payload).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_18" /* shareRoutedCalendarSuccess */](response);
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_9_app_Application__["b" /* getApplication */])().actions.NotificationActions.pushNotification({
        content: 'Sorry, there was an error sharing this calendar. Please try again.',
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_17" /* shareRoutedCalendarFailure */](error));
    });
  });
};

var fetchConnectedCalendarsEpic = function fetchConnectedCalendarsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["z" /* FETCH_CONNECTED_CALENDARS */]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["g" /* fetchConnectedCalendars */]().map(function (agentIds) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["B" /* fetchConnectedCalendarsSuccess */](agentIds);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["A" /* fetchConnectedCalendarsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["z" /* fetchConnectedCalendarsFailure */](error));
    });
  });
};

var fetchMeetingTypesEpic = function fetchMeetingTypesEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["P" /* FETCH_MEETING_TYPES */]).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_5__api__["k" /* fetchMeetingTypes */]().map(function (meetingTypes) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["R" /* fetchMeetingTypesSuccess */](meetingTypes);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* fetchMeetingTypesPending */]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["P" /* fetchMeetingTypesFailure */]());
    });
  });
};

var updateMeetingTypeEpic = function updateMeetingTypeEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_34" /* UPDATE_MEETING_TYPE */]).debounceTime(500).pluck('payload').switchMap(function (meetingSettings) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["u" /* updateMeetingSettings */](meetingSettings).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["_34" /* updateMeetingTypeSuccess */](meetingSettings);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["_33" /* updateMeetingTypePending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["_32" /* updateMeetingTypeFailure */](error));
    });
  });
};

var fetchCalendlyMeetingTypesEpic = function fetchCalendlyMeetingTypesEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* FETCH_CALENDLY_MEETING_TYPES */]).pluck('payload').mergeMap(function (apiKey) {
    return __WEBPACK_IMPORTED_MODULE_5__api__["f" /* fetchCalendlyMeetingTypes */](apiKey).flatMap(function (calendlyMeetingTypes) {
      var defaultAvailability = __WEBPACK_IMPORTED_MODULE_8__models__["e" /* defaultNewMeetingType */].get('availability');
      return [__WEBPACK_IMPORTED_MODULE_4__actions__["x" /* fetchCalendlyMeetingTypesSuccess */]()].concat(_toConsumableArray(calendlyMeetingTypes.map(function (meetingType) {
        return __WEBPACK_IMPORTED_MODULE_4__actions__["_31" /* updateMeetingType */](meetingType.set('availability', defaultAvailability).set('timezone', 'America/New_York').toJS());
      })));
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["w" /* fetchCalendlyMeetingTypesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["v" /* fetchCalendlyMeetingTypesFailure */](error));
    });
  });
};

var hasSeenPersonalizationTooltip = function hasSeenPersonalizationTooltip(action$, _ref) {
  var getState = _ref.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__constants__["_26" /* UPDATE_MEETING_SETTINGS */], __WEBPACK_IMPORTED_MODULE_3__assistantSettings_constants__["C" /* PATCH_ASSISTANT_AGENT_SETTINGS */], __WEBPACK_IMPORTED_MODULE_2__constants__["_22" /* UPDATE_GOOGLE_CALENDAR */], __WEBPACK_IMPORTED_MODULE_2__constants__["_38" /* UPDATE_MICROSOFT_CALENDAR */], __WEBPACK_IMPORTED_MODULE_2__constants__["_15" /* OPENED_MEETING_EMAIL_MODAL */]).filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */])(getState()).get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION', false);
  }).map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */])({ "HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION": true }, false);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(googleOauthAcceptEpic, microsoftOauthAcceptEpic, zoomOauthAcceptEpic, fetchCalendarStatusEpic, fetchGoogleScopesEpic, triggerFetchGoogleCalendarsEpic, triggerFetchMicrosoftCalendarsEpic, fetchGoogleCalendarsEpic, fetchMicrosoftCalendarsEpic, updateGoogleCalendarEpic, updateMicrosoftCalendarEpic, disconnectGoogleCalendarEpic, disconnectMicrosoftCalendarEpic, fetchMeetingSettingsEpic, fetchMeetingTypesEpic, fetchCalendlyMeetingTypesEpic, updateMeetingTypeEpic, updateMeetingSettingsEpic, debouncedUpdateMeetingSettingsEpic, deleteMeetingTypeEpic, updateMeetingSettingsNewAppointmentsEpic, triggerUpdateSettingsSuccessNotificationEpic, triggerUpdateSettingsFailureNotificationEpic, triggerDeleteMeetingTypeSuccessNotificationEpic, triggerDeleteMeetingTypeFailureNotificationEpic, shareCalendarEpic, fetchConnectedCalendarsEpic, fetchMicrosoftAdminConsent, microsoftAdminManagedAccept, disconnectMicrosoftAdminConsentEpic, fetchMicrosoftManagedCalendarsEpic, shareRoutedCalendarEpic, hasSeenPersonalizationTooltip));

/***/ }),

/***/ "Ib5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_billing_components__ = __webpack_require__("oNNb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_billing_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_billing_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EmailTemplateModal__ = __webpack_require__("KCeE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_EmailTemplateModal_utils__ = __webpack_require__("sNIf");







var MeetingEmailSettings = function MeetingEmailSettings(_ref) {
  var confirmationEmailStatus = _ref.confirmationEmailStatus,
      reminderEmailStatus = _ref.reminderEmailStatus,
      toggleMeetingConfirmationStatus = _ref.toggleMeetingConfirmationStatus,
      toggleMeetingReminderStatus = _ref.toggleMeetingReminderStatus,
      confirmationDelayTime = _ref.confirmationDelayTime,
      reminderDelayTime = _ref.reminderDelayTime,
      reminderFollowUpDelayTime = _ref.reminderFollowUpDelayTime,
      confirmationModal = _ref.confirmationModal,
      reminderModal = _ref.reminderModal,
      toggleModal = _ref.toggleModal,
      gatedModal = _ref.gatedModal,
      hasProPlan = _ref.hasProPlan,
      seenPersonalizationEmailEducation = _ref.seenPersonalizationEmailEducation,
      actions = _ref.actions,
      meetingSettings = _ref.meetingSettings,
      toggleMeetingManagement = _ref.toggleMeetingManagement;
  var _meetingSettings$allo = meetingSettings.allowMeetingManagement,
      allowMeetingManagement = _meetingSettings$allo === undefined ? false : _meetingSettings$allo;

  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'toggle-setting' },
      React.createElement(
        'div',
        { className: 'subheader meeting-management-subheader' },
        React.createElement(
          'div',
          { className: 'flex' },
          'Allow guests to cancel or reschedule their meeting'
        )
      ),
      React.createElement(
        'div',
        { className: 'copy-and-toggle' },
        React.createElement(
          'p',
          { className: 'settings-body-copy' },
          'Add links to your meeting invites so guests can reschedule or cancel meetings on their own.'
        ),
        React.createElement(
          'div',
          { className: 'drift-form' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], { checked: !!allowMeetingManagement, onChange: toggleMeetingManagement })
        )
      )
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_tooltips_legacy__["EducationTooltip"], {
      className: 'meeting-personalization-education-tooltip',
      onClose: function onClose() {
        return actions.openedMeetingEmailModal();
      },
      showTooltip: !seenPersonalizationEmailEducation,
      ribbonInfo: { ribbonCopy: 'New!', ribbonColor: 'var(--main-violet)' },
      tooltipSide: 'top',
      tooltipCaretLocation: 'center',
      headerCopy: 'Try personalizing your meeting emails',
      bodyCopy: 'You can now customize the emails that get automatically sent when someone books a meeting with you.',
      buttonInfoArray: [{
        copy: 'Personalize my confirmation Email',
        func: function func() {
          actions.openedMeetingEmailModal();
          toggleModal('confirmationModal', true);
        }
      }] }),
    React.createElement(
      'div',
      { className: 'toggle-setting' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EmailTemplateModal__["a" /* default */], { isOpen: confirmationModal,
        settingName: 'MEETING_CONFIRMATION',
        onClose: function onClose() {
          return toggleModal('confirmationModal', false);
        } }),
      React.createElement(
        'div',
        { className: 'subheader meeting-management-subheader' },
        React.createElement(
          'div',
          { className: 'flex' },
          'Send a confirmation email when a meeting is booked'
        )
      ),
      React.createElement(
        'div',
        { className: 'copy-and-toggle' },
        React.createElement(
          'p',
          { className: 'settings-body-copy' },
          'Your Drift Assistant will send a personalized email to your guest ',
          Object(__WEBPACK_IMPORTED_MODULE_5_components_EmailTemplateModal_utils__["a" /* humanizeDelay */])(confirmationDelayTime),
          ' after they book a meeting.\xA0',
          React.createElement(
            'a',
            { onClick: function onClick() {
                actions.openedMeetingEmailModal();
                toggleModal('confirmationModal', true);
              } },
            'Customize'
          )
        ),
        React.createElement(
          'div',
          { className: 'drift-form' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], { checked: !!confirmationEmailStatus, onChange: toggleMeetingConfirmationStatus })
        )
      )
    ),
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("toggle-setting", { gated: !hasProPlan }), onClick: function onClick() {
          !hasProPlan && toggleModal('gatedModal', true);
        } },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EmailTemplateModal__["a" /* default */], { isOpen: reminderModal,
        settingName: 'MEETING_REMINDER',
        settingTemplateOptions: ['MEETING_REMINDER', 'MEETING_REMINDER_FOLLOW'],
        onClose: function onClose() {
          return toggleModal('reminderModal', false);
        } }),
      React.createElement(
        'div',
        { className: 'subheader meeting-management-subheader' },
        React.createElement(
          'div',
          { className: 'flex' },
          'Send a reminder email to guests before a meeting'
        )
      ),
      React.createElement(
        'div',
        { className: 'copy-and-toggle' },
        React.createElement(
          'p',
          { className: 'settings-body-copy' },
          hasProPlan ? 'To help reduce no shows, your Drift Assistant will send a personalized email to your guest ' + Object(__WEBPACK_IMPORTED_MODULE_5_components_EmailTemplateModal_utils__["a" /* humanizeDelay */])(reminderDelayTime) + ' and ' + Object(__WEBPACK_IMPORTED_MODULE_5_components_EmailTemplateModal_utils__["a" /* humanizeDelay */])(reminderFollowUpDelayTime) + ' before their meeting with you. ' : "To help reduce no shows, your Drift Assistant can automatically send personalized email reminders to your guests before your meeting.",
          hasProPlan && React.createElement(
            'a',
            { onClick: function onClick() {
                actions.openedMeetingEmailModal();
                toggleModal('reminderModal', true);
              } },
            'Customize'
          )
        ),
        React.createElement(
          'div',
          { className: 'drift-form' },
          hasProPlan && React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], { checked: !!reminderEmailStatus, onChange: toggleMeetingReminderStatus })
        )
      ),
      !hasProPlan && React.createElement(
        'div',
        { className: 'PremiumOverlay__Banner' },
        'Upgrade'
      ),
      !hasProPlan && gatedModal && React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_billing_components__["UpgradeModal"], {
        onCloseInitiated: function onCloseInitiated() {
          return toggleModal('gatedModal', false);
        },
        headLineFeatureText: 'Automated Meeting Reminders',
        planName: 'Pro',
        isMonthlyBilling: true
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MeetingEmailSettings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "IdOK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MessengerBuilder":"MessengerBuilder---1M1K1"};

/***/ }),

/***/ "IfBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IhB6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Im5/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_profile__ = __webpack_require__("YEs/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("3wYT");











function mapStateToProps(state) {
  return {
    meetingSettings: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["m" /* getMeetingSettings */])(state),
    meetingStatus: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["n" /* getMeetingSettingsStatus */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["_23" /* updateMeetingSettings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_profile__["a" /* withProfile */])({ profileUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["profileUrl"], visibility: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["visibility"] }), Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchMeetingSettings();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  handleSelectMinimumNoticeTime: function handleSelectMinimumNoticeTime(_ref) {
    var meetingSettings = _ref.meetingSettings,
        actions = _ref.actions;
    return function (_ref2) {
      var value = _ref2.value;

      actions.updateMeetingSettings(meetingSettings.set('minimumNoticeTime', value));
    };
  },
  handleSelectBufferTime: function handleSelectBufferTime(_ref3) {
    var meetingSettings = _ref3.meetingSettings,
        actions = _ref3.actions;
    return function (_ref4) {
      var value = _ref4.value;

      actions.updateMeetingSettings(meetingSettings.set('bufferTime', value));
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "Ipmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_plus_dist_react_select_plus_css__ = __webpack_require__("/XUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select_plus_dist_react_select_plus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_select_plus_dist_react_select_plus_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg__ = __webpack_require__("iv9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg__ = __webpack_require__("PK/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_AgentStatusAvatar__ = __webpack_require__("L7W3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_styl__ = __webpack_require__("B9fz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__styles_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var InviteTips = function InviteTips() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'invite-select-tips' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'dsg-Body color-navy-dark' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'color-navy-extra-dark' },
        'Key ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_updown_arrow_svg___default.a })
      ),
      ' ',
      'to navigate'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'dsg-Body color-navy-dark' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'color-navy-extra-dark' },
        'Return ',
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_keys_return_key_svg___default.a })
      ),
      ' ',
      'to select'
    )
  );
};

var InviteSelect = function (_PureComponent) {
  _inherits(InviteSelect, _PureComponent);

  function InviteSelect(props) {
    _classCallCheck(this, InviteSelect);

    var _this = _possibleConstructorReturn(this, (InviteSelect.__proto__ || Object.getPrototypeOf(InviteSelect)).call(this, props));

    _this.findUser = function (users, email) {
      if (users.has(email)) {
        return users.get(email).toJS();
      }
      var matchedUsers = users.filter(function (user) {
        return user.get('email') === email;
      });
      return matchedUsers.size ? matchedUsers.get(0).toJS() : {};
    };

    _this.renderUser = function (_ref) {
      var value = _ref.value,
          label = _ref.label;

      var user = _this.findUser(_this.props.users, value);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex agent-status-avatar-wrapper' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { className: 'agent-status-avatar', size: 'small', user: user }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'agent-status-indicator agent-status-indicator-conversations' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: Object(__WEBPACK_IMPORTED_MODULE_10_components_shared_AgentStatusAvatar__["b" /* resolveStatusIcon */])(user) })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'user-label' },
          label
        )
      );
    };

    _this.handleSelect = function (selectedUsers) {
      var consumerChangeEvent = _this.props.onChange || function () {};

      _this.setState({
        selectedUsers: selectedUsers.map(function (entry) {
          return entry.value;
        })
      }, consumerChangeEvent.bind(null, selectedUsers));
    };

    _this.handleClick = function () {
      var onNext = _this.props.onNext;

      onNext && onNext(_this.state.selectedUsers);
    };

    _this.state = {
      selectedUsers: props.value || []
    };
    return _this;
  }

  _createClass(InviteSelect, [{
    key: 'selectDefaults',
    value: function selectDefaults() {
      var defaults = {
        isOpen: true,
        multi: true,
        autofocus: this.props.shouldSelectAutofocus,
        value: this.state.selectedUsers,
        placeholder: "Enter email address",
        options: this.props.options || this.selectOptions.options,
        onChange: this.handleSelect,
        clearable: false,
        optionRenderer: this.props.optionRenderer || this.renderUser,
        valueRenderer: this.props.valueRenderer || this.renderUser,
        className: 'InviteSelect'
      };

      return _extends({}, defaults, this.props.selectOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          showInviteTips = _props.showInviteTips,
          CTA = _props.CTA;
      var selectedUsers = this.state.selectedUsers;

      var disabledCTA = Boolean(selectedUsers.length);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'InviteSelectContainer' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'invite-select-wrapper' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], this.selectDefaults()),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
            { condition: showInviteTips },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InviteTips, null)
          ),
          !!CTA && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            {
              disabled: !disabledCTA,
              className: 'invite-submit-button',
              onClick: this.handleClick },
            CTA
          )
        )
      );
    }
  }]);

  return InviteSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

InviteSelect.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array /* Currently chosen value */
  , CTA: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string /* text for cta */
  , options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired /* All the options to be displayed */
  , onChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func /* fires on input additions and deletes */
  , onNext: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func /* what to do on cta click */
  , className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string /* Optional class name to set on the select component */
  , arrow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool /* Whether to display an arrow for the dropdown */
  , showInviteTips: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  CustomButton: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element
};
InviteSelect.defaultProps = {
  showInviteTips: true,
  shouldSelectAutofocus: true
};


/* harmony default export */ __webpack_exports__["a"] = (InviteSelect);

/***/ }),

/***/ "Ipqy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ItLX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ivb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("sHc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("p57G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Subnav = function (_Component) {
  _inherits(Subnav, _Component);

  function Subnav(props) {
    _classCallCheck(this, Subnav);

    var _this = _possibleConstructorReturn(this, (Subnav.__proto__ || Object.getPrototypeOf(Subnav)).call(this, props));

    _this.state = {
      open: props.open
    };

    _this.onToggle = _this.onToggle.bind(_this);
    return _this;
  }

  _createClass(Subnav, [{
    key: 'onToggle',
    value: function onToggle() {
      var onToggle = this.props.onToggle;


      onToggle && onToggle();
      this.setState({ open: !this.state.open });
    }
  }, {
    key: 'render',
    value: function render() {
      var open = this.state.open;
      var _props = this.props,
          className = _props.className,
          mode = _props.mode;


      var modeClassName = 'tc-subnav--' + mode;
      var nodes = Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* getChildNodes */])(this.props.nodes);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("tc-subnav-wrapper", { 'tc-subnav-wrapper--collapsed': !open }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("tc-subnav", { 'tc-subnav--collapsed': !open }, modeClassName, className) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["H3"],
            { className: 'tc-subnav-header' },
            this.props.title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
            { className: 'tc-subnav-content' },
            nodes
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tc-subnav-toggle-button', { 'tc-subnav-toggle-button--collapsed': !open }), onClick: this.onToggle },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { name: 'arrow-1-left', width: '8', height: '8' })
        )
      );
    }
  }]);

  return Subnav;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Subnav.defaultProps = {
  mode: 'slide',
  open: true
};


/* harmony default export */ __webpack_exports__["a"] = (Subnav);

/***/ }),

/***/ "IyfO":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "IypW":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.375 7.545h-8.75A.631.631 0 0 1 5 6.91c0-.351.28-.636.625-.636h8.75c.345 0 .625.285.625.636 0 .351-.28.636-.625.636zm0-5h-8.75A.631.631 0 0 1 5 1.91c0-.351.28-.636.625-.636h8.75c.345 0 .625.285.625.636 0 .351-.28.636-.625.636zM1.5 13.273c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm0-5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S3 .946 3 1.773s-.673 1.5-1.5 1.5zm4.125 8h8.75c.345 0 .625.285.625.636 0 .351-.28.636-.625.636h-8.75A.631.631 0 0 1 5 11.91c0-.351.28-.636.625-.636z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Iz1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omitBy__ = __webpack_require__("uN7r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNull__ = __webpack_require__("qtVo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("sAia");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var filterNull = function filterNull(data) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_omitBy___default()(data, __WEBPACK_IMPORTED_MODULE_1_lodash_isNull___default.a);
};

function parseProfile(data) {
  var _filterNull = filterNull(data),
      visibility = _filterNull.visibility,
      profile = _objectWithoutProperties(_filterNull, ['visibility']);

  return {
    visibility: visibility,
    profile: Object(__WEBPACK_IMPORTED_MODULE_4__models__["d" /* Profile */])(profile)
  };
}

var api = {
  get: function get(userId) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxCustomerAPI"].get('/users/' + userId + '/profile').checkStatus().mapResponse(parseProfile);
  },
  fetch: function fetch(userId) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["CustomerAPI"].get('/users/' + userId + '/profile').then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["json"]).then(parseProfile).catch(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */]);
  },
  update: function update(userId, operations) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["CustomerAPI"].patch('/users/' + userId + '/profile', operations).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["json"]).then(parseProfile);
  },
  checkUserHandle: function checkUserHandle(handle) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["CustomerAPI"].head('/users/handle_check', { handle: handle });
  },
  checkGlobalHandle: function checkGlobalHandle(globalHandle) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["CustomerAPI"].head('/users/handle_check', { globalHandle: globalHandle });
  }
};

/***/ }),

/***/ "J+qo":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "J7dj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var InputFilter = function (_PureComponent) {
  _inherits(InputFilter, _PureComponent);

  function InputFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputFilter.__proto__ || Object.getPrototypeOf(InputFilter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.onValueUpdated = function (event) {
      var _this$props = _this.props,
          onUpdateCondition = _this$props.onUpdateCondition,
          activeFilter = _this$props.activeFilter;

      var value = event.target.value;

      var newFilter = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["clone"])(activeFilter);

      newFilter.value = value;

      _this.setState({
        value: value
      });

      onUpdateCondition(newFilter);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputFilter, [{
    key: 'render',
    value: function render() {
      var value = this.state.value;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { value: value, onChange: this.onValueUpdated })
      );
    }
  }]);

  return InputFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (InputFilter);

/***/ }),

/***/ "J7ra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("gQOl");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var initialState = {
  integrationProperties: [],
  integrationMappings: [],
  integrationMappingsErr: null,
  integrationPatchLoading: false
};

var sortedByStatic = function sortedByStatic(mappings) {
  return _.sortBy(mappings, function (mapping) {
    return !mapping.static;
  });
};

var integrationMappings = function integrationMappings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_MARKETO_FIELDS_SUCCESS */]:
      return _extends({}, state, { integrationFields: action.fields });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_MARKETO_MAPPINGS_SUCCESS */]:
      var clonedState = _extends({}, state);
      clonedState.integrationMappings = sortedByStatic(action.mappings);
      clonedState.allowAttributeDefaults = action.allowAttributeDefaults;
      clonedState.useCountryAcronyms = action.useCountryAcronyms;
      clonedState.useStateAcronyms = action.useStateAcronyms;
      return clonedState;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_MARKETO_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {
        integrationMappings: sortedByStatic(action.mappings),
        allowAttributeDefaults: action.allowAttributeDefaults,
        useCountryAcronyms: action.useCountryAcronyms,
        useStateAcronyms: action.useStateAcronyms,
        integrationMappingsErr: null,
        integrationPatchLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_MARKETO_MAPPINGS_ERROR */]:
      return _extends({}, state, { integrationMappingsErr: action.err, integrationPatchLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_MARKETO_MAPPINGS_START */]:
      return _extends({}, state, { integrationPatchLoading: true });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (integrationMappings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "JGxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var volume = __webpack_require__("HnAN");
var check = __webpack_require__("UAZS");

var EnableSound = function (_Component) {
  _inherits(EnableSound, _Component);

  function EnableSound(props) {
    _classCallCheck(this, EnableSound);

    var _this = _possibleConstructorReturn(this, (EnableSound.__proto__ || Object.getPrototypeOf(EnableSound)).call(this, props));

    _this.setOpen = function () {
      _this.setState({ closed: false });
    };

    _this.setClose = function () {
      _this.setState({ closed: true });
    };

    _this.state = {
      closed: true
    };
    return _this;
  }

  _createClass(EnableSound, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.setOpen, 2000);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.sound === 'enabled') {
        setTimeout(this.setClose, 1000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('global-notification-tease', 'instruction', { 'show-bar': !this.state.closed }) },
        this.props.sound === 'enabled' && React.createElement(
          'p',
          null,
          '  ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: check }),
          ' Notification sounds enabled '
        ),
        this.props.sound === 'failed' && React.createElement(
          'p',
          null,
          '  ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: volume }),
          ' Click anywhere on the page to enable notification sounds'
        )
      );
    }
  }]);

  return EnableSound;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EnableSound);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "JIpA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redirect__ = __webpack_require__("hseA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ConversationStats_InboxMetrics__ = __webpack_require__("Uq9O");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var CONVERSATION_STATS_PATH = '/conversation-stats';

var RootDashboardRedirect = React.createClass({
  displayName: 'RootDashboardRedirect',


  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  },

  // Default to a week time range
  getDefaultDates: function getDefaultDates() {
    return {
      startDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(6, 'days').startOf('day').valueOf(),
      endDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').valueOf()
    };
  },
  componentWillMount: function componentWillMount() {
    var query = this.props.location.query;

    if (!query.inboxId || !query.metric || !query.startDate || !query.endDate) {
      return this.redirectToDefaultDashboard();
    }
  },
  render: function render() {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ConversationStats_InboxMetrics__["a" /* default */], { query: this.props.location.query });
  },
  redirectToDefaultDashboard: function redirectToDefaultDashboard() {
    var defaultDates = this.getDefaultDates();

    var query = {
      metric: 'NEW_CONVERSATIONS',
      inboxId: __guard__(_.head(_.values(this.props.inboxesById)), function (x) {
        return x.id;
      }),
      startDate: defaultDates.startDate,
      endDate: defaultDates.endDate
    };
    return this.context.router.replace({ pathname: CONVERSATION_STATS_PATH, query: query });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(RootDashboardRedirect, {

  listenTo: ['stores.InboxStore'],

  fetch: {
    inboxesById: function inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList();
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
}));

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "JK9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchTagListPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchTagListFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return receiveTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTagPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createTagFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateTagPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateTagFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteTagPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteTagFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteTagSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receiveTag; });
/* unused harmony export createTag */
/* unused harmony export updateTag */
/* unused harmony export deleteTag */
/* unused harmony export tagConversationPending */
/* unused harmony export tagConversationSuccess */
/* unused harmony export tagConversationFailed */
/* unused harmony export tagConversation */
/* unused harmony export untagConversationPending */
/* unused harmony export untagConversationSuccess */
/* unused harmony export untagConversationFailed */
/* unused harmony export untagConversation */
/* unused harmony export tagCompanyPending */
/* unused harmony export tagCompanyFailed */
/* unused harmony export tagCompanySuccess */
/* unused harmony export tagCompany */
/* unused harmony export untagCompanyPending */
/* unused harmony export untagCompanySuccess */
/* unused harmony export untagCompanyFailed */
/* unused harmony export untagCompany */
/* unused harmony export tagEndUserPending */
/* unused harmony export tagEndUserFailed */
/* unused harmony export tagEndUserSuccess */
/* unused harmony export tagEndUser */
/* unused harmony export untagEndUserPending */
/* unused harmony export untagEndUserFailed */
/* unused harmony export untagEndUserSuccess */
/* unused harmony export untagEndUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_memoize__ = __webpack_require__("8hab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_org__ = __webpack_require__("rDli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("6Cv+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("9ZnD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("rRpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__ = __webpack_require__("60ou");








var fetchTagListPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].FETCH_TAG_LIST_PENDING);
var fetchTagListFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].FETCH_TAG_LIST_FAILED);
var receiveTagList = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].RECEIVE_TAG_LIST);

var fetchTagList = Object(__WEBPACK_IMPORTED_MODULE_0_app_api_memoize__["a" /* default */])(function () {
  return function (dispatch, getState) {
    dispatch(fetchTagListPending());
    var orgId = __WEBPACK_IMPORTED_MODULE_2_app_modules_org__["c" /* selectors */].orgId(getState());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchList(orgId).then(function (tagList) {
      return dispatch(receiveTagList(tagList));
    }).catch(function (error) {
      dispatch(fetchTagListFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
});

var createTagPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].CREATE_TAG_PENDING);
var createTagFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].CREATE_TAG_FAILED);
var updateTagPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UPDATE_TAG_PENDING);
var updateTagFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UPDATE_TAG_FAILED);
var deleteTagPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].DELETE_TAG_PENDING);
var deleteTagFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].DELETE_TAG_FAILED);
var deleteTagSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].DELETE_TAG_SUCCESS);
var receiveTag = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].RECEIVE_TAG);

var createTag = function createTag(tag) {
  return function (dispatch, getState) {
    dispatch(createTagPending(tag));
    var orgId = __WEBPACK_IMPORTED_MODULE_2_app_modules_org__["c" /* selectors */].orgId(getState());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].create(orgId, tag).then(function (tag) {
      return dispatch(receiveTag(tag));
    }).catch(function (error) {
      dispatch(createTagFailed({ error: error, tag: tag }));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var updateTag = function updateTag(tag) {
  return function (dispatch, getState) {
    var oldTag = __WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* tag */](getState(), { tagId: tag.id });
    var orgId = __WEBPACK_IMPORTED_MODULE_2_app_modules_org__["c" /* selectors */].orgId(getState());
    dispatch(updateTagPending(tag));
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].updateTag(orgId, tag).then(function (tag) {
      return dispatch(tag);
    }).catch(function (error) {
      dispatch(updateTagFailed({ error: error, tag: oldTag }));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var deleteTag = function deleteTag(tagId) {
  return function (dispatch, getState) {
    var orgId = __WEBPACK_IMPORTED_MODULE_2_app_modules_org__["c" /* selectors */].orgId(getState());
    var oldTag = __WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* tag */](getState(), { tagId: tagId });
    dispatch(deleteTagPending(tagId));
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].delete(orgId, tagId).then(function () {
      return dispatch(deleteTagSuccess());
    }).catch(function (error) {
      dispatch(deleteTagFailed({ error: error, tag: oldTag }));
    });
  };
};

var tagConversationPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_CONVERSATION_PENDING);
var tagConversationSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_CONVERSATION_SUCCESS);
var tagConversationFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_CONVERSATION_FAILED);

var tagConversation = function tagConversation(conversationId, tagIds) {
  return function (dispatch) {
    dispatch(tagConversationPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].tagConversation(conversationId, tagIds).then(function () {
      return dispatch(tagConversationSuccess());
    }).catch(function (error) {
      dispatch(tagConversationFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var untagConversationPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_CONVERSATION_PENDING);
var untagConversationSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_CONVERSATION_SUCCESS);
var untagConversationFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_CONVERSATION_FAILED);

var untagConversation = function untagConversation(conversationId, tagIds) {
  return function (dispatch) {
    dispatch(untagConversationPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].untagConversation(conversationId, tagIds).then(function () {
      return dispatch(untagConversationSuccess());
    }).catch(function (error) {
      dispatch(untagConversationFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var tagCompanyPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_COMPANY_PENDING);
var tagCompanyFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_COMPANY_FAILED);
var tagCompanySuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_COMPANY_SUCCESS);

var tagCompany = function tagCompany(companyId, tagIds) {
  return function (dispatch) {
    dispatch(tagCompanyPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].tagCompany(companyId, tagIds).then(function () {
      return dispatch(tagCompanySuccess());
    }).catch(function (error) {
      dispatch(tagCompanySuccess(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var untagCompanyPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_COMPANY_PENDING);
var untagCompanySuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_COMPANY_SUCCESS);
var untagCompanyFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_COMPANY_FAILED);

var untagCompany = function untagCompany(companyId, tagIds) {
  return function (dispatch) {
    dispatch(untagCompanyPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].untagCompany(companyId, tagIds).then(function () {
      return dispatch(untagCompanySuccess());
    }).catch(function (error) {
      dispatch(untagCompanyFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var tagEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_END_USER_PENDING);
var tagEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_END_USER_FAILED);
var tagEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].TAG_END_USER_SUCCESS);

var tagEndUser = function tagEndUser(endUserId, tagIds) {
  return function (dispatch) {
    dispatch(tagEndUserPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].tagEndUser(endUserId, tagIds).then(function () {
      return dispatch(tagEndUserSuccess());
    }).catch(function (error) {
      dispatch(tagEndUserFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

var untagEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_END_USER_PENDING);
var untagEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_END_USER_FAILED);
var untagEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* constants */].UNTAG_END_USER_SUCCESS);

var untagEndUser = function untagEndUser(endUserId, tagIds) {
  return function (dispatch) {
    dispatch(untagEndUserPending());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].untagEndUser(endUserId, tagIds).then(function () {
      return dispatch(untagEndUserSuccess());
    }).catch(function (error) {
      dispatch(untagEndUserFailed(error));
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error);
      throw error;
    });
  };
};

/***/ }),

/***/ "JL2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_TagConstants__ = __webpack_require__("qFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__ = __webpack_require__("zyQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_queries_CampaignQueries__ = __webpack_require__("h41x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_store__ = __webpack_require__("Tvnw");
/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var CampaignStore = Marty.createStore({
  id: 'CampaignStore',

  getInitialState: function getInitialState() {
    return {
      campaignsById: {},
      successReportsByCampaignId: {},
      interactionIdsByCampaignId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
      campaignsByEndUserId: {},
      campaignResultsById: {},
      campaignMembersResponseByKey: {},
      announcementDraft: {},
      NPSDraft: {},
      testCampaignEmails: {},
      updateCampaignStateById: {}
    };
  },


  handlers: {
    fetchCampaignsDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FETCH_DONE,
    fetchCampaignDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_FETCH_DONE,
    createCampaignDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_DONE,
    updateCampaignDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_DONE,
    updateCampaignFailed: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED,

    fetchCampaignResultsDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESULTS_FETCH_DONE,
    fetchCampaignMembersDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_MEMBERS_FETCH_DONE,

    fetchCampaignsForEndUserIdDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FOR_END_USER_FETCH_DONE,

    saveAnnouncementDraft: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].SAVE_ANNOUNCEMENT_DRAFT,
    saveNPSDraft: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].SAVE_NPS_DRAFT,

    deleteCampaign: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_DELETE_DONE,

    sendTestCampaignStarting: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_STARTING,
    sendTestCampaignDone: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_DONE,
    sendTestCampaignFailed: __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].SEND_TEST_CAMPAIGN_FAILED
  },

  saveAnnouncementDraft: function saveAnnouncementDraft(updates) {
    var announcementDraft = _.cloneDeep(this.state.announcementDraft);
    announcementDraft = _.assign(announcementDraft, updates);
    return this.setState({ announcementDraft: announcementDraft });
  },
  saveNPSDraft: function saveNPSDraft(updates) {
    var NPSDraft = _.cloneDeep(this.state.NPSDraft);
    NPSDraft = _.assign(NPSDraft, updates);
    return this.setState({ NPSDraft: NPSDraft });
  },
  getAnnouncementDraft: function getAnnouncementDraft() {
    return this.state.announcementDraft;
  },
  resetAnnouncementDraft: function resetAnnouncementDraft() {
    return this.setState({ announcementDraft: {} });
  },
  getNPSDraft: function getNPSDraft() {
    return this.state.NPSDraft;
  },
  resetNPSDraft: function resetNPSDraft() {
    return this.setState({ NPSDraft: {} });
  },
  getOrFetchCampaigns: function getOrFetchCampaigns() {
    return this.fetch({
      id: 'getOrFetchCampaigns',

      locally: function locally() {
        if (this.hasAlreadyFetched('getOrFetchCampaigns')) {
          return this.state.campaignsById;
        }
      },
      remotely: function remotely() {
        return this.app.queries.CampaignQueries.fetchCampaigns();
      }
    });
  },
  getOrFetchCampaign: function getOrFetchCampaign(id) {
    var accessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return this.fetch({
      id: 'getOrFetchCampaign' + id,
      locally: function locally() {
        return this.state.campaignsById[id];
      },
      remotely: function remotely() {
        return this.app.queries.CampaignQueries.fetchCampaign(id, accessToken);
      }
    });
  },
  getOrFetchCampaignsForEndUserId: function getOrFetchCampaignsForEndUserId(endUserId) {
    return this.fetch({
      id: 'getOrFetchCampaignsForEndUserId' + endUserId,

      locally: function locally() {
        return this.state.campaignsByEndUserId[endUserId];
      },
      remotely: function remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignsForEndUserId(endUserId);
      }
    });
  },
  getOrFetchCampaignResults: function getOrFetchCampaignResults(campaignId) {
    return this.fetch({
      id: 'getOrFetchCampaignResults' + campaignId,

      locally: function locally() {
        return this.state.campaignResultsById[campaignId];
      },
      remotely: function remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignResults(campaignId);
      }
    });
  },
  campaignPeriodKey: function campaignPeriodKey(campaignId, periodTimestamp) {
    var key = campaignId;
    if (periodTimestamp != null) {
      key += '-' + periodTimestamp;
    }
    return key;
  },
  getOrFetchCampaignMembers: function getOrFetchCampaignMembers(campaignId, query) {
    var key = '' + campaignId + (query != null ? JSON.stringify(query) : '');
    return this.fetch({
      id: 'getOrFetchCampaignMembers' + key,

      locally: function locally() {
        return this.state.campaignMembersResponseByKey[key];
      },
      remotely: function remotely() {
        return this.app.queries.CampaignQueries.fetchCampaignMembers(campaignId, query);
      }
    });
  },
  fetchCampaignResultsDone: function fetchCampaignResultsDone(campaignId, results) {
    var campaignResultsById = _.cloneDeep(this.state.campaignResultsById);
    campaignResultsById[campaignId] = results;
    return this.setState({ campaignResultsById: campaignResultsById });
  },
  fetchCampaignMembersDone: function fetchCampaignMembersDone(campaignId, query, response) {
    var campaignMembersResponseByKey = _.cloneDeep(this.state.campaignMembersResponseByKey);
    var key = '' + campaignId + (query != null ? JSON.stringify(query) : '');
    campaignMembersResponseByKey[key] = response;
    return this.setState({ campaignMembersResponseByKey: campaignMembersResponseByKey });
  },
  fetchCampaignsDone: function fetchCampaignsDone(campaigns) {
    var campaignsById = _.cloneDeep(this.state.campaignsById);
    _.each(campaigns, function (campaign) {
      return campaignsById[campaign.id] = campaign;
    });
    return this.setState({ campaignsById: campaignsById });
  },
  setCampaign: function setCampaign(id, campaign) {
    var campaignsById = _.cloneDeep(this.state.campaignsById);
    campaignsById[id] = campaign;
    var newState = { campaignsById: campaignsById };
    if (campaign.type === 'BOT') {
      newState.interactionIdsByCampaignId = this.state.interactionIdsByCampaignId.set(campaign.id, campaign.attributes.interactionId);
    }
    return this.setState(newState);
  },
  fetchCampaignDone: function fetchCampaignDone(id, campaign) {
    return this.setCampaign(id, campaign);
  },
  updateCampaignDone: function updateCampaignDone(id, campaign) {
    this.setCampaign(id, campaign);
    this.state.updateCampaignStateById[id] = campaign;
    return this.setState({ updateCampaignStateById: this.state.updateCampaignStateById });
  },
  updateCampaignFailed: function updateCampaignFailed(id, campaign) {
    this.state.updateCampaignStateById[id] = __WEBPACK_IMPORTED_MODULE_2_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED;
    return this.setState({ updateCampaignStateById: this.state.updateCampaignStateById });
  },
  getUpdateCampaignStateById: function getUpdateCampaignStateById() {
    return this.state.updateCampaignStateById;
  },
  createCampaignDone: function createCampaignDone(campaign) {
    return this.setCampaign(campaign.id, campaign);
  },
  fetchCampaignsForEndUserIdDone: function fetchCampaignsForEndUserIdDone(endUserId, campaigns) {
    var campaignsByEndUserId = _.cloneDeep(this.state.campaignsByEndUserId);
    campaignsByEndUserId[endUserId] = campaigns;
    return this.setState({ campaignsByEndUserId: campaignsByEndUserId });
  },
  deleteCampaign: function deleteCampaign(campaignId) {
    var campaignsById = _.cloneDeep(this.state.campaignsById);
    delete campaignsById[campaignId];
    return this.setState({ campaignsById: campaignsById });
  },
  getTestCampaignStatus: function getTestCampaignStatus(campaign) {
    return _.cloneDeep(this.state.testCampaignEmails[campaign.name]);
  },
  sendTestCampaignStarting: function sendTestCampaignStarting(campaign, emails) {
    var testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails);
    testCampaignEmails[campaign.name] = { sending: true };
    return this.setState({ testCampaignEmails: testCampaignEmails });
  },
  sendTestCampaignDone: function sendTestCampaignDone(campaign, emails) {
    var testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails);
    testCampaignEmails[campaign.name] = { sending: false, success: true };
    return this.setState({ testCampaignEmails: testCampaignEmails });
  },
  sendTestCampaignFailed: function sendTestCampaignFailed(campaign, emails) {
    var testCampaignEmails = _.cloneDeep(this.state.testCampaignEmails);
    testCampaignEmails[campaign.name] = { sending: false, success: false };
    return this.setState({ testCampaignEmails: testCampaignEmails });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CampaignStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "JMAf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentUserStarted", function() { return fetchCurrentUserStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentUserFailed", function() { return fetchCurrentUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchCurrentUserStarted", function() { return patchCurrentUserStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchCurrentUserFailed", function() { return patchCurrentUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveCurrentUser", function() { return receiveCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClearbitForEmail", function() { return fetchClearbitForEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClearbitForEmailSuccess", function() { return fetchClearbitForEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClearbitForEmailFailed", function() { return fetchClearbitForEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClearbitForEmailPending", function() { return fetchClearbitForEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGoogleScopes", function() { return fetchGoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGoogleScopesSuccess", function() { return fetchGoogleScopesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGoogleScopesFailed", function() { return fetchGoogleScopesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGoogleScopesPending", function() { return fetchGoogleScopesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmailSignature", function() { return fetchEmailSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmailSignatureSuccess", function() { return fetchEmailSignatureSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmailSignatureFailed", function() { return fetchEmailSignatureFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmailSignaturePending", function() { return fetchEmailSignaturePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEmailSignature", function() { return resetEmailSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmailSignature", function() { return setEmailSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmailSignatureSuccess", function() { return setEmailSignatureSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmailSignatureFailed", function() { return setEmailSignatureFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgUsersStarted", function() { return fetchOrgUsersStarted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgUsersFailed", function() { return fetchOrgUsersFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrgUsers", function() { return receiveOrgUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveOrgUser", function() { return receiveOrgUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiveGates", function() { return receiveGates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turnOffManualAway", function() { return turnOffManualAway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turnOffManualAwayPending", function() { return turnOffManualAwayPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turnOffManualAwaySuccess", function() { return turnOffManualAwaySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "turnOffManualAwayFailure", function() { return turnOffManualAwayFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgSignature", function() { return fetchOrgSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgSignaturePending", function() { return fetchOrgSignaturePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgSignatureFailed", function() { return fetchOrgSignatureFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgSignatureCancelled", function() { return fetchOrgSignatureCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgSignatureSuccess", function() { return fetchOrgSignatureSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgMultiSignature", function() { return fetchOrgMultiSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgMultiSignaturePending", function() { return fetchOrgMultiSignaturePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgMultiSignatureFailed", function() { return fetchOrgMultiSignatureFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgMultiSignatureCancelled", function() { return fetchOrgMultiSignatureCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgMultiSignatureSuccess", function() { return fetchOrgMultiSignatureSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disconnectGmailAccount", function() { return disconnectGmailAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disconnectGmailAccountPending", function() { return disconnectGmailAccountPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disconnectGmailAccountSuccess", function() { return disconnectGmailAccountSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disconnectGmailAccountFailure", function() { return disconnectGmailAccountFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndividualUserConvoLimit", function() { return fetchIndividualUserConvoLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndividualUserConvoLimitPending", function() { return fetchIndividualUserConvoLimitPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndividualUserConvoLimitFailed", function() { return fetchIndividualUserConvoLimitFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndividualUserConvoLimitCancelled", function() { return fetchIndividualUserConvoLimitCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndividualUserConvoLimitSuccess", function() { return fetchIndividualUserConvoLimitSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIndividualUserConvoLimit", function() { return updateIndividualUserConvoLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIndividualUserConvoLimitPending", function() { return updateIndividualUserConvoLimitPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIndividualUserConvoLimitFailed", function() { return updateIndividualUserConvoLimitFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIndividualUserConvoLimitCancelled", function() { return updateIndividualUserConvoLimitCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIndividualUserConvoLimitSuccess", function() { return updateIndividualUserConvoLimitSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUser", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserPending", function() { return updateUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserFailed", function() { return updateUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserCancelled", function() { return updateUserCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserSuccess", function() { return updateUserSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentUser", function() { return fetchCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refreshCurrentUser", function() { return refreshCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCurrentUser", function() { return updateCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOrgUsers", function() { return fetchOrgUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrgUserStatus", function() { return updateOrgUserStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_memoize__ = __webpack_require__("8hab");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_selectors_Org__ = __webpack_require__("MQdo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("aJZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("+Z1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__demodata__ = __webpack_require__("jpZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);










var fetchCurrentUserStarted = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["k" /* FETCH_CURRENT_USER_STARTED */]);
var fetchCurrentUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["j" /* FETCH_CURRENT_USER_FAILED */]);
var patchCurrentUserStarted = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["L" /* PATCH_CURRENT_USER_STARTED */]);
var patchCurrentUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["K" /* PATCH_CURRENT_USER_FAILED */]);
var receiveCurrentUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* RECEIVE_CURRENT_USER */]);

var fetchClearbitForEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* FETCH_CLEARBIT_FOR_EMAIL */]);
var fetchClearbitForEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* FETCH_CLEARBIT_FOR_EMAIL_SUCCESS */]);
var fetchClearbitForEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* FETCH_CLEARBIT_FOR_EMAIL_FAILED */]);
var fetchClearbitForEmailPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* FETCH_CLEARBIT_FOR_EMAIL_PENDING */]);

var fetchGoogleScopes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["p" /* FETCH_GOOGLE_SCOPES */]);
var fetchGoogleScopesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["s" /* FETCH_GOOGLE_SCOPES_SUCCESS */]);
var fetchGoogleScopesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["q" /* FETCH_GOOGLE_SCOPES_FAILED */]);
var fetchGoogleScopesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["r" /* FETCH_GOOGLE_SCOPES_PENDING */]);

var fetchEmailSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["l" /* FETCH_EMAIL_SIGNATURE */]);
var fetchEmailSignatureSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["o" /* FETCH_EMAIL_SIGNATURE_SUCCESS */]);
var fetchEmailSignatureFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["m" /* FETCH_EMAIL_SIGNATURE_FAILED */]);
var fetchEmailSignaturePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["n" /* FETCH_EMAIL_SIGNATURE_PENDING */]);

var resetEmailSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["R" /* RESET_EMAIL_SIGNATURE */]);

var setEmailSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["S" /* SET_EMAIL_SIGNATURE */]);
var setEmailSignatureSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["U" /* SET_EMAIL_SIGNATURE_SUCCESS */]);
var setEmailSignatureFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["T" /* SET_EMAIL_SIGNATURE_FAILED */]);

var fetchOrgUsersStarted = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["J" /* FETCH_ORG_USERS_STARTED */]);
var fetchOrgUsersFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["I" /* FETCH_ORG_USERS_FAILED */]);
var receiveOrgUsers = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* RECEIVE_ORG_USERS */]);
var receiveOrgUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["P" /* RECEIVE_ORG_USER */]);

var receiveGates = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["O" /* RECEIVE_GATES */]);

var turnOffManualAway = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["V" /* TURN_OFF_MANUAL_AWAY */]);
var turnOffManualAwayPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["X" /* TURN_OFF_MANUAL_AWAY_PENDING */]);
var turnOffManualAwaySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["Y" /* TURN_OFF_MANUAL_AWAY_SUCCESS */]);
var turnOffManualAwayFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["W" /* TURN_OFF_MANUAL_AWAY_FAILURE */]);

var fetchOrgSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["D" /* FETCH_ORG_SIGNATURE */]);
var fetchOrgSignaturePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["G" /* FETCH_ORG_SIGNATURE_PENDING */]);
var fetchOrgSignatureFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["F" /* FETCH_ORG_SIGNATURE_FAILED */]);
var fetchOrgSignatureCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["E" /* FETCH_ORG_SIGNATURE_CANCELLED */]);
var fetchOrgSignatureSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["H" /* FETCH_ORG_SIGNATURE_SUCCESS */]);

var fetchOrgMultiSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["y" /* FETCH_ORG_MULTI_SIGNATURE */]);
var fetchOrgMultiSignaturePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["B" /* FETCH_ORG_MULTI_SIGNATURE_PENDING */]);
var fetchOrgMultiSignatureFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["A" /* FETCH_ORG_MULTI_SIGNATURE_FAILED */]);
var fetchOrgMultiSignatureCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["z" /* FETCH_ORG_MULTI_SIGNATURE_CANCELLED */]);
var fetchOrgMultiSignatureSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["C" /* FETCH_ORG_MULTI_SIGNATURE_SUCCESS */]);

var disconnectGmailAccount = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* DISCONNECT_GMAIL_ACCOUNT */]);
var disconnectGmailAccountPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DISCONNECT_GMAIL_ACCOUNT_PENDING */]);
var disconnectGmailAccountSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* DISCONNECT_GMAIL_ACCOUNT_SUCCESS */]);
var disconnectGmailAccountFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* DISCONNECT_GMAIL_ACCOUNT_FAILURE */]);

var fetchIndividualUserConvoLimit = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["t" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT */]);
var fetchIndividualUserConvoLimitPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["w" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING */]);
var fetchIndividualUserConvoLimitFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["v" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED */]);
var fetchIndividualUserConvoLimitCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["u" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED */]);
var fetchIndividualUserConvoLimitSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["x" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS */]);

var updateIndividualUserConvoLimit = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["Z" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT */]);
var updateIndividualUserConvoLimitPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_2" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING */]);
var updateIndividualUserConvoLimitFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED */]);
var updateIndividualUserConvoLimitCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_0" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED */]);
var updateIndividualUserConvoLimitSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_3" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS */]);

var updateUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_4" /* UPDATE_USER */]);
var updateUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_7" /* UPDATE_USER_PENDING */]);
var updateUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_6" /* UPDATE_USER_FAILED */]);
var updateUserCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_5" /* UPDATE_USER_CANCELLED */]);
var updateUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_3__constants__["_8" /* UPDATE_USER_SUCCESS */]);

var fetchCurrentUser = Object(__WEBPACK_IMPORTED_MODULE_1_app_api_memoize__["a" /* default */])(function () {
  return function (dispatch, getState) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["currentUserLoaded"])(getState())) {
      dispatch(fetchCurrentUserStarted());
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchCurrent().then(function (user) {
        return dispatch(receiveCurrentUser(user));
      }).catch(function (error) {
        return dispatch(fetchCurrentUserFailed(error));
      });
    } else {
      return Promise.resolve();
    }
  };
});

var refreshCurrentUser = function refreshCurrentUser() {
  return function (dispatch) {
    dispatch(fetchCurrentUserStarted());

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchCurrent().then(function (user) {
      dispatch(receiveCurrentUser(user));
      dispatch(receiveGates(user.gates));
    }).catch(function (error) {
      dispatch(fetchCurrentUserFailed(error));
      return Promise.reject();
    });
  };
};

var updateCurrentUser = function updateCurrentUser(updates) {
  return function (dispatch, getState) {
    dispatch(patchCurrentUserStarted());
    var user = Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["currentUser"])(getState());
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].patchUser(user.id, updates).then(function (user) {
      return dispatch(receiveCurrentUser(user));
    }).catch(function (error) {
      dispatch(patchCurrentUserFailed(error));
      return Promise.reject();
    });
  };
};

// should really live under org
var fetchOrgUsers = function fetchOrgUsers() {
  return function (dispatch, getState) {
    if (__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      dispatch(fetchOrgUsersStarted());
      var orgId = Object(__WEBPACK_IMPORTED_MODULE_2_app_selectors_Org__["a" /* getOrgId */])(getState());
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchUsers(orgId).then(function (users) {
        return dispatch(receiveOrgUsers(users.merge(Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_7__demodata__["a" /* users */](orgId)).map(__WEBPACK_IMPORTED_MODULE_4__api__["b" /* parseUser */]))));
      }).catch(function (error) {
        return dispatch(fetchOrgUsersFailed(error));
      });
    } else {
      dispatch(fetchOrgUsersStarted());
      var _orgId = Object(__WEBPACK_IMPORTED_MODULE_2_app_selectors_Org__["a" /* getOrgId */])(getState());
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchUsers(_orgId).then(function (users) {
        return dispatch(receiveOrgUsers(users));
      }).catch(function (error) {
        return dispatch(fetchOrgUsersFailed(error));
      });
    }
  };
};

var updateOrgUserStatus = function updateOrgUserStatus(id, updates) {
  return function (dispatch) {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].setOrgUserStatus(id, updates).then(function () {
      return dispatch(fetchOrgUsers());
    }).catch(function (error) {
      dispatch(patchCurrentUserFailed(error));
      return Promise.reject();
    });
  };
};

/***/ }),

/***/ "JRbK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AddButton_index__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OwnerMappingRow__ = __webpack_require__("mXWR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_svg_hubspot_empty_user_mapping_svg__ = __webpack_require__("j5zp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_svg_hubspot_empty_user_mapping_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_svg_hubspot_empty_user_mapping_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("fQqe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var OwnerMapper = function (_PureComponent) {
  _inherits(OwnerMapper, _PureComponent);

  function OwnerMapper(props) {
    _classCallCheck(this, OwnerMapper);

    var _this = _possibleConstructorReturn(this, (OwnerMapper.__proto__ || Object.getPrototypeOf(OwnerMapper)).call(this, props));

    _this.getFormattedUserOptions = function (users) {
      return Object.values(users).map(function (user) {
        return { value: user.id, label: Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user) };
      });
    };

    _this.isValid = function () {

      var hasInvalidOptions = _.some(_this.state.userMappings, function (_ref) {
        var integrationUserId = _ref.integrationUserId,
            driftUserId = _ref.driftUserId;

        return integrationUserId && !driftUserId || !integrationUserId && driftUserId;
      });

      return !_this.state.userMappings.length || !hasInvalidOptions;
    };

    _this.onMappingsChange = function () {
      var userMappings = _this.state.userMappings;


      if (_this.isValid()) {
        _this.saveMappings();
      }

      if (!userMappings.length) _this.addNewMapping();
    };

    _this.getIntegrationUserOptions = function (id) {
      var mappedIds = _this.state.userMappings.map(function (mapping) {
        return mapping.integrationUserId;
      }).filter(function (integrationId) {
        return integrationId !== id;
      });

      return _this.props.integrationUsers.filter(function (user) {
        return !mappedIds.includes(user.id);
      }).map(function (user) {
        return { label: user.name, value: user.id };
      });
    };

    _this.searchIntegrationUsers = function (query, index) {
      _this.setState({
        hasActiveSearch: query.length ? index : null
      });

      !!query.length && _this.debouncedSearch(query);
      return query;
    };

    _this.debouncedSearch = _.debounce(function (query) {
      _this.props.searchIntegrationUsers(query);
    }, 500);

    _this.addNewMapping = function () {
      var emptyMap = _extends({}, _this.props.userMappingModel);

      _this.setState(function (prevState) {
        return {
          userMappings: prevState.userMappings.concat(emptyMap)
        };
      });
    };

    _this.removeMapping = function (index) {
      var mappings = [].concat(_toConsumableArray(_this.state.userMappings));
      mappings.splice(index, 1);

      _this.setState({
        userMappings: mappings
      }, _this.onMappingsChange);
    };

    _this.saveIntegrationOption = function (value, index) {
      var mappings = [].concat(_toConsumableArray(_this.state.userMappings));
      mappings[index].integrationUserId = value ? value.value : null;

      _this.setState({ userMapping: mappings }, _this.onMappingsChange);
    };

    _this.saveDriftUserOption = function (value, index) {
      var mappings = [].concat(_toConsumableArray(_this.state.userMappings));
      mappings[index].driftUserId = value ? value.value : null;

      _this.setState({ userMapping: mappings }, _this.onMappingsChange);
    };

    _this.state = {
      userMappings: _.cloneDeep(props.mappings) || [],
      pendingInvites: null,
      invitedIndex: null,
      hasActiveSearch: null,
      waitingForInvitedUsers: false
    };
    return _this;
  }

  _createClass(OwnerMapper, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      var _state = this.state,
          waitingForInvitedUsers = _state.waitingForInvitedUsers,
          pendingInvites = _state.pendingInvites,
          invitedIndex = _state.invitedIndex;
      var driftUsers = this.props.driftUsers;


      if (waitingForInvitedUsers) {
        var pendingUser = Object.values(driftUsers).filter(function (user) {
          return user.email === pendingInvites[0];
        });
        if (!pendingUser.length) {
          this.props.fetchOrgUsers();
        } else {
          this.saveDriftUserOption({ value: pendingUser[0].id }, invitedIndex);
          this.setState({
            pendingInvites: null,
            invitedIndex: null,
            waitingForInvitedUsers: false
          });
        }
      }
    }
  }, {
    key: 'saveMappings',
    value: function saveMappings() {
      var _this2 = this;

      var _props = this.props,
          patchMappings = _props.patchMappings,
          notifications = _props.notifications,
          integrationName = _props.integrationName;

      var userMappingsWithoutEmptyRows = this.state.userMappings.filter(function (mapping) {
        return !_.isEqual(mapping, _this2.props.userMappingModel);
      });
      patchMappings({ mappings: userMappingsWithoutEmptyRows }, function () {
        notifications.success('You\'ve successfully updated your ' + integrationName + ' owner mappings!');
      });
    }
  }, {
    key: 'renderMappingRows',
    value: function renderMappingRows() {
      var _this3 = this;

      var _state2 = this.state,
          userMappings = _state2.userMappings,
          hasActiveSearch = _state2.hasActiveSearch;
      var _props2 = this.props,
          isSearching = _props2.isSearching,
          integrationName = _props2.integrationName,
          driftUsers = _props2.driftUsers;

      var formattedDriftUsers = this.getFormattedUserOptions(driftUsers);

      return userMappings.map(function (mapping, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OwnerMappingRow__["a" /* default */], {
          integrationName: integrationName,
          key: index,
          index: index,
          mapping: mapping,
          isSearching: isSearching,
          driftUsers: formattedDriftUsers,
          getUserOptions: _this3.getIntegrationUserOptions,
          searchUsers: _this3.searchIntegrationUsers,
          saveOption: _this3.saveIntegrationOption,
          saveUserOption: _this3.saveDriftUserOption,
          hasActiveSearch: hasActiveSearch,
          onMappingRemove: _this3.removeMapping
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var integrationName = this.props.integrationName;
      var userMappings = this.state.userMappings;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'integration-user-mapping' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'drift-table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              { className: 'integration-user-mapping-header' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                integrationName,
                ' User'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'integration-user-mapping-table-seperator' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                'Drift Teammate'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'integration-user-mapping-actions' })
            )
          ),
          !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["isEmpty"])(userMappings) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            this.renderMappingRows()
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            { className: 'hubspot-user-mapping-empty-state' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6_images_svg_hubspot_empty_user_mapping_svg___default.a })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'You don\u2019t have any users mapped between Drift and Hubspot yet.'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AddButton_index__["a" /* default */], {
          addButtonLabel: 'Map New ' + integrationName + ' User',
          type: 'tertiary',
          onClick: this.addNewMapping
        })
      );
    }
  }]);

  return OwnerMapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(OwnerMapper));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "JSzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* unused harmony export defaultContentStyle */
/* unused harmony export defaultOverlayStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_modal__ = __webpack_require__("sW0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("3cP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var defaultContentStyle = {
  // This is how to get rid of default styles from the lib ATM
  position: '',
  top: '',
  left: '',
  right: '',
  bottom: '',
  overflow: '',
  background: '#fff',
  outline: 'none'
};

var defaultOverlayStyle = {
  backgroundColor: 'rgba(28,35,39,0.8)',
  zIndex: 10001
};

var Wrapper = function Wrapper(_ref) {
  var style = _ref.style,
      rest = _objectWithoutProperties(_ref, ['style']);

  return React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_modal___default.a, _extends({
    portalClassName: 'DefaultModalPortal',
    contentLabel: 'Modal'
  }, rest, {
    style: {
      overlay: _extends({}, defaultOverlayStyle, style && style.overlay || {}),
      content: _extends({}, defaultContentStyle, { borderRadius: 4, border: '1px solid #ccc' }, style && style.content || {})
    }
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Wrapper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "JUti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_Card__ = __webpack_require__("RkbX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("wCVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);






var TitleCard = function TitleCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      className = _ref.className,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_shared_Card__["a" /* default */],
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.TitleCard, className) },
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: "header flex-space-between" },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'title' },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'subtitle' },
        subtitle
      )
    ),
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: 'content' },
      children
    )
  );
};
TitleCard.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (TitleCard);

/***/ }),

/***/ "JYZ/":
/***/ (function(module, exports) {

module.exports = "<svg width=\"30\" height=\"30\" viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27.188 30H2.812A2.815 2.815 0 0 1 0 27.187V13.124c0-.01.006-.02.006-.032.002-.07.023-.134.04-.2.014-.053.02-.107.043-.155.02-.05.06-.092.092-.14.038-.053.072-.11.12-.154.01-.01.012-.02.02-.028l3.755-3.252a.936.936 0 1 1 1.227 1.417l-3.048 2.642c.042.017.086.025.126.05L15 21.384l12.618-8.112c.04-.025.084-.032.127-.05l-3.052-2.643a.94.94 0 0 1 1.228-1.42l3.756 3.255c.01.008.012.02.02.028.05.044.084.1.122.156.032.045.07.086.093.137.024.05.03.103.043.155.018.067.038.13.04.2 0 .01.007.02.007.032v14.063C30 28.738 28.74 30 27.188 30zm1.06-14.903l-12.74 8.19a.936.936 0 0 1-1.015 0L1.816 15.14v12.047c0 .518.48.938.996.938h24.376c.516 0 1.06-.42 1.06-.938v-12.09zm-9.93-2.712c-.774-.307-1.256-.93-1.387-1.687a3.705 3.705 0 0 1-1.93.553 3.755 3.755 0 0 1-3.75-3.75A3.755 3.755 0 0 1 15 3.75c.718 0 1.383.214 1.954.565a.937.937 0 0 1 1.796.372v5.626c0 .078 0 .225.26.33.313.123.75.062.933-.13.73-.773.708-1.763.688-2.638l-.005-.375A5.63 5.63 0 0 0 15 1.875 5.63 5.63 0 0 0 9.375 7.5 5.632 5.632 0 0 0 15 13.126.938.938 0 0 1 15 15c-4.136 0-7.5-3.364-7.5-7.5C7.5 3.365 10.864 0 15 0s7.5 3.365 7.5 7.5l.006.333c.02.985.06 2.634-1.2 3.966-.717.76-1.945 1-2.988.585zM15 5.625c-1.035 0-1.876.84-1.876 1.875a1.876 1.876 0 0 0 3.75 0c0-1.034-.84-1.875-1.874-1.875z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "JYhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_profile__ = __webpack_require__("YEs/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__ = __webpack_require__("8Eel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("HRBm");












var DEFAULT_SLOT = Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["a" /* AvailabilitySlot */])({
  dayOfWeek: 'WEEKDAYS',
  startTime: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["b" /* AvailabilitySlotTime */])({
    hour: 9,
    minutes: 0
  }),
  endTime: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["b" /* AvailabilitySlotTime */])({
    hour: 17,
    minutes: 0
  })
});

function mapStateToProps(state) {
  return {
    meetingSettings: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__["m" /* getMeetingSettings */])(state),
    meetingStatus: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__["n" /* getMeetingSettingsStatus */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__["_23" /* updateMeetingSettings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_profile__["a" /* withProfile */])({ profileUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["profileUrl"], visibility: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectors__["visibility"] }), Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchMeetingSettings();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('errorMessageKey', 'setErrorMessageKey', null), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  validateAndMaybeUpdate: function validateAndMaybeUpdate(_ref) {
    var actions = _ref.actions,
        setErrorMessageKey = _ref.setErrorMessageKey;
    return function (settings) {
      if (settings.availability.every(function (slot) {
        return slot.startTime.hour < slot.endTime.hour || slot.startTime.hour === slot.endTime.hour && slot.startTime.minutes < slot.endTime.minutes;
      })) {
        actions.updateMeetingSettings(settings);
        setErrorMessageKey('');
      } else {
        setErrorMessageKey('PASTENDTIME');
      }
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  handleAddSlotClick: function handleAddSlotClick(_ref2) {
    var meetingSettings = _ref2.meetingSettings,
        validateAndMaybeUpdate = _ref2.validateAndMaybeUpdate;
    return function () {
      validateAndMaybeUpdate(meetingSettings.set('availability', meetingSettings.availability.push(DEFAULT_SLOT)));
    };
  },
  handleRemoveSlotClick: function handleRemoveSlotClick(_ref3) {
    var meetingSettings = _ref3.meetingSettings,
        validateAndMaybeUpdate = _ref3.validateAndMaybeUpdate;
    return function (slot) {
      validateAndMaybeUpdate(meetingSettings.set('availability', meetingSettings.availability.remove(slot)));
    };
  },
  handleSelectDayOfWeek: function handleSelectDayOfWeek(_ref4) {
    var meetingSettings = _ref4.meetingSettings,
        validateAndMaybeUpdate = _ref4.validateAndMaybeUpdate;
    return function (slot, dayOfWeek) {
      validateAndMaybeUpdate(meetingSettings.setIn(['availability', slot, 'dayOfWeek'], dayOfWeek));
    };
  },
  handleSelectStartTime: function handleSelectStartTime(_ref5) {
    var meetingSettings = _ref5.meetingSettings,
        validateAndMaybeUpdate = _ref5.validateAndMaybeUpdate;
    return function (slot, startTime) {
      validateAndMaybeUpdate(meetingSettings.mergeIn(['availability', slot, 'startTime'], startTime));
    };
  },
  handleSelectEndTime: function handleSelectEndTime(_ref6) {
    var meetingSettings = _ref6.meetingSettings,
        validateAndMaybeUpdate = _ref6.validateAndMaybeUpdate;
    return function (slot, endTime) {
      validateAndMaybeUpdate(meetingSettings.mergeIn(['availability', slot, 'endTime'], endTime));
    };
  },
  handleSelectTimezone: function handleSelectTimezone(_ref7) {
    var meetingSettings = _ref7.meetingSettings,
        actions = _ref7.actions;
    return function (_ref8) {
      var value = _ref8.value;

      actions.updateMeetingSettings(meetingSettings.set('timezone', value));
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref9) {
  var meetingSettings = _ref9.meetingSettings,
      setErrorMessageKey = _ref9.setErrorMessageKey;
  return {
    showRemoveSlotUI: meetingSettings.availability.size > 1,
    settingsErrorMessages: {
      PASTENDTIME: React.createElement(
        'span',
        null,
        'Make sure your availability\'s start time is before the end time!',
        ' ',
        React.createElement(
          'span',
          {
            className: 'dismiss-error',
            onClick: function onClick() {
              setErrorMessageKey('');
            }
          },
          'dismiss'
        )
      )
    }
  };
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "JbjM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jkun":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("NOwD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("Gaye");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "Jl+d":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(456);

/***/ }),

/***/ "JltT":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "Jm+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Email__ = __webpack_require__("4XJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MeetingTripwire__ = __webpack_require__("2xWa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_icon_layout_svg__ = __webpack_require__("bV3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_icon_layout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_icon_layout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_simple_text_svg__ = __webpack_require__("LFtc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_simple_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_simple_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_hero_layout_svg__ = __webpack_require__("wxyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_hero_layout_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_hero_layout_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("2g0C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



















var EmailTemplateSelect = function EmailTemplateSelect(_ref) {
  var onEmailLayoutSelect = _ref.onEmailLayoutSelect,
      marketingEmailLayout = _ref.marketingEmailLayout;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-sequence-layout-select' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-sequence-layout-select-header' },
      'Pick an email template'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-sequence-layout-select-options' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onClick: function onClick() {
            return onEmailLayoutSelect(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].SIMPLE);
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-sequence-layout-option', _defineProperty({}, 'playbook-sequence-layout-option-selected', marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].SIMPLE))
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-icon layout-option-simple' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_simple_text_svg___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-name' },
          'Simple Text'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onClick: function onClick() {
            return onEmailLayoutSelect(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_COMPANY_LOGO);
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-sequence-layout-option', _defineProperty({}, 'playbook-sequence-layout-option-selected', marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_COMPANY_LOGO))
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-icon' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_icon_layout_svg___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-name' },
          'Logo Styled'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onClick: function onClick() {
            return onEmailLayoutSelect(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_HERO_IMAGE);
          },
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-sequence-layout-option', _defineProperty({}, 'playbook-sequence-layout-option-selected', marketingEmailLayout === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_131" /* MarketingEmailLayouts */].WITH_HERO_IMAGE))
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-icon' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_hero_layout_svg___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-sequence-layout-option-name' },
          'Banner Styled'
        )
      )
    )
  );
};

var IndividualSenderToggle = function IndividualSenderToggle(_ref2) {
  var editSenderLevel = _ref2.editSenderLevel,
      onSetEditSenderLevel = _ref2.onSetEditSenderLevel;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-edit-sender-toggle-individual' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-edit-sender-toggle-label' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-sender-toggle-label-title' },
        'Edit sender for each email individually'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-sender-toggle-label-help' },
        editSenderLevel === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL ? 'currently editing sender for each email' : 'currently editing sender for all emails'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Toggle"], {
      className: 'playbook-table-row-status-toggle',
      checked: editSenderLevel === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL,
      onChange: onSetEditSenderLevel
    })
  );
};

var Sequence = function Sequence(_ref3) {
  var emails = _ref3.sequence.emails,
      onAddClick = _ref3.onAddClick,
      canSelectTemplate = _ref3.canSelectTemplate,
      onEmailLayoutSelect = _ref3.onEmailLayoutSelect,
      marketingEmailLayout = _ref3.marketingEmailLayout,
      isOneTimeMarketingSequencePlaybook = _ref3.isOneTimeMarketingSequencePlaybook,
      isMarketingSequencePlaybook = _ref3.isMarketingSequencePlaybook,
      showTripwire = _ref3.showTripwire,
      setShowTripwire = _ref3.setShowTripwire,
      sendTestSequencePending = _ref3.sendTestSequencePending,
      onSendTestSequence = _ref3.onSendTestSequence,
      editSenderLevel = _ref3.editSenderLevel,
      onSetEditSenderLevel = _ref3.onSetEditSenderLevel;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-sequence' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Build your ',
        isMarketingSequencePlaybook ? 'email' : 'sequence',
        '.'
      ),
      isMarketingSequencePlaybook ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Choose from one of three templates to get started.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Need help? We got you. Just ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '#marketing-email-help' },
            'click here'
          ),
          '.'
        )
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Create a set of emails to send to your leads.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Need help getting started? We got you. Just ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: '#sequence-help' },
            'click here'
          ),
          '.'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].isList(emails) && emails.size > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-sequence-extra-edit-options' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-sequence-send-test' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          'Send yourself the entire sequence as a test'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          { onClick: onSendTestSequence, disabled: sendTestSequencePending, loading: sendTestSequencePending, type: 'secondary' },
          'Send Test Sequence'
        )
      ),
      isMarketingSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndividualSenderToggle, {
        editSenderLevel: editSenderLevel,
        onSetEditSenderLevel: onSetEditSenderLevel
      })
    ),
    canSelectTemplate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmailTemplateSelect, {
      onEmailLayoutSelect: onEmailLayoutSelect,
      marketingEmailLayout: marketingEmailLayout }),
    emails.map(function (id, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Email__["a" /* default */], { key: id, id: id, index: index, setShowTripwire: setShowTripwire });
    }),
    !isOneTimeMarketingSequencePlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { onClick: onAddClick, className: 'drift-button' },
      'Add Email'
    ),
    showTripwire && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__MeetingTripwire__["a" /* default */], { setShowTripwire: setShowTripwire })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Sequence);

/***/ }),

/***/ "JmSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("FFPI");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var IP_ENRICHMENT_LIMIT = 50;

var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchDemandbaseCompanyDataPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchDemandbaseCompanyDataSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchDemandbaseCompanyDataFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchDemandbaseCompanyDataCancelled */]), function (state, action) {
  return action.type;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var data = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchDemandbaseCompanyDataSuccess */], function (state, action) {
  var _action$payload = action.payload,
      data = _action$payload.data,
      ip = _action$payload.ip,
      endUserId = _action$payload.endUserId;

  if (ip !== undefined) {
    return state.setIn('byIp', ip, data).takeLast(IP_ENRICHMENT_LIMIT);
  } else if (endUserId !== undefined) {
    return state.setIn('byEndUserId', endUserId, data);
  } else {
    return state;
  }
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var industries = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* fetchDemandbaseTargetingIndustriesSuccess */], function (state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());

var subIndustries = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* fetchDemandbaseTargetingSubIndustriesSuccess */], function (state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({ status: status, data: data, industries: industries, subIndustries: subIndustries }));

/***/ }),

/***/ "JmgY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CurrentTeamMembers__ = __webpack_require__("xv13");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("F4+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);









var ExtensionInviteModal = function ExtensionInviteModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      sendInvitationsViaEmail = _ref.sendInvitationsViaEmail,
      sendInvitationsViaSlack = _ref.sendInvitationsViaSlack,
      usersWithExtension = _ref.usersWithExtension;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__PlaybookModal__["a" /* default */],
    {
      title: 'Message',
      onCloseClick: onCloseClick,
      closeLabel: 'Close',
      showSaveStatus: false,
      contentClassName: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.ExtensionInviteModalContent,
      headerClassName: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.ExtensionInviteModalHeader,
      description: 'Send From'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'extension-invite-wrapper drift-form flex-column' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'extension-invite-cta' },
        'Teammates who have the Drift Extension installed'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex existing-extension-avatar' },
        usersWithExtension.map(function (user) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              key: user.id,
              title: Object(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user),
              style: { marginRight: '5px', position: 'relative' }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__["a" /* default */], { user: user })
          );
        }).toArray()
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CurrentTeamMembers__["a" /* default */], null)
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ExtensionInviteModal);

/***/ }),

/***/ "Jnvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var makeSnippet = function makeSnippet(segmentId) {
  return "\n  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"page\",\"once\",\"off\",\"on\"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement(\"script\");e.type=\"text/javascript\";e.async=!0;e.src=(\"https:\"===document.location.protocol?\"https://\":\"http://\")+\"cdn.segment.com/analytics.js/v1/\"+t+\"/analytics.min.js\";var n=document.getElementsByTagName(\"script\")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION=\"3.1.0\";\n  analytics.load(\"" + segmentId + "\");\n  }}();\n  ";
};

/* harmony default export */ __webpack_exports__["a"] = (makeSnippet);

/***/ }),

/***/ "Joq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_customer_CompanyCard_Header__ = __webpack_require__("bbMV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("SX5Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
  src: __webpack_require__("lT+U"),
  style: { width: 12, height: 12, marginRight: 6 }
});

var SegmentsCardPlaceholder = function SegmentsCardPlaceholder() {
  var placeholderShape = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 0, x: '0', y: '0', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 1, x: '0', y: '47', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { key: 2, x: '0', y: '94', width: '229', height: '27', rx: '2' })];

  var options = {
    height: 131,
    width: 229,
    primaryColor: __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
    secondaryColor: __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
    primaryOpacity: __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
    secondaryOpacity: __WEBPACK_IMPORTED_MODULE_13_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_14__style_styl__["segmentsCardPlaceholder"] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 })
  );
};

var Segment = function Segment(props) {
  var _props$segment = props.segment,
      id = _props$segment.id,
      name = _props$segment.name,
      createdAt = _props$segment.createdAt,
      className = props.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { key: id, style: { padding: '5 20px' }, className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
      {
        to: {
          pathname: '/contacts/segments/' + id
        },
        onClick: function onClick() {
          return Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_tracking_actions__["track"])('Conversation Sidebar - Segment Clicked');
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'dsg-Body' },
        name
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dsg-Regular color-navy-dark' },
      'Added ',
      __WEBPACK_IMPORTED_MODULE_2_moment___default()(createdAt).format('M/D/YY')
    )
  );
};

var SegmentsCard = function (_PureComponent) {
  _inherits(SegmentsCard, _PureComponent);

  function SegmentsCard() {
    _classCallCheck(this, SegmentsCard);

    return _possibleConstructorReturn(this, (SegmentsCard.__proto__ || Object.getPrototypeOf(SegmentsCard)).apply(this, arguments));
  }

  _createClass(SegmentsCard, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.segmentListLoaded) {
        this.props.actions.fetchSegmentList();
      }
      if (!this.props.endUserSegmentsLoaded) {
        this.props.actions.fetchEndUserMembership({ endUserId: this.props.endUserId });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.endUser !== nextProps.endUser) {
        this.props.actions.fetchEndUserMembership({ endUserId: nextProps.endUserId });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var endUserSegments = this.props.endUserSegments;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('dsg-card', this.props.className), style: { marginBottom: '1rem' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_customer_CompanyCard_Header__["a" /* default */], {
          label: 'segments',
          icon: Icon
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: '20px 0' } },
          endUserSegments.valueSeq().map(function (segment) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Segment, { key: segment.id, segment: segment, className: _this2.props.segmentClassName });
          })
        )
      );
    }
  }]);

  return SegmentsCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var makeMapStateToProps = function makeMapStateToProps() {
  var endUserSelector = __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_selectors__["g" /* makeEndUserSelector */]();
  return function (state, props) {
    var endUserId = props.endUserId;

    return {
      endUserSegments: __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_selectors__["c" /* endUserSegments */](state, { endUserId: endUserId }),
      endUserSegmentsLoaded: __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_selectors__["b" /* endUserMembershipByIdFetched */](state, { endUserId: endUserId }),
      segmentListLoaded: __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_selectors__["d" /* segmentListLoaded */](state, { endUserId: endUserId }),
      endUser: endUserSelector(state, { id: props.endUserId })
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      fetchEndUserMembership: __WEBPACK_IMPORTED_MODULE_8_app_modules_segment_actions__["a" /* fetchEndUserMembership */],
      fetchSegmentList: __WEBPACK_IMPORTED_MODULE_8_app_modules_segment_actions__["d" /* fetchSegmentList */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* branch */])(function (props) {
  return !props.endUserId;
}, Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["f" /* renderComponent */])(SegmentsCardPlaceholder)))(SegmentsCard));

/***/ }),

/***/ "Jp3r":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 31 31\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-3\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"apps\" transform=\"translate(-755.000000, -671.000000)\"><g id=\"Group\" transform=\"translate(755.000000, 671.000000)\"><g id=\"Group-3\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Clip-2\"></g><path d=\"M29.2457992,30.954142 C30.1891674,30.954142 30.954142,30.1911752 30.954142,29.2502018 L30.954142,1.78502219 C30.954142,0.843805037 30.1891674,0.0810819783 29.2457992,0.0810819783 L1.70842426,0.0810819783 C0.764648766,0.0810819783 0,0.843805037 0,1.78502219 L0,29.2502018 C0,30.1911752 0.764648766,30.954142 1.70842426,30.954142 L29.2457992,30.954142\" id=\"Fill-1\" fill=\"#3A5285\" mask=\"url(#mask-2)\"></path></g><path d=\"M20.4360407,31 L20.4360407,19.0349679 L24.3029792,19.0349679 L24.8818144,14.3718447 L20.4360407,14.3718447 L20.4360407,11.3947344 C20.4360407,10.0446882 20.7970103,9.12460133 22.6610412,9.12460133 L25.0384615,9.12354432 L25.0384615,4.95290665 C24.6271551,4.89615332 23.2159996,4.76923077 21.57414,4.76923077 C18.1464555,4.76923077 15.799801,6.94228146 15.799801,10.9330648 L15.799801,14.3718447 L11.9230769,14.3718447 L11.9230769,19.0349679 L15.799801,19.0349679 L15.799801,31 L20.4360407,31\" id=\"Fill-4\" fill=\"#FFFFFE\"></path></g></g></g></svg>"

/***/ }),

/***/ "JpL5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  "value": "1_and_1_hosting",
  "label": "1&1 Hosting"
}, {
  "value": "3d_cart",
  "label": "3d Cart"
}, {
  "value": "acquisio",
  "label": "Acquisio"
}, {
  "value": "activecampaign",
  "label": "Activecampaign"
}, {
  "value": "add_to_any",
  "label": "Add To Any"
}, {
  "value": "adobe_business_catalyst",
  "label": "Adobe Business Catalyst"
}, {
  "value": "adobe_connect",
  "label": "Adobe Connect"
}, {
  "value": "adobe_dynamic_tag_management",
  "label": "Adobe Dynamic Tag Management"
}, {
  "value": "adroll",
  "label": "AdRoll"
}, {
  "value": "airbrake",
  "label": "Airbrake"
}, {
  "value": "akamai",
  "label": "Akamai"
}, {
  "value": "akamai_dns",
  "label": "Akamai DNS"
}, {
  "value": "alexa",
  "label": "Alexa"
}, {
  "value": "altocloud",
  "label": "Altocloud"
}, {
  "value": "amazon_associates",
  "label": "Amazon Associates"
}, {
  "value": "amazon_payments",
  "label": "Amazon Payments"
}, {
  "value": "amazon_s3",
  "label": "Amazon S3"
}, {
  "value": "amazon_ses",
  "label": "Amazon Simple Email Service"
}, {
  "value": "amcharts",
  "label": "amCharts"
}, {
  "value": "amplitude",
  "label": "Amplitude"
}, {
  "value": "android",
  "label": "Android"
}, {
  "value": "apache",
  "label": "Apache"
}, {
  "value": "app_nexus",
  "label": "App Nexus"
}, {
  "value": "appboy",
  "label": "Appboy"
}, {
  "value": "appcues",
  "label": "Appcues"
}, {
  "value": "appdynamics",
  "label": "AppDynamics"
}, {
  "value": "apteligent",
  "label": "Apteligent"
}, {
  "value": "asp_net",
  "label": "ASP.Net"
}, {
  "value": "attribution",
  "label": "Attribution"
}, {
  "value": "authorizenet",
  "label": "Authorizenet"
}, {
  "value": "autopilot",
  "label": "Autopilot"
}, {
  "value": "aweber",
  "label": "Aweber"
}, {
  "value": "aws_ec2",
  "label": "Amazon Web Services"
}, {
  "value": "aws_route_53",
  "label": "Route 53"
}, {
  "value": "bazaarvoice",
  "label": "Bazaarvoice"
}, {
  "value": "benchmarkemail",
  "label": "Benchmarkemail"
}, {
  "value": "big_cartel",
  "label": "Big Cartel"
}, {
  "value": "bigcommerce",
  "label": "Bigcommerce"
}, {
  "value": "bing_ads",
  "label": "Bing Ads"
}, {
  "value": "bing_advertiser",
  "label": "Bing Advertiser"
}, {
  "value": "bing_maps",
  "label": "Bing Maps"
}, {
  "value": "bloomreach",
  "label": "Bloomreach"
}, {
  "value": "bluehost_hosting",
  "label": "Bluehost Hosting"
}, {
  "value": "braintree",
  "label": "Braintree"
}, {
  "value": "branch",
  "label": "Branch"
}, {
  "value": "brightcove",
  "label": "Brightcove"
}, {
  "value": "bronto",
  "label": "Bronto"
}, {
  "value": "bug_herd",
  "label": "Bug Herd"
}, {
  "value": "bugsnag",
  "label": "Bugsnag"
}, {
  "value": "calq",
  "label": "Calq"
}, {
  "value": "campaignmonitor",
  "label": "Campaignmonitor"
}, {
  "value": "castle",
  "label": "Castle"
}, {
  "value": "centos",
  "label": "CentOS"
}, {
  "value": "chargify",
  "label": "Chargify"
}, {
  "value": "chart_beat",
  "label": "Chart Beat"
}, {
  "value": "chartio",
  "label": "Chartio"
}, {
  "value": "chatlio",
  "label": "Chatlio"
}, {
  "value": "chownow",
  "label": "Chownow"
}, {
  "value": "clickfunnels",
  "label": "ClickFunnels"
}, {
  "value": "clicktale",
  "label": "Clicktale"
}, {
  "value": "clicky",
  "label": "Clicky"
}, {
  "value": "cloud_flare",
  "label": "Cloud Flare"
}, {
  "value": "cloudinary",
  "label": "Cloudinary"
}, {
  "value": "commerce_sciences",
  "label": "Commerce Sciences"
}, {
  "value": "constant_contact",
  "label": "Constant Contact"
}, {
  "value": "contently",
  "label": "Contently"
}, {
  "value": "convert_kit",
  "label": "Convert Kit"
}, {
  "value": "crazy_egg",
  "label": "Crazy Egg"
}, {
  "value": "criteo",
  "label": "Criteo"
}, {
  "value": "customer_io",
  "label": "Customer.io"
}, {
  "value": "debian",
  "label": "Debian"
}, {
  "value": "demandbase",
  "label": "Demandbase"
}, {
  "value": "demandware",
  "label": "Demandware"
}, {
  "value": "digital_ocean",
  "label": "Digital Ocean"
}, {
  "value": "disqus",
  "label": "Disqus"
}, {
  "value": "django",
  "label": "Django"
}, {
  "value": "dns_made_easy",
  "label": "DNS Made Easy"
}, {
  "value": "double_click",
  "label": "DoubleClick Ads"
}, {
  "value": "double_click_advertiser",
  "label": "DoubleClick Advertiser"
}, {
  "value": "dreamhost_hosting",
  "label": "DreamHost Hosting"
}, {
  "value": "drift",
  "label": "Drift"
}, {
  "value": "drip",
  "label": "Drip"
}, {
  "value": "drupal",
  "label": "Drupal"
}, {
  "value": "dwolla",
  "label": "Dwolla"
}, {
  "value": "dyn_dns",
  "label": "Dyn DNS"
}, {
  "value": "dynamic_yield",
  "label": "Dynamic Yield"
}, {
  "value": "ecwid",
  "label": "Ecwid"
}, {
  "value": "elasticemail",
  "label": "ElasticEmail"
}, {
  "value": "elevio",
  "label": "Elevio"
}, {
  "value": "eloqua",
  "label": "Eloqua"
}, {
  "value": "emma",
  "label": "Emma"
}, {
  "value": "errorception",
  "label": "Errorception"
}, {
  "value": "express",
  "label": "Express"
}, {
  "value": "facebook_advertiser",
  "label": "Facebook Advertiser"
}, {
  "value": "facebook_beacon",
  "label": "Facebook Beacon"
}, {
  "value": "facebook_comments",
  "label": "Facebook Comments"
}, {
  "value": "facebook_connect",
  "label": "Facebook Connect"
}, {
  "value": "facebook_like_button",
  "label": "Facebook Like Button"
}, {
  "value": "facebook_social_plugins",
  "label": "Facebook Social Plugins"
}, {
  "value": "fedora",
  "label": "Fedora"
}, {
  "value": "formstack",
  "label": "Formstack"
}, {
  "value": "freebsd",
  "label": "FreeBSD"
}, {
  "value": "freshdesk",
  "label": "Freshdesk"
}, {
  "value": "fullcontact",
  "label": "Fullcontact"
}, {
  "value": "fullstory",
  "label": "Fullstory"
}, {
  "value": "fusioncharts",
  "label": "FusionCharts"
}, {
  "value": "gauges",
  "label": "Gauges"
}, {
  "value": "get_response",
  "label": "Get Response"
}, {
  "value": "get_satisfaction",
  "label": "Get Satisfaction"
}, {
  "value": "go_squared",
  "label": "Go Squared"
}, {
  "value": "gocardless",
  "label": "Gocardless"
}, {
  "value": "godaddy_hosting",
  "label": "GoDaddy Hosting"
}, {
  "value": "godaddy_nameserver",
  "label": "Godaddy Nameserver"
}, {
  "value": "google_adsense",
  "label": "Google Adsense"
}, {
  "value": "google_adwords",
  "label": "Google Adwords"
}, {
  "value": "google_affiliate_network",
  "label": "Google Affiliate Network"
}, {
  "value": "google_analytics",
  "label": "Google Analytics"
}, {
  "value": "google_apps",
  "label": "Google Apps"
}, {
  "value": "google_charts",
  "label": "Google Charts"
}, {
  "value": "google_cloud",
  "label": "Google Cloud"
}, {
  "value": "google_forms",
  "label": "Google Forms"
}, {
  "value": "google_maps",
  "label": "Google Maps"
}, {
  "value": "google_tag_manager",
  "label": "Google Tag Manager"
}, {
  "value": "google_website_optimizer",
  "label": "Google Website Optimizer"
}, {
  "value": "google_widgets",
  "label": "Google Widgets"
}, {
  "value": "graphiq",
  "label": "GraphIQ"
}, {
  "value": "gravity_forms",
  "label": "Gravity Forms"
}, {
  "value": "greenhouse",
  "label": "Greenhouse"
}, {
  "value": "heap",
  "label": "Heap"
}, {
  "value": "hello_bar",
  "label": "Hello Bar"
}, {
  "value": "help_scout",
  "label": "Help Scout"
}, {
  "value": "heroku",
  "label": "Heroku"
}, {
  "value": "highcharts",
  "label": "Highcharts"
}, {
  "value": "hotjar",
  "label": "Hotjar"
}, {
  "value": "hoverowl",
  "label": "Hoverowl"
}, {
  "value": "hubspot",
  "label": "HubSpot"
}, {
  "value": "icims",
  "label": "Icims"
}, {
  "value": "indicative",
  "label": "Indicative"
}, {
  "value": "infusionsoft",
  "label": "Infusionsoft"
}, {
  "value": "inside_sales",
  "label": "Inside Sales"
}, {
  "value": "inspectlet",
  "label": "Inspectlet"
}, {
  "value": "instagram",
  "label": "Instagram"
}, {
  "value": "instagram_links",
  "label": "Instagram Links"
}, {
  "value": "instart_logic",
  "label": "Instart Logic"
}, {
  "value": "intense_debate",
  "label": "Intense Debate"
}, {
  "value": "intercom",
  "label": "Intercom"
}, {
  "value": "ios",
  "label": "ios"
}, {
  "value": "iterable",
  "label": "Iterable"
}, {
  "value": "java",
  "label": "Java"
}, {
  "value": "jobvite",
  "label": "Jobvite"
}, {
  "value": "joomla",
  "label": "Joomla"
}, {
  "value": "kapost",
  "label": "Kapost"
}, {
  "value": "keen_io",
  "label": "Keen IO"
}, {
  "value": "kiss_metrics",
  "label": "Kissmetrics"
}, {
  "value": "klaviyo",
  "label": "Klaviyo"
}, {
  "value": "knowtify",
  "label": "Knowtify"
}, {
  "value": "lead_dyno",
  "label": "Lead Dyno"
}, {
  "value": "lever",
  "label": "Lever"
}, {
  "value": "linked_in_advertiser",
  "label": "LinkedIn Advertiser"
}, {
  "value": "linkwithin",
  "label": "Linkwithin"
}, {
  "value": "linode_hosting",
  "label": "Linode Hosting"
}, {
  "value": "live_chat",
  "label": "Live Chat"
}, {
  "value": "livefyre",
  "label": "Livefyre"
}, {
  "value": "liveramp",
  "label": "Liveramp"
}, {
  "value": "localytics",
  "label": "Localytics"
}, {
  "value": "looker",
  "label": "Looker"
}, {
  "value": "lucky_orange",
  "label": "Lucky Orange"
}, {
  "value": "mad_kudu",
  "label": "Mad Kudu"
}, {
  "value": "magento",
  "label": "Magento"
}, {
  "value": "magento_enterprise",
  "label": "Magento Enterprise"
}, {
  "value": "mailchimp",
  "label": "Mailchimp"
}, {
  "value": "mailgun",
  "label": "Mailgun"
}, {
  "value": "mailjet",
  "label": "Mailjet"
}, {
  "value": "mandrill",
  "label": "Mandrill"
}, {
  "value": "marketo",
  "label": "Marketo"
}, {
  "value": "maxmind",
  "label": "Maxmind"
}, {
  "value": "microsoft_azure",
  "label": "Microsoft Azure"
}, {
  "value": "microsoft_exchange_online",
  "label": "Microsoft Exchange Online"
}, {
  "value": "microsoft_office_365",
  "label": "Microsoft Office 365"
}, {
  "value": "mixpanel",
  "label": "Mixpanel"
}, {
  "value": "mode",
  "label": "Mode"
}, {
  "value": "mouseflow",
  "label": "Mouseflow"
}, {
  "value": "mousestats",
  "label": "Mousestats"
}, {
  "value": "my_site_auditor",
  "label": "My Site Auditor"
}, {
  "value": "namecheap_dns",
  "label": "Namecheap Dns"
}, {
  "value": "new_relic",
  "label": "New Relic"
}, {
  "value": "nextable",
  "label": "Nextable"
}, {
  "value": "nginx",
  "label": "Nginx"
}, {
  "value": "nosto",
  "label": "Nosto"
}, {
  "value": "olark",
  "label": "Olark"
}, {
  "value": "omniconvert",
  "label": "Omniconvert"
}, {
  "value": "omniture_adobe_analytics",
  "label": "Omniture (Adobe Analytics)"
}, {
  "value": "ooyala",
  "label": "Ooyala"
}, {
  "value": "open_table",
  "label": "Open Table"
}, {
  "value": "optimizely",
  "label": "Optimizely"
}, {
  "value": "optimonk",
  "label": "Optimonk"
}, {
  "value": "oscommerce",
  "label": "Oscommerce"
}, {
  "value": "outbound",
  "label": "Outbound"
}, {
  "value": "outbrain_ads",
  "label": "Outbrain Ads"
}, {
  "value": "outlook",
  "label": "Outlook"
}, {
  "value": "owneriq",
  "label": "ownerIQ"
}, {
  "value": "pardot",
  "label": "Pardot"
}, {
  "value": "paypal",
  "label": "PayPal"
}, {
  "value": "payza",
  "label": "Payza"
}, {
  "value": "percolate",
  "label": "Percolate"
}, {
  "value": "perfect_audience",
  "label": "Perfect Audience"
}, {
  "value": "periscope_data",
  "label": "Periscope Data"
}, {
  "value": "pinterest",
  "label": "Pinterest"
}, {
  "value": "piwik",
  "label": "Piwik"
}, {
  "value": "postmark",
  "label": "Postmark"
}, {
  "value": "powerreviews",
  "label": "PowerReviews"
}, {
  "value": "qualaroo",
  "label": "Qualaroo"
}, {
  "value": "qualtrics",
  "label": "Qualtrics"
}, {
  "value": "quantcast",
  "label": "Quantcast"
}, {
  "value": "qubit",
  "label": "Qubit"
}, {
  "value": "rackspace",
  "label": "Rackspace"
}, {
  "value": "rackspace_email",
  "label": "Rackspace Email"
}, {
  "value": "recaptcha",
  "label": "Recaptcha"
}, {
  "value": "recruiterbox",
  "label": "Recruiterbox"
}, {
  "value": "recurly",
  "label": "Recurly"
}, {
  "value": "red_hat",
  "label": "Red Hat"
}, {
  "value": "resrcit",
  "label": "ReSRCit"
}, {
  "value": "resumator",
  "label": "Resumator"
}, {
  "value": "retailrocket",
  "label": "RetailRocket"
}, {
  "value": "rezdy",
  "label": "Rezdy"
}, {
  "value": "rezgo",
  "label": "Rezgo"
}, {
  "value": "robly",
  "label": "Robly"
}, {
  "value": "rollbar",
  "label": "Rollbar"
}, {
  "value": "ruby_on_rails",
  "label": "Ruby On Rails"
}, {
  "value": "salesforce",
  "label": "Salesforce"
}, {
  "value": "salesmachine",
  "label": "Salesmachine"
}, {
  "value": "satismeter",
  "label": "Satismeter"
}, {
  "value": "segment",
  "label": "Segment"
}, {
  "value": "sendgrid",
  "label": "Sendgrid"
}, {
  "value": "sentry",
  "label": "Sentry"
}, {
  "value": "sessioncam",
  "label": "Sessioncam"
}, {
  "value": "sharepoint",
  "label": "Sharepoint"
}, {
  "value": "shopify",
  "label": "Shopify"
}, {
  "value": "shopify_plus",
  "label": "Shopify Plus"
}, {
  "value": "shopware",
  "label": "Shopware"
}, {
  "value": "silkroad",
  "label": "Silkroad"
}, {
  "value": "simplicant",
  "label": "Simplicant"
}, {
  "value": "slack",
  "label": "Slack"
}, {
  "value": "smartlook",
  "label": "Smartlook"
}, {
  "value": "socket_io",
  "label": "Socket.io"
}, {
  "value": "softlayer_hosting",
  "label": "Softlayer Hosting"
}, {
  "value": "squarespace",
  "label": "Squarespace"
}, {
  "value": "steel_house",
  "label": "SteelHouse"
}, {
  "value": "stripe",
  "label": "Stripe"
}, {
  "value": "success_factors",
  "label": "Success Factors"
}, {
  "value": "survey_monkey",
  "label": "Survey Monkey"
}, {
  "value": "tableau",
  "label": "Tableau"
}, {
  "value": "taboola_ads",
  "label": "Taboola Ads"
}, {
  "value": "taleo",
  "label": "Taleo"
}, {
  "value": "talkable",
  "label": "Talkable"
}, {
  "value": "tawk",
  "label": "Tawk"
}, {
  "value": "tealium",
  "label": "Tealium"
}, {
  "value": "totango",
  "label": "Totango"
}, {
  "value": "tout",
  "label": "Tout"
}, {
  "value": "toutapp",
  "label": "Toutapp"
}, {
  "value": "towerdata",
  "label": "TowerData"
}, {
  "value": "track_js",
  "label": "Track JS"
}, {
  "value": "trustpilot",
  "label": "Trustpilot"
}, {
  "value": "twitter_advertiser",
  "label": "Twitter Advertiser"
}, {
  "value": "twitter_badge",
  "label": "Twitter Badge"
}, {
  "value": "twitter_button",
  "label": "Twitter Button"
}, {
  "value": "typeform",
  "label": "Typeform"
}, {
  "value": "typekit_by_adobe",
  "label": "Typekit By Adobe"
}, {
  "value": "uber_cart",
  "label": "Uber Cart"
}, {
  "value": "ubuntu",
  "label": "Ubuntu"
}, {
  "value": "ultipro",
  "label": "Ultipro"
}, {
  "value": "unix",
  "label": "Unix"
}, {
  "value": "user_voice",
  "label": "UserVoice"
}, {
  "value": "vero",
  "label": "Vero"
}, {
  "value": "verticalresponse",
  "label": "Verticalresponse"
}, {
  "value": "videojs",
  "label": "Video.js"
}, {
  "value": "vidyard",
  "label": "Vidyard"
}, {
  "value": "vimeo",
  "label": "Vimeo"
}, {
  "value": "virtue_mart",
  "label": "Virtue Mart"
}, {
  "value": "visual_website_optimizer",
  "label": "Visual Website Optimizer"
}, {
  "value": "volusion",
  "label": "Volusion"
}, {
  "value": "webengage",
  "label": "WebEngage"
}, {
  "value": "weebly",
  "label": "Weebly"
}, {
  "value": "wistia",
  "label": "Wistia"
}, {
  "value": "wix_stores",
  "label": "Wix Stores"
}, {
  "value": "woo_commerce",
  "label": "Woo Commerce"
}, {
  "value": "woopra",
  "label": "Woopra"
}, {
  "value": "wootric",
  "label": "Wootric"
}, {
  "value": "wordpress",
  "label": "Wordpress"
}, {
  "value": "workable",
  "label": "Workable"
}, {
  "value": "wp_engine",
  "label": "Wp Engine"
}, {
  "value": "wufoo",
  "label": "Wufoo"
}, {
  "value": "xt_commerce",
  "label": "xt:Commerce"
}, {
  "value": "yahoo_stores",
  "label": "Yahoo Stores"
}, {
  "value": "yandex_metrica",
  "label": "Yandex Metrica"
}, {
  "value": "yelp_seatme",
  "label": "Yelp Seatme"
}, {
  "value": "yesware",
  "label": "Yesware"
}, {
  "value": "yieldify",
  "label": "Yieldify"
}, {
  "value": "yotpo",
  "label": "Yotpo"
}, {
  "value": "youtube",
  "label": "Youtube"
}, {
  "value": "zen_cart",
  "label": "Zen Cart"
}, {
  "value": "zendesk",
  "label": "Zendesk"
}, {
  "value": "zenreach",
  "label": "Zenreach"
}, {
  "value": "zopim",
  "label": "Zopim"
}, {
  "value": "zuora",
  "label": "Zuora"
}]);

/***/ }),

/***/ "Jq9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SW_REGISTRATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SW_REGISTRATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SERVICE_WORKER_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATION_SOUND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATION_SOUND_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_ABM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SHOW_ABM_MODAL_FAILED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('notifications');

var FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION = makeConstant('FETCH_CONVO_FOR_PARTICIPANT_NOTIFICATION');

var SW_REGISTRATION_SUCCESS = makeConstant('SW_REGISTRATION_SUCCESS');
var SW_REGISTRATION_FAILED = makeConstant('SW_REGISTRATION_FAILED');
var SERVICE_WORKER_MESSAGE = makeConstant('SERVICE_WORKER_MESSAGE');

var NOTIFICATION_SOUND_SUCCESS = makeConstant('NOTIFICATION_SOUND_SUCCESS');
var NOTIFICATION_SOUND_FAILED = makeConstant('NOTIFICATION_SOUND_FAILED');

var SHOW_ABM_MODAL = makeConstant('SHOW_ABM_MODAL');
var SHOW_ABM_MODAL_FAILED = makeConstant('SHOW_ABM_MODAL_FAILED');

/***/ }),

/***/ "Jtxw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMyAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDMzIDExLjM4bC05LjY5IDEwLjA3MmMtLjM2LjM1Ny0uODIuNTQ4LTEuMzEuNTQ4LS40OSAwLS45NS0uMTktMS4yOTYtLjUzNmwtOC4yNTItOC4yNUMuNTQgMTIuODY3LjM1IDEyLjQwNi4zNSAxMS45MTZjMC0uNDkuMTktLjk1LjUzNS0xLjI5NkwxMC45ODMuOTA1QzExLjUuMzg1IDEyLjQzMyAwIDEzLjE4MyAwaDcuMzM0YzEuMDEgMCAxLjgzMy44MjIgMS44MzMgMS44MzN2Ny4zMzRjMCAuNzUtLjM4NiAxLjY4Mi0uOTE3IDIuMjEzem0tLjkxNi05LjU0N2gtNy4zMzRjLS4yNiAwLS43MzIuMTk2LS45MTYuMzhMMi4xNyAxMS45M2w4LjI2MyA4LjI0di0uMDAzaC4wMDNsOS42ODgtMTAuMDdjLjE5OC0uMTk4LjM5My0uNjcuMzkzLS45M1YxLjgzM3ptLTMuNzUgNS41ODRjLTEuMDEgMC0xLjgzMy0uODIzLTEuODMzLTEuODM0IDAtMS4wMS44MjItMS44MzMgMS44MzMtMS44MzMgMS4wMSAwIDEuODM0LjgyMiAxLjgzNCAxLjgzMyAwIDEuMDEtLjgyMiAxLjgzNC0xLjgzMyAxLjgzNHoiIGZpbGw9IiM3Njk1QTUiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "JuPD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("KGi3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "Judl":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 19 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.27 16H1.58c-.865 0-1.57-.718-1.57-1.6V1.6C.012.718.717 0 1.582 0H17.27c.865 0 1.706.718 1.706 1.6v12.8c0 .882-.841 1.6-1.706 1.6zm.122-14.4H1.581v7.06l4.196-3.667a.773.773 0 0 1 1.065.041l4.226 4.31L13.66 7.36a.773.773 0 0 1 1.073.128l2.658 3.253V1.6zm0 11.64l-3.387-4.144-2.54 1.944a.773.773 0 0 1-1.026-.074L6.246 6.69l-4.665 4.078V14.4h15.811v-1.16zM12.563 4.8c0-.882.704-1.6 1.57-1.6.864 0 1.567.718 1.567 1.6 0 .882-.703 1.6-1.567 1.6-.866 0-1.57-.718-1.57-1.6zm1.567 0l.003.8v-.8h-.003z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Jy8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TEMP_ID_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TEMP_ID_KEY_PATH; });
/* harmony export (immutable) */ __webpack_exports__["c"] = parseMessage;
/* unused harmony export Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var TEMP_ID_KEY = "clientTempId";
var TEMP_ID_KEY_PATH = ["attributes", TEMP_ID_KEY];

function parseRecipientStatuses(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().withMutations(function (mutable) {
    Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(data).reduce(function (result, status, userString) {
      var _userString$split = userString.split(':'),
          _userString$split2 = _slicedToArray(_userString$split, 2),
          type = _userString$split2[0],
          id = _userString$split2[1];

      return result.setIn([type, parseInt(id)], status);
    }, mutable);
  });
}

function parseMessage(data) {
  var tags = data.tags,
      cc = data.cc,
      bcc = data.bcc,
      attachments = data.attachments,
      context = data.context,
      attributes = data.attributes,
      recipientStatuses = data.recipientStatuses,
      rest = _objectWithoutProperties(data, ["tags", "cc", "bcc", "attachments", "context", "attributes", "recipientStatuses"]);

  return Message(_extends({
    tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(tags),
    cc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(cc),
    bcc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(bcc),
    attachments: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(attachments),
    attributes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(attributes) || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
    context: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(context) || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
    recipientStatuses: parseRecipientStatuses(recipientStatuses)
  }, rest));
}

var Message = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  inboxId: undefined,
  type: undefined,
  orgId: undefined,
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  cc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  bcc: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  conversationId: undefined,
  customerId: undefined,
  authorId: undefined,
  replyToId: undefined,
  authorType: undefined,
  to: undefined,
  from: undefined,
  sender: undefined,
  subject: undefined,
  body: undefined,
  uuid: undefined,
  originalHtml: undefined,
  originalText: undefined,
  conversationEvent: undefined,
  attachments: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  createdAt: undefined,
  updatedAt: undefined,
  layerUrl: undefined,
  attributes: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  deliveryChannel: undefined,
  contentType: undefined,
  context: undefined,
  isPreMessage: undefined,
  failed: false,
  recipientStatuses: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

/***/ }),

/***/ "JzR3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchSavedRepliesEpic */
/* unused harmony export updateSavedReplyEpic */
/* unused harmony export setSavedReplyToComposerTextEpic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("4VmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("2+SW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("/g2I");







var fetchSavedRepliesEpic = function fetchSavedRepliesEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* fetchSavedReplies */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* fetchReplies */]().map(function (savedReplies) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* fetchSavedRepliesSuccess */](savedReplies);
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* fetchSavedRepliesPending */]).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* fetchSavedRepliesFailure */](error));
    });
  });
};

var updateSavedReplyEpic = function updateSavedReplyEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* updateSavedReply */].toString()).pluck('payload').mergeMap(function (_ref) {
    var replyId = _ref.replyId,
        reply = _ref.reply;

    return __WEBPACK_IMPORTED_MODULE_3__api__["b" /* updateReply */](replyId, reply).map(function () {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* updateSavedReplySuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* updateSavedReplyPending */]).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* updateSavedReplyFailure */](error));
    });
  });
};

var setSavedReplyToComposerTextEpic = function setSavedReplyToComposerTextEpic(action$, _ref2) {
  var getState = _ref2.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* selectSavedReply */].toString()).pluck('payload').mergeMap(function (id) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* setComposerTextToInsert */](__WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* savedReplyToPopulate */](id)(getState())));
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchSavedRepliesEpic, updateSavedReplyEpic, setSavedReplyToComposerTextEpic);

/***/ }),

/***/ "K2hD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("EBU2");















var gatedMeetingCta = {
  label: React.createElement(
    'div',
    { className: 'disabled' },
    'Schedule a Meeting ',
    React.createElement(
      'span',
      { className: 'upgrade-cta' },
      'Upgrade to Enterprise'
    )
  ),
  value: -1
};

var disabledMeetingCta = {
  label: React.createElement(
    'div',
    { className: 'disabled' },
    'Schedule a Meeting (only non-bot users can book meetings for themselves)'
  ),
  disabled: true,
  value: -1
};

var unGatedMeetingCta = {
  label: 'Schedule a Meeting',
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING
};

var noCta = {
  label: 'No CTA',
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].NONE
};

var CtaTypeOptions = [{
  label: 'Start a Conversation',
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT
}, {
  label: 'Link to a URL',
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].URL
}];

var mapStateToProps = function mapStateToProps(state) {
  return {
    welcomeMessage: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_106" /* welcomeMessage */](state),
    firstGoal: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["C" /* firstGoal */](state),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state),
    hasMeetingCta: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])('has_meeting_cta')(state),
    hasEnterpriseAccount: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])(__WEBPACK_IMPORTED_MODULE_3_utils_Access__["b" /* Gates */].PLAYBOOKS)(state),
    botUser: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["botUser"](state),
    reportType: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_67" /* reportType */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setCtaType: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_146" /* setCtaType */],
      setCtaLink: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_145" /* setCtaLink */],
      setCtaCopy: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_144" /* setCtaCopy */],
      saveGoalRoutingOption: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_107" /* saveGoalRoutingOption */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  var meetingCtaIsDisabled = props.botUser && props.botUser.id === props.welcomeMessage.authorId && props.reportType !== __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABM;
  var meetingCta = props.hasEnterpriseAccount || props.hasMeetingCta ? meetingCtaIsDisabled ? disabledMeetingCta : unGatedMeetingCta : gatedMeetingCta;
  return {
    CtaTypeOptions: [].concat(CtaTypeOptions, [meetingCta, noCta]),
    cta: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_models__["d" /* Cta */](props.welcomeMessage.cta)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    showCtaCopy: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["W" /* CtaViewConfig */][props.cta.type || __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].NONE].showCopy,
    showCtaUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["W" /* CtaViewConfig */][props.cta.type || __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].NONE].showUrl,
    ctaType: props.cta.type,
    CtaViewConfig: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["W" /* CtaViewConfig */]
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onAuthorChange: function onAuthorChange(props) {
    return function (_ref) {
      var value = _ref.value;

      props.actions.setAuthorId(value);
    };
  },
  onCtaChange: function onCtaChange(_ref2) {
    var actions = _ref2.actions,
        firstGoal = _ref2.firstGoal,
        isOnFreePlan = _ref2.isOnFreePlan,
        reportType = _ref2.reportType;
    return function (e) {
      if (!e) {
        return;
      }
      if (isOnFreePlan && e.value !== __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT) {
        actions.setCtaType(__WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT);
        return;
      }
      if (e.value === -1) {
        window.location.hash = 'enterprise-upgrade';
      } else {
        if (e.value === __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING && reportType !== __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABM) {
          actions.saveGoalRoutingOption({
            goalRoutingOption: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_models__["n" /* RoutingOption */](),
            goalId: firstGoal.id
          });
        }
        actions.setCtaType(e.value);
      }
    };
  },
  onCtaCopyChange: function onCtaCopyChange(props) {
    return function (e) {
      props.actions.setCtaCopy(e.target.value);
    };
  },
  onCtaLinkChange: function onCtaLinkChange(props) {
    return function (e) {
      props.actions.setCtaLink(e.target.value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "K5FN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_AgentStatusAvatar__ = __webpack_require__("L7W3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_rules_selectors__ = __webpack_require__("+dPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_rules_actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_rules_api__ = __webpack_require__("4PhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("GpqP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_times_icon_svg__ = __webpack_require__("+Juk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_times_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_times_icon_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var OnCallModal = function (_Component) {
  _inherits(OnCallModal, _Component);

  function OnCallModal(props) {
    _classCallCheck(this, OnCallModal);

    var _this = _possibleConstructorReturn(this, (OnCallModal.__proto__ || Object.getPrototypeOf(OnCallModal)).call(this, props));

    _this.isDirty = function () {
      return !_.isEqual(_this.props.onCall.userIds, _this.state.selectedParticipants);
    };

    _this.saveOnCall = function () {
      var data = { userIds: _this.state.selectedParticipants };

      __WEBPACK_IMPORTED_MODULE_10_app_modules_rules_api__["a" /* api */].editOncall(data).then(function () {
        _this.props.fetchRules();
        _this.props.onClose();
      }).catch(function () {
        return _this.props.notifications.error("Something went wrong saving the participants.");
      });
    };

    _this.saveParticipant = function (values) {
      _this.setState(function (prevState) {
        var newOptions = prevState.selectedParticipants.slice(0);
        var onlyValues = values.map(function (option) {
          return option.value;
        });
        newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
        newOptions.sort();

        return {
          selectedParticipants: newOptions
        };
      });
    };

    _this.removeParticipant = function (value) {
      _this.setState(function (prevState) {
        return {
          selectedParticipants: _.without(prevState.selectedParticipants, value)
        };
      });
    };

    _this.state = {
      selectedParticipants: props.onCall.userIds
    };
    return _this;
  }

  _createClass(OnCallModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchRoundRobinByKey({ roundRobinKey: 'lastOnCall' });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_.isEqual(nextProps.onCall.userIds, this.props.onCall.userIds)) {
        this.setState({ selectedParticipants: nextProps.onCall.userIds });
      }
    }
  }, {
    key: 'getFormattedUsersOptions',
    value: function getFormattedUsersOptions() {
      var _ref;

      var users = this.props.users;
      var selectedParticipants = this.state.selectedParticipants;

      var unusedUserIds = (_ref = _).without.apply(_ref, [Object.keys(users).map(Number)].concat(_toConsumableArray(selectedParticipants)));

      return unusedUserIds.filter(function (userId) {
        return users[userId].status === 'ENABLED';
      }).map(function (userId) {
        var nameOrEmail = !!users[userId].name ? users[userId].name : users[userId].email;
        return { label: nameOrEmail, value: userId };
      });
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var selectOptions = {
        multi: true,
        autoFocus: false,
        options: this.getFormattedUsersOptions(),
        onChange: this.saveParticipant,
        pageSize: 3,
        placeholder: 'Add a participant...'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderParticipantSelectionList',
    value: function renderParticipantSelectionList() {
      var _this2 = this;

      var lastOnCall = this.props.lastOnCall;
      // TODO: loading state
      if (!lastOnCall) return null;
      var activeParticipantIds = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["intersection"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["keys"])(this.props.users), this.state.selectedParticipants.map(String));
      var sortedParticipantIds = activeParticipantIds.sort(function (a, b) {
        return a - b;
      });
      var nextUpIndex = (sortedParticipantIds.findIndex(function (participantId) {
        return participantId === String(lastOnCall.lastRouted);
      }) + 1) % sortedParticipantIds.length;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: activeParticipantIds.length * 75 + 75 + 'px' } },
        sortedParticipantIds.map(function (userId, index) {
          var nameOrEmail = function nameOrEmail(user) {
            return user.name ? user.name : user.email;
          };
          var shouldShowName = !!_this2.props.users[userId] ? nameOrEmail(_this2.props.users[userId]) : '[Deleted User]';

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: userId + '-' + index, className: 'participants-list-item' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_AgentStatusAvatar__["a" /* default */], { user: _this2.props.users[userId] }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              shouldShowName
            ),
            index === nextUpIndex && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Tag"], { text: 'Next Up' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_times_icon_svg___default.a, className: 'remove', onClick: function onClick() {
                return _this2.removeParticipant(Number(userId));
              } })
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var onClose = this.props.onClose;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Modal"],
        {
          onClose: onClose,
          open: true,
          size: 'small'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'drift-modal oncall-modal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'oncall-modal-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              'Default Rule'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'When teammates become a part of this rule, one participant will be added on a rotating basis'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'drift-form' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'rules-choice-options oncall-participant-search' },
              this.renderSearchBar()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'rules-choice-selection oncall-participant-list' },
              this.renderParticipantSelectionList()
            )
          ),
          this.isDirty() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'footer',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'drift-button', onClick: onClose },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'drift-button drift-button-primary', onClick: this.saveOnCall },
              'Save'
            )
          )
        )
      );
    }
  }]);

  return OnCallModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchRoundRobinByKey: __WEBPACK_IMPORTED_MODULE_9_app_modules_rules_actions__["fetchRoundRobinByKey"]
    }, dispatch)
  };
};

var onCallModalMapStateToProps = function onCallModalMapStateToProps(state) {
  return {
    lastOnCall: __WEBPACK_IMPORTED_MODULE_8_app_modules_rules_selectors__["a" /* getRoundRobinData */](state, 'lastOnCall')
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(onCallModalMapStateToProps, mapDispatchToProps)(OnCallModal));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "K5ht":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_utils_faker__ = __webpack_require__("EOku");



var messages = function messages(currentUser, orgUsers, conversationId) {
  var endUserId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var createdAt = Object(__WEBPACK_IMPORTED_MODULE_1_app_utils_faker__["h" /* recentDate */])();

  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([{
    "id": 336611,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Got it! Thanks for entering your phone number.",
    "uuid": "36b8628a-ca1f-438a-b246-2342a1a1b850",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Got it! Thanks for entering your phone number.",
      "isBot": true,
      "interactionId": 1252,
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336610,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": endUserId,
    "replyToId": 0,
    "authorType": "END_USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "5555555555",
    "uuid": "3cc40e4c-ab08-4013-94bb-ef4893206598",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "8603046131",
      "interactionId": 1252,
      "questionId": "b386b3a9-1138-4121-8f63-122606d38cbc",
      "sentOfflineHours": false,
      "widgetGuid": "db53bae6-ea50-4d49-8e13-e7e99a6638da",
      "clientTimestamp": 1517929957830,
      "integrations": {},
      "botClassification": 15
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": {
      "campaign": {},
      "ip": "144.121.21.2",
      "locale": "en",
      "location": {
        "city": "Boston",
        "region": "Massachusetts",
        "country": "US",
        "countryName": "United States",
        "postalCode": "02116",
        "latitude": 42.3496,
        "longitude": -71.0746
      },
      "os": {
        "name": "OS X 10.13.2",
        "version": "10.13.2",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "/home",
        "referrer": "",
        "search": "",
        "title": "Drift",
        "url": "app.driftqa.com/home",
        "href": "https://app.driftqa.com/home"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
    },
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336262,
    "inboxId": 1,
    "type": "CONVERSATION_EVENT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "",
    "uuid": "bc313775-ecb0-4c49-ac87-eedc388cb0e0",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": {
      "type": "CQL_UPDATED",
      "cqlscore": 3,
      "cqlsource": "BOT"
    },
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "",
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CONVERSATION_EVENT",
    "context": {
      "ip": "52.204.75.158",
      "location": {
        "city": "Ashburn",
        "region": "Virginia",
        "country": "US",
        "countryName": "United States",
        "postalCode": "20149",
        "latitude": 39.0481,
        "longitude": -77.4728
      }
    },
    "recipientStatuses": {},
    "viewerRecipientStatus": null
  }, {
    "id": 336260,
    "inboxId": 1,
    "type": "CONVERSATION_EVENT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "",
    "uuid": "6aa9741f-7b16-4fc4-bbac-1f069d8322d3",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": {
      "type": "CONVERSATION_CLASSIFIED",
      "authorUserIdType": "USER",
      "currentParticipantIds": [7412],
      "createdAt": 1517856900255,
      "classificationId": "shFwhtNs9Dbw"
    },
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "",
      "botClassification": 1
    },
    "deliveryChannel": null,
    "contentType": "CONVERSATION_EVENT",
    "context": null,
    "recipientStatuses": {},
    "viewerRecipientStatus": null
  }, {
    "id": 336259,
    "inboxId": 1,
    "type": "CONVERSATION_EVENT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "",
    "uuid": "5e0a663f-1137-4e49-9109-ce0cb8e6cf9b",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": {
      "type": "GOAL_REACHED",
      "authorUserIdType": "USER",
      "currentParticipantIds": [7412],
      "createdAt": 1517856840140,
      "playbookId": 3359,
      "goalId": "7cc1e6c3-acc0-4ec4-9081-3e75540fef4c"
    },
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "",
      "botClassification": 1
    },
    "deliveryChannel": null,
    "contentType": "CONVERSATION_EVENT",
    "context": null,
    "recipientStatuses": {},
    "viewerRecipientStatus": null
  }, {
    "id": 336258,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Great!",
    "uuid": "8da6bca9-0425-47ef-949e-c2039a9c625d",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Great!",
      "isBot": true,
      "interactionId": 1252,
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336257,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": endUserId,
    "replyToId": 0,
    "authorType": "END_USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Definitely",
    "uuid": "ddca4f9d-afdc-4dc4-bb6b-9679ef14d8ea",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Definitely",
      "interactionId": 1252,
      "questionId": "92db5f61-79c0-4356-84dc-52cae06c9315",
      "buttonClicked": true,
      "sentOfflineHours": false,
      "widgetGuid": "4c7d6ac6-9373-4428-8b1e-a10f517e02c8",
      "clientTimestamp": 1517856802392,
      "integrations": {},
      "botClassification": 15
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": {
      "campaign": {},
      "ip": "146.115.89.231",
      "locale": "en",
      "location": {
        "city": "Boston",
        "region": "Massachusetts",
        "country": "US",
        "countryName": "United States",
        "postalCode": "02116",
        "latitude": 42.3496,
        "longitude": -71.0746
      },
      "os": {
        "name": "OS X 10.13.2",
        "version": "10.13.2",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "/home",
        "referrer": "",
        "search": "",
        "title": "Drift",
        "url": "app.driftqa.com/home",
        "href": "https://app.driftqa.com/home"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
    },
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336256,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Want to learn more and setup a call with somebody from our team?",
    "uuid": "17cc778a-96a9-4668-8dac-1c0492be4291",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Want to learn more and setup a call with somebody from our team?",
      "isBot": true,
      "interactionId": 1252,
      "buttons": [{
        "label": "Definitely",
        "value": "Definitely"
      }, {
        "label": "No",
        "value": "No"
      }],
      "questionId": "92db5f61-79c0-4356-84dc-52cae06c9315",
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336255,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Sounds good",
    "uuid": "99fc9ef0-443e-4f80-9e9b-0cf4e1375751",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Sounds good",
      "isBot": true,
      "interactionId": 1252,
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336254,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": endUserId,
    "replyToId": 0,
    "authorType": "END_USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "No",
    "uuid": "893ba727-bf1e-4c82-a948-9857c38756d2",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "No",
      "interactionId": 1252,
      "questionId": "934ae907-e43e-4d6b-927c-4bdec58a79ca",
      "buttonClicked": true,
      "sentOfflineHours": false,
      "widgetGuid": "7f5a2da1-07bd-41b0-ad52-f93330f4f8d1",
      "clientTimestamp": 1517856798750,
      "integrations": {},
      "botClassification": 15
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": {
      "campaign": {},
      "ip": "146.115.89.231",
      "locale": "en",
      "location": {
        "city": "Boston",
        "region": "Massachusetts",
        "country": "US",
        "countryName": "United States",
        "postalCode": "02116",
        "latitude": 42.3496,
        "longitude": -71.0746
      },
      "os": {
        "name": "OS X 10.13.2",
        "version": "10.13.2",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "/home",
        "referrer": "",
        "search": "",
        "title": "Drift",
        "url": "app.driftqa.com/home",
        "href": "https://app.driftqa.com/home"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
    },
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336253,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Are you already using a product/service like ours?",
    "uuid": "c2247dda-a2fb-4faf-958c-fc7d0910f4fa",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Are you already using a product/service like ours?",
      "isBot": true,
      "interactionId": 1252,
      "buttons": [{
        "label": "Yes",
        "value": "Yes"
      }, {
        "label": "No",
        "value": "No"
      }],
      "questionId": "934ae907-e43e-4d6b-927c-4bdec58a79ca",
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336252,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Awesome!",
    "uuid": "0b44b6d8-8329-4be2-8ee0-8465f9807628",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Awesome!",
      "isBot": true,
      "interactionId": 1252,
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336250,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": endUserId,
    "replyToId": 0,
    "authorType": "END_USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Want to talk to sales",
    "uuid": "696b17ac-7d04-4bf5-96c1-2cfee2b9860d",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Want to talk to sales",
      "interactionId": 1252,
      "questionId": "f75362a3-6dfe-4541-8f2e-406cae37e302",
      "buttonClicked": true,
      "sentOfflineHours": false,
      "widgetGuid": "45035fa2-047a-4a00-ac75-6746f018e4fb",
      "clientTimestamp": 1517856789861,
      "integrations": {},
      "botClassification": 15
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": {
      "campaign": {},
      "ip": "146.115.89.231",
      "locale": "en",
      "location": {
        "city": "Boston",
        "region": "Massachusetts",
        "country": "US",
        "countryName": "United States",
        "postalCode": "02116",
        "latitude": 42.3496,
        "longitude": -71.0746
      },
      "os": {
        "name": "OS X 10.13.2",
        "version": "10.13.2",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "/home",
        "referrer": "",
        "search": "",
        "title": "Drift",
        "url": "app.driftqa.com/home",
        "href": "https://app.driftqa.com/home"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
    },
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336249,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 15860,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Welcome to Drift Staging! What brought you here to check us out?",
    "uuid": "ec493c5b-2402-49d3-97fe-23a23f1f720d",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Welcome to Drift! What brought you here to check us out?",
      "isBot": true,
      "interactionId": 1252,
      "buttons": [{
        "label": "Want to talk to sales",
        "value": "Want to talk to sales"
      }, {
        "label": "Just Browsing",
        "value": "Just Browsing"
      }],
      "questionId": "f75362a3-6dfe-4541-8f2e-406cae37e302",
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336248,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 15860,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "Hey there!",
    "uuid": "f5a24dcb-7156-4f77-802b-5b26d60dfd14",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "Hey there!",
      "isBot": true,
      "interactionId": 1252,
      "botClassification": 1
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": null,
    "recipientStatuses": {
      "END_USER:1023273": "Read",
      "USER:18458": "Read"
    },
    "viewerRecipientStatus": "Read"
  }, {
    "id": 336247,
    "inboxId": 1,
    "type": "CHAT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": endUserId,
    "replyToId": 0,
    "authorType": "END_USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "",
    "uuid": "976d9ad4-4e7f-4ced-882a-2b9b8e52d665",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": null,
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "",
      "accountId": "18074430-91ae-4ec6-a2dd-281bcb7442d1",
      "withGreeting": true,
      "interactionId": 1252,
      "autoAssigneeId": 7412,
      "sentOfflineHours": false,
      "widgetGuid": "aaed324a-5caa-44c5-9aef-e93cd62f5ced",
      "startInteraction": 1252,
      "clientTimestamp": 1517856762730,
      "integrations": {},
      "botClassification": 15
    },
    "deliveryChannel": "CHAT",
    "contentType": "CHAT",
    "context": {
      "campaign": {},
      "ip": "146.115.89.231",
      "locale": "en",
      "location": {
        "city": "Boston",
        "region": "Massachusetts",
        "country": "US",
        "countryName": "United States",
        "postalCode": "02116",
        "latitude": 42.3496,
        "longitude": -71.0746
      },
      "os": {
        "name": "OS X 10.13.2",
        "version": "10.13.2",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "/home",
        "referrer": "",
        "search": "",
        "title": "Drift",
        "url": "app.driftqa.com/home",
        "href": "https://app.driftqa.com/home"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36"
    },
    "recipientStatuses": {
      "END_USER:1023273": "Read"
    },
    "viewerRecipientStatus": null
  }, {
    "id": 336246,
    "inboxId": 1,
    "type": "CONVERSATION_EVENT",
    "orgId": 1,
    "tags": [],
    "cc": [],
    "bcc": [],
    "conversationId": conversationId,
    "customerId": 0,
    "authorId": 101,
    "replyToId": 0,
    "authorType": "USER",
    "to": null,
    "from": null,
    "subject": null,
    "body": "",
    "uuid": "b0d0e630-5600-46b2-b613-2aecb42f7433",
    "originalHtml": null,
    "originalText": null,
    "conversationEvent": {
      "type": "ADDED_PARTICIPANTS",
      "authorUserIdType": "USER",
      "conversationStatus": "BULK_SENT",
      "participantIds": [7412],
      "currentParticipantIds": [7412],
      "participantChangeType": "DIRECT",
      "createdAt": 1517856763030
    },
    "attachments": [],
    "createdAt": createdAt -= 10000,
    "updatedAt": createdAt,
    "layerUrl": null,
    "attributes": {
      "preview": "",
      "botClassification": 1
    },
    "deliveryChannel": null,
    "contentType": "CONVERSATION_EVENT",
    "context": null,
    "recipientStatuses": {},
    "viewerRecipientStatus": null
  }]);
};

/***/ }),

/***/ "K6LP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IntlContainer__ = __webpack_require__("rGVz");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Create an IntlProvider for the current selected locale
 */

var I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n() {
    _classCallCheck(this, I18n);

    return _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).apply(this, arguments));
  }

  _createClass(I18n, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          messages = _props.messages,
          locale = _props.orgSettings.locale;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* IntlProvider */],
        { locale: locale, messages: messages },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: className },
          children
        )
      );
    }
  }]);

  return I18n;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

I18n.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__IntlContainer__["a" /* default */])(I18n));

/***/ }),

/***/ "K8bH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_Accordion__ = __webpack_require__("1mHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OfficeLogo__ = __webpack_require__("3Z2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_meetings_tease_calendar_connect_png__ = __webpack_require__("ovfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_images_meetings_tease_calendar_connect_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_images_meetings_tease_calendar_connect_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("YBly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var MICROSOFT_CONSENT_BASE_URL = 'https://login.microsoftonline.com/common/adminconsent';

var TitleDescription = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'span',
  null,
  'Take the back and forth out of scheduling and give leads and customers a direct line to your calendar. Let people schedule meetings with you right from chat or email. ',
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: 'https://help.drift.com/article/calendarsetup/', target: '_blank', rel: 'noopener noreferrer' },
    'Learn More'
  )
);

var Header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: 'settings-global-calendar--connect header' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_settings_Accordion__["a" /* default */], {
    className: 'global-calendar-title',
    title: 'My Meetings',
    description: TitleDescription,
    locked: true })
);

var ConnectGlobalCalendar = function (_Component) {
  _inherits(ConnectGlobalCalendar, _Component);

  function ConnectGlobalCalendar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConnectGlobalCalendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectGlobalCalendar.__proto__ || Object.getPrototypeOf(ConnectGlobalCalendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pending: false
    }, _this.onCalendarConnectClick = function () {
      _this.setState({
        pending: true
      });

      var params = {
        redirect_uri: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/office-365-admin-consent',
        client_id: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["F" /* MICROSOFT_ADMIN_CONSENT_CLIENT_ID */]
      };

      Object(__WEBPACK_IMPORTED_MODULE_4_components_Integration_helpers__["b" /* popUp */])({
        path: MICROSOFT_CONSENT_BASE_URL + '?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])(params),
        onMessage: _this.handlePostMessage
      });
    }, _this.handlePostMessage = function (e) {
      var _this$props = _this.props,
          onConnected = _this$props.onConnected,
          onConnectFailed = _this$props.onConnectFailed;

      var success = e.data.status === 'success';

      _this.setState({ pending: false }, function () {
        success ? onConnected() : onConnectFailed();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConnectGlobalCalendar, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'settings-global-calendar--connect' },
        Header,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'settings-global-calendar--connect content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'settings-global-calendar--connect info' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__OfficeLogo__["a" /* default */], null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'connect-title' },
              'Connect your teams\' calendars to get started'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'connect-description' },
              'With one click, connect your entire teams\' calendars to Drift and let leads and customers book times with each member directly through Drift chat.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
              { onClick: this.onCalendarConnectClick },
              'Connect Calendars'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7_images_meetings_tease_calendar_connect_png___default.a })
        )
      );
    }
  }]);

  return ConnectGlobalCalendar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ConnectGlobalCalendar);

/***/ }),

/***/ "K9D0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CardLayoutPreviewContainer":"CardLayoutPreviewContainer---1kBjL","CardLayoutPreview":"CardLayoutPreview---2ipkx","WideLayoutPreviewContainer":"WideLayoutPreviewContainer---26pkm","WideLayoutPreview__Header":"WideLayoutPreview__Header---10Hcj","WideLayoutPreview__Content":"WideLayoutPreview__Content---3P4v5"};

/***/ }),

/***/ "KBK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_Accordion__ = __webpack_require__("so0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("19Z2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_DrupalInstaller__ = __webpack_require__("qE/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_WordPressInstaller__ = __webpack_require__("qk1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_JavaScriptInstaller__ = __webpack_require__("6RZ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_HubSpotInstaller__ = __webpack_require__("XHia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_SegmentInstaller__ = __webpack_require__("tWDN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_ShopifyInstaller__ = __webpack_require__("y53j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InstallEduTooltip__ = __webpack_require__("B9jE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__GDPRMessage__ = __webpack_require__("1brp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_Access__ = __webpack_require__("6k1g");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var logoSrc = {
  javascript: __webpack_require__("xBm8"),
  wordpress: __webpack_require__("oRkD"),
  drupal: __webpack_require__("TcBr"),
  hubspot: __webpack_require__("6N1b"),
  segment: __webpack_require__("Qxuw"),
  shopify: __webpack_require__("UNEK")
};

var generateServices = function generateServices() {
  var Services = {
    javascript: {
      title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex', style: { alignItems: 'center' } },
        Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.javascript),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { marginLeft: 6 } },
          'JavaScript'
        )
      ),
      Service: __WEBPACK_IMPORTED_MODULE_9__services_JavaScriptInstaller__["a" /* default */]
    },
    wordpress: {
      title: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.wordpress),
      Service: __WEBPACK_IMPORTED_MODULE_8__services_WordPressInstaller__["a" /* default */]
    },
    segment: {
      title: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.segment),
      Service: __WEBPACK_IMPORTED_MODULE_11__services_SegmentInstaller__["a" /* default */]
    },
    shopify: {
      title: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.shopify),
      Service: __WEBPACK_IMPORTED_MODULE_12__services_ShopifyInstaller__["a" /* default */]
    },
    drupal: {
      title: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.drupal),
      Service: __WEBPACK_IMPORTED_MODULE_7__services_DrupalInstaller__["a" /* default */]
    }
  };

  if (__WEBPACK_IMPORTED_MODULE_15_utils_Access__["c" /* default */].hasGates(__WEBPACK_IMPORTED_MODULE_15_utils_Access__["b" /* Gates */].HUBSPOT_INSTALL)) {
    // temporarliy removing this to see if customers notice. If not, remove permanently
    // giving back the ability if gated so CSMs can work with customer's already having this installed
    Services.hubspot = {
      title: Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* renderLogoSVG */])(logoSrc.hubspot),
      Service: __WEBPACK_IMPORTED_MODULE_10__services_HubSpotInstaller__["a" /* default */]
    };
  }

  return Services;
};

var InstallPage = function (_Component) {
  _inherits(InstallPage, _Component);

  function InstallPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InstallPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstallPage.__proto__ || Object.getPrototypeOf(InstallPage)).call.apply(_ref, [this].concat(args))), _this), _this.renderServices = function () {
      var integrationStates = _this.props.integrationStates;

      return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(generateServices(), function (_ref2, serviceName) {
        var Service = _ref2.Service,
            title = _ref2.title;

        var isConnected = integrationStates[serviceName];
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_shared_Accordion__["a" /* default */],
          { key: serviceName, title: title, isConnected: isConnected },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Service, { isConnected: isConnected })
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InstallPage, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__InstallEduTooltip__["a" /* default */], null),
        this.renderServices(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'gdpr-message-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__GDPRMessage__["a" /* default */], null)
        )
      );
    }
  }]);

  return InstallPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_container__["a" /* makeDefaultFailedContainer */])(InstallPage, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates: function integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates();
    }
  }
}));

/***/ }),

/***/ "KCeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("ndex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EnhanceWithAssistantConfig__ = __webpack_require__("WrLk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__EnhanceWithAssistantConfig__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["k" /* withStateHandlers */])(function (_ref) {
  var settingName = _ref.settingName;
  return { selectedSettingName: settingName };
}, {
  selectSetting: function selectSetting() {
    return function (selectedSetting) {
      return { selectedSettingName: selectedSetting };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref2) {
  var selectedSettingName = _ref2.selectedSettingName,
      assistantAgentSettings = _ref2.assistantAgentSettings,
      editingAssistantAgentSettings = _ref2.editingAssistantAgentSettings;

  return {
    initialSettings: assistantAgentSettings && assistantAgentSettings.get(selectedSettingName),
    editingSettings: editingAssistantAgentSettings && editingAssistantAgentSettings.get(selectedSettingName)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref3) {
  var initialSettings = _ref3.initialSettings,
      editingSettings = _ref3.editingSettings;
  return {
    delayTime: editingSettings && editingSettings.get('delayTime'),
    initialEmailSubject: initialSettings && initialSettings.get('emailSubject'),
    initialEmailBody: initialSettings && initialSettings.get('emailBody')
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onDelayEdit: function onDelayEdit(_ref4) {
    var actions = _ref4.actions,
        selectedSettingName = _ref4.selectedSettingName,
        editingSettings = _ref4.editingSettings;
    return function (newDelayTime) {
      var newSettings = editingSettings.set("delayTime", newDelayTime);
      return actions.onUpdate({ settingName: selectedSettingName, newSettings: newSettings });
    };
  },
  onSubjectEdit: function onSubjectEdit(_ref5) {
    var actions = _ref5.actions,
        selectedSettingName = _ref5.selectedSettingName,
        editingSettings = _ref5.editingSettings;
    return function (newSubject) {
      var newSettings = editingSettings.set("emailSubject", newSubject);
      return actions.onUpdate({ settingName: selectedSettingName, newSettings: newSettings });
    };
  },
  onBodyEdit: function onBodyEdit(_ref6) {
    var actions = _ref6.actions,
        selectedSettingName = _ref6.selectedSettingName,
        editingSettings = _ref6.editingSettings;
    return function (newBody) {
      var newSettings = editingSettings.set("emailBody", newBody);
      return actions.onUpdate({ settingName: selectedSettingName, newSettings: newSettings });
    };
  },
  sendTestEmail: function sendTestEmail(_ref7) {
    var actions = _ref7.actions,
        selectedSettingName = _ref7.selectedSettingName;
    return function () {
      return actions.sendTestEmail(selectedSettingName);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */])));

/***/ }),

/***/ "KGSq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("c6Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PERSIST_DEBOUNCE_TIMEOUT = 500;

var IntegrationRetryDelay = function (_Component) {
    _inherits(IntegrationRetryDelay, _Component);

    function IntegrationRetryDelay(props) {
        var _this2 = this;

        _classCallCheck(this, IntegrationRetryDelay);

        var _this = _possibleConstructorReturn(this, (IntegrationRetryDelay.__proto__ || Object.getPrototypeOf(IntegrationRetryDelay)).call(this, props));

        _this.componentDidMount = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var retryDelay;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.props.getDelay(_this.props.integration);

                        case 2:
                            retryDelay = _context.sent;


                            _this.setState({
                                delay: retryDelay.retryDelayInMinutes
                            });

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.onChange = function (event) {
            var delay = event.target.value;

            var _this$validateDelay = _this.validateDelay(delay),
                valid = _this$validateDelay.valid,
                errorMessage = _this$validateDelay.errorMessage;

            if (valid && !!errorMessage) {
                _this.setState({
                    delay: ""
                });
                return;
            }

            if (valid) {
                _this.setState({
                    delay: parseInt(event.target.value),
                    errorMessage: null
                }, function () {
                    return onStateSet();
                });
            } else {
                _this.setState({
                    errorMessage: errorMessage
                });
            }
            var onStateSet = function onStateSet() {
                _this.debouncedPersist(_this.state.delay);
            };
        };

        _this.persist = function () {
            var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(delay) {
                var _this$props, setDelay, integration, notifications;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this$props = _this.props, setDelay = _this$props.setDelay, integration = _this$props.integration, notifications = _this$props.notifications;
                                _context2.next = 3;
                                return setDelay(delay, integration);

                            case 3:

                                notifications.success(integration + ' settings are updated!');

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.validateDelay = function (delay) {
            if (delay === "") {
                return { valid: true, errorMessage: true };
            }

            if (delay.charAt(0) == 0 || delay.charAt(0) == '-' || parseInt(delay) < 0 || parseInt(delay) > 1440) {
                return { valid: false, errorMessage: "Valid delays are between 1 and 1440 minutes" };
            }
            return { valid: true, errorMessage: null };
        };

        _this.debouncedPersist = _.debounce(_this.persist, PERSIST_DEBOUNCE_TIMEOUT);


        _this.state = {
            delay: 15,
            errorMessage: null
        };
        return _this;
    }

    _createClass(IntegrationRetryDelay, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                delay = _state.delay,
                errorMessage = _state.errorMessage;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'integration-delay-container' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], {
                        onChange: this.onChange,
                        type: 'number',
                        value: delay,
                        placeholder: 'enter a number...'
                    }),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'span',
                        { className: 'integration-delay-span' },
                        'minutes'
                    )
                ),
                errorMessage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'span',
                    { className: 'integration-retry-delay-error' },
                    ' ',
                    errorMessage,
                    ' '
                )
            );
        }
    }]);

    return IntegrationRetryDelay;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(IntegrationRetryDelay));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "KGi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("RtjN");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  hubspotAttributeFields: null,
  hubspotAttributeMappings: [],
  hubspotAttributeMappingsErr: null,
  hubspotAttributePatching: false,
  hubspotUsers: [],
  hubspotUserMappings: [],
  hubspotUserMappingsErr: null,
  hubspotUserMappingLoading: false,
  hubspotUserMappingLoaded: false,
  hubspotUserMappingsPatchLoading: false,
  hubspotUsersSearchLoading: false,
  hubspotUsersSearchLoaded: false,
  hubspotResponse: {}
};

var sortedByStatic = function sortedByStatic(mappings) {
  return _.sortBy(mappings, function (mapping) {
    return !mapping.static;
  });
};

var handleUserMappings = function handleUserMappings(_ref, _ref2) {
  var hubspotUsers = _ref.hubspotUsers;
  var mappings = _ref2.mappings,
      users = _ref2.users;
  return {
    hubspotUserMappings: mappings,
    hubspotUsers: _.uniqBy([].concat(_toConsumableArray(hubspotUsers), _toConsumableArray(users)), 'id')
  };
};

var hubspotMappings = function hubspotMappings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var hubspotResponse = state.hubspotResponse;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FETCH_HUBSPOT_FIELDS_SUCCESS */]:
      return _extends({}, state, { hubspotAttributeFields: action.fields });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS */]:
      var clonedState = _extends({}, state);
      clonedState.hubspotAttributeMappings = sortedByStatic(action.mappings);
      clonedState.allowAttributeDefaults = action.allowAttributeDefaults;
      clonedState.useCountryAcronyms = action.useCountryAcronyms;
      clonedState.useStateAcronyms = action.useStateAcronyms;
      return clonedState;

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {
        hubspotAttributeMappings: sortedByStatic(action.mappings),
        allowAttributeDefaults: action.allowAttributeDefaults,
        useCountryAcronyms: action.useCountryAcronyms,
        useStateAcronyms: action.useStateAcronyms,
        hubspotAttributeMappingsErr: null,
        hubspotAttributePatching: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR */]:
      return _extends({}, state, { hubspotAttributeMappingsErr: action.err, hubspotAttributePatching: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START */]:
      return _extends({}, state, { hubspotAttributePatching: true });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_HUBSPOT_USERS_SEARCH_SUCCESS */]:
      return _extends({}, state, {
        hubspotUsersSearchLoaded: true,
        hubspotUsersSearchLoading: false,
        hubspotUsers: _.uniqBy([].concat(_toConsumableArray(state.hubspotUsers), _toConsumableArray(action.users)), 'id')
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* FETCH_HUBSPOT_USERS_SEARCH_ERROR */]:
      return _extends({}, state, { hubspotUsersSearchLoading: false, hubspotUsersSearchLoaded: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_HUBSPOT_USERS_SEARCH_START */]:
      return _extends({}, state, { hubspotUsersSearchLoading: true, hubspotUsersSearchLoaded: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* FETCH_HUBSPOT_USER_MAPPINGS_STARTED */]:
      return _extends({}, state, {
        hubspotUserMappingLoading: true,
        hubspotUserMappingLoaded: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PATCH_HUBSPOT_USER_MAPPINGS_START */]:
      return _extends({}, state, { hubspotUserMappingsPatchLoading: true });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS */]:
      return _extends({}, state, _extends({
        hubspotUserMappingsPatchLoading: false
      }, handleUserMappings(state, action)));

    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* PATCH_HUBSPOT_USER_MAPPINGS_FAILED */]:
      return _extends({}, state, { hubspotUserMappingsErr: action.err, hubspotUserMappingsPatchLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS */]:
      return _extends({}, state, _extends({
        hubspotUserMappingLoading: false,
        hubspotUserMappingLoaded: true
      }, handleUserMappings(state, action)));

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FETCH_HUBSPOT_BY_EMAIL_STARTED */]:
      hubspotResponse[action.key] = {
        loading: true,
        error: {},
        data: {}
      };
      return _extends({}, state, { hubspotResponse: hubspotResponse });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_HUBSPOT_BY_EMAIL_FAILED */]:
      hubspotResponse[action.key] = {
        loading: false,
        error: action.err,
        data: {}
      };
      return _extends({}, state, { hubspotResponse: hubspotResponse });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FETCH_HUBSPOT_BY_EMAIL_SUCCESS */]:
      hubspotResponse[action.key] = {
        loading: false,
        error: {},
        data: action.data
      };
      return _extends({}, state, { hubspotResponse: hubspotResponse });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (hubspotMappings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "KMoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InnerDisableSalesSequenceModal__ = __webpack_require__("EpRB");


var DisableSalesSequenceConfirmModal = function DisableSalesSequenceConfirmModal(_ref) {
  var draft = _ref.draft,
      onCloseClick = _ref.onCloseClick,
      onDisableClick = _ref.onDisableClick;

  return React.createElement(__WEBPACK_IMPORTED_MODULE_0__InnerDisableSalesSequenceModal__["a" /* default */], {
    onCloseClick: onCloseClick,
    onDisableClick: onDisableClick,
    playbook: draft
  });
};

/* harmony default export */ __webpack_exports__["a"] = (DisableSalesSequenceConfirmModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "KNDM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KOTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OrNode; });
/* harmony export (immutable) */ __webpack_exports__["a"] = AddIcon;
/* harmony export (immutable) */ __webpack_exports__["c"] = RemoveIcon;
/* unused harmony export PlusSvgSrc */
/* unused harmony export CrossSvgSrc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__("RyI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var IS_NOT = "isn't any of";
var IS = "is any of";

var OrNode = React.createElement(
  'div',
  { className: 'dsg-Label--gray flex', style: { alignItems: 'center', justifyContent: 'flex-end' } },
  'Or'
);

function Icon(_ref) {
  var onClick = _ref.onClick,
      src = _ref.src;

  return React.createElement(
    'div',
    { onClick: onClick, style: { padding: 3 } },
    React.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, {
      style: { width: 10, height: 10, cursor: "pointer" },
      element: 'div',
      className: 'gray-icon',
      src: src
    })
  );
}

function AddIcon(_ref2) {
  var onClick = _ref2.onClick;

  return React.createElement(Icon, {
    onClick: onClick,
    src: PlusSvgSrc
  });
}

function RemoveIcon(_ref3) {
  var onClick = _ref3.onClick;

  return React.createElement(Icon, {
    onClick: onClick,
    src: CrossSvgSrc
  });
}

var PlusSvgSrc = __webpack_require__("EI0t");
var CrossSvgSrc = __webpack_require__("+Juk");

var IsAnyOfInputs = function (_Component) {
  _inherits(IsAnyOfInputs, _Component);

  function IsAnyOfInputs() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, IsAnyOfInputs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = IsAnyOfInputs.__proto__ || Object.getPrototypeOf(IsAnyOfInputs)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      options: _this.props.options
    }, _this.optionCreator = function (_ref5) {
      var label = _ref5.label;

      return { label: label, value: label };
    }, _this.handleCreateOption = function (index) {
      return function (option) {
        var options = [].concat(_toConsumableArray(_this.state.options), [option]);
        _this.setState({ options: options }, _this.makeOnOptionSelect(index)(option));
      };
    }, _this.renderSelect = function () {
      var options = _this.props.conditionValue.get('value');
      var isCreatable = _this.props.isCreatable || false;
      return options.map(function (option, index, _ref6) {
        var size = _ref6.size;

        var actionButton = void 0;
        if (index === 0) {
          actionButton = _this.renderAddIcon();
        } else {
          actionButton = _this.renderRemoveIcon(index);
        }
        var node = [React.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Select"], {
          value: option,
          options: _this.state.options,
          onChange: _this.makeOnOptionSelect(index),
          clearable: false,
          creatable: isCreatable,
          newOptionCreator: _this.optionCreator,
          onNewOptionClick: _this.handleCreateOption(index),
          placeholder: _this.props.placeholder
        }), actionButton];
        if (index !== size - 1) {
          node.push(OrNode);
        }
        return node;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IsAnyOfInputs, [{
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'makeOnOptionSelect',
    value: function makeOnOptionSelect(index) {
      var _this2 = this;

      return function (option) {
        var options = _this2.props.conditionValue.get('value');
        _this2.props.conditionUpdater('value', options.set(index, option.value));
      };
    }
  }, {
    key: 'makeOnRemove',
    value: function makeOnRemove(index) {
      var _this3 = this;

      return function () {
        var options = _this3.props.conditionValue.get('value');
        _this3.props.conditionUpdater('value', options.splice(index, 1));
      };
    }
  }, {
    key: 'onAddOptionSelect',
    value: function onAddOptionSelect() {
      var availableOptions = this.getAvailableOptions();
      if (!availableOptions || !availableOptions.length) return;
      var firstOptionValue = availableOptions[0].value;
      var options = this.props.conditionValue.get('value');
      this.props.conditionUpdater('value', options.push(firstOptionValue));
    }

    /**
     * get options that are not selected
     * @returns {Array}
     */

  }, {
    key: 'getAvailableOptions',
    value: function getAvailableOptions() {
      var options = this.props.conditionValue.get('value');
      return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(this.state.options, function (_ref7) {
        var value = _ref7.value;

        var found = options.find(function (option) {
          return option === value;
        });
        return !found;
      });
    }
  }, {
    key: 'renderAddIcon',
    value: function renderAddIcon() {
      var availableOptions = this.getAvailableOptions();
      return React.createElement(AddIcon, {
        onClick: availableOptions.length ? this.onAddOptionSelect.bind(this) : null
      });
    }
  }, {
    key: 'renderRemoveIcon',
    value: function renderRemoveIcon(index) {
      return React.createElement(RemoveIcon, {
        onClick: this.makeOnRemove(index)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var conditionValue = this.props.conditionValue;

      var isAnyOf = conditionValue.get('operator') === 'isAnyOf';
      return React.createElement(
        'div',
        { className: 'flex-space-around flex-2 flex-wrap' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_SimpleSelect__["a" /* default */], {
          onSelection: this.onOperatorSelect.bind(this),
          options: [isAnyOf ? { value: 'notIsAnyOf', text: IS_NOT } : { value: 'isAnyOf', text: IS }],
          selectedValue: isAnyOf ? IS : IS_NOT
        }),
        this.renderSelect()
      );
    }
  }]);

  return IsAnyOfInputs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

IsAnyOfInputs.propTypes = {
  conditionUpdater: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  conditionValue: __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.map,
  // TODO create static type for SimpleSelectOption and use it here
  options: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object)
};


/* harmony default export */ __webpack_exports__["d"] = (IsAnyOfInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "KP0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return googleOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return googleOauthAcceptSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return googleOauthAcceptFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return microsoftOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return microsoftOauthAcceptSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return microsoftOauthAcceptFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return zoomOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return zoomOauthAcceptSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return zoomOauthAcceptFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchCalendarStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchCalendarStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchCalendarStatusSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchCalendarStatusFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchGoogleCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return fetchGoogleCalendarsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return fetchGoogleCalendarsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fetchGoogleCalendarsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return fetchMicrosoftCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return fetchMicrosoftCalendarsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return fetchMicrosoftCalendarsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return fetchMicrosoftCalendarsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return fetchMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return fetchMicrosoftAdminConsentPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return fetchMicrosoftAdminConsentSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return fetchMicrosoftAdminConsentFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return fetchMicrosoftManagedCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return fetchMicrosoftManagedCalendarsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return fetchMicrosoftManagedCalendarsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return fetchMicrosoftManagedCalendarsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return disconnectMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return disconnectMicrosoftAdminConsentPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return disconnectMicrosoftAdminConsentSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return disconnectMicrosoftAdminConsentFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return microsoftAdminManagedAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return microsoftAdminManagedAcceptSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return microsoftAdminManagedAcceptFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return updateGoogleCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return updateGoogleCalendarPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return updateGoogleCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return updateGoogleCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return updateMicrosoftCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return updateMicrosoftCalendarPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return updateMicrosoftCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return updateMicrosoftCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return disconnectGoogleCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return disconnectGoogleCalendarPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return disconnectGoogleCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return disconnectGoogleCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return disconnectMicrosoftCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return disconnectMicrosoftCalendarPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return disconnectMicrosoftCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return disconnectMicrosoftCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return fetchGoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchGoogleScopesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return fetchGoogleScopesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return fetchGoogleScopesFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return fetchMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return fetchMeetingSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return fetchMeetingSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fetchMeetingSettingsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debounceUpdateMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return updateMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return updateMeetingSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return updateMeetingSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return updateMeetingSettingsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteMeetingType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteMeetingTypePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteMeetingTypeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteMeetingTypeFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return updateMeetingType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return updateMeetingTypePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return updateMeetingTypeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return updateMeetingTypeFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return fetchMeetingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return fetchMeetingTypesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return fetchMeetingTypesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return fetchMeetingTypesFailure; });
/* unused harmony export fetchCalendlyMeetingTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchCalendlyMeetingTypesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchCalendlyMeetingTypesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchCalendlyMeetingTypesFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return updateMeetingSettingsNewAppointments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return updateMeetingSettingsNewAppointmentsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return updateMeetingSettingsNewAppointmentsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return updateMeetingSettingsNewAppointmentsFailure; });
/* unused harmony export shareCalendar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return shareCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return shareCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchConnectedCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchConnectedCalendarsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchConnectedCalendarsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchConnectedCalendarsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return shareRoutedCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return shareRoutedCalendarSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return shareRoutedCalendarFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return openedMeetingEmailModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("kk8i");



var googleOauthAccept = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* GOOGLE_OAUTH_ACCEPT */]);
var googleOauthAcceptSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* GOOGLE_OAUTH_ACCEPT_SUCCESS */]);
var googleOauthAcceptFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* GOOGLE_OAUTH_ACCEPT_FAILURE */]);

var microsoftOauthAccept = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* MICROSOFT_OAUTH_ACCEPT */]);
var microsoftOauthAcceptSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* MICROSOFT_OAUTH_ACCEPT_SUCCESS */]);
var microsoftOauthAcceptFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* MICROSOFT_OAUTH_ACCEPT_FAILURE */]);

var zoomOauthAccept = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_42" /* ZOOM_OAUTH_ACCEPT */]);
var zoomOauthAcceptSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_44" /* ZOOM_OAUTH_ACCEPT_SUCCESS */]);
var zoomOauthAcceptFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_43" /* ZOOM_OAUTH_ACCEPT_FAILURE */]);

var fetchCalendarStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_CALENDAR_STATUS */]);
var fetchCalendarStatusPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_CALENDAR_STATUS_PENDING */]);
var fetchCalendarStatusSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_CALENDAR_STATUS_SUCCESS */]);
var fetchCalendarStatusFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_CALENDAR_STATUS_FAILURE */]);

var fetchGoogleCalendars = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* FETCH_GOOGLE_CALENDARS */]);
var fetchGoogleCalendarsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* FETCH_GOOGLE_CALENDARS_PENDING */]);
var fetchGoogleCalendarsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* FETCH_GOOGLE_CALENDARS_SUCCESS */]);
var fetchGoogleCalendarsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* FETCH_GOOGLE_CALENDARS_FAILURE */]);

var fetchMicrosoftCalendars = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* FETCH_MICROSOFT_CALENDARS */]);
var fetchMicrosoftCalendarsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* FETCH_MICROSOFT_CALENDARS_PENDING */]);
var fetchMicrosoftCalendarsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* FETCH_MICROSOFT_CALENDARS_SUCCESS */]);
var fetchMicrosoftCalendarsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* FETCH_MICROSOFT_CALENDARS_FAILURE */]);

var fetchMicrosoftAdminConsent = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* FETCH_MICROSOFT_ADMIN_CONSENT */]);
var fetchMicrosoftAdminConsentPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* FETCH_MICROSOFT_ADMIN_CONSENT_PENDING */]);
var fetchMicrosoftAdminConsentSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["W" /* FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS */]);
var fetchMicrosoftAdminConsentFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE */]);

var fetchMicrosoftManagedCalendars = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* FETCH_MICROSOFT_MANAGED_CALENDARS */]);
var fetchMicrosoftManagedCalendarsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING */]);
var fetchMicrosoftManagedCalendarsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS */]);
var fetchMicrosoftManagedCalendarsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE */]);

var disconnectMicrosoftAdminConsent = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* DISCONNECT_MICROSOFT_ADMIN_CONSENT */]);
var disconnectMicrosoftAdminConsentPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DISCONNECT_MICROSOFT_ADMIN_CONSENT_PENDING */]);
var disconnectMicrosoftAdminConsentSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* DISCONNECT_MICROSOFT_ADMIN_CONSENT_SUCCESS */]);
var disconnectMicrosoftAdminConsentFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* DISCONNECT_MICROSOFT_ADMIN_CONSENT_FAILURE */]);

var microsoftAdminManagedAccept = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* MICROSOFT_ADMIN_MANAGED_ACCEPT */]);
var microsoftAdminManagedAcceptSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS */]);
var microsoftAdminManagedAcceptFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE */]);

var updateGoogleCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_22" /* UPDATE_GOOGLE_CALENDAR */]);
var updateGoogleCalendarPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_24" /* UPDATE_GOOGLE_CALENDAR_PENDING */]);
var updateGoogleCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* UPDATE_GOOGLE_CALENDAR_SUCCESS */]);
var updateGoogleCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_23" /* UPDATE_GOOGLE_CALENDAR_FAILURE */]);

var updateMicrosoftCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_38" /* UPDATE_MICROSOFT_CALENDAR */]);
var updateMicrosoftCalendarPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_40" /* UPDATE_MICROSOFT_CALENDAR_PENDING */]);
var updateMicrosoftCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_41" /* UPDATE_MICROSOFT_CALENDAR_SUCCESS */]);
var updateMicrosoftCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_39" /* UPDATE_MICROSOFT_CALENDAR_FAILURE */]);

var disconnectGoogleCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* DISCONNECT_GOOGLE_CALENDAR */]);
var disconnectGoogleCalendarPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* DISCONNECT_GOOGLE_CALENDAR_PENDING */]);
var disconnectGoogleCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* DISCONNECT_GOOGLE_CALENDAR_SUCCESS */]);
var disconnectGoogleCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* DISCONNECT_GOOGLE_CALENDAR_FAILURE */]);

var disconnectMicrosoftCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* DISCONNECT_MICROSOFT_CALENDAR */]);
var disconnectMicrosoftCalendarPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* DISCONNECT_MICROSOFT_CALENDAR_PENDING */]);
var disconnectMicrosoftCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* DISCONNECT_MICROSOFT_CALENDAR_SUCCESS */]);
var disconnectMicrosoftCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* DISCONNECT_MICROSOFT_CALENDAR_FAILURE */]);

var fetchGoogleScopes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* FETCH_GOOGLE_SCOPES */]);
var fetchGoogleScopesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* FETCH_GOOGLE_SCOPES_PENDING */]);
var fetchGoogleScopesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* FETCH_GOOGLE_SCOPES_SUCCESS */]);
var fetchGoogleScopesFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* FETCH_GOOGLE_SCOPES_FAILURE */]);

var fetchMeetingSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* FETCH_MEETING_SETTINGS */]);
var fetchMeetingSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* FETCH_MEETING_SETTINGS_PENDING */]);
var fetchMeetingSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* FETCH_MEETING_SETTINGS_SUCCESS */]);
var fetchMeetingSettingsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* FETCH_MEETING_SETTINGS_FAILURE */]);

var debounceUpdateMeetingSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DEBOUNCE_UPDATE_MEETING_SETTINGS */]);
var updateMeetingSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_26" /* UPDATE_MEETING_SETTINGS */]);
var updateMeetingSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_32" /* UPDATE_MEETING_SETTINGS_PENDING */]);
var updateMeetingSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_33" /* UPDATE_MEETING_SETTINGS_SUCCESS */]);
var updateMeetingSettingsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_27" /* UPDATE_MEETING_SETTINGS_FAILURE */]);

var deleteMeetingType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DELETE_MEETING_TYPE */]);
var deleteMeetingTypePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* DELETE_MEETING_TYPE_PENDING */]);
var deleteMeetingTypeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* DELETE_MEETING_TYPE_SUCCESS */]);
var deleteMeetingTypeFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* DELETE_MEETING_TYPE_FAILURE */]);

var updateMeetingType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_34" /* UPDATE_MEETING_TYPE */]);
var updateMeetingTypePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_36" /* UPDATE_MEETING_TYPE_PENDING */]);
var updateMeetingTypeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_37" /* UPDATE_MEETING_TYPE_SUCCESS */]);
var updateMeetingTypeFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_35" /* UPDATE_MEETING_TYPE_FAILURE */]);

var fetchMeetingTypes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* FETCH_MEETING_TYPES */]);
var fetchMeetingTypesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* FETCH_MEETING_TYPES_PENDING */]);
var fetchMeetingTypesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* FETCH_MEETING_TYPES_SUCCESS */]);
var fetchMeetingTypesFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* FETCH_MEETING_TYPES_FAILURE */]);

var fetchCalendlyMeetingTypes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_CALENDLY_MEETING_TYPES */]);
var fetchCalendlyMeetingTypesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_CALENDLY_MEETING_TYPES_PENDING */]);
var fetchCalendlyMeetingTypesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* FETCH_CALENDLY_MEETING_TYPES_SUCCESS */]);
var fetchCalendlyMeetingTypesFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_CALENDLY_MEETING_TYPES_FAILURE */]);

var updateMeetingSettingsNewAppointments = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_28" /* UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS */]);
var updateMeetingSettingsNewAppointmentsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_30" /* UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING */]);
var updateMeetingSettingsNewAppointmentsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_31" /* UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS */]);
var updateMeetingSettingsNewAppointmentsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_29" /* UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE */]);

var shareCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_16" /* SHARE_CALENDAR */]);
var shareCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_18" /* SHARE_CALENDAR_SUCCESS */]);
var shareCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_17" /* SHARE_CALENDAR_FAILURE */]);

var fetchConnectedCalendars = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* FETCH_CONNECTED_CALENDARS */]);
var fetchConnectedCalendarsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* FETCH_CONNECTED_CALENDARS_PENDING */]);
var fetchConnectedCalendarsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* FETCH_CONNECTED_CALENDARS_SUCCESS */]);
var fetchConnectedCalendarsFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* FETCH_CONNECTED_CALENDARS_FAILURE */]);

var shareRoutedCalendar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_19" /* SHARE_ROUTED_CALENDAR */]);
var shareRoutedCalendarSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_21" /* SHARE_ROUTED_CALENDAR_SUCCESS */]);
var shareRoutedCalendarFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_20" /* SHARE_ROUTED_CALENDAR_FAILURE */]);

var openedMeetingEmailModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_15" /* OPENED_MEETING_EMAIL_MODAL */]);

/***/ }),

/***/ "KPF2":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 18H3c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zM3 16h18c.551 0 1-.449 1-1V3.203l-9.372 7.575a.996.996 0 0 1-1.256 0L2 3.203V15c0 .551.449 1 1 1zM20.307 2H3.693L12 8.715 20.307 2z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "KQYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__ = __webpack_require__("GoMo");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.






var ConversationAPI = Marty.createStateSource({
  id: 'ConversationAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["i" /* CONVERSATION_API */],

  fetchConversationsById: function fetchConversationsById(conversationIds) {
    return this.post({
      url: 'conversations/find',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["a" /* JSON */],
      body: JSON.stringify({ ids: conversationIds })
    });
  },
  fetchRecentOpenConversations: function fetchRecentOpenConversations() {
    return this.get({
      url: 'conversations/open',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchConversation: function fetchConversation(conversationId) {
    return this.get({
      url: '/conversations/' + conversationId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  searchConversations: function searchConversations(query) {
    return this.get({
      url: '/conversations/search?q=' + encodeURI(query),
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  sendActiveStatus: function sendActiveStatus() {
    return this.post({
      url: "/agents/active",
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["a" /* JSON */]
    });
  },
  sendMobileNotificationTest: function sendMobileNotificationTest() {
    return this.post({
      url: "/notifications/test/push",
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["a" /* JSON */]
    });
  },
  sendEmailNotificationTest: function sendEmailNotificationTest() {
    return this.post({
      url: "/notifications/test/email",
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["a" /* JSON */]
    });
  },
  sendBrowserNotificationTest: function sendBrowserNotificationTest() {
    return this.post({
      url: "/notifications/test/web",
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_3_constants_RequestContentType__["a" /* JSON */]
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ConversationAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(512);

/***/ }),

/***/ "KTtR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withOAuthConnectionStatus__ = __webpack_require__("hzfC");





var CalendarSettingsLink = function CalendarSettingsLink(_ref) {
  var isConnected = _ref.isConnected;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: '/meetings' },
    isConnected ? 'View meeting settings' : 'Connect your calendar'
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_2__withOAuthConnectionStatus__["a" /* default */])(CalendarSettingsLink));

/***/ }),

/***/ "KWmQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SalesforceLeadRoutingRadioDisplay__ = __webpack_require__("1Vzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__ = __webpack_require__("Sctq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("/1Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SalesforceRoutingHeader = function (_Component) {
  _inherits(SalesforceRoutingHeader, _Component);

  function SalesforceRoutingHeader() {
    _classCallCheck(this, SalesforceRoutingHeader);

    return _possibleConstructorReturn(this, (SalesforceRoutingHeader.__proto__ || Object.getPrototypeOf(SalesforceRoutingHeader)).apply(this, arguments));
  }

  _createClass(SalesforceRoutingHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          overlayText = _props.overlayText;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
          { flow: 'up', component: overlayText },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 15, height: 15, name: 'info' })
        )
      );
    }
  }]);

  return SalesforceRoutingHeader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SalesforceLeadRouting = function (_Component2) {
  _inherits(SalesforceLeadRouting, _Component2);

  function SalesforceLeadRouting(props) {
    _classCallCheck(this, SalesforceLeadRouting);

    var _this2 = _possibleConstructorReturn(this, (SalesforceLeadRouting.__proto__ || Object.getPrototypeOf(SalesforceLeadRouting)).call(this, props));

    _this2.cleanLabel = function (fieldName, objectName) {
      //SFDC labels the owner field as {Object} Owner but only exposes the Owner Id label through their API :(
      return fieldName === "Owner ID" ? objectName + " Owner" : fieldName;
    };

    _this2.selectObject = function (index, _ref) {
      var value = _ref.value;

      var settingsClone = [].concat(_toConsumableArray(_this2.state.salesforceLeadRoutingSettings));
      settingsClone[index].object = value;
      _this2.setState({ salesforceLeadRoutingSettings: settingsClone }, function () {
        _this2.props.onSalesforceLeadRoutingSettingsUpdated(_this2.state.salesforceLeadRoutingSettings);
      });
    };

    _this2.selectField = function (index, _ref2) {
      var value = _ref2.value;

      var settingsClone = [].concat(_toConsumableArray(_this2.state.salesforceLeadRoutingSettings));
      settingsClone[index].field = value;
      _this2.setState({ salesforceLeadRoutingSettings: settingsClone }, function () {
        _this2.props.onSalesforceLeadRoutingSettingsUpdated(_this2.state.salesforceLeadRoutingSettings);
      });
    };

    _this2.state = {
      salesforceLeadRoutingSettings: [],
      salesforceLeadRoutingToggles: [],
      formattedSFDCObjects: [],
      formattedAccountFields: [],
      formattedContactFields: [],
      formattedLeadFields: [],
      lookupContactByEmail: false,
      lookupAccountByWebsite: false,
      defaultSettings: [{
        object: "Account",
        field: "OwnerId",
        lookupMethod: __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__["a" /* LookupMethodEnum */].CONTACT_EMAIL
      }]
    };
    return _this2;
  }

  _createClass(SalesforceLeadRouting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchSFDCObjectList();
      this.props.actions.fetchSFDCFLeadRoutingSettings();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this3 = this;

      var salesforceLeadRoutingSettings = this.state.salesforceLeadRoutingSettings;


      if (this.props.sfdcObjectList !== prevProps.sfdcObjectList) {
        this.setState({
          formattedSFDCObjects: this.props.sfdcObjectList.map(function (object) {
            return { label: object, value: object };
          })
        }, function () {
          _this3.props.sfdcObjectList.forEach(function (element) {
            _this3.props.actions.fetchSFDCFieldList(element);
          });
        });
      }

      if (this.props.sfdcAccountFieldsList !== prevProps.sfdcAccountFieldsList) {
        this.setState({
          formattedAccountFields: this.props.sfdcAccountFieldsList.map(function (field) {
            return { label: _this3.cleanLabel(field.label, "Account"), value: field.name };
          })
        });
      }

      if (this.props.sfdcContactFieldsList !== prevProps.sfdcContactFieldsList) {
        this.setState({
          formattedContactFields: this.props.sfdcContactFieldsList.map(function (field) {
            return { label: _this3.cleanLabel(field.label, "Contact"), value: field.name };
          })
        });
      }

      if (this.props.sfdcLeadFieldsList !== prevProps.sfdcLeadFieldsList) {
        this.setState({
          formattedLeadFields: this.props.sfdcLeadFieldsList.map(function (field) {
            return { label: _this3.cleanLabel(field.label, "Lead"), value: field.name };
          })
        });
      }

      if (this.props.sfdcLeadRoutingSettings !== prevProps.sfdcLeadRoutingSettings) {
        var newSettings = this.props.sfdcLeadRoutingSettings.length === 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.state.defaultSettings) : this.props.sfdcLeadRoutingSettings;
        this.setState({ salesforceLeadRoutingSettings: newSettings });
        this.props.onSalesforceLeadRoutingSettingsUpdated(newSettings);
      }

      if (this.state.salesforceLeadRoutingToggles !== prevState.salesforceLeadRoutingToggles) {
        this.props.onSalesforceLeadRoutingTogglesUpdated(this.state.salesforceLeadRoutingToggles);
      }
    }
  }, {
    key: 'selectAccountFindOption',
    value: function selectAccountFindOption(index, value) {
      var _this4 = this;

      if (index in this.state.salesforceLeadRoutingSettings) {
        var settingsClone = [].concat(_toConsumableArray(this.state.salesforceLeadRoutingSettings));
        settingsClone[index].lookupMethod = value;
        this.setState({ salesforceLeadRoutingSettings: settingsClone }, function () {
          _this4.props.onSalesforceLeadRoutingSettingsUpdated(_this4.state.salesforceLeadRoutingSettings);
        });
      }
    }
  }, {
    key: 'fieldOptions',
    value: function fieldOptions(objectType) {
      switch (objectType) {
        case 'Account':
          return this.state.formattedAccountFields;
        case 'Contact':
          return this.state.formattedContactFields;
        case 'Lead':
          return this.state.formattedLeadFields;
        default:
          return this.state.formattedAccountFields;
      }
    }
  }, {
    key: 'fieldSelection',
    value: function fieldSelection(index) {
      return !Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isEmpty"])(this.props.sfdcLeadRoutingSettings) && this.props.sfdcLeadRoutingSettings[index].field;
    }
  }, {
    key: 'displayExistingSettingRows',
    value: function displayExistingSettingRows() {
      var _this5 = this;

      var tableRow = this.state.salesforceLeadRoutingSettings.map(function (row, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { key: index },
          _this5.renderTableRow(_this5.state.salesforceLeadRoutingSettings, index, _this5.selectObject, _this5.selectField)
        );
      });

      return tableRow;
    }
  }, {
    key: 'addRow',
    value: function addRow() {
      var _this6 = this;

      var settingsClone = [].concat(_toConsumableArray(this.state.salesforceLeadRoutingSettings));
      var defaultSettings = this.state.defaultSettings;

      settingsClone.push(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(defaultSettings[0]));
      this.setState({ salesforceLeadRoutingSettings: settingsClone }, function () {
        _this6.props.onSalesforceLeadRoutingSettingsUpdated(_this6.state.salesforceLeadRoutingSettings);
      });
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(index) {
      var _this7 = this;

      var settingsClone = [].concat(_toConsumableArray(this.state.salesforceLeadRoutingSettings));
      settingsClone.splice(index, 1);
      this.setState({ salesforceLeadRoutingSettings: settingsClone }, function () {
        _this7.props.onSalesforceLeadRoutingSettingsUpdated(_this7.state.salesforceLeadRoutingSettings);
      });
    }
  }, {
    key: 'renderTableRow',
    value: function renderTableRow(values, index, onObjectChange, onFieldChange) {
      var _this8 = this;

      var isFirst = index === 0;
      var isLast = index === values.length - 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'rules-dropdown-table' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              { className: 'rules-row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: isFirst ? "padded-label" : "" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  isFirst ? "Primary" : "Fallback"
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
                  clearable: false,
                  searchable: false,
                  label: isFirst && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesforceRoutingHeader, {
                    className: "rules-sfdc-object-label",
                    label: "SFDC OBJECT",
                    overlayText: "Salesforce Accounts, Contacts, or Leads"
                  }),
                  className: 'rules-sfdc-object',
                  placeholder: 'Select ...',
                  value: values[index].object,
                  options: this.state.formattedSFDCObjects,
                  onChange: function onChange(value) {
                    return onObjectChange(index, value);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
                  clearable: false,
                  searchable: false,
                  label: isFirst && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SalesforceRoutingHeader, {
                    className: "rules-sfdc-field-label",
                    label: "SFDC FIELD",
                    overlayText: "An ID field associated with the object that should map to Drift"
                  }),
                  className: 'rules-sfdc-field',
                  placeholder: 'Select ...',
                  value: values[index].field,
                  options: this.fieldOptions(values[index].object),
                  onChange: function onChange(value) {
                    return onFieldChange(index, value);
                  }
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'td',
                { className: 'padded-button' },
                !isFirst && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'delete-button',
                    onClick: function onClick() {
                      _this8.deleteRow(index);
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 15, name: 'trash' })
                ),
                isLast && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
                  { size: 'small',
                    type: 'tertiary',
                    className: "or-button" + (isFirst ? " padded-button" : ""),
                    onClick: function onClick() {
                      _this8.addRow();
                    } },
                  '+ OR'
                )
              )
            )
          )
        ),
        values[index].object === 'Account' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SalesforceLeadRoutingRadioDisplay__["a" /* default */], {
          contactLookupChecked: values[index].lookupMethod === __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__["a" /* LookupMethodEnum */].CONTACT_EMAIL,
          contactLookupOnClick: function contactLookupOnClick() {
            _this8.selectAccountFindOption(index, __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__["a" /* LookupMethodEnum */].CONTACT_EMAIL);
          },
          accountLookupChecked: values[index].lookupMethod === __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__["a" /* LookupMethodEnum */].DOMAIN,
          accountLookupOnClick: function accountLookupOnClick() {
            _this8.selectAccountFindOption(index, __WEBPACK_IMPORTED_MODULE_5_constants_SalesforceLeadRoutingConstants__["a" /* LookupMethodEnum */].DOMAIN);
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-lead-routing-form' },
        this.displayExistingSettingRows()
      );
    }
  }]);

  return SalesforceLeadRouting;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceLeadRouting);

/***/ }),

/***/ "Khpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EveryoneString */
/* unused harmony export VisitorString */
/* unused harmony export UserString */
/* unused harmony export Audience */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IdentifiedUsersOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EveryoneOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnonymousOption; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton__ = __webpack_require__("EP6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__("tLAg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var LabelClasses = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.AudienceOption_Label, 'flex');

var EveryoneString = 'Everyone';
var VisitorString = 'Site Visitors';
var UserString = 'Known Users';

var Audience = {
  VISITORS: {
    display: VisitorString
  },
  USERS: {
    display: UserString
  },
  EVERYONE: {
    display: EveryoneString,
    renderDisplay: function renderDisplay(userCount) {
      var noun = userCount > 1 ? 'Users' : 'User';
      return EveryoneString + ' (' + VisitorString + ', ' + userCount + ' ' + noun + ')';
    }
  }
};

var AnonymousUserLabel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: LabelClasses },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
    src: __webpack_require__("tx/f"),
    element: 'div',
    className: 'icon',
    style: { width: 11, height: 11 }
  }),
  "any site visitors who aren't logged in and"
);

var IdentifiedUsersOptionInner = function (_Component) {
  _inherits(IdentifiedUsersOptionInner, _Component);

  function IdentifiedUsersOptionInner() {
    _classCallCheck(this, IdentifiedUsersOptionInner);

    return _possibleConstructorReturn(this, (IdentifiedUsersOptionInner.__proto__ || Object.getPrototypeOf(IdentifiedUsersOptionInner)).apply(this, arguments));
  }

  _createClass(IdentifiedUsersOptionInner, [{
    key: 'render',
    value: function render() {
      var endUsersCount = this.props.endUsersCount;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton__["MenuItem"],
        {
          key: 'USERS',
          value: 'USERS',
          text: 'known users',
          className: __WEBPACK_IMPORTED_MODULE_6__style___default.a.AudienceOption
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body' },
          Audience.USERS.display
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: LabelClasses },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
            src: __webpack_require__("PK+e"),
            element: 'div',
            className: 'icon',
            style: { width: 11, height: 13 } }),
          endUsersCount ? endUsersCount + ' users' : ''
        )
      );
    }
  }]);

  return IdentifiedUsersOptionInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var IdentifiedUsersOption = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(IdentifiedUsersOptionInner);

var EveryoneOptionInner = function (_Component2) {
  _inherits(EveryoneOptionInner, _Component2);

  function EveryoneOptionInner() {
    _classCallCheck(this, EveryoneOptionInner);

    return _possibleConstructorReturn(this, (EveryoneOptionInner.__proto__ || Object.getPrototypeOf(EveryoneOptionInner)).apply(this, arguments));
  }

  _createClass(EveryoneOptionInner, [{
    key: 'render',
    value: function render() {
      var endUsersCount = this.props.endUsersCount;

      var labels = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        AnonymousUserLabel,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: LabelClasses },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
            src: __webpack_require__("PK+e"),
            element: 'div',
            className: 'icon',
            style: { marginLeft: '.2rem', width: 11, height: 13 } }),
          endUsersCount ? endUsersCount + ' users' : ''
        )
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton__["MenuItem"],
        {
          key: 'EVERYONE',
          value: 'EVERYONE',
          text: 'everyone',
          className: __WEBPACK_IMPORTED_MODULE_6__style___default.a.AudienceOption
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body' },
          Audience.EVERYONE.display
        ),
        labels
      );
    }
  }]);

  return EveryoneOptionInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    endUsersCount: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["endUserCount"])(state)
  };
};

var EveryoneOption = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(EveryoneOptionInner);

var AnonymousOption = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_4_react_aria_menubutton__["MenuItem"],
  {
    key: 'VISITORS',
    value: 'VISITORS',
    text: 'site visitors',
    className: __WEBPACK_IMPORTED_MODULE_6__style___default.a.AudienceOption + ' nm-anonymous-option'
  },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'dsg-Body' },
    Audience.VISITORS.display
  ),
  AnonymousUserLabel
);

/***/ }),

/***/ "Kkvv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export selectedConversations */
/* unused harmony export isConversationSelected */
/* unused harmony export selectedConversationsCount */
/* unused harmony export isSelectedConversationsLimitReached */
/* unused harmony export composeModalStatus */
/* unused harmony export composeModalEndUserId */
/* unused harmony export composeModalEndUser */
/* unused harmony export composeType */
/* unused harmony export composeModalCompanyName */
/* unused harmony export composeModalPage */
/* unused harmony export byId */
/* unused harmony export getSuggestedArticles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getGlobalAutoCloseConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isGlobalAutoCloseConfigurationLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isGlobalAutoCloseConfigurationLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return makePaginatedConversationData; });
/* unused harmony export filteredPaginatedConversationDataById */
/* unused harmony export makeFilteredPaginatedConversationDataById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return activeQuery; });
/* unused harmony export makeConversations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return makeActiveConversations; });
/* unused harmony export makeConversationsCount */
/* unused harmony export hasMoreConversations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return nextCursor; });
/* unused harmony export conversationHasLoaded */
/* unused harmony export conversationIsLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return makeConversationSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return makeConversationLoadedSelector; });
/* unused harmony export makeFetchConversationFailedSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return activeConversationContactTabIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return activeConversationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activeConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return endUserConversationsCountFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return endUserConversationsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return conversationCountForEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return playbookIdByConversationId; });
/* unused harmony export getInfluencingPlaybookIdForActiveConversation */
/* unused harmony export getPlaybookIdForActiveConversation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return makeConversation; });
/* unused harmony export conversationTags */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return endUserIdsOfActiveConversations; });
/* unused harmony export getRoutingAuditLog */
/* unused harmony export getRoutingAuditLogLoaded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getRoutingAuditLogNeverLoaded; });
/* unused harmony export routingAuditLogHasRules */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return makeParticipantIdsByConversationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return makeConversationStatusByConversationId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_unread_selectors__ = __webpack_require__("385t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ConversationStatusConstants__ = __webpack_require__("U98Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_SortConversationsConstants__ = __webpack_require__("/Ggu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("dMZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fast_json_stable_stringify__ = __webpack_require__("hBsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_fast_json_stable_stringify__);












var root = function root(state) {
  return state.get('conversations');
};

var selectedConversations = function selectedConversations(state) {
  return root(state).get('selectedConversations');
};
var isConversationSelected = function isConversationSelected(state, _ref) {
  var conversationId = _ref.conversationId;
  return selectedConversations(state).has(conversationId);
};
var selectedConversationsCount = function selectedConversationsCount(state) {
  return selectedConversations(state).size;
};
var isSelectedConversationsLimitReached = function isSelectedConversationsLimitReached(state) {
  return selectedConversationsCount(state) === __WEBPACK_IMPORTED_MODULE_8__constants__["N" /* MAX_SELECTED_CONVERSATIONS_COUNT */];
};

var composeModalStatus = function composeModalStatus(state) {
  return root(state).get('composeModalStatus').status;
};
var composeModalEndUserId = function composeModalEndUserId(state) {
  return root(state).get('composeModalStatus').endUserId;
};
var composeModalEndUser = function composeModalEndUser(state) {
  return root(state).get('composeModalStatus').endUser;
};
var composeType = function composeType(state) {
  return root(state).get('composeModalStatus').composeType;
};
var composeModalCompanyName = function composeModalCompanyName(state) {
  return root(state).get('composeModalStatus').companyName;
};
var composeModalPage = function composeModalPage(state) {
  return root(state).get('composeModalStatus').page;
};

var activeQueryByInboxId = function activeQueryByInboxId(state) {
  return root(state).get('activeQueryByInboxId');
};
var activeConversationByInboxId = function activeConversationByInboxId(state) {
  return root(state).get('activeConversationByInboxId');
};

var byId = function byId(state) {
  return root(state).get('byId');
};

var paginatedConversationsByQuery = function paginatedConversationsByQuery(state) {
  return root(state).get('paginatedConversationsByQuery');
};
var paginatedConversationDataById = function paginatedConversationDataById(state) {
  return root(state).get('paginatedConversationDataById');
};

var endUserConversationsCounts = function endUserConversationsCounts(state) {
  return root(state).get('endUserConversationsCounts');
};

var paginatedConversations = function paginatedConversations(state, _ref2) {
  var query = _ref2.query;

  return paginatedConversationsByQuery(state).get(__WEBPACK_IMPORTED_MODULE_10_fast_json_stable_stringify___default()(query), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
};

var makePaginatedConversations = function makePaginatedConversations() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(paginatedConversations, function (paginatedConversations) {
    return paginatedConversations;
  });
};

var getSuggestedArticles = function getSuggestedArticles(state) {
  return root(state).get('suggestedArticles');
};

var globalAutoCloseConfiguration = function globalAutoCloseConfiguration(state) {
  return root(state).get('globalAutoCloseConfiguration');
};
var globalAutoCloseConfigurationData = function globalAutoCloseConfigurationData(state) {
  return globalAutoCloseConfiguration(state).get('data');
};
var globalAutoCloseConfigurationStatus = function globalAutoCloseConfigurationStatus(state) {
  return globalAutoCloseConfiguration(state).get('status');
};

var getGlobalAutoCloseConfiguration = function getGlobalAutoCloseConfiguration(state) {
  return globalAutoCloseConfigurationData(state);
};

var isGlobalAutoCloseConfigurationLoading = function isGlobalAutoCloseConfigurationLoading(state) {
  var status = globalAutoCloseConfigurationStatus(state).get('fetch');
  return status === __WEBPACK_IMPORTED_MODULE_8__constants__["B" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING */];
};

var isGlobalAutoCloseConfigurationLoaded = function isGlobalAutoCloseConfigurationLoaded(state) {
  var status = globalAutoCloseConfigurationStatus(state).get('fetch');
  return [__WEBPACK_IMPORTED_MODULE_8__constants__["C" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS */], __WEBPACK_IMPORTED_MODULE_8__constants__["A" /* FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE */]].includes(status);
};

var makePaginatedConversationData = function makePaginatedConversationData() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([paginatedConversationDataById, function (state, _ref3) {
    var conversationId = _ref3.conversationId;
    return conversationId;
  }], function (paginatedConversationDataById, conversationId) {
    return paginatedConversationDataById.get(conversationId);
  });
};

var filteredPaginatedConversationDataById = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([paginatedConversationDataById, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"]], function (paginatedConversationDataById, user) {
  return paginatedConversationDataById.filter(function (conversationData) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_access_helpers__["b" /* hasConversationAccess */])(conversationData.participantIds, user);
  });
});

var makeFilteredPaginatedConversationDataById = function makeFilteredPaginatedConversationDataById() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([paginatedConversationDataById, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"]], function (paginatedConversationDataById, user) {
    return paginatedConversationDataById.filter(function (conversationData) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_access_helpers__["b" /* hasConversationAccess */])(conversationData.participantIds, user);
    });
  });
};

var activeQuery = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_selectors__["b" /* currentInboxId */], activeQueryByInboxId], function (currentInboxId, activeQueryByInboxId) {
  return activeQueryByInboxId.get(currentInboxId, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
});

var parseParticipantFilter = function parseParticipantFilter(query) {
  if (query.get('participantFilter') === '0') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])([0]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(query.get('participantFilter')).map(function (id) {
    return parseInt(id);
  });
};

var queryAppliesToConversation = function queryAppliesToConversation(query, conversation) {
  if (!query) {
    return false;
  }

  if (query.get('statusFilter') != null) {
    if (!query.get('statusFilter').includes(conversation.status)) {
      return false;
    }
  } else {
    if (!__WEBPACK_IMPORTED_MODULE_6_constants_ConversationStatusConstants__["a" /* ActiveConversationStatuses */].includes(conversation.status)) {
      return false;
    }
  }

  if (query.get('participantFilter') != null) {
    var filteredParticipantIds = parseParticipantFilter(query);
    var matchesNoParticipants = filteredParticipantIds.has(0) && conversation.participantIds.size === 0;
    var matchesSelectedParticipants = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(conversation.participantIds).intersect(filteredParticipantIds).count() > 0;
    if (!matchesNoParticipants && !matchesSelectedParticipants) {
      return false;
    }
  }

  if (query.get('typeFilter') != null) {
    if (!query.get('typeFilter').includes(conversation.type)) {
      return false;
    }
  }

  if (query.get('conversationTagFilter') != null) {
    if (query.get('conversationTagFilter').some(function (tagFilter) {
      return !(conversation.tags && conversation.tags.includes(parseInt(tagFilter)));
    })) {
      return false;
    }
  }

  return true;
};

var makeConversations = function makeConversations() {
  var filteredPaginatedConversationDataByIdSelector = makeFilteredPaginatedConversationDataById();
  var paginatedConversationsSelector = makePaginatedConversations();

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([filteredPaginatedConversationDataByIdSelector, paginatedConversationsSelector, __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_selectors__["b" /* currentInboxId */], __WEBPACK_IMPORTED_MODULE_5_app_modules_unread_selectors__["a" /* unreadConversationIds */], activeConversationId, function (state, _ref4) {
    var query = _ref4.query;
    return query;
  }, function (state, _ref5) {
    var filterUnreadsOnly = _ref5.filterUnreadsOnly;
    return filterUnreadsOnly;
  }], function (filteredPaginatedConversationDataById, paginatedConversations, currentInboxId, unreadConversationIds, activeConversationId, query, filterUnreadsOnly) {
    var filteredByQuery = filteredPaginatedConversationDataById.filter(function (conversationData) {
      return conversationData.inboxId === currentInboxId && queryAppliesToConversation(query, conversationData);
    }).filter(function (conversation) {
      if (filterUnreadsOnly) {
        return unreadConversationIds.includes(conversation.id) || conversation.id === activeConversationId;
      }

      return true;
    });

    var sortedConversations = filteredByQuery.sortBy(function (conversationData) {
      if (query.get('sortBy') === __WEBPACK_IMPORTED_MODULE_7_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].OLDEST.value) {
        return conversationData.updatedAt;
      }

      return -conversationData.updatedAt;
    });

    var filteredByPaginationCursor = sortedConversations.filter(function (conversationData) {
      if (paginatedConversations) {
        var cursor = paginatedConversations.get('cursor');
        var hasMore = paginatedConversations.get('hasMore');

        if (hasMore && cursor) {
          if (query.get('sortBy') === __WEBPACK_IMPORTED_MODULE_7_constants_SortConversationsConstants__["a" /* SortConversationsEnum */].OLDEST.value) {
            return conversationData.updatedAt <= cursor;
          }

          return conversationData.updatedAt >= cursor;
        }
      }

      return true;
    });

    return filteredByPaginationCursor;
  });
};

var makeActiveConversations = function makeActiveConversations() {
  var conversationsSelector = makeConversations();

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([activeQuery, function (state) {
    return state;
  }], function (activeQuery, state) {
    return conversationsSelector(state, { query: activeQuery });
  });
};

var makeConversationsCount = function makeConversationsCount() {
  var conversationsSelector = makeConversations();

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(conversationsSelector, function (conversations) {
    return conversations.count();
  });
};

var hasMoreConversations = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(paginatedConversations, function (paginatedConversations) {
  return paginatedConversations.get('hasMore', false);
});

var nextCursor = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(paginatedConversations, function (paginatedConversations) {
  return paginatedConversations.get('cursor', 0);
});

var conversationHasLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(paginatedConversations, function (paginatedConversations) {
  return paginatedConversations.get('loaded', false);
});

var conversationIsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(paginatedConversations, function (paginatedConversations) {
  return paginatedConversations.get('loading', false);
});

var makeConversationSelector = function makeConversationSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([byId, function (state, props) {
    return props.conversationId;
  }], function (byId, conversationId) {
    return byId.getIn([conversationId, 'data']);
  });
};
var makeConversationLoadedSelector = function makeConversationLoadedSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([byId, function (state, props) {
    return props.conversationId;
  }], function (byId, conversationId) {
    return [__WEBPACK_IMPORTED_MODULE_8__constants__["S" /* RECEIVE_CONVERSATION */], __WEBPACK_IMPORTED_MODULE_8__constants__["s" /* FETCH_CONVERSATION_FAILED */]].includes(byId.getIn([conversationId, 'status']));
  });
};

var makeFetchConversationFailedSelector = function makeFetchConversationFailedSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([byId, function (state, props) {
    return props.conversationId;
  }], function (byId, conversationId) {
    return byId.getIn([conversationId, 'status']) === __WEBPACK_IMPORTED_MODULE_8__constants__["s" /* FETCH_CONVERSATION_FAILED */];
  });
};

var activeConversationContactTabIndex = function activeConversationContactTabIndex(state) {
  return root(state).get('activeConversationContactTabIndex');
};

var activeConversationId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_selectors__["b" /* currentInboxId */], activeConversationByInboxId], function (currentInboxId, activeConversationByInboxId) {
  return activeConversationByInboxId.get(currentInboxId) || null;
});

var activeConversation = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([activeConversationId, byId], function (activeConversationId, byId) {
  return byId.getIn([activeConversationId, 'data']);
});

var endUserConversationsCountFetched = function endUserConversationsCountFetched(state, props) {
  return endUserConversationsCounts(state).has(props.endUser.id);
};
var endUserConversationsCount = function endUserConversationsCount(state, props) {
  return endUserConversationsCounts(state).get(props.endUser.id);
};

var conversationCountForEndUser = function conversationCountForEndUser(state, _ref6) {
  var endUserId = _ref6.endUserId;
  return endUserConversationsCounts(state).get(endUserId, { all: 0 }).all;
};

var playbookIdByConversationId = function playbookIdByConversationId(state) {
  return root(state).get('playbookIdByConversationId');
};

var getInfluencingPlaybookIdForActiveConversation = function getInfluencingPlaybookIdForActiveConversation(state) {
  var conversationSelector = makeConversationSelector();
  var conversationFromState = conversationSelector(state, { conversationId: activeConversationId(state) });
  return conversationFromState && conversationFromState.getIn(['context', 'influencingCampaignId'], 0);
};

var getPlaybookIdForActiveConversation = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(activeConversationId, playbookIdByConversationId, function (activeConversationId, playbookIdByConversationId) {
  return playbookIdByConversationId.get(activeConversationId);
});

var makeConversation = function makeConversation() {
  return function (state, props) {
    return byId(state).getIn([props.conversationId, 'data']);
  };
};

var conversationTags = function conversationTags(state, props) {
  return byId(state).getIn([props.conversationId, 'data', 'tags']);
};

var endUserIdsOfActiveConversations = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(filteredPaginatedConversationDataById, activeConversation, function (filteredPaginatedConversationDataById, activeConversation) {
  var activeConversations = activeConversation ? filteredPaginatedConversationDataById.set(activeConversation.id, activeConversation) : filteredPaginatedConversationDataById;
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(activeConversations.map(function (conversation) {
    return conversation.endUserId;
  }).valueSeq());
});

var getRoutingAuditLog = function getRoutingAuditLog(state, routingGroupId) {
  return root(state).getIn(['routingAuditLogById', routingGroupId]);
};
var getRoutingAuditLogLoaded = function getRoutingAuditLogLoaded(state, routingGroupId) {
  return root(state).getIn(['routingAuditLogStatusById', routingGroupId]) === __WEBPACK_IMPORTED_MODULE_9__actions__["B" /* fetchRoutingAuditLogSuccess */].toString();
};
var getRoutingAuditLogNeverLoaded = function getRoutingAuditLogNeverLoaded(state, routingGroupId) {
  return root(state).getIn(['routingAuditLogStatusById', routingGroupId]) === undefined;
};
var routingAuditLogHasRules = function routingAuditLogHasRules(state, routingGroupId) {
  return getRoutingAuditLogLoaded(state, routingGroupId) && getRoutingAuditLog(state, routingGroupId).some(function (entry) {
    return entry.routingEntryType === 'RULE_ROUTE';
  });
};

var makeParticipantIdsByConversationId = function makeParticipantIdsByConversationId() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([filteredPaginatedConversationDataById, function (state, _ref7) {
    var conversationIds = _ref7.conversationIds;
    return conversationIds;
  }], function (filteredPaginatedConversationDataById, conversationIds) {
    var participantIdsByConversationId = conversationIds.reduce(function (accum, conversationId) {
      var conversation = filteredPaginatedConversationDataById.get(conversationId);

      if (!conversation) {
        return accum;
      }

      return accum.set(conversationId, conversation.participantIds);
    }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

    return participantIdsByConversationId;
  });
};

var makeConversationStatusByConversationId = function makeConversationStatusByConversationId() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([filteredPaginatedConversationDataById, function (state, _ref8) {
    var conversationIds = _ref8.conversationIds;
    return conversationIds;
  }], function (filteredPaginatedConversationDataById, conversationIds) {
    return conversationIds.reduce(function (accum, conversationId) {
      var conversation = filteredPaginatedConversationDataById.get(conversationId);

      if (!conversation) {
        return accum;
      }

      return accum.set(conversationId, conversation.status);
    }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
  });
};

/***/ }),

/***/ "KlsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OnlineIndicator__ = __webpack_require__("D7Qt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__("8/TF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EndUserAvatar = function (_Component) {
  _inherits(EndUserAvatar, _Component);

  function EndUserAvatar() {
    _classCallCheck(this, EndUserAvatar);

    return _possibleConstructorReturn(this, (EndUserAvatar.__proto__ || Object.getPrototypeOf(EndUserAvatar)).apply(this, arguments));
  }

  _createClass(EndUserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          endUser = _props.endUser;


      if (!endUser) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style__["placeholderAvatar"], className) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__["a" /* default */], null)
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style__["endUserAvatar"], className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["Avatar"], { user: endUser, size: 'small' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__OnlineIndicator__["a" /* default */], { className: 'onlineIndicator', endUser: endUser })
      );
    }
  }]);

  return EndUserAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EndUserAvatar);

/***/ }),

/***/ "Ko7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_tracking__ = __webpack_require__("jAlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("Z7nH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var HELP_DOC_URL = "https://gethelp.drift.com/hc/en-us/articles/360019666973-How-to-Connect-Drift-and-Eloqua";

var EloquaIntegrationPage = function (_Component) {
  _inherits(EloquaIntegrationPage, _Component);

  function EloquaIntegrationPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EloquaIntegrationPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EloquaIntegrationPage.__proto__ || Object.getPrototypeOf(EloquaIntegrationPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalOpen: false
    }, _this.handleToggleModal = function () {

      _this.setState(function (prevState) {
        return { modalOpen: !prevState.modalOpen };
      });
    }, _this.refreshProperties = function () {
      return _this.props.actions.fetchOrgProperties();
    }, _this.refreshGates = function () {
      return _this.props.actions.refreshCurrentUser();
    }, _this.onConnectClicked = function () {
      _this.context.router.push('/settings/setup/eloqua-config');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EloquaIntegrationPage, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.data.installed;
      var hasEloquaMappedCdosFeature = this.props.userGates.get("eloqua_mapped_cdos") || false;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'eloqua-integration-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'integration-page-description' },
          'Using Eloqua? Seamlessly add Drift in to your existing workflow. With our integration you\u2019ll enrich your team\u2019s Drift experience by syncing Eloqua contact information and pushing Drift leads into Eloqua.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'integration-page-description' },
          'Want more info? Check out our help doc here: ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: HELP_DOC_URL },
            'Eloqua & Drift'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/eloqua/config', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Synced Eloqua Data'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Eloqua and Drift.'
          )
        ),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/eloqua/mapping/attributes', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Mapped Eloqua Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map which fields you want to sync between Drift and Eloqua.'
          )
        ),
        isConnected && (!hasEloquaMappedCdosFeature ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'div-upsell-modal' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core__["Modal"],
            {
              open: this.state.modalOpen,
              onClose: this.handleToggleModal,
              size: 'small',
              className: 'upsell-modal',
              footerCopy: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy__["Button"],
                {
                  type: 'secondary',
                  onClick: Object(__WEBPACK_IMPORTED_MODULE_14_utils_tracking__["b" /* trackEvent */])('Click integration upsell'),
                  href: '/settings2/billing' },
                'Go to Billing'
              ) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy__["H2"],
              null,
              'Syncing to Eloqua CDOs is available on our Advanced Plan or higher'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_12__driftt_tide_core_legacy__["P"],
              null,
              'Access this integration feature by upgrading today!'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { onClick: this.handleToggleModal, className: 'integration-config-link' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core__["Ribbon"], { className: 'ribbon', isUpgrade: true, text: 'upgrade' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                { className: 'integration-section-title' },
                'Mapped CDO Attributes'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Map which fields you want to sync to Eloqua CDOs'
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/eloqua/mapping/attributes/cdo', className: 'integration-config-link' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-section-title' },
            'Mapped CDO Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map which fields you want to sync to Eloqua CDOs'
          )
        )),
        isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/settings/eloqua/event-log', className: 'integration-config-link' },
          'View Eloqua Event Log'
        )
      );
    }
  }]);

  return EloquaIntegrationPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EloquaIntegrationPage.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    orgProperties: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["properties"](state),
    gates: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["gates"](state),
    org: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["org"](state),
    userGates: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["userGates"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_10_redux__["b" /* bindActionCreators */])({ fetchOrg: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["fetchOrg"], fetchOrgProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["fetchOrgProperties"], refreshCurrentUser: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__["refreshCurrentUser"] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__["a" /* default */])(EloquaIntegrationPage)));

/***/ }),

/***/ "Krjk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KtIW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_GEOLOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_GEOLOCATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_GEOLOCATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_GEOLOCATION_FAILURE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('geolocation');

var FETCH_GEOLOCATION = makeConstant('FETCH_GEOLOCATION');
var FETCH_GEOLOCATION_PENDING = makeConstant('FETCH_GEOLOCATION_PENDING');
var FETCH_GEOLOCATION_SUCCESS = makeConstant('FETCH_GEOLOCATION_SUCCESS');
var FETCH_GEOLOCATION_FAILURE = makeConstant('FETCH_GEOLOCATION_FAILURE');

/***/ }),

/***/ "Kv7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_ContactRecordLite__ = __webpack_require__("044x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_models__ = __webpack_require__("/Abo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var PresenceContactRecordLite = function PresenceContactRecordLite(_ref) {
  var user = _ref.user,
      endUser = _ref.endUser,
      props = _objectWithoutProperties(_ref, ['user', 'endUser']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_ContactRecordLite__["a" /* default */], _extends({
    user: endUser,
    userStatus: user && {
      lastUpdatedAt: user.updatedAt,
      geo: user.location
    }
  }, props));
};

var makeMapStateToProps = function makeMapStateToProps() {
  var endUserSelector = __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_selectors__["g" /* makeEndUserSelector */]();
  return function (state, props) {
    var endUserId = props.user && props.user.getIn(['endUserId']);
    var endUser = endUserId && endUserSelector(state, { id: endUserId });
    return {
      endUser: endUser || new __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_models__["a" /* EndUser */]({ id: endUserId })
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps)(PresenceContactRecordLite));

/***/ }),

/***/ "Kxpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attributesFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return properties; });
/* unused harmony export events */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return propertiesOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filteredProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__("tUpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ClearbitBlacklist__ = __webpack_require__("gtVU");







var root = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* root */], function (endUserRoot) {
  return endUserRoot.get('attributes');
});

var attributesFetched = function attributesFetched(state) {
  return root(state).get('status') === __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* receiveAttributes */].toString();
};

var properties = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('properties');
});
var events = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('events');
});

var propertiesOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(properties, function (properties) {
  return properties.map(function (_ref) {
    var name = _ref.name,
        type = _ref.type,
        displayName = _ref.displayName;
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ label: displayName || name, value: name, type: type });
  });
});

var filteredProperties = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(propertiesOptions, function (properties) {
  var blacklist = __WEBPACK_IMPORTED_MODULE_5_constants_ClearbitBlacklist__["a" /* default */];
  var filteredProperties = properties.filter(function (property) {
    return !blacklist.includes(property.get('label'));
  });
  return filteredProperties.toJS();
});

/***/ }),

/***/ "Kxxm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("enmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons_Clearbit__ = __webpack_require__("MZpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Crunchbase__ = __webpack_require__("ENVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_SIX_SENSE__ = __webpack_require__("6xuS");






var CompanyInfoProvider = function CompanyInfoProvider(_ref) {
  var provider = _ref.provider;


  var iconMap = {
    'CLEARBIT_OEM': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icons_Clearbit__["a" /* default */], { key: 'clearbit-icon' }),
    'SIX_SENSE_V3': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_SIX_SENSE__["a" /* default */], { key: 'six-sense-icon' }),
    'CRUNCHBASE_OEM': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_Crunchbase__["a" /* default */], { key: 'crunchbase-icon' })

    // support multiple sources being passed in
  };var iconData = Array.isArray(provider) ? provider.map(function (providerItem) {
    return iconMap[providerItem] || null;
  }) : iconMap[provider] || null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Provider, { icon: iconData });
};

var Provider = function Provider(_ref2) {
  var icon = _ref2.icon;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'company-info-provider' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'company-info-provider-msg' },
      'Powered by'
    ),
    icon
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyInfoProvider);

/***/ }),

/***/ "L/10":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRules", function() { return fetchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRulesPending", function() { return fetchRulesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRulesCancelled", function() { return fetchRulesCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRulesFailed", function() { return fetchRulesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRulesSuccess", function() { return fetchRulesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRoundRobinByKey", function() { return fetchRoundRobinByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRoundRobinByKeyPending", function() { return fetchRoundRobinByKeyPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRoundRobinByKeyCancelled", function() { return fetchRoundRobinByKeyCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRoundRobinByKeyFailed", function() { return fetchRoundRobinByKeyFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRoundRobinByKeySuccess", function() { return fetchRoundRobinByKeySuccess; });
/* harmony export (immutable) */ __webpack_exports__["editRule"] = editRule;
/* harmony export (immutable) */ __webpack_exports__["resetActiveRule"] = resetActiveRule;
/* harmony export (immutable) */ __webpack_exports__["resetActiveRuleAction"] = resetActiveRuleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("T1OH");



var fetchRules = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_RULES */]);
var fetchRulesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_RULES_PENDING */]);
var fetchRulesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_RULES_CANCELLED */]);
var fetchRulesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_RULES_FAILED */]);
var fetchRulesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_RULES_SUCCESS */]);

var fetchRoundRobinByKey = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_ROUND_ROBIN_BY_KEY */]);
var fetchRoundRobinByKeyPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_ROUND_ROBIN_BY_KEY_PENDING */]);
var fetchRoundRobinByKeyCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_ROUND_ROBIN_BY_KEY_CANCELLED */]);
var fetchRoundRobinByKeyFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* FETCH_ROUND_ROBIN_BY_KEY_FAILED */]);
var fetchRoundRobinByKeySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_ROUND_ROBIN_BY_KEY_SUCCESS */]);

function editRule(rule) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* EDIT_RULE */],
    rule: rule
  };
}

function resetActiveRule() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants__["I" /* RESET_ACTIVE_RULE */]
  };
}

function resetActiveRuleAction() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* RESET_ACTIVE_RULE_ACTION */]
  };
}

/***/ }),

/***/ "L3SV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "L6Yq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__ = __webpack_require__("ut3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanyInfoProvider__ = __webpack_require__("Kxxm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_reveal_selectors__ = __webpack_require__("SRF/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_reveal_actions__ = __webpack_require__("tHDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_ContactRecordLite_Social__ = __webpack_require__("1t2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_live_default_company_logo_svg__ = __webpack_require__("lZSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_live_default_company_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_live_default_company_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("Wuyk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var NewCompanyInfo = function (_Component) {
  _inherits(NewCompanyInfo, _Component);

  function NewCompanyInfo() {
    _classCallCheck(this, NewCompanyInfo);

    return _possibleConstructorReturn(this, (NewCompanyInfo.__proto__ || Object.getPrototypeOf(NewCompanyInfo)).apply(this, arguments));
  }

  _createClass(NewCompanyInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.actions.fetchReveal({ endUserId: this.props.endUserId });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.endUserId !== nextProps.endUserId) {
        this.props.actions.fetchReveal({ endUserId: this.props.endUserId });
      }
    }
  }, {
    key: "getSources",
    value: function getSources(sourceData) {
      var toSource = function toSource(datum) {
        return datum && datum.source;
      };
      return _.chain(sourceData).mapValues(toSource).filter(_.identity).uniq().value();
    }
  }, {
    key: "render",
    value: function render() {
      var companyInfo = _.get(this.props.companyInfo, 'value.companyData', {});
      var explainData = _.get(this.props.companyInfo, 'explain.companyData', {});
      var location = _.get(companyInfo, 'address', '-');
      var category = _.get(companyInfo, 'industry', '-');
      var subCategory = _.get(companyInfo, 'subIndustry', '-') || '-';
      var linkedin = _.get(companyInfo, 'linkedinHandle');
      var employees = _.get(companyInfo, 'employeeCount', '-');
      var raised = _.get(companyInfo, 'raised', '-');
      var twitter = _.get(companyInfo, 'twitterHandle');
      var about = _.get(companyInfo, 'description', '-');
      var revenueRange = _.get(companyInfo, 'revenueRange', '-');
      var sources = this.getSources(explainData);
      var url = _.get(companyInfo, 'url');
      var logo = _.get(companyInfo, 'logo');
      var domain = _.get(companyInfo, 'domain');
      var tags = _.union(_.get(companyInfo, 'techTags'), _.get((companyInfo, 'companyTags')));

      var canUseCompanyTags = this.props.canUseCompanyTags;

      var companyLogo = !!logo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_shared_AvatarCompat__["a" /* AvatarCompat */], { company: { name: name, logo: logo }, type: "company", size: "small" }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "contact-info-header-logo" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_live_default_company_logo_svg___default.a })
      );
      var companyProvider = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CompanyInfoProvider__["a" /* default */], { provider: sources });

      var companyLink = _.includes(url, 'http') ? url : "http://www." + domain;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "scrolly-content" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "company-info-header" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "company-info-header-left" },
            companyLogo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "company-info-header-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "company-info-title" },
              name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              { href: companyLink, target: "_blank", className: "company-info-url" },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "span",
                null,
                domain
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              { className: "company-info-social" },
              !!twitter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_ContactRecordLite_Social__["a" /* default */], { type: "twitter", handle: twitter, className: "company-info-social-icon" }),
              !!linkedin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_ContactRecordLite_Social__["a" /* default */], { type: "linkedin", handle: linkedin, className: "company-info-social-icon" })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "company-info-content" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "company-info-content-left" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: location, secondary: "location" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: category, secondary: "category" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: subCategory, secondary: "subcategory" }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_components_shared_ConditionalRender__["a" /* default */],
              { condition: canUseCompanyTags },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: tags.join(', '), secondary: "tags" })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "company-info-content-right" },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: employees, secondary: "employees" }),
            sources.includes('DEMANDBASE_OEM') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: revenueRange, secondary: "revenue range" }),
            sources.includes('CLEARBIT_OEM') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: "$" + Object(__WEBPACK_IMPORTED_MODULE_3_humanize_plus__["intComma"])(raised), secondary: "money raised" })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: "company-info-content-divider" }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyInfoField__["a" /* default */], { primary: about, secondary: "about" })
        ),
        !!companyProvider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "company-info-footer" },
          companyProvider
        )
      );
    }
  }]);

  return NewCompanyInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state, props) {
    var revealData = __WEBPACK_IMPORTED_MODULE_7_app_modules_reveal_selectors__["a" /* makeGetEndUserReveal */]();

    return {
      companyInfo: revealData(state, { endUserId: props.endUserId, orgId: props.orgId }),
      canUseCompanyTags: props.canUseCompanyTags,
      orgId: props.orgId
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchReveal: __WEBPACK_IMPORTED_MODULE_8_app_modules_reveal_actions__["g" /* fetchRevealDataBySourceProperties */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(NewCompanyInfo));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "L7W3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resolveStatusIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("90gJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_values__ = __webpack_require__("JWJY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda_src_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_contains__ = __webpack_require__("wPla");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda_src_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("xdQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);









var resolveStatusIcon = function resolveStatusIcon(user) {
  var isValidAgentStatus = __WEBPACK_IMPORTED_MODULE_5_ramda_src_contains___default()(user.availability, __WEBPACK_IMPORTED_MODULE_4_ramda_src_values___default()(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AvailabilityStatus */]));
  var agentStatus = isValidAgentStatus ? user.availability : __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AvailabilityStatus */].AWAY;
  return __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* AvailabilityStatusIcons */].find(function (icon) {
    return icon.availabilityStatus === agentStatus;
  }).icon;
};

var StatusAvatar = function StatusAvatar(_ref) {
  var user = _ref.user,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? "icon" : _ref$size;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'agent-status-avatar-wrapper' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'agent-status-avatar' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Avatar"], { size: size, user: user })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'agent-status-indicator' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: resolveStatusIcon(user) })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StatusAvatar);

/***/ }),

/***/ "L9SV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LAZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LCi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("QMlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var WelcomeMessageAvatar = function WelcomeMessageAvatar(_ref) {
  var user = _ref.user,
      backgroundColor = _ref.backgroundColor;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.AvatarWrapper },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], {
      user: user,
      style: { borderColor: '#' + backgroundColor },
      shape: 'circle'
    })
  );
};
WelcomeMessageAvatar.propTypes = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  user: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};

function MenuItem(_ref2) {
  var children = _ref2.children,
      foregroundColor = _ref2.foregroundColor,
      props = _objectWithoutProperties(_ref2, ['children', 'foregroundColor']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, props, { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.MenuItem,
      style: { color: '#' + foregroundColor } }),
    children
  );
}
MenuItem.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};
function Menu(_ref3) {
  var children = _ref3.children,
      foregroundColor = _ref3.foregroundColor,
      props = _objectWithoutProperties(_ref3, ['children', 'foregroundColor']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({ className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Menu }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.MenuItems },
      __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          MenuItem,
          { foregroundColor: foregroundColor },
          child
        );
      })
    )
  );
}
Menu.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};

function WelcomeMessageAvatars(_ref4) {
  var children = _ref4.children;

  return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.AvatarsList },

    /* We render children in reverse order and visually "flip" the ordering back using
    `flex-direction: row-reverse`. This keeps the children in the same order visually,
     but with the stacking contexts reversed, so that the nth child can overlap the
     nth+1 child. */
    __WEBPACK_IMPORTED_MODULE_1_react__["Children"].toArray(children).reverse()
  );
}
WelcomeMessageAvatars.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};

var WelcomeMessageHeader = function (_Component) {
  _inherits(WelcomeMessageHeader, _Component);

  function WelcomeMessageHeader() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, WelcomeMessageHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = WelcomeMessageHeader.__proto__ || Object.getPrototypeOf(WelcomeMessageHeader)).call.apply(_ref5, [this].concat(args))), _this), _this.renderAvatar = function (user) {
      var key = user.id,
          publicProfileUrl = user.publicProfileUrl;
      var backgroundColor = _this.props.backgroundColor;

      var avatarProps = { user: user, backgroundColor: backgroundColor };
      if (publicProfileUrl) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'a',
          { key: key, href: publicProfileUrl, target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WelcomeMessageAvatar, avatarProps)
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WelcomeMessageAvatar, _extends({ key: key }, avatarProps));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WelcomeMessageHeader, [{
    key: 'renderUserAvatars',
    value: function renderUserAvatars() {
      var users = this.props.users;

      if (!users || users.isEmpty()) {
        return null;
      }
      if (users.size === 1 && !Object(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["c" /* userHasAvatar */])(users.first())) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        WelcomeMessageAvatars,
        null,
        users.map(this.renderAvatar)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          foregroundColor = _props.foregroundColor,
          title = _props.title,
          children = _props.children,
          users = _props.users,
          menu = _props.menu;


      var hasUsers = users.size > 0;
      var hasMultipleAvatars = users.size > 1;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Container, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.MultiAvatars, hasMultipleAvatars)),
          style: { backgroundColor: '#' + backgroundColor, color: '#' + foregroundColor }
        },
        (hasUsers || title) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Header },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.HeaderContent },
            this.renderUserAvatars(),
            title && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              {
                className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Title,
                style: { color: '#' + foregroundColor }
              },
              title
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Menu,
            { foregroundColor: foregroundColor },
            menu
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Body },
          children
        )
      );
    }
  }]);

  return WelcomeMessageHeader;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

WelcomeMessageHeader.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  menu: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  users: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  foregroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
WelcomeMessageHeader.defaultProps = {
  users: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()
};


/* unused harmony default export */ var _unused_webpack_default_export = (WelcomeMessageHeader);

/***/ }),

/***/ "LDhr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_socket_constants__ = __webpack_require__("EkEs");






function pushTag(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_3_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_3_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref) {
    var channel = _ref.channel,
        leaveChannel$ = _ref.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function () {
      channel.on('tag-updated', function (payload) {
        __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.TagActions.pushTag(payload);
      });
      channel.on('tag-new', function (payload) {
        __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.TagActions.pushTag(payload);
      });
    }).takeUntil(leaveChannel$);
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(pushTag);

/***/ }),

/***/ "LEIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export fetchStatus */
/* unused harmony export addStatus */
/* unused harmony export removeStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentConversationId; });
/* unused harmony export isLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return participantsLoaded; });
/* unused harmony export participants */
/* unused harmony export participantsOptionsLoaded */
/* unused harmony export userParticipants */
/* unused harmony export participantsOptions */
/* unused harmony export isCurrentUserParticipating */
/* unused harmony export isModalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_selectors__ = __webpack_require__("Bqo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_constants__ = __webpack_require__("aJZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("At/u");









var root = function root(state) {
  return state.get('participants');
};

var fetchStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'fetch']);
});
var addStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'add']);
});
var removeStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'remove']);
});

var currentConversationId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'conversationId']);
});

var isLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fetchStatus, addStatus, removeStatus, function (fetchStatus, addStatus, removeStatus) {
  return addStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["a" /* ADD_PARTICIPANTS */] || addStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* ADD_PARTICIPANTS_PENDING */] || fetchStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["e" /* FETCH_PARTICIPANTS */] || fetchStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["h" /* FETCH_PARTICIPANTS_PENDING */] || removeStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["j" /* REMOVE_PARTICIPANTS */] || removeStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["l" /* REMOVE_PARTICIPANTS_PENDING */];
});

var participantsLoaded = function participantsLoaded(conversationId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fetchStatus, currentConversationId, function (fetchStatus, currentConversationId) {
    return fetchStatus === __WEBPACK_IMPORTED_MODULE_5__constants__["i" /* RECEIVE_PARTICIPANTS */] && conversationId === currentConversationId;
  });
};

var participants = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('data');
});

var participantsOptionsLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(participantsLoaded, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["orgUsersLoaded"], function (participantsLoaded, orgUsersLoaded) {
  return participantsLoaded && orgUsersLoaded;
});

var userParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["unfilteredOrgUsersById"], participants, function (unfilteredOrgUsersById, participants) {
  return participants.toList().map(function (participantId) {
    return unfilteredOrgUsersById.get(participantId);
  }).filter(Boolean).filter(function (participant) {
    return !participant.bot;
  }).sortBy(function (participant) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(participant).toLowerCase();
  });
});

var participantsOptions = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(userParticipants, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentOrgUsers"], function (userParticipants, currentOrgUsers) {
  return currentOrgUsers.filter(function (user) {
    return !userParticipants.map(function (participant) {
      return participant.id;
    }).includes(user.id);
  }).toJS().map(function (user) {
    return { label: Object(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user), value: user.id };
  });
});

var isCurrentUserParticipating = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(participantsLoaded, participants, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"], function (participantsLoaded, participants, currentUser) {
  return participantsLoaded && participants.has(currentUser.id);
});

var isModalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('ui');
});

/***/ }),

/***/ "LESv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LFtc":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 124 114\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Simple-Text\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-528.000000, -441.000000)\"><g id=\"Group-4\" transform=\"translate(528.000000, 441.000000)\" fill=\"#B9D4E2\"><path d=\"M0,0 L50,0 L50,4 L0,4 L0,0 Z M0,110 L30,110 L30,114 L0,114 L0,110 Z M0,20 L124,20 L124,24 L0,24 L0,20 Z M0,30 L114,30 L114,34 L0,34 L0,30 Z M0,40 L124,40 L124,44 L0,44 L0,40 Z M0,50 L114,50 L114,54 L0,54 L0,50 Z M0,60 L124,60 L124,64 L0,64 L0,60 Z M0,70 L114,70 L114,74 L0,74 L0,70 Z M0,80 L124,80 L124,84 L0,84 L0,80 Z M0,90 L114,90 L114,94 L0,94 L0,90 Z\" id=\"Combined-Shape\"></path></g></g></svg>"

/***/ }),

/***/ "LFxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SegmentSelectHelper__ = __webpack_require__("iKCO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CampaignWizards_TargetingInputArea_SegmentSelect__ = __webpack_require__("m1lM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_campaign_NewCampaign_SegmentOptionRow__ = __webpack_require__("dOkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__ = __webpack_require__("Khpy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__ = __webpack_require__("EP6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Constants__ = __webpack_require__("iXXD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("2Fuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














function getRows(segments, segmentsToHide, users, selectedSegmentId) {
  var selected = void 0;
  var rows = segments.reduce(function (result, segment) {
    var row = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_campaign_NewCampaign_SegmentOptionRow__["a" /* default */], { segment: segment, author: users[segment.authorId] });

    if (selectedSegmentId === segment.id) {
      selected = row;
    }

    if (segmentsToHide.contains(segment.id)) {
      return result;
    }

    return result.push(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__["MenuItem"],
      {
        key: segment.id,
        value: segment.id,
        text: segment.name
      },
      row
    ));
  }, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());

  return { rows: rows, selected: selected };
}

function getSelectedAudienceOption(audience) {
  switch (audience) {
    case "VISITORS":
      return __WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__["a" /* AnonymousOption */];
    case "EVERYONE":
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__["b" /* EveryoneOption */], null);
    case "USERS":
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__["c" /* IdentifiedUsersOption */], null);
    default:
      return "Pick an Audience";
  }
}

var SegmentSelect = function (_Component) {
  _inherits(SegmentSelect, _Component);

  function SegmentSelect() {
    _classCallCheck(this, SegmentSelect);

    return _possibleConstructorReturn(this, (SegmentSelect.__proto__ || Object.getPrototypeOf(SegmentSelect)).apply(this, arguments));
  }

  _createClass(SegmentSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          index = _props.index,
          segments = _props.segments,
          audience = _props.audience,
          users = _props.users,
          onSelection = _props.onSelection,
          selectedSegmentId = _props.selectedSegmentId,
          _props$segmentsToHide = _props.segmentsToHide,
          segmentsToHide = _props$segmentsToHide === undefined ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])() : _props$segmentsToHide;


      var nonSegmentOptions = index === 0 ? [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__["b" /* EveryoneOption */], null), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_CampaignWizards_TargetingInputArea_AudienceOption__["c" /* IdentifiedUsersOption */], null)] : null;

      var _getRows = getRows(Object(__WEBPACK_IMPORTED_MODULE_4_utils_SegmentSelectHelper__["a" /* getSegmentSelection */])(selectedSegmentId, segments), segmentsToHide, users, selectedSegmentId),
          rows = _getRows.rows,
          selected = _getRows.selected;

      var selectedOption = selected || getSelectedAudienceOption(audience);

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { key: 'segmentId', className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__style_styl___default.a.SegmentSelect, { "top-select": index === 0 }) },
        this.renderSegmentActions(),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__["Wrapper"],
          {
            className: 'AriaMenuButton AriaMenuButton--large',
            onSelection: onSelection
          },
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__["Button"],
            null,
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'div',
              { className: 'content' },
              selectedOption
            )
          ),
          __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_8_react_aria_menubutton__["Menu"],
            null,
            nonSegmentOptions,
            rows
          )
        )
      );
    }
  }, {
    key: 'renderSegmentActions',
    value: function renderSegmentActions() {
      var _props2 = this.props,
          audience = _props2.audience,
          selectedSegmentId = _props2.selectedSegmentId,
          onClear = _props2.onClear;

      if (audience === __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].SEGMENT.key) {
        if (selectedSegmentId) {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'div',
            { className: 'select-actions' },
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_CampaignWizards_TargetingInputArea_SegmentSelect__["a" /* SegmentPreviewLink */], { segmentId: selectedSegmentId }),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'span',
              { className: 'action-separator' },
              '|'
            ),
            __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
              'a',
              { onClick: onClear },
              'Clear'
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
            'a',
            { className: 'select-actions', onClick: onClear },
            'Clear'
          );
        }
      }
    }
  }]);

  return SegmentSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var MultiSegmentSelect = function (_Component2) {
  _inherits(MultiSegmentSelect, _Component2);

  function MultiSegmentSelect() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, MultiSegmentSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = MultiSegmentSelect.__proto__ || Object.getPrototypeOf(MultiSegmentSelect)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      numberOfSelects: _this2.props.selectedSegments.size || 1
    }, _this2.addSegmentSelect = function () {
      var numberOfSelects = _this2.state.numberOfSelects;

      _this2.setState({ numberOfSelects: numberOfSelects + 1 });
    }, _this2.handleSelection = function (index) {
      return function (value) {
        var onSelection = _this2.props.onSelection;

        var newAudience = _this2.getAudience(value);

        if (newAudience !== __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].SEGMENT.key) {
          _this2.setState({ numberOfSelects: 1 });
        }

        onSelection(newAudience, index, value);
      };
    }, _this2.handleClear = function (index) {
      return function () {
        var onSelection = _this2.props.onSelection;
        var numberOfSelects = _this2.state.numberOfSelects;


        if (numberOfSelects === 1) {
          onSelection(__WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].EVERYONE.key);
        } else {
          onSelection(__WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].SEGMENT.key, index);
          _this2.setState({ numberOfSelects: numberOfSelects - 1 });
        }
      };
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(MultiSegmentSelect, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          segments = _props3.segments,
          audience = _props3.audience,
          users = _props3.users,
          selectedSegments = _props3.selectedSegments,
          className = _props3.className;


      var components = selectedSegments.map(function (selectedSegmentId, index) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(SegmentSelect, {
          index: index,
          audience: audience,
          segments: segments,
          selectedSegmentId: selectedSegmentId,
          segmentsToHide: selectedSegments,
          users: users,
          onSelection: _this3.handleSelection(index),
          onClear: _this3.handleClear(index)
        });
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__style_styl___default.a.MultiSegmentSelect, className) },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'div',
          { className: 'dsg-Label--gray' },
          'Audience'
        ),
        components,
        this.renderExtraSelect(),
        this.renderAddSegment(components.size)
      );
    }
  }, {
    key: 'renderExtraSelect',
    value: function renderExtraSelect() {
      var _props4 = this.props,
          segments = _props4.segments,
          audience = _props4.audience,
          users = _props4.users,
          selectedSegments = _props4.selectedSegments;
      var numberOfSelects = this.state.numberOfSelects;


      if (numberOfSelects > selectedSegments.size) {
        var index = numberOfSelects - 1;
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(SegmentSelect, {
          index: index,
          segments: segments,
          segmentsToHide: selectedSegments,
          audience: audience,
          users: users,
          onSelection: this.handleSelection(index),
          onClear: this.handleClear(index)
        });
      }
    }
  }, {
    key: 'renderAddSegment',
    value: function renderAddSegment() {
      var _props5 = this.props,
          audience = _props5.audience,
          selectedSegments = _props5.selectedSegments;
      var numberOfSelects = this.state.numberOfSelects;


      if (audience === __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].SEGMENT.key && numberOfSelects == selectedSegments.size) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'a',
          { key: 'add-segment',
            className: 'add-segment',
            onClick: this.addSegmentSelect },
          '+ Add another segment'
        );
      }
    }
  }, {
    key: 'getAudience',
    value: function getAudience(value) {
      if (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNumber(value)) {
        return __WEBPACK_IMPORTED_MODULE_9__Constants__["a" /* audienceOptions */].SEGMENT.key;
      }
      return value;
    }
  }]);

  return MultiSegmentSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MultiSegmentSelect);

/***/ }),

/***/ "LImj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAzNyAyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+R3JvdXAgQ29weSArIE92YWwgMjM8L3RpdGxlPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEpIiBzdHJva2U9IiM5QTlBOUEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgZmlsbD0iIzlBOUE5QSI+PHBhdGggZD0iTTIyLjQzIDYuMzI1Yy0uMTY3LTEuMDI1LTEuMDc4LTEuNTItMi4wMTgtMS4xMTJMMi4yMjUgMTMuMDk3Yy0xLjkwMy44MjUtMi42NyAyLjk4Ny0xLjY3MiA0LjgxNiAwIDAgLjA5NC4zNS41NjIuODgyLjM3OC40MyAyMi4zIDQuNTA4IDIyLjMgNC41MDggMS4wMS4xODggMS42OTMtLjQ4MyAxLjUyNS0xLjUxNUwyMi40MyA2LjMyNXoiIHN0cm9rZS13aWR0aD0iLjUyNSIvPjxwYXRoIGQ9Ik0yNy4zOTYgNy42NjNMMzMuODggMi42Yy4yMzMtLjE4My4zNzItLjY1LjMxLTEuMDQ0LS4wNi0uMzkzLS4zLS41NjMtLjUzNC0uMzhsLTYuNDgzIDUuMDZjLS4yMzQuMTg0LS4zNzMuNjUtLjMxMiAxLjA0NS4wNDMuMjY4LjE2Ny40MzMuMzE1LjQ1NC4wNy4wMS4xNDYtLjAxMy4yMi0uMDd6TTM1LjExIDIwLjUxbC02LjM2NS0xLjQ0OGMtLjIyOC0uMDUzLS4zOTIuMjU1LS4zNjMuNjg2LjAzLjQzMi4yNC44MjQuNDcuODc2bDYuMzYzIDEuNDVjLjAzLjAwNS4wNi4wMDYuMDg2IDAgLjE4NC0uMDMuMzA0LS4zMTIuMjc4LS42ODgtLjAzLS40My0uMjQtLjgyMy0uNDctLjg3NXpNMzQuNDU0IDExLjM0NmMtLjA0Mi0uNDQ0LS4yNTUtLjc0LS40NzUtLjY3NWwtNS43MjcgMS44NWMtLjIyLjA3LS4zNjcuNDktLjMyNS45MzIuMDM3LjQwMi4yMTYuNjg4LjQxMy42ODQuMDIyIDAgLjA0Mi0uMDA0LjA2My0uMDFsNS43MjYtMS44NDhjLjIyLS4wNy4zNjUtLjQ5LjMyNC0uOTMyeiIgc3Ryb2tlLXdpZHRoPSIuNjcxIi8+PC9nPjxlbGxpcHNlIHN0cm9rZS13aWR0aD0iMi42ODQiIGN4PSIxMC4yNTgiIGN5PSIyMS43NjciIHJ4PSI0Ljg0NiIgcnk9IjQuMDMzIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "LMde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssistantConfigOrgSettings__ = __webpack_require__("jGIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SFDCValues__ = __webpack_require__("OBXZ");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var AssistantConfigSalesforceActivity = function (_React$Component) {
  _inherits(AssistantConfigSalesforceActivity, _React$Component);

  function AssistantConfigSalesforceActivity(props) {
    _classCallCheck(this, AssistantConfigSalesforceActivity);

    var _this = _possibleConstructorReturn(this, (AssistantConfigSalesforceActivity.__proto__ || Object.getPrototypeOf(AssistantConfigSalesforceActivity)).call(this, props));

    _this.getEventField = function () {
      return _this.state.orgSettings.get('sfEventFields').keySeq().first();
    };

    _this.handleSalesforceEventObjectChange = function (_ref) {
      var value = _ref.value;

      var sfEventField = _this.getEventField();
      if (sfEventField) {
        var newSettings = _this.state.orgSettings.get('sfEventFields').delete(sfEventField);
        _this.setState({
          orgSettings: _this.state.orgSettings.set('sfEventFields', newSettings).set('salesforceEventObject', value)
        });
      } else {
        _this.setState({ orgSettings: _this.state.orgSettings.set('salesforceEventObject', value) });
      }
    };

    _this.handleSalesforceEventFieldChange = function (_ref2) {
      var value = _ref2.value;

      var sfEventField = _this.getEventField();
      if (sfEventField) {
        var newSettings = _this.state.orgSettings.get('sfEventFields').delete(sfEventField);
        _this.setState({
          orgSettings: _this.state.orgSettings.set('sfEventFields', newSettings).setIn(['sfEventFields', value], __WEBPACK_IMPORTED_MODULE_4_immutable__["List"].of(''))
        });
      } else {
        _this.setState({
          orgSettings: _this.state.orgSettings.setIn(['sfEventFields', value], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])())
        });
      }
    };

    _this.removeSalesforceEventField = function () {
      var sfEventField = _this.getEventField();
      if (sfEventField) {
        var newSettings = _this.state.orgSettings.get('sfEventFields').delete(sfEventField);
        _this.setState({ orgSettings: _this.state.orgSettings.set('sfEventFields', newSettings) });
      }
    };

    _this.handleSalesforceEventFieldValueChange = function (value, index, sfEventField) {
      _this.setState({
        orgSettings: _this.state.orgSettings.setIn(['sfEventFields', sfEventField, index], value)
      });
    };

    _this.removeSalesforceEventFieldValue = function (index, sfEventField) {
      var filteredSelectionList = _this.state.orgSettings.getIn(['sfEventFields', sfEventField]).filter(function (v) {
        return v !== '';
      });
      if (filteredSelectionList.size === 1) {
        _this.setState({
          orgSettings: _this.state.orgSettings.deleteIn(['sfEventFields', sfEventField]).setIn(['sfEventFields', sfEventField], __WEBPACK_IMPORTED_MODULE_4_immutable__["List"].of(''))
        });
      } else {
        _this.setState({
          orgSettings: _this.state.orgSettings.deleteIn(['sfEventFields', sfEventField, index])
        });
      }
    };

    _this.getFilteredOrgSettings = function () {
      var sfEventField = _this.getEventField();
      if (sfEventField) {
        var filteredSelectionList = _this.state.orgSettings.getIn(['sfEventFields', sfEventField]).filter(function (v) {
          return v !== '';
        });
        return _this.state.orgSettings.setIn(['sfEventFields', sfEventField], filteredSelectionList);
      } else {
        return _this.state.orgSettings;
      }
    };

    _this.isChanged = function () {
      return !Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["is"])(_this.props.orgSettings, _this.state.orgSettings);
    };

    _this.handleSave = function () {
      _this.props.actions.patchAssistantOrgSettings({
        newSettings: _this.getFilteredOrgSettings().toJS(),
        settingName: 'ACTIVITY'
      });
      if (!_this.props.hasPassedOnboarding) {
        _this.props.actions.patchOrgProperties([{
          operation: 'set',
          property: 'hasCustomizedAssistantSFDCActivity',
          value: true
        }]);
      }
    };

    _this.handleCancel = function () {
      _this.setState({ orgSettings: _this.props.orgSettings });
      if (!_this.props.hasPassedOnboarding) {
        _this.props.actions.patchOrgProperties([{
          operation: 'set',
          property: 'hasCustomizedAssistantSFDCActivity',
          value: true
        }]);
      }
      _this.props.handleEdit(false);
    };

    _this.state = {
      isEditing: false,
      orgSettings: _this.props.orgSettings
    };
    return _this;
  }

  _createClass(AssistantConfigSalesforceActivity, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.orgSettings != this.props.orgSettings) {
        this.setState({ orgSettings: nextProps.orgSettings });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var orgSettings = this.state.orgSettings;
      var _props = this.props,
          salesforceEventSettings = _props.salesforceEventSettings,
          salesforceTaskSettings = _props.salesforceTaskSettings,
          hasPassedOnboarding = _props.hasPassedOnboarding,
          salesforceOutOfSync = _props.salesforceOutOfSync,
          patchAssistantOrgSettingsPending = _props.patchAssistantOrgSettingsPending;


      var sfEventObject = orgSettings.get('salesforceEventObject');
      var sfEventField = this.getEventField();
      var sfEventFieldValues = sfEventField ? orgSettings.getIn(['sfEventFields', sfEventField]) : Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])();
      var filteredSelectionList = sfEventFieldValues.filter(function (v) {
        return v !== '';
      });

      var salesforceEventObjectOptions = {
        multi: false,
        searchable: false,
        autoFocus: false,
        clearable: false,
        placeholder: 'Event object',
        value: sfEventObject,
        options: [{ label: 'Event', value: 'EVENT' }, { label: 'Task', value: 'TASK' }],
        onChange: this.handleSalesforceEventObjectChange
      };

      var salesforceEventFieldOptions = {
        multi: false,
        autoFocus: false,
        clearable: false,
        placeholder: 'SFDC field...',
        value: sfEventField,
        options: sfEventObject === 'EVENT' ? salesforceEventSettings.get('eventFields') : salesforceTaskSettings.get('taskFields'),
        onChange: this.handleSalesforceEventFieldChange
      };

      var currentConfigIsValid = !sfEventField || sfEventField && filteredSelectionList.size > 0;

      var saveEnabled = !hasPassedOnboarding && currentConfigIsValid || salesforceOutOfSync && currentConfigIsValid || hasPassedOnboarding && this.isChanged() && currentConfigIsValid;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'assistant-config-settings-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'What should your team get reminders for?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-settings-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-subheader' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Activity'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Field ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                '(optional)'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              'Value'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'assistant-settings-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Select"], salesforceEventObjectOptions),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'micro-copy' },
                'with'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'assistant-settings-column' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Select"], salesforceEventFieldOptions),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'micro-copy' },
                'is'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SFDCValues__["a" /* default */], {
              orgSettings: orgSettings,
              sfObjectType: sfEventObject,
              sfField: sfEventField,
              sfValueSelections: sfEventFieldValues,
              filteredSelections: filteredSelectionList,
              inputHandler: this.handleSalesforceEventFieldValueChange,
              removeHandler: this.removeSalesforceEventFieldValue,
              removeFieldHandler: this.removeSalesforceEventField
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-settings-cta-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            {
              onClick: this.handleSave,
              disabled: !saveEnabled && !patchAssistantOrgSettingsPending,
              type: 'primary',
              loading: patchAssistantOrgSettingsPending
            },
            'Save'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { onClick: this.handleCancel, type: 'subtle' },
            'Cancel'
          )
        )
      );
    }
  }]);

  return AssistantConfigSalesforceActivity;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var AssistantConfigSalesforceActivityView = function AssistantConfigSalesforceActivityView(props) {
  var sfEventObject = props.orgSettings.get('salesforceEventObject');
  var sfEventField = props.orgSettings.get('sfEventFields').keySeq().first();

  var fieldValues = null;
  if (sfEventObject === 'EVENT' && sfEventField) {
    fieldValues = props.salesforceEventSettings.get('eventFieldValues');
  } else if (sfEventField) {
    fieldValues = props.salesforceTaskSettings.get('taskFieldValues');
  }

  var sfFieldLabel = _.get(fieldValues, [sfEventField, 'fieldLabel'], '');

  var salesforceOutOfSync = sfFieldLabel === '' && !!sfEventField;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AssistantConfigOrgSettings__["a" /* default */], {
    assistantSetting: 'salesforceActivity',
    sfFieldTitle: sfFieldLabel,
    orgSettings: props.orgSettings,
    handleEdit: props.handleEdit,
    hasPassedOnboarding: props.hasPassedOnboarding,
    salesforceOutOfSync: salesforceOutOfSync
  });
};

var LoadingState = function LoadingState() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'SFDC-config-loading-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Loading__["a" /* default */], { color: '#CCCCCC' })
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    salesforceEventSettings: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["q" /* salesforceEventSettings */])(state),
    salesforceTaskSettings: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["s" /* salesforceTaskSettings */])(state),
    fetchSalesforceSettingsSuccess: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["i" /* fetchSalesforceSettingsSuccess */])(state),
    patchAssistantOrgSettingsPending: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["m" /* patchAssistantOrgSettingsPending */])(state),
    patchAssistantOrgSettingsSuccess: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["n" /* patchAssistantOrgSettingsSuccess */])(state),
    patchAssistantOrgSettingsFailed: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_assistantSettings_selectors__["l" /* patchAssistantOrgSettingsFailed */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      patchAssistantOrgSettings: __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__["H" /* patchAssistantOrgSettings */],
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__["patchOrgProperties"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.orgSettings || !props.fetchSalesforceSettingsSuccess;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(LoadingState)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.isEditing;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(AssistantConfigSalesforceActivityView)))(AssistantConfigSalesforceActivity));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "LMzq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LQB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Integration_ListConstants__ = __webpack_require__("QBUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





function verifyGate(integrationId) {
  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1__components_Integration_ListConstants__["c" /* Integrations */].length; i++) {
    if (integrationId === __WEBPACK_IMPORTED_MODULE_1__components_Integration_ListConstants__["c" /* Integrations */][i].id) {
      return !__WEBPACK_IMPORTED_MODULE_1__components_Integration_ListConstants__["c" /* Integrations */][i].requiredGates || __WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].hasGates(__WEBPACK_IMPORTED_MODULE_1__components_Integration_ListConstants__["c" /* Integrations */][i].requiredGates);
    }
  }
  return true;
}

var AuthHOC = {
  applyGateChecker: function applyGateChecker(WrappedComponent, integrationId) {
    return function (_Component) {
      _inherits(_class, _Component);

      function _class(props) {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
      }

      _createClass(_class, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!verifyGate(integrationId)) {
            window.location.replace('/settings2/integrations');
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
        }
      }]);

      return _class;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  },

  applyGateCheckerThroughProps: function applyGateCheckerThroughProps(WrappedComponent) {
    return function (_Component2) {
      _inherits(_class2, _Component2);

      function _class2(props) {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));
      }

      _createClass(_class2, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!verifyGate(this.props.params.integrationId)) {
            window.location.replace('/settings2/integrations');
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
        }
      }]);

      return _class2;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  },

  applyAdminChecker: function applyAdminChecker(WrappedComponent) {
    return function (_Component3) {
      _inherits(_class3, _Component3);

      function _class3(props) {
        _classCallCheck(this, _class3);

        return _possibleConstructorReturn(this, (_class3.__proto__ || Object.getPrototypeOf(_class3)).call(this, props));
      }

      _createClass(_class3, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (!__WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].isAdmin()) {
            window.location.replace('/settings2/profile');
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, this.props);
        }
      }]);

      return _class3;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthHOC);

/***/ }),

/***/ "LSvj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toHumanizedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toMilliseconds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultUnit; });
var MINUTE = 60 * 1000;
var HOUR = 60 * MINUTE;

var toHumanizedValue = function toHumanizedValue(milliseconds, unit) {
  return milliseconds / (unit === 'hour' ? HOUR : MINUTE);
};

var toMilliseconds = function toMilliseconds(humanizedValue, unit) {
  return humanizedValue * (unit === 'hour' ? HOUR : MINUTE);
};

var defaultUnit = function defaultUnit(milliseconds) {
  return _.isInteger(milliseconds / HOUR) ? 'hour' : 'minute';
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "LW3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PickOauthComponent__ = __webpack_require__("puRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectCalendarComponent__ = __webpack_require__("gk5T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__ = __webpack_require__("KP0q");












function makeMapStateToProps() {
  return function (state) {
    return {
      calendar: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["b" /* getCalendar */])(state),
      getCalendarStatusLoaded: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["c" /* getCalendarStatusLoaded */])(state),
      hasCalendars: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["e" /* getCalendars */])(state).size > 0,
      googleAuthed: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["g" /* getIsGoogleOauthConnected */])(state),
      microsoftAuthed: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["i" /* getIsMicrosoftOauthConnected */])(state),
      isTokenRevoked: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["j" /* getIsTokenRevoked */])(state),
      isGoogleOrMicrosoftConnected: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["w" /* isGoogleOrMicrosoftConnected */])(state)
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["r" /* fetchCalendarStatus */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchCalendarStatus();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var nextPropsHasCalendar = !!(nextProps.calendar && nextProps.calendar.id);
    if (!this.props.calendar.equals(nextProps.calendar) && nextPropsHasCalendar) {
      nextProps.router.replace('/settings/calendar');
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  handleSaveRedirect: function handleSaveRedirect(props) {
    return function () {
      props.router.replace('/settings/calendar');
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref) {
  var googleAuthed = _ref.googleAuthed,
      microsoftAuthed = _ref.microsoftAuthed,
      hasCalendars = _ref.hasCalendars;
  return {
    connected: (googleAuthed || microsoftAuthed) && hasCalendars
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["k" /* withStateHandlers */])(function () {
  return { googlePermissionError: false };
}, {
  setGooglePermissionErrorState: function setGooglePermissionErrorState() {
    return function (status) {
      return { googlePermissionError: status };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref2) {
  var getCalendarStatusLoaded = _ref2.getCalendarStatusLoaded;
  return !getCalendarStatusLoaded;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"])), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref3) {
  var connected = _ref3.connected;
  return connected;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_5__SelectCalendarComponent__["a" /* default */])))(__WEBPACK_IMPORTED_MODULE_4__PickOauthComponent__["a" /* default */]));

/***/ }),

/***/ "LYJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_api__ = __webpack_require__("jYTI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("KMoa");














var mapStateToProps = function mapStateToProps(state) {
  return {
    disableSalesSequenceModalVisible: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["O" /* getDisableSalesSequenceModalVisible */](state),
    draft: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["n" /* draft */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      hideDisableSalesSequenceModal: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_80" /* hideDisableSalesSequenceModal */],
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_151" /* setDraftStatus */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onCloseClick: function onCloseClick(_ref) {
    var hideDisableSalesSequenceModal = _ref.actions.hideDisableSalesSequenceModal;
    return function () {
      hideDisableSalesSequenceModal();
    };
  },
  onDisableClick: function onDisableClick(_ref2) {
    var _ref2$actions = _ref2.actions,
        hideDisableSalesSequenceModal = _ref2$actions.hideDisableSalesSequenceModal,
        setDraftStatus = _ref2$actions.setDraftStatus,
        draft = _ref2.draft;
    return function () {
      // Send (bulk) unenrollment request to the backend and update the playbook status and disable playbook.
      // If the request errors out, do not set the draft status to DISABLED.
      try {
        __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_api__["a" /* api */].disableSalesSequenceById(draft.id);
        setDraftStatus({ status: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED });
      } catch (err) {
        Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(err);
      }

      hideDisableSalesSequenceModal();
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),

/***/ "LYdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__ = __webpack_require__("W8CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__ = __webpack_require__("/POY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* eslint-disable
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var OrgPropertiesQueries = Marty.createQueries({
  id: 'OrgPropertiesQueries',

  fetchProperties: function fetchProperties(orgId) {
    var _this = this;

    var promise = this.app.sources.OrgPropertiesAPI.fetchProperties(orgId);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].FETCH_ORG_PROPERTIES_DONE, orgId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].FETCH_ORG_PROPERTIES_FAILED, res);
      }
    });
    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].FETCH_ORG_PROPERTIES_FAILED, error);
    });
  },
  updateProperties: function updateProperties(orgId, properties, notificationMessage) {
    var _this2 = this;

    var promise = this.app.sources.OrgPropertiesAPI.updateProperties(orgId, properties);
    promise.then(function (res) {
      if (res.status === 200) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPDATE_ORG_PROPERTIES_DONE, orgId, res.body, properties);
        if (notificationMessage) {
          return _this2.app.actions.NotificationActions.pushNotification({
            content: notificationMessage
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPDATE_ORG_PROPERTIES_FAILED, orgId, properties, res);
      }
    });
    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPDATE_ORG_PROPERTIES_FAILED, orgId, properties, error);
    });
  },
  uploadOrgLogo: function uploadOrgLogo(orgId, file, fileId, updateOrg) {
    var _this3 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_STARTING, orgId, file, fileId);
    var orgLogoUploadPromise = this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file);
    orgLogoUploadPromise.then(function (res) {
      if (res.status === 200) {
        var logoUrl = res.body.attachmentUrl;
        var update = { theme: { logoUrl: logoUrl } };
        var operations = Object(__WEBPACK_IMPORTED_MODULE_3_utils_PatchHelper__["a" /* patchOperations */])(update, {});
        var promise = _this3.app.sources.DefaultEmbedAPI.patchDefaultEmbed(operations);
        return promise.then(function (res) {
          if (res.status === 200) {
            _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_DONE, res.body);
            _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_DONE, orgId, logoUrl, fileId);
            return _this3.app.actions.NotificationActions.pushNotification({
              content: 'Your organization logo has been updated'
            });
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
            _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_FAILED, operations, res);
            throw new Error('Failed to update logo url');
          }
        });
      } else {
        throw new Error('Failed to update logo url', res);
      }
    });
    return orgLogoUploadPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_FAILED, orgId, error, fileId);
    });
  },


  /**
   * uploadOrgImage
   * Uploads an image associated with an organization.
   * @param { number } orgId - the organization's ID
   * @param { File } file - File to upload
   * @param { String } imageType - String to identify this org image type (e.g. welcome-image)
   */
  uploadOrgImage: function uploadOrgImage(orgId, file, imageType) {
    var _this4 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_STARTING, orgId, file, imageType);
    var orgLogoUploadPromise = this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file);
    orgLogoUploadPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_FAILED, orgId, error, imageType);
    });
    return orgLogoUploadPromise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_DONE, orgId, res.body.attachmentUrl, imageType);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_FAILED, orgId, error, imageType);
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgPropertiesQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "Lb/h":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 30 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M29.675 8.58l-4.95 7c-.168.238-.433.39-.724.416l-.085.004c-.26 0-.514-.103-.7-.29l-3.017-3c-.39-.388-.394-1.02-.007-1.414.387-.392 1.018-.396 1.41-.006l2.182 2.17 4.27-6.04c.32-.45.94-.554 1.388-.236.448.32.554.945.235 1.395zM13.753 13.4c4.08 1.17 7.145 4.786 7.145 8.934V23c0 .552-.445 1-.995 1H1.98c-.55 0-.995-.448-.995-1v-.666c0-4.148 3.067-7.764 7.146-8.934C5.686 12.312 3.973 9.855 3.973 7c0-3.86 3.127-7 6.97-7s6.97 3.14 6.97 7c0 2.855-1.713 5.312-4.16 6.4zM2.985 22h15.913c-.196-3.827-3.76-7-7.956-7-4.196 0-7.76 3.173-7.957 7zm7.957-20C8.197 2 5.964 4.243 5.964 7s2.233 5 4.978 5c2.745 0 4.978-2.243 4.978-5s-2.233-5-4.978-5z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "LbGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullStorySettings; });
/**
 * Originally this was intended to record ONLY sessions that were relevant by putting
 * configuration at the gate level. record_playboks, could indicate Fullstory only run
 * on a subset of pages related to playbooks
 *
 * Due to shortcomings in the fullstory API (and their biz model based on recorded sessions),
 * so they discourage reducing # of sessions recorded, I've abandoned that idea in favor of having
 * a single gate `record_sessions` that injects fullstory selectively. We end up with more sessions
 * recorded, but we avoid the noisey firehose of sessions that we'd have if it was enabled for all.
 */
var FullStorySettings = {
  debug: true,
  host: 'fullstory.com',
  orgKey: '13D52'
};

var shouldRecordSession = function shouldRecordSession(gates) {
  var recordingTargets = gates.filter(function (value, key) {
    return key.includes('record_sessions') && value;
  });
  return recordingTargets.size > 0;
};

/* harmony default export */ __webpack_exports__["b"] = (shouldRecordSession);

/***/ }),

/***/ "Ldfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("tUpl");




var api = {
  fetch: function fetch(orgId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/organizations/' + orgId + '/end_users/attributes2').checkStatus().retryWithBackoff().mapResponse(function (_ref) {
      var events = _ref.events,
          properties = _ref.properties;
      return {
        events: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(events).map(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Event */]),
        properties: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])(properties).map(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* Property */])
      };
    });
  }
};

/***/ }),

/***/ "Lftg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch, _) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchTokenForDriftt; });
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchOauthCode;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchOAuthAppInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__ = __webpack_require__("GoMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Helpers__ = __webpack_require__("nJx7");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





var fetchTokenForDriftt = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(driftt_token) {
    var request;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/oauth/token', {
              method: 'POST',
              headers: {
                'Content-Type': __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__["b" /* X_WWW_FORM */]
              },
              body: Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["h" /* serializeObject */])({
                driftt_token: driftt_token,
                grant_type: 'driftt',
                client_id: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["f" /* CLIENT_ID */],
                redirect_uri: 'http://localhost:3000/'
              })
            });
            return _context.abrupt('return', request);

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchTokenForDriftt(_x) {
    return _ref.apply(this, arguments);
  };
}();

function fetchOauthCode(_ref2) {
  var redirect_uri = _ref2.redirect_uri,
      client_id = _ref2.client_id;

  var request = fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/oauth/auth', {
    method: 'POST',
    headers: _.extend({ 'Content-Type': __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__["b" /* X_WWW_FORM */] }, Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["f" /* getAuthorizationHeader */])()),
    body: Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["h" /* serializeObject */])({
      response_type: 'code',
      client_id: client_id,
      access_type: 'offline',
      redirect_uri: redirect_uri
    })
  });
  return request;
}

function fetchOAuthAppInfo(client_id) {
  var request = fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/oauth/applications?clientId=' + client_id, {
    method: 'GET',
    headers: Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["f" /* getAuthorizationHeader */])()
  });
  return request;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V"), __webpack_require__("M4fF")))

/***/ }),

/***/ "LhIC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LhMo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lhx5":
/***/ (function(module, exports) {

module.exports = "<svg width=\"938px\" height=\"1287px\" viewBox=\"0 0 938 1287\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group</title><desc>Created with Sketch.</desc><defs><rect id=\"path-1\" x=\"0\" y=\"0\" width=\"1048\" height=\"1369\"></rect><linearGradient x1=\"73.0174165%\" y1=\"0%\" x2=\"73.0174184%\" y2=\"100%\" id=\"linearGradient-3\"><stop stop-color=\"#5A5A5A\" offset=\"0%\"></stop><stop stop-color=\"#161616\" offset=\"100%\"></stop></linearGradient><rect id=\"path-4\" x=\"289.114458\" y=\"88.1299644\" width=\"1819.75756\" height=\"1094.00346\" rx=\"10\"></rect><path d=\"M1416.41706,84.5506073 L2108.87202,84.5506073 L2108.87202,1205.76518 L1428.43871,1205.76518 C1428.43871,1205.76518 1416.41706,1210.96527 1416.41706,1205.76518 L1416.41706,84.5506073 Z\" id=\"path-6\"></path><mask id=\"mask-7\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"692.454955\" height=\"1123.52573\" fill=\"white\"><use xlink:href=\"#path-6\"></use></mask><pattern id=\"pattern-8\" width=\"48\" height=\"48\" x=\"1368.41706\" y=\"36.5506073\" patternUnits=\"userSpaceOnUse\"><use xlink:href=\"#image-9\"></use></pattern><image id=\"image-9\" width=\"48\" height=\"48\" xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAV9JREFUaAXt2O0NgjAQBmBrt4DoDiawEHEQB1F3MK7BHKxR+2oKQfnseXCX0B/SEr3zucZIz+R57nZ+OOfuZVmeMcWaOEyWZVdjTBHicMW3aZpekMQnOyVJcqiq6hmSUq6Ig3iIyxnf+iRH7iSc8e1SleJCWGyvZsQboBlRA7QiWgCNiB+ANkQnQBOiF6AFMQjQgBgFSEdMAkhGTAZIRcwCSETMBkhDRAEkIaIBUhAkgAQEGbA2AgCDL0Edax2KrO8e3JCcCsDn10CgK/HQ2I0IZ+w9KucXBfo4mGJNHA79JfSBQhzO+FtfKFS567rEb2LrC3VV/vse507Uf2ScSQDiil8DOJOEHeFAtAAaET8AbYhOgCZEL0ALYhCgATEKkI6YBJCMmAyQipgFkIiYDZCGiAJIQkQDpCBIAAkIMmBtBAD/OMizPe+jQBh9j+JbX+hTn+a1r1K437wrfvYd/wV+UgblD/bGFgAAAABJRU5ErkJggg==\"></image><linearGradient x1=\"100%\" y1=\"59.0212107%\" x2=\"0%\" y2=\"59.0212107%\" id=\"linearGradient-10\"><stop stop-color=\"#000000\" offset=\"0%\"></stop><stop stop-color=\"#FFFFFF\" stop-opacity=\"0.5\" offset=\"49.648972%\"></stop><stop stop-color=\"#000000\" offset=\"100%\"></stop></linearGradient><rect id=\"path-11\" x=\"0.569390165\" y=\"1218.09861\" width=\"2404.54223\" height=\"7.74250494\"></rect><filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-12\"><feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset><feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite><feColorMatrix values=\"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.300000012 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix></filter><rect id=\"path-13\" x=\"0.713101161\" y=\"0.945502175\" width=\"669\" height=\"773.049988\"></rect><mask id=\"mask-14\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"669\" height=\"773.049988\" fill=\"white\"><use xlink:href=\"#path-13\"></use></mask></defs><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Step-4---Slack-Connect\" transform=\"translate(-1613.000000, -455.000000)\"><g id=\"Group\" transform=\"translate(1613.000000, 407.000000)\"><mask id=\"mask-2\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><g id=\"Mask\"></g><g mask=\"url(#mask-2)\" id=\"macbook\"><g transform=\"translate(-1424.616283, 48.975709)\"><g><path d=\"M2112.71929,0 C2150.35568,0 2181.9701,31.8290414 2181.9701,69.6825445 L2181.9701,1171.64358 C2181.9701,1188.86992 2181.77246,1205.72521 2178.11623,1218.02429 L1407.61623,1218.02429 L258.336317,1241.32612 C219.609788,1241.32612 216.016374,1209.49708 216.016374,1171.64358 L216.016374,69.6825445 C216.016374,31.8290414 247.630793,0 285.26719,0 L2112.71929,0 Z\" id=\"top\" fill=\"url(#linearGradient-3)\" opacity=\"0.4\"></path><ellipse id=\"Oval-20\" fill=\"#000000\" opacity=\"0.119999997\" cx=\"1198.99324\" cy=\"1273.19805\" rx=\"1039.27919\" ry=\"12.5225998\"></ellipse><mask id=\"mask-5\" fill=\"white\"><use xlink:href=\"#path-4\"></use></mask><use id=\"screen\" stroke=\"#EEEEEE\" stroke-width=\"4\" fill=\"#FFFFFF\" xlink:href=\"#path-4\"></use><g id=\"Rectangle-231\" opacity=\"0.2\" mask=\"url(#mask-5)\" stroke-width=\"2\" stroke=\"#979797\" fill=\"url(#pattern-8)\"><use mask=\"url(#mask-7)\" xlink:href=\"#path-6\"></use></g><path d=\"M2123.35484,1225.84111 L2405.11162,1225.84111 C2405.11162,1225.84111 2325.71355,1265.23551 2128.10836,1263.00514 C2127.23349,1265.23551 1462.53107,1272.29614 1204.76414,1272.29614 C943.149945,1272.29614 278.447523,1265.23551 277.572655,1263.00514 C79.9674643,1265.23551 0.569390165,1225.84111 0.569390165,1225.84111 L2123.35484,1225.84111 Z\" id=\"bottom\" fill=\"#1A1A1A\" opacity=\"0.4\"></path><g id=\"bottomfront\" opacity=\"0.4\"><use fill=\"#7C7C7C\" fill-rule=\"evenodd\" xlink:href=\"#path-11\"></use><use fill-opacity=\"0.02\" fill=\"url(#linearGradient-10)\" fill-rule=\"evenodd\" style=\"mix-blend-mode: multiply;\" xlink:href=\"#path-11\"></use><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-12)\" xlink:href=\"#path-11\"></use></g></g></g></g><g id=\"Group-2\" mask=\"url(#mask-2)\"><g transform=\"translate(-4.000000, 254.000000)\"><use id=\"Rectangle-2\" stroke=\"#E1EEF4\" mask=\"url(#mask-14)\" stroke-width=\"30\" fill=\"#FFFFFF\" xlink:href=\"#path-13\"></use><rect id=\"Rectangle\" stroke=\"none\" fill=\"#F2F6F8\" x=\"2\" y=\"53\" width=\"38\" height=\"706\"></rect><rect id=\"Rectangle-5\" stroke=\"none\" fill=\"#FFFFFF\" x=\"406\" y=\"172\" width=\"124\" height=\"33\"></rect><g id=\"Input\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" transform=\"translate(56.000000, 699.000000)\"><rect id=\"Rectangle-4\" fill=\"#F2F6F8\" x=\"0\" y=\"0\" width=\"586\" height=\"45\" rx=\"6\"></rect><g id=\"smilie\" transform=\"translate(548.000000, 11.000000)\" fill=\"#B5D2E1\"><path d=\"M12.5,25 C5.60729167,25 0,19.3927083 0,12.5 C0,5.60729167 5.60729167,0 12.5,0 C19.3927083,0 25,5.60729167 25,12.5 C25,19.3927083 19.3927083,25 12.5,25 L12.5,25 Z M12.5,2.08333333 C6.75625,2.08333333 2.08333333,6.75625 2.08333333,12.5 C2.08333333,18.24375 6.75625,22.9166667 12.5,22.9166667 C18.24375,22.9166667 22.9166667,18.24375 22.9166667,12.5 C22.9166667,6.75625 18.24375,2.08333333 12.5,2.08333333 L12.5,2.08333333 Z M12.5,20.8333333 C9.465625,20.8333333 6.71041667,19.009375 5.31041667,16.0739583 C5.06145833,15.5541667 5.28229167,14.9322917 5.80104167,14.6854167 C6.31770833,14.4354167 6.94270833,14.65625 7.18958333,15.1770833 C8.24166667,17.3802083 10.2760417,18.75 12.5,18.75 C14.7364583,18.75 16.7708333,17.3822917 17.8083333,15.1802083 C18.0520833,14.6604167 18.6729167,14.4354167 19.1947917,14.6822917 C19.7145833,14.928125 19.9375,15.5489583 19.6916667,16.0697917 C18.3072917,19.0072917 15.5510417,20.8333333 12.5,20.8333333 L12.5,20.8333333 Z M16.6666667,12.5 C15.51875,12.5 14.5833333,11.565625 14.5833333,10.4166667 C14.5833333,9.26770833 15.51875,8.33333333 16.6666667,8.33333333 C17.815625,8.33333333 18.75,9.26770833 18.75,10.4166667 C18.75,11.565625 17.815625,12.5 16.6666667,12.5 L16.6666667,12.5 Z M8.33333333,12.5 C7.18541667,12.5 6.25,11.565625 6.25,10.4166667 C6.25,9.26770833 7.18541667,8.33333333 8.33333333,8.33333333 C9.48229167,8.33333333 10.4166667,9.26770833 10.4166667,10.4166667 C10.4166667,11.565625 9.48229167,12.5 8.33333333,12.5 L8.33333333,12.5 Z\" id=\"Shape\"></path></g><g id=\"plus\" transform=\"translate(12.000000, 11.000000)\" fill=\"#B5D2E1\"><path d=\"M10,20.5 C10,21.3284271 10.6715729,22 11.5,22 C12.3284271,22 13,21.3284271 13,20.5 L13,1.5 C13,0.671572875 12.3284271,0 11.5,0 C10.6715729,0 10,0.671572875 10,1.5 L10,20.5 Z\" id=\"Path-2\"></path><path d=\"M10,20.5 C10,21.3284271 10.6715729,22 11.5,22 C12.3284271,22 13,21.3284271 13,20.5 L13,1.5 C13,0.671572875 12.3284271,0 11.5,0 C10.6715729,0 10,0.671572875 10,1.5 L10,20.5 Z\" id=\"Path-2\" transform=\"translate(11.500000, 11.000000) rotate(90.000000) translate(-11.500000, -11.000000) \"></path></g></g><rect id=\"Rectangle-3\" stroke=\"none\" fill=\"#E1EEF4\" x=\"2\" y=\"5\" width=\"659\" height=\"54.1701309\"></rect></g></g></g></g></g></svg>"

/***/ }),

/***/ "Li5j":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE3IiBoZWlnaHQ9IjkyIiB2aWV3Qm94PSIwIDAgMTE3IDkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjx0aXRsZT5SZWN0YW5nbGUgNjQgKyBSZWN0YW5nbGUgNjQgQ29weSArIFJlY3RhbmdsZSA2NCBDb3B5IDI8L3RpdGxlPjxnIHN0cm9rZT0iI0NDQyIgc3Ryb2tlLXdpZHRoPSI0IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yIDUxaDI2LjA0djM4LjU5Mkgyek00NCAyaDI2LjA0djg3LjA1Nkg0NHpNODggMzRoMjYuMDR2NTQuNzQ2SDg4eiIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ "Ljxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPES; });
/* unused harmony export TypesByServerType */
/* unused harmony export MESSAGE_TYPE */
/* unused harmony export FREQUENCY */
/* unused harmony export DELIVERY_TIMEFRAME */
/* unused harmony export EMAIL_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


/*
 * A table of "Web App" campaign types.
 * The order of which these types is declared is used for the
 * New Campaign Type menu
*/
var TYPES = {
  chat: {
    displayName: 'Enable Live Chat',
    iconSrc: __webpack_require__("lDPC"),
    serverType: 'CHAT',
    path: '/campaigns/new/chat',
    key: 'chat',
    description: 'Use this to enable live chat for specific segments of users.'
  },

  email_capture: {
    displayName: 'Email Capture',
    iconSrc: __webpack_require__("W8VV"),
    svgIconSrc: __webpack_require__("JYZ/"),
    serverType: 'EMAIL_CAPTURE',
    path: '/wizard/email-capture',
    key: 'email_capture'
  },

  bot: {
    displayName: 'Bot',
    iconSrc: __webpack_require__("kXoj"),
    svgIconSrc: __webpack_require__("ZXW5"),
    serverType: 'BOT'
  },

  announcement: {
    displayName: 'Announcement',
    iconSrc: __webpack_require__("Gx+F"),
    svgIconSrc: __webpack_require__("oMU9"),
    grayIconSrc: __webpack_require__("LImj"),
    serverType: 'ANNOUNCEMENT_ONE_TIME',
    path: '/wizard/message',
    key: 'announcement',
    description: 'Use this to send an in-app message to many users at once.'
  },

  nps: {
    displayName: 'NPS Survey',
    iconSrc: __webpack_require__("t9ih"),
    svgIconSrc: __webpack_require__("NP6h"),
    grayIconSrc: __webpack_require__("kPt/"),
    serverType: 'NPS_ONE_TIME',
    path: '/wizard/nps',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },

  nps_recurring: {
    displayName: 'NPS Survey',
    iconSrc: __webpack_require__("t9ih"),
    grayIconSrc: __webpack_require__("kPt/"),
    serverType: 'NPS_RECURRING',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },
  feedback: {
    displayName: 'Leave Feedback',
    iconSrc: __webpack_require__("nPT9"),
    key: 'feedback',
    comingSoon: true,
    description: 'Use this to get quick feedback from your customers through an in-app message.'
  },
  survey: {
    displayName: 'Survey',
    iconSrc: __webpack_require__("RNq+"),
    key: 'survey',
    comingSoon: true,
    description: 'Learn more from your users with robust questionnaires.'
  },
  banner: {
    displayName: 'Top Banner',
    iconSrc: __webpack_require__("xBok"),
    key: 'banner',
    comingSoon: true,
    description: 'Have something important to say? Use this to broadcast an announcement to your users.'
  },
  takeover: {
    displayName: 'Takeover',
    iconSrc: __webpack_require__("De6q"),
    key: 'nps',
    comingSoon: true,
    description: 'This full-screen campaign is useful for sharing important messages with your customers.'
  },
  rate: {
    displayName: 'Rate Support',
    iconSrc: __webpack_require__("Li5j"),
    svgIconSrc: __webpack_require__("Eaba"),
    key: 'rate',
    comingSoon: true,
    description: 'How satisfied are your users after interacting with customer support? Use this to find out!'
  }
};



var TypesByServerType = _.keyBy(TYPES, 'serverType');

// `messageType` attribute
var MESSAGE_TYPE = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['CHAT', // "web app" campaigns
'EMAIL' // email campaigns
]);

// `periodLength` attribute
var FREQUENCY = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['MONTHLY', // sent every month
'QUARTERLY' // sent every quarter
]);

// `delivery` attribute
var DELIVERY_TIMEFRAME = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['NOW', // delivered now. when making API calls, use ONLY FOR EMAILS, not chats
'UNTIL', // delivered until some end date
'FOREVER' // delivered forever (no end date)
]);

var EMAIL_TYPES = {
  announcement: {
    displayName: 'Announcement',
    iconSrc: __webpack_require__("csxS"),
    grayIconSrc: __webpack_require__("LImj"),
    serverType: 'ANNOUNCEMENT_ONE_TIME',
    path: '/campaigns/new/email-announcement',
    key: 'announcement',
    description: 'Use this to send an email message to many users at once.'
  },
  nps: {
    displayName: 'NPS Survey',
    iconSrc: __webpack_require__("t9ih"),
    grayIconSrc: __webpack_require__("kPt/"),
    serverType: 'NPS_ONE_TIME',
    path: '/campaigns/new/email-nps',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },

  nps_recurring: {
    displayName: 'NPS Survey',
    iconSrc: __webpack_require__("t9ih"),
    grayIconSrc: __webpack_require__("kPt/"),
    serverType: 'NPS_RECURRING',
    key: 'nps',
    description: 'Send this to your users to measure how they feel about your product.'
  },
  survey: {
    displayName: 'Survey',
    iconSrc: __webpack_require__("RNq+"),
    key: 'survey',
    comingSoon: true,
    description: 'Learn more from your users with robust questionnaires.'
  },
  rate: {
    displayName: 'Rate Support',
    iconSrc: __webpack_require__("Li5j"),
    key: 'rate',
    comingSoon: true,
    description: 'How satisfied are your users  after interacting with customer support? Use this to find out!'
  }
};

var STATUS = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a({
  QUEUED: {},
  SENT: {},
  RUNNING: {},
  NOT_RUNNING: {},
  ARCHIVED: {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Lkyf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StepContainer":"StepContainer---OX3Fc","StepContent":"StepContent---21K-4","FileIcon":"FileIcon---2TChG","RefreshIcon":"RefreshIcon---2TT46","ChatIcon":"ChatIcon---1Kkax"};

/***/ }),

/***/ "LqW9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"Sidebar---mC82D"};

/***/ }),

/***/ "Lrv4":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 30C6.73 30 0 23.272 0 15 0 6.73 6.73 0 15 0s15 6.73 15 15c0 8.272-6.73 15-15 15zm.938-28.078V3.75c0 .518-.42.938-.938.938s-.938-.42-.938-.938V1.922c-6.488.462-11.68 5.653-12.14 12.14h1.83c.517 0 .937.42.937.938s-.42.938-.938.938h-1.83c.46 6.487 5.652 11.677 12.14 12.14V26.25c0-.517.42-.938.938-.938s.938.42.938.938v1.827c6.488-.462 11.68-5.652 12.142-12.14h-1.83c-.517 0-.938-.42-.938-.937 0-.518.42-.938.938-.938h1.83c-.462-6.487-5.654-11.678-12.142-12.14zm3.75 19.633h-9.375c-1.035 0-1.876-.84-1.876-1.875v-.938c0-.046.02-.088.028-.133.01-.068.015-.135.04-.197.02-.058.055-.105.087-.155.032-.052.058-.104.1-.15.046-.047.1-.08.154-.118.04-.028.07-.066.113-.087l2.81-1.395c-.522-1.075-.528-2.116-.516-2.42 0-.008-.004-.012-.004-.02l.002-2.81c0-.03.013-.052.016-.08.003-.03-.008-.062 0-.095.01-.062.04-.116.055-.177l.006-.02c.417-1.508 2.18-2.44 3.67-2.44h.006c1.487 0 3.247.93 3.665 2.44l.008.02c.016.06.044.116.055.178.007.032-.004.063 0 .095.002.026.015.05.015.077l.002 2.812c0 .006-.004.01-.004.017.012.305.007 1.34-.512 2.412l2.81 1.404c.044.022.072.06.112.087.053.038.107.072.152.12.043.046.07.1.103.152.032.05.065.095.086.15.024.065.03.133.04.202.007.044.026.084.026.128v.938c0 1.034-.84 1.875-1.875 1.875zm0-2.233l-3.11-1.555c-.04-.014-.078-.04-.117-.06h-.004l-.003-.002c-.066-.035-.134-.064-.193-.115-.03-.026-.044-.063-.07-.09-.022-.025-.04-.05-.058-.077-.05-.07-.094-.138-.123-.217-.018-.043-.026-.086-.036-.13-.014-.067-.026-.13-.026-.197 0-.066.01-.128.024-.192.01-.05.02-.097.04-.144.01-.032.01-.065.025-.096.026-.052.07-.088.103-.133.01-.015.015-.033.027-.048.78-.898.706-2.113.705-2.125 0-.018.008-.034.007-.052 0-.007-.005-.012-.005-.02l-.002-2.673c-.126-.494-.987-1.077-1.873-1.077-.885 0-1.747.585-1.873 1.078l-.002 2.672c0 .007-.004.012-.004.02 0 .018.01.033.008.052-.003.034-.07 1.234.706 2.125.027.03.036.07.06.104.02.034.054.06.073.096.01.02.008.043.017.065.025.062.038.123.05.186.01.058.02.113.02.17 0 .06-.01.118-.023.177-.01.06-.022.116-.044.17-.023.055-.054.102-.086.152-.035.054-.07.105-.118.152-.016.016-.022.037-.04.052-.036.03-.08.044-.117.07-.03.017-.05.047-.082.063l-3.23 1.602v.355h9.374v-.358z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Lv5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__ = __webpack_require__("Lrv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__ = __webpack_require__("xoR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("AdSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var LeandataFilter = function (_Component) {
  _inherits(LeandataFilter, _Component);

  function LeandataFilter(props) {
    _classCallCheck(this, LeandataFilter);

    var _this = _possibleConstructorReturn(this, (LeandataFilter.__proto__ || Object.getPrototypeOf(LeandataFilter)).call(this, props));

    _this.props.setPageValidity(true);
    _this.props.updateAction(_extends({}, __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_models__["t" /* leandataAction */]));
    return _this;
  }

  _createClass(LeandataFilter, [{
    key: 'renderCopySection',
    value: function renderCopySection() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default.a }),
          'When a site visitor chats in to Drift, we\u2019ll check LeanData to find the right rep to connect them with. If a rep is found, we\u2019ll route the conversation to that person.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default.a }),
          'If we can\u2019t find a Drift teammate to connect the site visitor with, we\u2019ll carry on with your other Routing Rules.'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-targeted-accounts-filter rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'How the LeanData routing rule works'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          this.renderCopySection()
        )
      );
    }
  }]);

  return LeandataFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LeandataFilter);

/***/ }),

/***/ "LwAT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion__ = __webpack_require__("/fEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_NotificationBar_styl__ = __webpack_require__("UsF/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_NotificationBar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_components_NotificationBar_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.









var NOTIFICATION_DISPLAY_DURATION = 5000;

var NotificationBar = React.createClass({
  displayName: 'NotificationBar',
  getDefaultProps: function getDefaultProps() {
    return {
      variant: 'green'
    };
  },
  dismissNotification: function dismissNotification() {
    clearTimeout(this.delayedDismissal);
    return this.app.actions.NotificationActions.dismissNotification();
  },
  undoNotification: function undoNotification(notification) {
    notification.undoAction();
    return this.dismissNotification();
  },
  render: function render() {
    var _this = this;

    if (this.props.notifications.length) {
      var notification = _.head(this.props.notifications);
      if (!notification.sticky) {
        this.delayedDismissal = setTimeout(this.dismissNotification, notification.displayTime || NOTIFICATION_DISPLAY_DURATION);
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_motion__["Motion"],
        null,
        function (interpolated) {
          return React.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('NotificationBar', notification.variant),
              style: { top: interpolated.top + 'rem' } },
            React.createElement(
              'div',
              { className: 'notification-content' },
              notification.content
            ),
            notification.viewLinkTo ? React.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
              { onClick: _this.dismissNotification, to: notification.viewLinkTo },
              React.createElement(
                'button',
                { className: 'dsg-SmallButton' },
                'View'
              )
            ) : undefined,
            notification.undoAction ? React.createElement(
              'button',
              {
                className: 'dsg-SmallButton',
                onClick: _this.undoNotification.bind(_this, notification) },
              'Undo'
            ) : undefined,
            notification.actioNode ? notification.actioNode : undefined,
            React.createElement('img', {
              src: __webpack_require__("S03J"),
              onClick: _this.dismissNotification })
          );
        }
      );
    } else {
      return React.createElement('div', null);
    }
  }
});

NotificationBar.displayName = 'NotificationBar';
NotificationBar.propTypes = {
  notifications: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    variant: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['red', 'gray', 'green', 'blue']),
    viewLinkTo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    displayTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    undoAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  }).isRequired)
};

var NotificationBarContainer = Marty.createContainer(NotificationBar, {
  listenTo: ['stores.NotificationStore'],
  fetch: {
    notifications: function notifications() {
      return this.app.stores.NotificationStore.getNotifications();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (NotificationBarContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "Lxm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("14CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("SKr3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demodata__ = __webpack_require__("3UPu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("XmtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__ = __webpack_require__("lgiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__demandbase__ = __webpack_require__("aVRA");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }














function parseEnrichment(data) {
  var tags = data.get('tags');
  var geo = data.get('geography');
  var tech = data.get('tech');

  return {
    name: data.get('name'),
    domain: data.get('domain'),
    logo: data.get('logo'),
    description: data.get('description'),
    linkedInHandle: data.getIn(['social', 'linkedin', 'handle']),
    twitterHandle: data.getIn(['social', 'twitter', 'handle']),
    employeeCount: data.getIn(['metrics', 'employees']),
    industry: data.getIn(['category', 'industry']),
    subIndustry: data.getIn(['category', 'subIndustry']),
    location: data.get('location'),
    madkuduScore: data.get('companyScore'),
    moneyRaised: data.getIn(['metrics', 'raised']),
    marketCap: data.getIn(['metrics', 'revenueRange']),
    geo: geo && geo.toJS(),
    tags: tags && tags.toJS(),
    url: data.get('url'),
    source: data.get('source'),
    tech: tech && tech.toJS()
  };
}

var fetchLocal = function fetchLocal(state, options) {
  if (__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["i" /* hasDemoOrg */](state)) {
    return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])(parseEnrichment(__WEBPACK_IMPORTED_MODULE_3__demodata__["a" /* companyData */]));
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* companyData */])(state, options);
  }
};

var fetchRemote = function fetchRemote(state, options) {
  return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* api */].fetchEnrichedCompanyData(options).map(function (data) {
    return hasEnrichmentResults(data) ? makeResponse(Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])(parseEnrichment(data)), true) : makeResponse(data, false);
  });
};

var makeResponse = function makeResponse(data, status) {
  return { result: data, ok: status };
};

var getCompanyData = function getCompanyData(state, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(fetchLocal(state, options)).flatMap(function (result) {
    return result ? Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(makeResponse(result, true)) : fetchRemote(state, options);
  });
};

var fetchEnrichedCompanyData = function fetchEnrichedCompanyData(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* fetchEnrichedCompanyData */].toString()).pluck('payload').mergeMap(function (options) {
    return getCompanyData(getState(), options).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* fetchEnrichedCompanyDataCancelled */]({ email: options.email, ip: options.ip }))).map(function (data) {
      if (data.ok === true) {
        return __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* fetchEnrichedCompanyDataSuccess */]({ data: data.result, email: options.email, ip: options.ip, conversationId: options.conversationId });
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* fetchEnrichedCompanyDataNoResult */]({ email: options.email, ip: options.ip });
      }
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* fetchEnrichedCompanyDataPending */]({ email: options.email, ip: options.ip })).catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(error).map(function () {
        return __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* fetchEnrichedCompanyDataFailed */]({ email: options.email, ip: options.ip });
      });
    });
  });
};

var fetchDecodedCondition = function fetchDecodedCondition(action$, _ref2) {
  var getState = _ref2.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* fetchDecodedCondition */].toString()).pluck('payload').mergeMap(function (_ref3) {
    var conditions = _ref3.conditions,
        rest = _objectWithoutProperties(_ref3, ['conditions']);

    var state = getState();
    var getHasRequestedDecodedCondition = Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["e" /* makeHasRequestedDecodedCondition */])(state);
    return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(_extends({
      conditions: conditions.filter(function (condition) {
        return !getHasRequestedDecodedCondition(condition);
      }),
      orgId: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"])(state)
    }, rest));
  }).filter(function (_ref4) {
    var conditions = _ref4.conditions;
    return conditions.length;
  }).mergeMap(function (_ref5) {
    var conditions = _ref5.conditions,
        ip = _ref5.ip,
        orgId = _ref5.orgId,
        enrichmentProvider = _ref5.enrichmentProvider;
    return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* api */].fetchDecodedCondition(enrichmentProvider, conditions, ip, orgId).map(function (_ref6) {
      var response = _ref6.response;

      var map = {};
      conditions.forEach(function (condition, i) {
        return map[condition] = response[i];
      });
      return __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* fetchDecodedConditionSuccess */]({ conditions: Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])(map) });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* fetchDecodedConditionPending */]({ conditions: conditions })).catch(function (err) {
      return Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_observable_of__["of"])(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* fetchDecodedConditionFailed */]({ conditions: conditions, err: err }));
    });
  });
};

var hasEnrichmentResults = function hasEnrichmentResults(data) {
  return data !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_9_lodash__["isEmpty"])(data.get('name'));
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetchEnrichedCompanyData, fetchDecodedCondition, __WEBPACK_IMPORTED_MODULE_10__demandbase__["a" /* epic */]);

/***/ }),

/***/ "LyFp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"profile":"profile---2AE1M"};

/***/ }),

/***/ "M+te":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/agentstatus.ecb111b1.png";

/***/ }),

/***/ "M37C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__ = __webpack_require__("PNFo");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var ReportStore = Marty.createStore({
  id: 'ReportStore',
  getInitialState: function getInitialState() {
    return {
      activities: undefined
    };
  },


  handlers: {
    fetchUsersActivityDone: __WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__["a" /* default */].FETCH_USERS_ACTIVITY_DONE
  },

  fetchUsersActivity: function fetchUsersActivity() {
    return this.fetch({
      id: 'fetchUsersActivity',
      // gotta make sure the access token work
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally: function locally() {
        return this.state.activities;
      },
      remotely: function remotely() {
        return this.app.queries.ReportQueries.fetchUsersActivity();
      }
    });
  },
  fetchUsersActivityDone: function fetchUsersActivityDone(activities) {
    return this.setState({ activities: activities });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ReportStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "M9k1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_customer_EndUserIdentity__ = __webpack_require__("x1bR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_TagList__ = __webpack_require__("8DYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_GlobalSearch_ResultPreview_User_styl__ = __webpack_require__("0mIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_GlobalSearch_ResultPreview_User_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_styles_components_GlobalSearch_ResultPreview_User_styl__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.











var ResultPreviewUser = React.createClass({
  displayName: 'ResultPreviewUser',

  propTypes: function propTypes() {
    return {
      endUser: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
      companies: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
    };
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'ResultPreviewUser' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_customer_EndUserIdentity__["a" /* default */], { endUser: this.props.endUser }),
      (this.props.companies[this.props.endUser.customerId] != null ? this.props.companies[this.props.endUser.customerId].name : undefined) != null ? React.createElement(
        'div',
        { className: 'organization' },
        React.createElement(
          'span',
          null,
          'Works for ' + this.props.companies[this.props.endUser.customerId].name
        )
      ) : undefined,
      !_.isEmpty(this.props.endUser.tags) ? React.createElement(
        'div',
        { className: 'tag-list' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_TagList__["a" /* default */], { tagIds: this.props.endUser.tags })
      ) : undefined
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(ResultPreviewUser, {
  listenTo: ['stores.CompanyStore'],

  fetch: {
    companies: function companies() {
      return this.app.stores.CompanyStore.fetchCompanies([this.props.endUser.customerId]);
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "M9ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchIntegrationStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchIntegrationStatesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchIntegrationStatesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchIntegrationStatesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return updateIntegrationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return updateIntegrationStateSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return updateIntegrationStateFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return updateIntegrationStatePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchIntegrationEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchIntegrationEventsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchIntegrationEventsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchIntegrationEventsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return destroyIntegrationEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchPaginatedIntegrationEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchPaginatedIntegrationEventsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return postBusinessEventCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return postBusinessEventCsvSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return postBusinessEventCsvFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchOutreachStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchOutreachStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchOutreachStatusFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchOutreachStatusSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAccessTokenPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAccessTokenFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createAccessTokenSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createSlackbotToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return setWordpressV2Integration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return setWordpressV2IntegrationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return setWordpressV2IntegrationSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return setWordpressV2IntegrationFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return setWordpressDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return setWordpressDomainPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return setWordpressDomainSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return setWordpressDomainFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchWordpressDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchWordpressDomainPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fetchWordpressDomainSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchWordpressDomainFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getLeanDataAuthStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getLeanDataAuthStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getLeanDataAuthStatusFailed; });
/* unused harmony export getLeanDataAuthStatusCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getLeanDataAuthStatusSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createSandBoxAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchStripeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchStripeKeysPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchStripeKeysFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchStripeKeysCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchStripeKeysSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);



var fetchIntegrationStates = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* FETCH_INTEGRATION_STATES */]);
var fetchIntegrationStatesSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* FETCH_INTEGRATION_STATES_SUCCESS */]);
var fetchIntegrationStatesFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* FETCH_INTEGRATION_STATES_FAILED */]);
var fetchIntegrationStatesPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* FETCH_INTEGRATION_STATES_PENDING */]);

var updateIntegrationState = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["X" /* UPDATE_INTEGRATION_STATE */]);
var updateIntegrationStateSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["_0" /* UPDATE_INTEGRATION_STATE_SUCCESS */]);
var updateIntegrationStateFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["Y" /* UPDATE_INTEGRATION_STATE_FAILED */]);
var updateIntegrationStatePending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* UPDATE_INTEGRATION_STATE_PENDING */]);

var fetchIntegrationEvents = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_INTEGRATION_EVENTS */]);
var fetchIntegrationEventsSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* FETCH_INTEGRATION_EVENTS_SUCCESS */]);
var fetchIntegrationEventsFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* FETCH_INTEGRATION_EVENTS_FAILED */]);
var fetchIntegrationEventsPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_INTEGRATION_EVENTS_PENDING */]);
var destroyIntegrationEvents = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DESTORY_INTEGRATION_EVENTS */]);

var fetchPaginatedIntegrationEvents = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["u" /* FETCH_PAGINATED_INTEGRATION_EVENTS */]);
var fetchPaginatedIntegrationEventsSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["v" /* FETCH_PAGINATED_INTEGRATION_EVENTS_SUCCESS */]);

var postBusinessEventCsv = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["M" /* POST_BUSINESS_EVENT_CSV */]);
var postBusinessEventCsvSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["O" /* POST_BUSINESS_EVENT_CSV_SUCCESS */]);
var postBusinessEventCsvFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["N" /* POST_BUSINESS_EVENT_CSV_FAILED */]);

var fetchOutreachStatus = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* FETCH_OUTREACH_STATUS */]);
var fetchOutreachStatusPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* FETCH_OUTREACH_STATUS_PENDING */]);
var fetchOutreachStatusFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* FETCH_OUTREACH_STATUS_FAILED */]);
var fetchOutreachStatusSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* FETCH_OUTREACH_STATUS_SUCCESS */]);

var createAccessToken = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CREATE_ACCESS_TOKEN */]);
var createAccessTokenPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CREATE_ACCESS_TOKEN_PENDING */]);
var createAccessTokenFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CREATE_ACCESS_TOKEN_FAILED */]);
var createAccessTokenSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CREATE_ACCESS_TOKEN_SUCCESS */]);

var createSlackbotToken = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* CREATE_SLACKBOT_TOKEN */]);

var setWordpressV2Integration = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["T" /* SET_WORDPRESS_V2_INTEGRATION */]);
var setWordpressV2IntegrationPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["V" /* SET_WORDPRESS_V2_INTEGRATION_PENDING */]);
var setWordpressV2IntegrationSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["W" /* SET_WORDPRESS_V2_INTEGRATION_SUCCESS */]);
var setWordpressV2IntegrationFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["U" /* SET_WORDPRESS_V2_INTEGRATION_FAILED */]);

var setWordpressDomain = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["P" /* SET_WORDPRESS_DOMAIN */]);
var setWordpressDomainPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["R" /* SET_WORDPRESS_DOMAIN_PENDING */]);
var setWordpressDomainSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["S" /* SET_WORDPRESS_DOMAIN_SUCCESS */]);
var setWordpressDomainFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["Q" /* SET_WORDPRESS_DOMAIN_FAILED */]);

var fetchWordpressDomain = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["B" /* FETCH_WORDPRESS_DOMAIN */]);
var fetchWordpressDomainPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["D" /* FETCH_WORDPRESS_DOMAIN_PENDING */]);
var fetchWordpressDomainSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["E" /* FETCH_WORDPRESS_DOMAIN_SUCCESS */]);
var fetchWordpressDomainFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["C" /* FETCH_WORDPRESS_DOMAIN_FAILED */]);

var getLeanDataAuthStatus = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["F" /* GET_LEANDATA_AUTH_STATUS */]);
var getLeanDataAuthStatusPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["I" /* GET_LEANDATA_AUTH_STATUS_PENDING */]);
var getLeanDataAuthStatusFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["H" /* GET_LEANDATA_AUTH_STATUS_FAILED */]);
var getLeanDataAuthStatusCancelled = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["G" /* GET_LEANDATA_AUTH_STATUS_CANCELLED */]);
var getLeanDataAuthStatusSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["J" /* GET_LEANDATA_AUTH_STATUS_SUCCESS */]);

var createSandBoxAccessToken = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CREATE_SANDBOX_ACCESS_TOKEN */]);

var fetchStripeKeys = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["w" /* FETCH_STRIPE_KEYS */]);
var fetchStripeKeysPending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["z" /* FETCH_STRIPE_KEYS_PENDING */]);
var fetchStripeKeysFailed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FETCH_STRIPE_KEYS_FAILED */]);
var fetchStripeKeysCancelled = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["x" /* FETCH_STRIPE_KEYS_CANCELLED */]);
var fetchStripeKeysSuccess = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_0__constants__["A" /* FETCH_STRIPE_KEYS_SUCCESS */]);

/***/ }),

/***/ "MCwX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment__ = __webpack_require__("7WJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dot_fragment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__ = __webpack_require__("pBsb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_salesforce_video_png__ = __webpack_require__("yk+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_salesforce_video_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_salesforce_video_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("57/x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SALESFORCE_EDU_URL = 'https://insider.drift.com/lessons/salesforce-and-drift/';

function mapStateToProps(state) {
  return {
    hasSeenEduNudge: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */])(state).get('hasSeenSalesforceEduNudge') || false
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchUserProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__["a" /* fetchUserProperties */],
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties_actions__["p" /* updateUserPropertiesTheRightWay */],
      track: __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
}

var SalesforceEduTooltip = function (_Component) {
  _inherits(SalesforceEduTooltip, _Component);

  function SalesforceEduTooltip(props) {
    _classCallCheck(this, SalesforceEduTooltip);

    var _this = _possibleConstructorReturn(this, (SalesforceEduTooltip.__proto__ || Object.getPrototypeOf(SalesforceEduTooltip)).call(this, props));

    _this.componentDidMount = function () {
      _this.props.actions.fetchUserProperties();
      setTimeout(function () {
        _this.setState({ showEduNudgeTimed: true });
        _this.props.actions.track("In App Education - Viewed", { page: "salesforce", nudge: !_this.props.hasSeenEduNudge });
      }, 5000);
    };

    _this.componentWillUnmount = function () {
      _this.updateUserProps();
    };

    _this.updateUserProps = function () {
      if (!_this.props.hasSeenEduNudge) {
        _this.props.actions.updateUserProperties({ hasSeenSalesforceEduNudge: true }, false);
      }
    };

    _this.onToggleEduTooltip = function () {
      var showEduTooltip = _this.state.showEduTooltip;

      if (!!showEduTooltip) {
        _this.updateUserProps();
        _this.props.actions.track("In App Education - Closed", { page: "salesforce", nudge: !_this.props.hasSeenEduNudge });
      } else {
        _this.props.actions.track("In App Education - Opened", { page: "salesforce", nudge: !_this.props.hasSeenEduNudge });
      }
      _this.setState({ showEduTooltip: !showEduTooltip, showEduNudgeTimed: false });
    };

    _this.onWatchEduTooltip = function (link) {
      window.open(SALESFORCE_EDU_URL, '_blank');
      _this.props.actions.track("In App Education - Watched", { page: "salesforce", nudge: !_this.props.hasSeenEduNudge, link: link });
      _this.setState({ showEduTooltip: false });
    };

    _this.state = {
      showEduNudgeTimed: false,
      showEduTooltip: false
    };
    return _this;
  }

  _createClass(SalesforceEduTooltip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showEduNudgeTimed = _state.showEduNudgeTimed,
          showEduTooltip = _state.showEduTooltip;
      var hasSeenEduNudge = this.props.hasSeenEduNudge;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-integration-edu-nudge-animation-container' },
        !!showEduNudgeTimed && !hasSeenEduNudge && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_dot_fragment___default.a,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-bolt', name: 'lightning-bolt-filled' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__driftt_tide_tooltips_legacy__["FeatureTooltip"],
          {
            className: 'salesforce-integration-edu-tooltip',
            onClose: function onClose() {
              return _this2.onToggleEduTooltip();
            },
            showTooltip: !!showEduTooltip,
            ribbonType: 'how',
            orientation: 'vertical',
            tooltipSide: 'bottom',
            tooltipCaretLocation: 'center',
            headerCopy: 'Learn how to set up your Salesforce integration',
            bodyCopy: 'Measure the impact of your funnel by pushing leads, contacts, attributes, and chat transcripts to Salesforce!',
            mediaComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: "salesforce-integration-edu-tooltip-img", src: __WEBPACK_IMPORTED_MODULE_9_images_salesforce_video_png___default.a, onClick: function onClick() {
                  _this2.onWatchEduTooltip("img");
                }, alt: 'Salesforce how-to video' })
            ),
            buttonInfoArray: [{
              copy: 'Watch on Drift Insider',
              func: function func() {
                _this2.onWatchEduTooltip("button");
              }
            }] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'salesforce-integration-edu-tooltip-container', onClick: this.onToggleEduTooltip },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'salesforce-integration-edu-nudge-icon', name: 'video-play' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'salesforce-integration-edu-nudge-copy' },
              'How to set up Salesforce'
            )
          )
        )
      );
    }
  }]);

  return SalesforceEduTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(SalesforceEduTooltip));

/***/ }),

/***/ "MD1P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OnlineToggle":"OnlineToggle---1K3tv"};

/***/ }),

/***/ "MD3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LeanDataError__ = __webpack_require__("wkqp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LeanDataConnected__ = __webpack_require__("nf5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LeanDataDisconnected__ = __webpack_require__("SS0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_logos_leandata_with_name_svg__ = __webpack_require__("vuMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_logos_leandata_with_name_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_logos_leandata_with_name_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_green_check_circle_svg__ = __webpack_require__("9SsH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_green_check_circle_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_svg_green_check_circle_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("irP4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch';

var NO_ERROR_VALUE = __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_constants__["L" /* LeanDataAuthStatuses */].NO_ERROR;

var makeGetLeanDataAuthStatusConfig = function makeGetLeanDataAuthStatusConfig(successCallback) {
  return {
    url: __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["i" /* CONVERSATION_API */] + '/integration/test/leandata/authorization',
    method: 'get',
    data: {},
    successMessage: '',
    errorMessage: '',
    successCallback: successCallback
  };
};

var LeanData = function (_React$PureComponent) {
  _inherits(LeanData, _React$PureComponent);

  function LeanData(props) {
    _classCallCheck(this, LeanData);

    var _this = _possibleConstructorReturn(this, (LeanData.__proto__ || Object.getPrototypeOf(LeanData)).call(this, props));

    _this.state = {
      leandataConnectedWithAccess: false,
      leandataConnectedWithNoAccess: false,
      leandataNotConnected: true
    };
    return _this;
  }

  _createClass(LeanData, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.getLeanDataAuthStatus();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var newValue = this.props.leandataAuthenticationStatus.get("value");
      var a = __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_constants__["L" /* LeanDataAuthStatuses */];
      if (newValue && prevProps.leandataAuthenticationStatus.value !== newValue) {
        this.setState({
          leandataConnectedWithAccess: this.props.leandataConnected && newValue === NO_ERROR_VALUE,
          leandataConnectedWithNoAccess: this.props.leandataConnected && newValue !== NO_ERROR_VALUE
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          salesforceConnected = _props.salesforceConnected,
          leandataConnected = _props.leandataConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'integration-leandata-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'integration-leandata-title-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'integration-leanddata-title-icon', src: __WEBPACK_IMPORTED_MODULE_9_images_logos_leandata_with_name_svg___default.a })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            this.state.leandataConnectedWithAccess && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'integration-leandata-title-connected' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_10_images_svg_green_check_circle_svg___default.a }),
              'Connected'
            ),
            this.state.leandataConnectedWithNoAccess && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'integration-leandata-title-incomplete' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'incomplete-icon', name: 'warning-triangle' }),
              ' INCOMPLETE'
            )
          )
        ),
        this.state.leandataConnectedWithAccess && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_LeanDataConnected__["a" /* default */], {
          asyncButtonPress: this.props.actions.asyncButtonPress,
          togglePending: this.props.togglePending,
          integrationsFetchPending: this.props.integrationsFetchPending,
          fetchIntegrationStates: this.props.actions.fetchIntegrationStates
        }),
        this.state.leandataConnectedWithNoAccess && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LeanDataError__["a" /* default */], {
          error: this.props.leandataAuthenticationStatus.get("value")
        }),
        !this.props.leandataConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_LeanDataDisconnected__["a" /* default */], {
          asyncButtonPress: this.props.actions.asyncButtonPress,
          togglePending: this.props.togglePending,
          integrationsFetchPending: this.props.integrationsFetchPending,
          fetchIntegrationStates: this.props.actions.fetchIntegrationStates
        })
      );
    }
  }]);

  return LeanData;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    salesforceConnected: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_selectors__["l" /* isConnectedTo */](state, 'salesforce'),
    leandataConnected: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_selectors__["l" /* isConnectedTo */](state, 'leandata'),
    integrationsFetchPending: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_selectors__["b" /* connectionsFetchPending */](state),
    togglePending: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["c" /* asyncButtonPending */](state, LEANDATA_INTEGRATION_SWITCH),
    leandataAuthenticationStatus: __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_selectors__["j" /* getLeanDataAuthStatus */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      updateIntegrationState: __WEBPACK_IMPORTED_MODULE_14_app_modules_integrations_actions__["T" /* updateIntegrationState */],
      asyncButtonPress: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_actions__["n" /* asyncButtonPress */],
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_14_app_modules_integrations_actions__["l" /* fetchIntegrationStates */],
      getLeanDataAuthStatus: __WEBPACK_IMPORTED_MODULE_14_app_modules_integrations_actions__["E" /* getLeanDataAuthStatus */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(LeanData));

/***/ }),

/***/ "MD73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OperatorOptions = [{ value: "is" }, { value: "notIs", text: "is not" }, { value: "lessThan", text: "is less than" }, { value: "greaterThan", text: "is greater than" }];

var OperatorByValue = __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default()(OperatorOptions, 'value');

var NumericInputs = function (_Component) {
  _inherits(NumericInputs, _Component);

  function NumericInputs() {
    _classCallCheck(this, NumericInputs);

    return _possibleConstructorReturn(this, (NumericInputs.__proto__ || Object.getPrototypeOf(NumericInputs)).apply(this, arguments));
  }

  _createClass(NumericInputs, [{
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'onNumberChange',
    value: function onNumberChange(value) {
      this.props.conditionUpdater('value', parseInt(value));
    }
  }, {
    key: 'renderOperatorSelection',
    value: function renderOperatorSelection() {
      var operator = this.props.conditionValue.get('operator');
      var selectedValue = OperatorByValue[operator];
      var text = selectedValue.text,
          value = selectedValue.value;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__["a" /* default */], {
        onSelection: this.onOperatorSelect.bind(this),
        options: OperatorOptions,
        selectedValue: text || value
      });
    }
  }, {
    key: 'renderNumericInput',
    value: function renderNumericInput() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default.a, {
        type: 'number',
        min: 0,
        valueLink: {
          requestChange: this.onNumberChange.bind(this),
          value: this.props.conditionValue.get('value')
        },
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'flex-space-around flex-1' },
        this.renderOperatorSelection(),
        this.renderNumericInput(),
        React.createElement('div', { style: { width: 16 } })
      );
    }
  }]);

  return NumericInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NumericInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "MDpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("NBzk");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__epic__ = __webpack_require__("mmRg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__epic__["a"]; });





/***/ }),

/***/ "MHWM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MMge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popover__ = __webpack_require__("uGjW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("2OsS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Help = function (_Component) {
  _inherits(Help, _Component);

  function Help(props) {
    _classCallCheck(this, Help);

    var _this = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this, props));

    _this.toggleOpen = function () {
      if (_this.state.flyoutOpen) {
        _this.trackHelpFlyoutInteraction({ eventType: 'dismissed' });
      }

      var wrapperRect = _this.wrapperRef.getBoundingClientRect();

      _this.setState(function (prevState) {
        return {
          flyoutOpen: !prevState.flyoutOpen,
          flyoutPosition: window.innerHeight - wrapperRect.bottom
        };
      });
    };

    _this.trackHelpFlyoutInteraction = function (_ref) {
      var eventType = _ref.eventType,
          _ref$ctaInfo = _ref.ctaInfo,
          ctaInfo = _ref$ctaInfo === undefined ? {} : _ref$ctaInfo;

      // Tracking flyoutTriggered(by icon click), flyoutShown, flyoutClosed, flyoutLinkClicked
      return _this.props.actions.track('Flyout ' + Object(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__["capitalize"])(eventType), _extends({ subject: 'integrated-help-tooltip' }, { ctaInfo: ctaInfo }));
    };

    _this.state = {
      flyoutOpen: false,
      flyoutPosition: 0
    };
    _this.onClickOutside = _this.toggleOpen;
    return _this;
  }

  _createClass(Help, [{
    key: 'renderFlyOut',
    value: function renderFlyOut() {
      if (!this.state.flyoutOpen) return null;
      this.trackHelpFlyoutInteraction({ eventType: 'triggered' });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { position: 'fixed', bottom: this.state.flyoutPosition } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */], {
          trackHelpFlyout: this.trackHelpFlyoutInteraction,
          onClickOutside: this.toggleOpen
        })
      );
    }
  }, {
    key: 'renderHoverTooltip',
    value: function renderHoverTooltip() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
        { component: 'Need Help?', flow: 'right', hover: !this.state.flyoutOpen },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'nav-status-icon-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { width: 19, name: 'question' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'help-wrapper', ref: function ref(_ref2) {
            return _this2.wrapperRef = _ref2;
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'help-tooltip', onClick: this.toggleOpen },
          this.renderHoverTooltip()
        ),
        this.renderFlyOut()
      );
    }
  }]);

  return Help;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null, mapDispatchToProps)(Help));

/***/ }),

/***/ "MQX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__ = __webpack_require__("rc0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var OrgSettingsActionCreators = function (_Marty$ActionCreators) {
  _inherits(OrgSettingsActionCreators, _Marty$ActionCreators);

  function OrgSettingsActionCreators() {
    _classCallCheck(this, OrgSettingsActionCreators);

    return _possibleConstructorReturn(this, (OrgSettingsActionCreators.__proto__ || Object.getPrototypeOf(OrgSettingsActionCreators)).apply(this, arguments));
  }

  _createClass(OrgSettingsActionCreators, [{
    key: 'updateIcon',
    value: function updateIcon(orgId, file) {
      var _this2 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__["a" /* default */].UPLOAD_WIDGET_ICON_STARTED, orgId, file);
      return this.app.sources.OrgPropertiesAPI.uploadOrgImage(orgId, file).then(function (res) {
        if (res.status === 200) {
          var iconUrl = res.body.attachmentUrl;
          _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__["a" /* default */].UPLOAD_WIDGET_ICON_FINISHED, ['theme', 'iconUrl'], iconUrl);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
          _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__["a" /* default */].UPLOAD_WIDGET_ICON_FAILED);
        }
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__["a" /* default */].UPLOAD_WIDGET_ICON_FAILED);
      });
    }
  }, {
    key: 'updateOrgSettings',
    value: function updateOrgSettings(orgSettings) {
      this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgSettingsConstants__["a" /* default */].ORG_SETTINGS_UPDATED, orgSettings);
    }
  }]);

  return OrgSettingsActionCreators;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (OrgSettingsActionCreators);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "MQdo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrgId; });
var getOrgId = function getOrgId(state) {
  return state.getIn(['currentUser', 'user', 'orgId']);
};

/***/ }),

/***/ "MSOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("4VmE");
var _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var savedReplies = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchSavedRepliesSuccess */], function (state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());

var composerTextToInsert = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* setComposerTextToInsert */], function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* clearComposerTextToInsert */], function () {
  return null;
}), _handleActions2), null);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({
  savedReplies: savedReplies,
  composerTextToInsert: composerTextToInsert
}));

/***/ }),

/***/ "MSQN":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.92 11.84C9.2 11.84 15 5.92 15 5.92S9.2 0 5.92 0C2.65 0 0 2.65 0 5.92s2.65 5.92 5.92 5.92z\" fill=\"#0075FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "MShG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TargetConditions":"TargetConditions---1nKDm","TargetCondition":"TargetCondition---2Bv7g","TargetModal__Header":"TargetModal__Header---3Bets","TargetModal__Content":"TargetModal__Content---1Qt1f"};

/***/ }),

/***/ "MZpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Clearbit = function Clearbit() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "svg",
    { width: "79", height: "24", viewBox: "0 0 79 24", xmlns: "http://www.w3.org/2000/svg" },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "g",
        { fillRule: "nonzero" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M11.52 0v11.52h11.52V3.6a3.6 3.6 0 0 0-3.6-3.6h-7.92z", fill: "#5CA4FF", opacity: ".9" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M0 11.52v7.92a3.6 3.6 0 0 0 3.6 3.6h7.92V11.52H0z", fill: "#499AFF" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M11.52 11.52v11.52h7.92a3.6 3.6 0 0 0 3.6-3.6v-7.92H11.52z", fill: "#E9F3FF" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", { d: "M3.6 0A3.6 3.6 0 0 0 0 3.6v7.92h11.52V0H3.6z", fill: "#499AFF" })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "text",
        { fill: "#499AFF", fontFamily: "AvenirNext-Medium, Avenir Next", fontSize: "12.6", fontWeight: "400" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tspan",
          { x: "32.4", y: "15.25" },
          "Clearbi"
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "text",
        { fill: "#499AFF", fontFamily: "AvenirNext-Medium, Avenir Next", fontSize: "12.6", fontWeight: "400" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "tspan",
          { x: "74.362", y: "15.25" },
          "t"
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Clearbit);

/***/ }),

/***/ "McSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("Lxm3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("9I79");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "MdQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CustomizeTemplate":"CustomizeTemplate---iAwUf","CustomizeSidebar":"CustomizeSidebar---1IwOf","ExitButton":"ExitButton---dxkx1"};

/***/ }),

/***/ "Mh5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConfigAPI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");



var ConfigAPI = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({ baseURL: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["g" /* CONFIG_API */] });

var getConfig = function getConfig(config) {
  return ConfigAPI.get('' + config);
};

/***/ }),

/***/ "MhvU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "MiBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("8dyo");















var mapStateToProps = function mapStateToProps(state) {
  var inboxes = __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["f" /* inboxes */](state);
  return {
    inboxes: inboxes,
    isLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["g" /* isInboxListLoaded */](state),
    isLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["h" /* isInboxListLoading */](state),
    inboxOptionsWithLabels: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["e" /* inboxOptionsWithLabels */](state),
    selectedInboxId: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_58" /* playbookActionInboxId */](state),
    defaultInbox: inboxes.first()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_7_app_modules_inbox_actions__["A" /* fetchInboxList */],
      setActionInboxId: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_135" /* setActionInboxId */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_lifecycle___default()({
  componentWillMount: function componentWillMount() {
    if (this.props.inboxes.size === 0 && !this.props.isLoading) {
      this.props.actions.fetchInboxList();
    }
  }
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers___default()({
  onSelectChange: function onSelectChange(_ref) {
    var actions = _ref.actions;
    return function (option) {
      actions.setActionInboxId(option.value);
    };
  }
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (_ref2) {
  var defaultInbox = _ref2.defaultInbox,
      selectedInboxId = _ref2.selectedInboxId,
      inboxOptionsWithLabels = _ref2.inboxOptionsWithLabels;
  return {
    selectedInboxId: !!selectedInboxId && selectedInboxId || !!defaultInbox && defaultInbox.id,
    inboxOptions: inboxOptionsWithLabels.toJS()
  };
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));

/***/ }),

/***/ "MmXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EndUserAvatar__ = __webpack_require__("KlsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FollowButton__ = __webpack_require__("Eapw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LocalTime__ = __webpack_require__("x1nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Placeholder__ = __webpack_require__("lCnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EnrollButtonConvo__ = __webpack_require__("Hysi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("LyFp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_icons_twitter_logo_svg__ = __webpack_require__("sWJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_icons_twitter_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_icons_twitter_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_icons_linkedin_svg__ = __webpack_require__("Ocgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_icons_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_icons_linkedin_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var TwitterHandle = function TwitterHandle(_ref) {
  var twitterHandle = _ref.twitterHandle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: 'https://twitter.com/' + twitterHandle, target: '_blank' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'social-icon', src: __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_icons_twitter_logo_svg___default.a })
  );
};

var LinkedInHandle = function LinkedInHandle(_ref2) {
  var linkedInHandle = _ref2.linkedInHandle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: 'https://www.linkedin.com/' + linkedInHandle, target: '_blank' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'social-icon social-icon-linkedin', src: __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_icons_linkedin_svg___default.a })
  );
};

var Loading = function Loading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_13__style_styl__["profile"], 'placeholder') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Placeholder__["a" /* default */], null)
  );
};

var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'renderSocialIcons',
    value: function renderSocialIcons() {
      var _props = this.props,
          twitterHandle = _props.twitterHandle,
          linkedInHandle = _props.linkedInHandle;


      if (!twitterHandle && !linkedInHandle) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'social-icons' },
        twitterHandle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwitterHandle, { twitterHandle: twitterHandle }),
        linkedInHandle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkedInHandle, { linkedInHandle: linkedInHandle })
      );
    }
  }, {
    key: 'renderEmail',
    value: function renderEmail() {
      var _props2 = this.props,
          email = _props2.email,
          displayName = _props2.displayName;


      if (!email || email === displayName) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-row icon-row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { width: 13, height: 13, name: 'email', className: 'icon' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'icon-row-text' },
          email
        )
      );
    }
  }, {
    key: 'renderJobTitle',
    value: function renderJobTitle() {
      var jobTitle = this.props.jobTitle;


      return jobTitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-row icon-row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { width: 13, height: 13, name: 'briefcase', className: 'icon' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'icon-row-text' },
          jobTitle
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          endUser = _props3.endUser,
          conversationId = _props3.conversationId,
          displayName = _props3.displayName;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_13__style_styl__["profile"] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'flex-row header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Link */],
              { to: '/contacts/details/' + endUser.id, target: '_self' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__EndUserAvatar__["a" /* default */], { endUser: endUser, className: 'endUserAvatar' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_router__["c" /* Link */],
              { to: '/contacts/details/' + endUser.id, className: 'name', target: '_self' },
              displayName
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex-row action-links' },
              this.renderSocialIcons(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FollowButton__["a" /* default */], { endUser: endUser }),
              __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('has_sequence_enroll_in_convo_view') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EnrollButtonConvo__["a" /* default */], { endUser: endUser })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LocalTime__["a" /* default */], { endUser: endUser, conversationId: conversationId }),
        this.renderEmail(),
        this.renderJobTitle()
      );
    }
  }]);

  return Profile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return !props.endUser;
}, Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["f" /* renderComponent */])(Loading)), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["e" /* mapProps */])(function (_ref3) {
  var endUser = _ref3.endUser,
      props = _objectWithoutProperties(_ref3, ['endUser']);

  return _extends({
    endUser: endUser,
    email: endUser.email,
    displayName: Object(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser) || 'Site Visitor',
    linkedInHandle: _.get(endUser, 'attributes.linkedin_handle') || _.get(endUser, 'socialProfile.linkedin.handle'),
    twitterHandle: _.get(endUser, 'attributes.twitter_handle') || _.get(endUser, 'socialProfile.twitter.handle'),
    jobTitle: _.get(endUser, 'attributes.employment_title') || _.get(endUser, 'socialProfile.employment.title')
  }, props);
}))(Profile));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Mmqy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__ = __webpack_require__("PNFo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var ReportQueries = Marty.createQueries({
  id: 'ReportQueries',

  fetchUsersActivity: function fetchUsersActivity() {
    var _this = this;

    var promise = this.app.sources.ReportAPI.fetchUsersActivity();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__["a" /* default */].FETCH_USERS_ACTIVITY_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__["a" /* default */].FETCH_USERS_ACTIVITY_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ReportConstants__["a" /* default */].FETCH_USERS_ACTIVITY_FAILED, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ReportQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "MphB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MryT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(217);

/***/ }),

/***/ "MuiX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGeolocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("5BTZ");



var fetchGeolocation = function fetchGeolocation() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/location').checkStatus().retryWithBackoff().mapResponse(function (location) {
    return new __WEBPACK_IMPORTED_MODULE_1__models__["a" /* Geolocation */](location);
  });
};

/***/ }),

/***/ "MujL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPresence", function() { return hasPresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPresence", function() { return getPresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInterval", function() { return getInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBufferedUsers", function() { return getBufferedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewLiveUsers", function() { return getNewLiveUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewLiveUsersCount", function() { return getNewLiveUsersCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentIndex", function() { return getCurrentIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPagination", function() { return getPagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewFilters", function() { return getNewFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewSorts", function() { return getNewSorts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShowMore", function() { return getShowMore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFilterKnownUsers", function() { return getFilterKnownUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReceivingPresence", function() { return isReceivingPresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveStatus", function() { return getActiveStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPresenceProblems", function() { return getPresenceProblems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPresenceLoading", function() { return getPresenceLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHasProcessedUsers", function() { return getHasProcessedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processAllUsers", function() { return processAllUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRawProcessedUsers", function() { return getRawProcessedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersWithMessageSent", function() { return usersWithMessageSent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processedUsers", function() { return processedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processedUsersArray", function() { return processedUsersArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAgentPresence", function() { return getAgentPresence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQuery", function() { return getQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserByAnonymousId", function() { return getUserByAnonymousId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_embed_selectors__ = __webpack_require__("m8XX");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var root = function root(state) {
  return state.get('presence');
};

var hasPresence = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_gates_selectors__["u" /* makeHasGate */])('has_presence');

var getPresence = function getPresence(state) {
  return state.getIn(['presence', 'data']);
};

var getInterval = function getInterval(state) {
  return getPresence(state).get('interval');
};

var getBufferedUsers = function getBufferedUsers(state) {
  return getPresence(state).get('bufferedUsers');
};

var getNewLiveUsers = function getNewLiveUsers(state) {
  return getPresence(state).get('newLiveUsers');
};

var getNewLiveUsersCount = function getNewLiveUsersCount(state) {
  return getPresence(state).get('newLiveUsersCount');
};

var getCurrentIndex = function getCurrentIndex(state) {
  return getPresence(state).get('currentIndex') || 0;
};

var getPagination = function getPagination(state) {
  return getPresence(state).get('pagination');
};

var getNewFilters = function getNewFilters(state) {
  return getPresence(state).get('newFilters');
};

var getNewSorts = function getNewSorts(state) {
  return getPresence(state).get('newSorts');
};

var getShowMore = function getShowMore(state) {
  return getPresence(state).get('showMore');
};

var getFilterKnownUsers = function getFilterKnownUsers(state) {
  return getPresence(state).get('filterKnownUsers');
};

var isReceivingPresence = function isReceivingPresence(state) {
  return getPresence(state).get('toggle');
};

var getActiveStatus = function getActiveStatus(state) {
  return getPresence(state).get('activeStatus');
};

var getPresenceProblems = function getPresenceProblems(state) {
  return getPresence(state).get('presenceProblems');
};

var getPresenceLoading = function getPresenceLoading(state) {
  return getPresence(state).get('presenceLoading');
};

var getHasProcessedUsers = function getHasProcessedUsers(state) {
  return getPresence(state).get('hasProcessedUsers');
};

var processAllUsers = function processAllUsers(state) {
  return root(state).get('processAll');
};

var getRawProcessedUsers = function getRawProcessedUsers(state) {
  return root(state).get('usersProcessed');
};

var usersWithMessageSent = function usersWithMessageSent(state) {
  return getPresence(state).get('usersWithMessageSent');
};

var processedUsers = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getRawProcessedUsers, function (processedUsers) {
  return processedUsers.keySeq().toSet();
});

/**
 * Safe for passing over postMessage without having to call toJS() constantly
 */
var processedUsersArray = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(processedUsers, function (processedUsers) {
  return processedUsers.toJS();
});

var getAgentPresence = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getActiveStatus, __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__["currentUser"], function (activeStatus, user) {
  return _extends({}, activeStatus, { userId: user.id });
});

var knownContactsFilter = [{
  property: 'endUser.email',
  operation: 'HAS_PROPERTY'
}, {
  property: 'endUser.name',
  operation: 'HAS_PROPERTY'
}, {
  property: 'company.name',
  operation: 'HAS_PROPERTY'
}];

var getQuery = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getNewFilters, getNewSorts, getShowMore, __WEBPACK_IMPORTED_MODULE_3_app_modules_embed_selectors__["s" /* orgTimezone */], function (filters, _, showMore, timezone) {
  var matchAll = filters.filter(function (_val, key) {
    return key !== 'anonymousVisitors' && key !== 'location';
  }).reduce(function (acc, val, key) {
    if (val) {
      if (key === 'page.url') {
        acc.push({
          property: key,
          value: val.toLowerCase().replace(/(^\w+:|^)\/\//, ''),
          operation: 'CONTAINS'
        });
      } else if (key === 'updatedAt') {
        acc.push({
          property: key,
          value: val.toLowerCase(),
          operation: 'GTE'
        });
      } else {
        acc.push({
          property: key,
          value: val.toLowerCase(),
          operation: 'CONTAINS'
        });
      }
    }
    return acc;
  }, []);

  return {
    sorts: [{ property: 'session.activeSessionStartedAt', order: 'DESC' }],
    matchAll: matchAll.concat({ property: 'session.activeSessionStartedAt', operation: 'HAS_PROPERTY' }),
    matchAny: filters.get('anonymousVisitors') ? [] : knownContactsFilter,
    filterGroups: filters.get('location') ? [{
      negateFilterGroup: false,
      shouldMatch: 1,
      filters: [{
        property: 'location.city',
        operation: 'CONTAINS',
        value: filters.get('location').toLowerCase()
      }, {
        property: 'location.subdivision',
        operation: 'CONTAINS',
        value: filters.get('location').toLowerCase()
      }, {
        property: 'location.country',
        operation: 'CONTAINS',
        value: filters.get('location').toLowerCase()
      },
      // The following included twice as a workaround until we update the mapping to use the lowercase normalizer
      {
        property: 'location.countryName',
        operation: 'CONTAINS',
        value: filters.get('location').toLowerCase()
      },

      // This one matches if you correctly match the case ofo the stored countryName
      {
        property: 'location.countryName',
        operation: 'CONTAINS',
        value: filters.get('location')
      }]
    }] : [],
    size: showMore ? 250 : 20,
    timezone: timezone
  };
});

var getAnonymousIdProp = function getAnonymousIdProp(state, props) {
  return props.anonymousId;
};

var getUserByAnonymousId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getBufferedUsers, getAnonymousIdProp, function (users, anonymousId) {
  return users.filter(function (user) {
    return user.getIn(['meta', 'anonymousId']) === anonymousId;
  }).sortBy(function (user) {
    return user.getIn(['meta', 'userId']);
  }).first();
});

/***/ }),

/***/ "MwRK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/no-duplicates,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var MetricAPI = Marty.createStateSource({
  id: 'MetricAPI',
  type: 'http',

  fetchMetrics: function fetchMetrics(orgId) {
    return this.get({
      url: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/metric_configurations',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchMetric: function fetchMetric(metricId, startDate, endDate) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["h" /* serializeObject */])({
      startDate: startDate,
      endDate: endDate,
      periodType: 'DAY'
    });
    return this.get({
      url: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["s" /* EVENT_API */] + '/metrics/' + metricId + '/contents?' + queryParams,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (MetricAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "N+TI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export senderProperties */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fuse_js__ = __webpack_require__("z1nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_ClearbitProperties__ = __webpack_require__("uwTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component__ = __webpack_require__("CKnD");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















/* TODO: remove this code once account attributes are pulled in from Account API */
var ExtraProperty = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  name: null,
  displayName: null,
  displayNamespace: __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER,
  requiresABM: false
});

var extraProperties = [new ExtraProperty({ 'name': 'account.name', 'displayName': 'Account Name', 'displayNamespace': __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER, requiresABM: true })];
/* END TODO */

var senderProperties = [{ name: 'sender.name', displayName: 'Full Name' }, { name: 'profile.jobTitle', displayName: 'Title' }, { name: 'org.name', displayName: 'Company Name' }, { name: 'org.url', displayName: 'Company Website URL' }, { name: 'org.address', displayName: 'Company Address' }, { name: 'profile.location', displayName: 'Profile Location' }, { name: 'sender.email', displayName: 'Email' }, { name: 'org.twitterLink', displayName: 'Team Twitter Link' }, { name: 'org.linkedInLink', displayName: 'Team Linkedin Link' }, { name: 'org.facebookLink', displayName: 'Team Facebook Link' }, { name: 'profile.phoneNumber', displayName: 'Phone Number' },
//  { name: 'sender.profile_link', displayName: 'Profile Link' }, TODO
{ name: 'profile.twitterHandle', displayName: 'User Twitter' }, { name: 'profile.instagramHandle', displayName: 'User Instagram' }, { name: 'profile.linkedInHandle', displayName: 'User Linkedin' }, { name: 'profile.facebookHandle', displayName: 'User Facebook' }].map(function (attr) {
  return new ExtraProperty(_extends({ displayNamespace: __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].SENDER }, attr));
});

var tokenStringFromProperty = function tokenStringFromProperty(property, namespace) {
  var tokenString = '';
  if (!property.displayNamespace) {
    tokenString = namespace + '.';
  }
  return '' + tokenString + property.get('name');
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProperties: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_attribute_selectors__["c" /* properties */])(state).toArray(),
    hideClearbitTab: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state) || __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_48" /* isSignaturePlaybook */](state),
    senderTokensOnly: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_48" /* isSignaturePlaybook */](state),
    hasClearbitEnabled: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_26" /* hasEnterpriseActions */](state),
    hasABM: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["u" /* makeHasGate */])('ABM')(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchAttributes: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      hideTokenModal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_91" /* hideTokenModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    if (!this.props.senderTokensOnly) this.props.actions.fetchAttributes();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('selectedProperty', 'setSelectedProperty', undefined), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('selectedNamespace', 'setSelectedNamespace', undefined), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('selectedTab', 'setSelectedTab', function (props) {
  return props.senderTokensOnly ? __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].SENDER : __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER;
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('modalStep', 'setModalStep', __WEBPACK_IMPORTED_MODULE_12__component__["c" /* TokenModalSteps */].SELECT), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('search', 'setSearch', ''), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('defaultValue', 'setDefaultValue', undefined), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  onPropertySelect: function onPropertySelect(props) {
    return function (name, namespace) {
      var selectedProperty = extraProperties.filter(function (prop) {
        return prop.displayNamespace === __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER;
      }).filter(function (prop) {
        return !prop.requiresABM || props.hasABM;
      }).concat(props.userProperties).concat(senderProperties).find(function (property) {
        return property.get('name') === name;
      });
      props.setSelectedNamespace(namespace);
      props.setSelectedProperty(selectedProperty);
      props.setModalStep(__WEBPACK_IMPORTED_MODULE_12__component__["c" /* TokenModalSteps */].CONFIRM);
    };
  },
  onDefaultConfirm: function onDefaultConfirm(props) {
    return function () {
      props.setModalStep(__WEBPACK_IMPORTED_MODULE_12__component__["c" /* TokenModalSteps */].SELECT);
      var editor = window.tinymce.activeEditor;
      var defaultValue = props.defaultValue ? ' or "' + props.defaultValue + '"' : '';
      editor.insertContent('<span' + (props.senderTokensOnly ? '' : ' class="drift-editor-tag mceNonEditable"') + '>{{ ' + tokenStringFromProperty(props.selectedProperty, props.selectedNamespace) + defaultValue + ' }}</span>');
      props.actions.hideTokenModal();
    };
  },
  onClearbitTabClick: function onClearbitTabClick(props) {
    return function () {
      props.hasClearbitEnabled && props.setSelectedTab(__WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].CLEARBIT);
    };
  },
  onUserTabClick: function onUserTabClick(props) {
    return function () {
      props.setSelectedTab(__WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER);
    };
  },
  hideTokenModal: function hideTokenModal(props) {
    return function () {
      // may be duplicative of Cancel handler below... - pk2
      props.setSelectedNamespace(undefined);
      props.setSelectedProperty(undefined);
      props.setDefaultValue(undefined);
      props.setModalStep(__WEBPACK_IMPORTED_MODULE_12__component__["c" /* TokenModalSteps */].SELECT);
      props.actions.hideTokenModal();
    };
  },
  onDefaultCancel: function onDefaultCancel(props) {
    return function () {
      props.setSelectedNamespace(undefined);
      props.setSelectedProperty(undefined);
      props.setDefaultValue(undefined);
      props.setModalStep(__WEBPACK_IMPORTED_MODULE_12__component__["c" /* TokenModalSteps */].SELECT);
    };
  },
  onSearchChange: function onSearchChange(props) {
    return function (event) {
      props.setSearch(event.target.value);
    };
  },
  onDefaultChange: function onDefaultChange(props) {
    return function (event) {
      // make sure to escape double quotes
      props.setDefaultValue(event.target.value.replace('"', '\\"'));
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function () {
      // props.setModalOpen(false)
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  var userProperties = extraProperties.filter(function (prop) {
    return prop.displayNamespace === __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER;
  }).filter(function (prop) {
    return !prop.requiresABM || props.hasABM;
  }).concat(props.userProperties);
  if (!props.search) {
    return {
      clearbitProperties: __WEBPACK_IMPORTED_MODULE_11_constants_ClearbitProperties__["a" /* default */],
      userProperties: userProperties,
      senderProperties: senderProperties
    };
  } else {
    var fuseConfig = { keys: ['displayName', 'name'] };
    var userFuse = new __WEBPACK_IMPORTED_MODULE_4_fuse_js___default.a(userProperties, fuseConfig);
    var clearbitFuse = new __WEBPACK_IMPORTED_MODULE_4_fuse_js___default.a(__WEBPACK_IMPORTED_MODULE_11_constants_ClearbitProperties__["a" /* default */], fuseConfig);
    var senderFuse = new __WEBPACK_IMPORTED_MODULE_4_fuse_js___default.a(senderProperties, fuseConfig);
    return {
      userProperties: userFuse.search(props.search),
      clearbitProperties: clearbitFuse.search(props.search),
      senderProperties: senderFuse.search(props.search)
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    noPropertiesShown: props.selectedTab === __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].USER && props.userProperties.length === 0 || props.selectedTab === __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].CLEARBIT && props.clearbitProperties.length === 0 || props.selectedTab === __WEBPACK_IMPORTED_MODULE_12__component__["b" /* PropertyNamespaces */].SENDER && props.senderProperties.length === 0
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (_ref) {
  var noPersonalization = _ref.noPersonalization;
  return noPersonalization;
}, __WEBPACK_IMPORTED_MODULE_3_recompose__["g" /* renderNothing */]), __WEBPACK_IMPORTED_MODULE_5_react_onclickoutside_decorator___default.a)(__WEBPACK_IMPORTED_MODULE_12__component__["a" /* EditorTokenModal */]));

/***/ }),

/***/ "N/SQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  getApiKeyForOrg: function getApiKeyForOrg(orgId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/organizations/' + orgId + '/api_keys').map(function (res) {
      return res.response;
    });
  },
  createApiKeyForOrg: function createApiKeyForOrg(orgId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].post('/organizations/' + orgId + '/api_keys', { isProd: true }).map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "N0ey":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/snooze.618b25e8.png";

/***/ }),

/***/ "N1pB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_HoverAvatar__ = __webpack_require__("PTbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__ = __webpack_require__("aLj5");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var UserSelect = function (_Component) {
  _inherits(UserSelect, _Component);

  function UserSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSelect.__proto__ || Object.getPrototypeOf(UserSelect)).call.apply(_ref, [this].concat(args))), _this), _this.renderOptionUser = function (value) {
      return _this.userRenderer(value && value.userId);
    }, _this.renderValueUser = function (option) {
      return _this.userRenderer(option[0] && option[0].userId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserSelect, [{
    key: 'userRenderer',
    value: function userRenderer(userId) {
      var users = this.props.users;


      if (typeof userId === 'undefined') return;
      var user = users[userId];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_HoverAvatar__["a" /* default */], { user: user, size: 'extra-small', style: { marginRight: 4 } }),
        user.name || user.email
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedUserId = _props.selectedUserId,
          users = _props.users,
          onChange = _props.onChange;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__["b" /* default */], {
        searchable: false,
        value: [{ userId: selectedUserId, isInTree: true }],
        options: Object.keys(users).map(function (userId) {
          return { userId: userId };
        }),
        optionRenderer: this.renderOptionUser,
        valueRenderer: this.renderValueUser,
        className: 'full-width',
        onChange: onChange
      });
    }
  }]);

  return UserSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_container__["a" /* makeDefaultFailedContainer */])(UserSelect, {
  listenTo: ['stores.UserStore'],
  fetch: {
    users: function users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg();
    }
  }
}));

/***/ }),

/***/ "N30b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_MapAPI__ = __webpack_require__("+gtz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_customer_CompanyCard_CancelAndSave__ = __webpack_require__("h2QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getGradient__ = __webpack_require__("wIyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_colors__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Banner = function (_Component) {
  _inherits(Banner, _Component);

  function Banner() {
    _classCallCheck(this, Banner);

    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
  }

  _createClass(Banner, [{
    key: 'getTime',
    value: function getTime() {
      var timeZone = this.props.timeZone;

      return !!timeZone && __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()().tz(timeZone);
    }
  }, {
    key: 'getDisplayTime',
    value: function getDisplayTime() {
      var time = this.getTime();
      return !!time && time.format('h:mm A z');
    }
  }, {
    key: 'renderLinks',
    value: function renderLinks() {
      var _props = this.props,
          editing = _props.editing,
          editable = _props.editable,
          handleEdit = _props.handleEdit,
          handleSave = _props.handleSave,
          handleCancel = _props.handleCancel,
          changed = _props.changed,
          updating = _props.updating;

      if (editable) {
        return editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_customer_CompanyCard_CancelAndSave__["a" /* default */], {
          updating: updating,
          changed: changed,
          onCancel: handleCancel,
          onSave: handleSave
        }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'edit link dsg-Body', onClick: handleEdit },
          'Edit'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editing = _props2.editing,
          longitude = _props2.longitude,
          latitude = _props2.latitude,
          displayLocation = _props2.displayLocation,
          handleEdit = _props2.handleEdit,
          editable = _props2.editable,
          endUser = _props2.endUser;

      var _getGradient = Object(__WEBPACK_IMPORTED_MODULE_5__getGradient__["a" /* default */])(this.getTime(), .8),
          _getGradient2 = _slicedToArray(_getGradient, 2),
          leftColor = _getGradient2[0],
          rightColor = _getGradient2[1];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'banner',
          style: {
            height: editing ? '75px' : '85px',
            backgroundImage: longitude && latitude ? 'url(' + Object(__WEBPACK_IMPORTED_MODULE_3_app_api_MapAPI__["a" /* getMapURL */])(latitude, longitude, 320, 120) + ')' : undefined,
            borderBottom: '2px solid ' + __WEBPACK_IMPORTED_MODULE_6_styles_colors___default.a['color-navy-light'],
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            transition: 'all .4s ease-in-out'
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'flex-column',
            style: {
              justifyContent: 'space-around',
              alignItems: 'flex-end',
              height: '100%',
              width: '100%',
              borderTopLeftRadius: '3px',
              borderTopRightRadius: '3px',
              backgroundImage: 'linear-gradient(to right, ' + leftColor + ', ' + rightColor + ')',
              paddingRight: '24px',
              position: 'relative'
            }
          },
          this.renderLinks(),
          !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { paddingBottom: '7px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'dsg-Body color-white flex-end dsg-medium-weight' },
              this.getDisplayTime()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: 'dsg-Regular color-white flex-end dsg-medium-weight',
                onClick: editable && !displayLocation && handleEdit
              },
              displayLocation || editable && 'Add Location'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], {
            user: endUser,
            size: 'extra-large',
            style: {
              position: 'absolute',
              top: editing ? '12px' : '65px',
              left: '14px',
              transition: 'all .4s ease-out'
            }
          })
        )
      );
    }
  }]);

  return Banner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Banner);

/***/ }),

/***/ "N4Vs":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.78 11.718a6.65 6.65 0 0 0 .096-1.215 6.65 6.65 0 0 0-.097-1.215l2.015-1.75a.373.373 0 0 0 .122-.46 10.02 10.02 0 0 0-1.993-3.45c-.12-.147-.29-.196-.46-.123l-2.528.875a7.833 7.833 0 0 0-2.09-1.215L12.336.54a.413.413 0 0 0-.34-.34A10.002 10.002 0 0 0 8.01.2a.413.413 0 0 0-.34.34l-.51 2.625A7.473 7.473 0 0 0 5.07 4.38l-2.526-.875c-.17-.073-.34-.024-.462.122A10.02 10.02 0 0 0 .09 7.077a.373.373 0 0 0 .12.462L2.23 9.287a6.65 6.65 0 0 0-.098 1.215c0 .413.025.826.098 1.215L.21 13.468a.373.373 0 0 0-.12.46A10.02 10.02 0 0 0 2.08 17.38c.12.145.29.194.462.12l2.527-.874c.608.51 1.337.924 2.09 1.215l.51 2.625c.025.17.17.316.34.34.657.122 1.313.195 1.993.195.68 0 1.337-.073 1.993-.194a.413.413 0 0 0 .34-.34l.51-2.625a7.833 7.833 0 0 0 2.09-1.214l2.527.875c.17.074.34.025.46-.12a10.02 10.02 0 0 0 1.994-3.45.373.373 0 0 0-.122-.463l-2.016-1.75zM6.066 10.503a3.935 3.935 0 0 1 3.936-3.936 3.95 3.95 0 0 1 3.937 3.936 3.935 3.935 0 0 1-3.937 3.936 3.92 3.92 0 0 1-3.936-3.937z\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "N53e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__ = __webpack_require__("lMLN");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var IntegrationsActions = Marty.createActionCreators({
  createAccessToken: function createAccessToken(name, body) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN, name, body);
  },
  updateIntegrationState: function updateIntegrationState(properties) {
    return this.app.queries.IntegrationsQueries.updateIntegrationState(properties);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "N6sL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N6zH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N748":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N7zt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BotAvatarPreviewContainer":"BotAvatarPreviewContainer---24T__","BotAvatarPicker__Preview":"BotAvatarPicker__Preview---3fH7L","BotAvatarPicker__Loading":"BotAvatarPicker__Loading---3rBtl"};

/***/ }),

/***/ "N88K":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/outreach-logo-text.0a77a7ae.svg";

/***/ }),

/***/ "N98/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_TagColorSelector_styl__ = __webpack_require__("sCqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_TagColorSelector_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_TagColorSelector_styl__);


/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var SUBMIT_IMAGES_BY_COLOR = ['FF876B', '13CB6E', '00E0FF', '2D8EFF', 'EA81FF', '7695A5', 'E95330', '1F9A57', '009AB0', '0960C5', 'A60087', '394F5A'];

var TagColorSelector = React.createClass({
  displayName: 'TagColorSelector',


  propTypes: {
    colorClicked: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
  },

  onColorClick: function onColorClick(tagColor) {
    return this.props.colorClicked(tagColor);
  },
  render: function render() {
    var _this = this;

    return React.createElement(
      'div',
      { className: 'TagColorSelector' },
      React.createElement(
        'div',
        { className: 'tag-colors' },
        _.map(SUBMIT_IMAGES_BY_COLOR, function (tagColor) {
          return React.createElement('div', {
            key: tagColor,
            onClick: _this.onColorClick.bind(_this, tagColor),
            className: 'tag-color',
            style: {
              backgroundColor: '#' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_TagAppearanceHelper__["a" /* getNormalizedTagColor */])(tagColor),
              color: 'var(--main-navy-extra-dark)'
            } });
        })
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TagColorSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "NBzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__ = __webpack_require__("JMAf");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchUserPropertiesPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchUserPropertiesCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchUserPropertiesFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveUserProperties */]), function (state, action) {
  return state.set('fetch', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* updateUserPropertiesPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* updateUserPropertiesCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* updateUserPropertiesFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveUserProperties */]), function (state, action) {
  return state.set('update', action.type);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  fetch: null,
  update: null
}));

var data = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* receiveUserProperties */], function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["o" /* updateUserPropertiesPending */], function (state, action) {
  return state.merge(action.payload);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__["turnOffManualAwaySuccess"], function (state) {
  return state.merge({ 'auto-away': true });
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["q" /* userAtConversationLimitUpdate */], function (state, action) {
  return state.merge({ 'atConversationLimit': action.payload });
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var usersByPropertyName = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchUsersByPropertyNameSuccess */], function (state, action) {
  return state.merge(action.payload);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  status: status,
  data: data,
  usersByPropertyName: usersByPropertyName
}));

/***/ }),

/***/ "NJAK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("gA9W");











var mapStateToProps = function mapStateToProps(state) {
  return {
    userListIds: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    draftId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["p" /* draftId */](state),
    isSaved: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_46" /* isSaved */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_151" /* setDraftStatus */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('sendEmailButtonActive', 'setEmailButtonActive', true), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('emailButtonLabel', 'setEmailButtonLabel', 'Send Email'), Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["c" /* getContext */])({
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    hasSegmentsSelected: !!props.userListIds && props.userListIds.size
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  onClick: function onClick(props) {
    return function () {
      var setDraftStatus = props.actions.setDraftStatus,
          setEmailButtonLabel = props.setEmailButtonLabel,
          setEmailButtonActive = props.setEmailButtonActive,
          onClickConfirm = props.onClickConfirm;

      if (!onClickConfirm || onClickConfirm()) {
        setEmailButtonActive(false);
        setEmailButtonLabel('Sending...');
        setDraftStatus({ status: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT });
        setTimeout(function () {
          var path = props.isMarketingSequencePlaybook ? '/reports/playbooks/' + props.draftId : '/reports/chat-playbooks/' + props.draftId;
          window.location.pathname = path;
        }, 1000);
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "NL/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__ = __webpack_require__("ySI2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var UserPropertiesQueries = Marty.createQueries({
  id: 'UserPropertiesQueries',

  fetchProperties: function fetchProperties(userId) {
    var _this = this;

    var promise = this.app.sources.UserPropertiesAPI.fetchProperties(userId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].FETCH_USER_PROPERTIES_DONE, userId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].FETCH_USER_PROPERTIES_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].FETCH_USER_PROPERTIES_FAILED, error);
    });
  },
  updateProperties: function updateProperties(userId, properties, notificationMessage) {
    var _this2 = this;

    var promise = this.app.sources.UserPropertiesAPI.updateProperties(userId, properties);

    promise.then(function (res) {
      if (res.status === 200) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_DONE, userId, res.body, properties);
        if (notificationMessage) {
          return _this2.app.actions.NotificationActions.pushNotification({
            content: notificationMessage
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_FAILED, userId, properties, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserPropertiesConstants__["a" /* default */].UPDATE_USER_PROPERTIES_FAILED, userId, properties, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserPropertiesQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "NNVj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NOHI":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 24H1a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2zm-8-4c-4.187 0-7-2.813-7-7V1a1 1 0 0 1 2 0v12c0 3.084 1.916 5 5 5s5-1.916 5-5V1a1 1 0 0 1 2 0v12c0 4.187-2.813 7-7 7z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "NOUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_rx__ = __webpack_require__("ukvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_RouterHelpers__ = __webpack_require__("8uzH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_containers_AppContainer__ = __webpack_require__("oTiO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_store__ = __webpack_require__("Tvnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_perf__ = __webpack_require__("c+Ld");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_perf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_addons_perf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_main_styl__ = __webpack_require__("60Pi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_main_styl__);















if (__ENV__ !== 'PRODUCTION') {
  window.Perf = __WEBPACK_IMPORTED_MODULE_11_react_addons_perf___default.a;
  window.api = __webpack_require__("qwEQ");
  window.Immutable = __webpack_require__("BYKG");
  window.store = __WEBPACK_IMPORTED_MODULE_10_containers_store__["a" /* default */];
}

// trick SDK into thinking FullStory is loaded
window._fs_namespace = 'FS';

var history = Object(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_7_app_RouterHelpers__["a" /* appHistory */], __WEBPACK_IMPORTED_MODULE_10_containers_store__["a" /* default */], {
  selectLocationState: __WEBPACK_IMPORTED_MODULE_6_app_modules_router_selectors__["b" /* locationState */]
});

function main() {
  window.__DRIFT__recordBootstrapCheckpoint('main.willRenderReactApp');

  var createRoutes = __webpack_require__("Vskm").default;

  var routes = createRoutes(__WEBPACK_IMPORTED_MODULE_10_containers_store__["a" /* default */]);
  Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_containers_AppContainer__["a" /* default */], {
    app: __WEBPACK_IMPORTED_MODULE_9_containers_app__["a" /* default */],
    history: history,
    store: __WEBPACK_IMPORTED_MODULE_10_containers_store__["a" /* default */],
    routes: routes
  }), document.getElementById('app'));
}

Object(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["LoadStyles"])();
main();

/***/ }),

/***/ "NOwD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("d0nC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("khns");








function fetchClassifications(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* fetchClassifications */].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetch().map(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchClassificationsSuccess */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* fetchClassificationsFailed */]());
    });
  });
}

function createClassifications(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* createClassifications */].toString()).pluck('payload').mergeMap(function (classifications) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].create(classifications).map(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createClassificationsSuccess */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createClassificationsFailed */]());
    });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchClassifications, createClassifications);

/***/ }),

/***/ "NP6h":
/***/ (function(module, exports) {

module.exports = "<svg width=\"29\" height=\"29\" viewBox=\"0 0 29 29\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 29C6.505 29 0 22.495 0 14.5S6.505 0 14.5 0 29 6.505 29 14.5 22.495 29 14.5 29zm0-27.188C7.504 1.813 1.812 7.505 1.812 14.5c0 6.996 5.692 12.688 12.688 12.688S27.188 21.495 27.188 14.5c0-6.995-5.692-12.688-12.688-12.688zM23.177 12.3l-3.696 3.76c.003 0-.01.058-.01.084l1.43 5.05c.153.544-.032.9-.154 1.062-.194.254-.49.4-.815.4-.242 0-.485-.08-.72-.242l-4.71-3.22-4.706 3.218c-.558.38-1.203.288-1.54-.157-.122-.163-.307-.52-.154-1.06l1.436-5.076c-.003 0-.02-.06-.033-.08l-3.68-3.74c-.354-.363-.473-.83-.318-1.25.154-.42.545-.697 1.046-.742l4.894-.457c-.01-.002.035-.034.05-.054l1.952-4.507c.206-.475.6-.76 1.054-.76.456 0 .85.285 1.055.762l1.967 4.532c0-.008.044.024.067.032l4.86.45c.503.048.895.327 1.048.748.153.42.034.885-.32 1.245zm-5.788-.645c-.64-.06-1.28-.528-1.532-1.114L14.5 7.414l-1.358 3.132c-.253.584-.896 1.05-1.528 1.11l-3.555.332 2.753 2.8c.444.45.64 1.22.466 1.827l-.908 3.207 3.153-2.156c.27-.187.618-.29.975-.29s.704.103.977.29l3.153 2.157-.907-3.208c-.175-.604.02-1.373.467-1.825l2.753-2.8-3.554-.332z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "NUAQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIIAAACWCAMAAAAlmqBCAAAAkFBMVEX7+/tbRLD///5VPK5XP69RN6yckcz///9TOq2Qg8iBcr9/b79TOa1YQK/y8feWisrAud/49/zx7/lPNKyqodOFeMG6stylm9Czq9f5+fyek82LfsOgls3HweLOyOipoNLZ1O51Y7xiTLPf3PBLLqpiTbPo5fR4Z7xsWrdGJ6mYi87r6PXCvN56ar7a1u1pVrbyEKI3AAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+MDEg0DLYeeuq0AAARVSURBVHja7dzpYqo6EABgkhABS1gFQUVBltojte//dgdrvbdWtoQl2gO/W/o1mWGwzYwgDHZBKHC+oJHxRsA/aGnxNcCZrB48jScC6ggQOzpJkCsBAJJEhg+5bcSZAICoOjEnxJUAAFL1jDMBAHm/9CW+BABwaowfl7cEAOxDMPZj4ifhnKHhuM/LO0KRHPZ82wmh0X13CaFAID1mjwnouXFR/WAnQpEc8jJjNcDFG3pdnay2igoCACrYmJCRIAOCEqBsM7ON4vKALr3wh8GUHHAnf8Y1sveOZzUHRlGsqwhFcrwaDDVUWsrXG4hqcpjFfv1y1hGKuMTzkDoupY38/fdA+EPPJal6MWo24oKQFdrkuCVctgQ7XuhXxCdU6gmf5YtuN6TSPMf4MMuzMkUzochQstC6Ei6LkSrGfa63IQCi9kH4XFKchJCFAAjsiVDUwYA7AedjEGqTDBvPTWhbdhoILjsBhqfj+SEHBciL4M8SMVrPglg7FgWwZkUGJKyKGiwWiQ0+nJUbWtAXyiVDEtD/hQPbOH3X8+BUUs7rCarXIRzvXnQRtu19tP15S0kZjfD1tDMoCYsOhPL1xSMS/AqCOw5BrCEYIxIUkTdBWE8ECgIs/8KOBOQXseC0JThDEcx1LwS5C8GZCPwJ5pAEvRVBezLC/FcTyIMSVJeSsHvqVbD4x8JEeBTCfCJMhIJg9UZQByC4IxLKk1J1ua8CdZlasoYj5E6weiOghyTMxo6FDSNB6y0j/hnCy3AEMhGqCPgBCMZEGJsg/hICc42YCBPhGsZUnyMmwkR4FoI8ACF/OgL6nYSAO8HePiJhPlQ4avwJ5u8h7NjfFzgTZLOaEFL+ucubCMMQ4ockkHEJSXb/39qhCP4dgSCMU+XuWOxwq/CDIMp4r3ih5QtcCMWPB8omyMoPVw+3EealBhNkg5ddmEmVRx6HJSAMoo2R1Z1wbzxO02UjXt/SdZ5pftMR2OEIQnA0pVYtF7SEldyCoJpC++ZPasIGtSW0Pgdde7oLMxLQEfZEIAnnVSDJYZEJbOFo9UFA+CW07iMKrtoQbK07QSbroLR9qBXBdrquAsH71amiZbQNwfaomrjuCWISLaq7uJoJIggoO4ZuCQTJTlDX8NMYjnJ0omycuiEQG+gNrVdNhGRN3T/27ewrST5yramZoZ5AsEffyyetv24p2/M23aG1BHEfMLT7fhEwWsat/HUEHMUsnYTnjRBxusi69lMWuaizteJDHdvr4Ni6rbQyKQlasLZ0ruYGRV9rJUEEW4H1OtLZKwhqlLH3GEPaVSt7a7KVEfu9ywgEL8YcQlBCENPtuN3mdwSVuij0TRg1DMoIxA5Gn0VxS0D77fjDMG4I6mvMYRzHd4KtcxkSAz31Ggayx2ckyX8ElAacBrNcCfg95jYa5kJIdH6zgqCHz2GQ+xxn9BQElG65TipyMX7PuA5sgu6bzntkVM76itjf1fZj+19cmIDu328dIQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "NVJO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"WidgetModeSelector":"WidgetModeSelector---1tInT"};

/***/ }),

/***/ "NYrp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AssignDropdown":"AssignDropdown---1Nmv0"};

/***/ }),

/***/ "NZ+S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {/* harmony export (immutable) */ __webpack_exports__["c"] = fetchTargets;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchTarget;
/* harmony export (immutable) */ __webpack_exports__["a"] = createTarget;
/* harmony export (immutable) */ __webpack_exports__["d"] = patchTarget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var BASE = __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["i" /* CONVERSATION_API */] + '/targets';

function fetchTargets() {
  var request = fetch(BASE, {
    method: 'GET',
    headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
  });
  return request.then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('Failed to get targets');
    }
  });
}

function fetchTarget(id) {
  var request = fetch(BASE + '/' + id, {
    method: 'GET',
    headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
  });
  return request.then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('Failed to get target');
    }
  });
}

function createTarget(target) {
  var request = fetch(BASE, {
    method: 'POST',
    headers: _extends(Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(), __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["a" /* PostJsonHeaders */]),
    body: JSON.stringify(target)
  });
  return request.then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('Failed to create target');
    }
  });
}

function patchTarget(operations, id) {
  var request = fetch(BASE + '/' + id, {
    method: 'PATCH',
    headers: _extends(Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(), __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["a" /* PostJsonHeaders */]),
    body: JSON.stringify(operations)
  });

  return request.then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('Failed to update target');
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V")))

/***/ }),

/***/ "NZKz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NgrA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterEditor___ = __webpack_require__("jbvk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionEditor___ = __webpack_require__("VQ/G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NewRuleConfirmation___ = __webpack_require__("RP1A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__ = __webpack_require__("4PhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ADD_FILTER = 'ADD';

var RulesEditor = function (_Component) {
  _inherits(RulesEditor, _Component);

  function RulesEditor(props) {
    _classCallCheck(this, RulesEditor);

    var _this = _possibleConstructorReturn(this, (RulesEditor.__proto__ || Object.getPrototypeOf(RulesEditor)).call(this, props));

    _this.getNextButtonText = function () {
      if (_.get(_this.props, 'activeFilter.field') === 'salesforceOwner') {
        switch (_this.props.activePage) {
          case 'newRuleConfirmation':
            return 'Publish';
          default:
            return 'Continue';
        }
      } else {
        switch (_this.props.activePage) {
          case 'newRuleConfirmation':
            return 'Publish';
          default:
            return 'Save and Continue';
        }
      }
    };

    _this.onPublish = function () {
      var notifyAndReroute = function notifyAndReroute(msg) {
        return function () {
          _this.props.notifications.success(msg);
          _this.context.router.push('/settings/rules');
        };
      };

      _this.setState({ ruleIsSaving: true });

      var publishSFDCSettings = function publishSFDCSettings() {
        __WEBPACK_IMPORTED_MODULE_7_app_modules_sfdc_api__["a" /* api */].patchSalesforceLeadRoutingSettings(_this.props.salesforceLeadRoutingSettings);
      };

      var publishSFDCToggles = function publishSFDCToggles() {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_api__["L" /* patchSalesforceToggles */])(_this.props.salesforceLeadRoutingToggles);
      };

      if (_this.state.saveSFDCSettings === true) {
        publishSFDCSettings();
      }

      if (_this.state.saveSFDCToggles === true) {
        publishSFDCToggles();
      }

      if (_this.isEditing()) {
        __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].editRule(_this.props.rule.data.item, _this.props.rule.data.item.id).then(notifyAndReroute('Your rule was successfully updated!'));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].createRule(_this.props.rule.data.item).then(notifyAndReroute('You\'ve successfully created a new rule!'));
      }
    };

    _this.shouldPublishLeanDataRule = function () {
      var _this$props = _this.props,
          activeFilter = _this$props.activeFilter,
          activePage = _this$props.activePage;


      return activeFilter && activeFilter.field && activeFilter.field === 'leandata' && activePage === 'filterEditor';
    };

    _this.publishLeanDataRule = function () {
      var notifyAndReroute = function notifyAndReroute(msg) {
        return function () {
          _this.props.notifications.success(msg);
          _this.context.router.push('/settings/rules');
        };
      };

      var ruleData = _this.props.rule.data.item;

      ruleData.name = 'LeanData Rule';

      _this.setState({
        ruleIsSaving: true
      });
      if (_this.isEditing()) {
        __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].editRule(ruleData, ruleData.id).then(notifyAndReroute('Your rule was successfully updated!'));
      } else {
        __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_api__["a" /* api */].createRule(ruleData).then(notifyAndReroute('You\'ve successfully created a new rule!'));
      }
    };

    _this.saveAndGetNextActivePage = function () {
      var thereAreFilters = _this.props.rule.data.item.conditions[0] && _this.props.rule.data.item.conditions[0].length;

      var isAvailabilityRule = _this.props.rule.data.item.id && (_this.props.rule.data.item.conditions.length === 0 || _this.props.rule.data.item.conditions[0].length === 0) || _this.props.activeFilter.field === 'onlineUsers';

      if (_this.shouldPublishLeanDataRule()) {
        _this.publishLeanDataRule();
        return 'filterEditor';
      }

      switch (_this.props.activePage) {
        case 'filterEditor':
          if (_this.props.activeFilter !== 'ADD') {
            _this.props.saveActiveFilter();
          }
          return 'actionEditor';
        case 'actionEditor':
          if (isAvailabilityRule) {
            _this.props.saveActiveFilter();
            return 'newRuleConfirmation';
          }
          return thereAreFilters ? 'newRuleConfirmation' : 'filterEditor';
        case 'newRuleConfirmation':
          _this.onPublish();
          return 'newRuleConfirmation';
        default:
          return 'filterEditor';
      }
    };

    _this.onSave = function () {
      _this.props.setActivePage(_this.saveAndGetNextActivePage());
    };

    _this.onPrevious = function () {
      if (_.get(_this.props, 'activeFilter.field') === 'salesforceOwner' || _.get(_this.props, 'activeFilter.field') === 'targetedAccounts') {
        _this.props.resetActiveRuleAction(_this.props.rule);
      }

      var getLastValidFilter = function getLastValidFilter() {
        var addConditions = _.head(_this.props);
        return _.last(addConditions);
      };

      var processAndGetPrevious = function processAndGetPrevious() {
        switch (_this.props.activePage) {
          case 'filterEditor':
            _this.props.activeFilter === ADD_FILTER ? _this.props.setActiveFilter(getLastValidFilter()) : _this.props.setActiveFilter(ADD_FILTER);
            return 'filterEditor';
          case 'actionEditor':
            return 'filterEditor';
          case 'newRuleConfirmation':
            return 'actionEditor';
          default:
            return 'filterEditor';
        }
      };

      _this.props.setActivePage(processAndGetPrevious());
    };

    _this.shouldShowNavigation = function () {
      var hasNoFilters = !(_this.props.rule.data.item.conditions[0] && _this.props.rule.data.item.conditions[0].length);
      return !(_this.props.activePage === 'filterEditor' && _this.props.activeFilter === 'ADD' && hasNoFilters);
    };

    _this.canSave = function () {
      var ruleIsSaving = _this.state.ruleIsSaving;


      return !ruleIsSaving && (_this.props.currentPageIsValid || _this.props.activePage === 'filterEditor' && _this.props.activeFilter === 'ADD');
    };

    _this.isEditing = function () {
      return !!_this.props.rule.data.item.id;
    };

    _this.state = {
      saveSFDCSettings: false,
      saveSFDCToggles: false,
      ruleIsSaving: false
    };
    return _this;
  }

  _createClass(RulesEditor, [{
    key: 'getEditorComponent',
    value: function getEditorComponent() {

      var components = {
        'filterEditor': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__FilterEditor___["a" /* default */], this.props),
        'actionEditor': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ActionEditor___["a" /* default */], this.props),
        'newRuleConfirmation': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__NewRuleConfirmation___["a" /* default */], this.props)
      };

      return components[this.props.activePage];
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          salesforceLeadRoutingSettings = _props.salesforceLeadRoutingSettings,
          salesforceLeadRoutingToggles = _props.salesforceLeadRoutingToggles;


      if (salesforceLeadRoutingSettings !== prevProps.salesforceLeadRoutingSettings) {
        this.setState({ saveSFDCSettings: true });
      }

      if (salesforceLeadRoutingToggles !== prevProps.salesforceLeadRoutingToggles) {
        this.setState({ saveSFDCToggles: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var ruleIsSaving = this.state.ruleIsSaving;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-editor' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-breadcrumbs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: '/settings/rules', className: 'breadcrumb-back' },
              'Team Settings / Conversation Routing'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h1',
              null,
              this.isEditing() ? 'Edit your rule' : 'Create a new rule'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'header-right-nav' },
            this.shouldShowNavigation() && !(_.get(this.props, 'activeFilter.field') === 'salesforceOwner') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'previous-step-button', onClick: this.onPrevious },
              '< Previous Step'
            ),
            this.shouldShowNavigation() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
              { type: 'primary', loading: ruleIsSaving, onClick: this.onSave, disabled: !this.canSave() },
              this.getNextButtonText()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: '/settings/rules', className: 'drift-button' },
              'Close'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          null,
          this.getEditorComponent()
        )
      );
    }
  }]);

  return RulesEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RulesEditor.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_components_shared_notifications__["a" /* default */])(RulesEditor));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "NiPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontFamilies; });
var FontFamilies = {
  Arial: 'Arial',
  TimesNewRoman: 'Times New Roman',
  Helvetica: 'Helvetica',
  Georgia: 'Georgia',
  Brandon: 'Brandon Text',
  Lato: 'Lato',
  OpenSans: 'Open Sans',
  Roboto: 'Roboto',
  RobotoSlab: 'Roboto Slab',
  Overpass: 'Overpass'
};

/***/ }),

/***/ "Niip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"campaign-segment-option":"campaign-segment-option---fSMuK","DeliveryTimeFrame":"DeliveryTimeFrame---XDhVO","Disclaimer":"Disclaimer---1LMRt","TargetingAudience":"TargetingAudience---1ovUf","EmailFallBackDaysInput":"EmailFallBackDaysInput---2To-Y"};

/***/ }),

/***/ "NivL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_CampaignWizards_TargetingInputArea_TargetConditionInput__ = __webpack_require__("xfIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_TargetingInputArea_MultiSegmentSelect__ = __webpack_require__("LFxc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Customize_Audience_Helpers__ = __webpack_require__("vMoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("SCc4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















function updateAudience(initialOrgSettings, audience, index, value) {
  var orgSettings = initialOrgSettings.setIn(['theme', 'audience'], audience);

  if (audience === __WEBPACK_IMPORTED_MODULE_9_components_Customize_Audience_Helpers__["a" /* Audiences */].SEGMENT.key) {
    if (!!value) {
      return orgSettings.setIn(['theme', 'userListIds', index], value);
    } else {
      return orgSettings.deleteIn(['theme', 'userListIds', index]);
    }
  } else {
    return orgSettings.setIn(['theme', 'userListIds'], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])());
  }
}

function maybeUnsetUserListIds(orgSettings) {
  var _orgSettings$theme = orgSettings.theme,
      userListIds = _orgSettings$theme.userListIds,
      audience = _orgSettings$theme.audience;


  if (userListIds && audience !== __WEBPACK_IMPORTED_MODULE_9_components_Customize_Audience_Helpers__["a" /* Audiences */].SEGMENT.key) {
    return orgSettings.removeIn(['theme', 'userListIds']);
  }
  return orgSettings;
}

var Audience = function (_Component) {
  _inherits(Audience, _Component);

  function Audience(props) {
    _classCallCheck(this, Audience);

    var _this = _possibleConstructorReturn(this, (Audience.__proto__ || Object.getPrototypeOf(Audience)).call(this, props));

    _this.onMultiSegmentSelected = _this.onMultiSegmentSelected.bind(_this);
    return _this;
  }

  _createClass(Audience, [{
    key: 'onMultiSegmentSelected',
    value: function onMultiSegmentSelected(newAudience, index, value) {
      var _props = this.props,
          embed = _props.embed,
          orgSettings = _props.orgSettings;

      var initialOrgSettings = Object(__WEBPACK_IMPORTED_MODULE_7_components_Customize_OrgSettings_Helpers__["c" /* getOrgSettingsFromEmbed */])(embed);
      var updatedOrgSettings = updateAudience(orgSettings, newAudience, index, value);

      var shouldUpdate = !Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["is"])(initialOrgSettings, updatedOrgSettings);

      if (shouldUpdate) this.updateMultiSegment(initialOrgSettings, updatedOrgSettings);
    }
  }, {
    key: 'updateMultiSegment',
    value: function updateMultiSegment(initialOrgSettings, updatedOrgSettings) {
      var actions = this.context.app.actions;

      var changes = Object(__WEBPACK_IMPORTED_MODULE_7_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(maybeUnsetUserListIds(updatedOrgSettings), initialOrgSettings);

      actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings);
      actions.DefaultEmbedActions.patchDefaultEmbed(changes, __WEBPACK_IMPORTED_MODULE_8_components_Customize_Availability_Constants__["g" /* NotificationMessages */].TARGETING);
    }
  }, {
    key: 'isPremium',
    value: function isPremium() {
      return __WEBPACK_IMPORTED_MODULE_10_utils_Access__["c" /* default */].hasGates(__WEBPACK_IMPORTED_MODULE_10_utils_Access__["b" /* Gates */].PREMIUM);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          segments = _props2.segments,
          users = _props2.users,
          orgSettings = _props2.orgSettings;
      var _orgSettings$theme2 = orgSettings.theme,
          audience = _orgSettings$theme2.audience,
          userListIds = _orgSettings$theme2.userListIds;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_TargetingInputArea_MultiSegmentSelect__["a" /* default */], {
        audience: audience,
        segments: segments,
        users: users,
        selectedSegments: userListIds,
        onSelection: this.onMultiSegmentSelected,
        isPremium: this.isPremium(),
        className: __WEBPACK_IMPORTED_MODULE_11__style_styl___default.a.Segment
      });
    }
  }]);

  return Audience;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Audience.propTypes = {
  orgSettings: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.recordOf({
    theme: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.recordOf({
      userList: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number).isRequired,
      userListMode: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      welcomeMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
      emailCaptureMessage: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
    }).isRequired
  }).isRequired
};
Audience.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


function mapStateToProps(state) {
  return {
    embed: state.get('embed').toJS().data
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, null)(Audience));

/***/ }),

/***/ "NjXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("37s/");












var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsers: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["nonBotOrgUsersAlphabetical"](state),
    orgUsersWithRandom: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["randomAndOrgUsersAlphabetical"](state),
    inboxes: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["f" /* inboxes */](state),
    isInboxListLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["h" /* isInboxListLoading */](state),
    isInboxListLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_selectors__["g" /* isInboxListLoaded */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_4_app_modules_inbox_actions__["A" /* fetchInboxList */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (this.props.includeInboxEmails && !this.props.isInboxListLoaded && !this.props.isInboxListLoading) {
      this.props.actions.fetchInboxList();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var orgUsers = _ref.orgUsers,
      includeInboxEmails = _ref.includeInboxEmails,
      isInboxListLoaded = _ref.isInboxListLoaded;
  return !orgUsers.size || includeInboxEmails && !isInboxListLoaded;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {

  var nonCalUsersNormal = props.orgUsers.filter(function (user) {
    return !user.scopes.includes('calendar_user');
  });

  var nonCalUsersRandom = props.orgUsersWithRandom.filter(function (user) {
    return !user.scopes.includes('calendar_user');
  });

  var replyArray = function replyArray() {
    if (props.includeRandom && !props.restrictCalendarUsers) {
      return props.orgUsersWithRandom;
    } else if (props.includeRandom && props.restrictCalendarUsers) {
      return nonCalUsersRandom;
    } else if (!props.includeRandom && !props.restrictCalendarUsers) {
      return props.orgUsers;
    } else {
      return nonCalUsersNormal;
    }
  };

  var correctUserArray = replyArray();

  var replyToOptions = correctUserArray.map(function (user) {
    return {
      value: user.id,
      user: user,
      label: React.createElement(
        'div',
        { className: 'flex routing-option' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
        props.renderOption ? props.renderOption(user) : user.name || user.email
      )
    };
  }).toJS();
  var inboxOptions = [];
  if (props.inboxes.size > 0 && props.includeInboxEmails) {
    inboxOptions = props.inboxes.toList().map(function (inbox) {
      return {
        value: inbox.address,
        isInbox: true,
        label: inbox.address + ' (' + inbox.name + ' Inbox)'
      };
    }).toJS();
  }
  var options = inboxOptions.concat(replyToOptions);
  var isIdEmail = ('' + props.selectedUserId).includes('@');
  var userForEmail = isIdEmail && props.orgUsers.find(function (user) {
    return user.email === props.selectedUserId;
  });
  var inboxForEmail = isIdEmail && inboxOptions.find(function (inbox) {
    return inbox.value === props.selectedUserId;
  });
  var selectedValue = userForEmail ? { label: userForEmail.name, value: userForEmail.id } : inboxForEmail || props.selectedUserId;
  return {
    selectedValue: selectedValue,
    options: options
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  filter: function filter() {
    return function (option, filterText) {
      if (option.isInbox) {
        return option.label.includes(filterText);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(option.user).toLowerCase().includes(filterText);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "NjlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_experiment_helpers_js__ = __webpack_require__("grSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ChatWidget_components_Advanced_components_ToggleSection__ = __webpack_require__("3JoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChatWidget_components_BackButton__ = __webpack_require__("h2eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ChatWidget_components_PageTitle__ = __webpack_require__("dtTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AutoCloseConfiguration__ = __webpack_require__("d258");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CustomSequenceLimitModal__ = __webpack_require__("orkc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_styl__ = __webpack_require__("uMQj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var SEQUENCE_LIMIT = 150;

var ConversationsSettings = function (_Component) {
  _inherits(ConversationsSettings, _Component);

  function ConversationsSettings(props) {
    _classCallCheck(this, ConversationsSettings);

    var _this = _possibleConstructorReturn(this, (ConversationsSettings.__proto__ || Object.getPrototypeOf(ConversationsSettings)).call(this, props));

    _this.hasGlobalAutoClose = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_experiment_helpers_js__["a" /* variation */])('has_global_auto_close') === 'on';
    };

    _this.handleDateChange = function (_ref) {
      var startDate = _ref.startDate,
          endDate = _ref.endDate;

      _this.setState({
        startDate: startDate,
        endDate: endDate
      });
    };

    _this.debouncedHandleChatLimitChange = _.debounce(function (limitNumChats) {
      var limitNumChatsEnabled = _this.state.limitNumChatsEnabled;

      _this.setState({
        updatePending: true
      });

      _this.props.actions.setConversationLimit({ limitNumChatsEnabled: limitNumChatsEnabled, limitNumChats: limitNumChats });
    }, 1000);
    _this.debouncedHandleSequenceLimitChange = _.debounce(function (value) {
      var _patchOperations;

      var ops = Object(__WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__["a" /* patchOperations */])((_patchOperations = {}, _defineProperty(_patchOperations, 'orgSequenceLimit', value || String(SEQUENCE_LIMIT)), _defineProperty(_patchOperations, 'customOrgSequenceEnabled', true), _patchOperations), _this.props.orgProperties);

      if (ops.length > 0) {
        _this.setState({
          updatePending: true
        });
        _this.props.actions.patchOrgProperties(ops);
      }
    }, 1000);

    _this.handleChatLimitChange = function (event) {
      _this.setState({
        limitNumChats: parseInt(event.target.value) || undefined
      }, function () {
        _this.debouncedHandleChatLimitChange(_this.state.limitNumChats);
      });
    };

    _this.handleOrgSequenceLimitChange = function (event) {
      _this.setState({
        orgSequenceLimit: parseInt(event.target.value) || undefined
      }, function () {
        if (_this.state.orgSequenceLimit < 2001) {
          _this.setState({
            sequenceLimitError: false
          });
          _this.debouncedHandleSequenceLimitChange(String(_this.state.orgSequenceLimit));
        } else {
          _this.setState({
            sequenceLimitError: true
          });
        }
      });
    };

    _this.handleChangeCustomSequenceLimitToggle = function (event) {
      if (event.target.checked) {
        _this.setState({
          showCustomSequenceLimitWarning: true
        });
      } else {
        _this.setState({
          customOrgSequenceEnabled: false,
          orgSequenceLimit: SEQUENCE_LIMIT,
          updatePending: true,
          showCustomSequenceLimitWarning: false
        }, function () {
          var _patchOperations2;

          var ops = Object(__WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__["a" /* patchOperations */])((_patchOperations2 = {}, _defineProperty(_patchOperations2, 'customOrgSequenceEnabled', _this.state.customOrgSequenceEnabled), _defineProperty(_patchOperations2, 'orgSequenceLimit', String(SEQUENCE_LIMIT)), _patchOperations2), _this.props.orgProperties);
          _this.props.actions.patchOrgProperties(ops);
        });
      }
    };

    _this.handleChangeLimitEnabledToggle = function (event) {
      _this.setState({
        limitNumChatsEnabled: event.target.checked,
        updatePending: true
      }, function () {
        var _this$state = _this.state,
            limitNumChatsEnabled = _this$state.limitNumChatsEnabled,
            limitNumChats = _this$state.limitNumChats;

        _this.props.actions.setConversationLimit({ limitNumChatsEnabled: limitNumChatsEnabled, limitNumChats: limitNumChats });
      });
    };

    _this.handleChangeRerouteConversationToggle = function (event) {
      _this.setState({
        rerouteConversationsEnabled: event.target.checked,
        updatePending: true
      }, function () {
        var ops = Object(__WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__["a" /* patchOperations */])(_defineProperty({}, 'rerouteConversationsEnabled', _this.state.rerouteConversationsEnabled), _this.props.orgProperties);
        _this.props.actions.patchOrgProperties(ops);
      });
    };

    _this.handleUnfurlToggle = function (event) {
      _this.setState({
        showUnfurl: event.target.checked,
        updatePending: true
      }, function () {
        var ops = [{ operation: "set", property: "theme.showUnfurl", value: _this.state.showUnfurl }];
        _this.props.actions.patchEmbed(ops);
      });
    };

    _this.handleChatLimitSubmit = function (event) {
      event.preventDefault();
    };

    _this.selectInbox = function (value) {
      _this.setState({
        selectedInbox: value.value
      });
    };

    _this.getInboxOptions = function () {
      return _this.props.inboxes.valueSeq().map(function (inbox) {
        return {
          label: inbox.name,
          value: inbox.id
        };
      }).toArray();
    };

    _this.acceptCustomSequenceWarning = function () {
      _this.setState({
        customOrgSequenceEnabled: true,
        orgSequenceLimit: SEQUENCE_LIMIT,
        updatePending: true,
        showCustomSequenceLimitWarning: false
      }, function () {
        var _patchOperations4;

        var ops = Object(__WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__["a" /* patchOperations */])((_patchOperations4 = {}, _defineProperty(_patchOperations4, 'customOrgSequenceEnabled', _this.state.customOrgSequenceEnabled), _defineProperty(_patchOperations4, 'orgSequenceLimit', String(SEQUENCE_LIMIT)), _patchOperations4), _this.props.orgProperties);
        _this.props.actions.patchOrgProperties(ops);
      });
    };

    _this.declineCustomSequenceWarning = function () {
      _this.setState({
        showCustomSequenceLimitWarning: false
      });
    };

    _this.notifySuccess = function () {
      _this.context.app.actions.NotificationActions.pushNotification({
        content: 'Your conversations settings were successfully updated.',
        variant: 'green'
      });
    };

    _this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      selectedInbox: null,
      limitNumChats: props.orgProperties['limitNumChats'] || 0,
      orgSequenceLimit: props.orgProperties['orgSequenceLimit'] || SEQUENCE_LIMIT,
      limitNumChatsEnabled: props.orgProperties['limitNumChatsEnabled'] || false,
      rerouteConversationsEnabled: props.orgProperties['rerouteConversationsEnabled'] || false,
      customOrgSequenceEnabled: props.orgProperties['customOrgSequenceEnabled'] || false,
      showUnfurl: _.get(props.embed, ['theme', 'showUnfurl'], true),
      updatePending: false,
      sequenceLimitError: false,
      showCustomSequenceLimitWarning: false
    };
    return _this;
  }

  _createClass(ConversationsSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchInboxList();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var updated = this.props.orgProperties['limitNumChats'] !== nextProps.orgProperties['limitNumChats'] || this.props.orgProperties['limitNumChatsEnabled'] !== nextProps.orgProperties['limitNumChatsEnabled'] || this.props.orgProperties['rerouteConversationsEnabled'] !== nextProps.orgProperties['rerouteConversationsEnabled'] || this.props.orgProperties['customOrgSequenceEnabled'] !== nextProps.orgProperties['customOrgSequenceEnabled'] || this.props.orgProperties['orgSequenceLimit'] !== nextProps.orgProperties['orgSequenceLimit'] || _.get(this.props.embed, ['theme', 'showUnfurl']) !== _.get(nextProps.embed, ['theme', 'showUnfurl']);

      if (updated) {
        if (this.state.updatePending) {
          this.notifySuccess();
        }
        this.setState({
          limitNumChats: nextProps.orgProperties['limitNumChats'],
          limitNumChatsEnabled: nextProps.orgProperties['limitNumChatsEnabled'],
          rerouteConversationsEnabled: nextProps.orgProperties['rerouteConversationsEnabled'],
          customOrgSequenceEnabled: nextProps.orgProperties['customOrgSequenceEnabled'],
          orgSequenceLimit: nextProps.orgProperties['orgSequenceLimit'],
          showUnfurl: _.get(nextProps.embed, ['theme', 'showUnfurl']),
          updatePending: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          limitNumChats = _state.limitNumChats,
          limitNumChatsEnabled = _state.limitNumChatsEnabled,
          rerouteConversationsEnabled = _state.rerouteConversationsEnabled,
          showUnfurl = _state.showUnfurl,
          orgSequenceLimit = _state.orgSequenceLimit,
          sequenceLimitError = _state.sequenceLimitError,
          customOrgSequenceEnabled = _state.customOrgSequenceEnabled,
          showCustomSequenceLimitWarning = _state.showCustomSequenceLimitWarning;
      var _props = this.props,
          hasLimitNumberOfChats = _props.hasLimitNumberOfChats,
          hasCompanyPlan = _props.hasCompanyPlan;


      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_20__style_styl___default.a.Conversations },
        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ChatWidget_components_BackButton__["a" /* default */], { title: 'Conversations Settings', url: '/settings2/conversations' }),
        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__ChatWidget_components_PageTitle__["a" /* default */], { title: 'Advanced', description: 'Customize advanced settings for conversations' }),
        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ChatWidget_components_Advanced_components_ToggleSection__["a" /* default */], {
          title: 'Unfurl links in the conversation',
          description: 'Show or hide the preview of links in the conversation view',
          className: 'advanced-settings-toggle conversation-unfurl-links',
          isChecked: showUnfurl,
          onToggled: this.handleUnfurlToggle
        }),
        (hasLimitNumberOfChats || hasCompanyPlan) && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_15__ChatWidget_components_Advanced_components_ToggleSection__["a" /* default */],
          {
            title: 'Limit Chats For Your Reps',
            description: 'When a rep is over their limit of open conversations, Drift will not route any new conversations to them so they can focus on their current ones.',
            isChecked: limitNumChatsEnabled,
            className: 'advanced-settings-toggle',
            onToggled: this.handleChangeLimitEnabledToggle
          },
          __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
            'div',
            { className: 'content' },
            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
              'div',
              { className: 'conversation-limit-number-of-chats' },
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'span',
                null,
                'Automatically set my reps to be away when they have '
              ),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'form',
                { className: 'drift-form', onSubmit: this.handleChatLimitSubmit },
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', { type: 'number', min: 0, value: limitNumChats, onChange: this.handleChatLimitChange })
              ),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'span',
                null,
                ' open conversations.'
              )
            )
          )
        ),
        hasCompanyPlan && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ChatWidget_components_Advanced_components_ToggleSection__["a" /* default */], {
            title: 'Reroute conversations with no participants',
            description: 'When an agent comes online, we will reroute these conversations according to your Lead Routing Rules.',
            className: 'advanced-settings-toggle conversation-reroute-conversations',
            isChecked: rerouteConversationsEnabled,
            onToggled: this.handleChangeRerouteConversationToggle
          })
        ),
        this.hasGlobalAutoClose() && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__AutoCloseConfiguration__["a" /* default */], { onChangeSuccess: this.notifySuccess }),
        hasCompanyPlan && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ChatWidget_components_Advanced_components_ToggleSection__["a" /* default */], {
            title: 'Customize Sequence Enroll Limit for your Reps',
            description: 'If your reps need more than ' + SEQUENCE_LIMIT + ' sequence enrollments per day, you can update that number here.',
            isChecked: customOrgSequenceEnabled,
            onToggled: this.handleChangeCustomSequenceLimitToggle,
            className: 'advanced-settings-toggle conversation-unfurl-links'
          }),
          customOrgSequenceEnabled && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
            'div',
            { className: 'content' },
            __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
              'div',
              { className: 'limit-number-of-sequences ' },
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'span',
                null,
                'Allow my reps to enroll up to '
              ),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'form',
                { className: 'drift-form', onSubmit: this.handleChatLimitSubmit },
                __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement('input', {
                  type: 'number',
                  min: SEQUENCE_LIMIT,
                  max: 2000,
                  value: orgSequenceLimit,
                  onChange: this.handleOrgSequenceLimitChange
                })
              ),
              __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'span',
                null,
                ' contacts in sequences per day. '
              ),
              sequenceLimitError && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
                'span',
                { className: 'sequence-limit-error' },
                ' ',
                'Please input a limit between ',
                SEQUENCE_LIMIT,
                ' and 2000'
              )
            )
          )
        ),
        showCustomSequenceLimitWarning && __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__CustomSequenceLimitModal__["a" /* default */], {
          handleCloseModal: this.declineCustomSequenceWarning,
          handleDisconnect: this.acceptCustomSequenceWarning
        })
      );
    }
  }]);

  return ConversationsSettings;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

ConversationsSettings.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasLimitNumberOfChats: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["k" /* hasLimitNumberOfChats */](state),
    hasCompanyPlan: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["h" /* hasCompanyPlan */](state),
    hasNewConvoExport: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["m" /* hasNewConvoExport */](state),
    orgProperties: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["properties"](state),
    embed: __WEBPACK_IMPORTED_MODULE_3_app_modules_embed_selectors__["h" /* getEmbedConfig */](state),
    inboxes: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_inbox_selectors__["f" /* inboxes */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_13_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_actions__["A" /* fetchInboxList */],
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__["patchOrgProperties"],
      patchEmbed: __WEBPACK_IMPORTED_MODULE_2_app_modules_embed_actions__["f" /* patchEmbed */],
      setConversationLimit: __WEBPACK_IMPORTED_MODULE_1_app_modules_conversation_actions__["S" /* setConversationLimit */]
    }, dispatch)
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_access_helpers__["a" /* ensureIsAdmin */])(ConversationsSettings)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "NkIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_Accordion__ = __webpack_require__("so0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_HelpDocConstants__ = __webpack_require__("fBam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_WordPress__ = __webpack_require__("/fzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_Zendesk__ = __webpack_require__("Vl6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_HelpScout__ = __webpack_require__("bdc9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_HelpDocs__ = __webpack_require__("7FVZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__GDPRMessage__ = __webpack_require__("1brp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl__ = __webpack_require__("19Z2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var DRIFT_BOT_SKILLS_LINK = '/settings/routing';

var defaultToEmptyObject = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["defaultTo"])({});

var logoSrc = {
  wordpress: __webpack_require__("oRkD"),
  zendesk: __webpack_require__("ZLiY"),
  helpscout: __webpack_require__("5/UP"),
  helpdocs: __webpack_require__("ms2+")

  // these keys should correspond with
  // the integrationStates object
};var getServives = function getServives(wordpressType) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, wordpressType, {
    title: Object(__WEBPACK_IMPORTED_MODULE_9__helpers__["d" /* renderLogoSVG */])(logoSrc.wordpress),
    Service: __WEBPACK_IMPORTED_MODULE_12__services_WordPress__["a" /* default */]
  }), _defineProperty(_ref, 'zendesk', {
    title: Object(__WEBPACK_IMPORTED_MODULE_9__helpers__["d" /* renderLogoSVG */])(logoSrc.zendesk),
    Service: __WEBPACK_IMPORTED_MODULE_13__services_Zendesk__["a" /* default */]
  }), _defineProperty(_ref, 'helpScout', {
    title: Object(__WEBPACK_IMPORTED_MODULE_9__helpers__["c" /* renderLogo */])(logoSrc.helpscout),
    Service: __WEBPACK_IMPORTED_MODULE_14__services_HelpScout__["a" /* default */]
  }), _defineProperty(_ref, 'helpdocsio', {
    title: Object(__WEBPACK_IMPORTED_MODULE_9__helpers__["c" /* renderLogo */])(logoSrc.helpdocs),
    Service: __WEBPACK_IMPORTED_MODULE_15__services_HelpDocs__["a" /* default */]
  }), _ref;
};

var HelpCenterPage = function (_Component) {
  _inherits(HelpCenterPage, _Component);

  function HelpCenterPage(props) {
    var _this2 = this;

    _classCallCheck(this, HelpCenterPage);

    var _this = _possibleConstructorReturn(this, (HelpCenterPage.__proto__ || Object.getPrototypeOf(HelpCenterPage)).call(this, props));

    _this.isDriftHelpConnected = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.actions.fetchDriftHelpStatus();

            case 2:
              response = _context.sent;

              _this.setState({
                isDriftHelpEnabled: response
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.renderServices = function () {
      var integrationStates = _this.props.integrationStates;
      var isDriftHelpEnabled = _this.state.isDriftHelpEnabled;


      var wordpressIntegrationType = __WEBPACK_IMPORTED_MODULE_17_utils_Access__["c" /* default */].hasGates('HAS_WORDPRESS_V2') ? 'wordpressV2' : 'wordpress';
      var Services = getServives(wordpressIntegrationType);

      return __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(Services, function (_ref3, serviceName) {
        var Service = _ref3.Service,
            title = _ref3.title;

        var isConnected = void 0;

        if (serviceName === "driftHelp" && Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isNil"])(integrationStates[serviceName])) {
          isConnected = isDriftHelpEnabled;
        } else {
          isConnected = integrationStates[serviceName];
        }

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_components_shared_Accordion__["a" /* default */],
          { className: serviceName, key: serviceName, title: title, isConnected: isConnected },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Service, { isConnected: isConnected })
        );
      });
    };

    _this.state = {
      isDriftHelpEnabled: null
    };
    _this.isDriftHelpConnected();
    return _this;
  }

  _createClass(HelpCenterPage, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_components_shared_Accordion__["a" /* default */],
          {
            key: 'help-center-intro',
            title: 'Connect your knowledge base to Drift',
            locked: true,
            className: 'help-center-settings-header'
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'When you connect your knowledge base to Drift, Driftbot will surface help article links in the conversation.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'When someone asks Driftbot a question or responds to your welcome message, Driftbot will surface the best help article links to the questions you have already answered and enable your customers to submit a ticket from the conversation so you can save your brain power for the bigger questions!'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'help-center-buttons' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Button"],
              { className: 'second', type: 'tertiary', href: __WEBPACK_IMPORTED_MODULE_10_constants_HelpDocConstants__["c" /* HELP_CENTER_HELPDOC_URL */], target: '_blank' },
              'Learn more'
            )
          )
        ),
        this.renderServices(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'gdpr-message-wrapper' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__GDPRMessage__["a" /* default */], null)
        )
      );
    }
  }]);

  return HelpCenterPage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgId: defaultToEmptyObject(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"](state))
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({ fetchDriftHelpStatus: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__["fetchDriftHelpStatus"] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(HelpCenterPage));

/***/ }),

/***/ "Nl1C":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjI1cHgiIGhlaWdodD0iMzZweCIgdmlld0JveD0iMCAwIDI1IDM2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICA8ZyBpZD0ibWFya2V0byIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPGcgaWQ9IkFydGJvYXJkLTItQ29weSIgZmlsbD0iIzAwNTQ4RiI+DQogICAgICA8cGF0aCBkPSJNMC4xNDcyNTA2MjcsMjUuNzYwNTI0OCBMMC4xNDcyNTA2MjcsMTUuNDUyOTgwOSBMMy4zNTYyMDI5NywxMy41Nzc2MTkxIEM0Ljk2NzYyNDkzLDEyLjU2MzUzNDYgNi43MTc5NjI1NywxMS43MDIyNTc0IDYuODQyOTg2NjksMTEuNjc0NDc0MiBDNy4xMzQ3MDk2MywxMS42NzQ0NzQyIDcuMzAxNDA4NDUsMTMuNjc0ODYwMSA3LjMwMTQwODQ1LDIwLjc0NTY2ODUgTDcuMzAxNDA4NDUsMjkuODQ0NjQ2IEwxMS4yMjQzODc0LDI5LjcwNTczMDMgQzE0LjI5NDQyNDEsMjkuNTUyOTIzIDE1LjYxNDEyMzEsMjkuNDQxNzkwNSAxNi4zNTAzNzYyLDI5LjAzODkzNSBDMTguMTAwNzEzOSwyOC4wOTQzMDgzIDE4LjI1MzUyMTEsMjcuMjA1MjQ3OSAxOC4yNTM1MjExLDE4LjA3ODQ4NzQgQzE4LjI1MzUyMTEsMTMuNTIyMDUyOSAxOC4yNTM1MjExLDkuNDM3OTMxNyAxOC4xMDA3MTM5LDguOTM3ODM1MjMgQzE3Ljk0NzkwNjYsOC40Mzc3Mzg3NiAxNy4zNjQ0NjA3LDcuNzI5MjY4NzYgMTYuNzk0OTA2NCw3LjI4NDczODU3IEMxNS43ODA4MjE5LDYuNTM0NTkzODYgMTUuNDg5MDk5LDYuNTM0NTkzODYgNy44Njk1NzM2MSw2LjM5NTY3ODE4IEwwLDYuMjU2NzYyNDkgTDAsMCBMOC41ODQ5ODkzOSwwLjE0NTg2MTQ3IEMxNi43OTQ5MDY0LDAuMjkzMTEyMDk3IDE3LjUzMTE1OTYsMC4zMjIyODQzOTEgMTkuMjY3NjA1NiwxLjAzMjE0MzU1IEMyMC41NzM0MTMxLDEuNTEyNzkxODIgMjEuOTA3MDAzNywyLjM0NjI4NTkzIDIyLjc2ODI4MDksMy4zMzI1ODczIEMyNS4yNTQ4NzE3LDUuNzMwMjcyMDQgMjUuMzkzNzg3NCw2LjY2MTAwNzE0IDI1LjM5Mzc4NzQsMTguMDM4MjAxOCBDMjUuMzkzNzg3NCwyOC44NzM2MjUzIDI1LjI1NDg3MTcsMjkuOTU3MTY3NyAyMy4xOTg5MTk1LDMyLjMwNDg0MjggQzIwLjcyNjIyMDMsMzUuMzMzMjA0NyAxNy44MDg5OTA5LDM2IDcuNDI1MDQzNDEsMzYgTDAsMzYgTDAuMTQ3MjUwNjI3LDI1LjcwNjM0NzcgTDAuMTQ3MjUwNjI3LDI1Ljc2MDUyNDggWiIgaWQ9IlBhdGgiPg0KICAgICAgPC9wYXRoPg0KICAgIDwvZz4NCiAgPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "NpRG":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 35 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33.313 19.94h-1.376a.682.682 0 0 1-.687-.675c0-.374.308-.677.688-.677h.687V2.352H6.5v.677a.682.682 0 0 1-.688.677.682.682 0 0 1-.687-.677V1.676c0-.374.308-.676.688-.676h27.5c.379 0 .687.302.687.676v17.589a.682.682 0 0 1-.688.675zM29.875 5.736v17.588a.683.683 0 0 1-.688.677h-27.5A.683.683 0 0 1 1 23.323V5.735c0-.374.308-.677.688-.677h27.5c.379 0 .687.303.687.677zm-1.375.676H2.375v16.236H28.5V6.411zM16.812 9.794h8.25c.38 0 .688.303.688.677a.682.682 0 0 1-.688.675h-8.25a.682.682 0 0 1-.687-.675c0-.374.308-.677.688-.677zm0 4.058h4.125c.38 0 .688.304.688.677a.682.682 0 0 1-.688.676h-4.125a.682.682 0 0 1-.687-.676c0-.373.308-.677.688-.677zM7.99 15.347c0 .26.065.507.182.741a.63.63 0 0 0 .546.338.65.65 0 0 0 .637-.65c0-.026 0-.065-.013-.13s-.026-.117-.026-.169c0-.507.455-.819.949-1.183.65-.455 1.378-.975 1.378-2.054 0-1.17-1.001-2.041-2.639-2.041-.936 0-1.755.299-2.418.858a.655.655 0 0 0 .429 1.157.645.645 0 0 0 .416-.143c.39-.338.845-.52 1.417-.52.845 0 1.235.429 1.235.936 0 .507-.429.806-.91 1.144-.559.403-1.183.845-1.183 1.716zm.026 2.886c0 .494.416.91.91.91.494 0 .91-.416.91-.91a.921.921 0 0 0-.91-.91.921.921 0 0 0-.91.91z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "NpTE":
/***/ (function(module, exports) {

module.exports = {"color-white":"#FFFFFF","color-white-off":"#FAFAFA","color-gray-extra-light":"#F8F8F8","color-gray-light":"#EEEEEE","color-gray":"#CCCCCC","color-gray-dark":"#9A9A9A","color-gray-extra-dark":"#333333","color-black":"#000000","color-blue":"#0176FF","color-blue-dark":"#0960C5","color-blue-light":"#9EDCF7","color-navy-extra-dark":"#394F5A","color-navy-dark":"#7695A5","color-navy":"#B5D2E1","color-navy-light":"#E1EEF4","color-navy-off-white":"#F2F6F8","color-teal":"#13DDB0","color-teal-dark":"#10B993","color-green":"#13CB6E","color-green-dark":"#1FA45C","color-pink":"#FF7F93","color-orange":"#F56C4C","color-orange-light":"#F7A41B","color-red":"#E92E4B","color-red-dark":"#D0021B","color-yellow-extra-light":"#FFFCD9","color-yellow-light":"#FEF79E","color-violet":"#E877DC","closed-status-color":"#B5D2E1","archived-status-color":"#B5D2E1","pending-status-color":"#9EDCF7","open-status-color":"#13CB6E"}

/***/ }),

/***/ "NqvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return currentInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return inboxes; });
/* unused harmony export countsById */
/* unused harmony export countsById2 */
/* unused harmony export countsStatusById */
/* unused harmony export makeCountsSelector */
/* unused harmony export makeCountsSelector2 */
/* unused harmony export makeIsCountStatusPending */
/* unused harmony export makeIsAnyCountStatusPending */
/* unused harmony export makeIsCountStatusLoaded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return inboxOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return inboxOptionsWithLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createdInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isInboxListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isInboxListLoading; });
/* unused harmony export isSendingDomainLoaded */
/* unused harmony export isSendingDomainLoading */
/* unused harmony export isInboxLoading */
/* unused harmony export isInboxLoaded */
/* unused harmony export nonMissingWhitelabels */
/* unused harmony export nonDefaultNonMissingWhitelabels */
/* unused harmony export isWhitelabelLoading */
/* unused harmony export isWhitelabelLoaded */
/* unused harmony export isAnyWhiteLabelLoading */
/* unused harmony export isAnyWhiteLabelLoaded */
/* unused harmony export isWhitelabelOpen */
/* unused harmony export whitelabel */
/* unused harmony export isWhitelabelVerified */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sendingDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isSendingDomainsLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("Y4lW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("UZmf");






var DEFAULT_DOMAINS = ['fwd-dev.drifttmail.com'];

var root = function root(state) {
  return state.get('inbox');
};

var inbox = function inbox(inboxId) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
    return root.getIn(['byId', inboxId], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  });
};
var currentInboxId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('currentInboxId');
});
var inboxes = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('byId', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});

var countsById = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('countsById');
});
var countsById2 = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('countsById2');
});
var countsStatusById = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('countsStatusById');
});

var makeCountsSelector = function makeCountsSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([countsById, function (state, props) {
    return props.inboxId;
  }], function (countsById, inboxId) {
    return countsById.get(inboxId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  });
};

// TODO: Prioritize count of loaded, fully paged conversations over counts in
// the store when counts from the store are larger than the paged convo count.
var makeCountsSelector2 = function makeCountsSelector2() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([countsById2, function (state, props) {
    return props.inboxId;
  }], function (countsById2, inboxId) {
    return countsById2.get(inboxId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  });
};

var makeIsCountStatusPending = function makeIsCountStatusPending() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([countsStatusById, function (state, props) {
    return props.inboxId;
  }], function (countsStatusById, inboxId) {
    return countsStatusById.get(inboxId) === __WEBPACK_IMPORTED_MODULE_4__actions__["w" /* fetchCountsPending */].toString();
  });
};

var makeIsAnyCountStatusPending = function makeIsAnyCountStatusPending() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([countsStatusById, function (state, props) {
    return props.inboxIds;
  }], function (countsStatusById, inboxIds) {
    return inboxIds.map(function (inboxId) {
      return countsStatusById.get(inboxId) === __WEBPACK_IMPORTED_MODULE_4__actions__["w" /* fetchCountsPending */].toString();
    }).some(function (isCountStatusPending) {
      return isCountStatusPending;
    });
  });
};

var makeIsCountStatusLoaded = function makeIsCountStatusLoaded() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([countsStatusById, function (state, props) {
    return props.inboxId;
  }], function (countsStatusById, inboxId) {
    return [__WEBPACK_IMPORTED_MODULE_4__actions__["R" /* receiveCounts */].toString(), __WEBPACK_IMPORTED_MODULE_4__actions__["S" /* receiveCounts2 */].toString()].includes(countsStatusById.get(inboxId));
  });
};

var inboxOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(inboxes, function (inboxes) {
  return !!inboxes && inboxes.valueSeq().map(function (inbox) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
      value: inbox.id,
      label: inbox.name ? inbox.name + ' (' + inbox.address + ')' : inbox.address
    });
  });
});

var inboxOptionsWithLabels = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(inboxes, function (inboxes) {
  return !!inboxes && inboxes.valueSeq().map(function (inbox) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
      value: inbox.id,
      label: inbox.name + ' (' + inbox.address + ')'
    });
  });
});

var createdInboxId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return !!root.get('createdInboxId') && root.get('createdInboxId');
});

var isInboxListLoaded = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  var status = root.get('status');
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* RECEIVE_INBOX_LIST */];
});
var isInboxListLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  var status = root.get('status');
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["E" /* FETCH_INBOX_LIST */] || status === __WEBPACK_IMPORTED_MODULE_3__constants__["H" /* FETCH_INBOX_LIST_PENDING */];
});

var isSendingDomainLoaded = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  var status = root.get('status');
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["_1" /* RECEIVE_INBOX_LIST */];
});
var isSendingDomainLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  var status = root.get('status');
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["J" /* FETCH_SENDING_DOMAINS */] || status === __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* FETCH_COUNTS_PENDING */];
});

var isInboxLoading = function isInboxLoading(state, inboxId) {
  return [__WEBPACK_IMPORTED_MODULE_3__constants__["B" /* FETCH_INBOX */], __WEBPACK_IMPORTED_MODULE_3__constants__["I" /* FETCH_INBOX_PENDING */]].includes(root(state).getIn(['byId', inboxId, 'fetchStatus']));
};
var isInboxLoaded = function isInboxLoaded(state, inboxId) {
  return root(state).getIn(['byId', inboxId, 'fetchStatus']) === __WEBPACK_IMPORTED_MODULE_3__constants__["_0" /* RECEIVE_INBOX */];
};

var nonMissingWhitelabels = function nonMissingWhitelabels(state) {
  return root(state).get('byDomain', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).filter(function (domain) {
    return !domain.getIn(['data', 'missing']) && !domain.getIn(['data', 'fetchStatus']) !== __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* FETCH_WHITELABEL_PENDING */];
  }).map(function (record) {
    return record.get('data');
  });
};
var nonDefaultNonMissingWhitelabels = function nonDefaultNonMissingWhitelabels(state) {
  return nonMissingWhitelabels(state).filter(function (record, key) {
    return !DEFAULT_DOMAINS.includes(key);
  });
};
var isWhitelabelLoading = function isWhitelabelLoading(state, domain) {
  return [__WEBPACK_IMPORTED_MODULE_3__constants__["L" /* FETCH_WHITELABEL */], __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* FETCH_WHITELABEL_PENDING */]].includes(root(state).getIn(['byDomain', domain, 'data', 'fetchStatus']));
};
var isWhitelabelLoaded = function isWhitelabelLoaded(state, domain) {
  return root(state).getIn(['byDomain', domain, 'data', 'fetchStatus']) === __WEBPACK_IMPORTED_MODULE_3__constants__["P" /* FETCH_WHITELABEL_SUCCESS */];
};
var isAnyWhiteLabelLoading = function isAnyWhiteLabelLoading(state) {
  return root(state).get('byDomain', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).some(function (domain) {
    return [__WEBPACK_IMPORTED_MODULE_3__constants__["L" /* FETCH_WHITELABEL */], __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* FETCH_WHITELABEL_PENDING */]].includes(domain.getIn(['data', 'fetchStatus']));
  });
};
var isAnyWhiteLabelLoaded = function isAnyWhiteLabelLoaded(state) {
  return root(state).get('byDomain', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).some(function (domain) {
    return [__WEBPACK_IMPORTED_MODULE_3__constants__["N" /* FETCH_WHITELABEL_FAILED */], __WEBPACK_IMPORTED_MODULE_3__constants__["P" /* FETCH_WHITELABEL_SUCCESS */]].includes(domain.getIn(['data', 'fetchStatus']));
  });
};
var isWhitelabelOpen = function isWhitelabelOpen(state, domain) {
  return root(state).getIn(['byDomain', domain, 'ui', 'isAccordionOpen'], false);
};

var whitelabel = function whitelabel(state, domain) {
  return root(state).getIn(['byDomain', domain, 'data']);
};
var isWhitelabelVerified = function isWhitelabelVerified(state, domain) {
  var validities = root(state).getIn(['byDomain', domain, 'data', 'dns'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).map(function (record) {
    return record.get('valid');
  });
  return validities.size !== 0 && validities.every(__WEBPACK_IMPORTED_MODULE_2_lodash__["identity"]);
};

var sendingDomains = function sendingDomains(state) {
  return root(state).getIn(['sendingDomains', 'data', 'byId'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var isSendingDomainsLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  var status = root.getIn(['sendingDomains', 'status', 'fetch'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["J" /* FETCH_SENDING_DOMAINS */] || status === __WEBPACK_IMPORTED_MODULE_3__constants__["K" /* FETCH_SENDING_DOMAINS_PENDING */];
});

/***/ }),

/***/ "NrfI":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"flow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"admin-copy-2\" transform=\"translate(-412.000000, -851.000000)\"><g id=\"Oval-Copy-3\" fill=\"#7695A5\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"419\" cy=\"858\" r=\"6\"></circle></g></g></g></svg>"

/***/ }),

/***/ "Ns++":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O+OV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conversationSection":"conversationSection---3EI62"};

/***/ }),

/***/ "O/gD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Customize_InputWithLimit__ = __webpack_require__("hHEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("Oa/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__("qo/O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);








var MessageInputs = function MessageInputs(_ref) {
  var intl = _ref.intl,
      welcomeMessage = _ref.welcomeMessage,
      awayMessage = _ref.awayMessage,
      onWelcomeMessageChanged = _ref.onWelcomeMessageChanged,
      onAwayMessageChanged = _ref.onAwayMessageChanged;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style___default.a.MessageInputsWrapper },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'message-inputs' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Customize_InputWithLimit__["a" /* default */], {
        title: 'Online Message',
        text: welcomeMessage,
        placeholder: intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* Messages */].defaultWelcomeMessage),
        maxLength: 140,
        invalidLabel: 'You have entered too many characters',
        onChange: onWelcomeMessageChanged,
        className: 'message-input'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Customize_InputWithLimit__["a" /* default */], {
        title: 'Offline Message',
        text: awayMessage,
        placeholder: intl.formatMessage(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* Messages */].defaultAwayMessage),
        maxLength: 164,
        invalidLabel: 'You have entered too many characters',
        onChange: onAwayMessageChanged,
        className: 'message-input'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["d" /* injectIntl */])(MessageInputs));

/***/ }),

/***/ "O04e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var GateConstants = Marty.createConstants(['SET_GATE', 'GATES_UPDATE']);

/* harmony default export */ __webpack_exports__["a"] = (GateConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "O13t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FakeBrowser":"FakeBrowser---1GwS6","TopBar":"TopBar---k-56v","AddressBar":"AddressBar---3mzTQ","ViewPort":"ViewPort---1Putb"};

/***/ }),

/***/ "O19k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MarketoActivityOption__ = __webpack_require__("jzDT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("2BXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Integration_components_AddButton_index__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_marketo_empty_activity_svg__ = __webpack_require__("VfYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_svg_marketo_empty_activity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_svg_marketo_empty_activity_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ERROR_MESSAGE = "Ooops, something went wrong. Please try again.";
var indexMatches = function indexMatches(indexToMatch) {
  return function (value, index) {
    return index === indexToMatch;
  };
};

var isMappedActivityFullyDefined = function isMappedActivityFullyDefined(activity) {
  return Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["all"])(Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["complement"])(__WEBPACK_IMPORTED_MODULE_8_ramda__["isNil"]))([activity.marketoName, activity.marketoId, activity.activityType]);
};

var MarketoActivityMapper = function (_Component) {
  _inherits(MarketoActivityMapper, _Component);

  function MarketoActivityMapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarketoActivityMapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarketoActivityMapper.__proto__ || Object.getPrototypeOf(MarketoActivityMapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activities: []
    }, _this.addActivity = function () {
      var activities = _this.state.activities;

      var updatedActivities = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["append"])(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* EmptyActivity */], activities);
      _this.setState({ activities: updatedActivities });
    }, _this.tryDeleteActivity = function (mappedActivity, oldActivities) {
      var notifications = _this.props.notifications;

      if (!mappedActivity.activityType) return;

      var handleError = function handleError() {
        _this.setState({ activities: oldActivities });
        notifications.error(ERROR_MESSAGE);
      };

      Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_api__["f" /* deleteMarketoMappedActivity */])(mappedActivity.activityType).catch(handleError);
    }, _this.deleteActivity = function (_ref2) {
      var activityIndex = _ref2.activityIndex,
          mappedActivity = _ref2.mappedActivity;
      var activities = _this.state.activities;

      var updatedActivities = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["addIndex"])(__WEBPACK_IMPORTED_MODULE_8_ramda__["reject"])(indexMatches(activityIndex), activities);
      var onLocalStateUpdated = function onLocalStateUpdated() {
        return _this.tryDeleteActivity(mappedActivity, activities);
      };

      _this.setState({ activities: updatedActivities }, onLocalStateUpdated);
    }, _this.tryPatchActivities = function (oldActivities, newActivities) {
      var notifications = _this.props.notifications;

      var fullyDefinedActivities = newActivities.filter(isMappedActivityFullyDefined);
      if (Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["isEmpty"])(fullyDefinedActivities)) return;

      var handleError = function handleError() {
        _this.setState({ activities: oldActivities });
        notifications.error(ERROR_MESSAGE);
      };

      return Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_api__["I" /* patchMarketoMappedActivities */])(fullyDefinedActivities).catch(handleError);
    }, _this.tryHandlingDriftActivityTypeChange = function (_ref3) {
      var activityIndex = _ref3.activityIndex,
          mappedActivity = _ref3.mappedActivity;
      var activities = _this.state.activities;

      var existingActivity = activities[activityIndex];

      var wasActivityTypeChanged = existingActivity && existingActivity.activityType && existingActivity.activityType !== mappedActivity.activityType;

      if (wasActivityTypeChanged) {
        Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_api__["f" /* deleteMarketoMappedActivity */])(existingActivity.activityType);
      }
    }, _this.updateActivities = function (_ref4) {
      var activityIndex = _ref4.activityIndex,
          mappedActivity = _ref4.mappedActivity;
      var activities = _this.state.activities;

      var updatedActivity = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["merge"])(activities[activityIndex], mappedActivity);
      var updatedActivities = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["update"])(activityIndex, updatedActivity, activities);
      var onLocalStateUpdated = function onLocalStateUpdated() {
        return _this.tryPatchActivities(activities, updatedActivities);
      };

      _this.tryHandlingDriftActivityTypeChange({ activityIndex: activityIndex, mappedActivity: mappedActivity });
      _this.setState({ activities: updatedActivities }, onLocalStateUpdated);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarketoActivityMapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var handleActivities = function handleActivities(activities) {
        _this2.setState({ activities: activities });
      };

      Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_integrations_api__["k" /* fetchMarketoMappedActivities */])().then(handleActivities);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var activities = this.state.activities;

      var isAddActivityDisabled = activities.length >= Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["values"])(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* DriftActivityType */]).length;

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'marketo-activity-mapper' },
          React.createElement(
            'div',
            { className: 'marketo-activity-mapper-header' },
            React.createElement(
              'div',
              null,
              'Drift Activity'
            ),
            React.createElement(
              'div',
              null,
              'Marketo Activity'
            )
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__["a" /* default */],
            { condition: Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["isEmpty"])(activities) },
            React.createElement(
              'div',
              { className: 'marketo-activity-mapper-empty-state' },
              React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_9_images_svg_marketo_empty_activity_svg___default.a }),
              React.createElement(
                'p',
                null,
                'You don\u2019t have any activity mapped between Drift and Marketo yet.'
              )
            )
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__["a" /* default */],
            { condition: !Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["isEmpty"])(activities) },
            React.createElement(
              'div',
              { className: 'marketo-activity-mapper-actions' },
              activities.map(function (activity, index) {
                return React.createElement(__WEBPACK_IMPORTED_MODULE_4__MarketoActivityOption__["a" /* default */], {
                  key: index,
                  activityIndex: index,
                  activity: activity,
                  mappedActivities: activities,
                  updateActivities: _this3.updateActivities,
                  deleteActivity: _this3.deleteActivity
                });
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'marketo-activity-mapper-footer' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Integration_components_AddButton_index__["a" /* default */], {
            className: 'add-drift-activity-button',
            addButtonLabel: 'Add Drift Activity',
            type: 'tertiary',
            onClick: this.addActivity
          })
        )
      );
    }
  }]);

  return MarketoActivityMapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_shared_notifications__["a" /* default */])(MarketoActivityMapper));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "O27J":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(69);

/***/ }),

/***/ "O2cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = __webpack_require__("W+Sr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subscription__ = __webpack_require__("B00U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_phoenix_socket__ = __webpack_require__("4FSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_phoenix_socket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_phoenix_socket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_message_actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__("cRAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors__ = __webpack_require__("P/TS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__("b2Ql");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AUTO_JOIN_CHANNELS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var AUTO_JOIN_CHANNELS = (_AUTO_JOIN_CHANNELS = {}, _defineProperty(_AUTO_JOIN_CHANNELS, __WEBPACK_IMPORTED_MODULE_11__constants__["v" /* SocketCluster */].MESSAGES, [__WEBPACK_IMPORTED_MODULE_11__constants__["u" /* SocketChannel */].ORG_PRIVATE, __WEBPACK_IMPORTED_MODULE_11__constants__["u" /* SocketChannel */].USER]), _defineProperty(_AUTO_JOIN_CHANNELS, __WEBPACK_IMPORTED_MODULE_11__constants__["v" /* SocketCluster */].PUSH, [__WEBPACK_IMPORTED_MODULE_11__constants__["u" /* SocketChannel */].ORG_PRIVATE]), _AUTO_JOIN_CHANNELS);

var makeClusterEpic = function makeClusterEpic(clusterName) {
  var authenticateEpic = function authenticateEpic(action$, store) {
    return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* AUTHENTICATE */]).pluck('payload').filter(function (payload) {
      return payload.clusterName === clusterName;
    }).map(function () {
      var state = store.getState();
      return {
        apiBaseUrl: __WEBPACK_IMPORTED_MODULE_12__selectors__["c" /* getApiBaseUrl */](state, { clusterName: clusterName }),
        authParams: __WEBPACK_IMPORTED_MODULE_12__selectors__["d" /* getAuthParams */](state, { clusterName: clusterName })
      };
    }).switchMap(function (payload) {
      return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* authenticate */](payload).map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_10__actions__["d" /* authenticateSuccess */](_extends({ clusterName: clusterName }, data));
      }).startWith(__WEBPACK_IMPORTED_MODULE_10__actions__["c" /* authenticatePending */]({ clusterName: clusterName })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_6_utils_SentryHelpers__["a" /* captureException */])(error, { extra: { clusterName: clusterName } });
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_10__actions__["b" /* authenticateFailure */]({ clusterName: clusterName, error: error }));
      });
    });
  };

  var connectEpic = function connectEpic(action$, store) {
    return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* AUTHENTICATE_SUCCESS */]).pluck('payload').filter(function (payload) {
      return payload.clusterName === clusterName;
    }).switchMap(function (_ref) {
      var sessionToken = _ref.sessionToken;

      var joinChannel$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["j" /* JOIN_CHANNEL */]).pluck('payload').filter(function (payload) {
        return payload.clusterName === clusterName;
      });

      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
        var socket = new __WEBPACK_IMPORTED_MODULE_5_phoenix_socket__["Socket"](__WEBPACK_IMPORTED_MODULE_12__selectors__["g" /* getWssBaseUrl */](store.getState(), { clusterName: clusterName }) + '/ws', {
          params: { session_token: sessionToken },
          /**
           * If a Socket receives and error (onError) or becomes disconnected
           * (onClose), it will automatically attempt to reconnect after the
           * timeout returned from this function.
           *
           * If a Channel receives an error (onError) or could not be joined
           * (join().receive('error' | 'timeout')), it will automatically
           * attempt to rejoin after the timeout returned from this function.
           *
           * The `attempt` argument is incremented by 1 each time it is called
           * until successful reconnect or rejoin.
           *
           * We dispatch an action to keep track of when reconnect/rejoin
           * attempts have been queued so that we may display a countdown
           * timer to the user.
           */
          reconnectAfterMs: function reconnectAfterMs(attempt) {
            var timeUntilReconnect = [1000, 2000, 5000, 10000][attempt - 1] || 10000;
            observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["p" /* socketReconnectAttemptQueued */]({ clusterName: clusterName, timeUntilReconnect: timeUntilReconnect }));
            return timeUntilReconnect;
          }
        });

        var awaitingInitialConnection = true;

        socket.onOpen(function () {
          observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["o" /* socketOpenEventReceived */]({ clusterName: clusterName }));

          if (!awaitingInitialConnection) {
            var channelsToJoin = __WEBPACK_IMPORTED_MODULE_12__selectors__["a" /* channelsToJoin */](store.getState(), { clusterName: clusterName });
            channelsToJoin.forEach(function (channel) {
              channel.rejoinUntilConnected();
            });
          }

          awaitingInitialConnection = false;
        });

        socket.onError(function () {
          observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["n" /* socketErrorEventReceived */]({ clusterName: clusterName }));
        });

        socket.onClose(function () {
          observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["m" /* socketCloseEventReceived */]({ clusterName: clusterName }));
        });

        var subscription = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subscription__["Subscription"]();

        subscription.add(joinChannel$.subscribe({
          next: function next(_ref2) {
            var channelName = _ref2.channelName;

            var channel = socket.channel(__WEBPACK_IMPORTED_MODULE_12__selectors__["e" /* getChannelName */](store.getState(), { clusterName: clusterName, channelName: channelName }));

            var onMessageSubject = new __WEBPACK_IMPORTED_MODULE_4_rxjs_Subject__["Subject"]();

            channel.onError(function () {
              observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["f" /* channelErrorEventReceived */]({ clusterName: clusterName, channelName: channelName }));
            });

            channel.onClose(function () {
              observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["e" /* channelCloseEventReceived */]({ clusterName: clusterName, channelName: channelName }));
            });

            channel.onMessage = function (event, payload, ref) {
              onMessageSubject.next({
                event: event,
                payload: payload,
                ref: ref
              });
              return payload;
            };

            var leaveChannel$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["n" /* LEAVE_CHANNEL */]).filter(function (_ref3) {
              var payload = _ref3.payload;
              return payload.clusterName === clusterName;
            }).filter(function (_ref4) {
              var payload = _ref4.payload;
              return payload.channelName === channelName;
            }).map(function () {
              return channel.leave();
            });

            observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["j" /* joinChannelPending */]({
              clusterName: clusterName,
              channelName: channelName,
              channel: channel,
              onMessageSubject: onMessageSubject,
              leaveChannel$: leaveChannel$
            }));

            channel.join().receive('ok', function () {
              observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["k" /* joinChannelSuccess */]({
                clusterName: clusterName,
                channelName: channelName,
                channel: channel,
                leaveChannel$: leaveChannel$
              }));
            }).receive('error', function (error) {
              observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["i" /* joinChannelFailure */]({
                clusterName: clusterName,
                channelName: channelName,
                channel: channel,
                error: error
              }));
            }).receive('timeout', function () {
              observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["i" /* joinChannelFailure */]({
                clusterName: clusterName,
                channelName: channelName,
                channel: channel,
                error: 'The request has timed out. please try again later'
              }));
            });
          }
        }));

        socket.connect();

        observer.next(__WEBPACK_IMPORTED_MODULE_10__actions__["g" /* connect */]({
          clusterName: clusterName,
          socket: socket
        }));

        return function () {
          socket.disconnect(function () {
            subscription.unsubscribe();
          });
        };
      }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["i" /* DISCONNECT */]));
    });
  };

  /**
   * Listens for queued Socket reconnect / Channel rejoin attempts.
   * When an attempt is queued, we setup an interval to fire off a
   * `SOCKET_RECONNECT_TIMER_TICKED` action every second. When this action
   * reaches the reducer, the `timeUntilReconnect` value is updated by
   * subtracting 1 second. This allows us to show the user how many seconds are
   * remaining before we automatically attempt to reconnect.
   *
   * Note that the timer will tick every second until a channel is successfully
   * rejoined, closed gracefully, or the socket is opened or disconnected AND
   * there are no remaining channels left to join.
   */
  var socketReconnectTimerEpic = function socketReconnectTimerEpic(action$, store) {
    return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["r" /* SOCKET_RECONNECT_ATTEMPT_QUEUED */]).pluck('payload').filter(function (payload) {
      return payload.clusterName === clusterName;
    }).switchMap(function (payload) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].interval(1000).mapTo(__WEBPACK_IMPORTED_MODULE_10__actions__["q" /* socketReconnectTimerTicked */]({
        clusterName: payload.clusterName,
        timePassed: 1000
      })).takeUntil(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["q" /* SOCKET_OPEN_EVENT_RECEIVED */], __WEBPACK_IMPORTED_MODULE_11__constants__["m" /* JOIN_CHANNEL_SUCCESS */], __WEBPACK_IMPORTED_MODULE_11__constants__["e" /* CHANNEL_CLOSE_EVENT_RECEIVED */], __WEBPACK_IMPORTED_MODULE_11__constants__["i" /* DISCONNECT */]).pluck('payload').filter(function (payload) {
        return payload.clusterName === clusterName;
      }).filter(function () {
        return !__WEBPACK_IMPORTED_MODULE_12__selectors__["a" /* channelsToJoin */](store.getState(), { clusterName: clusterName }).count();
      }), __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].timer(payload.timeUntilReconnect)));
    });
  };

  var joinChannelEpic = function joinChannelEpic(action$, store) {
    return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* CONNECT */]).pluck('payload').filter(function () {
      return !(__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["p" /* hasSplitEndUserChannel */](store.getState()) && clusterName === __WEBPACK_IMPORTED_MODULE_11__constants__["v" /* SocketCluster */].PUSH);
    }).filter(function (payload) {
      return payload.clusterName === clusterName;
    }).flatMap(function () {
      return AUTO_JOIN_CHANNELS[clusterName].map(function (channelName) {
        return __WEBPACK_IMPORTED_MODULE_10__actions__["h" /* joinChannel */]({ clusterName: clusterName, channelName: channelName });
      });
    });
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(authenticateEpic, connectEpic, socketReconnectTimerEpic, joinChannelEpic);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(makeClusterEpic(__WEBPACK_IMPORTED_MODULE_11__constants__["v" /* SocketCluster */].MESSAGES), makeClusterEpic(__WEBPACK_IMPORTED_MODULE_11__constants__["v" /* SocketCluster */].PUSH)));

/***/ }),

/***/ "O812":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>link-2</title><desc>Created with Sketch.</desc><defs></defs><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"message-copy\" transform=\"translate(-464.000000, -710.000000)\" fill=\"#425964\"><g id=\"link-2\" transform=\"translate(464.000000, 710.000000)\"><path d=\"M18.3536,8.1792 L15.6032,10.9744 C15.296,11.2864 14.7984,11.2864 14.4912,10.9744 C14.184,10.6624 14.184,10.1568 14.4912,9.844 L17.2416,7.0496 C17.7496,6.5336 18.0296,5.8472 18.0296,5.1184 C18.0296,4.3888 17.7496,3.7024 17.2416,3.1864 C16.2248,2.1552 14.4552,2.1544 13.44,3.1864 L9.4144,7.2752 C8.3672,8.3408 8.3672,10.0736 9.4144,11.1376 C9.5528,11.2784 9.7056,11.4032 9.8704,11.5112 C10.236,11.7488 10.3432,12.2432 10.108,12.6152 C9.9584,12.8536 9.7048,12.9832 9.4456,12.9832 C9.3,12.9832 9.1528,12.9424 9.0216,12.856 C8.7616,12.6872 8.5192,12.4888 8.3016,12.2672 C6.6416,10.5808 6.6416,7.8344 8.3024,6.1448 L12.328,2.0568 C13.1328,1.2392 14.2024,0.7888 15.3408,0.7888 C16.4792,0.7888 17.5488,1.2392 18.3536,2.0568 C19.1592,2.8744 19.6024,3.9608 19.6024,5.1184 C19.6024,6.2744 19.1592,7.3616 18.3536,8.1792 Z M6.9512,17.5944 L10.9768,13.5048 C11.4848,12.9888 11.7648,12.3032 11.7648,11.5736 C11.7648,10.844 11.4848,10.1584 10.9768,9.6424 C10.8432,9.5072 10.6968,9.3864 10.5424,9.284 C10.1792,9.0432 10.076,8.5472 10.3136,8.1776 C10.5512,7.8088 11.0384,7.7056 11.4016,7.9448 C11.6472,8.108 11.8776,8.2984 12.0888,8.512 C12.8944,9.3304 13.3376,10.4168 13.3376,11.5736 C13.3376,12.7304 12.8944,13.8168 12.0888,14.6344 L8.0632,18.7248 C7.2328,19.568 6.1408,19.9904 5.0504,19.9904 C3.9592,19.9904 2.868,19.5688 2.0376,18.7248 C0.3752,17.0368 0.3752,14.2888 2.0376,12.6016 L4.7784,9.816 C5.0856,9.504 5.5832,9.504 5.8904,9.816 C6.1976,10.1288 6.1976,10.6344 5.8904,10.9464 L3.1496,13.7312 C2.6416,14.2472 2.3624,14.9328 2.3624,15.6624 C2.3624,16.3928 2.6416,17.0784 3.1496,17.5944 C4.1984,18.66 5.9032,18.6576 6.9512,17.5944 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "O9CT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__ = __webpack_require__("1WKC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_queries_ApiKeyQueries__ = __webpack_require__("DYVe");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var ApiKeyStore = Marty.createStore({
  id: 'ApiKeyStore',

  getInitialState: function getInitialState() {
    return {
      apiKey: {}
    };
  },


  handlers: {
    getApiKeyDone: __WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].GET_API_KEY_DONE,
    createApiKeyDone: __WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].CREATE_API_KEY_DONE
  },

  getApiKeyDone: function getApiKeyDone(apiKey) {
    if (!this.setApiKey(apiKey)) {
      var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
      return this.createApiKey(orgId);
    }
  },
  getApiKeyForCurrentOrg: function getApiKeyForCurrentOrg() {
    return this.fetch({
      id: 'getApiKey',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        if (this.hasAlreadyFetched('getApiKey')) {
          return this.state.apiKey;
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.ApiKeyQueries.getApiKeyByOrgId(orgId);
      }
    });
  },
  createApiKey: function createApiKey(orgId) {
    return this.app.queries.ApiKeyQueries.createApiKeyForOrgId(orgId);
  },
  createApiKeyDone: function createApiKeyDone(apiKey) {
    return this.setApiKey(apiKey);
  },
  setApiKey: function setApiKey(apiKey) {
    if (!_.isEmpty(apiKey)) {
      this.setState({ apiKey: apiKey[0] });
      return true;
    } else {
      return false;
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ApiKeyStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "OAum":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OBXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__("2247");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var closeSRC = __webpack_require__("vhf4");

var DefaultDisabledState = function DefaultDisabledState() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'assistant-settings-column' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SFDC-value-row' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], { placeholder: 'SFDC value...', disabled: 'true' })
    )
  );
};

var SFDCValues = function (_React$Component) {
  _inherits(SFDCValues, _React$Component);

  function SFDCValues(props) {
    _classCallCheck(this, SFDCValues);

    var _this = _possibleConstructorReturn(this, (SFDCValues.__proto__ || Object.getPrototypeOf(SFDCValues)).call(this, props));

    _this.addEmptyValue = function () {
      _this.setState({ canAddEmptyValue: false });
      _this.props.inputHandler('', _this.props.sfValueSelections.size, _this.props.sfField);
    };

    _this.inputHandlerWrapper = function (value, index, sfField) {
      _this.setState({ canAddEmptyValue: true });
      _this.props.inputHandler(value, index, sfField);
    };

    _this.removeHandlerWrapper = function (index, sfField) {
      if (_this.props.filteredSelections.size !== _this.props.sfValueSelections.size) {
        _this.setState({ canAddEmptyValue: false });
      }
      _this.props.removeHandler(index, sfField);
      if (_this.props.filteredSelections.size === 1) {
        _this.props.removeFieldHandler();
      }
    };

    _this.salesforceFieldValueOptionsHelper = function (sfFieldValue, isPicklist, index) {
      var _this$props = _this.props,
          sfField = _this$props.sfField,
          sfFieldValuesKey = _this$props.sfFieldValuesKey,
          salesforceSettings = _this$props.salesforceSettings;

      var salesforceFieldValueOptions = {
        autoFocus: sfFieldValue === '',
        placeholder: 'SFDC value...',
        disabled: !sfField,
        value: sfFieldValue,
        onChange: function onChange(event) {
          return _this.inputHandlerWrapper(event.target.value, index, sfField);
        }
      };
      var salesforceFieldPicklistValueOptions = {
        autoFocus: sfFieldValue === '',
        multi: false,
        clearable: false,
        placeholder: 'SFDC value...',
        disabled: !sfField,
        value: sfFieldValue,
        onChange: function onChange(_ref) {
          var value = _ref.value;
          return _this.inputHandlerWrapper(value, index, sfField);
        }
      };

      if (sfField && isPicklist) {
        salesforceFieldPicklistValueOptions['options'] = salesforceSettings.get(sfFieldValuesKey)[sfField]['picklistValues'];
      }

      return { salesforceFieldValueOptions: salesforceFieldValueOptions, salesforceFieldPicklistValueOptions: salesforceFieldPicklistValueOptions };
    };

    _this.state = {
      canAddEmptyValue: props.filteredSelections.size === props.sfValueSelections.size
    };
    return _this;
  }

  _createClass(SFDCValues, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.sfValueSelections.size === 0) {
        this.addEmptyValue();
      }
    }
  }, {
    key: 'renderSFDCValue',
    value: function renderSFDCValue(sfField, sfFieldValue, index, salesforceSettings, sfFieldValuesKey, isPicklist) {
      var _this2 = this;

      var _salesforceFieldValue = this.salesforceFieldValueOptionsHelper(sfFieldValue, isPicklist, index),
          salesforceFieldValueOptions = _salesforceFieldValue.salesforceFieldValueOptions,
          salesforceFieldPicklistValueOptions = _salesforceFieldValue.salesforceFieldPicklistValueOptions;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'SFDC-value-row', key: 'SFDC-value-' + index },
        isPicklist ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Select"], salesforceFieldPicklistValueOptions) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], salesforceFieldValueOptions),
        sfFieldValue && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'remove-value-button' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: closeSRC, onClick: function onClick() {
              return _this2.removeHandlerWrapper(index, sfField);
            } })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          sfField = _props.sfField,
          sfValueSelections = _props.sfValueSelections,
          filteredSelections = _props.filteredSelections,
          salesforceSettings = _props.salesforceSettings,
          sfFieldValuesKey = _props.sfFieldValuesKey;
      var canAddEmptyValue = this.state.canAddEmptyValue;

      var isPicklist = sfField ? salesforceSettings.get(sfFieldValuesKey)[sfField]['valueType'] === 'picklist' : false;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'assistant-settings-column' },
        __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(sfValueSelections.toJS(), function (sfFieldValue, index) {
          return _this3.renderSFDCValue(sfField, sfFieldValue, index, salesforceSettings, sfFieldValuesKey, isPicklist);
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'input-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'SFDC-add-value-row' },
            filteredSelections.size > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
              {
                type: 'subtle',
                className: 'SFDC-add-value-button',
                disabled: !canAddEmptyValue,
                onClick: this.addEmptyValue
              },
              '+ Add Value'
            )
          )
        )
      );
    }
  }]);

  return SFDCValues;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state, props) {
    var sfObjectType = props.sfObjectType;


    var salesforceSettings = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__["r" /* salesforceLeadSettings */])(state);
    var sfFieldValuesKey = 'leadFieldValues';
    switch (sfObjectType) {
      case 'CONTACT':
        salesforceSettings = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__["p" /* salesforceContactSettings */])(state);
        sfFieldValuesKey = 'contactFieldValues';
        break;
      case 'EVENT':
        salesforceSettings = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__["q" /* salesforceEventSettings */])(state);
        sfFieldValuesKey = 'eventFieldValues';
        break;
      case 'TASK':
        salesforceSettings = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__["s" /* salesforceTaskSettings */])(state);
        sfFieldValuesKey = 'taskFieldValues';
        break;
    }

    return {
      salesforceSettings: salesforceSettings,
      sfFieldValuesKey: sfFieldValuesKey
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.sfField;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(DefaultDisabledState)), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.orgSettings;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]))(SFDCValues));

/***/ }),

/***/ "ODkj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_api_TimeZoneAPI__ = __webpack_require__("Zhpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Banner_js__ = __webpack_require__("N30b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Information_js__ = __webpack_require__("CyFg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InformationEdit_js__ = __webpack_require__("BFyV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__("aotX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_styles_colors__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var TitleCard = function (_Component) {
  _inherits(TitleCard, _Component);

  function TitleCard() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, TitleCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TitleCard.__proto__ || Object.getPrototypeOf(TitleCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editing: false,
      updating: false,
      endUser: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(_this.props.endUser)
    }, _this.handleNameChange = function (event) {
      _this.setState({ endUser: _this.state.endUser.set('name', event.target.value) });
    }, _this.handleLocationChange = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(suggestion) {
        var _suggestion$location, lat, lng, timezone, city, country;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _suggestion$location = suggestion.location, lat = _suggestion$location.lat, lng = _suggestion$location.lng;
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9_app_api_TimeZoneAPI__["a" /* fetchTimeZone */])(lat, lng);

              case 3:
                timezone = _context.sent;
                city = suggestion.gmaps.address_components.find(function (component) {
                  return component.types.find(function (type) {
                    return type === 'locality';
                  });
                });
                country = suggestion.gmaps.address_components.find(function (component) {
                  return component.types.find(function (type) {
                    return type === 'country';
                  });
                });

                _this.setState({
                  endUser: _this.state.endUser.setIn(['attributes', 'display_location'], suggestion.label).setIn(['attributes', 'latitude'], lat).setIn(['attributes', 'longitude'], lng).setIn(['attributes', 'city'], city.long_name).setIn(['attributes', 'country'], country.long_name).set('timeZone', timezone.timeZoneId)
                });

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.handleEdit = function () {
      _this.setState({ editing: true });
    }, _this.handleCancel = function () {
      _this.setState({
        endUser: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(_this.props.endUser),
        editing: false
      });
    }, _this.handleSave = function () {
      if (!_this.isChanged()) return;
      __WEBPACK_IMPORTED_MODULE_6_containers_app__["a" /* default */].queries.EndUserQueries.updateEndUser(_this.props.endUser.id, _this.state.endUser.toJS());
      _this.setState({ updating: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TitleCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.fetchEmbed();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.updating && Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["is"])(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(nextProps.endUser), this.state.endUser)) {
        this.setState({ editing: false, updating: false });
      }
    }
  }, {
    key: 'isChanged',
    value: function isChanged() {
      return !Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["is"])(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(this.props.endUser), this.state.endUser);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          endUser = _state.endUser,
          editing = _state.editing,
          updating = _state.updating;
      var _props = this.props,
          defaultInboxId = _props.defaultInboxId,
          width = _props.width,
          editable = _props.editable,
          showTooltip = _props.showTooltip,
          showProfileLink = _props.showProfileLink;


      var name = Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(this.state.endUser.toJS());
      var timeZone = endUser.get('timeZone');
      var displayLocation = endUser.getIn(['attributes', 'display_location']);
      var employmentTitle = endUser.getIn(['attributes', 'employment_title']);
      var longitude = endUser.getIn(['attributes', 'longitude']);
      var latitude = endUser.getIn(['attributes', 'latitude']);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        {
          className: 'dsg-card ' + __WEBPACK_IMPORTED_MODULE_13__style___default.a.TitleCard,
          style: {
            width: width,
            background: __WEBPACK_IMPORTED_MODULE_14_styles_colors___default.a['color-white'],
            marginBottom: '1rem'
          }
        },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Banner_js__["a" /* default */], {
          longitude: longitude,
          latitude: latitude,
          displayLocation: displayLocation,
          editing: editing,
          updating: updating,
          editable: editable,
          handleEdit: this.handleEdit,
          handleSave: this.handleSave,
          handleCancel: this.handleCancel,
          changed: this.isChanged(),
          endUser: endUser.toJS(),
          timeZone: timeZone
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { style: { padding: '3px 14px 14px' } },
          editing ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__InformationEdit_js__["a" /* default */], {
            name: name,
            displayLocation: displayLocation,
            handleSave: this.handleSave,
            handleNameChange: this.handleNameChange,
            handleLocationChange: this.handleLocationChange
          }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Information_js__["a" /* default */], {
            showProfileLink: showProfileLink,
            showTooltip: showTooltip,
            employmentTitle: employmentTitle,
            editable: editable,
            endUser: this.props.endUser,
            name: name,
            inboxId: defaultInboxId,
            handleEdit: editable && this.handleEdit
          })
        )
      );
    }
  }]);

  return TitleCard;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

TitleCard.defaultProps = {
  editable: true,
  width: '100%'
};


function mapStateToProps(state) {
  return {
    defaultInboxId: __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["b" /* defaultInboxId */](state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      fetchEmbed: __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_actions__["a" /* fetchEmbed */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(TitleCard));

/***/ }),

/***/ "OHI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rootUI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return query; });
/* unused harmony export draft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__("inMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("s+vs");






var rootUI = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3__selectors__["d" /* root */], function (root) {
  return root.get('ui');
});

var query = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(rootUI, function (rootUI) {
  return rootUI.get('query', "");
});

var draft = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(rootUI, __WEBPACK_IMPORTED_MODULE_2_app_modules_inbox_selectors__["d" /* inboxOptions */], __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__["currentUser"], function (rootUI, inboxOptions, currentUser) {
  return rootUI.get('draft', Object(__WEBPACK_IMPORTED_MODULE_4__models__["a" /* parseBotCampaign */])({
    inboxId: !!inboxOptions && inboxOptions.size > 1 && inboxOptions.valueSeq().first().get('value'),
    attributes: { senderId: currentUser.id }
  }));
});

/***/ }),

/***/ "OK4y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"WelcomeMessage":"WelcomeMessage---2R7Av"};

/***/ }),

/***/ "OK9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OMDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__ = __webpack_require__("IX9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var EndUserTokenQueries = Marty.createQueries({
  id: 'EndUserTokenQueries',

  getEndUserToken: function getEndUserToken(orgId, email, leadId, userId, version) {
    var _this = this;

    var promise = this.app.sources.EndUserTokenAPI.getEndUserToken(orgId, email, leadId, userId, version);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__["a" /* default */].GET_END_USER_TOKEN_DONE, orgId, email, leadId, userId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__["a" /* default */].GET_END_USER_TOKEN_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__["a" /* default */].GET_END_USER_TOKEN_FAILED, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserTokenQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "OOF1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ORV9":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.15 20.16H.85a.845.845 0 0 1-.85-.84v-.56c0-3.485 2.618-6.521 6.1-7.504-2.088-.914-3.55-2.978-3.55-5.376C2.55 2.638 5.219 0 8.5 0s5.95 2.638 5.95 5.88c0 2.398-1.462 4.462-3.55 5.376 3.482.983 6.1 4.02 6.1 7.504v.56c0 .464-.38.84-.85.84zm-3.4-14.28c0-2.316-1.907-4.2-4.25-4.2s-4.25 1.884-4.25 4.2c0 2.316 1.907 4.2 4.25 4.2s4.25-1.884 4.25-4.2zM8.5 12.6c-3.583 0-6.625 2.665-6.792 5.88h13.584c-.167-3.215-3.21-5.88-6.792-5.88z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "OTri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("7IUX");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("inMS");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectorsUI__ = __webpack_require__("OHI1");
/* unused harmony reexport selectorsUI */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epic__ = __webpack_require__("l2mm");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reducer__ = __webpack_require__("2olE");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__reducer__["a"]; });











/***/ }),

/***/ "OUXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelProps; });
var LabelProps = {
  className: "color-navy-dark dsg-Small",
  style: { textTransform: 'uppercase' }
};

function ReadOnlyRow(_ref) {
  var label = _ref.label,
      body = _ref.body,
      enterPrompt = _ref.enterPrompt,
      onEditing = _ref.onEditing,
      isLast = _ref.isLast;

  var style = isLast ? null : { marginBottom: 18 };
  var displayBody = body ? React.createElement(
    "div",
    { className: "dsg-Body" },
    body
  ) : React.createElement(
    "div",
    {
      className: "dsg-Body color-navy",
      onClick: onEditing,
      style: { cursor: 'pointer' }
    },
    enterPrompt
  );

  return React.createElement(
    "div",
    { style: style },
    React.createElement(
      "div",
      LabelProps,
      label
    ),
    displayBody
  );
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReadOnlyRow);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "OWv3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return makeHasGate; });
/* unused harmony export hasStandardTrial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasProPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasStarterPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasCompanyPlan; });
/* unused harmony export isOnStandardPlan */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isOnFreePlan; });
/* unused harmony export hasOutboundPlaybooksGate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasCentralizedRouting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hasLimitNumberOfChats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasBulkMessageRead; });
/* unused harmony export hasSequenceTestEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasDemoOrg; });
/* unused harmony export hasNewConversationReports */
/* unused harmony export hasMarketingSequence */
/* unused harmony export hasSalesCalendaring */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return hasMeetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasTeamHours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return hasSplitEndUserChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasPresence; });
/* unused harmony export hasMadKudu */
/* unused harmony export hasWidgetCustomization */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return hasNewConvoExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasBetaBulkClose; });
/* unused harmony export hasNewSendFlow */
/* unused harmony export hasCompactConversationHeader */
/* unused harmony export hasClearbitReveal */
/* unused harmony export hasBetaEnrichment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasBetaGlobalCalendars; });
/* unused harmony export hasPublicShiypard */
/* unused harmony export hasConversationRatingAgentDrop */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasWebSocketChatNotifications; });
/* unused harmony export hasInviteViaRoundRobinToTeam */
/* unused harmony export hasClassificationNotifications */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hasInboxFilterSidebar; });
/* unused harmony export killOneTimeEmailSends */
/* unused harmony export hasNewConversationSidebar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disableNewMessageComposer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseCompanyTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);



var getGates = function getGates(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_user_selectors__["currentUserLoaded"])(state) && Object(__WEBPACK_IMPORTED_MODULE_0_app_modules_user_selectors__["currentUser"])(state).gates;
};
var makeHasGate = function makeHasGate(gate) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getGates, function (gates) {
    return gates && gates.get(gate);
  });
};
var hasStandardTrial = makeHasGate('standard_trial');
var hasProPlan = makeHasGate('premium_team');
var hasStarterPlan = makeHasGate('premium_drift');
var hasCompanyPlan = makeHasGate('premium_enterprise');
var isOnStandardPlan = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([hasStarterPlan, hasProPlan, hasCompanyPlan], function (hasStarterPlan, hasProPlan, hasCompanyPlan) {
  return hasStarterPlan && !hasProPlan && !hasCompanyPlan;
});
var isOnFreePlan = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([hasProPlan, hasStarterPlan, hasCompanyPlan, hasStandardTrial], function (hasProPlan, hasStarterPlan, hasCompanyPlan, hasStandardTrial) {
  return [hasProPlan, hasStarterPlan, hasCompanyPlan, hasStandardTrial].every(function (isOnPlan) {
    return !isOnPlan;
  });
});
var hasOutboundPlaybooksGate = function hasOutboundPlaybooksGate(state) {
  return makeHasGate('outbound_playbooks')(state);
};
var hasCentralizedRouting = makeHasGate('CENTRALIZED_ROUTING');
var hasLimitNumberOfChats = makeHasGate('has_limit_num_chats');
var hasBulkMessageRead = function hasBulkMessageRead(state) {
  return makeHasGate('has_bulk_message_read')(state);
};
var hasSequenceTestEmail = makeHasGate('has_sequence_test_email');
var hasDemoOrg = function hasDemoOrg(state) {
  return makeHasGate('has_demo_org')(state);
};
var hasNewConversationReports = makeHasGate('has_new_conversation_reports');
var hasMarketingSequence = makeHasGate('has_marketing_sequences');
var hasSalesCalendaring = makeHasGate('has_sales_calendaring');
var hasMeetings = makeHasGate('has_meetings');
var hasTeamHours = makeHasGate('has_team_hours');
var hasSplitEndUserChannel = makeHasGate('has_split_end_user_channel');
var hasPresence = makeHasGate('has_presence');
var hasMadKudu = makeHasGate('has_madkudu');
var hasWidgetCustomization = makeHasGate('has_widget_customization');
var hasNewConvoExport = makeHasGate('has_new_convo_export');
var hasBetaBulkClose = makeHasGate('beta_bulk_close');
var hasNewSendFlow = makeHasGate('has_new_send_flow');
var hasCompactConversationHeader = makeHasGate('has_compact_conversation_header');
var hasClearbitReveal = makeHasGate('has_reveal');
var hasBetaEnrichment = makeHasGate('has_beta_enrichment');
var hasBetaGlobalCalendars = makeHasGate('has_beta_global_calendars');
var hasPublicShiypard = makeHasGate('has_public_shipyard');
var hasConversationRatingAgentDrop = makeHasGate('has_conversation_rating_drop');
var hasWebSocketChatNotifications = makeHasGate('web_socket_chat_notifications');
var hasInviteViaRoundRobinToTeam = makeHasGate('invite_via_round_robin_to_team_beta');
var hasClassificationNotifications = makeHasGate('has_classification_notifications');
var hasInboxFilterSidebar = makeHasGate('has_inbox_filter_sidebar');
var killOneTimeEmailSends = makeHasGate('kill_one_time_email_sends');
var hasNewConversationSidebar = makeHasGate('NEW_CONVERSATION_SIDEBAR');
var disableNewMessageComposer = makeHasGate('disable_new_message_composer');
var canUseCompanyTags = makeHasGate('can_use_company_tags');

/***/ }),

/***/ "Oa/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PreviewState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__("Pq8k");


var PreviewState = {
  ONLINE: 'online',
  AWAY: 'away'
};

var Messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* defineMessages */])({
  typeMessage: {
    id: 'app.widget.placeholder',
    description: 'Composer placeholder',
    defaultMessage: 'Type your message...'
  },
  defaultWelcomeMessage: {
    id: 'app.widget.defaultWelcomeMessage',
    description: 'Message greeting that appears on the New Conversation screen',
    defaultMessage: 'How can we help out? We are here for you!'
  },
  defaultAwayMessage: {
    id: 'app.widget.defaultAwayMessage',
    description: 'Message shown to a user indicating that the Team is currently away or offline',
    defaultMessage: 'We’re not currently online right now but if you leave a message, we’ll get back to you as soon as possible!'
  }
});

/***/ }),

/***/ "Ocgb":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 37 35\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.61 12.09v22.9h7.37v-22.9H1.61zm19.166 9.603c0-2.954 1.884-4.432 4.095-4.432 2.213 0 4.015 1.48 4.015 5.172V34.99h7.37V21.692c0-6.648-3.684-10.34-8.845-10.34-2.948 0-5.16 1.682-6.634 3.898l-.246-3.16h-7.25c0 .78.124 5.17.124 5.17v17.73h7.372V21.692zM5.254 8.398c2.744 0 4.464-1.806 4.464-4.063C9.678 2.037 7.998.273 5.336.273 2.633.273.872 2.037.872 4.335c0 2.257 1.72 4.063 4.34 4.063h.042z\" fill=\"currentColor\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "OczV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Oe5r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify__ = __webpack_require__("OvQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WelcomeMessageHeader__ = __webpack_require__("LCi6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons__ = __webpack_require__("/EMc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WelcomeMessageCard__ = __webpack_require__("nsRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_PlaybookPreviews_WelcomeMessage_welcomeMessage__ = __webpack_require__("DvTU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("/sFR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var MissingFonts = ['Lato', 'Open+Sans', 'Roboto+Slab', 'Overpass'];

var WelcomeMessage = function (_Component) {
  _inherits(WelcomeMessage, _Component);

  function WelcomeMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WelcomeMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WelcomeMessage.__proto__ || Object.getPrototypeOf(WelcomeMessage)).call.apply(_ref, [this].concat(args))), _this), _this.loadMissingFonts = function () {
      MissingFonts.forEach(function (font) {
        var $linkTag = document.createElement('link');
        $linkTag.rel = 'stylesheet';
        $linkTag.href = 'https://fonts.googleapis.com/css?family=' + font + '|' + font + ':bold&display=swap';
        document.body && document.body.appendChild($linkTag);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WelcomeMessage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadMissingFonts();
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _props = this.props,
          showProfileIcon = _props.showProfileIcon,
          showDismissIcon = _props.showDismissIcon,
          onProfileClick = _props.onProfileClick,
          onDismissClick = _props.onDismissClick;

      return [showProfileIcon && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons__["b" /* ProfileIcon */], { key: 'profile', onClick: onProfileClick }), showDismissIcon && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons__["a" /* DismissIcon */], { key: 'dismiss', onClick: onDismissClick })].filter(Boolean);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          users = _props2.users,
          message = _props2.message,
          backgroundColor = _props2.backgroundColor,
          foregroundColor = _props2.foregroundColor,
          children = _props2.children,
          isHTMLPreview = _props2.isHTMLPreview,
          callToAction = _props2.callToAction;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_PlaybookPreviews_WelcomeMessage_welcomeMessage__["a" /* default */], {
        users: users,
        backgroundColor: backgroundColor,
        message: message,
        isHTMLPreview: isHTMLPreview,
        callToAction: callToAction
      });
    }
  }]);

  return WelcomeMessage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

WelcomeMessage.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  message: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,
  users: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  foregroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  showProfileIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onProfileClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  showDismissIcon: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  onDismissClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  isHTMLPreview: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
WelcomeMessage.defaultProps = {
  users: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
  isHTMLPreview: false
};


/* harmony default export */ __webpack_exports__["a"] = (WelcomeMessage);

/***/ }),

/***/ "OeZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_TooltipAvatar__ = __webpack_require__("gBvH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var personIcon = __webpack_require__("mXkB");
var arrowIcon = __webpack_require__("MSQN");

var types = {
  PARTICIPANT: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'participant-add-heading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: personIcon }),
    ' Add Participant'
  ),
  SALESFORCE_PARTICIPANT: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'participant-add-heading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: personIcon }),
    ' Add Participant'
  ),
  ABM_PARTICIPANT: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'participant-add-heading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: personIcon }),
    ' Add Drift Account Owner'
  ),
  LEANDATA_PARTICIPANT: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'participant-add-heading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: personIcon }),
    ' Add LeanData Account Owner'
  )
};

var RuleActions = function (_Component) {
  _inherits(RuleActions, _Component);

  function RuleActions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RuleActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RuleActions.__proto__ || Object.getPrototypeOf(RuleActions)).call.apply(_ref, [this].concat(args))), _this), _this.subTypes = function () {
      return {
        PARTICIPANT: _this.renderActionSet,
        SALESFORCE_PARTICIPANT: _this.salesforceSubType,
        ABM_PARTICIPANT: _this.targetedAccountsSubType,
        LEANDATA_PARTICIPANT: _this.leandataSubType
      };
    }, _this.renderTeam = function () {
      var _this$props = _this.props,
          action = _this$props.action,
          teams = _this$props.teams;


      if (action.options.teamId) {
        var team = teams.find(function (x) {
          return x.id === action.options.teamId;
        });
        if (team) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'participant-avatar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_TooltipAvatar__["a" /* default */], { tooltipName: team.name, type: 'team', team: team })
          );
        }
      }
    }, _this.renderLink = function () {
      var isActive = _this.props.activePage === "actionEditor";
      var activeClass = isActive ? 'active' : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          _this.displayType(_this.props.action.type)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: activeClass + ' action-preview-link' },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: arrowIcon }),
          'Choose Action'
        )
      );
    }, _this.renderActionSet = function () {
      var action = _this.props.action;

      var hasUserIds = !!action.options.userIds && action.options.userIds.length > 0;
      var isActive = _this.props.activePage === "actionEditor";
      var activeClass = isActive ? 'active' : '';
      var hasNoParticipants = !hasUserIds && !action.options.teamId;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          _this.displayType(_this.props.action.type)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: activeClass + ' action-preview-users' },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: arrowIcon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'action-participant-container' },
            hasNoParticipants && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'action-preview-link' },
              'Choose Participants'
            ),
            !hasUserIds && _this.renderTeam(),
            hasUserIds && _this.renderUsers()
          )
        )
      );
    }, _this.salesforceSubType = function () {
      var isActive = _this.props.activePage === "actionEditor";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          _this.displayType(_this.props.action.type)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('action-preview-users', { isActive: 'active' }) },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: arrowIcon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Account/Contact/Lead Owners'
          )
        )
      );
    }, _this.targetedAccountsSubType = function () {
      var isActive = _this.props.activePage === "actionEditor";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          _this.displayType(_this.props.action.type)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('action-preview-users', { isActive: 'active' }) },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: arrowIcon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Drift Account Owners'
          )
        )
      );
    }, _this.leandataSubType = function () {
      var isActive = _this.props.activePage === "actionEditor";

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          null,
          _this.displayType(_this.props.action.type)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('action-preview-users', { isActive: 'active' }) },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: arrowIcon }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'LeanData Account Owners'
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RuleActions, [{
    key: 'displayType',
    value: function displayType(type) {
      return types[type];
    }
  }, {
    key: 'renderUsers',
    value: function renderUsers() {
      var _props = this.props,
          action = _props.action,
          users = _props.users;

      return action.options.userIds.map(function (userId, index) {
        var user = users[userId];
        if (user) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index, className: 'participant-avatar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_TooltipAvatar__["a" /* default */], { tooltipName: user.name, type: 'user', user: user })
          );
        }
      });
    }
  }, {
    key: 'actionOrLink',
    value: function actionOrLink() {
      if (_.isEmpty(this.props.action)) {
        return this.renderLink();
      }

      return this.subTypes()[this.props.action.type]();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var noFilters = this.props.noFilters;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-actions overview-rule', onClick: function onClick() {
            return _this2.props.setActivePage('actionEditor');
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          noFilters ? 'Add one of the following:' : 'Then do this...'
        ),
        this.actionOrLink()
      );
    }
  }]);

  return RuleActions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_4_app_modules_teams_hoc_withOrgTeams__["a" /* default */])(RuleActions));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Ohub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__ = __webpack_require__("u1z1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesforceLeadRouting__ = __webpack_require__("KWmQ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function mapStateToProps(state) {
  return {
    sfdcObjectList: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["i" /* isSFDCObjectListLoaded */](state),
    sfdcObjectListErr: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["m" /* sfdcObjectListErrStatus */](state),
    sfdcAccountFieldsList: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["e" /* isSFDCAccountFieldsListLoaded */](state),
    sfdcContactFieldsList: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["f" /* isSFDCContactFieldsListLoaded */](state),
    sfdcLeadFieldsList: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["g" /* isSFDCLeadFieldsListLoaded */](state),
    sfdcFieldsListErr: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["k" /* sfdcFieldListErrStatus */](state),
    sfdcLeadRoutingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["h" /* isSFDCLeadRoutingSettingsLoaded */](state),
    sfdcLeadRoutingSettingsErr: __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["l" /* sfdcLeadRoutingSettingsErrStatus */](state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_actions__), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__SalesforceLeadRouting__["a" /* default */]));

/***/ }),

/***/ "OnEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchBannedIPs: function fetchBannedIPs() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].get('/bans').checkStatus().map(function (res) {
      return res.response;
    });
  },
  banIP: function banIP(ip, conversationId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/bans', { ip: ip, conversationId: conversationId }).checkStatus().retryWithBackoff();
  },
  unbanIP: function unbanIP(ip, conversationId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/bans/delete', { ip: ip, conversationId: conversationId }).checkStatus().retryWithBackoff();
  }
};

/***/ }),

/***/ "OnKl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Attribute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_customer_EndUserAttributesCard_helper__ = __webpack_require__("VkOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_PropertyCreator__ = __webpack_require__("lOCj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_customer_CompanyCard_Header__ = __webpack_require__("bbMV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_customer_CompanyCard_CancelAndSave__ = __webpack_require__("h2QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_customer_CompanyCard_Card_styl__ = __webpack_require__("k36k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_customer_CompanyCard_Card_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_customer_CompanyCard_Card_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("UX+c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ViewAllAttributesButton__ = __webpack_require__("sDN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AttributesModal__ = __webpack_require__("tq3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Icon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
  src: __webpack_require__("PnwF"),
  style: { width: 16, height: 11, marginRight: 9 }
});

var EndUserAttributesCardPlaceholder = function EndUserAttributesCardPlaceholder() {
  var placeholderShape = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', { key: 0, x: '0', y: '0', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', { key: 1, x: '0', y: '47', width: '229', height: '27', rx: '2' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('rect', { key: 2, x: '0', y: '94', width: '229', height: '27', rx: '2' })];

  var options = {
    height: 131,
    width: 229,
    primaryColor: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
    secondaryColor: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
    primaryOpacity: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
    secondaryOpacity: __WEBPACK_IMPORTED_MODULE_14_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_11__style_styl__["endUserAttributesCardPlaceholder"] },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 })
  );
};

var EndUserAttributesCard = function (_Component) {
  _inherits(EndUserAttributesCard, _Component);

  function EndUserAttributesCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EndUserAttributesCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EndUserAttributesCard.__proto__ || Object.getPrototypeOf(EndUserAttributesCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showAttributesModal: false,
      showPropertyCreatorModal: false
    }, _this.showAttributesModal = function () {
      _this.setState({ showAttributesModal: true });
    }, _this.closeAttributesModal = function () {
      _this.setState({ showAttributesModal: false });
      _this.props.handleCancel();
    }, _this.showPropertyCreatorModal = function () {
      _this.setState({ showPropertyCreatorModal: true });
    }, _this.closePropertyCreatorModal = function () {
      _this.setState({ showPropertyCreatorModal: false });
      _this.props.handleCancel();
    }, _this.filterRows = function () {
      var _this$props = _this.props,
          contactRows = _this$props.contactRows,
          socialRows = _this$props.socialRows,
          driftRows = _this$props.driftRows,
          customRows = _this$props.customRows,
          enabledAttributes = _this$props.enabledAttributes,
          handleEdit = _this$props.handleEdit,
          editing = _this$props.editing;

      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])().concat(contactRows).concat(socialRows).concat(driftRows).concat(customRows).filter(function (_ref2) {
        var label = _ref2.label;
        return enabledAttributes.has(label);
      }).map(function (row, i) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Attribute, _extends({
          key: i
        }, row, {
          editing: editing,
          handleEdit: handleEdit,
          hideCheckBox: true
        }));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EndUserAttributesCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          changed = _props.changed,
          editing = _props.editing,
          updating = _props.updating,
          handleCancel = _props.handleCancel,
          handleSave = _props.handleSave,
          handleEdit = _props.handleEdit;
      var _state = this.state,
          showAttributesModal = _state.showAttributesModal,
          showPropertyCreatorModal = _state.showPropertyCreatorModal;

      var headerControl = editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_customer_CompanyCard_CancelAndSave__["a" /* default */], {
        updating: updating,
        changed: changed,
        onCancel: handleCancel,
        onSave: handleSave }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'link edit dsg-Body', onClick: handleEdit },
        'Edit'
      );

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'dsg-card ' + __WEBPACK_IMPORTED_MODULE_10_components_customer_CompanyCard_Card_styl__["Card"] + ' ' + __WEBPACK_IMPORTED_MODULE_11__style_styl__["CardWrapper"] + ' ' + this.props.className },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_customer_CompanyCard_Header__["a" /* default */], {
          label: 'About',
          more: headerControl,
          icon: Icon
        }),
        this.filterRows(),
        this.props.hideAllAttributesModal ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { padding: '10 20px' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__ViewAllAttributesButton__["a" /* default */], { onClick: this.showAttributesModal }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'property-creator-modal-open-button drift-button drift-button-tertiary', onClick: this.showPropertyCreatorModal },
            'Create New Contact Attribute'
          )
        ),
        showAttributesModal ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AttributesModal__["a" /* default */], {
          onClose: this.closeAttributesModal,
          endUser: this.props.endUser
        }) : null,
        showPropertyCreatorModal && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_PropertyCreator__["a" /* default */], {
          onClose: this.closePropertyCreatorModal
        })
      );
    }
  }]);

  return EndUserAttributesCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EndUserAttributesCard.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var Attribute = function (_Component2) {
  _inherits(Attribute, _Component2);

  function Attribute() {
    var _ref3;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, Attribute);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref3 = Attribute.__proto__ || Object.getPrototypeOf(Attribute)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = {
      isInput: null
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(Attribute, [{
    key: 'getInputValue',
    value: function getInputValue() {
      var _props2 = this.props,
          value = _props2.value,
          handleChange = _props2.handleChange;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, {
        className: 'flex-1',
        isValid: value ? value.length > 0 : true,
        valueLink: { value: value, requestChange: handleChange },
        size: 'small'
      });
    }
  }, {
    key: 'getReadOnlyValue',
    value: function getReadOnlyValue() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex-1 dsg-body color-navy-dark' },
        this.props.value
      );
    }
  }, {
    key: 'getLinkValue',
    value: function getLinkValue() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'a',
        { className: 'flex-1', href: this.props.href, target: '_blank' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'dsg-Body truncate' },
          this.props.value
        )
      );
    }
  }, {
    key: 'getNormalValue',
    value: function getNormalValue() {
      var value = this.props.value;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex-1 dsg-Body truncate' },
        typeof value === 'boolean' ? JSON.stringify(value) : value
      );
    }
  }, {
    key: 'getMissingValue',
    value: function getMissingValue() {
      var label = this.props.label;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        {
          className: 'dsg-Body color-navy',
          onClick: this.props.handleEdit,
          style: {
            cursor: 'pointer'
          }
        },
        'Add ',
        label
      );
    }
  }, {
    key: 'getDisplayValue',
    value: function getDisplayValue() {
      var _props3 = this.props,
          empty = _props3.empty,
          value = _props3.value,
          href = _props3.href,
          editing = _props3.editing,
          handleChange = _props3.handleChange;

      if (editing) {
        if (typeof handleChange !== 'undefined') {
          return this.getInputValue();
        } else {
          return this.getReadOnlyValue();
        }
      } else {
        if (empty) {
          return this.getMissingValue();
        } else {
          if (typeof value === 'undefined' || value == null) {
            return this.getMissingValue();
          } else {
            if (typeof href !== 'undefined') {
              return this.getLinkValue();
            } else {
              return this.getNormalValue();
            }
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var label = this.props.label;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { key: label, style: { padding: '10px 20px 0' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            className: 'dsg-Small color-navy-dark dsg-medium-weight',
            style: { paddingRight: 10 }
          },
          label
        ),
        this.getDisplayValue()
      );
    }
  }]);

  return Attribute;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.endUser;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(EndUserAttributesCardPlaceholder)))(Object(__WEBPACK_IMPORTED_MODULE_6_components_customer_EndUserAttributesCard_helper__["a" /* default */])(EndUserAttributesCard)));

/***/ }),

/***/ "Or1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var EmbedConstants = Marty.createConstants(['EMBED_FETCH', 'EMBED_CREATE']);

/* harmony default export */ __webpack_exports__["a"] = (EmbedConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "OrmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export root */
/* unused harmony export getMeetingsState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDefaultMeetingType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getMeetingTypes; });
/* unused harmony export getMeetingTypeStatus */
/* unused harmony export getCalendlyMeetingTypes */
/* unused harmony export getCalendlyMeetingTypeStatus */
/* unused harmony export getCalendarStatusFetchStatus */
/* unused harmony export getGoogleCalendarFetchStatus */
/* unused harmony export getMicrosoftCalendarFetchStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCalendarStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCalendarStatusLoaded; });
/* unused harmony export isGoogleCalendarsFetchPending */
/* unused harmony export isGoogleCalendarsFetchCompleted */
/* unused harmony export isMicrosoftCalendarsFetchPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isMicrosoftCalendarsFetchCompleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return hasMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getMicrosoftAdminConsentUsers; });
/* unused harmony export getIsMicrosoftAdminConsentError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasFetchedMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isMicrosoftGlobalCalendarsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isMicrosoftGlobalCalendarsLoaded; });
/* unused harmony export isFetchMicrosoftAdminConsentLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isFetchMicrosoftAdminConsentLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return isOauthConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIsGoogleOauthConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIsGoogleOauthConnectedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getIsMicrosoftOauthConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getIsZoomOauthConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getIsZoomOauthConnectedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getIsTokenRevoked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isGoogleOrMicrosoftConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCalendars; });
/* unused harmony export getGoogleScopes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return hasCalendarScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasEmailScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getMeetingSettingsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isMeetingSettingsLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isMeetingTypesLoaded; });
/* unused harmony export isMeetingTypesLoading */
/* unused harmony export getMeetingTypeBySlug */
/* unused harmony export getAgentIdsWithConnectedCalendarsStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAgentIdsWithConnectedCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isAgentIdsWithConnectedCalendarsPending; });
/* unused harmony export isShareRoutedCalendarLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_constants__ = __webpack_require__("+ecq");



var root = function root(state) {
  return state.get('meetings');
};
var getMeetingsState = function getMeetingsState(state) {
  return state.get('meetings');
};
var getDefaultMeetingType = function getDefaultMeetingType(state) {
  return state.getIn(['meetings', 'meeting']);
};
var getMeetingTypes = function getMeetingTypes(state) {
  return state.getIn(['meetings', 'meetingTypes']);
};
var getMeetingTypeStatus = function getMeetingTypeStatus(state) {
  return state.getIn(['meetings', 'meetingTypesStatus']);
};

var getCalendlyMeetingTypes = function getCalendlyMeetingTypes(state) {
  return state.getIn(['meetings', 'calendlyMeetingTypes']);
};
var getCalendlyMeetingTypeStatus = function getCalendlyMeetingTypeStatus(state) {
  return state.getIn(['meetings', 'calendlyMeetingTypesStatus']);
};

var getCalendarStatusFetchStatus = function getCalendarStatusFetchStatus(state) {
  return getMeetingsState(state).calendarStatusFetchStatus;
};
var getGoogleCalendarFetchStatus = function getGoogleCalendarFetchStatus(state) {
  return getMeetingsState(state).googleCalendarsFetchStatus;
};
var getMicrosoftCalendarFetchStatus = function getMicrosoftCalendarFetchStatus(state) {
  return getMeetingsState(state).microsoftCalendarsFetchStatus;
};

var getCalendarStatusPending = function getCalendarStatusPending(state) {
  return getCalendarStatusFetchStatus(state) === 'pending';
};
var getCalendarStatusLoaded = function getCalendarStatusLoaded(state) {
  return getCalendarStatusFetchStatus(state) === 'success' || getCalendarStatusFetchStatus(state) === 'failure';
};

var isGoogleCalendarsFetchPending = function isGoogleCalendarsFetchPending(state) {
  return getGoogleCalendarFetchStatus(state) === 'pending';
};
var isGoogleCalendarsFetchCompleted = function isGoogleCalendarsFetchCompleted(state) {
  return getGoogleCalendarFetchStatus(state) === 'success' || getGoogleCalendarFetchStatus(state) === 'failure';
};

var isMicrosoftCalendarsFetchPending = function isMicrosoftCalendarsFetchPending(state) {
  return getMicrosoftCalendarFetchStatus(state) === 'pending';
};
var isMicrosoftCalendarsFetchCompleted = function isMicrosoftCalendarsFetchCompleted(state) {
  return getMicrosoftCalendarFetchStatus(state) === 'success' || getMicrosoftCalendarFetchStatus(state) === 'failure';
};

var hasMicrosoftAdminConsent = function hasMicrosoftAdminConsent(state) {
  return getMeetingsState(state).microsoftCalendarAdminManaged;
};
var getMicrosoftAdminConsentUsers = function getMicrosoftAdminConsentUsers(state) {
  return getMeetingsState(state).microsoftCalendarAdminIds;
};
var getIsMicrosoftAdminConsentError = function getIsMicrosoftAdminConsentError(state) {
  return getMeetingsState(state).microsoftCalendarAdminError;
};
var hasFetchedMicrosoftAdminConsent = function hasFetchedMicrosoftAdminConsent(state) {
  return getMeetingsState(state).microsoftCalendarAdminManaged !== undefined;
};
var isMicrosoftGlobalCalendarsLoading = function isMicrosoftGlobalCalendarsLoading(state) {
  return getMeetingsState(state).fetchMicrosoftGlobalCalendarStatus === 'pending';
};
var isMicrosoftGlobalCalendarsLoaded = function isMicrosoftGlobalCalendarsLoaded(state) {
  return getMeetingsState(state).fetchMicrosoftGlobalCalendarStatus === 'success';
};

var isFetchMicrosoftAdminConsentLoading = function isFetchMicrosoftAdminConsentLoading(state) {
  return getMeetingsState(state).fetchMicrosoftAdminConsentStatus === 'pending';
};
var isFetchMicrosoftAdminConsentLoaded = function isFetchMicrosoftAdminConsentLoaded(state) {
  return getMeetingsState(state).fetchMicrosoftAdminConsentStatus === 'success';
};

var isOauthConnected = function isOauthConnected(state) {
  return getMeetingsState(state).connected;
};
var getIsGoogleOauthConnected = function getIsGoogleOauthConnected(state) {
  return getMeetingsState(state).googleAuthed;
};
var getIsGoogleOauthConnectedError = function getIsGoogleOauthConnectedError(state) {
  return getMeetingsState(state).googleAuthedError;
};
var getIsMicrosoftOauthConnected = function getIsMicrosoftOauthConnected(state) {
  return getMeetingsState(state).microsoftAuthed;
};
var getIsZoomOauthConnected = function getIsZoomOauthConnected(state) {
  return getMeetingsState(state).zoomAuthed;
};
var getIsZoomOauthConnectedError = function getIsZoomOauthConnectedError(state) {
  return getMeetingsState(state).zoomAuthedError;
};
var getIsTokenRevoked = function getIsTokenRevoked(state) {
  return getMeetingsState(state).isTokenRevoked;
};
var isGoogleOrMicrosoftConnected = function isGoogleOrMicrosoftConnected(state) {
  return getIsGoogleOauthConnected(state) || getIsMicrosoftOauthConnected(state) || hasFetchedMicrosoftAdminConsent(state);
};

var getCalendar = function getCalendar(state) {
  return getMeetingsState(state).calendar;
};
var getCalendars = function getCalendars(state) {
  return getMeetingsState(state).calendars;
};
var getGoogleScopes = function getGoogleScopes(state) {
  return getMeetingsState(state).scopes;
};
var hasCalendarScope = function hasCalendarScope(state) {
  return getGoogleScopes(state).includes(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_constants__["K" /* GoogleScopes */].CALENDAR);
};
var hasEmailScope = function hasEmailScope(state) {
  return _.some(getGoogleScopes(state), function (scope) {
    return scope === __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND || scope === __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_constants__["K" /* GoogleScopes */].READ;
  });
};

var getMeetingSettings = function getMeetingSettings(state) {
  return getMeetingsState(state).meeting;
};
var getMeetingSettingsStatus = function getMeetingSettingsStatus(state) {
  return getMeetingsState(state).meetingStatus;
};
var isMeetingSettingsLoaded = function isMeetingSettingsLoaded(state) {
  return getMeetingsState(state).meetingStatus === 'success';
};

var isMeetingTypesLoaded = function isMeetingTypesLoaded(state) {
  return getMeetingTypeStatus(state) === 'success';
};
var isMeetingTypesLoading = function isMeetingTypesLoading(state) {
  return getMeetingTypeStatus(state) === 'pending';
};

var getMeetingTypeBySlug = function getMeetingTypeBySlug(slug) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getMeetingTypes, function (meetingTypes) {
    return _.find(meetingTypes, { slug: slug });
  });
};

var getAgentIdsWithConnectedCalendarsStatus = function getAgentIdsWithConnectedCalendarsStatus(state) {
  return getMeetingsState(state).agentIdsWithConnectedCalendarsStatus;
};
var getAgentIdsWithConnectedCalendars = function getAgentIdsWithConnectedCalendars(state) {
  return getMeetingsState(state).agentIdsWithConnectedCalendars;
};

var isAgentIdsWithConnectedCalendarsPending = function isAgentIdsWithConnectedCalendarsPending(state) {
  return getAgentIdsWithConnectedCalendarsStatus(state) === 'pending';
};

var isShareRoutedCalendarLoading = function isShareRoutedCalendarLoading(state) {
  return root(state).get('shareRoutedCalendarLoading');
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "OtCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export demandbaseCompanyDataByIp */
/* unused harmony export demandbaseCompanyDataByEndUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return demandbaseTargetingIndustries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return demandbaseTargetingSubIndustries; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('enrichment').demandbase;
};
var demandbaseCompanyDataByIp = function demandbaseCompanyDataByIp(ip) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.getIn(['data', 'byIp', ip]);
  });
};
var demandbaseCompanyDataByEndUser = function demandbaseCompanyDataByEndUser(endUserId) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.getIn(['data', 'byEndUserId', endUserId]);
  });
};
var demandbaseTargetingIndustries = function demandbaseTargetingIndustries(state) {
  return root(state).get('industries');
};
var demandbaseTargetingSubIndustries = function demandbaseTargetingSubIndustries(state) {
  return root(state).get('subIndustries');
};

/***/ }),

/***/ "Otj0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PreviewButtons":"PreviewButtons---n__Wv"};

/***/ }),

/***/ "OvX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_styles_dropdown_styl__ = __webpack_require__("yhak");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_styles_dropdown_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_styles_dropdown_styl__);






//#######
// props:
// - onClickOutside
// - renderInnerComponent
//
//#######

var DropDown = React.createClass({
  displayName: 'DropDown',

  mixins: [__webpack_require__("aCGJ")],

  propTypes: {
    onClickOutside: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    renderInnerComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
  },

  getInitialState: function getInitialState() {
    return {};
  },
  handleClickOutside: function handleClickOutside(event) {
    this.props.onClickOutside(event);
    return event.preventDefault();
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('DropDown', this.props.className) },
      (typeof this.props.renderInnerComponent === 'function' ? this.props.renderInnerComponent() : undefined) || this.props.children
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DropDown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Ovcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("pKGU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });


/***/ }),

/***/ "Ox78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range__ = __webpack_require__("l5j/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_DateHelpers__ = __webpack_require__("97t2");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

// side effect


var FETCH_ORG_END_USER_COUNT_HISTORY_DONE = __webpack_require__("h6+o").default.FETCH_ORG_END_USER_COUNT_HISTORY_DONE;



var EndUserGrowthStore = Marty.createStore({
  id: 'EndUserGrowthStore',

  getInitialState: function getInitialState() {
    return {
      endUserCountHistoryByDate: {}
    };
  },


  handlers: {
    fetchEndUserCountHistoryDone: FETCH_ORG_END_USER_COUNT_HISTORY_DONE
  },

  getEndUserCountHistory: function getEndUserCountHistory(startDate, endDate) {
    var _this = this;

    var histories = [];
    var range = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.range(startDate, endDate);
    range.by('days', function (day) {
      return histories.push(_this.state.endUserCountHistoryByDate[day.format('YYYY-MM-DD')]);
    });
    return histories;
  },
  fetchEndUserCountHistory: function fetchEndUserCountHistory(startDate, endDate) {
    var id = 'fetchEndUserCountHistory ' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_DateHelpers__["d" /* toISOLocalDateString */])(startDate) + Object(__WEBPACK_IMPORTED_MODULE_2_utils_DateHelpers__["d" /* toISOLocalDateString */])(endDate);
    return this.fetch({
      id: id,
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.getEndUserCountHistory(startDate, endDate);
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.EndUserQueries.fetchOrgEndUserCountHistory(orgId, startDate, endDate);
      }
    });
  },
  fetchEndUserCountHistoryDone: function fetchEndUserCountHistoryDone(histories) {
    var endUserCountHistoryByDate = _.cloneDeep(this.state.endUserCountHistoryByDate);
    _.each(histories, function (history) {
      return endUserCountHistoryByDate[history.date] = history;
    });
    return this.setState({ endUserCountHistoryByDate: endUserCountHistoryByDate });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserGrowthStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "OyGa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range__ = __webpack_require__("l5j/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Button__ = __webpack_require__("1iW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_timeline_selectors__ = __webpack_require__("4iEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_timeline_actions__ = __webpack_require__("G57K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Filters__ = __webpack_require__("+5bf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ConversationEvent__ = __webpack_require__("zIDI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EmailCaptureCampaignEvent__ = __webpack_require__("vfHo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__EndUserAddedEvent__ = __webpack_require__("vPdD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MessageCampaignEvent__ = __webpack_require__("c4Jp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__NoteLoggingEvent__ = __webpack_require__("crjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NPSResponseEvent__ = __webpack_require__("0vKZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__NPSCampaignEvent__ = __webpack_require__("o/MR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TagEvent__ = __webpack_require__("4hUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__GenericEvent__ = __webpack_require__("8wCm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PageViewEvent__ = __webpack_require__("mzVW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__EndUserPropertyUpdateEvents__ = __webpack_require__("7Sbm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_styles_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_styl__ = __webpack_require__("vJPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var eventToComponent = function eventToComponent(event) {
  switch (event.eventType) {
    case 'ADDED':
      return __WEBPACK_IMPORTED_MODULE_15__EndUserAddedEvent__["a" /* default */];
    case 'NOTE':
      return __WEBPACK_IMPORTED_MODULE_17__NoteLoggingEvent__["a" /* default */];
    case 'MESSAGE_SEEN':
    case 'MESSAGE_SENT':
    case 'MESSAGE_CTA_CLICKED':
      return __WEBPACK_IMPORTED_MODULE_16__MessageCampaignEvent__["a" /* default */];
    case 'NPS_RESPONDED':
      return __WEBPACK_IMPORTED_MODULE_18__NPSResponseEvent__["a" /* default */];
    case 'NPS_SENT':
      return __WEBPACK_IMPORTED_MODULE_19__NPSCampaignEvent__["a" /* default */];
    case 'EMAIL_CAPTURE_SUBMITTED':
      return __WEBPACK_IMPORTED_MODULE_14__EmailCaptureCampaignEvent__["a" /* default */];
    case 'CONVERSATION':
      return __WEBPACK_IMPORTED_MODULE_13__ConversationEvent__["a" /* default */];
    case 'TAG_REMOVE':
    case 'TAG_ADD':
      return __WEBPACK_IMPORTED_MODULE_20__TagEvent__["a" /* default */];
    case 'TRIGGERED_EVENT':
      if (event.body && event.body.event === 'page') {
        return __WEBPACK_IMPORTED_MODULE_22__PageViewEvent__["a" /* default */];
      } else {
        return __WEBPACK_IMPORTED_MODULE_21__GenericEvent__["a" /* default */];
      }
    case 'PROPERTY':
      return __WEBPACK_IMPORTED_MODULE_23__EndUserPropertyUpdateEvents__["a" /* default */];
    default:
      return __WEBPACK_IMPORTED_MODULE_21__GenericEvent__["a" /* default */];
  }
};

var NoActivityProps = {
  style: {
    marginLeft: 38
  },
  className: 'color-navy-dark dsg-Body'
};

var NoActivity = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  NoActivityProps,
  'No activity'
);

var LoadMore = function LoadMore(_ref) {
  var onClick = _ref.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex-center', style: { margin: '10px 0' } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Button__["a" /* default */],
      {
        hollow: true,
        onClick: onClick,
        role: 'secondary'
      },
      onClick ? 'Load 20 More' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Loading__["a" /* default */], { color: '#13DDB0', size: 'medium' })
    )
  );
};

function MonthDivider(_ref2) {
  var months = _ref2.months;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_25__style_styl___default.a.MonthDivider + ' color-navy-dark dsg-Regular dsg-medium-weight' },
    months.length === 1 ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(months[0]).format('MMMM YYYY') : __WEBPACK_IMPORTED_MODULE_3_moment___default()(months[0]).format('MMMM YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(months[months.length - 1]).format('MMMM YYYY')
  );
}

var TimeLine = function (_Component) {
  _inherits(TimeLine, _Component);

  function TimeLine() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeLine);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = TimeLine.__proto__ || Object.getPrototypeOf(TimeLine)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      loading: false
    }, _this.loadMore = function () {
      var _this$props = _this.props,
          endUser = _this$props.endUser,
          filter = _this$props.filter;

      _this.props.actions.loadMoreEvents({ endUserId: endUser.id, filter: filter.keySeq().toJS() });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeLine, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.fetchEvents({ endUserId: this.props.endUser.id, filter: this.props.filter.keySeq().toJS() });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.filter.equals(nextProps.filter)) {
        this.props.actions.fetchEvents({ endUserId: this.props.endUser.id, filter: nextProps.filter.keySeq().toJS() });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actions.cancelEventFetch({ endUserId: this.props.endUser.id });
    }
  }, {
    key: 'renderLoadMore',
    value: function renderLoadMore() {
      var isTimelineLoadingMore = this.props.isTimelineLoadingMore;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LoadMore, { onClick: !isTimelineLoadingMore ? this.loadMore : false });
    }
  }, {
    key: 'renderEvents',
    value: function renderEvents() {
      var _props = this.props,
          events = _props.events,
          endUser = _props.endUser,
          isTimelineLoading = _props.isTimelineLoading;


      if (isTimelineLoading) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'loading-dots-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_components_Loading__["a" /* default */], { color: __WEBPACK_IMPORTED_MODULE_24_styles_colors_json___default.a['color-navy-dark'] })
        );
      }

      if (events.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'empty-container dsg-Body color-gray-dark' },
          'No matching events found'
        );
      }

      var range = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.range(__WEBPACK_IMPORTED_MODULE_3_moment___default()(events[events.length - 1].createdAt).startOf('month'), __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('month'));
      var months = [];
      // Time range has no option to do this in descending order, this reverses it
      range.by('M', function (month) {
        months.unshift(month);
      });
      var currentIndex = 0;
      var rows = [];
      var emptyMonths = void 0;
      months.forEach(function (month) {
        if (!__WEBPACK_IMPORTED_MODULE_3_moment___default()(events[currentIndex].createdAt).isSame(month, 'month')) {
          if (emptyMonths) {
            emptyMonths.push(month);
          } else {
            emptyMonths = [month];
          }
          return;
        }
        if (emptyMonths) {
          rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDivider, { months: emptyMonths }));
          rows.push(NoActivity);
          emptyMonths = false;
        }
        rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MonthDivider, { months: [month] }));
        while (currentIndex < events.length && __WEBPACK_IMPORTED_MODULE_3_moment___default()(events[currentIndex].createdAt).isSame(month, 'month')) {
          var event = events[currentIndex];
          var component = eventToComponent(event);
          if (component) {
            var eventNode = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, { event: event, endUser: endUser });
            rows.push(eventNode);
          }
          currentIndex++;
        }
      });
      return rows;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_25__style_styl___default.a.TimeLine, style: { marginTop: 10 } },
          this.renderEvents()
        ),
        this.props.hasNext ? this.renderLoadMore() : null
      );
    }
  }]);

  return TimeLine;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state) {
  return {
    hasReduxTimeline: true,
    events: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_timeline_selectors__["b" /* events */](state).toJS(),
    isTimelineLoading: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_timeline_selectors__["d" /* isLoading */](state),
    isTimelineLoadingMore: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_timeline_selectors__["e" /* isLoadingMore */](state),
    hasNext: __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_timeline_selectors__["c" /* hasNext */](state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchEvents: __WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_timeline_actions__["a" /* fetchTimelineEventsForEndUser */],
      cancelEventFetch: __WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_timeline_actions__["b" /* fetchTimelineEventsForEndUserCancelled */],
      loadMoreEvents: __WEBPACK_IMPORTED_MODULE_11_app_modules_endUser_timeline_actions__["f" /* loadMoreTimelineEventsForEndUser */]
    }, dispatch)
  };
}

var TimelineContainer = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(TimeLine);

var TimeLineWrapper = function (_Component2) {
  _inherits(TimeLineWrapper, _Component2);

  function TimeLineWrapper(props) {
    _classCallCheck(this, TimeLineWrapper);

    var _this2 = _possibleConstructorReturn(this, (TimeLineWrapper.__proto__ || Object.getPrototypeOf(TimeLineWrapper)).call(this, props));

    _this2.updateFilter = function (filter) {
      _this2.setState({ filter: filter });
    };

    _this2.state = { filter: Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Map"])() };
    return _this2;
  }

  _createClass(TimeLineWrapper, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Filters__["a" /* default */], { filter: this.state.filter, updateFilter: this.updateFilter }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimelineContainer, _extends({ filter: this.state.filter }, this.props))
      );
    }
  }]);

  return TimeLineWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return {
    hasReduxTimeline: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])('has_redux_timeline')(state)
  };
})(TimeLineWrapper));

/***/ }),

/***/ "P/EE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__ = __webpack_require__("rFuW");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var NotificationActions = Marty.createActionCreators({
  pushNotification: function pushNotification(notification) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].NOTIFICATION_PUSH, notification);
  },
  dismissNotification: function dismissNotification() {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].NOTIFICATION_DISPLAY_DONE);
  },
  clearNotifications: function clearNotifications() {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_NotificationConstants__["b" /* default */].CLEAR_NOTIFICATIONS);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NotificationActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "P/TS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getUserId */
/* unused harmony export getUserIpAddress */
/* unused harmony export getSessionToken */
/* unused harmony export isAuthenticated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return didAuthenticationFail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return channelsToJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChannelName; });
/* unused harmony export getChannel */
/* unused harmony export getSocketState */
/* unused harmony export hasConnected */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTimeUntilReconnect; });
/* unused harmony export getChannelState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getWssBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getApiBaseUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAuthParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("IJhC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("EkEs");






var root = function root(state) {
  return state.get('socket');
};
var socketsRoot = function socketsRoot(state) {
  return root(state).get('socket');
};
var byCluster = function byCluster(state, _ref) {
  var clusterName = _ref.clusterName;
  return socketsRoot(state).get(clusterName, Object(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* SocketState */])());
};

var getUserId = function getUserId(state, props) {
  return byCluster(state, props).userId;
};
var getUserIpAddress = function getUserIpAddress(state, props) {
  return byCluster(state, props).userIpAddress;
};
var getSessionToken = function getSessionToken(state, props) {
  return byCluster(state, props).sessionToken;
};
var isAuthenticated = function isAuthenticated(state) {
  return !!getSessionToken(state);
};

var didAuthenticationFail = function didAuthenticationFail(state, _ref2) {
  var clusterName = _ref2.clusterName;

  return byCluster(state, { clusterName: clusterName }).get('authenticateStatus') === __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AUTHENTICATE_FAILURE */];
};

var channelsToJoin = function channelsToJoin(state, props) {
  return byCluster(state, props).get('channels').valueSeq().filter(function (channelState) {
    return channelState.state === __WEBPACK_IMPORTED_MODULE_4__constants__["g" /* CHANNEL_STATES */].ERRORED;
  }).map(function (channelState) {
    return channelState.channel;
  });
};

var getChannelName = function getChannelName(state, _ref3) {
  var clusterName = _ref3.clusterName,
      channelName = _ref3.channelName;

  switch (channelName) {
    case __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* SocketChannel */].USER:
      return 'user:' + getUserId(state, { clusterName: clusterName });
    case __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* SocketChannel */].ORG_PUBLIC:
      return 'org:' + Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
    case __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* SocketChannel */].ORG_PRIVATE:
      return 'private-org:' + Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
    default:
      return channelName;
  }
};

var getChannel = function getChannel(state, props) {
  return byCluster(state, props).getIn(['channels', props.channelName], Object(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* ChannelState */])());
};

var getSocketState = function getSocketState(state, _ref4) {
  var clusterName = _ref4.clusterName;

  return byCluster(state, { clusterName: clusterName }).get('state');
};

var hasConnected = function hasConnected(state, _ref5) {
  var clusterName = _ref5.clusterName;

  return byCluster(state, { clusterName: clusterName }).get('hasConnected');
};

var getTimeUntilReconnect = function getTimeUntilReconnect(state, _ref6) {
  var clusterName = _ref6.clusterName;

  return byCluster(state, { clusterName: clusterName }).get('timeUntilReconnect');
};

var getChannelState = function getChannelState(state, _ref7) {
  var clusterName = _ref7.clusterName,
      channelName = _ref7.channelName;

  return getChannel(state, { clusterName: clusterName, channelName: channelName }).get('state');
};

var getWssBaseUrl = function getWssBaseUrl(state, _ref8) {
  var clusterName = _ref8.clusterName;

  switch (clusterName) {
    case __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* SocketCluster */].MESSAGES:
      if (__WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_7" /* WS_CHAT_USE_SHARDS */]) {
        var _orgId = Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
        var _shardId = computeShardId(_orgId);
        return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_10" /* WS_WSS_PROTOCOL */] + '://' + _orgId + '-' + _shardId + '.' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_6" /* WS_CHAT_BASE */];
      } else {
        return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["D" /* MESSAGES_WSS_BASE */];
      }

    case __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* SocketCluster */].PUSH:
      var orgId = Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
      var shardId = computeShardId(orgId);
      return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_10" /* WS_WSS_PROTOCOL */] + '://' + orgId + '-' + shardId + '.' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_9" /* WS_PUSH_BASE */];
  }
};

var getApiBaseUrl = function getApiBaseUrl(state, _ref9) {
  var clusterName = _ref9.clusterName;

  switch (clusterName) {
    case __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* SocketCluster */].MESSAGES:
      if (__WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_7" /* WS_CHAT_USE_SHARDS */]) {
        var _orgId2 = Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
        var _shardId2 = computeShardId(_orgId2);
        return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_5" /* WS_API_PROTOCOL */] + '://' + _orgId2 + '-' + _shardId2 + '.' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_6" /* WS_CHAT_BASE */];
      } else {
        return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["C" /* MESSAGES_API_BASE */];
      }

    case __WEBPACK_IMPORTED_MODULE_4__constants__["v" /* SocketCluster */].PUSH:
      var orgId = Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_org_selectors__["orgId"])(state);
      var shardId = computeShardId(orgId);
      return __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_5" /* WS_API_PROTOCOL */] + '://' + orgId + '-' + shardId + '.' + __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_9" /* WS_PUSH_BASE */];
  }
};

var getAuthParams = function getAuthParams(state) {
  return {
    access_token: Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["getAccessToken"])()
  };
};

var computeShardId = function computeShardId(orgId) {
  return orgId % __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_8" /* WS_NUM_SHARDS */];
};

/***/ }),

/***/ "P4HO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(471);

/***/ }),

/***/ "P4YN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_colors_json__);


function Cancel(_ref) {
  var onClick = _ref.onClick;

  return React.createElement(
    'div',
    {
      style: {
        fontSize: 14,
        color: __WEBPACK_IMPORTED_MODULE_0_styles_colors_json___default.a['color-navy-dark'],
        cursor: 'pointer',
        marginRight: 24,
        textTransform: 'uppercase'
      },
      onClick: onClick
    },
    'Cancel'
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Cancel);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "P5/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slack_lander_styl__ = __webpack_require__("/ub6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slack_lander_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__slack_lander_styl__);




var _require = __webpack_require__("lMLN"),
    CREATE_ACCESS_TOKEN_DONE = _require.CREATE_ACCESS_TOKEN_DONE;





var SlackLander = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createClass({
  displayName: 'SlackLander',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  },

  getInitialState: function getInitialState() {
    return { accessTokenCreated: false };
  },
  creatingSlackBotToken: function creatingSlackBotToken() {
    return this.props.location.query.code != null;
  },
  mappingSlackUser: function mappingSlackUser() {
    return this.props.params.slackUserId != null;
  },
  componentDidMount: function componentDidMount() {
    if (this.creatingSlackBotToken()) {
      this.app.queries.IntegrationsQueries.createSlackBotToken(this.props.location.query.code);
    }
    if (this.mappingSlackUser()) {
      return this.app.queries.IntegrationsQueries.mapSlackUser(this.props.params.slackUserId);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if ((nextProps.accessTokenCreationState != null ? nextProps.accessTokenCreationState.slack : undefined) === CREATE_ACCESS_TOKEN_DONE) {
      this.context.router.replace('/');
    }
    if (nextProps.slackUserMappingState) {
      this.app.actions.NotificationActions.pushNotification({ content: 'Thanks for logging in! Now you can respond to conversations in Slack!' });
      return this.context.router.replace('/inboxes');
    }
  },
  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('Page', __WEBPACK_IMPORTED_MODULE_4__slack_lander_styl__["integrationLander"]) },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h1',
          null,
          'We\'re currently talking to Slack!'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          null,
          'Please give us a few moments while we hook you up.'
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(SlackLander, {
  listenTo: ['stores.IntegrationsStore'],

  fetch: {
    accessTokenCreationState: function accessTokenCreationState() {
      return this.app.stores.IntegrationsStore.getAccessTokenCreationState();
    },
    slackUserMappingState: function slackUserMappingState() {
      return this.app.stores.IntegrationsStore.getSlackUserMappingState();
    }
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "P5ci":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Modal__ = __webpack_require__("3F5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_HelpModal_styl__ = __webpack_require__("hnps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_HelpModal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_HelpModal_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.








var joinHelpLinks = function joinHelpLinks(links) {
  return _.transform(links, function (result, provider, i) {
    result.push(React.createElement(
      'a',
      { href: provider.link, target: '_blank' },
      provider.display
    ));

    if (i !== links.length - 1) {
      return result.push(React.createElement(
        'span',
        null,
        ', '
      ));
    } else {
      return result.push(React.createElement(
        'span',
        null,
        '.'
      ));
    }
  });
};

var forwardingHelpLinks = [{
  display: 'Gmail',
  link: 'https://support.google.com/mail/answer/10957?hl=en'
}, {
  display: 'GoDaddy',
  link: 'https://www.godaddy.com/help/managing-email-forwarding-3367'
}, {
  display: 'Office 365',
  link: 'https://technet.microsoft.com/en-us/library/dd351134(v=exchg.141).aspx'
}];

var dkimHelpLinks = [{
  display: 'Godaddy',
  link: 'https://www.godaddy.com/help/add-a-cname-record-19236'
}, {
  display: 'Rackspace',
  link: 'http://www.rackspace.com/knowledge_center/article/creating-dns-records-for-cloud-servers-with-the-control-panel#D'
}, {
  display: 'Hostgator',
  link: 'http://support.hostgator.com/articles/hosting-guide/lets-get-started/dns-name-servers/manage-dns-records-with-hostgatorenom'
}, {
  display: 'Dreamhost',
  link: 'http://wiki.dreamhost.com/CNAME_record#Custom_CNAME_Record'
}, {
  display: 'AWS',
  link: 'http://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/CNAMEs.html'
}];

var HelpModal = React.createClass({
  displayName: 'HelpModal',

  propTypes: {
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    inbox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  getForwardingHelpLinks: function getForwardingHelpLinks() {
    return joinHelpLinks(forwardingHelpLinks);
  },
  getDKIMHelpLinks: function getDKIMHelpLinks() {
    return joinHelpLinks(dkimHelpLinks);
  },
  getModalHeader: function getModalHeader() {
    if (this.props.type === 'forward') {
      return 'Email Forwarding';
    } else {
      return 'White Label (DKIM)';
    }
  },
  getModalContent: function getModalContent() {
    if (this.props.type === 'forward') {
      return React.createElement(
        'div',
        { className: 'set-up-steps' },
        'Email forwarding must be configured from your current email provider\u2019s website.',
        React.createElement(
          'div',
          { className: 'link-text' },
          'Here are some links that you might find useful: '
        ),
        this.getForwardingHelpLinks()
      );
    } else {
      return React.createElement(
        'div',
        { className: 'set-up-steps' },
        'DKIM must be configured in order for us to send email on behalf of ',
        React.createElement(
          'span',
          null,
          this.props.inbox.address
        ),
        React.createElement(
          'div',
          { className: 'link-text' },
          'Here are some links that you might find useful: '
        ),
        this.getDKIMHelpLinks()
      );
    }
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'HelpModal' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_components_Modal__["a" /* default */],
        { onClose: this.props.onClose },
        React.createElement(
          'div',
          { className: 'title' },
          this.getModalHeader()
        ),
        React.createElement(
          'div',
          { className: 'set-up' },
          this.getModalContent(),
          React.createElement(
            'div',
            null,
            'Having trouble? Contact us at: ',
            React.createElement(
              'a',
              { href: 'mailto:support@driftt.com' },
              'support@driftt.com'
            )
          )
        ),
        React.createElement(
          'div',
          null,
          React.createElement('div', { className: 'bottom-divider' }),
          React.createElement(
            'div',
            { className: 'button-container' },
            React.createElement(
              'button',
              { className: 'color-teal btn-settings', onClick: this.props.onClose },
              'got it'
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (HelpModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "P9bU":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMjQiICB2aWV3Qm94PSIwIDAgMzAgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjY3NSA4LjU4bC00Ljk1IDdhLjk5NC45OTQgMCAwIDEtLjcyNC40MTZsLS4wODUuMDA0YS45OS45OSAwIDAgMS0uNy0uMjlsLTMuMDE3LTNhMS4wMDMgMS4wMDMgMCAwIDEtLjAwNy0xLjQxNC45OTQuOTk0IDAgMCAxIDEuNDEtLjAwNmwyLjE4MiAyLjE3IDQuMjctNi4wNGEuOTk1Ljk5NSAwIDAgMSAxLjM4OC0uMjM2Yy40NDguMzIuNTU0Ljk0NS4yMzUgMS4zOTV6TTEzLjc1MyAxMy40YzQuMDggMS4xNyA3LjE0NSA0Ljc4NiA3LjE0NSA4LjkzNFYyM2MwIC41NTItLjQ0NSAxLS45OTUgMUgxLjk4YS45OTcuOTk3IDAgMCAxLS45OTUtMXYtLjY2NmMwLTQuMTQ4IDMuMDY3LTcuNzY0IDcuMTQ2LTguOTM0QTcuMDA4IDcuMDA4IDAgMCAxIDMuOTczIDdjMC0zLjg2IDMuMTI3LTcgNi45Ny03czYuOTcgMy4xNCA2Ljk3IDdhNy4wMDcgNy4wMDcgMCAwIDEtNC4xNiA2LjR6TTIuOTg1IDIyaDE1LjkxM2MtLjE5Ni0zLjgyNy0zLjc2LTctNy45NTYtNy00LjE5NiAwLTcuNzYgMy4xNzMtNy45NTcgN3ptNy45NTctMjBDOC4xOTcgMiA1Ljk2NCA0LjI0MyA1Ljk2NCA3czIuMjMzIDUgNC45NzggNWMyLjc0NSAwIDQuOTc4LTIuMjQzIDQuOTc4LTVzLTIuMjMzLTUtNC45NzgtNXoiIGZpbGw9IiMwMTc2RkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "PD3t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_pages_CommonIntegrationPage__ = __webpack_require__("Vdf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Integration_services_ExternalIntegration__ = __webpack_require__("1MSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Integration_PageConstants__ = __webpack_require__("uuK8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_svg_default_app_icon_svg__ = __webpack_require__("ceBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_images_svg_default_app_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_images_svg_default_app_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("R2Sm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ramda__ = __webpack_require__("ivXw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var orDefaultIconSrc = function orDefaultIconSrc(src) {
  return Object(__WEBPACK_IMPORTED_MODULE_17_ramda__["defaultTo"])(__WEBPACK_IMPORTED_MODULE_15_images_svg_default_app_icon_svg___default.a)(src);
};

var IntegrationsPage = function (_Component) {
  _inherits(IntegrationsPage, _Component);

  function IntegrationsPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IntegrationsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IntegrationsPage.__proto__ || Object.getPrototypeOf(IntegrationsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isLoading: true,
      pages: __WEBPACK_IMPORTED_MODULE_7_components_Integration_PageConstants__["c" /* Pages */],
      integrationIdList: []
    }, _this.fetchPrivateIntegrations = function () {
      var mapToPage = function mapToPage(app) {
        return _defineProperty({}, app.id, {
          title: app.name,
          description: app.longDescription,
          paidStatus: app.paidStatus,
          isConnected: app.installed,
          builtBy: 'PARTNER',
          logo: orDefaultIconSrc(app.iconUrl),
          Page: __WEBPACK_IMPORTED_MODULE_4_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
          Service: function Service() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Integration_services_ExternalIntegration__["a" /* default */], { data: app });
          },
          backLinkText: __WEBPACK_IMPORTED_MODULE_7_components_Integration_PageConstants__["a" /* BACK_LINK_TEXT */],
          backLinkUrl: __WEBPACK_IMPORTED_MODULE_7_components_Integration_PageConstants__["b" /* INTEGRATIONS_URL */],
          hasRequiredAccess: function hasRequiredAccess() {
            return __WEBPACK_IMPORTED_MODULE_11_utils_Access__["c" /* default */].hasAllOrgIntegrations();
          }
        });
      };

      var onFetched = function onFetched(apps) {
        var privatePages = Object(__WEBPACK_IMPORTED_MODULE_17_ramda__["mergeAll"])(apps.map(mapToPage));
        var pages = _this.state.pages;

        _this.setState({
          isLoading: false,
          pages: _extends({}, pages, privatePages),
          integrationIdList: apps
        });
      };

      var onError = function onError(err) {
        console.warn(err);
        _this.setState({ isLoading: false });
      };

      Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["j" /* fetchInstalledApps */])().then(onFetched).catch(onError);
    }, _this.setDriftMade = function (page) {
      page['builtBy'] = 'DRIFT';
      page['paidStatus'] = 'FREE'; // free with current plan.
      return page;
    }, _this.getPageByIntegrationId = function (integrationId) {
      var _this$state = _this.state,
          pages = _this$state.pages,
          integrationIdList = _this$state.integrationIdList;


      switch (integrationId) {
        case 'pardot':
        case __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */]:
          return _this.setDriftMade(pages[__WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["K" /* PARDOT_APP_ID */]]);
        case 'eloqua':
        case __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["r" /* ELOQUA_APP_ID */]:
          return _this.setDriftMade(pages[__WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["r" /* ELOQUA_APP_ID */]]);
        default:
          if (integrationId.length === 36) {
            // get page using guid
            return pages[integrationId];
          }

          var currentIntegration = _.filter(integrationIdList, function (integration) {
            return integrationId === Object(__WEBPACK_IMPORTED_MODULE_14_components_Integration_helpers__["a" /* createAppName */])(integration.name);
          });
          if (currentIntegration.length === 1) {
            return pages[currentIntegration[0].id]; // get dev platform page using integrationName
          }
          return pages[integrationId]; // get all other integrations
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IntegrationsPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPrivateIntegrations();
      this.props.actions.fetchIntegrationStates();
    }
  }, {
    key: 'refreshPage',
    value: function refreshPage() {
      window.location.reload();
    }
  }, {
    key: 'render',
    value: function render() {
      var isLoading = this.state.isLoading;

      if (isLoading) {
        return null;
      }

      var _props = this.props,
          integrationConnectionStatus = _props.integrationConnectionStatus,
          integrationStates = _props.integrationStates,
          integrationId = _props.params.integrationId;

      var _getPageByIntegration = this.getPageByIntegrationId(integrationId),
          title = _getPageByIntegration.title,
          description = _getPageByIntegration.description,
          paidStatus = _getPageByIntegration.paidStatus,
          builtBy = _getPageByIntegration.builtBy,
          logo = _getPageByIntegration.logo,
          Page = _getPageByIntegration.Page,
          Service = _getPageByIntegration.Service,
          backLinkText = _getPageByIntegration.backLinkText,
          backLinkUrl = _getPageByIntegration.backLinkUrl,
          serviceClassName = _getPageByIntegration.serviceClassName,
          hideDisconnectButton = _getPageByIntegration.hideDisconnectButton,
          eduTooltip = _getPageByIntegration.eduTooltip,
          incompleteInstallEndpoint = _getPageByIntegration.incompleteInstallEndpoint,
          retired = _getPageByIntegration.retired,
          redirectPath = _getPageByIntegration.redirectPath,
          hasRequiredAccess = _getPageByIntegration.hasRequiredAccess;

      if (!!hasRequiredAccess && !hasRequiredAccess()) {
        window.location.replace('/');
        return null;
      }

      if (integrationConnectionStatus === __WEBPACK_IMPORTED_MODULE_10__app_modules_integrations_constants__["n" /* FETCH_INTEGRATION_STATES_FAILED */]) {
        this.refreshPage();
      }

      if (retired) {
        var host = __ENV__ === 'PRODUCTION' ? 'https://app.drift.com' : 'https://app.driftqa.com';
        document.location = '' + host + redirectPath;
      }

      var pageProps = {
        integrationId: integrationId,
        integrationStates: integrationStates,
        Service: Service,
        paidStatus: paidStatus,
        builtBy: builtBy,
        title: logo,
        isConnected: integrationStates[integrationId],
        description: description,
        logo: logo,
        name: title,
        serviceClassName: serviceClassName,
        hideDisconnectButton: hideDisconnectButton,
        EduTooltip: eduTooltip || '',
        incompleteInstallEndpoint: incompleteInstallEndpoint
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'IntegrationListContainer' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: backLinkText,
          backLinkUrl: backLinkUrl
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Page, pageProps)
      );
    }
  }]);

  return IntegrationsPage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

IntegrationsPage.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    integrationStates: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state) || {},
    integrationConnectionStatus: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["d" /* connectionsStatus */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["l" /* fetchIntegrationStates */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(IntegrationsPage));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "PDo8":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18px\" height=\"17px\" viewBox=\"0 0 18 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"flow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"admin-copy-2\" transform=\"translate(-1215.000000, -886.000000)\"><g id=\"Oval-Copy\" fill=\"#7695A5\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"1222\" cy=\"896\" r=\"6\"></circle></g><g id=\"Artboard-2\" transform=\"translate(1223.000000, 886.000000)\" fill-rule=\"nonzero\"><path d=\"M9.53335714,7.57142857 C9.53335714,9.18544898 8.22879236,10.5 6.61128571,10.5 L2.92207143,10.5 C1.79586641,10.5 0.77024696,9.85033109 0.284798174,8.83235678 C-0.195939587,7.8213507 -0.0606505598,6.6249393 0.63662562,5.74678002 L1.07370103,5.19676901 C0.417941571,4.65915341 0,3.84179431 0,2.92857143 C0,1.31456515 1.30548666,0 2.92207143,0 L6.61128571,0 C7.73836991,0 8.76308647,0.649619183 9.24556588,1.66137673 C9.73062346,2.67240037 9.59516963,3.87108515 8.89766009,4.75321998 L8.46037216,5.30349842 C9.11585152,5.84111527 9.53335714,6.65835166 9.53335714,7.57142857 Z\" id=\"Path\" fill=\"#394F5A\"></path><path fill=\"#7695A5\" d=\"M2,2.92857143 C2,3.44114286 2.41321429,3.85714286 2.92207143,3.85714286 L4.69285714,3.85714286 L2.20242857,6.99107143 C1.9805,7.27057143 1.93778571,7.65128571 2.091,7.9735 C2.24421429,8.29478571 2.56828571,8.5 2.92207143,8.5 L6.61128571,8.5 C7.12107143,8.5 7.53335714,8.084 7.53335714,7.57142857 C7.53335714,7.05885714 7.12107143,6.64285714 6.61128571,6.64285714 L4.84142857,6.64285714 L7.33185714,3.50892857 C7.55285714,3.22942857 7.5965,2.84778571 7.44235714,2.5265 C7.28914286,2.20521429 6.966,2 6.61128571,2 L2.92207143,2 C2.41321429,2 2,2.416 2,2.92857143 Z\" id=\"Path\" fill=\"#13CB6E\"></path></g></g></g></svg>"

/***/ }),

/***/ "PFDe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrganizations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOrganizationScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return switchOrganization; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



var getOrganizations = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/multi_org').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getOrganizations() {
    return _ref.apply(this, arguments);
  };
}();

var getOrganizationScopes = function () {
  var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].get('/multi_org/scopes').then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function getOrganizationScopes() {
    return _ref2.apply(this, arguments);
  };
}();

var switchOrganization = function () {
  var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(orgId, authClientId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/multi_org/switch?targetOrgId=' + orgId + '&clientId=' + authClientId).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function switchOrganization(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "PGMV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyNiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBpZD0iY29sb3IiIGQ9Ik0yNSA3aC0xLjExM2wtMi43NzUgMjMuMTI2QzIwLjk4NiAzMS4xNzYgMjAuMDYgMzIgMTkgMzJIN2MtMS4wNiAwLTEuOTg2LS44MjMtMi4xMTItMS44NzRMMi4xMTMgN0gxYy0uNTUyIDAtMS0uNDQ4LTEtMXMuNDQ4LTEgMS0xaDdWM2MwLTEuNjU0IDEuMzQ2LTMgMy0zaDRjMS42NTQgMCAzIDEuMzQ2IDMgM3YyaDdjLjU1MiAwIDEgLjQ0OCAxIDFzLS40NDggMS0xIDF6bS05LTRjMC0uNTUyLS40NS0xLTEtMWgtNGMtLjU1IDAtMSAuNDQ4LTEgMXYyaDZWM3pNNC4xMjcgN2wyLjc0NyAyMi44ODhjLjAwNS4wNDMuMDgzLjExMi4xMjYuMTEyaDEyYy4wNDMgMCAuMTItLjA3LjEyNi0uMTEyTDIxLjg3MyA3SDQuMTI3eiIgZmlsbD0iI0U5MkU0QiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg=="

/***/ }),

/***/ "PIqi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserDisplayName; });
var getUserDisplayName = function getUserDisplayName(user) {
  return !!user ? user.name || user.email : null;
};

/***/ }),

/***/ "PJ2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__("ZJVj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











function isValidAvailability(opens, closes) {
  return __WEBPACK_IMPORTED_MODULE_4_moment___default()(opens, __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["d" /* HOUR_FORMAT */]) < __WEBPACK_IMPORTED_MODULE_4_moment___default()(closes, __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["d" /* HOUR_FORMAT */]);
}

var TimeSelect = function (_Component) {
  _inherits(TimeSelect, _Component);

  function TimeSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimeSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimeSelect.__proto__ || Object.getPrototypeOf(TimeSelect)).call.apply(_ref, [this].concat(args))), _this), _this.onSelectDayOfWeek = function (_ref2) {
      var value = _ref2.value;

      _this.props.onSelection('dayOfWeek', value);
    }, _this.onSelectOpens = function (_ref3) {
      var value = _ref3.value;

      _this.props.onSelection('opens', value);
    }, _this.onSelectCloses = function (_ref4) {
      var value = _ref4.value;

      _this.props.onSelection('closes', value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimeSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          day = _props.day,
          opens = _props.opens,
          closes = _props.closes,
          onRemove = _props.onRemove;

      var invalid = !isValidAvailability(opens, closes);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__style___default.a.TimeSelect },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_UISelect__["b" /* default */], {
          value: day,
          options: __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["b" /* DAY_OPTIONS */],
          className: __WEBPACK_IMPORTED_MODULE_8__style___default.a.DaySelect,
          onSelection: this.onSelectDayOfWeek
        }),
        'from',
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_UISelect__["b" /* default */], {
          value: opens,
          options: __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["e" /* HOUR_OPTIONS */],
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.HourSelect, { invalid: invalid }),
          onSelection: this.onSelectOpens
        }),
        'to',
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_UISelect__["b" /* default */], {
          value: closes,
          options: __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["e" /* HOUR_OPTIONS */],
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style___default.a.HourSelect, { invalid: invalid }),
          onSelection: this.onSelectCloses
        }),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { onClick: onRemove,
            style: { width: 11, height: 11 } },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, { src: __webpack_require__("wKHa")
          })
        )
      );
    }
  }]);

  return TimeSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var MultiTimeSelect = function (_Component2) {
  _inherits(MultiTimeSelect, _Component2);

  function MultiTimeSelect() {
    var _ref5;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, MultiTimeSelect);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref5 = MultiTimeSelect.__proto__ || Object.getPrototypeOf(MultiTimeSelect)).call.apply(_ref5, [this].concat(args))), _this2), _this2.handleSelect = function (index) {
      return function (key, value) {
        var _this2$props = _this2.props,
            openHours = _this2$props.openHours,
            onSelection = _this2$props.onSelection;

        var valid = _this2.isValid(openHours.setIn([index, key], value));
        return onSelection(index, key, value, valid);
      };
    }, _this2.handleRemoveTime = function (index) {
      return function () {
        var valid = _this2.isValid(_this2.props.openHours.delete(index));
        _this2.props.onRemoveTime(index, valid);
      };
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(MultiTimeSelect, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          openHours = _props2.openHours,
          onAddTime = _props2.onAddTime;

      var valid = this.isValid(openHours);

      var timeSelects = openHours.map(function (hoursSet, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TimeSelect, {
          key: 'multi-time-select-' + index,
          day: hoursSet.get('dayOfWeek'),
          opens: hoursSet.get('opens'),
          closes: hoursSet.get('closes'),
          onSelection: _this3.handleSelect(index),
          onRemove: _this3.handleRemoveTime(index)
        });
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__style___default.a.MultiTimeSelect },
        this.renderInvalidLabel(valid),
        timeSelects,
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'add-time', onClick: onAddTime },
          '+ Add time'
        )
      );
    }
  }, {
    key: 'renderInvalidLabel',
    value: function renderInvalidLabel(valid) {
      if (!valid) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: 'invalid-label' },
          'Your start time must be before your finish time'
        );
      }
    }
  }, {
    key: 'isValid',
    value: function isValid(hours) {
      return hours.reduce(function (result, hoursSet) {
        return result && isValidAvailability(hoursSet.get('opens'), hoursSet.get('closes'));
      }, true);
    }
  }]);

  return MultiTimeSelect;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

MultiTimeSelect.propTypes = {
  openHours: __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["f" /* Hours */]).isRequired,
  onSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onRemoveTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onAddTime: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (MultiTimeSelect);

/***/ }),

/***/ "PK+e":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 21 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.25 23.74H.75c-.414 0-.75-.333-.75-.743v-.742c0-4.38 3.568-8.29 8.086-9.35-2.532-.965-4.336-3.39-4.336-6.228C3.75 2.997 6.78 0 10.5 0c3.722 0 6.75 2.996 6.75 6.677 0 2.84-1.805 5.263-4.336 6.227C17.432 13.966 21 17.876 21 22.254v.743c0 .41-.336.742-.75.742zm-4.5-17.063c0-2.864-2.355-5.193-5.25-5.193s-5.25 2.33-5.25 5.193c0 2.863 2.355 5.193 5.25 5.193s5.25-2.33 5.25-5.193zm-5.25 7.418c-4.795 0-9 3.814-9 8.16h18c0-4.346-4.205-8.16-9-8.16z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "PK/j":
/***/ (function(module, exports) {

module.exports = "<svg width=\"20\" height=\"12\" viewBox=\"0 0 20 12\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#394F5A\" fill-rule=\"evenodd\"><path d=\"M7.263 8.852l-2.777 2.813A.62.62 0 0 1 3.95 12a.493.493 0 0 1-.35-.146L.638 8.852a.504.504 0 0 1 0-.707.49.49 0 0 1 .698 0l2.194 2.222V.5c0-.276.148-.5.42-.5.273 0 .58.224.58.5v9.706l2.035-2.06a.49.49 0 0 1 .698 0 .504.504 0 0 1 0 .706zM19.769 3.842a.491.491 0 0 1-.699 0l-2.12-2.14v9.762a.496.496 0 0 1-.494.498c-.273 0-.426-.216-.426-.492V1.633l-2.189 2.209a.491.491 0 0 1-.698 0 .502.502 0 0 1 0-.704L16.107.146c.04-.04.089-.068.14-.091A.43.43 0 0 1 16.456 0a.49.49 0 0 1 .349.146l2.964 2.992a.503.503 0 0 1 0 .704z\"></path></g></svg>"

/***/ }),

/***/ "PKrq":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 28 27\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27.85 26.6c-.16.25-.43.4-.72.4H.88c-.3 0-.57-.15-.73-.4-.16-.24-.2-.56-.1-.83l3.5-9c.15-.35.47-.57.83-.57H7c.48 0 .88.4.88.9s-.4.9-.88.9H4.97l-2.8 7.2h23.66l-2.8-7.2H21c-.48 0-.87-.4-.87-.9s.4-.9.87-.9h2.63c.35 0 .67.22.8.57l3.5 9c.12.27.08.6-.08.83zm-13.28-5.22c-.16.15-.37.22-.57.22-.2 0-.4-.07-.57-.22-.3-.26-7.3-6.53-7.3-13.24C6.13 3.64 9.66 0 14 0s7.88 3.65 7.88 8.14c0 6.7-7 12.98-7.3 13.24zM14 1.8c-3.38 0-6.12 2.84-6.12 6.34 0 4.86 4.5 9.74 6.12 11.34 1.62-1.6 6.13-6.5 6.13-11.34 0-3.5-2.75-6.34-6.13-6.34zm-3.5 6.37c0-2 1.57-3.6 3.5-3.6s3.5 1.6 3.5 3.6c0 1.98-1.57 3.6-3.5 3.6s-3.5-1.62-3.5-3.6zm3.5 1.8c.96 0 1.75-.8 1.75-1.8s-.8-1.8-1.75-1.8c-.96 0-1.75.8-1.75 1.8s.8 1.8 1.75 1.8z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "PLnn":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 53 59\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M43.524 40.082c-1.593 1.77-3.424 2.86-5.495 2.86h-.342c-1.183 0-2.34-.326-3.472-.92-1.276-.655-2.246-1.588-3.04-2.77-.82-1.16-1.266-2.428-1.266-3.77v-.41c0-1.32.253-2.57.892-3.754.682-1.293 1.604-2.298 2.83-3.097 1.205-.793 2.49-1.182 3.923-1.182h.133c1.3 0 2.528.256 3.688.85 1.183.633 2.148 1.498 2.897 2.635.727 1.138 1.16 2.366 1.3 3.703.02.278.032.563.032.835 0 1.815-.693 3.496-2.08 5.022zm7.173-12.316c-1.295-2.228-3.116-4.013-5.393-5.358-1.7-.99-3.466-1.62-5.454-1.89v-7.077c1.988-.843 3.222-2.71 3.222-4.89 0-2.972-2.382-5.38-5.35-5.38-2.972 0-5.396 2.408-5.396 5.38 0 2.18 1.162 4.047 3.15 4.89v7.082c-1.59.23-3.24.726-4.746 1.488-3.076-2.337-13.164-10.002-19.065-14.48.14-.503.248-1.023.248-1.572C11.913 2.668 9.248 0 5.956 0S0 2.667 0 5.958c0 3.29 2.666 5.96 5.958 5.96 1.123 0 2.162-.33 3.058-.87l1.246.945 17.112 12.33c-.905.83-1.747 1.775-2.42 2.835-1.367 2.16-2.202 4.54-2.202 7.133v.542c0 1.82.346 3.54.936 5.154.518 1.41 1.277 2.692 2.217 3.85l-5.68 5.695c-.503-.185-1.033-.287-1.585-.287-1.23 0-2.383.48-3.252 1.348-.87.872-1.347 2.028-1.347 3.258s.48 2.386 1.35 3.255c.87.87 2.026 1.35 3.256 1.35s2.387-.48 3.257-1.35c.868-.87 1.348-2.025 1.348-3.255 0-.476-.073-.94-.21-1.382l5.87-5.87c.804.555 1.673 1.023 2.608 1.427 1.843.797 3.877 1.282 6.103 1.282h.41c2.46 0 4.782-.578 6.965-1.76 2.3-1.25 4.1-2.96 5.46-5.14 1.367-2.19 2.12-4.606 2.12-7.265v-.133c0-2.616-.606-5.03-1.878-7.24z\" fill=\"#E56E2C\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "PMAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchMarketoMappings: function fetchMarketoMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/marketo/mappings/attributes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchMarketoMappings: function patchMarketoMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/marketo/mappings/attributes', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchMarketoFields: function fetchMarketoFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/marketo/lead/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "PN6C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PNFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var ReportConstants = Marty.createConstants(['FETCH_USERS_ACTIVITY']);

/* harmony default export */ __webpack_exports__["a"] = (ReportConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "PRJa":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 13 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Targeting-Iteration\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Advanced-3\" transform=\"translate(-721.000000, -566.000000)\" fill=\"#BDD8E4\"><g id=\"info\" transform=\"translate(721.000000, 566.000000)\"><path d=\"M11.0949486,11.0965833 C9.86743048,12.324 8.23491861,13 6.49775155,13 C4.76112957,13 3.1286177,12.324 1.90055451,11.0960417 C-0.633518171,8.56158333 -0.633518171,4.437875 1.90055451,1.90395833 C3.1286177,0.676 4.76112957,0 6.49775155,0 C8.23491861,0 9.86743048,0.676 11.0949486,1.90395833 C12.3235569,3.131375 13,4.76395833 13,6.5 C13,8.23604167 12.3235569,9.868625 11.0949486,11.0965833 Z M10.3291125,2.669875 C9.30599901,1.64666667 7.94548161,1.08333333 6.49775155,1.08333333 C5.05056657,1.08333333 3.69004916,1.64666667 2.66693571,2.669875 C0.554754243,4.78183333 0.554754243,8.21816667 2.66693571,10.330125 C3.69004916,11.3533333 5.05056657,11.9166667 6.49775155,11.9166667 C7.94548161,11.9166667 9.30599901,11.3533333 10.3291125,10.330125 C11.352771,9.30745833 11.9163828,7.94679167 11.9163828,6.5 C11.9163828,5.05320833 11.352771,3.69308333 10.3291125,2.669875 Z M7.58191386,10.2916667 L5.4146794,10.2916667 C5.11597606,10.2916667 4.87287078,10.049 4.87287078,9.75 C4.87287078,9.451 5.11597606,9.20833333 5.4146794,9.20833333 L5.95648801,9.20833333 L5.95648801,7.04166667 L5.4146794,7.04166667 C5.11597606,7.04166667 4.87287078,6.799 4.87287078,6.5 C4.87287078,6.201 5.11597606,5.95833333 5.4146794,5.95833333 L6.49829663,5.95833333 C6.79754505,5.95833333 7.04010524,6.201 7.04010524,6.5 L7.04010524,9.20833333 L7.58191386,9.20833333 C7.88116228,9.20833333 8.12372247,9.451 8.12372247,9.75 C8.12372247,10.049 7.88116228,10.2916667 7.58191386,10.2916667 Z M6.49829663,4.875 C5.90088995,4.875 5.4146794,4.38858333 5.4146794,3.791125 C5.4146794,3.19420833 5.90088995,2.70833333 6.49829663,2.70833333 C7.09624839,2.70833333 7.58191386,3.19420833 7.58191386,3.791125 C7.58191386,4.38858333 7.09624839,4.875 6.49829663,4.875 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "PTbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_customer_TitleCard__ = __webpack_require__("ODkj");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var HoverAvatar = function (_Component) {
  _inherits(HoverAvatar, _Component);

  function HoverAvatar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HoverAvatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HoverAvatar.__proto__ || Object.getPrototypeOf(HoverAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayCard: false
    }, _this.showCard = function () {
      _this.setState({ displayCard: true });
    }, _this.hideCard = function () {
      _this.setState({ displayCard: false });
    }, _this.handleOnMouseOver = function () {
      _this.showCardTimeout = setTimeout(_this.showCard, 100);
      clearTimeout(_this.hideMenuTimeout);
    }, _this.handleOnMouseLeave = function () {
      _this.hideMenuTimeout = setTimeout(_this.hideCard, 100);
      clearTimeout(_this.showCardTimeout);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HoverAvatar, [{
    key: 'renderAvatar',
    value: function renderAvatar(avatarProps) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { onMouseOver: this.handleOnMouseOver, onMouseLeave: this.handleOnMouseLeave },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], avatarProps)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          attachment = _props.attachment,
          targetAttachment = _props.targetAttachment,
          targetOffset = _props.targetOffset,
          avatarProps = _objectWithoutProperties(_props, ['attachment', 'targetAttachment', 'targetOffset']);

      if (this.state.displayCard) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_tether___default.a,
          {
            attachment: attachment,
            targetAttachment: targetAttachment,
            targetOffset: targetOffset,
            constraints: [{ to: 'scrollParent', attachment: 'together' }]
          },
          this.renderAvatar(avatarProps),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onMouseOver: this.handleOnMouseOver, onMouseLeave: this.handleOnMouseLeave },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_customer_TitleCard__["a" /* default */], { endUser: this.props.user, showProfileLink: true, editable: false, width: '300px' })
          )
        );
      } else {
        return this.renderAvatar(avatarProps);
      }
    }
  }]);

  return HoverAvatar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

HoverAvatar.propTypes = {
  attachment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  targetAttachment: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  targetOffset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
HoverAvatar.defaultProps = {
  attachment: 'top left',
  targetAttachment: 'top right',
  targetOffset: '0 10px'
};
/* harmony default export */ __webpack_exports__["a"] = (HoverAvatar);

/***/ }),

/***/ "PUQf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Nav__ = __webpack_require__("+xz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnswerModal__ = __webpack_require__("yCoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__QuestionAdvancedModal__ = __webpack_require__("1CT1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GoalActionModal__ = __webpack_require__("HKYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GoalRoutingModal__ = __webpack_require__("VH+I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConditionModal__ = __webpack_require__("xHSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScheduleModal__ = __webpack_require__("5d52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ExtensionInviteModal__ = __webpack_require__("E/eJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EditorCalendarLinkModal__ = __webpack_require__("f5yp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EmailEditSenderModal__ = __webpack_require__("WdEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SequenceInviteModal__ = __webpack_require__("UrZR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SendEmailConfirmModal__ = __webpack_require__("YbvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditorTokenModal__ = __webpack_require__("N+TI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EditorCtaButtonModal__ = __webpack_require__("87IZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GoogleAuthModal__ = __webpack_require__("cP8E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PlaybookDraftToggle__ = __webpack_require__("vd8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SaveStatus__ = __webpack_require__("+cTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__DisableSalesSequenceConfirmModal__ = __webpack_require__("LYJB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_styl__ = __webpack_require__("G20T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_styl__);




























var Playbook = function Playbook(_ref) {
  var draft = _ref.draft,
      onNameChange = _ref.onNameChange,
      children = _ref.children,
      editSenderModalVisible = _ref.editSenderModalVisible,
      tokenModalVisible = _ref.tokenModalVisible,
      ctaButtonModalVisible = _ref.ctaButtonModalVisible,
      goalRoutingModalVisible = _ref.goalRoutingModalVisible,
      goalActionModalVisible = _ref.goalActionModalVisible,
      answerModalVisible = _ref.answerModalVisible,
      questionAdvancedModalVisible = _ref.questionAdvancedModalVisible,
      extensionInviteModalVisible = _ref.extensionInviteModalVisible,
      calendarLinkModalVisible = _ref.calendarLinkModalVisible,
      scheduleModalVisible = _ref.scheduleModalVisible,
      conditionModalVisible = _ref.conditionModalVisible,
      sequenceInviteModalVisible = _ref.sequenceInviteModalVisible,
      googleAuthModalVisible = _ref.googleAuthModalVisible,
      isOneTimeEmailPlaybook = _ref.isOneTimeEmailPlaybook,
      isStatusLoading = _ref.isStatusLoading,
      isDraftEnabled = _ref.isDraftEnabled,
      isAutosaveActive = _ref.isAutosaveActive,
      sendEmailConfirmModalVisible = _ref.sendEmailConfirmModalVisible,
      disableSalesSequenceModalVisible = _ref.disableSalesSequenceModalVisible,
      isEmailPlaybook = _ref.isEmailPlaybook,
      isSignaturePlaybook = _ref.isSignaturePlaybook;


  function handleExit() {
    var exitLink = __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["c" /* APP_URL */] + '/playbooks';
    if (isSignaturePlaybook) exitLink += '/list/signature';
    if (isEmailPlaybook) exitLink += '/list/email';
    window.location.href = exitLink;
  }

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_22__style_styl___default.a.Playbook },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-header flex-space-between' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["InlineEditInput"], {
        className: 'playbook-title-inline-edit-input',
        type: 'heading',
        headingSize: 'h3',
        value: draft.name,
        onChange: onNameChange
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-save-content flex' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SaveStatus__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Span"],
          { className: 'playbook-exit', onClick: handleExit },
          'Exit'
        ),
        !isOneTimeEmailPlaybook && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-enable flex-space-between' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            !isAutosaveActive && isStatusLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'playbook-enable-loading' },
              isDraftEnabled ? 'Enabling' : 'Disabling',
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_LoadingDots__["a" /* default */], null)
            ),
            (isAutosaveActive || !isStatusLoading) && 'This playbook is'
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__PlaybookDraftToggle__["a" /* default */], null)
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Nav__["a" /* default */], { playbookId: draft.id }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'subcontent' },
        children
      )
    ),
    calendarLinkModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EditorCalendarLinkModal__["a" /* default */], null),
    editSenderModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EmailEditSenderModal__["a" /* default */], null),
    tokenModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EditorTokenModal__["a" /* default */], null),
    ctaButtonModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__EditorCtaButtonModal__["a" /* default */], null),
    answerModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AnswerModal__["a" /* default */], null),
    questionAdvancedModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__QuestionAdvancedModal__["a" /* default */], null),
    goalActionModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GoalActionModal__["a" /* default */], null),
    goalRoutingModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__GoalRoutingModal__["a" /* default */], null),
    conditionModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ConditionModal__["a" /* default */], null),
    extensionInviteModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ExtensionInviteModal__["a" /* default */], null),
    scheduleModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScheduleModal__["a" /* default */], null),
    sequenceInviteModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SequenceInviteModal__["a" /* default */], null),
    googleAuthModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__GoogleAuthModal__["a" /* default */], null),
    sendEmailConfirmModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SendEmailConfirmModal__["a" /* default */], null),
    disableSalesSequenceModalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__DisableSalesSequenceConfirmModal__["a" /* default */], null)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Playbook);

/***/ }),

/***/ "PVNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__ = __webpack_require__("qFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var TagQueries = Marty.createQueries({
  id: 'TagQueries',

  fetchTagsForOrgId: function fetchTagsForOrgId(orgId) {
    var _this = this;

    var promise = this.app.sources.TagAPI.fetchTagsForOrgId(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_LIST_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_LIST_FETCH_FAILED, res, orgId);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_LIST_FETCH_FAILED, error, orgId);
    });
  },
  createTagForOrgId: function createTagForOrgId(orgId, tagParams) {
    var _this2 = this;

    var promise = this.app.sources.TagAPI.createTagForOrgId(orgId, tagParams);

    promise.then(function (res) {
      if (res.status === 200) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_CREATE_DONE, res.body);
        return _this2.app.actions.NotificationActions.pushNotification({
          content: '\'' + res.body.name + '\' tag has been saved!'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_CREATE_FAILED, res, orgId, tagParams);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_CREATE_FAILED, error, orgId, tagParams);
    });
  },
  updateTagForOrgId: function updateTagForOrgId(orgId, tagId, tagParams) {
    var _this3 = this;

    var promise = this.app.sources.TagAPI.updateTagForOrgId(orgId, tagId, tagParams);

    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_UPDATE_DONE, res.body);
        return _this3.app.actions.NotificationActions.pushNotification({
          content: '\'' + res.body.name + '\' tag has been updated!'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_UPDATE_FAILED, res, orgId, tagId, tagParams);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_UPDATE_FAILED, error, orgId, tagId, tagParams);
    });
  },
  deleteTagForOrgId: function deleteTagForOrgId(orgId, tagId) {
    var _this4 = this;

    var promise = this.app.sources.TagAPI.deleteTagForOrgId(orgId, tagId);

    promise.then(function (res) {
      if (res.status === 200) {
        _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_DELETE_DONE, tagId);
        return _this4.app.actions.NotificationActions.pushNotification({
          content: 'Tag has been deleted!',
          variant: 'red'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_DELETE_FAILED, res, orgId, tagId);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_DELETE_FAILED, error, orgId, tagId);
    });
  },
  addTagsToConversationId: function addTagsToConversationId(conversationId, tagIds) {
    var _this5 = this;

    var promise = this.app.sources.TagAPI.addTagsToConversationId(conversationId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_CONVERSATION_ID_DONE, conversationId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_CONVERSATION_ID_FAILED, res, conversationId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_CONVERSATION_ID_FAILED, error, conversationId, tagIds);
    });
  },
  removeTagsFromConversationId: function removeTagsFromConversationId(conversationId, tagIds) {
    var _this6 = this;

    var promise = this.app.sources.TagAPI.removeTagsFromConversationId(conversationId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_CONVERSATION_ID_DONE, conversationId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_CONVERSATION_ID_FAILED, res, conversationId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_CONVERSATION_ID_FAILED, error, conversationId, tagIds);
    });
  },
  addTagsToCompanyId: function addTagsToCompanyId(companyId, tagIds) {
    var _this7 = this;

    var promise = this.app.sources.TagAPI.addTagsToCompanyId(companyId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_COMPANY_ID_DONE, companyId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_COMPANY_ID_FAILED, res, companyId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_COMPANY_ID_FAILED, error, companyId, tagIds);
    });
  },
  removeTagsFromCompanyId: function removeTagsFromCompanyId(companyId, tagIds) {
    var _this8 = this;

    var promise = this.app.sources.TagAPI.removeTagsFromCompanyId(companyId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_COMPANY_ID_DONE, companyId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_COMPANY_ID_FAILED, res, companyId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_COMPANY_ID_FAILED, error, companyId, tagIds);
    });
  },
  addTagsToEndUserId: function addTagsToEndUserId(endUserId, tagIds) {
    var _this9 = this;

    var promise = this.app.sources.TagAPI.addTagsToEndUserId(endUserId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_END_USER_ID_DONE, endUserId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_END_USER_ID_FAILED, res, endUserId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_ADD_TO_END_USER_ID_FAILED, error, endUserId, tagIds);
    });
  },
  removeTagsFromEndUserId: function removeTagsFromEndUserId(endUserId, tagIds) {
    var _this10 = this;

    var promise = this.app.sources.TagAPI.removeTagsFromEndUserId(endUserId, tagIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_END_USER_ID_DONE, endUserId, tagIds);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_END_USER_ID_FAILED, res, endUserId, tagIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_REMOVE_FROM_END_USER_ID_FAILED, error, endUserId, tagIds);
    });
  },
  setResponseTags: function setResponseTags(campaignId, conversationId, questionId, tagIds) {
    var _this11 = this;

    return this.app.sources.TagAPI.setResponseTags(campaignId, conversationId, questionId, tagIds).then(function (data) {
      return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_RESPONSE_DONE, campaignId, conversationId, questionId, data.tags);
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_RESPONSE_FAILED, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TagQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "PawR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return states; });
var states = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

/***/ }),

/***/ "PbNt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ChatWidgetTargetRule":"ChatWidgetTargetRule---_iSn0"};

/***/ }),

/***/ "Pe/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Editor__ = __webpack_require__("eJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailCaptureSliderPreview__ = __webpack_require__("6lcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_PlaybookPreviews_EmailCapture_UnsubmittedPreview__ = __webpack_require__("okxz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_PlaybookPreviews_EmailCapture_SubmittedPreview__ = __webpack_require__("oava");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("d4Rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);













var EmailCaptureMessage = function EmailCaptureMessage(_ref) {
  var message = _ref.message,
      onMessageChange = _ref.onMessageChange,
      headline = _ref.headline,
      onHeadlineChange = _ref.onHeadlineChange,
      thankYouMessage = _ref.thankYouMessage,
      onThankYouMessageChange = _ref.onThankYouMessageChange,
      thankYouHeadline = _ref.thankYouHeadline,
      onThankYouHeadlineChange = _ref.onThankYouHeadlineChange,
      selectedUser = _ref.selectedUser,
      onAuthorChange = _ref.onAuthorChange,
      selectedFont = _ref.selectedFont;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-message playbook-email-capture-message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Customize the message your users will see.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'What do you want to say? Keep it short and sweet, be personal and human!'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Card__["a" /* default */],
      {
        title: 'Sign Up Message',
        description: headline,
        className: 'drift-form'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-email-capture-message-preview' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_PlaybookPreviews_EmailCapture_UnsubmittedPreview__["a" /* default */], {
          title: headline,
          message: message,
          previewUser: selectedUser,
          fontFamily: selectedFont })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Sign Up Headline'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: onHeadlineChange, value: headline }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Sign Up Message'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Editor__["a" /* default */], { value: message, onChange: onMessageChange }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Send From'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_UserSelect__["a" /* default */], { selectedUserId: selectedUser ? selectedUser.id : null, onUserIdChange: onAuthorChange })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__Card__["a" /* default */],
      {
        title: 'Thank You Message',
        description: thankYouHeadline,
        className: 'drift-form'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-email-capture-message-preview' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_PlaybookPreviews_EmailCapture_SubmittedPreview__["a" /* default */], { title: thankYouHeadline, message: thankYouMessage, fontFamily: selectedFont })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Thank You Headline'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: onThankYouHeadlineChange, value: thankYouHeadline }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Thank You Message'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Editor__["a" /* default */], { onChange: onThankYouMessageChange, value: thankYouMessage })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailCaptureMessage);

/***/ }),

/***/ "Pga6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api__ = __webpack_require__("jYTI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__ = __webpack_require__("CpSP");






















var fetchPlaybook = function fetchPlaybook(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_17" /* fetchPlaybook */].toString()).pluck('payload').mergeMap(function (_ref) {
    var id = _ref.id;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetch(id).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_44" /* fetchPlaybookPending */]({ id: id })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_34" /* fetchPlaybookFailed */]({ id: id, error: error }));
    });
  });
};

var getPlaybook = function getPlaybook(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_67" /* getPlaybook */].toString()).pluck('payload').mergeMap(function (_ref2) {
    var playbookId = _ref2.playbookId,
        nextAction = _ref2.nextAction;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetch(playbookId).flatMap(function (playbook) {
      return [nextAction(playbook), __WEBPACK_IMPORTED_MODULE_14__actions__["_75" /* getPlaybookSuccess */](playbook)];
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_74" /* getPlaybookPending */]({ playbookId: playbookId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_73" /* getPlaybookFailed */]({ playbookId: playbookId, error: error }));
    });
  });
};

var allChanges = function allChanges(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_135" /* setActionInboxId */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_183" /* setName */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_210" /* setSlug */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_176" /* setGreeting */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["l" /* addQuestion */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["f" /* addEmailCaptureQuestion */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["k" /* addPhoneCaptureQuestion */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["M" /* deleteQuestion */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_95" /* moveQuestionUp */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["b" /* addAnswer */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["G" /* deleteAnswer */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_66" /* flagAnswer */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_209" /* setSkipTo */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_172" /* setFieldAttributeName */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_187" /* setQuestionPrompt */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_189" /* setSenderName */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_181" /* setMessage */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_222" /* setVideoUrl */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_164" /* setEmailMessage */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_165" /* setEmailOverride */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_168" /* setEmailTitle */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_163" /* setEmailDelay */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_193" /* setSequenceEmailOverride */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_198" /* setSequenceSenderName */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_190" /* setSequenceAuthorId */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_177" /* setHeadline */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_217" /* setThankYouMessage */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_216" /* setThankYouHeadline */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_146" /* setCtaType */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_145" /* setCtaLink */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_144" /* setCtaCopy */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_182" /* setMetaAttribute */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_138" /* setAuthorId */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_167" /* setEmailTheme */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["h" /* addGoal */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["K" /* deleteGoal */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_173" /* setGoalClassification */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_174" /* setGoalMessage */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["L" /* deleteKeyword */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["i" /* addKeyword */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_178" /* setKeywordText */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_179" /* setKeywordType */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_136" /* setAnswerType */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_140" /* setButtonText */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_188" /* setResponse */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_148" /* setDefaultPhoneCountryCode */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_106" /* saveGoalAction */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_103" /* removeGoalAction */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_107" /* saveGoalRoutingOption */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_149" /* setDraftFrequency */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_137" /* setAudience */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_221" /* setUserListIds */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_171" /* setExcludedUserListIds */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_143" /* setConditionValue */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_141" /* setConditionField */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_142" /* setConditionOperator */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["c" /* addCondition */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["d" /* addConditionSet */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["H" /* deleteCondition */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["I" /* deleteConditionSet */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_168" /* setEmailTitle */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_163" /* setEmailDelay */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_224" /* setWeekdaysOnly */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_214" /* setSmartSending */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_219" /* setUnenrollOnReply */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_220" /* setUnenrollOnReplyByDomain */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_218" /* setThreadedWithPrevious */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["e" /* addEmail */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["J" /* deleteEmail */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_94" /* moveEmailUp */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_212" /* setSmartFilterEngagedContacts */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_180" /* setMarketingEmailLayout */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_162" /* setEmailBannerSuccess */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["s" /* clearEmailBanner */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_166" /* setEmailPlaybookConditionValue */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_139" /* setButtonOnlyResponses */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_196" /* setSequenceIndividualEmailOverride */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_197" /* setSequenceIndividualSenderName */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_194" /* setSequenceIndividualDynamicAttr */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_195" /* setSequenceIndividualDynamicFormat */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_205" /* setSignatureBody */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_206" /* setSignatureIncludeAvatar */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_208" /* setSignatureIncludeSocial */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_207" /* setSignatureIncludeBanner */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_204" /* setSignatureBannerSuccess */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_202" /* setSignatureBannerLinkURL */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["u" /* clearSignatureBanner */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_104" /* removeSignature */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["g" /* addEmptyBannerSignature */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_102" /* removeEmptyBannerSignature */].toString()).filter(function (action) {
    return action.payload && !action.payload.dontSave || !action.payload;
  }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["m" /* allChanges */]);
};

var disablePlaybook = function disablePlaybook(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["m" /* allChanges */].toString()).switchMap(function () {
    var autosaveDisabled = store.getState().getIn(['playbooks', 'ui', 'autosave']) === false;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(autosaveDisabled ? __WEBPACK_IMPORTED_MODULE_14__actions__["_93" /* markDraftUnsaved */]() : __WEBPACK_IMPORTED_MODULE_14__actions__["_110" /* savePlaybookDraft */]());
  });
};

var getPlaybookByCampaignId = function getPlaybookByCampaignId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_68" /* getPlaybookByCampaignId */].toString()).pluck('payload').mergeMap(function (_ref3) {
    var campaignId = _ref3.campaignId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybookByCampaignId(campaignId).flatMap(function (playbook) {
      return [__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */](playbook), __WEBPACK_IMPORTED_MODULE_14__actions__["_72" /* getPlaybookByCampaignIdSuccess */]({ campaignId: campaignId, playbook: playbook })];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_70" /* getPlaybookByCampaignIdFailed */]({ campaignId: campaignId, err: err }));
    });
  });
};

var fetchPlaybookByCampaignId = function fetchPlaybookByCampaignId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_18" /* fetchPlaybookByCampaignId */].toString()).pluck('payload').mergeMap(function (_ref4) {
    var campaignId = _ref4.campaignId,
        conversationId = _ref4.conversationId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybookByCampaignId(campaignId).flatMap(function (playbook) {
      return [__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */](playbook), __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_actions__["W" /* setPlaybookIdForConversation */]({
        conversationId: conversationId,
        playbookId: playbook.get('result').get(0)
      })];
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_20" /* fetchPlaybookByCampaignIdPending */]({ conversationId: conversationId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_19" /* fetchPlaybookByCampaignIdFailed */]({ conversationId: conversationId, error: error }));
    });
  });
};

var fetchPlaybookCardinality = function fetchPlaybookCardinality(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_25" /* fetchPlaybookCardinality */].toString()).debounceTime(300).pluck('payload').switchMap(function (userListObj) {
    // we might be passed empty userListIds, in which case, we want to return 0
    // it's a little silly to expect the API to check empty lists, as checking query params like that
    // is at the mercy of Dropwizard's API
    var userListIds = userListObj.userListIds,
        excludedUserListIds = userListObj.excludedUserListIds,
        smartFilters = userListObj.smartFilters,
        isEmailPlaybook = userListObj.isEmailPlaybook;

    var isEmpty = function isEmpty(maybeArrayMaybeList) {
      return maybeArrayMaybeList.size === 0 || maybeArrayMaybeList.length === 0;
    };
    var isObjEmpty = function isObjEmpty(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(obj).reduce(function (hasBeenNull, value) {
        return hasBeenNull && value === null;
      }, true);
    };
    if (!!userListIds && !!excludedUserListIds && isEmpty(userListIds) && isEmpty(excludedUserListIds) && isObjEmpty(smartFilters)) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_29" /* fetchPlaybookCardinalitySuccess */]({ cardinality: 0 }));
    }
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchCardinality(userListObj).flatMap(function (res) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_29" /* fetchPlaybookCardinalitySuccess */](res.response));
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_28" /* fetchPlaybookCardinalityPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_27" /* fetchPlaybookCardinalityFailed */]({ error: error }));
    });
  });
};

var fetchPlaybookByInteractionId = function fetchPlaybookByInteractionId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_21" /* fetchPlaybookByInteractionId */].toString()).pluck('payload').mergeMap(function (_ref5) {
    var interactionId = _ref5.interactionId,
        conversationId = _ref5.conversationId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybookByInteractionId(interactionId).flatMap(function (playbook) {
      return [__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */](playbook), __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_actions__["W" /* setPlaybookIdForConversation */]({
        conversationId: conversationId,
        playbookId: playbook.get('result').get(0)
      })];
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_23" /* fetchPlaybookByInteractionIdPending */]({ conversationId: conversationId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_22" /* fetchPlaybookByInteractionIdFailed */]({ conversationId: conversationId, error: error }));
    });
  });
};

var fetchPlaybooksByIds = function fetchPlaybooksByIds(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_50" /* fetchPlaybooksByIds */].toString()).pluck('payload').mergeMap(function (playbookIds) {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].byIds(playbookIds).map(function (_ref6) {
      var playbooks = _ref6.playbooks;

      return __WEBPACK_IMPORTED_MODULE_14__actions__["_53" /* fetchPlaybooksByIdsSuccess */](playbooks);
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_52" /* fetchPlaybooksByIdsPending */]({ playbookIds: playbookIds })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_51" /* fetchPlaybooksByIdsFailed */]({ playbookIds: playbookIds, error: error }));
    });
  });
};

var createPlaybook = function createPlaybook(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["C" /* createPlaybook */].toString()).pluck('payload').mergeMap(function (type) {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].create(type).mergeMap(function (draft) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */](draft)), __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])('/playbooks/' + draft.get('result') + '/edit')));
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["E" /* createPlaybookPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["D" /* createPlaybookFailed */]({ error: error }));
    });
  });
};

var clonePlaybook = function clonePlaybook(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["v" /* clonePlaybook */].toString()).pluck('payload').mergeMap(function (id) {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].clone(id).mergeMap(function (draft) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */](draft)), __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])('/playbooks/' + draft.get('result') + '/edit')));
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["x" /* clonePlaybookPending */](id)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["w" /* clonePlaybookFailed */]({ error: error, id: id }));
    });
  });
};

var sendTestEmail = function sendTestEmail(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_125" /* sendTestEmail */].toString()).pluck('payload').mergeMap(function (_ref7) {
    var emailId = _ref7.emailId;

    var state = store.getState();
    var actionId = __WEBPACK_IMPORTED_MODULE_15__selectors__["V" /* getFirstActionType */](state).get('id');
    var playbookId = __WEBPACK_IMPORTED_MODULE_15__selectors__["p" /* draftId */](state);
    var orgId = __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__["orgId"](state);
    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](state);
    var email = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state).email;
    playbook.orgId = orgId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].sendTestEmail(playbookId, actionId, email, emailId, playbook).map(function () {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Test email sent to ' + email + '.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_128" /* sendTestEmailSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_127" /* sendTestEmailPending */]()).catch(function (error) {
      if (error.response.message.indexOf('authenticated') > -1) {
        __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: "You haven't authenticated your gmail account yet so we can't send test emails!",
          variant: 'red',
          sticky: true
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'There was an error sending your test email, please try again.',
          variant: 'red'
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_126" /* sendTestEmailFailed */](error));
    });
  });
};

var sendTestSequence = function sendTestSequence(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_129" /* sendTestSequence */].toString()).pluck('payload').mergeMap(function () {
    var state = store.getState();
    var actionId = __WEBPACK_IMPORTED_MODULE_15__selectors__["V" /* getFirstActionType */](state).get('id');
    var playbookId = __WEBPACK_IMPORTED_MODULE_15__selectors__["p" /* draftId */](state);
    var orgId = __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__["orgId"](state);
    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](state);
    var email = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state).email;
    playbook.orgId = orgId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].sendTestSequence(playbookId, actionId, email, playbook).map(function () {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Test sequence sent to ' + email + ', your emails will arrive about 5 minutes apart.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_133" /* sendTestSequenceSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_132" /* sendTestSequencePending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'There was an error sending your test sequence, please try again.',
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_131" /* sendTestSequenceFailed */](error));
    });
  });
};

var fetchPlaybooksPriority = function fetchPlaybooksPriority(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_58" /* fetchPlaybooksPriority */].toString()).pluck('payload').switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].search([__WEBPACK_IMPORTED_MODULE_16__constants__["_141" /* PlaybookStatus */].ENABLED, __WEBPACK_IMPORTED_MODULE_16__constants__["_141" /* PlaybookStatus */].DISABLED], false) // don't normalize
    .map(__WEBPACK_IMPORTED_MODULE_14__actions__["_61" /* fetchPlaybooksPrioritySuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_60" /* fetchPlaybooksPriorityPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_59" /* fetchPlaybooksPriorityFailed */]({ error: error }));
    });
  });
};

var fetchChatActivePlaybooks = function fetchChatActivePlaybooks(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["Y" /* fetchChatActivePlaybooks */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchChatActive().map(__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_121" /* searchPlaybooksPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_120" /* searchPlaybooksFailed */]({ err: err }));
    });
  });
};

var updateStatus = function updateStatus(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_215" /* setStatus */].toString()).pluck('payload').mergeMap(function (_ref8) {
    var id = _ref8.id,
        status = _ref8.status;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].updateStatus(id, status).flatMap(function () {
      return [__WEBPACK_IMPORTED_MODULE_14__actions__["_116" /* savePlaybookSuccess */](), __WEBPACK_IMPORTED_MODULE_14__actions__["_30" /* fetchPlaybookCounts */](), __WEBPACK_IMPORTED_MODULE_14__actions__["_58" /* fetchPlaybooksPriority */]()];
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_115" /* savePlaybookPending */]({ id: id })).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We were unable to save your playbook, please contact support for more information",
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_114" /* savePlaybookFailed */]({ id: id, error: error }));
    });
  });
};

var updateDraftStatus = function updateDraftStatus(action$, _ref9) {
  var getState = _ref9.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_151" /* setDraftStatus */].toString()).pluck('payload').mergeMap(function (_ref10) {
    var status = _ref10.status;

    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](getState());
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].updateStatus(playbook.id, status).map(function () {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_155" /* setDraftStatusSuccess */]({ status: status });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_154" /* setDraftStatusPending */]()).catch(function (err) {
      var errorMessage = void 0;

      var responseText = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["pathOr"])('', ['response', 'message'], err);
      // cases for restricted functionality on sunset email features
      switch (responseText) {
        case 'org_cannot_enable_sales_sequence_playbooks':
        case 'org_cannot_enable_marketing_email_playbooks':
          errorMessage = 'This playbook type can no longer be enabled';
          break;

        case 'org_cannot_clone_sales_sequence_playbooks':
        case 'org_cannot_clone_marketing_email_playbooks':
          errorMessage = 'Cloning has been disabled for this playbook type';
          break;

        default:
          errorMessage = 'Could not save changes';
          break;
      }

      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: errorMessage,
        variant: 'red',
        sticky: true
      });

      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_153" /* setDraftStatusFailed */]()), __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_151" /* setDraftStatus */]({ status: __WEBPACK_IMPORTED_MODULE_16__constants__["_141" /* PlaybookStatus */].DISABLED })));
    });
  });
};

var setDraftSuccess = function setDraftSuccess(action$, _ref11) {
  var getState = _ref11.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_155" /* setDraftStatusSuccess */].toString()).pluck('payload').mergeMap(function (_ref12) {
    var status = _ref12.status;

    if (__WEBPACK_IMPORTED_MODULE_15__selectors__["_2" /* getIsEmailPlaybook */](getState()) && (status === 'ENABLED' || status === 'SENT')) {
      var appNotif = status === 'ENABLED' ? __WEBPACK_IMPORTED_MODULE_15__selectors__["_6" /* getIsOutboundSequencePlaybook */](getState()) ? 'Your email was successfully enabled!' : 'Your email was successfully sent and enabled!' : 'Your email was successfully sent!';
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: appNotif
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
  });
};

var saveDraft = function saveDraft(action$, _ref13) {
  var getState = _ref13.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_110" /* savePlaybookDraft */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["N" /* disablePlaybook */].toString()).debounceTime(1000).mergeMap(function () {
    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](getState());
    if (playbook.meta.driftLinkOnly) {
      playbook.targeting.display = [];
      playbook.targeting.userListIds = [];
      playbook.targeting.excludedUserListIds = [];
      playbook.targeting.audience = __WEBPACK_IMPORTED_MODULE_16__constants__["w" /* AudienceType */].NONE;
    }
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].update(playbook).map(function () {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_119" /* searchPlaybooks */]([playbook.status]);
    }).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */]());
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_113" /* savePlaybookDraftPending */]({ id: playbook.id })).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We were unable to save your playbook, please contact support for more information",
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_112" /* savePlaybookDraftFailed */]({ id: playbook.id, error: error }));
    });
  });
};

var scheduleDraft = function scheduleDraft(action$, _ref14) {
  var getState = _ref14.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_117" /* schedulePlaybookDraft */].toString()).mergeMap(function () {
    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](getState());
    playbook.status = __WEBPACK_IMPORTED_MODULE_16__constants__["_141" /* PlaybookStatus */].SCHEDULED;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].update(playbook).mergeMap(function (draft) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */](draft)), __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])('/playbooks')));
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_113" /* savePlaybookDraftPending */]({ id: playbook.id })).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We were unable to save your playbook, please contact support for more information",
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_112" /* savePlaybookDraftFailed */]({ id: playbook.id, error: error }));
    });
  });
};

var receivePlaybook = function receivePlaybook(action$, _ref15) {
  var getState = _ref15.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_100" /* receivePlaybookDraft */].toString()).pluck('payload').mergeMap(function (response) {
    var normalizedLocal = __WEBPACK_IMPORTED_MODULE_15__selectors__["r" /* draftRoot */](getState());
    if (normalizedLocal.size === 0) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* acceptPlaybookDraft */](response));
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
    }
  });
};

var fetchPlaybooksCounts = function fetchPlaybooksCounts(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_30" /* fetchPlaybookCounts */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].counts().map(__WEBPACK_IMPORTED_MODULE_14__actions__["_33" /* fetchPlaybookCountsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_32" /* fetchPlaybookCountsPending */]).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_31" /* fetchPlaybookCountsFailed */]({ error: error }));
    });
  });
};

var searchPlaybooks = function searchPlaybooks(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_119" /* searchPlaybooks */].toString()).pluck('payload').mergeMap(function (status) {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].search(status).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_121" /* searchPlaybooksPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_120" /* searchPlaybooksFailed */]({ error: error }));
    });
  });
};

var searchEnabledPlaybooks = function searchEnabledPlaybooks(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_118" /* searchEnabledPlaybooks */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchEnabled().map(__WEBPACK_IMPORTED_MODULE_14__actions__["_122" /* searchPlaybooksSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_121" /* searchPlaybooksPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_120" /* searchPlaybooksFailed */]({ error: error }));
    });
  });
};

var setCurrentGoalId = function setCurrentGoalId(action$, _ref16) {
  var getState = _ref16.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_147" /* setCurrentGoalId */].toString()).mergeMap(function () {
    var currentGoal = __WEBPACK_IMPORTED_MODULE_15__selectors__["j" /* currentGoal */](getState());
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_124" /* selectGoalRoutingOptionUI */](currentGoal.routing));
  });
};

var fetchDataPreviewEmail = function fetchDataPreviewEmail(action$, _ref17) {
  var getState = _ref17.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["Z" /* fetchDataPreviewEmail */].toString()).pluck('payload').mergeMap(function (_ref18) {
    var playbookId = _ref18.playbookId,
        userListIds = _ref18.userListIds,
        campaignId = _ref18.campaignId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */]
    // TODO: _.unescape is a very naive un-escaping function. We definitely want something more robust, since the API
    // endpoint will break on things like the single quote hex code instead of the normal HTMl code. e.g.: &#39; -> ✅ ; &#x26; -> ❌
    .fetchDataPreviewEmail(_.unescape(__WEBPACK_IMPORTED_MODULE_15__selectors__["w" /* emailMessage */](getState()).message), userListIds, campaignId).map(function (templateResponse) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_3" /* fetchDataPreviewEmailSuccess */]({
        template: templateResponse.template,
        playbookId: playbookId
      });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_2" /* fetchDataPreviewEmailPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_1" /* fetchDataPreviewEmailFailed */]({ error: error }));
    });
  });
};

var fetchDataPreviewSequenceEmail = function fetchDataPreviewSequenceEmail(action$, _ref19) {
  var getState = _ref19.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_4" /* fetchDataPreviewSequenceEmail */].toString()).pluck('payload').mergeMap(function (_ref20) {
    var emailId = _ref20.emailId,
        userListIds = _ref20.userListIds,
        campaignId = _ref20.campaignId,
        userId = _ref20.userId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */]
    // TODO: _.unescape is a very naive un-escaping function. We definitely want something more robust, since the API
    // endpoint will break on things like the single quote hex code instead of the normal HTMl code. e.g.: &#39; -> ✅ ; &#x26; -> ❌
    .fetchDataPreviewEmail(_.unescape(__WEBPACK_IMPORTED_MODULE_15__selectors__["S" /* getEmail */](getState(), { id: emailId }).message), userListIds, campaignId, userId).map(function (templateResponse) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_8" /* fetchDataPreviewSequenceEmailSuccess */]({
        template: templateResponse.template,
        emailId: emailId
      });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_7" /* fetchDataPreviewSequenceEmailPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_6" /* fetchDataPreviewSequenceEmailFailed */]({ error: error }));
    });
  });
};

var enroll = function enroll(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["U" /* enroll */].toString()).pluck('payload').mergeMap(function (_ref21) {
    var action = _ref21.action,
        playbookId = _ref21.playbookId,
        email = _ref21.email;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].enroll(playbookId, email, action).map(function () {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["X" /* enrollSuccess */]({ email: email });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["W" /* enrollPending */]({ email: email })).catch(function (request) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["V" /* enrollFailed */]({
        email: email,
        error: request.response ? request.response.message : 'Something went wrong'
      }));
    });
  });
};

var unenroll = function unenroll(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_242" /* unenroll */].toString()).pluck('payload').mergeMap(function (_ref22) {
    var endUserId = _ref22.endUserId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].unenroll(endUserId).map(function () {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'You unenrolled this user from all sequences.'
      });
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_245" /* unenrollSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_244" /* unenrollPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_243" /* unenrollFailed */](error));
    });
  });
};

var fetchEnrolledPlaybookId = function fetchEnrolledPlaybookId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_9" /* fetchEnrolledPlaybookId */].toString()).pluck('payload').switchMap(function (_ref23) {
    var email = _ref23.email;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchEnrolledPlaybookId(email).map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_12" /* fetchEnrolledPlaybookIdSuccess */](!data.response.lockTTL && data.response.playbookId);
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_11" /* fetchEnrolledPlaybookIdPending */]()).catch(function (error) {
      if (error.status) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_12" /* fetchEnrolledPlaybookIdSuccess */](false));
      }
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_10" /* fetchEnrolledPlaybookIdFailed */]());
    });
  });
};

var notify = function notify(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_96" /* notify */].toString()).pluck('payload').mergeMap(function (_ref24) {
    var playbookId = _ref24.playbookId,
        userIds = _ref24.userIds;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].notify(playbookId, userIds).map(function () {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'You successfully shared this sequence.'
      });
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_99" /* notifySuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_98" /* notifyPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_97" /* notifyFailed */](error));
    });
  });
};

var fetchEnrolledSequenceCount = function fetchEnrolledSequenceCount(action$, _ref25) {
  var getState = _ref25.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_13" /* fetchEnrolledSequenceCount */].toString()).mergeMap(function () {
    var state = getState();
    var authorId = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state).id;
    var hasSalesSequences = __WEBPACK_IMPORTED_MODULE_11_utils_Access__["c" /* default */].hasScopes('SALES_SEQUENCES');
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchEnrolledSequenceCount({ authorId: authorId, hasSalesSequences: hasSalesSequences }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_16" /* fetchEnrolledSequenceCountSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_15" /* fetchEnrolledSequenceCountPending */]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_14" /* fetchEnrolledSequenceCountFailed */]());
    });
  });
};

var fetchPlaybookForEndUser = function fetchPlaybookForEndUser(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_40" /* fetchPlaybookForEndUser */].toString()).pluck('payload').mergeMap(function (_ref26) {
    var email = _ref26.email,
        playbookId = _ref26.playbookId;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybookForEndUser({ playbookId: playbookId, email: email }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_43" /* fetchPlaybookForEndUserSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_42" /* fetchPlaybookForEndUserPending */]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_41" /* fetchPlaybookForEndUserFailed */]());
    });
  });
};

var uploadEmailBannerImage = function uploadEmailBannerImage(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_159" /* setEmailBanner */].toString()).pluck('payload').mergeMap(function (_ref27) {
    var emailId = _ref27.emailId,
        file = _ref27.file;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].uploadImage(file).map(function (res) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_162" /* setEmailBannerSuccess */]({ res: res, emailId: emailId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_161" /* setEmailBannerPending */]({ emailId: emailId })).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_160" /* setEmailBannerFailed */]({ emailId: emailId }));
    });
  });
};

var uploadSignatureBannerImage = function uploadSignatureBannerImage(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_199" /* setSignatureBanner */].toString()).pluck('payload').mergeMap(function (_ref28) {
    var file = _ref28.file,
        signatureId = _ref28.signatureId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].uploadImage(file).map(function (res) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_204" /* setSignatureBannerSuccess */]({ value: res.url, signatureId: signatureId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_203" /* setSignatureBannerPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_201" /* setSignatureBannerFailed */]({ err: err }));
    });
  });
};

var fetchPlaybooksByGatedPlan = function fetchPlaybooksByGatedPlan(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_45" /* fetchPlaybooksByGatedPlan */].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybooksByGatedPlan().map(__WEBPACK_IMPORTED_MODULE_14__actions__["_49" /* fetchPlaybooksByGatedPlanSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_48" /* fetchPlaybooksByGatedPlanPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_47" /* fetchPlaybooksByGatedPlanFailed */]({ err: err }));
    });
  });
};

var fetchSignatureMultiBannerPreview = function fetchSignatureMultiBannerPreview(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_62" /* fetchSignatureMultiBannerPreview */].toString()).pluck('payload').debounceTime(350) // average keystroke frequency
  .switchMap(function (_ref29) {
    var userId = _ref29.userId,
        _ref29$isPlaybookEdit = _ref29.isPlaybookEditor,
        isPlaybookEditor = _ref29$isPlaybookEdit === undefined ? false : _ref29$isPlaybookEdit;

    var state = store.getState();
    var orgId = __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__["orgId"](state);
    var playbook = __WEBPACK_IMPORTED_MODULE_15__selectors__["m" /* denormalizedDraft */](state);
    playbook.orgId = orgId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchSignatureMultiBannerPreviewForPlaybook({ playbook: playbook, userId: userId, isPlaybookEditor: isPlaybookEditor }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_65" /* fetchSignatureMultiBannerPreviewSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_64" /* fetchSignatureMultiBannerPreviewPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_63" /* fetchSignatureMultiBannerPreviewFailed */]({ err: err }));
    });
  });
};

var asyncButtonPress = function asyncButtonPress(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["n" /* asyncButtonPress */].toString()).mergeMap(function (_ref30) {
    var _ref30$payload = _ref30.payload,
        url = _ref30$payload.url,
        successMessage = _ref30$payload.successMessage,
        errorMessage = _ref30$payload.errorMessage,
        _ref30$payload$data = _ref30$payload.data,
        data = _ref30$payload$data === undefined ? null : _ref30$payload$data,
        clickId = _ref30$payload.clickId,
        _ref30$payload$method = _ref30$payload.method,
        method = _ref30$payload$method === undefined ? 'GET' : _ref30$payload$method,
        _ref30$payload$succes = _ref30$payload.successCallback,
        successCallback = _ref30$payload$succes === undefined ? function () {} : _ref30$payload$succes,
        _ref30$payload$errorC = _ref30$payload.errorCallback,
        errorCallback = _ref30$payload$errorC === undefined ? function () {} : _ref30$payload$errorC;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3_axios___default()({
      method: method.toLowerCase(),
      data: data,
      url: url,
      headers: {
        'content-type': 'application/json; charset=UTF-8',
        'Authorization': 'bearer ' + Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["getAccessToken"])()
      }
    })).map(function (res) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: successMessage,
        variant: 'green'
      });
      successCallback.call(null, res);
      return __WEBPACK_IMPORTED_MODULE_14__actions__["q" /* asyncButtonPressSuccess */]({ clickId: clickId, meta: { at: Date.now() } });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["p" /* asyncButtonPressPending */]({ clickId: clickId, meta: { at: Date.now() } })).catch(function (err) {
      __WEBPACK_IMPORTED_MODULE_10_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: errorMessage,
        variant: 'red'
      });
      errorCallback.call(null, err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["o" /* asyncButtonPressFailed */]({ clickId: clickId, meta: { err: err, at: Date.now() } }));
    });
  });
};

var createInitialWelcomePlaybooks = function createInitialWelcomePlaybooks(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["y" /* createInitialWelcomePlaybooks */].toString()).pluck('payload').switchMap(function (_ref31) {
    var onlineMsg = _ref31.onlineMsg,
        offlineMsg = _ref31.offlineMsg;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].createInitialWelcomePlaybooks({ onlineMsg: onlineMsg, offlineMsg: offlineMsg }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["B" /* createInitialWelcomePlaybooksSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["A" /* createInitialWelcomePlaybooksPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["z" /* createInitialWelcomePlaybooksFailed */](err));
    });
  });
};

var fetchPlaybookForCampaignId = function fetchPlaybookForCampaignId(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_35" /* fetchPlaybookForCampaignId */].toString()).pluck('payload').filter(function (_ref32) {
    var campaignId = _ref32.campaignId;
    return __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_59" /* playbookForCampaignIdNeverFetched */](store.getState(), campaignId);
  }).mergeMap(function (_ref33) {
    var campaignId = _ref33.campaignId;
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybookByCampaignIdUntouched(campaignId).map(function (playbook) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_39" /* fetchPlaybookForCampaignIdSuccess */]({ data: playbook, campaignId: campaignId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_38" /* fetchPlaybookForCampaignIdPending */]({ campaignId: campaignId })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_37" /* fetchPlaybookForCampaignIdFailed */]({ campaignId: campaignId, err: err });
    });
  });
};

var fetchPlaybooksByReportType = function fetchPlaybooksByReportType(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_54" /* fetchPlaybooksByReportType */].toString()).pluck('payload').mergeMap(function (reportType) {
    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].fetchPlaybooksByReportType({ reportType: reportType }).map(function (playbooks) {
      return __WEBPACK_IMPORTED_MODULE_14__actions__["_57" /* fetchPlaybooksByReportTypeSuccess */]({ reportType: reportType, playbooks: playbooks });
    }).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["_56" /* fetchPlaybooksByReportTypePending */]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_55" /* fetchPlaybooksByReportTypeFailed */]());
    });
  });
};

var enableAllPlaybooksByReportType = function enableAllPlaybooksByReportType(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["P" /* enableAllPlaybooksByReportType */].toString()).pluck('payload').mergeMap(function (_ref34) {
    var orgId = _ref34.orgId,
        reportType = _ref34.reportType;

    return __WEBPACK_IMPORTED_MODULE_13__api__["a" /* api */].enableAllPlaybooksByReportType({ orgId: orgId, reportType: reportType }).map(__WEBPACK_IMPORTED_MODULE_14__actions__["S" /* enableAllPlaybooksByReportTypeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_14__actions__["R" /* enableAllPlaybooksByReportTypePending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["Q" /* enableAllPlaybooksByReportTypeFailed */](err));
    });
  });
};

var recordPlaybookReportLoadTime = function recordPlaybookReportLoadTime(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_241" /* startReportTimer */].toString()).pluck('payload').mergeMap(function (_ref35) {
    var playbookId = _ref35.playbookId;

    var start = Date.now();
    var count = 0;
    var startedIncrementing = false;

    var increment$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["_92" /* incrementReportTimer */].toString()).pluck('payload.playbookId').filter(function (localPlaybookId) {
      return playbookId !== localPlaybookId;
    }).map(function () {
      return { count: 1 };
    });

    var decrement$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["F" /* decrementReportTimer */].toString()).pluck('payload.playbookId').filter(function (localPlaybookId) {
      return playbookId !== localPlaybookId;
    }).map(function () {
      return { count: -1 };
    });

    var stopTaking$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_14__actions__["F" /* decrementReportTimer */].toString(), __WEBPACK_IMPORTED_MODULE_14__actions__["_92" /* incrementReportTimer */].toString()).pluck('payload.playbookId').filter(function (localPlaybookId) {
      return playbookId !== localPlaybookId;
    }).filter(function () {
      return count === 0 && startedIncrementing;
    }), __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].timer(5 * 60 * 1000) // 5min timeout
    );

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].merge(increment$, decrement$).mergeMap(function (_ref36) {
      var countChange = _ref36.count;

      startedIncrementing = true;
      count += countChange;
      if (count === 0) {
        var elapsed = Date.now() - start;
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          data: {
            metric: 'playbook.report.pageLoad',
            dimensions: {
              type: 'timer'
            },
            value: elapsed
          },
          url: __WEBPACK_IMPORTED_MODULE_18_constants_ResourcesConstants__["E" /* METRICS_API_BASE */] + '/monitoring/metrics/add',
          headers: {
            'content-type': 'application/json; charset=UTF-8',
            'Authorization': 'bearer ' + Object(__WEBPACK_IMPORTED_MODULE_5__driftt_web_auth__["getAccessToken"])()
          }
        })).map(__WEBPACK_IMPORTED_MODULE_14__actions__["_101" /* recordedReportTimer */]).catch(function () {
          return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_14__actions__["_101" /* recordedReportTimer */]());
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
      }
    }).takeUntil(stopTaking$);
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchPlaybook, getPlaybook, fetchPlaybooksCounts, saveDraft, scheduleDraft, updateStatus, updateDraftStatus, createPlaybook, searchPlaybooks, searchEnabledPlaybooks, receivePlaybook, clonePlaybook, fetchPlaybooksPriority, setCurrentGoalId, sendTestEmail, sendTestSequence, disablePlaybook, allChanges, fetchPlaybooksByIds, fetchPlaybookByCampaignId, fetchPlaybookByInteractionId, fetchDataPreviewEmail, enroll, unenroll, fetchPlaybookCardinality, notify, fetchEnrolledPlaybookId, fetchEnrolledSequenceCount, fetchPlaybookForEndUser, uploadEmailBannerImage, fetchDataPreviewSequenceEmail, getPlaybookByCampaignId, fetchPlaybooksByGatedPlan, asyncButtonPress, uploadSignatureBannerImage, fetchSignatureMultiBannerPreview, setDraftSuccess, createInitialWelcomePlaybooks, fetchPlaybookForCampaignId, fetchPlaybooksByReportType, enableAllPlaybooksByReportType, fetchChatActivePlaybooks, recordPlaybookReportLoadTime);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "PhT/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("sXVg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AppLink = function (_Component) {
  _inherits(AppLink, _Component);

  function AppLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppLink.__proto__ || Object.getPrototypeOf(AppLink)).call.apply(_ref, [this].concat(args))), _this), _this.goToApp = function () {
      var app = _this.props.app;

      window.location.href = app.url;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppLink, [{
    key: 'render',
    value: function render() {
      var app = this.props.app;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Div"],
        { className: 'app-link-container', onClick: this.goToApp },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Div"],
          { className: 'app-link-entry' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: 18, height: 18, src: app.iconSrc, alt: 'app-switcher' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["P"],
            { href: app.url, className: 'app-link-text' },
            app.name
          )
        )
      );
    }
  }]);

  return AppLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AppLink);

/***/ }),

/***/ "PhZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return urlB64ToUint8Array; });
// Coming from https://github.com/GoogleChromeLabs/web-push-codelab/blob/master/app/scripts/main.js guide on web push
var urlB64ToUint8Array = function urlB64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

/***/ }),

/***/ "PjO6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PjwL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SAVED_REPLIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SAVED_REPLIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SAVED_REPLIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SAVED_REPLIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_SAVED_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_SAVED_REPLY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_SAVED_REPLY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_SAVED_REPLY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SELECT_SAVED_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_SELECTED_SAVED_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_COMPOSER_TEXT_TO_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_COMPOSER_TEXT_TO_INSERT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('composer');

var FETCH_SAVED_REPLIES = makeConstant('FETCH_SAVED_REPLIES');
var FETCH_SAVED_REPLIES_PENDING = makeConstant('FETCH_SAVED_REPLIES_PENDING');
var FETCH_SAVED_REPLIES_SUCCESS = makeConstant('FETCH_SAVED_REPLIES_SUCCESS');
var FETCH_SAVED_REPLIES_FAILURE = makeConstant('FETCH_SAVED_REPLIES_FAILURE');

var UPDATE_SAVED_REPLY = makeConstant('UPDATE_SAVED_REPLY');
var UPDATE_SAVED_REPLY_PENDING = makeConstant('UPDATE_SAVED_REPLY_PENDING');
var UPDATE_SAVED_REPLY_SUCCESS = makeConstant('UPDATE_SAVED_REPLY_SUCCESS');
var UPDATE_SAVED_REPLY_FAILURE = makeConstant('UPDATE_SAVED_REPLY_FAILURE');

var SELECT_SAVED_REPLY = makeConstant('SELECT_SAVED_REPLY');
var CLEAR_SELECTED_SAVED_REPLY = makeConstant('CLEAR_SELECTED_SAVED_REPLY');

var SET_COMPOSER_TEXT_TO_INSERT = makeConstant('SET_COMPOSER_TEXT_TO_INSERT');
var CLEAR_COMPOSER_TEXT_TO_INSERT = makeConstant('CLEAR_COMPOSER_TEXT_TO_INSERT');

/***/ }),

/***/ "PkvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_Accordion__ = __webpack_require__("1mHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("7KbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var ClickThroughAccordion = function (_Component) {
  _inherits(ClickThroughAccordion, _Component);

  function ClickThroughAccordion() {
    _classCallCheck(this, ClickThroughAccordion);

    return _possibleConstructorReturn(this, (ClickThroughAccordion.__proto__ || Object.getPrototypeOf(ClickThroughAccordion)).apply(this, arguments));
  }

  _createClass(ClickThroughAccordion, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          description = _props.description,
          hoverText = _props.hoverText,
          redirectToUrl = _props.redirectToUrl;
      var push = this.context.router.push;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.ClickThroughAccordion) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_settings_Accordion__["a" /* default */], {
          title: title,
          description: description,
          rightContent: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            hoverText
          ),
          locked: true,
          onToggle: function onToggle() {
            return push(redirectToUrl);
          }
        })
      );
    }
  }]);

  return ClickThroughAccordion;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ClickThroughAccordion.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
ClickThroughAccordion.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  redirectToUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  hoverText: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
ClickThroughAccordion.defaultProps = {
  hoverText: "View"
};


/* harmony default export */ __webpack_exports__["a"] = (ClickThroughAccordion);

/***/ }),

/***/ "PnBG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMED_OUT; });
/* unused harmony export UserFeature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('experiment');

var SET_LOADED = makeConstant('SET_LOADED');
var TIMED_OUT = makeConstant('TIMED_OUT');

var UserFeature = Object.freeze({
  ICP_ONBOARDING_STEP: 'icp-onboarding-step'
});

/***/ }),

/***/ "PnwF":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMiAxNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMDI0IDE0LjM3NUgxLjU0NGMtLjQ4OCAwLS44ODUtLjQwMy0uODg1LS44OThWLjg5N0MuNjYuNDA0IDEuMDU1IDAgMS41NDQgMGgxOS40OGMuNDg3IDAgLjg4NC40MDMuODg0Ljg5OHYxMi41OGMwIC40OTQtLjM5OC44OTctLjg4Ni44OTd6bS0uODg2LTEyLjU3OEgyLjQzdjEwLjc4aDIuNjU2di0uODk3YzAtLjQ5Ni4zOTctLjkuODg2LS45LjQ4OCAwIC44ODUuNDA0Ljg4NS45di44OThoOC44NTR2LS44OThjMC0uNDk2LjM5OC0uOS44ODctLjkuNDg4IDAgLjg4NS40MDQuODg1Ljl2Ljg5OGgyLjY1NlYxLjc5OHptLTIuNjU2IDcuMTg3aC00LjQyN2MtLjQ5IDAtLjg4NS0uNDAyLS44ODUtLjg5OHMuMzk2LS45Ljg4NS0uOWw0LjQyNy4wMDJjLjQ5IDAgLjg4NS40MDIuODg1Ljg5OHMtLjM5Ni44OTgtLjg4NS44OTh6bTAtMy41OTNoLTQuNDI3Yy0uNDkgMC0uODg1LS40MDItLjg4NS0uODk4cy4zOTYtLjg5OC44ODUtLjg5OGg0LjQyN2MuNDkgMCAuODg1LjQwMi44ODUuODk4cy0uMzk2LjktLjg4NS45em0tOC4zIDMuNTk0SDQuNTM2Yy0uMTgzIDAtLjMzMi0uMTUtLjMzMi0uMzM3di0uMzgyYzAtLjE4Ni4zMzItLjMzNy4zMzItLjMzN2wxLjQ0LS43ODZjLS40NjQtLjM3OC0uNjY1LTEuMTU4LS42NjUtMS41MjVWNC45NGMwLS44OTguODE1LTEuMzQ0IDEuNTUtMS4zNDQuNzMgMCAxLjU1LjQ0NiAxLjU1IDEuMzQ1di42NzdjMCAuNDAzLS4yMTIgMS4xNi0uNjc0IDEuNTI4bDEuNDQ2Ljc4M3MuMzMuMTM4LjMzLjMzN3YuMzgyYzAgLjE4Ni0uMTQ3LjMzNy0uMzMuMzM3eiIgZmlsbD0iIzc2OTVBNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "PqDO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pqey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_SearchResultTypesEnum__ = __webpack_require__("Df95");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResultPreview_User__ = __webpack_require__("M9k1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ResultPreview_Conversation__ = __webpack_require__("eKDZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResultPreview_styl__ = __webpack_require__("gI3P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ResultPreview_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ResultPreview_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


var _React = React,
    Component = _React.Component;













var ResultPreview = function (_Component) {
  _inherits(ResultPreview, _Component);

  _createClass(ResultPreview, null, [{
    key: 'initClass',
    value: function initClass() {
      this.propTypes = {
        item: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
      };
    }
  }]);

  function ResultPreview(props) {
    _classCallCheck(this, ResultPreview);

    var _this = _possibleConstructorReturn(this, (ResultPreview.__proto__ || Object.getPrototypeOf(ResultPreview)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ResultPreview, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: 'ResultPreview' },
        function () {
          switch (_this2.props.item.type) {
            case __WEBPACK_IMPORTED_MODULE_4_constants_SearchResultTypesEnum__["a" /* default */].endUser.key:
              return React.createElement(__WEBPACK_IMPORTED_MODULE_5__ResultPreview_User__["a" /* default */], { endUser: _this2.props.endUser });
            case __WEBPACK_IMPORTED_MODULE_4_constants_SearchResultTypesEnum__["a" /* default */].conversation.key:
              return React.createElement(__WEBPACK_IMPORTED_MODULE_6__ResultPreview_Conversation__["a" /* default */], { conversation: _this2.props.conversation });
          }
        }()
      );
    }
  }]);

  return ResultPreview;
}(Component);

ResultPreview.initClass();

var ResultPreviewContainer = Marty.createContainer(ResultPreview, {
  listenTo: ['stores.EndUserStore', 'stores.ConversationStore'],

  fetch: {
    endUser: function endUser() {
      if (this.props.item.type === __WEBPACK_IMPORTED_MODULE_4_constants_SearchResultTypesEnum__["a" /* default */].endUser.key) {
        return this.app.stores.EndUserStore.getOrFetchEndUser(this.props.item.id);
      }
    },
    conversation: function conversation() {
      if (this.props.item.type === __WEBPACK_IMPORTED_MODULE_4_constants_SearchResultTypesEnum__["a" /* default */].conversation.key) {
        return this.app.stores.ConversationStore.getOrFetchConversation(this.props.item.id);
      }
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ResultPreviewContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "Prq2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TOTAL_COUNT_HEADER */
/* unused harmony export PAGE_INFO_HEADER */
/* unused harmony export CURSOR_PREFIX */
/* unused harmony export HAS_MORE_PREFIX */
/* unused harmony export PageInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BidirectionalPagedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PagedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseBidirectionalPagedData; });
/* harmony export (immutable) */ __webpack_exports__["c"] = combinePagedData;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parsePagedData; });
/* unused harmony export getTotalCount */
/* unused harmony export getPagingData */
/* unused harmony export getBidirectionalPagingData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_zipObject__ = __webpack_require__("BlOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_zipObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_zipObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__("309y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var TOTAL_COUNT_HEADER = "X-Results-Total-Count";
var PAGE_INFO_HEADER = "X-Page-Info";
var CURSOR_PREFIX = "next=";
var HAS_MORE_PREFIX = "hasMore=";

var PageInfo = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  id: undefined,
  page: 1
});

var BidirectionalPagedData = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  data: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
  cursor: undefined,
  hasNext: undefined,
  hasPrevious: undefined,
  total: undefined
});

var PagedData = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  data: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
  cursor: undefined,
  hasMore: undefined,
  status: undefined,
  total: undefined
});

var parseBidirectionalPagedData = function parseBidirectionalPagedData() {
  var parse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"];
  return function (_ref) {
    var response = _ref.response,
        xhr = _ref.xhr;

    var totalCountInfo = xhr.getResponseHeader(TOTAL_COUNT_HEADER);
    var pageInfo = xhr.getResponseHeader(PAGE_INFO_HEADER);

    return BidirectionalPagedData(_extends({ data: parse(response) }, getBidirectionalPagingData(pageInfo, totalCountInfo)));
  };
};

function combinePagedData(current, next) {
  return current.withMutations(function (_current) {
    return _current.update('data', function (data) {
      return data.concat(next.data);
    }).set('cursor', next.cursor).set('hasNext', next.hasNext).set('hasPrevious', next.hasPrevious);
  });
}

var parsePagedData = function parsePagedData() {
  var parse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"];
  return function (_ref2) {
    var response = _ref2.response,
        xhr = _ref2.xhr;

    return PagedData(_extends({ data: parse(response) }, getPagingData(xhr)));
  };
};

function getTotalCount(totalCountInfo) {
  return {
    total: parseInt(totalCountInfo)
  };
}

function getPagingData(xhr) {
  var totalCountInfo = xhr.getResponseHeader(TOTAL_COUNT_HEADER);
  var pageInfo = xhr.getResponseHeader(PAGE_INFO_HEADER);
  var data = pageInfo.split(',');

  if (data.length === 1) {
    return _extends({
      hasMore: data[0].substr(HAS_MORE_PREFIX.length) === "true"
    }, getTotalCount(totalCountInfo));
  } else {
    return _extends({
      cursor: data[0].substr(CURSOR_PREFIX.length),
      hasMore: data[1].substr(HAS_MORE_PREFIX.length) === "true"
    }, getTotalCount(totalCountInfo));
  }
}

function getBidirectionalPagingData(pageInfo, totalCountInfo) {
  if (!pageInfo) {
    return getTotalCount(totalCountInfo);
  }

  var pagingData = castBooleans(__WEBPACK_IMPORTED_MODULE_0_lodash_zipObject___default()(pageInfo.split(',').map(function (record) {
    return record.split("=");
  })), ['hasNext', 'hasPrevious']);

  return _extends({}, pagingData, getTotalCount(totalCountInfo));
}

function castBooleans(data, keys) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(data, function (value, key) {
    if (keys.includes(key)) {
      data[key] = value === "true";
    }
  });
}

/***/ }),

/***/ "Pyzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChartOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ColorConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_colors__);


var ChartOptions = {
  tooltipTemplate: '<%= value %>',
  bezierCurve: false,
  pointDotRadius: 8,
  pointDotStrokeWidth: 2,
  datasetFill: false,
  scaleShowVerticalLines: false,
  tooltipYPadding: 12,
  tooltipXPadding: 12,
  pointHitDetectionRadius: 3,
  tooltipYOffset: 20,
  tooltipFontStyle: 'bold',
  responsive: true,
  maintainAspectRatio: false,
  tooltipFontFamily: 'Brandon',
  scaleFontFamily: 'Brandon'
};

var ColorConfig = {
  fillColor: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-white'],
  strokeColor: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green'],
  pointColor: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-white'],
  pointStrokeColor: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green'],
  pointHighlightFill: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green'],
  pointHighlightStroke: __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-green']
};

/***/ }),

/***/ "Q0tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__("66UN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_Toggle_styl__ = __webpack_require__("tO9F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_Toggle_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_Toggle_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







function ToggleCmp(_ref) {
  var className = _ref.className,
      style = _ref.style,
      actions = _ref.actions,
      props = _objectWithoutProperties(_ref, ['className', 'style', 'actions']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3_styles_components_Toggle_styl___default.a.Toggle, className), style: style },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a, _extends({
      icons: {
        checked: null,
        unchecked: null
      }
    }, props))
  );
}
ToggleCmp.displayName = 'Toggle';

/* harmony default export */ __webpack_exports__["a"] = (ToggleCmp);

/***/ }),

/***/ "Q3ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_API_KEY_FOR_ORG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_API_KEY_FOR_ORG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_API_KEY_FOR_ORG_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_API_KEY_FOR_ORG_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_API_KEY_FOR_ORG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_API_KEY_FOR_ORG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_API_KEY_FOR_ORG_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_API_KEY_FOR_ORG_PENDING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('ban');

var GET_API_KEY_FOR_ORG = makeConstant('GET_API_KEY_FOR_ORG');
var GET_API_KEY_FOR_ORG_SUCCESS = makeConstant('GET_API_KEY_FOR_ORG_SUCCESS');
var GET_API_KEY_FOR_ORG_FAILED = makeConstant('GET_API_KEY_FOR_ORG_FAILED');
var GET_API_KEY_FOR_ORG_PENDING = makeConstant('GET_API_KEY_FOR_ORG_PENDING');

var CREATE_API_KEY_FOR_ORG = makeConstant('CREATE_API_KEY_FOR_ORG');
var CREATE_API_KEY_FOR_ORG_SUCCESS = makeConstant('CREATE_API_KEY_FOR_ORG_SUCCESS');
var CREATE_API_KEY_FOR_ORG_FAILED = makeConstant('CREATE_API_KEY_FOR_ORG_FAILED');
var CREATE_API_KEY_FOR_ORG_PENDING = makeConstant('CREATE_API_KEY_FOR_ORG_PENDING');

/***/ }),

/***/ "Q4xG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q5Ik":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"23\" viewBox=\"0 0 25 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.46 17.73H5.596L1.82 22.545a1.014 1.014 0 0 1-1.136.334A1.04 1.04 0 0 1 0 21.893V4.142C0 1.87 1.812.02 4.04.02h16.42c2.228 0 4.04 1.85 4.04 4.122v9.465c0 2.273-1.812 4.122-4.04 4.122zm-2.085-9.376H6.125c-.564 0-1.02-.467-1.02-1.042S5.56 6.27 6.125 6.27h12.25c.563 0 1.02.467 1.02 1.042s-.457 1.042-1.02 1.042zm-12.25 2.062h8.167c.563 0 1.02.466 1.02 1.04 0 .576-.457 1.043-1.02 1.043H6.125c-.564 0-1.02-.47-1.02-1.044s.456-1.04 1.02-1.04z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Q72M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("Zpgp");














var mapStateToProps = function mapStateToProps(state, props) {
  return {
    condition: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["F" /* getCondition */](state, props),
    segments: __WEBPACK_IMPORTED_MODULE_3_app_modules_segment_selectors__["e" /* segments */](state, props),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state),
    getPlaybookIdForCampaignId: function getPlaybookIdForCampaignId(campaignId) {
      return __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_60" /* playbookIdForCampaignId */](state, campaignId);
    },
    getIsPlaybookIdForCampaignIdLoading: function getIsPlaybookIdForCampaignIdLoading(campaignId) {
      return __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_62" /* playbookIdForCampaignIdLoading */](state, campaignId);
    },
    playbooks: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_64" /* playbooks */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      deleteCondition: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["H" /* deleteCondition */],
      showConditionModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_227" /* showConditionModal */],
      getPlaybookByCampaignId: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_68" /* getPlaybookByCampaignId */],
      getPlaybookByCampaignIdPending: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_71" /* getPlaybookByCampaignIdPending */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_8_app_modules_teams_hoc_withOrgTeams__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    getSegmentNames: function getSegmentNames(displayValues) {
      return displayValues.map(function (value) {
        var segment = props.segments.find(function (segment) {
          return segment.get('id') === value;
        });
        if (segment) {
          return segment.get('name');
        } else {
          return __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["u" /* AudienceDisplay */][value];
        }
      }).filter(Boolean);
    },
    isSegment: props.condition.field === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["R" /* ConditionType */].SEGMENT,
    isTeamCondition: props.condition.field === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["R" /* ConditionType */].TEAM_AVAILABILITY,
    isOutboundSessionCondition: props.condition.field === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["R" /* ConditionType */].OUTBOUND_SESSION,
    isEmailPlaybookCondition: props.condition.field === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["R" /* ConditionType */].URL_QUERY && props.condition.value.some(function (v) {
      return v && v.startsWith && v.startsWith('d_campaign');
    })
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  if (props.isEmailPlaybookCondition) {
    try {
      var campaignId = parseInt(props.condition.value.first().split('=')[1]);
      var selectedPlaybookId = props.getPlaybookIdForCampaignId(campaignId);
      if (!selectedPlaybookId && campaignId && !props.getIsPlaybookIdForCampaignIdLoading(campaignId)) {
        props.actions.getPlaybookByCampaignId({ campaignId: campaignId });
        props.actions.getPlaybookByCampaignIdPending({ campaignId: campaignId });
      } else if (selectedPlaybookId) {
        return {
          selectedPlaybookId: selectedPlaybookId
        };
      }
    } catch (err) {
      return {};
    }
  }
  return {};
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onDeleteClick: function onDeleteClick(_ref) {
    var id = _ref.id,
        deleteCondition = _ref.actions.deleteCondition;
    return function () {
      deleteCondition(id);
    };
  },
  onEditClick: function onEditClick(_ref2) {
    var id = _ref2.id,
        showConditionModal = _ref2.actions.showConditionModal;
    return function () {
      showConditionModal(id);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),

/***/ "Q8nZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 146 102\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M102.597 91.114a45.491 45.491 0 0 1-3.704 2.597 59.159 59.159 0 0 1-2.539 1.49c-.173.096-.343.192-.516.286-.248.135-.477.249-.724.364a47.009 47.009 0 0 1-21.497 5.173 47.034 47.034 0 0 1-22.03-5.442c-.133-.076-.247-.132-.38-.21-.439-.229-.898-.476-1.317-.723a24.662 24.662 0 0 1-1.507-.918c-.098-.058-.174-.115-.27-.171a48.763 48.763 0 0 1-3.797-2.691C33.3 82.18 26.218 68.723 26.218 53.6c0-26.171 21.23-47.402 47.4-47.402 26.19 0 47.418 21.23 47.418 47.402 0 15.273-7.216 28.849-18.439 37.513z\" fill=\"#E1EEF4\"></path><g transform=\"translate(0 2)\"><use fill=\"#5E6D75\" xlink:href=\"#a\"></use><path stroke=\"#979797\" d=\"M57.5 58.5h32v20h-32z\"></path></g><path d=\"M29.451 5.08a2.827 2.827 0 0 1-2.824 2.83 2.827 2.827 0 0 1-2.824-2.83 2.827 2.827 0 0 1 2.824-2.83 2.827 2.827 0 0 1 2.824 2.83z\" stroke=\"#E1EEF4\" stroke-width=\"2.64\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M131.051 6.08l1.172 3.989c.099.341.367.608.706.71l3.98 1.173c1 .295 1 1.715 0 2.01l-3.98 1.175c-.34.1-.607.368-.706.71l-1.172 3.987c-.294 1.003-1.71 1.003-2.005 0l-1.171-3.988a1.05 1.05 0 0 0-.708-.71l-3.98-1.174c-.999-.295-.999-1.715 0-2.01l3.98-1.174a1.05 1.05 0 0 0 .708-.71l1.171-3.988c.294-1.002 1.71-1.002 2.005 0M141.579 86.193l.783 2.669a.7.7 0 0 0 .475.474l2.662.785c.668.197.668 1.148 0 1.346l-2.662.785a.698.698 0 0 0-.475.474l-.783 2.669c-.196.67-1.145.67-1.341 0l-.785-2.669a.697.697 0 0 0-.471-.474l-2.663-.785c-.67-.198-.67-1.15 0-1.346l2.663-.785a.7.7 0 0 0 .471-.474l.785-2.67c.196-.67 1.145-.67 1.34 0M14.506 67.628l.783 2.668a.7.7 0 0 0 .475.475l2.662.785c.668.196.668 1.148 0 1.346l-2.662.785a.698.698 0 0 0-.475.474l-.783 2.669c-.196.67-1.145.67-1.341 0l-.785-2.67a.697.697 0 0 0-.472-.473l-2.662-.785c-.67-.198-.67-1.15 0-1.346l2.662-.785a.7.7 0 0 0 .472-.475l.785-2.668c.196-.671 1.145-.671 1.34 0M122.56 100.163a2.038 2.038 0 0 1-2.036-2.04c0-1.129.912-2.043 2.036-2.043a2.04 2.04 0 0 1 2.037 2.042c0 1.128-.912 2.04-2.037 2.04zM2.56 30.163a2.038 2.038 0 0 1-2.036-2.04c0-1.129.912-2.043 2.036-2.043a2.04 2.04 0 0 1 2.037 2.042c0 1.128-.912 2.04-2.037 2.04z\" fill=\"#E1EEF4\"></path><path d=\"M98.893 93.71c-.038.02-.096.06-.134.078-.782.497-1.584.955-2.405 1.414-.172.094-.344.19-.517.286-.247.133-.477.249-.724.363a46.996 46.996 0 0 1-21.495 5.172 47.049 47.049 0 0 1-22.029-5.44c-.134-.076-.25-.133-.383-.211-.439-.23-.897-.475-1.316-.724a22.98 22.98 0 0 1-1.508-.918c-.096-.056-.174-.113-.267-.17a48.335 48.335 0 0 1-3.8-2.692c5.9-9.89 16.704-16.514 29.054-16.514 12.466 0 23.348 6.738 29.227 16.761a45.16 45.16 0 0 1-3.703 2.595z\" fill=\"#FFF\"></path><path d=\"M73.501 81.068a4.906 4.906 0 0 1-4.892-4.892V68.72c0-2.69 2.202-4.89 4.892-4.89h.558c2.69 0 4.89 2.2 4.89 4.89v7.455c0 2.69-2.2 4.892-4.89 4.892h-.558z\" fill=\"#7295A7\"></path><path d=\"M89.694 36.835v18.267c0 8.936-7.302 16.24-16.24 16.24-8.917 0-16.237-7.304-16.237-16.24V36.835h32.477z\" fill=\"#91ACBA\"></path><path d=\"M78.568 37h-.24c-4.386 3.653-10.153 6.986-17.3 10v44C58.36 90 56.351 86.167 55 79.5v-44l.096-.023C55.844 29.569 60.889 25 67 25h14c6.12 0 11.169 4.58 11.907 10.5H93v44c-1 5-3 8.833-6 11.5V46.5c-4.395-3.846-7.206-7.012-8.432-9.5z\" fill=\"#5E6D75\"></path></g></svg>"

/***/ }),

/***/ "QBUr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IntegrationIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Integrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntegrationCategories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Access__ = __webpack_require__("6k1g");

var SETTINGS_PATH = '/settings/setup';

var IntegrationIds = {
  SLACK: "slackBot",
  LINKEDIN: "linkedin",
  DRIFT_CODE: 'drift-code',
  HUBSPOT: "hubspot",
  ZAPIER: "zapier",
  DRIP: "drip",
  FULLSTORY: "fullstory",
  HELP_CENTER: "knowledgebase",
  SALESFORCE: "salesforce",
  MARKETO: "marketo",
  DEMANDBASE: "demandbase",
  MADKUDU: "madkudu",
  VIDYARD: "vidyard",
  GOOGLE_ANALYTICS: "googleAnalytics",
  CLEARBIT: "clearbit",
  OUTREACH: "outreach",
  FACEBOOK: "facebookAnalytics",
  LEANDATA: "leandata",
  STRIPE: "stripe"
};

var Integrations = [{
  id: IntegrationIds.SLACK,
  title: 'Slack',
  keywords: 'communication messaging chat',
  description: 'Manage conversations and reply right from Slack.',
  logoSrc: __webpack_require__("ykk9"),
  path: SETTINGS_PATH + '/slack'
}, {
  id: IntegrationIds.LINKEDIN,
  title: 'LinkedIn Sales Navigator',
  keywords: 'networking sales contacts',
  description: 'View Market Insights and connect with contacts directly through LinkedIn.',
  requiredGates: ['HAS_LINKEDIN'],
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade',
  logoSrc: __webpack_require__("IyfO"),
  path: SETTINGS_PATH + '/linkedin'
}, {
  id: IntegrationIds.DRIFT_CODE,
  title: 'Drift HTTP API',
  keywords: 'drift code install api contacts',
  description: 'Enrich your data or manage your contacts with our API',
  logoSrc: __webpack_require__("50R4"),
  external: true,
  externalUrl: 'https://devdocs.drift.com/docs'
}, {
  id: IntegrationIds.HUBSPOT,
  title: 'HubSpot',
  keywords: 'crm contacts',
  description: 'Connect with HubSpot to sync your new contacts with Drift.',
  logoSrc: __webpack_require__("Zyf8"),
  requiredGates: ['hubspot_settings'],
  path: SETTINGS_PATH + '/hubspot',
  gatedUrl: 'https://help.drift.com/integrations/hubspot-integration',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.ZAPIER,
  title: 'Zapier',
  keywords: 'crm contacts',
  description: 'Integrate any app via Zapier',
  logoSrc: __webpack_require__("fg5y"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].PREMIUM, __WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].STANDARD_APRIL_2018],
  path: SETTINGS_PATH + '/zapier',
  gatedUrl: 'https://help.drift.com/integrations/zapier-integration',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.DRIP,
  title: 'Drip',
  keywords: 'crm contacts',
  description: 'See your Drip data in Drift, and your Drift data in Drip.',
  logoSrc: __webpack_require__("G/PM"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].PREMIUM],
  path: SETTINGS_PATH + '/drip',
  gatedUrl: 'https://help.drift.com/integrations/drip-integration',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.FULLSTORY,
  title: 'FullStory',
  keywords: 'advanced tracking',
  description: 'See what your customers see and give them the help they need.',
  logoSrc: __webpack_require__("Rvc/"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].PREMIUM],
  path: SETTINGS_PATH + '/fullstory',
  gatedUrl: 'https://help.drift.com/integrations/fullstory',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.HELP_CENTER,
  title: 'Help Center',
  keywords: 'drift help knowledgebase help zendesk helpscout helpdocs',
  description: 'Pair your Help Center with Drift’s intelligent messaging',
  logoSrc: __webpack_require__("T0+/"),
  grandfathered: function grandfathered() {
    return __WEBPACK_IMPORTED_MODULE_0_utils_Access__["c" /* default */].hasGates(__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].KNOWLEDGE_BASE);
  },
  detail: 'Learn More',
  path: SETTINGS_PATH + '/knowledgebase',
  gatedUrl: 'http://help.drift.com/integrations/knowledge-base-and-help-doc-integrations',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.SALESFORCE,
  title: 'Salesforce',
  keywords: 'crm contacts',
  description: 'Sync your Drift leads and conversations to Salesforce',
  logoSrc: __webpack_require__("V0l4"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].PREMIUM_TEAM, __WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].TEAM_VIDEO_LICENSE],
  detail: 'Learn More',
  path: SETTINGS_PATH + '/salesforce',
  gatedUrl: 'https://gethelp.drift.com/hc/en-us/articles/360018794974-How-To-Integrate-Drift-With-Salesforce',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.MARKETO,
  title: 'Marketo V2',
  keywords: 'crm contacts leads',
  description: 'Sync your Drift data over to Marketo V2',
  logoSrc: __webpack_require__("NUAQ"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].MARKETO],
  path: SETTINGS_PATH + '/marketo',
  gatedUrl: 'https://gethelp.drift.com/hc/en-us/articles/360019503974-How-to-Connect-Drift-and-Marketo',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.DEMANDBASE,
  title: 'Demandbase',
  keywords: 'encrichment firmographic',
  description: 'Connect Demandbase to enrich your Drift lead data',
  logoSrc: __webpack_require__("Nl1C"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].DEMANDBASE],
  path: SETTINGS_PATH + '/demandbase',
  gatedUrl: 'https://help.drift.com/integrations/demandbase-integration',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.MADKUDU,
  title: 'MadKudu',
  keywords: 'encrichment firmographic',
  description: "Use MadKudu's predictive lead scoring to qualify leads",
  logoSrc: __webpack_require__("9SVm"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].HAS_MADKUDU, 'has_madkudu'], // lower case has_madkudu access grandfathered in.
  path: SETTINGS_PATH + '/madkudu',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.VIDYARD,
  title: 'Vidyard',
  keywords: 'communication video screenshare messaging',
  description: 'Send personalized videos in conversations with Vidyard',
  logoSrc: __webpack_require__("DaXa"),
  path: SETTINGS_PATH + '/vidyard'
}, {
  id: IntegrationIds.GOOGLE_ANALYTICS,
  title: 'Google Analytics',
  keywords: 'analytics tracking google',
  description: 'Easily add Drift data to your Google Analytics dashboard',
  logoSrc: __webpack_require__("hCcJ"),
  path: SETTINGS_PATH + '/googleAnalytics'
}, {
  id: IntegrationIds.CLEARBIT,
  title: 'Clearbit',
  keywords: 'encrichment reveal',
  description: 'Connect Clearbit to enrich your Drift lead data',
  logoSrc: __webpack_require__("lO8c"),
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].CLEARBIT_SETTINGS],
  path: SETTINGS_PATH + '/clearbit',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade'
}, {
  id: IntegrationIds.OUTREACH,
  title: 'Outreach',
  keywords: 'sequences email',
  description: 'Have seamless conversations between Drift & Outreach',
  logoSrc: __webpack_require__("3t0E"),
  path: SETTINGS_PATH + '/outreach',
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].OUTREACH],
  gatedUrl: 'https://gethelp.drift.com/hc/en-us/articles/360019505134-How-to-Connect-Drift-and-Outreach',
  isGatedByPlan: true,
  upgradeRibbonText: 'Upgrade',
  incompleteInstallEndpoint: '/integrations/outreach/install_status/internal'
}, {
  id: IntegrationIds.FACEBOOK,
  title: 'Facebook Analytics',
  keywords: 'analytics tracking facebook',
  description: 'Measure traffic to your conversational landing pages',
  logoSrc: __webpack_require__("uQXq"),
  path: SETTINGS_PATH + '/facebookAnalytics'
}, {
  id: IntegrationIds.LEANDATA,
  title: 'LeanData',
  keywords: 'routing routing routing',
  description: 'Assign leads to reps using your LeanData account.',
  logoSrc: __webpack_require__("MhvU"),
  path: SETTINGS_PATH + '/leandata',
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].LEANDATA],
  renderGate: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].LEANDATA],
  isGatedByPlan: true,
  upgradeRibbonText: 'Soon!'
}, {
  id: IntegrationIds.STRIPE,
  title: 'Stripe Payments',
  keywords: 'payment transaction stripe',
  description: 'Process payments during conversations with Stripe.',
  logoSrc: __webpack_require__("5xWb"),
  path: SETTINGS_PATH + '/stripe',
  requiredGates: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].STRIPE],
  renderGate: [__WEBPACK_IMPORTED_MODULE_0_utils_Access__["b" /* Gates */].STRIPE],
  isGatedByPlan: true,
  upgradeRibbonText: 'Soon!'
}];

var IntegrationCategories = {
  ALL: {
    label: 'All integrations',
    keywords: ''
  },
  INSTALLED_APPS: {
    label: 'Connected integrations',
    keywords: 'installed'
  },
  PARTNER_APPS: {
    label: 'Third party integrations',
    keywords: 'partner'
  },
  COMMUNICATION: {
    label: 'Communication',
    keywords: 'communication'
  },
  CRM: {
    label: 'CRM',
    keywords: 'crm'
  },
  ENRICHMENT: {
    label: 'Enrichment',
    keywords: 'encrichment'
  },
  KNOWLEDGE_BASE: {
    label: 'Knowledge base',
    keywords: 'knowledgebase'
  }
};

/***/ }),

/***/ "QF6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return constants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Visibility; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Layout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keymirror__);




var constants = __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default()(__WEBPACK_IMPORTED_MODULE_2_keymirror___default()({
  SET_PROFILE_UI: null,
  SET_PROFILE_UI_DATA: null,

  FETCH_CURRENT_PROFILE_STARTED: null,
  FETCH_CURRENT_PROFILE_FAILED: null,

  UPDATE_PROFILE_STARTED: null,
  UPDATE_PROFILE_FAILED: null,
  UPDATE_PROFILE_SUCCESS: null,

  CHECK_USER_HANDLE_EXISTENCE_STARTED: null,
  CHECK_USER_HANDLE_EXISTENCE_FAILED: null,
  RECEIVE_USER_HANDLE_EXISTENCE: null,
  RECEIVE_USER_GLOBAL_HANDLE_EXISTENCE: null,

  FETCH_USER_PROFILE: null,
  FETCH_USER_PROFILE_PENDING: null,
  FETCH_USER_PROFILE_SUCCESS: null,
  FETCH_USER_PROFILE_FAILED: null,

  SET_VISIBILITY_STARTED: null,
  SET_VISIBILITY_FAILED: null,

  RECEIVE_PROFILE: null,

  CLEAR_COVER_PHOTO: null,
  UPLOAD_COVER_PHOTO_STARTED: null,
  UPLOAD_COVER_PHOTO_SUCCESS: null,
  UPLOAD_COVER_PHOTO_FAILED: null
}), __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default.a);

var Visibility = __WEBPACK_IMPORTED_MODULE_2_keymirror___default()({
  PUBLIC: null,
  PRIVATE: null
});

var Layout = __WEBPACK_IMPORTED_MODULE_2_keymirror___default()({
  WIDE: null,
  CARD: null
});

/***/ }),

/***/ "QGO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.

var SegmentActions = Marty.createActionCreators({
  createDynamicSegment: function createDynamicSegment(requestId, name, query) {
    var body = {
      type: 'QUERY',
      name: name,
      query: query
    };
    return this.app.queries.SegmentQueries.createSegment(requestId, body);
  },
  createStaticSegment: function createStaticSegment(requestId, name, endUserIds, isTemp) {
    var body = {
      type: 'ID_LIST',
      name: name
    };
    if (isTemp) {
      body.status = 'HIDDEN';
    }
    return this.app.queries.SegmentQueries.createSegment(requestId, body, endUserIds);
  },
  createStaticSegmentBasedOnQuery: function createStaticSegmentBasedOnQuery(requestId, name, query, isTemp) {
    var body = {
      type: 'ID_LIST',
      name: name,
      query: query
    };
    if (isTemp) {
      body.status = 'HIDDEN';
    }
    return this.app.queries.SegmentQueries.createSegment(requestId, body);
  },
  addEndUserIdsToStaticSegment: function addEndUserIdsToStaticSegment(segmentId, endUserIds) {
    return this.app.queries.SegmentQueries.addEndUserIdsToStaticSegment(segmentId, endUserIds);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SegmentActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "QKOS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 10 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-887.000000, -772.000000)\" fill=\"#E95531\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"check-circle\" transform=\"translate(17.000000, 294.000000)\"><path d=\"M10.70725,99.70725 C10.51225,99.90225 10.25625,100.00025 10.00025,100.00025 C9.74425,100.00025 9.48825,99.90225 9.29325,99.70725 L6.00025,96.41425 L2.70725,99.70725 C2.51225,99.90225 2.25625,100.00025 2.00025,100.00025 C1.74425,100.00025 1.48825,99.90225 1.29325,99.70725 C0.90225,99.31725 0.90225,98.68325 1.29325,98.29325 L4.58625,95.00025 L1.29325,91.70725 C0.90225,91.31725 0.90225,90.68425 1.29325,90.29325 C1.68425,89.90225 2.31625,89.90225 2.70725,90.29325 L6.00025,93.58625 L9.29325,90.29325 C9.68425,89.90225 10.31625,89.90225 10.70725,90.29325 C11.09825,90.68425 11.09825,91.31725 10.70725,91.70725 L7.41425,95.00025 L10.70725,98.29325 C11.09825,98.68325 11.09825,99.31725 10.70725,99.70725 Z\" id=\"redx\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "QM6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__ = __webpack_require__("99ZJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("senS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var classesByScore = Object.freeze({
  '1': 'cql-option cql-low',
  '2': 'cql-option cql-med',
  '3': 'cql-option cql-high'
});

var ICONS_FOR_SCORE = {
  '1': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
    { className: 'cql-option--icon-wrapper' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 })
  ),
  '2': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
    { className: 'cql-option--icon-wrapper' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 })
  ),
  '3': __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
    { className: 'cql-option--icon-wrapper' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Bolt__["a" /* default */], { className: 'lightning-bolt', height: 15 })
  )
};

var MinimumCqlScoreWidget = function (_Component) {
  _inherits(MinimumCqlScoreWidget, _Component);

  function MinimumCqlScoreWidget() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MinimumCqlScoreWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MinimumCqlScoreWidget.__proto__ || Object.getPrototypeOf(MinimumCqlScoreWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      score: undefined
    }, _this.setCQLScore = function (score) {
      var _this$props = _this.props,
          integrationName = _this$props.integrationName,
          notifications = _this$props.notifications,
          setMinimumCQLScore = _this$props.setMinimumCQLScore;

      setMinimumCQLScore({ integrationName: integrationName, score: score });

      _this.setState({
        score: score
      });
      notifications.success(Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["capitalize"])(integrationName) + ' settings are updated!');
    }, _this.renderCQLIcon = function (score) {
      var cqlScore = _this.state.score;

      var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(classesByScore[score], {
        'cql--selected': cqlScore === score
      });

      var tooltipText = 'CQL score: ' + score;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["ToolTip"],
        { hover: true, component: tooltipText, flow: 'up', className: 'cql-option--tooltip' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
          { className: className, onClick: function onClick() {
              return _this.setCQLScore(score);
            } },
          ICONS_FOR_SCORE[score]
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MinimumCqlScoreWidget, [{
    key: 'getScore',
    value: function getScore(data) {
      // score can come from the field 'score' or 'minimumCQLScore'
      // depending on the endpoint being hit
      var score = data.score;
      if (!score) {
        score = data.minimumCQLScore;
      }
      return score;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          integrationName = _props.integrationName,
          getMinimumCQLScore = _props.getMinimumCQLScore;

      getMinimumCQLScore(integrationName).then(function (data) {
        var score = _this2.getScore(data);
        _this2.setState({ score: score });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Div"],
          { className: 'integrations--mark-cql' },
          this.renderCQLIcon(1),
          this.renderCQLIcon(2),
          this.renderCQLIcon(3)
        )
      );
    }
  }]);

  return MinimumCqlScoreWidget;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MinimumCqlScoreWidget.propTypes = {
  integrationName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  setMinimumCQLScore: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
  getMinimumCQLScore: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_shared_notifications__["a" /* default */])(MinimumCqlScoreWidget));

/***/ }),

/***/ "QMlG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Body":"Body---2-bIA","Container":"Container---1q6Fy","Header":"Header---uJXlN","Title":"Title---2h1OS","Menu":"Menu---1bCvE","MenuItems":"MenuItems---3mrlB","MenuItem":"MenuItem---6cag9","HeaderContent":"HeaderContent---1MkJR","AvatarsList":"AvatarsList---2HD4h","MultiAvatars":"MultiAvatars---2THWg","AvatarWrapper":"AvatarWrapper---3_sRl"};

/***/ }),

/***/ "QNLA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("hYTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var DEFAULT_ICON_SRC = __webpack_require__("uNny");

var EventCard = function (_Component) {
  _inherits(EventCard, _Component);

  function EventCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EventCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EventCard.__proto__ || Object.getPrototypeOf(EventCard)).call.apply(_ref, [this].concat(args))), _this), _this.renderTimelineEventIcon = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'timelineEventIcon', src: _this.props.iconSrc });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EventCard, [{
    key: 'render',
    value: function render() {
      var isNote = this.props.isNote;

      var noteClass = isNote ? 'note' : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-start' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.TypeIcon + ' flex-center' },
          this.renderTimelineEventIcon()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.Card + ' ' + noteClass },
          this.props.children
        )
      );
    }
  }]);

  return EventCard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EventCard.defaultProps = {
  iconSrc: DEFAULT_ICON_SRC
};
/* harmony default export */ __webpack_exports__["a"] = (EventCard);

/***/ }),

/***/ "QOQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("13Mi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("SrDG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "QQaY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QR21":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QRWD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyBy;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


function keyBy(elements, opts) {
  var _ref = opts || {},
      _ref$acc = _ref.acc,
      acc = _ref$acc === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])() : _ref$acc,
      _ref$keyGetter = _ref.keyGetter,
      keyGetter = _ref$keyGetter === undefined ? function (element) {
    return element.get('id');
  } : _ref$keyGetter;

  return acc.withMutations(function (state) {
    elements.forEach(function (element) {
      return state.set(keyGetter(element), element);
    });
  });
}

/***/ }),

/***/ "QXt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"campaign-segment-option":"campaign-segment-option---cHZ01"};

/***/ }),

/***/ "QYDB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QZc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__ = __webpack_require__("S8Mv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("4ODQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DEFAULT_WIDTH = 13.6;

function getColor(percent) {
  if (percent >= 90) {
    return __WEBPACK_IMPORTED_MODULE_4_styles_colors___default.a['color-orange'];
  } else {
    return __WEBPACK_IMPORTED_MODULE_4_styles_colors___default.a['color-green'];
  }
}

var QuotaBar = function (_PureComponent) {
  _inherits(QuotaBar, _PureComponent);

  function QuotaBar() {
    _classCallCheck(this, QuotaBar);

    return _possibleConstructorReturn(this, (QuotaBar.__proto__ || Object.getPrototypeOf(QuotaBar)).apply(this, arguments));
  }

  _createClass(QuotaBar, [{
    key: 'getWidth',
    value: function getWidth() {
      return this.props.totalWidth || DEFAULT_WIDTH;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          percent = _props.percent,
          light = _props.light;

      var color = getColor(percent);
      var width = this.getWidth() * percent / 100 + 'rem';
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.CounterContainer, { light: light }), style: { width: this.getWidth() + 'rem' } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_addons_css_transition_group___default.a,
          {
            transitionName: 'counter-grow',
            transitionAppear: true,
            transitionEnterTimeout: 3000,
            transitionLeaveTimeout: 1000,
            transitionAppearTimeout: 250
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Counter, style: { width: width, backgroundColor: color } })
        )
      );
    }
  }]);

  return QuotaBar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

QuotaBar.propTypes = {
  percent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
  totalWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (QuotaBar);

/***/ }),

/***/ "Qa1t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_hotkeys__ = __webpack_require__("S+6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mixins_MakeInputChangeHandler__ = __webpack_require__("0HTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_tags_TagColorSelectorDropdown__ = __webpack_require__("fRuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_tags_TagEditingInput_styl__ = __webpack_require__("vk0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_tags_TagEditingInput_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_components_settings_tags_TagEditingInput_styl__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.















var TagEditingInput = React.createClass({
  displayName: 'TagEditingInput',

  mixins: [__webpack_require__("aCGJ"), __WEBPACK_IMPORTED_MODULE_4_mixins_MakeInputChangeHandler__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {
      showColorDropdown: false,
      selectedColor: this.props.selectedColor,
      creatingTag: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.selectedColor != null) {
      this.setState({ selectedColor: nextProps.selectedColor });
    }

    if (this.state.creatingTag) {
      var newTagId = _.findKey(nextProps.tagsById, { name: this.tagName() });

      if (newTagId) {
        this.setState({ creatingTag: false });
        this.props.onCreate(parseInt(newTagId));
        return this.props.onClose();
      }
    }
  },
  getAllTags: function getAllTags() {
    return this.props.customerTagList.concat(this.props.conversationTagList);
  },
  isTagNameValid: function isTagNameValid(tagName) {
    var editTag = void 0;
    if (tagName == null) {
      tagName = this.state.tagName;
    }
    var allTags = this.getAllTags();
    if (this.props.editingTag) {
      editTag = _.find(allTags, { 'id': this.props.editingTag.id });
    }

    var tagAlreadyExists = _.some(allTags, function (tag) {
      return tag.name === tagName;
    });
    return !tagAlreadyExists || (editTag != null ? editTag.name : undefined) === tagName;
  },
  colorClicked: function colorClicked(tagColor) {
    return this.setState({
      showColorDropdown: false,
      selectedColor: tagColor
    });
  },
  renderColorDropdown: function renderColorDropdown() {
    var _this = this;

    return React.createElement(__WEBPACK_IMPORTED_MODULE_5_components_settings_tags_TagColorSelectorDropdown__["a" /* default */], {
      colorClicked: this.colorClicked,
      onClickOutside: function onClickOutside() {
        return _this.setState({ showColorDropdown: false });
      } });
  },
  onSaveOrUpdateTag: function onSaveOrUpdateTag() {
    var saved = this.createOrUpdateTag();
    if (saved && !this.props.onCreate) {
      return this.props.onClose();
    }
  },
  tagName: function tagName(trim) {
    if (trim == null) {
      trim = true;
    }
    var tagName = trim ? this.state.tagName != null ? this.state.tagName.trim() : undefined : this.state.tagName;
    return tagName || (this.props.editingTag != null ? this.props.editingTag.name : undefined);
  },
  validInput: function validInput() {
    var colorNotSelected = this.state.selectedColor == null;
    var emptyTagName = this.tagName() == null;
    var invalidTagName = !this.isTagNameValid();
    if (emptyTagName || colorNotSelected || invalidTagName) {
      if (typeof this.props.invalidSaveAttempt === 'function') {
        this.props.invalidSaveAttempt(emptyTagName, colorNotSelected, invalidTagName);
      }
      return false;
    }

    return true;
  },


  // return: boolean, if tag has been saved
  createOrUpdateTag: function createOrUpdateTag() {
    if (!this.validInput()) {
      return false;
    }

    var body = {
      name: this.tagName(),
      color: this.state.selectedColor,
      targetType: this.props.tagType
    };
    if (this.props.editingTag) {
      this.app.actions.TagActions.updateTag(this.props.editingTag.id, body);
    } else {
      this.app.actions.TagActions.createTag(body);
      if (this.props.onCreate != null) {
        this.setState({ creatingTag: true });
      }
    }
    return true;
  },
  handleClickOutside: function handleClickOutside(event) {
    if (!this.props.disableClickOutsideSave) {
      this.createOrUpdateTag();
      return this.props.onClose();
    }
  },
  handleInputKeyDown: function handleInputKeyDown(event) {
    // disable newline when using <Textarea>
    if (this.props.multiLine && event.keyCode === 13) {
      return event.preventDefault();
    }
  },
  handleInputChange: function handleInputChange(newTagName) {
    return typeof this.props.onTagNameChange === 'function' ? this.props.onTagNameChange(newTagName) : undefined;
  },
  onTagColorClick: function onTagColorClick() {
    if (!this.props.disableColorDropdown) {
      return this.setState({ showColorDropdown: true });
    }
  },
  tagColorBackgroundColor: function tagColorBackgroundColor() {
    if (this.state.selectedColor != null) {
      return '#' + Object(__WEBPACK_IMPORTED_MODULE_8_utils_TagAppearanceHelper__["a" /* getNormalizedTagColor */])(this.state.selectedColor);
    } else {
      return 'transparent';
    }
  },
  render: function render() {
    return React.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('create-tag', {
          'tag-multiline': this.props.multiLine
        }),
        onFocus: function onFocus(e) {
          return e.stopPropagation();
        } },
      React.createElement('div', {
        onClick: this.onTagColorClick,
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('tag-color', {
          'tag-color-empty': this.state.selectedColor == null
        }),
        style: {
          backgroundColor: this.tagColorBackgroundColor(),
          color: 'var(--main-navy-extra-dark)'
        } }),
      this.state.showColorDropdown ? this.renderColorDropdown() : undefined,
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react_hotkeys__["HotKeys"],
        {
          className: 'input-container',
          keyMap: {
            'saveOrUpdateTag': ['enter'],
            'close': 'esc'
          },
          handlers: {
            'saveOrUpdateTag': this.onSaveOrUpdateTag,
            'close': this.props.onClose
          } },
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
          type: 'text',
          placeholder: 'Tag name',
          autoFocus: true,
          valueLink: {
            value: this.tagName(false),
            requestChange: this.makeInputChangeHandler('tagName', this.handleInputChange)
          },
          isValid: this.isTagNameValid(),
          errorLabel: 'Sorry, this name is taken',
          isTextAreaAutosize: this.props.multiLine,
          onKeyDown: this.handleInputKeyDown })
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
        className: 'cancel-tag-button',
        src: __webpack_require__("+Juk"),
        onClick: this.props.onClose })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(TagEditingInput, {
  listenTo: ['stores.TagStore'],

  fetch: {
    customerTagList: function customerTagList() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList();
    },
    conversationTagList: function conversationTagList() {
      return this.app.stores.TagStore.getOrFetchConversationTagList();
    },
    tagsById: function tagsById() {
      return this.app.stores.TagStore.getOrFetchTagList();
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_7_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "Qb1k":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1My41OSIgaGVpZ2h0PSI2NC4zNiIgdmlld0JveD0iMCAwIDUzLjU5IDY0LjM2Ij48cGF0aCBmaWxsPSIjZWIzYzAwIiBkPSJNLjUgNTEuNlYxMy4xTDM0LjU3LjUgNTMuMSA2LjQzdjUxLjg1bC0xOC41MyA1LjU4TC41IDUxLjZsMzQuMDcgNC4xVjEwLjg4bC0yMi4yMiA1LjJWNDYuNHoiLz48L3N2Zz4="

/***/ }),

/***/ "Qbpt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qd9x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__ = __webpack_require__("lMLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var IntegrationsQueries = Marty.createQueries({
  id: 'IntegrationsQueries',

  mapSlackUser: function mapSlackUser(slackUserId) {
    var _this = this;

    var promise = this.app.sources.IntegrationsAPI.mapSlackUser(slackUserId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].MAP_SLACK_USER_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].MAP_SLACK_USER_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].MAP_SLACK_USER_FAILED, error);
    });
  },
  createSlackBotToken: function createSlackBotToken(code, href) {
    var _this2 = this;

    var promise = this.app.sources.IntegrationsAPI.createSlackBotToken(code, href);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_DONE, 'slack', name, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED, 'slack', name, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED, 'slack', name, error);
    });
  },
  createAccessToken: function createAccessToken(name, body) {
    var _this3 = this;

    var promise = this.app.sources.IntegrationsAPI.createAccessToken(name, body);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_DONE, name, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED, name, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED, name, error);
    });
  },
  fetchIntegrationStates: function fetchIntegrationStates() {
    var _this4 = this;

    var promise = this.app.sources.IntegrationsAPI.integrationStates();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_INTEGRATION_STATES_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_INTEGRATION_STATES_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_INTEGRATION_STATES_FAILED, error);
    });
  },
  enableShopifyIntegration: function enableShopifyIntegration() {
    var promise = void 0;
    return promise = this.app.sources.IntegrationsAPI.enableShopifyIntegration();
  },
  fetchHubspotInjectionState: function fetchHubspotInjectionState() {
    var _this5 = this;

    var promise = this.app.sources.IntegrationsAPI.hubspotInjectionState();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_INJECTION_STATE_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_INJECTION_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_INJECTION_STATE_FAILED, error);
    });
  },
  fetchHubspotTimelineState: function fetchHubspotTimelineState() {
    var _this6 = this;

    var promise = this.app.sources.IntegrationsAPI.hubspotTimelineState();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_TIMELINE_STATE_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_TIMELINE_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_TIMELINE_STATE_FAILED, error);
    });
  },
  updateHubspotInjectionState: function updateHubspotInjectionState(state) {
    var _this7 = this;

    var promise = this.app.sources.IntegrationsAPI.updateHubspotInjectionState(state);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_INJECTION_STATE_DONE, state);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_INJECTION_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_INJECTION_STATE_FAILED, error);
    });
  },
  updateHubspotTimelineState: function updateHubspotTimelineState(state) {
    var _this8 = this;

    var promise = this.app.sources.IntegrationsAPI.updateHubspotTimelineState(state);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_TIMELINE_STATE_DONE, state);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_TIMELINE_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_TIMELINE_STATE_FAILED, error);
    });
  },
  fetchHubspotCookieState: function fetchHubspotCookieState() {
    var _this9 = this;

    var promise = this.app.sources.IntegrationsAPI.hubspotCookieState();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_COOKIE_STATE_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_COOKIE_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_COOKIE_STATE_FAILED, error);
    });
  },
  updateHubspotCookieState: function updateHubspotCookieState(state) {
    var _this10 = this;

    var promise = this.app.sources.IntegrationsAPI.updateHubspotCookieState(state);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_COOKIE_STATE_DONE, state);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_COOKIE_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_COOKIE_STATE_FAILED, error);
    });
  },
  updateIntegrationState: function updateIntegrationState(properties) {
    var _this11 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_INTEGRATION_STATE_STARTING, properties);

    var promise = this.app.sources.IntegrationsAPI.updateIntegrationState(properties);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_INTEGRATION_STATE_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_INTEGRATION_STATE_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_INTEGRATION_STATE_FAILED, error);
    });
  },
  fetchProtip: function fetchProtip(id) {
    var _this12 = this;

    var promise = this.app.sources.IntegrationsAPI.protip(id);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_PROTIP_DONE, id, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_PROTIP_FAILED, id, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_PROTIP_FAILED, id, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "Qfgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchNonPlaybookEvents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("/Abo");


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






var fetchNonPlaybookEvents = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(orgId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["CustomerAPI"].get('/organizations/' + orgId + '/end_users/attributes2?playbookEventInclude=false').then(__WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["json"]));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchNonPlaybookEvents(_x) {
    return _ref.apply(this, arguments);
  };
}();

var api = {
  fetch: function fetch(id) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + id + '?withMaster=true').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_4__models__["b" /* parseEndUser */]);
  },
  bulkFetch: function bulkFetch(ids) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/end_users/find', { endUserIds: ids }).checkStatus().retryWithBackoff().mapResponse(function (res) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(res).map(__WEBPACK_IMPORTED_MODULE_4__models__["b" /* parseEndUser */]);
    });
  },
  updateEndUser: function updateEndUser(endUserId, endUserParams) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].patch('/end_users/' + endUserId, endUserParams).checkStatus().retryWithBackoff();
  },
  fetchFollowing: function fetchFollowing(id) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + id + '/following').checkStatus().retryWithBackoff().map(function (_ref2) {
      var response = _ref2.response;
      return response;
    });
  },
  updateFollowing: function updateFollowing(id, following) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].patch('/end_users/' + id + '/following', { following: following }).checkStatus().retryWithBackoff().map(function (_ref3) {
      var response = _ref3.response;
      return response;
    });
  },
  updateCQL: function updateCQL(endUserId, score, conversationId) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/end_users/' + endUserId + '/cql', { conversationId: conversationId, score: score }).checkStatus().retryWithBackoff();
  },
  createNewContactAttribute: function createNewContactAttribute(data) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/property_definitions', data).checkStatus().retryWithBackoff().pluck('response');
  },
  addNewContactAttribute: function addNewContactAttribute(data) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["CustomerAPI"].post('/property_definitions', data).then(__WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["json"]);
  },
  fetchUnsubscribedCount: function fetchUnsubscribedCount() {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].get('/unsubscribe/count').checkStatus().retryWithBackoff().pluck('response');
  },
  checkUnsubscribed: function checkUnsubscribed(email, orgId) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/check', { email: email, orgId: orgId }).checkStatus().retryWithBackoff().pluck('response');
  },
  unsubscribe: function unsubscribe(email) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/mark', { email: email }).checkStatus().retryWithBackoff().pluck('response');
  },
  unsubscribeById: function unsubscribeById(_ref4) {
    var endUserId = _ref4.endUserId,
        reason = _ref4.reason;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/enduser/' + endUserId + '?reason=' + encodeURIComponent(reason)).checkStatus().retryWithBackoff().pluck('response');
  },
  unsubscribeByEncodedEmail: function unsubscribeByEncodedEmail(_ref5) {
    var email = _ref5.email,
        endUserId = _ref5.endUserId,
        reason = _ref5.reason;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/byIdentifier/' + encodeURIComponent(window.btoa(email)) + '?reason=' + encodeURIComponent(reason) + '&endUserId=' + endUserId).retryWithBackoff(1).pluck('response');
  },
  unsubscribeByEmailAndOrgId: function unsubscribeByEmailAndOrgId(_ref6) {
    var email = _ref6.email,
        orgId = _ref6.orgId;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/byEmail/', {
      email: email,
      orgId: orgId
    }).retryWithBackoff(1).pluck('response');
  },

  requestContactData: function requestContactData(payload) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxGdprAPI"].post('/retrieve', payload).checkStatus().pluck('response');
  },
  requestDataDeletion: function requestDataDeletion(payload) {
    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxGdprAPI"].post('/delete', payload).checkStatus().pluck('response');
  },
  requestUnsubDeleteData: function requestUnsubDeleteData(_ref7) {
    var email = _ref7.email,
        endUserId = _ref7.endUserId,
        orgId = _ref7.orgId;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/delete_user_data', { email: email, endUserId: endUserId, orgId: orgId }).retryWithBackoff(1);
  },
  resubscribe: function resubscribe(_ref8) {
    var email = _ref8.email,
        endUserId = _ref8.endUserId;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/resubscribe/' + encodeURIComponent(window.btoa(email)) + '?endUserId=' + endUserId).checkStatus().retryWithBackoff().pluck('response');
  },
  resubscribeByEmailandOrgId: function resubscribeByEmailandOrgId(_ref9) {
    var email = _ref9.email,
        orgId = _ref9.orgId;

    return __WEBPACK_IMPORTED_MODULE_3__driftt_dapper__["RxCustomerAPI"].post('/unsubscribe/resubscribe', { email: email, orgId: orgId }).checkStatus().retryWithBackoff().pluck('response');
  }
};

/***/ }),

/***/ "Qj5x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_paging__ = __webpack_require__("Prq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("G57K");
var _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchTimelineEventsForEndUserPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchTimelineEventsForEndUserCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchTimelineEventsForEndUserFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchTimelineEventsForEndUserSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["i" /* loadMoreTimelineEventsForEndUserPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* loadMoreTimelineEventsForEndUserCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* loadMoreTimelineEventsForEndUserFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* loadMoreTimelineEventsForEndUserSuccess */]), function (state, action) {
  return action.type;
}), null);

var events = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchTimelineEventsForEndUser */], function () {
  return Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["a" /* BidirectionalPagedData */])();
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchTimelineEventsForEndUserSuccess */], function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* loadMoreTimelineEventsForEndUserSuccess */], function (state, action) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["c" /* combinePagedData */])(state, action.payload);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["a" /* BidirectionalPagedData */])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({ status: status, events: events }));

/***/ }),

/***/ "Qk83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var closeSRC = __webpack_require__("+Juk");

var HeadquarterPostalCodeFilter = function (_Component) {
  _inherits(HeadquarterPostalCodeFilter, _Component);

  function HeadquarterPostalCodeFilter(props) {
    _classCallCheck(this, HeadquarterPostalCodeFilter);

    var _this = _possibleConstructorReturn(this, (HeadquarterPostalCodeFilter.__proto__ || Object.getPrototypeOf(HeadquarterPostalCodeFilter)).call(this, props));

    _initialiseProps.call(_this);

    var _props$activeFilter = props.activeFilter,
        value = _props$activeFilter.value,
        field = _props$activeFilter.field;


    _this.state = {
      currentPostalCode: '',
      postalCodes: value || [],
      fieldType: field
    };
    return _this;
  }

  _createClass(HeadquarterPostalCodeFilter, [{
    key: 'getListHeight',
    value: function getListHeight() {
      var itemHeight = 75;
      var totalColumns = 2;
      var maxHeight = this.state.postalCodes.length * itemHeight / totalColumns + itemHeight;
      return {
        height: maxHeight + 'px'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.currentPostalCode, onChange: this.updateCurrentPostalCode, className: 'large postal-code-input', placeholder: 'value', onKeyPress: function onKeyPress(e) {
              if (e.key === 'Enter') {
                _this2.savePostalCode();
              }
            } }),
          this.state.currentPostalCode && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'postal-code-option-add', onClick: this.savePostalCode },
            '+Add'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-selection rules-choice-selection-multi-column' },
          this.renderTagSelectionList()
        )
      );
    }
  }]);

  return HeadquarterPostalCodeFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.removePostalCode = function (value) {
    _this3.setState(function (prevState) {
      return {
        postalCodes: _.without(prevState.postalCodes, value)
      };
    }, _this3.updateCondition);
  };

  this.updateCurrentPostalCode = function (event) {
    _this3.setState({
      currentPostalCode: event.target.value
    });
  };

  this.savePostalCode = function () {
    _this3.setState(function (prevState) {
      if (_.includes(prevState.postalCodes, _this3.state.currentPostalCode)) {
        return {
          currentPostalCode: '',
          postalCodes: prevState.postalCodes
        };
      } else {
        var newOptions = [].concat(_toConsumableArray(prevState.postalCodes), [_this3.state.currentPostalCode]);
        newOptions.sort();
        return {
          currentPostalCode: '',
          postalCodes: newOptions
        };
      }
    }, _this3.updateCondition);
  };

  this.updateCondition = function () {
    var updatedCondition = {
      operator: __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
      value: _this3.state.postalCodes
    };

    _this3.props.onUpdateCondition(updatedCondition);
  };

  this.renderTagSelectionList = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { style: _this3.getListHeight() },
      _this3.state.postalCodes.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: option + '-' + index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            option
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
              return _this3.removePostalCode(option);
            } })
        );
      })
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (HeadquarterPostalCodeFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "QkC9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qlga":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qoum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_MadKuduTag__ = __webpack_require__("AJjG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("FxSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_svg__ = __webpack_require__("A1a6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_redx_svg__ = __webpack_require__("QKOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_redx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_redx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_madkudu_logo_svg__ = __webpack_require__("BcoS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_madkudu_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_madkudu_logo_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var renderSignalValue = function renderSignalValue(value) {
  if (value === null) {
    return '';
  }
  var numValue = parseInt(value);

  if (_.isNumber(numValue) && !isNaN(numValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["intComma"])(numValue);
  }
  return value;
};

var ScoringSignal = function ScoringSignal(_ref) {
  var signal = _ref.signal;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { key: signal.name, className: 'madkudu-signal-list-item' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
      src: signal.type === 'positive' ? __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_check_svg___default.a : __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_redx_svg___default.a,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('madkudu-dot-icon', signal.type)
    }),
    ' ',
    (__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_130" /* MadkuduSignalMap */][signal.name] || signal.name) + ' ' + renderSignalValue(signal.value)
  );
};

var ScoringSection = function (_Component) {
  _inherits(ScoringSection, _Component);

  function ScoringSection(props) {
    _classCallCheck(this, ScoringSection);

    var _this = _possibleConstructorReturn(this, (ScoringSection.__proto__ || Object.getPrototypeOf(ScoringSection)).call(this, props));

    _this.handleShowAllPositive = function () {
      _this.setState({
        showAllPositive: true
      });
    };

    _this.handleShowAllNegative = function () {
      _this.setState({
        showAllNegative: true
      });
    };

    _this.state = {
      showAllPositive: false,
      showAllNegative: false
    };
    return _this;
  }

  _createClass(ScoringSection, [{
    key: 'renderPlaceholder',
    value: function renderPlaceholder() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'scoring-section-placeholder' });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.endUser) {
        return this.renderPlaceholder();
      }

      var _state = this.state,
          showAllPositive = _state.showAllPositive,
          showAllNegative = _state.showAllNegative;
      var attributes = this.props.endUser.attributes;


      var kuduScore = attributes.get('_madkudu_score');
      var signalsBlob = attributes.get('_madkudu_signals');

      if (!kuduScore || !signalsBlob) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);

      var kuduSignals = JSON.parse(signalsBlob);

      var defaultSliceLength = 5;
      var positiveSignals = kuduSignals.filter(function (signal) {
        return signal.type === 'positive';
      });
      var showMorePosCount = positiveSignals.length - defaultSliceLength;
      var negativeSignals = kuduSignals.filter(function (signal) {
        return signal.type === 'negative';
      });
      var showMoreNegCount = negativeSignals.length - defaultSliceLength;

      var totalSignals = negativeSignals.length + positiveSignals.length;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__style_styl__["SectionHeader"] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Score'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_madkudu_logo_svg___default.a, className: 'madkudu-logo' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_7__style_styl__["SectionBody"] },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'madkudu-lead-score' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_MadKuduTag__["a" /* default */], { score: kuduScore })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'madkudu-lead-narrative' },
            'This lead is ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_129" /* MadkuduLabelMap */][kuduScore]
            ),
            ' based on',
            ' ',
            positiveSignals.length,
            ' positive and ',
            negativeSignals.length,
            ' negative',
            ' ',
            totalSignals < 2 && negativeSignals.length === 1 ? 'signal' : Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(totalSignals, 'signal'),
            '.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'madkudu-signal-list' },
            positiveSignals.slice(0, showAllPositive ? 100 : defaultSliceLength).map(function (signal, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScoringSignal, { key: index, signal: signal });
            }),
            !showAllPositive && showMorePosCount > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'show-more-signals', onClick: this.handleShowAllPositive },
              'show ',
              showMorePosCount,
              ' more...'
            ),
            negativeSignals.slice(0, showAllNegative ? 100 : defaultSliceLength).map(function (signal, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScoringSignal, { key: index, signal: signal });
            }),
            !showAllPositive && showMoreNegCount > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'show-more-signals', onClick: this.handleShowAllNegative },
              'show ',
              showMoreNegCount,
              ' more...'
            )
          )
        )
      );
    }
  }]);

  return ScoringSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ScoringSection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Qv24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_link_svg__ = __webpack_require__("O812");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_link_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("CCVr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);












var ENTITY_TYPE = 'LINK';

var addLink = function addLink(editorState, pushChange, link) {
  var selectionState = editorState.getSelection();
  var currentContent = editorState.getCurrentContent();
  var contentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].applyEntity(currentContent, selectionState, __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].create(ENTITY_TYPE, 'MUTABLE', {
    href: link,
    target: '_blank'
  }));
  pushChange(__WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, contentState, 'apply-entity'));
};

var LinkInput = function LinkInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'rich-editor-link-popover drift-form' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rich-editor-link-text-preview' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Add a link to text:'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'em',
          null,
          props.linkText
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      className: 'rich-editor-link-input',
      type: 'url',
      placeholder: 'enter url...',
      onChange: props.onInputChange }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        onClick: props.onEnter,
        className: 'drift-button rich-editor-link-button'
      },
      '\u2714'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        onClick: props.onCancel,
        className: 'drift-button rich-editor-link-button'
      },
      '\u2716'
    )
  );
};

var LinkButton = function LinkButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5_react_tether___default.a,
    {
      attachment: 'top left',
      targetAttachment: 'top center',
      targetOffset: '0 10px',
      constraints: [{ to: 'scrollParent', attachment: 'together' }]
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rich-editor-link-button-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rich-editor-toolbar-button rich-editor-link-button', onClick: props.toggleOpen },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_link_svg___default.a })
      ),
      props.popoverOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkInput, props)
    )
  );
};

var LinkButtonContainer = Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('popoverOpen', 'setPopoverOpen', false), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('linkedURL', 'setLinkedURL', undefined), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  onCancel: function onCancel(props) {
    return function () {
      props.setPopoverOpen(false);
      props.setLinkedURL(undefined);
    };
  },
  onEnter: function onEnter(props) {
    return function () {
      addLink(props.editorState, props.onChange, props.linkedURL);
      props.setPopoverOpen(false);
      props.setLinkedURL(undefined);
    };
  },
  toggleOpen: function toggleOpen(props) {
    return function () {
      props.setPopoverOpen(!props.popoverOpen);
    };
  },
  onInputChange: function onInputChange(props) {
    return function (evt) {
      props.setLinkedURL(evt.target.value);
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function () {
      props.setPopoverOpen(false);
      props.setLinkedURL(undefined);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  var editorContent = props.editorState.getCurrentContent();
  var selection = props.editorState.getSelection();
  var selectedBlock = editorContent.getBlockForKey(selection.getAnchorKey());
  return {
    linkText: selectedBlock.getText().slice(selection.getAnchorOffset(), selection.getEndOffset())
  };
}), __WEBPACK_IMPORTED_MODULE_6_react_onclickoutside_decorator___default.a)(LinkButton);

// TODO: maybe consider more protocols
var startsWithProtocol = function startsWithProtocol(link) {
  return ['http', 'https', 'tel', 'tcp', 'file', 'mailto'].some(function (protocol) {
    return link && link.startsWith(protocol);
  });
};
// ref: https://en.wikipedia.org/wiki/Wikipedia:Protocol-relative_URL
var isProtocolRelative = function isProtocolRelative(link) {
  return link && link.startsWith('//');
};

var LinkDecorator = {
  strategy: __WEBPACK_IMPORTED_MODULE_2_draft_extend__["pluginUtils"].entityStrategy(ENTITY_TYPE),
  component: function component(props) {
    var entity = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].get(props.entityKey);

    var _entity$getData = entity.getData(),
        href = _entity$getData.href,
        target = _entity$getData.target;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: !!href && (startsWithProtocol(href) || isProtocolRelative(href)) ? href : 'http://' + href, target: target },
      props.children
    );
  }
};

var htmlToEntity = function htmlToEntity(nodeName, node) {
  if (nodeName === 'a') {
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].create(ENTITY_TYPE, 'MUTABLE', {
      href: node.getAttribute('href'),
      target: node.getAttribute('target')
    });
  }
};

var entityToHTML = function entityToHTML(entity, originalText) {
  if (entity.type === ENTITY_TYPE) {
    return '<a href="' + entity.data.href + '" target="' + entity.data.target + '">' + originalText + '</a>';
  }
  return originalText;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_draft_extend__["createPlugin"])({
  displayName: 'LinkPlugin',
  buttons: LinkButtonContainer,
  decorators: LinkDecorator,
  htmlToEntity: htmlToEntity,
  entityToHTML: entityToHTML
}));

/***/ }),

/***/ "Qxuw":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 360 78\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path id=\"a\" d=\"M78.802 32.94H0V.495h78.802z\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M133.932 37.586l-6.545-1.42c-3.275-.71-5.078-2.73-5.078-5.69 0-3.762 3.34-6.6 7.77-6.6 6.13 0 7.94 4.51 8.35 5.894.13.46.45.85.88 1.065.42.215.89.247 1.34.09l3.45-1.217c.86-.302 1.33-1.226 1.08-2.104-.89-3.13-4.16-10.41-15.25-10.41-8.21 0-15.14 6.28-15.14 13.715 0 6.39 4.193 11.11 11.22 12.64l6.24 1.36c3.756.79 6 3.08 6 6.12 0 3.88-3.19 6.29-8.33 6.29-6.04 0-8.95-3.96-9.66-7.67-.093-.49-.39-.91-.81-1.16-.42-.25-.93-.31-1.4-.16l-3.79 1.21c-.83.26-1.333 1.09-1.17 1.93 1.18 6.15 6.233 12.71 16.9 12.71 9.014 0 15.812-5.87 15.812-13.65 0-6.57-4.336-11.29-11.9-12.96m38.752 6c.02.13-.04.23-.08.27-.04.05-.13.13-.275.13h-13.9c-.11 0-.217-.05-.287-.14-.04-.05-.097-.14-.07-.27.635-2.898 3.12-5.82 7.24-5.82 4.047 0 6.8 2.17 7.365 5.813zm-7.426-12.32c-7.32 0-14.89 6.12-14.89 16.37 0 4.94 1.62 9.16 4.69 12.19 2.844 2.81 6.73 4.36 10.94 4.36 6.27 0 11.35-3.276 13.59-8.76.18-.45.17-.95-.024-1.39-.197-.435-.554-.76-1.005-.916l-3.06-1.06c-.85-.29-1.79.122-2.137.943-1.32 3.11-3.8 4.68-7.37 4.68-4.32 0-7.61-2.91-8.18-7.243-.02-.13.045-.23.085-.27.04-.05.13-.13.27-.13h20.284c.91 0 1.67-.71 1.72-1.616.02-.29.03-.61.03-.926 0-10.02-5.73-16.243-14.95-16.243zm34.54 24.32c-4.87 0-7.9-3.38-7.9-8.82 0-5.36 3.1-8.824 7.9-8.824 4.65 0 7.774 3.54 7.774 8.82 0 5.274-3.126 8.82-7.775 8.82zm12.98-23.4h-3.67c-.95 0-1.725.773-1.725 1.77 0 .215-.17.31-.22.33-.07.03-.21.07-.336-.05-1.89-1.728-4.55-2.605-7.9-2.605-8.303 0-14.33 6.37-14.33 15.14 0 8.732 6.027 15.07 14.33 15.07 3.07 0 5.85-1.008 7.83-2.838.13-.12.27-.09.34-.06.05.02.22.11.22.33v1.26c0 6.1-2.67 8.945-8.39 8.945-3.63 0-6.48-2.25-7.25-5.728-.1-.45-.37-.83-.76-1.073s-.86-.32-1.31-.22l-3.604.83c-.92.218-1.487 1.12-1.294 2.06 1.29 6.32 7.006 10.57 14.21 10.57 5.37 0 9.46-1.635 12.16-4.86 2.23-2.666 3.41-6.367 3.41-10.703V33.92c0-.95-.77-1.72-1.72-1.72zm43.63-.864c-4.06 0-7.363 1.532-9.554 4.44-.083.11-.2.174-.335.164-.104 0-.186-.05-.24-.135-1.837-2.84-5.008-4.47-8.7-4.47-2.937 0-5.76 1.032-7.748 2.835-.155.148-.318.1-.38.07-.075-.03-.2-.12-.2-.312 0-.95-.774-1.72-1.724-1.72h-3.486c-.95 0-1.72.77-1.72 1.72v27.63c0 .95.774 1.722 1.724 1.722h3.67c.95 0 1.72-.776 1.72-1.726V44.68c0-4.093 2.5-6.844 6.23-6.844 4.88 0 5.61 3.827 5.61 6.107v17.61c0 .95.77 1.72 1.72 1.72h3.733c.95 0 1.72-.774 1.72-1.724V44.62c0-3.996 2.54-6.786 6.17-6.786 4.883 0 5.61 3.83 5.61 6.11v17.61c0 .95.77 1.72 1.72 1.72h3.67c.95 0 1.72-.774 1.72-1.724V43.32c0-8.28-5.49-11.983-10.93-11.983m24.81 12.656c-.11 0-.216-.05-.287-.138-.036-.045-.094-.14-.066-.266.636-2.9 3.12-5.82 7.244-5.82 4.046 0 6.8 2.17 7.364 5.81.02.13-.043.23-.08.27-.043.04-.13.12-.275.12h-13.9zm6.83-12.72c-7.32 0-14.89 6.124-14.89 16.37 0 4.946 1.62 9.163 4.686 12.196 2.84 2.81 6.72 4.35 10.94 4.35 6.26 0 11.34-3.28 13.59-8.77.18-.45.17-.95-.03-1.39-.2-.44-.56-.76-1.01-.92l-3.06-1.058c-.85-.293-1.79.12-2.138.942-1.32 3.102-3.8 4.68-7.37 4.68-4.32 0-7.61-2.916-8.18-7.25-.02-.135.04-.23.08-.276.04-.05.13-.125.27-.125h20.29c.91 0 1.667-.71 1.72-1.617.017-.29.03-.61.03-.93 0-10.02-5.73-16.25-14.95-16.25zm36.77.063c-3.105 0-5.827 1.058-7.87 3.06-.14.134-.29.1-.366.07-.06-.03-.21-.115-.21-.324v-.22c0-.95-.774-1.72-1.724-1.72h-3.6c-.95 0-1.724.77-1.724 1.72v27.625c0 .95.77 1.723 1.72 1.723h3.73c.95 0 1.725-.775 1.725-1.725V45.418c0-3.608 1.635-7.464 6.23-7.464 4.13 0 6.226 2.283 6.226 6.785v16.8c0 .95.77 1.72 1.72 1.72h3.73c.95 0 1.722-.78 1.722-1.73V43.75c0-7.66-4.338-12.42-11.31-12.42m28.69 7.488h4.35c.95 0 1.72-.775 1.72-1.724V33.92c0-.95-.77-1.72-1.72-1.72h-4.35c-.196 0-.35-.158-.35-.35v-7.314c0-.95-.776-1.722-1.725-1.722h-3.24c-.95 0-1.72.772-1.72 1.722v3.78c0 1.77-.678 3.883-3.888 3.883H342c-.95 0-1.72.77-1.72 1.72v3.17c0 .95.773 1.72 1.72 1.72h3.61c.195 0 .35.15.35.35v15.27c0 5.64 3.435 9.14 8.96 9.14 1.54 0 2.738-.22 3.315-.35.78-.18 1.328-.87 1.328-1.68V58.6c0-.487-.21-.952-.57-1.277-.36-.328-.85-.486-1.338-.436-.39.04-.768.063-1.064.063-2.51 0-3.45-.92-3.45-3.39v-14.4c0-.192.16-.348.35-.348\" fill=\"#43AF79\"></path><g transform=\"translate(0 45)\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"></use></mask><path d=\"M51.926 8.497H4c-2.21 0-4-1.79-4-4s1.79-4 4-4h47.926c2.21 0 4 1.79 4 4s-1.79 4-4 4\" fill=\"#93C8A2\" mask=\"url(#b)\"></path><path d=\"M41.65 33c-3.904 0-7.76-.58-11.46-1.727-2.11-.654-3.29-2.894-2.637-5.004.654-2.12 2.9-3.3 5.005-2.64 2.932.91 5.99 1.37 9.092 1.37 13.573 0 25.358-8.71 29.327-21.68.646-2.11 2.88-3.3 4.995-2.65 2.112.64 3.3 2.88 2.654 4.99C73.622 22.01 58.762 33 41.65 33\" fill=\"#43AF79\" mask=\"url(#b)\"></path></g><path d=\"M79.3 33.175H31.376c-2.21 0-4-1.79-4-4s1.79-4 4-4H79.3c2.21 0 4 1.79 4 4s-1.79 4-4 4\" fill=\"#93C8A2\"></path><path d=\"M8.5 33.176c-.387 0-.78-.057-1.17-.176-2.114-.648-3.302-2.884-2.655-4.996C9.68 11.654 24.54.672 41.65.672c3.907 0 7.763.58 11.46 1.728 2.112.655 3.29 2.895 2.637 5.005-.654 2.11-2.896 3.297-5.005 2.636-2.93-.9-5.99-1.36-9.092-1.36-13.57 0-25.357 8.71-29.326 21.68-.527 1.72-2.11 2.83-3.823 2.83\" fill=\"#43AF79\"></path><path d=\"M69.392 13.932c0 2.21-1.79 4-4 4-2.208 0-4-1.79-4-4s1.792-4 4-4c2.21 0 4 1.79 4 4M21.907 64.746c0 2.21-1.79 4-4 4-2.208 0-4-1.79-4-4s1.792-4 4-4c2.21 0 4 1.79 4 4\" fill=\"#93C8A2\"></path></g></svg>"

/***/ }),

/***/ "R/TV":
/***/ (function(module, exports) {

module.exports = "<svg width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-887.000000, -772.000000)\" fill=\"#E95531\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"check-circle\" transform=\"translate(17.000000, 294.000000)\"><path d=\"M10.70725,99.70725 C10.51225,99.90225 10.25625,100.00025 10.00025,100.00025 C9.74425,100.00025 9.48825,99.90225 9.29325,99.70725 L6.00025,96.41425 L2.70725,99.70725 C2.51225,99.90225 2.25625,100.00025 2.00025,100.00025 C1.74425,100.00025 1.48825,99.90225 1.29325,99.70725 C0.90225,99.31725 0.90225,98.68325 1.29325,98.29325 L4.58625,95.00025 L1.29325,91.70725 C0.90225,91.31725 0.90225,90.68425 1.29325,90.29325 C1.68425,89.90225 2.31625,89.90225 2.70725,90.29325 L6.00025,93.58625 L9.29325,90.29325 C9.68425,89.90225 10.31625,89.90225 10.70725,90.29325 C11.09825,90.68425 11.09825,91.31725 10.70725,91.70725 L7.41425,95.00025 L10.70725,98.29325 C11.09825,98.68325 11.09825,99.31725 10.70725,99.70725 Z\" id=\"redx\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "R26V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R2Sm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GetStartedCards":"GetStartedCards---3MSpy","GetStarted":"GetStarted---1NsZh","GetStartedCards__Icon":"GetStartedCards__Icon---atCb5"};

/***/ }),

/***/ "R33K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select_fast_filter_options__ = __webpack_require__("N+Zm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select_fast_filter_options___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_select_fast_filter_options__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("t++u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("n58A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var TimezonePicker = function (_Component) {
  _inherits(TimezonePicker, _Component);

  function TimezonePicker(props) {
    _classCallCheck(this, TimezonePicker);

    var _this = _possibleConstructorReturn(this, (TimezonePicker.__proto__ || Object.getPrototypeOf(TimezonePicker)).call(this, props));

    _this.getThemeTimezone = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(_this.props, 'orgSettings.theme.timezone', null);
    };

    _this.onTimezoneChanged = function (option) {
      var value = !!option ? option.value : null;
      _this.updateTimezone(value);
    };

    _this.updateTimezone = function (timezone) {
      if (timezone !== null) {
        var initialSettings = _this.props.orgSettings;
        var updatedSettings = _this.updateOrgSettingsWithTimezone(timezone);
        var changes = Object(__WEBPACK_IMPORTED_MODULE_6_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(updatedSettings, initialSettings);

        _this.props.actions.updateOrg(updatedSettings.toJS());
        _this.props.actions.patchEmbed(changes);
      }

      _this.setState({ selectedTimezone: timezone });
    };

    _this.updateOrgSettingsWithTimezone = function (timezone) {
      var orgSettings = _this.props.orgSettings;


      return orgSettings.setIn(['theme', 'timezone'], timezone);
    };

    _this.state = {
      timezoneOptions: Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* getAllTimezoneOptions */])(),
      filteredTimezoneOptions: [Object(__WEBPACK_IMPORTED_MODULE_7__utils__["c" /* getCurrentTimezoneOption */])()].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* MOST_POPULATED_TIMEZONES */])),
      selectedTimezone: _this.getThemeTimezone()
    };
    return _this;
  }

  _createClass(TimezonePicker, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedTimezone = _state.selectedTimezone,
          timezoneOptions = _state.timezoneOptions,
          filteredTimezoneOptions = _state.filteredTimezoneOptions;

      var selectedOption = !!selectedTimezone ? Object(__WEBPACK_IMPORTED_MODULE_7__utils__["d" /* getOptionForTimezone */])(selectedTimezone) : null;
      var filterOptions = __WEBPACK_IMPORTED_MODULE_5_react_select_fast_filter_options___default()({
        indexes: ['label', 'value'],
        options: timezoneOptions
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Select"], {
        size: 'large',
        value: selectedOption,
        options: filteredTimezoneOptions,
        className: 'timezone-picker--select',
        filterOptions: filterOptions,
        onChange: this.onTimezoneChanged
      });
    }
  }]);

  return TimezonePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      updateOrg: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_actions__["updateOrg"],
      patchEmbed: __WEBPACK_IMPORTED_MODULE_9_app_modules_embed_actions__["f" /* patchEmbed */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(null, mapDispatchToProps)(TimezonePicker));

/***/ }),

/***/ "R6PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__ = __webpack_require__("IX9L");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var EndUserTokenStore = Marty.createStore({
  id: 'EndUserTokenStore',

  getInitialState: function getInitialState() {
    return {
      endUserTokens: {}
    };
  },


  handlers: {
    getEndUserTokenDone: __WEBPACK_IMPORTED_MODULE_0_constants_EndUserTokenConstants__["a" /* default */].GET_END_USER_TOKEN_DONE
  },

  getEndUserToken: function getEndUserToken(orgId, email, leadId, userId, version) {
    var key = orgId + '-' + (email || leadId || userId);
    return this.fetch({
      id: 'getEndUserToken' + key,
      locally: function locally() {
        return this.state.endUserTokens[key];
      },
      remotely: function remotely() {
        return this.app.queries.EndUserTokenQueries.getEndUserToken(orgId, email, leadId, userId, version);
      }
    });
  },
  getEndUserTokenDone: function getEndUserTokenDone(orgId, email, leadId, userId, data) {
    var tokens = _.cloneDeep(this.state.endUserTokens);
    tokens[orgId + '-' + (email || leadId || userId)] = data;
    return this.setState({ endUserTokens: tokens });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserTokenStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "R6Pq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("u+jz");










var mapStateToProps = function mapStateToProps(state) {
  return {
    userListIds: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_104" /* userListIds */](state),
    draftId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["p" /* draftId */](state),
    isSaved: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_46" /* isSaved */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      schedulePlaybookDraft: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_117" /* schedulePlaybookDraft */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('scheduleEmailButtonActive', 'setScheduleEmailButtonActive', true), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["j" /* withState */])('emailButtonLabel', 'setEmailButtonLabel', 'Schedule Email'), Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    hasSegmentsSelected: !!props.userListIds && props.userListIds.size
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["c" /* getContext */])({
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  handleScheduleClick: function handleScheduleClick(props) {
    return function () {
      if (!props.onClickConfirm || props.onClickConfirm()) {
        props.setScheduleEmailButtonActive(false);
        props.setEmailButtonLabel('Scheduling...');
        props.actions.schedulePlaybookDraft();
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "R9hW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DemandbaseAudiences; });
var DemandbaseAudiences = Object.freeze([{
  label: 'Enterprise Business',
  value: 'Enterprise Business'
}, {
  label: 'Mid-Market Business',
  value: 'Mid-Market Business'
}, {
  label: 'SMB',
  value: 'SMB'
}, {
  label: 'Government',
  value: 'Government'
}, {
  label: 'Education',
  value: 'Education'
}, {
  label: 'Hospitality',
  value: 'Hospitality'
}, {
  label: 'Residential',
  value: 'Residential'
}, {
  label: 'Wireless',
  value: 'Wireless'
}, {
  label: 'Bot',
  value: 'Bot'
}, {
  label: 'SOHO',
  value: 'SOHO'
}, {
  label: 'Obscured',
  value: 'Obscured'
}]);

/***/ }),

/***/ "RBcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getApiKeyForOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getApiKeyForOrgPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getApiKeyForOrgFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getApiKeyForOrgSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createApiKeyForOrg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createApiKeyForOrgSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createApiKeyForOrgFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createApiKeyForOrgPending; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Q3ha");




var getApiKeyForOrg = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* GET_API_KEY_FOR_ORG */]);
var getApiKeyForOrgPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* GET_API_KEY_FOR_ORG_PENDING */]);
var getApiKeyForOrgFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* GET_API_KEY_FOR_ORG_FAILED */]);
var getApiKeyForOrgSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* GET_API_KEY_FOR_ORG_SUCCESS */]);

var createApiKeyForOrg = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CREATE_API_KEY_FOR_ORG */]);
var createApiKeyForOrgSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_API_KEY_FOR_ORG_SUCCESS */]);
var createApiKeyForOrgFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CREATE_API_KEY_FOR_ORG_FAILED */]);
var createApiKeyForOrgPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_API_KEY_FOR_ORG_PENDING */]);

/***/ }),

/***/ "REqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RH6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export DAY_OPTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("deK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_removeSVGTagAttrs_false_images_svg_dismiss_svg__ = __webpack_require__("z1XD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_removeSVGTagAttrs_false_images_svg_dismiss_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_removeSVGTagAttrs_false_images_svg_dismiss_svg__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var HOUR_LABEL_FORMAT = 'h:mma';
var HOUR_FORMAT = 'H:mm';

var HOUR_OPTIONS = _.range(24).reduce(function (result, hour) {
  var topValue = hour + ':0';
  var midValue = hour + ':30';
  result.push({ value: topValue, label: __WEBPACK_IMPORTED_MODULE_2_moment___default()(topValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT) });
  result.push({ value: midValue, label: __WEBPACK_IMPORTED_MODULE_2_moment___default()(midValue, HOUR_FORMAT).format(HOUR_LABEL_FORMAT) });
  return result;
}, []).concat([{ value: '23:59', label: '12:00AM' }]);

var DAY_OPTIONS = __WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__["c" /* DAY_RANGES */].concat(__WEBPACK_IMPORTED_MODULE_4_components_Customize_Availability_Constants__["a" /* DAYS */]).map(function (day) {
  return {
    label: day.charAt(0) + day.substring(1).toLowerCase(),
    value: day
  };
}).toJS();

var AvailabilitySlotSelect = function (_Component) {
  _inherits(AvailabilitySlotSelect, _Component);

  function AvailabilitySlotSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AvailabilitySlotSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AvailabilitySlotSelect.__proto__ || Object.getPrototypeOf(AvailabilitySlotSelect)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelectDayOfWeek = function (_ref2) {
      var value = _ref2.value;

      _this.props.onSelectDayOfWeek(_this.props.index, value);
    }, _this.handleSelectStartTime = function (_ref3) {
      var value = _ref3.value;

      var _value$split$map = value.split(':').map(function (x) {
        return parseInt(x);
      }),
          _value$split$map2 = _slicedToArray(_value$split$map, 2),
          hour = _value$split$map2[0],
          minutes = _value$split$map2[1];

      _this.props.onSelectStartTime(_this.props.index, { hour: hour, minutes: minutes });
    }, _this.handleSelectEndTime = function (_ref4) {
      var value = _ref4.value;

      var _value$split$map3 = value.split(':').map(function (x) {
        return parseInt(x);
      }),
          _value$split$map4 = _slicedToArray(_value$split$map3, 2),
          hour = _value$split$map4[0],
          minutes = _value$split$map4[1];

      _this.props.onSelectEndTime(_this.props.index, { hour: hour, minutes: minutes });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AvailabilitySlotSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          dayOfWeek = _props.dayOfWeek,
          startTime = _props.startTime,
          endTime = _props.endTime,
          onRemove = _props.onRemove,
          index = _props.index,
          hideRemove = _props.hideRemove;


      var startTimeValue = startTime.hour + ':' + startTime.minutes;
      var endTimeValue = endTime.hour + ':' + endTime.minutes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.TimeSelect },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'day',
          value: dayOfWeek,
          options: DAY_OPTIONS,
          searchable: false,
          clearable: false,
          onChange: this.handleSelectDayOfWeek
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'from'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'time',
          value: startTimeValue,
          options: HOUR_OPTIONS,
          searchable: false,
          clearable: false,
          onChange: this.handleSelectStartTime
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'to'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'time',
          value: endTimeValue,
          options: HOUR_OPTIONS,
          searchable: false,
          clearable: false,
          onChange: this.handleSelectEndTime
        }),
        !hideRemove && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          {
            onClick: function onClick() {
              onRemove(index);
            },
            style: { width: 11, height: 11 }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'availability-remove', src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_removeSVGTagAttrs_false_images_svg_dismiss_svg___default.a })
        )
      );
    }
  }]);

  return AvailabilitySlotSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AvailabilitySlotSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "RKqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__ = __webpack_require__("Wr1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_CookieHelpers__ = __webpack_require__("WB5i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_StatePicker__ = __webpack_require__("8hLx");
/* eslint-disable
    import/default,
    import/named,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


var CONVERSATION_COLLAPSE_STATE_COOKIE = 'conversationCollapseStateByCompanyId';


var CompanyStore = Marty.createStore({
  id: 'CompanyStore',

  getInitialState: function getInitialState() {
    return {
      companiesById: {}
    };
  },


  handlers: {
    fetchCompanyDone: __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_FETCH_DONE,
    fetchCompanyListDone: __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_DONE,

    setCompanyFromPusher: __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].SET_COMPANY_FROM_PUSHER,
    updateCompanyDone: __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_UPDATE_DONE
  },

  getOrFetchCompanyList: function getOrFetchCompanyList() {
    return this.fetch({
      id: 'fetchCompanyList',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchCompanyList')) {
          return this.state.companiesById;
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.CompanyQueries.fetchCompanyListForOrgId(orgId);
      }
    });
  },
  fetchCompanyListDone: function fetchCompanyListDone(companies) {
    var companiesById = _.cloneDeep(this.state.companiesById);
    _.each(companies, function (company) {
      return companiesById[company.id] = company;
    });
    return this.setState({ companiesById: companiesById });
  },
  getCompaniesById: function getCompaniesById() {
    return this.state.companiesById;
  },
  getCompany: function getCompany(companyId) {
    if (companyId > 0) {
      return this.state.companiesById[companyId];
    } else {
      return false;
    }
  },
  getOrFetchCompany: function getOrFetchCompany(companyId) {
    return this.fetch({
      id: 'fetchCompany' + companyId,
      locally: function locally() {
        return this.getCompany(companyId);
      },
      remotely: function remotely() {
        return this.app.queries.CompanyQueries.fetchCompany(companyId);
      }
    });
  },
  fetchCompanyDone: function fetchCompanyDone(companyId, company) {
    return this.setCompany(company);
  },
  fetchCompanies: function fetchCompanies(companyIds) {
    return this.fetch({
      id: 'fetchCompanies' + companyIds,
      locally: function locally() {
        return Object(__WEBPACK_IMPORTED_MODULE_2_utils_StatePicker__["a" /* pickObjects */])(this.state.companiesById, companyIds);
      },
      remotely: function remotely() {
        var _this = this;

        var idsNeedsFetching = _.filter(companyIds, function (companyId) {
          return _this.state.companiesById[companyId] == null;
        });
        return this.app.queries.CompanyQueries.fetchCompaniesByIds(idsNeedsFetching);
      }
    });
  },
  setCompanyFromPusher: function setCompanyFromPusher(company) {
    return this.setCompany(company);
  },
  updateCompanyDone: function updateCompanyDone(company) {
    return this.setCompany(company);
  },
  setCompany: function setCompany(company) {
    var companiesById = _.cloneDeep(this.state.companiesById);
    companiesById[company.id] = company;
    return this.setState({ companiesById: companiesById });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CompanyStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "RLGo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RN02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_false_images_svg_onboarding_slack_laptop_svg__ = __webpack_require__("Lhx5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_false_images_svg_onboarding_slack_laptop_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_false_images_svg_onboarding_slack_laptop_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_curved_arrow_small_svg__ = __webpack_require__("U9xw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_curved_arrow_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_curved_arrow_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("bwU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ProfileDetailsPreview = function (_Component) {
  _inherits(ProfileDetailsPreview, _Component);

  function ProfileDetailsPreview() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProfileDetailsPreview);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileDetailsPreview.__proto__ || Object.getPrototypeOf(ProfileDetailsPreview)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.ProfileDetailsPreview },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.SidebarContainer },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.SlackPreviewContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.PreviewSlackChat }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.PreviewLaptop },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_false_images_svg_onboarding_slack_laptop_svg___default.a })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.ArrowText },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { style: { maxWidth: "200px", textAlign: "center", margin: "0", color: "#FFFFFF" } },
            'This is what Drift notifications look like in slack'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
            src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_curved_arrow_small_svg___default.a,
            style: { margin: "0" }
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return ProfileDetailsPreview;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ProfileDetailsPreview);

/***/ }),

/***/ "RNq+":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMzUzLjggMjYwIDExNC44IDEwMi42Ij48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNDQ0M7c3Ryb2tlLXdpZHRoOjQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kfS5zdDF7c3Ryb2tlLXdpZHRoOjMuNX0uc3QxLC5zdDJ7ZmlsbDpub25lO3N0cm9rZTojQ0NDfS5zdDJ7c3Ryb2tlLXdpZHRoOjR9PC9zdHlsZT48dGl0bGU+R3JvdXA8L3RpdGxlPjxnIGlkPSJQQS1GbG93Ij48ZyBpZD0iV2l6YXJkLS0tVHlwZSI+PGcgaWQ9Ikdyb3VwIj48cGF0aCBpZD0iTGluZS1Db3B5LTEwIiBjbGFzcz0ic3QwIiBkPSJNLTMwOS41IDMzM2g0Ny41Ii8+PHBhdGggaWQ9IlJlY3RhbmdsZS02MSIgY2xhc3M9InN0MSIgZD0iTS0zMzAuNyAzMjZoNy44YzEuNyAwIDMuMSAxLjQgMy4xIDMuMXY3LjhjMCAxLjctMS40IDMuMS0zLjEgMy4xaC03LjhjLTEuNyAwLTMuMS0xLjQtMy4xLTMuMXYtNy44YzAtMS43IDEuNC0zLjEgMy4xLTMuMXoiLz48cGF0aCBpZD0iUmVjdGFuZ2xlLTYxLUNvcHktMyIgY2xhc3M9InN0MiIgZD0iTS0zNDQuOCAyNjVoOTZjMi4yIDAgNCAxLjggNCA0djg1YzAgMi4yLTEuOCA0LTQgNGgtOTZjLTIuMiAwLTQtMS44LTQtNHYtODVjMC0yLjIgMS44LTQgNC00eiIvPjxwYXRoIGlkPSJMaW5lLUNvcHktMTEiIGNsYXNzPSJzdDAiIGQ9Ik0tMzA5LjUgMzEyaDQ3LjUiLz48cGF0aCBpZD0iUmVjdGFuZ2xlLTYxLUNvcHkiIGNsYXNzPSJzdDEiIGQ9Ik0tMzMwLjcgMzA1aDcuOGMxLjcgMCAzLjEgMS40IDMuMSAzLjF2Ny44YzAgMS43LTEuNCAzLjEtMy4xIDMuMWgtNy44Yy0xLjcgMC0zLjEtMS40LTMuMS0zLjF2LTcuOGMwLTEuNyAxLjQtMy4xIDMuMS0zLjF6Ii8+PHBhdGggaWQ9IkxpbmUtQ29weS0xMiIgY2xhc3M9InN0MCIgZD0iTS0zMDkuNSAyOTBoNDcuNSIvPjxwYXRoIGlkPSJSZWN0YW5nbGUtNjEtQ29weS0yIiBjbGFzcz0ic3QxIiBkPSJNLTMzMC43IDI4NGg3LjhjMS43IDAgMy4xIDEuNCAzLjEgMy4xdjcuOGMwIDEuNy0xLjQgMy4xLTMuMSAzLjFoLTcuOGMtMS43IDAtMy4xLTEuNC0zLjEtMy4xdi03LjhjMC0xLjcgMS40LTMuMSAzLjEtMy4xeiIvPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "RP1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("vMFt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var NewRuleConfirmation = function (_Component) {
  _inherits(NewRuleConfirmation, _Component);

  function NewRuleConfirmation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewRuleConfirmation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewRuleConfirmation.__proto__ || Object.getPrototypeOf(NewRuleConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.updateTitle = function (event) {
      _this.props.updateTitle(event.target.value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewRuleConfirmation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // force page validation
      this.props.updateTitle(this.props.rule.data.item.name);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'rules-choice' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'header',
          { className: 'publish-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h1',
            null,
            'Ready to publish your Rule?'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'small',
            null,
            'We recommend giving your rule a name so you can reference it later.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'rule-publish-content drift-form' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], {
            className: 'rule-name-input',
            autoFocus: true,
            type: 'text',
            placeholder: 'Name your rule',
            size: 'large',
            description: '*required',
            value: this.props.rule.data.item.name,
            onChange: this.updateTitle })
        )
      );
    }
  }]);

  return NewRuleConfirmation;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

NewRuleConfirmation.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (NewRuleConfirmation);

/***/ }),

/***/ "RWmt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("j4fR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("HFS5");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var attribs = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchAccountAttribsPending */]), function (state) {
  return state.set('loading', true);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchAccountAttribsCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchAccountAttribsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchAccountAttribsSuccess */]), function (state) {
  return state.set('loading', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchAccountAttribsSuccess */], function (state, action) {
  return state.set('attribs', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(action.payload.map(function (attrib) {
    return new __WEBPACK_IMPORTED_MODULE_4__models__["a" /* Attrib */](attrib);
  })));
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var segments = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* fetchAccountSegmentsPending */]), function (state) {
  return state.set('loading', true);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchAccountSegmentsCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchAccountSegmentsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* fetchAccountSegmentsSuccess */]), function (state) {
  return state.set('loading', false);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* fetchAccountSegmentsSuccess */], function (state, action) {
  return state.set('accountSegments', action.payload);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({ attribs: attribs, segments: segments }));

/***/ }),

/***/ "RXt6":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "RYJX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rbbe":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 22a1 1 0 0 1-.012-2c.294-.01 1.574-.165 1.92-2H20a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4c0 3.955-2.616 5-4 5zm-7 0a1 1 0 0 1-.012-2c.294-.01 1.574-.165 1.92-2H13a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v4c0 3.955-2.616 5-4 5zm-2-12H8a1 1 0 0 1-1-1V5c0-3.955 2.616-5 4-5a1 1 0 0 1 .012 2c-.294.01-1.574.165-1.92 2H11a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-7 0H1a1 1 0 0 1-1-1V5c0-3.955 2.616-5 4-5a1 1 0 0 1 .012 2c-.294.01-1.574.165-1.92 2H4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "RdwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_settings_reply_ComposeReplyModalWrapper__ = __webpack_require__("SWdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_inboxes_ManageInbox__ = __webpack_require__("109c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_UserProfile__ = __webpack_require__("hiGV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_AssistantConfigOrg__ = __webpack_require__("DLlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_reply_ManageSavedReplies__ = __webpack_require__("Dhnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_containers_RulesHome__ = __webpack_require__("k2Sf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_settings_Rules_containers_RulesEditor__ = __webpack_require__("AW3I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Integration_List__ = __webpack_require__("tXUm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Integration_pages_SalesforceMapping__ = __webpack_require__("5qtx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Integration_pages_SalesforceConfig__ = __webpack_require__("snhG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Integration_pages_SalesforceAccountSyncErrors__ = __webpack_require__("idlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Integration_pages_HubspotConfig__ = __webpack_require__("3p/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Integration_pages_MarketoConfig__ = __webpack_require__("gneb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Integration_pages_EloquaConfig__ = __webpack_require__("eHEN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Integration_pages_PardotConfig__ = __webpack_require__("fQjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_Integration_pages_SalesforceUserMapping__ = __webpack_require__("8pQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Integration_pages_SalesforceRoutingSettings__ = __webpack_require__("SMLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Integration_pages_SalesforceMetricsMapping__ = __webpack_require__("5a3S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Integration_pages_MarketoAttributeMapping__ = __webpack_require__("yv8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_Integration_pages_HubspotUserMapping__ = __webpack_require__("zH3L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Integration_pages_HubspotAttributeMapping__ = __webpack_require__("Fhyq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_Integration_pages_EloquaAttributeMapping__ = __webpack_require__("3/+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Integration_pages_EloquaAttributeMappingCdo__ = __webpack_require__("GtGr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Integration_pages_PardotAttributeMapping__ = __webpack_require__("htGL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Integration_pages_IntegrationEventLog__ = __webpack_require__("TAJY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_Integration_PageLayout__ = __webpack_require__("PD3t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_settings_Settings__ = __webpack_require__("sNOP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_settings_conversations__ = __webpack_require__("X4Y0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_settings_advancedConversationSettings__ = __webpack_require__("NjlA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_components_settings_ChatWidget__ = __webpack_require__("Gdnd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_components_settings_ChatWidget_components_HoursAndTargeting__ = __webpack_require__("BO9e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_components_settings_ChatWidget_components_Design__ = __webpack_require__("HkY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_components_settings_ChatWidget_components_WelcomeMessage__ = __webpack_require__("jfJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_components_settings_ChatWidget_components_Advanced__ = __webpack_require__("uYAw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_components_settings_GlobalCalendarSettings__ = __webpack_require__("n8LW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__ = __webpack_require__("QBUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__ = __webpack_require__("LQB/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_components_settings_meetings_routes__ = __webpack_require__("uqpo");












































var createRoutes = function createRoutes(store) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
    { path: 'settings', component: __WEBPACK_IMPORTED_MODULE_28_components_settings_Settings__["a" /* default */] },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* IndexRedirect */], { to: 'team' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'consent/edit/:language', component: function component(route) {
        return window.location.replace('/settings2/consent/edit/' + route.params.language);
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'consent/new', component: function component() {
        return window.location.replace('/settings2/consent/new');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'consent', component: function component() {
        return window.location.replace('/settings2/consent');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'dkim', component: function component() {
        return window.location.replace('/settings2/dkim');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'email', component: function component() {
        return window.location.replace('/settings2/email');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'notifications', component: function component() {
        return window.location.replace('/settings2/notifications');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'notifications/advanced', component: function component() {
        return window.location.replace('/settings2/notifications/advanced');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'account', component: function component() {
        return window.location.replace('/settings2/account');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'assistant', component: function component() {
        return window.location.replace('/settings2/assistant');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'profile', component: function component() {
        return window.location.replace('/settings2/profile');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'assistant/org', component: __WEBPACK_IMPORTED_MODULE_5_components_settings_AssistantConfigOrg__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'teams', component: function component() {
        return window.location.replace('/settings2/teams');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'teams/:teamId', component: function component(route) {
        return window.location.replace('/settings2/teams/' + route.params.teamId);
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'company', component: function component() {
        return window.location.replace('/settings2/company');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'team', component: function component() {
        return window.location.replace('/settings2/team');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'billing', component: function component() {
        return window.location.replace('/settings2/billing');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'routing', to: 'bot' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'driftbot', to: 'bot' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'bot', component: function component() {
        return window.location.replace('/settings2/bot');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'rules', component: __WEBPACK_IMPORTED_MODULE_7_components_settings_Rules_containers_RulesHome__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'rules/:ruleId', component: __WEBPACK_IMPORTED_MODULE_8_components_settings_Rules_containers_RulesEditor__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'manage-inboxes/:inboxId', component: __WEBPACK_IMPORTED_MODULE_3_components_settings_inboxes_ManageInbox__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'team/user-logs', component: function component() {
        return window.location.replace('/settings2/user-logs');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: ':integrationId/event-log', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateCheckerThroughProps(__WEBPACK_IMPORTED_MODULE_26_components_Integration_pages_IntegrationEventLog__["a" /* default */]) }),
    Object(__WEBPACK_IMPORTED_MODULE_40_components_settings_meetings_routes__["a" /* Routes */])(store),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'conversations/advanced', component: function component() {
        return window.location.replace('/settings2/conversations/advanced');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'conversations', component: function component() {
        return window.location.replace('/settings2/conversations');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
      { path: 'widget', component: __WEBPACK_IMPORTED_MODULE_31_components_settings_ChatWidget__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'hours-and-targeting', component: __WEBPACK_IMPORTED_MODULE_32_components_settings_ChatWidget_components_HoursAndTargeting__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'design', component: __WEBPACK_IMPORTED_MODULE_33_components_settings_ChatWidget_components_Design__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'default-greeting', component: __WEBPACK_IMPORTED_MODULE_34_components_settings_ChatWidget_components_WelcomeMessage__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'welcome-message', to: 'default-greeting' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'advanced', component: __WEBPACK_IMPORTED_MODULE_35_components_settings_ChatWidget_components_Advanced__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
      { path: 'replies', component: __WEBPACK_IMPORTED_MODULE_6_components_settings_reply_ManageSavedReplies__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'compose/:replyId', component: __WEBPACK_IMPORTED_MODULE_2_components_settings_reply_ComposeReplyModalWrapper__["a" /* default */] })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'integrations', component: __WEBPACK_IMPORTED_MODULE_9_components_Integration_List__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'authentication', component: function component() {
        return window.location.replace('/settings2/security');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'security', component: function component() {
        return window.location.replace('/settings2/security');
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'global/calendars', component: __WEBPACK_IMPORTED_MODULE_36_components_settings_GlobalCalendarSettings__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'setup/:integrationId', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateCheckerThroughProps(__WEBPACK_IMPORTED_MODULE_27_components_Integration_PageLayout__["a" /* default */]) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/routing', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_18_components_Integration_pages_SalesforceRoutingSettings__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/mapping/attributes', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_10_components_Integration_pages_SalesforceMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/mapping/attributes/metrics', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_19_components_Integration_pages_SalesforceMetricsMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/mapping/users', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_17_components_Integration_pages_SalesforceUserMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/config', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_11_components_Integration_pages_SalesforceConfig__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'salesforce/config/account-sync-errors', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_12_components_Integration_pages_SalesforceAccountSyncErrors__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].SALESFORCE) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'hubspot/config', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_13_components_Integration_pages_HubspotConfig__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].HUBSPOT) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'hubspot/mapping/attributes', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_22_components_Integration_pages_HubspotAttributeMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].HUBSPOT) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'hubspot/mapping/users', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_21_components_Integration_pages_HubspotUserMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].HUBSPOT) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'marketo/config', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_14_components_Integration_pages_MarketoConfig__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].MARKETO) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'marketo/mapping/attributes', component: __WEBPACK_IMPORTED_MODULE_39_app_utils_gateChecker__["a" /* default */].applyGateChecker(__WEBPACK_IMPORTED_MODULE_20_components_Integration_pages_MarketoAttributeMapping__["a" /* default */], __WEBPACK_IMPORTED_MODULE_38_components_Integration_ListConstants_js__["b" /* IntegrationIds */].MARKETO) }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'eloqua/config', component: __WEBPACK_IMPORTED_MODULE_15_components_Integration_pages_EloquaConfig__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'eloqua/mapping/attributes', component: __WEBPACK_IMPORTED_MODULE_23_components_Integration_pages_EloquaAttributeMapping__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'eloqua/mapping/attributes/cdo', component: __WEBPACK_IMPORTED_MODULE_24_components_Integration_pages_EloquaAttributeMappingCdo__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'pardot/config', component: __WEBPACK_IMPORTED_MODULE_16_components_Integration_pages_PardotConfig__["a" /* default */],
      onEnter: function onEnter(nextState, replace) {
        if (!__WEBPACK_IMPORTED_MODULE_37_utils_Access__["c" /* default */].hasGates('HAS_PARDOT')) {
          replace('/integrations');
        }
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: 'pardot/mapping/attributes', component: __WEBPACK_IMPORTED_MODULE_25_components_Integration_pages_PardotAttributeMapping__["a" /* default */],
      onEnter: function onEnter(nextState, replace) {
        if (!__WEBPACK_IMPORTED_MODULE_37_utils_Access__["c" /* default */].hasGates('HAS_PARDOT')) {
          replace('/integrations');
        }
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'apps', to: 'integrations' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'tags', to: 'conversations' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'manage-inboxes', to: 'conversations' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { from: 'livechat', to: 'widget' })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (createRoutes);

/***/ }),

/***/ "Ret+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgxK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ri9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rjoa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vidyard-logo-text.d7932cb5.png";

/***/ }),

/***/ "RjrD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_color__ = __webpack_require__("orX9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("wgR7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var Picker = __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default()(function (_ref) {
  var onClickOutside = _ref.onClickOutside,
      rest = _objectWithoutProperties(_ref, ['onClickOutside']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_color__["ChromePicker"], rest);
});

var ColorInput = function (_Component) {
  _inherits(ColorInput, _Component);

  function ColorInput() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ColorInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ColorInput.__proto__ || Object.getPrototypeOf(ColorInput)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      showPicker: false
    }, _this.handleHexChange = function (event) {
      return _this.changeColor(event.target.value);
    }, _this.handleColorPickerChange = function (_ref3) {
      var hex = _ref3.hex;
      return _this.changeColor(hex);
    }, _this.handlePaletteClick = function () {
      _this.setState({ showPicker: !_this.state.showPicker });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ColorInput, [{
    key: 'changeColor',
    value: function changeColor(hex) {
      var onChange = this.props.onChange;

      var fixedHex = hex.replace('#', '');
      onChange && onChange(fixedHex);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          onChange = _props.onChange,
          valid = _props.valid,
          rest = _objectWithoutProperties(_props, ['color', 'onChange', 'valid']);

      var showPicker = this.state.showPicker;

      var extraClassNames = {
        white: color.toLowerCase() === 'ffffff',
        invalid: !valid
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a['color-input'], this.props.size, extraClassNames) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a,
          _extends({}, rest, {
            isValid: valid,
            value: color,
            onChange: this.handleHexChange,
            childrenFirst: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: 'palette',
            style: { backgroundColor: '#' + color },
            onClick: this.handlePaletteClick
          }),
          showPicker && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picker, {
            color: color,
            onChangeComplete: this.handleColorPickerChange,
            disableAlpha: true,
            onClickOutside: this.handlePaletteClick
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('color-input-hash', this.props.size) },
            '#'
          )
        ),
        !valid && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'color-input-error' },
          'Invalid Hex'
        )
      );
    }
  }]);

  return ColorInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ColorInput.defaultProps = {
  color: '2d88f3',
  valid: true
};
ColorInput.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.string,
  onChange: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.func,
  valid: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.bool
};
/* harmony default export */ __webpack_exports__["a"] = (ColorInput);

/***/ }),

/***/ "RkbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Card__ = __webpack_require__("CsAK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styl__ = __webpack_require__("y7ir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var Card = function Card(_ref) {
  var className = _ref.className,
      rest = _objectWithoutProperties(_ref, ['className']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Card__["a" /* default */], _extends({ className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_styl___default.a.Card, className) }, rest));
};

/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),

/***/ "RoXl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RtjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_HUBSPOT_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_HUBSPOT_USERS_SEARCH_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_HUBSPOT_USERS_SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_HUBSPOT_USERS_SEARCH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_HUBSPOT_USER_MAPPINGS_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_HUBSPOT_USER_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PATCH_HUBSPOT_USER_MAPPINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PATCH_HUBSPOT_USER_MAPPINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_HUBSPOT_BY_EMAIL_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_HUBSPOT_BY_EMAIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_HUBSPOT_BY_EMAIL_SUCCESS; });
var FETCH_HUBSPOT_FIELDS_SUCCESS = 'FETCH_HUBSPOT_FIELDS_SUCCESS';
var FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS = 'FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS';
var PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR';
var PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS';
var PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START = 'PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START';

var FETCH_HUBSPOT_USERS_SEARCH_START = 'FETCH_HUBSPOT_USERS_SEARCH_START';
var FETCH_HUBSPOT_USERS_SEARCH_SUCCESS = 'FETCH_HUBSPOT_USERS_SEARCH_SUCCESS';
var FETCH_HUBSPOT_USERS_SEARCH_ERROR = 'FETCH_HUBSPOT_USERS_SEARCH_ERROR';

var FETCH_HUBSPOT_USER_MAPPINGS_STARTED = 'FETCH_HUBSPOT_USER_MAPPINGS_STARTED';
var FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS = 'FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS';
var FETCH_HUBSPOT_USER_MAPPINGS_ERROR = 'FETCH_HUBSPOT_USER_MAPPINGS_ERROR';

var PATCH_HUBSPOT_USER_MAPPINGS_FAILED = 'PATCH_HUBSPOT_USER_MAPPINGS_FAILED';
var PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS = 'PATCH_HUBSPOT_USER_MAPPINGS_SUCCESS';
var PATCH_HUBSPOT_USER_MAPPINGS_START = 'PATCH_HUBSPOT_USER_MAPPINGS';

var FETCH_HUBSPOT_BY_EMAIL_STARTED = 'FETCH_HUBSPOT_BY_EMAIL_STARTED';
var FETCH_HUBSPOT_BY_EMAIL_FAILED = 'FETCH_HUBSPOT_BY_EMAIL_FAILED';
var FETCH_HUBSPOT_BY_EMAIL_SUCCESS = 'FETCH_HUBSPOT_BY_EMAIL_SUCCESS';

/***/ }),

/***/ "RuZ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isParticipantEvent */
/* unused harmony export isRoutingFailedEvent */
/* harmony export (immutable) */ __webpack_exports__["a"] = isBackendGenerated;
/* unused harmony export isEmailCaptureMessage */
/* harmony export (immutable) */ __webpack_exports__["b"] = isEmptyGoalMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = isFirstBotInteractionMessage;
/* unused harmony export isEditMessage */
/* unused harmony export isChatRating */
/* unused harmony export shouldNotifyUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_UserTypes__ = __webpack_require__("p1Ml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("x/uU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_access_helpers__ = __webpack_require__("5TTc");




function emptyMessage(message) {
  var type = message.type,
      body = message.body,
      attachments = message.attachments;


  return type === __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* NotifiableMessageTypes */].CHAT && body && body.length === 0 && attachments && attachments.count() === 0;
}

function isParticipantEvent(message) {
  var contentType = message.contentType,
      conversationEvent = message.conversationEvent;


  return contentType === "CONVERSATION_EVENT" && !!conversationEvent.participantChangeType;
}

function isRoutingFailedEvent(message) {
  var contentType = message.contentType,
      conversationEvent = message.conversationEvent;

  return contentType === "CONVERSATION_EVENT" && conversationEvent.type === "ROUTING_FAILED";
}

function isBackendGenerated(message) {
  var authorId = message.authorId,
      conversationEvent = message.conversationEvent;

  return authorId === 0 && conversationEvent.type !== 'END_USER_PROPERTY_ALREADY_PRESENT' && !isParticipantEvent(message) && !isRoutingFailedEvent(message);
}

function isEmailCaptureMessage(message) {
  return message.getIn(['attributes', 'show_email_capture_card'], false);
}

function isEmptyGoalMessage(message) {
  return message.getIn(["attributes", "goalReached"], false) && message.get("body") === "";
}

function isFirstBotInteractionMessage(message) {
  return message.getIn(['attributes', 'startInteraction'], false) && (message.get('authorType') === __WEBPACK_IMPORTED_MODULE_0_utils_UserTypes__["b" /* UserTypes */].END_USER || message.get('authorType') === __WEBPACK_IMPORTED_MODULE_0_utils_UserTypes__["b" /* UserTypes */].LEAD);
}

function isEditMessage(message) {
  return message.type === 'EDIT' || message.getIn(['attributes', 'editedMessageId'], false);
}

var isChatRating = function isChatRating(message) {
  return message.type === 'CHAT_RATING';
};

function shouldNotifyUser(message, conversation, currentUser, userProperties) {
  var hasCentralizedRouting = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (!Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_access_helpers__["b" /* hasConversationAccess */])(conversation.participantIds, currentUser)) {
    return false;
  }

  if (hasCentralizedRouting) {
    if (userProperties.get('notifications-snoozed')) {
      return false;
    }
  } else {
    if (currentUser.availability === "OFFLINE") {
      return false;
    }
  }

  var browserNotificationSetting = userProperties.get('humane-notifications-browser', 'nothing');
  var browserNotificationsAll = browserNotificationSetting === 'all';
  var browserNotificationsUnassigned = browserNotificationSetting === 'mine-and-unassigned';
  var browserNotificationsOnlyMine = browserNotificationSetting === 'mine';

  var isParticipant = conversation.participantIds.includes(currentUser.id);
  var isMine = message.authorType === 'USER' && currentUser.id === message.authorId;
  var isNotifiableType = !!__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* NotifiableMessageTypes */][message.type];

  if (!isMine && !emptyMessage(message) && isNotifiableType) {
    if (conversation.status === "BULK_SENT") return false;

    return browserNotificationsAll || browserNotificationsUnassigned && (isParticipant || !conversation.participantIds.count()) || browserNotificationsOnlyMine && isParticipant;
  }

  return false;
}

/***/ }),

/***/ "Rvc/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzUiIGhlaWdodD0iODMiIHZpZXdCb3g9IjAgMCA3NSA4MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+T3ZhbDwvdGl0bGU+PHBhdGggZD0iTTkuMDM2IDQxLjExNEM5LjAzNiAyMy4zIDIxLjg5IDkuMDM2IDM3LjUgOS4wMzZjMTUuNjEgMCAyOC40NjQgMTQuMjYzIDI4LjQ2NCAzMi4wNzggMCA1LjQ3NS0xLjIxNyAxMC43MzgtMy41MDMgMTUuNDItMS4wOTMgMi4yNDMtLjE2MiA0Ljk0OCAyLjA4IDYuMDQzIDIuMjQzIDEuMDk0IDQuOTQ4LjE2MyA2LjA0Mi0yLjA4QzczLjQ3IDU0LjU4MyA3NSA0Ny45NjQgNzUgNDEuMTE1IDc1IDE4LjUwNiA1OC4zMiAwIDM3LjUgMFMwIDE4LjUwNiAwIDQxLjExNEMwIDYzLjcyNCAxNi42OCA4Mi4yMyAzNy41IDgyLjIzYzIuNDk1IDAgNC41MTgtMi4wMjQgNC41MTgtNC41MiAwLTIuNDk0LTIuMDIzLTQuNTE3LTQuNTE4LTQuNTE3LTE1LjYxIDAtMjguNDY0LTE0LjI2My0yOC40NjQtMzIuMDh6IiBmaWxsPSIjMzk5MUUyIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "S03J":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+Q2xvc2U8L3RpdGxlPjxwYXRoIGQ9Ik04LjgxOCAxMkwuNjU4IDMuODRBMi4yNSAyLjI1IDAgMCAxIDMuODQyLjY2TDEyIDguODE3bDguMTYtOC4xNmEyLjI1IDIuMjUgMCAwIDEgMy4xOCAzLjE4M0wxNS4xODMgMTJsOC4xNiA4LjE2YTIuMjUgMi4yNSAwIDAgMS0zLjE4MyAzLjE4TDEyIDE1LjE4M2wtOC4xNiA4LjE2YTIuMjUgMi4yNSAwIDAgMS0zLjE4LTMuMTgzTDguODE3IDEyeiIgZmlsbD0iIzAwMCIgb3BhY2l0eT0iLjIiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "S0Pm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAppInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAppInfoFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAppCodeFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("5JuT");


var appInfo = function appInfo(state) {
  return state.get('externalApp').appInfo;
};
var appCodes = function appCodes(state) {
  return state.get('externalApp').appCodes;
};
var status = function status(state) {
  return state.get('externalApp').status;
};

var getAppInfo = function getAppInfo(clientId, state) {
  return appInfo(state).get(clientId);
};
var getAppCode = function getAppCode(clientId, state) {
  return appCodes(state).get(clientId);
};

var getAppInfoFailed = function getAppInfoFailed(clientId, state) {
  return status(state).getIn(['appInfo', clientId]) === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_OAUTH_APP_INFO_FAILED */];
};
var getAppCodeFailed = function getAppCodeFailed(clientId, state) {
  return status(state).getIn(['appCode', clientId]) === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* FETCH_OAUTH_CODE_FAILED */];
};

/***/ }),

/***/ "S2Kx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OAuthConnect":"OAuthConnect---2897I"};

/***/ }),

/***/ "S2pE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("HGQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_live_default_company_logo_svg__ = __webpack_require__("lZSu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_live_default_company_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_live_default_company_logo_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var CompanyAvatar = function (_Component) {
  _inherits(CompanyAvatar, _Component);

  function CompanyAvatar() {
    _classCallCheck(this, CompanyAvatar);

    return _possibleConstructorReturn(this, (CompanyAvatar.__proto__ || Object.getPrototypeOf(CompanyAvatar)).apply(this, arguments));
  }

  _createClass(CompanyAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          companyName = _props.companyName,
          logoUrl = _props.logoUrl;


      if (!logoUrl) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style__["placeholderAvatar"], className) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_live_default_company_logo_svg___default.a })
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style__["companyAvatar"], className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core__["Avatar"], { company: { name: companyName, logo: logoUrl }, type: 'company', size: 'small' })
      );
    }
  }]);

  return CompanyAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyAvatar);

/***/ }),

/***/ "S6Q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, fetch) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_UserStatusEnum__ = __webpack_require__("7XD2");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.






var UserAPI = Marty.createStateSource({
  id: 'UserAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  createUserWithEmail: function createUserWithEmail(email) {
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var body = { email: email };
    if (password != null) {
      body.password = password;
    }

    return this.post({
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      url: '/users?clientId=' + __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["f" /* CLIENT_ID */],
      body: JSON.stringify(body)
    });
  },
  sendWelcomeEmail: function sendWelcomeEmail(isMobile) {
    if (isMobile == null) {
      isMobile = true;
    }
    return this.post({
      url: '/users/welcome?mobile=' + isMobile,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON
    });
  },
  fetchUser: function fetchUser(userId) {
    return this.get({
      url: '/users/' + userId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchUsersForOrgId: function fetchUsersForOrgId(orgId) {
    return this.get({
      url: '/organizations/' + orgId + '/users?status=INVITED&status=ENABLED',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCurrentLoggedInUser: function fetchCurrentLoggedInUser() {
    return this.get({
      url: '/users/me',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  getUserExistsByEmail: function getUserExistsByEmail(email) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["h" /* serializeObject */])({ email: email });
    return fetch(this.baseUrl + '/users/?' + queryParams, {
      method: 'HEAD'
    });
  },
  getUserExistsByEmailAndOrgHandle: function getUserExistsByEmailAndOrgHandle(email, orgHandle) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["h" /* serializeObject */])({ email: email, orgHandle: orgHandle });
    return fetch(this.baseUrl + '/users/?' + queryParams, {
      method: 'HEAD'
    });
  },
  updateUser: function updateUser(userId, params) {
    return this.patch({
      url: '/users/' + userId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(params)
    });
  },
  changePassword: function changePassword(userId, password) {
    return this.post({
      url: '/users/' + userId + '/password?clientId=' + __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["f" /* CLIENT_ID */],
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify({
        password: password
      })
    });
  },
  uploadUserAvatar: function uploadUserAvatar(userId, file) {
    var data = new FormData();
    data.append('file', file);
    return this.post({
      url: '/users/' + userId + '/avatar',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].FORM_DATA,
      body: data
    });
  },
  archiveUser: function archiveUser(userId) {
    return this.patch({
      url: '/users/' + userId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify({ status: __WEBPACK_IMPORTED_MODULE_2_constants_UserStatusEnum__["a" /* default */].ARCHIVED.key })
    });
  },
  archiveUsers: function archiveUsers(_ref) {
    var orgId = _ref.orgId,
        userIds = _ref.userIds;

    return this.delete({
      url: 'organizations/' + orgId + '/users',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(userIds)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("LC9V")))

/***/ }),

/***/ "SAM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isWindows10Check */
/* unused harmony export isFirefoxCheck */
/* unused harmony export isChromeCheck */
/* unused harmony export isSafariCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIosCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMobileCheck; });
/* unused harmony export isAndroidCheck */
/* unused harmony export setServerSideHeaders */
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var serverSideHeaders = false;

var getUserAgent = function getUserAgent() {
  var userAgent = false;
  // if we are on the client side, use the browser's context
  if (typeof navigator !== 'undefined' && navigator !== null || typeof window !== 'undefined' && window !== null) {
    userAgent = navigator.userAgent || navigator.vendor || window.opera;
  } else {
    userAgent = serverSideHeaders != null ? serverSideHeaders['user-agent'] : undefined;
  }
  return userAgent;
};

var isWindows10Check = function isWindows10Check() {
  var userAgent = getUserAgent();
  return (/Windows NT 10\.\d+;/.test(userAgent)
  );
};

var isFirefoxCheck = function isFirefoxCheck() {
  var userAgent = getUserAgent();
  return (/Firefox\/\S+/.test(userAgent) && !/Seamonkey\/\S+/.test(userAgent)
  );
};

var isChromeCheck = function isChromeCheck() {
  var userAgent = getUserAgent();
  return (/Chrome\/\S+/.test(userAgent) && !/Chromium\/\S+/.test(userAgent)
  );
};

var isSafariCheck = function isSafariCheck() {
  var userAgent = getUserAgent();
  return (/Safari\/\S+/.test(userAgent) && !/Chrome\/\S+/.test(userAgent) && !/Chromium\/\S+/.test(userAgent)
  );
};

var isIosCheck = function isIosCheck() {
  var userAgent = getUserAgent();
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroidCheck = function isAndroidCheck() {
  var userAgent = getUserAgent();
  return (/Android/.test(userAgent) && !window.MSStream
  );
};

var isMobileCheck = function isMobileCheck() {
  var check = false;
  var userAgent = getUserAgent();
  // staging and prod is on cloudfront which has its own headers
  if (['PRODUCTION', 'MASTER'].includes(__ENV__) && serverSideHeaders && serverSideHeaders['cloudfront-is-mobile-viewer'] != null) {
    check = serverSideHeaders['cloudfront-is-mobile-viewer'];
    check = JSON.parse(check);
  } else if (userAgent) {
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
        return check = true;
      }
    })(userAgent);
  }
  return check;
};

var setServerSideHeaders = function setServerSideHeaders(headers) {
  return serverSideHeaders = headers;
};



/***/ }),

/***/ "SAet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['B2B', 'B2C', 'E-Commerce', 'Enterprise', 'ISP', 'Marketplace', 'Mobile', 'SAAS', '3D Printing', 'Accounting', 'Aerospace & Defense', 'Agriculture', 'Airlines', 'Alternative Medicine', 'Animation', 'Apparel & Fashion', 'Apparel & Footwear', 'Architecture', 'Arts', 'Arts & Crafts', 'Asset Management', 'Audio', 'Automation', 'Automotive', 'Banking & Mortgages', 'Beverages', 'Biotechnology', 'Broadband', 'Broadcasting', 'Building Materials', 'Business Supplies', 'Chemicals', 'Civil Engineering', 'Cloud Services', 'Communications', 'Computer Hardware', 'Computer Networking', 'Construction', 'Consulting & Professional Services', 'Consumer Discretionary', 'Consumer Electronics', 'Consumer Goods', 'Consumer Staples', 'Corporate & Business', 'Cosmetics', 'Design', 'E-Commerce & Marketplaces', 'E-Learning', 'Education', 'Electrical', 'Energy', 'Entertainment & Recreation', 'Eyewear', 'Facilities', 'Family Services', 'Finance', 'Financial Services', 'Fine Art', 'Fishery', 'Food', 'Food Production', 'Food, Beverage & Tobacco', 'Fundraising', 'Gambling & Casinos', 'Graphic Design', 'Ground Transportation', 'Health & Wellness', 'Health Care', 'Higher Education', 'Home & Furniture', 'Home Improvement', 'Human Resources', 'Import & Export', 'Industrials & Manufacturing', 'Information Technology & Services', 'Insurance', 'International Relations', 'International Trade', 'Internet', 'Investment', 'Investment Banking', 'Investment Management', 'Jewelry, Watches & Luxury Goods', 'Legal Services', 'Libraries', 'Machinery', 'Maritime', 'Market Research', 'Marketing & Advertising', 'Mechanical Engineering', 'Media', 'Medicine', 'Military', 'Mining & Metals', 'Mobile', 'Movies & TV', 'Museums', 'Music', 'Nanotechnology', 'Oil & Gas', 'Outsourcing', 'Packaging & Containers', 'Paper Goods', 'Payments', 'Pharmaceuticals', 'Pharmacy', 'Photography', 'Plastics', 'Plumbing', 'Pornography', 'Primary & Secondary Education', 'Printing', 'Public Relations', 'Publishing', 'Ranching', 'Real Estate', 'Renewable Energy', 'Renewables & Environment', 'Research', 'Restaurants', 'Retail', 'Security', 'Services', 'Shipbuilding', 'Shipping & Logistics', 'Sporting Goods', 'Sports & Fitness', 'Supermarkets', 'Talent Agencies', 'Technology', 'Telecommunications', 'Textiles', 'Tobacco', 'Tools', 'Translation', 'Transportation', 'Travel & Leisure', 'Utilities', 'Venture Capital', 'Veterinary', 'Video Games', 'Wholesale', 'Wireless']);

/***/ }),

/***/ "SCc4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Segment":"Segment---1X_tn"};

/***/ }),

/***/ "SDtC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__ = __webpack_require__("wFBz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_teams_actions__ = __webpack_require__("YWXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");










var mapStateToProps = function mapStateToProps(state) {
  return {
    teams: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["d" /* teams */])(state),
    teamsOptions: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["e" /* teamsOptions */])(state),
    doFetchOrgUsers: !Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["orgUsersLoaded"])(state) && !Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["orgUsersLoading"])(state),
    doFetchOrgTeams: !Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["b" /* fetchTeamsSuccess */])(state) && !Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["a" /* fetchTeamsPending */])(state),
    teamsWithMemberAvailability: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_teams_selectors__["f" /* teamsWithMemberAvailability */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchOrgTeams: __WEBPACK_IMPORTED_MODULE_4_app_modules_teams_actions__["m" /* fetchOrgTeams */],
      fetchOrgUsers: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__["fetchOrgUsers"]
    }, dispatch)
  };
};

var withOrgTeams = function withOrgTeams(WrappedComponent) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
    componentDidMount: function componentDidMount() {
      var _props = this.props,
          actions = _props.actions,
          doFetchOrgTeams = _props.doFetchOrgTeams,
          doFetchOrgUsers = _props.doFetchOrgUsers;

      if (doFetchOrgTeams) {
        actions.fetchOrgTeams();
      }
      if (doFetchOrgUsers) {
        actions.fetchOrgUsers(); // for user availability status
      }
    }
  }))(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (withOrgTeams);

/***/ }),

/***/ "SFGn":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "SHj4":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 1993 504\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"slack-logo-with-name\" transform=\"translate(-2.000000, -2.000000)\"><g id=\"Group\" transform=\"translate(637.915663, 8.015748)\" fill=\"#000000\"><path d=\"M2.0060241,390.767717 L26.8807229,333.054331 C53.7614458,353.093701 89.4686747,363.514173 124.774699,363.514173 C150.853012,363.514173 167.30241,353.494488 167.30241,338.264567 C166.901205,295.781102 11.2337349,329.046457 10.0301205,222.437008 C9.62891566,168.330709 57.773494,126.648819 125.978313,126.648819 C166.5,126.648819 207.021687,136.668504 235.908434,159.513386 L212.638554,218.429134 C186.159036,201.596063 153.260241,189.572441 121.966265,189.572441 C100.70241,189.572441 86.660241,199.592126 86.660241,212.417323 C87.0614458,254.099213 243.93253,231.254331 245.537349,333.054331 C245.537349,388.362992 198.596386,427.23937 131.193976,427.23937 C81.8457831,427.23937 36.5096386,415.616535 2.0060241,390.767717\" id=\"Path\"></path><path d=\"M956.472289,312.213386 C944.03494,333.855906 920.76506,348.685039 893.884337,348.685039 C854.16506,348.685039 822.068675,316.622047 822.068675,276.944094 C822.068675,237.266142 854.16506,205.20315 893.884337,205.20315 C920.76506,205.20315 944.03494,220.032283 956.472289,241.674803 L1025.07831,203.6 C999.401205,157.910236 950.053012,126.648819 893.884337,126.648819 C810.83494,126.648819 743.43253,193.981102 743.43253,276.944094 C743.43253,359.907087 810.83494,427.23937 893.884337,427.23937 C950.454217,427.23937 999.401205,396.37874 1025.07831,350.288189 L956.472289,312.213386 Z\" id=\"Path\"></path><rect id=\"Rectangle\" x=\"280.040964\" y=\"2.00393701\" width=\"85.8578313\" height=\"419.624409\"></rect><polygon id=\"Path\" points=\"1058.77952 2.00393701 1058.77952 421.628346 1144.63735 421.628346 1144.63735 295.781102 1246.54337 421.628346 1356.47349 421.628346 1226.88434 272.134646 1346.84458 132.66063 1241.72892 132.66063 1144.63735 248.488189 1144.63735 2.00393701\"></polygon><path d=\"M621.06506,313.014961 C608.627711,333.455118 582.950602,348.685039 554.063855,348.685039 C514.344578,348.685039 482.248193,316.622047 482.248193,276.944094 C482.248193,237.266142 514.344578,205.20315 554.063855,205.20315 C582.950602,205.20315 608.627711,221.234646 621.06506,242.075591 L621.06506,313.014961 Z M621.06506,132.66063 L621.06506,166.727559 C607.022892,143.081102 572.118072,126.648819 535.608434,126.648819 C460.181928,126.648819 400.803614,193.179528 400.803614,276.543307 C400.803614,359.907087 460.181928,427.23937 535.608434,427.23937 C572.118072,427.23937 607.022892,410.807087 621.06506,387.16063 L621.06506,421.227559 L706.922892,421.227559 L706.922892,132.66063 L621.06506,132.66063 Z\" id=\"Shape\" fill-rule=\"nonzero\"></path></g><g id=\"Group\"><g transform=\"translate(0.000000, 264.519685)\" fill=\"#E01E5A\" id=\"Path\"><path d=\"M109.127711,56.1102362 C109.127711,85.3677165 85.4566265,109.014173 56.1686747,109.014173 C26.8807229,109.014173 3.20963855,85.3677165 3.20963855,56.1102362 C3.20963855,26.8527559 26.8807229,3.20629921 56.1686747,3.20629921 L109.127711,3.20629921 L109.127711,56.1102362 Z\"></path><path d=\"M135.607229,56.1102362 C135.607229,26.8527559 159.278313,3.20629921 188.566265,3.20629921 C217.854217,3.20629921 241.525301,26.8527559 241.525301,56.1102362 L241.525301,188.370079 C241.525301,217.627559 217.854217,241.274016 188.566265,241.274016 C159.278313,241.274016 135.607229,217.627559 135.607229,188.370079 L135.607229,56.1102362 Z\"></path></g><g fill=\"#36C5F0\" id=\"Path\"><path d=\"M188.566265,108.212598 C159.278313,108.212598 135.607229,84.5661417 135.607229,55.3086614 C135.607229,26.0511811 159.278313,2.40472441 188.566265,2.40472441 C217.854217,2.40472441 241.525301,26.0511811 241.525301,55.3086614 L241.525301,108.212598 L188.566265,108.212598 Z\"></path><path d=\"M188.566265,135.065354 C217.854217,135.065354 241.525301,158.711811 241.525301,187.969291 C241.525301,217.226772 217.854217,240.873228 188.566265,240.873228 L55.7674699,240.873228 C26.4795181,240.873228 2.80843373,217.226772 2.80843373,187.969291 C2.80843373,158.711811 26.4795181,135.065354 55.7674699,135.065354 L188.566265,135.065354 Z\"></path></g><g transform=\"translate(264.795181, 0.000000)\" fill=\"#2EB67D\" id=\"Path\"><path d=\"M136.008434,187.969291 C136.008434,158.711811 159.679518,135.065354 188.96747,135.065354 C218.255422,135.065354 241.926506,158.711811 241.926506,187.969291 C241.926506,217.226772 218.255422,240.873228 188.96747,240.873228 L136.008434,240.873228 L136.008434,187.969291 Z\"></path><path d=\"M109.528916,187.969291 C109.528916,217.226772 85.8578313,240.873228 56.5698795,240.873228 C27.2819277,240.873228 3.61084337,217.226772 3.61084337,187.969291 L3.61084337,55.3086614 C3.61084337,26.0511811 27.2819277,2.40472441 56.5698795,2.40472441 C85.8578313,2.40472441 109.528916,26.0511811 109.528916,55.3086614 L109.528916,187.969291 Z\"></path></g><g transform=\"translate(264.795181, 264.519685)\" fill=\"#ECB22E\" id=\"Path\"><path d=\"M56.5698795,135.466142 C85.8578313,135.466142 109.528916,159.112598 109.528916,188.370079 C109.528916,217.627559 85.8578313,241.274016 56.5698795,241.274016 C27.2819277,241.274016 3.61084337,217.627559 3.61084337,188.370079 L3.61084337,135.466142 L56.5698795,135.466142 Z\"></path><path d=\"M56.5698795,109.014173 C27.2819277,109.014173 3.61084337,85.3677165 3.61084337,56.1102362 C3.61084337,26.8527559 27.2819277,3.20629921 56.5698795,3.20629921 L189.368675,3.20629921 C218.656627,3.20629921 242.327711,26.8527559 242.327711,56.1102362 C242.327711,85.3677165 218.656627,109.014173 189.368675,109.014173 L56.5698795,109.014173 Z\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "SKH6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(209);

/***/ }),

/***/ "SKr3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return receiveEndUserCompanyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBulkConversationEnrichmentDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchEnrichedCompanyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchEnrichedCompanyDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchEnrichedCompanyDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchEnrichedCompanyDataNoResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchEnrichedCompanyDataFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchEnrichedCompanyDataCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDecodedCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchDecodedConditionPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDecodedConditionFailed; });
/* unused harmony export fetchDecodedConditionCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchDecodedConditionSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("hWD1");



var receiveEndUserCompanyData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* RECEIVE_END_USER_COMPANY_DATA */]);

var fetchBulkConversationEnrichmentDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS */]);

var fetchEnrichedCompanyData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_ENRICHED_COMPANY_DATA */]);
var fetchEnrichedCompanyDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_ENRICHED_COMPANY_DATA_PENDING */]);
var fetchEnrichedCompanyDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_ENRICHED_COMPANY_DATA_SUCCESS */]);
var fetchEnrichedCompanyDataNoResult = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_ENRICHED_COMPANY_DATA_NO_RESULT */]);
var fetchEnrichedCompanyDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_ENRICHED_COMPANY_DATA_FAILED */]);
var fetchEnrichedCompanyDataCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_ENRICHED_COMPANY_DATA_CANCELLED */]);

var fetchDecodedCondition = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_DECODED_CONDITION */]);
var fetchDecodedConditionPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_DECODED_CONDITION_PENDING */]);
var fetchDecodedConditionFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_DECODED_CONDITION_FAILED */]);
var fetchDecodedConditionCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_DECODED_CONDITION_CANCELLED */]);
var fetchDecodedConditionSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_DECODED_CONDITION_SUCCESS */]);

/***/ }),

/***/ "SMLT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_components_FilterEditor_SalesforceFilter_containers_SalesforceLeadRouting__ = __webpack_require__("Ohub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("Dlon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SalesforceRoutingSettings = function (_Component) {
  _inherits(SalesforceRoutingSettings, _Component);

  function SalesforceRoutingSettings(props) {
    _classCallCheck(this, SalesforceRoutingSettings);

    var _this = _possibleConstructorReturn(this, (SalesforceRoutingSettings.__proto__ || Object.getPrototypeOf(SalesforceRoutingSettings)).call(this, props));

    _this.onSalesforceLeadRoutingSettingsUpdated = function (settings) {

      // skip storing changesMade for intial load
      if (_this.state.selectedSalesforceLeadRoutingSettings) {
        _this.setState({ changesMade: true });
      }
      _this.setState({ selectedSalesforceLeadRoutingSettings: settings });
    };

    _this.publishSFDCSettings = function () {
      var selectedSalesforceLeadRoutingSettings = _this.state.selectedSalesforceLeadRoutingSettings;

      if (selectedSalesforceLeadRoutingSettings) {
        __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].patchSalesforceLeadRoutingSettings({ settings: selectedSalesforceLeadRoutingSettings });
      }
    };

    _this.state = { changesMade: false };
    return _this;
  }

  _createClass(SalesforceRoutingSettings, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedSalesforceLeadRoutingSettings = _state.selectedSalesforceLeadRoutingSettings,
          changesMade = _state.changesMade;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Salesforce Integration',
          backLinkUrl: '/settings/setup/salesforce'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Salesforce Conversation Routing Settings'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-routing-ui' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'When a known user chats in to Drift, we\u2019ll use their email to see if they exist in Salesforce and will find the appropriate owner in cascading order.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-salesforce-filter rules-choice' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'rules-editor-content' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'rules-choice-content drift-form' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_components_FilterEditor_SalesforceFilter_containers_SalesforceLeadRouting__["a" /* default */], {
                  onSalesforceLeadRoutingSettingsUpdated: this.onSalesforceLeadRoutingSettingsUpdated,
                  selectedSalesforceLeadRoutingSettings: this.state.selectedSalesforceLeadRoutingSettings })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'salesforce-routing-save-button-container' },
          changesMade && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
            {
              className: 'salesforce-routing-cancel-button',
              to: '/settings/setup/salesforce' },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
            {
              className: 'salesforce-routing-save-button',
              type: 'primary',
              onClick: this.publishSFDCSettings,
              disabled: !this.state.selectedSalesforceLeadRoutingSettings },
            'Save changes'
          )
        )
      );
    }
  }]);

  return SalesforceRoutingSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceRoutingSettings);

/***/ }),

/***/ "SPbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_company_categories__ = __webpack_require__("b3eM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var closeSRC = __webpack_require__("+Juk");

var CompanyTagsFilter = function (_Component) {
  _inherits(CompanyTagsFilter, _Component);

  function CompanyTagsFilter(props) {
    _classCallCheck(this, CompanyTagsFilter);

    var _this = _possibleConstructorReturn(this, (CompanyTagsFilter.__proto__ || Object.getPrototypeOf(CompanyTagsFilter)).call(this, props));

    _initialiseProps.call(_this);

    var _props$activeFilter = props.activeFilter,
        value = _props$activeFilter.value,
        field = _props$activeFilter.field;


    _this.state = {
      selectedCategories: value || [],
      fieldType: field
    };
    return _this;
  }

  _createClass(CompanyTagsFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateCondition();
    }
  }, {
    key: 'getFormattedTags',
    value: function getFormattedTags() {
      var _ref;

      var unusedCategories = (_ref = _).without.apply(_ref, [__WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_company_categories__["a" /* COMPANY_CATEGORIES */]].concat(_toConsumableArray(this.state.selectedCategories)));
      return unusedCategories.map(function (category) {
        return { label: category, value: category };
      });
    }
  }, {
    key: 'getListHeight',
    value: function getListHeight() {
      var itemHeight = 75;
      var totalColumns = 2;
      var maxHeight = this.state.selectedCategories.length * itemHeight / totalColumns + itemHeight;
      return {
        height: maxHeight + 'px'
      };
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var selectOptions = {
        multi: true,
        autoFocus: true,
        options: this.getFormattedTags(),
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        onChange: this.saveCategory,
        placeholder: 'Choose a category...'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          this.renderSearchBar()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-selection rules-choice-selection-multi-column' },
          this.renderTagSelectionList()
        )
      );
    }
  }]);

  return CompanyTagsFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.removeCategory = function (value) {
    _this2.setState(function (prevState) {
      return {
        selectedCategories: _.without(prevState.selectedCategories, value)
      };
    }, _this2.updateCondition);
  };

  this.saveCategory = function (values) {
    _this2.setState(function (prevState) {
      var newOptions = prevState.selectedCategories.slice(0);
      var onlyValues = values.map(function (option) {
        return option.value;
      });
      newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
      newOptions.sort();

      return {
        selectedCategories: newOptions
      };
    }, _this2.updateCondition);
  };

  this.updateCondition = function () {
    var updatedCondition = {
      operator: __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
      value: _this2.state.selectedCategories
    };

    _this2.props.onUpdateCondition(updatedCondition);
  };

  this.renderSelectOption = function (_ref2) {
    var label = _ref2.label;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'geo-option choice-dropdown-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'choice-option-value' },
        label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'choice-option-add' },
        '+Add'
      )
    );
  };

  this.renderTagSelectionList = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { style: _this2.getListHeight() },
      _this2.state.selectedCategories.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: option + '-' + index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            option
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
              return _this2.removeCategory(option);
            } })
        );
      })
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyTagsFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "SRF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export dataById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeGetEndUserReveal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);



var root = function root(state) {
  return state.get('reveal');
};

var dataById = function dataById(state) {
  return state.getIn(['reveal', 'dataByEndUserId']);
};

var _endUserIdFromProps = function _endUserIdFromProps(state, _ref) {
  var endUserId = _ref.endUserId;

  return endUserId;
};

var makeGetEndUserReveal = function makeGetEndUserReveal() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(dataById, _endUserIdFromProps, function (revealData, endUserId) {
    return revealData.get(endUserId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  });
};

/***/ }),

/***/ "SS0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("ScLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_api__ = __webpack_require__("a5br");






var LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch';
var LEANDATA_HELPDOC = 'https://gethelp.drift.com/hc/en-us/articles/360019667073-Drift-and-LeanData';

var makeConnectButtonPressConfig = function makeConnectButtonPressConfig(enabled, successCallback) {
  return {
    url: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/integrations/leandata/toggles',
    method: 'patch',
    data: {
      enabled: enabled
    },
    successMessage: 'Successfully sent request to LeanData',
    errorMessage: 'Something went wrong and we couldn\u2019t get your request to LeanData',
    clickId: LEANDATA_INTEGRATION_SWITCH,
    successCallback: successCallback
  };
};

var successCallbackWithEmail = function successCallbackWithEmail(successCallback) {
  __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_api__["a" /* api */].sendLeanDataIntegrationEmail();
  successCallback();
};

var LeanDataDisconnected = function LeanDataDisconnected(_ref) {
  var asyncButtonPress = _ref.asyncButtonPress,
      togglePending = _ref.togglePending,
      integrationsFetchPending = _ref.integrationsFetchPending,
      fetchIntegrationStates = _ref.fetchIntegrationStates;
  return React.createElement(
    'div',
    { className: 'leandata-connected-view-container' },
    React.createElement(
      'p',
      null,
      'Connect your account to Drift to assign leads to reps using your LeanData rules. ',
      React.createElement(
        'a',
        { href: LEANDATA_HELPDOC },
        'Learn more'
      )
    ),
    React.createElement(
      'div',
      null,
      React.createElement(
        'h3',
        { className: 'integration-leandata-how-it-works-title' },
        'How it works'
      ),
      React.createElement(
        'ul',
        { className: 'integration-leandata-how-it-works-list' },
        React.createElement(
          'li',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { name: 'arrow-2-right', width: 16, className: 'how-it-works-icon' }),
          'Connect your LeanData account with Drift.'
        ),
        React.createElement(
          'li',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { name: 'arrow-2-right', width: 16, className: 'how-it-works-icon' }),
          'When you connect LeanData through Drift, we\u2019ll send an email to the LeanData team letting them know to turn on the integration.'
        ),
        React.createElement(
          'li',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { name: 'arrow-2-right', width: 16, className: 'how-it-works-icon' }),
          'Create a new conversation routing rule using LeanData.'
        ),
        React.createElement(
          'li',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { name: 'arrow-2-right', width: 16, className: 'how-it-works-icon' }),
          'When visitors chat in, Drift will automatically connect them with the right person according to LeanData.'
        )
      ),
      React.createElement(
        'p',
        { className: 'integration-leandata-extra-note' },
        React.createElement(
          'strong',
          null,
          'Note:'
        ),
        ' Just remember to make sure that teammates are in Salesforce and Drift.'
      )
    ),
    React.createElement(
      'div',
      { className: 'leandata-connected-disconnect-container' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
        { type: 'primary', loading: togglePending || integrationsFetchPending, onClick: function onClick() {
            return asyncButtonPress(makeConnectButtonPressConfig(true, successCallbackWithEmail(fetchIntegrationStates)));
          } },
        'Request Access from LeanData'
      ),
      React.createElement(
        'p',
        { className: 'integration-leandata-extra-note' },
        'We\'ll include your email in our request to LeanData. They\'ll reach out to you there once everything is enabled.'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LeanDataDisconnected);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "SW2R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OperatorOptions = [{ value: "lessThan", text: "is less than" }, { value: "greaterThan", text: "is greater than" }];

var OperatorByValue = __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default()(OperatorOptions, 'value');

var ScrollPercentageInput = function (_Component) {
  _inherits(ScrollPercentageInput, _Component);

  function ScrollPercentageInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ScrollPercentageInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollPercentageInput.__proto__ || Object.getPrototypeOf(ScrollPercentageInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleOperatorSelect = function (operator) {
      _this.props.conditionUpdater('operator', operator);
    }, _this.handleChange = function (value) {
      _this.props.conditionUpdater('value', parseInt(value));
    }, _this.isValid = function () {
      var value = _this.props.conditionValue.get('value');
      return value >= 0 && value <= 100;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ScrollPercentageInput, [{
    key: 'renderOperatorSelection',
    value: function renderOperatorSelection() {
      var operator = this.props.conditionValue.get('operator');
      var selectedValue = OperatorByValue[operator];
      var text = selectedValue.text,
          value = selectedValue.value;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__["a" /* default */], {
        onSelection: this.handleOperatorSelect,
        options: OperatorOptions,
        selectedValue: text || value
      });
    }
  }, {
    key: 'renderNumericInput',
    value: function renderNumericInput() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default.a, {
        type: 'number',
        min: 0,
        max: 100,
        step: 1,
        valueLink: {
          requestChange: this.handleChange,
          value: this.props.conditionValue.get('value')
        },
        isValid: this.isValid()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'flex-space-around flex-1' },
        this.renderOperatorSelection(),
        this.renderNumericInput(),
        React.createElement('div', { style: { width: 16 } })
      );
    }
  }]);

  return ScrollPercentageInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollPercentageInput);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "SWdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_reply_ComposeReplyModal__ = __webpack_require__("q4i+");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var ComposeReplyModalWrapper = React.createClass({
  displayName: 'ComposeReplyModalWrapper',
  render: function render() {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_reply_ComposeReplyModal__["a" /* default */], _.assign({ onClose: this.props.onModalClose, duplicate: this.props.location.query.duplicate }, this.props));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ComposeReplyModalWrapper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "SX5Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"segmentsCardPlaceholder":"segmentsCardPlaceholder---FoKjH"};

/***/ }),

/***/ "ScLi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sctq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LookupMethodEnum; });
var LookupMethodEnum = Object.freeze({ CONTACT_EMAIL: 'CONTACT_EMAIL', DOMAIN: 'DOMAIN' });

/***/ }),

/***/ "SfLo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("8NIt");












function makeMapStateToProps() {
  return function (state) {
    return {
      isGoogleOrMicrosoftConnected: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["w" /* isGoogleOrMicrosoftConnected */])(state),
      googleAuthed: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["g" /* getIsGoogleOauthConnected */])(state),
      microsoftAuthed: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["i" /* getIsMicrosoftOauthConnected */])(state),
      microsoftAdminManaged: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["s" /* hasFetchedMicrosoftAdminConsent */])(state),
      getCalendarStatusLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["c" /* getCalendarStatusLoaded */])(state),
      calendar: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["b" /* getCalendar */])(state)
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["r" /* fetchCalendarStatus */],
      fetchMicrosoftAdminConsent: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["S" /* fetchMicrosoftAdminConsent */],
      openedMeetingEmailModal: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["_13" /* openedMeetingEmailModal */],
      fetchGoogleScopes: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__["fetchGoogleScopes"],
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      fetchMeetingTypes: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["O" /* fetchMeetingTypes */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (!this.props.isCalendarLoaded || !this.props.isSettingsLoaded || !this.props.isMeetingTypesLoaded) {
      this.props.actions.fetchCalendarStatus();
      this.props.actions.fetchGoogleScopes();
      this.props.actions.fetchMeetingSettings();
      this.props.actions.fetchMicrosoftAdminConsent();
      this.props.actions.fetchMeetingTypes();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (!(nextProps.calendar && nextProps.calendar.id)) {
      nextProps.router.replace('/settings/calendar/connect');
    }
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "Sjwf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_CookieHelpers__ = __webpack_require__("WB5i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("7X7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TrialMessaging__ = __webpack_require__("/896");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WidgetStatusTease__ = __webpack_require__("xKD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EnableNotifications__ = __webpack_require__("o6eF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_InstallDriftNotice__ = __webpack_require__("cVTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_EnableSound__ = __webpack_require__("JGxS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__ = __webpack_require__("TFJD");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















__webpack_require__("npn6");

var NOTIFICATION_TYPES = {
  trial: __WEBPACK_IMPORTED_MODULE_6__components_TrialMessaging__["a" /* default */],
  widgetStatus: __WEBPACK_IMPORTED_MODULE_7__components_WidgetStatusTease__["a" /* default */],
  notifications: __WEBPACK_IMPORTED_MODULE_8__components_EnableNotifications__["a" /* default */],
  installDriftNotice: __WEBPACK_IMPORTED_MODULE_9__components_InstallDriftNotice__["a" /* default */],
  sound: __WEBPACK_IMPORTED_MODULE_10__components_EnableSound__["a" /* default */]
};

var startSound = new Audio(__webpack_require__("iELk"));
startSound.muted = true;

var GlobalNotificationBar = function (_Component) {
  _inherits(GlobalNotificationBar, _Component);

  function GlobalNotificationBar(props) {
    _classCallCheck(this, GlobalNotificationBar);

    var _this = _possibleConstructorReturn(this, (GlobalNotificationBar.__proto__ || Object.getPrototypeOf(GlobalNotificationBar)).call(this, props));

    _this.playStartSoundOnClick = function () {
      startSound.play().catch(function (error) {
        // Sound should definitely be able to play after user interaction, surface error to user through log
        console.info('Sound still unable to play after user interaction:');
        console.info(error);
      });
      _this.setState({ sound: _this.state.sound === 'failed' ? 'enabled' : 'confirmed' });
      // remove this listener to prevent subsequent unnecessary plays
      document.removeEventListener('click', _this.playStartSoundOnClick);
    };

    _this.hasBeenPromptedForClick = function () {
      return _this.state.sound !== 'default' && _this.state.sound !== 'confirmed';
    };

    _this.hasRequestedSound = function () {
      return _this.props.settings['humane-notifications-browser'] !== 'nothing' && _this.props.settings['humane-notifications-browser-sound'] && _this.props.settings['humane-notifications-browser-sound'] !== 'none';
    };

    _this.hasNotificationPermissionsGranted = function () {
      return window.Notification && window.Notification.permission === 'granted';
    };

    _this.isOnTeamSettingsPage = function () {
      var currentPath = _this.props.currentPath;

      return currentPath === '/settings/team';
    };

    _this.isOnboarding = function () {
      var currentPath = _this.props.currentPath;

      return currentPath.includes('/welcome') || currentPath.includes('/setup') || currentPath.includes('install');
    };

    _this.selectNotificationType = function () {
      var query = _this.context.location.query;

      if (query.overrideNotification) {
        return NOTIFICATION_TYPES[query.overrideNotification];
      }

      if (_this.props.orgProperties.widgetInstalled != true) {
        return NOTIFICATION_TYPES.installDriftNotice;
      }

      var trialExpiresAt = _this.props.orgProperties.trialExpiresAt;
      var trialNudge = _this.state.trialNudge;


      if (__WEBPACK_IMPORTED_MODULE_12_utils_Access__["c" /* default */].hasGates('premium_team_trial') && trialExpiresAt) {
        var expirationMoment = __WEBPACK_IMPORTED_MODULE_3_moment___default()(+trialExpiresAt);
        if (expirationMoment.isBefore() || !trialNudge) {
          return NOTIFICATION_TYPES.trial;
        }
      }

      if (_this.shouldShowNotificationsEnable()) {
        return NOTIFICATION_TYPES.notifications;
      }

      if (_this.shouldShowSoundEnable()) {
        return NOTIFICATION_TYPES.sound;
      }

      return NOTIFICATION_TYPES.widgetStatus;
    };

    _this.shouldShowNotificationsEnable = function () {
      var pathname = _this.context.location.pathname;

      var hasntDissmissedForever = !window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* NEVER_SHOW */]);

      return hasntDissmissedForever && window.Notification && window.Notification.permission === 'default' && pathname.includes('inboxes');
    };

    _this.shouldShowSoundEnable = function () {
      var pathname = _this.context.location.pathname;

      return _this.hasBeenPromptedForClick() && _this.hasRequestedSound() && _this.hasNotificationPermissionsGranted() && pathname.includes('inboxes');
    };

    _this.state = {
      trialNudge: Object(__WEBPACK_IMPORTED_MODULE_4_utils_CookieHelpers__["a" /* getCookie */])('DriftTrialDaily'),
      sound: 'default'
    };
    return _this;
  }

  _createClass(GlobalNotificationBar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      //// Play an initial silent + muted sound to overcome browser autoplay policies
      // See https://goo.gl/xX8pDD for details on Chrome
      startSound.play().catch(function () {
        // The user interaction requirement is met on click so play our initial sound then
        document.addEventListener("click", _this2.playStartSoundOnClick);
        setTimeout(function () {
          _this2.setState({ sound: _this2.state.sound === 'confirmed' ? 'confirmed' : 'failed' });
        }, 10000);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.isOnboarding()) {
        return React.createElement('div', null);
      }

      var NotificationComponent = this.selectNotificationType();
      return React.createElement(
        'div',
        { className: 'notification-bar-wrapper' },
        NotificationComponent && React.createElement(NotificationComponent, _extends({}, this.props, this.context, { sound: this.state.sound }))
      );
    }
  }]);

  return GlobalNotificationBar;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

GlobalNotificationBar.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
GlobalNotificationBar.propTypes = {
  orgProperties: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


function mapStateToProps(state) {
  var settings = __WEBPACK_IMPORTED_MODULE_11_app_modules_user_properties_selectors__["g" /* properties */](state);
  return {
    orgProperties: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_org_selectors__["properties"])(state),
    settings: settings && settings.toJS()
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(GlobalNotificationBar));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "SmOF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SqAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userListOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);


var userListOptions = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a({
  RANDOM: {
    display: 'Randomly Chosen'
  },
  CUSTOM: {
    display: 'Hand Picked'
  }
});

/***/ }),

/***/ "SrDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("L/10");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _handleActions2, _handleActions3, _handleActions5, _handleActions7;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var rules = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesSuccess"], function (state, action) {
  return action.payload.rules;
}), []);

var rulesLoaded = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesSuccess"], function () {
  return true;
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesPending"], function () {
  return false;
}), _handleActions2), false);

var rulesLoading = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesPending"], function () {
  return true;
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesSuccess"], function () {
  return false;
}), _handleActions3), true);

var onCall = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesSuccess"], function (state, action) {
  return action.payload.onCall;
}), {});

var activeRule = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* EDIT_RULE */], function (state, action) {
  return _extends({}, state, { loading: false, data: action.rule });
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* RESET_ACTIVE_RULE */], function () {
  return _.cloneDeep(__WEBPACK_IMPORTED_MODULE_1__models__["w" /* newRuleModel */]);
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* RESET_ACTIVE_RULE_ACTION */], function (state) {
  var newState = _.cloneDeep(state);
  newState.data.item.action = __WEBPACK_IMPORTED_MODULE_1__models__["x" /* participantAction */];
  return newState;
}), _handleActions5), _.cloneDeep(__WEBPACK_IMPORTED_MODULE_1__models__["w" /* newRuleModel */]));

var userIdsForRules = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRulesSuccess"], function (state, action) {
  var flatRules = action.payload.rules;
  return _(flatRules).map(function (rule) {
    if (rule.action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPES */].PARTICIPANT) {
      return rule.action.options.userIds;
    }
  }).flatten().uniq().map(function (id) {
    return +id;
  }).value();
}), []);

var roundRobinStatusByKey = Object(__WEBPACK_IMPORTED_MODULE_4_redux_actions__["handleActions"])((_handleActions7 = {}, _defineProperty(_handleActions7, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRoundRobinByKey"], function (state, action) {
  return state.set(action.payload.roundRobinKey, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    loaded: false,
    loading: false,
    data: null,
    err: null
  }));
}), _defineProperty(_handleActions7, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRoundRobinByKeyPending"], function (state, action) {
  return state.setIn([action.payload.roundRobinKey, 'loading'], true);
}), _defineProperty(_handleActions7, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRoundRobinByKeyFailed"], function (state, action) {
  return state.setIn([action.payload.roundRobinKey, 'loading'], false).setIn([action.payload.roundRobinKey, 'loaded'], false).setIn([action.payload.roundRobinKey, 'err'], action.payload.err).setIn([action.payload.roundRobinKey, 'data'], null);
}), _defineProperty(_handleActions7, __WEBPACK_IMPORTED_MODULE_5__actions__["fetchRoundRobinByKeySuccess"], function (state, action) {
  return state.setIn([action.payload.roundRobinKey, 'loading'], false).setIn([action.payload.roundRobinKey, 'loaded'], true).setIn([action.payload.roundRobinKey, 'data'], action.payload.data).setIn([action.payload.roundRobinKey, 'err'], null);
}), _handleActions7), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__["combineReducers"])({
  rules: rules,
  rulesLoading: rulesLoading,
  onCall: onCall,
  activeRule: activeRule,
  userIdsForRules: userIdsForRules,
  rulesLoaded: rulesLoaded,
  roundRobinStatusByKey: roundRobinStatusByKey
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "SrDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Suvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchPardotFieldsSuccess */
/* unused harmony export fetchPardotMappingsSuccess */
/* unused harmony export patchPardotMappingsSuccess */
/* unused harmony export patchPardotMappingsError */
/* unused harmony export patchPardotMappingsStart */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchPardotFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchPardotMappings;
/* harmony export (immutable) */ __webpack_exports__["c"] = patchPardotMappings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("vY9o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_pardot_api__ = __webpack_require__("q/43");



function fetchPardotFieldsSuccess(_ref) {
    var fields = _ref.fields;

    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_PARDOT_FIELDS_SUCCESS */],
        fields: fields
    };
}

function fetchPardotMappingsSuccess(_ref2) {
    var mappings = _ref2.mappings;

    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_PARDOT_MAPPINGS_SUCCESS */],
        mappings: mappings
    };
}

function patchPardotMappingsSuccess(_ref3) {
    var mappings = _ref3.mappings;

    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_PARDOT_MAPPINGS_SUCCESS */],
        mappings: mappings
    };
}

function patchPardotMappingsError(err) {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_PARDOT_MAPPINGS_ERROR */],
        err: err
    };
}

function patchPardotMappingsStart() {
    return {
        type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_PARDOT_MAPPINGS_START */]
    };
}

function fetchPardotFields() {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_1_app_modules_pardot_api__["a" /* api */].fetchPardotFields().then(function (response) {
            dispatch(fetchPardotFieldsSuccess(response));
        });
    };
}

function fetchPardotMappings() {
    return function (dispatch) {
        __WEBPACK_IMPORTED_MODULE_1_app_modules_pardot_api__["a" /* api */].fetchPardotMappings().then(function (response) {
            dispatch(fetchPardotMappingsSuccess(response));
        });
    };
}

function patchPardotMappings(mappings) {
    var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    return function (dispatch) {
        dispatch(patchPardotMappingsStart());
        __WEBPACK_IMPORTED_MODULE_1_app_modules_pardot_api__["a" /* api */].patchPardotMappings(mappings).then(function (response) {
            successCB();
            dispatch(patchPardotMappingsSuccess(response));
        }).catch(function (err) {
            dispatch(patchPardotMappingsError(err));
        });
    };
}

/***/ }),

/***/ "SuxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("HbY0");












var mapStateToProps = function mapStateToProps(state) {
  return {
    display: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_103" /* targetingDisplay */](state),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      addConditionSet: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["d" /* addConditionSet */],
      addCondition: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["c" /* addCondition */],
      showConditionModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_227" /* showConditionModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onBackClick: function onBackClick(_ref) {
    var params = _ref.params,
        router = _ref.router;
    return function () {
      router.replace('/playbooks/' + params.playbookId + '/edit/targeting/display');
    };
  },
  onAddConditionSetClick: function onAddConditionSetClick(props) {
    return function () {
      var conditionSetId = Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_helpers__["a" /* weakUuid */])();
      var conditionId = Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_helpers__["a" /* weakUuid */])();
      props.actions.addConditionSet({
        conditionSet: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__["c" /* ConditionSet */]({ id: conditionSetId })
      });
      props.actions.addCondition({
        conditionSetId: conditionSetId,
        condition: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__["b" /* Condition */]({
          id: conditionId
        })
      });
      props.actions.showConditionModal(conditionId);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),

/***/ "SyCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_component_with_partials__ = __webpack_require__("Fbwe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_component_with_partials___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_component_with_partials__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__ = __webpack_require__("1Pxv");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var BIO_PLACEHOLDER = 'Help others learn more about you by writing a great bio.\n\nHere\u2019s a couple tips: be relatable and unique! What are some things that aren\u2019t on your resume, things that make you\u2026 well, you! This is your space, so go for it!';

var DetailInfo = function (_PureComponent) {
  _inherits(DetailInfo, _PureComponent);

  function DetailInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DetailInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DetailInfo.__proto__ || Object.getPrototypeOf(DetailInfo)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (key, event) {
      var value = event.target.value;

      _this.props.actions.setProfileUIData({ key: key, value: value });
    }, _this.handleSave = function () {
      if (!_this.canSubmit()) return;

      _this.props.actions.updateDetails();
    }, _this.handleCancel = function () {
      _this.props.actions.setProfileUI(_this.props.details);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DetailInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          detailsUI = _props.detailsUI,
          partial = _props.partial;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["b" /* Subsection */],
        { title: 'Details',
          isValid: this.isValid(),
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-settings' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'profile-settings-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'profile-settings-left' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Label' },
                  'Extended bio'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, {
                  size: 'small',
                  placeholder: BIO_PLACEHOLDER,
                  value: detailsUI.bio,
                  onChange: partial(this.handleChange, 'bio'),
                  isValid: true,
                  isTextArea: true,
                  className: 'profile-settings-extended-bio'
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'profile-settings-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'profile-settings-item' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dsg-Label' },
                    'Interests'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                    placeholder: 'What do you like?',
                    value: detailsUI.likes,
                    onChange: partial(this.handleChange, 'likes'),
                    isValid: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'profile-settings-item' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dsg-Label' },
                    'Fun fact'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                    placeholder: 'Got a hidden talent?',
                    value: detailsUI.funFact,
                    onChange: partial(this.handleChange, 'funFact'),
                    isValid: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'profile-settings-item' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dsg-Label' },
                    'Education'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                    placeholder: 'School of Hard Knocks \u201988',
                    value: detailsUI.educationInfo,
                    onChange: partial(this.handleChange, 'educationInfo'),
                    isValid: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'profile-settings-item' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'dsg-Label' },
                    'Blog URL'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                    placeholder: 'www.example.com',
                    value: detailsUI.blogUrl,
                    onChange: partial(this.handleChange, 'blogUrl'),
                    isValid: this.isValidUrl(detailsUI.blogUrl)
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'profile-settings-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dsg-Label' },
                'Languages'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                placeholder: 'e.g. English, Spanish, Chinese',
                value: detailsUI.languages,
                onChange: partial(this.handleChange, 'languages'),
                isValid: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'profile-settings-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dsg-Label' },
                'Podcast URL'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, { size: 'small',
                value: detailsUI.podcastUrl,
                placeholder: 'www.example.com',
                onChange: partial(this.handleChange, 'podcastUrl'),
                isValid: this.isValidUrl(detailsUI.podcastUrl)
              })
            )
          )
        )
      );
    }
  }, {
    key: 'canSubmit',
    value: function canSubmit() {
      return !Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["is"])(this.props.detailsUI, this.props.details);
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      var _props$detailsUI = this.props.detailsUI,
          podcastUrl = _props$detailsUI.podcastUrl,
          blogUrl = _props$detailsUI.blogUrl;


      return this.isValidUrl(podcastUrl) && this.isValidUrl(blogUrl);
    }
  }, {
    key: 'isValidUrl',
    value: function isValidUrl(url) {
      if (url && url.length > 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_validator__["isURL"])(url);
      }

      return true;
    }
  }]);

  return DetailInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_component_with_partials___default()(DetailInfo));

/***/ }),

/***/ "SzO/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(500);

/***/ }),

/***/ "T0+/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/knowledge-base-group.84062b59.svg";

/***/ }),

/***/ "T1OH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EMPTY_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_RULES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_RULES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_RULES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_RULES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_RULES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_ROUND_ROBIN_BY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_ROUND_ROBIN_BY_KEY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_ROUND_ROBIN_BY_KEY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_ROUND_ROBIN_BY_KEY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_ROUND_ROBIN_BY_KEY_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EDIT_RULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return RESET_ACTIVE_RULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return RESET_ACTIVE_RULE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PARTICIPANT_ADD_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GEO_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GEO_FILTER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return REGION_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTINENT_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EMPLOYEES_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return MONEY_RAISED_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REVENUE_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CATEGORY_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEMANDBASE_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FIRMOGRAPHIC_FILTER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FIRMOGRAPHIC_FILTER_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return REVENUE_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EMPLOYEE_NUMBER_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return MONEY_RAISED_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SITE_VISITS_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISPLAY_WHEN_FILTER_TYPES; });
/* unused harmony export DISPLAY_WHEN_FILTER_TYPE_LABELS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SITE_VISITS_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return URL_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return URL_FILTER_OPERATOR_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return URL_FILTER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return URL_FILTER_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SALESFORCE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SALESFORCE_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return TARGETED_ACCOUNTS_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TARGETED_ACCOUNTS_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return OPERATOR_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SUB_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONDITION_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONDITION_SUB_TYPE_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONDITION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AVAILABILITY_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AVAILABILITY_FILTER_OPERATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return LEANDATA_FILTER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('rules');

var EMPTY_STRING = '';

var FETCH_RULES = makeConstant('FETCH_RULES');
var FETCH_RULES_PENDING = makeConstant('FETCH_RULES_PENDING');
var FETCH_RULES_CANCELLED = makeConstant('FETCH_RULES_CANCELLED');
var FETCH_RULES_FAILED = makeConstant('FETCH_RULES_FAILED');
var FETCH_RULES_SUCCESS = makeConstant('FETCH_RULES_SUCCESS');

var FETCH_ROUND_ROBIN_BY_KEY = makeConstant('FETCH_ROUND_ROBIN_BY_KEY');
var FETCH_ROUND_ROBIN_BY_KEY_PENDING = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_PENDING');
var FETCH_ROUND_ROBIN_BY_KEY_FAILED = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_FAILED');
var FETCH_ROUND_ROBIN_BY_KEY_SUCCESS = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_SUCCESS');
var FETCH_ROUND_ROBIN_BY_KEY_CANCELLED = makeConstant('FETCH_ROUND_ROBIN_BY_KEY_CANCELLED');

var EDIT_RULE = 'EDIT_RULE';
var RESET_ACTIVE_RULE = 'RESET_ACTIVE_RULE';
var RESET_ACTIVE_RULE_ACTION = 'RESET_ACTIVE_RULE_ACTION';
var PARTICIPANT_ADD_TYPES = { ONE: 'ADD_ONE', ALL: 'ADD_ALL' };
var ACTION_TYPES = {
  PARTICIPANT: 'PARTICIPANT',
  SALESFORCE_PARTICIPANT: 'SALESFORCE_PARTICIPANT',
  ABM_PARTICIPANT: 'ABM_PARTICIPANT',
  LEANDATA_PARTICIPANT: 'LEANDATA_PARTICIPANT'

  //GEO
};var GEO_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf' };
var GEO_FILTER_TYPES = { STATE: 'geoState', COUNTRY: 'geoCountryCode' };
var REGION_LABELS = {
  northeast: 'Northeast',
  south: 'South',
  west: 'West',
  midwest: 'Midwest'
};

var CONTINENT_LABELS = {
  AFRICA: 'Africa',
  ASIA: 'Asia',
  EUROPE: 'Europe',
  MIDDLE_EAST: 'Middle East',
  NORTH_AMERICA: 'North America',
  CENTRAL_AMERICA_CARRIBEAN: 'Central America & Carribean',
  SOUTH_AMERICA: 'South America',
  OCEANIA: 'Oceania'

  //FIRMO
};var EMPLOYEES_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' };
var MONEY_RAISED_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' };
var REVENUE_FILTER_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' };
var CATEGORY_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf' };
var DEMANDBASE_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', IS_NOT: 'notIsAnyOf', BTW: 'isBetween' };

var FIRMOGRAPHIC_FILTER_TYPES = {
  EMPLOYEES: 'clearbit_employees',
  MONEY_RAISED: 'clearbit_raised',
  COMPANY_CATEGORIES: 'clearbit_tags_company',
  MARKET_CATEGORIES: 'clearbit_tags_market',
  TECH_TAGS: 'clearbit_tech',
  HEADQUARTERS_STATE: 'clearbit_state',
  HEADQUARTERS_COUNTRY: 'clearbit_country',
  HEADQUARTERS_POSTAL_CODE: 'clearbit_postal_code',
  REVENUE: 'clearbit_revenue',
  DEMANDBASE_AUDIENCE: 'demandbase_audience',
  DEMANDBASE_EMPLOYEE_COUNT: 'demandbase_employee_count',
  DEMANDBASE_INDUSTRY: 'demandbase_industry',
  DEMANDBASE_SUB_INDUSTRY: 'demandbase_sub_industry',
  DEMANDBASE_EMPLOYEE_RANGE: 'demandbase_employee_range',
  DEMANDBASE_MARKETING_ALIAS: 'demandbase_marketing_alias',
  DEMANDBASE_ANNUAL_SALES: 'demandbase_annual_sales',
  DEMANDBASE_REVENUE_RANGE: 'demandbase_revenue_range',
  DEMANDBASE_HEADQUARTERS_CITY: 'demandbase_city',
  DEMANDBASE_HEADQUARTERS_STATE: 'demandbase_state',
  DEMANDBASE_HEADQUARTERS_COUNTRY: 'demandbase_country_code'
};

var FIRMOGRAPHIC_FILTER_TYPE_LABELS = {
  EMPLOYEES: 'Number of Employees',
  MONEY_RAISED: 'Money Raised',
  COMPANY_CATEGORIES: 'Company Categories',
  MARKET_CATEGORIES: 'Market Categories',
  TECH_TAGS: 'Technology Used',
  HEADQUARTERS_STATE: 'Headquarter State',
  HEADQUARTERS_COUNTRY: 'Headquarter Country',
  HEADQUARTERS_POSTAL_CODE: 'Headquarter Postal Code',
  REVENUE: 'Annual Revenue',
  DEMANDBASE_AUDIENCE: 'Demandbase - Audience',
  DEMANDBASE_EMPLOYEE_COUNT: 'Demandbase - Number of Employees',
  DEMANDBASE_INDUSTRY: 'Demandbase - Industry',
  DEMANDBASE_SUB_INDUSTRY: 'Demandbase - Sub-Industry',
  DEMANDBASE_EMPLOYEE_RANGE: 'Demandbase - Employee Range',
  DEMANDBASE_MARKETING_ALIAS: 'Demandbase - Marketing Alias',
  DEMANDBASE_ANNUAL_SALES: 'Demandbase - Annual Sales',
  DEMANDBASE_REVENUE_RANGE: 'Demandbase - Revenue Range',
  DEMANDBASE_HEADQUARTERS_CITY: 'Demandbase - City',
  DEMANDBASE_HEADQUARTERS_STATE: 'Demandbase - State',
  DEMANDBASE_HEADQUARTERS_COUNTRY: 'Demandbase - Country'
};

var REVENUE_GROUPS = [{
  label: '$0-$1M',
  value: '$0-$1M'
}, {
  label: '$1M-$10M',
  value: '$1M-$10M'
}, {
  label: '$10M-$50M',
  value: '$10M-$50M'
}, {
  label: '$50M-$100M',
  value: '$50M-$100M'
}, {
  label: '$100M-$250M',
  value: '$100M-$250M'
}, {
  label: '$250M-$500M',
  value: '$250M-$500M'
}, {
  label: '$500M-$1B',
  value: '$500M-$1B'
}, {
  label: '$1B-$10B',
  value: '$1B-$10B'
}, {
  label: '$10B+',
  value: '$10B+'
}];

var EMPLOYEE_NUMBER_GROUPS = [{ min: 0, max: 10 }, { min: 11, max: 25 }, { min: 26, max: 50 }, { min: 51, max: 200 }, { min: 201, max: 500 }, { min: 501, max: 2000 }];

var MONEY_RAISED_GROUPS = [{ min: 0, max: 2 }, { min: 2, max: 10 }, { min: 10, max: 20 }, { min: 20, max: 35 }];

//DISPLAY WHEN
var SITE_VISITS_OPERATORS = { GT: 'greaterThan', LT: 'lessThan', BTW: 'isBetween' };
var DISPLAY_WHEN_FILTER_TYPES = {
  SITE_VISITS: 'siteVisits'
};

var DISPLAY_WHEN_FILTER_TYPE_LABELS = {
  SITE_VISITS: 'Number of Site Visits'
};

var SITE_VISITS_GROUPS = [{ min: 0, max: 1 }, { min: 2, max: 4 }, { min: 5, max: 10 }];

//url
var URL_FILTER_OPERATORS = { IS_ANY: 'isAnyOf', INCLUDES_ANY: 'includesAnyOf', IS_NOT: 'notIsAnyOf' };
var URL_FILTER_OPERATOR_LABELS = { IS_ANY: 'is', INCLUDES_ANY: 'includes', IS_NOT: 'is not' };

var URL_FILTER_TYPES = {
  URL_PATH: 'urlPath',
  URL_HOST: 'urlHost',
  URL_QUERY: 'urlQuery'
};

var URL_FILTER_TYPE_LABELS = {
  URL_PATH: 'URL Path',
  URL_HOST: 'URL Host',
  URL_QUERY: 'URL Query Param'

  //SALESFORCE
};var SALESFORCE_FILTER = 'salesforceOwner';

var SALESFORCE_OPERATORS = { IS: 'is'

  //TARGETED ACCOUNTS
};var TARGETED_ACCOUNTS_FILTER = 'targetedAccounts';

var TARGETED_ACCOUNTS_OPERATORS = { IS: 'is'

  //MISC
};var OPERATOR_LABELS = {
  isAnyOf: 'is',
  notIsAnyOf: 'is not',
  isBetween: 'is between',
  includesAnyOf: 'is'
};

var SUB_TYPE_LABELS = {
  clearbit_employees: 'has Number of Employees',
  clearbit_raised: 'is Money Raised',
  clearbit_tags_company: 'is Company Categories',
  clearbit_tags_market: 'is Market Categories',
  clearbit_tech: 'is Technology Used',
  clearbit_state: 'is Headquarter State',
  clearbit_country: 'is Headquarter Country',
  clearbit_postal_code: 'is Headquarter Postal Code',
  clearbit_revenue: 'is Annual Revenue',
  demandbase_company_name: 'is Company',
  demandbase_audience: 'is in Audience',
  demandbase_industry: 'is in Industry',
  demandbase_sub_industry: 'is in Sub Industry',
  demandbase_employee_count: 'Number of Employees',
  demandbase_employee_range: 'has Employee Range',
  demandbase_marketing_alias: 'has Marketing Alias',
  demandbase_annual_sales: 'Annual Sales',
  demandbase_revenue_range: 'has Revenue Range',
  demandbase_state: 'is Headquarter State',
  demandbase_country_code: 'is Headquarter Country',
  demandbase_city: 'is Headquarter City',
  urlHost: 'host is',
  urlPath: 'path is',
  urlQuery: 'query param is',
  salesforceOwner: 'Salesforce Owner',
  leandata: 'LeanData Owner'
};

var CONDITION_TYPE_LABELS = {
  geoState: 'Geolocation',
  geoCountryCode: 'Geolocation',
  clearbit_employees: 'Firmographics',
  clearbit_raised: 'Firmographics',
  clearbit_tags_company: 'Firmographics',
  clearbit_tags_market: 'Firmographics',
  clearbit_tech: 'Firmographics',
  clearbit_state: 'Firmographics',
  clearbit_country: 'Firmographics',
  clearbit_postal_code: 'Firmographics',
  clearbit_revenue: 'Firmographics',
  demandbase_company_name: 'Firmographics',
  demandbase_audience: 'Firmographics',
  demandbase_industry: 'Firmographics',
  demandbase_sub_industry: 'Firmographics',
  demandbase_employee_count: 'Firmographics',
  demandbase_employee_range: 'Firmographics',
  demandbase_marketing_alias: 'Firmographics',
  demandbase_annual_sales: 'Firmographics',
  demandbase_revenue_range: 'Firmographics',
  demandbase_state: 'Firmographics',
  demandbase_country_code: 'Firmographics',
  demandbase_city: 'Firmographics',
  siteVisits: 'Number of Site Visits',
  urlHost: 'URL Host',
  urlPath: 'URL Path',
  urlQuery: 'URL Query Param',
  salesforceOwner: 'Salesforce',
  targetedAccounts: 'Targeted Account',
  onlineUsers: 'Available Agents',
  leandata: 'LeanData'
};

var CONDITION_SUB_TYPE_LABELS = {
  geoState: 'State',
  geoCountryCode: 'Country',
  clearbit_employees: 'Number of Employees',
  clearbit_raised: 'Money Raised',
  clearbit_tags_company: 'Company Category',
  clearbit_tags_market: 'Market Category',
  clearbit_tech: 'Technology Used',
  clearbit_state: 'Headquarter State',
  clearbit_country: 'Headquarter Country',
  clearbit_postal_code: 'Headquarter Postal Code',
  clearbit_revenue: 'Annual Revenue',
  demandbase_company_name: 'Company Name',
  demandbase_audience: 'In Audience',
  demandbase_industry: 'In Industry',
  demandbase_sub_industry: 'In Sub-Industry',
  demandbase_employee_count: 'Number of Employees',
  demandbase_employee_range: 'Employee Range',
  demandbase_marketing_alias: 'Marketing Alias',
  demandbase_annual_sales: 'Annual Sales',
  demandbase_revenue_range: 'Revenue Range',
  demandbase_state: 'Headquarter State',
  demandbase_country_code: 'Headquarter Country',
  demandbase_city: 'Headquarter City',
  siteVisits: 'Number of Site Visits',
  urlHost: 'URL Host',
  urlPath: 'URL Path',
  urlQuery: 'URL Query Param',
  salesforceOwner: 'Salesforce Owner',
  targetedAccounts: 'Targeted Account',
  leandata: 'LeanData Owner'
};

var CONDITION_TYPES = {
  geoState: 'GEO',
  geoCountryCode: 'GEO',
  clearbit_employees: 'FIRMOGRAPHIC',
  clearbit_raised: 'FIRMOGRAPHIC',
  clearbit_tags_company: 'FIRMOGRAPHIC',
  clearbit_tags_market: 'FIRMOGRAPHIC',
  clearbit_tech: 'FIRMOGRAPHIC',
  clearbit_state: 'FIRMOGRAPHIC',
  clearbit_country: 'FIRMOGRAPHIC',
  clearbit_postal_code: 'FIRMOGRAPHIC',
  clearbit_revenue: 'FIRMOGRAPHIC',
  demandbase_company_name: 'FIRMOGRAPHIC',
  demandbase_audience: 'FIRMOGRAPHIC',
  demandbase_industry: 'FIRMOGRAPHIC',
  demandbase_sub_industry: 'FIRMOGRAPHIC',
  demandbase_employee_count: 'FIRMOGRAPHIC',
  demandbase_employee_range: 'FIRMOGRAPHIC',
  demandbase_marketing_alias: 'FIRMOGRAPHIC',
  demandbase_annual_sales: 'FIRMOGRAPHIC',
  demandbase_revenue_range: 'FIRMOGRAPHIC',
  demandbase_city: 'FIRMOGRAPHIC',
  demandbase_state: 'FIRMOGRAPHIC',
  demandbase_country_code: 'FIRMOGRAPHIC',
  siteVisits: 'DISPLAY_WHEN',
  urlHost: 'URL',
  urlPath: 'URL',
  urlQuery: 'URL',
  salesforceOwner: 'Salesforce Owner',
  targetedAccounts: 'Targeted Account',
  leandata: 'LeanData Owner'
};

var AVAILABILITY_FILTER = 'onlineUsers';
var AVAILABILITY_FILTER_OPERATORS = { 'IS_ANY': 'isAnyOf' };

var LEANDATA_FILTER = 'leandata';

/***/ }),

/***/ "T2nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHasLicensesEnabled */
/* unused harmony export getHasMarketplaceModalCutover */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getVideoWelcomeMessageCutover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDriftCutover; });
/* unused harmony export getPlaybooksTableCutover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var getHasLicensesEnabled = function getHasLicensesEnabled(orgId) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/' + orgId + '?namespace=LICENSES_ENABLED').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getHasMarketplaceModalCutover = function getHasMarketplaceModalCutover(orgId) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/' + orgId + '?namespace=HAS_MARKETPLACE_MODAL').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getVideoWelcomeMessageCutover = function getVideoWelcomeMessageCutover() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/fromContext?namespace=VIDEO_WELCOME_MESSAGE').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getDriftCutover = function getDriftCutover(_ref) {
  var orgId = _ref.orgId,
      cutoverName = _ref.cutoverName;
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/' + orgId + '?namespace=' + cutoverName).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getPlaybooksTableCutover = function getPlaybooksTableCutover() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/cutover/organizations/fromContext?namespace=PLAYBOOKS_TABLE_IN_PEW').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

/***/ }),

/***/ "T45g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_CommonIntegrationPage_api_js__ = __webpack_require__("ew+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("1C73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DisconnectConfirmModal = function (_Component) {
  _inherits(DisconnectConfirmModal, _Component);

  function DisconnectConfirmModal(props) {
    var _this2 = this;

    _classCallCheck(this, DisconnectConfirmModal);

    var _this = _possibleConstructorReturn(this, (DisconnectConfirmModal.__proto__ || Object.getPrototypeOf(DisconnectConfirmModal)).call(this, props));

    _this.getDisconnectNotifyCopy = function (integrationName) {
      return 'Disconnect ' + integrationName + '?';
    };

    _this.getDisconnectBodyCopy = function (integrationName) {
      switch (integrationName) {
        case "Clearbit Enrichment":
          return "Disconnecting this integration will disable contact and profile enrichment features from your account.";
        case "Clearbit Reveal":
          return "Disconnecting this integration will disable ABM targeting features from your account.";
        case "Outreach":
          return 'Any prospects currently in a sequence will still be enrolled.';
        case "Salesforce":
        case "Marketo":
        case "Hubspot":
        case "Eloqua":
        case "Pardot":
          return 'We\u2019ll keep your mapped attributes and users, but your data will no longer be synced between ' + integrationName + ' and Drift.';
        default:
          return 'Your data will no longer be synced between ' + integrationName + ' and Drift.';
      }
    };

    _this.feedbackChange = function (event) {
      _this.setState({
        integrationFeedback: event
      });
    };

    _this.innerDisconnect = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.integrationFeedback) {
                _context.next = 9;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__pages_CommonIntegrationPage_api_js__["a" /* api */].postIntegrationFeedback(_this.props.integrationName, _this.state.integrationFeedback);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0);

            case 9:
              _this.props.onDisconnect();

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 6]]);
    }));

    _this.state = {
      integrationFeedback: null
    };
    return _this;
  }

  _createClass(DisconnectConfirmModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClose = _props.onClose,
          integrationName = _props.integrationName,
          open = _props.open;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'disconnect-confirm' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Modal"],
          {
            size: 'small',
            className: 'disconnect-confirm-modal',
            type: 'warning',
            onClose: onClose,
            open: open },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'disconnect-confirm-modal-content' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'disconnect-confirm-modal-notify' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'h1',
                { className: 'disconnect-header' },
                this.getDisconnectNotifyCopy(integrationName)
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'disconnect-modal-copy' },
              this.getDisconnectBodyCopy(integrationName)
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'disconnect-feedback-holder' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'disconnect-feedback-header' },
                'Feedback (optional)'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["TextArea"], { className: 'disconnect-textarea', size: 'large', placeholder: 'Have some feedback about this integration? Let us know!', onChange: this.feedbackChange })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'disconnect-button-section' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              { onClick: this.innerDisconnect, type: 'secondary', className: 'modal-disconnect-button' },
              'Disconnect ' + integrationName
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              { onClick: onClose, type: 'tertiary' },
              'Nevermind'
            )
          )
        )
      );
    }
  }]);

  return DisconnectConfirmModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DisconnectConfirmModal);

/***/ }),

/***/ "T4JO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTRIB_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_TEAMMEMBER_ATTRIBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_TEAMMEMBER_ATTRIBS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_TEAMMEMBER_ATTRIBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_TEAMMEMBER_ATTRIBS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_TEAMMEMBER_ATTRIBS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ACCOUNT_ATTRIBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ACCOUNT_ATTRIBS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_ACCOUNT_ATTRIBS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ACCOUNT_ATTRIBS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ACCOUNT_ATTRIBS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ACCOUNT_SEGMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_ACCOUNT_SEGMENTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ACCOUNT_SEGMENTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_ACCOUNT_SEGMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ACCOUNT_SEGMENTS_CANCELLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('account');

var ATTRIB_TYPES = {
  TEAMMEMBER: 'TEAMMEMBER',
  STRING: 'STRING',
  EMAIL: 'EMAIL',
  NUMBER: 'NUMBER',
  ENUM: 'ENUM',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  LATLON: 'LATLON',
  LAT: 'LAT',
  LON: 'LON',
  PHONE: 'PHONE',
  URL: 'URL',
  ENUMARRAY: 'ENUMARRAY'
};

var FETCH_TEAMMEMBER_ATTRIBS = makeConstant('FETCH_TEAMMEMBER_ATTRIBS');
var FETCH_TEAMMEMBER_ATTRIBS_PENDING = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_PENDING');
var FETCH_TEAMMEMBER_ATTRIBS_SUCCESS = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_SUCCESS');
var FETCH_TEAMMEMBER_ATTRIBS_FAILED = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_FAILED');
var FETCH_TEAMMEMBER_ATTRIBS_CANCELLED = makeConstant('FETCH_TEAMMEMBER_ATTRIBS_CANCELLED');

var FETCH_ACCOUNT_ATTRIBS = makeConstant('FETCH_ACCOUNT_ATTRIBS');
var FETCH_ACCOUNT_ATTRIBS_PENDING = makeConstant('FETCH_ACCOUNT_ATTRIBS_PENDING');
var FETCH_ACCOUNT_ATTRIBS_SUCCESS = makeConstant('FETCH_ACCOUNT_ATTRIBS_SUCCESS');
var FETCH_ACCOUNT_ATTRIBS_FAILED = makeConstant('FETCH_ACCOUNT_ATTRIBS_FAILED');
var FETCH_ACCOUNT_ATTRIBS_CANCELLED = makeConstant('FETCH_ACCOUNT_ATTRIBS_CANCELLED');

var FETCH_ACCOUNT_SEGMENTS = makeConstant('FETCH_ACCOUNT_SEGMENTS');
var FETCH_ACCOUNT_SEGMENTS_PENDING = makeConstant('FETCH_ACCOUNT_SEGMENTS_PENDING');
var FETCH_ACCOUNT_SEGMENTS_FAILED = makeConstant('FETCH_ACCOUNT_SEGMENTS_FAILED');
var FETCH_ACCOUNT_SEGMENTS_SUCCESS = makeConstant('FETCH_ACCOUNT_SEGMENTS_SUCCESS');
var FETCH_ACCOUNT_SEGMENTS_CANCELLED = makeConstant('FETCH_ACCOUNT_SEGMENTS_CANCELLED');

/***/ }),

/***/ "T5NG":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 14H14v10c0 .552-.448 1-1 1s-1-.448-1-1V14H2c-.552 0-1-.448-1-1s.448-1 1-1h10V2c0-.552.448-1 1-1s1 .448 1 1v10h10c.552 0 1 .448 1 1s-.448 1-1 1z\" stroke=\"#9A9A9A\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "T7bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_serviceworker_notifications__ = __webpack_require__("x8hE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_serviceworker_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_serviceworker_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("H+ql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("Jq9o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_NotificationConstants__ = __webpack_require__("rFuW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_utils_ByteArrayConversionHelper__ = __webpack_require__("PhZX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__ = __webpack_require__("a56C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_participants_utils__ = __webpack_require__("fvUW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utils_Access__ = __webpack_require__("6k1g");






















var createParticipantNotification = function createParticipantNotification(state, message) {
  var conversationEvent = message.conversationEvent,
      conversationId = message.conversationId;
  var type = conversationEvent.type,
      authorUserId = conversationEvent.authorUserId;

  var conversationSelector = __WEBPACK_IMPORTED_MODULE_12_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
  var conversation = conversationSelector(state, { conversationId: conversationId });
  var endUserId = conversation.endUserId;
  var endUserSelector = __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_selectors__["g" /* makeEndUserSelector */]();
  var endUser = endUserSelector(state, { id: endUserId });
  var usersById = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["orgUsersById"](state).toJS();

  if (authorUserId !== 0) {
    var notification = void 0;
    switch (type) {
      case 'ADDED_PARTICIPANTS':
        notification = Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_participants_utils__["a" /* formatParticipantsNotification */])(authorUserId, conversationEvent, usersById, endUser, true);
        break;
      case 'REMOVED_PARTICIPANTS':
        notification = Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_participants_utils__["a" /* formatParticipantsNotification */])(authorUserId, conversationEvent, usersById, endUser, false);
        break;
    }

    if (!!notification) {
      Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["f" /* notifyParticipants */])(notification, message);
    }
  }
};

function browserNotification(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["u" /* SocketChannel */].USER;
  }).switchMap(function (_ref) {
    var channel = _ref.channel,
        leaveChannel$ = _ref.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('browser-notification', function (payload) {
        var state = store.getState();
        var currentUser = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](state);

        var message = payload.body.message;


        if (_.get(message, 'contentType') === 'CHAT') {
          var userProperties = __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */](state);
          var soundSetting = userProperties.get('humane-notifications-browser-sound', 'click');
          Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["e" /* notifyNewMessage */])(message);
          if (soundSetting !== 'none') Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["h" /* soundNotification */])(soundSetting);
          Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["a" /* displayTabIndicator */])();
        }
        if (_.get(message, 'contentType') === 'CONVERSATION_EVENT' && _.includes(message.conversationEvent.participantIds, currentUser.id)) {
          var conversationId = message.conversationId;

          var conversationSelector = __WEBPACK_IMPORTED_MODULE_12_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
          var conversation = conversationSelector(state, { conversationId: conversationId });
          if (!!conversation) {
            createParticipantNotification(state, message);
          } else {
            observer.next(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* fetchConvoForParticipantNotification */]({ message: message }));
          }
        }
      });
    }).takeUntil(leaveChannel$);
  });
}

function fetchConversationForNotification(action$, _ref2) {
  var getState = _ref2.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* fetchConvoForParticipantNotification */].toString()).mergeMap(function (message) {
    // Wait for conversation
    var conversationId = message.conversationId;

    var conversationSelector = __WEBPACK_IMPORTED_MODULE_12_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
    var conversation = conversationSelector(getState(), { conversationId: conversationId });
    if (!conversation) {
      return action$.ofType(__WEBPACK_IMPORTED_MODULE_11_app_modules_conversation_actions__["J" /* receiveConversation */].toString()).pluck('payload', 'conversation').filter(function (conversation) {
        return conversation.id === conversationId;
      }).map(function () {
        return message;
      }).first();
    }

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(message);
  }).mergeMap(function (message) {
    // Wait for endUser
    var state = getState();
    var conversationSelector = __WEBPACK_IMPORTED_MODULE_12_app_modules_conversation_selectors__["p" /* makeConversationSelector */]();
    var conversation = conversationSelector(state, { conversationId: message.conversationId });
    if (!conversation) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
    }
    var endUserSelector = __WEBPACK_IMPORTED_MODULE_10_app_modules_endUser_selectors__["g" /* makeEndUserSelector */]();
    var endUser = endUserSelector(state, { id: conversation.endUserId });

    if (!endUser) {
      return action$.ofType(__WEBPACK_IMPORTED_MODULE_9_app_modules_endUser_actions__["B" /* receiveEndUser */].toString()).pluck('payload').filter(function (endUser) {
        return endUser.id === conversation.endUserId;
      }).map(function () {
        return message;
      }).first();
    }

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(message);
  }).do(function (message) {
    var state = getState();
    createParticipantNotification(state, message);
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
  }); // Don't dispatch any actions
}

function followBrowserNotifications(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_0_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref3) {
    var channel = _ref3.channel,
        leaveChannel$ = _ref3.leaveChannel$;

    var settings = __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */](store.getState());
    var hasFollowEnabled = settings.get('follow_accounts');
    var currentUserId = __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentUser"](store.getState()).id;
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function () {
      channel.on('end-user-presence', function (payload) {
        if (payload.userId === currentUserId) {
          Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["c" /* notifyFollowing */])(payload);
        }
      });
      if (__WEBPACK_IMPORTED_MODULE_18_utils_Access__["c" /* default */].hasGates('ACCOUNTS_FOLLOW') && hasFollowEnabled) {
        channel.on('account-presence', function (payload) {
          var isOwner = payload.account.ownerId === currentUserId;
          isOwner && Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["d" /* notifyFollowingAccount */])(payload);
        });
      }
    }).takeUntil(leaveChannel$);
  });
}

var isAbmNotificationClick = function isAbmNotificationClick(event) {
  return event.data && event.data.onClickUrl && event.data.onClickUrl.indexOf('endUserId') > -1;
};

var isSoundMessage = function isSoundMessage(event) {
  return event.data === 'notification';
};

var subscribeToMessages = function subscribeToMessages() {
  return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].fromEvent(navigator.serviceWorker, 'message');
};

var registerServiceWorker$ = function registerServiceWorker$() {
  var promise = navigator.serviceWorker.register(__WEBPACK_IMPORTED_MODULE_3__driftt_serviceworker_notifications__["SW_PATHNAME"]).then(function (swRegistration) {
    // Checks if service worker script has been updated if the service worker is already running
    // and reloads with the new script if it has changed
    swRegistration.update();

    return swRegistration.pushManager.getSubscription().then(function (subscription) {
      if (subscription) {
        return Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["j" /* updateSubscriptionOnServer */])(subscription);
      } else {
        var applicationServerKey = Object(__WEBPACK_IMPORTED_MODULE_15_utils_ByteArrayConversionHelper__["a" /* urlB64ToUint8Array */])(__WEBPACK_IMPORTED_MODULE_14_constants_NotificationConstants__["a" /* WEB_PUSH_SERVER_PUBLIC_KEY */]);

        return swRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: applicationServerKey
        }).then(function (subscription) {
          return Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["j" /* updateSubscriptionOnServer */])(subscription);
        });
      }
    }).catch(console.error);
  });

  return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].fromPromise(promise);
};

var isServiceWorkerSupportedAndDesktopNotificationsEnabled = function isServiceWorkerSupportedAndDesktopNotificationsEnabled(state) {
  return function () {
    return 'serviceWorker' in navigator && 'PushManager' in window && !Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__["s" /* hasWebSocketChatNotifications */])(state) && Notification.permission === 'granted';
  };
};

var registerForPushNotifications = function registerForPushNotifications(action$, _ref4) {
  var getState = _ref4.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__["receiveCurrentUser"].toString()).filter(isServiceWorkerSupportedAndDesktopNotificationsEnabled(getState())).first().mergeMap(registerServiceWorker$).map(function () {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* serviceWorkerRegistered */]();
  }).catch(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* failedToRegisterServiceWorker */]());
  });
};

var subsribeOnServiceWorkerMessages = function subsribeOnServiceWorkerMessages(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* SW_REGISTRATION_SUCCESS */]).mergeMap(function () {
    return subscribeToMessages();
  }).map(function (r) {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* serviceWorkerMessage */](r);
  });
};

var playSoundOnNotificationClick = function playSoundOnNotificationClick(action$, _ref5) {
  var getState = _ref5.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* SERVICE_WORKER_MESSAGE */]).pluck('payload').filter(isSoundMessage).do(function () {
    var userProperties = __WEBPACK_IMPORTED_MODULE_6_app_modules_user_properties_selectors__["g" /* properties */](getState());
    var soundSetting = userProperties.get('humane-notifications-browser-sound', 'click');
    if (soundSetting !== 'none') Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["i" /* soundNotificationImmediate */])(soundSetting);
    Object(__WEBPACK_IMPORTED_MODULE_16_utils_NotificationHelper__["a" /* displayTabIndicator */])();
  }).map(function () {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* soundPlayed */]();
  }).catch(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* soundPlayFailed */]());
  });
};

var toEndUserIdAndAttributes = function toEndUserIdAndAttributes(event) {
  var url = new URL('' + window.location.origin + event.data.onClickUrl);
  return {
    endUserId: url.searchParams.get('endUserId'),
    companyName: url.searchParams.get('companyName'),
    page: url.searchParams.get('page')
  };
};

var showModalOnAbmNotificationClick = function showModalOnAbmNotificationClick(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* SERVICE_WORKER_MESSAGE */]).pluck('payload').filter(isAbmNotificationClick).map(toEndUserIdAndAttributes).map(function (endUserIdAndAttributes) {
    return __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* showAbmModal */](endUserIdAndAttributes);
  }).catch(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* showAbmModalFailed */]());
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(browserNotification, fetchConversationForNotification, followBrowserNotifications, registerForPushNotifications, subsribeOnServiceWorkerMessages, playSoundOnNotificationClick, showModalOnAbmNotificationClick);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "TAJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EventTable__ = __webpack_require__("Bbe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("diFG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("gndv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var IntegrationEventLog = function (_Component) {
  _inherits(IntegrationEventLog, _Component);

  function IntegrationEventLog() {
    _classCallCheck(this, IntegrationEventLog);

    return _possibleConstructorReturn(this, (IntegrationEventLog.__proto__ || Object.getPrototypeOf(IntegrationEventLog)).apply(this, arguments));
  }

  _createClass(IntegrationEventLog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var integrationId = this.props.params.integrationId;


      if (!__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* allowedIntegrations */].includes(integrationId)) {
        this.context.router.push('/settings2/integrations');
      }
    }
  }, {
    key: 'getBackLinkUrl',
    value: function getBackLinkUrl(integrationId) {
      switch (integrationId) {
        case 'eloqua':
          return '/settings/setup/eloqua';
        case 'pardot':
          return '/settings/setup/pardot';
        default:
          return '/settings/setup/' + integrationId;
      }
    }
  }, {
    key: 'renderMarketoInfo',
    value: function renderMarketoInfo() {
      if (!__WEBPACK_IMPORTED_MODULE_9_utils_Access__["c" /* default */].hasGates('HAS_MARKETO_SYNC_LIST')) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'integration-event-log--extra-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'info', height: 14 }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Pro tip: If you\u2019ve imported any Marketo lists, those logs are located in the Contacts tab.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/contacts/imports/logs', className: 'integration-event-log--extra-info-link', target: '_blank' },
          'View Marketo Import Logs'
        )
      );
    }
  }, {
    key: 'renderPardotInfo',
    value: function renderPardotInfo() {
      if (!__WEBPACK_IMPORTED_MODULE_9_utils_Access__["c" /* default */].hasGates('HAS_PARDOT_SYNC_LIST')) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'integration-event-log--extra-info' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { name: 'info', height: 14 }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Pro tip: If you\u2019ve imported any Pardot lists, those logs are located in the Contacts tab.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/contacts/imports/logs', className: 'integration-event-log--extra-info-link', target: '_blank' },
          'View Pardot Import Logs'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var integrationId = this.props.params.integrationId;

      var displayName = Object(__WEBPACK_IMPORTED_MODULE_5_humanize_plus__["capitalize"])(integrationId, true);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: displayName + ' Integration',
          backLinkUrl: this.getBackLinkUrl(integrationId)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            displayName,
            ' Event Log'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Here\u2019s a view of what data are passing between ',
            displayName,
            ' and Drift. We\u2019ll report all events and errors in the table below up until the last 60 days.'
          ),
          integrationId === 'marketo' && this.renderMarketoInfo(),
          integrationId === 'pardot' && this.renderPardotInfo()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_EventTable__["a" /* default */], { sourceId: integrationId })
      );
    }
  }]);

  return IntegrationEventLog;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IntegrationEventLog.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (IntegrationEventLog);

/***/ }),

/***/ "TDXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REQUEST_BULK_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REQUEST_BULK_UPDATE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REQUEST_BULK_UPDATE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REQUEST_BULK_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RECEIVE_BULK_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_BULK_UPDATE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_BULK_UPDATE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_BULK_UPDATE_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('conversation/bulkUpdate');

var REQUEST_BULK_UPDATE = makeConstant('REQUEST_BULK_UPDATE');
var REQUEST_BULK_UPDATE_PENDING = makeConstant('REQUEST_BULK_UPDATE_PENDING');
var REQUEST_BULK_UPDATE_FAILED = makeConstant('REQUEST_BULK_UPDATE_FAILED');
var REQUEST_BULK_UPDATE_SUCCESS = makeConstant('REQUEST_BULK_UPDATE_SUCCESS');

var RECEIVE_BULK_UPDATE = makeConstant('RECEIVE_BULK_UPDATE');
var RECEIVE_BULK_UPDATE_PENDING = makeConstant('RECEIVE_BULK_UPDATE_PENDING');
var RECEIVE_BULK_UPDATE_FAILED = makeConstant('RECEIVE_BULK_UPDATE_FAILED');
var RECEIVE_BULK_UPDATE_SUCCESS = makeConstant('RECEIVE_BULK_UPDATE_SUCCESS');

/***/ }),

/***/ "TFJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgId", function() { return orgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userGates", function() { return userGates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "org", function() { return org; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "endUserCount", function() { return endUserCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgName", function() { return orgName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgHandle", function() { return orgHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "properties", function() { return properties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actualProperties", function() { return actualProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIsVidyardEnabled", function() { return getIsVidyardEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOutboundInboxId", function() { return getOutboundInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgCutover", function() { return orgCutover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasCustomizedAssistantSFDCMapping", function() { return hasCustomizedAssistantSFDCMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasCustomizedAssistantSFDCActivity", function() { return hasCustomizedAssistantSFDCActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateCreatedAt", function() { return getDateCreatedAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgLogoUrl", function() { return orgLogoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arePropertiesLoaded", function() { return arePropertiesLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoaded", function() { return isLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasAutoCreatedOBPB", function() { return hasAutoCreatedOBPB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLimitedContactsMktEmail", function() { return hasLimitedContactsMktEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("7zgI");



var EMPTY_MAP = {};

var orgId = function orgId(state) {
  return state.getIn(['currentUser', 'user', 'orgId']);
};
var userGates = function userGates(state) {
  return state.getIn(['currentUser', 'user', 'gates']);
};
var org = function org(state) {
  return state.getIn(['org', 'data']);
};
var endUserCount = function endUserCount(state) {
  return state.getIn(['org', 'endUserCount']);
};
var orgName = function orgName(state) {
  return state.getIn(['org', 'data', 'name']);
};
var orgHandle = function orgHandle(state) {
  return state.getIn(['org', 'data', 'handle']);
};
var status = function status(state) {
  return state.getIn(['org', 'status', 'update']);
};
var properties = function properties(state) {
  return state.getIn(['org', 'data', 'properties']) || EMPTY_MAP;
};
var actualProperties = function actualProperties(state) {
  return state.getIn(['org', 'data', 'properties']);
};
var getIsVidyardEnabled = function getIsVidyardEnabled(state) {
  return properties(state).isVidyardEnabled;
};
var getOutboundInboxId = function getOutboundInboxId(state) {
  return properties(state).outboundInboxId;
};
var orgCutover = function orgCutover(state, cutoverName) {
  return state.getIn(['org', cutoverName]);
};

var hasCustomizedAssistantSFDCMapping = function hasCustomizedAssistantSFDCMapping(state) {
  return _.get(properties(state), 'hasCustomizedAssistantSFDCMapping', false);
};
var hasCustomizedAssistantSFDCActivity = function hasCustomizedAssistantSFDCActivity(state) {
  return _.get(properties(state), 'hasCustomizedAssistantSFDCActivity', false);
};

var getDateCreatedAt = function getDateCreatedAt(state) {
  return state.getIn(['org', 'data', 'createdAt']);
};

var orgLogoUrl = function orgLogoUrl(state) {
  if (!!state.getIn(['org', 'data', 'properties'])) return state.getIn(['org', 'data', 'properties'])['org-logo-url'];
  return null;
};

var arePropertiesLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['org', 'data', 'properties']);
}, function (properties) {
  return !!properties;
});

var isLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['org', 'status', 'fetch']);
}, function (orgFetchStatus) {
  return orgFetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* constants */].RECEIVE_ORG;
});

var hasAutoCreatedOBPB = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(orgId, function (orgId) {
  return orgId >= 1066286;
}); // this is the first orgId after the backend code was merged

var hasLimitedContactsMktEmail = function hasLimitedContactsMktEmail(state) {
  return state && state.getIn(['org', 'hasLimitedContactsMktEmail']);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "TJAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("aheP");















var mapStateToProps = function mapStateToProps(state) {
  var question = __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["N" /* getCurrentQuestionByAnswer */](state);
  return {
    answer: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["J" /* getCurrentAnswer */](state),
    question: question,
    hasSpecialKeyword: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["K" /* getCurrentAnswerHasSpecialKeyword */](state),
    skipToOptions: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_96" /* skipToOptions */](state),
    currentSkipToOption: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["l" /* currentSkipToOption */](state),
    buttonOnlyResponses: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["g" /* buttonOnlyResponses */](state, question.id)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideAnswerModal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_76" /* hideAnswerModal */],
      setAnswerType: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_136" /* setAnswerType */],
      setButtonText: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_140" /* setButtonText */],
      addKeyword: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["i" /* addKeyword */],
      setResponse: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_188" /* setResponse */],
      flagAnswer: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_66" /* flagAnswer */],
      setSkipTo: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_209" /* setSkipTo */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (props) {
  return {
    isKeywords: props.answer.type === __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["t" /* AnswerType */].KEYWORDS,
    isFlagged: props.answer.id === props.question.defaultAnswerId
  };
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      var hideAnswerModal = props.actions.hideAnswerModal;

      hideAnswerModal();
    };
  },
  onButtonTextChange: function onButtonTextChange(props) {
    return function (event) {
      var setButtonText = props.actions.setButtonText,
          answerId = props.answer.id;

      setButtonText({ answerId: answerId, buttonText: event.target.value });
    };
  },
  onClickKeywordsType: function onClickKeywordsType(props) {
    return function () {
      var setAnswerType = props.actions.setAnswerType,
          answerId = props.answer.id;

      setAnswerType({ answerId: answerId, type: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["t" /* AnswerType */].KEYWORDS });
    };
  },
  onClickButtonType: function onClickButtonType(props) {
    return function () {
      var setAnswerType = props.actions.setAnswerType,
          answerId = props.answer.id;

      setAnswerType({ answerId: answerId, type: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants__["t" /* AnswerType */].BUTTON });
    };
  },
  onAddYesKeywordClick: function onAddYesKeywordClick(props) {
    return function () {
      var addKeyword = props.actions.addKeyword,
          answerId = props.answer.id;

      addKeyword({
        answerId: answerId,
        keyword: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["j" /* Keyword */]({ id: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__["a" /* weakUuid */])(), special: true, text: 'Yes' })
      });
    };
  },
  onAddNoKeywordClick: function onAddNoKeywordClick(props) {
    return function () {
      var addKeyword = props.actions.addKeyword,
          answerId = props.answer.id;

      addKeyword({
        answerId: answerId,
        keyword: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["j" /* Keyword */]({ id: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__["a" /* weakUuid */])(), special: true, text: 'No' })
      });
    };
  },
  onAddGenericKeywordClick: function onAddGenericKeywordClick(props) {
    return function () {
      var addKeyword = props.actions.addKeyword,
          answerId = props.answer.id;

      addKeyword({
        answerId: answerId,
        keyword: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["j" /* Keyword */]({ id: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__["a" /* weakUuid */])() })
      });
    };
  },
  onFlagClick: function onFlagClick(props) {
    return function () {
      var isFlagged = props.isFlagged,
          flagAnswer = props.actions.flagAnswer,
          answerId = props.answer.id,
          questionId = props.question.id;

      flagAnswer({ questionId: questionId, answerId: isFlagged ? null : answerId });
    };
  },
  onSkipToChange: function onSkipToChange(props) {
    return function (value) {
      var setSkipTo = props.actions.setSkipTo,
          answerId = props.answer.id;

      var _ref = value ? value.value : {},
          _ref$isGoal = _ref.isGoal,
          isGoal = _ref$isGoal === undefined ? false : _ref$isGoal,
          _ref$id = _ref.id,
          skipToId = _ref$id === undefined ? null : _ref$id;

      setSkipTo({ answerId: answerId, isGoal: isGoal, skipToId: skipToId });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));

/***/ }),

/***/ "TJez":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(51);

/***/ }),

/***/ "TKIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__ = __webpack_require__("GoMo");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var SavedReplyAPI = Marty.createStateSource({
  id: 'SavedReplyAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["i" /* CONVERSATION_API */],

  fetchReplies: function fetchReplies() {
    return this.get({
      url: '/snippets',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchReply: function fetchReply(replyId) {
    return this.get({
      url: '/snippets/' + replyId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createReply: function createReply(reply) {
    return this.post({
      url: '/snippets',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__["a" /* JSON */],
      body: JSON.stringify(reply)
    });
  },
  updateReply: function updateReply(replyId, reply) {
    return this.patch({
      url: '/snippets/' + replyId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_constants_RequestContentType__["a" /* JSON */],
      body: JSON.stringify(reply)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SavedReplyAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "TL61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Enrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return User; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BareUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("aJZK");



var Avatars = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  image200: undefined,
  squareCropImage200: undefined
});

var Enrichment = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  bio: null,
  city: null,
  country: null,
  display_location: null,
  display_name: null,
  employment_name: null,
  employment_role: null,
  employment_seniority: null,
  employment_title: null,
  first_name: null,
  gender: null,
  github_followers: null,
  github_handle: null,
  twitter_followers: null,
  twitter_handle: null,
  last_name: null,
  latitude: null,
  linkedin_handle: null,
  longitude: null,
  site: null,
  state: null
});

var User = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  name: undefined,
  alias: null,
  availability: 'OFFLINE',
  avatarUrl: undefined,
  avatars: Avatars(),
  bot: false,
  createdAt: undefined,
  email: undefined,
  externalId: null,
  gates: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  scopes: [],
  roles: [],
  locale: null,
  phone: null,
  profile: null,
  role: undefined,
  slackUserId: null,
  status: __WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* UserStatus */].ARCHIVED,
  timezone: null,
  type: undefined,
  verified: false,
  teams: [],
  workspaceRoles: [],
  features: []
});

var BareUser = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  type: undefined
});

/***/ }),

/***/ "TNwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("2712");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("tHDv");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("SRF/");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("hmNJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });








/***/ }),

/***/ "TOwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_copy_to_clipboard__ = __webpack_require__("sQ20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__page__ = __webpack_require__("Ybad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("xJzF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_info_icon_svg__ = __webpack_require__("PRJa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_info_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_info_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("CwoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);














var INFO_SLUG_CHANGE_COPY = "Changing your meeting link will not automatically update \r\nany links you've shared outside of Drift. Change this with care!";

var HelpIcon = function HelpIcon(_ref) {
  var copy = _ref.copy;
  return React.createElement(
    'div',
    { className: 'inline-help-icon-tooltip' },
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
      {
        flow: 'up',
        component: React.createElement(
          'span',
          null,
          copy
        ) },
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_info_icon_svg___default.a, style: { display: 'block' } })
    )
  );
};

var MEETING_NOTIFICATION_COPY = Object.freeze({
  confirmation: 'Automatic confirmation emails for your guests are enabled.',
  reminder: 'Automatic reminder emails for your guests are enabled.',
  both: 'Automatic confirmation and reminder emails for your guests are enabled.'
});

var MeetingTypeEdit = function MeetingTypeEdit(_ref2) {
  var settings = _ref2.settings,
      isDefault = _ref2.isDefault,
      isCopied = _ref2.isCopied,
      isSaving = _ref2.isSaving,
      profileUrl = _ref2.profileUrl,
      handleUpdateMeetingName = _ref2.handleUpdateMeetingName,
      handleDurationSelect = _ref2.handleDurationSelect,
      handleChangeMeetingSlug = _ref2.handleChangeMeetingSlug,
      handleUpdateMeetingLocation = _ref2.handleUpdateMeetingLocation,
      handleUpdateMeetingDescription = _ref2.handleUpdateMeetingDescription,
      isSlugInConflict = _ref2.isSlugInConflict,
      isSlugEmpty = _ref2.isSlugEmpty,
      isSlugReserved = _ref2.isSlugReserved,
      isSlugValid = _ref2.isSlugValid,
      isSlugChanged = _ref2.isSlugChanged,
      isTitleEmpty = _ref2.isTitleEmpty,
      handleCopyMeetingLink = _ref2.handleCopyMeetingLink,
      isSettingsChanged = _ref2.isSettingsChanged,
      isTitleChanged = _ref2.isTitleChanged,
      handleSave = _ref2.handleSave,
      placeholderSlug = _ref2.placeholderSlug,
      confirmationEmailStatus = _ref2.confirmationEmailStatus,
      reminderEmailStatus = _ref2.reminderEmailStatus;

  var meetingLink = '' + profileUrl + (isDefault ? '?schedule' : '/' + settings.slug);
  var meetingNotificationCopy = confirmationEmailStatus && reminderEmailStatus ? MEETING_NOTIFICATION_COPY.both : confirmationEmailStatus ? MEETING_NOTIFICATION_COPY.confirmation : MEETING_NOTIFICATION_COPY.reminder;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_5__page__["a" /* default */],
    { hideHeader: true },
    React.createElement(
      'div',
      { className: 'meeting-type-edit-wrapper tide-form' },
      React.createElement(
        'div',
        { className: 'header' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
          { className: 'settings-nav', to: '/settings/calendar' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'settings-nav-back-bracket', width: 6, name: 'arrow-1-left' }),
          React.createElement(
            'div',
            null,
            'Back to Calendar Settings'
          )
        ),
        React.createElement(
          'div',
          { className: 'meeting-type-edit-section' },
          React.createElement('img', {
            className: 'meeting-type-edit-duration-icon',
            src: __WEBPACK_IMPORTED_MODULE_6__constants__["c" /* MEETING_ICON_TO_DURATION */]['' + settings.duration]
          }),
          React.createElement(
            'div',
            { className: 'meeting-type-edit-duration' },
            React.createElement(
              'div',
              { className: 'meeting-type-edit-subheader' },
              'Meeting Duration'
            ),
            React.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select_plus__["b" /* default */], {
              className: 'meeting-type-edit-duration-select',
              value: settings.duration,
              options: __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* CUSTOM_MEETING_LENGTH_OPTIONS */],
              onChange: handleDurationSelect,
              clearable: false,
              searchable: false
            })
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'meeting-type-edit-setting' },
        React.createElement(
          'div',
          { className: 'meeting-type-edit-control' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
            type: 'text',
            label: React.createElement(
              'div',
              null,
              'Public Calendar Event Title ',
              React.createElement(
                'span',
                { className: 'muted' },
                '(required)'
              )
            ),
            className: 'meeting-type-input',
            defaultValue: settings.name,
            onChange: handleUpdateMeetingName,
            placeholder: settings.duration + ' Minute Meeting'
          }),
          isTitleEmpty && isTitleChanged ? React.createElement(
            'div',
            { className: 'meeting-type-edit-helptext error' },
            'Please fill out a name for your meeting type. It will be used when people book time with you.'
          ) : React.createElement(
            'div',
            { className: 'meeting-type-edit-description meeting-type-edit-helptext' },
            'This should describe the type of meeting people are booking with you.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'meeting-type-edit-setting' },
        React.createElement(
          'div',
          { className: 'meeting-type-edit-subheader' },
          React.createElement(
            'div',
            { className: 'meeting-type-subheader-with-info' },
            'Meeting Link',
            React.createElement(
              'span',
              { className: 'muted' },
              isDefault ? ' (the default link cannot be changed)' : ' (required)'
            ),
            !isDefault && React.createElement(HelpIcon, { copy: INFO_SLUG_CHANGE_COPY })
          )
        ),
        React.createElement(
          'div',
          { className: 'meeting-type-edit-control' },
          isDefault ? React.createElement('input', { type: 'text', className: 'tide-input', value: profileUrl + '?schedule', disabled: true }) : React.createElement(
            'div',
            { className: 'meeting-type-edit-slug-wrapper' },
            React.createElement(
              'div',
              { className: 'faux-input-wrapper' },
              React.createElement(
                'span',
                { className: 'faux-input-prefix' },
                profileUrl,
                '/'
              ),
              React.createElement('input', {
                type: 'text',
                className: 'tide-input',
                autoCorrect: 'off',
                value: settings.slug,
                placeholder: settings.duration + 'm-' + placeholderSlug,
                onChange: handleChangeMeetingSlug
              })
            ),
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_copy_to_clipboard___default.a,
              { text: meetingLink, onCopy: handleCopyMeetingLink },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
                {
                  className: 'meeting-link-copy',
                  type: 'tertiary',
                  disabled: !isSlugValid && isSlugChanged,
                  onClick: handleCopyMeetingLink
                },
                React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'meeting-link-copy-icon', width: 12, name: 'link-1' }),
                ' ',
                isCopied ? 'Copied!' : 'Copy Link'
              )
            )
          ),
          isSlugInConflict && React.createElement(
            'div',
            { className: 'meeting-type-edit-helptext error' },
            'This link is already in use.'
          ),
          isSlugChanged && isSlugEmpty && React.createElement(
            'div',
            { className: 'meeting-type-edit-helptext error' },
            'Meeting link cannot be empty.'
          ),
          isSlugReserved && React.createElement(
            'div',
            { className: 'meeting-type-edit-helptext error' },
            'Meeting link cannot be a reserved word.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'meeting-type-edit-setting' },
        React.createElement(
          'div',
          { className: 'meeting-type-edit-control' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
            type: 'text',
            label: 'Location',
            className: 'meeting-type-input',
            defaultValue: settings.location,
            onChange: handleUpdateMeetingLocation,
            placeholder: 'phone call, zoom.us, join.me, Skype, 123 Drift Street'
          })
        ),
        React.createElement(
          'div',
          { className: 'meeting-type-edit-helptext' },
          'This is where your meeting will take place.'
        )
      ),
      React.createElement(
        'div',
        { className: 'meeting-type-edit-setting' },
        React.createElement(
          'div',
          { className: 'meeting-type-edit-control' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["TextArea"], {
            label: 'Description / Meeting Instructions',
            placeholder: 'Describe what your attendees can expect from this meeting',
            onChange: handleUpdateMeetingDescription,
            defaultValue: settings.inviteDescription
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'meeting-notification-copy-wrapper' },
        React.createElement(
          'div',
          { className: 'meeting-notification-header' },
          'Meeting Notifications'
        ),
        React.createElement(
          'div',
          { className: 'meeting-notification-copy' },
          meetingNotificationCopy,
          ' ',
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
            { to: '/settings/calendar/advanced' },
            'View Calendar Settings'
          )
        )
      ),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
        {
          className: 'meeting-type-edit-save-button',
          onClick: handleSave,
          type: 'primary',
          disabled: !isSettingsChanged || isSaving || !isSlugValid || isTitleEmpty
        },
        isSaving ? 'Saving...' : 'Save & Finish'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MeetingTypeEdit);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "TPdv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__("6QfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style__);




var SubmitEmailBox = function SubmitEmailBox(_ref) {
  var backgroundColor = _ref.backgroundColor;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'submit-email-preview-box' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      'Email Address'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'input' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'submit-button',
          style: {
            backgroundColor: backgroundColor
          } },
        'Submit'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SubmitEmailBox);

/***/ }),

/***/ "TSCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__ = __webpack_require__("W8CA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_store__ = __webpack_require__("Tvnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* eslint-disable
    import/no-duplicates,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var DefaultEmbedQueries = Marty.createQueries({
  id: 'DefaultEmbedQueries',

  fetchDefaultEmbed: function fetchDefaultEmbed(orgId) {
    var _this = this;

    var promise = this.app.sources.DefaultEmbedAPI.fetchDefaultEmbed(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_FETCH_DONE, orgId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_FETCH_FAILED, orgId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_FETCH_FAILED, orgId, error);
    });
  },
  updateDefaultEmbed: function updateDefaultEmbed(configuration, notificationMessage) {
    var operations = Object(__WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__["a" /* patchOperations */])(configuration, {});
    return this.patchDefaultEmbed(operations, notificationMessage);
  },
  patchDefaultEmbed: function patchDefaultEmbed(operations, notificationMessage) {
    var _this2 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_START, {});
    var promise = this.app.sources.DefaultEmbedAPI.patchDefaultEmbed(operations);

    promise.then(function (res) {
      if (res.status === 200) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_DONE, res.body);
        __WEBPACK_IMPORTED_MODULE_3_containers_store__["a" /* default */].dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["i" /* patchEmbedSuccess */])(res.body));
        if (notificationMessage) {
          return _this2.app.actions.NotificationActions.pushNotification({
            content: notificationMessage
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_FAILED, operations, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_PATCH_FAILED, operations, res);
    });
  },
  refreshDefaultEmbed: function refreshDefaultEmbed(orgId) {
    var _this3 = this;

    return this.app.sources.DefaultEmbedAPI.refreshDefaultEmbed(orgId).then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_REFRESH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_REFRESH_FAILED, orgId);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].DEFAULT_EMBED_REFRESH_FAILED, orgId);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (DefaultEmbedQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "TSnc":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 243 187\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group 2</title><desc>Created with Sketch.</desc><defs><rect id=\"path-1\" x=\"0\" y=\"23\" width=\"25\" height=\"25\" rx=\"12.5\"></rect><pattern id=\"pattern-2\" patternUnits=\"objectBoundingBox\" x=\"0%\" width=\"100%\" height=\"100%\"><use xlink:href=\"#image-3\" transform=\"scale(0.1953125,0.1953125)\"></use></pattern><image id=\"image-3\" width=\"128\" height=\"128\" xlink:href=\"data:image/png;base64,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\"></image><rect id=\"path-5\" x=\"0\" y=\"163\" width=\"25\" height=\"25\" rx=\"12.5\"></rect><pattern id=\"pattern-6\" patternUnits=\"objectBoundingBox\" x=\"0%\" width=\"100%\" height=\"100%\"><use xlink:href=\"#image-7\" transform=\"scale(0.1953125,0.1953125)\"></use></pattern><image id=\"image-7\" width=\"128\" height=\"128\" xlink:href=\"data:image/png;base64,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\"></image></defs><g id=\"opt-in\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"people-without-routing-rules-(free-+-standard)-confirmation\" transform=\"translate(-766.000000, -579.000000)\"><g id=\"Group-2\" transform=\"translate(766.000000, 578.000000)\"><path d=\"M106,61 L233,61 L233,61 C238.522848,61 243,65.4771525 243,71 L243,79.9999986 L243,79.9999986 C243,85.522846 238.522847,89.9999985 233,89.9999986 L106,89.9999999 L106,90 C100.477153,90.0000001 96.0000001,85.5228476 96,80.0000001 L96.0000001,71 L96.0000001,71 C96.0000001,65.4771525 100.477153,61 106,61 Z\" id=\"Feeback-Copy-25\" fill=\"#2D88F3\" transform=\"translate(169.500000, 75.500000) scale(-1, 1) translate(-169.500000, -75.500000) \"></path><path d=\"M43.0623594,18 L172.937641,18 L172.937641,18 C178.494928,18 183,22.5050717 183,28.0623593 L183,42.9376398 L183,42.9376398 C183,48.4949274 178.494928,52.9999991 172.937641,52.9999992 L43.0623594,52.9999999 L43.0623594,53 C37.5050718,53 33,48.4949283 33,42.9376407 L33.0000001,28.0623593 L33.0000001,28.0623593 C33.0000001,22.5050717 37.5050718,18 43.0623594,18 Z\" id=\"Feeback-Copy-26\" fill=\"#F8F8F8\"></path><path d=\"M43,100 L201,100 L201,100 C206.522847,100 211,104.477153 211,110 L211,177.999998 L211,177.999998 C211,183.522845 206.522847,187.999998 201,187.999998 L43,188 L43,188 C37.4771525,188 33,183.522848 32.9999999,178 C32.9999999,178 32.9999999,178 32.9999999,178 L33,110 L33,110 C33,104.477153 37.4771525,100 43,100 Z\" id=\"Feeback-Copy-27\" fill=\"#F8F8F8\"></path><text id=\"How-can-i-help?-I-se\" font-family=\"BrandonText-Regular, Brandon Text\" font-size=\"12\" font-weight=\"normal\" fill=\"#000000\"><tspan x=\"46\" y=\"124\">How can i help? I see that </tspan><tspan x=\"46\" y=\"141\">you’re over in Boston! Hope </tspan><tspan x=\"46\" y=\"158\">the weather’s nice over </tspan><tspan x=\"46\" y=\"175\">there :)</tspan></text><text id=\"Hi---yes-I-have-a-co\" font-family=\"BrandonText-Regular, Brandon Text\" font-size=\"12\" font-weight=\"normal\" fill=\"#FFFFFF\"><tspan x=\"110\" y=\"79\">Hi - yes I have a couple</tspan></text><path d=\"M42,38.0179325 C42,38.1339662 42.1035599,38.2383966 42.2186264,38.2383966 L42.6673858,38.2383966 C42.793959,38.2383966 42.8860122,38.1339662 42.8860122,38.0179325 L42.8860122,34.5021097 L47.5577131,34.5021097 L47.5577131,38.0179325 C47.5577131,38.1339662 47.6497663,38.2383966 47.7763394,38.2383966 L48.2250989,38.2383966 C48.3401654,38.2383966 48.4437253,38.1339662 48.4437253,38.0179325 L48.4437253,30.3364979 C48.4437253,30.2204641 48.3401654,30.1160338 48.2250989,30.1160338 L47.7763394,30.1160338 C47.6497663,30.1160338 47.5577131,30.2204641 47.5577131,30.3364979 L47.5577131,33.7246835 L42.8860122,33.7246835 L42.8860122,30.3364979 C42.8860122,30.2204641 42.793959,30.1160338 42.6673858,30.1160338 L42.2186264,30.1160338 C42.1035599,30.1160338 42,30.2204641 42,30.3364979 L42,38.0179325 Z M49.9510967,35.5580169 C49.9510967,34.0495781 50.9176555,32.7616034 52.5285868,32.7616034 C53.9208918,32.7616034 54.9334772,33.7943038 54.9334772,35.1983122 C54.9334772,35.2911392 54.9219705,35.4303797 54.9104639,35.5232068 C54.8989572,35.6624473 54.7838907,35.7552743 54.6688242,35.7552743 L50.802589,35.7552743 C50.8256023,36.6487342 51.5735347,37.5886076 52.5400935,37.5886076 C53.2419993,37.5886076 53.6792521,37.3449367 53.978425,37.1476793 C54.1625315,37.0200422 54.243078,36.9736287 54.3811579,37.1824895 L54.5192377,37.3797468 C54.6227976,37.5421941 54.6688242,37.600211 54.4732111,37.7510549 C54.1510248,38.0063291 53.449119,38.3660338 52.5285868,38.3660338 C50.9176555,38.3660338 49.9510967,37.0896624 49.9510967,35.5580169 Z M50.8140956,35.0706751 L54.0819849,35.0706751 C54.0589716,34.2816456 53.4376124,33.5390295 52.5285868,33.5390295 C51.631068,33.5390295 50.9176555,34.2352321 50.8140956,35.0706751 Z M57.6260338,38.2267932 L56.6019417,40.6751055 C56.5213952,40.8607595 56.6134484,41 56.8205681,41 L57.2348076,41 C57.3268608,41 57.4304207,40.9187764 57.4649407,40.8375527 L60.7903632,33.1793249 C60.8709097,33.0052743 60.7903632,32.8776371 60.5832434,32.8776371 L60.1574973,32.8776371 C60.0539374,32.8776371 59.9618842,32.935654 59.9273643,33.028481 L58.1323265,37.2869198 L58.1093132,37.2869198 L56.6019417,33.028481 C56.5674218,32.935654 56.4753686,32.8776371 56.3718087,32.8776371 L55.8885293,32.8776371 C55.6814096,32.8776371 55.6123697,32.9936709 55.6814096,33.1677215 L57.6260338,38.2267932 Z M64.6450917,33.6202532 L64.6450917,36.8808017 C64.6450917,37.7162447 64.8522114,38.3660338 65.8647968,38.3660338 C66.5782093,38.3660338 67.1305286,38.0991561 67.3606616,37.9367089 C67.4987415,37.8438819 67.5217548,37.7626582 67.4527149,37.5886076 L67.349155,37.3449367 C67.2916217,37.2172996 67.2225818,37.1128692 67.0154621,37.2405063 C66.7968357,37.3797468 66.4631428,37.5886076 65.9683567,37.5886076 C65.6691837,37.5886076 65.496584,37.3797468 65.496584,36.8227848 L65.496584,33.6202532 L67.0614887,33.6202532 C67.2110752,33.6202532 67.3261417,33.5042194 67.3261417,33.3649789 L67.3261417,33.1329114 C67.3261417,32.9820675 67.2110752,32.8776371 67.0614887,32.8776371 L65.496584,32.8776371 L65.496584,31.3691983 C65.496584,31.2299578 65.3930241,31.1023207 65.2549443,31.1139241 L64.898238,31.1371308 C64.7716649,31.1487342 64.6450917,31.2531646 64.6450917,31.3924051 L64.6450917,32.8776371 L63.9431859,32.8776371 C63.7820928,32.8776371 63.6785329,32.9820675 63.6785329,33.1329114 L63.6785329,33.3649789 C63.6785329,33.5042194 63.7820928,33.6202532 63.9431859,33.6202532 L64.6450917,33.6202532 Z M68.6609133,37.9831224 C68.6609133,38.1223629 68.7759799,38.2383966 68.9140597,38.2383966 L69.2592593,38.2383966 C69.3858324,38.2383966 69.5124056,38.1223629 69.5124056,37.9831224 L69.5124056,34.3048523 C69.5124056,34.3048523 70.1337648,33.5390295 71.1463502,33.5390295 C71.9633225,33.5390295 72.2624955,34.1308017 72.2624955,35.1518987 L72.2624955,37.9831224 C72.2624955,38.1223629 72.377562,38.2383966 72.5156419,38.2383966 L72.8723481,38.2383966 C72.9989213,38.2383966 73.1254944,38.1223629 73.1254944,37.9831224 L73.1254944,35.1518987 C73.1254944,33.585443 72.5271485,32.7616034 71.2038835,32.7616034 C70.1337648,32.7616034 69.5124056,33.4462025 69.5124056,33.4462025 L69.5124056,30.371308 C69.5124056,30.2436709 69.3858324,30.1160338 69.2592593,30.1160338 L68.9140597,30.1160338 C68.7759799,30.1160338 68.6609133,30.2436709 68.6609133,30.371308 L68.6609133,37.9831224 Z M74.529306,35.5580169 C74.529306,34.0495781 75.4958648,32.7616034 77.1067961,32.7616034 C78.499101,32.7616034 79.5116864,33.7943038 79.5116864,35.1983122 C79.5116864,35.2911392 79.5001798,35.4303797 79.4886731,35.5232068 C79.4771665,35.6624473 79.3621,35.7552743 79.2470334,35.7552743 L75.3807983,35.7552743 C75.4038116,36.6487342 76.151744,37.5886076 77.1183028,37.5886076 C77.8202086,37.5886076 78.2574613,37.3449367 78.5566343,37.1476793 C78.7407407,37.0200422 78.8212873,36.9736287 78.9593671,37.1824895 L79.097447,37.3797468 C79.2010068,37.5421941 79.2470334,37.600211 79.0514204,37.7510549 C78.7292341,38.0063291 78.0273283,38.3660338 77.1067961,38.3660338 C75.4958648,38.3660338 74.529306,37.0896624 74.529306,35.5580169 Z M75.3923049,35.0706751 L78.6601942,35.0706751 C78.6371809,34.2816456 78.0158216,33.5390295 77.1067961,33.5390295 C76.2092772,33.5390295 75.4958648,34.2352321 75.3923049,35.0706751 Z M80.9039914,37.9831224 C80.9039914,38.1223629 81.0190579,38.2383966 81.1571377,38.2383966 L81.5023373,38.2383966 C81.6289105,38.2383966 81.7554836,38.1223629 81.7554836,37.9831224 L81.7554836,34.2700422 C81.7554836,34.2700422 82.1697231,33.585443 83.1938152,33.585443 C83.4469615,33.585443 83.6425746,33.67827 83.7691478,33.7362869 C83.895721,33.7943038 84.0222941,33.7827004 84.0798274,33.6086498 L84.2294139,33.1909283 C84.3559871,32.8196203 83.7001079,32.7616034 83.297375,32.7616034 C82.1927364,32.7616034 81.6634304,33.4462025 81.6634304,33.4462025 L81.5713772,33.0632911 C81.5368572,32.935654 81.444804,32.8776371 81.3412442,32.8776371 L81.1571377,32.8776371 C81.0190579,32.8776371 80.9039914,33.0052743 80.9039914,33.1329114 L80.9039914,37.9831224 Z M84.8392665,35.5580169 C84.8392665,34.0495781 85.8058252,32.7616034 87.4167566,32.7616034 C88.8090615,32.7616034 89.8216469,33.7943038 89.8216469,35.1983122 C89.8216469,35.2911392 89.8101402,35.4303797 89.7986336,35.5232068 C89.7871269,35.6624473 89.6720604,35.7552743 89.5569939,35.7552743 L85.6907587,35.7552743 C85.713772,36.6487342 86.4617044,37.5886076 87.4282632,37.5886076 C88.130169,37.5886076 88.5674218,37.3449367 88.8665948,37.1476793 C89.0507012,37.0200422 89.1312478,36.9736287 89.2693276,37.1824895 L89.4074074,37.3797468 C89.5109673,37.5421941 89.5569939,37.600211 89.3613808,37.7510549 C89.0391945,38.0063291 88.3372887,38.3660338 87.4167566,38.3660338 C85.8058252,38.3660338 84.8392665,37.0896624 84.8392665,35.5580169 Z M85.7022654,35.0706751 L88.9701546,35.0706751 C88.9471413,34.2816456 88.3257821,33.5390295 87.4167566,33.5390295 C86.5192377,33.5390295 85.8058252,34.2352321 85.7022654,35.0706751 Z M91.7432578,35.0822785 L91.8813376,35.0822785 C91.9848975,35.0822785 92.0884574,34.9894515 92.099964,34.8966245 L92.3185904,31.6360759 L92.3185904,30.3364979 C92.3185904,30.2204641 92.2150306,30.1160338 92.099964,30.1160338 L91.5246314,30.1160338 C91.4095649,30.1160338 91.306005,30.2204641 91.306005,30.3364979 L91.306005,31.6592827 L91.5246314,34.8966245 C91.5361381,34.9894515 91.639698,35.0822785 91.7432578,35.0822785 Z M91.1564186,37.693038 C91.1564186,38.0527426 91.4555915,38.3544304 91.8122977,38.3544304 C92.1805106,38.3544304 92.4681769,38.0527426 92.4681769,37.693038 C92.4681769,37.32173 92.1805106,37.0316456 91.8122977,37.0316456 C91.4555915,37.0316456 91.1564186,37.32173 91.1564186,37.693038 Z M96.3459187,38.2383966 C96.173319,38.2383966 96.0812657,38.0875527 96.1503056,37.9367089 L99.6483279,30.1276371 C99.6828479,30.0580169 99.7403812,30 99.843941,30 L99.9590076,30 C100.062567,30 100.120101,30.0580169 100.154621,30.1276371 L103.62963,37.9367089 C103.69867,38.0875527 103.606616,38.2383966 103.434017,38.2383966 L102.97375,38.2383966 C102.870191,38.2383966 102.801151,38.1687764 102.778137,38.1107595 L101.926645,36.1962025 L97.8417835,36.1962025 L97.0017979,38.1107595 C96.9787846,38.1687764 96.9097447,38.2383966 96.8061848,38.2383966 L96.3459187,38.2383966 Z M98.1639698,35.4767932 L101.615965,35.4767932 C101.05214,34.2120253 100.49982,32.935654 99.9359942,31.6708861 L99.843941,31.6708861 L98.1639698,35.4767932 Z M104.619202,37.9831224 C104.619202,38.1223629 104.734268,38.2383966 104.872348,38.2383966 L105.217548,38.2383966 C105.344121,38.2383966 105.470694,38.1223629 105.470694,37.9831224 L105.470694,34.2816456 C105.470694,34.2816456 106.10356,33.5390295 107.104639,33.5390295 C107.887091,33.5390295 108.232291,34.0147679 108.232291,35.035865 L108.232291,37.9831224 C108.232291,38.1223629 108.347357,38.2383966 108.485437,38.2383966 L108.830636,38.2383966 C108.95721,38.2383966 109.083783,38.1223629 109.083783,37.9831224 L109.083783,35.1518987 C109.083783,33.771097 108.704063,32.7616034 107.162172,32.7616034 C106.057533,32.7616034 105.378641,33.4462025 105.378641,33.4462025 L105.263574,33.0400844 C105.240561,32.9240506 105.171521,32.8776371 105.056455,32.8776371 L104.872348,32.8776371 C104.734268,32.8776371 104.619202,33.0052743 104.619202,33.1329114 L104.619202,37.9831224 Z M112.075512,38.2267932 L111.05142,40.6751055 C110.970874,40.8607595 111.062927,41 111.270047,41 L111.684286,41 C111.776339,41 111.879899,40.9187764 111.914419,40.8375527 L115.239842,33.1793249 C115.320388,33.0052743 115.239842,32.8776371 115.032722,32.8776371 L114.606976,32.8776371 C114.503416,32.8776371 114.411363,32.935654 114.376843,33.028481 L112.581805,37.2869198 L112.558792,37.2869198 L111.05142,33.028481 C111.0169,32.935654 110.924847,32.8776371 110.821287,32.8776371 L110.338008,32.8776371 C110.130888,32.8776371 110.061848,32.9936709 110.130888,33.1677215 L112.075512,38.2267932 Z M118.599784,35.5580169 C118.599784,34.0263713 119.635383,32.7616034 121.085221,32.7616034 C122.040273,32.7616034 122.673139,33.306962 122.673139,33.306962 L122.753686,33.0632911 C122.811219,32.9588608 122.868752,32.8776371 123.006832,32.8776371 L123.167925,32.8776371 C123.306005,32.8776371 123.432578,33.0052743 123.432578,33.1329114 L123.432578,40.7447257 C123.432578,40.8839662 123.306005,41 123.167925,41 L122.845739,41 C122.707659,41 122.592593,40.8839662 122.592593,40.7447257 L122.592593,37.8902954 C122.592593,37.8902954 121.994247,38.3660338 121.119741,38.3660338 C119.658396,38.3660338 118.599784,37.1244726 118.599784,35.5580169 Z M119.462783,35.5464135 C119.462783,36.7067511 120.222222,37.5770042 121.234808,37.5770042 C121.971233,37.5770042 122.592593,37.1360759 122.592593,37.1360759 L122.592593,34.2004219 C122.592593,34.2004219 122.040273,33.5506329 121.177274,33.5506329 C120.118662,33.5506329 119.462783,34.5021097 119.462783,35.5464135 Z M125.170083,36.0221519 C125.170083,37.4377637 125.538296,38.3660338 127.06868,38.3660338 C128.023732,38.3660338 128.518519,37.878692 128.714132,37.6698312 L128.817691,38.0063291 C128.852211,38.1455696 128.909745,38.2383966 129.059331,38.2383966 L129.243438,38.2383966 C129.370011,38.2383966 129.485077,38.1223629 129.485077,37.9831224 L129.485077,33.1329114 C129.485077,33.0052743 129.370011,32.8776371 129.243438,32.8776371 L128.886731,32.8776371 C128.748652,32.8776371 128.645092,33.0052743 128.645092,33.1329114 L128.645092,36.8111814 C128.403452,37.0896624 127.931679,37.5886076 127.13772,37.5886076 C126.366775,37.5886076 126.021575,37.1012658 126.021575,36.0337553 L126.021575,33.1329114 C126.021575,33.0052743 125.906508,32.8776371 125.768429,32.8776371 L125.423229,32.8776371 C125.273643,32.8776371 125.170083,33.0052743 125.170083,33.1329114 L125.170083,36.0221519 Z M130.946422,35.5580169 C130.946422,34.0495781 131.912981,32.7616034 133.523912,32.7616034 C134.916217,32.7616034 135.928803,33.7943038 135.928803,35.1983122 C135.928803,35.2911392 135.917296,35.4303797 135.905789,35.5232068 C135.894283,35.6624473 135.779216,35.7552743 135.66415,35.7552743 L131.797914,35.7552743 C131.820928,36.6487342 132.56886,37.5886076 133.535419,37.5886076 C134.237325,37.5886076 134.674577,37.3449367 134.97375,37.1476793 C135.157857,37.0200422 135.238403,36.9736287 135.376483,37.1824895 L135.514563,37.3797468 C135.618123,37.5421941 135.66415,37.600211 135.468536,37.7510549 C135.14635,38.0063291 134.444444,38.3660338 133.523912,38.3660338 C131.912981,38.3660338 130.946422,37.0896624 130.946422,35.5580169 Z M131.809421,35.0706751 L135.07731,35.0706751 C135.054297,34.2816456 134.432938,33.5390295 133.523912,33.5390295 C132.626393,33.5390295 131.912981,34.2352321 131.809421,35.0706751 Z M138.805466,38.3660338 C139.887091,38.3660338 140.61201,37.6814346 140.61201,36.8343882 C140.61201,35.8597046 139.818051,35.5116034 138.897519,35.0822785 C138.253146,34.7805907 137.884933,34.6065401 137.884933,34.1308017 C137.884933,33.8755274 138.080547,33.5390295 138.667386,33.5390295 C139.162172,33.5390295 139.530385,33.7130802 139.760518,33.8523207 C139.875584,33.9219409 140.048184,33.9103376 140.128731,33.7594937 L140.243797,33.5390295 C140.324344,33.3881857 140.30133,33.2721519 140.186264,33.1793249 C139.933118,32.9936709 139.357785,32.7616034 138.667386,32.7616034 C137.436174,32.7616034 137.021935,33.6086498 137.021935,34.1656118 C137.021935,35.0822785 137.8274,35.4651899 138.529306,35.8132911 C139.300252,36.1962025 139.714491,36.4050633 139.714491,36.9156118 C139.714491,37.3333333 139.346278,37.5886076 138.805466,37.5886076 C138.126573,37.5886076 137.666307,37.2521097 137.482201,37.1128692 C137.332614,37.0084388 137.240561,37.0548523 137.171521,37.1824895 L137.010428,37.4841772 C136.964401,37.5770042 136.987415,37.6582278 137.044948,37.7162447 C137.321108,37.971519 137.919453,38.3660338 138.805466,38.3660338 Z M142.338008,33.6202532 L142.338008,36.8808017 C142.338008,37.7162447 142.545128,38.3660338 143.557713,38.3660338 C144.271125,38.3660338 144.823445,38.0991561 145.053578,37.9367089 C145.191658,37.8438819 145.214671,37.7626582 145.145631,37.5886076 L145.042071,37.3449367 C144.984538,37.2172996 144.915498,37.1128692 144.708378,37.2405063 C144.489752,37.3797468 144.156059,37.5886076 143.661273,37.5886076 C143.3621,37.5886076 143.1895,37.3797468 143.1895,36.8227848 L143.1895,33.6202532 L144.754405,33.6202532 C144.903991,33.6202532 145.019058,33.5042194 145.019058,33.3649789 L145.019058,33.1329114 C145.019058,32.9820675 144.903991,32.8776371 144.754405,32.8776371 L143.1895,32.8776371 L143.1895,31.3691983 C143.1895,31.2299578 143.08594,31.1023207 142.94786,31.1139241 L142.591154,31.1371308 C142.464581,31.1487342 142.338008,31.2531646 142.338008,31.3924051 L142.338008,32.8776371 L141.636102,32.8776371 C141.475009,32.8776371 141.371449,32.9820675 141.371449,33.1329114 L141.371449,33.3649789 C141.371449,33.5042194 141.475009,33.6202532 141.636102,33.6202532 L142.338008,33.6202532 Z M146.756562,31.4968354 C147.113269,31.4968354 147.389428,31.2067511 147.389428,30.8702532 C147.389428,30.4989451 147.113269,30.2204641 146.756562,30.2204641 C146.411363,30.2204641 146.135203,30.4989451 146.135203,30.8702532 C146.135203,31.2067511 146.411363,31.4968354 146.756562,31.4968354 Z M146.35383,37.9831224 C146.35383,38.1223629 146.468896,38.2383966 146.606976,38.2383966 L146.952175,38.2383966 C147.078749,38.2383966 147.205322,38.1223629 147.205322,37.9831224 L147.205322,33.1329114 C147.205322,33.0052743 147.078749,32.8776371 146.952175,32.8776371 L146.606976,32.8776371 C146.468896,32.8776371 146.35383,33.0052743 146.35383,33.1329114 L146.35383,37.9831224 Z M148.65516,35.5464135 C148.65516,34.0379747 149.851852,32.7616034 151.324703,32.7616034 C152.797555,32.7616034 153.994247,34.0379747 153.994247,35.5464135 C153.994247,37.0780591 152.797555,38.3660338 151.324703,38.3660338 C149.851852,38.3660338 148.65516,37.0780591 148.65516,35.5464135 Z M149.495146,35.5464135 C149.495146,36.6603376 150.277598,37.5886076 151.324703,37.5886076 C152.371809,37.5886076 153.142754,36.6603376 153.142754,35.5464135 C153.142754,34.4556962 152.371809,33.5390295 151.324703,33.5390295 C150.277598,33.5390295 149.495146,34.4556962 149.495146,35.5464135 Z M155.444085,37.9831224 C155.444085,38.1223629 155.559151,38.2383966 155.697231,38.2383966 L156.042431,38.2383966 C156.169004,38.2383966 156.295577,38.1223629 156.295577,37.9831224 L156.295577,34.2816456 C156.295577,34.2816456 156.928443,33.5390295 157.929522,33.5390295 C158.711974,33.5390295 159.057174,34.0147679 159.057174,35.035865 L159.057174,37.9831224 C159.057174,38.1223629 159.17224,38.2383966 159.31032,38.2383966 L159.65552,38.2383966 C159.782093,38.2383966 159.908666,38.1223629 159.908666,37.9831224 L159.908666,35.1518987 C159.908666,33.771097 159.528946,32.7616034 157.987055,32.7616034 C156.882416,32.7616034 156.203524,33.4462025 156.203524,33.4462025 L156.088457,33.0400844 C156.065444,32.9240506 155.996404,32.8776371 155.881338,32.8776371 L155.697231,32.8776371 C155.559151,32.8776371 155.444085,33.0052743 155.444085,33.1329114 L155.444085,37.9831224 Z M163.130529,38.3660338 C164.212154,38.3660338 164.937073,37.6814346 164.937073,36.8343882 C164.937073,35.8597046 164.143114,35.5116034 163.222582,35.0822785 C162.578209,34.7805907 162.209996,34.6065401 162.209996,34.1308017 C162.209996,33.8755274 162.405609,33.5390295 162.992449,33.5390295 C163.487235,33.5390295 163.855448,33.7130802 164.085581,33.8523207 C164.200647,33.9219409 164.373247,33.9103376 164.453794,33.7594937 L164.56886,33.5390295 C164.649407,33.3881857 164.626393,33.2721519 164.511327,33.1793249 C164.258181,32.9936709 163.682848,32.7616034 162.992449,32.7616034 C161.761237,32.7616034 161.346997,33.6086498 161.346997,34.1656118 C161.346997,35.0822785 162.152463,35.4651899 162.854369,35.8132911 C163.625315,36.1962025 164.039554,36.4050633 164.039554,36.9156118 C164.039554,37.3333333 163.671341,37.5886076 163.130529,37.5886076 C162.451636,37.5886076 161.99137,37.2521097 161.807264,37.1128692 C161.657677,37.0084388 161.565624,37.0548523 161.496584,37.1824895 L161.335491,37.4841772 C161.289464,37.5770042 161.312478,37.6582278 161.370011,37.7162447 C161.64617,37.971519 162.244516,38.3660338 163.130529,38.3660338 Z M167.62963,35.0822785 L167.940309,35.0822785 C168.055376,35.0822785 168.181949,35.0126582 168.181949,34.850211 L168.181949,34.3744726 C168.181949,33.4229958 170,33.2953586 170,31.7753165 C170,30.7078059 169.194534,30 167.997843,30 C166.548004,30 165.892125,31.021097 165.892125,31.021097 C165.823085,31.1139241 165.800072,31.2415612 165.892125,31.3227848 L166.110752,31.5200422 C166.214311,31.6128692 166.306365,31.6128692 166.409924,31.5084388 C166.640058,31.2647679 167.065804,30.7194093 167.997843,30.7194093 C168.745775,30.7194093 169.137001,31.1951477 169.137001,31.7405063 C169.137001,33.0516878 167.411003,32.935654 167.411003,34.3744726 L167.411003,34.8618143 C167.411003,34.9894515 167.514563,35.0822785 167.62963,35.0822785 Z M167.11183,37.693038 C167.11183,38.0527426 167.411003,38.3544304 167.767709,38.3544304 C168.135922,38.3544304 168.423589,38.0527426 168.423589,37.693038 C168.423589,37.32173 168.135922,37.0316456 167.767709,37.0316456 C167.411003,37.0316456 167.11183,37.32173 167.11183,37.693038 Z\" id=\"Hey-there!-Any-quest\" fill=\"#000000\"></path><text id=\"Teresa-Porter\" font-family=\"BrandonText-Medium, Brandon Text\" font-size=\"10\" font-weight=\"400\" line-spacing=\"7.90019913\" fill=\"#9A9A9A\"><tspan x=\"40\" y=\"11\">Teresa Porter</tspan></text><mask id=\"mask-4\" fill=\"white\"><use xlink:href=\"#path-1\"></use></mask><use id=\"Rectangle-4\" fill=\"url(#pattern-2)\" xlink:href=\"#path-1\"></use><mask id=\"mask-8\" fill=\"white\"><use xlink:href=\"#path-5\"></use></mask><use id=\"Rectangle-4\" fill=\"url(#pattern-6)\" xlink:href=\"#path-5\"></use></g></g></g></svg>"

/***/ }),

/***/ "TT4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__ = __webpack_require__("xMS5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_queries_NoteQueries__ = __webpack_require__("IDni");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var NoteStore = Marty.createStore({
  id: 'NoteStore',

  getInitialState: function getInitialState() {
    return {
      notesByEndUserId: {},
      notesByCompanyId: {}
    };
  },


  handlers: {
    fetchNoteListForEndUserIdDone: __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_END_USER_FETCH_DONE,
    fetchNoteListForCompanyIdDone: __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_LIST_FOR_COMPANY_FETCH_DONE,
    createNoteForEndUserDone: __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_END_USER_CREATE_DONE,
    createNoteForCompanyDone: __WEBPACK_IMPORTED_MODULE_0_constants_NoteConstants__["a" /* default */].NOTE_COMPANY_CREATE_DONE
  },

  // MESSAGES
  getOrFetchNoteListForEndUserId: function getOrFetchNoteListForEndUserId(endUserId) {
    return this.fetch({
      id: 'getOrFetchNoteListForEndUserId' + endUserId,
      locally: function locally() {
        return this.state.notesByEndUserId[endUserId];
      },
      remotely: function remotely() {
        return this.app.queries.NoteQueries.fetchNotesForEndUserId(endUserId);
      }
    });
  },
  fetchNoteListForEndUserIdDone: function fetchNoteListForEndUserIdDone(endUserId, notes) {
    var notesByEndUserId = _.cloneDeep(this.state.notesByEndUserId);
    notesByEndUserId[endUserId] = notes;
    return this.setState({ notesByEndUserId: notesByEndUserId });
  },
  getOrFetchNoteListForCompanyId: function getOrFetchNoteListForCompanyId(companyId) {
    return this.fetch({
      id: 'getOrFetchNoteListForCompanyId' + companyId,
      locally: function locally() {
        return this.state.notesByCompanyId[companyId];
      },
      remotely: function remotely() {
        return this.app.queries.NoteQueries.fetchNotesForCompanyId(companyId);
      }
    });
  },
  fetchNoteListForCompanyIdDone: function fetchNoteListForCompanyIdDone(companyId, notes) {
    var notesByCompanyId = _.cloneDeep(this.state.notesByCompanyId);
    notesByCompanyId[companyId] = notes;
    return this.setState({ notesByCompanyId: notesByCompanyId });
  },
  createNoteForEndUserDone: function createNoteForEndUserDone(endUserId, note) {
    var notesByEndUserId = _.cloneDeep(this.state.notesByEndUserId);
    var notes = _.reject(notesByEndUserId[endUserId], 'id', note.id);
    notes.push(note);
    notesByEndUserId[endUserId] = notes;
    return this.setState({ notesByEndUserId: notesByEndUserId });
  },
  createNoteForCompanyDone: function createNoteForCompanyDone(companyId, note) {
    var notesByCompanyId = _.cloneDeep(this.state.notesByCompanyId);
    var notes = _.reject(notesByCompanyId[companyId], 'id', note.id);
    notes.push(note);
    notesByCompanyId[companyId] = notes;
    return this.setState({ notesByCompanyId: notesByCompanyId });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (NoteStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "TUwc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCPropertiesSuccess"] = fetchSFDCPropertiesSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMappingsSuccess"] = fetchSFDCMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMappingsFailed"] = fetchSFDCMappingsFailed;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMetricsMappingsSuccess"] = fetchSFDCMetricsMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMetricsMappingsFailed"] = fetchSFDCMetricsMappingsFailed;
/* harmony export (immutable) */ __webpack_exports__["fetchMetricsListSuccess"] = fetchMetricsListSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchMetricsListFailed"] = fetchMetricsListFailed;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCPropertiesFailed"] = fetchSFDCPropertiesFailed;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMappingsSuccess"] = patchSFDCMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMappingsError"] = patchSFDCMappingsError;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMappingsStart"] = patchSFDCMappingsStart;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMetricsMappingsSuccess"] = patchSFDCMetricsMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMetricsMappingsError"] = patchSFDCMetricsMappingsError;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMetricMappingsStart"] = patchSFDCMetricMappingsStart;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCProperties"] = fetchSFDCProperties;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMappings"] = fetchSFDCMappings;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCMetricsMappings"] = fetchSFDCMetricsMappings;
/* harmony export (immutable) */ __webpack_exports__["fetchMetricsList"] = fetchMetricsList;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMappings"] = patchSFDCMappings;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCMetricsMappings"] = patchSFDCMetricsMappings;
/* harmony export (immutable) */ __webpack_exports__["searchSFDCUsersSuccess"] = searchSFDCUsersSuccess;
/* harmony export (immutable) */ __webpack_exports__["searchSFDCUsersError"] = searchSFDCUsersError;
/* harmony export (immutable) */ __webpack_exports__["searchSFDCUsersStart"] = searchSFDCUsersStart;
/* harmony export (immutable) */ __webpack_exports__["searchSFDCUsers"] = searchSFDCUsers;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCUserMappingsSuccess"] = fetchSFDCUserMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCUserMappings"] = fetchSFDCUserMappings;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCUserMappings"] = patchSFDCUserMappings;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCUserMappingsFailed"] = patchSFDCUserMappingsFailed;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCUserMappingsSuccess"] = patchSFDCUserMappingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCObjectList"] = fetchSFDCObjectList;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCObjectListSuccess"] = fetchSFDCObjectListSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCObjectListError"] = fetchSFDCObjectListError;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCFieldList"] = fetchSFDCFieldList;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCFieldListSuccess"] = fetchSFDCFieldListSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCFieldListError"] = fetchSFDCFieldListError;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCFLeadRoutingSettings"] = fetchSFDCFLeadRoutingSettings;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCLeadRoutingSettingsSuccess"] = fetchSFDCLeadRoutingSettingsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCLeadRoutingSettingsError"] = fetchSFDCLeadRoutingSettingsError;
/* harmony export (immutable) */ __webpack_exports__["fetchSalesforceEnrichmentByEmail"] = fetchSalesforceEnrichmentByEmail;
/* harmony export (immutable) */ __webpack_exports__["fetchSalesforceEnrichmentByDomain"] = fetchSalesforceEnrichmentByDomain;
/* harmony export (immutable) */ __webpack_exports__["fetchSalesforceEnrichmentStart"] = fetchSalesforceEnrichmentStart;
/* harmony export (immutable) */ __webpack_exports__["fetchSalesforceEnrichmentFailed"] = fetchSalesforceEnrichmentFailed;
/* harmony export (immutable) */ __webpack_exports__["fetchSalesforceEnrichmentSuccess"] = fetchSalesforceEnrichmentSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCEnrichmentFields"] = fetchSFDCEnrichmentFields;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCEnrichmentFields"] = patchSFDCEnrichmentFields;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCEnrichmentFieldsSuccess"] = fetchSFDCEnrichmentFieldsSuccess;
/* harmony export (immutable) */ __webpack_exports__["fetchSFDCEnrichmentFieldsError"] = fetchSFDCEnrichmentFieldsError;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCEnrichmentFieldsSuccess"] = patchSFDCEnrichmentFieldsSuccess;
/* harmony export (immutable) */ __webpack_exports__["patchSFDCEnrichmentFieldsError"] = patchSFDCEnrichmentFieldsError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("rAlQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__ = __webpack_require__("pE/Y");



function fetchSFDCPropertiesSuccess(_ref) {
  var properties = _ref.properties;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_SFDC_ATTRIBUTES_SUCCESS */],
    properties: properties
  };
}

function fetchSFDCMappingsSuccess(_ref2) {
  var mappings = _ref2.mappings,
      useCountryAcronyms = _ref2.useCountryAcronyms,
      useStateAcronyms = _ref2.useStateAcronyms,
      allowAttributeDefaults = _ref2.allowAttributeDefaults,
      createContactOnCaseCreation = _ref2.createContactOnCaseCreation;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* FETCH_SFDC_MAPPINGS_SUCCESS */],
    mappings: convertMappingFromSfdcToIntegration(mappings),
    useCountryAcronyms: useCountryAcronyms, useStateAcronyms: useStateAcronyms, allowAttributeDefaults: allowAttributeDefaults, createContactOnCaseCreation: createContactOnCaseCreation
  };
}

function fetchSFDCMappingsFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* FETCH_SFDC_MAPPINGS_ERROR */],
    err: err
  };
}

function fetchSFDCMetricsMappingsSuccess(_ref3) {
  var mappings = _ref3.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* FETCH_SFDC_METRIC_MAPPINGS_SUCCESS */],
    mappings: mappings
  };
}

function fetchSFDCMetricsMappingsFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* FETCH_SFDC_METRIC_MAPPINGS_ERROR */],
    err: err
  };
}

function fetchMetricsListSuccess(_ref4) {
  var list = _ref4.list;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_METRICS_LIST_SUCCESS */],
    list: list
  };
}

function fetchMetricsListFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_METRICS_LIST_ERROR */],
    err: err
  };
}

function fetchSFDCPropertiesFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* FETCH_SFDC_ATTRIBUTES_ERROR */],
    err: err
  };
}

function patchSFDCMappingsSuccess(_ref5) {
  var mappings = _ref5.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* PATCH_SFDC_MAPPINGS_SUCCESS */],
    mappings: convertMappingFromSfdcToIntegration(mappings)
  };
}

function patchSFDCMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* PATCH_SFDC_MAPPINGS_ERROR */],
    err: err
  };
}

function patchSFDCMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* PATCH_SFDC_MAPPINGS_START */]
  };
}

function patchSFDCMetricsMappingsSuccess(_ref6) {
  var mappings = _ref6.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* PATCH_SFDC_METRIC_MAPPINGS_SUCCESS */],
    mappings: mappings
  };
}

function patchSFDCMetricsMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* PATCH_SFDC_METRIC_MAPPINGS_ERROR */],
    err: err
  };
}

function patchSFDCMetricMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* PATCH_SFDC_METRIC_MAPPINGS_START */]
  };
}

function fetchSFDCProperties(propertyType) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSFDCProperties(propertyType).then(function (response) {
      dispatch(fetchSFDCPropertiesSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCPropertiesFailed(err));
    });
  };
}

function fetchSFDCMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSFDCMappings().then(function (response) {
      dispatch(fetchSFDCMappingsSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCMappingsFailed(err));
    });
  };
}

function fetchSFDCMetricsMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSFDCMetricsMappings().then(function (response) {
      dispatch(fetchSFDCMetricsMappingsSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCMetricsMappingsFailed(err));
    });
  };
}

function fetchMetricsList() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchMetricsList().then(function (response) {
      dispatch(fetchMetricsListSuccess({ "list": response }));
    }).catch(function (err) {
      return dispatch(fetchMetricsListFailed(err));
    });
  };
}

function patchSFDCMappings(mappings, useRawMapping) {
  var successCB = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  return function (dispatch) {
    dispatch(patchSFDCMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].patchSFDCMappings(mappings, useRawMapping).then(function (response) {
      successCB();
      dispatch(patchSFDCMappingsSuccess(response));
    }).catch(function (err) {
      dispatch(patchSFDCMappingsError(err));
    });
  };
}

function patchSFDCMetricsMappings(mappings) {
  var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch) {
    dispatch(patchSFDCMetricMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].patchSFDCMetricsMappings(mappings).then(function (response) {
      dispatch(patchSFDCMetricsMappingsSuccess(response));
      successCB();
    }).catch(function (err) {
      dispatch(patchSFDCMetricsMappingsError(err));
    });
  };
}

function searchSFDCUsersSuccess(_ref7) {
  var users = _ref7.users;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* FETCH_SFDC_USERS_SUCCESS */],
    users: users
  };
}

function searchSFDCUsersError() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* FETCH_SFDC_USERS_ERROR */]
  };
}

function searchSFDCUsersStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* FETCH_SFDC_USERS_START */]
  };
}

function searchSFDCUsers(query) {
  return function (dispatch) {
    dispatch(searchSFDCUsersStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].searchSFDCUsers(query).then(function (response) {
      dispatch(searchSFDCUsersSuccess(response));
    });
  };
}

function fetchSFDCUserMappingsSuccess(_ref8) {
  var mappings = _ref8.mappings,
      users = _ref8.users;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FETCH_SFDC_USER_MAPPINGS_SUCCESS */],
    mappings: mappings,
    users: users
  };
}

function fetchSFDCUserMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSFDCUserMappings().then(function (response) {
      dispatch(fetchSFDCUserMappingsSuccess(response));
    });
  };
}

function patchSFDCUserMappings(data) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].patchSFDCUserMappings(data).then(function (resp) {
      dispatch(patchSFDCUserMappingsSuccess(resp));
    }).catch(function (err) {
      dispatch(patchSFDCUserMappingsFailed(err));
    });
  };
}

function patchSFDCUserMappingsFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* PATCH_SFDC_USER_MAPPINGS_FAILED */],
    err: err
  };
}

function patchSFDCUserMappingsSuccess(_ref9) {
  var mappings = _ref9.mappings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FETCH_SFDC_USER_MAPPINGS_SUCCESS */],
    mappings: mappings
  };
}

function fetchSFDCObjectList() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].getSalesforceObjectList().then(function (response) {
      dispatch(fetchSFDCObjectListSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCObjectListError(err));
    });
  };
}

function fetchSFDCObjectListSuccess(_ref10) {
  var objects = _ref10.objects;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* FETCH_SFDC_OBJECT_LIST_SUCCESS */],
    objects: objects
  };
}

function fetchSFDCObjectListError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* FETCH_SFDC_OBJECT_LIST_ERROR */],
    err: err
  };
}

function fetchSFDCFieldList(fieldType) {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].getSalesforceFieldList(fieldType).then(function (response) {
      dispatch(fetchSFDCFieldListSuccess(fieldType, response.fields));
    }).catch(function (err) {
      return dispatch(fetchSFDCFieldListError(fieldType, err));
    });
  };
}

function fetchSFDCFieldListSuccess(fieldType, fields) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_SFDC_FIELD_LIST_SUCCESS */],
    fieldType: fieldType,
    fields: fields
  };
}

function fetchSFDCFieldListError(fieldType, err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* FETCH_SFDC_FIELD_LIST_ERROR */],
    fieldType: fieldType,
    err: err
  };
}

function fetchSFDCFLeadRoutingSettings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].getSalesforceLeadRoutingSettings().then(function (response) {
      dispatch(fetchSFDCLeadRoutingSettingsSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCLeadRoutingSettingsError(err));
    });
  };
}

function fetchSFDCLeadRoutingSettingsSuccess(_ref11) {
  var settings = _ref11.settings;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS */],
    settings: settings
  };
}

function fetchSFDCLeadRoutingSettingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR */],
    err: err
  };
}

function fetchSalesforceEnrichmentByEmail(_ref12) {
  var email = _ref12.email,
      domain = _ref12.domain;

  return function (dispatch) {
    if (email) {
      dispatch(fetchSalesforceEnrichmentStart(email));
      __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSalesforceEnrichmentByEmail({ email: email }).then(function (response) {
        dispatch(fetchSalesforceEnrichmentSuccess(response, email));
      }).catch(function (err) {
        return err.status === 404 && !!domain ? fetchSalesforceEnrichmentByDomain(dispatch, email, { domain: domain }) : dispatch(fetchSalesforceEnrichmentFailed(err, email));
      });
    } else if (domain) {
      fetchSalesforceEnrichmentByDomain(dispatch, email, { domain: domain });
    } else {
      dispatch(fetchSalesforceEnrichmentFailed({ status: 404 }, email));
    }
  };
}

function fetchSalesforceEnrichmentByDomain(dispatch, key, _ref13) {
  var domain = _ref13.domain;

  dispatch(fetchSalesforceEnrichmentStart(key));
  __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSalesforceEnrichmentByDomain({ domain: domain }).then(function (response) {
    dispatch(fetchSalesforceEnrichmentSuccess(response, key));
  }).catch(function (err) {
    return dispatch(fetchSalesforceEnrichmentFailed(err, key));
  });
}

function fetchSalesforceEnrichmentStart(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FETCH_SALESFORCE_ENRICHMENT_STARTED */],
    key: key
  };
}

function fetchSalesforceEnrichmentFailed(err, key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FETCH_SALESFORCE_ENRICHMENT_FAILED */],
    err: err,
    key: key
  };
}

function fetchSalesforceEnrichmentSuccess(data, key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FETCH_SALESFORCE_ENRICHMENT_SUCCESS */],
    data: data,
    key: key
  };
}

function fetchSFDCEnrichmentFields() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].fetchSalesforceEnrichmentFields().then(function (response) {
      dispatch(fetchSFDCEnrichmentFieldsSuccess(response));
    }).catch(function (err) {
      return dispatch(fetchSFDCEnrichmentFieldsError(err));
    });
  };
}

function patchSFDCEnrichmentFields(_ref14) {
  var fields = _ref14.fields;

  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_sfdc_api__["a" /* api */].patchSalesforceEnrichmentFields({ fields: fields }).then(function (response) {
      dispatch(patchSFDCEnrichmentFieldsSuccess(response));
    }).catch(function (err) {
      return dispatch(patchSFDCEnrichmentFieldsError(err));
    });
  };
}

function fetchSFDCEnrichmentFieldsSuccess(fields) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS */],
    fields: fields
  };
}

function fetchSFDCEnrichmentFieldsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_SFDC_ENRICHMENT_FIELDS_ERROR */],
    err: err
  };
}

function patchSFDCEnrichmentFieldsSuccess(fields) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS */],
    fields: fields
  };
}

function patchSFDCEnrichmentFieldsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* PATCH_SFDC_ENRICHMENT_FIELDS_ERROR */],
    err: err
  };
}
function convertMappingFromSfdcToIntegration(mappings) {
  return mappings.map(function (entry) {
    var defaultValue = entry.defaultValue,
        driftAttribute = entry.driftAttribute,
        isOverwritable = entry.isOverwritable,
        salesforceAttribute = entry.salesforceAttribute;

    return {
      defaultValue: defaultValue,
      driftAttribute: driftAttribute,
      isOverwritable: isOverwritable,
      integrationAttribute: salesforceAttribute,
      editable: !entry["static"]
    };
  });
}

/***/ }),

/***/ "TWPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_plus_svg__ = __webpack_require__("EI0t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_close_svg__ = __webpack_require__("DHpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("LESv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);













var AvatarOption = function AvatarOption(props) {
  var option = props.option,
      onSelect = props.onSelect,
      onFocus = props.onFocus,
      isFocused = props.isFocused;

  var displayName = Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(option);
  var handleMouseDown = function handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    onSelect(option, event);
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    onFocus(option, event);
  };
  var handleMouseMove = function handleMouseMove(event) {
    if (isFocused) {
      return;
    }
    onFocus(option, event);
  };
  return React.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames__("rep-option", { focused: isFocused }),
      onMouseDown: handleMouseDown,
      onMouseEnter: handleMouseEnter,
      onMouseMove: handleMouseMove,
      title: displayName },
    React.createElement(
      'div',
      { title: displayName, style: { display: 'inline-flex' } },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { key: option.id, user: option }),
      React.createElement(
        'span',
        null,
        displayName
      )
    )
  );
};

var AvatarValue = function AvatarValue(props) {
  var _props$value = props.value,
      value = _props$value.value,
      label = _props$value.label;

  return value ? React.createElement(
    'div',
    { className: 'Select-value rep-select', title: label },
    React.createElement(
      'span',
      { className: 'Select-value-label' },
      React.createElement(
        'div',
        { title: label, style: { display: 'inline-flex' } },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { key: value.id, user: value }),
        React.createElement(
          'span',
          null,
          label
        )
      )
    )
  ) : null;
};

var getUsersFromIds = function getUsersFromIds(listOfUserIds, Users) {
  return listOfUserIds.map(function (id) {
    return Users.find(function (user) {
      return user.get('id') === id;
    });
  });
};

var setValuesGivenListOfUsers = function setValuesGivenListOfUsers(listOfUsers) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(listOfUsers.map(function (user) {
    return _.get(user, 'id', null);
  }));
};

var RepSelectContainer = function RepSelectContainer(_ref) {
  var options = _ref.options,
      _onChange = _ref.onChange,
      value = _ref.value,
      className = _ref.className;

  var users = getUsersFromIds(value, options);
  return React.createElement(
    'div',
    { className: className },
    React.createElement(
      'div',
      null,
      users.map(function (innerValue, index) {
        return React.createElement(
          'div',
          { className: 'flex', style: { marginBottom: 10 }, key: index },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_select_plus__["b" /* default */], {
            key: index,
            clearable: false,
            value: { value: innerValue, label: innerValue && Object(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(innerValue) },
            valueComponent: AvatarValue,
            onChange: function onChange(newValue) {
              var newListOfUsers = users.set(index, newValue);
              _onChange(setValuesGivenListOfUsers(newListOfUsers));
            },
            placeholder: 'Select a Rep',
            options: options.toJS(),
            optionComponent: AvatarOption,
            searchable: false
          }),
          index === 0 ? React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_plus_svg___default.a, onClick: function onClick() {
              return _onChange(value.push(''));
            } }) : React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_svg_close_svg___default.a, onClick: function onClick() {
              return _onChange(value.delete(index));
            } })
        );
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RepSelectContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "TXHR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TZYG":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 338.6 402.31\"><path d=\"M175.6.1a169.34,169.34,0,0,0-32,336.6,4,4,0,0,1,3.1,5.7l-25.2,51.9s-.6,1.3-1.1,2.3a4.1,4.1,0,0,0,5,5.5c52.7-16.3,213.2-99.8,213.2-234.9C338.6,77.6,265.1,3.3,175.6.1Zm66.1,84.1a10.59,10.59,0,0,1-1,1.2l-47.3,53.8a11,11,0,0,0-1.2,1.4c-1.7,2.4,0,5.4,3.3,5.5h19.3c3.2.3,4.8,3.2,3.1,5.6l-1.3,1.6-34.9,39.3c-.4.5-.8.9-1.2,1.5-1.5,2.4.2,5.1,3.4,5.3h12.6a4.36,4.36,0,0,1,4.1,2.3,3.25,3.25,0,0,1-1,4,11,11,0,0,1-1,.8l-80.7,60.9a15,15,0,0,1-1.5,1.2,2.44,2.44,0,0,1-2.6,0,1.76,1.76,0,0,1-.8-2c.2-.5.7-1.5.7-1.5l22.2-45.8.6-1.3c1.5-3,0-5.6-3.3-6H116.4a12.1,12.1,0,0,1-1.9-.1c-2.7-.4-4.2-2.7-3.2-5a15.48,15.48,0,0,1,.8-1.5l27.6-46.3s.3-.5.5-.8c1.5-2.7-.3-5.4-3.8-5.5H118.3c-2.3,0-4-1.2-4.4-3.1a4.23,4.23,0,0,1,.7-2.7l8.4-14.8,27.6-48.6.7-1.1a7.49,7.49,0,0,1,7-3.8h78.6a16.35,16.35,0,0,1,2.2.2C241.9,79.5,243.1,82.1,241.7,84.2Z\"></path></svg>"

/***/ }),

/***/ "TcBr":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 288 80\" enable-background=\"new 0 0 288 80\" xml:space=\"preserve\" transform=\"translate(-15)\"><g id=\"Layer_1\" display=\"none\"><g display=\"inline\"><path fill=\"#04759B\" d=\"M167,33.1h-11.3v1.2c3.5,0,4.1,0.8,4.1,5.3v8.1c0,4.5-0.6,5.3-4.1,5.3c-2.7-0.4-4.6-1.8-7.1-4.6l-2.9-3.2 c3.9-0.7,6-3.2,6-5.9c0-3.5-3-6.1-8.5-6.1H132v1.2c3.5,0,4.1,0.8,4.1,5.3v8.1c0,4.5-0.6,5.3-4.1,5.3v1.2h12.6v-1.2 c-3.5,0-4.1-0.8-4.1-5.3v-2.3h1.1l7,8.8H167c9,0,13-4.8,13-10.6C180,37.8,176.1,33.1,167,33.1L167,33.1L167,33.1z M140.5,43.4V35 h2.6c2.8,0,4.1,2,4.1,4.2c0,2.2-1.3,4.2-4.1,4.2L140.5,43.4L140.5,43.4L140.5,43.4z M167.2,52.2h-0.4c-2.3,0-2.6-0.6-2.6-3.5V35h3 c6.6,0,7.8,4.8,7.8,8.5C175,47.4,173.8,52.2,167.2,52.2L167.2,52.2L167.2,52.2z M96.8,45.7l4.4-12.9c1.3-3.7,0.7-4.8-3.4-4.8v-1.3 h11.9V28c-4,0-4.9,0.9-6.5,5.6L96,55.2h-0.8l-6.5-19.8l-6.6,19.8h-0.8l-7-21.6C72.7,28.9,71.7,28,68,28v-1.3h14V28 c-3.7,0-4.7,0.9-3.4,4.8l4.2,12.9l6.4-19h1.2L96.8,45.7L96.8,45.7z M118.3,54.9c-7,0-12.7-5.1-12.7-11.4c0-6.2,5.7-11.3,12.7-11.3 c7,0,12.7,5.1,12.7,11.3C130.9,49.8,125.2,54.9,118.3,54.9L118.3,54.9L118.3,54.9z M118.3,34.2c-5.8,0-7.8,5.3-7.8,9.4 c0,4.2,2,9.4,7.8,9.4c5.9,0,7.9-5.2,7.9-9.4C126.2,39.4,124.2,34.2,118.3,34.2L118.3,34.2L118.3,34.2z\"></path><path fill=\"#474443\" d=\"M195.6,52.9v1.3h-14.5v-1.3c4.2,0,5-1.1,5-7.4V35.3c0-6.3-0.8-7.3-5-7.3v-1.3h13.1 c6.5,0,10.1,3.4,10.1,7.8c0,4.4-3.6,7.8-10.1,7.8h-3.6v3.1C190.6,51.8,191.4,52.9,195.6,52.9L195.6,52.9L195.6,52.9z M194.2,29 h-3.6v11h3.6c3.5,0,5.2-2.5,5.2-5.4C199.4,31.5,197.8,29,194.2,29L194.2,29L194.2,29z M247.8,48.2l-0.3,1.1 c-0.6,2.1-1.3,2.8-5.8,2.8h-0.9c-3.3,0-3.9-0.8-3.9-5.3V44c4.9,0,5.3,0.4,5.3,3.7h1.2v-9.4h-1.2c0,3.3-0.4,3.7-5.3,3.7V35h3.5 c4.5,0,5.2,0.8,5.8,2.8l0.3,1.2h1l-0.4-5.9h-18.6v1.2c3.5,0,4.1,0.8,4.1,5.3v8.1c0,4.1-0.5,5.1-3.3,5.3c-2.7-0.4-4.5-1.9-7-4.6 l-2.9-3.2c3.9-0.7,6-3.2,6-5.9c0-3.5-3-6.1-8.5-6.1h-11.1v1.2c3.5,0,4.1,0.8,4.1,5.3v8.1c0,4.5-0.6,5.3-4.1,5.3v1.2h12.6v-1.2 c-3.5,0-4.1-0.8-4.1-5.3v-2.3h1.1l7,8.8h26l0.4-5.9L247.8,48.2L247.8,48.2L247.8,48.2z M214.3,43.4V35h2.6c2.8,0,4.1,2,4.1,4.2 c0,2.2-1.3,4.2-4.1,4.2L214.3,43.4L214.3,43.4L214.3,43.4z M260.7,54.9c-2.5,0-4.7-1.3-5.7-2.2c-0.3,0.3-0.9,1.3-1,2.2h-1.2v-8.7 h1.3c0.5,4.2,3.4,6.6,7.2,6.6c2,0,3.7-1.1,3.7-3c0-1.6-1.5-2.9-4.1-4.1l-3.6-1.7c-2.5-1.2-4.4-3.3-4.4-6.1c0-3,2.8-5.6,6.8-5.6 c2.1,0,3.9,0.8,4.9,1.6c0.3-0.3,0.6-0.9,0.8-1.7h1.2v7.5h-1.3c-0.4-3-2.1-5.4-5.4-5.4c-1.8,0-3.4,1-3.4,2.6c0,1.6,1.3,2.5,4.4,3.9 l3.5,1.7c3,1.5,4.2,3.8,4.2,5.7C268.4,52.2,264.9,54.9,260.7,54.9L260.7,54.9L260.7,54.9z M280.2,54.9c-2.5,0-4.7-1.3-5.7-2.2 c-0.3,0.3-0.9,1.3-1,2.2h-1.2v-8.7h1.3c0.5,4.2,3.4,6.6,7.2,6.6c2,0,3.7-1.1,3.7-3c0-1.6-1.5-2.9-4.1-4.1l-3.6-1.7 c-2.5-1.2-4.4-3.3-4.4-6.1c0-3,2.8-5.6,6.8-5.6c2.1,0,3.9,0.8,4.9,1.6c0.3-0.3,0.6-0.9,0.8-1.7h1.2v7.5h-1.3 c-0.4-3-2.1-5.4-5.4-5.4c-1.8,0-3.4,1-3.4,2.6c0,1.6,1.3,2.5,4.4,3.9l3.5,1.7c3,1.5,4.2,3.8,4.2,5.7 C287.9,52.2,284.4,54.9,280.2,54.9L280.2,54.9L280.2,54.9z\"></path><g><path fill=\"#474443\" d=\"M4.8,40c0,11.1,6.4,20.7,15.8,25.2L7.2,28.6C5.6,32.1,4.8,35.9,4.8,40L4.8,40L4.8,40z M51.7,38.6 c0-3.5-1.2-5.9-2.3-7.7c-1.4-2.3-2.8-4.3-2.8-6.6c0-2.6,2-5,4.7-5c0.1,0,0.2,0,0.4,0c-5-4.6-11.6-7.4-18.9-7.4 C23,12,14.4,17,9.4,24.6c0.7,0,1.3,0,1.8,0c2.9,0,7.5-0.4,7.5-0.4c1.5-0.1,1.7,2.1,0.2,2.3c0,0-1.5,0.2-3.2,0.3l10.2,30.3 l6.1-18.4l-4.4-12c-1.5-0.1-2.9-0.3-2.9-0.3c-1.5-0.1-1.3-2.4,0.2-2.3c0,0,4.6,0.4,7.4,0.4c2.9,0,7.5-0.4,7.5-0.4 c1.5-0.1,1.7,2.1,0.2,2.3c0,0-1.5,0.2-3.2,0.3L46.7,57l2.8-9.3C50.7,43.8,51.7,41,51.7,38.6L51.7,38.6L51.7,38.6z M33.3,42.4 l-8.4,24.4c2.5,0.7,5.2,1.1,7.9,1.1c3.3,0,6.4-0.6,9.3-1.6c-0.1-0.1-0.1-0.2-0.2-0.4L33.3,42.4L33.3,42.4z M57.3,26.6 c0.1,0.9,0.2,1.8,0.2,2.9c0,2.8-0.5,6-2.1,10l-8.6,24.7c8.3-4.9,13.9-13.9,13.9-24.2C60.8,35.1,59.5,30.6,57.3,26.6L57.3,26.6 L57.3,26.6z M32.8,7.4C14.8,7.4,0.1,22,0.1,40c0,18,14.6,32.6,32.6,32.6c18,0,32.6-14.6,32.6-32.6C65.4,22,50.8,7.4,32.8,7.4 L32.8,7.4L32.8,7.4z M32.8,71.2c-17.2,0-31.1-14-31.1-31.2c0-17.2,14-31.1,31.1-31.1c17.2,0,31.1,14,31.1,31.1 C63.9,57.2,49.9,71.2,32.8,71.2L32.8,71.2L32.8,71.2z\"></path></g></g></g><g id=\"Layer_2\"><g><g><g><path fill=\"#0164A5\" d=\"M138.5,47.8c0,3-0.3,5.7-0.8,7.9c-0.6,2.2-1.5,4-2.8,5.4c-1.4,1.4-3,2.5-5.3,3.2s-4.8,1-8,1H106 c-0.6,0-0.8-0.3-0.8-0.7V31.2c0-0.6,0.3-0.7,0.8-0.7h15.6c3.2,0,6,0.3,8,1c2.2,0.7,3.9,1.7,5.3,3.2c1.4,1.4,2.2,3.2,2.8,5.4 S138.5,44.8,138.5,47.8z M130,48c0-2.5-0.1-4.4-0.4-6c-0.3-1.5-0.8-2.8-1.5-3.6c-0.7-0.8-1.7-1.5-2.9-1.8 c-1.2-0.3-2.6-0.6-4.4-0.6h-7.2V60h7.2c1.7,0,3.2-0.1,4.4-0.6c1.2-0.3,2.2-1,2.9-1.8c0.7-0.8,1.2-2.1,1.5-3.6 C129.8,52.4,130,50.3,130,48z\"></path><path fill=\"#0164A5\" d=\"M157.5,45.2c-0.1,0.1-0.3,0.3-0.8,0.3c-1.5,0-2.8,0-4,0.1c-1.1,0.1-1.9,0.3-2.4,0.3v18.7 c0,0.4-0.3,0.7-0.8,0.7h-6.1c-0.1,0-0.3,0-0.6-0.1c-0.1-0.1-0.3-0.3-0.3-0.6V43.9c0-0.7,0.1-1.2,0.6-1.5c0.4-0.3,1-0.7,1.7-1 c0.8-0.3,1.7-0.4,2.8-0.6c1.1-0.1,2.2-0.3,3.2-0.4c0.7-0.1,1.5-0.1,2.4-0.3c0.8-0.1,1.7-0.1,2.5-0.1h0.4c0.3,0,0.4,0,0.6,0 c0.1,0,0.3,0.1,0.4,0.3c0,0,0.1,0.1,0.3,0.3c0.1,0.1,0.1,0.3,0.1,0.6v3.5C157.6,44.8,157.6,44.9,157.5,45.2z\"></path><path fill=\"#0164A5\" d=\"M180.9,63.9c-1.9,1.4-5,2.1-9.1,2.1c-1.9,0-3.7-0.1-5.1-0.4c-1.5-0.3-2.8-0.8-3.7-1.5 c-1-0.7-1.8-1.5-2.2-2.8c-0.6-1.1-0.8-2.6-0.8-4.3V42c0-0.7,0.3-1.1,1-1.1l5.7-0.8h0.3c0.6,0,0.8,0.3,0.8,0.8v16.5 c0,1.2,0.3,2.2,0.8,2.9c0.6,0.7,1.7,1,3.3,1c1,0,1.7-0.1,2.2-0.3c0.6-0.1,1-0.4,1.2-0.8s0.6-0.7,0.6-1.2c0.1-0.4,0.1-1,0.1-1.5 V42c0-0.7,0.3-1,1-1.1l5.7-0.8c0,0,0.1,0,0.3,0c0.6,0,0.8,0.3,0.8,0.8v16.2C183.8,60.1,182.8,62.5,180.9,63.9z\"></path><path fill=\"#0164A5\" d=\"M212.9,52.9c0,1.7-0.1,3.3-0.4,4.8c-0.3,1.5-0.7,2.9-1.5,4.2c-0.7,1.2-1.8,2.2-3.3,2.9 c-1.4,0.7-3.3,1.1-5.7,1.1c-1.4,0-2.5-0.1-3.7-0.3c-1.1-0.1-2.2-0.4-3-0.6l0.6,2.9v5.1c0,0.7-0.3,1-1,1.1l-5.7,0.8h-0.3 c-0.6,0-0.8-0.3-0.8-0.8V45.2c0-0.7,0.1-1.2,0.3-1.7c0.1-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.6,1-0.7c0.4-0.1,0.8-0.4,1.4-0.6 c1.7-0.4,3.3-0.8,5.1-1.1c1.8-0.3,3.6-0.4,5.3-0.4c2.5,0,4.4,0.3,6,1c1.5,0.7,2.6,1.5,3.3,2.8c0.8,1.1,1.2,2.5,1.5,4.2 C212.7,49.3,212.9,51.1,212.9,52.9z M205,52.8c0-1.8-0.1-3.2-0.3-4.3c-0.1-1.1-0.4-1.8-0.8-2.4c-0.4-0.6-0.8-0.8-1.5-1 c-0.6-0.1-1.4-0.3-2.2-0.3c-0.6,0-1,0-1.5,0.1c-0.6,0.1-1,0.1-1.4,0.3c-0.6,0.1-1,0.1-1.4,0.3v15.2c0.4,0.1,0.7,0.1,1.1,0.3 c0.4,0,0.8,0.1,1.2,0.1c0.4,0,1,0,1.5,0c1,0,1.8-0.1,2.5-0.3c0.7-0.1,1.2-0.6,1.7-1.2c0.4-0.6,0.7-1.4,0.8-2.5 C204.8,56.1,205,54.5,205,52.8z\"></path><path fill=\"#0164A5\" d=\"M238.9,62.5c-0.1,0.6-0.4,1-0.8,1.4s-0.8,0.6-1.5,0.8c-0.6,0.1-1.4,0.4-2.2,0.6c-1,0.3-1.9,0.4-3.2,0.6 c-1.1,0.1-2.5,0.1-4,0.1c-1.5,0-2.9-0.1-4.4-0.3c-1.4-0.1-2.8-0.6-3.9-1.1c-1.1-0.6-2.1-1.4-2.8-2.4c-0.7-1.1-1.1-2.5-1.1-4.4 c0-1.5,0.3-2.8,0.7-3.6c0.4-1,1.1-1.7,1.8-2.1c0.7-0.6,1.5-0.8,2.5-1.1c1-0.3,1.8-0.4,2.8-0.6l8.7-1.4v-1.2c0-0.7,0-1.1-0.1-1.5 c-0.1-0.4-0.4-0.7-1-1c-0.7-0.3-1.8-0.4-3.6-0.4c-0.8,0-1.7,0-2.5,0.1c-0.8,0.1-1.7,0.3-2.5,0.4c-0.8,0.1-1.5,0.3-2.1,0.4 c-0.6,0.1-1.1,0.3-1.4,0.3c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0-0.6-0.1-0.6-0.4l-0.7-3.2c0,0,0-0.1,0-0.3c0-0.3,0-0.4,0.1-0.4 c0.1-0.1,0.3-0.1,0.4-0.3c0.3-0.1,0.7-0.3,1.4-0.4s1.5-0.4,2.5-0.6c1-0.1,2.1-0.4,3.3-0.6c1.2-0.1,2.5-0.3,3.9-0.3 c1.8,0,3.3,0.1,4.6,0.4c1.2,0.3,2.2,0.6,3,1c1.2,0.7,2.1,1.5,2.5,2.5c0.4,1.1,0.7,2.2,0.7,3.6v13 C239.2,61.2,239,61.9,238.9,62.5z M231.5,53.5l-5.4,0.8c-0.4,0-1,0.1-1.4,0.3c-0.4,0.1-0.8,0.3-1.1,0.6c-0.3,0.3-0.6,0.6-0.8,1 c-0.1,0.4-0.3,1-0.3,1.7c0,0.8,0.1,1.5,0.4,1.9c0.3,0.6,0.7,0.8,1.1,1.1c0.4,0.3,1,0.4,1.5,0.4c0.6,0,1.1,0.1,1.7,0.1 c1,0,1.8,0,2.5-0.1c0.7-0.1,1.2-0.3,1.7-0.3v-7.5H231.5z\"></path><path fill=\"#0164A5\" d=\"M256.3,64.3c0,0.3,0,0.4-0.1,0.6c-0.1,0.1-0.3,0.1-0.3,0.1c-0.3,0.1-0.7,0.3-1.5,0.4 c-0.7,0.1-1.8,0.3-3.3,0.3c-2.6,0-4.4-0.6-5.7-1.8c-1.2-1.2-1.8-2.8-1.8-4.8V31.8c0-0.3,0-0.6,0.1-0.7s0.3-0.3,0.7-0.3l5.8-0.8 h0.3c0.6,0,0.8,0.3,0.8,0.8v27.7c0,0.8,0.3,1.4,0.7,1.7c0.4,0.3,0.8,0.4,1.4,0.4c0.4,0,0.7,0,1,0s0.6,0,0.7-0.1c0,0,0,0,0.1,0 c0,0,0,0,0.1,0c0.3,0,0.6,0.1,0.6,0.6l0.7,3.2v0.1H256.3z\"></path></g></g><path fill=\"#0164A5\" d=\"M77.4,18.1c-3.6-2.2-6.9-3-10.4-5.4c-2.1-1.4-5-4.8-7.5-7.8c-0.4,4.7-1.9,6.5-3.5,7.9 c-3.5,2.8-5.7,3.5-8.6,5.1c-2.5,1.2-16.1,9.4-16.1,26.9s14.7,30.3,31,30.3s30.5-11.9,30.5-29.8S79.6,19.3,77.4,18.1z M77.8,68.9 c-0.3,0.3-3.5,2.5-7.1,2.9c-3.6,0.3-8.6,0.6-11.6-2.2c-0.4-0.4-0.3-1.1,0-1.4c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.3,0,0.6,0.1 c1.4,1.1,3.3,1.9,7.8,1.9c4.3,0,7.3-1.2,8.7-2.2c0.6-0.4,0.8,0,1,0.1C78.2,68,78.3,68.3,77.8,68.9z M66,62.6 c0.7-0.7,1.9-1.8,3-2.2C70.2,60,70.9,60,72,60c1.1,0,2.2,0,3,0.6c0.8,0.6,1.2,1.8,1.5,2.5c0.3,0.7,0,1.1-0.6,1.4 c-0.4,0.3-0.6,0.1-1-0.7c-0.4-0.8-0.8-1.8-3.2-1.8c-2.4,0-3,0.8-4.3,1.8c-1.1,1-1.5,1.2-1.9,0.7C65,63.9,65.2,63.3,66,62.6z M83.9,63.2c-2.5-0.1-7.3-7.8-10.4-7.9c-3.9-0.1-12.5,8.2-19.1,8.2c-4,0-5.3-0.6-6.6-1.5c-2.1-1.4-3-3.6-3-6.5 c0-5.3,5-10.2,11.2-10.2c7.9,0,13.4,7.9,17.4,7.8c3.3,0,9.8-6.6,13-6.6c3.3,0,4.3,3.5,4.3,5.7c0,2.2-0.7,6-2.4,8.3 C86.8,62.5,85.8,63.3,83.9,63.2z\"></path></g></g></svg>"

/***/ }),

/***/ "Tg02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MobileLander */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ConnectedToSlack__ = __webpack_require__("pHGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectToSlack__ = __webpack_require__("/3M9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailPrompt__ = __webpack_require__("xcG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PendingTemplate__ = __webpack_require__("UeYU");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MobileLander = function (_Component) {
  _inherits(MobileLander, _Component);

  function MobileLander() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MobileLander);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MobileLander.__proto__ || Object.getPrototypeOf(MobileLander)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MobileLander, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var tokenStateChanged = nextProps.accessTokenCreationState['slack'] !== this.props.accessTokenCreationState['slack'];
      if (tokenStateChanged) {
        this.setState({ connecting: false });
        // refresh the integration state
        // TODO ask backend for a freaking real time pusher event
        this.app.queries.IntegrationsQueries.fetchIntegrationStates();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var code = this.props.location.query.code;

      if (code) {
        this.setState({ connecting: true });
        this.app.queries.IntegrationsQueries.createSlackBotToken(code, '' + window.location.origin + window.location.pathname);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.connecting) {
        return __WEBPACK_IMPORTED_MODULE_5__PendingTemplate__["a" /* default */];
      }
      var connected = this.props.integrationStates['slackBot'];
      var isInstalled = this.props.orgProperties['segmentEnabled'] || this.props.orgProperties['orgActivated'];
      var isSignedUp = this.props.orgProperties['signUpDone'];

      if (!isInstalled || !isSignedUp) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EmailPrompt__["a" /* default */], null);
      } else if (connected) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ConnectedToSlack__["a" /* default */], { channel: this.props.integrationStates.slackChannel });
      } else {
        return __WEBPACK_IMPORTED_MODULE_3__ConnectToSlack__["a" /* default */];
      }
    }
  }]);

  return MobileLander;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var container = Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(MobileLander, {
  listenTo: ['stores.IntegrationsStore', 'stores.OrgPropertiesStore'],
  fetch: {
    integrationStates: function integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates();
    },
    accessTokenCreationState: function accessTokenCreationState() {
      return this.app.stores.IntegrationsStore.getAccessTokenCreationState();
    },
    orgProperties: function orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    }
  }
});

/***/ }),

/***/ "Ti9R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AddButton_index__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AttributeMappingRow_index__ = __webpack_require__("E4DR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("a98j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};

var AttributeMapper = function (_Component) {
  _inherits(AttributeMapper, _Component);

  function AttributeMapper(props) {
    _classCallCheck(this, AttributeMapper);

    var _this = _possibleConstructorReturn(this, (AttributeMapper.__proto__ || Object.getPrototypeOf(AttributeMapper)).call(this, props));

    _this.checkEmptyState = function (mappings) {
      var mappingsEmptyState = [{
        "integrationAttribute": null,
        "driftAttribute": null,
        "defaultValue": null,
        "isOverwritable": false,
        "editable": true
      }];

      return mappings.length > 0 ? mappings : mappingsEmptyState;
    };

    _this.isClean = function () {
      var validMappings = _this.getValidMappings();
      return _.isEqual(validMappings, _this.props.mappings);
    };

    _this.getValidMappings = function () {
      return _.filter(_this.state.mappings, function (map) {
        return _this.isMappingValid(map);
      });
    };

    _this.addNewMapping = function () {
      var updatedMappings = [].concat(_toConsumableArray(_this.state.mappings));
      updatedMappings.push(_extends({}, _this.props.mappingModel));

      _this.setState({ mappings: _this.checkEmptyState(updatedMappings) });
    };

    _this.updateDeleteProperties = function (_ref) {
      var target = _ref.target;

      _this.setState(function (prevState) {
        var value = target.value,
            checked = target.checked;

        var updatedToDelete = checked ? [].concat(_toConsumableArray(prevState.toDelete), [value]) : Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["without"])(value, prevState.toDelete);

        return {
          toDelete: updatedToDelete
        };
      });
    };

    _this.patchMappings = function () {
      var _this$props = _this.props,
          integrationName = _this$props.integrationName,
          notifications = _this$props.notifications,
          patchMappings = _this$props.patchMappings;

      var successCB = function successCB() {
        return notifications.success(getSuccessMessage(integrationName));
      };
      var strippedMappings = _this.getValidMappings();
      patchMappings(strippedMappings, successCB);
    };

    _this.deleteMappings = function () {
      var updatedMappings = [].concat(_toConsumableArray(_this.state.mappings));
      _.pullAt(updatedMappings, _this.state.toDelete);

      _this.setState({
        mappings: _this.checkEmptyState(updatedMappings),
        toDelete: []
      }, _this.patchMappings);
    };

    _this.updateMapping = function (index, mapping) {
      var updatedMappings = [].concat(_toConsumableArray(_this.state.mappings));
      updatedMappings[index] = mapping;

      _this.setState({ mappings: _this.checkEmptyState(updatedMappings) });
    };

    _this.state = {
      editingIntegrationProperty: null,
      mappings: _this.checkEmptyState(_.cloneDeep(props.mappings)),
      toDelete: [],
      overwriteHelpText: "Allow previously synced attributes to be overwritten by newer values in order to keep " + props.integrationName + " up to date."
    };
    return _this;
  }

  _createClass(AttributeMapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (this.props.allowAttributeDefaults && this.props.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
        var updatedMappings = _.cloneDeep(nextProps.mappings.map(function (mapping) {
          return mapping.driftAttribute && mapping.defaultValue ? _extends(mapping, { defaultValue: null }) : mapping;
        }));
        this.setState({ mappings: this.checkEmptyState(updatedMappings) });
      } else if (!_.isEqual(this.props.mappings, nextProps.mappings)) {
        this.setState({
          mappings: this.checkEmptyState(_.cloneDeep(nextProps.mappings))
        });
      }

      if (nextProps.patchError) {
        nextProps.patchError.json().then(function (resp) {
          resp.message && _this2.props.notifications.error(resp.message);
        });
      }
    }
  }, {
    key: 'isMappingValid',
    value: function isMappingValid(mapping) {
      return (!!mapping.driftAttribute || !!mapping.defaultValue) && !!mapping.integrationAttribute;
    }
  }, {
    key: 'renderTableRows',
    value: function renderTableRows() {
      var _this3 = this;

      var _props = this.props,
          driftAttributes = _props.driftAttributes,
          integrationAttributes = _props.integrationAttributes,
          integrationName = _props.integrationName,
          allowAttributeDefaults = _props.allowAttributeDefaults,
          allowAttributeOverwrites = _props.allowAttributeOverwrites;


      return this.state.mappings.map(function (mapItem, index) {
        var matchedMapItem = _.find(integrationAttributes, { name: mapItem.integrationAttribute });
        // Skip type filter if the attribute is has_consent as its type was altered after it was introduced.
        var driftAttributesByType = matchedMapItem && mapItem.driftAttribute !== 'has_consent' ? driftAttributes.filter(function (attr) {
          return attr.type === matchedMapItem.type || attr.type === "DATETIME" && matchedMapItem.type === "DATE";
        }) : driftAttributes;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AttributeMappingRow_index__["a" /* default */], {
          mapping: mapItem,
          key: mapItem.integrationAttribute,
          index: index,
          integrationAttributes: integrationAttributes,
          driftAttributes: driftAttributesByType,
          defaultValue: mapItem.defaultValue,
          updateDeleteProperties: _this3.updateDeleteProperties,
          updateMapping: _this3.updateMapping,
          allowAttributeDefaults: allowAttributeDefaults,
          allowAttributeOverwrites: allowAttributeOverwrites });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          patchLoading = _props2.patchLoading,
          integrationName = _props2.integrationName,
          allowAttributeDefaults = _props2.allowAttributeDefaults,
          allowAttributeOverwrites = _props2.allowAttributeOverwrites;
      var _state = this.state,
          toDelete = _state.toDelete,
          overwriteHelpText = _state.overwriteHelpText;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'mapping-actions' },
          toDelete.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'selected-delete' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'selected-text' },
              toDelete.length,
              ' Selected'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'selected-separator', style: { padding: '0 .9rem' } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'delete-button', onClick: this.deleteMappings },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'delete-icon', width: 15, name: 'trash' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'delete-text' },
                'Delete'
              )
            )
          ),
          toDelete.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              '*'
            ),
            'Required Fields'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AddButton_index__["a" /* default */], {
            addButtonLabel: 'Add New Field',
            type: 'tertiary',
            className: 'mapping-add-field',
            onClick: this.addNewMapping
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
            {
              onClick: this.patchMappings,
              size: 'medium',
              loading: patchLoading,
              disabled: this.isClean() || !this.state.mappings.length
            },
            'Update'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'drift-table mapping-table drift-form' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'empty-header' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("drift-attribute-header", { "drift-attribute-header-expand": !allowAttributeDefaults }) },
                'Drift Attribute or Value'
              ),
              allowAttributeDefaults && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'drift-attribute-header' },
                'Default Value'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'type-header' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  null,
                  'Type'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("field-header", { "field-header-expand": !allowAttributeDefaults }) },
                integrationName,
                ' Field'
              ),
              allowAttributeOverwrites != false && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'overwrite-header' },
                'Allow overwrite?',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
                  { flow: 'up', component: overwriteHelpText, className: 'overwrite-info-button' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { width: 15, height: 15, name: 'info' })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            this.renderTableRows()
          )
        )
      );
    }
  }]);

  return AttributeMapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(AttributeMapper));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Tpy9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tvnw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__("093v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_RouterHelpers__ = __webpack_require__("8uzH");




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), __WEBPACK_IMPORTED_MODULE_2_app_RouterHelpers__["a" /* appHistory */]));

/***/ }),

/***/ "TwmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tz40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_DEMANDBASE_COMPANY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_DEMANDBASE_COMPANY_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_DEMANDBASE_COMPANY_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_DEMANDBASE_TARGETING_INDUSTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('enrichment/demandbase');

var FETCH_DEMANDBASE_COMPANY_DATA = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA');
var FETCH_DEMANDBASE_COMPANY_DATA_PENDING = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_PENDING');
var FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_SUCCESS');
var FETCH_DEMANDBASE_COMPANY_DATA_FAILED = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_FAILED');
var FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED = makeConstant('FETCH_DEMANDBASE_COMPANY_DATA_CANCELLED');

var FETCH_DEMANDBASE_TARGETING_INDUSTRIES = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES');
var FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_PENDING');
var FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_SUCCESS');
var FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED = makeConstant('FETCH_DEMANDBASE_TARGETING_INDUSTRIES_FAILED');

var FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES');
var FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_PENDING');
var FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_SUCCESS');
var FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED = makeConstant('FETCH_DEMANDBASE_TARGETING_SUB_INDUSTRIES_FAILED');

/***/ }),

/***/ "U0mh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("EoEX");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("sYP+");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "U1mr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("sMXN");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchSegments */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchSegmentsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchSegmentsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchSegmentsSuccess */]), function (state, action) {
  return action.type;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var segmentsByEndUserId = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchSegmentsSuccess */], function (state, action) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      endUserSegments = _action$payload.endUserSegments;

  return state.set(id, endUserSegments);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ status: status, segmentsByEndUserId: segmentsByEndUserId }));

/***/ }),

/***/ "U2f2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3uR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_presence_actions__ = __webpack_require__("9gNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_presence__ = __webpack_require__("eUvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_comment_svg__ = __webpack_require__("uS60");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_comment_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_comment_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ChatButton = function (_Component) {
  _inherits(ChatButton, _Component);

  function ChatButton() {
    _classCallCheck(this, ChatButton);

    return _possibleConstructorReturn(this, (ChatButton.__proto__ || Object.getPrototypeOf(ChatButton)).apply(this, arguments));
  }

  _createClass(ChatButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          usersWithMessageSent = _props.usersWithMessageSent,
          endUserId = _props.endUserId;


      if (usersWithMessageSent.includes(endUserId)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
          { id: 'presence_chat', type: 'tertiary', onClick: this.setSelectedUser, className: 'sent-message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, {
            src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_comment_svg___default.a }),
          ' Sent'
        );
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
          { className: 'sent-message', id: 'presence_chat', type: 'tertiary', onClick: this.setSelectedUser },
          'Chat'
        );
      }
    }
  }]);

  return ChatButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  return function (state) {
    return {
      usersWithMessageSent: __WEBPACK_IMPORTED_MODULE_7_app_modules_presence__["d" /* selectors */].usersWithMessageSent(state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchEndUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_actions__["k" /* fetchEndUser */],
      bootstrapUser: __WEBPACK_IMPORTED_MODULE_5_app_modules_presence_actions__["bootstrapUser"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(ChatButton));

/***/ }),

/***/ "U76K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TargetMessageLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_MessagePreviews_SliderMessage__ = __webpack_require__("wrj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MessageCta__ = __webpack_require__("K2hD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Editor__ = __webpack_require__("eJtH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("Krjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);













var TargetedMessageHeader = function TargetedMessageHeader() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'header',
    { className: 'playbook-title-header' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'Customize the message your users will see.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'What do you want to say? Keep it short and sweet, be personal and human!'
    )
  );
};

var TargetMessageLoading = function TargetMessageLoading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TargetedMessageHeader, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-message-loading' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h3',
        null,
        'Loading your playbook'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Loader"], null)
    )
  );
};

var TargetedMessage = function TargetedMessage(_ref) {
  var message = _ref.message,
      onMessageChange = _ref.onMessageChange,
      headline = _ref.headline,
      onHeadlineChange = _ref.onHeadlineChange,
      ctaCopy = _ref.ctaCopy,
      selectedUser = _ref.selectedUser,
      onAuthorChange = _ref.onAuthorChange,
      defaultEmbed = _ref.defaultEmbed,
      hideCta = _ref.hideCta,
      headlineInvalid = _ref.headlineInvalid;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TargetedMessageHeader, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__Card__["a" /* default */],
      { title: 'Targeted Message', description: headline, className: 'drift-form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_MessagePreviews_SliderMessage__["a" /* default */], {
        hideCta: hideCta,
        widgetContent: { message: message, headline: headline, ctaCopy: ctaCopy, selectedUser: selectedUser },
        defaultEmbed: defaultEmbed
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Headline'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: onHeadlineChange, value: headline, invalid: headlineInvalid }),
      headlineInvalid && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-slider-message-invalid--helptext' },
        'A slider message needs a headline'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Targeted Message Copy'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Editor__["a" /* default */], { value: message, onChange: onMessageChange }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MessageCta__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-edit-message-heading' },
        'Send From'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UserSelect__["a" /* default */], { selectedUserId: selectedUser ? selectedUser.id : null, onUserIdChange: onAuthorChange })
    )
  );
};
/* harmony default export */ __webpack_exports__["b"] = (TargetedMessage);

/***/ }),

/***/ "U7vG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(24);

/***/ }),

/***/ "U98Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConversationStatusEnum; });
/* unused harmony export ActiveConversationStatusEnum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveConversationStatuses; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
// straight from java now we here
// https://github.com/Driftt/conversation-api/blob/master/ConversationService/src/main/java/com/driftt/conversation/api/conversation/ConversationStatus.java




var ConversationStatusEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['OPEN', 'PENDING', 'CLOSED', 'ARCHIVED']);
var ActiveConversationStatusEnum = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['OPEN', 'PENDING', 'CLOSED']);
var ActiveConversationStatuses = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(['OPEN', 'PENDING', 'CLOSED']);

/***/ }),

/***/ "U9xw":
/***/ (function(module, exports) {

module.exports = "<svg width=\"32\" height=\"36\" viewBox=\"0 0 64 71\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M46.958 61.089c-.08-15.336-3.196-27.277-8.817-36.22-4.986-7.935-11.74-13.208-19.643-16.318a44.815 44.815 0 0 0-11.271-2.81 37.82 37.82 0 0 0-3.433-.246 18.137 18.137 0 0 0-1.168.002A2.5 2.5 0 0 1 2.374.503C3.47.448 5.343.491 7.798.773A49.778 49.778 0 0 1 20.33 3.9c8.85 3.483 16.461 9.424 22.045 18.31 5.972 9.503 9.308 21.912 9.568 37.513l7.406-12.891a2.5 2.5 0 1 1 4.335 2.49L52.21 69.294a2.5 2.5 0 0 1-3.994.462L32.607 53.064a2.5 2.5 0 0 1 3.652-3.416l10.699 11.44z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "UAZS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.787 16.903a.867.867 0 0 1-.614-.257L1.133 9.53a.9.9 0 0 1-.006-1.26c.34-.348.892-.35 1.235-.004l6.38 6.448L20.29 1.197a.86.86 0 0 1 1.23-.087c.365.323.403.885.086 1.256l-12.16 14.23a.863.863 0 0 1-.627.306h-.033z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "UAvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__ = __webpack_require__("zrFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_continents__ = __webpack_require__("cTDj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_tech_tags__ = __webpack_require__("nyZa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_geolocation_svg__ = __webpack_require__("PKrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_geolocation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_geolocation_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg__ = __webpack_require__("sNAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_marker_svg__ = __webpack_require__("MSQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_marker_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_marker_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_icons_window_settings_svg__ = __webpack_require__("XWnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_icons_window_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_icons_window_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg__ = __webpack_require__("oaJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_sf_small_svg__ = __webpack_require__("ZbX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_sf_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_sf_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_targeting_map_location_svg__ = __webpack_require__("7Ub3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_targeting_map_location_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_targeting_map_location_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_logos_leandata_svg__ = __webpack_require__("EBDq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_logos_leandata_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_logos_leandata_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var newLineValues = ['clearbit_employees', 'clearbit_raised', 'clearbit_tags_company', 'clearbit_tags_market', 'siteVisits', 'clearbit_tech', 'clearbit_state', 'clearbit_country', 'clearbit_postal_code'];

var RuleFilters = function (_Component) {
  _inherits(RuleFilters, _Component);

  function RuleFilters() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RuleFilters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RuleFilters.__proto__ || Object.getPrototypeOf(RuleFilters)).call.apply(_ref, [this].concat(args))), _this), _this.formatURLValues = function (value, _, operator) {
      switch (operator) {
        case 'isAnyOf':
          return 'is ' + value;
        case 'notIsAnyOf':
          return 'is not ' + value;
        case 'includesAnyOf':
          return 'includes ' + value;
        default:
          return '' + value;
      }
    }, _this.formatNumericalValues = function (value, operator) {
      switch (operator) {
        case 'isBetween':
          return 'is between ' + value.min + ' and ' + value.max;
        case 'greaterThan':
          return 'is greater than ' + value;
        case 'lessThan':
          return 'is less than ' + value;
        default:
          return '' + value;
      }
    }, _this.selectFilter = function (filter) {
      return function () {
        _this.props.setActiveFilter(filter);
      };
    }, _this.addFilter = function (e) {
      e.stopPropagation();

      if (_this.props.activePage === 'filterEditor') {
        _this.props.saveActiveFilter();
      } else {
        _this.props.setActivePage('filterEditor');
      }

      _this.props.setActiveFilter('ADD');
    }, _this.removeFilter = function (filter) {
      return function (e) {
        e.stopPropagation();
        _this.props.removeFilter(filter);
      };
    }, _this.shouldShowActiveFilter = function () {
      var onlyOrCondition = _this.props.conditions[0] || [];

      if (_this.props.activePage !== 'filterEditor') {
        return false;
      }

      if (_this.props.activeFilter === 'ADD') {
        return true;
      }

      if (__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["f" /* CONDITION_TYPES */][_this.props.activeFilter.field] === 'FIRMOGRAPHIC') {
        return !onlyOrCondition.find(function (cond) {
          return cond.field === _this.props.activeFilter.field;
        });
      }

      return !onlyOrCondition.find(function (cond) {
        return __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["f" /* CONDITION_TYPES */][cond.field] === __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["f" /* CONDITION_TYPES */][_this.props.activeFilter.field];
      });
    }, _this.buildFilterSet = function () {
      var onlyOrCondition = _this.props.conditions[0] || [];
      return _this.shouldShowActiveFilter() ? [].concat(_toConsumableArray(onlyOrCondition), [_this.props.activeFilter]) : onlyOrCondition;
    }, _this.renderFilterRuleSet = function () {
      var filtersToDiplay = _this.buildFilterSet();
      return filtersToDiplay.map(function (filter, index) {
        if (filter === 'ADD') {
          return _this.renderChooseFilterLink();
        }

        var newLineValue = newLineValues.includes(filter.field) ? 'rule-new-line-value' : '';
        var isActive = _this.props.activePage === 'filterEditor' && _this.props.activeFilter.field === filter.field;
        var isActionOnlyFilter = _this.props.isActionOnlyField(_this.props.activeFilter.field);
        var preventPropagation = function preventPropagation(e) {
          return e.stopPropagation();
        };

        //defaulting to first rule since we dont support ors yet
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { onClick: _this.selectFilter(filter), className: 'rule-filters-set', key: index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            null,
            _this.displayIcon(filter.field),
            _this.displayType(filter.field),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { onClick: _this.removeFilter(filter) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'filter-close-button', height: 10, name: 'close' })
            )
          ),
          !isActionOnlyFilter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { className: __WEBPACK_IMPORTED_MODULE_16_classnames___default()('rule-preview-geo-value', { 'active': isActive }) },
            isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_marker_svg___default.a }),
            _this.displayOperator(filter.field),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: newLineValue },
              ' ',
              _this.displayValue(filter)
            )
          ),
          index < filtersToDiplay.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { onClick: preventPropagation, className: 'fitler-display-and' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              'AND'
            )
          )
        );
      });
    }, _this.renderChooseFilterLink = function () {
      var isActive = _this.props.activePage === "filterEditor";
      var activeClass = isActive ? 'active' : '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'rule-filters-set', key: 'custom' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { className: activeClass + ' filter-preview-link' },
          isActive && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_marker_svg___default.a }),
          'Choose Filter'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RuleFilters, [{
    key: 'displayType',
    value: function displayType(type) {
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["g" /* CONDITION_TYPE_LABELS */][type];
    }
  }, {
    key: 'displayIcon',
    value: function displayIcon(type) {
      var _ICONS;

      var ICONS = (_ICONS = {}, _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_geolocation_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_svg_geolocation_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_AUDIENCE, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_INDUSTRY, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_SUB_INDUSTRY, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_COUNT, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_RANGE, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_ANNUAL_SALES, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_MARKETING_ALIAS, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_REVENUE_RANGE, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_CITY, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, __WEBPACK_IMPORTED_MODULE_11__svg_inline_removeTags_true_images_icons_window_settings_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH, __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_HOST, __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_QUERY, __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_icons_link_icon_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */], __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_sf_small_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */], __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_targeting_map_location_svg___default.a), _defineProperty(_ICONS, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["C" /* LEANDATA_FILTER */], __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_logos_leandata_svg___default.a), _ICONS);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: ICONS[type], className: type });
    }
  }, {
    key: 'displayOperator',
    value: function displayOperator(operator, type) {
      //some of our conditions (like firmographics) have sub-types and are handled differently
      return __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["Q" /* SUB_TYPE_LABELS */][type] ? __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["Q" /* SUB_TYPE_LABELS */][type] : __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["F" /* OPERATOR_LABELS */][operator];
    }
  }, {
    key: 'displayValue',
    value: function displayValue(_ref2) {
      var value = _ref2.value,
          field = _ref2.field,
          operator = _ref2.operator;

      var conditionType = __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["f" /* CONDITION_TYPES */][field];

      if (conditionType === 'LeanData') {
        return conditionType;
      }
      if (conditionType === 'GEO') {
        return this.formatGeoValue(value, field);
      }
      if (conditionType === 'FIRMOGRAPHIC') {
        return this.formatFirmographicValue(value, field, operator);
      }
      if (conditionType === 'DISPLAY_WHEN') {
        return this.formatDisplayWhenValue(value, field);
      }
      if (conditionType === 'URL') {
        return this.formatURLValues(value, field, operator);
      }
      if (conditionType === 'Targeted Account') {
        return value;
      }
    }
  }, {
    key: 'formatFirmographicValue',
    value: function formatFirmographicValue(value, field, operator) {
      var _typeValues;

      var typeValues = (_typeValues = {}, _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, value.min + ' - ' + value.max + ' employees'), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, '$' + value.min + ' - $' + value.max + ' million'), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, '' + (Array.isArray(value) && value.join(', '))), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, '' + (Array.isArray(value) && value.join(', '))), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, '' + (Array.isArray(value) && value.map(function (key) {
        return __WEBPACK_IMPORTED_MODULE_6_components_settings_Rules_constants_tech_tags__["a" /* TECH_TAGS */][key];
      }).join(', '))), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, this.formatGeoValue(value, field)), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, this.formatGeoValue(value, field)), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_POSTAL_CODE, '' + (Array.isArray(value) && value.join(', '))), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, value + ' in annual revenue'), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_AUDIENCE, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_MARKETING_ALIAS, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_INDUSTRY, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_SUB_INDUSTRY, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_COUNT, this.formatNumericalValues(value, operator)), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_RANGE, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_ANNUAL_SALES, this.formatNumericalValues(value, operator)), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_REVENUE_RANGE, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_CITY, '' + value), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, this.formatGeoValue(value, field)), _defineProperty(_typeValues, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, this.formatGeoValue(value, field)), _typeValues);

      return typeValues[field];
    }
  }, {
    key: 'formatDisplayWhenValue',
    value: function formatDisplayWhenValue(value, type) {
      var typeValues = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, value.min + ' - ' + value.max + ' site visits');

      return typeValues[type];
    }
  }, {
    key: 'formatGeoValue',
    value: function formatGeoValue(value, field) {
      var geoType = [__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY].includes(field) ? __WEBPACK_IMPORTED_MODULE_5_components_settings_Rules_constants_continents__["a" /* continents */] : __WEBPACK_IMPORTED_MODULE_4_components_settings_Rules_constants_regions__["a" /* regions */];
      var valueMap = [__WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY].includes(field) ? __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["h" /* CONTINENT_LABELS */] : __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["H" /* REGION_LABELS */];
      var matchedBucket = _.find(Object.keys(geoType), function (type) {
        return _.isEqual(geoType[type], value);
      });

      return matchedBucket ? valueMap[matchedBucket] : 'Custom';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activeFilter = _props.activeFilter,
          currentPageIsValid = _props.currentPageIsValid,
          conditions = _props.conditions;

      var hasConditions = !Object(__WEBPACK_IMPORTED_MODULE_7_lodash__["isEmpty"])(conditions[0]);
      var conditionsContainActionOnlyField = hasConditions && conditions[0].some(function (condition) {
        return _this2.props.isActionOnlyField(condition.field);
      });
      var newFilterButtonIsDisabled = activeFilter === 'ADD' || activeFilter.field === 'targetedAccounts' || activeFilter.field === 'salesforceOwner' || !currentPageIsValid || conditionsContainActionOnlyField;

      if (activeFilter.field === 'onlineUsers') {
        return false;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-filters overview-rule' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'If conditions match...'
        ),
        this.renderFilterRuleSet(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { className: 'add-new-filter', size: 'small', type: 'primary', disabled: newFilterButtonIsDisabled, onClick: this.addFilter },
          '+ Add Filter'
        )
      );
    }
  }]);

  return RuleFilters;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RuleFilters);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "UCyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var IntegrationsAPI = Marty.createStateSource({
  id: 'IntegrationsAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  mapSlackUser: function mapSlackUser(slackUserId) {
    return this.post({
      url: '/integrations/slack/map_user',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify({ slackUserId: slackUserId })
    });
  },
  getStateParam: function getStateParam() {
    return this.get({
      url: '/integrations/slack/state',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createSlackBotToken: function createSlackBotToken(code, href) {
    var queryParams = href != null ? Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])({ redirectUri: href }) : '';
    return this.post({
      url: '/integrations/slack/activate_bot?' + queryParams,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify({ code: code })
    });
  },
  createAccessToken: function createAccessToken(name, body) {
    return this.post({
      url: '/integrations/' + name + '/access_token',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(body)
    });
  },
  integrationStates: function integrationStates() {
    return this.get({
      url: '/integrations',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  enableShopifyIntegration: function enableShopifyIntegration(state) {
    return this.post({
      url: '/integrations/shopify?enable=#' + state,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  hubspotInjectionState: function hubspotInjectionState() {
    return this.get({
      url: '/integrations/hubspot/js/inject',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  hubspotTimelineState: function hubspotTimelineState() {
    return this.get({
      url: '/integrations/hubspot/timeline',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateHubspotInjectionState: function updateHubspotInjectionState(state) {
    return this.post({
      url: '/integrations/hubspot/js/inject?enable=' + state,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateHubspotTimelineState: function updateHubspotTimelineState(state) {
    return this.post({
      url: '/integrations/hubspot/timeline?enable=' + state,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  hubspotCookieState: function hubspotCookieState() {
    return this.get({
      url: '/integrations/hubspot/cookie',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateHubspotCookieState: function updateHubspotCookieState(state) {
    return this.post({
      url: '/integrations/hubspot/cookie?enable=' + state,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateIntegrationState: function updateIntegrationState(properties) {
    return this.patch({
      url: '/integrations',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(properties)
    });
  },
  protip: function protip(key) {
    return this.get({
      url: '/protips/' + key,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "UEdl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchGeolocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGeolocationPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchGeolocationSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGeolocationFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("KtIW");




var fetchGeolocation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_GEOLOCATION */]);
var fetchGeolocationPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_GEOLOCATION_PENDING */]);
var fetchGeolocationSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_GEOLOCATION_SUCCESS */]);
var fetchGeolocationFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_GEOLOCATION_FAILURE */]);

/***/ }),

/***/ "UIoH":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Routing-/-Calendar-Edge-States\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Default\" transform=\"translate(-520.000000, -762.000000)\" fill=\"#D0011B\"><path d=\"M528.5,779 C523.812958,779 520,775.187042 520,770.5 C520,765.812958 523.812958,762 528.5,762 C533.187042,762 537,765.812958 537,770.5 C537,775.187042 533.187042,779 528.5,779 Z M528.5,763.416667 C524.59425,763.416667 521.416667,766.59425 521.416667,770.5 C521.416667,774.40575 524.59425,777.583333 528.5,777.583333 C532.40575,777.583333 535.583333,774.40575 535.583333,770.5 C535.583333,766.59425 532.40575,763.416667 528.5,763.416667 Z M528.5,775.458333 C528.315833,775.458333 528.131667,775.380417 527.997083,775.252917 C527.868875,775.118333 527.791667,774.934167 527.791667,774.75 C527.791667,774.55875 527.868875,774.381667 527.997083,774.247083 C528.259167,773.985 528.73375,773.985 529.002917,774.247083 C529.130417,774.381667 529.208333,774.55875 529.208333,774.75 C529.208333,774.934167 529.130417,775.118333 529.002917,775.252917 C528.868333,775.380417 528.684167,775.458333 528.5,775.458333 Z M528.5,772.625 C528.108292,772.625 527.791667,772.307667 527.791667,771.916667 L527.791667,766.25 C527.791667,765.859 528.108292,765.541667 528.5,765.541667 C528.891708,765.541667 529.208333,765.859 529.208333,766.25 L529.208333,771.916667 C529.208333,772.307667 528.891708,772.625 528.5,772.625 Z\" id=\"Shape\"></path></g></g></svg>"

/***/ }),

/***/ "UKWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return saveDemandbaseApiKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return saveMadKuduApiKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectMarketo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return searchForMarketoActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getMarketoToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return patchMarketoToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return setMarketoLeadOwnerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getMarketoLeadOwnerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return queryMarketoPrograms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchMarketoPrograms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getDefaultMarketoProgram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return setDefaultMarketoProgram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deleteDefaultMarketoProgram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return setMinimumCqlScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getMinimumCqlScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getSalesforceToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return patchSalesforceToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getEloquaConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return patchEloquaConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return patchPardotConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getPardotConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getPardotTranscriptField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return setPardotTranscriptField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return setPardotLeadOwnerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getPardotLeadOwnerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getHubspotToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return patchSlackNotificationToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getSlackNotificationToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return patchHubspotToggles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchMarketoMappedActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deleteMarketoMappedActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return patchMarketoMappedActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return toggleLinkedinIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return toggleVidyardIntegration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchInstalledApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return postIntegrationSuggestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return uninstallInstalledApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchAppScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authorizeApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getGoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getIntegrationStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getIntegrationEventLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getIntegrationEventLogQueryStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return emailBusinessCsvExport; });
/* unused harmony export enableClearbitEnrichment */
/* unused harmony export disableClearbitEnrichment */
/* unused harmony export enableClearbitReveal */
/* unused harmony export disableClearbitReveal */
/* unused harmony export fetchClearbitApiKeyOwner */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchStripeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchOutreachStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createSlackbotToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return updateIntegrationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return setWordpressDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchWordpressDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getLeanDataAuthorizationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getIntegrationRetryDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return setIntegrationRetryDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return postLoginFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__ = __webpack_require__("Y7j0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Helpers__ = __webpack_require__("nJx7");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var saveDemandbaseApiKey = function saveDemandbaseApiKey(apiKey) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/demandbase/access_token', { token: apiKey }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var saveMadKuduApiKey = function saveMadKuduApiKey(apiKey) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/madkudu/access_token', { token: apiKey }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var connectMarketo = function connectMarketo(_ref) {
  var munchkinId = _ref.munchkinId,
      clientId = _ref.clientId,
      clientSecret = _ref.clientSecret;

  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/marketo/config', { munchkinId: munchkinId, clientId: clientId, clientSecret: clientSecret }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var searchForMarketoActivity = function searchForMarketoActivity(searchTerm) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/marketo/activities/types?search=' + searchTerm).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getMarketoToggles = function getMarketoToggles() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/marketo/toggles').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchMarketoToggles = function patchMarketoToggles(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/marketo/toggles', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var setMarketoLeadOwnerField = function setMarketoLeadOwnerField(leadOwnerField) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/marketo/owner/field', { leadOwnerField: leadOwnerField }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getMarketoLeadOwnerField = function getMarketoLeadOwnerField() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/marketo/owner/field').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('leadOwnerField'));
};

var queryMarketoPrograms = function queryMarketoPrograms(query) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["SyncjobAPI"].get('/marketo/programs?q=' + query + '&offset=0&maxReturn=50').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchMarketoPrograms = function fetchMarketoPrograms() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["SyncjobAPI"].post('/marketo/programs/fetch', {}).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getDefaultMarketoProgram = function getDefaultMarketoProgram() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/marketo/programs/default').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var setDefaultMarketoProgram = function setDefaultMarketoProgram(programName, assignOnlyOnCreate) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/marketo/programs/default?assignOnlyOnCreate=' + assignOnlyOnCreate + '&programName=' + encodeURIComponent(programName), {}).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var deleteDefaultMarketoProgram = function deleteDefaultMarketoProgram() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].delete('/marketo/programs/default').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var setMinimumCqlScore = function setMinimumCqlScore(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/minimum_cql_score', data) // ex: { integrationName: 'salesforce', 'score': 1}
  .then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getMinimumCqlScore = function getMinimumCqlScore(integrationName) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/minimum_cql_score?integrationName=' + integrationName).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getSalesforceToggles = function getSalesforceToggles() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/toggles').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchSalesforceToggles = function patchSalesforceToggles(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/toggles', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getEloquaConfig = function getEloquaConfig() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/config').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchEloquaConfig = function patchEloquaConfig(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/eloqua/config', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchPardotConfig = function patchPardotConfig(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/pardot/config', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getPardotConfig = function getPardotConfig() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/config').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getPardotTranscriptField = function getPardotTranscriptField() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/config').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (json) {
    return json.conversationTranscriptField;
  });
};

var setPardotTranscriptField = function setPardotTranscriptField(transcriptField) {
  var payload = { 'conversationTranscriptField': transcriptField };
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/pardot/config', payload).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var setPardotLeadOwnerField = function setPardotLeadOwnerField(leadOwnerField) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/pardot/owner/field', { leadOwnerField: leadOwnerField }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getPardotLeadOwnerField = function getPardotLeadOwnerField() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/owner/field').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('leadOwnerField'));
};

var getHubspotToggles = function getHubspotToggles() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/hubspot/toggles').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};
var patchSlackNotificationToggle = function patchSlackNotificationToggle(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/slack/notifications', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var getSlackNotificationToggle = function getSlackNotificationToggle() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/slack/notifications').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchHubspotToggles = function patchHubspotToggles(data) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/hubspot/toggles', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchMarketoMappedActivities = function fetchMarketoMappedActivities() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/marketo/activities/mapped').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var deleteMarketoMappedActivity = function deleteMarketoMappedActivity(activityType) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].delete('/integrations/marketo/activities/mapped?activity-type=' + activityType).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var patchMarketoMappedActivities = function patchMarketoMappedActivities(activities) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/marketo/activities/mapped', activities).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var toggleLinkedinIntegration = function toggleLinkedinIntegration(isEnabled) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/linkedin/toggles', { enabled: isEnabled }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var toggleVidyardIntegration = function toggleVidyardIntegration(isEnabled) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations/vidyard/toggles', { enabled: isEnabled }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var fetchInstalledApps = function fetchInstalledApps() {
  return __WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__["b" /* CustomerAPIAuthEnabled */].get('/integrations/external').then(function (res) {
    return res.data;
  }).then(function (data) {
    return data.integrations;
  });
};

var postIntegrationSuggestion = function postIntegrationSuggestion(suggestion) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrationsuggestions?suggestion=' + suggestion).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var uninstallInstalledApp = function uninstallInstalledApp(id) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/external/' + id + '/uninstall').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchApp = function fetchApp(id) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/external/' + id).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchAppScopes = function fetchAppScopes(id) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/external/' + id + '/scopes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
    return data.scopes;
  });
};

var authorizeApp = function authorizeApp(id) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/external/' + id + '/authorize').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getGoogleScopes = function getGoogleScopes() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["MeetingsAPI"].get('/google/calendar/oauth/scopes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getIntegrationStates = function getIntegrationStates() {
  return __WEBPACK_IMPORTED_MODULE_1_app_auth_requests_api__["b" /* CustomerAPIAuthEnabled */].get('/integrations/all/public').then(function (res) {
    return res.data;
  });
};

var getIntegrationEventLog = function getIntegrationEventLog(query) {
  return getIntegrationEventLogQueryStr(Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])(query));
};

var getIntegrationEventLogQueryStr = function getIntegrationEventLogQueryStr(queryStr) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["DriftAPI"].get('/business/events/auth?' + queryStr).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var emailBusinessCsvExport = function emailBusinessCsvExport(payload) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["DriftAPI"].post('/business/events/export/csv', payload).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var enableClearbitEnrichment = function enableClearbitEnrichment() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/clearbit/toggles/enrichment', { enabled: true }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (response) {
    return response.data;
  });
};

var disableClearbitEnrichment = function disableClearbitEnrichment() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations', { clearbit_enrichment: false }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (response) {
    return response.data;
  });
};

var enableClearbitReveal = function enableClearbitReveal(apiKey) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/clearbit/properties/reveal_api_key', { apiKey: apiKey }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (response) {
    return response.data;
  });
};

var disableClearbitReveal = function disableClearbitReveal() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations', { clearbit_reveal: false }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (response) {
    return response.data;
  });
};

var fetchClearbitApiKeyOwner = function fetchClearbitApiKeyOwner() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/clearbit/properties/reveal_api_key/owner').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchStripeKeys = function fetchStripeKeys() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/stripe/keys').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var fetchOutreachStatus = function fetchOutreachStatus(orgId) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/outreach/install_status/internal').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var createAccessToken = function createAccessToken(integrationName, body) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/' + integrationName + '/access_token', body).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var createSlackbotToken = function createSlackbotToken(code, href) {
  var queryParams = href != null ? Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ redirectUri: href }) : '';
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/slack/activate_bot?' + queryParams, { code: code }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var updateIntegrationState = function updateIntegrationState(_ref2) {
  var integration = _ref2.integration,
      connected = _ref2.connected;

  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/integrations', _defineProperty({}, integration, connected)).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var setWordpressDomain = function setWordpressDomain(rootUrl) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/wordpress/v2', { rootUrl: rootUrl }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

var fetchWordpressDomain = function fetchWordpressDomain() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/wordpress/v2').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getLeanDataAuthorizationStatus = function getLeanDataAuthorizationStatus() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].get('/integration/test/leandata/authorization').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var getIntegrationRetryDelay = function getIntegrationRetryDelay(integration) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/integrations/delay_time/' + integration).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};
var setIntegrationRetryDelay = function setIntegrationRetryDelay(delay, integration) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/delay_time/' + integration, { retryDelayInMinutes: delay }, {
    headers: { 'Content-Type': 'application/json' } }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
};

var postLoginFailure = function postLoginFailure(integration) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/integrations/' + integration + '/failed_connect').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
};

/***/ }),

/***/ "UKWu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/getstarted-bg.1a7c9437.png";

/***/ }),

/***/ "UNEK":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 302.1 612 192\"><path fill=\"#95BF47\" d=\"M131.5 341.9c-.1-.9-.9-1.3-1.5-1.3s-13.7-1-13.7-1-9.1-9.1-10.2-10c-1-1-2.9-.7-3.7-.5-.1 0-2 .6-5.1 1.6-3.1-8.9-8.4-17-17.9-17h-.9c-2.6-3.4-6-5-8.8-5-22 0-32.6 27.5-35.9 41.5-8.6 2.7-14.7 4.5-15.4 4.8-4.8 1.5-4.9 1.6-5.5 6.1-.5 3.4-13 100.1-13 100.1l97.3 18.2L150 468c.1-.2-18.4-125.2-18.5-126.1zm-39.6-9.8c-2.4.7-5.3 1.6-8.2 2.6v-1.8c0-5.4-.7-9.8-2-13.3 5 .6 8.1 6.1 10.2 12.5zm-16.3-11.4c1.3 3.4 2.2 8.2 2.2 14.8v1c-5.4 1.7-11.1 3.4-17 5.3 3.3-12.6 9.6-18.8 14.8-21.1zm-6.4-6.2c1 0 2 .4 2.8 1-7.1 3.3-14.6 11.6-17.7 28.4-4.7 1.5-9.2 2.8-13.5 4.2 3.6-12.8 12.6-33.6 28.4-33.6z\"></path><path fill=\"#5E8E3E\" d=\"M130 340.4c-.6 0-13.7-1-13.7-1s-9.1-9.1-10.2-10c-.4-.4-.9-.6-1.3-.6l-7.3 150.6 52.8-11.4s-18.5-125.2-18.6-126.1c-.4-.9-1.1-1.3-1.7-1.5z\"></path><path fill=\"#FFF\" d=\"M79.4 369.6L73 388.9s-5.8-3.1-12.7-3.1c-10.3 0-10.8 6.5-10.8 8.1 0 8.8 23 12.2 23 32.9 0 16.3-10.3 26.8-24.2 26.8-16.8 0-25.2-10.4-25.2-10.4l4.5-14.8s8.8 7.6 16.2 7.6c4.9 0 6.9-3.8 6.9-6.6 0-11.5-18.8-12-18.8-31 0-15.9 11.4-31.3 34.5-31.3 8.6-.1 13 2.5 13 2.5z\"></path><path d=\"M211.6 405.9c-5.3-2.8-8-5.3-8-8.6 0-4.2 3.8-6.9 9.7-6.9 6.9 0 13 2.8 13 2.8l4.8-14.7s-4.4-3.4-17.4-3.4c-18.1 0-30.7 10.4-30.7 25 0 8.3 5.9 14.6 13.7 19.1 6.4 3.5 8.6 6.1 8.6 9.9 0 3.9-3.2 7.1-9.1 7.1-8.7 0-17-4.5-17-4.5l-5.1 14.7s7.6 5.1 20.4 5.1c18.6 0 32.1-9.2 32.1-25.7-.2-9-6.9-15.2-15-19.9zm74.2-31c-9.2 0-16.4 4.4-21.9 11l-.2-.1 8-41.6H251l-20.2 106h20.7l6.9-36.2c2.7-13.7 9.8-22.2 16.4-22.2 4.7 0 6.5 3.2 6.5 7.7 0 2.8-.2 6.4-.9 9.2l-7.8 41.5h20.7l8.1-42.8c.9-4.5 1.5-9.9 1.5-13.6-.1-11.9-6.2-18.9-17.1-18.9zm63.9 0c-25 0-41.5 22.5-41.5 47.6 0 16 9.9 29 28.5 29 24.5 0 41-21.9 41-47.6.1-14.9-8.5-29-28-29zm-10.2 60.8c-7.1 0-10-6-10-13.6 0-11.9 6.1-31.2 17.4-31.2 7.3 0 9.8 6.4 9.8 12.5 0 12.7-6.3 32.3-17.2 32.3zm91.3-60.8c-14 0-21.9 12.4-21.9 12.4h-.2l1.2-11.1h-18.4c-.9 7.5-2.6 19-4.2 27.5L373 479.6h20.7l5.8-30.7h.5s4.3 2.7 12.1 2.7c24.4 0 40.3-25 40.3-50.2-.1-14-6.4-26.5-21.6-26.5zm-19.8 61c-5.4 0-8.6-3.1-8.6-3.1l3.4-19.3c2.4-13 9.2-21.5 16.4-21.5 6.4 0 8.3 5.9 8.3 11.4.1 13.4-7.9 32.5-19.5 32.5zm70.9-90.7c-6.6 0-11.9 5.3-11.9 12 0 6.1 3.9 10.4 9.8 10.4h.2c6.5 0 12-4.4 12.1-12 .1-6.1-4-10.4-10.2-10.4zm-29 104.9h20.7l14-73.6h-20.8m73.6-.1H526l.7-3.4c1.2-7.1 5.4-13.3 12.4-13.3 3.7 0 6.6 1.1 6.6 1.1l4-16.3s-3.5-1.8-11.3-1.8c-7.3 0-14.7 2.1-20.3 6.9-7.1 6-10.4 14.7-12 23.5l-.6 3.4h-9.7l-3.1 15.7h9.7l-11 58h20.7l11-58h14.3l3-15.8zm49.9.1s-13 32.7-18.7 50.6h-.2c-.4-5.8-5.1-50.6-5.1-50.6h-21.8l12.5 67.4c.2 1.5.1 2.4-.5 3.4-2.4 4.7-6.5 9.2-11.3 12.5-3.9 2.8-8.3 4.7-11.8 5.9l5.8 17.6c4.2-.9 13-4.4 20.3-11.3 9.4-8.8 18.2-22.5 27.2-41.1l25.3-54.5h-21.7z\"></path></svg>"

/***/ }),

/***/ "UQNy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SendFromEdit":"SendFromEdit---Fimb_"};

/***/ }),

/***/ "UWAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_TeamsAPI__ = __webpack_require__("cATl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_TeamsConstants__ = __webpack_require__("p9md");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TeamsStore = function (_Marty$Store) {
  _inherits(TeamsStore, _Marty$Store);

  function TeamsStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TeamsStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TeamsStore.__proto__ || Object.getPrototypeOf(TeamsStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = false, _this.handlers = {
      teamsFetched: __WEBPACK_IMPORTED_MODULE_1_constants_TeamsConstants__["e" /* default */].FETCH_TEAMS_FINISHED,
      updateTeam: __WEBPACK_IMPORTED_MODULE_1_constants_TeamsConstants__["e" /* default */].UPDATE_TEAM_FINISHED
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TeamsStore, [{
    key: 'dehydrate',
    value: function dehydrate() {
      return false;
    }
  }, {
    key: 'rehydrate',
    value: function rehydrate(dehydratedState) {
      if (!!dehydratedState) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_app_api_TeamsAPI__["b" /* parseTeamList */])(dehydratedState);
      }
      return dehydratedState;
    }
  }, {
    key: 'getTeams',
    value: function getTeams() {
      return this.fetch({
        id: 'getTeams',
        dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
        locally: function locally() {
          if (!!this.state) {
            return this.state;
          }
        },
        remotely: function remotely() {
          var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
          return this.app.actions.TeamsActions.fetchTeamsForOrg(orgId);
        }
      });
    }
  }, {
    key: 'teamsFetched',
    value: function teamsFetched(teams) {
      this.state = teams;
    }
  }, {
    key: 'updateTeam',
    value: function updateTeam(teamId, team) {
      this.state = this.state.set(teamId, team);
    }
  }]);

  return TeamsStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (TeamsStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "UX+c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CardWrapper":"CardWrapper---1SvLQ","endUserAttributesCardPlaceholder":"endUserAttributesCardPlaceholder---3zkbO"};

/***/ }),

/***/ "UZTh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__ = __webpack_require__("/xdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





__webpack_require__("NZKz");

var AccountCallToActionPane = function (_Component) {
  _inherits(AccountCallToActionPane, _Component);

  function AccountCallToActionPane() {
    _classCallCheck(this, AccountCallToActionPane);

    return _possibleConstructorReturn(this, (AccountCallToActionPane.__proto__ || Object.getPrototypeOf(AccountCallToActionPane)).apply(this, arguments));
  }

  _createClass(AccountCallToActionPane, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isDisabled = _props.isDisabled,
          ctaTitle = _props.ctaTitle,
          ctaDescription = _props.ctaDescription,
          buttonLabel = _props.buttonLabel,
          handleClick = _props.handleClick,
          handleDismiss = _props.handleDismiss;

      var disabledClass = isDisabled ? 'disabled-account' : '';
      return React.createElement(
        'div',
        { className: disabledClass + ' PlanCta' },
        React.createElement(
          'h3',
          { className: 'dsg-h3 title' },
          ctaTitle
        ),
        React.createElement(
          'div',
          { className: 'dsg-Body description' },
          ctaDescription
        ),
        React.createElement(
          'button',
          { className: 'drift-button drift-button-primary large', style: { maxWidth: '14rem' }, onClick: handleClick },
          buttonLabel
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { className: 'close-button', src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default.a, onClick: handleDismiss })
      );
    }
  }]);

  return AccountCallToActionPane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AccountCallToActionPane);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "UZmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return fetchInboxPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchInboxCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchInboxFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return receiveInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return bulkCloseForInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return bulkCloseForInboxRequested; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return bulkCloseForInboxFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchInboxList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return fetchInboxListPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchInboxListCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchInboxListFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return receiveInboxList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchCountsForInboxIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchCounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchCountsPending; });
/* unused harmony export fetchCountsCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchCountsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return receiveCounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return receiveCounts2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return changeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bulkChangeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return changeParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return inboxChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return inboxRedirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return fetchWhitelabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return fetchWhitelabelPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return fetchWhitelabelFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return fetchWhitelabelCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fetchWhitelabelSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return createInboxBeforeWhitelabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return createWhitelabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return createWhitelabelPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return createWhitelabelFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return createWhitelabelCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return createWhitelabelSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return verifyWhitelabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return verifyWhitelabelPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return verifyWhitelabelFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return verifyWhitelabelCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return verifyWhitelabelSuccess; });
/* unused harmony export openWhitelabelDKIMSetting */
/* unused harmony export closeWhitelabelDKIMSetting */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return createInboxPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return createInboxFailed; });
/* unused harmony export createInboxCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return createInboxSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return patchInbox; });
/* unused harmony export patchInboxPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return patchInboxFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return patchInboxSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return archiveInbox; });
/* unused harmony export archiveInboxPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return archiveInboxFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return archiveInboxSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return fetchSendingDomains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return fetchSendingDomainsPending; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("Y4lW");



var fetchInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* FETCH_INBOX */]);
var fetchInboxPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* FETCH_INBOX_PENDING */]);
var fetchInboxCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* FETCH_INBOX_CANCELLED */]);
var fetchInboxFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* FETCH_INBOX_FAILED */]);
var receiveInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* RECEIVE_INBOX */]);

var bulkCloseForInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* BULK_CLOSE_FOR_INBOX */]);
var bulkCloseForInboxRequested = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* BULK_CLOSE_FOR_INBOX_REQUESTED */]);
var bulkCloseForInboxFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* BULK_CLOSE_FOR_INBOX_FAILED */]);

var fetchInboxList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* FETCH_INBOX_LIST */]);
var fetchInboxListPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* FETCH_INBOX_LIST_PENDING */]);
var fetchInboxListCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* FETCH_INBOX_LIST_CANCELLED */]);
var fetchInboxListFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* FETCH_INBOX_LIST_FAILED */]);
var receiveInboxList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* RECEIVE_INBOX_LIST */]);

var fetchCountsForInboxIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* FETCH_COUNTS_FOR_INBOX_IDS */]);
var fetchCounts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_COUNTS */]);
var fetchCountsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* FETCH_COUNTS_PENDING */]);
var fetchCountsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_COUNTS_CANCELLED */]);
var fetchCountsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* FETCH_COUNTS_FAILED */]);
var receiveCounts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* RECEIVE_COUNTS */]);
var receiveCounts2 = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* RECEIVE_COUNTS_2 */]);
var changeStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* CHANGE_STATUS */]);
var bulkChangeStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* BULK_CHANGE_STATUS */]);
var changeParticipants = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CHANGE_PARTICIPANTS */]);

var inboxChanged = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* INBOX_CHANGED */]);
var inboxRedirect = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* INBOX_REDIRECT */]);

var fetchWhitelabel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* FETCH_WHITELABEL */]);
var fetchWhitelabelPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* FETCH_WHITELABEL_PENDING */]);
var fetchWhitelabelFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* FETCH_WHITELABEL_FAILED */]);
var fetchWhitelabelCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* FETCH_WHITELABEL_CANCELLED */]);
var fetchWhitelabelSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* FETCH_WHITELABEL_SUCCESS */]);

var createInboxBeforeWhitelabel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* CREATE_INBOX_BEFORE_WHITELABEL */]);
var createWhitelabel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* CREATE_WHITELABEL */]);
var createWhitelabelPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* CREATE_WHITELABEL_PENDING */]);
var createWhitelabelFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* CREATE_WHITELABEL_FAILED */]);
var createWhitelabelCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* CREATE_WHITELABEL_CANCELLED */]);
var createWhitelabelSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* CREATE_WHITELABEL_SUCCESS */]);

var verifyWhitelabel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* VERIFY_WHITELABEL */]);
var verifyWhitelabelPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* VERIFY_WHITELABEL_PENDING */]);
var verifyWhitelabelFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* VERIFY_WHITELABEL_FAILED */]);
var verifyWhitelabelCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* VERIFY_WHITELABEL_CANCELLED */]);
var verifyWhitelabelSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* VERIFY_WHITELABEL_SUCCESS */]);

var openWhitelabelDKIMSetting = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* OPEN_WHITELABEL_DKIM_SETTING */]);
var closeWhitelabelDKIMSetting = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* CLOSE_WHITELABEL_DKIM_SETTING */]);

var createInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* CREATE_INBOX */]);
var createInboxPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* CREATE_INBOX_PENDING */]);
var createInboxFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* CREATE_INBOX_FAILED */]);
var createInboxCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* CREATE_INBOX_CANCELLED */]);
var createInboxSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* CREATE_INBOX_SUCCESS */]);

var patchInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* PATCH_INBOX */]);
var patchInboxPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["W" /* PATCH_INBOX_PENDING */]);
var patchInboxFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* PATCH_INBOX_FAILED */]);
var patchInboxSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* PATCH_INBOX_SUCCESS */]);

var archiveInbox = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ARCHIVE_INBOX */]);
var archiveInboxPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ARCHIVE_INBOX_PENDING */]);
var archiveInboxFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ARCHIVE_INBOX_FAILED */]);
var archiveInboxSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ARCHIVE_INBOX_SUCCESS */]);

var fetchSendingDomains = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* FETCH_SENDING_DOMAINS */]);
var fetchSendingDomainsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* FETCH_SENDING_DOMAINS_PENDING */]);

/***/ }),

/***/ "UbJF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UIDropArea__ = __webpack_require__("o4YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_playbook_components_TinyEditor__ = __webpack_require__("wfRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_playbook_components_Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_picture_drawing_svg__ = __webpack_require__("/3JQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_picture_drawing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_picture_drawing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MultiSignaturePreview__ = __webpack_require__("g7iH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("mdbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var AlsoIncludeSection = function AlsoIncludeSection(_ref) {
  var signatureIncludeAvatar = _ref.signatureIncludeAvatar,
      signatureIncludeSocial = _ref.signatureIncludeSocial,
      signatureIncludeBanner = _ref.signatureIncludeBanner,
      onIncludeAvatarChange = _ref.onIncludeAvatarChange,
      onIncludeSocialChange = _ref.onIncludeSocialChange,
      onIncludeBannerChange = _ref.onIncludeBannerChange;
  return React.createElement(
    'div',
    { className: 'signature-editor-also-include' },
    React.createElement(
      'h3',
      { className: 'signature-editor-also-include-title' },
      'Also Include:'
    ),
    React.createElement(
      'div',
      { className: 'signature-editor-also-include-wrapper' },
      React.createElement(
        'div',
        { className: 'signature-editor-option' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], { type: 'checkbox', onChange: onIncludeAvatarChange, checked: signatureIncludeAvatar }),
        React.createElement(
          'label',
          { className: 'signature-editor-option-label' },
          'Avatar'
        )
      ),
      React.createElement(
        'div',
        { className: 'signature-editor-option' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], { type: 'checkbox', onChange: onIncludeSocialChange, checked: signatureIncludeSocial }),
        React.createElement(
          'label',
          { className: 'signature-editor-option-label' },
          'Company Social Media'
        )
      ),
      React.createElement(
        'div',
        { className: 'signature-editor-option' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], { type: 'checkbox', onChange: onIncludeBannerChange, checked: signatureIncludeBanner }),
        React.createElement(
          'label',
          { className: 'signature-editor-option-label' },
          'Banner Graphic'
        )
      )
    )
  );
};

var BannerSettings = function BannerSettings(_ref2) {
  var onBannerUpload = _ref2.onBannerUpload,
      onBannerLinkURLChange = _ref2.onBannerLinkURLChange,
      onClearSignatureBanner = _ref2.onClearSignatureBanner,
      onIncludeNoBannerOption = _ref2.onIncludeNoBannerOption,
      emptyBannerChecked = _ref2.emptyBannerChecked,
      onAddNewBanner = _ref2.onAddNewBanner,
      onRemoveSignatureClick = _ref2.onRemoveSignatureClick,
      signatureIncludeBanner = _ref2.signatureIncludeBanner,
      signatureBannerUploadPending = _ref2.signatureBannerUploadPending,
      signatures = _ref2.signatures;
  return signatureIncludeBanner && React.createElement(
    'div',
    null,
    signatures.toList().map(function (signature, i) {
      return signature.hasCampaignGraphic && React.createElement(
        'div',
        { className: 'playbook-signature-banner-customize', key: signature.id },
        React.createElement(
          'div',
          { className: 'playbook-signature-remove-signature-container' },
          React.createElement(
            'div',
            { className: 'playbook-signature-remove-signature', onClick: function onClick() {
                return onRemoveSignatureClick(signature.id, signatures.size);
              } },
            React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { name: 'cancel-circle' }),
            React.createElement(
              'p',
              null,
              'Remove this option'
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_UIDropArea__["a" /* default */],
          {
            onDrop: function onDrop(files) {
              return onBannerUpload(files, signature.id);
            },
            onClear: function onClear(e) {
              return onClearSignatureBanner(e, signature);
            },
            shouldRenderClear: false,
            shouldRenderPreview: false,
            className: 'playbook-email-edit-banner-drop-area',
            disabled: !!signature.campaignGraphic
          },
          !!signature.campaignGraphic && React.createElement(
            'div',
            { className: 'playbook-signature-edit-banner-drop-area' },
            React.createElement('img', { src: signature.campaignGraphic })
          ),
          !signature.campaignGraphic && React.createElement(
            'div',
            { className: 'playbook-email-edit-banner-drop-zone playbook-signature-edit-banner-drop-area' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'playbook-email-edit-empty-banner-icon' },
                React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_picture_drawing_svg___default.a, width: "20px" })
              ),
              !signatureBannerUploadPending && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-title' },
                  'Drag and drop or ',
                  React.createElement(
                    'span',
                    { className: 'link' },
                    'Upload a Graphic'
                  )
                )
              ),
              signatureBannerUploadPending && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-title' },
                  'Uploading your banner image.'
                ),
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-upload-loading-container' },
                  React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__["a" /* default */], null)
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'playbook-edit-banner-help-text' },
              React.createElement(
                'p',
                null,
                'Keep in mind that your image will be shrunk to 450px wide in the email.'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'playbook-signature-edit-banner-link' },
          React.createElement(
            'p',
            { className: 'playbook-signature-edit-banner-link-title' },
            'Image Link'
          ),
          React.createElement(
            'p',
            { className: 'playbook-signature-edit-banner-link-helptext' },
            'The link users are taken to when they click the campaign banner'
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], { value: signature.campaignGraphicLink || '', onChange: function onChange(e) {
              return onBannerLinkURLChange(e, signature.id);
            }, placeholder: 'link for people who click the image' })
        )
      );
    }).toJS(),
    React.createElement(
      'div',
      { className: 'playbook-signature-add-more-section' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
        { className: 'playbook-signature-add-more-button', onClick: onAddNewBanner, disabled: signatures.size >= 5 },
        '+ Add Another'
      ),
      (signatures.size < 5 || emptyBannerChecked) && React.createElement(
        'div',
        { className: 'signature-editor-option signature-editor-empty-option' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], { type: 'checkbox', checked: emptyBannerChecked, onChange: onIncludeNoBannerOption }),
        React.createElement(
          'label',
          { className: 'signature-editor-option-label' },
          'Include a "No Banner" Option'
        )
      ),
      signatures.size < 5 && React.createElement(
        'p',
        { className: 'playbook-signature-banner-count' },
        'You can add up to ',
        '' + (5 - signatures.size),
        ' more banner',
        5 - signatures.size > 1 ? 's' : ''
      ),
      signatures.size >= 5 && React.createElement(
        'p',
        { className: 'playbook-signature-banner-count' },
        'You have added all 5 allowed banner options.'
      )
    )
  );
};

var MiniSignaturePreview = function MiniSignaturePreview(_ref3) {
  var signaturePreviewContent = _ref3.signaturePreviewContent,
      signaturePreviewFetchFailed = _ref3.signaturePreviewFetchFailed,
      signaturePreviewFetchPending = _ref3.signaturePreviewFetchPending;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'playbook-signature-editor-preview-loading-container' },
      signaturePreviewFetchPending && React.createElement(
        'div',
        { className: 'playbook-signature-editor-preview-loading' },
        'Fetching updated preview',
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__["a" /* default */], null)
      ),
      signaturePreviewFetchFailed && React.createElement(
        'div',
        { className: 'playbook-signature-editor-preview-failed' },
        'Could not fetch the newest preview, check your signature for any errors'
      )
    ),
    React.createElement('div', { dangerouslySetInnerHTML: { __html: signaturePreviewContent } })
  );
};

var SignatureEditor = function SignatureEditor(_ref4) {
  var signatureBody = _ref4.signatureBody,
      onContentChange = _ref4.onContentChange,
      props = _objectWithoutProperties(_ref4, ['signatureBody', 'onContentChange']);

  return React.createElement(
    'div',
    null,
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_5_components_playbook_components_Card__["a" /* default */],
      { title: 'Configure Template' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_playbook_components_TinyEditor__["a" /* default */], {
        initialContent: signatureBody,
        onChange: onContentChange,
        showPersonalization: true,
        showSignature: false,
        includeColorAndSize: true,
        includeAlignment: false
      }),
      React.createElement(AlsoIncludeSection, props),
      React.createElement(BannerSettings, props),
      React.createElement(
        'div',
        { className: 'signature-editor-mini-preview' },
        React.createElement(
          'div',
          { className: 'playbook-card-no-padding signature-editor-mini-preview-title' },
          'PREVIEW'
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_7__MultiSignaturePreview__["a" /* default */], {
          multiSignature: props.signaturePreviewAllData,
          multiSignaturePreviewFetchPending: props.signaturePreviewAllFetchPending,
          multiSignaturePreviewFetchFailed: props.signaturePreviewAllFetchFailed,
          onRefetchClick: props.onRefetchPreviewClick
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SignatureEditor);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "UeYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_colors_json__);


var PendingTemplate = React.createElement(
  "div",
  { style: { height: "100vh", width: "100vw", backgroundColor: __WEBPACK_IMPORTED_MODULE_0_styles_colors_json___default.a['color-blue'] }, className: "flex-center" },
  React.createElement("img", { style: { width: "100%" }, src: __webpack_require__("z6IM") })
);

/* harmony default export */ __webpack_exports__["a"] = (PendingTemplate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "UnnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_hocs_withTracking__ = __webpack_require__("xq94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_MainNav_NewAgentStatus_constants__ = __webpack_require__("ZBOl");










// TODO: Lift into shared helper


var isActiveAvailability = function isActiveAvailability(availability) {
  return availability === __WEBPACK_IMPORTED_MODULE_9_components_MainNav_NewAgentStatus_constants__["a" /* AvailabilityStatus */].ACTIVE || availability === __WEBPACK_IMPORTED_MODULE_9_components_MainNav_NewAgentStatus_constants__["a" /* AvailabilityStatus */].ON_CALL;
};

var mapStateToProps = function mapStateToProps(state) {
  var _OrgSelectors$propert = __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["properties"](state),
      limitNumChats = _OrgSelectors$propert.limitNumChats,
      limitNumChatsEnabled = _OrgSelectors$propert.limitNumChatsEnabled;

  var currentUser = __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"](state);

  return {
    currentUser: currentUser,
    isActive: isActiveAvailability(currentUser.availability),
    currentUserLoaded: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUserLoaded"](state),
    limitNumChatsEnabled: limitNumChatsEnabled,
    limitNumChats: limitNumChats,
    isUserAtConversationLimit: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_properties_selectors__["e" /* isUserAtConversationLimit */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    updateCurrentUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_actions__["updateCurrentUser"]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_8_components_hocs_withTracking__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["k" /* withStateHandlers */])(function () {
  return {
    isUpdatingStatus: false,
    nextAvailability: null
  };
}, {
  setNextAvailability: function setNextAvailability() {
    return function (nextAvailability) {
      return {
        isUpdatingStatus: true,
        nextAvailability: nextAvailability
      };
    };
  },
  setNextAvailabilityDone: function setNextAvailabilityDone() {
    return function () {
      return {
        isUpdatingStatus: false,
        nextAvailability: null
      };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  toggleStatus: function toggleStatus(props) {
    return function (_ref) {
      var source = _ref.source;

      if (props.isUpdatingStatus) {
        return;
      }

      var nextAvailability = props.isActive ? __WEBPACK_IMPORTED_MODULE_9_components_MainNav_NewAgentStatus_constants__["a" /* AvailabilityStatus */].AWAY : __WEBPACK_IMPORTED_MODULE_9_components_MainNav_NewAgentStatus_constants__["a" /* AvailabilityStatus */].ACTIVE;

      var operations = Object(__WEBPACK_IMPORTED_MODULE_7_utils_PatchHelper__["a" /* patchOperations */])({ availability: nextAvailability }, { availability: props.currentUser.availability });

      if (!operations.length) {
        return;
      }

      props.setNextAvailability(nextAvailability);
      props.updateCurrentUser(operations).finally(props.setNextAvailabilityDone);
      props.track('AgentStatusToggle clicked', {
        status: nextAvailability,
        source: source
      });
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref2) {
  var isUpdatingStatus = _ref2.isUpdatingStatus,
      isActive = _ref2.isActive,
      nextAvailability = _ref2.nextAvailability;
  return {
    isActive: isUpdatingStatus ? isActiveAvailability(nextAvailability) : isActive
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref3) {
  var currentUserLoaded = _ref3.currentUserLoaded;
  return {
    isAgentStatusLoaded: currentUserLoaded
  };
})));

/***/ }),

/***/ "Unpx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iOCIgZmlsbCA9IiMwMTc2RkYiIHZpZXdCb3g9IjAgMCAxMSA4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik02LjEzMiA2LjA2NmEuODQ0Ljg0NCAwIDAgMS0xLjE4OC4wMDZMMS4yNTIgMi40NDZhLjg0NC44NDQgMCAxIDEgMS4xODMtMS4yMDRMNS41NDIgNC4yOCA4LjU2IDEuMjQ4QS44NDQuODQ0IDAgMSAxIDkuNzUyIDIuNDRsLTMuNjIgMy42MjZ6IiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4="

/***/ }),

/***/ "Uq9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_chartjs__ = __webpack_require__("JdSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactabular__ = __webpack_require__("QDzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactabular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reactabular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customer_CustomerMetric__ = __webpack_require__("WBJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__ = __webpack_require__("97t2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__conversation_InboxButton__ = __webpack_require__("A3PM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabbedView__ = __webpack_require__("ChgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_web_src_components_Table__ = __webpack_require__("XRZ2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_web_src_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_web_src_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_TimeSelectorButton__ = __webpack_require__("cYdt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_ChartConfig__ = __webpack_require__("Pyzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_styles_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_components_Dashboard_styl__ = __webpack_require__("IfBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_styles_components_Dashboard_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_styles_components_Dashboard_styl__);

















var metricMapping = {
  NEW_CONVERSATIONS: {
    display: 'new conversations',
    value: function value(metric) {
      return metric.sum;
    },
    previousValue: function previousValue(metric) {
      return metric.previousSum;
    },
    delta: function delta(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["b" /* calculateChangePercentage */](metric.previousSum, metric.sum);
    }
  },
  CLOSED_CONVERSATIONS: {
    display: 'closed conversations',
    value: function value(metric) {
      return metric.sum;
    },
    previousValue: function previousValue(metric) {
      return metric.previousSum;
    },
    delta: function delta(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["b" /* calculateChangePercentage */](metric.previousSum, metric.sum);
    }
  },
  OPEN_CONVERSATIONS: {
    display: 'open conversations',
    value: function value(metric) {
      return metric.sum;
    },
    previousValue: function previousValue(metric) {
      return metric.previousSum;
    },
    delta: function delta(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["b" /* calculateChangePercentage */](metric.previousSum, metric.sum);
    }
  },
  AVERAGE_TIME_TO_FIRST_RESPONSE: {
    display: 'avg time to first response',
    value: function value(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](metric.average);
    },
    previousValue: function previousValue(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](metric.previousAverage);
    },
    dataTransformer: function dataTransformer(datum) {
      return parseFloat(__WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](datum));
    },
    delta: function delta(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["b" /* calculateChangePercentage */](metric.previousAverage, metric.average);
    }
  },
  AVERAGE_TIME_TO_CLOSE: {
    display: 'avg time to close',
    value: function value(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](metric.average);
    },
    previousValue: function previousValue(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](metric.previousAverage);
    },
    dataTransformer: function dataTransformer(datum) {
      return parseFloat(__WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["c" /* millisecondsToDuration */](datum));
    },
    delta: function delta(metric) {
      return __WEBPACK_IMPORTED_MODULE_6_utils_DateHelpers__["b" /* calculateChangePercentage */](metric.previousAverage, metric.average);
    }
  }
};

var Dashboard = React.createClass({
  displayName: 'Dashboard',


  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      columns: this.getColumns(),
      header: this.getHeader()
    };
  },
  getSelectedMetric: function getSelectedMetric() {
    var metrics = this.props.inboxStats != null ? this.props.inboxStats.inboxMetrics : undefined;
    return _.find(metrics, { metricType: this.context.location.query.metric });
  },
  formatDateRangeTooltip: function formatDateRangeTooltip(startDate, endDate) {
    var strFormat = 'MM/DD';
    return startDate.format(strFormat) + ' - ' + endDate.format(strFormat);
  },
  getMetricTooltip: function getMetricTooltip(metric) {
    var metricDisplay = metricMapping[metric.metricType];
    var query = this.context.location.query;

    var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(+query.startDate);
    var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(+query.endDate);

    var diff = this.getMomentDateRange().diff('days');

    var previousStartDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).subtract(diff, 'days');
    var previousEndDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(endDate).subtract(diff, 'days');

    return React.createElement(
      'div',
      null,
      React.createElement(
        'table',
        null,
        React.createElement(
          'tr',
          null,
          React.createElement(
            'td',
            null,
            this.formatDateRangeTooltip(previousStartDate, previousEndDate)
          ),
          React.createElement(
            'td',
            null,
            metricDisplay.previousValue(metric)
          )
        ),
        React.createElement(
          'tr',
          null,
          React.createElement(
            'td',
            null,
            this.formatDateRangeTooltip(startDate, endDate)
          ),
          React.createElement(
            'td',
            null,
            metricDisplay.value(metric)
          )
        )
      )
    );
  },
  getMetricsItems: function getMetricsItems() {
    var _this = this;

    return _.map(this.props.inboxStats != null ? this.props.inboxStats.inboxMetrics : undefined, function (metric, i) {
      var metricDisplay = metricMapping[metric.metricType];

      return React.createElement(
        'div',
        { key: i, onClick: _this.clickMetric.bind(_this, metric) },
        React.createElement(__WEBPACK_IMPORTED_MODULE_5__customer_CustomerMetric__["a" /* default */], {
          metric: (metricDisplay != null ? metricDisplay.value(metric) : undefined) || 0,
          display: metricDisplay.display,
          deltaPercentage: metricDisplay != null ? metricDisplay.delta(metric) : undefined,
          showDelta: true,
          selectable: true,
          tooltipText: _this.getMetricTooltip(metric),
          isSelected: metric === _this.getSelectedMetric() })
      );
    });
  },
  cloneQuery: function cloneQuery() {
    return _.cloneDeep(this.context.location.query);
  },
  onQueryChange: function onQueryChange(query) {
    var pathname = '/conversation-stats';
    return this.context.router.push({ pathname: pathname, query: query });
  },
  clickMetric: function clickMetric(metric) {
    if (this.context.location.metric === metric.metricType) {
      return;
    }
    var query = this.cloneQuery();
    query.metric = metric.metricType;
    return this.onQueryChange(query);
  },
  onSelectInbox: function onSelectInbox(inbox) {
    if (this.context.location.query.inboxId === inbox.id) {
      return;
    }
    var query = this.cloneQuery();
    query.inboxId = inbox.id;
    return this.onQueryChange(query);
  },
  getMomentDateRange: function getMomentDateRange() {
    var query = this.context.location.query;

    var now = __WEBPACK_IMPORTED_MODULE_0_moment___default()();
    var startDate = query.startDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(parseInt(query.startDate)) : now;
    var endDate = query.endDate ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(parseInt(query.endDate)) : now;
    return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.range(startDate, endDate);
  },
  onSetRange: function onSetRange(range) {
    if (range.isSame(this.getMomentDateRange())) {
      return;
    }
    var query = this.cloneQuery();
    query.startDate = range.start.valueOf();
    query.endDate = range.end.valueOf();
    return this.onQueryChange(query);
  },
  getColumns: function getColumns() {
    return [{
      property: 'name',
      header: 'Name'
    }, {
      property: 'openConversations',
      header: 'Open Conversations'
    }, {
      property: 'closedConversations',
      header: 'Closed Conversations'
    }];
  },
  getHeader: function getHeader() {
    var _this2 = this;

    return {
      onClick: function onClick(column) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_reactabular__["sortColumn"])(_this2.state.columns, column, _this2.setState.bind(_this2));
      }
    };
  },
  getTableData: function getTableData() {
    return _.map(this.props.inboxStats != null ? this.props.inboxStats.drifttUserMetrics : undefined, function (userMetric, i) {
      return {
        name: userMetric.user.name,
        openConversations: userMetric.openConversations,
        closedConversations: userMetric.closedConversations
      };
    });
  },
  getChartData: function getChartData() {
    var labels = [];
    var numDays = this.getMomentDateRange().diff('days');

    this.getMomentDateRange().by('days', function (moment) {
      return labels.push(moment.format('MM/DD'));
    });

    var selectedMetric = this.getSelectedMetric();
    var metricDisplay = metricMapping[__guard__(this.getSelectedMetric(), function (x) {
      return x.metricType;
    })];

    var histogramData = (metricDisplay != null ? metricDisplay.dataTransformer : undefined) ? _.map(selectedMetric.buckets, metricDisplay.dataTransformer) : selectedMetric != null ? selectedMetric.buckets : undefined;

    return {
      labels: labels,
      datasets: [_.extend({ data: histogramData }, __WEBPACK_IMPORTED_MODULE_11_constants_ChartConfig__["b" /* ColorConfig */])]
    };
  },
  renderTables: function renderTables() {
    var _this3 = this;

    if ((this.props.inboxStats != null ? this.props.inboxStats.drifttUserMetrics.length : undefined) > 0) {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_8__TabbedView__["a" /* default */], {
        tabs: [{
          display: 'By Team Member',
          render: function render() {
            return React.createElement(__WEBPACK_IMPORTED_MODULE_9_shared_web_src_components_Table___default.a, {
              columns: _this3.state.columns,
              data: __WEBPACK_IMPORTED_MODULE_3_reactabular__["sortColumn"].sort(_this3.getTableData(), _this3.state.sortingColumn, _.orderBy),
              columnNames: _this3.state.header });
          }
        }] });
    }
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'Page' },
      React.createElement(
        'div',
        { className: 'DashboardPage' },
        React.createElement(
          'div',
          { className: 'controls' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7__conversation_InboxButton__["a" /* default */], {
            onSelectInbox: this.onSelectInbox,
            selectedInbox: this.props.inboxesById != null ? this.props.inboxesById[this.context.location.query.inboxId] : undefined,
            inboxes: this.props.inboxesById != null && _.values(this.props.inboxesById) }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_TimeSelectorButton__["a" /* default */], {
            onSetRange: this.onSetRange,
            selectedDateRange: this.getMomentDateRange() })
        ),
        React.createElement(
          'div',
          { className: 'metrics' },
          this.getMetricsItems()
        ),
        React.createElement(
          'div',
          { className: 'chart-container' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2_react_chartjs__["Line"], { redraw: true, options: __WEBPACK_IMPORTED_MODULE_11_constants_ChartConfig__["a" /* ChartOptions */], data: this.getChartData() })
        ),
        React.createElement(
          'div',
          { className: 'tabular-info' },
          this.renderTables()
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(Dashboard, {
  contextTypes: {
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  listenTo: ['stores.InboxStore', 'stores.DashboardStore'],

  fetch: {
    inboxesById: function inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList();
    },
    inboxStats: function inboxStats() {
      var query = this.props.query;
      var inboxId = query.inboxId;
      var startDate = query.startDate;
      var endDate = query.endDate;

      if (inboxId) {
        return this.app.stores.DashboardStore.getOrFetchInboxStats(inboxId, startDate, endDate);
      }
    }
  },

  pending: function pending() {
    return React.createElement(Dashboard, null);
  },
  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
}));

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "UrZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("kPnO");










var mapStateToProps = function mapStateToProps(state) {
  return {
    users: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["orgUsersById"])(state),
    nonBotUsers: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["nonBotUsers"])(state),
    draftId: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["p" /* draftId */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideSequenceInviteModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_90" /* hideSequenceInviteModal */],
      notify: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_96" /* notify */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    options: props.nonBotUsers.toArray().map(function (user) {
      return { value: user.id, label: user.name || user.email };
    })
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onCloseClick: function onCloseClick(props) {
    return function () {
      return props.actions.hideSequenceInviteModal();
    };
  },
  onNext: function onNext(props) {
    return function (userIds) {
      props.actions.hideSequenceInviteModal();
      props.actions.notify({ userIds: userIds, playbookId: props.draftId });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "UsF/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UsXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"LinkIcon":"LinkIcon---3Qf90"};

/***/ }),

/***/ "Utpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SubmitEmailPreviewBox__ = __webpack_require__("TPdv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("auPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);






var toHex = function toHex(colorCode) {
  return '#' + colorCode;
};

var EmailCapturePreview = function EmailCapturePreview(_ref) {
  var name = _ref.name,
      message = _ref.message,
      avatarUrl = _ref.avatarUrl,
      backgroundColor = _ref.backgroundColor,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.EmailCapturePreview, className) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'capture-message' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'name' },
        name
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content' },
        message
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'submit-email-wrapper' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'avatar' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'avatar-image', style: { backgroundImage: 'url(' + avatarUrl + ')' } })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_SubmitEmailPreviewBox__["a" /* default */], { backgroundColor: toHex(backgroundColor) })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailCapturePreview);

/***/ }),

/***/ "Uu++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlaybookDraftToggle__ = __webpack_require__("vd8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SendButton__ = __webpack_require__("NJAK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScheduleButton__ = __webpack_require__("R6Pq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OutboundSequence__ = __webpack_require__("xdhv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScheduleEmail__ = __webpack_require__("3inQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PlaybookSelects__ = __webpack_require__("+f5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_action_error_svg__ = __webpack_require__("3kMP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_action_error_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_action_error_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("FAbD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);




















var HAS_UNLIMITED_CONTACTS_COPY = "Once you turn this playbook on, all contacts in the segment added by the bot will immediately receive emails. " + "New contacts added into that same segment will automatically receive these emails.";

var ReviewHeader = function ReviewHeader(_ref) {
  var playbookStatus = _ref.playbookStatus,
      isEmailPlaybook = _ref.isEmailPlaybook,
      isOutboundSequencePlaybook = _ref.isOutboundSequencePlaybook,
      targetingCardinality = _ref.targetingCardinality,
      isCardinalityLoading = _ref.isCardinalityLoading,
      isOneTimeEmailPlaybook = _ref.isOneTimeEmailPlaybook,
      copy = _ref.copy,
      hasLimitedContactsMktEmail = _ref.hasLimitedContactsMktEmail;
  return React.createElement(
    'header',
    { className: 'playbook-title-header' },
    isEmailPlaybook && !isOutboundSequencePlaybook && playbookStatus !== __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT && hasLimitedContactsMktEmail && React.createElement(
      'h2',
      { className: 'playbook-build-review-title' },
      isCardinalityLoading ? React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__["a" /* default */], null) : targetingCardinality,
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(targetingCardinality, 'person', 'people'),
      ' receive this email.'
    ),
    isOneTimeEmailPlaybook && playbookStatus === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT && React.createElement(
      'h2',
      { className: 'playbook-build-review-title' },
      'Up to ',
      isCardinalityLoading ? React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__["a" /* default */], null) : targetingCardinality,
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_2_humanize_plus__["pluralize"])(targetingCardinality, 'person', 'people'),
      ' received this email.'
    ),
    isOutboundSequencePlaybook && React.createElement(
      'h2',
      null,
      'You\u2019re almost ready to send your sequence'
    ),
    !isEmailPlaybook && React.createElement(
      'h2',
      null,
      'Your playbook is ready.'
    ),
    React.createElement('p', { dangerouslySetInnerHTML: { __html: isEmailPlaybook && !hasLimitedContactsMktEmail ? HAS_UNLIMITED_CONTACTS_COPY : copy } })
  );
};

var ReportLink = function ReportLink(_ref2) {
  var isMarketingSequencePlaybook = _ref2.isMarketingSequencePlaybook,
      playbookId = _ref2.playbookId;

  var href = isMarketingSequencePlaybook ? '/reports/playbooks/' + playbookId : '/reports/chat-playbooks/' + playbookId;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
    {
      type: 'subtle',
      className: 'playbook-review-view-report-button',
      href: href
    },
    'View Report'
  );
};

var Review = function Review(_ref3) {
  var draft = _ref3.draft,
      copy = _ref3.copy,
      isOneTimeEmailPlaybook = _ref3.isOneTimeEmailPlaybook,
      isEmailPlaybook = _ref3.isEmailPlaybook,
      isSendNow = _ref3.isSendNow,
      isScheduled = _ref3.isScheduled,
      onEnableConfirm = _ref3.onEnableConfirm,
      handleSetNow = _ref3.handleSetNow,
      handleSetScheduled = _ref3.handleSetScheduled,
      hasSegmentSelected = _ref3.hasSegmentSelected,
      targetingCardinality = _ref3.targetingCardinality,
      isCardinalityLoading = _ref3.isCardinalityLoading,
      isOutboundSequencePlaybook = _ref3.isOutboundSequencePlaybook,
      onShareClick = _ref3.onShareClick,
      isGmailConnected = _ref3.isGmailConnected,
      onConnectGmailClick = _ref3.onConnectGmailClick,
      onInstallExtensionClick = _ref3.onInstallExtensionClick,
      userProperties = _ref3.userProperties,
      isMarketingSequencePlaybook = _ref3.isMarketingSequencePlaybook,
      isDkimSetUp = _ref3.isDkimSetUp,
      isDkimVerified = _ref3.isDkimVerified,
      hasLimitedContactsMktEmail = _ref3.hasLimitedContactsMktEmail;
  return React.createElement(
    'div',
    { className: 'playbook-builder-review-wrapper' },
    React.createElement(ReviewHeader, {
      isEmailPlaybook: isEmailPlaybook,
      isOutboundSequencePlaybook: isOutboundSequencePlaybook,
      targetingCardinality: targetingCardinality,
      isCardinalityLoading: isCardinalityLoading,
      isOneTimeEmailPlaybook: isOneTimeEmailPlaybook,
      playbookStatus: draft.status,
      copy: copy,
      hasLimitedContactsMktEmail: hasLimitedContactsMktEmail
    }),
    isOneTimeEmailPlaybook && React.createElement(
      'div',
      { className: 'playbook-container' },
      React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("playbook-review-email-send-options", { disabled: !hasSegmentSelected || draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT || draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SCHEDULED }) },
        React.createElement(
          'form',
          { className: 'playbook-review-email-send-options-form' },
          React.createElement(
            'label',
            { className: 'email-send-radio-option' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], { type: 'radio', onClick: handleSetNow, disabled: !hasSegmentSelected || draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT, checked: isSendNow }),
            ' Send email now'
          ),
          React.createElement(
            'label',
            { className: 'email-send-radio-option' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Input"], { type: 'radio', onClick: handleSetScheduled, disabled: !hasSegmentSelected || draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT, checked: isScheduled }),
            ' Schedule email for later'
          )
        )
      ),
      React.createElement('hr', null),
      !hasSegmentSelected && React.createElement(
        'div',
        { className: 'playbook-review-errors' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_action_error_svg___default.a }),
        ' You must choose at least one segment to send email.',
        ' ',
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
          { to: '/playbooks/' + draft.id + '/edit/targeting/audience' },
          'Build Your Audience'
        )
      ),
      isSendNow && React.createElement(__WEBPACK_IMPORTED_MODULE_9__SendButton__["a" /* default */], {
        className: 'playbook-review-email-send-button',
        onClickConfirm: onEnableConfirm,
        isMarketingSequencePlaybook: isMarketingSequencePlaybook,
        disabled: draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT
      }),
      isScheduled && React.createElement(
        'div',
        null,
        React.createElement(__WEBPACK_IMPORTED_MODULE_12__ScheduleEmail__["a" /* default */], null),
        React.createElement(__WEBPACK_IMPORTED_MODULE_10__ScheduleButton__["a" /* default */], {
          className: 'playbook-review-email-schedule-button',
          disabled: draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT
        }),
        React.createElement(
          'span',
          { className: 'playbook-review-schedule-warning' },
          'Heads up! You ',
          React.createElement(
            'strong',
            null,
            'can\'t edit this email once '
          ),
          ' it\'s been ',
          React.createElement(
            'strong',
            null,
            'scheduled'
          )
        )
      )
    ),
    !isOneTimeEmailPlaybook && !isOutboundSequencePlaybook && React.createElement(
      'div',
      { className: 'playbook-container playbook-review-toggle-summary' },
      React.createElement(
        'div',
        { className: 'flex-space-between' },
        React.createElement(
          'div',
          { className: 'color-navy-extra-dark dsg-medium-weight' },
          'This playbook is'
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_8__PlaybookDraftToggle__["a" /* default */], null)
      ),
      !isEmailPlaybook && React.createElement(__WEBPACK_IMPORTED_MODULE_13__PlaybookSelects__["a" /* default */], { reportType: draft.reportType, playbookId: draft.id })
    ),
    isMarketingSequencePlaybook && React.createElement(
      __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["InlineWarning"],
      {
        title: 'Before you send this email',
        type: 'info',
        icon: 'info',
        className: 'playbook-review-warning' },
      React.createElement(
        'div',
        null,
        !isDkimSetUp && React.createElement(
          'div',
          { className: 'playbook-review-warning--action-item' },
          React.createElement(
            'span',
            { className: 'playbook-review-warning--action-item-title' },
            'SET UP YOUR DKIM:'
          ),
          ' To make sure your emails are successfully delivered, ',
          React.createElement(
            'a',
            { href: '/settings/dkim' },
            'set up DKIM'
          ),
          ' for your sending domain.'
        ),
        isDkimSetUp && !isDkimVerified && React.createElement(
          'div',
          { className: 'playbook-review-warning--action-item' },
          React.createElement(
            'span',
            { className: 'playbook-review-warning--action-item-title' },
            'VERIFY YOUR DKIM:'
          ),
          ' To make sure your emails are successfully delivered, ',
          React.createElement(
            'a',
            { href: '/settings/dkim' },
            'verify DKIM'
          ),
          ' for your sending domain.'
        )
      ),
      React.createElement(
        'div',
        { className: 'playbook-review-warning--action-item' },
        React.createElement(
          'span',
          { className: 'playbook-review-warning--action-item-title' },
          'TRACK YOUR REPLIES:'
        ),
        ' In order to track replies, make sure the senders of this email ',
        __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].isAdmin() ? React.createElement(
          'a',
          { href: '/settings/email' },
          'connect their Gmail accounts'
        ) : React.createElement(
          'p',
          null,
          'connect their Gmail accounts'
        ),
        '.'
      )
    ),
    !isOutboundSequencePlaybook && [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT].includes(draft.status) && React.createElement(ReportLink, { isMarketingSequencePlaybook: isMarketingSequencePlaybook, playbookId: draft.id }),
    isOutboundSequencePlaybook && React.createElement(__WEBPACK_IMPORTED_MODULE_11__OutboundSequence__["a" /* default */], {
      onShareClick: onShareClick,
      onConnectGmailClick: onConnectGmailClick,
      isGmailConnected: isGmailConnected,
      onInstallExtensionClick: onInstallExtensionClick,
      isExtensionInstalled: userProperties && userProperties.get('extensionInstalled')
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Review);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Uy7L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {var ConversationActions = Marty.createActionCreators({
  searchConversations: function searchConversations(query) {
    return this.app.queries.ConversationQueries.searchConversations(query);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ConversationActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "V/l/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V0l4":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "V6Hr":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE4IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjgzOSAxMy4zMmMtLjY0IDAtMS4xNjItLjUyLTEuMTYyLTEuMTU5IDAtLjQyNy4yMzYtLjc5Ny41ODEtLjk5OXYtNC4zOGwtMi4zMzQgMS4zMzJjLjAwMi4wMi4wMTEuMDM2LjAxMS4wNTVWMTMuOWMwIC4wMjItLjAxLjA0MS0uMDEyLjA2M2EuNjAzLjYwMyAwIDAgMS0uMDI0LjExNS41Ny41NyAwIDAgMS0uMTkyLjI3Yy0uMDE3LjAxNC0uMDI3LjAzMy0uMDQ2LjA0NC0uMDgyLjA1Mi0yLjA0NiAxLjI0Ny00Ljk1MSAxLjI0N3MtNC44Ny0xLjE5NS00Ljk1MS0xLjI0N2MtLjAyLS4wMTEtLjAzLS4wMy0uMDQ3LS4wNDNhLjU0Ni41NDYgMCAwIDEtLjIxNS0uMzg2Yy0uMDAzLS4wMjEtLjAxMy0uMDQtLjAxMy0uMDYzVjguMTdjMC0uMDIuMDEtLjAzNy4wMS0uMDU2TC4yOTQgNi4yODdhLjU3OC41NzggMCAwIDEgMC0xLjAwN0w4LjQyMi42NDJhLjU4Mi41ODIgMCAwIDEgLjU3NiAwbDguMTI5IDQuNjM4YS41NzguNTc4IDAgMCAxIC4yOTIuNTA0YzAgLjAxLS4wMDcuMDE4LS4wMDcuMDI4IDAgLjAxNC4wMDcuMDI1LjAwNy4wMzl2NS4zMTFjLjM0Ni4yMDIuNTgxLjU3Mi41ODEuOTk5IDAgLjYzOS0uNTIgMS4xNi0xLjE2MSAxLjE2em0tNC4wNjUuMjM1VjguNzdsLTMuNzc2IDIuMTU1YS41NzguNTc4IDAgMCAxLS41NzYgMEw0LjY0NSA4Ljc3djQuNzgzYy41ODMuMjkxIDIuMDc4LjkyNyA0LjA2NS45MjcgMS45OTggMCAzLjQ4NC0uNjM0IDQuMDY0LS45MjV6TTguNzEgMS44MTNMMS43NSA1Ljc4M2w2Ljk1OSAzLjk3IDYuOTU4LTMuOTctNi45NTgtMy45N3oiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "VAK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchAssistantOrgSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchAssistantOrgSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchAssistantOrgSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchAssistantOrgSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createAssistantOrgSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createAssistantOrgSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createAssistantOrgSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createAssistantOrgSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return patchAssistantOrgSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return patchAssistantOrgSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return patchAssistantOrgSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return patchAssistantOrgSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchAssistantAgentSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchAssistantAgentSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchAssistantAgentSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchAssistantAgentSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAssistantAgentSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createAssistantAgentSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createAssistantAgentSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createAssistantAgentSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return patchAssistantAgentSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return patchAssistantAgentSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return patchAssistantAgentSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return patchAssistantAgentSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchSalesforceSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchSalesforceSettingsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchSalesforceSettingsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchSalesforceSettingsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchPersonalizationTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchPersonalizationTagsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchPersonalizationTagsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchPersonalizationTagsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return handleEditConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return setInitial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return onUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return onWarmLeadUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return onWarmLeadUpdateTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return onCancel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return sendTestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return sendTestEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return sendTestEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return sendTestEmailFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("E3/D");




// Org level actions
var fetchAssistantOrgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_ASSISTANT_ORG_SETTINGS */]);
var fetchAssistantOrgSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_ASSISTANT_ORG_SETTINGS_PENDING */]);
var fetchAssistantOrgSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_ASSISTANT_ORG_SETTINGS_SUCCESS */]);
var fetchAssistantOrgSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_ASSISTANT_ORG_SETTINGS_FAILED */]);

var createAssistantOrgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CREATE_ASSISTANT_ORG_SETTINGS */]);
var createAssistantOrgSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* CREATE_ASSISTANT_ORG_SETTINGS_PENDING */]);
var createAssistantOrgSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CREATE_ASSISTANT_ORG_SETTINGS_SUCCESS */]);
var createAssistantOrgSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CREATE_ASSISTANT_ORG_SETTINGS_FAILED */]);

var patchAssistantOrgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* PATCH_ASSISTANT_ORG_SETTINGS */]);
var patchAssistantOrgSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* PATCH_ASSISTANT_ORG_SETTINGS_PENDING */]);
var patchAssistantOrgSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* PATCH_ASSISTANT_ORG_SETTINGS_SUCCESS */]);
var patchAssistantOrgSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* PATCH_ASSISTANT_ORG_SETTINGS_FAILED */]);

// Agent level actions
var fetchAssistantAgentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_ASSISTANT_AGENT_SETTINGS */]);
var fetchAssistantAgentSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_ASSISTANT_AGENT_SETTINGS_PENDING */]);
var fetchAssistantAgentSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS */]);
var fetchAssistantAgentSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_ASSISTANT_AGENT_SETTINGS_FAILED */]);

var createAssistantAgentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CREATE_ASSISTANT_AGENT_SETTINGS */]);
var createAssistantAgentSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_ASSISTANT_AGENT_SETTINGS_PENDING */]);
var createAssistantAgentSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_ASSISTANT_AGENT_SETTINGS_SUCCESS */]);
var createAssistantAgentSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CREATE_ASSISTANT_AGENT_SETTINGS_FAILED */]);

var patchAssistantAgentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* PATCH_ASSISTANT_AGENT_SETTINGS */]);
var patchAssistantAgentSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* PATCH_ASSISTANT_AGENT_SETTINGS_PENDING */]);
var patchAssistantAgentSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS */]);
var patchAssistantAgentSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* PATCH_ASSISTANT_AGENT_SETTINGS_FAILED */]);

// Salesforce settings
var fetchSalesforceSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_SALESFORCE_SETTINGS */]);
var fetchSalesforceSettingsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_SALESFORCE_SETTINGS_PENDING */]);
var fetchSalesforceSettingsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_SALESFORCE_SETTINGS_SUCCESS */]);
var fetchSalesforceSettingsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_SALESFORCE_SETTINGS_FAILED */]);

// Personalization tags
var fetchPersonalizationTags = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* FETCH_PERSONALIZATION_TAGS */]);
var fetchPersonalizationTagsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_PERSONALIZATION_TAGS_PENDING */]);
var fetchPersonalizationTagsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_PERSONALIZATION_TAGS_SUCCESS */]);
var fetchPersonalizationTagsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_PERSONALIZATION_TAGS_FAILED */]);

// editing state actions
var handleEditConfig = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* SET_INITIAL_ORG_EDIT_STATE */]);

var setInitial = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* SET_INITIAL */]);
var onUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* ON_UPDATE */]);
var onWarmLeadUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* ON_WARM_LEAD_UPDATE */]);
var onWarmLeadUpdateTemplate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* ON_WARM_LEAD_UPDATE_TEMPLATE */]);
var onCancel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* ON_CANCEL */]);

var sendTestEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SEND_TEST_EMAIL */]);
var sendTestEmailPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SEND_TEST_EMAIL_PENDING */]);
var sendTestEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SEND_TEST_EMAIL_SUCCESS */]);
var sendTestEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SEND_TEST_EMAIL_FAILED */]);

/***/ }),

/***/ "VCB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_paging__ = __webpack_require__("Prq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__("s+vs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("7MmB");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function parseCampaign(data) {
  if (data.type === __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CampaignTypes */].BOT) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["a" /* parseBotCampaign */])(data);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(data);
}

var api = {
  fetch: function fetch(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/campaigns/' + id).checkStatus().retryWithBackoff().map(function (_ref) {
      var response = _ref.response;
      return parseCampaign(response);
    });
  },
  update: function update(id, operations) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/campaigns/' + id + '/patch', operations).checkStatus().retryWithBackoff().map(function (_ref2) {
      var response = _ref2.response;
      return parseCampaign(response);
    });
  },
  search: function search(query, _ref3) {
    var _ref3$offset = _ref3.offset,
        offset = _ref3$offset === undefined ? 0 : _ref3$offset,
        _ref3$limit = _ref3.limit,
        limit = _ref3$limit === undefined ? 30 : _ref3$limit;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/campaigns', _defineProperty({ q: query, size: limit }, 'from', offset)).checkStatus().retryWithBackoff().map(Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["e" /* parsePagedData */])());
  }
};

/***/ }),

/***/ "VGs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_ModalHelpers__ = __webpack_require__("2MvB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_GlobalModalConstants__ = __webpack_require__("xJoo");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var GlobalModalActions = function (_Marty$ActionCreators) {
  _inherits(GlobalModalActions, _Marty$ActionCreators);

  function GlobalModalActions() {
    _classCallCheck(this, GlobalModalActions);

    return _possibleConstructorReturn(this, (GlobalModalActions.__proto__ || Object.getPrototypeOf(GlobalModalActions)).apply(this, arguments));
  }

  _createClass(GlobalModalActions, [{
    key: 'openModal',
    value: function openModal(title, description, onConfirm, onCancel, buttonProps) {
      var confirm = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "Yes, Continue";

      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_GlobalModalConstants__["a" /* default */].MODAL_OPENED, Object(__WEBPACK_IMPORTED_MODULE_0_utils_ModalHelpers__["a" /* ModalData */])({ title: title, description: description, onConfirm: onConfirm, onCancel: onCancel, buttonProps: buttonProps, confirm: confirm }));
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_GlobalModalConstants__["a" /* default */].MODAL_CLOSED);
    }
  }]);

  return GlobalModalActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (GlobalModalActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "VH+I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component__ = __webpack_require__("BmH0");



















var mapStateToProps = function mapStateToProps(state) {
  return {
    goal: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["j" /* currentGoal */](state),
    classificationOptions: __WEBPACK_IMPORTED_MODULE_13_app_modules_classification_selectors__["a" /* classificationOptions */](state),
    selectedGoalRoutingOption: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_71" /* selectedGoalRoutingOption */](state),
    isSingleRoutingSelected: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_49" /* isSingleRoutingSelected */](state),
    isGlobalRoutingSelected: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_38" /* isGlobalRoutingSelected */](state),
    isGroupRoutingSelected: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_39" /* isGroupRoutingSelected */](state),
    isNoRoutingSelected: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_43" /* isNoRoutingSelected */](state),
    goalRoutingView: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_22" /* goalRoutingView */](state),
    orgUsersById: __WEBPACK_IMPORTED_MODULE_12_app_modules_user_selectors__["orgUsersById"](state),
    calendarConnectedAgentIds: __WEBPACK_IMPORTED_MODULE_11_app_modules_meetings_selectors__["a" /* getAgentIdsWithConnectedCalendars */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideGoalRoutingModal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_84" /* hideGoalRoutingModal */],
      selectGoalRoutingOptionUI: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_124" /* selectGoalRoutingOptionUI */],
      saveGoalRoutingOption: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_107" /* saveGoalRoutingOption */],
      setGoalRoutingView: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_175" /* setGoalRoutingView */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_6_recompose_lifecycle___default()({
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        goal = _props.goal,
        selectGoalRoutingOptionUI = _props.actions.selectGoalRoutingOptionUI;

    selectGoalRoutingOptionUI(goal.get('routing') || __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["n" /* RoutingOption */]());
  }
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (props) {
  return {
    viewSingleRoutingOptions: props.goalRoutingView === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE,
    viewGroupRoutingOptions: props.goalRoutingView === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].GROUP,
    viewGlobalRoutingOptions: false && props.goalRoutingView === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL, // false until we  build out the UI...
    classificationDetails: props.classificationOptions.find(function (classification) {
      return classification.value === props.goal.classification.get('classificationId');
    }),
    orgUsersOptions: props.orgUsersById.toArray().map(function (user) {
      var isCalendarConnected = props.calendarConnectedAgentIds.includes(user.id);
      return {
        value: user.id,
        user: user,
        label: React.createElement(
          'div',
          { className: 'flex routing-option' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
          user.name || user.email,
          ' ',
          isCalendarConnected ? ' 📅' : ''
        )
      };
    }),
    selectedRoutingUsers: props.selectedGoalRoutingOption.userIds ? props.selectedGoalRoutingOption.userIds instanceof Array ? props.selectedGoalRoutingOption.userIds : props.selectedGoalRoutingOption.userIds.toJS() : null,
    firstUser: props.orgUsersById.first()
  };
}), __WEBPACK_IMPORTED_MODULE_5_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      var id = props.goal.id,
          _props$actions = props.actions,
          hideGoalRoutingModal = _props$actions.hideGoalRoutingModal,
          saveGoalRoutingOption = _props$actions.saveGoalRoutingOption,
          selectedGoalRoutingOption = props.selectedGoalRoutingOption;

      saveGoalRoutingOption({ goalId: id, goalRoutingOption: selectedGoalRoutingOption });
      hideGoalRoutingModal();
    };
  },
  onCancelClick: function onCancelClick(props) {
    return function () {
      var _props$actions2 = props.actions,
          hideGoalRoutingModal = _props$actions2.hideGoalRoutingModal,
          setGoalRoutingView = _props$actions2.setGoalRoutingView;

      hideGoalRoutingModal();
      setGoalRoutingView(null);
    };
  },
  resetRoutingView: function resetRoutingView(props) {
    return function () {
      var setGoalRoutingView = props.actions.setGoalRoutingView;

      setGoalRoutingView(null);
    };
  },
  handleSelectGroup: function handleSelectGroup(props) {
    return function () {
      var orgUsersById = props.orgUsersById,
          goal = props.goal,
          _props$actions3 = props.actions,
          selectGoalRoutingOptionUI = _props$actions3.selectGoalRoutingOptionUI,
          setGoalRoutingView = _props$actions3.setGoalRoutingView;

      selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["h" /* GroupRoutingOption */]({
        userIds: goal.getIn(['routing', 'userIds']) || null
      }));
      setGoalRoutingView(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].GROUP);
    };
  },
  handleSelectSingle: function handleSelectSingle(props) {
    return function () {
      var orgUsersById = props.orgUsersById,
          goal = props.goal,
          _props$actions4 = props.actions,
          selectGoalRoutingOptionUI = _props$actions4.selectGoalRoutingOptionUI,
          setGoalRoutingView = _props$actions4.setGoalRoutingView;

      var userId = goal.getIn(['routing', 'userId']) || orgUsersById.first().id;
      selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["q" /* SingleRoutingOption */]({
        userId: userId
      }));
      setGoalRoutingView(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE);
    };
  },
  handleSelectGlobal: function handleSelectGlobal(props) {
    return function () {
      var _props$actions5 = props.actions,
          selectGoalRoutingOptionUI = _props$actions5.selectGoalRoutingOptionUI,
          setGoalRoutingView = _props$actions5.setGoalRoutingView;

      selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["n" /* RoutingOption */]({
        type: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL
      }));
      setGoalRoutingView(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL);
    };
  },
  handleSelectNoRouting: function handleSelectNoRouting(props) {
    return function () {
      var _props$actions6 = props.actions,
          selectGoalRoutingOptionUI = _props$actions6.selectGoalRoutingOptionUI,
          setGoalRoutingView = _props$actions6.setGoalRoutingView;

      selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["n" /* RoutingOption */]({
        type: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_150" /* RoutingType */].NONE
      }));
      setGoalRoutingView(null);
    };
  },
  onSingleRouteUserSelect: function onSingleRouteUserSelect(props) {
    return function (ref) {
      props.actions.selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["q" /* SingleRoutingOption */]({
        userId: ref.value
      }));
    };
  },
  onGroupRouteUserSelect: function onGroupRouteUserSelect(props) {
    return function (ref) {
      props.actions.selectGoalRoutingOptionUI(__WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_models__["h" /* GroupRoutingOption */]({
        userIds: ref.map(function (elt) {
          return elt.value;
        })
      }));
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_14__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "VIJZ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#9A9A9A\" fill-rule=\"evenodd\"><path d=\"M0 5.994A5.994 5.994 0 0 1 5.994 0h12.012A5.994 5.994 0 0 1 24 5.994v12.012A5.994 5.994 0 0 1 18.006 24H5.994A5.994 5.994 0 0 1 0 18.006V5.994zm2.75-.25A2.996 2.996 0 0 1 5.743 2.75h12.514a2.996 2.996 0 0 1 2.993 2.993v12.514a2.996 2.996 0 0 1-2.993 2.993H5.743a2.996 2.996 0 0 1-2.993-2.993V5.743z\"></path><path d=\"M10.63 14.203l5.97-5.97a.8.8 0 0 1 1.13 1.132l-6.4 6.4a.81.81 0 0 1-.06.053.8.8 0 0 1-1.203.083L6.735 12.57a.8.8 0 1 1 1.13-1.13l2.766 2.765z\" stroke=\"#9A9A9A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></svg>"

/***/ }),

/***/ "VJrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VN3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hydrateModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__ = __webpack_require__("QM6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_pardot_api__ = __webpack_require__("q/43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PardotProspectFieldSelect__ = __webpack_require__("6iaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PardotProspectCampaignInput__ = __webpack_require__("ld5k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var model = [{
  type: 'syncProspectsEnabled',
  value: false,
  label: 'Sync prospects from Drift to Pardot',
  description: 'Prospects from Drift will be created or updated in Pardot whenever a conversation closes'
}, {
  type: 'shouldOnlySyncQualified',
  value: false,
  label: 'Set a minimum CQL score for synced contacts and conversations',
  description: 'Unchecked, Drift will sync all contacts and conversations to Pardot except those that have been disqualified.',
  children: {
    autoExpand: true,
    label: 'Minimum CQL score',
    description: 'Drift will only sync conversations that have the selected CQL score or higher.',

    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      integrationName: 'pardot',
      setMinimumCQLScore: function setMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["K" /* patchPardotConfig */])({ "minimumCQLScore": data.score });
      },
      getMinimumCQLScore: function getMinimumCQLScore() {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["B" /* getPardotConfig */])();
      }
    })(__WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__["a" /* default */]),
    items: []
  }
}, {
  type: 'shouldSetLeadOwner',
  value: false,
  label: 'Assign a Lead Owner in Pardot',
  description: "For every new prospect that Drift creates, we'll assign a Lead Owner email based on who books a meeting, who was routed into the conversation, or who closes the conversation (in that order!).",
  openAdvancedSettingsOnEnable: true,
  children: {
    label: 'Lead Owner field',
    description: "Which Pardot field should Drift use? Note that this will overwrite the chosen field’s existing value in Pardot.",
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      getSelectedField: __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["C" /* getPardotLeadOwnerField */],
      setSelectedField: __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["X" /* setPardotLeadOwnerField */],
      fetchFields: __WEBPACK_IMPORTED_MODULE_3_app_modules_pardot_api__["a" /* api */].fetchPardotFields,
      isEnabled: true
    })(__WEBPACK_IMPORTED_MODULE_4__PardotProspectFieldSelect__["a" /* default */]),
    items: []
  }
}, {
  type: 'syncConversationTranscriptsEnabled',
  value: false,
  label: 'Sync conversation transcripts from Drift to Pardot',
  description: "A conversation transcript will be pushed to the selected field whenever a conversation closes. We recommend using a custom field of type textarea in Pardot.",
  openAdvancedSettingsOnEnable: true,
  children: {
    label: 'Conversation Transcript Field',
    description: "Which Pardot field should Drift use? Note that this will overwrite the chosen field's existing value in Pardot.",
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      getSelectedField: __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["D" /* getPardotTranscriptField */],
      setSelectedField: __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["Y" /* setPardotTranscriptField */],
      fetchFields: __WEBPACK_IMPORTED_MODULE_3_app_modules_pardot_api__["a" /* api */].fetchPardotFields,
      isEnabled: true
    })(__WEBPACK_IMPORTED_MODULE_4__PardotProspectFieldSelect__["a" /* default */]),
    items: []
  }
}, {
  type: 'shouldSetProspectCampaign',
  value: false,
  label: 'Assign prospects created by Drift to a Pardot campaign',
  description: "For every new prospect that Drift creates, we'll assign that prospect to a desired Pardot campaign",
  openAdvancedSettingsOnEnable: true,
  children: {
    label: 'Default prospect campaign field',
    description: "Which Pardot campaign should Drift use? Note that this will only be set for new prospects into Pardot. You can also search for the exact Campaign name below.",
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      setProspectCampaignField: function setProspectCampaignField(prospectCampaign) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["K" /* patchPardotConfig */])({ prospectCampaign: prospectCampaign });
      },
      getPardotConfig: __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["B" /* getPardotConfig */],
      fetchCampaigns: __WEBPACK_IMPORTED_MODULE_3_app_modules_pardot_api__["a" /* api */].fetchPardotProspectCampaigns,
      searchCampaigns: __WEBPACK_IMPORTED_MODULE_3_app_modules_pardot_api__["a" /* api */].searchPardotProspectCampaigns,
      isEnabled: true
    })(__WEBPACK_IMPORTED_MODULE_5__PardotProspectCampaignInput__["a" /* default */]),
    items: []
  }
}, {
  type: 'cookieIdentificationEnabled',
  value: false,
  label: 'Identify Drift visitors with the Pardot cookie',
  description: 'If someone was already identified by Pardot, Drift will automatically recognize them as a known contact. We\'ll only check Pardot if the visitor has a Pardot cookie set.'
}];

var hydrateModel = function hydrateModel(toggles) {
  return [].concat(model).map(function (topLevel) {
    var updatedToggle = _extends({}, topLevel);
    updatedToggle.value = toggles[topLevel.type];
    return updatedToggle;
  });
};

/***/ }),

/***/ "VNK0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VOfZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(75);

/***/ }),

/***/ "VOtq":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 29 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28 13h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 0 1 0-2h3V8a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2zm-15.177.4C16.92 14.57 20 18.186 20 22.334V23a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.666c0-4.148 3.08-7.764 7.177-8.934C4.72 12.312 3 9.855 3 7c0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.01 22h15.98c-.196-3.827-3.776-7-7.99-7s-7.793 3.173-7.99 7zM10 2C7.243 2 5 4.243 5 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "VQ/G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ParticipantAction__ = __webpack_require__("Xy+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ParticipantActions__ = __webpack_require__("y4Mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SalesforceAction__ = __webpack_require__("18cF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TargetedAccountsAction__ = __webpack_require__("pdN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LeandataAction__ = __webpack_require__("jces");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ActionEditor = function (_Component) {
  _inherits(ActionEditor, _Component);

  function ActionEditor() {
    _classCallCheck(this, ActionEditor);

    return _possibleConstructorReturn(this, (ActionEditor.__proto__ || Object.getPrototypeOf(ActionEditor)).apply(this, arguments));
  }

  _createClass(ActionEditor, [{
    key: 'render',
    value: function render() {
      var _get = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(this.props.rule, 'data.item'),
          action = _get.action;

      if (!action) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-action-editor' },
        action.type === 'LEANDATA_PARTICIPANT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LeandataAction__["a" /* default */], this.props),
        __WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('has_beta_lead_routing') && action.type === 'PARTICIPANT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ParticipantActions__["a" /* default */], this.props),
        !__WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('has_beta_lead_routing') && action.type === 'PARTICIPANT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ParticipantAction__["a" /* default */], this.props),
        action.type === 'SALESFORCE_PARTICIPANT' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SalesforceAction__["a" /* default */], this.props),
        action.type === 'ABM_PARTICIPANT' && this.props.hasABM && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TargetedAccountsAction__["a" /* default */], this.props)
      );
    }
  }]);

  return ActionEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ActionEditor);

/***/ }),

/***/ "VQvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("U76K");












var mapStateToProps = function mapStateToProps(state) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["v" /* theme */](state),
    defaultEmbed: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["h" /* getEmbedConfig */](state),
    embedFetchPending: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["c" /* embedFetchPending */](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    targetedMessage: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_101" /* targetedMessage */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_181" /* setMessage */],
      setHeadline: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_177" /* setHeadline */],
      setCtaLink: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_145" /* setCtaLink */],
      setCtaCopy: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_144" /* setCtaCopy */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_138" /* setAuthorId */],
      savePlaybookFailed: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_114" /* savePlaybookFailed */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.theme || props.embedFetchPending || !props.orgUsers.size;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* TargetMessageLoading */])), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    userObjForAuthor: props.orgUsers.toJS().find(function (user) {
      return user.id === props.targetedMessage.authorId;
    })
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    message: props.targetedMessage.message,
    headline: props.targetedMessage.title,
    hideCta: !props.targetedMessage.cta || _.get(props.targetedMessage, 'cta.type', __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT) === __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__["V" /* CtaTypes */].NONE,
    ctaCopy: _.get(props.targetedMessage, 'cta.copy'),
    ctaLink: _.get(props.targetedMessage, 'cta.url'),
    selectedUser: props.userObjForAuthor || props.orgUsers.first().toJS()
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('headlineInvalid', 'setHeadlineInvalid', function (props) {
  return !props.headline || !props.headline.trim();
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onMessageChange: function onMessageChange(props) {
    return function (message) {
      props.actions.setMessage(message);
    };
  },
  onHeadlineChange: function onHeadlineChange(props) {
    return function (event) {
      var isInvalid = !event.target.value || !event.target.value.trim();
      if (isInvalid) {
        props.actions.savePlaybookFailed();
        props.setHeadlineInvalid(true);
      } else {
        props.setHeadlineInvalid(false);
      }
      props.actions.setHeadline({ value: event.target.value, dontSave: isInvalid });
    };
  },
  onAuthorChange: function onAuthorChange(props) {
    return function (_ref) {
      var value = _ref.value;

      props.actions.setAuthorId(value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["b" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "VRvY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AcceptIntegrate":"AcceptIntegrate---1n_fk"};

/***/ }),

/***/ "VRwS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 19 19\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"color\" transform=\"translate(-366.000000, -403.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(255.000000, 358.000000)\"><g id=\"calendar-check\" transform=\"translate(111.000000, 45.000000)\"><path d=\"M17.4166667,19 L1.58333333,19 C0.710125,19 0,18.289875 0,17.4166667 L0,3.16666667 C0,2.29345833 0.710125,1.58333333 1.58333333,1.58333333 L4.75,1.58333333 L4.75,0.791666667 C4.75,0.354666667 5.103875,0 5.54166667,0 C5.97945833,0 6.33333333,0.354666667 6.33333333,0.791666667 L6.33333333,1.58333333 L12.6666667,1.58333333 L12.6666667,0.791666667 C12.6666667,0.354666667 13.0205417,0 13.4583333,0 C13.896125,0 14.25,0.354666667 14.25,0.791666667 L14.25,1.58333333 L17.4166667,1.58333333 C18.2890833,1.58333333 19,2.29345833 19,3.16666667 L19,17.4166667 C19,18.289875 18.2890833,19 17.4166667,19 Z M14.25,3.16666667 L14.25,3.95833333 C14.25,4.39533333 13.896125,4.75 13.4583333,4.75 C13.0205417,4.75 12.6666667,4.39533333 12.6666667,3.95833333 L12.6666667,3.16666667 L6.33333333,3.16666667 L6.33333333,3.95833333 C6.33333333,4.39533333 5.97945833,4.75 5.54166667,4.75 C5.103875,4.75 4.75,4.39533333 4.75,3.95833333 L4.75,3.16666667 L1.58333333,3.16666667 L1.58333333,17.4166667 L17.4142917,17.4166667 L17.4166667,3.16666667 L14.25,3.16666667 Z M9.18570833,13.9745 C9.04004167,14.1447083 8.827875,14.2444583 8.60383333,14.2492083 C8.5975,14.25 8.59195833,14.25 8.585625,14.25 C8.367125,14.25 8.15970833,14.1605417 8.00929167,14.0014167 L5.75779167,11.61375 C5.45775,11.2962917 5.472,10.7951667 5.78945833,10.495125 C6.1085,10.1950833 6.60883333,10.2093333 6.90966667,10.5275833 L8.55791667,12.2755833 L12.0657917,8.19216667 C12.352375,7.86045833 12.8519167,7.82404167 13.1820417,8.10825 C13.51375,8.39245833 13.55175,8.89279167 13.2675417,9.2245 L9.18570833,13.9745 Z\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "VSu+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__ = __webpack_require__("Or1g");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


var EmbedActions = Marty.createActionCreators({
  createEmbedForInboxId: function createEmbedForInboxId(inboxId) {
    return this.app.queries.EmbedQueries.createEmbedForInboxId(inboxId);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EmbedActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "VUJx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendDriftAppMetric; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var sendDriftAppMetric = function sendDriftAppMetric(metric) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxDriftMetricsAPI"].post('/monitoring/metrics/add', metric).checkStatus().retryWithBackoff();
};

/***/ }),

/***/ "VV2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_extend__);


var BLOCK_TYPE = 'unstyled';

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_draft_extend__["createPlugin"])({
  blockToHTML: function blockToHTML(block) {
    if (block.type === BLOCK_TYPE) {
      return React.createElement('div', null);
    }
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "VZhT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return propertiesLoaded; });
/* unused harmony export fetchPropertiesFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return properties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extensionProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return usersByPropertyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isUserAtConversationLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeUsersWithProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCurrentUserEligibleForContactSidebarRedesignAnnouncement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasCompactViewEnabled; });
/* unused harmony export isConversationStatusDisabled */
/* unused harmony export hasUnreadsOnly */
/* unused harmony export isUnreadsOnlyEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return videoSignUpDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isDesktopUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("7QUA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_constants__ = __webpack_require__("aJZK");






var root = function root(state) {
  return state.get('userProperties');
};

var propertiesLoaded = function propertiesLoaded(state) {
  return root(state).getIn(['status', 'fetch']) === __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* RECEIVE_USER_PROPERTIES */];
};
var fetchPropertiesFailed = function fetchPropertiesFailed(state) {
  return root(state).getIn(['status', 'fetch']) === __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* FETCH_USER_PROPERTIES_FAILED */];
};
var properties = function properties(state) {
  return root(state).get('data', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
};
var extensionProperties = function extensionProperties(state) {
  return properties(state).get('extensionSettings');
};
var usersByPropertyName = function usersByPropertyName(state) {
  return root(state).get('usersByPropertyName');
};
var isUserAtConversationLimit = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (props) {
  return props.get('atConversationLimit');
});

var alwaysTrue = function alwaysTrue() {
  return true;
};
var makeUsersWithProperty = function makeUsersWithProperty(property) {
  var matcher = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : alwaysTrue;

  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([usersByPropertyName, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["orgUsersById"]], function (usersByPropertyName, orgUsersById) {
    return usersByPropertyName.get(property, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).filter(function (entry) {
      return matcher(entry.get('value'), entry.get('updatedAt'));
    }).map(function (entry, userId) {
      return orgUsersById.get(userId);
    }).filter(function (user) {
      return !!user;
    }).filter(function (user) {
      return user.status === __WEBPACK_IMPORTED_MODULE_4_app_modules_user_constants__["_9" /* UserStatus */].ENABLED;
    });
  });
};

var CONTACT_SIDEBAR_REDESIGN_FULCRUM_DATE = new Date('2018-7-18');

var isCurrentUserEligibleForContactSidebarRedesignAnnouncement = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"], properties], function (user, userProperties) {
  return user && user.createdAt <= +CONTACT_SIDEBAR_REDESIGN_FULCRUM_DATE && userProperties && !userProperties.get('did_acknowledge_contact_sidebar_redesign');
});

var hasCompactViewEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('hasCompactConversationListItemExperiment') && properties.get('isCompactViewEnabled');
});

var isConversationStatusDisabled = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('isConversationStatusDisabled');
});

var hasUnreadsOnly = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('hasUnreadsOnly');
});

var isUnreadsOnlyEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('isUnreadsOnlyEnabled');
});

var videoSignUpDone = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('videoSignUpDone');
});

var isDesktopUser = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(properties, function (properties) {
  return properties && properties.get('has_desktop_app') && properties.get('has_desktop_app') !== "false";
});

/***/ }),

/***/ "Vc6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ManageTagDropdown__ = __webpack_require__("4Nf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_tags_TagColorSelectorDropdown__ = __webpack_require__("fRuY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_settings_tags_TagEditingInput__ = __webpack_require__("Qa1t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_components_settings_tags_ManageTagsList_styl__ = __webpack_require__("Q4xG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_components_settings_tags_ManageTagsList_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_styles_components_settings_tags_ManageTagsList_styl__);












var ManageTagsList = React.createClass({
  displayName: 'ManageTagsList',

  propTypes: {
    tagList: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      showTagEditingInput: false,
      showColorDropdown: false,
      editingTag: undefined,
      showDropdownTagId: undefined
    };
  },
  renderTags: function renderTags() {
    var _this = this;

    return React.createElement(
      'div',
      { className: 'ManageTagsList tags' },
      _.map(this.props.tagList, function (tag) {
        if (tag.id === (_this.state.editingTag != null ? _this.state.editingTag.id : undefined)) {
          return;
        }
        return React.createElement(
          'div',
          {
            key: tag.id,
            className: 'tag',
            style: {
              backgroundColor: '#' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_TagAppearanceHelper__["a" /* getNormalizedTagColor */])(tag.color),
              color: 'var(--main-navy-extra-dark)'
            } },
          React.createElement(
            'div',
            { className: 'tag-label' },
            tag.name
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
            className: 'configure-tag',
            onClick: _this.tagSettingsClicked.bind(_this, tag),
            src: __webpack_require__("N4Vs") }),
          tag.id === _this.state.showDropdownTagId ? React.createElement(__WEBPACK_IMPORTED_MODULE_4__ManageTagDropdown__["a" /* default */], {
            handleClickOutside: _this.outsideManageTagDropdownClicked,
            editTagClicked: function editTagClicked() {
              return _this.editTagClicked(tag);
            },
            deleteTagClicked: function deleteTagClicked() {
              return _this.deleteTagClicked(tag);
            } }) : undefined
        );
      }),
      !this.state.showTagEditingInput ? this.renderAddTagButton() : undefined
    );
  },
  renderAddTagButton: function renderAddTagButton() {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_3_react_tether___default.a,
      {
        attachment: 'bottom right',
        targetOffset: '39 -275px',
        constraints: [{ to: 'scrollParent', attachment: 'together' }]
      },
      React.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('add-tag-button', { selected: this.state.showColorDropdown }),
          onClick: this.addTagClicked },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
          className: 'add-tag-plus',
          src: __webpack_require__("T5NG") }),
        React.createElement(
          'span',
          { className: 'tag-button-title' },
          'Add Tag'
        )
      ),
      this.state.showColorDropdown && React.createElement(__WEBPACK_IMPORTED_MODULE_5_components_settings_tags_TagColorSelectorDropdown__["a" /* default */], {
        colorClicked: this.colorClicked,
        onClickOutside: this.outsideColorSelectDropdownClicked
      })
    );
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ManageTagsList ', this.props.className) },
      this.renderTags(),
      React.createElement(
        'div',
        { className: 'add-tag' },
        this.state.showTagEditingInput ? React.createElement(__WEBPACK_IMPORTED_MODULE_6_components_settings_tags_TagEditingInput__["a" /* default */], {
          selectedColor: this.state.selectedColor,
          editingTag: this.state.editingTag,
          tagType: this.props.tagType,
          onClose: this.cancelCreateTag }) : undefined
      )
    );
  },
  addTagClicked: function addTagClicked() {
    return this.setState({ showColorDropdown: !this.state.showColorDropdown });
  },
  colorClicked: function colorClicked(tagColor) {
    return this.setState({
      showColorDropdown: false,
      showTagEditingInput: true,
      selectedColor: tagColor
    });
  },
  cancelCreateTag: function cancelCreateTag() {
    return this.setState(this.getInitialState());
  },
  showColorDropdownClicked: function showColorDropdownClicked() {
    return this.setState({ showColorDropdown: true });
  },
  tagSettingsClicked: function tagSettingsClicked(tag) {
    return this.setState({ showDropdownTagId: tag.id });
  },
  editTagClicked: function editTagClicked(tag) {
    return this.setState({
      showTagEditingInput: true,
      editingTag: tag,
      selectedColor: tag.color,
      showDropdownTagId: false
    });
  },
  deleteTagClicked: function deleteTagClicked(tag) {
    this.props.app.actions.TagActions.deleteTag(tag.id);
    return this.setState({
      showTagEditingInput: false,
      editingTag: undefined,
      showDropdownTagId: false
    });
  },
  outsideManageTagDropdownClicked: function outsideManageTagDropdownClicked() {
    return this.setState({ showDropdownTagId: undefined });
  },
  outsideColorSelectDropdownClicked: function outsideColorSelectDropdownClicked(event) {
    return this.setState({ showColorDropdown: false });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ManageTagsList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "Vdf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GDPRMessage__ = __webpack_require__("1brp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DisconnectButton__ = __webpack_require__("8UUf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DisconnectConfirmModal__ = __webpack_require__("T45g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_js__ = __webpack_require__("ew+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("1lot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var DISCONNECT_MESSAGE = function DISCONNECT_MESSAGE(serviceName) {
  return serviceName + ' has been successfully disconnected!';
};

var CommonIntegrationPage = function (_Component) {
  _inherits(CommonIntegrationPage, _Component);

  function CommonIntegrationPage(props) {
    var _this2 = this;

    _classCallCheck(this, CommonIntegrationPage);

    var _this = _possibleConstructorReturn(this, (CommonIntegrationPage.__proto__ || Object.getPrototypeOf(CommonIntegrationPage)).call(this, props));

    _this.componentDidMount = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this$props, name, incompleteInstallEndpoint, userInfo, whoIsConnected, isIntegrationStarted, res;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, name = _this$props.name, incompleteInstallEndpoint = _this$props.incompleteInstallEndpoint;
              _context.next = 3;
              return _this.getConnectedUser(name);

            case 3:
              userInfo = _context.sent;
              whoIsConnected = undefined;

              if (!userInfo) {
                _context.next = 13;
                break;
              }

              _context.t0 = name;
              _context.next = _context.t0 === 'Salesforce' ? 9 : _context.t0 === 'Marketo' ? 11 : 13;
              break;

            case 9:
              whoIsConnected = userInfo.email;
              return _context.abrupt('break', 13);

            case 11:
              whoIsConnected = 'Munchkin: ' + userInfo.munchkinId + ', ClientId: ' + userInfo.clientId;
              return _context.abrupt('break', 13);

            case 13:
              isIntegrationStarted = false;

              if (!incompleteInstallEndpoint) {
                _context.next = 19;
                break;
              }

              _context.next = 17;
              return _this.getIncompleteState(incompleteInstallEndpoint);

            case 17:
              res = _context.sent;

              isIntegrationStarted = res.installed;

            case 19:

              _this.setState({
                whoIsConnected: whoIsConnected,
                isIntegrationStarted: isIntegrationStarted
              });

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.getIncompleteState = function (endpoint) {
      return __WEBPACK_IMPORTED_MODULE_13__api_js__["a" /* api */].integrationAPICall(endpoint);
    };

    _this.getConnectedUser = function (serviceName) {
      return __WEBPACK_IMPORTED_MODULE_13__api_js__["a" /* api */].whoIsConnected(serviceName);
    };

    _this.showDisconnectModal = function () {
      _this.setState({ showDisconnectModal: true });
    };

    _this.hideDisconnectModal = function () {
      _this.setState({ showDisconnectModal: false });
    };

    _this.disconnect = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _this$props2, name, integrationId, actions, stopDisconnecting;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, name = _this$props2.name, integrationId = _this$props2.integrationId, actions = _this$props2.actions;

              stopDisconnecting = function stopDisconnecting() {
                _this.setState({ isDisconnecting: false });
                _this.props.notifications.success(DISCONNECT_MESSAGE(name));
              };

              _this.setState({ isDisconnecting: true });
              _this.hideDisconnectModal();
              _context2.next = 6;
              return actions.updateIntegrationState({ integration: integrationId, connected: false });

            case 6:
              stopDisconnecting();

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.connectionIndicator = function (whoIsConnected) {
      var _this$props3 = _this.props,
          incompleteInstallEndpoint = _this$props3.incompleteInstallEndpoint,
          isConnected = _this$props3.isConnected;
      var isIntegrationStarted = _this.state.isIntegrationStarted;


      if (incompleteInstallEndpoint && (!isConnected && isIntegrationStarted || !isIntegrationStarted && isConnected)) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'common-integration-page-connection-indicator common-integration-page-connection-indicator--warning' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { name: 'warning-triangle' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            'Incomplete'
          )
        );
      }

      return whoIsConnected ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-connection-indicator-holder' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["ToolTip"],
          { className: 'common-integratin-page-connection-indicator-text', component: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              null,
              'Connected to:',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
              whoIsConnected
            ), flow: 'down' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { name: 'check-circle' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'common-integration-page-span' },
            'Connected!'
          )
        )
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-connection-indicator' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { name: 'check-circle' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          null,
          'Connected!'
        )
      );
    };

    _this.componentDidUpdate = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(prevProps) {
        var incompleteInstallEndpoint, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(prevProps.isConnected != _this.props.isConnected)) {
                  _context3.next = 7;
                  break;
                }

                incompleteInstallEndpoint = _this.props.incompleteInstallEndpoint;

                if (!incompleteInstallEndpoint) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return _this.getIncompleteState(incompleteInstallEndpoint);

              case 5:
                res = _context3.sent;

                _this.setState({
                  isIntegrationStarted: res.installed
                });

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.state = {
      whoIsConnected: null,
      showDisconnectModal: false,
      isDisconnecting: false,
      isIntegrationStarted: false

    };
    return _this;
  }

  _createClass(CommonIntegrationPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Service = _props.Service,
          logo = _props.logo,
          isConnected = _props.isConnected,
          serviceClassName = _props.serviceClassName,
          name = _props.name,
          hideDisconnectButton = _props.hideDisconnectButton,
          EduTooltip = _props.EduTooltip;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('common-integration-page', serviceClassName) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'common-integration-page-notes' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__["a" /* default */],
            { condition: EduTooltip },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EduTooltip, this.props)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__["a" /* default */],
            { condition: isConnected },
            this.connectionIndicator(this.state.whoIsConnected)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'common-integration-page-layout' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_components_shared_ConditionalRender__["a" /* default */],
            { condition: logo },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'integration-header' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: logo, className: 'common-integration-page-logo' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'common-integration-page-service' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Service, this.props),
            isConnected && !hideDisconnectButton && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_DisconnectButton__["a" /* default */], {
              onClick: this.showDisconnectModal,
              isProcessing: this.state.isDisconnecting
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'common-integration-gdpr-message-wrapper' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GDPRMessage__["a" /* default */], null)
            ),
            this.state.showDisconnectModal && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_DisconnectConfirmModal__["a" /* default */], {
              integrationName: name,
              onDisconnect: this.disconnect,
              onClose: this.hideDisconnectModal,
              open: this.state.showDisconnectModal })
          )
        )
      );
    }
  }]);

  return CommonIntegrationPage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    integrationStates: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__["l" /* fetchIntegrationStates */],
      updateIntegrationState: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__["T" /* updateIntegrationState */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(CommonIntegrationPage)));

/***/ }),

/***/ "Veu9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(18);

/***/ }),

/***/ "VfYs":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/marketo-empty-activity.48b3ec17.svg";

/***/ }),

/***/ "VhE9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTU1NC4wNDcgOTMuNDY3bDQuMDkyIDQuMTJjLjYxNi42MjIuNjEyIDEuNjMgMCAyLjI1bC05LjMgOS4zNjVjLS42MTguNjItMS43ODcgMS4zNTMtMi42MTUgMS42MjIgMCAwLTUuMTAyIDEuODQ3LTUuOTY4Ljk3NS0uODY1LS44NzIuNzMtNi4zMDcuNzMtNi4zMDcuMjI3LS44NDguOTE0LTIuMDQzIDEuNTI3LTIuNjZsOS4zLTkuMzY2Yy42MTctLjYyIDEuNjEzLS42MjQgMi4yMzMgMHoiIGlkPSJhIi8+PG1hc2sgaWQ9ImIiIHg9IjAiIHk9IjAiIHdpZHRoPSIxOC42IiBoZWlnaHQ9IjE5LjAzMyIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48L2RlZnM+PHVzZSBtYXNrPSJ1cmwoI2IpIiB4bGluazpocmVmPSIjYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU0MCAtOTMpIiBzdHJva2U9IiM3MTk4QUMiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "VjwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("u/Km");

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]);

/***/ }),

/***/ "Vjxe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__("Jy8O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("b3Ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("x/uU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__attachment__ = __webpack_require__("kMz3");
var _handleActions, _handleActions2, _handleActions3;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var paginatedStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchPaginatedConversationMessagesPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchPaginatedConversationMessagesFailed */], __WEBPACK_IMPORTED_MODULE_4__actions__["y" /* receivePaginatedMessageList */]), function (state, action) {
  var conversationId = action.payload.conversationId;

  return state.setIn([conversationId, 'firstFetch'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchNextPaginatedConversationMessagesPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchNextPaginatedConversationMessagesFailed */], __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* receiveNextMessageList */]), function (state, action) {
  var conversationId = action.payload.conversationId;

  return state.setIn([conversationId, 'paginateFetch'], action.type);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var readReceipts = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["y" /* receivePaginatedMessageList */], __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* receiveNextMessageList */]), function (state, action) {
  var messages = action.payload.messages;

  return state.withMutations(function (_state) {
    messages.forEach(function (message) {
      _state.set(message.id, message.recipientStatuses);
    });
  });
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["w" /* receiveMessageRead */], function (state, action) {
  var _action$payload = action.payload,
      messageId = _action$payload.messageId,
      recipientType = _action$payload.recipientType,
      recipientId = _action$payload.recipientId,
      status = _action$payload.status;

  return state.setIn([messageId, recipientType, recipientId], status);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["q" /* messageReadSuccess */], function (state, action) {
  var _action$payload2 = action.payload,
      messageId = _action$payload2.messageId,
      recipientType = _action$payload2.recipientType,
      recipientId = _action$payload2.recipientId;

  return state.setIn([messageId, recipientType, recipientId], __WEBPACK_IMPORTED_MODULE_5__constants__["y" /* MessageStatus */].Read);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* bulkMessageReadSuccess */], function (state, action) {
  var _action$payload3 = action.payload,
      messages = _action$payload3.messages,
      recipientType = _action$payload3.recipientType,
      recipientId = _action$payload3.recipientId;

  return messages.reduce(function (acc, _ref) {
    var messageId = _ref.messageId;
    return state.setIn([messageId, recipientType, recipientId], __WEBPACK_IMPORTED_MODULE_5__constants__["y" /* MessageStatus */].Read);
  }, state);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var paginatedConversationMessages = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createMessagePending */], function (state, action) {
  var _action$payload4 = action.payload,
      conversationId = _action$payload4.conversationId,
      message = _action$payload4.message;

  if (message.type === 'EDIT') {
    return state.setIn(['editMessagesById', conversationId, message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */])], message);
  } else {
    return state.updateIn(['messagesByConversationId', conversationId], function (messages) {
      return messages.push(message.set('id', message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */])));
    });
  }
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["v" /* receiveMessage */], function (state, action) {
  var _action$payload5 = action.payload,
      conversationId = _action$payload5.conversationId,
      message = _action$payload5.message;

  if (message.type === 'EDIT' && state.hasIn(['editMessagesById', conversationId])) {
    return state.deleteIn(['editMessagesById', conversationId, message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */])]).setIn(['editMessagesById', conversationId, message.id], message);
  } else if (state.hasIn(['messagesByConversationId', conversationId])) {
    return state.updateIn(['messagesByConversationId', conversationId], function (messages) {
      var removeTemp = messages.filter(function (_ref2) {
        var id = _ref2.id;
        return id !== message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */]) && id !== message.id;
      });
      var addIndex = removeTemp.findIndex(function (_ref3) {
        var createdAt = _ref3.createdAt;
        return createdAt > message.createdAt;
      });
      if (addIndex === -1) {
        return removeTemp.push(message);
      } else {
        return removeTemp.insert(addIndex, message);
      }
    });
  } else {
    return state;
  }
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["t" /* receiveBulkUpdateMessages */], function (state, action) {
  var messages = action.payload.messages;


  return state.withMutations(function (_state) {
    messages.forEach(function (message) {
      if (_state.hasIn(['messagesByConversationId', message.conversationId])) {
        _state.updateIn(['messagesByConversationId', message.conversationId], function (existingMessages) {
          var removeTemp = existingMessages.filter(function (_ref4) {
            var id = _ref4.id;
            return id !== message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */]) && id !== message.id;
          });
          var addIndex = removeTemp.findIndex(function (_ref5) {
            var createdAt = _ref5.createdAt;
            return createdAt > message.createdAt;
          });
          if (addIndex === -1) {
            return removeTemp.push(message);
          } else {
            return removeTemp.insert(addIndex, message);
          }
        });
      }
    });
  });
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createMessageFailed */], function (state, action) {
  var _action$payload6 = action.payload,
      conversationId = _action$payload6.conversationId,
      message = _action$payload6.message;

  if (state.hasIn('editMessagesById', conversationId, message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */]))) {
    return state.setIn(['editMessagesById', conversationId, message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */]), 'failed'], true);
  } else {
    return state.updateIn(['messagesByConversationId', conversationId], function (messages) {
      var index = messages.findIndex(function (m) {
        return m.id === message.getIn(__WEBPACK_IMPORTED_MODULE_3__models__["b" /* TEMP_ID_KEY_PATH */]);
      });
      return messages.setIn([index, 'failed'], true);
    });
  }
  return state;
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["y" /* receivePaginatedMessageList */], function (state, action) {
  var _action$payload7 = action.payload,
      messages = _action$payload7.messages,
      conversationId = _action$payload7.conversationId,
      more = _action$payload7.more,
      next = _action$payload7.next;

  var messagesGroupedByIfIsEditMessages = messages.groupBy(function (message) {
    return message.get('type') === 'EDIT';
  });
  var editMessages = messagesGroupedByIfIsEditMessages.get(true, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
  var nonEditMessages = messagesGroupedByIfIsEditMessages.get(false, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
  return state.setIn(['editMessagesById', conversationId], editMessages).setIn(['paginationById', conversationId, 'more'], more).setIn(['paginationById', conversationId, 'next'], next).setIn(['messagesByConversationId', conversationId], nonEditMessages.toList());
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* receiveNextMessageList */], function (state, action) {
  var _action$payload8 = action.payload,
      messages = _action$payload8.messages,
      conversationId = _action$payload8.conversationId,
      more = _action$payload8.more,
      next = _action$payload8.next;

  var messagesGroupedByIfIsEditMessages = messages.groupBy(function (message) {
    return message.get('type') === 'EDIT';
  });
  var editMessages = messagesGroupedByIfIsEditMessages.get(true, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
  var nonEditMessages = messagesGroupedByIfIsEditMessages.get(false, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
  return state.updateIn(['messagesByConversationId', conversationId], function (existingMessages) {
    return nonEditMessages.toList().concat(existingMessages);
  }).updateIn(['editMessagesById', conversationId], function (existingMessages) {
    return existingMessages.merge(editMessages);
  }).setIn(['paginationById', conversationId, 'more'], more).setIn(['paginationById', conversationId, 'next'], next);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["z" /* removeMessage */], function (state, action) {
  var _action$payload9 = action.payload,
      conversationId = _action$payload9.conversationId,
      id = _action$payload9.id;

  return state.deleteIn(['editMessagesById', conversationId, id]).updateIn(['messagesByConversationId', conversationId], function (messages) {
    return messages.filter(function (message) {
      return id !== message.id;
    });
  });
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["u" /* receiveFirstMessages */], function (state, action) {
  var _action$payload10 = action.payload,
      messages = _action$payload10.messages,
      conversationId = _action$payload10.conversationId;

  return state.setIn(['firstMessagesById', conversationId], messages);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  messagesByConversationId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  firstMessagesById: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  paginationById: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  editMessagesById: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
}));

var firstMessagesStatus = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchFirstMessagesPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* fetchFirstMessagesFailed */], __WEBPACK_IMPORTED_MODULE_4__actions__["u" /* receiveFirstMessages */]), function (state, action) {
  var conversationId = action.payload.conversationId;


  return state.set(conversationId, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  paginatedConversationMessages: paginatedConversationMessages,
  firstMessagesStatus: firstMessagesStatus,
  paginatedStatus: paginatedStatus,
  readReceipts: readReceipts,
  attachment: __WEBPACK_IMPORTED_MODULE_6__attachment__["a" /* default */]
}));

/***/ }),

/***/ "VkOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_HoverAvatar__ = __webpack_require__("PTbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_TagSelect__ = __webpack_require__("Ytp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_UserSelect__ = __webpack_require__("N1pB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_TagList__ = __webpack_require__("8DYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_api_TimeZoneAPI__ = __webpack_require__("Zhpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_LocationSearch__ = __webpack_require__("D1sA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_endUser_segment_actions__ = __webpack_require__("sMXN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_segment_selectors__ = __webpack_require__("WJTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_app_modules_user_selectors__ = __webpack_require__("hTEi");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var LABEL = Object.freeze({
  name: 'name',
  email: 'email',
  phone: 'phone number',
  timeZone: 'time zone',
  displayLocation: 'location',
  employmentTitle: 'title',
  employmentRole: 'role',
  employmentSeniority: 'seniority',
  linkedinHandle: 'linkedin',
  twitterHandle: 'twitter',
  bio: 'twitter bio',
  githubHandle: 'github',
  facebookHandle: 'facebook',
  tags: 'tags',
  conversations: '# conversations',
  segments: '# segments',
  externalId: 'userId',
  _account_owner: 'account owner'
});

var DEFAULT_ATTRIBUTES = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(Object.keys(LABEL));
var DEFAULT_ENABLED_ATTRIBUTES = __WEBPACK_IMPORTED_MODULE_2_immutable__["Set"].of('_account_owner', 'tags', 'email', 'phone', 'location', 'twitter', 'linkedin', 'title', 'time zone', '_classification');
var UNEDITABLE_ATTRIBUTES = __WEBPACK_IMPORTED_MODULE_2_immutable__["Set"].of('city', 'country', 'latitude', 'longitude', 'country', '_classification');

/* harmony default export */ __webpack_exports__["a"] = (function (ComposedComponent) {
  var GetRows = function (_PureComponent) {
    _inherits(GetRows, _PureComponent);

    function GetRows() {
      var _ref,
          _this2 = this;

      var _temp, _this, _ret;

      _classCallCheck(this, GetRows);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GetRows.__proto__ || Object.getPrototypeOf(GetRows)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        endUser: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(_this.props.endUser),
        enabledAttributes: _this.getEnabledAttributes()
      }, _this.createAttributeCheckBoxChange = function (label) {
        return function () {
          var enabledAttributes = _this.state.enabledAttributes;

          if (enabledAttributes.has(label)) {
            _this.setState({ enabledAttributes: enabledAttributes.remove(label) });
          } else {
            _this.setState({ enabledAttributes: enabledAttributes.add(label) });
          }
        };
      }, _this.handleEdit = function () {
        _this.setState({ editing: true });
      }, _this.handleCancel = function () {
        _this.setState({
          editing: false,
          endUser: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(_this.props.endUser),
          enabledAttributes: _this.getEnabledAttributes()
        });
      }, _this.handleSave = function () {
        if (!_this.hasChanged()) return;
        _this.props.actions.updateEndUser({
          endUserId: _this.props.endUser.id,
          endUserParams: _this.state.endUser && _this.state.endUser.toJS()
        });
        _this.props.actions.patchOrgProperties(Object(__WEBPACK_IMPORTED_MODULE_14_utils_PatchHelper__["a" /* patchOperations */])({ enabledAttributes: JSON.stringify(_this.state.enabledAttributes && _this.state.enabledAttributes.toJS()) }, _this.props.orgProperties.enabledAttributes));
        _this.setState({ editing: false });
      }, _this.createHandleInputChange = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["curry"])(function (path, newValue) {
        _this.setState({ endUser: _this.state.endUser.setIn(path, newValue) });
      }), _this.handleLocationChange = function () {
        var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(suggestion) {
          var _suggestion$location, lat, lng, timezone, city, country;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _suggestion$location = suggestion.location, lat = _suggestion$location.lat, lng = _suggestion$location.lng;
                  _context.next = 3;
                  return Object(__WEBPACK_IMPORTED_MODULE_12_app_api_TimeZoneAPI__["a" /* fetchTimeZone */])(suggestion.location.lat, suggestion.location.lng);

                case 3:
                  timezone = _context.sent;
                  city = suggestion.gmaps.address_components.find(function (component) {
                    return component.types.find(function (type) {
                      return type === 'locality';
                    });
                  });
                  country = suggestion.gmaps.address_components.find(function (component) {
                    return component.types.find(function (type) {
                      return type === 'country';
                    });
                  });

                  _this.setState({
                    endUser: _this.state.endUser.setIn(['attributes', 'display_location'], suggestion.label).setIn(['attributes', 'latitude'], lat).setIn(['attributes', 'longitude'], lng).setIn(['attributes', 'city'], city.long_name).setIn(['attributes', 'country'], country.long_name).set('timeZone', timezone.timeZoneId)
                  });

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }(), _this.handleTagsChange = function (tags) {
        _this.setState({
          endUser: _this.state.endUser.set('tags', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(tags.map(function (tag) {
            return tag.id;
          })))
        });
      }, _this.handleAccountOwnerChange = function (_ref3) {
        var userId = _ref3.userId;

        _this.setState({
          endUser: _this.state.endUser.setIn(['attributes', '_account_owner'], userId)
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GetRows, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!this.props.endUserAttributesFetched) {
          this.props.actions.fetchEndUserAttributes();
        }
        if (!this.props.segmentFetchedForEndUser) {
          this.props.actions.fetchSegments({ id: this.state.endUser.get('id') });
        }
        if (!this.props.endUserConversationCountFetched) {
          this.props.actions.fetchConversationsCountForEndUserId({ id: this.state.endUser.get('id') });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.endUser.id !== this.props.endUser.id) {
          this.setState({
            endUser: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(nextProps.endUser)
          });
        }

        if (nextProps.endUserAttributesFetched && !this.props.endUserAttributesFetched) {
          this.setState({
            enabledAttributes: this.getEnabledAttributes()
          });
        }
      }
    }, {
      key: 'hasChanged',
      value: function hasChanged() {
        var endUserChanged = !Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["is"])(this.state.endUser, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(this.props.endUser));
        var enabledAttributesChanged = !Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["is"])(this.state.enabledAttributes, this.getEnabledAttributes());
        return endUserChanged || enabledAttributesChanged;
      }
    }, {
      key: 'getEnabledAttributes',
      value: function getEnabledAttributes() {
        return this.props.orgProperties.enabledAttributes ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(JSON.parse(this.props.orgProperties.enabledAttributes)) : DEFAULT_ENABLED_ATTRIBUTES;
      }
    }, {
      key: 'userRenderer',
      value: function userRenderer(userId) {
        if (typeof userId === 'undefined') return;
        var users = this.props.users;

        var user = users.get(userId) && users.get(userId).toJS();
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_HoverAvatar__["a" /* default */], { user: user, size: 'extra-small', style: { marginRight: 4 } }),
          Object(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user)
        );
      }
    }, {
      key: 'getContactRows',
      value: function getContactRows() {
        var _state = this.state,
            endUser = _state.endUser,
            editing = _state.editing;

        return [{
          label: LABEL.name,
          value: endUser.get('name'),
          handleChange: this.createHandleInputChange(['name'])
        }, {
          label: LABEL.email,
          value: endUser.get('email'),
          handleChange: this.createHandleInputChange(['email'])
        }, {
          label: LABEL.externalId,
          value: endUser.get('externalId')
        }, {
          label: LABEL.phone,
          value: endUser.get('phone'),
          handleChange: this.createHandleInputChange(['phone'])
        }, {
          label: LABEL.timeZone,
          value: endUser.get('timeZone')
        }, {
          label: LABEL.displayLocation,
          value: editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_shared_LocationSearch__["a" /* default */], {
            placeholder: '',
            initialValue: endUser.getIn(['attributes', 'display_location']),
            types: ['(cities)'],
            onSuggestSelect: this.handleLocationChange
          }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'flex-3 dsg-Body' },
            endUser.getIn(['attributes', 'display_location'])
          ),
          empty: !endUser.getIn(['attributes', 'display_location'])
        }, {
          label: LABEL.employmentTitle,
          value: endUser.getIn(['attributes', 'employment_title']),
          handleChange: this.createHandleInputChange(['attributes', 'employment_title'])
        }, {
          label: LABEL.employmentRole,
          value: endUser.getIn(['attributes', 'employment_role']),
          handleChange: this.createHandleInputChange(['attributes', 'employment_role'])
        }, {
          label: LABEL.employmentSeniority,
          value: endUser.getIn(['attributes', 'employment_seniority']),
          handleChange: this.createHandleInputChange(['attributes', 'employment_seniority'])
        }];
      }
    }, {
      key: 'getSocialRows',
      value: function getSocialRows() {
        var endUser = this.state.endUser;

        return [{
          label: LABEL.linkedinHandle,
          href: 'http://linkedin.com/' + endUser.getIn(['attributes', 'linkedin_handle']),
          value: endUser.getIn(['attributes', 'linkedin_handle']),
          handleChange: this.createHandleInputChange(['attributes', 'linkedin_handle'])
        }, {
          label: LABEL.twitterHandle,
          href: 'http://twitter.com/' + endUser.getIn(['attributes', 'twitter_handle']),
          value: endUser.getIn(['attributes', 'twitter_handle']),
          handleChange: this.createHandleInputChange(['attributes', 'twitter_handle'])
        }, {
          label: LABEL.bio,
          value: endUser.getIn(['attributes', 'bio']),
          handleChange: this.createHandleInputChange(['attributes', 'bio'])
        }, {
          label: LABEL.githubHandle,
          value: endUser.getIn(['attributes', 'github_handle']),
          href: 'http://github.com/' + endUser.getIn(['attributes', 'github_handle']),
          handleChange: this.createHandleInputChange(['attributes', 'github_handle'])
        }, {
          label: LABEL.facebookHandle,
          value: endUser.getIn(['attributes', 'facebook_handle']),
          href: 'http://facebook.com/' + endUser.getIn(['attributes', 'facebook_handle']),
          handleChange: this.createHandleInputChange(['attributes', 'facebook_handle'])
        }];
      }
    }, {
      key: 'getDriftRows',
      value: function getDriftRows() {
        var _props = this.props,
            endUserSegments = _props.endUserSegments,
            endUserConversationsCount = _props.endUserConversationsCount,
            users = _props.users;
        var _state2 = this.state,
            endUser = _state2.endUser,
            editing = _state2.editing;

        var accountOwnerId = endUser.getIn(['attributes', '_account_owner']);
        var endUserTags = endUser.get('tags');
        return [{
          label: LABEL._account_owner,
          value: editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_UserSelect__["a" /* default */], {
            selectedUserId: accountOwnerId,
            onChange: this.handleAccountOwnerChange
          }) : this.userRenderer(parseInt(accountOwnerId)),
          empty: !users.get(parseInt(accountOwnerId))
        }, {
          label: LABEL.tags,
          value: editing ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_shared_TagSelect__["a" /* default */], { onChange: this.handleTagsChange, selected: endUserTags && endUserTags.toJS() }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_TagList__["a" /* default */], { tagIds: endUserTags && endUserTags.toJS() }),
          empty: !(endUserTags && endUserTags.size)
        }, {
          label: LABEL.conversations,
          value: _.get(endUserConversationsCount, 'all', 0)
        }, {
          label: LABEL.segments,
          value: _.get(endUserSegments, 'length', 0)
        }];
      }
    }, {
      key: 'getCustomRows',
      value: function getCustomRows() {
        var _this3 = this;

        var _state3 = this.state,
            endUser = _state3.endUser,
            editing = _state3.editing;
        var endUserAttributesProperties = this.props.endUserAttributesProperties;

        return endUserAttributesProperties.filter(function (_ref4) {
          var name = _ref4.name;
          return !DEFAULT_ATTRIBUTES.has(name);
        }).map(function (_ref5) {
          var name = _ref5.name,
              displayName = _ref5.displayName,
              type = _ref5.type;

          var value = endUser.getIn(['attributes', name]);

          return {
            value: type === 'DATETIME' && !editing && !!value ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'span',
              { title: value },
              __WEBPACK_IMPORTED_MODULE_4_moment___default()(value).format('L LT')
            ) : endUser.getIn(['attributes', name]),
            label: displayName,
            handleChange: UNEDITABLE_ATTRIBUTES.has(name) ? undefined : _this3.createHandleInputChange(['attributes', name])
          };
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _state4 = this.state,
            editing = _state4.editing,
            enabledAttributes = _state4.enabledAttributes;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ComposedComponent, _extends({
          contactRows: this.getContactRows(),
          socialRows: this.getSocialRows(),
          driftRows: this.getDriftRows(),
          customRows: this.getCustomRows(),
          editing: editing,
          changed: this.hasChanged(),
          enabledAttributes: enabledAttributes,
          createAttributeCheckBoxChange: this.createAttributeCheckBoxChange,
          handleEdit: this.handleEdit,
          handleCancel: this.handleCancel,
          handleSave: this.handleSave
        }, this.props));
      }
    }]);

    return GetRows;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

  var mapStateToProps = function mapStateToProps(state, props) {
    var propsToSelectFrom = { endUser: props.endUser };
    return {
      endUserAttributesFetched: __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_selectors__["a" /* attributesFetched */](state),
      endUserAttributesProperties: __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_selectors__["c" /* properties */](state),
      endUserSegments: __WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_segment_selectors__["a" /* endUserSegments */](state, propsToSelectFrom),
      segmentFetchedForEndUser: __WEBPACK_IMPORTED_MODULE_21_app_modules_endUser_segment_selectors__["b" /* segmentFetchedForEndUser */](state, propsToSelectFrom),
      endUserConversationsCount: __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["f" /* endUserConversationsCount */](state, propsToSelectFrom),
      endUserConversationsCountFetched: __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_selectors__["g" /* endUserConversationsCountFetched */](state, propsToSelectFrom),
      orgId: __WEBPACK_IMPORTED_MODULE_22_app_modules_org_selectors__["orgId"](state),
      orgProperties: __WEBPACK_IMPORTED_MODULE_22_app_modules_org_selectors__["properties"](state),
      users: __WEBPACK_IMPORTED_MODULE_24_app_modules_user_selectors__["orgUsersById"](state)
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
      actions: Object(__WEBPACK_IMPORTED_MODULE_6_redux__["b" /* bindActionCreators */])({
        fetchEndUserAttributes: __WEBPACK_IMPORTED_MODULE_18_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
        fetchSegments: __WEBPACK_IMPORTED_MODULE_20_app_modules_endUser_segment_actions__["a" /* fetchSegments */],
        fetchConversationsCountForEndUserId: __WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_actions__["o" /* fetchConversationsCountForEndUserId */],
        patchOrgProperties: __WEBPACK_IMPORTED_MODULE_23_app_modules_org_actions__["patchOrgProperties"],
        updateEndUser: __WEBPACK_IMPORTED_MODULE_17_app_modules_endUser_actions__["_4" /* updateEndUser */]
      }, dispatch)
    };
  };

  return Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(GetRows);
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "Vl6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ZendeskPayload = {
  client_id: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_11" /* ZENDESK_CLIENT_ID */],
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/zendesk',
  scope: 'read write'
};

var Zendesk = function (_Component) {
  _inherits(Zendesk, _Component);

  function Zendesk() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Zendesk);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Zendesk.__proto__ || Object.getPrototypeOf(Zendesk)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      accountName: ''
    }, _this.renderInput = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, { placeholder: 'ORG NAME', label: 'your organization name in zendesk',
        valueLink: {
          requestChange: function requestChange(input) {
            _this.setState({ accountName: input });
          },
          value: _this.state.accountName
        },
        isValid: !!_this.state.accountName
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Zendesk, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;
      var accountName = this.state.accountName;

      var authLink = 'https://' + accountName + '.zendesk.com/oauth/authorizations/new';
      var OauthPayload = _extends({}, ZendeskPayload, { state: accountName });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Use Drift\u2019s intelligent messaging to surface help article links from your Zendesk knowledge base.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'When Driftbot cannot find an article to help your customer, it will ask if they would like to create a ticket directly in the conversation. Just enter your organization name on Zendesk and we will handle the rest!'
        ),
        isConnected ? null : this.renderInput(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__["a" /* default */], {
          integrationId: 'zendesk',
          isOauth: true,
          oauthLink: authLink,
          oauthQueryParams: OauthPayload
        })
      );
    }
  }]);

  return Zendesk;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Zendesk);

/***/ }),

/***/ "VlbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchSegments: function fetchSegments(id, orgId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxCustomerAPI"].get('/end_users/' + id + '/memberships?orgId=' + orgId).checkStatus().retryWithBackoff().map(function (_ref) {
      var response = _ref.response;
      return response;
    });
  }
};

/***/ }),

/***/ "VmIC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAuthorizationType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__("ivXw");


var getName = function getName(_ref) {
  var name = _ref.name;
  return name || ' ';
};
var nameComparator = function nameComparator(a, b) {
  return getName(a).localeCompare(getName(b));
};
var sortByName = function sortByName(organizations) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["sort"])(nameComparator, organizations);
};

var getAuthorizationType = function getAuthorizationType(scopes) {
  if (scopes.includes('org_admin')) {
    return 'Admin';
  } else if (scopes.includes('calendar_user')) {
    return 'Calendar User';
  }
  return 'Chat User';
};

/***/ }),

/***/ "Vn0U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("MD1P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var OnlineToggle = function OnlineToggle(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toggle__["a" /* default */], _extends({
    className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.OnlineToggle, className),
    icons: {
      checked: React.createElement(
        'span',
        null,
        'Online'
      ),
      unchecked: React.createElement(
        'span',
        null,
        'Offline'
      )
    }
  }, props));
};

OnlineToggle.displayName = 'OnlineToggle';

/* harmony default export */ __webpack_exports__["a"] = (OnlineToggle);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "VpnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("IDPS");












var mapStateToProps = function mapStateToProps(state, props) {
  return {
    conditionSet: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["H" /* getConditionSet */](state, props),
    isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      deleteConditionSet: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["I" /* deleteConditionSet */],
      addCondition: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["c" /* addCondition */],
      showConditionModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_227" /* showConditionModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onAddConditionClick: function onAddConditionClick(props) {
    return function () {
      var id = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_helpers__["a" /* weakUuid */])();
      props.actions.addCondition({
        condition: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__["b" /* Condition */]({ id: id }),
        conditionSetId: props.id
      });
      props.actions.showConditionModal(id);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),

/***/ "Vskm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_Application__ = __webpack_require__("08hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteConfig__ = __webpack_require__("huSt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_profile_actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_actions__ = __webpack_require__("cRAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_routes_ConversationRoutes__ = __webpack_require__("mdkU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_routes_EndUserRoutes__ = __webpack_require__("sQnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_routes_SettingsRoutes__ = __webpack_require__("RdwF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_routes_CustomizeRoutes__ = __webpack_require__("Zd4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_routes_DriftAdminPanelRoutes__ = __webpack_require__("+c5p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_ApplicationComponent__ = __webpack_require__("ebD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_NotFoundPage__ = __webpack_require__("17LC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_SlackLander__ = __webpack_require__("P5/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_SlackInstall__ = __webpack_require__("gGYB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_HealthCheck__ = __webpack_require__("gfbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_Logout__ = __webpack_require__("2Pw7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_MobileLander__ = __webpack_require__("Tg02");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Integration_OAuth__ = __webpack_require__("uo5z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_WhoAmI__ = __webpack_require__("A9xC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_Presence__ = __webpack_require__("oGG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_Integration_Lander__ = __webpack_require__("mQ0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_Customize_CustomizeTemplate__ = __webpack_require__("98WB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_ConversationStats_RootDashboardRedirect__ = __webpack_require__("JIpA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_customer_Unsubscribe__ = __webpack_require__("twml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_playbook_routes__ = __webpack_require__("Bb29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_app_modules_driftAppMetrics_actions__ = __webpack_require__("ZuE5");


var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






































var DASHBOARD_PATH = '/dashboard';
var CONVERSATION_STATS_PATH = '/conversation-stats';

var SalesforceRedirectPage = function SalesforceRedirectPage() {
  window.location.href = __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/integrations/detail/salesforce';
  return null;
};

var On24RedirectPage = function On24RedirectPage() {
  window.location.href = __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/integrations/detail/on24';
  return null;
};

var OutreachRedirectPage = function OutreachRedirectPage() {
  window.location.href = __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/integrations/detail/outreach';
  return null;
};

var ZapierRedirectPage = function ZapierRedirectPage() {
  window.location.href = __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/integrations/detail/zapier';
  return null;
};

var PlaceholderDashboard = function PlaceholderDashboard() {
  //this is a hack to fix broken signups.
  //the style thing is to avoid a flash of the nav before we redirect.
  document.body.style.display = 'none';
  window.location.href = __WEBPACK_IMPORTED_MODULE_30_constants_ResourcesConstants__["c" /* APP_URL */] + '/home' + window.location.search;
  return null;
};

var createRoutes = function createRoutes(store) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */],
    { path: '/', onEnter: function onEnter() {
        return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_32_app_modules_driftAppMetrics_actions__["a" /* enterRootAppRoute */])());
      } },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: 'accept-integration/:integration', component: __WEBPACK_IMPORTED_MODULE_25_components_Integration_Lander__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/logout', component: __WEBPACK_IMPORTED_MODULE_20_components_Logout__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/setup/salesforce', component: SalesforceRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/setup/on24', component: On24RedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/setup/outreach', component: OutreachRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/setup/zapier', component: ZapierRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/integrations/salesforce', component: SalesforceRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/salesforce/config', component: SalesforceRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/salesforce/mapping/attributes', component: SalesforceRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/settings/salesforce/mapping/attributes/metrics', component: SalesforceRedirectPage }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */],
      { component: __WEBPACK_IMPORTED_MODULE_15_components_ApplicationComponent__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: 'healthcheck', component: __WEBPACK_IMPORTED_MODULE_19_components_HealthCheck__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/import-end-users', to: '/users/import' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/integrate', to: '/settings2/integrations' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/setup/segment', to: '/settings/setup/install' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/integrations', to: '/settings2/integrations' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/assistant', to: '/settings2/assistant' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/profile', to: '/settings2/profile' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/setup', to: '/settings2/integrations' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/setup/:integration', to: '/settings/setup/:integration' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/settings/configure', to: '/customize' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/integrate/:integration', to: '/settings/setup/:integration' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/upgrade', to: '/settings/billing' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Redirect */], { from: '/settings2/integrations/segment', to: '/settings/widget' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: 'setup-slack', component: __WEBPACK_IMPORTED_MODULE_18_components_SlackInstall__["a" /* default */] }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */],
        {
          onEnter: function () {
            var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nextState, replace, callback) {
              var processingCredential;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return Object(__WEBPACK_IMPORTED_MODULE_4__RouteConfig__["b" /* onLoggedInRouteEnter */])(Object(__WEBPACK_IMPORTED_MODULE_3_app_Application__["b" /* getApplication */])(), nextState, replace, callback);

                    case 2:
                      processingCredential = _context.sent;

                      callback();

                      if (!processingCredential) {
                        _context.next = 6;
                        break;
                      }

                      return _context.abrupt('return');

                    case 6:
                      _context.next = 8;
                      return store.dispatch(__WEBPACK_IMPORTED_MODULE_5_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
                        store.dispatch(__WEBPACK_IMPORTED_MODULE_5_app_modules_user__["a" /* actions */].fetchOrgUsers());
                        store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_actions__["a" /* fetchEmbed */])());
                        store.dispatch(__WEBPACK_IMPORTED_MODULE_7_app_modules_socket_actions__["a" /* authenticate */]({ clusterName: __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["v" /* SocketCluster */].PUSH }));
                        store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_31_app_modules_integrations_actions__["l" /* fetchIntegrationStates */])());
                        return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_app_modules_socket_actions__["a" /* authenticate */]({ clusterName: __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES }));
                      });

                    case 8:
                      return _context.abrupt('return', store.dispatch(__WEBPACK_IMPORTED_MODULE_6_app_modules_profile_actions__["fetchCurrentProfile"]()));

                    case 9:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x, _x2, _x3) {
              return _ref.apply(this, arguments);
            };
          }(),
          onChange: function onChange(prevState, nextState, replace, callback) {
            Object(__WEBPACK_IMPORTED_MODULE_4__RouteConfig__["a" /* onLoggedInRouteChange */])(prevState, nextState, replace, callback);
          }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: 'mobile-lander', component: __WEBPACK_IMPORTED_MODULE_21_components_MobileLander__["a" /* container */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* IndexRedirect */], { to: DASHBOARD_PATH }),
        Object(__WEBPACK_IMPORTED_MODULE_29_components_playbook_routes__["a" /* Routes */])(store),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: 'oauth', component: __WEBPACK_IMPORTED_MODULE_22_components_Integration_OAuth__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/debug/whoami', component: __WEBPACK_IMPORTED_MODULE_23_components_WhoAmI__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_14_app_routes_DriftAdminPanelRoutes__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/start-slack(/:slackUserId)', component: __WEBPACK_IMPORTED_MODULE_17_components_SlackLander__["a" /* default */] }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */],
          {
            onChange: function onChange(prevState, nextState, replace, callback) {
              return Object(__WEBPACK_IMPORTED_MODULE_4__RouteConfig__["c" /* onProtectedRouteEnter */])(Object(__WEBPACK_IMPORTED_MODULE_3_app_Application__["b" /* getApplication */])(), nextState, replace, callback);
            },
            onEnter: function onEnter(nextState, replace, callback) {
              return Object(__WEBPACK_IMPORTED_MODULE_4__RouteConfig__["c" /* onProtectedRouteEnter */])(Object(__WEBPACK_IMPORTED_MODULE_3_app_Application__["b" /* getApplication */])(), nextState, replace, callback);
            }
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: DASHBOARD_PATH, component: PlaceholderDashboard }),
          Object(__WEBPACK_IMPORTED_MODULE_10_app_routes_ConversationRoutes__["a" /* default */])(store),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: CONVERSATION_STATS_PATH, component: __WEBPACK_IMPORTED_MODULE_27_components_ConversationStats_RootDashboardRedirect__["a" /* default */] }),
          Object(__WEBPACK_IMPORTED_MODULE_12_app_routes_SettingsRoutes__["a" /* default */])(store),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */],
            { path: __WEBPACK_IMPORTED_MODULE_13_app_routes_CustomizeRoutes__["a" /* Path */], component: __WEBPACK_IMPORTED_MODULE_26_components_Customize_CustomizeTemplate__["a" /* default */] },
            __WEBPACK_IMPORTED_MODULE_13_app_routes_CustomizeRoutes__["b" /* Routes */]
          ),
          Object(__WEBPACK_IMPORTED_MODULE_11_app_routes_EndUserRoutes__["a" /* default */])(store),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '/live', component: __WEBPACK_IMPORTED_MODULE_24_components_Presence__["a" /* default */] })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* Route */], { path: '*', component: __WEBPACK_IMPORTED_MODULE_16_components_NotFoundPage__["a" /* default */] })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["default"] = (createRoutes);

/***/ }),

/***/ "Vu8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_selectors__ = __webpack_require__("+dPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RuleLink__ = __webpack_require__("2cpB");







var makeMapStateToProps = function makeMapStateToProps() {
  var rule = __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_selectors__["b" /* makeRule */]();

  return function (state, props) {
    return {
      rule: rule(state, props)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])({
      fetchRules: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_actions__["fetchRules"]
    }, dispatch)
  };
};

var componentLifecycle = {
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchRules();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])(componentLifecycle), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.rule;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]))(__WEBPACK_IMPORTED_MODULE_5__RuleLink__["a" /* RuleLink */]));

/***/ }),

/***/ "Vxfn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VxqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("MHWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var Option = function Option(_ref) {
  var title = _ref.title,
      children = _ref.children,
      checked = _ref.checked,
      onClick = _ref.onClick,
      _ref$toggleDisabled = _ref.toggleDisabled,
      toggleDisabled = _ref$toggleDisabled === undefined ? false : _ref$toggleDisabled,
      _ref$tooltipText = _ref.tooltipText,
      tooltipText = _ref$tooltipText === undefined ? '' : _ref$tooltipText;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-sequence-option' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-sequence-option-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'playbook-sequence-option-description' },
        children
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
        { hover: tooltipText, component: tooltipText, flow: 'up' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Toggle__["a" /* default */], { onClick: onClick, checked: checked, disabled: toggleDisabled })
      )
    )
  );
};

var SequenceOptions = function SequenceOptions(_ref2) {
  var onSmartSendingClick = _ref2.onSmartSendingClick,
      onWeekdaysOnlyClick = _ref2.onWeekdaysOnlyClick,
      onUnenrollOnReplyClick = _ref2.onUnenrollOnReplyClick,
      onUnenrollOnReplyByDomainClick = _ref2.onUnenrollOnReplyByDomainClick,
      weekdaysOnly = _ref2.weekdaysOnly,
      smartSending = _ref2.smartSending,
      unenrollOnReply = _ref2.unenrollOnReply,
      isOutboundSequencePlaybook = _ref2.isOutboundSequencePlaybook,
      unenrollOnReplyByDomain = _ref2.unenrollOnReplyByDomain;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-sequence-options' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-title-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        'Advanced sending options'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Improve your open rates by optimizing how and when your emails send.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-card' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Option,
        { title: 'Smart Sending', checked: smartSending, onClick: onSmartSendingClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Drift knows the timezone of the person you are emailing. Use smart sending to send emails when your prospect is most likely to open it.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Option,
        { title: 'Avoid weekends and holidays', checked: weekdaysOnly, onClick: onWeekdaysOnlyClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Drift won\u2019t send your emails on weekends (Saturday + Sunday) or Federal US holidays.',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'https://help.drift.com/article/advanced-sequence-sending-options/', target: '_blank' },
            'Learn more'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Option,
        { title: 'Unenroll contacts on reply',
          checked: unenrollOnReply || isOutboundSequencePlaybook,
          onClick: onUnenrollOnReplyClick,
          toggleDisabled: isOutboundSequencePlaybook,
          tooltipText: isOutboundSequencePlaybook && 'Unenroll on reply is always on for sales sequences sent through Gmail' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          isOutboundSequencePlaybook ? 'Drift will unenroll contacts from receiving additional emails in a sequence once they reply to an email.' : 'Drift can unenroll contacts from receiving addtional emails in a sequence once they reply to an email'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Option,
        { title: 'Unenroll same domain contacts on reply',
          checked: unenrollOnReplyByDomain,
          onClick: onUnenrollOnReplyByDomainClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'When a contact replies to your email Drift can unenroll all contacts with the same domain from the sequence. The sender must have Gmail connected here to track replies.'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SequenceOptions);

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(193);

/***/ }),

/***/ "W68D":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 34 28\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#394F5A\" fill-rule=\"evenodd\"><path d=\"M31.875 27.818H2.125C.953 27.818 0 26.883 0 25.733V2.086C0 .936.953 0 2.125 0h29.75C33.047 0 34 .936 34 2.086v23.647c0 1.15-.953 2.085-2.125 2.085zm.708-25.732a.703.703 0 0 0-.708-.695H2.125a.703.703 0 0 0-.708.695v3.478h31.166V2.086zm0 4.869H1.417v18.778c0 .383.318.695.708.695h29.75c.39 0 .708-.312.708-.695V6.955zM3.556 2.812h.007c.392 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695zm2.125 0h.007c.39 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695zm2.125 0h.007c.392 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695z\"></path><path d=\"M22.458 17.042h-2.166a.542.542 0 1 1 0-1.084h2.166a.541.541 0 1 1 0 1.084zm-2.866-3.138a.54.54 0 0 1-.766 0 .541.541 0 0 1 0-.766l1.625-1.625a.541.541 0 1 1 .766.766l-1.625 1.625zM16.5 19.208a2.71 2.71 0 0 1-2.708-2.707 2.711 2.711 0 0 1 2.708-2.709 2.711 2.711 0 0 1 2.708 2.709 2.71 2.71 0 0 1-2.708 2.707zm0-4.332c-.896 0-1.625.729-1.625 1.625 0 .895.73 1.623 1.625 1.623.896 0 1.625-.728 1.625-1.623 0-.896-.73-1.625-1.625-1.625zm0-1.626a.542.542 0 0 1-.542-.542v-2.166a.541.541 0 1 1 1.084 0v2.166a.542.542 0 0 1-.542.542zm-2.708.812a.54.54 0 0 1-.383-.158l-1.625-1.626a.541.541 0 1 1 .766-.766l1.625 1.626a.541.541 0 0 1-.383.924zM13.25 16.5a.542.542 0 0 1-.542.542h-2.166a.542.542 0 1 1 0-1.084h2.166c.3 0 .542.242.542.542zm.16 2.055a.541.541 0 1 1 .766.765l-1.626 1.625a.54.54 0 0 1-.766 0 .541.541 0 0 1 0-.765l1.626-1.625zm3.09 1.195c.3 0 .542.242.542.542v2.166a.541.541 0 1 1-1.084 0v-2.166c0-.3.242-.542.542-.542zm3.091-1.196l1.625 1.626a.541.541 0 1 1-.766.765l-1.625-1.625a.541.541 0 1 1 .766-.766z\"></path></g></svg>"

/***/ }),

/***/ "W6a3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "W8CA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var DefaultEmbedConstants = Marty.createConstants(['DEFAULT_EMBED_FETCH', 'DEFAULT_EMBED_PATCH', 'DEFAULT_EMBED_REFRESH', 'UPDATE_CURRENT_EMBED', 'DEFAULT_EMBED_PATCH_DONE', 'DEFAULT_EMBED_PATCH_FAILED', 'DEFAULT_EMBED_PATCH_START']);

/* harmony default export */ __webpack_exports__["a"] = (DefaultEmbedConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "W8VV":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "WAuC":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 38 44\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"opt-in\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Artboard\" transform=\"translate(-898.000000, -142.000000)\" fill=\"#FFFFFF\"><g id=\"rock-copy-2\" transform=\"translate(897.000000, 141.000000)\"><path d=\"M24.956,44.999 C18.862,44.999 14.353,42.557 11.171,37.536 C6.577,30.286 3.296,26.568 1.75,24.998 C1.147,24.387 0.888,23.55 1.041,22.704 C1.193,21.855 1.753,21.13 2.538,20.764 C5.084,19.577 7.88,19.883 10.208,21.596 L13.007,23.891 L13.007,4.999 C13.007,3.033 14.497,0.999 16.99,0.999 C19.483,0.999 20.973,3.033 20.973,4.999 L20.973,17.533 C21.537,17.208 22.196,16.999 22.965,16.999 C24.239,16.999 25.249,17.557 25.937,18.363 C26.622,17.557 27.641,16.999 28.939,16.999 C29.705,16.999 30.366,17.215 30.931,17.549 L30.931,9.999 C30.931,8.033 32.42,5.999 34.914,5.999 C37.407,5.999 38.897,8.033 38.897,9.999 L38.897,23.999 L38.897,31.733 C38.897,39.544 33.164,44.999 24.956,44.999 Z M36.905,9.999 C36.905,9.005 36.222,7.999 34.914,7.999 C33.606,7.999 32.922,9.005 32.922,9.999 L32.922,20.999 C32.922,21.08 32.894,21.153 32.876,21.228 C32.864,21.277 32.865,21.33 32.847,21.376 C32.815,21.453 32.763,21.516 32.714,21.582 C32.687,21.619 32.67,21.663 32.638,21.695 C32.584,21.751 32.515,21.787 32.45,21.829 C32.407,21.856 32.371,21.893 32.324,21.914 C32.261,21.941 32.19,21.946 32.121,21.96 C32.062,21.972 32.008,21.998 31.946,21.999 C31.939,21.999 31.932,21.999 31.925,21.999 C31.789,21.999 31.66,21.971 31.541,21.921 C31.506,21.906 31.48,21.877 31.448,21.859 C31.369,21.815 31.289,21.772 31.226,21.709 C31.197,21.68 31.182,21.641 31.157,21.608 C31.103,21.54 31.047,21.474 31.012,21.393 C30.997,21.358 30.998,21.316 30.987,21.279 C30.962,21.195 30.932,21.112 30.93,21.02 C30.909,20.04 30.205,18.999 28.939,18.999 C27.631,18.999 26.948,20.005 26.948,20.999 C26.948,21.08 26.92,21.152 26.902,21.227 C26.89,21.276 26.891,21.329 26.872,21.376 C26.841,21.453 26.788,21.516 26.74,21.582 C26.712,21.619 26.695,21.663 26.663,21.695 C26.609,21.751 26.54,21.787 26.475,21.829 C26.432,21.856 26.396,21.893 26.349,21.914 C26.287,21.941 26.215,21.946 26.146,21.96 C26.087,21.972 26.034,21.998 25.971,21.999 C25.965,21.999 25.958,21.999 25.951,21.999 C25.815,21.999 25.685,21.971 25.566,21.921 C25.531,21.906 25.505,21.877 25.472,21.858 C25.394,21.814 25.315,21.772 25.251,21.709 C25.223,21.681 25.208,21.642 25.183,21.611 C25.129,21.542 25.073,21.475 25.038,21.393 C25.023,21.358 25.024,21.318 25.013,21.281 C24.987,21.196 24.957,21.113 24.955,21.02 C24.935,20.04 24.231,18.999 22.965,18.999 C21.657,18.999 20.973,20.005 20.973,20.999 C20.973,21.552 20.528,21.999 19.977,21.999 C19.427,21.999 18.981,21.552 18.981,20.999 L18.981,4.999 C18.981,4.005 18.298,2.999 16.99,2.999 C15.682,2.999 14.998,4.005 14.998,4.999 L14.998,25.999 C14.998,26.044 14.978,26.084 14.972,26.128 C14.963,26.197 14.955,26.265 14.931,26.332 C14.908,26.399 14.872,26.455 14.836,26.514 C14.812,26.553 14.803,26.596 14.774,26.632 C14.763,26.645 14.747,26.651 14.736,26.663 C14.689,26.716 14.632,26.754 14.575,26.795 C14.526,26.831 14.481,26.87 14.427,26.896 C14.372,26.922 14.313,26.932 14.253,26.948 C14.186,26.966 14.121,26.985 14.052,26.989 C14.034,26.99 14.02,26.999 14.003,26.999 C13.956,26.999 13.916,26.979 13.872,26.972 C13.803,26.963 13.738,26.955 13.672,26.932 C13.605,26.908 13.548,26.872 13.489,26.835 C13.451,26.812 13.408,26.802 13.372,26.773 L8.989,23.178 C7.306,21.938 5.246,21.707 3.376,22.579 C3.176,22.672 3.038,22.848 3.001,23.06 C2.98,23.175 2.974,23.396 3.166,23.592 C5.123,25.58 8.393,29.426 12.851,36.462 C15.638,40.86 19.598,42.999 24.956,42.999 C32.103,42.999 36.905,38.472 36.905,31.733 L36.905,23.999 L36.905,9.999 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "WB5i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCookie; });
/* unused harmony export clearCookie */
/* unused harmony export clearAllCookies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var getCookie = function getCookie(cookieName) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(cookieName);
};

var clearAllCookies = function clearAllCookies() {
  var cookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.all();
  return _.each(cookies, function (_, name) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(name);
  });
};

var setCookie = function setCookie(name, value, options) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(name, value, options);
};

var clearCookie = function clearCookie(name, options) {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(name, options);
};


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "WBJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_DateHelpers__ = __webpack_require__("97t2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_ToolTipOnHover__ = __webpack_require__("46ps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_customer_CustomerMetric_styl__ = __webpack_require__("pYOq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_customer_CustomerMetric_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_components_customer_CustomerMetric_styl__);
/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.










var CustomerMetric = React.createClass({
  displayName: 'CustomerMetric',

  propTypes: {
    metric: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
    display: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,
    showDelta: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    deltaPercentage: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    selectable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    isSelected: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
    tooltipText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
    className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      selectable: false,
      isSelected: false,
      showDelta: false
    };
  },
  renderDelta: function renderDelta() {
    var delta = this.props.deltaPercentage;

    if (delta != null) {
      return React.createElement(
        'div',
        { className: 'delta' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_ToolTipOnHover__["a" /* default */],
          { toolTip: this.props.tooltipText },
          React.createElement('div', {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()({
              'arrow': this.props.showDelta && delta !== 0,
              'increasing': delta > 0 || delta === __WEBPACK_IMPORTED_MODULE_1_utils_DateHelpers__["a" /* NO_DELTA_CHANGE */],
              'decreasing': delta < 0
            }) }),
          React.createElement(
            'div',
            { className: 'percent' },
            '' + (delta === __WEBPACK_IMPORTED_MODULE_1_utils_DateHelpers__["a" /* NO_DELTA_CHANGE */] ? __WEBPACK_IMPORTED_MODULE_1_utils_DateHelpers__["a" /* NO_DELTA_CHANGE */] : Math.abs(delta)),
            delta !== __WEBPACK_IMPORTED_MODULE_1_utils_DateHelpers__["a" /* NO_DELTA_CHANGE */] ? '%' : undefined
          )
        )
      );
    }
  },
  render: function render() {
    return React.createElement(
      'div',
      {
        className: 'CustomerMetric ' + (this.props.className ? this.props.className : undefined) },
      React.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('container', {
            selectable: this.props.selectable,
            isSelected: this.props.isSelected
          }) },
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'value' },
            this.props.metric
          ),
          React.createElement(
            'div',
            { className: 'display' },
            this.props.display,
            this.renderDelta()
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CustomerMetric);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "WExX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WJ2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_InlineEditor__ = __webpack_require__("D6+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_customer_Inputs_makeCmdEnterHandler__ = __webpack_require__("wV7H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_customer_Inputs_isMediumInputEmpty__ = __webpack_require__("cMSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Cancel__ = __webpack_require__("P4YN");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ThickGrayBorder = '2px solid ' + __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default.a['color-navy-light'];

var NoteDisplay = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
  style: { width: 13, height: 13.5, marginRight: 6 },
  src: __webpack_require__("ai6w")
}), "New Note"];

var NoteInput = function (_Component) {
  _inherits(NoteInput, _Component);

  function NoteInput(props) {
    _classCallCheck(this, NoteInput);

    var _this = _possibleConstructorReturn(this, (NoteInput.__proto__ || Object.getPrototypeOf(NoteInput)).call(this, props));

    _this.handleInputChange = function (input) {
      _this.setState({ input: input });
    };

    _this.onCancel = function () {
      _this.setState({ input: null });
    };

    _this.createNote = function () {
      if (!_this.canSubmit()) return;
      _this.context.app.queries.NoteQueries.createNoteForEndUserId(_this.props.endUser.id, { body: _this.state.input });
      _this.setState({ input: null });
    };

    _this.onEditorKeyDown = Object(__WEBPACK_IMPORTED_MODULE_4_components_customer_Inputs_makeCmdEnterHandler__["a" /* default */])(_this.createNote);

    _this.state = {};
    return _this;
  }

  _createClass(NoteInput, [{
    key: 'canSubmit',
    value: function canSubmit() {
      return Object(__WEBPACK_IMPORTED_MODULE_5_components_customer_Inputs_isMediumInputEmpty__["a" /* default */])(this.state.input);
    }
  }, {
    key: 'render',
    value: function render() {
      var canPost = this.canSubmit();
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { style: {
            borderRadius: "0 0 5px 5px",
            border: ThickGrayBorder,
            backgroundColor: "white"
          } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_InlineEditor__["a" /* InlineEditor */], {
          options: {
            placeholder: { text: 'start typing to leave a note...' },
            noImageDragging: true
          },
          onChange: this.handleInputChange,
          onKeyDown: this.onEditorKeyDown,
          style: {
            padding: 13,
            minHeight: 90
          },
          text: this.state.input
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            style: {
              borderTop: ThickGrayBorder,
              padding: '5px 12px'
            },
            className: 'flex-end'
          },
          canPost ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Cancel__["a" /* default */], { onClick: this.onCancel }) : null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            {
              style: {
                fontSize: 14,
                fontWeight: 600,
                transition: "color .3s",
                cursor: canPost ? 'pointer' : 'not-allowed',
                color: canPost ? __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default.a['color-blue'] : __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default.a['color-navy'],
                textTransform: 'uppercase'
              },
              onClick: this.createNote
            },
            'Post'
          )
        )
      );
    }
  }]);

  return NoteInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

NoteInput.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


var Option = {
  display: NoteDisplay,
  component: NoteInput
};

/* unused harmony default export */ var _unused_webpack_default_export = (NoteInput);

/***/ }),

/***/ "WJD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__ = __webpack_require__("qXGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var SavedReplyQueries = Marty.createQueries({
  id: 'SavedReplyQueries',

  fetchReplies: function fetchReplies() {
    var _this = this;

    var promise = this.app.sources.SavedReplyAPI.fetchReplies();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_LIST_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_LIST_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_LIST_FETCH_FAILED, error);
    });
  },
  fetchReply: function fetchReply(replyId) {
    var _this2 = this;

    var promise = this.app.sources.SavedReplyAPI.fetchReply(replyId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_FETCH_FAILED, replyId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_FETCH_FAILED, replyId, error);
    });
  },
  createReply: function createReply(reply) {
    var _this3 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].CREATE_REPLY_STARTING, reply);
    var promise = this.app.sources.SavedReplyAPI.createReply(reply);
    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].CREATE_REPLY_DONE, res.body);
        return _this3.app.actions.NotificationActions.pushNotification({
          content: res.body.name + ' has been saved!'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].CREATE_REPLY_FAILED, reply, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].CREATE_REPLY_FAILED, reply, error);
    });
  },
  updateReply: function updateReply(replyId, reply, notify) {
    var _this4 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].UPDATE_REPLY_STARTING, replyId, reply);
    var promise = this.app.sources.SavedReplyAPI.updateReply(replyId, reply);
    promise.then(function (res) {
      if (res.status === 200) {
        _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].UPDATE_REPLY_DONE, res.body);
        if (notify) {
          var finishedAction = void 0,
              variant = void 0;
          if (reply.status !== 'ARCHIVED') {
            finishedAction = 'updated';
            variant = 'green';
          } else {
            finishedAction = 'deleted';
            variant = 'green';
          }
          return _this4.app.actions.NotificationActions.pushNotification({
            content: res.body.name + ' has been ' + finishedAction + '!',
            variant: variant
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].UPDATE_REPLY_FAILED, replyId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].UPDATE_REPLY_FAILED, replyId, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SavedReplyQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "WJTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export segmentsByEndUserId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return segmentFetchedForEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return endUserSegments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__("2+Aq");




var root = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* root */], function (endUserRoot) {
  return endUserRoot.get('segments');
});
var segmentsByEndUserId = function segmentsByEndUserId(state) {
  return root(state).get('segmentsByEndUserId');
};

var segmentFetchedForEndUser = function segmentFetchedForEndUser(state, props) {
  return segmentsByEndUserId(state).has(props.endUser.id);
};
var endUserSegments = function endUserSegments(state, props) {
  return segmentsByEndUserId(state).get(props.endUser.id);
};

/***/ }),

/***/ "WN26":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 9 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.357 1.912H6.92L3.413 14.658H4.5a.64.64 0 0 1 .643.637.64.64 0 0 1-.643.637H.643A.64.64 0 0 1 0 15.295a.64.64 0 0 1 .643-.637H2.08L5.587 1.912H4.5a.64.64 0 0 1-.643-.638A.64.64 0 0 1 4.5.637h3.857A.64.64 0 0 1 9 1.274a.64.64 0 0 1-.643.638z\" fill=\"#425964\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "WTSp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_hubspot_actions__ = __webpack_require__("vCIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_hubspot_logo_svg__ = __webpack_require__("PLnn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_hubspot_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_hubspot_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style__ = __webpack_require__("kw6s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_hubspot_selectors__ = __webpack_require__("1eL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_message_selectors__ = __webpack_require__("bWf9");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var HubSpotSection = function (_Component) {
  _inherits(HubSpotSection, _Component);

  function HubSpotSection(props) {
    _classCallCheck(this, HubSpotSection);

    var _this = _possibleConstructorReturn(this, (HubSpotSection.__proto__ || Object.getPrototypeOf(HubSpotSection)).call(this, props));

    _this.enrichConversation = function () {
      var _this$props = _this.props,
          email = _this$props.email,
          actions = _this$props.actions;

      return actions.fetchHubSpotByEmail({ email: email });
    };

    _this.renderHubSpotInfo = function () {
      var data = _this.state.data;
      var contact = data.contact,
          opportunities = data.opportunities;
      var properties = contact.properties;

      var emptyValue = { 'value': null };
      var contactOwner = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(data, 'owner', null);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        opportunities && !!opportunities.length && _this.renderHubSpotOpportunityBar(),
        renderRow("Contact Owner", __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(contactOwner, 'name')),
        renderRow("Lifecycle Stage", __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(properties, 'lifecyclestage', emptyValue).value),
        renderRow("Lead Status", __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(properties, 'hs_lead_status', emptyValue).value),
        renderRow("HubSpot Score", __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(properties, 'hubspotscore', emptyValue).value),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(contact, 'profileUrl'), target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'view-in-hubspot-bar' },
            'View in HubSpot'
          )
        )
      );
    };

    _this.renderErrorState = function () {
      var error = _this.state.error;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        error.status === 404 ? "Couldn't find matching record in HubSpot" : "Error fetching data from HubSpot"
      );
    };

    _this.state = {
      loading: true,
      error: null,
      data: null
    };
    _this.enrichConversation();
    return _this;
  }

  _createClass(HubSpotSection, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hubSpotEnrichment = this.props.hubSpotEnrichment;

      if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default()(hubSpotEnrichment, nextProps.hubSpotEnrichment)) {
        this.setState({
          loading: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(nextProps.hubSpotEnrichment, "loading", false),
          error: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(nextProps.hubSpotEnrichment, "error", {}),
          data: __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(nextProps.hubSpotEnrichment, "data", {})
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(__WEBPACK_IMPORTED_MODULE_11__style__["conversationSection"], className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_hubspot_logo_svg___default.a, name: 'HUBSPOT_ICON', className: 'header-icon' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'section-title' },
            'HubSpot Details'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-body' },
          loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Loader"], null),
          !!__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(error, "status") && this.renderErrorState(),
          !loading && !__WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(error, "status") && this.renderHubSpotInfo()
        )
      );
    }
  }]);

  return HubSpotSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

HubSpotSection.props = {
  email: String
};

var renderRow = function renderRow(header, value) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'hubspot-enrichment-body-row' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'hubspot-enrichment-row-header' },
      header
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'hubspot-enrichment-row-body' },
      value ? value : "N/A"
    )
  );
};

var makeMapStateToProps = function makeMapStateToProps() {
  var firstEndUserMessageSelector = Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_message_selectors__["a" /* firstEndUserMessage */])();
  var getHubspotByEmail = Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_hubspot_selectors__["m" /* makeGetHubspotByEmail */])();

  return function (state, props) {
    var conversationId = props.conversationId,
        email = props.email;


    return {
      firstEndUserMessage: firstEndUserMessageSelector(state, { conversationId: conversationId }),
      hubSpotEnrichment: getHubspotByEmail(state, email)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchHubSpotByEmail: __WEBPACK_IMPORTED_MODULE_3_app_modules_hubspot_actions__["a" /* fetchHubSpotByEmail */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* branch */])(function (props) {
  return !!props.conversationId && !props.firstEndUserMessage;
}, __WEBPACK_IMPORTED_MODULE_4_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["e" /* mapProps */])(function (_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _extends({}, props);
}))(HubSpotSection));

/***/ }),

/***/ "WW4l":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "WX5J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPERATORS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__ = __webpack_require__("KOTG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MATCH = "matches";
var NOT_MATCH = "does not match";

var OPTIONS = [{ value: 'isMatch', text: MATCH }, { value: 'notIsMatch', text: NOT_MATCH }];

var OPERATORS = OPTIONS.map(function (_ref) {
  var value = _ref.value;
  return value;
});

var RegexInput = function (_Component) {
  _inherits(RegexInput, _Component);

  function RegexInput() {
    _classCallCheck(this, RegexInput);

    return _possibleConstructorReturn(this, (RegexInput.__proto__ || Object.getPrototypeOf(RegexInput)).apply(this, arguments));
  }

  _createClass(RegexInput, [{
    key: 'onAddRegex',
    value: function onAddRegex() {
      var strings = this.props.conditionValue.get('value');
      this.props.conditionUpdater('value', strings.push(""));
    }
  }, {
    key: 'makeOnRemove',
    value: function makeOnRemove(index) {
      var _this2 = this;

      return function () {
        var strings = _this2.props.conditionValue.get('value');
        _this2.props.conditionUpdater('value', strings.splice(index, 1));
      };
    }
  }, {
    key: 'makeRegexInputChange',
    value: function makeRegexInputChange(index) {
      var _this3 = this;

      return function (value) {
        var strings = _this3.props.conditionValue.get('value');
        _this3.props.conditionUpdater('value', strings.set(index, value));
      };
    }
  }, {
    key: 'renderAddButton',
    value: function renderAddButton() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["a" /* AddIcon */], {
        onClick: this.onAddRegex.bind(this)
      });
    }
  }, {
    key: 'renderRemoveIcon',
    value: function renderRemoveIcon(index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["c" /* RemoveIcon */], {
        onClick: this.makeOnRemove(index)
      });
    }
  }, {
    key: 'renderRegexInput',
    value: function renderRegexInput(value, index, placeholder) {
      var isRegexValid = true;
      try {
        new RegExp(value);
      } catch (e) {
        isRegexValid = false;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        valueLink: {
          requestChange: this.makeRegexInputChange(index),
          value: value
        },
        placeholder: placeholder,
        isValid: !!(value && isRegexValid)
      });
    }
  }, {
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      var conditionValue = this.props.conditionValue;

      return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var conditionValue = this.props.conditionValue;

      var strings = conditionValue.get('value');
      var selects = strings.map(function (stringToMatch, index, _ref2) {
        var size = _ref2.size;

        var actionButton = void 0;
        if (index === 0) {
          actionButton = _this4.renderAddButton();
        } else {
          actionButton = _this4.renderRemoveIcon(index);
        }
        var node = [_this4.renderRegexInput(stringToMatch, index, conditionValue.get('placeholder')), actionButton];
        if (index != size - 1) {
          node.push(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["b" /* OrNode */]);
        }
        return node;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-space-around flex-1 flex-wrap' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__["a" /* default */], {
          onSelection: this.onOperatorSelect.bind(this),
          options: OPTIONS,
          selectedValue: this.getSelectedValue()
        }),
        selects
      );
    }
  }]);

  return RegexInput;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (RegexInput);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "WZzu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Accordion":"Accordion---NqJRy"};

/***/ }),

/***/ "WdEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_account_selectors__ = __webpack_require__("nGBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_account_actions__ = __webpack_require__("j4fR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component__ = __webpack_require__("mxMN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_playbook_constants__ = __webpack_require__("st9j");


















var STATIC_SENDER = {
  label: 'Drift User',
  value: 'DRIFT_USER',
  type: __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].STATIC
};

var ACCOUNT_OWNER = {
  label: React.createElement(
    'div',
    null,
    'Account Owner  - ',
    React.createElement(
      'span',
      { className: 'email-sender-option-light-text' },
      '{{ account.ownerId }}'
    )
  ),
  value: 'ownerId',
  type: __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].DYNAMIC
};

var LAST_SALES_CONTACTED = {
  label: React.createElement(
    'div',
    null,
    'Last Sales Contact - ',
    React.createElement(
      'span',
      { className: 'email-sender-option-light-text' },
      '{{ user.engagedAgent }}'
    )
  ),
  value: 'engagedAgent',
  type: __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].DYNAMIC
};

var attribToSendTypeOption = function attribToSendTypeOption(attrib) {
  return {
    value: attrib.name,
    label: React.createElement(
      'div',
      null,
      attrib.label,
      ' - ',
      React.createElement(
        'span',
        { className: 'email-sender-option-light-text' },
        '{{ account.' + attrib.name + ' }}'
      )
    ),
    type: __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].DYNAMIC
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setSequenceSenderName: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_198" /* setSequenceSenderName */],
      setSequenceEmailOverride: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_193" /* setSequenceEmailOverride */],
      setSequenceDynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_191" /* setSequenceDynamicAccountSendAttribute */],
      setSequenceAuthorId: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_190" /* setSequenceAuthorId */],
      setSenderName: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_189" /* setSenderName */],
      setEmailOverride: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_165" /* setEmailOverride */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_138" /* setAuthorId */],
      setDynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_156" /* setDynamicAccountSendAttribute */],
      setSequenceDynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_192" /* setSequenceDynamicSenderFormat */],
      setDynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_157" /* setDynamicSenderFormat */],
      fetchAccountAttribs: __WEBPACK_IMPORTED_MODULE_11_app_modules_account_actions__["a" /* fetchAccountAttribs */],
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_9_app_modules_inbox_actions__["A" /* fetchInboxList */],
      hideEditSenderModal: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_81" /* hideEditSenderModal */],
      setSequenceIndividualSenderName: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_197" /* setSequenceIndividualSenderName */],
      setSequenceIndividualEmailOverride: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_196" /* setSequenceIndividualEmailOverride */],
      setSequenceIndividualDynamicAttr: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_194" /* setSequenceIndividualDynamicAttr */],
      setSequenceIndividualDynamicFormat: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_195" /* setSequenceIndividualDynamicFormat */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    emailMessage: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["w" /* emailMessage */](state),
    org: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["org"](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    currentUser: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["currentUser"](state),
    dynamicSenderTypes: __WEBPACK_IMPORTED_MODULE_6_app_modules_account_selectors__["c" /* teamMemberAttribs */](state),
    isSequence: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_7" /* getIsSequencePlaybook */](state),
    sequenceDynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_76" /* sequenceDynamicSendAttribute */](state),
    sequenceDynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_77" /* sequenceDynamicSenderFormat */](state),
    dynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["t" /* dynamicAccountSendAttribute */](state),
    dynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["u" /* dynamicSenderFormat */](state),
    senderEmailOverride: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_73" /* senderEmailOverride */](state),
    sendFromOverride: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_72" /* sendFromOverride */](state),
    sequenceSenderEmailOverride: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_80" /* sequenceSenderEmailOverride */](state),
    sequenceSendFromOverride: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_79" /* sequenceSendFromOverride */](state),
    sequenceAuthorId: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["_75" /* sequenceAuthorId */](state),
    authorId: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["e" /* authorId */](state),
    isInboxListLoading: __WEBPACK_IMPORTED_MODULE_10_app_modules_inbox_selectors__["h" /* isInboxListLoading */](state),
    isInboxListLoaded: __WEBPACK_IMPORTED_MODULE_10_app_modules_inbox_selectors__["g" /* isInboxListLoaded */](state),
    inboxes: __WEBPACK_IMPORTED_MODULE_10_app_modules_inbox_selectors__["f" /* inboxes */](state),
    editSenderLevel: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["P" /* getEditSenderLevel */](state),
    editingEmailId: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["Q" /* getEditSenderModalEditingEmailId */](state),
    emails: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_selectors__["y" /* emails */](state),
    hasDynamicAccountBasedSender: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_gates_selectors__["u" /* makeHasGate */])('ABM')(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        actions = _props.actions,
        isInboxListLoaded = _props.isInboxListLoaded,
        isInboxListLoading = _props.isInboxListLoading;

    if (!isInboxListLoaded && !isInboxListLoading) {
      actions.fetchInboxList();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var orgUsers = _ref.orgUsers,
      isInboxListLoaded = _ref.isInboxListLoaded;
  return !orgUsers.size || !isInboxListLoaded;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  var inboxEmailIsOverride = !!props.inboxes.find(function (inbox) {
    return inbox.get('address') === senderEmailOverride;
  });
  var senderEmailOverride = props.senderEmailOverride;
  var sendFromOverride = props.sendFromOverride;
  var authorId = props.authorId;
  var setSenderNameAction = props.actions.setSenderName;
  var setEmailOverrideAction = props.actions.setEmailOverride;
  var setDynamicAccountSendAttributeAction = props.actions.setDynamicAccountSendAttribute;
  var setDynamicSenderFormatAction = props.actions.setDynamicAccountSenderFormat;
  var dynamicAccountSendAttribute = props.dynamicAccountSendAttribute;
  var dynamicSenderFormat = props.dynamicSenderFormat;
  if (props.isSequence) {
    senderEmailOverride = props.sequenceSenderEmailOverride;
    sendFromOverride = props.sequenceSendFromOverride;
    authorId = props.sequenceAuthorId;
    setSenderNameAction = props.actions.setSequenceSenderName;
    setEmailOverrideAction = props.actions.setSequenceEmailOverride;
    setDynamicAccountSendAttributeAction = props.actions.setSequenceDynamicAccountSendAttribute;
    setDynamicSenderFormatAction = props.actions.setSequenceDynamicSenderFormat;
    dynamicAccountSendAttribute = props.sequenceDynamicAccountSendAttribute;
    dynamicSenderFormat = props.sequenceDynamicSenderFormat;

    if (props.editSenderLevel === __WEBPACK_IMPORTED_MODULE_14_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL) {
      var email = props.emails.get(props.editingEmailId);
      senderEmailOverride = email.get('senderEmailOverride');
      sendFromOverride = email.get('sendFromOverride');
      dynamicAccountSendAttribute = email.get('dynamicAccountSendAttribute');
      dynamicSenderFormat = email.get('dynamicSenderFormat');
      setSenderNameAction = function setSenderNameAction(name) {
        return props.actions.setSequenceIndividualSenderName({ data: name, emailId: props.editingEmailId });
      };
      setEmailOverrideAction = function setEmailOverrideAction(email) {
        return props.actions.setSequenceIndividualEmailOverride({ data: email, emailId: props.editingEmailId });
      };
      setDynamicAccountSendAttributeAction = function setDynamicAccountSendAttributeAction(attr) {
        return props.actions.setSequenceIndividualDynamicAttr({ data: attr, emailId: props.editingEmailId });
      };
      setDynamicSenderFormatAction = function setDynamicSenderFormatAction(format) {
        return props.actions.setSequenceIndividualDynamicFormat({ data: format, emailId: props.editingEmailId });
      };
    }
  }
  var selectedUserId = inboxEmailIsOverride ? senderEmailOverride : authorId;

  if (props.isSequence) {
    return {
      authorId: authorId,
      setSenderNameAction: setSenderNameAction,
      setEmailOverrideAction: setEmailOverrideAction,
      setDynamicAccountSendAttributeAction: setDynamicAccountSendAttributeAction,
      setDynamicSenderFormatAction: setDynamicSenderFormatAction,
      setAuthorIdAction: props.actions.setSequenceAuthorId,
      dynamicSenderFormat: dynamicSenderFormat,
      dynamicAccountSendAttribute: dynamicAccountSendAttribute,
      senderEmailOverride: senderEmailOverride,
      sendFromOverride: sendFromOverride,
      selectedUserId: selectedUserId,
      defaultUser: props.orgUsers.toJS().find(function (user) {
        return user.id === authorId || user.email === authorId;
      }) || props.orgUsers.first().toJS()
    };
  } else {
    return {
      authorId: authorId,
      setSenderNameAction: setSenderNameAction,
      setEmailOverrideAction: setEmailOverrideAction,
      setDynamicAccountSendAttributeAction: setDynamicAccountSendAttributeAction,
      setDynamicSenderFormatAction: setDynamicSenderFormatAction,
      setAuthorIdAction: props.actions.setAuthorId,
      dynamicSenderFormat: dynamicSenderFormat,
      dynamicAccountSendAttribute: dynamicAccountSendAttribute,
      senderEmailOverride: senderEmailOverride,
      sendFromOverride: sendFromOverride,
      selectedUserId: selectedUserId,
      defaultUser: props.orgUsers.toJS().find(function (user) {
        return user.id === authorId || user.email === authorId;
      }) || props.orgUsers.first().toJS()
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref2) {
  var orgUsers = _ref2.orgUsers;
  return !orgUsers.size;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (this.props.hasDynamicAccountBasedSender) {
      this.props.actions.fetchAccountAttribs();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedSenderType', 'setSelectedSenderType', function (props) {
  return !!props.dynamicAccountSendAttribute ? __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].DYNAMIC : __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].STATIC;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedSenderChoice', 'setSelectedSenderChoice', function (props) {
  return props.dynamicAccountSendAttribute || STATIC_SENDER.value;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('formatType', 'setFormatType', function (props) {
  return props.dynamicSenderFormat || __WEBPACK_IMPORTED_MODULE_13__component__["b" /* EmailFormatTypes */].FIRST_LAST;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('dynamicSendAttribute', 'setDynamicSendAttribute', function (props) {
  return props.dynamicAccountSendAttribute;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('staticSendName', 'setStaticSendName', function (props) {
  return props.sendFromOverride || _.get(props, 'emailMessage.sendFromOverride');
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('staticSendEmail', 'setStaticSendEmail', function (props) {
  return props.senderEmailOverride;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedAuthorId', 'setSelectedAuthorId', function (props) {
  return props.authorId;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedOption', 'setSelectedOption', function (props) {
  return props.senderEmailOverride;
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onSenderTypeSelect: function onSenderTypeSelect(props) {
    return function (_ref3) {
      var value = _ref3.value,
          type = _ref3.type;

      props.setSelectedSenderType(type);
      props.setSelectedSenderChoice(value);
      if (type === __WEBPACK_IMPORTED_MODULE_13__component__["c" /* EmailSenderTypes */].DYNAMIC) {
        props.setDynamicSendAttribute(value);
      } else {
        props.setDynamicSendAttribute(null);
      }
    };
  },
  onFormatSelect: function onFormatSelect(props) {
    return function (formatType) {
      props.setFormatType(formatType);
    };
  },
  onStaticSendNameChange: function onStaticSendNameChange(props) {
    return function (e) {
      props.setStaticSendName(e.target.value);
    };
  },
  hideModal: function hideModal(props) {
    return function () {
      props.actions.hideEditSenderModal();
    };
  },
  renderSelectedUser: function renderSelectedUser(props) {
    return function () {
      return React.createElement(
        'div',
        { className: 'Select-value' },
        React.createElement(
          'span',
          { className: 'Select-value-label' },
          props.staticSendEmail || props.defaultUser.email
        )
      );
    };
  },
  onUserIdChange: function onUserIdChange(props) {
    return function (option) {
      props.setSelectedOption(option);
      if (option.isInbox) {
        props.setSelectedAuthorId(props.currentUser.get('id', 0));
        props.setStaticSendEmail(option.value);
      } else {
        props.setSelectedAuthorId(option.value);
        var sendFromAuthor = props.orgUsers.find(function (user) {
          return user.id === option.value;
        });
        sendFromAuthor && props.setStaticSendEmail(sendFromAuthor.email);
      }
    };
  },
  onSave: function onSave(props) {
    return function () {
      props.setSenderNameAction(props.staticSendName);
      props.setEmailOverrideAction(props.staticSendEmail);
      props.setAuthorIdAction(props.selectedAuthorId);
      props.setDynamicAccountSendAttributeAction(props.dynamicSendAttribute);
      props.setDynamicSenderFormatAction(props.formatType);
      props.actions.hideEditSenderModal();
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    exampleUser: props.currentUser || props.orgUsers.first(),
    senderChoices: [STATIC_SENDER, LAST_SALES_CONTACTED].concat(props.hasDynamicAccountBasedSender ? [ACCOUNT_OWNER] : []).concat(props.dynamicSenderTypes.map(attribToSendTypeOption).toJS())
  };
}), __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default.a)(__WEBPACK_IMPORTED_MODULE_13__component__["a" /* EmailEditSenderModal */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "WhVc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(115);

/***/ }),

/***/ "WjK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_advancedRoutingOptIn_jpg__ = __webpack_require__("3DHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_advancedRoutingOptIn_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_advancedRoutingOptIn_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("Ret+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);






var AdvancedRoutingOptInModal = function AdvancedRoutingOptInModal(_ref) {
  var onClose = _ref.onClose,
      optIntoAdvancedRouting = _ref.optIntoAdvancedRouting;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Modal"],
    {
      onClose: onClose,
      open: true,
      size: 'medium',
      className: 'advanced-routing-opt-in-modal',
      title: 'What\'s new in routing'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'advanced-routing-opt-in-modal-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'advanced-routing-opt-in-modal-image-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'advanced-routing-opt-in-image', src: __WEBPACK_IMPORTED_MODULE_2_images_advancedRoutingOptIn_jpg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'advanced-routing-opt-in-info-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h2',
          null,
          'Introducing Advanced Routing'
        ),
        'Easily build out your routing rules with our new drag-and-drop visual builder, so you can connect the right site visitors with the right teammates in real-time!',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'advanced-routing-opt-in-modal-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
            { type: 'primary', onClick: optIntoAdvancedRouting },
            'Try it now!'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', onClick: onClose },
            'I\'ll try it later'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AdvancedRoutingOptInModal);

/***/ }),

/***/ "Wmkg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseCsvImport;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CsvImport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function parseCsvImport(data) {
  var columnNames = data.columnNames,
      sampleData = data.sampleData,
      rest = _objectWithoutProperties(data, ['columnNames', 'sampleData']);

  return CsvImport(_extends({
    columnNames: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(columnNames),
    sampleData: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(sampleData)
  }, rest));
}

var CsvImport = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  attributeMapping: undefined,
  columnNames: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  createdAt: undefined,
  id: undefined,
  orgId: undefined,
  sampleData: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  status: undefined,
  statusData: undefined
});

/***/ }),

/***/ "Wr1c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var CompanyConstants = Marty.createConstants(['COMPANY_FETCH', 'COMPANY_LIST_FETCH', 'COMPANY_UPDATE', 'SET_COMPANY_FROM_PUSHER']);

/* harmony default export */ __webpack_exports__["a"] = (CompanyConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "WrLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);








var mapStateToProps = function mapStateToProps(state) {
  return {
    assistantAgentSettings: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["a" /* assistantAgentSettings */])(state),
    fetchAssistantOrgSettingsPending: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["f" /* fetchAssistantOrgSettingsPending */])(state),
    editingAssistantAgentSettings: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["d" /* editingAssistantAgentSettings */])(state),
    assistantConfigHasEdits: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["b" /* assistantConfigHasEdits */])(state),
    personalizationTags: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["o" /* personalizationTags */])(state),
    sendTestEmailPending: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_assistantSettings_selectors__["t" /* sendTestEmailPending */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["i" /* fetchAssistantAgentSettings */],
      patchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["D" /* patchAssistantAgentSettings */],
      setInitial: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["P" /* setInitial */],
      onUpdate: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["A" /* onUpdate */],
      onCancel: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["z" /* onCancel */],
      sendTestEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["L" /* sendTestEmail */],
      fetchPersonalizationTags: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["q" /* fetchPersonalizationTags */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var actions = this.props.actions;

    actions.fetchAssistantAgentSettings();
    actions.fetchPersonalizationTags();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onSave: function onSave(_ref) {
    var actions = _ref.actions,
        editingAssistantAgentSettings = _ref.editingAssistantAgentSettings;
    return function () {
      return actions.patchAssistantAgentSettings({ settings: editingAssistantAgentSettings });
    };
  },
  onCancel: function onCancel(_ref2) {
    var actions = _ref2.actions,
        assistantAgentSettings = _ref2.assistantAgentSettings;
    return function () {
      return actions.onCancel(assistantAgentSettings);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref3) {
  var fetchAssistantOrgSettingsPending = _ref3.fetchAssistantOrgSettingsPending;
  return fetchAssistantOrgSettingsPending;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Loader"]))));

/***/ }),

/***/ "WsFt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("wwAV");













var mapStateToProps = function mapStateToProps(state) {
  var userListIds = __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_104" /* userListIds */](state);
  return {
    userListIds: userListIds,
    draft: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["n" /* draft */](state),
    reportType: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_67" /* reportType */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    draftFrequency: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["o" /* draftFrequency */](state),
    audience: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["d" /* audience */](state),
    numConditions: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_10" /* getNumConditions */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setDraftFrequency: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_149" /* setDraftFrequency */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_5_recompose_withState___default()('playbookFrequency', 'setPlaybookFrequency', function (props) {
  return props.draftFrequency || __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].ONCE;
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default()(function (props) {
  return {
    hasSegmentSelected: !!props.userListIds && props.userListIds.size > 0,
    isOnce: props.playbookFrequency === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].ONCE,
    isSession: props.playbookFrequency === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].SESSION,
    isAlways: props.playbookFrequency === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].ALWAYS
  };
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withHandlers___default()({
  handleSetFrequency: function handleSetFrequency(props) {
    return function (_ref) {
      var value = _ref.target.value;

      props.setPlaybookFrequency(value); // set locally for speedy UI...
      props.actions.setDraftFrequency(value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),

/***/ "WsvI":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31 22H1c-.553 0-1-.448-1-1V1c0-.552.447-1 1-1 .553 0 1 .448 1 1v19h29c.553 0 1 .448 1 1s-.447 1-1 1zM27 9c-.553 0-1-.448-1-1V6.328l-7.342 6.425c-.058.05-.127.08-.192.114-.036.02-.068.048-.105.063-.116.045-.237.07-.36.07-.133 0-.265-.03-.39-.082-.043-.02-.077-.054-.117-.078-.07-.04-.14-.074-.2-.133l-3.346-3.345L7.65 14.76c-.188.16-.42.24-.65.24-.28 0-.562-.118-.76-.35-.36-.418-.31-1.05.11-1.41l7-6c.04-.034.09-.048.136-.075.06-.037.114-.077.18-.1.057-.02.116-.025.177-.035.066-.01.13-.025.197-.022.062.002.12.02.182.035.063.015.126.024.186.05.06.028.11.072.166.112.044.03.094.05.133.088l3.338 3.34L24.482 5H23c-.553 0-1-.448-1-1s.447-1 1-1h4c.553 0 1 .448 1 1v4c0 .552-.447 1-1 1z\" fill=\"#9A9A9A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Wuyk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WwTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("ndOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DisconnectLink = function (_Component) {
  _inherits(DisconnectLink, _Component);

  function DisconnectLink() {
    _classCallCheck(this, DisconnectLink);

    return _possibleConstructorReturn(this, (DisconnectLink.__proto__ || Object.getPrototypeOf(DisconnectLink)).apply(this, arguments));
  }

  _createClass(DisconnectLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          serviceName = _props.serviceName,
          handleDisconnect = _props.handleDisconnect;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
        {
          className: 'flex ' + __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.IntegrationControl + ' ' + __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.IntegrationLink + ' ' + __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.DisconnectLink + ' \'tertiary',
          onClick: handleDisconnect },
        'Disconnect from ',
        serviceName
      );
    }
  }]);

  return DisconnectLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DisconnectLink);

/***/ }),

/***/ "WyPe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmployeeFilter__ = __webpack_require__("3vYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MoneyRaisedFilter__ = __webpack_require__("HH7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CompanyTagsFilter__ = __webpack_require__("SPbm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarketTagsFilter__ = __webpack_require__("aTxl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TechTagsFilter__ = __webpack_require__("a6mH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HeadquartersGeoFilter__ = __webpack_require__("5yt0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HeadquarterPostalCodeFilter__ = __webpack_require__("Qk83");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AnnualRevenueFilter__ = __webpack_require__("n41v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__InputFilter__ = __webpack_require__("J7dj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SelectFilter__ = __webpack_require__("ANGi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__NumericalValuesFilter__ = __webpack_require__("jq0a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Demandbase_DemandbaseAudienceFilter__ = __webpack_require__("DbKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Demandbase_DemandbaseIndustryFilter__ = __webpack_require__("imtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Demandbase_DemandbaseSubIndustryFilter__ = __webpack_require__("9uhU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_constants_DemandbaseEmployeeRanges__ = __webpack_require__("ZPDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_constants_DemandbaseRevenueRanges__ = __webpack_require__("bxiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var emptyFilter = {
  operator: null,
  value: null
};

var mapToOptions = function mapToOptions(values) {
  return !!values ? values.map(function (value) {
    return { label: value, value: value };
  }) : [];
};

var FirmographicFilter = function (_Component) {
  _inherits(FirmographicFilter, _Component);

  function FirmographicFilter(props) {
    _classCallCheck(this, FirmographicFilter);

    var _this = _possibleConstructorReturn(this, (FirmographicFilter.__proto__ || Object.getPrototypeOf(FirmographicFilter)).call(this, props));

    _this.onTypeSelect = function (type) {
      _this.props.updateModel(type.value);
      _this.setState({ fieldType: type.value, firmographicCondition: emptyFilter }, _this.updateParent);
    };

    _this.onUpdateCondition = function (updatedCondition) {
      _this.setState({ firmographicCondition: updatedCondition }, _this.updateParent);
    };

    _this.updateParent = function () {
      var isValid = _this.isValid();
      _this.props.setPageValidity(isValid);
      if (isValid) {
        _this.props.setActiveFilter({
          field: _this.state.fieldType,
          operator: _this.state.firmographicCondition.operator,
          value: _this.state.firmographicCondition.value
        });
      }
    };

    _this.renderTypeSelect = function () {
      var _this$props = _this.props,
          hasDemandbase = _this$props.hasDemandbase,
          hasClearbitReveal = _this$props.hasClearbitReveal;


      var types = [];

      if (hasClearbitReveal) {
        var clearbitOptions = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(Object.keys(__WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */]), function (key) {
          return __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */][key].includes('clearbit');
        });

        types = types.concat(clearbitOptions);
      }

      if (hasDemandbase) {
        var demandbaseOptions = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["filter"])(Object.keys(__WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */]), function (key) {
          return __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */][key].includes('demandbase');
        });

        types = types.concat(demandbaseOptions);
      }

      var typeOptions = Object.values(types).map(function (type) {
        return {
          value: __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */][type],
          label: __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["z" /* FIRMOGRAPHIC_FILTER_TYPE_LABELS */][type]
        };
      });

      var selectOptions = {
        multi: false,
        autoFocus: false,
        options: typeOptions,
        onChange: _this.onTypeSelect,
        clearable: false,
        searchable: false,
        value: _this.state.fieldType
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], selectOptions);
    };

    _this.state = {
      fieldType: props.activeFilter.field,
      firmographicCondition: emptyFilter
    };
    return _this;
  }

  _createClass(FirmographicFilter, [{
    key: 'isValid',
    value: function isValid() {
      return !!this.state.firmographicCondition.operator && !!this.state.firmographicCondition.value;
    }
  }, {
    key: 'renderTypeComponent',
    value: function renderTypeComponent() {
      var _components;

      var _CONSTANTS$FIRMOGRAPH = __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */],
          EMPLOYEES = _CONSTANTS$FIRMOGRAPH.EMPLOYEES,
          MONEY_RAISED = _CONSTANTS$FIRMOGRAPH.MONEY_RAISED,
          COMPANY_CATEGORIES = _CONSTANTS$FIRMOGRAPH.COMPANY_CATEGORIES,
          MARKET_CATEGORIES = _CONSTANTS$FIRMOGRAPH.MARKET_CATEGORIES,
          TECH_TAGS = _CONSTANTS$FIRMOGRAPH.TECH_TAGS,
          HEADQUARTERS_STATE = _CONSTANTS$FIRMOGRAPH.HEADQUARTERS_STATE,
          HEADQUARTERS_COUNTRY = _CONSTANTS$FIRMOGRAPH.HEADQUARTERS_COUNTRY,
          HEADQUARTERS_POSTAL_CODE = _CONSTANTS$FIRMOGRAPH.HEADQUARTERS_POSTAL_CODE,
          REVENUE = _CONSTANTS$FIRMOGRAPH.REVENUE,
          DEMANDBASE_AUDIENCE = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_AUDIENCE,
          DEMANDBASE_MARKETING_ALIAS = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_MARKETING_ALIAS,
          DEMANDBASE_INDUSTRY = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_INDUSTRY,
          DEMANDBASE_SUB_INDUSTRY = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_SUB_INDUSTRY,
          DEMANDBASE_EMPLOYEE_COUNT = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_EMPLOYEE_COUNT,
          DEMANDBASE_EMPLOYEE_RANGE = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_EMPLOYEE_RANGE,
          DEMANDBASE_ANNUAL_SALES = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_ANNUAL_SALES,
          DEMANDBASE_REVENUE_RANGE = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_REVENUE_RANGE,
          DEMANDBASE_HEADQUARTERS_CITY = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_HEADQUARTERS_CITY,
          DEMANDBASE_HEADQUARTERS_STATE = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_HEADQUARTERS_STATE,
          DEMANDBASE_HEADQUARTERS_COUNTRY = _CONSTANTS$FIRMOGRAPH.DEMANDBASE_HEADQUARTERS_COUNTRY;

      var components = (_components = {}, _defineProperty(_components, EMPLOYEES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__EmployeeFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, MONEY_RAISED, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MoneyRaisedFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, COMPANY_CATEGORIES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CompanyTagsFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, MARKET_CATEGORIES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MarketTagsFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, TECH_TAGS, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TechTagsFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HeadquartersGeoFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HeadquartersGeoFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, HEADQUARTERS_POSTAL_CODE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__HeadquarterPostalCodeFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, REVENUE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AnnualRevenueFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_AUDIENCE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Demandbase_DemandbaseAudienceFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_MARKETING_ALIAS, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__InputFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_INDUSTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Demandbase_DemandbaseIndustryFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_SUB_INDUSTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Demandbase_DemandbaseSubIndustryFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_REVENUE_RANGE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SelectFilter__["a" /* default */], _extends({ options: mapToOptions(__WEBPACK_IMPORTED_MODULE_21_constants_DemandbaseRevenueRanges__["a" /* default */]) }, this.props, { onUpdateCondition: this.onUpdateCondition, creatable: true }))), _defineProperty(_components, DEMANDBASE_EMPLOYEE_RANGE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__SelectFilter__["a" /* default */], _extends({ options: mapToOptions(__WEBPACK_IMPORTED_MODULE_20_constants_DemandbaseEmployeeRanges__["a" /* default */]) }, this.props, { onUpdateCondition: this.onUpdateCondition, creatable: true }))), _defineProperty(_components, DEMANDBASE_HEADQUARTERS_CITY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__InputFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_ANNUAL_SALES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NumericalValuesFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_EMPLOYEE_COUNT, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__NumericalValuesFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HeadquartersGeoFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _defineProperty(_components, DEMANDBASE_HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__HeadquartersGeoFilter__["a" /* default */], _extends({}, this.props, { onUpdateCondition: this.onUpdateCondition }))), _components);
      return components[this.state.fieldType];
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose a Firmographic'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Match enriched data about your visitors like industry, company size, time zone etc. '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-sidebar drift-form' },
            this.renderTypeSelect()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-editor-selection' },
            this.renderTypeComponent()
          )
        )
      );
    }
  }]);

  return FirmographicFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasDemandbase: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_selectors__["l" /* isConnectedTo */])(state, 'demandbase'),
    hasClearbitReveal: Object(__WEBPACK_IMPORTED_MODULE_22_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state).leadRoutingReveal
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null)(FirmographicFilter));

/***/ }),

/***/ "X/M4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ATTACHMENTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ATTACHMENTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ATTACHMENTS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPLOAD_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPLOAD_ATTACHMENT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPLOAD_ATTACHMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPLOAD_ATTACHMENT_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('message/attachment');

var FETCH_ATTACHMENTS = makeConstant('FETCH_ATTACHMENTS');
var FETCH_ATTACHMENTS_PENDING = makeConstant('FETCH_ATTACHMENTS_PENDING');
var FETCH_ATTACHMENTS_FAILED = makeConstant('FETCH_ATTACHMENTS_FAILED');
var FETCH_ATTACHMENTS_CANCELLED = makeConstant('FETCH_ATTACHMENTS_CANCELLED');
var RECEIVE_ATTACHMENTS = makeConstant('RECEIVE_ATTACHMENTS');

var UPLOAD_ATTACHMENT = makeConstant('UPLOAD_ATTACHMENT');
var UPLOAD_ATTACHMENT_PENDING = makeConstant('UPLOAD_ATTACHMENT_PENDING');
var UPLOAD_ATTACHMENT_FAILED = makeConstant('UPLOAD_ATTACHMENT_FAILED');
var UPLOAD_ATTACHMENT_SUCCESS = makeConstant('UPLOAD_ATTACHMENT_SUCCESS');

/***/ }),

/***/ "X2bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AgentStatusAvatar = function (_Component) {
  _inherits(AgentStatusAvatar, _Component);

  function AgentStatusAvatar() {
    _classCallCheck(this, AgentStatusAvatar);

    return _possibleConstructorReturn(this, (AgentStatusAvatar.__proto__ || Object.getPrototypeOf(AgentStatusAvatar)).apply(this, arguments));
  }

  _createClass(AgentStatusAvatar, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'drift-status-nav-icon', onClick: this.props.onClick },
        React.createElement(
          'div',
          { className: 'agent-status-avatar' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Avatar"], {
            withPresence: true,
            presenceState: this.props.agentStatus,
            withBorder: true,
            user: this.props.currentUser })
        )
      );
    }
  }]);

  return AgentStatusAvatar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AgentStatusAvatar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "X3Bt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("fi0M");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SingleParticipantAction = function (_PureComponent) {
  _inherits(SingleParticipantAction, _PureComponent);

  function SingleParticipantAction(props) {
    _classCallCheck(this, SingleParticipantAction);

    var _this = _possibleConstructorReturn(this, (SingleParticipantAction.__proto__ || Object.getPrototypeOf(SingleParticipantAction)).call(this, props));

    _this.renderSelectOption = function (_ref) {
      var value = _ref.value;
      var users = _this.props.users;

      var user = _this.props.users[value];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'choice-dropdown-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Avatar"], { user: user }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-value' },
          Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user)
        )
      );
    };

    _this.onParticipantSelected = function (selectedOption) {
      var _this$props = _this.props,
          setActionParticipants = _this$props.setActionParticipants,
          users = _this$props.users;


      _this.setState({ selectedParticipant: selectedOption }, function () {
        var participants = !!_this.state.selectedParticipant ? [_this.state.selectedParticipant.value] : [];
        setActionParticipants({ participants: participants, participantType: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* PARTICIPANT_TYPES */].SINGLE });
      });
    };

    _this.state = {
      selectedParticipant: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props.rule, 'data.item.action.options.userIds[0]', null)
    };
    return _this;
  }

  _createClass(SingleParticipantAction, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedParticipant = this.state.selectedParticipant;
      var setActionParticipants = this.props.setActionParticipants;


      if (!!selectedParticipant) {
        setActionParticipants({ participants: [selectedParticipant], participantType: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* PARTICIPANT_TYPES */].SINGLE });
      }
    }
  }, {
    key: 'getFormattedUsersOptions',
    value: function getFormattedUsersOptions() {
      return Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["toArray"])(this.props.users).map(function (user) {
        return { label: Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user), value: Number(user.id) };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'participant-action single-participant' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'participant-action-selector-description' },
          'Who do you want to add?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
          className: 'participant-single-select',
          autoFocus: true,
          options: this.getFormattedUsersOptions(),
          pageSize: 10,
          clearable: true,
          optionRenderer: this.renderSelectOption,
          valueRenderer: this.renderSelectOption,
          placeholder: 'Add a participant...',
          value: this.state.selectedParticipant,
          onChange: this.onParticipantSelected,
          size: 'large'
        })
      );
    }
  }]);

  return SingleParticipantAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (SingleParticipantAction);

/***/ }),

/***/ "X4Y0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_settings_Accordion__ = __webpack_require__("1mHf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_settings_ClickThroughAccordion__ = __webpack_require__("PkvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BulkMessageActions__ = __webpack_require__("hD25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_settings_inboxes_ManageInboxes__ = __webpack_require__("Ep/z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_settings_tags_ManageTags__ = __webpack_require__("DN+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_settings_Unsubscription__ = __webpack_require__("H6K0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_styl__ = __webpack_require__("pxbv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var ConversationsSettings = function (_Component) {
  _inherits(ConversationsSettings, _Component);

  function ConversationsSettings(props) {
    _classCallCheck(this, ConversationsSettings);

    var _this = _possibleConstructorReturn(this, (ConversationsSettings.__proto__ || Object.getPrototypeOf(ConversationsSettings)).call(this, props));

    _this.handleTagsToggle = function () {
      _this.setState({ tagsOpen: !_this.state.tagsOpen });
    };

    _this.handleUnsubscriptionsToggle = function () {
      _this.setState({ unsubscriptionsOpen: !_this.state.unsubscriptionsOpen });
    };

    _this.handleInboxesToggle = function () {
      _this.setState({ inboxesOpen: !_this.state.inboxesOpen });
    };

    _this.handleBulkCloseToggle = function () {
      _this.setState({ bulkCloseOpen: !_this.state.bulkCloseOpen });
    };

    _this.redirectToSavedReplies = function () {
      _this.context.router.push('/settings/replies');
    };

    _this.state = {
      tagsOpen: false,
      inboxesOpen: false,
      unsubscriptionsOpen: false
    };
    return _this;
  }

  _createClass(ConversationsSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchInboxList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          tagsOpen = _state.tagsOpen,
          inboxesOpen = _state.inboxesOpen,
          unsubscriptionsOpen = _state.unsubscriptionsOpen,
          bulkCloseOpen = _state.bulkCloseOpen;
      var _props = this.props,
          hasPremiumDrift = _props.hasPremiumDrift,
          _props$settingsAppCon = _props.settingsAppConfig,
          hasSavedReplies = _props$settingsAppCon.hasSavedReplies,
          hasTags = _props$settingsAppCon.hasTags,
          hasBulkClose = _props$settingsAppCon.hasBulkClose,
          hasEmailSendingDomains = _props$settingsAppCon.hasEmailSendingDomains,
          hasEmailPreferencesLink = _props$settingsAppCon.hasEmailPreferencesLink,
          hasInboxes = _props$settingsAppCon.hasInboxes,
          hasAdvanced = _props$settingsAppCon.hasAdvanced;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_19__style_styl___default.a.Conversations) },
        hasSavedReplies && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_settings_ClickThroughAccordion__["a" /* default */], {
          title: 'Saved replies',
          description: 'Manage your saved replies',
          redirectToUrl: '/settings/replies'
        }),
        hasTags && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_settings_Accordion__["a" /* default */],
          {
            title: 'Tags',
            description: 'Tags organize your inboxes and customer base',
            open: tagsOpen,
            onToggle: this.handleTagsToggle
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_settings_tags_ManageTags__["a" /* default */], null)
        ),
        hasEmailPreferencesLink && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_settings_Accordion__["a" /* default */],
          {
            title: 'Email preferences link',
            description: 'Copy a link for someone to manage what emails they get from your company',
            open: unsubscriptionsOpen,
            onToggle: this.handleUnsubscriptionsToggle
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_settings_Unsubscription__["a" /* default */], null)
        ),
        hasEmailSendingDomains && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_settings_ClickThroughAccordion__["a" /* default */], {
          title: 'Email sending domains',
          description: 'Manage the domains you use to send emails through Drift',
          redirectToUrl: '/settings/dkim'
        }),
        hasInboxes && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_settings_Accordion__["a" /* default */],
          {
            title: 'Inboxes',
            description: hasPremiumDrift ? 'Create multiple inboxes to organize your conversations' : 'Configure your inbox',
            open: inboxesOpen,
            onToggle: this.handleInboxesToggle
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_settings_inboxes_ManageInboxes__["a" /* default */], null)
        ),
        hasAdvanced && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_settings_ClickThroughAccordion__["a" /* default */], {
          title: 'Advanced',
          description: 'Customize advanced settings',
          redirectToUrl: '/settings/conversations/advanced'
        }),
        hasBulkClose && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_components_settings_Accordion__["a" /* default */],
          {
            title: 'Bulk close',
            description: 'Close all of the open conversations in an inbox.',
            open: bulkCloseOpen,
            onToggle: this.handleBulkCloseToggle
          },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__BulkMessageActions__["a" /* default */], null)
        )
      );
    }
  }]);

  return ConversationsSettings;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ConversationsSettings.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPremiumDrift: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["q" /* hasStarterPlan */](state),
    orgProperties: __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__["properties"](state),
    hasBetaBulkClose: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["d" /* hasBetaBulkClose */](state),
    inboxes: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_inbox_selectors__["f" /* inboxes */])(state),
    settingsAppConfig: Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_user_selectors__["settingsAppConfig"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchInboxList: __WEBPACK_IMPORTED_MODULE_8_app_modules_inbox_actions__["A" /* fetchInboxList */],
      patchOrgProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["patchOrgProperties"]
    }, dispatch)
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_16_app_modules_access_helpers__["a" /* ensureIsAdmin */])(ConversationsSettings)));

/***/ }),

/***/ "X5js":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Dropdown":"Dropdown---1USoa"};

/***/ }),

/***/ "XA3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TetheredToolTip = function (_Component) {
  _inherits(TetheredToolTip, _Component);

  function TetheredToolTip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TetheredToolTip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TetheredToolTip.__proto__ || Object.getPrototypeOf(TetheredToolTip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovering: false
    }, _this.toggleHover = function () {
      _this.setState({
        hovering: true
      });
    }, _this.toggleHoverOff = function () {
      _this.setState({
        hovering: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TetheredToolTip, [{
    key: 'render',
    value: function render() {
      var hovering = this.state.hovering;
      var _props = this.props,
          children = _props.children,
          component = _props.component,
          flow = _props.flow,
          _props$attachment = _props.attachment,
          attachment = _props$attachment === undefined ? 'middle left' : _props$attachment,
          className = _props.className,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onMouseOver: this.toggleHover,
          onMouseOut: this.toggleHoverOff
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_tether___default.a,
          {
            attachment: attachment,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}, className, !!className))
          },
          children,
          hovering && !disabled && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"], {
            flow: flow,
            open: true,
            component: component
          })
        )
      );
    }
  }]);

  return TetheredToolTip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TetheredToolTip);

/***/ }),

/***/ "XB2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_customer_Location_styl__ = __webpack_require__("x8mI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_customer_Location_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_customer_Location_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.








var Location = React.createClass({
  displayName: 'Location',

  propTypes: {
    locationString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  },

  render: function render() {
    return React.createElement(
      'div',
      { className: 'Location' },
      this.props.locationString ? [React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, {
        src: __webpack_require__("+xoY") }), this.props.locationString] : undefined
    );
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (Location);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "XBhg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("3n1Z");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var byId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["c" /* receiveAttachments */], function (state, action) {
  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_3_utils_immutable__["a" /* keyBy */])(action.payload));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* uploadAttachmentSuccess */], function (state, action) {
  var attachment = action.payload.attachment;

  return state.set(attachment.id, attachment);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var attachmentUploadStateById = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* uploadAttachmentPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* uploadAttachmentFailed */]), function (state, action) {
  var ticketId = action.payload.ticketId;

  return state.set(ticketId, action.type);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* uploadAttachmentSuccess */], function (state, action) {
  var _action$payload = action.payload,
      attachment = _action$payload.attachment,
      ticketId = _action$payload.ticketId;

  return state.set(ticketId, attachment);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  byId: byId,
  attachmentUploadStateById: attachmentUploadStateById
}));

/***/ }),

/***/ "XHia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubSpotInstaller */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var FIND_HUB_ID_LINK = "http://knowledge.hubspot.com/articles/kcs_article/account/where-can-i-find-my-hub-id";

var HUBSPOT_PAYLOAD = {
  client_id: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["y" /* HUBSPOT_CLIENT_ID */],
  redirect_uri: __WEBPACK_IMPORTED_MODULE_5_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/hubspot'
};

var RAW_PARAM_PAYLOAD = '&scope=contacts%20timeline%20forms%20content';

var HubSpotInstaller = function (_Component) {
  _inherits(HubSpotInstaller, _Component);

  function HubSpotInstaller() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HubSpotInstaller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HubSpotInstaller.__proto__ || Object.getPrototypeOf(HubSpotInstaller)).call.apply(_ref, [this].concat(args))), _this), _this.handleInjectionStateChange = function (event) {
      _this.app.queries.IntegrationsQueries.updateHubspotInjectionState(event.target.checked);
      _this.app.queries.IntegrationsQueries.fetchIntegrationStates();
    }, _this.renderEmbedToggle = function () {
      var hubspotInjectionState = _this.props.hubspotInjectionState;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-space-between', style: { paddingBottom: '1rem' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Toggle__["a" /* default */], {
          defaultChecked: hubspotInjectionState,
          id: 'hubspot-injection-state',
          onChange: _this.handleInjectionStateChange.bind(_this)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { style: { display: 'inline-block', paddingLeft: '1rem' } },
          'Add the Drift widget to my HubSpot hosted pages (COS, Landing Pages & Blog)'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HubSpotInstaller, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var integrationStates = _ref2.integrationStates,
          hubspotInjectionState = _ref2.hubspotInjectionState,
          orgProps = _ref2.orgProps;

      var currentIntegrationStates = this.props.integrationStates;
      var currentInjectionState = this.props.hubspotInjectionState;
      var orgActivated = this.props.orgProps.orgActivated;

      if (currentIntegrationStates['hubspot'] !== integrationStates['hubspot']) {
        this.setState({ updating: false });
      }

      if (currentInjectionState !== hubspotInjectionState) {
        this.app.actions.NotificationActions.pushNotification({ content: 'Your settings were successfully updated.' });
        if (hubspotInjectionState) {
          var _orgActivated = this.props.orgProps.orgActivated;

          if (!_orgActivated) {
            this.app.queries.OrgPropertiesQueries.updateProperties(this.props.org.id, { orgActivated: true });
          }
        }
      }
      if (orgActivated !== orgProps.orgActivated && orgProps.orgActivated) {
        this.app.actions.NotificationActions.pushNotification({
          content: 'Drift is successfully set up and ready to go!'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      var authLink = "https://app.hubspot.com/oauth/authorize";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Using HubSpot? Let\u2019s make this easy. Clicking connect below will automatically display the Drift chat on your website that you manage with HubSpot.'
        ),
        isConnected ? this.renderEmbedToggle() : null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_IntegrationConnector__["a" /* default */], {
          integrationId: 'hubspot',
          isOauth: true,
          oauthLink: authLink,
          oauthQueryParams: HUBSPOT_PAYLOAD,
          oauthRawParams: RAW_PARAM_PAYLOAD
        })
      );
    }
  }]);

  return HubSpotInstaller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var HubSpotInstallerContainer = Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(HubSpotInstaller, {
  listenTo: ['stores.IntegrationsStore'],
  fetch: {
    integrationStates: function integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates();
    },
    hubspotInjectionState: function hubspotInjectionState() {
      return this.app.stores.IntegrationsStore.fetchHubspotInjectionState();
    },
    orgProps: function orgProps() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    },
    org: function org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (HubSpotInstallerContainer);

/***/ }),

/***/ "XK6v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeaderBody":"HeaderBody---2AUBH"};

/***/ }),

/***/ "XLbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("ElC7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("G57K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("4iEJ");






function fetchEvents(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchTimelineEventsForEndUser */].toString()).pluck('payload').switchMap(function (_ref) {
    var endUserId = _ref.endUserId,
        size = _ref.size,
        filter = _ref.filter;

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetch(endUserId, { filter: filter, size: size }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchTimelineEventsForEndUserCancelled */].toString()).filter(function (action) {
      return action.payload.endUserId === endUserId;
    })).map(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchTimelineEventsForEndUserSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchTimelineEventsForEndUserPending */]({ endUserId: endUserId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchTimelineEventsForEndUserFailed */]({ endUserId: endUserId, error: error }));
    });
  });
}

function loadMoreEvents(action$, _ref2) {
  var getState = _ref2.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* loadMoreTimelineEventsForEndUser */].toString()).filter(function () {
    return __WEBPACK_IMPORTED_MODULE_4__selectors__["c" /* hasNext */](getState());
  }).pluck('payload').switchMap(function (_ref3) {
    var endUserId = _ref3.endUserId,
        size = _ref3.size,
        filter = _ref3.filter;

    var cursor = __WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* cursor */](getState());
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetch(endUserId, { filter: filter, size: size, after: cursor }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchTimelineEventsForEndUser */].toString(), __WEBPACK_IMPORTED_MODULE_3__actions__["g" /* loadMoreTimelineEventsForEndUserCancelled */].toString())).map(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* loadMoreTimelineEventsForEndUserSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* loadMoreTimelineEventsForEndUserPending */]({ endUserId: endUserId })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* loadMoreTimelineEventsForEndUserFailed */]({ endUserId: endUserId, error: error }));
    });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEvents, loadMoreEvents);

/***/ }),

/***/ "XLdb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguMTk3IDIxSDIuNjE3QzEuMTg3IDIxIC4wMiAxOS44MjIuMDIgMTguMzc1di04Ljc1YzAtLjAwNy4wMDMtLjAxNC4wMDUtLjAyLjAwMy0uMTMuMDM0LS4yNTUuMDkzLS4zNy4wMDItLjAxLjAwNC0uMDIuMDEtLjAzLjAxNy0uMDM0LjA1LS4wNTYuMDcyLS4wODhsLjAxOC0uMDJjLjAzLS4wNC4wNS0uMDg1LjA4Ni0uMTJMMy4xNCA2LjM3MmMuMzU0LS4zMjYuOS0uMyAxLjIyMi4wNTguMzIuMzU3LjI5Ni45MS0uMDYgMS4yMzZMMi4zNyA5LjQ0Nmw4LjAzNyA0LjQzMiA4LjA0LTQuNDMyLTEuOTItMS43NjRjLS4zNTQtLjMyNi0uMzgtLjg4LS4wNTgtMS4yMzcuMzItLjM1Ny44NjgtLjM4NCAxLjIyMi0uMDU4bDIuNzE3IDIuNWMuMzIuMTQ2LjU5LjQxMy41OS43Mzh2OC43NUMyMSAxOS44MjIgMTkuNjI4IDIxIDE4LjE5NyAyMXptMS4wNTMtMTAuMDA1bC04LjQzIDQuNjQ4Yy0uMTI3LjA3LS4yNy4xMDctLjQxMy4xMDctLjE0MyAwLS4yODUtLjAzNi0uNDE1LS4xMDdMMS43NTIgMTEuMXY3LjI3NWMwIC40ODIuMzg4Ljg3NS44NjUuODc1aDE1LjU4Yy40NzYgMCAxLjA1My0uMzkzIDEuMDUzLS44NzV2LTcuMzh6bS02Ljg1Mi0yLjI2OGMtLjUxMi0uMjA0LS44NjgtLjU4LTEuMDI4LTEuMDQ0LS4zLjEyLS42MjIuMTkyLS45NjMuMTkyLTEuNDMyIDAtMi41OTctMS4xNzgtMi41OTctMi42MjVzMS4xNjUtMi42MjUgMi41OTctMi42MjVjLjc4NiAwIDEuNDgyLjM2MiAxLjk2LjkyLjM2My4xMDUuNjM2LjQyOC42MzYuODN2Mi43NTJjLjA2Mi4wMjYuMzg3LjAzNy40NzgtLjA0Mi40MS0uNDQuMzk2LTEuMDQ1LjM4NC0xLjU4bC0uMDAzLS4yNTVjMC0xLjkzLTEuNTUtMy41LTMuNDU2LTMuNS0xLjkwOCAwLTMuNDYgMS41Ny0zLjQ2IDMuNXMxLjU1MiAzLjUgMy40NiAzLjVjLjQ3OCAwIC44NjUuMzkyLjg2NS44NzVzLS4zODguODc1LS44NjYuODc1Yy0yLjg2IDAtNS4xOS0yLjM1NS01LjE5LTUuMjVTNy41NDMgMCAxMC40MDQgMGMyLjg2IDAgNS4xODggMi4zNTUgNS4xODggNS4yNWwuMDAzLjIxNmMuMDE2LjY5NS4wNCAxLjg1OC0uODU2IDIuODItLjU0My41ODItMS41MjcuNzY4LTIuMzQyLjQ0em0tMS45OS00LjM1MmMtLjQ3OCAwLS44NjcuMzkzLS44NjcuODc1cy4zOS44NzUuODY3Ljg3NS44NjYtLjM5My44NjYtLjg3NS0uMzktLjg3NS0uODY2LS44NzV6IiBmaWxsPSIjNzY5NUE1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "XOYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__ = __webpack_require__("O04e");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var GateActions = Marty.createActionCreators({
  gatesUpdated: function gatesUpdated(gates) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_GateConstants__["a" /* default */].GATES_UPDATE_DONE, gates);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (GateActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "XPGI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AssistantConfigOrg":"AssistantConfigOrg---27H87"};

/***/ }),

/***/ "XQR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("T7bc");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });


/***/ }),

/***/ "XQet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TOTAL_AVATARS = 4;

var MappedUsers = function (_Component) {
  _inherits(MappedUsers, _Component);

  function MappedUsers() {
    _classCallCheck(this, MappedUsers);

    return _possibleConstructorReturn(this, (MappedUsers.__proto__ || Object.getPrototypeOf(MappedUsers)).apply(this, arguments));
  }

  _createClass(MappedUsers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchSFDCUserMappings();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var userIds = this.props.sfdcUserMappings.map(function (user) {
        return user.userId;
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        userIds.map(function (id, index) {
          if (index === _this2.props.max) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: id },
            '+ ',
            userIds.length - _this2.props.max,
            ' more'
          );
          if (index > _this2.props.max) return null;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Avatar__["a" /* default */], { key: id, user: _this2.props.users[id] });
        })
      );
    }
  }]);

  return MappedUsers;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MappedUsers);

/***/ }),

/***/ "XUE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__ = __webpack_require__("eUvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var PRESENCE_INTERVAL = 20000;
var FILTER_DEBOUNCE = 300;

var PresenceFiltersRow = function (_Component) {
  _inherits(PresenceFiltersRow, _Component);

  function PresenceFiltersRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PresenceFiltersRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PresenceFiltersRow.__proto__ || Object.getPrototypeOf(PresenceFiltersRow)).call.apply(_ref, [this].concat(args))), _this), _this.handleChangeNewFilters = function (filterName) {
      return function (e) {
        var q = e.target.value ? _defineProperty({}, filterName, e.target.value) : undefined;

        var _this$props$query = _this.props.query,
            _previousValue = _this$props$query[filterName],
            rest = _objectWithoutProperties(_this$props$query, [filterName]);

        _this.props.router.replace({
          pathname: window.location.pathname,
          query: _extends({}, rest, q),
          hash: window.location.hash
        });

        _this.props.actions.setNewFilters(_this.props.newFilters.set(filterName, e.target.value));
        _this.useNewFilters();
      };
    }, _this.useNewFilters = _.debounce(function () {
      _this.props.actions.cancelPresenceInterval();
      _this.props.actions.getPresenceStateOnInterval(PRESENCE_INTERVAL);
    }, FILTER_DEBOUNCE), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PresenceFiltersRow, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        this.props.tableColumns.map(function (_ref3) {
          var label = _ref3.label,
              filter = _ref3.filter,
              filterPlaceholder = _ref3.filterPlaceholder,
              filterProperty = _ref3.filterProperty;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { key: label + '-' + filterPlaceholder + '-' + filterProperty, className: 'pr-filter' },
            filter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Input"], {
              size: 'small',
              type: 'search',
              placeholder: filterPlaceholder,
              onChange: _this2.handleChangeNewFilters(filterProperty),
              value: _this2.props.newFilters.get(filterProperty)
            })
          );
        })
      );
    }
  }]);

  return PresenceFiltersRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    newFilters: __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__["d" /* selectors */].getNewFilters(state),
    query: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_router_selectors__["a" /* getQueryParams */])(state).toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setNewFilters: __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__["a" /* actions */].setNewFilters,
      getPresenceStateOnInterval: __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__["a" /* actions */].getPresenceStateOnInterval,
      cancelPresenceInterval: __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__["a" /* actions */].cancelPresenceInterval,
      bootstrapUser: __WEBPACK_IMPORTED_MODULE_4_app_modules_presence__["a" /* actions */].bootstrapUser
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["h" /* withRouter */])(PresenceFiltersRow)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "XUxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("8tbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("hJjc");







function uploadCsv(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["i" /* uploadCsv */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref) {
    var file = _ref.file;
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].upload(file).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["j" /* uploadCsvCancelled */].toString())).map(__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* uploadCsvSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_5__actions__["l" /* uploadCsvPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "An error occurred", //TODO: fix error message
        variant: "red",
        sticky: true
      });

      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_5__actions__["k" /* uploadCsvFailed */]({ error: error }));
    });
  });
}

function startImport(action$, query) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* startCsvImport */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref2) {
    var id = _ref2.id,
        mapping = _ref2.mapping,
        createSegment = _ref2.createSegment,
        csvName = _ref2.csvName;
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].start(id, mapping, createSegment, csvName).map(function () {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({ content: "Your CSV import is in progress..." });

      return __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* startCsvImportSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* startCsvImportPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "An error occurred", //TODO: fix error message
        variant: "red",
        sticky: true
      });

      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* startCsvImportFailed */]({ error: error }));
    });
  });
}

function importStartedRedirect(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* startCsvImportPending */].toString()).mapTo(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["push"])('/users'));
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(uploadCsv, startImport, importStartedRedirect);

/***/ }),

/***/ "XWnB":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 28 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.67 25.67H2.33C1.05 25.67 0 24.62 0 23.33v-21C0 1.05 1.05 0 2.33 0h23.34C26.95 0 28 1.05 28 2.33v21c0 1.3-1.05 2.34-2.33 2.34zM2 23.75h24.33V6.25H2v17.5zM2 1.5v3h24.33v-3H2zm11.64 12.32l-.27 1.86h1.46l.26-1.86h-1.46zm-1.9 3.2H10.5V15.7h1.42l.27-1.86h-1.25v-1.35h1.42l.42-2.97h1.44l-.42 2.97h1.46l.4-2.97h1.46l-.4 2.97h1.1v1.35h-1.3l-.25 1.86h1.1v1.35h-1.3L15.67 20h-1.45l.4-2.97H13.2L12.78 20h-1.46l.42-2.97z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Xajo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(527);

/***/ }),

/***/ "Xbg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("4PhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var AddButton = function AddButton(_ref) {
  var addButtonLabel = _ref.addButtonLabel,
      className = _ref.className,
      type = _ref.type,
      onClick = _ref.onClick,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
    { className: className, type: type, size: 'medium', onClick: onClick, loading: isProcessing, disabled: disabled },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
      className: 'plus-icon',
      width: 15,
      height: 10,
      stroke: true,
      name: 'plus'
    }),
    addButtonLabel
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AddButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Xe1X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ClickableOpacity":"ClickableOpacity---2RPC7","OAuthConnect":"OAuthConnect---2-XJI"};

/***/ }),

/***/ "XfFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Org; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Org = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  handle: "",
  name: "",
  createdAt: null,
  status: null,
  properties: null
});

/***/ }),

/***/ "XhSY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("eVe+");











var mapStateToProps = function mapStateToProps(state) {
  return {
    slug: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_97" /* slug */](state),
    driftLinkOnly: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_35" /* isDriftLinkOnly */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setSlug: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_210" /* setSlug */],
      setMetaAttribute: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_182" /* setMetaAttribute */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default()('driftLinkToggleStatus', 'setDriftLinkToggleStatus', function (props) {
  return props.driftLinkOnly;
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  toggleDriftLinkOnly: function toggleDriftLinkOnly(props) {
    return function () {
      var driftLinkToggleStatus = props.driftLinkToggleStatus,
          setDriftLinkToggleStatus = props.setDriftLinkToggleStatus,
          setMetaAttribute = props.actions.setMetaAttribute;


      if (!driftLinkToggleStatus) {
        setMetaAttribute({ driftLinkOnly: true });
      } else {
        setMetaAttribute({ driftLinkOnly: false });
      }
      setDriftLinkToggleStatus(!driftLinkToggleStatus);
    };
  },
  onSlugChange: function onSlugChange(props) {
    return function (event) {
      var setSlug = props.actions.setSlug;

      setSlug(event.target.value.slice(1));
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "Xl8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPresenceUserIds;
/* unused harmony export flattenMetas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_UserTypes__ = __webpack_require__("p1Ml");



function getPresenceUserIds(user) {
  var typeNumeral = __WEBPACK_IMPORTED_MODULE_1_utils_UserTypes__["a" /* UserTypeNumeral */][user.type];
  if (user.type === 'LEAD') {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([user.orgId + '-anon:' + user.primaryIdentity + '-' + typeNumeral, user.orgId + '-' + user.id + '-' + typeNumeral]);
  } else {
    return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(user.orgId + '-' + user.id + '-' + typeNumeral);
  }
}

function flattenMetas(result, _ref, userId) {
  var metas = _ref.metas;

  result[userId] = metas.map(function (meta) {
    return { type: "join", meta: meta };
  });
  return result;
}

/***/ }),

/***/ "XmC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAGE_TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HELP_CENTER_HELPDOC_URL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Access__ = __webpack_require__("6k1g");


var routingTitle = !__WEBPACK_IMPORTED_MODULE_0_utils_Access__["c" /* default */].hasNonBlacklistedGate('rules_routing') ? 'Conversation Routing' : 'Basic Conversation Routing';

var PAGE_TITLES = [{ path: '/settings/notifications', title: 'Notifications' }, { path: '/settings2/profile', title: 'Drift Profile' }, { path: '/settings/email', title: 'Email' }, { path: '/settings/assistant', title: 'Drift Assistant' }, { path: '/settings2/assistant', title: 'Drift Assistant' }, { path: '/settings2/conversations', title: 'Conversations' }, { path: '/settings/rules', title: routingTitle }, { path: '/settings2/teams', title: 'Teams' }];

var HELP_CENTER_HELPDOC_URL = 'http://help.drift.com';

/***/ }),

/***/ "XmeL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var SLACK_TEAM_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  FETCH_SLACK_TEAM_STARTED: null,
  FETCH_SLACK_TEAM_FINISHED: null,
  FETCH_SLACK_TEAM_FAILED: null,

  INVITE_SLACK_USER_STARTED: null,
  INVITE_SLACK_USER_FINISHED: null,
  INVITE_SLACK_USER_FAILED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default()(SLACK_TEAM_CONSTANTS, _.uniqueId));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "XmtY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export companyDataByIp */
/* unused harmony export endUserCompanyData */
/* unused harmony export enrichmentByConversationId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyData; });
/* unused harmony export getIsICP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCompanyDataLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isCompanyDataLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return companyDataJS; });
/* unused harmony export endUserCompanyDataJS */
/* unused harmony export decodedConditions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeHasRequestedDecodedCondition; });
/* unused harmony export getDecodedConditionStatus */
/* unused harmony export getDecodedCondition */
/* unused harmony export hasMinimumRevealDataForClearbitTrialOffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("hWD1");



var root = function root(state) {
  return state.get('enrichment');
};
var status = function status(state) {
  return root(state).status;
};
var companyDataStatus = function companyDataStatus(state, props) {
  return status(state).get(props.ip + '-' + props.email);
};
var isDataLoaded = function isDataLoaded(status) {
  return status === __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_ENRICHED_COMPANY_DATA_SUCCESS */] || status === __WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_ENRICHED_COMPANY_DATA_NO_RESULT */] || status === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_ENRICHED_COMPANY_DATA_FAILED */];
};
var isDataLoading = function isDataLoading(status) {
  return status === __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_ENRICHED_COMPANY_DATA */] || status === __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_ENRICHED_COMPANY_DATA_PENDING */];
};
var eligibleDataForClearbitTrial = [['name', 'domain'], 'linkedInHandle', 'description', 'employeeCount', 'moneyRaised', 'marketCap', 'industry', 'tags'];
var eligibiltyCheck = function eligibiltyCheck(conditions, source) {
  conditions.map(function (condition) {
    if (Array.isArray(condition)) {
      return _.compact(eligibiltyCheck(condition, source));
    }
    return source.contains(condition);
  });
};

var companyDataByIp = function companyDataByIp(state, props) {
  return root(state).company.get(props.ip);
};

var endUserCompanyData = function endUserCompanyData(state, props) {
  return root(state).companyByEndUserId.get(props.endUserId);
};

var enrichmentByConversationId = function enrichmentByConversationId(state, props) {
  var enrichmentSourceId = root(state).enrichmentSourcesByConversationId.get('' + props.conversationId);
  return root(state).company.get('' + enrichmentSourceId);
};

var companyData = function companyData(state, props) {
  return root(state).company.get(props.ip + '-' + props.email);
};

var getIsICP = function getIsICP(state, props) {
  var data = companyData(state, props);
  if (!data) {
    return false;
  }
  var employeeCountCondition = data.get('employeeCount') >= 150;
  var marketoCondition = data.get('tech').includes('marketo');
  var salesforceCondition = data.get('tech').includes('salesforce');
  return employeeCountCondition && marketoCondition && salesforceCondition;
};

var isCompanyDataLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([companyDataStatus], function (status) {
  return isDataLoaded(status);
});

var isCompanyDataLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([companyDataStatus], function (status) {
  return isDataLoading(status);
});

var companyDataJS = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([companyData], function (data) {
  if (!data) {
    return null;
  }
  return data.toJS();
});

var endUserCompanyDataJS = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([endUserCompanyData], function (data) {
  if (!data) {
    return null;
  }
  return data.toJS();
});

var decodedConditions = function decodedConditions(state) {
  return root(state).decodedConditions;
};
var makeHasRequestedDecodedCondition = function makeHasRequestedDecodedCondition(state) {
  return function (condition) {
    return decodedConditions(state).has(condition);
  };
};
var getDecodedConditionRoot = function getDecodedConditionRoot(state, condition) {
  return decodedConditions(state).get(condition);
};
var getDecodedConditionStatus = function getDecodedConditionStatus(state, condition) {
  return getDecodedConditionRoot(state, condition).get('status');
};
var getDecodedCondition = function getDecodedCondition(state, condition) {
  return getDecodedConditionRoot(state, condition).get('data');
};

var hasMinimumRevealDataForClearbitTrialOffer = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(companyDataByIp, function (data) {
  if (!data) {
    return false;
  }
  return _.compact(eligibiltyCheck(eligibleDataForClearbitTrial, data)).length >= 5;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "XsVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("qdP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DEFAULT_LABEL = "Don't set type";
var UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.';
var DEFAULT_OPTION = { id: null, name: DEFAULT_LABEL };

var taskToSelectOption = function taskToSelectOption(name) {
  return {
    id: name,
    name: name
  };
};

var SalesforceCampaignMapping = function (_Component) {
  _inherits(SalesforceCampaignMapping, _Component);

  function SalesforceCampaignMapping(props) {
    _classCallCheck(this, SalesforceCampaignMapping);

    var _this = _possibleConstructorReturn(this, (SalesforceCampaignMapping.__proto__ || Object.getPrototypeOf(SalesforceCampaignMapping)).call(this, props));

    _this.getInitialValue = function () {
      var promises = [__WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceTaskTypeList(), __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceTaskType()];

      var onDone = function onDone(_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            taskTypes = _ref2[0],
            taskType = _ref2[1];

        _this.setState({
          isLoading: false,
          selectOptions: taskTypes.map(taskToSelectOption),
          selectValue: taskType
        });
      };

      Promise.all(promises).then(onDone).catch(_this.handleUnknownError);
    };

    _this.handleUnknownError = function () {
      _this.setState({
        isLoading: false,
        hasError: true,
        errorText: UNKNOWN_ERROR
      });
    };

    _this.onChange = function (_ref3) {
      var id = _ref3.id,
          name = _ref3.name;

      var onDone = function onDone() {
        _this.setState({ isLoading: false });
      };

      var patch = __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].patchSalesforceTaskType({ taskType: id }).then(onDone).catch(_this.handleUnknownError);

      _this.setState({
        selectValue: id,
        selectLabel: name,
        isLoading: true
      }, patch);
    };

    _this.resolveSelectOptions = function () {
      var selectOptions = _this.state.selectOptions;

      return [DEFAULT_OPTION].concat(_toConsumableArray(selectOptions));
    };

    _this.state = {
      isLoading: true,
      hasError: false,
      selectValue: null,
      selectLabel: null,
      selectOptions: []
    };
    return _this;
  }

  _createClass(SalesforceCampaignMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInitialValue();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectValue = _state.selectValue,
          selectLabel = _state.selectLabel,
          isLoading = _state.isLoading;

      var options = this.resolveSelectOptions();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-activity-select-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'advanced-integration-toggle-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            'Map conversations to a Salesforce Activity Type'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Every new conversation in Drift can be associated with a Salesforce Activity Type.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'salesforce-activity-select-input',
          labelKey: 'name',
          valueKey: 'id',
          autosize: false,
          clearable: false,
          placeholder: DEFAULT_LABEL,
          value: selectValue,
          label: selectLabel,
          options: options,
          isLoading: isLoading,
          onChange: this.onChange,
          resetValue: DEFAULT_OPTION
        }),
        this.state.hasError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'salesforce-task-error-text' },
          this.state.errorText
        )
      );
    }
  }]);

  return SalesforceCampaignMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceCampaignMapping);

/***/ }),

/***/ "Xy+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var closeSRC = __webpack_require__("+Juk");

var ParticipantActionComponent = function (_Component) {
  _inherits(ParticipantActionComponent, _Component);

  function ParticipantActionComponent(props) {
    _classCallCheck(this, ParticipantActionComponent);

    var _this = _possibleConstructorReturn(this, (ParticipantActionComponent.__proto__ || Object.getPrototypeOf(ParticipantActionComponent)).call(this, props));

    _this.updateParent = function () {
      var isValidAction = _this.state.addType && _this.state.selectedParticipants.length;
      _this.props.setPageValidity(!!isValidAction);
      if (isValidAction) {
        _this.props.updateAction({
          type: __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["a" /* ACTION_TYPES */].PARTICIPANT,
          options: {
            isAccountOwner: true,
            addType: _this.state.addType,
            userIds: _this.state.selectedParticipants
          }
        });
      }
    };

    _this.saveParticipant = function (values) {
      _this.setState(function (prevState) {
        var newOptions = prevState.selectedParticipants.slice(0);
        var onlyValues = values.map(function (option) {
          return option.value;
        });
        newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
        newOptions.sort();

        return {
          selectedParticipants: newOptions.map(Number)
        };
      }, _this.updateParent);
    };

    _this.removeParticipant = function (value) {
      _this.setState(function (prevState) {
        var shouldSetAddOne = prevState.selectedParticipants.length <= 2 ? __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE : prevState.addType;

        return {
          addType: shouldSetAddOne,
          selectedParticipants: _.without(prevState.selectedParticipants, value).map(Number)
        };
      }, _this.updateParent);
    };

    _this.addOne = function () {
      _this.setState({ addType: __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE }, _this.updateParent);
    };

    _this.addAll = function () {
      _this.setState({ addType: __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ALL }, _this.updateParent);
    };

    _this.renderSelectOption = function (_ref) {
      var value = _ref.value;

      var nameOrEmail = _this.props.users[value].name ? _this.props.users[value].name : _this.props.users[value].email;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'choice-dropdown-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { user: _this.props.users[value] }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-value' },
          nameOrEmail
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'choice-option-add' },
          '+Add'
        )
      );
    };

    _this.state = {
      selectedParticipants: props.rule.data.item.action.options.userIds.map(Number),
      addType: props.rule.data.item.action.options.addType
    };
    return _this;
  }

  _createClass(ParticipantActionComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateParent();
    }
  }, {
    key: 'getFormattedUsersOptions',
    value: function getFormattedUsersOptions() {
      var _ref2,
          _this2 = this;

      var userIds = Object.keys(this.props.users).map(Number);
      var archivedUserIds = Object.values(this.props.users).filter(function (user) {
        return user.status === 'ARCHIVED';
      }).map(function (user) {
        return user.id;
      }).map(Number);
      var unusedParticipants = (_ref2 = _).without.apply(_ref2, [userIds].concat(_toConsumableArray(this.state.selectedParticipants), _toConsumableArray(archivedUserIds)));
      return unusedParticipants.map(function (user) {
        var nameOrEmail = _this2.props.users[user].name ? _this2.props.users[user].name : _this2.props.users[user].email;
        return { label: nameOrEmail, value: Number(user) };
      });
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var selectOptions = {
        multi: true,
        autoFocus: true,
        options: this.getFormattedUsersOptions(),
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        onChange: this.saveParticipant,
        placeholder: 'Add a participant...'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderParticipantSelectionList',
    value: function renderParticipantSelectionList() {
      var _this3 = this;

      var activeParticipantIds = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["intersection"])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["keys"])(this.props.users).map(Number), this.state.selectedParticipants);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { style: { height: activeParticipantIds.length * 75 / 2 + 75 + 'px' } },
        activeParticipantIds.map(function (userId, index) {
          var userById = _this3.props.users[userId.toString()];
          var nameOrEmail = userById.name ? userById.name : userById.email;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: userId + '-' + index, className: 'participants-list-item' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Avatar__["a" /* default */], { user: userById }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              nameOrEmail
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
                return _this3.removeParticipant(userId);
              } })
          );
        })
      );
    }
  }, {
    key: 'renderOwnerTypeSelect',
    value: function renderOwnerTypeSelect() {
      var _addTypeCopy,
          _this4 = this;

      var oneSelected = this.state.addType === __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE ? 'selected' : '';
      var allSelected = this.state.addType === __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ALL ? 'selected' : '';
      var addTypeCopy = (_addTypeCopy = {}, _defineProperty(_addTypeCopy, __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE, "One participant will be added on a rotating basis"), _defineProperty(_addTypeCopy, __WEBPACK_IMPORTED_MODULE_5_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ALL, "All participants will be added to the conversation"), _addTypeCopy);

      var pillSet = function pillSet() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'fieldset',
          { className: 'drift-pill-set' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button large ' + oneSelected, onClick: _this4.addOne },
            'Add One'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'drift-button large ' + allSelected, onClick: _this4.addAll },
            'Add All'
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.selectedParticipants.length >= 2 && pillSet(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'participant-rotation-helper' },
          addTypeCopy[this.state.addType]
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose participants to add'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Select which teammate(s) you want to add to a conversation as a participant.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-sidebar drift-form' },
            this.renderOwnerTypeSelect()
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'drift-form rules-editor-selection' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'rules-choice-options' },
              this.renderSearchBar()
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'rules-choice-selection' },
              this.renderParticipantSelectionList()
            )
          )
        )
      );
    }
  }]);

  return ParticipantActionComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ParticipantActionComponent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "XydC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Icon":"Icon---1aXVd","DismissIcon":"DismissIcon---1Nkjr"};

/***/ }),

/***/ "Y4lW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_INBOX_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_INBOX_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_INBOX_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return RECEIVE_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BULK_CLOSE_FOR_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BULK_CLOSE_FOR_INBOX_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BULK_CLOSE_FOR_INBOX_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_INBOX_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_INBOX_LIST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_INBOX_LIST_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_INBOX_LIST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return RECEIVE_INBOX_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_COUNTS_FOR_INBOX_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_COUNTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_COUNTS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_COUNTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return RECEIVE_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return RECEIVE_COUNTS_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CHANGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BULK_CHANGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CHANGE_PARTICIPANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return INBOX_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return INBOX_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return INBOX_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_WHITELABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return FETCH_WHITELABEL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return FETCH_WHITELABEL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FETCH_WHITELABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCH_WHITELABEL_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_INBOX_BEFORE_WHITELABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CREATE_WHITELABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CREATE_WHITELABEL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CREATE_WHITELABEL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CREATE_WHITELABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CREATE_WHITELABEL_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return VERIFY_WHITELABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return VERIFY_WHITELABEL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return VERIFY_WHITELABEL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return VERIFY_WHITELABEL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return VERIFY_WHITELABEL_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return OPEN_WHITELABEL_DKIM_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLOSE_WHITELABEL_DKIM_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CREATE_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CREATE_INBOX_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CREATE_INBOX_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CREATE_INBOX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CREATE_INBOX_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FETCH_SENDING_DOMAINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCH_SENDING_DOMAINS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PATCH_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PATCH_INBOX_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PATCH_INBOX_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return PATCH_INBOX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARCHIVE_INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ARCHIVE_INBOX_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ARCHIVE_INBOX_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ARCHIVE_INBOX_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('inbox');

var FETCH_INBOX = makeConstant('FETCH_INBOX');
var FETCH_INBOX_PENDING = makeConstant('FETCH_INBOX_PENDING');
var FETCH_INBOX_CANCELLED = makeConstant('FETCH_INBOX_CANCELLED');
var FETCH_INBOX_FAILED = makeConstant('FETCH_INBOX_FAILED');
var RECEIVE_INBOX = makeConstant('RECEIVE_INBOX');

var BULK_CLOSE_FOR_INBOX = makeConstant('BULK_CLOSE_FOR_INBOX');
var BULK_CLOSE_FOR_INBOX_REQUESTED = makeConstant('BULK_CLOSE_FOR_INBOX_REQUESTED');
var BULK_CLOSE_FOR_INBOX_FAILED = makeConstant('BULK_CLOSE_FOR_INBOX_FAILED');

var FETCH_INBOX_LIST = makeConstant('FETCH_INBOX_LIST');
var FETCH_INBOX_LIST_PENDING = makeConstant('FETCH_INBOX_LIST_PENDING');
var FETCH_INBOX_LIST_CANCELLED = makeConstant('FETCH_INBOX_LIST_CANCELLED');
var FETCH_INBOX_LIST_FAILED = makeConstant('FETCH_INBOX_LIST_FAILED');
var RECEIVE_INBOX_LIST = makeConstant('RECEIVE_INBOX_LIST');

var FETCH_COUNTS_FOR_INBOX_IDS = makeConstant('FETCH_COUNTS_FOR_INBOX_IDS');
var FETCH_COUNTS = makeConstant('FETCH_COUNTS');
var FETCH_COUNTS_PENDING = makeConstant('FETCH_COUNTS_PENDING');
var FETCH_COUNTS_CANCELLED = makeConstant('FETCH_COUNTS_CANCELLED');
var FETCH_COUNTS_FAILED = makeConstant('FETCH_COUNTS_FAILED');
var RECEIVE_COUNTS = makeConstant('RECEIVE_COUNTS');
var RECEIVE_COUNTS_2 = makeConstant('RECEIVE_COUNTS_2');
var CHANGE_STATUS = makeConstant('CHANGE_STATUS');
var BULK_CHANGE_STATUS = makeConstant('BULK_CHANGE_STATUS');
var CHANGE_PARTICIPANTS = makeConstant('CHANGE_PARTICIPANTS');

var INBOX_REDIRECT = makeConstant('INBOX_REDIRECT');

var INBOX_CHANGED = makeConstant('INBOX_CHANGED');
var INBOX_REGEX = /inboxes\/?(\d+)?/;

var FETCH_WHITELABEL = makeConstant('FETCH_WHITELABEL');
var FETCH_WHITELABEL_PENDING = makeConstant('FETCH_WHITELABEL_PENDING');
var FETCH_WHITELABEL_FAILED = makeConstant('FETCH_WHITELABEL_FAILED');
var FETCH_WHITELABEL_SUCCESS = makeConstant('FETCH_WHITELABEL_SUCCESS');
var FETCH_WHITELABEL_CANCELLED = makeConstant('FETCH_WHITELABEL_CANCELLED');

var CREATE_INBOX_BEFORE_WHITELABEL = makeConstant('CREATE_INBOX_BEFORE_WHITELABEL');
var CREATE_WHITELABEL = makeConstant('CREATE_WHITELABEL');
var CREATE_WHITELABEL_PENDING = makeConstant('CREATE_WHITELABEL_PENDING');
var CREATE_WHITELABEL_FAILED = makeConstant('CREATE_WHITELABEL_FAILED');
var CREATE_WHITELABEL_SUCCESS = makeConstant('CREATE_WHITELABEL_SUCCESS');
var CREATE_WHITELABEL_CANCELLED = makeConstant('CREATE_WHITELABEL_CANCELLED');

var VERIFY_WHITELABEL = makeConstant('VERIFY_WHITELABEL');
var VERIFY_WHITELABEL_PENDING = makeConstant('VERIFY_WHITELABEL_PENDING');
var VERIFY_WHITELABEL_FAILED = makeConstant('VERIFY_WHITELABEL_FAILED');
var VERIFY_WHITELABEL_SUCCESS = makeConstant('VERIFY_WHITELABEL_SUCCESS');
var VERIFY_WHITELABEL_CANCELLED = makeConstant('VERIFY_WHITELABEL_CANCELLED');

var OPEN_WHITELABEL_DKIM_SETTING = makeConstant('OPEN_WHITELABEL_DKIM_SETTING');
var CLOSE_WHITELABEL_DKIM_SETTING = makeConstant('CLOSE_WHITELABEL_DKIM_SETTING');

var CREATE_INBOX = makeConstant('CREATE_INBOX');
var CREATE_INBOX_PENDING = makeConstant('CREATE_INBOX_PENDING');
var CREATE_INBOX_FAILED = makeConstant('CREATE_INBOX_FAILED');
var CREATE_INBOX_SUCCESS = makeConstant('CREATE_INBOX_SUCCESS');
var CREATE_INBOX_CANCELLED = makeConstant('CREATE_INBOX_CANCELLED');

var FETCH_SENDING_DOMAINS = makeConstant('FETCH_SENDING_DOMAINS');
var FETCH_SENDING_DOMAINS_PENDING = makeConstant('FETCH_SENDING_DOMAINS_PENDING');

var PATCH_INBOX = makeConstant('PATCH_INBOX');
var PATCH_INBOX_PENDING = makeConstant('PATCH_INBOX_PENDING');
var PATCH_INBOX_FAILED = makeConstant('PATCH_INBOX_FAILED');
var PATCH_INBOX_SUCCESS = makeConstant('PATCH_INBOX_SUCCESS');

var ARCHIVE_INBOX = makeConstant('ARCHIVE_INBOX');
var ARCHIVE_INBOX_PENDING = makeConstant('ARCHIVE_INBOX_PENDING');
var ARCHIVE_INBOX_FAILED = makeConstant('ARCHIVE_INBOX_FAILED');
var ARCHIVE_INBOX_SUCCESS = makeConstant('ARCHIVE_INBOX_SUCCESS');

/***/ }),

/***/ "Y7j0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CustomerAPIAuthEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConversationAPIAuthEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");



var redirectToLoginOnAuthError = function redirectToLoginOnAuthError(error) {
  if (error.response.status === 401 || error.response.status === 403) {
    Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["deleteAccessToken"])();
    Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */]);
  }
};

var CustomerAPIAuthEnabled = Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["createAuthedHttpClient"])({
  baseConfig: {
    baseURL: '' + __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */]
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError]
});

var ConversationAPIAuthEnabled = Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["createAuthedHttpClient"])({
  baseConfig: {
    baseURL: '' + __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["i" /* CONVERSATION_API */]
  },
  responseSuccessHandlers: [],
  responseErrorHandlers: [redirectToLoginOnAuthError]
});

/***/ }),

/***/ "Y9Yz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBly":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YEs/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("9Gfy");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("Dvx7");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectorsUI__ = __webpack_require__("vTSr");
/* unused harmony reexport selectorsUI */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("QF6P");
/* unused harmony reexport constants */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("Iz1I");
/* unused harmony reexport api */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container__ = __webpack_require__("ykXs");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__container__["a"]; });











/***/ }),

/***/ "YGS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__ = __webpack_require__("qFJD");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var TagActions = Marty.createActionCreators({
  createTag: function createTag(tagParams) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_CREATE, tagParams);
  },
  updateTag: function updateTag(tagId, tagParams) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_UPDATE, tagId, tagParams);
  },
  deleteTag: function deleteTag(tagId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_DELETE, tagId);
  },
  pushTag: function pushTag(tag) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].PUSH_TAG, tag);
  },
  addTagsToConversationId: function addTagsToConversationId(conversationId, tagIds) {
    return this.app.queries.TagQueries.addTagsToConversationId(conversationId, tagIds);
  },
  removeTagsFromConversationId: function removeTagsFromConversationId(conversationId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromConversationId(conversationId, tagIds);
  },
  addTagsToCompanyId: function addTagsToCompanyId(companyId, tagIds) {
    return this.app.queries.TagQueries.addTagsToCompanyId(companyId, tagIds);
  },
  removeTagsFromCompanyId: function removeTagsFromCompanyId(companyId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromCompanyId(companyId, tagIds);
  },
  addTagsToEndUserId: function addTagsToEndUserId(endUserId, tagIds) {
    return this.app.queries.TagQueries.addTagsToEndUserId(endUserId, tagIds);
  },
  removeTagsFromEndUserId: function removeTagsFromEndUserId(endUserId, tagIds) {
    return this.app.queries.TagQueries.removeTagsFromEndUserId(endUserId, tagIds);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TagActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "YITf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("jaNg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__epic__ = __webpack_require__("t6hr");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__epic__["a"]; });





/***/ }),

/***/ "YIzp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (immutable) */ __webpack_exports__["b"] = makeOauthUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Connected__ = __webpack_require__("COe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_constants__ = __webpack_require__("+ecq");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var OAuthFailed = "Uh oh! Something happened before we could connect. Try again!";

function makeOauthUrl(oauthLink, oauthQueryParams, oauthRawParams) {
  var params = Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["h" /* serializeObject */])(oauthQueryParams);
  var extraParams = oauthRawParams || '';
  return oauthLink + '?' + params + extraParams;
}

var OauthConnector = function (_Component) {
  _inherits(OauthConnector, _Component);

  function OauthConnector(props) {
    _classCallCheck(this, OauthConnector);

    var _this = _possibleConstructorReturn(this, (OauthConnector.__proto__ || Object.getPrototypeOf(OauthConnector)).call(this, props));

    _this.handleClose = function () {
      if (_this.state.updating && !_this.props.integrationsConnectionStatus == __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_constants__["o" /* FETCH_INTEGRATION_STATES_PENDING */]) {
        _this.props.actions.fetchIntegrationStates();
        _this.setState({ updating: false });
      }
    };

    _this.handleConnect = function () {
      var _this$props = _this.props,
          oauthLink = _this$props.oauthLink,
          oauthQueryParams = _this$props.oauthQueryParams,
          oauthRawParams = _this$props.oauthRawParams,
          onConnecting = _this$props.onConnecting;

      var url = makeOauthUrl(oauthLink, oauthQueryParams, oauthRawParams);

      if (onConnecting) {
        onConnecting();
      }

      _this.popUp({
        path: url,
        onClose: _this.handleClose,
        onMessage: function onMessage(e) {
          var integrationStatus = e.data.status;
          if (integrationStatus === 'success') {
            if (_this.state.updating && !_this.props.integrationsConnectionStatus == __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_constants__["o" /* FETCH_INTEGRATION_STATES_PENDING */]) {
              _this.setState(function () {
                return { updating: false };
              });
              _this.props.actions.fetchIntegrationStates();
            }
            console.log('oauth calling succes in popup');
            _this.notifySuccess();
          } else if (integrationStatus === 'failed' || integrationStatus === 'failure') {
            _this.notifyFailure(e.data.errormessage || OAuthFailed);
          }
        }
      });
      _this.setState({ updating: true });
    };

    _this.handleDisconnect = function () {
      var _this$props2 = _this.props,
          integrationId = _this$props2.integrationId,
          actions = _this$props2.actions;

      actions.updateIntegrationState({ integration: integrationId, connected: false });
      actions.track('Integration Disconnected', { integration: integrationId, connected: false });
      _this.setState({ updating: true });
    };

    _this.notifySuccess = function () {
      var _this$props3 = _this.props,
          integrationId = _this$props3.integrationId,
          actions = _this$props3.actions,
          notifications = _this$props3.notifications,
          trackingPayload = _this$props3.trackingPayload,
          onIntegrationConnected = _this$props3.onIntegrationConnected;

      console.log('in oauth success');
      actions.track('Integration Connected', _extends({ integration: integrationId, connected: true }, trackingPayload));
      notifications.success(_this.getSuccessMessage(integrationId));
      onIntegrationConnected && onIntegrationConnected();
    };

    _this.notifyFailure = function (errormessage) {
      _this.props.notifications.error(errormessage);
      if (_this.props.logLoginFail) {
        Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["O" /* postLoginFailure */])(_this.props.integrationId);
      }
    };

    _this.renderConnectionLinks = function () {
      var _this$props4 = _this.props,
          integrationStates = _this$props4.integrationStates,
          integrationId = _this$props4.integrationId,
          connectorType = _this$props4.connectorType,
          connectorClass = _this$props4.connectorClass,
          label = _this$props4.label,
          buttonType = _this$props4.buttonType,
          tooltipText = _this$props4.tooltipText,
          isDisabled = _this$props4.isDisabled;

      if (integrationStates && !!integrationStates[integrationId]) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Connected__["a" /* default */], {
          integrationId: integrationId,
          handleDisconnect: _this.handleDisconnect
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ConnectLink__["a" /* default */], {
          handleConnect: _this.handleConnect,
          connectorClass: connectorClass,
          connectorType: connectorType,
          label: label,
          buttonType: buttonType,
          tooltipText: tooltipText,
          isDisabled: isDisabled
        });
      }
    };

    _this.state = {
      updating: false
    };
    return _this;
  }

  _createClass(OauthConnector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!!this.props.integrationStates && this.props.integrationStates[this.props.integrationId]) {
        this.props.onIntegrationConnected && this.props.onIntegrationConnected();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var integrationStates = _ref.integrationStates,
          failedCreateAccessToken = _ref.failedCreateAccessToken,
          integrationId = _ref.integrationId,
          actions = _ref.actions,
          trackingPayload = _ref.trackingPayload;

      var currentIntegrationStates = this.props.integrationStates;
      if (!!currentIntegrationStates && !!integrationStates && currentIntegrationStates[integrationId] !== integrationStates[integrationId]) {
        this.setState({ updating: false });
        if (integrationStates[integrationId]) {
          console.log('oauth calling success in cwrp');
          this.setState({ updating: false });
          this.notifySuccess();
        }
      }

      if (failedCreateAccessToken) {
        console.log('access token failed in connector');
        this.setState({ updating: false });
        this.props.notifications.error("We could not connect. Please check your input and try again.");
      }
    }
  }, {
    key: 'popUp',
    value: function popUp(_ref2) {
      var path = _ref2.path,
          onClose = _ref2.onClose,
          onMessage = _ref2.onMessage,
          windowName = _ref2.windowName,
          windowOptions = _ref2.windowOptions;

      windowName = windowName || 'ConnectWithOAuth'; // should not include space for IE
      windowOptions = windowOptions || 'location=0,status=0,width=800,height=600';
      onClose = onClose || function () {
        console.log("OauthConnector default onClose calling reload");
        window.location.reload();
      };
      var _oauthWindow = window.open(path, windowName, windowOptions);
      var _oauthInterval = window.setInterval(function () {
        if (_oauthWindow.closed) {
          console.log("OauthConnector _oauthWindow.closed");
          window.clearInterval(_oauthInterval);
          onClose();
        }
      }, 1000);
      window.addEventListener('message', function (e) {
        onMessage && onMessage(e);
        return true;
      });
      return _oauthWindow;
    }
  }, {
    key: 'getSuccessMessage',
    value: function getSuccessMessage(service) {
      return _.capitalize(service) + ' was successfully connected!';
    }
  }, {
    key: 'render',
    value: function render() {
      var updating = this.state.updating;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        updating ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { maxWidth: '50px' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_shared_LoadingDots__["a" /* default */], null)
        ) : this.renderConnectionLinks()
      );
    }
  }]);

  return OauthConnector;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OauthConnector.propTypes = {
  trackingPayload: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
    context: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
  })
};


var mapStateToProps = function mapStateToProps(state, props) {
  var integrationName = props.integrationId || '';

  return {
    integrationStates: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state),
    accessTokenCreationFailed: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__["h" /* failedCreateAccessToken */])(state, integrationName),
    integrationsConnectionStatus: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_selectors__["d" /* connectionsStatus */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_5_app_modules_tracking__["a" /* actions */].track,
      createAccessToken: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__["a" /* createAccessToken */],
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__["l" /* fetchIntegrationStates */],
      updateIntegrationState: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_actions__["T" /* updateIntegrationState */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(OauthConnector)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "YOd+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(532);

/***/ }),

/***/ "YWXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchOrgTeams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchOrgTeamsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchOrgTeamsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchOrgTeamsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchTeamsForUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchTeamsForUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchTeamsForUserSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchTeamsForUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return patchOrgTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return patchOrgTeamPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return patchOrgTeamSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return patchOrgTeamFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deleteOrgTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteOrgTeamPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteOrgTeamSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteOrgTeamFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createOrgTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createOrgTeamPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createOrgTeamSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createOrgTeamFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return updateAvailabilityForTeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return updateAvailabilityForTeamPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return updateAvailabilityForTeamSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return updateAvailabilityForTeamFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchTeamAvailabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchTeamAvailabilitiesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchTeamAvailabilitiesSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchTeamAvailabilitiesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchTeamAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchTeamAvailabilityPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchTeamAvailabilitySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchTeamAvailabilityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createTeamAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createTeamAvailabilityPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createTeamAvailabilitySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createTeamAvailabilityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return updateTeamAvailability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return updateTeamAvailabilityPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return updateTeamAvailabilitySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return updateTeamAvailabilityFailed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("rEEY");



var fetchOrgTeams = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_ORG_TEAMS */]);
var fetchOrgTeamsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_ORG_TEAMS_PENDING */]);
var fetchOrgTeamsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_ORG_TEAMS_SUCCESS */]);
var fetchOrgTeamsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_ORG_TEAMS_FAILED */]);

var fetchTeamsForUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* FETCH_TEAMS_FOR_USER */]);
var fetchTeamsForUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_TEAMS_FOR_USER_PENDING */]);
var fetchTeamsForUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_TEAMS_FOR_USER_SUCCESS */]);
var fetchTeamsForUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_TEAMS_FOR_USER_FAILED */]);

var patchOrgTeam = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* PATCH_ORG_TEAM */]);
var patchOrgTeamPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* PATCH_ORG_TEAM_PENDING */]);
var patchOrgTeamSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* PATCH_ORG_TEAM_SUCCESS */]);
var patchOrgTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* PATCH_ORG_TEAM_FAILED */]);

var deleteOrgTeam = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* DELETE_ORG_TEAM */]);
var deleteOrgTeamPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* DELETE_ORG_TEAM_PENDING */]);
var deleteOrgTeamSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* DELETE_ORG_TEAM_SUCCESS */]);
var deleteOrgTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* DELETE_ORG_TEAM_FAILED */]);

var createOrgTeam = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CREATE_ORG_TEAM */]);
var createOrgTeamPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_ORG_TEAM_PENDING */]);
var createOrgTeamSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_ORG_TEAM_SUCCESS */]);
var createOrgTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CREATE_ORG_TEAM_FAILED */]);

var updateAvailabilityForTeam = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* UPDATE_AVAILABILITY_FOR_TEAM */]);
var updateAvailabilityForTeamPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* UPDATE_AVAILABILITY_FOR_TEAM_PENDING */]);
var updateAvailabilityForTeamSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS */]);
var updateAvailabilityForTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* UPDATE_AVAILABILITY_FOR_TEAM_FAILED */]);

var fetchTeamAvailabilities = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_TEAM_AVAILABILITIES */]);
var fetchTeamAvailabilitiesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_TEAM_AVAILABILITIES_PENDING */]);
var fetchTeamAvailabilitiesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_TEAM_AVAILABILITIES_SUCCESS */]);
var fetchTeamAvailabilitiesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_TEAM_AVAILABILITIES_FAILED */]);

var fetchTeamAvailability = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* FETCH_TEAM_AVAILABILITY */]);
var fetchTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* FETCH_TEAM_AVAILABILITY_PENDING */]);
var fetchTeamAvailabilitySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* FETCH_TEAM_AVAILABILITY_SUCCESS */]);
var fetchTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* FETCH_TEAM_AVAILABILITY_FAILED */]);

var createTeamAvailability = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CREATE_TEAM_AVAILABILITY */]);
var createTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* CREATE_TEAM_AVAILABILITY_PENDING */]);
var createTeamAvailabilitySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CREATE_TEAM_AVAILABILITY_SUCCESS */]);
var createTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CREATE_TEAM_AVAILABILITY_FAILED */]);

var updateTeamAvailability = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* UPDATE_TEAM_AVAILABILITY */]);
var updateTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* UPDATE_TEAM_AVAILABILITY_PENDING */]);
var updateTeamAvailabilitySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* UPDATE_TEAM_AVAILABILITY_SUCCESS */]);
var updateTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* UPDATE_TEAM_AVAILABILITY_FAILED */]);

/***/ }),

/***/ "YacT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getOS;
var OS = {
    WIN: 'windows',
    MAC: 'mac',
    LINUX: 'linux',
    UNIX: 'unix',
    OTHER: 'other'

    /* Returns the user's os.
     */
};function getOS() {
    if (navigator.appVersion.indexOf("Win") != -1) return OS.WIN;
    if (navigator.appVersion.indexOf("Mac") != -1) return OS.MAC;
    if (navigator.appVersion.indexOf("X11") != -1) return OS.UNIX;
    if (navigator.appVersion.indexOf("Linux") != -1) return OS.LINUX;
    return OS.OTHER;
}

/***/ }),

/***/ "Yalu":
/***/ (function(module, exports) {

module.exports = {"v":"5.4.2","fr":29.9700012207031,"ip":0,"op":119.000004846969,"w":450,"h":320,"nm":"Comp 1","ddd":1,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Antenna top Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[224,69.5,0],"ix":2},"a":{"a":0,"k":[4,10.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-3.653,-10.178],[3.653,-10.178],[3.653,10.178],[-3.653,10.178]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.442999985639,0.922000002394,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[3.903,10.428],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":2,"ty":4,"nm":"4 Outlines","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 181);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[4.935,-114,0],"ix":2},"a":{"a":0,"k":[-126.5,16.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[8.835,15.565],[3.528,16.123],[2.774,8.949],[-11.648,10.465],[-12.118,5.999],[-1.798,-15.356],[5.504,-16.123],[7.567,3.498],[11.604,3.073],[12.118,7.967],[8.081,8.391]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[2.26,4.055],[0.722,-10.577],[-6.947,5.023]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.26699999641,0.620000023935,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[12.368,16.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":3,"ty":4,"nm":"Star 2","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 65);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[0,-58,0],"ix":2},"a":{"a":0,"k":[-197,13,0],"ix":1},"s":{"a":0,"k":[68.841,74.155,66.815],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.464,-1.595],[0,0],[-0.542,-0.162],[0,0],[1.579,-0.471],[0,0],[0.16,-0.543],[0,0],[0.464,1.595],[0,0],[0.535,0.158],[0,0],[-1.582,0.468],[0,0],[-0.157,0.544],[0,0]],"o":[[0,0],[0.16,0.544],[0,0],[1.579,0.468],[0,0],[-0.542,0.158],[0,0],[-0.464,1.595],[0,0],[-0.157,-0.543],[0,0],[-1.582,-0.471],[0,0],[0.535,-0.162],[0,0],[0.464,-1.595]],"v":[[1.904,-10.941],[3.754,-4.595],[4.876,-3.467],[11.168,-1.601],[11.168,1.6],[4.876,3.467],[3.754,4.594],[1.904,10.941],[-1.267,10.941],[-3.121,4.594],[-4.236,3.467],[-10.529,1.6],[-10.529,-1.601],[-4.236,-3.467],[-3.121,-4.595],[-1.267,-10.941]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.838999968884,0.866999966491,0.882000014361,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[12.36,12.786],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":4,"ty":4,"nm":"0/dizzy-bot-404 Outlines","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 181);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[6,-37.909,0],"ix":2},"a":{"a":0,"k":[-149.5,18,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.779,1.707],[-1.474,7.581],[-8.826,-1.716],[1.483,-7.626]],"o":[[-8.825,-1.715],[1.482,-7.626],[8.778,1.706],[-1.473,7.581]],"v":[[-3.026,15.004],[-12.515,-3.094],[3.054,-16.273],[12.506,1.77]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[-5.117,-0.995],[-1.12,5.765],[5.117,0.995],[1.13,-5.81]],"o":[[5.07,0.986],[1.13,-5.81],[-5.117,-0.995],[-1.121,5.765]],"v":[[-2.108,10.283],[6.919,0.684],[2.136,-11.552],[-6.929,-2.008]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.26699999641,0.620000023935,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[14.239,18.239],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":5,"ty":4,"nm":"Dot Outlines","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 181);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[4.952,-118,0],"ix":2},"a":{"a":0,"k":[93,6,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.095,0],[0,3.121],[-3.091,0],[0,-3.121]],"o":[[-3.091,0],[0,-3.121],[3.095,0],[0,3.121]],"v":[[-0.002,5.648],[-5.601,0.002],[-0.002,-5.648],[5.601,0.002]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.838999968884,0.866999966491,0.882000014361,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[5.851,5.898],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":6,"ty":4,"nm":"4 Outlines","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":180,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 181);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[0,-47,0],"ix":2},"a":{"a":0,"k":[184.5,16.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[10.069,14.697],[4.914,16.079],[3.047,9.111],[-10.961,12.865],[-12.122,8.527],[-5.271,-14.179],[1.822,-16.079],[6.927,2.978],[10.849,1.926],[12.122,6.68],[8.202,7.73]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[1.773,4.359],[-2.035,-9.854],[-7.168,6.755]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.26699999641,0.620000023935,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[12.372,16.329],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":7,"ty":4,"nm":"Star 1 Outlines","parent":8,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":360,"ix":9,"x":"var $bm_rt;\n$bm_rt = mul(time, 272);"},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[2,28,0],"ix":2},"a":{"a":0,"k":[180,15,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-0.54,-1.856],[0,0],[-0.63,-0.188],[0,0],[1.837,-0.548],[0,0],[0.186,-0.632],[0,0],[0.54,1.856],[0,0],[0.624,0.183],[0,0],[-1.841,0.544],[0,0],[-0.182,0.633],[0,0]],"o":[[0,0],[0.186,0.633],[0,0],[1.837,0.544],[0,0],[-0.63,0.183],[0,0],[-0.54,1.856],[0,0],[-0.182,-0.632],[0,0],[-1.841,-0.548],[0,0],[0.624,-0.188],[0,0],[0.54,-1.856]],"v":[[1.844,-12.732],[3.999,-5.347],[5.303,-4.034],[12.626,-1.862],[12.626,1.862],[5.303,4.035],[3.999,5.347],[1.844,12.732],[-1.844,12.732],[-4.003,5.347],[-5.301,4.035],[-12.622,1.862],[-12.622,-1.862],[-5.301,-4.034],[-4.003,-5.347],[-1.844,-12.732]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.838999968884,0.866999966491,0.882000014361,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[14.714,14.838],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":8,"ty":3,"nm":"Null 2","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[225,160,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":9,"ty":4,"nm":"Dizzy ring 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":15,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":30,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":45,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":60,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":75,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":90,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":105,"s":[0],"e":[10]},{"t":119.000004846969}],"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":0,"s":[227,87,0],"e":[214,87,0],"to":[-2.16666674613953,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":15,"s":[214,87,0],"e":[227,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":30,"s":[227,87,0],"e":[214,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":45,"s":[214,87,0],"e":[227,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":60,"s":[227,87,0],"e":[214,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":75,"s":[214,87,0],"e":[227,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":90,"s":[227,87,0],"e":[214,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":105,"s":[214,87,0],"e":[227,87,0],"to":[0,0,0],"ti":[-2.16666674613953,0,0]},{"t":119.000004846969}],"ix":2},"a":{"a":0,"k":[123,49,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-60.634,17.44],[1.668,5.836],[60.634,-17.44],[-1.668,-5.836]],"o":[[60.634,-17.441],[-1.668,-5.836],[-60.634,17.441],[1.668,5.836]],"v":[[3.021,10.567],[109.787,-31.579],[-3.02,-10.567],[-109.787,31.579]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.728999956916,0.859000052658,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.59,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[122.93,48.89],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":10,"ty":4,"nm":"Dizzy ring 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":15,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":30,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":45,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":60,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":75,"s":[0],"e":[10]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":90,"s":[10],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":105,"s":[0],"e":[10]},{"t":119.000004846969}],"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":0,"s":[231,87,0],"e":[218,87,0],"to":[-2.16666674613953,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":15,"s":[218,87,0],"e":[231,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":30,"s":[231,87,0],"e":[218,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":45,"s":[218,87,0],"e":[231,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":60,"s":[231,87,0],"e":[218,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":75,"s":[218,87,0],"e":[231,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":90,"s":[231,87,0],"e":[218,87,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":105,"s":[218,87,0],"e":[231,87,0],"to":[0,0,0],"ti":[-2.16666674613953,0,0]},{"t":119.000004846969}],"ix":2},"a":{"a":0,"k":[126,22.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-63.078,0],[0,6.071],[57.367,0.583],[4.103,0],[4.098,-0.043],[0,-5.666]],"o":[[63.077,0],[0,-5.676],[-3.991,-0.041],[-4.216,0],[-57.209,0.598],[0,6.071]],"v":[[0.001,10.993],[114.212,0.001],[12.145,-10.93],[0.001,-10.993],[-12.475,-10.928],[-114.212,0.001]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.579999976065,0.783999992819,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4.59,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[125.686,22.467],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":11,"ty":4,"nm":"Eye left/dizzy-bot-404 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\n$bm_rt = mul(time, 453);"},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[176.423,207.433,0],"ix":2},"a":{"a":0,"k":[24.423,22.433,0],"ix":1},"s":{"a":0,"k":[115,115,115],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.083,-1.074],[-1.354,1.341],[1.939,2.782],[3.05,-3.298],[-3.177,-3.418],[-3.304,3.276],[4.13,4.095],[4.753,-5.495],[-8.66,0]],"o":[[-1.083,1.073],[1.354,1.341],[1.691,-1.678],[-1.7,-2.439],[-2.526,2.732],[3.167,3.407],[4.13,-4.096],[-5.163,-5.119],[-8.279,9.569],[0,0]],"v":[[1.751,-1.441],[1.751,2.447],[6.652,2.447],[7.486,-4.456],[-1.84,-4.456],[-1.572,6.667],[10.959,5.865],[10.959,-8.966],[-6.81,-7.788],[1.103,14.085]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.579999976065,0.783999992819,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[22.589,21.586],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-11.6],[11.598,0],[0,11.599],[-11.598,0]],"o":[[0,11.599],[-11.598,0],[0,-11.6],[11.598,0]],"v":[[21,0],[-0.002,21],[-21,0],[-0.002,-21]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.030999998953,0.243000000598,0.46699999641,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[24.423,22.433],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":12,"ty":4,"nm":"Eye right/dizzy-bot-404 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\n$bm_rt = mul(time, -453);"},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[276.422,207.433,0],"ix":2},"a":{"a":0,"k":[24.422,22.433,0],"ix":1},"s":{"a":0,"k":[115,115,115],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.082,-1.074],[-1.353,1.341],[1.939,2.782],[3.051,-3.298],[-3.177,-3.418],[-3.304,3.276],[4.13,4.095],[4.754,-5.495],[-8.66,0]],"o":[[-1.082,1.073],[1.354,1.341],[1.692,-1.678],[-1.7,-2.439],[-2.526,2.732],[3.167,3.407],[4.13,-4.096],[-5.162,-5.119],[-8.278,9.569],[0,0]],"v":[[1.751,-1.441],[1.751,2.447],[6.652,2.447],[7.486,-4.456],[-1.84,-4.456],[-1.571,6.667],[10.959,5.865],[10.959,-8.966],[-6.811,-7.788],[1.103,14.085]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.579999976065,0.783999992819,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[22.589,21.586],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-11.6],[11.595,0],[0,11.599],[-11.602,0]],"o":[[0,11.599],[-11.602,0],[0,-11.6],[11.595,0]],"v":[[21,0],[0.002,21],[-21,0],[0.002,-21]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.030999998953,0.243000000598,0.46699999641,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[24.422,22.433],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0},{"ddd":1,"ind":15,"ty":4,"nm":"Face/dizzy-bot-404 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"rx":{"a":0,"k":0,"ix":8},"ry":{"a":0,"k":0,"ix":9},"rz":{"a":0,"k":0,"ix":10},"or":{"a":0,"k":[0,0,0],"ix":7},"p":{"a":0,"k":[225,160,0],"ix":2},"a":{"a":0,"k":[118,136.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-8.975,0],[0,0],[0,-8.975],[0,0],[8.975,0],[0,0],[0,8.975],[0,0]],"o":[[0,0],[8.975,0],[0,0],[0,8.975],[0,0],[-8.975,0],[0,0],[0,-8.975]],"v":[[-81.158,-34.606],[81.159,-34.606],[97.409,-18.356],[97.409,18.356],[81.159,34.606],[-81.158,34.606],[-97.408,18.356],[-97.408,-18.356]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.615,183.914],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[16.523,0],[0,0],[0,16.663],[0,0],[-16.522,0],[0,0],[0,-16.663],[0,0]],"o":[[0,0],[-16.522,0],[0,0],[0,-16.663],[0,0],[16.523,0],[0,0],[0,16.663]],"v":[[87.51,78.658],[-87.511,78.658],[-117.553,48.36],[-117.553,-48.361],[-87.511,-78.658],[87.51,-78.658],[117.553,-48.361],[117.553,48.36]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.035000000748,0.356999984442,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.803,193.272],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-6.707,0],[0,-6.763],[6.707,0],[0,6.764]],"o":[[6.707,0],[0,6.764],[-6.707,0],[0,-6.763]],"v":[[0,-12.223],[12.138,0.018],[0,12.223],[-12.138,0.018]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.075,0.313999998803,0.795999983245,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.804,12.473],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,-11.921],[0,0],[0,0],[0,0],[-11.154,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,-11.921],[0,0],[0,0],[11.117,0]],"v":[[53.145,9.361],[53.145,12.215],[-53.145,12.215],[-53.145,9.361],[-32.987,-12.215],[0,-12.215],[33.025,-12.215]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.075,0.313999998803,0.795999983245,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.804,103.851],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,2.024],[0,0],[2.013,0],[0,-2.024],[0,0],[-2.013,0]],"o":[[0,0],[0,-2.024],[-2.013,0],[0,0],[0,2.024],[2.013,0]],"v":[[3.645,33.066],[3.645,-33.066],[0,-36.73],[-3.645,-33.066],[-3.645,33.066],[0,36.73]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.442999985639,0.922000002394,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[117.202,57.791],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":120.0000048877,"st":0,"bm":0}],"markers":[]}

/***/ }),

/***/ "Ybad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* unused harmony export Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title__ = __webpack_require__("aTtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Ezlc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_settings_Settings_styl__ = __webpack_require__("cLnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_settings_Settings_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_styles_components_settings_Settings_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var REVOKED_TOKEN_HELP_LINK = 'https://help.drift.com/settings/why-calendars-disconnect';

var PAGE_TITLE = 'My Meetings';

var PAGE_DESCRIPTION = React.createElement(
  'span',
  null,
  'Take the back and forth out of scheduling and give leads and customers a direct line to your calendar. Let people schedule meetings with you right from chat or email.',
  ' ',
  React.createElement(
    'a',
    {
      href: 'https://help.drift.com/article/calendarsetup/',
      title: 'Drift Calendars help doc',
      target: '_blank'
    },
    'Learn More'
  )
);

var Header = function Header(_ref) {
  var nav = _ref.nav,
      title = _ref.title,
      description = _ref.description,
      _ref$withBorder = _ref.withBorder,
      withBorder = _ref$withBorder === undefined ? true : _ref$withBorder;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('header setting-page-title', _defineProperty({}, 'with-border', withBorder)) },
    !!nav && React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
      { className: 'settings-nav', to: nav.link },
      React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'settings-nav-back-bracket', width: 6, name: 'arrow-1-left' }),
      React.createElement(
        'div',
        null,
        nav.label
      )
    ),
    !!title && React.createElement(
      'div',
      { className: 'flex-space-between' },
      React.createElement(
        'h1',
        { className: 'page-title' },
        title
      )
    ),
    !!description && React.createElement(
      'div',
      null,
      React.createElement(
        'p',
        { className: 'page-description' },
        description
      )
    )
  );
};

var CalendarSettingsPage = function CalendarSettingsPage(_ref2) {
  var isTokenRevoked = _ref2.isTokenRevoked,
      hideHeader = _ref2.hideHeader,
      _ref2$showHeaderBorde = _ref2.showHeaderBorder,
      showHeaderBorder = _ref2$showHeaderBorde === undefined ? true : _ref2$showHeaderBorde,
      children = _ref2.children;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_document_title___default.a,
    { title: 'My Meetings' },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.CalendarSettings },
      React.createElement(
        'div',
        { className: 'calendar-upgrade-pill-wrapper' },
        !hideHeader && React.createElement(
          'div',
          { className: 'meetings-settings-page-title' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["NavigationHeader"],
            { title: PAGE_TITLE },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["P"],
              { className: 'page-description' },
              PAGE_DESCRIPTION
            )
          )
        ),
        isTokenRevoked && React.createElement(
          'div',
          { className: 'calendar-token-revoked-message' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { size: '30', className: 'token-revoked-icon', name: 'warning-triangle' }),
          React.createElement(
            'div',
            null,
            React.createElement(
              'div',
              { className: 'token-revoked-title' },
              'The calendar connection has been expired or revoked by your calendar provider.'
            ),
            React.createElement(
              'div',
              null,
              'Reconnect below to reactivate your calendar features.',
              ' ',
              React.createElement(
                'a',
                { href: REVOKED_TOKEN_HELP_LINK, target: '_blank' },
                'Learn More'
              ),
              '.'
            )
          )
        ),
        React.createElement(
          'div',
          null,
          children
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CalendarSettingsPage);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "YbvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("ndDR");












var mapStateToProps = function mapStateToProps(state) {
  return {
    isCardinalityLoading: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["i" /* cardinalityLoading */](state),
    targetingCardinality: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_102" /* targetingCardinality */](state),
    isOneTimeEmailPlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_4" /* getIsOneTimeEmailPlaybook */](state),
    hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__["hasLimitedContactsMktEmail"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_151" /* setDraftStatus */],
      hideSendEmailConfirmModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_89" /* hideSendEmailConfirmModal */],
      hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["hasLimitedContactsMktEmail"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    var hasLimitedContactsMktEmail = this.props.actions.hasLimitedContactsMktEmail;


    hasLimitedContactsMktEmail();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onCloseClick: function onCloseClick(_ref) {
    var hideSendEmailConfirmModal = _ref.actions.hideSendEmailConfirmModal;
    return function () {
      hideSendEmailConfirmModal();
    };
  },
  onConfirmClick: function onConfirmClick(_ref2) {
    var isOneTimeEmailPlaybook = _ref2.isOneTimeEmailPlaybook,
        _ref2$actions = _ref2.actions,
        hideSendEmailConfirmModal = _ref2$actions.hideSendEmailConfirmModal,
        setDraftStatus = _ref2$actions.setDraftStatus;
    return function () {
      setDraftStatus({ status: isOneTimeEmailPlaybook ? __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT : __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED });
      hideSendEmailConfirmModal();
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),

/***/ "Ycog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newConversation;
/* harmony export (immutable) */ __webpack_exports__["b"] = openSidebar;
/* unused harmony export showWelcomeMessage */
/* unused harmony export hideWidget */
/* unused harmony export trackPage */
/* unused harmony export showWidget */
function newConversation() {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.on('ready', function (api) {
    return api.sidebar.open();
  });
}

function openSidebar() {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.on('ready', function (api) {
    return api.sidebar.open();
  });
}

function showWelcomeMessage(options) {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.on('ready', function (api) {
    return api.showWelcomeMessage(options);
  });
}

function hideWidget() {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.hide();
}

function trackPage() {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.page();
}

function showWidget() {
  if (typeof drift === 'undefined' || drift === null) {
    return;
  }
  return drift.show();
}

/***/ }),

/***/ "Yf0l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_TagList_styl__ = __webpack_require__("bcin");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_TagList_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_components_TagList_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TagList = function (_React$Component) {
  _inherits(TagList, _React$Component);

  function TagList() {
    _classCallCheck(this, TagList);

    return _possibleConstructorReturn(this, (TagList.__proto__ || Object.getPrototypeOf(TagList)).apply(this, arguments));
  }

  _createClass(TagList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          extraContentNode = _props.extraContentNode,
          afterTagsNode = _props.afterTagsNode,
          tagIds = _props.tagIds,
          tagsById = _props.tagsById,
          tagClickFunc = _props.tagClickFunc;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'TagList' },
        children,
        extraContentNode,
        _.map(tagIds, function (tagId) {
          var tag = tagsById.get(tagId);
          if (tag == null) {
            return;
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ canHover: !!tagClickFunc }),
              title: tag.name,
              key: '' + tagId },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { tag: Object(__WEBPACK_IMPORTED_MODULE_1_utils_TagAppearanceHelper__["b" /* normalizeColor */])(tag) }),
            tagClickFunc && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'remove-tag', onClick: function onClick() {
                  return tagClickFunc && tagClickFunc([tag.id]);
                } },
              'X'
            )
          );
        }),
        afterTagsNode
      );
    }
  }]);

  return TagList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TagList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "YkI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("dR61");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "YlRO":
/***/ (function(module, exports) {

module.exports = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.583 14.894l-3.256 3.78c-.7.813-1.26.598-1.25-.46a10689.413 10689.413 0 0 1 .035-4.775V4.816a3.89 3.89 0 0 1 3.88-3.89h12.064a3.885 3.885 0 0 1 3.882 3.89v6.185a3.89 3.89 0 0 1-3.882 3.89H4.583z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "Yqpn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ExitIntent":"ExitIntent---2rnOB"};

/***/ }),

/***/ "Yt9r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TargetingDisplay":"TargetingDisplay---1EyjJ"};

/***/ }),

/***/ "Ytp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_TagAppearanceHelper__ = __webpack_require__("3tUM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__("csip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_container__ = __webpack_require__("mKU3");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var TagSelect = function (_Component) {
  _inherits(TagSelect, _Component);

  function TagSelect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TagSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TagSelect.__proto__ || Object.getPrototypeOf(TagSelect)).call.apply(_ref, [this].concat(args))), _this), _this.renderTag = function (tag) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Tag___default.a, { tag: Object(__WEBPACK_IMPORTED_MODULE_4_utils_TagAppearanceHelper__["b" /* normalizeColor */])(tag) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          multi = _props.multi,
          selected = _props.selected,
          tags = _props.tags,
          onChange = _props.onChange,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['multi', 'selected', 'tags', 'onChange', 'className']);

      var filteredTags = _.filter(tags, function (tag) {
        return tag.status !== 'ARCHIVED';
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__["b" /* default */], _extends({
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, __WEBPACK_IMPORTED_MODULE_5__style__["TagSelect"]),
        placeholder: 'All Tags',
        multi: multi,
        searchable: false,
        value: multi ? selected.map(function (id) {
          return filteredTags.find(function (tag) {
            return tag.id === id;
          });
        }) : filteredTags.find(function (tag) {
          return tag.id === selected;
        }),
        menuBuffer: 10,
        options: filteredTags,
        onChange: onChange,
        valueKey: 'name',
        labelKey: 'id',
        optionRenderer: this.renderTag,
        valueRenderer: this.renderTag,
        clearable: !multi
      }, props));
    }
  }]);

  return TagSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

TagSelect.defaultProps = {
  multi: true
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_components_container__["a" /* makeDefaultFailedContainer */])(TagSelect, {
  listenTo: ['stores.TagStore'],
  fetch: {
    tags: function tags() {
      return this.app.stores.TagStore.getOrFetchCustomerTagList();
    }
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "YwA3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-analytics-logo.4c871b32.svg";

/***/ }),

/***/ "YwI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hydrateModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__ = __webpack_require__("QM6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketoProgramSelect__ = __webpack_require__("rc0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_api__ = __webpack_require__("PMAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MarketoMappedLeadOwnerInput__ = __webpack_require__("l7G3");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var model = [{
  type: 'syncLeadsEnabled',
  value: false,
  label: 'Sync leads from Drift to Marketo',
  description: 'Leads from Drift will be created or updated in Marketo whenever a conversation closes',
  openAdvancedSettingsOnEnable: true,
  children: {
    label: 'Associate leads with a Marketo Program',
    description: 'Drift will add the lead to a program.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])({
      fetchPrograms: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["l" /* fetchMarketoPrograms */],
      queryPrograms: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["P" /* queryMarketoPrograms */],
      getSelectedProgram: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["p" /* getDefaultMarketoProgram */],
      setProgram: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["T" /* setDefaultMarketoProgram */],
      deleteProgram: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["e" /* deleteDefaultMarketoProgram */]
    })(__WEBPACK_IMPORTED_MODULE_1__MarketoProgramSelect__["a" /* default */]),
    items: []
  }
}, {
  type: 'identityResolutionEnabled',
  value: false,
  label: 'Identify Drift visitors with the Marketo cookie',
  description: 'If someone was already identified by Marketo, Drift will automatically recognize them as a known contact. We\'ll only check Marketo if the visitor has a Marketo cookie set.'
}, {
  type: 'associateLeadsEnabled',
  value: false,
  label: 'Attach anonymous history to Marketo leads',
  description: 'Use Marketo’s Munchkin Cookies to attach browsing history to an anonymous Marketo lead when they become identified in Drift'
}, {
  type: 'conversationTranscriptEnabled',
  value: false,
  label: 'Include Conversation Transcripts on Activities pushed to Marketo',
  description: 'If the \'New Drift Conversation\' activity is mapped below, we\'ll added a raw conversation transcript as an attribute on the activity'
}, {
  type: 'shouldOnlySyncQualifiedLeads',
  value: false,
  label: 'Set a minimum CQL score for synced contacts and conversations',
  description: 'Unchecked, Drift will sync all contacts and conversations to Marketo.',
  topLevelAdvancedItems: [],
  children: {
    autoExpand: true,
    label: 'Minimum CQL score',
    description: 'Drift will only sync conversations that have the selected CQL score or higher.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])({ integrationName: 'marketo',
      setMinimumCQLScore: function setMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["W" /* setMinimumCqlScore */])(data);
      },
      getMinimumCQLScore: function getMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["A" /* getMinimumCqlScore */])(data);
      }
    })(__WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__["a" /* default */]),
    items: []
  }
}, {
  type: 'leadOwnerFieldEnabled',
  value: false,
  label: 'Assign a Lead Owner in Marketo',
  description: "For every new contact that Drift creates, we'll assign a Lead Owner email based on who books a meeting, who was routed into the conversation, or who closes the conversation (in that order!).",
  openAdvancedSettingsOnEnable: true,
  children: {
    label: 'Lead Owner field',
    description: "Which Marketo field should Drift use? Note that this will overwrite the chosen field’s existing value in Marketo.",
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])({
      getMarketoLeadOwnerField: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["y" /* getMarketoLeadOwnerField */],
      setMarketoLeadOwnerField: __WEBPACK_IMPORTED_MODULE_3_app_modules_integrations_api__["V" /* setMarketoLeadOwnerField */],
      fetchMarketoFields: __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_api__["a" /* api */].fetchMarketoFields
    })(__WEBPACK_IMPORTED_MODULE_5__MarketoMappedLeadOwnerInput__["a" /* default */]),
    items: []
  }
}];

var hydrateModel = function hydrateModel(toggles) {
  return [].concat(model).map(function (topLevel) {
    var updatedToggle = _extends({}, topLevel);
    updatedToggle.value = toggles[topLevel.type];
    return updatedToggle;
  });
};

/***/ }),

/***/ "YwUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BrandingLink":"BrandingLink---2Tm6g","BrandingLink--black":"BrandingLink--black---2Dyi3"};

/***/ }),

/***/ "Yxa2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Modal__ = __webpack_require__("3F5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl__ = __webpack_require__("7TTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var EMAIL_SNIPPET = 'Hello! Do you mind helping me install Drift on our website? It shouldn’t take more than 2 minutes. The code snippet is below and here are some instructions.\n\n[Drift code will appear here]';

var EmailInviteModal = function (_Component) {
  _inherits(EmailInviteModal, _Component);

  function EmailInviteModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EmailInviteModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailInviteModal.__proto__ || Object.getPrototypeOf(EmailInviteModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputValue: ''
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      var inputValue = _this.state.inputValue;

      _this.app.actions.OrgActions.shareSnippet(inputValue, _this.props.org.id);
      _this.props.onClose();
      _this.props.actions.track('Onboarding Install Assistance Request Email Sent', {
        context: 'widget-onboarding'
      });
      if (!_this.props.skipRedirect) {
        _this.context.router.push('/');
      }
      _this.props.onSend();
    }, _this.handleChange = function (event) {
      var globalHandle = event.target.value.trim();
      _this.setState({
        inputValue: globalHandle
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EmailInviteModal, [{
    key: 'render',
    value: function render() {
      var inputValue = this.state.inputValue;
      var _props = this.props,
          users = _props.users,
          onClose = _props.onClose;

      var isValid = this.state.inputValue && Object(__WEBPACK_IMPORTED_MODULE_6_validator__["isEmail"])(this.state.inputValue);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_components_Modal__["a" /* default */],
        { ignoreCloseOnClickOutside: true, onClose: onClose, modalContentClassName: 'snippet-share-modal' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'snippet-share-header' },
          'Email a teammate'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'form',
          { className: 'drift-form', onSubmit: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              null,
              'Send To',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                autoFocus: true,
                pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,63}$',
                type: 'email',
                value: inputValue,
                placeholder: 'Enter an email address',
                onChange: this.handleChange,
                className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('valid-email', isValid)
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'fieldset',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'label',
              null,
              'Message',
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'textarea',
                { className: 'email-message', readOnly: true, rows: '6', cols: '40' },
                EMAIL_SNIPPET
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { disabled: !isValid, className: 'drift-button drift-button-primary' },
            'Send Message'
          )
        )
      );
    }
  }]);

  return EmailInviteModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

EmailInviteModal.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_11_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
};

var EmailInviteModalContainer = Object(__WEBPACK_IMPORTED_MODULE_5_components_container__["a" /* makeDefaultFailedContainer */])(EmailInviteModal, {
  listenTo: ['stores.OrgStore', 'stores.UserStore'],
  fetch: {
    org: function org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    },
    users: function users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg();
    }
  }
});

var EmailInviteModalConnect = Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["b" /* connect */])(null, mapDispatchToProps)(EmailInviteModalContainer);

/* harmony default export */ __webpack_exports__["a"] = (EmailInviteModalConnect);

/***/ }),

/***/ "YyeZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(5);

/***/ }),

/***/ "Z1E+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_TargetAPI__ = __webpack_require__("NZ+S");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var _require$default = __webpack_require__("h6+o").default,
    FETCH_TARGET_CONDITIONS_DONE = _require$default.FETCH_TARGET_CONDITIONS_DONE,
    FETCH_TARGET_CONDITION_DONE = _require$default.FETCH_TARGET_CONDITION_DONE,
    CREATE_TARGET_CONDITION_DONE = _require$default.CREATE_TARGET_CONDITION_DONE,
    PATCH_TARGET_CONDITION_DONE = _require$default.PATCH_TARGET_CONDITION_DONE;




var TargetConditionQueries = Marty.createQueries({
  id: 'TargetConditionQueries',

  fetchTargets: function fetchTargets() {
    var _this = this;

    var promise = Object(__WEBPACK_IMPORTED_MODULE_1_app_api_TargetAPI__["c" /* fetchTargets */])();
    promise.then(function (targets) {
      return _this.dispatch(FETCH_TARGET_CONDITIONS_DONE, targets);
    });

    return promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["a" /* captureException */])(error);
    });
  },
  fetchTarget: function fetchTarget(id) {
    var _this2 = this;

    var promise = Object(__WEBPACK_IMPORTED_MODULE_1_app_api_TargetAPI__["b" /* fetchTarget */])(id);
    promise.then(function (target) {
      return _this2.dispatch(FETCH_TARGET_CONDITION_DONE, target);
    });

    return promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["a" /* captureException */])(error);
    });
  },
  createTarget: function createTarget(target) {
    var _this3 = this;

    var promise = Object(__WEBPACK_IMPORTED_MODULE_1_app_api_TargetAPI__["a" /* createTarget */])(target);
    promise.then(function (target) {
      _this3.dispatch(CREATE_TARGET_CONDITION_DONE, target);
      return _this3.app.actions.NotificationActions.pushNotification({
        content: 'You\'ve created a new condition: ' + target.name
      });
    });

    promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["a" /* captureException */])(error);
    });

    return promise;
  },
  updateTarget: function updateTarget(operations, id) {
    var _this4 = this;

    var promise = Object(__WEBPACK_IMPORTED_MODULE_1_app_api_TargetAPI__["d" /* patchTarget */])(operations, id);
    promise.then(function (target) {
      _this4.dispatch(PATCH_TARGET_CONDITION_DONE, target);
      return _this4.app.actions.NotificationActions.pushNotification({
        content: 'You\'ve updated condition: ' + target.name
      });
    });

    promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["a" /* captureException */])(error);
    });

    return promise;
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TargetConditionQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "Z4Hx":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 26\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"V1-Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><g id=\"Actions\" transform=\"translate(-886.000000, -408.000000)\" stroke=\"#394F5A\" stroke-width=\"2\"><g id=\"Group-5\" transform=\"translate(771.000000, 360.000000)\"><path d=\"M122.933277,58.6167665 L129.406486,58.6167665 L115.955829,78.4822809 L121.044314,62.988024 L115.207784,62.988024 L127.415531,43.206349 L122.933277,58.6167665 Z\" id=\"Path-106\"></path></g></g></g></svg>"

/***/ }),

/***/ "Z6Zx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z7nH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z9sL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__ = __webpack_require__("Eys3");








var mapStateToProps = function mapStateToProps(state) {
  var isLoaded = Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_selectors__["k" /* isGlobalAutoCloseConfigurationLoaded */])(state);

  return {
    globalAutoCloseConfiguration: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_selectors__["i" /* getGlobalAutoCloseConfiguration */])(state),
    isGlobalAutoCloseConfigurationLoaded: isLoaded,
    doFetch: !isLoaded && !Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_selectors__["l" /* isGlobalAutoCloseConfigurationLoading */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({ fetchGlobalAutoCloseConfiguration: __WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__["s" /* fetchGlobalAutoCloseConfiguration */] }, dispatch);
};

var withGlobalAutoCloseConfiguration = Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (this.props.doFetch) {
      this.props.fetchGlobalAutoCloseConfiguration();
    }
  }
}));

/* harmony default export */ __webpack_exports__["a"] = (withGlobalAutoCloseConfiguration);

/***/ }),

/***/ "ZAIb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SelectWrapper":"SelectWrapper---2qqnh"};

/***/ }),

/***/ "ZBOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvailabilityStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NotificationSnoozeStatus; });
/* unused harmony export AvailabilityStatusIcons */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStatusIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg__ = __webpack_require__("baVF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg__ = __webpack_require__("pB77");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg__ = __webpack_require__("NrfI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg__ = __webpack_require__("PDo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_with_notifications_svg__ = __webpack_require__("jqpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_with_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_with_notifications_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_without_notifications_svg__ = __webpack_require__("xNwu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_without_notifications_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_without_notifications_svg__);







var AvailabilityStatus = {
  ACTIVE: 'AVAILABLE',
  AWAY: 'OFFLINE',
  ON_CALL: 'ON_CALL'
};

var NotificationSnoozeStatus = {
  ON: 'SNOOZE_ON',
  OFF: 'SNOOZE_OFF'
};

var AvailabilityStatusIcons = [{
  availabilityStatus: AvailabilityStatus.ACTIVE,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ACTIVE,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ON_CALL,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_0__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.ON_CALL,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_1__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_active_without_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.AWAY,
  notificationSnoozeStatus: NotificationSnoozeStatus.OFF,
  icon: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_with_notifications_svg___default.a
}, {
  availabilityStatus: AvailabilityStatus.AWAY,
  notificationSnoozeStatus: NotificationSnoozeStatus.ON,
  icon: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_away_without_notifications_svg___default.a
}];

var getStatusIcon = function getStatusIcon(availabilityStatus, notificationSnoozeStatus, isLimited) {
  if (isLimited && availabilityStatus === AvailabilityStatus.ACTIVE) {
    return notificationSnoozeStatus === NotificationSnoozeStatus.ON ? __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_without_notifications_svg___default.a : __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_status_icons_auto_away_with_notifications_svg___default.a;
  }

  return AvailabilityStatusIcons.find(function (icon) {
    return icon.availabilityStatus === availabilityStatus && icon.notificationSnoozeStatus === notificationSnoozeStatus;
  }).icon;
};

/***/ }),

/***/ "ZDAe":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"18\" viewBox=\"0 0 25 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.61 17.4c.78.825 2.09.836 2.882.02L23.645 3.88a1.99 1.99 0 0 0-.042-2.818 1.994 1.994 0 0 0-2.818.042L9.07 13.134 4.135 7.9a1.994 1.994 0 0 0-2.817-.086 1.99 1.99 0 0 0-.086 2.816l6.377 6.77z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ZDyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WidgetStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetMode; });
var WidgetStatus = Object.freeze({
  ON: 'ON',
  OFF: 'OFF',
  AWAY: 'AWAY'
});

var WidgetMode = Object.freeze({
  AUTO: 'AUTO',
  MANUAL: 'MANUAL'
});

/***/ }),

/***/ "ZF7Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__ = __webpack_require__("9eSk");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var EndUserActions = Marty.createActionCreators({
  createEndUser: function createEndUser(endUser, orgId) {
    return this.app.queries.EndUserQueries.createEndUserForOrgId(endUser, orgId);
  },
  updateEndUser: function updateEndUser(endUserId, endUserParams, accessToken) {
    return this.app.queries.EndUserQueries.updateEndUser(endUserId, endUserParams, accessToken);
  },
  setEndUserFromPusher: function setEndUserFromPusher(endUser, isNewEndUser) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].SET_END_USER_FROM_PUSHER, endUser, isNewEndUser);
  },
  searchEndUser: function searchEndUser(orgId, query) {
    return this.app.queries.EndUserQueries.searchEndUser(orgId, query);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ZJVj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MultiTimeSelect":"MultiTimeSelect---1yckL","TimeSelect":"TimeSelect---1dUUu","DaySelect":"DaySelect---13CKA","HourSelect":"HourSelect---3r-Ej"};

/***/ }),

/***/ "ZL5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("mMZi");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__; });



/***/ }),

/***/ "ZLiY":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 228 44\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#03363D\" fill-rule=\"evenodd\"><path d=\"M152.67 37.665c3.015.07 5.933-1.063 8.104-3.15l4.018 4.343c-3.153 3.242-7.55 4.98-12.077 4.77-9.82 0-16.163-6.526-16.163-15.346-.093-4.077 1.484-8.017 4.367-10.912 2.882-2.894 6.823-4.495 10.914-4.433 9.753 0 15.283 7.426 14.787 17.73h-23.003c.664 4.365 4.646 7.444 9.053 6.998zm7.02-11.902c-.218-4.058-3.695-7.17-7.765-6.953-4.177-.244-7.825 2.79-8.33 6.93l16.095.023zM0 37.35l17.743-18H.406v-5.693H25.96v5.76l-17.743 18h18.06v5.67H0M47.406 37.665c3.015.07 5.933-1.063 8.104-3.15l4.018 4.343c-3.153 3.242-7.55 4.98-12.077 4.77-9.82 0-16.162-6.526-16.162-15.346-.093-4.077 1.484-8.017 4.367-10.912 2.883-2.894 6.824-4.495 10.916-4.433 9.753 0 15.283 7.426 14.787 17.73h-22.98c.662 4.356 4.63 7.43 9.03 6.998zm7.02-11.902c-.23-4.05-3.703-7.148-7.765-6.93-4.15-.22-7.768 2.794-8.284 6.907l16.05.023zM99.733 28.282c-.173-4.012 1.31-7.92 4.103-10.815 2.793-2.894 6.654-4.523 10.683-4.507 3.78-.028 7.38 1.62 9.82 4.5V0h6.275v43.02h-6.276v-4.05c-2.406 2.968-6.038 4.683-9.866 4.657-4.013-.033-7.843-1.682-10.62-4.572-2.775-2.89-4.26-6.774-4.12-10.773zm24.945 0c0-5.144-4.185-9.314-9.346-9.314-5.162 0-9.346 4.17-9.346 9.314 0 5.145 4.184 9.315 9.346 9.315 5.16 0 9.346-4.17 9.346-9.315zM170.55 36.788l5.665-3.038c1.524 2.72 4.436 4.376 7.562 4.297 3.544 0 5.373-1.822 5.373-3.892s-3.432-2.88-7.156-3.645c-5.034-1.058-10.226-2.7-10.226-8.775 0-4.657 4.514-9 11.422-9 4.692-.28 9.195 1.882 11.897 5.715l-5.26 3.06c-1.474-2.183-3.976-3.45-6.614-3.353-3.364 0-5.08 1.643-5.08 3.533s2.71 2.7 6.976 3.645c4.852 1.057 10.338 2.655 10.338 8.775 0 4.072-3.544 9.54-11.942 9.495-5.272.386-10.303-2.26-12.957-6.817zM211.77 29.948l-4.967 5.422v7.672h-6.276V0h6.276v28.17L220.1 13.5h7.63l-11.536 12.622L228 43.02h-7.066M81.087 12.96c-7.45 0-13.68 4.837-13.68 12.848V43.02h6.388V26.595c-.227-2.06.477-4.114 1.92-5.605 1.445-1.49 3.48-2.265 5.552-2.112 4.74 0 7.09 2.902 7.09 7.717V43.02h6.455V25.807c0-8.01-6.276-12.847-13.725-12.847z\"></path></g></svg>"

/***/ }),

/***/ "ZPDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['Small', 'Mid-Market', 'Enterprise']);

/***/ }),

/***/ "ZSqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__ = __webpack_require__("1Pxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ManageCalendarLink__ = __webpack_require__("KTtR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CalendarField__ = __webpack_require__("gauQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_styl__ = __webpack_require__("e37Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SocialHandle = function SocialHandle(_ref) {
  var name = _ref.name,
      title = _ref.title,
      url = _ref.url,
      value = _ref.value,
      onChange = _ref.onChange,
      style = _ref.style;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_8__styles_styl___default.a.SocialHandle, style: style },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'dsg-Label' },
      title
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_8__styles_styl___default.a.SocialHandle__InputContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__styles_styl___default.a.SocialHandle__URL },
        url
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_8__styles_styl___default.a.SocialHandle__Input,
        size: 'small',
        name: name,
        placeholder: 'username',
        value: value,
        onChange: onChange,
        isValid: true
      })
    )
  );
};

var ContactInfo = function (_PureComponent) {
  _inherits(ContactInfo, _PureComponent);

  function ContactInfo() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ContactInfo.__proto__ || Object.getPrototypeOf(ContactInfo)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (event) {
      _this.props.actions.setProfileUIData({
        key: event.target.name,
        value: event.target.type === 'checkbox' ? event.target.checked : event.target.value
      });
    }, _this.handleCtaVisibilityChange = function (event) {
      _this.props.actions.setProfileUIData({
        key: 'enableCalendarCta',
        value: event.target.checked
      });
    }, _this.handleSave = function () {
      if (!_this.canSubmit()) return;

      _this.props.actions.updateContact();
    }, _this.handleCancel = function () {
      _this.props.actions.setProfileUI(_this.props.social);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactInfo, [{
    key: 'canSubmit',
    value: function canSubmit() {
      return !Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["is"])(this.props.socialUI, this.props.social) && this.isValidCalendarCtaCopy;
    }
  }, {
    key: 'isValidUrl',
    value: function isValidUrl(url) {
      if (!url) {
        return true;
      }
      return Object(__WEBPACK_IMPORTED_MODULE_2_validator__["isURL"])(url) || url && url.length === 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var socialUI = this.props.socialUI;

      var isValidCalendarUrl = this.isValidUrl(socialUI.calendarUrl);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["b" /* Subsection */],
        {
          title: 'Contact',
          isValid: isValidCalendarUrl,
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'profile-settings' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: 1, marginRight: '4rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dsg-Label' },
                'Phone number'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
                size: 'small',
                placeholder: '123-456-7890',
                value: socialUI.phoneNumber,
                name: 'phoneNumber',
                onChange: this.handleChange,
                isValid: true,
                type: 'tel'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex-1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'dsg-Label' },
                'Calendar CTA'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'flex align-items-flex-start' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Body', style: { marginRight: '2.5rem' } },
                  'Display a button that allows users to book a meeting with you from your profile.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core__["Toggle"], {
                  checked: socialUI.enableCalendarCta,
                  onChange: this.handleCtaVisibilityChange
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'Twitter',
              url: 'twitter.com/',
              value: socialUI.twitterHandle,
              onChange: this.handleChange,
              name: 'twitterHandle',
              style: { marginRight: '4rem' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex-1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'flex flex-space-between' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Label' },
                  'Calendar link'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Label' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ManageCalendarLink__["a" /* default */], null)
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CalendarField__["a" /* default */], {
                size: 'small',
                value: socialUI.calendarUrl,
                placeholder: 'www.example.com/username',
                name: 'calendarUrl',
                onChange: this.handleChange,
                isValid: isValidCalendarUrl,
                debounceTime: 1000
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'LinkedIn',
              url: 'linkedin.com/in/',
              value: socialUI.linkedInHandle,
              onChange: this.handleChange,
              name: 'linkedInHandle',
              style: { marginRight: '4rem' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex-1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'flex flex-space-between' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Label' },
                  'Calendar CTA copy'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'dsg-Body ' + (this.isValidCalendarCtaCopy ? 'color-navy-dark' : 'color-red') },
                  this.calendarCtaCopyRemainingCharacters
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
                size: 'small',
                name: 'calendarCta',
                placeholder: 'e.g. book a demo',
                value: socialUI.calendarCta,
                onChange: this.handleChange,
                isValid: this.isValidCalendarCtaCopy,
                invalidLabel: this.isValidCalendarCtaCopy ? '' : 'CTA exceeds max length'
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'Instagram',
              url: 'instagram.com/',
              value: socialUI.instagramHandle,
              onChange: this.handleChange,
              name: 'instagramHandle',
              style: { marginRight: '4rem' }
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'SoundCloud',
              url: 'soundcloud.com/',
              value: socialUI.soundCloudHandle,
              onChange: this.handleChange,
              name: 'soundCloudHandle'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'Pinterest',
              url: 'pinterest.com/',
              style: { marginRight: '4rem' },
              value: socialUI.pinterestHandle,
              onChange: this.handleChange,
              name: 'pinterestHandle'
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
              title: 'Skype',
              url: 'skype.com/',
              value: socialUI.skypeHandle,
              onChange: this.handleChange,
              name: 'skypeHandle'
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_components_settings_UserProfile_Section__["a" /* Row */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { flex: '1', marginRight: '4rem' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SocialHandle, {
                title: 'Facebook',
                url: 'facebook.com/',
                value: socialUI.facebookHandle,
                onChange: this.handleChange,
                name: 'facebookHandle'
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'flex-1' })
          )
        )
      );
    }
  }, {
    key: 'calendarCtaCopyRemainingCharacters',
    get: function get() {
      return 18 - _.get(this.props.socialUI, 'calendarCta.length', 0);
    }
  }, {
    key: 'isValidCalendarCtaCopy',
    get: function get() {
      return this.calendarCtaCopyRemainingCharacters > -1;
    }
  }]);

  return ContactInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ContactInfo);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "ZTRB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("HSWx");












function makeMapStateToProps() {
  return function (state) {
    return {
      hasCalendarScope: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["q" /* hasCalendarScope */])(state),
      hasEmailScope: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["r" /* hasEmailScope */])(state),
      isGoogleAuthed: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["g" /* getIsGoogleOauthConnected */])(state),
      isMicrosoftAuthed: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["i" /* getIsMicrosoftOauthConnected */])(state),
      isTokenRevoked: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["j" /* getIsTokenRevoked */])(state),
      calendar: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["b" /* getCalendar */])(state),
      isCalendarPending: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["d" /* getCalendarStatusPending */])(state),
      isCalendarLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["c" /* getCalendarStatusLoaded */])(state),
      isSettingsLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["x" /* isMeetingSettingsLoaded */])(state),
      currentUser: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["currentUser"])(state),
      meetingSettings: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["f" /* getDefaultMeetingType */])(state),
      hasMeetings: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["l" /* hasMeetings */])(state),
      hasBetaGlobalCalendars: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["e" /* hasBetaGlobalCalendars */])(state),
      isGlobalCalendarManaged: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["t" /* hasMicrosoftAdminConsent */])(state),
      isGlobalAdminConsentLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["v" /* isFetchMicrosoftAdminConsentLoaded */])(state),
      isOnFreePlan: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state),
      meetingTypes: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["o" /* getMeetingTypes */])(state),
      isMeetingTypesLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["y" /* isMeetingTypesLoaded */])(state)
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["r" /* fetchCalendarStatus */],
      updateMeetingType: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["_31" /* updateMeetingType */],
      fetchGoogleScopes: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["G" /* fetchGoogleScopes */],
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["_23" /* updateMeetingSettings */],
      disconnectGoogleCalendar: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["f" /* disconnectGoogleCalendar */],
      disconnectMicrosoftCalendar: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["n" /* disconnectMicrosoftCalendar */],
      fetchMicrosoftAdminConsent: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["S" /* fetchMicrosoftAdminConsent */],
      fetchMeetingTypes: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["O" /* fetchMeetingTypes */]
    }, dispatch)
  };
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (!this.props.isCalendarLoaded || !this.props.isSettingsLoaded || !this.props.isMeetingTypesLoaded) {
      this.props.actions.fetchCalendarStatus();
      this.props.actions.fetchGoogleScopes();
      this.props.actions.fetchMeetingSettings();
      this.props.actions.fetchMicrosoftAdminConsent();
      this.props.actions.fetchMeetingTypes();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isCreatingNew', 'setIsCreatingNew', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isUpgradeModalOpen', 'setUpgradeModal', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('activeTab', 'setActiveTab', 0), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  handleCreateMeetingType: function handleCreateMeetingType(props) {
    return function () {
      props.setIsCreatingNew(true);
      setTimeout(function () {
        props.router.push('/settings/calendar/edit/new');
      }, 400);
    };
  },
  handleGoogleCalendarScopeAdded: function handleGoogleCalendarScopeAdded(props) {
    return function () {
      props.actions.fetchGoogleScopes();
    };
  },
  handleDisconnectCalendar: function handleDisconnectCalendar(_ref) {
    var isGoogleAuthed = _ref.isGoogleAuthed,
        actions = _ref.actions;
    return function () {
      isGoogleAuthed ? actions.disconnectGoogleCalendar() : actions.disconnectMicrosoftCalendar();
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref2) {
  var isCalendarLoaded = _ref2.isCalendarLoaded,
      isSettingsLoaded = _ref2.isSettingsLoaded,
      isGlobalAdminConsentLoaded = _ref2.isGlobalAdminConsentLoaded;
  return !isCalendarLoaded || !isSettingsLoaded || !isGlobalAdminConsentLoaded;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        meetingSettings = _props.meetingSettings,
        isGoogleAuthed = _props.isGoogleAuthed,
        isMicrosoftAuthed = _props.isMicrosoftAuthed,
        isGlobalCalendarManaged = _props.isGlobalCalendarManaged,
        actions = _props.actions;
    // if allowNewAppointments if false while customer is connected they're in a bad state.
    // So enable it, pronto. This is > a clumsy settings backfill. - pk2

    if (!meetingSettings.allowNewAppointments && (isGoogleAuthed || isMicrosoftAuthed || isGlobalCalendarManaged)) {
      actions.updateMeetingSettings(meetingSettings.set('allowNewAppointments', true));
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (!(nextProps.calendar && nextProps.calendar.id)) {
      nextProps.router.replace('/settings/calendar/connect');
    }
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "ZUYt":
/***/ (function(module, exports) {

module.exports = "<svg width=\"57\" height=\"52\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><ellipse fill=\"#DAEAF1\" cx=\"27.299\" cy=\"26\" rx=\"26.365\" ry=\"26\"></ellipse><g transform=\"translate(0 4.571)\"><polygon fill=\"#FFF\" fill-rule=\"nonzero\" points=\"0.78974359 4.67281106 0.78974359 39.718894 53.6307692 39.718894 53.6307692 4.67281106\"></polygon><path d=\"M0 4.86c0-.534.439-.966.98-.966h52.46c.541 0 .98.432.98.966v34.672a.973.973 0 0 1-.98.966H.98a.973.973 0 0 1-.98-.966V4.86zm1.961.966v32.74H52.46V5.826H1.961z\" fill=\"#2C3E48\" fill-rule=\"nonzero\"></path><rect fill=\"#2A3E4A\" x=\"38.985\" width=\"3.159\" height=\"7.788\" rx=\".505\"></rect><rect fill=\"#2A3E4A\" x=\"12.636\" width=\"3.159\" height=\"7.788\" rx=\".505\"></rect></g><path d=\"M26.272 39.168c6.542 0 11.846-5.23 11.846-11.682 0-2.081-.552-4.035-1.52-5.728-.768-1.345 4.679-1.345.73-7.511-3.949-6.167-6.298 2.43-7.78 2.01a12.008 12.008 0 0 0-3.276-.453c-6.543 0-11.846 5.23-11.846 11.682s5.303 11.682 11.846 11.682z\" fill=\"#FFF\"></path><g transform=\"translate(20.744 18.92)\" fill=\"#AE55CD\" fill-rule=\"nonzero\"><path d=\"M6.053.743C6.615-.18 7.875.535 7.568 1.6l-1.864 6.1h3.422c.708 0 1.11.922.68 1.563l-6.363 9.498c-.596.89-1.824.121-1.483-.928l2.033-6.368H1.14c-.691 0-1.097-.883-.703-1.529L6.053.743z\"></path><polygon points=\"6.72747396 3.48258859 2.56666667 10.296619 5.61792534 10.296619 3.76867767 15.9874574 8.48425926 8.94878878 5.15432947 8.94878878\"></polygon></g><ellipse fill=\"#E85965\" cx=\"47.266\" cy=\"39.947\" rx=\"8.64\" ry=\"8.567\"></ellipse><ellipse stroke=\"#2C3E49\" stroke-width=\"1.947\" cx=\"47.266\" cy=\"39.947\" rx=\"8.64\" ry=\"8.567\"></ellipse><path d=\"M50.018 37.825a.725.725 0 0 1 1.03 0 .736.736 0 0 1 0 1.037l-3.96 3.985a.725.725 0 0 1-1.03 0l-1.69-1.7a.736.736 0 0 1 0-1.038.725.725 0 0 1 1.03 0l1.175 1.183 3.445-3.467z\" fill=\"#FFF\" fill-rule=\"nonzero\"></path><path d=\"M36.013 16.229l-2.963 2.923\" fill=\"#384F5B\"></path><path d=\"M36.013 16.229l-2.963 2.923\" stroke=\"#384F5B\" stroke-width=\"1.035\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M31.26 15.15l-.428 2.021\" fill=\"#384F5B\"></path><path d=\"M31.26 15.15l-.428 2.021\" stroke=\"#384F5B\" stroke-width=\"1.035\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M36.966 20.672l-2.67.629\" fill=\"#384F5B\"></path><path d=\"M36.966 20.672l-2.67.629\" stroke=\"#384F5B\" stroke-width=\"1.035\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></svg>"

/***/ }),

/***/ "ZWQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AnswerModalContent":"AnswerModalContent---1LoZW","ConversationPreview":"ConversationPreview---3gbM8"};

/***/ }),

/***/ "ZWSh":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.702 14.635C2.997 6.115 10.665 0 20 0c11.2 0 20 8.8 20 20s-8.8 20-20 20C10.383 40 2.536 33.512.51 24.588h18.42v6.635L30.54 19.61 18.93 8v6.635H.7z\" fill=\"#13DDB0\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ZXW5":
/***/ (function(module, exports) {

module.exports = "<svg width=\"26\" height=\"36\" viewBox=\"0 0 26 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 27.063V25h2v2.063c3.823.492 6.5 3.788 6.5 7.937v1h-15v-1c0-4.15 2.677-7.445 6.5-7.937zm2-23.33a2 2 0 1 0-2 0V7H3.005A3 3 0 0 0 0 9.994v12.012A3 3 0 0 0 3.005 25h19.99A3 3 0 0 0 26 22.006V9.994A3 3 0 0 0 22.995 7H14V3.732zM2 9.993A1 1 0 0 1 3.005 9h19.99A1 1 0 0 1 24 9.994v12.012a1 1 0 0 1-1.005.994H3.005A1 1 0 0 1 2 22.006V9.994zM7.567 34c.401-2.925 2.557-5 5.433-5s5.032 2.075 5.433 5H7.567zM8.5 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm9 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ZbBQ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./actions/ApiKeyActions": "qMuy",
	"./actions/ApiKeyActions.js": "qMuy",
	"./actions/BotActions": "sE9z",
	"./actions/BotActions.js": "sE9z",
	"./actions/CampaignActions": "1hGQ",
	"./actions/CampaignActions.js": "1hGQ",
	"./actions/CompanyActions": "FvBW",
	"./actions/CompanyActions.js": "FvBW",
	"./actions/ConversationActions": "Uy7L",
	"./actions/ConversationActions.js": "Uy7L",
	"./actions/DefaultEmbedActions": "rMfo",
	"./actions/DefaultEmbedActions.js": "rMfo",
	"./actions/DraftActions": "+st4",
	"./actions/DraftActions.js": "+st4",
	"./actions/EmbedActions": "VSu+",
	"./actions/EmbedActions.js": "VSu+",
	"./actions/EndUserActions": "ZF7Z",
	"./actions/EndUserActions.js": "ZF7Z",
	"./actions/GateActions": "XOYT",
	"./actions/GateActions.js": "XOYT",
	"./actions/GlobalModalActions": "VGs4",
	"./actions/GlobalModalActions.js": "VGs4",
	"./actions/InboxActions": "Bo47",
	"./actions/InboxActions.js": "Bo47",
	"./actions/IntegrationsActions": "N53e",
	"./actions/IntegrationsActions.js": "N53e",
	"./actions/LocaleActions": "D4Fr",
	"./actions/LocaleActions.js": "D4Fr",
	"./actions/NoteActions": "0Ikz",
	"./actions/NoteActions.js": "0Ikz",
	"./actions/NotificationActions": "P/EE",
	"./actions/NotificationActions.js": "P/EE",
	"./actions/OrgActions": "qNcR",
	"./actions/OrgActions.js": "qNcR",
	"./actions/OrgPropertiesActions": "khh8",
	"./actions/OrgPropertiesActions.js": "khh8",
	"./actions/OrgSettingsActions": "MQX+",
	"./actions/OrgSettingsActions.js": "MQX+",
	"./actions/PusherActions": "hD9j",
	"./actions/PusherActions.js": "hD9j",
	"./actions/SavedReplyActions": "uhyN",
	"./actions/SavedReplyActions.js": "uhyN",
	"./actions/SearchActions": "AmoF",
	"./actions/SearchActions.js": "AmoF",
	"./actions/SegmentActions": "QGO0",
	"./actions/SegmentActions.js": "QGO0",
	"./actions/SlackTeamActions": "ZcQw",
	"./actions/SlackTeamActions.js": "ZcQw",
	"./actions/TagActions": "YGS8",
	"./actions/TagActions.js": "YGS8",
	"./actions/TeamsActions": "wvzT",
	"./actions/TeamsActions.js": "wvzT",
	"./actions/TranslationActions": "xwdT",
	"./actions/TranslationActions.js": "xwdT",
	"./actions/UserActions": "st9s",
	"./actions/UserActions.js": "st9s",
	"./actions/UserPropertiesActions": "oIkF",
	"./actions/UserPropertiesActions.js": "oIkF",
	"./queries/ApiKeyQueries": "DYVe",
	"./queries/ApiKeyQueries.js": "DYVe",
	"./queries/CampaignQueries": "h41x",
	"./queries/CampaignQueries.js": "h41x",
	"./queries/CompanyQueries": "lGef",
	"./queries/CompanyQueries.js": "lGef",
	"./queries/ConversationQueries": "caNN",
	"./queries/ConversationQueries.js": "caNN",
	"./queries/DefaultEmbedQueries": "TSCa",
	"./queries/DefaultEmbedQueries.js": "TSCa",
	"./queries/EmbedQueries": "ISL8",
	"./queries/EmbedQueries.js": "ISL8",
	"./queries/EndUserQueries": "qTcJ",
	"./queries/EndUserQueries.js": "qTcJ",
	"./queries/EndUserTokenQueries": "OMDX",
	"./queries/EndUserTokenQueries.js": "OMDX",
	"./queries/GateQueries": "6hwE",
	"./queries/GateQueries.js": "6hwE",
	"./queries/InboxQueries": "3WI9",
	"./queries/InboxQueries.js": "3WI9",
	"./queries/IntegrationsQueries": "Qd9x",
	"./queries/IntegrationsQueries.js": "Qd9x",
	"./queries/NoteQueries": "IDni",
	"./queries/NoteQueries.js": "IDni",
	"./queries/OrgPropertiesQueries": "LYdG",
	"./queries/OrgPropertiesQueries.js": "LYdG",
	"./queries/OrgQueries": "jwnV",
	"./queries/OrgQueries.js": "jwnV",
	"./queries/ReportQueries": "Mmqy",
	"./queries/ReportQueries.js": "Mmqy",
	"./queries/SavedReplyQueries": "WJD2",
	"./queries/SavedReplyQueries.js": "WJD2",
	"./queries/SegmentQueries": "wLCu",
	"./queries/SegmentQueries.js": "wLCu",
	"./queries/TagQueries": "PVNM",
	"./queries/TagQueries.js": "PVNM",
	"./queries/TargetConditionQueries": "Z1E+",
	"./queries/TargetConditionQueries.js": "Z1E+",
	"./queries/UserPropertiesQueries": "NL/f",
	"./queries/UserPropertiesQueries.js": "NL/f",
	"./queries/UserQueries": "aXca",
	"./queries/UserQueries.js": "aXca",
	"./sources/ApiKeyAPI": "rhnZ",
	"./sources/ApiKeyAPI.js": "rhnZ",
	"./sources/CampaignAPI": "FaLI",
	"./sources/CampaignAPI.js": "FaLI",
	"./sources/CompanyAPI": "jbnd",
	"./sources/CompanyAPI.js": "jbnd",
	"./sources/ConversationAPI": "KQYP",
	"./sources/ConversationAPI.js": "KQYP",
	"./sources/DefaultEmbedAPI": "1FFt",
	"./sources/DefaultEmbedAPI.js": "1FFt",
	"./sources/EmbedAPI": "hDPW",
	"./sources/EmbedAPI.js": "hDPW",
	"./sources/EndUserAPI": "zu27",
	"./sources/EndUserAPI.js": "zu27",
	"./sources/EndUserTokenAPI": "DPIX",
	"./sources/EndUserTokenAPI.js": "DPIX",
	"./sources/EventAPI": "8v82",
	"./sources/EventAPI.js": "8v82",
	"./sources/GateAPI": "pi86",
	"./sources/GateAPI.js": "pi86",
	"./sources/InboxAPI": "6rnP",
	"./sources/InboxAPI.js": "6rnP",
	"./sources/IntegrationsAPI": "UCyF",
	"./sources/IntegrationsAPI.js": "UCyF",
	"./sources/MetricAPI": "MwRK",
	"./sources/MetricAPI.js": "MwRK",
	"./sources/NoteAPI": "0hmb",
	"./sources/NoteAPI.js": "0hmb",
	"./sources/OrgAPI": "fp2m",
	"./sources/OrgAPI.js": "fp2m",
	"./sources/OrgPropertiesAPI": "mgTr",
	"./sources/OrgPropertiesAPI.js": "mgTr",
	"./sources/ReportAPI": "CL+O",
	"./sources/ReportAPI.js": "CL+O",
	"./sources/SavedReplyAPI": "TKIo",
	"./sources/SavedReplyAPI.js": "TKIo",
	"./sources/SegmentAPI": "cyc6",
	"./sources/SegmentAPI.js": "cyc6",
	"./sources/TagAPI": "otDV",
	"./sources/TagAPI.js": "otDV",
	"./sources/UserAPI": "S6Q/",
	"./sources/UserAPI.js": "S6Q/",
	"./sources/UserPropertiesAPI": "lc4l",
	"./sources/UserPropertiesAPI.js": "lc4l",
	"./stores/ApiKeyStore": "O9CT",
	"./stores/ApiKeyStore.js": "O9CT",
	"./stores/AvailabilityStore": "D5er",
	"./stores/AvailabilityStore.js": "D5er",
	"./stores/BotStore": "7e6o",
	"./stores/BotStore.js": "7e6o",
	"./stores/CampaignStore": "JL2A",
	"./stores/CampaignStore.js": "JL2A",
	"./stores/CompanyStore": "RKqz",
	"./stores/CompanyStore.js": "RKqz",
	"./stores/ConversationStore": "0fRW",
	"./stores/ConversationStore.js": "0fRW",
	"./stores/DashboardStore": "ey39",
	"./stores/DashboardStore.js": "ey39",
	"./stores/DefaultEmbedStore": "2m6g",
	"./stores/DefaultEmbedStore.js": "2m6g",
	"./stores/EmbedStore": "wWXe",
	"./stores/EmbedStore.js": "wWXe",
	"./stores/EndUserCountStore": "rzwA",
	"./stores/EndUserCountStore.js": "rzwA",
	"./stores/EndUserGrowthStore": "Ox78",
	"./stores/EndUserGrowthStore.js": "Ox78",
	"./stores/EndUserStore": "dhv+",
	"./stores/EndUserStore.js": "dhv+",
	"./stores/EndUserTokenStore": "R6PS",
	"./stores/EndUserTokenStore.js": "R6PS",
	"./stores/GateStore": "fCd/",
	"./stores/GateStore.js": "fCd/",
	"./stores/GlobalModalStore": "m1DN",
	"./stores/GlobalModalStore.js": "m1DN",
	"./stores/InboxStore": "gIr2",
	"./stores/InboxStore.js": "gIr2",
	"./stores/IntegrationsStore": "cHrg",
	"./stores/IntegrationsStore.js": "cHrg",
	"./stores/LocaleStore": "n1b9",
	"./stores/LocaleStore.js": "n1b9",
	"./stores/NoteStore": "TT4J",
	"./stores/NoteStore.js": "TT4J",
	"./stores/NotificationStore": "+YYK",
	"./stores/NotificationStore.js": "+YYK",
	"./stores/OrgPropertiesStore": "wrqW",
	"./stores/OrgPropertiesStore.js": "wrqW",
	"./stores/OrgSettingsStore": "9Myh",
	"./stores/OrgSettingsStore.js": "9Myh",
	"./stores/OrgStore": "9tpJ",
	"./stores/OrgStore.js": "9tpJ",
	"./stores/ReportStore": "M37C",
	"./stores/ReportStore.js": "M37C",
	"./stores/SavedReplyStore": "btml",
	"./stores/SavedReplyStore.js": "btml",
	"./stores/SegmentStore": "qbtw",
	"./stores/SegmentStore.js": "qbtw",
	"./stores/SlackTeamStore": "0/Ul",
	"./stores/SlackTeamStore.js": "0/Ul",
	"./stores/TagStore": "asTl",
	"./stores/TagStore.js": "asTl",
	"./stores/TargetConditionStore": "x4Zn",
	"./stores/TargetConditionStore.js": "x4Zn",
	"./stores/TeamsStore": "UWAF",
	"./stores/TeamsStore.js": "UWAF",
	"./stores/TranslationStore": "IIdC",
	"./stores/TranslationStore.js": "IIdC",
	"./stores/UserPropertiesStore": "2Est",
	"./stores/UserPropertiesStore.js": "2Est",
	"./stores/UserStore": "4YZ8",
	"./stores/UserStore.js": "4YZ8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZbBQ";

/***/ }),

/***/ "ZbX0":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 22 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.86 1.425c1.32 0 2.47.716 3.084 1.777.533-.23 1.123-.36 1.744-.36 2.38 0 4.312 1.892 4.312 4.226s-1.93 4.225-4.312 4.225c-.29 0-.574-.028-.85-.082-.54.937-1.57 1.57-2.75 1.57-.495 0-.962-.11-1.38-.31-.546 1.252-1.822 2.13-3.31 2.13-1.548 0-2.868-.952-3.374-2.287-.22.046-.45.07-.686.07C2.494 12.383 1 10.916 1 9.106c0-1.213.67-2.272 1.67-2.838-.206-.46-.32-.967-.32-1.5C2.35 2.69 4.09 1 6.233 1c1.26 0 2.38.582 3.09 1.483.644-.653 1.542-1.058 2.535-1.058z\" stroke=\"#7695A5\" fill-rule=\"nonzero\" fill=\"none\"></path></svg>"

/***/ }),

/***/ "ZcQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__ = __webpack_require__("XmeL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_SlackTeamAPI__ = __webpack_require__("huaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SlackTeamActions = function (_Marty$ActionCreators) {
  _inherits(SlackTeamActions, _Marty$ActionCreators);

  function SlackTeamActions() {
    _classCallCheck(this, SlackTeamActions);

    return _possibleConstructorReturn(this, (SlackTeamActions.__proto__ || Object.getPrototypeOf(SlackTeamActions)).apply(this, arguments));
  }

  _createClass(SlackTeamActions, [{
    key: 'fetchSlackTeam',
    value: function fetchSlackTeam() {
      var _this2 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].FETCH_SLACK_TEAM_STARTED);
      return __WEBPACK_IMPORTED_MODULE_1_app_api_SlackTeamAPI__["a" /* default */].fetch().then(function (users) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].FETCH_SLACK_TEAM_FINISHED, users);
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].FETCH_SLACK_TEAM_FAILED);
      });
    }
  }, {
    key: 'sendInvitationsToSlackDM',
    value: function sendInvitationsToSlackDM(users, orgId, scopes) {
      var _this3 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].INVITE_SLACK_USER_STARTED);
      return __WEBPACK_IMPORTED_MODULE_1_app_api_SlackTeamAPI__["a" /* default */].sendInvitations(users, orgId, scopes).then(function (res) {
        if (res.ok) {
          _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].INVITE_SLACK_USER_FINISHED);
          _this3.app.actions.NotificationActions.pushNotification({
            content: "Your invites have been sent!"
          });
        } else {
          _this3.app.actions.NotificationActions.pushNotification({
            content: res.message,
            variant: 'red'
          });
          Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
          _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SlackTeamConstants__["a" /* default */].INVITE_SLACK_USER_FAILED);
        }
      });
    }
  }]);

  return SlackTeamActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (SlackTeamActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "Zd4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Path; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");



var Path = '/customize';

var Routes = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* IndexRedirect */], { key: 'routes-customize-index', to: '/settings/widget' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { key: 'routes-customize-hours', from: 'hours', to: '/settings2/widget/hours-and-targeting' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { key: 'routes-customize-style', from: 'style', to: '/settings2/widget/design' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { key: 'routes-customize-online', from: 'online', to: '/settings/widget' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Redirect */], { key: 'routes-customize-offline', from: 'offline', to: '/settings/widget' })];

/***/ }),

/***/ "ZhFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmailEditCard__ = __webpack_require__("BCsj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styl__ = __webpack_require__("OK9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_styl__);




var EmailMessage = function EmailMessage(_ref) {
  var message = _ref.message,
      headline = _ref.headline,
      renderSelectedUser = _ref.renderSelectedUser,
      emailMessage = _ref.emailMessage,
      dynamicAccountSendAttribute = _ref.dynamicAccountSendAttribute,
      _ref$actions = _ref.actions,
      setSenderName = _ref$actions.setSenderName,
      setMessage = _ref$actions.setMessage,
      setHeadline = _ref$actions.setHeadline,
      setAuthorId = _ref$actions.setAuthorId,
      setEmailOverride = _ref$actions.setEmailOverride;
  return React.createElement(
    'div',
    { className: 'playbook-message' },
    React.createElement(
      'div',
      null,
      React.createElement(
        'h2',
        null,
        'Customize the message your users will see.'
      ),
      React.createElement(
        'h3',
        null,
        'What do you want to say? Keep it short and sweet, be personal and human!'
      )
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__EmailEditCard__["a" /* default */], {
      title: "Email",
      description: headline,
      message: message,
      setSenderName: setSenderName,
      setMessage: setMessage,
      setHeadline: setHeadline,
      setAuthorId: setAuthorId,
      setEmailOverride: setEmailOverride,
      renderSelectedUser: renderSelectedUser,
      dynamicAccountSendAttribute: dynamicAccountSendAttribute,
      emailMessage: emailMessage,
      includeSenderSelect: true,
      includeInboxEmails: true
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailMessage);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Zhpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {/* harmony export (immutable) */ __webpack_exports__["a"] = fetchTimeZone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");



function fetchTimeZone(lat, lng) {
  var query = {
    location: lat + ',' + lng,
    timestamp: Math.floor(new Date().getTime() / 1000),
    key: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["u" /* GOOGLE_API_KEY */]
  };

  var request = fetch('https://maps.googleapis.com/maps/api/timezone/json?' + Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["d" /* encodeQueryData */])(query), {
    method: 'GET'
  });
  return request.then(function (res) {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error('Failed to get timezone from google');
    }
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V")))

/***/ }),

/***/ "Zisu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return didPatchErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isPatchLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('eloqua');
};

var getMappings = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationMappings;
});

var getFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationFields;
});

var didPatchErr = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationMappingsErr;
});

var isPatchLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationPatchLoading;
});

/***/ }),

/***/ "ZjNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("RoXl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var WarningModal = function WarningModal(_ref) {
  var _ref$Service = _ref.Service,
      Service = _ref$Service === undefined ? 'Calendar' : _ref$Service,
      handleCloseModal = _ref.handleCloseModal,
      handleDisconnect = _ref.handleDisconnect;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_components_shared_Modal__["a" /* default */],
    { onClose: handleCloseModal, isOpen: true, style: { content: { padding: 0, width: 450 } } },
    React.createElement(
      'div',
      { className: 'settings-calendar-warning-modal-content' },
      React.createElement(
        'div',
        { className: 'topper' },
        React.createElement(
          'div',
          { className: 'header' },
          'Disconnect ',
          Service,
          ' Account'
        ),
        React.createElement(
          'div',
          { className: 'copy' },
          'You\u2019re about to disconnect your ',
          Service,
          ' Account from Drift.'
        ),
        React.createElement(
          'div',
          { className: 'copy' },
          'This may change your messaging experience:',
          React.createElement(
            'ul',
            null,
            React.createElement(
              'li',
              null,
              'Your calendar will no longer be shared in conversations'
            ),
            React.createElement(
              'li',
              null,
              'Meeting links you\'ve shared will no longer work'
            ),
            React.createElement(
              'li',
              null,
              'You will be unable to use Drift Sequences'
            ),
            React.createElement(
              'li',
              null,
              'Your calendar will no longer be shared by playbooks'
            )
          ),
          React.createElement(
            'div',
            { className: 'helptext' },
            'This will not affect any meetings you have already scheduled.'
          )
        )
      ),
      React.createElement(
        'div',
        { className: 'controls' },
        React.createElement(
          'button',
          { className: 'tide-button tide-button--tertiary', onClick: handleCloseModal },
          'Cancel'
        ),
        React.createElement(
          'button',
          { className: 'tide-button tide-button--danger', onClick: handleDisconnect },
          'Disconnect'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (WarningModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Zl59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tags_selectors__ = __webpack_require__("rRpe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tags_actions__ = __webpack_require__("JK9z");






var mapStateToProps = function mapStateToProps(state) {
  return {
    tagsById: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_tags_selectors__["d" /* tags */])(state),
    _isLoaded: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_tags_selectors__["a" /* isLoaded */])(state),
    _isLoading: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_tags_selectors__["b" /* isLoading */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
    _fetchTagList: __WEBPACK_IMPORTED_MODULE_4_app_modules_tags_actions__["f" /* fetchTagList */]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (!this.props._isLoaded && !this.props._isLoading) {
      this.props._fetchTagList();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["i" /* withProps */])(function (_ref) {
  var _isLoaded = _ref._isLoaded;
  return { isTagsByIdLoaded: _isLoaded };
})));

/***/ }),

/***/ "Zmw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WarningModal__ = __webpack_require__("4hbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_Application__ = __webpack_require__("08hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("Xe1X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_onboarding_google_G_logo_L_svg__ = __webpack_require__("tPhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_images_onboarding_google_G_logo_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_images_onboarding_google_G_logo_L_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var APP = Object(__WEBPACK_IMPORTED_MODULE_13_app_Application__["b" /* getApplication */])();

var GoogleOAuthConnect = function (_Component) {
  _inherits(GoogleOAuthConnect, _Component);

  function GoogleOAuthConnect(props) {
    _classCallCheck(this, GoogleOAuthConnect);

    var _this = _possibleConstructorReturn(this, (GoogleOAuthConnect.__proto__ || Object.getPrototypeOf(GoogleOAuthConnect)).call(this, props));

    _this.getCalendarConnectionSource = function () {
      var params = new URL(window.location).searchParams;
      return params.get('source') || 'organic';
    };

    _this.handlePostMessage = function (e) {
      var _this$props = _this.props,
          onSuccess = _this$props.onSuccess,
          track = _this$props.actions.track;

      var success = e.data.status === 'success';

      if (success) {
        _this.setState({ pending: false }, function () {
          APP.actions.NotificationActions.pushNotification({
            content: 'Your Google account was successfully connected.'
          });
          track('Calendar Connected', { context: 'settings', source: _this.getCalendarConnectionSource() });
          _this.trackEvent('Calendar Setup', { action: 'connected' });
          _this.props.actions.fetchCalendarStatus();
        });
        !!onSuccess && onSuccess(e);
      } else {
        _this.setState({ pending: false }, function () {
          _this.props.setGooglePermissionErrorState(true);
        });
      }
    };

    _this.handleConnectClick = function () {
      _this.setState({
        pending: true
      });

      var params = {
        redirect_uri: __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/google-calendar',
        client_id: __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__["v" /* GOOGLE_CLIENT_ID */],
        response_type: 'code',
        access_type: 'offline',
        include_granted_scopes: true
      };

      if (_this.props.includeEmailScopes) {
        params.scope = __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_constants__["K" /* GoogleScopes */].CALENDAR + ' ' + __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND + ' ' + __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_constants__["K" /* GoogleScopes */].READ;
      } else {
        params.scope = __WEBPACK_IMPORTED_MODULE_15_app_modules_integrations_constants__["K" /* GoogleScopes */].CALENDAR;
      }

      Object(__WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__["b" /* popUp */])({
        path: 'https://accounts.google.com/o/oauth2/v2/auth?' + Object(__WEBPACK_IMPORTED_MODULE_11_utils_Helpers__["d" /* encodeQueryData */])(params),
        onMessage: _this.handlePostMessage
      });
    };

    _this.trackEvent = function (name, attributes) {
      _this.props.actions.track(name, _extends({
        context: 'settings',
        service: 'google-calendar'
      }, attributes));
    };

    _this.handleSaveClick = function (_ref) {
      var calId = _ref.calId;
      var _this$props2 = _this.props,
          onSave = _this$props2.onSave,
          calendars = _this$props2.calendars,
          actions = _this$props2.actions;

      var selectedCalendarId = !!calId ? calId : _this.getSelectedCalendarId();
      var calendar = calendars.find(function (calendar) {
        return calendar.id === selectedCalendarId;
      });
      if (!!calendar) {
        actions.updateCalendar(calendar);
        _this.trackEvent('Calendar Setup', { action: 'updated-calendar', selectedCalendarId: selectedCalendarId });
        window.drift && window.drift.on('ready', function (api) {
          api.setUserAttributes({ first_calendar_connect: true });
        });
        !!onSave && onSave();
      }
    };

    _this.handleShowDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: true
      });
    };

    _this.handleHideDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: false
      });
    };

    _this.handleDisconnectClick = function (e) {
      var disconnectCallback = _this.props.disconnectCallback;

      e.preventDefault();

      _this.setState({
        calendarId: undefined
      }, function () {
        _this.props.actions.disconnectCalendar();
        _this.trackEvent('Calendar Setup', { action: 'disconnected' });
        !!disconnectCallback && disconnectCallback();
      });
    };

    _this.handleCalendarSelect = function (_ref2) {
      var value = _ref2.value;
      var autoSaveSelect = _this.props.autoSaveSelect;

      _this.setState({
        calendarId: value
      }, function () {
        autoSaveSelect && _this.handleSaveClick({ calId: value });
      });
    };

    _this.getSelectedCalendarId = function () {
      if (_this.state.calendarId) {
        return _this.state.calendarId;
      }

      if (_this.props.calendar.id) {
        return _this.props.calendar.id;
      }
    };

    _this.renderCalendarSelect = function () {
      var _this$props3 = _this.props,
          calendars = _this$props3.calendars,
          withDisconnect = _this$props3.withDisconnect;
      var showDisconnectModal = _this.state.showDisconnectModal;

      var selectedCalendarId = _this.getSelectedCalendarId();
      return React.createElement(
        'div',
        { className: 'minimal-ui' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select_plus__["b" /* default */], {
          className: 'minimal-calendar-select',
          value: selectedCalendarId,
          searchable: false,
          clearable: false,
          placeholder: 'Pick a calendar to connect...',
          options: calendars.map(function (calendar) {
            return { value: calendar.id, label: calendar.name };
          }).toArray(),
          onChange: _this.handleCalendarSelect
        }),
        withDisconnect && React.createElement(
          'button',
          { className: 'tide-button medium utility-button minimal-ui-disconnect', onClick: _this.handleShowDisconnectModal },
          'Disconnect'
        ),
        withDisconnect && showDisconnectModal && React.createElement(__WEBPACK_IMPORTED_MODULE_7__WarningModal__["a" /* default */], {
          handleCloseModal: _this.handleHideDisconnectModal,
          handleDisconnect: _this.handleDisconnectClick
        })
      );
    };

    _this.state = {
      pending: false,
      showDisconnectModal: false
    };
    return _this;
  }

  _createClass(GoogleOAuthConnect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var calendars = this.props.calendars;


      if (calendars.size === 1) {
        this.handleSaveClick({ calId: calendars.getIn([0, 'id']) });
      }
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var pending = this.state.pending;
      var buttonLabel = this.props.buttonLabel;

      return React.createElement(
        'button',
        {
          className: 'drift-button drift-button-primary',
          style: { marginLeft: 'auto' },
          onClick: this.handleConnectClick,
          disabled: pending
        },
        pending ? React.createElement(
          'div',
          { className: 'flex flex-center' },
          'Connecting ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Loading__["a" /* default */], { style: { marginLeft: '0.5rem' }, size: 'small' })
        ) : buttonLabel || 'Connect'
      );
    }
  }, {
    key: 'renderNotConnected',
    value: function renderNotConnected() {
      var minimalUI = this.props.minimalUI;


      if (minimalUI) {
        return this.renderButton();
      }

      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_16__style_styl___default.a.OAuthConnect },
        React.createElement(
          'div',
          { className: 'service-icon' },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_17_images_onboarding_google_G_logo_L_svg___default.a, alt: 'google logo' })
        ),
        React.createElement(
          'div',
          { className: 'service-info media-body' },
          React.createElement(
            'div',
            { className: 'service-name' },
            'Google Calendar'
          ),
          React.createElement(
            'div',
            { className: 'service-description' },
            'Allows Drift to check your Google Calendar for conflicts and add events to it.'
          )
        ),
        React.createElement(
          'div',
          { style: { marginLeft: 'auto', paddingLeft: '1.5rem' } },
          this.renderButton()
        )
      );
    }
  }, {
    key: 'renderConnected',
    value: function renderConnected() {
      var _props = this.props,
          googleAuthed = _props.googleAuthed,
          minimalUI = _props.minimalUI,
          buttonLabel = _props.buttonLabel,
          title = _props.title,
          _props$withDisconnect = _props.withDisconnect,
          withDisconnect = _props$withDisconnect === undefined ? false : _props$withDisconnect,
          _props$autoSaveSelect = _props.autoSaveSelect,
          autoSaveSelect = _props$autoSaveSelect === undefined ? false : _props$autoSaveSelect,
          _props$hideIcon = _props.hideIcon,
          hideIcon = _props$hideIcon === undefined ? false : _props$hideIcon;


      if (minimalUI) {
        return this.renderCalendarSelect();
      }

      var _state = this.state,
          pending = _state.pending,
          showDisconnectModal = _state.showDisconnectModal;

      var selectedCalendarId = this.getSelectedCalendarId();
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_16__style_styl___default.a.OAuthConnect },
        !hideIcon && React.createElement(
          'div',
          { className: 'service-icon' },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_17_images_onboarding_google_G_logo_L_svg___default.a, alt: 'google logo' })
        ),
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("service-info media-body", { 'hide-icon': hideIcon }) },
          !hideIcon && React.createElement(
            'div',
            { className: 'service-name' },
            !!title ? title : 'Google Calendar'
          ),
          React.createElement(
            'div',
            { className: 'drift-form' },
            React.createElement(
              'div',
              { className: 'calendar-selector-wrapper' },
              React.createElement(
                'div',
                { className: 'calendar-select-inner' },
                this.renderCalendarSelect()
              ),
              withDisconnect && React.createElement(
                __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
                {
                  type: 'danger',
                  size: 'small',
                  disabled: !googleAuthed,
                  onClick: this.handleShowDisconnectModal
                },
                'Disconnect'
              ),
              !autoSaveSelect && React.createElement(
                __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
                {
                  onClick: this.handleSaveClick,
                  disabled: !selectedCalendarId,
                  loading: pending
                },
                !!buttonLabel ? buttonLabel : 'Save'
              )
            )
          )
        ),
        withDisconnect && showDisconnectModal && React.createElement(__WEBPACK_IMPORTED_MODULE_7__WarningModal__["a" /* default */], {
          handleCloseModal: this.handleHideDisconnectModal,
          handleDisconnect: this.handleDisconnectClick
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          googleAuthed = _props2.googleAuthed,
          isMissingScopes = _props2.isMissingScopes;

      if (!googleAuthed || isMissingScopes) {
        return this.renderNotConnected();
      } else {
        return this.renderConnected();
      }
    }
  }]);

  return GoogleOAuthConnect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    googleAuthed: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["g" /* getIsGoogleOauthConnected */])(state),
    calendar: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["b" /* getCalendar */])(state),
    calendars: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["e" /* getCalendars */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["r" /* fetchCalendarStatus */],
      updateCalendar: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["_19" /* updateGoogleCalendar */],
      disconnectCalendar: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["f" /* disconnectGoogleCalendar */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["_23" /* updateMeetingSettings */],
      track: __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(GoogleOAuthConnect));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "Zpgp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_Oxford__ = __webpack_require__("8/nX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RepAvatarPreview__ = __webpack_require__("jrVC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_close_svg__ = __webpack_require__("DHpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_images_svg_pencil_svg__ = __webpack_require__("3iTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_inline_images_svg_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__svg_inline_images_svg_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("jdCl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);

















var standardPreview = function standardPreview(conditionValues, getValueDisplay) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_Oxford__["a" /* default */], {
    items: conditionValues.map(getValueDisplay).map(function (x) {
      return !!x ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        x
      ) : '""';
    }).toJS(),
    limit: 2,
    conjunction: 'or'
  });
};

var TeamPreview = function TeamPreview(_ref) {
  var teams = _ref.teams,
      teamIds = _ref.teamIds;

  var items = teamIds.map(function (teamId) {
    return teams.find(function (t) {
      return t.id === teamId;
    });
  }).map(function (team) {
    return !!team ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      team.name
    ) : '';
  }).toJS();
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_Oxford__["a" /* default */], { items: items, limit: 3, conjunction: 'or' });
};

var EmailPlaybookPreview = function EmailPlaybookPreview(_ref2) {
  var getPlaybookIdForCampaignId = _ref2.getPlaybookIdForCampaignId,
      getIsPlaybookIdForCampaignIdLoading = _ref2.getIsPlaybookIdForCampaignIdLoading,
      playbooks = _ref2.playbooks,
      value = _ref2.value;

  try {
    var campaignId = parseInt(value.first().split('=')[1]);
    var isLoading = getIsPlaybookIdForCampaignIdLoading(campaignId);
    if (isLoading) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_LoadingDots__["a" /* default */], null)
    );

    var playbook = playbooks.get('' + getPlaybookIdForCampaignId(campaignId));
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      'Came to website from email in',
      ' ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
        { to: '/reports/playbooks/' + playbook.get('id'), target: '_blank' },
        playbook.get('name')
      )
    );
  } catch (err) {
    // TODO: we don't have the campaign yet, it's being fetched
    return null;
  }
};

var ConditionPreview = function ConditionPreview(_ref3) {
  var teams = _ref3.teams,
      playbooks = _ref3.playbooks,
      _ref3$condition = _ref3.condition,
      field = _ref3$condition.field,
      operator = _ref3$condition.operator,
      value = _ref3$condition.value,
      onDeleteClick = _ref3.onDeleteClick,
      onEditClick = _ref3.onEditClick,
      getSegmentNames = _ref3.getSegmentNames,
      getPlaybookIdForCampaignId = _ref3.getPlaybookIdForCampaignId,
      getIsPlaybookIdForCampaignIdLoading = _ref3.getIsPlaybookIdForCampaignIdLoading,
      isOutboundPlaybook = _ref3.isOutboundPlaybook,
      isOutboundSessionCondition = _ref3.isOutboundSessionCondition,
      isEmailPlaybookCondition = _ref3.isEmailPlaybookCondition,
      isTeamCondition = _ref3.isTeamCondition,
      isSegment = _ref3.isSegment,
      isOnFreePlan = _ref3.isOnFreePlan;

  var _ConditionTypes$get = __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["S" /* ConditionTypes */].get(field),
      displayName = _ConditionTypes$get.displayName,
      _ConditionTypes$get$g = _ConditionTypes$get.getValueDisplay,
      getValueDisplay = _ConditionTypes$get$g === undefined ? function (x) {
    return '' + x;
  } : _ConditionTypes$get$g;

  var conditionValues = _.get(value, 'join', false) ? value : __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of(value);
  var displayStaticOutboundCondition = isOutboundPlaybook && isOutboundSessionCondition;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("playbook-condition-preview flex-space-between", {
        'playbook-condition-preview-disabled': isOnFreePlan || displayStaticOutboundCondition
      }) },
    displayStaticOutboundCondition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      'Clicked a link to your website from a ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'b',
        null,
        'Drift Sequence'
      ),
      ', an ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'b',
        null,
        'Outreach Sequence'
      ),
      ', a ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'b',
        null,
        'Salesloft Cadence'
      ),
      ', or an email sent with the ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'b',
        null,
        'Drift Extension'
      ),
      '.'
    ),
    isSegment && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-preview-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        displayName,
        '\xA0'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        standardPreview(getSegmentNames(conditionValues), getValueDisplay)
      )
    ),
    isEmailPlaybookCondition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-preview-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmailPlaybookPreview, {
        getPlaybookIdForCampaignId: getPlaybookIdForCampaignId,
        playbooks: playbooks,
        getIsPlaybookIdForCampaignIdLoading: getIsPlaybookIdForCampaignIdLoading,
        value: value
      })
    ),
    isTeamCondition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-preview-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_4_humanize_plus__["pluralize"])(conditionValues.size, 'Team'),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TeamPreview, { teams: teams, teamIds: conditionValues }),
        ' ',
        conditionValues.size > 1 ? __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_138" /* OperatorToDisplay */][operator].replace('is', 'are') : __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_138" /* OperatorToDisplay */][operator]
      )
    ),
    !isEmailPlaybookCondition && !isTeamCondition && !isSegment && !displayStaticOutboundCondition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-preview-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        displayName,
        '\xA0',
        __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_138" /* OperatorToDisplay */][operator],
        '\xA0'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        field === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["R" /* ConditionType */].OUTBOUND_REP ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RepAvatarPreview__["a" /* default */], { listOfSelectedIds: conditionValues }) : standardPreview(conditionValues, getValueDisplay)
      )
    ),
    !isOnFreePlan && !displayStaticOutboundCondition && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { className: 'playbook-condition-preview-icon', onClick: onEditClick, src: __WEBPACK_IMPORTED_MODULE_11__svg_inline_images_svg_pencil_svg___default.a }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { className: 'playbook-condition-preview-icon', onClick: onDeleteClick, src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_removeTags_true_images_svg_close_svg___default.a })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConditionPreview);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "ZsVd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_Drift_full_svg__ = __webpack_require__("kl36");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_Drift_full_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_Drift_full_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("oDAH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);







var HeaderBrand = function HeaderBrand(_ref) {
  var large = _ref.large;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
    { to: '/' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.HeaderBrand, { large: large }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_Drift_full_svg___default.a })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (HeaderBrand);

/***/ }),

/***/ "ZuE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sendDriftAppMetric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendDriftAppMetricPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return sendDriftAppMetricFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sendDriftAppMetricSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return enterRootAppRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return startConversationsAppTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return recordConversationsAppTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hitConversationsAppRenderCheckpoint; });
/* unused harmony export trackPresenceLoadTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("BP1X");



var sendDriftAppMetric = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SEND_DRIFT_APP_METRIC */]);
var sendDriftAppMetricPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* SEND_DRIFT_APP_METRIC_PENDING */]);
var sendDriftAppMetricFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SEND_DRIFT_APP_METRIC_FAILED */]);
var sendDriftAppMetricSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* SEND_DRIFT_APP_METRIC_SUCCESS */]);

var enterRootAppRoute = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ENTER_ROOT_APP_ROUTE */]);
var startConversationsAppTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* START_CONVERSATIONS_APP_TIMER */]);
var recordConversationsAppTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RECORD_CONVERSATIONS_APP_TIMER */]);
var hitConversationsAppRenderCheckpoint = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* HIT_CONVERSATIONS_APP_RENDER_CHECKPOINT */]);

var trackPresenceLoadTime = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRACK_PRESENCE_LOAD_TIME */]);

/***/ }),

/***/ "Zyf8":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "a/+K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("hKIp");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var targetsById = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchTargetsSuccess */], function (state, action) {
  return action.payload.reduce(function (acc, target) {
    return acc.set(target.id, target);
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* updateTargetSuccess */], function (state, action) {
  return state.setIn(['targetsById', action.payload.id], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload));
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var lastCreatedTargetId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createTargetSuccess */], function (state, action) {
  return action.payload.id;
}), -1);

var lastUpdatedTargetId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* updateTargetSuccess */], function (state, action) {
  return action.payload.id;
}), -1);

var status = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchTargetsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchTargetsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchTargetsFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["k" /* updateTargetPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* updateTargetSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* updateTargetFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* createTargetPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createTargetSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* createTargetFailed */]), function (state, action) {
  return action.type;
}), false);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  targetsById: targetsById,
  status: status,
  lastCreatedTargetId: lastCreatedTargetId,
  lastUpdatedTargetId: lastUpdatedTargetId
}));

/***/ }),

/***/ "a/xs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("N/SQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("RBcE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__ = __webpack_require__("TFJD");







var getApiKeyForOrgEpic = function getApiKeyForOrgEpic(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* getApiKeyForOrg */].toString()).pluck('payload').switchMap(function () {
    var orgId = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["orgId"])(getState());

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].getApiKeyForOrg(orgId).map(function (response) {
      if (!!response && !!response.length) {
        return __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* getApiKeyForOrgSuccess */](response);
      } else {
        return __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* createApiKeyForOrg */]();
      }
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* getApiKeyForOrgPending */](orgId)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* getApiKeyForOrgFailed */]({ error: error, orgId: orgId }));
    });
  });
};

var createApiKeyForOrgEpic = function createApiKeyForOrgEpic(action$, _ref2) {
  var getState = _ref2.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* createApiKeyForOrg */].toString()).pluck('payload').switchMap(function () {
    var orgId = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["orgId"])(getState());

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].createApiKeyForOrg(orgId).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createApiKeyForOrgSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* createApiKeyForOrgPending */](orgId)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* createApiKeyForOrgFailed */]({ error: error, orgId: orgId }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(getApiKeyForOrgEpic, createApiKeyForOrgEpic);

/***/ }),

/***/ "a0kp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a1ge":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"23\" viewBox=\"0 0 25 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.516 9.953C24.516 4.453 19.04 0 12.258 0 5.476 0 0 4.452 0 9.953c0 3.318 1.986 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.844 4.084-.14.14-.17.368-.113.567a.524.524 0 0 0 .482.312c2.95 0 5.335-1.93 6.612-3.206.652.086 1.362.142 2.07.142 6.783 0 12.26-4.452 12.26-9.953z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "a2hK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRESENCE_DIFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PRESENCE_DIFF_LEAVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SEND_WELCOME_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SEND_WELCOME_MESSAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SEND_WELCOME_MESSAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_NEW_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_NEW_SORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_FILTER_KNOWN_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_PAGINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_CUSTOM_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_SHOW_MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INITIALIZE_PRESENCE_FOR_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_PRESENCE_IS_RECEIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOTSTRAP_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BOOTSTRAP_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BOOTSTRAP_USER_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_BUFFERED_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_PROCESS_ALL_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_USER_PROCESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return REMOVE_USER_PROCESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REMOVE_USER_PROCESSED_DELAYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SEND_ACTIVE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_PRESENCE_PROBLEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_PRESENCE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_NEW_LIVE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_PRESENCE_STATE_ON_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CANCEL_PRESENCE_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_HAS_PROCESSED_USERS; });
/* unused harmony export PresenceChannel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PhoenixStatus; });
/* unused harmony export WORKER_DEBUG_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MESSAGE_SENT; });
var PRESENCE_ACTION_PREFIX = '@@app/presence';
var makeConstant = function makeConstant(constant) {
  return PRESENCE_ACTION_PREFIX + '/' + constant;
};

var PRESENCE_DIFF = makeConstant('PRESENCE_DIFF');
var PRESENCE_DIFF_LEAVES = makeConstant('PRESENCE_DIFF_LEAVES');

var SEND_WELCOME_MESSAGE = makeConstant('SEND_WELCOME_MESSAGE');
var SEND_WELCOME_MESSAGE_SUCCESS = makeConstant('SEND_WELCOME_MESSAGE_SUCCESS');
var SEND_WELCOME_MESSAGE_FAILURE = makeConstant('SEND_WELCOME_MESSAGE_FAILURE');

var SET_FILTERS = makeConstant('SET_FILTERS');
var SET_NEW_FILTERS = makeConstant('SET_NEW_FILTERS');
var SET_NEW_SORTS = makeConstant('SET_NEW_SORTS');
var SET_FILTER_KNOWN_USERS = makeConstant('SET_FILTER_KNOWN_USERS');
var SET_PAGINATION = makeConstant('SET_PAGINATION');
var SET_CUSTOM_INTERVAL = makeConstant('SET_CUSTOM_INTERVAL');

var SET_SHOW_MORE = makeConstant('SET_SHOW_MORE');

var INITIALIZE_PRESENCE_FOR_USERS = makeConstant('INITIALIZE_PRESENCE_FOR_USERS');
var SET_PRESENCE_IS_RECEIVING = makeConstant('SET_PRESENCE_IS_RECEIVING');

var BOOTSTRAP_USER = makeConstant('BOOTSTRAP_USER');
var BOOTSTRAP_USER_SUCCESS = makeConstant('BOOTSTRAP_USER_SUCCESS');
var BOOTSTRAP_USER_ERROR = makeConstant('BOOTSTRAP_USER_ERROR');

var SET_BUFFERED_USERS = makeConstant('SET_BUFFERED_USERS');

var SET_PROCESS_ALL_USERS = makeConstant('SET_PROCESS_ALL_USERS');
var ADD_USER_PROCESSED = makeConstant('ADD_USER_PROCESSED');
var REMOVE_USER_PROCESSED = makeConstant('REMOVE_USER_PROCESSED');
var REMOVE_USER_PROCESSED_DELAYED = makeConstant('REMOVE_USER_PROCESSED_DELAYED');

var SEND_ACTIVE_STATUS = makeConstant('SEND_ACTIVE_STATUS');
var SET_PRESENCE_PROBLEMS = makeConstant('SET_PRESENCE_PROBLEMS');
var SET_PRESENCE_LOADING = makeConstant('SET_PRESENCE_LOADING');

var SET_NEW_LIVE_USERS = makeConstant('SET_NEW_LIVE_USERS');

var GET_PRESENCE_STATE_ON_INTERVAL = makeConstant('GET_PRESENCE_STATE_ON_INTERVAL');
var CANCEL_PRESENCE_INTERVAL = makeConstant('CANCEL_PRESENCE_INTERVAL');

var SET_HAS_PROCESSED_USERS = makeConstant('SET_HAS_PROCESSED_USERS');

var PresenceChannel = Object.freeze({
  ORG: 'ORG',
  ORG_PRIVATE: 'ORG_PRIVATE',
  USER: 'USER'
});

var PhoenixStatus = Object.freeze({
  CONNECTED: 'CONNECTED',
  DISCONNECTING: 'DISCONNECTING',
  DISCONNECTED: 'DISCONNECTED'
});

var WORKER_DEBUG_KEY = 'presence-worker-debug';

var MESSAGE_SENT = makeConstant('MESSAGE_SENT');

/***/ }),

/***/ "a3xq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("SmOF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MISSING_CAMPAIGN = 'The previously used campaign is no longer available.';
var UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.';
var SEARCH_DEBOUNCE_TIMEOUT = 500;

var SalesforcePlaybookCampaignSelect = function (_Component) {
    _inherits(SalesforcePlaybookCampaignSelect, _Component);

    function SalesforcePlaybookCampaignSelect(props) {
        var _this2 = this;

        _classCallCheck(this, SalesforcePlaybookCampaignSelect);

        var _this = _possibleConstructorReturn(this, (SalesforcePlaybookCampaignSelect.__proto__ || Object.getPrototypeOf(SalesforcePlaybookCampaignSelect)).call(this, props));

        _this.fetchSalesforceOptions = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var selectOptions, hasSelectValue, _ref2, _ref3, salesforceCampaigns, _ref3$, salesforceCampaignId, salesforceCampaignName, toggle;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            selectOptions = [];
                            hasSelectValue = false;
                            _context.next = 5;
                            return Promise.all([__WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].getSalesforceCampaigns(), __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].getSelectedSalesforceCampaign(_this.props.playbookId)]);

                        case 5:
                            _ref2 = _context.sent;
                            _ref3 = _slicedToArray(_ref2, 2);
                            salesforceCampaigns = _ref3[0].salesforceCampaigns;
                            _ref3$ = _ref3[1];
                            salesforceCampaignId = _ref3$.salesforceCampaignId;
                            salesforceCampaignName = _ref3$.salesforceCampaignName;
                            toggle = _ref3$.toggle;


                            salesforceCampaigns.forEach(function (campaign) {
                                if (campaign.Id === salesforceCampaignId) {
                                    hasSelectValue = true;
                                }

                                selectOptions.push({
                                    label: campaign.Name,
                                    value: campaign.Id
                                });
                            });

                            if (!hasSelectValue && !!salesforceCampaignId) {
                                selectOptions.unshift({
                                    label: salesforceCampaignName,
                                    value: salesforceCampaignId
                                });
                            }

                            _this.setState({
                                selectValue: salesforceCampaignId,
                                selectLabel: salesforceCampaignName,
                                onlyNetNew: !!toggle,
                                selectOptions: selectOptions,
                                isLoading: false
                            });
                            _context.next = 21;
                            break;

                        case 17:
                            _context.prev = 17;
                            _context.t0 = _context['catch'](0);

                            console.warn(_context.t0);
                            _this.handleUnknownError();

                        case 21:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 17]]);
        }));

        _this.handleMissingCampaign = function () {
            _this.setState({
                isLoading: false,
                hasError: true,
                selectValue: null,
                errorText: MISSING_CAMPAIGN
            });
        };

        _this.handleUnknownError = function () {
            _this.setState({
                isLoading: false,
                hasError: true,
                errorText: UNKNOWN_ERROR
            });
        };

        _this.onDone = function () {
            _this.setState({ isLoading: false });
        };

        _this.onChange = function (campaign) {
            var onStateSet = function onStateSet() {
                if (!!_this.state.selectValue) {
                    __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceCampaign({
                        salesforceCampaignId: campaign.value,
                        playbookId: _this.props.playbookId,
                        toggle: _this.state.onlyNetNew
                    });
                } else {
                    __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].deleteSalesforceCampaign(_this.props.playbookId);
                }
            };
            if (!!campaign.value) {
                _this.setState({
                    selectValue: campaign.value,
                    selectLabel: campaign.label
                }, onStateSet);
            } else {
                _this.setState({
                    selectValue: null,
                    selectLabel: null,
                    onlyNetNew: false
                }, onStateSet);
            }
        };

        _this.searchSalesforceCampaigns = function (query) {
            //we limit SF response to 500 for rendering purposes.
            //We then need to consult with SF incase a campaign is not in the 500 returned
            if (_this.state.selectOptions.length < 500) {
                _this.setState({ responseOptions: [] });
                return;
            }
            if (query.length <= 2 && !_this.state.selectValue) {
                _this.setState({ responseOptions: [] });
                return;
            }
            // salesforce wants queries of length > 2 or it won't return anything
            if (query.length > 2) {
                _this.debouncedSearch(query);
            }
            return query;
        };

        _this.searchForCampaigns = function () {
            var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(query) {
                var onDone;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                onDone = function onDone(response) {
                                    var responseOptions = response.salesforceCampaigns.map(function (campaign) {
                                        return {
                                            label: campaign.Name,
                                            value: campaign.Id
                                        };
                                    });

                                    _this.setState({
                                        responseOptions: responseOptions,
                                        isLoading: false
                                    });
                                };

                                _this.setState({ isLoading: true });
                                _context2.prev = 2;
                                _context2.next = 5;
                                return __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].fetchCampaigns(query).then(onDone);

                            case 5:
                                _context2.next = 11;
                                break;

                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2['catch'](2);

                                console.log(_context2.t0);
                                _this.handleUnknownError();

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[2, 7]]);
            }));

            return function (_x) {
                return _ref4.apply(this, arguments);
            };
        }();

        _this.debouncedSearch = _.debounce(_this.searchForCampaigns, SEARCH_DEBOUNCE_TIMEOUT);

        _this.resolveDefaultSelectOption = function () {
            var defaultSelectLabelText = _this.props.defaultSelectLabelText;

            return { value: null, label: defaultSelectLabelText };
        };

        _this.resolveSelectOptions = function () {
            var selectOptions = _this.state.selectOptions;

            var defaultSelectOption = _this.resolveDefaultSelectOption();
            return selectOptions.concat(defaultSelectOption);
        };

        _this.updateOnlyNetNew = function () {
            __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceCampaign({
                salesforceCampaignId: _this.state.selectValue,
                playbookId: _this.props.playbookId,
                toggle: !_this.state.onlyNetNew
            });

            _this.setState({
                onlyNetNew: !_this.state.onlyNetNew
            });
        };

        _this.state = {
            isLoading: true,
            hasError: false,
            onlyNetNew: false,
            selectValue: null,
            selectLabel: null,
            selectOptions: [],
            responseOptions: []
        };
        return _this;
    }

    _createClass(SalesforcePlaybookCampaignSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchSalesforceOptions();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                description = _props.description,
                defaultSelectLabelText = _props.defaultSelectLabelText;
            var _state = this.state,
                selectValue = _state.selectValue,
                isLoading = _state.isLoading,
                hasError = _state.hasError,
                errorText = _state.errorText,
                onlyNetNew = _state.onlyNetNew,
                responseOptions = _state.responseOptions;

            var defaultSelectOption = this.resolveDefaultSelectOption();
            var selectOptions = responseOptions.length > 0 ? responseOptions : this.state.selectOptions;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'salesforce-playbook-campaign-select-container' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'advanced-integration-toggle-header' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'salesforce-campaign-select-title' },
                        'Salesforce Campaign'
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'salesforce-playbook-campaign-select-description' },
                        description
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
                        className: 'salesforce-campaign-select-input',
                        autosize: false,
                        placeholder: defaultSelectLabelText,
                        value: selectValue,
                        options: selectOptions,
                        isLoading: isLoading,
                        onChange: this.onChange,
                        resetValue: defaultSelectOption,
                        onInputChange: this.searchSalesforceCampaigns
                    }),
                    hasError && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'p',
                        { className: 'salesforce-campaign-error-text' },
                        errorText
                    ),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                        'div',
                        { className: 'salesforce-campaign-checkbox' },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], { className: 'salesforce-campaign-input', type: 'checkbox', checked: onlyNetNew, onChange: this.updateOnlyNetNew }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                            'p',
                            { className: 'salesforce-campaign-paragraph' },
                            'Only associate net new leads/contacts with this campaign'
                        )
                    )
                )
            );
        }
    }]);

    return SalesforcePlaybookCampaignSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforcePlaybookCampaignSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "a56C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return notifyNewMessage; });
/* unused harmony export notifyNewParticipant */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return notifyFollowing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notifyFollowingAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return notifyParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return soundNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return soundNotificationImmediate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notifyAcceptedInvitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return displayTabIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateSubscriptionOnServer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
var _this = this;





var hasNotifications = 'Notification' in window;

var ensureNotificationPermission = function ensureNotificationPermission(cb) {
  // const's check if the browser supports notifications
  if (typeof window === 'undefined' || window === null || !hasNotifications) {
    return;
  }

  if (Notification.permission === 'granted') {
    return cb();
  } else if (Notification.permission !== 'denied') {
    return Notification.requestPermission(function (permission) {
      if (permission === 'granted') {
        return cb();
      }
    });
  }
};

var showNotification = function showNotification(notification, options, handleClick) {
  hasNotifications && ensureNotificationPermission(function () {
    var n = new Notification(notification, options);
    n.onclick = handleClick;
    return setTimeout(function () {
      return n.close();
    }, 10000);
  });
};

var redirectToNewConversation = function redirectToNewConversation(endUserId) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (event) {
    event.preventDefault();
    return endUserId ? window.open('/inboxes?endUserId=' + endUserId) : window.open('/live?user=' + opts.anonymousId + '&account=' + opts.accountName);
  };
};

var redirectToConversation = function redirectToConversation(message) {
  return function (event) {
    event.preventDefault();
    return window.open('/inboxes/' + message.inboxId + '/conversations/' + message.conversationId);
  };
};

var notifyNewMessage = function notifyNewMessage(message) {
  var strippedBody = message.attributes && message.attributes.preview;
  var hasAttachment = message.attachments && message.attachments.length;
  var messageToShow = hasAttachment ? '\n📎 Message sent with attachment.' : message.subject || strippedBody;

  return showNotification('#' + message.conversationId + ' ' + messageToShow, {
    body: strippedBody,
    tag: 'message' + message.id,
    icon: __webpack_require__("W6a3")
  }, redirectToConversation(message));
};

var notifyNewParticipant = function notifyNewParticipant(message) {
  var strippedBody = message.attributes && message.attributes.preview;
  return showNotification('#' + message.conversationId + ' ' + (message.subject || strippedBody), {
    body: "You’ve been added to a conversation in Drift. Click here to view it.",
    tag: 'message' + message.id,
    icon: __webpack_require__("W6a3")
  }, redirectToConversation(message));
};

var notifyFollowing = function notifyFollowing(payload) {

  var message = '[Live View] ' + __WEBPACK_IMPORTED_MODULE_0_shared_web_src_helpers_CustomerHelpers__["getDisplayName"](payload.endUser) + ' is on your site: ' + (_.get(event, 'attributes.title') || _.get(event, 'attributes.url')) + '!';
  return showNotification(message, {
    tag: message,
    icon: __webpack_require__("W6a3")
  }, redirectToNewConversation(payload.endUser.id));
};

var notifyFollowingAccount = function notifyFollowingAccount(_ref) {
  var account = _ref.account,
      event = _ref.event,
      companyData = _ref.companyData;

  var message = '[ABM] ' + account.name + ' is on your site: ' + (_.get(event, 'attributes.title') || _.get(event, 'attributes.url')) + '!';
  showNotification(message, {
    tag: message,
    body: 'Page: ' + (event.attributes.title || event.attributes.url),
    icon: companyData.logo || __webpack_require__("W6a3")
  }, redirectToNewConversation(event.driftId, { anonymousId: event.anonymousId, accountName: account.name }));
};

var notifyParticipants = function notifyParticipants(message, event) {
  return showNotification(message, { tag: message, icon: __webpack_require__("W6a3") }, redirectToConversation(event));
};

var uniqueId = function uniqueId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

var clearTabs = function clearTabs() {
  return window.localStorage.setItem('openTabs', JSON.stringify([]));
};

var isFirstInLineCheck = function isFirstInLineCheck() {
  return new Promise(function (resolve) {
    var tabs = JSON.parse(window.localStorage.getItem('openTabs'));

    if (!window.thisTabID) {
      window.thisTabID = uniqueId();
    }

    tabs.push(window.thisTabID);
    window.localStorage.setItem('openTabs', JSON.stringify(tabs));

    return setTimeout(function () {
      var latestStoredTabs = JSON.parse(window.localStorage.getItem('openTabs'));
      var firstInLine = latestStoredTabs.indexOf(window.thisTabID) === 0;
      return resolve(firstInLine);
    }, 100);
  }.bind(_this));
};

var soundNotification = function soundNotification() {
  var soundPref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';
  return isFirstInLineCheck().then(function (isFirstInLine) {
    if (isFirstInLine) {
      return soundNotificationImmediate(soundPref);
    }
  });
};

var soundNotificationImmediate = function soundNotificationImmediate() {
  var soundPref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'click';

  return __webpack_require__.e/* require.ensure */(2).then((function (require) {
    if (soundPref === 'none') return;

    new Audio(__webpack_require__("UwW0")("./drift-" + soundPref + '.mp3')).play().catch(function (error) {
      // Most likely, browser is blocking sound autoplaying before user interaction. Log so user has visibility
      console.info(error);
    });
    clearTabs();
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var notifyAcceptedInvitation = function notifyAcceptedInvitation(user) {
  var body = (user.name || user.email) + ' has joined your team!';
  return showNotification('Invitation Accepted!', {
    body: body,
    tag: 'invite' + user.id,
    icon: __webpack_require__("W6a3")
  });
};

var displayTabIndicator = function displayTabIndicator() {
  var originalIcon = __webpack_require__("4PhW");
  var newMessageIcon = __webpack_require__("dTHV");

  var changeFavIcon = function changeFavIcon(icon) {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = icon;
    document.getElementsByTagName('head')[0].appendChild(link);
  };

  var clear = function clear() {
    changeFavIcon(originalIcon);
    window.onfocus = null;
  };

  if (!document.hasFocus()) {
    changeFavIcon(newMessageIcon);
    window.onfocus = clear;
  }
};

var updateSubscriptionOnServer = function updateSubscriptionOnServer(subscription) {
  // Get public key and user auth from the subscription object
  var key = subscription.getKey ? subscription.getKey('p256dh') : '';
  var auth = subscription.getKey ? subscription.getKey('auth') : '';

  return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/notification/web/register', {
    endpoint: subscription.endpoint,
    // Take byte[] and turn it into a base64 encoded string suitable for POSTing to a server over HTTP
    key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : '',
    authentication: auth ? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : ''
  }).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "a5br":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return demoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIframelyVideoEmbed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_paging__ = __webpack_require__("Prq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("5bKX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__demodata__ = __webpack_require__("cKlu");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









// Given paginated, enriched conversations:
// 1. Separate pagintation metadata from enriched conversations.
// 2. Parse the conversations into a normalized structure where each key
//    contains values for the expanded models (conversations, endUsers,
//    enrichmentData).
// 3. Reconstruct a normalize payload, nesting the pagination metadata under
//    the `paginatedConversations` key, colocating the metadata with the models
//    for which it is associated.
var normalizePaginatedEnrichedConversations = function normalizePaginatedEnrichedConversations(paginatedEnrichedConversations) {
  var _paginatedEnrichedCon = paginatedEnrichedConversations.toJS(),
      enrichedConversations = _paginatedEnrichedCon.data,
      paginationMetadata = _objectWithoutProperties(_paginatedEnrichedCon, ['data']);

  var parsed = Object(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* parseEnrichedConversations */])(enrichedConversations);

  var conversations = parsed.get('conversations');
  var endUsers = parsed.get('endUsers');
  var enrichedCompanyDataByEndUserId = parsed.get('enrichedCompanyDataByEndUserId');

  return {
    paginatedConversations: Object(__WEBPACK_IMPORTED_MODULE_3_utils_paging__["b" /* PagedData */])(_extends({
      data: conversations
    }, paginationMetadata)),
    endUsers: endUsers,
    enrichedCompanyDataByEndUserId: enrichedCompanyDataByEndUserId
  };
};

var demoApi = {
  fetchConversationsByInbox: function fetchConversationsByInbox(_ref) {
    var inboxId = _ref.inboxId;

    var conversations = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_6__demodata__["b" /* conversations */]).map(function (conversation) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */])(conversation).set('inboxId', inboxId);
    });

    var paginationMetadata = {
      hasMore: false,
      total: 0,
      cursor: 1516982801425
    };

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_3_utils_paging__["b" /* PagedData */])(_extends({}, paginationMetadata, { data: conversations })));
  },
  fetchEnrichedConversationsByInbox: function fetchEnrichedConversationsByInbox(_ref2) {
    var inboxId = _ref2.inboxId,
        query = _objectWithoutProperties(_ref2, ['inboxId']);

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_6__demodata__["c" /* makeEnrichedPaginatedConversations */]({ inboxId: inboxId, query: query })).map(normalizePaginatedEnrichedConversations);
  }
};


var api = {
  fetch: function fetch(conversationId) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/conversations/' + conversationId).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */]);
  },
  bulkFetch: function bulkFetch(conversationIds) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/conversations/find', { ids: conversationIds }).checkStatus().retryWithBackoff().mapResponse(function (data) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(data).map(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */]);
    });
  },
  create: function create(message) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxMessagingAPI"].post("/messages", message).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */]);
  },
  patch: function patch(id, update) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].patch('/conversations/' + id, update).checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */]);
  },
  fetchConversationsForEndUser: function fetchConversationsForEndUser(endUserId) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$limit = _ref3.limit,
        limit = _ref3$limit === undefined ? 4 : _ref3$limit,
        _ref3$onlyInboxVisibl = _ref3.onlyInboxVisible,
        onlyInboxVisible = _ref3$onlyInboxVisibl === undefined ? true : _ref3$onlyInboxVisibl;

    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["ConversationAPI"].get('/conversations/end_users/' + endUserId, { limit: limit, onlyInboxVisible: onlyInboxVisible }).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["json"]);
  },
  fetchConversationsCountForEndUserId: function fetchConversationsCountForEndUserId(endUserId) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/conversations/end_users/' + endUserId + '/counts').checkStatus().retryWithBackoff().mapResponse(function (response) {
      return response;
    });
  },
  sendConversationTranscript: function sendConversationTranscript(_ref4) {
    var conversationId = _ref4.conversationId,
        email = _ref4.email;

    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].post('/conversations/' + conversationId + '/transcript?' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["d" /* encodeQueryData */])({ email: email })).checkStatus();
  },
  fetchConversationsByInbox: function fetchConversationsByInbox(_ref5) {
    var inboxId = _ref5.inboxId,
        query = _objectWithoutProperties(_ref5, ['inboxId']);

    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/inboxes/' + inboxId + '/conversations?' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["d" /* encodeQueryData */])(query), undefined, { headers: { 'x-version': 3 } }).checkStatus().retryWithBackoff().map(Object(__WEBPACK_IMPORTED_MODULE_3_utils_paging__["e" /* parsePagedData */])(function (conversations) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(conversations).map(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* parseConversation */]);
    }));
  },
  fetchBulkConversationEnrichmentData: function fetchBulkConversationEnrichmentData(convoEndUser) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationClientAPI"].post('/data/enrichment', convoEndUser).checkStatus().retryWithBackoff().mapResponse(function (response) {
      return response;
    });
  },
  fetchEnrichedConversationsByInbox: function fetchEnrichedConversationsByInbox(_ref6) {
    var inboxId = _ref6.inboxId,
        query = _objectWithoutProperties(_ref6, ['inboxId']);

    // Each of these fields will be expanded into fully hydrated models in the
    // nested response payload
    var expandedQuery = _extends({}, query, { expand: ['END_USER', 'COMPANY_ENRICHMENT'] });
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationClientAPI"].get('/data/inboxes/' + inboxId + '/query?' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["d" /* encodeQueryData */])(expandedQuery)).checkStatus().retryWithBackoff().map(Object(__WEBPACK_IMPORTED_MODULE_3_utils_paging__["e" /* parsePagedData */])()).map(normalizePaginatedEnrichedConversations);
  },
  buttonAction: function buttonAction(conversationId, buttonActionBody) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].post('/conversations/' + conversationId + '/button-action', buttonActionBody).checkStatus().retryWithBackoff();
  },
  fetchRoutingAuditLog: function fetchRoutingAuditLog(_ref7) {
    var conversationId = _ref7.conversationId,
        routingGroupId = _ref7.routingGroupId;

    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/routing-audit-log/' + conversationId + '/' + routingGroupId).checkStatus().mapResponse(function (data) {
      return data.conversationRoutingEntries.map(__WEBPACK_IMPORTED_MODULE_5__models__["c" /* parseRoutingAuditLogEntry */]);
    });
  },
  setConversationLimit: function setConversationLimit(limitEnabled, limitValue) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].post('/conversations/conversation-limit', { enabled: limitEnabled, limit: limitValue }).checkStatus();
  },
  fetchSuggestedArticles: function fetchSuggestedArticles(messageText) {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxAnswersAPI"].post('/answers/suggestions?limit=3', { lastMessageText: messageText }).checkStatus().mapResponse(function (response) {
      return response;
    });
  },
  fetchGlobalAutoCloseConfiguration: function fetchGlobalAutoCloseConfiguration() {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].get('/conversations/autoclose/config').checkStatus().mapResponse(function (_ref8) {
      var enabled = _ref8.enabled,
          timeInSeconds = _ref8.timeInSeconds,
          filters = _ref8.filters;
      return {
        isEnabled: enabled,
        timeout: timeInSeconds * 1000, // System expects milliseconds
        filters: filters
      };
    });
  },
  updateGlobalAutoCloseConfiguration: function updateGlobalAutoCloseConfiguration(_ref9) {
    var isEnabled = _ref9.isEnabled,
        timeout = _ref9.timeout,
        filters = _ref9.filters;

    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["RxConversationAPI"].patch('/conversations/autoclose/config', {
      enabled: isEnabled,
      timeout: timeout / 1000, // API expects seconds
      filters: filters
    }).checkStatus();
  },
  sendLeanDataIntegrationEmail: function sendLeanDataIntegrationEmail() {
    return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["ConversationAPI"].post('/integration/test/leandata/authorization');
  }
};


var createConversation = function createConversation(message) {
  return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["MessagingAPI"].post("/messages", message).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["json"]);
};

var getIframelyVideoEmbed = function getIframelyVideoEmbed(url) {
  return __WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["ConversationAPI"].post('/url_validation/playable_video?' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["d" /* encodeQueryData */])({ url: url })).then(__WEBPACK_IMPORTED_MODULE_2__driftt_dapper__["json"]);
};

/* harmony default export */ __webpack_exports__["c"] = (api);

/***/ }),

/***/ "a5ts":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 11 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.132 6.066a.844.844 0 0 1-1.188.006L1.252 2.446a.844.844 0 1 1 1.183-1.204L5.542 4.28 8.56 1.248A.844.844 0 1 1 9.752 2.44l-3.62 3.626z\" stroke-width=\"2\"></path></svg>"

/***/ }),

/***/ "a6mH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_tech_tags__ = __webpack_require__("nyZa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var closeSRC = __webpack_require__("+Juk");

var TechTagsFilter = function (_Component) {
  _inherits(TechTagsFilter, _Component);

  function TechTagsFilter(props) {
    _classCallCheck(this, TechTagsFilter);

    var _this = _possibleConstructorReturn(this, (TechTagsFilter.__proto__ || Object.getPrototypeOf(TechTagsFilter)).call(this, props));

    _initialiseProps.call(_this);

    var _props$activeFilter = props.activeFilter,
        value = _props$activeFilter.value,
        field = _props$activeFilter.field;


    _this.state = {
      selectedCategories: value || [],
      fieldType: field
    };
    return _this;
  }

  _createClass(TechTagsFilter, [{
    key: 'getFormattedTags',
    value: function getFormattedTags() {
      var _ref;

      var unusedCategories = (_ref = _).without.apply(_ref, [Object.keys(__WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_tech_tags__["a" /* TECH_TAGS */])].concat(_toConsumableArray(this.state.selectedCategories)));
      return unusedCategories.map(function (category) {
        return { label: __WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_tech_tags__["a" /* TECH_TAGS */][category], value: category };
      });
    }
  }, {
    key: 'getListHeight',
    value: function getListHeight() {
      var itemHeight = 75;
      var totalColumns = 2;
      var maxHeight = this.state.selectedCategories.length * itemHeight / totalColumns + itemHeight;
      return {
        height: maxHeight + 'px'
      };
    }
  }, {
    key: 'renderSearchBar',
    value: function renderSearchBar() {
      var selectOptions = {
        multi: true,
        autoFocus: true,
        options: this.getFormattedTags(),
        pageSize: 10,
        optionRenderer: this.renderSelectOption,
        onChange: this.saveCategory,
        placeholder: 'Choose a technology...'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          this.renderSearchBar()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-selection rules-choice-selection-multi-column' },
          this.renderTagSelectionList()
        )
      );
    }
  }]);

  return TechTagsFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.removeCategory = function (value) {
    _this2.setState(function (prevState) {
      return {
        selectedCategories: _.without(prevState.selectedCategories, value)
      };
    }, _this2.updateCondition);
  };

  this.saveCategory = function (values) {
    _this2.setState(function (prevState) {
      var newOptions = prevState.selectedCategories.slice(0);
      var onlyValues = values.map(function (option) {
        return option.value;
      });
      newOptions.push.apply(newOptions, _toConsumableArray(onlyValues));
      newOptions.sort();

      return {
        selectedCategories: newOptions
      };
    }, _this2.updateCondition);
  };

  this.updateCondition = function () {
    var updatedCondition = {
      operator: __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
      value: _this2.state.selectedCategories
    };

    _this2.props.onUpdateCondition(updatedCondition);
  };

  this.renderSelectOption = function (_ref2) {
    var label = _ref2.label;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'geo-option choice-dropdown-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'choice-option-value' },
        label
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'choice-option-add' },
        '+Add'
      )
    );
  };

  this.renderTagSelectionList = function () {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'ul',
      { style: _this2.getListHeight() },
      _this2.state.selectedCategories.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'li',
          { key: option + '-' + index },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_3_components_settings_Rules_constants_tech_tags__["a" /* TECH_TAGS */][option]
          ),
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: closeSRC, className: 'remove', onClick: function onClick() {
              return _this2.removeCategory(option);
            } })
        );
      })
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (TechTagsFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "a98j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aCE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Cta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RoutingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SingleRoutingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GroupRoutingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Goal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SmartFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Targeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConditionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Condition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Email; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Signature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Sequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Question; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Interaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Answer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FieldConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Keyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PlaybookMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Playbook; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("st9j");




var Cta = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  type: __WEBPACK_IMPORTED_MODULE_1__constants__["V" /* CtaTypes */].NONE,
  url: 'https://drift.com',
  copy: 'Learn More'
});

var RoutingOption = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  type: null
});

var SingleRoutingOption = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_150" /* RoutingType */].SINGLE,
  userId: null
});

var GroupRoutingOption = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_150" /* RoutingType */].GROUP,
  userIds: null
});

var Goal = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  name: undefined,
  playbookId: undefined,
  routing: null,
  classification: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  message: null,
  schedule: null,
  markCQL: null,
  statusChange: null
});

var SmartFilters = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  meetingScheduled: null,
  salesSequenceEngaged: null,
  chatEngaged: null
});

var Targeting = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  userListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  accountListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  excludedUserListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  excludedAccountListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  display: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  audience: __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* AudienceType */].NONE,
  dueAt: null,
  campaignReenrollmentType: null,
  unenrollOnReply: null,
  unenrollOnReplyByDomain: null,
  smartFilters: SmartFilters()
});

var ConditionSet = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  conditions: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
});

var Condition = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  value: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  operator: 'includesAnyOf',
  field: 'url'
});

var Email = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  message: '',
  title: '',
  delay: 3,
  delayUnit: 'DAYS',
  id: undefined,
  threadedWithPrevious: undefined,
  bannerImageUrl: null,
  campaignId: null,
  sendFromOverride: null,
  senderEmailOverride: null,
  dynamicAccountSendAttribute: null,
  dynamicSenderFormat: null
});

var Signature = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  signatureId: null,
  signatureBody: null,
  authorId: null,
  includeAvatar: false,
  includeCompanySocialMedia: false,
  hasCampaignGraphic: false,
  campaignGraphic: null, // URL for the image
  campaignGraphicLink: null // URL for the link wrapping the image
});

var Sequence = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  emails: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  options: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

var Question = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  prompt: '',
  defaultAnswerId: null,
  answers: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  status: 'ENABLED',
  actionId: null,
  interactionId: null,
  isButtonOnly: null,
  fieldConfiguration: null
});

var Interaction = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  name: 'Sample LeadBot',
  slug: null,
  greeting: 'Hey there!',
  questions: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  actionTypeId: null,
  campaignId: null
});

var Answer = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  response: '',
  keywords: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  skipTo: null,
  skipToGoal: null,
  type: __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* AnswerType */].BUTTON,
  validationType: null,
  validationConfig: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  buttonText: '',
  questionId: null
});

var FieldConfiguration = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  fieldName: null
});

var Keyword = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  text: '',
  type: __WEBPACK_IMPORTED_MODULE_1__constants__["_125" /* KeywordType */].CONTAINS,
  special: false,
  answerId: null
});

var PlaybookMeta = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  autoArchived: false,
  driftLinkOnly: false
});

var Playbook = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  meta: PlaybookMeta(),
  priority: undefined,
  createdAt: undefined,
  createdAuthorId: undefined,
  updatedAt: undefined,
  updatedAuthorId: undefined,
  name: 'New Playbook',
  reportType: undefined,
  status: undefined,
  actions: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  goals: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  targeting: Targeting()
});

/***/ }),

/***/ "aGl+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PLACEHOLDER_PRIMARY_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLACEHOLDER_SECONDARY_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PLACEHOLDER_PRIMARY_OPACITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLACEHOLDER_SECONDARY_OPACITY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Person__ = __webpack_require__("4rKJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Company__ = __webpack_require__("gp6G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("APMr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_arrow_solid_right_svg__ = __webpack_require__("zbqJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_arrow_solid_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_arrow_solid_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_new_feature_badge_svg__ = __webpack_require__("8g3x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_new_feature_badge_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_new_feature_badge_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_hocs_withEnrichedCompanyData__ = __webpack_require__("0Mws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__withContactInfo__ = __webpack_require__("cXWW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var PLACEHOLDER_PRIMARY_COLOR = '#E4EFF4';
var PLACEHOLDER_SECONDARY_COLOR = '#E4EFF4';
var PLACEHOLDER_PRIMARY_OPACITY = .75;
var PLACEHOLDER_SECONDARY_OPACITY = .4;

var ContactSideBar = function (_Component) {
  _inherits(ContactSideBar, _Component);

  function ContactSideBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactSideBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ContactSideBar.__proto__ || Object.getPrototypeOf(ContactSideBar)).call.apply(_ref, [this].concat(args))), _this), _this.hideContactSidebar = function () {
      _this.props.setEndUserSideBarVisibility(false);
    }, _this.onActivateTab = function (index) {
      _this.props.actions.setActiveConversationContactTabIndex(index);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactSideBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          conversationId = _props.conversationId,
          hasDemandbase = _props.hasDemandbase,
          hasCompanyData = _props.hasCompanyData,
          isCurrentUserEligibleForRedesignAnnouncement = _props.isCurrentUserEligibleForRedesignAnnouncement,
          revealContext = _props.revealContext,
          ip = _props.ip,
          email = _props.email;


      var tabData = _.compact([{
        title: 'Person',
        component: function component() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Person__["a" /* default */], { conversationId: conversationId, ip: ip });
        }
      }, (revealContext.conversationsReveal || hasDemandbase) && {
        title: 'Company',
        component: function component() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Company__["a" /* default */], _extends({ conversationId: conversationId, ip: ip, email: email }, _this2.props));
        }
      }]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_11__style_styl__["ContactSideBar"] },
        hasCompanyData && isCurrentUserEligibleForRedesignAnnouncement && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'new-feature-badge' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_new_feature_badge_svg___default.a })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Button"],
          { className: __WEBPACK_IMPORTED_MODULE_11__style_styl__["hideContactSidebarButton"], onClick: this.hideContactSidebar, type: 'tertiary', size: 'small' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Icon"], { className: 'contact-icon', name: 'user' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'collapse-right-arrow-icon', src: __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_arrow_solid_right_svg___default.a }),
          'Hide'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Tabs"], { data: tabData, controlled: true, activeTab: this.props.activeConversationTabIndex, onActivateTab: this.onActivateTab })
      );
    }
  }]);

  return ContactSideBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {

  return function (state, props) {
    return {
      activeConversationTabIndex: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_conversation_selectors__["b" /* activeConversationContactTabIndex */])(state),
      hasCompanyData: props.companyData && !_.every(props.companyData, function (data) {
        return !data || _.isEmpty(data);
      }),
      isCurrentUserEligibleForRedesignAnnouncement: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_selectors__["c" /* isCurrentUserEligibleForContactSidebarRedesignAnnouncement */](state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setActiveConversationContactTabIndex: __WEBPACK_IMPORTED_MODULE_6_app_modules_conversation_actions__["Q" /* setActiveConversationContactTabIndex */]
    }, dispatch)
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_15__withContactInfo__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_14_components_hocs_withEnrichedCompanyData__["a" /* default */])(ContactSideBar));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "aJZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UserStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvailabilityStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return RANDOM_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CLEARBIT_FOR_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CLEARBIT_FOR_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_CLEARBIT_FOR_EMAIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_CLEARBIT_FOR_EMAIL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_GOOGLE_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_GOOGLE_SCOPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_GOOGLE_SCOPES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_GOOGLE_SCOPES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_EMAIL_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_EMAIL_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_EMAIL_SIGNATURE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_EMAIL_SIGNATURE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return RESET_EMAIL_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_EMAIL_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_EMAIL_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_EMAIL_SIGNATURE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_CURRENT_USER_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CURRENT_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PATCH_CURRENT_USER_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PATCH_CURRENT_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return RECEIVE_CURRENT_USER; });
/* unused harmony export FETCH_USER_STARTED */
/* unused harmony export FETCH_USER_FAILED */
/* unused harmony export RECEIVE_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FETCH_ORG_USERS_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_ORG_USERS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return RECEIVE_ORG_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return RECEIVE_ORG_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return RECEIVE_GATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return TURN_OFF_MANUAL_AWAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return TURN_OFF_MANUAL_AWAY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return TURN_OFF_MANUAL_AWAY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TURN_OFF_MANUAL_AWAY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_ORG_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_ORG_SIGNATURE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_ORG_SIGNATURE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_ORG_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_ORG_SIGNATURE_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_ORG_MULTI_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_ORG_MULTI_SIGNATURE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_ORG_MULTI_SIGNATURE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_ORG_MULTI_SIGNATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_ORG_MULTI_SIGNATURE_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCONNECT_GMAIL_ACCOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISCONNECT_GMAIL_ACCOUNT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISCONNECT_GMAIL_ACCOUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISCONNECT_GMAIL_ACCOUNT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_INDIVIDUAL_USER_CONVO_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_INDIVIDUAL_USER_CONVO_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_USER_CANCELLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('user');

var UserStatus = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  ENABLED: null,
  ARCHIVED: null,
  INVITED: null
});

var AvailabilityStatus = {
  ACTIVE: 'AVAILABLE',
  AWAY: 'OFFLINE',
  ON_CALL: 'ON_CALL'
};

var RANDOM_USER = Object.freeze({
  id: 0,
  name: 'Random Teammate'
});

var FETCH_CLEARBIT_FOR_EMAIL = makeConstant('FETCH_CLEARBIT_FOR_EMAIL');
var FETCH_CLEARBIT_FOR_EMAIL_SUCCESS = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_SUCCESS');
var FETCH_CLEARBIT_FOR_EMAIL_FAILED = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_FAILED');
var FETCH_CLEARBIT_FOR_EMAIL_PENDING = makeConstant('FETCH_CLEARBIT_FOR_EMAIL_PENDING');

var FETCH_GOOGLE_SCOPES = makeConstant('FETCH_GOOGLE_SCOPES');
var FETCH_GOOGLE_SCOPES_SUCCESS = makeConstant('FETCH_GOOGLE_SCOPES_SUCCESS');
var FETCH_GOOGLE_SCOPES_FAILED = makeConstant('FETCH_GOOGLE_SCOPES_FAILED');
var FETCH_GOOGLE_SCOPES_PENDING = makeConstant('FETCH_GOOGLE_SCOPES_PENDING');

var FETCH_EMAIL_SIGNATURE = makeConstant('FETCH_EMAIL_SIGNATURE');
var FETCH_EMAIL_SIGNATURE_SUCCESS = makeConstant('FETCH_EMAIL_SIGNATURE_SUCCESS');
var FETCH_EMAIL_SIGNATURE_FAILED = makeConstant('FETCH_EMAIL_SIGNATURE_FAILED');
var FETCH_EMAIL_SIGNATURE_PENDING = makeConstant('FETCH_EMAIL_SIGNATURE_PENDING');

var RESET_EMAIL_SIGNATURE = makeConstant('RESET_EMAIL_SIGNATURE');

var SET_EMAIL_SIGNATURE = makeConstant('SET_EMAIL_SIGNATURE');
var SET_EMAIL_SIGNATURE_SUCCESS = makeConstant('SET_EMAIL_SIGNATURE_SUCCESS');
var SET_EMAIL_SIGNATURE_FAILED = makeConstant('SET_EMAIL_SIGNATURE_FAILED');

var FETCH_CURRENT_USER_STARTED = makeConstant('FETCH_CURRENT_USER_STARTED');
var FETCH_CURRENT_USER_FAILED = makeConstant('FETCH_CURRENT_USER_FAILED');
var PATCH_CURRENT_USER_STARTED = makeConstant('PATCH_CURRENT_USER_STARTED');
var PATCH_CURRENT_USER_FAILED = makeConstant('PATCH_CURRENT_USER_FAILED');
var RECEIVE_CURRENT_USER = makeConstant('RECEIVE_CURRENT_USER');

var FETCH_USER_STARTED = makeConstant('FETCH_USER_STARTED');
var FETCH_USER_FAILED = makeConstant('FETCH_USER_FAILED');
var RECEIVE_USER = makeConstant('RECEIVE_USER');

var FETCH_ORG_USERS_STARTED = makeConstant('FETCH_ORG_USERS_STARTED');
var FETCH_ORG_USERS_FAILED = makeConstant('FETCH_ORG_USERS_FAILED');

var RECEIVE_ORG_USERS = makeConstant('RECEIVE_ORG_USERS');
var RECEIVE_ORG_USER = makeConstant('RECEIVE_ORG_USER');

var RECEIVE_GATES = makeConstant('RECEIVE_GATES');

var TURN_OFF_MANUAL_AWAY = makeConstant('TURN_OFF_MANUAL_AWAY');
var TURN_OFF_MANUAL_AWAY_PENDING = makeConstant('TURN_OFF_MANUAL_AWAY_PENDING');
var TURN_OFF_MANUAL_AWAY_SUCCESS = makeConstant('TURN_OFF_MANUAL_AWAY_SUCCESS');
var TURN_OFF_MANUAL_AWAY_FAILURE = makeConstant('TURN_OFF_MANUAL_AWAY_FAILURE');

var FETCH_ORG_SIGNATURE = makeConstant('FETCH_ORG_SIGNATURE');
var FETCH_ORG_SIGNATURE_PENDING = makeConstant('FETCH_ORG_SIGNATURE_PENDING');
var FETCH_ORG_SIGNATURE_FAILED = makeConstant('FETCH_ORG_SIGNATURE_FAILED');
var FETCH_ORG_SIGNATURE_SUCCESS = makeConstant('FETCH_ORG_SIGNATURE_SUCCESS');
var FETCH_ORG_SIGNATURE_CANCELLED = makeConstant('FETCH_ORG_SIGNATURE_CANCELLED');

var FETCH_ORG_MULTI_SIGNATURE = makeConstant('FETCH_ORG_MULTI_SIGNATURE');
var FETCH_ORG_MULTI_SIGNATURE_PENDING = makeConstant('FETCH_ORG_MULTI_SIGNATURE_PENDING');
var FETCH_ORG_MULTI_SIGNATURE_FAILED = makeConstant('FETCH_ORG_MULTI_SIGNATURE_FAILED');
var FETCH_ORG_MULTI_SIGNATURE_SUCCESS = makeConstant('FETCH_ORG_MULTI_SIGNATURE_SUCCESS');
var FETCH_ORG_MULTI_SIGNATURE_CANCELLED = makeConstant('FETCH_ORG_MULTI_SIGNATURE_CANCELLED');

var DISCONNECT_GMAIL_ACCOUNT = makeConstant('DISCONNECT_GMAIL_ACCOUNT');
var DISCONNECT_GMAIL_ACCOUNT_PENDING = makeConstant('DISCONNECT_GMAIL_ACCOUNT_PENDING');
var DISCONNECT_GMAIL_ACCOUNT_SUCCESS = makeConstant('DISCONNECT_GMAIL_ACCOUNT_SUCCESS');
var DISCONNECT_GMAIL_ACCOUNT_FAILURE = makeConstant('DISCONNECT_GMAIL_ACCOUNT_FAILURE');

var FETCH_INDIVIDUAL_USER_CONVO_LIMIT = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT');
var FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING');
var FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED');
var FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS');
var FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED = makeConstant('FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED');

var UPDATE_INDIVIDUAL_USER_CONVO_LIMIT = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT');
var UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING');
var UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED');
var UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS');
var UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED = makeConstant('UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED');

var UPDATE_USER = makeConstant('UPDATE_USER');
var UPDATE_USER_PENDING = makeConstant('UPDATE_USER_PENDING');
var UPDATE_USER_FAILED = makeConstant('UPDATE_USER_FAILED');
var UPDATE_USER_SUCCESS = makeConstant('UPDATE_USER_SUCCESS');
var UPDATE_USER_CANCELLED = makeConstant('UPDATE_USER_CANCELLED');

/***/ }),

/***/ "aKBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"DriftModal":"DriftModal---KkacM"};

/***/ }),

/***/ "aLj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreatableUISelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("zjfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





__webpack_require__("/XUS");


var UISelect = function UISelect(_ref) {
  var value = _ref.value,
      options = _ref.options,
      onSelection = _ref.onSelection,
      className = _ref.className,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === undefined ? true : _ref$arrow,
      _ref$SelectComponent = _ref.SelectComponent,
      SelectComponent = _ref$SelectComponent === undefined ? __WEBPACK_IMPORTED_MODULE_2_react_select_plus__["b" /* default */] : _ref$SelectComponent,
      onInputChange = _ref.onInputChange,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === undefined ? false : _ref$clearable,
      props = _objectWithoutProperties(_ref, ['value', 'options', 'onSelection', 'className', 'arrow', 'SelectComponent', 'onInputChange', 'clearable']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({
    value: value,
    options: options,
    onChange: onSelection,
    clearable: clearable,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.UISelect, 'UISelect', className, { 'arrow-disabled': !arrow }),
    onInputChange: onInputChange
  }, props));
};

UISelect.propTypes = {
  arrow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

var CreatableUISelect = function CreatableUISelect(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UISelect, _extends({}, props, { SelectComponent: __WEBPACK_IMPORTED_MODULE_2_react_select_plus__["a" /* Creatable */] }));
};



/* harmony default export */ __webpack_exports__["b"] = (UISelect);

/***/ }),

/***/ "aNG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderRedirectViewInWindow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);


var style = "\n  body {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  @keyframes dot-blink {\n    0% { opacity: 0; }\n    50% { opacity: 1; }\n    100% { opacity: 0; }\n  }  \n\n  @keyframes dot-blink {\n    0% { opacity: 0; }\n    50% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\n  .animation-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n  }\n\n  .header {\n    font-family: 'ProximaSoft-Regular';\n    font-weight: 200;\n    font-style: normal;\n    color: #394f5a;\n  }\n\n  .animated-dot {\n    margin: 0 .6rem;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    animation: dot-blink 1.5s ease-in-out infinite;\n    border: 1px solid transparent;\n    background: #9A9A9A;\n  }\n\n  .delay-1 {\n    animation-delay: 0.2s;\n  }\n\n  .delay-2 {\n    animation-delay: 0.4s;\n  }\n\n  .delay-3 {\n    animation-delay: 0.6s;\n  }";

var redirectWindow = function redirectWindow() {
  return React.createElement(
    "div",
    null,
    React.createElement(
      "h1",
      { className: "header" },
      "Redirecting..."
    ),
    React.createElement(
      "div",
      { className: "animation-container" },
      React.createElement("div", { className: "delay-1 animated-dot" }),
      React.createElement("div", { className: "delay-2 animated-dot" }),
      React.createElement("div", { className: "delay-3 animated-dot" })
    )
  );
};

var createStylesheet = function createStylesheet(window) {
  var stylesheet = window.document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = "data:text/css," + style;
  return stylesheet;
};

var renderRedirectViewInWindow = function renderRedirectViewInWindow(window) {
  var container = window.document.createElement('div');
  var head = window.document.getElementsByTagName('head')[0];
  var stylesheet = createStylesheet(window);
  head.appendChild(stylesheet);
  window.document.body.appendChild(container);
  __WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.render(redirectWindow(), container);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "aOkE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aQOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_shared_CircleOfWaiting_styl__ = __webpack_require__("lppJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_shared_CircleOfWaiting_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_components_shared_CircleOfWaiting_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.




var CircleOfWaiting = React.createClass({
  displayName: "CircleOfWaiting",
  getDefaultProps: function getDefaultProps() {
    return {
      numberOfDots: 3
    };
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: "CircleOfWaiting" },
      _.times(this.props.numberOfDots, function (n) {
        return React.createElement("div", { className: "circle", key: n, style: { animationDelay: n * .2 + "s" } });
      })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (CircleOfWaiting);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "aTxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_settings_Rules_constants_market_categories__ = __webpack_require__("ANOQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var MarketTagsFilter = function (_Component) {
  _inherits(MarketTagsFilter, _Component);

  function MarketTagsFilter(props) {
    _classCallCheck(this, MarketTagsFilter);

    var _this = _possibleConstructorReturn(this, (MarketTagsFilter.__proto__ || Object.getPrototypeOf(MarketTagsFilter)).call(this, props));

    _this.updateCondition = function () {
      var updatedCondition = {
        operator: __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
        value: _this.state.selectedCategories
      };

      _this.props.onUpdateCondition(updatedCondition);
    };

    _this.addRemoveCategory = function (event) {
      var _event$target = event.target,
          checked = _event$target.checked,
          value = _event$target.value;

      var selectedCopy = _this.state.selectedCategories.slice();

      if (checked) {
        selectedCopy.push(value);
      } else {
        selectedCopy = _.without(selectedCopy, value);
      }

      _this.setState({ selectedCategories: selectedCopy }, _this.updateCondition);
    };

    _this.renderTagInputs = function () {
      var selectedCategories = _this.state.selectedCategories;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: 'market-categories-list' },
        __WEBPACK_IMPORTED_MODULE_1_components_settings_Rules_constants_market_categories__["a" /* MARKET_CATEGORIES */].map(function (option, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'li',
            { key: option + '-' + index },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'checkbox', value: option, checked: selectedCategories.includes(option), onChange: _this.addRemoveCategory }),
              ' ',
              option
            )
          );
        })
      );
    };

    var initialValue = props.activeFilter.value;

    _this.state = {
      selectedCategories: initialValue
    };
    return _this;
  }

  _createClass(MarketTagsFilter, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-selection rules-choice-selection-multi-column' },
          this.renderTagInputs()
        )
      );
    }
  }]);

  return MarketTagsFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MarketTagsFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "aUxz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aVRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("FFPI");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("OtCs");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("+Q8e");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("JmSK");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });









/***/ }),

/***/ "aWai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_HelpDocConstants__ = __webpack_require__("fBam");





var DripPayload = {
  client_id: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["p" /* DRIP_CLIENT_ID */],
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/drip'
};
var DripAuthUrl = 'https://www.getdrip.com/oauth/authorize';

var Drip = function Drip(_ref) {
  var isConnected = _ref.isConnected;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'With Drift and Drip, you can see all of your data and events in both places. For example, inside of Drift, you\u2019ll be able to see who\u2019s subscribed to your Drip campaigns, opened your emails, and more.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Inside of Drip, you\u2019ll be able to see things like which of your email subscribers have had conversations with you via Drift.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Want more information? ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: __WEBPACK_IMPORTED_MODULE_3_constants_HelpDocConstants__["a" /* DRIP_HELPDOC_URL */], target: '_blank' },
        'Learn more.'
      )
    ),
    !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'connect-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_IntegrationConnector__["a" /* default */], {
        integrationId: 'drip',
        isOauth: true,
        oauthLink: DripAuthUrl,
        oauthQueryParams: DripPayload,
        title: 'Connect Account',
        connectorType: 'button',
        buttonType: 'primary',
        className: 'drip-integration-connector' })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Drip);

/***/ }),

/***/ "aXca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__ = __webpack_require__("1rl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_TokenAPI_js__ = __webpack_require__("Lftg");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-undef,
    prefer-const,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var UserQueries = Marty.createQueries({
  id: 'UserQueries',

  createUserWithEmail: function createUserWithEmail(email) {
    var _this = this;

    var promise = this.app.sources.UserAPI.createUserWithEmail(email);
    promise.then(function (res) {
      if (res.status === 200) {
        var user = res.body.user;
        var accessToken = res.body.accessToken;

        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_DONE, email, user, accessToken);
      } else if (res.status === 400) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].EMAIL_ALREADY_REGISTERED, email);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_FAILED, email, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_FAILED, email, error);
    });
  },
  sendWelcomeEmail: function sendWelcomeEmail(isMobile) {
    var _this2 = this;

    var promise = this.app.sources.UserAPI.sendWelcomeEmail(isMobile);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].SEND_WELCOME_EMAIL_DONE);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].SEND_WELCOME_EMAIL_FAILED);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].SEND_WELCOME_EMAIL_FAILED);
    });
  },
  fetchUser: function fetchUser(userId) {
    var _this3 = this;

    var promise = this.app.sources.UserAPI.fetchUser(userId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_FETCH_DONE, userId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_FETCH_FAILED, userId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_FETCH_FAILED, userId, error);
    });
  },
  fetchUsersForOrgId: function fetchUsersForOrgId(orgId) {
    var _this4 = this;

    var promise = this.app.sources.UserAPI.fetchUsersForOrgId(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_USERS_FOR_ORG_ID_DONE, orgId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_USERS_FOR_ORG_ID_FAILED, orgId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_USERS_FOR_ORG_ID_FAILED, orgId, error);
    });
  },
  fetchCurrentLoggedInUser: function fetchCurrentLoggedInUser() {
    var _this5 = this;

    return this.app.sources.UserAPI.fetchCurrentLoggedInUser().then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_FAILED);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_FAILED, error);
    });
  },
  checkUserEmailExistence: function checkUserEmailExistence(email) {
    var _this6 = this;

    return this.app.sources.UserAPI.getUserExistsByEmail(email).then(function (res) {
      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_EMAIL_DONE, email, true);
      } else if (res.status === 404) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_EMAIL_DONE, email, false);
      } else {
        _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_EMAIL_FAILED, email, res);
        return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, error);
    });
  },
  getUserExistenceByEmailAndOrgHandle: function getUserExistenceByEmailAndOrgHandle(email, orgHandle) {
    var _this7 = this;

    return this.app.sources.UserAPI.getUserExistsByEmailAndOrgHandle(email, orgHandle).then(function (res) {
      if (res.status === 200) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_DONE, email, orgHandle, true);
      } else if (res.status === 404) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_DONE, email, orgHandle, false);
      } else {
        _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, res);
        return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL_FAILED, email, orgHandle, error);
    });
  },
  updateUser: function updateUser() {
    var _this8 = this;

    var obj = arguments.length <= 0 ? undefined : arguments[0],
        userId = obj.userId,
        params = obj.params,
        isCurrentUser = obj.isCurrentUser,
        val = obj.notify,
        notify = val != null ? val : false;

    var updateUserPromise = this.app.sources.UserAPI.updateUser(userId, params);
    updateUserPromise.then(function (res) {
      if (res.status !== 200) {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        _this8.app.actions.NotificationActions.pushNotification({
          content: res.body.message,
          variant: 'red',
          sticky: true
        });
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_UPDATE_FAILED, userId, res);
      } else {
        _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_UPDATE_DONE, userId, res.body, params);
        if (notify) {
          var prefix = isCurrentUser ? 'Your' : __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default.a.getDisplayName(res.body) + '\'s';
          return _this8.app.actions.NotificationActions.pushNotification({
            content: prefix + ' profile update has been saved!'
          });
        }
      }
    });

    return updateUserPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_UPDATE_FAILED, userId, error);
    });
  },
  fetchOauthCode: function fetchOauthCode(_ref) {
    var _this9 = this;

    var redirect_uri = _ref.redirect_uri,
        client_id = _ref.client_id;

    return Object(__WEBPACK_IMPORTED_MODULE_4_app_api_TokenAPI_js__["b" /* fetchOauthCode */])({ redirect_uri: redirect_uri, client_id: client_id }).then(function (res) {
      return res.json().then(function (body) {
        if (res.ok) {
          return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_OAUTH_CODE_DONE, { redirect_uri: redirect_uri, client_id: client_id, body: body });
        } else {
          return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_OAUTH_CODE_FAILED, { redirect_uri: redirect_uri, client_id: client_id, body: body });
        }
      });
    }).catch(function (errors) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(errors);
    });
  },
  fetchOauthAppInfo: function fetchOauthAppInfo(client_id) {
    var _this10 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_4_app_api_TokenAPI_js__["a" /* fetchOAuthAppInfo */])(client_id).then(function (res) {
      if (res.ok) {
        return res.json().then(function (body) {
          return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_OAUTH_APP_DONE, { client_id: client_id, app: body });
        });
      } else if (res.status === 404) {
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_OAUTH_APP_DONE, { client_id: client_id, app: 'NOT_FOUND' });
      }
    }).catch(function (errors) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(errors);
    });
  },
  clearPasswordValidationErrors: function clearPasswordValidationErrors() {
    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CLEAR_PASSWORD_VALIDATION_ERRORS);
  },
  changePassword: function changePassword(userId, password, notify) {
    var _this11 = this;

    if (notify == null) {
      notify = true;
    }

    return this.app.sources.UserAPI.changePassword(userId, password).then(function (res) {
      if (res.status === 200) {
        if (notify) {
          _this11.app.actions.NotificationActions.pushNotification({
            content: 'Your password has been changed!'
          });
        }
        return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_DONE, userId, res.body);
      } else {

        var validationErrors = _.get(res, 'body.errors', []);
        _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_FAILED, userId, validationErrors);

        var error = new Error();
        error.isValidationError = true;

        return Promise.reject(error);
      }
    }).catch(function (error) {

      if (!error.isValidationError) {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
        _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD_FAILED, userId, []);
        _this11.app.actions.NotificationActions.pushNotification({
          content: 'Ooops, we couldn’t set your password. Please try again.',
          variant: 'red'
        });
      }

      return Promise.reject(error);
    });
  },
  uploadUserAvatar: function uploadUserAvatar(userId, file) {
    var _this12 = this;

    var avatarUploadPromise = this.app.sources.UserAPI.uploadUserAvatar(userId, file);
    avatarUploadPromise.then(function (res) {
      if (res.status === 200) {
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_AVATAR_UPLOAD_DONE, userId, file);
        // suppressing this until we can design a solution compatible with new
        // per-rep onboarding flow
        // @app.actions.NotificationActions.pushNotification({
        //   content: 'Your avatar has been updated!'
        // })
      } else {
        _this12.app.actions.NotificationActions.pushNotification({
          content: res.body.message,
          variant: 'red'
        });
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_AVATAR_UPLOAD_FAILED, userId, res);
      }
    });

    return avatarUploadPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_AVATAR_UPLOAD_FAILED, userId, error);
    });
  },
  logoutUser: function logoutUser() {
    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].LOGOUT_USER_STARTING);
    Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["deleteAccessToken"])();
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].LOGOUT_USER_DONE);
  },
  archiveUser: function archiveUser(userId) {
    var _this13 = this;

    var userPromise = this.app.sources.UserAPI.archiveUser(userId);

    userPromise.then(function (res) {
      if (res.status === 200) {
        return _this13.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_ARCHIVE_DONE, userId);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this13.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_ARCHIVE_FAILED, userId);
      }
    });

    return userPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this13.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_ARCHIVE_FAILED, userId, error);
    });
  },
  archiveUsers: function archiveUsers(payload) {
    var _this14 = this;

    var ARCHIVE_USERS_DONE = __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].ARCHIVE_USERS_DONE,
        ARCHIVE_USERS_FAILED = __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].ARCHIVE_USERS_FAILED;

    return this.app.sources.UserAPI.archiveUsers(payload).then(function (res) {
      if (res.status !== 200) {
        throw res;
      }
      return _this14.dispatch(ARCHIVE_USERS_DONE, payload.userIds);
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this14.dispatch(ARCHIVE_USERS_FAILED, payload, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "aZez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IntegrationToggle */
/* unused harmony export IntegrationToggleForGatedOrg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_tracking__ = __webpack_require__("jAlB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("sJLy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var IntegrationToggle = function IntegrationToggle(_ref) {
  var toggle = _ref.toggle,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      _ref$isVisible = _ref.isVisible,
      isVisible = _ref$isVisible === undefined ? true : _ref$isVisible;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('integration-toggle', { "toggle-not-visible": !isVisible }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'label',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["Input"], {
        type: 'checkbox',
        checked: toggle.value,
        label: toggle.label,
        description: toggle.description && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          toggle.description
        ),
        onChange: function onChange(event) {
          return _onChange(event, toggle);
        },
        disabled: disabled
      })
    )
  );
};

var IntegrationToggleForGatedOrg = function IntegrationToggleForGatedOrg(_ref2) {
  var toggle = _ref2.toggle,
      _onChange2 = _ref2.onChange,
      disabled = _ref2.disabled,
      _ref2$isVisible = _ref2.isVisible,
      isVisible = _ref2$isVisible === undefined ? true : _ref2$isVisible;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'integration-toggle-with-description' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('integration-toggle-gated', { "toggle-not-visible": !isVisible }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["Input"], {
        type: 'checkbox',
        label: toggle.label,
        onChange: function onChange(event) {
          return _onChange2(event, toggle);
        },
        disabled: true }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["ToolTip"],
        { render: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              'Go to Billing'
            );
          }, flow: 'up', className: 'tooltip-for-upgrade' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["Button"],
          { type: 'utility',
            onClick: Object(__WEBPACK_IMPORTED_MODULE_3_utils_tracking__["b" /* trackEvent */])('Click integration-toggle upsell'),
            href: '/settings2/billing',
            className: 'upgrade-button',
            educationHover: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core__["Ribbon"], { isUpgrade: true, text: 'upgrade' })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'input-description' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        toggle.description
      )
    )
  );
};

var IntegrationToggles = function IntegrationToggles(_ref3) {
  var toggles = _ref3.toggles,
      onChange = _ref3.onChange,
      disabled = _ref3.disabled,
      onSuccess = _ref3.onSuccess,
      noPadding = _ref3.noPadding,
      _ref3$isToggleAvailab = _ref3.isToggleAvailableForOrg,
      isToggleAvailableForOrg = _ref3$isToggleAvailab === undefined ? true : _ref3$isToggleAvailab;

  return !isToggleAvailableForOrg ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('', { "integration-toggles drift-form": !noPadding }) },
    ' ',
    toggles.map(function (toggle, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationToggleForGatedOrg, {
          toggle: toggle,
          onChange: onChange,
          disabled: disabled,
          key: toggle.type + '-' + toggle.value
        }),
        toggle.children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationAdvancedToggles, {
          toggles: toggle.children,
          onChange: onChange,
          isEnabled: toggle.value,
          onSuccess: onSuccess,
          openAdvancedSettingsOnEnable: !!toggle.openAdvancedSettingsOnEnable
        })
      );
    })
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('', { "integration-toggles drift-form": !noPadding }) },
    ' ',
    toggles.map(function (toggle, index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: index },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationToggle, {
          toggle: toggle,
          onChange: onChange,
          disabled: disabled,
          key: toggle.type + '-' + toggle.value
        }),
        toggle.children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationAdvancedToggles, {
          toggles: toggle.children,
          onChange: onChange,
          isEnabled: toggle.value,
          onSuccess: onSuccess,
          openAdvancedSettingsOnEnable: !!toggle.openAdvancedSettingsOnEnable
        })
      );
    })
  );
};

var IntegrationAdvancedToggles = function (_Component) {
  _inherits(IntegrationAdvancedToggles, _Component);

  function IntegrationAdvancedToggles() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, IntegrationAdvancedToggles);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = IntegrationAdvancedToggles.__proto__ || Object.getPrototypeOf(IntegrationAdvancedToggles)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.openAdvancedSettings = function () {
      _this.setState({
        show: true
      });
    }, _this.toggle = function () {
      var isEnabled = _this.props.isEnabled;

      if (!isEnabled) {
        return;
      }
      _this.setState(function (prevState) {
        return {
          show: !prevState.show
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IntegrationAdvancedToggles, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var isEnabled = this.props.isEnabled;


      var toggleWasJustDisabled = prevProps.isEnabled && !isEnabled;
      if (toggleWasJustDisabled && this.state.show) {
        this.toggle();
      }

      var toggleWasJustEnabled = !prevProps.isEnabled && isEnabled;
      if (prevProps.openAdvancedSettingsOnEnable && toggleWasJustEnabled && !this.state.show) {
        this.openAdvancedSettings();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggles = _props.toggles,
          onChange = _props.onChange,
          onSuccess = _props.onSuccess,
          isEnabled = _props.isEnabled;
      var AdvancedComponent = toggles.advancedComponent;
      var show = this.state.show;


      var autoExpand = !!toggles.autoExpand;
      var showAdvancedSettings = isEnabled && (show || autoExpand);
      var toggleText = showAdvancedSettings ? 'Hide' : 'Show';

      var showIntegrationTogglesAdvancedItems = toggles.topLevelAdvancedItems && toggles.topLevelAdvancedItems.length > 0;
      var showIntegrationTogglesItems = toggles.items && toggles.items.length > 0;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'advanced-integration-toggles' },
        !autoExpand && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          {
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('', { 'advanced-integration-disabled-text': !isEnabled }),
            onClick: this.toggle
          },
          toggleText,
          ' advanced integration sync settings'
        ),
        showAdvancedSettings && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'advanced-integration-toggles-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'advanced-integration-toggle-header' },
            showIntegrationTogglesAdvancedItems && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationToggles, { disabled: !isEnabled, toggles: toggles.topLevelAdvancedItems, onChange: onChange }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              toggles.label
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              toggles.description
            ),
            showIntegrationTogglesItems && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IntegrationToggles, { disabled: !isEnabled, toggles: toggles.items, onChange: onChange }),
            AdvancedComponent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdvancedComponent, {
              isEnabled: isEnabled,
              onSuccess: onSuccess
            })
          )
        )
      );
    }
  }]);

  return IntegrationAdvancedToggles;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (IntegrationToggles);

/***/ }),

/***/ "aae1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_OptionsDropdown__ = __webpack_require__("bag8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_copy_to_clipboard__ = __webpack_require__("sQ20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("xJzF");








var TagWithTooltip = function TagWithTooltip(_ref) {
  var tag = _ref.tag,
      copy = _ref.copy;
  return React.createElement(
    'div',
    { className: 'meeting-tag-tooltip' },
    React.createElement(
      'div',
      { is: true, tooltip: copy, flow: 'up' },
      React.createElement(
        'div',
        { className: 'meeting-type-tag' },
        tag
      )
    )
  );
};

var TooltipCopy = {
  ROUTING: 'Meetings created through playbooks will use this meeting type.',
  PROFILE: 'This Meeting is bookable through your Drift Profile.'
};

var MeetingTypeListItem = function MeetingTypeListItem(_ref2) {
  var router = _ref2.router,
      settings = _ref2.settings,
      isDefault = _ref2.isDefault,
      isDeleting = _ref2.isDeleting,
      profileUrl = _ref2.profileUrl,
      isCopied = _ref2.isCopied,
      handleCopyMeetingLink = _ref2.handleCopyMeetingLink,
      handleDeleteMeetingType = _ref2.handleDeleteMeetingType,
      _ref2$gated = _ref2.gated,
      gated = _ref2$gated === undefined ? false : _ref2$gated,
      _ref2$profileVisibili = _ref2.profileVisibility,
      profileVisibility = _ref2$profileVisibili === undefined ? false : _ref2$profileVisibili;

  var meetingLink = '' + profileUrl + (isDefault ? '?schedule' : '/' + settings.slug);
  var preventClickHandler = function preventClickHandler(e) {
    if (gated) {
      e.stopPropagation();
      e.preventDefault();
    }
  };
  var profileIsPrivate = profileVisibility === 'PRIVATE';
  var meetingTypeTooltipContent = profileIsPrivate ? React.createElement(
    'span',
    null,
    'Set your profile privacy to \'public\'',
    React.createElement('br', null),
    'to share your profile link'
  ) : React.createElement(
    'span',
    null,
    'Click to copy your meeting link'
  );

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('settings-meeting-type-list-item', { deleting: isDeleting || gated }) },
    React.createElement(
      'div',
      { className: 'flex' },
      React.createElement('img', { className: 'meeting-type-list-item-icon', src: __WEBPACK_IMPORTED_MODULE_5__constants__["c" /* MEETING_ICON_TO_DURATION */]['' + settings.duration] }),
      React.createElement(
        'div',
        { className: 'meeting-type-list-item-details' },
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()({ "meeting-type-list-item-text-wrapper": !isDefault }) },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
            {
              onClick: preventClickHandler,
              className: 'meeting-type-title',
              to: '/settings/calendar/edit/' + (isDefault ? 'default' : settings.slug)
            },
            settings.name
          ),
          React.createElement(
            'span',
            { className: 'meeting-type-list-item-duration' },
            settings.duration,
            ' min'
          )
        ),
        React.createElement(
          'div',
          { className: 'meeting-type-list-item-subdetails' },
          isDefault && React.createElement(
            'div',
            { className: 'flex-space-between' },
            React.createElement(TagWithTooltip, { tag: 'Chat', copy: TooltipCopy.ROUTING }),
            React.createElement(TagWithTooltip, { tag: 'Drift Profile', copy: TooltipCopy.PROFILE })
          )
        )
      )
    ),
    !gated && React.createElement(
      'div',
      { className: 'meeting-type-list-item-controls' },
      !isDeleting && React.createElement(
        'div',
        { className: 'meeting-type-list-item-menu' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["ToolTip"],
          {
            flow: 'up',
            component: meetingTypeTooltipContent
          },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_copy_to_clipboard___default.a,
            { text: meetingLink, onCopy: handleCopyMeetingLink },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
              { className: 'meeting-link-copy', type: 'tertiary', disabled: gated || profileIsPrivate },
              React.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { className: 'meeting-link-copy-icon', width: 12, name: 'link-1' }),
              ' ',
              isCopied ? 'Copied!' : 'Share this meeting'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'meeting-options-dropdown' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_OptionsDropdown__["a" /* default */], {
            handleEditClick: function handleEditClick() {
              router.push('/settings/calendar/edit/' + (isDefault ? 'default' : settings.slug));
            },
            handleDeleteClick: !isDefault && handleDeleteMeetingType
          })
        )
      )
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (MeetingTypeListItem);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "adG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("0AcM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_SegmentSelectHelper__ = __webpack_require__("iKCO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_selectors__ = __webpack_require__("TFJD");









function fetchSegmentList(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* fetchSegmentList */].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchList().map(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* receiveSegmentList */]).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* fetchSegmentListPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* fetchSegmentListFailed */](error));
    });
  });
}

function fetchSegmentSetCardinality(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* fetchSegmentSetCardinality */].toString()).pluck('payload').switchMap(function (userListIds) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchSegmentSetCardinality(userListIds).map(function (res) {
      return res.response;
    }).flatMap(function (response) {
      return [__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* receiveSegmentSetCardinality */]({ segmentSet: __WEBPACK_IMPORTED_MODULE_6_utils_SegmentSelectHelper__["c" /* segmentIdsToSegmentSet */](userListIds), cardinality: response.cardinality })];
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchSegmentSetCardinalityPending */]).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* fetchSegmentSetCardinalityFailed */]({ userListIds: userListIds, error: error }));
    });
  });
}

function fetchEndUserMembership(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* fetchEndUserMembership */].toString()).pluck('payload').filter(function (_ref2) {
    var endUserId = _ref2.endUserId;
    return !__WEBPACK_IMPORTED_MODULE_5__selectors__["b" /* endUserMembershipByIdFetched */](getState(), endUserId);
  }).mergeMap(function (_ref3) {
    var endUserId = _ref3.endUserId;

    var orgId = __WEBPACK_IMPORTED_MODULE_7_app_modules_org_selectors__["orgId"](getState());
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchEndUserMembership(endUserId, orgId).map(function (res) {
      return res.response;
    }).map(function (membership) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["j" /* receiveEndUserMembership */]({ endUserId: endUserId, membership: membership });
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* fetchEndUserMembershipPending */]).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* fetchEndUserMembershipFailed */]({ endUserId: endUserId, error: error }));
    });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchSegmentList, fetchSegmentSetCardinality, fetchEndUserMembership);

/***/ }),

/***/ "ag9w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(430);

/***/ }),

/***/ "agXk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aheP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox__ = __webpack_require__("cbHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Keyword__ = __webpack_require__("lxwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__botFollowUp__ = __webpack_require__("+aVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("ZWQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var StandardAnswerBody = function StandardAnswerBody(_ref) {
  var _ref$answer = _ref.answer,
      buttonText = _ref$answer.buttonText,
      keywords = _ref$answer.keywords,
      isKeywords = _ref.isKeywords,
      hasSpecialKeyword = _ref.hasSpecialKeyword,
      onButtonTextChange = _ref.onButtonTextChange,
      onClickKeywordsType = _ref.onClickKeywordsType,
      onClickButtonType = _ref.onClickButtonType,
      onAddYesKeywordClick = _ref.onAddYesKeywordClick,
      onAddNoKeywordClick = _ref.onAddNoKeywordClick,
      onAddGenericKeywordClick = _ref.onAddGenericKeywordClick,
      isFlagged = _ref.isFlagged,
      onFlagClick = _ref.onFlagClick,
      skipToOptions = _ref.skipToOptions,
      currentSkipToOption = _ref.currentSkipToOption,
      onSkipToChange = _ref.onSkipToChange,
      botFollowUpProps = _ref.botFollowUpProps,
      buttonOnlyResponses = _ref.buttonOnlyResponses;

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.AnswerModalContent },
    React.createElement(
      'div',
      { className: 'drift-form' },
      React.createElement(
        'strong',
        null,
        'Trigger this Follow Up'
      ),
      React.createElement(
        'p',
        null,
        'Allow users to trigger this follow up by typing a response (Keywords) or by clicking a button.'
      ),
      React.createElement(
        'fieldset',
        { className: 'drift-pill-set' },
        React.createElement(
          'button',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('drift-button', 'large', { selected: !isKeywords }),
            onClick: onClickButtonType
          },
          'Button'
        ),
        !!buttonOnlyResponses ? React.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
          {
            component: 'Only button responses are available for this question. Change in Advanced Settings',
            className: 'playbook-answer-modal-keyword-tooltip-wrapper',
            flow: 'up'
          },
          React.createElement(
            'button',
            {
              className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('drift-button', 'large', { selected: isKeywords }),
              onClick: onClickKeywordsType,
              disabled: buttonOnlyResponses
            },
            'Keywords'
          )
        ) : React.createElement(
          'button',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('drift-button', 'large', { selected: isKeywords }),
            onClick: onClickKeywordsType,
            disabled: buttonOnlyResponses
          },
          'Keywords'
        )
      )
    ),
    isKeywords ? React.createElement(
      'div',
      { className: 'keywords-section drift-form' },
      React.createElement(
        'strong',
        null,
        'Keywords'
      ),
      React.createElement(
        'p',
        null,
        'We recommend adding at least 4 or 5 keywords or phrases to help the bot respond more accurately.'
      ),
      keywords.map(function (id) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_4__Keyword__["a" /* default */], { key: id, id: id });
      }),
      React.createElement(
        'button',
        {
          className: 'drift-button drift-button-secondary',
          onClick: onAddGenericKeywordClick
        },
        '+ New Keyword'
      ),
      !hasSpecialKeyword && React.createElement(
        'button',
        { className: 'drift-button drift-button-secondary', onClick: onAddYesKeywordClick },
        '+ Yes'
      ),
      !hasSpecialKeyword && React.createElement(
        'button',
        { className: 'drift-button drift-button-secondary', onClick: onAddNoKeywordClick },
        '+ No'
      )
    ) : React.createElement(
      'div',
      { className: 'drift-form' },
      React.createElement(
        'strong',
        null,
        'Enter Button Text'
      ),
      React.createElement(
        'p',
        null,
        'We recommend you keep it short and sweet. Especially if you plan on having multiple buttons per question.'
      ),
      React.createElement('input', {
        type: 'text',
        value: buttonText,
        placeholder: 'Enter text...',
        onChange: onButtonTextChange
      })
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_5__botFollowUp__["a" /* default */], _extends({
      showFollowUpPrompt: true
    }, botFollowUpProps)),
    React.createElement(
      'div',
      { className: 'flag-section' },
      React.createElement(
        'strong',
        null,
        'Flag as Default Follow Up'
      ),
      React.createElement(
        'div',
        { className: 'flex' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_CheckBox___default.a, { onChange: onFlagClick, checked: isFlagged, id: 'answer-flagged' }),
        React.createElement(
          'p',
          null,
          'This follow up will send if no other follow ups match.'
        )
      )
    ),
    React.createElement(
      'div',
      { className: 'drift-form' },
      React.createElement(
        'strong',
        null,
        'Next Step'
      ),
      React.createElement(
        'p',
        null,
        'If user matches this follow up, end the conversation or skip them to a different question or goal. You can only skip ahead.'
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__["b" /* default */], {
        className: 'skip-select',
        options: skipToOptions,
        clearable: true,
        value: currentSkipToOption,
        onChange: onSkipToChange
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (StandardAnswerBody);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ai6w":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNiAyNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTIuMTI1IDE1LjYwMmMuMDQ1LjEzMy4wNjcuMjcyLjA2Ny40MTV2NC42OWMwIDEuOTI1IDEuMzg3IDMuNDkyIDMuMDkyIDMuNDkySDE2LjI5YzEuNzAzIDAgMy4wOS0xLjU2NyAzLjA5LTMuNDkydi0zLjI4MmMwLS4xNi4wMy0uMzE4LjA4NS0uNDY3LjE3LS40NTQuNTY4LS43NDcgMS4wMS0uNzQ3LjYwNiAwIDEuMS41NDQgMS4xIDEuMjEzdjMuMjgyYzAgMS41NzgtLjU1IDMuMDYtMS41NDIgNC4xNzUtMSAxLjEyMi0yLjMzIDEuNzQtMy43NDQgMS43NEg1LjI4M2MtMS4wNjIgMC0yLjA4Ni0uMzUyLTIuOTYyLTEuMDE3LTEuMTUzLS44NzMtMS45NC0yLjE5LTIuMjE1LTMuNzEtLjA3Mi0uMzktLjEwNy0uNzg4LS4xMDctMS4xOXYtNC42OWMwLS4xNDIuMDItLjI4LjA2Ni0uNDE0Qy4wMiAxNS40NyAwIDE1LjMzIDAgMTUuMTg3di00LjY5YzAtLjQuMDM1LS44LjEwNy0xLjE5LjI3NS0xLjUxOCAxLjA2Mi0yLjgzNiAyLjIxNS0zLjcxLjg3Ni0uNjY0IDEuOS0xLjAxNSAyLjk2Mi0xLjAxNWgzLjM5YzEuNDE2IDAgMS43MDUgMi40MjMgMCAyLjQyM2gtMy4zOWMtMS43MDUgMC0zLjA5MiAxLjU2OC0zLjA5MiAzLjQ5M3Y0LjY5YzAgLjE0Mi0uMDIyLjI4LS4wNjcuNDE0ek0yNS41MTcgNC4yMDdjLjU2NS41Ny41NjIgMS40OTUgMCAyLjA2bC04LjUzIDguNTljLS41NjQuNTctMS42MzYgMS4yNC0yLjM5NiAxLjQ4OCAwIDAtNC42NzcgMS42OTMtNS40Ny44OTQtLjc5NC0uOC42NjgtNS43ODQuNjY4LTUuNzg0LjIwOC0uNzc4Ljg0LTEuODczIDEuNC0yLjQ0TDE5LjcyLjQyOGMuNTY0LS41NyAxLjQ3OC0uNTcyIDIuMDQ2IDBsMy43NTMgMy43OHoiIGlkPSJhIi8+PG1hc2sgaWQ9ImIiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNS45MzkiIGhlaWdodD0iMjYuNjIyIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjwvZGVmcz48dXNlIG1hc2s9InVybCgjYikiIHhsaW5rOmhyZWY9IiNhIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZT0iIzcxOThBQyIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg=="

/***/ }),

/***/ "aiLn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("arqL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("rpEm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("n5J5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_ConversationStatusConstants__ = __webpack_require__("U98Q");













var VALID_RECEIVE_BULK_UPDATE_STATUSES = ['PENDING', 'FAILED', 'SUCCESS'];

var handleBulkUpdateSocketEvent = function handleBulkUpdateSocketEvent(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref) {
    var channel = _ref.channel,
        leaveChannel$ = _ref.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('conversation-bulk-updated', function (payload) {
        var updaterId = payload.updaterId,
            updateType = payload.updateType,
            conversationDiffs = payload.updateInfo,
            updateRequestId = payload.requestId,
            orgId = payload.orgId,
            inboxId = payload.inboxId,
            error = payload.error;


        if (error) {
          return observer.next(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* receiveBulkUpdate */]({ status: 'FAILED', updateRequestId: updateRequestId }));
        }

        observer.next(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* receiveBulkUpdate */]({
          status: 'SUCCESS',
          updaterId: updaterId,
          conversationDiffs: conversationDiffs.map(function (conversationDiff) {
            return {
              previousStatus: conversationDiff.previousStatus,
              previousParticipantIds: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(conversationDiff.previousParticipantIds),
              currentStatus: conversationDiff.currentStatus,
              currentParticipantIds: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(conversationDiff.currentParticipantIds),
              conversationId: conversationDiff.conversationId
            };
          }),
          conversationIds: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(conversationDiffs.map(function (conversationDiff) {
            return conversationDiff.conversationId;
          })),
          updateRequestId: updateRequestId,
          inboxId: inboxId
        }));
      });
    }).takeUntil(leaveChannel$);
  });
};

var requestBulkUpdate = function requestBulkUpdate(action$, _ref2) {
  var getState = _ref2.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* requestBulkUpdate */].toString()).pluck('payload')
  // NOTE: Backend currenly only supports bulk close.
  .filter(function (_ref3) {
    var conversationStatus = _ref3.conversationStatus;
    return conversationStatus === __WEBPACK_IMPORTED_MODULE_10_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key;
  }).mergeMap(function (_ref4) {
    var updateRequestId = _ref4.updateRequestId,
        inboxId = _ref4.inboxId,
        conversationIds = _ref4.conversationIds;

    if (__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].timer(100) // Artificial delay
      .map(function () {
        return __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* requestBulkUpdateSuccess */]({ inboxId: inboxId, tempUpdateRequestId: updateRequestId, updateRequestId: __WEBPACK_IMPORTED_MODULE_2_lodash_uniqueId___default()('server_generated_update_request_') });
      }).startWith(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* requestBulkUpdatePending */]({ updateRequestId: updateRequestId }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].requestBulkClose({ inboxId: inboxId, conversationIds: conversationIds }).map(function (_ref5) {
        var serverGeneratedUpdateRequestId = _ref5.response.requestId;

        return __WEBPACK_IMPORTED_MODULE_5__actions__["h" /* requestBulkUpdateSuccess */]({
          inboxId: inboxId,
          tempUpdateRequestId: updateRequestId,
          updateRequestId: serverGeneratedUpdateRequestId
        });
      }).startWith(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* requestBulkUpdatePending */]({ updateRequestId: updateRequestId })).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* requestBulkUpdateFailed */]({ error: error, updateRequestId: updateRequestId }));
      });
    }
  });
};

var requestBulkUpdateSuccess = function requestBulkUpdateSuccess(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* requestBulkUpdateSuccess */].toString()).pluck('payload').map(function (_ref6) {
    var updateRequestId = _ref6.updateRequestId;
    return __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* receiveBulkUpdate */]({ updateRequestId: updateRequestId, status: 'PENDING' });
  });
};

var receiveBulkUpdate = function receiveBulkUpdate(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* receiveBulkUpdate */].toString()).pluck('payload').filter(function (_ref7) {
    var status = _ref7.status;
    return VALID_RECEIVE_BULK_UPDATE_STATUSES.includes(status);
  }).map(function (payload) {
    var updateRequestId = payload.updateRequestId,
        status = payload.status;


    switch (status) {
      case 'PENDING':
        return __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* receiveBulkUpdatePending */]({ updateRequestId: updateRequestId });
      case 'FAILED':
        return __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* receiveBulkUpdateFailed */]({ updateRequestId: updateRequestId });
      case 'SUCCESS':
        return __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* receiveBulkUpdateSuccess */](payload);
    }
  });
};

var receiveBulkUpdatePending = function receiveBulkUpdatePending(action$, _ref8) {
  var getState = _ref8.getState;

  var participantIdsByConversationIdSelector = __WEBPACK_IMPORTED_MODULE_8_app_modules_conversation_selectors__["s" /* makeParticipantIdsByConversationId */]();
  var conversationStatusByConversationIdSelector = __WEBPACK_IMPORTED_MODULE_8_app_modules_conversation_selectors__["q" /* makeConversationStatusByConversationId */]();

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* receiveBulkUpdatePending */].toString()).pluck('payload').filter(function () {
    return __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState());
  }).mergeMap(function (_ref9) {
    var updateRequestId = _ref9.updateRequestId;

    var state = getState();

    var bulkUpdateRequest = __WEBPACK_IMPORTED_MODULE_6__selectors__["a" /* bulkUpdateRequest */](state, { updateRequestId: updateRequestId });

    var participantIdsByConversationId = participantIdsByConversationIdSelector(state, {
      conversationIds: bulkUpdateRequest.get('conversationIds')
    });

    var conversationStatusByConversationId = conversationStatusByConversationIdSelector(state, {
      conversationIds: bulkUpdateRequest.get('conversationIds')
    });

    var successPayload = {
      inboxId: bulkUpdateRequest.get('inboxId'),
      updaterId: bulkUpdateRequest.get('updaterId'),
      updateRequestId: bulkUpdateRequest.get('id'),
      conversationDiffs: bulkUpdateRequest.get('conversationIds').map(function (conversationId) {
        var participantIds = participantIdsByConversationId.get(conversationId);

        return {
          conversationId: conversationId,
          currentStatus: bulkUpdateRequest.get('conversationStatus'),
          previousStatus: conversationStatusByConversationId.get(conversationId),
          currentParticipantIds: participantIds,
          previousParticipantIds: participantIds
        };
      })
    };

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].timer(500) // Artificial delay
    .map(function () {
      return __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* receiveBulkUpdateSuccess */](successPayload);
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(handleBulkUpdateSocketEvent, requestBulkUpdate, requestBulkUpdateSuccess, receiveBulkUpdate, receiveBulkUpdatePending);

/***/ }),

/***/ "aiMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aj9M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__ = __webpack_require__("PIqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_profile_actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_calendar_check_svg__ = __webpack_require__("/mUT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_calendar_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_calendar_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_female_placeholder_svg__ = __webpack_require__("Q8nZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_female_placeholder_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_female_placeholder_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_team_2_svg__ = __webpack_require__("H439");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_team_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_team_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_styl__ = __webpack_require__("Bo3U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm'
};

var DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR';
var ENTITY_TYPE = 'LINK';

var getCalendarLink = function getCalendarLink(user) {
  if (user === DYNAMIC_CALENDAR) {
    return '{{ sender.profile_schedule_url }}';
  } else {
    return 'https://' + __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */] + '/' + user.getIn(['profile', 'globalHandle']) + '/meeting';
  }
};

var insertCalendar = function insertCalendar(linkText, link, editorState) {
  var pushChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

  var contentState = __WEBPACK_IMPORTED_MODULE_0_draft_js__["Modifier"].insertText(editorState.getCurrentContent(), editorState.getSelection(), linkText, null, __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].create(ENTITY_TYPE, 'MUTABLE', {
    href: link,
    target: '_blank'
  }));
  pushChange(__WEBPACK_IMPORTED_MODULE_0_draft_js__["EditorState"].push(editorState, contentState, 'insert-characters'));
};

var CalendarPopoverSelect = function (_React$Component) {
  _inherits(CalendarPopoverSelect, _React$Component);

  function CalendarPopoverSelect() {
    _classCallCheck(this, CalendarPopoverSelect);

    return _possibleConstructorReturn(this, (CalendarPopoverSelect.__proto__ || Object.getPrototypeOf(CalendarPopoverSelect)).apply(this, arguments));
  }

  _createClass(CalendarPopoverSelect, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          usersWithCalendar = _props.usersWithCalendar,
          usersWithoutCalendar = _props.usersWithoutCalendar,
          search = _props.search,
          onSearchChange = _props.onSearchChange,
          onPropertySelect = _props.onPropertySelect,
          currentUser = _props.currentUser,
          currentUserHasCalendarConnected = _props.currentUserHasCalendarConnected,
          enableDynamicCalendarLink = _props.enableDynamicCalendarLink,
          showCurrentUser = _props.showCurrentUser,
          isSearching = _props.isSearching;


      return React.createElement(
        'div',
        { className: 'popover-selector-container' },
        React.createElement(
          'div',
          { className: 'popover-selector-section popover-selector-section-top drift-form' },
          React.createElement('input', {
            className: 'popover-selector-search-input',
            type: 'text',
            value: search,
            onChange: onSearchChange,
            placeholder: 'Search'
          })
        ),
        React.createElement(
          'div',
          { className: 'rich-editor-calendar-popover-options' },
          !!enableDynamicCalendarLink && !isSearching && React.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('rich-editor-calendar-popover-option'),
              onClick: function onClick() {
                return onPropertySelect(DYNAMIC_CALENDAR);
              }
            },
            React.createElement(
              'div',
              { className: 'rich-editor-calendar-dynamic-option-icon' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_team_2_svg___default.a })
            ),
            React.createElement(
              'span',
              { className: 'rich-editor-calendar-popover-option-name' },
              'Dynamic based on email sender'
            )
          ),
          showCurrentUser && React.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('rich-editor-calendar-popover-option', { 'rich-editor-calendar-popover-option-disabled': !currentUserHasCalendarConnected }),
              onClick: function onClick() {
                return currentUserHasCalendarConnected ? onPropertySelect(currentUser) : null;
              }
            },
            React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: currentUser }),
            React.createElement(
              'span',
              { className: 'rich-editor-calendar-popover-option-name' },
              Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(currentUser)
            ),
            !currentUserHasCalendarConnected && React.createElement(
              'a',
              {
                href: '/meetings/?source=email-playbook-editor',
                className: 'link dsg-Regular'
              },
              'Connect your calendar'
            )
          ),
          usersWithCalendar.map(function (user) {
            return React.createElement(
              'div',
              {
                key: user,
                className: 'rich-editor-calendar-popover-option',
                onClick: function onClick() {
                  return onPropertySelect(user);
                }
              },
              React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
              React.createElement(
                'span',
                { className: 'rich-editor-calendar-popover-option-name' },
                Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(user)
              )
            );
          }),
          usersWithoutCalendar.size > 0 && React.createElement(
            'div',
            { className: 'rich-editor-calendar-popover-options-header' },
            'These calendars are not connected.'
          ),
          usersWithoutCalendar.map(function (user) {
            return React.createElement(
              'div',
              {
                key: user,
                className: 'rich-editor-calendar-popover-option rich-editor-calendar-popover-option-disabled'
              },
              React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: user }),
              React.createElement(
                'span',
                { className: 'rich-editor-calendar-popover-option-name' },
                Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(user)
              )
            );
          }),
          usersWithoutCalendar.size === 0 && usersWithCalendar.size === 0 && !showCurrentUser && React.createElement(
            'div',
            { className: 'popover-calendar-selector-empty-options' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_female_placeholder_svg___default.a }),
            React.createElement(
              'p',
              null,
              'There is no one on your team by that name.'
            )
          )
        )
      );
    }
  }]);

  return CalendarPopoverSelect;
}(React.Component);

var CalendarPopoverConfirm = function CalendarPopoverConfirm(_ref) {
  var onDefaultCancel = _ref.onDefaultCancel,
      onDefaultConfirm = _ref.onDefaultConfirm,
      selectedUser = _ref.selectedUser,
      linkText = _ref.linkText,
      onDefaultChange = _ref.onDefaultChange,
      calendarProfileLoading = _ref.calendarProfileLoading;
  return React.createElement(
    'div',
    { className: 'popover-selector-container' },
    React.createElement(
      'div',
      { className: 'popover-selector-section popover-selector-section-top' },
      React.createElement(
        'div',
        null,
        selectedUser === DYNAMIC_CALENDAR && React.createElement(
          'div',
          { className: 'popover-selector-user-preview' },
          React.createElement(
            'span',
            { className: 'popover-selector-user-preview-name' },
            'Dynamic based on email sender'
          )
        ),
        selectedUser !== DYNAMIC_CALENDAR && React.createElement(
          'div',
          { className: 'popover-selector-user-preview' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_web_src_components_Avatar__["a" /* default */], { size: 'small', user: selectedUser }),
          React.createElement(
            'span',
            { className: 'popover-selector-user-preview-name' },
            Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(selectedUser)
          )
        )
      ),
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'link' },
        'Back'
      )
    ),
    React.createElement(
      'div',
      { className: 'drift-form popover-calendar-confirm-form' },
      React.createElement(
        'label',
        { className: 'default-form-label' },
        'Link text:'
      ),
      React.createElement('input', { type: 'text', value: linkText, onChange: onDefaultChange }),
      React.createElement(
        'p',
        { className: 'default-form-extra-details' },
        'Default values display when a contact doesn\u2018t have a value for this variable'
      )
    ),
    React.createElement(
      'div',
      { className: 'popover-selector-section' },
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'popover-selector-section-button drift-button drift-button-secondary' },
        'Cancel'
      ),
      React.createElement(
        'div',
        { onClick: onDefaultConfirm, disabled: !!calendarProfileLoading, className: 'popover-selector-section-button drift-button drift-button-primary' },
        'Insert'
      )
    )
  );
};

var CalendarPopover = function CalendarPopover(props) {
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()("rich-editor-calendar-popover", { 'rich-editor-popover-bottom-anchor': !!props.popoverAnchorBottom }) },
    props.popoverStep === CalendarPopoverSteps.SELECT && React.createElement(CalendarPopoverSelect, props),
    props.popoverStep === CalendarPopoverSteps.CONFIRM && React.createElement(CalendarPopoverConfirm, props)
  );
};

var CalendarButton = function CalendarButton(props) {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_6_react_tether___default.a,
    {
      attachment: 'top left',
      targetAttachment: 'top right',
      targetOffset: '0 10px',
      constraints: [{ to: 'scrollParent', attachment: 'together' }]
    },
    React.createElement(
      'div',
      { className: 'rich-editor-calendar-button-container' },
      React.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('rich-editor-calendar-button', 'rich-editor-toolbar-button', { active: props.popoverOpen }),
          onClick: props.togglePopoverOpen
        },
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_calendar_check_svg___default.a, className: 'rich-editor-toolbar-button-icon' }),
        React.createElement(
          'span',
          null,
          'Calendar Link'
        )
      ),
      props.popoverOpen && React.createElement(CalendarPopover, props)
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsersById: __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["nonBotOrgUsersAlphabetical"](state).toList(),
    currentUser: __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"](state),
    calendarConnectedAgentIds: __WEBPACK_IMPORTED_MODULE_12_app_modules_meetings_selectors__["a" /* getAgentIdsWithConnectedCalendars */](state),
    calendarProfileLoading: __WEBPACK_IMPORTED_MODULE_15_app_modules_playbook_selectors__["h" /* calendarProfileLoading */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({
      fetchUserProfile: __WEBPACK_IMPORTED_MODULE_16_app_modules_profile_actions__["fetchUserProfile"]
    }, dispatch)
  };
};

var CalendarButtonContainer = Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["j" /* withState */])('selectedUser', 'setSelectedUser', undefined), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["j" /* withState */])('popoverStep', 'setPopoverStep', CalendarPopoverSteps.SELECT), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["j" /* withState */])('popoverOpen', 'setPopoverOpen', false), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["j" /* withState */])('search', 'setSearch', ''), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["j" /* withState */])('linkText', 'setLinkText', 'Schedule a meeting'), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["i" /* withProps */])(function (props) {
  var usersWithoutCalendar = props.orgUsersById.filter(function (user) {
    return !props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id');
  });
  var usersWithCalendar = props.orgUsersById.filter(function (user) {
    return props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id');
  });
  if (!props.search) {
    return {
      usersWithoutCalendar: usersWithoutCalendar,
      usersWithCalendar: usersWithCalendar,
      currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
      showCurrentUser: true,
      isSearching: false
    };
  } else {
    var withCalFiltered = usersWithCalendar.filter(function (user) {
      return Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(user).toLowerCase().includes(props.search.toLowerCase());
    });
    var withoutCalFiltered = usersWithoutCalendar.filter(function (user) {
      return Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(user).toLowerCase().includes(props.search.toLowerCase());
    });
    var showCurrentUser = props.currentUser && !!props.search && Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_utils__["a" /* getUserDisplayName */])(props.currentUser).toLowerCase().includes(props.search.toLowerCase());
    return {
      usersWithoutCalendar: withoutCalFiltered,
      usersWithCalendar: withCalFiltered,
      currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
      showCurrentUser: showCurrentUser,
      isSearching: true
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_5_recompose__["h" /* withHandlers */])({
  onPropertySelect: function onPropertySelect(props) {
    return function (user) {
      props.setSelectedUser(user);
      if (user !== DYNAMIC_CALENDAR) {
        props.actions.fetchUserProfile(user.get('id'));
      }
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM);
    };
  },
  onDefaultConfirm: function onDefaultConfirm(props) {
    return function () {
      props.setPopoverStep(CalendarPopoverSteps.SELECT);
      // the select value (user) that's being passed around hasn't been hydrated with the profile info, so we're going to get the user from the store
      var selectedUser = props.selectedUser;
      if (selectedUser !== DYNAMIC_CALENDAR) {
        selectedUser = props.orgUsersById.filter(function (user) {
          return user.get('id') === props.selectedUser.get('id');
        }).first();
      }
      insertCalendar(props.linkText, getCalendarLink(selectedUser), props.editorState, props.onChange);
      props.setPopoverOpen(false);
    };
  },
  onDefaultCancel: function onDefaultCancel(props) {
    return function () {
      props.setSelectedUser(undefined);
      props.setLinkText('Schedule a meeting');
      props.setPopoverStep(CalendarPopoverSteps.SELECT);
    };
  },
  togglePopoverOpen: function togglePopoverOpen(props) {
    return function () {
      props.setPopoverOpen(!props.popoverOpen);
    };
  },
  onSearchChange: function onSearchChange(props) {
    return function (event) {
      props.setSearch(event.target.value);
    };
  },
  onDefaultChange: function onDefaultChange(props) {
    return function (event) {
      // make sure to escape double quotes
      props.setLinkText(event.target.value);
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function () {
      props.setPopoverOpen(false);
    };
  }
}), __WEBPACK_IMPORTED_MODULE_8_react_onclickoutside_decorator___default.a)(CalendarButton);

var CalendarDecorator = {
  strategy: __WEBPACK_IMPORTED_MODULE_1_draft_extend__["pluginUtils"].entityStrategy(ENTITY_TYPE),
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Tag"], { className: 'rich-editor-calendar', tag: { name: props.children } });
  }
};

var htmlToEntity = function htmlToEntity(nodeName, node) {
  if (nodeName === 'a') {
    return __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].create(ENTITY_TYPE, 'MUTABLE', {
      href: node.getAttribute('href'),
      target: node.getAttribute('target')
    });
  }
};

var entityToHTML = function entityToHTML(entity, originalText) {
  if (entity.type === ENTITY_TYPE) {
    return '<a href="' + entity.data.href + '" target="' + entity.data.target + '">' + originalText + '</a>';
  }
  return originalText;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_draft_extend__["createPlugin"])({
  decorators: CalendarDecorator,
  buttons: CalendarButtonContainer,
  htmlToEntity: htmlToEntity,
  entityToHTML: entityToHTML
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "aotX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TitleCard":"TitleCard---3x-r1"};

/***/ }),

/***/ "ar93":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(40);

/***/ }),

/***/ "arqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  requestBulkClose: function requestBulkClose(_ref) {
    var inboxId = _ref.inboxId,
        conversationIds = _ref.conversationIds;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post("/conversations/update/close", {
      inboxId: inboxId,
      conversationIds: conversationIds,
      status: "CLOSED"
    }).checkStatus();
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (api);

/***/ }),

/***/ "asTl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__ = __webpack_require__("qFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_TagTypeEnum__ = __webpack_require__("gC8o");



var TagStore = Marty.createStore({
  id: 'TagStore',
  getInitialState: function getInitialState() {
    return {
      tagsById: {}
    };
  },


  handlers: {
    fetchTagListDone: __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_LIST_FETCH_DONE,
    createTag: __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_CREATE,
    updateTag: __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_UPDATE,
    deleteTag: __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].TAG_DELETE,
    pushTag: __WEBPACK_IMPORTED_MODULE_0_constants_TagConstants__["a" /* default */].PUSH_TAG
  },

  getOrFetchTagList: function getOrFetchTagList() {
    return this.fetch({
      id: 'fetchTags',
      // gotta make sure the access token work
      dependsOn: [this.app.stores.UserStore.getOrFetchCurrentUser()],
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchTags')) {
          return this.state.tagsById;
        }
      },
      remotely: function remotely() {
        return this.app.queries.TagQueries.fetchTagsForOrgId(this.app.stores.UserStore.getCurrentUser().orgId);
      }
    });
  },
  getOrFetchConversationTagList: function getOrFetchConversationTagList() {
    return this.fetch({
      id: 'fetchConversationTags',
      dependsOn: [this.getOrFetchTagList()],
      locally: function locally() {
        return _.filter(this.state.tagsById, function (tag) {
          return tag.targetType === __WEBPACK_IMPORTED_MODULE_1_constants_TagTypeEnum__["a" /* default */].CONVERSATION.key;
        });
      }
    });
  },
  getOrFetchCustomerTagList: function getOrFetchCustomerTagList() {
    return this.fetch({
      id: 'fetchCustomerTags',
      dependsOn: [this.getOrFetchTagList()],
      locally: function locally() {
        return _.filter(this.state.tagsById, function (tag) {
          return tag.targetType === __WEBPACK_IMPORTED_MODULE_1_constants_TagTypeEnum__["a" /* default */].ANY.key;
        });
      }
    });
  },
  getOrFetchCompanyTagList: function getOrFetchCompanyTagList() {
    return this.fetch({
      id: 'fetchCompanyTags',
      dependsOn: [this.getOrFetchTagList()],
      locally: function locally() {
        return _.filter(this.state.tagsById, function (tag) {
          return tag.targetType === __WEBPACK_IMPORTED_MODULE_1_constants_TagTypeEnum__["a" /* default */].ANY.key;
        });
      }
    });
  },
  getOrFetchTagIdsForConversationId: function getOrFetchTagIdsForConversationId(conversationId) {
    return this.fetch({
      id: 'getOrFetchTagListForConversationId' + conversationId,
      dependsOn: [this.app.stores.ConversationStore.getOrFetchConversation(conversationId)],
      locally: function locally() {
        return this.app.stores.ConversationStore.getConversationById(conversationId).tags;
      }
    });
  },
  getOrFetchTagIdsForEndUserId: function getOrFetchTagIdsForEndUserId(endUserId) {
    return this.fetch({
      id: 'getOrFetchTagListForEndUserId' + endUserId,
      dependsOn: [this.app.stores.EndUserStore.getOrFetchEndUser(endUserId)],
      locally: function locally() {
        return this.app.stores.EndUserStore.getEndUser(endUserId).tags;
      }
    });
  },
  getOrFetchTagIdsForCompanyId: function getOrFetchTagIdsForCompanyId(companyId) {
    return this.fetch({
      id: 'getOrFetchTagListForCompanyId' + companyId,
      dependsOn: [this.app.stores.CompanyStore.getOrFetchCompany(companyId)],
      locally: function locally() {
        return this.app.stores.CompanyStore.getCompany(companyId).tags;
      }
    });
  },
  fetchTagListDone: function fetchTagListDone(tags) {
    return this.setState({ tagsById: _.keyBy(tags, 'id') });
  },
  getTag: function getTag(tagId) {
    return this.state.tagsById[tagId];
  },
  createTag: function createTag(tagParams) {
    var _app$stores$UserStore = this.app.stores.UserStore.getCurrentUser(),
        orgId = _app$stores$UserStore.orgId;

    return this.app.queries.TagQueries.createTagForOrgId(orgId, tagParams);
  },
  updateTag: function updateTag(tagId, tagParams) {
    var _app$stores$UserStore2 = this.app.stores.UserStore.getCurrentUser(),
        orgId = _app$stores$UserStore2.orgId;

    return this.app.queries.TagQueries.updateTagForOrgId(orgId, tagId, tagParams);
  },
  deleteTag: function deleteTag(tagId) {
    var _app$stores$UserStore3 = this.app.stores.UserStore.getCurrentUser(),
        orgId = _app$stores$UserStore3.orgId;

    return this.app.queries.TagQueries.deleteTagForOrgId(orgId, tagId);
  },
  setTag: function setTag(tag) {
    var tagsById = _.cloneDeep(this.state.tagsById);
    tagsById[tag.id] = tag;
    return this.setState({ tagsById: tagsById });
  },
  deleteTagById: function deleteTagById(tagId) {
    var tagsById = _.cloneDeep(this.state.tagsById);
    delete tagsById[tagId];
    return this.setState({ tagsById: tagsById });
  },
  pushTag: function pushTag(tag) {
    if (tag.status === 'ARCHIVED') {
      return this.deleteTagById(tag.id);
    } else {
      return this.setTag(tag);
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TagStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "auMU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/***/ }),

/***/ "auPN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"EmailCapturePreview":"EmailCapturePreview---2zRKP"};

/***/ }),

/***/ "avVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_ToggleSection__ = __webpack_require__("itDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_HelpDocConstants__ = __webpack_require__("fBam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_containers_app__ = __webpack_require__("AJef");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var TOGGLE_ERROR_MESSAGE = 'Oops, something went wrong. Please try again.';
var TOGGLE_DESCRIPTION = 'Enable this integration so your Drift team can access their LinkedIn Sales Navigator features from within Drift! Once enabled, your teammates will have the opportunity to connect their Sales Navigator accounts.';
var defaultToEmptyObject = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["defaultTo"])({});

var Linkedin = function (_Component) {
  _inherits(Linkedin, _Component);

  function Linkedin(props) {
    _classCallCheck(this, Linkedin);

    var _this = _possibleConstructorReturn(this, (Linkedin.__proto__ || Object.getPrototypeOf(Linkedin)).call(this, props));

    _this.refreshOrgProperties = function () {
      var notifications = _this.props.notifications;
      var isEnabled = _this.state.isEnabled;

      notifications.success('LinkedIn Sales Navigator has successfully been ' + (isEnabled ? 'connected' : 'disconnected') + '!');
      return _this.props.actions.fetchOrgProperties();
    };

    _this.toggleEnabled = function (isEnabled) {

      var onError = function onError() {
        _this.props.notifications.error(TOGGLE_ERROR_MESSAGE);
        _this.setState({ isEnabled: !isEnabled });
      };

      var onLocalStateSet = function onLocalStateSet() {
        Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["_0" /* toggleLinkedinIntegration */])(isEnabled).catch(onError).then(function () {
          return _this.props.actions.fetchIntegrationStates();
        }).then(_this.refreshOrgProperties);
      };

      _this.setState({ isEnabled: isEnabled }, onLocalStateSet);
    };

    _this.state = {
      isEnabled: props.isEnabled
    };
    return _this;
  }

  _createClass(Linkedin, [{
    key: 'render',
    value: function render() {
      var isEnabled = this.state.isEnabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'linkedin-description' },
          'Enable the LinkedIn Sales Navigator Integration. \xA0',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: __WEBPACK_IMPORTED_MODULE_10_constants_HelpDocConstants__["f" /* LINKEDIN_HELPDOC_URL */] },
            'Learn more.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_ToggleSection__["a" /* default */], {
          title: 'Add LinkedIn Sales Navigator to Drift',
          description: TOGGLE_DESCRIPTION,
          isActive: isEnabled,
          onToggled: Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["partial"])(this.toggleEnabled, [!isEnabled]),
          className: 'linkedin-toggle-section'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
      );
    }
  }]);

  return Linkedin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnabled: defaultToEmptyObject(__WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__["properties"](state)).isLinkedinEnabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ fetchOrgProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["fetchOrgProperties"], fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__["l" /* fetchIntegrationStates */] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(Linkedin)));

/***/ }),

/***/ "b+Ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EloquaMapping; });
var EloquaMapping = {
  static: false,
  defaultValue: null,
  driftAttribute: null,
  integrationAttribute: null,
  isOverwritable: null
};

/***/ }),

/***/ "b/iu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__("GX2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var vidyardScriptId = 'vidyard-script';
var config = { clientId: 'drift.com' };

var VidyardModal = function (_Component) {
  _inherits(VidyardModal, _Component);

  function VidyardModal(props) {
    _classCallCheck(this, VidyardModal);

    var _this = _possibleConstructorReturn(this, (VidyardModal.__proto__ || Object.getPrototypeOf(VidyardModal)).call(this, props));

    _this.createVidyardScript = function () {
      var script = document.createElement('script');
      script.id = vidyardScriptId;
      script.src = '//app.vidyard.com/v1/embed.js';
      return script;
    };

    _this.onViyardScriptLoaded = function () {
      _this.setState({ isLoading: false });
      _this.createVidyardLibrary();
    };

    _this.createVidyardLibrary = function () {
      var library = window.Vidyard.goVideo.createLibrary(_this.embedElement, config);
      library.on('player:created', _this.onPlayerCreated);
    };

    _this.onPlayerCreated = function (_ref) {
      var embed_codes = _ref.embed_codes;
      var _this$props = _this.props,
          onVideoInserted = _this$props.onVideoInserted,
          _this$props$insertFul = _this$props.insertFull,
          insertFull = _this$props$insertFul === undefined ? false : _this$props$insertFul;

      if (onVideoInserted) {
        if (insertFull) {
          onVideoInserted(embed_codes);
        } else {
          onVideoInserted(embed_codes.sharing_page);
        }
      }
      _this.setState({ isOpen: false });
    };

    _this.loadVidyardScript = function () {
      var script = _this.createVidyardScript();
      script.onload = _this.onViyardScriptLoaded;

      document.body.appendChild(script);
    };

    _this.removeVidyardScript = function () {
      var elt = document.getElementById(vidyardScriptId);
      if (!!elt) elt.remove();
    };

    _this.tryLoadVidyardScript = function () {
      if (document.getElementById(vidyardScriptId)) _this.removeVidyardScript();
      _this.loadVidyardScript();
    };

    _this.closeModal = function () {
      var tryInvokeOnClosed = function tryInvokeOnClosed() {
        var onClosed = _this.props.onClosed;

        onClosed && onClosed();
      };
      _this.setState({ isOpen: false }, tryInvokeOnClosed);
    };

    _this.captureEmbedElement = function (element) {
      _this.embedElement = element;
    };

    _this.state = {
      isOpen: props.isOpen,
      isLoading: true
    };
    return _this;
  }

  _createClass(VidyardModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ isOpen: !!props.isOpen });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isOpen = _state.isOpen,
          isLoading = _state.isLoading;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_components_shared_Modal__["a" /* default */],
        {
          isOpen: isOpen,
          onAfterOpen: this.tryLoadVidyardScript,
          onRequestClose: this.closeModal,
          className: 'vidyard-modal-content' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_ConditionalRender__["a" /* default */],
          { condition: isLoading },
          React.createElement(
            'div',
            { className: 'vidyard-modal-loader' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_CircleOfWaiting__["a" /* default */], null)
          )
        ),
        React.createElement('div', { ref: this.captureEmbedElement })
      );
    }
  }]);

  return VidyardModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (VidyardModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "b2Ql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);


var authenticate = function authenticate(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      authParams = _ref.authParams;

  return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].ajax({
    url: apiBaseUrl + '/api/auth',
    method: 'POST',
    crossDomain: true,
    responseType: 'json',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(authParams)
  }).retryWhen(function (errors) {
    return errors.scan(function (count, error) {
      if (count >= 3) {
        throw error;
      }
      return count + 1;
    }, 0).mergeMap(function (count) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].timer(2 ^ count * 1000);
    });
  }).map(function (data) {
    return {
      userIpAddress: data.response.remote_ip,
      userId: data.response.user_id,
      sessionToken: data.response.session_token
    };
  });
};

/***/ }),

/***/ "b3Ti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchFirstMessagesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchFirstMessagesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return receiveFirstMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchConversationMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchPaginatedConversationMessagesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchPaginatedConversationMessagesFailed; });
/* unused harmony export fetchPaginatedConversationMessagesCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return receivePaginatedMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchNextPaginatedConversationMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchNextPaginatedConversationMessagesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchNextPaginatedConversationMessagesFailed; });
/* unused harmony export fetchNextPaginatedConversationMessagesCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return receiveNextMessageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMessagePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createMessageFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return receiveMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return removeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return messageRead; });
/* unused harmony export messageReadPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return messageReadFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return messageReadSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return optimisticMessageReadSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return markMessageReadByConversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bulkMessageReadSuccess; });
/* unused harmony export messageReadUntilFailed */
/* unused harmony export messageReadUntilSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return receiveMessageRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return notifyUser; });
/* unused harmony export browserNotification */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return selectBotAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchPlaybookContext; });
/* unused harmony export loadMoreMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return receiveBulkUpdateMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("x/uU");



var fetchFirstMessagesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_FIRST_MESSAGES_PENDING */]);
var fetchFirstMessagesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_FIRST_MESSAGES_FAILED */]);
var receiveFirstMessages = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* RECEIVE_FIRST_MESSAGES */]);

var fetchConversationMessages = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_CONVERSATION_MESSAGES */]);
var fetchPaginatedConversationMessagesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING */]);
var fetchPaginatedConversationMessagesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED */]);
var fetchPaginatedConversationMessagesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED */]);
var receivePaginatedMessageList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* RECEIVE_PAGINATED_MESSAGE_LIST */]);

var fetchNextPaginatedConversationMessages = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES */]);
var fetchNextPaginatedConversationMessagesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING */]);
var fetchNextPaginatedConversationMessagesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED */]);
var fetchNextPaginatedConversationMessagesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED */]);
var receiveNextMessageList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* RECEIVE_NEXT_MESSAGE_LIST */]);

var createMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_MESSAGE */]);
var createMessagePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CREATE_MESSAGE_PENDING */]);
var createMessageFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_MESSAGE_FAILED */]);
var receiveMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* RECEIVE_MESSAGE */]);

var removeMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* REMOVE_MESSAGE */]);

var messageRead = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* MESSAGE_READ */]);
var messageReadPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* MESSAGE_READ_PENDING */]);
var messageReadFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* MESSAGE_READ_FAILED */]);
var messageReadSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* MESSAGE_READ_SUCCESS */]); // dummy
var optimisticMessageReadSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* OPTIMISTIC_MESSAGE_READ_SUCCESS */]);
var markMessageReadByConversation = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* MARK_MESSAGE_READ_BY_CONVERSATION */]);
var bulkMessageReadSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BULK_MESSAGE_READ_SUCCESS */]);

var messageReadUntilFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* MESSAGE_READ_UNTIL_FAILED */]);
var messageReadUntilSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* MESSAGE_READ_UNTIL_SUCCESS */]);

var receiveMessageRead = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* RECEIVE_MESSAGE_READ */]);

var notifyUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* NOTIFY_USER */]);
var browserNotification = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* BROWSER_NOTIFICATION */]);

var selectBotAction = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SELECT_BOT_ACTION */]);
var fetchPlaybookContext = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_PLAYBOOK_CONTEXT */]);

var loadMoreMessages = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* LOAD_MORE_MESSAGES */]);

var receiveBulkUpdateMessages = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* RECEIVE_BULK_UPDATE_MESSAGES */]);

/***/ }),

/***/ "b3eM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY_CATEGORIES; });

var COMPANY_CATEGORIES = ['3D Printing', 'Accounting', 'Aerospace & Defense', 'Agriculture', 'Airlines', 'Alternative Medicine', 'Animation', 'Apparel & Fashion', 'Apparel & Footwear', 'Architecture', 'Arts', 'Arts & Crafts', 'Asset Management', 'Audio', 'Automation', 'Automotive', 'Banking & Mortgages', 'Beverages', 'Biotechnology', 'Broadband', 'Broadcasting', 'Building Materials', 'Business Supplies', 'Chemicals', 'Civil Engineering', 'Cloud Services', 'Communications', 'Computer Hardware', 'Computer Networking', 'Construction', 'Consulting & Professional Services', 'Consumer Discretionary', 'Consumer Electronics', 'Consumer Staples', 'Corporate & Business', 'Cosmetics', 'Design', 'E-Commerce & Marketplaces', 'E-Learning', 'Education', 'Electrical', 'Energy', 'Entertainment & Recreation', 'Eyewear', 'Facilities', 'Family Services', 'Finance', 'Financial Services', 'Fine Art', 'Fishery', 'Food', 'Food Production', 'Food, Beverage & Tobacco', 'Fundraising', 'Gambling & Casinos', 'Graphic Design', 'Ground Transportation', 'Health & Wellness', 'Health Care', 'Higher Education', 'Home & Furniture', 'Home Improvement', 'Human Resources', 'Import & Export', 'Industrials & Manufacturing', 'Information Technology & Services', 'Insurance', 'International Relations', 'International Trade', 'Internet', 'Investment', 'Investment Banking', 'Investment Management', 'Jewelry, Watches & Luxury Goods', 'Legal Services', 'Libraries', 'Machinery', 'Maritime', 'Market Research', 'Marketing & Advertising', 'Mechanical Engineering', 'Media', 'Medicine', 'Military', 'Mining & Metals', 'Mobile', 'Movies & TV', 'Museums', 'Music', 'Nanotechnology', 'Oil & Gas', 'Outsourcing', 'Packaging & Containers', 'Paper Goods', 'Payments', 'Pharmaceuticals', 'Pharmacy', 'Photography', 'Plastics', 'Plumbing', 'Pornography', 'Primary & Secondary Education', 'Printing', 'Public Relations', 'Publishing', 'Ranching', 'Real Estate', 'Renewable Energy', 'Renewables & Environment', 'Research', 'Restaurants', 'Security', 'Services', 'Shipbuilding', 'Shipping & Logistics', 'Sporting Goods', 'Sports & Fitness', 'Supermarkets', 'Talent Agencies', 'Technology', 'Telecommunications', 'Textiles', 'Tobacco', 'Tools', 'Translation', 'Transportation', 'Travel & Leisure', 'Utilities', 'Venture Capital', 'Veterinary', 'Video Games', 'Wholesale', 'Wireless '];

/***/ }),

/***/ "b4nd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_UIDropdown__ = __webpack_require__("3gGk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_UIDropdownItem__ = __webpack_require__("nj5R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_svg_trash_red_svg__ = __webpack_require__("PGMV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_svg_trash_red_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_svg_trash_red_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("pDON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);








var OptionsDropdown = function OptionsDropdown(_ref) {
  var handleEditClick = _ref.handleEditClick,
      handleDeleteClick = _ref.handleDeleteClick;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.OptionsDropdown },
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_UIDropdown__["a" /* default */],
      {
        title: React.createElement(
          'button',
          { className: 'options-dropdown-button tide-button tide-button--tertiary small' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'options-dropdown-icon', name: 'chevron-down', width: '20' })
        ),
        attachment: 'top right',
        targetAttachment: 'bottom right',
        offset: '8px 0px'
      },
      !!handleEditClick && React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_UIDropdownItem__["a" /* default */],
        { onClick: handleEditClick },
        React.createElement(
          'div',
          { className: 'flex' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'item-icon', name: 'edit-1', width: '15' }),
          'Edit'
        )
      ),
      !!handleDeleteClick && React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_UIDropdownItem__["a" /* default */],
        { onClick: handleDeleteClick },
        React.createElement(
          'div',
          { className: 'flex trash-icon' },
          React.createElement('img', { className: 'item-icon', src: __WEBPACK_IMPORTED_MODULE_3_images_svg_trash_red_svg___default.a, width: '15' }),
          'Delete'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OptionsDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "b54Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("IXNn");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("rVtu");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "b5sd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dates__ = __webpack_require__("OjkW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("g41V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);








var BusinessExportModal = function BusinessExportModal(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onDateChange = _ref.onDateChange,
      onDatePickerFocus = _ref.onDatePickerFocus,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      focusedInput = _ref.focusedInput,
      sourceId = _ref.sourceId,
      _ref$isOutsideRange = _ref.isOutsideRange,
      isOutsideRange = _ref$isOutsideRange === undefined ? function (day) {
    return day.isAfter(__WEBPACK_IMPORTED_MODULE_2_moment___default()()) || day.isBefore(__WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(60, 'days'));
  } : _ref$isOutsideRange,
      _ref$isDayBlocked = _ref.isDayBlocked,
      isDayBlocked = _ref$isDayBlocked === undefined ? function () {
    return false;
  } : _ref$isDayBlocked,
      _ref$initialVisibleMo = _ref.initialVisibleMonth,
      initialVisibleMonth = _ref$initialVisibleMo === undefined ? function () {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'month');
  } : _ref$initialVisibleMo,
      exportRequestPending = _ref.exportRequestPending,
      onClickExportButton = _ref.onClickExportButton,
      disabledReason = _ref.disabledReason;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Modal"],
    { open: open, onClose: onClose, className: 'export-business-events-modal', size: 'medium' },
    React.createElement(
      'div',
      { className: 'export-business-events-modal-body' },
      React.createElement(
        'div',
        null,
        React.createElement(
          'h2',
          { className: 'export-business-events-modal-header' },
          'Export your ',
          Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["startCase"])(sourceId),
          ' activity'
        ),
        React.createElement(
          'p',
          { className: 'export-business-events-modal-subtitle' },
          'You can export up to the last 60 days of log history'
        ),
        React.createElement(
          'div',
          { className: 'export-business-events-modal-part-one' },
          React.createElement(
            'div',
            { className: 'export-business-events-modal-date-picker' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'export-business-events-modal-date-picker--from' },
                'From'
              ),
              React.createElement(
                'span',
                null,
                'To'
              )
            ),
            React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dates__["DateRangePicker"], {
              startDate: startDate,
              endDate: endDate,
              onDatesChange: onDateChange,
              focusedInput: !!focusedInput ? focusedInput : "startDate",
              onFocusChange: onDatePickerFocus,
              isOutsideRange: isOutsideRange,
              enableOutsideDays: false,
              isDayBlocked: isDayBlocked,
              hideKeyboardShortcutsPanel: true,
              initialVisibleMonth: initialVisibleMonth
            })
          )
        )
      )
    ),
    React.createElement(
      'footer',
      { className: 'export-business-events-modal-footer' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
        { type: 'primary', disabled: exportRequestPending || !!disabledReason, loading: exportRequestPending, className: 'export-business-events-modal-footer--export-button', onClick: onClickExportButton },
        'Export CSV'
      ),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
        { type: 'tertiary', onClick: onClose },
        'Cancel'
      ),
      !!disabledReason && React.createElement(
        'span',
        { className: 'export-business-events-disabled-reason' },
        disabledReason
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BusinessExportModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "b93K":
/***/ (function(module, exports) {

module.exports = "<svg width=\"9\" height=\"16\" viewBox=\"0 0 9 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FEF899\" d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061z\"></path><path d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061L5.921 1zm-.85 5.37H8a.75.75 0 0 1 .612 1.183l-5.578 7.88c-.5.708-1.603.143-1.321-.677L3.559 9.38H1a.75.75 0 0 1-.63-1.157L5.292.593c.471-.73 1.6-.207 1.347.625L5.073 6.37z\" fill=\"#E8AD0E\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),

/***/ "b9qL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live-view-preview.6835e602.svg";

/***/ }),

/***/ "bH6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("4/vI");








var fetchUsersAndPropertiesAfterInvite = function fetchUsersAndPropertiesAfterInvite(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["sendInvitationsViaSlackCompleted"].toString(), __WEBPACK_IMPORTED_MODULE_4__actions__["sendExistingUsersInvitationsViaEmailCompleted"].toString(), __WEBPACK_IMPORTED_MODULE_4__actions__["sendInvitationsViaEmailCompleted"].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_actions__["fetchOrgUsers"])(), Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_properties_actions__["e" /* fetchUsersByPropertyName */])(['extensionInvited', 'extensionInstalled']));
  });
};

var fetchEndUserCount = function fetchEndUserCount(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["fetchEndUserCount"].toString()).pluck('payload').mergeMap(function (orgId) {
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].fetchEndUserCount(orgId).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["fetchEndUserCountSuccess"](response.totalMatching);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["fetchEndUserCountPending"](orgId)).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["fetchEndUserCountFailed"]({ error: error, orgId: orgId }));
    });
  });
};

var patchOrgProperties = function patchOrgProperties(action$, _ref) {
  var getState = _ref.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["patchOrgProperties"].toString()).pluck('payload').mergeMap(function (updates) {
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].patchProperties(__WEBPACK_IMPORTED_MODULE_5__selectors__["orgId"](getState()), updates).map(function (result) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["receiveOrgProperties"](result);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["patchOrgPropertiesPending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["patchOrgPropertiesFailure"](error));
    });
  });
};

var hasLimitedContactsMktEmail = function hasLimitedContactsMktEmail(action$, _ref2) {
  var getState = _ref2.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["hasLimitedContactsMktEmail"].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].getHasLimitedContactsMktEmail(__WEBPACK_IMPORTED_MODULE_5__selectors__["orgId"](getState())).map(__WEBPACK_IMPORTED_MODULE_4__actions__["hasLimitedContactsMktEmailSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["hasLimitedContactsMktEmailPending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["hasLimitedContactsMktEmailFailed"](error));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchUsersAndPropertiesAfterInvite, fetchEndUserCount, patchOrgProperties, hasLimitedContactsMktEmail);

/***/ }),

/***/ "bNDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_END_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_END_USER_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RECEIVE_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_END_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_END_USER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_END_USER_LIST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_END_USER_LIST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_END_USER_LIST_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_END_USER_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return JOIN_END_USER_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLOSE_END_USER_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_FOLLOWING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_FOLLOWING_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_FOLLOWING_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_FOLLOWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_FOLLOWING_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPDATE_FOLLOWING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return UPDATE_FOLLOWING_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPDATE_FOLLOWING_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return UPDATE_FOLLOWING_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_CQL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_CQL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_CQL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_CQL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_UNSUBSCRIBED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHECK_UNSUBSCRIBED_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_UNSUBSCRIBED_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHECK_UNSUBSCRIBED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UNSUBSCRIBE_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UNSUBSCRIBE_BY_ENCODED_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UNSUBSCRIBE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UNSUBSCRIBE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UNSUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return RESUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return RESUBSCRIBE_BY_EMAIL_AND_ORG_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return RESUBSCRIBE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return RESUBSCRIBE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return RESUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_UNSUBSCRIBED_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_UNSUBSCRIBED_COUNT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_UNSUBSCRIBED_COUNT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_UNSUBSCRIBED_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_PROPERTY_DEFINITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_PROPERTY_DEFINITION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_PROPERTY_DEFINITION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREATE_PROPERTY_DEFINITION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_PROPERTY_DEFINITION_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return REQUEST_CONTACT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return REQUEST_CONTACT_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return REQUEST_CONTACT_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return REQUEST_CONTACT_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return REQUEST_DELETE_CONTACT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return REQUEST_DELETE_CONTACT_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return REQUEST_DELETE_CONTACT_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return REQUEST_DELETE_CONTACT_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return REQUEST_UNSUB_DELETE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return REQUEST_UNSUB_DELETE_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return REQUEST_UNSUB_DELETE_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return REQUEST_UNSUB_DELETE_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return REQUEST_UNSUB_DELETE_DATA_CANCELLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('endUser');

var FETCH_END_USER = makeConstant('FETCH_END_USER');
var FETCH_END_USER_PENDING = makeConstant('FETCH_END_USER_PENDING');
var FETCH_END_USER_FAILED = makeConstant('FETCH_END_USER_FAILED');
var FETCH_END_USER_CANCELLED = makeConstant('FETCH_END_USER_CANCELLED');
var RECEIVE_END_USER = makeConstant('RECEIVE_END_USER');

var UPDATE_END_USER = makeConstant('UPDATE_END_USER');
var UPDATE_END_USER_PENDING = makeConstant('UPDATE_END_USER_PENDING');
var UPDATE_END_USER_FAILED = makeConstant('UPDATE_END_USER_FAILED');

var FETCH_END_USER_LIST = makeConstant('FETCH_END_USER_LIST');
var FETCH_END_USER_LIST_PENDING = makeConstant('FETCH_END_USER_LIST_PENDING');
var FETCH_END_USER_LIST_FAILED = makeConstant('FETCH_END_USER_LIST_FAILED');
var FETCH_END_USER_LIST_CANCELLED = makeConstant('FETCH_END_USER_LIST_CANCELLED');
var FETCH_END_USER_LIST_SUCCESS = makeConstant('FETCH_END_USER_LIST_SUCCESS');

var JOIN_END_USER_CHANNEL = makeConstant('JOIN_END_USER_CHANNEL');
var CLOSE_END_USER_CHANNEL = makeConstant('CLOSE_END_USER_CHANNEL');

var FETCH_FOLLOWING = makeConstant('FETCH_FOLLOWING');
var FETCH_FOLLOWING_PENDING = makeConstant('FETCH_FOLLOWING_PENDING');
var FETCH_FOLLOWING_FAILED = makeConstant('FETCH_FOLLOWING_FAILED');
var FETCH_FOLLOWING_SUCCESS = makeConstant('FETCH_FOLLOWING_SUCCESS');
var FETCH_FOLLOWING_CANCELLED = makeConstant('FETCH_FOLLOWING_CANCELLED');

var UPDATE_FOLLOWING = makeConstant('UPDATE_FOLLOWING');
var UPDATE_FOLLOWING_PENDING = makeConstant('UPDATE_FOLLOWING_PENDING');
var UPDATE_FOLLOWING_FAILED = makeConstant('UPDATE_FOLLOWING_FAILED');
var UPDATE_FOLLOWING_SUCCESS = makeConstant('UPDATE_FOLLOWING_SUCCESS');

var UPDATE_CQL = makeConstant('UPDATE_CQL');
var UPDATE_CQL_PENDING = makeConstant('UPDATE_CQL_PENDING');
var UPDATE_CQL_FAILED = makeConstant('UPDATE_CQL_FAILED');
var UPDATE_CQL_SUCCESS = makeConstant('UPDATE_CQL_SUCCESS');

var CHECK_UNSUBSCRIBED = makeConstant('CHECK_UNSUBSCRIBED');
var CHECK_UNSUBSCRIBED_PENDING = makeConstant('CHECK_UNSUBSCRIBED_PENDING');
var CHECK_UNSUBSCRIBED_FAILED = makeConstant('CHECK_UNSUBSCRIBED_FAILED');
var CHECK_UNSUBSCRIBED_SUCCESS = makeConstant('CHECK_UNSUBSCRIBED_SUCCESS');

var UNSUBSCRIBE = makeConstant('UNSUBSCRIBE');
var UNSUBSCRIBE_BY_ID = makeConstant('UNSUBSCRIBE_BY_ID');
var UNSUBSCRIBE_BY_ENCODED_EMAIL = makeConstant('UNSUBSCRIBE_BY_ENCODED_EMAIL');
var UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID = makeConstant('UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID');
var UNSUBSCRIBE_PENDING = makeConstant('UNSUBSCRIBE_PENDING');
var UNSUBSCRIBE_FAILED = makeConstant('UNSUBSCRIBE_FAILED');
var UNSUBSCRIBE_SUCCESS = makeConstant('UNSUBSCRIBE_SUCCESS');

var RESUBSCRIBE = makeConstant('RESUBSCRIBE');
var RESUBSCRIBE_BY_EMAIL_AND_ORG_ID = makeConstant('RESUBSCRIBE_BY_EMAIL_AND_ORG_ID');
var RESUBSCRIBE_PENDING = makeConstant('RESUBSCRIBE_PENDING');
var RESUBSCRIBE_FAILED = makeConstant('RESUBSCRIBE_FAILED');
var RESUBSCRIBE_SUCCESS = makeConstant('RESUBSCRIBE_SUCCESS');

var FETCH_UNSUBSCRIBED_COUNT = makeConstant('FETCH_UNSUBSCRIBED_COUNT');
var FETCH_UNSUBSCRIBED_COUNT_PENDING = makeConstant('FETCH_UNSUBSCRIBED_COUNT_PENDING');
var FETCH_UNSUBSCRIBED_COUNT_FAILED = makeConstant('FETCH_UNSUBSCRIBED_COUNT_FAILED');
var FETCH_UNSUBSCRIBED_COUNT_SUCCESS = makeConstant('FETCH_UNSUBSCRIBED_COUNT_SUCCESS');

var CREATE_PROPERTY_DEFINITION = makeConstant('CREATE_PROPERTY_DEFINITION');
var CREATE_PROPERTY_DEFINITION_PENDING = makeConstant('CREATE_PROPERTY_DEFINITION_PENDING');
var CREATE_PROPERTY_DEFINITION_FAILED = makeConstant('CREATE_PROPERTY_DEFINITION_FAILED');
var CREATE_PROPERTY_DEFINITION_SUCCESS = makeConstant('CREATE_PROPERTY_DEFINITION_SUCCESS');
var CREATE_PROPERTY_DEFINITION_CANCELLED = makeConstant('CREATE_PROPERTY_DEFINITION_CANCELLED');

var REQUEST_CONTACT_DATA = makeConstant('REQUEST_CONTACT_DATA');
var REQUEST_CONTACT_DATA_PENDING = makeConstant('REQUEST_CONTACT_DATA_PENDING');
var REQUEST_CONTACT_DATA_SUCCESS = makeConstant('REQUEST_CONTACT_DATA_SUCCESS');
var REQUEST_CONTACT_DATA_FAILED = makeConstant('REQUEST_CONTACT_DATA_FAILED');

var REQUEST_DELETE_CONTACT_DATA = makeConstant('REQUEST_DELETE_CONTACT_DATA');
var REQUEST_DELETE_CONTACT_DATA_PENDING = makeConstant('REQUEST_DELETE_CONTACT_DATA_PENDING');
var REQUEST_DELETE_CONTACT_DATA_SUCCESS = makeConstant('REQUEST_DELETE_CONTACT_DATA_SUCCESS');
var REQUEST_DELETE_CONTACT_DATA_FAILED = makeConstant('REQUEST_DELETE_CONTACT_DATA_FAILED');

var REQUEST_UNSUB_DELETE_DATA = makeConstant('REQUEST_UNSUB_DELETE_DATA');
var REQUEST_UNSUB_DELETE_DATA_PENDING = makeConstant('REQUEST_UNSUB_DELETE_DATA_PENDING');
var REQUEST_UNSUB_DELETE_DATA_FAILED = makeConstant('REQUEST_UNSUB_DELETE_DATA_FAILED');
var REQUEST_UNSUB_DELETE_DATA_SUCCESS = makeConstant('REQUEST_UNSUB_DELETE_DATA_SUCCESS');
var REQUEST_UNSUB_DELETE_DATA_CANCELLED = makeConstant('REQUEST_UNSUB_DELETE_DATA_CANCELLED');

/***/ }),

/***/ "bO/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiSignaturePreview__ = __webpack_require__("g7iH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_playbook_components_Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("cjxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);






var SignaturePreview = function SignaturePreview(_ref) {
  var selectedUserId = _ref.selectedUserId,
      onUserSelect = _ref.onUserSelect,
      selectRandomUser = _ref.selectRandomUser,
      signaturePreviewAllData = _ref.signaturePreviewAllData,
      signaturePreviewAllFetchPending = _ref.signaturePreviewAllFetchPending,
      signaturePreviewAllFetchFailed = _ref.signaturePreviewAllFetchFailed,
      onRefetchPreviewClick = _ref.onRefetchPreviewClick;
  return React.createElement(
    'div',
    null,
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components_playbook_components_Card__["a" /* default */],
      { title: 'Preview Team Signatures' },
      React.createElement(
        'div',
        { className: 'signature-preview-user-select-wrapper' },
        React.createElement(
          'h4',
          null,
          'Choose a user to preview or select a ',
          React.createElement(
            'a',
            { onClick: selectRandomUser },
            'random user'
          )
        ),
        React.createElement(
          'div',
          { className: 'signature-preview-user-select-container' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_UserSelect__["a" /* default */], { className: 'signature-preview-user-select', selectedUserId: selectedUserId, onUserIdChange: onUserSelect })
        )
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0__MultiSignaturePreview__["a" /* default */], {
        multiSignature: signaturePreviewAllData,
        multiSignaturePreviewFetchPending: signaturePreviewAllFetchPending,
        multiSignaturePreviewFetchFailed: signaturePreviewAllFetchFailed,
        onRefetchClick: onRefetchPreviewClick
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePreview);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "bOG0":
/***/ (function(module, exports) {

module.exports = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.354 2.117L11.64 15.775a.977.977 0 0 1-.703.34h-.04a.976.976 0 0 1-.688-.286L5.326 10.95a.975.975 0 1 1 1.38-1.38l4.136 4.133L21.873.847a.977.977 0 0 1 1.48 1.27zm-9.45 2.21H2.136L2.113 21.97l17.675-.002v-11.76c0-.54.333-.92.873-.92s.976.436.976.974v12.682c0 .54-.436.976-.975.976H1.138a.976.976 0 0 1-.977-.976V3.434c0-.54.438-.977.977-.977h12.69c.54 0 .976.437.976.976 0 .538-.36.895-.9.895z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "bOpv":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0zM1.667 10c0-4.583 3.75-8.333 8.333-8.333s8.333 3.75 8.333 8.333-3.75 8.333-8.333 8.333S1.667 14.583 1.667 10zm13.077-.938c.518.761.32 1.798-.44 2.316L9.27 14.803a1.667 1.667 0 0 1-2.604-1.378v-6.85A1.667 1.667 0 0 1 9.27 5.197l5.032 3.425c.174.118.323.267.44.44zm-6.41-2.487v6.85L13.365 10 8.333 6.575z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "bQUY":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><title>Shape</title><path d=\"M7.988 7.173l6.13 6.153a.599.599 0 0 1-.42 1.02.594.594 0 0 1-.422-.175l-6.13-6.153-6.13 6.153a.591.591 0 0 1-.841 0 .599.599 0 0 1 0-.845l6.13-6.153L.174 1.02a.599.599 0 0 1 0-.845.594.594 0 0 1 .841 0l6.13 6.152 6.13-6.152a.594.594 0 0 1 .842 0 .6.6 0 0 1 0 .845l-6.13 6.153z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "bQtw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+dHdpdHRlcjwvdGl0bGU+PHBhdGggZD0iTTEyIDBjNi42MzkgMCAxMiA1LjM2MSAxMiAxMlMxOC42NCAyNCAxMiAyNCAwIDE4LjY0IDAgMTIgNS4zNjEgMCAxMiAwem03LjMwNiA5LjM2MWMuNjY2LS40NzIgMS4yMjItMS4wODMgMS42OTQtMS43NWE3LjY0NCA3LjY0NCAwIDAgMS0xLjk3Mi41MjhjLjcyMi0uNDE3IDEuMjIyLTEuMDgzIDEuNDcyLTEuODg5YTcuMTQ2IDcuMTQ2IDAgMCAxLTIuMTM5LjgzM0EzLjM1NSAzLjM1NSAwIDAgMCAxNS44OSA2QzE0IDYgMTIuNSA3LjUyOCAxMi41IDkuNDE3YzAgLjI1LjAyOC41MjcuMDgzLjc3N2E5LjcgOS43IDAgMCAxLTcuMDU1LTMuNTgzIDMuNjkzIDMuNjkzIDAgMCAwLS40NDUgMS43MjJjMCAxLjE5NS41ODQgMi4yMjMgMS41IDIuODM0YTMuMTQgMy4xNCAwIDAgMS0xLjUyNy0uNDE3di4wMjhhMy40MjkgMy40MjkgMCAwIDAgMi43MjIgMy4zNiAzLjEyMSAzLjEyMSAwIDAgMS0uODkuMTEyIDQuNTYgNC41NiAwIDAgMS0uNjM4LS4wNTZjLjQxNyAxLjM2MiAxLjY5NCAyLjI3OCAzLjE2NyAyLjMwNi0xLjE2Ny45MTctMi42MTEgMS41NTYtNC4yMjMgMS41NTYtLjI3NyAwLS41NTUtLjAyOC0uODA1LS4wNTYgMS41Ljk3MiAzLjMwNSAxLjUgNS4yMjIgMS41IDYuMjc4IDAgOS42OTUtNS4xOTQgOS42OTUtOS42OTRWOS4zNnoiIGZpbGw9IiNCNkQzRTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "bV3S":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 126 138\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Simple-Text\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-710.000000, -424.000000)\"><g id=\"Group-4\" transform=\"translate(710.000000, 424.000000)\"><path d=\"M2,25 L124,25 C125.104569,25 126,25.8954305 126,27 L126,136 C126,137.104569 125.104569,138 124,138 L2,138 C0.8954305,138 1.3527075e-16,137.104569 0,136 L0,27 C-1.3527075e-16,25.8954305 0.8954305,25 2,25 Z\" id=\"Rectangle-7\" fill=\"#FFFFFF\"></path><path d=\"M2,26 C1.44771525,26 1,26.4477153 1,27 L1,136 C1,136.552285 1.44771525,137 2,137 L124,137 C124.552285,137 125,136.552285 125,136 L125,27 C125,26.4477153 124.552285,26 124,26 L2,26 Z M2,25 L124,25 C125.104569,25 126,25.8954305 126,27 L126,136 C126,137.104569 125.104569,138 124,138 L2,138 C0.8954305,138 0,137.104569 0,136 L0,27 C0,25.8954305 0.8954305,25 2,25 Z\" id=\"Rectangle-7\" fill=\"#B4D2E2\" fill-rule=\"nonzero\"></path><path d=\"M8,44 L51,44 L51,48 L8,48 L8,44 Z M8,115 L34,115 L34,119 L8,119 L8,115 Z M8,60 L114,60 L114,64 L8,64 L8,60 Z M8,70 L105,70 L105,74 L8,74 L8,70 Z M8,80 L114,80 L114,84 L8,84 L8,80 Z M8,90 L105,90 L105,94 L8,94 L8,90 Z M8,100 L114,100 L114,104 L8,104 L8,100 Z\" id=\"Combined-Shape\" fill=\"#B9D4E2\"></path><rect id=\"Rectangle-8\" fill=\"#B9D4E2\" x=\"47\" y=\"0\" width=\"34\" height=\"16\"></rect></g></g></svg>"

/***/ }),

/***/ "bWf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export currentSelectedMessageCount */
/* unused harmony export attachmentIdsForConversation */
/* unused harmony export firstMessagesForConversationId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makeConversationMessages; });
/* unused harmony export paginationHasMoreMessages */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getNextPageId; });
/* unused harmony export firstChatMessage */
/* unused harmony export startInteractionMessage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firstEndUserMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return lastEndUserMessage; });
/* unused harmony export readReceipts */
/* unused harmony export makeLastMessageIdReadByEndUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return makeLatestEditMessageSelector; });
/* unused harmony export makeFirstMessageIdUnreadByAgent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isReadByCurrentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstMessagesLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return firstMessagesLoaded; });
/* unused harmony export firstMessagesFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return firstPaginatedListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return nextListPendingForConversation; });
/* unused harmony export isUnableToConnect */
/* unused harmony export isAwaitingReconnect */
/* unused harmony export timeUntilReconnect */
/* unused harmony export latestPreviewableMessageFromAuthorByConversationId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_selectors__ = __webpack_require__("P/TS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_UserTypes__ = __webpack_require__("p1Ml");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__("RuZ+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("x/uU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__("b3Ti");











var root = function root(state) {
  return state.get('messages');
};
var paginatedStatus = function paginatedStatus(state) {
  return root(state).get('paginatedStatus');
};
var firstMessagesStatus = function firstMessagesStatus(state) {
  return root(state).get('firstMessagesStatus');
};

var getMessagesByConversationId = function getMessagesByConversationId(state) {
  return root(state).getIn(['paginatedConversationMessages', 'messagesByConversationId']);
};

var getMessages = function getMessages(state, props) {
  return getMessagesByConversationId(state).get(props.conversationId, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
};

var currentSelectedMessageCount = function currentSelectedMessageCount(state) {
  return root(state).get('messageToDisplay');
};
function extractPreMessages(message) {
  if (!message.hasIn(['attributes', 'preMessages'])) {
    return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(message);
  }

  return message.getIn(['attributes', 'preMessages']).map(function (preMessage, index) {
    var widgetGuid = message.getIn(['attributes', 'widgetGuid']) + '-' + index;
    return message.withMutations(function (_message) {
      return _message.set('id', widgetGuid).set('attributes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ widgetGuid: widgetGuid })).set('body', preMessage.get('body')).set('sender', preMessage.get('sender')).set('authorId', preMessage.getIn(['sender', 'id'])).set('authorType', 'USER').set('context', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).set('attachments', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).set('isPreMessage', true);
    });
  }).push(message);
}
var attachmentIdsForConversation = function attachmentIdsForConversation(conversationId) {
  return function (state) {
    return getMessages(state, { conversationId: conversationId }).flatMap(function (m) {
      return m.attachments;
    });
  };
};

var firstMessagesForConversationId = function firstMessagesForConversationId(state, props) {
  return root(state).getIn(['paginatedConversationMessages', 'firstMessagesById', props.conversationId], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var editMessagesById = function editMessagesById(state, props) {
  return root(state).getIn(['paginatedConversationMessages', 'editMessagesById', props.conversationId], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var makeConversationMessages = function makeConversationMessages() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getMessages], function (messages) {
    return messages.filterNot(function (message) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["a" /* isBackendGenerated */])(message) || Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["c" /* isFirstBotInteractionMessage */])(message) || Object(__WEBPACK_IMPORTED_MODULE_7__helpers__["b" /* isEmptyGoalMessage */])(message);
    }).flatMap(extractPreMessages);
  });
};

var paginationById = function paginationById(state) {
  return root(state).getIn(['paginatedConversationMessages', 'paginationById']);
};

var paginationHasMoreMessages = function paginationHasMoreMessages(state, props) {
  return paginationById(state).getIn([props.conversationId, 'more'], false);
};
var getNextPageId = function getNextPageId(state, props) {
  return paginationById(state).getIn([props.conversationId, 'next'], null);
};

var firstChatMessage = function firstChatMessage() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConversationMessages();
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(messages, function (messages) {
    return messages.filter(function (message) {
      return message.type === 'CHAT' && message.isPreMessage !== true;
    }).first();
  });
};

var startInteractionMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([firstMessagesForConversationId], function (firstMessagesForConversationId) {
  return firstMessagesForConversationId.filter(function (message) {
    return message.get('attributes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).has('isFromConversationalLandingPage');
  }).first();
});

var firstEndUserMessage = function firstEndUserMessage() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([firstMessagesForConversationId], function (firstMessagesForConversationId) {
    return firstMessagesForConversationId.filter(function (message) {
      return ['END_USER', 'LEAD'].includes(message.authorType) && message.type == "CHAT";
    }).first();
  });
};

var lastEndUserMessage = function lastEndUserMessage() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConversationMessages();
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(messages, function (messages) {
    return messages.filter(function (message) {
      return ['END_USER', 'LEAD'].includes(message.authorType) && message.type == "CHAT";
    }).last();
  });
};

var readReceipts = function readReceipts(state) {
  return root(state).get('readReceipts', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var makeLastMessageIdReadByEndUser = function makeLastMessageIdReadByEndUser() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConversationMessages();
  var endUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_selectors__["e" /* makeEndUserForConversationId */])();
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(messages, endUser, readReceipts, function (messages, endUser, receipts) {
    var lastMessageUnreadByEndUser = endUser && messages.findLast(function (message) {
      return message.type === 'CHAT' && message.authorType === __WEBPACK_IMPORTED_MODULE_6_utils_UserTypes__["b" /* UserTypes */].USER && message.contentType !== 'PRIVATE_NOTE' && receipts.getIn([message.id, endUser.type, endUser.id]) === __WEBPACK_IMPORTED_MODULE_8__constants__["y" /* MessageStatus */].Read;
    });

    return lastMessageUnreadByEndUser && lastMessageUnreadByEndUser.id;
  });
};

var makeLatestEditMessageSelector = function makeLatestEditMessageSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([editMessagesById, function (state, props) {
    return props;
  }], function (conversationMessagesForId, props) {
    return conversationMessagesForId && conversationMessagesForId.sortBy(function (message) {
      return message.createdAt;
    }).findLast(function (message) {
      return message.get('type') === 'EDIT' && message.get('attributes') && message.get('attributes').get('editedMessageId') === props.messageId;
    });
  });
};

var makeFirstMessageIdUnreadByAgent = function makeFirstMessageIdUnreadByAgent() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConversationMessages();
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(messages, __WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"], readReceipts, function (messages, currentUser, receipts) {
    var index = currentUser && messages.findLastIndex(function (message) {
      return message.type === 'CHAT' && receipts.getIn([message.id, __WEBPACK_IMPORTED_MODULE_6_utils_UserTypes__["b" /* UserTypes */].USER, currentUser.id]) === __WEBPACK_IMPORTED_MODULE_8__constants__["y" /* MessageStatus */].Read;
    });

    var firstUnreadMessage = messages.slice(index + 1).find(function (message) {
      return message.type === 'CHAT';
    });

    if (index === -1 || !firstUnreadMessage) {
      return null;
    }

    return firstUnreadMessage.id;
  });
};

var isReadByCurrentUser = function isReadByCurrentUser(messageId) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"], readReceipts, function (currentUser, receipts) {
    return receipts.getIn([messageId, __WEBPACK_IMPORTED_MODULE_6_utils_UserTypes__["b" /* UserTypes */].USER, currentUser.id]) === __WEBPACK_IMPORTED_MODULE_8__constants__["y" /* MessageStatus */].Read;
  });
};

var firstMessagesLoading = function firstMessagesLoading(state, props) {
  return firstMessagesStatus(state).get(props.conversationId) === __WEBPACK_IMPORTED_MODULE_9__actions__["g" /* fetchFirstMessagesPending */].toString();
};

var firstMessagesLoaded = function firstMessagesLoaded(state, props) {
  return firstMessagesStatus(state).get(props.conversationId) === __WEBPACK_IMPORTED_MODULE_9__actions__["u" /* receiveFirstMessages */].toString();
};

var firstMessagesFailed = function firstMessagesFailed(state, props) {
  return firstMessagesStatus(state).get(props.conversationId) === __WEBPACK_IMPORTED_MODULE_9__actions__["f" /* fetchFirstMessagesFailed */].toString();
};

var firstPaginatedListLoaded = function firstPaginatedListLoaded(state, props) {
  return paginatedStatus(state).getIn([props.conversationId, 'firstFetch']) === __WEBPACK_IMPORTED_MODULE_9__actions__["y" /* receivePaginatedMessageList */].toString();
};

var nextListPendingForConversation = function nextListPendingForConversation(state, props) {
  return paginatedStatus(state).getIn([props.conversationId, 'paginateFetch']) === __WEBPACK_IMPORTED_MODULE_9__actions__["j" /* fetchNextPaginatedConversationMessagesPending */].toString();
};

var isUnableToConnect = function isUnableToConnect(state) {
  var clusterName = __WEBPACK_IMPORTED_MODULE_5_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  return __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_selectors__["b" /* didAuthenticationFail */](state, { clusterName: clusterName });
};

var isAwaitingReconnect = function isAwaitingReconnect(state) {
  var clusterName = __WEBPACK_IMPORTED_MODULE_5_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  return !!__WEBPACK_IMPORTED_MODULE_4_app_modules_socket_selectors__["a" /* channelsToJoin */](state, { clusterName: clusterName }).count();
};

var timeUntilReconnect = function timeUntilReconnect(state) {
  return __WEBPACK_IMPORTED_MODULE_4_app_modules_socket_selectors__["f" /* getTimeUntilReconnect */](state, {
    clusterName: __WEBPACK_IMPORTED_MODULE_5_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES
  });
};

var latestPreviewableMessageFromAuthorByConversationId = function latestPreviewableMessageFromAuthorByConversationId() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeConversationMessages();
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([messages, function (state, _ref) {
    var authorId = _ref.authorId;
    return authorId;
  }], function (messages, authorId) {
    return messages.filter(function (message) {
      return __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* TYPES_TO_PREVIEW */].includes(message.type);
    }).findLast(function (message) {
      return message.authorId === authorId;
    });
  });
};

/***/ }),

/***/ "bYlK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bYpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("g+Sm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var DISMISS_ICON = __webpack_require__("z1XD");

function getIconUrl(iconStyle, iconType) {
  switch (iconType) {
    case __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].dismiss:
      return DISMISS_ICON;
    default:
      return __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][iconStyle][iconType];
  }
}

var Widget = function Widget(_ref) {
  var _ref$iconStyle = _ref.iconStyle,
      iconStyle = _ref$iconStyle === undefined ? __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID1 : _ref$iconStyle,
      _ref$iconType = _ref.iconType,
      iconType = _ref$iconType === undefined ? __WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */].chatSrc : _ref$iconType,
      iconUrl = _ref.iconUrl,
      avatarUrl = _ref.avatarUrl,
      backgroundColor = _ref.backgroundColor,
      foregroundColor = _ref.foregroundColor,
      unreadCount = _ref.unreadCount;

  var url = avatarUrl || iconUrl;

  if (url) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Widget,
        style: {
          backgroundImage: 'url(' + url + ')',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundColor: '#' + backgroundColor
        } },
      unreadCount ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Widget__Count },
        unreadCount
      ) : undefined
    );
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Widget,
      style: { backgroundColor: '#' + backgroundColor, color: '#' + foregroundColor }
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a['icon-type-' + iconType], iconType)),
      src: getIconUrl(iconStyle, iconType)
    }),
    unreadCount ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Widget__Count },
      unreadCount
    ) : undefined
  );
};
Widget.propTypes = {
  backgroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  foregroundColor: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  iconStyle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */])),
  iconType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(Object.keys(__WEBPACK_IMPORTED_MODULE_4_components_Customize_Styling_IconPicker_Constants__["c" /* IconTypes */])),
  iconUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  avatarUrl: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};

/* harmony default export */ __webpack_exports__["a"] = (Widget);

/***/ }),

/***/ "bZrC":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 33 14\" xmlns=\"http://www.w3.org/2000/svg\"><g stroke=\"#9A9A9A\" stroke-width=\"3\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M16.5 7S30.888-4.184 30.888 7 16.5 7 16.5 7zM16.5 7S2.112-4.184 2.112 7 16.5 7 16.5 7z\"></path></g></svg>"

/***/ }),

/***/ "baVF":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"flow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"admin-copy-2\" transform=\"translate(-126.000000, -851.000000)\"><g id=\"Oval-Copy\" fill=\"#13CB6E\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"133\" cy=\"858\" r=\"6\"></circle></g></g></g></svg>"

/***/ }),

/***/ "bag8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("b4nd");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]);

/***/ }),

/***/ "bbMV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_customer_CompanyCard_ReadOnlyRow__ = __webpack_require__("OUXB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_styles_colors_json__);



function Header(_ref) {
  var label = _ref.label,
      more = _ref.more,
      icon = _ref.icon;

  return React.createElement(
    'div',
    {
      style: {
        borderBottom: '1px solid ' + __WEBPACK_IMPORTED_MODULE_1_styles_colors_json___default.a['color-navy-light'],
        padding: '10px 20px'
      },
      className: 'flex-space-between'
    },
    React.createElement(
      'div',
      { className: 'flex' },
      icon,
      React.createElement(
        'span',
        __WEBPACK_IMPORTED_MODULE_0_components_customer_CompanyCard_ReadOnlyRow__["a" /* LabelProps */],
        label
      )
    ),
    more
  );
}

/* harmony default export */ __webpack_exports__["a"] = (Header);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "bcin":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bdc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__ = __webpack_require__("lsaV");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ArticleLink = "http://developer.helpscout.net/docs-api/";

var HelpScout = function (_Component) {
  _inherits(HelpScout, _Component);

  function HelpScout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HelpScout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpScout.__proto__ || Object.getPrototypeOf(HelpScout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      key: ''
    }, _this.getConnectionPayload = function () {
      var key = _this.state.key;

      return { key: key };
    }, _this.renderInput = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
          placeholder: 'Enter your Help Scout Docs API Key',
          label: 'HELPSCOUT DOCS API KEY',
          valueLink: {
            requestChange: function requestChange(input) {
              _this.setState({ key: input });
            },
            value: _this.state.key
          },
          isValid: !!_this.state.key && _this.state.key !== '' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dsg-Body color-gray-dark' },
          'Need help finding your Docs API key? Here\u2019s',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: ArticleLink },
            ' an article from Help Scout'
          ),
          '.'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HelpScout, [{
    key: 'render',
    value: function render() {
      var isConnected = this.props.isConnected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Use Drift\u2019s intelligent messaging to answer your visitors questions using your Help Scout knowledge base.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Just plugin your Docs API key and connect.'
        ),
        isConnected ? null : this.renderInput(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_IntegrationConnector__["a" /* default */], {
          integrationId: 'helpScout',
          isConnected: isConnected,
          connectionPayload: this.getConnectionPayload() })
      );
    }
  }]);

  return HelpScout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HelpScout);

/***/ }),

/***/ "bi1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("H6An");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);




var SettingsPageHeader = function SettingsPageHeader(_ref) {
  var title = _ref.title;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["H3"],
    { className: 'settings-page-header' },
    title
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SettingsPageHeader);

/***/ }),

/***/ "bqmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return byId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lastCreatedTargetId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return lastUpdatedTargetId; });
/* unused harmony export targets */
/* unused harmony export targetsLoaded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wasTargetCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return wasTargetUpdated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("DTGo");



var root = function root(state) {
  return state.get('targeting');
};
var byId = function byId(state) {
  return root(state).get('targetsById', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var lastCreatedTargetId = function lastCreatedTargetId(state) {
  return root(state).get('lastCreatedTargetId', -1);
};
var lastUpdatedTargetId = function lastUpdatedTargetId(state) {
  return root(state).get('lastUpdatedTargetId', -1);
};

var targets = function targets(id) {
  return function (state) {
    return byId(state).get(id);
  };
};
var targetsLoaded = function targetsLoaded(state) {
  return [__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_TARGETS_SUCCESS */], __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* UPDATE_TARGET_SUCCESS */], __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_TARGET_SUCCESS */]].includes(root(state).get('status'));
};

var wasTargetCreated = function wasTargetCreated(state) {
  return [__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_TARGET_SUCCESS */]].includes(root(state).get('status'));
};

var wasTargetUpdated = function wasTargetUpdated(state) {
  return [__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* UPDATE_TARGET_SUCCESS */]].includes(root(state).get('status'));
};

/***/ }),

/***/ "btml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__ = __webpack_require__("qXGn");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var SavedReplyStore = Marty.createStore({
  id: 'SavedReplyStore',

  getInitialState: function getInitialState() {
    return {
      // assuming we only see one org's saved replies in the app
      replyById: {}
    };
  },


  handlers: {
    fetchReplyListDone: __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_LIST_FETCH_DONE,
    fetchReplyDone: __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].REPLY_FETCH_DONE,
    updateReplyDone: __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].UPDATE_REPLY_DONE,
    setReplyToPopulate: __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].SET_REPLY_TO_POPULATE
  },

  fetchReplyList: function fetchReplyList() {
    return this.fetch({
      id: 'fetchReplyList',
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchReplyList')) {
          return this.state.replyById;
        }
      },
      remotely: function remotely() {
        return this.app.queries.SavedReplyQueries.fetchReplies();
      }
    });
  },
  fetchReplyListSorted: function fetchReplyListSorted() {
    return this.fetch({
      id: 'fetchReplyListSorted',
      dependsOn: this.fetchReplyList(),
      locally: function locally() {
        return _.chain(this.state.replyById).values().sortBy('updatedAt').reverse().value();
      }
    });
  },
  fetchReplyListDone: function fetchReplyListDone(replies) {
    var replyById = _.cloneDeep(this.state.replyById);
    replyById = _.assign(replyById, _.keyBy(replies, 'id'));
    return this.setState({ replyById: replyById });
  },
  fetchReply: function fetchReply(replyId) {
    return this.fetch({
      id: 'fetchReply' + replyId,
      locally: function locally() {
        return this.state.replyById[replyId];
      },
      remotely: function remotely() {
        return this.app.queries.SavedReplyQueries.fetchReply(replyId);
      }
    });
  },
  fetchReplyDone: function fetchReplyDone(reply) {
    return this.setReply(reply);
  },
  updateReplyDone: function updateReplyDone(reply) {
    return this.setReply(reply);
  },
  setReply: function setReply(reply) {
    var replyById = _.cloneDeep(this.state.replyById);
    if (reply.status !== 'ARCHIVED') {
      replyById[reply.id] = reply;
      // remove ARCHIVED replies
    } else {
      delete replyById[reply.id];
    }

    return this.setState({ replyById: replyById });
  },
  setReplyToPopulate: function setReplyToPopulate(replyId) {
    return this.setState({ replyIdToPopulate: replyId });
  },
  getReplyToPopulate: function getReplyToPopulate() {
    return this.state.replyById[this.state.replyIdToPopulate];
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SavedReplyStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "bwU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ProfileDetailsPreview":"ProfileDetailsPreview---Vac4Z","SidebarContainer":"SidebarContainer---1QJYN","Sidebar":"Sidebar---1IXtw","SidebarPreview":"SidebarPreview---1U08_","ArrowText":"ArrowText---1A9VX","PreviewSlackChat":"PreviewSlackChat---1-FpC","PreviewSlackLiveChat":"PreviewSlackLiveChat---2qJce","PreviewLaptop":"PreviewLaptop---2bNvD"};

/***/ }),

/***/ "bwbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("iext");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("j4fR");






var fetchAccountAttribs = function fetchAccountAttribs(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchAccountAttribs */].toString()).pluck('payload').switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].fromPromise(Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* fetchAccountAttribs */])().then(function (res) {
      return res.json();
    })).map(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchAccountAttribsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchAccountAttribsPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchAccountAttribsFailed */](err));
    });
  });
};

var fetchAccountSegments = function fetchAccountSegments(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchAccountSegments */].toString()).pluck('payload').mergeMap(function (_ref) {
    var _ref$index = _ref.index,
        index = _ref$index === undefined ? 0 : _ref$index,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 1000 : _ref$size;

    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].fromPromise(Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* fetchAccountSegments */])(index, size).then(function (res) {
      return res.json();
    })).map(__WEBPACK_IMPORTED_MODULE_3__actions__["j" /* fetchAccountSegmentsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["i" /* fetchAccountSegmentsPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchAccountSegmentsFailed */](err));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetchAccountAttribs, fetchAccountSegments);

/***/ }),

/***/ "bxiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (['$1 - $1M', '$1M - $5M', '$5M - $10M', '$10M - $25M', '$25M - $50M', '$50M - $100M', '$100M - $250M', '$250M - $500M', '$500M - $1B', '$1B - $2.5B', '$2.5B - $5B', 'Over $5B']);

/***/ }),

/***/ "c1G0":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMSAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMS4xODJjLS40MDcuMi0uODQuMzQyLTEuMjk5LjQuNDcxLS4zMTQuODI4LS44MTMuOTkzLTEuMzk3QTQuMzIzIDQuMzIzIDAgMCAxIDkuMjcuNzk4QzguODQ5LjMxMyA4LjI2MyAwIDcuNjEzIDAgNi4zNjYgMCA1LjM2IDEuMTI1IDUuMzYgMi41MjFjMCAuMi4wMTMuNC4wNS41ODRDMy41NCAyLjk5MSAxLjg4NSAyLjAzNy43NjUuNTEzYy0uMTkxLjM3LS4zMDYuNzU1LS4zMDYgMS4yMjUgMCAuODY5LjM5NSAxLjYzOCAxLjAwNiAyLjA5NGEyLjExMyAyLjExMyAwIDAgMS0xLjAxOC0uMzEzdi4wMjhjMCAxLjIyNS43NzYgMi4yNSAxLjgwNyAyLjQ3OWEyLjEwMyAyLjEwMyAwIDAgMS0xLjAxOC4wNDJjLjI4Ljk5OCAxLjEyIDEuNzM4IDIuMSAxLjc1My0uNzYzLjY4My0xLjc0NCAxLjE5Ni0yLjggMS4xOTYtLjE3OSAwLS4zNTctLjAxNC0uNTM1LS4wNDNDLjk5MyA5LjY4NyAyLjE5IDEwIDMuNDYzIDEwYzQuMTUgMCA2LjQxNy0zLjg0NiA2LjQxNy03LjE4di0uMzI3QTUuMDI2IDUuMDI2IDAgMCAwIDExIDEuMTgzeiIgZmlsbD0iIzBBNUJGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "c4Jp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CAMPAIGN_ICON_SRC = __webpack_require__("ArDQ");
var ActionMap = {
  MESSAGE_CTA_CLICKED: 'clicked on CTA in',
  MESSAGE_SEEN: 'opened',
  MESSAGE_SENT: 'received'
};

var MessageCampaignEvent = function (_Component) {
  _inherits(MessageCampaignEvent, _Component);

  function MessageCampaignEvent() {
    _classCallCheck(this, MessageCampaignEvent);

    return _possibleConstructorReturn(this, (MessageCampaignEvent.__proto__ || Object.getPrototypeOf(MessageCampaignEvent)).apply(this, arguments));
  }

  _createClass(MessageCampaignEvent, [{
    key: 'render',
    value: function render() {
      var campaign = this.props.event.body.campaign;

      var action = ActionMap[this.props.event.eventType];
      var eventProps = _extends({
        iconSrc: CAMPAIGN_ICON_SRC,
        eventLabel: action + ' campaign'
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
        eventProps,
        campaign && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/campaigns/' + campaign.id },
          campaign.name
        )
      );
    }
  }]);

  return MessageCampaignEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MessageCampaignEvent);

/***/ }),

/***/ "c6Bo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c9tv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subscription__ = __webpack_require__("B00U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("qK29");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("AQ+G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("8dTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_UserTypes__ = __webpack_require__("p1Ml");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var TYPING_TIMEOUT = 5000;
var TYPING_STARTED_EVENT = 'typing:started';
var TYPING_FINISHED_EVENT = 'typing:finished';

var joinUserChannelEpic = function joinUserChannelEpic(action$, _ref) {
  var getState = _ref.getState;

  var activeConversationsSelector = Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_conversation_selectors__["m" /* makeActiveConversations */])();

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref2) {
    var channel = _ref2.channel,
        leaveChannel$ = _ref2.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function (observer) {
      // handle incoming typing indicators
      var handleTypingEvent = function handleTypingEvent(payload, actionCreator) {
        var userId = payload.userId,
            userType = payload.userType,
            conversationId = payload.conversationId;

        // don't re-dispatch own typing indicators

        var user = Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentUser"])(getState());
        if (userType === __WEBPACK_IMPORTED_MODULE_9_utils_UserTypes__["b" /* UserTypes */].USER && userId === user.id) {
          return;
        }

        var existingConversationList = activeConversationsSelector(getState());

        // dont dispatch typing indicators for conversations not in the current list
        if (!existingConversationList.has(conversationId)) {
          return;
        }

        observer.next(actionCreator(payload));
      };

      channel.on(TYPING_STARTED_EVENT, function (payload) {
        handleTypingEvent(payload, __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* typing */]);
      });

      channel.on(TYPING_FINISHED_EVENT, function (payload) {
        handleTypingEvent(payload, __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* typingFinished */]);
      });
    }).takeUntil(leaveChannel$);
  });
};

var joinPrivateOrgChannelEpic = function joinPrivateOrgChannelEpic(action$, _ref3) {
  var getState = _ref3.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["m" /* JOIN_CHANNEL_SUCCESS */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_7_app_modules_socket_constants__["u" /* SocketChannel */].USER;
  }).switchMap(function (_ref4) {
    var channel = _ref4.channel,
        leaveChannel$ = _ref4.leaveChannel$;

    var sendTypingIndicators$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* USER_TYPING */], __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* USER_TYPING_FINISHED */]).map(function (_ref5) {
      var type = _ref5.type,
          payload = _ref5.payload;

      var user = Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentUser"])(getState());
      return {
        event: type === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* USER_TYPING */] ? TYPING_STARTED_EVENT : TYPING_FINISHED_EVENT,
        data: _extends({
          userId: user.id,
          userType: __WEBPACK_IMPORTED_MODULE_9_utils_UserTypes__["b" /* UserTypes */].USER,
          participants: Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["a" /* getParticipants */])(getState())
        }, payload)
      };
    });

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].create(function () {
      var subscription = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Subscription__["Subscription"]();

      // dispatch outgoing typing indicators to user channel
      subscription.add(sendTypingIndicators$.subscribe({
        next: function next(_ref6) {
          var event = _ref6.event,
              data = _ref6.data;

          channel.push(event, data);
        }
      }));

      return function () {
        subscription.unsubscribe();
      };
    }).takeUntil(leaveChannel$);
  });
};

var typingEpic = function typingEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* TYPING */]).pluck('payload').mergeMap(function (_ref7) {
    var userId = _ref7.userId,
        userType = _ref7.userType,
        conversationId = _ref7.conversationId;

    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* TYPING */], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* TYPING_FINISHED */]).filter(function (action) {
      return action.payload.userId === userId && action.payload.userType === userType && action.payload.conversationId === conversationId;
    }), __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].timer(TYPING_TIMEOUT)).first().filter(function (action) {
      return !action;
    }).map(function () {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["b" /* typingFinished */]({
        userId: userId,
        userType: userType,
        conversationId: conversationId
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(joinUserChannelEpic, joinPrivateOrgChannelEpic, typingEpic));

/***/ }),

/***/ "cATl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(fetch) {/* unused harmony export Team */
/* unused harmony export parseTeam */
/* harmony export (immutable) */ __webpack_exports__["b"] = parseTeamList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var Team = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  inboxId: undefined,
  main: false,
  members: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  name: undefined,
  orgId: undefined,
  slackChannel: null,
  status: undefined,
  updatedAt: undefined
});

function parseTeam(data) {
  var members = data.members,
      rest = _objectWithoutProperties(data, ['members']);

  return Team(_extends({
    members: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(members)
  }, rest));
}

function parseTeamList(data) {
  return data.reduce(function (result, team) {
    return result.set(team.id, parseTeam(team));
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
}

var TeamsAPI = {
  fetchTeamsForOrg: function fetchTeamsForOrg(orgId) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/teams', {
      method: 'GET',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    }).then(function (res) {
      if (res.ok) {
        return res.json().then(parseTeamList);
      } else {
        throw new Error('Could not fetch teams for org ' + orgId);
      }
    });
  },
  updateTeam: function updateTeam(teamId, properties) {
    return fetch(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/teams/' + teamId, {
      method: 'PATCH',
      body: JSON.stringify(properties),
      headers: new Headers(_extends({}, __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["a" /* PostJsonHeaders */], Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()))
    }).then(function (res) {
      if (res.ok) {
        return res.json().then(parseTeam);
      } else {
        throw new Error('Could not update team ' + teamId);
      }
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TeamsAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("LC9V")))

/***/ }),

/***/ "cCgd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeaderBackButton":"HeaderBackButton---30BAe"};

/***/ }),

/***/ "cE9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__ = __webpack_require__("8wQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keyBy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OperatorOptions = [{ value: "lessThan", text: "is less than" }, { value: "greaterThan", text: "is greater than" }];

var OperatorByValue = __WEBPACK_IMPORTED_MODULE_3_lodash_keyBy___default()(OperatorOptions, 'value');

var TimeInputs = function (_Component) {
  _inherits(TimeInputs, _Component);

  function TimeInputs() {
    _classCallCheck(this, TimeInputs);

    return _possibleConstructorReturn(this, (TimeInputs.__proto__ || Object.getPrototypeOf(TimeInputs)).apply(this, arguments));
  }

  _createClass(TimeInputs, [{
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'onNumberChange',
    value: function onNumberChange(value) {
      this.props.conditionUpdater('value', parseInt(value));
    }
  }, {
    key: 'renderOperatorSelection',
    value: function renderOperatorSelection() {
      var operator = this.props.conditionValue.get('operator');
      var selectedValue = OperatorByValue[operator];
      var text = selectedValue.text,
          value = selectedValue.value;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_SimpleSelect__["a" /* default */], {
        onSelection: this.onOperatorSelect.bind(this),
        options: OperatorOptions,
        selectedValue: text || value
      });
    }
  }, {
    key: 'renderNumericInput',
    value: function renderNumericInput() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Input___default.a, {
        type: 'number',
        min: 0,
        valueLink: {
          requestChange: this.onNumberChange.bind(this),
          value: this.props.conditionValue.get('value')
        },
        isValid: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'flex-space-around flex-1' },
        this.renderOperatorSelection(),
        this.renderNumericInput(),
        React.createElement('div', { style: { width: 16 } })
      );
    }
  }]);

  return TimeInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TimeInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "cFHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_check_in_box_svg__ = __webpack_require__("5XQI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_check_in_box_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_check_in_box_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_infinite_svg__ = __webpack_require__("oG2j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_infinite_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_infinite_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component__ = __webpack_require__("DVR/");





















var SegmentTypeToLabel = {
  ID_LIST: 'Static segment',
  QUERY: 'Dynamic segment'
};
var SegmentTypeToIcon = {
  ID_LIST: __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_svg_check_in_box_svg___default.a,
  QUERY: __WEBPACK_IMPORTED_MODULE_14__svg_inline_removeTags_true_images_svg_infinite_svg___default.a
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    excludedUserListIds: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["A" /* excludedUserListIds */](state),
    segments: __WEBPACK_IMPORTED_MODULE_10_app_modules_segment_selectors__["e" /* segments */](state),
    orgUsersById: __WEBPACK_IMPORTED_MODULE_11_app_modules_user_selectors__["orgUsersById"](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      setExcludedUserListIds: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_171" /* setExcludedUserListIds */],
      hideSegmentSelect: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_88" /* hideSegmentSelect */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onChange: function onChange(props) {
    return function (selectedSegments) {
      var selectedSegmentIds = Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])(selectedSegments).map(function (selection) {
        return selection.value;
      });
      props.actions.setExcludedUserListIds(selectedSegmentIds);
    };
  }
}), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (props) {
  return {
    options: (props.extraOptions || Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])()).concat(props.segments).map(function (segment) {
      var name = segment.name,
          id = segment.id,
          authorId = segment.authorId,
          type = segment.type;

      var author = props.orgUsersById.get(authorId);
      return {
        value: id,
        name: name,
        label: React.createElement(
          'div',
          { className: 'flex' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('icon segment-option-icon', 'icon-type-' + type.toLowerCase()),
            src: SegmentTypeToIcon[type]
          }),
          React.createElement(
            'div',
            { className: 'segment-option-meta' },
            React.createElement(
              'div',
              { className: 'segment-option-name' },
              name
            ),
            React.createElement(
              'div',
              { className: 'segment-option-description' },
              SegmentTypeToLabel[type],
              ' ',
              !!author ? 'created by ' + (author.name || author.email) : ''
            )
          )
        )
      };
    }).toArray(),
    value: props.value || props.excludedUserListIds.toJS()
  };
}))(__WEBPACK_IMPORTED_MODULE_15__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "cH6z":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M3.36 17H1.992V.992H3.36V17zm13.008 0H15.12V9.152c0-2.232-1.128-2.904-2.808-2.904-1.488 0-3.024.936-3.768 1.992V17H7.296V5.408h1.248V7.16c.84-1.008 2.496-2.04 4.176-2.04 2.352 0 3.648 1.152 3.648 3.768V17zm7.344.288c-1.872 0-3.312-.552-4.464-1.848l.744-.912c.744.936 2.112 1.704 3.744 1.704 1.944 0 3.096-1.008 3.096-2.352 0-3.168-7.32-1.368-7.32-5.544 0-1.776 1.512-3.216 4.128-3.216 1.992 0 3.312.768 4.152 1.704l-.696.888c-.672-.912-1.92-1.536-3.456-1.536-1.8 0-2.88.912-2.88 2.112 0 2.904 7.296 1.128 7.296 5.592 0 1.872-1.44 3.408-4.344 3.408zm12.696 0c-3.384 0-5.784-2.52-5.784-6.096 0-3.36 2.352-6.072 5.568-6.072 3.528 0 5.472 2.784 5.472 6.144v.336h-9.696c.12 2.52 1.8 4.608 4.536 4.608 1.464 0 2.808-.552 3.792-1.608l.648.816c-1.152 1.2-2.616 1.872-4.536 1.872zm3.984-6.672c-.024-1.968-1.32-4.416-4.224-4.416-2.736 0-4.104 2.4-4.2 4.416h8.424zM46.128 17H44.88V5.408h1.248V7.4c.984-1.296 2.304-2.232 3.912-2.232v1.368c-.216-.048-.384-.048-.624-.048-1.176 0-2.76 1.056-3.288 2.064V17zm8.88.288c-1.536 0-2.28-.936-2.28-2.52V6.512h-1.92V5.408h1.92V2.24H54v3.168h2.352v1.104H54v8.064c0 .936.384 1.584 1.2 1.584a1.81 1.81 0 0 0 1.296-.552l.48.96c-.456.432-1.008.72-1.968.72zm9.528 4.248l.216-1.152c.264.12.72.192 1.008.192.768 0 1.296-.312 1.776-1.416l.912-2.064-4.92-11.688h1.392l4.224 10.128L73.32 5.408h1.416l-6 14.136c-.624 1.464-1.608 2.16-2.952 2.16-.408 0-.936-.072-1.248-.168zm17.208-4.248c-3.384 0-5.544-2.712-5.544-6.096s2.16-6.072 5.544-6.072c3.432 0 5.592 2.688 5.592 6.072s-2.16 6.096-5.592 6.096zm0-1.128c2.736 0 4.248-2.376 4.248-4.968 0-2.568-1.512-4.944-4.248-4.944-2.688 0-4.224 2.376-4.224 4.944 0 2.592 1.536 4.968 4.224 4.968zm17.88.84h-1.248v-1.704c-.936 1.056-2.496 1.992-4.176 1.992-2.352 0-3.648-1.104-3.648-3.72v-8.16H91.8v7.872c0 2.256 1.128 2.88 2.808 2.88 1.488 0 3-.888 3.768-1.92V5.408h1.248V17zm5.136 0h-1.248V5.408h1.248V7.4c.984-1.296 2.304-2.232 3.912-2.232v1.368c-.216-.048-.384-.048-.624-.048-1.176 0-2.76 1.056-3.288 2.064V17zm17.544.288c-3.408 0-5.616-2.712-5.616-6.096s2.208-6.072 5.616-6.072c2.016 0 3.168.792 4.104 1.968l-.864.768c-.84-1.152-1.896-1.608-3.168-1.608-2.712 0-4.368 2.16-4.368 4.944s1.656 4.968 4.368 4.968c1.272 0 2.328-.48 3.168-1.632l.864.768c-.936 1.2-2.088 1.992-4.104 1.992zM137.808 17h-1.248v-1.368c-1.032 1.128-2.328 1.656-3.936 1.656-1.992 0-4.056-1.368-4.056-3.864 0-2.52 2.04-3.84 4.056-3.84 1.608 0 2.928.528 3.936 1.656V8.888c0-1.728-1.392-2.664-3.096-2.664-1.464 0-2.592.504-3.648 1.704l-.696-.864c1.2-1.296 2.544-1.944 4.464-1.944 2.352 0 4.224 1.128 4.224 3.72V17zm-4.752-.696c1.392 0 2.688-.528 3.504-1.584v-2.544c-.816-1.08-2.112-1.608-3.504-1.608-1.896 0-3.168 1.224-3.168 2.88 0 1.632 1.272 2.856 3.168 2.856zm9.888.696h-1.248V.992h1.248V17zm9.024.288c-3.384 0-5.784-2.52-5.784-6.096 0-3.36 2.352-6.072 5.568-6.072 3.528 0 5.472 2.784 5.472 6.144v.336h-9.696c.12 2.52 1.8 4.608 4.536 4.608 1.464 0 2.808-.552 3.792-1.608l.648.816c-1.152 1.2-2.616 1.872-4.536 1.872zm3.984-6.672c-.024-1.968-1.32-4.416-4.224-4.416-2.736 0-4.104 2.4-4.2 4.416h8.424zM169.512 17h-1.248V9.152c0-2.232-1.128-2.904-2.808-2.904-1.488 0-3.024.936-3.768 1.992V17h-1.248V5.408h1.248V7.16c.84-1.008 2.496-2.04 4.176-2.04 2.352 0 3.648 1.152 3.648 3.768V17zm13.704 0h-1.272v-1.848c-.816 1.2-2.304 2.136-4.032 2.136-3.072 0-5.16-2.352-5.16-6.072 0-3.672 2.088-6.096 5.16-6.096 1.656 0 3.12.84 4.032 2.16V.992h1.272V17zm-5.088-.84c1.632 0 3.144-.96 3.816-2.064V8.36c-.672-1.128-2.184-2.112-3.816-2.112-2.568 0-4.056 2.16-4.056 4.968s1.488 4.944 4.056 4.944zm17.592.84h-1.248v-1.368c-1.032 1.128-2.328 1.656-3.936 1.656-1.992 0-4.056-1.368-4.056-3.864 0-2.52 2.04-3.84 4.056-3.84 1.608 0 2.928.528 3.936 1.656V8.888c0-1.728-1.392-2.664-3.096-2.664-1.464 0-2.592.504-3.648 1.704l-.696-.864c1.2-1.296 2.544-1.944 4.464-1.944 2.352 0 4.224 1.128 4.224 3.72V17zm-4.752-.696c1.392 0 2.688-.528 3.504-1.584v-2.544c-.816-1.08-2.112-1.608-3.504-1.608-1.896 0-3.168 1.224-3.168 2.88 0 1.632 1.272 2.856 3.168 2.856zm9.888.696h-1.248V5.408h1.248V7.4c.984-1.296 2.304-2.232 3.912-2.232v1.368c-.216-.048-.384-.048-.624-.048-1.176 0-2.76 1.056-3.288 2.064V17zm23.712 0h-1.2l-3.24-9.912L216.864 17h-1.2l-3.768-11.592h1.344l3.072 9.84 3.264-9.84h1.08l3.264 9.84 3.072-9.84h1.344L224.568 17zm6.744-13.416a.979.979 0 0 1-.96-.96c0-.528.456-.936.96-.936.528 0 .96.408.96.936s-.432.96-.96.96zM231.936 17h-1.248V5.408h1.248V17zm6.408.288c-1.536 0-2.28-.936-2.28-2.52V6.512h-1.92V5.408h1.92V2.24h1.272v3.168h2.352v1.104h-2.352v8.064c0 .936.384 1.584 1.2 1.584a1.81 1.81 0 0 0 1.296-.552l.48.96c-.456.432-1.008.72-1.968.72zM251.496 17h-1.248V9.104c0-2.232-1.128-2.856-2.808-2.856-1.488 0-3.024.936-3.768 1.992V17h-1.248V.992h1.248V7.16c.84-1.008 2.496-2.04 4.176-2.04 2.352 0 3.648 1.104 3.648 3.72V17z\" fill=\"#000\"></path><g transform=\"translate(0 28)\"><rect fill=\"#222\" width=\"262\" height=\"40\"></rect><path d=\"M15.785 30H6.074V6.948h9.676c7.258 0 12.477 4.355 12.477 11.509S23.008 30 15.785 30zm-.035-5.184c4.044 0 6.394-2.938 6.394-6.359 0-3.56-2.143-6.325-6.359-6.325h-3.767v12.684h3.732zM36.383 30H31.06V13.308h5.323v2.039c1.106-1.348 3.248-2.489 5.218-2.489v5.115c-.31-.104-.76-.138-1.313-.138-1.382 0-3.214.587-3.905 1.52V30zm10.299-18.179c-1.694 0-3.042-1.382-3.042-3.075a3.024 3.024 0 0 1 3.042-3.042c1.693 0 3.075 1.348 3.075 3.042a3.083 3.083 0 0 1-3.075 3.075zM49.342 30H44.02V13.308h5.323V30zm10.334 0h-5.322V17.904h-2.765v-4.596h2.765v-.38c0-3.975 2.488-6.325 5.979-6.325 1.797 0 3.663.518 4.77 1.555l-1.936 3.318c-.415-.38-.968-.588-1.728-.588-.968 0-1.763.657-1.763 2.04v.38h3.387v4.596h-3.387V30zm11.923.415c-3.387 0-5.218-1.694-5.218-4.908v-7.603h-2.765v-4.596h2.765V8.746h5.322v4.562h3.387v4.596h-3.387v6.117c0 .968.553 1.694 1.452 1.694.587 0 1.175-.208 1.347-.415l1.037 4.009c-.656.622-1.97 1.106-3.94 1.106zM112.864 30h-5.944V14.759L101.114 30h-2.627l-5.84-15.241V30h-5.945V6.948h8.26L99.8 19.667l4.804-12.719h8.26V30zm12.027.415c-5.15 0-9.09-3.353-9.09-8.779 0-4.838 3.63-8.743 8.848-8.743 4.942 0 8.536 3.629 8.536 9.296v1.21h-11.888c.38 1.486 1.762 2.73 4.181 2.73 1.175 0 3.11-.518 4.078-1.417l2.316 3.49c-1.659 1.487-4.424 2.213-6.981 2.213zm3.214-10.645c-.138-1.175-1.002-2.592-3.456-2.592-2.316 0-3.214 1.383-3.421 2.592h6.877zm15.725 10.645c-5.15 0-9.09-3.353-9.09-8.779 0-4.838 3.63-8.743 8.848-8.743 4.942 0 8.536 3.629 8.536 9.296v1.21h-11.888c.38 1.486 1.762 2.73 4.181 2.73 1.175 0 3.11-.518 4.078-1.417l2.316 3.49c-1.659 1.487-4.424 2.213-6.981 2.213zm3.214-10.645c-.138-1.175-1.002-2.592-3.456-2.592-2.316 0-3.214 1.383-3.422 2.592h6.878zm14.031 10.645c-3.387 0-5.218-1.694-5.218-4.908v-7.603h-2.765v-4.596h2.765V8.746h5.322v4.562h3.387v4.596h-3.387v6.117c0 .968.553 1.694 1.451 1.694.588 0 1.175-.208 1.348-.415l1.037 4.009c-.657.622-1.97 1.106-3.94 1.106zm8.778-18.594c-1.693 0-3.04-1.382-3.04-3.075a3.024 3.024 0 0 1 3.04-3.042c1.694 0 3.076 1.348 3.076 3.042a3.083 3.083 0 0 1-3.076 3.075zM172.515 30h-5.323V13.308h5.323V30zm20.494 0h-5.323v-9.642c0-2.04-1.071-2.765-2.73-2.765-1.59 0-2.626.864-3.249 1.624V30h-5.322V13.308h5.322v2.039c1.003-1.175 2.973-2.454 5.807-2.454 3.767 0 5.495 2.212 5.495 5.287V30zm10.817 6.774c-2.869 0-5.253-.726-7.396-2.489l2.316-3.732c1.313 1.382 3.145 1.935 5.08 1.935 1.762 0 4.25-.76 4.25-3.94V27.27c-1.382 1.659-3.04 2.454-4.941 2.454-4.078 0-7.327-2.8-7.327-8.433 0-5.495 3.145-8.398 7.327-8.398 1.866 0 3.594.726 4.942 2.384v-1.97h5.322v15.241c0 6.774-5.426 8.226-9.573 8.226zm1.071-11.75c1.106 0 2.523-.588 3.18-1.487V19.08c-.657-.899-2.074-1.486-3.18-1.486-2.108 0-3.663 1.279-3.663 3.698 0 2.454 1.555 3.732 3.663 3.732zm18.8 5.39c-3.006 0-6.082-1.002-7.844-2.591l2.212-3.802c1.244 1.106 3.905 2.247 5.875 2.247 1.59 0 2.246-.45 2.246-1.176 0-2.073-9.711.07-9.711-6.704 0-2.938 2.557-5.495 7.154-5.495 2.834 0 5.184.898 6.98 2.212l-2.038 3.767c-1.002-.968-2.903-1.832-4.908-1.832-1.244 0-2.073.484-2.073 1.14 0 1.832 9.677-.069 9.677 6.774 0 3.18-2.8 5.46-7.57 5.46z\" fill=\"#FFF\"></path><g transform=\"translate(239 7)\"><polygon fill=\"#F5A623\" points=\"7.24739634 10.6167665 8.19653714 11.9316184 8.63270391 10.6167665\"></polygon><path d=\"M14 10.617a1 1 0 0 1 .791 1.611L5.23 24.611c-.701.908-2.13.113-1.728-.962l3.244-8.661H2a1 1 0 0 1-.818-1.576L9.62 1.424c.662-.94 2.129-.202 1.767.89l-2.754 8.303H14z\" fill=\"#F5A623\"></path><polygon fill=\"#F5A623\" points=\"8.1875 14.988024 7.25103279 13.6372688 6.74510552 14.988024\"></polygon><polygon fill=\"#FEF79E\" fill-rule=\"nonzero\" points=\"10.4375 2 2 13.988024 8.1875 13.988024 4.4375 24 14 11.6167665 7.24739634 11.6167665\"></polygon></g></g></g></svg>"

/***/ }),

/***/ "cHrg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__ = __webpack_require__("lMLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_queries_IntegrationsQueries__ = __webpack_require__("Qd9x");
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var IntegrationsStore = Marty.createStore({
  id: 'IntegrationsStore',

  getInitialState: function getInitialState() {
    return {
      slackUserMapped: undefined,
      createAccessTokenState: {},
      dailiesByDate: {},
      protipsById: {},
      integrationStates: undefined,
      hubspotInjectionState: undefined,
      hubspotTimelineState: undefined,
      hubspotCookieState: undefined
    };
  },


  handlers: {
    mapSlackUserDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].MAP_SLACK_USER_DONE,
    createAccessTokenDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_DONE,
    createAccessTokenFailed: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED,
    fetchProtipDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_PROTIP_DONE,
    fetchIntegrationStatesDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_INTEGRATION_STATES_DONE,
    fetchHubspotInjectionStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_INJECTION_STATE_DONE,
    fetchHubspotTimelineStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_TIMELINE_STATE_DONE,
    fetchHubspotCookieStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].FETCH_HUBSPOT_COOKIE_STATE_DONE,
    updateIntegrationStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_INTEGRATION_STATE_DONE,
    updateHubspotInjectionStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_INJECTION_STATE_DONE,
    updateHubspotTimelineStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_TIMELINE_STATE_DONE,
    updateHubspotCookieStateDone: __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].UPDATE_HUBSPOT_COOKIE_STATE_DONE
  },

  createAccessToken: function createAccessToken(name, body) {
    this.app.queries.IntegrationsQueries.createAccessToken(name, body);
    var createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState);
    createAccessTokenState[name] = __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_STARTING;
    return this.setState({ createAccessTokenState: createAccessTokenState });
  },
  mapSlackUserDone: function mapSlackUserDone(body) {
    return this.setState({ slackUserMapped: body.ok });
  },
  createAccessTokenDone: function createAccessTokenDone(name) {
    var createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState);
    createAccessTokenState[name] = __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_DONE;
    return this.setState({ createAccessTokenState: createAccessTokenState });
  },
  createAccessTokenFailed: function createAccessTokenFailed(name) {
    var createAccessTokenState = _.cloneDeep(this.state.createAccessTokenState);
    createAccessTokenState[name] = __WEBPACK_IMPORTED_MODULE_0_constants_IntegrationsConstants__["default"].CREATE_ACCESS_TOKEN_FAILED;
    return this.setState({ createAccessTokenState: createAccessTokenState });
  },
  getSlackUserMappingState: function getSlackUserMappingState() {
    return this.state.slackUserMapped;
  },
  getAccessTokenCreationState: function getAccessTokenCreationState() {
    return this.state.createAccessTokenState;
  },
  fetchProtip: function fetchProtip(id) {
    return this.fetch({
      id: 'fetchProtip-' + id,
      locally: function locally() {
        return this.state.protipsById[id];
      },
      remotely: function remotely() {
        return this.app.queries.IntegrationsQueries.fetchProtip(id);
      }
    });
  },
  fetchProtipDone: function fetchProtipDone(id, body) {
    var protipsById = _.cloneDeep(this.state.protipsById);
    protipsById[id] = body;
    return this.setState({ protipsById: protipsById });
  },
  fetchIntegrationStates: function fetchIntegrationStates() {
    return this.fetch({
      id: 'fetchIntegrationStates',
      locally: function locally() {
        return this.state.integrationStates;
      },
      remotely: function remotely() {
        return this.app.queries.IntegrationsQueries.fetchIntegrationStates();
      }
    });
  },
  fetchIntegrationStatesDone: function fetchIntegrationStatesDone(body) {
    return this.setState({ integrationStates: body });
  },
  fetchHubspotInjectionStateDone: function fetchHubspotInjectionStateDone(body) {
    return this.setState({ hubspotInjectionState: body });
  },
  fetchHubspotTimelineStateDone: function fetchHubspotTimelineStateDone(body) {
    return this.setState({ hubspotTimelineState: body });
  },
  fetchHubspotCookieStateDone: function fetchHubspotCookieStateDone(body) {
    return this.setState({ hubspotCookieState: body });
  },
  updateIntegrationStateDone: function updateIntegrationStateDone(body) {
    return this.setState({ integrationStates: body });
  },
  updateHubspotInjectionStateDone: function updateHubspotInjectionStateDone(body) {
    return this.setState({ hubspotInjectionState: body });
  },
  updateHubspotTimelineStateDone: function updateHubspotTimelineStateDone(body) {
    return this.setState({ hubspotTimelineState: body });
  },
  updateHubspotCookieStateDone: function updateHubspotCookieStateDone(body) {
    return this.setState({ hubspotCookieState: body });
  },
  fetchHubspotInjectionState: function fetchHubspotInjectionState() {
    return this.fetch({
      id: 'fetchHubspotInjectionState',
      locally: function locally() {
        return this.state.hubspotInjectionState;
      },
      remotely: function remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotInjectionState();
      }
    });
  },
  fetchHubspotTimelineState: function fetchHubspotTimelineState() {
    return this.fetch({
      id: 'fetchHubspotTimelineState',
      locally: function locally() {
        return this.state.hubspotTimelineState;
      },
      remotely: function remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotTimelineState();
      }
    });
  },
  fetchHubspotCookieState: function fetchHubspotCookieState() {
    return this.fetch({
      id: 'fetchHubspotCookieState',
      locally: function locally() {
        return this.state.hubspotCookieState;
      },
      remotely: function remotely() {
        return this.app.queries.IntegrationsQueries.fetchHubspotCookieState();
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "cKlu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return conversation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return conversations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeEnrichedPaginatedConversations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__ = __webpack_require__("EOku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_paging__ = __webpack_require__("Prq2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_helpers__ = __webpack_require__("nS6h");





var firstConversation = __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["h" /* recentDate */]();

var conversation = function conversation(_ref) {
  var _ref$conversationId = _ref.conversationId,
      conversationId = _ref$conversationId === undefined ? 110225 : _ref$conversationId,
      _ref$endUserId = _ref.endUserId,
      endUserId = _ref$endUserId === undefined ? 1 : _ref$endUserId;
  return {
    "id": conversationId,
    "displayId": 50885,
    "type": "CHAT",
    "status": "OPEN",
    "orgId": 1,
    "inboxId": 17639,
    "endUserId": endUserId,
    "assigneeId": 0,
    "customerId": 0,
    "campaignId": 0,
    "subject": null,
    "uuid": "7148b44b-02d0-4d84-b6d8-2351595093dd",
    "slackChannel": "C91MGH021",
    "tags": [],
    "cc": [],
    "bcc": [],
    "source": null,
    "collaborators": [],
    "preview": "Thank you so much",
    "imported": false,
    "createdAt": firstConversation,
    "updatedAt": firstConversation,
    "closedAt": 0,
    "layerUrl": "layer+driftt:///conversation/pending",
    "defaultMessageDeliveryChannel": "CHAT",
    "context": {
      "campaign": {},
      "locale": "en",
      "os": {
        "name": "OS X 10.12.6",
        "version": "10.12.6",
        "family": "OS X",
        "architecture": "32"
      },
      "page": {
        "path": "",
        "referrer": "",
        "search": "",
        "title": "Drift Staging Profiles",
        "url": "team.driftqa.com",
        "href": "https://team.driftqa.com/"
      },
      "timezone": "America/New_York",
      "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/60.0.3112.101 Safari/537.36"
    },
    "slackAnnTimestamp": "1517409469.000025",
    "slackAnnChannelId": "C5W0NRPR9",
    "participantIds": [],
    "matchedRuleId": 0,
    "possibleRuleIds": [],
    "flowContext": null,
    "relatedCampaignId": null,
    "unreadMessageCount": null,
    "user": {
      "id": 0,
      "type": "LEAD"
    }
  };
};

// TODO: Parameterize same as above
var conversations = [{
  "id": 110225,
  "displayId": 50885,
  "type": "CHAT",
  "status": "OPEN",
  "orgId": 1,
  "inboxId": 17639,
  "endUserId": 1,
  "assigneeId": 0,
  "customerId": 0,
  "campaignId": 0,
  "subject": null,
  "uuid": "7148b44b-02d0-4d84-b6d8-2351595093dd",
  "slackChannel": "C91MGH021",
  "tags": [],
  "cc": [],
  "bcc": [],
  "source": null,
  "collaborators": [],
  "preview": "Thank you so much",
  "imported": false,
  "createdAt": firstConversation,
  "updatedAt": firstConversation,
  "closedAt": 0,
  "layerUrl": "layer+driftt:///conversation/pending",
  "defaultMessageDeliveryChannel": "CHAT",
  "context": {
    "campaign": {},
    "locale": "en",
    "os": {
      "name": "OS X 10.12.6",
      "version": "10.12.6",
      "family": "OS X",
      "architecture": "32"
    },
    "page": {
      "path": "",
      "referrer": "",
      "search": "",
      "title": "Drift Staging Profiles",
      "url": "team.driftqa.com",
      "href": "https://team.driftqa.com/"
    },
    "timezone": "America/New_York",
    "userAgent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/60.0.3112.101 Safari/537.36"
  },
  "slackAnnTimestamp": "1517409469.000025",
  "slackAnnChannelId": "C5W0NRPR9",
  "participantIds": [],
  "matchedRuleId": 0,
  "possibleRuleIds": [],
  "flowContext": null,
  "relatedCampaignId": null,
  "unreadMessageCount": null,
  "user": {
    "id": 0,
    "type": "LEAD"
  }
}];

var makeEnrichmentData = function makeEnrichmentData() {
  return {
    category: {
      industry: "Internet Software & Services",
      subIndustry: "Internet Software & Services"
    },
    geography: {
      city: "Boston",
      country: "United States",
      countryCode: "US",
      state: "Massachusetts"
    },
    location: "4 Copley Pl, Boston, MA 02116, USA",
    logo: "https://logo.clearbit.com/wayfair.com",
    metrics: {
      raised: 0,
      revenueRange: null,
      employees: 7030
    },
    name: __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["b" /* companyName */](),
    social: {
      linkedin: {
        handle: "company/wayfair"
      },
      twitter: {
        handle: "Wayfair"
      }
    },
    source: "DEMANDBASE",
    url: "http://wayfair.com"
  };
};

// TODO: Augment with Geolocation Data
var makeEnrichedEndUser = function makeEnrichedEndUser(_ref2) {
  var id = _ref2.id;

  return {
    id: id,
    orgId: 1,
    status: 'ENABLED',
    attributes: {},
    name: __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["d" /* fullName */](),
    email: __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["c" /* email */](),
    avatarUrl: __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["a" /* avatar */](),
    primaryIdentity: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_helpers__["a" /* weakUuid */])(),
    externalId: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_helpers__["a" /* weakUuid */])(),
    type: 'END_USER',
    enrichmentData: makeEnrichmentData()
  };
};

var makeEnrichedConversation = function makeEnrichedConversation(_ref3) {
  var id = _ref3.id,
      inboxId = _ref3.inboxId,
      participantIds = _ref3.participantIds,
      conversationStatuses = _ref3.conversationStatuses,
      updatedAt = _ref3.updatedAt;

  var endUser = makeEnrichedEndUser({ id: id });
  var normalizedParticipantIds = participantIds ? participantIds === '0' ? [] : participantIds.map(parseInt) : []; // TODO: Random participants

  return {
    id: id,
    type: 'CHAT',
    status: conversationStatuses && __WEBPACK_IMPORTED_MODULE_0_app_utils_faker__["g" /* randomChoice */](conversationStatuses) || 'OPEN',
    orgId: 1,
    inboxId: inboxId,
    endUserId: endUser.id,
    endUserType: endUser.type,
    preview: 'Thank you so much',
    participantIds: normalizedParticipantIds,
    updatedAt: updatedAt,
    endUser: endUser,
    user: {
      id: endUser.id,
      type: endUser.type
    }
  };
};

var makeEnrichedConversations = function makeEnrichedConversations(_ref4) {
  var inboxId = _ref4.inboxId,
      limit = _ref4.limit,
      sortBy = _ref4.sortBy,
      before = _ref4.before,
      after = _ref4.after,
      participantIds = _ref4.participantIds,
      conversationStatuses = _ref4.conversationStatuses;

  // TODO: Restrict timestamps to specific min/max based on sortBy param
  // e.g. moment(Date.now()).subtract(1, 'days') for min/max
  var updatedAt = Date.now();
  return _.range(limit).map(function (index) {
    return makeEnrichedConversation({ id: index + 1, inboxId: inboxId, participantIds: participantIds, conversationStatuses: conversationStatuses, updatedAt: updatedAt });
  });
};

var makeEnrichedPaginatedConversations = function makeEnrichedPaginatedConversations(_ref5) {
  var inboxId = _ref5.inboxId,
      query = _ref5.query;
  var limit = query.limit,
      before = query.before,
      after = query.after,
      sortBy = query.sortBy,
      participantIds = query.participantId,
      conversationStatuses = query.status;


  var enrichedConversations = makeEnrichedConversations({
    inboxId: inboxId,
    limit: limit,
    sortBy: sortBy,
    before: before,
    after: after,
    participantIds: participantIds,
    conversationStatuses: conversationStatuses
  });

  var sorted = _.sortBy(enrichedConversations, function (_ref6) {
    var updatedAt = _ref6.updatedAt;

    return sortBy === 'oldest' ? updatedAt : -updatedAt;
  });

  return Object(__WEBPACK_IMPORTED_MODULE_2_utils_paging__["b" /* PagedData */])({
    data: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(sorted),
    cursor: _.last(sorted).updatedAt,
    hasMore: true
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "cLnm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cMSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * given an input captured from medium editor determine if it is empty or not
 * @param input
 * @returns {*|boolean}
 */
function isMediumInputEmpty(input) {
  // "<p><br></p>" is a bug from medium editor we consider that as null input
  return input && input !== '<p><br></p>';
}

/* harmony default export */ __webpack_exports__["a"] = (isMediumInputEmpty);

/***/ }),

/***/ "cP8E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_Application__ = __webpack_require__("08hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("2qcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var APP = Object(__WEBPACK_IMPORTED_MODULE_8_app_Application__["b" /* getApplication */])();
var GOOGLE_AUTH_URL = 'https://accounts.google.com/o/oauth2/v2/auth';

var GoogleAuthModal = function (_Component) {
  _inherits(GoogleAuthModal, _Component);

  function GoogleAuthModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GoogleAuthModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GoogleAuthModal.__proto__ || Object.getPrototypeOf(GoogleAuthModal)).call.apply(_ref, [this].concat(args))), _this), _this.doGmailConnect = function () {
      var scope = __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_constants__["K" /* GoogleScopes */].READ + ' ' + __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND;
      var params = {
        scope: scope,
        redirect_uri: __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/google-calendar',
        client_id: __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__["v" /* GOOGLE_CLIENT_ID */],
        response_type: 'code',
        access_type: 'offline',
        include_granted_scopes: true
      };

      Object(__WEBPACK_IMPORTED_MODULE_7_components_Integration_helpers__["b" /* popUp */])({
        path: GOOGLE_AUTH_URL + '?' + Object(__WEBPACK_IMPORTED_MODULE_6_utils_Helpers__["d" /* encodeQueryData */])(params),
        onMessage: _this.handlePostMessage
      });
    }, _this.handlePostMessage = function (e) {
      var onSuccess = _this.props.onSuccess;

      var success = e.data.status === 'success';
      _this.props.actions.hideGoogleAuthModal();
      if (success) {
        APP.actions.NotificationActions.pushNotification({
          content: 'Your Google account was successfully connected.'
        });
        !!onSuccess && onSuccess(e);
        _this.props.actions.fetchGoogleScopesSuccess(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"].of(__WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_constants__["K" /* GoogleScopes */].READ, __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND));
      } else {
        APP.actions.NotificationActions.pushNotification({
          content: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            null,
            'Your Google account may be connected to a different Drift account. Please review your',
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              {
                style: { color: '#EFEFEF', textDecoration: 'underline' },
                href: 'https://myaccount.google.com/permissions',
                target: '_blank'
              },
              'Google app permissions'
            ),
            '.'
          ),
          variant: 'red',
          sticky: true
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GoogleAuthModal, [{
    key: 'render',
    value: function render() {
      var onClose = this.props.onClose;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_components_shared_Modal__["a" /* default */],
        {
          onRequestClose: onClose,
          isOpen: true,
          style: { content: { padding: 0, border: '1px solid transparent', background: 'none' } }
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'drift-modal link-google-auth-modal' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'h2',
            null,
            'One quick thing\u2026'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'In order for you to send a test email, we need you to connect your Gmail account. Learn more',
            ' ',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { href: 'https://help.drift.com/sequences/connect-your-email-to-drift-sequences', target: '_blank' },
              'here'
            ),
            '.'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'footer',
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'drift-button', onClick: this.props.actions.hideGoogleAuthModal },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'button',
              { className: 'drift-button drift-button-primary', onClick: this.doGmailConnect },
              'Link Gmail Account'
            )
          )
        )
      );
    }
  }]);

  return GoogleAuthModal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      hideGoogleAuthModal: __WEBPACK_IMPORTED_MODULE_12_app_modules_playbook_actions__["_85" /* hideGoogleAuthModal */],
      fetchGoogleScopesSuccess: __WEBPACK_IMPORTED_MODULE_11_app_modules_user_actions__["fetchGoogleScopesSuccess"]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(undefined, mapDispatchToProps)(GoogleAuthModal));

/***/ }),

/***/ "cRAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return authenticate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return authenticatePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return authenticateSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authenticateFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return connect; });
/* unused harmony export disconnect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return joinChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return joinChannelPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return joinChannelSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return joinChannelFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return socketOpenEventReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return socketErrorEventReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return socketCloseEventReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return socketReconnectAttemptQueued; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return socketReconnectTimerTicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return channelErrorEventReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return channelCloseEventReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return leaveChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("EkEs");



var authenticate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* AUTHENTICATE */]);
var authenticatePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* AUTHENTICATE_PENDING */]);
var authenticateSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* AUTHENTICATE_SUCCESS */]);
var authenticateFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AUTHENTICATE_FAILURE */]);

var connect = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CONNECT */]);
var disconnect = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* DISCONNECT */]);

var joinChannel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* JOIN_CHANNEL */]);
var joinChannelPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* JOIN_CHANNEL_PENDING */]);
var joinChannelSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* JOIN_CHANNEL_SUCCESS */]);
var joinChannelFailure = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* JOIN_CHANNEL_FAILURE */]);

var socketOpenEventReceived = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* SOCKET_OPEN_EVENT_RECEIVED */]);
var socketErrorEventReceived = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SOCKET_ERROR_EVENT_RECEIVED */]);
var socketCloseEventReceived = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SOCKET_CLOSE_EVENT_RECEIVED */]);

var socketReconnectAttemptQueued = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SOCKET_RECONNECT_ATTEMPT_QUEUED */]);
var socketReconnectTimerTicked = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* SOCKET_RECONNECT_TIMER_TICKED */]);

var channelErrorEventReceived = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CHANNEL_ERROR_EVENT_RECEIVED */]);
var channelCloseEventReceived = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CHANNEL_CLOSE_EVENT_RECEIVED */]);

var leaveChannel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* LEAVE_CHANNEL */]);

/***/ }),

/***/ "cTDj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return continents; });
var continents = {
	'AFRICA': ['DZ', 'AO', 'BJ', 'BW', 'BF', 'BI', 'CM', 'CV', 'CF', 'TD', 'KM', 'CG', 'CD', 'DJ', 'EG', 'GQ', 'ER', 'ET', 'GA', 'GM', 'GH', 'GN', 'GW', 'KE', 'LS', 'LR', 'LY', 'MG', 'MW', 'ML', 'MR', 'MU', 'MA', 'MZ', 'NA', 'NE', 'NG', 'RW', 'ST', 'SN', 'SC', 'SL', 'SO', 'ZA', 'SD', 'SZ', 'TZ', 'TG', 'TN', 'UG', 'ZM', 'ZW'],
	'ASIA': ['AF', 'BD', 'BT', 'IO', 'BN', 'KH', 'CN', 'TL', 'GU', 'HK', 'IN', 'ID', 'JP', 'KZ', 'KR', 'KG', 'LA', 'MO', 'MY', 'MV', 'MN', 'MM', 'NR', 'NP', 'MP', 'PK', 'PW', 'PH', 'SG', 'LK', 'TJ', 'TW', 'TH', 'TM', 'UZ', 'VN'],
	'EUROPE': ['AL', 'AD', 'AT', 'BY', 'BE', 'BA', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'DE', 'GI', 'GR', 'HU', 'IS', 'IE', 'IM', 'IT', 'RS', 'LV', 'LI', 'LT', 'LU', 'MK', 'MT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'UA', 'GB', 'VA', 'RS'],
	'MIDDLE_EAST': ['AM', 'AZ', 'BH', 'GE', 'IR', 'IQ', 'IL', 'JO', 'KW', 'LB', 'OM', 'QA', 'SA', 'SY', 'TR', 'TM', 'AE', 'YE'],
	'NORTH_AMERICA': ['BM', 'CA', 'GL', 'MX', 'PM', 'US', 'UM'],
	'CENTRAL_AMERICA_CARRIBEAN': ['AI', 'AG', 'AW', 'BS', 'BB', 'BZ', 'KY', 'CR', 'CU', 'DM', 'DO', 'SV', 'GD', 'GP', 'GT', 'HT', 'HN', 'JM', 'MQ', 'MX', 'MS', 'AN', 'NI', 'PA', 'PR', 'KN', 'LC', 'VC', 'TT', 'TC', 'UM', 'VG', 'VI'],
	'SOUTH_AMERICA': ['AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF', 'GY', 'PY', 'PE', 'SR', 'UY', 'VE'],
	'OCEANIA': ['AS', 'AU', 'CX', 'CC', 'CK', 'FJ', 'PF', 'TF', 'HM', 'ID', 'KI', 'MH', 'FM', 'NR', 'NC', 'NZ', 'NU', 'NF', 'PW', 'PG', 'PN', 'WS', 'SB', 'TK', 'TO', 'TV', 'UM', 'VU', 'WF']
};

/***/ }),

/***/ "cVTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_team_EmailInviteModal__ = __webpack_require__("Yxa2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var closeIconSrc = __webpack_require__("+Juk");

var InstallDriftNotice = function (_Component) {
  _inherits(InstallDriftNotice, _Component);

  function InstallDriftNotice(props) {
    _classCallCheck(this, InstallDriftNotice);

    var _this = _possibleConstructorReturn(this, (InstallDriftNotice.__proto__ || Object.getPrototypeOf(InstallDriftNotice)).call(this, props));

    _this.hideForSession = function () {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('hide-install-notice', true);
      }
      _this.setClose();
    };

    _this.showWarning = function () {
      _this.setState({ showWarning: true });
    };

    _this.setClose = function () {
      _this.setState({ closed: true });
    };

    _this.setOpen = function () {
      _this.setState({ closed: false });
    };

    _this.redirectToSettings = function () {
      _this.context.router.push('/settings/widget');
    };

    _this.showInviteModal = function () {
      _this.setState({ showInviteModal: true });
    };

    _this.closeInviteModal = function () {
      _this.setState({ showInviteModal: false });
    };

    _this.state = {
      closed: true,
      showInviteModal: false
    };
    return _this;
  }

  _createClass(InstallDriftNotice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.sessionStorage && !JSON.parse(window.sessionStorage.getItem('hide-install-notice'))) {
        this.timeout = setTimeout(this.setOpen, 5000);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var closed = this.state.closed;

      var showBar = !closed ? 'show-bar' : '';
      var noticeMessage = React.createElement(
        'p',
        null,
        'We noticed you haven\u2019t installed Drift yet \u2013 keep getting setup!'
      );

      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('global-notification-tease attention', _defineProperty({}, 'show-bar', showBar)) },
        noticeMessage,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.redirectToSettings },
          'Install Drift'
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.showInviteModal },
          'Send Drift snippet to a teammate'
        ),
        React.createElement(
          'div',
          { className: 'dismiss-notification', onClick: this.hideForSession },
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'close' })
        ),
        this.state.showInviteModal && React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_settings_team_EmailInviteModal__["a" /* default */], {
          onClose: this.closeInviteModal,
          skipRedirect: true,
          onSend: this.hideForSession
        })
      );
    }
  }]);

  return InstallDriftNotice;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

InstallDriftNotice.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (InstallDriftNotice);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "cXWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_message_selectors__ = __webpack_require__("bWf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };










var mapStateToProps = function mapStateToProps() {
  var getUserIpEmail = function getUserIpEmail(state, endUser, conversationId, firstEndUserMessageSelector) {
    var firstMessagesLoaded = __WEBPACK_IMPORTED_MODULE_4_app_modules_message_selectors__["b" /* firstMessagesLoaded */](state, { conversationId: conversationId });

    if (!firstMessagesLoaded) {
      return {};
    }

    var firstEndUserMessage = firstEndUserMessageSelector(state, { conversationId: conversationId });

    var endUserMessageIp = firstEndUserMessage && firstEndUserMessage.getIn(['context', 'ip']);

    return {
      ip: endUserMessageIp,
      email: Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["get"])(endUser, 'email')
    };
  };

  var firstEndUserMessageSelector = __WEBPACK_IMPORTED_MODULE_4_app_modules_message_selectors__["a" /* firstEndUserMessage */]();
  var endUserForConversationId = __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_selectors__["f" /* makeEndUserForConversationIdSelector */]();

  return function (state, props) {
    var conversationId = props.conversationId;

    var endUser = endUserForConversationId(state, { conversationId: conversationId });
    var result = getUserIpEmail(state, endUser, conversationId, firstEndUserMessageSelector);
    return result;
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])(_extends({}, props.actions), dispatch)
  };
};

var withContactInfo = function withContactInfo(WrappedComponent) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps))(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (withContactInfo);

/***/ }),

/***/ "cYdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TimeSelectorDropdown__ = __webpack_require__("fDDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_TimeSelectorButton__ = __webpack_require__("hSe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_TimeSelectorButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_components_TimeSelectorButton__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.













/* harmony default export */ __webpack_exports__["a"] = (React.createClass({
  displayName: 'TimeSelectorButton',

  mixins: [__webpack_require__("aCGJ")],

  propTypes: {
    onSetRange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    selectedDateRange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
  },

  getInitialState: function getInitialState() {
    return {
      showTimeRangeDropdown: false
    };
  },
  formatDate: function formatDate(date) {
    var todayOrYesterday = date.calendar(null, { sameDay: '[Today]', lastDay: '[Yesterday]' });
    if (todayOrYesterday === 'Today' || todayOrYesterday === 'Yesterday') {
      return todayOrYesterday;
    }

    return date.format('MMMM D');
  },
  getRangeText: function getRangeText() {
    if (this.props.selectedDateRange) {
      return this.formatDate(this.props.selectedDateRange.start) + ' - ' + this.formatDate(this.props.selectedDateRange.end);
    }
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'TimeSelectorButton' },
      React.createElement(
        'button',
        {
          ref: 'timeButton',
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('main-button', { selected: this.state.showTimeRangeDropdown }),
          onClick: this.handleOnClick },
        React.createElement(
          'div',
          null,
          this.getRangeText()
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __webpack_require__("75Yw") })
      ),
      this.state.showTimeRangeDropdown ? React.createElement(
        'div',
        null,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_DropDown__["a" /* default */],
          {
            className: 'time-selector-dropdown',
            onClickOutside: this.handleClickOutside },
          React.createElement(__WEBPACK_IMPORTED_MODULE_4__TimeSelectorDropdown__["a" /* default */], this.props)
        )
      ) : undefined
    );
  },
  handleClickOutside: function handleClickOutside() {
    return this.setState({ showTimeRangeDropdown: false });
  },
  handleOnClick: function handleOnClick() {
    return this.setState({ showTimeRangeDropdown: !this.state.showTimeRangeDropdown });
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "caNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__ = __webpack_require__("pIAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");




var ConversationQueries = Marty.createQueries({
  id: 'ConversationQueries',

  fetchConversationsById: function fetchConversationsById(conversationIds) {
    var _this = this;

    return this.app.sources.ConversationAPI.fetchConversationsById(conversationIds).then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATIONS_BY_ID_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATIONS_BY_ID_FETCH_FAILED, res);
      }
    }).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATIONS_BY_ID_FETCH_FAILED, error);
    });
  },
  fetchConversation: function fetchConversation(conversationId) {
    var _this2 = this;

    var conversationPromise = this.app.sources.ConversationAPI.fetchConversation(conversationId);

    conversationPromise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATION_FETCH_DONE, conversationId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATION_FETCH_FAILED, conversationId, res);
      }
    });

    return conversationPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].CONVERSATION_FETCH_FAILED, conversationId, error);
    });
  },
  searchConversations: function searchConversations(query) {
    var _this3 = this;

    var promise = this.app.sources.ConversationAPI.searchConversations(query);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].SEARCH_ALL_CONVERSATIONS_DONE, query, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].SEARCH_ALL_CONVERSATIONS_FAILED, query, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ConversationConstants__["a" /* default */].SEARCH_ALL_CONVERSATIONS_FAILED, query, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ConversationQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "cbE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ceBF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default-app-icon.32c6c795.svg";

/***/ }),

/***/ "chwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_thunk__ = __webpack_require__("bEzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__epic__ = __webpack_require__("+Fsc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__("jZgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);




/* harmony default export */ __webpack_exports__["a"] = (function (history) {
  return [__WEBPACK_IMPORTED_MODULE_0_redux_thunk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__epic__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerMiddleware"])(history)];
});

/***/ }),

/***/ "cj8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cjxO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cmMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_FakeEmailWindow__ = __webpack_require__("jwya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg__ = __webpack_require__("gYUb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("HaDl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var HELP_DOC_LINK = 'https://help.drift.com/article/personalization-tokens/';
var HELP_LINK_TEXT = 'Click here to learn more about using personalization attributes in a Drift playbook.';

var SimpleEmailTemplate = function SimpleEmailTemplate(_ref) {
  var fromName = _ref.fromName,
      fromEmail = _ref.fromEmail,
      headline = _ref.headline,
      messagePreview = _ref.messagePreview,
      showRenderedPreview = _ref.showRenderedPreview;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_components_shared_FakeEmailWindow__["a" /* default */],
    { from: fromName, address: fromEmail, subject: headline },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("playbook-email-template-content", { 'playbook-email-template-data-preview': showRenderedPreview }), dangerouslySetInnerHTML: { __html: messagePreview } })
  );
};

var StyledEmailTemplate = function StyledEmailTemplate(_ref2) {
  var sender = _ref2.sender,
      fromName = _ref2.fromName,
      fromEmail = _ref2.fromEmail,
      headline = _ref2.headline,
      messagePreview = _ref2.messagePreview,
      backgroundColor = _ref2.backgroundColor,
      organizationName = _ref2.organizationName,
      showRenderedPreview = _ref2.showRenderedPreview;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6_components_shared_FakeEmailWindow__["a" /* default */],
    { from: fromName, address: fromEmail, subject: headline },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'playbook-email-template-styled-top-bar', style: { backgroundColor: backgroundColor } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-email-template-styled-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("playbook-email-template-content", { 'playbook-email-template-data-preview': showRenderedPreview }), dangerouslySetInnerHTML: { __html: messagePreview } }),
      sender && sender.name && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex playbook-email-template-styled-signature' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__["a" /* default */], { user: sender }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'playbook-email-template-styled-signature-name' },
            Object(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(sender)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'playbook-email-template-styled-signature-organization' },
            organizationName
          )
        )
      )
    )
  );
};

var ThemeOption = function ThemeOption(_ref3) {
  var color = _ref3.color,
      selected = _ref3.selected,
      type = _ref3.type,
      onClick = _ref3.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-email-theme-option', { selected: selected }), onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'playbook-email-theme-option-swatch', style: { backgroundColor: color } }),
    type
  );
};

var EmailMessagePreview = function EmailMessagePreview(_ref4) {
  var headline = _ref4.headline,
      message = _ref4.message,
      selectedUser = _ref4.selectedUser,
      organizationName = _ref4.organizationName,
      backgroundColor = _ref4.backgroundColor,
      simpleSelected = _ref4.simpleSelected,
      styledSelected = _ref4.styledSelected,
      onStyledClick = _ref4.onStyledClick,
      onSimpleClick = _ref4.onSimpleClick,
      sendTestEmailLoading = _ref4.sendTestEmailLoading,
      onSendTestEmailClick = _ref4.onSendTestEmailClick,
      showRenderedPreview = _ref4.showRenderedPreview,
      emailRenderedPreview = _ref4.emailRenderedPreview,
      selectedPreview = _ref4.selectedPreview,
      onDefaultPreviewClick = _ref4.onDefaultPreviewClick,
      onTemplatePreviewClick = _ref4.onTemplatePreviewClick,
      onRenderedPreviewClick = _ref4.onRenderedPreviewClick,
      onRefreshPreviewClick = _ref4.onRefreshPreviewClick,
      userListIdOptions = _ref4.userListIdOptions,
      handleChangeUserListOption = _ref4.handleChangeUserListOption,
      selectedUserListOption = _ref4.selectedUserListOption,
      EmailPreviewView = _ref4.EmailPreviewView,
      fromNameOverride = _ref4.fromNameOverride,
      fromEmailOverride = _ref4.fromEmailOverride,
      isTemplateContactPreviewLoading = _ref4.isTemplateContactPreviewLoading;

  var messagePreview = selectedPreview !== EmailPreviewView.TEMPLATE && emailRenderedPreview ? emailRenderedPreview : message;
  var templateProps = {
    messagePreview: messagePreview,
    headline: headline,
    sender: selectedUser,
    fromName: fromNameOverride || Object(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(selectedUser),
    fromEmail: fromEmailOverride,
    showRenderedPreview: showRenderedPreview,
    emailRenderedPreview: emailRenderedPreview
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-message' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h2',
      null,
      'How should your email look?'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Choose a plain text or styled email.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Card__["a" /* default */],
      { title: 'Email', description: headline },
      simpleSelected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleEmailTemplate, templateProps),
      styledSelected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledEmailTemplate, _extends({}, templateProps, {
        backgroundColor: backgroundColor,
        organizationName: organizationName
      }))
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'email-playbook-extra-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'email-playbook-preview-options' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { className: 'preview-options-label' },
          'Preview Sample Data',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { is: true, href: HELP_DOC_LINK, tooltip: HELP_LINK_TEXT, flow: 'up', target: '_blank' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_info_icon_svg___default.a })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'drift-pill-set' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              onClick: onTemplatePreviewClick,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.TEMPLATE
              })
            },
            'Template'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              onClick: onDefaultPreviewClick,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.DEFAULTS
              })
            },
            'Defaults'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            {
              onClick: onRenderedPreviewClick,
              className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'playbook-extra-option-button', {
                active: selectedPreview === EmailPreviewView.RENDERED_DATA
              })
            },
            'Contact'
          )
        )
      )
    ),
    selectedPreview === EmailPreviewView.RENDERED_DATA && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'email-playbook-extra-option email-playbook-segment-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_shared_UISelect__["b" /* default */], {
        className: 'playbook-email-preview-segment-select',
        options: userListIdOptions,
        value: selectedUserListOption,
        onChange: handleChangeUserListOption,
        placeholder: 'choose a segment..'
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { disabled: isTemplateContactPreviewLoading, onClick: onRefreshPreviewClick, className: 'drift-button playbook-extra-option-button' },
          isTemplateContactPreviewLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'email-preview-options-loading-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__["a" /* default */], null)
          ),
          !isTemplateContactPreviewLoading && 'Refresh'
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'email-playbook-extra-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        null,
        'Select a Theme'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThemeOption, { type: 'Styled', selected: styledSelected, color: backgroundColor, onClick: onStyledClick }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThemeOption, { type: 'Simple', selected: simpleSelected, onClick: onSimpleClick })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'email-playbook-extra-option' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'label',
        null,
        'Send me a test email'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            className: 'drift-button playbook-extra-option-button',
            disabled: sendTestEmailLoading,
            onClick: onSendTestEmailClick
          },
          sendTestEmailLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'email-preview-options-loading-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_LoadingDots__["a" /* default */], null)
          ),
          !sendTestEmailLoading && 'Send Email'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailMessagePreview);

/***/ }),

/***/ "cnR9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__("Gvdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_auth_requests_api__ = __webpack_require__("Y7j0");




var API = {
  sendWelcomeMessage: function sendWelcomeMessage(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/ws/messages?ws_user_id=' + data.presenceEndUserId, data.payload).map(function (_ref) {
      var response = _ref.response;
      return response;
    });
  },
  bootstrapUser: function bootstrapUser(anonID) {
    var payload = {
      topic: 'widget:bootstrapEndUser',
      anonId: anonID
    };

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/ws/messages', payload).map(function (_ref2) {
      var response = _ref2.response;
      return response;
    });
  },
  sendActiveStatus: function sendActiveStatus(conversationId) {
    var queryString = conversationId ? '?conversationId=' + conversationId : '';
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_2_app_auth_requests_api__["a" /* ConversationAPIAuthEnabled */].post('/agents/active' + queryString).then(function (res) {
      return res.response;
    }));
  },
  getPresenceState: function getPresenceState() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { size: 25 };

    var queryString = query.timezone ? '?timezone=' + query.timezone : '';

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxLiveAPI"].post('/visitor/searchWithCounts' + queryString, query).map(function (_ref3) {
      var response = _ref3.response;
      return response;
    });
  }
};

/***/ }),

/***/ "cnY4":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 21 22\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Settings---Integrations-Copy-9\" transform=\"translate(-1085.000000, -152.000000)\" fill=\"#FFFFFF\"><g id=\"Group-3-Copy-2\" transform=\"translate(106.000000, 135.000000)\"><g id=\"Group-7\" transform=\"translate(979.000000, 12.400000)\"><g id=\"Group\" transform=\"translate(0.000000, 5.600000)\"><path d=\"M0,6.36 C0,5.49888 0.5798,4.8 1.2935,4.8 L9.0558,4.8 C9.5459,4.8 9.9944,5.13384 10.2141,5.66268 C10.4325,6.19152 10.3857,6.82332 10.0906,7.29756 L3.8818,17.28 L9.0558,17.28 C9.7708,17.28 10.3493,17.97732 10.3493,18.84 C10.3493,19.70268 9.7708,20.4 9.0558,20.4 L1.2935,20.4 C0.8047,20.4 0.3562,20.06616 0.1365,19.53732 C-0.0819,19.00848 -0.0351,18.37668 0.26,17.904 L6.4688,7.92156 L1.2935,7.92156 C0.5798,7.92156 0,7.22112 0,6.36 L0,6.36 Z\" id=\"Path\"></path><path d=\"M14,0.96 C14,0.43008 14.3568,0 14.796,0 L19.5728,0 C19.8744,0 20.1504,0.20544 20.2856,0.53088 C20.42,0.85632 20.3912,1.24512 20.2096,1.53696 L16.3888,7.68 L19.5728,7.68 C20.0128,7.68 20.3688,8.10912 20.3688,8.64 C20.3688,9.17088 20.0128,9.6 19.5728,9.6 L14.796,9.6 C14.4952,9.6 14.2192,9.39456 14.084,9.06912 C13.9496,8.74368 13.9784,8.35488 14.16,8.064 L17.9808,1.92096 L14.796,1.92096 C14.3568,1.92096 14,1.48992 14,0.96 L14,0.96 Z\" id=\"Path\" stroke=\"#FFFFFF\" stroke-width=\"0.5\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "cp96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "crjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NOTE_ICON_SRC = __webpack_require__("VhE9");

var NoteLoggingEvent = function (_Component) {
  _inherits(NoteLoggingEvent, _Component);

  function NoteLoggingEvent() {
    _classCallCheck(this, NoteLoggingEvent);

    return _possibleConstructorReturn(this, (NoteLoggingEvent.__proto__ || Object.getPrototypeOf(NoteLoggingEvent)).apply(this, arguments));
  }

  _createClass(NoteLoggingEvent, [{
    key: 'render',
    value: function render() {
      var eventProps = _extends({
        iconSrc: NOTE_ICON_SRC,
        isNote: true,
        eventLabel: "added a note"
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GenericEvent__["a" /* default */], eventProps);
    }
  }]);

  return NoteLoggingEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NoteLoggingEvent);

/***/ }),

/***/ "csip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TagSelect":"TagSelect---2ObrZ"};

/***/ }),

/***/ "csxS":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMzQ5IDI3MCAxMjUgODEiPjxzdHlsZT4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzIwZDRhY30uc3QwLC5zdDF7c3Ryb2tlLXdpZHRoOjR9LnN0MXtmaWxsOiNGRkZ9LnN0MSwuc3Qye3N0cm9rZTojMjBkNGFjfS5zdDJ7ZmlsbDojMjBkNGFjO3N0cm9rZS13aWR0aDoxLjY3ODl9PC9zdHlsZT48dGl0bGU+R3JvdXA8L3RpdGxlPjxnIGlkPSJOUFMtRmxvdyI+PGcgaWQ9IldpemFyZC0tLVR5cGUiPjxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMikiPjxlbGxpcHNlIGlkPSJPdmFsLTIzIiBjbGFzcz0ic3QwIiBjeD0iLTMxMiIgY3k9IjMzMy41IiByeD0iMTUuNiIgcnk9IjEzLjgiLz48cGF0aCBpZD0iUGF0aC0yMy1Db3B5IiBjbGFzcz0ic3QxIiBkPSJNLTI2Ny41IDI4Ni4yYy0uNS0zLjUtMy42LTUuMi02LjgtMy43bC02MC41IDI3LjFjLTYuNSAyLjktOS4xIDEwLjQtNS44IDE2LjYgMCAwIC40IDEuMyAxLjkgMy4xIDEuMyAxLjUgNzQuNCAxNS41IDc0LjQgMTUuNSAzLjUuNyA1LjgtMS42IDUuMy01LjFsLTguNS01My41eiIvPjxwYXRoIGlkPSJTaGFwZS1Db3B5IiBjbGFzcz0ic3QyIiBkPSJNLTI1MC4zIDI5MC42bDE2LjQtMTAuNWMuNi0uNCAxLjEtMS41IDEuMi0yLjUuMS0xLS40LTEuNS0xLTEuMWwtMTYuNCAxMC41Yy0uNi40LTEuMSAxLjUtMS4yIDIuNSAwIC43LjEgMS4xLjUgMS4yLjEgMCAuMyAwIC41LS4xeiIvPjxwYXRoIGlkPSJTaGFwZS1Db3B5LTIiIGNsYXNzPSJzdDIiIGQ9Ik0tMjMxLjEgMzMyLjRsLTE0LjEtMy40Yy0uNS0uMS0uOS42LS44IDEuNi4xIDEgLjUgMS45IDEgMmwxNC4xIDMuNGguMmMuNC0uMS43LS43LjYtMS42IDAtMS0uNS0xLjktMS0yeiIvPjxwYXRoIGlkPSJTaGFwZS1Db3B5LTMiIGNsYXNzPSJzdDIiIGQ9Ik0tMjI5LjYgMzA3LjNjLjEtMS4xLS4yLTItLjgtMS45bC0xNC43IDJjLS42LjEtMS4xIDEuMS0xLjIgMi4yLS4xIDEgLjIgMS45LjcgMS45aC4ybDE0LjctMmMuNCAwIC45LTEgMS4xLTIuMnoiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "cxPT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(3);

/***/ }),

/***/ "cyc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var SegmentAPI = Marty.createStateSource({
  id: 'SegmentAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  createSegment: function createSegment(body) {
    return this.post({
      url: '/user_lists',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(body)
    });
  },
  addEndUserIdsToStaticSegment: function addEndUserIdsToStaticSegment(segmentId, endUserIds) {
    return this.patch({
      url: '/user_lists/' + segmentId + '/members',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(endUserIds),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  deleteEndUserIdsFromStaticSegment: function deleteEndUserIdsFromStaticSegment(segmentId, endUserIds) {
    return this.delete({
      url: '/user_lists/' + segmentId + '/members',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(endUserIds),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateSegment: function updateSegment(id, updates) {
    return this.patch({
      url: '/user_lists/' + id,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(updates),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  elasticSearchMembersOfSegment: function elasticSearchMembersOfSegment(segmentId, from, size) {
    var sizeQuery = {};
    if (from != null) {
      sizeQuery.from = from;
    }
    if (size != null) {
      sizeQuery.size = size;
    }
    return this.get({
      url: '/user_lists/' + segmentId + '/members?' + Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["d" /* encodeQueryData */])(sizeQuery),
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchSegments: function fetchSegments() {
    return this.get({
      url: '/user_lists',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchSegment: function fetchSegment(segmentId) {
    return this.get({
      url: '/user_lists/' + segmentId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SegmentAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "czSA":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(12);

/***/ }),

/***/ "d/UH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SalesforceMeetingBookedBySelect__ = __webpack_require__("eOvD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("qdP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DEFAULT_LABEL = "Don't set type";
var UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.';
var DEFAULT_OPTION = { id: null, name: DEFAULT_LABEL };

var eventToSelectOption = function eventToSelectOption(name) {
  return {
    id: name,
    name: name
  };
};

var SalesforceEventMapping = function (_Component) {
  _inherits(SalesforceEventMapping, _Component);

  function SalesforceEventMapping(props) {
    _classCallCheck(this, SalesforceEventMapping);

    var _this = _possibleConstructorReturn(this, (SalesforceEventMapping.__proto__ || Object.getPrototypeOf(SalesforceEventMapping)).call(this, props));

    _this.getInitialValue = function () {
      var promises = [__WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceEventTypeList(), __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].getSalesforceEventType()];

      var onDone = function onDone(_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            eventTypes = _ref2[0],
            eventType = _ref2[1];

        _this.setState({
          isLoading: false,
          selectOptions: eventTypes.map(eventToSelectOption),
          selectValue: eventType
        });
      };

      Promise.all(promises).then(onDone).catch(_this.handleUnknownError);
    };

    _this.handleUnknownError = function () {
      _this.setState({
        isLoading: false,
        hasError: true,
        errorText: UNKNOWN_ERROR
      });
    };

    _this.onChange = function (_ref3) {
      var id = _ref3.id,
          name = _ref3.name;

      var onDone = function onDone() {
        _this.setState({ isLoading: false });
      };

      var patch = __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].patchSalesforceEventType({ eventType: id }).then(onDone).catch(_this.handleUnknownError);

      _this.setState({
        selectValue: id,
        selectLabel: name,
        isLoading: true
      }, patch);
    };

    _this.resolveSelectOptions = function () {
      var selectOptions = _this.state.selectOptions;

      return [DEFAULT_OPTION].concat(_toConsumableArray(selectOptions));
    };

    _this.state = {
      isLoading: true,
      hasError: false,
      selectValue: null,
      selectLabel: null,
      selectOptions: []
    };
    return _this;
  }

  _createClass(SalesforceEventMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInitialValue();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          hasError = _state.hasError,
          errorText = _state.errorText,
          selectValue = _state.selectValue,
          selectLabel = _state.selectLabel,
          isLoading = _state.isLoading;

      var options = this.resolveSelectOptions();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'salesforce-activity-select-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          className: 'salesforce-activity-select-input',
          labelKey: 'name',
          valueKey: 'id',
          autosize: false,
          searchable: false,
          clearable: false,
          placeholder: DEFAULT_LABEL,
          value: selectValue,
          label: selectLabel,
          options: options,
          isLoading: isLoading,
          onChange: this.onChange,
          resetValue: DEFAULT_OPTION
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SalesforceMeetingBookedBySelect__["a" /* default */], null),
        hasError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'salesforce-task-error-text' },
          errorText
        )
      );
    }
  }]);

  return SalesforceEventMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceEventMapping);

/***/ }),

/***/ "d0nC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("n79a");





var api = {
  fetch: function fetch() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/classifications').checkStatus().retryWithBackoff().mapResponse(function (classifications) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(classifications).map(function (classification) {
        return new __WEBPACK_IMPORTED_MODULE_2__models__["a" /* Classification */](classification);
      });
    });
  },
  create: function create(classifications) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/classifications', classifications).checkStatus().retryWithBackoff().mapResponse(function (classifications) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(classifications).map(function (classification) {
        return new __WEBPACK_IMPORTED_MODULE_2__models__["a" /* Classification */](classification);
      });
    });
  }
};

/***/ }),

/***/ "d258":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withGlobalAutoCloseConfiguration__ = __webpack_require__("Z9sL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("EfR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__ = __webpack_require__("LSvj");








var MINUTE = 60 * 1000;
var DAYS_IN_WEEK = 7;
var WEEK = MINUTE * 60 * 24 * DAYS_IN_WEEK;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
    updateGlobalAutoCloseConfiguration: __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_actions__["_0" /* updateGlobalAutoCloseConfiguration */]
  }, dispatch);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_4__withGlobalAutoCloseConfiguration__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return !props.isGlobalAutoCloseConfigurationLoaded;
}, __WEBPACK_IMPORTED_MODULE_1_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(null, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["k" /* withStateHandlers */])(function (_ref) {
  var globalAutoCloseConfiguration = _ref.globalAutoCloseConfiguration;

  var timeoutInMilliseconds = _.get(globalAutoCloseConfiguration, 'timeout', 10 * MINUTE);
  var unit = __WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["a" /* defaultUnit */](timeoutInMilliseconds);
  var humanizedTimeoutValue = parseInt(__WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["b" /* toHumanizedValue */](timeoutInMilliseconds, unit));

  return {
    isEnabled: _.get(globalAutoCloseConfiguration, 'isEnabled', false),
    timeoutUnit: unit,
    savedUnit: unit,
    timeoutValue: humanizedTimeoutValue,
    savedTimeout: humanizedTimeoutValue,
    filters: _.get(globalAutoCloseConfiguration, ['filters'], {})
  };
}, {
  setIsEnabled: function setIsEnabled(_ref2, _ref3) {
    var savedTimeout = _ref2.savedTimeout,
        savedUnit = _ref2.savedUnit,
        filters = _ref2.filters;
    var updateGlobalAutoCloseConfiguration = _ref3.updateGlobalAutoCloseConfiguration;
    return function (isEnabled) {
      updateGlobalAutoCloseConfiguration({
        isEnabled: isEnabled,
        timeout: __WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["c" /* toMilliseconds */](savedTimeout, savedUnit),
        filters: filters
      });

      return { isEnabled: isEnabled // Optimistic Update
      };
    };
  },
  setFilters: function setFilters(_ref4, _ref5) {
    var isEnabled = _ref4.isEnabled,
        filters = _ref4.filters,
        savedTimeout = _ref4.savedTimeout,
        savedUnit = _ref4.savedUnit;
    var updateGlobalAutoCloseConfiguration = _ref5.updateGlobalAutoCloseConfiguration;
    return function (newFilters) {
      var updatedFilters = {};
      _.merge(updatedFilters, filters, newFilters);

      updateGlobalAutoCloseConfiguration({
        isEnabled: isEnabled,
        timeout: __WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["c" /* toMilliseconds */](savedTimeout, savedUnit),
        filters: updatedFilters
      });

      return { filters: updatedFilters };
    };
  },
  setTimeoutUnit: function setTimeoutUnit() {
    return function (timeoutUnit) {
      return { timeoutUnit: timeoutUnit };
    };
  },
  setTimeoutValue: function setTimeoutValue() {
    return function (timeoutValue) {
      return { timeoutValue: parseInt(timeoutValue) };
    };
  },
  discardUnsavedChanged: function discardUnsavedChanged(_ref6) {
    var savedTimeout = _ref6.savedTimeout,
        savedUnit = _ref6.savedUnit;
    return function () {
      return { timeoutValue: savedTimeout, timeoutUnit: savedUnit };
    };
  },
  saveChanges: function saveChanges(_ref7, _ref8) {
    var isEnabled = _ref7.isEnabled,
        timeoutValue = _ref7.timeoutValue,
        timeoutUnit = _ref7.timeoutUnit,
        filters = _ref7.filters;
    var updateGlobalAutoCloseConfiguration = _ref8.updateGlobalAutoCloseConfiguration;
    return function () {
      updateGlobalAutoCloseConfiguration({
        isEnabled: isEnabled,
        timeout: __WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["c" /* toMilliseconds */](timeoutValue, timeoutUnit),
        filters: filters
      });
    };
  },
  handleGlobalAutoCloseConfigurationChange: function handleGlobalAutoCloseConfigurationChange(_ref9, _ref10) {
    var timeoutUnit = _ref9.timeoutUnit;
    var globalAutoCloseConfiguration = _ref10.globalAutoCloseConfiguration,
        onChangeSuccess = _ref10.onChangeSuccess;
    return function () {
      var timeoutInMilliseconds = _.get(globalAutoCloseConfiguration, 'timeout');
      var humanizedTimeoutValue = parseInt(__WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["b" /* toHumanizedValue */](timeoutInMilliseconds, timeoutUnit));

      onChangeSuccess();

      return {
        isEnabled: _.get(globalAutoCloseConfiguration, 'isEnabled', false),
        savedUnit: timeoutUnit,
        timeoutValue: humanizedTimeoutValue,
        savedTimeout: humanizedTimeoutValue,
        filters: _.get(globalAutoCloseConfiguration, 'filters', {})
      };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    hasUnsavedChanges: props.savedTimeout !== props.timeoutValue || props.savedUnit !== props.timeoutUnit,
    minTimeoutValue: Math.ceil(__WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["b" /* toHumanizedValue */](MINUTE, props.timeoutUnit)),
    maxTimeoutValue: Math.floor(__WEBPACK_IMPORTED_MODULE_6_components_DelayTime_utils__["b" /* toHumanizedValue */](WEEK, props.timeoutUnit)),
    exceedsLimitText: 'Cannot exceed ' + DAYS_IN_WEEK + ' days'
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.globalAutoCloseConfiguration, this.props.globalAutoCloseConfiguration)) {
      this.props.handleGlobalAutoCloseConfigurationChange();
    }
  }
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "d4Rx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d4mf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d76z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__("r8Ip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("D5Pz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);






var PageTitle = function PageTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Section__["a" /* SectionItem */], {
    title: title,
    description: description,
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.SettingsPageTitle, className)
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),

/***/ "dAuv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redirectWindow__ = __webpack_require__("aNG5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_logos_drift_svg__ = __webpack_require__("/SsX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_images_logos_drift_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_images_logos_drift_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_default_app_icon_svg__ = __webpack_require__("ceBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_images_svg_default_app_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_images_svg_default_app_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("TwmB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var orDefaultIconSrc = function orDefaultIconSrc(src) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["defaultTo"])(__WEBPACK_IMPORTED_MODULE_10_images_svg_default_app_icon_svg___default.a)(src);
};

var ExternalIntegrationInstallModal = function (_Component) {
  _inherits(ExternalIntegrationInstallModal, _Component);

  function ExternalIntegrationInstallModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ExternalIntegrationInstallModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExternalIntegrationInstallModal.__proto__ || Object.getPrototypeOf(ExternalIntegrationInstallModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isAuthorizing: false
    }, _this.openRedirectWindow = function () {
      var redirectWindow = window.open('', '_blank');
      Object(__WEBPACK_IMPORTED_MODULE_8__redirectWindow__["a" /* renderRedirectViewInWindow */])(redirectWindow);
      return redirectWindow;
    }, _this.authorizeApp = function () {
      var appId = _this.props.appId;
      var _this$props = _this.props,
          isAuthorizing = _this$props.isAuthorizing,
          notifications = _this$props.notifications,
          onAuthorized = _this$props.onAuthorized;


      if (isAuthorizing) return;

      var redirectWindow = _this.openRedirectWindow();
      var onDone = function onDone(_ref2) {
        var redirectUrl = _ref2.redirectUrl;

        redirectWindow.location = redirectUrl;
        _this.setState({ isAuthorizing: false }, onAuthorized);
      };

      var onError = function onError() {
        notifications.error('Ooops, something went wrong. Plese try again.');
        _this.setState({ isAuthorizing: false });
      };

      var onStateSet = function onStateSet() {
        return Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__["a" /* authorizeApp */])(appId).then(onDone).catch(onError);
      };

      _this.setState({ isAuthorizing: true }, onStateSet);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExternalIntegrationInstallModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          closeModal = _props.closeModal,
          appName = _props.appName,
          appIconSrc = _props.appIconSrc,
          scopes = _props.scopes;
      var isAuthorizing = this.state.isAuthorizing;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__["a" /* default */],
        {
          isOpen: isOpen,
          onRequestClose: closeModal,
          className: 'external-integration-install-modal' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'external-integration-install-modal-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'external-integration-install-modal-logos' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: orDefaultIconSrc(appIconSrc), alt: 'drift logo' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_9_images_logos_drift_svg___default.a, alt: 'app logo' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            { className: 'external-integration-install-modal-title' },
            'Install ',
            appName,
            ' to Drift'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__["a" /* default */],
            { condition: !Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["isEmpty"])(scopes) },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'external-integration-install-modal-description' },
              appName,
              ' would like these permissions in Drift'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'ul',
              { className: 'external-integration-install-modal-scopes' },
              scopes.map(function (scope, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  { key: index },
                  scope.description
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'external-integration-install-modal-buttons' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: 'drift-button drift-button-ternary',
                onClick: closeModal },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              {
                className: 'drift-button drift-button-primary external-integration-authorize-button',
                onClick: this.authorizeApp },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__["a" /* default */],
                { condition: !isAuthorizing },
                'Authorize App'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_components_shared_ConditionalRender__["a" /* default */],
                { condition: isAuthorizing },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_CircleOfWaiting__["a" /* default */], null)
              )
            )
          )
        )
      );
    }
  }]);

  return ExternalIntegrationInstallModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ExternalIntegrationInstallModal.propTypes = {
  onAuthorized: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  scopes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  appIconSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  appId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  appName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  closeModal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__["a" /* default */])(ExternalIntegrationInstallModal));

/***/ }),

/***/ "dF7v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("sHc2");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ParentNode = function (_Component) {
  _inherits(ParentNode, _Component);

  function ParentNode(props) {
    _classCallCheck(this, ParentNode);

    var _this = _possibleConstructorReturn(this, (ParentNode.__proto__ || Object.getPrototypeOf(ParentNode)).call(this, props));

    _this.state = {
      expanded: props.expanded
    };

    _this.toggleClick = _this.toggleClick.bind(_this);
    return _this;
  }

  _createClass(ParentNode, [{
    key: 'toggleClick',
    value: function toggleClick() {
      var onClick = this.props.onClick;


      onClick && onClick();
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          className = _props.className;
      var expanded = this.state.expanded;

      var nodes = Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* getChildNodes */])(this.props.nodes);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tc-subnav-node-group', { 'tc-subnav-node-group--collapsed': !expanded }, className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
          { className: 'tc-subnav-node-group-header', onClick: this.toggleClick },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
            { className: 'tc-subnav-node-group-toggle' },
            label,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { name: 'arrow-1-right', width: '8', height: '8' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
          { className: 'tc-subnav-node-group-drawer-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Div"],
            { className: 'tc-subnav-node-group-drawer' },
            nodes
          )
        )
      );
    }
  }]);

  return ParentNode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ParentNode);

/***/ }),

/***/ "dIjX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GlobalModal":"GlobalModal---2Ok_R","GlobalModalContent":"GlobalModalContent---2auUJ","GlobalModalButtonContainer":"GlobalModalButtonContainer---2N4BC"};

/***/ }),

/***/ "dJ8c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dot_fragment__ = __webpack_require__("7WJP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dot_fragment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dot_fragment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__ = __webpack_require__("TFJD");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var OutreachPayload = {
  client_id: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["I" /* OUTREACH_CLIENT_ID */],
  response_type: 'code',
  scope: 'prospects.all sequences.all sequenceStates.all mailboxes.all sequenceSteps.all',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/outreach'
};

var OutreachAuthUrl = 'https://accounts.outreach.io/oauth/authorize';

var Outreach = function (_Component) {
  _inherits(Outreach, _Component);

  function Outreach() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Outreach);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Outreach.__proto__ || Object.getPrototypeOf(Outreach)).call.apply(_ref, [this].concat(args))), _this), _this.onTabFocus = function (e) {
      _this.props.actions.fetchOutreachStatus();
      window.removeEventListener('focus', _this.onTabFocus);
    }, _this.componentDidUpdate = function (prevProps) {
      if (_this.props.isConnected === true && prevProps.isConnected === false) {
        _this.props.actions.fetchOutreachStatus();
        window.addEventListener('focus', _this.onTabFocus);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Outreach, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchOutreachStatus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isConnected = _props.isConnected,
          isDriftConnectedOnOutreachSide = _props.isDriftConnectedOnOutreachSide,
          orgId = _props.orgId;


      var isDriftConnectedOutreachDisconnected = isConnected && !isDriftConnectedOnOutreachSide;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ "outreach--is-halfway-connected": isDriftConnectedOutreachDisconnected }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: "outreach-paragraph" },
          'Connect your account to drive seamless conversations between chat and email! ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019505134-How-to-Connect-Drift-and-Outreach', target: '_blank', rel: 'noopener noreferrer' },
            ' Learn more '
          ),
          ' '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'outreach-list-item' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'outreach-list-item-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { width: 26, height: 24, name: 'chat-1' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'outreach-list-item-description' },
            'Continue the conversation from email and turn on ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { target: '_blank', rel: 'noopener noreferrer', href: '/playbooks/list/chat' },
              ' your Outbound Welcome Message Playbook'
            ),
            ' to automatically chat with people with people who click on your Outreach Sequence.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'outreach-list-item' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'outreach-list-item-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { width: 28, height: 24, name: 'user-check' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'outreach-list-item-description' },
            'When a Drift contact is enrolled, if they don\u2019t exist in your Outreach account yet, we\u2019ll automatically create a new prospect for you in Outreach with any contact attributes we have. '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'outreach-list-item' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'outreach-list-item-icon' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { width: 25, height: 24, name: 'fork-arrows' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'outreach-list-item-description' },
            'You can ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://accounts.outreach.io?pending[path]=triggers', rel: 'noopener noreferrer', target: '_blank' },
              ' customize your team\u2019s Outreach Triggers '
            ),
            ' to automatically take an action based on a Drift event. For example, when a new Drift conversation is started from a sequence, you can create an action to automatically unenroll that prospect. '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          isDriftConnectedOutreachDisconnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_dot_fragment___default.a,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'outreach-integration-subheadline' },
              ' Almost there! Connect your Drift account in Outreach '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'outreach-integration-copy' },
              ' To automatically unenroll contacts or create a task when a new Drift conversation is started, ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'outreach-integration-bold' },
                ' you must connect your Drift account in Outreach. '
              ),
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["ToolTip"],
              {
                flow: 'up',
                component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  'You must be an Admin in ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  ' Outreach to connect this ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  ' integration'
                ) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
                {
                  href: 'https://accounts.outreach.io/apps/drift',
                  type: 'primary',
                  target: '_blank',
                  icon: 'expand',
                  className: 'outreach-connect-button' },
                'Connect Drift in Outreach'
              )
            )
          ),
          !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'connect-container' },
            isDriftConnectedOnOutreachSide && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_dot_fragment___default.a,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'outreach-integration-subheadline outreach-integration-one-last-step' },
                ' One last step to complete your Drift and Outreach integration! '
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_IntegrationConnector__["a" /* default */], {
              integrationId: 'outreach',
              isOauth: true,
              oauthLink: OutreachAuthUrl,
              oauthQueryParams: _extends({}, OutreachPayload, {
                state: JSON.stringify({
                  isDriftConnectedOnOutreachSide: isDriftConnectedOnOutreachSide,
                  orgId: orgId
                })
              }),
              title: 'Connect Outreach',
              connectorType: 'button',
              buttonType: 'primary',
              className: 'outreach-integration-connector',
              tooltipText: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'You must be an Admin in ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                ' Outreach to connect this ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                ' integration'
              ) })
          )
        )
      );
    }
  }]);

  return Outreach;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isOutreachPending: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_selectors__["o" /* isOutreachStatusPending */](state),
    isDriftConnectedOnOutreachSide: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_selectors__["n" /* isOutreachConnected */](state),
    isIntegrationsPending: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_selectors__["b" /* connectionsFetchPending */](state) || __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_selectors__["e" /* connectionsUpdatePending */](state),
    orgId: __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__["orgId"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchOutreachStatus: __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__["p" /* fetchOutreachStatus */],
      fetchIntegrations: __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__["l" /* fetchIntegrationStates */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Outreach));

/***/ }),

/***/ "dJC7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchCalendarStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchGoogleCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchGoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchMicrosoftCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return microsoftAdminConsentAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchMicrosoftManagedCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return disconnectMicrosoftAdminConsent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateGoogleCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateMicrosoftCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disconnectGoogleCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return disconnectMicrosoftCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return googleOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return microsoftOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return zoomOauthAccept; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchMeetingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchCalendlyMeetingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return updateMeetingSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deleteMeetingType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return updateMeetingSettingsNewAppointments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return sendShareCalendarMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchConnectedCalendars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sendShareRoutedCalendarMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__("8Eel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("kk8i");






var fetchCalendarStatus = function fetchCalendarStatus() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/calendar/properties/status/v3').checkStatus().retryWithBackoff().map(function (_ref) {
    var response = _ref.response;

    return {
      connected: response.connected,
      calendar: Object(__WEBPACK_IMPORTED_MODULE_3__models__["c" /* Calendar */])(response.calendar),
      googleAuthed: response.googleAuthed,
      microsoftAuthed: response.microsoftAuthed,
      isTokenRevoked: response.tokenRevoked
    };
  });
};

var fetchGoogleCalendars = function fetchGoogleCalendars() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/google/calendar/calendars').checkStatus().retryWithBackoff().map(function (_ref2) {
    var response = _ref2.response;

    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(response).map(function (calendar) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__models__["c" /* Calendar */])(calendar);
    });
  });
};

var fetchGoogleScopes = function fetchGoogleScopes() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/google/calendar/oauth/scopes').checkStatus().retryWithBackoff().mapResponse(function (response) {
    return response;
  });
};

var fetchMicrosoftCalendars = function fetchMicrosoftCalendars() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/microsoft/calendar/calendars').checkStatus().retryWithBackoff().map(function (_ref3) {
    var response = _ref3.response;

    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(response).map(function (calendar) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__models__["c" /* Calendar */])(calendar);
    });
  });
};

var fetchMicrosoftAdminConsent = function fetchMicrosoftAdminConsent() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/microsoft/calendar/isManaged').checkStatus().mapResponse(function (response) {
    return response;
  });
};

var microsoftAdminConsentAccept = function microsoftAdminConsentAccept(tenant) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/microsoft/organization/calendar/oauth/accept', tenant).checkStatus().mapResponse(function (response) {
    return response;
  });
};

var fetchMicrosoftManagedCalendars = function fetchMicrosoftManagedCalendars() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/microsoft/calendar/managed/calendars/choose').checkStatus().retryWithBackoff().mapResponse(function (response) {
    return response;
  });
};

var disconnectMicrosoftAdminConsent = function disconnectMicrosoftAdminConsent() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/microsoft/calendar/managed/disconnect').checkStatus();
};

var updateGoogleCalendar = function updateGoogleCalendar(calendar) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/google/calendar/calendars/choose', calendar).checkStatus();
};

var updateMicrosoftCalendar = function updateMicrosoftCalendar(calendar) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/microsoft/calendar/calendars/choose', calendar).checkStatus();
};

var disconnectGoogleCalendar = function disconnectGoogleCalendar() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/google/calendar/disconnect').checkStatus();
};

var disconnectMicrosoftCalendar = function disconnectMicrosoftCalendar() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/microsoft/calendar/disconnect').checkStatus();
};

var googleOauthAccept = function googleOauthAccept(oauthCode) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/google/calendar/oauth/accept', {
    code: oauthCode
  }).checkStatus();
};

var microsoftOauthAccept = function microsoftOauthAccept(oauthCode) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/microsoft/calendar/oauth/accept', { code: oauthCode }).checkStatus();
};

var zoomOauthAccept = function zoomOauthAccept(oauthCode) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/zoom/oauth/accept', {
    code: oauthCode
  }).checkStatus();
};

var fetchMeetingSettings = function fetchMeetingSettings() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/scheduling/settings').checkStatus().retryWithBackoff().map(function (_ref4) {
    var response = _ref4.response;
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["f" /* makeMeeting */])(response);
  });
};

var fetchMeetingTypes = function fetchMeetingTypes() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/scheduling/settings/custom').checkStatus().retryWithBackoff().map(function (_ref5) {
    var response = _ref5.response;
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["g" /* makeMeetingTypes */])(response);
  });
};

var fetchCalendlyMeetingTypes = function fetchCalendlyMeetingTypes(apiKey) {
  return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].ajax({
    url: 'https://calendly.com/api/v1/users/me/event_types',
    method: 'GET',
    crossDomain: true,
    responseType: 'json',
    headers: { 'X-TOKEN': apiKey }
  }).map(function (res) {
    var meetingTypes = res.response.data;
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["h" /* processCalendlyMeetings */])(meetingTypes);
  });
};

var updateMeetingSettings = function updateMeetingSettings(meeting) {
  var queryPayload = meeting.oldSlug ? '?oldSlug=' + meeting.oldSlug : '';
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].put('/scheduling/settings' + (meeting.slug ? '/custom/' + meeting.slug : '') + queryPayload, {
    allowNewAppointments: meeting.allowNewAppointments,
    allowMeetingManagement: meeting.allowMeetingManagement,
    bufferTime: meeting.bufferTime,
    minimumNoticeTime: meeting.minimumNoticeTime,
    timezone: meeting.timezone,
    availability: meeting.availability.map(function (slot) {
      return {
        dayOfWeek: slot.dayOfWeek,
        startTimeHour: slot.startTime.hour,
        startTimeMinutes: slot.startTime.minutes,
        endTimeHour: slot.endTime.hour,
        endTimeMinutes: slot.endTime.minutes
      };
    }),
    meetingTemplate: {
      duration: meeting.duration,
      name: meeting.name,
      location: meeting.location,
      inviteDescription: meeting.inviteDescription
    }
  }).checkStatus().map(function (_ref6) {
    var response = _ref6.response;
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["f" /* makeMeeting */])(response);
  });
};

var deleteMeetingType = function deleteMeetingType(slug) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].delete('/scheduling/settings/custom/' + slug).checkStatus();
};

var updateMeetingSettingsNewAppointments = function updateMeetingSettingsNewAppointments(allowNewAppointments) {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].post('/scheduling/settings', {
    allowNewAppointments: allowNewAppointments
  }).checkStatus().map(function (_ref7) {
    var response = _ref7.response;
    return Object(__WEBPACK_IMPORTED_MODULE_3__models__["f" /* makeMeeting */])(response).allowNewAppointments;
  });
};

var sendShareCalendarMessage = function sendShareCalendarMessage(_ref8) {
  var agentId = _ref8.agentId,
      conversationId = _ref8.conversationId,
      _ref8$meetingSource = _ref8.meetingSource,
      meetingSource = _ref8$meetingSource === undefined ? __WEBPACK_IMPORTED_MODULE_4__constants__["_14" /* MeetingSource */].CALENDAR_DROP : _ref8$meetingSource;

  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMessagingAPI"].post('/conversations/' + conversationId + '/messages', {
    type: 'CHAT',
    attributes: {
      offerSchedule: agentId,
      meetingSource: meetingSource
    }
  }).checkStatus();
};

var fetchConnectedCalendars = function fetchConnectedCalendars() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxMeetingsAPI"].get('/scheduling/settings/connected').checkStatus().map(function (_ref9) {
    var response = _ref9.response;
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(response);
  });
};

var sendShareRoutedCalendarMessage = function sendShareRoutedCalendarMessage(_ref10) {
  var conversationId = _ref10.conversationId;

  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxConversationAPI"].post('/routed-calendar-drop?conversationId=' + conversationId, {}).checkStatus();
};

/***/ }),

/***/ "dLPI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dLe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InviteSelectUsers__ = __webpack_require__("Ipmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InviteSelectUsersAndTeams__ = __webpack_require__("H8TN");




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["a" /* branch */])(function (props) {
  return !!props.teams;
}, Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_2__InviteSelectUsersAndTeams__["a" /* default */]), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_1__InviteSelectUsers__["a" /* default */]))());

/***/ }),

/***/ "dMZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_CONVERSATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_CONVERSATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_CONVERSATION_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PATCH_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PATCH_CONVERSATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PATCH_CONVERSATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PATCH_CONVERSATION_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_PLAYBOOK_ID_FOR_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_CONVERSATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_CONVERSATION_LIST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_CONVERSATION_LIST_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_CONVERSATION_LIST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_CONVERSATION_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_NEXT_CONVERSATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_NEXT_CONVERSATION_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_CONVERSATIONS_FOR_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_CONVERSATIONS_FOR_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_CONVERSATIONS_FOR_END_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_CONVERSATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_CONVERSATION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return RECEIVE_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SET_ACTIVE_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UNSET_ACTIVE_CONVERSATION; });
/* unused harmony export ConversationStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONVERSATION_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONVERSATIONS_REGEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SEND_CONVERSATION_TRANSCRIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SEND_CONVERSATION_TRANSCRIPT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SEND_CONVERSATION_TRANSCRIPT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SET_COMPOSE_MODAL_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_ROUTING_AUDIT_LOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_ROUTING_AUDIT_LOG_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_ROUTING_AUDIT_LOG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_ROUTING_AUDIT_LOG_FAILED; });
/* unused harmony export ConversationSortByProperties */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SELECT_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DESELECT_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SELECT_CONVERSATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DESELECT_CONVERSATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DESELECT_ALL_CONVERSATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return MAX_SELECTED_CONVERSATIONS_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_CONVERSATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_CONVERSATION_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return SET_CONVERSATION_LIMIT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_CONVERSATION_LIMIT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SET_CONVERSATION_LIMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FETCH_SUGGESTED_ARTICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_SUGGESTED_ARTICLES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCH_SUGGESTED_ARTICLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCH_SUGGESTED_ARTICLES_FAILED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('conversation');

var FETCH_CONVERSATION = makeConstant('FETCH_CONVERSATION');
var FETCH_CONVERSATION_PENDING = makeConstant('FETCH_CONVERSATION_PENDING');
var FETCH_CONVERSATION_FAILED = makeConstant('FETCH_CONVERSATION_FAILED');
var FETCH_CONVERSATION_CANCELLED = makeConstant('FETCH_CONVERSATION_CANCELLED');

var PATCH_CONVERSATION = makeConstant('PATCH_CONVERSATION');
var PATCH_CONVERSATION_PENDING = makeConstant('PATCH_CONVERSATION_PENDING');
var PATCH_CONVERSATION_FAILED = makeConstant('PATCH_CONVERSATION_FAILED');
var PATCH_CONVERSATION_CANCELLED = makeConstant('PATCH_CONVERSATION_CANCELLED');

var SET_PLAYBOOK_ID_FOR_CONVERSATION = makeConstant('SET_PLAYBOOK_ID_FOR_CONVERSATION');

var FETCH_CONVERSATION_LIST = makeConstant('FETCH_CONVERSATION_LIST');
var FETCH_CONVERSATION_LIST_PENDING = makeConstant('FETCH_CONVERSATION_LIST_PENDING');
var FETCH_CONVERSATION_LIST_CANCELLED = makeConstant('FETCH_CONVERSATION_LIST_CANCELLED');
var FETCH_CONVERSATION_LIST_FAILED = makeConstant('FETCH_CONVERSATION_LIST_FAILED');
var FETCH_CONVERSATION_LIST_SUCCESS = makeConstant('FETCH_CONVERSATION_LIST_SUCCESS');
var FETCH_NEXT_CONVERSATION_LIST = makeConstant('FETCH_NEXT_CONVERSATION_LIST');
var FETCH_NEXT_CONVERSATION_LIST_SUCCESS = makeConstant('FETCH_NEXT_CONVERSATION_LIST_SUCCESS');

var FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID');
var FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING');
var FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED');
var FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS');

var FETCH_CONVERSATIONS_FOR_END_USER = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER');
var FETCH_CONVERSATIONS_FOR_END_USER_PENDING = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_PENDING');
var FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS');
var FETCH_CONVERSATIONS_FOR_END_USER_FAILURE = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_FAILURE');

var CREATE_CONVERSATION = makeConstant('CREATE_CONVERSATION');
var CREATE_CONVERSATION_PENDING = makeConstant('CREATE_CONVERSATION_PENDING');
var CREATE_CONVERSATION_FAILED = makeConstant('CREATE_CONVERSATION_FAILED');

var RECEIVE_CONVERSATION = makeConstant('RECEIVE_CONVERSATION');

var SET_ACTIVE_CONVERSATION = makeConstant('SET_CURRENT_CONVERSATION');
var UNSET_ACTIVE_CONVERSATION = makeConstant('UNSET_ACTIVE_CONVERSATION');
var ConversationStatus = Object.freeze({
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  CLOSED: 'CLOSED'
});

var SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX = makeConstant('SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX');

var CONVERSATION_CHANGED = makeConstant('CONVERSATION_CHANGED');
var CONVERSATIONS_REGEX = /inboxes\/(\d+)\/conversations\/?(\d+)?/;

var SEND_CONVERSATION_TRANSCRIPT = makeConstant('SEND_CONVERSATION_TRANSCRIPT');
var SEND_CONVERSATION_TRANSCRIPT_SUCCESS = makeConstant('SEND_CONVERSATION_TRANSCRIPT_SUCCESS');
var SEND_CONVERSATION_TRANSCRIPT_FAILURE = makeConstant('SEND_CONVERSATION_TRANSCRIPT_FAILURE');

var SET_QUERY = makeConstant('SET_QUERY');
var SET_COMPOSE_MODAL_STATUS = makeConstant('SET_COMPOSE_MODAL_STATUS');

var FETCH_ROUTING_AUDIT_LOG = makeConstant('FETCH_ROUTING_AUDIT_LOG');
var FETCH_ROUTING_AUDIT_LOG_PENDING = makeConstant('FETCH_ROUTING_AUDIT_LOG_PENDING');
var FETCH_ROUTING_AUDIT_LOG_SUCCESS = makeConstant('FETCH_ROUTING_AUDIT_LOG_SUCCESS');
var FETCH_ROUTING_AUDIT_LOG_FAILED = makeConstant('FETCH_ROUTING_AUDIT_LOG_FAILED');

var ConversationSortByProperties = Object.freeze({
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
  LONGEST_WAITING: 'Longest Waiting'
});

var SELECT_CONVERSATION = makeConstant('SELECT_CONVERSATION');
var DESELECT_CONVERSATION = makeConstant('DESELECT_CONVERSATION');
var SELECT_CONVERSATIONS = makeConstant('SELECT_CONVERSATIONS');
var DESELECT_CONVERSATIONS = makeConstant('DESELECT_CONVERSATIONS');
var DESELECT_ALL_CONVERSATIONS = makeConstant('DESELECT_ALL_CONVERSATIONS');

var MAX_SELECTED_CONVERSATIONS_COUNT = 25;

var UPDATE_CONVERSATIONS = makeConstant('UPDATE_CONVERSATIONS');

var SET_CONVERSATION_LIMIT = makeConstant('SET_CONVERSATION_LIMIT');
var SET_CONVERSATION_LIMIT_PENDING = makeConstant('SET_CONVERSATION_LIMIT_PENDING');
var SET_CONVERSATION_LIMIT_FAILURE = makeConstant('SET_CONVERSATION_LIMIT_FAILURE');
var SET_CONVERSATION_LIMIT_SUCCESS = makeConstant('SET_CONVERSATION_LIMIT_SUCCESS');

var FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION');
var FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING');
var FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE');
var FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS');

var UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION');
var UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING');
var UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE');
var UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS');

var FETCH_SUGGESTED_ARTICLES = makeConstant('FETCH_SUGGESTED_ARTICLES');
var FETCH_SUGGESTED_ARTICLES_PENDING = makeConstant('FETCH_SUGGESTED_ARTICLES_PENDING');
var FETCH_SUGGESTED_ARTICLES_SUCCESS = makeConstant('FETCH_SUGGESTED_ARTICLES_SUCCESS');
var FETCH_SUGGESTED_ARTICLES_FAILED = makeConstant('FETCH_SUGGESTED_ARTICLES_FAILED');

/***/ }),

/***/ "dMja":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/rule.e08d4373.png";

/***/ }),

/***/ "dO+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactabular__ = __webpack_require__("QDzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactabular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reactabular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_reply_ReplyEditDropDown__ = __webpack_require__("879Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_StripHTMLFromText__ = __webpack_require__("W71x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_settings_reply_ReplyTable_styl__ = __webpack_require__("ItLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_settings_reply_ReplyTable_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styles_components_settings_reply_ReplyTable_styl__);











var ReplyTable = React.createClass({
  displayName: 'ReplyTable',


  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  },

  onReplyClick: function onReplyClick(reply) {
    if (!this.state.selectedReplyToEdit) {
      var path = '/settings/replies/compose/' + reply.id;
      return this.context.router.push(path);
    }
  },
  onEditOptionsClick: function onEditOptionsClick(reply, event) {
    event.stopPropagation();
    return this.setState({
      selectedReplyToEdit: reply
    });
  },
  onDeleteReply: function onDeleteReply(replyId) {
    this.props.onDeleteReply(replyId);
    return this.setState({ selectedReplyToEdit: null });
  },
  renderEditDropDownForReply: function renderEditDropDownForReply(reply) {
    var _this = this;

    return React.createElement(__WEBPACK_IMPORTED_MODULE_5_components_settings_reply_ReplyEditDropDown__["a" /* default */], {
      replyId: reply.id,
      onClickOutside: function onClickOutside() {
        return _this.setState({ selectedReplyToEdit: false });
      },
      onDelete: this.onDeleteReply.bind(this) });
  },
  getColumns: function getColumns() {
    var _this2 = this;

    return [{
      property: 'name',
      header: 'Preview',
      cell: function cell(value, data, rowIndex) {
        var reply = data[rowIndex];
        return React.createElement(
          'div',
          { className: 'preview' },
          React.createElement(
            'div',
            { className: 'name' },
            reply.name
          ),
          React.createElement('div', {
            className: 'text',
            dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_6_shared_web_src_helpers_StripHTMLFromText__["a" /* stripHTMLFromText */])(reply.text) } })
        );
      }
    },
    // TODO add tags when ready
    {
      property: 'updatedAt',
      header: 'Last Used',
      cell: function cell(value) {
        return React.createElement(
          'div',
          { className: 'last-used' },
          __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).fromNow()
        );
      }
    }, {
      cell: function cell(value, data, rowIndex) {
        var reply = data[rowIndex];
        var isSelected = _this2.state.selectedReplyToEdit === reply;
        return React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('edit', { selected: isSelected }) },
          React.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, {
            className: 'ignore-react-onclickoutside',
            src: __webpack_require__("N4Vs"),
            onClick: _this2.onEditOptionsClick.bind(_this2, reply) }),
          isSelected ? _this2.renderEditDropDownForReply(reply) : undefined
        );
      }
    }];
  },
  getHeader: function getHeader() {
    var _this3 = this;

    return {
      onClick: function onClick(column) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_reactabular__["sortColumn"])(_this3.state.columns, column, _this3.setState.bind(_this3));
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      columns: this.getColumns(),
      header: this.getHeader()
    };
  },
  render: function render() {
    var _this4 = this;

    var data = __WEBPACK_IMPORTED_MODULE_2_reactabular__["sortColumn"].sort(this.props.replies, this.state.sortingColumn, _.orderBy);
    return React.createElement(
      'div',
      { className: 'ReplyTable' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_2_reactabular__["Table"], {
        columns: this.state.columns,
        data: data,
        columnNames: this.state.header,
        row: function row(reply) {
          return {
            onClick: _this4.onReplyClick.bind(_this4, reply)
          };
        } })
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ReplyTable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "dOkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("QXt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_AudienceOption_style__ = __webpack_require__("tLAg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_AudienceOption_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_AudienceOption_style__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.









var SegmentOptionRow = React.createClass({
  displayName: 'SegmentOptionRow',
  getCreatorName: function getCreatorName() {
    if (this.props.author) {
      return this.props.author.name || this.props.author.email;
    } else {
      return '';
    }
  },
  getSegmentUserCount: function getSegmentUserCount() {
    // TODO get user count for segment
    return 9999;
  },
  renderCountSection: function renderCountSection() {
    var count = this.getSegmentUserCount();
    return React.createElement(
      'div',
      { className: 'end-user-count' },
      React.createElement(
        'div',
        { className: 'count-value' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
          className: 'user-icon',
          src: __webpack_require__("PK+e") }),
        count
      ),
      count > 1 ? 'Users' : 'User'
    );
  },
  renderCampaignType: function renderCampaignType() {
    var authorName = this.getCreatorName();
    if (this.props.segment.type === 'ID_LIST') {
      return [React.createElement(
        'div',
        { className: 'type-icon-wrapper static' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
          className: 'type-icon',
          src: __webpack_require__("VIJZ") })
      ), authorName ? 'static segment created by ' + authorName : undefined];
    } else {
      return [React.createElement(
        'div',
        { className: 'type-icon-wrapper' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
          className: 'type-icon',
          src: __webpack_require__("bZrC") })
      ), 'dynamic segment created by ' + authorName];
    }
  },
  render: function render() {
    // TODO detemine if the campaign is temp
    var isTemp = false;
    return React.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a['campaign-segment-option'], __WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_AudienceOption_style___default.a.AudienceOption) },
      React.createElement(
        'div',
        { className: 'segment-name-and-type' },
        React.createElement(
          'div',
          { className: 'dsg-Body' },
          this.props.segment.name
        ),
        React.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('type', this.props.segment.type, __WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_AudienceOption_style___default.a.AudienceOption_Label) },
          !isTemp ? this.renderCampaignType() : undefined
        )
      )
    );
  }
  // TODO render this when we have count
  // @renderCountSection()

});

Marty.createContainer(SegmentOptionRow, {
  listenTo: ['stores.UserStore'],

  fetch: {
    author: function author() {
      return this.app.stores.UserStore.getOrFetchUser(this.props.segment.authorId);
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SegmentOptionRow);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "dQ2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__ = __webpack_require__("u1z1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetricsMapping__ = __webpack_require__("0t1x");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function mapStateToProps(state) {
  return {
    sfdcMetricMappings: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["b" /* getSFDCMetricMappings */])(state),
    sfdcPatchMetricsLoading: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["d" /* getSFDCPatchMetricsLoading */])(state),
    sfdcPatchMetricsErr: Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_selectors__["c" /* getSFDCPatchMetricsErr */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__, { fetchSFDCMetricsMappings: __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__["fetchSFDCMetricsMappings"] }), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__MetricsMapping__["a" /* default */]));

/***/ }),

/***/ "dR61":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_ConversationTypes__ = __webpack_require__("+lmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__ = __webpack_require__("b3Ti");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var READABLE_MESSAGE_TYPES = [__WEBPACK_IMPORTED_MODULE_3_utils_ConversationTypes__["a" /* default */].CHAT, __WEBPACK_IMPORTED_MODULE_3_utils_ConversationTypes__["a" /* default */].EMAIL, __WEBPACK_IMPORTED_MODULE_3_utils_ConversationTypes__["a" /* default */].PRIVATE_NOTE, __WEBPACK_IMPORTED_MODULE_3_utils_ConversationTypes__["a" /* default */].PRIVATE_PROMPT];

var lastMessageByConversationId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__["J" /* receiveConversation */], function (state, action) {
  var _action$payload$conve = action.payload.conversation,
      id = _action$payload$conve.id,
      sentAt = _action$payload$conve.lastSentMessageTimestamp,
      readAt = _action$payload$conve.lastReadMessageTimestamp;


  return state.withMutations(function (state) {
    if (sentAt) {
      var prevSentAt = state.getIn([id, 'sentAt']);
      if (!prevSentAt || prevSentAt < sentAt) {
        state.setIn([id, 'sentAt'], sentAt);
      }
    }

    if (readAt) {
      var prevReadAt = state.getIn([id, 'readAt']);
      if (!prevReadAt || prevReadAt < readAt) {
        state.setIn([id, 'readAt'], readAt);
      }
    }
  });
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__["m" /* fetchConversationListSuccess */], __WEBPACK_IMPORTED_MODULE_4_app_modules_conversation_actions__["x" /* fetchNextConversationListSuccess */]), function (state, action) {
  var conversations = action.payload.paginatedConversations.data;


  return state.withMutations(function (state) {
    conversations.forEach(function (conversation) {
      var id = conversation.id,
          sentAt = conversation.lastSentMessageTimestamp,
          readAt = conversation.lastReadMessageTimestamp;


      if (sentAt) {
        var prevSentAt = state.getIn([id, 'sentAt']);
        if (!prevSentAt || prevSentAt < sentAt) {
          state.setIn([id, 'sentAt'], sentAt);
        }
      }

      if (readAt) {
        var prevReadAt = state.getIn([id, 'readAt']);
        if (!prevReadAt || prevReadAt < readAt) {
          state.setIn([id, 'readAt'], readAt);
        }
      }
    });
  });
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__["u" /* receiveFirstMessages */], __WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__["y" /* receivePaginatedMessageList */], __WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__["x" /* receiveNextMessageList */]), function (state, action) {
  var _action$payload = action.payload,
      messages = _action$payload.messages,
      conversationId = _action$payload.conversationId;


  var latestReadableMessage = messages.reduce(function (latestReadableMessage, currentMessage) {
    return READABLE_MESSAGE_TYPES.includes(currentMessage.type) && (!latestReadableMessage || latestReadableMessage.createdAt < currentMessage.createdAt) && currentMessage;
  });

  return state.withMutations(function (state) {
    if (latestReadableMessage) {
      var sentAt = latestReadableMessage.createdAt;
      var readAt = latestReadableMessage.viewerRecipientStatus === 'Read' && latestReadableMessage.createdAt;

      var prevSentAt = state.getIn([conversationId, 'sentAt']);
      if (!prevSentAt || prevSentAt < sentAt) {
        state.setIn([conversationId, 'sentAt'], sentAt);
      }

      if (readAt) {
        var prevReadAt = state.getIn([conversationId, 'readAt']);
        if (!prevReadAt || prevReadAt < readAt) {
          state.setIn([conversationId, 'readAt'], readAt);
        }
      }
    }
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__["v" /* receiveMessage */], function (state, action) {
  var _action$payload2 = action.payload,
      message = _action$payload2.message,
      conversationId = _action$payload2.conversationId;


  return state.withMutations(function (state) {
    var isReadableMessage = READABLE_MESSAGE_TYPES.includes(message.type);

    if (isReadableMessage) {
      var sentAt = message.createdAt;

      var prevSentAt = state.getIn([conversationId, 'sentAt']);
      if (!prevSentAt || prevSentAt < sentAt) {
        state.setIn([conversationId, 'sentAt'], sentAt);
      }
    }
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5_app_modules_message_actions__["s" /* optimisticMessageReadSuccess */], function (state, action) {
  var _action$payload3 = action.payload,
      readAt = _action$payload3.messageCreatedAt,
      conversationId = _action$payload3.conversationId;


  return state.withMutations(function (state) {
    var prevReadAt = state.getIn([conversationId, 'readAt']);
    if (!prevReadAt || prevReadAt < readAt) {
      state.setIn([conversationId, 'readAt'], readAt);
    }
  });
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  lastMessageByConversationId: lastMessageByConversationId
}));

/***/ }),

/***/ "dTHV":
/***/ (function(module, exports) {

module.exports = "data:image/x-icon;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI1MjFjNTgxYmZkZGYzYjA2MGVkMzk4NDEwOGVkZjk1OC5pY28iOw=="

/***/ }),

/***/ "dUGx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_components_Integration_components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("nFdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var PardotIntegrationPage = function (_Component) {
    _inherits(PardotIntegrationPage, _Component);

    function PardotIntegrationPage(props) {
        _classCallCheck(this, PardotIntegrationPage);

        var _this = _possibleConstructorReturn(this, (PardotIntegrationPage.__proto__ || Object.getPrototypeOf(PardotIntegrationPage)).call(this, props));

        _this.getSalesforcePayload = function () {

            return {
                state: JSON.stringify({ 'businessUnitId': _this.state.businessUnitId, 'orgId': _this.props.orgId, 'userId': _this.props.userId }),
                client_id: __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["O" /* SALESFORCE_CLIENT_ID */],
                response_type: 'code',
                redirect_uri: __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["a" /* API_URL */] + '/integration/pardot/install-integration-via-oauth'
            };
        };

        _this.handleChangeBusinessUnitIdInput = function (e) {
            _this.setState({
                businessUnitId: e.target.value
            });
        };

        _this.state = {
            businessUnitId: null
        };
        return _this;
    }

    _createClass(PardotIntegrationPage, [{
        key: 'render',
        value: function render() {
            var isConnected = this.props.data.installed;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pardot-integration-page' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'integration-page-description' },
                    'Using Pardot? Seamlessly add Drift in to your existing workflow. With our integration you\u2019ll enrich your team\u2019s Drift experience by syncing Pardot contact information and pushing Drift leads into Pardot.'
                ),
                !isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'pardot-sso-button' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Input"], { className: 'pardot-input', label: 'Business Unit Id', placeholder: 'Business Unit Id', onChange: this.handleChangeBusinessUnitIdInput }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__scripts_components_Integration_components_IntegrationConnector__["a" /* default */], {
                        onIntegrationConnected: this.props.onClickSSO,
                        integrationId: 'Pardot',
                        isOauth: true,
                        oauthLink: 'https://login.salesforce.com/services/oauth2/authorize',
                        title: 'Log in with Salesforce',
                        connectorType: 'button',
                        buttonType: 'primary',
                        oauthQueryParams: this.getSalesforcePayload(),
                        logLoginFail: true,
                        isDisabled: !!!this.state.businessUnitId
                    })
                ),
                isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
                    { to: '/settings/pardot/config', className: 'integration-config-link' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        { className: 'integration-section-title' },
                        'Synced Pardot Data'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Choose which data is sent between Pardot and Drift.'
                    )
                ),
                isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
                    { to: '/settings/pardot/mapping/attributes', className: 'integration-config-link' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'h2',
                        { className: 'integration-section-title' },
                        'Mapped Pardot Attributes'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        'Map which fields you want to sync between Drift and Pardot.'
                    )
                ),
                isConnected && __WEBPACK_IMPORTED_MODULE_10_utils_Access__["c" /* default */].hasGates('HAS_PARDOT_SYNC_LIST') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'integration-config-section' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h2',
                            { className: 'integration-section-title' },
                            'Import Lists from Pardot'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            null,
                            'Sync Pardot Lists into Drift to use as segments.'
                        )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Button"],
                        { type: 'tertiary', href: '/contacts/imports', target: '_blank' },
                        'Go to Imports'
                    )
                ),
                isConnected && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
                    { to: '/settings/pardot/event-log', className: 'integration-config-link' },
                    'View Pardot Event Log'
                )
            );
        }
    }]);

    return PardotIntegrationPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PardotIntegrationPage.contextTypes = {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        orgId: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["orgId"](state),
        userId: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUserId"](state)
    };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(PardotIntegrationPage)));

/***/ }),

/***/ "dUcK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__WarningModal__ = __webpack_require__("4hbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_Application__ = __webpack_require__("08hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("S2Kx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logos_office_365_svg__ = __webpack_require__("Qb1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_images_logos_office_365_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_images_logos_office_365_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var APP = Object(__WEBPACK_IMPORTED_MODULE_13_app_Application__["b" /* getApplication */])();

var MICROSOFT_OAUTH_BASE_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';

var MicrosoftOAuthConnect = function (_Component) {
  _inherits(MicrosoftOAuthConnect, _Component);

  function MicrosoftOAuthConnect(props) {
    _classCallCheck(this, MicrosoftOAuthConnect);

    var _this = _possibleConstructorReturn(this, (MicrosoftOAuthConnect.__proto__ || Object.getPrototypeOf(MicrosoftOAuthConnect)).call(this, props));

    _this.getCalendarConnectionSource = function () {
      var params = new URL(window.location).searchParams;
      return params.get('source') || 'organic';
    };

    _this.trackEvent = function (name, attributes) {
      _this.props.actions.track(name, _extends({
        context: 'settings',
        service: 'microsoft-calendar'
      }, attributes));
    };

    _this.handlePostMessage = function (e) {
      var track = _this.props.actions.track;

      var success = e.data.status === 'success';

      if (success) {
        _this.setState({ pending: false }, function () {
          APP.actions.NotificationActions.pushNotification({
            content: 'Your Office 365 account was successfully connected.'
          });
          track('Calendar Connected', { context: 'settings', source: _this.getCalendarConnectionSource() });
          _this.trackEvent('Calendar Setup', { action: 'connected' });
          _this.props.actions.fetchCalendarStatus();
        });
      } else {
        _this.setState({ pending: false }, function () {
          APP.actions.NotificationActions.pushNotification({
            content: 'Your calendar may already be connected to a different Drift account. Please review your Office 365 app permissions.',
            variant: 'red',
            sticky: true
          });
        });
      }
    };

    _this.handleConnectClick = function () {
      _this.setState({
        pending: true
      });

      var params = {
        response_type: 'code',
        response_mode: 'query',
        redirect_uri: __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/office-365-calendar',
        client_id: __WEBPACK_IMPORTED_MODULE_14_constants_ResourcesConstants__["G" /* MICROSOFT_CALENDAR_CLIENT_ID */],
        scope: 'openid profile offline_access User.Read Calendars.ReadWrite'
      };

      Object(__WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__["b" /* popUp */])({
        path: MICROSOFT_OAUTH_BASE_URL + '?' + Object(__WEBPACK_IMPORTED_MODULE_11_utils_Helpers__["d" /* encodeQueryData */])(params),
        onMessage: _this.handlePostMessage
      });
    };

    _this.handleUpdateCalendar = function () {
      var selectedCalendarId = _this.getSelectedCalendarId();
      if (selectedCalendarId && selectedCalendarId !== _this.props.calendar.id) {
        var calendar = _this.props.calendars.find(function (calendar) {
          return calendar.id === selectedCalendarId;
        });
        _this.props.actions.updateCalendar(calendar);
        _this.trackEvent('Calendar Setup', { action: 'updated-calendar-id', selectedCalendarId: selectedCalendarId });
      }
    };

    _this.handleSaveClick = function (_ref) {
      var calId = _ref.calId;
      var _this$props = _this.props,
          onSave = _this$props.onSave,
          calendars = _this$props.calendars,
          actions = _this$props.actions;

      var selectedCalendarId = !!calId ? calId : _this.getSelectedCalendarId();
      var calendar = calendars.find(function (calendar) {
        return calendar.id === selectedCalendarId;
      });
      if (!!calendar) {
        actions.updateCalendar(calendar);
        _this.trackEvent('Calendar Setup', { action: 'updated-calendar', selectedCalendarId: selectedCalendarId });
        window.drift && window.drift.on('ready', function (api) {
          api.setUserAttributes({ first_calendar_connect: true });
        });
        !!onSave && onSave();
      }
    };

    _this.handleShowDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: true
      });
    };

    _this.handleHideDisconnectModal = function () {
      _this.setState({
        showDisconnectModal: false
      });
    };

    _this.handleDisconnectClick = function (e) {
      var disconnectCallback = _this.props.disconnectCallback;

      e.preventDefault();

      _this.setState({
        calendarId: undefined
      }, function () {
        _this.props.actions.disconnectCalendar();
        _this.trackEvent('Calendar Setup', { action: 'disconnected' });
        !!disconnectCallback && disconnectCallback();
      });
    };

    _this.handleCalendarSelect = function (_ref2) {
      var value = _ref2.value;
      var autoSaveSelect = _this.props.autoSaveSelect;

      _this.setState({
        calendarId: value
      }, function () {
        autoSaveSelect && _this.handleSaveClick({ calId: value });
      });
    };

    _this.getSelectedCalendarId = function () {
      if (_this.state.calendarId) {
        return _this.state.calendarId;
      }

      if (_this.props.calendar.id) {
        return _this.props.calendar.id;
      }

      if (!_this.props.calendars.isEmpty()) {
        return _this.props.calendars.first().id;
      }
    };

    _this.handleHelpdocLink = function () {
      window.location.href = 'https://help.drift.com/integrations/office-365-calendar-support';
    };

    _this.renderDisabledSelect = function () {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select_plus__["b" /* default */], { value: { label: '', key: 0 }, disabled: true, searchable: false, clearable: false, options: [] });
    };

    _this.renderCalendarSelect = function () {
      var _this$props2 = _this.props,
          calendars = _this$props2.calendars,
          isLoading = _this$props2.isLoading,
          hasCalendars = _this$props2.hasCalendars,
          withDisconnect = _this$props2.withDisconnect;
      var showDisconnectModal = _this.state.showDisconnectModal;


      if (isLoading) {
        return _this.renderDisabledSelect();
      }

      if (!isLoading && !hasCalendars) {
        return React.createElement(
          'div',
          { className: 'subtle-calendar-connect-error' },
          'No calendars found.',
          ' ',
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
            { type: 'danger', size: 'small', onClick: _this.handleHelpdocLink },
            'Check Compatibility'
          )
        );
      }

      var selectedCalendarId = _this.getSelectedCalendarId();
      return React.createElement(
        'div',
        { className: 'minimal-ui' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select_plus__["b" /* default */], {
          value: selectedCalendarId,
          searchable: false,
          clearable: false,
          placeholder: 'Pick a calendar to connect...',
          options: calendars.map(function (calendar) {
            return { value: calendar.id, label: calendar.name };
          }).toArray(),
          onChange: _this.handleCalendarSelect
        }),
        withDisconnect && React.createElement(
          'button',
          { className: 'tide-button medium utility-button minimal-ui-disconnect', onClick: _this.handleShowDisconnectModal },
          'Disconnect'
        ),
        withDisconnect && showDisconnectModal && React.createElement(__WEBPACK_IMPORTED_MODULE_7__WarningModal__["a" /* default */], {
          handleCloseModal: _this.handleHideDisconnectModal,
          handleDisconnect: _this.handleDisconnectClick
        })
      );
    };

    _this.state = {
      pending: false,
      showDisconnectModal: false
    };
    return _this;
  }

  _createClass(MicrosoftOAuthConnect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var calendars = this.props.calendars;


      if (calendars.size === 1) {
        this.handleSaveClick({ calId: calendars.getIn([0, 'id']) });
      }
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var _props = this.props,
          pending = _props.pending,
          buttonLabel = _props.buttonLabel;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
        {
          type: 'primary',
          style: { marginLeft: 'auto' },
          onClick: this.handleConnectClick,
          disabled: pending
        },
        pending ? React.createElement(
          'div',
          { className: 'flex flex-center' },
          'Connecting ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_shared_web_src_components_Loading__["a" /* default */], { style: { marginLeft: '0.5rem' }, size: 'small' })
        ) : buttonLabel || 'Connect'
      );
    }
  }, {
    key: 'renderNotConnected',
    value: function renderNotConnected() {
      var minimalUI = this.props.minimalUI;


      if (minimalUI) {
        return this.renderButton();
      }

      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_15__style_styl___default.a.OAuthConnect },
        React.createElement(
          'div',
          { className: 'media-object' },
          React.createElement(
            'div',
            { className: 'service-icon' },
            React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_16_images_logos_office_365_svg___default.a, alt: 'office 365 logo' })
          ),
          React.createElement(
            'div',
            { className: 'service-info media-body' },
            React.createElement(
              'div',
              { className: 'service-name' },
              'Office 365 Calendar'
            ),
            React.createElement(
              'div',
              { className: 'service-description' },
              'Allows Drift to check your Office 365 Calendar for conflicts and add events to it.'
            )
          ),
          React.createElement(
            'div',
            { style: { marginLeft: 'auto', paddingLeft: '1.5rem' } },
            this.renderButton()
          )
        )
      );
    }
  }, {
    key: 'renderConnected',
    value: function renderConnected() {
      var _props2 = this.props,
          microsoftAuthed = _props2.microsoftAuthed,
          minimalUI = _props2.minimalUI,
          buttonLabel = _props2.buttonLabel,
          title = _props2.title,
          _props2$withDisconnec = _props2.withDisconnect,
          withDisconnect = _props2$withDisconnec === undefined ? false : _props2$withDisconnec,
          _props2$autoSaveSelec = _props2.autoSaveSelect,
          autoSaveSelect = _props2$autoSaveSelec === undefined ? false : _props2$autoSaveSelec,
          hideIcon = _props2.hideIcon;


      if (minimalUI) {
        return this.renderCalendarSelect();
      }

      var showDisconnectModal = this.state.showDisconnectModal;

      var selectedCalendarId = this.getSelectedCalendarId();
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_15__style_styl___default.a.OAuthConnect },
        !hideIcon && React.createElement(
          'div',
          { className: 'service-icon' },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_16_images_logos_office_365_svg___default.a, alt: 'office 365 logo' })
        ),
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("service-info media-body", { 'hide-icon': hideIcon }) },
          !hideIcon && React.createElement(
            'div',
            { className: 'service-name' },
            !!title ? title : 'Office 365 Calendar'
          ),
          React.createElement(
            'div',
            { className: 'drift-form' },
            React.createElement(
              'div',
              { className: 'calendar-selector-wrapper' },
              React.createElement(
                'div',
                { className: 'calendar-select-inner' },
                this.renderCalendarSelect()
              ),
              withDisconnect && React.createElement(
                __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
                {
                  type: 'danger',
                  size: 'small',
                  disabled: !microsoftAuthed,
                  onClick: this.handleShowDisconnectModal
                },
                'Disconnect'
              ),
              !autoSaveSelect && React.createElement(
                __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
                {
                  type: 'primary',
                  onClick: this.handleSaveClick,
                  disabled: !selectedCalendarId
                },
                !!buttonLabel ? buttonLabel : 'Save'
              )
            )
          )
        ),
        withDisconnect && showDisconnectModal && React.createElement(__WEBPACK_IMPORTED_MODULE_7__WarningModal__["a" /* default */], {
          handleCloseModal: this.handleHideDisconnectModal,
          handleDisconnect: this.handleDisconnectClick
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.microsoftAuthed ? this.renderConnected() : this.renderNotConnected();
    }
  }]);

  return MicrosoftOAuthConnect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

function mapStateToProps(state) {
  var calendarFetchCompleted = Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["z" /* isMicrosoftCalendarsFetchCompleted */])(state);
  return {
    microsoftAuthed: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["i" /* getIsMicrosoftOauthConnected */])(state),
    calendar: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["b" /* getCalendar */])(state),
    calendars: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["e" /* getCalendars */])(state),
    hasCalendars: calendarFetchCompleted && Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["e" /* getCalendars */])(state).size > 0,
    isLoading: !calendarFetchCompleted
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["r" /* fetchCalendarStatus */],
      updateCalendar: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["_35" /* updateMicrosoftCalendar */],
      disconnectCalendar: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["n" /* disconnectMicrosoftCalendar */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_9_app_modules_meetings_actions__["_23" /* updateMeetingSettings */],
      track: __WEBPACK_IMPORTED_MODULE_10_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MicrosoftOAuthConnect));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "dZQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("rx5m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var RadioOption = function RadioOption(_ref) {
  var className = _ref.className,
      style = _ref.style,
      children = _ref.children,
      selected = _ref.selected,
      onClick = _ref.onClick;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.RadioOption, className), style: style },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("empty-circle", { selected: selected }), onClick: onClick },
      selected && React.createElement('div', { className: 'circle' })
    ),
    React.createElement(
      'div',
      { className: 'flex-1' },
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (RadioOption);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "dZeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var OrgConstants = Marty.createConstants(['ORG_CREATE', 'ORG_FETCH', 'ORG_UPDATE', 'INVITE_TO_ORG', 'SHARE_SNIPPET', 'RESEND_INVITE', 'ADD_BILLING_INFO', 'USER_CREATE_WITH_EMAIL']);

/* harmony default export */ __webpack_exports__["a"] = (OrgConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "de+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Customize_OrgSettings_Constants__ = __webpack_require__("hHSs");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var FontPicker = function (_Component) {
  _inherits(FontPicker, _Component);

  function FontPicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FontPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FontPicker.__proto__ || Object.getPrototypeOf(FontPicker)).call.apply(_ref, [this].concat(args))), _this), _this.renderFont = function (_ref2) {
      var label = _ref2.label,
          value = _ref2.value;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('body-font', value) },
        label
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FontPicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          fontFamily = _props.fontFamily,
          onSelection = _props.onSelection;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__["b" /* default */], {
        value: fontFamily,
        options: __WEBPACK_IMPORTED_MODULE_4_components_Customize_OrgSettings_Constants__["a" /* FONT_FAMILY_OPTIONS */],
        onSelection: onSelection,
        optionRenderer: this.renderFont,
        valueRenderer: this.renderFont
      });
    }
  }]);

  return FontPicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

FontPicker.propTypes = {
  fontFamily: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (FontPicker);

/***/ }),

/***/ "deK3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TimeSelect":"TimeSelect---2v5s_"};

/***/ }),

/***/ "dfnn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Wrapper---Cx4nP","SliderPreviewsWrapper":"SliderPreviewsWrapper---2ZVHt","Label":"Label---1rhq4","Content":"Content---1_gZJ","TakeoverContent":"TakeoverContent---KYaCm","TakeoverPreview":"TakeoverPreview---3veYw","WelcomeMessagePreview":"WelcomeMessagePreview---3vhqp","SliderPreview":"SliderPreview---FfiFN","PreviewEnter":"PreviewEnter---CkmCr","PreviewLeave":"PreviewLeave---zjn4z"};

/***/ }),

/***/ "dgdp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return teams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("YWXU");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var teams = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* fetchOrgTeamsSuccess */], function (state, action) {
  return state.set('data', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["F" /* patchOrgTeamSuccess */], function (state, action) {
  var _action$payload = action.payload,
      teamId = _action$payload.teamId,
      team = _action$payload.team;

  var restTeams = state.get('data').filter(function (team) {
    return team.id !== teamId;
  });
  return state.set('data', [].concat(_toConsumableArray(restTeams), [team]));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* deleteOrgTeam */], function (state, _ref) {
  var payload = _ref.payload;

  return state.set('data', state.get('data').filter(function (team) {
    return team.id !== payload.teamId;
  }));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* fetchTeamAvailabilitiesSuccess */], function (state, action) {
  return state.set('teamAvailabilities', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["J" /* updateAvailabilityForTeamSuccess */], function (state, action) {
  var teamAvailabilitySettings = action.payload.teamAvailabilitySettings;

  var restAvailabilities = state.get('teamAvailabilities').filter(function (ta) {
    return ta.id !== teamAvailabilitySettings.id;
  });
  return state.set('teamAvailabilities', [].concat(_toConsumableArray(restAvailabilities), [teamAvailabilitySettings]));
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* fetchOrgTeamsFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* fetchOrgTeamsPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* fetchOrgTeamsSuccess */]), function (state, action) {
  return state.setIn(['status', 'fetch'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* createOrgTeamFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* createOrgTeamPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* createOrgTeamSuccess */]), function (state, action) {
  return state.setIn(['status', 'create'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["D" /* patchOrgTeamFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["E" /* patchOrgTeamPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["F" /* patchOrgTeamSuccess */]), function (state, action) {
  return state.setIn(['status', 'update'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* deleteOrgTeamFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* deleteOrgTeamPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* deleteOrgTeamSuccess */]), function (state, action) {
  return state.setIn(['status', 'delete'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["H" /* updateAvailabilityForTeamFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["I" /* updateAvailabilityForTeamPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["J" /* updateAvailabilityForTeamSuccess */]), function (state, action) {
  return state.setIn(['status', 'updateAvailabilityForTeam'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* fetchTeamAvailabilitiesFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* fetchTeamAvailabilitiesPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* fetchTeamAvailabilitiesSuccess */]), function (state, action) {
  return state.setIn(['status', 'fetchAllAvailabilities'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["v" /* fetchTeamAvailabilityFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* fetchTeamAvailabilityPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* fetchTeamAvailabilitySuccess */]), function (state, action) {
  return state.setIn(['status', 'fetchSingleAvailability'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* createTeamAvailabilityFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* createTeamAvailabilityPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* createTeamAvailabilitySuccess */]), function (state, action) {
  return state.setIn(['status', 'createTeamAvailability'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["L" /* updateTeamAvailabilityFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["M" /* updateTeamAvailabilityPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["N" /* updateTeamAvailabilitySuccess */]), function (state, action) {
  return state.setIn(['status', 'updateTeamAvailability'], action.type);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

/***/ }),

/***/ "dgt1":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "dhv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ActionConstants__ = __webpack_require__("h6+o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ConversationConstants__ = __webpack_require__("pIAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__ = __webpack_require__("9eSk");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var EndUserStore = Marty.createStore({
  id: 'EndUserStore',
  LAST_ES_FETCH_ID: '',

  getInitialState: function getInitialState() {
    return {
      endUsersById: __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS({}),
      searchResults: {},
      endUserUpdateStateById: __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(),
      endUserUnsubscribeStateById: __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(),
      elasticSearchResults: {},
      endUserTimeLineById: {},
      endUserSegmentsById: {}
    };
  },
  rehydrate: function rehydrate(dehydratedState) {
    dehydratedState.endUserUpdateStateById = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(dehydratedState.endUserUpdateStateById);
    dehydratedState.endUsersById = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(dehydratedState.endUsersById);
    return this.state = dehydratedState;
  },


  handlers: {
    refreshEndUsers: __WEBPACK_IMPORTED_MODULE_1_constants_ActionConstants__["default"].REFRESH_ALL_PLZ,
    fetchEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_FETCH_DONE,
    fetchEndUserListDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_LIST_FETCH_DONE,

    fetchEndUsersDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USERS_FETCH_DONE,
    fetchEndUserSegmentsDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_SEGMENTS_FETCH_DONE,

    createEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].CREATE_USER_FOR_ORG_ID_DONE,
    setEndUserFromPusher: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].SET_END_USER_FROM_PUSHER,
    updatingEndUser: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_STARTING,
    updateEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_DONE,
    unsubscribeEndUserStarting: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_STARTING,
    unsubscribeEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_DONE,

    searchEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].SEARCH_END_USER_DONE,
    searchConversationsDone: __WEBPACK_IMPORTED_MODULE_2_constants_ConversationConstants__["a" /* default */].SEARCH_ALL_CONVERSATIONS_DONE,
    elasticSearchEndUserDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].ELASTIC_SEARCH_END_USER_DONE,

    fetchEndUserAttributesDone: __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_ATTRIBUTES_FETCH_DONE,

    deleteEndUsersDone: [__WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_DONE, __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_BULK_DONE]
  },

  refreshEndUsers: function refreshEndUsers() {
    // This should already be fetched, no good way to do this right now
    var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
    return this.app.queries.EndUserQueries.fetchRecentEndUsers(orgId);
  },
  getEndUserSegments: function getEndUserSegments(endUserId) {
    if (endUserId > 0) {
      return this.state.endUserSegmentsById[endUserId];
    } else {
      return false;
    }
  },
  fetchEndUserSegmentsDone: function fetchEndUserSegmentsDone(endUserId, endUserSegments) {
    return this.setState({
      endUserSegmentsById: _extends({}, this.state.endUserSegmentsById, _defineProperty({}, endUserId, endUserSegments))
    });
  },
  searchEndUserDone: function searchEndUserDone(orgId, query, searchResult) {
    var searchResults = _.cloneDeep(this.state.searchResults);
    searchResults[query] = searchResult;
    this.setState({ searchResults: searchResults });
    return this.fetchEndUsers(_.map(searchResult, function (item) {
      return item._source.id;
    }));
  },


  // We lazily look up end users here in response to conversation searches
  // because we need the state from this store to de-dupe lookups.
  searchConversationsDone: function searchConversationsDone(query, searchResult) {
    return this.fetchEndUsers(_.map(searchResult, function (item) {
      return item._source.endUserId;
    }));
  },
  getSearchQuery: function getSearchQuery(searchQuery) {
    var query = _.cloneDeep(searchQuery || {});
    return query;
  },
  fetchLastElasticSearchResults: function fetchLastElasticSearchResults() {
    return this.state.elasticSearchResults[this.LAST_ES_FETCH_ID];
  },
  fetchElasticSearchResult: function fetchElasticSearchResult(query, from, size, sortField, sortDirection) {
    var transFormedQuery = this.getSearchQuery(query);
    var fetchId = this.generateElasticSearchCacheId(transFormedQuery, from, size, sortField, sortDirection);
    return this.fetch({
      id: 'fetchElasticSearchResult' + fetchId,
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        return this.state.elasticSearchResults[fetchId];
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.EndUserQueries.elasticSearchEndUser(orgId, transFormedQuery, from, size, sortField, sortDirection);
      }
    });
  },
  generateElasticSearchCacheId: function generateElasticSearchCacheId(query, from, size, sortField, sortDirection) {
    var sizeQuery = {};
    if (from != null) {
      sizeQuery.from = from;
    }
    if (size != null) {
      sizeQuery.size = size;
    }
    var sortQuery = {};
    if (sortField != null) {
      sortQuery.sortField = sortField;
    }
    if (sortDirection != null) {
      sortQuery.sortDirection = sortDirection;
    }
    return '' + JSON.stringify(query) + JSON.stringify(sizeQuery) + JSON.stringify(sortQuery);
  },
  elasticSearchEndUserDone: function elasticSearchEndUserDone(orgId, query, from, size, sortField, sortDirection, searchResult) {
    var fetchId = this.generateElasticSearchCacheId(query, from, size, sortField, sortDirection);
    this.LAST_ES_FETCH_ID = fetchId;
    var elasticSearchResults = _.assign({}, this.state.elasticSearchResults);
    elasticSearchResults[fetchId] = searchResult;
    return this.setState({ elasticSearchResults: elasticSearchResults });
  },
  getSearchResults: function getSearchResults() {
    return this.state.searchResults;
  },
  resetSearchResults: function resetSearchResults() {
    return this.setState({ searchResults: {} });
  },
  resetElasticSearchResults: function resetElasticSearchResults() {
    return this.setState({ elasticSearchResults: {} });
  },
  fetchEndUserListDone: function fetchEndUserListDone(endUsers) {
    var endUsersById = this.state.endUsersById;

    _.each(endUsers, function (endUser) {
      return endUsersById = endUsersById.set(endUser.id, endUser);
    });
    return this.setState({ endUsersById: endUsersById });
  },
  fetchEndUsersDone: function fetchEndUsersDone(endUsers) {
    return this.fetchEndUserListDone(endUsers);
  },
  getEndUsersById: function getEndUsersById() {
    return this.state.endUsersById.toJS();
  },
  getEndUser: function getEndUser(endUserId) {
    if (endUserId > 0) {
      return this.state.endUsersById.get(endUserId);
    } else {
      return false;
    }
  },
  getOrFetchEndUser: function getOrFetchEndUser(endUserId) {
    return this.fetch({
      id: 'fetchEndUser' + endUserId,
      locally: function locally() {
        return this.getEndUser(endUserId);
      },
      remotely: function remotely() {
        return this.app.queries.EndUserQueries.fetchEndUser(endUserId);
      }
    });
  },
  fetchEndUserDone: function fetchEndUserDone(endUserID, endUser) {
    return this.setEndUser(endUser);
  },
  fetchEndUserForConversation: function fetchEndUserForConversation(conversationId) {
    return this.fetch({
      id: 'fetchEndUserForConversation' + conversationId,
      dependsOn: this.app.stores.ConversationStore.getOrFetchConversation(conversationId),
      locally: function locally() {
        var conversation = this.app.stores.ConversationStore.getConversationById(conversationId);
        return this.getEndUser(conversation.endUserId);
      },
      remotely: function remotely() {
        var conversation = this.app.stores.ConversationStore.getConversationById(conversationId);
        return this.app.queries.EndUserQueries.fetchEndUser(conversation.endUserId);
      }
    });
  },
  unfetchedEndUserIds: function unfetchedEndUserIds(endUserIds) {
    var _this = this;

    return _.filter(endUserIds, function (endUserId) {
      return _this.state.endUsersById.get(endUserId) == null;
    });
  },
  fetchEndUsers: function fetchEndUsers(endUserIds) {
    var id = 'fetchEndUserForConversation' + endUserIds;
    var unfetchedEndUserIds = this.unfetchedEndUserIds(endUserIds);
    return this.fetch({
      id: id,
      locally: function locally() {
        if (_.isEmpty(unfetchedEndUserIds) || this.hasAlreadyFetched(id)) {
          return _.pick(this.state.endUsersById.toJS(), endUserIds);
        }
      },
      remotely: function remotely() {
        return this.app.queries.EndUserQueries.fetchEndUsers(unfetchedEndUserIds);
      }
    });
  },
  fetchEndUserAttributes: function fetchEndUserAttributes() {
    return this.fetch({
      id: 'fetchEndUserAttributes',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchEndUserAttributes')) {
          return this.state.attributes;
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.EndUserQueries.fetchEndUserAttributesForOrg(orgId);
      }
    });
  },
  fetchEndUserAttributesDone: function fetchEndUserAttributesDone(attributes) {
    attributes.properties.push({ name: 'tags', displayName: 'Drift Tags', type: 'TAGS' });
    attributes.events = _.sortBy(attributes.events, function (attribute) {
      return attribute.displayName;
    });
    attributes.properties = _.sortBy(attributes.properties, function (attribute) {
      return attribute.displayName;
    });
    return this.setState({ attributes: attributes });
  },
  createEndUserDone: function createEndUserDone(endUser) {
    return this.setEndUser(endUser);
  },
  deleteEndUsersDone: function deleteEndUsersDone(endUserIds) {
    var endUsersById = this.state.endUsersById;

    _.each(endUserIds, function (endUserId) {
      return endUsersById = endUsersById.delete(endUserId);
    });
    this.setState({ endUsersById: endUsersById });
    // wait for ES cluster to catch up and invalidate the search cache to get new ones
    return setTimeout(this.resetElasticSearchResults.bind(this), 5000);
  },
  setEndUserFromPusher: function setEndUserFromPusher(endUser) {
    if (_.isEmpty(endUser)) {
      return;
    }
    return this.setEndUser(endUser);
  },
  updateEndUser: function updateEndUser(endUserId, endUserParams) {
    return this.app.queries.EndUserQueries.updateEndUser(endUserId, endUserParams);
  },
  updateEndUserDone: function updateEndUserDone(endUser) {
    var endUserUpdateStateById = this.state.endUserUpdateStateById.set(endUser.id.toString(), __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_DONE);
    this.setState({ endUserUpdateStateById: endUserUpdateStateById });
    return this.setEndUser(endUser);
  },
  unsubscribeEndUserStarting: function unsubscribeEndUserStarting(endUserId) {
    var endUserUnsubscribeStateById = this.state.endUserUnsubscribeStateById.set(endUserId, __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_STARTING);
    return this.setState({ endUserUnsubscribeStateById: endUserUnsubscribeStateById });
  },
  unsubscribeEndUserDone: function unsubscribeEndUserDone(endUserId) {
    var endUserUnsubscribeStateById = this.state.endUserUnsubscribeStateById.set(endUserId, __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_DONE);
    return this.setState({ endUserUnsubscribeStateById: endUserUnsubscribeStateById });
  },
  updatingEndUser: function updatingEndUser(endUserId) {
    var endUserUpdateStateById = this.state.endUserUpdateStateById.set(endUserId, __WEBPACK_IMPORTED_MODULE_3_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_STARTING);
    return this.setState({ endUserUpdateStateById: endUserUpdateStateById });
  },
  getEndUserUpdateStateById: function getEndUserUpdateStateById(endUserId) {
    return this.state.endUserUpdateStateById.get(endUserId);
  },
  getEndUserUnsubscribeStateById: function getEndUserUnsubscribeStateById(endUserId) {
    return this.state.endUserUnsubscribeStateById.get(endUserId);
  },
  setEndUser: function setEndUser(endUser) {
    var endUsersById = this.state.endUsersById.set(endUser.id, endUser);
    return this.setState({ endUsersById: endUsersById });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "diFG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allowedIntegrations; });
var allowedIntegrations = ['salesforce', 'hubspot', 'marketo', 'eloqua', 'pardot'];

/***/ }),

/***/ "dk5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_navigation_close_svg__ = __webpack_require__("bQUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_navigation_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_images_navigation_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("jv4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);











var KEYWORD_OPTIONS = [{
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_125" /* KeywordType */].FUZZY,
  label: 'Similar to'
}, {
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_125" /* KeywordType */].CONTAINS,
  label: 'Contains'
}, {
  value: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_125" /* KeywordType */].EQUALS,
  label: 'Equals'
}];

var Keyword = function Keyword(_ref) {
  var onDeleteClick = _ref.onDeleteClick,
      onTextChange = _ref.onTextChange,
      _ref$keyword = _ref.keyword,
      special = _ref$keyword.special,
      text = _ref$keyword.text,
      type = _ref$keyword.type,
      onTypeChange = _ref.onTypeChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-keyword', 'flex', 'drift-form') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_UISelect__["b" /* default */], {
      disabled: special,
      value: KEYWORD_OPTIONS.find(function (_ref2) {
        var value = _ref2.value;
        return value === type;
      }),
      options: KEYWORD_OPTIONS,
      onChange: onTypeChange
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'text',
      className: 'flex-1',
      onChange: onTextChange,
      disabled: special,
      required: true,
      value: text
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
      className: 'playbook-keyword-delete-icon',
      src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_navigation_close_svg___default.a,
      onClick: onDeleteClick
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Keyword);

/***/ }),

/***/ "dlfT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SEGMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_SEGMENT_LIST_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SEGMENT_LIST_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RECEIVE_SEGMENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SEGMENT_SET_CARDINALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SEGMENT_SET_CARDINALITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SEGMENT_SET_CARDINALITY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SEGMENT_SET_CARDINALITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_END_USER_MEMBERSHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_END_USER_MEMBERSHIP_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_END_USER_MEMBERSHIP_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_END_USER_MEMBERSHIP_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('segment');

var FETCH_SEGMENT_LIST = makeConstant('FETCH_SEGMENT_LIST');
var FETCH_SEGMENT_LIST_PENDING = makeConstant('FETCH_SEGMENT_LIST_PENDING');
var FETCH_SEGMENT_LIST_FAILED = makeConstant('FETCH_SEGMENT_LIST_FAILED');
var RECEIVE_SEGMENT_LIST = makeConstant('RECEIVE_SEGMENT_LIST');

var FETCH_SEGMENT_SET_CARDINALITY = makeConstant('FETCH_SEGMENT_SET_CARDINALITY');
var FETCH_SEGMENT_SET_CARDINALITY_PENDING = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_PENDING');
var FETCH_SEGMENT_SET_CARDINALITY_FAILED = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_FAILED');
var FETCH_SEGMENT_SET_CARDINALITY_SUCCESS = makeConstant('FETCH_SEGMENT_SET_CARDINALITY_SUCCESS');

var FETCH_END_USER_MEMBERSHIP = makeConstant('FETCH_END_USER_MEMBERSHIP');
var FETCH_END_USER_MEMBERSHIP_PENDING = makeConstant('FETCH_END_USER_MEMBERSHIP_PENDING');
var FETCH_END_USER_MEMBERSHIP_FAILED = makeConstant('FETCH_END_USER_MEMBERSHIP_FAILED');
var FETCH_END_USER_MEMBERSHIP_SUCCESS = makeConstant('FETCH_END_USER_MEMBERSHIP_SUCCESS');

/***/ }),

/***/ "dtTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("rSFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);






var PageTitle = function PageTitle(_ref) {
  var title = _ref.title,
      description = _ref.description,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Section__["a" /* SectionItem */], {
    title: title,
    description: description,
    className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style___default.a.SettingsPageTitle, className)
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PageTitle);

/***/ }),

/***/ "dyHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("rAlQ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



var initialState = {
  sfdcProperties: [],
  sfdcMappings: [],
  sfdcMetricMappings: [],
  conversationMetrics: {},
  sfdcTaskFields: [],
  sfdcUsers: [],
  sfdcUserMappings: [],
  sfdcUserMappingsError: null,
  sfdcMappingsErr: null,
  sfdcPatchLoading: false,
  sfdcUserMappingLoading: false,
  sfdcAttributesErr: null,
  sfdcObjectList: [],
  sfdcObjectListErr: null,
  sfdcAccountFieldsList: [],
  sfdcContactFieldsList: [],
  sfdcLeadFieldsList: [],
  sfdcFieldsListErr: null,
  sfdcLeadRoutingSettings: [],
  sfdcLeadRoutingSettingsErr: null,
  enrichment: {},
  sfdcEnrichmentFields: [],
  sfdcEnrichmentFieldsErr: null
};

var sortedByStatic = function sortedByStatic(mappings) {
  return _.sortBy(mappings, function (mapping) {
    return !mapping.static;
  });
};
var deDupe = function deDupe(arr) {
  return Array.from(new Set(arr.map(JSON.stringify))).map(JSON.parse);
};

var sfdcMappings = function sfdcMappings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var enrichment = state.enrichment;

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* FETCH_SFDC_USERS_SUCCESS */]:
      return _extends({}, state, { sfdcUserMappingLoading: false, sfdcUsers: deDupe([].concat(_toConsumableArray(state.sfdcUsers), _toConsumableArray(action.users))) });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["I" /* PATCH_SFDC_USER_MAPPINGS_SUCCESS */]:
      return _extends({}, state, { sfdcUserMappingPatchLoading: false, sfdcUserMappings: action.mappings });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["H" /* PATCH_SFDC_USER_MAPPINGS_FAILED */]:
      return _extends({}, state, { sfdcUserMappingsError: action.err, sfdcUserMappingPatchLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FETCH_SFDC_USER_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {
        sfdcUserMappings: action.mappings,
        sfdcUsers: _.merge(state.sfdcUsers, action.users)
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* PATCH_SFDC_METRIC_MAPPINGS_SUCCESS */]:
      return _extends({}, state, { sfdcPatchMetricsLoading: false, sfdcMetricMappings: action.mappings });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* PATCH_SFDC_METRIC_MAPPINGS_ERROR */]:
      return _extends({}, state, { sfdcPatchMetricsLoading: false, sfdcPatchMetricsErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["q" /* FETCH_SFDC_METRIC_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {
        sfdcMetricMappings: action.mappings
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["F" /* PATCH_SFDC_METRIC_MAPPINGS_START */]:
      return _extends({}, state, { sfdcPatchMetricsLoading: true });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS */]:
      return _extends({}, state, { sfdcTaskFields: action.properties });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* FETCH_SFDC_TASK_ATTRIBUTES_ERROR */]:
      return _extends({}, state, { sfdcAttributesErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_METRICS_LIST_SUCCESS */]:
      return _extends({}, state, { conversationMetrics: action.list });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_METRICS_LIST_ERROR */]:
      return _extends({}, state, { conversationMetrics: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_SFDC_ATTRIBUTES_SUCCESS */]:
      return _extends({}, state, { sfdcProperties: action.properties });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* FETCH_SFDC_ATTRIBUTES_ERROR */]:
      return _extends({}, state, { sfdcAttributesErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* FETCH_SFDC_MAPPINGS_SUCCESS */]:
      return _extends({}, state, { mappings: action.mappings,
        useCountryAcronyms: action.useCountryAcronyms,
        useStateAcronyms: action.useStateAcronyms,
        allowAttributeDefaults: action.allowAttributeDefaults,
        createContactOnCaseCreation: action.createContactOnCaseCreation
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* FETCH_SFDC_MAPPINGS_ERROR */]:
      return _extends({}, state, { sfdcMappingsErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* PATCH_SFDC_MAPPINGS_SUCCESS */]:
      return _extends({}, state, {

        sfdcMappings: sortedByStatic(action.mappings),
        sfdcMappingsErr: null,
        sfdcPatchLoading: false
      });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* PATCH_SFDC_MAPPINGS_ERROR */]:
      return _extends({}, state, { sfdcMappingsErr: action.err, sfdcPatchLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* PATCH_SFDC_MAPPINGS_START */]:
      return _extends({}, state, { sfdcPatchLoading: true });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* FETCH_SFDC_USERS_START */]:
      return _extends({}, state, { sfdcUserMappingLoading: true });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* FETCH_SFDC_USERS_ERROR */]:
      return _extends({}, state, { sfdcUserMappingLoading: false });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* FETCH_SFDC_OBJECT_LIST_SUCCESS */]:
      return _extends({}, state, { sfdcObjectList: action.objects });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* FETCH_SFDC_OBJECT_LIST_ERROR */]:
      return _extends({}, state, { sfdcObjectListErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_SFDC_FIELD_LIST_SUCCESS */]:
      switch (action.fieldType) {
        case __WEBPACK_IMPORTED_MODULE_0__constants__["J" /* SFDC_ACCOUNT_FIELDS */]:
          return _extends({}, state, { sfdcAccountFieldsList: action.fields });
        case __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* SFDC_CONTACT_FIELDS */]:
          return _extends({}, state, { sfdcContactFieldsList: action.fields });
        case __WEBPACK_IMPORTED_MODULE_0__constants__["L" /* SFDC_LEAD_FIELDS */]:
          return _extends({}, state, { sfdcLeadFieldsList: action.fields });
        default:
          return action.fieldType;
      }

    case __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* FETCH_SFDC_FIELD_LIST_ERROR */]:
      return _extends({}, state, { sfdcFieldsListErr: [action.fieldType, action.err] });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS */]:
      return _extends({}, state, { sfdcLeadRoutingSettings: action.settings });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR */]:
      return _extends({}, state, { sfdcLeadRoutingSettingsErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FETCH_SALESFORCE_ENRICHMENT_STARTED */]:
      enrichment[action.key] = {
        loading: true,
        error: {},
        data: {}
      };
      return _extends({}, state, { enrichment: enrichment });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FETCH_SALESFORCE_ENRICHMENT_FAILED */]:
      enrichment[action.key] = {
        loading: false,
        error: action.err,
        data: {}
      };
      return _extends({}, state, { enrichment: enrichment });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FETCH_SALESFORCE_ENRICHMENT_SUCCESS */]:
      enrichment[action.key] = {
        loading: false,
        error: {},
        data: action.data
      };
      return _extends({}, state, { enrichment: enrichment });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS */]:
      return _extends({}, state, { sfdcEnrichmentFields: action.fields });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_SFDC_ENRICHMENT_FIELDS_ERROR */]:
      return _extends({}, state, { sfdcEnrichmentFieldsErr: action.err });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS */]:
      return _extends({}, state, { sfdcEnrichmentFields: action.fields });

    case __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* PATCH_SFDC_ENRICHMENT_FIELDS_ERROR */]:
      return _extends({}, state, { sfdcEnrichmentFieldsErr: action.err });

    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (sfdcMappings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "dzDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IsoToCountriesNames; });
var IsoToCountriesNames = {
  'AF': 'Afghanistan',
  'AX': 'Aland Islands',
  'AL': 'Albania',
  'DZ': 'Algeria',
  'AS': 'American Samoa',
  'AD': 'Andorra',
  'AO': 'Angola',
  'AI': 'Anguilla',
  'AQ': 'Antarctica',
  'AG': 'Antigua And Barbuda',
  'AR': 'Argentina',
  'AM': 'Armenia',
  'AW': 'Aruba',
  'AU': 'Australia',
  'AT': 'Austria',
  'AZ': 'Azerbaijan',
  'BS': 'Bahamas',
  'BH': 'Bahrain',
  'BD': 'Bangladesh',
  'BB': 'Barbados',
  'BY': 'Belarus',
  'BE': 'Belgium',
  'BZ': 'Belize',
  'BJ': 'Benin',
  'BM': 'Bermuda',
  'BT': 'Bhutan',
  'BO': 'Bolivia',
  'BA': 'Bosnia And Herzegovina',
  'BW': 'Botswana',
  'BV': 'Bouvet Island',
  'BR': 'Brazil',
  'IO': 'British Indian Ocean Territory',
  'BN': 'Brunei Darussalam',
  'BG': 'Bulgaria',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodia',
  'CM': 'Cameroon',
  'CA': 'Canada',
  'CV': 'Cape Verde',
  'KY': 'Cayman Islands',
  'CF': 'Central African Republic',
  'TD': 'Chad',
  'CL': 'Chile',
  'CN': 'China',
  'CX': 'Christmas Island',
  'CC': 'Cocos (Keeling) Islands',
  'CO': 'Colombia',
  'KM': 'Comoros',
  'CG': 'Congo',
  'CD': 'Congo, Democratic Republic',
  'CK': 'Cook Islands',
  'CR': 'Costa Rica',
  'CI': 'Cote D\'Ivoire',
  'HR': 'Croatia',
  'CU': 'Cuba',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'DK': 'Denmark',
  'DJ': 'Djibouti',
  'DM': 'Dominica',
  'DO': 'Dominican Republic',
  'EC': 'Ecuador',
  'EG': 'Egypt',
  'SV': 'El Salvador',
  'GQ': 'Equatorial Guinea',
  'ER': 'Eritrea',
  'EE': 'Estonia',
  'ET': 'Ethiopia',
  'FK': 'Falkland Islands (Malvinas)',
  'FO': 'Faroe Islands',
  'FJ': 'Fiji',
  'FI': 'Finland',
  'FR': 'France',
  'GF': 'French Guiana',
  'PF': 'French Polynesia',
  'TF': 'French Southern Territories',
  'GA': 'Gabon',
  'GM': 'Gambia',
  'GE': 'Georgia',
  'DE': 'Germany',
  'GH': 'Ghana',
  'GI': 'Gibraltar',
  'GR': 'Greece',
  'GL': 'Greenland',
  'GD': 'Grenada',
  'GP': 'Guadeloupe',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GG': 'Guernsey',
  'GN': 'Guinea',
  'GW': 'Guinea-Bissau',
  'GY': 'Guyana',
  'HT': 'Haiti',
  'HM': 'Heard Island & Mcdonald Islands',
  'VA': 'Holy See (Vatican City State)',
  'HN': 'Honduras',
  'HK': 'Hong Kong',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IN': 'India',
  'ID': 'Indonesia',
  'IR': 'Iran, Islamic Republic Of',
  'IQ': 'Iraq',
  'IE': 'Ireland',
  'IM': 'Isle Of Man',
  'IL': 'Israel',
  'IT': 'Italy',
  'JM': 'Jamaica',
  'JP': 'Japan',
  'JE': 'Jersey',
  'JO': 'Jordan',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KI': 'Kiribati',
  'KR': 'Korea',
  'KW': 'Kuwait',
  'KG': 'Kyrgyzstan',
  'LA': 'Lao People\'s Democratic Republic',
  'LV': 'Latvia',
  'LB': 'Lebanon',
  'LS': 'Lesotho',
  'LR': 'Liberia',
  'LY': 'Libyan Arab Jamahiriya',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MO': 'Macao',
  'MK': 'Macedonia',
  'MG': 'Madagascar',
  'MW': 'Malawi',
  'MY': 'Malaysia',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malta',
  'MH': 'Marshall Islands',
  'MQ': 'Martinique',
  'MR': 'Mauritania',
  'MU': 'Mauritius',
  'YT': 'Mayotte',
  'MX': 'Mexico',
  'FM': 'Micronesia, Federated States Of',
  'MD': 'Moldova',
  'MC': 'Monaco',
  'MN': 'Mongolia',
  'ME': 'Montenegro',
  'MS': 'Montserrat',
  'MA': 'Morocco',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibia',
  'NR': 'Nauru',
  'NP': 'Nepal',
  'NL': 'Netherlands',
  'AN': 'Netherlands Antilles',
  'NC': 'New Caledonia',
  'NZ': 'New Zealand',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigeria',
  'NU': 'Niue',
  'NF': 'Norfolk Island',
  'MP': 'Northern Mariana Islands',
  'NO': 'Norway',
  'OM': 'Oman',
  'PK': 'Pakistan',
  'PW': 'Palau',
  'PS': 'Palestinian Territory, Occupied',
  'PA': 'Panama',
  'PG': 'Papua New Guinea',
  'PY': 'Paraguay',
  'PE': 'Peru',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Poland',
  'PT': 'Portugal',
  'PR': 'Puerto Rico',
  'QA': 'Qatar',
  'RE': 'Reunion',
  'RO': 'Romania',
  'RU': 'Russian Federation',
  'RW': 'Rwanda',
  'BL': 'Saint Barthelemy',
  'SH': 'Saint Helena',
  'KN': 'Saint Kitts And Nevis',
  'LC': 'Saint Lucia',
  'MF': 'Saint Martin',
  'PM': 'Saint Pierre And Miquelon',
  'VC': 'Saint Vincent And Grenadines',
  'WS': 'Samoa',
  'SM': 'San Marino',
  'ST': 'Sao Tome And Principe',
  'SA': 'Saudi Arabia',
  'SN': 'Senegal',
  'RS': 'Serbia',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapore',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'SB': 'Solomon Islands',
  'SO': 'Somalia',
  'ZA': 'South Africa',
  'GS': 'South Georgia And Sandwich Isl.',
  'ES': 'Spain',
  'LK': 'Sri Lanka',
  'SD': 'Sudan',
  'SR': 'Suriname',
  'SJ': 'Svalbard And Jan Mayen',
  'SZ': 'Swaziland',
  'SE': 'Sweden',
  'CH': 'Switzerland',
  'SY': 'Syrian Arab Republic',
  'TW': 'Taiwan',
  'TJ': 'Tajikistan',
  'TZ': 'Tanzania',
  'TH': 'Thailand',
  'TL': 'Timor-Leste',
  'TG': 'Togo',
  'TK': 'Tokelau',
  'TO': 'Tonga',
  'TT': 'Trinidad And Tobago',
  'TN': 'Tunisia',
  'TR': 'Turkey',
  'TM': 'Turkmenistan',
  'TC': 'Turks And Caicos Islands',
  'TV': 'Tuvalu',
  'UG': 'Uganda',
  'UA': 'Ukraine',
  'AE': 'United Arab Emirates',
  'GB': 'United Kingdom',
  'US': 'United States',
  'UM': 'United States Outlying Islands',
  'UY': 'Uruguay',
  'UZ': 'Uzbekistan',
  'VU': 'Vanuatu',
  'VE': 'Venezuela',
  'VN': 'Viet Nam',
  'VG': 'Virgin Islands, British',
  'VI': 'Virgin Islands, U.S.',
  'WF': 'Wallis And Futuna',
  'EH': 'Western Sahara',
  'YE': 'Yemen',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe'
};

/***/ }),

/***/ "e/xQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("cRAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("IJhC");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var socket = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AUTHENTICATE */], function (state, action) {
  var clusterName = action.payload.clusterName;

  if (!state.get(clusterName)) {
    return state.set(clusterName, Object(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* SocketState */])());
  }
  return state;
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* AUTHENTICATE_PENDING */], function (state, action) {
  var clusterName = action.payload.clusterName;

  return state.setIn([clusterName, 'authenticateStatus'], __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* AUTHENTICATE_PENDING */]);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* AUTHENTICATE_FAILURE */], function (state, action) {
  var clusterName = action.payload.clusterName;

  return state.setIn([clusterName, 'authenticateStatus'], __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* AUTHENTICATE_FAILURE */]);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* AUTHENTICATE_SUCCESS */], function (state, action) {
  var _action$payload = action.payload,
      clusterName = _action$payload.clusterName,
      userIpAddress = _action$payload.userIpAddress,
      userId = _action$payload.userId,
      sessionToken = _action$payload.sessionToken;

  return state.setIn([clusterName, 'userIpAddress'], userIpAddress).setIn([clusterName, 'userId'], userId).setIn([clusterName, 'sessionToken'], sessionToken).setIn([clusterName, 'authenticateStatus'], __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* AUTHENTICATE_SUCCESS */]).setIn([clusterName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* SOCKET_STATES */].CONNECTING);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SOCKET_OPEN_EVENT_RECEIVED */], function (state, action) {
  var clusterName = action.payload.clusterName;

  var prevState = state.getIn([clusterName, 'reconnectStatus', 'prevState']);

  if (_.isNull(prevState)) {
    return state.setIn([clusterName, 'hasConnected'], true).setIn([clusterName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* SOCKET_STATES */].OPEN).setIn([clusterName, 'reconnectStatus', 'prevState'], __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* SOCKET_OPEN_EVENT_RECEIVED */]);
  }

  var shouldReload = [__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* socketCloseEventReceived */].toString(), __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* socketErrorEventReceived */].toString()].includes(prevState);

  if (shouldReload) {
    return state.setIn([clusterName, 'hasConnected'], true).setIn([clusterName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* SOCKET_STATES */].OPEN).setIn([clusterName, 'reconnectStatus', 'prevState'], action.type);
  }

  return state.setIn([clusterName, 'hasConnected'], true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["o" /* SOCKET_CLOSE_EVENT_RECEIVED */], function (state, action) {
  var clusterName = action.payload.clusterName;

  return state.setIn([clusterName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* SOCKET_STATES */].CLOSED).setIn([clusterName, 'reconnectStatus', 'prevState'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["p" /* SOCKET_ERROR_EVENT_RECEIVED */], function (state, action) {
  var clusterName = action.payload.clusterName;

  return state.setIn([clusterName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["t" /* SOCKET_STATES */].ERRORED).setIn([clusterName, 'reconnectStatus', 'prevState'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* SOCKET_RECONNECT_ATTEMPT_QUEUED */], function (state, action) {
  var _action$payload2 = action.payload,
      clusterName = _action$payload2.clusterName,
      timeUntilReconnect = _action$payload2.timeUntilReconnect;

  return state.setIn([clusterName, 'timeUntilReconnect'], timeUntilReconnect);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* SOCKET_RECONNECT_TIMER_TICKED */], function (state, action) {
  var _action$payload3 = action.payload,
      clusterName = _action$payload3.clusterName,
      timePassed = _action$payload3.timePassed;

  return state.updateIn([clusterName, 'timeUntilReconnect'], function (timeUntilReconnect) {
    return timeUntilReconnect - timePassed;
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* CONNECT */], function (state, action) {
  var _action$payload4 = action.payload,
      clusterName = _action$payload4.clusterName,
      socket = _action$payload4.socket;

  return state.setIn([clusterName, 'socket'], socket);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* JOIN_CHANNEL_PENDING */], function (state, action) {
  var _action$payload5 = action.payload,
      clusterName = _action$payload5.clusterName,
      channelName = _action$payload5.channelName,
      channel = _action$payload5.channel,
      onMessageSubject = _action$payload5.onMessageSubject;

  return state.setIn([clusterName, 'channels', channelName], Object(__WEBPACK_IMPORTED_MODULE_5__models__["a" /* ChannelState */])({
    channel: channel,
    onMessageSubject: onMessageSubject,
    state: __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CHANNEL_STATES */].JOINING
  }));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["m" /* JOIN_CHANNEL_SUCCESS */], function (state, action) {
  var _action$payload6 = action.payload,
      clusterName = _action$payload6.clusterName,
      channelName = _action$payload6.channelName;

  return state.setIn([clusterName, 'channels', channelName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CHANNEL_STATES */].JOINED);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* JOIN_CHANNEL_FAILURE */], function (state, action) {
  var _action$payload7 = action.payload,
      clusterName = _action$payload7.clusterName,
      channelName = _action$payload7.channelName;

  return state.setIn([clusterName, 'channels', channelName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CHANNEL_STATES */].ERRORED);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CHANNEL_ERROR_EVENT_RECEIVED */], function (state, action) {
  var _action$payload8 = action.payload,
      clusterName = _action$payload8.clusterName,
      channelName = _action$payload8.channelName;

  return state.setIn([clusterName, 'channels', channelName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CHANNEL_STATES */].ERRORED);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CHANNEL_CLOSE_EVENT_RECEIVED */], function (state, action) {
  var _action$payload9 = action.payload,
      clusterName = _action$payload9.clusterName,
      channelName = _action$payload9.channelName;

  return state.setIn([clusterName, 'channels', channelName, 'state'], __WEBPACK_IMPORTED_MODULE_3__constants__["g" /* CHANNEL_STATES */].CLOSED);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({
  socket: socket
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "e0zj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UserProfile":"UserProfile---Tk8zx"};

/***/ }),

/***/ "e1hw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_remoteTags_true_images_svg_chat_svg__ = __webpack_require__("yfY0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_remoteTags_true_images_svg_chat_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_remoteTags_true_images_svg_chat_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SendMessageButton = function (_Component) {
  _inherits(SendMessageButton, _Component);

  function SendMessageButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SendMessageButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SendMessageButton.__proto__ || Object.getPrototypeOf(SendMessageButton)).call.apply(_ref, [this].concat(args))), _this), _this.openNewConversation = function () {
      var _this$props = _this.props,
          endUserId = _this$props.endUserId,
          inboxId = _this$props.inboxId;

      localStorage.setItem('ComposeConversationForEndUserId', endUserId);
      _this.context.router.push('/inboxes/' + inboxId);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SendMessageButton, [{
    key: 'render',
    value: function render() {
      var disabled = this.props.disabled;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        {
          disabled: disabled,
          className: 'drift-button drift-button-primary',
          style: { width: '100%' },
          onClick: this.openNewConversation
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_remoteTags_true_images_svg_chat_svg___default.a }),
        'Send Message'
      );
    }
  }]);

  return SendMessageButton;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

SendMessageButton.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (SendMessageButton);

/***/ }),

/***/ "e37Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SocialHandle":"SocialHandle---29BSi","SocialHandle__Input":"SocialHandle__Input---2uRaD","SocialHandle__URL":"SocialHandle__URL---1Y5LF","SocialHandle__InputContainer":"SocialHandle__InputContainer---3SDOe"};

/***/ }),

/***/ "e4AA":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 338.6 402.31\"><path d=\"M175.6.1a169.34,169.34,0,0,0-32,336.6,4,4,0,0,1,3.1,5.7l-25.2,51.9s-.6,1.3-1.1,2.3a4.1,4.1,0,0,0,5,5.5c52.7-16.3,213.2-99.8,213.2-234.9C338.6,77.6,265.1,3.3,175.6.1Zm66.1,84.1a10.59,10.59,0,0,1-1,1.2l-47.3,53.8a11,11,0,0,0-1.2,1.4c-1.7,2.4,0,5.4,3.3,5.5h19.3c3.2.3,4.8,3.2,3.1,5.6l-1.3,1.6-34.9,39.3c-.4.5-.8.9-1.2,1.5-1.5,2.4.2,5.1,3.4,5.3h12.6a4.36,4.36,0,0,1,4.1,2.3,3.25,3.25,0,0,1-1,4,11,11,0,0,1-1,.8l-80.7,60.9a15,15,0,0,1-1.5,1.2,2.44,2.44,0,0,1-2.6,0,1.76,1.76,0,0,1-.8-2c.2-.5.7-1.5.7-1.5l22.2-45.8.6-1.3c1.5-3,0-5.6-3.3-6H116.4a12.1,12.1,0,0,1-1.9-.1c-2.7-.4-4.2-2.7-3.2-5a15.48,15.48,0,0,1,.8-1.5l27.6-46.3s.3-.5.5-.8c1.5-2.7-.3-5.4-3.8-5.5H118.3c-2.3,0-4-1.2-4.4-3.1a4.23,4.23,0,0,1,.7-2.7l8.4-14.8,27.6-48.6.7-1.1a7.49,7.49,0,0,1,7-3.8h78.6a16.35,16.35,0,0,1,2.2.2C241.9,79.5,243.1,82.1,241.7,84.2Z\"></path></svg>"

/***/ }),

/***/ "e6+Q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(19);

/***/ }),

/***/ "e6/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ELOQUA_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ELOQUA_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATCH_ELOQUA_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PATCH_ELOQUA_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PATCH_ELOQUA_MAPPINGS_START; });
var FETCH_ELOQUA_FIELDS_SUCCESS = 'FETCH_ELOQUA_FIELDS_SUCCESS';
var FETCH_ELOQUA_MAPPINGS_SUCCESS = 'FETCH_ELOQUA_MAPPINGS_SUCCESS';
var PATCH_ELOQUA_MAPPINGS_ERROR = 'PATCH_ELOQUA_MAPPINGS_ERROR';
var PATCH_ELOQUA_MAPPINGS_SUCCESS = 'PATCH_ELOQUA_MAPPINGS_SUCCESS';
var PATCH_ELOQUA_MAPPINGS_START = 'PATCH_ELOQUA_MAPPINGS_START';

/***/ }),

/***/ "e7xn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserMapping__ = __webpack_require__("4Wgl");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









function mapStateToProps(state) {
  return {
    sfdcUsers: state.get('sfdc').sfdcUsers,
    sfdcUserMappings: state.get('sfdc').sfdcUserMappings,
    users: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["orgUsersById"])(state).toJS(),
    sfdcUserMappingLoading: state.get('sfdc').sfdcUserMappingLoading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__, { fetchOrgUsers: __WEBPACK_IMPORTED_MODULE_3_app_modules_user_actions__["fetchOrgUsers"] }), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__UserMapping__["a" /* default */]));

/***/ }),

/***/ "eAP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeOnEnterKeyHandler */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeOnCommandEnterKeyHandler; });
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var makeOnEnterKeyHandler = function makeOnEnterKeyHandler(callback) {
  return function (event) {
    if (event.key === 'Enter') {
      return callback();
    }
  };
};

var makeOnCommandEnterKeyHandler = function makeOnCommandEnterKeyHandler(callback) {
  return function (event) {
    if (event.key === 'Enter' && event.getModifierState('Meta')) {
      return callback();
    }
  };
};



/***/ }),

/***/ "eH3a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eHEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AutoSyncCallout__ = __webpack_require__("fysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model__ = __webpack_require__("m93T");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.';
var PATCH_ERROR_MESSAGE = 'We could not save your changes.';

var EloquaConfig = function (_Component) {
  _inherits(EloquaConfig, _Component);

  function EloquaConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EloquaConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EloquaConfig.__proto__ || Object.getPrototypeOf(EloquaConfig)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      eloquaSyncContactsEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][0],
      eloquaShouldSetLeadOwner: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][1],
      eloquaShouldOnlySyncQualifiedContacts: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][2],
      eloquaSyncConversationTranscriptsEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][3],
      cookieIdentificationEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][4]
    }, _this.onError = function () {
      var router = _this.context.router;


      _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
      router.push({ pathname: '/settings/setup/eloqua' });
    }, _this.onPatchError = function () {
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.receiveToggles = function (resp) {
      _this.setState({
        eloquaSyncContactsEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[0],
        eloquaShouldSetLeadOwner: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[1],
        eloquaShouldOnlySyncQualifiedContacts: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[2],
        eloquaSyncConversationTranscriptsEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[3],
        cookieIdentificationEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[4]
      });
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('Eloqua settings are updated!');
    }, _this.patchToggle = function (event, toggle) {
      var data = _defineProperty({}, toggle.type, event);

      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["G" /* patchEloquaConfig */])(data).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EloquaConfig, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["q" /* getEloquaConfig */])().then(this.receiveToggles).catch(this.onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          eloquaSyncContactsEnabled = _state.eloquaSyncContactsEnabled,
          eloquaShouldSetLeadOwner = _state.eloquaShouldSetLeadOwner,
          eloquaShouldOnlySyncQualifiedContacts = _state.eloquaShouldOnlySyncQualifiedContacts,
          eloquaSyncConversationTranscriptsEnabled = _state.eloquaSyncConversationTranscriptsEnabled,
          cookieIdentificationEnabled = _state.cookieIdentificationEnabled;

      var hasEloquaCDO = this.props.userGates.get("eloqua_mapped_cdos") || false;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Eloqua Integration',
          backLinkUrl: '/settings/setup/eloqua'
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Synced Eloqua Data'
          ),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Eloqua and Drift.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Drift',
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Eloqua'
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Integration_components_AutoSyncCallout__["a" /* default */], { integrationName: 'Eloqua' }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: true ? [eloquaShouldOnlySyncQualifiedContacts] : [],
          onChange: this.patchToggle
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: [eloquaSyncContactsEnabled],
          onChange: this.patchToggle
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: [eloquaSyncConversationTranscriptsEnabled],
          onChange: this.patchToggle,
          disabled: !hasEloquaCDO,
          isToggleAvailableForOrg: hasEloquaCDO
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Eloqua',
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Drift'
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_IntegrationToggles__["a" /* default */], {
          toggles: [cookieIdentificationEnabled],
          onChange: this.patchToggle
        })
      );
    }
  }]);

  return EloquaConfig;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

EloquaConfig.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    userGates: __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__["userGates"](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(EloquaConfig)));

/***/ }),

/***/ "eJSL":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 26 22\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 18.857c-.566 0-1.443.006-1.974.009-1.96 2.905-5.936 3.125-6.112 3.133L4.875 22a.815.815 0 0 1-.715-.413.763.763 0 0 1 .058-.835c.014-.019 1.272-1.72 1.45-3.76C2.006 15.09 0 12.419 0 9.429 0 4.229 5.832 0 13 0s13 4.23 13 9.429-5.832 9.428-13 9.428zm0-17.286c-6.272 0-11.375 3.525-11.375 7.858 0 3.36 3.282 5.447 5.238 6.393.276.133.45.405.45.702 0 1.398-.437 2.675-.878 3.608 1.147-.329 2.623-1.013 3.413-2.423a.818.818 0 0 1 .708-.41s1.581-.013 2.444-.013c6.273 0 11.375-3.525 11.375-7.857 0-4.333-5.102-7.858-11.375-7.858zm5.688 8.643H7.313A.8.8 0 0 1 6.5 9.43a.8.8 0 0 1 .813-.786h11.375a.8.8 0 0 1 .812.786.8.8 0 0 1-.813.785zm0-3.143H7.313a.8.8 0 0 1-.813-.785.8.8 0 0 1 .813-.786h11.375a.8.8 0 0 1 .812.786.8.8 0 0 1-.813.785zM7.313 11.786h6.5a.8.8 0 0 1 .812.785.8.8 0 0 1-.813.786h-6.5a.8.8 0 0 1-.812-.786.8.8 0 0 1 .813-.785z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "eJtH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_convert__ = __webpack_require__("Gfmt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_convert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draft_convert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_calendar__ = __webpack_require__("aj9M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_token__ = __webpack_require__("zgcv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_blockStyles__ = __webpack_require__("hnY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_link__ = __webpack_require__("Qv24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_image__ = __webpack_require__("k+Gh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_paragraph__ = __webpack_require__("VV2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dompurify__ = __webpack_require__("OvQW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_draft_js_dist_Draft_css__ = __webpack_require__("F0qx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_draft_js_dist_Draft_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_draft_js_dist_Draft_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("1pyT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var plugins = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["compose"])(__WEBPACK_IMPORTED_MODULE_8__plugins_blockStyles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__plugins_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__plugins_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__plugins_paragraph__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__plugins_token__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__plugins_calendar__["a" /* default */]);
var WithPlugins = plugins(__WEBPACK_IMPORTED_MODULE_3_draft_extend__["Editor"]);
var toHTML = plugins(__WEBPACK_IMPORTED_MODULE_2_draft_convert__["convertToHTML"]);
var fromHTML = plugins(__WEBPACK_IMPORTED_MODULE_2_draft_convert__["convertFromHTML"]);

var Editor = function (_Component) {
  _inherits(Editor, _Component);

  function Editor(props) {
    _classCallCheck(this, Editor);

    var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));

    _this.handleChange = function (editorState) {
      var didContentChange = _this.editorStateChanged(_this.state.editorState, editorState);
      if (_this.props.setIsTyping && didContentChange) {
        _this.props.setIsTyping(true);
        if (_this.previousTypingTimeoutId) {
          clearTimeout(_this.previousTypingTimeoutId);
        }
        _this.previousTypingTimeoutId = setTimeout(function () {
          _this.props.setIsTyping(false);
        }, 450);
      }
      _this.setState({ editorState: editorState }, didContentChange ? _this.handleOutgoingChange : null);
    };

    _this.handleKeyCommand = function (command, editorState) {
      var newState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["RichUtils"].handleKeyCommand(editorState, command);
      if (newState) {
        _this.handleChange(newState);
        return 'handled';
      }
      return 'not-handled';
    };

    var purifiedMessage = __WEBPACK_IMPORTED_MODULE_12_dompurify___default.a.sanitize(props.value);
    var contentState = fromHTML(purifiedMessage);
    _this.state = {
      editorState: __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].createWithContent(contentState)
    };
    _this.handleOutgoingChange = _.debounce(function () {
      var value = toHTML(_this.state.editorState.getCurrentContent()).replace(/&quot;/g, '"') // escape jinja values
      .replace(/&#x27;/g, "'") // escape jinja values
      .replace(/&lt;/g, '<') // escape jinja values
      .replace(/&gt;/g, '>') // escape jinja values
      .replace(/<div><\/div>/g, '<br />');
      var sanitized = __WEBPACK_IMPORTED_MODULE_12_dompurify___default.a.sanitize(value); // replace empty blocks with empty lines
      _this.props.onChange(_this.state.editorState.getCurrentContent().hasText() ? sanitized : '');
      _this.props.setIsTyping && _this.props.setIsTyping(false);
    }, 400); // give it some time to save playbook, otherwise input delays. toHTML() is HEAVY...
    return _this;
  }

  _createClass(Editor, [{
    key: 'editorStateChanged',
    value: function editorStateChanged(oldState, newState) {
      return oldState.getCurrentContent() !== newState.getCurrentContent();
    }
  }, {
    key: 'render',
    value: function render() {
      var editorState = this.state.editorState;
      var _props = this.props,
          className = _props.className,
          popoverAnchorBottom = _props.popoverAnchorBottom,
          removeKeyCommandListener = _props.removeKeyCommandListener,
          noPersonalization = _props.noPersonalization,
          addKeyCommandListener = _props.addKeyCommandListener,
          enableDynamicCalendarLink = _props.enableDynamicCalendarLink;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('rich-editor', className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WithPlugins, {
          editorState: editorState,
          handleKeyCommand: this.handleKeyCommand,
          onChange: this.handleChange,
          addKeyCommandListener: addKeyCommandListener,
          removeKeyCommandListener: removeKeyCommandListener,
          noPersonalization: noPersonalization,
          enableDynamicCalendarLink: enableDynamicCalendarLink,
          popoverAnchorBottom: popoverAnchorBottom
        })
      );
    }
  }]);

  return Editor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_draft_extend__["KeyCommandController"])(Editor));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "eKDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_TagList__ = __webpack_require__("8DYL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_GlobalSearch_ResultPreview_Conversation_styl__ = __webpack_require__("fdmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_GlobalSearch_ResultPreview_Conversation_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_GlobalSearch_ResultPreview_Conversation_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.









var ResultPreviewConversation = React.createClass({
  displayName: 'ResultPreviewConversation',

  propTypes: function propTypes() {
    return {
      conversation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
    };
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'ResultPreviewConversation' },
      React.createElement(
        'div',
        { className: 'subject' },
        this.props.conversation.subject || 'Conversation'
      ),
      React.createElement(
        'div',
        { className: 'body' },
        this.props.conversation.preview
      ),
      React.createElement(
        'div',
        { className: 'bottom' },
        React.createElement(
          'div',
          { className: 'tag-list' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_TagList__["a" /* default */], { tagIds: this.props.conversation.tags })
        ),
        React.createElement(
          'div',
          { className: 'status ' + this.props.conversation.status },
          this.props.conversation.status
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Marty.createContainer(ResultPreviewConversation, {
  listenTo: ['stores.TagStore'],

  fetch: {
    selectedTags: function selectedTags() {
      return this.app.stores.TagStore.getOrFetchTagIdsForConversationId(this.props.conversation.id);
    },
    allAvailableTagsById: function allAvailableTagsById() {
      return this.app.stores.TagStore.getOrFetchConversationTagList();
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "eKzs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OnlineHours":"OnlineHours---3APej"};

/***/ }),

/***/ "eOUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("hjek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("GwZk");






var fetchOverview = function fetchOverview(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchOverview */].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetch().map(__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* receiveOverview */]).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchOverviewPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchOverviewFailed */]());
    });
  });
};

var epic = fetchOverview;

/***/ }),

/***/ "eOvD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("qdP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DEFAULT_LABEL = "Don't set field";
var DESCRIPTION = 'When Drift sends a meeting to Salesforce, we\u2019ll populate the field you select below with the name or email of the user that shared the calendar. These are pulled from your configured event fields in Salesforce.';

var DEFAULT_OPTION = { value: null, label: DEFAULT_LABEL };

var eventToSelectOption = function eventToSelectOption(field) {
    return {
        value: field.name,
        label: field.label
    };
};

var SalesforceMeetingBookedBySelect = function (_Component) {
    _inherits(SalesforceMeetingBookedBySelect, _Component);

    function SalesforceMeetingBookedBySelect(props) {
        var _this2 = this;

        _classCallCheck(this, SalesforceMeetingBookedBySelect);

        var _this = _possibleConstructorReturn(this, (SalesforceMeetingBookedBySelect.__proto__ || Object.getPrototypeOf(SalesforceMeetingBookedBySelect)).call(this, props));

        _this.fetchData = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var allFields, field, wasFieldDeletedInSalesforce;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].getSalesforceMeetingEventFields();

                        case 2:
                            allFields = _context.sent;
                            _context.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].getSalesforceBookedByField().catch(function (e) {
                                return null;
                            });

                        case 5:
                            field = _context.sent;


                            if (!!field) {
                                wasFieldDeletedInSalesforce = allFields.filter(function (aField) {
                                    return aField.label === field.label;
                                })[0];

                                if (!!wasFieldDeletedInSalesforce) {
                                    _this.setState({
                                        options: allFields.map(eventToSelectOption),
                                        selectLabel: field.label,
                                        selectValue: field.name,
                                        allFields: allFields
                                    });
                                } else {
                                    console.log('The field "' + field.label + '" was previously saved but appears to have been deleted from salesforce. We have deleted the mapping.');
                                    __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].deleteSalesforceBookedByField();
                                }
                            } else {
                                _this.setState({
                                    options: allFields.map(eventToSelectOption),
                                    selectLabel: null,
                                    selectValue: null,
                                    allFields: allFields
                                });
                            }

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.onChange = function () {
            var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
                var label = _ref3.label,
                    value = _ref3.value;
                var allFields, field;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!!value) {
                                    _context2.next = 5;
                                    break;
                                }

                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].deleteSalesforceBookedByField();

                            case 3:
                                _context2.next = 8;
                                break;

                            case 5:
                                allFields = _this.state.allFields;
                                field = allFields.filter(function (field) {
                                    return field.label === label;
                                })[0];

                                __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceBookedByField(field);

                            case 8:
                                _this.setState({
                                    selectValue: value,
                                    selectLabel: label
                                });

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.state = {
            options: [],
            allFields: [],
            selectValue: null,
            selectLabel: null
        };
        return _this;
    }

    _createClass(SalesforceMeetingBookedBySelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData();
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                options = _state.options,
                selectValue = _state.selectValue;

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'booked-by-event-field-holder' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'strong',
                    null,
                    'Set calendar shared by user field'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'p',
                    { className: 'booked-by-event-description' },
                    DESCRIPTION
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], { className: 'salesforce-activity-select-input',
                    placeholder: DEFAULT_LABEL,
                    options: options,
                    onChange: this.onChange,
                    value: selectValue,
                    resetValue: DEFAULT_OPTION
                })
            );
        }
    }]);

    return SalesforceMeetingBookedBySelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceMeetingBookedBySelect);

/***/ }),

/***/ "eUvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("9gNq");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("MujL");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__selectors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("sYZ0");
/* unused harmony reexport models */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("a2hK");
/* unused harmony reexport PresenceChannel */
/* unused harmony reexport PhoenixStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epic__ = __webpack_require__("zNUd");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reducer__ = __webpack_require__("elIl");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__reducer__["a"]; });













/***/ }),

/***/ "eVe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_InlineEdit__ = __webpack_require__("lau8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("IQRA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var DriftLink = function DriftLink(_ref) {
  var onSlugChange = _ref.onSlugChange,
      driftLinkOnly = _ref.driftLinkOnly,
      toggleDriftLinkOnly = _ref.toggleDriftLinkOnly,
      slug = _ref.slug;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.DriftLink },
    React.createElement(
      'header',
      { className: 'playbook-title-header' },
      React.createElement(
        'h2',
        null,
        'Create a #DriftLink'
      ),
      React.createElement(
        'p',
        null,
        'Your #DriftLink is what leads will click to trigger this playbook. All you need to do is add it to the end of any link where Drift is installed on your website. (ex. drift.com/#book-a-demo).'
      )
    ),
    React.createElement(
      'div',
      { className: 'playbook-targeting-driftlink-wrapper' },
      React.createElement(
        'div',
        { className: 'slug-container playbook-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_InlineEdit__["a" /* default */], { className: 'slug-edit', onChange: onSlugChange, value: '#' + slug })
      ),
      React.createElement(
        'div',
        { className: 'playbook-targeting-driftlink-toggle' },
        React.createElement(
          'div',
          { className: 'playbook-targeting-driftlink-toggle-label' },
          React.createElement(
            'div',
            null,
            'Target via #DriftLink Only'
          ),
          React.createElement(
            'div',
            { className: 'subtext' },
            'This Playbook will only be accessible through your #DriftLink.'
          )
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_Toggle__["a" /* default */], { checked: driftLinkOnly, onChange: toggleDriftLinkOnly })
      ),
      React.createElement('hr', null),
      React.createElement(
        'div',
        { className: 'playbook-targeting-driftlink-video' },
        React.createElement(
          'div',
          null,
          'Have questions about using #DriftLinks?'
        ),
        React.createElement(
          'div',
          { className: 'subtext' },
          'watch this video:'
        ),
        React.createElement('iframe', {
          width: '390',
          height: '221',
          className: 'playbook-targeting-howto-embed',
          src: 'https://www.youtube.com/embed/qnQEMeM3m_E',
          frameBorder: '0'
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DriftLink);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "eYyn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_QuotaBar__ = __webpack_require__("QZc8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_GlobalNotificationBar_helpers__ = __webpack_require__("3j7a");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





__webpack_require__("y1me");

var CounterPane = function CounterPane(_ref) {
  var highlightColor = _ref.highlightColor,
      title = _ref.title,
      description = _ref.description,
      percentage = _ref.percentage;
  return React.createElement(
    'div',
    { className: 'counter-card' },
    React.createElement(
      'div',
      { className: 'counter-card-label' },
      React.createElement(
        'div',
        { style: { color: highlightColor } },
        title
      ),
      React.createElement(
        'div',
        { className: 'description' },
        description
      )
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_QuotaBar__["a" /* default */], { percent: percentage })
  );
};

var AccountStatusPane = function (_Component) {
  _inherits(AccountStatusPane, _Component);

  function AccountStatusPane() {
    _classCallCheck(this, AccountStatusPane);

    return _possibleConstructorReturn(this, (AccountStatusPane.__proto__ || Object.getPrototypeOf(AccountStatusPane)).apply(this, arguments));
  }

  _createClass(AccountStatusPane, [{
    key: 'renderCounters',
    value: function renderCounters() {
      var counters = this.props.counters;
      var type = counters.type;

      return _.map(counters, function (counter) {
        return React.createElement(CounterPane, _extends({}, counter, { highlightColor: type === 'seats' ? Object(__WEBPACK_IMPORTED_MODULE_2_components_GlobalNotificationBar_helpers__["b" /* getSeatColor */])(counter.percentage) : Object(__WEBPACK_IMPORTED_MODULE_2_components_GlobalNotificationBar_helpers__["a" /* getColor */])(counter.percentage) }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          planTitle = _props.planTitle,
          planDescription = _props.planDescription;

      return React.createElement(
        'div',
        { className: 'counter-container' },
        React.createElement(
          'div',
          { className: 'plan-card' },
          React.createElement(
            'div',
            { className: 'title truncate', title: planTitle },
            planTitle
          ),
          React.createElement(
            'div',
            { className: 'description' },
            planDescription
          )
        ),
        this.renderCounters()
      );
    }
  }]);

  return AccountStatusPane;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AccountStatusPane);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "ea2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__ = __webpack_require__("KOTG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var INCLUDES = "includes";
var EXCLUDES = "does not include";
var IS_EXACT = "is";
var NOT_IS_EXACT = "is not";

var OPTIONS = [{ value: 'isAnyOf', text: IS_EXACT }, { value: 'notIsAnyOf', text: NOT_IS_EXACT }, { value: 'includesAnyOf', text: INCLUDES }, { value: 'notIncludesAnyOf', text: EXCLUDES }];

var StringInputs = function (_Component) {
  _inherits(StringInputs, _Component);

  function StringInputs() {
    _classCallCheck(this, StringInputs);

    return _possibleConstructorReturn(this, (StringInputs.__proto__ || Object.getPrototypeOf(StringInputs)).apply(this, arguments));
  }

  _createClass(StringInputs, [{
    key: 'onAddString',
    value: function onAddString() {
      var strings = this.props.conditionValue.get('value');
      this.props.conditionUpdater('value', strings.push(""));
    }
  }, {
    key: 'makeOnRemove',
    value: function makeOnRemove(index) {
      var _this2 = this;

      return function () {
        var strings = _this2.props.conditionValue.get('value');
        _this2.props.conditionUpdater('value', strings.splice(index, 1));
      };
    }
  }, {
    key: 'makeStringInputChange',
    value: function makeStringInputChange(index) {
      var _this3 = this;

      return function (value) {
        var strings = _this3.props.conditionValue.get('value');
        _this3.props.conditionUpdater('value', strings.set(index, value));
      };
    }
  }, {
    key: 'renderAddButton',
    value: function renderAddButton() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["a" /* AddIcon */], {
        onClick: this.onAddString.bind(this)
      });
    }
  }, {
    key: 'renderRemoveIcon',
    value: function renderRemoveIcon(index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["c" /* RemoveIcon */], {
        onClick: this.makeOnRemove(index)
      });
    }
  }, {
    key: 'renderStringInput',
    value: function renderStringInput(value, index, placeholder) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        valueLink: {
          requestChange: this.makeStringInputChange(index),
          value: value
        },
        placeholder: placeholder,
        isValid: value
      });
    }
  }, {
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      var conditionValue = this.props.conditionValue;

      return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          conditionValue = _props.conditionValue,
          optionTypes = _props.optionTypes;

      var strings = conditionValue.get('value');
      var selects = strings.map(function (stringToMatch, index, _ref) {
        var size = _ref.size;

        var actionButton = void 0;
        if (index === 0) {
          actionButton = _this4.renderAddButton();
        } else {
          actionButton = _this4.renderRemoveIcon(index);
        }
        var node = [_this4.renderStringInput(stringToMatch, index, conditionValue.get('placeholder')), actionButton];
        if (index != size - 1) {
          node.push(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["b" /* OrNode */]);
        }
        return node;
      });

      var options = _.filter(OPTIONS, function (_ref2) {
        var value = _ref2.value;
        return optionTypes.includes(value);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-space-around flex-1 flex-wrap' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__["a" /* default */], {
          onSelection: this.onOperatorSelect.bind(this),
          options: options,
          selectedValue: this.getSelectedValue()
        }),
        selects
      );
    }
  }]);

  return StringInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

StringInputs.defaultProps = {
  optionTypes: ['isAnyOf', 'notIsAnyOf', 'includesAnyOf', 'notIncludesAnyOf']
};


/* harmony default export */ __webpack_exports__["a"] = (StringInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "ebD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__ = __webpack_require__("c4Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_document_title__ = __webpack_require__("aTtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_doc_meta__ = __webpack_require__("5OC1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_doc_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_doc_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_idle_timer__ = __webpack_require__("asCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_presence_actions__ = __webpack_require__("9gNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_presence_selectors__ = __webpack_require__("MujL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_experiment_selectors__ = __webpack_require__("mjTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_IdleTimeout__ = __webpack_require__("GI14");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_fullstory_component__ = __webpack_require__("vT2B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_fullstory_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_fullstory_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_GlobalModal__ = __webpack_require__("BX9I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_NotificationBar__ = __webpack_require__("LwAT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_GlobalNotificationBar__ = __webpack_require__("Sjwf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_MainNav__ = __webpack_require__("4CQX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_utils_SessionRecording__ = __webpack_require__("LbGM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_GlobalSearch__ = __webpack_require__("xKXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__driftt_integrated_help_launcher__ = __webpack_require__("vS8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__driftt_integrated_help_launcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__driftt_integrated_help_launcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_dates_lib_css_datepicker_css__ = __webpack_require__("DTuZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_react_dates_lib_css_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_react_dates_lib_css_datepicker_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







































var DEFAULT_PRESENCE_INTERVAL = 1000;

var BLACKLISTED_INTEGRATED_HELP_URLS = Object.freeze(["/inboxes", "/welcome", "/getstarted"]);

var ApplicationComponent = function (_Component) {
  _inherits(ApplicationComponent, _Component);

  function ApplicationComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ApplicationComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ApplicationComponent.__proto__ || Object.getPrototypeOf(ApplicationComponent)).call.apply(_ref, [this].concat(args))), _this), _this.closeSearch = function () {
      var query = _.cloneDeep(_this.props.location.query);
      delete query[__WEBPACK_IMPORTED_MODULE_29_components_GlobalSearch__["a" /* GLOBAL_SEARCH_KEY */]];
      return _this.context.router.push({ pathname: _this.props.location.pathname, query: query });
    }, _this.onActive = function () {
      if (_this.props.currentUser) {
        _this.props.actions.sendActiveStatus({ isActive: true });
      }
    }, _this.onIdle = function () {
      if (_this.props.currentUser) {
        _this.props.actions.sendActiveStatus({ isActive: false });
      }
    }, _this.renderIntegratedHelp = function () {
      var _this$props = _this.props,
          isFreeUser = _this$props.isFreeUser,
          hasIntegratedHelpGate = _this$props.hasIntegratedHelpGate,
          location = _this$props.location;

      if (!__WEBPACK_IMPORTED_MODULE_27_constants_ResourcesConstants__["w" /* HAS_INTEGRATED_HELP */] && !hasIntegratedHelpGate) {
        return null;
      }

      if (BLACKLISTED_INTEGRATED_HELP_URLS.some(function (blacklistUrl) {
        return location.pathname.startsWith(blacklistUrl);
      })) {
        return null;
      }
      var interactionId = isFreeUser ? __WEBPACK_IMPORTED_MODULE_27_constants_ResourcesConstants__["t" /* FREE_USER_INTEGRATED_HELP_INTERACTION_ID */] : __WEBPACK_IMPORTED_MODULE_27_constants_ResourcesConstants__["J" /* PAID_USER_INTEGRATED_HELP_INTERACTION_ID */];

      return React.createElement(__WEBPACK_IMPORTED_MODULE_30__driftt_integrated_help_launcher___default.a, { interactionId: interactionId });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ApplicationComponent, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { location: this.props.location };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.parseInts(this.props.params);
      this.parseInts(this.props.query);
      this.trackPage(this.props.location.pathname);
      if (this.props.hasPresence) {
        this.props.actions.setPresenceIsReceiving({ on: true });
        this.props.actions.setCustomInterval(DEFAULT_PRESENCE_INTERVAL);
      }
      window.localStorage.setItem('openTabs', JSON.stringify([]));
      setTimeout(this.onActive, 10000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.hasPresence) {
        this.props.actions.setPresenceIsReceiving({ on: false });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.parseInts(nextProps.params);
      this.parseInts(nextProps.query);
      this.trackPage(nextProps.location.pathname);
      if (nextProps.org && nextProps.orgProperties) {
        Object(__WEBPACK_IMPORTED_MODULE_10__driftt_web_auth__["setIdentityInfo"])(nextProps.currentUser, Object(__WEBPACK_IMPORTED_MODULE_21_ramda__["merge"])(_extends({}, nextProps.orgProperties), { name: nextProps.org.name }));
      }
    }
  }, {
    key: 'trackPage',
    value: function trackPage(pathname) {
      if (pathname === this.lastTrackedPath) {
        return;
      }
      this.lastTrackedPath = pathname;
      return this.props.actions.page();
    }
  }, {
    key: 'parseInts',
    value: function parseInts(params) {
      //this is a marshal thing.
      //https://github.com/Driftt/customer-web/commit/9a767861f6fdb40b65133b492d51440d8c7d71fd
      return _.each(params, function (param, key) {
        if (!isNaN(param)) {
          return params[key] = parseInt(param);
        }
      });
    }
  }, {
    key: 'getMetaTags',
    value: function getMetaTags() {
      return [{
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var currentUser = this.props.currentUser;


      var AppCore = React.createElement(
        __WEBPACK_IMPORTED_MODULE_20__driftt_tide_core_legacy__["Div"],
        null,
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_idle_timer__["a" /* default */], { onActive: this.onActive, onIdle: this.onIdle, timeout: 20000 }),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_8_react_doc_meta___default.a,
          { tags: this.getMetaTags() },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_document_title___default.a,
            { title: __WEBPACK_IMPORTED_MODULE_27_constants_ResourcesConstants__["b" /* APP_TITLE */] },
            React.createElement(
              'div',
              { className: 'AppContainer' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_25_components_GlobalNotificationBar__["a" /* default */], { currentPath: this.props.location.pathname }),
              React.createElement(
                'div',
                { className: 'App' },
                this.props.location.query[__WEBPACK_IMPORTED_MODULE_29_components_GlobalSearch__["a" /* GLOBAL_SEARCH_KEY */]] !== undefined && React.createElement(__WEBPACK_IMPORTED_MODULE_29_components_GlobalSearch__["b" /* GlobalSearch */], { onClose: this.closeSearch, query: this.props.location.query }),
                React.createElement(__WEBPACK_IMPORTED_MODULE_26_components_MainNav__["a" /* default */], this.props),
                React.createElement(
                  'div',
                  { className: 'app-content-container' },
                  React.createElement(__WEBPACK_IMPORTED_MODULE_24_components_NotificationBar__["a" /* default */], null),
                  React.createElement(
                    'div',
                    { className: 'app-route-content' },
                    React.cloneElement(this.props.children, { gates: currentUser.gates.toJS() })
                  )
                ),
                this.renderIntegratedHelp()
              ),
              React.createElement(__WEBPACK_IMPORTED_MODULE_23_components_GlobalModal__["a" /* default */], null),
              Object(__WEBPACK_IMPORTED_MODULE_28_utils_SessionRecording__["b" /* default */])(currentUser.gates) && React.createElement(__WEBPACK_IMPORTED_MODULE_22_react_fullstory_component__["FullStory"], {
                settings: __WEBPACK_IMPORTED_MODULE_28_utils_SessionRecording__["a" /* FullStorySettings */],
                sessionId: currentUser.email,
                data: _extends({}, currentUser.toJS(), { displayName: currentUser.name })
              })
            )
          )
        )
      );

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_19_components_IdleTimeout__["a" /* default */],
        { sessionLengthMillis: this.props.sessionLengthMillis },
        AppCore
      );
    }
  }]);

  return ApplicationComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ApplicationComponent.childContextTypes = {
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
ApplicationComponent.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPresence: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["u" /* makeHasGate */])('has_presence')(state),
    activeStatus: __WEBPACK_IMPORTED_MODULE_13_app_modules_presence_selectors__["getActiveStatus"](state),
    currentUser: __WEBPACK_IMPORTED_MODULE_14_app_modules_user_selectors__["currentUser"](state),
    hasIntegratedHelpGate: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["u" /* makeHasGate */])('has_integrated_help_active')(state),
    splitLoaded: __WEBPACK_IMPORTED_MODULE_17_app_modules_experiment_selectors__["a" /* getLoaded */](state),
    isFreeUser: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["t" /* isOnFreePlan */])(state),
    orgId: Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_org_selectors__["orgId"])(state),
    org: Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_org_selectors__["org"])(state),
    orgProperties: Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_org_selectors__["properties"])(state),
    videoSignUpDone: __WEBPACK_IMPORTED_MODULE_16_app_modules_user_properties_selectors__["j" /* videoSignUpDone */](state),
    isDesktopUser: __WEBPACK_IMPORTED_MODULE_16_app_modules_user_properties_selectors__["d" /* isDesktopUser */](state),
    sessionLengthMillis: Object(__WEBPACK_IMPORTED_MODULE_18_app_modules_org_selectors__["properties"])(state).sessionLengthMillis
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      sendActiveStatus: __WEBPACK_IMPORTED_MODULE_12_app_modules_presence_actions__["sendActiveStatus"],
      setPresenceIsReceiving: __WEBPACK_IMPORTED_MODULE_12_app_modules_presence_actions__["setPresenceIsReceiving"],
      setCustomInterval: __WEBPACK_IMPORTED_MODULE_12_app_modules_presence_actions__["setCustomInterval"],
      setProcessAllUsers: __WEBPACK_IMPORTED_MODULE_12_app_modules_presence_actions__["setProcessAllUsers"],
      page: __WEBPACK_IMPORTED_MODULE_15_app_modules_tracking__["a" /* actions */].page
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (props) {
  return !props.currentUser;
}, __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default.a), __WEBPACK_IMPORTED_MODULE_5_recompose_branch___default()(function (props) {
  return !props.splitLoaded;
}, __WEBPACK_IMPORTED_MODULE_6_recompose_renderNothing___default.a))(ApplicationComponent));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "efiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("3Jsy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);




var ClearbitPage = function ClearbitPage() {
    window.location.replace(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/integrations/detail/clearbit_reveal_v2');
};

/* harmony default export */ __webpack_exports__["a"] = (ClearbitPage);

/***/ }),

/***/ "ehLV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_DelayTime__ = __webpack_require__("neFV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("sDd2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);





var AutoCloseConfiguration = function AutoCloseConfiguration(_ref) {
  var timeoutValue = _ref.timeoutValue,
      timeoutUnit = _ref.timeoutUnit,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      setTimeoutUnit = _ref.setTimeoutUnit,
      setTimeoutValue = _ref.setTimeoutValue,
      saveChanges = _ref.saveChanges,
      discardUnsavedChanged = _ref.discardUnsavedChanged,
      minTimeoutValue = _ref.minTimeoutValue,
      maxTimeoutValue = _ref.maxTimeoutValue,
      exceedsLimitText = _ref.exceedsLimitText,
      filters = _ref.filters,
      setFilters = _ref.setFilters;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.conversationAutoClose, 'content') },
    React.createElement(
      'div',
      { className: 'input-group auto-close-filters' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], {
        type: 'checkbox',
        label: 'Apply only to conversations in which no teammates have ever joined',
        checked: filters.filterTeammateParticipated,
        onChange: function onChange(checked) {
          return setFilters({ filterTeammateParticipated: checked });
        } })
    ),
    React.createElement(
      'div',
      { className: 'auto-close-time' },
      React.createElement(
        'div',
        { className: 'input-group' },
        React.createElement(
          'span',
          null,
          'Close conversations after '
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_DelayTime__["a" /* default */], {
          className: 'auto-close-timeout',
          value: timeoutValue,
          unit: timeoutUnit,
          validRange: { min: minTimeoutValue, max: maxTimeoutValue },
          onUnitChange: setTimeoutUnit,
          onValueChange: setTimeoutValue }),
        React.createElement(
          'span',
          null,
          ' of inactivity.'
        ),
        _.isInteger(timeoutValue) && timeoutValue > maxTimeoutValue && React.createElement(
          'span',
          { className: 'error-label' },
          exceedsLimitText
        )
      ),
      hasUnsavedChanges && React.createElement(
        'div',
        { className: 'save-buttons' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
          {
            type: 'primary',
            size: 'medium',
            onClick: saveChanges,
            disabled: !(_.isInteger(timeoutValue) && timeoutValue >= minTimeoutValue && timeoutValue <= maxTimeoutValue) },
          'Save'
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', size: 'medium', onClick: discardUnsavedChanged },
          'Cancel'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (AutoCloseConfiguration);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "ejgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Customize_InputWithLimit__ = __webpack_require__("hHEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EmailCapturePreview__ = __webpack_require__("Utpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__("CQR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var messages = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* defineMessages */])({
  emailCaptureMessage: {
    id: 'app.widget.emailCaptureMessage',
    description: 'Message sent to the user asking them for their email address',
    defaultMessage: "Hey there! We're excited to help you out. Let us know your email address so that we can follow up in case we get disconnected."
  }
});

var EmailCapture = function (_Component) {
  _inherits(EmailCapture, _Component);

  function EmailCapture(props) {
    _classCallCheck(this, EmailCapture);

    var _this = _possibleConstructorReturn(this, (EmailCapture.__proto__ || Object.getPrototypeOf(EmailCapture)).call(this, props));

    _this.onMessageChanged = _this.onMessageChanged.bind(_this);

    _this.state = {
      message: props.message
    };
    return _this;
  }

  _createClass(EmailCapture, [{
    key: 'onMessageChanged',
    value: function onMessageChanged(message, isValid) {
      if (!isValid) return;

      this.setState({ message: message });
      this.props.onMessageChanged(message);
    }
  }, {
    key: 'render',
    value: function render() {
      var message = this.state.message;
      var _props = this.props,
          intl = _props.intl,
          className = _props.className,
          name = _props.name,
          avatarUrl = _props.avatarUrl,
          backgroundColor = _props.backgroundColor;

      var placeholderMessage = intl.formatMessage(messages.emailCaptureMessage);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style___default.a.EmailCapture, className) },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Customize_InputWithLimit__["a" /* default */], {
          title: 'Email Capture Text',
          text: message,
          placeholder: placeholderMessage,
          maxLength: 200,
          invalidLabel: 'You have entered too many characters',
          onChange: this.onMessageChanged,
          className: 'email-capture-input'
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__EmailCapturePreview__["a" /* default */], {
          name: name,
          message: message || placeholderMessage,
          avatarUrl: avatarUrl,
          backgroundColor: backgroundColor,
          className: 'email-capture-preview'
        })
      );
    }
  }]);

  return EmailCapture;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["d" /* injectIntl */])(EmailCapture));

/***/ }),

/***/ "elIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("Xl8E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("9gNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("sYZ0");
var _handleActions2, _handleActions3;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var processAll = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["setProcessAllUsers"], function (state, action) {
  return action.payload;
}), false);

var usersProcessed = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["addUserProcessed"], function (state, action) {
  return state.withMutations(function (mutable) {
    Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getPresenceUserIds */])(action.payload).forEach(function (presenceId) {
      mutable.update(presenceId, 0, function (count) {
        return count + 1;
      });
    });
  });
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_4__actions__["removeUserProcessedDelayed"], function (state, action) {
  return state.withMutations(function (mutable) {
    Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["a" /* getPresenceUserIds */])(action.payload).forEach(function (presenceId) {
      if (mutable.get(presenceId) === 1) {
        mutable.delete(presenceId);
      } else {
        mutable.update(presenceId, function (count) {
          return count - 1;
        });
      }
    });
  });
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var data = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setPresenceIsReceiving"], function (state, action) {
  var newState = state.set('toggle', action.payload.on);

  if (!action.payload.on) {
    // Buffered users is now stale
    return newState.delete('bufferedUsers');
  }

  return newState;
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["sendActiveStatus"], function (state, action) {
  return state.set('activeStatus', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setHasProcessedUsers"], function (state, action) {
  return state.set('hasProcessedUsers', true);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setBufferedUsers"], function (state, action) {
  return state.set('bufferedUsers', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setNewLiveUsers"], function (state, action) {
  return state.withMutations(function (mutable) {
    mutable.set('newLiveUsers', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(action.payload.visitors.map(__WEBPACK_IMPORTED_MODULE_5__models__["b" /* parsePresenceVisitor */])));
    mutable.set('newLiveUsersCount', action.payload.resultSetSize);
  });
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setFilters"], function (state, action) {
  return state.set('filters', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setNewFilters"], function (state, action) {
  return state.set('newFilters', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setShowMore"], function (state, action) {
  return state.set('showMore', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setNewSorts"], function (state, action) {
  return state.set('newSorts', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setFilterKnownUsers"], function (state, action) {
  return state.set('filterKnownUsers', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setCustomInterval"], function (state, action) {
  return state.set('interval', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setPagination"], function (state, action) {
  return state.set('pagination', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setPresenceProblems"], function (state) {
  return state.set('presenceProblems', true);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["setPresenceLoading"], function (state, action) {
  return state.set('presenceLoading', action.payload);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["messageSent"], function (state, action) {
  return state.set('usersWithMessageSent', [].concat(_toConsumableArray(state.get('usersWithMessageSent')), [action.payload]));
}), _handleActions3), new __WEBPACK_IMPORTED_MODULE_5__models__["a" /* PresenceState */]());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ data: data, processAll: processAll, usersProcessed: usersProcessed }));

/***/ }),

/***/ "enmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ep7x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Action":"Action---1Cgth","SelectedAction":"SelectedAction---3_LTn"};

/***/ }),

/***/ "epiu":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 19 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.23 19.546c2.794.355 4.75 2.735 4.75 5.732V26H4.02v-.722c0-2.997 1.956-5.377 4.75-5.732v-1.49h1.46v1.49zM8.77 2.696a1.441 1.441 0 0 1-.732-1.252C8.038.647 8.693 0 9.5 0c.807 0 1.462.647 1.462 1.444 0 .535-.294 1.002-.731 1.252v2.36h6.573c1.212 0 2.196.968 2.196 2.162v8.675c0 1.195-.984 2.163-2.196 2.163H2.196C.984 18.056 0 17.087 0 15.893V7.218c0-1.195.984-2.162 2.196-2.162h6.573v-2.36zM1.461 7.218v8.675c0 .395.328.718.734.718h14.608a.726.726 0 0 0 .734-.718V7.218a.727.727 0 0 0-.734-.718H2.196a.726.726 0 0 0-.734.718zM5.53 24.556h7.94c-.293-2.113-1.868-3.612-3.97-3.612-2.102 0-3.677 1.499-3.97 3.612zm.682-11.917a1.816 1.816 0 0 1-1.827-1.806c0-.997.818-1.805 1.827-1.805s1.826.808 1.826 1.805c0 .998-.817 1.806-1.826 1.806zm6.576 0a1.816 1.816 0 0 1-1.826-1.806c0-.997.817-1.805 1.826-1.805 1.01 0 1.827.808 1.827 1.805 0 .998-.818 1.806-1.827 1.806z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "esK+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IconSet":"IconSet---2P9f-","IconPicker":"IconPicker---25i6t","IconPickerRow":"IconPickerRow---2VkxL"};

/***/ }),

/***/ "eugp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HoursAndTargeting":"HoursAndTargeting---3SneG","DisabledAudienceAndTargeting":"DisabledAudienceAndTargeting---2Px3J"};

/***/ }),

/***/ "euoy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_action_error_svg__ = __webpack_require__("UIoH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_action_error_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_action_error_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Action_style_styl__ = __webpack_require__("olQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Action_style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Action_style_styl__);






var ActionError = function ActionError(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__Action_style_styl___default.a.Action, 'flex') },
    React.createElement(
      'div',
      { className: 'action-icon' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_action_error_svg___default.a })
    ),
    React.createElement(
      'div',
      { className: 'action-content action-error' },
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ActionError);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "eupy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_copy_to_clipboard__ = __webpack_require__("sQ20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("EjAY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var Unsubscription = function Unsubscription(_ref) {
  var unsubLink = _ref.unsubLink,
      onEndUserEmailChange = _ref.onEndUserEmailChange,
      endUserEmail = _ref.endUserEmail,
      handleCopyUnsubLink = _ref.handleCopyUnsubLink,
      isCopied = _ref.isCopied;
  return React.createElement(
    'div',
    { className: 'conversation-settings-unsubscribe-link' },
    React.createElement(
      'h3',
      null,
      'Create an unsubscribe link'
    ),
    React.createElement(
      'label',
      null,
      'Enter the user\u2019s email'
    ),
    React.createElement(
      'div',
      { className: 'conversation-settings-email-input-helptext' },
      '(optional, this is used to pre-fill the email text box for your users)'
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], { className: 'conversation-unsubscribe-email-input', placeholder: 'email', onChange: onEndUserEmailChange, value: endUserEmail }),
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_copy_to_clipboard___default.a,
      { text: unsubLink, onCopy: handleCopyUnsubLink },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
        { type: 'primary' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { width: 12, name: 'link-1' }),
        ' ',
        isCopied ? 'Copied!' : 'Copy Unsubscribe Link'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Unsubscription);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ew+M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  whoIsConnected: function whoIsConnected(integrationName) {
    switch (integrationName) {
      case 'Salesforce':
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get("/salesforce/userinfo").then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
      case 'Marketo':
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get("/marketo/config/munchkin").then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
      default:
        return {};
    }
  },
  postIntegrationFeedback: function postIntegrationFeedback(integrationName, feedback) {
    __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post("/integrations/disconnect/reason", { integrationName: integrationName, reason: feedback });
  },
  integrationAPICall: function integrationAPICall(integrationEndpoint) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get(integrationEndpoint).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "ewCN":
/***/ (function(module, exports) {

module.exports = "<svg width=\"1708px\" viewBox=\"0 0 1708 377\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(-621.000000, -722.000000)\"><g transform=\"translate(621.000000, 722.000000)\"><rect fill=\"#E1EEF4\" x=\"2\" y=\"83\" width=\"974\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"2\" y=\"33\" width=\"206\" height=\"39\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1285\" y=\"69\" width=\"120\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1579\" y=\"69\" width=\"120\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"2\" y=\"217\" width=\"974\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"2\" y=\"167\" width=\"206\" height=\"39\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1285\" y=\"203\" width=\"120\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1579\" y=\"203\" width=\"120\" height=\"20\" rx=\"3\"></rect><path d=\"M1,135 L1707.69805,135\" id=\"Path-2\" stroke=\"#E1EEF4\" stroke-width=\"2\"></path><rect fill=\"#E1EEF4\" x=\"2\" y=\"357\" width=\"974\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"2\" y=\"307\" width=\"206\" height=\"39\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1285\" y=\"343\" width=\"120\" height=\"20\" rx=\"3\"></rect><rect fill=\"#E1EEF4\" x=\"1579\" y=\"343\" width=\"120\" height=\"20\" rx=\"3\"></rect><path d=\"M1,275 L1707.69805,275\" id=\"Path-2\" stroke=\"#E1EEF4\" stroke-width=\"2\"></path></g></g></g></svg>"

/***/ }),

/***/ "ewSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("xpCh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var emptyList = { accountListName: null, accountListId: null };

var SFDCAccountSyncModal = function (_Component) {
  _inherits(SFDCAccountSyncModal, _Component);

  function SFDCAccountSyncModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SFDCAccountSyncModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SFDCAccountSyncModal.__proto__ || Object.getPrototypeOf(SFDCAccountSyncModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      listsToSync: [emptyList],
      targetList: true
    }, _this.isValid = function () {
      var listsToSync = _this.state.listsToSync;

      listsToSync.pop(); // remove null value from list
      var hasBothValues = function hasBothValues(_ref2) {
        var accountListId = _ref2.accountListId,
            accountListName = _ref2.accountListName;
        return !!accountListName && !!accountListId;
      };
      return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["all"])(hasBothValues)(listsToSync);
    }, _this.addNewList = function () {
      _this.setState(function (prevState) {
        return {
          listsToSync: [].concat(_toConsumableArray(prevState.listsToSync), [emptyList])
        };
      });
    }, _this.removeListToSync = function (index) {
      _this.setState(function (prevState) {
        return {
          listsToSync: Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["remove"])(index, 1, prevState.listsToSync)
        };
      });
    }, _this.renderNewListSelect = function (_ref3, index) {
      var accountListId = _ref3.accountListId;
      var lists = _this.props.lists;
      var _this$state = _this.state,
          targetList = _this$state.targetList,
          listsToSync = _this$state.listsToSync;


      var onStateSet = function onStateSet() {
        _this.addNewList();
      };
      var listOptions = lists.map(function (_ref4) {
        var label = _ref4.label,
            id = _ref4.id;
        return { label: label, value: id };
      });
      var updateListToSync = function updateListToSync(option, index) {
        _this.setState(function (prevState) {
          var updatedLists = [].concat(_toConsumableArray(prevState.listsToSync));
          updatedLists[index] = { accountListId: option.value, accountListName: option.label, targeted: targetList };
          return { listsToSync: updatedLists };
        }, function () {
          return onStateSet();
        });
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'sfdc-accounts-sync-add-list', key: accountListId },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
          onChange: function onChange(value) {
            return updateListToSync(value, index);
          },
          value: accountListId,
          options: listOptions,
          placeholder: "Select an Account List",
          clearable: false
        }),
        listsToSync.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { onClick: function onClick() {
              return _this.removeListToSync(index);
            } },
          listsToSync[index].accountListName !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { className: 'account-list-close-icon', width: 11, name: 'close' })
        )
      );
    }, _this.onSetTargetList = function () {
      _this.setState(function (prevState) {
        return {
          targetList: !prevState.targetList
        };
      });
    }, _this.sendToServer = function () {
      var onCloseClick = _this.props.onCloseClick;
      var _this$state2 = _this.state,
          listsToSync = _this$state2.listsToSync,
          targetList = _this$state2.targetList;


      if (_this.isValid()) {
        var correctedTargeting = listsToSync.map(function (list) {
          list.targeted = targetList;
          return list;
        });
        onCloseClick(correctedTargeting);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SFDCAccountSyncModal, [{
    key: 'render',
    value: function render() {
      var onCancelClick = this.props.onCancelClick;
      var _state = this.state,
          listsToSync = _state.listsToSync,
          targetList = _state.targetList;


      var syncAllText = function syncAllText() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'Sync these accounts as targeted ABM accounts.',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019482234-How-to-Sync-Accounts-into-Drift-from-Salesforce-and-Set-Up-a-Personalized-Welcome-Message' },
            '\xA0Learn More'
          )
        );
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Modal"],
          {
            className: "sfdc-account-sync-modal",
            open: true,
            size: "small",
            onClose: onCancelClick
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'account-list-modal-holder' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              'Synced Salesforce Account Lists'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Choose an Account List to sync from Salesforce'
            ),
            listsToSync.map(this.renderNewListSelect),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Input"], {
              type: 'checkbox',
              label: syncAllText(),
              onChange: this.onSetTargetList,
              checked: targetList,
              size: "small"

            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              {
                type: 'secondary',
                onClick: this.sendToServer,
                className: 'modal-button-container',
                style: { marginRight: '5px' },
                disabled: listsToSync[0].accountListName === null ? true : false
              },
              'Sync'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              { type: 'tertiary', onClick: onCancelClick, className: 'modal-button-container' },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return SFDCAccountSyncModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SFDCAccountSyncModal);

/***/ }),

/***/ "ey39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__ = __webpack_require__("lzSP");
/* eslint-disable
    import/default,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


/* harmony default export */ __webpack_exports__["default"] = (Marty.createStore({
  id: 'DashboardStore',

  getInitialState: function getInitialState() {
    return {
      inboxStats: {}
    };
  },


  handlers: {
    fetchInboxMetricsDone: __WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__["a" /* default */].INBOX_FETCH_STATS_DONE,
    fetchInboxMetricsFailed: __WEBPACK_IMPORTED_MODULE_0_constants_DashboardConstants__["a" /* default */].INBOX_FETCH_STATS_FAILED
  },

  _cloneStats: function _cloneStats() {
    return _.cloneDeep(this.state.inboxStats) || {};
  },
  getInboxDateKey: function getInboxDateKey(inboxId, startDate, endDate) {
    return 'inbox-' + inboxId + '-daterange-' + startDate.toString() + '-' + endDate.toString();
  },
  getOrFetchInboxStats: function getOrFetchInboxStats(inboxId, startDate, endDate) {
    return this.fetch({
      dependsOn: [this.app.stores.InboxStore.getOrFetchInboxList()],
      id: 'fetchInboxMetrics' + inboxId,
      locally: function locally() {
        return this.state.inboxStats != null ? this.state.inboxStats[this.getInboxDateKey(inboxId, startDate, endDate)] : undefined;
      },
      remotely: function remotely() {
        return this.app.queries.InboxQueries.fetchInboxMetrics(inboxId, startDate, endDate);
      }
    });
  },
  fetchInboxMetricsDone: function fetchInboxMetricsDone(inboxId, startDate, endDate, stats) {
    var inboxStats = this._cloneStats();
    inboxStats[this.getInboxDateKey(inboxId, startDate, endDate)] = stats;
    return this.setState({ inboxStats: inboxStats });
  },
  fetchInboxMetricsFailed: function fetchInboxMetricsFailed(stats) {
    return {};
  }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "f/uQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UspsCodesToStateName; });
var UspsCodesToStateName = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'DC': 'District of Columbia',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

/***/ }),

/***/ "f5yp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DYNAMIC_CALENDAR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_utils__ = __webpack_require__("PIqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_profile_actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component__ = __webpack_require__("+H3u");

















var DYNAMIC_CALENDAR = 'DYNAMIC_CALENDAR';

var CalendarPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm'
};

var getCalendarLink = function getCalendarLink(orgHandle, user) {
  if (user === DYNAMIC_CALENDAR) {
    return '{{ sender.profile_schedule_url }}';
  } else {
    return 'https://' + __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */] + '/' + user.getIn(['profile', 'globalHandle']) + '?schedule';
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsersById: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["nonBotOrgUsersAlphabetical"](state).toList(),
    currentUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["currentUser"](state),
    calendarConnectedAgentIds: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_selectors__["a" /* getAgentIdsWithConnectedCalendars */](state),
    orgHandle: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_selectors__["orgHandle"](state),
    calendarProfileLoading: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["h" /* calendarProfileLoading */](state),
    enableDynamicCalendarLink: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_7" /* getIsSequencePlaybook */](state) || __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchUserProfile: __WEBPACK_IMPORTED_MODULE_10_app_modules_profile_actions__["fetchUserProfile"],
      hideCalendarLinkModal: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_actions__["_77" /* hideCalendarLinkModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedUser', 'setSelectedUser', undefined), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('popoverStep', 'setPopoverStep', CalendarPopoverSteps.SELECT), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('popoverOpen', 'setPopoverOpen', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('search', 'setSearch', ''), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('linkText', 'setLinkText', 'Schedule a meeting'), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  var usersWithoutCalendar = props.orgUsersById.filter(function (user) {
    return !props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id');
  });
  var usersWithCalendar = props.orgUsersById.filter(function (user) {
    return props.calendarConnectedAgentIds.contains(user.get('id')) && user.get('id') !== props.currentUser.get('id');
  });
  if (!props.search) {
    return {
      usersWithoutCalendar: usersWithoutCalendar,
      usersWithCalendar: usersWithCalendar,
      currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
      showCurrentUser: true,
      isSearching: false
    };
  } else {
    var withCalFiltered = usersWithCalendar.filter(function (user) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_utils__["a" /* getUserDisplayName */])(user).toLowerCase().includes(props.search.toLowerCase());
    });
    var withoutCalFiltered = usersWithoutCalendar.filter(function (user) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_utils__["a" /* getUserDisplayName */])(user).toLowerCase().includes(props.search.toLowerCase());
    });
    var showCurrentUser = props.currentUser && !!props.search && Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_utils__["a" /* getUserDisplayName */])(props.currentUser).toLowerCase().includes(props.search.toLowerCase());
    return {
      usersWithoutCalendar: withoutCalFiltered,
      usersWithCalendar: withCalFiltered,
      currentUserHasCalendarConnected: props.calendarConnectedAgentIds.contains(props.currentUser.get('id')),
      showCurrentUser: showCurrentUser,
      isSearching: true
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onPropertySelect: function onPropertySelect(props) {
    return function (user) {
      props.setSelectedUser(user);
      props.actions.fetchUserProfile(user.get('id'));
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM);
    };
  },
  onDynamicCalSelect: function onDynamicCalSelect(props) {
    return function () {
      props.setSelectedUser(DYNAMIC_CALENDAR);
      props.setPopoverStep(CalendarPopoverSteps.CONFIRM);
    };
  },
  onDefaultConfirm: function onDefaultConfirm(props) {
    return function () {
      props.setPopoverStep(CalendarPopoverSteps.SELECT);
      var editor = window.tinymce.activeEditor;
      var selectedUser = props.selectedUser;
      if (selectedUser !== DYNAMIC_CALENDAR) {
        selectedUser = props.orgUsersById.filter(function (user) {
          return user.get('id') === props.selectedUser.get('id');
        }).first();
      }
      editor.insertContent('<a href="' + getCalendarLink(props.orgHandle, selectedUser) + '">' + (props.linkText || 'Schedule a meeting') + '</a>');
      props.actions.hideCalendarLinkModal();
    };
  },
  onDefaultCancel: function onDefaultCancel(props) {
    return function () {
      props.setSelectedUser(undefined);
      props.setLinkText('Schedule a meeting');
      props.setPopoverStep(CalendarPopoverSteps.SELECT);
    };
  },
  hideCalendarLinkModal: function hideCalendarLinkModal(props) {
    return function () {
      props.actions.hideCalendarLinkModal();
    };
  },
  togglePopoverOpen: function togglePopoverOpen(props) {
    return function () {
      props.setPopoverOpen(!props.popoverOpen);
    };
  },
  onSearchChange: function onSearchChange(props) {
    return function (event) {
      props.setSearch(event.target.value);
    };
  },
  onDefaultChange: function onDefaultChange(props) {
    return function (event) {
      // make sure to escape double quotes
      props.setLinkText(event.target.value);
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function () {
      props.setPopoverOpen(false);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (this.props.isOutboundSequencePlaybook) {
      this.props.setSelectedUser(DYNAMIC_CALENDAR);
      this.props.setPopoverStep(CalendarPopoverSteps.CONFIRM);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_3_react_onclickoutside_decorator___default.a)(__WEBPACK_IMPORTED_MODULE_12__component__["a" /* default */]));

/***/ }),

/***/ "f9IB":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 28\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Targeting-Iteration\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"dis-targeting\" transform=\"translate(-529.000000, -442.000000)\" fill=\"#394F5A\"><g id=\"window\" transform=\"translate(529.000000, 442.000000)\"><path d=\"M30,27.332 L2,27.332 C0.897333333,27.332 0,26.4353333 0,25.3333333 L0,2.666 C0,1.56333333 0.897333333,0.666 2,0.666 L30,0.666 C31.1026667,0.666 32,1.56333333 32,2.666 L32,25.3333333 C32,26.4353333 31.1026667,27.332 30,27.332 Z M30.6666667,2.666 C30.6666667,2.298 30.3673333,1.99933333 30,1.99933333 L2,1.99933333 C1.63266667,1.99933333 1.33333333,2.298 1.33333333,2.666 L1.33333333,5.99933333 L30.6666667,5.99933333 L30.6666667,2.666 Z M30.6666667,7.33266667 L1.33333333,7.33266667 L1.33333333,25.3333333 C1.33333333,25.7006667 1.63266667,25.9993333 2,25.9993333 L30,25.9993333 C30.3673333,25.9993333 30.6666667,25.7006667 30.6666667,25.3333333 L30.6666667,7.33266667 Z M3.34666667,3.36133333 L3.35333333,3.36133333 C3.722,3.36133333 4.02,3.65933333 4.02,4.028 C4.02,4.396 3.722,4.69466667 3.35333333,4.69466667 C2.98466667,4.69466667 2.68333333,4.396 2.68333333,4.028 C2.68333333,3.65933333 2.97866667,3.36133333 3.34666667,3.36133333 Z M5.34666667,3.36133333 L5.35333333,3.36133333 C5.72133333,3.36133333 6.02,3.65933333 6.02,4.028 C6.02,4.396 5.72133333,4.69466667 5.35333333,4.69466667 C4.98533333,4.69466667 4.68333333,4.396 4.68333333,4.028 C4.68333333,3.65933333 4.97866667,3.36133333 5.34666667,3.36133333 Z M7.34666667,3.36133333 L7.35333333,3.36133333 C7.722,3.36133333 8.02,3.65933333 8.02,4.028 C8.02,4.396 7.722,4.69466667 7.35333333,4.69466667 C6.98466667,4.69466667 6.68333333,4.396 6.68333333,4.028 C6.68333333,3.65933333 6.97866667,3.36133333 7.34666667,3.36133333 Z\" id=\"Shape\"></path><path d=\"M23.3333333,17.3333333 L21.9593333,17.3333333 C21.6506667,20.1093333 19.4426667,22.3186667 16.6666667,22.6273333 L16.6666667,24 C16.6666667,24.368 16.3686667,24.6666667 16,24.6666667 C15.6313333,24.6666667 15.3333333,24.368 15.3333333,24 L15.3333333,22.6273333 C12.5573333,22.3186667 10.3493333,20.1093333 10.0406667,17.3333333 L8.66666667,17.3333333 C8.298,17.3333333 8,17.0346667 8,16.6666667 C8,16.2986667 8.298,16 8.66666667,16 L10.0406667,16 C10.3493333,13.224 12.5566667,11.014 15.3333333,10.7053333 L15.3333333,9.33333333 C15.3333333,8.96533333 15.6313333,8.66666667 16,8.66666667 C16.3686667,8.66666667 16.6666667,8.96533333 16.6666667,9.33333333 L16.6666667,10.7053333 C19.4433333,11.014 21.6506667,13.224 21.9593333,16 L23.3333333,16 C23.702,16 24,16.2986667 24,16.6666667 C24,17.0346667 23.702,17.3333333 23.3333333,17.3333333 Z M16.6666667,21.266 C18.7026667,20.9706667 20.3093333,19.3673333 20.6046667,17.3333333 L19.26,17.3333333 C18.9933333,18.636 17.97,19.6666667 16.6666667,19.932 L16.6666667,21.266 Z M16.6666667,16 L17.8773333,16 C17.6746667,15.438 17.2306667,14.9906667 16.6666667,14.7893333 L16.6666667,16 Z M17.8766667,17.3333333 L16.6666667,17.3333333 L16.6666667,18.5433333 C17.2306667,18.342 17.674,17.8946667 17.8766667,17.3333333 Z M15.3333333,17.3333333 L14.1233333,17.3333333 C14.326,17.8946667 14.7693333,18.342 15.3333333,18.5433333 L15.3333333,17.3333333 Z M15.3333333,21.266 L15.3333333,19.932 C14.03,19.6666667 13.0066667,18.636 12.74,17.3333333 L11.3953333,17.3333333 C11.6906667,19.3673333 13.2973333,20.9706667 15.3333333,21.266 Z M15.3333333,12.0666667 C13.2966667,12.362 11.6906667,13.966 11.3953333,16 L12.74,16 C13.006,14.6973333 14.03,13.6666667 15.3333333,13.4006667 L15.3333333,12.0666667 Z M14.1226667,16 L15.3333333,16 L15.3333333,14.7893333 C14.7693333,14.9906667 14.3253333,15.438 14.1226667,16 Z M16.6666667,12.0666667 L16.6666667,13.4006667 C17.97,13.6666667 18.994,14.6973333 19.26,16 L20.6046667,16 C20.3093333,13.966 18.7033333,12.362 16.6666667,12.0666667 Z\" id=\"Shape\"></path></g></g></g></svg>"

/***/ }),

/***/ "f9kp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DriftAPI = {
  showWelcomeMessage: null,
  hideWelcomeMessage: null,
  showWelcomeOrAwayMessage: null,
  openChat: null,
  hideChat: null,
  startInteraction: null
};

Object.keys(DriftAPI).map(function (method) {
  var newFunc = function newFunc() {
    var _arguments = arguments;

    if (window.drift.api) {
      window.drift.api[method].apply(null, arguments);
    } else {
      window.drift.on('ready', function (api) {
        api[method].apply(null, _arguments);
      });
    }
  };
  DriftAPI[method] = newFunc;
});

/* harmony default export */ __webpack_exports__["a"] = (DriftAPI);

/***/ }),

/***/ "fBam":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HUBSPOT_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DRIP_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FULLSTORY_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HELP_CENTER_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ZAPIER_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INTERCOM_HELPDOC_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LINKEDIN_HELPDOC_URL; });
var HUBSPOT_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360042255093-HubSpot-Integration';
var DRIP_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019504674-How-to-Connect-Drift-with-Drip';
var FULLSTORY_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019666893-How-to-Integrate-Drift-with-FullStory';
var HELP_CENTER_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019504694-How-to-Connect-Drift-with-Your-Support-Knowledge-Base';
var ZAPIER_HELPDOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360019665513-How-to-Connect-Drift-to-Your-Zapier-Account';
var INTERCOM_HELPDOC_URL = 'http://help.drift.com/integrations/intercom-integration';
var LINKEDIN_HELPDOC_URL = 'https://help.drift.com/article/linkedin-integration/';

/***/ }),

/***/ "fCHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"onlineIndicator":"onlineIndicator---3a0k-"};

/***/ }),

/***/ "fCd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__ = __webpack_require__("1rl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_GateConstants__ = __webpack_require__("O04e");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var GateStore = Marty.createStore({
  id: 'GateStore',

  getInitialState: function getInitialState() {
    return {
      gates: {}
    };
  },


  handlers: {
    fetchCurrentUserDone: __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].FETCH_CURRENT_USER_DONE,
    updateGatesDone: __WEBPACK_IMPORTED_MODULE_1_constants_GateConstants__["a" /* default */].GATES_UPDATE_DONE,
    setGateDone: __WEBPACK_IMPORTED_MODULE_1_constants_GateConstants__["a" /* default */].SET_GATE_DONE
  },

  fetchCurrentUserDone: function fetchCurrentUserDone(user) {
    var gates = user.gates || {};
    return this.setState({ gates: gates });
  },
  updateGatesDone: function updateGatesDone(gates) {
    return this.setState({ gates: gates || {} });
  },
  setGateDone: function setGateDone(gates) {
    return this.setState({ gates: gates || {} });
  },
  getOrFetchGates: function getOrFetchGates() {
    return this.fetch({
      id: 'getOrFetchGates',
      dependsOn: this.app.stores.UserStore.getOrFetchCurrentUser(),
      locally: function locally() {
        return this.state.gates;
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (GateStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "fDDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_range__ = __webpack_require__("l5j/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_daterange_picker__ = __webpack_require__("YWjJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_TimeSelectorDropdown__ = __webpack_require__("d4mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styles_components_TimeSelectorDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_styles_components_TimeSelectorDropdown__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.










var TimeSelectorDropdown = React.createClass({
  displayName: 'TimeSelectorDropdown',

  propTypes: {
    onSetRange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    selectedDateRange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  },

  dateRangeLastNDays: function dateRangeLastNDays(days) {
    var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(days, 'days').startOf('day');
    var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()().endOf('day');
    return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.range(start, end);
  },
  clickWeek: function clickWeek() {
    return this.props.onSetRange(this.dateRangeLastNDays(6));
  },
  clickMonth: function clickMonth() {
    return this.props.onSetRange(this.dateRangeLastNDays(29));
  },
  handleRangeChange: function handleRangeChange(range) {
    var selectedRange = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.range(range.start.startOf('day'), range.end.endOf('day'));
    return this.props.onSetRange(selectedRange);
  },
  createDropdown: function createDropdown() {
    return [React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'preset-time-buttons' },
        React.createElement(
          'button',
          { className: 'dsg-MediumButton', onClick: this.clickWeek },
          'last week'
        ),
        React.createElement(
          'button',
          { className: 'dsg-MediumButton', onClick: this.clickMonth },
          'last month'
        )
      )
    ), React.createElement(__WEBPACK_IMPORTED_MODULE_4_react_daterange_picker___default.a, {
      selectionType: 'range',
      value: this.props.selectedDateRange,
      onSelect: this.handleRangeChange })];
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: 'TimeSelectorDropdown', onClick: this.handleOnClick },
      this.createDropdown()
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TimeSelectorDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "fIG5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");







var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
};

var settingsClick = function settingsClick() {
  track('Navigation Item Clicked', { subject: 'settings' });
};

var SettingsIcon = function SettingsIcon() {

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'nav-help-wrapper', 'data-ocweb-id': 'traffic-control.SettingsCog' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/team' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'nav-help-tooltip', onClick: settingsClick },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
          { className: 'navigation-hover-tooltip--wrapper', component: 'Settings',
            flow: 'right', tethered: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'nav-status-icon-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { width: 19, height: 24,
              name: 'settings-1' })
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapDispatchToProps)(SettingsIcon));

/***/ }),

/***/ "fIl0":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.5 8.5l7.3 7.3c.27.27.27.72 0 1-.15.13-.33.2-.5.2-.2 0-.37-.07-.5-.2L8.5 9.5l-7.3 7.3c-.13.13-.3.2-.5.2-.17 0-.35-.07-.5-.2-.27-.28-.27-.73 0-1l7.3-7.3L.2 1.2C-.06.94-.06.5.2.2c.28-.27.73-.27 1 0l7.3 7.3L15.8.2c.27-.27.72-.27 1 0 .27.28.27.73 0 1L9.5 8.5z\" stroke-width=\".25\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "fMSb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__("uw+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var PresenceIndicator = function (_PureComponent) {
  _inherits(PresenceIndicator, _PureComponent);

  function PresenceIndicator() {
    _classCallCheck(this, PresenceIndicator);

    return _possibleConstructorReturn(this, (PresenceIndicator.__proto__ || Object.getPrototypeOf(PresenceIndicator)).apply(this, arguments));
  }

  _createClass(PresenceIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isConnected = _props.isConnected,
          endUser = _props.endUser;


      if (!endUser) return false;

      var lastActive = endUser.attributes.last_active ? 'active ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(endUser.attributes.last_active).fromNow() : '';

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'div',
        { key: 'presence-indicator', className: 'flex dsg-Regular color-navy-dark end-user-info' },
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', {
          style: { marginRight: isConnected && '.25rem' },
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("presence-indicator", { active: isConnected })
        }),
        __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
          'span',
          null,
          isConnected ? 'online now' : lastActive
        )
      );
    }
  }]);

  return PresenceIndicator;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

PresenceIndicator.propTypes = {
  isConnected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  endUser: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
PresenceIndicator.defaultProps = {
  isConnected: false
};
/* harmony default export */ __webpack_exports__["a"] = (PresenceIndicator);

/***/ }),

/***/ "fQXI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fQjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl__ = __webpack_require__("C8Tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AutoSyncCallout__ = __webpack_require__("fysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__model__ = __webpack_require__("VN3N");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var CONNECT_ERROR_MESSAGE = 'We could not fetch your Pardot settings.';

var PardotConfig = function (_Component) {
  _inherits(PardotConfig, _Component);

  function PardotConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PardotConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PardotConfig.__proto__ || Object.getPrototypeOf(PardotConfig)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pardotSyncProspectsEnabled: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][0],
      pardotShouldOnlySyncQualifiedContacts: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][1],
      pardotShouldSetLeadOwner: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][2],
      syncConversationTranscriptsEnabled: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][3],
      pardotShouldSetProspectCampaign: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][4],
      cookieIdentificationEnabled: __WEBPACK_IMPORTED_MODULE_9__model__["b" /* model */][5]
    }, _this.onError = function () {
      var router = _this.context.router;


      _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
      // router.push({ pathname: `/settings/setup/${PARDOT_APP_ID}` })
    }, _this.onPatchError = function () {
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.receiveToggles = function (resp) {
      var hydratedModel = Object(__WEBPACK_IMPORTED_MODULE_9__model__["a" /* hydrateModel */])(resp);
      _this.setState({
        pardotSyncProspectsEnabled: hydratedModel[0],
        pardotShouldOnlySyncQualifiedContacts: hydratedModel[1],
        pardotShouldSetLeadOwner: hydratedModel[2],
        syncConversationTranscriptsEnabled: hydratedModel[3],
        pardotShouldSetProspectCampaign: hydratedModel[4],
        cookieIdentificationEnabled: hydratedModel[5]
      });
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('Pardot settings are updated!');
    }, _this.patchToggle = function (event, toggle) {
      var data = _defineProperty({}, toggle.type, event);

      Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["K" /* patchPardotConfig */])(data).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('Pardot settings are updated!');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PardotConfig, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["B" /* getPardotConfig */])().then(this.receiveToggles).catch(this.onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          pardotSyncProspectsEnabled = _state.pardotSyncProspectsEnabled,
          pardotShouldOnlySyncQualifiedContacts = _state.pardotShouldOnlySyncQualifiedContacts,
          pardotShouldSetLeadOwner = _state.pardotShouldSetLeadOwner,
          syncConversationTranscriptsEnabled = _state.syncConversationTranscriptsEnabled,
          pardotShouldSetProspectCampaign = _state.pardotShouldSetProspectCampaign,
          cookieIdentificationEnabled = _state.cookieIdentificationEnabled;

      // drift -> pardot toggles

      var driftPardotToggles = [pardotSyncProspectsEnabled, pardotShouldOnlySyncQualifiedContacts, pardotShouldSetLeadOwner, syncConversationTranscriptsEnabled, pardotShouldSetProspectCampaign];

      // pardot -> drift toggles
      var pardotDriftToggles = [cookieIdentificationEnabled];

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Pardot Integration',
          backLinkUrl: '/settings/setup/pardot'
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Synced Pardot Data'
          ),
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Pardot and Drift.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Drift',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Pardot'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AutoSyncCallout__["a" /* default */], { integrationName: 'Pardot' }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__["a" /* default */], {
          toggles: driftPardotToggles,
          onChange: this.patchToggle,
          onSuccess: this.settingsUpdatedNotification
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Pardot',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Drift'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__["a" /* default */], {
          toggles: pardotDriftToggles,
          onChange: this.patchToggle,
          onSuccess: this.settingsUpdatedNotification
        })
      );
    }
  }]);

  return PardotConfig;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

PardotConfig.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__["a" /* default */])(PardotConfig));

/***/ }),

/***/ "fQqe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fQuc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(121);

/***/ }),

/***/ "fRuY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_TagColorSelector__ = __webpack_require__("N98/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_TagDropDownList_styl__ = __webpack_require__("IJHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_TagDropDownList_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_styles_components_settings_tags_TagDropDownList_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.









var TagColorSelectorDropdown = React.createClass({
  displayName: 'TagColorSelectorDropdown',


  propTypes: {
    colorClicked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
    onClickOutside: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
  },

  onColorClick: function onColorClick(tagColor) {
    return this.props.colorClicked(tagColor);
  },
  render: function render() {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_0_components_DropDown__["a" /* default */],
      {
        className: 'TagColorSelectDropdown tag-color-select-dropdown',
        onClickOutside: this.props.onClickOutside },
      React.createElement(
        'div',
        { className: 'title' },
        'Pick Tag Color'
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_TagColorSelector__["a" /* default */], this.props)
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (TagColorSelectorDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "fUPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("cmMt");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var mapStateToProps = function mapStateToProps(state, _ref) {
  var playbookId = _ref.params.playbookId;
  return {
    playbookId: playbookId,
    orgUsers: __WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    userListIds: __WEBPACK_IMPORTED_MODULE_4_app_modules_segment_selectors__["e" /* segments */](state),
    emailMessage: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["w" /* emailMessage */](state),
    emailRenderedPreview: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_15" /* getRenderedEmailPreview */](state, playbookId),
    defaultEmbed: __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["h" /* getEmbedConfig */](state),
    sendTestEmailLoading: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_19" /* getSendTestEmailLoading */](state),
    isTemplateContactPreviewLoading: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_51" /* isTemplateContactPreviewLoading */](state),
    firstAction: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["B" /* firstAction */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setEmailTheme: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_167" /* setEmailTheme */],
      sendTestEmail: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_125" /* sendTestEmail */],
      fetchRenderedEmailPreview: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["Z" /* fetchDataPreviewEmail */],
      fetchSegmentList: __WEBPACK_IMPORTED_MODULE_5_app_modules_segment_actions__["d" /* fetchSegmentList */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref2) {
  var defaultEmbed = _ref2.defaultEmbed,
      orgUsers = _ref2.orgUsers;
  return !defaultEmbed || !orgUsers.size;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var actions = this.props.actions;

    actions.fetchSegmentList();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    message: props.emailMessage.message,
    headline: props.emailMessage.title,
    fromNameOverride: props.emailMessage.sendFromOverride,
    fromEmailOverride: props.emailMessage.senderEmailOverride,
    simpleSelected: props.emailMessage.emailTheme === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_20" /* EmailThemeType */].SIMPLE,
    styledSelected: props.emailMessage.emailTheme === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_20" /* EmailThemeType */].STYLED,
    backgroundColor: props.defaultEmbed.theme.backgroundColor,
    organizationName: props.defaultEmbed.organizationName,
    selectedUser: props.orgUsers.toJS().find(function (user) {
      return user.id === props.emailMessage.authorId;
    }),
    userListIdOptions: props.userListIds.map(function (segment) {
      return _extends(segment.toJS(), { label: segment.name, value: segment.id });
    }).toJS(),
    EmailPreviewView: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */]
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedPreview', 'changeSelectedPreview', __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('selectedUserListOption', 'changeUserListOption', undefined), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    showRenderedPreview: props.selectedPreview === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onStyledClick: function onStyledClick(props) {
    return function () {
      var setEmailTheme = props.actions.setEmailTheme;

      setEmailTheme(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_20" /* EmailThemeType */].STYLED);
    };
  },
  onSimpleClick: function onSimpleClick(props) {
    return function () {
      var setEmailTheme = props.actions.setEmailTheme;

      setEmailTheme(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_20" /* EmailThemeType */].SIMPLE);
    };
  },
  onSendTestEmailClick: function onSendTestEmailClick(props) {
    return function () {
      var sendTestEmail = props.actions.sendTestEmail;

      sendTestEmail({});
    };
  },
  onDefaultPreviewClick: function onDefaultPreviewClick(props) {
    return function () {
      var changeSelectedPreview = props.changeSelectedPreview,
          playbookId = props.playbookId,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      fetchRenderedEmailPreview({ playbookId: playbookId, userListIds: [] });
      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].DEFAULTS);
    };
  },
  onTemplatePreviewClick: function onTemplatePreviewClick(props) {
    return function () {
      var changeSelectedPreview = props.changeSelectedPreview;

      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE);
    };
  },
  onRenderedPreviewClick: function onRenderedPreviewClick(props) {
    return function () {
      var changeSelectedPreview = props.changeSelectedPreview;

      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA);
    };
  },
  onRefreshPreviewClick: function onRefreshPreviewClick(props) {
    return function () {
      var selectedUserListOption = props.selectedUserListOption,
          firstAction = props.firstAction,
          playbookId = props.playbookId,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      if (!!selectedUserListOption)
        // make sure the option from the select box was not the "null" option
        fetchRenderedEmailPreview({ playbookId: playbookId, userListIds: [selectedUserListOption.id], campaignId: firstAction.get('campaignId') });
    };
  },
  handleChangeUserListOption: function handleChangeUserListOption(props) {
    return function (option) {
      var changeUserListOption = props.changeUserListOption,
          changeSelectedPreview = props.changeSelectedPreview,
          firstAction = props.firstAction,
          playbookId = props.playbookId,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      changeUserListOption(option);
      fetchRenderedEmailPreview({ playbookId: playbookId, userListIds: [option.id], campaignId: firstAction.get('campaignId') });
      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));

/***/ }),

/***/ "fZJU":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 20 24\"><path d=\"M19 6h-1.09l-1.805 16.117A2.143 2.143 0 0 1 14 24H6a2.14 2.14 0 0 1-2.104-1.885L2.12 6H1a1 1 0 0 1 0-2h5V3c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h5a1 1 0 0 1 0 2zm-7-3c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1h4V3zM4.132 6l1.753 15.897c.004.04.075.103.115.103h8c.04 0 .113-.065.118-.105L15.898 6H4.132z\" class=\"cls-1\"></path></svg>"

/***/ }),

/***/ "faNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__ = __webpack_require__("69aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__ = __webpack_require__("KOTG");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var IS_IN_WATCHLIST = "has key:value";
var NOT_IS_IN_WATCHLIST = "does not have key:value";
var IS_WATCHLIST_VALUE_NULL = "has a null value";
var NOT_IS_WATCHLIST_VALUE_NULL = "does not have a null value";

var OPTIONS = [{ value: 'isInWatchlist', text: IS_IN_WATCHLIST }, { value: 'notIsInWatchlist', text: NOT_IS_IN_WATCHLIST }, { value: 'isWatchlistValueNull', text: IS_WATCHLIST_VALUE_NULL }, { value: 'notIsWatchlistValueNull', text: NOT_IS_WATCHLIST_VALUE_NULL }];

var DemandbaseWatchlistInputs = function (_Component) {
  _inherits(DemandbaseWatchlistInputs, _Component);

  function DemandbaseWatchlistInputs() {
    _classCallCheck(this, DemandbaseWatchlistInputs);

    return _possibleConstructorReturn(this, (DemandbaseWatchlistInputs.__proto__ || Object.getPrototypeOf(DemandbaseWatchlistInputs)).apply(this, arguments));
  }

  _createClass(DemandbaseWatchlistInputs, [{
    key: 'onAddString',
    value: function onAddString() {
      var strings = this.props.conditionValue.get('value');
      this.props.conditionUpdater('value', strings.push(""));
    }
  }, {
    key: 'makeOnRemove',
    value: function makeOnRemove(index) {
      var _this2 = this;

      return function () {
        var strings = _this2.props.conditionValue.get('value');
        _this2.props.conditionUpdater('value', strings.splice(index, 1));
      };
    }
  }, {
    key: 'makeStringInputChange',
    value: function makeStringInputChange(index, event) {
      var value = event.target ? event.target.value : event.value;

      var strings = this.props.conditionValue.get('value');
      this.props.conditionUpdater('value', strings.set(index, value));
    }
  }, {
    key: 'renderAddButton',
    value: function renderAddButton() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["a" /* AddIcon */], {
        onClick: this.onAddString.bind(this)
      });
    }
  }, {
    key: 'renderRemoveIcon',
    value: function renderRemoveIcon(index) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["c" /* RemoveIcon */], {
        onClick: this.makeOnRemove(index)
      });
    }
  }, {
    key: 'renderStringInput',
    value: function renderStringInput(value, index, placeholder) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], {
        onChange: function onChange(value) {
          return _this3.makeStringInputChange(index, value);
        },
        value: value,
        placeholder: placeholder
      });
    }
  }, {
    key: 'onOperatorSelect',
    value: function onOperatorSelect(operator) {
      this.props.conditionUpdater('operator', operator);
    }
  }, {
    key: 'getSelectedValue',
    value: function getSelectedValue() {
      var conditionValue = this.props.conditionValue;

      return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          conditionValue = _props.conditionValue,
          optionTypes = _props.optionTypes;

      var strings = conditionValue.get('value');
      var selects = strings.map(function (stringToMatch, index, _ref) {
        var size = _ref.size;

        var actionButton = void 0;
        if (index === 0) {
          actionButton = _this4.renderAddButton();
        } else {
          actionButton = _this4.renderRemoveIcon(index);
        }
        var node = [_this4.renderStringInput(stringToMatch, index, conditionValue.get('placeholder')), actionButton];
        if (index != size - 1) {
          node.push(__WEBPACK_IMPORTED_MODULE_3__IsAnyOfInputs__["b" /* OrNode */]);
        }
        return node;
      });

      var options = _.filter(OPTIONS, function (_ref2) {
        var value = _ref2.value;
        return optionTypes.includes(value);
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'flex-space-around flex-1 flex-wrap' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_SimpleSelect__["a" /* default */], {
          onSelection: this.onOperatorSelect.bind(this),
          options: options,
          selectedValue: this.getSelectedValue()
        }),
        selects
      );
    }
  }]);

  return DemandbaseWatchlistInputs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DemandbaseWatchlistInputs.defaultProps = {
  optionTypes: ['isInWatchlist', 'notIsInWatchlist', 'isWatchlistValueNull', 'notIsWatchlistValueNull']
};


/* harmony default export */ __webpack_exports__["a"] = (DemandbaseWatchlistInputs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "fdBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("gCgU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var DefaultBotAvatar = function DefaultBotAvatar(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? "000" : _ref$backgroundColor;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-preview-default-bot-avatar', style: { background: '#' + backgroundColor } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      { viewBox: '0 0 277 276' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { transform: 'translate(.22 .462)', fill: 'none', fillRule: 'evenodd' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '1.78', y: '1.538', width: '273', height: '272.443', rx: '10' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M185.99 275.256h80.127a9.988 9.988 0 0 0 9.991-9.991V10.246c0-5.517-4.473-9.99-9.99-9.99H10.536a9.988 9.988 0 0 0-9.991 9.99v255.019c0 5.517 4.473 9.99 9.99 9.99H86.46V260.75c4.152-20.961 21.273-37.27 42.671-40.255v-10.092H57.319c-4.68 0-8.453-3.773-8.453-8.427v-97.758c0-4.647 3.78-8.428 8.445-8.428h64.862V82.035h13.745V58.33c-5.339-1.888-9.164-6.983-9.164-12.971 0-7.596 6.154-13.754 13.746-13.754 7.59 0 13.745 6.158 13.745 13.754 0 5.988-3.825 11.083-9.164 12.97v23.706h13.745V95.79h60.264c4.669 0 8.462 3.773 8.462 8.428v97.758c0 4.647-3.785 8.427-8.454 8.427H144.18v10.223c21.024 3.31 37.756 19.512 41.81 40.24v14.39z', fill: '#FFF', opacity: '.85' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { fill: '#FFF', x: '72.994', y: '123.785', width: '131.425', height: '41.376', rx: '10' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { opacity: '.5', cx: '101.112', cy: '145.301', rx: '14.886', ry: '14.895' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { opacity: '.5', cx: '172.234', cy: '145.301', rx: '14.886', ry: '14.895' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { fill: '#000', opacity: '.6', cx: '101.112', cy: '145.301', rx: '14.886', ry: '14.895' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse', { fill: '#000', opacity: '.6', cx: '172.234', cy: '145.301', rx: '14.886', ry: '14.895' })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DefaultBotAvatar);

/***/ }),

/***/ "fdmG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fdnL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailEditCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_picture_drawing_svg__ = __webpack_require__("/3JQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_picture_drawing_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_picture_drawing_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_UIDropArea__ = __webpack_require__("o4YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TinyEditor__ = __webpack_require__("wfRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__("ExgD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_svg_twitter_svg__ = __webpack_require__("bQtw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_images_svg_twitter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_images_svg_twitter_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_svg_linkedin_svg__ = __webpack_require__("88Th");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_svg_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_svg_linkedin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_svg_facebook_svg__ = __webpack_require__("kTiu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_images_svg_facebook_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_images_svg_facebook_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("aUxz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















var EmailEditCard = function EmailEditCard(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "Email" : _ref$title,
      description = _ref.description,
      onDeleteClick = _ref.onDeleteClick,
      narrowHeader = _ref.narrowHeader,
      includeSenderSelect = _ref.includeSenderSelect,
      senderName = _ref.senderName,
      onHeadlineChange = _ref.onHeadlineChange,
      headline = _ref.headline,
      message = _ref.message,
      onMessageChange = _ref.onMessageChange,
      placeholderName = _ref.placeholderName,
      emailOverride = _ref.emailOverride,
      _ref$actions = _ref.actions,
      fetchEmbed = _ref$actions.fetchEmbed,
      fetchOrg = _ref$actions.fetchOrg,
      embedFetchPending = _ref.embedFetchPending,
      dynamicAccountSendAttribute = _ref.dynamicAccountSendAttribute,
      onSenderNameChange = _ref.onSenderNameChange,
      onUserIdChange = _ref.onUserIdChange,
      _ref$selectedUserId = _ref.selectedUserId,
      selectedUserId = _ref$selectedUserId === undefined ? null : _ref$selectedUserId,
      renderSelectedUser = _ref.renderSelectedUser,
      _ref$includeInboxEmai = _ref.includeInboxEmails,
      includeInboxEmails = _ref$includeInboxEmai === undefined ? true : _ref$includeInboxEmai,
      hasDynamicSenderEnabled = _ref.hasDynamicSenderEnabled,
      _ref$sendTestLoading = _ref.sendTestLoading,
      sendTestLoading = _ref$sendTestLoading === undefined ? false : _ref$sendTestLoading,
      onSendTestEmailClick = _ref.onSendTestEmailClick,
      _ref$showInlineTestEm = _ref.showInlineTestEmail,
      showInlineTestEmail = _ref$showInlineTestEm === undefined ? false : _ref$showInlineTestEm,
      showCompanyLogo = _ref.showCompanyLogo,
      showHeroImage = _ref.showHeroImage,
      showCompanyFooter = _ref.showCompanyFooter,
      orgLogoUrl = _ref.orgLogoUrl,
      orgName = _ref.orgName,
      orgTwitterUrl = _ref.orgTwitterUrl,
      orgLinkedinUrl = _ref.orgLinkedinUrl,
      orgFacebookUrl = _ref.orgFacebookUrl,
      orgAddress = _ref.orgAddress,
      onBannerUpload = _ref.onBannerUpload,
      bannerImageUrl = _ref.bannerImageUrl,
      onBannerClear = _ref.onBannerClear,
      isOrgLoaded = _ref.isOrgLoaded,
      isBannerUploadPending = _ref.isBannerUploadPending,
      defaultUser = _ref.defaultUser,
      onEditSenderClick = _ref.onEditSenderClick;
  return React.createElement(
    'div',
    { className: 'playbook-message' },
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Card__["a" /* default */],
      {
        title: title,
        description: !!description ? description : headline,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("drift-form", "playbook-email-message-edit", { "padded-email-edit-card": !hasDynamicSenderEnabled }),
        onDeleteClick: onDeleteClick,
        narrowHeader: narrowHeader
      },
      includeSenderSelect && !hasDynamicSenderEnabled && React.createElement(
        'div',
        { className: 'playbook-email-edit-card-non-dynamic-header' },
        React.createElement(
          'div',
          { className: 'playbook-edit-message-heading' },
          'Sender Name and Email'
        ),
        React.createElement('input', {
          className: 'playbook-email-message-input-stacked',
          type: 'text',
          onChange: onSenderNameChange,
          value: senderName,
          placeholder: 'Sender name'
        }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_UserSelect__["a" /* default */], {
          selectedUserId: selectedUserId,
          onUserIdChange: onUserIdChange,
          renderOption: function renderOption(user) {
            return !!user.name ? user.email + ' (' + user.name + ')' : user.email;
          },
          renderSelectedValue: renderSelectedUser,
          includeInboxEmails: includeInboxEmails
        }),
        React.createElement(
          'div',
          { className: 'playbook-edit-message-heading' },
          'Subject Line'
        ),
        React.createElement('input', { type: 'text', className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(_defineProperty({}, "playbook-edit-message-subject-input", showInlineTestEmail)), onChange: onHeadlineChange, value: !!description ? description : headline }),
        showInlineTestEmail && React.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', onClick: onSendTestEmailClick, loading: sendTestLoading },
          'Send Test Email'
        )
      ),
      includeSenderSelect && hasDynamicSenderEnabled && React.createElement(
        'div',
        { className: 'playbook-email-edit-card-top' },
        React.createElement(
          'div',
          { className: 'playbook-email-edit-card-sender' },
          React.createElement(
            'span',
            { className: 'playbook-email-edit-card-header' },
            'Sender'
          ),
          dynamicAccountSendAttribute ? React.createElement(__WEBPACK_IMPORTED_MODULE_0_shared_web_src_components_Tag___default.a, { className: 'playbook-email-edit-dynamic-sender-attrib', tag: { name: '{{ account.' + dynamicAccountSendAttribute + ' }}' } }) : React.createElement(
            'span',
            null,
            senderName || placeholderName,
            ' <',
            emailOverride || defaultUser.email,
            '>'
          ),
          React.createElement(
            'a',
            { onClick: onEditSenderClick, className: 'playbook-email-edit-card-sender-edit-link' },
            'edit'
          )
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-card-subject' },
          React.createElement(
            'span',
            { className: 'playbook-email-edit-card-header' },
            'Subject'
          ),
          React.createElement('input', { className: 'playbook-email-edit-card-subject-input', placeholder: '[No Subject] - Required', type: 'text', onChange: onHeadlineChange, value: !!description ? description : headline }),
          showInlineTestEmail && React.createElement(
            __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', size: 'small', onClick: onSendTestEmailClick, loading: sendTestLoading },
            'Send Test Email'
          )
        )
      ),
      showCompanyLogo && React.createElement(
        'div',
        { className: 'playbook-email-edit-header-image' },
        !!orgLogoUrl && React.createElement('img', { src: orgLogoUrl }),
        !!!orgLogoUrl && React.createElement(
          'p',
          null,
          'You do not have company logo in your Drift account.'
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-header-meta' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
            { target: '_blank', className: 'playbook-email-edit-meta-link', to: '/settings/company' },
            'Edit Logo'
          ),
          '|',
          React.createElement(
            'span',
            {
              className: 'playbook-email-edit-meta-link playbook-email-edit-meta-refresh-header',
              onClick: fetchOrg
            },
            'Refresh Logo',
            !isOrgLoaded && React.createElement(
              'span',
              { className: 'playbook-email-edit-loading' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_LoadingDots__["a" /* default */], null)
            )
          )
        )
      ),
      showHeroImage && React.createElement(
        'div',
        { className: 'playbook-email-edit-header-image' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_6_components_shared_UIDropArea__["a" /* default */],
          {
            onDrop: onBannerUpload,
            onClear: onBannerClear,
            shouldRenderClear: false,
            shouldRenderPreview: false,
            className: 'playbook-email-edit-banner-drop-area'
          },
          bannerImageUrl && React.createElement('img', { src: bannerImageUrl }),
          !bannerImageUrl && React.createElement(
            'div',
            { className: 'playbook-email-edit-banner-drop-zone' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'playbook-email-edit-empty-banner-icon' },
                React.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_picture_drawing_svg___default.a, width: "20px" })
              ),
              !isBannerUploadPending && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-title' },
                  'Add a banner image.'
                ),
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-title' },
                  'Drag and drop or ',
                  React.createElement(
                    'span',
                    { className: 'link' },
                    'Upload'
                  )
                )
              ),
              isBannerUploadPending && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-title' },
                  'Uploading your banner image.'
                ),
                React.createElement(
                  'div',
                  { className: 'playbook-email-edit-banner-upload-loading-container' },
                  React.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_LoadingDots__["a" /* default */], null)
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'playbook-edit-banner-help-text' },
              React.createElement(
                'p',
                null,
                'Keep in mind that your image will be scaled to 600px wide in the email.'
              )
            )
          )
        ),
        bannerImageUrl && React.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { className: 'playbook-email-edit-banner-clear', type: 'secondary', onClick: onBannerClear },
          'Clear Image'
        )
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_9__TinyEditor__["a" /* default */], { initialContent: message, onChange: onMessageChange, noOuterBorder: hasDynamicSenderEnabled, showCtaInsert: true }),
      showCompanyFooter && React.createElement(
        'div',
        { className: 'playbook-email-edit-footer' },
        React.createElement(
          'div',
          { className: 'playbook-email-edit-social-links' },
          !!orgTwitterUrl && React.createElement(
            'a',
            { target: '_blank', href: orgTwitterUrl },
            React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_11_images_svg_twitter_svg___default.a })
          ),
          !!orgLinkedinUrl && React.createElement(
            'a',
            { target: '_blank', href: orgLinkedinUrl },
            React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_12_images_svg_linkedin_svg___default.a })
          ),
          !!orgFacebookUrl && React.createElement(
            'a',
            { target: '_blank', href: orgFacebookUrl },
            React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_13_images_svg_facebook_svg___default.a })
          )
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-footer-text' },
          orgName
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-footer-text playbook-email-edit-footer-text-small' },
          orgAddress
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-footer-text-muted' },
          React.createElement(
            'a',
            null,
            'Click here to unsubscribe'
          )
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-edit-footer-meta' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
            { className: 'playbook-email-edit-footer-meta-link', target: '_blank', to: '/settings/company' },
            'Edit Footer'
          ),
          '|',
          React.createElement(
            'span',
            { className: 'playbook-email-edit-footer-meta-link', onClick: function onClick() {
                return fetchEmbed();
              } },
            'Refresh Footer',
            embedFetchPending && React.createElement(
              'span',
              { className: 'playbook-email-edit-loading' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_8_components_shared_LoadingDots__["a" /* default */], null)
            )
          )
        )
      )
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "feRR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fef1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants_js__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("um7b");










var mapStateToProps = function mapStateToProps(state, props) {
  var goals = __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["b" /* allGoals */](state);
  return {
    playbook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_11" /* getPlaybook */](state, props),
    classifications: __WEBPACK_IMPORTED_MODULE_4_app_modules_classification_selectors__["b" /* classifications */](state),
    goal: goals.find(function (goal) {
      return goal.get('id') === props.goalId;
    })
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps), __WEBPACK_IMPORTED_MODULE_2_recompose_withProps___default()(function (props) {
  return {
    loaded: !!props.playbook && !!props.goal,
    isLeadBotPlaybook: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_constants_js__["_296" /* isLeadBotPlaybook */])(props.playbook.reportType)
  };
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "fg5y":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "fgsc":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 9 16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FEF899\" d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061z\"></path><path d=\"M5.922 1L1 8.629h3.61L2.421 15 8 7.12H4.061L5.921 1zm-.85 5.37H8a.75.75 0 0 1 .612 1.183l-5.578 7.88c-.5.708-1.603.143-1.321-.677L3.559 9.38H1a.75.75 0 0 1-.63-1.157L5.292.593c.471-.73 1.6-.207 1.347.625L5.073 6.37z\" fill=\"#E8AD0E\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),

/***/ "fhvE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ColorPicker":"ColorPicker---3UavJ"};

/***/ }),

/***/ "fi0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PARTICIPANT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PARTICIPANT_TYPE_OPTIONS; });
var PARTICIPANT_TYPES = Object.freeze({
  'SINGLE': 'SINGLE',
  'GROUP': 'GROUP',
  'TEAM': 'TEAM'
});

var PARTICIPANT_TYPE_OPTIONS = Object.freeze([{
  label: "Add a single person or account owner",
  value: PARTICIPANT_TYPES.SINGLE
}, {
  label: "Round robin within a group",
  value: PARTICIPANT_TYPES.GROUP
}, {
  label: "Round robin within a team",
  value: PARTICIPANT_TYPES.TEAM
}]);

/***/ }),

/***/ "fk1d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("Oa/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Otj0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);







var PreviewButtons = function PreviewButtons(_ref) {
  var previewState = _ref.previewState,
      onPreviewStateChanged = _ref.onPreviewStateChanged;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.PreviewButtons },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      'Preview:'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'buttons' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        {
          onClick: onPreviewStateChanged(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* PreviewState */].ONLINE),
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: previewState === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* PreviewState */].ONLINE }) },
        'Online'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'button',
        {
          onClick: onPreviewStateChanged(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* PreviewState */].AWAY),
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ selected: previewState === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* PreviewState */].AWAY }) },
        'Offline'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PreviewButtons);

/***/ }),

/***/ "fk1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("GwZk");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var status = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchOverview */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchOverviewPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchOverviewFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* receiveOverview */]), function (_state, action) {
  return action.type;
}), false);

var data = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* receiveOverview */], function (_state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({ status: status, data: data }));

/***/ }),

/***/ "fkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("ZhFk");











var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    emailMessage: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["w" /* emailMessage */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    dynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["t" /* dynamicAccountSendAttribute */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setSenderName: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_189" /* setSenderName */],
      setMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_181" /* setMessage */],
      setHeadline: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_177" /* setHeadline */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_138" /* setAuthorId */],
      setEmailOverride: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_165" /* setEmailOverride */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var orgUsers = _ref.orgUsers;
  return !orgUsers.size;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    message: props.emailMessage.message,
    headline: props.emailMessage.title,
    selectedValue: props.emailMessage.senderEmailOverride
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  renderSelectedUser: function renderSelectedUser(props) {
    return function (option) {
      var selectedUser = props.orgUsers.find(function (user) {
        return user.id === option.value.value;
      });
      return React.createElement(
        'div',
        { className: 'Select-value' },
        React.createElement(
          'span',
          { className: 'Select-value-label' },
          !!selectedUser ? selectedUser.email : option.value.value
        )
      );
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "fp2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");



var OrgAPI = Marty.createStateSource({
  id: 'OrgAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  createOrg: function createOrg(settings) {
    return this.post({
      url: '/organizations?clientId=' + __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["f" /* CLIENT_ID */],
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(settings)
    });
  },
  fetchOrgById: function fetchOrgById(orgId) {
    return this.get({
      url: '/organizations/' + orgId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  shareEmailSnippet: function shareEmailSnippet(email, orgId) {
    return this.post({
      url: '/snippets/send?email=' + email,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify([{ email: email }])
    });
  },
  updateOrg: function updateOrg(orgId, update) {
    return this.patch({
      url: '/organizations/' + orgId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(update)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "froD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Content":"Content---22hf8"};

/***/ }),

/***/ "fvUW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (immutable) */ __webpack_exports__["b"] = showParticipantsNotification;
/* unused harmony export formatParticipantsEvent */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatParticipantsNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_utils__ = __webpack_require__("PIqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_conversation_RuleLink__ = __webpack_require__("Vu8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_conversation_PlaybookConversationEvent__ = __webpack_require__("fef1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("CIox");







function showParticipantsNotification(currentUser, authorUserId, participantIds, userProperties) {
  var hasCentralizedRouting = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (hasCentralizedRouting) {
    if (userProperties.get('notifications-snoozed')) {
      return false;
    }
  } else {
    if (currentUser.availability === 'OFFLINE') {
      return false;
    }
  }

  return userProperties.get('humane-notifications-browser', 'nothing') !== 'nothing' && currentUser.id !== authorUserId && participantIds.includes(currentUser.id);
}

function formatParticipantsEvent(authorUserId, firstChatMessage, playbook, conversationEvent, currentUserId, isCurrentUserAdmin, usersById, added, hasCentralizedRouting) {
  var participantIds = conversationEvent.participantIds,
      participantChangeType = conversationEvent.participantChangeType;

  var attributes = firstChatMessage && firstChatMessage.attributes;

  if (participantIds.includes(authorUserId)) {
    var others = getOthers(participantIds, usersById, { filterUser: authorUserId });

    if (added) {
      return others.length > 0 ? 'joined the conversation, and invited ' + others : 'joined the conversation';
    } else {
      return others.length > 0 ? 'left the conversation, along with ' + others : 'left the conversation';
    }
  }

  if (participantChangeType === 'MANUAL') {
    if (authorUserId === 0) {
      var _others = getOthers(participantIds, usersById, { skipFirst: true });

      if (added) {
        return _others.length > 0 ? 'joined the conversation, along with ' + _others : 'joined the conversation';
      } else {
        return _others.length > 0 ? 'left the conversation, along with ' + _others : 'left the conversation';
      }
    }

    return (added ? 'invited' : 'removed') + ' ' + getOthers(participantIds, usersById) + ' ' + (added ? 'to' : 'from') + ' the conversation';
  }

  if (participantChangeType === 'ON_CALL') {
    return 'joined the conversation from ' + (hasCentralizedRouting ? 'the Default Lead Routing Rule' : 'being On-Call');
  }

  if (participantChangeType === 'PLAYBOOK_GOAL' && isCurrentUserAdmin) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_4_components_conversation_PlaybookConversationEvent__["a" /* default */], conversationEvent);
  }

  if (participantChangeType === 'ROUTING_RULE') {
    var _others2 = getOthers(participantIds, usersById, { skipFirst: true });

    if (_others2.length > 0) {
      return React.createElement(
        'span',
        null,
        'joined conversation from Lead Routing Rule ',
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_conversation_RuleLink__["a" /* default */], { ruleId: conversationEvent.ruleId }),
        ', along with ',
        _others2
      );
    }

    return React.createElement(
      'span',
      null,
      'joined conversation from Lead Routing Rule ',
      React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_conversation_RuleLink__["a" /* default */], { ruleId: conversationEvent.ruleId })
    );
  }

  if (participantChangeType === 'DIRECT') {
    // check params set in attributes of first message
    // to deduce precise route
    if (attributes) {
      if (attributes.get("profileMode")) {
        return 'added to the conversation that was started from their Drift Profile';
      }
      if (attributes.get("liveViewInitiated")) {
        return 'joined the conversation from Live View';
      }
    }
    // check whether playbook type contains "ABM" or "OUTBOUND" strings
    var reportType = playbook.get("reportType");
    if (reportType) {
      if (reportType.indexOf("ABM") >= 0) {
        return "joined the conversation from ABM routing";
      }
      if (reportType.indexOf("OUTBOUND") >= 0) {
        return "joined the conversation from an Outbound Email";
      }
    }
    // if nothing matches, return the generic string
    return 'joined the conversation from a Direct Message';
  }

  if (participantChangeType === "PLAYBOOK_ACTION") {
    return React.createElement(
      'span',
      null,
      'joined conversation from Playbook ',
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_router__["c" /* Link */],
        { href: '/playbooks/editor/' + playbook.id + '/' },
        playbook.name
      ),
      'and Route Conversation skill'
    );
  }

  return (added ? 'added' : 'removed') + ' ' + getOthers(participantIds, usersById) + ' ' + (added ? 'to' : 'from') + ' conversation';
}

function formatParticipantsNotification(authorUserId, conversationEvent, usersById, endUser, added) {
  var participantChangeType = conversationEvent.participantChangeType;


  if (participantChangeType === 'ON_CALL') {
    return 'You\u2019ve been added to the conversation with ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser);
  }

  if (participantChangeType === 'ROUTING_RULE') {
    return 'The conversation with ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser) + ' has been routed to you';
  }

  if (participantChangeType === 'DIRECT') {
    return 'You\u2019ve been added to the conversation with ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser) + ' from a Direct Message';
  }

  if (participantChangeType === 'PLAYBOOK_GOAL') {
    return 'You\u2019ve been added to the conversation with ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser) + ' from a Playbook Goal';
  }

  var author = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_utils__["a" /* getUserDisplayName */])(usersById[authorUserId]);
  return author + ' ' + (added ? 'added' : 'removed') + ' you ' + (added ? 'to' : 'from') + ' the conversation with ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(endUser);
}

function getOthers(participantIds, usersById) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var others = participantIds;
  var filterUser = options.filterUser,
      skipFirst = options.skipFirst;


  if (filterUser) {
    others = participantIds.filter(function (id) {
      return id !== filterUser;
    });
  }

  if (skipFirst) {
    others = participantIds.slice(1);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["oxford"])(others.map(function (id) {
    return usersById.get(id);
  }).map(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_utils__["a" /* getUserDisplayName */]).filter(Boolean), 5);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "fvhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export Header */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hotkeys__ = __webpack_require__("S+6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_document_title__ = __webpack_require__("aTtA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_document_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_GlobalSearch__ = __webpack_require__("xKXM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_components_App__ = __webpack_require__("3nos");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_styles_components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_styles_components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("CLoi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_icons_times_icon_svg__ = __webpack_require__("+Juk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_icons_times_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_icons_times_icon_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.handleOpenSearch = function () {
      Object(__WEBPACK_IMPORTED_MODULE_8_components_GlobalSearch__["c" /* openGlobalSearch */])(_this.context);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusHeader();
    }
  }, {
    key: 'getTotalMessageCount',
    value: function getTotalMessageCount() {
      if (!this.props.inboxesById) return;
      return _.chain(this.props.inboxesById).sum('openConversationCount').value();
    }
  }, {
    key: 'getDocumentTitle',
    value: function getDocumentTitle() {
      var totalMessageCount = this.getTotalMessageCount();
      var prefix = totalMessageCount > 0 ? '(' + totalMessageCount + ') ' : '';
      return '' + prefix + __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__["b" /* APP_TITLE */] + ' - ' + this.props.title;
    }
  }, {
    key: 'closeSearch',
    value: function closeSearch() {
      var query = _.cloneDeep(this.context.location.query);
      delete query[__WEBPACK_IMPORTED_MODULE_8_components_GlobalSearch__["a" /* GLOBAL_SEARCH_KEY */]];
      this.context.router.push({ pathname: this.context.location.pathname, query: query });
      this.focusHeader();
    }
  }, {
    key: 'focusHeader',
    value: function focusHeader() {
      var node = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.refs.refHeader);
      node && node.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var globalSearch = null;
      if (this.context.location && this.context.location.query[__WEBPACK_IMPORTED_MODULE_8_components_GlobalSearch__["a" /* GLOBAL_SEARCH_KEY */]] != undefined) {
        globalSearch = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_GlobalSearch__["b" /* GlobalSearch */], {
          onClose: this.closeSearch.bind(this),
          query: this.context.location.query });
      }

      var pageTitle = null;
      if (this.props.showTitle) {
        pageTitle = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.headerTitle },
          this.props.titleNode || this.props.title
        );
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_document_title___default.a,
        { title: this.getDocumentTitle() },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_hotkeys__["HotKeys"],
          {
            handlers: { openSearch: this.handleOpenSearch },
            keyMap: { openSearch: 'command+/' } },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.Header, { navy: this.props.navy }), ref: 'refHeader', style: this.props.style },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.leftColumn },
              this.props.leftNav || null
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.centerColumn },
              pageTitle
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.rightColumn + ' flex-center' },
              this.props.rightNav || null,
              this.renderCloseButton()
            )
          ),
          globalSearch,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.RestContent },
            this.props.children
          )
        )
      );
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton() {
      if (this.props.showClose) {
        var closeIcon = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_13__svg_inline_removeTags_true_images_icons_times_icon_svg___default.a, alt: 'Close Page' });

        if (!!this.props.onClose) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { onClick: this.props.onClose,
              className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.headerClose,
              alt: 'Close Page' },
            closeIcon
          );
        } else if (!!this.props.closePath) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10_react_router__["c" /* Link */],
            { className: __WEBPACK_IMPORTED_MODULE_12__style_styl___default.a.headerClose, to: this.props.closePath },
            closeIcon
          );
        }
      }
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Header.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};
Header.propTypes = {
  leftNav: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element,
  rightNav: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element,
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  titleNode: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element,
  showClose: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  closePath: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  showTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};
Header.defaultProps = {
  showClose: true,
  showTitle: true,
  closePath: '/home'
};
var container = Object(__WEBPACK_IMPORTED_MODULE_6_components_container__["a" /* makeDefaultFailedContainer */])(Header, {
  listenTo: ['stores.InboxStore', 'stores.GateStore'],
  fetch: {
    gates: function gates() {
      return this.app.stores.GateStore.getOrFetchGates();
    },
    inboxesById: function inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (container);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "fysp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl__ = __webpack_require__("LhMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var AutoSyncCallout = function (_Component) {
  _inherits(AutoSyncCallout, _Component);

  function AutoSyncCallout(props) {
    _classCallCheck(this, AutoSyncCallout);

    var _this = _possibleConstructorReturn(this, (AutoSyncCallout.__proto__ || Object.getPrototypeOf(AutoSyncCallout)).call(this, props));

    _this.render = function () {
      var autoSyncEnabled = _this.state.autoSyncEnabled;
      var integrationName = _this.props.integrationName;


      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        null,
        autoSyncEnabled && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["InlineWarning"], {
          className: 'autosync-callout',
          title: 'Session timeouts are enabled for syncing data to your integrations',
          type: 'info',
          icon: 'info',
          copy: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            'div',
            null,
            'Data will sync to ',
            integrationName,
            ' when the conversation\u2019s session ends. Additionally, users can sync data manually at any time during the conversation. ',
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
              'a',
              { href: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2/conversations/advanced', target: '_blank', rel: 'noopener noreferrer' },
              'View session timeout settings'
            )
          )
        })
      );
    };

    _this.state = {
      autoSyncEnabled: false
    };

    __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/conversations/autosync/org/status').checkStatus().map(function (res) {
      return res.response;
    }).catch(function (e) {}).subscribe(function (data) {
      _this.setState({ autoSyncEnabled: data.enabled });
    });
    return _this;
  }

  return AutoSyncCallout;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AutoSyncCallout);

/***/ }),

/***/ "g+Sm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Widget":"Widget---1dxAI","icon-type-dismiss":"icon-type-dismiss---nfVi2","Widget__Count":"Widget__Count---1rK42"};

/***/ }),

/***/ "g0Sp":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "g3z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("adG0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("6THR");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "g41V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g7iH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__("4gqt");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/*
 * expected props:
 *
 * multiSignature -> Immutable.Map() - the response payload from the server
 * multiSignaturePreviewFetchPending -> boolean - whether the fetch for the multi signature is in flight
 * multiSignaturePreviewFetchFailed -> boolean - whether the last fetch failed
 * onRefetchClick -> function - the function to call when re-trying a multi signature fetch
 *
 * all the other props are internal to the component
 */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["j" /* withState */])('selectedSignatureIndex', 'setSelectedSignatureIndex', 0), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["i" /* withProps */])(function (props) {
  var noBannerSigId = props.multiSignature.get('noBannerSignatureId');
  var nonEmptySigIds = [].concat(_toConsumableArray(props.multiSignature.get('populatedSignatures', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).filter(function (sig, sigId) {
    return sigId !== '' + noBannerSigId;
  }).keys()));
  var currentlyViewingSignature = props.selectedSignatureIndex === nonEmptySigIds.length ? props.multiSignature.getIn(['populatedSignatures', '' + noBannerSigId]) : props.multiSignature.getIn(['populatedSignatures', '' + nonEmptySigIds[props.selectedSignatureIndex]]);

  return {
    viewingSignatureNumber: props.selectedSignatureIndex === nonEmptySigIds.length ? 'No Banner' : props.selectedSignatureIndex + 1 + ' / ' + nonEmptySigIds.length,
    doCycle: props.multiSignature.get('doCycle', false),
    numSignatures: nonEmptySigIds.length,
    currentlyViewingSignature: currentlyViewingSignature,
    noBannerSigId: noBannerSigId
  };
}), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["h" /* withHandlers */])({
  onNextSignatureClick: function onNextSignatureClick(props) {
    return function () {
      props.setSelectedSignatureIndex((props.selectedSignatureIndex + 1) % (!!props.noBannerSigId ? props.numSignatures + 1 : props.numSignatures));
    };
  },
  onPreviousSignatureClick: function onPreviousSignatureClick(props) {
    return function () {
      var next = props.selectedSignatureIndex - 1;
      if (next === -1) {
        props.setSelectedSignatureIndex(!!props.noBannerSigId ? props.numSignatures : props.numSignatures - 1);
      } else {
        props.setSelectedSignatureIndex(next);
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),

/***/ "g9fI":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyOSAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjggMTNoLTN2M2ExIDEgMCAwIDEtMiAwdi0zaC0zYTEgMSAwIDAgMSAwLTJoM1Y4YTEgMSAwIDAgMSAyIDB2M2gzYTEgMSAwIDAgMSAwIDJ6bS0xNS4xNzcuNEMxNi45MiAxNC41NyAyMCAxOC4xODYgMjAgMjIuMzM0VjIzYTEgMSAwIDAgMS0xIDFIMWExIDEgMCAwIDEtMS0xdi0uNjY2YzAtNC4xNDggMy4wOC03Ljc2NCA3LjE3Ny04LjkzNEM0LjcyIDEyLjMxMiAzIDkuODU1IDMgN2MwLTMuODYgMy4xNC03IDctN3M3IDMuMTQgNyA3YzAgMi44NTUtMS43MiA1LjMxMi00LjE3NyA2LjR6TTIuMDEgMjJoMTUuOThjLS4xOTYtMy44MjctMy43NzYtNy03Ljk5LTdzLTcuNzkzIDMuMTczLTcuOTkgN3pNMTAgMkM3LjI0MyAyIDUgNC4yNDMgNSA3czIuMjQzIDUgNSA1IDUtMi4yNDMgNS01LTIuMjQzLTUtNS01eiIgZmlsbD0iIzAxNzZGRiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "gA9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var SendButton = function SendButton(_ref) {
  var emailButtonLabel = _ref.emailButtonLabel,
      onClick = _ref.onClick,
      isSaved = _ref.isSaved,
      className = _ref.className,
      sendEmailButtonActive = _ref.sendEmailButtonActive,
      disabled = _ref.disabled,
      hasSegmentsSelected = _ref.hasSegmentsSelected;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'button',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'drift-button-primary', className),
      disabled: !sendEmailButtonActive || !isSaved || disabled || !hasSegmentsSelected,
      onClick: onClick
    },
    emailButtonLabel
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SendButton);

/***/ }),

/***/ "gBvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);



var TooltipAvatar = function TooltipAvatar(_ref) {
  var tooltipName = _ref.tooltipName,
      _ref$flow = _ref.flow,
      flow = _ref$flow === undefined ? 'up' : _ref$flow,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'user' : _ref$type,
      _ref$team = _ref.team,
      team = _ref$team === undefined ? {} : _ref$team,
      _ref$user = _ref.user,
      user = _ref$user === undefined ? {} : _ref$user,
      _ref$company = _ref.company,
      company = _ref$company === undefined ? {} : _ref$company;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
    { flow: flow, component: tooltipName },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Avatar"], { type: type, team: team, user: user, company: company })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TooltipAvatar);

/***/ }),

/***/ "gC8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_enum___default.a(['ANY', 'CONVERSATION']));

/***/ }),

/***/ "gCgU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gDdS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 23 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.5 11.64L19.7.44a1.5 1.5 0 1 1 2.12 2.12L9.81 14.57c-.034.036-.07.07-.108.1a1.5 1.5 0 0 1-2.258.156L1.19 8.57a1.5 1.5 0 1 1 2.12-2.12l5.19 5.19z\" id=\"color\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "gFEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_images_svg_targeting_display_heart_svg__ = __webpack_require__("A38K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_inline_images_svg_targeting_display_heart_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__svg_inline_images_svg_targeting_display_heart_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_images_svg_targeting_display_target_svg__ = __webpack_require__("f9IB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_inline_images_svg_targeting_display_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__svg_inline_images_svg_targeting_display_target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_snooze_window_svg__ = __webpack_require__("tJQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_snooze_window_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_snooze_window_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_sun_window_svg__ = __webpack_require__("W68D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_sun_window_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_sun_window_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TargetingOption__ = __webpack_require__("oz/I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("Yt9r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);









var TargetingDisplay = function TargetingDisplay(_ref) {
  var onDisplayClick = _ref.onDisplayClick,
      onAlwaysClick = _ref.onAlwaysClick,
      alwaysSelected = _ref.alwaysSelected,
      displayTargetingSelected = _ref.displayTargetingSelected,
      isOnFreePlan = _ref.isOnFreePlan,
      onDisplayOnlineClick = _ref.onDisplayOnlineClick,
      onDisplayOfflineClick = _ref.onDisplayOfflineClick,
      displayOnlineSelected = _ref.displayOnlineSelected,
      displayOfflineSelected = _ref.displayOfflineSelected;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.TargetingDisplay },
    React.createElement(
      'header',
      { className: 'playbook-title-header' },
      React.createElement(
        'h2',
        null,
        'Where would you like to display this Playbook?'
      ),
      React.createElement(
        'p',
        null,
        'Display to visitors who match the following conditions:'
      )
    ),
    React.createElement(
      'div',
      { className: 'playbook-targeting-choice-list' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4__TargetingOption__["a" /* default */], {
        iconSrc: __WEBPACK_IMPORTED_MODULE_0__svg_inline_images_svg_targeting_display_heart_svg___default.a,
        isSelected: alwaysSelected,
        handleClick: onAlwaysClick,
        label: 'Display Always',
        description: 'Display this playbook on any page, at any time.'
      }),
      isOnFreePlan && React.createElement(__WEBPACK_IMPORTED_MODULE_4__TargetingOption__["a" /* default */], {
        iconSrc: __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_sun_window_svg___default.a,
        isSelected: displayOnlineSelected,
        handleClick: onDisplayOnlineClick,
        label: 'Display When Drift is Online',
        description: 'Only display this playbook when Drift is online.'
      }),
      isOnFreePlan && React.createElement(__WEBPACK_IMPORTED_MODULE_4__TargetingOption__["a" /* default */], {
        iconSrc: __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_snooze_window_svg___default.a,
        isSelected: displayOfflineSelected,
        handleClick: onDisplayOfflineClick,
        label: 'Display When Drift is Offline',
        description: 'Only display this playbook when Drift is offline.'
      }),
      !isOnFreePlan && React.createElement(__WEBPACK_IMPORTED_MODULE_4__TargetingOption__["a" /* default */], {
        iconSrc: __WEBPACK_IMPORTED_MODULE_1__svg_inline_images_svg_targeting_display_target_svg___default.a,
        isSelected: displayTargetingSelected,
        handleClick: onDisplayClick,
        label: 'Display With Targeting',
        description: 'Add targeting conditions to display this message to a specific audience.'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TargetingDisplay);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "gGYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_nav_Header_HeaderBrand__ = __webpack_require__("ZsVd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Integration_components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_Accordion__ = __webpack_require__("so0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Integration_services_Slack__ = __webpack_require__("913P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("+xoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_caret_icon_svg__ = __webpack_require__("5vEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_caret_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_caret_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinycolor2__ = __webpack_require__("YrBu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_tinycolor2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_tinycolor2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Preview__ = __webpack_require__("RN02");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var SLACK_LOGO_SRC = __webpack_require__("SHj4");
var SLACK_OAUTH_PAYLOAD = {
  client_id: __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["Z" /* SLACK_CLIENT_ID */],
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/slack',
  state: ''
};
var SLACK_AUTH_URL = 'https://slack.com/oauth/authorize';

var SlackInstall = function (_Component) {
  _inherits(SlackInstall, _Component);

  function SlackInstall() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SlackInstall);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlackInstall.__proto__ || Object.getPrototypeOf(SlackInstall)).call.apply(_ref, [this].concat(args))), _this), _this.handleSkip = function () {
      var _this$props = _this.props,
          org = _this$props.org,
          track = _this$props.actions.track;

      track('Slack Install', { context: 'widget-onboarding', skipped: true });
      _this.context.app.queries.OrgPropertiesQueries.updateProperties(org.id, { postInstall: null }).then(function () {
        var isUniversityUser = localStorage.getItem('userOnboardingForUniversity');
        if (isUniversityUser) {
          window.location.href = __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["c" /* APP_URL */] + '/university';
        } else {
          _this.context.router.push('/');
        }
      });
    }, _this.renderSkipButton = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_13__style_styl___default.a.NavButtons },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'nav-button link skip', onClick: _this.handleSkip },
          'Skip',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_icons_caret_icon_svg___default.a })
        )
      );
    }, _this.renderRightHeader = function () {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'link', onClick: _this.handleSkip },
        'Go to Home'
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SlackInstall, [{
    key: 'clearPostInstallAction',
    value: function clearPostInstallAction() {
      var _this2 = this;

      var org = this.props.org;

      this.context.app.queries.OrgPropertiesQueries.updateProperties(org.id, { postInstall: null }).then(function () {
        _this2.context.router.push({
          pathname: '/',
          query: { showSlackModal: true }
        });
      }).catch(function (err) {
        Object(__WEBPACK_IMPORTED_MODULE_5_utils_SentryHelpers__["a" /* captureException */])(err);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var integrationStates = _ref2.integrationStates;

      if (integrationStates['slackBot']) {
        this.clearPostInstallAction();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = Object(__WEBPACK_IMPORTED_MODULE_12_components_Integration_helpers__["d" /* renderLogoSVG */])(SLACK_LOGO_SRC);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_13__style_styl___default.a.WelcomeLayout },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: __WEBPACK_IMPORTED_MODULE_13__style_styl___default.a.Integration },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_13__style_styl___default.a.WelcomeTitle },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_nav_Header_HeaderBrand__["a" /* default */], { large: true }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'dsg-h1 color-blue' },
                'Connect to Slack'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'p',
                { className: 'description' },
                'Connecting to Slack is easy and takes less than 2 min.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_components_shared_Accordion__["a" /* default */],
              { key: 'slackBot', title: title, locked: true },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Integration_services_Slack__["a" /* default */], _extends({ suppressUI: true }, this.props))
            ),
            this.renderActionButtons()
          )
        ),
        this.renderPreview()
      );
    }
  }, {
    key: 'renderActionButtons',
    value: function renderActionButtons() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex-center flex-column' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Integration_components_IntegrationConnector__["a" /* default */], {
          connectorType: 'button',
          integrationId: 'slackBot',
          isOauth: true,
          oauthLink: SLACK_AUTH_URL,
          oauthQueryParams: SLACK_OAUTH_PAYLOAD,
          trackingPayload: { context: 'widget-onboarding' }
        }),
        this.renderSkipButton()
      );
    }
  }, {
    key: 'getKey',
    value: function getKey(prefix) {
      var location = this.props.location;

      return prefix + '-' + location.pathname;
    }
  }, {
    key: 'renderPreview',
    value: function renderPreview() {
      var _props = this.props,
          user = _props.user,
          orgSettings = _props.orgSettings;
      var _props2 = this.props,
          previewWidth = _props2.previewWidth,
          previewColor = _props2.previewColor;
      var backgroundColor = orgSettings.theme.backgroundColor;

      var color = previewColor || __WEBPACK_IMPORTED_MODULE_16_tinycolor2___default()(backgroundColor).toHexString();
      var darkColor = __WEBPACK_IMPORTED_MODULE_16_tinycolor2___default()(color).darken(15).toHexString();
      var style = {
        width: previewWidth,
        backgroundImage: 'linear-gradient(' + color + ', ' + darkColor + ')'
      };
      var settings = orgSettings.toJS();
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: style.WelcomePreview, style: style },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Preview__["a" /* default */], { user: user, orgSettings: settings })
      );
    }
  }]);

  return SlackInstall;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

SlackInstall.defaultProps = {
  previewWidth: 414
};
SlackInstall.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var container = Object(__WEBPACK_IMPORTED_MODULE_6_components_container__["a" /* makeDefaultFailedContainer */])(SlackInstall, {
  listenTo: ['stores.OrgStore', 'stores.OrgSettingsStore', 'stores.OrgPropertiesStore', 'stores.UserStore', 'stores.IntegrationsStore'],
  fetch: {
    org: function org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    },
    user: function user() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    },
    orgProperties: function orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    },
    integrationStates: function integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates();
    }
  }
});

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking__["a" /* actions */].track
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, mapDispatchToProps)(container));

/***/ }),

/***/ "gHk3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gI3P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gIDI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(4);

/***/ }),

/***/ "gIFM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(522);

/***/ }),

/***/ "gIr2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__ = __webpack_require__("xIgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ConversationConstants__ = __webpack_require__("pIAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_queries_InboxQueries__ = __webpack_require__("3WI9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var InboxStore = Marty.createStore({
  id: 'InboxStore',

  getInitialState: function getInitialState() {
    return {
      inboxesById: {},
      inboxCreationState: undefined,
      lastCreatedInboxId: undefined,
      inboxExistenceByEmail: {},
      whiteListLabelsByDomain: {}
    };
  },


  handlers: {
    getOrFetchInboxList: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_LIST_FETCH,
    fetchInboxListDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_LIST_FETCH_DONE,

    fetchInboxDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_FETCH_DONE,

    archiveInbox: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE,
    archiveInboxDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_ARCHIVE_DONE,

    updateInbox: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_UPDATE,
    updateInboxDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_UPDATE_DONE,

    createInbox: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_CREATE,
    createInboxDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].INBOX_CREATE_DONE,

    checkInboxExistsForEmail: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL,
    checkInboxExistsForEmailDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].CHECK_INBOX_EXISTENCE_BY_EMAIL_DONE,

    createWhiteListLabels: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_CREATE,
    createWhiteListLabelsDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_CREATE_DONE,

    validateWhiteListLabels: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE,
    validateWhiteListLabelsDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE,

    fetchWhiteListLabelsDone: __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_FETCH_DONE
  },

  getOrFetchInboxList: function getOrFetchInboxList() {
    return this.fetch({
      id: 'fetchInboxList',
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchInboxList')) {
          return this.state.inboxesById;
        }
      },
      remotely: function remotely() {
        return this.app.queries.InboxQueries.fetchInboxes();
      }
    });
  },
  getInboxList: function getInboxList() {
    return _.values(this.state.inboxesById);
  },
  fetchInboxListDone: function fetchInboxListDone(inboxes) {
    var inboxesById = _.keyBy(inboxes, 'id');
    return this.setState({ inboxesById: _.merge(inboxesById, this.state.inboxesById) });
  },
  getOrFetchInbox: function getOrFetchInbox(inboxId) {
    return this.fetch({
      id: 'fetchInbox' + inboxId,
      locally: function locally() {
        if (this.state.inboxesById) {
          return this.state.inboxesById[inboxId];
        }
      },
      remotely: function remotely() {
        return this.app.queries.InboxQueries.fetchInbox(inboxId);
      }
    });
  },
  fetchInboxDone: function fetchInboxDone(inboxId, inbox) {
    var inboxesById = this._cloneInbox();
    inboxesById[inboxId] = inbox;
    return this.setState({ inboxesById: inboxesById });
  },
  _cloneInbox: function _cloneInbox() {
    return _.cloneDeep(this.state.inboxesById) || {};
  },
  updateInbox: function updateInbox(inboxId, params) {
    return this.app.queries.InboxQueries.updateInbox(inboxId, params);
  },
  updateInboxDone: function updateInboxDone(inboxId, inbox) {
    var inboxesById = this._cloneInbox();
    inboxesById[inboxId] = inbox;
    return this.setState({ inboxesById: inboxesById });
  },
  createInbox: function createInbox(params) {
    return this.app.queries.InboxQueries.createInbox(params);
  },
  createInboxDone: function createInboxDone(inbox) {
    this.setState({
      lastCreatedInboxId: inbox.id
    });

    var inboxesById = this._cloneInbox();
    inboxesById[inbox.id] = inbox;
    return this.setState({ inboxesById: inboxesById });
  },
  resetLastCreatedInbox: function resetLastCreatedInbox() {
    return this.setState({
      lastCreatedInboxId: undefined
    });
  },
  getLastCreatedInbox: function getLastCreatedInbox() {
    return this.state.inboxesById[this.state.lastCreatedInboxId];
  },
  getInboxExistenceByEmail: function getInboxExistenceByEmail() {
    return this.state.inboxExistenceByEmail;
  },
  checkInboxExistsForEmail: function checkInboxExistsForEmail(email) {
    if (this.state.inboxExistenceByEmail[email] == null) {
      return this.app.queries.InboxQueries.checkInboxExistsForEmail(email);
    }
  },
  checkInboxExistsForEmailDone: function checkInboxExistsForEmailDone(email, exists) {
    var inboxExistenceByEmail = _.cloneDeep(this.state.inboxExistenceByEmail);
    inboxExistenceByEmail[email] = exists;
    return this.setState({ inboxExistenceByEmail: inboxExistenceByEmail });
  },
  createWhiteListLabels: function createWhiteListLabels(domain) {
    var whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain);
    if (whiteListLabels[domain] != null) {
      whiteListLabels[domain].isConfiguring = true;
    }
    this.setState({ whiteListLabelsByDomain: whiteListLabels });

    return this.app.queries.InboxQueries.createWhiteListLabels(domain);
  },
  createWhiteListLabelsDone: function createWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload);
  },
  fetchWhiteListLabelsDone: function fetchWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload);
  },
  storeWhiteListLabelsByDomain: function storeWhiteListLabelsByDomain(domain, payload) {
    var whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain);

    var config = payload != null ? payload.dns : undefined;

    if (!!!config) {
      whiteListLabels[domain] = {};
      this.setState({ whiteListLabelsByDomain: whiteListLabels });
      return;
    }

    whiteListLabels[domain] = {
      isConfiguring: false,
      dns: [{
        data: config.mail_cname.data,
        host: config.mail_cname.host,
        state: config.mail_cname.valid ? __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE : __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_FAILED
      }, {
        data: config.dkim1.data,
        host: config.dkim1.host,
        state: config.dkim1.valid ? __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE : __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_FAILED
      }, {
        data: config.dkim2.data,
        host: config.dkim2.host,
        state: config.dkim2.valid ? __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_DONE : __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_FAILED
      }]
    };

    return this.setState({ whiteListLabelsByDomain: whiteListLabels });
  },
  getDomainByInboxId: function getDomainByInboxId(inboxId) {
    var inbox = this.state.inboxesById[inboxId];
    return __WEBPACK_IMPORTED_MODULE_4_utils_Helpers__["g" /* getDomainFromEmail */](inbox != null ? inbox.address : undefined);
  },
  getOrFetchWhiteListLabels: function getOrFetchWhiteListLabels(inboxId) {
    var _this = this;

    var domain = void 0;
    return this.fetch({
      id: 'fetchWhiteLabels',
      dependsOn: this.getOrFetchInbox(inboxId),
      locally: function locally() {
        domain = _this.getDomainByInboxId(inboxId);
        return _this.state.whiteListLabelsByDomain[domain];
      },
      remotely: function remotely() {
        domain = this.getDomainByInboxId(inboxId);
        return this.app.queries.InboxQueries.fetchWhiteListLabelsByDomain(domain);
      }
    });
  },
  validateWhiteListLabels: function validateWhiteListLabels(domain) {
    var whiteListLabels = _.cloneDeep(this.state.whiteListLabelsByDomain);

    whiteListLabels[domain].dns = _.map(whiteListLabels[domain].dns, function (item) {
      item.state = __WEBPACK_IMPORTED_MODULE_1_constants_InboxConstants__["a" /* default */].WHITE_LIST_LABELS_VALIDATE_STARTING;
      return item;
    });

    this.setState({ whiteListLabelsByDomain: whiteListLabels });

    return this.app.queries.InboxQueries.validateWhiteListLabels(domain);
  },
  validateWhiteListLabelsDone: function validateWhiteListLabelsDone(domain, payload) {
    return this.storeWhiteListLabelsByDomain(domain, payload);
  },
  archiveInbox: function archiveInbox(inboxId) {
    return this.app.queries.InboxQueries.archiveInbox(inboxId);
  },
  archiveInboxDone: function archiveInboxDone(inboxId) {
    var inboxes = this._cloneInbox();
    delete inboxes[inboxId];
    this.setState({ inboxesById: inboxes });
    return this.hasChanged();
  }
});

/* harmony default export */ __webpack_exports__["default"] = (InboxStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "gOkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("dMZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify__ = __webpack_require__("hBsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify__);
var _handleActions, _handleActions3, _handleActions10, _handleActions11, _handleActions12, _handleActions14;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var selectedConversations = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["K" /* selectConversation */], function (state, action) {
  var conversationId = action.payload.conversationId;

  return state.add(conversationId);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["f" /* deselectConversation */], function (state, action) {
  var conversationId = action.payload.conversationId;

  return state.delete(conversationId);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["L" /* selectConversations */], function (state, action) {
  var conversationIds = action.payload.conversationIds;

  return state.union(conversationIds);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["g" /* deselectConversations */], function (state, action) {
  var conversationIds = action.payload.conversationIds;

  return state.subtract(conversationIds);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4__actions__["e" /* deselectAllConversations */], function (state) {
  return state.clear();
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])());

var composeModalStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["R" /* setComposeModalStatus */], function (state, action) {
  var _action$payload = action.payload,
      status = _action$payload.status,
      endUserId = _action$payload.endUserId,
      endUser = _action$payload.endUser,
      composeType = _action$payload.composeType,
      companyName = _action$payload.companyName,
      page = _action$payload.page;

  var eid = endUser && endUser.id || endUserId;
  var type = composeType || 'new_conversation';
  return { status: status, endUserId: status && eid, endUser: endUser, composeType: type, companyName: companyName, page: page };
}), false);

var byId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["n" /* fetchConversationPending */], function (state, action) {
  var conversationId = action.payload.conversationId;


  return state.setIn([conversationId, 'status'], __WEBPACK_IMPORTED_MODULE_5__constants__["y" /* FETCH_CONVERSATION_PENDING */]);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["J" /* receiveConversation */], function (state, action) {
  var conversation = action.payload.conversation;

  var conversationId = conversation.get('id');

  return state.setIn([conversationId, 'status'], __WEBPACK_IMPORTED_MODULE_5__constants__["S" /* RECEIVE_CONVERSATION */]).setIn([conversationId, 'data'], conversation);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["Z" /* updateConversations */], function (state, action) {
  var updates = action.payload.updates;


  return state.withMutations(function (_state) {
    updates.forEach(function (update) {
      if (!_state.get(update.conversationId)) {
        return;
      }

      _state.setIn([update.conversationId, 'data', 'status'], update.conversationStatus).setIn([update.conversationId, 'data', 'participantIds'], update.participantIds);
    });
  });
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchConversationFailed */], function (state, action) {
  var _action$payload2 = action.payload,
      conversationId = _action$payload2.conversationId,
      error = _action$payload2.error;


  return state.setIn([conversationId, 'status'], __WEBPACK_IMPORTED_MODULE_5__constants__["s" /* FETCH_CONVERSATION_FAILED */]).setIn([conversationId, 'error'], error);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var endUserConversationsCounts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["r" /* fetchConversationsCountForEndUserIdSuccess */], function (state, action) {
  var _action$payload3 = action.payload,
      id = _action$payload3.id,
      count = _action$payload3.count;

  return state.set(id, count);
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var playbookIdByConversationId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["W" /* setPlaybookIdForConversation */], function (state, action) {
  var _action$payload4 = action.payload,
      conversationId = _action$payload4.conversationId,
      playbookId = _action$payload4.playbookId;

  return state.set(conversationId, playbookId);
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var activeConversationContactTabIndex = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["Q" /* setActiveConversationContactTabIndex */], function (state, action) {
  return action.payload;
}), 0);

var routingAuditLogStatusById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["B" /* fetchRoutingAuditLogSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["z" /* fetchRoutingAuditLogFailed */], __WEBPACK_IMPORTED_MODULE_4__actions__["A" /* fetchRoutingAuditLogPending */]), function (state, action) {
  return state.set(action.payload.routingGroupId, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var routingAuditLogById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["B" /* fetchRoutingAuditLogSuccess */], function (state, action) {
  return state.set(action.payload.routingGroupId, action.payload.data);
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var activeQueryByInboxId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["X" /* setQuery */], function (state, action) {
  var _action$payload5 = action.payload,
      conversationId = _action$payload5.conversationId,
      query = _objectWithoutProperties(_action$payload5, ['conversationId']);

  var inboxId = query.inboxId;


  return state.set(inboxId, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(query));
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var activeConversationByInboxId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions10 = {}, _defineProperty(_handleActions10, __WEBPACK_IMPORTED_MODULE_4__actions__["P" /* setActiveConversation */], function (state, action) {
  var _action$payload6 = action.payload,
      inboxId = _action$payload6.inboxId,
      conversationId = _action$payload6.conversationId;


  return state.set(inboxId, conversationId);
}), _defineProperty(_handleActions10, __WEBPACK_IMPORTED_MODULE_4__actions__["Y" /* unsetActiveConversation */], function (state, action) {
  var inboxId = action.payload.inboxId;


  return state.set(inboxId, null);
}), _handleActions10), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var paginatedConversationsByQuery = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions11 = {}, _defineProperty(_handleActions11, __WEBPACK_IMPORTED_MODULE_4__actions__["X" /* setQuery */], function (state, action) {
  var _action$payload7 = action.payload,
      conversationId = _action$payload7.conversationId,
      query = _objectWithoutProperties(_action$payload7, ['conversationId']);

  if (!state.get(__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query))) {
    var newState = state.setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'total'], 0).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'cursor'], 0).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'hasMore'], false).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loading'], true);

    return conversationId ? newState : newState.setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loaded'], false);
  }

  return state;
}), _defineProperty(_handleActions11, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* fetchConversationListSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* fetchNextConversationListSuccess */]), function (state, action) {
  var _action$payload8 = action.payload,
      query = _action$payload8.query,
      _action$payload8$pagi = _action$payload8.paginatedConversations,
      total = _action$payload8$pagi.total,
      cursor = _action$payload8$pagi.cursor,
      hasMore = _action$payload8$pagi.hasMore;


  return state.setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'total'], total).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'cursor'], parseInt(cursor)).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'hasMore'], hasMore).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loaded'], true).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loading'], false);
}), _defineProperty(_handleActions11, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchConversationListPending */]), function (state, action) {
  var query = action.payload.query;


  return state.setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loading'], true);
}), _defineProperty(_handleActions11, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchConversationListFailed */]), function (state, action) {
  var query = action.payload.query;


  return state.setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loaded'], true).setIn([__WEBPACK_IMPORTED_MODULE_6_fast_json_stable_stringify___default()(query), 'loading'], false);
}), _handleActions11), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

// Assumes conversationIds are unique at the org level (and not inbox level)
var paginatedConversationDataById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions12 = {}, _defineProperty(_handleActions12, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* fetchConversationListSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* fetchNextConversationListSuccess */]), function (state, action) {
  var conversations = action.payload.paginatedConversations.data;


  return state.mergeDeep(Object(__WEBPACK_IMPORTED_MODULE_2_utils_immutable__["a" /* keyBy */])(conversations));
}), _defineProperty(_handleActions12, __WEBPACK_IMPORTED_MODULE_4__actions__["J" /* receiveConversation */], function (state, action) {
  var conversation = action.payload.conversation;


  var existingConversation = state.get(conversation.id);
  if (existingConversation) {
    if (conversation.updatedAt > existingConversation.updatedAt) {
      return state.set(conversation.id, conversation);
    } else {
      return state;
    }
  } else {
    return state.set(conversation.id, conversation);
  }
}), _defineProperty(_handleActions12, __WEBPACK_IMPORTED_MODULE_4__actions__["Z" /* updateConversations */], function (state, action) {
  var updates = action.payload.updates;


  return state.withMutations(function (_state) {
    updates.forEach(function (update) {
      if (!_state.get(update.conversationId)) {
        return;
      }

      _state.setIn([update.conversationId, 'status'], update.conversationStatus).setIn([update.conversationId, 'participantIds'], update.participantIds);
    });
  });
}), _handleActions12), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var suggestedArticles = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__actions__["F" /* fetchSuggestedArticlesSuccess */], function (state, action) {
  return [].concat(_toConsumableArray(action.payload.suggestedActions));
}), []);

var globalAutoCloseConfigurationStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions14 = {}, _defineProperty(_handleActions14, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["u" /* fetchGlobalAutoCloseConfigurationPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["v" /* fetchGlobalAutoCloseConfigurationSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["t" /* fetchGlobalAutoCloseConfigurationFailure */]), function (state, action) {
  return state.set('fetch', action.type);
}), _defineProperty(_handleActions14, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["_2" /* updateGlobalAutoCloseConfigurationPending */], __WEBPACK_IMPORTED_MODULE_4__actions__["_3" /* updateGlobalAutoCloseConfigurationSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["_1" /* updateGlobalAutoCloseConfigurationFailure */]), function (state, action) {
  return state.set('update', action.type);
}), _handleActions14), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var globalAutoCloseConfigurationData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4__actions__["v" /* fetchGlobalAutoCloseConfigurationSuccess */], __WEBPACK_IMPORTED_MODULE_4__actions__["_3" /* updateGlobalAutoCloseConfigurationSuccess */]), function (state, action) {
  return action.payload;
}), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var globalAutoCloseConfiguration = Object(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__["combineReducers"])({
  status: globalAutoCloseConfigurationStatus,
  data: globalAutoCloseConfigurationData
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__["combineReducers"])({
  selectedConversations: selectedConversations,
  composeModalStatus: composeModalStatus,
  activeConversationContactTabIndex: activeConversationContactTabIndex,
  byId: byId, // Full conversations
  endUserConversationsCounts: endUserConversationsCounts,
  activeQueryByInboxId: activeQueryByInboxId,
  activeConversationByInboxId: activeConversationByInboxId,
  paginatedConversationsByQuery: paginatedConversationsByQuery, // Paging, Loading, Ordered list
  paginatedConversationDataById: paginatedConversationDataById, // Preview conversations
  playbookIdByConversationId: playbookIdByConversationId,
  routingAuditLogStatusById: routingAuditLogStatusById,
  routingAuditLogById: routingAuditLogById,
  suggestedArticles: suggestedArticles,
  globalAutoCloseConfiguration: globalAutoCloseConfiguration
}));

/***/ }),

/***/ "gQOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_MARKETO_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_MARKETO_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATCH_MARKETO_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PATCH_MARKETO_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PATCH_MARKETO_MAPPINGS_START; });
var FETCH_MARKETO_FIELDS_SUCCESS = 'FETCH_MARKETO_FIELDS_SUCCESS';
var FETCH_MARKETO_MAPPINGS_SUCCESS = 'FETCH_MARKETO_MAPPINGS_SUCCESS';
var PATCH_MARKETO_MAPPINGS_ERROR = 'PATCH_MARKETO_MAPPINGS_ERROR';
var PATCH_MARKETO_MAPPINGS_SUCCESS = 'PATCH_MARKETO_MAPPINGS_SUCCESS';
var PATCH_MARKETO_MAPPINGS_START = 'PATCH_MARKETO_MAPPINGS_START';

/***/ }),

/***/ "gX8A":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(509);

/***/ }),

/***/ "gYUb":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22\" height=\"22\" viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#CCC\" fill-rule=\"evenodd\"><path d=\"M10.92 21.065c-5.597 0-10.15-4.553-10.15-10.15S5.322.765 10.92.765s10.15 4.553 10.15 10.15-4.553 10.15-10.15 10.15zm0-19c-4.88 0-8.85 3.97-8.85 8.85 0 4.88 3.97 8.85 8.85 8.85 4.88 0 8.85-3.97 8.85-8.85 0-4.88-3.97-8.85-8.85-8.85z\"></path><path d=\"M12.497 15.205a1.884 1.884 0 0 1-.19.218c-.1.102-.277.226-.532.373-.254.146-.517.23-.786.254-.69.058-1.19-.226-1.498-.854-.274-.59-.293-1.283-.058-2.082l.387-1.617c.137-.468.12-.768-.05-.9-.037-.037-.106-.052-.21-.043a1.01 1.01 0 0 0-.228.05c-.08.028-.15.055-.203.08l-.07.037c-.114.063-.215.025-.302-.113a.34.34 0 0 1 .007-.406c.035-.054.1-.13.19-.225.092-.096.265-.22.52-.372a1.84 1.84 0 0 1 .785-.26c.705-.06 1.208.223 1.51.85.273.59.292 1.284.057 2.083l-.387 1.617c-.135.48-.117.784.054.914.026.03.095.04.206.03.07-.007.147-.024.23-.05.08-.03.148-.055.202-.08l.068-.038c.115-.062.216-.022.304.12.088.144.086.282-.007.415M11.67 8.722a1.475 1.475 0 1 1 0-2.95 1.475 1.475 0 0 1 0 2.95\"></path></g></svg>"

/***/ }),

/***/ "gauQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withOAuthConnectionStatus__ = __webpack_require__("hzfC");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var CalendarField = function CalendarField(props) {
  if (!props.isConnected) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, props);
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, _extends({}, props, {
    value: '',
    onChange: null,
    disabled: true,
    placeholder: 'Your Google Calendar is connected'
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_4__withOAuthConnectionStatus__["a" /* default */])(CalendarField));

/***/ }),

/***/ "gfVV":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 41 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.5 30.857c-.892 0-2.276.01-3.113.016-3.09 4.754-9.361 5.113-9.638 5.126L7.688 36a1.287 1.287 0 0 1-1.035-2.043c.02-.03 2.004-2.812 2.284-6.15C3.165 24.692 0 20.322 0 15.428 0 6.92 9.197 0 20.5 0S41 6.921 41 15.429c0 8.507-9.197 15.428-20.5 15.428zm0-28.286c-9.891 0-17.938 5.768-17.938 12.858 0 5.497 5.177 8.915 8.26 10.461.435.218.71.663.71 1.151 0 2.286-.689 4.375-1.384 5.903 1.807-.539 4.135-1.657 5.382-3.965.222-.41.65-.669 1.116-.671 0 0 2.493-.022 3.854-.022 9.891 0 17.938-5.768 17.938-12.857 0-7.09-8.047-12.858-17.938-12.858zm0 20.572c-.333 0-.666-.142-.91-.373a1.354 1.354 0 0 1-.371-.913c0-.335.14-.668.371-.914.487-.474 1.346-.474 1.82 0 .23.246.371.579.371.914 0 .334-.14.669-.371.913a1.32 1.32 0 0 1-.91.373zm1.048-5.73c-.046.071-.08.152-.138.214a1.358 1.358 0 0 1-.509.29A1.095 1.095 0 0 1 20.5 18c-.143 0-.275-.033-.4-.082a1.353 1.353 0 0 1-.51-.29 1.351 1.351 0 0 1-.29-.514 1.112 1.112 0 0 1-.081-.4V9c0-.711.574-1.286 1.281-1.286S21.781 8.29 21.781 9v7.714c0 .144-.033.277-.082.403a1.37 1.37 0 0 1-.15.295z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "gfbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var HealthCheck = React.createClass({
  displayName: "HealthCheck",
  render: function render() {
    return React.createElement(
      "div",
      null,
      "OKAY"
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (HealthCheck);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "gh/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return saveFailed; });
/* unused harmony export isPlaybooks */
/* unused harmony export getEndUserEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getSendTestEmailLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getSendTestEmailId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getEnrolledPlaybookId; });
/* unused harmony export getPlaybooksById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getPlaybookIsPending; });
/* unused harmony export enrolledSequenceCount */
/* unused harmony export enrollmentLimit */
/* unused harmony export enrollmentPeriod */
/* unused harmony export enrolledSequenceCountLoaded */
/* unused harmony export playbookForEndUser */
/* unused harmony export editingPlaybookId */
/* unused harmony export fetchPlaybookForEndUserPending */
/* unused harmony export enrollErrorsByEmail */
/* unused harmony export enrollSucceeded */
/* unused harmony export enrollFailed */
/* unused harmony export enrollPending */
/* unused harmony export enrollingPlaybookId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return playbooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allGoals; });
/* unused harmony export actionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return playbookList; });
/* unused harmony export denormalizedPlaybookList */
/* unused harmony export normalizedStatus */
/* unused harmony export listNeverFetched */
/* unused harmony export isListLoading */
/* unused harmony export activePlaybooksList */
/* unused harmony export outboundPlaybooksList */
/* unused harmony export playbooksListExcludingOutbound */
/* unused harmony export enabledPlaybooksList */
/* unused harmony export disabledPlaybooksList */
/* unused harmony export archivedPlaybooksList */
/* unused harmony export scheduledPlaybooksList */
/* unused harmony export sentPlaybooksList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return emailPlaybooks; });
/* unused harmony export activeEmailPlaybooks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return draftRoot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return draftId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return draftLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return draft; });
/* unused harmony export draftMeta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return isDriftLinkOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return denormalizedDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return isEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return isArchived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return hasEnterpriseActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return reportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return isLeadBot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return isSignaturePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getIsOutboundSequencePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getIsSequencePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getIsMarketingSequencePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return isMessageTypePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return isCaptureTypePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return isCtaTypePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return isChatTypePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getIsOneTimeEmailPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getIsEmailPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return isOutboundPlaybook; });
/* unused harmony export getDisabledOutboundPlaybooks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return isABMPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return hasAutoCloseAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return hasCalendarAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return goals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return firstGoal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return orderedGoals; });
/* unused harmony export draftActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getFirstActionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return firstAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return playbookActionInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return marketingEmailLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return sequenceDynamicSenderFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return sequenceDynamicSendAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return sequenceSenderEmailOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return sequenceSendFromOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return sequenceWeekdaysOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return sequenceSmartSending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return sequenceAuthorId; });
/* unused harmony export marketingEmailSubType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getIsOneTimeMarketingSequencePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getIsAutomatedMarketingEmailPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return dynamicSenderFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return dynamicAccountSendAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return senderEmailOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return sendFromOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return authorId; });
/* unused harmony export isChatCta */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return isMeetingCta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getHasRoutingAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return interaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return welcomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return targetedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return takeoverMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return emailMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return emailCaptureMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return sequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return slug; });
/* unused harmony export getLastQuestionId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getLastEmailId; });
/* unused harmony export answers */
/* unused harmony export getAnswer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return questions; });
/* unused harmony export getQuestion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return numQuestions; });
/* unused harmony export getIsDefaultAnswer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return emails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return isEmailCaptureQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return isPhoneCaptureQuestion; });
/* unused harmony export hasEmailCaptureQuestion */
/* unused harmony export hasPhoneCaptureQuestion */
/* unused harmony export keywords */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return isStatusLoading; });
/* unused harmony export getSignatureBannerStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return signatureBannerStatusPending; });
/* unused harmony export signatureBannerStatusSuccess */
/* unused harmony export signatureBannerStatusFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getEditSenderLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asyncButtonPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getSendTestSequencePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return isTemplateContactPreviewLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return isAutosaveActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return pendingPlaybookChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return isSaved; });
/* unused harmony export bannerUploadPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return isBannerUploadPending; });
/* unused harmony export pendingDraftStatus */
/* unused harmony export priorityOrderedPlaybookIds */
/* unused harmony export playbookCounts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return isSaving; });
/* unused harmony export isFetching */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getSendEmailConfirmModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getAnswerModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getQuestionAdvancedModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getRenderedEmailPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return playbookIdForCampaignIdFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return playbookIdForCampaignIdLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return playbookIdForCampaignId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getGoalActionModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getEditSenderModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getEditSenderModalEditingEmailId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getTokenModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getCtaButtonModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getCalendarLinkModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getGoogleAuthModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getGoalRoutingModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getExtensionInviteModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return segmentSelectVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getConditionModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getScheduleModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return sequenceInviteModalVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return calendarProfileLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return cardinalityLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return targetingCardinality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getDisableSalesSequenceModalVisible; });
/* unused harmony export currentGoalId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return currentGoal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return currentGoalRouting; });
/* unused harmony export isCurrentGoalRoutingSingle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return selectedGoalAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return selectedGoalRoutingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return isSingleRoutingSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return goalRoutingView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return isGroupRoutingSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return isGlobalRoutingSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return isNoRoutingSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getCurrentConditionId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getCurrentAnswer; });
/* unused harmony export keywordsByAnswerId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getCurrentQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getCurrentQuestionByAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getQuestionIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return buttonOnlyResponses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return keywordAnswersForQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return questionHasKeywordAnswers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return numKeywordsInQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getCurrentAnswerHasSpecialKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return skipToOptions; });
/* unused harmony export skipToOption */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return currentSkipToOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return audience; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return dueAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return excludedUserListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return userListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return excludedAccountListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return builderSmartFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return targetingDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return draftFrequency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return sequenceUnenrollOnReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return sequenceUnenrollDomainOnReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return smartFilters; });
/* unused harmony export smartFilterEngagedContacts */
/* unused harmony export smartFilterChatEngagedContacts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getConditionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getFirstCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getNumConditions; });
/* unused harmony export playbookReportTypePlans */
/* unused harmony export playbookReportTypePlansLoading */
/* unused harmony export playbookReportTypePlansLoaded */
/* unused harmony export getPlaybookReportTypePlansEnabled */
/* unused harmony export getPlaybookEditorLink */
/* unused harmony export signatureRoot */
/* unused harmony export signaturePreviewAll */
/* unused harmony export signaturePreviewAllStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return signaturePreviewAllFetchPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return signaturePreviewAllFetchFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return signaturePreviewAllData; });
/* unused harmony export signaturePreviewAllContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return signatures; });
/* unused harmony export firstSignature */
/* unused harmony export signature */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return viewingSignatureId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return signatureBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return signatureIncludeAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return signatureIncludeSocial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return signatureIncludeBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return signatureBannerImgURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return signatureBannerLinkURL; });
/* unused harmony export getSignature */
/* unused harmony export getSignatureBody */
/* unused harmony export getSignatureIncludeAvatar */
/* unused harmony export getSignatureIncludeSocial */
/* unused harmony export getSignatureIncludeBanner */
/* unused harmony export getSignatureBannerImgURL */
/* unused harmony export getSignatureBannerLinkURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return playbookForCampaignIdNeverFetched; });
/* unused harmony export playbookForCampaignIdPending */
/* unused harmony export playbookForCampaignIdFailed */
/* unused harmony export playbookForCampaignId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_normalizr__ = __webpack_require__("JeHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__schema__ = __webpack_require__("BEyV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__ = __webpack_require__("OWv3");
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }














var root = function root(state) {
  return state.get('playbooks');
};

var rootStatus = function rootStatus(state) {
  return root(state).get('status');
};
var saveFailed = function saveFailed(state) {
  return [__WEBPACK_IMPORTED_MODULE_8__actions__["_114" /* savePlaybookFailed */].toString(), __WEBPACK_IMPORTED_MODULE_8__actions__["_112" /* savePlaybookDraftFailed */].toString()].includes(rootStatus(state));
};

var isPlaybooks = function isPlaybooks(state) {
  return root(state).get('normalized', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).size;
};
var getEndUserEmail = function getEndUserEmail(state) {
  return root(state).get('endUserEmail');
};

var getSendTestEmailStatus = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('sendTestEmailStatus');
});
var getSendTestEmailLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getSendTestEmailStatus, function (sendTestEmailStatus) {
  return sendTestEmailStatus === __WEBPACK_IMPORTED_MODULE_8__actions__["_127" /* sendTestEmailPending */].toString();
});

var getSendTestEmailId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('sendTestEmailId');
});

var getEnrolledPlaybookId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('enrolledPlaybookId');
});
var getPlaybooksById = function getPlaybooksById(state) {
  return root(state).get('byIds');
};
var getPlaybookIsPending = function getPlaybookIsPending(state, playbookId) {
  return getPlaybooksById(state).get(playbookId) === 'PENDING';
};
var enrolledSequenceEnrollmentInfo = function enrolledSequenceEnrollmentInfo(state) {
  return root(state).get('enrolledSequenceCount');
};

var enrolledSequenceCount = function enrolledSequenceCount(state) {
  return enrolledSequenceEnrollmentInfo(state).get('count');
};
var enrollmentLimit = function enrollmentLimit(state) {
  return enrolledSequenceEnrollmentInfo(state).get('limit');
};
var enrollmentPeriod = function enrollmentPeriod(state) {
  return enrolledSequenceEnrollmentInfo(state).get('refreshRate');
};

var fetchEnrolledSequenceCountStatus = function fetchEnrolledSequenceCountStatus(state) {
  return root(state).get('fetchEnrolledSequenceCountStatus');
};
var enrolledSequenceCountLoaded = function enrolledSequenceCountLoaded(state) {
  return fetchEnrolledSequenceCountStatus(state) === __WEBPACK_IMPORTED_MODULE_8__actions__["_16" /* fetchEnrolledSequenceCountSuccess */].toString();
};

var playbookForEndUser = function playbookForEndUser(state) {
  return root(state).get('playbookForEndUser');
};

var editingPlaybookId = function editingPlaybookId(state) {
  return root(state).get('editingPlaybookId');
};

var fetchPlaybookForEndUserStatus = function fetchPlaybookForEndUserStatus(state) {
  return root(state).get('fetchPlaybookForEndUserStatus');
};
var fetchPlaybookForEndUserPending = function fetchPlaybookForEndUserPending(state) {
  return fetchPlaybookForEndUserStatus(state) === __WEBPACK_IMPORTED_MODULE_8__actions__["_42" /* fetchPlaybookForEndUserPending */].toString();
};

var enrollStatusByEmail = function enrollStatusByEmail(state) {
  return root(state).get('enrollStatusByEmail');
};
var enrollErrorsByEmail = function enrollErrorsByEmail(state) {
  return root(state).get('enrollErrorsByEmail');
};

var enrollHasOccurred = function enrollHasOccurred(state) {
  return !enrollStatusByEmail(state).isEmpty();
};
var enrollSucceeded = function enrollSucceeded(state) {
  return enrollHasOccurred(state) && enrollStatusByEmail(state).every(function (status) {
    return status === __WEBPACK_IMPORTED_MODULE_8__actions__["X" /* enrollSuccess */].toString();
  });
};
var enrollFailed = function enrollFailed(state) {
  return enrollHasOccurred(state) && enrollStatusByEmail(state).some(function (status) {
    return status === __WEBPACK_IMPORTED_MODULE_8__actions__["V" /* enrollFailed */].toString();
  });
};
var enrollPending = function enrollPending(state) {
  return enrollHasOccurred(state) && enrollStatusByEmail(state).some(function (status) {
    return status === __WEBPACK_IMPORTED_MODULE_8__actions__["W" /* enrollPending */].toString();
  });
};

var enrollingPlaybookId = function enrollingPlaybookId(state) {
  return root(state).get('enrollingPlaybookId');
};

var entities = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['normalized', 'entities'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var playbooks = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(entities, function (entities) {
  return entities.get('playbooks', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var allGoals = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(entities, function (entities) {
  return entities.get('goals', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var actionTypes = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(entities, function (entities) {
  return entities.get('actionTypes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var getPlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([playbooks, function (state, props) {
  return props.playbookId;
}], function (playbooks, playbookId) {
  return playbooks.get('' + playbookId, __WEBPACK_IMPORTED_MODULE_5__models__["k" /* Playbook */]({ id: playbookId }));
});

var normalizedResult = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['normalized', 'result'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])());
});
var playbookList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(normalizedResult, playbooks, function (normalizedResult, playbooks) {
  return normalizedResult.toList().map(String).map(function (result) {
    return playbooks.get(result);
  });
});
var denormalizedPlaybookList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(normalizedResult, entities, function (normalizedResult, entities) {
  return normalizedResult.toList().map(String).map(function (result) {
    var denormalizedPlaybook = Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["a" /* denormalize */])(result, __WEBPACK_IMPORTED_MODULE_7__schema__["a" /* playbook */], entities);
    if (!_.isEmpty(denormalizedPlaybook.get('targeting'))) {
      return denormalizedPlaybook.updateIn(['targeting', 'display'], function (display) {
        return display.map(function (_ref) {
          var conditions = _ref.conditions;
          return conditions.map(function (condition) {
            return condition.toJS();
          }).map(function (_ref2) {
            var id = _ref2.id,
                rest = _objectWithoutProperties(_ref2, ['id']);

            return rest;
          });
        } // remove id
        );
      });
    }
    return denormalizedPlaybook;
  });
});

var normalizedStatus = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('normalizedStatus');
});
var listNeverFetched = function listNeverFetched(state) {
  return normalizedStatus(state) === false;
};
var isListLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(normalizedStatus, function (normalizedStatus) {
  return normalizedStatus === __WEBPACK_IMPORTED_MODULE_8__actions__["_121" /* searchPlaybooksPending */].toString();
});

var activePlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(denormalizedPlaybookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED || playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED;
  });
});
var outboundPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(activePlaybooksList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    if (!playbook.targeting) {
      return false;
    }
    return playbook.targeting.get('display').flatten(false) // false == deep flatten
    .find(function (condition) {
      return condition.field === 'outboundSession';
    });
  });
});
var playbooksListExcludingOutbound = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(activePlaybooksList, outboundPlaybooksList, function (playbooks, outboundPlaybooks) {
  return playbooks.filter(function (pb) {
    return !outboundPlaybooks.includes(pb);
  });
});
var enabledPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED;
  });
});
var disabledPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED;
  });
});
var archivedPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ARCHIVED;
  });
});
var scheduledPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SCHEDULED;
  });
});
var sentPlaybooksList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return playbook.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].SENT;
  });
});
var emailPlaybooks = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(playbookList, function (playbooks) {
  var email_playbook_types = [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SEND_AN_AUTOMATED_EMAIL, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SEND_A_ONETIME_EMAIL, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].OUTBOUND_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_ONE_TIME_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].BLOG_NURTURE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEW_BLOG_CONTENT, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEWSLETTER, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].PRODUCT_ANNOUNCEMENT, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABANDONED_BOOK_A_MEETING];
  return playbooks.filter(function (playbook) {
    return email_playbook_types.includes(playbook.reportType);
  });
});
var activeEmailPlaybooks = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(emailPlaybooks, function (playbooks) {
  return playbooks.filter(function (playbook) {
    return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED].includes(playbook.status);
  });
});

var draftRoot = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['draft', 'entities'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var draftId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['draft', 'result']);
});
var draftLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftId, function (draftId) {
  return !draftId;
});

var draft = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftId, draftRoot, function (draftId, draftRoot) {
  return draftRoot.getIn(['playbooks', '' + draftId]);
});

var draftMeta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draft, function (draft) {
  return draft.get('meta');
});
var isDriftLinkOnly = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftMeta, function (meta) {
  return meta.get('driftLinkOnly', false);
});

var isLocalOnlySignature = function isLocalOnlySignature(sig) {
  return sig.signatureId === null;
};
var removeSignatureIds = function removeSignatureIds(sig) {
  return sig.delete('id').delete('signatureId');
};

var denormalizedDraft = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftId, draftRoot, function (draftId, draftEntities) {
  var denormalized = Object(__WEBPACK_IMPORTED_MODULE_3_normalizr__["a" /* denormalize */])(draftId, __WEBPACK_IMPORTED_MODULE_7__schema__["a" /* playbook */], draftEntities).updateIn(['targeting', 'display'], function (display) {
    return display.map(function (_ref3) {
      var conditions = _ref3.conditions;
      return conditions.map(function (condition) {
        return condition.toJS();
      }).map(function (_ref4) {
        var id = _ref4.id,
            rest = _objectWithoutProperties(_ref4, ['id']);

        return rest;
      });
    } // remove id
    );
  });
  if (denormalized.getIn(['actions', '0', 'action', 'cta', 'type']) === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["V" /* CtaTypes */].NONE) {
    return denormalized.setIn(['actions', '0', 'action', 'cta'], null).toJS();
  }

  if (denormalized.getIn(['actions', '0', 'action']).has('signatureActions')) {
    return denormalized.set('actions', denormalized.actions.updateIn(['0', 'action', 'signatureActions'], function (sigs) {
      return sigs.map(function (sig) {
        return isLocalOnlySignature(sig) ? removeSignatureIds(sig) : sig;
      });
    })).toJS();
  }

  return denormalized.toJS();
});


var status = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftId, draftRoot, function (draftId, draftRoot) {
  return draftRoot.getIn(['playbooks', '' + draftId, 'status']);
});
var isEnabled = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(status, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED;
});
var isArchived = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(status, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ARCHIVED;
});

var hasEnterpriseActions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__["u" /* makeHasGate */])('premium_enterprise'), Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__["u" /* makeHasGate */])('PLAYBOOKS'), function (hasEnterprise, hasLegacyPlaybooksGate) {
  return hasEnterprise || hasLegacyPlaybooksGate;
});

var reportType = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftId, draftRoot, function (draftId, draftRoot) {
  return draftRoot.getIn(['playbooks', '' + draftId, 'reportType']);
});
var isLeadBot = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_296" /* isLeadBotPlaybook */]);

var isSignaturePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SIGNATURE;
});
var getIsOutboundSequencePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].OUTBOUND_SEQUENCE;
});
var getIsSequencePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].OUTBOUND_SEQUENCE || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_SEQUENCE || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_ONE_TIME_SEQUENCE || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].BLOG_NURTURE || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEW_BLOG_CONTENT || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEWSLETTER || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].PRODUCT_ANNOUNCEMENT || reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABANDONED_BOOK_A_MEETING;
});
var getIsMarketingSequencePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_ONE_TIME_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].BLOG_NURTURE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEW_BLOG_CONTENT, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEWSLETTER, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].PRODUCT_ANNOUNCEMENT, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABANDONED_BOOK_A_MEETING].includes(reportType);
});
var isMessageTypePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(isLeadBot, getIsSequencePlaybook, isSignaturePlaybook, function (isLeadBot, isSequencePlaybook, isSig) {
  return !isLeadBot && !isSequencePlaybook && !isSig;
});
var isCaptureTypePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return reportType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].BUILD_A_SUBSCRIBER_LIST;
});
var isCtaTypePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].DRIVE_TRAFFIC_TARGETED_MESSAGE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].PROMOTION_FULL_SCREEN_TAKEOVER, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SEND_AN_AUTOMATED_EMAIL, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SEND_A_ONETIME_EMAIL, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].EMPTY_SLIDER, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].EMPTY_TAKEOVER].includes(reportType);
});
//TODO: no longer valid
var isChatTypePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MORE_SALES_CONVERSATIONS, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].EMPTY_WELCOME_MESSAGE].includes(reportType);
});
var getIsOneTimeEmailPlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].SEND_A_ONETIME_EMAIL, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].MARKETING_ONE_TIME_SEQUENCE, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEW_BLOG_CONTENT, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].NEWSLETTER, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].PRODUCT_ANNOUNCEMENT].includes(reportType);
});
var getIsEmailPlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_295" /* isEmailPlaybook */]);

var isOutboundPlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].TALK_TO_YOUR_OUTBOUND_PROSPECTS].includes(reportType);
});

var getDisabledOutboundPlaybooks = function getDisabledOutboundPlaybooks(state) {
  return root(state).getIn(['playbooksByReportType', 'data', __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].TALK_TO_YOUR_OUTBOUND_PROSPECTS, 'disabled']);
};

var isABMPlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reportType, function (reportType) {
  return [__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_140" /* PlaybookReportType */].ABM].includes(reportType);
});

var hasAutoCloseAction = hasEnterpriseActions;
var hasCalendarAction = hasEnterpriseActions;

var goals = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('goals', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var firstGoal = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(goals, function (goals) {
  return goals.first();
});
var orderedGoals = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(goals, draft, function (goals, draft) {
  return draft.get('goals').map(function (goalId) {
    return goals.get(goalId);
  });
});

var draftActionTypes = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('actionTypes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var getFirstActionType = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftActionTypes, function (actionTypes) {
  return actionTypes.first() || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
});
var firstAction = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getFirstActionType, function (firstActionType) {
  return firstActionType.get('action', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var playbookActionInboxId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('inboxId');
});
var marketingEmailLayout = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'marketingEmailLayout']);
});
var sequenceDynamicSenderFormat = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'dynamicSenderFormat']);
});
var sequenceDynamicSendAttribute = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'dynamicAccountSendAttribute']);
});
var sequenceSenderEmailOverride = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'senderEmailOverride']);
});
var sequenceSendFromOverride = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'sendFromOverride']);
});
var sequenceWeekdaysOnly = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'weekdaysOnly']);
});
var sequenceSmartSending = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'smartSending']);
});

var sequenceAuthorId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'authorId']);
});
var marketingEmailSubType = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.getIn(['options', 'marketingEmailSubType']);
});
var getIsOneTimeMarketingSequencePlaybook = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(marketingEmailSubType, function (subType) {
  return subType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_132" /* MarketingEmailSubTypes */].ONE_TIME;
});
var getIsAutomatedMarketingEmailPlaybook = function getIsAutomatedMarketingEmailPlaybook(state) {
  return marketingEmailSubType(state) === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_132" /* MarketingEmailSubTypes */].AUTOMATED;
};
var dynamicSenderFormat = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('dynamicSenderFormat');
});
var dynamicAccountSendAttribute = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('dynamicAccountSendAttribute');
});
var senderEmailOverride = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('senderEmailOverride');
});
var sendFromOverride = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('sendFromOverride');
});
var authorId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.get('authorId');
});
var isChatCta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftActionTypes, function (draftActionTypes) {
  return !!draftActionTypes.map(function (a) {
    return a.getIn(['action', 'cta', 'type']);
  }).filter(function (t) {
    return t === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT;
  }).size;
});
var isMeetingCta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftActionTypes, function (draftActionTypes) {
  return !!draftActionTypes.map(function (a) {
    return a.getIn(['action', 'cta', 'type']);
  }).filter(function (t) {
    return t === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["V" /* CtaTypes */].MEETING;
  }).size;
});

var getHasRoutingAction = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(isCtaTypePlaybook, isCaptureTypePlaybook, isChatCta, function (isCtaTypePlaybook, isCaptureTypePlaybook, isChatCta) {
  return !isCtaTypePlaybook && !isCaptureTypePlaybook || isCtaTypePlaybook && isChatCta;
});

var interaction = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return __WEBPACK_IMPORTED_MODULE_5__models__["i" /* Interaction */](firstAction);
});
var welcomeMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.toJS();
});
var targetedMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.toJS();
});
var takeoverMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.toJS();
});
var emailMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.toJS();
});
var emailCaptureMessage = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return firstAction.toJS();
});
var sequence = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(firstAction, function (firstAction) {
  return __WEBPACK_IMPORTED_MODULE_5__models__["o" /* Sequence */](firstAction);
});

var slug = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(interaction, function (interaction) {
  return interaction.slug;
});
var getLastQuestionId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(interaction, function (interaction) {
  return interaction.questions.last();
});

var getLastEmailId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sequence, function (sequence) {
  return sequence.emails.last();
});

var answers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('answers', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var getAnswer = function getAnswer(state, props) {
  return answers(state).get(props.id);
};

var questions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('questions');
});
var getQuestion = function getQuestion(state, props) {
  return questions(state).get(props.id);
};
var numQuestions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(questions, function (questions) {
  return questions.size;
});
var getIsDefaultAnswer = function getIsDefaultAnswer(state, props) {
  var answer = answers(state).get(props.id);
  var question = questions(state).get(answer.questionId);
  return question.defaultAnswerId === answer.id;
};

var emails = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('emails');
});
var getEmail = function getEmail(state, props) {
  return emails(state).get('' + props.id);
};

var isEmailCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state, question) {
  return question;
}, answers, function (question, answers) {
  var emailCaptureAnswers = answers.filter(function (answer) {
    return question.answers.contains(answer.id) && answer.type === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["t" /* AnswerType */].VALIDATE && answer.validationType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_292" /* ValidationType */].EMAIL;
  });
  return emailCaptureAnswers.size > 0;
});
var isPhoneCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state, question) {
  return question;
}, answers, function (question, answers) {
  var phoneCaptureAnswers = answers.filter(function (answer) {
    return question.answers.contains(answer.id) && answer.type === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["t" /* AnswerType */].VALIDATE && answer.validationType === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_292" /* ValidationType */].PHONE;
  });
  return phoneCaptureAnswers.size > 0;
});

var hasEmailCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state) {
  return state;
}, questions, function (state, questions) {
  var emailCaptureQuestions = questions.filter(function (question) {
    return isEmailCaptureQuestion(state, question);
  });
  return emailCaptureQuestions.size > 0;
});
var hasPhoneCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state) {
  return state;
}, questions, function (state, questions) {
  var phoneCaptureQuestions = questions.filter(function (question) {
    return isPhoneCaptureQuestion(state, question);
  });
  return phoneCaptureQuestions.size > 0;
});

var keywords = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('keywords');
});
var getKeyword = function getKeyword(state, props) {
  return keywords(state).get(props.id);
};

var ui = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.get('ui');
});
var isStatusLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (uiRoot) {
  return uiRoot.get('statusLoading', false);
});
// this assumes you won't be uploading multiple banners at once in a signature playbook, which may not be correct
var getSignatureBannerStatus = function getSignatureBannerStatus(state) {
  return ui(state).get('signatureBannerUploadStatus');
};
var signatureBannerStatusPending = function signatureBannerStatusPending(state) {
  return [__WEBPACK_IMPORTED_MODULE_8__actions__["_199" /* setSignatureBanner */].toString(), __WEBPACK_IMPORTED_MODULE_8__actions__["_203" /* setSignatureBannerPending */].toString()].includes(getSignatureBannerStatus(state));
};
var signatureBannerStatusSuccess = function signatureBannerStatusSuccess(state) {
  return getSignatureBannerStatus(state) === __WEBPACK_IMPORTED_MODULE_8__actions__["_204" /* setSignatureBannerSuccess */].toString();
};
var signatureBannerStatusFailed = function signatureBannerStatusFailed(state) {
  return getSignatureBannerStatus(state) === __WEBPACK_IMPORTED_MODULE_8__actions__["_201" /* setSignatureBannerFailed */].toString();
};

var getEditSenderLevel = function getEditSenderLevel(state) {
  return ui(state).get('editSenderLevel', __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].GLOBAL);
};

var asyncButtonPress = function asyncButtonPress(state) {
  return ui(state).get('asyncButtonPress', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var asyncButtonPending = function asyncButtonPending(state, clickId) {
  return asyncButtonPress(state).getIn(['' + clickId, 'status']) === __WEBPACK_IMPORTED_MODULE_8__actions__["p" /* asyncButtonPressPending */].toString();
};

var getSendTestSequenceStatus = function getSendTestSequenceStatus(state) {
  return ui(state).get('sendTestSequenceStatus', false);
};
var getSendTestSequencePending = function getSendTestSequencePending(state) {
  return getSendTestSequenceStatus(state) === __WEBPACK_IMPORTED_MODULE_8__actions__["_132" /* sendTestSequencePending */].toString();
};

var isTemplateContactPreviewLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (uiRoot) {
  return uiRoot.get('templateContactPreviewLoading', false);
});
var isAutosaveActive = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (uiRoot) {
  return uiRoot.get('autosave', false);
});
var pendingPlaybookChanges = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (uiRoot) {
  return uiRoot.get('doPlaybookChanges', false);
});
var isSaved = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (uiRoot) {
  return uiRoot.get('saved');
});
var bannerUploadPending = function bannerUploadPending(state) {
  return state.getIn(['playbooks', 'ui', 'bannerUploadPending'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var isBannerUploadPending = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([bannerUploadPending, function (state, emailId) {
  return emailId;
}], function (bannerUploadPending, emailId) {
  return bannerUploadPending.get(emailId, false);
});
var pendingDraftStatus = (ui, function (uiRoot) {
  return uiRoot.get('doPending', false);
});
var priorityOrderedPlaybookIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('priorityOrderedPlaybookIds', []);
});
var playbookCounts = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('counts', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
});
var isSaving = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('saving');
});
var isFetching = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('fetching');
});
var getSendEmailConfirmModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('sendEmailConfirmModalVisible');
});
var getAnswerModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('answerModalVisible');
});
var getQuestionAdvancedModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('QuestionAdvancedModalVisible');
});
var getRenderedEmailPreview = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([ui, function (state, playbookId) {
  return playbookId;
}], function (ui, playbookId) {
  return ui.getIn(['emailRenderedPreviews', playbookId]);
});
var playbookIdForCampaignIdFailed = function playbookIdForCampaignIdFailed(state, campaignId) {
  return state.getIn(['playbooks', 'ui', 'campaignIdToPlaybookIdMap', campaignId]) === null;
};
var playbookIdForCampaignIdLoading = function playbookIdForCampaignIdLoading(state, campaignId) {
  return state.getIn(['playbooks', 'ui', 'campaignIdToPlaybookIdMap', campaignId]) === 'PENDING';
};
var playbookIdForCampaignId = function playbookIdForCampaignId(state, campaignId) {
  return state.getIn(['playbooks', 'ui', 'campaignIdToPlaybookIdMap', campaignId]);
};
var getGoalActionModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('goalActionModalVisible');
});
var getEditSenderModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.getIn(['editSenderModal', 'visible']);
});
var getEditSenderModalEditingEmailId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.getIn(['editSenderModal', 'editingEmailId']);
});
var getTokenModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('tokenModalVisible');
});
var getCtaButtonModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('ctaButtonModalVisible');
});
var getCalendarLinkModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('calendarLinkVisible');
});
var getGoogleAuthModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('googleAuthModalVisible');
});
var getGoalRoutingModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('goalRoutingModalVisible');
});
var getExtensionInviteModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('extensionInviteModalVisible');
});
var segmentSelectVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('segmentSelectVisible');
});
var getConditionModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('conditionModalVisible');
});
var getScheduleModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('scheduleModalVisible');
});
var sequenceInviteModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('sequenceInviteModalVisible');
});
var calendarProfileLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('calendarProfileLoading');
});
var cardinalityLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('cardinalityLoading');
});
var targetingCardinality = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('targetingCardinality');
});
var getDisableSalesSequenceModalVisible = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('disableSalesSequenceModalVisible');
});

var currentGoalId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('currentGoalId');
});
var currentGoal = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(goals, currentGoalId, function (goals, currentGoalId) {
  return goals.get(currentGoalId) || __WEBPACK_IMPORTED_MODULE_5__models__["g" /* Goal */]();
});
var currentGoalRouting = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentGoal, function (currentGoal) {
  return currentGoal.get('routing') || __WEBPACK_IMPORTED_MODULE_5__models__["n" /* RoutingOption */]();
});
var isCurrentGoalRoutingSingle = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentGoalRouting, function (currentGoalRouting) {
  return currentGoalRouting && currentGoalRouting.type === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE;
});
var selectedGoalAction = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('selectedGoalAction');
});
var selectedGoalRoutingOption = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('selectedGoalRoutingOption') || __WEBPACK_IMPORTED_MODULE_5__models__["n" /* RoutingOption */]();
});
var isSingleRoutingSelected = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(selectedGoalRoutingOption, function (selectedGoalRoutingOption) {
  return selectedGoalRoutingOption.get('type') === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE;
});
var goalRoutingView = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('goalRoutingView');
});
var isGroupRoutingSelected = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(selectedGoalRoutingOption, function (selectedGoalRoutingOption) {
  return selectedGoalRoutingOption.get('type') === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_150" /* RoutingType */].GROUP;
});
var isGlobalRoutingSelected = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(selectedGoalRoutingOption, function (selectedGoalRoutingOption) {
  return selectedGoalRoutingOption.get('type') === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL;
});
var isNoRoutingSelected = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(selectedGoalRoutingOption, function (selectedGoalRoutingOption) {
  return selectedGoalRoutingOption.get('type') === null;
});

var getCurrentConditionId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('currentConditionId');
});

var getCurrentAnswerId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('currentAnswerId');
});
var getCurrentAnswer = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getCurrentAnswerId, answers, function (currentAnswerId, answers) {
  return answers.get(currentAnswerId);
});
var keywordsByAnswerId = function keywordsByAnswerId(answerId) {
  return function (state) {
    return getAnswer(state, { id: answerId }).get('keywords').map(function (keywordId) {
      return getKeyword(state, { id: keywordId });
    });
  };
};
var getCurrentQuestionId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(ui, function (ui) {
  return ui.get('currentQuestionId');
});
var getCurrentQuestion = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(questions, getCurrentQuestionId, function (questions, currentQuestionId) {
  return questions.find(function (q) {
    return q.id === currentQuestionId;
  });
});
var getCurrentQuestionByAnswer = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getCurrentAnswerId, questions, function (currentAnswerId, questions) {
  return questions.find(function (question) {
    return question.answers.includes(currentAnswerId);
  });
});

var getQuestionIndex = function getQuestionIndex(state, props) {
  return interaction(state).questions.findIndex(function (questionId) {
    return questionId === props.id;
  });
};

var buttonOnlyResponses = function buttonOnlyResponses(state, questionId) {
  return (questions(state).find(function (q) {
    return q.id === questionId;
  }) || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).get('isButtonOnly', false);
};
var keywordAnswersForQuestion = function keywordAnswersForQuestion(state, questionId) {
  return answers(state).filter(function (a) {
    return a.questionId === questionId && a.type === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["t" /* AnswerType */].KEYWORDS;
  });
};
var questionHasKeywordAnswers = function questionHasKeywordAnswers(state, questionId) {
  return !keywordAnswersForQuestion(state, questionId).isEmpty();
};
var numKeywordsInQuestion = function numKeywordsInQuestion(state, questionId) {
  return keywordAnswersForQuestion(state, questionId).reduce(function (numKeywords, answer) {
    return numKeywords + (answer.keywords.size || answer.keywords.length || 0);
  }, 0);
};

var getCurrentAnswerHasSpecialKeyword = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getCurrentAnswerId, keywords, function (currentAnswerId, keywords) {
  return keywords.some(function (keyword) {
    return keyword.special && keyword.answerId === currentAnswerId;
  });
});

var goalSkipToOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draft, goals, __WEBPACK_IMPORTED_MODULE_9_app_modules_classification_selectors__["b" /* classifications */], function (draft, goals, classifications) {
  return draft.get('goals').map(function (goalId) {
    return goals.get(goalId);
  }).map(function (goal, i) {
    var classification = classifications.find(function (cl) {
      return cl.id === goal.classification.get('classificationId');
    });
    return {
      value: {
        id: goal.id,
        isGoal: true
      },
      label: 'Goal ' + (i + 1) + ': ' + (classification ? classification.name : '...')
    };
  });
});

var questionSkipToOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(function (state) {
  return state;
}, interaction, questions, function (state, interaction, questions) {
  var options = interaction.questions.map(function (questionId) {
    return questions.get(questionId);
  }).map(function (question, i) {
    var doesEmailCapture = isEmailCaptureQuestion(state, question);
    var doesPhoneCapture = isPhoneCaptureQuestion(state, question);
    var prompt = Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["i" /* truncateWords */])(question.prompt.replace(/<[^>]*>/g, ''), 8);
    return {
      value: {
        id: question.id,
        isGoal: false
      },
      label: doesEmailCapture ? 'Email Capture Question ' + (i + 1) + ': ' + (prompt || '...') : doesPhoneCapture ? 'Phone Capture Question ' + (i + 1) + ': ' + (prompt || '...') : 'Question ' + (i + 1) + ': ' + (prompt || '...')
    };
  });
  return options;
});

var skipToOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(questionSkipToOptions, goalSkipToOptions, function (questionSkipTos, goalSkipTos) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])().concat(questionSkipTos, goalSkipTos).push(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_13" /* END_CONVERSATION_OPTION */]).filter(Boolean).toArray();
});

var skipToOption = function skipToOption(answerId) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(skipToOptions, answers, interaction, function (skipToOptions, answers, interaction) {
    var answer = answers.get(answerId);
    var isLastQuestion = interaction.questions.last() === answer.questionId;
    if (answer.skipTo) {
      return skipToOptions.find(function (option) {
        return option.value.id === answer.skipTo;
      });
    }
    if (answer.getIn(['skipToGoal', 'goalId'])) {
      var goalOption = skipToOptions.find(function (option) {
        return option.value.id === answer.getIn(['skipToGoal', 'goalId']);
      });
      if (goalOption) {
        return goalOption;
      }
    }
    if (isLastQuestion) {
      return __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_13" /* END_CONVERSATION_OPTION */];
    } else {
      return __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_139" /* PROCEED_OPTION */];
    }
  });
};

var currentSkipToOption = function currentSkipToOption(state) {
  var answerId = getCurrentAnswerId(state);
  return skipToOption(answerId)(state);
};

var targeting = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draft, function (draft) {
  return draft.get('targeting') || __WEBPACK_IMPORTED_MODULE_5__models__["s" /* Targeting */]();
});
var audience = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('audience');
});
var dueAt = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  var dueAt = targeting.get('dueAt');
  if (dueAt === null) {
    return null;
  }
  var utcDueAt = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.utc(dueAt);
  return utcDueAt.clone().tz(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess()); // return in local tz
});
var excludedUserListIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('excludedUserListIds');
});
var userListIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('userListIds');
});
var accountListIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('accountListIds');
});
var excludedAccountListIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('excludedAccountListIds');
});
var builderSmartFilters = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('smartFilters');
});
var targetingDisplay = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('display');
});
var draftFrequency = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('campaignReenrollmentType');
});
var sequenceUnenrollOnReply = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('unenrollOnReply');
});
var sequenceUnenrollDomainOnReply = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('unenrollOnReplyByDomain');
});
var smartFilters = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.get('smartFilters');
});
var smartFilterEngagedContacts = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  // "engagedContacts" is a value shown to the user, behind the scenes, it's a package of:
  // meetingScheduled and salesSequenceEngaged
  return targeting.getIn(['smartFilters', 'meetingScheduled']);
});
var smartFilterChatEngagedContacts = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(targeting, function (targeting) {
  return targeting.getIn(['smartFilters', 'chatEngaged']);
});

var getConditionSets = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('conditionSets');
});
var getConditionSet = function getConditionSet(state, props) {
  return getConditionSets(state).get(props.id);
};

var getConditions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draftRoot) {
  return draftRoot.get('conditions');
});
var getFirstCondition = function getFirstCondition(state) {
  return getConditions(state).first();
};
var getCondition = function getCondition(state, props) {
  return getConditions(state).get(props.id);
};
var getNumConditions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getConditions, function (conditions) {
  return conditions.size;
});

var playbookReportTypePlans = function playbookReportTypePlans(state) {
  return root(state).get('playbookReportTypesByGate');
};
var playbookReportTypePlansLoading = function playbookReportTypePlansLoading(state) {
  return playbookReportTypePlans(state).get('loading', false);
};
var playbookReportTypePlansLoaded = function playbookReportTypePlansLoaded(state) {
  return playbookReportTypePlans(state).get('loaded', false);
};
var getPlaybookReportTypePlansEnabled = function getPlaybookReportTypePlansEnabled(state) {
  return playbookReportTypePlans(state).get('types', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).map(function (gates) {
    return gates.length === 0 || gates.some(function (gate) {
      return Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__["u" /* makeHasGate */])(gate)(state);
    });
  });
};

var getPlaybookEditorLink = function getPlaybookEditorLink(state, _ref5) {
  var id = _ref5.id,
      reportType = _ref5.reportType;
  return __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_133" /* NEW_EDITOR_PLAYBOOK_TYPES */].includes(reportType) ? '/playbooks/editor/' + id + '/' : '/playbooks/' + id + '/edit';
};

var signatureRoot = function signatureRoot(state) {
  return root(state).getIn(['ui', 'signatures'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var signaturePreviewAll = function signaturePreviewAll(state) {
  return signatureRoot(state).get('previewAll', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var signaturePreviewAllStatus = function signaturePreviewAllStatus(state) {
  return signaturePreviewAll(state).get('status');
};
var signaturePreviewAllFetchPending = function signaturePreviewAllFetchPending(state) {
  return [__WEBPACK_IMPORTED_MODULE_8__actions__["_62" /* fetchSignatureMultiBannerPreview */].toString(), __WEBPACK_IMPORTED_MODULE_8__actions__["_64" /* fetchSignatureMultiBannerPreviewPending */].toString()].includes(signaturePreviewAllStatus(state));
};
var signaturePreviewAllFetchFailed = function signaturePreviewAllFetchFailed(state) {
  return __WEBPACK_IMPORTED_MODULE_8__actions__["_63" /* fetchSignatureMultiBannerPreviewFailed */].toString() === signaturePreviewAllStatus(state);
};
var signaturePreviewAllData = function signaturePreviewAllData(state) {
  return signaturePreviewAll(state).getIn(['data'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var signaturePreviewAllContent = function signaturePreviewAllContent(state, signatureId) {
  return signaturePreviewAll(state).getIn(['data', 'signaturePreview', '' + signatureId]);
};

var signatures = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(draftRoot, function (draft) {
  return draft.get('signatureActions');
});
var firstSignature = function firstSignature(state) {
  return signatures(state).first() || __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */]();
};
var signature = function signature(state, signatureId) {
  return signatures(state).get(signatureId);
};

var viewingSignatureId = function viewingSignatureId(state) {
  return firstSignature(state).id;
};

// for now, everything except the banner is shared between signatures in a playbook
var signatureBody = function signatureBody(state) {
  return firstSignature(state).get('signatureBody');
};
var signatureIncludeAvatar = function signatureIncludeAvatar(state) {
  return firstSignature(state).get('includeAvatar', false);
};
var signatureIncludeSocial = function signatureIncludeSocial(state) {
  return firstSignature(state).get('includeCompanySocialMedia', false);
};
var signatureIncludeBanner = function signatureIncludeBanner(state) {
  return firstSignature(state).get('hasCampaignGraphic', false);
};

var signatureBannerImgURL = function signatureBannerImgURL(state, signatureId) {
  return signatures(state).getIn(['' + signatureId, 'campaignGraphic']);
};
var signatureBannerLinkURL = function signatureBannerLinkURL(state, signatureId) {
  return signatures(state).getIn(['' + signatureId, 'campaignGraphicLink']);
};

// TODO: deprecated, remove these soon
var getSignature = function getSignature(state) {
  return __WEBPACK_IMPORTED_MODULE_5__models__["p" /* Signature */](firstAction(state));
};
var getSignatureBody = function getSignatureBody(state) {
  return getSignature(state).get('signatureBody');
};
var getSignatureIncludeAvatar = function getSignatureIncludeAvatar(state) {
  return getSignature(state).get('includeAvatar', false);
};
var getSignatureIncludeSocial = function getSignatureIncludeSocial(state) {
  return getSignature(state).get('includeCompanySocialMedia', false);
};
var getSignatureIncludeBanner = function getSignatureIncludeBanner(state) {
  return getSignature(state).get('hasCampaignGraphic', false);
};
var getSignatureBannerImgURL = function getSignatureBannerImgURL(state) {
  return getSignature(state).get('campaignGraphic');
};
var getSignatureBannerLinkURL = function getSignatureBannerLinkURL(state) {
  return getSignature(state).get('campaignGraphicLink');
};

var campaignIdToPlaybook = function campaignIdToPlaybook(state) {
  return root(state).get('campaignIdToPlaybook');
};
var campaignIdToPlaybookStatus = function campaignIdToPlaybookStatus(state, campaignId) {
  return campaignIdToPlaybook(state).getIn([campaignId, 'status']);
};
var playbookForCampaignIdNeverFetched = function playbookForCampaignIdNeverFetched(state, campaignId) {
  return campaignIdToPlaybookStatus(state, campaignId) === undefined;
};
var playbookForCampaignIdPending = function playbookForCampaignIdPending(state, campaignId) {
  return campaignIdToPlaybookStatus(state, campaignId) === __WEBPACK_IMPORTED_MODULE_8__actions__["_38" /* fetchPlaybookForCampaignIdPending */].toString();
};
var playbookForCampaignIdFailed = function playbookForCampaignIdFailed(state, campaignId) {
  return campaignIdToPlaybookStatus(state, campaignId) === __WEBPACK_IMPORTED_MODULE_8__actions__["_37" /* fetchPlaybookForCampaignIdFailed */].toString();
};
var playbookForCampaignId = function playbookForCampaignId(state, campaignId) {
  return campaignIdToPlaybook(state).getIn([campaignId, 'data']);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "gk5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__page__ = __webpack_require__("Ybad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GoogleOAuthConnect__ = __webpack_require__("Zmw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MicrosoftOAuthConnect__ = __webpack_require__("dUcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_onboarding_google_G_logo_L_svg__ = __webpack_require__("tPhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_onboarding_google_G_logo_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_onboarding_google_G_logo_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_logos_office_365_svg__ = __webpack_require__("Qb1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_logos_office_365_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_logos_office_365_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_settings_Settings_styl__ = __webpack_require__("cLnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_settings_Settings_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_components_settings_Settings_styl__);











var CalendarConnect = function CalendarConnect(_ref) {
  var googleAuthed = _ref.googleAuthed,
      microsoftAuthed = _ref.microsoftAuthed,
      handleSaveRedirect = _ref.handleSaveRedirect;

  var CalendarLogo = googleAuthed ? React.createElement('img', { className: 'connect-calendar-header-logo', src: __WEBPACK_IMPORTED_MODULE_4_images_onboarding_google_G_logo_L_svg___default.a, alt: 'Google logo' }) : React.createElement('img', { className: 'connect-calendar-header-logo', src: __WEBPACK_IMPORTED_MODULE_5_images_logos_office_365_svg___default.a, alt: 'Outlook 365 logo' });
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_1__page__["a" /* default */],
    null,
    React.createElement(
      'div',
      { className: 'subsection' },
      React.createElement(
        'div',
        { className: 'subheader select-calendar' },
        CalendarLogo,
        React.createElement(
          'div',
          { className: 'select-calendar-text' },
          'Connect your ' + (googleAuthed ? 'Google' : 'Office 365') + ' calendar'
        )
      ),
      React.createElement(
        'div',
        { className: 'settings-body-copy select-calendar' },
        'When a new meeting is scheduled with you, we\u2019ll check this calendar for any conflicts and add a new calendar event to it. Don\u2019t see the calendar you want? Make sure it\u2019s not \u201Cread-only\u201D and can be modified.'
      ),
      React.createElement(
        'div',
        { className: 'settings-calendars-connected' },
        googleAuthed && React.createElement(__WEBPACK_IMPORTED_MODULE_2__GoogleOAuthConnect__["a" /* default */], { hideIcon: true, buttonLabel: 'Connect + Finish Setup', onSave: handleSaveRedirect }),
        microsoftAuthed && React.createElement(__WEBPACK_IMPORTED_MODULE_3__MicrosoftOAuthConnect__["a" /* default */], { hideIcon: true, buttonLabel: 'Connect + Finish Setup', onSave: handleSaveRedirect })
      ),
      React.createElement(
        'div',
        { className: 'assistant-footer' },
        React.createElement(
          'div',
          { className: 'subheader select-calendar' },
          'When you connect your calendar, you\u2019ll also get your own Drift Assistant'
        ),
        React.createElement(
          'p',
          { className: 'settings-body-copy assistant-helper-copy' },
          'The',
          ' ',
          React.createElement(
            'a',
            {
              href: 'https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work',
              target: '_blank',
              rel: 'noreferrer noopener'
            },
            'Drift Assistant'
          ),
          ' ',
          'helps you close more deals with less work. It prepares you for meetings and sends reminders so you never accidentally lose a lead or opportunity again.',
          ' ',
          React.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work', target: '_blank', rel: 'noreferrer noopener' },
            'Learn more'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* withRouter */])(CalendarConnect));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "gndv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gneb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl__ = __webpack_require__("Qbpt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AutoSyncCallout__ = __webpack_require__("fysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MarketoIntegrationPage_MarketoActivityMapper__ = __webpack_require__("O19k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__model__ = __webpack_require__("YwI9");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.';
var PATCH_ERROR_MESSAGE = 'We could not save your changes.';

var MarketoConfig = function (_Component) {
  _inherits(MarketoConfig, _Component);

  function MarketoConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarketoConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarketoConfig.__proto__ || Object.getPrototypeOf(MarketoConfig)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      syncLeadsEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][0],
      identityResolutionEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][1],
      associateLeadsEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][2],
      conversationTranscriptEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][3],
      shouldOnlySyncQualifiedLeads: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][4],
      leadOwnerFieldEnabled: __WEBPACK_IMPORTED_MODULE_10__model__["b" /* model */][5]
    }, _this.onError = function () {
      var router = _this.context.router;


      _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
      router.push({ pathname: '/settings/setup/marketo' });
    }, _this.onPatchError = function () {
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.receiveToggles = function (resp) {
      _this.setState({
        syncLeadsEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[0],
        identityResolutionEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[1],
        associateLeadsEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[2],
        conversationTranscriptEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[3],
        shouldOnlySyncQualifiedLeads: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[4],
        leadOwnerFieldEnabled: Object(__WEBPACK_IMPORTED_MODULE_10__model__["a" /* hydrateModel */])(resp)[5]
      });
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('Marketo settings are updated!');
    }, _this.patchToggle = function (event, toggle) {
      var data = _defineProperty({}, toggle.type, event);

      Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["J" /* patchMarketoToggles */])(data).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarketoConfig, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["z" /* getMarketoToggles */])().then(this.receiveToggles).catch(this.onError);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          syncLeadsEnabled = _state.syncLeadsEnabled,
          identityResolutionEnabled = _state.identityResolutionEnabled,
          associateLeadsEnabled = _state.associateLeadsEnabled,
          conversationTranscriptEnabled = _state.conversationTranscriptEnabled,
          shouldOnlySyncQualifiedLeads = _state.shouldOnlySyncQualifiedLeads,
          leadOwnerFieldEnabled = _state.leadOwnerFieldEnabled;


      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Marketo Integration',
          backLinkUrl: '/settings/setup/marketo'
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Synced Marketo Data'
          ),
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
            'p',
            null,
            'Choose which data is sent between Marketo and Drift.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Drift',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Marketo'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AutoSyncCallout__["a" /* default */], { integrationName: 'Marketo' }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__["a" /* default */], {
          toggles: [syncLeadsEnabled, associateLeadsEnabled, conversationTranscriptEnabled, shouldOnlySyncQualifiedLeads, leadOwnerFieldEnabled],
          onChange: this.patchToggle,
          onSuccess: this.settingsUpdatedNotification
        }),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          { className: 'marketo-activity-mapper-wrapper' },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MarketoIntegrationPage_MarketoActivityMapper__["a" /* default */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Marketo',
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Drift'
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_IntegrationToggles__["a" /* default */], {
          toggles: [identityResolutionEnabled],
          onChange: this.patchToggle,
          onSuccess: this.settingsUpdatedNotification
        })
      );
    }
  }]);

  return MarketoConfig;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

MarketoConfig.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_components_shared_notifications__["a" /* default */])(MarketoConfig));

/***/ }),

/***/ "gp6G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_message_selectors__ = __webpack_require__("bWf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ClearbitRevealPreview__ = __webpack_require__("FgcT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkedinSection__ = __webpack_require__("mxgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_utils_Integrations__ = __webpack_require__("CCiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CompanyDisplayNameMap__ = __webpack_require__("4tyc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Header__ = __webpack_require__("sTFW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Placeholder__ = __webpack_require__("sJs2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("LqW9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_sidebar_no_company_data_svg__ = __webpack_require__("0NJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_sidebar_no_company_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_sidebar_no_company_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_Presence_CompanyInfo_CompanyInfoProvider__ = __webpack_require__("Kxxm");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var Loading = function Loading() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__style_styl__["Sidebar"], 'placeholder') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Placeholder__["a" /* default */], null)
  );
};

var Empty = function Empty() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_16__style_styl__["Sidebar"], 'empty') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, { className: 'no-company-info', src: __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_sidebar_no_company_data_svg___default.a }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'no-company-info-text' },
      'We don\u2019t have any company data for this person.'
    )
  );
};

var CompanyDataRow = function CompanyDataRow(_ref) {
  var fieldData = _ref.fieldData,
      displayName = _ref.displayName;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'row' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-info' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-label' },
        displayName
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-value' },
        fieldData
      )
    )
  );
};

var Company = function (_Component) {
  _inherits(Company, _Component);

  function Company() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Company);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Company.__proto__ || Object.getPrototypeOf(Company)).call.apply(_ref2, [this].concat(args))), _this), _this.handleRedesignAcknowledged = function () {
      _this.props.actions.updateUserProperties({
        notify: false,
        properties: { 'did_acknowledge_contact_sidebar_redesign': true }
      });
    }, _this.renderCompanyTabRedesignPopover = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-tab-redesign-popover' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'title' },
          'More Room to Breathe',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'badge' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'body' },
          'We\u2019ve given Company profiles a new home so your conversations have more room to breathe.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13__driftt_tide_core_legacy__["Button"],
            { onClick: _this.handleRedesignAcknowledged, size: 'small' },
            'Got it!'
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Company, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$companyData = _props.companyData,
          name = _props$companyData.name,
          domain = _props$companyData.domain,
          logo = _props$companyData.logo,
          linkedInHandle = _props$companyData.linkedInHandle,
          twitterHandle = _props$companyData.twitterHandle,
          source = _props$companyData.source,
          url = _props$companyData.url,
          companyData = _props.companyData,
          isCurrentUserEligibleForRedesignAnnouncement = _props.isCurrentUserEligibleForRedesignAnnouncement,
          hasLinkedin = _props.hasLinkedin;


      var companyProvider = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_Presence_CompanyInfo_CompanyInfoProvider__["a" /* default */], { provider: source });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_16__style_styl__["Sidebar"] },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Header__["a" /* default */], {
          className: 'header-section',
          companyName: name,
          companyDomain: domain,
          companyUrl: url,
          companyLogo: logo,
          companyLinkedInHandle: linkedInHandle,
          companyTwitterHandle: twitterHandle
        }),
        isCurrentUserEligibleForRedesignAnnouncement && this.renderCompanyTabRedesignPopover(),
        canDisplayLinkedinSectionCompany(hasLinkedin, name, url) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LinkedinSection__["a" /* default */], { companyName: name, companyUrl: url }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'attributes-section' },
          Object.keys(__WEBPACK_IMPORTED_MODULE_12__CompanyDisplayNameMap__["a" /* default */]).map(function (field) {
            if (!!companyData[field]) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanyDataRow, { key: __WEBPACK_IMPORTED_MODULE_12__CompanyDisplayNameMap__["a" /* default */][field], fieldData: companyData[field], displayName: __WEBPACK_IMPORTED_MODULE_12__CompanyDisplayNameMap__["a" /* default */][field] });
            }
          })
        ),
        !!companyProvider && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          companyProvider
        )
      );
    }
  }]);

  return Company;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var canDisplayLinkedinSectionCompany = function canDisplayLinkedinSectionCompany(hasLinkedin, name, website) {
  return hasLinkedin && !!(name || website);
};

var makeMapStateToProps = function makeMapStateToProps() {

  return function (state, props) {
    var conversationId = props.conversationId;


    return {
      isCurrentUserEligibleForRedesignAnnouncement: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_selectors__["c" /* isCurrentUserEligibleForContactSidebarRedesignAnnouncement */](state),
      firstMessagesLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_message_selectors__["b" /* firstMessagesLoaded */](state, { conversationId: conversationId }),
      firstMessagesLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_message_selectors__["c" /* firstMessagesLoading */](state, { conversationId: conversationId }),
      hasLinkedin: Object(__WEBPACK_IMPORTED_MODULE_11_utils_Integrations__["b" /* isIntegrationConnected */])('linkedin')
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      updateUserProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_actions__["l" /* updateUserProperties */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return props.firstMessagesFailed;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Empty)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.firstMessagesLoaded;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Loading)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.ip && !props.email;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Empty)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.isCompanyDataLoaded;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Loading)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return !props.isCompanyDataLoading && !props.companyData;
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Empty)), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (props) {
  return _.every(props.companyData, function (data) {
    return !data || _.isEmpty(data);
  });
}, Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["f" /* renderComponent */])(Empty)))(Company));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "grSu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return variation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("wwd1");


var variation = function variation(feature) {
  if (__WEBPACK_IMPORTED_MODULE_0__epic__["a" /* client */]) {
    return __WEBPACK_IMPORTED_MODULE_0__epic__["a" /* client */].getTreatment(feature);
  } else {
    console.warn('split-io client unavailable - assuming control treatment for ' + feature);
  }
};

/***/ }),

/***/ "gtVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (Object.freeze(["postalCode", "postal_code", "employmentRole", "employment_role", "employmentSeniority", "employment_seniority", "displayLocation", "display_location", "latitude", "longitude", "displayName", "display_name", "githubHandle", "github_handle", "githubFollowers", "github_followers", "twitterHandle", "twitter_handle", "twitterFollowers", "twitter_followers", "facebookHandle", "facebook_handle", "linkedinHandle", "linkedin_handle", "bio", "gender", "site"]));

/***/ }),

/***/ "h/k+":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30.906 24.943H14.96c-.55 0-.997-.447-.997-.998 0-.55.447-.998.997-.998h15.946c.55 0 .997.447.997.998 0 .55-.446.998-.997.998zm0-6.982H14.96c-.55 0-.997-.444-.997-.996 0-.55.447-.997.997-.997h15.946c.55 0 .997.446.997.997 0 .552-.446.997-.997.997zm0-6.98h-8.97c-.55 0-.996-.445-.996-.997 0-.55.446-.997.996-.997h8.97c.55 0 .997.446.997.997 0 .552-.446.997-.997.997zm0-6.98H17.95c-.55 0-.997-.447-.997-.998 0-.55.447-.998.997-.998h12.956c.55 0 .997.447.997.998 0 .55-.446.997-.997.997zm-13.29 6.728c-.19.17-.427.252-.662.252-.275 0-.55-.113-.746-.335L9.906 3.55v27.42c0 .55-.376.954-.926.954s-.997-.446-.997-.997V3.63l-6.23 7.015c-.367.412-.996.45-1.41.083-.41-.366-.447-.997-.08-1.407L8.234.346c.006-.007.015-.01.02-.015.183-.195.438-.32.725-.32.282 0 .515.11.678.287.02.02.048.027.067.048l7.973 8.976c.366.41.33 1.042-.082 1.408zm-2.656 19.2h15.946c.55 0 .997.447.997 1 0 .55-.446.996-.997.996H14.96c-.55 0-.997-.446-.997-.997 0-.552.447-.998.997-.998z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "h2QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Loading__ = __webpack_require__("nNzv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors_json__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_colors_json__);





function Cancel(_ref) {
  var onClick = _ref.onClick;

  return React.createElement(
    'div',
    {
      style: { cursor: 'pointer', marginRight: 15 },
      className: 'dsg-Body color-navy',
      onClick: onClick
    },
    'Cancel'
  );
}

function Save(_ref2) {
  var changed = _ref2.changed,
      onClick = _ref2.onClick;

  return React.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('dsg-Body', { link: changed, 'color-navy-light': !changed }),
      onClick: onClick
    },
    'Save'
  );
}

function CancelAndSave(_ref3) {
  var updating = _ref3.updating,
      changed = _ref3.changed,
      onCancel = _ref3.onCancel,
      onSave = _ref3.onSave;

  var content = void 0;
  if (updating) {
    content = React.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Loading__["a" /* default */], { color: __WEBPACK_IMPORTED_MODULE_2_styles_colors_json___default.a['color-teal'], size: 'small' });
  } else {
    content = [React.createElement(Cancel, { onClick: onCancel, key: 'cancel' }), React.createElement(Save, { changed: changed, onClick: onSave, key: 'save' })];
  }
  return React.createElement(
    'div',
    { className: 'flex' },
    content
  );
}

/* harmony default export */ __webpack_exports__["a"] = (CancelAndSave);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "h2eI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_Routing_constants_js__ = __webpack_require__("jUKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("DCOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_caret_icon_svg__ = __webpack_require__("75Yw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_caret_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_caret_icon_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var BackButton = function BackButton(_ref) {
  var url = _ref.url,
      title = _ref.title;

  var relativePath = url.replace('/settings', '');
  var pathObj = __WEBPACK_IMPORTED_MODULE_3_components_settings_Routing_constants_js__["a" /* CUTOVER_SETTINGS_ROUTES */].find(function (route) {
    return route.path === relativePath;
  });
  var shouldRedirect = pathObj && (!pathObj.requiredGate || __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates(pathObj.requiredGate));

  var linkProps = shouldRedirect ? { href: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["c" /* APP_URL */] + '/settings2' + relativePath } : { to: '' + url };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
    _extends({
      className: __WEBPACK_IMPORTED_MODULE_6__style_styl___default.a.BackButton
    }, linkProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_caret_icon_svg___default.a }),
    title
  );
};

/* harmony default export */ __webpack_exports__["a"] = (BackButton);

/***/ }),

/***/ "h41x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__ = __webpack_require__("zyQd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_DrifttHelpers__ = __webpack_require__("Ycog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_campaign_constants__ = __webpack_require__("Ljxo");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var CampaignQueries = Marty.createQueries({
  id: 'CampaignQueries',

  createCampaign: function createCampaign(body, requestId) {
    var _this = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_STARTING, requestId);

    var promise = this.app.sources.CampaignAPI.createCampaign(body);

    promise.then(function (res) {
      if (res.status === 200) {
        var campaign = res.body;
        _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_DONE, campaign, requestId);

        var notification = {
          content: 'You\'ve created a new campaign: ' + campaign.name,
          displayTime: 5000
          // Don't include a URL for Chat campaigns (which have no reports page)
        };if (campaign.type !== __WEBPACK_IMPORTED_MODULE_3_components_campaign_constants__["b" /* TYPES */].chat.serverType) {
          notification.viewLinkTo = {
            pathname: '/campaigns/' + campaign.id
          };
        }

        return _this.app.actions.NotificationActions.pushNotification(notification);
      } else if (res.status === 403) {
        _this.app.actions.NotificationActions.pushNotification({
          content: "Before you can send email campaigns you need to be verified by the Drift team",
          actioNode: React.createElement(
            'button',
            { className: 'dsg-SmallButton', onClick: __WEBPACK_IMPORTED_MODULE_2_utils_DrifttHelpers__["b" /* openSidebar */] },
            'Chat with us'
          ),
          sticky: true,
          variant: 'red'
        });
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_FAILED, requestId, res);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_FAILED, requestId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_CREATE_FAILED, requestId, error);
    });
  },
  updateCampaign: function updateCampaign(id, update) {
    var _this2 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_STARTING, id, update);

    var promise = this.app.sources.CampaignAPI.updateCampaign(id, update);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_DONE, id, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED, id, update, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED, id, update, error);
    });
  },
  updateCampaignOld: function updateCampaignOld(id, update) {
    var _this3 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_STARTING, id, update);

    var promise = this.app.sources.CampaignAPI.updateCampaignOld(id, update);

    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_DONE, id, res.body);
        if (update.status === __WEBPACK_IMPORTED_MODULE_3_components_campaign_constants__["a" /* STATUS */].NOT_RUNNING.key) {
          return _this3.app.actions.NotificationActions.pushNotification({
            content: 'Campaign has been paused'
          });
        } else if (update.status === __WEBPACK_IMPORTED_MODULE_3_components_campaign_constants__["a" /* STATUS */].RUNNING.key) {
          return _this3.app.actions.NotificationActions.pushNotification({
            content: 'Campaign has been started'
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED, id, update, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_UPDATE_FAILED, id, update, error);
    });
  },
  fetchCampaigns: function fetchCampaigns() {
    var _this4 = this;

    var promise = this.app.sources.CampaignAPI.fetchCampaigns();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FETCH_FAILED, error);
    });
  },
  fetchCampaign: function fetchCampaign(id) {
    var _this5 = this;

    var accessToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var promise = this.app.sources.CampaignAPI.fetchCampaign(id, accessToken);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_FETCH_DONE, id, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_FETCH_FAILED, id, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_FETCH_FAILED, id, error);
    });
  },
  fetchCampaignsForEndUserId: function fetchCampaignsForEndUserId(endUserId) {
    var _this6 = this;

    var promise = this.app.sources.CampaignAPI.fetchCampaignsForEndUserId(endUserId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FOR_END_USER_FETCH_DONE, endUserId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FOR_END_USER_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGNS_FOR_END_USER_FETCH_FAILED, error);
    });
  },
  fetchCampaignResults: function fetchCampaignResults(campaignId) {
    var _this7 = this;

    var promise = this.app.sources.CampaignAPI.fetchCampaignResults(campaignId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESULTS_FETCH_DONE, campaignId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESULTS_FETCH_FAILED, campaignId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESULTS_FETCH_FAILED, campaignId, error);
    });
  },
  fetchCampaignMembers: function fetchCampaignMembers(campaignId, query) {
    var _this8 = this;

    var promise = this.app.sources.CampaignAPI.fetchCampaignMembers(campaignId, query);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_MEMBERS_FETCH_DONE, campaignId, query, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_MEMBERS_FETCH_FAILED, campaignId, query, res);
      }
    });

    promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_MEMBERS_FETCH_FAILED, campaignId, query, error);
    });

    promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESPONSES_FETCH_FAILED, error);
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_RESPONSES_FETCH_FAILED, error);
    });
  },
  deleteCampaignForCampaignId: function deleteCampaignForCampaignId(campaignId) {
    var _this9 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_DELETE_STARTING, campaignId);

    var promise = this.app.sources.CampaignAPI.updateCampaignOld(campaignId, { status: 'ARCHIVED' });
    promise.then(function (res) {
      if (res.status === 200) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_DELETE_DONE, campaignId);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_DELETE_FAILED, campaignId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CampaignConstants__["a" /* default */].CAMPAIGN_DELETE_FAILED, campaignId, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CampaignQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("U7vG")))

/***/ }),

/***/ "h6+o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var actions = {
  REFRESH_ALL_PLZ: 'REFRESH_ALL_PLZ',
  FETCH_ORG_END_USER_COUNT_DONE: 'FETCH_ORG_END_USER_COUNT_DONE',
  FETCH_ORG_END_USER_COUNT_HISTORY_DONE: 'FETCH_ORG_END_USER_COUNT_HISTORY_DONE',
  FETCH_LATEST_CAMPAIGN_STATS_DONE: 'FETCH_LATEST_CAMPAIGN_STATS_DONE',
  FETCH_OPEN_CONVERSATIONS_DONE: 'FETCH_OPEN_CONVERSATIONS_DONE',
  FETCH_TARGET_CONDITIONS_DONE: 'FETCH_TARGET_CONDITIONS_DONE',
  FETCH_TARGET_CONDITION_DONE: 'FETCH_TARGET_CONDITION_DONE',
  CREATE_TARGET_CONDITION_DONE: 'CREATE_TARGET_CONDITION_DONE',
  PATCH_TARGET_CONDITION_DONE: 'PATCH_TARGET_CONDITION_DONE'
};
/* harmony default export */ __webpack_exports__["default"] = (actions);

/***/ }),

/***/ "hCcJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-analytics-icon.212f2308.svg";

/***/ }),

/***/ "hCmk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("cp96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_live_live_view_empty_svg__ = __webpack_require__("ozKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_live_live_view_empty_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_live_live_view_empty_svg__);





var NoCompanyInfo = function NoCompanyInfo() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'no-company-info-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'no-company-info-icon-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'no-company-info-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_live_live_view_empty_svg___default.a })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'no-company-info-text' },
      'We don\'t have any company data',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
      'for this person'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (NoCompanyInfo);

/***/ }),

/***/ "hD25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_inbox_selectors__ = __webpack_require__("NqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_actions__ = __webpack_require__("UZmf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("RLGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var BulkMessageActions = function (_Component) {
  _inherits(BulkMessageActions, _Component);

  function BulkMessageActions(props) {
    _classCallCheck(this, BulkMessageActions);

    var _this = _possibleConstructorReturn(this, (BulkMessageActions.__proto__ || Object.getPrototypeOf(BulkMessageActions)).call(this, props));

    _this.handleOnChange = function (_ref) {
      var value = _ref.value;

      _this.setState({
        selectedInboxId: value
      });
    };

    _this.handleBulkClose = function () {
      _this.setState(function (prevState) {
        return {
          isLoading: !prevState.isLoading
        };
      }, function () {
        return _this.props.actions.bulkCloseForInbox(_this.state.selectedInboxId);
      });
    };

    _this.state = {
      isLoading: false,
      selectedInboxId: props.inboxOptions[0].value
    };
    return _this;
  }

  _createClass(BulkMessageActions, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'bulk-close-inbox-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'bulk-close-inbox-action-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bulk-close-inbox-selector-wrapper' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Select"], {
              label: 'Inbox name',
              onChange: this.handleOnChange,
              options: this.props.inboxOptions,
              value: this.state.selectedInboxId
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'bulk-close-inbox-selector-button' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
              { disabled: this.state.isLoading, onClick: this.handleBulkClose, type: 'danger' },
              'Close All Open Conversations'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'bulk-close-inbox-warning-message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'WARNING: Closing many open conversations within an inbox can lead to performance issues in the conversations view. It is recommended to perform this action during off-peak hours.'
          )
        )
      );
    }
  }]);

  return BulkMessageActions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    inboxOptions: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_inbox_selectors__["d" /* inboxOptions */])(state).toJS()
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      bulkCloseForInbox: __WEBPACK_IMPORTED_MODULE_6_app_modules_inbox_actions__["e" /* bulkCloseForInbox */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return !props.inboxOptions.length;
}, __WEBPACK_IMPORTED_MODULE_1_recompose__["g" /* renderNothing */]))(BulkMessageActions));

/***/ }),

/***/ "hD9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ActionConstants__ = __webpack_require__("h6+o");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var PusherActions = Marty.createActionCreators({
  refreshAll: function refreshAll() {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ActionConstants__["default"].REFRESH_ALL_PLZ);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (PusherActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "hDPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var EmbedAPI = Marty.createStateSource({
  id: 'EmbedAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["_3" /* WIDGET_CACHE_API */],

  fetchEmbedList: function fetchEmbedList() {
    return this.get({
      url: '/embeds',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createEmbedForInboxId: function createEmbedForInboxId(inboxId) {
    return this.post({
      url: '/embeds',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify({ configuration: { inboxId: inboxId } })
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EmbedAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "hHEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Cfau");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InputWithLimit = function (_Component) {
  _inherits(InputWithLimit, _Component);

  function InputWithLimit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputWithLimit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputWithLimit.__proto__ || Object.getPrototypeOf(InputWithLimit)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.getStateFromProps(_this.props), _this.handleChange = function (text) {
      if (text === _this.state.text) return;

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          maxLength = _this$props.maxLength;

      var valid = _this.validate(text, maxLength);
      _this.setState({ text: text, valid: valid });
      onChange(text, valid);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputWithLimit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }, {
    key: 'getStateFromProps',
    value: function getStateFromProps(props) {
      return {
        text: props.text,
        valid: this.validate(props.text, props.maxLength)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          text = _state.text,
          valid = _state.valid;

      var _props = this.props,
          title = _props.title,
          placeholder = _props.placeholder,
          maxLength = _props.maxLength,
          invalidLabel = _props.invalidLabel,
          className = _props.className,
          onChange = _props.onChange,
          rest = _objectWithoutProperties(_props, ['title', 'placeholder', 'maxLength', 'invalidLabel', 'className', 'onChange']);

      var length = text ? maxLength - text.length : maxLength;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.InputWithLimit, className) },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'div',
          { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.InputWithLimit__Label },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            null,
            title
          ),
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
            'span',
            null,
            length
          )
        ),
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, _extends({
          className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.TextInput,
          isTextAreaAutosize: true,
          placeholder: placeholder,
          valueLink: {
            requestChange: this.handleChange,
            value: text
          },
          isValid: valid,
          invalidLabel: !valid ? invalidLabel : ''
        }, rest))
      );
    }
  }, {
    key: 'validate',
    value: function validate(text, maxLength) {
      if (text) {
        return text.length <= maxLength && text.length > 0;
      }
      return true;
    }
  }]);

  return InputWithLimit;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

InputWithLimit.propTypes = {
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['small', 'medium', 'large']),
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  invalidLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
InputWithLimit.defaultProps = {
  size: "medium"
};


/* harmony default export */ __webpack_exports__["a"] = (InputWithLimit);

/***/ }),

/***/ "hHSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FontFamilies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FONT_FAMILY_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_enum__);



var FontFamilies = new __WEBPACK_IMPORTED_MODULE_1_enum___default.a({
  Arial: "Arial",
  TimesNewRoman: "Times New Roman",
  Helvetica: "Helvetica",
  Georgia: "Georgia",
  Brandon: "Brandon Text",
  Lato: "Lato",
  OpenSans: "Open Sans",
  Roboto: "Roboto",
  RobotoSlab: "Roboto Slab",
  Overpass: "Overpass"
});

var FONT_FAMILY_OPTIONS = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(FontFamilies.enums, function (font) {
  return {
    label: font.value,
    value: font.key
  };
});

/* unused harmony default export */ var _unused_webpack_default_export = (FontFamilies);

/***/ }),

/***/ "hJjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return uploadCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return uploadCsvPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return uploadCsvFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return uploadCsvCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return uploadCsvSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startCsvImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startCsvImportPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startCsvImportFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return startCsvImportSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearCsv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("20V9");



var uploadCsv = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* UPLOAD_CSV */]);
var uploadCsvPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UPLOAD_CSV_PENDING */]);
var uploadCsvFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* UPLOAD_CSV_FAILED */]);
var uploadCsvCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* UPLOAD_CSV_CANCELLED */]);
var uploadCsvSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* UPLOAD_CSV_SUCCESS */]);

var startCsvImport = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* START_CSV_IMPORT */]);
var startCsvImportPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* START_CSV_IMPORT_PENDING */]);
var startCsvImportFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* START_CSV_IMPORT_FAILED */]);
var startCsvImportSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* START_CSV_IMPORT_SUCCESS */]);

var clearCsv = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CLEAR_CSV */]);
var setMapping = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* SET_MAPPING */]);

var setSelected = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* SET_SELECTED */]);
var toggleColumn = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* TOGGLE_COLUMN */]);

/***/ }),

/***/ "hKIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchTargets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchTargetsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchTargetsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchTargetsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateTargetPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateTargetSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateTargetFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createTargetPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createTargetSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createTargetFailed; });
/* unused harmony export setTarget */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("DTGo");



var fetchTargets = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_TARGETS */]);
var fetchTargetsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_TARGETS_PENDING */]);
var fetchTargetsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_TARGETS_SUCCESS */]);
var fetchTargetsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_TARGETS_FAILED */]);

var updateTarget = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* UPDATE_TARGET */]);
var updateTargetPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* UPDATE_TARGET_PENDING */]);
var updateTargetSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* UPDATE_TARGET_SUCCESS */]);
var updateTargetFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* UPDATE_TARGET_FAILED */]);

var createTarget = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CREATE_TARGET */]);
var createTargetPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_TARGET_PENDING */]);
var createTargetSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_TARGET_SUCCESS */]);
var createTargetFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CREATE_TARGET_FAILED */]);

var setTarget = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* SET_TARGET */]);

// handlePatchTarget
// handleTargetCreation
// setTarget

/***/ }),

/***/ "hOuJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("3n1Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("pB3H");






function fetchAttachments(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* fetchAttachments */].toString()).pluck('payload').mergeMap(function (ids) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetch(ids).map(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* receiveAttachments */]).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* fetchAttachmentsFailed */]({ ids: ids, err: err }));
    });
  });
}

function uploadAttachment(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* uploadAttachment */].toString()).pluck('payload').mergeMap(function (_ref) {
    var conversationId = _ref.conversationId,
        file = _ref.file,
        ticketId = _ref.ticketId;

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].upload(conversationId, file).map(function (attachment) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* uploadAttachmentSuccess */]({ attachment: attachment, ticketId: ticketId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* uploadAttachmentPending */]({ ticketId: ticketId })).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* uploadAttachmentFailed */]({ ticketId: ticketId }));
    });
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchAttachments, uploadAttachment);

/***/ }),

/***/ "hPkC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/marketo-video.b479317e.png";

/***/ }),

/***/ "hSe9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hTEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "root", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUser", function() { return currentUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCurrentUserAdmin", function() { return isCurrentUserAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enrichment", function() { return enrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserStatus", function() { return currentUserStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gates", function() { return gates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convoLimitForUser", function() { return convoLimitForUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convoLimitForUserLoading", function() { return convoLimitForUserLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convoLimitForUserNeverLoaded", function() { return convoLimitForUserNeverLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convoLimitForUserSavedSuccess", function() { return convoLimitForUserSavedSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGoogleScopesStatus", function() { return currentGoogleScopesStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGoogleScopesPending", function() { return isGoogleScopesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGoogleScopes", function() { return getGoogleScopes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGmailConnected", function() { return isGmailConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmailSignature", function() { return getEmailSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgSignatureStatus", function() { return orgSignatureStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgSignatureFetchPending", function() { return orgSignatureFetchPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgSignatureFetchFailed", function() { return orgSignatureFetchFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgSignatureContent", function() { return orgSignatureContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgMultiSignatureStatus", function() { return orgMultiSignatureStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgMultiSignatureFetchPending", function() { return orgMultiSignatureFetchPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgMultiSignatureFetchFailed", function() { return orgMultiSignatureFetchFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgMultiSignatureData", function() { return orgMultiSignatureData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserLoading", function() { return currentUserLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserLoaded", function() { return currentUserLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentUserFailed", function() { return fetchCurrentUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unfilteredOrgUsersById", function() { return unfilteredOrgUsersById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserName", function() { return currentUserName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserEmail", function() { return currentUserEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserId", function() { return currentUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserFirstName", function() { return currentUserFirstName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentUserLastName", function() { return currentUserLastName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unfilteredOrgUsersByIdJS", function() { return unfilteredOrgUsersByIdJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgUsersById", function() { return orgUsersById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nonBotUsers", function() { return nonBotUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "botUser", function() { return botUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "availableUsers", function() { return availableUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "awayUsers", function() { return awayUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeUserSelector", function() { return makeUserSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isUpdatingUser", function() { return isUpdatingUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastUpdatedUser", function() { return lastUpdatedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgUsersStatus", function() { return orgUsersStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgUsersLoading", function() { return orgUsersLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgUsersLoaded", function() { return orgUsersLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentOrgUsers", function() { return currentOrgUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNonBotOrgUsers", function() { return currentNonBotOrgUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentOrgUsersAlphabetical", function() { return currentOrgUsersAlphabetical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomAndOrgUsersAlphabetical", function() { return randomAndOrgUsersAlphabetical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nonBotOrgUsersAlphabetical", function() { return nonBotOrgUsersAlphabetical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberOfOrgUsers", function() { return numberOfOrgUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settingsAppConfig", function() { return settingsAppConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trafficControlConfig", function() { return trafficControlConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("aJZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("TL61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_utils__ = __webpack_require__("PIqi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_app_config__ = __webpack_require__("gRUG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_app_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_app_config__);











var root = function root(state) {
  return state.get('currentUser');
};

var orgUsers = function orgUsers(state) {
  return root(state).get('orgUsers', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var currentUser = function currentUser(state) {
  return root(state).get('user');
};
var currentUserJS = function currentUserJS(state) {
  return !!currentUser(state) ? currentUser(state).toJS() : {};
};

var isCurrentUserAdmin = function isCurrentUserAdmin(state) {
  return root(state).get('user').scopes.includes('org_admin');
};
var enrichment = function enrichment(state) {
  return root(state).get('enrichment');
};
var currentUserStatus = function currentUserStatus(state) {
  return root(state).getIn(['status', 'currentUser']);
};
var gates = function gates(state) {
  return root(state).getIn(['user', 'gates']);
};

var userConvoLimits = function userConvoLimits(state) {
  return root(state).get('userConvoLimits', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var convoLimitForUser = function convoLimitForUser(state, userId) {
  return userConvoLimits(state).getIn([userId, 'data'], {}).convoLimit;
};
var convoLimitForUserLoading = function convoLimitForUserLoading(state, userId) {
  return userConvoLimits(state).getIn([userId, 'status']) === __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING */];
};
var convoLimitForUserNeverLoaded = function convoLimitForUserNeverLoaded(state, userId) {
  return userConvoLimits(state).getIn([userId, 'status']) === undefined;
};
var convoLimitForUserSavedSuccess = function convoLimitForUserSavedSuccess(state, userId) {
  return userConvoLimits(state).getIn([userId, 'status']) === __WEBPACK_IMPORTED_MODULE_3__constants__["_3" /* UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS */];
};

var currentGoogleScopesStatus = function currentGoogleScopesStatus(state) {
  return root(state).get('googleScopesStatus');
};

var isGoogleScopesPending = function isGoogleScopesPending(state) {
  return currentGoogleScopesStatus(state) === __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* FETCH_GOOGLE_SCOPES_PENDING */];
};

var getGoogleScopes = function getGoogleScopes(state) {
  return root(state).get('googleScopes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
};

var isGmailConnected = function isGmailConnected(state) {
  var googleScopes = getGoogleScopes(state);
  return googleScopes.includes(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_constants__["K" /* GoogleScopes */].READ) && googleScopes.includes(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND);
};

var getEmailSignature = function getEmailSignature(state) {
  return state.getIn(['currentUser', 'emailSignature']);
};

// TODO: deprecated, remove when multi banner signatures is ready
var orgSignature = function orgSignature(state) {
  return state.getIn(['currentUser', 'orgSignature'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var orgSignatureStatus = function orgSignatureStatus(state) {
  return orgSignature(state).get('status');
};
var orgSignatureFetchPending = function orgSignatureFetchPending(state) {
  return [__WEBPACK_IMPORTED_MODULE_3__constants__["D" /* FETCH_ORG_SIGNATURE */], __WEBPACK_IMPORTED_MODULE_3__constants__["G" /* FETCH_ORG_SIGNATURE_PENDING */]].includes(orgSignatureStatus(state));
};
var orgSignatureFetchFailed = function orgSignatureFetchFailed(state) {
  return orgSignatureStatus(state) === __WEBPACK_IMPORTED_MODULE_3__constants__["F" /* FETCH_ORG_SIGNATURE_FAILED */];
};
var orgSignatureContent = function orgSignatureContent(state) {
  return orgSignature(state).getIn(['data', 'emailSignature']);
};

var orgMultiSignature = function orgMultiSignature(state) {
  return state.getIn(['currentUser', 'orgMultiSignature'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var orgMultiSignatureStatus = function orgMultiSignatureStatus(state) {
  return orgMultiSignature(state).get('status');
};
var orgMultiSignatureFetchPending = function orgMultiSignatureFetchPending(state) {
  return [__WEBPACK_IMPORTED_MODULE_3__constants__["y" /* FETCH_ORG_MULTI_SIGNATURE */], __WEBPACK_IMPORTED_MODULE_3__constants__["B" /* FETCH_ORG_MULTI_SIGNATURE_PENDING */]].includes(orgMultiSignatureStatus(state));
};
var orgMultiSignatureFetchFailed = function orgMultiSignatureFetchFailed(state) {
  return orgMultiSignatureStatus(state) === __WEBPACK_IMPORTED_MODULE_3__constants__["A" /* FETCH_ORG_MULTI_SIGNATURE_FAILED */];
};
var orgMultiSignatureData = function orgMultiSignatureData(state) {
  return orgMultiSignature(state).get('data', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var currentUserLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentUserStatus, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["k" /* FETCH_CURRENT_USER_STARTED */];
});

var currentUserLoaded = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentUserStatus, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["N" /* RECEIVE_CURRENT_USER */];
});

var fetchCurrentUserFailed = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentUserStatus, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["K" /* PATCH_CURRENT_USER_FAILED */];
});

var unfilteredOrgUsersById = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsers, function (orgUsers) {
  return orgUsers.map(function (user) {
    return user.set('name', user.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* UserStatus */].ARCHIVED ? Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_utils__["a" /* getUserDisplayName */])(user) + ' [deleted]' : user.name);
  });
});

var currentUserName = function currentUserName(state) {
  return state.getIn(['currentUser', 'user', 'name']);
};
var currentUserEmail = function currentUserEmail(state) {
  return state.getIn(['currentUser', 'user', 'email']);
};
var currentUserId = function currentUserId(state) {
  return state.getIn(['currentUser', 'user', 'id']);
};
var currentUserFirstName = function currentUserFirstName(state) {
  return currentUserName(state) && currentUserName(state).split(" ")[0];
};
var currentUserLastName = function currentUserLastName(state) {
  return currentUserName(state) && Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["last"])(currentUserName(state).split(" "));
};

var unfilteredOrgUsersByIdJS = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(unfilteredOrgUsersById, function (unfilteredOrgUsersById) {
  return unfilteredOrgUsersById.toJS();
});

var orgUsersById = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(unfilteredOrgUsersById, function (unfilteredOrgUsersById) {
  return unfilteredOrgUsersById.filter(function (user) {
    return user.status !== __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* UserStatus */].ARCHIVED;
  });
});

var nonBotUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsersById, function (orgUsersById) {
  return orgUsersById.filter(function (user) {
    return !user.bot;
  });
});

var botUser = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsersById, function (orgUsersById) {
  return orgUsersById.find(function (user) {
    return user.bot;
  });
});

var availableUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(nonBotUsers, function (nonBotUsers) {
  return nonBotUsers.filter(function (user) {
    return user.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* UserStatus */].ENABLED;
  }).filter(function (user) {
    return user.availability !== __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AvailabilityStatus */].AWAY;
  });
});

var awayUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(nonBotUsers, function (nonBotUsers) {
  return nonBotUsers.filter(function (user) {
    return user.status === __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* UserStatus */].ENABLED;
  }).filter(function (user) {
    return user.availability === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* AvailabilityStatus */].AWAY;
  });
});

var makeUserSelector = function makeUserSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([unfilteredOrgUsersById, function (state, props) {
    return props.id;
  }], function (unfilteredOrgUsersById, id) {
    var emptyUser = Object(__WEBPACK_IMPORTED_MODULE_4__models__["d" /* User */])({
      id: id,
      name: '[Deleted Team Member]',
      status: __WEBPACK_IMPORTED_MODULE_3__constants__["_9" /* UserStatus */].ARCHIVED
    });

    return unfilteredOrgUsersById.get(id, emptyUser);
  });
};

var isUpdatingUser = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'updateUser']) === 'pending';
});
var lastUpdatedUser = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['lastUpdatedUser']);
});

var orgUsersStatus = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['status', 'orgUsers']);
});

var orgUsersLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsersStatus, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["J" /* FETCH_ORG_USERS_STARTED */];
});

var orgUsersLoaded = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsersStatus, function (status) {
  return status === __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* RECEIVE_ORG_USERS */];
});

var currentOrgUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(orgUsersById, function (orgUsersById) {
  return orgUsersById.valueSeq();
});
var currentNonBotOrgUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(nonBotUsers, function (orgUsersById) {
  return orgUsersById.valueSeq();
});
var currentOrgUsersAlphabetical = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentOrgUsers, function (orgUsers) {
  return orgUsers.sortBy(function (user) {
    return (Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_utils__["a" /* getUserDisplayName */])(user) || '').toLowerCase();
  });
});
var randomAndOrgUsersAlphabetical = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentOrgUsers, function (users) {
  return __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(Object(__WEBPACK_IMPORTED_MODULE_4__models__["d" /* User */])(__WEBPACK_IMPORTED_MODULE_3__constants__["M" /* RANDOM_USER */])).concat(users.sortBy(function (user) {
    return (Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_utils__["a" /* getUserDisplayName */])(user) || '').toLowerCase();
  }));
});
var nonBotOrgUsersAlphabetical = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentNonBotOrgUsers, function (orgUsers) {
  return orgUsers.sortBy(function (user) {
    return (Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_user_utils__["a" /* getUserDisplayName */])(user) || '').toLowerCase();
  });
});

var numberOfOrgUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentOrgUsers, function (users) {
  return users.filter(function (user) {
    return !user.bot;
  }).count();
});

var settingsAppConfig = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentUserJS, function (currentUserJS) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__driftt_app_config__["generateSettingsWebAppConfig"])(currentUserJS);
});

var trafficControlConfig = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentUserJS, function (currentUserJS) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__driftt_app_config__["generateTrafficControlNavConfig"])(currentUserJS);
});

/***/ }),

/***/ "hWD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RECEIVE_END_USER_COMPANY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ENRICHED_COMPANY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_ENRICHED_COMPANY_DATA_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_ENRICHED_COMPANY_DATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_ENRICHED_COMPANY_DATA_NO_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ENRICHED_COMPANY_DATA_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ENRICHED_COMPANY_DATA_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_DECODED_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_DECODED_CONDITION_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_DECODED_CONDITION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_DECODED_CONDITION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_DECODED_CONDITION_CANCELLED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('enrichment/demandbase');

var RECEIVE_END_USER_COMPANY_DATA = makeConstant('RECEIVE_END_USER_COMPANY_DATA');

var FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS = makeConstant('FETCH_BULK_CONVERSATION_ENRICHMENT_DATA_SUCCESS');

var FETCH_ENRICHED_COMPANY_DATA = makeConstant('FETCH_ENRICHEDCOMPANY_DATA');
var FETCH_ENRICHED_COMPANY_DATA_PENDING = makeConstant('FETCH_ENRICHED_COMPANY_DATA_PENDING');
var FETCH_ENRICHED_COMPANY_DATA_SUCCESS = makeConstant('FETCH_ENRICHED_COMPANY_DATA_SUCCESS');
var FETCH_ENRICHED_COMPANY_DATA_NO_RESULT = makeConstant('FETCH_ENRICHED_COMPANY_DATA_NO_RESULT');
var FETCH_ENRICHED_COMPANY_DATA_FAILED = makeConstant('FETCH_ENRICHED_COMPANY_DATA_FAILED');
var FETCH_ENRICHED_COMPANY_DATA_CANCELLED = makeConstant('FETCH_ENRICHED_COMPANY_DATA_CANCELLED');

var FETCH_DECODED_CONDITION = makeConstant('FETCH_DECODED_CONDITION');
var FETCH_DECODED_CONDITION_PENDING = makeConstant('FETCH_DECODED_CONDITION_PENDING');
var FETCH_DECODED_CONDITION_FAILED = makeConstant('FETCH_DECODED_CONDITION_FAILED');
var FETCH_DECODED_CONDITION_SUCCESS = makeConstant('FETCH_DECODED_CONDITION_SUCCESS');
var FETCH_DECODED_CONDITION_CANCELLED = makeConstant('FETCH_DECODED_CONDITION_CANCELLED');

/***/ }),

/***/ "hYTA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---2JShL","TypeIcon":"TypeIcon---37ax-"};

/***/ }),

/***/ "ha7b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hgXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_playbooks_card_arrow_right_svg__ = __webpack_require__("pGxX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_playbooks_card_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_playbooks_card_arrow_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_onboarding_close_svg__ = __webpack_require__("fIl0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_onboarding_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_onboarding_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_pencil_svg__ = __webpack_require__("3iTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("olQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);








var Action = function Action(_ref) {
  var label = _ref.label,
      children = _ref.children,
      onEditClick = _ref.onEditClick,
      onDeleteClick = _ref.onDeleteClick;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Action, 'flex') },
    React.createElement(
      'div',
      { className: 'action-icon' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_images_svg_playbooks_card_arrow_right_svg___default.a })
    ),
    React.createElement(
      'div',
      { className: 'action-content' },
      React.createElement(
        'div',
        null,
        label && React.createElement(
          'div',
          { className: 'action-label' },
          label
        ),
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()({ 'no-edit': !onEditClick }) },
          children
        )
      ),
      React.createElement(
        'div',
        { className: 'action-icons' },
        !!onEditClick && React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
          className: 'action-tool-icon action-edit-icon',
          src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_svg_pencil_svg___default.a,
          onClick: onEditClick
        }),
        !!onDeleteClick && React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
          className: 'action-tool-icon action-delete-icon',
          src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_onboarding_close_svg___default.a,
          onClick: onDeleteClick
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Action);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "hiGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sections_Profile__ = __webpack_require__("hkon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl__ = __webpack_require__("e0zj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UserProfile = function (_Component) {
  _inherits(UserProfile, _Component);

  function UserProfile() {
    _classCallCheck(this, UserProfile);

    return _possibleConstructorReturn(this, (UserProfile.__proto__ || Object.getPrototypeOf(UserProfile)).apply(this, arguments));
  }

  _createClass(UserProfile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          rest = _objectWithoutProperties(_props, ['user']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_styl___default.a.UserProfile },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Sections_Profile__["a" /* default */], _extends({ user: user }, rest))
      );
    }
  }]);

  return UserProfile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var UserProfileContainer = Object(__WEBPACK_IMPORTED_MODULE_4_components_container__["a" /* makeDefaultFailedContainer */])(UserProfile, {
  listenTo: ['stores.UserStore', 'stores.UserPropertiesStore'],
  fetch: {
    user: function user() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    userProperties: function userProperties() {
      return this.app.stores.UserPropertiesStore.fetchPropertiesForCurrentUser();
    }
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    profile: __WEBPACK_IMPORTED_MODULE_2_app_modules_profile_selectors__["profile"](state),
    isProfileLoaded: __WEBPACK_IMPORTED_MODULE_2_app_modules_profile_selectors__["isLoaded"](state)
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, null)(UserProfileContainer));

/***/ }),

/***/ "hjbO":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2.987h-2.236L5.31 22.903H7c.552 0 1 .445 1 .996 0 .548-.448.994-1 .994H1c-.552 0-1-.446-1-.995 0-.552.448-.997 1-.997h2.236L8.69 2.987H7c-.552 0-1-.446-1-.996s.448-.995 1-.995h6c.552 0 1 .446 1 .996s-.448.997-1 .997z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "hjek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);



var api = {
  fetch: function fetch() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].get('/overview').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  }
};

/***/ }),

/***/ "hk2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"followButton":"followButton---3h4Zd"};

/***/ }),

/***/ "hkeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return fetchPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return fetchPlaybookPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return fetchPlaybookCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return fetchPlaybookFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return getPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return getPlaybookPending; });
/* unused harmony export getPlaybookCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return getPlaybookFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return getPlaybookSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return fetchPlaybookCounts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return fetchPlaybookCountsPending; });
/* unused harmony export fetchPlaybookCountsCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return fetchPlaybookCountsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return fetchPlaybookCountsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return fetchPlaybookCardinality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return fetchPlaybookCardinalityPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return fetchPlaybookCardinalitySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return fetchPlaybookCardinalityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return fetchPlaybookCardinalityCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return fetchPlaybookByCampaignId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return fetchPlaybookByCampaignIdPending; });
/* unused harmony export fetchPlaybookByCampaignIdCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return fetchPlaybookByCampaignIdFailed; });
/* unused harmony export fetchPlaybookByCampaignIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getPlaybookByCampaignId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return getPlaybookByCampaignIdPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return getPlaybookByCampaignIdCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return getPlaybookByCampaignIdFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return getPlaybookByCampaignIdSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return fetchPlaybookByInteractionId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return fetchPlaybookByInteractionIdPending; });
/* unused harmony export fetchPlaybookByInteractionIdCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return fetchPlaybookByInteractionIdFailed; });
/* unused harmony export fetchPlaybookByInteractionIdSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return createPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return createPlaybookPending; });
/* unused harmony export createPlaybookCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return createPlaybookFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return clonePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return clonePlaybookPending; });
/* unused harmony export clonePlaybookCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return clonePlaybookFailed; });
/* unused harmony export clonePlaybookSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return sendTestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return sendTestEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return sendTestEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return sendTestEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return sendTestSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return sendTestSequencePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return sendTestSequenceFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return sendTestSequenceCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return sendTestSequenceSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return searchEnabledPlaybooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return searchPlaybooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return searchPlaybooksPending; });
/* unused harmony export searchPlaybooksCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return searchPlaybooksFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return searchPlaybooksSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return savePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return savePlaybookPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return savePlaybookCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return savePlaybookSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return savePlaybookFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return setStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return savePlaybookDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return savePlaybookDraftPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return savePlaybookDraftCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return savePlaybookDraftFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return schedulePlaybookDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return receivePlaybookDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptPlaybookDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return clearDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return enablePlaybookAutosave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return disablePlaybookAutosave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return markDraftUnsaved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return setDraftStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return setDraftStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return setDraftStatusCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return setDraftStatusSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return setDraftStatusFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return setName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return setSlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return setSequenceDynamicAccountSendAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return setSequenceDynamicSenderFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return setSequenceEmailOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return setSequenceSenderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return setSequenceIndividualEmailOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return setSequenceIndividualSenderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return setSequenceIndividualDynamicAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return setSequenceIndividualDynamicFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return setDynamicAccountSendAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return setDynamicSenderFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return setEmailOverride; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return setSenderName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return setMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return setVideoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return setHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return setThankYouMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return setThankYouHeadline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return setCtaType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return setCtaLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return setCtaCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return setSequenceAuthorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return setAuthorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return setEmailTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return setEmailTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return setEmailMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return setEmailDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deleteEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return moveEmailUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return setWeekdaysOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return setSmartSending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return setUnenrollOnReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return setUnenrollOnReplyByDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return setThreadedWithPrevious; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return setGreeting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return setQuestionPrompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return setSkipTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return setGoalClassification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return setGoalMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return setKeywordText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return setKeywordType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return setAnswerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return setButtonText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return setResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return setDefaultPhoneCountryCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return setFieldAttributeName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return setButtonOnlyResponses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addGoal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addEmailCaptureQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addPhoneCaptureQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return deleteQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return deleteAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return deleteGoal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deleteKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return flagAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return moveQuestionUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return saveGoalAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return saveGoalRoutingOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return setActionInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return setCurrentGoalId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return selectGoalRoutingOptionUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return setGoalRoutingView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return selectGoalAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return removeGoalAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return showSendEmailConfirmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return hideSendEmailConfirmModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return showEditSenderModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return hideEditSenderModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return showCalendarLinkModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return hideCalendarLinkModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return showTokenModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return hideTokenModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return showCtaButtonModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return hideCtaButtonModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return showExtensionInviteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return hideExtensionInviteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return showGoalActionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return hideGoalActionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return showGoalRoutingModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return hideGoalRoutingModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return showAnswerModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return hideAnswerModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return showQuestionAdvancedModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return hideQuestionAdvancedModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return showConditionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return hideConditionModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return showScheduleModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return hideScheduleModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return showSequenceInviteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return hideSequenceInviteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return showGoogleAuthModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return hideGoogleAuthModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return setMarketingEmailLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return showDisableSalesSequenceModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return hideDisableSalesSequenceModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return resetDisplayConditions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return setEmailPlaybookConditionValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return setConditionValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return setConditionField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return setConditionOperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deleteCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return deleteConditionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addConditionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return setAudience; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return setDraftSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return setExcludedUserListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return setUserListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return setExcludedAccountListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return setAccountListIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return setSmartFilterEngagedContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return setSmartFilterChatEngagedContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return setSmartFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return fetchPlaybooksPriority; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return fetchPlaybooksPriorityPending; });
/* unused harmony export fetchPlaybooksPriorityCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return fetchPlaybooksPriorityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return fetchPlaybooksPrioritySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return setMetaAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return hideSegmentSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return showSegmentSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return setDraftFrequency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return disablePlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return allChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return fetchDataPreviewEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return fetchDataPreviewEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return fetchDataPreviewEmailCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return fetchDataPreviewEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return fetchDataPreviewEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return fetchDataPreviewSequenceEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return fetchDataPreviewSequenceEmailPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return fetchDataPreviewSequenceEmailCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return fetchDataPreviewSequenceEmailFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return fetchDataPreviewSequenceEmailSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return enroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return enrollPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return enrollFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return enrollSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return unenroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return unenrollPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return unenrollFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return unenrollSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return notify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return notifyPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return notifyFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return notifySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return fetchPlaybooksByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return fetchPlaybooksByIdsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return fetchPlaybooksByIdsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return fetchPlaybooksByIdsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return fetchEnrolledPlaybookId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return fetchEnrolledPlaybookIdSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return fetchEnrolledPlaybookIdPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return fetchEnrolledPlaybookIdFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return fetchEnrolledSequenceCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return fetchEnrolledSequenceCountSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return fetchEnrolledSequenceCountPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return fetchEnrolledSequenceCountFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return fetchPlaybookForEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return fetchPlaybookForEndUserSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return fetchPlaybookForEndUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return fetchPlaybookForEndUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return setPlaybookForEndUserSubject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return setPlaybookForEndUserMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return setPlaybookForEndUserDelay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return clearEnrollModalState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return clearEmailBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return setEmailBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return setEmailBannerSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return setEmailBannerFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return setEmailBannerPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return fetchPlaybooksByGatedPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return fetchPlaybooksByGatedPlanPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return fetchPlaybooksByGatedPlanFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return fetchPlaybooksByGatedPlanCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return fetchPlaybooksByGatedPlanSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return setEndUserEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return asyncButtonPress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return asyncButtonPressPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return asyncButtonPressFailed; });
/* unused harmony export asyncButtonPressCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return asyncButtonPressSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return setEditSenderLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return setSignatureBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return setSignatureIncludeAvatar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return setSignatureIncludeSocial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return setSignatureIncludeBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return setSignatureBannerLinkURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return setViewingSignatureId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addNewSignatureToPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return removeSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addEmptyBannerSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return removeEmptyBannerSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return clearSignatureBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return setSignatureBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return setSignatureBannerPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return setSignatureBannerFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return setSignatureBannerCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return setSignatureBannerSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return fetchSignatureMultiBannerPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return fetchSignatureMultiBannerPreviewPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return fetchSignatureMultiBannerPreviewFailed; });
/* unused harmony export fetchSignatureMultiBannerPreviewCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return fetchSignatureMultiBannerPreviewSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return createInitialWelcomePlaybooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return createInitialWelcomePlaybooksPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return createInitialWelcomePlaybooksFailed; });
/* unused harmony export createInitialWelcomePlaybooksCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return createInitialWelcomePlaybooksSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return fetchPlaybookForCampaignId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return fetchPlaybookForCampaignIdPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return fetchPlaybookForCampaignIdFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return fetchPlaybookForCampaignIdCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return fetchPlaybookForCampaignIdSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return fetchPlaybooksByReportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return fetchPlaybooksByReportTypePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return fetchPlaybooksByReportTypeFailed; });
/* unused harmony export fetchPlaybooksByReportTypeCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return fetchPlaybooksByReportTypeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return enableAllPlaybooksByReportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return enableAllPlaybooksByReportTypePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return enableAllPlaybooksByReportTypeFailed; });
/* unused harmony export enableAllPlaybooksByReportTypeCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return enableAllPlaybooksByReportTypeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return fetchChatActivePlaybooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return startReportTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return incrementReportTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return decrementReportTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return recordedReportTimer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("st9j");



var fetchPlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_40" /* FETCH_PLAYBOOK */]);
var fetchPlaybookPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_91" /* FETCH_PLAYBOOK_PENDING */]);
var fetchPlaybookCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_70" /* FETCH_PLAYBOOK_CANCELLED */]);
var fetchPlaybookFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_81" /* FETCH_PLAYBOOK_FAILED */]);

var getPlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_98" /* GET_PLAYBOOK */]);
var getPlaybookPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_106" /* GET_PLAYBOOK_PENDING */]);
var getPlaybookCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_104" /* GET_PLAYBOOK_CANCELLED */]);
var getPlaybookFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_105" /* GET_PLAYBOOK_FAILED */]);
var getPlaybookSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_107" /* GET_PLAYBOOK_SUCCESS */]);

var fetchPlaybookCounts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_76" /* FETCH_PLAYBOOK_COUNTS */]);
var fetchPlaybookCountsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_79" /* FETCH_PLAYBOOK_COUNTS_PENDING */]);
var fetchPlaybookCountsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_77" /* FETCH_PLAYBOOK_COUNTS_CANCELLED */]);
var fetchPlaybookCountsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_80" /* FETCH_PLAYBOOK_COUNTS_SUCCESS */]);
var fetchPlaybookCountsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_78" /* FETCH_PLAYBOOK_COUNTS_FAILED */]);

var fetchPlaybookCardinality = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_71" /* FETCH_PLAYBOOK_CARDINALITY */]);
var fetchPlaybookCardinalityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_74" /* FETCH_PLAYBOOK_CARDINALITY_PENDING */]);
var fetchPlaybookCardinalitySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_75" /* FETCH_PLAYBOOK_CARDINALITY_SUCCESS */]);
var fetchPlaybookCardinalityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_73" /* FETCH_PLAYBOOK_CARDINALITY_FAILED */]);
var fetchPlaybookCardinalityCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_72" /* FETCH_PLAYBOOK_CARDINALITY_CANCELLED */]);

var fetchPlaybookByCampaignId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_60" /* FETCH_PLAYBOOK_BY_CAMPAIGN_ID */]);
var fetchPlaybookByCampaignIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_63" /* FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING */]);
var fetchPlaybookByCampaignIdCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_61" /* FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED */]);
var fetchPlaybookByCampaignIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_62" /* FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED */]);
var fetchPlaybookByCampaignIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_64" /* FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS */]);

var getPlaybookByCampaignId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_99" /* GET_PLAYBOOK_BY_CAMPAIGN_ID */]);
var getPlaybookByCampaignIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_102" /* GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING */]);
var getPlaybookByCampaignIdCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_100" /* GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED */]);
var getPlaybookByCampaignIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_101" /* GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED */]);
var getPlaybookByCampaignIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_103" /* GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS */]);

var fetchPlaybookByInteractionId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_65" /* FETCH_PLAYBOOK_BY_INTERACTION_ID */]);
var fetchPlaybookByInteractionIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_68" /* FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING */]);
var fetchPlaybookByInteractionIdCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_66" /* FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED */]);
var fetchPlaybookByInteractionIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_67" /* FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED */]);
var fetchPlaybookByInteractionIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_69" /* FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS */]);

var createPlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* CREATE_PLAYBOOK */]);
var createPlaybookPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* CREATE_PLAYBOOK_PENDING */]);
var createPlaybookCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* CREATE_PLAYBOOK_CANCELLED */]);
var createPlaybookFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* CREATE_PLAYBOOK_FAILED */]);

var clonePlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* CLONE_PLAYBOOK */]);
var clonePlaybookPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* CLONE_PLAYBOOK_PENDING */]);
var clonePlaybookCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* CLONE_PLAYBOOK_CANCELLED */]);
var clonePlaybookFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* CLONE_PLAYBOOK_FAILED */]);
var clonePlaybookSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* CLONE_PLAYBOOK_SUCCESS */]);

var sendTestEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_169" /* SEND_TEST_EMAIL */]);
var sendTestEmailPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_171" /* SEND_TEST_EMAIL_PENDING */]);
var sendTestEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_172" /* SEND_TEST_EMAIL_SUCCESS */]);
var sendTestEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_170" /* SEND_TEST_EMAIL_FAILED */]);

var sendTestSequence = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_173" /* SEND_TEST_SEQUENCE */]);
var sendTestSequencePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_176" /* SEND_TEST_SEQUENCE_PENDING */]);
var sendTestSequenceFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_175" /* SEND_TEST_SEQUENCE_FAILED */]);
var sendTestSequenceCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_174" /* SEND_TEST_SEQUENCE_CANCELLED */]);
var sendTestSequenceSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_177" /* SEND_TEST_SEQUENCE_SUCCESS */]);

var searchEnabledPlaybooks = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_162" /* SEARCH_ENABLED_PLAYBOOKS */]);
var searchPlaybooks = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_163" /* SEARCH_PLAYBOOKS */]);
var searchPlaybooksPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_166" /* SEARCH_PLAYBOOKS_PENDING */]);
var searchPlaybooksCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_164" /* SEARCH_PLAYBOOKS_CANCELLED */]);
var searchPlaybooksFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_165" /* SEARCH_PLAYBOOKS_FAILED */]);
var searchPlaybooksSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_167" /* SEARCH_PLAYBOOKS_SUCCESS */]);

var savePlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_153" /* SAVE_PLAYBOOK */]);
var savePlaybookPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_159" /* SAVE_PLAYBOOK_PENDING */]);
var savePlaybookCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_154" /* SAVE_PLAYBOOK_CANCELLED */]);
var savePlaybookSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_160" /* SAVE_PLAYBOOK_SUCCESS */]);
var savePlaybookFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_157" /* SAVE_PLAYBOOK_DRAFT_FAILED */]);

var setStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_260" /* SET_STATUS */]);

var savePlaybookDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_155" /* SAVE_PLAYBOOK_DRAFT */]);
var savePlaybookDraftPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_158" /* SAVE_PLAYBOOK_DRAFT_PENDING */]);
var savePlaybookDraftCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_156" /* SAVE_PLAYBOOK_DRAFT_CANCELLED */]);
var savePlaybookDraftFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_157" /* SAVE_PLAYBOOK_DRAFT_FAILED */]);

var schedulePlaybookDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_161" /* SCHEDULE_PLAYBOOK_DRAFT */]);

var receivePlaybookDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_144" /* RECEIVE_PLAYBOOK_DRAFT */]);
var acceptPlaybookDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ACCEPT_PLAYBOOK_DRAFT */]);
var clearDraft = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* CLEAR_DRAFT */]);

var enablePlaybookAutosave = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* ENABLE_PLAYBOOK_AUTOSAVE */]);
var disablePlaybookAutosave = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* DISABLE_PLAYBOOK_AUTOSAVE */]);
var markDraftUnsaved = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_126" /* MARK_DRAFT_UNSAVED */]);

var setDraftStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_195" /* SET_DRAFT_STATUS */]);
var setDraftStatusPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_198" /* SET_DRAFT_STATUS_PENDING */]);
var setDraftStatusCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_196" /* SET_DRAFT_STATUS_CANCELLED */]);
var setDraftStatusSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_199" /* SET_DRAFT_STATUS_SUCCESS */]);
var setDraftStatusFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_197" /* SET_DRAFT_STATUS_DRAFT_FAILED */]);

var setName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_228" /* SET_NAME */]);
var setSlug = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_255" /* SET_SLUG */]);

var setSequenceDynamicAccountSendAttribute = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_236" /* SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE */]);
var setSequenceDynamicSenderFormat = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_237" /* SET_SEQUENCE_DYNAMIC_SENDER_FORMAT */]);
var setSequenceEmailOverride = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_238" /* SET_SEQUENCE_EMAIL_OVERRIDE */]);
var setSequenceSenderName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_243" /* SET_SEQUENCE_SENDER_NAME */]);
var setSequenceIndividualEmailOverride = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_241" /* SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE */]);
var setSequenceIndividualSenderName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_242" /* SET_SEQUENCE_INDIVIDUAL_SENDER_NAME */]);
var setSequenceIndividualDynamicAttr = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_239" /* SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR */]);
var setSequenceIndividualDynamicFormat = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_240" /* SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT */]);
var setDynamicAccountSendAttribute = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_200" /* SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE */]);
var setDynamicSenderFormat = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_201" /* SET_DYNAMIC_SENDER_FORMAT */]);
var setEmailOverride = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_209" /* SET_EMAIL_OVERRIDE */]);
var setSenderName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_234" /* SET_SENDER_NAME */]);
var setMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_226" /* SET_MESSAGE */]);
var setVideoUrl = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_267" /* SET_VIDEO_URL */]);
var setHeadline = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_222" /* SET_HEADLINE */]);
var setThankYouMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_262" /* SET_THANK_YOU_MESSAGE */]);
var setThankYouHeadline = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_261" /* SET_THANK_YOU_HEADLINE */]);
var setCtaType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_190" /* SET_CTA_TYPE */]);
var setCtaLink = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_189" /* SET_CTA_LINK */]);
var setCtaCopy = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_188" /* SET_CTA_COPY */]);
var setSequenceAuthorId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_235" /* SET_SEQUENCE_AUTHOR_ID */]);
var setAuthorId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_182" /* SET_AUTHOR_ID */]);
var setEmailTheme = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_211" /* SET_EMAIL_THEME */]);

var setEmailTitle = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_212" /* SET_EMAIL_TITLE */]);
var setEmailMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_208" /* SET_EMAIL_MESSAGE */]);
var setEmailDelay = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_207" /* SET_EMAIL_DELAY */]);
var addEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ADD_EMAIL */]);
var deleteEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* DELETE_EMAIL */]);
var moveEmailUp = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_127" /* MOVE_EMAIL_UP */]);
var setWeekdaysOnly = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_269" /* SET_WEEKDAYS_ONLY */]);
var setSmartSending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_259" /* SET_SMART_SENDING */]);
var setUnenrollOnReply = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_264" /* SET_UNENROLL_ON_REPLY */]);
var setUnenrollOnReplyByDomain = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_265" /* SET_UNENROLL_ON_REPLY_BY_DOMAIN */]);
var setThreadedWithPrevious = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_263" /* SET_THREADED_WITH_PREVIOUS */]);

var setGreeting = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_221" /* SET_GREETING */]);
var setQuestionPrompt = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_232" /* SET_QUESTION_PROMPT */]);
var setSkipTo = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_254" /* SET_SKIP_TO */]);
var setGoalClassification = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_217" /* SET_GOAL_CLASSIFICATION */]);
var setGoalMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_218" /* SET_GOAL_MESSAGE */]);
var setKeywordText = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_223" /* SET_KEYWORD_TEXT */]);
var setKeywordType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_224" /* SET_KEYWORD_TYPE */]);
var setAnswerType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_180" /* SET_ANSWER_TYPE */]);
var setButtonText = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_184" /* SET_BUTTON_TEXT */]);
var setResponse = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_233" /* SET_RESPONSE */]);
var setDefaultPhoneCountryCode = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_192" /* SET_DEFAULT_PHONE_COUNTRY_CODE */]);
var setFieldAttributeName = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_216" /* SET_FIELD_ATTRIBUTE_NAME */]);
var setButtonOnlyResponses = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_183" /* SET_BUTTON_ONLY_RESPONSES */]);
var addGoal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* ADD_GOAL */]);
var addQuestion = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* ADD_QUESTION */]);
var addKeyword = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* ADD_KEYWORD */]);
var addAnswer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ADD_ANSWER */]);
var addEmailCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* ADD_EMAIL_CAPTURE_QUESTION */]);
var addPhoneCaptureQuestion = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* ADD_PHONE_CAPTURE_QUESTION */]);
var deleteQuestion = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* DELETE_QUESTION */]);
var deleteAnswer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* DELETE_ANSWER */]);
var deleteGoal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* DELETE_GOAL */]);
var deleteKeyword = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* DELETE_KEYWORD */]);
var flagAnswer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_97" /* FLAG_ANSWER */]);
var moveQuestionUp = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_128" /* MOVE_QUESTION_UP */]);
var saveGoalAction = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_151" /* SAVE_GOAL_ACTION */]);
var saveGoalRoutingOption = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_152" /* SAVE_GOAL_ROUTING_OPTION */]);

var setActionInboxId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_179" /* SET_ACTION_INBOX_ID */]);

var setCurrentGoalId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_191" /* SET_CURRENT_GOAL_ID */]);
var selectGoalRoutingOptionUI = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_219" /* SET_GOAL_ROUTING_OPTION */]);
var setGoalRoutingView = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_220" /* SET_GOAL_ROUTING_VIEW */]);
var selectGoalAction = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_168" /* SELECT_GOAL_ACTION */]);
var removeGoalAction = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_147" /* REMOVE_GOAL_ACTION */]);

var showSendEmailConfirmModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_283" /* SHOW_SEND_EMAIL_CONFIRM_MODAL */]);
var hideSendEmailConfirmModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_121" /* HIDE_SEND_EMAIL_CONFIRM_MODAL */]);
var showEditSenderModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_275" /* SHOW_EDIT_SENDER_MODAL */]);
var hideEditSenderModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_113" /* HIDE_EDIT_SENDER_MODAL */]);
var showCalendarLinkModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_271" /* SHOW_CALENDAR_LINK_MODAL */]);
var hideCalendarLinkModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_109" /* HIDE_CALENDAR_LINK_MODAL */]);
var showTokenModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_285" /* SHOW_TOKEN_MODAL */]);
var hideTokenModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_123" /* HIDE_TOKEN_MODAL */]);
var showCtaButtonModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_273" /* SHOW_CTA_BUTTON_MODAL */]);
var hideCtaButtonModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_111" /* HIDE_CTA_BUTTON_MODAL */]);
var showExtensionInviteModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_276" /* SHOW_EXTENSION_INVITE_MODAL */]);
var hideExtensionInviteModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_114" /* HIDE_EXTENSION_INVITE_MODAL */]);
var showGoalActionModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_277" /* SHOW_GOAL_ACTION_MODAL */]);
var hideGoalActionModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_115" /* HIDE_GOAL_ACTION_MODAL */]);
var showGoalRoutingModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_278" /* SHOW_GOAL_ROUTING_MODAL */]);
var hideGoalRoutingModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_116" /* HIDE_GOAL_ROUTING_MODAL */]);
var showAnswerModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_270" /* SHOW_ANSWER_MODAL */]);
var hideAnswerModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_108" /* HIDE_ANSWER_MODAL */]);
var showQuestionAdvancedModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_280" /* SHOW_QUESTION_ADVANCED_MODAL */]);
var hideQuestionAdvancedModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_118" /* HIDE_QUESTION_ADVANCED_MODAL */]);
var showConditionModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_272" /* SHOW_CONDITION_MODAL */]);
var hideConditionModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_110" /* HIDE_CONDITION_MODAL */]);
var showScheduleModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_281" /* SHOW_SCHEDULE_MODAL */]);
var hideScheduleModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_119" /* HIDE_SCHEDULE_MODAL */]);
var showSequenceInviteModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_284" /* SHOW_SEQUENCE_INVITE_MODAL */]);
var hideSequenceInviteModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_122" /* HIDE_SEQUENCE_INVITE_MODAL */]);
var showGoogleAuthModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_279" /* SHOW_GOOGLE_AUTH_MODAL */]);
var hideGoogleAuthModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_117" /* HIDE_GOOGLE_AUTH_MODAL */]);
var setMarketingEmailLayout = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_225" /* SET_MARKETING_EMAIL_LAYOUT */]);
var showDisableSalesSequenceModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_274" /* SHOW_DISABLE_SALES_SEQUENCE_MODAL */]);
var hideDisableSalesSequenceModal = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_112" /* HIDE_DISABLE_SALES_SEQUENCE_MODAL */]);

var resetDisplayConditions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_149" /* RESET_DISPLAY_CONDITIONS */]);
var setEmailPlaybookConditionValue = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_210" /* SET_EMAIL_PLAYBOOK_CONDITION_VALUE */]);
var setConditionValue = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_187" /* SET_CONDITION_VALUE */]);
var setConditionField = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_185" /* SET_CONDITION_FIELD */]);
var setConditionOperator = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_186" /* SET_CONDITION_OPERATOR */]);
var deleteCondition = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* DELETE_CONDITION */]);
var addCondition = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ADD_CONDITION */]);
var deleteConditionSet = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* DELETE_CONDITION_SET */]);
var addConditionSet = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ADD_CONDITION_SET */]);

var setAudience = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_181" /* SET_AUDIENCE */]);
var setDraftSchedule = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_194" /* SET_DRAFT_SCHEDULE */]);
var setExcludedUserListIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_215" /* SET_EXCLUDED_USER_LIST_IDS */]);
var setUserListIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_266" /* SET_USER_LIST_IDS */]);
var setExcludedAccountListIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_214" /* SET_EXCLUDED_ACCOUNT_LIST_IDS */]);
var setAccountListIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_178" /* SET_ACCOUNT_LIST_IDS */]);
var setSmartFilterEngagedContacts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_258" /* SET_SMART_FILTERS_ENGAGED_CONTACTS */]);
var setSmartFilterChatEngagedContacts = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_257" /* SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS */]);
var setSmartFilters = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_256" /* SET_SMART_FILTERS */]);

var fetchPlaybooksPriority = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_55" /* FETCH_PLAYBOOKS_PRIORITY */]);
var fetchPlaybooksPriorityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_58" /* FETCH_PLAYBOOKS_PRIORITY_PENDING */]);
var fetchPlaybooksPriorityCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_56" /* FETCH_PLAYBOOKS_PRIORITY_CANCELLED */]);
var fetchPlaybooksPriorityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_57" /* FETCH_PLAYBOOKS_PRIORITY_FAILED */]);
var fetchPlaybooksPrioritySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_59" /* FETCH_PLAYBOOKS_PRIORITY_SUCCESS */]);

var setMetaAttribute = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_227" /* SET_META_ATTRIBUTE */]);

var hideSegmentSelect = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_120" /* HIDE_SEGMENT_SELECT */]);
var showSegmentSelect = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_282" /* SHOW_SEGMENT_SELECT */]);

var setDraftFrequency = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_193" /* SET_DRAFT_FREQUENCY */]);
var disablePlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* DISABLE_PLAYBOOK */]);
var allChanges = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* ALL_CHANGES */]);

var fetchDataPreviewEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_22" /* FETCH_DATA_PREVIEW_EMAIL */]);
var fetchDataPreviewEmailPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* FETCH_DATA_PREVIEW_EMAIL_PENDING */]);
var fetchDataPreviewEmailCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_23" /* FETCH_DATA_PREVIEW_EMAIL_CANCELLED */]);
var fetchDataPreviewEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_24" /* FETCH_DATA_PREVIEW_EMAIL_FAILED */]);
var fetchDataPreviewEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_26" /* FETCH_DATA_PREVIEW_EMAIL_SUCCESS */]);

var fetchDataPreviewSequenceEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_27" /* FETCH_DATA_PREVIEW_SEQUENCE_EMAIL */]);
var fetchDataPreviewSequenceEmailPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_30" /* FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING */]);
var fetchDataPreviewSequenceEmailCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_28" /* FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CANCELLED */]);
var fetchDataPreviewSequenceEmailFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_29" /* FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED */]);
var fetchDataPreviewSequenceEmailSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_31" /* FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS */]);

var enroll = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_14" /* ENROLL */]);
var enrollPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_16" /* ENROLL_PENDING */]);
var enrollFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_15" /* ENROLL_FAILED */]);
var enrollSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_17" /* ENROLL_SUCCESS */]);

var unenroll = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_288" /* UNENROLL */]);
var unenrollPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_290" /* UNENROLL_PENDING */]);
var unenrollFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_289" /* UNENROLL_FAILED */]);
var unenrollSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_291" /* UNENROLL_SUCCESS */]);

var notify = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_134" /* NOTIFY */]);
var notifyPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_136" /* NOTIFY_PENDING */]);
var notifyFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_135" /* NOTIFY_FAILED */]);
var notifySuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_137" /* NOTIFY_SUCCESS */]);

var fetchPlaybooksByIds = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_46" /* FETCH_PLAYBOOKS_BY_IDS */]);
var fetchPlaybooksByIdsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_49" /* FETCH_PLAYBOOKS_BY_IDS_SUCCESS */]);
var fetchPlaybooksByIdsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_48" /* FETCH_PLAYBOOKS_BY_IDS_PENDING */]);
var fetchPlaybooksByIdsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_47" /* FETCH_PLAYBOOKS_BY_IDS_FAILED */]);

var fetchEnrolledPlaybookId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_32" /* FETCH_ENROLLED_PLAYBOOK_ID */]);
var fetchEnrolledPlaybookIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_35" /* FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS */]);
var fetchEnrolledPlaybookIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_34" /* FETCH_ENROLLED_PLAYBOOK_ID_PENDING */]);
var fetchEnrolledPlaybookIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_33" /* FETCH_ENROLLED_PLAYBOOK_ID_FAILED */]);

var fetchEnrolledSequenceCount = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_36" /* FETCH_ENROLLED_SEQUENCE_COUNT */]);
var fetchEnrolledSequenceCountSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_39" /* FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS */]);
var fetchEnrolledSequenceCountPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_38" /* FETCH_ENROLLED_SEQUENCE_COUNT_PENDING */]);
var fetchEnrolledSequenceCountFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_37" /* FETCH_ENROLLED_SEQUENCE_COUNT_FAILED */]);

var fetchPlaybookForEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_87" /* FETCH_PLAYBOOK_FOR_END_USER */]);
var fetchPlaybookForEndUserSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_90" /* FETCH_PLAYBOOK_FOR_END_USER_SUCCESS */]);
var fetchPlaybookForEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_89" /* FETCH_PLAYBOOK_FOR_END_USER_PENDING */]);
var fetchPlaybookForEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_88" /* FETCH_PLAYBOOK_FOR_END_USER_FAILED */]);

var setPlaybookForEndUserSubject = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_231" /* SET_PLAYBOOK_FOR_END_USER_SUBJECT */]);
var setPlaybookForEndUserMessage = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_230" /* SET_PLAYBOOK_FOR_END_USER_MESSAGE */]);
var setPlaybookForEndUserDelay = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_229" /* SET_PLAYBOOK_FOR_END_USER_DELAY */]);

var clearEnrollModalState = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* CLEAR_ENROLL_MODAL_STATE */]);

var clearEmailBanner = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* CLEAR_EMAIL_BANNER */]);
var setEmailBanner = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_203" /* SET_EMAIL_BANNER */]);
var setEmailBannerSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_206" /* SET_EMAIL_BANNER_SUCCESS */]);
var setEmailBannerFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_204" /* SET_EMAIL_BANNER_FAILED */]);
var setEmailBannerPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_205" /* SET_EMAIL_BANNER_PENDING */]);

var fetchPlaybooksByGatedPlan = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_41" /* FETCH_PLAYBOOKS_BY_GATED_PLAN */]);
var fetchPlaybooksByGatedPlanPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_44" /* FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING */]);
var fetchPlaybooksByGatedPlanFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_43" /* FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED */]);
var fetchPlaybooksByGatedPlanCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_42" /* FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED */]);
var fetchPlaybooksByGatedPlanSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_45" /* FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS */]);

var setEndUserEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_213" /* SET_END_USER_EMAIL */]);

var asyncButtonPress = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* ASYNC_BUTTON_PRESS */]);
var asyncButtonPressPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* ASYNC_BUTTON_PRESS_PENDING */]);
var asyncButtonPressFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* ASYNC_BUTTON_PRESS_FAILED */]);
var asyncButtonPressCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* ASYNC_BUTTON_PRESS_CANCELLED */]);
var asyncButtonPressSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* ASYNC_BUTTON_PRESS_SUCCESS */]);

var setEditSenderLevel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_202" /* SET_EDIT_SENDER_LEVEL */]);

var setSignatureBody = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_250" /* SET_SIGNATURE_BODY */]);
var setSignatureIncludeAvatar = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_251" /* SET_SIGNATURE_INCLUDE_AVATAR */]);
var setSignatureIncludeSocial = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_253" /* SET_SIGNATURE_INCLUDE_SOCIAL */]);
var setSignatureIncludeBanner = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_252" /* SET_SIGNATURE_INCLUDE_BANNER */]);
var setSignatureBannerLinkURL = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_247" /* SET_SIGNATURE_BANNER_LINK_URL */]);

var setViewingSignatureId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_268" /* SET_VIEWING_SIGNATURE_ID */]);
var addNewSignatureToPlaybook = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* ADD_NEW_SIGNATURE_TO_PLAYBOOK */]);
var removeSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_148" /* REMOVE_SIGNATURE */]);
var addEmptyBannerSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* ADD_EMPTY_BANNER_SIGNATURE */]);
var removeEmptyBannerSignature = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_146" /* REMOVE_EMPTY_BANNER_SIGNATURE */]);

var clearSignatureBanner = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* CLEAR_SIGNATURE_BANNER */]);
var setSignatureBanner = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_244" /* SET_SIGNATURE_BANNER */]);
var setSignatureBannerPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_248" /* SET_SIGNATURE_BANNER_PENDING */]);
var setSignatureBannerFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_246" /* SET_SIGNATURE_BANNER_FAILED */]);
var setSignatureBannerCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_245" /* SET_SIGNATURE_BANNER_CANCELLED */]);
var setSignatureBannerSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_249" /* SET_SIGNATURE_BANNER_SUCCESS */]);

var fetchSignatureMultiBannerPreview = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_92" /* FETCH_SIGNATURE_MULTI_BANNER_PREVIEW */]);
var fetchSignatureMultiBannerPreviewPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_95" /* FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING */]);
var fetchSignatureMultiBannerPreviewFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_94" /* FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED */]);
var fetchSignatureMultiBannerPreviewCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_93" /* FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED */]);
var fetchSignatureMultiBannerPreviewSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_96" /* FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS */]);

var createInitialWelcomePlaybooks = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* CREATE_INITIAL_WELCOME_PLAYBOOKS */]);
var createInitialWelcomePlaybooksPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING */]);
var createInitialWelcomePlaybooksFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED */]);
var createInitialWelcomePlaybooksCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED */]);
var createInitialWelcomePlaybooksSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS */]);

var fetchPlaybookForCampaignId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_82" /* FETCH_PLAYBOOK_FOR_CAMPAIGN_ID */]);
var fetchPlaybookForCampaignIdPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_85" /* FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING */]);
var fetchPlaybookForCampaignIdFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_84" /* FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED */]);
var fetchPlaybookForCampaignIdCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_83" /* FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED */]);
var fetchPlaybookForCampaignIdSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_86" /* FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS */]);

var fetchPlaybooksByReportType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_50" /* FETCH_PLAYBOOKS_BY_REPORT_TYPE */]);
var fetchPlaybooksByReportTypePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_53" /* FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING */]);
var fetchPlaybooksByReportTypeFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_52" /* FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED */]);
var fetchPlaybooksByReportTypeCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_51" /* FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED */]);
var fetchPlaybooksByReportTypeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_54" /* FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS */]);

var enableAllPlaybooksByReportType = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE */]);
var enableAllPlaybooksByReportTypePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING */]);
var enableAllPlaybooksByReportTypeFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED */]);
var enableAllPlaybooksByReportTypeCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED */]);
var enableAllPlaybooksByReportTypeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS */]);

var fetchChatActivePlaybooks = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_21" /* FETCH_CHAT_ACTIVE_PLAYBOOKS */]);

var startReportTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_286" /* START_REPORT_TIMER */]);
var incrementReportTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_124" /* INCREMENT_REPORT_TIMER */]);
var decrementReportTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* DECREMENT_REPORT_TIMER */]);
var recordedReportTimer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_145" /* RECORDED_REPORT_TIMER */]);

/***/ }),

/***/ "hkon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_profile__ = __webpack_require__("YEs/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_I18n__ = __webpack_require__("K6LP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__ = __webpack_require__("vTSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OverviewInfo__ = __webpack_require__("myYH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ContactInfo__ = __webpack_require__("ZSqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MessagingInfo__ = __webpack_require__("AGXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DetailInfo__ = __webpack_require__("SyCm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeInfo__ = __webpack_require__("GPLL");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ProfileSection = function (_Component) {
  _inherits(ProfileSection, _Component);

  function ProfileSection() {
    _classCallCheck(this, ProfileSection);

    return _possibleConstructorReturn(this, (ProfileSection.__proto__ || Object.getPrototypeOf(ProfileSection)).apply(this, arguments));
  }

  _createClass(ProfileSection, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.actions.setProfileUI(this.props.profile);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'my-profile-settings-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_I18n__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__OverviewInfo__["a" /* default */], {
            orgHandle: this.props.orgHandle,
            handle: this.props.handle,
            handleUI: this.props.handleUI,
            globalHandle: this.props.globalHandle,
            globalHandleUI: this.props.globalHandleUI,
            profile: this.props.profile,
            overview: this.props.overview,
            overviewUI: this.props.overviewUI,
            companyUrl: this.props.companyUrl,
            isValidHandle: this.props.isValidHandle,
            isHandleValid: this.props.isHandleValid,
            isGlobalHandleValid: this.props.isGlobalHandleValid,
            globalHandleCheckComplete: this.props.globalHandleCheckComplete,
            profileUpdateStatusSuccess: this.props.profileUpdateStatusSuccess,
            profileUpdateStatusPending: this.props.profileUpdateStatusPending,
            visibility: this.props.visibility,
            actions: this.props.actions
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ThemeInfo__["a" /* default */], {
            theme: this.props.theme,
            themeUI: this.props.themeUI,
            coverPhotoUpload: this.props.coverPhotoUpload,
            user: this.props.user,
            actions: this.props.actions
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ContactInfo__["a" /* default */], {
            social: this.props.social,
            socialUI: this.props.socialUI,
            actions: this.props.actions,
            hasMeetings: this.props.hasMeetings
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MessagingInfo__["a" /* default */], {
            messaging: this.props.messaging,
            messagingUI: this.props.messagingUI,
            actions: this.props.actions
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DetailInfo__["a" /* default */], {
            details: this.props.details,
            detailsUI: this.props.detailsUI,
            actions: this.props.actions
          })
        )
      );
    }
  }]);

  return ProfileSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_profile__["a" /* withProfile */])({
  handle: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["handle"],
  handleUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["e" /* handle */],
  globalHandle: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["globalHandle"],
  globalHandleUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["c" /* globalHandle */],
  profile: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profile"],
  profileUrl: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profileUrl"],
  companyUrl: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["companyUrl"],
  overview: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["overview"],
  overviewUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["j" /* overview */],
  isValidHandle: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["h" /* isValidHandle */],
  isHandleValid: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["g" /* isHandleValid */],
  isGlobalHandleValid: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["f" /* isGlobalHandleValid */],
  globalHandleCheckComplete: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["d" /* globalHandleCheckComplete */],
  profileUpdateStatusSuccess: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profileUpdateStatusSuccess"],
  profileUpdateStatusPending: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profileUpdateStatusPending"],
  social: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["social"],
  socialUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["l" /* social */],
  details: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["details"],
  detailsUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["b" /* details */],
  messaging: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["messaging"],
  messagingUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["i" /* messaging */],
  visibility: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["visibility"],
  theme: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["theme"],
  themeUI: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["m" /* theme */],
  coverPhotoUpload: __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_selectorsUI__["a" /* coverPhotoUpload */],
  hasMeetings: __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__["l" /* hasMeetings */]
}, { blocking: true })(ProfileSection));

/***/ }),

/***/ "hkqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("fi0M");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var UserAvatarOption = function UserAvatarOption(_ref) {
  var user = _ref.user,
      onUserDeleted = _ref.onUserDeleted;

  var nameOrEmail = user ? user.name ? user.name : user.email : 'Unknown User';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'choice-dropdown-option' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Avatar"], { user: user }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'choice-option-value' },
      nameOrEmail
    ),
    onUserDeleted && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'choice-delete-icon', onClick: function onClick() {
          return onUserDeleted(user);
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { name: 'close', height: 10, width: 10 })
    )
  );
};

var GroupParticipantAction = function (_PureComponent) {
  _inherits(GroupParticipantAction, _PureComponent);

  function GroupParticipantAction(props) {
    _classCallCheck(this, GroupParticipantAction);

    var _this = _possibleConstructorReturn(this, (GroupParticipantAction.__proto__ || Object.getPrototypeOf(GroupParticipantAction)).call(this, props));

    _this.renderSelectOption = function (_ref2) {
      var value = _ref2.value;
      var users = _this.props.users;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserAvatarOption, { user: users[value] });
    };

    _this.onParticipantsSelected = function (selectedOption) {
      var setActionParticipants = _this.props.setActionParticipants;


      _this.setState(function (prevState) {
        var selectedOptions = [].concat(_toConsumableArray(prevState.selectedParticipants), [selectedOption[0].value]);
        var availableUsers = prevState.availableUsers.filter(function (user) {
          return user.value !== selectedOption[0].value;
        });

        return {
          selectedParticipants: selectedOptions,
          availableUsers: availableUsers
        };
      }, function () {
        setActionParticipants({
          participants: _this.state.selectedParticipants,
          participantType: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* PARTICIPANT_TYPES */].GROUP
        });
      });
    };

    _this.onGroupUserRemoved = function (user) {
      var setActionParticipants = _this.props.setActionParticipants;


      _this.setState(function (prevState) {
        var groupUsers = [].concat(_toConsumableArray(prevState.selectedParticipants)).filter(function (participantId) {
          return participantId !== user.id;
        });

        return {
          selectedParticipants: groupUsers,
          availableUsers: prevState.availableUsers.filter(function (availableUser) {
            return availableUser.value !== user.id;
          })
        };
      }, function () {
        setActionParticipants({
          participants: _this.state.selectedParticipants,
          participantType: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* PARTICIPANT_TYPES */].GROUP
        });
      });
    };

    var selectedParticipants = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props.rule, 'data.item.action.options.userIds', []);
    var availableUsersReducer = function availableUsersReducer(usersArray, user) {
      if (!selectedParticipants.includes(user.id)) {
        usersArray.push({
          label: Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user),
          value: Number(user.id)
        });
      }

      return usersArray;
    };

    _this.state = {
      selectedParticipants: selectedParticipants,
      availableUsers: Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["toArray"])(_this.props.users).reduce(availableUsersReducer, [])
    };
    return _this;
  }

  _createClass(GroupParticipantAction, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var users = this.props.users;
      var _state = this.state,
          selectedParticipants = _state.selectedParticipants,
          availableUsers = _state.availableUsers;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'participant-action single-participant' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'participant-action-selector-description' },
          'Who do you want to add to the group?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
          multi: true,
          autoFocus: true,
          options: availableUsers,
          pageSize: 10,
          optionRenderer: this.renderSelectOption,
          placeholder: 'Add a participant to the group...',
          onChange: this.onParticipantsSelected,
          size: 'large'
        }),
        selectedParticipants.map(function (user, index) {
          var selectedUser = users[user];
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { key: index, className: 'group-participant-selected' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserAvatarOption, { user: selectedUser, onUserDeleted: _this2.onGroupUserRemoved })
          );
        })
      );
    }
  }]);

  return GroupParticipantAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (GroupParticipantAction);

/***/ }),

/***/ "hlzs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_DeleteConfirmModal_styl__ = __webpack_require__("RYJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_DeleteConfirmModal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_components_settings_inboxes_DeleteConfirmModal_styl__);





var DeleteConfirmModal = React.createClass({
  displayName: 'DeleteConfirmModal',

  propTypes: {
    onClose: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
    onConfirm: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
    confirmLabel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    disableButtons: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    disableCancel: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    disableConfirm: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  render: function render() {
    var _props = this.props,
        onClose = _props.onClose,
        title = _props.title,
        children = _props.children,
        _props$disableButtons = _props.disableButtons,
        disableButtons = _props$disableButtons === undefined ? false : _props$disableButtons,
        _props$disableCancel = _props.disableCancel,
        disableCancel = _props$disableCancel === undefined ? false : _props$disableCancel,
        _props$disableConfirm = _props.disableConfirm,
        disableConfirm = _props$disableConfirm === undefined ? false : _props$disableConfirm,
        onConfirm = _props.onConfirm,
        confirmLabel = _props.confirmLabel;

    return React.createElement(
      'div',
      { className: 'DeleteConfirm' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Modal"],
        {
          title: title,
          open: true,
          size: 'small',
          onClose: onClose,
          type: 'warning' },
        React.createElement(
          'div',
          { className: 'container' },
          React.createElement(
            'div',
            { className: 'content' },
            children
          ),
          React.createElement(
            'div',
            { className: 'bottom' },
            React.createElement('div', { className: 'bottom-divider' }),
            React.createElement(
              'div',
              { className: 'button-container' },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
                { type: 'secondary', onClick: onConfirm, disabled: disableButtons || disableConfirm },
                confirmLabel || 'Delete'
              ),
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
                { type: 'tertiary', onClick: onClose, disabled: disableButtons || disableCancel, className: 'delete-confirm-modal-cancel-button' },
                'Cancel'
              )
            )
          )
        )
      )
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DeleteConfirmModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "hmNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("tHDv");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var MAX_REVEAL_IPS = 50;

var isRevealDataShownByIp = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["m" /* showRevealData */], function (state, action) {
  var ip = action.payload.ip;

  return state.set(ip, true);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var statusByIp = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchRevealDataByIpPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchRevealDataByIpSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchRevealDataByIpFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchRevealDataByIpCancelled */]), function (state, action) {
  var ip = action.payload.ip;

  return state.set(ip, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var dataByIp = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchRevealDataByIpSuccess */], function (state, action) {
  var _action$payload = action.payload,
      data = _action$payload.data,
      ip = _action$payload.ip;

  return state.set(ip, data).takeLast(MAX_REVEAL_IPS);
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());

var dataByEndUserId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* fetchRevealDataSuccess */], function (state, action) {
  var _action$payload2 = action.payload,
      data = _action$payload2.data,
      endUserId = _action$payload2.endUserId;

  return endUserId ? state.set(endUserId, data) : state;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  statusByIp: statusByIp,
  dataByIp: dataByIp,
  dataByEndUserId: dataByEndUserId,
  isRevealDataShownByIp: isRevealDataShownByIp
}));

/***/ }),

/***/ "hmRH":
/***/ (function(module, exports) {

module.exports = "<svg width=\"21\" height=\"18\" viewBox=\"0 0 21 18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.096 11.3V6.5c0-.828.656-1.648 1.466-1.83l13.044-2.944A1.248 1.248 0 0 1 18.856.5c.69 0 1.25.562 1.25 1.252v14.996c0 .692-.554 1.252-1.25 1.252a1.253 1.253 0 0 1-1.25-1.226L9.15 14.866l-.377 1.97a.967.967 0 0 1-1.167.765l-3.527-.75c-.543-.114-.983-.663-.985-1.213l-.01-4.34.01.003zM.094 6.008C.094 5.45.538 5 1.094 5c.553 0 1 .457 1 1.008v6.484c0 .557-.443 1.008-1 1.008-.552 0-1-.457-1-1.008V6.008zm4.33 7.784l3.54.81-.23 1.31a.476.476 0 0 1-.578.386l-2.26-.48a.636.636 0 0 1-.49-.61l.018-1.416z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "hnY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_bold_svg__ = __webpack_require__("DZms");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_bold_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_bold_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_italic_svg__ = __webpack_require__("WN26");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_italic_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_italic_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_underline_svg__ = __webpack_require__("Ala6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_underline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_underline_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_list_bullets_svg__ = __webpack_require__("IypW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_list_bullets_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_list_bullets_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_list_numbers_svg__ = __webpack_require__("CGW9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_list_numbers_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_list_numbers_svg__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












var ToolbarButton = function ToolbarButton(_ref) {
  var iconSrc = _ref.iconSrc,
      onClick = _ref.onClick,
      active = _ref.active;

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('rich-editor-toolbar-button', { active: active }), onClick: onClick },
    React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: iconSrc })
  );
};

var BLOCK_TYPES = [{ iconSrc: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_list_bullets_svg___default.a, style: 'unordered-list-item' }, { iconSrc: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_list_numbers_svg___default.a, style: 'ordered-list-item' }];

var INLINE_STYLES = [{ iconSrc: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_bold_svg___default.a, style: 'BOLD' }, { iconSrc: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_italic_svg___default.a, style: 'ITALIC' }, { iconSrc: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_underline_svg___default.a, style: 'UNDERLINE' }];

var createBlockStyleButton = function createBlockStyleButton(_ref2) {
  var iconSrc = _ref2.iconSrc,
      style = _ref2.style;

  return function (_ref3) {
    var editorState = _ref3.editorState,
        onChange = _ref3.onChange;

    var toggleStyle = function toggleStyle() {
      onChange(__WEBPACK_IMPORTED_MODULE_0_draft_js__["RichUtils"].toggleBlockType(editorState, style));
    };
    var currentBlockStyle = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
    var isActive = currentBlockStyle === style;
    return React.createElement(ToolbarButton, {
      active: isActive,
      iconSrc: iconSrc,
      onClick: toggleStyle
    });
  };
};

var createInlineStyleButton = function createInlineStyleButton(_ref4) {
  var iconSrc = _ref4.iconSrc,
      style = _ref4.style;

  return function (_ref5) {
    var editorState = _ref5.editorState,
        onChange = _ref5.onChange;

    var toggleStyle = function toggleStyle() {
      onChange(__WEBPACK_IMPORTED_MODULE_0_draft_js__["RichUtils"].toggleInlineStyle(editorState, style));
    };
    var currentInlineStyle = editorState.getCurrentInlineStyle();
    var isActive = currentInlineStyle.has(style);
    return React.createElement(ToolbarButton, {
      active: isActive,
      iconSrc: iconSrc,
      onClick: toggleStyle
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_draft_extend__["createPlugin"])({
  buttons: [].concat(_toConsumableArray(INLINE_STYLES.map(createInlineStyleButton)), _toConsumableArray(BLOCK_TYPES.map(createBlockStyleButton)))
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "hnkb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MappingType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LeadContactPropertyMapping__ = __webpack_require__("FVGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountPropertyMapping__ = __webpack_require__("GIEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("FRQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);









var HELP_DOC_URL = 'https://help.drift.com/integrations/mapping-salesforce-attributes';

var MappingType = {
  LEAD: 'lead',
  CONTACT: 'contact',
  CASE: 'case',
  ACCOUNT: 'account'
};

var SalesforceMapping = function SalesforceMapping(_ref) {
  var hasCaseCutover = _ref.hasCaseCutover,
      selectedTab = _ref.selectedTab,
      onTabClick = _ref.onTabClick;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'common-integration-page-layout' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
      backLinkText: 'Salesforce Integration',
      backLinkUrl: '/settings/setup/salesforce'
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'header',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        { className: 'integration-header' },
        'Mapped Salesforce Attributes'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'You can map exisiting Drift Attributes or static values to your Leads, Contacts, ',
        hasCaseCutover ? 'Cases, ' : '',
        'and Accounts in Salesforce.',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: HELP_DOC_URL },
          ' Learn More'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
        {
          className: 'event-log-link',
          to: '/settings/salesforce/event-log'
        },
        'View Salesforce Event Log'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'salesforce-property-mapping-tabs' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: selectedTab === MappingType.LEAD && 'selected',
          onClick: function onClick() {
            return onTabClick(MappingType.LEAD);
          }
        },
        'Lead Properties'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: selectedTab === MappingType.CONTACT && 'selected',
          onClick: function onClick() {
            return onTabClick(MappingType.CONTACT);
          }
        },
        'Contact Properties'
      ),
      hasCaseCutover && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: selectedTab === MappingType.CASE && 'selected',
          onClick: function onClick() {
            return onTabClick(MappingType.CASE);
          }
        },
        'Case Properties'
      ),
      __WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].hasGates('SALESFORCE_ACCOUNT_MAPPING') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        {
          className: selectedTab === MappingType.ACCOUNT && 'selected',
          onClick: function onClick() {
            return onTabClick(MappingType.ACCOUNT);
          }
        },
        'Account Properties'
      )
    ),
    selectedTab === MappingType.ACCOUNT ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccountPropertyMapping__["a" /* default */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__LeadContactPropertyMapping__["a" /* default */], { key: selectedTab, type: selectedTab })
  );
};

/* harmony default export */ __webpack_exports__["b"] = (SalesforceMapping);

/***/ }),

/***/ "hnps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hoI/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "htGL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_pardot_actions__ = __webpack_require__("Suvm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_pardot_selectors__ = __webpack_require__("+Hgj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_pardot_models__ = __webpack_require__("6Fjn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("CdFk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var HELP_DOC_URL = 'https://gethelp.drift.com/hc/en-us/articles/360021057613-Drift-and-Pardot';
var integrationName = "Pardot";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return 'You successfully updated your ' + integrationName + ' App!';
};

var PardotAttributeMapping = function (_Component) {
  _inherits(PardotAttributeMapping, _Component);

  function PardotAttributeMapping(props) {
    _classCallCheck(this, PardotAttributeMapping);

    var _this = _possibleConstructorReturn(this, (PardotAttributeMapping.__proto__ || Object.getPrototypeOf(PardotAttributeMapping)).call(this, props));

    _this.patchDecorator = function (strippedMappings, successCB) {
      var payload = { mappings: strippedMappings };
      _this.props.actions.patchPardotMappings(payload, successCB);
    };

    _this.state = {
      mappings: props.mappings
    };
    return _this;
  }

  _createClass(PardotAttributeMapping, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.mappings !== nextProps.mappings) {
        this.setState({ mappings: nextProps.mappings });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchDriftProperties();
      this.props.actions.fetchPardotFields();
      this.props.actions.fetchPardotMappings();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          patchLoading = _props.patchLoading,
          driftProperties = _props.driftProperties,
          pardotFields = _props.pardotFields,
          actions = _props.actions,
          notifications = _props.notifications;
      var mappings = this.state.mappings;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pardot-mapping common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Pardot Integration',
          backLinkUrl: '/settings/setup/pardot'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Mapped Pardot Attributes'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            ' Map which fields you want to add to new Pardot Prospects. These Drift attributes will be added to new Pardot Prospects when they\u2019re created.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: HELP_DOC_URL },
              ' Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__["a" /* default */], {
          integrationName: 'Pardot',
          mappings: mappings,
          driftAttributes: driftProperties,
          integrationAttributes: pardotFields,
          mappingModel: __WEBPACK_IMPORTED_MODULE_9_app_modules_pardot_models__["a" /* PardotMapping */],
          patchMappings: this.patchDecorator,
          patchLoading: patchLoading,
          allowAttributeDefaults: true })
      );
    }
  }]);

  return PardotAttributeMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PardotAttributeMapping.defaultProps = {
  allowAttributeDefaults: false
};

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state),
    mappings: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_pardot_selectors__["c" /* getMappings */])(state),
    pardotFields: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_pardot_selectors__["b" /* getFields */])(state),
    patchError: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_pardot_selectors__["a" /* didPatchErr */])(state),
    patchLoading: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_pardot_selectors__["d" /* isPatchLoading */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      fetchPardotMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_pardot_actions__["b" /* fetchPardotMappings */],
      fetchPardotFields: __WEBPACK_IMPORTED_MODULE_4_app_modules_pardot_actions__["a" /* fetchPardotFields */],
      patchPardotMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_pardot_actions__["c" /* patchPardotMappings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PardotAttributeMapping)));

/***/ }),

/***/ "huSt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, Marty) {/* harmony export (immutable) */ __webpack_exports__["a"] = onLoggedInRouteChange;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return onLoggedInRouteEnter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onProtectedRouteEnter; });
/* unused harmony export getGateRedirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_UserAgentHelper__ = __webpack_require__("SAM1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_api_TokenAPI__ = __webpack_require__("Lftg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var getLogInRedirect = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(app) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return app.stores.UserStore.getOrFetchCurrentUser().toPromise();

          case 3:
            _context.next = 9;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context['catch'](0);

            console.warn(_context.t0);
            Object(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__["redirectToLoginPage"])(__WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */]);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 5]]);
  }));

  return function getLogInRedirect(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getOnboardingRedirectPath = function () {
  var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(app, nextState) {
    var query, _ref6, _ref7, orgProperties, userProperties, postInstall;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            query = nextState.location.query;
            _context3.next = 3;
            return Promise.all([app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg().toPromise(), app.stores.UserPropertiesStore.fetchPropertiesForCurrentUser().toPromise()]);

          case 3:
            _ref6 = _context3.sent;
            _ref7 = _slicedToArray(_ref6, 2);
            orgProperties = _ref7[0];
            userProperties = _ref7[1];
            postInstall = orgProperties.postInstall;

            if (!(postInstall === 'slack')) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt('return', 'setup-slack');

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getOnboardingRedirectPath(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










var CONVERSATIONS_URL_REGEX = /inboxes\/\d+\/conversations\/(\d+)/;

/**
 * config used for allowed path for each gate
 * @type {{premium: RegExp, chat: RegExp}}
 */
var ALLOWED_PATHS = {
  premium_drift: /./,
  chat: /^\/(inboxes|settings(?!\/notifications-beta($|\/))|dashboard|live|conversation-stats|setup|users|customize(?!\/audience($|\/)))/,
  has_11_2016_targeting: /^\/customize\/audience/,
  has_messaging_for_all: /^\/(inboxes|settings)($|\/)/
};

function isWhiteGloveRoute(pathname) {
  return pathname && pathname.includes('white-glove');
}

function conversationsDeepLinkRedirect(pathname) {
  var conversationId = CONVERSATIONS_URL_REGEX.exec(pathname)[1];
  window.location = 'drift://conversation/' + conversationId;
}

var removeCodeFromQuery = function removeCodeFromQuery(_ref2) {
  var replace = _ref2.replace,
      pathname = _ref2.pathname,
      query = _ref2.query;

  var newQuery = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["omit"])(['code'], query);
  replace({ pathname: pathname, query: newQuery });
};

var sanitizeTokenFromHistory = function sanitizeTokenFromHistory(_ref3) {
  var replace = _ref3.replace,
      pathname = _ref3.pathname,
      query = _ref3.query;

  var newQuery = _.cloneDeep(query);
  delete newQuery.token;
  delete newQuery.driftt_token;
  replace({ pathname: pathname, query: newQuery });
};

function onLoggedInRouteChange(prevState, nextState, replace, callback) {
  var _nextState$location = nextState.location,
      query = _nextState$location.query,
      pathname = _nextState$location.pathname;


  if (query.token || query.driftt_token) {
    sanitizeTokenFromHistory({ replace: replace, pathname: pathname, query: query });
  }

  if (query.code && !isWhiteGloveRoute(pathname)) {
    removeCodeFromQuery({ replace: replace, pathname: pathname, query: query });
  }

  callback();
}

var CONSUMED_CODES = [];

var onLoggedInRouteEnter = function () {
  var _ref4 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(app, nextState, replace) {
    var _nextState$location2, query, pathname, processingCredential, response, body, currentUser, raven, authRedirect;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _nextState$location2 = nextState.location, query = _nextState$location2.query, pathname = _nextState$location2.pathname;
            _context2.next = 3;
            return Object(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__["checkForGlobalSession"])();

          case 3:
            processingCredential = false;
            _context2.prev = 4;

            if (!(query.code && !isWhiteGloveRoute(pathname))) {
              _context2.next = 12;
              break;
            }

            if (!CONSUMED_CODES.includes(query.code)) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt('return');

          case 8:
            CONSUMED_CODES.push(query.code);
            processingCredential = true;
            _context2.next = 12;
            return Object(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__["authenticateWithCode"])({ authorizationCode: query.code, clientId: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["d" /* AUTH_CLIENT_ID */] });

          case 12:

            /**
             * This is how we accept token on oauth redirect from start.driftt.com
             */
            if (query.token) {
              processingCredential = true;
              Object(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__["setAccessToken"])({ token: query.token });
            }
            // try exchange this one time token for an access token

            if (!query.driftt_token) {
              _context2.next = 33;
              break;
            }

            processingCredential = true;
            _context2.next = 17;
            return Object(__WEBPACK_IMPORTED_MODULE_5_app_api_TokenAPI__["c" /* fetchTokenForDriftt */])(query.driftt_token);

          case 17:
            response = _context2.sent;
            _context2.next = 20;
            return response.json();

          case 20:
            body = _context2.sent;

            if (!body.access_token) {
              _context2.next = 30;
              break;
            }

            Object(__WEBPACK_IMPORTED_MODULE_3__driftt_web_auth__["setAccessToken"])({ token: body.access_token });
            _context2.next = 25;
            return app.stores.UserStore.getOrFetchCurrentUser().toPromise();

          case 25:
            currentUser = _context2.sent;
            _context2.next = 28;
            return app.queries.UserQueries.updateUser({
              userId: currentUser.id,
              params: {
                status: 'ENABLED'
              }
            });

          case 28:
            _context2.next = 33;
            break;

          case 30:
            raven = Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["d" /* getRavenClient */])();

            raven && raven.captureMessage('Bad Invitation Token!', { level: 'warn' });
            console.warn(body);

          case 33:
            if (!(query.code && !isWhiteGloveRoute(pathname))) {
              _context2.next = 37;
              break;
            }

            removeCodeFromQuery({ replace: replace, pathname: pathname, query: query });
            _context2.next = 49;
            break;

          case 37:
            if (!(query.token || query.driftt_token)) {
              _context2.next = 41;
              break;
            }

            sanitizeTokenFromHistory({ replace: replace, pathname: pathname, query: query });
            _context2.next = 49;
            break;

          case 41:
            if (!(Object(__WEBPACK_IMPORTED_MODULE_2_utils_UserAgentHelper__["b" /* isMobileCheck */])() && pathname !== '/mobile-lander')) {
              _context2.next = 45;
              break;
            }

            if (CONVERSATIONS_URL_REGEX.test(pathname)) {
              conversationsDeepLinkRedirect(pathname);
            } else {
              window.location = Object(__WEBPACK_IMPORTED_MODULE_2_utils_UserAgentHelper__["a" /* isIosCheck */])() ? __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["B" /* LOGIN_APP_URL */] + '/download-ios-app' : __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["B" /* LOGIN_APP_URL */] + '/download-android-app';
            }
            _context2.next = 49;
            break;

          case 45:
            _context2.next = 47;
            return getLogInRedirect(app);

          case 47:
            authRedirect = _context2.sent;

            if (authRedirect) {
              // This is super special case. Super super. It is due to going outside the app
              // is not part of the router's concern
              if (Marty.isBrowser) {
                window.location.href = authRedirect;
              } else {
                replace({
                  state: {
                    external: authRedirect
                  }
                });
              }
            }

          case 49:
            _context2.next = 55;
            break;

          case 51:
            _context2.prev = 51;
            _context2.t0 = _context2['catch'](4);

            Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(_context2.t0);
            return _context2.abrupt('return', processingCredential);

          case 55:
            _context2.prev = 55;
            return _context2.abrupt('return', processingCredential);

          case 58:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[4, 51, 55, 58]]);
  }));

  return function onLoggedInRouteEnter(_x2, _x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

var onProtectedRouteEnter = function () {
  var _ref8 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(app, nextState, replace, callback) {
    var pathname, redirectPath;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            pathname = nextState.location.pathname;
            _context4.next = 4;
            return getOnboardingRedirectPath(app, nextState);

          case 4:
            _context4.t0 = _context4.sent;

            if (_context4.t0) {
              _context4.next = 12;
              break;
            }

            _context4.t1 = getGateRedirect;
            _context4.next = 9;
            return app.stores.GateStore.getOrFetchGates().toPromise();

          case 9:
            _context4.t2 = _context4.sent;
            _context4.t3 = pathname;
            _context4.t0 = (0, _context4.t1)(_context4.t2, _context4.t3);

          case 12:
            redirectPath = _context4.t0;

            // redirect != pathname to prevent infinite replacement loop. possible
            // react-router bug
            if (redirectPath && redirectPath.includes('letsgo')) {
              window.location = redirectPath;
            }
            if (redirectPath && redirectPath != pathname) {
              replace({ pathname: redirectPath });
            }
            _context4.next = 20;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t4 = _context4['catch'](0);

            Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(_context4.t4);

          case 20:
            _context4.prev = 20;

            callback();
            return _context4.finish(20);

          case 23:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[0, 17, 20, 23]]);
  }));

  return function onProtectedRouteEnter(_x7, _x8, _x9, _x10) {
    return _ref8.apply(this, arguments);
  };
}();

function getGateRedirect(gates, pathname) {
  var isAllowed = _.some(gates, function (value, gate) {
    return !!value && ALLOWED_PATHS[gate] && ALLOWED_PATHS[gate].test(pathname);
  });
  if (!isAllowed) {
    return gates.chat || gates.premium_drift ? '/' : '/letsgo';
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "huaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SlackUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_auth_requests_api__ = __webpack_require__("Y7j0");





var SlackUser = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  email: undefined,
  slackUserId: undefined,
  avatarUrl: undefined,
  name: undefined
});

function parseResponse(data) {
  var user = data.user,
      slackUser = data.slackUser;

  return SlackUser({
    name: user.name,
    email: user.email,
    slackUserId: slackUser.id,
    avatarUrl: slackUser.profile.image_48 // possible img suffixes _24 _32 _48 _71 _192 _512
  });
}

var SlackTeamAPI = {
  fetch: function fetch() {
    return __WEBPACK_IMPORTED_MODULE_3_app_auth_requests_api__["b" /* CustomerAPIAuthEnabled */].get('/integrations/slack/team').then(function (response) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(response.data).map(parseResponse);
    }).catch(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */]);
  },
  sendInvitations: function sendInvitations(users, orgId, scopes) {
    /*
     * Rather than create a new endpoint for slack, we're re-using the org invite endpoint. This creates some
     * confusion  between our SlackStore and our OrgStore and who owns what. It may be worth dedicating
     * Customer API code to slack integration activity rather than doubling duty of the org API
     */
    var usersWithScopes = users.map(function (user) {
      return {
        slackUserId: user.slackUserId,
        email: user.email,
        scopes: scopes
      };
    });

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/organizations/' + orgId + '/users/invitations/slack', usersWithScopes).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SlackTeamAPI);

/***/ }),

/***/ "hzfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withOAuthConnectionStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__ = __webpack_require__("KP0q");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









function withOAuthConnectionStatus(WrappedComponent) {
  var enhance = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
    return { isConnected: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["C" /* isOauthConnected */])(state) };
  }, function (dispatch) {
    return { actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({ fetchCalendarStatus: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["r" /* fetchCalendarStatus */] }, dispatch) };
  });

  var WithOauthConnectionStatus = function (_Component) {
    _inherits(WithOauthConnectionStatus, _Component);

    function WithOauthConnectionStatus() {
      _classCallCheck(this, WithOauthConnectionStatus);

      return _possibleConstructorReturn(this, (WithOauthConnectionStatus.__proto__ || Object.getPrototypeOf(WithOauthConnectionStatus)).apply(this, arguments));
    }

    _createClass(WithOauthConnectionStatus, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.actions.fetchCalendarStatus();
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }
    }]);

    return WithOauthConnectionStatus;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  return enhance(WithOauthConnectionStatus);
}

/***/ }),

/***/ "i4Ts":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NoteBody":"NoteBody---2abPP","TimelineAttributes":"TimelineAttributes---_FTAx","NPSEvent":"NPSEvent---1fe6C"};

/***/ }),

/***/ "iAL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export endUserMembershipById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return endUserMembershipByIdFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return byId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return segmentListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return endUserSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return segments; });
/* unused harmony export endUserCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("1uBT");




var root = function root(state) {
  return state.get('segment');
};

var endUserMemberships = function endUserMemberships(state) {
  return root(state).get('endUserMembership');
};

var endUserMembershipById = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([endUserMemberships, function (state, props) {
  return props.endUserId;
}], function (endUserMemberships, endUserId) {
  return endUserMemberships.get(endUserId);
});

var endUserMembershipByIdFetched = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([endUserMemberships, function (state, props) {
  return props.endUserId;
}], function (endUserMemberships, endUserId) {
  return endUserMemberships.has(endUserId);
});

var byId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('byId');
});
var segmentListStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('segmentStatus');
});
var segmentListLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(segmentListStatus, function (segmentListStatus) {
  return segmentListStatus === __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* receiveSegmentList */].toString();
});

var endUserSegments = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([endUserMembershipById, byId], function (endUserMembershipById, byId) {
  return byId.filter(function (segment) {
    return _.includes(endUserMembershipById, segment.id);
  });
});

var cardinalityByIdSet = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('cardinalityByIdSet');
});
var segments = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(byId, function (byId) {
  return byId.valueSeq().filter(function (_ref) {
    var status = _ref.status;
    return status !== __WEBPACK_IMPORTED_MODULE_2__models__["a" /* SegmentStatus */].HIDDEN;
  });
});
var endUserCount = function endUserCount(state, props) {
  return cardinalityByIdSet(state).get(props.segmentSet);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "iELk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "silence.mp3";

/***/ }),

/***/ "iKCO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export getSegmentIdFromQuery */
/* harmony export (immutable) */ __webpack_exports__["b"] = isSegmentHidden;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSegmentSelection;
/* harmony export (immutable) */ __webpack_exports__["c"] = segmentIdsToSegmentSet;
function getSegmentIdFromQuery(query, segmentList) {
  if (query && query.segmentId) {
    var parsedSegmentId = parseInt(query.segmentId);
    if (_.keyBy(segmentList, 'id')[parsedSegmentId]) {
      return parsedSegmentId;
    }
  }
  return undefined;
}

function isSegmentHidden(segment) {
  return segment.status === 'HIDDEN';
}

function getSegmentSelection(selectedSegmentId, segments) {
  return _.filter(segments, function (segment) {
    return !isSegmentHidden(segment) || segment.id === selectedSegmentId;
  });
}

function segmentIdsToSegmentSet(segmentIds) {
  return segmentIds.slice().sort().join(',');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "iL8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return fetchEndUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchEndUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchEndUserCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return receiveEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return updateEndUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return updateEndUserPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return updateEndUserFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchEndUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return fetchEndUserListPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return fetchEndUserListFailed; });
/* unused harmony export fetchEndUserListCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return fetchEndUserListSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return joinEndUserChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return closeEndUserChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchFollowing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchFollowingPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchFollowingFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchFollowingSuccess; });
/* unused harmony export fetchFollowingCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return updateFollowing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return updateFollowingPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return updateFollowingFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return updateFollowingSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return updateCQL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return updateCQLPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return updateCQLFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return updateCQLSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return unsubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return unsubscribeById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return unsubscribeByEncodedEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return unsubscribeByEmailAndOrgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return unsubscribePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return unsubscribeFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return unsubscribeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return resubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return resubscribeByEmailandOrgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return resubscribePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return resubscribeFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return resubscribeSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkUnsubscribed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkUnsubscribedPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkUnsubscribedFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return checkUnsubscribedSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchUnsubscribedCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchUnsubscribedCountPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchUnsubscribedCountFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchUnsubscribedCountSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createPropertyDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createPropertyDefinitionPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createPropertyDefinitionFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createPropertyDefinitionCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return createPropertyDefinitionSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return requestContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return requestContactDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return requestContactDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return requestContactDataFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return requestDeleteContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return requestDeleteContactDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return requestDeleteContactDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return requestDeleteContactDataFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return requestUnsubDeleteData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return requestUnsubDeleteDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return requestUnsubDeleteDataFailed; });
/* unused harmony export requestUnsubDeleteDataCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return requestUnsubDeleteDataSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("bNDg");



var fetchEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_END_USER */]);
var fetchEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* FETCH_END_USER_PENDING */]);
var fetchEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_END_USER_FAILED */]);
var fetchEndUserCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_END_USER_CANCELLED */]);
var receiveEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* RECEIVE_END_USER */]);

var updateEndUser = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* UPDATE_END_USER */]);
var updateEndUserPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* UPDATE_END_USER_PENDING */]);
var updateEndUserFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* UPDATE_END_USER_FAILED */]);

var fetchEndUserList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_END_USER_LIST */]);
var fetchEndUserListPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* FETCH_END_USER_LIST_PENDING */]);
var fetchEndUserListFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_END_USER_LIST_FAILED */]);
var fetchEndUserListCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_END_USER_LIST_CANCELLED */]);
var fetchEndUserListSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* FETCH_END_USER_LIST_SUCCESS */]);

var joinEndUserChannel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* JOIN_END_USER_CHANNEL */]);
var closeEndUserChannel = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* CLOSE_END_USER_CHANNEL */]);

var fetchFollowing = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* FETCH_FOLLOWING */]);
var fetchFollowingPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* FETCH_FOLLOWING_PENDING */]);
var fetchFollowingFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* FETCH_FOLLOWING_FAILED */]);
var fetchFollowingSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* FETCH_FOLLOWING_SUCCESS */]);
var fetchFollowingCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FETCH_FOLLOWING_CANCELLED */]);

var updateFollowing = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* UPDATE_FOLLOWING */]);
var updateFollowingPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* UPDATE_FOLLOWING_PENDING */]);
var updateFollowingFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* UPDATE_FOLLOWING_FAILED */]);
var updateFollowingSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* UPDATE_FOLLOWING_SUCCESS */]);

var updateCQL = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* UPDATE_CQL */]);
var updateCQLPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* UPDATE_CQL_PENDING */]);
var updateCQLFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* UPDATE_CQL_FAILED */]);
var updateCQLSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* UPDATE_CQL_SUCCESS */]);

var unsubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["W" /* UNSUBSCRIBE */]);
var unsubscribeById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* UNSUBSCRIBE_BY_ID */]);
var unsubscribeByEncodedEmail = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* UNSUBSCRIBE_BY_ENCODED_EMAIL */]);
var unsubscribeByEmailAndOrgId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* UNSUBSCRIBE_BY_EMAIL_AND_ORG_ID */]);
var unsubscribePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* UNSUBSCRIBE_PENDING */]);
var unsubscribeFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* UNSUBSCRIBE_FAILED */]);
var unsubscribeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* UNSUBSCRIBE_SUCCESS */]);

var resubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* RESUBSCRIBE */]);
var resubscribeByEmailandOrgId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* RESUBSCRIBE_BY_EMAIL_AND_ORG_ID */]);
var resubscribePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* RESUBSCRIBE_PENDING */]);
var resubscribeFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* RESUBSCRIBE_FAILED */]);
var resubscribeSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* RESUBSCRIBE_SUCCESS */]);

var checkUnsubscribed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CHECK_UNSUBSCRIBED */]);
var checkUnsubscribedPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CHECK_UNSUBSCRIBED_PENDING */]);
var checkUnsubscribedFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CHECK_UNSUBSCRIBED_FAILED */]);
var checkUnsubscribedSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CHECK_UNSUBSCRIBED_SUCCESS */]);

var fetchUnsubscribedCount = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* FETCH_UNSUBSCRIBED_COUNT */]);
var fetchUnsubscribedCountPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* FETCH_UNSUBSCRIBED_COUNT_PENDING */]);
var fetchUnsubscribedCountFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* FETCH_UNSUBSCRIBED_COUNT_FAILED */]);
var fetchUnsubscribedCountSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* FETCH_UNSUBSCRIBED_COUNT_SUCCESS */]);

var createPropertyDefinition = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CREATE_PROPERTY_DEFINITION */]);
var createPropertyDefinitionPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* CREATE_PROPERTY_DEFINITION_PENDING */]);
var createPropertyDefinitionFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* CREATE_PROPERTY_DEFINITION_FAILED */]);
var createPropertyDefinitionCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* CREATE_PROPERTY_DEFINITION_CANCELLED */]);
var createPropertyDefinitionSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* CREATE_PROPERTY_DEFINITION_SUCCESS */]);

var requestContactData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* REQUEST_CONTACT_DATA */]);
var requestContactDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* REQUEST_CONTACT_DATA_PENDING */]);
var requestContactDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* REQUEST_CONTACT_DATA_SUCCESS */]);
var requestContactDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* REQUEST_CONTACT_DATA_FAILED */]);

var requestDeleteContactData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* REQUEST_DELETE_CONTACT_DATA */]);
var requestDeleteContactDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* REQUEST_DELETE_CONTACT_DATA_PENDING */]);
var requestDeleteContactDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* REQUEST_DELETE_CONTACT_DATA_SUCCESS */]);
var requestDeleteContactDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* REQUEST_DELETE_CONTACT_DATA_FAILED */]);

var requestUnsubDeleteData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* REQUEST_UNSUB_DELETE_DATA */]);
var requestUnsubDeleteDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* REQUEST_UNSUB_DELETE_DATA_PENDING */]);
var requestUnsubDeleteDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* REQUEST_UNSUB_DELETE_DATA_FAILED */]);
var requestUnsubDeleteDataCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* REQUEST_UNSUB_DELETE_DATA_CANCELLED */]);
var requestUnsubDeleteDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* REQUEST_UNSUB_DELETE_DATA_SUCCESS */]);

/***/ }),

/***/ "iOLK":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.38 15H3.12c-.34 0-.62-.28-.62-.63V3.13c0-.35.28-.63.63-.63h11.25c.34 0 .62.28.62.63v11.25c0 .34-.28.62-.63.62zm-.63-11.25h-10v10h10v-10zm-7.5 4.38h1.88V6.25c0-.34.27-.63.62-.63s.63.3.63.63v1.88h1.87c.35 0 .63.27.63.62s-.3.63-.63.63H9.37v1.87c0 .35-.27.63-.62.63s-.63-.3-.63-.63V9.37H6.25c-.34 0-.63-.27-.63-.62s.3-.63.63-.63zm5.63-6.88H1.24v10.63c0 .34-.28.62-.63.62-.34 0-.62-.28-.62-.63V.63C0 .28.28 0 .63 0h11.24c.35 0 .63.28.63.63 0 .34-.28.62-.63.62z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "iRcY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SFDCMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SFDCUserMapping; });
var SFDCMapping = {
  required: false,
  defaultValue: null,
  driftAttribute: null,
  integrationAttribute: null,
  isOverwritable: null
};

var SFDCUserMapping = {
  salesforceId: null,
  userId: null
};

/***/ }),

/***/ "iXXD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return audienceOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);


var audienceOptions = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a({
  EVERYONE: {
    display: 'Everyone',
    long: 'This chat is available to everyone who visits your website.'
  },
  USERS: {
    display: 'Known Users',
    long: 'This chat is available to known users who visit your website.'
  },
  SEGMENT: {
    display: 'Choose a Segment',
    long: 'This chat is available to SEGMENT who visit your website.'
  }
});

/***/ }),

/***/ "idlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("1/7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SalesforceAccountSyncErrors = function (_Component) {
  _inherits(SalesforceAccountSyncErrors, _Component);

  function SalesforceAccountSyncErrors() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SalesforceAccountSyncErrors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SalesforceAccountSyncErrors.__proto__ || Object.getPrototypeOf(SalesforceAccountSyncErrors)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      syncHistory: {}
    }, _this.resync = function () {
      __WEBPACK_IMPORTED_MODULE_8_app_modules_sfdc_api__["a" /* api */].resyncAccountList().then(function () {
        return _this.props.notifications.success(' We are re-syncing your accounts :)');
      });
    }, _this.receiveHistory = function (resp) {
      _this.setState({
        syncHistory: resp
      });
    }, _this.renderErrorList = function (errors) {
      return errors.map(function (name) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: 'account-sync-error-list-item',
            key: name
          },
          name
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SalesforceAccountSyncErrors, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_8_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountListSyncHistory().then(this.receiveHistory);
    }
  }, {
    key: 'render',
    value: function render() {
      var syncHistory = this.state.syncHistory;

      if (!syncHistory.updateDateTime) return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);

      var results = syncHistory.results;


      var errors = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["uniq"])([].concat(_toConsumableArray(results.FAILED_NODOMAIN), _toConsumableArray(results.FAILED_NOOWNER)).map(function (error) {
        return error.name;
      }));
      var formattedDate = __WEBPACK_IMPORTED_MODULE_7_moment___default()(syncHistory.updateDateTime).format('DD/MM/YYYY') + ' at ' + __WEBPACK_IMPORTED_MODULE_7_moment___default()(syncHistory.updateDateTime).format('HH:MM');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout account-sync-error-page' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'account-sync-error-breadcrumbs' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
            backLinkText: 'Salesforce Integration',
            backLinkUrl: '/settings/setup/salesforce'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
            backLinkText: 'Synced Salesforce Data',
            backLinkUrl: '/settings/salesforce/config'
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Account List Sync Errors for ',
            formattedDate
          ),
          errors && errors.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'We couldn\'t sync ',
            errors.length,
            ' accounts because they were missing required information.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'integration-header' },
            'Not Synced Accounts'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'account-sync-error-page-warning-text' },
            'Please double check the accounts below to make sure that they have a website field, and also that the Account Owner in Salesforce is mapped to a Drift teammate',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
              { to: '/settings/salesforce/mapping/users' },
              ' here.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'account-sync-error-list-container' },
            this.renderErrorList(errors)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Button"],
            {
              type: 'subtle',
              size: 'medium',
              onClick: this.resync
            },
            'Resync Accounts'
          )
        )
      );
    }
  }]);

  return SalesforceAccountSyncErrors;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

SalesforceAccountSyncErrors.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(SalesforceAccountSyncErrors));

/***/ }),

/***/ "ienp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "iext":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAccountAttribs; });
/* unused harmony export fetchTeamMemberAttribs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAccountSegments; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var fetchAccountAttribs = function fetchAccountAttribs() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/attrib');
};
var fetchTeamMemberAttribs = function fetchTeamMemberAttribs() {
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/attrib?type=TEAMMEMBER');
};
var fetchAccountSegments = function fetchAccountSegments() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
  return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/accounts/segment?index=' + index + '&size=' + size);
};

/***/ }),

/***/ "ikuy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgdmlld0JveD0iMCAwIDE5IDE5Ij4KICAgIDxnIGZpbGw9IiM5ZWFiYjMiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHJ4PSIxIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHg9IjciIHJ4PSIxIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHg9IjE0IiByeD0iMSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI0LjUiIGhlaWdodD0iNC41IiB5PSI3IiByeD0iMSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI0LjUiIGhlaWdodD0iNC41IiB4PSI3IiB5PSI3IiByeD0iMSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI0LjUiIGhlaWdodD0iNC41IiB4PSIxNCIgeT0iNyIgcng9IjEiLz4KICAgICAgICA8cmVjdCB3aWR0aD0iNC41IiBoZWlnaHQ9IjQuNSIgeT0iMTQiIHJ4PSIxIi8+CiAgICAgICAgPHJlY3Qgd2lkdGg9IjQuNSIgaGVpZ2h0PSI0LjUiIHg9IjciIHk9IjE0IiByeD0iMSIvPgogICAgICAgIDxyZWN0IHdpZHRoPSI0LjUiIGhlaWdodD0iNC41IiB4PSIxNCIgeT0iMTQiIHJ4PSIxIi8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "imtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_demandbase_selectors__ = __webpack_require__("OtCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_demandbase_actions__ = __webpack_require__("FFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectFilter__ = __webpack_require__("ANGi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var mapToOptions = function mapToOptions(values) {
  return !!values ? values.map(function (value) {
    return { label: value, value: value };
  }) : [];
};

var DemandbaseIndustryFilter = function (_PureComponent) {
  _inherits(DemandbaseIndustryFilter, _PureComponent);

  function DemandbaseIndustryFilter() {
    _classCallCheck(this, DemandbaseIndustryFilter);

    return _possibleConstructorReturn(this, (DemandbaseIndustryFilter.__proto__ || Object.getPrototypeOf(DemandbaseIndustryFilter)).apply(this, arguments));
  }

  _createClass(DemandbaseIndustryFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var actions = this.props.actions;


      actions.fetchDemandbaseTargetingIndustries();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSubIndustry = _props.isSubIndustry,
          demandbaseIndustries = _props.demandbaseIndustries,
          onUpdateCondition = _props.onUpdateCondition,
          activeFilter = _props.activeFilter;

      var options = mapToOptions(demandbaseIndustries);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SelectFilter__["a" /* default */], { options: options, onUpdateCondition: onUpdateCondition, activeFilter: activeFilter, creatable: true });
    }
  }]);

  return DemandbaseIndustryFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDemandbaseTargetingIndustries: __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_demandbase_actions__["f" /* fetchDemandbaseTargetingIndustries */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    demandbaseIndustries: __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_demandbase_selectors__["a" /* demandbaseTargetingIndustries */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(DemandbaseIndustryFilter));

/***/ }),

/***/ "inMS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return root; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return campaign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchStatus; });
/* unused harmony export isCampaignUpdating */
/* unused harmony export isCampaignLoading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCampaignFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchResults; });
/* unused harmony export searchStatus */
/* unused harmony export isLoadingSearchResults */
/* unused harmony export isLoadingMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("7MmB");



var root = function root(state) {
  return state.get('campaigns');
};

var campaign = function campaign(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.getIn(['byId', id]);
  });
};

var fetchStatus = function fetchStatus(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.getIn(['statusById', id]);
  });
};

var isCampaignUpdating = function isCampaignUpdating(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fetchStatus(id), function (fetchStatus) {
    return fetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* UPDATE_CAMPAIGN */] || fetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* UPDATE_CAMPAIGN_PENDING */];
  });
};

var isCampaignLoading = function isCampaignLoading(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(fetchStatus(id), function (fetchStatus) {
    return fetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_CAMPAIGN */] || fetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_CAMPAIGN_PENDING */];
  });
};

var isCampaignFetched = function isCampaignFetched(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
    return root.hasIn(['byId', id]);
  });
};

var searchResults = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['searchResults', 'data']);
});

var searchStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(searchResults, function (searchResults) {
  return searchResults.get('status');
});

var isLoadingSearchResults = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(searchStatus, function (searchStatus) {
  return searchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SEARCH_CAMPAIGNS */] || searchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SEARCH_CAMPAIGNS_PENDING */];
});

var isLoadingMore = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(searchStatus, function (searchStatus) {
  return searchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* LOAD_MORE_CAMPAIGNS */] || searchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["i" /* LOAD_MORE_CAMPAIGNS_PENDING */];
});

/***/ }),

/***/ "ipDR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ipNP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__("FBvR");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("UEdl");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("3wjN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("7uC7");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });









/***/ }),

/***/ "iqf+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UserSelectionSection__ = __webpack_require__("5y4S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Constants__ = __webpack_require__("SqAV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl__ = __webpack_require__("pJPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_immutable__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var DESCRIPTIONS = {
  DESCRIPTION_USER: 'We’ll always display this person in your default greeting.',
  DESCRIPTION_RANDOM: 'We’ll display a member of your team at random in your default greeting.'
};

function getSelectedUser(allUsers, userId) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(allUsers, { id: userId });
}

var toSelectOptions = function toSelectOptions(userListOptions) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(userListOptions.enums, function (data) {
    return { value: data.key, label: data.value.display };
  });
};

var UserList = function UserList(_ref) {
  var allUsers = _ref.allUsers,
      userList = _ref.userList,
      onSelectUser = _ref.onSelectUser,
      validation = _ref.validation;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'user-list' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UserSelectionSection__["a" /* default */], {
      user: getSelectedUser(allUsers, userList.first()),
      onSelect: onSelectUser,
      enableClear: false
    }),
    !validation.isValid ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'dsg-Label--pink', style: { textTransform: 'none' } },
      validation.invalidLabel
    ) : null
  );
};

var HelpingTeamMemberSelection = function (_Component) {
  _inherits(HelpingTeamMemberSelection, _Component);

  function HelpingTeamMemberSelection(props) {
    _classCallCheck(this, HelpingTeamMemberSelection);

    var _this = _possibleConstructorReturn(this, (HelpingTeamMemberSelection.__proto__ || Object.getPrototypeOf(HelpingTeamMemberSelection)).call(this, props));

    _this.onUserListModeChange = _this.onUserListModeChange.bind(_this);
    _this.onSelectUser = _this.onSelectUser.bind(_this);

    _this.state = {
      userListMode: props.userListMode,
      userList: props.userList
    };
    return _this;
  }

  _createClass(HelpingTeamMemberSelection, [{
    key: 'onUserListModeChange',
    value: function onUserListModeChange(userListMode) {
      this.setState({ userListMode: userListMode.value });
      this.props.onUserListModeChange(userListMode.value);
    }
  }, {
    key: 'onSelectUser',
    value: function onSelectUser(userId) {
      var userList = userId !== undefined ? __WEBPACK_IMPORTED_MODULE_6_immutable__["List"].of(userId) : Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])();
      this.setState({ userList: userList });
      this.props.onSelectUser(userList);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          allUsers = _props.allUsers,
          validation = _props.validation;
      var _state = this.state,
          userListMode = _state.userListMode,
          userList = _state.userList;


      var options = toSelectOptions(__WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* userListOptions */]);
      var isHandPicked = userListMode === __WEBPACK_IMPORTED_MODULE_4__Constants__["a" /* userListOptions */].CUSTOM.key;
      var description = DESCRIPTIONS[isHandPicked ? 'DESCRIPTION_USER' : 'DESCRIPTION_RANDOM'];

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5__styles_styl___default.a.HelpingTeamMemberSelection, onFocus: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.noop },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'top-row' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__["b" /* default */], {
            value: userListMode,
            onSelection: this.onUserListModeChange,
            options: options,
            searchable: false
          }),
          isHandPicked && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(UserList, {
            allUsers: allUsers,
            userList: userList,
            onSelectUser: this.onSelectUser,
            validation: validation
          })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'description' },
          description
        )
      );
    }
  }]);

  return HelpingTeamMemberSelection;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (HelpingTeamMemberSelection);

/***/ }),

/***/ "irP4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "it3B":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE4IDE1Ij4KICAgIDxwYXRoIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTS43NSAyLjk0MWgxNi41Yy40MTQgMCAuNzUuMzMuNzUuNzM1djEwLjI5NWEuNzQzLjc0MyAwIDAgMS0uNzUuNzM1SC43NUEuNzQzLjc0MyAwIDAgMSAwIDEzLjk3VjMuNjc2YzAtLjQwNi4zMzYtLjczNS43NS0uNzM1em0wIC43MzV2MTAuMjk1aDE2LjVWMy42NzZILjc1em02IDIuNjY1YS40MjcuNDI3IDAgMCAxIC42NC0uMzcxbDQuMzUzIDIuNDgyYS40MjcuNDI3IDAgMCAxIDAgLjc0M2wtNC4zNTQgMi40ODNhLjQyNy40MjcgMCAwIDEtLjYzOS0uMzcyVjYuMzQxek0xLjEyNSAyLjQ3Yy0uMjA3IDAtLjM3NS0uMjI0LS4zNzUtLjUgMC0uMjc3LjE2OC0uNS4zNzUtLjVoMTUuNzM4Yy4yMDcgMCAuMzc1LjIyMy4zNzUuNSAwIC4yNzYtLjE2OC41LS4zNzUuNUgxLjEyNXpNMi42MjUgMUMyLjQxOCAxIDIuMjUuNzc2IDIuMjUuNXMuMTY4LS41LjM3NS0uNWgxMy41Yy4yMDcgMCAuMzc1LjIyNC4zNzUuNXMtLjE2OC41LS4zNzUuNWgtMTMuNXoiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "itDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("99XN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var ToggleSection = function ToggleSection(_ref) {
  var title = _ref.title,
      description = _ref.description,
      isActive = _ref.isActive,
      onToggled = _ref.onToggled,
      className = _ref.className;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("shared-toggle-section", className) },
    React.createElement(
      'div',
      null,
      React.createElement(
        'span',
        { className: 'shared-toggle-section-title' },
        title
      ),
      React.createElement(
        'span',
        { className: 'shared-toggle-section-description' },
        description
      )
    ),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_Toggle__["a" /* default */], {
      className: 'shared-toggle-section-toggle',
      checked: isActive,
      onChange: onToggled })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ToggleSection);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "iv9e":
/***/ (function(module, exports) {

module.exports = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.045 5.691a.49.49 0 0 0 .107.163l1.993 2a.495.495 0 0 0 .704 0 .501.501 0 0 0 0-.708L1.707 6h7.265a2.998 2.998 0 0 0 2.99-3V.5a.5.5 0 1 0-.997 0V3c0 1.103-.894 2-1.993 2H1.707l1.142-1.147a.501.501 0 0 0 0-.707.496.496 0 0 0-.704 0l-1.993 2a.5.5 0 0 0-.107.545z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ivXw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(32);

/***/ }),

/***/ "j4fR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchTeamMemberAttribs */
/* unused harmony export fetchTeamMemberAttribsPending */
/* unused harmony export fetchTeamMemberAttribsSuccess */
/* unused harmony export fetchTeamMemberAttribsFailed */
/* unused harmony export fetchTeamMemberAttribsCancelled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAccountAttribs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAccountAttribsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchAccountAttribsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchAccountAttribsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAccountAttribsCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchAccountSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchAccountSegmentsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchAccountSegmentsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchAccountSegmentsCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchAccountSegmentsSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("T4JO");




var fetchTeamMemberAttribs = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_TEAMMEMBER_ATTRIBS */]);
var fetchTeamMemberAttribsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* FETCH_TEAMMEMBER_ATTRIBS_PENDING */]);
var fetchTeamMemberAttribsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* FETCH_TEAMMEMBER_ATTRIBS_SUCCESS */]);
var fetchTeamMemberAttribsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* FETCH_TEAMMEMBER_ATTRIBS_FAILED */]);
var fetchTeamMemberAttribsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_TEAMMEMBER_ATTRIBS_CANCELLED */]);

var fetchAccountAttribs = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_ACCOUNT_ATTRIBS */]);
var fetchAccountAttribsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_ACCOUNT_ATTRIBS_PENDING */]);
var fetchAccountAttribsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_ACCOUNT_ATTRIBS_SUCCESS */]);
var fetchAccountAttribsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_ACCOUNT_ATTRIBS_FAILED */]);
var fetchAccountAttribsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_ACCOUNT_ATTRIBS_CANCELLED */]);

var fetchAccountSegments = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_ACCOUNT_SEGMENTS */]);
var fetchAccountSegmentsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_ACCOUNT_SEGMENTS_PENDING */]);
var fetchAccountSegmentsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_ACCOUNT_SEGMENTS_FAILED */]);
var fetchAccountSegmentsCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_ACCOUNT_SEGMENTS_CANCELLED */]);
var fetchAccountSegmentsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_ACCOUNT_SEGMENTS_SUCCESS */]);

/***/ }),

/***/ "j5zp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "j8vl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OWNER_TOGGLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hydrateModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hydrateOwnerToggles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SalesforceCampaignMapping__ = __webpack_require__("mnbJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SalesforceActivityDataMapping__ = __webpack_require__("XsVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesforceEventDataMapping__ = __webpack_require__("d/UH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SalesforceTaskTypeSelect__ = __webpack_require__("EGTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MinimumCqlScoreWidget__ = __webpack_require__("QM6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IntegrationRetryDelay__ = __webpack_require__("KGSq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__ = __webpack_require__("UKWd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };












var OWNER_TOGGLES = [{
  type: 'routeContactToSalesforceAccountOwner',
  value: true,
  label: 'Find the Contact by email, use their Account’s owner'
}, {
  type: 'routeContactToSalesforceContactOwner',
  value: true,
  label: 'Find the Contact by email, use the Contact owner'
}, {
  type: 'routeContactToSalesforceAccountOwnerByDomain',
  value: false,
  label: 'Find the Account whose website matches the email domain, use that Account’s owner'
}, {
  type: 'routeLeadToSalesforceLeadOwner',
  value: true,
  label: 'Find the Lead by email, use the Lead owner'
}];

var model = [{
  type: 'shouldOnlySyncQualifiedLeadsAndContactsToSalesforce',
  value: false,
  label: 'Set a minimum CQL score for synced contacts and conversations',
  description: 'Unchecked, Drift will sync all contacts and conversations to Salesforce except those that have been disqualified.',
  children: {
    autoExpand: true,
    label: 'Minimum CQL score',
    description: 'Drift will only sync conversations that have the selected CQL score or higher.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["i" /* withProps */])({
      integrationName: 'salesforce',
      setMinimumCQLScore: function setMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["W" /* setMinimumCqlScore */])(data);
      },
      getMinimumCQLScore: function getMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["A" /* getMinimumCqlScore */])(data);
      }
    })(__WEBPACK_IMPORTED_MODULE_4__MinimumCqlScoreWidget__["a" /* default */]),
    items: []
  }
}, {
  type: 'hasLeadCreationSynced',
  value: false,
  label: 'Sync leads from Drift to Salesforce',
  description: 'New Leads from Drift will be created in Salesforce as a lead record.',
  children: {
    label: 'Set Lead Owner',
    description: 'For every new Lead that Drift creates, we can set a Lead Owner based on the following conversation events in this order. If none are checked, we’ll leave the Lead Owner field blank.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["i" /* withProps */])({ type: 'leads' })(__WEBPACK_IMPORTED_MODULE_0__SalesforceCampaignMapping__["a" /* default */]),
    items: [{
      type: 'leadOwnerMeetingEnabled',
      label: 'Teammate with a scheduled meeting (if meeting scheduled)',
      value: false
    }, {
      type: 'leadOwnerRoutingEnabled',
      label: 'User who was last routed to (if routing occurred)',
      value: false
    }, {
      type: 'leadOwnerConversationClosedEnabled',
      label: 'User who closed conversation',
      value: false
    }]
  }
}, {
  type: 'hasContactCreationSynced',
  value: false,
  label: 'Sync contacts from Drift to Salesforce',
  description: 'New Contacts from Drift will be created in Salesforce as a contact record if we can find a suitable account to associate it with.',
  children: {
    label: 'Set Contact Owner',
    description: 'For every new Contact that Drift creates, we can set a Contact Owner based on the following conversation events in this order. If none are checked, we’ll leave the Contact Owner field blank.',
    topLevelAdvancedItems: [{
      type: 'shouldAlwaysCreateContactRecord',
      value: false,
      label: 'Create new contacts without accounts',
      description: 'Create a new contact even if we can\'t find a suitable account to associate it with.'
    }],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["i" /* withProps */])({ type: 'contacts' })(__WEBPACK_IMPORTED_MODULE_0__SalesforceCampaignMapping__["a" /* default */]),
    items: [{
      type: 'leadOwnerMeetingEnabled',
      label: 'Teammate with a scheduled meeting (if meeting scheduled)',
      value: false
    }, {
      type: 'leadOwnerRoutingEnabled',
      label: 'User who was last routed to (if routing occurred)',
      value: false
    }, {
      type: 'leadOwnerConversationClosedEnabled',
      label: 'User who closed conversation',
      value: false
    }]
  }
}, {
  type: 'hasAnyActivitySyncEnabled',
  value: false,
  label: 'Send Drift chat activity data to Salesforce',
  description: 'When a lead or contact has a conversation with you in Drift, we’ll add activity to their Salesforce record with the full chat transcript attached when their conversation is closed.',
  children: {
    label: 'Set Activity Owner',
    description: 'For every new conversation in Drift, we create an activity in Salesforce with an Activity Owner based on the following conversation events in this order. If none are checked, we’ll leave the Activity Owner field blank. ',
    topLevelAdvancedItems: [],
    advancedComponent: __WEBPACK_IMPORTED_MODULE_1__SalesforceActivityDataMapping__["a" /* default */],
    items: [{
      type: 'activityOwnerMeetingEnabled',
      value: false,
      label: 'User who scheduled a meeting (if a meeting was scheduled)'
    }, {
      type: 'activityOwnerRoutingEnabled',
      value: false,
      label: 'User who was last routed to (if routing occurred)'
    }, {
      type: 'activityOwnerConversationClosedEnabled',
      value: false,
      label: 'User who closed the conversation'
    }]
  }
}, {
  type: 'meetingBookedInChatBecomesEventEnabled',
  value: false,
  label: 'Send meetings booked in Drift to Salesforce',
  description: 'When a lead or contact books a meeting with you in Drift, we’ll add an event to their Salesforce record',
  children: {
    label: 'Set Event Type',
    description: 'When Drift sends a meeting to Salesforce, we’ll set the event type to what you select below. These are pulled from your configured event fields in Salesforce.',
    topLevelAdvancedItems: [{
      type: 'holdMeetingTillConvoClosed',
      label: 'Only sync meetings when a conversation closes.',
      description: 'Meetings will be sent to Salesforce when the conversation closes instead of the moment they\'re booked',
      value: false
    }],
    advancedComponent: __WEBPACK_IMPORTED_MODULE_2__SalesforceEventDataMapping__["a" /* default */],
    items: []
  }
}, {
  type: 'hasPhoneSyncEnabled',
  value: false,
  label: 'Send Drift call activity to Salesforce',
  description: 'When you make a call in Drift, we’ll add a task to Salesforce once the call ends.',
  children: {
    label: 'Set Task Type',
    description: 'When Drift sends call activity to Salesforce, we’ll set the task type to what you select below. These are pulled from your configured task fields in Salesforce.',
    advancedComponent: __WEBPACK_IMPORTED_MODULE_3__SalesforceTaskTypeSelect__["a" /* default */],
    items: []
  }
}, {
  type: 'salesforceRetryDelayEnabled',
  value: true,
  label: 'Retry attachment for events and tasks after a delay',
  description: 'If we fail to attach a meeting event or conversation task to a contact or lead, we\'ll try again after this delay',
  children: {
    label: 'Set retry delay',
    description: 'Enter the amount of minutes that you want us to wait until we attempt to retry our event/task attachment',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_8_recompose__["i" /* withProps */])({
      integration: "salesforce",
      getDelay: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["v" /* getIntegrationRetryDelay */],
      setDelay: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_api__["U" /* setIntegrationRetryDelay */] })(__WEBPACK_IMPORTED_MODULE_5__IntegrationRetryDelay__["a" /* default */]),
    items: []
  }
}, {
  type: 'shouldAlwaysCreateNewRecord',
  value: false,
  label: 'Always create new Salesforce records',
  description: 'Don\'t check for existing leads/contacts when creating conversation and/or meeting activities; instead create a new record every time',
  confirmation: 'This setting will cause Drift to create duplicate records in Salesforce and is only recommended if you have a process in place to handle these duplicates.'
}];

var hydrateModel = function hydrateModel(toggles, hasContactSync) {
  var phoneSyncSettingId = 'hasPhoneSyncEnabled';
  var contactSyncSettingIds = ['shouldOnlySyncQualifiedLeadsAndContactsToSalesforce', 'hasLeadCreationSynced', 'hasContactCreationSynced'];

  var modelCopy = [].concat(model);

  if (!__WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('has_drift_voice')) {
    modelCopy = modelCopy.filter(function (toggle) {
      return toggle.type !== phoneSyncSettingId;
    });
  }
  if (!hasContactSync) {
    modelCopy = modelCopy.filter(function (toggle) {
      return !contactSyncSettingIds.includes(toggle.type);
    });
  }

  return modelCopy.map(function (topLevel) {
    var updatedToggle = _extends({}, topLevel);

    updatedToggle.value = toggles[topLevel.type];
    if (!!topLevel.children && topLevel.children.items.length > 0) {
      updatedToggle.children.items = addValuesToToggles(topLevel.children.items, toggles);
    }
    if (hasTopLevelAdvancedItems(topLevel)) {
      updatedToggle.children.topLevelAdvancedItems = addValuesToToggles(topLevel.children.topLevelAdvancedItems, toggles);
    }

    return updatedToggle;
  });
};

var hasTopLevelAdvancedItems = function hasTopLevelAdvancedItems(toggle) {
  return !!toggle.children && !!toggle.children.topLevelAdvancedItems && toggle.children.topLevelAdvancedItems.length > 0;
};

var addValuesToToggles = function addValuesToToggles(toggles, fullToggles) {
  return toggles.map(function (secondLevel) {
    var updatedSecondaryToggle = _extends({}, secondLevel);
    updatedSecondaryToggle.value = !!fullToggles[secondLevel.type];
    return updatedSecondaryToggle;
  });
};

var hydrateOwnerToggles = function hydrateOwnerToggles(toggles) {
  return OWNER_TOGGLES.map(function (toggle) {
    var newToggle = _extends({}, toggle);
    newToggle.value = toggles[toggle.type];
    return newToggle;
  });
};

/***/ }),

/***/ "jAlB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackPageView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identifyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_store__ = __webpack_require__("Tvnw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Port of the tracking interface in traffic-control




var trackPageView = function trackPageView(pageName) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var currentUser = __WEBPACK_IMPORTED_MODULE_0_app_modules_user__["c" /* selectors */].currentUser(__WEBPACK_IMPORTED_MODULE_2_containers_store__["a" /* default */].getState());

  if (!window.analytics || __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["T" /* SEGMENT_TRACKING_BLACKLIST */].includes(currentUser.orgId)) {
    return;
  }

  window.analytics && window.analytics.page(pageName, properties);
};

var identifyUser = function identifyUser(currentUser) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!currentUser || !currentUser.orgId || !currentUser.id) {
    return;
  }

  if (currentUser.userJwt && window.drift && window.drift.setUserJwt) {
    window.drift.setUserJwt(currentUser.userJwt);
  }

  return window.analytics && window.analytics.identify(currentUser.orgId + '-' + currentUser.id, _extends({
    name: currentUser.name,
    email: currentUser.email,
    role: currentUser.role,
    orgId: currentUser.orgId
  }, traits), {
    integrations: { drift: { userJwt: currentUser.userJwt } }
  });
};

var trackEvent = function trackEvent(eventName, properties) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_0_app_modules_user__["c" /* selectors */].currentUser(__WEBPACK_IMPORTED_MODULE_2_containers_store__["a" /* default */].getState());

  if (!window.analytics || __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["T" /* SEGMENT_TRACKING_BLACKLIST */].includes(currentUser.orgId)) {
    return;
  }
  var propertiesWithEmail = _extends({}, { email: currentUser.email, orgId: currentUser.orgId }, properties);
  window.analytics.track(eventName, propertiesWithEmail);
};

/***/ }),

/***/ "jBdL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jGIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AssistantConfigOrgSettings = function (_React$Component) {
  _inherits(AssistantConfigOrgSettings, _React$Component);

  function AssistantConfigOrgSettings() {
    _classCallCheck(this, AssistantConfigOrgSettings);

    return _possibleConstructorReturn(this, (AssistantConfigOrgSettings.__proto__ || Object.getPrototypeOf(AssistantConfigOrgSettings)).apply(this, arguments));
  }

  _createClass(AssistantConfigOrgSettings, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          assistantSetting = _props.assistantSetting,
          orgSettings = _props.orgSettings,
          handleEdit = _props.handleEdit,
          hasPassedOnboarding = _props.hasPassedOnboarding,
          sfFieldTitle = _props.sfFieldTitle;


      var sfLeadObject = orgSettings.get('salesforceLeadObject');
      var sfLeadField = orgSettings.get('sfLeadFields').keySeq().first();
      var sfEventObject = orgSettings.get('salesforceEventObject');
      var sfEventField = orgSettings.get('sfEventFields').keySeq().first();
      var openOps = orgSettings.get('followUpWithOpenOps');

      var sfLeadFieldValues = sfLeadField ? orgSettings.getIn(['sfLeadFields', sfLeadField]) : [];
      var sfLeadFieldValueText = sfLeadFieldValues.size > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '\xA0is\xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          sfLeadFieldValues.join(', ')
        )
      ) : '';
      var sfEventFieldValues = sfEventField ? orgSettings.getIn(['sfEventFields', sfEventField]) : [];
      var sfEventFieldValueText = sfEventFieldValues.size > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        '\xA0is\xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          sfEventFieldValues.join(', ')
        )
      ) : '';

      var connectedIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
        className: 'status-icon',
        src: __webpack_require__("+570")
      });

      var customSalesforceLeadConditions = sfLeadField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'assistant-config-custom-settings' },
        'With the property: ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          sfFieldTitle
        ),
        sfLeadFieldValues.size > 0 && sfLeadFieldValueText
      );
      var customSalesforceEventConditions = sfEventField && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'assistant-config-custom-settings' },
        'With the property: ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          sfFieldTitle
        ),
        sfEventFieldValues.size > 0 && sfEventFieldValueText
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'assistant-config-settings-view' },
        assistantSetting === 'salesforceMapping' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-header' },
            hasPassedOnboarding && connectedIcon,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'The Drift Assistant will remind your team about:'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              null,
              'Salesforce ',
              sfLeadObject.toLocaleLowerCase(),
              's',
              customSalesforceLeadConditions
            ),
            openOps && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              null,
              'Open Opportunities'
            )
          )
        ),
        assistantSetting === 'salesforceActivity' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'list-header' },
            hasPassedOnboarding && connectedIcon,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'The Drift Assistant will know a demo\u2019s been held on:'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'ul',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              null,
              'Salesforce ',
              sfEventObject.toLocaleLowerCase(),
              's',
              customSalesforceEventConditions
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          {
            type: 'secondary',
            onClick: function onClick() {
              return handleEdit({ isEditingValue: true, isSFDCOutOfSyncValue: false });
            }
          },
          'Configure'
        )
      );
    }
  }]);

  return AssistantConfigOrgSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var SalesforceOutOfSyncError = function SalesforceOutOfSyncError(props) {
  var assistantSetting = props.assistantSetting,
      handleEdit = props.handleEdit;

  var skillDetails = assistantSetting === 'salesforceMapping' ? 'meeting reminder skills' : 'meeting reminder skills to follow up with next steps after demos';

  var disconnectedIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
    className: 'status-icon',
    src: __webpack_require__("95qH")
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'assistant-config-settings-view' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'SFDC-error-state' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'list-header' },
        disconnectedIcon,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Oh no! The original mappings for your Drift Assistant',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'no longer match your Salesforce account'
          ),
          '.'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'error-message-info' },
        'You need to reconfigure the Drift Assistant so your team can keep using the ',
        skillDetails,
        '.'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
      {
        type: 'secondary',
        onClick: function onClick() {
          return handleEdit({ isEditingValue: true, isSFDCOutOfSyncValue: true });
        }
      },
      'Configure'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return !props.orgSettings;
}, __WEBPACK_IMPORTED_MODULE_1_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return props.salesforceOutOfSync;
}, Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["f" /* renderComponent */])(SalesforceOutOfSyncError)))(AssistantConfigOrgSettings));

/***/ }),

/***/ "jKHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__ = __webpack_require__("9hk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("cbE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var GatedState = function GatedState(_ref) {
  var gatedOnClick = _ref.gatedOnClick;
  return React.createElement(
    'div',
    { className: 'gated-custom-meeting-times', onClick: gatedOnClick },
    React.createElement(
      'div',
      { className: 'helper-text' },
      'Upgrade your account to access ',
      React.createElement(
        'b',
        null,
        'unlimited meeting types'
      ),
      '. You\u2019ll be able to book Drift Meetings of different lengths so you can only spend your time with the leads that matter most.'
    ),
    React.createElement(
      'div',
      { className: 'gated-component-wrapper' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__["a" /* default */], { key: 'gated1', gated: true, settings: {
          slug: 'sdc',
          duration: 15,
          name: "Short Discovery Call"
        } })
    ),
    React.createElement(
      'div',
      { className: 'gated-component-wrapper' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__["a" /* default */], { key: 'gated2', gated: true, settings: {
          slug: 'platinum',
          duration: 60,
          name: "Platinum Customer Kickoff"
        } })
    ),
    React.createElement(
      'div',
      { className: 'PremiumOverlay__Banner' },
      'Upgrade'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GatedState);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "jLuP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return coerceToValidHex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditorCtaButtonModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_color__ = __webpack_require__("orX9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TinyEditorModal__ = __webpack_require__("+qeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("l8Pp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Ns++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









// The color picker removes leading zeroes when storing hex values,
// so this ensures we had a valid hex value in all cases.
var coerceToValidHex = function coerceToValidHex(hexString) {
  // Return early if string is valid hex ( e.g. #02546e ).
  if (hexString.length === 7) {
    return hexString;
  } else {
    return '#' + hexString.substring(1, hexString.length).padStart(6, '0');
  }
};

var ButtonEditContentForm = function ButtonEditContentForm(_ref) {
  var buttonCopy = _ref.buttonCopy,
      setButtonCopy = _ref.setButtonCopy,
      linkValue = _ref.linkValue,
      setLinkValue = _ref.setLinkValue,
      setLinkToType = _ref.setLinkToType,
      linkToType = _ref.linkToType,
      urlInputSetup = _ref.urlInputSetup;
  return React.createElement(
    'div',
    { className: 'drift-form' },
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Button Text'
      ),
      React.createElement('input', { className: 'tiny-button-modal-form-input', type: 'text', value: buttonCopy, onChange: function onChange(e) {
          return setButtonCopy(e.target.value);
        } })
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Link To'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: linkToType, onChange: function onChange(e) {
            return setLinkToType(e.target.value);
          } },
        React.createElement(
          'option',
          { value: __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LinkToTypes */].WEB_ADDRESS },
          __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LinkToTypes */].WEB_ADDRESS
        ),
        React.createElement(
          'option',
          { value: __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LinkToTypes */].EMAIL },
          __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LinkToTypes */].EMAIL
        )
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        urlInputSetup.label
      ),
      React.createElement('input', { className: 'tiny-button-modal-form-input', type: 'text', placeholder: urlInputSetup.placeholder, value: linkValue, onChange: function onChange(e) {
          return setLinkValue(e.target.value);
        } })
    )
  );
};

var ButtonEditStyleForm = function ButtonEditStyleForm(_ref2) {
  var borderRadius = _ref2.borderRadius,
      setBorderRadius = _ref2.setBorderRadius,
      bgColorHex = _ref2.bgColorHex,
      setBgColorHex = _ref2.setBgColorHex,
      textColorHex = _ref2.textColorHex,
      setTextColorHex = _ref2.setTextColorHex,
      letterSpacing = _ref2.letterSpacing,
      setLetterSpacing = _ref2.setLetterSpacing,
      paddingSize = _ref2.paddingSize,
      setPaddingSize = _ref2.setPaddingSize,
      textSize = _ref2.textSize,
      setTextSize = _ref2.setTextSize,
      displayBgColorPicker = _ref2.displayBgColorPicker,
      openBgColorPicker = _ref2.openBgColorPicker,
      closeBgColorPicker = _ref2.closeBgColorPicker,
      displayTextColorPicker = _ref2.displayTextColorPicker,
      openTextColorPicker = _ref2.openTextColorPicker,
      closeTextColorPicker = _ref2.closeTextColorPicker;
  return React.createElement(
    'div',
    { className: 'drift-form' },
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Border Radius'
      ),
      React.createElement('input', { type: 'number', className: 'tiny-button-modal-form-input tiny-modal-form-small-text-input', value: borderRadius, onChange: function onChange(e) {
          return setBorderRadius(e.target.value);
        } })
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Background Color'
      ),
      displayBgColorPicker && React.createElement(
        'div',
        { className: 'tiny-button-modal-color-picker-popover' },
        React.createElement('div', { className: 'tiny-button-modal-color-picker-cover', onClick: closeBgColorPicker }),
        React.createElement(
          'div',
          { className: 'tiny-buttom-modal-color-picker-wrapper' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_color__["ChromePicker"], {
            color: coerceToValidHex(bgColorHex),
            onChangeComplete: function onChangeComplete(c) {
              setBgColorHex(coerceToValidHex(c.hex));
            },
            disableAlpha: true
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'tiny-button-modal-form-color-preview', onClick: openBgColorPicker },
        React.createElement('div', { style: { backgroundColor: coerceToValidHex(bgColorHex) }, className: 'tiny-button-modal-form-color-preview-square' }),
        coerceToValidHex(bgColorHex)
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Text Color'
      ),
      displayTextColorPicker && React.createElement(
        'div',
        { className: 'tiny-button-modal-color-picker-popover' },
        React.createElement('div', { className: 'tiny-button-modal-color-picker-cover', onClick: closeTextColorPicker }),
        React.createElement(
          'div',
          { className: 'tiny-buttom-modal-color-picker-wrapper' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_color__["ChromePicker"], {
            color: textColorHex,
            onChangeComplete: function onChangeComplete(c) {
              setTextColorHex(c.hex);
            },
            disableAlpha: true
          })
        )
      ),
      React.createElement(
        'div',
        { className: 'tiny-button-modal-form-color-preview', onClick: openTextColorPicker },
        React.createElement('div', { style: { backgroundColor: textColorHex }, className: 'tiny-button-modal-form-color-preview-square' }),
        textColorHex
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Spacing'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: letterSpacing, onChange: function onChange(e) {
            return setLetterSpacing(e.target.value);
          } },
        Object.entries(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* SpacingSizes */]).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              name = _ref4[0],
              size = _ref4[1];

          return React.createElement(
            'option',
            { key: size, value: size },
            name
          );
        })
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Text Size'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: textSize, onChange: function onChange(e) {
            return setTextSize(e.target.value);
          } },
        __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* PixelSizes */].map(function (size) {
          return React.createElement(
            'option',
            { key: size, value: size },
            size
          );
        })
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Padding'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: paddingSize, onChange: function onChange(e) {
            return setPaddingSize(e.target.value);
          } },
        __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* PixelSizes */].map(function (size) {
          return React.createElement(
            'option',
            { key: size, value: size },
            size
          );
        })
      )
    )
  );
};

var ButtonEditSettingsForm = function ButtonEditSettingsForm(_ref5) {
  var buttonAlignment = _ref5.buttonAlignment,
      setButtonAlignment = _ref5.setButtonAlignment,
      buttonWidth = _ref5.buttonWidth,
      setButtonWidth = _ref5.setButtonWidth;
  return React.createElement(
    'div',
    { className: 'drift-form' },
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Align Button'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: buttonAlignment, onChange: function onChange(e) {
            return setButtonAlignment(e.target.value);
          } },
        __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* Alignments */].map(function (alignment) {
          return React.createElement(
            'option',
            { key: alignment, value: alignment },
            alignment
          );
        })
      )
    ),
    React.createElement(
      'fieldset',
      null,
      React.createElement(
        'label',
        null,
        'Width'
      ),
      React.createElement(
        'select',
        { className: 'tiny-button-modal-form-input', value: buttonWidth, onChange: function onChange(e) {
            return setButtonWidth(e.target.value);
          } },
        Object.entries(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* Widths */]).map(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 2),
              name = _ref7[0],
              size = _ref7[1];

          return React.createElement(
            'option',
            { key: size, value: size },
            name
          );
        })
      )
    )
  );
};

var ButtonModalEdit = function ButtonModalEdit(_ref8) {
  var activeEditTab = _ref8.activeEditTab,
      onContentTabClick = _ref8.onContentTabClick,
      onStyleTabClick = _ref8.onStyleTabClick,
      onSettingsTabClick = _ref8.onSettingsTabClick,
      rest = _objectWithoutProperties(_ref8, ['activeEditTab', 'onContentTabClick', 'onStyleTabClick', 'onSettingsTabClick']);

  return React.createElement(
    'div',
    { className: 'tiny-button-modal-section tiny-button-modal-edit-section' },
    React.createElement(
      'div',
      { className: 'tiny-button-modal-edit-tabs' },
      React.createElement(
        'span',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("tiny-button-modal-edit-tab", { active: activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].CONTENT }),
          onClick: onContentTabClick
        },
        'Content'
      ),
      React.createElement(
        'span',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("tiny-button-modal-edit-tab", { active: activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].STYLE }),
          onClick: onStyleTabClick
        },
        'Style'
      ),
      React.createElement(
        'span',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()("tiny-button-modal-edit-tab", { active: activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].SETTINGS }),
          onClick: onSettingsTabClick
        },
        'Settings'
      )
    ),
    React.createElement(
      'div',
      { className: 'tiny-button-modal-edit-form' },
      activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].CONTENT && React.createElement(ButtonEditContentForm, rest),
      activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].STYLE && React.createElement(ButtonEditStyleForm, rest),
      activeEditTab === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ButtonEditTabs */].SETTINGS && React.createElement(ButtonEditSettingsForm, rest)
    )
  );
};

var ButtonModalPreview = function ButtonModalPreview(_ref9) {
  var buttonCopy = _ref9.buttonCopy,
      buttonStyle = _ref9.buttonStyle,
      buttonContainerStyle = _ref9.buttonContainerStyle,
      previewButtonLink = _ref9.previewButtonLink;
  return React.createElement(
    'div',
    { className: 'tiny-button-modal-section tiny-button-modal-preview-section' },
    React.createElement(
      'div',
      { style: buttonContainerStyle },
      React.createElement(
        'a',
        { target: '_blank', rel: 'nofollow', href: previewButtonLink, style: buttonStyle },
        buttonCopy
      )
    )
  );
};

var EditorCtaButtonModal = function EditorCtaButtonModal(_ref10) {
  var hideCtaButtonModal = _ref10.hideCtaButtonModal,
      onInsert = _ref10.onInsert,
      existingBtnFound = _ref10.existingBtnFound,
      props = _objectWithoutProperties(_ref10, ['hideCtaButtonModal', 'onInsert', 'existingBtnFound']);

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2__TinyEditorModal__["a" /* default */],
    { title: (existingBtnFound ? 'Update' : 'Insert') + ' Button', onClose: hideCtaButtonModal, className: 'tiny-button-modal-content' },
    React.createElement(
      'div',
      { className: 'playbook-button-modal' },
      React.createElement(
        'div',
        { className: 'tiny-button-modal' },
        React.createElement(ButtonModalEdit, props),
        React.createElement(ButtonModalPreview, props)
      ),
      React.createElement(
        'div',
        { className: 'tiny-button-modal-footer' },
        React.createElement(
          'div',
          { className: 'tiny-button-modal-footer-button drift-button drift-button-primary', onClick: onInsert },
          existingBtnFound ? 'Update' : 'Insert'
        ),
        React.createElement(
          'div',
          { className: 'tiny-button-modal-footer-button drift-button drift-button-secondary', onClick: hideCtaButtonModal },
          'Cancel'
        )
      )
    )
  );
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "jQsl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("nu3i");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchAttributes */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchAttributesPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchAttributesFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchAttributesCancelled */], __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* receiveAttributes */]), function (state, action) {
  return action.type;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var properties = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* receiveAttributes */], function (state, action) {
  return action.payload.properties;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])());

var events = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["e" /* receiveAttributes */], function (state, action) {
  return action.payload.events;
}), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_immutable__["combineReducers"])({ status: status, properties: properties, events: events }));

/***/ }),

/***/ "jQzK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jUKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUTOVER_SETTINGS_ROUTES; });
//once your settings-web page is fully developed and tested, add it here to ensure the nav bar and router redirect to the new page
//you will also have to change your Route to a Redirect in /scripts/app/routes/SettingsRoutes.js
var CUTOVER_SETTINGS_ROUTES = Object.freeze([{ path: '/account' }, { path: '/company' }, { path: '/security' }, { path: '/consent' }, { path: '/help' }, { path: '/widget' }, { path: '/team' }, { path: '/billing' }, { path: '/email' }]);

/***/ }),

/***/ "jYTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schema__ = __webpack_require__("BEyV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_api_FileAPI__ = __webpack_require__("0OV4");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var parsePlaybooks = function parsePlaybooks(res) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__schema__["b" /* playbookListNormalizer */])(res.map(function (pb) {
    var targetingDisplay = _.get(pb, 'targeting.display');
    if (!!targetingDisplay) {
      pb.targeting.display = pb.targeting.display.map(function (conditionSet) {
        return {
          conditions: conditionSet.map(function (condition) {
            return _extends({ id: Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* weakUuid */])() }, condition);
          }),
          id: Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* weakUuid */])()
        };
      });
    }
    return pb;
  }));
};
var parsePlaybook = function parsePlaybook(res) {
  // TODO: get rid of this code once the backend returns signatures with an "id" property
  var isSignature = res.reportType === 'SIGNATURE';
  var newActions = res.actions;
  if (isSignature) {
    newActions = [{
      id: res.actions[0].id,
      actionType: res.actions[0].actionType,
      action: {
        signatureActions: res.actions[0].action.signatureActions.map(function (sig) {
          return _.assign(sig, { id: sig.signatureId });
        })
      }
    }];
  }
  var targetingDisplay = _.get(res, 'targeting.display');
  if (!!targetingDisplay) {
    var newTargeting = _.assign(res.targeting, { display: targetingDisplay.map(function (conditionSet) {
        return {
          conditions: conditionSet.map(function (condition) {
            return _extends({ id: Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* weakUuid */])() }, condition);
          }),
          id: Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* weakUuid */])()
        };
      }) });
    return Object(__WEBPACK_IMPORTED_MODULE_4__schema__["c" /* playbookNormalizer */])(_.assign(res, { targeting: newTargeting }, { actions: newActions }));
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_4__schema__["c" /* playbookNormalizer */])(_.assign(res, { actions: newActions }));
  }
};

var api = {
  fetchChatActive: function fetchChatActive() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ status: ['ENABLED', 'DISABLED'], reportType: __WEBPACK_IMPORTED_MODULE_5__constants__["_293" /* chatPlaybookReportTypes */], limited: true })).checkStatus().retryWithBackoff().mapResponse(parsePlaybooks).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  search: function search(status) {
    var parse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks' + (!!status ? '?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ status: status }) : '')).checkStatus().retryWithBackoff().mapResponse(function (response) {
      return parse ? parsePlaybooks(response) : response;
    }).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },

  // deprecate & refactor this in favor of search w/status arg ^^
  fetchEnabled: function fetchEnabled() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks?status=' + __WEBPACK_IMPORTED_MODULE_5__constants__["_141" /* PlaybookStatus */].ENABLED).checkStatus().retryWithBackoff().mapResponse(parsePlaybooks).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchCardinality: function fetchCardinality(_ref) {
    var orgId = _ref.orgId,
        userListIds = _ref.userListIds,
        excludedUserListIds = _ref.excludedUserListIds,
        smartFilters = _ref.smartFilters,
        isEmailPlaybook = _ref.isEmailPlaybook;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxCustomerAPI"].post('/user_lists/count/inc_exc', {
      inclusionLists: userListIds.toJS(),
      exclusionLists: excludedUserListIds.toJS(),
      smartFilters: smartFilters,
      orgId: orgId,
      isEmailCampaign: isEmailPlaybook
    }).checkStatus().retryWithBackoff();
  },
  counts: function counts() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks/counts').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  enroll: function enroll(playbookId, endUserId, action) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + playbookId + '/manual_enroll', { endUserId: endUserId, action: action });
  },
  unenroll: function unenroll(endUserId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/unenroll', { endUserId: endUserId }).checkStatus().retryWithBackoff();
  },
  fetchEnrolledPlaybookId: function fetchEnrolledPlaybookId(email) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/sequences/for/' + email);
  },
  fetchPlaybookByCampaignIdUntouched: function fetchPlaybookByCampaignIdUntouched(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/campaigns/' + id + '/playbook').checkStatus().retryWithBackoff().map(function (_ref2) {
      var response = _ref2.response;
      return response;
    });
  },
  fetchPlaybookByCampaignId: function fetchPlaybookByCampaignId(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/campaigns/' + id + '/playbook').checkStatus().retryWithBackoff().mapResponse(function (res) {
      return parsePlaybooks([res]);
    }).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchPlaybookByInteractionId: function fetchPlaybookByInteractionId(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks/by_interaction_id/' + id).checkStatus().retryWithBackoff().mapResponse(function (res) {
      return parsePlaybooks([res]);
    }).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetch: function fetch(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks/' + id).checkStatus().retryWithBackoff().mapResponse(parsePlaybook).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchPersonalized: function fetchPersonalized(id, endUserId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["ConversationAPI"].get('/playbooks/' + id).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]).then(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  update: function update(playbook) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/playbooks', playbook).checkStatus().retryWithBackoff().mapResponse(parsePlaybook).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  updateStatus: function updateStatus(id, status) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/playbooks/' + id + '/' + status).checkStatus().retryWithBackoff(undefined, undefined, [400, 403, 404]).mapResponse(parsePlaybook).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  create: function create(type) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ type: type })).checkStatus().retryWithBackoff().mapResponse(parsePlaybook).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  clone: function clone(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + id + '/clone').checkStatus().retryWithBackoff().mapResponse(parsePlaybook).map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  reorder: function reorder(orderedPlaybookIds) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/playbooks/reorder', orderedPlaybookIds).checkStatus().retryWithBackoff();
  },
  byIds: function byIds(playbookIds) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/by_id', playbookIds).checkStatus().retryWithBackoff().mapResponse(function (response) {
      return response;
    });
  },

  // wrapping in RX here b/c Targeting API is SUPER OLD
  fetchTarget: function fetchTarget(id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/targets/' + id).checkStatus().retryWithBackoff().mapResponse();
  },
  sendTestEmail: function sendTestEmail(id, actionId, email, emailId, playbook) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + id + '/test_email/' + actionId + '/v2', { emails: [email], emailId: emailId, playbookEdit: playbook }).checkStatus().retryWithBackoff();
  },
  sendTestSequence: function sendTestSequence(playbookId, actionId, email, playbook) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + playbookId + '/test_email_sequence/' + actionId + '/v2', { emails: [email], playbookEdit: playbook, delayInSeconds: 240 }).checkStatus().retryWithBackoff();
  },
  fetchDataPreviewEmail: function fetchDataPreviewEmail(templateBody) {
    var userListIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var campaignId = arguments[2];
    var userId = arguments[3];

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/template_preview', { templateBody: templateBody, userListIds: userListIds, campaignId: campaignId, userId: userId }).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  notify: function notify(id, userIds) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + id + '/notify', { userIds: userIds }).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  fetchEnrolledSequenceCount: function fetchEnrolledSequenceCount() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/sequences/sends').checkStatus().retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  fetchPlaybookForEndUser: function fetchPlaybookForEndUser(options) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks/' + options.playbookId + '/for_end_user?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ endUserId: options.email })).retryWithBackoff().mapResponse(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  uploadImage: function uploadImage(file) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_7_app_api_FileAPI__["a" /* upload */](file)).retryWithBackoff();
  },
  fetchPlaybooksByGatedPlan: function fetchPlaybooksByGatedPlan() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks/playbooks_by_gate').checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  fetchSignatureMultiBannerPreviewForPlaybook: function fetchSignatureMultiBannerPreviewForPlaybook(_ref3) {
    var userId = _ref3.userId,
        playbook = _ref3.playbook,
        isPlaybookEditor = _ref3.isPlaybookEditor;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/signature_preview/' + userId + '/v2' + (isPlaybookEditor ? '?isPlaybookEditor=true' : ''), playbook).checkStatus().map(function (res) {
      return res.response;
    });
  },
  createInitialWelcomePlaybooks: function createInitialWelcomePlaybooks(_ref4) {
    var onlineMsg = _ref4.onlineMsg,
        offlineMsg = _ref4.offlineMsg;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/welcome_messages', { onlineText: onlineMsg, offlineText: offlineMsg }).checkStatus().retryWithBackoff(2);
  },
  fetchPlaybooksByReportType: function fetchPlaybooksByReportType(_ref5) {
    var reportType = _ref5.reportType;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/playbooks?' + Object(__WEBPACK_IMPORTED_MODULE_3_utils_Helpers__["d" /* encodeQueryData */])({ limited: true, reportType: reportType })).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  enableAllPlaybooksByReportType: function enableAllPlaybooksByReportType(_ref6) {
    var orgId = _ref6.orgId,
        reportType = _ref6.reportType;

    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/playbooks/' + orgId + '/enable_playbooks', reportType).checkStatus().retryWithBackoff().map(function (res) {
      return res.response;
    });
  },
  disableSalesSequenceById: function disableSalesSequenceById(playbookId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].post('/sequences/bulk_unenroll/' + playbookId).then(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["json"]);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "jYqW":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.408 10.448a1.584 1.584 0 0 1-1.816 0L1.583 5.542h15.834l-7.009 4.906zm7.009 6.969H1.583V7l7.009 4.966a1.568 1.568 0 0 0 1.816 0L17.417 7v10.417zM1.583 3.959C.71 3.959 0 4.667 0 5.542v11.875C0 18.29.71 19 1.583 19h15.834C18.29 19 19 18.29 19 17.417V5.542c0-.875-.709-1.583-1.583-1.583H1.583zm12.667-.792a.791.791 0 0 0 .792-.792v-.792a.791.791 0 1 0-1.584 0v.792c0 .438.355.792.792.792m-4.75 0a.791.791 0 0 0 .792-.792V.792a.791.791 0 1 0-1.584 0v1.583c0 .438.355.792.792.792m-4.75 0a.791.791 0 0 0 .792-.792v-.792a.791.791 0 1 0-1.584 0v.792c0 .438.355.792.792.792\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "jaNg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timeline__ = __webpack_require__("xlyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__attribute__ = __webpack_require__("94Ok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__segment__ = __webpack_require__("HRTS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("bNDg");
var _handleActions, _handleActions3, _handleActions4, _handleActions5, _handleActions6, _handleActions7, _handleActions8, _handleActions9, _handleActions10;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var statusById = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["r" /* fetchEndUserPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["m" /* fetchEndUserFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["B" /* receiveEndUser */]), function (state, action) {
  return state.set(action.payload.id, action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["p" /* fetchEndUserListPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["o" /* fetchEndUserListFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["q" /* fetchEndUserListSuccess */]), function (state, action) {
  var ids = action.payload.ids;

  return state.withMutations(function (_state) {
    return ids.reduce(function (result, id) {
      return result.set(id, action.type);
    }, _state);
  });
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var unsubscribedCount = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_7__actions__["z" /* fetchUnsubscribedCountSuccess */], function (state, action) {
  return action.payload;
}), 0);

var unsubscribed = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_7__actions__["d" /* checkUnsubscribedSuccess */], function (state, action) {
  return state.set('value', action.payload);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["T" /* unsubscribe */], __WEBPACK_IMPORTED_MODULE_7__actions__["Z" /* unsubscribeSuccess */]), function (state) {
  return state.set('value', true);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["T" /* unsubscribe */], __WEBPACK_IMPORTED_MODULE_7__actions__["W" /* unsubscribeById */], __WEBPACK_IMPORTED_MODULE_7__actions__["Y" /* unsubscribePending */], __WEBPACK_IMPORTED_MODULE_7__actions__["X" /* unsubscribeFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["Z" /* unsubscribeSuccess */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions3, __WEBPACK_IMPORTED_MODULE_7__actions__["X" /* unsubscribeFailed */], function (state, action) {
  var _action$payload = action.payload,
      response = _action$payload.response,
      status = _action$payload.status;

  if (status === 400) {
    return state.set('errorMessage', response.message);
  } else {
    return state.set('errorMessage', 'Something went wrong, please try again.');
  }
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["K" /* requestUnsubDeleteData */], __WEBPACK_IMPORTED_MODULE_7__actions__["M" /* requestUnsubDeleteDataPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["N" /* requestUnsubDeleteDataSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["L" /* requestUnsubDeleteDataFailed */]), function (state, action) {
  return state.set('requestUnsubDeleteDataStatus', action.type);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ value: false }));

var resubscribed = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions4 = {}, _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["O" /* resubscribe */], __WEBPACK_IMPORTED_MODULE_7__actions__["S" /* resubscribeSuccess */]), function (state) {
  return state.set('value', true);
}), _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["O" /* resubscribe */], __WEBPACK_IMPORTED_MODULE_7__actions__["R" /* resubscribePending */], __WEBPACK_IMPORTED_MODULE_7__actions__["Q" /* resubscribeFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["S" /* resubscribeSuccess */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_7__actions__["Q" /* resubscribeFailed */], function (state, action) {
  var _action$payload2 = action.payload,
      response = _action$payload2.response,
      status = _action$payload2.status;

  if (status === 400) {
    return state.set('errorMessage', response.message);
  } else {
    return state.set('errorMessage', 'Something went wrong, please try again.');
  }
}), _handleActions4), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ value: false }));

var byId = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_7__actions__["B" /* receiveEndUser */], function (state, action) {
  var existingEndUser = state[action.payload.id];
  var isNewerVersion = existingEndUser && action.payload.getIn(['attributes', '_end_user_version']) >= existingEndUser.getIn(['attributes', '_end_user_version']);
  if (!existingEndUser || isNewerVersion) {
    return state.set(action.payload.id, action.payload);
  }
  return state;
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_7__actions__["_0" /* updateCQL */], function (state, action) {
  var _action$payload3 = action.payload,
      endUserId = _action$payload3.endUserId,
      score = _action$payload3.score;

  return state.setIn([endUserId, 'attributes', '_cql_score'], score);
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_7__actions__["q" /* fetchEndUserListSuccess */], function (state, action) {
  var data = action.payload.data;

  return state.merge(Object(__WEBPACK_IMPORTED_MODULE_6_utils_immutable__["a" /* keyBy */])(data));
}), _handleActions5), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

var propDefs = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions6 = {}, _defineProperty(_handleActions6, __WEBPACK_IMPORTED_MODULE_7__actions__["i" /* createPropertyDefinitionPending */], function (state, action) {
  return state.setIn(['newlyCreated', action.payload], 'PENDING');
}), _defineProperty(_handleActions6, __WEBPACK_IMPORTED_MODULE_7__actions__["j" /* createPropertyDefinitionSuccess */], function (state, action) {
  return state.setIn(['newlyCreated', action.payload], 'CREATED');
}), _defineProperty(_handleActions6, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["g" /* createPropertyDefinitionCancelled */], __WEBPACK_IMPORTED_MODULE_7__actions__["h" /* createPropertyDefinitionFailed */]), function (state, action) {
  return state.setIn(['newlyCreated', action.payload.name], 'FAILED');
}), _handleActions6), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ newlyCreated: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])() }));

var following = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions7 = {}, _defineProperty(_handleActions7, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["v" /* fetchFollowingSuccess */], __WEBPACK_IMPORTED_MODULE_7__actions__["_10" /* updateFollowingSuccess */]), function (state, action) {
  return state.setIn(['data', action.payload.id], action.payload.following);
}), _defineProperty(_handleActions7, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["s" /* fetchFollowing */], __WEBPACK_IMPORTED_MODULE_7__actions__["u" /* fetchFollowingPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["t" /* fetchFollowingFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["v" /* fetchFollowingSuccess */]), function (state, action) {
  return state.setIn(['fetchFollowingState', action.payload.id], action.type);
}), _defineProperty(_handleActions7, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["_7" /* updateFollowing */], __WEBPACK_IMPORTED_MODULE_7__actions__["_9" /* updateFollowingPending */], __WEBPACK_IMPORTED_MODULE_7__actions__["_8" /* updateFollowingFailed */], __WEBPACK_IMPORTED_MODULE_7__actions__["_10" /* updateFollowingSuccess */]), function (state, action) {
  return state.setIn(['updateFollowingState', action.payload.id], action.type);
}), _handleActions7), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), fetchFollowingState: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), updateFollowingState: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])() }));

var retrieval = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions8 = {}, _defineProperty(_handleActions8, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["C" /* requestContactData */], __WEBPACK_IMPORTED_MODULE_7__actions__["E" /* requestContactDataPending */]), function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["G" /* REQUEST_CONTACT_DATA_PENDING */]);
}), _defineProperty(_handleActions8, __WEBPACK_IMPORTED_MODULE_7__actions__["F" /* requestContactDataSuccess */], function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["H" /* REQUEST_CONTACT_DATA_SUCCESS */]);
}), _defineProperty(_handleActions8, __WEBPACK_IMPORTED_MODULE_7__actions__["D" /* requestContactDataFailed */], function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["F" /* REQUEST_CONTACT_DATA_FAILED */]);
}), _handleActions8), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  status: null
}));
var deletion = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions9 = {}, _defineProperty(_handleActions9, Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_7__actions__["G" /* requestDeleteContactData */], __WEBPACK_IMPORTED_MODULE_7__actions__["I" /* requestDeleteContactDataPending */]), function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["K" /* REQUEST_DELETE_CONTACT_DATA_PENDING */]);
}), _defineProperty(_handleActions9, __WEBPACK_IMPORTED_MODULE_7__actions__["J" /* requestDeleteContactDataSuccess */], function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["L" /* REQUEST_DELETE_CONTACT_DATA_SUCCESS */]);
}), _defineProperty(_handleActions9, __WEBPACK_IMPORTED_MODULE_7__actions__["H" /* requestDeleteContactDataFailed */], function (state) {
  return state.set('status', __WEBPACK_IMPORTED_MODULE_8__constants__["J" /* REQUEST_DELETE_CONTACT_DATA_FAILED */]);
}), _handleActions9), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  status: null
}));

var activeEndUserChannels = Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions10 = {}, _defineProperty(_handleActions10, __WEBPACK_IMPORTED_MODULE_7__actions__["A" /* joinEndUserChannel */], function (state, action) {
  return state.add(action.payload);
}), _defineProperty(_handleActions10, __WEBPACK_IMPORTED_MODULE_7__actions__["e" /* closeEndUserChannel */], function (state, action) {
  return state.delete(action.payload);
}), _handleActions10), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  byId: byId,
  statusById: statusById,
  following: following,
  attributes: __WEBPACK_IMPORTED_MODULE_4__attribute__["a" /* default */],
  segments: __WEBPACK_IMPORTED_MODULE_5__segment__["a" /* default */],
  timeline: __WEBPACK_IMPORTED_MODULE_3__timeline__["a" /* default */],
  unsubscribed: unsubscribed,
  unsubscribedCount: unsubscribedCount,
  resubscribed: resubscribed,
  propDefs: propDefs,
  retrieval: retrieval,
  deletion: deletion,
  activeEndUserChannels: activeEndUserChannels
}));

/***/ }),

/***/ "jbeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WelcomeMessageBuilder__ = __webpack_require__("Oe5r");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WelcomeMessageBuilder__["a"]; });


/***/ }),

/***/ "jbnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var CompanyAPI = Marty.createStateSource({
  id: 'CompanyAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  fetchCompany: function fetchCompany(companyId) {
    return this.get({
      url: '/companies/' + companyId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCompanyListForOrgId: function fetchCompanyListForOrgId(orgId) {
    return this.get({
      url: '/organizations/' + orgId + '/companies',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchCompaniesByIds: function fetchCompaniesByIds(companyIds) {
    var query = companyIds.map(function (companyId) {
      return 'companyId=' + companyId;
    }).join('&');
    return this.get({
      url: '/companies?' + query,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateCompany: function updateCompany(companyId, companyParams) {
    return this.patch({
      url: '/companies/' + companyId,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(companyParams)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CompanyAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "jbvk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__("s8yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var makeMapStateToProps = function makeMapStateToProps() {

  return function (state, props) {
    var revealContext = Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state);

    return _extends({}, props, {
      hasFirmographics: revealContext.leadRoutingReveal || __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('routing_firmographics'),
      hasSalesforceRouting: __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('salesforce_routing_settings_enabled'),
      hasLeandataRouting: __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates(__WEBPACK_IMPORTED_MODULE_5_utils_Access__["b" /* Gates */].LEANDATA)
    });
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps))(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),

/***/ "jces":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LeandataAction = function (_PureComponent) {
  _inherits(LeandataAction, _PureComponent);

  function LeandataAction(props) {
    _classCallCheck(this, LeandataAction);

    var _this = _possibleConstructorReturn(this, (LeandataAction.__proto__ || Object.getPrototypeOf(LeandataAction)).call(this, props));

    _this.renderSelectOption = function (_ref) {
      var label = _ref.label;

      var iconName = 'user-circle';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "participant-type-dropdown-option" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { height: 14, width: 14, name: iconName }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          label
        )
      );
    };

    _this.state = {
      selectedValue: "default-settings"
    };
    return _this;
  }

  _createClass(LeandataAction, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "participant-actions" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "header",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            "Review Settings"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Please note that default settings for targeted accounts are populated below."
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "participant-action-selector" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "participant-action-selector-description" },
            "How do you want to add participants?"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], {
            multi: false,
            options: [{ label: "Add single teammate", value: "default-settings" }],
            optionRenderer: this.renderSelectOption,
            valueRenderer: this.renderSelectOption,
            autoFocus: true,
            clearable: false,
            value: this.state.selectedValue,
            disabled: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Automatically add the account owner to each new conversation."
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "participant-action-selector" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "participant-action-selector-description" },
            "Who do you want to add?"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], {
            multi: false,
            options: [{ label: "LeanData account owner", value: "default-settings" }],
            autoFocus: true,
            clearable: false,
            value: this.state.selectedValue,
            disabled: true
          })
        )
      );
    }
  }]);

  return LeandataAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (LeandataAction);

/***/ }),

/***/ "jdCl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jdNW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Button":"Button---11wCx"};

/***/ }),

/***/ "jfJP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BackButton__ = __webpack_require__("h2eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Customize_Online_HelpingTeamMemberSelection__ = __webpack_require__("iqf+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_WelcomeMessageBuilderContainer__ = __webpack_require__("mLv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_MessageInputs__ = __webpack_require__("O/gD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_PreviewButtons__ = __webpack_require__("fk1d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__("Oa/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PageTitle__ = __webpack_require__("dtTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl__ = __webpack_require__("OK4y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var NOTIFICATION_MESSAGE = 'The message settings of your Drift Widget have been updated!';

var PageDescription = function PageDescription() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'page-description' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      'Customize your Welcome Message to convey your own copy.'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { href: 'http://help.drift.com/customization/welcome-message', target: '_blank' },
      'Learn More'
    )
  );
};

var NewPageDescription = function NewPageDescription() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'page-description' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      null,
      'Customize how you greet your site visitors when they click on your Drift Widget.'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'a',
      { href: 'https://help.drift.com/article/setting-up-a-default-greeting/', target: '_blank' },
      'Learn More'
    )
  );
};

var DELAY_IN_MS = 1000;

var orNull = function orNull(input) {
  return input || null;
};

var WelcomeMessage = function (_Component) {
  _inherits(WelcomeMessage, _Component);

  function WelcomeMessage(props) {
    _classCallCheck(this, WelcomeMessage);

    var _this = _possibleConstructorReturn(this, (WelcomeMessage.__proto__ || Object.getPrototypeOf(WelcomeMessage)).call(this, props));

    _this.handleUserListModeChange = function (userListMode) {
      var orgSettings = _this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'userListMode'], userListMode);

      _this.patchOrgSettings(updatedOrgSettings, orgSettings);
    };

    _this.handleSelectUser = function (userIds) {
      var orgSettings = _this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'userList'], userIds);

      _this.patchOrgSettings(updatedOrgSettings, orgSettings);
    };

    _this.onToggleWelcomeMessage = _this.onToggleWelcomeMessage.bind(_this);
    _this.onPreviewStateChanged = _this.onPreviewStateChanged.bind(_this);
    _this.onAwayMessageChanged = _this.onAwayMessageChanged.bind(_this);
    _this.onWelcomeMessageChanged = _this.onWelcomeMessageChanged.bind(_this);
    _this.handleSelectUser = _this.handleSelectUser.bind(_this);
    _this.handleUserListModeChange = _this.handleUserListModeChange.bind(_this);
    _this.patchOrgSettingsDebounced = _.debounce(_this.patchOrgSettings, DELAY_IN_MS);

    _this.state = {
      previewState: __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* PreviewState */].ONLINE,
      welcomeMessage: props.orgSettings.theme.welcomeMessage,
      awayMessage: props.orgSettings.theme.awayMessage
    };
    return _this;
  }

  _createClass(WelcomeMessage, [{
    key: 'onPreviewStateChanged',
    value: function onPreviewStateChanged(previewState) {
      var _this2 = this;

      return function () {
        _this2.setState({ previewState: previewState });
      };
    }
  }, {
    key: 'onToggleWelcomeMessage',
    value: function onToggleWelcomeMessage(event) {
      var orgSettings = this.props.orgSettings;

      var showWelcomeMessage = event.target.checked;
      var updatedOrgSettings = orgSettings.setIn(['theme', 'showWelcomeMessage'], showWelcomeMessage);

      this.patchOrgSettings(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'updateOrgSettings',
    value: function updateOrgSettings(updatedOrgSettings) {
      var actions = this.context.app.actions;

      actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'patchOrgSettings',
    value: function patchOrgSettings(updatedOrgSettings, orgSettings) {
      var changes = Object(__WEBPACK_IMPORTED_MODULE_8_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(updatedOrgSettings, orgSettings);

      var actions = this.context.app.actions;

      actions.DefaultEmbedActions.patchDefaultEmbed(changes, NOTIFICATION_MESSAGE);
    }
  }, {
    key: 'onWelcomeMessageChanged',
    value: function onWelcomeMessageChanged(welcomeMessage, isValid) {
      if (!isValid) return;

      this.setState({
        previewState: __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* PreviewState */].ONLINE,
        welcomeMessage: welcomeMessage
      });

      var orgSettings = this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'welcomeMessage'], orNull(welcomeMessage));

      this.patchOrgSettingsDebounced(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'onAwayMessageChanged',
    value: function onAwayMessageChanged(awayMessage, isValid) {
      if (!isValid) return;

      this.setState({
        previewState: __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* PreviewState */].AWAY,
        awayMessage: awayMessage
      });

      var orgSettings = this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'awayMessage'], orNull(awayMessage));

      this.patchOrgSettingsDebounced(updatedOrgSettings, orgSettings);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentUser = _props.currentUser,
          orgSettings = _props.orgSettings,
          users = _props.users,
          hasConsolidatedWelcomeMsg = _props.hasConsolidatedWelcomeMsg;

      var name = currentUser.name || orgSettings.orgName;
      var theme = orgSettings.theme;
      var _state = this.state,
          previewState = _state.previewState,
          welcomeMessage = _state.welcomeMessage,
          awayMessage = _state.awayMessage;

      var message = previewState === __WEBPACK_IMPORTED_MODULE_15__constants__["b" /* PreviewState */].ONLINE ? welcomeMessage : awayMessage;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* IntlProvider */],
        { locale: 'en' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_17__style_styl___default.a.WelcomeMessage },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BackButton__["a" /* default */], { title: 'Drift Widget Settings', url: '/settings/widget' }),
          !hasConsolidatedWelcomeMsg && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PageTitle__["a" /* default */], {
            title: 'Welcome Message',
            description: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PageDescription, null),
            className: 'welcome-message-page-title'
          }),
          hasConsolidatedWelcomeMsg && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PageTitle__["a" /* default */], {
            title: 'Default Greeting',
            description: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NewPageDescription, null),
            className: 'welcome-message-page-title'
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_PreviewButtons__["a" /* default */], { previewState: previewState, onPreviewStateChanged: this.onPreviewStateChanged }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'preview-container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'preview' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_WelcomeMessageBuilderContainer__["a" /* default */], {
                theme: theme,
                previewState: previewState,
                message: message,
                currentUser: currentUser,
                name: name
              })
            ),
            !hasConsolidatedWelcomeMsg && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'div',
              { className: 'welcome-message-info' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Toggle__["a" /* default */], {
                defaultChecked: theme.showWelcomeMessage,
                onChange: this.onToggleWelcomeMessage,
                className: 'welcome-message-toggle'
              }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Section__["a" /* SectionItem */], {
                title: 'Welcome Message',
                description: 'Automatically show your welcome message before someone opens the chat window. The welcome message will not automatically display when the widget is offline.',
                className: 'info-section'
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_MessageInputs__["a" /* default */], {
            welcomeMessage: welcomeMessage,
            awayMessage: awayMessage,
            onWelcomeMessageChanged: this.onWelcomeMessageChanged,
            onAwayMessageChanged: this.onAwayMessageChanged
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'team-members' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Section__["a" /* SectionItem */], {
              title: 'Who shows on the ' + (hasConsolidatedWelcomeMsg ? 'default greeting' : 'Welcome Message')
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Customize_Online_HelpingTeamMemberSelection__["a" /* default */], {
              allUsers: users,
              userList: theme.userList,
              userListMode: theme.userListMode,
              onSelectUser: this.handleSelectUser,
              onUserListModeChange: this.handleUserListModeChange,
              validation: true
            })
          )
        )
      );
    }
  }]);

  return WelcomeMessage;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

WelcomeMessage.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasConsolidatedWelcomeMsg: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_gates_selectors__["u" /* makeHasGate */])('has_consolidated_welcome_msg')(state)
  };
};

var WelcomeMessageContainer = Object(__WEBPACK_IMPORTED_MODULE_6_components_container__["a" /* makeDefaultFailedContainer */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["h" /* withRouter */])(WelcomeMessage)), {
  listenTo: ['stores.UserStore'],
  fetch: {
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    },
    currentUser: function currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    users: function users() {
      return this.app.stores.UserStore.getOrFetchUsersForCurrentUserOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (WelcomeMessageContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "jjhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (immutable) */ __webpack_exports__["b"] = popUp;
/* harmony export (immutable) */ __webpack_exports__["c"] = renderLogo;
/* harmony export (immutable) */ __webpack_exports__["d"] = renderLogoSVG;
/* harmony export (immutable) */ __webpack_exports__["a"] = createAppName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);


function popUp(_ref) {
  var path = _ref.path,
      onClose = _ref.onClose,
      onMessage = _ref.onMessage,
      windowName = _ref.windowName,
      windowOptions = _ref.windowOptions;

  windowName = windowName || 'ConnectWithOAuth'; // should not include space for IE
  windowOptions = windowOptions || 'location=0,status=0,width=800,height=650';
  onClose = onClose || function () {};
  var _oauthWindow = window.open(path, windowName, windowOptions);
  var _oauthInterval = window.setInterval(function () {
    if (_oauthWindow.closed) {
      window.clearInterval(_oauthInterval);
      onClose();
    }
  }, 1000);
  var eventer = window.addEventListener;
  eventer('message', function (e) {
    if (e.origin !== window.location.origin || e.source !== _oauthWindow) return;
    !!onMessage && onMessage(e);
  });
  return _oauthWindow;
}

function renderLogo(src) {
  return React.createElement(
    'i',
    { className: 'logo' },
    React.createElement('img', { src: src, alt: 'logo' })
  );
}

function renderLogoSVG(src) {
  return React.createElement(
    'i',
    { className: 'logo' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: src })
  );
}

function createAppName(appName) {
  return appName.toLowerCase().replace(/ /g, "-").replace(/\'/g, "");
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "jpZJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return users; });

var users = function users(orgId) {

  return [{
    "id": 101,
    "orgId": orgId,
    "status": "ENABLED",
    "name": "Bot",
    "alias": "Bot",
    "email": "bot-15860@drift.com",
    "phone": null,
    "locale": null,
    "timeZone": null,
    "avatarUrl": "",
    "verified": false,
    "bot": true,
    "createdAt": 1516636600606,
    "externalId": "",
    "slackUserId": null,
    "role": "MEMBER",
    "gates": null,
    "scopes": ["org_admin", "member"],
    "avatars": {
      "image200": null,
      "squareCropImage200": null,
      "faceImage470": null,
      "faceImage940": null,
      "faceImage1880": null
    },
    "availability": "AVAILABLE",
    "type": "USER",
    "graphType": "TeamMember"
  }];
};

/***/ }),

/***/ "jq0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__("ivXw");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DEFAULT_VALUE = 100;

var mapObjectToOptions = function mapObjectToOptions(obj) {
  var options = [];

  Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["forOwn"])(obj, function (value, key) {
    options.push({ label: value, value: key });
  });

  return options;
};

var OPERATOR_MAP = {
  greaterThan: "is greater than",
  lessThan: "is less than",
  isBetween: "is between"
};

var NumericalValuesFilter = function (_PureComponent) {
  _inherits(NumericalValuesFilter, _PureComponent);

  function NumericalValuesFilter(props) {
    _classCallCheck(this, NumericalValuesFilter);

    var _this = _possibleConstructorReturn(this, (NumericalValuesFilter.__proto__ || Object.getPrototypeOf(NumericalValuesFilter)).call(this, props));

    _this.onConditionUpdated = function () {
      var _this$props = _this.props,
          activeFilter = _this$props.activeFilter,
          onUpdateCondition = _this$props.onUpdateCondition;
      var _this$state = _this.state,
          selectedOperator = _this$state.selectedOperator,
          selectedValue = _this$state.selectedValue;


      var cloneFilter = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["clone"])(activeFilter);
      cloneFilter.operator = selectedOperator, cloneFilter.value = selectedValue;

      onUpdateCondition(cloneFilter);
    };

    _this.onOperatorChange = function (option) {
      if (option === null) {
        return;
      }

      var isGroup = option.value === 'isBetween';

      _this.setState({
        selectedOperator: option.value,
        isGroupValue: isGroup,
        selectedValue: isGroup ? {} : DEFAULT_VALUE
      }, _this.onConditionUpdated);
    };

    _this.onSingleValueChanged = function (evt) {
      var value = evt.target.value;
      _this.setState({ selectedValue: value }, _this.onConditionUpdated);
    };

    _this.onMinValueChanged = function (evt) {
      var selectedValue = _this.state.selectedValue;

      var value = evt.target.value;

      if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"])(selectedValue)) {
        _this.setState({ selectedValue: _extends({}, selectedValue, { min: value }) }, _this.onConditionUpdated);
      } else {
        _this.setState({ selectedValue: { min: value } }, _this.onConditionUpdated);
      }
    };

    _this.onMaxValueChanged = function (evt) {
      var selectedValue = _this.state.selectedValue;

      var value = evt.target.value;

      if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"])(selectedValue)) {
        _this.setState({ selectedValue: _extends({}, selectedValue, { max: value }) }, _this.onConditionUpdated);
      } else {
        _this.setState({ selectedValue: { max: value } }, _this.onConditionUpdated);
      }
    };

    _this.renderOperatorOptions = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], { className: 'operator-select', clearable: false, options: mapObjectToOptions(OPERATOR_MAP), value: _this.state.selectedOperator, onChange: _this.onOperatorChange });
    };

    _this.renderOperatorInputs = function () {
      var _this$state2 = _this.state,
          selectedOperator = _this$state2.selectedOperator,
          selectedValue = _this$state2.selectedValue,
          isGroupValue = _this$state2.isGroupValue;


      if (!isGroupValue) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'numerical-values-singular-input' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], { value: selectedValue, onChange: _this.onSingleValueChanged })
        );
      } else {
        var value = selectedValue || {};

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'between-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], { value: value.min, onChange: _this.onMinValueChanged }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'between-container-text' },
            'And'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Input"], { value: value.max, onChange: _this.onMaxValueChanged })
        );
      }
    };

    _this.state = {
      selectedOperator: props.activeFilter.operator || Object.keys(OPERATOR_MAP)[0],
      selectedValue: props.activeFilter.value,
      isGroupValue: !!props.activeFilter && Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isObject"])(props.activeFilter.value)
    };
    return _this;
  }

  _createClass(NumericalValuesFilter, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form numerical-filter' },
        this.renderOperatorOptions(),
        this.renderOperatorInputs()
      );
    }
  }]);

  return NumericalValuesFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (NumericalValuesFilter);

/***/ }),

/***/ "jqpN":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" xmlns=\"http://www.w3.org/2000/svg\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"419\" cy=\"858\" r=\"6\" fill=\"#F7D86B\" transform=\"translate(-412 -851)\" fill-rule=\"evenodd\"></circle></svg>"

/***/ }),

/***/ "jqrc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("60pu");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "jrVC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");









var humanizeRepAvatars = function humanizeRepAvatars(repAvatars) {
  switch (repAvatars.length) {
    case 0:
    case 1:
      return repAvatars;
    case 2:
      return [repAvatars[0], React.createElement(
        'span',
        null,
        '\xA0or\xA0'
      ), repAvatars[1]];
    default:
      var remainingLength = repAvatars.length - 2;
      return [repAvatars[0], React.createElement(
        'span',
        null,
        '\xA0'
      ), repAvatars[1], React.createElement(
        'span',
        null,
        '\xA0or ' + remainingLength + ' ' + Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(remainingLength, "other")
      )];
  }
};

var RepAvatarPreview = function RepAvatarPreview(_ref) {
  var listOfSelectedIds = _ref.listOfSelectedIds,
      orgUsers = _ref.orgUsers;

  var repAvatars = listOfSelectedIds.toJS().map(function (id) {
    var user = orgUsers.find(function (user) {
      return user.id === id;
    });
    var displayName = Object(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(user);
    return user && React.createElement(
      'div',
      { className: 'rep-preview', title: displayName },
      React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], { key: user.get('id'), user: user.toJS() }),
      React.createElement(
        'span',
        null,
        displayName
      )
    );
  });
  return React.createElement(
    'div',
    { className: 'rep-preview' },
    humanizeRepAvatars(repAvatars)
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgUsers: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["nonBotOrgUsersAlphabetical"](state),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(RepAvatarPreview));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "jv4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jwnV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__ = __webpack_require__("dZeU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_UserConstants__ = __webpack_require__("1rl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_GateConstants__ = __webpack_require__("O04e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_EmbedConstants__ = __webpack_require__("Or1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var OrgQueries = Marty.createQueries({
  id: 'OrgQueries',

  createOrg: function createOrg(settings) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var promise = _this.app.sources.OrgAPI.createOrg(settings);
      return promise.then(function (res) {
        try {
          if (res.status === 200) {
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_UserConstants__["a" /* default */].USER_CREATE_DONE, settings.email, res.body.user, res.body.accessToken);
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_CREATE_DONE, res.body.organization);
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_GateConstants__["a" /* default */].SET_GATE_DONE, res.body.gates);
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_3_constants_EmbedConstants__["a" /* default */].EMBED_CREATE_DONE, res.body.embed.configuration.inboxId, res.body.embed);
            return resolve(res);
          } else if (res.status === 400) {
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_UserConstants__["a" /* default */].EMAIL_ALREADY_REGISTERED, settings.email);
            return reject(res);
          } else {
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_FAILED, settings.email, res);
            _this.app.actions.NotificationActions.pushNotification({
              content: "An error ocurred while creating your account. Please try again later.",
              variant: 'red',
              sticky: true
            });
            return reject(res);
          }
        } catch (error) {
          Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].USER_CREATE_WITH_EMAIL_FAILED, settings.email, error);
          _this.app.actions.NotificationActions.pushNotification({
            content: "An error ocurred while creating your account. Please try again later.",
            variant: 'red',
            sticky: true
          });
          return reject(error);
        }
      });
    });
  },
  fetchOrgById: function fetchOrgById(orgId) {
    var _this2 = this;

    var promise = this.app.sources.OrgAPI.fetchOrgById(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_FETCH_FAILED, error);
    });
  },
  shareSnippet: function shareSnippet(email, orgId) {
    var _this3 = this;

    var promise = this.app.sources.OrgAPI.shareEmailSnippet(email, orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_DONE, email, orgId, res.body);
        return _this3.app.actions.NotificationActions.pushNotification({ content: "Your message has been sent!" });
      } else if (res.status === 400) {
        return _this3.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: res.body.message
        });
      } else {
        _this3.app.actions.NotificationActions.pushNotification({
          variant: "red",
          content: "We are having trouble sending your invitations right now."
        });
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET_FAILED, error);
    });
  },
  updateOrg: function updateOrg(orgId, update) {
    var _this4 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_STARTING, orgId);
    var promise = this.app.sources.OrgAPI.updateOrg(orgId, update);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_DONE, orgId, res.body, update);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_FAILED, orgId, update, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].ORG_UPDATE_FAILED, orgId, update, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "jwya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("QR21");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var FakeEmailWindow = function FakeEmailWindow(_ref) {
  var from = _ref.from,
      address = _ref.address,
      subject = _ref.subject,
      children = _ref.children;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'fake-email-window' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fake-email-window-title-bar' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fake-email-window-title-bar-dot' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fake-email-window-title-bar-dot' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fake-email-window-title-bar-dot' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fake-email-window-title-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'fake-email-window-title' },
        'From: '
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        from
      ),
      address && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'fake-email-address' },
        ' <' + address + '>'
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fake-email-window-title-container' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'fake-email-window-title' },
        'Subject: '
      ),
      subject
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'fake-email-window-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('base', { target: '_blank' }),
      children
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (FakeEmailWindow);

/***/ }),

/***/ "jzDT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("2BXq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__ = __webpack_require__("UKWd");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DriftActivityText;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var SEARCH_DELAY_IN_MS = 300;

var DriftActivityText = (_DriftActivityText = {}, _defineProperty(_DriftActivityText, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DriftActivityType */].SYNC_CONVERSATIONS, 'New Drift Conversation'), _defineProperty(_DriftActivityText, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DriftActivityType */].SYNC_MEETINGS, 'New Drift Meeting'), _defineProperty(_DriftActivityText, __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DriftActivityType */].SYNC_CQL_SCORE, 'New Drift CQL Score'), _DriftActivityText);

var isNonEmptyActivityType = function isNonEmptyActivityType(activityType) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["complement"])(__WEBPACK_IMPORTED_MODULE_4_ramda__["equals"])(activityType, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* EmptyActivity */].activityType);
};

var resolveVisibleDriftActivityTypes = function resolveVisibleDriftActivityTypes(activityType, mappedActivityTypes) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["uniq"])([].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["without"])(mappedActivityTypes, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["values"])(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* DriftActivityType */]))), [activityType]));
};

var activitySearchResultToSelectItem = function activitySearchResultToSelectItem(result) {
  return {
    value: result.id,
    label: result.name
  };
};

var MarketoActivityOption = function (_Component) {
  _inherits(MarketoActivityOption, _Component);

  function MarketoActivityOption() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarketoActivityOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarketoActivityOption.__proto__ || Object.getPrototypeOf(MarketoActivityOption)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activitySearchResults: [],
      canDisplayNoResultsMessage: false
    }, _this.onMarketoInputChange = function (value) {
      var handleSearchResults = function handleSearchResults(results) {
        return _this.setState({
          activitySearchResults: results,
          canDisplayNoResultsMessage: true
        });
      };

      Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__["S" /* searchForMarketoActivity */])(value).then(handleSearchResults);
    }, _this.onMarketoInputChangeDebounced = _.debounce(_this.onMarketoInputChange, SEARCH_DELAY_IN_MS), _this.onMarketoInputSelected = function (_ref2) {
      var value = _ref2.value,
          label = _ref2.label;
      var _this$props = _this.props,
          updateActivities = _this$props.updateActivities,
          activity = _this$props.activity,
          activityIndex = _this$props.activityIndex;

      var mappedActivity = {
        marketoId: value,
        marketoName: label
      };

      updateActivities({ activityIndex: activityIndex, mappedActivity: mappedActivity });
    }, _this.onDriftInputSelected = function (_ref3) {
      var value = _ref3.value;
      var _this$props2 = _this.props,
          updateActivities = _this$props2.updateActivities,
          activity = _this$props2.activity,
          activityIndex = _this$props2.activityIndex;

      var mappedActivity = {
        activityType: value
      };

      updateActivities({ activityIndex: activityIndex, mappedActivity: mappedActivity });
    }, _this.deleteActivity = function () {
      var _this$props3 = _this.props,
          activityIndex = _this$props3.activityIndex,
          deleteActivity = _this$props3.deleteActivity,
          activity = _this$props3.activity;

      deleteActivity({ activityIndex: activityIndex, mappedActivity: activity });
    }, _this.resolveDriftSelectItemOptions = function () {
      var _this$props4 = _this.props,
          activity = _this$props4.activity,
          mappedActivities = _this$props4.mappedActivities;

      var mappedActivityTypes = mappedActivities.map(function (a) {
        return a.activityType;
      });
      var visibleDriftActivityTypes = resolveVisibleDriftActivityTypes(activity.activityType, mappedActivityTypes);

      return visibleDriftActivityTypes.filter(isNonEmptyActivityType).map(function (activityType) {
        return {
          value: activityType,
          label: DriftActivityText[activityType]
        };
      });
    }, _this.resolveMarketoSelectItemOptions = function () {
      var activitySearchResults = _this.state.activitySearchResults;
      var activity = _this.props.activity;


      var defaultOptions = [];
      if (!Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isNil"])(activity.marketoId) && !Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isNil"])(activity.marketoName)) {
        defaultOptions = [{
          value: activity.marketoId,
          label: activity.marketoName
        }];
      }

      return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isEmpty"])(activitySearchResults) ? defaultOptions : activitySearchResults.map(activitySearchResultToSelectItem);
    }, _this.onMarketoDropdownClosed = function () {
      _this.setState({
        activitySearchResults: [],
        canDisplayNoResultsMessage: false
      });
    }, _this.resolveMarketoNoResultsText = function () {
      var _this$state = _this.state,
          canDisplayNoResultsMessage = _this$state.canDisplayNoResultsMessage,
          activitySearchResults = _this$state.activitySearchResults;

      return canDisplayNoResultsMessage && Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["isEmpty"])(activitySearchResults) ? 'No results found' : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarketoActivityOption, [{
    key: 'render',
    value: function render() {
      var activity = this.props.activity;


      var driftSelectOptions = {
        multi: false,
        searchable: false,
        autoFocus: false,
        clearable: false,
        value: activity.activityType,
        options: this.resolveDriftSelectItemOptions(),
        onChange: this.onDriftInputSelected
      };

      var marketoSelectOptions = {
        multi: false,
        searchable: true,
        autoFocus: false,
        clearable: false,
        noResultsText: this.resolveMarketoNoResultsText(),
        placeholder: 'Search Marketo activities...',
        value: activity.marketoId,
        options: this.resolveMarketoSelectItemOptions(),
        onInputChange: this.onMarketoInputChangeDebounced,
        onChange: this.onMarketoInputSelected,
        onClose: this.onMarketoDropdownClosed
      };

      return React.createElement(
        'div',
        { className: 'marketo-activity-mapper-action' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], driftSelectOptions),
        React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], marketoSelectOptions),
        React.createElement(
          'span',
          { onClick: this.deleteActivity },
          React.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], {
            className: 'close-icon',
            width: 15,
            name: 'close'
          })
        )
      );
    }
  }]);

  return MarketoActivityOption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (MarketoActivityOption);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "jzIA":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 16 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.49 10.896C14.617 12.06 16 14.304 16 17c0 4.056-2.916 7-6.934 7H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8.066C12.45 0 15 2.58 15 6c0 2.05-.986 3.818-2.51 4.896zM14 17c0-2.47-1.707-4.97-4.97-4.97-.053 0-.1-.022-.153-.03H2v10h7.066C12.456 22 14 19.408 14 17zM9.066 2H2v8h7c2.28 0 4-1.72 4-4 0-2.318-1.654-4-3.934-4z\" fill=\"#777\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "k+Gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone__ = __webpack_require__("KTM0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_api_FileAPI__ = __webpack_require__("0OV4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_image_svg__ = __webpack_require__("Judl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_image_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_image_svg__);









var ENTITY_TYPE = 'IMAGE';
var BLOCK_TYPE = 'atomic';

var ImageButton = function ImageButton(_ref) {
  var editorState = _ref.editorState,
      onChange = _ref.onChange;

  var addLink = function addLink(src) {
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = contentState.createEntity(ENTITY_TYPE, 'IMMUTABLE', { src: src });
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    var newEditorState = __WEBPACK_IMPORTED_MODULE_0_draft_js__["AtomicBlockUtils"].insertAtomicBlock(editorState, entityKey, ' ');
    onChange(newEditorState);
  };
  var onDrop = function onDrop(files) {
    return __WEBPACK_IMPORTED_MODULE_4_app_api_FileAPI__["a" /* upload */](files[0]).then(function (res) {
      return addLink(res.url);
    });
  };
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_dropzone___default.a,
    { onDrop: onDrop, className: 'rich-editor-toolbar-button' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_image_svg___default.a })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_draft_extend__["createPlugin"])({
  htmlToBlock: function htmlToBlock(nodeName, node, lastList, inBlock) {
    if (nodeName === 'figure' && node.firstChild.nodeName === 'IMG' || nodeName === 'img' && inBlock !== BLOCK_TYPE) {
      return BLOCK_TYPE;
    }
  },
  htmlToEntity: function htmlToEntity(nodeName, node) {
    if (nodeName === 'img') {
      return __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].create(ENTITY_TYPE, 'IMMUTABLE', { src: node.getAttribute('src') });
    }
  },
  blockRendererFn: function blockRendererFn(block) {
    if (block.getType() === 'atomic' && block.length > 0 && __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].get(block.getEntityAt(0)).getType() === ENTITY_TYPE) {
      return {
        component: function component(_ref2) {
          var block = _ref2.block;

          var _Entity$get$getData = __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].get(block.getEntityAt(0)).getData(),
              src = _Entity$get$getData.src;

          return React.createElement('img', { src: src });
        },
        editable: false
      };
    }
  },
  blockToHTML: {
    atomic: {
      start: '',
      end: ''
    }
  },
  entityToHTML: function entityToHTML(entity) {
    if (entity.type === ENTITY_TYPE) {
      return '<img style="max-width: 230px;" src="' + entity.data.src + '" />';
    }
  },
  buttons: ImageButton
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "k/LG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export withOrg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_selectors__ = __webpack_require__("Bqo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("CR44");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var withOrg = function withOrg() {
  var selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__selectors__;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { blocking: false };
  return function (InnerComponent) {
    var OrgContainer = function (_Component) {
      _inherits(OrgContainer, _Component);

      function OrgContainer() {
        _classCallCheck(this, OrgContainer);

        return _possibleConstructorReturn(this, (OrgContainer.__proto__ || Object.getPrototypeOf(OrgContainer)).apply(this, arguments));
      }

      _createClass(OrgContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.props.actions.fetchOrg();
        }
      }, {
        key: 'render',
        value: function render() {
          if (options.blocking && !this.props.isLoaded) return false;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerComponent, this.props);
        }
      }]);

      return OrgContainer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    OrgContainer.displayName = 'withOrg(' + getDisplayName(InnerComponent) + ')';

    function mapStateToProps(state) {
      var appliedSelectors = options.blocking ? _extends({ isLoaded: __WEBPACK_IMPORTED_MODULE_4__selectors__["isLoaded"] }, selectors) : selectors;

      return Object(__WEBPACK_IMPORTED_MODULE_3_utils_selectors__["a" /* applySelectors */])(appliedSelectors, state);
    }

    function mapDispatchToProps(dispatch) {
      return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])(__WEBPACK_IMPORTED_MODULE_5__actions__, dispatch)
      };
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(OrgContainer);
  };
};

/***/ }),

/***/ "k0xy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k2Sf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_rules_actions__ = __webpack_require__("L/10");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_teams_selectors__ = __webpack_require__("wFBz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layouts_RulesHome__ = __webpack_require__("8uTn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















function mapStateToProps(state) {
  return {
    rules: state.get('rules').get('rules'),
    onCall: state.get('rules').get('onCall'),
    rulesLoading: state.get('rules').get('rulesLoading'),
    users: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["unfilteredOrgUsersByIdJS"])(state),
    teams: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_teams_selectors__["d" /* teams */])(state),
    hasVisualRoutingBuilder: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["u" /* makeHasGate */])('HAS_VISUAL_ROUTING_BUILDER')(state),
    currentUserLoaded: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["currentUserLoaded"])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_0_app_modules_rules_actions__, { fetchOrgUsers: __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__["fetchOrgUsers"], patchOrgProperties: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_actions__["patchOrgProperties"] }), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_11_app_modules_teams_hoc_withOrgTeams__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.currentUserLoaded;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return props.hasVisualRoutingBuilder;
}, function () {
  setTimeout(function () {
    return window.location.replace('/settings2/rules');
  }, 0);
  Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */])();
}))(__WEBPACK_IMPORTED_MODULE_10__layouts_RulesHome__["a" /* default */]));

/***/ }),

/***/ "k30Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"localTime":"localTime---1PdQ8"};

/***/ }),

/***/ "k36k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---3wUK_"};

/***/ }),

/***/ "k6b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orgHandle; });
/* unused harmony export isValidOrgHandle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("TFJD");



var orgHandle = function orgHandle(state) {
  return state.getIn(['orgUI', 'data', 'handle']);
};

var isValidOrgHandle = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(orgHandle, __WEBPACK_IMPORTED_MODULE_1__selectors__["orgHandle"], function (state) {
  return state.getIn(['orgUI', 'valid', 'handle']);
}, function (handle, originalHandle, valid) {
  if (handle === originalHandle || typeof valid === 'undefined') return true;

  return valid && !!handle && handle.length > 0 && !handle.includes('.');
});

/***/ }),

/***/ "kBO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return geoFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return companyTagsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return marketTagsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return techTagsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return headquarterStateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return headquarterCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return headquarterPostalCodeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return annualRevenueFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return firmographicFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return siteVisitsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return urlPathFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return urlHostFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return urlQueryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return salesforceFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return targetedAccountsFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return leandataFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return participantAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return salesforceAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return leandataAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return targetedAccountsAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return demandbaseAudienceFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return demandbaseIndustryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return demandbaseSubIndustryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return demandbaseEmployeeCountFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return demandbaseEmployeeRangeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return demandbaseMarketingAliasFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return demandbaseAnnualSalesFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return demandbaseRevenueRangeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return demandbaseHeadquarterCityFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return demandbaseHeadquarterStateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return demandbaseHeadquarterCountryFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return newRuleModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return availabilityFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_DemandbaseAudiences__ = __webpack_require__("R9hW");



var geoFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* GEO_FILTER_TYPES */].STATE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* GEO_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var companyTagsFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var marketTagsFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var techTagsFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var headquarterStateFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var headquarterCountryFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var headquarterPostalCodeFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_POSTAL_CODE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CATEGORY_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var annualRevenueFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["K" /* REVENUE_FILTER_OPERATORS */].BTW,
  'value': '$0-$1M'
};

var firmographicFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* EMPLOYEES_FILTER_OPERATORS */].BTW,
  'value': { min: 0, max: 10 }
};

var siteVisitsFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["P" /* SITE_VISITS_OPERATORS */].BTW,
  'value': { min: 0, max: 1 }
};

var urlPathFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["V" /* URL_FILTER_TYPES */].URL_PATH,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["T" /* URL_FILTER_OPERATORS */].INCLUDES_ANY,
  'value': [__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* EMPTY_STRING */]]
};

var urlHostFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["V" /* URL_FILTER_TYPES */].URL_HOST,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["T" /* URL_FILTER_OPERATORS */].IS_ANY,
  'value': [__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* EMPTY_STRING */]]
};

var urlQueryFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["V" /* URL_FILTER_TYPES */].URL_QUERY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["T" /* URL_FILTER_OPERATORS */].IS_ANY,
  'value': [__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* EMPTY_STRING */]]
};

var salesforceFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["M" /* SALESFORCE_FILTER */],
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["N" /* SALESFORCE_OPERATORS */].IS,
  'value': true
};

var targetedAccountsFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["R" /* TARGETED_ACCOUNTS_FILTER */],
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["S" /* TARGETED_ACCOUNTS_OPERATORS */].IS,
  'value': true
};

var leandataFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["C" /* LEANDATA_FILTER */],
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["S" /* TARGETED_ACCOUNTS_OPERATORS */].IS,
  'value': true
};

var participantAction = {
  'type': __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPES */].PARTICIPANT,
  'options': {
    'teamId': null, // teamId if the participant is a team
    'userIds': [], // list of users to add
    'addType': __WEBPACK_IMPORTED_MODULE_0__constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE, // either ADD_ONE or ADD_ALL
    'isAccountOwner': true // true if the added user should also be set as the account owner, false otherwise
  }
};

var salesforceAction = {
  'type': __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPES */].SALESFORCE_PARTICIPANT
};

var leandataAction = {
  'type': __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPES */].LEANDATA_PARTICIPANT
};

var targetedAccountsAction = {
  'type': __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACTION_TYPES */].ABM_PARTICIPANT
};

var demandbaseAudienceFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_AUDIENCE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': __WEBPACK_IMPORTED_MODULE_1_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */][0].value
};

var demandbaseIndustryFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_INDUSTRY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseSubIndustryFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_SUB_INDUSTRY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseEmployeeCountFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_COUNT,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].BTW,
  'value': { min: 0, max: 10 }
};

var demandbaseEmployeeRangeFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_RANGE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseMarketingAliasFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_MARKETING_ALIAS,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseAnnualSalesFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_ANNUAL_SALES,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].BTW,
  'value': { min: 0, max: 10 }
};

var demandbaseRevenueRangeFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_REVENUE_RANGE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseHeadquarterCityFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_CITY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': ''
};

var demandbaseHeadquarterStateFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var demandbaseHeadquarterCountryFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY,
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DEMANDBASE_FILTER_OPERATORS */].IS_ANY,
  'value': []
};

var newRuleModel = {
  valid: false,
  loading: true,
  error: null,
  data: {
    item: {
      name: '',
      conditions: [],
      action: participantAction,
      status: "ENABLED"
    }
  }
};

var availabilityFilter = {
  'field': __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* AVAILABILITY_FILTER */],
  'operator': __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* AVAILABILITY_FILTER_OPERATORS */].IS_ANY,
  'value': true
};

/***/ }),

/***/ "kCfH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_helpers__ = __webpack_require__("nS6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("Jm+C");














var mapStateToProps = function mapStateToProps(state) {
  return {
    sequence: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_74" /* sequence */](state),
    emails: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["y" /* emails */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    marketingEmailLayout: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_53" /* marketingEmailLayout */](state),
    isOneTimeMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_5" /* getIsOneTimeMarketingSequencePlaybook */](state),
    sendTestSequencePending: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_20" /* getSendTestSequencePending */](state),
    editSenderLevel: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["P" /* getEditSenderLevel */](state),
    isGmailConnected: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__["isGmailConnected"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      addEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["e" /* addEmail */],
      setMarketingEmailLayout: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_180" /* setMarketingEmailLayout */],
      fetchGoogleScopes: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__["fetchGoogleScopes"],
      showGoogleAuthModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_234" /* showGoogleAuthModal */],
      sendTestSequence: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_129" /* sendTestSequence */],
      setEditSenderLevel: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_158" /* setEditSenderLevel */],
      setSenderName: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_198" /* setSequenceSenderName */],
      setEmailOverride: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_193" /* setSequenceEmailOverride */],
      setDynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_156" /* setDynamicAccountSendAttribute */],
      setDynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_157" /* setDynamicSenderFormat */],
      setSequenceDynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_191" /* setSequenceDynamicAccountSendAttribute */],
      setSequenceDynamicSenderFormat: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_192" /* setSequenceDynamicSenderFormat */],
      setSequenceIndividualDynamicAttr: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_194" /* setSequenceIndividualDynamicAttr */],
      setSequenceIndividualDynamicFormat: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_195" /* setSequenceIndividualDynamicFormat */],
      setSequenceIndividualSenderName: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_197" /* setSequenceIndividualSenderName */],
      setSequenceIndividualEmailOverride: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_196" /* setSequenceIndividualEmailOverride */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.props.actions.fetchGoogleScopes();

    // make sure the data is clean and the "edit sender level" toggle is correctly set
    var globalSenderIsEmpty = this.props.sequence.options.get('sendFromOverride') === null && this.props.sequence.options.get('senderEmailOverride') === null && this.props.sequence.options.get('dynamicAccountSendAttribute') === null && this.props.sequence.options.get('dynamicSenderFormat') === null;
    var localSenderIsEmpty = this.props.emails.reduce(function (emptySoFar, email) {
      return emptySoFar && email.get('sendFromOverride') === null && email.get('senderEmailOverride') === null && email.get('dynamicAccountSendAttribute') === null && email.get('dynamicSenderFormat') === null;
    }, true);
    var isLocalSender = !localSenderIsEmpty;
    this.props.actions.setEditSenderLevel(isLocalSender ? __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL : __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].GLOBAL);
    if (isLocalSender && !globalSenderIsEmpty) {
      this.props.actions.setSenderName(null);
      this.props.actions.setEmailOverride(null);
      if (this.props.isMarketingSequencePlaybook) {
        this.props.actions.setSequenceDynamicAccountSendAttribute(null);
        this.props.actions.setSequenceDynamicSenderFormat(null);
      } else {
        this.props.actions.setDynamicAccountSendAttribute(null);
        this.props.actions.setDynamicSenderFormat(null);
      }
    } else if (!isLocalSender && !localSenderIsEmpty) {
      this.props.sequence.emails.forEach(function (emailId) {
        _this.props.actions.setSequenceIndividualEmailOverride({ data: null, emailId: emailId });
        _this.props.actions.setSequenceIndividualSenderName({ data: null, emailId: emailId });
        _this.props.actions.setSequenceIndividualDynamicAttr({ data: null, emailId: emailId });
        _this.props.actions.setSequenceIndividualDynamicFormat({ data: null, emailId: emailId });
      });
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    canSelectTemplate: props.isMarketingSequencePlaybook
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onSetEditSenderLevel: function onSetEditSenderLevel(props) {
    return function () {
      var isLocal = props.editSenderLevel === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL;
      if (isLocal) {
        props.actions.setEditSenderLevel(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].GLOBAL);
        // wipe out local sender edits
        props.sequence.emails.forEach(function (emailId) {
          props.actions.setSequenceIndividualEmailOverride({ data: null, emailId: emailId });
          props.actions.setSequenceIndividualSenderName({ data: null, emailId: emailId });
          props.actions.setSequenceIndividualDynamicAttr({ data: null, emailId: emailId });
          props.actions.setSequenceIndividualDynamicFormat({ data: null, emailId: emailId });
        });
      } else {
        props.actions.setEditSenderLevel(__WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_18" /* EditSenderLevels */].LOCAL);
        // wipe out the global sender edits, we're going to edit each email individually
        props.actions.setSenderName(null);
        props.actions.setEmailOverride(null);
        if (props.isMarketingSequencePlaybook) {
          props.actions.setSequenceDynamicAccountSendAttribute(null);
          props.actions.setSequenceDynamicSenderFormat(null);
        } else {
          props.actions.setDynamicAccountSendAttribute(null);
          props.actions.setDynamicSenderFormat(null);
        }
      }
    };
  },
  onAddClick: function onAddClick(props) {
    return function () {
      props.actions.addEmail({ email: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_models__["e" /* Email */]({ id: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_helpers__["a" /* weakUuid */])() }) });
    };
  },
  onEmailLayoutSelect: function onEmailLayoutSelect(props) {
    return function (type) {
      props.actions.setMarketingEmailLayout(type);
    };
  },
  onSendTestSequence: function onSendTestSequence(props) {
    return function () {
      if (props.isMarketingSequencePlaybook || props.isGmailConnected) {
        props.actions.sendTestSequence();
      } else {
        props.actions.showGoogleAuthModal();
      }
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["k" /* withStateHandlers */])({ showTripwire: false }, {
  setShowTripwire: function setShowTripwire() {
    return function (showTripwire) {
      return { showTripwire: showTripwire };
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));

/***/ }),

/***/ "kJAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__("6EYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__("qbTP");
var _handleActions, _handleActions2, _handleActions3, _handleActions5, _handleActions6;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var orgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["o" /* fetchAssistantOrgSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["p" /* fetchAssistantOrgSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["n" /* fetchAssistantOrgSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* createAssistantOrgSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* createAssistantOrgSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* createAssistantOrgSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["J" /* patchAssistantOrgSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["K" /* patchAssistantOrgSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["I" /* patchAssistantOrgSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["p" /* fetchAssistantOrgSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* createAssistantOrgSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["K" /* patchAssistantOrgSettingsSuccess */]), function (state, action) {
  return state.set('data', action.payload);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var agentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["k" /* fetchAssistantAgentSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["l" /* fetchAssistantAgentSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["j" /* fetchAssistantAgentSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* createAssistantAgentSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* createAssistantAgentSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* createAssistantAgentSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["F" /* patchAssistantAgentSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["G" /* patchAssistantAgentSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["E" /* patchAssistantAgentSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* fetchAssistantAgentSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* createAssistantAgentSettings */], __WEBPACK_IMPORTED_MODULE_3__actions__["G" /* patchAssistantAgentSettingsSuccess */]), function (state, action) {
  return state.set('data', action.payload);
}), _handleActions2), new __WEBPACK_IMPORTED_MODULE_2_immutable__["Map"]({
  data: Object(__WEBPACK_IMPORTED_MODULE_4__models__["a" /* AgentSettings */])(),
  status: null
}));

var salesforceMappings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["w" /* fetchSalesforceSettingsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["x" /* fetchSalesforceSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["v" /* fetchSalesforceSettingsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["x" /* fetchSalesforceSettingsSuccess */]), function (state, action) {
  // Turn massive SFDC settings lists into usable formats
  var leadFields = [];
  var contactFields = [];
  var eventFields = [];
  var taskFields = [];

  var leadFieldValues = {};
  var contactFieldValues = {};
  var eventFieldValues = {};
  var taskFieldValues = {};

  Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* buildMappings */])(action.payload.LEAD, leadFields, leadFieldValues);
  Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* buildMappings */])(action.payload.CONTACT, contactFields, contactFieldValues);
  Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* buildMappings */])(action.payload.EVENT, eventFields, eventFieldValues);
  Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* buildMappings */])(action.payload.TASK, taskFields, taskFieldValues);
  return state.setIn(['data', 'LEAD', 'leadFields'], leadFields).setIn(['data', 'LEAD', 'leadFieldValues'], leadFieldValues).setIn(['data', 'CONTACT', 'contactFields'], contactFields).setIn(['data', 'CONTACT', 'contactFieldValues'], contactFieldValues).setIn(['data', 'EVENT', 'eventFields'], eventFields).setIn(['data', 'EVENT', 'eventFieldValues'], eventFieldValues).setIn(['data', 'TASK', 'taskFields'], taskFields).setIn(['data', 'TASK', 'taskFieldValues'], taskFieldValues);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var editingOrgSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__actions__["y" /* handleEditConfig */], function (state, _ref) {
  var payload = _ref.payload;

  return state.set(payload.settingName, payload.value);
}), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var editingAgentSettings = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["l" /* fetchAssistantAgentSettingsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["G" /* patchAssistantAgentSettingsSuccess */]), function (state, _ref2) {
  var payload = _ref2.payload;

  return payload.get('taskConfigMap');
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_3__actions__["z" /* onCancel */], function (state, _ref3) {
  var payload = _ref3.payload;

  return payload;
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_3__actions__["A" /* onUpdate */], function (state, _ref4) {
  var payload = _ref4.payload;

  return state.set(payload.settingName, payload.newSettings);
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_3__actions__["B" /* onWarmLeadUpdate */], function (state, _ref5) {
  var payload = _ref5.payload;

  var newCancelSettings = state.get('MEETING_CANCELLED').set('on', payload.newSettings.get('on')).set('delayTime', payload.newSettings.get('delayTime'));
  var newRescheduledSettings = state.get('MEETING_RESCHEDULED').set('on', payload.newSettings.get('on')).set('delayTime', payload.newSettings.get('delayTime'));
  return state.set('MEETING_CANCELLED', newCancelSettings).set('MEETING_RESCHEDULED', newRescheduledSettings);
}), _defineProperty(_handleActions5, __WEBPACK_IMPORTED_MODULE_3__actions__["C" /* onWarmLeadUpdateTemplate */], function (state, _ref6) {
  var payload = _ref6.payload;

  var cancelSettings = payload.MEETING_CANCELLED;
  var rescheduleSettings = payload.MEETING_RESCHEDULED;
  var newCancelSettings = state.get('MEETING_CANCELLED').set('emailSubject', cancelSettings.get('emailSubject')).set('emailBody', cancelSettings.get('emailBody'));
  var newRescheduledSettings = state.get('MEETING_RESCHEDULED').set('emailSubject', rescheduleSettings.get('emailSubject')).set('emailBody', rescheduleSettings.get('emailBody'));
  return state.set('MEETING_CANCELLED', newCancelSettings).set('MEETING_RESCHEDULED', newRescheduledSettings);
}), _handleActions5), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var personalizationTags = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions6 = {}, _defineProperty(_handleActions6, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["s" /* fetchPersonalizationTagsPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["t" /* fetchPersonalizationTagsSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["r" /* fetchPersonalizationTagsFailed */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions6, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["t" /* fetchPersonalizationTagsSuccess */]), function (state, action) {
  return state.set('data', action.payload);
}), _handleActions6), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var sendingTestEmailStatus = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["N" /* sendTestEmailPending */], __WEBPACK_IMPORTED_MODULE_3__actions__["O" /* sendTestEmailSuccess */], __WEBPACK_IMPORTED_MODULE_3__actions__["M" /* sendTestEmailFailed */]), function (state, action) {
  return action.type;
}), null);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  orgSettings: orgSettings,
  agentSettings: agentSettings,
  salesforceMappings: salesforceMappings,
  editingAgentSettings: editingAgentSettings,
  editingOrgSettings: editingOrgSettings,
  personalizationTags: personalizationTags,
  sendingTestEmailStatus: sendingTestEmailStatus
}));

/***/ }),

/***/ "kKL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_segment_selectors__ = __webpack_require__("iAL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_actions__ = __webpack_require__("x8Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component__ = __webpack_require__("Cloq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux__ = __webpack_require__("2KeS");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

















var mapStateToProps = function mapStateToProps(state) {
  var sequence = __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_74" /* sequence */](state);
  return {
    sequence: sequence,
    currentUserId: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentUserId"](state),
    currentUserName: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentUserName"](state),
    currentUserEmail: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentUserEmail"](state),
    emails: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["y" /* emails */](state),
    isMarketingSequencePlaybook: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_3" /* getIsMarketingSequencePlaybook */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state),
    marketingEmailLayout: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_53" /* marketingEmailLayout */](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    orgName: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["orgName"](state),
    orgLogoUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["orgLogoUrl"](state),
    orgTwitterUrl: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["t" /* orgTwitterLink */](state),
    orgLinkedinUrl: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["r" /* orgLinkedinLink */](state),
    orgFacebookUrl: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["q" /* orgFacebookLink */](state),
    orgAddress: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["p" /* orgAddress */](state),
    backgroundColor: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["a" /* backgroundColor */](state),
    showBranding: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["l" /* getOrgShowBranding */](state),
    userListIds: __WEBPACK_IMPORTED_MODULE_7_app_modules_segment_selectors__["e" /* segments */](state),
    isTemplateContactPreviewLoading: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_51" /* isTemplateContactPreviewLoading */](state),
    getEmailTemplate: function getEmailTemplate(emailId) {
      return __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_15" /* getRenderedEmailPreview */](state, emailId);
    },
    sequenceSenderEmailOverride: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_80" /* sequenceSenderEmailOverride */](state),
    sequenceSendFromOverride: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_79" /* sequenceSendFromOverride */](state),
    sequenceDynamicSendAttribute: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_76" /* sequenceDynamicSendAttribute */](state),
    senderEmailOverride: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_73" /* senderEmailOverride */](state),
    sendFromOverride: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["_73" /* senderEmailOverride */](state),
    dynamicAccountSendAttribute: __WEBPACK_IMPORTED_MODULE_2_app_modules_playbook_selectors__["t" /* dynamicAccountSendAttribute */](state),
    hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_org_selectors__["hasLimitedContactsMktEmail"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_12_redux__["b" /* bindActionCreators */])({
      fetchSegmentList: __WEBPACK_IMPORTED_MODULE_9_app_modules_segment_actions__["d" /* fetchSegmentList */],
      fetchRenderedEmailPreview: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_4" /* fetchDataPreviewSequenceEmail */],
      hasLimitedContactsMktEmail: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_actions__["hasLimitedContactsMktEmail"]
    }, dispatch)
  };
};

var replaceCalendarTokenForTemplate = function replaceCalendarTokenForTemplate(template) {
  return template && template.replace("<div><span class=\"drift-editor-tag mceNonEditable\">{{ sender.upcoming_availability }}</span></div>", "<div class=\"calendar-injection\"><span class=\"drift-editor-tag mceNonEditable calendar-preview\"></span></div>");
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        _props$actions = _props.actions,
        fetchRenderedEmailPreview = _props$actions.fetchRenderedEmailPreview,
        fetchSegmentList = _props$actions.fetchSegmentList,
        hasLimitedContactsMktEmail = _props$actions.hasLimitedContactsMktEmail,
        currentUserEmail = _props.currentUserEmail,
        currentUserId = _props.currentUserId,
        emails = _props.emails,
        orgUsers = _props.orgUsers,
        sequenceSenderEmailOverride = _props.sequenceSenderEmailOverride;


    fetchSegmentList();
    hasLimitedContactsMktEmail();

    emails.map(function (_ref) {
      var id = _ref.id,
          senderEmailOverride = _ref.senderEmailOverride;

      // Find the sender for each email - account for full sequence override or individual email override.
      var senderEmail = senderEmailOverride || sequenceSenderEmailOverride || senderEmailOverride || currentUserEmail;
      // If navigating directly to the preview page, orgUsers will be empty, so default to the current user.
      var sender = orgUsers.toJS().find(function (user) {
        return user.email === senderEmail;
      });
      fetchRenderedEmailPreview({ emailId: id, userListIds: [], userId: sender && sender.id || currentUserId });
    });
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    userListIdOptions: props.userListIds.map(function (segment) {
      return _extends(segment.toJS(), { label: segment.name, value: segment.id });
    }).toJS()
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedPreview', 'changeSelectedPreview', __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].DEFAULTS), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedUserListOption', 'changeUserListOption', undefined), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  var getDynamicAttr = function getDynamicAttr(email) {
    return email.get('dynamicAccountSendAttribute') || props.sequenceDynamicSendAttribute || props.dynamicAccountSendAttribute;
  };
  return {
    getIsDynamicSender: function getIsDynamicSender(email) {
      return !!getDynamicAttr(email);
    },
    getPreviewMessage: function getPreviewMessage(emailId, message) {
      return props.selectedPreview === __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE ? message : replaceCalendarTokenForTemplate(props.getEmailTemplate(emailId));
    },
    getFromName: function getFromName(email) {
      return !!getDynamicAttr(email) ? getDynamicAttr(email) : email.get('sendFromOverride') || props.sequenceSendFromOverride || props.sendFromOverride || props.currentUserName;
    },
    getFromEmail: function getFromEmail(email) {
      return !!getDynamicAttr(email) ? null : email.get('senderEmailOverride') || props.sequenceSenderEmailOverride || props.senderEmailOverride || props.currentUserEmail;
    }
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onRenderedPreviewClick: function onRenderedPreviewClick(props) {
    return function () {
      props.changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA);
    };
  },
  onDefaultPreviewClick: function onDefaultPreviewClick(props) {
    return function () {
      var changeSelectedPreview = props.changeSelectedPreview,
          emails = props.emails,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].DEFAULTS);
      emails.map(function (_ref2) {
        var id = _ref2.id;
        return fetchRenderedEmailPreview({ emailId: id, userListIds: [] });
      });
    };
  },
  onTemplatePreviewClick: function onTemplatePreviewClick(props) {
    return function () {
      props.changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].TEMPLATE);
    };
  },
  handleChangeUserListOption: function handleChangeUserListOption(props) {
    return function (option) {
      var changeUserListOption = props.changeUserListOption,
          changeSelectedPreview = props.changeSelectedPreview,
          emails = props.emails,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      changeUserListOption(option);
      emails.map(function (_ref3) {
        var id = _ref3.id,
            campaignId = _ref3.campaignId;
        return fetchRenderedEmailPreview({ emailId: id, userListIds: [option.id], campaignId: campaignId });
      });
      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA);
    };
  },
  onRefreshPreviewClick: function onRefreshPreviewClick(props) {
    return function () {
      var selectedUserListOption = props.selectedUserListOption,
          changeSelectedPreview = props.changeSelectedPreview,
          emails = props.emails,
          fetchRenderedEmailPreview = props.actions.fetchRenderedEmailPreview;

      if (selectedUserListOption) emails.map(function (_ref4) {
        var id = _ref4.id,
            campaignId = _ref4.campaignId;
        return fetchRenderedEmailPreview({ emailId: id, userListIds: [selectedUserListOption.id], campaignId: campaignId });
      });
      changeSelectedPreview(__WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_constants__["_19" /* EmailPreviewView */].RENDERED_DATA);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_11__component__["a" /* SequencePreview */]));

/***/ }),

/***/ "kMz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("hOuJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("XBhg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "kPnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__ = __webpack_require__("dLe+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("85Tc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);








var SequenceInviteModal = function SequenceInviteModal(_ref) {
  var users = _ref.users,
      options = _ref.options,
      onNext = _ref.onNext,
      onCloseClick = _ref.onCloseClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__PlaybookModal__["a" /* default */],
    {
      hideDescription: true,
      title: 'Share Sequence',
      isOpen: true,
      contentClassName: 'playbook-sequence-invite-modal',
      onCloseClick: onCloseClick
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_InviteSelect__["a" /* default */], {
      users: users,
      options: options,
      CTA: 'Share',
      onNext: onNext
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SequenceInviteModal);

/***/ }),

/***/ "kPt/":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMzc0IDI4NC42IDQyIDQyLjQiPjxzdHlsZT4uc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzlhOWE5YTtzdHJva2Utd2lkdGg6Mi40fS5zdDF7ZmlsbDojOWE5YTlhfTwvc3R5bGU+PHRpdGxlPm5vdW5fOTczMzVfY2M8L3RpdGxlPjxnIGlkPSJOUFMtUmVwb3J0Ij48ZyBpZD0iZGVmYXVsdC0tLWNvbGxhcHNlZC1wcmV2aWV3Ij48ZyBpZD0iR3JvdXBfMV8iPjxnIGlkPSJub3VuXzk3MzM1X2NjIj48ZyBpZD0iR3JvdXAiPjxwYXRoIGlkPSJTaGFwZSIgY2xhc3M9InN0MCIgZD0iTS0zNTMgMzI0LjhjLTEwLjUgMC0xOS04LjQtMTktMTguOHM4LjUtMTguOCAxOS0xOC44IDE5IDguNCAxOSAxOC44LTguNSAxOC44LTE5IDE4Ljh6bTAtMzYuNGMtOS45IDAtMTcuOSA3LjktMTcuOSAxNy43IDAgOS44IDggMTcuNyAxNy45IDE3LjdzMTcuOS03LjkgMTcuOS0xNy43YzAtOS44LTgtMTcuNy0xNy45LTE3Ljd6Ii8+PC9nPjxnIGlkPSJzdGFyIj48cGF0aCBpZD0iU2hhcGVfMV8iIGNsYXNzPSJzdDEiIGQ9Ik0tMzQ4LjE0MiAzMTQuOTM2bC00LjctMi40aC0uMWwtNC43IDIuNGMtLjYuMy0xLjMuMS0xLjctLjMtLjMtLjMtLjQtLjctLjMtMS4xbC45LTUuMnYtLjFsLTMuOS0zLjZjLS40LS40LS41LS45LS4zLTEuNC4yLS41LjYtLjggMS4xLS45bDUuMy0uOGMuMSAwIC4xIDAgLjEtLjFsMi40LTQuN2MuMy0uNC43LS44IDEuMi0uOHMxIC4zIDEuMi44bDIuNCA0LjcuMS4xIDUuMy44Yy41LjEgMSAuNCAxLjEuOS4yLjUgMCAxLS4zIDEuNGwtMy45IDMuNnMtLjEuMSAwIC4xbC45IDUuMmMuMS40LS4xLjgtLjMgMS4xLS4xLjMtLjQuNC0uOS40LS41LjEtLjcgMC0uOS0uMXoiLz48cGF0aCBpZD0iUGF0aCIgY2xhc3M9InN0MSIgZD0iTS0zNTIuNDQyIDMxMS41MzZsNC44IDIuNXMuMSAwIC4xLS4xdi0uMWwtLjgtNS4yYy0uMS0uNC4xLS45LjQtMS4ybDMuOS0zLjdzLjEtLjEgMC0uMWMwLS4xLS4xLS4xLS4xLS4xbC01LjMtLjhjLS41LS4xLS44LS4zLTEtLjhsLTIuNC00LjdzMC0uMS0uMS0uMS0uMS4xLS4xLjFsLTIuNCA0LjdjLS4yLjQtLjYuNy0xIC44bC01LjQuOHMtLjEgMC0uMS4xdi4xbDMuOSAzLjdjLjMuMy41LjguNCAxLjJsLS45IDUuMnYuMWwuMS4xIDQuOC0yLjVjLjMtLjEuNS0uMS43LS4xcy4zIDAgLjUuMXoiLz48L2c+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "kTiu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+ZmFjZWJvb2s8L3RpdGxlPjxwYXRoIGQ9Ik0xMiAwYzYuNjExIDAgMTIgNS4zODkgMTIgMTIgMCA2LjYzOS01LjM4OSAxMi0xMiAxMi02LjYzOSAwLTEyLTUuMzYxLTEyLTEyQzAgNS4zODkgNS4zNjEgMCAxMiAwem0xIDEwLjAyOFY3Ljg2YzAtLjgzMy4xNjctMS4zNjEgMS4yMjItMS4zNjFoMS42NEwxNiAzLjY2N3MtLjgzMy0uMTY3LTIuMjc4LS4xNjdDMTAuNzc4IDMuNSA5LjUgNS4yNzggOS41IDcuMjc4VjEwaC0ydjNoMnY3LjVIMTNWMTNoMi44MDZMMTYgMTAuMDI4aC0zeiIgZmlsbD0iI0I2RDNFMSIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "kUVr":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 14 21\" xmlns=\"http://www.w3.org/2000/svg\"><title>Artboard 3</title><path d=\"M13.027 9.085c.843.77.85 2.015.014 2.79l-9.323 8.672c-.84.78-2.213.792-3.068.025-.856-.767-.868-2.022-.028-2.803l7.81-7.3L.638 3.385C-.21 2.61-.213 1.356.634.582c.847-.775 2.22-.776 3.07-.003l9.323 8.505z\" fill=\"#13CB6E\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "kWes":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QuestionAdvancedModal":"QuestionAdvancedModal---1ybUo"};

/***/ }),

/***/ "kXoj":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMiAyNy4wNjNWMjVoMnYyLjA2M2MzLjgyMy40OTIgNi41IDMuNzg4IDYuNSA3LjkzN3YxaC0xNXYtMWMwLTQuMTUgMi42NzctNy40NDUgNi41LTcuOTM3em0yLTIzLjMzYTIgMiAwIDEgMC0yIDBWN0gzLjAwNUEzIDMgMCAwIDAgMCA5Ljk5NHYxMi4wMTJBMyAzIDAgMCAwIDMuMDA1IDI1aDE5Ljk5QTMgMyAwIDAgMCAyNiAyMi4wMDZWOS45OTRBMyAzIDAgMCAwIDIyLjk5NSA3SDE0VjMuNzMyek0yIDkuOTkzQTEgMSAwIDAgMSAzLjAwNSA5aDE5Ljk5QTEgMSAwIDAgMSAyNCA5Ljk5NHYxMi4wMTJhMSAxIDAgMCAxLTEuMDA1Ljk5NEgzLjAwNUExIDEgMCAwIDEgMiAyMi4wMDZWOS45OTR6TTcuNTY3IDM0Yy40MDEtMi45MjUgMi41NTctNSA1LjQzMy01czUuMDMyIDIuMDc1IDUuNDMzIDVINy41Njd6TTguNSAxNy41YTIuNSAyLjUgMCAxIDAgMC01IDIuNSAyLjUgMCAwIDAgMCA1em05IDBhMi41IDIuNSAwIDEgMCAwLTUgMi41IDIuNSAwIDAgMCAwIDV6IiBmaWxsPSIjQjVEMkUxIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ "kbde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kfQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_api__ = __webpack_require__("a5br");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl__ = __webpack_require__("LhIC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LIVE_VIEW_TAG = 'Live View';

var StartConversationModal = function (_Component) {
  _inherits(StartConversationModal, _Component);

  function StartConversationModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StartConversationModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StartConversationModal.__proto__ || Object.getPrototypeOf(StartConversationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      message: '',
      sent: false,
      sending: false
    }, _this.handleChange = function (e) {
      _this.setState({ message: e.target.value });
    }, _this.sendMessage = function (e) {
      e.preventDefault();
      _this.setState({ sending: true }, _this.handleSendClick);
    }, _this.handleSendClick = function () {
      _this.props.listenForMessageSent(_this.props.userId);

      var messageCopyDelay = function messageCopyDelay() {
        return setTimeout(function () {
          return _this.setState({ sent: false });
        }, 15000);
      };

      var message = {
        body: _this.state.message,
        status: 'CLOSED',
        orgId: _this.props.currentUser.orgId,
        authorId: _this.props.currentUser.id,
        inboxId: _this.props.outboundInboxId || _this.props.defaultInboxId,
        authorType: 'USER',
        attributes: {
          liveViewInitiated: true
        },
        tags: [LIVE_VIEW_TAG],
        to: {
          id: _this.props.userId,
          type: _this.props.userType
        }
      };

      Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_conversation_api__["b" /* createConversation */])(message).then(function (resp) {
        _this.setState({
          message: '',
          sentConversationLink: '/inboxes/' + resp.inboxId + '/conversations/' + resp.conversationId,
          sent: true,
          sending: false
        }, messageCopyDelay);
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StartConversationModal, [{
    key: 'render',
    value: function render() {
      var sentCopy = this.state.sent ? 'Sent!' : 'Send message';
      var isConversationDisabled = this.props.isConversationDisabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'lite-contact-send-message' },
          this.state.sent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'lite-contact-message-sent' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Your message was sent!'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: this.state.sentConversationLink },
              'View conversation'
            )
          ),
          !this.state.sent && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { className: 'drift-form', onSubmit: this.sendMessage },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'fieldset',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                  disabled: isConversationDisabled,
                  placeholder: 'Hey! How\u2019s the weather over there?',
                  required: true,
                  autoFocus: true,
                  value: this.state.message,
                  onChange: this.handleChange
                })
              )
            ),
            this.state.sending && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'Sending Message...'
            ),
            !this.state.sending && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Button"],
              {
                onClick: this.sendMessage,
                disabled: isConversationDisabled
              },
              sentCopy
            )
          )
        )
      );
    }
  }]);

  return StartConversationModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["currentUser"])(state),
    isConversationDisabled: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_gates_selectors__["b" /* disableNewMessageComposer */])(state),
    defaultInboxId: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_selectors__["b" /* defaultInboxId */](state),
    outboundInboxId: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__["getOutboundInboxId"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(StartConversationModal));

/***/ }),

/***/ "khXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"WidgetSizePicker":"WidgetSizePicker---k_AqX"};

/***/ }),

/***/ "khh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var OrgPropertiesActions = Marty.createActionCreators({
  updateProperties: function updateProperties(orgId, properties, notificationMessage) {
    return this.app.queries.OrgPropertiesQueries.updateProperties(orgId, properties, notificationMessage);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgPropertiesActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "khns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchClassifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchClassificationsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchClassificationsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchClassificationsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createClassifications; });
/* unused harmony export createClassificationsPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createClassificationsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createClassificationsSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("2rb0");



var fetchClassifications = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_CLASSIFICATIONS */]);
var fetchClassificationsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_CLASSIFICATIONS_PENDING */]);
var fetchClassificationsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_CLASSIFICATIONS_FAILED */]);
var fetchClassificationsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_CLASSIFICATIONS_SUCCESS */]);

var createClassifications = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CREATE_CLASSIFICATIONS */]);
var createClassificationsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* CREATE_CLASSIFICATIONS_PENDING */]);
var createClassificationsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* CREATE_CLASSIFICATIONS_FAILED */]);
var createClassificationsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* CREATE_CLASSIFICATIONS_SUCCESS */]);

/***/ }),

/***/ "khqj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kj23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__);



function renderLocation(endUser) {
  if (endUser.attributes.display_location) {
    return endUser.attributes.display_location + ' . ';
  }
}

function makeDisplay(author, endUser, timestamp) {
  return React.createElement(
    'div',
    { className: 'dsg-Regular color-navy-dark' },
    __WEBPACK_IMPORTED_MODULE_0_moment___default()(timestamp).format('LLL'),
    ' .\xA0',
    renderLocation(endUser),
    'Sent by ' + Object(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(author)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (makeDisplay);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "kk7P":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 45 31\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M43.594 31H1.406C.63 31 0 30.37 0 29.59V1.41C0 .63.63 0 1.406 0h42.188C44.37 0 45 .63 45 1.41v28.18c0 .78-.63 1.41-1.406 1.41zM42.187 2.818H2.813v25.364H8.44v-1.41c0-.777.63-1.408 1.407-1.408.776 0 1.406.63 1.406 1.41v1.408H33.75v-1.41c0-.777.63-1.408 1.406-1.408.778 0 1.407.63 1.407 1.41v1.408h5.624V2.818zm-5.624 14.09h-11.25c-.775 0-1.405-.63-1.405-1.408 0-.778.63-1.41 1.406-1.41h11.248c.778 0 1.407.632 1.407 1.41 0 .778-.63 1.41-1.407 1.41zm0-5.635h-11.25c-.775 0-1.405-.632-1.405-1.41 0-.777.63-1.408 1.406-1.408h11.248c.778 0 1.407.63 1.407 1.41 0 .776-.63 1.408-1.407 1.408zm-17.81 11.272H9.376c-1.292 0-2.343-1.107-2.343-2.467V19.02c0-.044.02-.08.024-.123.008-.097.028-.188.058-.28.025-.087.054-.168.095-.247.042-.077.093-.146.147-.217.06-.076.124-.142.2-.204.033-.03.052-.07.09-.093l2.67-1.836c-.448-1.03-.48-1.904-.468-2.26 0-.006-.003-.01-.003-.017V10.57c0-.037.02-.068.022-.103.002-.044-.012-.085-.005-.13.34-2.032 2.444-3.29 4.2-3.29h.007c1.748 0 3.848 1.257 4.19 3.29.008.042-.006.083-.003.127.002.037.02.068.02.106l.003 3.173-.003.015c.012.353-.02 1.225-.467 2.255l2.673 1.846c.037.024.055.062.087.09.075.06.14.13.2.206.055.07.104.138.145.216.042.08.07.16.097.248.028.09.046.18.056.277.004.043.025.08.025.123v1.058c0 1.36-1.05 2.467-2.343 2.467zm-3.58-4.934c-.03-.017-.063-.026-.09-.047-.126-.097-.216-.22-.3-.345-.01-.013-.023-.023-.03-.037-.072-.113-.11-.24-.146-.368-.014-.05-.04-.097-.05-.15-.014-.085 0-.173.003-.262.002-.098-.004-.194.02-.29.01-.046.038-.086.053-.13.04-.12.075-.24.15-.35.01-.016.03-.024.042-.04v-.003c.68-.885.648-1.693.647-1.702-.003-.03.01-.058.008-.09 0-.015-.01-.03-.01-.048l-.003-2.986c-.11-.403-.773-.896-1.403-.896s-1.297.493-1.404.896l-.002 2.987c0 .014-.007.025-.007.04 0 .026.01.05.01.077-.005.066-.025.855.642 1.722.01.01.01.025.018.038.008.01.02.015.03.027.046.07.06.147.092.22.04.087.09.168.11.258.02.092.014.184.017.277.002.087.014.173 0 .26-.014.09-.055.174-.085.26-.03.083-.05.167-.098.245-.047.08-.12.142-.184.213-.055.06-.09.13-.156.178-.01.01-.027.014-.04.023-.01.008-.013.02-.024.026l-3.086 2.117h8.34L15.17 17.61zm10.14 2.117h5.626c.775 0 1.405.632 1.405 1.41 0 .777-.63 1.408-1.406 1.408h-5.626c-.776 0-1.406-.63-1.406-1.41 0-.776.63-1.408 1.406-1.408z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "kk8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return GOOGLE_OAUTH_ACCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GOOGLE_OAUTH_ACCEPT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GOOGLE_OAUTH_ACCEPT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return MICROSOFT_OAUTH_ACCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return MICROSOFT_OAUTH_ACCEPT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return MICROSOFT_OAUTH_ACCEPT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return ZOOM_OAUTH_ACCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return ZOOM_OAUTH_ACCEPT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return ZOOM_OAUTH_ACCEPT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_CALENDAR_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_CALENDAR_STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_CALENDAR_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_CALENDAR_STATUS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return FETCH_MICROSOFT_CALENDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return FETCH_MICROSOFT_CALENDARS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return FETCH_MICROSOFT_CALENDARS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return FETCH_MICROSOFT_CALENDARS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return FETCH_MICROSOFT_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return FETCH_MICROSOFT_ADMIN_CONSENT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return FETCH_MICROSOFT_MANAGED_CALENDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DISCONNECT_MICROSOFT_ADMIN_CONSENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DISCONNECT_MICROSOFT_ADMIN_CONSENT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DISCONNECT_MICROSOFT_ADMIN_CONSENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISCONNECT_MICROSOFT_ADMIN_CONSENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return MICROSOFT_ADMIN_MANAGED_ACCEPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_GOOGLE_CALENDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_GOOGLE_CALENDARS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_GOOGLE_CALENDARS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_GOOGLE_CALENDARS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return UPDATE_GOOGLE_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return UPDATE_GOOGLE_CALENDAR_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return UPDATE_GOOGLE_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return UPDATE_GOOGLE_CALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return UPDATE_MICROSOFT_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return UPDATE_MICROSOFT_CALENDAR_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return UPDATE_MICROSOFT_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return UPDATE_MICROSOFT_CALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DISCONNECT_GOOGLE_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DISCONNECT_GOOGLE_CALENDAR_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DISCONNECT_GOOGLE_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DISCONNECT_GOOGLE_CALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DISCONNECT_MICROSOFT_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DISCONNECT_MICROSOFT_CALENDAR_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DISCONNECT_MICROSOFT_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DISCONNECT_MICROSOFT_CALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_GOOGLE_SCOPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return FETCH_GOOGLE_SCOPES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return FETCH_GOOGLE_SCOPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_GOOGLE_SCOPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_MEETING_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return FETCH_MEETING_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return FETCH_MEETING_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return FETCH_MEETING_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return FETCH_MEETING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return FETCH_MEETING_TYPES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return FETCH_MEETING_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return FETCH_MEETING_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_CALENDLY_MEETING_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_CALENDLY_MEETING_TYPES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_CALENDLY_MEETING_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_CALENDLY_MEETING_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return UPDATE_MEETING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return UPDATE_MEETING_TYPE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return UPDATE_MEETING_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return UPDATE_MEETING_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBOUNCE_UPDATE_MEETING_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return UPDATE_MEETING_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return UPDATE_MEETING_SETTINGS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return UPDATE_MEETING_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return UPDATE_MEETING_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_MEETING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_MEETING_TYPE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_MEETING_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_MEETING_TYPE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SHARE_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SHARE_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SHARE_CALENDAR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_CONNECTED_CALENDARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_CONNECTED_CALENDARS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_CONNECTED_CALENDARS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_CONNECTED_CALENDARS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SHARE_ROUTED_CALENDAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SHARE_ROUTED_CALENDAR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SHARE_ROUTED_CALENDAR_FAILURE; });
/* unused harmony export SHARE_ROUTED_CALENDAR_PENDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return OPENED_MEETING_EMAIL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return MeetingSource; });
var ACTION_PREFIX = '@@app/meetings';
var makeConstant = function makeConstant(constant) {
  return ACTION_PREFIX + '/' + constant;
};

var GOOGLE_OAUTH_ACCEPT = makeConstant('GOOGLE_OAUTH_ACCEPT');
var GOOGLE_OAUTH_ACCEPT_SUCCESS = makeConstant('GOOGLE_OAUTH_ACCEPT_SUCCESS');
var GOOGLE_OAUTH_ACCEPT_FAILURE = makeConstant('GOOGLE_OAUTH_ACCEPT_FAILURE');

var MICROSOFT_OAUTH_ACCEPT = makeConstant('MICROSOFT_OAUTH_ACCEPT');
var MICROSOFT_OAUTH_ACCEPT_SUCCESS = makeConstant('MICROSOFT_OAUTH_ACCEPT_SUCCESS');
var MICROSOFT_OAUTH_ACCEPT_FAILURE = makeConstant('MICROSOFT_OAUTH_ACCEPT_FAILURE');

var ZOOM_OAUTH_ACCEPT = makeConstant('ZOOM_OAUTH_ACCEPT');
var ZOOM_OAUTH_ACCEPT_SUCCESS = makeConstant('ZOOM_OAUTH_ACCEPT_SUCCESS');
var ZOOM_OAUTH_ACCEPT_FAILURE = makeConstant('ZOOM_OAUTH_ACCEPT_FAILURE');

var FETCH_CALENDAR_STATUS = makeConstant('FETCH_CALENDAR_STATUS');
var FETCH_CALENDAR_STATUS_PENDING = makeConstant('FETCH_CALENDAR_STATUS_PENDING');
var FETCH_CALENDAR_STATUS_SUCCESS = makeConstant('FETCH_CALENDAR_STATUS_SUCCESS');
var FETCH_CALENDAR_STATUS_FAILURE = makeConstant('FETCH_CALENDAR_STATUS_FAILURE');

var FETCH_MICROSOFT_CALENDARS = makeConstant('FETCH_MICROSOFT_CALENDARS');
var FETCH_MICROSOFT_CALENDARS_PENDING = makeConstant('FETCH_MICROSOFT_CALENDARS_PENDING');
var FETCH_MICROSOFT_CALENDARS_SUCCESS = makeConstant('FETCH_MICROSOFT_CALENDARS_SUCCESS');
var FETCH_MICROSOFT_CALENDARS_FAILURE = makeConstant('FETCH_MICROSOFT_CALENDARS_FAILURE');

var FETCH_MICROSOFT_ADMIN_CONSENT = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT');
var FETCH_MICROSOFT_ADMIN_CONSENT_PENDING = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_PENDING');
var FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS');
var FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE = makeConstant('FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE');

var FETCH_MICROSOFT_MANAGED_CALENDARS = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS');
var FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING');
var FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS');
var FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE = makeConstant('FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE');

var DISCONNECT_MICROSOFT_ADMIN_CONSENT = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT ');
var DISCONNECT_MICROSOFT_ADMIN_CONSENT_PENDING = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _PENDING');
var DISCONNECT_MICROSOFT_ADMIN_CONSENT_SUCCESS = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _SUCCESS');
var DISCONNECT_MICROSOFT_ADMIN_CONSENT_FAILURE = makeConstant('DISCONNECT_MICROSOFT_ADMIN_CONSENT _FAILURE');

var MICROSOFT_ADMIN_MANAGED_ACCEPT = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT');
var MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS');
var MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE = makeConstant('MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE');

var FETCH_GOOGLE_CALENDARS = makeConstant('FETCH_GOOGLE_CALENDARS');
var FETCH_GOOGLE_CALENDARS_PENDING = makeConstant('FETCH_GOOGLE_CALENDARS_PENDING');
var FETCH_GOOGLE_CALENDARS_SUCCESS = makeConstant('FETCH_GOOGLE_CALENDARS_SUCCESS');
var FETCH_GOOGLE_CALENDARS_FAILURE = makeConstant('FETCH_GOOGLE_CALENDARS_FAILURE');

var UPDATE_GOOGLE_CALENDAR = makeConstant('UPDATE_GOOGLE_CALENDAR');
var UPDATE_GOOGLE_CALENDAR_PENDING = makeConstant('UPDATE_GOOGLE_CALENDAR_PENDING');
var UPDATE_GOOGLE_CALENDAR_SUCCESS = makeConstant('UPDATE_GOOGLE_CALENDAR_SUCCESS');
var UPDATE_GOOGLE_CALENDAR_FAILURE = makeConstant('UPDATE_GOOGLE_CALENDAR_FAILURE');

var UPDATE_MICROSOFT_CALENDAR = makeConstant('UPDATE_MICROSOFT_CALENDAR');
var UPDATE_MICROSOFT_CALENDAR_PENDING = makeConstant('UPDATE_MICROSOFT_CALENDAR_PENDING');
var UPDATE_MICROSOFT_CALENDAR_SUCCESS = makeConstant('UPDATE_MICROSOFT_CALENDAR_SUCCESS');
var UPDATE_MICROSOFT_CALENDAR_FAILURE = makeConstant('UPDATE_MICROSOFT_CALENDAR_FAILURE');

var DISCONNECT_GOOGLE_CALENDAR = makeConstant('DISCONNECT_GOOGLE_CALENDAR');
var DISCONNECT_GOOGLE_CALENDAR_PENDING = makeConstant('DISCONNECT_GOOGLE_CALENDAR_PENDING');
var DISCONNECT_GOOGLE_CALENDAR_SUCCESS = makeConstant('DISCONNECT_GOOGLE_CALENDAR_SUCCESS');
var DISCONNECT_GOOGLE_CALENDAR_FAILURE = makeConstant('DISCONNECT_GOOGLE_CALENDAR_FAILURE');

var DISCONNECT_MICROSOFT_CALENDAR = makeConstant('DISCONNECT_MICROSOFT_CALENDAR');
var DISCONNECT_MICROSOFT_CALENDAR_PENDING = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_PENDING');
var DISCONNECT_MICROSOFT_CALENDAR_SUCCESS = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_SUCCESS');
var DISCONNECT_MICROSOFT_CALENDAR_FAILURE = makeConstant('DISCONNECT_MICROSOFT_CALENDAR_FAILURE');

var FETCH_GOOGLE_SCOPES = makeConstant('FETCH_GOOGLE_SCOPES');
var FETCH_GOOGLE_SCOPES_PENDING = makeConstant('FETCH_GOOGLE_SCOPES_PENDING');
var FETCH_GOOGLE_SCOPES_SUCCESS = makeConstant('FETCH_GOOGLE_SCOPES_SUCCESS');
var FETCH_GOOGLE_SCOPES_FAILURE = makeConstant('FETCH_GOOGLE_SCOPES_FAILURE');

var FETCH_MEETING_SETTINGS = makeConstant('FETCH_MEETING_SETTINGS');
var FETCH_MEETING_SETTINGS_PENDING = makeConstant('FETCH_MEETING_SETTINGS_PENDING');
var FETCH_MEETING_SETTINGS_SUCCESS = makeConstant('FETCH_MEETING_SETTINGS_SUCCESS');
var FETCH_MEETING_SETTINGS_FAILURE = makeConstant('FETCH_MEETING_SETTINGS_FAILURE');

var FETCH_MEETING_TYPES = makeConstant('FETCH_MEETING_TYPES');
var FETCH_MEETING_TYPES_PENDING = makeConstant('FETCH_MEETING_TYPES_PENDING');
var FETCH_MEETING_TYPES_SUCCESS = makeConstant('FETCH_MEETING_TYPES_SUCCESS');
var FETCH_MEETING_TYPES_FAILURE = makeConstant('FETCH_MEETING_TYPES_FAILURE');

var FETCH_CALENDLY_MEETING_TYPES = makeConstant('FETCH_CALENDLY_MEETING_TYPES');
var FETCH_CALENDLY_MEETING_TYPES_PENDING = makeConstant('FETCH_CALENDLY_MEETING_TYPES_PENDING');
var FETCH_CALENDLY_MEETING_TYPES_SUCCESS = makeConstant('FETCH_CALENDLY_MEETING_TYPES_SUCCESS');
var FETCH_CALENDLY_MEETING_TYPES_FAILURE = makeConstant('FETCH_CALENDLY_MEETING_TYPES_FAILURE');

var UPDATE_MEETING_TYPE = makeConstant('UPDATE_MEETING_TYPE');
var UPDATE_MEETING_TYPE_PENDING = makeConstant('UPDATE_MEETING_TYPE_PENDING');
var UPDATE_MEETING_TYPE_SUCCESS = makeConstant('UPDATE_MEETING_TYPE_SUCCESS');
var UPDATE_MEETING_TYPE_FAILURE = makeConstant('UPDATE_MEETING_TYPE_FAILURE');

var DEBOUNCE_UPDATE_MEETING_SETTINGS = makeConstant('DEBOUNCE_UPDATE_MEETING_SETTINGS');
var UPDATE_MEETING_SETTINGS = makeConstant('UPDATE_MEETING_SETTINGS');
var UPDATE_MEETING_SETTINGS_PENDING = makeConstant('UPDATE_MEETING_SETTINGS_PENDING');
var UPDATE_MEETING_SETTINGS_SUCCESS = makeConstant('UPDATE_MEETING_SETTINGS_SUCCESS');
var UPDATE_MEETING_SETTINGS_FAILURE = makeConstant('UPDATE_MEETING_SETTINGS_FAILURE');

var DELETE_MEETING_TYPE = makeConstant('DELETE_MEETING_TYPE');
var DELETE_MEETING_TYPE_PENDING = makeConstant('DELETE_MEETING_TYPE_PENDING');
var DELETE_MEETING_TYPE_SUCCESS = makeConstant('DELETE_MEETING_TYPE_SUCCESS');
var DELETE_MEETING_TYPE_FAILURE = makeConstant('DELETE_MEETING_TYPE_FAILURE');

var UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS = makeConstant('UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS');
var UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING = makeConstant('UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING');
var UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS = makeConstant('UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS');
var UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE = makeConstant('UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE');

var SHARE_CALENDAR = makeConstant('SHARE_CALENDAR');
var SHARE_CALENDAR_SUCCESS = makeConstant('SHARE_CALENDAR_SUCCESS');
var SHARE_CALENDAR_FAILURE = makeConstant('SHARE_CALENDAR_FAILURE');

var FETCH_CONNECTED_CALENDARS = makeConstant('FETCH_CONNECTED_CALENDARS');
var FETCH_CONNECTED_CALENDARS_PENDING = makeConstant('FETCH_CONNECTED_CALENDARS_PENDING');
var FETCH_CONNECTED_CALENDARS_SUCCESS = makeConstant('FETCH_CONNECTED_CALENDARS_SUCCESS');
var FETCH_CONNECTED_CALENDARS_FAILURE = makeConstant('FETCH_CONNECTED_CALENDARS_FAILURE');

var SHARE_ROUTED_CALENDAR = makeConstant('SHARE_ROUTED_CALENDAR');
var SHARE_ROUTED_CALENDAR_SUCCESS = makeConstant('SHARE_ROUTED_CALENDAR_SUCCESS');
var SHARE_ROUTED_CALENDAR_FAILURE = makeConstant('SHARE_ROUTED_CALENDAR_FAILURE');
var SHARE_ROUTED_CALENDAR_PENDING = makeConstant('SHARE_ROUTED_CALENDAR_PENDING');

var OPENED_MEETING_EMAIL_MODAL = makeConstant('OPENED_MEETING_EMAIL_MODAL');

var MeetingSource = Object.freeze({
  CALENDAR_DROP: 'CALENDAR_DROP',
  EMAIL_DROP: 'EMAIL_DROP',
  PLAYBOOK_DROP: 'PLAYBOOK_DROP',
  PROFILE_DROP: 'PROFILE_DROP',
  PROFILE_LINK: 'PROFILE_LINK',
  RESCHEDULE: 'RESCHEDULE',
  SEQUENCE_DROP: 'SEQUENCE_DROP',
  NONE: 'NONE'
});

/***/ }),

/***/ "kl36":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 188 65\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path class=\"logo-white\" d=\"M56.434 23.615c-.485-.283-1.084-.283-1.57 0L34.81 35.308c-.486.284-.785.807-.785 1.374v6.165c0 .567.3 1.09.785 1.373.482.28 1.072.28 1.556.006.003-.002.01-.004.013-.007l6.597-3.85v14.294c0 .565.3 1.09.785 1.372.243.14.514.213.785.213.27 0 .54-.073.785-.214l3.944-2.3c.485-.283.784-.806.784-1.372V36.24l6.374-3.718c.486-.284.785-.808.785-1.373v-6.163c0-.567-.3-1.09-.786-1.372M34.81 19.88l6.064 3.536c.192.11.31.318.31.54v4.28c0 .482.52.786.936.543 2.452-1.428 9.05-5.27 11.49-6.685.416-.24.408-.837-.006-1.078L36.38 10.973c-.486-.283-1.084-.283-1.57 0s-.785.806-.785 1.372v6.162c0 .566.3 1.09.785 1.372M31.256 10.973c-.486-.283-1.084-.283-1.57 0l-17.24 10.054c-.408.236-.416.82-.01 1.057 2.434 1.412 9.085 5.283 11.53 6.706.408.238.916-.06.916-.534V23.95c0-.22.115-.42.304-.53l5.76-3.36c.678-.396 1.095-1.12 1.095-1.906v-5.81c0-.565-.298-1.088-.784-1.37M30.917 35.308L10.862 23.615c-.486-.283-1.083-.283-1.57 0-.485.283-.784.805-.784 1.372v6.162c0 .564.3 1.088.785 1.372l6.374 3.717v16.124c0 .566.3 1.09.785 1.372l3.943 2.3c.245.14.515.213.785.213s.542-.073.785-.214c.485-.283.784-.807.784-1.372V40.37l6.597 3.85.015.006c.483.275 1.073.274 1.555-.006.485-.284.785-.806.785-1.373v-6.165c0-.567-.3-1.09-.785-1.374\" fill=\"#FFF\"></path><path d=\"M.71 32.664C.71 50.524 15.177 65 33.022 65c17.846 0 32.313-14.477 32.313-32.336 0-17.86-14.467-32.338-32.313-32.338C15.177.326.71 14.804.71 32.664zm31.302 8.12c0 .49-.26.945-.682 1.19-.418.245-.93.246-1.35.007-.005 0-.01-.003-.014-.006l-5.734-3.344v12.42c0 .493-.26.948-.68 1.194-.212.122-.447.185-.683.185-.236 0-.47-.064-.683-.186l-3.427-2c-.422-.245-.682-.7-.682-1.19V35.038l-5.54-3.23c-.422-.247-.68-.702-.68-1.194V25.26c0-.49.258-.945.68-1.19.423-.247.942-.247 1.364 0L31.33 34.23c.422.248.682.703.682 1.195v5.358zm.295-21.46c0 .68-.362 1.312-.95 1.656l-5.272 3.074v4.048c0 .412-.44.67-.796.465-2.124-1.237-7.904-4.602-10.018-5.83-.354-.204-.347-.71.006-.917l14.983-8.737c.423-.246.943-.246 1.365 0 .422.246.682.7.682 1.193v5.047zm1.725-5.048c0-.492.26-.947.682-1.193.422-.246.94-.246 1.363 0l14.976 8.732c.357.21.363.72.005.928-2.115 1.228-7.86 4.572-9.992 5.815-.362.21-.813-.053-.813-.473v-3.978c0-.033-.017-.064-.046-.08l-5.493-3.204c-.422-.247-.682-.7-.682-1.193v-5.354zm20.156 16.34c0 .492-.26.947-.682 1.194l-5.54 3.23v14.013c0 .49-.26.946-.68 1.192l-3.43 2c-.21.12-.446.184-.68.184-.237 0-.47-.064-.682-.186-.423-.246-.682-.7-.682-1.193V38.63l-5.735 3.344-.01.007c-.422.24-.935.24-1.353-.005-.422-.246-.682-.7-.682-1.192v-5.358c0-.492.26-.947.682-1.195l17.428-10.16c.422-.247.942-.247 1.364 0 .423.245.682.7.682 1.19v5.356zM82.265 17.083c0-.497.395-.942.89-.942h12.088c9.56 0 17.388 7.784 17.388 17.302 0 9.617-7.827 17.4-17.387 17.4H83.155c-.495 0-.89-.444-.89-.94V17.08zm12.928 26.423c5.598 0 9.215-4.412 9.215-10.064 0-5.6-3.617-10.014-9.215-10.014h-5.2v20.078h5.2zM116.84 29.03c0-.644.495-1.09 1.088-1.09h2.378c.596 0 .893.297 1.04.694l1.04 2.528c.99-1.834 2.725-3.718 5.698-3.718 2.082 0 3.618.545 4.458 1.19.397.297.397.792.15 1.24l-2.28 4.51c-.246.446-.644.794-1.288.545-.397-.15-1.238-.347-1.734-.347-1.733 0-3.02 1.24-3.02 3.172v11.998c0 .694-.398 1.09-1.24 1.09h-5.202c-.593 0-1.09-.496-1.09-1.09V29.03M136.665 20.478c0-2.38 1.883-4.362 4.258-4.362 2.38 0 4.312 1.983 4.312 4.362 0 2.33-1.933 4.264-4.312 4.264-2.375 0-4.258-1.934-4.258-4.264zm.546 8.527c0-.644.494-1.09 1.09-1.09h5.348c.597 0 1.09.446 1.09 1.09v20.723c0 .594-.493 1.09-1.09 1.09H138.3c-.596 0-1.09-.496-1.09-1.09V29.005zM151.88 34.73h-1.982c-.644 0-1.09-.494-1.09-1.09v-4.61c0-.644.446-1.09 1.09-1.09h1.982v-1.884c0-6.148 3.22-10.412 9.858-10.412 2.97 0 5.993 1.24 6.986 2.183.347.247.443.842.197 1.288l-2.426 4.263c-.25.398-.794.546-1.24.298-.742-.447-1.83-.892-2.972-.892-2.576 0-2.874 1.437-2.874 3.272v1.883h5.748c.593 0 1.088.446 1.088 1.09v4.61c0 .596-.495 1.09-1.088 1.09h-5.748v15.023c0 .594-.544 1.09-1.136 1.09h-5.302c-.546 0-1.09-.496-1.09-1.09V34.73M173.22 34.707h-1.882c-.545 0-.993-.496-.993-1.09v-4.612c0-.644.448-1.09.993-1.09h1.882V21.57c0-.596.495-1.092 1.09-1.092h5.448c.546 0 .99.496.99 1.09v6.347h4.61c.592 0 1.088.446 1.088 1.09v4.61c0 .596-.496 1.092-1.088 1.092h-4.61v7.98c0 1.092.546 1.587 1.538 1.587.792 0 2.277-.347 2.823-.495.594-.15 1.138.097 1.287.693l.992 4.313c.146.694-.102.99-.745 1.29-1.536.643-4.11 1.288-6.54 1.288-4.358 0-6.885-2.777-6.885-7.98v-8.677\" fill=\"#0176FF\"></path></g></svg>"

/***/ }),

/***/ "klvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SectionHeader":"SectionHeader---3I5zG"};

/***/ }),

/***/ "kmUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export WEEKDAYS */
/* unused harmony export HOUR_LABEL_FORMAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HOUR_FORMAT; });
/* unused harmony export MIDNIGHT_VALUE */
/* unused harmony export MIDNIGHT_LABEL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Hours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DAY_RANGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DAY_OPTIONS; });
/* unused harmony export DAY_OPTIONS_ORDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TIMEZONE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HOUR_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NotificationMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_timezoneHelpers__ = __webpack_require__("zSQi");





var WEEKDAYS = 'WEEKDAYS';

var HOUR_LABEL_FORMAT = 'h:mmA';
var HOUR_FORMAT = 'HH:mm:ss';

var MIDNIGHT_VALUE = '23:59:59';
var MIDNIGHT_LABEL = '11:59PM';

var DEFAULT_OPEN = '09:00:00';
var DEFAULT_CLOSE = '17:00:00';

var Hours = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  opens: DEFAULT_OPEN,
  closes: DEFAULT_CLOSE,
  dayOfWeek: WEEKDAYS
});

var DAYS = __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of('MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY');

var DAY_RANGES = __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of('EVERYDAY', 'WEEKDAYS', 'WEEKENDS');

var DAY_OPTIONS = DAY_RANGES.concat(DAYS).map(function (day) {
  return {
    label: day.toLowerCase(),
    value: day
  };
}).toJS();

var DAY_OPTIONS_ORDER = DAYS.concat(DAY_RANGES).reduce(function (days, day, index) {
  return days.set(day, index);
}, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).toJS();

var TIMEZONE_OPTIONS = Object(__WEBPACK_IMPORTED_MODULE_3_utils_timezoneHelpers__["a" /* getSupportedTimezones */])().map(function (zone) {
  return { value: zone, label: Object(__WEBPACK_IMPORTED_MODULE_3_utils_timezoneHelpers__["b" /* normalizedTimezone */])(zone) };
});

var HOUR_OPTIONS = _.range(24).reduce(function (result, time) {
  var hour = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time, 'H');
  var midHour = __WEBPACK_IMPORTED_MODULE_0_moment___default()(hour).add(30, 'minutes');

  result.push({ value: hour.format(HOUR_FORMAT), label: hour.format(HOUR_LABEL_FORMAT) });
  result.push({ value: midHour.format(HOUR_FORMAT), label: midHour.format(HOUR_LABEL_FORMAT) });
  return result;
}, []);
HOUR_OPTIONS.push({ value: MIDNIGHT_VALUE, label: MIDNIGHT_LABEL });



var NotificationMessages = {
  AVAILABILITY: 'The availability settings of your Chat Widget have been updated!',
  TARGETING: 'The targeting settings of your Chat Widget have been updated!'
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "kn7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ParentNode__ = __webpack_require__("dF7v");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ParentNode__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EndNode__ = __webpack_require__("FRFo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__EndNode__["a"]; });



/***/ }),

/***/ "knub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kuIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return timedOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("PnBG");



var setLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* SET_LOADED */]);
var timedOut = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* TIMED_OUT */]);

/***/ }),

/***/ "kvsP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubspotMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HubspotUserMap; });
var HubspotMapping = {
  static: false,
  defaultValue: null,
  driftAttribute: null,
  integrationAttribute: null,
  isOverwritable: null
};

var HubspotUserMap = {
  driftUserId: null,
  integrationUserId: null
};

/***/ }),

/***/ "kw6s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conversationSection":"conversationSection---3RVSj"};

/***/ }),

/***/ "l+9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Theme */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrgSettings; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getOrgSettingsFromEmbed;
/* harmony export (immutable) */ __webpack_exports__["b"] = getChanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_I18n_Constants__ = __webpack_require__("waKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_color__ = __webpack_require__("4Vxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Constants__ = __webpack_require__("hHSs");










var Theme = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  // Auidence & Targeting
  audience: '',
  userListIds: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(),
  targetId: 0,

  // Styling
  logoUrl: undefined,
  iconUrl: undefined,
  backgroundColor: undefined,
  foregroundColor: undefined,
  activeColor: undefined,
  textColor: undefined,
  widgetBackgroundColor: undefined,
  iconStyle: __WEBPACK_IMPORTED_MODULE_2_components_Customize_Styling_IconPicker_Constants__["b" /* IconStyles */].SOLID1,
  fontFamily: __WEBPACK_IMPORTED_MODULE_6__Constants__["b" /* FontFamilies */].Brandon.key,
  widgetHalfHeight: undefined,

  // Online Messaging
  unreadBadgeEnabled: null,
  userList: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(),
  userListMode: 'CUSTOM',
  welcomeMessage: null,
  emailCaptureMessage: null,
  showWelcomeMessage: false,
  captureEmail: true,
  soundNotificationEnabled: null,
  allowEndUserFileUpload: null,
  allowAgentFileUpload: null,
  titleNotificationEnabled: null,
  disableNewConversations: null,

  // Offline Messaging
  awayMessage: null,
  confirmationMessage: null,

  // Team Directory
  teamDirectoryHeading: 'Meet the Team',
  teamDirectoryDescription: null,

  timezone: undefined
});

var OrgSettings = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  orgName: '[no name]',
  orgUrl: '',
  locale: __WEBPACK_IMPORTED_MODULE_3_components_I18n_Constants__["b" /* Locales */].en.key,
  showBranding: null,
  theme: Theme()
});

function getOrgSettingsFromEmbed(embed) {
  var _embed$configuration = embed.configuration,
      locale = _embed$configuration.locale,
      organizationName = _embed$configuration.organizationName,
      organizationUrl = _embed$configuration.organizationUrl,
      showBranding = _embed$configuration.showBranding,
      _embed$configuration$ = _embed$configuration.theme,
      activeColor = _embed$configuration$.activeColor,
      allowEndUserFileUpload = _embed$configuration$.allowEndUserFileUpload,
      allowAgentFileUpload = _embed$configuration$.allowAgentFileUpload,
      audience = _embed$configuration$.audience,
      awayMessage = _embed$configuration$.awayMessage,
      backgroundColor = _embed$configuration$.backgroundColor,
      captureEmail = _embed$configuration$.captureEmail,
      confirmationMessage = _embed$configuration$.confirmationMessage,
      disableNewConversations = _embed$configuration$.disableNewConversations,
      emailCaptureMessage = _embed$configuration$.emailCaptureMessage,
      foregroundColor = _embed$configuration$.foregroundColor,
      fontFamily = _embed$configuration$.fontFamily,
      iconStyle = _embed$configuration$.iconStyle,
      iconUrl = _embed$configuration$.iconUrl,
      logoUrl = _embed$configuration$.logoUrl,
      showWelcomeMessage = _embed$configuration$.showWelcomeMessage,
      soundNotificationEnabled = _embed$configuration$.soundNotificationEnabled,
      targetId = _embed$configuration$.targetId,
      teamDirectoryDescription = _embed$configuration$.teamDirectoryDescription,
      teamDirectoryHeading = _embed$configuration$.teamDirectoryHeading,
      textColor = _embed$configuration$.textColor,
      timezone = _embed$configuration$.timezone,
      titleNotificationEnabled = _embed$configuration$.titleNotificationEnabled,
      unreadBadgeEnabled = _embed$configuration$.unreadBadgeEnabled,
      userList = _embed$configuration$.userList,
      userListIds = _embed$configuration$.userListIds,
      userListMode = _embed$configuration$.userListMode,
      welcomeMessage = _embed$configuration$.welcomeMessage,
      widgetBackgroundColor = _embed$configuration$.widgetBackgroundColor,
      widgetHalfHeight = _embed$configuration$.widgetHalfHeight;


  return OrgSettings({
    orgName: organizationName,
    orgUrl: organizationUrl,
    locale: locale || __WEBPACK_IMPORTED_MODULE_3_components_I18n_Constants__["b" /* Locales */].en.key,
    showBranding: showBranding,
    theme: Theme({
      activeColor: activeColor,
      allowEndUserFileUpload: allowEndUserFileUpload,
      allowAgentFileUpload: allowAgentFileUpload,
      audience: audience,
      awayMessage: awayMessage,
      backgroundColor: backgroundColor,
      captureEmail: captureEmail,
      confirmationMessage: confirmationMessage,
      disableNewConversations: disableNewConversations,
      emailCaptureMessage: emailCaptureMessage,
      fontFamily: fontFamily,
      foregroundColor: foregroundColor,
      iconStyle: iconStyle,
      iconUrl: iconUrl,
      logoUrl: logoUrl,
      showWelcomeMessage: showWelcomeMessage,
      soundNotificationEnabled: soundNotificationEnabled,
      targetId: targetId,
      teamDirectoryDescription: teamDirectoryDescription,
      teamDirectoryHeading: teamDirectoryHeading,
      textColor: textColor || Object(__WEBPACK_IMPORTED_MODULE_5_utils_color__["a" /* getTextColorForBackground */])(backgroundColor),
      timezone: timezone,
      titleNotificationEnabled: titleNotificationEnabled,
      unreadBadgeEnabled: unreadBadgeEnabled,
      userList: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(userList),
      userListIds: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(userListIds),
      userListMode: userListMode,
      welcomeMessage: welcomeMessage,
      widgetBackgroundColor: widgetBackgroundColor,
      widgetHalfHeight: widgetHalfHeight
    })
  });
}

function getChanges(orgSettings, initialOrgSettings) {
  var newTheme = orgSettings.theme.toJS();
  var oldTheme = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.pick(initialOrgSettings.theme, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.keys(newTheme));
  return Object(__WEBPACK_IMPORTED_MODULE_4_utils_PatchHelper__["a" /* patchOperations */])({
    organizationName: orgSettings.orgName,
    organizationUrl: orgSettings.orgUrl,
    locale: orgSettings.locale,
    theme: newTheme,
    showBranding: orgSettings.showBranding
  }, {
    organizationName: initialOrgSettings.organizationName,
    organizationUrl: initialOrgSettings.orgUrl,
    locale: initialOrgSettings.locale,
    theme: oldTheme,
    showBranding: initialOrgSettings.showBranding
  });
}

/***/ }),

/***/ "l/4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__("Kkvv");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("Eys3");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("+GRK");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__("gOkU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__reducer__["a"]; });









/***/ }),

/***/ "l071":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_FILTER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONVERSATION_TAG_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARTICIPANT_FILTER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADVANCED_SEARCH_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SORT_KEY; });
var STATUS_FILTER_KEY = 'statusFilter';
var CONVERSATION_TAG_KEY = 'conversationTagFilter';
var PARTICIPANT_FILTER_KEY = 'participantFilter';
var ADVANCED_SEARCH_KEY = 'advanced';
var SORT_KEY = 'sortBy';

/***/ }),

/***/ "l2mm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("VCB8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__("7IUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__("inMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectorsUI__ = __webpack_require__("OHI1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__ = __webpack_require__("EkEs");











function fetchCampaign(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* fetchCampaign */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (_ref2) {
    var id = _ref2.id;
    return __WEBPACK_IMPORTED_MODULE_7__selectors__["b" /* fetchStatus */](id)(getState()) !== __WEBPACK_IMPORTED_MODULE_6__actions__["d" /* fetchCampaignPending */].toString();
  }).filter(function (_ref3) {
    var id = _ref3.id,
        force = _ref3.force;
    return !__WEBPACK_IMPORTED_MODULE_7__selectors__["c" /* isCampaignFetched */](id)(getState()) || force;
  }).mergeMap(function (_ref4) {
    var id = _ref4.id;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetch(id).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* fetchCampaign */])).map(__WEBPACK_IMPORTED_MODULE_6__actions__["i" /* receiveCampaign */]).startWith(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* fetchCampaignPending */]({ id: id })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_6__actions__["c" /* fetchCampaignFailed */]({ id: id, error: error }));
    });
  });
}

function updateCampaign(action$, _ref5) {
  var getState = _ref5.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["q" /* updateCampaign */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (newCampaign) {
    var id = newCampaign.get('id');
    var oldCampaign = __WEBPACK_IMPORTED_MODULE_7__selectors__["a" /* campaign */](id)(getState());
    var operations = Object(__WEBPACK_IMPORTED_MODULE_2_utils_PatchHelper__["a" /* patchOperations */])(newCampaign.toJS(), oldCampaign.toJS());
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].update(id, operations).map(__WEBPACK_IMPORTED_MODULE_6__actions__["i" /* receiveCampaign */]).startWith(__WEBPACK_IMPORTED_MODULE_6__actions__["t" /* updateCampaignPending */]({ id: id })).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We’re having trouble updating your campaign right now. Please try again in a bit.",
        variant: 'red'
      });
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_6__actions__["s" /* updateCampaignFailed */]({ id: id, error: error }));
    });
  });
}

function searchCampaigns(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* searchCampaigns */].toString()).debounceTime(200).switchMap(function (action) {
    var _action$payload = action.payload,
        _action$payload$query = _action$payload.query,
        query = _action$payload$query === undefined ? "" : _action$payload$query,
        limit = _action$payload.limit;


    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].search(query, { limit: limit }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["l" /* searchCampaignsCancelled */].toString())).map(__WEBPACK_IMPORTED_MODULE_6__actions__["o" /* searchCampaignsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_6__actions__["n" /* searchCampaignsPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_6__actions__["m" /* searchCampaignsFailed */](error));
    });
  });
}

function loadMoreCampaigns(action$, _ref6) {
  var getState = _ref6.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* loadMoreCampaigns */].toString()).switchMap(function () {
    var state = getState();
    var query = __WEBPACK_IMPORTED_MODULE_8__selectorsUI__["a" /* query */](state);
    var offset = __WEBPACK_IMPORTED_MODULE_7__selectors__["e" /* searchResults */](state).size;
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetch(query, { offset: offset }).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* searchCampaigns */].toString())).map(__WEBPACK_IMPORTED_MODULE_6__actions__["h" /* loadMoreCampaignsSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_6__actions__["g" /* loadMoreCampaignsPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_6__actions__["f" /* loadMoreCampaignsFailed */](error));
    });
  });
}

function pushCampaign(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_9_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref7) {
    var channel = _ref7.channel,
        leaveChannel$ = _ref7.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('campaign-updated', function (payload) {
        __WEBPACK_IMPORTED_MODULE_5_containers_app__["a" /* default */].actions.CampaignActions.pushCampaign(payload);
      });
    }).takeUntil(leaveChannel$);
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchCampaign, updateCampaign, searchCampaigns, loadMoreCampaigns, pushCampaign);

/***/ }),

/***/ "l7G3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MarketoMappedLeadOwnerInput = function (_Component) {
  _inherits(MarketoMappedLeadOwnerInput, _Component);

  function MarketoMappedLeadOwnerInput(props) {
    var _this2 = this;

    _classCallCheck(this, MarketoMappedLeadOwnerInput);

    var _this = _possibleConstructorReturn(this, (MarketoMappedLeadOwnerInput.__proto__ || Object.getPrototypeOf(MarketoMappedLeadOwnerInput)).call(this, props));

    _this.getLeadOwnerValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var getMarketoLeadOwnerField, fieldName;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getMarketoLeadOwnerField = _this.props.getMarketoLeadOwnerField;
              _context.next = 3;
              return getMarketoLeadOwnerField();

            case 3:
              fieldName = _context.sent;


              _this.setState({
                mappedLeadOwnerValue: fieldName || ''
              });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.getMarketoFieldOptions = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var fetchMarketoFields, data, formatField, options;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fetchMarketoFields = _this.props.fetchMarketoFields;
              _context2.next = 3;
              return fetchMarketoFields();

            case 3:
              data = _context2.sent;

              formatField = function formatField(field) {
                return { label: field.displayName, value: field.name };
              };

              options = data.fields.filter(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["propEq"])('type', 'STRING')).map(formatField);


              _this.setState({
                marketoFieldOptions: options
              });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));
    _this._saveLeadOwnerValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var _this$props, onSuccess, setMarketoLeadOwnerField, mappedLeadOwnerValue;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, onSuccess = _this$props.onSuccess, setMarketoLeadOwnerField = _this$props.setMarketoLeadOwnerField;
              mappedLeadOwnerValue = _this.state.mappedLeadOwnerValue;
              _context3.prev = 2;
              _context3.next = 5;
              return setMarketoLeadOwnerField(mappedLeadOwnerValue);

            case 5:
              onSuccess();
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](2);

              console.warn(_context3.t0);

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[2, 8]]);
    }));

    _this.handleSelectChange = function (selectedOption) {
      var newLeadOwnerValue = void 0;

      var selectionCleared = !selectedOption;
      if (selectionCleared) {
        newLeadOwnerValue = '';
      } else {
        newLeadOwnerValue = selectedOption.value;
      }

      _this.setState({
        mappedLeadOwnerValue: newLeadOwnerValue
      }, _this.saveLeadOwnerValue);
    };

    _this.state = {
      mappedLeadOwnerValue: '',
      marketoFieldOptions: []
    };

    _this.saveLeadOwnerValue = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(_this._saveLeadOwnerValue, 1000);
    return _this;
  }

  _createClass(MarketoMappedLeadOwnerInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getLeadOwnerValue();
      this.getMarketoFieldOptions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          mappedLeadOwnerValue = _state.mappedLeadOwnerValue,
          marketoFieldOptions = _state.marketoFieldOptions;

      var disabled = !this.props.isEnabled;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Select"], {
        className: 'marketo-lead-owner-select',
        options: marketoFieldOptions,
        value: mappedLeadOwnerValue,
        disabled: disabled,
        onChange: this.handleSelectChange
      });
    }
  }]);

  return MarketoMappedLeadOwnerInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MarketoMappedLeadOwnerInput.propTypes = {
  fetchMarketoFields: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getMarketoLeadOwnerField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setMarketoLeadOwnerField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  isEnabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarketoMappedLeadOwnerInput);

/***/ }),

/***/ "l8Pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonEditTabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LinkToTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alignments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Widths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PixelSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SpacingSizes; });
var _Widths, _SpacingSizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ButtonEditTabs = {
  CONTENT: 'content',
  STYLE: 'style',
  SETTINGS: 'settings'
};

var LinkToTypes = {
  EMAIL: 'Email',
  WEB_ADDRESS: 'Web Address'
};

var Alignments = ['Center', 'Left', 'Right'];

var Widths = (_Widths = {}, _defineProperty(_Widths, 'Full Width', '85%'), _defineProperty(_Widths, 'Half Width', '50%'), _defineProperty(_Widths, 'No Change', 'initial'), _Widths);

var PixelSizes = ['10px', '12px', '14px', '16px', '18px', '20px'];

var SpacingSizes = (_SpacingSizes = {
  Tiny: '-2px',
  Small: '-1px',
  Normal: '0px',
  Large: '1px'
}, _defineProperty(_SpacingSizes, 'Extra Large', '3px'), _defineProperty(_SpacingSizes, 'Jumbo', '5px'), _SpacingSizes);

/***/ }),

/***/ "lBcI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lCnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var placeholderShape = [React.createElement('rect', { key: 0, x: '0', y: '0', width: '60', height: '60', rx: '3' }), React.createElement('rect', { key: 1, x: '70', y: '24', width: '101', height: '12', rx: '5' }), React.createElement('rect', { key: 2, x: '70', y: '0', width: '156', height: '12', rx: '5' }), React.createElement('rect', { key: 3, x: '0', y: '164', width: '171', height: '15', rx: '5' }), React.createElement('rect', { key: 4, x: '0', y: '107', width: '171', height: '15', rx: '5' }), React.createElement('rect', { key: 5, x: '70', y: '48', width: '63', height: '12', rx: '5' }), React.createElement('rect', { key: 6, x: '0', y: '90', width: '63', height: '12', rx: '5' }), React.createElement('rect', { key: 7, x: '0', y: '147', width: '63', height: '12', rx: '5' })];

  var options = {
    height: 179,
    width: 226,
    primaryColor: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
    secondaryColor: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
    primaryOpacity: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
    secondaryOpacity: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
  };

  return React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "lDPC":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMzQ1IDI1Ni45IDEwMCAxMDEuMSI+PHN0eWxlPi5zdDB7ZmlsbDpub25lO3N0cm9rZTojMjBkNGFjO3N0cm9rZS13aWR0aDo0fTwvc3R5bGU+PHRpdGxlPlNoYXBlICsgT3ZhbCA2NzwvdGl0bGU+PGcgaWQ9IkNoYXQtRmxvdyI+PGcgaWQ9IkNvbWluZy1Tb29uIj48ZyBpZD0iR3JvdXAiPjxnIGlkPSJTaGFwZS1feDJCXy1PdmFsLTY3Ij48cGF0aCBpZD0iU2hhcGUiIGNsYXNzPSJzdDAiIGQ9Ik0tMjk1IDM1Mi45Yy0yNS4xIDAtNDUuNS0yMC40LTQ1LjUtNDUuNXMyMC40LTQ1LjUgNDUuNS00NS41IDQ1LjUgMjAuNCA0NS41IDQ1LjYtMjAuNCA0NS40LTQ1LjUgNDUuNHoiLz48cGF0aCBpZD0iT3ZhbC02NyIgY2xhc3M9InN0MCIgZD0iTS0zMDQuNyAzMTcuNWwtNi4yIDYuOGMtMS40IDEuNS0yLjYgMS4xLTIuNi0xIDAgMC0uMS0xMi0uMS0xOC40di01LjJjMC00LjIgMy40LTcuNSA3LjUtNy41aDI0YzQuMiAwIDcuNSAzLjQgNy41IDcuNVYzMTBjMCA0LjItMy40IDcuNS03LjUgNy41aC0yMi42eiIvPjwvZz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ "lDiE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lGef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__ = __webpack_require__("Wr1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var CompanyQueries = Marty.createQueries({
  id: 'CompanyQueries',

  fetchCompany: function fetchCompany(companyId) {
    var _this = this;

    var companyPromise = this.app.sources.CompanyAPI.fetchCompany(companyId);
    companyPromise.then(function (res) {
      if (res.status === 200) {
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_FETCH_DONE, companyId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_FETCH_FAILED, companyId, res);
      }
    });

    return companyPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_FETCH_FAILED, companyId, error);
    });
  },
  fetchCompanyListForOrgId: function fetchCompanyListForOrgId(orgId) {
    var _this2 = this;

    var companyListPromise = this.app.sources.CompanyAPI.fetchCompanyListForOrgId(orgId);

    companyListPromise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_FAILED, res);
      }
    });

    return companyListPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_FAILED, error);
    });
  },
  updateCompany: function updateCompany(companyId, companyParams) {
    var _this3 = this;

    var promise = this.app.sources.CompanyAPI.updateCompany(companyId, companyParams);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_UPDATE_DONE, res.body, companyParams);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_UPDATE_FAILED, companyId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_UPDATE_FAILED, companyId, error);
    });
  },
  fetchCompaniesByIds: function fetchCompaniesByIds(endUserIds) {
    var _this4 = this;

    var promise = this.app.sources.CompanyAPI.fetchCompaniesByIds(endUserIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_FAILED, endUserIds, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_CompanyConstants__["a" /* default */].COMPANY_LIST_FETCH_FAILED, endUserIds, error);
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (CompanyQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "lGjg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IntegrationsTitle":"IntegrationsTitle---cxEaQ","IntegrationSearch":"IntegrationSearch---2FPAt","IntegrationList":"IntegrationList---1d7Zf","IntegrationTitle":"IntegrationTitle---Wx7wv","IntegrationContent":"IntegrationContent---3YpT2","MainContent":"MainContent---3d7_s","PreviewContent":"PreviewContent---1TMQi","IntegrationCategoryDropdown":"IntegrationCategoryDropdown---2yWYy"};

/***/ }),

/***/ "lIGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("X2bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_withAgentStatus__ = __webpack_require__("UnnZ");




var resolveUnifiedStatus = function resolveUnifiedStatus(_ref) {
  var isActive = _ref.isActive,
      limitNumChatsEnabled = _ref.limitNumChatsEnabled,
      isUserAtConversationLimit = _ref.isUserAtConversationLimit;

  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return 'chat_limit';
  }

  if (isActive) {
    return 'available';
  }

  return 'away';
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_2_components_withAgentStatus__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (_ref2) {
  var isActive = _ref2.isActive,
      limitNumChatsEnabled = _ref2.limitNumChatsEnabled,
      isUserAtConversationLimit = _ref2.isUserAtConversationLimit;
  return {
    agentStatus: resolveUnifiedStatus({
      isActive: isActive,
      limitNumChatsEnabled: limitNumChatsEnabled,
      isUserAtConversationLimit: isUserAtConversationLimit
    })
  };
}))(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),

/***/ "lMLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var IntegrationsConstants = Marty.createConstants(['MAP_SLACK_USER', 'CREATE_ACCESS_TOKEN', 'FETCH_PROTIP', 'FETCH_INTEGRATION_STATES', 'FETCH_HUBSPOT_INJECTION_STATE', 'FETCH_HUBSPOT_TIMELINE_STATE', 'FETCH_HUBSPOT_COOKIE_STATE', 'UPDATE_HUBSPOT_INJECTION_STATE', 'UPDATE_HUBSPOT_TIMELINE_STATE', 'UPDATE_HUBSPOT_COOKIE_STATE', 'UPDATE_INTEGRATION_STATE']);

/* harmony default export */ __webpack_exports__["default"] = (IntegrationsConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "lO8c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clearbit-logo.9964c2f1.svg";

/***/ }),

/***/ "lOCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_api__ = __webpack_require__("Qfgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("u9CK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TYPES = ['STRING', 'NUMERIC', 'BOOLEAN', 'DATETIME', 'DATE'];
var LABELS = {
  'STRING': 'Text',
  'NUMERIC': 'Number',
  'BOOLEAN': 'True/False',
  'DATETIME': 'Date/Time',
  'DATE': 'Date'
};

var ContactPropertyCreatorModal = function ContactPropertyCreatorModal(_ref) {
  var onClose = _ref.onClose;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__["a" /* default */],
    {
      onRequestClose: onClose,
      isOpen: true,
      style: { content: { padding: 0, border: '1px solid transparent', background: 'none' } }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'contact-property-creator-modal' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContactPropertyCreator, { onSave: onClose })
    )
  );
};

var ContactPropertyCreator = function (_Component) {
  _inherits(ContactPropertyCreator, _Component);

  function ContactPropertyCreator() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ContactPropertyCreator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ContactPropertyCreator.__proto__ || Object.getPrototypeOf(ContactPropertyCreator)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      label: '',
      type: 'STRING',
      hasError: false,
      errorMsg: ''
    }, _this.updateLabel = function (event) {
      _this.setState({
        label: event.target.value,
        hasError: false,
        errorMsg: ''
      });
    }, _this.updateType = function (option) {
      _this.setState({
        type: option.value,
        hasError: false,
        errorMsg: ''
      });
    }, _this.typeOptions = function () {
      return TYPES.map(function (type) {
        return { label: LABELS[type], value: type };
      });
    }, _this.isValid = function () {
      return _this.state.label.length && !!_this.state.type;
    }, _this.saveNewProperty = function () {
      if (!_this.isValid) return;
      var data = {
        displayName: _this.state.label,
        name: _this.state.label.split(' ').join('_'),
        type: _this.state.type
      };

      __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_api__["a" /* api */].addNewContactAttribute([data]).then(_this.props.onSave).catch(function (err) {
        _this.setState({
          hasError: true,
          errorMsg: err.message
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ContactPropertyCreator, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-property-creator drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Create New Contact Attribute'
        ),
        this.state.hasError && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          this.state.errorMsg
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Display Name'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', onChange: this.updateLabel }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          null,
          'Attribute Type'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
          options: this.typeOptions(),
          onChange: this.updateType,
          clearable: false,
          value: this.state.type
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'drift-button drift-button-primary', disabled: !this.isValid, onClick: this.saveNewProperty },
          'Save New Property'
        )
      );
    }
  }]);

  return ContactPropertyCreator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ContactPropertyCreatorModal);

/***/ }),

/***/ "lT+U":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNTM3IDI1QzcuNjMgMjUgMi43MjcgMjAuNTczIDIuMTMzIDE0LjcwM2MtLjA1OC0uNTczLjM2LTEuMDgzLjkzMi0xLjE0LjU4NC0uMDYgMS4wODQuMzYgMS4xNC45My40ODcgNC44MDMgNC40OTggOC40MjQgOS4zMzIgOC40MjQgNS4xNzIgMCA5LjM4LTQuMjA4IDkuMzgtOS4zOCAwLTQuODMzLTMuNjItOC44NDQtOC40Mi05LjMzLS41NzMtLjA1Ny0uOTktLjU2Ny0uOTMtMS4xNC4wNTYtLjU3LjU2Ni0uOTkgMS4xNC0uOTMyQzIwLjU3NCAyLjcyOCAyNSA3LjYzIDI1IDEzLjUzNyAyNSAxOS44NTggMTkuODU4IDI1IDEzLjUzNyAyNXpNMTIuNDkgMTEuNDQ4YzAgLjU3NS0uNDY1IDEuMDQyLTEuMDQgMS4wNDJIMS4xNDRjLS4wMzUuMDA0LS4wNy4wMDUtLjEwMy4wMDUtLjU3NiAwLTEuMDQyLS40NjItMS4wNDItMS4wMzd2LS4wMUMuMDA2IDUuMTQgNS4xNDMuMDA0IDExLjQ0OCAwaC4wMWMuNTc1IDAgMS4wNDIuNDY3IDEuMDQyIDEuMDQyIDAgLjA0Ny0uMDAzLjA5Mi0uMDEuMTM4djEwLjI2OHptLTIuMDgzLTkuMzA2Yy00LjMzLjQ4Ni03Ljc4IDMuOTM1LTguMjY0IDguMjY0aDguMjY0VjIuMTQyeiIgZmlsbD0iIzc4OTdBNyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg=="

/***/ }),

/***/ "lU3B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var SegmentConstants = Marty.createConstants(['SEGMENT_CREATE', 'SEGMENTS_FETCH', 'SEGMENT_FETCH', 'DELETE_SEGMENT', 'SEGMENT_ADD_MEMBERS', 'SEGMENT_DELETE_MEMBERS', 'SEGMENT_ELASTIC_SEARCH_MEMBERS_DONE', 'GET_CAMPAIGNS_FOR_SEGMENT']);

/* harmony default export */ __webpack_exports__["a"] = (SegmentConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "lV/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("1Ihb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__ = __webpack_require__("oThQ");







function fetchEmbedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["a" /* fetchEmbed */].toString()).pluck('payload').switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetch().map(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["e" /* fetchEmbedSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["d" /* fetchEmbedPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["c" /* fetchEmbedFailed */](error));
    });
  });
}

var fetchEmbedById = function fetchEmbedById(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["b" /* fetchEmbedById */].toString()).pluck('payload').switchMap(function (embedId) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchById(embedId).map(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["e" /* fetchEmbedSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["d" /* fetchEmbedPending */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_actions__["c" /* fetchEmbedFailed */](error));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEmbedEpic, fetchEmbedById);

/***/ }),

/***/ "lWre":
/***/ (function(module, exports) {

module.exports = "<svg width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.975.38c.014.043.02.087.024.132v.06c-.004.048-.014.095-.03.14-.006.017-.007.032-.014.046L7.252 12.692c-.09.19-.28.308-.49.308-.216-.002-.406-.127-.493-.32l-.537-3.41C5.56 8.18 4.55 7.1 3.478 6.86l-3.2-.72c-.18-.1-.287-.293-.277-.5.012-.206.138-.39.328-.47L12.248.04 12.3.026c.05-.015.098-.025.148-.026.02 0 .038 0 .058.003.046.004.09.013.132.028l.055.02c.056.027.11.06.154.107.053.053.085.11.11.168.008.018.013.036.018.055z\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "lWyc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setFilters */
/* unused harmony export clearFilters */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilters; });
/* unused harmony export setInboxId */
/* unused harmony export clearInboxId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInboxId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearAll; });
var FILTERS_CACHE_KEY = 'Drift.Conversation.queryFilters';
var INBOX_CACHE_KEY = 'Drift.Conversation.inboxId';

var setFilters = function setFilters(filters) {
  if (!filters) {
    return;
  }
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(filters));
  return filters;
};

var clearFilters = function clearFilters() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.removeItem(FILTERS_CACHE_KEY);
};

var getFilters = function getFilters() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  var filters = localStorage.getItem(FILTERS_CACHE_KEY);
  return filters && JSON.parse(filters);
};

var setInboxId = function setInboxId(inboxId) {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.setItem(INBOX_CACHE_KEY, inboxId);
  return inboxId;
};

var clearInboxId = function clearInboxId() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.removeItem(INBOX_CACHE_KEY);
};

var getInboxId = function getInboxId() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  return localStorage.getItem(INBOX_CACHE_KEY);
};

var clearAll = function clearAll() {
  if (!localStorage) {
    console.warn('localStorage is not available');
    return;
  }

  localStorage.removeItem(INBOX_CACHE_KEY);
  localStorage.removeItem(FILTERS_CACHE_KEY);
};

/***/ }),

/***/ "lZSu":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 28\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30.914 11.961h-4.007v9.982h1.994c.551 0 .996.447.996.998a.997.997 0 0 1-.996.998H2.98a.997.997 0 0 1 0-1.996h1.994v-9.982H.986a.998.998 0 0 1-.553-1.829L15.387.151a.998.998 0 0 1 1.106 0l14.844 9.907a.997.997 0 0 1-.423 1.903zm-8.992 9.982h2.991v-9.982h-2.991v9.982zm-4.985 0h2.991v-9.982h-2.991v9.982zm-1.994 0v-9.982H11.91v9.982h3.033zm-8.033 0h3.049v-9.982H6.91v9.982zm9.03-19.762L4.279 9.965h23.323L15.94 2.181zM.986 25.935h29.908a.997.997 0 0 1 0 1.996H.986a.997.997 0 1 1 0-1.996z\" fill=\"#CCC\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "lau8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__ = __webpack_require__("Vgyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_pencil_svg__ = __webpack_require__("3iTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_pencil_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_pencil_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("OczV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var InlineEdit = function InlineEdit(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('inline-edit', className) },
    React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_images_svg_pencil_svg___default.a }),
    React.createElement(__WEBPACK_IMPORTED_MODULE_2_react_textarea_autosize__["default"], _extends({}, props, { className: 'flex-1' }))
  );
};

/* harmony default export */ __webpack_exports__["a"] = (InlineEdit);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "lc4l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var UserPropertiesAPI = Marty.createStateSource({
  id: 'UserPropertiesAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  fetchProperties: function fetchProperties(userId) {
    return this.get({
      url: '/users/' + userId + '/properties',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateProperties: function updateProperties(userId, properties) {
    return this.patch({
      url: '/users/' + userId + '/properties',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(properties)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserPropertiesAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ld5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SEARCH_DEBOUNCE_TIMEOUT = 500;

var PardotProspectCampaignInput = function (_Component) {
  _inherits(PardotProspectCampaignInput, _Component);

  function PardotProspectCampaignInput(props) {
    var _this2 = this;

    _classCallCheck(this, PardotProspectCampaignInput);

    var _this = _possibleConstructorReturn(this, (PardotProspectCampaignInput.__proto__ || Object.getPrototypeOf(PardotProspectCampaignInput)).call(this, props));

    _this.getProspectCampaignValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var getPardotConfig, config, mappedProspectCampaignValue;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getPardotConfig = _this.props.getPardotConfig;
              _context.next = 3;
              return getPardotConfig();

            case 3:
              config = _context.sent;
              mappedProspectCampaignValue = undefined;

              if (config.prospectCampaign) {
                // Serialize for unique value identifier of campaign.
                mappedProspectCampaignValue = JSON.stringify(config.prospectCampaign);
              }

              _this.setState({
                mappedProspectCampaignValue: mappedProspectCampaignValue
              });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.formatCampaign = function (campaign) {
      return { label: campaign.name, value: JSON.stringify(campaign) };
    };

    _this.getFieldOptions = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var fetchCampaigns, data, campaigns, options;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              fetchCampaigns = _this.props.fetchCampaigns;
              _context2.next = 3;
              return fetchCampaigns();

            case 3:
              data = _context2.sent;

              if (!data.err) {
                _context2.next = 7;
                break;
              }

              console.error(data.err);
              return _context2.abrupt('return');

            case 7:
              campaigns = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pathOr"])([], ['result', 'campaign'], data);
              options = campaigns.map(_this.formatCampaign);


              _this.setState({
                selectOptions: options
              });

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.searchPardotCampaigns = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(name) {
        var searchCampaigns, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                searchCampaigns = _this.props.searchCampaigns;

                if (!(name.length <= 2)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:

                _this.setState({ isLoading: true });
                _context3.prev = 4;
                _context3.next = 7;
                return searchCampaigns(name);

              case 7:
                response = _context3.sent;

                _this.setState({
                  isLoading: false,
                  responseOptions: response.result.campaign.map(_this.formatCampaign)
                });
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](4);

                console.error(_context3.t0);
                _this.setState({
                  isLoading: false,
                  responseOptions: []
                });

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[4, 11]]);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.debouncedSearch = _.debounce(_this.searchPardotCampaigns, SEARCH_DEBOUNCE_TIMEOUT);
    _this._saveProspectCampaignValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this$props, onSuccess, setProspectCampaignField, mappedProspectCampaignValue;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props = _this.props, onSuccess = _this$props.onSuccess, setProspectCampaignField = _this$props.setProspectCampaignField;
              mappedProspectCampaignValue = _this.state.mappedProspectCampaignValue;

              if (mappedProspectCampaignValue) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt('return');

            case 4:
              _context4.prev = 4;
              _context4.next = 7;
              return setProspectCampaignField(JSON.parse(mappedProspectCampaignValue));

            case 7:
              onSuccess();
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](4);

              console.error(_context4.t0);

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2, [[4, 10]]);
    }));

    _this.handleSelectChange = function (selectedOption) {
      var newProspectCampaignValue = void 0;

      var selectionCleared = !selectedOption;
      if (selectionCleared) {
        newProspectCampaignValue = undefined;
      } else {
        newProspectCampaignValue = selectedOption.value;
      }

      _this.setState({
        mappedProspectCampaignValue: newProspectCampaignValue
      }, _this.saveProspectCampaignValue);
    };

    _this.state = {
      mappedProspectCampaignValue: '',
      selectOptions: [],
      responseOptions: [],
      isLoading: false
    };

    _this.saveProspectCampaignValue = __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(_this._saveProspectCampaignValue, 1000);
    return _this;
  }

  _createClass(PardotProspectCampaignInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getProspectCampaignValue();
      this.getFieldOptions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          mappedProspectCampaignValue = _state.mappedProspectCampaignValue,
          isLoading = _state.isLoading,
          responseOptions = _state.responseOptions,
          selectOptions = _state.selectOptions;

      var disabled = !this.props.isEnabled;
      var unfilteredOptions = [].concat(_toConsumableArray(responseOptions), _toConsumableArray(selectOptions));
      if (mappedProspectCampaignValue) {
        var selectedOption = JSON.parse(mappedProspectCampaignValue);
        unfilteredOptions.push(this.formatCampaign(selectedOption));
      }
      var allCampaignOptions = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["uniqBy"])(function (c) {
        return c.value;
      }, unfilteredOptions);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Select"], {
        className: 'pardot-prospect-campaign-select',
        options: allCampaignOptions,
        value: mappedProspectCampaignValue,
        disabled: disabled,
        onChange: this.handleSelectChange,
        autosize: true,
        isLoading: isLoading,
        onInputChange: this.debouncedSearch
      });
    }
  }]);

  return PardotProspectCampaignInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

PardotProspectCampaignInput.propTypes = {
  fetchCampaigns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  searchCampaigns: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getPardotConfig: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setProspectCampaignField: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  isEnabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (PardotProspectCampaignInput);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "lgUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("ICoT");









var mapStateToProps = function mapStateToProps(state) {
  return {
    draft: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["n" /* draft */](state),
    isActive: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_37" /* isEnabled */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      //someAction: PlaybookActions.someAction,
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    // TODO: something
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('isLoading', 'setIsLoading', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onChange: function onChange(props) {
    return function (arg) {
      var orgId = props.orgId;
      // TODO: do some action here
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "limV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lnLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("1q/a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__("EoOe");








// Org settings epics
var fetchAssistantOrgSettingsEpic = function fetchAssistantOrgSettingsEpic(action$, _ref) {
  var getState = _ref.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["m" /* fetchAssistantOrgSettings */].toString()).pluck('payload').filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["g" /* fetchAssistantOrgSettingsSuccess */])(getState());
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchAssistantOrgSettings().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["p" /* fetchAssistantOrgSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["o" /* fetchAssistantOrgSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["n" /* fetchAssistantOrgSettingsFailed */](error));
    });
  });
};

var createAssistantOrgSettingsEpic = function createAssistantOrgSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* createAssistantOrgSettings */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (assistantOrgSettings) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].createAssistantOrgSettings(assistantOrgSettings).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "Your organization's Drift Assistant settings have been updated.",
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["h" /* createAssistantOrgSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* createAssistantOrgSettingsPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We were unable to update your organization's Drift Assistant settings.",
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* createAssistantOrgSettingsFailed */](error));
    });
  });
};

var patchAssistantOrgSettingsEpic = function patchAssistantOrgSettingsEpic(action$, _ref2) {
  var dispatch = _ref2.dispatch;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["H" /* patchAssistantOrgSettings */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (patchOrgSettingsPayload) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].patchAssistantOrgSettings(patchOrgSettingsPayload.newSettings).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "Your organization's Drift Assistant settings have been updated.",
        variant: 'green'
      });
      dispatch(__WEBPACK_IMPORTED_MODULE_4__actions__["y" /* handleEditConfig */]({ settingName: patchOrgSettingsPayload.settingName, value: false }));
      return __WEBPACK_IMPORTED_MODULE_4__actions__["K" /* patchAssistantOrgSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["J" /* patchAssistantOrgSettingsPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "We were unable to update your organization's Drift Assistant settings.",
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["I" /* patchAssistantOrgSettingsFailed */](error));
    });
  });
};

// Agent settings epics
var fetchAssistantAgentSettingsEpic = function fetchAssistantAgentSettingsEpic(action$, _ref3) {
  var getState = _ref3.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* fetchAssistantAgentSettings */].toString()).pluck('payload').filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["e" /* fetchAssistantAgentSettingsSuccess */])(getState());
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchAssistantAgentSettings().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["l" /* fetchAssistantAgentSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* fetchAssistantAgentSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["j" /* fetchAssistantAgentSettingsFailed */](error));
    });
  });
};

var createAssistantAgentSettingsEpic = function createAssistantAgentSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* createAssistantAgentSettings */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (assistantAgentSettings) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].createAssistantAgentSettings(assistantAgentSettings).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Your Drift Assistant settings have been updated.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["d" /* createAssistantAgentSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* createAssistantAgentSettingsPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'We were unable to update your Drift Assistant settings.',
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* createAssistantAgentSettingsFailed */](error));
    });
  });
};

var patchAssistantAgentSettingsEpic = function patchAssistantAgentSettingsEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["D" /* patchAssistantAgentSettings */].toString()).map(function (action) {
    return action.payload;
  }).mergeMap(function (_ref4) {
    var settings = _ref4.settings,
        meetingCopy = _ref4.meetingCopy;

    var toastCopy = !!meetingCopy ? 'meeting' : 'Drift Assistant';
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].patchAssistantAgentSettings({ taskConfigMap: settings }).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Your ' + toastCopy + ' settings have been updated.',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["G" /* patchAssistantAgentSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["F" /* patchAssistantAgentSettingsPending */]()).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'We were unable to update your ' + toastCopy + ' settings.',
        variant: 'red',
        sticky: true
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["E" /* patchAssistantAgentSettingsFailed */](error));
    });
  });
};

var fetchSalesforceSettingsEpic = function fetchSalesforceSettingsEpic(action$, _ref5) {
  var getState = _ref5.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["u" /* fetchSalesforceSettings */].toString()).pluck('payload').filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["i" /* fetchSalesforceSettingsSuccess */])(getState());
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchSalesforceSettings().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["x" /* fetchSalesforceSettingsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["w" /* fetchSalesforceSettingsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["v" /* fetchSalesforceSettingsFailed */](error));
    });
  });
};

var fetchPersonalizationTagsEpic = function fetchPersonalizationTagsEpic(action$, _ref6) {
  var getState = _ref6.getState;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["q" /* fetchPersonalizationTags */].toString()).pluck('payload').filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["h" /* fetchPersonalizationTagsSuccess */])(getState());
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].fetchPersonalizationTags().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_4__actions__["t" /* fetchPersonalizationTagsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["s" /* fetchPersonalizationTagsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["r" /* fetchPersonalizationTagsFailed */](error));
    });
  });
};

var sendTestEmailEpic = function sendTestEmailEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__actions__["L" /* sendTestEmail */].toString()).pluck('payload').mergeMap(function (taskType) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* api */].sendTestEmail(taskType).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "Your test email has been sent!",
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_4__actions__["O" /* sendTestEmailSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_4__actions__["N" /* sendTestEmailPending */]()).catch(function (error) {

      __WEBPACK_IMPORTED_MODULE_2_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "There was an error sending your test email, please try again.",
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_4__actions__["M" /* sendTestEmailFailed */](error));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchAssistantOrgSettingsEpic, createAssistantOrgSettingsEpic, patchAssistantOrgSettingsEpic, fetchAssistantAgentSettingsEpic, createAssistantAgentSettingsEpic, patchAssistantAgentSettingsEpic, fetchSalesforceSettingsEpic, fetchPersonalizationTagsEpic, sendTestEmailEpic);

/***/ }),

/***/ "lpJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarCompat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("WExX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var AvatarCompat = function AvatarCompat(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'user-avatar-compat' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core__["Avatar"], props)
  );
};

/***/ }),

/***/ "lppJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lq9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("/Txf");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("IHje");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "lsaV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OauthConnector__ = __webpack_require__("YIzp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Connected__ = __webpack_require__("COe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var IntegrationConnector = function (_Component) {
  _inherits(IntegrationConnector, _Component);

  function IntegrationConnector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, IntegrationConnector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IntegrationConnector.__proto__ || Object.getPrototypeOf(IntegrationConnector)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      updating: false
    }, _this.handleConnect = function () {
      console.log('connect in integration connector');
      var _this$props = _this.props,
          integrationId = _this$props.integrationId,
          connectionPayload = _this$props.connectionPayload,
          actions = _this$props.actions;
      // pardot get its token on the backend

      console.log('integration connector ' + integrationId);
      if (integrationId !== 'Pardot') {
        actions.createAccessToken({ integrationName: integrationId, body: connectionPayload });
      }
      actions.track('Integration Connected', { integration: integrationId, connected: true });
      _this.setState({ updating: true });
    }, _this.handleDisconnect = function () {
      var _this$props2 = _this.props,
          integrationId = _this$props2.integrationId,
          actions = _this$props2.actions;

      actions.updateIntegrationState({ integration: integrationId, connected: false });
      actions.track('Integration Disconnected', { integration: integrationId, connected: false });
      _this.setState({ updating: true });
    }, _this.renderOauthConnector = function () {
      var _this2 = _this,
          props = _this2.props;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__OauthConnector__["a" /* default */], _extends({
        trackingPayload: props.trackingPayload,
        handleConnect: _this.handleConnect,
        label: props.title,
        isDisabled: props.isDisabled
      }, props));
    }, _this.renderNotConnected = function () {
      var isOauth = _this.props.isOauth;

      if (isOauth) {
        return _this.renderOauthConnector();
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ConnectLink__["a" /* default */], { handleConnect: _this.handleConnect });
    }, _this.renderConnected = function () {
      var integrationId = _this.props.integrationId;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Connected__["a" /* default */], { integrationId: integrationId, handleDisconnect: _this.handleDisconnect });
    }, _this.renderConnectors = function () {
      var isConnected = _this.props.isConnected;

      if (isConnected) {
        return _this.renderConnected();
      } else {
        return _this.renderNotConnected();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(IntegrationConnector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var integrationStates = _ref2.integrationStates,
          accessTokenCreated = _ref2.accessTokenCreated,
          failedCreateAccessToken = _ref2.failedCreateAccessToken,
          integrationId = _ref2.integrationId,
          postSuccessCB = _ref2.postSuccessCB;

      var currentIntegrationStates = this.props.integrationStates;

      if (!!currentIntegrationStates && !!integrationStates && currentIntegrationStates[integrationId] !== integrationStates[integrationId] || accessTokenCreated) {
        this.setState({ updating: false });
        if (integrationStates[integrationId]) {
          postSuccessCB();
        }
      }

      if (failedCreateAccessToken) {
        this.props.notifications.error("We could not connect. Please check your input and try again.");
        this.setState({ updating: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var updating = this.state.updating;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: this.props.className },
        updating ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { paddingTop: '1rem', maxWidth: '50px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__["a" /* default */], null)
        ) : this.renderConnectors()
      );
    }
  }]);

  return IntegrationConnector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

IntegrationConnector.defaultProps = {
  postSuccessCB: function postSuccessCB() {},
  title: 'CONNECT ACCOUNT'
};


var mapStateToProps = function mapStateToProps(state, props) {
  var integrationName = props.integrationId || '';

  return {
    integrationStates: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state),
    accessTokenCreated: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_selectors__["g" /* didCreateAccessToken */])(state, integrationName),
    accessTokenCreationFailed: Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_selectors__["h" /* failedCreateAccessToken */])(state, integrationName)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking__["a" /* actions */].track,
      createAccessToken: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__["a" /* createAccessToken */],
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__["l" /* fetchIntegrationStates */],
      updateIntegrationState: __WEBPACK_IMPORTED_MODULE_9_app_modules_integrations_actions__["T" /* updateIntegrationState */]
    }, dispatch)
  };
};

var IntegrationConnectorConnect = Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(IntegrationConnector));

/* harmony default export */ __webpack_exports__["a"] = (IntegrationConnectorConnect);

/***/ }),

/***/ "lxwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("dk5j");










var mapStateToProps = function mapStateToProps(state, props) {
  return {
    keyword: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_8" /* getKeyword */](state, props)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      deleteKeyword: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["L" /* deleteKeyword */],
      setKeywordText: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_178" /* setKeywordText */],
      setKeywordType: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_179" /* setKeywordType */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_2_recompose_withHandlers___default()({
  onDeleteClick: function onDeleteClick(props) {
    return function () {
      return props.actions.deleteKeyword(props.id);
    };
  },
  onTextChange: function onTextChange(props) {
    return function (event) {
      props.actions.setKeywordText({
        keywordId: props.id,
        text: event.target.value
      });
    };
  },
  onTypeChange: function onTypeChange(props) {
    return function (_ref) {
      var type = _ref.value;

      props.actions.setKeywordType({
        keywordId: props.id,
        type: type
      });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "ly6L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conversationIdFromPathname;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("dMZj");


function conversationIdFromPathname(pathname) {
  var result = __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONVERSATIONS_REGEX */].exec(pathname);

  if (result && result[2]) {
    return parseInt(result[2]);
  }
}

/***/ }),

/***/ "lzSP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/* harmony default export */ __webpack_exports__["a"] = (Marty.createConstants(['INBOX_FETCH_STATS_DONE', 'INBOX_FETCH_STATS_FAILED']));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "m1DN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_ModalHelpers__ = __webpack_require__("2MvB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_GlobalModalConstants__ = __webpack_require__("xJoo");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ModalState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  show: false,
  data: Object(__WEBPACK_IMPORTED_MODULE_1_utils_ModalHelpers__["a" /* ModalData */])()
});

var GlobalModalStore = function (_Marty$Store) {
  _inherits(GlobalModalStore, _Marty$Store);

  function GlobalModalStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalModalStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalModalStore.__proto__ || Object.getPrototypeOf(GlobalModalStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = ModalState(), _this.handlers = {
      openModal: [__WEBPACK_IMPORTED_MODULE_2_constants_GlobalModalConstants__["a" /* default */].MODAL_OPENED],
      closeModal: [__WEBPACK_IMPORTED_MODULE_2_constants_GlobalModalConstants__["a" /* default */].MODAL_CLOSED]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalModalStore, [{
    key: 'dehydrate',
    value: function dehydrate() {
      return this.state.toJS();
    }
  }, {
    key: 'rehydrate',
    value: function rehydrate(dehydratedState) {
      var show = dehydratedState.show,
          data = dehydratedState.data;

      return ModalState({ show: show, data: __WEBPACK_IMPORTED_MODULE_1_utils_ModalHelpers__["a" /* ModalData */].apply(undefined, _toConsumableArray(data)) });
    }
  }, {
    key: 'getModalState',
    value: function getModalState() {
      return this.fetch({
        id: 'getModalState',
        locally: function locally() {
          return this.state;
        }
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(modalData) {
      this.state = this.state.set('show', true).set('data', modalData);
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.state = this.state.set('show', false);
    }
  }]);

  return GlobalModalStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (GlobalModalStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "m1lM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SegmentPreviewLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__ = __webpack_require__("EP6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_campaign_NewCampaign_SegmentOptionRow__ = __webpack_require__("dOkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AudienceOption__ = __webpack_require__("Khpy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_SegmentSelectHelper__ = __webpack_require__("iKCO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_MessageUsers_Compose_EditableArea_style__ = __webpack_require__("mHc7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_MessageUsers_Compose_EditableArea_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_MessageUsers_Compose_EditableArea_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__("Niip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);











/**
 * return all the segment rows and the selected one if any
 * @param segments
 * @param users
 * @param selectedSegmentId
 * @returns {{rows: Nodes, selected: Node|null}}
 */
function renderSegmentOptions(segments, users, selectedSegmentId) {
  var selected = void 0;
  var rows = segments.map(function (segment) {
    var row = React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_campaign_NewCampaign_SegmentOptionRow__["a" /* default */], { segment: segment, author: users[segment.authorId] });
    if (selectedSegmentId === segment.id) {
      selected = row;
    }
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__["MenuItem"],
      {
        key: segment.id,
        value: segment.id,
        text: segment.name
      },
      row
    );
  });
  return { rows: rows, selected: selected };
}

function getSelectedAudienceOption(selectedSegmentId) {
  switch (selectedSegmentId) {
    case "VISITORS":
      return __WEBPACK_IMPORTED_MODULE_4__AudienceOption__["a" /* AnonymousOption */];
    case "EVERYONE":
      return React.createElement(__WEBPACK_IMPORTED_MODULE_4__AudienceOption__["b" /* EveryoneOption */], null);
    case "USERS":
      return React.createElement(__WEBPACK_IMPORTED_MODULE_4__AudienceOption__["c" /* IdentifiedUsersOption */], null);
    default:
      return "Pick a segment";
  }
}

var SegmentPreviewLink = function SegmentPreviewLink(_ref) {
  var segmentId = _ref.segmentId;

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
    {
      to: '/contacts/segments/' + segmentId,
      target: '_self',
      className: 'link dsg-Regular'
    },
    'Preview segment'
  );
};
SegmentPreviewLink.propTypes = {
  segmentId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired

  /**
   * Render SegmentSelect for a wizard.
   * @param onSelection
   * @param selectedSegmentId
   * @param isSlider, used for business logic, when true AnonymousOption is available
   * @param users
   * @param segments
   * @returns {XML}
   * @constructor
   */
};var SegmentSelect = function SegmentSelect(_ref2) {
  var onSelection = _ref2.onSelection,
      selectedSegmentId = _ref2.selectedSegmentId,
      isSlider = _ref2.isSlider,
      users = _ref2.users,
      segments = _ref2.segments;

  var previewLink = selectedSegmentId && Number.isInteger(selectedSegmentId) ? React.createElement(SegmentPreviewLink, { segmentId: selectedSegmentId }) : null;
  var segmentsToRender = Object(__WEBPACK_IMPORTED_MODULE_5_utils_SegmentSelectHelper__["a" /* getSegmentSelection */])(selectedSegmentId, segments);

  var _renderSegmentOptions = renderSegmentOptions(segmentsToRender, users, selectedSegmentId),
      rows = _renderSegmentOptions.rows,
      selected = _renderSegmentOptions.selected;

  var selectedOption = selected || getSelectedAudienceOption(selectedSegmentId);

  return React.createElement(
    'div',
    { key: 'segmentId', className: __WEBPACK_IMPORTED_MODULE_6_components_CampaignWizards_MessageUsers_Compose_EditableArea_style___default.a.InputWrapper + ' ' + __WEBPACK_IMPORTED_MODULE_7__style___default.a.TargetingAudience },
    React.createElement(
      'div',
      { className: 'flex-space-between' },
      React.createElement(
        'label',
        { className: 'dsg-Label color-navy-dark' },
        'Segment'
      ),
      previewLink
    ),
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__["Wrapper"],
      {
        className: 'AriaMenuButton AriaMenuButton--large nm-segment-select',
        onSelection: onSelection
      },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__["Button"],
        null,
        React.createElement(
          'div',
          { className: 'content' },
          selectedOption
        )
      ),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_aria_menubutton__["Menu"],
        null,
        isSlider ? React.createElement(__WEBPACK_IMPORTED_MODULE_4__AudienceOption__["b" /* EveryoneOption */], null) : null,
        isSlider ? React.createElement(__WEBPACK_IMPORTED_MODULE_4__AudienceOption__["c" /* IdentifiedUsersOption */], null) : null,
        isSlider ? __WEBPACK_IMPORTED_MODULE_4__AudienceOption__["a" /* AnonymousOption */] : null,
        rows
      )
    )
  );
};
SegmentSelect.propTypes = {
  onSelection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  selectedSegmentId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]).isRequired,
  isSlider: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
  users: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired,
  segments: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array.isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (SegmentSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "m2VY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_models__ = __webpack_require__("8Eel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("TOwt");













var MEETING_ADJECTIVES = ['quick', 'informational', 'important', 'onboarding', 'platinum', 'masters'];
var MEETING_NOUNS = ['demo', 'meeting', 'chat', 'call', 'talk', 'follow-up', 'check-in'];

function makeMapStateToProps() {
  return function (state, _ref) {
    var params = _ref.params;

    var slug = params.meetingTypeSlug;
    var isDefault = slug === 'default';
    var isNew = slug === 'new';
    return {
      assistantAgentSettings: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_selectors__["a" /* assistantAgentSettings */])(state),
      profileUrl: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profileUrl"](state),
      profileUrlHandle: __WEBPACK_IMPORTED_MODULE_3_app_modules_profile_selectors__["profileUrlHandle"](state),
      isDefault: isDefault,
      meetingTypes: __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["o" /* getMeetingTypes */](state),
      isSettingsLoaded: isDefault ? __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["x" /* isMeetingSettingsLoaded */](state) : __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["y" /* isMeetingTypesLoaded */](state),
      savedSettings: isNew ? __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_models__["e" /* defaultNewMeetingType */] : isDefault ? __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["f" /* getDefaultMeetingType */](state) : __WEBPACK_IMPORTED_MODULE_4_app_modules_meetings_selectors__["o" /* getMeetingTypes */](state).find(function (mt) {
        return mt.slug === slug;
      })
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchDefaultSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      fetchCustomSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["O" /* fetchMeetingTypes */],
      updateDefaultSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["a" /* debounceUpdateMeetingSettings */],
      updateCustomSettings: __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_actions__["_31" /* updateMeetingType */],
      fetchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_7_app_modules_assistantSettings_actions__["i" /* fetchAssistantAgentSettings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        isDefault = _props.isDefault,
        isSettingsLoaded = _props.isSettingsLoaded,
        _props$actions = _props.actions,
        fetchDefaultSettings = _props$actions.fetchDefaultSettings,
        fetchCustomSettings = _props$actions.fetchCustomSettings;

    if (!isSettingsLoaded) {
      isDefault ? fetchDefaultSettings() : fetchCustomSettings();
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref2) {
  var isSettingsLoaded = _ref2.isSettingsLoaded,
      savedSettings = _ref2.savedSettings;
  return !savedSettings || !isSettingsLoaded;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('settings', 'setSettings', function (_ref3) {
  var savedSettings = _ref3.savedSettings;
  return savedSettings.set('allowNewAppointments', true);
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isTitleEmpty', 'setIsTitleEmpty', function (props) {
  return props.settings.name === '';
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isTitleChanged', 'setIsTitleChanged', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isSlugInConflict', 'setIsSlugInConflict', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isSlugEmpty', 'setIsSlugEmpty', function (props) {
  return _.get(props, 'settings.slug') === '';
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isSlugChanged', 'setIsSlugChanged', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isSlugReserved', 'setIsSlugReserved', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isSaving', 'setSaving', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('isCopied', 'setIsCopied', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    isSlugValid: props.isDefault || !props.isSlugInConflict && !props.isSlugEmpty && !props.isSlugReserved,
    saveSettings: props.isDefault ? props.actions.updateDefaultSettings : props.actions.updateCustomSettings,
    isSettingsChanged: !_.isEqual(props.savedSettings, props.settings)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function () {
  var meetingNoun = _.sample(MEETING_NOUNS);
  var placeholderSlug = _.sample(MEETING_ADJECTIVES) + '-' + meetingNoun;
  return {
    placeholderSlug: placeholderSlug
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref4) {
  var assistantAgentSettings = _ref4.assistantAgentSettings;
  return {
    confirmationEmailStatus: assistantAgentSettings.getIn(['MEETING_CONFIRMATION', 'on'], false),
    reminderEmailStatus: assistantAgentSettings.getIn(['MEETING_REMINDER', 'on'], false)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  handleCopyMeetingLink: function handleCopyMeetingLink(_ref5) {
    var setIsCopied = _ref5.setIsCopied;
    return function () {
      setIsCopied(true);
      setTimeout(function () {
        setIsCopied(false);
      }, 1000);
    };
  },
  handleSave: function handleSave(_ref6) {
    var settings = _ref6.settings,
        saveSettings = _ref6.saveSettings,
        setSaving = _ref6.setSaving,
        savedSettings = _ref6.savedSettings,
        router = _ref6.router,
        isDefault = _ref6.isDefault;
    return function () {
      if (!isDefault && settings.slug !== savedSettings.slug) {
        saveSettings(settings.set('oldSlug', savedSettings.slug));
      } else {
        saveSettings(settings);
      }
      setSaving(true);
      setTimeout(function () {
        router.push('/settings/calendar');
      }, 800);
    };
  },
  handleUpdateMeetingName: function handleUpdateMeetingName(_ref7) {
    var settings = _ref7.settings,
        setSettings = _ref7.setSettings,
        setIsTitleEmpty = _ref7.setIsTitleEmpty,
        setIsTitleChanged = _ref7.setIsTitleChanged;
    return function (_ref8) {
      var value = _ref8.target.value;

      setIsTitleEmpty(value === '');
      setIsTitleChanged(true);
      setSettings(settings.set('name', value));
    };
  },
  handleDurationSelect: function handleDurationSelect(_ref9) {
    var settings = _ref9.settings,
        setSettings = _ref9.setSettings;
    return function (_ref10) {
      var value = _ref10.value;

      setSettings(settings.set('duration', value));
    };
  },
  handleChangeMeetingSlug: function handleChangeMeetingSlug(props) {
    return function (_ref11) {
      var value = _ref11.target.value;
      var meetingTypes = props.meetingTypes,
          setIsSlugInConflict = props.setIsSlugInConflict,
          setIsSlugEmpty = props.setIsSlugEmpty,
          setIsSlugChanged = props.setIsSlugChanged,
          setIsSlugReserved = props.setIsSlugReserved,
          setSettings = props.setSettings,
          savedSettings = props.savedSettings,
          settings = props.settings;

      var newSlug = value.toLowerCase();
      if (newSlug.replace(/[a-z0-9\-]+/, '').length) return false;

      var matchingMeetingTypes = meetingTypes.find(function (mt) {
        return mt.slug === newSlug;
      });
      setIsSlugInConflict(!!matchingMeetingTypes && savedSettings.slug !== newSlug);
      setIsSlugEmpty(newSlug === '');
      setIsSlugChanged(true);
      setIsSlugReserved(['default', 'meeting', 'new'].includes(newSlug));
      setSettings(settings.set('slug', newSlug));
    };
  },
  handleUpdateMeetingLocation: function handleUpdateMeetingLocation(_ref12) {
    var setSettings = _ref12.setSettings,
        settings = _ref12.settings;
    return function (_ref13) {
      var value = _ref13.target.value;

      setSettings(settings.set('location', value));
    };
  },
  handleUpdateMeetingDescription: function handleUpdateMeetingDescription(_ref14) {
    var setSettings = _ref14.setSettings,
        settings = _ref14.settings;
    return function (value) {
      setSettings(settings.set('inviteDescription', value));
    };
  },
  handleExitAttempt: function handleExitAttempt(_ref15) {
    var isSaving = _ref15.isSaving,
        savedSettings = _ref15.savedSettings,
        settings = _ref15.settings;
    return function () {
      return !isSaving && !_.isEqual(savedSettings, settings) ? 'You have unsaved changes. Would you like to exit without saving?' : true;
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props2 = this.props,
        router = _props2.router,
        route = _props2.route,
        handleExitAttempt = _props2.handleExitAttempt;

    router.setRouteLeaveHook(route, handleExitAttempt);
    this.props.actions.fetchAssistantAgentSettings();
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "m8XX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return embedLoadFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return embedLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return embedFetchPending; });
/* unused harmony export embedPatchPending */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return embedPatchSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return embedNotFetched; });
/* unused harmony export getRawEmbedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getEmbedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOrgId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOrgName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getOrgShowBranding; });
/* unused harmony export getRawEmbedConfiguration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getEmbedConfig; });
/* unused harmony export orgLocale */
/* unused harmony export orgUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return orgTwitterLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return orgLinkedinLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return orgFacebookLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return orgAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isChatEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isShowWidgetIfConvoHistoryEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return selectedWidgetFont; });
/* unused harmony export showUnfurl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return orgTimezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backgroundColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return logoUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultInboxId; });
/* unused harmony export makeEmbedHasGate */
/* unused harmony export isGlobalLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("rrQF");




var root = function root(state) {
  return state.get('embed');
};

var embedLoadFailed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('status') === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* FETCH_EMBED_FAILED */];
});

var embedLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* FETCH_EMBED_SUCCESS */], __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* PATCH_EMBED_SUCCESS */]].includes(root.get('status'));
});

var embedFetchPending = function embedFetchPending(state) {
  return state.getIn(['embed', 'status']) === __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* FETCH_EMBED_PENDING */];
};
var embedPatchPending = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('status') === __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* PATCH_EMBED_PENDING */];
});
var embedPatchSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('status') === __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* PATCH_EMBED_SUCCESS */];
});
var embedNotFetched = function embedNotFetched(state) {
  return !state.getIn(['embed', 'status']);
};
var getRawEmbedData = function getRawEmbedData(state) {
  return root(state).get('data');
};

var getEmbedId = function getEmbedId(state) {
  return root(state).getIn(['data', 'id']);
};
var getOrgId = function getOrgId(state) {
  return root(state).getIn(['data', 'orgId']);
};
var getOrgName = function getOrgName(state) {
  return root(state).getIn(['data', 'configuration', 'organizationName']);
};
var getOrgShowBranding = function getOrgShowBranding(state) {
  return root(state).getIn(['data', 'configuration', 'showBranding']);
};
var getRawEmbedConfiguration = function getRawEmbedConfiguration(state) {
  return root(state).getIn(['data', 'configuration']);
};
var getEmbedConfig = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getRawEmbedConfiguration, function (config) {
  return config ? config.toJS() : null;
});

var orgLocale = function orgLocale(state) {
  return root(state).getIn(['data', 'configuration', 'locale']);
};

var orgUrl = function orgUrl(state) {
  return root(state).getIn(['data', 'configuration', 'organizationUrl']);
};
var orgTwitterLink = function orgTwitterLink(state) {
  return root(state).getIn(['data', 'configuration', 'organizationTwitterLink']);
};
var orgLinkedinLink = function orgLinkedinLink(state) {
  return root(state).getIn(['data', 'configuration', 'organizationLinkedinLink']);
};
var orgFacebookLink = function orgFacebookLink(state) {
  return root(state).getIn(['data', 'configuration', 'organizationFacebookLink']);
};

var orgAddress = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getRawEmbedConfiguration, function (config) {
  return (config || Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()).get('organizationAddress');
});

var isChatEnabled = function isChatEnabled(state) {
  return root(state).getIn(['data', 'configuration', 'chatEnabled'], false);
};
var isShowWidgetIfConvoHistoryEnabled = function isShowWidgetIfConvoHistoryEnabled(state) {
  return root(state).getIn(['data', 'configuration', 'theme', 'enableChatIfConversationHistory'], false);
};
var theme = function theme(state) {
  return root(state).getIn(['data', 'configuration', 'theme'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
};

var selectedWidgetFont = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(theme, function (theme) {
  return theme.get('fontFamily', 'Brandon');
});
var showUnfurl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(theme, function (theme) {
  return theme.get('showUnfurl', true);
});
var orgTimezone = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(theme, function (theme) {
  return theme.get('timezone', 'America/New_York');
});
var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(theme, function (theme) {
  if (theme) {
    return '#' + theme.get('backgroundColor');
  }
});

var logoUrl = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(theme, function (theme) {
  return theme.get('logoUrl');
});
var defaultInboxId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.getIn(['data', 'configuration', 'inboxId']);
});
var getGates = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getRawEmbedConfiguration, function (config) {
  return config && config.get('gates');
});
var makeEmbedHasGate = function makeEmbedHasGate(gate) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(embedLoaded, getGates, function (embedLoaded, gates) {
    return embedLoaded && gates && gates.get(gate);
  });
};

var locale = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getEmbedConfig, function (embed) {
  return embed && embed.locale;
});
var isGlobalLocale = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(locale, locale !== 'en');

/***/ }),

/***/ "m93T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return model; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hydrateModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__ = __webpack_require__("QM6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var model = [{
  type: 'syncContactsEnabled',
  value: false,
  label: 'Sync leads from Drift to Eloqua',
  description: 'Leads from Drift will be created or updated in Eloqua whenever a conversation closes'
}, {
  type: 'shouldSetLeadOwner',
  value: false,
  label: 'Set Salesperson in Eloqua',
  description: 'For every new contact that Drift creates, we can set a Salesperson (if the Salesperson field is currently empty) based on who had a meeting booked, who was routed, or who closed the conversation in that order.'
}, {
  type: 'shouldOnlySyncQualifiedContacts',
  value: false,
  label: 'Set a minimum CQL score for synced contacts and conversations',
  description: 'Unchecked, Drift will sync all contacts and conversations to Eloqua except those that have been disqualified.',
  children: {
    autoExpand: true,
    label: 'Minimum CQL score',
    description: 'Drift will only sync conversations that have the selected CQL score or higher.',
    topLevelAdvancedItems: [],
    advancedComponent: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({
      integrationName: 'eloqua',
      setMinimumCQLScore: function setMinimumCQLScore(data) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["G" /* patchEloquaConfig */])({ "minimumCQLScore": data.score });
      },
      getMinimumCQLScore: function getMinimumCQLScore() {
        return Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["q" /* getEloquaConfig */])();
      }
    })(__WEBPACK_IMPORTED_MODULE_0__MinimumCqlScoreWidget__["a" /* default */]),
    items: []
  }
}, {
  type: 'syncConversationTranscriptsEnabled',
  value: false,
  label: 'Sync CDOs from Drift to Eloqua',
  description: "Push data to an Eloqua CDO of your choice. You can configure what data gets sent in the 'Mapped CDO Attributes' section"
}, {
  type: 'cookieIdentificationEnabled',
  value: false,
  label: 'Identify Drift visitors with the Eloqua cookie',
  description: 'If someone was already identified by Eloqua, Drift will automatically recognize them as a known contact. We\'ll only check Eloqua if the visitor has an Eloqua cookie set.'
}];

var hydrateModel = function hydrateModel(toggles) {
  return [].concat(model).map(function (topLevel) {
    var updatedToggle = _extends({}, topLevel);
    updatedToggle.value = toggles[topLevel.type];
    return updatedToggle;
  });
};

/***/ }),

/***/ "m9HF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("v4pT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_sequence_svg__ = __webpack_require__("DgN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_sequence_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_sequence_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var EnrollButton = function (_Component) {
  _inherits(EnrollButton, _Component);

  function EnrollButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, EnrollButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EnrollButton.__proto__ || Object.getPrototypeOf(EnrollButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      modalVisible: false,
      googleScopesFetched: false,
      googleScopes: []
    }, _this.messageEventHandler = function (event) {
      var frame = document.getElementById("contact-sequence-enroll-frame");
      if (event.source !== frame && !event.data.type) {
        return;
      }
      if (event.data.type === '@@driftext/hide_enroll_modal') {
        _this.setState({
          modalVisible: false
        });
      }
    }, _this.receiveScopes = function (data) {
      _this.setState({
        googleScopes: data,
        googleScopesFetched: true
      });
    }, _this.handleButtonClick = function () {
      _this.setState({ modalVisible: true });
    }, _this.handleCloseClick = function () {
      _this.setState({
        modalVisible: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(EnrollButton, [{
    key: 'componendWillUnmount',
    value: function componendWillUnmount() {
      window.removeEventListener('message', this.messageEventHandler, false);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('message', this.messageEventHandler, false);
      Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_api__["r" /* getGoogleScopes */])().then(this.receiveScopes);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          emails = _props.emails;
      var _state = this.state,
          modalVisible = _state.modalVisible,
          googleScopesFetched = _state.googleScopesFetched,
          googleScopes = _state.googleScopes;

      //will always be 1 email

      var enrollEmail = encodeURIComponent(emails[0]);

      var buttonProps = {
        className: 'drift-button',
        style: style,
        children: [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_images_svg_sequence_svg___default.a, key: 'enroll-button-icon' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { key: 'enroll-button-copy' },
          'Enroll in Sequence'
        )]
      };
      if (!googleScopesFetched) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', _extends({}, buttonProps, { disabled: true }));
      }
      if (!googleScopes.includes(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_constants__["K" /* GoogleScopes */].READ) || !googleScopes.includes(__WEBPACK_IMPORTED_MODULE_6_app_modules_integrations_constants__["K" /* GoogleScopes */].SEND)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */], _extends({}, buttonProps, { to: '/settings/email' }));
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button', _extends({ onClick: this.handleButtonClick }, buttonProps)),
        modalVisible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-sequence-enroll-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'contact-sequence-enroll' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { id: 'contact-sequence-enroll-frame', title: 'Enroll your sequence', src: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["W" /* SEQUENCE_ENROLL_URL */] + '?email=' + enrollEmail })
          )
        )
      );
    }
  }]);

  return EnrollButton;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EnrollButton);

/***/ }),

/***/ "mHc7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SendFromSection":"SendFromSection---2w0sp","DeliveryOptionEnter":"DeliveryOptionEnter---33PYZ","DeliveryOptionLeave":"DeliveryOptionLeave---3mONb","EditableArea":"EditableArea---3TYWF","lifeIn":"lifeIn---2w6ZK","InputWrapper":"InputWrapper---2RLyx","CtaTypeMenuOption":"CtaTypeMenuOption---2OHE3","CtaType__upgradeRequired":"CtaType__upgradeRequired---2GuIt","CtaTypeUpgradeLink":"CtaTypeUpgradeLink---375TN"};

/***/ }),

/***/ "mKU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, Marty) {/* harmony export (immutable) */ __webpack_exports__["a"] = makeDefaultFailedContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__ = __webpack_require__("60ou");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function failed(errors) {
  Object(__WEBPACK_IMPORTED_MODULE_0_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
  return React.createElement('div', null);
}

function makeDefaultFailedContainer(component, options) {
  return Marty.createContainer(component, _extends(options, { failed: failed }));
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "mKgd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mLv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_MessagePreviews_WelcomeMessage__ = __webpack_require__("jbeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("Oa/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__("Pq8k");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var WelcomeMessageBuilderContainer = function (_Component) {
  _inherits(WelcomeMessageBuilderContainer, _Component);

  function WelcomeMessageBuilderContainer() {
    _classCallCheck(this, WelcomeMessageBuilderContainer);

    return _possibleConstructorReturn(this, (WelcomeMessageBuilderContainer.__proto__ || Object.getPrototypeOf(WelcomeMessageBuilderContainer)).apply(this, arguments));
  }

  _createClass(WelcomeMessageBuilderContainer, [{
    key: 'resolveDefaultMessage',
    value: function resolveDefaultMessage() {
      var _props = this.props,
          previewState = _props.previewState,
          intl = _props.intl;


      return previewState === __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* PreviewState */].ONLINE ? intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* Messages */].defaultWelcomeMessage) : intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* Messages */].defaultAwayMessage);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          theme = _props2.theme,
          currentUser = _props2.currentUser,
          name = _props2.name,
          intl = _props2.intl,
          message = _props2.message,
          isHTMLPreview = _props2.isHTMLPreview;

      var resolvedMessage = message ? message : this.resolveDefaultMessage();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_components_shared_MessagePreviews_WelcomeMessage__["a" /* default */],
        {
          backgroundColor: theme.backgroundColor,
          foregroundColor: theme.foregroundColor,
          showProfileIcon: true,
          users: __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].of(currentUser),
          title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            name
          ),
          isHTMLPreview: isHTMLPreview,
          message: resolvedMessage },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'composer' },
          intl.formatMessage(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* Messages */].typeMessage)
        )
      );
    }
  }]);

  return WelcomeMessageBuilderContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["d" /* injectIntl */])(WelcomeMessageBuilderContainer));

/***/ }),

/***/ "mLwC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_OVERVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_OVERVIEW_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_OVERVIEW_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_OVERVIEW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('org/overview');

var FETCH_OVERVIEW = makeConstant('FETCH_OVERVIEW');
var FETCH_OVERVIEW_PENDING = makeConstant('FETCH_OVERVIEW_PENDING');
var FETCH_OVERVIEW_FAILED = makeConstant('FETCH_OVERVIEW_FAILED');
var RECEIVE_OVERVIEW = makeConstant('RECEIVE_OVERVIEW');

/***/ }),

/***/ "mMZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "track", function() { return track; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "page", function() { return page; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_tracking__ = __webpack_require__("jAlB");



/**
 * @depreacted Use utils/tracking/trackEvent
 */
var track = function track(eventName, properties) {
  return function (dispatch) {
    return dispatch(__WEBPACK_IMPORTED_MODULE_0_app_modules_user__["a" /* actions */].fetchCurrentUser()).then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_tracking__["b" /* trackEvent */])(eventName, properties);
    });
  };
};

/**
 * @depreacted Use utils/tracking/trackPageView
 */
var page = function page() {
  return function () {
    Object(__WEBPACK_IMPORTED_MODULE_1_utils_tracking__["c" /* trackPageView */])();
  };
};

/***/ }),

/***/ "mNi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mQ0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Lander */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_nav_Header_HeaderBrand__ = __webpack_require__("ZsVd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_nav_Header__ = __webpack_require__("fvhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_CircleOfWaiting__ = __webpack_require__("aQOb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_images_svg_outreach_intermidate_step_svg__ = __webpack_require__("s32+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__svg_inline_images_svg_outreach_intermidate_step_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__svg_inline_images_svg_outreach_intermidate_step_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl__ = __webpack_require__("VRvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















function getHubSpotData(_ref) {
  var code = _ref.code;

  return { code: code };
}

var GOOGLE_CALENDAR_ERROR_PROP = 'google-calendar-error';
var GOOGLE_CALENDAR_INTEGRATION_NAME = 'google-calendar';
var ZOOM_INTEGRATION_NAME = 'zoom';
var ZOOM_ERROR_PROP = 'zoom-error';
var MICROSOFT_CALENDAR_INTEGRATION_NAME = 'office-365-calendar';
var MICROSOFT_ADMIN_CONSENT_NAME = 'office-365-admin-consent';

var Lander = function (_Component) {
  _inherits(Lander, _Component);

  function Lander() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Lander);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Lander.__proto__ || Object.getPrototypeOf(Lander)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      closed: false,
      displayOutreachIntermediateState: false,
      pardotError: ''
    }, _this.closeWindowAndNotify = function (status) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      _this.setState({ closed: true }, function () {
        window.opener && window.opener.postMessage({ status: status ? 'success' : 'failure', errormessage: error }, window.location.origin);
        if (_this.props.location.query.isDesktop) {
          window.location.href = 'https://app.drift.com/conversations/deep-link?url=conversations/' + _this.props.location.query.isDesktop;
        } else {
          window.close();
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Lander, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var integration = this.props.params.integration;


      if (this.shouldDisplayOutreachIntermediateState(nextProps)) {
        this.setState({
          displayOutreachIntermediateState: true
        });
        return;
      }

      if (nextProps.accessTokenCreated) {
        console.log('access token created');
        this.closeWindowAndNotify(true);
      } else if (nextProps.accessTokenCreationFailed) {
        console.log('failed to create access token');
        this.closeWindowAndNotify(false, nextProps.accessTokenError);
      } else if (nextProps.statusByIntegration.has(integration)) {
        var status = nextProps.statusByIntegration.get(integration);
        this.closeWindowAndNotify(status);
      } else {
        console.log('no access token info');
      }
    }
  }, {
    key: 'shouldDisplayOutreachIntermediateState',
    value: function shouldDisplayOutreachIntermediateState(nextProps) {
      var integration = nextProps.params.integration,
          state = nextProps.location.query.state;


      if (integration !== "outreach") {
        return false;
      }

      var stateParams = state && JSON.parse(state);

      return stateParams && (nextProps.accessTokenCreated || nextProps.statusByIntegration.has("outreach")) && !stateParams.isDriftConnectedOnOutreachSide;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var integration = this.props.params.integration;


      switch (integration) {
        case "hubspot":
          this.handleHubSpot();
          break;
        case "outreach":
          this.handleOutreach();
          break;
        case "mailchimp":
          this.handleMailChimp();
          break;
        case "segment":
          this.handleSegment();
          break;
        case "drip":
          this.handleDrip();
          break;
        case "wordpress":
          this.handleWordpress();
          break;
        case "slack":
          this.handleSlack();
          break;
        case "salesforce":
          this.handleSalesforce();
          break;
        case "salesforceSandbox":
          this.handleSalesforceSandbox();
          break;
        case "pardot":
          this.handlePardot();
          break;
        case "zendesk":
          this.handleZendesk();
          break;
        case GOOGLE_CALENDAR_INTEGRATION_NAME:
          this.handleGoogleCalendar();
          break;
        case MICROSOFT_CALENDAR_INTEGRATION_NAME:
          this.handleMicrosoftCalendar();
          break;
        case ZOOM_INTEGRATION_NAME:
          this.handleZoom();
          break;
        case MICROSOFT_ADMIN_CONSENT_NAME:
          this.handleMicrosoftAdminConsent();
          break;

      }
    }
  }, {
    key: 'handleSlack',
    value: function handleSlack() {
      var code = this.props.location.query.code;

      this.props.actions.createSlackbotToken({ code: code, href: '' + window.location.origin + window.location.pathname });
    }
  }, {
    key: 'handleMailChimp',
    value: function handleMailChimp() {
      var _window$location = window.location,
          pathname = _window$location.pathname,
          origin = _window$location.origin;

      var update = {
        code: this.props.location.query.code,
        redirectUrl: '' + origin + pathname
      };
      this.props.actions.createAccessToken({ integrationName: 'mailchimp', body: update });
    }
  }, {
    key: 'handleDrip',
    value: function handleDrip() {
      var update = {
        code: this.props.location.query.code
      };
      this.props.actions.createAccessToken({ integrationName: 'drip', body: update });
    }
  }, {
    key: 'handleSalesforce',
    value: function handleSalesforce() {
      var update = {
        code: this.props.location.query.code,
        error: this.props.location.query.error
      };
      this.props.actions.createAccessToken({ integrationName: 'salesforce', body: update });
    }
  }, {
    key: 'handleSalesforceSandbox',
    value: function handleSalesforceSandbox() {
      var update = {
        code: this.props.location.query.code,
        sandbox: true
      };
      this.props.actions.createSandBoxAccessToken({ integrationName: 'salesforceSandbox', body: update });
    }
  }, {
    key: 'handlePardot',
    value: function handlePardot() {
      // If we get here we either signed into Pardot successfully on the backend
      // or we passed in the error we encountered
      var error = this.props.location.query.error;
      console.log('lander error ' + error);
      error ? this.props.actions.createAccessTokenFailed({ err: error, integrationName: 'Pardot' }) : this.props.actions.createAccessTokenSuccess({ integrationName: 'Pardot' });
    }
  }, {
    key: 'handleWordpress',
    value: function handleWordpress() {
      var update = {
        code: this.props.location.query.code
      };
      this.props.actions.createAccessToken({ integrationName: 'wordpress', body: update });
    }
  }, {
    key: 'handleOutreach',
    value: function handleOutreach() {
      var update = {
        code: this.props.location.query.code
      };
      this.props.actions.createAccessToken({ integrationName: 'outreach', body: _extends({}, update, { redirectUri: __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/outreach' }) });
    }
  }, {
    key: 'handleZendesk',
    value: function handleZendesk() {
      var update = {
        code: this.props.location.query.code,
        accountName: this.props.location.query.state
      };
      this.props.actions.createAccessToken({ integrationName: 'zendesk', body: update });
    }
  }, {
    key: 'handleHubSpot',
    value: function handleHubSpot() {
      var update = getHubSpotData(this.props.location.query);
      this.props.actions.createAccessToken({ integrationName: 'hubspot', body: update });
    }
  }, {
    key: 'handleSegment',
    value: function handleSegment() {
      // segment does nothing but posting a message done
      setTimeout(function () {
        window.opener.postMessage('DONE', window.location.origin);
        window.close();
      }, 3000);
    }
  }, {
    key: 'handleGoogleCalendar',
    value: function handleGoogleCalendar() {
      var code = this.props.location.query.code;
      this.props.actions.googleCalendarOauthAccept(code);
    }
  }, {
    key: 'handleMicrosoftCalendar',
    value: function handleMicrosoftCalendar() {
      var code = this.props.location.query.code;
      this.props.actions.microsoftCalendarOauthAccept(code);
    }
  }, {
    key: 'handleZoom',
    value: function handleZoom() {
      var code = this.props.location.query.code;
      this.props.actions.zoomOauthAccept(code);
    }
  }, {
    key: 'handleMicrosoftAdminConsent',
    value: function handleMicrosoftAdminConsent() {
      var tenantWithQuotes = this.props.location.query.tenant;
      var tenant = tenantWithQuotes.replace(/['"]+/g, '');

      if (!!tenant) {
        this.props.actions.microsoftAdminManagedAccept(tenant);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var displayOutreachIntermediateState = this.state.displayOutreachIntermediateState;

      return displayOutreachIntermediateState ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'outreach-intermidate-step' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_10__svg_inline_images_svg_outreach_intermidate_step_svg___default.a, className: 'outreach-intermidate-step-svg' }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'h3',
          null,
          'Continue to connect Drift in Outreach'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'outreach-intermidate-step-copy' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            ' Just connect Drift in Outreach and you\u2019ll be able to unenroll contacts or create a task when a new Drift conversation is started from a sequence. '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__driftt_tide_core_legacy__["Button"],
          { type: 'primary', href: 'https://accounts.outreach.io/apps/drift/install' },
          ' Connect Drift in Outreach '
        )
      ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_components_nav_Header__["a" /* default */],
        { title: 'Integration',
          showTitle: false,
          showClose: false,
          leftNav: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_nav_Header_HeaderBrand__["a" /* default */], null)
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex-center flex-column ' + __WEBPACK_IMPORTED_MODULE_16__style_styl___default.a.AcceptIntegrate },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'dsg-h1' },
            'Accepting permissions',
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_CircleOfWaiting__["a" /* default */], null)
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            null,
            'Please give us a few moments while we hook it up for you'
          )
        )
      );
    }
  }]);

  return Lander;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Lander.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};
function mapStateToProps(state, props) {
  var _extends2;

  var integrationName = props.params.integration || '';
  if (integrationName === 'pardot') {
    console.log('param set to pardot');
    integrationName = 'Pardot';
  }

  return {
    statusByIntegration: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(_extends((_extends2 = {}, _defineProperty(_extends2, GOOGLE_CALENDAR_INTEGRATION_NAME, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["g" /* getIsGoogleOauthConnected */])(state)), _defineProperty(_extends2, MICROSOFT_CALENDAR_INTEGRATION_NAME, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["i" /* getIsMicrosoftOauthConnected */])(state)), _defineProperty(_extends2, ZOOM_INTEGRATION_NAME, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["k" /* getIsZoomOauthConnected */])(state)), _defineProperty(_extends2, ZOOM_ERROR_PROP, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["l" /* getIsZoomOauthConnectedError */])(state)), _defineProperty(_extends2, GOOGLE_CALENDAR_ERROR_PROP, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["h" /* getIsGoogleOauthConnectedError */])(state)), _defineProperty(_extends2, MICROSOFT_ADMIN_CONSENT_NAME, Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_meetings_selectors__["t" /* hasMicrosoftAdminConsent */])(state)), _extends2), Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state))),
    accessTokenCreated: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["g" /* didCreateAccessToken */])(state, integrationName),
    accessTokenCreationFailed: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["h" /* failedCreateAccessToken */])(state, integrationName),
    accessTokenError: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_integrations_selectors__["a" /* accessTokenError */])(state, integrationName)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      googleCalendarOauthAccept: __WEBPACK_IMPORTED_MODULE_15_app_modules_meetings_actions__["_4" /* googleOauthAccept */],
      microsoftCalendarOauthAccept: __WEBPACK_IMPORTED_MODULE_15_app_modules_meetings_actions__["_10" /* microsoftOauthAccept */],
      zoomOauthAccept: __WEBPACK_IMPORTED_MODULE_15_app_modules_meetings_actions__["_39" /* zoomOauthAccept */],
      microsoftAdminManagedAccept: __WEBPACK_IMPORTED_MODULE_15_app_modules_meetings_actions__["_7" /* microsoftAdminManagedAccept */],
      createAccessToken: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["a" /* createAccessToken */],
      createSlackbotToken: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["f" /* createSlackbotToken */],
      createSandBoxAccessToken: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["e" /* createSandBoxAccessToken */],
      createAccessTokenSuccess: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["d" /* createAccessTokenSuccess */],
      createAccessTokenFailed: __WEBPACK_IMPORTED_MODULE_12_app_modules_integrations_actions__["b" /* createAccessTokenFailed */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Lander));

/***/ }),

/***/ "mQlq":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"5\" viewBox=\"0 0 21 5\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><circle cx=\"18.5\" cy=\"2.5\" r=\"2.5\"></circle><circle cx=\"10.5\" cy=\"2.5\" r=\"2.5\"></circle><circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\"></circle></g></svg>"

/***/ }),

/***/ "mVBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArchivedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SaveStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AutoSaveStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_icons_check_mark_icon_svg__ = __webpack_require__("0WCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_icons_check_mark_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_images_icons_check_mark_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_redx_svg__ = __webpack_require__("ClL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_redx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_redx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("9pOo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var ButtonUnsaved = function ButtonUnsaved(_ref) {
  var isEnabled = _ref.isEnabled,
      handleSave = _ref.handleSave,
      isOneTimeEmailPlaybook = _ref.isOneTimeEmailPlaybook;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Button"],
    { type: 'primary', onClick: handleSave },
    isEnabled ? 'Publish' : 'Save',
    ' ',
    isOneTimeEmailPlaybook ? 'Draft' : 'Changes'
  );
};

var ButtonSaved = function ButtonSaved() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: 'playbook-save-status flex-center' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
      { className: 'flex playbook-save-status-label' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_icons_check_mark_icon_svg___default.a }),
      ' Saved'
    )
  );
};

var ButtonSaving = function ButtonSaving() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: 'playbook-save-status flex-space-between loading' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
      null,
      'Saving'
    ),
    ' ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__["a" /* default */], null)
  );
};

var ButtonSaveFailed = function ButtonSaveFailed() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: 'playbook-save-status flex-center' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
      { className: 'flex playbook-save-status-label' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_redx_svg___default.a }),
      ' Save Failed'
    )
  );
};

var ArchivedStatus = function ArchivedStatus() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: 'playbook-save-status-archived' },
    'You are editing an ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'strong',
      null,
      'Archived Playbook'
    ),
    '. Your changes will not be saved.'
  );
};

var SaveStatus = function SaveStatus(_ref2) {
  var isSaved = _ref2.isSaved,
      isSaving = _ref2.isSaving,
      saveFailed = _ref2.saveFailed,
      handleSavePlaybookDraft = _ref2.handleSavePlaybookDraft,
      props = _objectWithoutProperties(_ref2, ['isSaved', 'isSaving', 'saveFailed', 'handleSavePlaybookDraft']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: 'drift-form' },
    isSaving && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonSaving, null),
    !isSaving && !isSaved && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonUnsaved, _extends({}, props, { handleSave: handleSavePlaybookDraft })),
    !isSaving && isSaved && !saveFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonSaved, null),
    !isSaving && isSaved && saveFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonSaveFailed, null)
  );
};


var AutoSaveStatus = function AutoSaveStatus(_ref3) {
  var isSaving = _ref3.isSaving,
      saveFailed = _ref3.saveFailed,
      className = _ref3.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
    { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('playbook-save-status', className, 'flex-center', { loading: isSaving, failed: saveFailed }) },
    !saveFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
      { className: 'flex playbook-save-status-label' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_images_icons_check_mark_icon_svg___default.a }),
      ' Saved'
    ),
    saveFailed && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Div"],
      { className: 'flex playbook-save-status-label' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_images_svg_redx_svg___default.a }),
      ' Save Failed'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_shared_LoadingDots__["a" /* default */], null)
  );
};

/***/ }),

/***/ "mX/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("wwd1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("G4FV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "mX/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Integration_components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("pDr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var MeetingPrepSVG = __webpack_require__("vCza");
var MeetingCancelSVG = __webpack_require__("4g/L");
var FollowUpSVG = __webpack_require__("ZUYt");

var salesforceConnectButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Integration_components_IntegrationConnector__["a" /* default */], {
  onIntegrationConnected: this.onIntegrationConnected,
  integrationId: 'salesforce',
  isOauth: true,
  oauthLink: __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__["N" /* SALESFORCE_AUTH_URL */],
  title: 'Connect Salesforce',
  connectorType: 'button',
  buttonType: 'primary',
  className: 'salesforce-integration-connector',
  oauthQueryParams: __WEBPACK_IMPORTED_MODULE_9_constants_ResourcesConstants__["P" /* SALESFORCE_PAYLOAD */]
});

var AssistantOrgSalesforceConnect = function (_React$Component) {
  _inherits(AssistantOrgSalesforceConnect, _React$Component);

  function AssistantOrgSalesforceConnect() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AssistantOrgSalesforceConnect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AssistantOrgSalesforceConnect.__proto__ || Object.getPrototypeOf(AssistantOrgSalesforceConnect)).call.apply(_ref, [this].concat(args))), _this), _this.onIntegrationConnected = function () {
      _this.props.actions.fetchIntegrationStates();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AssistantOrgSalesforceConnect, [{
    key: 'render',
    value: function render() {
      var SkillsComponents = [{
        skillName: 'Always be prepared for your meeting',
        subHead: 'Before a demo, you\u2019ll get an email with enriched data like the attendee\u2019s job title, company, and links to their LinkedIn and Salesforce record.',
        canOpen: false,
        settingName: 'MEETING_PREP',
        headerIcon: function headerIcon() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: MeetingPrepSVG });
        }
      }, {
        skillName: 'Keep your leads warm',
        subHead: 'If you haven’t followed up after a meeting has been canceled or rescheduled, we’ll send you a reminder so you don’t forget.',
        canOpen: false,
        settingName: 'MEETING_CANCELLED',
        headerIcon: function headerIcon() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: MeetingCancelSVG });
        }
      }, {
        skillName: 'Never lose an Opportunity',
        subHead: 'If you haven’t followed up after a meeting has been held, we’ll send you a reminder so you don’t forget.',
        canOpen: false,
        settingName: 'DEMO_FOLLOW_UP',
        headerIcon: function headerIcon() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: FollowUpSVG });
        }
      }];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_10__style_styl___default.a.AssistantOrgSalesforceConnect },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-config-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'left-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, {
                className: 'connected-icon',
                src: __webpack_require__("nJZ+")
              }),
              'The Drift Assistant'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'description' },
              'Make sure your team never lets a lead or opportunity fall through the cracks again. Help them succeed by configuring your team\u2019s Drift Assistant with your Salesforce account.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'right-content' },
            salesforceConnectButton,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: 'https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work', target: '_blank' },
              'Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          SkillsComponents.map(function (skillProps, i) {
            var props = _extends({}, skillProps);
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Skill"], _extends({}, props, { key: 'skill-' + i }));
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'assistant-page-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Connect your Salesforce account to map the Drift Assistant to match how your team identifies qualified leads and demos held.'
          ),
          salesforceConnectButton
        )
      );
    }
  }]);

  return AssistantOrgSalesforceConnect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_6_app_modules_assistantSettings_actions__["i" /* fetchAssistantAgentSettings */],
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_actions__["l" /* fetchIntegrationStates */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(undefined, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var actions = this.props.actions;

    actions.fetchAssistantAgentSettings();
  }
}))(AssistantOrgSalesforceConnect));

/***/ }),

/***/ "mXWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OwnerMappingRow = function (_Component) {
  _inherits(OwnerMappingRow, _Component);

  function OwnerMappingRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, OwnerMappingRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OwnerMappingRow.__proto__ || Object.getPrototypeOf(OwnerMappingRow)).call.apply(_ref, [this].concat(args))), _this), _this.renderIntegrationLoader = function (index) {
      var shouldShow = _this.props.hasActiveSearch === index && _this.props.isSearching;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ 'inline-loading': shouldShow }) });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(OwnerMappingRow, [{
    key: 'renderIntegrationUserDropdown',
    value: function renderIntegrationUserDropdown() {
      var _this2 = this;

      var _props = this.props,
          integrationName = _props.integrationName,
          getUserOptions = _props.getUserOptions,
          saveOption = _props.saveOption,
          searchUsers = _props.searchUsers,
          index = _props.index,
          mapping = _props.mapping;

      var userId = mapping.integrationUserId;

      var selectOptions = {
        placeholder: 'Search ' + integrationName + ' Users...',
        value: userId,
        options: getUserOptions(userId),
        searchable: true,
        isOpen: this.props.hasActiveSearch === index,
        pageSize: 10,
        arrowRenderer: function arrowRenderer() {
          return _this2.renderIntegrationLoader(index);
        },
        onChange: function onChange(value) {
          return saveOption(value, index);
        },
        onInputChange: function onInputChange(query) {
          return searchUsers(query, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderDriftUserDropdown',
    value: function renderDriftUserDropdown() {
      var _props2 = this.props,
          saveUserOption = _props2.saveUserOption,
          mapping = _props2.mapping,
          index = _props2.index;

      var driftUserId = mapping.driftUserId;

      var selectOptions = {
        value: driftUserId,
        pageSize: 10,
        searchable: true,
        placeholder: "Select Drift User..",
        options: this.props.driftUsers,
        onChange: function onChange(value) {
          return saveUserOption(value, index);
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          index = _props3.index,
          onMappingRemove = _props3.onMappingRemove;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.renderIntegrationUserDropdown()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'integration-user-mapping-table-seperator' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.renderDriftUserDropdown()
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'integration-user-mapping-actions' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: function onClick() {
                return onMappingRemove(index);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { width: 15, name: 'close' })
          )
        )
      );
    }
  }]);

  return OwnerMappingRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (OwnerMappingRow);

/***/ }),

/***/ "mXkB":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 28\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.5 27.43H.83c-.46 0-.83-.4-.83-.86v-.86c0-5.05 3.96-9.56 8.98-10.8-2.8-1.1-4.8-3.9-4.8-7.2 0-4.24 3.35-7.7 7.5-7.7 4.12 0 7.5 3.46 7.5 7.7 0 3.3-2.02 6.1-4.83 7.2 5.02 1.24 8.98 5.75 8.98 10.8v.87c0 .47-.37.86-.83.86zm-5-19.72c0-3.3-2.62-6-5.83-6-3.22 0-5.84 2.7-5.84 6 0 3.32 2.62 6 5.84 6 3.2 0 5.83-2.68 5.83-6zm-5.83 8.6c-5.33 0-10 4.4-10 9.4h20c0-5-4.68-9.4-10-9.4z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "mbVC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(530);

/***/ }),

/***/ "mdbp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mdkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_NotFoundPage__ = __webpack_require__("17LC");




var maybeLinkToExternalAppOnRouteEnter = function maybeLinkToExternalAppOnRouteEnter(nextState, replace, proceed) {
  if (['PRODUCTION', 'MASTER'].includes(__ENV__)) {
    // NOTE: We explicitly do NOT call proceed() so that the UI blocks
    // until redirect is complete. This ensures we avoid undesireable flash
    // of content.
    return window.location.href = window.location.href;
  } else {
    // Local Development Environment; proceed to Fallback page.
    return proceed();
  }
};

var ConversationRoutes = function ConversationRoutes() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
    { path: 'inboxes', onEnter: maybeLinkToExternalAppOnRouteEnter },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_2_components_NotFoundPage__["a" /* default */] }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: '*', component: __WEBPACK_IMPORTED_MODULE_2_components_NotFoundPage__["a" /* default */] })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConversationRoutes);

/***/ }),

/***/ "mfMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMappings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return didPatchErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPatchLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isAllowAttributeDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isUseCountryAcronyms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isUseStateAcronyms; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('marketo');
};

var getMappings = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationMappings;
});

var getFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationFields;
});

var didPatchErr = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationMappingsErr;
});

var isPatchLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.integrationPatchLoading;
});

var isAllowAttributeDefaults = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.allowAttributeDefaults;
});

var isUseCountryAcronyms = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.useCountryAcronyms;
});

var isUseStateAcronyms = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.useStateAcronyms;
});

/***/ }),

/***/ "mgTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* eslint-disable
    import/default,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var OrgPropertiesAPI = Marty.createStateSource({
  id: 'OrgPropertiesAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  fetchProperties: function fetchProperties(orgId) {
    return this.get({
      url: '/organizations/' + orgId + '/properties',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateProperties: function updateProperties(orgId, properties) {
    return this.patch({
      url: '/organizations/' + orgId + '/properties',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(properties)
    });
  },


  /**
   * Uploads a file associated with an organization
   * @param { number } orgId - the organization's ID
   * @param { File } file - an file to upload
   */
  uploadOrgImage: function uploadOrgImage(orgId, file) {
    var data = new FormData();
    data.append('file', file);
    return this.post({
      url: '/organizations/' + orgId + '/attachments',
      headers: Object(__WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_0_utils_Helpers__["b" /* RequestContentType */].FORM_DATA,
      body: data
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgPropertiesAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "miXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return demoReveal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var demoReveal = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([{
  "reveal": {
    "name": "ABC Corp",
    "location": "3 Copley Pl, Boston, MA",
    "type": "private",
    "domain": "drift.com",
    "description": "ABC Corp is your social media marketing platform built on social analytics, community engagement and governance for Facebook, Twitter, LinkedIn, and Instagram.",
    "url": "http://drift.com",
    "tags": ["SAAS", "Technology", "B2B", "Information Technology & Services"],
    "tech": ["google_tag_manager", "mandrill", "wordpress", "google_apps", "cloud_flare", "marketo", "sendgrid", "google_analytics", "zendesk", "intercom", "adroll"],
    "logo": "https://logo.clearbit.com/falcon.io",
    "facebook": {
      "handle": "drifthq"
    },
    "geo": {
      "city": "Boston",
      "state": null,
      "stateCode": null,
      "country": "United States",
      "countryCode": "DK",
      "lat": 55.674143,
      "lng": 12.571747
    },
    "github": null,
    "twitter": {
      "handle": "abccorp",
      "id": "395350496",
      "bio": "We're a unified customer experience platform for social media listening, engagement, publishing, analytics & customer data management. #socialmedia #custexp",
      "followers": 13454,
      "following": 6719,
      "location": "Boston, MA",
      "site": "https://t.co/PLYR7m8Fdw",
      "avatar": "https://pbs.twimg.com/profile_images/884466889786896384/ENsvoSrS_normal.jpg"
    },
    "linkedin": {
      "handle": null
    },
    "googleplus": null,
    "angellist": null,
    "customer": null,
    "crunchbase": {
      "handle": "organization/falcon-social"
    },
    "metrics": {
      "raised": 23700000,
      "employees": 240,
      "googleRank": 0,
      "alexaUsRank": 23273,
      "alexaGlobalRank": 59233,
      "marketCap": 0
    },
    "category": {
      "sector": "Information Technology",
      "industryGroup": "Software & Services",
      "industry": "Internet Software & Services",
      "subIndustry": "Internet Software & Services"
    },
    "dumbScore": 13454
  },
  "madkudu": {
    "segment": "very good",
    "top_signals": [{
      "name": "capital raised",
      "value": 23700000,
      "type": "positive"
    }, {
      "name": "employee count",
      "value": 240,
      "type": "positive"
    }, {
      "name": "based in a country where gdp per capita",
      "value": "high",
      "type": "positive"
    }, {
      "name": "belongs to industry where revenue per employee",
      "value": "high",
      "type": "positive"
    }, {
      "name": "number of tech found on website",
      "value": 12,
      "type": "positive"
    }, {
      "name": "web traffic volume",
      "value": "medium",
      "type": "positive"
    }, {
      "name": "company founding year",
      "value": 2010,
      "type": "positive"
    }]
  },
  "account": {
    "accountId": "bb840014-3be7-416f-9ee6-b1a6bd069723",
    "name": "ABC Corp",
    "domain": "drift.com",
    "orgDomainLookup": "drift.com",
    "ownerId": 143868,
    "orgId": 1,
    "deleted": false,
    "createDateTime": 1520317012312,
    "updateDateTime": 1520317012312,
    "targeted": true
  }
}]);

/***/ }),

/***/ "mjTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoaded; });
/* unused harmony export makehasNonBlacklistedGate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__("grSu");



var getRoot = function getRoot(state) {
  return state.get('experiment');
};

var getLoaded = function getLoaded(state) {
  return getRoot(state).get('loaded');
};

var makeHasExperiementVariation = function makeHasExperiementVariation(experimentName, experimentVariation) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getLoaded, function (isLoaded) {
    return isLoaded && Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* variation */])(experimentName) === experimentVariation;
  });
};

var makehasNonBlacklistedGate = function makehasNonBlacklistedGate(experimentName) {
  return makeHasExperiementVariation(experimentName, 'on');
};

/***/ }),

/***/ "mmRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("5ib6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors__ = __webpack_require__("VZhT");










function fetchProperties(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* fetchUserProperties */].toString()).filter(function () {
    return !__WEBPACK_IMPORTED_MODULE_8__selectors__["h" /* propertiesLoaded */](getState());
  }).pluck('payload').exhaustMap(function () {
    var user = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"])(getState());
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].fetch(user.id).map(__WEBPACK_IMPORTED_MODULE_7__actions__["i" /* receiveUserProperties */]).startWith(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* fetchUserPropertiesPending */]({ user: user })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* fetchUserPropertiesFailed */]({ error: error, user: user }));
    });
  });
}

var updateUserPropAndNotify = function updateUserPropAndNotify(apiCall, _ref2) {
  var notify = _ref2.notify,
      user = _ref2.user,
      properties = _ref2.properties;
  return apiCall(user.id, properties).map(function (newProperties) {
    if (notify) {
      __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: "Your settings have been saved.",
        variant: "green"
      });
    }
    return __WEBPACK_IMPORTED_MODULE_7__actions__["i" /* receiveUserProperties */](newProperties);
  }).startWith(__WEBPACK_IMPORTED_MODULE_7__actions__["o" /* updateUserPropertiesPending */](properties)).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7__actions__["n" /* updateUserPropertiesFailed */]({ error: error, user: user }));
  });
};

function updateProperties(action$, _ref3) {
  var getState = _ref3.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["l" /* updateUserProperties */].toString()).pluck('payload').mergeMap(function (_ref4) {
    var properties = _ref4.properties,
        _ref4$notify = _ref4.notify,
        notify = _ref4$notify === undefined ? true : _ref4$notify;

    var user = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"])(getState());
    return updateUserPropAndNotify(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].update, { notify: notify, user: user, properties: properties });
  });
}

function updateClassificationsNotificationProperties(action$, _ref5) {
  var getState = _ref5.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["j" /* updateClassificationsNotificationProperties */].toString()).pluck('payload').mergeMap(function (_ref6) {
    var properties = _ref6.properties,
        _ref6$notify = _ref6.notify,
        notify = _ref6$notify === undefined ? true : _ref6$notify;

    var state = getState();
    var user = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"])(state);
    return updateUserPropAndNotify(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].patchClassificationNotificationProperties, { notify: notify, user: user, properties: properties });
  });
}

function updateExtensionUserProperties(action$, _ref7) {
  var getState = _ref7.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["k" /* updateExtensionUserProperty */].toString()).pluck('payload').mergeMap(function (_ref8) {
    var properties = _ref8.properties,
        _ref8$notify = _ref8.notify,
        notify = _ref8$notify === undefined ? true : _ref8$notify;

    var state = getState();
    var user = Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_user_selectors__["currentUser"])(state);
    var existingExtensionUserProperties = __WEBPACK_IMPORTED_MODULE_8__selectors__["a" /* extensionProperties */](state);
    return updateUserPropAndNotify(__WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].patchExtensionProperties, { notify: notify, user: user, properties: { newProperties: properties, existingExtensionUserProperties: existingExtensionUserProperties } });
  });
}

function fetchCurrentUserProperties(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_app_modules_user_actions__["receiveCurrentUser"].toString()).map(function () {
    return __WEBPACK_IMPORTED_MODULE_7__actions__["a" /* fetchUserProperties */]();
  });
}

function fetchUsersByPropertyName(action$, _ref9) {
  var getState = _ref9.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* fetchUsersByPropertyName */].toString()).pluck('payload').switchMap(function (properties) {
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* api */].fetchUsersByPropertyName(Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_org_selectors__["orgId"])(getState()), properties).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_7__actions__["h" /* fetchUsersByPropertyNameSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_7__actions__["g" /* fetchUsersByPropertyNamePending */]({ properties: properties })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7__actions__["f" /* fetchUsersByPropertyNameFailure */]({ error: error, properties: properties }));
    });
  });
}

function receiveConversationLimitUserProperty(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__actions__["i" /* receiveUserProperties */].toString()).map(function (action) {
    return __WEBPACK_IMPORTED_MODULE_7__actions__["q" /* userAtConversationLimitUpdate */](action.payload.get('atConversationLimit'));
  });
}

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchProperties, updateProperties, updateExtensionUserProperties, updateClassificationsNotificationProperties, fetchCurrentUserProperties, fetchUsersByPropertyName, receiveConversationLimitUserProperty);

/***/ }),

/***/ "mmVS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(116);

/***/ }),

/***/ "mnbJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SalesforceCampaignSelect__ = __webpack_require__("rBQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__ = __webpack_require__("pE/Y");


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SalesforceCampaignMapping = function (_Component) {
  _inherits(SalesforceCampaignMapping, _Component);

  function SalesforceCampaignMapping(props) {
    var _this2 = this;

    _classCallCheck(this, SalesforceCampaignMapping);

    var _this = _possibleConstructorReturn(this, (SalesforceCampaignMapping.__proto__ || Object.getPrototypeOf(SalesforceCampaignMapping)).call(this, props));

    _this.checkForNetNew = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var isNetNewPresent;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].fetchSalesforceLeadPushCampaign();

            case 3:
              isNetNewPresent = _context.sent;

              _this.setState({ onlyAssociateNetNew: !!isNetNewPresent.campaignId });
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              console.log(_context.t0);

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 7]]);
    }));

    _this.handleNetNewCheckboxChange = function (campaignId, change) {
      var nextState = change;
      var setCampaign = nextState ? __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].replaceSalesforceLeadPushCampaign : __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceInfluenceCampaignId;
      var clearPrevCampaign = nextState ? __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceInfluenceCampaignId : __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].replaceSalesforceLeadPushCampaign;
      _this.setCampaign(setCampaign, campaignId);
      _this.clearPrevCampaign(clearPrevCampaign);

      _this.setState({
        onlyAssociateNetNew: change
      });
    };

    _this.setCampaign = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(setCampaignFn, campaignId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return setCampaignFn(campaignId);

              case 3:
                _context2.next = 8;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 5]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.clearPrevCampaign = function () {
      var _ref3 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(clearPrevCampaignFn) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return clearPrevCampaignFn({ campaignId: null });

              case 3:
                _context3.next = 8;
                break;

              case 5:
                _context3.prev = 5;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[0, 5]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.state = {
      onlyAssociateNetNew: false
    };
    return _this;
  }

  _createClass(SalesforceCampaignMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkForNetNew();
    }
  }, {
    key: 'render',
    value: function render() {
      var type = this.props.type;
      var onlyAssociateNetNew = this.state.onlyAssociateNetNew;


      var fetchCampaignFn = onlyAssociateNetNew ? __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].fetchSalesforceLeadPushCampaign : __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].getSalesforceInfluenceCampaignId;

      var setCampaignFn = onlyAssociateNetNew ? __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].replaceSalesforceLeadPushCampaign : __WEBPACK_IMPORTED_MODULE_3_app_modules_sfdc_api__["a" /* api */].setSalesforceInfluenceCampaignId;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'span',
          { className: 'salesforce-campaign-mapping-select-group-title' },
          'Associate ',
          type,
          ' with a Salesforce Campaign'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SalesforceCampaignSelect__["a" /* default */], {
          description: '',
          defaultSelectLabelText: 'Select or search for a Salesforce Campaign...',
          fetchSelectedCampaign: fetchCampaignFn,
          setSelectedCampaign: setCampaignFn,
          onToggleChange: this.handleNetNewCheckboxChange,
          toggleStatus: onlyAssociateNetNew,
          type: type
        })
      );
    }
  }]);

  return SalesforceCampaignMapping;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceCampaignMapping);

/***/ }),

/***/ "mrzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var LOCALE_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  LOCALE_LOADED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(LOCALE_CONSTANTS, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId));

/***/ }),

/***/ "ms2+":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mura":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hotkeys__ = __webpack_require__("S+6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_customer_EditableInfoCard_styl__ = __webpack_require__("wrQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styles_components_customer_EditableInfoCard_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_styles_components_customer_EditableInfoCard_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.










var EditableInfoCard = React.createClass({
  displayName: 'EditableInfoCard',

  mixins: [__webpack_require__("aCGJ")],

  propTypes: {
    save: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    sections: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,

    cardTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    canSave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    isEditMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    disableSaveOnEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    disableExitOnEscape: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    hasChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  },

  getInitialState: function getInitialState() {
    return {
      isEditMode: this.props.isEditMode
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      canSave: true,
      hasChanged: false
    };
  },
  componentDidMount: function componentDidMount() {
    return this.setOutsideClickHandler(this.state.isEditMode);
  },
  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
    return this.setOutsideClickHandler(nextState.isEditMode);
  },
  componentDidUpdate: function componentDidUpdate() {
    return this.maybeFocusTextArea();
  },
  renderEditMode: function renderEditMode(sections) {
    return _.map(sections, function (section) {
      return section.renderEdit();
    });
  },
  renderDisplayMode: function renderDisplayMode(sections) {
    return _.map(sections, function (section) {
      return section.renderDisplay();
    });
  },
  renderCardContent: function renderCardContent(sections) {
    return React.createElement(
      'div',
      { className: 'card-content' },
      this.props.isEditMode || this.state.isEditMode ? React.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_hotkeys__["HotKeys"],
        {
          className: 'editing-container',
          keyMap: {
            enterPressed: 'enter',
            escapePressed: 'esc'
          },
          handlers: {
            enterPressed: this.enterPressed,
            escapePressed: this.escapePressed
          } },
        this.renderEditMode(sections)
      ) : this.renderDisplayMode(sections)
    );
  },
  render: function render() {
    var sections = _.compact(this.props.sections);
    var renderedCardContent = this.renderCardContent(sections);

    return React.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('EditableInfoCard', { 'is-focused': this.state.isEditMode }) },
      this.state.isEditMode ? React.createElement(
        'div',
        { className: 'edit-mode-options-toggles' },
        React.createElement(
          'a',
          { className: 'cancel', onClick: this.cancelEditModeClicked },
          'Cancel'
        ),
        React.createElement(
          'a',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('save', { disabled: !this.props.canSave }),
            onClick: this.saveClicked },
          'Save'
        )
      ) : React.createElement(
        'a',
        { className: 'edit-toggle', onClick: this.editClicked },
        'Edit'
      ),
      this.props.cardTitle ? React.createElement(
        'div',
        { className: 'card-title' },
        this.props.cardTitle
      ) : undefined,
      this.state.isEditMode ? this.props.beforeEdit ? React.createElement(
        'div',
        { className: 'before-edit' },
        this.props.beforeEdit(),
        renderedCardContent
      ) : renderedCardContent : this.props.beforeDisplay ? React.createElement(
        'div',
        { className: 'before-display' },
        this.props.beforeDisplay(),
        renderedCardContent
      ) : renderedCardContent
    );
  },
  maybeFocusTextArea: function maybeFocusTextArea() {
    if (this.state.isEditMode && this.refs.editTextArea) {
      var editTextAreaNode = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.refs.editTextArea);
      // check out this neato-burrito hack to move the cursor to the end
      // of a text area, Mom
      var value = editTextAreaNode.value;

      editTextAreaNode.focus();
      return editTextAreaNode.value = value;
    }
  },
  setOutsideClickHandler: function setOutsideClickHandler(enabled) {
    if (enabled) {
      return this.enableOnClickOutside();
    } else {
      return this.disableOnClickOutside();
    }
  },
  handleClickOutside: function handleClickOutside() {
    if (!this.props.hasChanged) {
      return this.cancelEditModeClicked();
    }
  },
  cancelEditModeClicked: function cancelEditModeClicked() {
    this.setState({ isEditMode: false });
    return this.props.reset();
  },
  saveClicked: function saveClicked() {
    return this.maybeSaveAndCloseEdit();
  },
  enterPressed: function enterPressed() {
    if (!this.props.disableSaveOnEnter) {
      return this.maybeSaveAndCloseEdit();
    }
  },
  escapePressed: function escapePressed() {
    if (!this.props.disableExitOnEscape) {
      return this.cancelEditModeClicked;
    }
  },
  maybeSaveAndCloseEdit: function maybeSaveAndCloseEdit() {
    if (!this.props.canSave) {
      return;
    }
    this.setState({ isEditMode: false });
    return this.props.save();
  },
  editClicked: function editClicked() {
    return this.setState({ isEditMode: true });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EditableInfoCard);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "mvSl":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"24\" viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.748 18.23H5.873l-3.78 4.808a1.016 1.016 0 0 1-1.135.333 1.04 1.04 0 0 1-.684-.98V4.662c0-2.27 1.813-4.116 4.043-4.116h16.43c2.23 0 4.043 1.846 4.043 4.116v9.45c0 2.27-1.813 4.116-4.042 4.116zm2-13.567c0-1.122-.898-2.036-2-2.036H4.318c-1.104 0-2 .914-2 2.036v14.761l2.266-2.885c.012-.016.03-.022.043-.037.048-.055.104-.095.162-.138.05-.04.097-.08.154-.106.055-.028.114-.04.173-.057.07-.02.14-.04.212-.043.017 0 .033-.01.052-.01h15.366c1.102 0 2-.915 2-2.037v-9.45zM18.66 8.868H6.404a1.03 1.03 0 0 1-1.02-1.04c0-.574.456-1.04 1.02-1.04H18.66a1.03 1.03 0 0 1 1.023 1.04 1.03 1.03 0 0 1-1.022 1.04zM6.404 9.908h8.172a1.03 1.03 0 0 1 1.022 1.04 1.03 1.03 0 0 1-1.022 1.04H6.403a1.03 1.03 0 0 1-1.02-1.04c0-.574.456-1.04 1.02-1.04z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "mvlj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("khXy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_small_svg__ = __webpack_require__("xN9T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_large_svg__ = __webpack_require__("qtZ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_large_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_large_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var WidgetSizePicker = function (_Component) {
  _inherits(WidgetSizePicker, _Component);

  function WidgetSizePicker() {
    _classCallCheck(this, WidgetSizePicker);

    return _possibleConstructorReturn(this, (WidgetSizePicker.__proto__ || Object.getPrototypeOf(WidgetSizePicker)).apply(this, arguments));
  }

  _createClass(WidgetSizePicker, [{
    key: 'changeWidgetHeight',
    value: function changeWidgetHeight(isHalfHeight) {
      var onSelection = this.props.onSelection;

      onSelection(isHalfHeight, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var widgetHalfHeight = this.props.widgetHalfHeight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.WidgetSizePicker },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'widget-size-option-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('widget-size-option', { active: !widgetHalfHeight }),
              onClick: function onClick() {
                return _this2.changeWidgetHeight(false);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_large_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'widget-size-option-label' },
              'Large'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'widget-size-option-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('widget-size-option', { active: widgetHalfHeight }),
              onClick: function onClick() {
                return _this2.changeWidgetHeight(true);
              }
            },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_widget_option_small_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'widget-size-option-label' },
              'Small'
            )
          )
        )
      );
    }
  }]);

  return WidgetSizePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

WidgetSizePicker.propTypes = {
  widgetHalfHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};


/* harmony default export */ __webpack_exports__["a"] = (WidgetSizePicker);

/***/ }),

/***/ "mws/":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 910 144\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>Group 2</title><desc>Created with Sketch.</desc><defs></defs><g id=\"blank-state-+-upsell\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Grid-Copy\" transform=\"translate(-256.000000, -282.000000)\"><g id=\"Group-2\" transform=\"translate(256.000000, 283.000000)\"><path d=\"M0,70 L909.578125,70.7128187\" id=\"Path-2\" stroke=\"#E1EEF4\"></path><path d=\"M0,0 L909.578125,0.712818661\" id=\"Path-2\" stroke=\"#E1EEF4\"></path><path d=\"M0,142 L909.578125,142.712819\" id=\"Path-2\" stroke=\"#E1EEF4\"></path><rect id=\"Rectangle\" fill=\"#E1EEF4\" x=\"25\" y=\"20\" width=\"235\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-6\" fill=\"#E1EEF4\" x=\"25\" y=\"92\" width=\"94\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-3\" fill=\"#E1EEF4\" x=\"25\" y=\"38\" width=\"165\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-7\" fill=\"#E1EEF4\" x=\"25\" y=\"110\" width=\"165\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy\" fill=\"#E1EEF4\" x=\"362\" y=\"20\" width=\"186.034881\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-8\" fill=\"#E1EEF4\" x=\"362\" y=\"92\" width=\"146.029999\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-4\" fill=\"#E1EEF4\" x=\"362\" y=\"38\" width=\"116.029999\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-9\" fill=\"#E1EEF4\" x=\"362\" y=\"110\" width=\"116.029999\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-2\" fill=\"#E1EEF4\" x=\"601\" y=\"20\" width=\"186.034881\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-10\" fill=\"#E1EEF4\" x=\"601\" y=\"92\" width=\"160\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-5\" fill=\"#E1EEF4\" x=\"601\" y=\"38\" width=\"116.029999\" height=\"12\" rx=\"3\"></rect><rect id=\"Rectangle-Copy-11\" fill=\"#E1EEF4\" x=\"601\" y=\"110\" width=\"116.029999\" height=\"12\" rx=\"3\"></rect></g></g></g></svg>"

/***/ }),

/***/ "mxMN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EmailSenderTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EmailFormatTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmailEditSenderModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TinyEditorModal__ = __webpack_require__("+qeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_UserSelect__ = __webpack_require__("NjXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("vJV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }










var EmailSenderTypes = {
  STATIC: 'static',
  DYNAMIC: 'dynamic'
};

var EmailFormatTypes = {
  FIRST_LAST: 'FIRST_LAST',
  FIRST_ONLY: 'FIRST_ONLY',
  FIRST_WITH_ORG: 'FIRST_WITH_ORG',
  FIRST_LAST_WITH_ORG: 'FIRST_LAST_WITH_ORG'

  // TODO: remove this logic in place of using the displayName property once we implement it
};var getUserFirstName = function getUserFirstName(user) {
  return (user.name || '').split(' ')[0];
};

var StaticEmailSenderSelect = function StaticEmailSenderSelect(_ref) {
  var onUserIdChange = _ref.onUserIdChange,
      selectedOption = _ref.selectedOption,
      onStaticSendNameChange = _ref.onStaticSendNameChange,
      staticSendName = _ref.staticSendName,
      staticSendEmail = _ref.staticSendEmail,
      defaultUser = _ref.defaultUser,
      renderSelectedUser = _ref.renderSelectedUser,
      _ref$includeInboxEmai = _ref.includeInboxEmails,
      includeInboxEmails = _ref$includeInboxEmai === undefined ? true : _ref$includeInboxEmai;
  return React.createElement(
    'div',
    { className: 'edit-email-sender-user-select' },
    React.createElement(
      'div',
      { className: 'edit-email-sender-modal-heading' },
      'Sender Name & Email'
    ),
    React.createElement(
      'div',
      { className: 'edit-email-sender-modal-form' },
      React.createElement(
        'div',
        { className: 'drift-form' },
        React.createElement('input', { type: 'text', value: staticSendName || defaultUser.name, onChange: onStaticSendNameChange, placeholder: 'Sender name' })
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UserSelect__["a" /* default */], {
        selectedUserId: selectedOption || defaultUser.id,
        onUserIdChange: onUserIdChange,
        renderOption: function renderOption(user) {
          return !!user.name ? user.email + ' (' + user.name + ')' : user.email;
        },
        renderSelectedValue: renderSelectedUser,
        includeInboxEmails: includeInboxEmails
      })
    )
  );
};

var DynamicEmailSenderSelect = function DynamicEmailSenderSelect(_ref2) {
  var onUserIdChange = _ref2.onUserIdChange,
      selectedOption = _ref2.selectedOption,
      onStaticSendNameChange = _ref2.onStaticSendNameChange,
      onFormatSelect = _ref2.onFormatSelect,
      staticSendName = _ref2.staticSendName,
      renderSelectedUser = _ref2.renderSelectedUser,
      formatType = _ref2.formatType,
      exampleUser = _ref2.exampleUser,
      org = _ref2.org,
      defaultUser = _ref2.defaultUser,
      _ref2$includeInboxEma = _ref2.includeInboxEmails,
      includeInboxEmails = _ref2$includeInboxEma === undefined ? true : _ref2$includeInboxEma;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal-heading' },
        'Set Formatting'
      ),
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal-form' },
        React.createElement(
          'form',
          { className: 'drift-form' },
          React.createElement(
            'div',
            { className: 'edit-email-sender-format-option' },
            React.createElement('input', { type: 'radio', name: 'formatting', id: 'first-last-formatting', onClick: function onClick() {
                return onFormatSelect(EmailFormatTypes.FIRST_LAST);
              }, checked: formatType === EmailFormatTypes.FIRST_LAST }),
            React.createElement(
              'label',
              { htmlFor: 'first-last-formatting' },
              React.createElement(
                'p',
                { className: 'edit-email-sender-format-example' },
                exampleUser.name,
                ' <',
                exampleUser.email,
                '>'
              ),
              React.createElement(
                'small',
                { className: 'edit-email-sender-format-label' },
                'Full name'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'edit-email-sender-format-option' },
            React.createElement('input', { type: 'radio', name: 'formatting', id: 'first-only-formatting', onClick: function onClick() {
                return onFormatSelect(EmailFormatTypes.FIRST_ONLY);
              }, checked: formatType === EmailFormatTypes.FIRST_ONLY }),
            React.createElement(
              'label',
              { htmlFor: 'first-only-formatting' },
              React.createElement(
                'p',
                { className: 'edit-email-sender-format-example' },
                getUserFirstName(exampleUser),
                ' <',
                exampleUser.email,
                '>'
              ),
              React.createElement(
                'small',
                { className: 'edit-email-sender-format-label' },
                'First name'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'edit-email-sender-format-option' },
            React.createElement('input', { type: 'radio', name: 'formatting', id: 'first-with-org-formatting', onClick: function onClick() {
                return onFormatSelect(EmailFormatTypes.FIRST_WITH_ORG);
              }, checked: formatType === EmailFormatTypes.FIRST_WITH_ORG }),
            React.createElement(
              'label',
              { htmlFor: 'first-with-org-formatting' },
              React.createElement(
                'p',
                { className: 'edit-email-sender-format-example' },
                getUserFirstName(exampleUser),
                ' from ',
                org.name
              ),
              React.createElement(
                'small',
                { className: 'edit-email-sender-format-label' },
                'First name & company'
              )
            )
          )
        )
      )
    ),
    React.createElement(
      'div',
      { className: 'edit-email-sender-user-select' },
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal-heading' },
        'As a fallback, send from:'
      ),
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal-form' },
        React.createElement(
          'div',
          { className: 'drift-form' },
          React.createElement('input', { type: 'text', value: staticSendName || defaultUser.name, onChange: onStaticSendNameChange, placeholder: 'Sender name' })
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_UserSelect__["a" /* default */], {
          selectedUserId: selectedOption || defaultUser.id,
          onUserIdChange: onUserIdChange,
          renderOption: function renderOption(user) {
            return !!user.name ? user.email + ' (' + user.name + ')' : user.email;
          },
          renderSelectedValue: renderSelectedUser,
          includeInboxEmails: includeInboxEmails
        })
      )
    )
  );
};

var SenderSelect = function SenderSelect(_ref3) {
  var senderChoices = _ref3.senderChoices,
      onSenderTypeSelect = _ref3.onSenderTypeSelect,
      selectedSenderChoice = _ref3.selectedSenderChoice;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'edit-email-sender-modal-heading' },
      'Send From'
    ),
    React.createElement(
      'div',
      { className: 'edit-email-sender-modal-form' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_UISelect__["b" /* default */], {
        options: senderChoices,
        value: selectedSenderChoice,
        onChange: onSenderTypeSelect
      })
    )
  );
};

var EmailEditSenderModal = function EmailEditSenderModal(_ref4) {
  var selectedSenderType = _ref4.selectedSenderType,
      hideModal = _ref4.hideModal,
      onSave = _ref4.onSave,
      rest = _objectWithoutProperties(_ref4, ['selectedSenderType', 'hideModal', 'onSave']);

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_1__TinyEditorModal__["a" /* default */],
    { title: "Sender Details", onClose: hideModal, long: selectedSenderType === EmailSenderTypes.DYNAMIC },
    React.createElement(
      'div',
      { className: 'edit-email-sender-modal-content-container' },
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal' },
        React.createElement(SenderSelect, rest),
        selectedSenderType === EmailSenderTypes.STATIC && React.createElement(StaticEmailSenderSelect, rest),
        selectedSenderType === EmailSenderTypes.DYNAMIC && React.createElement(DynamicEmailSenderSelect, rest)
      ),
      React.createElement(
        'div',
        { className: 'edit-email-sender-modal-footer' },
        React.createElement(
          'button',
          { className: 'edit-email-sender-footer-button drift-button drift-button-primary', onClick: onSave },
          'Save'
        ),
        React.createElement(
          'button',
          { className: 'edit-email-sender-footer-button drift-button', onClick: hideModal },
          'Cancel'
        )
      )
    )
  );
};

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "mxgj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNumber__ = __webpack_require__("J009");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Integrations__ = __webpack_require__("CCiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__("hoI/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var LinkedinSection = function (_Component) {
  _inherits(LinkedinSection, _Component);

  function LinkedinSection(props) {
    _classCallCheck(this, LinkedinSection);

    var _this = _possibleConstructorReturn(this, (LinkedinSection.__proto__ || Object.getPrototypeOf(LinkedinSection)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(LinkedinSection, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          endUser = _props.endUser,
          companyName = _props.companyName,
          companyUrl = _props.companyUrl;

      var hasData = !!(companyName || companyUrl || endUser);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        hasData && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", {
            src: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Integrations__["a" /* getLinkedinIFrameUrl */])(endUser, companyName, companyUrl),
            width: "320",
            height: "336",
            id: "developer-specified-ID",
            frameBorder: "0",
            type: "text/html"
          })
        )
      );
    }
  }]);

  return LinkedinSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LinkedinSection);

/***/ }),

/***/ "myCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Attachment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Attachment = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  conversationId: undefined,
  createdAt: undefined,
  fileName: undefined,
  hash: undefined,
  height: undefined,
  id: undefined,
  mimeType: undefined,
  orgId: undefined,
  publicId: undefined,
  publicPreviewUrl: undefined,
  publicUrl: undefined,
  size_: undefined,
  width: undefined
});

/***/ }),

/***/ "myYH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_LocationSearch__ = __webpack_require__("D1sA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_UserProfile_Section__ = __webpack_require__("1Pxv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_constants__ = __webpack_require__("QF6P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_styl__ = __webpack_require__("+KTP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__styles_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_Settings_styl__ = __webpack_require__("cLnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_settings_Settings_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_components_settings_Settings_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core__ = __webpack_require__("0PwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var HandleInput = function HandleInput(_ref) {
  var url = _ref.url,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      className = _ref.className;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'HandleInput' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'HandleInput__InputContainer' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('HandleInput__URL', className) },
        url
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
        size: 'small',
        value: value,
        placeholder: 'your personal handle',
        defaultValue: defaultValue,
        onChange: onChange
      })
    )
  );
};

var OverviewInfo = function (_Component) {
  _inherits(OverviewInfo, _Component);

  function OverviewInfo(props) {
    _classCallCheck(this, OverviewInfo);

    var _this = _possibleConstructorReturn(this, (OverviewInfo.__proto__ || Object.getPrototypeOf(OverviewInfo)).call(this, props));

    _this.getProfileState = function () {
      var profile = _this.props.profile;

      return {
        handleInput: profile.handle,
        globalHandleInput: profile.globalHandle,
        jobTitleInput: profile.jobTitle,
        locationInput: profile.location,
        locationLat: profile.lat,
        locationLong: profile.lng,
        quoteInput: profile.quote
      };
    };

    _this.handleToggleAdvanced = function () {
      _this.setState({ showAdvanced: !_this.state.showAdvanced });
    };

    _this.handleBioChange = function (event) {
      var value = event.target.value;

      _this.setState({ inputs: _extends({}, _this.state.inputs, { quoteInput: value }) });
    };

    _this.handleTitleChange = function (event) {
      var value = event.target.value;

      _this.setState({ inputs: _extends({}, _this.state.inputs, { jobTitleInput: value }) });
    };

    _this.handleLocationChange = function (suggestion) {
      var label = suggestion.label,
          _suggestion$location = suggestion.location,
          lat = _suggestion$location.lat,
          lng = _suggestion$location.lng;

      _this.setState({
        inputs: _extends({}, _this.state.inputs, {
          locationInput: label,
          locationLat: lat,
          locationLong: lng
        })
      });
    };

    _this.selectDefault = function () {
      var defaultSelection = {
        label: '',
        location: { lat: 0, lng: 0 }
      };
      _this.handleLocationChange(defaultSelection);
    };

    _this.handleChangeHandle = function (event) {
      var handle = event.target.value.trim().toLowerCase().replace(/([^a-z0-9\-])+/g, ''); // trim all non-hyphen alphanumeric
      _this.setState({ inputs: _extends({}, _this.state.inputs, { handleInput: handle }) });
      if (handle.length > 0) {
        _this.props.actions.checkUserHandle(handle);
      }
    };

    _this.handleChangeGlobalHandle = function (event) {
      var globalHandle = event.target.value.trim().toLowerCase().replace(/([^a-z0-9\-])+/g, ''); // trim all non-hyphen alphanumeric
      _this.setState({ inputs: _extends({}, _this.state.inputs, { globalHandleInput: globalHandle }) });
      if (globalHandle.length > 0) {
        _this.props.actions.checkGlobalUserHandle(globalHandle);
      }
    };

    _this.handleVisibilityChange = function (event) {
      var value = event.target.checked ? __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_constants__["b" /* Visibility */].PUBLIC : __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_constants__["b" /* Visibility */].PRIVATE;
      _this.props.actions.setVisibility(value);
      _this.props.actions.track('Profile Visibility Changed', { value: value });
    };

    _this.handleSave = function () {
      var _this$props = _this.props,
          actions = _this$props.actions,
          globalHandle = _this$props.globalHandle,
          handle = _this$props.handle;
      var _this$state$inputs = _this.state.inputs,
          quoteInput = _this$state$inputs.quoteInput,
          jobTitleInput = _this$state$inputs.jobTitleInput,
          handleInput = _this$state$inputs.handleInput,
          globalHandleInput = _this$state$inputs.globalHandleInput,
          locationInput = _this$state$inputs.locationInput,
          locationLat = _this$state$inputs.locationLat,
          locationLong = _this$state$inputs.locationLong;

      var profilePayload = {
        quote: quoteInput,
        jobTitle: jobTitleInput,
        location: locationInput,
        latitude: locationLat,
        longitude: locationLong
      };
      _.map(profilePayload, function (value, key) {
        return value !== undefined && actions.setProfileUIData({ key: key, value: value });
      });
      if (!!globalHandleInput && globalHandleInput !== globalHandle) {
        actions.setProfileUIData({ key: 'globalHandle', value: globalHandleInput });
      }
      if (!!handleInput && handleInput !== handle) {
        actions.setProfileUIData({ key: 'handle', value: handleInput });
      }
      actions.updateOverview();
    };

    _this.handleCancel = function () {
      _this.setState({
        inputs: _this.getProfileState()
      });
    };

    _this.canSubmit = function () {
      var initialProfileState = _this.getProfileState();
      var _this$props2 = _this.props,
          isGlobalHandleValid = _this$props2.isGlobalHandleValid,
          isHandleValid = _this$props2.isHandleValid;
      var _this$state$inputs2 = _this.state.inputs,
          globalHandleInput = _this$state$inputs2.globalHandleInput,
          handleInput = _this$state$inputs2.handleInput; // are handles taken?

      var changes = _.filter(_this.state.inputs, function (value, key) {
        return value !== initialProfileState[key];
      });
      var invalidCharsInHandles = /([^a-z0-9\-])+/.test(globalHandleInput) || /([^a-z0-9\-])+/.test(handleInput);
      return changes.length > 0 && !invalidCharsInHandles && isGlobalHandleValid && isHandleValid;
    };

    _this.state = {
      inputs: _this.getProfileState(),
      showAdvanced: false
    };
    return _this;
  }

  _createClass(OverviewInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          globalHandle = _props.globalHandle,
          handle = _props.handle,
          visibility = _props.visibility,
          companyUrl = _props.companyUrl,
          globalHandleCheckComplete = _props.globalHandleCheckComplete,
          profileUpdateStatusPending = _props.profileUpdateStatusPending,
          isGlobalHandleValid = _props.isGlobalHandleValid,
          isHandleValid = _props.isHandleValid;
      var _state = this.state,
          showAdvanced = _state.showAdvanced,
          _state$inputs = _state.inputs,
          globalHandleInput = _state$inputs.globalHandleInput,
          handleInput = _state$inputs.handleInput,
          jobTitleInput = _state$inputs.jobTitleInput,
          locationInput = _state$inputs.locationInput,
          quoteInput = _state$inputs.quoteInput;


      var hideAdvancedLink = __WEBPACK_IMPORTED_MODULE_1_utils_Access__["c" /* default */].hasGates('hide_company_handle');

      // globalHandle
      var showBlankError = !!globalHandle && globalHandleInput === '';
      var globalHasInvalidChars = /([^a-z0-9\-])+/.test(globalHandleInput);
      var isGlobalHandleTaken = !isGlobalHandleValid && globalHandleCheckComplete && globalHandleInput !== globalHandle && globalHandleInput !== '';

      // handle
      var isHandleBlank = handleInput === '';
      var isHandleTaken = !isHandleValid && handleInput !== handle;

      var showGlobalHandleUrl = !globalHasInvalidChars && !isGlobalHandleTaken && !!globalHandleInput && globalHandleInput !== '';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_components_settings_UserProfile_Section__["b" /* Subsection */],
        {

          isValid: true,
          canSubmit: this.canSubmit(),
          onSubmit: this.handleSave,
          onCancel: this.handleCancel,
          loading: profileUpdateStatusPending,
          innerClassName: 'settings-overview-section'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_settings_UserProfile_Section__["a" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'settings-section-row-inner' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title' },
              'Your Drift Profile link',
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'profiles-settings-helptext-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core__["ToolTip"],
                  {
                    component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      'Your Drift Profile link may only contain ',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      ' lowercase letters, numbers and hyphens.'
                    ),
                    tethered: 'true',
                    flow: 'up'
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Icon"], { name: 'info' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: globalHandle + '-' + handle, className: 'handle-input-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HandleInput, {
                size: 'small',
                url: __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */],
                value: globalHandleInput,
                onChange: this.handleChangeGlobalHandle,
                defaultValue: globalHandleInput
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('handle-preview', {
                    error: showBlankError || globalHasInvalidChars || isGlobalHandleTaken
                  })
                },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  isGlobalHandleTaken && 'this handle is taken',
                  showGlobalHandleUrl && globalHandleInput && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'Share your unique link:',
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'a',
                      { href: 'https://' + __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */] + '/' + globalHandleInput },
                      __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["M" /* PROFILE_DOMAIN */],
                      '/',
                      globalHandleInput
                    )
                  ),
                  showBlankError && 'personal handle may not be blank',
                  globalHasInvalidChars && 'Your handle may only contain letters and numbers.'
                )
              ),
              /([^a-z0-9\-])+/.test(handle) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: { marginTop: '1em' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HandleInput, {
                  size: 'small',
                  className: 'long-url',
                  url: companyUrl,
                  value: handleInput,
                  onChange: this.handleChangeHandle,
                  defaultValue: handleInput
                }),
                /([^a-z0-9\-])+/.test(handleInput) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'handle-preview error' },
                  'Your handle may only contain letters and numbers.'
                ),
                isHandleTaken && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'handle-preview error' },
                  'This handle is taken.'
                ),
                isHandleBlank && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'handle-preview error' },
                  'handle cannot be blank.'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'settings-section-row-inner' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title' },
              'Allow others to see your Drift Profile'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex-space-between' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                'Ready to share your profile? Just turn this on.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core__["Toggle"], {
                defaultChecked: visibility === __WEBPACK_IMPORTED_MODULE_4_app_modules_profile_constants__["b" /* Visibility */].PUBLIC,
                onChange: this.handleVisibilityChange
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_components_settings_UserProfile_Section__["a" /* Row */],
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'settings-section-row-inner' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title' },
              'Title'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
              type: 'text',
              size: 'small',
              placeholder: 'Job Title',
              onChange: this.handleTitleChange,
              isValid: true,
              value: jobTitleInput
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title settings-overview-location' },
              'Location'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_shared_LocationSearch__["a" /* default */], {
              placeholder: 'Your location',
              initialValue: locationInput,
              types: ['(cities)'],
              onSuggestSelect: this.handleLocationChange,
              selectDefault: this.selectDefault
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'settings-section-row-inner' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title' },
              'Short bio'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
              className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()("tide-textarea", "settings-profile-bio-text-area"),
              value: quoteInput,
              onChange: this.handleBioChange,
              isValid: true
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'settings-overview-setting-title' },
              'Give a quick intro about who you are. Use this area to share your pronouns, interests outside of work, or even a fun fact!'
            )
          )
        )
      );
    }
  }]);

  return OverviewInfo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_components_shared_notifications__["a" /* default */])(OverviewInfo));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "mzVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PageViewEvent = function (_Component) {
  _inherits(PageViewEvent, _Component);

  function PageViewEvent() {
    _classCallCheck(this, PageViewEvent);

    return _possibleConstructorReturn(this, (PageViewEvent.__proto__ || Object.getPrototypeOf(PageViewEvent)).apply(this, arguments));
  }

  _createClass(PageViewEvent, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__GenericEvent__["a" /* default */], _extends({}, this.props, { eventLabel: 'viewed' }));
    }
  }]);

  return PageViewEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PageViewEvent);

/***/ }),

/***/ "n1b9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__ = __webpack_require__("waKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_LocaleConstants__ = __webpack_require__("mrzB");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
* Store containing all the locales currently loaded/polyfilled in the browser
*/

var LocaleStore = function (_Marty$Store) {
  _inherits(LocaleStore, _Marty$Store);

  function LocaleStore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LocaleStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocaleStore.__proto__ || Object.getPrototypeOf(LocaleStore)).call.apply(_ref, [this].concat(args))), _this), _this.state = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(__WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].en.key), _this.handlers = {
      updateLocales: [__WEBPACK_IMPORTED_MODULE_2_constants_LocaleConstants__["a" /* default */].LOCALE_LOADED]
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LocaleStore, [{
    key: 'rehydrate',
    value: function rehydrate() {
      // Ignore state from the server
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(__WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].en.key);
    }
  }, {
    key: 'loadLocale',
    value: function loadLocale() {
      return this.fetch({
        id: 'getLoadedLocales',
        dependsOn: [this.app.stores.OrgSettingsStore.getOrgSettings()],
        locally: function locally() {
          var locale = this.app.stores.OrgSettingsStore.state.locale;

          return this.state.get(locale);
        },
        remotely: function remotely() {
          var locale = this.app.stores.OrgSettingsStore.state.locale;

          return this.app.actions.LocaleActions.loadLocale(locale);
        }
      });
    }
  }, {
    key: 'updateLocales',
    value: function updateLocales(locale) {
      this.state = this.state.add(locale);
    }
  }]);

  return LocaleStore;
}(Marty.Store);

/* harmony default export */ __webpack_exports__["default"] = (LocaleStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "n24L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n41v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var RevenueRaised = function (_Component) {
  _inherits(RevenueRaised, _Component);

  function RevenueRaised(props) {
    _classCallCheck(this, RevenueRaised);

    var _this = _possibleConstructorReturn(this, (RevenueRaised.__proto__ || Object.getPrototypeOf(RevenueRaised)).call(this, props));

    _this.updateValue = function (_ref) {
      var value = _ref.value;
      var _this$props = _this.props,
          onUpdateCondition = _this$props.onUpdateCondition,
          activeFilter = _this$props.activeFilter;


      var newFilter = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["clone"])(activeFilter);

      newFilter.value = value;

      _this.setState({
        selected: value
      });

      onUpdateCondition(newFilter);
    };

    var initialValue = props.activeFilter.value;

    _this.state = {
      selected: initialValue
    };
    return _this;
  }

  _createClass(RevenueRaised, [{
    key: 'render',
    value: function render() {
      var selected = this.state.selected;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], { options: __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_constants__["L" /* REVENUE_GROUPS */], onChange: this.updateValue, value: selected, clearable: false })
        )
      );
    }
  }]);

  return RevenueRaised;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RevenueRaised);

/***/ }),

/***/ "n58A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n5J5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export currentBulkUpdateRequestId */
/* unused harmony export bulkUpdateRequestsById */
/* unused harmony export bulkUpdateRequestStatusesById */
/* unused harmony export bulkUpdateRequestIdsByInboxId */
/* unused harmony export bulkUpdateRequestsNotFromCurrentUser */
/* unused harmony export currentBulkUpdateConversationIds */
/* unused harmony export currentBulkUpdateConversationStatus */
/* unused harmony export currentBulkUpdateStatus */
/* unused harmony export currentBulkUpdateConversationCount */
/* unused harmony export isCurrentBulkUpdatePending */
/* unused harmony export isCurrentBulkUpdateFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bulkUpdateRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("TDXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");





var root = function root(state) {
  return state.get('conversationBulkUpdate');
};

var currentBulkUpdateRequestId = function currentBulkUpdateRequestId(state) {
  return root(state).get('currentUpdateRequestId');
};
var bulkUpdateRequestsById = function bulkUpdateRequestsById(state) {
  return root(state).get('updateRequestsById', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var bulkUpdateRequestStatusesById = function bulkUpdateRequestStatusesById(state) {
  return root(state).get('statusByUpdateRequestId', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};
var bulkUpdateRequestIdsByInboxId = function bulkUpdateRequestIdsByInboxId(state) {
  return root(state).get('updateRequestIdsByInboxId', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

var bulkUpdateRequestsNotFromCurrentUser = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["currentUser"], bulkUpdateRequestsById], function (currentUser, bulkUpdateRequestsById) {
  var requests = bulkUpdateRequestsById.filter(function (value, key, iter) {
    return value.has('updaterId') && value.get('updaterId') !== currentUser.id;
  });
  return requests;
});

var currentBulkUpdateConversationIds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([currentBulkUpdateRequestId, bulkUpdateRequestsById], function (currentBulkUpdateRequestId, bulkUpdateRequestsById) {
  return bulkUpdateRequestsById.getIn([currentBulkUpdateRequestId, 'conversationIds'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
});

var currentBulkUpdateConversationStatus = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([currentBulkUpdateRequestId, bulkUpdateRequestsById], function (currentBulkUpdateRequestId, bulkUpdateRequestsById) {
  return bulkUpdateRequestsById.getIn([currentBulkUpdateRequestId, 'conversationStatus']);
});

var currentBulkUpdateStatus = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([currentBulkUpdateRequestId, bulkUpdateRequestStatusesById], function (currentBulkUpdateRequestId, bulkUpdateRequestStatusesById) {
  return bulkUpdateRequestStatusesById.get(currentBulkUpdateRequestId);
});

var currentBulkUpdateConversationCount = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentBulkUpdateConversationIds, function (currentBulkUpdateConversationIds) {
  return currentBulkUpdateConversationIds.size;
});

var isCurrentBulkUpdatePending = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentBulkUpdateStatus, function (currentBulkUpdateStatus) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REQUEST_BULK_UPDATE_PENDING */], __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REQUEST_BULK_UPDATE_SUCCESS */], __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* RECEIVE_BULK_UPDATE_PENDING */]].includes(currentBulkUpdateStatus);
});

var isCurrentBulkUpdateFailed = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(currentBulkUpdateStatus, function (currentBulkUpdateStatus) {
  return [__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* REQUEST_BULK_UPDATE_FAILED */], __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* RECEIVE_BULK_UPDATE_FAILED */]].includes(currentBulkUpdateStatus);
});

var bulkUpdateRequest = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([bulkUpdateRequestsById, function (state, _ref) {
  var updateRequestId = _ref.updateRequestId;
  return updateRequestId;
}], function (bulkUpdateRequestsById, updateRequestId) {
  return bulkUpdateRequestsById.get(updateRequestId);
});

/***/ }),

/***/ "n79a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Classification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Classification = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  name: null
});

/***/ }),

/***/ "n8LW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_tracking__ = __webpack_require__("ZL5f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ConnectedCalendars__ = __webpack_require__("Cn+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConnectGlobalCalendar__ = __webpack_require__("K8bH");


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var GlobalCalendarSettings = function (_Component) {
  _inherits(GlobalCalendarSettings, _Component);

  function GlobalCalendarSettings(props) {
    _classCallCheck(this, GlobalCalendarSettings);

    var _this = _possibleConstructorReturn(this, (GlobalCalendarSettings.__proto__ || Object.getPrototypeOf(GlobalCalendarSettings)).call(this, props));

    _this.trackEvent = function (name, attributes) {
      _this.props.actions.track(name, _extends({
        context: 'settings',
        service: 'microsoft-admin-consent'
      }, attributes));
    };

    _this.onCalendarConnected = function () {
      var _this$props$actions = _this.props.actions,
          track = _this$props$actions.track,
          fetchMicrosoftManagedCalendars = _this$props$actions.fetchMicrosoftManagedCalendars;


      _this.setState({ isConnected: true }, function () {
        _this.props.notifications.success('Your Office 365 calendars are successfully connected.');
        track('Admin consent given', { context: 'settings' });
        _this.trackEvent('Admin Consent Setup', { action: 'connected' });
      }, fetchMicrosoftManagedCalendars);
    };

    _this.onCalendarConnectFailed = function () {
      _this.setState({ isConnected: false }, function () {
        _this.props.notifications.error('Failed to get admin consent. Please review your Office 365 app permissions.');
      });
    };

    _this.onCalendarDisconnect = function () {
      var track = _this.props.actions.track;


      _this.setState({ isConnected: false }, function () {
        _this.props.notifications.success('Your Office 365 calendars have been successfully disconnected.');
        track('Admin consent disconnected', { context: 'settings' });
        _this.trackEvent('Admin Consent Setup', { action: 'disconnected' });
      });
    };

    _this.state = {
      isConnected: props.isGlobalCalendarConnected
    };
    return _this;
  }

  _createClass(GlobalCalendarSettings, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.actions.fetchMicrosoftAdminConsent();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isGlobalCalendarConnected !== this.props.isGlobalCalendarConnected) {
        this.setState({ isConnected: this.props.isGlobalCalendarConnected, pending: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isConnected = this.state.isConnected;
      var hasFetchedConsentStatus = this.props.hasFetchedConsentStatus;


      if (!hasFetchedConsentStatus) return null;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'settings-global-calendar' },
        !isConnected && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ConnectGlobalCalendar__["a" /* default */], { onConnected: this.onCalendarConnected, onConnectFailed: this.onCalendarConnectFailed }),
        isConnected && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ConnectedCalendars__["a" /* default */], { onDisconnect: this.onCalendarDisconnect })
      );
    }
  }]);

  return GlobalCalendarSettings;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchMicrosoftAdminConsent: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__["S" /* fetchMicrosoftAdminConsent */],
      track: __WEBPACK_IMPORTED_MODULE_5_app_modules_tracking__["a" /* actions */].track,
      fetchMicrosoftManagedCalendars: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_actions__["_0" /* fetchMicrosoftManagedCalendars */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isGlobalCalendarConnected: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__["t" /* hasMicrosoftAdminConsent */])(state),
    hasFetchedConsentStatus: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__["s" /* hasFetchedMicrosoftAdminConsent */])(state),
    globalCalendarUsers: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_selectors__["p" /* getMicrosoftAdminConsentUsers */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(GlobalCalendarSettings)));

/***/ }),

/***/ "nFdx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nGBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export attribsRoot */
/* unused harmony export attribs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return teamMemberAttribs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccountSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAccountSegmentsIsLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("T4JO");





var root = function root(state) {
  return state.get('account');
};
var attribsRoot = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.get('attribs');
});

var attribs = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(attribsRoot, function (attribsRoot) {
  return attribsRoot.get('attribs', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());
});

var teamMemberAttribs = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(attribs, function (attribs) {
  return attribs.filter(function (attrib) {
    return attrib.type === __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* ATTRIB_TYPES */].TEAMMEMBER;
  });
});

var getAccountSegments = function getAccountSegments(state) {
  return root(state).getIn(['segments', 'accountSegments']);
};
var getAccountSegmentsIsLoading = function getAccountSegmentsIsLoading(state) {
  return root(state).getIn(['segments', 'loading']);
};

/***/ }),

/***/ "nJZ+":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.219 16.429c-.432 0-.782-.368-.782-.822V10.68c0-.455.35-.822.782-.822.432 0 .781.367.781.822v4.928c0 .454-.35.822-.781.822zM20.383 23H4.617c-1.253 0-2.273-1.072-2.273-2.39V7.318c0-1.318 1.02-2.39 2.273-2.39H6.25V3.287c0-.073.023-.14.04-.206a1.65 1.65 0 0 1-.821-1.437C5.469.738 6.169 0 7.03 0c.862 0 1.563.738 1.563 1.643a1.65 1.65 0 0 1-.821 1.437c.017.067.04.133.04.206v1.643h9.375V3.286c0-.073.022-.14.04-.206a1.65 1.65 0 0 1-.822-1.437C16.406.738 17.108 0 17.97 0s1.562.738 1.562 1.643a1.65 1.65 0 0 1-.82 1.437c.016.067.039.133.039.206v1.643h1.633c1.253 0 2.273 1.07 2.273 2.39V20.61c0 1.318-1.02 2.39-2.273 2.39zm.71-15.682c0-.411-.318-.747-.71-.747H4.617c-.392 0-.71.336-.71.747V20.61c0 .411.318.747.71.747h15.766c.392 0 .71-.336.71-.747V7.318zm-14.062 9.11c0-.454.35-.82.782-.82.432 0 .78.366.78.82h7.813c0-.454.35-.82.782-.82.432 0 .78.366.78.82v1.643H7.032V16.43zm8.985-2.464c-1.078 0-1.953-.92-1.953-2.053s.875-2.054 1.953-2.054c1.077 0 1.953.921 1.953 2.054 0 1.132-.876 2.053-1.953 2.053zm0-2.464a.402.402 0 0 0-.391.41c0 .227.176.411.39.411.215 0 .391-.184.391-.41a.402.402 0 0 0-.39-.411zm-7.032 2.464c-1.077 0-1.953-.92-1.953-2.053s.876-2.054 1.953-2.054c1.078 0 1.954.921 1.954 2.054 0 1.132-.876 2.053-1.954 2.053zm0-2.464a.402.402 0 0 0-.39.41c0 .227.176.411.39.411.215 0 .391-.184.391-.41a.402.402 0 0 0-.39-.411zM.781 16.429c-.432 0-.781-.368-.781-.822V10.68c0-.455.35-.822.781-.822.432 0 .781.367.781.822v4.928c0 .454-.349.822-.78.822z\" fill=\"#FFF\" fill-rule=\"evenodd\" opacity=\".7\"></path></svg>"

/***/ }),

/***/ "nJx7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return truncateWords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encodeQueryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAuthorizationHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RequestContentType; });
/* unused harmony export getQuery */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return serializeObject; });
/* unused harmony export generateRetinaImageProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return generateBulkFetchURL; });
/* unused harmony export isValidPassword */
/* unused harmony export isFileNameImage */
/* unused harmony export moveCursorToEnd */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDomainFromEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PostJsonHeaders; });
/* unused harmony export formatMoment */
/* harmony export (immutable) */ __webpack_exports__["c"] = a;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_MomentCalendarPresets__ = __webpack_require__("7+AP");



var truncateWords = function truncateWords(string, length) {
  var array = string.split(' ');
  if (array.length > length) {
    return array.splice(0, length).join(' ') + '...';
  }
  return string;
};

var encodeQueryData = function encodeQueryData(data) {
  var ret = [];

  var _loop = function _loop(key) {
    var value = data[key];
    if (_.isArray(value)) {
      _.each(value, function (element) {
        return ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(element));
      });
    } else if (value != null) {
      ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
  };

  for (var key in data) {
    _loop(key);
  }
  return ret.join('&');
};

var serializeObject = function serializeObject(obj) {
  return _.map(obj, function (value, key) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
  }).join('&');
};

var isValidPassword = function isValidPassword(password) {
  return password && password.length >= 6;
};

var getAuthorizationHeader = function getAuthorizationHeader() {
  var forcedAccessToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var accessToken = forcedAccessToken;
  if (accessToken == null) {
    accessToken = Object(__WEBPACK_IMPORTED_MODULE_0__driftt_web_auth__["getAccessToken"])();
  }
  if (accessToken) {
    return { Authorization: 'bearer ' + accessToken };
  }
};

var getQuery = function getQuery(paramName, values) {
  var str = values.join('&' + paramName + '=');
  return paramName + '=' + encodeURIComponent(str);
};

var getDomainFromEmail = function getDomainFromEmail(email) {
  if (!email) {
    return '';
  }
  return __guard__(email.split('@'), function (x) {
    return x[1];
  }) || '';
};

var JSON_TYPE = 'application/json';

var RequestContentType = {
  X_WWW_FORM: 'application/x-www-form-urlencoded',
  JSON: JSON_TYPE
};

var PostJsonHeaders = {
  Accept: JSON_TYPE,
  'Content-Type': JSON_TYPE
};

var generateRetinaImageProps = function generateRetinaImageProps(src, retinaSrc) {
  return { src: src, srcSet: src + ' 1x, ' + retinaSrc + ' 2x' };
};

var generateBulkFetchURL = function generateBulkFetchURL(baseURL, ids, paramName) {
  if (paramName == null) {
    paramName = 'id';
  }
  return _.reduce(ids, function (urlAcc, id, index) {
    var urlToken = index === 0 ? '?' : '&';
    return '' + urlAcc + urlToken + paramName + '=' + id;
  }, baseURL);
};

var isFileNameImage = function isFileNameImage(fileName) {
  if (fileName) {
    var tokens = fileName.split('.');
    if (tokens.length > 1) {
      return _.includes(['jpeg', 'jpg', 'gif', 'png', 'svg'], tokens.pop());
    }
  }
};

var moveCursorToEnd = function moveCursorToEnd(el) {
  var value = el.value;

  el.focus();
  el.value = '';
  return el.value = value;
};



function formatMoment(momentInTime) {
  return momentInTime.calendar(null, __WEBPACK_IMPORTED_MODULE_1_constants_MomentCalendarPresets__["a" /* default */].detailedSameDay);
}

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}

// https://github.com/rigoneri/indefinite-article.js/blob/master/indefinite-article.js
function a(phrase) {
  var full = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var match = /\w+/.exec(phrase);
  var word = void 0;
  if (match) word = match[0];else return ('an ' + (full ? l_word : '')).trim();

  var l_word = word.toLowerCase();
  // Specific start of words that should be preceeded by 'an'
  var alt_cases = ['honest', 'hour', 'hono'];
  for (var i in alt_cases) {
    if (l_word.indexOf(alt_cases[i]) == 0) return ('an ' + (full ? phrase : '')).trim();
  }

  // Single letter word which should be preceeded by `an ${phrase}`
  if (l_word.length == 1) {
    if ('aedhilmnorsx'.indexOf(l_word) >= 0) return ('an ' + (full ? phrase : '')).trim();else return ('a ' + (full ? phrase : '')).trim();
  }

  // Capital words which should likely be preceeded by `an ${phrase}`
  if (word.match(/(?!FJO|[HLMNS]Y.|RY[EO]|SQU|(F[LR]?|[HL]|MN?|N|RH?|S[CHKLMNPTVW]?|X(YL)?)[AEIOU])[FHLMNRSX][A-Z]/)) {
    return ('an ' + (full ? phrase : '')).trim();
  }

  // Special cases where a word that begins with a vowel should be preceeded by 'a'
  var regexes = [/^e[uw]/, /^onc?e\b/, /^uni([^nmd]|mo)/, /^u[bcfhjkqrst][aeiou]/];
  for (var _i in regexes) {
    if (l_word.match(regexes[_i])) return ('a ' + (full ? phrase : '')).trim();
  }

  // Special capital words (UK, UN)
  if (word.match(/^U[NK][AIEO]/)) {
    return 'a';
  } else if (word == word.toUpperCase()) {
    if ('aedhilmnorsx'.indexOf(l_word[0]) >= 0) return ('an ' + (full ? phrase : '')).trim();else return 'a';
  }

  // Basic method of words that begin with a vowel being preceeded by `an ${phrase}`
  if ('aeiou'.indexOf(l_word[0]) >= 0) return ('an ' + (full ? phrase : '')).trim();

  // Instances where y follwed by specific letters is preceeded by `an ${phrase}`
  if (l_word.match(/^y(b[lor]|cl[ea]|fere|gg|p[ios]|rou|tt)/)) return ('an ' + (full ? phrase : '')).trim();

  return ('a ' + (full ? phrase : '')).trim();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "nLH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("UsXE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





function CampaignIconLink(_ref) {
  var campaign = _ref.campaign;

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
    { to: '/campaigns/' + campaign.id, className: __WEBPACK_IMPORTED_MODULE_2__style_styl___default.a.LinkIcon + ' flex-center' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
      src: __webpack_require__("WsvI"),
      style: { width: 16, height: 11 }
    })
  );
}

/* harmony default export */ __webpack_exports__["a"] = (CampaignIconLink);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "nPT9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMzM1IDI2NyAxMzUgOTAiPjxzdHlsZT4uc3QwLC5zdDF7ZmlsbDpub25lO3N0cm9rZTojQ0NDO3N0cm9rZS13aWR0aDo0fS5zdDF7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kfTwvc3R5bGU+PHRpdGxlPkdyb3VwPC90aXRsZT48ZyBpZD0iTlBTLUZsb3ciPjxnIGlkPSJXaXphcmQtLS1UeXBlIj48ZyBpZD0iR3JvdXAiPjxwYXRoIGlkPSJSZWN0YW5nbGUtNTctQ29weS0yIiBjbGFzcz0ic3QwIiBkPSJNLTMxNS43IDMzNy44VjI4MWMwLTQuNCAzLjYtOCA4LThoOTNjNC40IDAgOCAzLjYgOCA4djY0YzAgNC40LTMuNiA4LTggOGgtMTA5LjhjLTEuOCAwLTIuMy0xLjEtMS4yLTIuNWwxMC0xMi43eiIvPjxwYXRoIGlkPSJMaW5lIiBjbGFzcz0ic3QxIiBkPSJNLTI5NC4zIDMxOS43aDU4LjIiLz48cGF0aCBpZD0iTGluZS1Db3B5LTkiIGNsYXNzPSJzdDEiIGQ9Ik0tMjk0LjMgMzMyLjdoNTAuMiIvPjxwYXRoIGlkPSJMaW5lLUNvcHkiIGNsYXNzPSJzdDEiIGQ9Ik0tMjk0LjMgMzA4aDcwLjYiLz48cGF0aCBpZD0iTGluZS1Db3B5LTIiIGNsYXNzPSJzdDEiIGQ9Ik0tMjk0LjMgMjk0LjdoNDIuMiIvPjwvZz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "nS6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = weakUuid;
function weakUuid(a) {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, weakUuid);
}

/***/ }),

/***/ "nUuA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "na0B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__conversationPreview__ = __webpack_require__("ovod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__botFollowUp__ = __webpack_require__("+aVH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("ZWQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);









var NonMatchModalBody = function NonMatchModalBody(_ref) {
  var response = _ref.answer.response,
      prompt = _ref.question.prompt,
      theme = _ref.theme,
      targetCopy = _ref.targetCopy,
      shortTargetCopy = _ref.shortTargetCopy,
      botFollowUpProps = _ref.botFollowUpProps;

  var defaultNonMatchResponse = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { className: 'defaultNonmatch' },
    'Your non-matching follow-up will go here'
  );
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.AnswerModalContent },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'drift-form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__botFollowUp__["a" /* default */], botFollowUpProps),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Loop on Unsuccessful Capture'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'If the user\u2019s answer doesn\u2019t include a valid ',
        targetCopy,
        ', we\u2019ll loop the response above.'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'In ',
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["c" /* a */])(Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["capitalizeAll"])(targetCopy)),
        ' Capture Question, a user\u2019s answer must include',
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["c" /* a */])(targetCopy),
        ' in order to move on to the Next Step. If their answer doesn\u2019t include',
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["c" /* a */])(targetCopy),
        ', Driftbot will loop and ask the question again until they respond with',
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["c" /* a */])(shortTargetCopy),
        '.',
        ' '
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__conversationPreview__["a" /* default */], {
      prompt: prompt,
      nonMatchAnswer: response || defaultNonMatchResponse,
      backgroundColor: _.get(theme, 'backgroundColor', '2D88F3'),
      textColor: _.get(theme, 'textColor', 'FFFFF')
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (NonMatchModalBody);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "ndDR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("U2f2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);








var renderEmailConfirmCopy = function renderEmailConfirmCopy(hasLimitedContactsMktEmail, isCardinalityLoading, targetingCardinality) {
  return hasLimitedContactsMktEmail ? React.createElement(
    'div',
    null,
    React.createElement(
      'span',
      null,
      'When you toggle this automated email "on", all contacts in the segments selected for Audience will receive it.'
    ),
    React.createElement(
      'div',
      { className: 'playbook-email-send-confirm-cardinality' },
      'Currently, that is ',
      isCardinalityLoading ? React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_LoadingDots__["a" /* default */], null) : targetingCardinality,
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(targetingCardinality || 0, 'person', 'people'),
      '.'
    ),
    React.createElement('br', null),
    React.createElement(
      'span',
      null,
      'As new contacts are added to the segments, they will be added to the Audience and start receiving this playbooks emails.'
    )
  ) : React.createElement(
    'div',
    null,
    React.createElement(
      'span',
      null,
      'When you toggle this email playbook to "On", all contacts in the segments created by the bot will receive the emails.'
    ),
    React.createElement('br', null),
    React.createElement('br', null),
    React.createElement(
      'span',
      null,
      'As new contacts are added to the segment by the bot, they will be added to the Audience and start receiving the emails as well.'
    )
  );
};

var ConditionModal = function ConditionModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      targetingCardinality = _ref.targetingCardinality,
      isCardinalityLoading = _ref.isCardinalityLoading,
      onConfirmClick = _ref.onConfirmClick,
      isOneTimeEmailPlaybook = _ref.isOneTimeEmailPlaybook,
      hasLimitedContactsMktEmail = _ref.hasLimitedContactsMktEmail;

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Modal"],
    {
      open: true,
      size: 'small',
      onClose: onCloseClick,
      className: 'playbook-email-send-confirm'
    },
    React.createElement(
      'div',
      { className: 'playbook-email-send-confirm-wrapper' },
      React.createElement(
        'div',
        null,
        React.createElement(
          'h2',
          null,
          'Ready to send your email?'
        )
      ),
      isOneTimeEmailPlaybook ? React.createElement(
        'div',
        null,
        React.createElement(
          'p',
          null,
          'You\'re about to send this email to: '
        ),
        React.createElement(
          'div',
          { className: 'playbook-email-send-confirm-cardinality' },
          isCardinalityLoading ? React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_LoadingDots__["a" /* default */], null) : targetingCardinality,
          ' ',
          Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(targetingCardinality || 0, 'person', 'people'),
          '.'
        ),
        React.createElement(
          'p',
          null,
          'This action cannot be undone.'
        )
      ) : renderEmailConfirmCopy(hasLimitedContactsMktEmail, isCardinalityLoading, targetingCardinality)
    ),
    React.createElement(
      'footer',
      null,
      React.createElement(
        'div',
        { className: 'playbook-email-send-confirm-actions' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { onClick: onConfirmClick },
          isOneTimeEmailPlaybook ? 'Send Email' : 'Turn on & Send email'
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', onClick: onCloseClick },
          'Cancel'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConditionModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ndOC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"IntegrationControl":"IntegrationControl---VkqRe","IntegrationLink":"IntegrationLink---2N7Jj","DisconnectLink":"DisconnectLink---2l2Hk"};

/***/ }),

/***/ "ndex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_driftiwyg_legacy__ = __webpack_require__("TM3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_driftiwyg_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_driftiwyg_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DelayTime__ = __webpack_require__("6maG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("7rdi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("sNIf");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TemplateOption = function TemplateOption(_ref) {
  var displayValue = _ref.displayValue,
      selected = _ref.selected,
      onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    {
      className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("template-option", { selected: selected }),
      onClick: onClick },
    displayValue
  );
};

var EmailTemplateModal = function (_React$Component) {
  _inherits(EmailTemplateModal, _React$Component);

  function EmailTemplateModal(props) {
    _classCallCheck(this, EmailTemplateModal);

    var _this = _possibleConstructorReturn(this, (EmailTemplateModal.__proto__ || Object.getPrototypeOf(EmailTemplateModal)).call(this, props));

    var templateOptions = _this.props.templateOptions;

    _this.state = {
      selectedOption: _.head(templateOptions)
    };
    return _this;
  }

  _createClass(EmailTemplateModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          onClose = _props.onClose,
          onSave = _props.onSave,
          onCancel = _props.onCancel,
          editingAssistantAgentSettings = _props.editingAssistantAgentSettings,
          settingName = _props.settingName,
          selectedSettingName = _props.selectedSettingName,
          selectSetting = _props.selectSetting,
          _props$settingTemplat = _props.settingTemplateOptions,
          settingTemplateOptions = _props$settingTemplat === undefined ? [] : _props$settingTemplat,
          _props$hasDelayEditin = _props.hasDelayEditing,
          hasDelayEditing = _props$hasDelayEditin === undefined ? true : _props$hasDelayEditin,
          delayTime = _props.delayTime,
          onDelayEdit = _props.onDelayEdit,
          initialEmailSubject = _props.initialEmailSubject,
          onSubjectEdit = _props.onSubjectEdit,
          initialEmailBody = _props.initialEmailBody,
          onBodyEdit = _props.onBodyEdit,
          sendTestEmail = _props.sendTestEmail,
          sendTestEmailPending = _props.sendTestEmailPending,
          assistantConfigHasEdits = _props.assistantConfigHasEdits,
          _props$personalizatio = _props.personalizationTags,
          personalizationTags = _props$personalizatio === undefined ? {} : _props$personalizatio;

      var hasTemplateOptions = !!settingTemplateOptions.length;

      var title = settingName === 'MEETING_CONFIRMATION' ? "Customize your meeting confirmation message" : "Customize your meeting reminder message";

      var delayCopy = settingName === 'MEETING_CONFIRMATION' ? "after a meeting is booked." : "before your meeting.";

      var templateOptionsComponents = hasTemplateOptions && _.map(settingTemplateOptions, function (optionName, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TemplateOption, {
          key: optionName + '-' + i,
          displayValue: Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* humanizeDelay */])(editingAssistantAgentSettings.getIn([optionName, 'delayTime'], 0)),
          selected: selectedSettingName === optionName,
          onClick: function onClick() {
            return selectSetting(optionName);
          } });
      });

      var SendEmailButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
        {
          disabled: assistantConfigHasEdits || sendTestEmailPending,
          loading: sendTestEmailPending,
          className: 'test-email-button',
          type: 'subtle',
          size: 'small',
          onClick: sendTestEmail },
        'Send test email'
      );

      var testEmailButton = assistantConfigHasEdits ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
        { flow: 'left', component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Save your changes to send a test email!'
          ), className: 'overwrite-info-button' },
        SendEmailButton
      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["ToolTip"],
        { flow: 'left', component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'Meeting information will be based ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'on your default meeting type'
          ), className: 'overwrite-info-button' },
        SendEmailButton
      );

      var meeting = personalizationTags.meeting,
          company = personalizationTags.company,
          user = personalizationTags.user;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Modal"],
        {
          className: 'meeting-email-template-modal',
          open: isOpen,
          size: 'medium',
          onClose: onClose
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'meeting-email-template-modal-content-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'meeting-email-template-modal-content' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'meeting-email-template-modal-header' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                title
              )
            ),
            !!hasTemplateOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'template-options-wrapper' },
              templateOptionsComponents
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'delay-and-send-wrapper' },
              hasDelayEditing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'meeting-email-template-modal-delay-editor' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DelayTime__["a" /* default */], {
                  value: delayTime,
                  onUpdate: onDelayEdit,
                  delayCopy: delayCopy,
                  selectedSettingName: selectedSettingName
                })
              ),
              testEmailButton
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()("meeting-email-template-body", { 'has-template-options': hasTemplateOptions }) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'template-label-option-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Email Subject'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_driftiwyg_legacy__["Driftiwyg"], {
                  className: 'email-subject-editor',
                  placeholder: 'Enter your email subject here!',
                  editorState: initialEmailSubject,
                  onChange: function onChange(value) {
                    return onSubjectEdit(value);
                  },
                  companyTagList: company,
                  meetingTagList: meeting,
                  userTagList: user,
                  toolbarOptions: ['emoji', 'tag'],
                  v2: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'template-label-option-wrapper' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Email Template'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_driftiwyg_legacy__["Driftiwyg"], {
                  className: 'email-body-editor',
                  placeholder: 'Enter your email template here!',
                  editorState: initialEmailBody,
                  onChange: function onChange(value) {
                    return onBodyEdit(value);
                  },
                  companyTagList: company,
                  meetingTagList: meeting,
                  userTagList: user,
                  toolbarOptions: ['bold', 'italic', 'underline', 'link', 'emoji', 'image', 'tag'],
                  v2: true
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'meeting-email-template-modal-button-section-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'meeting-email-template-modal-button-section' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              {
                type: 'primary',
                size: 'medium',
                onClick: function onClick() {
                  return onSave();
                }
              },
              'Save'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
              {
                type: 'tertiary',
                onClick: function onClick() {
                  // optimize this later
                  if (assistantConfigHasEdits) {
                    if (window.confirm("Are you sure you want to leave this page? You will lose any unsaved changes.")) {
                      onCancel();
                      return onClose();
                    }
                  } else {
                    onCancel();
                    return onClose();
                  }
                }
              },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return EmailTemplateModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (EmailTemplateModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "neFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("I+r9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);







var DelayTime = function DelayTime(_ref) {
  var value = _ref.value,
      unit = _ref.unit,
      updateValue = _ref.updateValue,
      pickUnits = _ref.pickUnits,
      _ref$validRange = _ref.validRange,
      validRange = _ref$validRange === undefined ? { min: 0 } : _ref$validRange,
      className = _ref.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.delayTimeWrapper, className) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
      type: 'number',
      value: value,
      min: validRange.min,
      max: validRange.max,
      step: '1',
      onChange: function onChange(e) {
        return updateValue(e.target.value);
      } }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Select"], {
      className: 'units',
      options: [{
        value: 'hour',
        label: Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(value, 'Hour', 'Hours')
      }, {
        value: 'minute',
        label: Object(__WEBPACK_IMPORTED_MODULE_1_humanize_plus__["pluralize"])(value, 'Minute', 'Minutes')
      }],
      value: unit,
      onChange: pickUnits,
      clearable: false
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  pickUnits: function pickUnits(props) {
    return function (_ref2) {
      var unit = _ref2.value;

      props.onUnitChange(unit);
    };
  },
  updateValue: function updateValue(props) {
    return function (value) {
      props.onValueChange(value);
    };
  }
}))(DelayTime));

/***/ }),

/***/ "nf5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("wWX/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");






var LEANDATA_INTEGRATION_SWITCH = 'leandata-integration-switch';

var SALESFORCE_ATTRIBUTE_MAPPINGS_PATH = '/settings/salesforce/mapping/attributes';
var SALESFORCE_TEAMMATE_MAPPINGS_PATH = '/settings/salesforce/mapping/users';
var GLOBAL_ROUTING_RULES_PATH = '/settings/rules';
var PLAYBOOKS_PATH = '/playbooks';

var makeConnectButtonPressConfig = function makeConnectButtonPressConfig(enabled, successCallback) {
  return {
    url: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/integrations/leandata/toggles',
    method: 'patch',
    data: {
      enabled: enabled
    },
    successMessage: 'Successfully turned off the LeanData integration',
    errorMessage: 'Something went wrong and we couldn\u2019t turn off the LeanData integration',
    clickId: LEANDATA_INTEGRATION_SWITCH,
    successCallback: successCallback
  };
};

var LeanDataCard = function LeanDataCard(_ref) {
  var header = _ref.header,
      message = _ref.message,
      linkText = _ref.linkText,
      linkTo = _ref.linkTo;
  return React.createElement(
    'div',
    { className: 'leandata-card' },
    React.createElement(
      'div',
      { className: 'leandata-card-header' },
      header
    ),
    React.createElement(
      'p',
      null,
      message
    ),
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
      { className: "leandata-card-link", to: linkTo },
      linkText
    )
  );
};

var LeanDataConnected = function LeanDataConnected(_ref2) {
  var asyncButtonPress = _ref2.asyncButtonPress,
      togglePending = _ref2.togglePending,
      integrationsFetchPending = _ref2.integrationsFetchPending,
      fetchIntegrationStates = _ref2.fetchIntegrationStates;
  return React.createElement(
    'div',
    { className: 'leandata-connected-view-container' },
    React.createElement(
      'div',
      { className: 'leandata-connected-view-header' },
      'You\u2019re all set to start using LeanData for conversation routing!'
    ),
    React.createElement(
      'div',
      { className: 'leandata-connected-cards-container' },
      React.createElement(LeanDataCard, {
        header: "Create a conversation routing rule",
        message: "Use LeanData in a conversation routing rule to connect site visitors with the right teammate.",
        linkText: "View conversation routing rules",
        linkTo: GLOBAL_ROUTING_RULES_PATH }),
      React.createElement(LeanDataCard, {
        header: "Route teammates in bot playbooks",
        message: "Use LeanData to route the conversation at specific points in a bot conversation.",
        linkText: "View all playbooks ",
        linkTo: PLAYBOOKS_PATH })
    ),
    React.createElement(
      'div',
      { className: 'leandata-connected-note-container' },
      React.createElement(
        'p',
        null,
        React.createElement(
          'b',
          null,
          'Note: '
        ),
        'We recommend checking that your ',
        React.createElement(
          'span',
          null,
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
            { to: SALESFORCE_ATTRIBUTE_MAPPINGS_PATH },
            'attribute mappings'
          )
        ),
        ' between Drift and Salesforce are set up correctly, and that your ',
        React.createElement(
          'span',
          null,
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
            { to: SALESFORCE_TEAMMATE_MAPPINGS_PATH },
            'teammates'
          )
        ),
        ' are in both Drift and Salesforce.'
      )
    ),
    React.createElement(
      'div',
      { className: 'leandata-connected-disconnect-container' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
        { type: 'secondary', loading: togglePending || integrationsFetchPending, onClick: function onClick() {
            return asyncButtonPress(makeConnectButtonPressConfig(false, fetchIntegrationStates));
          } },
        'Disconnect LeanData'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LeanDataConnected);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "nhTC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Action__ = __webpack_require__("hgXQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("2FY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var ABMSendFrom = function ABMSendFrom() {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__Action__["a" /* default */],
    { onEditClick: function onEditClick() {
        window.open("/accounts", "_blank");
      } },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.ABMSendFrom },
      React.createElement(
        'p',
        null,
        'This Welcome Message will send from the Account Owner. ',
        React.createElement(
          'a',
          { href: '/accounts', target: '_blank' },
          ' Go to accounts.'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ABMSendFrom);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "nmrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectButton__ = __webpack_require__("sCN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style__ = __webpack_require__("GN7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var SUCCESS_MESSAGE = 'Demandbase was successfully connected!';
var ERROR_MESSAGE = 'Oops, there was an error. Please try again.';

var Demandbase = function (_Component) {
  _inherits(Demandbase, _Component);

  function Demandbase(props) {
    _classCallCheck(this, Demandbase);

    var _this = _possibleConstructorReturn(this, (Demandbase.__proto__ || Object.getPrototypeOf(Demandbase)).call(this, props));

    _this.onApiKeyChanged = function (event) {
      _this.setState({ apiKey: event.target.value });
    };

    _this.isApiKeyValid = function () {
      return _this.state.apiKey !== '';
    };

    _this.isConnectButtonDisabled = function () {
      return !_this.isApiKeyValid();
    };

    _this.connectIntegration = function () {
      var notifications = _this.props.notifications;
      var IntegrationsQueries = _this.context.app.queries.IntegrationsQueries;


      var connect = function connect() {
        Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["Q" /* saveDemandbaseApiKey */])(_this.state.apiKey).then(function () {
          return notifications.success(SUCCESS_MESSAGE);
        }).catch(function () {
          return notifications.error(ERROR_MESSAGE);
        }).then(function () {
          return _this.setState({ isConnecting: false, isConnected: true });
        }).then(function () {
          return IntegrationsQueries.fetchIntegrationStates();
        });
      };

      _this.setState({ isConnecting: true }, connect);
    };

    _this.state = {
      apiKey: '',
      isConnecting: false,
      isConnected: props.isConnected
    };
    return _this;
  }

  _createClass(Demandbase, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ isConnected: props.isConnected });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isConnecting = _state.isConnecting,
          isConnected = _state.isConnected;


      return React.createElement(
        'div',
        { className: 'demandbase-integration-page' },
        React.createElement(
          'p',
          { className: 'integration-page-description' },
          'Enrich your lead data further in Drift by enabling the Demandbase integration. We\u2019ll attach information such as company name, headquarters location, and company size to leads when they become identified in Drift by email.',
          React.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019504234-How-to-Connect-Drift-to-Demandbase', target: '_blank' },
            'Learn more'
          )
        ),
        React.createElement(
          'div',
          { className: 'drift-form' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
            { condition: !isConnected },
            React.createElement(
              'span',
              { className: 'demandbase-key-label' },
              'API key'
            ),
            React.createElement('input', {
              className: 'demandbase-key-input',
              type: 'text',
              placeholder: 'e.g. 123456',
              onChange: this.onApiKeyChanged
            }),
            React.createElement(
              'p',
              { className: 'demandbase-key-description' },
              'Use your Demandbase API Key to connect Demandbase and Drift'
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
          { condition: !isConnected },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ConnectButton__["a" /* default */], {
            disabled: this.isConnectButtonDisabled(),
            onClick: this.connectIntegration,
            isProcessing: isConnecting
          })
        )
      );
    }
  }]);

  return Demandbase;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Demandbase.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(Demandbase));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "npn6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("xyiN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function WelcomeMessageCard(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  return React.createElement(
    'div',
    _extends({ className: __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.WelcomeMessageCard }, rest),
    children
  );
}
WelcomeMessageCard.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "nu3i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchAttributesPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchAttributesFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAttributesCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveAttributes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("z8rd");



var fetchAttributes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_ATTRIBUTES */]);
var fetchAttributesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_ATTRIBUTES_PENDING */]);
var fetchAttributesFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_ATTRIBUTES_FAILED */]);
var fetchAttributesCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_ATTRIBUTES_CANCELLED */]);
var receiveAttributes = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* RECEIVE_ATTRIBUTES */]);

/***/ }),

/***/ "nyZa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TECH_TAGS; });
var TECH_TAGS = {
  '1_and_1_hosting': '1&1 Hosting',
  '3d_cart': '3d Cart',
  'acquisio': 'Acquisio',
  'activecampaign': 'Activecampaign',
  'add_to_any': 'Add To Any',
  'adform_advertiser': 'Adform Advertiser',
  'adobe_business_catalyst': 'Adobe Business Catalyst',
  'adobe_connect': 'Adobe Connect',
  'adobe_dynamic_tag_management': 'Adobe Dynamic Tag Management',
  'adroll': 'AdRoll',
  'airbrake': 'Airbrake',
  'akamai': 'Akamai',
  'akamai_dns': 'Akamai DNS',
  'alexa': 'Alexa',
  'altocloud': 'Altocloud',
  'amazon_associates': 'Amazon Associates',
  'amazon_payments': 'Amazon Payments',
  'amazon_s3': 'Amazon S3',
  'amazon_ses': 'Amazon Simple Email Service',
  'amcharts': 'amCharts',
  'amplitude': 'Amplitude',
  'android': 'Android',
  'apache': 'Apache',
  'app_nexus': 'App Nexus',
  'appboy': 'Appboy',
  'appcues': 'Appcues',
  'appdynamics': 'AppDynamics',
  'apteligent': 'Apteligent',
  'asp_net': 'ASP.Net',
  'attribution': 'Attribution',
  'authorizenet': 'Authorizenet',
  'autopilot': 'Autopilot',
  'aweber': 'Aweber',
  'aws_ec2': 'Amazon Web Services',
  'aws_route_53': 'Route 53',
  'bazaarvoice': 'Bazaarvoice',
  'benchmarkemail': 'Benchmarkemail',
  'big_cartel': 'Big Cartel',
  'bigcommerce': 'Bigcommerce',
  'bing_ads': 'Bing Ads',
  'bing_advertiser': 'Bing Advertiser',
  'bing_maps': 'Bing Maps',
  'bloomreach': 'Bloomreach',
  'bluehost_hosting': 'Bluehost Hosting',
  'braintree': 'Braintree',
  'branch': 'Branch',
  'brightcove': 'Brightcove',
  'bronto': 'Bronto',
  'bug_herd': 'Bug Herd',
  'bugsnag': 'Bugsnag',
  'calq': 'Calq',
  'campaignmonitor': 'Campaignmonitor',
  'castle': 'Castle',
  'centos': 'CentOS',
  'chargify': 'Chargify',
  'chart_beat': 'Chart Beat',
  'chartio': 'Chartio',
  'chatlio': 'Chatlio',
  'chownow': 'Chownow',
  'clickfunnels': 'ClickFunnels',
  'clicktale': 'Clicktale',
  'clicky': 'Clicky',
  'cloud_flare': 'Cloud Flare',
  'cloudinary': 'Cloudinary',
  'commerce_sciences': 'Commerce Sciences',
  'constant_contact': 'Constant Contact',
  'contently': 'Contently',
  'convert_kit': 'Convert Kit',
  'crazy_egg': 'Crazy Egg',
  'criteo': 'Criteo',
  'customer_io': 'Customer.io',
  'debian': 'Debian',
  'demandbase': 'Demandbase',
  'demandware': 'Demandware',
  'digital_ocean': 'Digital Ocean',
  'disqus': 'Disqus',
  'django': 'Django',
  'dns_made_easy': 'DNS Made Easy',
  'double_click': 'DoubleClick Ads',
  'double_click_advertiser': 'DoubleClick Advertiser',
  'dreamhost_hosting': 'DreamHost Hosting',
  'drift': 'Drift',
  'drip': 'Drip',
  'drupal': 'Drupal',
  'dwolla': 'Dwolla',
  'dyn_dns': 'Dyn DNS',
  'dynamic_yield': 'Dynamic Yield',
  'ecwid': 'Ecwid',
  'elasticemail': 'ElasticEmail',
  'elevio': 'Elevio',
  'eloqua': 'Eloqua',
  'emma': 'Emma',
  'errorception': 'Errorception',
  'express': 'Express',
  'facebook_advertiser': 'Facebook Advertiser',
  'facebook_beacon': 'Facebook Beacon',
  'facebook_comments': 'Facebook Comments',
  'facebook_connect': 'Facebook Connect',
  'facebook_like_button': 'Facebook Like Button',
  'facebook_social_plugins': 'Facebook Social Plugins',
  'fedora': 'Fedora',
  'formstack': 'Formstack',
  'freebsd': 'FreeBSD',
  'freshdesk': 'Freshdesk',
  'fullcontact': 'Fullcontact',
  'fullstory': 'Fullstory',
  'fusioncharts': 'FusionCharts',
  'gauges': 'Gauges',
  'get_response': 'Get Response',
  'get_satisfaction': 'Get Satisfaction',
  'go_squared': 'Go Squared',
  'gocardless': 'Gocardless',
  'godaddy_hosting': 'GoDaddy Hosting',
  'godaddy_nameserver': 'Godaddy Nameserver',
  'google_adsense': 'Google Adsense',
  'google_adwords': 'Google Adwords',
  'google_affiliate_network': 'Google Affiliate Network',
  'google_analytics': 'Google Analytics',
  'google_apps': 'Google Apps',
  'google_charts': 'Google Charts',
  'google_cloud': 'Google Cloud',
  'google_forms': 'Google Forms',
  'google_maps': 'Google Maps',
  'google_tag_manager': 'Google Tag Manager',
  'google_website_optimizer': 'Google Website Optimizer',
  'google_widgets': 'Google Widgets',
  'graphiq': 'GraphIQ',
  'gravity_forms': 'Gravity Forms',
  'greenhouse': 'Greenhouse',
  'heap': 'Heap',
  'hello_bar': 'Hello Bar',
  'help_scout': 'Help Scout',
  'heroku': 'Heroku',
  'highcharts': 'Highcharts',
  'hotjar': 'Hotjar',
  'hoverowl': 'Hoverowl',
  'hubspot': 'HubSpot',
  'icims': 'Icims',
  'indicative': 'Indicative',
  'infusionsoft': 'Infusionsoft',
  'inside_sales': 'Inside Sales',
  'inspectlet': 'Inspectlet',
  'instagram': 'Instagram',
  'instagram_links': 'Instagram Links',
  'instart_logic': 'Instart Logic',
  'intense_debate': 'Intense Debate',
  'intercom': 'Intercom',
  'ios': 'ios',
  'iterable': 'Iterable',
  'java': 'Java',
  'jobvite': 'Jobvite',
  'joomla': 'Joomla',
  'kapost': 'Kapost',
  'keen_io': 'Keen IO',
  'kiss_metrics': 'Kissmetrics',
  'klaviyo': 'Klaviyo',
  'knowtify': 'Knowtify',
  'lead_dyno': 'Lead Dyno',
  'lever': 'Lever',
  'linked_in_advertiser': 'LinkedIn Advertiser',
  'linkwithin': 'Linkwithin',
  'linode_hosting': 'Linode Hosting',
  'live_chat': 'Live Chat',
  'livefyre': 'Livefyre',
  'liveramp': 'Liveramp',
  'localytics': 'Localytics',
  'looker': 'Looker',
  'lucky_orange': 'Lucky Orange',
  'mad_kudu': 'Mad Kudu',
  'magento': 'Magento',
  'magento_enterprise': 'Magento Enterprise',
  'mailchimp': 'Mailchimp',
  'mailgun': 'Mailgun',
  'mailjet': 'Mailjet',
  'mandrill': 'Mandrill',
  'marketo': 'Marketo',
  'maxmind': 'Maxmind',
  'microsoft_azure': 'Microsoft Azure',
  'microsoft_exchange_online': 'Microsoft Exchange Online',
  'microsoft_office_365': 'Microsoft Office 365',
  'mixpanel': 'Mixpanel',
  'mode': 'Mode',
  'mouseflow': 'Mouseflow',
  'mousestats': 'Mousestats',
  'my_site_auditor': 'My Site Auditor',
  'namecheap_dns': 'Namecheap Dns',
  'new_relic': 'New Relic',
  'nextable': 'Nextable',
  'nginx': 'Nginx',
  'nosto': 'Nosto',
  'olark': 'Olark',
  'omniconvert': 'Omniconvert',
  'omniture_adobe_analytics': 'Omniture (Adobe Analytics)',
  'ooyala': 'Ooyala',
  'open_table': 'Open Table',
  'optimizely': 'Optimizely',
  'optimonk': 'Optimonk',
  'oscommerce': 'Oscommerce',
  'outbound': 'Outbound',
  'outbrain_ads': 'Outbrain Ads',
  'outlook': 'Outlook',
  'owneriq': 'ownerIQ',
  'pardot': 'Pardot',
  'paypal': 'PayPal',
  'payza': 'Payza',
  'percolate': 'Percolate',
  'perfect_audience': 'Perfect Audience',
  'periscope_data': 'Periscope Data',
  'pinterest': 'Pinterest',
  'piwik': 'Piwik',
  'postmark': 'Postmark',
  'powerreviews': 'PowerReviews',
  'qualaroo': 'Qualaroo',
  'qualtrics': 'Qualtrics',
  'quantcast': 'Quantcast',
  'qubit': 'Qubit',
  'rackspace': 'Rackspace',
  'rackspace_email': 'Rackspace Email',
  'recaptcha': 'Recaptcha',
  'recruiterbox': 'Recruiterbox',
  'recurly': 'Recurly',
  'red_hat': 'Red Hat',
  'resrcit': 'ReSRCit',
  'resumator': 'Resumator',
  'retailrocket': 'RetailRocket',
  'rezdy': 'Rezdy',
  'rezgo': 'Rezgo',
  'robly': 'Robly',
  'rollbar': 'Rollbar',
  'ruby_on_rails': 'Ruby On Rails',
  'salesforce': 'Salesforce',
  'salesmachine': 'Salesmachine',
  'satismeter': 'Satismeter',
  'segment': 'Segment',
  'sendgrid': 'Sendgrid',
  'sentry': 'Sentry',
  'sessioncam': 'Sessioncam',
  'sharepoint': 'Sharepoint',
  'shopify': 'Shopify',
  'shopware': 'Shopware',
  'silkroad': 'Silkroad',
  'simplicant': 'Simplicant',
  'slack': 'Slack',
  'smartlook': 'Smartlook',
  'sociomantic': 'Sociomantic',
  'socket_io': 'Socket.io',
  'softlayer_hosting': 'Softlayer Hosting',
  'squarespace': 'Squarespace',
  'steel_house': 'SteelHouse',
  'stripe': 'Stripe',
  'success_factors': 'Success Factors',
  'survey_monkey': 'Survey Monkey',
  'tableau': 'Tableau',
  'taboola_ads': 'Taboola Ads',
  'taleo': 'Taleo',
  'talkable': 'Talkable',
  'tawk': 'Tawk',
  'tealium': 'Tealium',
  'totango': 'Totango',
  'tout': 'Tout',
  'toutapp': 'Toutapp',
  'towerdata': 'TowerData',
  'track_js': 'Track JS',
  'trustpilot': 'Trustpilot',
  'twitter_advertiser': 'Twitter Advertiser',
  'twitter_badge': 'Twitter Badge',
  'twitter_button': 'Twitter Button',
  'typeform': 'Typeform',
  'typekit_by_adobe': 'Typekit By Adobe',
  'uber_cart': 'Uber Cart',
  'ubuntu': 'Ubuntu',
  'ultipro': 'Ultipro',
  'unix': 'Unix',
  'user_voice': 'UserVoice',
  'vero': 'Vero',
  'verticalresponse': 'Verticalresponse',
  'videojs': 'Video.js',
  'vidyard': 'Vidyard',
  'vimeo': 'Vimeo',
  'virtue_mart': 'Virtue Mart',
  'visual_website_optimizer': 'Visual Website Optimizer',
  'volusion': 'Volusion',
  'webengage': 'WebEngage',
  'weebly': 'Weebly',
  'wistia': 'Wistia',
  'wix_stores': 'Wix Stores',
  'woo_commerce': 'Woo Commerce',
  'woopra': 'Woopra',
  'wootric': 'Wootric',
  'wordpress': 'Wordpress',
  'workable': 'Workable',
  'wp_engine': 'Wp Engine',
  'wufoo': 'Wufoo',
  'xt_commerce': 'xt:Commerce',
  'yahoo_stores': 'Yahoo Stores',
  'yandex_metrica': 'Yandex Metrica',
  'yelp_seatme': 'Yelp Seatme',
  'yesware': 'Yesware',
  'yieldify': 'Yieldify',
  'yotpo': 'Yotpo',
  'youtube': 'Youtube',
  'zeit_now': 'Zeit Now',
  'zen_cart': 'Zen Cart',
  'zendesk': 'Zendesk',
  'zenreach': 'Zenreach',
  'zopim': 'Zopim',
  'zuora': 'Zuora'
};

/***/ }),

/***/ "o/MR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NPS_ICON_SRC = __webpack_require__("Cyhm");

var NPSCampaignEvent = function (_Component) {
  _inherits(NPSCampaignEvent, _Component);

  function NPSCampaignEvent() {
    _classCallCheck(this, NPSCampaignEvent);

    return _possibleConstructorReturn(this, (NPSCampaignEvent.__proto__ || Object.getPrototypeOf(NPSCampaignEvent)).apply(this, arguments));
  }

  _createClass(NPSCampaignEvent, [{
    key: 'render',
    value: function render() {
      var campaign = this.props.event.body.campaign;

      var eventProps = _extends({
        iconSrc: NPS_ICON_SRC,
        eventLabel: 'received NPS survey'
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
        eventProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/campaigns/' + campaign.id },
          campaign.name
        )
      );
    }
  }]);

  return NPSCampaignEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (NPSCampaignEvent);

/***/ }),

/***/ "o/OB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_BANNED_IPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_BANNED_IPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_BANNED_IPS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_BANNED_IPS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAN_IP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BAN_IP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BAN_IP_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BAN_IP_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UNBAN_IP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UNBAN_IP_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UNBAN_IP_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UNBAN_IP_PENDING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('ban');

var FETCH_BANNED_IPS = makeConstant('FETCH_BANNED_IPS');
var FETCH_BANNED_IPS_SUCCESS = makeConstant('FETCH_BANNED_IPS_SUCCESS');
var FETCH_BANNED_IPS_FAILED = makeConstant('FETCH_BANNED_IPS_FAILED');
var FETCH_BANNED_IPS_PENDING = makeConstant('FETCH_BANNED_IPS_PENDING');

var BAN_IP = makeConstant('BAN_IP');
var BAN_IP_SUCCESS = makeConstant('BAN_IP_SUCCESS');
var BAN_IP_FAILED = makeConstant('BAN_IP_FAILED');
var BAN_IP_PENDING = makeConstant('BAN_IP_PENDING');

var UNBAN_IP = makeConstant('UNBAN_IP');
var UNBAN_IP_SUCCESS = makeConstant('UNBAN_IP_SUCCESS');
var UNBAN_IP_FAILED = makeConstant('UNBAN_IP_FAILED');
var UNBAN_IP_PENDING = makeConstant('UNBAN_IP_PENDING');

/***/ }),

/***/ "o4YO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__("KTM0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("Wmkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ImagePreview = function ImagePreview(_ref) {
  var preview = _ref.preview,
      className = _ref.className,
      shouldRenderPreview = _ref.shouldRenderPreview;

  if (!shouldRenderPreview) {
    return null;
  }
  if (preview) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', {
      className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('UIDropArea__Preview', className),
      style: {
        backgroundImage: 'url(' + preview + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('UIDropArea__DefaultPreview', className) },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: 'preview', src: __webpack_require__("HbAe"), alt: 'preview' })
    );
  }
};

var UIDropArea = function (_Component) {
  _inherits(UIDropArea, _Component);

  function UIDropArea() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, UIDropArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = UIDropArea.__proto__ || Object.getPrototypeOf(UIDropArea)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOpen = function (e) {
      e.preventDefault();
      _this.dropzone.open();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UIDropArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          preview = _props.preview,
          className = _props.className,
          previewClassName = _props.previewClassName,
          children = _props.children,
          _props$shouldRenderPr = _props.shouldRenderPreview,
          shouldRenderPreview = _props$shouldRenderPr === undefined ? true : _props$shouldRenderPr,
          _props$disabled = _props.disabled,
          disabled = _props$disabled === undefined ? false : _props$disabled;

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        'div',
        { className: 'UIDropAreaContainer' },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_dropzone___default.a,
          {
            ref: function ref(c) {
              return _this2.dropzone = c;
            },
            onDrop: onDrop,
            multiple: false,
            activeClassName: 'active',
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('UIDropArea', className),
            disabled: disabled
          },
          __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ImagePreview, { preview: preview, onClick: this.handleOpen, className: previewClassName, shouldRenderPreview: shouldRenderPreview }),
          children
        ),
        this.renderClear()
      );
    }
  }, {
    key: 'renderClear',
    value: function renderClear() {
      var _props2 = this.props,
          preview = _props2.preview,
          onClear = _props2.onClear,
          _props2$shouldRenderC = _props2.shouldRenderClear,
          shouldRenderClear = _props2$shouldRenderC === undefined ? true : _props2$shouldRenderC;

      if (preview && shouldRenderClear) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
          'a',
          { className: 'UIDropArea__Clear', onClick: onClear },
          'Clear'
        );
      }
    }
  }]);

  return UIDropArea;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

UIDropArea.propTypes = {
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  preview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (UIDropArea);

/***/ }),

/***/ "o59j":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 23\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Final\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Goal-Action-Route\" transform=\"translate(-417.000000, -443.000000)\" fill=\"#394F5A\"><g id=\"Group-5\" transform=\"translate(397.000000, 352.000000)\"><g id=\"team-hierarchy\" transform=\"translate(20.000000, 91.000000)\"><path d=\"M23.2091129,22.1216875 C23.2207258,22.1727188 23.2265323,22.226625 23.2265323,22.28125 C23.2265323,22.678 22.9020968,23 22.5014516,23 L22.4869355,23 L16.6841129,23 C16.2834677,23 15.9583065,22.678 15.9583065,22.28125 C15.9583065,20.8171563 16.8503226,19.558625 18.1212097,18.9994375 C17.2654839,18.4984687 16.6841129,17.5849375 16.6841129,16.53125 C16.6841129,14.9464063 17.9854839,13.65625 19.5851613,13.65625 C21.1855645,13.65625 22.4869355,14.9464063 22.4869355,16.53125 C22.4869355,17.586375 21.9041129,18.500625 21.0469355,19.000875 C22.2720968,19.5392187 23.1466935,20.7244375 23.2091129,22.1216875 Z M19.5851613,15.09375 C18.7853226,15.09375 18.135,15.7384688 18.135,16.53125 C18.135,17.3240313 18.7853226,17.96875 19.5851613,17.96875 C20.3857258,17.96875 21.0360484,17.3240313 21.0360484,16.53125 C21.0360484,15.7384688 20.3857258,15.09375 19.5851613,15.09375 Z M19.5851613,20.125 C18.6394355,20.125 17.8330645,20.725875 17.5333065,21.5625 L21.6370161,21.5625 C21.3379839,20.725875 20.5308871,20.125 19.5851613,20.125 Z M19.5851613,12.9375 C19.1852419,12.9375 18.8600806,12.6155 18.8600806,12.2180312 L12.3314516,12.2180312 C12.3314516,12.6155 12.0070161,12.9375 11.606371,12.9375 C11.2057258,12.9375 10.8805645,12.6155 10.8805645,12.2180312 L4.35266129,12.2180312 C4.35266129,12.6155 4.0275,12.9375 3.62685484,12.9375 C3.22620968,12.9375 2.90177419,12.6155 2.90177419,12.2180312 L2.90177419,11.5 C2.90177419,11.10325 3.22620968,10.78125 3.62685484,10.78125 L10.8805645,10.78125 C10.8805645,10.3845 11.2057258,10.0625 11.606371,10.0625 C12.0070161,10.0625 12.3314516,10.3845 12.3314516,10.78125 L19.5851613,10.78125 C19.9858065,10.78125 20.3109677,11.10325 20.3109677,11.5 L20.3109677,12.2180312 C20.3109677,12.6155 19.9858065,12.9375 19.5851613,12.9375 Z M14.5226613,9.34375 L14.5074194,9.34375 L8.70459677,9.34375 C8.30395161,9.34375 7.97951613,9.02175 7.97951613,8.625 C7.97951613,7.1601875 8.87080645,5.902375 10.1424194,5.3431875 C9.28669355,4.84221875 8.70459677,3.9286875 8.70459677,2.875 C8.70459677,1.2894375 10.0066935,0 11.606371,0 C13.2060484,0 14.5074194,1.2894375 14.5074194,2.875 C14.5074194,3.930125 13.9245968,4.844375 13.0674194,5.344625 C14.2925806,5.88296875 15.1671774,7.0681875 15.2295968,8.4654375 C15.2412097,8.51646875 15.2477419,8.56965625 15.2477419,8.625 C15.2477419,9.02175 14.9225806,9.34375 14.5226613,9.34375 Z M11.606371,1.4375 C10.8065323,1.4375 10.1554839,2.08221875 10.1554839,2.875 C10.1554839,3.66778125 10.8065323,4.3125 11.606371,4.3125 C12.4062097,4.3125 13.0572581,3.66778125 13.0572581,2.875 C13.0572581,2.08221875 12.4062097,1.4375 11.606371,1.4375 Z M11.606371,6.46875 C10.6606452,6.46875 9.85354839,7.069625 9.55451613,7.90625 L13.6582258,7.90625 C13.3584677,7.069625 12.5520968,6.46875 11.606371,6.46875 Z M6.52862903,16.53125 C6.52862903,17.586375 5.94580645,18.500625 5.08790323,19.000875 C6.31379032,19.5392187 7.1883871,20.7244375 7.25080645,22.1216875 C7.26241935,22.1727188 7.26822581,22.226625 7.26822581,22.28125 C7.26822581,22.678 6.94379032,23 6.54314516,23 L6.52862903,23 L0.725806452,23 C0.32516129,23 0,22.678 0,22.28125 C0,20.8171563 0.892016129,19.558625 2.16290323,18.9994375 C1.30717742,18.4984687 0.725806452,17.5849375 0.725806452,16.53125 C0.725806452,14.9464063 2.02717742,13.65625 3.62685484,13.65625 C5.22725806,13.65625 6.52862903,14.9464063 6.52862903,16.53125 Z M1.575,21.5625 L5.67870968,21.5625 C5.37967742,20.725875 4.57258065,20.125 3.62685484,20.125 C2.68112903,20.125 1.87475806,20.725875 1.575,21.5625 Z M2.17669355,16.53125 C2.17669355,17.3240313 2.82701613,17.96875 3.62685484,17.96875 C4.42741935,17.96875 5.07774194,17.3240313 5.07774194,16.53125 C5.07774194,15.7384688 4.42741935,15.09375 3.62685484,15.09375 C2.82701613,15.09375 2.17669355,15.7384688 2.17669355,16.53125 Z M10.1424194,18.9994375 C9.28669355,18.4984687 8.70459677,17.5849375 8.70459677,16.53125 C8.70459677,14.9464063 10.0066935,13.65625 11.606371,13.65625 C13.2060484,13.65625 14.5074194,14.9464063 14.5074194,16.53125 C14.5074194,17.586375 13.9245968,18.500625 13.0674194,19.000875 C14.2925806,19.5392187 15.1671774,20.7244375 15.2295968,22.1216875 C15.2412097,22.1727188 15.2477419,22.226625 15.2477419,22.28125 C15.2477419,22.678 14.9225806,23 14.5226613,23 L14.5074194,23 L8.70459677,23 C8.30395161,23 7.97951613,22.678 7.97951613,22.28125 C7.97951613,20.8171563 8.87080645,19.558625 10.1424194,18.9994375 Z M11.606371,15.09375 C10.8065323,15.09375 10.1554839,15.7384688 10.1554839,16.53125 C10.1554839,17.3240313 10.8065323,17.96875 11.606371,17.96875 C12.4062097,17.96875 13.0572581,17.3240313 13.0572581,16.53125 C13.0572581,15.7384688 12.4062097,15.09375 11.606371,15.09375 Z M13.6582258,21.5625 C13.3584677,20.725875 12.5520968,20.125 11.606371,20.125 C10.6606452,20.125 9.85354839,20.725875 9.55451613,21.5625 L13.6582258,21.5625 Z\" id=\"Shape\"></path></g></g></g></g></svg>"

/***/ }),

/***/ "o67s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o6GD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("rjNJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("H7wK");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "o6eF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_NotificationHelper__ = __webpack_require__("a56C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("7X7l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_tracking_actions__ = __webpack_require__("mMZi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var BellIcon = __webpack_require__("gfVV");

var EnableNotifications = function (_Component) {
  _inherits(EnableNotifications, _Component);

  function EnableNotifications(props) {
    _classCallCheck(this, EnableNotifications);

    var _this = _possibleConstructorReturn(this, (EnableNotifications.__proto__ || Object.getPrototypeOf(EnableNotifications)).call(this, props));

    _this.state = {
      closed: true,
      stage: 'initial'
    };

    _this.setClose = _this.setClose.bind(_this);
    _this.fuckOff = _this.fuckOff.bind(_this);
    _this.showConfirm = _this.showConfirm.bind(_this);
    _this.setOpen = _this.setOpen.bind(_this);
    _this.hideForSession = _this.hideForSession.bind(_this);
    _this.enableNotifications = _this.enableNotifications.bind(_this);
    _this.showInstructions = _this.showInstructions.bind(_this);
    return _this;
  }

  _createClass(EnableNotifications, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (window.sessionStorage && JSON.parse(!!!window.sessionStorage.getItem('hide-notifications-message'))) {
        setTimeout(this.setOpen, 5000);
      }
    }
  }, {
    key: 'hideForSession',
    value: function hideForSession() {
      this.props.actions.track('Browser Notifications Banner Dismissed Until Next Session');
      if (window.sessionStorage) {
        window.sessionStorage.setItem('hide-notifications-message', true);
      }

      this.setClose();
    }
  }, {
    key: 'showConfirm',
    value: function showConfirm() {
      this.props.actions.track('Browser Notifications Banner Dismissed');
      this.setState({ stage: 'confirm' });
    }
  }, {
    key: 'showInstructions',
    value: function showInstructions() {
      this.setState({ stage: 'instructions' });
    }
  }, {
    key: 'setClose',
    value: function setClose() {
      this.setState({ closed: true });
    }
  }, {
    key: 'setOpen',
    value: function setOpen() {
      this.setState({ closed: false });
    }
  }, {
    key: 'fuckOff',
    value: function fuckOff() {
      this.props.actions.track('Browser Notifications Banner Permanently Dismissed');
      this.setClose();
      window.localStorage.setItem(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* NEVER_SHOW */], true);
    }
  }, {
    key: 'sendTest',
    value: function sendTest() {
      var message = "Hey look!";
      var opts = {
        icon: __webpack_require__("W6a3"),
        tag: "",
        body: "You now will receive browser notifications 🚀"
      };
      var handle = function handle() {
        window.open('/inboxes');
      };
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_NotificationHelper__["g" /* showNotification */])(message, opts, handle);
      Object(__WEBPACK_IMPORTED_MODULE_6_utils_NotificationHelper__["h" /* soundNotification */])();
    }
  }, {
    key: 'enableNotifications',
    value: function enableNotifications() {
      var _this2 = this;

      this.showInstructions();
      this.props.actions.track('Enable Browser Notification Button Pressed', { stage: this.state.stage });
      Notification.requestPermission(function (permission) {
        if (permission === "granted") {
          _this2.sendTest();
          _this2.setClose();
          _this2.props.actions.track('Browser Notifications Enabled');
        } else if (permission === "denied") {
          _this2.props.actions.track('Browser Notifications Blocked');
        }
      });
    }
  }, {
    key: 'renderEnable',
    value: function renderEnable() {
      var showBar = !this.state.closed ? 'show-bar' : '';
      return React.createElement(
        'div',
        { className: 'global-notification-tease attention ' + showBar },
        React.createElement(
          'p',
          null,
          'Drift needs your permission to enable browser notifications'
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
          { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.enableNotifications },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { name: 'notification', width: 12 }),
          'Enable browser notifications'
        ),
        React.createElement(
          'div',
          { className: 'dismiss-notification', onClick: this.showConfirm },
          ' ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { name: 'close' }),
          ' '
        )
      );
    }
  }, {
    key: 'renderInstructions',
    value: function renderInstructions() {
      var showBar = !this.state.closed ? 'show-bar' : '';
      return React.createElement(
        'div',
        { className: 'global-notification-tease instruction ' + showBar },
        React.createElement(
          'p',
          null,
          'Click "Allow" in your browser\u2019s pop-up window to enable desktop notifications.'
        ),
        React.createElement(
          'div',
          { className: 'dismiss-notification', onClick: this.showConfirm },
          ' ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { name: 'close' }),
          ' '
        )
      );
    }
  }, {
    key: 'renderConfirm',
    value: function renderConfirm() {
      var showBar = !this.state.closed ? 'show-bar' : '';
      return React.createElement(
        'div',
        { className: 'global-notification-tease attention ' + showBar },
        React.createElement(
          'p',
          null,
          'We strongly recommend enabling desktop notifications if you\u2019ll be using Drift on this computer - we don\u2019t want you to miss any conversations!'
        ),
        React.createElement(
          'div',
          { className: 'notifications-dissmiss-actions' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.enableNotifications },
            'Enable desktop notifications'
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.hideForSession },
            'Ask me next time'
          ),
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', className: 'notification-button drift-button small', onClick: this.fuckOff },
            'Never ask again on this computer'
          )
        ),
        React.createElement(
          'div',
          { className: 'dismiss-notification', onClick: this.hideForSession },
          ' ',
          React.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { name: 'close' }),
          ' '
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      switch (this.state.stage) {
        case 'instructions':
          return this.renderInstructions();
        case 'confirm':
          return this.renderConfirm();
        default:
          return this.renderEnable();
      }
    }
  }]);

  return EnableNotifications;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      track: __WEBPACK_IMPORTED_MODULE_8_app_modules_tracking_actions__["track"]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(null, mapDispatchToProps))(EnableNotifications));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "o7yj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_RadioOption__ = __webpack_require__("dZQx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_OpenHoursHelper__ = __webpack_require__("4JBo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__ = __webpack_require__("ZDyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toggle__ = __webpack_require__("/gEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("NVJO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var WidgetModeSelector = function (_Component) {
  _inherits(WidgetModeSelector, _Component);

  function WidgetModeSelector(props) {
    _classCallCheck(this, WidgetModeSelector);

    var _this = _possibleConstructorReturn(this, (WidgetModeSelector.__proto__ || Object.getPrototypeOf(WidgetModeSelector)).call(this, props));

    _this.onManualModeSelected = _this.onManualModeSelected.bind(_this);
    _this.onAutomaticModeSelected = _this.onAutomaticModeSelected.bind(_this);

    _this.state = {
      widgetStatus: _this.props.embed.widgetStatus,
      widgetMode: _this.props.embed.widgetMode
    };
    return _this;
  }

  _createClass(WidgetModeSelector, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {

      if (_.isEqual(nextProps.embed, this.props.embed)) return;

      this.setState({
        widgetStatus: nextProps.embed.widgetStatus,
        widgetMode: nextProps.embed.widgetMode
      });
    }
  }, {
    key: 'checkIsOpenForBusiness',
    value: function checkIsOpenForBusiness() {
      var _props$embed$theme = this.props.embed.theme,
          timezone = _props$embed$theme.timezone,
          openHours = _props$embed$theme.openHours;

      return openHours && openHours.length == 0 || Object(__WEBPACK_IMPORTED_MODULE_3_utils_OpenHoursHelper__["a" /* areWeOpenForBusiness */])(timezone, openHours);
    }
  }, {
    key: 'checkIsOnline',
    value: function checkIsOnline() {
      var embed = this.props.embed;
      var widgetMode = embed.widgetMode,
          widgetStatus = embed.widgetStatus;


      if (widgetMode === __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].AUTO) {
        return this.checkIsOpenForBusiness();
      } else if (widgetMode === __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].MANUAL) {
        return widgetStatus === __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON;
      } else {
        return widgetStatus === __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON && this.checkIsOpenForBusiness();
      }
    }
  }, {
    key: 'onManualModeSelected',
    value: function onManualModeSelected() {
      var newWidgetStatus = this.checkIsOnline() ? __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON : __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].AWAY;

      this.updateWidgetState(newWidgetStatus, __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].MANUAL);
    }
  }, {
    key: 'onAutomaticModeSelected',
    value: function onAutomaticModeSelected() {
      this.updateWidgetState(__WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON, __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].AUTO);
    }
  }, {
    key: 'updateWidgetState',
    value: function updateWidgetState(newWidgetStatus, newWidgetMode) {
      var _state = this.state,
          widgetState = _state.widgetState,
          widgetStatus = _state.widgetStatus;


      var previousState = {
        widgetState: widgetState,
        widgetStatus: widgetStatus
      };
      var updatedState = {
        widgetStatus: newWidgetStatus,
        widgetMode: newWidgetMode
      };
      var changes = Object(__WEBPACK_IMPORTED_MODULE_5_utils_PatchHelper__["a" /* patchOperations */])(updatedState, previousState);

      this.setState({
        widgetStatus: newWidgetStatus,
        widgetMode: newWidgetMode
      });

      this.props.updateEmbed(changes);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          widgetStatus = _state2.widgetStatus,
          widgetMode = _state2.widgetMode;

      var isInAutoMode = widgetMode === __WEBPACK_IMPORTED_MODULE_4_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].AUTO;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8__style_styl___default.a.WidgetModeSelector },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_RadioOption__["a" /* default */],
          { selected: !isInAutoMode, onClick: this.onManualModeSelected },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'optionTitle' },
            'Manual'
          ),
          !isInAutoMode && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Toggle__["a" /* default */], { widgetMode: widgetMode, widgetStatus: widgetStatus, updateStatus: this.props.updateEmbed })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_RadioOption__["a" /* default */],
          {
            className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ selectorClearance: isInAutoMode }),
            selected: isInAutoMode,
            onClick: this.onAutomaticModeSelected },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'optionTitle' },
            'Automatic'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'optionDescription' },
            'Drift will automatically go online based on your team\u2019s schedule and availability.'
          )
        )
      );
    }
  }]);

  return WidgetModeSelector;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

WidgetModeSelector.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (WidgetModeSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "o9R1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o9mc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Goal":"Goal---1rRBa"};

/***/ }),

/***/ "oD5e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_MakeInputChangeHandler__ = __webpack_require__("0HTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_AssignDropdown_styl__ = __webpack_require__("NYrp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_styles_components_AssignDropdown_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_styles_components_AssignDropdown_styl__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.















var AssignDropdown = React.createClass({
  displayName: 'AssignDropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_MakeInputChangeHandler__["a" /* default */]],

  getInitialState: function getInitialState() {
    return {};
  },
  componentDidMount: function componentDidMount() {
    if (this.props.calendarUsersOnly) {
      return this.props.actions.fetchConnectedCalendars();
    }
  },
  handleUserRowOnClick: function handleUserRowOnClick(userId) {
    return this.props.handleUserRowOnClick(userId);
  },
  render: function render() {
    var _this = this;

    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_9_styles_components_AssignDropdown_styl___default.a.AssignDropdown },
      React.createElement(
        'div',
        { className: 'assign-header' },
        React.createElement(
          'div',
          { className: 'title' },
          this.props.handleClearAssignee ? this.props.assignee ? React.createElement(
            'div',
            { onClick: this.props.handleClearAssignee, className: 'clear-assignee' },
            'Clear Assignee'
          ) : 'Assign to someone' : this.props.title
        ),
        React.createElement('input', {
          type: 'text',
          autoFocus: true,
          placeholder: 'Search',
          onFocus: function onFocus(e) {
            return e.stopPropagation();
          },
          valueLink: {
            value: this.state.input,
            requestChange: this.makeInputChangeHandler('input')
          } })
      ),
      React.createElement(
        'div',
        { className: 'assignee-rows' },
        _.map(this.getUsersToDisplay(), function (user) {
          var isAssignee = (_this.props.assignee != null ? _this.props.assignee.id : undefined) === user.id;
          return React.createElement(
            'div',
            {
              className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('row', { 'is-assignee': isAssignee }),
              onClick: _this.handleUserRowOnClick.bind(_this, user.id) },
            React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Avatar__["a" /* default */], { user: user, selected: isAssignee }),
            React.createElement(
              'div',
              { className: 'name' },
              user.name || user.email
            ),
            isAssignee ? React.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, {
              className: 'selected-check-mark',
              src: __webpack_require__("gDdS") }) : undefined
          );
        })
      )
    );
  },
  getUsersToDisplay: function getUsersToDisplay() {
    var _this2 = this;

    var users = this.props.users;

    if (this.props.calendarUsersOnly) {
      users = _.filter(users, function (user) {
        return _this2.props.calendarUserIds != null ? _this2.props.calendarUserIds.contains(user.id) : undefined;
      });
    }
    if (this.state.input) {
      users = _.filter(users, function (value) {
        return _.includes(value.name != null ? value.name.toLowerCase() : undefined, _this2.state.input.toLowerCase());
      });
    }
    return users;
  }
});

var withCalendarUserIds = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function (state) {
  return {
    calendarUserIds: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["a" /* getAgentIdsWithConnectedCalendars */])(state),
    connectedCalendarsPending: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["u" /* isAgentIdsWithConnectedCalendarsPending */])(state)
  };
}, function (dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({ fetchConnectedCalendars: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["y" /* fetchConnectedCalendars */] }, dispatch)
  };
});

var withUsers = function withUsers(WrappedComponent) {
  return Marty.createContainer(WrappedComponent, {
    listenTo: ['stores.UserStore'],

    fetch: {
      users: function users() {
        return this.app.stores.UserStore.getOrFetchActiveUsersForCurrentUserOrg();
      }
    },

    failed: function failed(errors) {
      Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
      return React.createElement('div', null);
    }
  });
};

var AssignDropdownContainer = withUsers(withCalendarUserIds(AssignDropdown));

/* harmony default export */ __webpack_exports__["a"] = (AssignDropdownContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "oDAH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeaderBrand":"HeaderBrand---3ITr9"};

/***/ }),

/***/ "oFXL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oG2j":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 25 13\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.17 11.077A6.204 6.204 0 0 1 18.695 13a6.095 6.095 0 0 1-4.404-1.88.831.831 0 0 1 0-1.147.763.763 0 0 1 1.105 0c1.829 1.893 4.82 1.875 6.669-.04a4.92 4.92 0 0 0 1.373-3.436 4.916 4.916 0 0 0-1.373-3.434 4.577 4.577 0 0 0-6.621-.007c-.91 1.021-1.492 2.27-2.107 3.594-.69 1.485-1.405 3.02-2.648 4.407-.004.004-.009.004-.012.008-.004.004-.004.008-.008.012-1.18 1.223-2.75 1.898-4.419 1.898-1.67 0-3.238-.675-4.419-1.898A6.554 6.554 0 0 1 0 6.497c0-1.73.65-3.356 1.831-4.58A6.184 6.184 0 0 1 6.264 0h.045c1.67 0 3.23.665 4.4 1.878a.83.83 0 0 1 0 1.144.761.761 0 0 1-1.105 0 4.538 4.538 0 0 0-3.295-1.403h-.035a4.658 4.658 0 0 0-3.338 1.444 4.914 4.914 0 0 0-1.373 3.435c0 1.296.487 2.516 1.373 3.434a4.573 4.573 0 0 0 3.314 1.424c1.246 0 2.416-.501 3.3-1.41 1.08-1.206 1.74-2.625 2.379-3.999.64-1.378 1.303-2.804 2.381-4.007l.012-.008.008-.013a6.102 6.102 0 0 1 8.84 0A6.551 6.551 0 0 1 25 6.497c0 1.73-.65 3.357-1.83 4.58z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "oGG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__ = __webpack_require__("eUvQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PresenceTable__ = __webpack_require__("oYLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PresenceSidesheet__ = __webpack_require__("G4vU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_Subnav__ = __webpack_require__("Ivb/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_cache_live__ = __webpack_require__("BIem");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl__ = __webpack_require__("rOpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_utils_Access__ = __webpack_require__("6k1g");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }























var PRESENCE_INTERVAL = 20000;

var liveViewScreenshot = __webpack_require__("b9qL");
var BellIcon = __webpack_require__("gfVV");

var DEFAULT_PRESENCE_INTERVAL = 5000;
var PRESENCE_INTERVAL_KEY = 'presence-live-view-interval';

var ActionsAdmin = function ActionsAdmin() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'pr-gated-actions' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Button"],
      { type: 'primary', href: '/settings/billing' },
      'Upgrade Your Plan'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Button"],
      { type: 'subtle', href: 'https://help.drift.com/article/live-view/', target: '_blank' },
      'Learn More'
    )
  );
};

var ActionsRep = function ActionsRep() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'pr-gated-actions' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Button"],
      { type: 'subtle', href: 'https://help.drift.com/article/live-view/', target: '_blank' },
      'Learn More'
    )
  );
};

var PresenceNavigationTitle = function PresenceNavigationTitle(_ref) {
  var newLiveUsersCount = _ref.newLiveUsersCount;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'presence-title-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'presence-title-div' },
      'Live view (',
      newLiveUsersCount,
      ' online)'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["ToolTip"],
      { flow: 'down', render: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'presence-tool-tip-text' },
            'The Live view count is now more accurate! If visitors are in a Drift conversation or are not actively viewing your site, they will not be included in the total number of online visitors in the Live view count displayed.'
          );
        } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Icon"], { name: 'question', height: 14, width: 14 })
    )
  );
};

var rbacNodes = [{
  label: 'Activity',
  expanded: true,
  nodes: [{
    label: 'Account activity',
    expanded: false,
    path: __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__["c" /* APP_URL */] + '/activity'
  }]
}, {
  label: 'Accounts',
  expanded: true,
  nodes: [{
    label: 'Target accounts',
    expanded: false,
    path: __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__["c" /* APP_URL */] + '/activity/accounts'
  }]
}];

var liveViewNode = {
  label: 'Live view',
  expanded: false,
  path: '/live'
};

var RBACSubNav = function RBACSubNav() {
  __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].hasFeatures([{ featureName: 'prospector', accessLevel: 'READ' }]) && rbacNodes[0].nodes.push(liveViewNode);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_Subnav__["a" /* default */], { title: 'Activity', open: true, nodes: rbacNodes });
};

var Presence = function (_Component) {
  _inherits(Presence, _Component);

  function Presence(props) {
    _classCallCheck(this, Presence);

    var _this = _possibleConstructorReturn(this, (Presence.__proto__ || Object.getPrototypeOf(Presence)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      selectedUser: null,
      user: null,
      filters: props.filters,
      pause: false,
      accountMatchError: null,
      usersWithMessageSent: new Set()
    };

    _this.updateFilters = _.debounce(_this.props.actions.setFilters, 100);
    return _this;
  }

  _createClass(Presence, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var cachedFilters = Object(__WEBPACK_IMPORTED_MODULE_15_app_cache_live__["a" /* getFilters */])();
      var defaultFilters = { anonymousVisitors: true };
      var filters = cachedFilters || defaultFilters;

      this.props.actions.setNewFilters(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(_extends({}, this.props.query, filters)));

      this.setLiveViewUpdateAtFilterAndStartInterval();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actions.setProcessAllUsers(false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasProcessedUsers) {
        this.handleNoMatchAccount(nextProps);
      }
    }
  }, {
    key: 'renderGated',
    value: function renderGated() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pr-gate' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pr-gated-content' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Reach out and connect with leads while they\u2019re on your site.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'See who\u2019s online, follow important leads, and chat live\u2026'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Book more demos and close deals faster by reaching out to the people while they\u2019re on your website - not once they\u2019ve left. Unlock the power to follow users, get a notification and start a conversation while they\u2019re already here, live on your site.'
          ),
          Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_access_helpers__["a" /* ensureIsAdmin */])() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionsAdmin, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionsRep, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', {
            width: '390',
            height: '221',
            src: 'https://www.youtube.com/embed/I_1U0c9N-gE',
            frameBorder: '0',
            allowFullScreen: true
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: liveViewScreenshot })
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _props = this.props,
          users = _props.users,
          presenceLoading = _props.presenceLoading;

      var pauseVerb = this.state.pause ? 'Resume' : 'Pause';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        { className: 'presence-table-outer' },
        !!this.state.selectedUser && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PresenceSidesheet__["a" /* default */], {
          onClose: this.listenForSideBarClose,
          listenForMessageSent: this.listenForMessageSent,
          user: this.state.selectedUser,
          revealContext: this.props.revealContext
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'presence-table-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'pr-filter-bar' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'pr-filter-bar-checkboxes' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pr-filter-checkbox-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Input"], {
                  type: 'checkbox',
                  label: 'Include anonymous visitors',
                  onChange: this.handleShowAnonymousVisitorsChanged,
                  checked: this.props.newFilters.get('anonymousVisitors')
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'pr-filter-checkbox-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Input"], {
                  type: 'checkbox',
                  label: 'Show up to 250 visitors',
                  onChange: this.handleShow250Visitors,
                  checked: this.props.showMore
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["Button"],
              { onClick: this.togglePause },
              pauseVerb + ' live feed'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PresenceTable__["a" /* default */], {
            paused: this.state.pause,
            users: users,
            setPagination: this.props.actions.setPagination,
            userLoadCount: this.props.pagination.userLoadCount,
            setSelectedUser: this.setSelectedUser,
            handleStartConversationClick: this.handleStartConversationClick,
            companyInfoHandler: this.handleShowCompanyInfo(),
            presenceLoading: presenceLoading,
            hasReveal: this.props.hasReveal,
            hasLiveReveal: this.props.hasLiveReveal
          })
        )
      );
    }
  }, {
    key: 'renderNoMatchError',
    value: function renderNoMatchError() {
      var account = this.props.query.account;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'no-match-error' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Looks like ',
          account,
          ' is no longer on your site \uD83D\uDE41 We\u2019ll let you know the next time they come back.'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var accountMatchError = this.state.accountMatchError;
      var _props2 = this.props,
          gates = _props2.gates,
          presenceProblems = _props2.presenceProblems,
          newLiveUsersCount = _props2.newLiveUsersCount;

      var gateOrRender = gates.has_live_view && !gates.disabled_account || __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].isRbacUser() && __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].hasFeatures([{ featureName: 'prospector', accessLevel: 'READ' }]) ? this.renderTable() : this.renderGated();
      var hasAudiencesGate = __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].hasGates('AUDIENCE') && __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].isAdmin();

      var nodes = [{
        label: 'Audiences',
        hide: !hasAudiencesGate,
        path: '/audiences',
        external: true
      }, {
        label: 'CONTACTS',
        expanded: true,
        nodes: [{
          label: 'All contacts',
          path: '/contacts',
          external: true
        }, {
          label: 'Contact segments',
          path: '/contacts/segments',
          external: true
        }, {
          label: 'Import contacts',
          path: '/contacts/imports',
          external: true
        }, {
          label: 'Settings',
          path: '/contacts/contact-settings',
          external: true
        }]
      }, {
        label: 'ACCOUNTS',
        expanded: true,
        hide: !__WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].isAdmin(),
        nodes: [{
          label: 'All accounts',
          path: '/accounts',
          external: true
        }, {
          label: 'Account segments',
          path: '/accounts/segments',
          external: true
        }, {
          label: 'Import accounts',
          path: '/accounts/imports',
          external: true
        }]
      }, {
        label: 'Live view',
        path: '/live'
      }];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'page-presence-wrapper' },
        __WEBPACK_IMPORTED_MODULE_19_utils_Access__["c" /* default */].isRbacUser() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RBACSubNav, null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__shared_Subnav__["a" /* default */], { title: 'Visitors', open: true, nodes: nodes }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'page-presence' },
          !!accountMatchError && this.renderNoMatchError(),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'page-presence-title' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__driftt_tide_core_legacy__["NavigationHeader"], { title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PresenceNavigationTitle, { newLiveUsersCount: newLiveUsersCount }) })
          ),
          presenceProblems && gates.has_live_view && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            { className: 'presence-problems' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_svg_inline_react___default.a, { src: BellIcon }),
            'Sorry, it looks like we are experiencing some issues with live view right now. Please try again in a little while.'
          ),
          gateOrRender
        )
      );
    }
  }]);

  return Presence;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setLiveViewUpdateAtFilterAndStartInterval = function () {
    var _props3 = _this2.props,
        hasLiveViewFromReach = _props3.hasLiveViewFromReach,
        _props3$actions = _props3.actions,
        setNewFilters = _props3$actions.setNewFilters,
        getPresenceStateOnInterval = _props3$actions.getPresenceStateOnInterval;


    var updatedAtValue = hasLiveViewFromReach ? 'now-15m' : 'now-120s';
    setNewFilters(_this2.props.newFilters.set('updatedAt', updatedAtValue));
    getPresenceStateOnInterval(PRESENCE_INTERVAL);
  };

  this.setSelectedUser = function (user) {
    _this2.setState({
      selectedUser: user
    });
  };

  this.pause = function () {
    _this2.setState({
      pause: true
    });
  };

  this.start = function () {
    _this2.setState({
      pause: false
    });
  };

  this.togglePause = function () {
    var newPauseState = !_this2.state.pause;
    _this2.setState({
      pause: newPauseState
    });
  };

  this.setCustomInterval = function (_ref2) {
    var value = _ref2.value;

    _this2.props.actions.setCustomInterval(value);
    localStorage.setItem(PRESENCE_INTERVAL_KEY, value);
  };

  this.clearUserFromURI = function () {
    var q = _this2.props.query.q;

    _this2.props.router.replace({
      pathname: window.location.pathname,
      query: _extends({}, q),
      hash: window.location.hash
    });
  };

  this.handleNoMatchAccount = function (props) {
    var _props$query = props.query,
        user = _props$query.user,
        account = _props$query.account;

    if (!user) {
      return;
    }

    var cleanErrorAndURI = function cleanErrorAndURI() {
      setTimeout(function () {
        _this2.clearUserFromURI();
        _this2.setState({ accountMatchError: null });
      }, 5000);
    };

    var showOpenUser = user;
    var hasMatch = _this2.props.userByAnonId({ anonymousId: user });

    if (showOpenUser && !hasMatch) {
      _this2.setState({
        accountMatchError: {
          user: showOpenUser,
          account: account
        }
      }, cleanErrorAndURI);
    }
  };

  this.listenForSideBarClose = function () {
    _this2.setState({
      selectedUser: null
    }, _this2.clearUserFromURI);
  };

  this.listenForMessageSent = function (newUserId) {
    _this2.props.actions.messageSent(newUserId);
  };

  this.handleStartConversationClick = function (_ref3) {
    var user = _ref3.user;

    _this2.setState({
      startConversationModalOpen: true,
      user: user
    });
  };

  this.handleStartConversationModalClose = function () {
    _this2.setState({
      startConversationModalOpen: false,
      user: null
    });
  };

  this.handleShowCompanyInfo = function () {
    return {
      onShow: _this2.pause,
      onClose: _this2.start
    };
  };

  this.handleChangeFilters = function (e) {
    var q = e.target.value ? { q: e.target.value } : undefined;

    var _props$query2 = _this2.props.query,
        _previousValue = _props$query2.q,
        rest = _objectWithoutProperties(_props$query2, ['q']);

    _this2.props.router.replace({
      pathname: window.location.pathname,
      query: _extends({}, rest, q),
      hash: window.location.hash
    });

    var filters = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(e.target.value.split(', '));
    _this2.setState({ filters: filters }, function () {
      _this2.updateFilters(filters);
    });
  };

  this.handleToggleFilterKnownUsers = function () {
    var newValue = !_this2.props.filterKnownUsers;

    var _props$query3 = _this2.props.query,
        _previousValue = _props$query3.k,
        rest = _objectWithoutProperties(_props$query3, ['k']);

    var k = newValue ? { k: true } : undefined;

    _this2.props.router.replace({
      pathname: window.location.pathname,
      query: _extends({}, rest, k),
      hash: window.location.hash
    });

    _this2.props.actions.setFilterKnownUsers(newValue);
  };

  this.useNewFilters = function () {
    _this2.props.actions.cancelPresenceInterval();
    _this2.props.actions.getPresenceStateOnInterval(PRESENCE_INTERVAL);
  };

  this.handleShowAnonymousVisitorsChanged = function (value) {
    var anonymousVisitors = value ? value : undefined;
    var q = { anonymousVisitors: anonymousVisitors };

    Object(__WEBPACK_IMPORTED_MODULE_15_app_cache_live__["b" /* setFilters */])(q);

    _this2.props.router.replace({
      pathname: window.location.pathname,
      query: _extends({}, _this2.props.query, q),
      hash: window.location.hash
    });

    _this2.props.actions.setNewFilters(_this2.props.newFilters.set('anonymousVisitors', anonymousVisitors));

    _this2.useNewFilters();
  };

  this.handleShow250Visitors = function (value) {
    _this2.props.actions.setShowMore(!_this2.props.showMore);

    _this2.useNewFilters();
  };
};

var mapStateToProps = function mapStateToProps(state) {
  var users = __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getNewLiveUsers(state);
  var interval = parseInt(localStorage.getItem(PRESENCE_INTERVAL_KEY)) || DEFAULT_PRESENCE_INTERVAL;
  var reveal = Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state);

  return {
    users: users,
    newFilters: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getNewFilters(state),
    newLiveUsersCount: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getNewLiveUsersCount(state),
    newSorts: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getNewSorts(state),
    showMore: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getShowMore(state),
    filterKnownUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getFilterKnownUsers(state),
    pagination: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getPagination(state),
    presenceProblems: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getPresenceProblems(state),
    presenceLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getPresenceLoading(state),
    interval: interval,
    query: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_router_selectors__["a" /* getQueryParams */])(state).toJS(),
    hasProcessedUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getHasProcessedUsers(state),
    userByAnonId: function userByAnonId(props) {
      return __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["d" /* selectors */].getUserByAnonymousId(state, props);
    },
    revealContext: reveal,
    hasReveal: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])('hasReveal')(state),
    hasLiveReveal: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])('has_live_reveal')(state),
    hasLiveViewFromReach: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["u" /* makeHasGate */])('has_live_view_with_reach_events')(state),
    orgId: Object(__WEBPACK_IMPORTED_MODULE_16_app_modules_org_selectors__["orgId"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      setNewSorts: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setNewSorts,
      setNewFilters: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setNewFilters,
      setShowMore: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setShowMore,
      getPresenceStateOnInterval: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].getPresenceStateOnInterval,
      cancelPresenceInterval: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].cancelPresenceInterval,
      setFilters: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setFilters,
      setFilterKnownUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setFilterKnownUsers,
      setPagination: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setPagination,
      setProcessAllUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setProcessAllUsers,
      setCustomInterval: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setCustomInterval,
      bootstrapUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].bootstrapUser,
      setPresenceLoading: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].setPresenceLoading,
      messageSent: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence__["a" /* actions */].messageSent
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["h" /* withRouter */])(Presence)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "oHQn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg__ = __webpack_require__("fgsc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_minus_svg__ = __webpack_require__("3iND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_minus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_minus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("limV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);









var CQLBar = function CQLBar(_ref) {
  var selectedScore = _ref.selectedScore,
      handleSelectCql = _ref.handleSelectCql;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'cql-bar-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'cql-bar' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: handleSelectCql.bind(null, -1),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('cql-bar-option', { selected: selectedScore === -1 }),
          flow: 'up',
          tooltip: 'Unqualified'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-minus-icon', src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_minus_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: handleSelectCql.bind(null, 1),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('cql-bar-option', { selected: selectedScore === 1 }),
          flow: 'up',
          tooltip: 'Good CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: handleSelectCql.bind(null, 2),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('cql-bar-option', { selected: selectedScore === 2 }),
          flow: 'up',
          tooltip: 'Better CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          is: true,
          onClick: handleSelectCql.bind(null, 3),
          'class': __WEBPACK_IMPORTED_MODULE_1_classnames___default()('cql-bar-option', { selected: selectedScore === 3 }),
          flow: 'up',
          tooltip: 'Best CQL'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { className: 'cql-bar-bolt-icon', src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_bolt_svg___default.a })
      )
    )
  );
};
/* harmony default export */ __webpack_exports__["a"] = (CQLBar);

/***/ }),

/***/ "oIkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var UserPropertiesActions = Marty.createActionCreators({
  updateProperties: function updateProperties(userId, properties, notificationMessage) {
    return this.app.queries.UserPropertiesQueries.updateProperties(userId, properties, notificationMessage);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserPropertiesActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "oMU9":
/***/ (function(module, exports) {

module.exports = "<svg width=\"31\" height=\"26\" viewBox=\"0 0 31 26\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27.125 15.428v6.696a.955.955 0 0 1-.49.832.984.984 0 0 1-.978-.012L16.2 17.34H7.75v7.653c0 .53-.434.958-.97.958a.963.963 0 0 1-.968-.957V17.34H1.938C.87 17.34 0 16.484 0 15.43V7.776C0 6.72.87 5.862 1.938 5.862H16.2L25.658.26a.977.977 0 0 1 .977-.01c.303.168.49.485.49.83v6.696c2.138 0 3.876 1.717 3.876 3.827s-1.738 3.825-3.875 3.825zM5.812 7.776H1.938v7.652h3.875V7.776zM25.188 2.77l-8.22 4.87c-.02.01-.042.01-.062.022a.95.95 0 0 1-.182.063.986.986 0 0 1-.19.038c-.022 0-.04.013-.064.013H7.75v7.652h8.72c.02 0 .04.012.063.013.065.006.127.022.19.04a.963.963 0 0 1 .182.062c.02.01.042.01.063.022l8.22 4.872V2.77zm1.938 6.92v3.826c1.07 0 1.938-.86 1.938-1.913 0-1.055-.87-1.914-1.938-1.914z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "oNNb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(505);

/***/ }),

/***/ "oRkD":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 295 39\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#3E3D3A\" fill-rule=\"evenodd\"><path d=\"M133.42 34.88h-.593c-3.047 0-3.47-.76-3.47-4.654V11.86h4.063c8.802 0 10.41 6.43 10.41 11.425 0 5.163-1.608 11.596-10.41 11.596zM97.703 23.116V11.86h3.47c3.81 0 5.502 2.623 5.502 5.67 0 2.962-1.693 5.585-5.502 5.585h-3.47zM133.166 9.32h-15.15v1.608c4.74 0 5.5 1.015 5.5 7.025v10.834c0 6.01-.76 7.11-5.5 7.11-3.64-.508-6.094-2.455-9.48-6.18l-3.892-4.23c5.247-.932 8.04-4.233 8.04-7.958 0-4.655-3.978-8.21-11.426-8.21H86.36v1.608c4.74 0 5.502 1.015 5.502 7.025v10.834c0 6.01-.76 7.11-5.5 7.11v1.607h16.842v-1.607c-4.74 0-5.5-1.1-5.5-7.11V25.74h1.438l9.394 11.764h24.63c12.104 0 17.35-6.432 17.35-14.135 0-7.702-5.246-14.05-17.35-14.05zM39.22 26.248L45.06 8.98c1.693-4.993.93-6.43-4.486-6.43V.854h15.913V2.55c-5.332 0-6.602 1.268-8.718 7.447l-9.65 28.946h-1.1L28.386 12.45l-8.802 26.493h-1.1L9.09 9.997C7.057 3.817 5.702 2.55.793 2.55V.854h18.79V2.55c-4.994 0-6.348 1.183-4.57 6.43l5.67 17.268L29.234.855h1.607l8.38 25.393zM67.995 10.844c-7.786 0-10.495 7.024-10.495 12.525 0 5.586 2.71 12.527 10.495 12.527 7.872 0 10.58-6.94 10.58-12.528 0-5.502-2.708-12.526-10.58-12.526m0 27.76c-9.31 0-16.928-6.855-16.928-15.235 0-8.295 7.618-15.15 16.928-15.15s16.928 6.855 16.928 15.15c0 8.38-7.617 15.235-16.928 15.235M169.56 3.902h-4.825V18.63h4.824c4.74 0 6.94-3.3 6.94-7.28 0-4.06-2.2-7.448-6.94-7.448m1.86 31.91v1.692h-19.38V35.81c5.67 0 6.686-1.437 6.686-9.902v-13.54c0-8.466-1.016-9.82-6.687-9.82V.855h17.52c8.717 0 13.542 4.486 13.542 10.496 0 5.84-4.825 10.41-13.543 10.41h-4.825v4.148c0 8.465 1.015 9.903 6.686 9.903M196.39 23.115V11.86h3.47c3.808 0 5.502 2.622 5.502 5.67 0 2.962-1.694 5.585-5.502 5.585h-3.47zm44.856 6.434l-.422 1.522c-.762 2.793-1.694 3.81-7.703 3.81h-1.184c-4.4 0-5.162-1.017-5.162-7.027v-3.892c6.6 0 7.11.59 7.11 4.993h1.608V16.344h-1.61c0 4.402-.507 4.994-7.108 4.994v-9.48h4.654c6.01 0 6.94 1.017 7.702 3.81l.424 1.607h1.354l-.592-7.955h-24.884v1.607c4.74 0 5.5 1.016 5.5 7.026v10.834c0 5.497-.646 6.882-4.383 7.08-3.553-.543-5.99-2.48-9.327-6.15l-3.894-4.23c5.248-.933 8.04-4.233 8.04-7.958 0-4.655-3.977-8.21-11.425-8.21h-14.897v1.607c4.74 0 5.5 1.016 5.5 7.026v10.834c0 6.01-.76 7.11-5.5 7.11v1.607h16.843v-1.608c-4.738 0-5.5-1.1-5.5-7.11V25.74h1.438l9.395 11.764h34.785l.508-7.955h-1.27zM258.428 38.605c-3.386 0-6.35-1.777-7.618-2.878-.423.424-1.185 1.693-1.354 2.878h-1.608v-11.68h1.692c.678 5.585 4.57 8.887 9.565 8.887 2.708 0 4.91-1.523 4.91-4.062 0-2.2-1.948-3.895-5.418-5.502l-4.824-2.286c-3.386-1.608-5.925-4.4-5.925-8.126 0-4.062 3.81-7.53 9.057-7.53 2.793 0 5.162 1.014 6.6 2.2.424-.34.847-1.27 1.102-2.287l1.607-.002v9.99h-1.777c-.593-3.98-2.793-7.28-7.28-7.28-2.37 0-4.57 1.354-4.57 3.47 0 2.2 1.778 3.386 5.84 5.247l4.655 2.285c4.064 1.947 5.67 5.08 5.67 7.62 0 5.33-4.654 9.055-10.324 9.055M284.495 38.605c-3.386 0-6.35-1.777-7.618-2.878-.423.424-1.185 1.693-1.354 2.878h-1.608v-11.68h1.692c.678 5.585 4.57 8.887 9.565 8.887 2.708 0 4.91-1.523 4.91-4.062 0-2.2-1.948-3.895-5.418-5.502l-4.824-2.286c-3.386-1.608-5.925-4.4-5.925-8.126 0-4.062 3.81-7.53 9.057-7.53 2.793 0 5.162 1.014 6.6 2.2.424-.34.847-1.27 1.1-2.287l1.61-.002v9.99h-1.778c-.593-3.98-2.793-7.28-7.28-7.28-2.37 0-4.57 1.354-4.57 3.47 0 2.2 1.778 3.386 5.84 5.247l4.655 2.285c4.063 1.947 5.67 5.08 5.67 7.62 0 5.33-4.655 9.055-10.325 9.055\"></path></g></svg>"

/***/ }),

/***/ "oRn6":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 30 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M29.675 8.58l-4.95 7a.994.994 0 0 1-.724.416l-.085.004a.99.99 0 0 1-.7-.29l-3.017-3a1.003 1.003 0 0 1-.007-1.414.994.994 0 0 1 1.41-.006l2.182 2.17 4.27-6.04a.995.995 0 0 1 1.388-.236c.448.32.554.945.235 1.395zM13.753 13.4c4.08 1.17 7.145 4.786 7.145 8.934V23c0 .552-.445 1-.995 1H1.98a.997.997 0 0 1-.995-1v-.666c0-4.148 3.067-7.764 7.146-8.934A7.008 7.008 0 0 1 3.973 7c0-3.86 3.127-7 6.97-7s6.97 3.14 6.97 7a7.007 7.007 0 0 1-4.16 6.4zM2.985 22h15.913c-.196-3.827-3.76-7-7.956-7-4.196 0-7.76 3.173-7.957 7zm7.957-20C8.197 2 5.964 4.243 5.964 7s2.233 5 4.978 5c2.745 0 4.978-2.243 4.978-5s-2.233-5-4.978-5z\" fill=\"#0176FF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "oSV7":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.15 20.16H.85a.845.845 0 0 1-.85-.84v-.56c0-3.485 2.618-6.521 6.1-7.504-2.088-.914-3.55-2.978-3.55-5.376C2.55 2.638 5.219 0 8.5 0s5.95 2.638 5.95 5.88c0 2.398-1.462 4.462-3.55 5.376 3.482.983 6.1 4.02 6.1 7.504v.56c0 .464-.38.84-.85.84zm-3.4-14.28c0-2.316-1.907-4.2-4.25-4.2s-4.25 1.884-4.25 4.2c0 2.316 1.907 4.2 4.25 4.2s4.25-1.884 4.25-4.2zM8.5 12.6c-3.583 0-6.625 2.665-6.792 5.88h13.584c-.167-3.215-3.21-5.88-6.792-5.88z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "oThQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchEmbed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchEmbedById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchEmbedPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchEmbedFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchEmbedSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return patchEmbedSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return patchEmbedError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return patchEmbedPending; });
/* unused harmony export embedDataAdded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return patchEmbed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("rrQF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_embed_api__ = __webpack_require__("1Ihb");




var fetchEmbed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_EMBED */]);
var fetchEmbedById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_EMBED_BY_ID */]);
var fetchEmbedPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_EMBED_PENDING */]);
var fetchEmbedFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_EMBED_FAILED */]);
var fetchEmbedSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_EMBED_SUCCESS */]);

var patchEmbedSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* PATCH_EMBED_SUCCESS */]);
var patchEmbedError = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* PATCH_EMBED_ERROR */]);
var patchEmbedPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* PATCH_EMBED_PENDING */]);

var embedDataAdded = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* EMBED_DATA_ADDED */]);

var patchEmbed = function patchEmbed(changes) {
  return function (dispatch) {
    dispatch(patchEmbedPending());

    __WEBPACK_IMPORTED_MODULE_2_app_modules_embed_api__["a" /* api */].updateEmbedSettings(changes).then(function (response) {
      dispatch(patchEmbedSuccess(response));
    });
  };
};

/***/ }),

/***/ "oTiO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marty__ = __webpack_require__("y6Nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_Helpers__ = __webpack_require__("1BrH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__("CIox");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var MartyApp = function (_Component) {
  _inherits(MartyApp, _Component);

  function MartyApp() {
    _classCallCheck(this, MartyApp);

    return _possibleConstructorReturn(this, (MartyApp.__proto__ || Object.getPrototypeOf(MartyApp)).apply(this, arguments));
  }

  _createClass(MartyApp, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          app = _props.app,
          history = _props.history,
          routes = _props.routes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_marty__["ApplicationContainer"],
        { app: app },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router__["f" /* Router */], { history: history, routes: routes })
      );
    }
  }]);

  return MartyApp;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var AppContainer = function (_Component2) {
  _inherits(AppContainer, _Component2);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.__DRIFT__recordBootstrapCheckpoint('AppContainer.componentDidMount');
      Object(__WEBPACK_IMPORTED_MODULE_3_app_Helpers__["c" /* installWidgetStub */])();
      Object(__WEBPACK_IMPORTED_MODULE_3_app_Helpers__["d" /* waitForUserJwt */])();
      Object(__WEBPACK_IMPORTED_MODULE_3_app_Helpers__["b" /* installSegment */])();
      Object(__WEBPACK_IMPORTED_MODULE_3_app_Helpers__["a" /* hideWelcomeMessage */])();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          app = _props2.app,
          history = _props2.history,
          store = _props2.store,
          routes = _props2.routes;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],
        { store: store },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MartyApp, { app: app,
          history: history,
          routes: routes })
      );
    }
  }]);

  return AppContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AppContainer);

/***/ }),

/***/ "oYJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SEGMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SEGMENTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_SEGMENTS_FAILED; });
/* unused harmony export FETCH_SEGMENTS_CANCELLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SEGMENTS_SUCCESS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('endUser/segments');

var FETCH_SEGMENTS = makeConstant('FETCH_SEGMENTS');
var FETCH_SEGMENTS_PENDING = makeConstant('FETCH_SEGMENTS_PENDING');
var FETCH_SEGMENTS_FAILED = makeConstant('FETCH_SEGMENTS_FAILED');
var FETCH_SEGMENTS_CANCELLED = makeConstant('FETCH_SEGMENTS_CANCELLED');
var FETCH_SEGMENTS_SUCCESS = makeConstant('FETCH_SEGMENTS_SUCCESS');

/***/ }),

/***/ "oYLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_flip_move__ = __webpack_require__("2MBs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_flip_move___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_flip_move__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_presence_constants__ = __webpack_require__("a2hK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PresenceFiltersRow__ = __webpack_require__("XUE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NewPresenceRow__ = __webpack_require__("r17Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("NNVj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var PRESENCE_COLUMNS_NEW_LIVE_REVEAL = [{ label: 'Action' }, { label: 'Contact' }, { label: 'Account', filter: true, filterPlaceholder: 'Account...', filterProperty: 'company.name' }, { label: 'Current page', filter: true, filterPlaceholder: 'Page...', filterProperty: 'page.url' }, { label: 'Time on site' }, { label: 'Location', filter: true, filterPlaceholder: 'Location...', filterProperty: 'location' }];

var PRESENCE_COLUMNS_NEW_LIVE_NO_REVEAL = [{ label: 'Action' }, { label: 'Contact' }, { label: 'Current page', filter: true, filterPlaceholder: 'Page...', filterProperty: 'page.url' }, { label: 'Time on site' }, { label: 'Location', filter: true, filterPlaceholder: 'Location...', filterProperty: 'location' }];

var PresenceTable = function (_Component) {
  _inherits(PresenceTable, _Component);

  function PresenceTable(props) {
    _classCallCheck(this, PresenceTable);

    var _this = _possibleConstructorReturn(this, (PresenceTable.__proto__ || Object.getPrototypeOf(PresenceTable)).call(this, props));

    _this.renderColumnHeadings = function () {
      return _.map(_this.state.tableColumns, function (_ref) {
        var label = _ref.label;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'th',
          { key: label },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            label
          )
        );
      });
    };

    _this.isUserDisabled = function (user) {
      if (!!user.metasByRef) {
        status = user.metasByRef.first().phx_status;
        return status === __WEBPACK_IMPORTED_MODULE_4_app_modules_presence_constants__["k" /* PhoenixStatus */].DISCONNECTED;
      } else {
        return false;
      }
    };

    _this.hasFilters = function () {
      return _this.state.tableColumns.find(function (tc) {
        return tc.filter;
      });
    };

    _this.renderUserRows = function () {
      var handleStartConversationClick = _this.props.handleStartConversationClick;
      var _this$state = _this.state,
          users = _this$state.users,
          hasReveal = _this$state.hasReveal;


      if (users.length) {
        return users.map(function (user) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__NewPresenceRow__["a" /* default */], {
            user: _this.props.paused && _this.isUserDisabled(user) ? user.set('className', 'pr-user-disabled') : user,
            setSelectedUser: _this.props.setSelectedUser,
            onStartConversationClick: handleStartConversationClick,
            key: user.id,
            hasReveal: hasReveal,
            hasLiveReveal: _this.props.hasLiveReveal
          });
        });
      }
    };

    _this.state = {
      users: props.users.toArray(),
      hasReveal: props.hasReveal,
      tableColumns: PRESENCE_COLUMNS_NEW_LIVE_NO_REVEAL
    };
    return _this;
  }

  _createClass(PresenceTable, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !this.props.paused && !nextProps.paused;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.users.equals(this.props.users)) {
        this.setState({
          users: nextProps.users.toArray()
        });
      }

      if (nextProps.hasLiveReveal) {
        this.setState({
          tableColumns: PRESENCE_COLUMNS_NEW_LIVE_REVEAL
        });
      }
    }
  }, {
    key: 'renderZeroState',
    value: function renderZeroState() {
      if (this.state.users.length) {
        return;
      }

      var shouldShowLoadingState = this.props.presenceLoading;

      if (!this.state.users.length && shouldShowLoadingState) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'presence-zero-state loading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'Loading up your live view'
          )
        );
      }

      //empty state no one online
      // if (!this.state.users.length && !this.props.counts.known && !shouldShowLoadingState) {
      if (!this.state.users.length && !shouldShowLoadingState) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'presence-zero-state' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'cw-empty-search' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'No one\'s live on your site right now.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Try adjusting your filters or head over to ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            ' conversations to see who\'s chatting.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
            { to: '/inboxes', className: 'drift-button' },
            'View conversations'
          )
        );
      }

      //empty state from filters
      if (this.props.counts.online && !this.state.users.length && !shouldShowLoadingState) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'presence-zero-state' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: 'cw-empty-search' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'These don\'t seem like the results you\'re looking for.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'It looks like no one matched what you searched for. ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            ' Don\'t worry though, update your search terms and',
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            ' try again!'
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.renderZeroState(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'drift-table pr-table', ref: 'prTable' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              this.renderColumnHeadings()
            ),
            this.hasFilters() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PresenceFiltersRow__["a" /* default */], { tableColumns: this.state.tableColumns })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_flip_move___default.a,
            {
              easing: 'ease',
              enterAnimation: 'none',
              leaveAnimation: 'none',
              typeName: 'tbody',
              staggerDurationBy: 15,
              staggerDelayBy: 20,
              duration: 700,
              delay: 0
            },
            this.renderUserRows()
          )
        )
      );
    }
  }]);

  return PresenceTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PresenceTable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "oaJS":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.94 9.22l-3.44 3.5c-.38.4-1 .4-1.4 0-.37-.4-.37-1.02 0-1.42l3.45-3.5c.64-.63 1-1.5 1-2.4 0-.9-.36-1.77-1-2.42-1.27-1.3-3.48-1.3-4.75 0l-5.03 5.1c-1.3 1.35-1.3 3.5 0 4.84.17.18.36.33.57.47.46.3.6.9.3 1.37-.2.3-.5.46-.83.46-.18 0-.36-.05-.52-.16-.33-.2-.63-.46-.9-.74-2.08-2.1-2.08-5.54 0-7.65l5.03-5.1c1.02-1.03 2.35-1.6 3.78-1.6 1.42 0 2.76.57 3.76 1.6 1 1 1.56 2.37 1.56 3.82 0 1.44-.55 2.8-1.56 3.82zM7.7 21l5.02-5.12c.64-.64 1-1.5 1-2.4 0-.93-.36-1.78-1-2.43-.17-.17-.35-.32-.54-.45-.46-.3-.58-.92-.3-1.38.3-.46.92-.6 1.37-.3.3.2.6.45.86.72 1.02 1.02 1.57 2.38 1.57 3.83 0 1.44-.55 2.8-1.56 3.82L9.1 22.4C8.04 23.47 6.68 24 5.3 24c-1.35 0-2.7-.54-3.75-1.6-2.08-2.1-2.08-5.54 0-7.65l3.42-3.48c.4-.4 1-.4 1.4 0 .38.4.38 1.02 0 1.4l-3.43 3.5c-.64.64-1 1.5-1 2.4 0 .92.36 1.78 1 2.42 1.3 1.32 3.44 1.32 4.75 0z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "oaic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oava":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseButton__ = __webpack_require__("xmq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("NiPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("OAum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);







var SubmittedEmailCapturePlaybookPreview = function SubmittedEmailCapturePlaybookPreview(_ref) {
  var title = _ref.title,
      message = _ref.message,
      fontFamily = _ref.fontFamily;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'email-capture-playbook-preview--root', style: { fontFamily: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* FontFamilies */][fontFamily] } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'submitted-email-capture-playbook-preview--header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'submitted-email-capture-playbook-preview--header-text' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'email-capture-playbook-preview--title' },
          title
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CloseButton__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'email-capture-playbook-preview--description', dangerouslySetInnerHTML: { __html: message } })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SubmittedEmailCapturePlaybookPreview);

/***/ }),

/***/ "okxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloseButton__ = __webpack_require__("xmq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("NiPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("OAum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);








var UnsubmittedEmailCapturePlaybookPreview = function UnsubmittedEmailCapturePlaybookPreview(_ref) {
  var title = _ref.title,
      message = _ref.message,
      previewUser = _ref.previewUser,
      fontFamily = _ref.fontFamily;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'email-capture-playbook-preview--root', style: { fontFamily: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* FontFamilies */][fontFamily] } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'unsubmitted-email-capture-playbook-preview--header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'unsubmitted-email-capture-playbook-preview--header-text' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'email-capture-playbook-preview--title' },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__["a" /* AvatarCompat */], { size: 'medium', user: previewUser })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CloseButton__["a" /* default */], null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'email-capture-playbook-preview--description', dangerouslySetInnerHTML: { __html: message } })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'unsubmitted-email-capture-playbook-preview--input' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        'Email address'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (UnsubmittedEmailCapturePlaybookPreview);

/***/ }),

/***/ "olQZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Action":"Action---3_Efl"};

/***/ }),

/***/ "om6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("rpEm");
var _handleActions2, _handleActions3, _handleActions4;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var currentUpdateRequestId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* requestBulkUpdate */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* requestBulkUpdateFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* requestBulkUpdateSuccess */]), function (state, action) {
  var updateRequestId = action.payload.updateRequestId;

  return updateRequestId;
}), null);

var updateRequestsById = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* requestBulkUpdate */], __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* receiveBulkUpdate */]), function (state, action) {
  var _action$payload = action.payload,
      updateRequestId = _action$payload.updateRequestId,
      inboxId = _action$payload.inboxId,
      updaterId = _action$payload.updaterId,
      conversationIds = _action$payload.conversationIds,
      conversationStatus = _action$payload.conversationStatus;


  if (state.get(updateRequestId)) {
    return state;
  }

  var bulkUpdateRequest = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
    id: updateRequestId,
    inboxId: inboxId,
    updaterId: updaterId,
    conversationIds: conversationIds,
    conversationStatus: conversationStatus
  })();

  return state.set(updateRequestId, bulkUpdateRequest);
}), _defineProperty(_handleActions2, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* requestBulkUpdateSuccess */] // Use server-generated ID
), function (state, action) {
  var _action$payload2 = action.payload,
      tempUpdateRequestId = _action$payload2.tempUpdateRequestId,
      updateRequestId = _action$payload2.updateRequestId;


  var bulkUpdateRequest = state.get(tempUpdateRequestId).set('id', updateRequestId);

  return state.delete(tempUpdateRequestId).set(updateRequestId, bulkUpdateRequest);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var statusByUpdateRequestId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions3 = {}, _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* requestBulkUpdatePending */], __WEBPACK_IMPORTED_MODULE_3__actions__["f" /* requestBulkUpdateFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["c" /* receiveBulkUpdatePending */], __WEBPACK_IMPORTED_MODULE_3__actions__["b" /* receiveBulkUpdateFailed */], __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* receiveBulkUpdateSuccess */]), function (state, action) {
  var updateRequestId = action.payload.updateRequestId;

  return state.set(updateRequestId, action.type);
}), _defineProperty(_handleActions3, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* requestBulkUpdateSuccess */] // Use server-generated ID
), function (state, action) {
  var _action$payload3 = action.payload,
      tempUpdateRequestId = _action$payload3.tempUpdateRequestId,
      updateRequestId = _action$payload3.updateRequestId;

  return state.delete(tempUpdateRequestId).set(updateRequestId, action.type);
}), _handleActions3), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var updateRequestIdsByInboxId = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions4 = {}, _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* requestBulkUpdate */], __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* receiveBulkUpdate */]), function (state, action) {
  var _action$payload4 = action.payload,
      inboxId = _action$payload4.inboxId,
      updateRequestId = _action$payload4.updateRequestId;

  return state.update(inboxId, function (updateRequestIds) {
    return (updateRequestIds || Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])()).add(updateRequestId);
  });
}), _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_3__actions__["h" /* requestBulkUpdateSuccess */] // Use server-generated ID
), function (state, action) {
  var _action$payload5 = action.payload,
      inboxId = _action$payload5.inboxId,
      tempUpdateRequestId = _action$payload5.tempUpdateRequestId,
      updateRequestId = _action$payload5.updateRequestId;


  return state.update(inboxId, function (updateRequestIds) {
    return updateRequestIds.delete(tempUpdateRequestId).add(updateRequestId);
  });
}), _handleActions4), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  currentUpdateRequestId: currentUpdateRequestId,
  updateRequestsById: updateRequestsById,
  statusByUpdateRequestId: statusByUpdateRequestId,
  updateRequestIdsByInboxId: updateRequestIdsByInboxId
}));

/***/ }),

/***/ "or1p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return org; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return orgUI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("CR44");
var _handleActions, _handleActions2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var org = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["fetchOrgStarted"], __WEBPACK_IMPORTED_MODULE_2__actions__["fetchOrgFailed"], __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrg"]), function (state, action) {
  return state.setIn(['status', 'fetch'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["updateOrgStarted"], __WEBPACK_IMPORTED_MODULE_2__actions__["updateOrgFailed"], __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrg"]), function (state, action) {
  return state.setIn(['status', 'update'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["createOrgStarted"], __WEBPACK_IMPORTED_MODULE_2__actions__["createOrgFailed"], __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrg"]), function (state, action) {
  return state.setIn(['status', 'create'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["fetchEndUserCountSuccess"], function (state, action) {
  return state.set('endUserCount', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrg"], function (state, action) {
  return state.set('data', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrgProperties"], function (state, action) {
  return state.setIn(['data', 'properties'], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrgCutover"], function (state, action) {
  return state.setIn([action.meta], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__actions__["hasLimitedContactsMktEmailSuccess"], function (state, action) {
  return state.setIn(['hasLimitedContactsMktEmail'], action.payload['HAS_LIMITED_CONTACTS_MKTING_EMAIL']);
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

var orgUI = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_2__actions__["setOrgHandleUI"], function (state, action) {
  var handle = action.payload.handle;

  return state.setIn(['data', 'handle'], handle);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_2__actions__["receiveOrgHandleExistence"], function (state, action) {
  return state.setIn(['valid', 'handle'], action.payload.valid);
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());

/***/ }),

/***/ "orkc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("8COE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);




var WarningModal = function WarningModal(_ref) {
  var handleCloseModal = _ref.handleCloseModal,
      handleDisconnect = _ref.handleDisconnect;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_components_shared_Modal__["a" /* default */],
    { onClose: handleCloseModal, isOpen: true, style: { content: { padding: 0, width: 450 } } },
    React.createElement(
      'div',
      { className: 'settings-calendar-warning-modal-content' },
      React.createElement(
        'div',
        { className: 'topper' },
        React.createElement(
          'div',
          { className: 'header' },
          'Are you sure you want to lift the limit?'
        ),
        React.createElement(
          'div',
          { className: 'copy' },
          'Lifting the limit on sequences means your team will be able to send more emails through their Gmail account, potentially putting your sender score at risk.'
        )
      ),
      React.createElement(
        'div',
        { className: 'controls' },
        React.createElement(
          'button',
          { className: 'tide-button tide-button--tertiary', onClick: handleCloseModal },
          'Cancel'
        ),
        React.createElement(
          'button',
          { className: 'tide-button tide-button--danger', onClick: handleDisconnect },
          'I Understand'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (WarningModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "otDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var TagAPI = Marty.createStateSource({
  id: 'TagAPI',
  type: 'http',

  fetchTagsForOrgId: function fetchTagsForOrgId(orgId) {
    return this.get({
      url: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/tags',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createTagForOrgId: function createTagForOrgId(orgId, tagParams) {
    return this.post({
      url: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/tags',
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(tagParams)
    });
  },
  updateTagForOrgId: function updateTagForOrgId(orgId, tagId, tagParams) {
    return this.patch({
      url: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/tags/' + tagId,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(tagParams)
    });
  },
  deleteTagForOrgId: function deleteTagForOrgId(orgId, tagId) {
    return this.delete({
      url: __WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/organizations/' + orgId + '/tags/' + tagId,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  addTagsToConversationId: function addTagsToConversationId(conversationId, tagIds) {
    return this.addTagsToURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["i" /* CONVERSATION_API */] + '/conversations/' + conversationId + '/tags', tagIds);
  },
  removeTagsFromConversationId: function removeTagsFromConversationId(conversationId, tagIds) {
    return this.removeTagsFromURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["i" /* CONVERSATION_API */] + '/conversations/' + conversationId + '/tags', tagIds);
  },
  addTagsToCompanyId: function addTagsToCompanyId(companyId, tagIds) {
    return this.addTagsToURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/companies/' + companyId + '/tags', tagIds);
  },
  removeTagsFromCompanyId: function removeTagsFromCompanyId(companyId, tagIds) {
    return this.removeTagsFromURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/companies/' + companyId + '/tags', tagIds);
  },
  addTagsToEndUserId: function addTagsToEndUserId(endUserId, tagIds) {
    return this.addTagsToURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/end_users/' + endUserId + '/tags', tagIds);
  },
  removeTagsFromEndUserId: function removeTagsFromEndUserId(endUserId, tagIds) {
    return this.removeTagsFromURL(__WEBPACK_IMPORTED_MODULE_1_constants_ResourcesConstants__["j" /* CUSTOMER_API */] + '/end_users/' + endUserId + '/tags', tagIds);
  },
  setResponseTags: function setResponseTags(campaignId, conversationId, questionId, tagIds) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].patch('/campaigns/' + campaignId + '/interactions/' + conversationId + '/' + questionId + '/tags', { tags: tagIds }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  addTagsToURL: function addTagsToURL(url, tagIds) {
    return this.post({
      url: url,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(tagIds)
    });
  },
  removeTagsFromURL: function removeTagsFromURL(url, tagIds) {
    return this.delete({
      url: url,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(tagIds)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TagAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ovcL":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30.91 23h-8.97c-.55 0-.998-.448-.998-1 0-.553.447-1 .997-1h8.97c.55 0 .995.447.995 1 0 .552-.446 1-.996 1zm0-7H14.962c-.55 0-.997-.448-.997-1 0-.553.446-1 .997-1H30.91c.55 0 .995.447.995 1 0 .552-.446 1-.996 1zm0-7H14.962c-.55 0-.997-.448-.997-1s.446-1 .997-1H30.91c.55 0 .995.448.995 1s-.446 1-.996 1zm0-7H14.962c-.55 0-.997-.448-.997-1s.446-1 .997-1H30.91c.55 0 .995.448.995 1s-.446 1-.996 1zM17.617 21.253c.41.366.448 1 .083 1.41l-7.972 9c-.1.115-.227.198-.364.255-.114.052-.242.082-.38.082-.144 0-.278-.032-.4-.086-.03-.013-.052-.038-.08-.054-.09-.05-.175-.105-.245-.18-.007-.007-.016-.01-.022-.016l-7.974-9c-.365-.412-.328-1.045.083-1.41.412-.37 1.042-.333 1.407.082l6.232 7.034V1c0-.552.446-1 .997-1 .55 0 .923.448.923 1v27.453l6.305-7.117c.367-.415.995-.452 1.408-.083zM17.952 28H30.91c.55 0 .995.447.995 1 0 .553-.446 1-.996 1H17.95c-.55 0-.996-.447-.996-1 0-.553.446-1 .996-1z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "ovfa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tease-calendar-connect.1ed7df24.png";

/***/ }),

/***/ "ovod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_settings_Routing_BotAvatarPreview__ = __webpack_require__("GVZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("ZWQA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);





var BotMessage = function BotMessage(_ref) {
  var hideAvatar = _ref.hideAvatar,
      position = _ref.position,
      avatarUrl = _ref.avatarUrl,
      color = _ref.color,
      children = _ref.children;

  var botStyle = {
    height: '2.5rem',
    width: '2.5rem',
    marginRight: '0.5rem',
    visibility: hideAvatar ? 'hidden' : 'visible'
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'flex' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_settings_Routing_BotAvatarPreview__["a" /* default */], { color: color, preview: avatarUrl, style: botStyle }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: children }, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('message', position) })
  );
};

var ConversationPreview = function ConversationPreview(_ref2) {
  var prompt = _ref2.prompt,
      nonMatchAnswer = _ref2.nonMatchAnswer,
      textColor = _ref2.textColor,
      backgroundColor = _ref2.backgroundColor,
      avatarUrl = _ref2.avatarUrl;

  var userMessageStyle = {
    backgroundColor: backgroundColor,
    color: textColor
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.ConversationPreview },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'bot-label' },
      'Bot'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      BotMessage,
      { color: backgroundColor, avatarUrl: avatarUrl },
      prompt
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'message user', style: userMessageStyle },
      'Not right now!'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'bot-label' },
      'Bot'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      BotMessage,
      { hideAvatar: true, position: 'top', color: backgroundColor, avatarUrl: avatarUrl },
      nonMatchAnswer
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      BotMessage,
      { position: 'bottom', color: backgroundColor, avatarUrl: avatarUrl },
      prompt
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'flex-1' })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConversationPreview);

/***/ }),

/***/ "oxzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("VxqM");










var mapStateToProps = function mapStateToProps(state) {
  return {
    smartSending: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_81" /* sequenceSmartSending */](state),
    weekdaysOnly: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_84" /* sequenceWeekdaysOnly */](state),
    unenrollOnReply: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_83" /* sequenceUnenrollOnReply */](state),
    unenrollOnReplyByDomain: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_82" /* sequenceUnenrollDomainOnReply */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setSmartSending: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_214" /* setSmartSending */],
      setWeekdaysOnly: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_224" /* setWeekdaysOnly */],
      setUnenrollOnReply: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_219" /* setUnenrollOnReply */],
      setUnenrollOnReplyByDomain: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_220" /* setUnenrollOnReplyByDomain */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onSmartSendingClick: function onSmartSendingClick(props) {
    return function () {
      props.actions.setSmartSending(!props.smartSending);
    };
  },
  onWeekdaysOnlyClick: function onWeekdaysOnlyClick(props) {
    return function () {
      props.actions.setWeekdaysOnly(!props.weekdaysOnly);
    };
  },
  onUnenrollOnReplyClick: function onUnenrollOnReplyClick(props) {
    return function () {
      //when unenroll on reply is turned off, we also turn off reply by domain
      var enrollToBeSet = !props.unenrollOnReply;
      props.actions.setUnenrollOnReply(enrollToBeSet);
      props.actions.setUnenrollOnReplyByDomain(enrollToBeSet ? props.unenrollOnReplyByDomain : false);
    };
  },
  onUnenrollOnReplyByDomainClick: function onUnenrollOnReplyByDomainClick(props) {
    return function () {
      props.actions.setUnenrollOnReply(true);
      props.actions.setUnenrollOnReplyByDomain(!props.unenrollOnReplyByDomain);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "oz/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("2GLA");


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__component__["a" /* TargetingOption */]);

/***/ }),

/***/ "ozKP":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 251 203\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g transform=\"translate(0 2)\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M230 72.796H36V54.53C36 48.16 42.157 43 49.754 43h166.492C223.843 43 230 48.16 230 54.53v18.266zm0 .022v90.65c0 6.37-6.157 11.532-13.754 11.532H49.754C42.157 175 36 169.837 36 163.468v-90.65h194z\" fill=\"#B5D2E1\" opacity=\".6\" filter=\"url(#a)\"></path><use fill=\"#000\" filter=\"url(#b)\" xlink:href=\"#c\"></use><use fill=\"#FFF\" xlink:href=\"#c\"></use><path d=\"M37.8 40h8.379v132H37.8a1.8 1.8 0 0 1-1.8-1.8V41.8a1.8 1.8 0 0 1 1.8-1.8z\" fill=\"#394F5A\"></path><rect fill=\"#F2F6F8\" x=\"170\" y=\"62\" width=\"19.759\" height=\"3.6\" rx=\"1.8\"></rect><rect fill=\"#F2F6F8\" x=\"170\" y=\"68\" width=\"34.13\" height=\"3.6\" rx=\"1.8\"></rect><rect fill=\"#F2F6F8\" x=\"169.852\" y=\"80\" width=\"52.13\" height=\"63\" rx=\"26.065\"></rect><path d=\"M50.3 55.9h171.482\" stroke=\"#F2F6F8\" stroke-width=\".6\" stroke-linecap=\"square\"></path><g transform=\"translate(161 13)\"><mask id=\"e\" fill=\"#fff\"><use xlink:href=\"#d\"></use></mask><path d=\"M9.803 2.063l1.203 4.086c.103.35.376.624.726.726l4.086 1.203c1.027.303 1.027 1.758 0 2.06l-4.086 1.202c-.35.102-.623.377-.726.726l-1.203 4.086c-.302 1.026-1.757 1.026-2.06 0l-1.201-4.086a1.074 1.074 0 0 0-.728-.726l-4.086-1.203c-1.026-.301-1.026-1.756 0-2.06l4.086-1.202c.35-.102.624-.377.728-.726l1.201-4.086c.303-1.028 1.758-1.028 2.06 0\" fill=\"#4D9EFF\" mask=\"url(#e)\"></path></g><path d=\"M6.79 111.59l.924 3.138c.08.27.289.478.557.557l3.138.925c.788.231.788 1.348 0 1.58l-3.138.925a.82.82 0 0 0-.557.556l-.923 3.137c-.233.79-1.35.79-1.582 0l-.923-3.137a.817.817 0 0 0-.557-.556L.59 117.79c-.788-.232-.788-1.349 0-1.58l3.138-.925a.82.82 0 0 0 .557-.557l.923-3.138c.233-.787 1.35-.787 1.582 0\" fill=\"#B4C3D8\"></path><path d=\"M230 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z\" stroke=\"#B4C3D8\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M63 196a3 3 0 1 1-6 0 3 3 0 0 1 6 0z\" stroke=\"#4D9EFF\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M251 89.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0\" fill=\"#B4C3D8\"></path><path d=\"M171.652 80h48.4a1.8 1.8 0 0 1 1.8 1.8V86h-52v-4.2a1.8 1.8 0 0 1 1.8-1.8z\" fill=\"#E1EEF4\"></path><path d=\"M171.652 148h48.53a1.8 1.8 0 0 1 1.8 1.8V172h-52.13v-22.2a1.8 1.8 0 0 1 1.8-1.8z\" fill=\"#F2F6F8\"></path><path d=\"M171.652 148h48.4a1.8 1.8 0 0 1 1.8 1.8v4.2h-52v-4.2a1.8 1.8 0 0 1 1.8-1.8z\" fill=\"#E1EEF4\"></path><path fill=\"#394F5A\" opacity=\".232\" d=\"M46 40h116v132H46z\"></path><path d=\"M162 40h66.2a1.8 1.8 0 0 1 1.8 1.8V56h-68V40z\" fill=\"#394F5A\"></path></g></svg>"

/***/ }),

/***/ "p1Ml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserTypeNumeral; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_keymirror__);


var UserTypes = __WEBPACK_IMPORTED_MODULE_0_keymirror___default()({
  USER: null,
  END_USER: null,
  LEAD: null
});

var UserTypeNumeral = Object.freeze({
  USER: 1,
  END_USER: 2,
  LEAD: 4
});

/***/ }),

/***/ "p3Di":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p57G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p7KC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var SearchConstants = Marty.createConstants(['SEARCH_USERS']);

/* harmony default export */ __webpack_exports__["a"] = (SearchConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "p9DP":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 25 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.57 22.97c-.15.18-.36.28-.6.28H.78c-.23 0-.44-.1-.6-.28-.14-.17-.2-.4-.16-.63l1.55-8.46V.78c0-.43.34-.78.77-.78h20.1c.44 0 .78.35.78.78v13.1l1.54 8.46c.04.22-.02.46-.17.63zm-2.9-21.42H3.08v11.63h18.56V1.54zm.1 13.17H2.98L1.7 21.7h21.35l-1.27-6.97zM5.42 20.16H3.88V18.6H5.4v1.55zm-.76-3.88H6.2v1.55H4.63v-1.55zm3.1 3.88H6.18V18.6h1.53v1.55zm-.78-3.88H8.5v1.55H6.97v-1.55zm9.28 3.88H8.5V18.6h7.74v1.55zm2.32 0h-1.54V18.6h1.54v1.55zm2.32 0h-1.54V18.6h1.54v1.55zm-2.32-3.88h1.55v1.55h-1.54v-1.55zm-2.32 0h1.55v1.55h-1.56v-1.55zm-2.32 0h1.55v1.55h-1.55v-1.55zm-2.32 0h1.55v1.55H11.6v-1.55zm-2.32 0h1.55v1.55H9.28v-1.55z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "p9md":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOG_TEAM_STATEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOG_PLAYBOOK_STATEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOG_WIDGET_STATEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOG_PASSWORD_STATEMENTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var TEAMS_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  FETCH_TEAMS_STARTED: null,
  FETCH_TEAMS_FINISHED: null,
  FETCH_TEAMS_FAILED: null,

  UPDATE_TEAM_STARTED: null,
  UPDATE_TEAM_FINISHED: null,
  UPDATE_TEAM_FAILED: null
});

var LOG_TEAM_STATEMENTS = ['.* updated. Open Hours: .* Timezone: .*', 'User ID: .* Name: .* Email: .* Team .* created at .* on .*', 'User ID: .* Name: .* Email: .* An update was made to .* at .* on .*', 'User ID: .* Name: .* Email: .* .* .* .* at .* on .*', 'User ID: .* Name: .* Email: .* .* .* at .* on .*'];

var LOG_PLAYBOOK_STATEMENTS = ['User ID: .* Name: .* Email: .* .* .* playbook .* at .* on .*'];

var LOG_WIDGET_STATEMENTS = ['Default Embed Configuration updated. .* changed to .*'];

var LOG_PASSWORD_STATEMENTS = ['Password Reset Event.*'];

/* harmony default export */ __webpack_exports__["e"] = (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(TEAMS_CONSTANTS, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId));

/***/ }),

/***/ "pABh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_ToggleSection__ = __webpack_require__("itDR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_containers_app__ = __webpack_require__("AJef");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var TOGGLE_ERROR_MESSAGE = 'Oops, something went wrong. Please try again.';
var defaultToEmptyObject = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["defaultTo"])({});

var Vidyard = function (_Component) {
  _inherits(Vidyard, _Component);

  function Vidyard(props) {
    _classCallCheck(this, Vidyard);

    var _this = _possibleConstructorReturn(this, (Vidyard.__proto__ || Object.getPrototypeOf(Vidyard)).call(this, props));

    _this.refreshOrgProperties = function () {
      return _this.props.actions.fetchOrgProperties();
    };

    _this.refreshIntegrationState = function () {
      __WEBPACK_IMPORTED_MODULE_9_containers_app__["a" /* default */].queries.IntegrationsQueries.fetchIntegrationStates();
    };

    _this.toggleEnabled = function (isEnabled) {
      var onError = function onError() {
        _this.props.notifications.error(TOGGLE_ERROR_MESSAGE);
        _this.setState({ isEnabled: !isEnabled });
      };

      var onLocalStateSet = function onLocalStateSet() {
        Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_integrations_api__["_1" /* toggleVidyardIntegration */])(isEnabled).catch(onError).then(_this.refreshOrgProperties).then(_this.refreshIntegrationState);
      };

      _this.setState({ isEnabled: isEnabled }, onLocalStateSet);
    };

    _this.state = {
      isEnabled: props.isEnabled
    };
    return _this;
  }

  _createClass(Vidyard, [{
    key: 'render',
    value: function render() {
      var isEnabled = this.state.isEnabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'vidyard-description' },
          'Turn on Vidyard\u2019s GoVideo widget and start building stronger relationships with your leads and customers through video. If your team has Vidyard accounts, they\u2019ll be able to send personalized videos and screen recordings right from Drift.',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            {
              className: 'vidyard-help-doc-link',
              href: 'https://gethelp.drift.com/hc/en-us/articles/360019666073-Vidyard-Integration-Send-Personalized-Videos-and-Screen-Recordings-Right-From-Drift',
              target: '_blank' },
            'Learn more'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_ToggleSection__["a" /* default */], {
          title: 'Add Vidyard to Drift',
          description: 'Adds a button to your Conversations view to launch the GoVideo widget',
          isActive: isEnabled,
          onToggled: Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["partial"])(this.toggleEnabled, [!isEnabled]),
          className: 'vidyard-toggle-section'
        })
      );
    }
  }]);

  return Vidyard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnabled: defaultToEmptyObject(__WEBPACK_IMPORTED_MODULE_2_app_modules_org_selectors__["properties"](state)).isVidyardEnabled
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ fetchOrgProperties: __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["fetchOrgProperties"] }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(Vidyard)));

/***/ }),

/***/ "pB3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("myCo");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var api = {
  fetch: function fetch(ids) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxAttachmentsAPI"].get(Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["e" /* generateBulkFetchURL */])('/attachments', ids.toJS())).checkStatus().retryWithBackoff().mapResponse(function (attachments) {
      return attachments.map(function (attachment) {
        return new __WEBPACK_IMPORTED_MODULE_2__models__["a" /* Attachment */](_extends({}, _.omit(attachment, 'size'), { size_: attachment.size }));
      });
    });
    // https://github.com/facebook/immutable-js/issues/1007
  },
  upload: function upload(conversationId, file) {
    var data = new FormData();
    data.append('file', file);
    data.append('conversationId', conversationId);
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxAttachmentsAPI"].post('/attachments', data, { file: true }).checkStatus().mapResponse(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Attachment */]);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "pB77":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18px\" height=\"17px\" viewBox=\"0 0 18 17\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"flow\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"admin-copy-2\" transform=\"translate(-1215.000000, -886.000000)\"><g id=\"Oval-Copy\" fill=\"#13CB6E\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"1222\" cy=\"896\" r=\"6\"></circle></g><g id=\"Artboard-2\" transform=\"translate(1223.000000, 886.000000)\" fill-rule=\"nonzero\"><path d=\"M9.53335714,7.57142857 C9.53335714,9.18544898 8.22879236,10.5 6.61128571,10.5 L2.92207143,10.5 C1.79586641,10.5 0.77024696,9.85033109 0.284798174,8.83235678 C-0.195939587,7.8213507 -0.0606505598,6.6249393 0.63662562,5.74678002 L1.07370103,5.19676901 C0.417941571,4.65915341 0,3.84179431 0,2.92857143 C0,1.31456515 1.30548666,0 2.92207143,0 L6.61128571,0 C7.73836991,0 8.76308647,0.649619183 9.24556588,1.66137673 C9.73062346,2.67240037 9.59516963,3.87108515 8.89766009,4.75321998 L8.46037216,5.30349842 C9.11585152,5.84111527 9.53335714,6.65835166 9.53335714,7.57142857 Z\" id=\"Path\" fill=\"#394F5A\"></path><path fill=\"#13CB6E\" d=\"M2,2.92857143 C2,3.44114286 2.41321429,3.85714286 2.92207143,3.85714286 L4.69285714,3.85714286 L2.20242857,6.99107143 C1.9805,7.27057143 1.93778571,7.65128571 2.091,7.9735 C2.24421429,8.29478571 2.56828571,8.5 2.92207143,8.5 L6.61128571,8.5 C7.12107143,8.5 7.53335714,8.084 7.53335714,7.57142857 C7.53335714,7.05885714 7.12107143,6.64285714 6.61128571,6.64285714 L4.84142857,6.64285714 L7.33185714,3.50892857 C7.55285714,3.22942857 7.5965,2.84778571 7.44235714,2.5265 C7.28914286,2.20521429 6.966,2 6.61128571,2 L2.92207143,2 C2.41321429,2 2,2.416 2,2.92857143 Z\" id=\"Path\" fill=\"#13CB6E\"></path></g></g></g></svg>"

/***/ }),

/***/ "pDON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OptionsDropdown":"OptionsDropdown---fgpK4"};

/***/ }),

/***/ "pDST":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 15 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.583 14.605s-.06-1.714 0-1.953l.645-2.58c.006-.022.02-.038.028-.059.02-.06.05-.114.08-.17a.986.986 0 0 1 .105-.156c.014-.016.02-.038.035-.054L10 1.11c.026-.027.062-.038.091-.06a.86.86 0 0 1 .16-.106.893.893 0 0 1 .18-.064c.035-.01.065-.032.102-.037.2-.029 1.982-.247 3.069.92 1.064 1.133.86 2.796.834 2.982-.007.043-.028.077-.04.116-.014.052-.027.101-.05.151a.974.974 0 0 1-.123.186c-.021.025-.03.056-.054.08l-8.523 8.523c-.016.016-.038.021-.054.035a.921.921 0 0 1-.157.104.875.875 0 0 1-.17.082c-.021.007-.036.022-.058.028l-2.216.554H.583zm11.64-11.551c-.27-.29-.8-.35-1.143-.353l-.935.935 1.498 1.498.936-.936c-.004-.34-.073-.841-.356-1.144zM4.496 12.28l5.812-5.812L8.81 4.972l-5.812 5.811-.5 1.998 1.998-.5z\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "pDr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AssistantOrgSalesforceConnect":"AssistantOrgSalesforceConnect---43YZU"};

/***/ }),

/***/ "pE+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchMarketoFieldsSuccess */
/* unused harmony export fetchMarketoMappingsSuccess */
/* unused harmony export patchMarketoMappingsSuccess */
/* unused harmony export patchMarketoMappingsError */
/* unused harmony export patchMarketoMappingsStart */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchMarketoFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchMarketoMappings;
/* harmony export (immutable) */ __webpack_exports__["c"] = patchMarketoMappings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("gQOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_marketo_api__ = __webpack_require__("PMAQ");



function fetchMarketoFieldsSuccess(_ref) {
  var fields = _ref.fields;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_MARKETO_FIELDS_SUCCESS */],
    fields: fields
  };
}

function fetchMarketoMappingsSuccess(_ref2) {
  var mappings = _ref2.mappings,
      allowAttributeDefaults = _ref2.allowAttributeDefaults,
      useCountryAcronyms = _ref2.useCountryAcronyms,
      useStateAcronyms = _ref2.useStateAcronyms;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_MARKETO_MAPPINGS_SUCCESS */],
    mappings: mappings, allowAttributeDefaults: allowAttributeDefaults, useCountryAcronyms: useCountryAcronyms, useStateAcronyms: useStateAcronyms
  };
}

function patchMarketoMappingsSuccess(_ref3) {
  var mappings = _ref3.mappings,
      allowAttributeDefaults = _ref3.allowAttributeDefaults,
      useCountryAcronyms = _ref3.useCountryAcronyms,
      useStateAcronyms = _ref3.useStateAcronyms;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_MARKETO_MAPPINGS_SUCCESS */],
    mappings: mappings, allowAttributeDefaults: allowAttributeDefaults, useCountryAcronyms: useCountryAcronyms, useStateAcronyms: useStateAcronyms
  };
}

function patchMarketoMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_MARKETO_MAPPINGS_ERROR */],
    err: err
  };
}

function patchMarketoMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_MARKETO_MAPPINGS_START */]
  };
}

function fetchMarketoFields() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_marketo_api__["a" /* api */].fetchMarketoFields().then(function (response) {
      dispatch(fetchMarketoFieldsSuccess(response));
    });
  };
}

function fetchMarketoMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_marketo_api__["a" /* api */].fetchMarketoMappings().then(function (response) {
      dispatch(fetchMarketoMappingsSuccess(response));
    });
  };
}

function patchMarketoMappings(mappings) {
  var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch) {
    dispatch(patchMarketoMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_marketo_api__["a" /* api */].patchMarketoMappings(mappings).then(function (response) {
      successCB();
      dispatch(patchMarketoMappingsSuccess(response));
    }).catch(function (err) {
      dispatch(patchMarketoMappingsError(err));
    });
  };
}

/***/ }),

/***/ "pE/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchSFDCAccountListSyncHistory: function fetchSFDCAccountListSyncHistory() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/sync?showresults=true').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchAllSalesforceCampaigns: function fetchAllSalesforceCampaigns() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/list').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  resyncAccountList: function resyncAccountList() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/lists/sync').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  setForceResync: function setForceResync() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].post('/salesforce/toggles', [{ "name": "forceSync", "value": true }]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getAccountToggles: function getAccountToggles() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/toggles').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  setAccountDeleteOk: function setAccountDeleteOk(value) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].post('/salesforce/toggles', [{ "name": "deleteOk", "value": value }]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCAccountLists: function fetchSFDCAccountLists() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/lists').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSyncedSFDCAccountLists: function fetchSyncedSFDCAccountLists() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/properties').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCAccountProperties: function fetchSFDCAccountProperties() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/salesforce/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  saveSyncedSFDCAccountLists: function saveSyncedSFDCAccountLists(lists) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].post('/salesforce/properties', lists).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  deleteSyncedSFDCAccountList: function deleteSyncedSFDCAccountList(id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].delete('/salesforce/property/' + id).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCMappings: function fetchSFDCMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/mappings/attributes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSFDCMappings: function patchSFDCMappings(mappings, useRawMapping) {
    var payload = useRawMapping ? mappings : { mappings: mappings };
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/mappings/attributes/v3', payload).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCMetricsMappings: function fetchSFDCMetricsMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/mappings/attributes/metrics').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSFDCMetricsMappings: function patchSFDCMetricsMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/mappings/attributes/metrics', { mappings: mappings }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },


  // lead, contact, case
  fetchSFDCProperties: function fetchSFDCProperties(type) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/' + type + '/properties').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  searchSFDCUsers: function searchSFDCUsers(query) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/users?query=' + query).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCUserMappings: function fetchSFDCUserMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/mappings/users/overrides').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCAccountPropertyMappings: function fetchSFDCAccountPropertyMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/attrib/mapping').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchDriftAccountProperties: function fetchDriftAccountProperties() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].get('/attrib').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSFDCAccountPropertyMappings: function patchSFDCAccountPropertyMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].patch('/attrib/mapping', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  deleteSFDCAccountPropertyMappings: function deleteSFDCAccountPropertyMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["AccountsAPI"].delete('/attrib/mapping/multi/v2', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
  },
  patchSFDCUserMappings: function patchSFDCUserMappings(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/mappings/users/overrides', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSalesforceLeadPushCampaign: function fetchSalesforceLeadPushCampaign() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/push').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceAutoMappings: function getSalesforceAutoMappings(apply) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/mappings/users/automatic?apply=' + apply).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSalesforceCampaignById: function fetchSalesforceCampaignById(id) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/' + id).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  replaceSalesforceLeadPushCampaign: function replaceSalesforceLeadPushCampaign(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].put('/salesforce/campaigns/push', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  searchSalesforceCampaigns: function searchSalesforceCampaigns(query) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/search?q=' + query).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceTaskTypeList: function getSalesforceTaskTypeList() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/task/type/list').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.taskTypes;
    });
  },
  getSalesforceTaskType: function getSalesforceTaskType() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/task/type').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.taskType;
    });
  },
  getSalesforceTaskTypePhone: function getSalesforceTaskTypePhone() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/task/type/phone').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.taskType;
    });
  },
  getSalesforceInfluenceCampaignId: function getSalesforceInfluenceCampaignId() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/influence').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  setSalesforceInfluenceCampaignId: function setSalesforceInfluenceCampaignId(_ref) {
    var campaignId = _ref.campaignId;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].put('/salesforce/campaigns/influence', { campaignId: campaignId }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.taskType;
    });
  },
  patchSalesforceTaskType: function patchSalesforceTaskType(_ref2) {
    var taskType = _ref2.taskType;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/task/type', { taskType: taskType }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSalesforceTaskTypePhone: function patchSalesforceTaskTypePhone(_ref3) {
    var taskType = _ref3.taskType;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/task/type/phone', { taskType: taskType }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceObjectList: function getSalesforceObjectList() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/object/list').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceFieldList: function getSalesforceFieldList(fieldType) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/object/' + fieldType + '/field/list/v2').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceLeadRoutingSettings: function getSalesforceLeadRoutingSettings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/routing/owner/settings').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSalesforceLeadRoutingSettings: function patchSalesforceLeadRoutingSettings(_ref4) {
    var settings = _ref4.settings;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/routing/owner/settings', { settings: settings }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSalesforceEnrichmentByEmail: function fetchSalesforceEnrichmentByEmail(_ref5) {
    var email = _ref5.email;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].get('/salesforce/enrichment?email=' + encodeURIComponent(email)).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSalesforceEnrichmentByDomain: function fetchSalesforceEnrichmentByDomain(_ref6) {
    var domain = _ref6.domain;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].get('/salesforce/enrichment?domain=' + encodeURIComponent(domain)).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSalesforceEnrichmentFields: function fetchSalesforceEnrichmentFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/enrichment/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSalesforceEnrichmentFields: function patchSalesforceEnrichmentFields(_ref7) {
    var fields = _ref7.fields;

    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/enrichment/fields', { fields: fields }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchSalesforceEventType: function patchSalesforceEventType(data) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].patch('/salesforce/event/type', data).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceEventTypeList: function getSalesforceEventTypeList() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/event/type/list').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.eventTypes;
    });
  },
  getSalesforceEventType: function getSalesforceEventType() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/event/type').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]).then(function (data) {
      return data.eventType;
    });
  },
  getSalesforceCampaigns: function getSalesforceCampaigns() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/list').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSelectedSalesforceCampaign: function getSelectedSalesforceCampaign(playbookId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].get('/salesforce/playbook/campaign/' + playbookId).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  setSalesforceCampaign: function setSalesforceCampaign(playbookPayload) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].post('/salesforce/playbook/campaign', playbookPayload, {
      headers: { 'Content-Type': 'application/json' }
    }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchCampaigns: function fetchCampaigns(query) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/campaigns/search?q=' + query).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchSFDCConnection: function fetchSFDCConnection() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].get('/salesforce/playbook/campaign/connected').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  deleteSalesforceCampaign: function deleteSalesforceCampaign(playbookId) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["ConversationAPI"].delete('/salesforce/playbook/campaign/' + playbookId, {
      headers: { 'Content-Type': 'application/json' }
    }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceMeetingEventFields: function getSalesforceMeetingEventFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/event/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  getSalesforceBookedByField: function getSalesforceBookedByField() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].get('/salesforce/stored/event/field').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  setSalesforceBookedByField: function setSalesforceBookedByField(meetingEventField) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].post('/salesforce/event/fields', meetingEventField, {
      headers: { 'Content-Type': 'application/json' } }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  deleteSalesforceBookedByField: function deleteSalesforceBookedByField() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["CustomerAPI"].delete('/salesforce/stored/event/field').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]);
  }
};

/***/ }),

/***/ "pGxX":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.847 6.568c.101.243.101.517 0 .761-.05.121-.122.23-.214.321v.001l-5.978 5.964c-.195.194-.449.291-.704.291-.255 0-.51-.097-.705-.291-.389-.388-.389-1.018 0-1.406l4.277-4.267H1.011c-.551 0-.997-.445-.997-.994 0-.549.446-.993.997-.993h19.512l-4.277-4.267c-.389-.388-.389-1.018 0-1.406.389-.388 1.02-.388 1.409 0l5.978 5.964v.001c.092.091.164.2.214.321z\" fill=\"#C9DEE9\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "pHGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Template__ = __webpack_require__("xI2r");


var Title = ["Sweet! You’re on mobile - and you have", React.createElement("img", { style: { width: 83, height: 25, marginLeft: 10, marginRight: 10, verticalAlign: "middle" }, src: __webpack_require__("88BI") }), "set up."];

function launchSlack() {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
  var storeLink = void 0;
  if (isIOS) {
    storeLink = "https://itunes.apple.com/us/app/slack-team-communication/id618783545";
  } else if (isAndroid) {
    storeLink = "https://play.google.com/store/apps/details?id=com.Slack";
  }
  if (storeLink) {
    setTimeout(function () {
      window.location = storeLink;
    }, 25);
  }
  window.location = "slack://";
}

var Button = React.createElement(
  "button",
  {
    className: "dsg-LargeButton color-teal",
    onClick: launchSlack
  },
  "GO TO SLACK"
);

function makeCopy(channelname) {
  return ["Head over to ", React.createElement(
    "span",
    { className: "dsg-medium-weight" },
    channelname
  ), " and start talking to your customers!"];
}

var ConnectedToSlack = function ConnectedToSlack(_ref) {
  var channel = _ref.channel;

  return React.createElement(__WEBPACK_IMPORTED_MODULE_0__Template__["a" /* default */], {
    title: Title,
    copy: makeCopy(channel),
    button: Button
  });
};

/* harmony default export */ __webpack_exports__["a"] = (ConnectedToSlack);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "pIAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var ConversationConstants = Marty.createConstants(['RECENT_END_USER_CONVERSATIONS_FETCH', 'CONVERSATION_BLOCKS_FETCH', 'CONVERSATIONS_BY_ID_FETCH', 'LOAD_MORE_CONVERSATION_GROUPS', 'CONVERSATION_FETCH', 'CONVERSATIONS_COUNT_FETCH', 'OPEN_CONVERSATIONS_FETCH', 'MESSAGE_CREATE', 'UPDATE_CONVERSATION', 'PUSHER_CONVERSATION', 'SEARCH_ALL_CONVERSATIONS']);

ConversationConstants.COMPOSER_ELEMENT_ID = 'textAreaComponent';

/* harmony default export */ __webpack_exports__["a"] = (ConversationConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "pJPl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HelpingTeamMemberSelection":"HelpingTeamMemberSelection---1Uw8A"};

/***/ }),

/***/ "pKGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("ZuE5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("VUJx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_driftAppMetrics_helper__ = __webpack_require__("CoDi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__ = __webpack_require__("EkEs");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var MINUTE = 60 * 1000;

var sendDriftAppMetric$ = function sendDriftAppMetric$(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* sendDriftAppMetric */].toString()).pluck('payload').mergeMap(function (metric) {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* sendDriftAppMetric */](metric).map(function () {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* sendDriftAppMetricSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* sendDriftAppMetricPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* sendDriftAppMetricFailed */](error));
    });
  });
};

var actionCount = 0;
var countAllActions$ = function countAllActions$(action$, _ref) {
  var getState = _ref.getState;

  return action$.filter(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"])(getState()) === 1;
  }).do(function () {
    return actionCount++;
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
  });
};

var dispatchMetricInterval$ = function dispatchMetricInterval$(action$, _ref2) {
  var getState = _ref2.getState;

  return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].interval(MINUTE).filter(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"])(getState()) === 1;
  }).map(function () {
    var actionCountToDispatch = actionCount;
    actionCount = 0;
    return __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* sendDriftAppMetric */](Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_driftAppMetrics_helper__["b" /* reduxActionCount */])(actionCountToDispatch));
  });
};

var getTrackPresenceLoadTimePayload = function getTrackPresenceLoadTimePayload(startTime, getState) {
  var endTime = Date.now();
  var loadTime = endTime - startTime;
  if (__ENV__ !== 'PRODUCTION') {
    console.debug('__DRIFT__: Took ' + loadTime + 'ms to load presence state');
  }

  var metric = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_driftAppMetrics_helper__["a" /* createMetric */])('customer-web.liveSocketTime.buckets', {
    type: 'bootstrap.total',
    org_1: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgId"])(getState()) === 1
  });

  return {
    value: loadTime,
    dimensions: {
      type: 'bucket',
      buckets: "500, 1000, 2000, 5000, 15000"
    },
    metric: metric
  };
};

var recordBootstrapPerformance$ = function recordBootstrapPerformance$(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* enterRootAppRoute */].toString()).first().map(function () {
    var checkpoint = {
      label: 'enterRootAppRoute',
      timestamp: Date.now()
    };

    var bootstrapCheckpoints = [].concat(_toConsumableArray(window.__DRIFT__bootstrapCheckpoints), [checkpoint]);

    if (__ENV__ !== 'PRODUCTION') {
      for (var i = 0; i < bootstrapCheckpoints.length; i++) {
        var previousCheckpoint = bootstrapCheckpoints[i - 1];
        var currentCheckpoint = bootstrapCheckpoints[i];

        if (previousCheckpoint) {
          var elapsed = currentCheckpoint.timestamp - previousCheckpoint.timestamp;
          console.debug('__DRIFT__: Took ' + elapsed + 'ms from [' + previousCheckpoint.label + '] to [' + currentCheckpoint.label + ']');
        }
      }
    }

    var firstCheckpoint = bootstrapCheckpoints[0];
    var lastCheckpoint = bootstrapCheckpoints[bootstrapCheckpoints.length - 1];
    var totalTimeElapsed = lastCheckpoint.timestamp - firstCheckpoint.timestamp;

    if (__ENV__ !== 'PRODUCTION') {
      console.debug('__DRIFT__: (Total Bootstrap Time Elapsed: ' + totalTimeElapsed + 'ms)\n');
    }

    var metric = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_driftAppMetrics_helper__["a" /* createMetric */])('customer-web.loadTime', {
      type: 'bootstrap.total'
    });

    // NOTE: Sending single bootstrap metric--could dispatch multiple for more granularity into each checkpoint
    return __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* sendDriftAppMetric */]({
      value: totalTimeElapsed,
      dimensions: {
        path: window.location.pathname,
        type: 'timer'
      },
      metric: metric
    });
  });
};

var recordConversationsAppTimer$ = function recordConversationsAppTimer$(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* recordConversationsAppTimer */].toString()).pluck('payload').map(function (_ref3) {
    var checkpoint = _ref3.checkpoint,
        version = _ref3.version,
        elapsed = _ref3.elapsed;

    if (__ENV__ !== 'PRODUCTION') {
      console.info('__DRIFT__: Took ' + elapsed + 'ms from [ConversationsApp.init] to [' + checkpoint + ']');
    }

    var metric = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_driftAppMetrics_helper__["a" /* createMetric */])('customer-web.loadTime', {
      app: 'web.conversations',
      appVersion: version,
      type: 'readyForInteraction',
      checkpoint: checkpoint
    });

    // NOTE: Sending single bootstrap metric--could dispatch multiple for more granularity into each checkpoint
    return __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* sendDriftAppMetric */]({
      value: elapsed,
      dimensions: {
        type: 'timer'
      },
      metric: metric
    });
  });
};

var recordConversationsAppFirstMeaningfulRender$ = function recordConversationsAppFirstMeaningfulRender$(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["h" /* startConversationsAppTimer */].toString()).switchMap(function () {
    var start = Date.now();

    return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* hitConversationsAppRenderCheckpoint */].toString()).pluck('payload').first().map(function (_ref4) {
      var checkpoint = _ref4.checkpoint,
          version = _ref4.version;

      var elapsed = Date.now() - start;
      return __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* recordConversationsAppTimer */]({ checkpoint: checkpoint, version: version, elapsed: elapsed });
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(sendDriftAppMetric$, countAllActions$, dispatchMetricInterval$, recordBootstrapPerformance$, recordConversationsAppTimer$, recordConversationsAppFirstMeaningfulRender$);

/***/ }),

/***/ "pM3z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("a0kp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_location_pin_svg__ = __webpack_require__("8BMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_location_pin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_location_pin_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Social__ = __webpack_require__("1t2u");









var FOLLOW_ICON_SRC = __webpack_require__("g9fI");
var FOLLOWING_ICON_SRC = __webpack_require__("P9bU");

var ContactHeader = function ContactHeader(_ref) {
  var user = _ref.user,
      hasFollowing = _ref.hasFollowing,
      userStatus = _ref.userStatus,
      following = _ref.following,
      updateFollowing = _ref.updateFollowing;


  var geo = _.get(userStatus, 'geo');
  var location = ' - ';
  if (!!geo) {
    location = _.compact([geo.city, geo.subdivision, geo.country]).join(', ');
  }

  var attributes = user.attributes,
      name = user.name;

  var linkedin = user.getIn(['attributes', 'linkedin_handle']);
  var twitter = user.getIn(['attributes', 'twitter_handle']);

  var userAvatar = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_shared_AvatarCompat__["a" /* AvatarCompat */], { user: user, type: 'user', size: 'small' });

  var followingSRC = following ? FOLLOWING_ICON_SRC : FOLLOW_ICON_SRC;
  var followingCopy = following ? 'Following' : 'Follow';
  var followingLinkContent = function followingLinkContent() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'contact-info-location-icon', src: followingSRC }),
      followingCopy,
      ' '
    );
  };
  var followingLink = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    { onClick: updateFollowing },
    followingLinkContent()
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-info-header' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'contact-info-header-left' },
        userAvatar
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'company-info-header-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-info-title' },
          name
        ),
        attributes.employment_title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          attributes.employment_title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-info-location' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, {
            src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_location_pin_svg___default.a }),
          ' ',
          __WEBPACK_IMPORTED_MODULE_4_moment___default()(userStatus.lastUpdateAt).format('hh:mmA'),
          ' ',
          location
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'contact-info-social' },
          !!twitter && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Social__["a" /* default */], { type: 'twitter', handle: twitter, className: 'contact-info-social-icon' }),
          !!linkedin && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Social__["a" /* default */], { type: 'linkedin', handle: linkedin, className: 'contact-info-social-icon' }),
          hasFollowing && followingLink
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ContactHeader);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "pOiw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pOjB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var api = {
  /**
   * @deprecated due to archived enrichment-api, see [this PR](https://github.com/Driftt/enrichment-api/pull/278) 
   */
  fetchDemandbaseCompanyData: function fetchDemandbaseCompanyData() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  },
  fetchDemandbaseIndustries: function fetchDemandbaseIndustries() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxContactsApi"].get('/enrichment/demandbase/industries').checkStatus().map(function (res) {
      return res.response;
    });
  },
  fetchDemandbaseSubIndustries: function fetchDemandbaseSubIndustries() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["RxContactsApi"].get('/enrichment/demandbase/sub_industries').checkStatus().map(function (res) {
      return res.response;
    });
  }
};

/***/ }),

/***/ "pPBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("/1Fz");









var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      updateCQL: __WEBPACK_IMPORTED_MODULE_3_app_modules_endUser_actions__["_0" /* updateCQL */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(undefined, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["h" /* withHandlers */])({
  onClick: function onClick(props) {
    return function (score) {
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_tracking_actions__["track"])('Conversation Sidebar - CQL Score Changed');
        props.actions.updateCQL({
          conversationId: props.conversationId,
          endUserId: props.endUserId,
          score: props.score === score ? 0 : score
        });
      };
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "pTKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_NotificationHelper__ = __webpack_require__("a56C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties__ = __webpack_require__("MDpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_profile_actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__ = __webpack_require__("+Z1b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_profile_api__ = __webpack_require__("Iz1I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__ = __webpack_require__("hTEi");
















var fetchClearbitForEmail = function fetchClearbitForEmail(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchClearbitForEmail"].toString()).pluck('payload').mergeMap(function (email) {
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchClearbitForEmail(email).map(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchClearbitForEmailSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchClearbitForEmailPending"]({ email: email })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchClearbitForEmailFailed"]({ email: email, error: error }));
    });
  });
};

var fetchGoogleScopes = function fetchGoogleScopes(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchGoogleScopes"].toString()).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchGoogleScopes().map(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchGoogleScopesSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchGoogleScopesPending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchGoogleScopesFailed"]({ error: error }));
    });
  });
};

var fetchUserProfile = function fetchUserProfile(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9_app_modules_profile_actions__["fetchUserProfile"].toString()).pluck('payload').flatMap(function (userId) {
    return __WEBPACK_IMPORTED_MODULE_12_app_modules_profile_api__["a" /* api */].get(userId).map(function (_ref) {
      var profile = _ref.profile;
      return __WEBPACK_IMPORTED_MODULE_9_app_modules_profile_actions__["fetchUserProfileSuccess"]({ userId: userId, profile: profile });
    }).startWith(__WEBPACK_IMPORTED_MODULE_9_app_modules_profile_actions__["fetchUserProfilePending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9_app_modules_profile_actions__["fetchUserProfileFailed"]({ userId: userId, error: error }));
    });
  });
};

function fetchEmailSignature(action$, _ref2) {
  var getState = _ref2.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchEmailSignature"].toString()).pluck('payload').mergeMap(function () {
    var user = Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"])(getState());
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchEmailSignature(user.id).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchEmailSignatureSuccess"](response.emailSignature);
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchEmailSignaturePending"]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchEmailSignatureFailed"]({ error: error }));
    });
  });
}

// TODO: deprecated, remove once multiple signatures is ungated
var fetchOrgSignature = function fetchOrgSignature(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgSignature"].toString()).pluck('payload').mergeMap(function (_ref3) {
    var userId = _ref3.userId;
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchOrgSignature({ userId: userId }).map(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgSignatureSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgSignaturePending"]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgSignatureFailed"]({ err: err }));
    });
  });
};

var fetchOrgMultiSignature = function fetchOrgMultiSignature(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgMultiSignature"].toString()).pluck('payload').mergeMap(function (_ref4) {
    var userId = _ref4.userId;
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchOrgMultiSignature({ userId: userId }).map(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgMultiSignatureSuccess"]).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgMultiSignaturePending"]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchOrgMultiSignatureFailed"]({ err: err }));
    });
  });
};

function setEmailSignature(action$, _ref5) {
  var getState = _ref5.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["setEmailSignature"].toString()).pluck('payload').mergeMap(function (emailSignature) {
    var user = Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"])(getState());
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].setEmailSignature(user.id, emailSignature).map(function (response) {
      __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Email signature updated successfully!',
        variant: 'green'
      });
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["setEmailSignatureSuccess"](response.emailSignature);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Email signature update failed. Please try again.',
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["setEmailSignatureFailed"]({ error: error }));
    });
  });
}

function pushUser(action$, _ref6) {
  var getState = _ref6.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref7) {
    var channel = _ref7.channel,
        leaveChannel$ = _ref7.leaveChannel$;

    var currentUserId = Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"])(getState()).id;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('user-new', function (payload) {
        __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.UserActions.userUpdated(payload.id, payload);
        observer.next(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["receiveOrgUser"](Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["b" /* parseUser */])(payload)));
      });

      channel.on('user-updated', function (payload) {
        __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.UserActions.userUpdated(payload.id, payload);
        if (!Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["isUpdatingUser"])(getState())) {
          observer.next(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["receiveOrgUser"](Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["b" /* parseUser */])(payload)));
          if (payload.id === currentUserId) {
            observer.next(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["receiveCurrentUser"](Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["b" /* parseUser */])(payload)));
          }
        }
      });
    }).takeUntil(leaveChannel$);
  });
}

function turnOffManualAway(action$, _ref8) {
  var getState = _ref8.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAway"].toString()).map(function () {
    return { userId: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_user_selectors__["currentUser"])(getState()).id };
  }).mergeMap(function (_ref9) {
    var userId = _ref9.userId;

    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].turnOffManualAway({ userId: userId }).map(function (user) {
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAwaySuccess"](user);
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAwayPending"]({ userId: userId })).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAwayFailure"]({ userId: userId }));
    });
  });
}

function receiveUserAfterTurnOffManualAway(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["turnOffManualAwaySuccess"].toString()).pluck('payload').map(function (user) {
    return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["receiveCurrentUser"](user);
  });
}

function updateUserConversationLimitStatus(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["v" /* SocketCluster */].MESSAGES;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_6_app_modules_socket_constants__["u" /* SocketChannel */].USER;
  }).switchMap(function (_ref10) {
    var channel = _ref10.channel,
        leaveChannel$ = _ref10.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('user-convo-limit-update', function (payload) {
        observer.next(__WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_actions__["q" /* userAtConversationLimitUpdate */](payload.body.hasUserReachedLimit));
      });
    }).takeUntil(leaveChannel$);
  });
}

function disconnectGmailAccount(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["disconnectGmailAccount"].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].disconnectGmailAccount().map(function () {
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["disconnectGmailAccountSuccess"]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["disconnectGmailAccountPending"]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["disconnectGmailAccountFailure"]());
    });
  });
}

var fetchIndividualConvoLimit = function fetchIndividualConvoLimit(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchIndividualUserConvoLimit"].toString()).pluck('payload').mergeMap(function (_ref11) {
    var userId = _ref11.userId;
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].fetchIndividualConvoLimit().map(function (data) {
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchIndividualUserConvoLimitSuccess"]({ data: data, userId: userId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchIndividualUserConvoLimitPending"]({ userId: userId })).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["fetchIndividualUserConvoLimitFailed"]({ userId: userId }));
    });
  });
};

var updateIndividualConvoLimit = function updateIndividualConvoLimit(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateIndividualUserConvoLimit"].toString()).pluck('payload').mergeMap(function (_ref12) {
    var userId = _ref12.userId,
        limit = _ref12.limit,
        remove = _ref12.remove;
    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].updateIndividualConvoLimit(limit, remove).map(function () {
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateIndividualUserConvoLimitSuccess"]({ data: { userId: userId, convoLimit: limit }, userId: userId });
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateIndividualUserConvoLimitPending"]({ userId: userId })).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateIndividualUserConvoLimitFailed"]({ userId: userId }));
    });
  });
};

var updateUser = function updateUser(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateUser"].toString()).pluck('payload').mergeMap(function (_ref13) {
    var user = _ref13.user,
        originalUser = _ref13.originalUser,
        requiredPurchase = _ref13.requiredPurchase;

    return __WEBPACK_IMPORTED_MODULE_11_app_modules_user_api__["a" /* api */].updateUser(user).map(function () {
      if (!requiredPurchase) {
        __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: 'Successfully updated ' + (user.name || user.email),
          variant: 'green'
        });
      }
      return __WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateUserSuccess"](user);
    }).startWith(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateUserPending"](user)).catch(function () {
      __WEBPACK_IMPORTED_MODULE_4_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Failed to update ' + (user.name || user.email),
        variant: 'red'
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_actions__["updateUserFailed"](originalUser));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(pushUser, __WEBPACK_IMPORTED_MODULE_5_app_modules_user_properties__["b" /* epic */], setEmailSignature, fetchClearbitForEmail, fetchUserProfile, fetchEmailSignature, turnOffManualAway, receiveUserAfterTurnOffManualAway, fetchGoogleScopes, fetchOrgSignature, disconnectGmailAccount, fetchOrgMultiSignature, updateUserConversationLimitStatus, fetchIndividualConvoLimit, updateIndividualConvoLimit, updateUser);

/***/ }),

/***/ "pV5o":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(219);

/***/ }),

/***/ "pVow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("vY9o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conversation_bulkUpdate_selectors__ = __webpack_require__("n5J5");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var initialState = {
    integrationProperties: [],
    integrationMappings: [],
    integrationMappingsErr: null,
    integrationPatchLoading: false
};

var sortedByStatic = function sortedByStatic(mappings) {
    return _.sortBy(mappings, function (mapping) {
        return !mapping.static;
    });
};

var integrationMappings = function integrationMappings() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_PARDOT_FIELDS_SUCCESS */]:
            return _extends({}, state, { integrationFields: action.fields });

        case __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_PARDOT_MAPPINGS_SUCCESS */]:
            var clonedState = _extends({}, state);
            clonedState.integrationMappings = sortedByStatic(action.mappings);
            return clonedState;

        case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PATCH_PARDOT_MAPPINGS_SUCCESS */]:
            return _extends({}, state, {
                integrationMappings: sortedByStatic(action.mappings),
                integrationMappingsErr: null,
                integrationPatchLoading: false
            });

        case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* PATCH_PARDOT_MAPPINGS_ERROR */]:
            return _extends({}, state, { integrationMappingsErr: action.err, integrationPatchLoading: false });

        case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PATCH_PARDOT_MAPPINGS_START */]:
            return _extends({}, state, { integrationPatchLoading: true });

        default:
            return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (integrationMappings);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "pXZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__("uI/R");













function makeMapStateToProps() {
  return function (state) {
    return {
      profileUrl: __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_selectors__["profileUrl"](state),
      profileUrlHandle: __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_selectors__["profileUrlHandle"](state),
      defaultMeetingtype: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["f" /* getDefaultMeetingType */](state),
      meetingTypes: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["o" /* getMeetingTypes */](state),
      isMeetingTypesLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["y" /* isMeetingTypesLoaded */](state),
      isDefaultSettingsLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_meetings_selectors__["x" /* isMeetingSettingsLoaded */](state),
      isOnPaidPlan: __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasPaidGates()
    };
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchMeetingTypes: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["O" /* fetchMeetingTypes */],
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_7_app_modules_meetings_actions__["K" /* fetchMeetingSettings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchMeetingTypes();
    this.props.actions.fetchMeetingSettings();
  }
}), __WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* withRouter */])(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),

/***/ "pYOq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pal8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("96TJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });


/***/ }),

/***/ "pcjm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pdN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TargetedAccountsAction = function (_PureComponent) {
  _inherits(TargetedAccountsAction, _PureComponent);

  function TargetedAccountsAction(props) {
    _classCallCheck(this, TargetedAccountsAction);

    var _this = _possibleConstructorReturn(this, (TargetedAccountsAction.__proto__ || Object.getPrototypeOf(TargetedAccountsAction)).call(this, props));

    _this.renderSelectOption = function (_ref) {
      var label = _ref.label;

      var iconName = 'user-circle';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "participant-type-dropdown-option" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { height: 14, width: 14, name: iconName }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "span",
          null,
          label
        )
      );
    };

    _this.state = {
      selectedValue: "default-settings"
    };
    return _this;
  }

  _createClass(TargetedAccountsAction, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "participant-actions" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "header",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            null,
            "Review Settings"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Please note that default settings for targeted accounts are populated below."
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "participant-action-selector" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "participant-action-selector-description" },
            "How do you want to add participants?"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], {
            multi: false,
            options: [{ label: "Add single person", value: "default-settings" }],
            optionRenderer: this.renderSelectOption,
            valueRenderer: this.renderSelectOption,
            autoFocus: true,
            clearable: false,
            value: this.state.selectedValue,
            disabled: true
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            "Automatically add one user or account owner to each new conversation. If you choose a team, one member from the team will automatically be added to each conversation. "
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "participant-action-selector" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: "participant-action-selector-description" },
            "Who do you want to add?"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Select"], {
            multi: false,
            options: [{ label: "Drift account owner", value: "default-settings" }],
            autoFocus: true,
            clearable: false,
            value: this.state.selectedValue,
            disabled: true
          })
        )
      );
    }
  }]);

  return TargetedAccountsAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (TargetedAccountsAction);

/***/ }),

/***/ "pgka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);



var api = {
  fetchTargets: function fetchTargets() {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].get('/targets').checkStatus().retryWithBackoff().map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  createTarget: function createTarget(target) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].post('/targets', target).checkStatus().retryWithBackoff().map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  },
  patchTarget: function patchTarget(operations, id) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["RxConversationAPI"].patch('/targets/' + id, operations).checkStatus().retryWithBackoff().map(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
  }
};

/***/ }),

/***/ "pi86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var GateAPI = Marty.createStateSource({
  id: 'GateAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  setGate: function setGate(orgId, gateName, value) {
    return this.patch({
      url: '/gates/organizations/' + orgId,
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify([{ operation: 'set', property: gateName, value: value }])
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (GateAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "plGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("c9tv");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("zvtT");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "prel":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MappedUsers__ = __webpack_require__("XQet");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function mapStateToProps(state) {
  return {
    sfdcUserMappings: state.get('sfdc').sfdcUserMappings
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_0_app_modules_sfdc_actions__), dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__MappedUsers__["a" /* default */]));

/***/ }),

/***/ "puRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page__ = __webpack_require__("Ybad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleOAuthConnect__ = __webpack_require__("Zmw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MicrosoftOAuthConnect__ = __webpack_require__("dUcK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_onboarding_google_G_logo_L_svg__ = __webpack_require__("tPhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_images_onboarding_google_G_logo_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_images_onboarding_google_G_logo_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_logos_office_365_svg__ = __webpack_require__("Qb1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_images_logos_office_365_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_images_logos_office_365_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_settings_Settings_styl__ = __webpack_require__("cLnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_settings_Settings_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styles_components_settings_Settings_styl__);












var CalendarConnect = function CalendarConnect(_ref) {
  var googlePermissionError = _ref.googlePermissionError,
      setGooglePermissionErrorState = _ref.setGooglePermissionErrorState;

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2__page__["a" /* default */],
    null,
    React.createElement(
      'div',
      { className: 'subsection' },
      React.createElement(
        'div',
        { className: 'subheader select-calendar select-calendar-text' },
        'Connected Calendar'
      ),
      React.createElement(
        'div',
        { className: 'settings-body-copy select-calendar' },
        'Select which calendar you\u2019d like us to connect with. We\u2019ll check for any conflicts when new meetings are being scheduled, and add new calendar events to it.'
      ),
      googlePermissionError && React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["InlineWarning"], {
        title: 'Refresh your Google app permissions',
        copy: React.createElement(
          'span',
          null,
          'To re-connect your calendar, go to your ',
          React.createElement(
            'a',
            {
              onClick: function onClick() {
                return setGooglePermissionErrorState(false);
              },
              href: 'https://myaccount.google.com/permissions',
              target: '_blank',
              rel: 'noopener noreferrer'
            },
            'Google app permissions'
          ),
          ', open the Drift section and click "Remove access". Then come back here to re-connect your calendar!'
        ),
        buttonText: 'Manage Google Apps',
        onClick: function onClick() {
          window.open('https://myaccount.google.com/permissions', '_blank');
          setGooglePermissionErrorState(false);
        },
        className: 'google-app-permission-error'
      }),
      !googlePermissionError && React.createElement(
        'div',
        { className: 'setttings-calendar-connection-choices' },
        React.createElement(
          'div',
          { className: 'settings-calendar-connection-choice' },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_5_images_onboarding_google_G_logo_L_svg___default.a, alt: 'Google logo' }),
          React.createElement(
            'div',
            null,
            'Google Calendar'
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_3__GoogleOAuthConnect__["a" /* default */], { minimalUI: true, isMissingScopes: true, setGooglePermissionErrorState: setGooglePermissionErrorState })
        ),
        React.createElement(
          'div',
          { className: 'settings-calendar-connection-choice' },
          React.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6_images_logos_office_365_svg___default.a, alt: 'Outlook 365 logo' }),
          React.createElement(
            'div',
            null,
            'Office 365 Calendar'
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_4__MicrosoftOAuthConnect__["a" /* default */], { minimalUI: true })
        )
      ),
      React.createElement(
        'div',
        { className: 'assistant-footer' },
        React.createElement(
          'div',
          { className: 'subheader select-calendar' },
          'When you connect your calendar, you\u2019ll also get your own Drift Assistant'
        ),
        React.createElement(
          'p',
          { className: 'settings-body-copy assistant-helper-copy' },
          'The',
          ' ',
          React.createElement(
            'a',
            {
              href: 'https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work',
              target: '_blank',
              rel: 'noreferrer noopener'
            },
            'Drift Assistant'
          ),
          ' ',
          'helps you close more deals with less work. It prepares you for meetings and sends reminders so you never accidentally lose a lead or opportunity again.',
          ' ',
          React.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019617553-How-does-Drift-Assistant-Work', target: '_blank', rel: 'noreferrer noopener' },
            'Learn more'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["h" /* withRouter */])(CalendarConnect));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "pxbv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Conversations":"Conversations---QJ2YB"};

/***/ }),

/***/ "pyNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("pVow");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "pzVx":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M24 9h-2V4h-7V2h9v7zm-9 13v-2h7v-5h2v7h-9zM0 15h2v5h7v2H0v-7zM9 2v2H2v5H0V2h9z\"></path></svg>"

/***/ }),

/***/ "pzWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_user_agent_parser__ = __webpack_require__("r1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_user_agent_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_user_agent_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_message_selectors__ = __webpack_require__("bWf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__("O+OV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var ConversationSection = function (_Component) {
  _inherits(ConversationSection, _Component);

  function ConversationSection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConversationSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConversationSection.__proto__ || Object.getPrototypeOf(ConversationSection)).call.apply(_ref, [this].concat(args))), _this), _this.getFormattedUserAgentString = function (ua) {
      var browserString = _.compact([_.get(ua, 'browser.name'), _.get(ua, 'browser.version')]).join(' ');

      var osString = _.compact([_.get(ua, 'os.name'), _.get(ua, 'os.version')]).join(' ');

      return _.compact([browserString, osString]).join(' / ');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConversationSection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          ip = _props.ip,
          url = _props.url,
          ua = _props.ua;


      var userAgentString = this.getFormattedUserAgentString(ua);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__style__["conversationSection"], className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__driftt_tide_core_legacy__["Icon"], { name: 'chat-1', className: 'header-icon' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'section-title' },
            'Conversation Details'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'body-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-header' },
              'Conversation Started From'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-body' },
              url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: url },
                url
              ) : '-'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'body-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-header' },
              'Web Browser and Device'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-body' },
              !!userAgentString ? userAgentString : '-'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'body-row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-header' },
              'IP Address'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row-body' },
              ip ? ip : '-'
            )
          )
        )
      );
    }
  }]);

  return ConversationSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  var firstEndUserMessageSelector = __WEBPACK_IMPORTED_MODULE_5_app_modules_message_selectors__["a" /* firstEndUserMessage */]();

  return function (state, props) {
    var conversationId = props.conversationId;


    return {
      firstEndUserMessage: firstEndUserMessageSelector(state, { conversationId: conversationId })
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (props) {
  return !props.firstEndUserMessage;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["e" /* mapProps */])(function (_ref2) {
  var firstEndUserMessage = _ref2.firstEndUserMessage,
      props = _objectWithoutProperties(_ref2, ['firstEndUserMessage']);

  var userAgent = firstEndUserMessage.getIn(['context', 'userAgent']);
  var ua = userAgent && __WEBPACK_IMPORTED_MODULE_3_user_agent_parser___default()(userAgent);

  // edge case: the IE11 UA story
  // https://blogs.msdn.microsoft.com/ieinternals/2013/09/21/internet-explorer-11s-many-user-agent-strings/
  if (_.get(ua, 'browser.name') && _.get(ua, 'engine.name') === 'Trident') {
    ua.browser = { name: 'Internet Explorer', version: 11 };
  }

  return _extends({
    ip: firstEndUserMessage.getIn(['context', 'ip']),
    url: firstEndUserMessage.getIn(['context', 'page', 'href']),
    ua: ua
  }, props);
}))(ConversationSection));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "q/43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
    fetchPardotMappings: function fetchPardotMappings() {
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/mappings/attributes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
    },
    patchPardotMappings: function patchPardotMappings(mappings) {
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/pardot/mappings/attributes', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
    },
    fetchPardotFields: function fetchPardotFields() {
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/prospect/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
    },
    fetchPardotProspectCampaigns: function fetchPardotProspectCampaigns() {
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/pardot/campaigns').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
    },
    searchPardotProspectCampaigns: function searchPardotProspectCampaigns(name) {
        return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].post('/pardot/campaigns/search', {
            name: name
        }).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
    }
};

/***/ }),

/***/ "q/Xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard__ = __webpack_require__("sQ20");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("89IP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var InstallSnippetCard = function (_Component) {
  _inherits(InstallSnippetCard, _Component);

  function InstallSnippetCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InstallSnippetCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InstallSnippetCard.__proto__ || Object.getPrototypeOf(InstallSnippetCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      copied: false
    }, _this.onCopy = function () {
      _this.setState({ copied: true });

      setTimeout(function () {
        _this.setState({ copied: false });
      }, 1000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InstallSnippetCard, [{
    key: 'render',
    value: function render() {
      var snippet = this.props.snippet;
      var copied = this.state.copied;


      var copyText = copied ? "Copied!" : "Copy";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_copy_to_clipboard___default.a,
        { text: snippet, onCopy: this.onCopy },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.SnippetCard__container },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'pre',
            { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.SnippetCard__snippet },
            snippet
          ),
          copied && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'copy-button' },
            copyText
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'button',
            { className: 'drift-button' },
            'Copy Code'
          )
        )
      );
    }
  }]);

  return InstallSnippetCard;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

InstallSnippetCard.propTypes = {
  snippet: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (InstallSnippetCard);

/***/ }),

/***/ "q4i+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _, Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_shared_InlineEditor__ = __webpack_require__("D6+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Modal__ = __webpack_require__("3F5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_FormHelpers__ = __webpack_require__("eAP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mixins_MakeInputChangeHandler__ = __webpack_require__("0HTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_reply_ComposeReplyModal_styl__ = __webpack_require__("fQXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styles_components_reply_ComposeReplyModal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_styles_components_reply_ComposeReplyModal_styl__);









var ComposeReplyModal = React.createClass({
  displayName: 'ComposeReplyModal',

  mixins: [__WEBPACK_IMPORTED_MODULE_5_mixins_MakeInputChangeHandler__["a" /* default */]],

  getInitialState: function getInitialState() {
    var initialState = void 0;
    if (this.props.reply && !this.props.duplicate) {
      initialState = {
        name: this.props.reply.name,
        text: this.props.reply.text
      };
    } else {
      initialState = {
        name: '',
        text: this.props.populatedText || (this.props.reply != null ? this.props.reply.text : undefined) || ''
      };
    }

    initialState.isHandlingCreation = !this.props.reply || this.props.duplicate && this.props.reply;
    return initialState;
  },
  componentDidMount: function componentDidMount() {
    return this.cacheNamesTaken(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    return this.cacheNamesTaken(nextProps);
  },


  // optimization to not do this on render everything
  cacheNamesTaken: function cacheNamesTaken(props) {
    return this.setState({ replyNamesTaken: _.map(props.replyById, 'name') });
  },
  hasTextChanged: function hasTextChanged() {
    return this.state.text !== (this.props.reply != null ? this.props.reply.text : undefined);
  },
  hasChanged: function hasChanged() {
    return this.hasNameChanged() || this.hasTextChanged();
  },
  isNameValid: function isNameValid() {
    return this.state.name && !this.isNameTaken();
  },
  hasNameChanged: function hasNameChanged() {
    return this.state.name !== (this.props.reply != null ? this.props.reply.name : undefined);
  },
  getNameInputError: function getNameInputError() {
    if (this.isNameTaken()) {
      return 'Sorry, name is taken';
    }
  },
  isNameTaken: function isNameTaken() {
    if (this.state.name) {
      // check if name is taken on reply creation or edits of an existing reply when the name has changed.
      if (this.state.isHandlingCreation || !this.state.isHandlingCreation && this.hasNameChanged()) {
        return _.indexOf(this.state.replyNamesTaken, this.state.name) >= 0;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  canSave: function canSave() {
    return this.hasChanged() && this.isNameValid() && this.state.text;
  },
  tryRunOnSave: function tryRunOnSave() {
    var onSave = this.props.onSave;

    onSave && onSave();
  },
  tryRunOnClose: function tryRunOnClose() {
    var onClose = this.props.onClose;

    onClose && onClose();
  },
  onSaveClick: function onSaveClick() {
    if (this.canSave()) {
      if (!this.state.isHandlingCreation) {
        this.app.actions.SavedReplyActions.updateReply(this.props.reply.id, { name: this.state.name, text: this.state.text }, true).then(this.tryRunOnSave);
      } else {
        this.app.actions.SavedReplyActions.createReply({ name: this.state.name, text: this.state.text }).then(this.tryRunOnSave);
      }
    }

    this.tryRunOnClose();
  },
  render: function render() {
    return React.createElement(
      'div',
      {
        className: 'ComposeReplyModal',
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_4_utils_FormHelpers__["a" /* makeOnCommandEnterKeyHandler */])(this.onSaveClick) },
      React.createElement(
        'div',
        { className: 'modal-title' },
        !this.state.isHandlingCreation ? 'Edit This Reply' : 'Create New Saved Reply'
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        type: 'text',
        autoFocus: true,
        placeholder: 'Name (internal only)',
        valueLink: { value: this.state.name, requestChange: this.makeInputChangeHandler('name') },
        isValid: this.isNameValid(),
        errorLabel: this.getNameInputError() }),
      React.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_web_src_components_Input___default.a, {
        className: 'ComposeReplyModal--TextArea',
        inputComponent: __WEBPACK_IMPORTED_MODULE_0_components_shared_InlineEditor__["a" /* InlineEditor */],
        options: { placeholder: { text: 'What your visitor sees goes here' } },
        isSavedReplyEditor: true,
        onChange: this.makeInputChangeHandler('text'),
        isValid: this.state.text,
        text: this.state.text }),
      // TODO add tag functionality
      //React.DOM.div { className: 'tags' }
      React.createElement(
        'div',
        { className: 'actions' },
        React.createElement(
          'div',
          { className: 'cancel', onClick: this.props.onClose },
          'Cancel'
        ),
        React.createElement(
          'button',
          {
            className: 'color-teal',
            onClick: this.onSaveClick,
            disabled: !this.canSave() },
          'SAVE'
        )
      )
    );
  }
});

var ComposeReplyModalContainer = Marty.createContainer(ComposeReplyModal, {
  listenTo: ['stores.SavedReplyStore'],
  fetch: {
    replyById: function replyById() {
      return this.app.stores.SavedReplyStore.fetchReplyList();
    },
    reply: function reply() {
      if (this.props.params.replyId && this.props.params.replyId !== 'new') {
        return this.app.stores.SavedReplyStore.fetchReply(this.props.params.replyId);
      } else {
        return false;
      }
    }
  },

  pending: function pending() {
    return React.createElement(
      'div',
      { className: 'ComposeReplyModal' },
      React.createElement('div', { className: 'loader-rotating' })
    );
  },
  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
});

var ModalWrapper = React.createClass({
  displayName: 'ModalWrapper',
  render: function render() {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_2_components_Modal__["a" /* default */],
      { onClose: this.props.onClose, ignoreCloseOnClickOutside: true },
      React.createElement(ComposeReplyModalContainer, this.props)
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ModalWrapper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "q680":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__("oHQn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");








var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedGoalAction: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_70" /* selectedGoalAction */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withProps___default()(function (props) {
  return {
    selectedScore: _.get(props.selectedGoalAction, 'markCQL.score', null)
  };
}))(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "q8El":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);


/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var headline = _ref.headline,
      content = _ref.content,
      isExpanded = _ref.isExpanded,
      ctaCopy = _ref.ctaCopy,
      hideCta = _ref.hideCta,
      primaryColor = _ref.primaryColor,
      secondaryColor = _ref.secondaryColor;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'slider-message-callout' },
    (!isExpanded || hideCta) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'callout-tail' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'Content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Headline', isExpanded) },
        headline
      ),
      isExpanded && [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'ScrollableContent' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          content
        )
      ), !hideCta && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
          className: 'CtaButton',
          style: {
            backgroundColor: primaryColor,
            borderColor: primaryColor,
            color: secondaryColor,
            lineHeight: '18px',
            height: 'initial',
            padding: '8px' }
        },
        ctaCopy
      )]
    )
  );
});

/***/ }),

/***/ "qE/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__("jjhx");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DrupalInstaller = function (_Component) {
  _inherits(DrupalInstaller, _Component);

  function DrupalInstaller() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DrupalInstaller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DrupalInstaller.__proto__ || Object.getPrototypeOf(DrupalInstaller)).call.apply(_ref, [this].concat(args))), _this), _this.handleConnect = function () {
      Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* popUp */])({ path: __WEBPACK_IMPORTED_MODULE_2_constants_ResourcesConstants__["q" /* DRUPAL_PLUGIN_URL */] });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DrupalInstaller, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'The Drift Drupal Extension is provided via our community. Click below to download the plugin and upload it to your Drupal site via the extend section of your Drupal admin panel.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'After installing the plugin, you should see it as an installed module named ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'b',
            null,
            'Drift - Communication Tool'
          ),
          ', and be able to configure it in the admin panel under ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'i',
            null,
            '/admin/config/services/drift'
          ),
          '.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__["a" /* default */], {
          label: 'Download Drupal Module',
          handleConnect: this.handleConnect,
          connectorType: 'button',
          buttonType: 'tertiary'
        })
      );
    }
  }]);

  return DrupalInstaller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrupalInstaller);

/***/ }),

/***/ "qFJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var TagConstants = Marty.createConstants(['TAG_LIST_FETCH', 'TAG_CREATE', 'TAG_UPDATE', 'TAG_DELETE', 'TAG_ADD_TO_CONVERSATION_ID', 'TAG_REMOVE_FROM_CONVERSATION_ID', 'TAG_ADD_TO_END_USER_ID', 'TAG_REMOVE_FROM_END_USER_ID', 'TAG_ADD_TO_COMPANY_ID', 'TAG_REMOVE_FROM_COMPANY_ID', 'TAG_RESPONSE', 'PUSH_TAG']);

/* harmony default export */ __webpack_exports__["a"] = (TagConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "qGGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("DJjn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);




var SuggestIntegration = function SuggestIntegration(_ref) {
    var onClick = _ref.onClick;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'suggest-integration' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', { className: 'suggest-integration-hr' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'suggest-integration-header' },
                'Don\'t see what you\'re looking for? Let us know!'
            )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'suggest-integration-button-holder' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'suggest-integration-paragraph-holder' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'suggest-integration-paragraph' },
                    'Let our team know which integrations you\u2019re looking for! You can also check out',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'a',
                        { href: 'https://dev.drift.com', target: '_blank' },
                        ' Drift\u2019s dev platform '
                    ),
                    'to find ways to customize Drift to fit your team\u2019s needs. '
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Button"],
                { className: 'suggest-integration-button', onClick: onClick },
                ' Suggest an integration'
            )
        )
    );
};
/* harmony default export */ __webpack_exports__["a"] = (SuggestIntegration);

/***/ }),

/***/ "qHbA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qJND":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("9Cjf");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("Vjxe");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "qK29":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TYPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPING_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_TYPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_TYPING_FINISHED; });
var ACTION_PREFIX = '@@app/typing';
var makeConstant = function makeConstant(constant) {
  return ACTION_PREFIX + '/' + constant;
};

var TYPING = makeConstant('TYPING');
var TYPING_FINISHED = makeConstant('TYPING_FINISHED');

var USER_TYPING = makeConstant('USER_TYPING');
var USER_TYPING_FINISHED = makeConstant('USER_TYPING_FINISHED');

/***/ }),

/***/ "qKuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_branch__ = __webpack_require__("U77n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_branch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_branch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_renderNothing__ = __webpack_require__("c4Pn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_renderNothing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_renderNothing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_classification_actions__ = __webpack_require__("khns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_classification_selectors__ = __webpack_require__("27RM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_rules_selectors__ = __webpack_require__("+dPJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__component__ = __webpack_require__("2oiS");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



























var mapStateToProps = function mapStateToProps(state) {
  return {
    playbookId: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["p" /* draftId */](state),
    goal: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["j" /* currentGoal */](state),
    goalRouting: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["k" /* currentGoalRouting */](state),
    goals: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_23" /* goals */](state),
    isMessageTypePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_42" /* isMessageTypePlaybook */](state),
    isCaptureTypePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_32" /* isCaptureTypePlaybook */](state),
    isCtaTypePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_34" /* isCtaTypePlaybook */](state),
    isChatTypePlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_33" /* isChatTypePlaybook */](state),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state),
    isABMPlaybook: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_28" /* isABMPlaybook */](state),
    hasRoutingAction: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_0" /* getHasRoutingAction */](state),
    isMeetingCta: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_41" /* isMeetingCta */](state),
    classificationOptions: __WEBPACK_IMPORTED_MODULE_13_app_modules_classification_selectors__["a" /* classificationOptions */](state),
    orgUsersById: __WEBPACK_IMPORTED_MODULE_14_app_modules_user_selectors__["orgUsersById"](state),
    userIdsForRules: __WEBPACK_IMPORTED_MODULE_15_app_modules_rules_selectors__["c" /* userIdsForRules */](state),
    calendarConnectedAgentIds: __WEBPACK_IMPORTED_MODULE_16_app_modules_meetings_selectors__["a" /* getAgentIdsWithConnectedCalendars */](state),
    reportType: __WEBPACK_IMPORTED_MODULE_10_app_modules_playbook_selectors__["_67" /* reportType */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      createClassifications: __WEBPACK_IMPORTED_MODULE_12_app_modules_classification_actions__["a" /* createClassifications */],
      setGoalClassification: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_173" /* setGoalClassification */],
      setCurrentGoalId: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_147" /* setCurrentGoalId */],
      setMessageActionBody: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_174" /* setGoalMessage */],
      showGoalActionModal: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_232" /* showGoalActionModal */],
      showGoalRoutingModal: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_233" /* showGoalRoutingModal */],
      selectGoalAction: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_123" /* selectGoalAction */],
      selectGoalRoutingOptionUI: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_124" /* selectGoalRoutingOptionUI */],
      removeGoalAction: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["_103" /* removeGoalAction */],
      deleteGoal: __WEBPACK_IMPORTED_MODULE_9_app_modules_playbook_actions__["K" /* deleteGoal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_branch___default()(function (props) {
  return !props.goal || !props.classificationOptions.length || !props.orgUsersById.size;
}, __WEBPACK_IMPORTED_MODULE_5_recompose_renderNothing___default.a), __WEBPACK_IMPORTED_MODULE_7_recompose_withProps___default()(function (props) {
  return {
    copy: __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_297" /* playbooksCopy */][props.reportType].goals,
    classificationDetails: props.classificationOptions.find(function (classification) {
      return classification.value === props.goal.classification.get('classificationId');
    }),
    isGlobalRouting: props.goalRouting.get('type') === __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_150" /* RoutingType */].GLOBAL,
    isSingleRouting: props.goalRouting.get('type') === __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE,
    isGroupRouting: props.goalRouting.get('type') === __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_150" /* RoutingType */].GROUP,
    isNoRouting: props.goalRouting.get('type') === __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_150" /* RoutingType */].NONE,
    isMessage: props.goal && !!props.goal.get('message'),
    isCQL: props.goal && !!props.goal.get('markCQL'),
    cqlScore: props.goal && +_.get(props.goal.toJS(), 'markCQL.score', 0),
    isScheduling: props.goal && !!props.goal.get('schedule'),
    isStatusChange: props.goal && !!props.goal.get('statusChange'),
    isLastGoal: props.goals && props.goals.size == 1,
    singleRoutingTargetUser: props.goalRouting.get('type') === __WEBPACK_IMPORTED_MODULE_17_app_modules_playbook_constants__["_150" /* RoutingType */].SINGLE && props.orgUsersById.find(function (user) {
      return user.id === props.goalRouting.get('userId');
    }),
    usersForGlobalRules: props.userIdsForRules && props.userIdsForRules.map(function (ruleUserId) {
      return props.orgUsersById.find(function (user) {
        return user.id === ruleUserId;
      });
    }),
    groupRoutingTargetUsers: (props.goalRouting.get('userIds') || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).map(function (userId) {
      return props.orgUsersById.find(function (user) {
        return user.id === userId;
      });
    })
  };
}), __WEBPACK_IMPORTED_MODULE_8_recompose_lifecycle___default()({
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        actions = _props.actions,
        goalRouting = _props.goalRouting;

    actions.selectGoalRoutingOptionUI(goalRouting || __WEBPACK_IMPORTED_MODULE_11_app_modules_playbook_models__["n" /* RoutingOption */]());
  }
}), __WEBPACK_IMPORTED_MODULE_6_recompose_withHandlers___default()({
  singleRoutingInvalidUsers: function singleRoutingInvalidUsers(props) {
    return function () {
      if (!props.isScheduling || !props.goal || !props.orgUsersById) return [];
      var userId = props.goal.routing.get('userId');
      if (!props.calendarConnectedAgentIds.includes(userId)) {
        return [props.orgUsersById.get(userId)];
      }
      return [];
    };
  },
  globalRoutingInvalidUsers: function globalRoutingInvalidUsers(props) {
    return function () {
      if (!props.isScheduling) return [];
      var userIds = props.userIdsForRules ? props.userIdsForRules : [];
      return userIds.filter(function (id) {
        return !props.calendarConnectedAgentIds.includes(id);
      }).map(function (id) {
        return props.orgUsersById.get(id);
      }).filter(Boolean);
    };
  },
  onGoalDeleteClick: function onGoalDeleteClick(props) {
    return function () {
      var deleteGoal = props.actions.deleteGoal,
          goals = props.goals,
          id = props.goal.id,
          playbookId = props.playbookId;

      var redirectToGoalId = goals.reduce(function (redirectId, goal) {
        return !redirectId && goal.id !== id ? goal.id : redirectId;
      }, false);
      deleteGoal({ goalId: id, playbookId: playbookId });
      props.router.replace('/playbooks/' + playbookId + '/edit/goal/' + redirectToGoalId);
    };
  },
  onEditRoutingClick: function onEditRoutingClick(props) {
    return function () {
      var showGoalRoutingModal = props.actions.showGoalRoutingModal,
          id = props.goal.id;

      showGoalRoutingModal(id);
    };
  },
  onEditActionClick: function onEditActionClick(props) {
    return function (actionProperty) {
      var _props$actions = props.actions,
          showGoalActionModal = _props$actions.showGoalActionModal,
          selectGoalAction = _props$actions.selectGoalAction,
          goal = props.goal;

      selectGoalAction(_defineProperty({}, actionProperty, goal.get(actionProperty)));
      showGoalActionModal(goal.id);
    };
  },
  onDeleteActionClick: function onDeleteActionClick(props) {
    return function (actionProperty) {
      var removeGoalAction = props.actions.removeGoalAction,
          id = props.goal.id;

      removeGoalAction({ goalId: id, goalActionProperty: actionProperty });
    };
  },
  onAddActionClick: function onAddActionClick(props) {
    return function () {
      var showGoalActionModal = props.actions.showGoalActionModal,
          id = props.goal.id;

      showGoalActionModal(id);
    };
  },
  onClassificationChange: function onClassificationChange(props) {
    return function (event) {
      if (!event || !event.value || event.value.includes(' ')) return false;
      props.actions.setGoalClassification({
        goalId: props.goal.id,
        classificationId: event.value
      });
    };
  },
  onNewClassificationClick: function onNewClassificationClick(props) {
    return function (_ref) {
      var label = _ref.label;

      props.actions.createClassifications([{ name: label }]);
    };
  },
  onMessageActionBodyChange: function onMessageActionBodyChange(props) {
    return function (body) {
      props.actions.setMessageActionBody({ goalId: props.goal.id, body: body });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_18__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "qMuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__ = __webpack_require__("1WKC");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var ApiKeyActions = Marty.createActionCreators({
  getApiKeyByOrgId: function getApiKeyByOrgId(orgId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_ApiKeyConstants__["a" /* default */].GET_API_KEY, orgId);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ApiKeyActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "qNcR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__ = __webpack_require__("dZeU");
/* eslint-disable
    no-undef,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


var OrgActions = Marty.createActionCreators({
  createOrgWithSettings: function createOrgWithSettings(settings) {
    return this.app.queries.UserQueries.createUserWithEmail(email, password);
  },
  shareSnippet: function shareSnippet(email, orgId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_OrgConstants__["a" /* default */].SHARE_SNIPPET, email, orgId);
  },
  updateOrg: function updateOrg(orgId, update) {
    return this.app.queries.OrgQueries.updateOrg(orgId, update);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "qNox":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Toggle__ = __webpack_require__("Q0tM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_payments_Gates__ = __webpack_require__("G69f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_PremiumOverlay__ = __webpack_require__("6y6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("YwUe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);







var BOLT_SRC = __webpack_require__("b93K");

var brandingFeatureText = 'Custom Branding';
var brandingPlan = 'Pro';

var BrandingLink = function BrandingLink() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.BrandingLink },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      { className: 'widget-settings-section-header-title' },
      'Show Drift Branding'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'widget-settings-section-header-desc' },
      'When this is enabled, Drift branding will be displayed on your Drift Widget, Drift Meetings, Drift Profile and your Drift emails.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex' },
      'Chat',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { className: 'flex', src: BOLT_SRC, style: { margin: '0 0.25rem' } }),
      'by',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { style: { margin: '0 0.25rem', fontWeight: 500 } },
        'Drift'
      )
    )
  );
};

var Disabled = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_4_components_shared_PremiumOverlay__["a" /* default */],
  { className: 'DriftBrandingContainerDisabled' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'upgrade-prompt' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex-space-between' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrandingLink, null)
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'upgrade-prompt-text-container', style: { margin: "15px", height: "65px", "font-size": "13px" } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-prompt-text' },
        'To remove Drift'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-prompt-text' },
        'branding from the'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-prompt-text' },
        'chat widget\u2026'
      )
    )
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toggle__["a" /* default */], { checked: true, disabled: true })
);

var DriftBranding = function DriftBranding(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_components_payments_Gates__["b" /* PremiumTeamGate */],
    {
      FallbackComponent: Disabled,
      useModal: true,
      modalText: brandingFeatureText,
      modalPlan: brandingPlan,
      feature: 'drift-branding'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'flex-space-between' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BrandingLink, null),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Toggle__["a" /* default */], { defaultChecked: value, onChange: onChange })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DriftBranding);

/***/ }),

/***/ "qQ9Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countries; });
var countries = {
  'AF': 'Afghanistan',
  'AX': 'Aland Islands',
  'AL': 'Albania',
  'DZ': 'Algeria',
  'AS': 'American Samoa',
  'AD': 'Andorra',
  'AO': 'Angola',
  'AI': 'Anguilla',
  'AQ': 'Antarctica',
  'AG': 'Antigua And Barbuda',
  'AR': 'Argentina',
  'AM': 'Armenia',
  'AW': 'Aruba',
  'AU': 'Australia',
  'AT': 'Austria',
  'AZ': 'Azerbaijan',
  'BS': 'Bahamas',
  'BH': 'Bahrain',
  'BD': 'Bangladesh',
  'BB': 'Barbados',
  'BY': 'Belarus',
  'BE': 'Belgium',
  'BZ': 'Belize',
  'BJ': 'Benin',
  'BM': 'Bermuda',
  'BT': 'Bhutan',
  'BO': 'Bolivia',
  'BA': 'Bosnia And Herzegovina',
  'BW': 'Botswana',
  'BV': 'Bouvet Island',
  'BR': 'Brazil',
  'IO': 'British Indian Ocean Territory',
  'BN': 'Brunei Darussalam',
  'BG': 'Bulgaria',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodia',
  'CM': 'Cameroon',
  'CA': 'Canada',
  'CV': 'Cape Verde',
  'KY': 'Cayman Islands',
  'CF': 'Central African Republic',
  'TD': 'Chad',
  'CL': 'Chile',
  'CN': 'China',
  'CX': 'Christmas Island',
  'CC': 'Cocos (Keeling) Islands',
  'CO': 'Colombia',
  'KM': 'Comoros',
  'CG': 'Congo',
  'CD': 'Congo, Democratic Republic',
  'CK': 'Cook Islands',
  'CR': 'Costa Rica',
  'CI': 'Cote D\'Ivoire',
  'HR': 'Croatia',
  'CU': 'Cuba',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'DK': 'Denmark',
  'DJ': 'Djibouti',
  'DM': 'Dominica',
  'DO': 'Dominican Republic',
  'EC': 'Ecuador',
  'EG': 'Egypt',
  'SV': 'El Salvador',
  'GQ': 'Equatorial Guinea',
  'ER': 'Eritrea',
  'EE': 'Estonia',
  'ET': 'Ethiopia',
  'FK': 'Falkland Islands (Malvinas)',
  'FO': 'Faroe Islands',
  'FJ': 'Fiji',
  'FI': 'Finland',
  'FR': 'France',
  'GF': 'French Guiana',
  'PF': 'French Polynesia',
  'TF': 'French Southern Territories',
  'GA': 'Gabon',
  'GM': 'Gambia',
  'GE': 'Georgia',
  'DE': 'Germany',
  'GH': 'Ghana',
  'GI': 'Gibraltar',
  'GR': 'Greece',
  'GL': 'Greenland',
  'GD': 'Grenada',
  'GP': 'Guadeloupe',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GG': 'Guernsey',
  'GN': 'Guinea',
  'GW': 'Guinea-Bissau',
  'GY': 'Guyana',
  'HT': 'Haiti',
  'HM': 'Heard Island & Mcdonald Islands',
  'VA': 'Holy See (Vatican City State)',
  'HN': 'Honduras',
  'HK': 'Hong Kong',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IN': 'India',
  'ID': 'Indonesia',
  'IR': 'Iran, Islamic Republic Of',
  'IQ': 'Iraq',
  'IE': 'Ireland',
  'IM': 'Isle Of Man',
  'IL': 'Israel',
  'IT': 'Italy',
  'JM': 'Jamaica',
  'JP': 'Japan',
  'JE': 'Jersey',
  'JO': 'Jordan',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KI': 'Kiribati',
  'KR': 'Korea',
  'KW': 'Kuwait',
  'KG': 'Kyrgyzstan',
  'LA': 'Lao People\'s Democratic Republic',
  'LV': 'Latvia',
  'LB': 'Lebanon',
  'LS': 'Lesotho',
  'LR': 'Liberia',
  'LY': 'Libyan Arab Jamahiriya',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MO': 'Macao',
  'MK': 'Macedonia',
  'MG': 'Madagascar',
  'MW': 'Malawi',
  'MY': 'Malaysia',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malta',
  'MH': 'Marshall Islands',
  'MQ': 'Martinique',
  'MR': 'Mauritania',
  'MU': 'Mauritius',
  'YT': 'Mayotte',
  'MX': 'Mexico',
  'FM': 'Micronesia, Federated States Of',
  'MD': 'Moldova',
  'MC': 'Monaco',
  'MN': 'Mongolia',
  'ME': 'Montenegro',
  'MS': 'Montserrat',
  'MA': 'Morocco',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibia',
  'NR': 'Nauru',
  'NP': 'Nepal',
  'NL': 'Netherlands',
  'AN': 'Netherlands Antilles',
  'NC': 'New Caledonia',
  'NZ': 'New Zealand',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigeria',
  'NU': 'Niue',
  'NF': 'Norfolk Island',
  'MP': 'Northern Mariana Islands',
  'NO': 'Norway',
  'OM': 'Oman',
  'PK': 'Pakistan',
  'PW': 'Palau',
  'PS': 'Palestinian Territory, Occupied',
  'PA': 'Panama',
  'PG': 'Papua New Guinea',
  'PY': 'Paraguay',
  'PE': 'Peru',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Poland',
  'PT': 'Portugal',
  'PR': 'Puerto Rico',
  'QA': 'Qatar',
  'RE': 'Reunion',
  'RO': 'Romania',
  'RU': 'Russian Federation',
  'RW': 'Rwanda',
  'BL': 'Saint Barthelemy',
  'SH': 'Saint Helena',
  'KN': 'Saint Kitts And Nevis',
  'LC': 'Saint Lucia',
  'MF': 'Saint Martin',
  'PM': 'Saint Pierre And Miquelon',
  'VC': 'Saint Vincent And Grenadines',
  'WS': 'Samoa',
  'SM': 'San Marino',
  'ST': 'Sao Tome And Principe',
  'SA': 'Saudi Arabia',
  'SN': 'Senegal',
  'RS': 'Serbia',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapore',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'SB': 'Solomon Islands',
  'SO': 'Somalia',
  'ZA': 'South Africa',
  'GS': 'South Georgia And Sandwich Isl.',
  'ES': 'Spain',
  'LK': 'Sri Lanka',
  'SD': 'Sudan',
  'SR': 'Suriname',
  'SJ': 'Svalbard And Jan Mayen',
  'SZ': 'Swaziland',
  'SE': 'Sweden',
  'CH': 'Switzerland',
  'SY': 'Syrian Arab Republic',
  'TW': 'Taiwan',
  'TJ': 'Tajikistan',
  'TZ': 'Tanzania',
  'TH': 'Thailand',
  'TL': 'Timor-Leste',
  'TG': 'Togo',
  'TK': 'Tokelau',
  'TO': 'Tonga',
  'TT': 'Trinidad And Tobago',
  'TN': 'Tunisia',
  'TR': 'Turkey',
  'TM': 'Turkmenistan',
  'TC': 'Turks And Caicos Islands',
  'TV': 'Tuvalu',
  'UG': 'Uganda',
  'UA': 'Ukraine',
  'AE': 'United Arab Emirates',
  'GB': 'United Kingdom',
  'US': 'United States',
  'UM': 'United States Outlying Islands',
  'UY': 'Uruguay',
  'UZ': 'Uzbekistan',
  'VU': 'Vanuatu',
  'VE': 'Venezuela',
  'VN': 'Viet Nam',
  'VG': 'Virgin Islands, British',
  'VI': 'Virgin Islands, U.S.',
  'WF': 'Wallis And Futuna',
  'EH': 'Western Sahara',
  'YE': 'Yemen',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe'
};

/***/ }),

/***/ "qTcJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__ = __webpack_require__("9eSk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_store__ = __webpack_require__("Tvnw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_reports_demodata__ = __webpack_require__("tgWY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");






var _require$default = __webpack_require__("h6+o").default,
    FETCH_ORG_END_USER_COUNT_DONE = _require$default.FETCH_ORG_END_USER_COUNT_DONE,
    FETCH_ORG_END_USER_COUNT_HISTORY_DONE = _require$default.FETCH_ORG_END_USER_COUNT_HISTORY_DONE;

var NotFoundUser = {
  timeZone: null,
  locale: null,
  raw: null,
  name: 'Deleted User',
  type: 'END_USER',
  attributes: {}
};

var EndUserQueries = Marty.createQueries({
  id: 'EndUserQueries',

  fetchEndUser: function fetchEndUser(endUserId) {
    var _this = this;

    var endUserPromise = this.app.sources.EndUserAPI.fetchEndUser(endUserId);

    endUserPromise.then(function (res) {
      if (res.status === 200 || 404) {
        var found = res.status === 200;
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_FETCH_DONE, endUserId, found ? res.body : _.extend({ id: endUserId }, NotFoundUser));
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_FETCH_FAILED, endUserId, res);
      }
    });

    return endUserPromise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_FETCH_FAILED, endUserId, error);
    });
  },
  fetchEndUsers: function fetchEndUsers(endUserIds) {
    var _this2 = this;

    var promise = this.app.sources.EndUserAPI.fetchEndUsers(endUserIds);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USERS_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USERS_FETCH_FAILED, endUserIds, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USERS_FETCH_FAILED, endUserIds, error);
    });
  },
  fetchEndUserSegments: function fetchEndUserSegments(endUserId, orgId) {
    var _this3 = this;

    var promise = this.app.sources.EndUserAPI.fetchEndUserSegments(endUserId, orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_SEGMENTS_FETCH_DONE, endUserId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_SEGMENTS_FETCH_FAILED, endUserId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_SEGMENTS_FETCH_FAILED, endUserId, error);
    });
  },
  fetchOrgEndUserCount: function fetchOrgEndUserCount(orgId, startDate) {
    var _this4 = this;

    var promise = this.app.sources.EndUserAPI.fetchOrgEndUserCount(orgId, startDate);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(FETCH_ORG_END_USER_COUNT_DONE, res.body, startDate);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
      }
    });

    return promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
    });
  },
  fetchOrgEndUserCountHistory: function fetchOrgEndUserCountHistory(orgId, startDate, endDate) {
    var _this5 = this;

    var promise = this.app.sources.EndUserAPI.fetchOrgEndUserCountHistory(orgId, startDate, endDate);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(FETCH_ORG_END_USER_COUNT_HISTORY_DONE, res.body);
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
      }
    });

    return promise.catch(function (error) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
    });
  },
  fetchEndUserAttributesForOrg: function fetchEndUserAttributesForOrg(orgId) {
    var _this6 = this;

    var promise = this.app.sources.EndUserAPI.fetchEndUserAttributesForOrg(orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_ATTRIBUTES_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_ATTRIBUTES_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_ATTRIBUTES_FETCH_FAILED, error);
    });
  },
  createEndUserForOrgId: function createEndUserForOrgId(endUser, orgId) {
    var _this7 = this;

    var promise = this.app.sources.EndUserAPI.createEndUserForOrgId(endUser, orgId);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].CREATE_USER_FOR_ORG_ID_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].CREATE_USER_FOR_ORG_ID_FAILED, endUser, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].CREATE_USER_FOR_ORG_ID_FAILED, endUser, error);
    });
  },
  searchEndUser: function searchEndUser(orgId, query) {
    var _this8 = this;

    var promise = this.app.sources.EndUserAPI.searchEndUser(orgId, query);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].SEARCH_END_USER_DONE, orgId, query, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].SEARCH_END_USER_FAILED, orgId, query, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].SEARCH_END_USER_FAILED, orgId, query, error);
    });
  },
  elasticSearchEndUser: function elasticSearchEndUser(orgId, query) {
    var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;

    var _this9 = this;

    var sortField = arguments[4];
    var sortDirection = arguments[5];


    if (__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["i" /* hasDemoOrg */](__WEBPACK_IMPORTED_MODULE_2_containers_store__["a" /* default */].getState())) {
      return Promise.resolve(this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].ELASTIC_SEARCH_END_USER_DONE, orgId, query, from, size, sortField, sortDirection, __WEBPACK_IMPORTED_MODULE_3_app_modules_reports_demodata__["a" /* demoContacts */]));
    }

    var promise = this.app.sources.EndUserAPI.elasticSearchEndUser(orgId, query, from, size, sortField, sortDirection);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].ELASTIC_SEARCH_END_USER_DONE, orgId, query, from, size, sortField, sortDirection, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].ELASTIC_SEARCH_END_USER_FAILED, orgId, query, from, size, sortField, sortDirection, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].ELASTIC_SEARCH_END_USER_FAILED, orgId, query, from, size, sortField, sortDirection, error);
    });
  },
  deleteBySegment: function deleteBySegment(orgId, segmentId) {
    var _this10 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_BULK_STARTING);
    return this.app.sources.EndUserAPI.deleteBySegment(orgId, segmentId).then(function (res) {
      if (res.status === 200) {
        _this10.app.actions.NotificationActions.pushNotification({
          content: 'Your contacts have been successfully deleted.',
          variant: 'green'
        });
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_BULK_DONE, segmentId);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this10.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_BULK_FAILED, segmentId);
      }
    });
  },
  deleteEndUsers: function deleteEndUsers(endUserIds) {
    var _this11 = this;

    var promises = _.map(endUserIds, function (endUserId) {
      return _this11.app.sources.EndUserAPI.updateEndUser(endUserId, { status: 'ARCHIVED' });
    });
    var promise = Promise.all(promises);
    promise.then(function (responses) {
      if (_.every(responses, function (response) {
        return response.status === 200;
      })) {
        return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_DONE, endUserIds);
      } else {
        return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_FAILED, endUserIds);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this11.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].DELETE_END_USERS_FAILED, endUserIds);
    });
  },
  updateEndUser: function updateEndUser(endUserId, endUserParams, accessToken) {
    var _this12 = this;

    var promise = this.app.sources.EndUserAPI.updateEndUser(endUserId, endUserParams, accessToken);

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_STARTING, endUserId);
    promise.then(function (res) {
      if (res.status === 200) {
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_DONE, res.body, endUserParams);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_FAILED, endUserId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this12.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UPDATE_FAILED, endUserId, error);
    });
  },
  unsubscribeEndUser: function unsubscribeEndUser(endUserId, campaignId, reason) {
    var _this13 = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_STARTING, endUserId);
    return this.app.sources.EndUserAPI.unsubscribeEndUser(endUserId, campaignId, reason).then(function (res) {
      if (res.status >= 200 && res.status < 300) {
        return _this13.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_DONE, endUserId);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this13.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_EndUserConstants__["a" /* default */].END_USER_UNSUBSCRIBE_FAILED, res);
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "qUe4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"org-switcher":"org-switcher---2uV8k","organization-info-container":"organization-info-container---1lCLg","organization-global-name":"organization-global-name---2eF6A","org-switcher-header":"org-switcher-header---34-6n","org-switcher-provision":"org-switcher-provision---1Vx_i","org-switcher-increment":"org-switcher-increment---2_5mW","org-logo":"org-logo---3s9GA","organization-access-right":"organization-access-right---3djql"};

/***/ }),

/***/ "qV5s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qWFi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/on24.58184717.svg";

/***/ }),

/***/ "qXGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var SavedReplyConstants = Marty.createConstants(['REPLY_LIST_FETCH', 'REPLY_FETCH', 'UPDATE_REPLY', 'CREATE_REPLY', 'SET_REPLY_TO_POPULATE']);

/* harmony default export */ __webpack_exports__["a"] = (SavedReplyConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "qbTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildMappings; });
var buildMappings = function buildMappings(values, fieldList, valueSet) {
  _.map(values, function (value) {
    fieldList.push({ label: value.label, value: value.name });
    valueSet[value.name] = {
      valueType: value.type,
      fieldLabel: value.label,
      picklistValues: _.map(value.picklistValues, function (picklistValue) {
        return {
          label: picklistValue.label,
          value: picklistValue.value
        };
      })
    };
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "qbtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__ = __webpack_require__("lU3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SegmentSelectHelper__ = __webpack_require__("iKCO");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var SegmentStore = Marty.createStore({
  id: 'SegmentStore',

  getInitialState: function getInitialState() {
    return {
      // TODO each request should have its own status
      // overloading this map so when the request is done, the state is the segmentId
      requestIdToState: {},
      requestIdToSegmentId: {},
      createSegmentStatus: undefined,
      segmentsById: {},
      elasticSearchMembersBySegmentId: {},
      activeCampaignsBySegmentId: {}
    };
  },


  handlers: {
    createSegmentStarting: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_STARTING,
    createSegmentFailed: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED,
    createSegmentDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_DONE,

    fetchSegmentsDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENTS_FETCH_DONE,
    fetchSegmentDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_FETCH_DONE,
    elasticSearchMembersDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ELASTIC_SEARCH_MEMBERS_DONE,

    deleteSegmentDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].DELETE_SEGMENT_DONE,

    handleSegmentAddMembers: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ADD_MEMBERS_DONE,
    handleSegmentDeleteMembers: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_DELETE_MEMBERS_DONE,

    fetchCampaignsForSegmentDone: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].GET_CAMPAIGNS_FOR_SEGMENT_DONE
  },

  getOrFetchSegments: function getOrFetchSegments() {
    return this.fetch({
      id: 'getOrFetchSegments',

      locally: function locally() {
        if (this.hasAlreadyFetched('getOrFetchSegments')) {
          var segments = _.values(this.state.segmentsById);
          return _.orderBy(segments, 'createdAt', 'desc');
        }
      },
      remotely: function remotely() {
        return this.app.queries.SegmentQueries.fetchSegments();
      }
    });
  },
  fetchEnabledSegments: function fetchEnabledSegments() {
    return this.fetch({
      id: 'fetchEnabledSegments',
      dependsOn: [this.getOrFetchSegments()],
      locally: function locally() {
        return _.filter(this.state.segmentsById, function (segment) {
          return !Object(__WEBPACK_IMPORTED_MODULE_1_utils_SegmentSelectHelper__["b" /* isSegmentHidden */])(segment);
        });
      }
    });
  },
  fetchEnabledSegmentsGroupedByType: function fetchEnabledSegmentsGroupedByType() {
    return this.fetch({
      id: 'fetchEnabledSegmentsGroupedByType',
      dependsOn: [this.getOrFetchSegments()],
      locally: function locally() {
        var segments = _.filter(this.state.segmentsById, function (segment) {
          return !Object(__WEBPACK_IMPORTED_MODULE_1_utils_SegmentSelectHelper__["b" /* isSegmentHidden */])(segment);
        });
        return _.groupBy(segments, 'type');
      }
    });
  },
  fetchEnabledSegmentsByName: function fetchEnabledSegmentsByName() {
    return this.fetch({
      id: 'fetchEnabledSegmentsByName',
      dependsOn: [this.getOrFetchSegments()],
      locally: function locally() {
        var enabledSegments = _.filter(this.state.segmentsById, function (segment) {
          return !Object(__WEBPACK_IMPORTED_MODULE_1_utils_SegmentSelectHelper__["b" /* isSegmentHidden */])(segment);
        });
        return _.keyBy(enabledSegments, 'name');
      }
    });
  },
  fetchStaticSegments: function fetchStaticSegments() {
    return this.fetch({
      id: 'fetchStaticSegments',
      dependsOn: [this.getOrFetchSegments()],
      locally: function locally() {
        return _.filter(this.state.segmentsById, function (segment) {
          return segment.type === 'ID_LIST' && !Object(__WEBPACK_IMPORTED_MODULE_1_utils_SegmentSelectHelper__["b" /* isSegmentHidden */])(segment);
        });
      }
    });
  },
  getOrFetchSegment: function getOrFetchSegment(segmentId) {
    return this.fetch({
      id: 'getOrFetchSegment' + segmentId,

      locally: function locally() {
        return this.state.segmentsById[segmentId];
      },
      remotely: function remotely() {
        return this.app.queries.SegmentQueries.fetchSegment(segmentId);
      }
    });
  },
  fetchCampaignsForSegment: function fetchCampaignsForSegment(segmentId) {
    return this.fetch({
      id: 'fetchCampaignsForSegment' + segmentId,
      locally: function locally() {
        return this.state.activeCampaignsBySegmentId[segmentId];
      },
      remotely: function remotely() {
        return this.app.queries.SegmentQueries.getCampaignsForSegment(segmentId);
      }
    });
  },
  fetchCampaignsForSegmentDone: function fetchCampaignsForSegmentDone(segmentId, campaigns) {
    var activeCampaignsBySegmentId = _.cloneDeep(this.state.activeCampaignsBySegmentId);
    activeCampaignsBySegmentId[segmentId] = campaigns;
    return this.setState({ activeCampaignsBySegmentId: activeCampaignsBySegmentId });
  },
  getCreateSegmentStatus: function getCreateSegmentStatus() {
    return this.state.createSegmentStatus;
  },
  getLastSegmentCreated: function getLastSegmentCreated() {
    return this.state.lastSegmentCreated;
  },
  createSegmentStarting: function createSegmentStarting(requestId) {
    var requestIdToState = _.cloneDeep(this.state.requestIdToState);
    requestIdToState[requestId] = __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_STARTING;
    return this.setState({
      requestIdToState: requestIdToState,
      createSegmentStatus: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_STARTING
    });
  },
  createSegmentFailed: function createSegmentFailed(requestId) {
    var requestIdToState = _.cloneDeep(this.state.requestIdToState);
    requestIdToState[requestId] = __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED;
    return this.setState({
      requestIdToState: requestIdToState,
      createSegmentStatus: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED
    });
  },
  fetchSegmentDone: function fetchSegmentDone(segmentId, segment) {
    var segmentsById = _.cloneDeep(this.state.segmentsById);
    segmentsById[segmentId] = segment;
    return this.setState({ segmentsById: segmentsById });
  },
  deleteSegmentDone: function deleteSegmentDone(segmentId) {
    var segmentsById = _.cloneDeep(this.state.segmentsById);
    delete segmentsById[segmentId];
    return this.setState({ segmentsById: segmentsById });
  },
  fetchSegmentsDone: function fetchSegmentsDone(segments) {
    var segmentsById = _.cloneDeep(this.state.segmentsById);
    _.each(segments, function (segment) {
      return segmentsById[segment.id] = segment;
    });
    return this.setState({ segmentsById: segmentsById });
  },
  createSegmentDone: function createSegmentDone(requestId, segment) {
    var segmentsById = _.cloneDeep(this.state.segmentsById);
    segmentsById[segment.id] = segment;
    var requestIdToState = _.cloneDeep(this.state.requestIdToState);
    requestIdToState[requestId] = segment.id;
    return this.setState({
      segmentsById: segmentsById,
      requestIdToState: requestIdToState,
      createSegmentStatus: __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_DONE,
      lastSegmentCreated: segment
    });
  },
  getRequestIdToState: function getRequestIdToState() {
    return this.state.requestIdToState;
  },
  getSegmentsById: function getSegmentsById() {
    return this.state.segmentsById;
  },
  resetCreationState: function resetCreationState() {
    return this.setState({
      createSegmentStatus: undefined,
      lastSegmentCreated: undefined
    });
  },
  elasticSearchMembersOfSegment: function elasticSearchMembersOfSegment(segmentId, from, size) {
    var fetchId = 'elasticSearchMembersOfSegment' + segmentId + '[' + from + '-' + size + ']';
    return this.fetch({
      id: fetchId,
      locally: function locally() {
        var membersForSegmentId = this.state.elasticSearchMembersBySegmentId[segmentId];
        if (membersForSegmentId) {
          return membersForSegmentId[this.generateElasticSearchCacheId(from, size)];
        }
      },
      remotely: function remotely() {
        return this.app.queries.SegmentQueries.elasticSearchMembersOfSegment(segmentId, from, size);
      }
    });
  },
  generateElasticSearchCacheId: function generateElasticSearchCacheId(from, size) {
    var sizeQuery = {};
    if (from != null) {
      sizeQuery.from = from;
    }
    if (size != null) {
      sizeQuery.size = size;
    }
    return JSON.stringify(sizeQuery);
  },
  handleSegmentAddMembers: function handleSegmentAddMembers(segmentId) {
    return this.resetElasticSearchMembersForSegment(segmentId);
  },
  handleSegmentDeleteMembers: function handleSegmentDeleteMembers(segmentId) {
    return this.resetElasticSearchMembersForSegment(segmentId);
  },
  resetElasticSearchMembersForSegment: function resetElasticSearchMembersForSegment(segmentId) {
    var elasticSearchMembersBySegmentId = _.cloneDeep(this.state.elasticSearchMembersBySegmentId);
    delete elasticSearchMembersBySegmentId[segmentId];
    return this.setState({ elasticSearchMembersBySegmentId: elasticSearchMembersBySegmentId });
  },
  elasticSearchMembersDone: function elasticSearchMembersDone(segmentId, from, size, searchResult) {
    var elasticSearchMembersBySegmentId = _.cloneDeep(this.state.elasticSearchMembersBySegmentId);
    if (!elasticSearchMembersBySegmentId[segmentId]) {
      elasticSearchMembersBySegmentId[segmentId] = {};
    }

    elasticSearchMembersBySegmentId[segmentId][this.generateElasticSearchCacheId(from, size)] = searchResult;
    return this.setState({ elasticSearchMembersBySegmentId: elasticSearchMembersBySegmentId });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SegmentStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "qd9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__ = __webpack_require__("Lrv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__ = __webpack_require__("xoR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_pages_SalesforceConfig_OwnerRouting__ = __webpack_require__("5xnA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_SalesforceLeadRouting__ = __webpack_require__("Ohub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Integration_components_IntegrationConnector__ = __webpack_require__("lsaV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl__ = __webpack_require__("/1Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var SalesforceFilter = function (_Component) {
  _inherits(SalesforceFilter, _Component);

  function SalesforceFilter(props) {
    _classCallCheck(this, SalesforceFilter);

    var _this = _possibleConstructorReturn(this, (SalesforceFilter.__proto__ || Object.getPrototypeOf(SalesforceFilter)).call(this, props));

    _this.onSalesforceLeadRoutingSettingsUpdated = function (settings) {
      var settingsPayload = { "settings": settings };
      _this.props.updateSalesforceLeadRoutingSettings(settingsPayload);
      _this.setState({ selectedSalesforceLeadRoutingSettings: settings });
    };

    _this.onSalesforceLeadRoutingTogglesUpdated = function (toggles) {
      _this.props.updateSalesforceLeadRoutingToggles(toggles);
      _this.setState({ selectedSalesforceLeadRoutingToggles: toggles });
    };

    _this.onIntegrationConnected = function () {
      _this.setState({ sfdcConnected: true });
      _this.props.setPageValidity(true);
      _this.props.updateAction(_extends({}, __WEBPACK_IMPORTED_MODULE_9_app_modules_rules_models__["y" /* salesforceAction */], {
        options: {}
      }));
    };

    props.setPageValidity(true);
    _this.state = {
      sfdcConnected: false,
      hasSalesforceRoutingSettingsEnabled: __WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].hasGates('salesforce_routing_settings_enabled')
    };
    return _this;
  }

  _createClass(SalesforceFilter, [{
    key: 'renderLeadRouting',
    value: function renderLeadRouting() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_SalesforceLeadRouting__["a" /* default */], {
        onSalesforceLeadRoutingSettingsUpdated: this.onSalesforceLeadRoutingSettingsUpdated,
        onSalesforceLeadRoutingTogglesUpdated: this.onSalesforceLeadRoutingTogglesUpdated,
        selectedSalesforceLeadRoutingSettings: this.state.selectedSalesforceLeadRoutingSettings,
        selectedSalesforceLeadRoutingToggles: this.state.selectedSalesforceLeadRoutingToggles
      });
    }
  }, {
    key: 'renderOldLeadRouting',
    value: function renderOldLeadRouting() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-old-lead-routing-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default.a }),
          ' When a known user chats in to Drift, we\u2019ll use their email to see if they exist in Salesforce and will find the appropriate owner in the following order. Simply uncheck the fields you want us to skip:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_pages_SalesforceConfig_OwnerRouting__["a" /* default */], { className: 'owner-routing-toggles' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default.a }),
          'If we can\u2019t map an owner to a Drift teammate, we\u2019ll carry on with your other Routing Rules'
        )
      );
    }
  }, {
    key: 'renderSFDCConnect',
    value: function renderSFDCConnect() {
      var SalesforcePayload = {
        client_id: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["O" /* SALESFORCE_CLIENT_ID */],
        response_type: 'code',
        redirect_uri: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/salesforce'
      };
      var SaleseforceAuthUrl = 'https://login.salesforce.com/services/oauth2/authorize';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-sfdc-connect' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'You need to connect your salesforce account before you can continue.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Integration_components_IntegrationConnector__["a" /* default */], {
          onIntegrationConnected: this.onIntegrationConnected,
          integrationId: 'salesforce',
          isOauth: true,
          oauthLink: SaleseforceAuthUrl,
          oauthQueryParams: SalesforcePayload })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          sfdcConnected = _state.sfdcConnected,
          hasSalesforceRoutingSettingsEnabled = _state.hasSalesforceRoutingSettingsEnabled;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-salesforce-filter rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Salesforce Owner'
          ),
          hasSalesforceRoutingSettingsEnabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'When a known user chats in to Drift, we\u2019ll use their email to see if they exist in ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              'Salesforce and will find the appropriate owner in cascading order.'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Add an identified contact\u2019s Account, Contact or Lead Owner to new conversations. Learn More'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          sfdcConnected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-content drift-form' },
            hasSalesforceRoutingSettingsEnabled ? this.renderLeadRouting() : this.renderOldLeadRouting()
          ) : this.renderSFDCConnect()
        )
      );
    }
  }]);

  return SalesforceFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SalesforceFilter);

/***/ }),

/***/ "qdP/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qk1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("Lkyf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var WORDPRESS_PLUGIN_URL = 'https://wordpress.org/plugins-wp/drift/';
var WORDPRESS_HELP_URL = 'https://help.drift.com/article/install-drift-on-your-wordpress-site/';

var WordPressInstaller = function (_Component) {
  _inherits(WordPressInstaller, _Component);

  function WordPressInstaller() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WordPressInstaller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WordPressInstaller.__proto__ || Object.getPrototypeOf(WordPressInstaller)).call.apply(_ref, [this].concat(args))), _this), _this.handleConnect = function () {
      Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* popUp */])({ path: WORDPRESS_PLUGIN_URL });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WordPressInstaller, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        "1. Add the Drift plugin to your WordPress account and activate it.",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        '2. Copy the Javascript snippet from the section above. Navigate to the Drift plugin and paste the snippet where indicated. Make sure Drift (Live Chat) is set to Enabled.',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        'Need some help? Click ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.Link, href: WORDPRESS_HELP_URL },
          'here'
        ),
        ' for more details!',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__["a" /* default */], {
          label: 'Download Wordpress Plugin',
          handleConnect: this.handleConnect,
          connectorType: 'button',
          buttonType: 'tertiary'
        })
      );
    }
  }]);

  return WordPressInstaller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (WordPressInstaller);

/***/ }),

/***/ "qkXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder__ = __webpack_require__("DZSL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("CyMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var AudienceBuilderContainer = function (_Component) {
  _inherits(AudienceBuilderContainer, _Component);

  function AudienceBuilderContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AudienceBuilderContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AudienceBuilderContainer.__proto__ || Object.getPrototypeOf(AudienceBuilderContainer)).call.apply(_ref, [this].concat(args))), _this), _this.resolveUserListDataDisparity = function () {
      var _this$props = _this.props,
          userListIds = _this$props.userListIds,
          usersSelected = _this$props.usersSelected,
          visitorsSelected = _this$props.visitorsSelected,
          noneSelected = _this$props.noneSelected,
          onEveryoneClick = _this$props.onEveryoneClick;

      var included = userListIds.toJS();

      if (usersSelected) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["append"])(__WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder__["knownVisitors"].id, included);
      } else if (visitorsSelected) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["append"])(__WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder__["anonVisitors"].id, included);
      }

      if (noneSelected) {
        onEveryoneClick();
      }

      return included;
    }, _this.getSelectedSmartFilters = function () {
      var smartFilters = _this.props.smartFilters;


      var filters = !smartFilters ? {} : !!smartFilters.toJS ? smartFilters.toJS() : smartFilters;

      return filters;
    }, _this.getSelections = function () {
      return {
        selectedSendContacts: _this.resolveUserListDataDisparity(),
        selectedDontSendContacts: _this.props.excludedUserListIds.toJS(),
        selectedAccounts: _this.props.accountListIds.toJS(),
        selectedDontSendAccounts: _this.props.excludedAccountListIds.toJS(),
        selectedFilters: _this.getSelectedSmartFilters()
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AudienceBuilderContainer, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // TODO: change this to be a functional stateless component
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.props.loading, nextProps.loading) ||
      // TODO: use array.every check instead for perf reasons
      !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.getSelections(this.props), this.getSelections(nextProps)) || !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.props.isCardinalityLoading, nextProps.isCardinalityLoading) || !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.props.targetingCardinality, nextProps.targetingCardinality) || !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.props.usersSelected, nextProps.usersSelected) || !Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["equals"])(this.props.visitorsSelected, nextProps.visitorsSelected)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          saveAudience = _props.saveAudience,
          loading = _props.loading,
          isEmailPlaybook = _props.isEmailPlaybook,
          targetingCardinality = _props.targetingCardinality,
          isCardinalityLoading = _props.isCardinalityLoading,
          hasAccountSegmentation = _props.hasAccountSegmentation,
          hasSmartFilterInclusion = _props.hasSmartFilterInclusion,
          hasAbandonedMeetingSmartFilter = _props.hasAbandonedMeetingSmartFilter,
          hasLimitedContactsMktEmail = _props.hasLimitedContactsMktEmail;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'new-audience-builder ' + (hasAccountSegmentation ? 'new-audience-builder-with-account-segmentation' : '') },
        hasLimitedContactsMktEmail ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'playbook-title-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Build Your Audience'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Who should receive this playbook?',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            ' You can also choose who not to send to, and Drift will automatically exclude them.'
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          { className: 'playbook-title-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'Build Your Audience'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Only the bot can add contacts or segments to send emails to.',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            'You can still choose to exclude specific contacts and segments from receiving these emails.'
          )
        ),
        isEmailPlaybook && hasLimitedContactsMktEmail && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'new-audience-builder-cardinality-label' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'This email will send to'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'new-audience-builder-cardinality' },
            isCardinalityLoading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__["a" /* default */], null) : targetingCardinality
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            'contacts'
          )
        ),
        loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'new-audience-builder-loader' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Loader"], null)
        ),
        !loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_audience_builder__["AudienceBuilder"], {
          selections: this.getSelections(),
          isChatPlaybook: !isEmailPlaybook,
          saveAudience: saveAudience,
          hasFeatureMap: {
            hasAccountSegmentation: hasAccountSegmentation,
            hasSmartFilterInclusion: hasSmartFilterInclusion,
            hasAbandonedMeetingSmartFilter: hasAbandonedMeetingSmartFilter,
            hasLimitedContactsMktEmail: hasLimitedContactsMktEmail
          },
          loading: false
        })
      );
    }
  }]);

  return AudienceBuilderContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AudienceBuilderContainer);

/***/ }),

/***/ "qo/O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MessageInputsWrapper":"MessageInputsWrapper---25ibo"};

/***/ }),

/***/ "qrgV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtEq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qtZ0":
/***/ (function(module, exports) {

module.exports = "<svg width=\"270px\" height=\"151px\" viewBox=\"0 0 270 151\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Artboard-3\" transform=\"translate(-29.000000, -53.000000)\"><g id=\"Group-3-Copy\" transform=\"translate(29.000000, 53.000000)\"><g id=\"Group\"><polygon id=\"Rectangle-10\" fill=\"#E2EEF4\" points=\"0 13.9084967 270 13.9084967 270 150.013072 0 150.013072\"></polygon><path d=\"M2.39589179,2.66492432e-15 C1.07267729,2.66176371e-15 1.17093835e-16,1.06828203 1.17093835e-16,2.4067968 L1.17093835e-16,13.9084967 L270,13.9084967 L270,2.4067968 C270,1.07755963 268.926228,3.3015531e-15 267.604108,3.29839511e-15 L2.39589179,2.66492432e-15 Z\" id=\"top\" fill=\"#FFFFFF\"></path><g id=\"Rectangle-16\"><use fill=\"#F2F6F8\" fill-rule=\"evenodd\" xlink:href=\"#path-1\"></use><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-2)\" xlink:href=\"#path-1\"></use></g><path d=\"M0.5,13.4117647 L269.5,13.4117647\" id=\"Line-2\" stroke=\"#B5D2E1\" stroke-linecap=\"square\"></path><path d=\"M0.5,150.509804 L269.5,150.509804\" id=\"Line-2-Copy-5\" stroke=\"#B5D2E1\" stroke-linecap=\"square\"></path><g id=\"Group-6\" transform=\"translate(197.000000, 12.915033)\"><g id=\"Line\" stroke-linecap=\"square\"><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-3\"></use><use stroke=\"#F2F6F8\" stroke-width=\"1\" xlink:href=\"#path-3\"></use></g><polygon id=\"Rectangle-6\" fill=\"#FFFFFF\" points=\"2 0.993464052 72.021978 0.993464052 72.021978 136.106567 2 136.106567\"></polygon><rect id=\"Rectangle-9\" fill=\"#F2F6F8\" x=\"3\" y=\"0.993464052\" width=\"69.021978\" height=\"17.9260217\"></rect><path d=\"M2.5,124.679739 L72.5,124.679739\" id=\"Line-2-Copy\" stroke=\"#B5D2E1\" stroke-linecap=\"square\"></path><path d=\"M2.5,136.601307 L2.5,1.49019608\" id=\"Line-2-Copy-4\" stroke=\"#B5D2E1\" stroke-linecap=\"square\"></path><path d=\"M36.4175824,48.4421658 C36.4175824,46.7886724 37.7570268,45.4482511 39.4161057,45.4482511 L63.6827953,45.4482511 C65.3388341,45.4482511 66.6813187,46.7916296 66.6813187,48.4421658 L66.6813187,58.3715956 C66.6813187,60.025089 65.3418743,61.3655103 63.6827953,61.3655103 L39.4161057,61.3655103 C37.760067,61.3655103 36.4175824,60.0221318 36.4175824,58.3715956 L36.4175824,48.4421658 Z\" id=\"Rectangle-Copy-2\" fill=\"#E1EEF4\"></path><path d=\"M22.1758242,10.076564 C22.1758242,8.61142071 23.3548016,7.42368742 24.8382233,7.42368742 L40.8760624,7.42368742 C42.3464648,7.42368742 43.5384615,8.61440198 43.5384615,10.076564 L43.5384615,10.076564 C43.5384615,11.5417072 42.3594841,12.7294405 40.8760624,12.7294405 L24.8382233,12.7294405 C23.3678209,12.7294405 22.1758242,11.5387259 22.1758242,10.076564 L22.1758242,10.076564 Z\" id=\"Rectangle-Copy-5\" fill=\"#E1EEF4\"></path><path d=\"M45.3186813,98.0636357 C45.3186813,95.3775397 47.5044652,93.2000287 50.1795538,93.2000287 L61.8204462,93.2000287 C64.5050319,93.2000287 66.6813187,95.3830054 66.6813187,98.0636357 L66.6813187,98.0636357 C66.6813187,100.749732 64.4955348,102.927243 61.8204462,102.927243 L50.1795538,102.927243 C47.4949681,102.927243 45.3186813,100.744266 45.3186813,98.0636357 L45.3186813,98.0636357 Z\" id=\"Rectangle-Copy-4\" fill=\"#E1EEF4\"></path><rect id=\"Rectangle-Copy\" fill=\"#F2F6F8\" x=\"21.2857143\" y=\"28.6466997\" width=\"33.8241758\" height=\"9.72721396\" rx=\"4.86360698\"></rect><rect id=\"Rectangle-Copy-3\" fill=\"#F2F6F8\" x=\"21.2857143\" y=\"69.3241399\" width=\"33.8241758\" height=\"15.9172592\" rx=\"3\"></rect><path d=\"M64.3134827,9.97249369 L67.27756,12.9174674 C67.3901346,13.0291783 67.3901346,13.2103853 67.27756,13.3220962 C67.2215629,13.377808 67.1478671,13.4056639 67.0741714,13.4056639 C67.0004756,13.4056639 66.9267799,13.377808 66.8704926,13.3220962 L63.9061251,10.3771225 L60.9420478,13.3220962 C60.8860506,13.377808 60.8123549,13.4056639 60.7386592,13.4056639 C60.6649634,13.4056639 60.5912677,13.377808 60.5349804,13.3220962 C60.4224058,13.2103853 60.4224058,13.0291783 60.5349804,12.9174674 L63.4990577,9.97249369 L60.5349804,7.02780715 C60.4224058,6.9160963 60.4224058,6.73488923 60.5349804,6.62317838 C60.647555,6.51146753 60.8297633,6.51146753 60.9420478,6.62317838 L63.9061251,9.56786493 L66.8702025,6.62317838 C66.9827771,6.51146753 67.1649854,6.51146753 67.27756,6.62317838 C67.3898445,6.73488923 67.3898445,6.9160963 67.27756,7.02780715 L64.3134827,9.97249369 L64.3134827,9.97249369 Z\" id=\"Shape\" fill=\"#B5D2E1\"></path><ellipse id=\"Oval-3\" fill=\"url(#pattern-5)\" cx=\"13.2747253\" cy=\"10.076564\" rx=\"5.34065934\" ry=\"5.30575307\"></ellipse><ellipse id=\"Oval-3-Copy\" fill=\"url(#pattern-7)\" cx=\"13.2747253\" cy=\"33.9524528\" rx=\"5.34065934\" ry=\"5.30575307\"></ellipse><ellipse id=\"Oval-3-Copy-2\" fill=\"url(#pattern-9)\" cx=\"13.2747253\" cy=\"80.8199382\" rx=\"5.34065934\" ry=\"5.30575307\"></ellipse></g></g></g></g></g></svg>"

/***/ }),

/***/ "quQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("J7ra");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });



/***/ }),

/***/ "qwEQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(515);

/***/ }),

/***/ "r17Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_router_selectors__ = __webpack_require__("F6Ot");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_models__ = __webpack_require__("/Abo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_presence_actions__ = __webpack_require__("9gNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChatButton__ = __webpack_require__("U3uR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_AvatarCompat__ = __webpack_require__("lpJc");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var SessionLength = function SessionLength(_ref) {
  var presenceUser = _ref.presenceUser;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(presenceUser.session.activeSessionStartedAt).fromNow(true)
    )
  );
};

var NewPresenceRow = function (_Component) {
  _inherits(NewPresenceRow, _Component);

  function NewPresenceRow(props) {
    _classCallCheck(this, NewPresenceRow);

    var _this = _possibleConstructorReturn(this, (NewPresenceRow.__proto__ || Object.getPrototypeOf(NewPresenceRow)).call(this, props));

    _this.renderName = function () {
      var endUser = _this.props.endUser;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_AvatarCompat__["a" /* AvatarCompat */], { key: endUser.get("id"), user: endUser }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'pr-data-name-label' },
          endUser.name || endUser.email || 'Site Visitor'
        )
      );
    };

    _this.renderCompanyIcon = function (visitorPresenceUser) {
      var url = _.get(visitorPresenceUser, 'company.logo', undefined);
      var name = _.get(visitorPresenceUser, 'company.name', undefined);
      return url && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_shared_AvatarCompat__["a" /* AvatarCompat */], { company: { name: name, logo: url }, type: 'company' });
    };

    _this.renderCompany = function () {
      var _this$props = _this.props,
          hasLiveReveal = _this$props.hasLiveReveal,
          visitorPresenceUser = _this$props.user;


      if (hasLiveReveal) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'pr-data-company-container' },
          _this.renderCompanyIcon(visitorPresenceUser),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'pr-data-company-label' },
            _this.companyName(visitorPresenceUser)
          )
        );
      } else {
        return null;
      }
    };

    _this.companyName = function (visitorPresenceUser) {
      return visitorPresenceUser.company && visitorPresenceUser.company.name || '-';
    };

    _this.renderPage = function () {
      var user = _this.props.user;

      var _ref2 = user.page ? user.page : {},
          url = _ref2.url,
          path = _ref2.path,
          title = _ref2.title;

      if (url) {
        if (title) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { is: true, href: '//' + url, tooltip: url, flow: 'right' },
            title,
            ' ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              {
                className: 'pr-path-link' },
              path || "/"
            )
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { is: true, href: '//' + url, tooltip: url, flow: 'right' },
            path || "/"
          );
        }
      }
    };

    _this.renderLastUpdate = function () {
      var user = _this.props.user;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        ' ',
        __WEBPACK_IMPORTED_MODULE_3_moment___default()(user.updatedAt).fromNow(),
        ' '
      );
    };

    _this.renderLocation = function () {
      var geo = _this.props.user.location;
      if (!geo) return;

      var location = _.compact([geo.city, geo.subdivision, geo.country]).join(', ') || ' - ';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { title: location },
        location
      );
    };

    _this.state = {
      hasEndUser: false
    };
    return _this;
  }

  _createClass(NewPresenceRow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var id = this.props.user ? this.props.user.get("endUserId") : undefined;
      if (id) {
        this.props.actions.fetchEndUser({ id: id });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _ref3 = this.props.user.endUser ? this.props.user.endUser : {},
          id = _ref3.id;

      var _ref4 = nextProps.user.endUser ? nextProps.user.endUser : {},
          nextId = _ref4.id;

      if (id !== nextId && nextId) {
        this.props.actions.fetchEndUser({ id: nextId });
      }

      var endUser = this.props.endUser;

      var hasEndUser = endUser && endUser.id;
      this.setState({
        hasEndUser: hasEndUser
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var user = this.props.user;

      var statusClass = user.className || '';
      var companyName = null;
      if (this.props.hasLiveReveal) {
        companyName = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-company' },
          this.renderCompany()
        );
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { className: 'pr-tr ' + statusClass, onClick: function onClick() {
            return _this2.props.setSelectedUser(user);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-chatbutton' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ChatButton__["a" /* default */], { endUserId: user.endUserId, onClick: function onClick() {
                return _this2.props.setSelectedUser(user);
              } })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-name' },
          this.renderName()
        ),
        companyName,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-url' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.renderPage()
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-last-update' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SessionLength, { presenceUser: user })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'pr-td pr-data-location' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            this.renderLocation()
          )
        )
      );
    }
  }]);

  return NewPresenceRow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  var endUserSelector = __WEBPACK_IMPORTED_MODULE_8_app_modules_endUser_selectors__["g" /* makeEndUserSelector */]();
  var emptyEndUser = new __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_models__["a" /* EndUser */]();

  return function (state, props) {
    return {
      endUser: props.user.endUserId && endUserSelector(state, { id: props.user.endUserId }) || emptyEndUser,
      query: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_router_selectors__["a" /* getQueryParams */])(state),
      hasLiveReveal: props.hasLiveReveal
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchEndUser: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_actions__["k" /* fetchEndUser */],
      bootstrapUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_presence_actions__["bootstrapUser"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(NewPresenceRow));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "r8Ip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("13R5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var SectionItem = function SectionItem(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(__WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.SectionItem, className) },
    title && React.createElement(
      'span',
      { className: 'title' },
      title
    ),
    description && React.createElement(
      'div',
      { className: 'description' },
      description
    ),
    React.createElement(
      'div',
      { className: 'content' },
      children
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "r8ZY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(211);

/***/ }),

/***/ "rAlQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_SFDC_ATTRIBUTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SFDC_ATTRIBUTES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_SFDC_TASK_ATTRIBUTES_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_SFDC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_SFDC_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_SFDC_METRIC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_SFDC_METRIC_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_METRICS_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_METRICS_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PATCH_SFDC_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PATCH_SFDC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PATCH_SFDC_MAPPINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PATCH_SFDC_METRIC_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PATCH_SFDC_METRIC_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PATCH_SFDC_METRIC_MAPPINGS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_SFDC_USERS_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_SFDC_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_SFDC_USERS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_SFDC_USER_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PATCH_SFDC_USER_MAPPINGS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PATCH_SFDC_USER_MAPPINGS_SUCCESS; });
/* unused harmony export PATCH_SFDC_USER_MAPPINGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_SFDC_OBJECT_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_SFDC_OBJECT_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SFDC_FIELD_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SFDC_FIELD_LIST_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SFDC_ACCOUNT_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SFDC_CONTACT_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SFDC_LEAD_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR; });
/* unused harmony export FETCH_SALESFORCE_ENRICHMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SALESFORCE_ENRICHMENT_STARTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SALESFORCE_ENRICHMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SALESFORCE_ENRICHMENT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SFDC_ENRICHMENT_FIELDS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PATCH_SFDC_ENRICHMENT_FIELDS_ERROR; });
var FETCH_SFDC_ATTRIBUTES_SUCCESS = 'FETCH_SFDC_ATTRIBUTES_SUCCESS';
var FETCH_SFDC_ATTRIBUTES_ERROR = 'FETCH_SFDC_ATTRIBUTES_ERROR';
var FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS = 'FETCH_SFDC_TASK_ATTRIBUTES_SUCCESS';
var FETCH_SFDC_TASK_ATTRIBUTES_ERROR = 'FETCH_SFDC_TASK_ATTRIBUTES_ERROR';
var FETCH_SFDC_MAPPINGS_SUCCESS = 'FETCH_SFDC_MAPPINGS_SUCCESS';
var FETCH_SFDC_MAPPINGS_ERROR = 'FETCH_SFDC_MAPPINGS_ERROR';
var FETCH_SFDC_METRIC_MAPPINGS_SUCCESS = 'FETCH_SFDC_METRICS_MAPPINGS_SUCCESS';
var FETCH_SFDC_METRIC_MAPPINGS_ERROR = 'FETCH_SFDC_METRICS_MAPPINGS_ERROR';
var FETCH_METRICS_LIST_SUCCESS = 'FETCH_SFDC_METRICS_LIST_SUCCESS';
var FETCH_METRICS_LIST_ERROR = 'FETCH_SFDC_METRICS_LIST_ERROR';

var PATCH_SFDC_MAPPINGS_ERROR = 'PATCH_SFDC_MAPPINGS_ERROR';
var PATCH_SFDC_MAPPINGS_SUCCESS = 'PATCH_SFDC_MAPPINGS_SUCCESS';
var PATCH_SFDC_MAPPINGS_START = 'PATCH_SFDC_MAPPINGS_START';
var PATCH_SFDC_METRIC_MAPPINGS_ERROR = 'PATCH_SFDC_METRIC_MAPPINGS_FAILED';
var PATCH_SFDC_METRIC_MAPPINGS_SUCCESS = 'PATCH_SFDC_METRIC_MAPPINGS_SUCCESS';
var PATCH_SFDC_METRIC_MAPPINGS_START = 'PATCH_SFDC_METRIC_MAPPINGS_START';

var FETCH_SFDC_USERS_START = 'FETCH_SFDC_USERS_START';
var FETCH_SFDC_USERS_SUCCESS = 'FETCH_SFDC_USERS_SUCCESS';
var FETCH_SFDC_USERS_ERROR = 'FETCH_SFDC_USERS_ERROR';

var FETCH_SFDC_USER_MAPPINGS_SUCCESS = 'FETCH_SFDC_USER_MAPPINGS_SUCCESS';

var PATCH_SFDC_USER_MAPPINGS_FAILED = 'PATCH_SFDC_USER_MAPPINGS_FAILED';
var PATCH_SFDC_USER_MAPPINGS_SUCCESS = 'PATCH_SFDC_USER_MAPPINGS_SUCCESS';
var PATCH_SFDC_USER_MAPPINGS = 'PATCH_SFDC_USER_MAPPINGS';

var FETCH_SFDC_OBJECT_LIST_SUCCESS = 'FETCH_SFDC_OBJECT_LIST_SUCCESS';
var FETCH_SFDC_OBJECT_LIST_ERROR = 'FETCH_SFDC_OBJECT_LIST_ERROR';

var FETCH_SFDC_FIELD_LIST_SUCCESS = 'FETCH_SFDC_FIELD_LIST_SUCCESS';
var FETCH_SFDC_FIELD_LIST_ERROR = 'FETCH_SFDC_FIELD_LIST_ERROR';
var SFDC_ACCOUNT_FIELDS = 'Account';
var SFDC_CONTACT_FIELDS = 'Contact';
var SFDC_LEAD_FIELDS = 'Lead';

var FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS = 'FETCH_SFDC_LEAD_ROUTING_SETTINGS_SUCCESS';
var FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR = 'FETCH_SFDC_LEAD_ROUTING_SETTINGS_ERROR';

var FETCH_SALESFORCE_ENRICHMENT = 'FETCH_SALESFORCE_ENRICHMENT';
var FETCH_SALESFORCE_ENRICHMENT_STARTED = 'FETCH_SALESFORCE_ENRICHMENT_STARTED';
var FETCH_SALESFORCE_ENRICHMENT_SUCCESS = 'FETCH_SALESFORCE_ENRICHMENT_SUCCESS';
var FETCH_SALESFORCE_ENRICHMENT_FAILED = 'FETCH_SALESFORCE_ENRICHMENT_FAILED';

var FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS = 'FETCH_SFDC_ENRICHMENT_FIELDS_SUCCESS';
var FETCH_SFDC_ENRICHMENT_FIELDS_ERROR = 'FETCH_SFDC_ENRICHMENT_FIELDS_ERROR';
var PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS = 'PATCH_SFDC_ENRICHMENT_FIELDS_SUCCESS';
var PATCH_SFDC_ENRICHMENT_FIELDS_ERROR = 'PATCH_SFDC_ENRICHMENT_FIELDS_ERROR';

/***/ }),

/***/ "rBQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl__ = __webpack_require__("qdP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_styl__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var MISSING_CAMPAIGN = 'The previously used campaign is no longer available.';
var UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.';
var SEARCH_DEBOUNCE_TIMEOUT = 500;

var SalesforceCampaignSelect = function (_Component) {
  _inherits(SalesforceCampaignSelect, _Component);

  function SalesforceCampaignSelect(props) {
    var _this2 = this;

    _classCallCheck(this, SalesforceCampaignSelect);

    var _this = _possibleConstructorReturn(this, (SalesforceCampaignSelect.__proto__ || Object.getPrototypeOf(SalesforceCampaignSelect)).call(this, props));

    _this.fetchCampaignById = function (campaignId) {
      var onError = function onError(err) {
        if (err.status == 404) {
          _this.handleMissingCampaign();
        } else {
          _this.handleUnknownError();
        }
      };

      return __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__["a" /* api */].fetchSalesforceCampaignById(campaignId).then(_this.handleFetchedCampaign).catch(onError);
    };

    _this.resolveOptions = function (options) {
      var resolvedOptions = options.salesforceCampaigns.map(function (campaign) {
        return { Name: campaign.Name, Id: campaign.Id };
      });
      _this.setState({
        selectOptions: resolvedOptions
      });
    };

    _this.getInitialValue = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var fetchSelectedCampaign, onCampaignIdPresent, onCampaignIdAbsent, onSelectedCampaignIdFetched;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchSelectedCampaign = _this.props.fetchSelectedCampaign;
              _context.next = 3;
              return _this.fetchAllSalesforceCampaigns();

            case 3:
              onCampaignIdPresent = function onCampaignIdPresent(campaignId) {
                var onStateSet = function onStateSet() {
                  return _this.fetchCampaignById(campaignId);
                };

                _this.setState({
                  selectValue: campaignId,
                  isLoading: true
                }, onStateSet);
              };

              onCampaignIdAbsent = function onCampaignIdAbsent() {
                _this.setState({
                  selectValue: null,
                  isLoading: false
                });
              };

              onSelectedCampaignIdFetched = function onSelectedCampaignIdFetched(data) {
                data.campaignId ? onCampaignIdPresent(data.campaignId) : onCampaignIdAbsent();
              };

              fetchSelectedCampaign().then(onSelectedCampaignIdFetched).catch(_this.handleUnknownError);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));
    _this.fetchAllSalesforceCampaigns = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var options;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__["a" /* api */].fetchAllSalesforceCampaigns();

            case 3:
              options = _context2.sent;

              _this.resolveOptions(options);
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2['catch'](0);

              console.log(_context2.t0);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 7]]);
    }));

    _this.handleFetchedCampaign = function (campaign) {
      var existsInList = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["find"])(function (campaignId) {
        return campaignId.Id === campaign.Id;
      }, _this.state.selectOptions);
      var nextState = !!existsInList ? {
        selectLabel: campaign.Name,
        selectValue: campaign.Id,
        isLoading: false,
        hasError: false
      } : {
        selectOptions: _this.state.selectOptions.concat([campaign]),
        selectLabel: campaign.Name,
        selectValue: campaign.Id,
        isLoading: false,
        hasError: false
      };
      _this.setState(nextState);
    };

    _this.handleMissingCampaign = function () {
      _this.setState({
        isLoading: false,
        hasError: true,
        selectValue: null,
        errorText: MISSING_CAMPAIGN
      });
    };

    _this.handleUnknownError = function () {
      _this.setState({
        isLoading: false,
        hasError: true,
        errorText: UNKNOWN_ERROR
      });
    };

    _this.onChange = function (campaign) {
      var setSelectedCampaign = _this.props.setSelectedCampaign;


      var onDone = function onDone() {
        _this.setState({
          isLoading: false,
          hasError: false
        });
      };

      var onStateSet = function onStateSet() {
        return setSelectedCampaign({ campaignId: campaign.Id }).then(onDone);
      };

      var existsInList = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["find"])(function (campaignId) {
        return campaignId.Id === campaign.Id;
      }, _this.state.selectOptions);
      var nextState = !!existsInList || !campaign.Name ? {
        selectValue: campaign.Id,
        selectLabel: campaign.Name,
        isLoading: true
      } : {
        selectOptions: _this.state.selectOptions.concat([campaign]),
        selectValue: campaign.Id,
        selectLabel: campaign.Name,
        isLoading: true
      };
      _this.setState(nextState, onStateSet);
    };

    _this.searchSalesforceCampaigns = function (query) {
      if (_this.state.selectOptions.length < 500 || query.length <= 2) {
        _this.setState({ responseOptions: [] });
        return;
      }

      // salesforce wants queries of length > 2 or it won't return anything
      if (query.length > 2) {
        _this.debouncedSearch(query);
      }
      return query;
    };

    _this.searchForCampaigns = function (query) {
      var onDone = function onDone(response) {
        _this.setState({
          responseOptions: response.salesforceCampaigns,
          isLoading: false
        });
      };
      var fetchCampaigns = function fetchCampaigns() {
        return __WEBPACK_IMPORTED_MODULE_5_app_modules_sfdc_api__["a" /* api */].searchSalesforceCampaigns(query).then(onDone).catch(_this.handleUnknownError);
      };

      _this.setState({ isLoading: true }, fetchCampaigns);
    };

    _this.debouncedSearch = _.debounce(_this.searchForCampaigns, SEARCH_DEBOUNCE_TIMEOUT);

    _this.resolveDefaultSelectOption = function () {
      return { Id: null, Name: null };
    };

    _this.resolveSelectOptions = function () {
      var selectOptions = _this.state.selectOptions;

      var defaultSelectOption = _this.resolveDefaultSelectOption();
      return selectOptions.concat(defaultSelectOption);
    };

    _this.handleToggleChange = function (change) {
      _this.props.onToggleChange({ campaignId: _this.state.selectValue }, change);
    };

    _this.state = {
      isLoading: true,
      hasError: false,
      selectValue: null,
      selectLabel: null,
      selectOptions: [],
      responseOptions: []
    };
    return _this;
  }

  _createClass(SalesforceCampaignSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getInitialValue();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.setSelectedCampaign.name === this.props.setSelectedCampaign.name) {
        return;
      }
      if (prevProps.fetchSelectedCampaign() != this.props.fetchSelectedCampaign()) {
        this.getInitialValue();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          description = _props.description,
          defaultSelectLabelText = _props.defaultSelectLabelText,
          type = _props.type,
          toggleStatus = _props.toggleStatus;
      var _state = this.state,
          selectValue = _state.selectValue,
          selectLabel = _state.selectLabel,
          isLoading = _state.isLoading,
          hasError = _state.hasError,
          errorText = _state.errorText,
          responseOptions = _state.responseOptions;

      var defaultSelectOption = this.resolveDefaultSelectOption();
      var selectOptions = responseOptions.length > 0 ? responseOptions : this.state.selectOptions;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'salesforce-campaign-select-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'advanced-integration-toggle-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'p',
            { className: 'salesforce-campaign-select-description' },
            description
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select_plus__["b" /* default */], {
          className: 'salesforce-campaign-select-input',
          labelKey: 'Name',
          valueKey: 'Id',
          autosize: false,
          placeholder: defaultSelectLabelText,
          value: selectValue,
          label: selectLabel,
          options: selectOptions,
          isLoading: isLoading,
          onChange: this.onChange,
          resetValue: defaultSelectOption,
          onInputChange: this.searchSalesforceCampaigns
        }),
        hasError && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { className: 'salesforce-campaign-error-text' },
          errorText
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'salesforce-campaign-mapping-net-new-checkbox' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], {
            onChange: this.handleToggleChange,
            type: 'checkbox',
            label: 'Only associate net new ' + type + ' with this campaign',
            checked: toggleStatus
          })
        )
      );
    }
  }]);

  return SalesforceCampaignSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

SalesforceCampaignSelect.propTypes = {
  defaultSelectLabelText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  fetchSelectedCampaign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setSelectedCampaign: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (SalesforceCampaignSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "rCTf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(524);

/***/ }),

/***/ "rDli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("CR44");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("TFJD");
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__selectors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container__ = __webpack_require__("k/LG");
/* unused harmony reexport withOrg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epic__ = __webpack_require__("bH6f");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__epic__["a"]; });








/***/ }),

/***/ "rEEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEAM_NAME_EDIT_MODE */
/* unused harmony export HOURS_EDIT_MODES */
/* unused harmony export HOURS_AVAILABILITY_MODES */
/* unused harmony export HOURS_MODE_COPY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_ORG_TEAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_ORG_TEAMS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_ORG_TEAMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_ORG_TEAMS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_TEAMS_FOR_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_TEAMS_FOR_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_TEAMS_FOR_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_TEAMS_FOR_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return PATCH_ORG_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return PATCH_ORG_TEAM_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return PATCH_ORG_TEAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return PATCH_ORG_TEAM_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_ORG_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_ORG_TEAM_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DELETE_ORG_TEAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_ORG_TEAM_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_ORG_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_ORG_TEAM_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_ORG_TEAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ORG_TEAM_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return UPDATE_AVAILABILITY_FOR_TEAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return UPDATE_AVAILABILITY_FOR_TEAM_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return UPDATE_AVAILABILITY_FOR_TEAM_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_TEAM_AVAILABILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_TEAM_AVAILABILITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_TEAM_AVAILABILITIES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_TEAM_AVAILABILITIES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_TEAM_AVAILABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_TEAM_AVAILABILITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_TEAM_AVAILABILITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_TEAM_AVAILABILITY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_TEAM_AVAILABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_TEAM_AVAILABILITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_TEAM_AVAILABILITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_TEAM_AVAILABILITY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return UPDATE_TEAM_AVAILABILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return UPDATE_TEAM_AVAILABILITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return UPDATE_TEAM_AVAILABILITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return UPDATE_TEAM_AVAILABILITY_FAILED; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");
var _HOURS_MODE_COPY;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('teams');

var TEAM_NAME_EDIT_MODE = Object.freeze({
  REVIEW: 'REVIEW',
  EDIT: 'EDIT'
});

var HOURS_EDIT_MODES = Object.freeze({
  REVIEW: 'REVIEW',
  EDIT: 'EDIT'
});

var HOURS_AVAILABILITY_MODES = Object.freeze({
  ALWAYS_ONLINE: 'ALWAYS_ONLINE',
  ALWAYS_OFFLINE: 'ALWAYS_OFFLINE',
  CUSTOM_HOURS: 'CUSTOM_HOURS'
});

var HOURS_MODE_COPY = (_HOURS_MODE_COPY = {}, _defineProperty(_HOURS_MODE_COPY, HOURS_AVAILABILITY_MODES.ALWAYS_ONLINE, {
  title: 'Always online',
  description: 'This team will always be online - 24 hours a day, 7 days a week'
}), _defineProperty(_HOURS_MODE_COPY, HOURS_AVAILABILITY_MODES.ALWAYS_OFFLINE, {
  title: 'Taken Offline',
  description: 'This team will always be offline.'
}), _defineProperty(_HOURS_MODE_COPY, HOURS_AVAILABILITY_MODES.CUSTOM_HOURS, {
  title: 'Scheduled Online Hours',
  description: 'Team availability is based on custom time slots'
}), _HOURS_MODE_COPY);

var FETCH_ORG_TEAMS = makeConstant('FETCH_ORG_TEAMS');
var FETCH_ORG_TEAMS_PENDING = makeConstant('FETCH_ORG_TEAMS_PENDING');
var FETCH_ORG_TEAMS_SUCCESS = makeConstant('FETCH_ORG_TEAMS_SUCCESS');
var FETCH_ORG_TEAMS_FAILED = makeConstant('FETCH_ORG_TEAMS_FAILED');

var FETCH_TEAMS_FOR_USER = makeConstant('FETCH_TEAMS_FOR_USER');
var FETCH_TEAMS_FOR_USER_PENDING = makeConstant('FETCH_TEAMS_FOR_USER_PENDING');
var FETCH_TEAMS_FOR_USER_SUCCESS = makeConstant('FETCH_TEAMS_FOR_USER_SUCCESS');
var FETCH_TEAMS_FOR_USER_FAILED = makeConstant('FETCH_TEAMS_FOR_USER_FAILED');

var PATCH_ORG_TEAM = makeConstant('PATCH_ORG_TEAM');
var PATCH_ORG_TEAM_PENDING = makeConstant('PATCH_ORG_TEAM_PENDING');
var PATCH_ORG_TEAM_SUCCESS = makeConstant('PATCH_ORG_TEAM_SUCCESS');
var PATCH_ORG_TEAM_FAILED = makeConstant('PATCH_ORG_TEAM_FAILED');

var DELETE_ORG_TEAM = makeConstant('DELETE_ORG_TEAM');
var DELETE_ORG_TEAM_PENDING = makeConstant('DELETE_ORG_TEAM_PENDING');
var DELETE_ORG_TEAM_SUCCESS = makeConstant('DELETE_ORG_TEAM_SUCCESS');
var DELETE_ORG_TEAM_FAILED = makeConstant('DELETE_ORG_TEAM_FAILED');

var CREATE_ORG_TEAM = makeConstant('CREATE_ORG_TEAM');
var CREATE_ORG_TEAM_PENDING = makeConstant('CREATE_ORG_TEAM_PENDING');
var CREATE_ORG_TEAM_SUCCESS = makeConstant('CREATE_ORG_TEAM_SUCCESS');
var CREATE_ORG_TEAM_FAILED = makeConstant('CREATE_ORG_TEAM_FAILED');

var UPDATE_AVAILABILITY_FOR_TEAM = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM');
var UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS');
var UPDATE_AVAILABILITY_FOR_TEAM_PENDING = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_PENDING');
var UPDATE_AVAILABILITY_FOR_TEAM_FAILED = makeConstant('UPDATE_AVAILABILITY_FOR_TEAM_FAILED');

var FETCH_TEAM_AVAILABILITIES = makeConstant('FETCH_TEAM_AVAILABILITIES');
var FETCH_TEAM_AVAILABILITIES_SUCCESS = makeConstant('FETCH_TEAM_AVAILABILITIES_SUCCESS');
var FETCH_TEAM_AVAILABILITIES_PENDING = makeConstant('FETCH_TEAM_AVAILABILITIES_PENDING');
var FETCH_TEAM_AVAILABILITIES_FAILED = makeConstant('FETCH_TEAM_AVAILABILITIES_FAILED');

var FETCH_TEAM_AVAILABILITY = makeConstant('FETCH_TEAM_AVAILABILITY');
var FETCH_TEAM_AVAILABILITY_SUCCESS = makeConstant('FETCH_TEAM_AVAILABILITY_SUCCESS');
var FETCH_TEAM_AVAILABILITY_PENDING = makeConstant('FETCH_TEAM_AVAILABILITY_PENDING');
var FETCH_TEAM_AVAILABILITY_FAILED = makeConstant('FETCH_TEAM_AVAILABILITY_FAILED');

var CREATE_TEAM_AVAILABILITY = makeConstant('CREATE_TEAM_AVAILABILITY');
var CREATE_TEAM_AVAILABILITY_SUCCESS = makeConstant('CREATE_TEAM_AVAILABILITY_SUCCESS');
var CREATE_TEAM_AVAILABILITY_PENDING = makeConstant('CREATE_TEAM_AVAILABILITY_PENDING');
var CREATE_TEAM_AVAILABILITY_FAILED = makeConstant('CREATE_TEAM_AVAILABILITY_FAILED');

var UPDATE_TEAM_AVAILABILITY = makeConstant('UPDATE_TEAM_AVAILABILITY');
var UPDATE_TEAM_AVAILABILITY_SUCCESS = makeConstant('UPDATE_TEAM_AVAILABILITY_SUCCESS');
var UPDATE_TEAM_AVAILABILITY_PENDING = makeConstant('UPDATE_TEAM_AVAILABILITY_PENDING');
var UPDATE_TEAM_AVAILABILITY_FAILED = makeConstant('UPDATE_TEAM_AVAILABILITY_FAILED');

/***/ }),

/***/ "rFuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEB_PUSH_SERVER_PUBLIC_KEY; });
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var NotificationConstants = Marty.createConstants(['NOTIFICATION_DISPLAY_DONE', 'NOTIFICATION_PUSH', 'CLEAR_NOTIFICATIONS']);

/* harmony default export */ __webpack_exports__["b"] = (NotificationConstants);

var WEB_PUSH_SERVER_PUBLIC_KEY = 'BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA=';
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "rGVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");



/* harmony default export */ __webpack_exports__["a"] = (function (Target) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(Target, {
    listenTo: ['stores.OrgSettingsStore', 'stores.LocaleStore', 'stores.TranslationStore'],
    fetch: {
      orgSettings: function orgSettings() {
        return this.app.stores.OrgSettingsStore.getOrgSettings();
      },
      locale: function locale() {
        return this.app.stores.LocaleStore.loadLocale();
      },
      messages: function messages() {
        return this.app.stores.TranslationStore.getTranslationsForLocale();
      }
    },
    pending: function pending() {
      return this.done({
        orgSettings: Object(__WEBPACK_IMPORTED_MODULE_0_components_Customize_OrgSettings_Helpers__["a" /* OrgSettings */])(),
        messages: this.app.stores.TranslationStore.state.get('en')
      });
    }
  });
});

/***/ }),

/***/ "rIPI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Organizations__ = __webpack_require__("ySLy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppIcons_app_switch_svg__ = __webpack_require__("ikuy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AppIcons_app_switch_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AppIcons_app_switch_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppLink__ = __webpack_require__("PhT/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppIcons_library_svg__ = __webpack_require__("it3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppIcons_library_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__AppIcons_library_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AppIcons_siftrock_svg__ = __webpack_require__("DEsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AppIcons_siftrock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AppIcons_siftrock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AppIcons_graduation_cap_svg__ = __webpack_require__("V6Hr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AppIcons_graduation_cap_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AppIcons_graduation_cap_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AppIcons_dev_platform_svg__ = __webpack_require__("1+QT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AppIcons_dev_platform_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AppIcons_dev_platform_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl__ = __webpack_require__("R26V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var AppSwitcher = function (_Component) {
  _inherits(AppSwitcher, _Component);

  function AppSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppSwitcher.__proto__ || Object.getPrototypeOf(AppSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showAppSwitcher: false
    }, _this.openAppSwitcher = function () {
      var showAppSwitcher = _this.state.showAppSwitcher;

      _this.setState({ showAppSwitcher: !showAppSwitcher });
    }, _this.handleClickOutside = function (event) {
      if (_this.appSwitcherRef && !_this.appSwitcherRef.contains(event.target)) {
        _this.state.showAppSwitcher && _this.setState({ showAppSwitcher: false });
      }
    }, _this.setAppSwitcherRef = function (node) {
      _this.appSwitcherRef = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppSwitcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: 'getApps',
    value: function getApps() {
      var _props = this.props,
          settingsLoaded = _props.settingsLoaded,
          videoSignUpDone = _props.videoSignUpDone,
          _props$trafficControl = _props.trafficControlConfig,
          hasDevPlatformSwitch = _props$trafficControl.hasDevPlatformSwitch,
          hasInsiderSwitch = _props$trafficControl.hasInsiderSwitch,
          hasVideoSwitch = _props$trafficControl.hasVideoSwitch;

      var apps = [{
        name: 'Siftrock',
        url: __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__["Y" /* SIFTROCK_URL */],
        iconSrc: __WEBPACK_IMPORTED_MODULE_12__AppIcons_siftrock_svg___default.a
      }];

      if (hasInsiderSwitch) {
        apps.push({
          name: 'Insider',
          url: __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__["n" /* DRIFT_INSIDER_URL */],
          iconSrc: __WEBPACK_IMPORTED_MODULE_13__AppIcons_graduation_cap_svg___default.a
        });
      }

      if (hasDevPlatformSwitch) {
        apps.push({
          name: 'Developer Platform',
          url: __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__["k" /* DEVELOPERS_WEB_URL */],
          iconSrc: __WEBPACK_IMPORTED_MODULE_14__AppIcons_dev_platform_svg___default.a
        });
      }

      if (settingsLoaded && this.props.showVideoOption && hasVideoSwitch) {
        apps.unshift({
          name: 'Drift Video',
          url: videoSignUpDone ? __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__["o" /* DRIFT_VIDEO_URL */] : __WEBPACK_IMPORTED_MODULE_10_constants_ResourcesConstants__["o" /* DRIFT_VIDEO_URL */] + '/accounts/existing-redirect',
          iconSrc: __WEBPACK_IMPORTED_MODULE_11__AppIcons_library_svg___default.a
        });
      }

      return apps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var showAppSwitcher = this.state.showAppSwitcher;


      if (__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isRbacUser() && !__WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].hasGates('app_switcher')) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { ref: this.setAppSwitcherRef },
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
          { className: 'navigation-hover-tooltip--wrapper', component: 'Switch Apps', flow: 'right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
            { className: 'nav-status-icon-wrapper', onClick: this.openAppSwitcher },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: 18, height: 18, src: __WEBPACK_IMPORTED_MODULE_6__AppIcons_app_switch_svg___default.a, alt: 'app-switcher' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('drift-app-switch-nav', { 'open': showAppSwitcher })
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
            { className: 'app-switcher-header' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
              { className: 'app-switcher-back-button', onClick: function onClick() {
                  return _this2.setState({ showAppSwitcher: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { width: 16, height: 16, name: 'arrow-2-left' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["H3"],
              { className: 'app-switcher-header-text' },
              'Switch to...'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_5_utils_Access__["c" /* default */].isMultiOrg() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Organizations__["a" /* default */], null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
            { className: 'app-switcher-app-list' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["H4"],
              { className: 'app-switcher-app-list-header' },
              ' APPS '
            ),
            this.getApps().map(function (app) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AppLink__["a" /* default */], { app: app, key: app.name });
            })
          )
        )
      );
    }
  }]);

  return AppSwitcher;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    settingsLoaded: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_selectors__["h" /* propertiesLoaded */](state),
    videoSignUpDone: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_properties_selectors__["j" /* videoSignUpDone */](state),
    trafficControlConfig: __WEBPACK_IMPORTED_MODULE_9_app_modules_user_selectors__["trafficControlConfig"](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(AppSwitcher));

/***/ }),

/***/ "rMfo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__ = __webpack_require__("W8CA");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var DefaultEmbedActions = Marty.createActionCreators({
  updateDefaultEmbed: function updateDefaultEmbed(configuration, notificationMessage) {
    return this.app.queries.DefaultEmbedQueries.updateDefaultEmbed(configuration, notificationMessage);
  },
  patchDefaultEmbed: function patchDefaultEmbed(operations, notificationMessage) {
    return this.app.queries.DefaultEmbedQueries.patchDefaultEmbed(operations, notificationMessage);
  },
  updateCurrentEmbed: function updateCurrentEmbed(update, message) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_DefaultEmbedConstants__["a" /* default */].UPDATE_CURRENT_EMBED, update, message);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (DefaultEmbedActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "rNMR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNbS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("Cb8u");
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__("t+vb");
/* unused harmony reexport selectors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epic__ = __webpack_require__("7RA5");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__epic__["a"]; });







/***/ }),

/***/ "rOpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rRpe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return tags; });
/* unused harmony export status */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tag; });
/* unused harmony export conversationTags */
/* unused harmony export customerTags */
/* unused harmony export tagsFetchStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isLoading; });
/* unused harmony export tagUpdateStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("9ZnD");



var root = function root(state) {
  return state.get('tags');
};
var tags = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root && root.get('data');
});
var status = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root && root.get('status');
});
var tag = function tag(state, _ref) {
  var tagId = _ref.tagId;
  return root(state) && root(state).getIn(['data', tagId]);
};
var conversationTags = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(tags, function (tags) {
  return tags.valueSeq().filter(function (tag) {
    return tag.targetType === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* TagType */].CONVERSATION;
  });
});
var customerTags = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(tags, function (tags) {
  return tags.valueSeq().filter(function (tag) {
    return tag.targetType === __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* TagType */].ANY;
  });
});
var tagsFetchStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(status, function (status) {
  return status && status.getIn(['tags', 'fetch']);
});
var isLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(tagsFetchStatus, function (tagsFetchStatus) {
  return tagsFetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* constants */].RECEIVE_TAG_LIST;
});
var isLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(tagsFetchStatus, function (tagsFetchStatus) {
  return tagsFetchStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* constants */].FETCH_TAG_LIST_PENDING;
});
var tagUpdateStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(status, function (status) {
  return status && status.getIn(['tag', 'update']);
});

/***/ }),

/***/ "rS5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumberInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StringsInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_plus_svg__ = __webpack_require__("EI0t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_plus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_close_svg__ = __webpack_require__("DHpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_close_svg__);






var NumberInput = function NumberInput(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === undefined ? 0 : _ref$min,
      max = _ref.max,
      _onChange = _ref.onChange,
      value = _ref.value,
      className = _ref.className;
  return React.createElement('input', {
    className: className,
    type: 'number',
    min: min,
    max: max,
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    },
    placeholder: 'Enter value'
  });
};

var StringsInput = function StringsInput(_ref2) {
  var _onChange2 = _ref2.onChange,
      value = _ref2.value,
      className = _ref2.className,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === undefined ? 'Enter Value' : _ref2$placeholder;
  return React.createElement(
    'div',
    { className: className },
    React.createElement(
      'div',
      null,
      (value || __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('')).map(function (innerValue, index) {
        return React.createElement(
          'div',
          { className: 'flex strings-input', style: { marginBottom: 10 }, key: index },
          React.createElement('input', {
            type: 'text',
            value: innerValue,
            onChange: function onChange(event) {
              return _onChange2(value.set(index, event.target.value));
            },
            placeholder: placeholder
          }),
          index === 0 ? React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_plus_svg___default.a, onClick: function onClick() {
              return _onChange2(value.push(''));
            } }) : React.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_close_svg___default.a, onClick: function onClick() {
              return _onChange2(value.delete(index));
            } })
        );
      })
    )
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "rSFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SettingsPageTitle":"SettingsPageTitle---1z6Me"};

/***/ }),

/***/ "rVLa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CurrentTeamMembers":"CurrentTeamMembers---2i2W9"};

/***/ }),

/***/ "rVtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("8Eel");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["N" /* fetchMeetingSettingsSuccess */], function (state, action) {
  return state.setIn(['meeting'], action.payload).setIn(['meetingStatus'], 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["L" /* fetchMeetingSettingsFailure */], function (state) {
  return state.setIn(['meetingStatus'], 'failed');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_29" /* updateMeetingSettingsPending */], function (state) {
  return state.setIn(['meetingStatus'], 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_30" /* updateMeetingSettingsSuccess */], function (state, action) {
  return state.setIn(['meeting'], action.payload).setIn(['meetingStatus'], 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_24" /* updateMeetingSettingsFailure */], function (state) {
  return state.setIn(['meetingStatus'], 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["x" /* fetchCalendlyMeetingTypesSuccess */], function (state) {
  return state.setIn(['calendlyMeetingTypesStatus'], 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["w" /* fetchCalendlyMeetingTypesPending */], function (state) {
  return state.setIn(['calendlyMeetingTypesStatus'], 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["v" /* fetchCalendlyMeetingTypesFailure */], function (state) {
  return state.setIn(['calendlyMeetingTypesStatus'], 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["R" /* fetchMeetingTypesSuccess */], function (state, action) {
  return state.setIn(['meetingTypes'], action.payload).setIn(['meetingTypesStatus'], 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["Q" /* fetchMeetingTypesPending */], function (state) {
  return state.setIn(['meetingTypesStatus'], 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_33" /* updateMeetingTypePending */], function (state) {
  return state.setIn(['meetingTypesStatus'], 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_34" /* updateMeetingTypeSuccess */], function (state, _ref) {
  var payload = _ref.payload;

  var filterSlug = payload.oldSlug || payload.slug;
  var existingMeetingTypes = state.get('meetingTypes').filter(function (mt) {
    return mt.slug !== filterSlug;
  });
  return state.set('meetingTypes', existingMeetingTypes.concat(payload)).set('meetingTypesStatus', 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_32" /* updateMeetingTypeFailure */], function (state) {
  return state.setIn(['meetingTypesStatus'], 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_25" /* updateMeetingSettingsNewAppointments */], function (state, action) {
  return state.setIn(['meeting', 'allowNewAppointments'], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["U" /* fetchMicrosoftAdminConsentPending */], function (state, action) {
  return state.set('fetchMicrosoftAdminConsentStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["V" /* fetchMicrosoftAdminConsentSuccess */], function (state, action) {
  return state.set('connected', false).set('microsoftCalendarAdminManaged', action.payload).set('fetchMicrosoftAdminConsentStatus', 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["T" /* fetchMicrosoftAdminConsentFailure */], function (state) {
  return state.set('connected', false).set('microsoftCalendarAdminManaged', false).set('fetchMicrosoftAdminConsentStatus', 'failed');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["m" /* disconnectMicrosoftAdminConsentSuccess */], function (state) {
  return state.set('connected', false).set('microsoftCalendarAdminManaged', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["k" /* disconnectMicrosoftAdminConsentFailure */], function (state) {
  return state.set('microsoftCalendarAdminError', true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_9" /* microsoftAdminManagedAcceptSuccess */], function (state, action) {
  return state.set('connected', false).set('microsoftCalendarAdminError', false).set('microsoftCalendarAdminManaged', true).set('microsoftCalendarAdminIds', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_8" /* microsoftAdminManagedAcceptFailure */], function (state, action) {
  return state.set('connected', false).set('microsoftCalendarAdminManaged', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_2" /* fetchMicrosoftManagedCalendarsPending */], function (state, action) {
  return state.set('fetchMicrosoftGlobalCalendarStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_3" /* fetchMicrosoftManagedCalendarsSuccess */], function (state, action) {
  return state.set('microsoftCalendarAdminIds', action.payload).set('fetchMicrosoftGlobalCalendarStatus', 'success').set('microsoftCalendarAdminError', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_1" /* fetchMicrosoftManagedCalendarsFailure */], function (state, action) {
  return state.set('microsoftCalendarAdminError', true).set('fetchMicrosoftGlobalCalendarStatus', 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_6" /* googleOauthAcceptSuccess */], function (state) {
  return state.set('connected', false).set('googleAuthed', true).set('googleAuthedError', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_5" /* googleOauthAcceptFailure */], function (state) {
  return state.set('connected', false).set('googleAuthed', false).set('googleAuthedError', true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_12" /* microsoftOauthAcceptSuccess */], function (state) {
  return state.set('connected', false).set('microsoftAuthed', true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_11" /* microsoftOauthAcceptFailure */], function (state) {
  return state.set('connected', false).set('microsoftAuthed', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_41" /* zoomOauthAcceptSuccess */], function (state) {
  return state.set('connected', false).set('zoomAuthed', true).set('zoomAuthedError', false);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_40" /* zoomOauthAcceptFailure */], function (state) {
  return state.set('connected', false).set('zoomAuthed', false).set('zoomAuthedError', true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["t" /* fetchCalendarStatusPending */], function (state) {
  return state.set('calendarStatusFetchStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["u" /* fetchCalendarStatusSuccess */], function (state, action) {
  return state.set('connected', action.payload.connected).set('calendar', action.payload.calendar).set('googleAuthed', action.payload.googleAuthed).set('microsoftAuthed', action.payload.microsoftAuthed).set('calendarStatusFetchStatus', 'success').set('isTokenRevoked', action.payload.isTokenRevoked);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["s" /* fetchCalendarStatusFailure */], function (state) {
  return state.set('calendarStatusFetchStatus', 'failure');
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["_22" /* updateGoogleCalendarSuccess */], __WEBPACK_IMPORTED_MODULE_1__actions__["_38" /* updateMicrosoftCalendarSuccess */]), function (state, action) {
  return state.set('calendar', action.payload).set('connected', true);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["F" /* fetchGoogleCalendarsSuccess */], __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* fetchMicrosoftCalendarsSuccess */]), function (state, action) {
  return state.set('calendars', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["J" /* fetchGoogleScopesSuccess */], function (state, action) {
  return state.set('scopes', action.payload);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["_21" /* updateGoogleCalendarPending */], __WEBPACK_IMPORTED_MODULE_1__actions__["_37" /* updateMicrosoftCalendarPending */]), function (state) {
  return state.set('connected', true);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["_20" /* updateGoogleCalendarFailure */], __WEBPACK_IMPORTED_MODULE_1__actions__["_36" /* updateMicrosoftCalendarFailure */]), function (state) {
  return state.set('connected', false);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["h" /* disconnectGoogleCalendarPending */], __WEBPACK_IMPORTED_MODULE_1__actions__["p" /* disconnectMicrosoftCalendarPending */]), function (state) {
  return state.set('connected', false);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* disconnectGoogleCalendarFailure */], __WEBPACK_IMPORTED_MODULE_1__actions__["o" /* disconnectMicrosoftCalendarFailure */]), function (state) {
  return state.set('connected', true);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["i" /* disconnectGoogleCalendarSuccess */], function (state) {
  return state.withMutations(function (state) {
    return state.set('connected', false).set('scopes', []).set('googleAuthed', undefined).delete('calendar').delete('calendars');
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["q" /* disconnectMicrosoftCalendarSuccess */], function (state) {
  return state.withMutations(function (state) {
    return state.set('connected', false).set('microsoftAuthed', undefined).delete('calendar').delete('calendars');
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["E" /* fetchGoogleCalendarsPending */], function (state) {
  return state.set('googleCalendarsFetchStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["F" /* fetchGoogleCalendarsSuccess */], function (state) {
  return state.set('googleCalendarsFetchStatus', 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["D" /* fetchGoogleCalendarsFailure */], function (state) {
  return state.set('googleCalendarsFetchStatus', 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["Y" /* fetchMicrosoftCalendarsPending */], function (state) {
  return state.set('microsoftCalendarsFetchStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["Z" /* fetchMicrosoftCalendarsSuccess */], function (state) {
  return state.set('microsoftCalendarsFetchStatus', 'success');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["X" /* fetchMicrosoftCalendarsFailure */], function (state) {
  return state.set('microsoftCalendarsFetchStatus', 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["A" /* fetchConnectedCalendarsPending */], function (state) {
  return state.set('agentIdsWithConnectedCalendarsStatus', 'pending');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["B" /* fetchConnectedCalendarsSuccess */], function (state, action) {
  return state.set('agentIdsWithConnectedCalendarsStatus', 'success').set('agentIdsWithConnectedCalendars', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["z" /* fetchConnectedCalendarsFailure */], function (state) {
  return state.set('agentIdsWithConnectedCalendarsStatus', 'failure');
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_1__actions__["_16" /* shareRoutedCalendar */], function (state) {
  return state.set('shareRoutedCalendarLoading', true);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_1__actions__["_18" /* shareRoutedCalendarSuccess */], __WEBPACK_IMPORTED_MODULE_1__actions__["_17" /* shareRoutedCalendarFailure */]), function (state) {
  return state.set('shareRoutedCalendarLoading', false);
}), _handleActions), new __WEBPACK_IMPORTED_MODULE_2__models__["d" /* MeetingState */]()));

/***/ }),

/***/ "rc0/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__ = __webpack_require__("94Kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__ = __webpack_require__("v8oQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keymirror__);




var ORG_SETTINGS_CONSTANTS = __WEBPACK_IMPORTED_MODULE_2_keymirror___default()({
  ORG_SETTINGS_UPDATED: null,

  UPLOAD_ORG_LOGO_STARTED: null,
  UPLOAD_ORG_LOGO_FINISHED: null,
  UPLOAD_ORG_LOGO_FAILED: null,

  UPLOAD_WIDGET_ICON_STARTED: null,
  UPLOAD_WIDGET_ICON_FINISHED: null,
  UPLOAD_WIDGET_ICON_FAILED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash_mapValues___default()(ORG_SETTINGS_CONSTANTS, __WEBPACK_IMPORTED_MODULE_1_lodash_uniqueId___default.a));

/***/ }),

/***/ "rc0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__("y1vT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var MarketoProgramSelect = function (_Component) {
  _inherits(MarketoProgramSelect, _Component);

  function MarketoProgramSelect(props) {
    var _this2 = this;

    _classCallCheck(this, MarketoProgramSelect);

    var _this = _possibleConstructorReturn(this, (MarketoProgramSelect.__proto__ || Object.getPrototypeOf(MarketoProgramSelect)).call(this, props));

    _this.getSelectedProgram = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var getSelectedProgram, program, programName, assignOnlyOnCreate;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getSelectedProgram = _this.props.getSelectedProgram;
              _context.prev = 1;
              _context.next = 4;
              return getSelectedProgram();

            case 4:
              program = _context.sent;
              programName = program.campaignId;
              assignOnlyOnCreate = program.assignOnlyOnCreate;


              _this.setState({
                selectedProgram: programName,
                assignOnlyOnCreate: assignOnlyOnCreate
              });
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);

              console.warn(_context.t0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[1, 10]]);
    }));

    _this._updateSelectOptions = function () {
      var _ref2 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(query) {
        var queryPrograms, selectedProgram, programs, programNames, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                queryPrograms = _this.props.queryPrograms;
                selectedProgram = _this.state.selectedProgram;
                _context2.prev = 2;
                _context2.next = 5;
                return queryPrograms(query);

              case 5:
                programs = _context2.sent;
                programNames = new Set(programs.map(function (program) {
                  return program.name;
                }));


                if (selectedProgram != '') {
                  programNames = programNames.add(selectedProgram);
                }

                options = Array.from(programNames).map(function (programName) {
                  return { label: programName, value: programName };
                });


                _this.setState({
                  fieldOptions: options,
                  isLoading: false
                });
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](2);

                console.warn(_context2.t0);
                _this.setState({ isLoading: false });

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.fetchAllPrograms = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var fetchPrograms;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fetchPrograms = _this.props.fetchPrograms;


              _this.setState({ isLoading: true });

              _context3.prev = 2;
              _context3.next = 5;
              return fetchPrograms();

            case 5:
              _context3.next = 11;
              break;

            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3['catch'](2);

              console.warn(_context3.t0);
              _this.setState({ isLoading: false });

            case 11:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[2, 7]]);
    }));
    _this.setProgram = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var _this$props, onSuccess, setProgram, _this$state, selectedProgram, assignOnlyOnCreate;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props = _this.props, onSuccess = _this$props.onSuccess, setProgram = _this$props.setProgram;
              _this$state = _this.state, selectedProgram = _this$state.selectedProgram, assignOnlyOnCreate = _this$state.assignOnlyOnCreate;
              _context4.prev = 2;
              _context4.next = 5;
              return setProgram(selectedProgram, assignOnlyOnCreate);

            case 5:
              onSuccess();
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](2);

              console.warn(_context4.t0);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2, [[2, 8]]);
    }));
    _this.deleteProgram = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var _this$props2, onSuccess, deleteProgram;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props2 = _this.props, onSuccess = _this$props2.onSuccess, deleteProgram = _this$props2.deleteProgram;
              _context5.prev = 1;
              _context5.next = 4;
              return deleteProgram();

            case 4:
              onSuccess();
              _context5.next = 10;
              break;

            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5['catch'](1);

              console.warn(_context5.t0);

            case 10:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this2, [[1, 7]]);
    }));

    _this.handleSelectChange = function (selectedOption) {
      var newValue = void 0;

      var selectionCleared = !selectedOption;
      if (selectionCleared) {
        newValue = '';
        _this.setState({
          selectedProgram: newValue,
          assignOnlyOnCreate: false
        }, _this.deleteProgram);
      } else {
        newValue = selectedOption.value;
        _this.setState({
          selectedProgram: newValue
        }, _this.setProgram);
      }
    };

    _this.handleCheckboxChange = function (newValue) {
      _this.setState({
        assignOnlyOnCreate: newValue
      }, _this.setProgram);
    };

    _this.state = {
      selectedProgram: '',
      assignOnlyOnCreate: false,
      fieldOptions: [],
      isLoading: false
    };

    _this.updateSelectOptions = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(_this._updateSelectOptions, 1000);
    return _this;
  }

  _createClass(MarketoProgramSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getSelectedProgram();
      this.fetchAllPrograms();
      this.updateSelectOptions("");
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedProgram = _state.selectedProgram,
          assignOnlyOnCreate = _state.assignOnlyOnCreate,
          fieldOptions = _state.fieldOptions,
          isLoading = _state.isLoading;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Select"], {
          className: 'marketo-program-select',
          options: fieldOptions,
          value: selectedProgram,
          onChange: this.handleSelectChange,
          onInputChange: this.updateSelectOptions,
          isLoading: isLoading
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
          className: 'marketo-program-checkbox',
          onChange: this.handleCheckboxChange,
          type: 'checkbox',
          label: 'Only associate net new leads with this program',
          checked: assignOnlyOnCreate
        })
      );
    }
  }]);

  return MarketoProgramSelect;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MarketoProgramSelect.propTypes = {
  fetchPrograms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  queryPrograms: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getSelectedProgram: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  setProgram: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  deleteProgram: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  onSuccess: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (MarketoProgramSelect);

/***/ }),

/***/ "rdCL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ClearbitRevealPreview__ = __webpack_require__("FgcT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanyInfo_NoCompanyInfo__ = __webpack_require__("hCmk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CompanyInfo__ = __webpack_require__("BaCT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CompanyInfo_newCompanyInfo__ = __webpack_require__("L6Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__ = __webpack_require__("OWv3");













var makeMapStateToProps = function makeMapStateToProps() {

  return function (state, props) {
    var revealContext = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state);
    var hasDemandbase = Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_integrations_selectors__["l" /* isConnectedTo */])(state, 'demandbase');
    var canUseCompanyTags = __WEBPACK_IMPORTED_MODULE_9_app_modules_gates_selectors__["a" /* canUseCompanyTags */](state);

    return {
      companyInfo: props.company,
      revealContext: revealContext,
      hasDemandbase: hasDemandbase,
      canUseCompanyTags: canUseCompanyTags
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({}, dispatch)
  };
};

var CompanyTab = Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["a" /* branch */])(function (props) {
  return !props.hasDemandbase && props.revealContext.isEligibleForLiveRevealUpgradeFlow;
}, Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_3_components_ClearbitRevealPreview__["a" /* ClearbitRevealLivePreview */])), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["a" /* branch */])(function (props) {
  return (!props.companyInfo || !props.companyInfo.name) && !props.endUserId;
}, Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_6__CompanyInfo_NoCompanyInfo__["a" /* default */])), Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["a" /* branch */])(function (props) {
  return props.endUserId;
}, Object(__WEBPACK_IMPORTED_MODULE_0_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_8__CompanyInfo_newCompanyInfo__["a" /* default */])))(__WEBPACK_IMPORTED_MODULE_7__CompanyInfo__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyTab);

/***/ }),

/***/ "rfXu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ThemeSettings":"ThemeSettings---Vth2k","CoverPhotoUploadButton":"CoverPhotoUploadButton---5zxE1","DropZone":"DropZone---1Wtn2","DropZone--active":"DropZone--active---1Rdcl","ProfileLayoutInput":"ProfileLayoutInput---1Iy1F","ProfileLayoutInput--checked":"ProfileLayoutInput--checked---2e6Fy","ProfileLayoutInput__radio":"ProfileLayoutInput__radio---KTE-i"};

/***/ }),

/***/ "rg4R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (Object.freeze([{
  "displayName": "Audience",
  "name": "audience"
}, {
  "displayName": "Company Name",
  "name": "companyName"
}, {
  "displayName": "Industry",
  "name": "industry"
}, {
  "displayName": "Sub Industry",
  "name": "subIndustry"
}, {
  "displayName": "Employee Count",
  "name": "employeeCount"
}, {
  "displayName": "Employee Range",
  "name": "employeeRange"
}, {
  "displayName": "Marketing Alias",
  "name": "marketingAlias"
}, {
  "displayName": "Annual Sales",
  "name": "annualSales"
}, {
  "displayName": "Revenue Range",
  "name": "revenueRange"
}, {
  "displayName": "City",
  "name": "city"
}, {
  "displayName": "State",
  "name": "state"
}, {
  "displayName": "Country Code",
  "name": "countryCode"
}, {
  "displayName": "Country Name",
  "name": "countryName"
}]));

/***/ }),

/***/ "rhnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__ = __webpack_require__("nJx7");
/* eslint-disable
    import/default,
    import/no-duplicates,
    import/no-named-as-default-member,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.




var ApiKeyAPI = Marty.createStateSource({
  id: 'ApiKeyAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  getApiKeyByOrgId: function getApiKeyByOrgId(orgId) {
    return this.get({
      url: '/organizations/' + orgId + '/api_keys',
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createApiKeyForOrgId: function createApiKeyForOrgId(orgId) {
    return this.post({
      url: '/organizations/' + orgId + '/api_keys',
      contentType: __WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_1_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify({ isProd: true })
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (ApiKeyAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "riHt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__ = __webpack_require__("Lrv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__ = __webpack_require__("xoR/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("PN6C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TargetedAccountsFilter = function (_Component) {
  _inherits(TargetedAccountsFilter, _Component);

  function TargetedAccountsFilter(props) {
    _classCallCheck(this, TargetedAccountsFilter);

    var _this = _possibleConstructorReturn(this, (TargetedAccountsFilter.__proto__ || Object.getPrototypeOf(TargetedAccountsFilter)).call(this, props));

    _this.props.setPageValidity(true);
    _this.props.updateAction(_extends({}, __WEBPACK_IMPORTED_MODULE_4_app_modules_rules_models__["B" /* targetedAccountsAction */]));
    return _this;
  }

  _createClass(TargetedAccountsFilter, [{
    key: 'renderCopySection',
    value: function renderCopySection() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice-content drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_user_target_svg___default.a }),
          ' When a known user chats in to Drift, we\u2019ll check to see if they are a targeted account. If so, we\u2019ll route the conversation to their account owner.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_user_search_svg___default.a }),
          'If we can\u2019t map an owner to a Drift teammate, we\u2019ll carry on with your other Routing Rules.'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-targeted-accounts-filter rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Targeted Accounts'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-editor-content' },
          this.renderCopySection()
        )
      );
    }
  }]);

  return TargetedAccountsFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TargetedAccountsFilter);

/***/ }),

/***/ "rjNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("Ghb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__("GHhY");






var fetchOAuthCodeEpic = function fetchOAuthCodeEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["e" /* fetchOAuthCode */].toString()).pluck('payload').switchMap(function (_ref) {
    var redirect_uri = _ref.redirect_uri,
        client_id = _ref.client_id;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromPromise(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchOAuthCode({ redirect_uri: redirect_uri, client_id: client_id })).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["h" /* fetchOAuthCodeSuccess */]({ redirect_uri: redirect_uri, client_id: client_id, code: response.code });
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["g" /* fetchOAuthCodePending */]({ client_id: client_id })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["f" /* fetchOAuthCodeFailed */]({ error: error, client_id: client_id }));
    });
  });
};

var fetchOAuthAppInfoEpic = function fetchOAuthAppInfoEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* fetchOAuthAppInfo */].toString()).pluck('payload').switchMap(function (_ref2) {
    var client_id = _ref2.client_id;

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* api */].fetchOAuthAppInfo({ client_id: client_id }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_3__actions__["d" /* fetchOAuthAppInfoSuccess */]({ client_id: client_id, app: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* fetchOAuthAppInfoPending */]({ client_id: client_id })).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* fetchOAuthAppInfoFailed */]({ error: error, client_id: client_id }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchOAuthCodeEpic, fetchOAuthAppInfoEpic);

/***/ }),

/***/ "rpEm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestBulkUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestBulkUpdatePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return requestBulkUpdateFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return requestBulkUpdateSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return receiveBulkUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveBulkUpdatePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveBulkUpdateFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return receiveBulkUpdateSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("TDXv");




var requestBulkUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* REQUEST_BULK_UPDATE */]);
var requestBulkUpdatePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* REQUEST_BULK_UPDATE_PENDING */]);
var requestBulkUpdateFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* REQUEST_BULK_UPDATE_FAILED */]);
var requestBulkUpdateSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* REQUEST_BULK_UPDATE_SUCCESS */]);

var receiveBulkUpdate = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* RECEIVE_BULK_UPDATE */]);
var receiveBulkUpdatePending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RECEIVE_BULK_UPDATE_PENDING */]);
var receiveBulkUpdateFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* RECEIVE_BULK_UPDATE_FAILED */]);
var receiveBulkUpdateSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* RECEIVE_BULK_UPDATE_SUCCESS */]);

/***/ }),

/***/ "rrQF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_EMBED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_EMBED_BY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_EMBED_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_EMBED_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_EMBED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMBED_DATA_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PATCH_EMBED_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PATCH_EMBED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PATCH_EMBED_PENDING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");


var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('embed');

var FETCH_EMBED = makeConstant('FETCH_EMBED');
var FETCH_EMBED_BY_ID = makeConstant('FETCH_EMBED_BY_ID');
var FETCH_EMBED_PENDING = makeConstant('FETCH_EMBED_PENDING');
var FETCH_EMBED_FAILED = makeConstant('FETCH_EMBED_FAILED');
var FETCH_EMBED_SUCCESS = makeConstant('FETCH_EMBED_SUCCESS');

var EMBED_DATA_ADDED = makeConstant('EMBED_DATA_ADDED');

var PATCH_EMBED_ERROR = makeConstant('PATCH_EMBED_ERROR');
var PATCH_EMBED_SUCCESS = makeConstant('PATCH_EMBED_SUCCESS');
var PATCH_EMBED_PENDING = makeConstant('PATCH_EMBED_PENDING');

/***/ }),

/***/ "rtN9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rx5m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RadioOption":"RadioOption---Z1_px"};

/***/ }),

/***/ "ryZ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__("votI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_TargetConditionInput__ = __webpack_require__("xfIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Customize_Audience_Helpers__ = __webpack_require__("vMoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__ = __webpack_require__("kmUj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl__ = __webpack_require__("PbNt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












function maybeUnsetUserListIds(orgSettings) {
  var _orgSettings$theme = orgSettings.theme,
      userListIds = _orgSettings$theme.userListIds,
      audience = _orgSettings$theme.audience;


  if (userListIds && audience !== __WEBPACK_IMPORTED_MODULE_6_components_Customize_Audience_Helpers__["a" /* Audiences */].SEGMENT.key) {
    return orgSettings.removeIn(['theme', 'userListIds']);
  }
  return orgSettings;
}

var Target = function (_Component) {
  _inherits(Target, _Component);

  function Target(props) {
    _classCallCheck(this, Target);

    var _this = _possibleConstructorReturn(this, (Target.__proto__ || Object.getPrototypeOf(Target)).call(this, props));

    _this.onTargetIdSelected = _this.onTargetIdSelected.bind(_this);
    return _this;
  }

  _createClass(Target, [{
    key: 'updateOrgSettingsWithTargetId',
    value: function updateOrgSettingsWithTargetId(targetId) {
      var orgSettings = this.props.orgSettings;

      return orgSettings.setIn(['theme', 'targetId'], targetId);
    }
  }, {
    key: 'onTargetIdSelected',
    value: function onTargetIdSelected(newTargetId, targetEdited) {
      var initialTargetId = this.props.orgSettings.theme.targetId;
      var shouldUpdate = targetEdited || newTargetId !== initialTargetId;

      if (shouldUpdate) this.updateTargetId(newTargetId);
    }
  }, {
    key: 'updateTargetId',
    value: function updateTargetId(targetId) {
      var initialOrgSettings = this.props.embed.configuration;
      var updatedOrgSettings = this.updateOrgSettingsWithTargetId(targetId);
      var changes = Object(__WEBPACK_IMPORTED_MODULE_5_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(maybeUnsetUserListIds(updatedOrgSettings), initialOrgSettings);
      var actions = this.context.app.actions;


      actions.OrgSettingsActions.updateOrgSettings(updatedOrgSettings);
      actions.DefaultEmbedActions.patchDefaultEmbed(changes, __WEBPACK_IMPORTED_MODULE_7_components_Customize_Availability_Constants__["g" /* NotificationMessages */].TARGETING);
    }
  }, {
    key: 'render',
    value: function render() {
      var orgSettings = this.props.orgSettings;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_CampaignWizards_TargetingInputArea_TargetConditionInput__["a" /* default */], {
        selectedTargetId: orgSettings.theme.targetId,
        onSelection: this.onTargetIdSelected,
        filterPlaybookTargets: true,
        className: __WEBPACK_IMPORTED_MODULE_8__style_styl___default.a.ChatWidgetTargetRule });
    }
  }]);

  return Target;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Target.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


function mapStateToProps(state) {
  return {
    embed: state.get('embed').toJS().data
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, null)(Target));

/***/ }),

/***/ "rzwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var FETCH_ORG_END_USER_COUNT_DONE = __webpack_require__("h6+o").default.FETCH_ORG_END_USER_COUNT_DONE;

var EndUserCountStore = Marty.createStore({
  id: 'EndUserCountStore',

  getInitialState: function getInitialState() {
    return {
      countByStartDate: {}
    };
  },


  handlers: {
    fetchEndUserCountDone: FETCH_ORG_END_USER_COUNT_DONE
  },

  fetchOrgEndUserCount: function fetchOrgEndUserCount(startDate) {
    var id = 'fetchOrgEndUserCount' + startDate;
    return this.fetch({
      id: id,
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.state.countByStartDate[startDate];
        }
      },
      remotely: function remotely() {
        var orgId = this.app.stores.OrgStore.getCurrentOrg().id;
        return this.app.queries.EndUserQueries.fetchOrgEndUserCount(orgId, startDate);
      }
    });
  },
  fetchEndUserCountDone: function fetchEndUserCountDone(count, startDate) {
    var countByStartDate = {};
    countByStartDate[startDate] = count;
    countByStartDate = _.assign({}, this.state.countByStartDate, countByStartDate);
    return this.setState({ countByStartDate: countByStartDate });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserCountStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "s+vs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BotCampaign */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseBotCampaign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var Attributes = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  interactionId: undefined,
  delivery: "FOREVER",
  runUntil: undefined,
  senderId: undefined,
  messageType: "CHAT"
});

var BotCampaign = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  name: 'LeadBot Campaign - created on ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('LL'),
  type: "BOT",
  inboxId: undefined,
  audience: undefined,
  userListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  targetId: 0,
  attributes: Attributes()
});

var parseBotCampaign = function parseBotCampaign(_ref) {
  var attributes = _ref.attributes,
      userListIds = _ref.userListIds,
      rest = _objectWithoutProperties(_ref, ['attributes', 'userListIds']);

  return BotCampaign(_extends({
    userListIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(userListIds),
    attributes: Attributes(attributes)
  }, rest));
};


/***/ }),

/***/ "s0m3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_object__ = __webpack_require__("1Rfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("bO/0");











var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["currentUser"](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_6_app_modules_user_selectors__["nonBotUsers"](state),
    signaturePreviewAllData: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_92" /* signaturePreviewAllData */](state),
    signaturePreviewAllFetchPending: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_94" /* signaturePreviewAllFetchPending */](state),
    signaturePreviewAllFetchFailed: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_93" /* signaturePreviewAllFetchFailed */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchSignatureMultiBannerPreview: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_62" /* fetchSignatureMultiBannerPreview */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    this.props.actions.fetchSignatureMultiBannerPreview({ userId: this.props.currentUser.id, isPlaybookEditor: true });
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedUserId', 'setSelectedUserId', function (props) {
  return props.currentUser.id;
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onUserSelect: function onUserSelect(props) {
    return function (selected) {
      var selectedUserId = Object(__WEBPACK_IMPORTED_MODULE_3_lodash_object__["get"])(selected, 'value', props.currentUser.id);
      props.actions.fetchSignatureMultiBannerPreview({ userId: selectedUserId, isPlaybookEditor: true });
      props.setSelectedUserId(selectedUserId);
    };
  },
  onRefetchPreviewClick: function onRefetchPreviewClick(props) {
    return function () {
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.selectedUserId, isPlaybookEditor: true });
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    selectRandomUser: function selectRandomUser() {
      var randomUser = props.orgUsers.toList().get(Math.round(Math.random() * (props.orgUsers.size - 1)));
      props.onUserSelect({ value: randomUser.id });
    }
  };
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "s15K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("+5q1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_rockon_svg__ = __webpack_require__("WAuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_rockon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_rockon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_times_icon_svg__ = __webpack_require__("+Juk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_times_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_times_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_agentstatus_png__ = __webpack_require__("M+te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_agentstatus_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_agentstatus_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_snooze_png__ = __webpack_require__("N0ey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_snooze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_snooze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_rule_png__ = __webpack_require__("dMja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_rule_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_rule_png__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var OptInModal = function (_Component) {
  _inherits(OptInModal, _Component);

  function OptInModal(props) {
    _classCallCheck(this, OptInModal);

    var _this = _possibleConstructorReturn(this, (OptInModal.__proto__ || Object.getPrototypeOf(OptInModal)).call(this, props));

    _this.state = {
      position: 0,
      active: 0
    };
    return _this;
  }

  _createClass(OptInModal, [{
    key: 'changePosition',
    value: function changePosition(index) {
      this.setState({
        position: index * 500,
        active: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var onClose = this.props.onClose;

      return (
        //get rid of this opinionated modal wrapper...
        //and these inline reset styles..
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__["a" /* default */],
          {
            onRequestClose: onClose,
            isOpen: true,
            style: { content: { padding: 0, border: '1px solid transparent', background: 'none' } }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'drift-modal gradient-modal opt-in-modal' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'header',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_rockon_svg___default.a }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h2',
                null,
                'Update Successful!'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'drift-image-slider', style: { transform: 'translateX(-' + this.state.position + 'px)' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'drift-image-slider-slide' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'drift-image-slider-slide-image' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_6__images_agentstatus_png___default.a })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Agent Availability is now only Active + Away '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'We simplified Agent Availability. When you set yourself to Away, you won\u2019t be automatically added to conversations. Perfect for when you need to step out for lunch!'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'drift-image-slider-slide' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'drift-image-slider-slide-image' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_7__images_snooze_png___default.a })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'You can now snooze notifications even if you\u2019re Active'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Do Not Disturb is now a notification toggle so you can control whether or not you recieve notifications seperately from your Active or Away status.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'drift-image-slider-slide' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'drift-image-slider-slide-image' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_8__images_rule_png___default.a })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'On-Call is ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    'replaced'
                  ),
                  ' by the Default Lead Routing Rule'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'We\u2019ll be turning the On-Call status into a Default Lead Routing Rule to reduce confusion and give you more control over who is automatically added to a conversation.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'drift-image-slider-pager' },
              _.range(3).map(function (index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
                  className: index === _this2.state.active && 'active',
                  onClick: function onClick() {
                    return _this2.changePosition(index);
                  } });
              })
            )
          )
        )
      );
    }
  }]);

  return OptInModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (OptInModal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "s32+":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(0 1)\"><g stroke=\"#D6DDE1\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M173.138 76.382c-.79.64-1.604 1.23-2.437 1.77\"></path><path stroke-dasharray=\"5.615999937057495,11.23349976539612\" d=\"M160.269 82.235c-9.705 1.68-20.006-1.8-26.643-9.996L103.81 35.417c-7.897-9.752-20.983-12.83-32.078-8.48\"></path></g><path fill=\"#D6DDE1\" fill-rule=\"nonzero\" d=\"M127.34 19.775l1.078 3.662a.963.963 0 0 0 .65.65l3.66 1.077c.92.27.92 1.574 0 1.844l-3.66 1.079a.96.96 0 0 0-.65.65l-1.078 3.66c-.27.919-1.573.919-1.844 0l-1.078-3.66a.958.958 0 0 0-.65-.65l-3.66-1.08c-.92-.27-.92-1.572 0-1.843l3.66-1.077a.96.96 0 0 0 .65-.65l1.078-3.662c.271-.92 1.573-.92 1.844 0\"></path><path fill=\"#EFF3F5\" fill-rule=\"nonzero\" d=\"M186.922 93.69l1.077 3.661a.963.963 0 0 0 .65.65l3.66 1.078c.921.27.921 1.574 0 1.844L188.65 102a.96.96 0 0 0-.65.65l-1.077 3.66c-.272.92-1.573.92-1.845 0l-1.077-3.66a.958.958 0 0 0-.65-.65l-3.66-1.078c-.92-.27-.92-1.574 0-1.844l3.66-1.077a.96.96 0 0 0 .65-.65l1.077-3.662c.272-.92 1.573-.92 1.845 0m-25.327-26.183a3.177 3.177 0 1 1 0-6.356 3.178 3.178 0 1 1 0 6.356zm60.761-34.328a3.178 3.178 0 1 1-6.357 0 3.178 3.178 0 1 1 6.357 0m-162 44a3.178 3.178 0 1 1-6.357 0 3.178 3.178 0 1 1 6.357 0M94.88 6.938a2.938 2.938 0 0 1-2.941 2.939 2.938 2.938 0 1 1 0-5.877 2.938 2.938 0 0 1 2.94 2.938\"></path><path fill=\"#D6DDE1\" fill-rule=\"nonzero\" d=\"M94.05 52.508c.336 0 .516.397.294.65l-8.493 9.664c-.293.335-.829-.002-.654-.412l3.098-7.268h-4.903a.392.392 0 0 1-.305-.637l7.493-9.355c.279-.348.83-.034.672.383l-2.633 6.975h5.43z\"></path><path fill=\"#010101\" d=\"M30 4C13.431 4 0 17.431 0 34c0 16.569 13.431 30 30 30 16.569 0 30-13.431 30-30C60 17.431 46.569 4 30 4zm-.967 37.735c0 .467-.247.9-.65 1.136a1.28 1.28 0 0 1-1.283 0h-.013l-5.443-3.192v11.838c0 .466-.246.898-.648 1.135a1.28 1.28 0 0 1-1.296 0l-3.254-1.906a1.313 1.313 0 0 1-.646-1.136V36.254l-5.258-3.087a1.315 1.315 0 0 1-.648-1.138v-5.102c0-.467.247-.9.65-1.135a1.28 1.28 0 0 1 1.293 0l16.548 9.693c.402.238.648.671.646 1.138l.002 5.112zm.294-20.45c0 .65-.345 1.25-.904 1.578l-5 2.916v3.858a.502.502 0 0 1-.754.442c-2.017-1.179-7.5-4.39-9.513-5.56a.508.508 0 0 1 0-.877l14.238-8.315c.4-.234.895-.234 1.296 0 .403.236.65.67.647 1.138l-.01 4.82zm1.642-4.81c0-.467.247-.899.65-1.135.4-.234.895-.234 1.296 0l14.216 8.333a.512.512 0 0 1 0 .885L37.65 30.08a.513.513 0 0 1-.77-.45v-3.792a.096.096 0 0 0-.045-.077l-5.208-3.056a1.304 1.304 0 0 1-.646-1.137l-.012-5.092zm19.135 15.587c0 .467-.247.9-.65 1.136l-5.264 3.077-.01 13.35c0 .467-.247.9-.649 1.138l-3.256 1.902c-.197.113-.42.173-.648.175a1.29 1.29 0 0 1-.648-.178 1.319 1.319 0 0 1-.646-1.137V39.688l-5.448 3.185h-.012a1.28 1.28 0 0 1-1.283 0 1.317 1.317 0 0 1-.648-1.138v-5.104a1.317 1.317 0 0 1 .65-1.14l16.56-9.67a1.28 1.28 0 0 1 1.296 0c.402.237.648.67.646 1.137l.01 5.105z\"></path><circle cx=\"53\" cy=\"10\" r=\"10\" fill=\"#13CB6E\" stroke=\"#FFF\" stroke-width=\"2\"></circle><path fill=\"#FFF\" d=\"M52.46 14L49 10.998l1.502-1.795 1.879 1.631 4.54-4.364a.667.667 0 0 1 .952.028l.682.736a.667.667 0 0 1-.027.934L52.46 14z\"></path><path fill=\"#5952FF\" d=\"M206.347 43c7.35 0 18.458 2.252 23.63 7.417 1.31 1.309 3.023 3.874 3.023 7.63 0 6.678-5.387 16.924-11.335 22.867-3.076 3.072-7.967 7.086-14.547 7.086-6.433 0-11.345-4.364-12.767-5.785C188.902 76.773 185 68.513 185 60.811c0-4.86 1.387-9.11 4.925-12.643C193.203 44.895 198.85 43 206.347 43zm10.443 25.337c2.686-2.262 3.41-5.048 3.41-6.581 0-1.112-.348-2.743-2-4.132-2.533-2.133-5.339-2.735-8.39-2.735-3.866 0-6.464 1.028-8.194 2.486-1.356 1.142-2.53 2.898-2.53 5.393 0 2.494 1.58 4.903 3.3 6.35 1.59 1.339 4.089 2.33 6.605 2.33 2.515 0 5.113-.849 7.799-3.11z\"></path></g></svg>"

/***/ }),

/***/ "s6JI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export root */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectionsRoot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return connectionsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectionsFetchPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connectionsUpdatePending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isConnectedTo; });
/* unused harmony export connectionsFetched */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getPaginationQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return csvRequestSent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return didCreateAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return failedCreateAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accessTokenError; });
/* unused harmony export isFacebookSettingsPending */
/* unused harmony export facebookSettingsData */
/* unused harmony export facebookSettingsNeverFetched */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isStripeKeysPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return stripeKeysData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return stripeKeysNeverFetched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isOutreachStatusPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isOutreachConnected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getLeanDataAuthStatus; });
/* unused harmony export getLeanDataAuthStatusPending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var root = function root(state) {
  return state.get('integrations');
};
var connectionsRoot = function connectionsRoot(state) {
  return state.getIn(['integrations', 'connections']);
};
var connectionsStatus = function connectionsStatus(state) {
  return state.getIn(['integrations', 'connectionsStatus']);
};
var connectionsFetchPending = function connectionsFetchPending(state) {
  return state.getIn(['integrations', 'connectionsStatus']) === __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* FETCH_INTEGRATION_STATES_PENDING */];
};
var connectionsUpdatePending = function connectionsUpdatePending(state) {
  return state.getIn(['integrations', 'connectionsStatus']) === __WEBPACK_IMPORTED_MODULE_0__constants__["Z" /* UPDATE_INTEGRATION_STATE_PENDING */];
};
var isConnectedTo = function isConnectedTo(state, integrationName) {
  return connectionsRoot(state) ? !!connectionsRoot(state)[integrationName] : false;
};

var connectionsFetched = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(root, function (root) {
  return root.has('connections') && !_.isEmpty(root.get('connections'));
});

var getEvents = function getEvents(state, integrationType) {
  return root(state).getIn(['events', integrationType, 'data']);
};
var getPaginationQuery = function getPaginationQuery(state, integrationType) {
  var link = root(state).getIn(['events', integrationType, 'paginationLink']);
  return link ? link.split('/business/events/auth?')[1] : null;
};

var isLoaded = function isLoaded(state, integrationType) {
  return root(state).getIn(['events', integrationType, 'status'], '') === __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* FETCH_INTEGRATION_EVENTS_SUCCESS */];
};

var csvRequestSent = function csvRequestSent(state, integrationName) {
  return root(state).getIn(['events', integrationName, 'status'], '') === __WEBPACK_IMPORTED_MODULE_0__constants__["O" /* POST_BUSINESS_EVENT_CSV_SUCCESS */];
};

var didCreateAccessToken = function didCreateAccessToken(state, integrationType) {
  return root(state).getIn(['accessToken', integrationType, 'status']) === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CREATE_ACCESS_TOKEN_SUCCESS */];
};
var failedCreateAccessToken = function failedCreateAccessToken(state, integrationType) {
  return root(state).getIn(['accessToken', integrationType, 'status']) === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CREATE_ACCESS_TOKEN_FAILED */];
};
var accessTokenError = function accessTokenError(state, integrationType) {
  return root(state).getIn(['accessToken', integrationType, 'error']);
};

var facebookSettings = function facebookSettings(state) {
  return root(state).get('facebookSettings', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
};
var facebookSettingsStatus = function facebookSettingsStatus(state) {
  return facebookSettings(state).get('status');
};
var isFacebookSettingsPending = function isFacebookSettingsPending(state) {
  return facebookSettingsStatus(state) === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_FACEBOOK_SETTINGS_PENDING */];
};
var facebookSettingsData = function facebookSettingsData(state) {
  return facebookSettings(state).get('data', {});
};
var facebookSettingsNeverFetched = function facebookSettingsNeverFetched(state) {
  return facebookSettingsStatus(state) === undefined;
};

var stripeKeys = function stripeKeys(state) {
  return root(state).get('stripeKeys', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
};
var stripeKeysStatus = function stripeKeysStatus(state) {
  return stripeKeys(state).get('status');
};
var isStripeKeysPending = function isStripeKeysPending(state) {
  return stripeKeysStatus(state) === __WEBPACK_IMPORTED_MODULE_0__constants__["z" /* FETCH_STRIPE_KEYS_PENDING */];
};
var stripeKeysData = function stripeKeysData(state) {
  return stripeKeys(state).get('data', {});
};
var stripeKeysNeverFetched = function stripeKeysNeverFetched(state) {
  return stripeKeysStatus(state) === undefined;
};

var outreachStatus = function outreachStatus(state) {
  return root(state).get('outreachStatus', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
};
var isOutreachStatusPending = function isOutreachStatusPending(state) {
  return outreachStatus(state) === __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* FETCH_OUTREACH_STATUS_PENDING */];
};
var isOutreachConnected = function isOutreachConnected(state) {
  return outreachStatus(state).getIn(['data', 'installed'], false);
};

var getLeanDataAuthStatus = function getLeanDataAuthStatus(state) {
  return root(state).get('leanDataAuthStatus', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
};
var getLeanDataAuthStatusPending = function getLeanDataAuthStatusPending(state) {
  return getLeanDataAuthStatus(state).getIn(['leanDataAuthStatus', 'status']) === actions.getLeanDataAuthStatusPending.toString();
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "s8yh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GeoFilter__ = __webpack_require__("IRT7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___ = __webpack_require__("WyPe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SiteVisitsFilter__ = __webpack_require__("t8Y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UrlFilter__ = __webpack_require__("3LZu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SalesforceFilter__ = __webpack_require__("qd9f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TargetedAccountsFilter__ = __webpack_require__("riHt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LeandataFilter__ = __webpack_require__("Lv5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_shared_DriftAPI__ = __webpack_require__("f9kp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl__ = __webpack_require__("LMzq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_geolocation_svg__ = __webpack_require__("PKrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_geolocation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_geolocation_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_firmographics_small_svg__ = __webpack_require__("sNAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_firmographics_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_icons_window_settings_svg__ = __webpack_require__("XWnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_icons_window_settings_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_icons_window_settings_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_icons_link_icon_svg__ = __webpack_require__("oaJS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_icons_link_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_icons_link_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_salesforce_logo_svg__ = __webpack_require__("GHRo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_salesforce_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_salesforce_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_rolodex_svg__ = __webpack_require__("kk7P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_rolodex_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_rolodex_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_participant_svg__ = __webpack_require__("mXkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_participant_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_participant_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_logos_leandata_svg__ = __webpack_require__("MhvU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_images_logos_leandata_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_images_logos_leandata_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _MODELS;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




























var MODELS = (_MODELS = {}, _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["p" /* geoFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["p" /* geoFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["A" /* siteVisitsFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["o" /* firmographicFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["o" /* firmographicFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["c" /* companyTagsFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["v" /* marketTagsFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["D" /* techTagsFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["s" /* headquarterStateFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["q" /* headquarterCountryFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_POSTAL_CODE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["r" /* headquarterPostalCodeFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["a" /* annualRevenueFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_AUDIENCE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["e" /* demandbaseAudienceFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_MARKETING_ALIAS, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["l" /* demandbaseMarketingAliasFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_INDUSTRY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["k" /* demandbaseIndustryFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_SUB_INDUSTRY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["n" /* demandbaseSubIndustryFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_COUNT, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["f" /* demandbaseEmployeeCountFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_RANGE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["g" /* demandbaseEmployeeRangeFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_ANNUAL_SALES, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["d" /* demandbaseAnnualSalesFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_REVENUE_RANGE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["m" /* demandbaseRevenueRangeFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_CITY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["h" /* demandbaseHeadquarterCityFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["j" /* demandbaseHeadquarterStateFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["i" /* demandbaseHeadquarterCountryFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["F" /* urlPathFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_HOST, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["E" /* urlHostFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_QUERY, __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["G" /* urlQueryFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */], __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["z" /* salesforceFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */], __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["C" /* targetedAccountsFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["b" /* AVAILABILITY_FILTER */], __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["b" /* availabilityFilter */]), _defineProperty(_MODELS, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["C" /* LEANDATA_FILTER */], __WEBPACK_IMPORTED_MODULE_12_app_modules_rules_models__["u" /* leandataFilter */]), _MODELS);

var getFilterModel = function getFilterModel(type) {
  return _extends({}, MODELS[type]);
};

var FilterEditor = function (_Component) {
  _inherits(FilterEditor, _Component);

  function FilterEditor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterEditor.__proto__ || Object.getPrototypeOf(FilterEditor)).call.apply(_ref, [this].concat(args))), _this), _this.openChatWidget = function () {
      var chatPayload = {};
      if (__WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */] && __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["R" /* SALES_USER_ID */]) {
        chatPayload.inboxId = __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["Q" /* SALES_INBOX_ID */];
        chatPayload.sender = { id: __WEBPACK_IMPORTED_MODULE_11_constants_ResourcesConstants__["R" /* SALES_USER_ID */] };
      }
      __WEBPACK_IMPORTED_MODULE_10_components_shared_DriftAPI__["a" /* default */].showWelcomeMessage(chatPayload);
    }, _this.addFirmographics = function () {
      if (_this.props.hasFirmographics) {
        _this.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES);
      } else {
        _this.openChatWidget();
      }
    }, _this.addRuleFilter = function (TYPE) {
      var filterModel = getFilterModel(TYPE);
      _this.props.setActiveFilter(filterModel);
    }, _this.addSalesforceFilter = function () {
      if (!_this.props.hasSalesforceRouting) {
        return;
      }

      _this.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */]);
    }, _this.addLeandataFilter = function () {
      if (!_this.props.hasSalesforceRouting) {
        return;
      }

      _this.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["C" /* LEANDATA_FILTER */]);
    }, _this.addTargetedAccountsFilter = function () {
      if (!_this.props.hasABM) {
        return;
      }

      _this.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */]);
    }, _this.alreadyHasFilterOf = function (subType) {
      var categoryType = __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["f" /* CONDITION_TYPES */][subType];
      var orConditions = _this.props.rule.data.item.conditions[0];
      return orConditions && orConditions.find(function (cond) {
        return __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["f" /* CONDITION_TYPES */][cond.field] === categoryType;
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterEditor, [{
    key: 'renderFilterType',
    value: function renderFilterType() {
      var _filters;

      var filters = (_filters = {}, _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GeoFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].COUNTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GeoFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__SiteVisitsFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UrlFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_HOST, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UrlFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_QUERY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UrlFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].EMPLOYEES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MONEY_RAISED, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].COMPANY_CATEGORIES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].MARKET_CATEGORIES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].TECH_TAGS, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].HEADQUARTERS_POSTAL_CODE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].REVENUE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_AUDIENCE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_MARKETING_ALIAS, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_INDUSTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_SUB_INDUSTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_COUNT, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_EMPLOYEE_RANGE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_ANNUAL_SALES, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_REVENUE_RANGE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_CITY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_STATE, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["y" /* FIRMOGRAPHIC_FILTER_TYPES */].DEMANDBASE_HEADQUARTERS_COUNTRY, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FirmographicFilter___["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SalesforceFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TargetedAccountsFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _defineProperty(_filters, __WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["C" /* LEANDATA_FILTER */], __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LeandataFilter__["a" /* default */], _extends({}, this.props, { updateModel: this.addRuleFilter }))), _filters);

      return filters[this.props.activeFilter.field];
    }
  }, {
    key: 'renderFilterChoice',
    value: function renderFilterChoice() {
      var _this2 = this;

      var gatedFirmoClass = this.props.hasFirmographics ? '' : 'gated-filter';
      var gatedSfdcClass = this.props.hasSalesforceRouting ? '' : 'gated-filter';
      var gatedAbmClass = this.props.hasABM ? '' : 'gated-filter';
      var noConditions = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(this.props.rule.data.item.conditions[0]);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-chooser' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            null,
            'How do you want to route your leads?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Choose when you want this rule to run'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-list' },
          !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-card', onClick: function onClick() {
                return _this2.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["B" /* GEO_FILTER_TYPES */].STATE);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_15__svg_inline_removeTags_true_images_svg_geolocation_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Geolocation'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Match a certain region, country or state'
            )
          ),
          !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-card', onClick: function onClick() {
                return _this2.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_icons_window_settings_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Website Behavior'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Match the number of times a visitor has visited your site (sessions, not page views)'
            )
          ),
          !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-card', onClick: function onClick() {
                return _this2.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["V" /* URL_FILTER_TYPES */].URL_PATH);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_icons_link_icon_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'URL'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Match on a number of URL parameters such as, Path, Host, Query Param and (Regex)'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: gatedFirmoClass + ' rules-choice-card firmographic-choice', onClick: this.addFirmographics },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'upgrade-ribbon' },
              'Upgrade'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_16__svg_inline_removeTags_true_images_svg_firmographics_small_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Firmographics'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Match enriched data about your visitors like industry, company size, time zone etc. '
            )
          ),
          this.props.hasSalesforceRouting && this.props.showSalesforceOption && !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */]) && !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */]) && noConditions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: gatedSfdcClass + ' rules-choice-card salesforce-choice', onClick: function onClick() {
                return _this2.addSalesforceFilter();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'upgrade-ribbon' },
              'Upgrade'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_19__svg_inline_removeTags_true_images_svg_salesforce_logo_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Salesforce'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Add an identified contact\u2019s Account, Contact or Lead Owner to new conversations.'
            )
          ),
          !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["M" /* SALESFORCE_FILTER */]) && !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["R" /* TARGETED_ACCOUNTS_FILTER */]) && noConditions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: gatedAbmClass + ' rules-choice-card targeted-accounts-choice', onClick: function onClick() {
                return _this2.props.hasABM ? _this2.addTargetedAccountsFilter() : location.href = '/settings/billing';
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { className: 'upgrade-ribbon' },
              'Upgrade'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_20__svg_inline_removeTags_true_images_svg_rolodex_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Targeted Accounts'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Add an identified contact\u2019s Drift account owner to new conversations.'
            )
          ),
          !this.alreadyHasFilterOf(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["b" /* AVAILABILITY_FILTER */]) && noConditions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-card', onClick: function onClick() {
                return _this2.addRuleFilter(__WEBPACK_IMPORTED_MODULE_13_app_modules_rules_constants__["b" /* AVAILABILITY_FILTER */]);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_participant_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'Available Agents'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Add an available agent from within a specified group or team.'
            )
          ),
          this.props.hasLeandataRouting && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-card', onClick: function onClick() {
                return _this2.addLeandataFilter();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_22_images_logos_leandata_svg___default.a }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              'LeanData'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              'Add teammates to new conversations using LeanData lead assignment rules.'
            )
          )
        )
      );
    }
  }, {
    key: 'renderChoiceOrFilter',
    value: function renderChoiceOrFilter() {

      return this.props.activeFilter === 'ADD' ? this.renderFilterChoice() : this.renderFilterType();
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-filter-editor' },
        this.renderChoiceOrFilter()
      );
    }
  }]);

  return FilterEditor;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FilterEditor);

/***/ }),

/***/ "sAia":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Overview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Social; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Details; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Messaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Profile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("QF6P");



var Overview = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  handle: '',
  globalHandle: '',
  quote: '',
  jobTitle: '',
  latitude: '',
  longitude: '',
  location: ''
});

var Social = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  calendarUrl: '',
  calendarCta: '',
  enableCalendarCta: true,
  phoneNumber: '',
  twitterHandle: '',
  linkedInHandle: '',
  instagramHandle: '',
  mediumHandle: '',
  pinterestHandle: '',
  skypeHandle: '',
  soundCloudHandle: '',
  facebookHandle: ''
});

var Details = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  bio: '',
  educationInfo: '',
  likes: '',
  funFact: '',
  blogUrl: '',
  languages: '',
  podcastUrl: ''
});

var Messaging = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  welcomeMessage: '',
  awayMessage: ''
});

var Theme = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  layout: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* Layout */].CARD,
  coverPhotoUrl: ''
});

var Profile = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  handle: '',
  globalHandle: '',
  quote: '',
  jobTitle: '',
  calendarUrl: '',
  calendarCta: '',
  coverPhotoUrl: '',
  enableCalendarCta: true,
  phoneNumber: '',
  twitterHandle: '',
  linkedInHandle: '',
  instagramHandle: '',
  mediumHandle: '',
  pinterestHandle: '',
  skypeHandle: '',
  soundCloudHandle: '',
  facebookHandle: '',
  bio: '',
  educationInfo: '',
  funFact: '',
  blogUrl: '',
  podcastUrl: '',
  languages: '',
  companyName: '',
  companyUrl: '',
  latitude: '',
  likes: '',
  location: '',
  longitude: '',
  welcomeMessage: '',
  awayMessage: '',
  layout: __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* Layout */].CARD
});

/***/ }),

/***/ "sCN1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);


var ConnectButton = function ConnectButton(_ref) {
  var onClick = _ref.onClick,
      isProcessing = _ref.isProcessing,
      disabled = _ref.disabled;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
    {
      type: "primary", onClick: onClick, loading: isProcessing, disabled: disabled },
    "Connect"
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConnectButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "sCqf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sDN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl__ = __webpack_require__("jdNW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_styl__);


function ViewAllAttributesButton(_ref) {
  var onClick = _ref.onClick;

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_0__style_styl__["Button"] + ' flex-center', onClick: onClick },
    React.createElement('img', {
      src: __webpack_require__("PnwF"),
      style: { width: 16, height: 11, marginRight: 7 }
    }),
    React.createElement(
      'span',
      { className: 'dsg-Body' },
      'View all attributes'
    )
  );
}

/* harmony default export */ __webpack_exports__["a"] = (ViewAllAttributesButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "sDd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"conversationAutoClose":"conversationAutoClose---3MhoR"};

/***/ }),

/***/ "sE9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_app_api_BotAPI__ = __webpack_require__("3ujL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__ = __webpack_require__("tTLk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BotActions = function (_Marty$ActionCreators) {
  _inherits(BotActions, _Marty$ActionCreators);

  function BotActions() {
    _classCallCheck(this, BotActions);

    return _possibleConstructorReturn(this, (BotActions.__proto__ || Object.getPrototypeOf(BotActions)).apply(this, arguments));
  }

  _createClass(BotActions, [{
    key: 'fetchBot',
    value: function fetchBot(orgId) {
      var _this2 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].FETCH_BOT_STARTED);
      return __WEBPACK_IMPORTED_MODULE_0_app_api_BotAPI__["b" /* default */].fetchOrCreate(orgId).then(function (bot) {
        return _this2.app.sources.UserAPI.fetchUser(bot.botId).then(function (res) {
          if (res.status === 200) {
            var _res$body = res.body,
                name = _res$body.name,
                _orgId = _res$body.orgId,
                avatarUrl = _res$body.avatarUrl;

            _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].FETCH_BOT_FINISHED, bot.set("name", name).set("avatarUrl", avatarUrl).set("orgId", _orgId));
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
            _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].FETCH_BOT_FAILED);
          }
        });
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].FETCH_BOT_FAILED);
      });
    }
  }, {
    key: 'enableBot',
    value: function enableBot(orgId, enabled) {
      var _this3 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].ENABLE_BOT_STARTED);
      return __WEBPACK_IMPORTED_MODULE_0_app_api_BotAPI__["b" /* default */].enable(orgId, enabled).then(function (bot) {
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].ENABLE_BOT_FINISHED, bot.enabled);
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].ENABLE_BOT_FAILED);
      });
    }
  }, {
    key: 'updateBot',
    value: function updateBot(botId, properties) {
      var _this4 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPDATE_BOT_STARTED);
      return this.app.sources.UserAPI.updateUser(botId, properties).then(function (res) {
        if (res.status === 200) {
          _this4.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPDATE_BOT_FINISHED, properties);
          _this4.app.actions.NotificationActions.pushNotification({ content: "Your bot has been saved!" });
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
          _this4.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPDATE_BOT_FAILED);
        }
      });
    }
  }, {
    key: 'setBotAvatar',
    value: function setBotAvatar(botId, file) {
      var _this5 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPLOAD_BOT_AVATAR_STARTED);
      return this.app.sources.UserAPI.uploadUserAvatar(botId, file).then(function (res) {
        if (res.status === 200) {
          _this5.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPLOAD_BOT_AVATAR_FINISHED, file);
          _this5.app.actions.NotificationActions.pushNotification({ content: "Your bot has been saved!" });
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["c" /* captureResponseException */])(res);
          _this5.dispatch(__WEBPACK_IMPORTED_MODULE_1_constants_BotConstants__["a" /* default */].UPLOAD_BOT_AVATAR_FAILED);
        }
      });
    }
  }]);

  return BotActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (BotActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "sHc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildNodes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nodes__ = __webpack_require__("kn7W");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




var getChildNodes = function getChildNodes(nodes) {
  return nodes.map(function (_ref) {
    var hide = _ref.hide,
        node = _objectWithoutProperties(_ref, ['hide']);

    var Node = node.nodes ? __WEBPACK_IMPORTED_MODULE_1__Nodes__["b" /* ParentNode */] : __WEBPACK_IMPORTED_MODULE_1__Nodes__["a" /* EndNode */];
    if (hide) {
      return null;
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Node, _extends({ key: node.label }, node));
    }
  });
};


/***/ }),

/***/ "sJLy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sJs2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");



/* harmony default export */ __webpack_exports__["a"] = (function () {
  var placeholderShape = [React.createElement('rect', { key: 0, x: '0', y: '0', width: '60', height: '60', rx: '3' }), React.createElement('rect', { key: 1, x: '70', y: '24', width: '101', height: '12', rx: '5' }), React.createElement('rect', { key: 2, x: '70', y: '0', width: '156', height: '12', rx: '5' }), React.createElement('rect', { key: 3, x: '0', y: '164', width: '171', height: '15', rx: '5' }), React.createElement('rect', { key: 4, x: '0', y: '107', width: '171', height: '15', rx: '5' }), React.createElement('rect', { key: 5, x: '70', y: '48', width: '63', height: '12', rx: '5' }), React.createElement('rect', { key: 6, x: '0', y: '90', width: '63', height: '12', rx: '5' }), React.createElement('rect', { key: 7, x: '0', y: '147', width: '63', height: '12', rx: '5' })];

  var options = {
    height: 179,
    width: 226,
    primaryColor: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */],
    secondaryColor: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["c" /* PLACEHOLDER_SECONDARY_COLOR */],
    primaryOpacity: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["b" /* PLACEHOLDER_PRIMARY_OPACITY */],
    secondaryOpacity: __WEBPACK_IMPORTED_MODULE_1_components_conversation_ContactSideBar__["d" /* PLACEHOLDER_SECONDARY_OPACITY */]
  };

  return React.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["ProgressiveLoader"], { options: options, placeholderShape: placeholderShape, numPlaceholders: 1 });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "sMXN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSegments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchSegmentsPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSegmentsFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSegmentsSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oYJn");



var fetchSegments = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_SEGMENTS */]);
var fetchSegmentsPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_SEGMENTS_PENDING */]);
var fetchSegmentsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_SEGMENTS_FAILED */]);
var fetchSegmentsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_SEGMENTS_SUCCESS */]);

/***/ }),

/***/ "sNAy":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#7695A5\" fill-rule=\"evenodd\"><path d=\"M2.8 3.66h1.78v1.77h-1.8zM2.8 7.4h1.78v1.76h-1.8zM2.8 10.94h1.78v1.77h-1.8zM6.36 3.66h1.8v1.77h-1.8zM9.04 9.9h1.8v1.78h-1.8zM9.04 13.02h1.8v1.77h-1.8zM11.98 9.9h1.8v1.78h-1.8z\"></path><path d=\"M1.5 14.3V2.4c0-.5.4-.9.9-.9h6.14c.5 0 .9.4.9.9v2.68h1V2.4c0-1.05-.85-1.9-1.9-1.9H2.4C1.35.5.5 1.35.5 2.4v11.9h1z\" fill-rule=\"nonzero\"></path><path d=\"M7.13 16.8V8.65c0-.5.4-.9.9-.9h6.14c.5 0 .9.4.9.9l-.02 7.7h1v-7.7c0-1.04-.83-1.9-1.88-1.9H8.02c-1.04 0-1.9.86-1.9 1.9v8.17h1z\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),

/***/ "sNIf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return humanizeDelay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);


var MINUTE = 60 * 1000;
var HOUR = 60 * MINUTE;

var humanizeDelay = function humanizeDelay(value) {
  var number = value / (_.isInteger(value / HOUR) ? HOUR : MINUTE);
  var unit = _.isInteger(value / HOUR) ? 'hour' : 'minute';
  return number + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(number, unit);
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "sNOP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_Settings_styl__ = __webpack_require__("cLnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_components_settings_Settings_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_components_settings_Settings_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_Subnav__ = __webpack_require__("Ivb/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__("XmC0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SettingsPageHeader__ = __webpack_require__("bi1w");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var Settings = function (_Component) {
  _inherits(Settings, _Component);

  function Settings(props) {
    _classCallCheck(this, Settings);

    var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));

    _this.componentDidUpdate = function (prevProps) {
      if (_this.props.location.pathname !== prevProps.location.pathname) {
        _this.setState({
          pageTitle: _this.getSettingsPageTitle()
        });
      }
    };

    _this.getSettingsPageTitle = function () {
      var pathname = _this.props.location.pathname;

      var pathObj = __WEBPACK_IMPORTED_MODULE_8__constants__["b" /* PAGE_TITLES */].find(function (element) {
        return element.path === pathname;
      });
      if (pathObj) {
        return pathObj.title;
      }
      return false;
    };

    _this.createSubnav = function () {
      var _this$props = _this.props,
          hasWorkspaces = _this$props.hasWorkspaces,
          settingsAppConfig = _this$props.settingsAppConfig;
      var _this$props$hasDeskto = _this.props.hasDesktopApp,
          hasDesktopApp = _this$props$hasDeskto === undefined ? true : _this$props$hasDeskto;
      var hasAccount = settingsAppConfig.hasAccount,
          hasAdminSettings = settingsAppConfig.hasAdminSettings,
          hasProfile = settingsAppConfig.hasProfile,
          hasDriftAssistant = settingsAppConfig.hasDriftAssistant,
          hasNotifications = settingsAppConfig.hasNotifications,
          hasEmail = settingsAppConfig.hasEmail,
          hasMeetingsInSubnav = settingsAppConfig.hasMeetingsInSubnav,
          hasBilling = settingsAppConfig.hasBilling,
          hasManageTeammates = settingsAppConfig.hasManageTeammates,
          hasTeams = settingsAppConfig.hasTeams,
          hasOrgMeetings = settingsAppConfig.hasOrgMeetings,
          hasDataPrivacy = settingsAppConfig.hasDataPrivacy,
          hasSecurity = settingsAppConfig.hasSecurity,
          hasWidget = settingsAppConfig.hasWidget,
          hasConvoRouting = settingsAppConfig.hasConvoRouting,
          hasBot = settingsAppConfig.hasBot,
          hasConversations = settingsAppConfig.hasConversations,
          hasCompany = settingsAppConfig.hasCompany,
          hasIntegrations = settingsAppConfig.hasIntegrations,
          hasHelpDocs = settingsAppConfig.hasHelpDocs;


      var isPremium = __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates('premium_drift');

      var mySettingsNavigationItems = [{
        label: 'MY SETTINGS',
        expanded: true,
        nodes: [{
          label: 'Account',
          path: '/settings2/account',
          external: true,
          hide: !hasAccount
        }, {
          label: 'Notifications',
          path: '/settings2/notifications',
          external: true,
          hide: !hasNotifications || hasDesktopApp,
          exact: false
        }, {
          label: 'Calendar',
          path: '/meetings/mine',
          external: true,
          hide: !hasMeetingsInSubnav
        }, {
          label: 'Drift Profile',
          path: '/settings2/profile',
          external: true,
          hide: !hasProfile
        }, {
          label: 'Email',
          path: '/settings2/email',
          external: true,
          hide: !hasEmail
        }, {
          label: 'Drift Assistant',
          path: '/settings2/assistant',
          external: true,
          hide: !hasDriftAssistant
        }]
      }];

      var orgSettingsNavigationItems = [{
        label: 'ORGANIZATION SETTINGS',
        expanded: true,
        nodes: [{
          label: 'Plan and billing',
          path: '/settings2/billing',
          external: true,
          hide: !hasBilling
        }, {
          label: 'Manage teammates',
          path: '/settings2/team',
          external: true,
          hide: !hasManageTeammates
        }, {
          label: 'Teams',
          path: '/settings2/teams',
          external: true,
          hide: !hasTeams
        }, {
          label: 'Meetings',
          path: '/meetings/organization',
          external: true,
          hide: !hasOrgMeetings
        }, {
          label: 'Company details',
          path: '/settings2/company',
          external: true,
          hide: !hasCompany
        }, {
          label: 'Data privacy',
          path: '/settings2/consent',
          external: true,
          hide: !hasDataPrivacy
        }, {
          label: 'Security',
          path: '/settings2/security',
          external: true,
          hide: !hasSecurity
        }, {
          label: 'Workspaces',
          path: '/settings2/workspaces',
          external: true,
          exact: false,
          hide: !hasWorkspaces
        }]
      }];

      var appSettingsNavigationItems = [{
        label: 'APP SETTINGS',
        expanded: true,
        nodes: [{
          label: 'Drift widget',
          path: '/settings2/widget',
          external: true,
          hide: !hasWidget
        }, {
          label: 'Conversations',
          path: '/settings2/conversations',
          external: true,
          hide: !hasConversations
        }, {
          label: 'Conversation routing',
          path: '/settings2/rules',
          external: true,
          hide: !hasConvoRouting
        }, {
          label: 'Bot',
          path: '/settings2/bot',
          external: true,
          icon: !isPremium ? 'lock' : null,
          disabled: !isPremium,
          hide: !hasBot
        }]
      }];

      var adminNavigationItems = [].concat(orgSettingsNavigationItems, appSettingsNavigationItems, [{
        label: 'Integrations',
        path: '/settings2/integrations',
        external: true,
        hide: !hasIntegrations
      }, {
        label: 'Help',
        path: '/settings2/help',
        external: true
      }]);

      var subnavItems = [].concat(mySettingsNavigationItems, _toConsumableArray(hasAdminSettings ? adminNavigationItems : [{
        label: 'Help Docs',
        path: __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* HELP_CENTER_HELPDOC_URL */],
        target: '_blank',
        rel: 'noopener noreferrer'
      }, {
        label: 'Integrations',
        path: '/settings2/integrations',
        external: true
      }]));

      var hasMySettings = mySettingsNavigationItems[0].nodes.some(function (node) {
        return !node.hide;
      });
      var hasOrgSettings = orgSettingsNavigationItems[0].nodes.some(function (node) {
        return !node.hide;
      });
      var hasAppSettings = appSettingsNavigationItems[0].nodes.some(function (node) {
        return !node.hide;
      });

      var rbacUserSubnavItems = [].concat(_toConsumableArray(hasMySettings ? mySettingsNavigationItems : []), _toConsumableArray(hasOrgSettings ? orgSettingsNavigationItems : []), _toConsumableArray(hasAppSettings ? appSettingsNavigationItems : []), [{
        label: 'Integrations',
        path: '/settings2/integrations',
        exact: false,
        hide: !hasIntegrations
      }, {
        label: 'Help Docs',
        path: __WEBPACK_IMPORTED_MODULE_8__constants__["a" /* HELP_CENTER_HELPDOC_URL */],
        target: '_blank',
        rel: 'noopener noreferrer',
        hide: !hasHelpDocs
      }]);

      return React.createElement(__WEBPACK_IMPORTED_MODULE_7__shared_Subnav__["a" /* default */], {
        title: 'Settings',
        open: true,
        nodes: __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].isRbacUser() ? rbacUserSubnavItems : subnavItems
      });
    };

    _this.state = {
      pageTitle: _this.getSettingsPageTitle()
    };
    return _this;
  }

  _createClass(Settings, [{
    key: 'render',
    value: function render() {
      var pageTitle = this.state.pageTitle;


      return React.createElement(
        'div',
        { className: 'settings-section' },
        React.createElement(
          'div',
          { className: 'settings-rest can-hide-nav' },
          this.createSubnav(),
          React.createElement(
            'div',
            { className: 'settings-page' },
            pageTitle && React.createElement(__WEBPACK_IMPORTED_MODULE_9__SettingsPageHeader__["a" /* default */], { title: pageTitle }),
            React.createElement(
              'div',
              { className: 'settings-page-content' },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return Settings;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    settingsAppConfig: Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_user_selectors__["settingsAppConfig"])(state),
    orgId: __WEBPACK_IMPORTED_MODULE_5__app_modules_org_selectors__["orgId"](state),
    hasWorkspaces: state.workspaces && state.workspaces.hasWorkspaces,
    hasDesktopApp: __WEBPACK_IMPORTED_MODULE_6__app_modules_user_properties_selectors__["d" /* isDesktopUser */](state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Settings));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "sNnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__("0l4V");










var mapStateToProps = function mapStateToProps(state) {
  return {
    answer: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["J" /* getCurrentAnswer */](state),
    skipToOptions: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_96" /* skipToOptions */](state),
    currentSkipToOption: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["l" /* currentSkipToOption */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setSkipTo: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_209" /* setSkipTo */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onSkipToChange: function onSkipToChange(props) {
    return function (value) {
      var setSkipTo = props.actions.setSkipTo,
          answerId = props.answer.id;

      var _ref = value ? value.value : {},
          _ref$isGoal = _ref.isGoal,
          isGoal = _ref$isGoal === undefined ? false : _ref$isGoal,
          _ref$id = _ref.id,
          skipToId = _ref$id === undefined ? null : _ref$id;

      setSkipTo({ answerId: answerId, isGoal: isGoal, skipToId: skipToId });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),

/***/ "sQnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_customer_EndUserInfo__ = __webpack_require__("wT/R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__ = __webpack_require__("st9j");






var EndUserRoutes = function EndUserRoutes(store) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */],
    { path: 'users', onEnter: function onEnter() {
        store.dispatch(__WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_119" /* searchPlaybooks */]([__WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED]));
      } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["e" /* Route */], { path: ':endUserId', component: __WEBPACK_IMPORTED_MODULE_2_components_customer_EndUserInfo__["a" /* default */] })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EndUserRoutes);

/***/ }),

/***/ "sTFW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CompanyAvatar__ = __webpack_require__("S2pE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("288j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_twitter_logo_svg__ = __webpack_require__("sWJN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_twitter_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_twitter_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_icons_linkedin_svg__ = __webpack_require__("Ocgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_icons_linkedin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_icons_linkedin_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var TwitterHandle = function TwitterHandle(_ref) {
  var twitterHandle = _ref.twitterHandle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: 'https://twitter.com/' + twitterHandle, target: '_blank' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'social-icon', src: __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeTags_true_images_icons_twitter_logo_svg___default.a })
  );
};

var LinkedInHandle = function LinkedInHandle(_ref2) {
  var linkedInHandle = _ref2.linkedInHandle;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'a',
    { href: 'https://www.linkedin.com/' + linkedInHandle, target: '_blank' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_svg_inline_react___default.a, { className: 'social-icon social-icon-linkedin', src: __WEBPACK_IMPORTED_MODULE_8__svg_inline_removeTags_true_images_icons_linkedin_svg___default.a })
  );
};

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'renderSocialIcons',
    value: function renderSocialIcons() {
      var _props = this.props,
          twitterHandle = _props.companyLinkedInHandle,
          linkedInHandle = _props.companyTwitterHandle;


      if (!twitterHandle && !linkedInHandle) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'social-icons' },
        twitterHandle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwitterHandle, { twitterHandle: twitterHandle }),
        linkedInHandle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkedInHandle, { linkedInHandle: linkedInHandle })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          conversationId = _props2.conversationId,
          companyName = _props2.companyName,
          companyDomain = _props2.companyDomain,
          companyLogo = _props2.companyLogo,
          companyUrl = _props2.companyUrl;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_6__style_styl__["header"], className, 'flex-row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__CompanyAvatar__["a" /* default */], { companyName: companyName, logoUrl: companyLogo, className: 'companyAvatar' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          companyName && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'name' },
            companyName
          ),
          companyDomain && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'domain' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: companyUrl || 'http://www.' + companyDomain, target: '_blank' },
              companyDomain
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-row action-links' },
            this.renderSocialIcons()
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "sU8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_check_svg__ = __webpack_require__("tHh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_redx_svg__ = __webpack_require__("R/TV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_redx_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_redx_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PlaybookModal__ = __webpack_require__("DeWp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SegmentSelect__ = __webpack_require__("0y2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EmailPlaybookSelect__ = __webpack_require__("5Knv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_ClearbitRevealPreview__ = __webpack_require__("FgcT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl__ = __webpack_require__("VJrH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style_styl__);
var _this = this;





















var Category = function Category(_ref) {
  var onClick = _ref.onClick,
      category = _ref.category,
      selected = _ref.selected;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('playbook-condition-modal-category', { selected: selected }), onClick: onClick },
    __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["Q" /* ConditionCategoryToDisplay */][category]
  );
};

var Upgrade = function Upgrade() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_ClearbitRevealPreview__["b" /* ClearbitRevealTargetingPreview */], null);
};

var mapToOptions = function mapToOptions(values) {
  return !!values ? values.map(function (value) {
    return { label: value, value: value };
  }) : [];
};

var ConditionModal = function ConditionModal(_ref2) {
  var _ref2$condition = _ref2.condition,
      field = _ref2$condition.field,
      value = _ref2$condition.value,
      operator = _ref2$condition.operator,
      onFieldChange = _ref2.onFieldChange,
      onValueChange = _ref2.onValueChange,
      onOperatorChange = _ref2.onOperatorChange,
      onCloseClick = _ref2.onCloseClick,
      onCategoryClick = _ref2.onCategoryClick,
      selectedCategory = _ref2.selectedCategory,
      hasSegmentSelect = _ref2.hasSegmentSelect,
      onSegmentNext = _ref2.onSegmentNext,
      onSegmentChange = _ref2.onSegmentChange,
      hasMarketingSequences = _ref2.hasMarketingSequences,
      onTestUrlChange = _ref2.onTestUrlChange,
      testUrl = _ref2.testUrl,
      testUrlIsValid = _ref2.testUrlIsValid,
      externalData = _ref2.externalData,
      selectedCategoryOptions = _ref2.selectedCategoryOptions,
      showEnrichmentUpgrade = _ref2.showEnrichmentUpgrade;

  var selectedConditionType = selectedCategory === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].EMAIL_PLAYBOOK ? __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["S" /* ConditionTypes */].get('email_playbook') : __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["S" /* ConditionTypes */].get(field);

  _this.renderExtraContent = function () {
    if (selectedConditionType.category === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].URL) {

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'url-help-section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'How does Drift define "',
            selectedConditionType.displayName,
            '"?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            selectedConditionType.description
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Example (from your input)'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'playbook-condition-helptext' },
            selectedConditionType.showPreview(value)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'Does your URL match?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'playbook-condition-test-url-instructions' },
          'Paste a URL here to see if it will match the condition above.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-condition-test-url' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Input"], {
            placeholder: 'https://www.google.com/my-url',
            value: testUrl,
            className: 'playbook-condition-test-url-input',
            onChange: onTestUrlChange
          }),
          !!testUrl && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_svg_inline_react___default.a, { src: testUrlIsValid ? __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_check_svg___default.a : __WEBPACK_IMPORTED_MODULE_7__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_svg_redx_svg___default.a })
        )
      );
    } else if (selectedConditionType.category === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].ENRICHMENT && showEnrichmentUpgrade) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'url-help-section' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Upgrade, null)
      );
    }
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__PlaybookModal__["a" /* default */],
    {
      onCloseClick: onCloseClick,
      title: 'Targeting',
      contentClassName: 'playbook-condition-modal drift-form',
      headerClassName: 'playbook-condition-modal-header',
      description: 'Edit Condition'
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'nav',
      { className: 'playbook-condition-modal-nav' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Pick Condition Type:'
      ),
      __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["T" /* ConditionTypesByCategory */].filter(function (conditions, category) {
        return category !== __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].CLEARBIT || ACCESS.hasGates('premium_enterprise');
      }).filter(function (conditions, category) {
        return category !== __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].SEGMENT || hasSegmentSelect;
      }).filter(function (conditions, category) {
        return category !== __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].EMAIL_PLAYBOOK || hasMarketingSequences;
      }).map(function (conditions, category) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Category, {
          key: category,
          category: category,
          onClick: onCategoryClick(category),
          selected: category === selectedConditionType.category
        });
      }).toArray()
    ),
    selectedConditionType.category !== __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].SEGMENT && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-modal-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'strong',
        null,
        'Edit Condition:'
      ),
      selectedConditionType.category === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].EMAIL_PLAYBOOK && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-condition-modal-email-select-description' },
          'The visitor came to my site from a link in the email playbook:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__EmailPlaybookSelect__["a" /* default */], null)
      ),
      selectedConditionType.category !== __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].EMAIL_PLAYBOOK && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'playbook-condition-modal-inputs' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
            className: 'playbook-condition-modal-input',
            clearable: false,
            options: selectedCategoryOptions,
            value: {
              label: selectedConditionType.displayName,
              value: field
            },
            onChange: onFieldChange
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], {
            className: 'playbook-condition-modal-input targeting-condition',
            clearable: false,
            options: selectedConditionType.operators.map(function (operator) {
              return {
                value: operator,
                label: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_138" /* OperatorToDisplay */][operator]
              };
            }),
            value: { value: operator, label: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["_138" /* OperatorToDisplay */][operator] },
            onChange: onOperatorChange
          }),
          !!selectedConditionType.externalOptionsProp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(selectedConditionType.Component, {
            className: 'playbook-condition-modal-input',
            placeholder: selectedConditionType.placeholder,
            value: value,
            onChange: onValueChange,
            options: mapToOptions(externalData[selectedConditionType.externalOptionsProp])
          }),
          !selectedConditionType.externalOptionsProp && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(selectedConditionType.Component, {
            className: 'playbook-condition-modal-input',
            placeholder: selectedConditionType.placeholder,
            value: value,
            onChange: onValueChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'targeting-condition-extra-content' },
          _this.renderExtraContent()
        )
      )
    ),
    selectedConditionType.category === __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["P" /* ConditionCategory */].SEGMENT && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'playbook-condition-modal-content segment-select-modal-content' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SegmentSelect__["a" /* default */], {
        onNext: onSegmentNext,
        value: value.toJS(),
        onChange: onSegmentChange,
        extraOptions: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(Object.keys(__WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["v" /* AudienceIcons */]).map(function (key) {
          return { id: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["w" /* AudienceType */][key], name: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_constants__["u" /* AudienceDisplay */][key] };
        })),
        showCancel: false
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConditionModal);

/***/ }),

/***/ "sWJN":
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 2000 1625.36\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"currentColor\" fillRule=\"evenodd\" d=\"m 1999.9999,192.4 c -73.58,32.64 -152.67,54.69 -235.66,64.61 84.7,-50.78 149.77,-131.19 180.41,-227.01 -79.29,47.03 -167.1,81.17 -260.57,99.57 C 1609.3399,49.82 1502.6999,0 1384.6799,0 c -226.6,0 -410.328,183.71 -410.328,410.31 0,32.16 3.628,63.48 10.625,93.51 -341.016,-17.11 -643.368,-180.47 -845.739,-428.72 -35.324,60.6 -55.5583,131.09 -55.5583,206.29 0,142.36 72.4373,267.95 182.5433,341.53 -67.262,-2.13 -130.535,-20.59 -185.8519,-51.32 -0.039,1.71 -0.039,3.42 -0.039,5.16 0,198.803 141.441,364.635 329.145,402.342 -34.426,9.375 -70.676,14.395 -108.098,14.395 -26.441,0 -52.145,-2.578 -77.203,-7.364 52.215,163.008 203.75,281.649 383.304,284.946 -140.429,110.062 -317.351,175.66 -509.5972,175.66 -33.1211,0 -65.7851,-1.949 -97.8828,-5.738 181.586,116.4176 397.27,184.359 628.988,184.359 754.732,0 1167.462,-625.238 1167.462,-1167.47 0,-17.79 -0.41,-35.48 -1.2,-53.08 80.1799,-57.86 149.7399,-130.12 204.7499,-212.41\"></path></svg>"

/***/ }),

/***/ "sWN9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldRedirectToInbox;
function shouldRedirectToInbox(pathname) {
  var strippedSlashes = pathname.split('/').join('');
  var strippedQueryParams = strippedSlashes.split('?')[0];

  return strippedQueryParams === 'inboxes';
}

/***/ }),

/***/ "sWvj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sXVg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sYP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__("kuxt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_add__ = __webpack_require__("32st");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda_src_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_subtract__ = __webpack_require__("9h5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_subtract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda_src_subtract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_curry__ = __webpack_require__("ZHZ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda_src_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda_src___ = __webpack_require__("xI+h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda_src____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ramda_src___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__ = __webpack_require__("U98Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models__ = __webpack_require__("tp7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__("UZmf");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _statusEnumToStatus, _handleActions, _handleActions2, _handleActions4, _handleActions5, _handleActions8;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var sub1 = __WEBPACK_IMPORTED_MODULE_4_ramda_src_subtract___default()(__WEBPACK_IMPORTED_MODULE_6_ramda_src____default.a, 1);
var add1 = __WEBPACK_IMPORTED_MODULE_3_ramda_src_add___default()(1);

var isOpenOrPending = function isOpenOrPending(status) {
  return status === __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key || status === __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key;
};

var updateParticipantCounts = __WEBPACK_IMPORTED_MODULE_5_ramda_src_curry___default()(function (payload, counts) {
  if (!counts) return;
  var isAdd = payload.isAdd,
      conversationStatus = payload.conversationStatus,
      currentParticipants = payload.currentParticipants,
      participants = payload.participants,
      currentUserId = payload.currentUserId;

  if (isOpenOrPending(conversationStatus)) {
    if (participants.includes(currentUserId)) {
      counts = counts.update('participating', isAdd ? add1 : sub1);
    }
    if (!currentParticipants.length && !isAdd) {
      counts = counts.update('noParticipants', add1);
    } else if (isAdd && Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(currentParticipants).union(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(participants)).subtract(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(participants)).isEmpty()) {
      counts = counts.update('noParticipants', sub1);
    }
  }
  return counts;
});

var statusEnumToStatus = (_statusEnumToStatus = {}, _defineProperty(_statusEnumToStatus, __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].OPEN.key, 'open'), _defineProperty(_statusEnumToStatus, __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].PENDING.key, 'pending'), _defineProperty(_statusEnumToStatus, __WEBPACK_IMPORTED_MODULE_7_constants_ConversationStatusConstants__["b" /* ConversationStatusEnum */].CLOSED.key, 'closed'), _statusEnumToStatus);

var updateParticipantCounts2 = __WEBPACK_IMPORTED_MODULE_5_ramda_src_curry___default()(function (payload, counts) {
  if (!counts) return;
  var isAdd = payload.isAdd,
      conversationStatus = payload.conversationStatus,
      currentParticipants = payload.currentParticipants,
      participants = payload.participants,
      currentUserId = payload.currentUserId;


  var previousPrimaryKey = void 0;
  var currentPrimaryKey = void 0;
  var secondaryKey = statusEnumToStatus[conversationStatus];

  var previousParticipants = isAdd ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(currentParticipants).subtract(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(participants)) : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(currentParticipants).union(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(participants));

  if (previousParticipants.isEmpty()) {
    previousPrimaryKey = 'noParticipants';
  } else if (previousParticipants.includes(currentUserId)) {
    previousPrimaryKey = 'participating';
  } else {
    previousPrimaryKey = 'all';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(currentParticipants).isEmpty()) {
    currentPrimaryKey = 'noParticipants';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(currentParticipants).includes(currentUserId)) {
    currentPrimaryKey = 'participating';
  } else {
    currentPrimaryKey = 'all';
  }

  if (previousPrimaryKey === currentPrimaryKey) {
    // No change--no counts to update (assumes conversation status has not changed)
    return counts;
  }

  if (previousPrimaryKey !== 'all') {
    counts = counts.updateIn([previousPrimaryKey, secondaryKey], sub1);
  }

  if (currentPrimaryKey !== 'all') {
    counts = counts.updateIn([currentPrimaryKey, secondaryKey], add1);
  }

  return counts;
});

var countsById = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_10__actions__["R" /* receiveCounts */], function (state, action) {
  return state.set(action.payload.id, action.payload.counts);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_10__actions__["h" /* changeParticipants */], function (state, action) {
  var _action$payload = action.payload,
      inboxId = _action$payload.inboxId,
      payload = _objectWithoutProperties(_action$payload, ['inboxId']);

  return state.update(inboxId, updateParticipantCounts(payload));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_10__actions__["i" /* changeStatus */], function (state, action) {
  var _action$payload2 = action.payload,
      id = _action$payload2.id,
      currentParticipants = _action$payload2.currentParticipants,
      currentUserId = _action$payload2.currentUserId,
      previousStatus = _action$payload2.previousStatus,
      status = _action$payload2.status;

  // these should never be counted (or uncounted)

  if (status === 'BULK_SENT' && !previousStatus) {
    return state;
  }

  var newState = state.updateIn([id, status.toLowerCase()], add1);

  // magic. trust us - "trun and tommy"
  if (previousStatus && previousStatus !== 'BULK_SENT') {
    newState = newState.updateIn([id, previousStatus.toLowerCase()], sub1);
  } else {
    newState = newState.updateIn([id, 'all'], add1);
  }

  var previousOpenOrPending = isOpenOrPending(previousStatus);
  var currentOpenOrPending = isOpenOrPending(status);
  if (previousStatus && previousStatus !== 'BULK_SENT' && previousOpenOrPending !== currentOpenOrPending) {
    var fn = currentOpenOrPending ? add1 : sub1;
    if (currentParticipants.includes(currentUserId)) {
      newState = newState.updateIn([id, 'participating'], fn);
    }
    if (!currentParticipants.length) {
      newState = newState.updateIn([id, 'noParticipants'], fn);
    }
  }

  return newState;
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_10__actions__["d" /* bulkChangeStatus */], function (state, action) {
  var _action$payload3 = action.payload,
      id = _action$payload3.id,
      currentUserId = _action$payload3.currentUserId,
      conversationDiffs = _action$payload3.conversationDiffs;


  return state.withMutations(function (_state) {
    conversationDiffs.forEach(function (_ref) {
      var currentParticipants = _ref.currentParticipants,
          previousStatus = _ref.previousStatus,
          status = _ref.status;

      // these should never be counted (or uncounted)
      if (status === 'BULK_SENT' && !previousStatus) {
        return;
      }

      _state.updateIn([id, status.toLowerCase()], add1);

      // magic. trust us - "trun and tommy"
      if (previousStatus && previousStatus !== 'BULK_SENT') {
        _state.updateIn([id, previousStatus.toLowerCase()], sub1);
      } else {
        _state.updateIn([id, 'all'], add1);
      }

      var previousOpenOrPending = isOpenOrPending(previousStatus);
      var currentOpenOrPending = isOpenOrPending(status);
      if (previousStatus && previousStatus !== 'BULK_SENT' && previousOpenOrPending !== currentOpenOrPending) {
        var fn = currentOpenOrPending ? add1 : sub1;
        if (currentParticipants.includes(currentUserId)) {
          _state.updateIn([id, 'participating'], fn);
        }
        if (!currentParticipants.length) {
          _state.updateIn([id, 'noParticipants'], fn);
        }
      }
    });
  });
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var countsById2 = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions2 = {}, _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_10__actions__["S" /* receiveCounts2 */], function (state, _ref2) {
  var payload = _ref2.payload;
  var id = payload.id,
      counts = payload.counts;


  var countsByPrimaryKey = counts.mapEntries(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        primaryKey = _ref4[0],
        count = _ref4[1];

    return [primaryKey, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
      open: count,
      pending: 0,
      closed: 0
    })];
  });

  return state.set(id, countsByPrimaryKey);
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_10__actions__["h" /* changeParticipants */], function (state, action) {
  var _action$payload4 = action.payload,
      inboxId = _action$payload4.inboxId,
      payload = _objectWithoutProperties(_action$payload4, ['inboxId']);

  return state.update(inboxId, updateParticipantCounts2(payload));
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_10__actions__["i" /* changeStatus */], function (state, action) {
  var _action$payload5 = action.payload,
      id = _action$payload5.id,
      currentParticipants = _action$payload5.currentParticipants,
      currentUserId = _action$payload5.currentUserId,
      previousStatus = _action$payload5.previousStatus,
      status = _action$payload5.status;

  // BULK_SENT conversations should never be counted (or uncounted; see logic/comments below)

  if (status === 'BULK_SENT' && !previousStatus) {
    return state;
  }

  var newState = state;

  var subtractSecondaryKey = statusEnumToStatus[previousStatus];
  var addSecondaryKey = statusEnumToStatus[status];

  var addPrimaryKey = void 0;
  var subtractPrimaryKey = void 0;

  if (currentParticipants.includes(currentUserId)) {
    addPrimaryKey = 'participating';
  }

  if (!currentParticipants.length) {
    addPrimaryKey = 'noParticipants';
  }

  subtractPrimaryKey = addPrimaryKey;

  if (addSecondaryKey) {
    if (addPrimaryKey) {
      newState = newState.updateIn([id, addPrimaryKey, addSecondaryKey], add1);
    }

    newState = newState.updateIn([id, 'all', addSecondaryKey], add1);
  }

  if (subtractSecondaryKey) {
    if (subtractPrimaryKey) {
      newState = newState.updateIn([id, subtractPrimaryKey, subtractSecondaryKey], sub1);
    }

    // There is nothing to subtract for conversations that changed status from
    // BULK_SENT since they were previously not counted (see logic/comments above).
    if (previousStatus && previousStatus !== 'BULK_SENT') {
      newState = newState.updateIn([id, 'all', subtractSecondaryKey], sub1);
    }
  }

  return newState;
}), _defineProperty(_handleActions2, __WEBPACK_IMPORTED_MODULE_10__actions__["d" /* bulkChangeStatus */], function (state, action) {
  var _action$payload6 = action.payload,
      id = _action$payload6.id,
      currentUserId = _action$payload6.currentUserId,
      conversationDiffs = _action$payload6.conversationDiffs;


  return state.withMutations(function (_state) {
    conversationDiffs.forEach(function (_ref5) {
      var currentParticipants = _ref5.currentParticipants,
          previousStatus = _ref5.previousStatus,
          status = _ref5.status;

      // BULK_SENT conversations should never be counted (or uncounted; see logic/comments below)
      if (status === 'BULK_SENT' && !previousStatus) {
        return;
      }

      var subtractSecondaryKey = statusEnumToStatus[previousStatus];
      var addSecondaryKey = statusEnumToStatus[status];

      var addPrimaryKey = void 0;
      var subtractPrimaryKey = void 0;

      if (currentParticipants.includes(currentUserId)) {
        addPrimaryKey = 'participating';
      }

      if (!currentParticipants.length) {
        addPrimaryKey = 'noParticipants';
      }

      subtractPrimaryKey = addPrimaryKey;

      if (addSecondaryKey) {
        if (addPrimaryKey) {
          _state.updateIn([id, addPrimaryKey, addSecondaryKey], add1);
        }

        _state.updateIn([id, 'all', addSecondaryKey], add1);
      }

      if (subtractSecondaryKey) {
        if (subtractPrimaryKey) {
          _state.updateIn([id, subtractPrimaryKey, subtractSecondaryKey], sub1);
        }

        // There is nothing to subtract for conversations that changed status from
        // BULK_SENT since they were previously not counted (see logic/comments above).
        if (previousStatus && previousStatus !== 'BULK_SENT') {
          _state.updateIn([id, 'all', subtractSecondaryKey], sub1);
        }
      }
    });
  });
}), _handleActions2), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var countsStatusById = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["t" /* fetchCounts */], __WEBPACK_IMPORTED_MODULE_10__actions__["w" /* fetchCountsPending */], __WEBPACK_IMPORTED_MODULE_10__actions__["u" /* fetchCountsFailed */], __WEBPACK_IMPORTED_MODULE_10__actions__["R" /* receiveCounts */], __WEBPACK_IMPORTED_MODULE_10__actions__["S" /* receiveCounts2 */]), function (state, action) {
  return state.set(action.payload.id, action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var byDomain = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions4 = {}, _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_10__actions__["s" /* createWhitelabelSuccess */], function (state, action) {
  return state.setIn([action.payload.get('domain'), 'data'], action.payload).setIn([action.payload.get('domain'), 'data', 'fetchStatus'], __WEBPACK_IMPORTED_MODULE_10__actions__["L" /* fetchWhitelabelSuccess */].toString());
}), _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["H" /* fetchWhitelabel */], __WEBPACK_IMPORTED_MODULE_10__actions__["K" /* fetchWhitelabelPending */], __WEBPACK_IMPORTED_MODULE_10__actions__["I" /* fetchWhitelabelCancelled */], __WEBPACK_IMPORTED_MODULE_10__actions__["J" /* fetchWhitelabelFailed */], __WEBPACK_IMPORTED_MODULE_10__actions__["L" /* fetchWhitelabelSuccess */]), function (state, action) {
  var domain = action.payload.domain;

  if (domain === undefined) return state;
  return state.updateIn([domain, 'data'], Object(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* Whitelabel */])({ domain: domain }), function (whitelabel) {
    return whitelabel.set('fetchStatus', action.type);
  });
}), _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_10__actions__["L" /* fetchWhitelabelSuccess */], function (state, action) {
  return state.setIn([action.payload.get('domain'), 'data'], action.payload.set('fetchStatus', action.type));
}), _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["X" /* verifyWhitelabelFailed */], __WEBPACK_IMPORTED_MODULE_10__actions__["Z" /* verifyWhitelabelSuccess */]), function (state, action) {
  var _action$payload7 = action.payload,
      domain = _action$payload7.domain,
      whitelabel = _action$payload7.whitelabel;

  if (domain === undefined) return state;
  return state.setIn([domain, 'data'], whitelabel.set('verifyStatus', action.type));
}), _defineProperty(_handleActions4, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["Y" /* verifyWhitelabelPending */], __WEBPACK_IMPORTED_MODULE_10__actions__["W" /* verifyWhitelabelCancelled */]), function (state, action) {
  var domain = action.payload.domain;

  if (domain === undefined) return state;
  return state.updateIn([domain, 'data'], Object(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* Whitelabel */])({ domain: domain }), function (whitelabel) {
    return whitelabel.set('verifyStatus', action.type);
  });
}), _defineProperty(_handleActions4, __WEBPACK_IMPORTED_MODULE_10__actions__["J" /* fetchWhitelabelFailed */], function (state, action) {
  var _action$payload8 = action.payload,
      domain = _action$payload8.domain,
      missing = _action$payload8.missing;

  if (domain === undefined) return state;
  return state.updateIn([domain, 'data'], Object(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* Whitelabel */])({ domain: domain }), function (whitelabel) {
    return whitelabel.set('missing', missing);
  });
}), _handleActions4), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var whitelabelCreatePending = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions5 = {}, _defineProperty(_handleActions5, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["o" /* createWhitelabel */], __WEBPACK_IMPORTED_MODULE_10__actions__["r" /* createWhitelabelPending */]), function () {
  return true;
}), _defineProperty(_handleActions5, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["q" /* createWhitelabelFailed */], __WEBPACK_IMPORTED_MODULE_10__actions__["p" /* createWhitelabelCancelled */], __WEBPACK_IMPORTED_MODULE_10__actions__["s" /* createWhitelabelSuccess */]), function () {
  return false;
}), _handleActions5), null);

var currentInboxId = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__actions__["M" /* inboxChanged */], function (state, action) {
  return action.payload.inboxId;
}), null);

var sendingDomains = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["F" /* fetchSendingDomains */], __WEBPACK_IMPORTED_MODULE_10__actions__["G" /* fetchSendingDomainsPending */]), function (state, action) {
  return state.setIn(['status', 'fetch'], action.type);
}), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var byId = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions8 = {}, _defineProperty(_handleActions8, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["T" /* receiveInbox */], __WEBPACK_IMPORTED_MODULE_10__actions__["Q" /* patchInboxSuccess */], __WEBPACK_IMPORTED_MODULE_10__actions__["n" /* createInboxSuccess */]), function (state, action) {
  var inbox = action.payload;
  return state.set(inbox.id, inbox);
}), _defineProperty(_handleActions8, __WEBPACK_IMPORTED_MODULE_10__actions__["U" /* receiveInboxList */], function (state, action) {
  return Object(__WEBPACK_IMPORTED_MODULE_9_utils_immutable__["a" /* keyBy */])(action.payload);
}), _handleActions8), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

var status = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_10__actions__["A" /* fetchInboxList */], __WEBPACK_IMPORTED_MODULE_10__actions__["D" /* fetchInboxListPending */], __WEBPACK_IMPORTED_MODULE_10__actions__["B" /* fetchInboxListCancelled */], __WEBPACK_IMPORTED_MODULE_10__actions__["C" /* fetchInboxListFailed */], __WEBPACK_IMPORTED_MODULE_10__actions__["U" /* receiveInboxList */]), function (state, action) {
  return action.type;
}), null);

var createdInboxId = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_10__actions__["n" /* createInboxSuccess */], function (state, action) {
  var inbox = action.payload;
  return inbox.id;
}), false);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  countsById: countsById,
  countsById2: countsById2,
  countsStatusById: countsStatusById,
  byDomain: byDomain,
  whitelabelCreatePending: whitelabelCreatePending,
  currentInboxId: currentInboxId,
  sendingDomains: sendingDomains,
  byId: byId,
  status: status,
  createdInboxId: createdInboxId
}));

/***/ }),

/***/ "sYT3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Title":"Title---BnwPL","Section":"Section---MeH1p","LabeledInput":"LabeledInput---2Md43","Subsection":"Subsection---8t0fl","Subsection__Title":"Subsection__Title---24NGq","Subsection__Body":"Subsection__Body---3BZoW"};

/***/ }),

/***/ "sYZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parsePresenceUsers */
/* unused harmony export parsePresenceUser */
/* unused harmony export parseMeta */
/* harmony export (immutable) */ __webpack_exports__["b"] = parsePresenceVisitor;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresenceState; });
/* unused harmony export PresenceSession */
/* unused harmony export PresenceBrowser */
/* unused harmony export PresenceMetaPage */
/* unused harmony export PresenceMetaGeo */
/* unused harmony export PresenceCompany */
/* unused harmony export PresenceVisitor */
/* unused harmony export PresenceMeta */
/* unused harmony export PresenceUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("a2hK");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }




function parsePresenceUsers(data) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(data).map(parsePresenceUser);
}

function parsePresenceUser(data) {
  var meta = data.meta,
      metasByRef = data.metasByRef,
      rest = _objectWithoutProperties(data, ['meta', 'metasByRef']);

  return PresenceUser(_extends({
    meta: !!meta && parseMeta(meta),
    metasByRef: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(metasByRef).map(parseMeta)
  }, rest));
}

function parseMeta(data) {
  var page = data.page,
      geo = data.geo,
      reveal = data.reveal,
      rest = _objectWithoutProperties(data, ['page', 'geo', 'reveal']);

  return PresenceMeta(_extends({
    page: PresenceMetaPage(page),
    geo: PresenceMetaGeo(geo),
    companyInfo: _extends({}, reveal)
  }, rest));
}

function parsePresenceVisitor(data) {
  var endUser = data.endUser,
      rest = _objectWithoutProperties(data, ['endUser']);

  return PresenceVisitor(_extends({
    endUserId: endUser && endUser.id || rest.id
  }, rest));
}

var PresenceState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  bufferedUsers: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  newLiveUsers: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  newLiveUsersCount: 0,
  toggle: false,
  filters: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  newFilters: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  newSorts: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  showMore: false,
  filterKnownUsers: false,
  pagination: { currentIndex: 0, userLoadCount: 50 },
  interval: 5000,
  activeStatus: { isActive: true },
  presenceProblems: false,
  presenceLoading: false,
  hasProcessedUsers: false,
  usersWithMessageSent: []
});

var PresenceSession = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  numSessions: undefined,
  numPageViews: undefined,
  activeSessionStartedAt: undefined,
  currentSessionStartedAt: undefined,
  currentPageViewStartedAt: undefined,
  previousSessionStartedAt: undefined,
  previousSessionEndedAt: undefined,
  firstSessionAt: undefined
});

var PresenceBrowser = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  userAgent: undefined,
  timezone: undefined,
  locale: undefined
});

var PresenceMetaPage = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  search: undefined,
  hostname: undefined,
  path: undefined,
  url: undefined,
  href: undefined,
  title: undefined,
  referrer: undefined
});

var PresenceMetaGeo = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  city: undefined,
  subdivision: undefined,
  country: undefined,
  countryName: undefined,
  latitude: undefined,
  longitude: undefined,
  latLong: undefined,
  metroCode: undefined,
  postalCode: undefined,
  ip: undefined,
  gdprApplicable: undefined
});

var PresenceCompany = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  name: undefined
});

var PresenceVisitor = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  updatedAt: undefined,
  endUserId: undefined,
  browser: new PresenceBrowser(),
  session: new PresenceSession(),
  page: new PresenceMetaPage(),
  location: new PresenceMetaGeo(),
  company: new PresenceCompany()
});

var PresenceMeta = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  phx_ref: undefined,
  phx_ref_prev: undefined,
  phx_status: __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* PhoenixStatus */].CONNECTED,
  ip: undefined,
  email: undefined,
  page: new PresenceMetaPage(),
  onlineAt: undefined,
  lastUpdateAt: undefined,
  externalId: undefined,
  anonymousId: undefined,
  userType: '',
  userId: undefined,
  geo: new PresenceMetaGeo(),
  companyInfo: undefined
});

var PresenceUser = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  meta: new PresenceMeta(),
  metaJson: '',
  metasByRef: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  className: ''
});

/***/ }),

/***/ "sb0q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "senS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sgb3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(107);

/***/ }),

/***/ "slDV":
/***/ (function(module, exports) {

module.exports = "<svg width=\"24\" height=\"23\" viewBox=\"0 0 24 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.465 22.085c-.53 0-.88-.44-.88-.98v-1.062L6.186 17.136v3.97a.97.97 0 0 1-.958.98.968.968 0 0 1-.96-.98v-4.332l-2.103-.397C1.2 16.195.44 15.265.44 14.26V8.39c0-1.005.76-1.935 1.727-2.117l19.417-3.668v-1.06c0-.54.352-.98.88-.98a.97.97 0 0 1 .96.98v19.56a.97.97 0 0 1-.96.98zm-.88-17.49L2.514 8.197c-.065.012-.16.127-.16.194v5.87c0 .065.095.182.16.193l19.07 3.6V4.596z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "snL0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return visibility$; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);


var visibility$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].fromEvent(document, 'visibilitychange').map(function () {
  return !document.hidden;
});

/***/ }),

/***/ "snhG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__ = __webpack_require__("pE/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AddButton__ = __webpack_require__("Xbg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Integration_components_AutoSyncCallout__ = __webpack_require__("fysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_IntegrationToggles__ = __webpack_require__("aZez");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_SFDC_SFDCAccountSyncModal__ = __webpack_require__("ewSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__model__ = __webpack_require__("j8vl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_user_selectors__ = __webpack_require__("hTEi");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var CONNECT_ERROR_MESSAGE = 'We could not fetch your settings.';
var PATCH_ERROR_MESSAGE = 'We could not save your changes.';

var SalesforceConfig = function (_Component) {
  _inherits(SalesforceConfig, _Component);

  function SalesforceConfig() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SalesforceConfig);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SalesforceConfig.__proto__ || Object.getPrototypeOf(SalesforceConfig)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      toggles: __WEBPACK_IMPORTED_MODULE_14__model__["d" /* model */],
      accountToggles: [],
      lists: [],
      savedLists: [],
      syncHistory: {},
      showAccountsSyncModal: false,
      warningModal: false,
      checked: false
    }, _this.startSyncPoll = function () {
      var getSyncInfo = function getSyncInfo() {
        __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountListSyncHistory().then(_this.receiveHistory);
      };

      _this.syncInterval = setInterval(getSyncInfo, 10000);
    }, _this.onError = function () {
      var router = _this.context.router;


      _this.props.notifications.error(CONNECT_ERROR_MESSAGE);
      router.push({ pathname: '/settings/setup/salesforce' });
    }, _this.onPatchError = function () {
      _this.props.notifications.error(PATCH_ERROR_MESSAGE);
    }, _this.resync = function () {
      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].resyncAccountList().then(function () {
        return _this.props.notifications.success(' We are re-syncing your accounts');
      }).catch(function () {
        return _this.props.notifications.error(' There were errors syncing your accounts lists');
      });
    }, _this.forceUpdateSync = function () {
      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].setForceResync().then(function () {
        __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].resyncAccountList().then(function () {
          return _this.props.notifications.success(' We are updating all of your accounts');
        });
      }).catch(function () {
        return _this.props.notifications.error(' There were errors syncing your accounts lists');
      });
    }, _this.receiveHistory = function (resp) {
      _this.setState({
        syncHistory: resp
      });
    }, _this.receiveToggles = function (resp) {
      _this.setState({
        toggles: Object(__WEBPACK_IMPORTED_MODULE_14__model__["b" /* hydrateModel */])(resp, _this.props.hasContactSync)
      });
    }, _this.settingsUpdatedNotification = function () {
      return _this.props.notifications.success('Salesforce settings are updated!');
    }, _this.receiveLists = function (resp) {
      _this.setState({
        lists: resp
      });
    }, _this.receiveSavedLists = function (resp) {
      _this.setState({
        savedLists: resp
      });
    }, _this.patchToggle = function (event, toggle) {
      if (!!toggle.confirmation && !toggle.value) {
        _this.setState({
          "confirmationModalOpen": true,
          "confirmationModalToggle": toggle
        });
        return;
      }

      var data = _defineProperty({}, toggle.type, event);

      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["L" /* patchSalesforceToggles */])(data).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _this.onConfirmClick = function () {
      var confirmationModalToggle = _this.state.confirmationModalToggle;

      var data = _defineProperty({}, confirmationModalToggle.type, !confirmationModalToggle.value);

      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["L" /* patchSalesforceToggles */])(data).then(_this.setState({ "confirmationModalOpen": false })).then(_this.receiveToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _this.onCancelClick = function (val) {
      _this.setState({
        "confirmationModalOpen": false
      });
    }, _this.warningModalOnCancelClick = function () {
      _this.setState(function (prevState) {
        return {
          'warningModal': !prevState.warningModal
        };
      });
    }, _this.handleCheckboxChange = function () {
      _this.setState(function (prevState) {
        return {
          'checked': !prevState.checked
        };
      });
    }, _this.setAccountDeleteOk = function (event) {

      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].setAccountDeleteOk(event).then(_this.receiveAccountToggles).then(_this.settingsUpdatedNotification).catch(_this.onPatchError);
    }, _this.toggleAccountsSyncModal = function () {
      _this.setState(function (prevState) {
        return {
          showAccountsSyncModal: !prevState.showAccountsSyncModal
        };
      });
    }, _this.deleteSyncedAccountList = function (id) {
      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].deleteSyncedSFDCAccountList(id).then(_this.receiveSavedLists).catch(_this.onPatchError);
    }, _this.saveNewAccountLists = function (accountLists) {
      var savedAndNewAccountLists = [].concat(_toConsumableArray(accountLists), _toConsumableArray(_this.state.savedLists));

      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].saveSyncedSFDCAccountLists(savedAndNewAccountLists).then(_this.receiveSavedLists).then(_this.toggleAccountsSyncModal).then(_this.props.notifications.success("We're syncing your Salesforce Accounts. Please check back soon.")).catch(_this.onPatchError);
    }, _this.renderSyncedList = function (list) {
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        'tr',
        { key: list.accountListId },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'td',
          null,
          list.accountListName
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'td',
          null,
          list.targeted && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Tag"], { text: 'Targeted' })
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'span',
            { onClick: function onClick() {
                return _this.deleteSyncedAccountList(list.accountListId);
              } },
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], { width: 15, name: 'trash' })
          )
        )
      );
    }, _this.renderSyncedAccountLists = function () {
      var savedLists = _this.state.savedLists;

      if (!savedLists.length) return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        'p',
        null,
        'You haven\u2019t synced any accounts from Salesforce yet. Today seems like a good day for it :)'
      );

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        'table',
        { className: 'drift-table salesforce-account-list-table' },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'tbody',
          null,
          savedLists.map(_this.renderSyncedList)
        )
      );
    }, _this.renderConfirmationModal = function (toggle) {
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Modal"],
        {
          open: true,
          onClose: _this.onCancelClick,
          className: 'toggle-confirmation-modal',
          size: 'small'
        },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'p',
          { className: 'sfdc-records-header' },
          'Are you sure you want to always create new Salesforce records?'
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'p',
          { className: 'sfdc-records-message-body' },
          toggle.confirmation
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'div',
          { className: 'button-container' },
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
            { onClick: _this.onConfirmClick, type: 'secondary' },
            'Continue'
          ),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
            { onClick: _this.onCancelClick, className: 'toggle-cancel-button', type: 'tertiary' },
            'Cancel'
          )
        )
      );
    }, _this.renderWarningModal = function () {
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Modal"],
        {
          open: true,
          className: 'warning-modal',
          size: 'small',
          onClose: _this.warningModalOnCancelClick
        },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'h3',
          null,
          'Before you sync SFDC Accounts'
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'p',
          null,
          'Please make sure your Drift and Salesforce users are properly mapped on',
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'a',
            { href: 'https://app.drift.com/settings/salesforce/mapping/users', target: '_blank' },
            ' https://app.drift.com/settings/salesforce/mapping/users '
          ),
          'before attempting to sync Accounts from Salesforce into Drift. Without mapped users, the account sync will fail.'
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'div',
          { className: 'button-container' },
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
            { type: 'secondary', onClick: function onClick(event) {
                _this.toggleAccountsSyncModal(event);_this.warningModalOnCancelClick(event);
              } },
            'Sync'
          ),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
            { type: 'tertiary', onClick: _this.warningModalOnCancelClick },
            'Cancel'
          ),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Input"], {
            className: 'warning-modal-checkbox',
            type: 'checkbox',
            checked: _this.handleCheckboxChange,
            label: 'Don\u2019t warn me again' })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SalesforceConfig, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.getElementsByClassName('app-content-container')[0].scrollTo(0, 0);

      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountListSyncHistory().then(this.receiveHistory).then(this.startSyncPoll);

      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].fetchSFDCAccountLists().then(this.receiveLists).catch(this.onError);

      __WEBPACK_IMPORTED_MODULE_2_app_modules_sfdc_api__["a" /* api */].fetchSyncedSFDCAccountLists().then(this.receiveSavedLists).catch(this.onError);

      Object(__WEBPACK_IMPORTED_MODULE_1_app_modules_integrations_api__["E" /* getSalesforceToggles */])().then(this.receiveToggles).catch(this.onError);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.syncInterval);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["equals"])(nextState, this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          toggles = _state.toggles,
          showAccountsSyncModal = _state.showAccountsSyncModal,
          lists = _state.lists,
          savedLists = _state.savedLists,
          syncHistory = _state.syncHistory,
          accountToggles = _state.accountToggles,
          confirmationModalOpen = _state.confirmationModalOpen,
          confirmationModalToggle = _state.confirmationModalToggle,
          warningModal = _state.warningModal;

      var hasErrors = syncHistory.results && (syncHistory.results.FAILED_NODOMAIN.length || syncHistory.results.FAILED_NOOWNER.length);

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        'div',
        { className: 'common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Salesforce Integration',
          backLinkUrl: '/settings/setup/salesforce'
        }),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Sync Settings'
          ),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'p',
            null,
            'Choose which Salesforce objects are sent between Drift and Salesforce.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'h3',
          { className: 'integration-header' },
          'Drift',
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
            className: 'right-arrow',
            width: 15,
            height: 10,
            name: 'arrow-2-right'
          }),
          'Salesforce'
        ),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Integration_components_AutoSyncCallout__["a" /* default */], { integrationName: 'Salesforce' }),
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_IntegrationToggles__["a" /* default */], {
          toggles: toggles,
          onChange: this.patchToggle
        }),
        __WEBPACK_IMPORTED_MODULE_13_utils_Access__["c" /* default */].hasGates('ABM') && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          'div',
          { className: 'salesforce-account-sync-config' },
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'h3',
            { className: 'integration-header' },
            'Salesforce',
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Icon"], {
              className: 'right-arrow',
              width: 15,
              height: 10,
              name: 'arrow-2-right'
            }),
            'Drift'
          ),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            'div',
            { className: 'salesforce-account-sync-config-container' },
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
              'h2',
              { className: 'integration-header' },
              'Synced Account Lists'
            ),
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
              'p',
              null,
              'Sync your accounts from Salesforce to target with Drift ABM or other playbooks. Drift will keep your accounts in sync with Salesforce and refresh daily.',
              __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'a',
                { target: '_blank', href: '/accounts' },
                '\xA0Click here to go to accounts.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_IntegrationToggles__["a" /* default */], {
              toggles: accountToggles,
              onChange: this.setAccountDeleteOk
            }),
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
              'div',
              { className: 'sfdc-accounts-sync--title-section drift-form' },
              syncHistory.updateDateTime && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'span',
                { className: 'account-sync-status' },
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                  'p',
                  null,
                  'Last Synced on ',
                  __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncHistory.updateDateTime).format('MM/DD/YYYY'),
                  ' at ',
                  __WEBPACK_IMPORTED_MODULE_9_moment___default()(syncHistory.updateDateTime).format('HH:MM')
                ),
                !hasErrors && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                  'span',
                  {
                    className: 'account-list-resync',
                    onClick: this.resync
                  },
                  'Resync'
                )
              ),
              !!hasErrors && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                'span',
                { className: 'salesforce-account-sync-error-message' },
                __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                  'p',
                  null,
                  'Oh no! We ran in to some errors while syncing your Salesforce Accounts. You can fix them',
                  __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
                    'a',
                    { href: '/accounts/imports', target: '_self' },
                    ' here.'
                  )
                )
              ),
              this.renderSyncedAccountLists()
            ),
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_AddButton__["a" /* default */], {
              addButtonLabel: 'Add Account List',
              type: 'secondary',
              onClick: syncHistory.results && _.isEmpty(syncHistory.results.CREATED) ? this.warningModalOnCancelClick : this.toggleAccountsSyncModal
            }),
            !!lists.length && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["Button"],
              {
                className: 'salesforce-account-force-update',
                type: 'subtle',
                size: 'medium',
                onClick: this.forceUpdateSync
              },
              'Force Update All'
            )
          )
        ),
        showAccountsSyncModal && __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_SFDC_SFDCAccountSyncModal__["a" /* default */], {
          onCloseClick: this.saveNewAccountLists,
          onCancelClick: this.toggleAccountsSyncModal,
          deleteSyncedAccountList: this.deleteSyncedAccountList,
          lists: lists,
          savedLists: savedLists
        }),
        warningModal && syncHistory.results && _.isEmpty(syncHistory.results.CREATED) && this.renderWarningModal(),
        confirmationModalOpen && this.renderConfirmationModal(confirmationModalToggle)
      );
    }
  }]);

  return SalesforceConfig;
}(__WEBPACK_IMPORTED_MODULE_12_react__["Component"]);

SalesforceConfig.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasContactSync: Object(__WEBPACK_IMPORTED_MODULE_16_app_modules_user_selectors__["settingsAppConfig"])(state)['hasSalesforceContactSync']
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_8_components_shared_notifications__["a" /* default */])(SalesforceConfig)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "so0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_styl__ = __webpack_require__("bYlK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      active: false
    }, _this.renderDropDownIcon = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'i',
        { className: 'icon' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __webpack_require__("wP5d") })
      );
    }, _this.handleClick = function () {
      if (!_this.props.locked) {
        _this.setState({ active: !_this.state.active });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Accordion, [{
    key: 'render',
    value: function render() {
      var active = this.state.active;
      var _props = this.props,
          children = _props.children,
          title = _props.title,
          locked = _props.locked,
          isConnected = _props.isConnected,
          centerLogo = _props.centerLogo,
          className = _props.className;

      var logoClass = centerLogo ? 'flex-center' : 'flex-space-between';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'accordion' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('title', className, logoClass, { active: active || locked, locked: locked }),
            onClick: this.handleClick
          },
          title,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex' },
            isConnected ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Icon"], { height: 37, width: 37, className: 'accordion-connected', name: 'check-circle' }) : null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { minWidth: 20, alignSelf: 'center' } },
              locked ? null : this.renderDropDownIcon()
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('content', { active: active || locked }) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'transition visible' },
            children
          )
        )
      );
    }
  }]);

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),

/***/ "sqON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FailedContent":"FailedContent---24ZlI","Content":"Content---38_BL"};

/***/ }),

/***/ "st9j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return FETCH_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return FETCH_PLAYBOOK_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return FETCH_PLAYBOOK_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return FETCH_PLAYBOOK_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return GET_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return GET_PLAYBOOK_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return GET_PLAYBOOK_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return GET_PLAYBOOK_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return GET_PLAYBOOK_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return GET_PLAYBOOK_BY_CAMPAIGN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return FETCH_PLAYBOOK_COUNTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return FETCH_PLAYBOOK_COUNTS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return FETCH_PLAYBOOK_COUNTS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return FETCH_PLAYBOOK_COUNTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return FETCH_PLAYBOOK_COUNTS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return FETCH_PLAYBOOK_CARDINALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return FETCH_PLAYBOOK_CARDINALITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return FETCH_PLAYBOOK_CARDINALITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return FETCH_PLAYBOOK_CARDINALITY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return FETCH_PLAYBOOK_CARDINALITY_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return FETCH_PLAYBOOK_BY_CAMPAIGN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return FETCH_PLAYBOOKS_BY_REPORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return FETCH_PLAYBOOK_BY_INTERACTION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CREATE_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CREATE_PLAYBOOK_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CREATE_PLAYBOOK_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CREATE_PLAYBOOK_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CLONE_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CLONE_PLAYBOOK_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CLONE_PLAYBOOK_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CLONE_PLAYBOOK_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CLONE_PLAYBOOK_SUCCESS; });
/* unused harmony export ARCHIVE_PLAYBOOK */
/* unused harmony export ARCHIVE_PLAYBOOK_PENDING */
/* unused harmony export ARCHIVE_PLAYBOOK_CANCELLED */
/* unused harmony export ARCHIVE_PLAYBOOK_FAILED */
/* unused harmony export ARCHIVE_PLAYBOOK_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return SEND_TEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return SEND_TEST_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return SEND_TEST_EMAIL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return SEND_TEST_EMAIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return SEND_TEST_SEQUENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return SEND_TEST_SEQUENCE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return SEND_TEST_SEQUENCE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return SEND_TEST_SEQUENCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return SEND_TEST_SEQUENCE_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return SEARCH_ENABLED_PLAYBOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return SEARCH_PLAYBOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return SEARCH_PLAYBOOKS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return SEARCH_PLAYBOOKS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return SEARCH_PLAYBOOKS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return SEARCH_PLAYBOOKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return SAVE_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return SAVE_PLAYBOOK_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return SAVE_PLAYBOOK_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return SAVE_PLAYBOOK_SUCCESS; });
/* unused harmony export SAVE_PLAYBOOK_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return SET_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return SAVE_PLAYBOOK_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return SAVE_PLAYBOOK_DRAFT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return SAVE_PLAYBOOK_DRAFT_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return SAVE_PLAYBOOK_DRAFT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return SCHEDULE_PLAYBOOK_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return RECEIVE_PLAYBOOK_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_PLAYBOOK_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLEAR_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return DISABLE_PLAYBOOK_AUTOSAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return ENABLE_PLAYBOOK_AUTOSAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return MARK_DRAFT_UNSAVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return SET_DRAFT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return SET_DRAFT_STATUS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return SET_DRAFT_STATUS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return SET_DRAFT_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return SET_DRAFT_STATUS_DRAFT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return SET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return SET_SLUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return FETCH_DATA_PREVIEW_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return FETCH_DATA_PREVIEW_EMAIL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return FETCH_DATA_PREVIEW_EMAIL_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return FETCH_DATA_PREVIEW_EMAIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return FETCH_DATA_PREVIEW_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return FETCH_DATA_PREVIEW_SEQUENCE_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return SET_SEQUENCE_DYNAMIC_SENDER_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return SET_SEQUENCE_EMAIL_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return SET_SEQUENCE_SENDER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return SET_SEQUENCE_INDIVIDUAL_SENDER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return SET_DYNAMIC_SENDER_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return SET_EMAIL_OVERRIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return SET_SENDER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return SET_VIDEO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return SET_HEADLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return SET_THANK_YOU_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return SET_THANK_YOU_HEADLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return SET_CTA_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return SET_CTA_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return SET_CTA_COPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return SET_SEQUENCE_AUTHOR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return SET_AUTHOR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return SET_EMAIL_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return SET_EMAIL_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return SET_EMAIL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return SET_EMAIL_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADD_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DELETE_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return MOVE_EMAIL_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return SET_WEEKDAYS_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return SET_SMART_SENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return SET_UNENROLL_ON_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return SET_UNENROLL_ON_REPLY_BY_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return SET_THREADED_WITH_PREVIOUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return SET_GREETING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return SET_QUESTION_PROMPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ADD_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_EMAIL_CAPTURE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ADD_PHONE_CAPTURE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return DELETE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return MOVE_QUESTION_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DELETE_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return FLAG_ANSWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return SET_SKIP_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return SET_FIELD_ATTRIBUTE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return SET_BUTTON_ONLY_RESPONSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ADD_GOAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return DELETE_GOAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return SET_GOAL_CLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return SET_CURRENT_GOAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return SET_GOAL_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return DELETE_KEYWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ADD_KEYWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return SET_KEYWORD_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return SET_KEYWORD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return SET_ANSWER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return SET_BUTTON_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return SET_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return SET_DEFAULT_PHONE_COUNTRY_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return SET_ACTION_INBOX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return SET_GOAL_ROUTING_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return SAVE_GOAL_ROUTING_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return SET_GOAL_ROUTING_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return SELECT_GOAL_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return SAVE_GOAL_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return REMOVE_GOAL_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return SHOW_SEND_EMAIL_CONFIRM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return HIDE_SEND_EMAIL_CONFIRM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return SHOW_EDIT_SENDER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return HIDE_EDIT_SENDER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return SHOW_CALENDAR_LINK_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return HIDE_CALENDAR_LINK_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return SHOW_TOKEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return HIDE_TOKEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return SHOW_CTA_BUTTON_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return HIDE_CTA_BUTTON_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return SHOW_EXTENSION_INVITE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return HIDE_EXTENSION_INVITE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return SHOW_GOAL_ACTION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return HIDE_GOAL_ACTION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return SHOW_GOAL_ROUTING_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return HIDE_GOAL_ROUTING_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return SHOW_ANSWER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return HIDE_ANSWER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return SHOW_QUESTION_ADVANCED_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return HIDE_QUESTION_ADVANCED_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return SHOW_CONDITION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return HIDE_CONDITION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return SHOW_SCHEDULE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return HIDE_SCHEDULE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return SHOW_SEQUENCE_INVITE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return HIDE_SEQUENCE_INVITE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return SHOW_GOOGLE_AUTH_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return HIDE_GOOGLE_AUTH_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return SHOW_DISABLE_SALES_SEQUENCE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return HIDE_DISABLE_SALES_SEQUENCE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return RESET_DISPLAY_CONDITIONS; });
/* unused harmony export SET_TARGETING_DISPLAY_VIEW */
/* unused harmony export SET_TARGETING_DISPLAY_TARGET_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return SET_EMAIL_PLAYBOOK_CONDITION_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return SET_CONDITION_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return SET_CONDITION_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return SET_CONDITION_OPERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DELETE_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_CONDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DELETE_CONDITION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_CONDITION_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return SET_AUDIENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return SET_DRAFT_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return SET_EXCLUDED_USER_LIST_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return SET_USER_LIST_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return SET_EXCLUDED_ACCOUNT_LIST_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return SET_ACCOUNT_LIST_IDS; });
/* unused harmony export SET_SMART_FILTERS_CUSTOMERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return SET_SMART_FILTERS_ENGAGED_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return SET_SMART_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return FETCH_PLAYBOOKS_PRIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return FETCH_PLAYBOOKS_PRIORITY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return FETCH_PLAYBOOKS_PRIORITY_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return FETCH_PLAYBOOKS_PRIORITY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return FETCH_PLAYBOOKS_PRIORITY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return SET_META_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return HIDE_SEGMENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return SHOW_SEGMENT_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return SET_DRAFT_FREQUENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DISABLE_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ALL_CHANGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return ENROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return ENROLL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return ENROLL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return ENROLL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return UNENROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return UNENROLL_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return UNENROLL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return UNENROLL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return NOTIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return NOTIFY_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return NOTIFY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return NOTIFY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return FETCH_PLAYBOOKS_BY_IDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return FETCH_PLAYBOOKS_BY_IDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return FETCH_PLAYBOOKS_BY_IDS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return FETCH_PLAYBOOKS_BY_IDS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return FETCH_ENROLLED_PLAYBOOK_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return FETCH_ENROLLED_PLAYBOOK_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return FETCH_ENROLLED_PLAYBOOK_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return FETCH_ENROLLED_SEQUENCE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return FETCH_ENROLLED_SEQUENCE_COUNT_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return FETCH_ENROLLED_SEQUENCE_COUNT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return FETCH_PLAYBOOK_FOR_END_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return FETCH_PLAYBOOK_FOR_END_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return FETCH_PLAYBOOK_FOR_END_USER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return FETCH_PLAYBOOK_FOR_END_USER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return SET_PLAYBOOK_FOR_END_USER_SUBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return SET_PLAYBOOK_FOR_END_USER_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return SET_PLAYBOOK_FOR_END_USER_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLEAR_EMAIL_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return SET_EMAIL_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return SET_EMAIL_BANNER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return SET_EMAIL_BANNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return SET_EMAIL_BANNER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLEAR_ENROLL_MODAL_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return SET_MARKETING_EMAIL_LAYOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return FETCH_PLAYBOOKS_BY_GATED_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return SET_END_USER_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ASYNC_BUTTON_PRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ASYNC_BUTTON_PRESS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ASYNC_BUTTON_PRESS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ASYNC_BUTTON_PRESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ASYNC_BUTTON_PRESS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return SET_EDIT_SENDER_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return SET_SIGNATURE_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return SET_SIGNATURE_INCLUDE_AVATAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return SET_SIGNATURE_INCLUDE_SOCIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return SET_SIGNATURE_INCLUDE_BANNER; });
/* unused harmony export SET_SIGNATURE_BANNER_IMG_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return SET_SIGNATURE_BANNER_LINK_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return SET_VIEWING_SIGNATURE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ADD_NEW_SIGNATURE_TO_PLAYBOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return REMOVE_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ADD_EMPTY_BANNER_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return REMOVE_EMPTY_BANNER_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CLEAR_SIGNATURE_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return SET_SIGNATURE_BANNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return SET_SIGNATURE_BANNER_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return SET_SIGNATURE_BANNER_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return SET_SIGNATURE_BANNER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return SET_SIGNATURE_BANNER_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return FETCH_SIGNATURE_MULTI_BANNER_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED; });
/* unused harmony export FETCH_SIGNATURE_PLAYBOOK_PREVIEW */
/* unused harmony export FETCH_SIGNATURE_PLAYBOOK_PREVIEW_PENDING */
/* unused harmony export FETCH_SIGNATURE_PLAYBOOK_PREVIEW_FAILED */
/* unused harmony export FETCH_SIGNATURE_PLAYBOOK_PREVIEW_SUCCESS */
/* unused harmony export FETCH_SIGNATURE_PLAYBOOK_PREVIEW_CANCELLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CREATE_INITIAL_WELCOME_PLAYBOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return FETCH_PLAYBOOK_FOR_CAMPAIGN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return FETCH_CHAT_ACTIVE_PLAYBOOKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return START_REPORT_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return INCREMENT_REPORT_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DECREMENT_REPORT_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return RECORDED_REPORT_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return PlaybookStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return EditSenderLevels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return EmailPreviewView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AudienceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return AudienceDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return PlaybooksFrequency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return AudienceIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return TargetingDisplay; });
/* unused harmony export SmartFilterValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return PlaybookReportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return chatPlaybookReportTypes; });
/* unused harmony export landingPagePlaybookReportTypes */
/* unused harmony export botPlaybookReportTypes */
/* unused harmony export isLandingPagePlaybook */
/* unused harmony export isNonLandingPageBotPlaybook */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return isLeadBotPlaybook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return isEmailPlaybook; });
/* unused harmony export isOneTimeEmailPlaybook */
/* unused harmony export isSignaturePlaybook */
/* unused harmony export isSalesSequencePlaybook */
/* unused harmony export ReportTypeToTableName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return CtaTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CtaGoalTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return MarketingEmailLayouts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return MarketingEmailSubTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ActionViewConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return CtaViewConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return EmailThemeType; });
/* unused harmony export PlaybookDefaultEditViewOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return emailSendModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return PlaybookViewConfig; });
/* unused harmony export playbooksCopyDefaults */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return playbooksCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return RoutingType; });
/* unused harmony export END_CONVERSATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return END_CONVERSATION_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return PROCEED_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return AnswerType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return ValidationType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return KeywordType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return OperatorToDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return ConditionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return MadkuduLabelMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return MadkuduSignalMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return ConditionCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return ConditionCategoryToDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return NEW_EDITOR_PLAYBOOK_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return ConditionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return ConditionTypesByCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_playbook_components_TargetingDisplay_SelectContainer__ = __webpack_require__("/hXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__ = __webpack_require__("9b51");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_playbook_components_TargetingDisplay_RepSelectContainer__ = __webpack_require__("2uII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__ = __webpack_require__("rS5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ClearbitTags__ = __webpack_require__("SAet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_constants_ClearbitTech__ = __webpack_require__("JpL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_constants_ClearbitRevenueRanges__ = __webpack_require__("BqSa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_constants_UspsStates__ = __webpack_require__("f/uQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__ = __webpack_require__("dzDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_constantsHelper__ = __webpack_require__("Ac9J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_constants_DemandbaseAudiences__ = __webpack_require__("R9hW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_DemandbaseEmployeeRanges__ = __webpack_require__("ZPDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseRevenueRanges__ = __webpack_require__("bxiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_known_users_svg__ = __webpack_require__("7/el");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_known_users_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_known_users_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_site_visitors_svg__ = __webpack_require__("NpRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_site_visitors_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_site_visitors_svg__);
var _Object$freeze, _Object$freeze2, _OperatorToDisplay, _MadkuduLabelMap, _MadkuduSignalMap, _Object$freeze3, _OrderedMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

























var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_13_utils_constantsHelper__["a" /* makeConstantFactory */])('playbook');

var FETCH_PLAYBOOK = makeConstant('FETCH_PLAYBOOK');
var FETCH_PLAYBOOK_PENDING = makeConstant('FETCH_PLAYBOOK_PENDING');
var FETCH_PLAYBOOK_CANCELLED = makeConstant('FETCH_PLAYBOOK_CANCELLED');
var FETCH_PLAYBOOK_FAILED = makeConstant('FETCH_PLAYBOOK_FAILED');

var GET_PLAYBOOK = makeConstant('GET_PLAYBOOK');
var GET_PLAYBOOK_PENDING = makeConstant('GET_PLAYBOOK_PENDING');
var GET_PLAYBOOK_CANCELLED = makeConstant('GET_PLAYBOOK_CANCELLED');
var GET_PLAYBOOK_FAILED = makeConstant('GET_PLAYBOOK_FAILED');
var GET_PLAYBOOK_SUCCESS = makeConstant('GET_PLAYBOOK_SUCCESS');

var GET_PLAYBOOK_BY_CAMPAIGN_ID = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID');
var GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING');
var GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED');
var GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED');
var GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS');

var FETCH_PLAYBOOK_COUNTS = makeConstant('FETCH_PLAYBOOK_COUNTS');
var FETCH_PLAYBOOK_COUNTS_PENDING = makeConstant('FETCH_PLAYBOOK_COUNTS_PENDING');
var FETCH_PLAYBOOK_COUNTS_CANCELLED = makeConstant('FETCH_PLAYBOOK_COUNTS_CANCELLED');
var FETCH_PLAYBOOK_COUNTS_SUCCESS = makeConstant('FETCH_PLAYBOOK_COUNTS_SUCCESS');
var FETCH_PLAYBOOK_COUNTS_FAILED = makeConstant('FETCH_PLAYBOOK_COUNTS_FAILED');

var FETCH_PLAYBOOK_CARDINALITY = makeConstant('FETCH_PLAYBOOK_CARDINALITY');
var FETCH_PLAYBOOK_CARDINALITY_PENDING = makeConstant('FETCH_PLAYBOOK_CARDINALITY_PENDING');
var FETCH_PLAYBOOK_CARDINALITY_SUCCESS = makeConstant('FETCH_PLAYBOOK_CARDINALITY_SUCCESS');
var FETCH_PLAYBOOK_CARDINALITY_FAILED = makeConstant('FETCH_PLAYBOOK_CARDINALITY_FAILED');
var FETCH_PLAYBOOK_CARDINALITY_CANCELLED = makeConstant('FETCH_PLAYBOOK_CARDINALITY_CANCELLED');

var FETCH_PLAYBOOK_BY_CAMPAIGN_ID = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID');
var FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING');
var FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED');
var FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED');
var FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS');

var FETCH_PLAYBOOKS_BY_REPORT_TYPE = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE');
var FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING');
var FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED');
var FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED');
var FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS');

var FETCH_PLAYBOOK_BY_INTERACTION_ID = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID');
var FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING');
var FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED');
var FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED');
var FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS');

var ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE');
var ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED');
var ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING');
var ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED');
var ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS');

var CREATE_PLAYBOOK = makeConstant('CREATE_PLAYBOOK');
var CREATE_PLAYBOOK_PENDING = makeConstant('CREATE_PLAYBOOK_PENDING');
var CREATE_PLAYBOOK_CANCELLED = makeConstant('CREATE_PLAYBOOK_CANCELLED');
var CREATE_PLAYBOOK_FAILED = makeConstant('CREATE_PLAYBOOK_FAILED');

var CLONE_PLAYBOOK = makeConstant('CLONE_PLAYBOOK');
var CLONE_PLAYBOOK_PENDING = makeConstant('CLONE_PLAYBOOK_PENDING');
var CLONE_PLAYBOOK_CANCELLED = makeConstant('CLONE_PLAYBOOK_CANCELLED');
var CLONE_PLAYBOOK_FAILED = makeConstant('CLONE_PLAYBOOK_FAILED');
var CLONE_PLAYBOOK_SUCCESS = makeConstant('CLONE_PLAYBOOK_SUCCESS');

var ARCHIVE_PLAYBOOK = makeConstant('ARCHIVE_PLAYBOOK');
var ARCHIVE_PLAYBOOK_PENDING = makeConstant('ARCHIVE_PLAYBOOK_PENDING');
var ARCHIVE_PLAYBOOK_CANCELLED = makeConstant('ARCHIVE_PLAYBOOK_CANCELLED');
var ARCHIVE_PLAYBOOK_FAILED = makeConstant('ARCHIVE_PLAYBOOK_FAILED');
var ARCHIVE_PLAYBOOK_SUCCESS = makeConstant('ARCHIVE_PLAYBOOK_SUCCESS');

var SEND_TEST_EMAIL = makeConstant('SEND_TEST_EMAIL');
var SEND_TEST_EMAIL_SUCCESS = makeConstant('SEND_TEST_EMAIL_SUCCESS');
var SEND_TEST_EMAIL_PENDING = makeConstant('SEND_TEST_EMAIL_PENDING');
var SEND_TEST_EMAIL_FAILED = makeConstant('SEND_TEST_EMAIL_FAILED');

var SEND_TEST_SEQUENCE = makeConstant('SEND_TEST_SEQUENCE');
var SEND_TEST_SEQUENCE_PENDING = makeConstant('SEND_TEST_SEQUENCE_PENDING');
var SEND_TEST_SEQUENCE_FAILED = makeConstant('SEND_TEST_SEQUENCE_FAILED');
var SEND_TEST_SEQUENCE_SUCCESS = makeConstant('SEND_TEST_SEQUENCE_SUCCESS');
var SEND_TEST_SEQUENCE_CANCELLED = makeConstant('SEND_TEST_SEQUENCE_CANCELLED');

var SEARCH_ENABLED_PLAYBOOKS = makeConstant('SEARCH_ENABLED_PLAYBOOKS');
var SEARCH_PLAYBOOKS = makeConstant('SEARCH_PLAYBOOKS');
var SEARCH_PLAYBOOKS_PENDING = makeConstant('SEARCH_PLAYBOOKS_PENDING');
var SEARCH_PLAYBOOKS_CANCELLED = makeConstant('SEARCH_PLAYBOOKS_CANCELLED');
var SEARCH_PLAYBOOKS_FAILED = makeConstant('SEARCH_PLAYBOOKS_FAILED');
var SEARCH_PLAYBOOKS_SUCCESS = makeConstant('SEARCH_PLAYBOOKS_SUCCESS');

var SAVE_PLAYBOOK = makeConstant('SAVE_PLAYBOOK');
var SAVE_PLAYBOOK_PENDING = makeConstant('SAVE_PLAYBOOK_PENDING');
var SAVE_PLAYBOOK_CANCELLED = makeConstant('SAVE_PLAYBOOK_CANCELLED');
var SAVE_PLAYBOOK_SUCCESS = makeConstant('SAVE_PLAYBOOK_SUCCESS');
var SAVE_PLAYBOOK_FAILED = makeConstant('SAVE_PLAYBOOK_FAILED');

var SET_STATUS = makeConstant('SET_STATUS');

var SAVE_PLAYBOOK_DRAFT = makeConstant('SAVE_PLAYBOOK_DRAFT');
var SAVE_PLAYBOOK_DRAFT_PENDING = makeConstant('SAVE_PLAYBOOK_DRAFT_PENDING');
var SAVE_PLAYBOOK_DRAFT_CANCELLED = makeConstant('SAVE_PLAYBOOK_DRAFT_CANCELLED');
var SAVE_PLAYBOOK_DRAFT_FAILED = makeConstant('SAVE_PLAYBOOK_DRAFT_FAILED');

var SCHEDULE_PLAYBOOK_DRAFT = makeConstant('SCHEDULE_PLAYBOOK_DRAFT');

var RECEIVE_PLAYBOOK_DRAFT = makeConstant('RECEIVE_PLAYBOOK_DRAFT');
var ACCEPT_PLAYBOOK_DRAFT = makeConstant('ACCEPT_PLAYBOOK_DRAFT');
var CLEAR_DRAFT = makeConstant('CLEAR_DRAFT');

var DISABLE_PLAYBOOK_AUTOSAVE = makeConstant('DISABLE_PLAYBOOK_AUTOSAVE');
var ENABLE_PLAYBOOK_AUTOSAVE = makeConstant('ENABLE_PLAYBOOK_AUTOSAVE');
var MARK_DRAFT_UNSAVED = makeConstant('MARK_DRAFT_UNSAVED');

var SET_DRAFT_STATUS = makeConstant('SET_DRAFT_STATUS');
var SET_DRAFT_STATUS_PENDING = makeConstant('SET_DRAFT_STATUS_PENDING');
var SET_DRAFT_STATUS_CANCELLED = makeConstant('SET_DRAFT_STATUS_CANCELLED');
var SET_DRAFT_STATUS_SUCCESS = makeConstant('SET_DRAFT_STATUS_SUCCESS');
var SET_DRAFT_STATUS_DRAFT_FAILED = makeConstant('SET_DRAFT_STATUS_DRAFT_FAILED');

var SET_NAME = makeConstant('SET_NAME');
var SET_SLUG = makeConstant('SET_SLUG');

var FETCH_DATA_PREVIEW_EMAIL = makeConstant('FETCH_DATA_PREVIEW_EMAIL');
var FETCH_DATA_PREVIEW_EMAIL_PENDING = makeConstant('FETCH_DATA_PREVIEW_EMAIL_PENDING');
var FETCH_DATA_PREVIEW_EMAIL_CANCELLED = makeConstant('FETCH_DATA_PREVIEW_EMAIL_CONCELLED');
var FETCH_DATA_PREVIEW_EMAIL_FAILED = makeConstant('FETCH_DATA_PREVIEW_EMAIL_FAILED');
var FETCH_DATA_PREVIEW_EMAIL_SUCCESS = makeConstant('FETCH_DATA_PREVIEW_EMAIL_SUCCESS');

var FETCH_DATA_PREVIEW_SEQUENCE_EMAIL = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL');
var FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING');
var FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CANCELLED = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CONCELLED');
var FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED');
var FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS');

var SET_SEQUENCE_DYNAMIC_SENDER_FORMAT = makeConstant('SET_SEQUENCE_DYNAMIC_SENDER_FORMAT');
var SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE = makeConstant('SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE');
var SET_SEQUENCE_EMAIL_OVERRIDE = makeConstant('SET_SEQUENCE_EMAIL_OVERRIDE');
var SET_SEQUENCE_SENDER_NAME = makeConstant('SET_SEQUENCE_SENDER_NAME');
var SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE = makeConstant('SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE');
var SET_SEQUENCE_INDIVIDUAL_SENDER_NAME = makeConstant('SET_SEQUENCE_INDIVIDUAL_SENDER_NAME');
var SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR = makeConstant('SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR');
var SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT = makeConstant('SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT');
var SET_DYNAMIC_SENDER_FORMAT = makeConstant('SET_DYNAMIC_SENDER_FORMAT');
var SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE = makeConstant('SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE');
var SET_EMAIL_OVERRIDE = makeConstant('SET_EMAIL_OVERRIDE');
var SET_SENDER_NAME = makeConstant('SET_SENDER_NAME');
var SET_MESSAGE = makeConstant('SET_MESSAGE');
var SET_VIDEO_URL = makeConstant('VIDEO_URL');
var SET_HEADLINE = makeConstant('SET_HEADLINE');
var SET_THANK_YOU_MESSAGE = makeConstant('SET_THANK_YOU_MESSAGE');
var SET_THANK_YOU_HEADLINE = makeConstant('SET_THANK_YOU_HEADLINE');
var SET_CTA_TYPE = makeConstant('SET_CTA_TYPE');
var SET_CTA_LINK = makeConstant('SET_CTA_LINK');
var SET_CTA_COPY = makeConstant('SET_CTA_COPY');
var SET_SEQUENCE_AUTHOR_ID = makeConstant('SET_SEQUENCE_AUTHOR_ID');
var SET_AUTHOR_ID = makeConstant('SET_AUTHOR_ID');
var SET_EMAIL_THEME = makeConstant('SET_EMAIL_THEME');

var SET_EMAIL_TITLE = makeConstant('SET_EMAIL_TITLE');
var SET_EMAIL_MESSAGE = makeConstant('SET_EMAIL_MESSAGE');
var SET_EMAIL_DELAY = makeConstant('SET_EMAIL_DELAY');
var ADD_EMAIL = makeConstant('ADD_EMAIL');
var DELETE_EMAIL = makeConstant('DELETE_EMAIL');
var MOVE_EMAIL_UP = makeConstant('MOVE_EMAIL_UP');
var SET_WEEKDAYS_ONLY = makeConstant('SET_WEEKDAYS_ONLY');
var SET_SMART_SENDING = makeConstant('SET_SMART_SENDING');
var SET_UNENROLL_ON_REPLY = makeConstant('SET_UNENROLL_ON_REPLY');
var SET_UNENROLL_ON_REPLY_BY_DOMAIN = makeConstant('SET_UNENROLL_ON_REPLY_BY_DOMAIN');
var SET_THREADED_WITH_PREVIOUS = makeConstant('SET_THREADED_WITH_PREVIOUS');

var SET_GREETING = makeConstant('SET_GREETING');
var SET_QUESTION_PROMPT = makeConstant('SET_QUESTION_PROMPT');
var ADD_QUESTION = makeConstant('ADD_QUESTION');
var ADD_EMAIL_CAPTURE_QUESTION = makeConstant('ADD_EMAIL_CAPTURE_QUESTION');
var ADD_PHONE_CAPTURE_QUESTION = makeConstant('ADD_PHONE_CAPTURE_QUESTION');
var DELETE_QUESTION = makeConstant('DELETE_QUESTION');
var MOVE_QUESTION_UP = makeConstant('MOVE_QUESTION_UP');
var ADD_ANSWER = makeConstant('ADD_ANSWER');
var DELETE_ANSWER = makeConstant('DELETE_ANSWER');
var FLAG_ANSWER = makeConstant('FLAG_ANSWER');
var SET_SKIP_TO = makeConstant('SET_SKIP_TO');
var SET_FIELD_ATTRIBUTE_NAME = makeConstant('SET_FIELD_ATTRIBUTE_NAME');
var SET_BUTTON_ONLY_RESPONSES = makeConstant('SET_BUTTON_ONLY_RESPONSES');
var ADD_GOAL = makeConstant('ADD_GOAL');
var DELETE_GOAL = makeConstant('DELETE_GOAL');
var SET_GOAL_CLASSIFICATION = makeConstant('SET_GOAL_CLASSIFICATION');
var SET_CURRENT_GOAL_ID = makeConstant('SET_CURRENT_GOAL_ID');
var SET_GOAL_MESSAGE = makeConstant('SET_GOAL_MESSAGE');
var DELETE_KEYWORD = makeConstant('DELETE_KEYWORD');
var ADD_KEYWORD = makeConstant('ADD_KEYWORD');
var SET_KEYWORD_TEXT = makeConstant('SET_KEYWORD_TEXT');
var SET_KEYWORD_TYPE = makeConstant('SET_KEYWORD_TYPE');
var SET_ANSWER_TYPE = makeConstant('SET_ANSWER_TYPE');
var SET_BUTTON_TEXT = makeConstant('SET_BUTTON_TEXT');
var SET_RESPONSE = makeConstant('SET_RESPONSE');
var SET_DEFAULT_PHONE_COUNTRY_CODE = makeConstant('SET_DEFAULT_PHONE_COUNTRY_CODE');

var SET_ACTION_INBOX_ID = makeConstant('SET_ACTION_INBOX_ID');

var SET_GOAL_ROUTING_OPTION = makeConstant('SET_GOAL_ROUTING_OPTION');
var SAVE_GOAL_ROUTING_OPTION = makeConstant('SAVE_GOAL_ROUTING_OPTION');
var SET_GOAL_ROUTING_VIEW = makeConstant('SET_GOAL_ROUTING_VIEW');
var SELECT_GOAL_ACTION = makeConstant('SELECT_GOAL_ACTION');
var SAVE_GOAL_ACTION = makeConstant('SAVE_GOAL_ACTION');
var REMOVE_GOAL_ACTION = makeConstant('REMOVE_GOAL_ACTION');

var SHOW_SEND_EMAIL_CONFIRM_MODAL = makeConstant('SHOW_SEND_EMAIL_CONFIRM_MODAL');
var HIDE_SEND_EMAIL_CONFIRM_MODAL = makeConstant('HIDE_SEND_EMAIL_CONFIRM_MODAL');
var SHOW_EDIT_SENDER_MODAL = makeConstant('SHOW_EDIT_SENDER_MODAL');
var HIDE_EDIT_SENDER_MODAL = makeConstant('HIDE_EDIT_SENDER_MODAL');
var SHOW_CALENDAR_LINK_MODAL = makeConstant('SHOW_CALENDAR_LINK_MODAL');
var HIDE_CALENDAR_LINK_MODAL = makeConstant('HIDE_CALENDAR_LINK_MODAL');
var SHOW_TOKEN_MODAL = makeConstant('SHOW_TOKEN_MODAL');
var HIDE_TOKEN_MODAL = makeConstant('HIDE_TOKEN_MODAL');
var SHOW_CTA_BUTTON_MODAL = makeConstant('SHOW_CTA_BUTTON_MODAL');
var HIDE_CTA_BUTTON_MODAL = makeConstant('HIDE_CTA_BUTTON_MODAL');
var SHOW_EXTENSION_INVITE_MODAL = makeConstant('SHOW_EXTENSION_INVITE_MODAL');
var HIDE_EXTENSION_INVITE_MODAL = makeConstant('HIDE_EXTENSION_INVITE_MODAL');
var SHOW_GOAL_ACTION_MODAL = makeConstant('SHOW_GOAL_ACTION_MODAL');
var HIDE_GOAL_ACTION_MODAL = makeConstant('HIDE_GOAL_ACTION_MODAL');
var SHOW_GOAL_ROUTING_MODAL = makeConstant('SHOW_GOAL_ROUTING_MODAL');
var HIDE_GOAL_ROUTING_MODAL = makeConstant('HIDE_GOAL_ROUTING_MODAL');
var SHOW_ANSWER_MODAL = makeConstant('SHOW_ANSWER_MODAL');
var HIDE_ANSWER_MODAL = makeConstant('HIDE_ANSWER_MODAL');
var SHOW_QUESTION_ADVANCED_MODAL = makeConstant('SHOW_QUESTION_ADVANCED_MODAL');
var HIDE_QUESTION_ADVANCED_MODAL = makeConstant('HIDE_QUESTION_ADVANCED_MODAL');
var SHOW_CONDITION_MODAL = makeConstant('SHOW_CONDITION_MODAL');
var HIDE_CONDITION_MODAL = makeConstant('HIDE_CONDITION_MODAL');
var SHOW_SCHEDULE_MODAL = makeConstant('SHOW_SCHEDULE_MODAL');
var HIDE_SCHEDULE_MODAL = makeConstant('HIDE_SCHEDULE_MODAL');
var SHOW_SEQUENCE_INVITE_MODAL = makeConstant('SHOW_SEQUENCE_INVITE_MODAL');
var HIDE_SEQUENCE_INVITE_MODAL = makeConstant('HIDE_SEQUENCE_INVITE_MODAL');
var SHOW_GOOGLE_AUTH_MODAL = makeConstant('SHOW_GOOGLE_AUTH_MODAL');
var HIDE_GOOGLE_AUTH_MODAL = makeConstant('HIDE_GOOGLE_AUTH_MODAL');
var SHOW_DISABLE_SALES_SEQUENCE_MODAL = makeConstant('SHOW_DISABLE_SALES_SEQUENCE_MODAL');
var HIDE_DISABLE_SALES_SEQUENCE_MODAL = makeConstant('HIDE_DISABLE_SALES_SEQUENCE_MODAL');

var RESET_DISPLAY_CONDITIONS = makeConstant('RESET_DISPLAY_CONDITIONS');
var SET_TARGETING_DISPLAY_VIEW = makeConstant('SET_TARGETING_DISPLAY_VIEW');
var SET_TARGETING_DISPLAY_TARGET_ID = makeConstant('SET_TARGETING_DISPLAY_TARGET_ID');
var SET_EMAIL_PLAYBOOK_CONDITION_VALUE = makeConstant('SET_EMAIL_PLAYBOOK_CONDITION_VALUE');
var SET_CONDITION_VALUE = makeConstant('SET_CONDITION_VALUE');
var SET_CONDITION_FIELD = makeConstant('SET_CONDITION_FIELD');
var SET_CONDITION_OPERATOR = makeConstant('SET_CONDITION_OPERATOR');
var DELETE_CONDITION = makeConstant('DELETE_CONDITION');
var ADD_CONDITION = makeConstant('ADD_CONDITION');
var DELETE_CONDITION_SET = makeConstant('DELETE_CONDITION_SET');
var ADD_CONDITION_SET = makeConstant('ADD_CONDITION_SET');

var SET_AUDIENCE = makeConstant('SET_AUDIENCE');
var SET_DRAFT_SCHEDULE = makeConstant('SET_DRAFT_SCHEDULE');
var SET_EXCLUDED_USER_LIST_IDS = makeConstant('SET_EXCLUDED_USER_LIST_IDS');
var SET_USER_LIST_IDS = makeConstant('SET_USER_LIST_IDS');
var SET_EXCLUDED_ACCOUNT_LIST_IDS = makeConstant('SET_EXCLUDED_ACCOUNT_LIST_IDS');
var SET_ACCOUNT_LIST_IDS = makeConstant('SET_ACCOUNT_LIST_IDS');
var SET_SMART_FILTERS_CUSTOMERS = makeConstant('SET_SMART_FILTERS_CUSTOMERS');
var SET_SMART_FILTERS_ENGAGED_CONTACTS = makeConstant('SET_SMART_FILTERS_ENGAGED_CONTACTS');
var SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS = makeConstant('SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS');
var SET_SMART_FILTERS = makeConstant('SET_SMART_FILTERS');

var FETCH_PLAYBOOKS_PRIORITY = makeConstant('FETCH_PLAYBOOKS_PRIORITY');
var FETCH_PLAYBOOKS_PRIORITY_PENDING = makeConstant('FETCH_PLAYBOOKS_PRIORITY_PENDING');
var FETCH_PLAYBOOKS_PRIORITY_CANCELLED = makeConstant('FETCH_PLAYBOOKS_PRIORITY_CANCELLED');
var FETCH_PLAYBOOKS_PRIORITY_FAILED = makeConstant('FETCH_PLAYBOOKS_PRIORITY_FAILED');
var FETCH_PLAYBOOKS_PRIORITY_SUCCESS = makeConstant('FETCH_PLAYBOOKS_PRIORITY_SUCCESS');

var SET_META_ATTRIBUTE = makeConstant('SET_META_ATTRIBUTE');

var HIDE_SEGMENT_SELECT = makeConstant('HIDE_SEGMENT_SELECT');
var SHOW_SEGMENT_SELECT = makeConstant('SHOW_SEGMENT_SELECT');

var SET_DRAFT_FREQUENCY = makeConstant('SET_DRAFT_FREQUENCY');
var DISABLE_PLAYBOOK = makeConstant('DISABLE_PLAYBOOK');
var ALL_CHANGES = makeConstant('ALL_CHANGES');

var ENROLL = makeConstant('ENROLL');
var ENROLL_PENDING = makeConstant('ENROLL_PENDING');
var ENROLL_FAILED = makeConstant('ENROLL_FAILED');
var ENROLL_SUCCESS = makeConstant('ENROLL_SUCCESS');

var UNENROLL = makeConstant('UNENROLL');
var UNENROLL_PENDING = makeConstant('UNENROLL_PENDING');
var UNENROLL_FAILED = makeConstant('UNENROLL_FAILED');
var UNENROLL_SUCCESS = makeConstant('UNENROLL_SUCCESS');

var NOTIFY = makeConstant('NOTIFY');
var NOTIFY_PENDING = makeConstant('NOTIFY_PENDING');
var NOTIFY_FAILED = makeConstant('NOTIFY_FAILED');
var NOTIFY_SUCCESS = makeConstant('NOTIFY_SUCCESS');

var FETCH_PLAYBOOKS_BY_IDS = makeConstant('FETCH_PLAYBOOKS_BY_IDS');
var FETCH_PLAYBOOKS_BY_IDS_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_IDS_SUCCESS');
var FETCH_PLAYBOOKS_BY_IDS_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_IDS_PENDING');
var FETCH_PLAYBOOKS_BY_IDS_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_IDS_FAILED');

var FETCH_ENROLLED_PLAYBOOK_ID = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID');
var FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS');
var FETCH_ENROLLED_PLAYBOOK_ID_PENDING = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_PENDING');
var FETCH_ENROLLED_PLAYBOOK_ID_FAILED = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_FAILED');

var FETCH_ENROLLED_SEQUENCE_COUNT = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT');
var FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS');
var FETCH_ENROLLED_SEQUENCE_COUNT_PENDING = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_PENDING');
var FETCH_ENROLLED_SEQUENCE_COUNT_FAILED = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_FAILED');

var FETCH_PLAYBOOK_FOR_END_USER = makeConstant('FETCH_PLAYBOOK_FOR_END_USER');
var FETCH_PLAYBOOK_FOR_END_USER_SUCCESS = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_SUCCESS');
var FETCH_PLAYBOOK_FOR_END_USER_PENDING = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_PENDING');
var FETCH_PLAYBOOK_FOR_END_USER_FAILED = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_FAILED');

var SET_PLAYBOOK_FOR_END_USER_SUBJECT = makeConstant('SET_PLAYBOOK_FOR_END_USER_SUBJECT');
var SET_PLAYBOOK_FOR_END_USER_MESSAGE = makeConstant('SET_PLAYBOOK_FOR_END_USER_MESSAGE');
var SET_PLAYBOOK_FOR_END_USER_DELAY = makeConstant('SET_PLAYBOOK_FOR_END_USER_DELAY');

var CLEAR_EMAIL_BANNER = makeConstant('CLEAR_EMAIL_BANNER');
var SET_EMAIL_BANNER = makeConstant('SET_EMAIL_BANNER');
var SET_EMAIL_BANNER_PENDING = makeConstant('SET_EMAIL_BANNER_PENDING');
var SET_EMAIL_BANNER_SUCCESS = makeConstant('SET_EMAIL_BANNER_SUCCESS');
var SET_EMAIL_BANNER_FAILED = makeConstant('SET_EMAIL_BANNER_FAILED');

var CLEAR_ENROLL_MODAL_STATE = makeConstant('CLEAR_ENROLL_MODAL_STATE');

var SET_MARKETING_EMAIL_LAYOUT = makeConstant('SET_MARKETING_EMAIL_LAYOUT');

var FETCH_PLAYBOOKS_BY_GATED_PLAN = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN');
var FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING');
var FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED');
var FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS');
var FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED');

var SET_END_USER_EMAIL = makeConstant('SET_END_USER_EMAIL');

var ASYNC_BUTTON_PRESS = makeConstant('ASYNC_BUTTON_PRESS');
var ASYNC_BUTTON_PRESS_PENDING = makeConstant('ASYNC_BUTTON_PRESS_PENDING');
var ASYNC_BUTTON_PRESS_FAILED = makeConstant('ASYNC_BUTTON_PRESS_FAILED');
var ASYNC_BUTTON_PRESS_SUCCESS = makeConstant('ASYNC_BUTTON_PRESS_SUCCESS');
var ASYNC_BUTTON_PRESS_CANCELLED = makeConstant('ASYNC_BUTTON_PRESS_CANCELLED');

var SET_EDIT_SENDER_LEVEL = makeConstant('SET_EDIT_SENDER_LEVEL');

var SET_SIGNATURE_BODY = makeConstant('SET_SIGNATURE_BODY');
var SET_SIGNATURE_INCLUDE_AVATAR = makeConstant('SET_SIGNATURE_INCLUDE_AVATAR');
var SET_SIGNATURE_INCLUDE_SOCIAL = makeConstant('SET_SIGNATURE_INCLUDE_SOCIAL');
var SET_SIGNATURE_INCLUDE_BANNER = makeConstant('SET_SIGNATURE_INCLUDE_BANNER');
var SET_SIGNATURE_BANNER_IMG_URL = makeConstant('SET_SIGNATURE_BANNER_IMG_URL');
var SET_SIGNATURE_BANNER_LINK_URL = makeConstant('SET_SIGNATURE_BANNER_LINK_URL');

var SET_VIEWING_SIGNATURE_ID = makeConstant('SET_VIEWING_SIGNATURE_ID');
var ADD_NEW_SIGNATURE_TO_PLAYBOOK = makeConstant('ADD_NEW_SIGNATURE_TO_PLAYBOOK');
var REMOVE_SIGNATURE = makeConstant('REMOVE_SIGNATURE');
var ADD_EMPTY_BANNER_SIGNATURE = makeConstant('ADD_EMPTY_BANNER_SIGNATURE');
var REMOVE_EMPTY_BANNER_SIGNATURE = makeConstant('REMOVE_EMPTY_BANNER_SIGNATURE');

var CLEAR_SIGNATURE_BANNER = makeConstant('CLEAR_SIGNATURE_BANNER');
var SET_SIGNATURE_BANNER = makeConstant('SET_SIGNATURE_BANNER');
var SET_SIGNATURE_BANNER_PENDING = makeConstant('SET_SIGNATURE_BANNER_PENDING');
var SET_SIGNATURE_BANNER_FAILED = makeConstant('SET_SIGNATURE_BANNER_FAILED');
var SET_SIGNATURE_BANNER_SUCCESS = makeConstant('SET_SIGNATURE_BANNER_SUCCESS');
var SET_SIGNATURE_BANNER_CANCELLED = makeConstant('SET_SIGNATURE_BANNER_CANCELLED');

var FETCH_SIGNATURE_MULTI_BANNER_PREVIEW = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW');
var FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING');
var FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED');
var FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS');
var FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED');

var FETCH_SIGNATURE_PLAYBOOK_PREVIEW = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW');
var FETCH_SIGNATURE_PLAYBOOK_PREVIEW_PENDING = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_PENDING');
var FETCH_SIGNATURE_PLAYBOOK_PREVIEW_FAILED = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_FAILED');
var FETCH_SIGNATURE_PLAYBOOK_PREVIEW_SUCCESS = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_SUCCESS');
var FETCH_SIGNATURE_PLAYBOOK_PREVIEW_CANCELLED = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_CANCELLED');

var CREATE_INITIAL_WELCOME_PLAYBOOKS = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS');
var CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING');
var CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED');
var CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS');
var CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED');

var FETCH_PLAYBOOK_FOR_CAMPAIGN_ID = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID');
var FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING');
var FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED');
var FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS');
var FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED');

var FETCH_CHAT_ACTIVE_PLAYBOOKS = makeConstant('FETCH_CHAT_ACTIVE_PLAYBOOKS');
var START_REPORT_TIMER = makeConstant('START_REPORT_TIMER');
var INCREMENT_REPORT_TIMER = makeConstant('INCREMENT_REPORT_TIMER');
var DECREMENT_REPORT_TIMER = makeConstant('DECREMENT_REPORT_TIMER');
var RECORDED_REPORT_TIMER = makeConstant('RECORDED_REPORT_TIMER');

// this is for UI filtering
var PlaybookStatus = Object.freeze({
  ACTIVE: 'ACTIVE', // rollup of enabled & disabled, WIP
  EMAIL: 'EMAIL', // rollup of email, sent, and sequences
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  ARCHIVED: 'ARCHIVED',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  DELETED: 'DELETED'
});

var EditSenderLevels = Object.freeze({
  GLOBAL: 'global', // edit the sender over the whole playbook
  LOCAL: 'local' // edit the sender over each email
});

var EmailPreviewView = {
  TEMPLATE: 'template',
  DEFAULTS: 'defaults',
  RENDERED_DATA: 'renderedData'
};

var AudienceType = Object.freeze({
  SEGMENT: 'SEGMENT',
  VISITORS: 'VISITORS',
  USERS: 'USERS',
  EVERYONE: 'EVERYONE',
  NONE: 'NONE'
});

var AudienceDisplay = Object.freeze({
  SEGMENT: 'Segment(s)',
  VISITORS: 'Visitors',
  USERS: 'Known Users',
  EVERYONE: 'Everyone',
  NONE: 'None'
});

var PlaybooksFrequency = Object.freeze({
  ONCE: 'ONCE',
  SESSION: 'ONCE_PER_SESSION',
  ALWAYS: 'ALWAYS'
});

var AudienceIcons = Object.freeze({
  VISITORS: __WEBPACK_IMPORTED_MODULE_18__svg_inline_removeTags_true_images_svg_site_visitors_svg___default.a,
  USERS: __WEBPACK_IMPORTED_MODULE_17__svg_inline_removeTags_true_images_svg_known_users_svg___default.a
});

var TargetingDisplay = Object.freeze({
  ALWAYS: 'Always',
  NONE: '#DriftLink only'
});

var SmartFilterValues = Object.freeze({
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE'
});

var PlaybookReportType = Object.freeze({
  BOOK_MORE_MEETINGS: 'BOOK_MORE_MEETINGS',
  MORE_QUALIFIED_CONVERSATIONS: 'MORE_QUALIFIED_CONVERSATIONS',
  MORE_SALES_CONVERSATIONS: 'MORE_SALES_CONVERSATIONS',
  DRIVE_TRAFFIC_TARGETED_MESSAGE: 'DRIVE_TRAFFIC_TARGETED_MESSAGE',
  PROMOTION_FULL_SCREEN_TAKEOVER: 'PROMOTION_FULL_SCREEN_TAKEOVER',
  SEND_AN_AUTOMATED_EMAIL: 'SEND_AN_AUTOMATED_EMAIL',
  SEND_A_ONETIME_EMAIL: 'SEND_A_ONETIME_EMAIL',
  TALK_TO_YOUR_OUTBOUND_PROSPECTS: 'TALK_TO_YOUR_OUTBOUND_PROSPECTS',
  BUILD_A_SUBSCRIBER_LIST: 'BUILD_A_SUBSCRIBER_LIST',
  EMPTY_LEADBOT: 'EMPTY_LEADBOT',
  EMPTY_SLIDER: 'EMPTY_SLIDER',
  EMPTY_TAKEOVER: 'EMPTY_TAKEOVER',
  EMPTY_WELCOME_MESSAGE: 'EMPTY_WELCOME_MESSAGE',
  NPS_BOT: 'NPS_BOT',
  ABM: 'ABM',
  OUTBOUND_SEQUENCE: 'OUTBOUND_SEQUENCE',
  MARKETING_SEQUENCE: 'MARKETING_SEQUENCE',
  MARKETING_ONE_TIME_SEQUENCE: 'MARKETING_ONE_TIME_SEQUENCE',
  BLOG_NURTURE: 'BLOG_NURTURE',
  NEW_BLOG_CONTENT: 'NEW_BLOG_CONTENT',
  NEWSLETTER: 'NEWSLETTER',
  PRODUCT_ANNOUNCEMENT: 'PRODUCT_ANNOUNCEMENT',
  ABANDONED_BOOK_A_MEETING: 'ABANDONED_BOOK_A_MEETING',
  SIGNATURE: 'SIGNATURE',
  LANDING_PAGE_LEADBOT: 'LANDING_PAGE_LEADBOT',
  VSB_DEFAULT_PLAYBOOK: 'VSB_DEFAULT_PLAYBOOK',
  CONVERSATION_STARTER_BOT: 'CONVERSATION_STARTER_BOT',
  RETARGETING_BOT: 'RETARGETING_BOT',
  PRICING_PAGE_BOT: 'PRICING_PAGE_BOT',
  SECOND_NET_BOT: 'SECOND_NET_BOT',
  ABM_HOMEPAGE_BOT: 'ABM_HOMEPAGE_BOT',
  PAID_TRAFFIC_BOT: 'PAID_TRAFFIC_BOT',
  FORM_REPLACER_CLP: 'FORM_REPLACER_CLP',
  CONVO_CONTENT_CLP: 'CONVO_CONTENT_CLP',
  ENTERPRISE_BOT: 'ENTERPRISE_BOT'
});

var chatPlaybookReportTypes = [PlaybookReportType.BOOK_MORE_MEETINGS, PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS, PlaybookReportType.MORE_SALES_CONVERSATIONS, PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE, PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER, PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS, PlaybookReportType.BUILD_A_SUBSCRIBER_LIST, PlaybookReportType.EMPTY_LEADBOT, PlaybookReportType.ENTERPRISE_BOT, PlaybookReportType.EMPTY_SLIDER, PlaybookReportType.EMPTY_TAKEOVER, PlaybookReportType.EMPTY_WELCOME_MESSAGE, PlaybookReportType.NPS_BOT, PlaybookReportType.ABM, PlaybookReportType.LANDING_PAGE_LEADBOT, PlaybookReportType.VSB_DEFAULT_PLAYBOOK, PlaybookReportType.CONVERSATION_STARTER_BOT, PlaybookReportType.RETARGETING_BOT, PlaybookReportType.PRICING_PAGE_BOT, PlaybookReportType.SECOND_NET_BOT, PlaybookReportType.ABM_HOMEPAGE_BOT, PlaybookReportType.PAID_TRAFFIC_BOT, PlaybookReportType.FORM_REPLACER_CLP, PlaybookReportType.CONVO_CONTENT_CLP];

var landingPagePlaybookReportTypes = [PlaybookReportType.LANDING_PAGE_LEADBOT, PlaybookReportType.FORM_REPLACER_CLP, PlaybookReportType.CONVO_CONTENT_CLP];

var botPlaybookReportTypes = [PlaybookReportType.BOOK_MORE_MEETINGS, PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS, PlaybookReportType.EMPTY_LEADBOT, PlaybookReportType.ENTERPRISE_BOT, PlaybookReportType.NPS_BOT, PlaybookReportType.LANDING_PAGE_LEADBOT, PlaybookReportType.VSB_DEFAULT_PLAYBOOK, PlaybookReportType.CONVERSATION_STARTER_BOT, PlaybookReportType.RETARGETING_BOT, PlaybookReportType.PRICING_PAGE_BOT, PlaybookReportType.SECOND_NET_BOT, PlaybookReportType.ABM_HOMEPAGE_BOT, PlaybookReportType.PAID_TRAFFIC_BOT, PlaybookReportType.FORM_REPLACER_CLP, PlaybookReportType.CONVO_CONTENT_CLP];

var isLandingPagePlaybook = function isLandingPagePlaybook(reportType) {
  return landingPagePlaybookReportTypes.includes(reportType);
};

var isNonLandingPageBotPlaybook = function isNonLandingPageBotPlaybook(reportType) {
  return botPlaybookReportTypes.includes(reportType) && !landingPagePlaybookReportTypes.includes(reportType);
};

var isLeadBotPlaybook = function isLeadBotPlaybook(reportType) {
  return botPlaybookReportTypes.includes(reportType);
};

var isEmailPlaybook = function isEmailPlaybook(reportType) {
  return reportType === PlaybookReportType.SEND_AN_AUTOMATED_EMAIL || reportType === PlaybookReportType.SEND_A_ONETIME_EMAIL || reportType === PlaybookReportType.SEND_A_ONETIME_OUTBOUND_EMAIL || reportType === PlaybookReportType.OUTBOUND_SEQUENCE || reportType === PlaybookReportType.MARKETING_SEQUENCE || reportType === PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE || reportType === PlaybookReportType.BLOG_NURTURE || reportType === PlaybookReportType.NEW_BLOG_CONTENT || reportType === PlaybookReportType.NEWSLETTER || reportType === PlaybookReportType.PRODUCT_ANNOUNCEMENT || reportType === PlaybookReportType.ABANDONED_BOOK_A_MEETING || reportType === PlaybookReportType.VSB_DEFAULT_PLAYBOOK;
};

var isOneTimeEmailPlaybook = function isOneTimeEmailPlaybook(reportType) {
  return reportType === PlaybookReportType.SEND_A_ONETIME_EMAIL || reportType === PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE || reportType === PlaybookReportType.NEW_BLOG_CONTENT || reportType === PlaybookReportType.NEWSLETTER || reportType === PlaybookReportType.PRODUCT_ANNOUNCEMENT;
};

var isSignaturePlaybook = function isSignaturePlaybook(reportType) {
  return reportType === PlaybookReportType.SIGNATURE;
};

var isSalesSequencePlaybook = function isSalesSequencePlaybook(reportType) {
  return reportType === PlaybookReportType.OUTBOUND_SEQUENCE;
};

var ReportTypeToTableName = Object.freeze((_Object$freeze = {}, _defineProperty(_Object$freeze, PlaybookReportType.BLOG_NURTURE, 'Triggered email'), _defineProperty(_Object$freeze, PlaybookReportType.MARKETING_SEQUENCE, 'Triggered email'), _defineProperty(_Object$freeze, PlaybookReportType.SEND_AN_AUTOMATED_EMAIL, 'Triggered email'), _defineProperty(_Object$freeze, PlaybookReportType.ABANDONED_BOOK_A_MEETING, 'Triggered email'), _defineProperty(_Object$freeze, PlaybookReportType.NEWSLETTER, 'One-time email'), _defineProperty(_Object$freeze, PlaybookReportType.NEW_BLOG_CONTENT, 'One-time email'), _defineProperty(_Object$freeze, PlaybookReportType.PRODUCT_ANNOUNCEMENT, 'One-time email'), _defineProperty(_Object$freeze, PlaybookReportType.SEND_A_ONETIME_EMAIL, 'One-time email'), _defineProperty(_Object$freeze, PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE, 'One-time email'), _defineProperty(_Object$freeze, PlaybookReportType.OUTBOUND_SEQUENCE, 'Sales email sequence'), _defineProperty(_Object$freeze, PlaybookReportType.NPS_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.EMPTY_LEADBOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.ENTERPRISE_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.BOOK_MORE_MEETINGS, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.LANDING_PAGE_LEADBOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.VSB_DEFAULT_PLAYBOOK, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.BUILD_A_SUBSCRIBER_LIST, 'Email capture'), _defineProperty(_Object$freeze, PlaybookReportType.ABM, 'Live chat'), _defineProperty(_Object$freeze, PlaybookReportType.EMPTY_WELCOME_MESSAGE, 'Live chat'), _defineProperty(_Object$freeze, PlaybookReportType.MORE_SALES_CONVERSATIONS, 'Live chat'), _defineProperty(_Object$freeze, PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS, 'Live chat'), _defineProperty(_Object$freeze, PlaybookReportType.EMPTY_SLIDER, 'Slider'), _defineProperty(_Object$freeze, PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE, 'Slider'), _defineProperty(_Object$freeze, PlaybookReportType.EMPTY_TAKEOVER, 'Takeover'), _defineProperty(_Object$freeze, PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER, 'Takeover'), _defineProperty(_Object$freeze, PlaybookReportType.CONVERSATION_STARTER_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.RETARGETING_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.PRICING_PAGE_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.SECOND_NET_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.ABM_HOMEPAGE_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.PAID_TRAFFIC_BOT, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.FORM_REPLACER_CLP, 'Bot'), _defineProperty(_Object$freeze, PlaybookReportType.CONVO_CONTENT_CLP, 'Bot'), _Object$freeze));

var CtaTypes = Object.freeze({
  CHAT: 'CHAT_RESPONSE',
  URL: 'URL_LINK',
  MEETING: 'SCHEDULE_MEETING',
  NONE: 'NONE'
});

var CtaGoalTypes = Object.freeze({
  CHAT_RESPONSE: 'conversation_started',
  URL_LINK: 'clicked',
  SCHEDULE_MEETING: 'conversation_started',
  NONE: 'none'
});

var MarketingEmailLayouts = Object.freeze({
  SIMPLE: 'SIMPLE',
  WITH_COMPANY_LOGO: 'WITH_COMPANY_LOGO',
  WITH_HERO_IMAGE: 'WITH_HERO_IMAGE'
});

var MarketingEmailSubTypes = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  ONE_TIME: 'ONE_TIME'
});

var ActionViewConfig = Object.freeze({
  CQL: 'CQL'
});

var CtaViewConfig = Object.freeze({
  CHAT_RESPONSE: {
    placeholder: 'Type your message...',
    showCopy: true,
    showUrl: false
  },
  URL_LINK: {
    placeholderUrl: 'https://drift.com',
    placeholder: 'Learn More',
    showCopy: true,
    showUrl: true
  },
  SCHEDULE_MEETING: {
    placeholder: 'Schedule a Meeting',
    requiredGates: [__WEBPACK_IMPORTED_MODULE_2_utils_Access__["b" /* Gates */].PREMIUM_ENTERPRISE],
    showUrl: false,
    showCopy: true
  },
  NONE: {
    showCopy: false,
    showUrl: false
  }
});

var EmailThemeType = Object.freeze({
  SIMPLE: 'SIMPLE',
  STYLED: 'STYLED'
});

var PlaybookDefaultEditViewOptions = Object.freeze({
  MESSAGE: 'message',
  SEQUENCE: 'sequence'
});

var emailSendModes = Object.freeze({
  NOW: 'NOW',
  SCHEDULED: 'SCHEDULED'
});

var PlaybookViewConfig = Object.freeze((_Object$freeze2 = {}, _defineProperty(_Object$freeze2, PlaybookReportType.BOOK_MORE_MEETINGS, {}), _defineProperty(_Object$freeze2, PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS, {}), _defineProperty(_Object$freeze2, PlaybookReportType.LANDING_PAGE_LEADBOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.VSB_DEFAULT_PLAYBOOK, {}), _defineProperty(_Object$freeze2, PlaybookReportType.EMPTY_LEADBOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.ENTERPRISE_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.NPS_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.MORE_SALES_CONVERSATIONS, {
  messageUrlPath: 'welcome',
  label: 'Live chat',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.EMPTY_WELCOME_MESSAGE, {
  messageUrlPath: 'welcome',
  label: 'Live chat',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE, {
  messageUrlPath: 'targeted',
  label: 'Announcement',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.EMPTY_SLIDER, {
  messageUrlPath: 'targeted',
  label: 'Announcement',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER, {
  messageUrlPath: 'takeover',
  label: 'Announcement',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.EMPTY_TAKEOVER, {
  messageUrlPath: 'takeover',
  label: 'Announcement',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.SEND_A_ONETIME_EMAIL, {
  messageUrlPath: 'email',
  previewUrlPath: 'email-preview',
  label: 'Email',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.SEND_AN_AUTOMATED_EMAIL, {
  messageUrlPath: 'email',
  previewUrlPath: 'email-preview',
  label: 'Email',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS, {
  messageUrlPath: 'welcome',
  label: 'Live chat',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.BUILD_A_SUBSCRIBER_LIST, {
  messageUrlPath: 'capture',
  label: 'Email Capture',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.ABM, {
  messageUrlPath: 'welcome',
  label: 'Live chat',
  default: PlaybookDefaultEditViewOptions.MESSAGE
}), _defineProperty(_Object$freeze2, PlaybookReportType.OUTBOUND_SEQUENCE, {}), _defineProperty(_Object$freeze2, PlaybookReportType.MARKETING_SEQUENCE, {}), _defineProperty(_Object$freeze2, PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE, {}), _defineProperty(_Object$freeze2, PlaybookReportType.BLOG_NURTURE, {}), _defineProperty(_Object$freeze2, PlaybookReportType.NEW_BLOG_CONTENT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.NEWSLETTER, {}), _defineProperty(_Object$freeze2, PlaybookReportType.PRODUCT_ANNOUNCEMENT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.ABANDONED_BOOK_A_MEETING, {}), _defineProperty(_Object$freeze2, PlaybookReportType.CONVERSATION_STARTER_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.RETARGETING_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.PRICING_PAGE_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.SECOND_NET_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.ABM_HOMEPAGE_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.PAID_TRAFFIC_BOT, {}), _defineProperty(_Object$freeze2, PlaybookReportType.FORM_REPLACER_CLP, {}), _Object$freeze2));

var playbooksCopyDefaults = Object.freeze({
  GOALS: 'Goals can be used to qualify (or dis-qualify) people who interact with this bot so your team can focus on only the best leads. Routing will kick in once a lead reaches this goal.',
  REVIEW: 'Once you turn this on, the LeadBot will start booking meetings and qualifying your leads for you, even in your sleep.'
});

var playbooksCopy = Object.freeze({
  BOOK_MORE_MEETINGS: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  MORE_QUALIFIED_CONVERSATIONS: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  VSB_DEFAULT_PLAYBOOK: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  LANDING_PAGE_LEADBOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  MORE_SALES_CONVERSATIONS: {
    goals: "For this playbook, there is only one goal...to have conversations! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: 'Once you turn this on, your playbook will start showing up on your pricing page (unless you changed the defaults) and help you have more sales conversations.'
  },
  DRIVE_TRAFFIC_TARGETED_MESSAGE: {
    goals: "For this playbook, there is only one goal...to drive traffic! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive traffic to whatever URL you've set as the CTA."
  },
  PROMOTION_FULL_SCREEN_TAKEOVER: {
    goals: "For this playbook, there is only one goal...to promote something! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive interest in whatever you're promoting."
  },
  NPS_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  EMPTY_LEADBOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  ENTERPRISE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  EMPTY_WELCOME_MESSAGE: {
    goals: "For this playbook, there is only one goal...to have conversations! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: 'Once you turn this on, your playbook will start showing up on your pricing page (unless you changed the defaults) and help you have more sales conversations.'
  },
  EMPTY_SLIDER: {
    goals: "For this playbook, there is only one goal...to drive traffic! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive traffic to whatever URL you've set as the CTA."
  },
  EMPTY_TAKEOVER: {
    goals: "For this playbook, there is only one goal...to promote something! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review: "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive interest in whatever you're promoting."
  },
  TALK_TO_YOUR_OUTBOUND_PROSPECTS: {
    goals: playbooksCopyDefaults.GOALS,
    review: "Once you turn this on, you’ll start automatically greeting prospects you email from Drift Sequences or the Drift Extension with a personalized message! Have more conversations <b><i>now.</i></b>"
  },
  ABM: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  SEND_AN_AUTOMATED_EMAIL: {
    goals: 'For this Playbook, there’s only one goal…to send an email and get people to engage with the links you added (CTAs). This goal is pre-set for you and you can change the lead stage name',
    review: 'Once you turn this on, your playbook will email everyone in the segment you chose. If anybody is added to that segment, they’ll also automatically get emailed.'
  },
  SEND_A_ONETIME_EMAIL: {
    goals: 'For this Playbook, there’s only one goal…to send an email and get people to engage with the links you added (CTAs). This goal is pre-set for you and you can change the lead stage name',
    review: 'Once you turn this on, your playbook will email everyone in the segment you chose.'
  },
  BUILD_A_SUBSCRIBER_LIST: {
    goals: 'For this playbook, there is only one goal...to capture an email! This goal is pre-set for you and you can change the lead stage name if you’d like.',
    review: 'Once you turn this on, your playbook will start showing up on your blog page (unless you changed the defaults) and help you build a blog subscriber list.'
  },
  OUTBOUND_SEQUENCE: {
    review: 'Once your sequence is ready to go and enabled, you can start enrolling contacts!'
  },
  MARKETING_ONE_TIME_SEQUENCE: {
    review: 'Once you turn this on, your playbook will email everyone in your chosen segment(s).'
  },
  MARKETING_SEQUENCE: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  BLOG_NURTURE: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  NEW_BLOG_CONTENT: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  NEWSLETTER: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  ABANDONED_BOOK_A_MEETING: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  PRODUCT_ANNOUNCEMENT: {
    review: 'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.'
  },
  CONVERSATION_STARTER_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  RETARGETING_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  PRICING_PAGE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  SECOND_NET_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  ABM_HOMEPAGE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  PAID_TRAFFIC_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  FORM_REPLACER_CLP: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  },
  CONVO_CONTENT_CLP: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW
  }
});

var RoutingType = Object.freeze({
  GLOBAL: 'GLOBAL',
  SINGLE: 'SINGLE',
  GROUP: 'GROUP',
  NONE: null
});

var END_CONVERSATION = 'END_CONVERSATION';

var END_CONVERSATION_OPTION = {
  value: {
    id: END_CONVERSATION,
    isGoal: false
  },
  label: 'End conversation'
};

var PROCEED_OPTION = {
  value: {
    id: null,
    isGoal: false
  },
  label: 'Proceed to next question'
};

var AnswerType = Object.freeze({
  KEYWORDS: 'KEYWORDS',
  BUTTON: 'BUTTON',
  VALIDATE: 'VALIDATE'
});

var ValidationType = Object.freeze({
  EMAIL: 'EMAIL',
  PHONE: 'PHONE'
});

var KeywordType = Object.freeze({
  EQUALS: 'EQUALS',
  FUZZY: 'FUZZY',
  CONTAINS: 'CONTAINS'
});

var StateOptions = _.map(__WEBPACK_IMPORTED_MODULE_11_constants_UspsStates__["a" /* UspsCodesToStateName */], function (label) {
  return { value: label, label: label };
});
var CountryOptions = _.map(__WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */], function (label, value) {
  return { value: value, label: label };
});
var CountryNameOptions = _.map(__WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */], function (label, value) {
  return { label: label, value: label };
});

var OperatorType = {
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  IS: 'is',
  NOT_IS: 'notIs',
  IS_ANY_OF: 'isAnyOf',
  NOT_IS_ANY_OF: 'notIsAnyOf',
  INCLUDES_ANY_OF: 'includesAnyOf',
  NOT_INCLUDES_ANY_OF: 'notIncludesAnyOf',
  IS_AVAILABLE: 'isAvailable',
  IS_NOT_AVAILABLE: 'isNotAvailable',
  IS_MATCH: 'isMatch',
  IS_IN_WATCHLIST: 'isInWatchlist',
  NOT_IS_IN_WATCHLIST: 'notIsInWatchlist',
  IS_WATCHLIST_VALUE_NULL: 'isWatchlistValueNull',
  NOT_IS_WATCHLIST_VALUE_NULL: 'notIsWatchlistValueNull'
};

var OperatorToDisplay = (_OperatorToDisplay = {}, _defineProperty(_OperatorToDisplay, OperatorType.GREATER_THAN, 'greater than'), _defineProperty(_OperatorToDisplay, OperatorType.LESS_THAN, 'less than'), _defineProperty(_OperatorToDisplay, OperatorType.IS, 'is'), _defineProperty(_OperatorToDisplay, OperatorType.NOT_IS, 'is not'), _defineProperty(_OperatorToDisplay, OperatorType.IS_ANY_OF, 'is'), _defineProperty(_OperatorToDisplay, OperatorType.NOT_IS_ANY_OF, 'is not'), _defineProperty(_OperatorToDisplay, OperatorType.INCLUDES_ANY_OF, 'includes'), _defineProperty(_OperatorToDisplay, OperatorType.NOT_INCLUDES_ANY_OF, 'does not include'), _defineProperty(_OperatorToDisplay, OperatorType.IS_AVAILABLE, 'is online'), _defineProperty(_OperatorToDisplay, OperatorType.IS_NOT_AVAILABLE, 'is offline'), _defineProperty(_OperatorToDisplay, OperatorType.IS_MATCH, 'matches (regex)'), _defineProperty(_OperatorToDisplay, OperatorType.IS_IN_WATCHLIST, 'has key:value'), _defineProperty(_OperatorToDisplay, OperatorType.NOT_IS_IN_WATCHLIST, 'does not have key:value'), _defineProperty(_OperatorToDisplay, OperatorType.IS_WATCHLIST_VALUE_NULL, 'has a null value'), _defineProperty(_OperatorToDisplay, OperatorType.NOT_IS_WATCHLIST_VALUE_NULL, 'does not have a null value'), _OperatorToDisplay);

var ConditionType = {
  TEAM_AVAILABILITY: 'teamAvailability',
  OUTBOUND_SESSION: 'outboundSession',
  OUTBOUND_REP: 'autoAssigneeId',
  COUNTRY: 'geoCountryCode',
  STATE: 'geoState',
  IP_ADDRESS: 'geoIp',
  DEVICE: 'device',
  SITE_VISITS: 'siteVisits',
  DAYS_SINCE_LAST_VISIT: 'daysSinceLastVisit',
  URL: 'url',
  URL_PATH: 'urlPath',
  URL_HOST: 'urlHost',
  URL_QUERY: 'urlQuery',
  COOKIE: 'cookie',
  SCROLL_PERCENTAGE: 'scrollPct',
  SECONDS_ON_PAGE: 'secondsOnPage',
  SECONDS_ON_SITE: 'secondsOnSite',
  REFERRER: 'referrer',
  WIDGET_STATUS: 'online',
  SEGMENT: 'segment',
  EXIT_INTENT: 'exitIntent',
  CLEARBIT_NAME: 'clearbit_name',
  CLEARBIT_DOMAIN: 'clearbit_domain',
  CLEARBIT_REVENUE: 'clearbit_revenue',
  CLEARBIT_TAGS: 'clearbit_tags',
  CLEARBIT_TECH: 'clearbit_tech',
  CLEARBIT_EMPLOYEES: 'clearbit_employees',
  CLEARBIT_RAISED: 'clearbit_raised',
  CLEARBIT_ALEXA_US: 'clearbit_alexa_us',
  CLEARBIT_ALEXA_GLOBAL: 'clearbit_alexa_global',
  CLEARBIT_HEADQUARTERS_STATE: 'clearbit_state',
  CLEARBIT_HEADQUARTERS_COUNTRY: 'clearbit_country',
  CLEARBIT_HEADQUARTERS_POSTAL_CODE: 'clearbit_postal_code',
  DEMANDBASE_AUDIENCE: 'demandbase_audience',
  DEMANDBASE_WATCHLIST: 'demandbase_watchlist',
  DEMANDBASE_COMPANY_NAME: 'demandbase_company_name',
  DEMANDBASE_INDUSTRY: 'demandbase_industry',
  DEMANDBASE_EMPLOYEE_COUNT: 'demandbase_employee_count',
  DEMANDBASE_EMPLOYEE_RANGE: 'demandbase_employee_range',
  DEMANDBASE_CITY: 'demandbase_city',
  DEMANDBASE_STATE: 'demandbase_state',
  DEMANDBASE_COUNTRY_CODE: 'demandbase_country_code',
  DEMANDBASE_MARKETING_ALIAS: 'demandbase_marketing_alias',
  DEMANDBASE_SUB_INDUSTRY: 'demandbase_sub_industry',
  DEMANDBASE_ANNUAL_SALES: 'demandbase_annual_sales',
  DEMANDBASE_REVENUE_RANGE: 'demandbase_revenue_range',
  DEMANDBASE_COUNTRY_NAME: 'demandbase_country_name',
  MADKUDU_SCORE: 'madkudu_score',
  TARGET_ACCOUNT: 'targetAccount',
  EMAIL_PLAYBOOK: 'email_playbook'
};

var DeviceOptions = [{ value: 'mobile', label: 'mobile' }, { value: 'tablet', label: 'tablet' }, { value: 'desktop', label: 'desktop' }];

var MadkuduScoreOptions = [{ label: 'Very Good', value: 'very good' }, { label: 'Good', value: 'good' }, { label: 'Medium', value: 'medium' }, { label: 'Low', value: 'low' }];

var MadkuduLabelMap = (_MadkuduLabelMap = {}, _defineProperty(_MadkuduLabelMap, 'very good', 'Very Good'), _defineProperty(_MadkuduLabelMap, 'good', 'Good'), _defineProperty(_MadkuduLabelMap, 'medium', 'OK'), _defineProperty(_MadkuduLabelMap, 'low', 'Poor'), _MadkuduLabelMap);
var MadkuduSignalMap = (_MadkuduSignalMap = {}, _defineProperty(_MadkuduSignalMap, 'personal email address', 'Personal Email'), _defineProperty(_MadkuduSignalMap, 'spam', 'Spam'), _defineProperty(_MadkuduSignalMap, 'fortune 500', 'Fortune 500'), _defineProperty(_MadkuduSignalMap, 'firmographics profile', 'Firmographics Profile'), _defineProperty(_MadkuduSignalMap, 'potentially spam', 'Spam (potential)'), _defineProperty(_MadkuduSignalMap, 'education', 'Education'), _defineProperty(_MadkuduSignalMap, 'employee count', 'Employee Count'), _defineProperty(_MadkuduSignalMap, 'number of employees', 'Number of Employees'), _defineProperty(_MadkuduSignalMap, 'team email', 'Team Email'), _defineProperty(_MadkuduSignalMap, 'nonprofit', 'Non-Profit'), _defineProperty(_MadkuduSignalMap, 'test email', 'Test Email'), _defineProperty(_MadkuduSignalMap, 'market cap', 'Market Cap'), _defineProperty(_MadkuduSignalMap, 'capital raised', 'Capital Raised'), _defineProperty(_MadkuduSignalMap, 'web traffic volume', 'Web Traffic Volume'), _defineProperty(_MadkuduSignalMap, 'based in a country where gdp per capita', 'Country GDP per Capita'), _defineProperty(_MadkuduSignalMap, 'enterprise tech found on website', 'Enterprise Tech on Web Site'), _defineProperty(_MadkuduSignalMap, 'belongs to industry where revenue per employee', 'Industrial Revenue per Employee'), _defineProperty(_MadkuduSignalMap, 'number of tech found on website', 'Tech on Web Site'), _defineProperty(_MadkuduSignalMap, 'twitter followers', 'Twitter Followers'), _defineProperty(_MadkuduSignalMap, 'company founding year', 'Company Founding Year'), _defineProperty(_MadkuduSignalMap, 'Company size', 'Company size is'), _MadkuduSignalMap);

var BooleanOptions = [{ value: true, label: 'true' }, { value: false, label: 'false' }];

var ClearbitTagsOptions = __WEBPACK_IMPORTED_MODULE_8_constants_ClearbitTags__["a" /* default */].map(function (tag) {
  return { value: tag, label: tag };
});

var ClearbitRevenueOptions = __WEBPACK_IMPORTED_MODULE_10_constants_ClearbitRevenueRanges__["a" /* default */].map(function (range) {
  return { value: range, label: range };
});

var DemandbaseEmployeeRangeOptions = __WEBPACK_IMPORTED_MODULE_15_constants_DemandbaseEmployeeRanges__["a" /* default */].map(function (value) {
  return { label: value, value: value };
});
var DemandbaseRevenueRangeOptions = __WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseRevenueRanges__["a" /* default */].map(function (value) {
  return { label: value, value: value };
});

var ConditionCategory = Object.freeze({
  URL: 'URL',
  EMAIL_PLAYBOOK: 'EMAIL_PLAYBOOK',
  BROWSER: 'BROWSER',
  GEOGRAPHY: 'GEOGRAPHY',
  ENRICHMENT: 'ENRICHMENT',
  DRIFT: 'DRIFT',
  SEGMENT: 'SEGMENT'
});

var ConditionCategoryToDisplay = Object.freeze((_Object$freeze3 = {}, _defineProperty(_Object$freeze3, ConditionCategory.URL, 'URL'), _defineProperty(_Object$freeze3, ConditionCategory.EMAIL_PLAYBOOK, 'Came from email playbook'), _defineProperty(_Object$freeze3, ConditionCategory.BROWSER, 'Website Behavior'), _defineProperty(_Object$freeze3, ConditionCategory.GEOGRAPHY, 'Geolocation'), _defineProperty(_Object$freeze3, ConditionCategory.ENRICHMENT, 'Firmographics'), _defineProperty(_Object$freeze3, ConditionCategory.DRIFT, 'Drift'), _defineProperty(_Object$freeze3, ConditionCategory.SEGMENT, 'Segment Membership'), _Object$freeze3));

var NEW_EDITOR_PLAYBOOK_TYPES = ['EMPTY_LEADBOT', 'ENTERPRISE_BOT', 'BOOK_MORE_MEETINGS', 'MORE_QUALIFIED_CONVERSATIONS', 'LANDING_PAGE_LEADBOT', 'VSB_DEFAULT_PLAYBOOK', 'CONVERSATION_STARTER_BOT', 'RETARGETING_BOT', 'PRICING_PAGE_BOT', 'SECOND_NET_BOT', 'ABM_HOMEPAGE_BOT', 'PAID_TRAFFIC_BOT', 'FORM_REPLACER_CLP', 'CONVO_CONTENT_CLP'];

var ConditionTypes = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])((_OrderedMap = {}, _defineProperty(_OrderedMap, ConditionType.URL, {
  displayName: 'URL',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.INCLUDES_ANY_OF, OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF, OperatorType.IS_MATCH],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  placeholder: 'www.drift.com/',
  showPreview: function showPreview(value) {
    return React.createElement(
      'div',
      null,
      React.createElement(
        'span',
        null,
        value.first() || 'www.drift.com/'
      )
    );
  },
  category: ConditionCategory.URL,
  description: 'This is the fully qualified URL. If you select "includes", it can match any part of the URL, but "is" must exactly match what shows up in the browser.'
}), _defineProperty(_OrderedMap, ConditionType.URL_PATH, {
  displayName: 'URL Path',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  placeholder: '/blog',
  category: ConditionCategory.URL,
  showPreview: function showPreview(value) {
    return React.createElement(
      'div',
      null,
      'https://yourdomain.com',
      React.createElement(
        'span',
        null,
        value.first() || '/path/to/page'
      ),
      '?example=true'
    );
  },
  description: 'That "path" is the part of the URL that displays from the first "/" after the domain until the first "?" (or until the end of the URL, if there is no "?").'
}), _defineProperty(_OrderedMap, ConditionType.URL_QUERY, {
  displayName: 'URL Query Param',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  placeholder: 'beta=true',
  showPreview: function showPreview(value) {
    return React.createElement(
      'div',
      null,
      'https://yourdomain.com/page?',
      React.createElement(
        'span',
        null,
        value.join('&') || 'example=true'
      )
    );
  },
  category: ConditionCategory.URL,
  description: 'The query parameters of a URL are one or more strings that follow the format key=value, with a "&" between them.\nQuery parameters that are not of the format key=value are invalid and will be ignored.'
}), _defineProperty(_OrderedMap, ConditionType.URL_HOST, {
  displayName: 'URL Host',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  placeholder: 'app.drift.com',
  category: ConditionCategory.URL,
  showPreview: function showPreview(value) {
    return React.createElement(
      'div',
      null,
      'https://',
      React.createElement(
        'span',
        null,
        value.first() || 'yourdomain'
      ),
      '/page?example=true'
    );
  },
  description: 'This is the domain of the url. It is at least the domain name and the top level domain, e.g. drift (domain name) and .com (top level domain).\nIt may also contain a subdomain, which might look like: app.drift.com'
}), _defineProperty(_OrderedMap, ConditionType.SECONDS_ON_PAGE, {
  displayName: 'Seconds on Page',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 10,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.SECONDS_ON_SITE, {
  displayName: 'Seconds on Site',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 60,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.REFERRER, {
  displayName: 'Referrer',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.COOKIE, {
  displayName: 'Cookie',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: 'cookieName=value' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.DEVICE, {
  displayName: 'Device',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: DeviceOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('mobile'),
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.SITE_VISITS, {
  displayName: '# Site Visits',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.IS, OperatorType.NOT_IS, OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 3,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.DAYS_SINCE_LAST_VISIT, {
  displayName: '# Days Since Last Visit',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.IS, OperatorType.NOT_IS, OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 3,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.SCROLL_PERCENTAGE, {
  displayName: 'Scroll Percentage',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 70,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.EXIT_INTENT, {
  displayName: 'On Exit Intent',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: [{ value: true, label: 'true' }] };
  })(__WEBPACK_IMPORTED_MODULE_3__components_playbook_components_TargetingDisplay_SelectContainer__["a" /* default */]),
  operators: [OperatorType.IS],
  defaultValue: true,
  category: ConditionCategory.BROWSER
}), _defineProperty(_OrderedMap, ConditionType.COUNTRY, {
  displayName: 'Country',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: CountryOptions };
  }), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({ getValueDisplay: function getValueDisplay() {
      return function (value) {
        return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
      };
    } }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('US'),
  getValueDisplay: function getValueDisplay(value) {
    return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
  },
  category: ConditionCategory.GEOGRAPHY
}), _defineProperty(_OrderedMap, ConditionType.STATE, {
  displayName: 'US State',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: StateOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('California'),
  category: ConditionCategory.GEOGRAPHY
}), _defineProperty(_OrderedMap, ConditionType.IP_ADDRESS, {
  displayName: 'IP Address',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: '192.0.2.2' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.GEOGRAPHY
}), _defineProperty(_OrderedMap, ConditionType.WIDGET_STATUS, {
  displayName: 'Drift Online',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: BooleanOptions };
  })(__WEBPACK_IMPORTED_MODULE_3__components_playbook_components_TargetingDisplay_SelectContainer__["a" /* default */]),
  operators: [OperatorType.IS],
  defaultValue: true,
  getValueDisplay: function getValueDisplay(value) {
    return !!value ? 'true' : 'false';
  },
  category: ConditionCategory.DRIFT
}), _defineProperty(_OrderedMap, ConditionType.TEAM_AVAILABILITY, {
  displayName: 'Team',
  requiredGate: 'has_beta_team_view',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_7_app_modules_teams_hoc_withOrgTeams__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (_ref) {
    var teams = _ref.teams;
    return { options: teams.map(function (team) {
        return { value: team.id, label: team.name };
      }) };
  }), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
    getValueDisplay: function getValueDisplay(_ref2) {
      var teams = _ref2.teams;
      return function (teamId) {
        var team = teams.find(function (t) {
          return t.id === teamId;
        });
        return !!team ? team.name : '';
      };
    }
  }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_AVAILABLE, OperatorType.IS_NOT_AVAILABLE],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.DRIFT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_AUDIENCE, {
  displayName: 'Demandbase - Audience',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: __WEBPACK_IMPORTED_MODULE_14_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */] };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(__WEBPACK_IMPORTED_MODULE_14_constants_DemandbaseAudiences__["a" /* DemandbaseAudiences */][0].value),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_WATCHLIST, {
  displayName: 'Demandbase - Watch List',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: 'accountOwner:dave' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_IN_WATCHLIST, OperatorType.NOT_IS_IN_WATCHLIST, OperatorType.IS_WATCHLIST_VALUE_NULL, OperatorType.NOT_IS_WATCHLIST_VALUE_NULL],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_COMPANY_NAME, {
  displayName: 'Demandbase - Company Name',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: 'Drift' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_INDUSTRY, {
  displayName: 'Demandbase - Industry',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { creatable: true, placeholder: 'Type to create custom value' };
  }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  externalOptionsProp: 'demandbaseIndustries',
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_SUB_INDUSTRY, {
  displayName: 'Demandbase - Sub Industry',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { creatable: true };
  }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  placeholder: 'Type to create custom value',
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  externalOptionsProp: 'demandbaseSubIndustries',
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_EMPLOYEE_COUNT, {
  displayName: 'Demandbase - Employee Count',
  requiredIntegration: 'demandbase',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 50,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_EMPLOYEE_RANGE, {
  displayName: 'Demandbase - Employee Range',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return {
      creatable: true,
      options: DemandbaseEmployeeRangeOptions,
      placeholder: 'Type to create custom value'
    };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_MARKETING_ALIAS, {
  displayName: 'Demandbase - Marketing Alias',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: 'Demandbase' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_ANNUAL_SALES, {
  displayName: 'Demandbase - Annual Sales',
  requiredIntegration: 'demandbase',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 400000,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_REVENUE_RANGE, {
  displayName: 'Demandbase - Revenue Range',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return {
      creatable: true,
      options: DemandbaseRevenueRangeOptions,
      placeholder: 'Type to create custom value'
    };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_CITY, {
  displayName: 'Demandbase - City',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { placeholder: 'Boston' };
  }))(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_STATE, {
  displayName: 'Demandbase - State',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: StateOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('California'),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_COUNTRY_CODE, {
  displayName: 'Demandbase - Country Code',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: CountryOptions };
  }), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({ getValueDisplay: function getValueDisplay() {
      return function (value) {
        return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
      };
    } }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('US'),
  getValueDisplay: function getValueDisplay(value) {
    return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
  },
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.DEMANDBASE_COUNTRY_NAME, {
  displayName: 'Demandbase - Country Name',
  requiredIntegration: 'demandbase',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: CountryNameOptions };
  }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('United States'),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_NAME, {
  displayName: 'Drift Intel - Name',
  requiredGate: 'has_targeting_reveal',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_DOMAIN, {
  displayName: 'Drift Intel - Domain',
  requiredGate: 'has_targeting_reveal',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF, OperatorType.INCLUDES_ANY_OF, OperatorType.NOT_INCLUDES_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_REVENUE, {
  displayName: 'Drift Intel - Revenue',
  requiredGate: 'has_targeting_reveal',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: ClearbitRevenueOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(__WEBPACK_IMPORTED_MODULE_10_constants_ClearbitRevenueRanges__["a" /* default */][0]),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_TAGS, {
  displayName: 'Drift Intel - Tags',
  requiredGate: 'has_targeting_reveal',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: ClearbitTagsOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(null),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_TECH, {
  displayName: 'Drift Intel - Tech',
  requiredGate: 'has_targeting_reveal',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: __WEBPACK_IMPORTED_MODULE_9_constants_ClearbitTech__["a" /* default */] };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(null),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_EMPLOYEES, {
  displayName: 'Drift Intel - # of Employees',
  requiredGate: 'has_targeting_reveal',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 50,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_RAISED, {
  displayName: 'Drift Intel - Amount Raised',
  requiredGate: 'has_targeting_reveal',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 100000,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_ALEXA_US, {
  displayName: 'Drift Intel - Alexa US Ranking',
  requiredGate: 'has_targeting_reveal',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */],
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 10000000,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_ALEXA_GLOBAL, {
  displayName: 'Drift Intel - Alexa Global Ranking',
  requiredGate: 'has_targeting_reveal',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])({ min: 0, max: 100 })(__WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["a" /* NumberInput */]),
  operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
  defaultValue: 10000000,
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_HEADQUARTERS_STATE, {
  displayName: 'Drift Intel - Headquarter State',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: StateOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('California'),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_HEADQUARTERS_COUNTRY, {
  displayName: 'Drift Intel - Headquarter Country',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: CountryOptions };
  }), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({ getValueDisplay: function getValueDisplay() {
      return function (value) {
        return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
      };
    } }))(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('US'),
  getValueDisplay: function getValueDisplay(value) {
    return __WEBPACK_IMPORTED_MODULE_12_constants_ISOCountries__["a" /* IsoToCountriesNames */][value];
  },
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.CLEARBIT_HEADQUARTERS_POSTAL_CODE, {
  displayName: 'Drift Intel - Headquarter Postal Code',
  Component: __WEBPACK_IMPORTED_MODULE_6__components_playbook_components_TargetingDisplay_Inputs__["b" /* StringsInput */],
  operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(''),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.MADKUDU_SCORE, {
  displayName: 'MadKudu Customer Fit',
  requiredGate: 'has_madkudu',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: MadkuduScoreOptions };
  })(__WEBPACK_IMPORTED_MODULE_4__components_playbook_components_TargetingDisplay_SelectsContainer__["a" /* default */]),
  operators: [OperatorType.IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of('very good'),
  category: ConditionCategory.ENRICHMENT
}), _defineProperty(_OrderedMap, ConditionType.OUTBOUND_SESSION, {
  displayName: 'Outbound Session (from Drift email, Outreach, Salesloft)',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: BooleanOptions };
  })(__WEBPACK_IMPORTED_MODULE_3__components_playbook_components_TargetingDisplay_SelectContainer__["a" /* default */]),
  operators: [OperatorType.IS],
  defaultValue: true,
  getValueDisplay: function getValueDisplay(value) {
    return !!value ? 'true' : 'false';
  },
  category: ConditionCategory.DRIFT
}), _defineProperty(_OrderedMap, ConditionType.OUTBOUND_REP, {
  displayName: 'Outbound Rep',
  Component: __WEBPACK_IMPORTED_MODULE_5__components_playbook_components_TargetingDisplay_RepSelectContainer__["a" /* default */],
  operators: [OperatorType.IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(null),
  category: ConditionCategory.DRIFT
}), _defineProperty(_OrderedMap, ConditionType.SEGMENT, {
  displayName: 'Contact is in Segment',
  category: ConditionCategory.SEGMENT,
  operators: [OperatorType.IS_ANY_OF],
  defaultValue: __WEBPACK_IMPORTED_MODULE_0_immutable__["List"].of(null)
}), _defineProperty(_OrderedMap, ConditionType.TARGET_ACCOUNT, {
  displayName: 'Targeted Account',
  Component: Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function () {
    return { options: BooleanOptions };
  })(__WEBPACK_IMPORTED_MODULE_3__components_playbook_components_TargetingDisplay_SelectContainer__["a" /* default */]),
  operators: [OperatorType.IS],
  defaultValue: true,
  getValueDisplay: function getValueDisplay(value) {
    return !!value ? 'true' : 'false';
  },
  category: ConditionCategory.DRIFT
}), _defineProperty(_OrderedMap, ConditionType.EMAIL_PLAYBOOK, {
  displayName: 'Clicked link in email playbook',
  requiredGate: 'has_marketing_sequences',
  category: ConditionCategory.EMAIL_PLAYBOOK,
  operators: [OperatorType.IS],
  defaultValue: null
}), _OrderedMap));

var ConditionTypesByCategory = ConditionTypes.groupBy(function (_ref3) {
  var category = _ref3.category;
  return category;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "st9s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__ = __webpack_require__("1rl7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator__ = __webpack_require__("pryd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.



var UserActions = Marty.createActionCreators({
  id: 'UserActions',

  createUserWithEmail: function createUserWithEmail(email) {
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return this.app.queries.UserQueries.createUserWithEmail(email, password);
  },
  sendWelcomeEmail: function sendWelcomeEmail(isMobile) {
    return this.app.queries.UserQueries.sendWelcomeEmail(isMobile);
  },
  checkIfUserExistForEmailAndOrgHandle: function checkIfUserExistForEmailAndOrgHandle(email, orgHandle) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_validator__["isEmail"])(email)) {
      return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL, email, orgHandle);
    }
  },
  updateUser: function updateUser(userId, params) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_UPDATE, userId, params);
  },
  changePasswordForUser: function changePasswordForUser(userId, password) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].CHANGE_PASSWORD, userId, password);
  },
  userUpdated: function userUpdated(userId, user) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_UPDATE_DONE, userId, user);
  },
  uploadUserAvatar: function uploadUserAvatar(userId, file) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_AVATAR_UPLOAD, userId, file);
  },
  logoutUser: function logoutUser() {
    return this.app.queries.UserQueries.logoutUser();
  },
  archiveUser: function archiveUser(userId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].USER_ARCHIVE, userId);
  },
  archiveUsers: function archiveUsers(payload) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_UserConstants__["a" /* default */].ARCHIVE_USERS, payload);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (UserActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "sumM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t++u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MOST_POPULATED_TIMEZONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllTimezoneOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentTimezoneOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOptionForTimezone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);


var ABBR_REGEX = new RegExp("^[^-+]"); // For non-empty abbreviations that do not begin with -/+
var SLASH_REGEX = new RegExp("/"); // Ex. EST/Eastern is not supported by the backend
var ETC_REGEX = new RegExp("Etc/"); // Ex. ETC/GMT+1 is also not supported by the backend

var MOST_POPULATED_TIMEZONES = Object.freeze([{
  label: "Pacific/Midway (SST) -11:00",
  value: "Pacific/Midway"
}, {
  label: "Pacific/Honolulu (HST) -10:00",
  value: "Pacific/Honolulu"
}, {
  label: "Pacific/Marquesas (MART) -09:30",
  value: "Pacific/Marquesas"
}, {
  label: "America/Adak (HDT) -09:00",
  value: "America/Adak"
}, {
  label: "America/Anchorage (AKDT) -08:00",
  value: "America/Anchorage"
}, {
  label: "America/Los_Angeles (PDT) -07:00",
  value: "America/Los_Angeles"
}, {
  label: "America/Denver (MDT) -06:00",
  value: "America/Denver"
}, {
  label: "America/Mexico_City (CDT) -05:00",
  value: "America/Mexico_City"
}, {
  label: "America/Caracas (VET) -04:30",
  value: "America/Caracas"
}, {
  label: "America/New_York (EST) -04:00",
  value: "America/New_York"
}, {
  label: "America/Sao_Paulo (BRT) -03:00",
  value: "America/Sao_Paulo"
}, {
  label: "America/St_Johns (NDT) -02:30",
  value: "America/St_Johns"
}, {
  label: "America/Godthab (WGST) -02:00",
  value: "America/Godthab"
}, {
  label: "Atlantic/Cape_Verde (CVT) -01:00",
  value: "Atlantic/Cape_Verde"
}, {
  label: "Africa/Abidjan (GMT) +00:00",
  value: "Africa/Abidjan"
}, {
  label: "Africa/Bangui (WAT) +01:00",
  value: "Africa/Bangui"
}, {
  label: "Europe/London (GST) +01:00",
  value: "Europe/London"
}, {
  label: "Africa/Cairo (EET) +02:00",
  value: "Africa/Cairo"
}, {
  label: "Asia/Jerusalem (GMT) +03:00",
  value: "Asia/Jerusalem"
}, {
  label: "Europe/Moscow (MSK) +03:00",
  value: "Europe/Moscow"
}, {
  label: "Asia/Dubai (GST) +04:00",
  value: "Asia/Dubai"
}, {
  label: "Asia/Tehran (IRDT) +04:30",
  value: "Asia/Tehran"
}, {
  label: "Asia/Karachi (PKT) +05:00",
  value: "Asia/Karachi"
}, {
  label: "Asia/Calcutta (IST) +05:30",
  value: "Asia/Calcutta"
}, {
  label: "Asia/Kathmandu (NPT) +05:45",
  value: "Asia/Kathmandu"
}, {
  label: "Asia/Dacca (BDT) +06:00",
  value: "Asia/Dacca"
}, {
  label: "Asia/Rangoon (MMT) +06:30",
  value: "Asia/Rangoon"
}, {
  label: "Asia/Jakarta (WIB) +07:00",
  value: "Asia/Jakarta"
}, {
  label: "Asia/Manila (PHT) +08:00",
  value: "Asia/Manila"
}, {
  label: "Asia/Pyongyang (KST) +08:30",
  value: "Asia/Pyongyang"
}, {
  label: "Australia/Eucla (ACWST) +08:45",
  value: "Australia/Eucla"
}, {
  label: "Asia/Tokyo (JST) +09:00",
  value: "Asia/Tokyo"
}, {
  label: "Australia/Adelaide (ACST) +09:30",
  value: "Australia/Adelaide"
}, {
  label: "Australia/ACT (AEST) +10:00",
  value: "Australia/ACT"
}, {
  label: "Australia/LHI (LHST) +10:30",
  value: "Australia/LHI"
}, {
  label: "Asia/Sakhalin (SAKT) +11:00",
  value: "Asia/Sakhalin"
}, {
  label: "Antarctica/McMurdo (NZST) +12:00",
  value: "Antarctica/McMurdo"
}, {
  label: "Pacific/Chatham (CHAST) +12:45",
  value: "Pacific/Chatham"
}, {
  label: "Pacific/Tongatapu (TOT) +13:00",
  value: "Pacific/Tongatapu"
}, {
  label: "Pacific/Kiritimati (LINT) +14:00",
  value: "Pacific/Kiritimati"
}]);

var getAllTimezoneOptions = function getAllTimezoneOptions() {
  return __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"].names().filter(function (timezone) {
    return SLASH_REGEX.test(timezone) && !ETC_REGEX.test(timezone);
  }).map(function (timezone) {
    var metadata = getTimezoneMetadata(timezone, new Date());
    return toTimezoneOption(metadata);
  });
};

var getCurrentTimezoneOption = function getCurrentTimezoneOption() {
  var timezoneGuess = __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"].guess();
  var timezoneMetadata = getTimezoneMetadata(timezoneGuess, new Date());
  return {
    label: "\uD83D\uDD0E Current Timezone (" + timezoneMetadata.name + ")",
    value: timezoneGuess
  };
};

var getOptionForTimezone = function getOptionForTimezone(timezone) {
  var timezoneMetadata = getTimezoneMetadata(timezone, new Date());
  return toTimezoneOption(timezoneMetadata);
};

var toTimezoneOption = function toTimezoneOption(_ref) {
  var name = _ref.name,
      abbreviation = _ref.abbreviation,
      offsetAsString = _ref.offsetAsString;

  return {
    label: "" + name + (abbreviation ? " (" + abbreviation + ")" : "") + " " + offsetAsString,
    value: name
  };
};

var getTimezoneMetadata = function getTimezoneMetadata(timezone, date) {
  var timestamp = date.getTime();
  var zone = __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"].zone(timezone);
  var zonedDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"](timestamp, timezone);
  var offsetAsString = zonedDate.format('Z');
  var abbr = zone.abbr(timestamp);

  return {
    name: zone.name,
    abbreviation: ABBR_REGEX.test(abbr) ? abbr : undefined,
    offset: zonedDate.utcOffset(),
    offsetAsString: offsetAsString,
    population: zone.population
  };
};

/***/ }),

/***/ "t+vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bannedIPs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchBannedIPsSuccess; });
/* unused harmony export fetchBannedIPsPending */
/* unused harmony export fetchBannedIPsFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("o/OB");




var bannedIPs = function bannedIPs(state) {
  return state.getIn(['bannedIPs', 'ips'], []);
};

var fetchBannedIPsSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['bannedIPStatus', 'status', 'fetch']);
}, function (fetchBannedIPsStatus) {
  return fetchBannedIPsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_BANNED_IPS_SUCCESS */];
});

var fetchBannedIPsPending = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['bannedIPStatus', 'status', 'fetch']);
}, function (fetchBannedIPsStatus) {
  return fetchBannedIPsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_BANNED_IPS_PENDING */];
});

var fetchBannedIPsFailed = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['bannedIPStatus', 'status', 'fetch']);
}, function (fetchBannedIPsStatus) {
  return fetchBannedIPsStatus === __WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_BANNED_IPS_FAILED */];
});

/***/ }),

/***/ "t2Y1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (immutable) */ __webpack_exports__["a"] = FakeBrowser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__("O13t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles__);



/* A fake-ass browser for fake-ass website previews */
function FakeBrowser(_ref) {
  var children = _ref.children;

  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__styles___default.a.FakeBrowser },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__styles___default.a.TopBar },
      React.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_1__styles___default.a.AddressBar })
    ),
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__styles___default.a.ViewPort },
      children
    )
  );
}

FakeBrowser.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "t6hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__attribute__ = __webpack_require__("94Ok");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__segment__ = __webpack_require__("HRTS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timeline__ = __webpack_require__("xlyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__("Qfgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__models__ = __webpack_require__("/Abo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_actions__ = __webpack_require__("cRAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__ = __webpack_require__("EkEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_reports_demodata__ = __webpack_require__("tgWY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__ = __webpack_require__("Eys3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_immutable__);






















var fetch = function fetch(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["k" /* fetchEndUser */].toString()).map(function (action) {
    return action.payload;
  }).filter(function (_ref2) {
    var id = _ref2.id;
    return !!id;
  }).filter(function (_ref3) {
    var id = _ref3.id;
    return !__WEBPACK_IMPORTED_MODULE_8__selectors__["d" /* isFetched */](getState(), { id: id });
  }).mergeMap(function (_ref4) {
    var id = _ref4.id;

    if (__WEBPACK_IMPORTED_MODULE_14_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      var data = Object(__WEBPACK_IMPORTED_MODULE_11__models__["b" /* parseEndUser */])(__WEBPACK_IMPORTED_MODULE_15_app_modules_reports_demodata__["c" /* makeFakePerson */](id));
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */](data));
    } else {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetch(id).map(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["r" /* fetchEndUserPending */]({ id: id })).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["l" /* fetchEndUserCancelled */].toString()).filter(function (action) {
        return action.payload.id === id;
      })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["m" /* fetchEndUserFailed */]({ id: id, error: error }));
      });
    }
  });
};

var updateEndUser = function updateEndUser(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["_4" /* updateEndUser */].toString()).pluck('payload').mergeMap(function (_ref5) {
    var endUserId = _ref5.endUserId,
        endUserParams = _ref5.endUserParams;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].updateEndUser(endUserId, endUserParams).map(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["_6" /* updateEndUserPending */]).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["_5" /* updateEndUserFailed */]({ endUserId: endUserId, error: error }));
    });
  });
};

var bulkFetch = function bulkFetch(action$, _ref6) {
  var getState = _ref6.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["n" /* fetchEndUserList */].toString()).map(function (action) {
    return action.payload.ids.filter(function (id) {
      return !__WEBPACK_IMPORTED_MODULE_8__selectors__["d" /* isFetched */](getState(), { id: id });
    });
  }).filter(function (ids) {
    return ids.length > 0;
  }).mergeMap(function (ids) {
    if (__WEBPACK_IMPORTED_MODULE_14_app_modules_gates_selectors__["i" /* hasDemoOrg */](getState())) {
      var data = Object(__WEBPACK_IMPORTED_MODULE_18_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_15_app_modules_reports_demodata__["b" /* makeFakePeopleWithIds */](ids.length, ids)).map(__WEBPACK_IMPORTED_MODULE_11__models__["b" /* parseEndUser */]);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["q" /* fetchEndUserListSuccess */]({ ids: ids, data: data }));
    } else {
      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].bulkFetch(ids).map(function (data) {
        return __WEBPACK_IMPORTED_MODULE_9__actions__["q" /* fetchEndUserListSuccess */]({ ids: ids, data: data });
      }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["p" /* fetchEndUserListPending */]({ ids: ids })).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
        return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["o" /* fetchEndUserListFailed */]({ ids: ids }));
      });
    }
  });
};

var fetchFollowing = function fetchFollowing(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["s" /* fetchFollowing */].toString()).mergeMap(function (action) {
    var id = action.payload.id;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchFollowing(id).map(function (_ref7) {
      var following = _ref7.following;
      return __WEBPACK_IMPORTED_MODULE_9__actions__["v" /* fetchFollowingSuccess */]({ id: id, following: following });
    }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["u" /* fetchFollowingPending */]({ id: id })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["t" /* fetchFollowingFailed */]({ id: id, error: error }));
    });
  });
};

var updateFollowing = function updateFollowing(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["_7" /* updateFollowing */].toString()).mergeMap(function (action) {
    var _action$payload = action.payload,
        id = _action$payload.id,
        following = _action$payload.following;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].updateFollowing(id, following).map(function (_ref8) {
      var following = _ref8.following;
      return __WEBPACK_IMPORTED_MODULE_9__actions__["_10" /* updateFollowingSuccess */]({ following: following, id: id });
    }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["_9" /* updateFollowingPending */]({ id: id })).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["_8" /* updateFollowingFailed */]({ id: id, error: error }));
    });
  });
};

var pushEndUser = function pushEndUser(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["v" /* SocketCluster */].PUSH;
  }).filter(function (payload) {
    return payload.channelName === __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["u" /* SocketChannel */].ORG_PRIVATE;
  }).switchMap(function (_ref9) {
    var channel = _ref9.channel,
        leaveChannel$ = _ref9.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('end-user-updated', function (payload) {
        var state = store.getState();
        var id = payload.id;

        if (__WEBPACK_IMPORTED_MODULE_8__selectors__["d" /* isFetched */](state, { id: id })) {
          __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.EndUserActions.setEndUserFromPusher(payload);
          observer.next(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */](Object(__WEBPACK_IMPORTED_MODULE_11__models__["b" /* parseEndUser */])(payload)));
        }
      });
    }).takeUntil(leaveChannel$);
  });
};

var pushEndUserForSplitChannels = function pushEndUserForSplitChannels(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["l" /* JOIN_CHANNEL_PENDING */]).pluck('payload').filter(function (payload) {
    return payload.clusterName === __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["v" /* SocketCluster */].PUSH;
  }).filter(function (payload) {
    return _.includes(payload.channelName, 'subscribe-end-user');
  }).mergeMap(function (_ref10) {
    var channel = _ref10.channel,
        leaveChannel$ = _ref10.leaveChannel$;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].create(function (observer) {
      channel.on('end-user-fetched', function (payload) {
        __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.EndUserActions.setEndUserFromPusher(payload);
        observer.next(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */](Object(__WEBPACK_IMPORTED_MODULE_11__models__["b" /* parseEndUser */])(payload)));
      });
      channel.on('end-user-updated', function (payload) {
        __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.EndUserActions.setEndUserFromPusher(payload);
        observer.next(__WEBPACK_IMPORTED_MODULE_9__actions__["B" /* receiveEndUser */](Object(__WEBPACK_IMPORTED_MODULE_11__models__["b" /* parseEndUser */])(payload)));
      });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].empty();
    }).takeUntil(leaveChannel$);
  });
};

var updateCQL = function updateCQL(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["_0" /* updateCQL */].toString()).pluck('payload').mergeMap(function (_ref11) {
    var conversationId = _ref11.conversationId,
        endUserId = _ref11.endUserId,
        score = _ref11.score;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].updateCQL(endUserId, score, conversationId).map(__WEBPACK_IMPORTED_MODULE_9__actions__["_3" /* updateCQLSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["_2" /* updateCQLPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["_1" /* updateCQLFailed */](error));
    });
  });
};

var checkUnsubscribed = function checkUnsubscribed(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* checkUnsubscribed */].toString()).pluck('payload').switchMap(function (_ref12) {
    var email = _ref12.email;

    var orgId = __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__["orgId"](store.getState());
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].checkUnsubscribed(email, orgId).map(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* checkUnsubscribedSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["c" /* checkUnsubscribedPending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["b" /* checkUnsubscribedFailed */](error));
    });
  });
};

var fetchUnsubscribedCount = function fetchUnsubscribedCount(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["w" /* fetchUnsubscribedCount */].toString()).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].fetchUnsubscribedCount().map(__WEBPACK_IMPORTED_MODULE_9__actions__["z" /* fetchUnsubscribedCountSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["y" /* fetchUnsubscribedCountPending */]()).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["x" /* fetchUnsubscribedCountFailed */]());
    });
  });
};

var unsubscribeById = function unsubscribeById(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["W" /* unsubscribeById */].toString()).pluck('payload').mergeMap(function (_ref13) {
    var endUserId = _ref13.endUserId,
        reason = _ref13.reason;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].unsubscribeById({ endUserId: endUserId, reason: reason }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["Z" /* unsubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["Y" /* unsubscribePending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error, { extra: { endUserId: endUserId } });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["X" /* unsubscribeFailed */](error));
    });
  });
};

var unsubscribeByEncodedEmail = function unsubscribeByEncodedEmail(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["V" /* unsubscribeByEncodedEmail */].toString()).pluck('payload').mergeMap(function (_ref14) {
    var email = _ref14.email,
        endUserId = _ref14.endUserId,
        reason = _ref14.reason;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].unsubscribeByEncodedEmail({ email: email, endUserId: endUserId, reason: reason }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["Z" /* unsubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["Y" /* unsubscribePending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error, { extra: { endUserId: endUserId } });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["X" /* unsubscribeFailed */](error));
    });
  });
};

var unsubscribeByEmailAndOrgId = function unsubscribeByEmailAndOrgId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["U" /* unsubscribeByEmailAndOrgId */].toString()).pluck('payload').mergeMap(function (_ref15) {
    var email = _ref15.email,
        orgId = _ref15.orgId;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].unsubscribeByEmailAndOrgId({ email: email, orgId: orgId }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["Z" /* unsubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["Y" /* unsubscribePending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error, { extra: { email: email, orgId: orgId } });
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["X" /* unsubscribeFailed */](error));
    });
  });
};

var resubscribe = function resubscribe(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["O" /* resubscribe */].toString()).pluck('payload').mergeMap(function (_ref16) {
    var email = _ref16.email,
        endUserId = _ref16.endUserId;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].resubscribe({ email: email, endUserId: endUserId }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["S" /* resubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["R" /* resubscribePending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["Q" /* resubscribeFailed */](error));
    });
  });
};

var resubscribeByEmailandOrgId = function resubscribeByEmailandOrgId(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["P" /* resubscribeByEmailandOrgId */].toString()).pluck('payload').mergeMap(function (_ref17) {
    var email = _ref17.email,
        orgId = _ref17.orgId;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].resubscribeByEmailandOrgId({ email: email, orgId: orgId }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["S" /* resubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["R" /* resubscribePending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["Q" /* resubscribeFailed */](error));
    });
  });
};

var requestUnsubDeleteData = function requestUnsubDeleteData(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["K" /* requestUnsubDeleteData */].toString()).pluck('payload').mergeMap(function (_ref18) {
    var email = _ref18.email,
        orgId = _ref18.orgId,
        endUserId = _ref18.endUserId;
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].requestUnsubDeleteData({ email: email, orgId: orgId, endUserId: endUserId }).map(__WEBPACK_IMPORTED_MODULE_9__actions__["N" /* requestUnsubDeleteDataSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["M" /* requestUnsubDeleteDataPending */]()).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["L" /* requestUnsubDeleteDataFailed */](err));
    });
  });
};

var unsubscribe = function unsubscribe(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["T" /* unsubscribe */].toString()).pluck('payload').mergeMap(function (_ref19) {
    var email = _ref19.email;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].unsubscribe(email).map(__WEBPACK_IMPORTED_MODULE_9__actions__["Z" /* unsubscribeSuccess */]).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["Y" /* unsubscribePending */]()).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["X" /* unsubscribeFailed */](error));
    });
  });
};

var createPropertyDefinition = function createPropertyDefinition(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* createPropertyDefinition */].toString()).pluck('payload').mergeMap(function (_ref20) {
    var name = _ref20.name;

    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */]
    // TODO: should we always create them of type STRING?
    .createNewContactAttribute([{ type: 'STRING', name: name, displayName: name }]).map(function () {
      return __WEBPACK_IMPORTED_MODULE_9__actions__["j" /* createPropertyDefinitionSuccess */](name);
    }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["i" /* createPropertyDefinitionPending */](name)).catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* createPropertyDefinitionFailed */]({ error: error, name: name }));
    });
  });
};

var requestContactData = function requestContactData(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["C" /* requestContactData */].toString()).pluck('payload').mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].requestContactData(payload).map(function (resp) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Your data request was successfully received! You’ll receive an email with the info soon!'
      });
      return __WEBPACK_IMPORTED_MODULE_9__actions__["F" /* requestContactDataSuccess */](resp);
    }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["E" /* requestContactDataPending */](payload)).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        variant: 'red',
        sticky: true,
        content: 'We were unable to process your request. Please chat in and let us know so we can make sure you\'re taken care of.'
      });
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["D" /* requestContactDataFailed */]({ error: error, payload: payload }));
    });
  });
};

var requestDeleteContactData = function requestDeleteContactData(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["G" /* requestDeleteContactData */].toString()).pluck('payload').mergeMap(function (payload) {
    return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* api */].requestDataDeletion(payload).map(function (resp) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        content: 'Your data deletion request was successfully received and is being processed!'
      });
      return __WEBPACK_IMPORTED_MODULE_9__actions__["J" /* requestDeleteContactDataSuccess */](resp);
    }).startWith(__WEBPACK_IMPORTED_MODULE_9__actions__["I" /* requestDeleteContactDataPending */](payload)).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
        variant: 'red',
        sticky: true,
        content: 'We were unable to process your request. Please chat in and let us know so we can make sure you\'re taken care of.'
      });
      Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_9__actions__["H" /* requestDeleteContactDataFailed */]({ error: error, payload: payload }));
    });
  });
};

var joinSpecificEndUserChannels = function joinSpecificEndUserChannels(action$, _ref21) {
  var getState = _ref21.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["A" /* joinEndUserChannel */].toString()).pluck('payload').map(function (endUserId) {
    return __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_actions__["h" /* joinChannel */]({
      clusterName: __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["v" /* SocketCluster */].PUSH,
      channelName: 'subscribe-end-user:' + __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__["orgId"](getState()) + '-' + endUserId
    });
  });
};

var closeSpecficEndUserChannels = function closeSpecficEndUserChannels(action$, _ref22) {
  var getState = _ref22.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__actions__["e" /* closeEndUserChannel */].toString()).pluck('payload').map(function (endUserId) {
    return __WEBPACK_IMPORTED_MODULE_12_app_modules_socket_actions__["l" /* leaveChannel */]({
      clusterName: __WEBPACK_IMPORTED_MODULE_13_app_modules_socket_constants__["v" /* SocketCluster */].PUSH,
      channelName: 'subscribe-end-user:' + __WEBPACK_IMPORTED_MODULE_10_app_modules_org_selectors__["orgId"](getState()) + '-' + endUserId
    });
  });
};

var updateSpecificEndUserChannels = function updateSpecificEndUserChannels(action$, _ref23) {
  var getState = _ref23.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__["m" /* fetchConversationListSuccess */].toString(), __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__["x" /* fetchNextConversationListSuccess */].toString(), __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__["J" /* receiveConversation */].toString(), __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__["P" /* setActiveConversation */].toString(), __WEBPACK_IMPORTED_MODULE_16_app_modules_conversation_actions__["Y" /* unsetActiveConversation */].toString()) // any actions that could change the conversation list
  .mergeMap(function () {
    var state = getState();
    var query = __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_selectors__["d" /* activeQuery */](state);
    var activeEndUserIdsFromConversation = __WEBPACK_IMPORTED_MODULE_17_app_modules_conversation_selectors__["h" /* endUserIdsOfActiveConversations */](state, { query: query });
    var activeEndUserChannels = __WEBPACK_IMPORTED_MODULE_8__selectors__["a" /* activeEndUserChannels */](state);

    var newChannelsToJoin = activeEndUserIdsFromConversation.subtract(activeEndUserChannels);
    var channelsToLeave = activeEndUserChannels.subtract(activeEndUserIdsFromConversation);

    var actionsToDispatch = newChannelsToJoin.toList().map(function (endUserId) {
      return __WEBPACK_IMPORTED_MODULE_9__actions__["A" /* joinEndUserChannel */](endUserId);
    }).concat(channelsToLeave.toList().map(function (endUserId) {
      return __WEBPACK_IMPORTED_MODULE_9__actions__["e" /* closeEndUserChannel */](endUserId);
    }));
    return actionsToDispatch;
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetch, updateEndUser, bulkFetch, fetchFollowing, updateFollowing, __WEBPACK_IMPORTED_MODULE_4__attribute__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_5__segment__["b" /* epic */], __WEBPACK_IMPORTED_MODULE_6__timeline__["b" /* epic */], pushEndUser, pushEndUserForSplitChannels, updateCQL, checkUnsubscribed, unsubscribe, resubscribe, fetchUnsubscribedCount, createPropertyDefinition, requestContactData, requestDeleteContactData, unsubscribeById, unsubscribeByEncodedEmail, unsubscribeByEmailAndOrgId, requestUnsubDeleteData, joinSpecificEndUserChannels, closeSpecficEndUserChannels, updateSpecificEndUserChannels, resubscribeByEmailandOrgId);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "t8Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_payments_Gates__ = __webpack_require__("G69f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Customize_Styling_IconPicker_Constants__ = __webpack_require__("8sd/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_PremiumOverlay__ = __webpack_require__("6y6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("o67s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);







var GatedIconPicker = function GatedIconPicker(_ref) {
  var iconStyle = _ref.iconStyle;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'GatedIconPicker-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_3_components_shared_PremiumOverlay__["a" /* default */],
      { className: 'GatedIconPicker' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-prompt' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'IconPickerWidget' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2_components_Customize_Styling_IconPicker_Constants__["a" /* IconPickerConfig */][iconStyle].chatSrc })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'upgrade-prompt-text-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'upgrade-prompt-text' },
            'Brand your'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'upgrade-prompt-text' },
            'chat widget\u2026'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'CustomIconPicker' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          'Make your widget your own'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          'with a custom image or logo!'
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (GatedIconPicker);

/***/ }),

/***/ "t8Y4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__ = __webpack_require__("T1OH");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var emptyCustomValue = { label: 'Custom', value: { min: null, max: null } };

var SiteVisitsFilter = function (_Component) {
  _inherits(SiteVisitsFilter, _Component);

  function SiteVisitsFilter(props) {
    _classCallCheck(this, SiteVisitsFilter);

    var _this = _possibleConstructorReturn(this, (SiteVisitsFilter.__proto__ || Object.getPrototypeOf(SiteVisitsFilter)).call(this, props));

    _this.updateMin = function (event) {
      var currentValue = event.target.value;
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { min: currentValue }) };
      }, _this.updateParent);
    };

    _this.updateMax = function (event) {
      var currentValue = event.target.value;
      _this.setState(function (prevState) {
        return { selectedValue: _extends(prevState.selectedValue, { max: currentValue }) };
      }, _this.updateParent);
    };

    _this.updateParent = function () {
      var isValid = _this.isValid();
      _this.props.setPageValidity(isValid);
      if (isValid) {
        _this.props.setActiveFilter({
          field: __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["j" /* DISPLAY_WHEN_FILTER_TYPES */].SITE_VISITS,
          operator: __WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["P" /* SITE_VISITS_OPERATORS */].BTW,
          value: _this.state.selectedValue
        });
      }
    };

    _this.onSelect = function (group) {
      if (group.value === 'CUSTOM') {
        return _this.setState({
          selectedValue: emptyCustomValue,
          isCustom: true
        }, _this.updateParent);
      }

      return _this.setState({
        selectedValue: group.value,
        isCustom: false
      }, _this.updateParent);
    };

    var initialValue = props.activeFilter.value;

    _this.state = {
      selectedValue: initialValue,
      isCustom: !_this.hasMatchedGroup(initialValue)
    };
    return _this;
  }

  _createClass(SiteVisitsFilter, [{
    key: 'hasMatchedGroup',
    value: function hasMatchedGroup(isMatchedGroup) {
      var matched = _.find(__WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["O" /* SITE_VISITS_GROUPS */], function (group) {
        return _.isEqual(group, isMatchedGroup);
      });

      return !!matched ? { value: matched, label: matched.min + ' - ' + matched.max } : null;
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return (!!this.state.selectedValue.min || this.state.selectedValue.min === 0) && !!this.state.selectedValue.max;
    }
  }, {
    key: 'renderSiteVisitsDropdown',
    value: function renderSiteVisitsDropdown() {
      var selectOptions = {
        multi: false,
        autoFocus: true,
        value: this.hasMatchedGroup(this.state.selectedValue) || emptyCustomValue,
        onChange: this.onSelect,
        clearable: false,
        options: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2_app_modules_rules_constants__["O" /* SITE_VISITS_GROUPS */].map(function (group) {
          return { value: group, label: group.min + ' - ' + group.max + ' site visits' };
        })), [{ label: 'Custom', value: 'CUSTOM' }])
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select_plus__["b" /* default */], selectOptions);
    }
  }, {
    key: 'renderCustomInput',
    value: function renderCustomInput() {
      if (!this.state.isCustom) return;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rule-filter-custom-input drift-form' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '0', onChange: this.updateMin, defaultValue: this.state.selectedValue.min }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'to'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', placeholder: '0', onChange: this.updateMax, defaultValue: this.state.selectedValue.max }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          'site visits'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-choice' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose the Number of Site Visits'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Match the number of times a visitor has visited your site (sessions, not page views)'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rules-choice-content drift-form rules-content-no-sidebar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rules-choice-options' },
            this.renderSiteVisitsDropdown(),
            this.renderCustomInput()
          )
        )
      );
    }
  }]);

  return SiteVisitsFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SiteVisitsFilter);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "t9ih":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzNCAzOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMjUgMzMuNUM5LjM5MyAzMy41IDMgMjcuMTA3IDMgMTkuMjVTOS4zOTMgNSAxNy4yNSA1IDMxLjUgMTEuMzkzIDMxLjUgMTkuMjUgMjUuMTA3IDMzLjUgMTcuMjUgMzMuNXptMC0yNi43MmMtNi44NzYgMC0xMi40NyA1LjU5NS0xMi40NyAxMi40NyAwIDYuODc2IDUuNTk0IDEyLjQ3IDEyLjQ3IDEyLjQ3czEyLjQ3LTUuNTk0IDEyLjQ3LTEyLjQ3YzAtNi44NzUtNS41OTQtMTIuNDctMTIuNDctMTIuNDd6bTguNTI4IDEwLjMwN2wtMy42MzMgMy42OTZjLjAwMy4wMDItLjAxMi4wNTctLjAxLjA4M2wxLjQwNSA0Ljk2NGMuMTUuNTMzLS4wMzIuODgyLS4xNTIgMS4wNDItLjE5LjI1LS40ODIuMzk0LS44LjM5NC0uMjQgMC0uNDc4LS4wOC0uNzEtLjIzOGwtNC42MjgtMy4xNjYtNC42MjUgMy4xNjRjLS41NS4zNzQtMS4xODIuMjgyLTEuNTEyLS4xNTUtLjEyLS4xNi0uMzAzLS41MDgtLjE1My0xLjA0bDEuNDEtNC45OWMtLjAwMiAwLS4wMTctLjA1NS0uMDMtLjA3OGwtMy42MTctMy42NzVjLS4zNDgtLjM1Ni0uNDY1LS44MTQtLjMxMy0xLjIyNy4xNS0uNDEyLjUzNi0uNjg2IDEuMDI4LS43M2w0LjgxLS40NWMtLjAxLS4wMDIuMDMzLS4wMzQuMDQ4LS4wNTNsMS45MTgtNC40M2MuMjAyLS40NjUuNTktLjc0NCAxLjAzNi0uNzQ0LjQ0OCAwIC44MzUuMjggMS4wMzcuNzQ3bDEuOTMzIDQuNDU0Yy0uMDAyLS4wMDguMDQzLjAyNC4wNjYuMDMybDQuNzc3LjQ0MmMuNDk1LjA0Ny44OC4zMjIgMS4wMy43MzUuMTUuNDEzLjAzMy44Ny0uMzE1IDEuMjI0em0tNS42OS0uNjMzYy0uNjI2LS4wNi0xLjI1Ny0uNTItMS41MDMtMS4wOTRsLTEuMzM1LTMuMDc1LTEuMzM1IDMuMDc4Yy0uMjUuNTc0LS44OCAxLjAzMi0xLjUwMiAxLjA5bC0zLjQ5My4zMjcgMi43MDcgMi43NTNjLjQzNS40NDIuNjMgMS4xOTcuNDU4IDEuNzk1bC0uODkyIDMuMTUgMy4xLTIuMTJjLjI2NS0uMTgyLjYwNi0uMjg0Ljk1Ny0uMjg0LjM1IDAgLjY5Mi4xMDIuOTYuMjg2bDMuMSAyLjEyLS44OTMtMy4xNTVjLS4xNzItLjU5My4wMi0xLjM1LjQ2LTEuNzkzbDIuNzA0LTIuNzUzLTMuNDktLjMyNnoiIGZpbGw9IiNCNUQyRTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg=="

/***/ }),

/***/ "tB4U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("F3N0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("8d3e");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });





/***/ }),

/***/ "tHDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchRevealData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchRevealDataPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchRevealDataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchRevealDataFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchRevealDataCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchRevealDataByIp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchRevealDataByIpPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchRevealDataByIpSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRevealDataByIpFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchRevealDataByIpCancelled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchRevealDataBySourceProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchRevealDataBySourcePropertiesPending; });
/* unused harmony export fetchRevealDataBySourcePropertiesSuccess */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return showRevealData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("BGpS");



var fetchRevealData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_REVEAL_DATA */]);
var fetchRevealDataPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* FETCH_REVEAL_DATA_PENDING */]);
var fetchRevealDataSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* FETCH_REVEAL_DATA_SUCCESS */]);
var fetchRevealDataFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_REVEAL_DATA_FAILED */]);
var fetchRevealDataCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_REVEAL_DATA_CANCELLED */]);

var fetchRevealDataByIp = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_REVEAL_DATA_BY_IP */]);
var fetchRevealDataByIpPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_REVEAL_DATA_BY_IP_PENDING */]);
var fetchRevealDataByIpSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_REVEAL_DATA_BY_IP_SUCCESS */]);
var fetchRevealDataByIpFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_REVEAL_DATA_BY_IP_FAILED */]);
var fetchRevealDataByIpCancelled = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_REVEAL_DATA_BY_IP_CANCELLED */]);
var fetchRevealDataBySourceProperties = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES */]);
var fetchRevealDataBySourcePropertiesPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_PENDING */]);
var fetchRevealDataBySourcePropertiesSuccess = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_REVEAL_DATA_BY_SOURCE_PREOPERTIES_SUCCESS */]);

var showRevealData = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SHOW_REVEAL_DATA */]);

/***/ }),

/***/ "tHh4":
/***/ (function(module, exports) {

module.exports = "<svg width=\"13px\" height=\"10px\" viewBox=\"0 0 13 10\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Conversation\" transform=\"translate(-886.000000, -742.000000)\" fill-rule=\"nonzero\" fill=\"#13CB6E\"><g id=\"SideBar\" transform=\"translate(868.000000, 138.000000)\"><g id=\"Group-2\" transform=\"translate(1.000000, 250.000000)\"><g id=\"check-circle\" transform=\"translate(17.000000, 294.000000)\"><path d=\"M1.70710678,64.783298 C1.31658249,64.3927737 0.683417511,64.3927737 0.292893219,64.783298 C-0.0976310729,65.1738223 -0.0976310729,65.8069872 0.292893219,66.1975115 L3.55249442,69.4571127 C3.94301871,69.847637 4.57618369,69.847637 4.96670798,69.4571127 L12.7167139,61.7071068 C13.1072382,61.3165825 13.1072382,60.6834175 12.7167139,60.2928932 C12.3261896,59.9023689 11.6930247,59.9023689 11.3025004,60.2928932 L4.2596012,67.3357924 L1.70710678,64.783298 Z\" id=\"check\"></path></g></g></g></g></g></svg>"

/***/ }),

/***/ "tJQP":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 34 28\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><path d=\"M2.975 13.883a.496.496 0 0 1-.4-.787c.007-.012.776-1.085.883-2.373C1.224 9.523 0 7.837 0 5.95 0 2.669 3.559 0 7.933 0c4.375 0 7.934 2.669 7.934 5.95s-3.559 5.95-7.934 5.95c-.345 0-.88.003-1.204.006-1.196 1.832-3.623 1.972-3.73 1.977h-.024zM7.933.992C4.106.992.992 3.216.992 5.95c0 2.12 2.003 3.437 3.196 4.035a.494.494 0 0 1 .275.443c0 .882-.267 1.688-.536 2.277.7-.208 1.6-.64 2.083-1.53a.495.495 0 0 1 .432-.259s.965-.008 1.491-.008c3.828 0 6.942-2.224 6.942-4.958S11.761.992 7.933.992zM5.911 3.967c0-.274.221-.496.493-.496h2.961a.494.494 0 0 1 .395.793L7.392 7.437h1.973c.272 0 .493.221.493.496a.494.494 0 0 1-.493.496h-2.96a.496.496 0 0 1-.394-.793l2.368-3.173H6.403a.495.495 0 0 1-.493-.496h.001z\" id=\"a\"></path></defs><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M31.875 27.818H2.125C.953 27.818 0 26.883 0 25.733V2.086C0 .936.953 0 2.125 0h29.75C33.047 0 34 .936 34 2.086v23.647c0 1.15-.953 2.085-2.125 2.085zm.708-25.732a.703.703 0 0 0-.708-.695H2.125a.703.703 0 0 0-.708.695v3.478h31.166V2.086zm0 4.869H1.417v18.778c0 .383.318.695.708.695h29.75c.39 0 .708-.312.708-.695V6.955zM3.556 2.812h.007c.392 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695zm2.125 0h.007c.39 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695zm2.125 0h.007c.392 0 .708.31.708.695a.702.702 0 0 1-.708.696.705.705 0 0 1-.712-.696c0-.384.314-.695.705-.695z\" fill=\"#394F5A\"></path><g transform=\"translate(8.567 9.7)\"><mask id=\"b\" fill=\"#fff\"><use xlink:href=\"#a\"></use></mask><use fill=\"#7695A5\" fill-rule=\"nonzero\" xlink:href=\"#a\"></use><g mask=\"url(#b)\" fill=\"#394F5A\"><path d=\"M-.567-1.7h17v17h-17z\"></path></g></g></g></svg>"

/***/ }),

/***/ "tKK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("UbJF");











var mapStateToProps = function mapStateToProps(state) {
  var viewingSignatureId = __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_105" /* viewingSignatureId */](state);
  return {
    signatureIncludeAvatar: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_89" /* signatureIncludeAvatar */](state),
    signatureIncludeSocial: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_91" /* signatureIncludeSocial */](state),
    signatureIncludeBanner: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_90" /* signatureIncludeBanner */](state),
    signatureBannerImgURL: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_85" /* signatureBannerImgURL */](state, viewingSignatureId),
    signatureBannerLinkURL: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_86" /* signatureBannerLinkURL */](state, viewingSignatureId),
    signatureBody: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_88" /* signatureBody */](state),
    signatureBannerUploadPending: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_87" /* signatureBannerStatusPending */](state),
    signaturePreviewAllData: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_92" /* signaturePreviewAllData */](state),
    signaturePreviewAllFetchPending: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_94" /* signaturePreviewAllFetchPending */](state),
    signaturePreviewAllFetchFailed: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_93" /* signaturePreviewAllFetchFailed */](state),
    viewingSignatureId: viewingSignatureId,
    signatures: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_selectors__["_95" /* signatures */](state),
    currentUser: __WEBPACK_IMPORTED_MODULE_5_app_modules_user_selectors__["currentUser"](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setViewingSignatureId: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_223" /* setViewingSignatureId */],
      setSignatureIncludeAvatar: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_206" /* setSignatureIncludeAvatar */],
      setSignatureIncludeSocial: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_208" /* setSignatureIncludeSocial */],
      setSignatureIncludeBanner: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_207" /* setSignatureIncludeBanner */],
      setSignatureBannerLinkURL: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_202" /* setSignatureBannerLinkURL */],
      setSignatureBanner: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_199" /* setSignatureBanner */],
      setSignatureBody: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_205" /* setSignatureBody */],
      clearSignatureBanner: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["u" /* clearSignatureBanner */],
      fetchSignatureMultiBannerPreview: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_62" /* fetchSignatureMultiBannerPreview */],
      addNewBanner: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["j" /* addNewSignatureToPlaybook */],
      addEmptyBannerSignature: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["g" /* addEmptyBannerSignature */],
      removeEmptyBannerSignature: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_102" /* removeEmptyBannerSignature */],
      removeSignature: __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_actions__["_104" /* removeSignature */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchSignatureMultiBannerPreview({ userId: this.props.currentUser.id, isPlaybookEditor: true });
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    emptyBannerChecked: props.signatures.filter(function (sig) {
      return sig.hasCampaignGraphic;
    }).size >= 1 && props.signatures.filter(function (sig) {
      return !sig.hasCampaignGraphic;
    }).size === 1
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onClearSignatureBanner: function onClearSignatureBanner(props) {
    return function (e, signatureId) {
      var _props$actions = props.actions,
          clearSignatureBanner = _props$actions.clearSignatureBanner,
          fetchSignatureMultiBannerPreview = _props$actions.fetchSignatureMultiBannerPreview,
          currentUser = props.currentUser;

      e.stopPropagation();
      clearSignatureBanner(signatureId);
      fetchSignatureMultiBannerPreview({ userId: currentUser.id });
    };
  },
  onAddNewBanner: function onAddNewBanner(props) {
    return function () {
      var addNewBanner = props.actions.addNewBanner;

      addNewBanner();
    };
  },
  onIncludeNoBannerOption: function onIncludeNoBannerOption(props) {
    return function () {
      if (!props.emptyBannerChecked) {
        props.actions.addEmptyBannerSignature();
      } else {
        props.actions.removeEmptyBannerSignature();
      }
    };
  },
  onRemoveSignatureClick: function onRemoveSignatureClick(props) {
    return function (signatureId, numberOfBanners) {
      if (numberOfBanners == 1) {
        props.actions.addNewBanner();
      }
      props.actions.removeSignature(signatureId);
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.currentUser.id, isPlaybookEditor: true });
    };
  },
  onRefetchPreviewClick: function onRefetchPreviewClick(props) {
    return function () {
      props.actions.fetchSignatureMultiBannerPreview({ userId: props.currentUser.id, isPlaybookEditor: true });
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  var currentUser = props.currentUser,
      _props$actions2 = props.actions,
      fetchSignatureMultiBannerPreview = _props$actions2.fetchSignatureMultiBannerPreview,
      setSignatureIncludeAvatar = _props$actions2.setSignatureIncludeAvatar,
      setSignatureIncludeSocial = _props$actions2.setSignatureIncludeSocial,
      setSignatureIncludeBanner = _props$actions2.setSignatureIncludeBanner,
      setSignatureBannerLinkURL = _props$actions2.setSignatureBannerLinkURL,
      setSignatureBody = _props$actions2.setSignatureBody,
      setSignatureBanner = _props$actions2.setSignatureBanner,
      signatureBody = props.signatureBody;


  var fetchPreview = fetchSignatureMultiBannerPreview.bind(null, { userId: currentUser.id });

  // decorator for simple actions that all do the same thing but also need to fetch the preview when they change
  var getPreviewAfter = function getPreviewAfter(firstDo, callWith) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    firstDo(callWith);
    setTimeout(fetchPreview, timeout);
  };

  var addHttp = function addHttp(url) {
    return url.startsWith('http') ? url : 'http://';
  };

  return {
    onIncludeAvatarChange: function onIncludeAvatarChange(val) {
      return getPreviewAfter(setSignatureIncludeAvatar, val);
    },
    onIncludeSocialChange: function onIncludeSocialChange(val) {
      return getPreviewAfter(setSignatureIncludeSocial, val);
    },
    onIncludeBannerChange: function onIncludeBannerChange(val) {
      return getPreviewAfter(setSignatureIncludeBanner, val);
    },
    onBannerLinkURLChange: function onBannerLinkURLChange(e, signatureId) {
      return getPreviewAfter(setSignatureBannerLinkURL, { value: addHttp(e.target.value), signatureId: signatureId });
    },
    onContentChange: function onContentChange(val) {
      return val !== signatureBody ? getPreviewAfter(setSignatureBody, val) : null;
    },
    onBannerUpload: function onBannerUpload(files, signatureId) {
      return getPreviewAfter(setSignatureBanner, { file: files[0], signatureId: signatureId }, 1500);
    }
  };
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "tLAg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"AudienceOption":"AudienceOption---2eGlZ","AudienceOption_Label":"AudienceOption_Label---1XYip"};

/***/ }),

/***/ "tO9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Toggle":"Toggle---3i74N"};

/***/ }),

/***/ "tPhy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "tQfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var ConditionalRender = function ConditionalRender(_ref) {
  var children = _ref.children,
      condition = _ref.condition,
      className = _ref.className;

  if (condition) {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(className) },
      children
    );
  }

  return null;
};

/* harmony default export */ __webpack_exports__["a"] = (ConditionalRender);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "tT6b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var BOT_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  FETCH_BOT_STARTED: null,
  FETCH_BOT_FINISHED: null,
  FETCH_BOT_FAILED: null,

  ENABLE_BOT_STARTED: null,
  ENABLE_BOT_FINISHED: null,
  ENABLE_BOT_FAILED: null,

  UPDATE_BOT_STARTED: null,
  UPDATE_BOT_FINISHED: null,
  UPDATE_BOT_FAILED: null,

  UPLOAD_BOT_AVATAR_STARTED: null,
  UPLOAD_BOT_AVATAR_FINISHED: null,
  UPLOAD_BOT_AVATAR_FAILED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(BOT_CONSTANTS, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId));

/***/ }),

/***/ "tUpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Property; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Property = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  type: undefined,
  index: undefined,
  displayName: undefined,
  name: undefined,
  status: undefined,
  updatedAt: undefined
});

var Event = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  displayName: undefined,
  name: undefined,
  updatedAt: undefined
});

/***/ }),

/***/ "tWDN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export SegmentInstallerContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__ = __webpack_require__("CaRb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Connected__ = __webpack_require__("COe1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl__ = __webpack_require__("Lkyf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var ENABLE_BUTTON_SCRIPT_URL = "https://static.segment.com/enable-button/v1/index.js";
var SEGMENT_HELP_URL = "https://help.drift.com/article/segment/";
var WRITEKEY_HELP_URL = "https://segment.com/docs/guides/setup/how-do-i-find-my-write-key/";

var SegmentInstaller = function (_Component) {
  _inherits(SegmentInstaller, _Component);

  function SegmentInstaller() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SegmentInstaller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentInstaller.__proto__ || Object.getPrototypeOf(SegmentInstaller)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      writeKey: '',
      updating: false,
      showKey: false
    }, _this.handleConnect = function () {
      var writeKey = _this.state.writeKey;

      var segmentButtonRef = document.querySelector('.segment-enable-button a');
      var link = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(segmentButtonRef, 'href');
      Object(__WEBPACK_IMPORTED_MODULE_7_components_Integration_helpers__["b" /* popUp */])({
        path: link,
        onClose: function onClose() {
          if (_this.state.updating) {
            _this.app.actions.NotificationActions.pushNotification({ variant: 'red', content: 'We could not connect. Please check your input and try again.' });
            _this.setState({ updating: false });
          }
        },
        onMessage: function onMessage() {
          _this.app.actions.OrgPropertiesActions.updateProperties(_this.props.currentUser.orgId, { segmentEnabled: true });
          _this.app.queries.IntegrationsQueries.fetchIntegrationStates();
          _this.setState({ updating: false });
        }
      });
      if (writeKey) {
        _this.app.queries.IntegrationsQueries.createAccessToken('segment', { writeKey: writeKey });
      }
      _this.setState({ updating: true });
    }, _this.handleDisconnect = function () {
      _this.app.actions.OrgPropertiesActions.updateProperties(_this.props.currentUser.orgId, { segmentEnabled: false, segmentWriteKey: null });
      _this.app.queries.IntegrationsQueries.fetchIntegrationStates();
      _this.setState({ updating: true });
    }, _this.getConnectionPayload = function () {
      var writeKey = _this.state.writeKey;

      return { writeKey: writeKey, segmentEnabled: true };
    }, _this.renderNotConnected = function () {
      var isOauth = _this.props.isOauth;

      if (isOauth) {
        return _this.renderOauthConnector();
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ConnectLink__["a" /* default */], { handleConnect: _this.handleConnect, connectorType: 'button', buttonType: 'tertiary' });
    }, _this.renderConnected = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Connected__["a" /* default */], { integrationId: 'segment', handleDisconnect: _this.handleDisconnect });
    }, _this.renderConnector = function () {
      var isConnected = _this.props.isConnected;

      if (isConnected) {
        return _this.renderConnected();
      } else {
        return _this.renderNotConnected();
      }
    }, _this.renderWriteKeyInput = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
        placeholder: 'e.g. 123456',
        label: 'SEGMENT WRITE KEY (optional)',
        valueLink: {
          requestChange: function requestChange(input) {
            _this.setState({ writeKey: input.trim() });
          },
          value: _this.state.writeKey
        },
        isValid: true
      });
    }, _this.renderHiddenSegmentButton = function () {
      var _this$props = _this.props,
          embedsByInboxId = _this$props.embedsByInboxId,
          accessToken = _this$props.apiKey.accessToken;

      var embedId = _.last(_.keys(embedsByInboxId));
      var dataSettings = JSON.stringify({ apiKey: accessToken, embedId: embedId });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: { display: 'none' },
        className: 'segment-enable-button',
        'data-integration': 'drift',
        'data-settings': dataSettings,
        'data-redirect-url': __WEBPACK_IMPORTED_MODULE_8_constants_ResourcesConstants__["c" /* APP_URL */] + '/accept-integration/segment'
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SegmentInstaller, [{
    key: 'showKeyInput',
    value: function showKeyInput() {
      this.setState({ showKey: true });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var segmentScript = document.createElement('script');
      segmentScript.src = ENABLE_BUTTON_SCRIPT_URL;
      document.head.appendChild(segmentScript);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var isConnected = _ref2.isConnected;

      var nextIsConnected = isConnected;
      var currentIsConnected = this.props.isConnected;
      if (currentIsConnected !== nextIsConnected) {
        this.setState({ updating: false });
        if (nextIsConnected) {
          this.app.actions.NotificationActions.pushNotification({
            content: 'Segment was successfully connected!'
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          updating = _state.updating,
          showKey = _state.showKey;
      var _props = this.props,
          isConnected = _props.isConnected,
          accessToken = _props.apiKey.accessToken;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        'With Segment you can install Drift on your site with one click, no need to touch any code at all! Just click the button below to connect your account and install the Drift widget.',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        'Need some help? Click ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: __WEBPACK_IMPORTED_MODULE_9__style_styl___default.a.Link, href: SEGMENT_HELP_URL },
          'here'
        ),
        ' for more details!',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        isConnected && accessToken && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Input"], {
            labelType: 'strong',
            className: 'segment-key-input',
            onClick: function onClick() {
              return _this2.showKeyInput();
            },
            description: 'Click to reveal. This key is used by Segment to authorize Segment data pushes to Drift.',
            type: showKey ? 'text' : 'password',
            value: accessToken,
            readOnly: true
          })
        ),
        updating ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { maxWidth: '50px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_shared_LoadingDots__["a" /* default */], null)
        ) : this.renderConnector(),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        "OPTIONAL: If you want your chat data to go back to Segment, enter your write key below. If you've already installed Drift without the ",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { className: __WEBPACK_IMPORTED_MODULE_9__style_styl___default.a.Link, href: WRITEKEY_HELP_URL },
          'write key'
        ),
        ", you'll need to disconnect and re-connect to enter it in now.",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        isConnected ? null : this.renderWriteKeyInput(),
        this.renderHiddenSegmentButton()
      );
    }
  }]);

  return SegmentInstaller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var SegmentInstallerContainer = Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(SegmentInstaller, {
  listenTo: ['stores.UserStore', 'stores.OrgPropertiesStore', 'stores.ApiKeyStore', 'stores.EmbedStore'],
  fetch: {
    currentUser: function currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    apiKey: function apiKey() {
      return this.app.stores.ApiKeyStore.getApiKeyForCurrentOrg();
    },
    embedsByInboxId: function embedsByInboxId() {
      return this.app.stores.EmbedStore.getOrFetchEmbedList();
    },
    orgProperties: function orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SegmentInstallerContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "tXUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListConstants__ = __webpack_require__("QBUr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IntegrationCard__ = __webpack_require__("6uMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_integrations_IntegrationList_styl__ = __webpack_require__("lGjg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styles_components_integrations_IntegrationList_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_styles_components_integrations_IntegrationList_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuse_js__ = __webpack_require__("z1nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_access_helpers__ = __webpack_require__("5TTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_svg_empty_integrations_svg__ = __webpack_require__("zkCP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_images_svg_empty_integrations_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_images_svg_empty_integrations_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_select_plus__ = __webpack_require__("+8W0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_SuggestIntegration__ = __webpack_require__("qGGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_SuggestIntegrationModal__ = __webpack_require__("HHjt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_Integration_helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_integrations_actions__ = __webpack_require__("M9ma");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

























var sortByNameCaseInsensitive = Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["sortBy"])(Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["compose"])(__WEBPACK_IMPORTED_MODULE_11_ramda__["toLower"], Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["prop"])('title')));

var isIntegrationVisible = function isIntegrationVisible(integration) {
  return integration.renderGate ? __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates(integration.renderGate) : true;
};

var createCustomIntegration = function createCustomIntegration(app, requiredGates, humanReadableId) {
  var id = humanReadableId || app.id;

  return {
    id: id,
    title: app.name,
    keywords: 'installed',
    description: app.shortDescription,
    logoSrc: app.iconUrl,
    path: '/settings/setup/' + id,
    installed: app.installed,
    requiredGates: requiredGates,
    isGatedByPlan: true,
    upgradeRibbonText: 'Upgrade'
  };
};

var FUSE_CONFIG = {
  keys: ['title', 'description', 'keywords', 'upgradeRibbonText'],
  threshold: 0.2
};

var NoResultsView = function NoResultsView(_ref) {
  var onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'integrations-empty-view' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', {
      className: 'integrations-empty-view-icon',
      src: __WEBPACK_IMPORTED_MODULE_12_images_svg_empty_integrations_svg___default.a
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'span',
      { className: 'integrations-empty-view-title' },
      'Whoops, we can\'t find the integration!'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'p',
      { className: 'integrations-empty-view-description' },
      'Looking for an integration we don\'t have? Let our team know!'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_18__driftt_tide_core_legacy__["Button"],
      { className: 'integrations-suggestion-button', onClick: onClick },
      'Suggest an integration'
    )
  );
};

var IntegrationCardGroup = function (_Component) {
  _inherits(IntegrationCardGroup, _Component);

  function IntegrationCardGroup() {
    _classCallCheck(this, IntegrationCardGroup);

    return _possibleConstructorReturn(this, (IntegrationCardGroup.__proto__ || Object.getPrototypeOf(IntegrationCardGroup)).apply(this, arguments));
  }

  _createClass(IntegrationCardGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          integrations = _props.integrations,
          integrationStates = _props.integrationStates;

      var visibleIntegrations = integrations.filter(isIntegrationVisible);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7_styles_components_integrations_IntegrationList_styl___default.a.IntegrationList },
        _.map(visibleIntegrations, function (integration) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_IntegrationCard__["a" /* default */], _extends({
            key: integration.id
          }, integration, {
            hasAccess: (_.has(integration, 'grandfathered') ? integration.grandfathered() : false) || (_.has(integration, 'requiredGates') ? __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates(integration.requiredGates) : true),
            isActive: integrationStates[integration.id] || false
          }));
        })
      );
    }
  }]);

  return IntegrationCardGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var IntegrationList = function (_Component2) {
  _inherits(IntegrationList, _Component2);

  function IntegrationList(props) {
    _classCallCheck(this, IntegrationList);

    var _this2 = _possibleConstructorReturn(this, (IntegrationList.__proto__ || Object.getPrototypeOf(IntegrationList)).call(this, props));

    _this2.fetchExternalIntegrations = function () {
      var isExternalIntegration = false;
      var mapToCard = function mapToCard(app) {
        if (__WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__["m" /* DRIFT_DEV_INTEGRATIONS */].has(app.name)) {
          return createCustomIntegration(app, [__WEBPACK_IMPORTED_MODULE_4_utils_Access__["a" /* DriftDevIntegrationGates */][app.id]], app.name.toLowerCase());
        } else if (app.id.length === 36) {
          isExternalIntegration = true;
        }

        var isIntegrationInList = function isIntegrationInList(app) {
          return _.find(_this2.state.publicExternalIntegrations, function (integration) {
            return app.id === integration.id;
          }) !== undefined;
        };

        var getExternalAppPath = function getExternalAppPath(app) {
          if (isIntegrationInList(app)) {
            return Object(__WEBPACK_IMPORTED_MODULE_19_components_Integration_helpers__["a" /* createAppName */])(app.name);
          }
          return app.id;
        };

        var getExternalAppName = function getExternalAppName(app) {
          var publicExternalIntegrationsList = _this2.state.publicExternalIntegrations;
          if (app.distributionStatus === "PUBLIC" && !isIntegrationInList(app)) {
            publicExternalIntegrationsList.push(app);
            _this2.setState({ publicExternalIntegrations: publicExternalIntegrationsList });
            return Object(__WEBPACK_IMPORTED_MODULE_19_components_Integration_helpers__["a" /* createAppName */])(app.name);
          }
        };

        return {
          id: isExternalIntegration ? getExternalAppName(app) : app.id,
          title: app.name,
          keywords: 'installed',
          description: app.shortDescription,
          logoSrc: app.iconUrl,
          path: '/settings/setup/' + (isExternalIntegration ? getExternalAppPath(app) : app.id),
          installed: app.installed
        };
      };

      var onFetched = function onFetched(apps) {
        var externalIntegrations = apps.map(mapToCard);
        _this2.setState({
          filteredIntegrations: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__ListConstants__["c" /* Integrations */]), _toConsumableArray(externalIntegrations)),
          externalIntegrations: externalIntegrations
        });
      };

      Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_integrations_api__["j" /* fetchInstalledApps */])().then(onFetched);
    };

    _this2.handleIntegrationCategorySelection = function (_ref2) {
      var value = _ref2.value;
      var keywords = __WEBPACK_IMPORTED_MODULE_5__ListConstants__["a" /* IntegrationCategories */][value].keywords;

      _this2.updateResults(keywords);
      _this2.setState({
        selectedIntegrationCategory: value,
        selectedIntegrationPlan: 'ALL',
        query: ''
      });
    };

    _this2.handleSearchInputChange = function (_ref3) {
      var target = _ref3.target;

      _this2.updateResults(target.value);
      _this2.setState({
        selectedIntegrationCategory: 'ALL',
        selectedIntegrationPlan: 'ALL',
        query: target.value
      });
    };

    _this2.searchIntegrations = function (searchTerm, integrations) {
      var externalIntegrations = _this2.state.externalIntegrations;

      if (searchTerm === 'installed') {
        var integrationStates = _this2.props.integrationStates;

        return [].concat(_toConsumableArray(integrations.filter(function (integration) {
          return integrationStates[integration.id];
        })), _toConsumableArray(externalIntegrations.filter(function (integration) {
          return integration.installed;
        })));
      } else if (searchTerm === 'partner') {
        // Return non-drift made third party applications.
        return externalIntegrations.filter(function (integration) {
          return !__WEBPACK_IMPORTED_MODULE_17_constants_ResourcesConstants__["m" /* DRIFT_DEV_INTEGRATIONS */].has(integration.title);
        });
      }

      var fuse = new __WEBPACK_IMPORTED_MODULE_8_fuse_js___default.a(integrations, FUSE_CONFIG);
      return fuse.search(searchTerm);
    };

    _this2.updateResults = function (updatedQuery) {
      var externalIntegrations = _this2.state.externalIntegrations;

      var allIntegrations = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__ListConstants__["c" /* Integrations */]), _toConsumableArray(externalIntegrations));

      var results = !!updatedQuery ? _this2.searchIntegrations(updatedQuery, allIntegrations) : allIntegrations;

      _this2.setState({ filteredIntegrations: results });
    };

    _this2.resolveCanRenderBuildSection = function () {
      var _this2$state = _this2.state,
          query = _this2$state.query,
          selectedIntegrationCategory = _this2$state.selectedIntegrationCategory,
          selectedIntegrationPlan = _this2$state.selectedIntegrationPlan;

      return !query && selectedIntegrationCategory === 'ALL' && selectedIntegrationPlan === 'ALL';
    };

    _this2.openModal = function () {
      _this2.setState({ openSuggestIntegrationModal: true });
    };

    _this2.closeModal = function () {
      _this2.setState({ openSuggestIntegrationModal: false });
    };

    _this2.state = {
      filteredIntegrations: __WEBPACK_IMPORTED_MODULE_5__ListConstants__["c" /* Integrations */],
      selectedIntegrationCategory: 'ALL',
      selectedIntegrationPlan: 'ALL',
      query: '',
      availableIntegrations: [],
      gatedIntegrations: [],
      isPaidPlan: __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates([__WEBPACK_IMPORTED_MODULE_4_utils_Access__["b" /* Gates */].PREMIUM, __WEBPACK_IMPORTED_MODULE_4_utils_Access__["b" /* Gates */].PREMIUM_TEAM]),
      externalIntegrations: [],
      openSuggestIntegrationModal: false,
      publicExternalIntegrations: []
    };
    return _this2;
  }

  _createClass(IntegrationList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.sortIntegrationsByGatedStatus();
      this.fetchExternalIntegrations();

      if (Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["isEmpty"])(this.props.integrationStates)) {
        this.props.actions.fetchIntegrationStates();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.sortIntegrationsByGatedStatus();
    }
  }, {
    key: 'sortIntegrationsByGatedStatus',
    value: function sortIntegrationsByGatedStatus() {
      var _state = this.state,
          isPaidPlan = _state.isPaidPlan,
          filteredIntegrations = _state.filteredIntegrations;

      // put them all in one bucket if not free plan

      if (isPaidPlan) {
        this.setState({
          availableIntegrations: filteredIntegrations
        });
        return;
      }

      var newState = _.reduce(filteredIntegrations, function (sorted, integration) {
        if (_.get(integration, 'requiredGates', false)) {
          if (__WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates(integration.requiredGates)) {
            sorted.availableIntegrations.push(integration);
          } else {
            sorted.gatedIntegrations.push(integration);
          }
        } else {
          sorted.availableIntegrations.push(integration);
        }
        return sorted;
      }, {
        availableIntegrations: [],
        gatedIntegrations: []
      });
      this.setState(newState);
    }
  }, {
    key: 'renderIntegrations',
    value: function renderIntegrations() {
      var _state2 = this.state,
          externalIntegrations = _state2.externalIntegrations,
          filteredIntegrations = _state2.filteredIntegrations;
      var integrationStates = this.props.integrationStates;

      if (integrationStates) {
        integrationStates['clearbit'] = !!integrationStates['clearbit_reveal'] || !!integrationStates['clearbit_enrichment'];
      }
      var integrations = sortByNameCaseInsensitive([].concat(_toConsumableArray(filteredIntegrations)));
      var externalIntegrationStates = externalIntegrations.map(function (integration) {
        return _defineProperty({}, integration.id, integration.installed);
      });
      var allIntegrationStates = _extends({}, integrationStates, Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["mergeAll"])(externalIntegrationStates));
      var canRenderBuildSection = this.resolveCanRenderBuildSection();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_components_shared_ConditionalRender__["a" /* default */],
          { condition: !Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["isEmpty"])(integrations) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IntegrationCardGroup, { integrations: integrations, integrationStates: allIntegrationStates }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_13_components_shared_ConditionalRender__["a" /* default */],
            { condition: canRenderBuildSection },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_SuggestIntegration__["a" /* default */], { onClick: this.openModal })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13_components_shared_ConditionalRender__["a" /* default */],
          { condition: Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["isEmpty"])(integrations) },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(NoResultsView, { onClick: this.openModal })
        )
      );
    }
  }, {
    key: 'renderCategoryDropDown',
    value: function renderCategoryDropDown() {
      var selectedIntegrationCategory = this.state.selectedIntegrationCategory;

      var options = Object(__WEBPACK_IMPORTED_MODULE_11_ramda__["toPairs"])(__WEBPACK_IMPORTED_MODULE_5__ListConstants__["a" /* IntegrationCategories */]).map(function (pair) {
        return { value: pair[0], label: pair[1].label };
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select_plus__["b" /* default */], {
        className: 'integrations-list-select integrations-list-select-categories',
        onChange: this.handleIntegrationCategorySelection,
        options: options,
        value: selectedIntegrationCategory,
        clearable: false,
        searchable: false,
        autosize: true,
        autofocus: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'integration-list-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_18__driftt_tide_core_legacy__["H3"],
          { className: 'integrations-header-title-description' },
          'Integrations'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'integrations-header' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'drift-form integrations-form' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
              type: 'text',
              placeholder: 'Search',
              value: this.state.query,
              onChange: this.handleSearchInputChange
            })
          ),
          this.renderCategoryDropDown()
        ),
        this.renderIntegrations(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_SuggestIntegrationModal__["a" /* default */], { open: this.state.openSuggestIntegrationModal, size: 'small', onClose: this.closeModal })
      );
    }
  }]);

  return IntegrationList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

IntegrationList.propTypes = {
  integrationStates: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    integrationStates: Object(__WEBPACK_IMPORTED_MODULE_21_app_modules_integrations_selectors__["c" /* connectionsRoot */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchIntegrationStates: __WEBPACK_IMPORTED_MODULE_20_app_modules_integrations_actions__["l" /* fetchIntegrationStates */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_access_helpers__["a" /* ensureIsAdmin */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(IntegrationList)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "tYz+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return api; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__);


var api = {
  fetchEloquaMappings: function fetchEloquaMappings() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/mappings/attributes').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchEloquaMappings: function patchEloquaMappings(mappings) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/eloqua/mappings/attributes', mappings).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchEloquaFields: function fetchEloquaFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/contact/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchEloquaCDOs: function fetchEloquaCDOs(query) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/custom_object/list?query=' + query + '&limit=50').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchEloquaCdoConfig: function fetchEloquaCdoConfig() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/cdo/config').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  patchEloquaCdoConfig: function patchEloquaCdoConfig(updates) {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].patch('/eloqua/cdo/config', updates).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  },
  fetchEloquaCdoFields: function fetchEloquaCdoFields() {
    return __WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["IntegrationAPI"].get('/eloqua/cdo/fields').then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["checkStatus"]).then(__WEBPACK_IMPORTED_MODULE_0__driftt_dapper__["json"]);
  }
};

/***/ }),

/***/ "tgWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* unused harmony export demoFunnelMetrics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeFakePerson; });
/* unused harmony export makeFakePeople */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeFakePeopleWithIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return demoContacts; });
/* unused harmony export demoPeople */
/* unused harmony export demoPeopleChatEngaged */
/* unused harmony export demoGoalLeads */
/* unused harmony export makeFakeChatHistogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_utils_faker__ = __webpack_require__("EOku");




var demoFunnelMetrics = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  'funnelMetrics': [{
    'displayName': 'Sent',
    'key': 'ENGAGED',
    'metric': {
      'value': 100,
      'type': 'FIXED'
    }
  }, {
    'displayName': 'Conversations',
    'key': 'CONVERSATIONS',
    'metric': {
      'value': 75,
      'type': 'FIXED'
    }
  }, {
    'displayName': 'Goals Reached',
    'key': 'GOAL_REACHED',
    'metric': {
      'value': 30,
      'type': 'FIXED'
    }
  }, {
    'displayName': 'CQLs',
    'key': 'CQL',
    'metric': {
      'value': 40,
      'type': 'FIXED'
    }
  }, {
    'displayName': 'Meetings Booked',
    'key': 'MEETINGS_BOOKED',
    'metric': {
      'value': 20,
      'type': 'FIXED'
    }
  }],
  'otherMetrics': [{
    'displayName': 'Emails Captured',
    'key': 'LEADS_CAPTURED',
    'metric': {
      'value': 0,
      'type': 'FIXED'
    }
  }, {
    'displayName': 'Delivered',
    'key': 'DELIVERED',
    'metric': {
      'value': 0,
      'type': 'FIXED'
    }
  }]
});

var makeFakePerson = function makeFakePerson(id) {
  return {
    id: id,
    name: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["d" /* fullName */])(),
    companyName: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["b" /* companyName */])(),
    jobTitle: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["e" /* jobTitle */])(),
    email: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["c" /* email */])(),
    leadStage: 'LeadBot Qualified',
    avatarUrl: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["a" /* avatar */])(),
    conversationDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["h" /* recentDate */])()).format('YYYY-MM-DD'),
    conversationId: id,
    inboxId: 41,
    attributes: {
      start_date: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["f" /* pastDate */])(),
      last_active: Object(__WEBPACK_IMPORTED_MODULE_2_app_utils_faker__["h" /* recentDate */])()
    }
  };
};

var makeFakePeople = function makeFakePeople(numPeople) {
  return _.range(numPeople).map(makeFakePerson);
};

var makeFakePeopleWithIds = function makeFakePeopleWithIds(numPeople, ids) {
  return _.forEach(ids).map(makeFakePerson);
};

var demoContacts = {
  "results": makeFakePeople(20),
  "totalMatching": 20
};

var demoPeople = makeFakePeople(100);

var demoPeopleChatEngaged = {
  people: demoPeople,
  total: 100
};

var demoGoalLeads = { 'leadStages': {}, 'other': { 'no_goal': { 'value': 3, 'type': 'FIXED' } }, 'total': 14 };

var generateFakeHistogram = function generateFakeHistogram(date) {
  return _.range(date.date()).map(function (i) {
    return {
      date: {
        value: __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).subtract(i, 'days').format('YYYY-MM-DD'),
        type: 'DATE'
      },
      'GOAL_REACHED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'CONVERSATIONS': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'ENGAGED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'MEETINGS_BOOKED': {
        'value': _.random(5),
        'type': 'FIXED'
      },
      'CQL': {
        'value': _.random(5),
        'type': 'FIXED'
      }
    };
  }).reverse();
};

var makeFakeChatHistogram = function makeFakeChatHistogram() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
    current: generateFakeHistogram(__WEBPACK_IMPORTED_MODULE_1_moment___default()()),
    previous: generateFakeHistogram(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'months').endOf('month')),
    metadata: {
      'GOAL_REACHED': 'Goals Reached',
      'CONVERSATIONS': 'Conversations',
      'MEETINGS_BOOKED': 'Meetings Booked',
      'ENGAGED': 'Sent',
      'CQL': 'CQLs'
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "tiT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__ = __webpack_require__("KP0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__ = __webpack_require__("VAK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_assistantSettings_selectors__ = __webpack_require__("EoOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("Ib5B");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













function mapStateToProps(state) {
  return {
    assistantAgentSettings: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_assistantSettings_selectors__["a" /* assistantAgentSettings */])(state),
    hasProPlan: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_gates_selectors__["o" /* hasProPlan */])(state),
    userProperties: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_user_properties_selectors__["g" /* properties */])(state),
    meetingSettings: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_meetings_selectors__["m" /* getMeetingSettings */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["i" /* fetchAssistantAgentSettings */],
      patchAssistantAgentSettings: __WEBPACK_IMPORTED_MODULE_4_app_modules_assistantSettings_actions__["D" /* patchAssistantAgentSettings */],
      openedMeetingEmailModal: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["_13" /* openedMeetingEmailModal */],
      fetchMeetingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["K" /* fetchMeetingSettings */],
      updateMeetingSettings: __WEBPACK_IMPORTED_MODULE_3_app_modules_meetings_actions__["_23" /* updateMeetingSettings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    this.props.actions.fetchAssistantAgentSettings();
    this.props.actions.fetchMeetingSettings();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (_ref) {
  var assistantAgentSettings = _ref.assistantAgentSettings,
      userProperties = _ref.userProperties;
  return {
    confirmationEmailStatus: assistantAgentSettings.getIn(['MEETING_CONFIRMATION', 'on'], false),
    confirmationDelayTime: assistantAgentSettings.getIn(['MEETING_CONFIRMATION', 'delayTime'], false),
    reminderEmailStatus: assistantAgentSettings.getIn(['MEETING_REMINDER', 'on'], false),
    reminderDelayTime: assistantAgentSettings.getIn(['MEETING_REMINDER', 'delayTime'], false),
    reminderFollowUpDelayTime: assistantAgentSettings.getIn(['MEETING_REMINDER_FOLLOW', 'delayTime'], false),
    seenPersonalizationEmailEducation: userProperties.get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION', false)
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  toggleMeetingConfirmationStatus: function toggleMeetingConfirmationStatus(_ref2) {
    var actions = _ref2.actions,
        assistantAgentSettings = _ref2.assistantAgentSettings,
        confirmationEmailStatus = _ref2.confirmationEmailStatus;
    return function () {
      var newSettings = assistantAgentSettings.setIn(['MEETING_CONFIRMATION', 'on'], !confirmationEmailStatus).setIn(['MEETING_RESCHEDULE_CONFIRMATION', 'on'], !confirmationEmailStatus);
      return actions.patchAssistantAgentSettings({ settings: newSettings, meetingCopy: true });
    };
  },
  toggleMeetingReminderStatus: function toggleMeetingReminderStatus(_ref3) {
    var actions = _ref3.actions,
        assistantAgentSettings = _ref3.assistantAgentSettings,
        reminderEmailStatus = _ref3.reminderEmailStatus;
    return function () {
      var newSettings = assistantAgentSettings.setIn(['MEETING_REMINDER', 'on'], !reminderEmailStatus).setIn(['MEETING_REMINDER_FOLLOW', 'on'], !reminderEmailStatus);
      return actions.patchAssistantAgentSettings({ settings: newSettings, meetingCopy: true });
    };
  },
  toggleMeetingManagement: function toggleMeetingManagement(_ref4) {
    var actions = _ref4.actions,
        meetingSettings = _ref4.meetingSettings;
    return function () {
      var _meetingSettings$allo = meetingSettings.allowMeetingManagement,
          allowMeetingManagement = _meetingSettings$allo === undefined ? false : _meetingSettings$allo;

      var settings = meetingSettings.set('allowMeetingManagement', !allowMeetingManagement);
      actions.updateMeetingSettings(settings);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["k" /* withStateHandlers */])({
  confirmationModal: false,
  reminderModal: false,
  gatedModal: false
}, {
  toggleModal: function toggleModal() {
    return function (modalName, state) {
      return _defineProperty({}, modalName, state);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),

/***/ "tp7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Inbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SendingDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Whitelabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var Inbox = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: undefined,
  orgId: undefined,
  name: undefined,
  address: undefined,
  forwardAddress: undefined,
  status: undefined,
  createdAt: 0,
  totalConversationCount: 0,
  openConversationCount: 0,
  fetchStatus: undefined
});

var SendingDomain = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  createdAt: undefined,
  domain: undefined,
  id: undefined,
  orgId: undefined,
  sendgridDkim: undefined,
  sendgridDkimStatus: undefined,
  status: undefined,
  updatedAt: undefined,
  sparkPostDkimStatus: undefined,
  sparkPostDkim: undefined
});

var Whitelabel = __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"];

/***/ }),

/***/ "tq3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Button__ = __webpack_require__("1iW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_CheckBox__ = __webpack_require__("cbHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderBody_styl__ = __webpack_require__("XK6v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HeaderBody_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HeaderBody_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_customer_EndUserAttributesCard_AttributesModal_ModalHeader__ = __webpack_require__("v9lS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_customer_EndUserAttributesCard_helper__ = __webpack_require__("VkOt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_customer_CompanyCard_CancelAndSave__ = __webpack_require__("h2QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_customer_EndUserAttributesCard_AttributesModal_Category__ = __webpack_require__("4ulW");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var Icon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
  src: __webpack_require__("Hbft"),
  style: { width: 25, height: 17, marginRight: 12 },
  element: 'div'
});

var AttributesModal = function (_Component) {
  _inherits(AttributesModal, _Component);

  function AttributesModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AttributesModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AttributesModal.__proto__ || Object.getPrototypeOf(AttributesModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      search: '',
      hideBlank: false
    }, _this.onSearchChange = function (search) {
      _this.setState({ search: search });
    }, _this.onCheckBoxSelection = function () {
      _this.setState({ hideBlank: !_this.state.hideBlank });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AttributesModal, [{
    key: 'filterRows',
    value: function filterRows(rows) {
      var _props = this.props,
          enabledAttributes = _props.enabledAttributes,
          createAttributeCheckBoxChange = _props.createAttributeCheckBoxChange;
      var _state = this.state,
          hideBlank = _state.hideBlank,
          search = _state.search;

      return rows.filter(function (_ref2) {
        var empty = _ref2.empty,
            value = _ref2.value;

        if (hideBlank && typeof empty === 'undefined') {
          return typeof value !== 'undefined' && value !== null;
        }
        if (hideBlank) return !empty;
        return true;
      }).filter(function (_ref3) {
        var label = _ref3.label;
        return !search || label && label.indexOf(search) !== -1;
      }).map(function (_ref4) {
        var label = _ref4.label,
            rest = _objectWithoutProperties(_ref4, ['label']);

        return _extends({
          label: label,
          checked: enabledAttributes.has(label),
          handleCheckBoxChange: createAttributeCheckBoxChange(label)
        }, rest);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onClose = _props2.onClose,
          contactRows = _props2.contactRows,
          socialRows = _props2.socialRows,
          driftRows = _props2.driftRows,
          customRows = _props2.customRows,
          changed = _props2.changed,
          handleCancel = _props2.handleCancel,
          handleSave = _props2.handleSave,
          handleEdit = _props2.handleEdit,
          editing = _props2.editing,
          updating = _props2.updating;
      var _state2 = this.state,
          search = _state2.search,
          hideBlank = _state2.hideBlank;


      var filteredContactRows = this.filterRows(contactRows);
      var filteredSocialRows = this.filterRows(socialRows);
      var filteredDriftRows = this.filterRows(driftRows);
      var filteredCustomRows = this.filterRows(customRows);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9_components_shared_Modal__["a" /* default */],
        {
          onRequestClose: onClose,
          isOpen: true,
          style: {
            content: {
              padding: 0,
              width: 550,
              maxHeight: '90%',
              overflowY: 'auto'
            }
          }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_components_customer_EndUserAttributesCard_AttributesModal_ModalHeader__["a" /* default */],
          { onClose: onClose },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dsg-Title flex ' + __WEBPACK_IMPORTED_MODULE_5__HeaderBody_styl__["HeaderBody"] },
            Icon,
            'All Attributes'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { padding: 27 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_shared_web_src_components_Input___default.a, {
            placeholder: 'Search',
            isValid: true,
            valueLink: {
              requestChange: this.onSearchChange,
              value: search
            },
            size: 'medium'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'flex-space-between', style: { padding: '5px 0 15px 0' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'flex' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_CheckBox___default.a, {
                id: 'hideBlank',
                checked: hideBlank,
                onChange: this.onCheckBoxSelection
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                {
                  className: 'dsg-Body color-navy-dark',
                  style: { paddingLeft: 5 }
                },
                'Hide Blank Properties'
              )
            ),
            editing ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_customer_CompanyCard_CancelAndSave__["a" /* default */], {
              updating: updating,
              changed: changed,
              onCancel: handleCancel,
              onSave: handleSave
            }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'link edit dsg-Body', onClick: handleEdit },
              'Edit'
            )
          ),
          filteredContactRows.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_customer_EndUserAttributesCard_AttributesModal_Category__["a" /* default */], { title: 'Contact Attributes', rows: filteredContactRows, editing: editing }) : null,
          filteredSocialRows.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_customer_EndUserAttributesCard_AttributesModal_Category__["a" /* default */], { title: 'Social Attributes', rows: filteredSocialRows, editing: editing }) : null,
          filteredDriftRows.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_customer_EndUserAttributesCard_AttributesModal_Category__["a" /* default */], { title: 'Drift Attributes', rows: filteredDriftRows, editing: editing }) : null,
          filteredCustomRows.size ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_customer_EndUserAttributesCard_AttributesModal_Category__["a" /* default */], { title: 'Custom Attributes', rows: filteredCustomRows.toList(), editing: editing }) : null,
          !editing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Button__["a" /* default */],
            {
              className: 'flex-center',
              cta: true,
              style: { width: '100%' },
              onClick: onClose
            },
            'done'
          )
        )
      );
    }
  }]);

  return AttributesModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_components_customer_EndUserAttributesCard_helper__["a" /* default */])(AttributesModal));

/***/ }),

/***/ "twml":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__ = __webpack_require__("iL8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__ = __webpack_require__("oThQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__ = __webpack_require__("2+Aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_geolocation_selectors__ = __webpack_require__("FBvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_geolocation_actions__ = __webpack_require__("UEdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component__ = __webpack_require__("4f8u");















var mapStateToProps = function mapStateToProps(state) {
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["a" /* backgroundColor */](state),
    embedLoaded: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["e" /* embedLoaded */](state),
    logoUrl: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["o" /* logoUrl */](state),
    orgId: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["j" /* getOrgId */](state),
    embedNotFetched: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["f" /* embedNotFetched */](state),
    embedLoadFailed: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["d" /* embedLoadFailed */](state),
    embedFetchPending: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["c" /* embedFetchPending */](state),
    organizationName: __WEBPACK_IMPORTED_MODULE_6_app_modules_embed_selectors__["k" /* getOrgName */](state),
    unsubscribePending: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["q" /* unsubscribePending */](state),
    unsubscribed: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["r" /* unsubscribed */](state),
    unsubscribeError: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["o" /* unsubscribeError */](state),
    unsubscribeErrorMessage: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["p" /* unsubscribeErrorMessage */](state),
    resubscribePending: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["k" /* resubscribePending */](state),
    resubscribed: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["l" /* resubscribed */](state),
    resubscribeError: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["i" /* resubscribeError */](state),
    resubscribeErrorMessage: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["j" /* resubscribeErrorMessage */](state),
    isFetchGeolocationPending: __WEBPACK_IMPORTED_MODULE_8_app_modules_geolocation_selectors__["c" /* isFetchGeolocationPending */](state),
    isGeolocationLoaded: __WEBPACK_IMPORTED_MODULE_8_app_modules_geolocation_selectors__["d" /* isGeolocationLoaded */](state),
    // If we failed to fetch geolocation data, assume that the visitor may be
    // coming from a GDPR-applicable IP address.
    isGdprConsentRequired: __WEBPACK_IMPORTED_MODULE_8_app_modules_geolocation_selectors__["b" /* isFetchGeolocationFailure */](state) || __WEBPACK_IMPORTED_MODULE_8_app_modules_geolocation_selectors__["a" /* getIsGdprApplicable */](state),
    unsubRequestDeleteStatus: __WEBPACK_IMPORTED_MODULE_7_app_modules_endUser_selectors__["n" /* unsubRequestDeleteStatus */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      unsubscribe: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["W" /* unsubscribeById */],
      unsubscribeByEncodedEmail: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["V" /* unsubscribeByEncodedEmail */],
      unsubscribeByEmailAndOrg: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["U" /* unsubscribeByEmailAndOrgId */],
      resubscribe: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["O" /* resubscribe */],
      resubscribeByEmailandOrgId: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["P" /* resubscribeByEmailandOrgId */],
      requestDeleteData: __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["K" /* requestUnsubDeleteData */],
      fetchEmbedById: __WEBPACK_IMPORTED_MODULE_5_app_modules_embed_actions__["b" /* fetchEmbedById */],
      fetchGeolocation: __WEBPACK_IMPORTED_MODULE_9_app_modules_geolocation_actions__["a" /* fetchGeolocation */]
    }, dispatch)
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('responded', 'setResponded', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('resubscribed', 'setResubscribe', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('unsubscribed', 'setUnsubscribe', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  // certain email clients html decode links (i.e. "&email=ryan" -> "&amp;email=ryan")
  // looks like it's most prevalent on Windows machines running IE
  var queryParams = props.location.query;
  var params = {
    endUserId: queryParams.endUserId || queryParams['amp;endUserId'],
    // orgId might have already been loaded from the embed
    orgId: props.orgId || queryParams.orgId || queryParams['amp;orgId'],
    campaignId: queryParams.d_campaign || queryParams['amp;d_campaign'],
    email: queryParams.email || queryParams['amp;email'],
    identifier: queryParams.identifier || queryParams['amp;identifier'],
    embedId: queryParams.embedId || queryParams['amp;embedId']

    // we're removing the email from the query params and instead adding "identifier"
  };if (!!params.identifier && !params.email) {
    try {
      params.email = atob(params.identifier);
    } catch (err) {
      // the email wansn't base64 encoded and URI encoded correctly
      Object(__WEBPACK_IMPORTED_MODULE_10_utils_SentryHelpers__["a" /* captureException */])(err, {
        extra: {
          searchQuery: Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["omit"])(props.location.query, 'email')
        }
      });
    }
  }

  return params;
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('forceShowLoading', 'setForceShowLoading', true), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('cantUnsub', 'setCantUnsub', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('cantResub', 'setCantResub', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    var _this = this;

    if (!this.props.isGeolocationLoaded && !this.props.isFetchGeolocationPending) {
      this.props.actions.fetchGeolocation();
    }

    if (this.props.embedNotFetched) {
      this.props.actions.fetchEmbedById(this.props.embedId);
    }
    setTimeout(function () {
      return _this.props.setForceShowLoading(false);
    }, 1500);
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('emailInput', 'setEmailInput', function (props) {
  return props.email;
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('unsubscribeChoice', 'setUnsubscribeChoice', null), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  var unsubPending = props.unsubscribePending || props.unsubscribeChoice === __WEBPACK_IMPORTED_MODULE_11__component__["c" /* unsubscribeChoices */].UNSUB_AND_REQUEST_DELETE && props.unsubRequestDeleteStatus === __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["M" /* requestUnsubDeleteDataPending */].toString();
  return {
    handleResponseClick: function handleResponseClick(reason) {
      return function () {
        props.actions.unsubscribe({ endUserId: props.endUserId, reason: reason, email: props.emailInput });
        props.setResponded(true);
      };
    },
    showLoading: props.forceShowLoading || props.embedFetchPending || props.isFetchGeolocationPending,
    confirmDisabled: unsubPending || props.isGdprConsentRequired && props.unsubscribeChoice === null,
    unsubRequestDeleteSuccess: props.unsubRequestDeleteStatus === __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["N" /* requestUnsubDeleteDataSuccess */].toString(),
    unsubPending: props.unsubscribePending || props.unsubscribeChoice === __WEBPACK_IMPORTED_MODULE_11__component__["c" /* unsubscribeChoices */].UNSUB_AND_REQUEST_DELETE && props.unsubRequestDeleteStatus === __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["M" /* requestUnsubDeleteDataPending */].toString(),
    requestDeleteFailed: props.unsubRequestDeleteStatus === __WEBPACK_IMPORTED_MODULE_4_app_modules_endUser_actions__["L" /* requestUnsubDeleteDataFailed */].toString()
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onEmailConfirmChange: function onEmailConfirmChange(props) {
    return function (e) {
      props.setEmailInput(e.target.value);
    };
  },
  onUnsubChoiceChange: function onUnsubChoiceChange(props) {
    return function (choice) {
      props.setUnsubscribeChoice(choice);
    };
  },
  onConfirmClick: function onConfirmClick(props) {
    return function () {
      if (props.unsubscribeChoice === __WEBPACK_IMPORTED_MODULE_11__component__["c" /* unsubscribeChoices */].UNSUB_AND_REQUEST_DELETE) {
        props.actions.requestDeleteData({ orgId: props.orgId, email: props.emailInput, endUserId: props.endUserId });
        props.setUnsubscribe(true);
      }
      if (!!props.endUserId) {
        props.actions.unsubscribeByEncodedEmail({ email: props.emailInput, endUserId: props.endUserId });
        props.setUnsubscribe(true);
      } else if (!!props.emailInput && !!props.orgId) {
        props.actions.unsubscribeByEmailAndOrg({ email: props.emailInput, orgId: props.orgId });
        props.setUnsubscribe(true);
      } else {
        props.setCantUnsub(true);
        Object(__WEBPACK_IMPORTED_MODULE_10_utils_SentryHelpers__["a" /* captureException */])('Need endUserId OR (orgId AND email) to unsubscribe', {
          extra: {
            orgId: props.orgId,
            endUserId: props.endUserId,
            emailInput: props.emailInput
          }
        });
      }
    };
  },
  onResubscribeClick: function onResubscribeClick(props) {
    return function () {
      if (!!props.endUserId) {
        props.actions.resubscribe({ email: props.emailInput, endUserId: props.endUserId });
        props.setResubscribe(true);
        props.setUnsubscribe(false);
      } else if (!!props.emailInput && !!props.orgId) {
        props.actions.resubscribeByEmailandOrgId({ email: props.emailInput, orgId: props.orgId });
        props.setResubscribe(true);
        props.setUnsubscribe(false);
      } else {
        props.setUnsubscribe(true);
        props.setCantResub(true);
        props.setCantUnsub(false);
        Object(__WEBPACK_IMPORTED_MODULE_10_utils_SentryHelpers__["a" /* captureException */])('Need endUserId and email, or email and orgId to resubscribe', {
          extra: {
            endUserId: props.endUserId,
            emailInput: props.emailInput,
            orgId: props.orgId
          }
        });
      }
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["a" /* branch */])(function (props) {
  return props.showLoading;
}, Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["f" /* renderComponent */])(__WEBPACK_IMPORTED_MODULE_11__component__["b" /* Loading */])))(__WEBPACK_IMPORTED_MODULE_11__component__["a" /* Confirm */]));

/***/ }),

/***/ "tx/f":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g transform=\"translate(1 1)\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M9.62 12.556h1.56c.25 0 .385-.173.385-.404v-.635c0-1.155 2.926-1.83 2.926-4.158 0-1.888-1.712-3.235-3.734-3.235-2.464 0-3.773 1.694-3.773 1.694-.134.134-.154.365 0 .5l.905.885c.135.115.27.115.424.02.385-.25.904-1.002 2.08-1.002.96 0 1.54.597 1.54 1.29 0 1.348-2.677 2.04-2.677 3.87v.808c0 .213.173.367.366.367zm-.808 3.85c0 .867.712 1.58 1.58 1.58.865 0 1.596-.713 1.596-1.58 0-.866-.73-1.597-1.597-1.597-.866 0-1.578.73-1.578 1.597z\" fill=\"#9A9A9A\"></path><circle stroke=\"#979797\" stroke-width=\"2\" cx=\"11\" cy=\"11\" r=\"11\"></circle></g></svg>"

/***/ }),

/***/ "u+jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);



var SendButton = function SendButton(_ref) {
  var className = _ref.className,
      emailButtonLabel = _ref.emailButtonLabel,
      isSaved = _ref.isSaved,
      scheduleEmailButtonActive = _ref.scheduleEmailButtonActive,
      hasSegmentsSelected = _ref.hasSegmentsSelected,
      handleScheduleClick = _ref.handleScheduleClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      {
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'drift-button-primary', className),
        disabled: !scheduleEmailButtonActive || !isSaved || !hasSegmentsSelected || disabled,
        onClick: handleScheduleClick
      },
      emailButtonLabel
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SendButton);

/***/ }),

/***/ "u/Km":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("wEE2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var OrgSwitcherSection = function (_Component) {
  _inherits(OrgSwitcherSection, _Component);

  function OrgSwitcherSection(props) {
    _classCallCheck(this, OrgSwitcherSection);

    var _this = _possibleConstructorReturn(this, (OrgSwitcherSection.__proto__ || Object.getPrototypeOf(OrgSwitcherSection)).call(this, props));

    _this.switchOrg = function (token) {
      window.analytics && window.analytics.track('Org Switched', {});
      Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["setAccessToken"])({ token: token });
      window.location.replace('/');
    };

    _this.clearOrgOption = function (token) {
      Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["clearIdentityInfo"])(token);
      _this.setState({ displayableIdentities: Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["getDisplayableIdentities"])() }, function () {
        _this.onScroll(); //recompute if we have to show scroll arrows
        _this.props.onChange();
      });
    };

    _this.renderOrgOption = function (identity) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { key: identity.email, className: 'org-switcher-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: 'org-switcher-avatar-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Avatar"], { user: identity })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: 'org-switcher-info', onClick: function onClick() {
              return _this.switchOrg(identity.token);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["P"],
            { className: 'org-switcher-user-name org-switcher-user-identifier' },
            identity.name
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["P"],
            { className: 'org-switcher-user-identifier' },
            identity.email
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: 'org-switcher-remove-account-container', key: identity.token, onClick: function onClick() {
              return _this.clearOrgOption(identity.token);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'org-switcher-remove-account', name: 'close', width: 12 })
        )
      );
    };

    _this.renderAddAccountOption = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { className: 'org-switcher-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: 'org-switcher-avatar-container org-switcher-plus-sign-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { width: 25, height: 25, name: 'plus' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
          { className: 'org-switcher-info', onClick: function onClick() {
              return document.location = __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["B" /* LOGIN_APP_URL */];
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["P"],
            { className: 'org-switcher-user-name org-switcher-user-identifier' },
            'Add account'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["P"],
            { className: 'org-switcher-user-identifier' },
            'Log in as another user'
          )
        )
      );
    };

    _this.renderScrollIndicator = function (iconName) {
      var _this$state = _this.state,
          canScrollUp = _this$state.canScrollUp,
          canScrollDown = _this$state.canScrollDown;

      var isUpArrow = iconName === "chevron-up";

      var scroll = function scroll(direction) {
        try {
          _this.listRef.scrollBy(0, 150 * direction); //3 options per page, 50px per option
        } catch (e) {
          console.error(e); //scrollBy doesn't work on Edge
        }
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('org-switcher-scroll-indicator', iconName, { 'canScroll': isUpArrow && canScrollUp || !isUpArrow && canScrollDown }), onClick: function onClick() {
            return scroll(isUpArrow ? -1 : 1);
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { name: iconName, height: '10px', width: '10px' })
      );
    };

    _this.onScroll = function () {
      var displayableIdentities = _this.state.displayableIdentities;

      var maxScrollTop = 50 * displayableIdentities.length + 50 - _this.listRef.offsetHeight;
      // = combined height of list items plus height of add account option minus height of the list view

      _this.setState({
        canScrollUp: _this.listRef.scrollTop > 0,
        canScrollDown: _this.listRef.scrollTop < maxScrollTop
      });
    };

    _this.state = {
      displayableIdentities: Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["getDisplayableIdentities"])(),
      canScrollUp: false,
      canScrollDown: Object(__WEBPACK_IMPORTED_MODULE_2__driftt_web_auth__["getDisplayableIdentities"])().length >= 3
    };
    _this.setListRef = function (element) {
      return _this.listRef = element;
    };
    return _this;
  }

  _createClass(OrgSwitcherSection, [{
    key: 'render',
    value: function render() {
      var displayableIdentities = this.state.displayableIdentities;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        null,
        this.renderScrollIndicator("chevron-up"),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'org-switcher-list-container', ref: this.setListRef, onScroll: this.onScroll },
          displayableIdentities.map(this.renderOrgOption),
          this.renderAddAccountOption()
        ),
        this.renderScrollIndicator("chevron-down")
      );
    }
  }]);

  return OrgSwitcherSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (OrgSwitcherSection);

/***/ }),

/***/ "u1z1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export root */
/* unused harmony export getConversationMetrics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSFDCMetricMappings; });
/* unused harmony export getSFDCTaskFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSFDCPatchMetricsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSFDCPatchMetricsErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isSFDCObjectListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return sfdcObjectListErrStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSFDCAccountFieldsListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isSFDCContactFieldsListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isSFDCLeadFieldsListLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sfdcFieldListErrStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isSFDCLeadRoutingSettingsLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sfdcLeadRoutingSettingsErrStatus; });
/* unused harmony export getSalesforceEnrichmentByEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return makeGetSalesforceEnrichmentByEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSFDCEnrichmentFields; });
/* unused harmony export sfdcEnrichmentFieldsErrStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var root = function root(state) {
  return state.get('sfdc');
};

var getConversationMetrics = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.conversationMetrics;
});

var getSFDCMetricMappings = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcMetricMappings;
});

var getSFDCTaskFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcTaskFields;
});

var getSFDCPatchMetricsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcPatchMetricsLoading;
});

var getSFDCPatchMetricsErr = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcPatchMetricsErr;
});

var isSFDCObjectListLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcObjectList;
});

var sfdcObjectListErrStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcObjectListErr;
});

var isSFDCAccountFieldsListLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcAccountFieldsList;
});

var isSFDCContactFieldsListLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcContactFieldsList;
});

var isSFDCLeadFieldsListLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcLeadFieldsList;
});

var sfdcFieldListErrStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcFieldsListErr;
});

var isSFDCLeadRoutingSettingsLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcLeadRoutingSettings;
});

var sfdcLeadRoutingSettingsErrStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcLeadRoutingSettingsErr;
});

var getSalesforceEnrichmentByEmail = function getSalesforceEnrichmentByEmail(state, email) {
  return root(state).enrichment[email];
};

var makeGetSalesforceEnrichmentByEmail = function makeGetSalesforceEnrichmentByEmail() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getSalesforceEnrichmentByEmail, function (salesforceEnrichment) {
    return salesforceEnrichment;
  });
};

var getSFDCEnrichmentFields = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcEnrichmentFields;
});

var sfdcEnrichmentFieldsErrStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(root, function (root) {
  return root.sfdcEnrichmentFieldsErr;
});

/***/ }),

/***/ "u9CK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uGjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_integrated_help_launcher__ = __webpack_require__("vS8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_integrated_help_launcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_integrated_help_launcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var HelpFlyout = function (_Component) {
  _inherits(HelpFlyout, _Component);

  function HelpFlyout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HelpFlyout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HelpFlyout.__proto__ || Object.getPrototypeOf(HelpFlyout)).call.apply(_ref, [this].concat(args))), _this), _this.triggerTicketPlaybook = function () {
      window.drift.api.startInteraction({ interactionId: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["_1" /* SUPPORT_TICKET_INTERACTION_ID */] });
    }, _this.triggerFreeIntegratedHelp = function () {
      window.drift.api.startInteraction({ interactionId: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["J" /* PAID_USER_INTEGRATED_HELP_INTERACTION_ID */] });
    }, _this.triggerPaidIntegratedHelp = function () {
      window.drift.api.startInteraction({ interactionId: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["J" /* PAID_USER_INTEGRATED_HELP_INTERACTION_ID */] });
    }, _this.triggerIntegratedHelp = function () {
      if (__WEBPACK_IMPORTED_MODULE_5__driftt_integrated_help_launcher__["helpUtils"].shouldLaunchHelpInteraction()) {
        var isPaidUser = __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasGates('premium_drift');
        isPaidUser ? _this.triggerPaidIntegratedHelp() : _this.triggerFreeIntegratedHelp();
        __WEBPACK_IMPORTED_MODULE_5__driftt_integrated_help_launcher__["helpUtils"].saveHelpInteractionStart();
      } else {
        window.drift.api.openChat();
      }
    }, _this.handleChatWidget = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'help-flyout-option-item' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'help-options-question-icon', name: 'comments-1' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { onClick: function onClick() {
              _this.triggerIntegratedHelp();
              return _this.handleLinkTracking('chat-widget', 'open chat widget', 'Chat with us');
            } },
          'Chat with us'
        )
      );
    }, _this.handleLinkTracking = function (key, cta, text) {
      _this.props.trackHelpFlyout({ eventType: 'clicked', ctaInfo: { key: key, type: 'link', CTA: cta, text: text } });
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HelpFlyout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.trackHelpFlyout({ eventType: 'viewed' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'help-flyout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          'How can we help?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'help-flyout-options' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'nav',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'help-flyout-option-item' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'help-options-window-icon', name: 'window-search' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: __WEBPACK_IMPORTED_MODULE_6_constants_ResourcesConstants__["x" /* HELP_URL */], target: '_blank', onClick: function onClick() {
                    return _this2.handleLinkTracking('help-center', 'trigger help center', 'Search our Help Center');
                  } },
                'Search our Help Center'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'help-flyout-option-item' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'help-options-lightning-icon', name: 'lightning-bolt' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://insider.drift.com/classes', target: '_blank', onClick: function onClick() {
                    return _this2.handleLinkTracking('webinar-page', 'trigger drift insider classes page', 'Find a Training');
                  } },
                'Find a Training'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].hasPaidGates() && this.handleChatWidget(),
            __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].isAdmin() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'help-flyout-option-item' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'help-options-comments-icon', name: 'question-bubble' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { onClick: function onClick() {
                    _this2.triggerTicketPlaybook();
                    return _this2.handleLinkTracking('help-request-submit', 'trigger ticket playbook', 'Submit a help request');
                  } },
                'Submit a help request'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_4_utils_Access__["c" /* default */].isAdmin() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'help-flyout-option-item' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { className: 'help-options-support-icon', name: 'support-ticket' }),
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: '/settings2/help', onClick: function onClick() {
                    return _this2.handleLinkTracking('help-request-page', 'trigger support requests page', 'View your help requests');
                  } },
                'View your help requests'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'help-flyout-option-item' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Icon"], { height: 16, width: 16, name: 'notification' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: 'https://drift.status.io', target: '_blank', rel: 'noreferrer noopener', onClick: function onClick() {
                    return _this2.handleLinkTracking('check-status-page', 'trigger status check page', 'Check out Drift\'s status');
                  } },
                'Check out Drift\'s status'
              )
            )
          )
        )
      );
    }
  }]);

  return HelpFlyout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator___default()(HelpFlyout));

/***/ }),

/***/ "uHIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_api__ = __webpack_require__("4PhQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_models__ = __webpack_require__("kBO7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_RulesEditorOverview___ = __webpack_require__("+7L0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_RulesEditor__ = __webpack_require__("NgrA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl__ = __webpack_require__("V/l/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var actionOnlyFilters = new Set(['onlineUsers']);
var isActionOnlyField = function isActionOnlyField(fieldName) {
  return actionOnlyFilters.has(fieldName);
};
var buildRuleFromFilter = function buildRuleFromFilter(previousRule, newFilters) {
  var newItem = _extends({}, previousRule.data.item, { conditions: [newFilters] });
  return _extends({}, previousRule, { data: { item: newItem } });
};

var RulesEditorLayout = function (_Component) {
  _inherits(RulesEditorLayout, _Component);

  function RulesEditorLayout(props) {
    _classCallCheck(this, RulesEditorLayout);

    var _this = _possibleConstructorReturn(this, (RulesEditorLayout.__proto__ || Object.getPrototypeOf(RulesEditorLayout)).call(this, props));

    _this.setPageValidity = function (canSave) {
      return _this.setState({ currentPageValidity: canSave });
    };

    _this.updateTitle = function (title) {
      _this.setState(function (prevState) {
        var updatedRule = _extends({}, prevState.rule.data.item, { name: title });
        var newState = {
          rule: _extends({}, prevState.rule, { data: { item: updatedRule } })
        };
        if (_this.state.activePage === 'newRuleConfirmation') {
          newState.currentPageValidity = title && title.length;
        }
        return newState;
      }, function () {
        return _this.props.actions.editRule(_this.state.rule.data);
      });
    };

    _this.setActiveFilter = function (filter) {
      var isActionOnlyRule = isActionOnlyField(filter.field);
      return _this.setState({ activeFilter: filter, activePage: isActionOnlyRule ? 'actionEditor' : 'filterEditor' });
    };

    _this.saveActiveFilter = function () {
      var filter = _this.state.activeFilter;
      _this.setState(function (prevState) {
        var normalizedConditions = _this.removeFilterBasedOnField(prevState.rule.data.item.conditions[0], filter);
        var conditions = filter === undefined || filter.field === 'onlineUsers' ? [] : [].concat(_toConsumableArray(normalizedConditions), [filter]);

        return {
          rule: buildRuleFromFilter(prevState.rule, conditions)
        };
      }, function () {
        _this.props.actions.editRule(_this.state.rule.data);
      });
    };

    _this.removeFilterBasedOnField = function (existingFilters, filterToRemove) {
      if (!existingFilters || !existingFilters.length) {
        return [];
      }

      var filterReference = existingFilters.find(function (existingFilter) {
        return existingFilter.field === filterToRemove.field;
      });
      return _.without(existingFilters, filterReference);
    };

    _this.removeFilter = function (filter) {

      var buildStateChangesAfterRemoval = function buildStateChangesAfterRemoval(newRule) {
        var conditions = newRule.data.item.conditions[0];
        if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["isEmpty"])(conditions)) {
          return {
            activePage: 'filterEditor',
            activeFilter: 'ADD'
          };
        }

        return {
          activeFilter: conditions[0]
        };
      };

      _this.setState(function (prevState) {
        var previousConditions = prevState.rule.data.item.conditions[0];
        var newConditions = _this.removeFilterBasedOnField(previousConditions, filter);
        var newRule = buildRuleFromFilter(prevState.rule, newConditions);
        _this.props.actions.editRule({ item: newRule.data.item });

        if (['salesforceOwner', 'targetedAccounts'].includes(filter.field)) {
          _this.props.actions.resetActiveRuleAction(newRule);
        }

        return _extends({
          rule: newRule
        }, buildStateChangesAfterRemoval(newRule));
      });
    };

    _this.updateAction = function (action) {
      var actionPromise = new Promise(function (resolve) {
        _this.setState(function (prevState) {
          var updatedRule = _extends({}, prevState.rule.data.item, { action: action });
          return {
            rule: _extends({}, prevState.rule, { data: { item: updatedRule } })
          };
        }, function () {
          _this.props.actions.editRule(_this.state.rule.data);
          resolve();
        });
      });

      return actionPromise;
    };

    _this.updateSalesforceLeadRoutingSettings = function (settings) {
      _this.setState({ salesforceLeadRoutingSettings: settings });
    };

    _this.updateSalesforceLeadRoutingToggles = function (toggles) {
      _this.setState({ salesforceLeadRoutingToggles: toggles });
    };

    _this.setActivePage = function (page) {
      _this.setState({ activePage: page });
    };

    _this.getValidityDetails = function () {
      var hasFilter = !!_this.state.rule.data.item.conditions[0];
      var filter = hasFilter ? _this.state.rule.data.item.conditions[0][0] : {};
      var action = _this.state.rule.data.item.action;

      var isSalesforce = action.type === 'SALESFORCE_PARTICIPANT';
      var hasAction = !!action.options || isSalesforce;

      var hasValidFilter = hasFilter && !!filter.value && (filter.value.length || _.isBoolean(filter.value) || _.isPlainObject(filter.value)) && !!filter.field && !!filter.operator;
      var hasValidAction = isSalesforce || hasAction && action.options.userIds.length && !!action.options.addType;
      var hasValidTitle = _this.state.rule.data.item.name.length;
      var hasServerError = !!_this.state.rule.error;

      return { hasValidFilter: hasValidFilter, hasValidAction: hasValidAction, hasValidTitle: hasValidTitle, hasServerError: hasServerError };
    };

    var isEditingExistingConditionlessRule = !!props.activeRule.data.item.id && props.rule.data.item.conditions.length === 0;

    _this.state = {
      rule: props.activeRule,
      currentPageValidity: false,
      activeFilter: isEditingExistingConditionlessRule ? 'actionEditor' : 'ADD'
    };
    return _this;
  }

  _createClass(RulesEditorLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchOrgUsers();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var isNew = this.props.params.ruleId === 'new';
      if (!isNew) {
        __WEBPACK_IMPORTED_MODULE_1_app_modules_rules_api__["a" /* api */].fetchRule(this.props.params.ruleId).then(function (resp) {
          _this2.props.actions.editRule({ item: resp });

          var conditions = resp.conditions[0];
          var isActionOnlyRule = !conditions || conditions.some(function (_ref) {
            var field = _ref.field;
            return isActionOnlyField(field);
          }) || conditions.length === 0;
          _this2.setState({
            activePage: isActionOnlyRule ? 'actionEditor' : 'filterEditor',
            currentPageValidity: true
          });
        });
      } else {
        this.setState({
          activePage: 'filterEditor'
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.actions.resetActiveRule();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps.activeRule) !== JSON.stringify(this.state.rule)) {
        var activeFilter = this.state.activeFilter;

        var isNew = !nextProps.activeRule.data.item.createdAt;

        var conditions = nextProps.activeRule.data.item.conditions[0];
        var lastFilter = conditions ? Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["last"])(nextProps.activeRule.data.item.conditions[0]) : __WEBPACK_IMPORTED_MODULE_3_app_modules_rules_models__["b" /* availabilityFilter */];

        var nextActiveFilter = isNew ? activeFilter : lastFilter;
        this.setState({ rule: nextProps.activeRule, activeFilter: nextActiveFilter });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rules-editor-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_RulesEditorOverview___["a" /* default */], {
          activeFilter: this.state.activeFilter,
          setActiveFilter: this.setActiveFilter,
          saveActiveFilter: this.saveActiveFilter,
          currentPageIsValid: this.state.currentPageValidity,
          updateFilter: this.updateFilter,
          rule: this.state.rule,
          updateTitle: this.updateTitle,
          setActivePage: this.setActivePage,
          users: this.props.users,
          activePage: this.state.activePage,
          removeFilter: this.removeFilter,
          hasABM: this.props.hasABM,
          isActionOnlyField: isActionOnlyField
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_RulesEditor__["a" /* default */], {
          activeFilter: this.state.activeFilter,
          setActiveFilter: this.setActiveFilter,
          currentPageIsValid: this.state.currentPageValidity,
          setPageValidity: this.setPageValidity,
          rule: this.state.rule,
          activePage: this.state.activePage,
          setActivePage: this.setActivePage,
          saveActiveFilter: this.saveActiveFilter,
          updateAction: this.updateAction,
          users: this.props.users,
          updateTitle: this.updateTitle,
          getValidityDetails: this.getValidityDetails,
          showSalesforceOption: this.props.showSalesforceOption,
          updateSalesforceLeadRoutingSettings: this.updateSalesforceLeadRoutingSettings,
          updateSalesforceLeadRoutingToggles: this.updateSalesforceLeadRoutingToggles,
          salesforceLeadRoutingSettings: this.state.salesforceLeadRoutingSettings,
          salesforceLeadRoutingToggles: this.state.salesforceLeadRoutingToggles,
          resetActiveRuleAction: this.props.actions.resetActiveRuleAction,
          hasABM: this.props.hasABM
        })
      );
    }
  }]);

  return RulesEditorLayout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RulesEditorLayout);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "uHcq":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"23\" viewBox=\"0 0 25 23\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24.892 9.953c0-5.5-5.476-9.953-12.258-9.953C5.854 0 .376 4.452.376 9.953c0 3.318 1.987 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.843 4.084-.142.14-.17.368-.114.567a.524.524 0 0 0 .482.312c2.95 0 5.334-1.93 6.61-3.206.654.086 1.363.142 2.072.142 6.782 0 12.258-4.452 12.258-9.953zm-5.128-.286H7.506a1.022 1.022 0 0 1 0-2.042h12.258a1.022 1.022 0 0 1 0 2.042zm-12.258 2.02h8.172a1.022 1.022 0 0 1 0 2.042H7.506a1.022 1.022 0 0 1 0-2.043z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "uI/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__ = __webpack_require__("9hk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("QQaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GatedState__ = __webpack_require__("jKHE");






var MeetingTypeList = function MeetingTypeList(_ref) {
  var meetingTypes = _ref.meetingTypes,
      defaultMeetingtype = _ref.defaultMeetingtype,
      gatedOnClick = _ref.gatedOnClick;

  return React.createElement(
    'div',
    { className: 'settings-meeting-types-list' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__["a" /* default */], { key: 'default', settings: defaultMeetingtype, isDefault: true, isPublic: true }),
    meetingTypes.sort(function (mt1, mt2) {
      return mt1.name > mt2.name;
    }).map(function (meetingType) {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_0__MeetingTypesListItem__["a" /* default */], { key: meetingType, settings: meetingType });
    }),
    !__WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].hasPaidGates() && React.createElement(__WEBPACK_IMPORTED_MODULE_3__GatedState__["a" /* default */], { gatedOnClick: gatedOnClick })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MeetingTypeList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "uMQj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Conversations":"Conversations---3YyIA"};

/***/ }),

/***/ "uNah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uNny":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxNiAyMyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNjggMTAuNTI2bC03LjgwNCAxMS41MWMtLjEzLjM4NC0uNDg4LjY1Ny0uOTA4LjY1Ny0uMDQgMC0uMDgtLjAwMi0uMTItLjAwOC0uNDUyLS4wNTMtLjc3NS0uNDA0LS44My0uODIyLS4wMDQtLjAyNS0uMDAyLS4wNTItLjAwNS0uMDc3LS4wMDItLjA1Mi0uMDItLjEtLjAxMi0uMTVsLjAxLS4wNzdjLjAwNS0uMDM2LjAwNi0uMDcuMDEzLS4xMDVsLjkxOC03LjI1M0gxLjQ2NGMtLjcwNSAwLTEuMDE2LS4zNzctMS4xMzgtLjYwMi0uMzQ1LS42My4wOC0xLjI0Mi4yMi0xLjQ0NEwxMC4wMjYuMzYzYy4zMy0uNDEuOTQzLS40ODMgMS4zNjQtLjE2My4yMzYuMTguMzUuNDQzLjM2LjcxMy4wMTYuMTEzLjAxNi4yMy0uMDE1LjM1TDkuOTAyIDguNTM4aDMuODg4Yy43IDAgMS4wMDYuMzYgMS4xMjYuNTc2LjMyNS41OS0uMDQyIDEuMTIzLS4yMzcgMS40MXptLTUuMjAyLS4xYy0uNDM3IDAtLjg0LS4xODctMS4xMzYtLjUyNy0uMzQzLS4zOTUtLjUtLjk2LS40MS0xLjQ3N2wuODc1LTMuNDc2LTUuOTIzIDcuMzY2aDMuNWMuNTQ2IDAgLjk3LjE2NSAxLjI1NC40OTIuMTUyLjE3NC4zOTIuNTUyLjI5NSAxLjEzN2wtLjQ4MiAzLjgxIDQuOTctNy4zMjdIOS40Nzd6IiBmaWxsPSIjNzY5NUE1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "uP6L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"agent-status-pane":"agent-status-pane---2Hiwa"};

/***/ }),

/***/ "uQXq":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "uS60":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 37 33\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.5 28.286c-.805 0-2.053.008-2.81.013-2.787 4.357-8.446 4.687-8.697 4.7h-.056c-.424 0-.816-.237-1.017-.62-.212-.4-.18-.886.083-1.253.02-.027 1.81-2.578 2.062-5.64C2.855 22.638 0 18.63 0 14.144 0 6.343 8.3 0 18.5 0S37 6.344 37 14.143c0 7.798-8.3 14.143-18.5 14.143zm0-25.93c-8.926 0-16.188 5.288-16.188 11.787 0 5.04 4.672 8.17 7.455 9.59.392.2.64.607.64 1.054 0 2.096-.622 4.01-1.25 5.412 1.633-.495 3.733-1.522 4.858-3.636.2-.376.586-.613 1.007-.617 0 0 2.25-.018 3.478-.018 8.926 0 16.188-5.288 16.188-11.787 0-6.5-7.262-11.786-16.188-11.786zm-8.612 18.47c-.28 0-.556-.112-.76-.318-.3-.302-.396-.752-.248-1.15l1.814-4.873.008-.01c.025-.065.072-.118.108-.177.04-.065.073-.135.124-.19.004 0 .004-.005.007-.008L18.3 6.674c.016-.017.037-.022.055-.037.012-.014.017-.033.03-.047 1.213-1.226 3.327-1.226 4.54 0 .605.61.94 1.425.94 2.29-.002.865-.337 1.678-.943 2.288-.015.015-.035.02-.05.034-.014.016-.02.037-.035.052l-7.357 7.425c-.003.002-.01.003-.013.007-.035.035-.084.054-.123.084-.078.058-.153.118-.24.152-.003 0-.004.002-.006.003l-4.83 1.832c-.123.045-.25.068-.378.068zm4.236-3.852l7.19-7.256c.014-.015.034-.02.05-.035.016-.016.02-.038.036-.054.198-.2.31-.467.31-.75 0-.286-.112-.554-.31-.755-.4-.405-1.094-.404-1.492 0-.016.015-.038.02-.054.036-.014.016-.018.035-.033.05l-7.193 7.263-.897 2.41 2.394-.91zm4.376 1.68h8.612c.594 0 1.077.485 1.077 1.085s-.484 1.085-1.078 1.085H18.5c-.594 0-1.077-.486-1.077-1.086 0-.6.483-1.086 1.077-1.086z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "uTQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_duration_format__ = __webpack_require__("SdwT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_duration_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_duration_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("YWXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_PatchHelper__ = __webpack_require__("DhfJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("Dm7V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_observable__);











// convert local hours/minutes Record to 00:00:00 format
var mapSlotHours = function mapSlotHours(teamAvailabilitySettings) {
  return teamAvailabilitySettings.get('openHours').map(function (slot) {
    return {
      dayOfWeek: slot.dayOfWeek,
      opens: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({ hours: slot.startTime.hour, minutes: slot.startTime.minutes }).format('HH:mm:ss', { trim: false }),
      closes: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration({ hours: slot.endTime.hour, minutes: slot.endTime.minutes }).format('HH:mm:ss', { trim: false })
    };
  });
};

var fetchOrgTeams = function fetchOrgTeams(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["m" /* fetchOrgTeams */].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchTeams().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* fetchOrgTeamsSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["o" /* fetchOrgTeamsPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["n" /* fetchOrgTeamsFailed */]({ error: error }));
    });
  });
};

var patchOrgTeam = function patchOrgTeam(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["C" /* patchOrgTeam */].toString()).pluck('payload').mergeMap(function (_ref) {
    var teamId = _ref.teamId,
        properties = _ref.properties;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].patchTeam({ teamId: teamId, properties: properties }).map(function (teamSettings) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["F" /* patchOrgTeamSuccess */]({ teamId: teamId, team: teamSettings });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["E" /* patchOrgTeamPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["D" /* patchOrgTeamFailed */](error));
    });
  });
};

var deleteOrgTeam = function deleteOrgTeam(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["i" /* deleteOrgTeam */].toString()).pluck('payload').mergeMap(function (_ref2) {
    var teamId = _ref2.teamId;

    var payload = Object(__WEBPACK_IMPORTED_MODULE_3_utils_PatchHelper__["a" /* patchOperations */])({
      status: 'ARCHIVED'
    });
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].patchTeam({ teamId: teamId, properties: payload }).map(function () {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* deleteOrgTeamSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["k" /* deleteOrgTeamPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["j" /* deleteOrgTeamFailed */](error));
    });
  });
};

var createOrgTeam = function createOrgTeam(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* createOrgTeam */].toString()).pluck('payload').mergeMap(function (_ref3) {
    var team = _ref3.team;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].createTeam({ team: team }).map(function () {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* createOrgTeamSuccess */]();
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* createOrgTeamPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* createOrgTeamFailed */](error));
    });
  });
};

var fetchTeamsForUser = function fetchTeamsForUser(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["y" /* fetchTeamsForUser */].toString()).pluck('payload').mergeMap(function (_ref4) {
    var userId = _ref4.userId;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchTeamsForUser({ userId: userId }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["B" /* fetchTeamsForUserSuccess */]({ userId: userId, teams: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["A" /* fetchTeamsForUserPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["z" /* fetchTeamsForUserFailed */]({ error: error }));
    });
  });
};

var fetchTeamAvailabilities = function fetchTeamAvailabilities(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["q" /* fetchTeamAvailabilities */].toString()).pluck('payload').mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchTeamAvailabilities().map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* fetchTeamAvailabilitiesSuccess */](response);
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["s" /* fetchTeamAvailabilitiesPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["r" /* fetchTeamAvailabilitiesFailed */]({ error: error }));
    });
  });
};

var fetchTeamAvailability = function fetchTeamAvailability(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["u" /* fetchTeamAvailability */].toString()).pluck('payload').mergeMap(function (_ref5) {
    var availabilityId = _ref5.availabilityId;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].fetchTeamAvailability({ availabilityId: availabilityId }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* fetchTeamAvailabilitySuccess */]({ availabilityId: availabilityId, teamAvailabilitySettings: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["w" /* fetchTeamAvailabilityPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["v" /* fetchTeamAvailabilityFailed */]({ error: error }));
    });
  });
};

var createTeamAvailability = function createTeamAvailability(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* createTeamAvailability */].toString()).pluck('payload').mergeMap(function (_ref6) {
    var teamAvailabilitySettings = _ref6.teamAvailabilitySettings;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].createTeamAvailability({ teamAvailabilitySettings: teamAvailabilitySettings }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* createTeamAvailabilitySuccess */]({
        teamAvailabilitySettings: response
      });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["g" /* createTeamAvailabilityPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["f" /* createTeamAvailabilityFailed */]({ error: error }));
    });
  });
};

var updateAvailabilityForTeam = function updateAvailabilityForTeam(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["G" /* updateAvailabilityForTeam */].toString()).pluck('payload').mergeMap(function (_ref7) {
    var teamId = _ref7.teamId,
        teamAvailabilitySettings = _ref7.teamAvailabilitySettings;

    var settings = !teamAvailabilitySettings ? null : teamAvailabilitySettings.set('openHours', mapSlotHours(teamAvailabilitySettings));
    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].updateAvailabilityForTeam({ teamId: teamId, teamAvailabilitySettings: settings }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["J" /* updateAvailabilityForTeamSuccess */]({ teamId: teamId, teamAvailabilitySettings: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["I" /* updateAvailabilityForTeamPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["H" /* updateAvailabilityForTeamFailed */]({ error: error }));
    });
  });
};

var updateTeamAvailability = function updateTeamAvailability(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__actions__["K" /* updateTeamAvailability */].toString()).pluck('payload').mergeMap(function (_ref8) {
    var teamAvailabilityId = _ref8.teamAvailabilityId,
        teamAvailabilitySettings = _ref8.teamAvailabilitySettings;

    return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* api */].updateTeamAvailability({ teamAvailabilityId: teamAvailabilityId, teamAvailabilitySettings: teamAvailabilitySettings }).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2__actions__["N" /* updateTeamAvailabilitySuccess */]({ teamAvailabilityId: teamAvailabilityId, teamAvailabilitySettings: response });
    }).startWith(__WEBPACK_IMPORTED_MODULE_2__actions__["M" /* updateTeamAvailabilityPending */]()).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_5_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["L" /* updateTeamAvailabilityFailed */]({ error: error }));
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_6_redux_observable__["combineEpics"])(fetchOrgTeams, patchOrgTeam, deleteOrgTeam, createOrgTeam, updateAvailabilityForTeam, fetchTeamsForUser, fetchTeamAvailabilities, fetchTeamAvailability, createTeamAvailability, updateTeamAvailability);

/***/ }),

/***/ "uXhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_datetime__ = __webpack_require__("8ijy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("dLPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__picker_styl__ = __webpack_require__("pOiw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__picker_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__picker_styl__);





var ScheduleEmail = function ScheduleEmail(_ref) {
  var selectedDateTime = _ref.selectedDateTime,
      selectedDateTimeFormatted = _ref.selectedDateTimeFormatted,
      handleSetDateTime = _ref.handleSetDateTime;
  return React.createElement(
    'div',
    { className: 'playbook-schedule-calendar-panes' },
    React.createElement(
      'div',
      { className: 'playbook-schedule-calendar-pane playbook-schedule-calendar-date' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_datetime__, {
        onChange: handleSetDateTime,
        value: selectedDateTime,
        input: false,
        timeFormat: false,
        isValidDate: function isValidDate(current) {
          return current.isAfter(__WEBPACK_IMPORTED_MODULE_0_react_datetime__["moment"]().subtract(1, 'day'));
        },
        className: 'playbook-schedule-calendar-picker'
      })
    ),
    React.createElement(
      'div',
      { className: 'playbook-schedule-calendar-pane playbook-schedule-calendar-time' },
      React.createElement(
        'div',
        { className: 'schedule-label' },
        'Pick a Time'
      ),
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_datetime__, {
        onChange: handleSetDateTime,
        value: selectedDateTime,
        input: false,
        dateFormat: false,
        isValidDate: function isValidDate(current) {
          return current.isAfter(__WEBPACK_IMPORTED_MODULE_0_react_datetime__["moment"]().subtract(1, 'day'));
        },
        className: 'playbook-schedule-time-picker'
      }),
      React.createElement(
        'div',
        { className: 'playbook-schedule-summary' },
        React.createElement(
          'div',
          { className: 'playbook-schedule-summary-heading' },
          'Schedule this playbook for'
        ),
        ' ',
        selectedDateTimeFormatted
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ScheduleEmail);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "uYAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BackButton__ = __webpack_require__("h2eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__("7G/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Customize_OrgSettings_Helpers__ = __webpack_require__("l+9u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__("Pq8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EmailCapture__ = __webpack_require__("ejgB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__ = __webpack_require__("3JoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PageTitle__ = __webpack_require__("dtTz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style__ = __webpack_require__("5acZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var NOTIFICATION_MESSAGE = 'Your changes have been saved';

var TOGGLE_ATTACHMENTS_HIDDEN_GATE = 'TOGGLE_ATTACHMENT_HIDDEN';

var orNull = function orNull(input) {
  return input || null;
};

var AdvancedChatWidgetSettings = function (_Component) {
  _inherits(AdvancedChatWidgetSettings, _Component);

  function AdvancedChatWidgetSettings(props) {
    _classCallCheck(this, AdvancedChatWidgetSettings);

    var _this = _possibleConstructorReturn(this, (AdvancedChatWidgetSettings.__proto__ || Object.getPrototypeOf(AdvancedChatWidgetSettings)).call(this, props));

    _this.onThemeSettingToggled = function (setting) {
      return function (event) {
        var orgSettings = _this.props.orgSettings;

        var isEnabled = event.target.checked;
        var updatedOrgSettings = orgSettings.setIn(['theme', setting], isEnabled);
        _this.patchOrgSettings(updatedOrgSettings);
      };
    };

    _this.handleSelectUser = function (option) {
      var orgSettings = _this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'userList'], option && option.value ? Object(__WEBPACK_IMPORTED_MODULE_14_immutable__["List"])([option.value]) : Object(__WEBPACK_IMPORTED_MODULE_14_immutable__["List"])());
      _this.setState({ updatedOrgSettings: updatedOrgSettings });

      _this.patchOrgSettings(updatedOrgSettings, orgSettings);
    };

    _this.onEmailFollowUpToggled = _this.onEmailFollowUpToggled.bind(_this);
    _this.onCaptureEmailToggled = _this.onCaptureEmailToggled.bind(_this);
    _this.onEmailCaptureMessageChanged = _this.onEmailCaptureMessageChanged.bind(_this);
    _this.onDisableNewConversationToggled = _this.onDisableNewConversationToggled.bind(_this);
    _this.onUpdateIncomingMsgPrompt = _this.onUpdateIncomingMsgPrompt.bind(_this);
    _this.handleSelectUser = _this.handleSelectUser.bind(_this);
    _this.debouncedPatchOrgSettings = _.debounce(_this.patchOrgSettings.bind(_this), 450);
    _this.state = {
      emailCaptureSectionVisible: props.orgSettings.theme.captureEmail,
      updatedOrgSettings: _this.props.orgSettings
    };
    return _this;
  }

  _createClass(AdvancedChatWidgetSettings, [{
    key: 'onEmailFollowUpToggled',
    value: function onEmailFollowUpToggled(event) {
      var queries = this.context.app.queries;
      var orgId = this.props.embed.orgId;

      var isEnabled = event.target.checked;
      queries.OrgPropertiesQueries.updateProperties(orgId, { chatFallbackEnabled: isEnabled }, NOTIFICATION_MESSAGE);
    }
  }, {
    key: 'onCaptureEmailToggled',
    value: function onCaptureEmailToggled(event) {
      var orgSettings = this.props.orgSettings;

      var isEnabled = event.target.checked;
      var updatedOrgSettings = orgSettings.setIn(['theme', 'captureEmail'], isEnabled);

      this.setState({ emailCaptureSectionVisible: isEnabled });
      this.patchOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'onDisableNewConversationToggled',
    value: function onDisableNewConversationToggled(event) {
      var orgSettings = this.props.orgSettings;

      var isEnabled = event.target.checked;
      var updatedOrgSettings = orgSettings.setIn(['theme', 'disableNewConversations'], isEnabled);

      this.patchOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'patchOrgSettings',
    value: function patchOrgSettings(updatedOrgSettings) {
      var orgSettings = this.props.orgSettings;

      var changes = Object(__WEBPACK_IMPORTED_MODULE_5_components_Customize_OrgSettings_Helpers__["b" /* getChanges */])(updatedOrgSettings, orgSettings);
      var actions = this.context.app.actions;

      actions.DefaultEmbedActions.patchDefaultEmbed(changes, NOTIFICATION_MESSAGE);
    }
  }, {
    key: 'onUpdateIncomingMsgPrompt',
    value: function onUpdateIncomingMsgPrompt(event) {
      var orgSettings = this.props.orgSettings;

      var prompt = event.target.value;
      var updatedOrgSettings = orgSettings.setIn(['theme', 'awayMessage'], orNull(prompt)).setIn(['theme', 'welcomeMessage'], orNull(prompt));

      this.debouncedPatchOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'onEmailCaptureMessageChanged',
    value: function onEmailCaptureMessageChanged(message) {
      var orgSettings = this.props.orgSettings;

      var updatedOrgSettings = orgSettings.setIn(['theme', 'emailCaptureMessage'], orNull(message));

      this.patchOrgSettings(updatedOrgSettings);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentUser = _props.currentUser,
          orgSettings = _props.orgSettings,
          orgProperties = _props.orgProperties;
      var emailCaptureSectionVisible = this.state.emailCaptureSectionVisible;

      var theme = orgSettings.theme;

      var name = currentUser.name || orgSettings.orgName;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* IntlProvider */],
        { locale: 'en' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_15__style___default.a.AdvancedChatWidgetSettings },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BackButton__["a" /* default */], { title: 'Drift Widget Settings', url: '/settings/widget' }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PageTitle__["a" /* default */], { title: 'Advanced', description: 'Customize advanced settings like emails' }),
          !__WEBPACK_IMPORTED_MODULE_12_utils_Access__["c" /* default */].hasGates(TOGGLE_ATTACHMENTS_HIDDEN_GATE) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Allow Incoming Attachments',
            description: 'Let your visitors send you attachments in conversations.',
            className: 'advanced-settings-toggle allow-attachments',
            isChecked: theme.allowEndUserFileUpload,
            onToggled: this.onThemeSettingToggled('allowEndUserFileUpload')
          }),
          !__WEBPACK_IMPORTED_MODULE_12_utils_Access__["c" /* default */].hasGates(TOGGLE_ATTACHMENTS_HIDDEN_GATE) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Allow Outgoing Attachments',
            description: 'Let your team members send your visitors attachments in conversations.',
            className: 'advanced-settings-toggle allow-attachments',
            isChecked: theme.allowAgentFileUpload,
            onToggled: this.onThemeSettingToggled('allowAgentFileUpload')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Show unread badge for first messages',
            description: 'When a visitor first arrives on your site, add an unread badge for new messages. Note: turning this off will likely result in decreased engagement with your Drift Widget.',
            className: 'advanced-settings-toggle widget-badge',
            isChecked: theme.unreadBadgeEnabled,
            onToggled: this.onThemeSettingToggled('unreadBadgeEnabled')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Play Sound for New Messages',
            description: 'Drift will make a nice pinging noise when a site visitor gets a new chat message',
            className: 'advanced-settings-toggle sound-notifications',
            isChecked: theme.soundNotificationEnabled,
            onToggled: this.onThemeSettingToggled('soundNotificationEnabled')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Flash Tab for New Messages',
            description: 'When a visitor has a new message from your team waiting for them, flash the tab bar to grab their attention.',
            className: 'advanced-settings-toggle flash-tab-option',
            isChecked: theme.titleNotificationEnabled,
            onToggled: this.onThemeSettingToggled('titleNotificationEnabled')
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Ask Site Visitors for email',
            description: 'Drift can automatically ask an unidentified user for their email address when they start a conversation with you.',
            className: 'advanced-settings-toggle ask-for-email',
            isChecked: theme.captureEmail,
            onToggled: this.onCaptureEmailToggled
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
            title: 'Don\'t allow visitors to create different conversations',
            description: 'Visitors will still be able to respond to #DriftLink, welcome messages, and playbooks but they won\'t be able to start a different conversation.',
            className: 'advanced-settings-toggle disable-new-conversations',
            isChecked: theme.disableNewConversations,
            onToggled: this.onDisableNewConversationToggled
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_EmailCapture__["a" /* default */], {
            name: name,
            avatarUrl: currentUser.avatarUrl,
            backgroundColor: theme.backgroundColor,
            onMessageChanged: this.onEmailCaptureMessageChanged,
            message: theme.emailCaptureMessage,
            className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()({
              'email-capture-visible': emailCaptureSectionVisible,
              'email-capture-hidden': !emailCaptureSectionVisible
            })
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'email-followup-container' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ToggleSection__["a" /* default */], {
              title: 'Email Follow Up',
              description: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'span',
                null,
                'If you send a message and it goes unread, we\u2019ll email it to your visitor. ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'a',
                  {
                    href: 'https://help.drift.com/article/email-follow-up/',
                    rel: 'noopener noreferrer',
                    target: '_blank'
                  },
                  'Learn more'
                )
              ),
              className: 'advanced-settings-toggle email-toggle-section',
              isChecked: orgProperties.chatFallbackEnabled,
              onToggled: this.onEmailFollowUpToggled
            })
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'widget-api' },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* SectionItem */], {
              title: 'Widget API',
              description: 'Are you a bit tech savvy? You can use our Widget API to customize the Drift widget to behave just the way you like. You can listen for Widget Events and have control Widget Configuration at runtime.',
              className: 'widget-section-item'
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              'a',
              { className: 'widget-api-link', href: 'https://devdocs.drift.com/docs/widget-start', target: '_blank' },
              'View the Widget API'
            )
          )
        )
      );
    }
  }]);

  return AdvancedChatWidgetSettings;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

AdvancedChatWidgetSettings.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    hasConsolidatedWelcomeMsg: Object(__WEBPACK_IMPORTED_MODULE_13_app_modules_gates_selectors__["u" /* makeHasGate */])('has_consolidated_welcome_msg')(state)
  };
};

var AdvancedChatWidgetSettingsContainer = Object(__WEBPACK_IMPORTED_MODULE_7_components_container__["a" /* makeDefaultFailedContainer */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(AdvancedChatWidgetSettings), {
  listenTo: ['stores.UserStore', 'stores.OrgSettingsStore', 'stores.OrgPropertiesStore', 'stores.DefaultEmbedStore'],
  fetch: {
    currentUser: function currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    orgSettings: function orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings();
    },
    orgProperties: function orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg();
    },
    embed: function embed() {
      return this.app.stores.DefaultEmbedStore.getOrFetchCurrentDefaultEmbed();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (AdvancedChatWidgetSettingsContainer);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "uatQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SectionItem":"SectionItem---1NxcQ"};

/***/ }),

/***/ "udYA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uhyN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__ = __webpack_require__("qXGn");
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var SavedReplyActions = Marty.createActionCreators({
  updateReply: function updateReply(replyId, reply, notify) {
    return this.app.queries.SavedReplyQueries.updateReply(replyId, reply, notify);
  },
  createReply: function createReply(reply) {
    return this.app.queries.SavedReplyQueries.createReply(reply);
  },
  deleteReply: function deleteReply(replyId) {
    return this.app.queries.SavedReplyQueries.updateReply(replyId, { status: 'ARCHIVED' }, true);
  },
  setReplyToPopulate: function setReplyToPopulate(replyId) {
    return this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SavedReplyConstants__["a" /* default */].SET_REPLY_TO_POPULATE, replyId);
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SavedReplyActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ujHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("oThQ");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* fetchEmbed */], __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* fetchEmbedPending */], __WEBPACK_IMPORTED_MODULE_2__actions__["e" /* fetchEmbedSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* fetchEmbedFailed */], __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* patchEmbedSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* patchEmbedError */], __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* patchEmbedPending */]), function (state, action) {
  return state.set('status', action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* fetchEmbedSuccess */], __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* patchEmbedSuccess */]), function (state, action) {
  return state.set('data', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload));
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()));

/***/ }),

/***/ "ukvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of__ = __webpack_require__("1APj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_from__ = __webpack_require__("S35O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_merge__ = __webpack_require__("fICK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_empty__ = __webpack_require__("AGQa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_forkJoin__ = __webpack_require__("iJMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_timer__ = __webpack_require__("jdeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_timer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_interval__ = __webpack_require__("SUuD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_fromEvent__ = __webpack_require__("E7Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_fromEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_observable_fromEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_dom_ajax__ = __webpack_require__("1Nls");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_dom_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_add_observable_dom_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_do__ = __webpack_require__("EnA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_bufferTime__ = __webpack_require__("Di9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_bufferTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_bufferTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_buffer__ = __webpack_require__("nsuO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_delay__ = __webpack_require__("94IA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_delay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_add_operator_delay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_first__ = __webpack_require__("okk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_groupBy__ = __webpack_require__("6s76");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_toPromise__ = __webpack_require__("eErF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_race__ = __webpack_require__("48bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_race___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_race__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_pluck__ = __webpack_require__("xOQQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mapTo__ = __webpack_require__("6gFN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mapTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_mapTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_switchMap__ = __webpack_require__("uCY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_add_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_exhaustMap__ = __webpack_require__("SSeX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_exhaustMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_exhaustMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_concatMap__ = __webpack_require__("jvbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs_add_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_take__ = __webpack_require__("hzF8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs_add_operator_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_takeUntil__ = __webpack_require__("T3fU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rxjs_add_operator_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_catch__ = __webpack_require__("6Yye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_mergeMap__ = __webpack_require__("HcJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_rxjs_add_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_scan__ = __webpack_require__("zJQZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs_add_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_retryWhen__ = __webpack_require__("10Gq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_retryWhen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_rxjs_add_operator_retryWhen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_rxjs_add_operator_skipUntil__ = __webpack_require__("8szd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_rxjs_add_operator_skipUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_rxjs_add_operator_skipUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_rxjs_add_operator_skipWhile__ = __webpack_require__("VaQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_rxjs_add_operator_skipWhile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_rxjs_add_operator_skipWhile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_rxjs_add_operator_startWith__ = __webpack_require__("/lY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_rxjs_add_operator_startWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_rxjs_add_operator_startWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_rxjs_add_operator_auditTime__ = __webpack_require__("CYDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_rxjs_add_operator_auditTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_rxjs_add_operator_auditTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_rxjs_add_operator_debounceTime__ = __webpack_require__("aV5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_rxjs_add_operator_debounceTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_rxjs_add_operator_debounceTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_rxjs_add_operator_throttleTime__ = __webpack_require__("jF50");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_rxjs_add_operator_throttleTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_rxjs_add_operator_throttleTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_rxjs_add_operator_distinctUntilChanged__ = __webpack_require__("q3ik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_rxjs_add_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_rxjs_add_operator_distinctUntilChanged__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__driftt_dapper_lib_rx_add_retryWithBackoff__ = __webpack_require__("a3Ws");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__driftt_dapper_lib_rx_add_retryWithBackoff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__driftt_dapper_lib_rx_add_retryWithBackoff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__driftt_dapper_lib_rx_add_checkStatus__ = __webpack_require__("6TkR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__driftt_dapper_lib_rx_add_checkStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__driftt_dapper_lib_rx_add_checkStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__driftt_dapper_lib_rx_add_mapResponse__ = __webpack_require__("QHw5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__driftt_dapper_lib_rx_add_mapResponse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__driftt_dapper_lib_rx_add_mapResponse__);












































/***/ }),

/***/ "um7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");


var PlaybookConversationEventGoal = function PlaybookConversationEventGoal(_ref) {
  var goal = _ref.goal,
      goalId = _ref.goalId,
      classifications = _ref.classifications,
      playbook = _ref.playbook,
      isLeadBotPlaybook = _ref.isLeadBotPlaybook;

  var goalName = goal.get('name');
  var classicationId = goal.getIn(['classification', 'classificationId']);
  var classification = classifications.find(function (c) {
    return c.id === classicationId;
  });
  var classificationName = _.get(classification, 'name', '...');
  var goalLink = isLeadBotPlaybook ? '/playbooks/editor/' + playbook.id + '/visual-builder?allGoalsOpen=true' : '/playbooks/' + playbook.id + '/edit/goal/' + goalId;
  var goalText = goalName ? goalName : classificationName;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
    { href: goalLink },
    goalText
  );
};

var PlaybookConversationEvent = function PlaybookConversationEvent(props) {
  var loaded = props.loaded,
      playbook = props.playbook,
      isAdmin = props.isAdmin;

  if (!loaded) return React.createElement(
    'span',
    null,
    'joined conversation from Playbook'
  );

  var playbookName = _.get(playbook, 'name', '...');
  var playbookLink = '/playbooks/' + playbook.id + '/' + (isAdmin ? 'edit' : 'report');
  return React.createElement(
    'span',
    null,
    'joined conversation from Playbook ',
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Link */],
      { to: playbookLink },
      playbookName
    ),
    ' and Goal ',
    ' ',
    React.createElement(PlaybookConversationEventGoal, props)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (PlaybookConversationEvent);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG")))

/***/ }),

/***/ "uo5z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("sqON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_externalApp_actions__ = __webpack_require__("GHhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_externalApp_selectors__ = __webpack_require__("S0Pm");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var Disclaimer = function Disclaimer(_ref) {
  var appInfo = _ref.appInfo;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    null,
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'oauth-modal-text' },
      appInfo.name,
      ' will be able to do everything that Drift can do:'
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'ul',
      { className: 'color-medium-gray', style: { paddingLeft: 30 } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'oauth-modal-li' },
        'Live Chat With Your Customers'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'oauth-modal-li' },
        'Send Customers In-App Messages'
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'li',
        { className: 'oauth-modal-li' },
        'Improve Your Net Promoter Score'
      )
    )
  );
};

var OAuthConnect = function OAuthConnect(_ref2) {
  var appInfo = _ref2.appInfo,
      handleAuthorize = _ref2.handleAuthorize;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'oauth-modal-container' },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'oauth-modal-header-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__("HmKA"), className: 'oauth-modal-header-icon' })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      {
        className: __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.Content + ' flex-column flex-center',
        style: {
          maxWidth: "90vw"
        } },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'oauth-modal-body-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'oauth-modal-subheader dsg-h3' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            { className: 'oauth-modal-subheader-accent' },
            appInfo.name
          ),
          '\xA0would like access to\xA0',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'strong',
            { className: 'oauth-modal-subheader-accent' },
            'Drift'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          appInfo.description && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { style: { marginBottom: 45 } },
            appInfo.description
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Disclaimer, { appInfo: appInfo })
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'oauth-modal-button-container' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
            { type: 'primary', className: 'oauth-submit-button', onClick: handleAuthorize },
            'Authorize'
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
            { type: 'secondary', className: 'oauth-submit-button', onClick: function onClick() {
                return window.close();
              } },
            'Cancel'
          )
        )
      )
    )
  );
};

var OAuthFailed = function OAuthFailed() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: '' + __WEBPACK_IMPORTED_MODULE_5__style_styl___default.a.FailedContent },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      { className: 'oauth-failure-container' },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__("L3SV"), className: 'oauth-failure-icon' }),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'oauth-failure-text-container' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'oauth-failure-subheader-text' },
          'We ran into a server error and weren\u2019t able to find that client ID.'
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'oauth-failure-body-text' },
          'Double check your URL and try again.  Still having trouble? \xA0',
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'span',
            { className: 'oauth-failure-message-accent' },
            'Talk to us.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
          { type: 'secondary', className: 'oauth-modal-cancel-Button', onClick: function onClick() {
              window.close();
            } },
          'Cancel'
        )
      )
    )
  );
};

var OAuth = function (_Component) {
  _inherits(OAuth, _Component);

  function OAuth(props) {
    _classCallCheck(this, OAuth);

    var _this = _possibleConstructorReturn(this, (OAuth.__proto__ || Object.getPrototypeOf(OAuth)).call(this, props));

    _this.shouldRenderConnect = function () {
      var _this$props = _this.props,
          code = _this$props.code,
          appInfo = _this$props.appInfo;

      return !!code && !!appInfo && !_this.state.fetchFailed;
    };

    _this.fetchOAuthInfoFailed = function (fetchAppCodeFailed, fetchAppInfoFailed) {
      return _this.props.fetchAppCodeFailed !== fetchAppCodeFailed && !!fetchAppCodeFailed || _this.props.fetchAppInfoFailed !== fetchAppInfoFailed && !!fetchAppInfoFailed;
    };

    _this.handleAuthorize = function () {
      var oauth_redirect_uri = _this.props.location.query.redirect_uri + '/?code=' + _this.props.code;
      window.location.href = oauth_redirect_uri;
    };

    _this.state = {
      fetchFailed: false
    };
    return _this;
  }

  _createClass(OAuth, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location$query = this.props.location.query,
          redirect_uri = _props$location$query.redirect_uri,
          client_id = _props$location$query.client_id;


      this.props.actions.fetchOAuthAppInfo({ redirect_uri: redirect_uri, client_id: client_id });
      this.props.actions.fetchOAuthCode({ redirect_uri: redirect_uri, client_id: client_id });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.fetchOAuthInfoFailed(nextProps.fetchAppCodeFailed, nextProps.fetchAppInfoFailed)) {
        this.setState({ fetchFailed: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var appInfo = this.props.appInfo;
      var fetchFailed = this.state.fetchFailed;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        fetchFailed && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OAuthFailed, null),
        this.shouldRenderConnect() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OAuthConnect, { appInfo: appInfo, handleAuthorize: this.handleAuthorize })
      );
    }
  }]);

  return OAuth;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

OAuth.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
};


var mapStateToProps = function mapStateToProps(state, props) {
  var client_id = props.location.query.client_id;


  return {
    appInfo: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_externalApp_selectors__["c" /* getAppInfo */])(client_id, state),
    code: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_externalApp_selectors__["a" /* getAppCode */])(client_id, state),
    fetchAppInfoFailed: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_externalApp_selectors__["d" /* getAppInfoFailed */])(client_id, state),
    fetchAppCodeFailed: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_externalApp_selectors__["b" /* getAppCodeFailed */])(client_id, state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_3_redux__["b" /* bindActionCreators */])({
      fetchOAuthCode: __WEBPACK_IMPORTED_MODULE_6_app_modules_externalApp_actions__["e" /* fetchOAuthCode */],
      fetchOAuthAppInfo: __WEBPACK_IMPORTED_MODULE_6_app_modules_externalApp_actions__["a" /* fetchOAuthAppInfo */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(OAuth));

/***/ }),

/***/ "uqpo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_meetings_selectors__ = __webpack_require__("OrmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_settings_meetings__ = __webpack_require__("ZTRB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_meetings_CalendarConnect__ = __webpack_require__("LW3l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_settings_meetings_CalendarAdvanced__ = __webpack_require__("SfLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_settings_meetings_MeetingTypeEdit__ = __webpack_require__("m2VY");









var Routes = function Routes(store) {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */],
    { path: '/settings/calendar' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* IndexRoute */], { key: 'index', component: __WEBPACK_IMPORTED_MODULE_2_components_settings_meetings__["a" /* default */] }),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'advanced', component: __WEBPACK_IMPORTED_MODULE_4_components_settings_meetings_CalendarAdvanced__["a" /* default */] }),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'connect', component: __WEBPACK_IMPORTED_MODULE_3_components_settings_meetings_CalendarConnect__["a" /* default */] }),
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Route */], { path: 'edit/:meetingTypeSlug', component: __WEBPACK_IMPORTED_MODULE_5_components_settings_meetings_MeetingTypeEdit__["a" /* default */] })
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "ut3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("PjO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_conversation_ContactSideBar__ = __webpack_require__("aGl+");




var CompanyInfoField = function CompanyInfoField(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'company-data-content' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'company-data-secondary' },
      secondary
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'company-data-primary' },
      !!primary ? primary : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        { width: '120', height: '12' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '120', height: '12', rx: '5', style: { fill: __WEBPACK_IMPORTED_MODULE_2_components_conversation_ContactSideBar__["a" /* PLACEHOLDER_PRIMARY_COLOR */] } })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyInfoField);

/***/ }),

/***/ "uuK8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTEGRATIONS_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BACK_LINK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Pages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__ = __webpack_require__("Vdf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_HelpCenter__ = __webpack_require__("NkIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_install__ = __webpack_require__("KBK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Drip__ = __webpack_require__("aWai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_LeanData__ = __webpack_require__("MD3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_Stripe__ = __webpack_require__("G2IJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_FullStory__ = __webpack_require__("1CGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_Linkedin__ = __webpack_require__("avVk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_HubSpot__ = __webpack_require__("DZDw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_Intercom__ = __webpack_require__("9FFE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_Salesforce__ = __webpack_require__("8xQt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_Slack__ = __webpack_require__("913P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_Zapier__ = __webpack_require__("yWAm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_WordPress__ = __webpack_require__("/fzh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__services_Outreach__ = __webpack_require__("dJ8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_MarketoIntegrationPage_index__ = __webpack_require__("4kPz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_MarketoConfigPage_index__ = __webpack_require__("4aFO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_Demandbase_index__ = __webpack_require__("nmrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_Vidyard__ = __webpack_require__("pABh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_MadKudu__ = __webpack_require__("wjvB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_ON24__ = __webpack_require__("+zL5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_ClearbitPage__ = __webpack_require__("efiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SalesforceEduTooltip__ = __webpack_require__("MCwX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_MarketoEduTooltip__ = __webpack_require__("3lFy");





























var logoSrc = {
  fullstory: __webpack_require__("g0Sp"),
  drip: __webpack_require__("55QV"),
  facebook: __webpack_require__("Jp3r"),
  googleanalytics: __webpack_require__("YwA3"),
  hubspot: __webpack_require__("7i7C"),
  intercom: __webpack_require__("xyK/"),
  linkedin: __webpack_require__("J+qo"),
  slack: __webpack_require__("AUaw"),
  salesforce: __webpack_require__("V0l4"),
  zapier: __webpack_require__("nUuA"),
  wordpress: __webpack_require__("FaTt"),
  marketo: __webpack_require__("/8Kr"),
  demandbase: __webpack_require__("ienp"),
  vidyard: __webpack_require__("Rjoa"),
  madkudu: __webpack_require__("dgt1"),
  outreach: __webpack_require__("N88K"),
  leandata: __webpack_require__("Jp3r"),
  on24: __webpack_require__("qWFi")
};

var INTEGRATIONS_URL = '/settings2/integrations';
var BACK_LINK_TEXT = 'All integrations';

var Pages = {
  knowledgebase: {
    title: 'Knowledgebase',
    description: 'Pair your knowledgebase with Drift’s intelligent messaging',
    Page: __WEBPACK_IMPORTED_MODULE_1__pages_HelpCenter__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations() || __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasFeatures({
        featureName: "bot_settings",
        accessLevel: "READ"
      });
    }
  },
  install: {
    title: 'Install',
    description: 'Install Drift on your website in minutes',
    Page: __WEBPACK_IMPORTED_MODULE_2__pages_install__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  drip: {
    title: 'Drip',
    description: '',
    logo: logoSrc.drip,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_3__services_Drip__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  fullstory: {
    title: 'FullStory',
    description: '',
    logo: logoSrc.fullstory,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_6__services_FullStory__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  googleAnalytics: {
    comment: 'MIGRATED TO SETTINGS-WEB, KEEPING PAGE FOR URL REDIRECT',
    retired: true,
    redirectPath: '/settings2/integrations/detail/googleAnalytics',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  hubspot: {
    title: 'HubSpot',
    description: '',
    logo: logoSrc.hubspot,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_8__services_HubSpot__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  linkedin: {
    title: 'LinkedIn',
    description: '',
    logo: logoSrc.linkedin,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_7__services_Linkedin__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hideDisconnectButton: true,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  intercom: {
    title: 'Intercom',
    description: '',
    logo: logoSrc.intercom,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_9__services_Intercom__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  slack: {
    title: 'Slack',
    description: '',
    logo: logoSrc.slack,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_11__services_Slack__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  salesforce: {
    title: 'Salesforce',
    description: '',
    logo: logoSrc.salesforce,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_10__services_Salesforce__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    eduTooltip: __WEBPACK_IMPORTED_MODULE_23__components_SalesforceEduTooltip__["a" /* default */],
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  zapier: {
    title: 'Zapier',
    description: '',
    logo: logoSrc.zapier,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_12__services_Zapier__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  wordpress: {
    title: 'WordPress',
    description: '',
    logo: logoSrc.wordpress,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_13__services_WordPress__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'common-integration-page-logo-very-wide',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  marketo: {
    title: 'Marketo',
    description: '',
    logo: logoSrc.marketo,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_15__pages_MarketoIntegrationPage_index__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    eduTooltip: __WEBPACK_IMPORTED_MODULE_24__components_MarketoEduTooltip__["a" /* default */],
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  'marketo-config': {
    title: 'Marketo',
    description: '',
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_16__pages_MarketoConfigPage_index__["a" /* default */],
    backLinkText: 'Marketo V2 Integration',
    backLinkUrl: '/settings/setup/marketo',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  'demandbase': {
    title: 'Demandbase',
    description: '',
    logo: logoSrc.demandbase,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_17__services_Demandbase_index__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'demandbase-integration-page',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  madkudu: {
    title: 'MadKudu',
    description: '',
    logo: logoSrc.madkudu,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_19__services_MadKudu__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  vidyard: {
    title: 'Vidyard',
    description: '',
    logo: logoSrc.vidyard,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_18__services_Vidyard__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hideDisconnectButton: true
  },
  clearbit: {
    title: 'Clearbit',
    description: '',
    Page: __WEBPACK_IMPORTED_MODULE_21__pages_ClearbitPage__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  outreach: {
    title: 'Outreach',
    description: '',
    logo: logoSrc.outreach,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_14__services_Outreach__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    serviceClassName: 'common-integration-page-logo-wide outreach-integration-page',
    incompleteInstallEndpoint: '/integrations/outreach/install_status/internal',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  facebookAnalytics: {
    comment: 'MIGRATED TO SETTINGS-WEB, KEEPING PAGE FOR URL REDIRECT',
    retired: true,
    redirectPath: '/settings2/integrations/detail/facebookAnalytics',
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  leandata: {
    title: 'LeanData',
    description: '',
    Page: __WEBPACK_IMPORTED_MODULE_4__services_LeanData__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  stripe: {
    title: 'Stripe Payments',
    description: '',
    Page: __WEBPACK_IMPORTED_MODULE_5__services_Stripe__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  },
  on24: {
    title: 'ON24',
    description: '',
    logo: logoSrc.on24,
    Page: __WEBPACK_IMPORTED_MODULE_0_components_Integration_pages_CommonIntegrationPage__["a" /* default */],
    Service: __WEBPACK_IMPORTED_MODULE_20__services_ON24__["a" /* default */],
    backLinkText: BACK_LINK_TEXT,
    backLinkUrl: INTEGRATIONS_URL,
    hasRequiredAccess: function hasRequiredAccess() {
      return __WEBPACK_IMPORTED_MODULE_22_utils_Access__["c" /* default */].hasAllOrgIntegrations();
    }
  }
};

/***/ }),

/***/ "uw+4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwH+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__("hygk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__ = __webpack_require__("lHK6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_first__ = __webpack_require__("y9NZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__("kbi+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_sfdc_actions__ = __webpack_require__("TUwc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_sf_small_svg__ = __webpack_require__("ZbX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_sf_small_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_sf_small_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_sfdc_selectors__ = __webpack_require__("u1z1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_enrichment_selectors__ = __webpack_require__("XmtY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style__ = __webpack_require__("ElMV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var SalesforceSection = function (_Component) {
  _inherits(SalesforceSection, _Component);

  function SalesforceSection(props) {
    _classCallCheck(this, SalesforceSection);

    var _this = _possibleConstructorReturn(this, (SalesforceSection.__proto__ || Object.getPrototypeOf(SalesforceSection)).call(this, props));

    _this.enrichConversation = function () {
      var _this$props = _this.props,
          email = _this$props.email,
          companyData = _this$props.companyData;

      var domain = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(companyData, "domain");
      _this.props.actions.fetchSalesforceEnrichmentByEmail({ email: email, domain: domain });
    };

    _this.renderSalesforceInfo = function () {
      var data = _this.state.data;

      var displayableData = _this.getDisplayableData(data);

      var salesforceEnrichmentFields = _this.props.salesforceEnrichmentFields;

      if (__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(salesforceEnrichmentFields) || salesforceEnrichmentFields.empty) {
        return _this.renderDefaultSalesforceInfo(displayableData);
      } else {
        return _this.renderCustomSalesforceInfo(salesforceEnrichmentFields, displayableData);
      }
    };

    _this.getDisplayableData = function (data) {
      var account = __WEBPACK_IMPORTED_MODULE_6_lodash_first___default()(data.accounts) || {};
      var contact = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(data.contacts, function (contact) {
        return !__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(account) || contact.AccountId === account.Id;
      }) || {};
      var lead = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(data.leads, function (lead) {
        return !!lead.Email;
      }) || {};
      var opportunity = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(data.opportunities, function (opp) {
        return !opp.IsClosed;
      });
      var baseUrl = data.baseUrl;

      return { account: account, contact: contact, lead: lead, opportunity: opportunity, baseUrl: baseUrl };
    };

    _this.renderDefaultSalesforceInfo = function (data) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(data.opportunity) && _this.renderSalesforceOpportunityBar(),
        _this.renderRow("Account Name", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.account, "Name")),
        _this.renderRow("Account Owner", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.account, "ownerName")),
        _this.renderRow("Contact Name", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.contact, "Name")),
        _this.renderRow("Contact Owner", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.contact, "ownerName")),
        _this.renderRow("Lead Stage", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.lead, "Status")),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data, "baseUrl") + __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.contact, "Id", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.lead, "Id", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.account, "Id"))), target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'view-in-salesforce-bar' },
            'View in Salesforce'
          )
        )
      );
    };

    _this.renderCustomSalesforceInfo = function (salesforceEnrichmentFields, data) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        !__WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(data.opportunity) && _this.renderSalesforceOpportunityBar(),
        salesforceEnrichmentFields.accountFields.map(function (field) {
          return _this.renderRow(field.label, __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.account, field.name));
        }),
        salesforceEnrichmentFields.contactFields.map(function (field) {
          return _this.renderRow(field.label, __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.contact, field.name));
        }),
        salesforceEnrichmentFields.leadFields.map(function (field) {
          return _this.renderRow(field.label, __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.lead, field.name));
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data, "baseUrl") + __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.contact, "Id", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.lead, "Id", __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(data.account, "Id"))), target: '_blank' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'view-in-salesforce-bar' },
            'View in Salesforce'
          )
        )
      );
    };

    _this.renderRow = function (header, value) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { key: header, className: 'sfdc-enrichment-body-row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sfdc-enrichment-row-header' },
          header
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'sfdc-enrichment-row-body' },
          value ? value : "N/A"
        )
      );
    };

    _this.renderSalesforceOpportunityBar = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        { className: 'opportunity-bar' },
        '\uD83D\uDCB0 This account has an open opportunity'
      );
    };

    _this.renderErrorState = function () {
      var error = _this.state.error;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        error.status === 404 ? "Couldn't find matching record in Salesforce" : "Error fetching data from Salesforce"
      );
    };

    _this.state = {
      loading: true,
      error: null,
      data: null,
      salesforceEnrichmentFields: [],
      requestedEnrichmentFields: false
    };
    return _this;
  }

  _createClass(SalesforceSection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.enrichConversation();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          salesforceEnrichment = _props.salesforceEnrichment,
          companyData = _props.companyData,
          salesforceEnrichmentFields = _props.salesforceEnrichmentFields;
      var requestedEnrichmentFields = this.state.requestedEnrichmentFields;

      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(prevProps.salesforceEnrichment, salesforceEnrichment)) {
        this.setState({
          loading: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(salesforceEnrichment, "loading") || false,
          error: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(salesforceEnrichment, "error") || {},
          data: __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(salesforceEnrichment, "data") || {}
        });
      }

      if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(prevProps.companyData, companyData)) {
        this.enrichConversation();
      }

      if (!requestedEnrichmentFields && __WEBPACK_IMPORTED_MODULE_5_lodash_isEmpty___default()(salesforceEnrichmentFields)) {
        this.setState({ requestedEnrichmentFields: true }, this.props.actions.fetchSFDCEnrichmentFields);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _state = this.state,
          loading = _state.loading,
          error = _state.error;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__style__["conversationSection"], className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_12__svg_inline_removeTags_true_images_svg_sf_small_svg___default.a, name: 'SALESFORCE_ICON', className: 'header-icon' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'section-title' },
            'Salesforce Details'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'section-body' },
          loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__driftt_tide_core_legacy__["Loader"], null),
          !!__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, "status") && this.renderErrorState(),
          !loading && !__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(error, "status") && this.renderSalesforceInfo()
        )
      );
    }
  }]);

  return SalesforceSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  var getSalesforceEnrichmentByEmail = __WEBPACK_IMPORTED_MODULE_13_app_modules_sfdc_selectors__["j" /* makeGetSalesforceEnrichmentByEmail */]();

  return function (state, props) {
    var email = props.email,
        ip = props.ip;


    return {
      salesforceEnrichment: getSalesforceEnrichmentByEmail(state, email),
      companyData: __WEBPACK_IMPORTED_MODULE_14_app_modules_enrichment_selectors__["b" /* companyDataJS */](state, { ip: ip }),
      salesforceEnrichmentFields: __WEBPACK_IMPORTED_MODULE_13_app_modules_sfdc_selectors__["a" /* getSFDCEnrichmentFields */](state)
    };
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      fetchSalesforceEnrichmentByEmail: __WEBPACK_IMPORTED_MODULE_10_app_modules_sfdc_actions__["fetchSalesforceEnrichmentByEmail"],
      fetchSFDCEnrichmentFields: __WEBPACK_IMPORTED_MODULE_10_app_modules_sfdc_actions__["fetchSFDCEnrichmentFields"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps)(SalesforceSection));

/***/ }),

/***/ "uwTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// taken from https://clearbit.com/docs#enrichment-api-company-api-attributes
// probably best to update periodically
/* harmony default export */ __webpack_exports__["a"] = ([
/*{
    'displayName': 'Id',
    'name': 'id'
  },*/
{
  'displayName': 'Name',
  'name': 'name'
}, {
  'displayName': 'Legal Name',
  'name': 'legalName'
}, {
  'displayName': 'Domain',
  'name': 'domain'
}, {
  'displayName': 'Domain Aliases',
  'name': 'domainAliases'
}, {
  'displayName': 'Phone Numbers',
  'name': 'site.phoneNumbers'
}, {
  'displayName': 'Email Addresses',
  'name': 'site.emailAddresses'
}, {
  'displayName': 'Sector',
  'name': 'category.sector'
}, {
  'displayName': 'Industry Group',
  'name': 'category.industryGroup'
}, {
  'displayName': 'Industry',
  'name': 'category.industry'
}, {
  'displayName': 'Sub Industry',
  'name': 'category.subIndustry'
},
/*{
    'displayName': 'Sic Code',
    'name': 'category.sicCode'
  },
  {
    'displayName': 'Naics Code',
    'name': 'category.naicsCode'
  },*/
{
  'displayName': 'Tags',
  'name': 'tags'
}, {
  'displayName': 'Description',
  'name': 'description'
}, {
  'displayName': 'Founded Year',
  'name': 'foundedYear'
}, {
  'displayName': 'Location',
  'name': 'location'
}, {
  'displayName': 'Time Zone',
  'name': 'timeZone'
},
/*{
    'displayName': 'UTC Offset',
    'name': 'utcOffset'
  },*/
{
  'displayName': 'Street Number',
  'name': 'geo.streetNumber'
}, {
  'displayName': 'Street Name',
  'name': 'geo.streetName'
},
/*{
    'displayName': 'Sub Premise',
    'name': 'geo.subPremise'
  },*/
{
  'displayName': 'City',
  'name': 'geo.city'
}, {
  'displayName': 'Postal Code',
  'name': 'geo.postalCode'
}, {
  'displayName': 'State',
  'name': 'geo.state'
}, {
  'displayName': 'State Code',
  'name': 'geo.stateCode'
}, {
  'displayName': 'Country',
  'name': 'geo.country'
}, {
  'displayName': 'Country Code',
  'name': 'geo.countryCode'
},
/*{
    'displayName': 'Latitude',
    'name': 'geo.lat'
  },
  {
    'displayName': 'Longitude',
    'name': 'geo.lng'
  },*/
{
  'displayName': 'Logo',
  'name': 'logo'
}, {
  'displayName': 'Facebook Handle',
  'name': 'facebook.handle'
}, {
  'displayName': 'LinkedIn Handle',
  'name': 'linkedin.handle'
}, {
  'displayName': 'Twitter Handle',
  'name': 'twitter.handle'
}, {
  'displayName': 'Twitter Id',
  'name': 'twitter.id'
}, {
  'displayName': 'Twitter Bio',
  'name': 'twitter.bio'
}, {
  'displayName': 'Twitter Number Followers',
  'name': 'twitter.followers'
}, {
  'displayName': 'Twitter Number Following',
  'name': 'twitter.following'
}, {
  'displayName': 'Twitter Listed Location',
  'name': 'twitter.location'
}, {
  'displayName': 'Twitter Listed Site',
  'name': 'twitter.site'
}, {
  'displayName': 'Twitter Avatar',
  'name': 'twitter.avatar'
}, {
  'displayName': 'Crunchbase Handle',
  'name': 'crunchbase.handle'
},
/*{
    'displayName': 'Email Provider',
    'name': 'emailProvider'
  },*/
{
  'displayName': 'Corporation Type',
  'name': 'type'
}, {
  'displayName': 'Stock Ticker Symbol',
  'name': 'ticker'
},
/*{
    'displayName': 'US EIN',
    'name': 'identifiers.usEIN'
  },*/
{
  'displayName': 'Phone',
  'name': 'phone'
},
/*{
    'displayName': 'Indexed At',
    'name': 'indexedAt'
  },*/
{
  'displayName': 'Alexa US Rank',
  'name': 'metrics.alexaUsRank'
}, {
  'displayName': 'Alexa Global Rank',
  'name': 'metrics.alexaGlobalRank'
}, {
  'displayName': 'Headcount',
  'name': 'metrics.employees'
}, {
  'displayName': 'Headcount Range',
  'name': 'metrics.employeesRange'
}, {
  'displayName': 'Market Cap',
  'name': 'metrics.marketCap'
}, {
  'displayName': 'Capital Raised',
  'name': 'metrics.raised'
}, {
  'displayName': 'Annual Revenue',
  'name': 'metrics.annualRevenue'
}, {
  'displayName': 'Estimated Annual Revenue',
  'name': 'metrics.estimatedAnnualRevenue'
}, {
  'displayName': 'Fiscal Year End',
  'name': 'metrics.fiscalYearEnd'
}, {
  'displayName': 'Tech',
  'name': 'tech'
}, {
  'displayName': 'Domain',
  'name': 'parent.domain'
}]);

/***/ }),

/***/ "v/lX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ChatWidgetDesign":"ChatWidgetDesign---3VxWT"};

/***/ }),

/***/ "v4pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v9lS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_styles_colors__);





var CloseButtonPadding = 10;
var ContentPadding = 27;

var CloseButton = function CloseButton(_ref) {
  var onClick = _ref.onClick;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, {
    style: { cursor: 'pointer', padding: CloseButtonPadding, width: 33, height: 33 },
    element: 'div',
    onClick: onClick,
    src: __webpack_require__("+Juk")
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (_ref2) {
  var children = _ref2.children,
      onClose = _ref2.onClose;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'flex-space-between',
      style: {
        height: 75,
        paddingLeft: ContentPadding,
        paddingRight: ContentPadding - CloseButtonPadding,
        borderBottom: '2px solid ' + __WEBPACK_IMPORTED_MODULE_2_styles_colors___default.a['color-navy-light']
      }
    },
    children,
    onClose && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton, { onClick: onClose })
  );
});

/***/ }),

/***/ "vCIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchHubspotFieldsSuccess */
/* unused harmony export fetchHubspotAttributeMappingsSuccess */
/* unused harmony export patchHubspotAttributeMappingsSuccess */
/* unused harmony export patchHubspotAttributeMappingsError */
/* unused harmony export patchHubspotAttributeMappingsStart */
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchHubspotFields;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchHubspotAttributeMappings;
/* harmony export (immutable) */ __webpack_exports__["e"] = patchHubspotAttributeMappings;
/* unused harmony export searchHubspotUsersSuccess */
/* unused harmony export searchHubspotUsersError */
/* unused harmony export searchHubspotUsersStart */
/* harmony export (immutable) */ __webpack_exports__["g"] = searchHubspotUsers;
/* unused harmony export fetchHubspotUserMappingsSuccess */
/* unused harmony export fetchHubspotUserMappingsError */
/* unused harmony export fetchHubspotUserMappingsStart */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchHubspotUserMappings;
/* harmony export (immutable) */ __webpack_exports__["f"] = patchHubspotUserMappings;
/* unused harmony export patchHubspotUserMappingsStarted */
/* unused harmony export patchHubspotUserMappingsFailed */
/* unused harmony export patchHubspotUserMappingsSuccess */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchHubSpotByEmail;
/* unused harmony export fetchHubSpotByEmailStart */
/* unused harmony export fetchHubSpotByEmailFailed */
/* unused harmony export fetchHubSpotSuccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("RtjN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__ = __webpack_require__("AXIl");



function fetchHubspotFieldsSuccess(_ref) {
  var fields = _ref.fields;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FETCH_HUBSPOT_FIELDS_SUCCESS */],
    fields: fields
  };
}

function fetchHubspotAttributeMappingsSuccess(_ref2) {
  var mappings = _ref2.mappings,
      allowAttributeDefaults = _ref2.allowAttributeDefaults,
      useCountryAcronyms = _ref2.useCountryAcronyms,
      useStateAcronyms = _ref2.useStateAcronyms;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FETCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS */],
    mappings: mappings, allowAttributeDefaults: allowAttributeDefaults, useCountryAcronyms: useCountryAcronyms, useStateAcronyms: useStateAcronyms
  };
}

function patchHubspotAttributeMappingsSuccess(_ref3) {
  var mappings = _ref3.mappings,
      allowAttributeDefaults = _ref3.allowAttributeDefaults,
      useCountryAcronyms = _ref3.useCountryAcronyms,
      useStateAcronyms = _ref3.useStateAcronyms;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_SUCCESS */],
    mappings: mappings, allowAttributeDefaults: allowAttributeDefaults, useCountryAcronyms: useCountryAcronyms, useStateAcronyms: useStateAcronyms
  };
}

function patchHubspotAttributeMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_ERROR */],
    err: err
  };
}

function patchHubspotAttributeMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* PATCH_HUBSPOT_ATTRIBUTE_MAPPINGS_START */]
  };
}

function fetchHubspotFields() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].fetchHubspotFields().then(function (response) {
      dispatch(fetchHubspotFieldsSuccess(response));
    });
  };
}

function fetchHubspotAttributeMappings() {
  return function (dispatch) {
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].fetchHubspotMappings().then(function (response) {
      dispatch(fetchHubspotAttributeMappingsSuccess(response));
    });
  };
}

function patchHubspotAttributeMappings(mappings) {
  var successCB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  return function (dispatch) {
    dispatch(patchHubspotAttributeMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].patchHubspotMappings(mappings).then(function (response) {
      successCB();
      dispatch(patchHubspotAttributeMappingsSuccess(response));
    }).catch(function (err) {
      dispatch(patchHubspotAttributeMappingsError(err));
    });
  };
}

function searchHubspotUsersSuccess(_ref4) {
  var users = _ref4.users;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_HUBSPOT_USERS_SEARCH_SUCCESS */],
    users: users
  };
}

function searchHubspotUsersError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* FETCH_HUBSPOT_USERS_SEARCH_ERROR */],
    err: err
  };
}

function searchHubspotUsersStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_HUBSPOT_USERS_SEARCH_START */]
  };
}

function searchHubspotUsers(query) {
  return function (dispatch) {
    dispatch(searchHubspotUsersStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].searchHubspotUsers(query).then(function (response) {
      return dispatch(searchHubspotUsersSuccess(response));
    }, function (err) {
      return dispatch(searchHubspotUsersError(err));
    });
  };
}

function fetchHubspotUserMappingsSuccess(_ref5) {
  var mappings = _ref5.mappings,
      users = _ref5.users;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS */],
    mappings: mappings,
    users: users
  };
}

function fetchHubspotUserMappingsError(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_HUBSPOT_USER_MAPPINGS_ERROR */],
    err: err
  };
}

var fetchHubspotUserMappingsStart = function fetchHubspotUserMappingsStart() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["j" /* FETCH_HUBSPOT_USER_MAPPINGS_STARTED */]
  };
};

function fetchHubspotUserMappings() {
  return function (dispatch) {
    dispatch(fetchHubspotUserMappingsStart());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].fetchHubspotUserMappings().then(function (response) {
      return dispatch(fetchHubspotUserMappingsSuccess(response));
    }, function (err) {
      return dispatch(fetchHubspotUserMappingsError(err));
    });
  };
}

function patchHubspotUserMappings(data, successCB) {
  return function (dispatch) {
    dispatch(patchHubspotUserMappingsStarted());
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].patchHubspotUserMappings(data).then(function (resp) {
      successCB && successCB();
      dispatch(patchHubspotUserMappingsSuccess(resp));
    }, function (err) {
      return dispatch(patchHubspotUserMappingsFailed(err));
    });
  };
}

function patchHubspotUserMappingsStarted() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PATCH_HUBSPOT_USER_MAPPINGS_START */]
  };
}

function patchHubspotUserMappingsFailed(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* PATCH_HUBSPOT_USER_MAPPINGS_FAILED */],
    err: err
  };
}

function patchHubspotUserMappingsSuccess(_ref6) {
  var mappings = _ref6.mappings,
      users = _ref6.users;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["k" /* FETCH_HUBSPOT_USER_MAPPINGS_SUCCESS */],
    mappings: mappings,
    users: users
  };
}

function fetchHubSpotByEmail(_ref7) {
  var email = _ref7.email;

  return function (dispatch) {
    dispatch(fetchHubSpotByEmailStart(email));
    __WEBPACK_IMPORTED_MODULE_1_app_modules_hubspot_api__["a" /* api */].fetchHubSpotContactByEmail({ email: email }).then(function (response) {
      dispatch(fetchHubSpotSuccess(response, email));
    }).catch(function (err) {
      return dispatch(fetchHubSpotByEmailFailed(err, email));
    });
  };
}

function fetchHubSpotByEmailStart(key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FETCH_HUBSPOT_BY_EMAIL_STARTED */],
    key: key
  };
}

function fetchHubSpotByEmailFailed(err, key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FETCH_HUBSPOT_BY_EMAIL_FAILED */],
    err: err,
    key: key
  };
}

function fetchHubSpotSuccess(data, key) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FETCH_HUBSPOT_BY_EMAIL_SUCCESS */],
    data: data,
    key: key
  };
}

/***/ }),

/***/ "vCza":
/***/ (function(module, exports) {

module.exports = "<svg width=\"56\" height=\"58\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><defs><polyline id=\"a\" points=\"0 0.0232595892 10.3601362 0.0232595892 10.3601362 8.25425331 0 8.25425331\"></polyline><linearGradient x1=\"100%\" y1=\"100%\" x2=\"0%\" y2=\"-4.824%\" id=\"b\"><stop stop-color=\"#AA55D5\" offset=\"0%\"></stop><stop stop-color=\"#FF5A39\" offset=\"100%\"></stop></linearGradient></defs><g fill=\"none\" fill-rule=\"evenodd\"><polygon stroke=\"#2C3E48\" stroke-width=\"2\" fill=\"#FFFFFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"2.00059532 25.7252985 28.3614693 42.7371119 54.7318684 25.7252985 28.3614693 16\"></polygon><g transform=\"translate(15.001 10)\" stroke=\"#2C3E48\" stroke-width=\"2.121\"><ellipse fill=\"#FFFFFF\" cx=\"14.147\" cy=\"9\" rx=\"8.839\" ry=\"9\"></ellipse><path d=\"M27.526 33.32c0-7.74-6.162-14.014-13.763-14.014S0 25.58 0 33.32h27.526z\" fill=\"#5662E7\"></path></g><polygon stroke=\"#2C3E48\" stroke-width=\"2\" fill=\"#FFFFFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"54.7317494 25.7249425 54.7317494 56.0327933 2.00047626 56.0327933 2.00047626 25.7249425 28.3625409 42.736756\"></polygon><polygon stroke=\"#2C3E48\" stroke-width=\"2\" fill=\"#FFFFFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" points=\"28.3620646 42.7366373 2 56.0326746 2 25.7248239\"></polygon><g transform=\"translate(.031 10.786)\"><mask id=\"c\" fill=\"white\"><use xlink:href=\"#a\"></use></mask><path d=\"M5.625.28c.684 0 1.28.434 1.598 1.076a1.99 1.99 0 0 1 .904-.218c1.233 0 2.233 1.145 2.233 2.558 0 1.412-1 2.557-2.233 2.557-.151 0-.298-.017-.44-.05-.28.567-.813.95-1.425.95-.257 0-.499-.068-.715-.187-.283.757-.944 1.288-1.714 1.288-.803 0-1.486-.576-1.749-1.384a1.523 1.523 0 0 1-.355.042C.774 6.912 0 6.024 0 4.93c0-.734.348-1.375.865-1.718a2.536 2.536 0 0 1-.166-.907c0-1.26.901-2.28 2.012-2.28.653 0 1.232.351 1.6.897.334-.395.8-.64 1.314-.64z\" fill=\"url(#b)\" fill-rule=\"nonzero\" mask=\"url(#c)\"></path></g><circle fill=\"#FFFFFF\" cx=\"47.5\" cy=\"8.5\" r=\"5.5\"></circle><path d=\"M24 .946a3.41 3.41 0 0 1-1.063.319c.386-.25.678-.65.813-1.117a3.58 3.58 0 0 1-1.167.49C22.24.251 21.76 0 21.23 0c-1.02 0-1.844.9-1.844 2.017 0 .16.01.32.042.467-1.531-.09-2.885-.854-3.802-2.074-.156.297-.25.604-.25.98 0 .695.323 1.31.823 1.676a1.757 1.757 0 0 1-.833-.251c0 1.003.635 1.823 1.479 2.006a1.757 1.757 0 0 1-.834.034c.23.797.917 1.39 1.72 1.401-.626.547-1.428.958-2.293.958A2.83 2.83 0 0 1 15 7.179c.813.57 1.792.821 2.833.821 3.396 0 5.25-3.077 5.25-5.744v-.262c.355-.285.667-.638.917-1.048zM38.193 3.645a.784.784 0 0 1-.945-.96.777.777 0 0 1 .56-.568.784.784 0 0 1 .944.96.777.777 0 0 1-.559.568M38 0c-1.657 0-3 1.365-3 3.048 0 1.32 1.846 3.779 2.641 4.778a.456.456 0 0 0 .718 0c.795-1 2.641-3.458 2.641-4.778C41 1.365 39.657 0 38 0M47.167 11.723V17h1.666v-5.277h-1.666zm4.333 2.213c0-.68.426-1.021.926-1.021s.907.34.907 1.191V17H55v-3.064c0-1.532-.833-2.383-2-2.383-.667 0-1.167.388-1.5.899l-.056-.729h-1.638c0 .18.027 1.192.027 1.192V17H51.5v-3.064zm-3.51-3.064c.621 0 1.01-.416 1.01-.936-.01-.53-.389-.936-.99-.936-.612 0-1.01.407-1.01.936 0 .52.389.936.981.936h.01z\" fill=\"url(#b)\"></path></g></svg>"

/***/ }),

/***/ "vJPe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TimeLine":"TimeLine---35E_g","MonthDivider":"MonthDivider---3TmjR"};

/***/ }),

/***/ "vJV5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vMFt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vMoV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Audiences; });
/* unused harmony export audienceSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_enum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");




var SEGMENT_DESCRIPTION_PREFIX = "This chat is available to ";

var Audiences = new __WEBPACK_IMPORTED_MODULE_1_enum___default.a({
  EVERYONE: {
    display: 'Everyone',
    long: 'This chat is available to everyone who visits your website.'
  },
  USERS: {
    display: 'Known Users',
    long: 'This chat is available to known users who visit your website.'
  },
  SEGMENT: {
    display: 'Choose a Segment',
    long: 'This chat is available to SEGMENT who visit your website.'
  }
});

function audienceSummary(orgSettings, segments) {
  var audience = orgSettings.theme.audience;

  var userListIds = orgSettings.theme.userListIds.toSet();

  if (!audience) {
    return;
  }

  if (audience === Audiences.SEGMENT.key && userListIds.size > 0) {
    var selectedSegments = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(segments, function (segment) {
      return userListIds.includes(segment.id);
    });

    if (selectedSegments.length > 0) {
      var segmentLinks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.flatten(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(selectedSegments, function (segment) {
        return [React.createElement(
          'span',
          null,
          ', '
        ), React.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
          { to: '/contacts/segments/' + segment.id },
          segment.name
        )];
      })).slice(1);

      return React.createElement(
        'span',
        null,
        SEGMENT_DESCRIPTION_PREFIX,
        ' ',
        segmentLinks
      );
    }
  } else if (Audiences[audience]) {
    return Audiences[audience].value.long;
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "vOUw":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNSAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNDc3IDE0LjU0aC0xLjA5NGwtLjk3NSA2LjYzYy0uMDY1LjQ0Ni0uNDQzLjc3NS0uODg3Ljc3NUg0LjUzYy0uNDQ1IDAtLjgyMy0uMzMtLjg5LS43NzRsLS45NzMtNi42M0guODk3Yy0uNDk1IDAtLjg5Ny0uNDA3LS44OTctLjkxdi0yLjcyN2MwLS41MDMuNDAyLS44MTcuODk4LS44MTdoNS40MWMtLjAwNC0uMDMyLS4wMi0uMDYtLjAyLS4wOTJ2LTEuODVDNC44IDguMDczIDMuNTY3IDcuNTkgMi42NDIgNi42Ny43NyA0Ljc5Ni44OTcgMS45LjkwMyAxLjc4Yy4wMDItLjA0NS4wMjMtLjA4Mi4wMy0uMTI1LjAxMy0uMDYuMDIzLS4xMTguMDQ1LS4xNzQuMDI1LS4wNi4wNi0uMTEuMDk1LS4xNjIuMDI4LS4wNC4wNTItLjA4Mi4wODYtLjExNy4wNTMtLjA1Ni4xMTQtLjEuMTgtLjE0LjAzLS4wMTguMDU2LS4wNC4wOS0uMDU1LjA3LS4wMzQuMTQ2LS4wNS4yMjUtLjA2MkMxLjY4My45NCAxLjcxLjkyIDEuNzQuOTJjLjAzMi0uMDAyLjA1OC4wMDIuMDg4IDBsLjAxOC0uMDAyYy4wMDQgMCAuMDA3LjAwMy4wMS4wMDMgMS44ODctLjEwNCAzLjM5My4zOTUgNC40ODcgMS40ODcuMjI1LjIyNi40Mi40NjguNTkyLjcxNy4yNTMtLjU2Ni42LTEuMTMgMS4wOTctMS42MjZDOS4xMjYuNDA4IDEwLjY0LS4wODYgMTIuNTE4LjAxMmwuMDEtLjAwMmMuMDA4IDAgLjAxMy4wMDIuMDIgMCAuMDMuMDAzLjA1NiAwIC4wODcgMCAuMDMuMDAyLjA1NS4wMi4wODQuMDIzLjA4LjAxMy4xNTYuMDMuMjI3LjA2My4wMzQuMDE2LjA2LjAzNy4wOTIuMDU2LjA2My4wNC4xMjIuMDgyLjE3NC4xMzguMDM2LjAzNy4wNjIuMDguMDkuMTIyLjAzNS4wNTIuMDY4LjEuMDkzLjE1OC4wMjMuMDU3LjAzMy4xMTYuMDQ1LjE3Ny4wMDguMDQyLjAzLjA4LjAzLjEyMy4wMDcuMTIzLjEzNCAzLjAxOC0xLjc0IDQuODg4LS45MjMuOTI0LTIuMTU2IDEuNDA1LTMuNjQ2IDEuNDc3djIuNzZjMCAuMDMyLS4wMTUuMDYtLjAyLjA5aDUuNDFjLjQ5NyAwIC45LjMxNS45LjgxOHYyLjcyN2MwIC41MDMtLjQwMy45MS0uOS45MXpNMTAuNDcgNC40NjRjLjc3NS0uNzc0IDEuMDUtMS44NzIgMS4xNS0yLjYzMy0uOTczLjA3NC0xLjc1Ni4zOTMtMi4zMjUuOTYyLS43NzQuNzczLTEuMDUgMS44Ny0xLjE1IDIuNjMuOTctLjA3NCAxLjc1Ni0uMzkgMi4zMjUtLjk1OHpNNS4zMDIgMjAuMTI2aDQuNDQ2bC44MTYtNS41ODZINC40ODdsLjgxNSA1LjU4NnptLS4yMy0xNi40MzJjLS41NjctLjU2NS0xLjM1LS44OC0yLjMyLS45NTMuMS43NjIuMzc2IDEuODYzIDEuMTYgMi42NC41NjguNTY1IDEuMzUuODggMi4zMi45NTMtLjEtLjc2LS4zNzYtMS44NjItMS4xNi0yLjY0em03LjUwNiA4LjExOEgxLjc5OHYxLjAxNGgxMC43OHYtMS4wMTR6IiBmaWxsPSIjNzY5NUE1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4="

/***/ }),

/***/ "vPMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ChatWidget":"ChatWidget---1E0L_"};

/***/ }),

/***/ "vPdD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var END_USER_ICON_SRC = __webpack_require__("vOUw");

var EndUserAddedEvent = function (_Component) {
  _inherits(EndUserAddedEvent, _Component);

  function EndUserAddedEvent() {
    _classCallCheck(this, EndUserAddedEvent);

    return _possibleConstructorReturn(this, (EndUserAddedEvent.__proto__ || Object.getPrototypeOf(EndUserAddedEvent)).apply(this, arguments));
  }

  _createClass(EndUserAddedEvent, [{
    key: 'render',
    value: function render() {
      var org = this.props.org;

      var eventProps = _extends({
        iconSrc: END_USER_ICON_SRC,
        eventLabel: "added to"
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
        eventProps,
        org.name
      );
    }
  }]);

  return EndUserAddedEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var container = Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(EndUserAddedEvent, {
  listenTo: ['stores.OrgStore'],
  fetch: {
    org: function org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (container);

/***/ }),

/***/ "vS8u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(507);

/***/ }),

/***/ "vTSr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return handle; });
/* unused harmony export orgHandle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return globalHandle; });
/* unused harmony export handleFetchStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return globalHandleCheckComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isGlobalHandleValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isHandleValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isValidHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return overview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return social; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return details; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return messaging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coverPhotoUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_selectors__ = __webpack_require__("Bqo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__("sAia");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("QF6P");





var profile = function profile(state) {
  return state.getIn(['profileUI', 'data']);
};
var handle = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(function (state) {
  return state.getIn(['profileUI', 'data', 'handle']);
}, function (handle) {
  if (typeof handle === 'undefined') {
    return '';
  }
  return handle;
});

var orgHandle = function orgHandle(state) {
  return state.getIn(['profileUI', 'data', 'orgHandle']);
};
var globalHandle = function globalHandle(state) {
  return state.getIn(['profileUI', 'data', 'globalHandle']);
};
var handleFetchStatus = function handleFetchStatus(state) {
  return state.getIn(['profileUI', 'handle', 'status']);
};
var globalHandleCheckComplete = function globalHandleCheckComplete(state) {
  return state.getIn(['profileUI', 'handle', 'status'], false) === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* constants */].RECEIVE_USER_GLOBAL_HANDLE_EXISTENCE;
};
var isGlobalHandleValid = function isGlobalHandleValid(state) {
  return state.getIn(['profileUI', 'valid', 'globalHandle'], true);
};
var isHandleValid = function isHandleValid(state) {
  return state.getIn(['profileUI', 'valid', 'handle'], true);
};

var isValidHandle = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(handle, function (state) {
  return state.getIn(['profile', 'data', 'handle']);
}, function (state) {
  return state.getIn(['profileUI', 'valid', 'handle']);
}, function (handle, originalHandle, valid) {
  if (handle === originalHandle || typeof valid === 'undefined') return true;
  return valid && !!handle && handle.length > 0 && !handle.includes('.');
});

var overview = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([handle, globalHandle, Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(profile, function (profile) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* Overview */])(profile);
})], function (handle, globalHandle, overview) {
  return overview.set('handle', handle).set('globalHandle', globalHandle);
});
var social = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(profile, function (profile) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__models__["e" /* Social */])(profile);
});
var details = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(profile, function (profile) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__models__["a" /* Details */])(profile);
});
var messaging = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(profile, function (profile) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__models__["b" /* Messaging */])(profile);
});
var theme = Object(__WEBPACK_IMPORTED_MODULE_1_utils_selectors__["b" /* immutableSelector */])(profile, function (profile) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__models__["f" /* Theme */])(profile);
});
var coverPhotoUpload = function coverPhotoUpload(state) {
  return state.getIn(['profileUI', 'coverPhotoUpload']);
};

/***/ }),

/***/ "vY9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_PARDOT_FIELDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_PARDOT_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PATCH_PARDOT_MAPPINGS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PATCH_PARDOT_MAPPINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PATCH_PARDOT_MAPPINGS_START; });
var FETCH_PARDOT_FIELDS_SUCCESS = 'FETCH_PARDOT_FIELDS_SUCCESS';
var FETCH_PARDOT_MAPPINGS_SUCCESS = 'FETCH_PARDOT_MAPPINGS_SUCCESS';
var PATCH_PARDOT_MAPPINGS_ERROR = 'PATCH_PARDOT_MAPPINGS_ERROR';
var PATCH_PARDOT_MAPPINGS_SUCCESS = 'PATCH_PARDOT_MAPPINGS_SUCCESS';
var PATCH_PARDOT_MAPPINGS_START = 'PATCH_PARDOT_MAPPINGS_START';

/***/ }),

/***/ "vaNF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/upsell-logos@2x.70a3f2a1.png";

/***/ }),

/***/ "vd8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState__ = __webpack_require__("lwrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle__ = __webpack_require__("xDLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component__ = __webpack_require__("9MpX");














var mapStateToProps = function mapStateToProps(state) {
  var userListIds = __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_104" /* userListIds */](state);
  return {
    checked: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_37" /* isEnabled */](state),
    isEmailPlaybook: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    isOutboundSequencePlaybook: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_6" /* getIsOutboundSequencePlaybook */](state),
    userListIds: userListIds,
    excludedUserListIds: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["A" /* excludedUserListIds */](state),
    draft: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["n" /* draft */](state),
    targetingCardinality: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_102" /* targetingCardinality */](state),
    smartFilters: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_98" /* smartFilters */](state),
    orgId: __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["orgId"](state),
    saved: __WEBPACK_IMPORTED_MODULE_8_app_modules_playbook_selectors__["_46" /* isSaved */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setDraftStatus: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_151" /* setDraftStatus */],
      setStatus: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_215" /* setStatus */],
      fetchPlaybookCardinality: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_25" /* fetchPlaybookCardinality */],
      showSendEmailConfirmModal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_238" /* showSendEmailConfirmModal */],
      enablePlaybookAutosave: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["T" /* enablePlaybookAutosave */],
      disablePlaybookAutosave: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["O" /* disablePlaybookAutosave */],
      showDisableSalesSequenceModal: __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_actions__["_229" /* showDisableSalesSequenceModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_withState___default()('defaultValue', 'setDefaultValue', false), __WEBPACK_IMPORTED_MODULE_5_recompose_lifecycle___default()({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        userListIds = _props.userListIds,
        excludedUserListIds = _props.excludedUserListIds,
        orgId = _props.orgId,
        smartFilters = _props.smartFilters;

    if (!window.isFinite(this.props.targetingCardinality)) {
      this.props.actions.fetchPlaybookCardinality({ orgId: orgId, userListIds: userListIds, excludedUserListIds: excludedUserListIds, smartFilters: smartFilters });
    }
  }
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onChange: function onChange(props) {
    return function () {
      var _props$actions = props.actions,
          disablePlaybookAutosave = _props$actions.disablePlaybookAutosave,
          enablePlaybookAutosave = _props$actions.enablePlaybookAutosave,
          setDraftStatus = _props$actions.setDraftStatus,
          showDisableSalesSequenceModal = _props$actions.showDisableSalesSequenceModal,
          showSendEmailConfirmModal = _props$actions.showSendEmailConfirmModal;


      if (!props.saved && props.draft.status !== __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED) {
        var wantsToEnable = confirm((props.isEmailPlaybook ? 'Send email' : 'Enable playbook') + ' without saving your changes?');
        if (!wantsToEnable) {
          props.setDefaultValue(!props.defaultValue);
          return;
        }
      }
      if (props.isEmailPlaybook && !props.isOutboundSequencePlaybook) {
        if (!props.checked) {
          props.setDefaultValue(false);
          showSendEmailConfirmModal();
        } else {
          setDraftStatus({ status: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED });
        }
        // Show DiableSalesSequenceModal if turning a Sales Sequence playbook off.
      } else if (props.isEmailPlaybook && props.isOutboundSequencePlaybook) {
        if (props.checked) {
          props.setDefaultValue(true);
          showDisableSalesSequenceModal();
        } else {
          setDraftStatus({ status: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED });
        }
      } else {
        var newStatus = props.draft.status === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED ? __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED : __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED;
        if (newStatus === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].ENABLED) {
          disablePlaybookAutosave();
        } else if (newStatus === __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_constants__["_141" /* PlaybookStatus */].DISABLED) {
          enablePlaybookAutosave();
        }
        setDraftStatus({ status: newStatus });
      }
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_10__component__["a" /* default */]));

/***/ }),

/***/ "vdcO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(476);

/***/ }),

/***/ "vfHo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EMAIL_ICON_SRC = __webpack_require__("XLdb");

var EmailCaptureCampaignEvent = function (_Component) {
  _inherits(EmailCaptureCampaignEvent, _Component);

  function EmailCaptureCampaignEvent() {
    _classCallCheck(this, EmailCaptureCampaignEvent);

    return _possibleConstructorReturn(this, (EmailCaptureCampaignEvent.__proto__ || Object.getPrototypeOf(EmailCaptureCampaignEvent)).apply(this, arguments));
  }

  _createClass(EmailCaptureCampaignEvent, [{
    key: 'render',
    value: function render() {
      var campaign = this.props.event.body.campaign;

      var eventProps = _extends({
        iconSrc: EMAIL_ICON_SRC,
        eventLabel: "submitted email to campaign"
      }, this.props);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
        eventProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
          { to: '/campaigns/email-capture/' + campaign.id },
          campaign.name
        )
      );
    }
  }]);

  return EmailCaptureCampaignEvent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EmailCaptureCampaignEvent);

/***/ }),

/***/ "vg0m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(23);

/***/ }),

/***/ "vhf4":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 18c-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9s9 4.038 9 9c0 4.963-4.038 9-9 9zM9 1.125C4.657 1.125 1.125 4.657 1.125 9c0 4.342 3.532 7.875 7.875 7.875 4.342 0 7.875-3.533 7.875-7.875 0-4.343-3.533-7.875-7.875-7.875zm3.21 11.085a.561.561 0 0 1-.795 0L9 9.795 6.585 12.21a.561.561 0 0 1-.795 0 .562.562 0 0 1 0-.795L8.205 9 5.79 6.585a.561.561 0 1 1 .795-.795L9 8.205l2.415-2.415a.561.561 0 1 1 .795.795L9.795 9l2.415 2.415c.22.22.22.576 0 .795z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "vk0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vozR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export driftNormalizeUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkUrlValidity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_url__ = __webpack_require__("ZC2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalize_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalize_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");







var isAnyOf = function isAnyOf(values, state) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(values, function (val) {
    return state === val;
  });
};

var notIsAnyOf = function notIsAnyOf(values, state) {
  return !isAnyOf(values, state);
};

var is = function is(value, state) {
  return value === state;
};

var notIs = function notIs(value, state) {
  return value !== state;
};

var isMatch = function isMatch(values) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(values)) {
    values = [values];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(values.map(function (value) {
    return new RegExp(value);
  }), function (val) {
    return val.test(state);
  });
};

var notIsMatch = function notIsMatch(values) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return !isMatch(values, state);
};

var includesAnyOf = function includesAnyOf(values) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(values, function (val) {
    return state.indexOf(val) !== -1;
  });
};

var notIncludesAnyOf = function notIncludesAnyOf(values) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["every"])(values, function (val) {
    return state.indexOf(val) === -1;
  });
};

var url = function url(operand, value, testUrl) {
  return operand(value, testUrl);
};

var urlPath = function urlPath(operand, value, testPathname) {
  return operand(value, testPathname);
};

var urlHost = function urlHost(operand, value, testHostname) {
  return operand(value, testHostname);
};

var urlQuery = function urlQuery(operand, value, testSearchParam) {
  // coerce to array
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(value)) {
    value = [value];
  }

  // group by key so we can check one param at a time with the specified operator
  var valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["chain"])(value).filter(function (keyAndValue) {
    return keyAndValue.indexOf('=') > 0;
  }).map(function (keyAndValue) {
    return keyAndValue.split('=', 2);
  }).map(function (keyAndValue) {
    return {
      key: keyAndValue[0].toLowerCase(),
      val: keyAndValue[1]
    };
  }).groupBy('key').mapValues(function (values) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["map"])(values, 'val');
  }).value();

  // only happens if there was an invalid key
  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(valuesByKey)) {
    return true;
  }

  var query = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.parse(testSearchParam);

  // values within a condition are OR'd
  // FIXME technically not true for `notIsAnyOf` and `notIncludesAnyOf`
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["some"])(valuesByKey, function (values, key) {
    return operand(values, query[key]);
  });
};

var driftNormalizeUrl = function driftNormalizeUrl(url) {
  try {
    url = __WEBPACK_IMPORTED_MODULE_1_normalize_url___default()(url, {
      normalizeProtocol: true, // convert '//' -> 'http://'
      stripFragment: false,
      stripWWW: true,
      removeQueryParameters: [], // default is to remove 'utm_' params
      removeTrailingSlash: true
    });
  } catch (e) {
    console.warn('Could not parse URL \'' + url + '\'');
  }

  // strip protocol entirely - `normalizeProtocol` only converts to http://
  return url.replace(/^https?:\/\//, '');
};

var operands = {
  is: is,
  notIs: notIs,
  isMatch: isMatch,
  notIsMatch: notIsMatch,
  isAnyOf: isAnyOf,
  notIsAnyOf: notIsAnyOf,
  includesAnyOf: includesAnyOf,
  notIncludesAnyOf: notIncludesAnyOf
};

var validationDefinitions = {
  url: {
    fn: url,
    typeFn: driftNormalizeUrl,
    selector: function selector(anchor) {
      return anchor.href;
    },
    operands: {
      is: is,
      notIs: notIs,
      isMatch: isMatch,
      notIsMatch: notIsMatch,
      isAnyOf: isAnyOf,
      notIsAnyOf: notIsAnyOf,
      includesAnyOf: includesAnyOf,
      notIncludesAnyOf: notIncludesAnyOf
    }
  },
  urlPath: {
    fn: urlPath,
    typeFn: driftNormalizeUrl,
    selector: function selector(anchor) {
      return anchor.pathname;
    },
    operands: {
      is: is,
      notIs: notIs,
      isAnyOf: isAnyOf,
      notIsAnyOf: notIsAnyOf,
      includesAnyOf: includesAnyOf,
      notIncludesAnyOf: notIncludesAnyOf
    }
  },
  urlHost: {
    fn: urlHost,
    selector: function selector(anchor) {
      return anchor.hostname;
    },
    operands: {
      is: is,
      notIs: notIs,
      isAnyOf: isAnyOf,
      notIsAnyOf: notIsAnyOf,
      includesAnyOf: includesAnyOf,
      notIncludesAnyOf: notIncludesAnyOf
    }
  },
  urlQuery: {
    fn: urlQuery,
    selector: function selector(anchor) {
      return anchor.search.slice(1);
    }, // get rid of "?"
    operands: {
      is: is,
      notIs: notIs,
      isAnyOf: isAnyOf,
      notIsAnyOf: notIsAnyOf,
      includesAnyOf: includesAnyOf,
      notIncludesAnyOf: notIncludesAnyOf
    }
  }
};

var checkUrlValidity = function checkUrlValidity(value, operator, field, testAnchor) {
  try {
    var operand = operands[operator];
    var _validationDefinition = validationDefinitions[field],
        fn = _validationDefinition.fn,
        _validationDefinition2 = _validationDefinition.typeFn,
        typeFn = _validationDefinition2 === undefined ? function (url) {
      return url;
    } : _validationDefinition2,
        selector = _validationDefinition.selector;

    return fn(operand, __WEBPACK_IMPORTED_MODULE_2_immutable__["List"].isList(value) ? value.map(typeFn).toJS() : typeFn(value), typeFn(selector(testAnchor)));
  } catch (err) {
    Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["a" /* captureException */])(err, {
      extra: {
        value: value,
        operator: operator,
        field: field,
        testAnchor: testAnchor
      }
    });
    return false;
  }
};

/***/ }),

/***/ "vt/k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCardState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHrefsByMessageId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCardsByHref; });
/* unused harmony export makeMessageHrefs */
/* unused harmony export makeGetCardsByMessageId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_message_selectors__ = __webpack_require__("bWf9");




var getCardState = function getCardState(state) {
  return state.get('cards');
};
var getHrefsByMessageId = function getHrefsByMessageId(state) {
  return getCardState(state).hrefsByMessageId;
};
var getCardsByHref = function getCardsByHref(state) {
  return getCardState(state).cardsByHref;
};

var EMBED_VIDYARD = "https://embed.vidyard.com";
var SUPPORTED_PLAYER_SITES = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(['YouTube', 'Vimeo', 'ViewedIt', 'Vidyard', 'Vidyard GoVideo', 'Wistia, Inc.', 'GIPHY']);

var makeMessageHrefs = function makeMessageHrefs() {
  var latestEditMessageSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2_app_modules_message_selectors__["i" /* makeLatestEditMessageSelector */]();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state, _ref) {
    var _ref$message = _ref.message,
        conversationId = _ref$message.conversationId,
        id = _ref$message.id;
    return latestEditMessageSelector(state, { conversationId: conversationId, messageId: id });
  }, getHrefsByMessageId, function (state, props) {
    return props;
  }], function (latestEditMessage, getHrefsByMessageId, props) {
    var id = props.message.id;

    return getHrefsByMessageId.get(latestEditMessage ? latestEditMessage.id : id, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());
  });
};

var makeGetCardsByMessageId = function makeGetCardsByMessageId() {
  var messageHrefs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : makeMessageHrefs();
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(messageHrefs, getCardsByHref, function (messageHrefs, cardsByHref) {
    return messageHrefs.map(function (href) {
      return cardsByHref.get(href);
    }).filter(function (cardAndStatus) {
      return !!cardAndStatus && cardAndStatus.status === 'success';
    }).map(function (cardAndStatus) {
      return cardAndStatus.card;
    }).filter(function (card) {
      var primaryRel = card.primaryRel;
      if (primaryRel === 'summary') {
        return true;
      }
      if (primaryRel === 'player') {
        return SUPPORTED_PLAYER_SITES.has(card.meta.site) || card.meta.canonical && card.meta.canonical.includes(EMBED_VIDYARD);
      }
      return false;
    });
  });
};

/***/ }),

/***/ "vuMb":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "w1VU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



function withNotifications(WrappedComponent) {
  var Notifications = function (_Component) {
    _inherits(Notifications, _Component);

    function Notifications() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Notifications);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call.apply(_ref, [this].concat(args))), _this), _this.success = function (content) {
        _this.sendMessage({
          variant: 'green',
          sticky: false,
          viewLinkTo: null,
          content: content
        });
      }, _this.error = function (content) {
        _this.sendMessage({
          variant: 'red',
          sticky: false,
          viewLinkTo: null,
          content: content
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Notifications, [{
      key: 'sendMessage',
      value: function sendMessage(settings) {
        this.app.actions.NotificationActions.pushNotification(settings);
      }
    }, {
      key: 'render',
      value: function render() {
        var success = this.success,
            error = this.error;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, _extends({}, this.props, { notifications: { success: success, error: error } }));
      }
    }]);

    return Notifications;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  return Marty.createContainer(Notifications);
}

/* harmony default export */ __webpack_exports__["a"] = (withNotifications);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "w2j9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_immutable__ = __webpack_require__("QRWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user__ = __webpack_require__("2phg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_teams_actions__ = __webpack_require__("YWXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__ = __webpack_require__("CR44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models__ = __webpack_require__("TL61");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_user_api__ = __webpack_require__("+Z1b");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












// In the future gates should live in a separate module
function preserveGatesAndScopes(oldVal, newVal, key) {
  if (key === 'gates') {
    if (oldVal.isEmpty()) {
      return newVal;
    }

    return oldVal;
  }

  if (key === 'scopes') {
    if (!oldVal || oldVal.length === 0) {
      return newVal;
    }

    return oldVal;
  }

  return newVal;
}

var currentUser = Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchClearbitForEmailSuccess, function (state, action) {
  var attributes = action.payload.get('attributes');
  if (attributes) {
    return state.set('enrichment', Object(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* Enrichment */])(attributes));
  }
  return state;
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchGoogleScopesSuccess, function (state, action) {
  return state.set('googleScopes', action.payload);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchEmailSignatureSuccess, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].setEmailSignatureSuccess), function (state, action) {
  return state.set('emailSignature', action.payload);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchGoogleScopesPending, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchGoogleScopesFailed, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchGoogleScopesSuccess), function (state, action) {
  return state.set('googleScopesStatus', action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveCurrentUser, function (state, action) {
  var user = state.get('user', Object(__WEBPACK_IMPORTED_MODULE_8__models__["d" /* User */])());
  return state.set('user', user.mergeWith(preserveGatesAndScopes, action.payload));
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignature, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignaturePending, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignatureFailed, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignatureCancelled, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignatureSuccess), function (state, action) {
  return state.setIn(['orgSignature', 'status'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignatureSuccess, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgSignatureFailed), function (state, action) {
  return state.setIn(['orgSignature', 'data'], action.payload);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignature, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignaturePending, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignatureFailed, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignatureCancelled, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignatureSuccess), function (state, action) {
  return state.setIn(['orgMultiSignature', 'status'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignatureSuccess, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgMultiSignatureFailed), function (state, action) {
  return state.setIn(['orgMultiSignature', 'data'], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveGates, function (state, action) {
  return state.setIn(['user', 'gates'], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveOrgUsers, function (state, action) {
  return state.set('orgUsers', Object(__WEBPACK_IMPORTED_MODULE_3_utils_immutable__["a" /* keyBy */])(action.payload));
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveOrgUser, function (state, action) {
  return state.setIn(['orgUsers', action.payload.id], action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_5_app_modules_profile_actions__["fetchUserProfileSuccess"], function (state, action) {
  var _action$payload = action.payload,
      userId = _action$payload.userId,
      profile = _action$payload.profile;

  return state.setIn(['orgUsers', userId, 'profile'], profile);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_6_app_modules_teams_actions__["B" /* fetchTeamsForUserSuccess */], function (state, action) {
  var _action$payload2 = action.payload,
      userId = _action$payload2.userId,
      teams = _action$payload2.teams;

  return state.setIn(['orgUsers', userId, 'teams'], teams);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_7_app_modules_org_actions__["receiveUserScopes"], function (state, action) {
  var userIds = Object.keys(action.payload);

  return state.withMutations(function (_state) {
    Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["each"])(userIds, function (userId) {
      return _state.setIn(['orgUsers', parseInt(userId), 'scopes'], action.payload[userId]);
    });
  });
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUserStarted, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveCurrentUser, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUserFailed), function (state, action) {
  return state.setIn(['status', 'currentUser'], action.type);
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgUsersStarted, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchOrgUsersFailed, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].receiveOrgUsers), function (state, action) {
  return state.setIn(['status', 'orgUsers'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchCurrentUserFailed, function (state, action) {
  return state.set('error', action.payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].disconnectGmailAccountSuccess, function (state) {
  return state.withMutations(function (state) {
    return state.set('googleScopes', []);
  });
}), _defineProperty(_handleActions, Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["combineActions"])(__WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchIndividualUserConvoLimit, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchIndividualUserConvoLimitPending, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchIndividualUserConvoLimitFailed, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchIndividualUserConvoLimitCancelled), function (state, action) {
  return state.setIn(['userConvoLimits', action.payload.userId, 'status'], action.type);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].fetchIndividualUserConvoLimitSuccess, function (state, action) {
  return state.setIn(['userConvoLimits', action.payload.userId, 'status'], action.type).setIn(['userConvoLimits', action.payload.userId, 'data'], action.payload.data);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].updateIndividualUserConvoLimitSuccess, function (state, action) {
  return state.setIn(['userConvoLimits', action.payload.userId, 'status'], action.type).setIn(['userConvoLimits', action.payload.userId, 'data'], action.payload.data);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].updateUserPending, function (state, _ref) {
  var payload = _ref.payload;
  return state.set('lastUpdatedUser', null).setIn(['status', 'updateUser'], 'pending').updateIn(['orgUsers', payload.id], function (user) {
    var scopes = payload.scopes,
        availability = payload.availability;

    return user.merge({ scopes: scopes, availability: availability });
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].updateUserSuccess, function (state, _ref2) {
  var payload = _ref2.payload;
  return state.setIn(['status', 'updateUser'], 'success').set('lastUpdatedUser', payload);
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_4_app_modules_user__["a" /* actions */].updateUserFailed, function (state, action) {
  return state.set('lastUpdatedUser', null).setIn(['status', 'updateUser'], 'failed').setIn(['orgUsers', action.payload.id], Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_user_api__["b" /* parseUser */])(action.payload));
}), _handleActions), Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  enrichment: Object(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* Enrichment */])()
}));

/***/ }),

/***/ "wCVS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TitleCard":"TitleCard---3RssV"};

/***/ }),

/***/ "wEE2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wFBz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return teams; });
/* unused harmony export teamAvailabilities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return teamsOptions; });
/* unused harmony export teamsStatus */
/* unused harmony export makeTeamSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTeamsSuccess; });
/* unused harmony export teamsForUser */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchTeamsPending; });
/* unused harmony export fetchTeamsFailed */
/* unused harmony export createTeamFailed */
/* unused harmony export createTeamSucceeded */
/* unused harmony export patchTeamFailed */
/* unused harmony export patchTeamPending */
/* unused harmony export patchTeamSucceeded */
/* unused harmony export deleteTeamFailed */
/* unused harmony export deleteTeamSucceeded */
/* unused harmony export updateAvailabilityForTeamSucceeded */
/* unused harmony export updateAvailabilityForTeamPending */
/* unused harmony export updateAvailabilityForTeamFailed */
/* unused harmony export fetchTeamAvailabilitiesSucceeded */
/* unused harmony export fetchTeamAvailabilitiesPending */
/* unused harmony export fetchTeamAvailabilitiesFailed */
/* unused harmony export fetchTeamAvailabilitySucceeded */
/* unused harmony export fetchTeamAvailabilityPending */
/* unused harmony export fetchTeamAvailabilityFailed */
/* unused harmony export createTeamAvailabilitySucceeded */
/* unused harmony export createTeamAvailabilityPending */
/* unused harmony export createTeamAvailabilityFailed */
/* unused harmony export updateTeamAvailabilitySucceeded */
/* unused harmony export updateTeamAvailabilityPending */
/* unused harmony export updateTeamAvailabilityFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return teamMembers; });
/* unused harmony export teamOwners */
/* unused harmony export teamOwner */
/* unused harmony export onlineTeamMembers */
/* unused harmony export offlineTeamMembers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return teamsWithMemberAvailability; });
/* unused harmony export makeDefaultAvailabilityForTeam */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__ = __webpack_require__("8Eel");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("rEEY");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var teams = function teams(state) {
  return state.getIn(['teams', 'data']) || [];
};

var teamAvailabilities = function teamAvailabilities(state) {
  return state.getIn(['teams', 'teamAvailabilities']) || [];
};
var teamsOptions = function teamsOptions(state) {
  return teams(state).map(function (team) {
    return {
      label: team.name,
      value: team
    };
  });
};
var teamsStatus = function teamsStatus(state) {
  return state.getIn(['teams', 'status']);
};

var makeTeamSelector = function makeTeamSelector() {
  return Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([function (state, props) {
    return props.teamId;
  }, teams], function (teamId, teams) {
    return teams.find(function (team) {
      return team.id === teamId;
    });
  });
};

var fetchTeamsSuccess = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetch']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["p" /* FETCH_ORG_TEAMS_SUCCESS */];
});

var teamsForUser = function teamsForUser(userId) {
  return function (state) {
    return state.getIn(['currentUser', 'orgUsers', userId, 'teams']) || [];
  };
};

var fetchTeamsPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetch']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["o" /* FETCH_ORG_TEAMS_PENDING */];
});

var fetchTeamsFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetch']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["n" /* FETCH_ORG_TEAMS_FAILED */];
});

var createTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'create']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["b" /* CREATE_ORG_TEAM_FAILED */];
});

var createTeamSucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'create']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["d" /* CREATE_ORG_TEAM_SUCCESS */];
});

var patchTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'update']);
}, function (patchStatus) {
  return patchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["D" /* PATCH_ORG_TEAM_FAILED */];
});
var patchTeamPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'update']);
}, function (patchStatus) {
  return patchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["E" /* PATCH_ORG_TEAM_PENDING */];
});
var patchTeamSucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'update']);
}, function (patchStatus) {
  return patchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["F" /* PATCH_ORG_TEAM_SUCCESS */];
});

var deleteTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'delete']);
}, function (deleteStatus) {
  return deleteStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* DELETE_ORG_TEAM_FAILED */];
});
var deleteTeamSucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'delete']);
}, function (deleteStatus) {
  return deleteStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* DELETE_ORG_TEAM_SUCCESS */];
});

var updateAvailabilityForTeamSucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateAvailabilityForTeam']);
}, function (updateStatus) {
  return updateStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["J" /* UPDATE_AVAILABILITY_FOR_TEAM_SUCCESS */];
});
var updateAvailabilityForTeamPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateAvailabilityForTeam']);
}, function (updateStatus) {
  return updateStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["I" /* UPDATE_AVAILABILITY_FOR_TEAM_PENDING */];
});
var updateAvailabilityForTeamFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateAvailabilityForTeam']);
}, function (updateStatus) {
  return updateStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["H" /* UPDATE_AVAILABILITY_FOR_TEAM_FAILED */];
});

var fetchTeamAvailabilitiesSucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchAllAvailabilities']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["x" /* FETCH_TEAM_AVAILABILITIES_SUCCESS */];
});
var fetchTeamAvailabilitiesPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchAllAvailabilities']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["w" /* FETCH_TEAM_AVAILABILITIES_PENDING */];
});
var fetchTeamAvailabilitiesFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchAllAvailabilities']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["v" /* FETCH_TEAM_AVAILABILITIES_FAILED */];
});

var fetchTeamAvailabilitySucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchSingleAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["B" /* FETCH_TEAM_AVAILABILITY_SUCCESS */];
});
var fetchTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchSingleAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["A" /* FETCH_TEAM_AVAILABILITY_PENDING */];
});
var fetchTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'fetchSingleAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["z" /* FETCH_TEAM_AVAILABILITY_FAILED */];
});

var createTeamAvailabilitySucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'createTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* CREATE_TEAM_AVAILABILITY_SUCCESS */];
});
var createTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'createTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["g" /* CREATE_TEAM_AVAILABILITY_PENDING */];
});
var createTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'createTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["f" /* CREATE_TEAM_AVAILABILITY_FAILED */];
});

var updateTeamAvailabilitySucceeded = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["N" /* UPDATE_TEAM_AVAILABILITY_SUCCESS */];
});
var updateTeamAvailabilityPending = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["M" /* UPDATE_TEAM_AVAILABILITY_PENDING */];
});
var updateTeamAvailabilityFailed = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
  return state.getIn(['teams', 'status', 'updateTeamAvailability']);
}, function (teamFetchStatus) {
  return teamFetchStatus === __WEBPACK_IMPORTED_MODULE_6__constants__["L" /* UPDATE_TEAM_AVAILABILITY_FAILED */];
});

var teamMembers = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([function (state) {
  return state;
}, function (state, props) {
  return props.teamId;
}, makeTeamSelector, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["makeUserSelector"]], function (state, teamId, teamSelector, userSelector) {
  var foundTeam = teamSelector(state, { teamId: teamId });
  var memberIds = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(foundTeam, 'members', []);
  return memberIds.map(function (id) {
    return userSelector(state, { id: id }).toJS();
  });
});

var teamOwners = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([function (state) {
  return state;
}, teams, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["makeUserSelector"]], function (state, teams, userSelector) {
  return teams.map(function (_ref) {
    var id = _ref.id,
        owner = _ref.owner;
    return {
      id: id,
      owner: userSelector(state, { id: owner }).toJS()
    };
  });
});

var teamOwner = function teamOwner(teamId) {
  return function (state) {
    // this selector smells bad, toJS and not createSelector
    var userSelector = Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["makeUserSelector"])();
    var foundTeam = makeTeamSelector()(state, { teamId: teamId });
    return userSelector(state, { id: foundTeam.owner }).toJS();
  };
};

var onlineTeamMembers = function onlineTeamMembers(teamId) {
  return function (state) {
    var members = teamMembers(state, { teamId: teamId });
    return members.filter(function (member) {
      return member.availability !== 'OFFLINE';
    });
  };
};

var offlineTeamMembers = function offlineTeamMembers(teamId) {
  return function (state) {
    var members = teamMembers(state, { teamId: teamId });
    return members.filter(function (member) {
      return member.availability === 'OFFLINE';
    });
  };
};

var teamsWithMemberAvailability = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(teams, __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["awayUsers"], __WEBPACK_IMPORTED_MODULE_3_app_modules_user_selectors__["availableUsers"], function (teams, awayUsers, availableUsers) {
  return teams.map(function (team) {
    return _extends({}, team, {
      awayMembers: awayUsers.filter(function (user) {
        return team.members.includes(user.id);
      }),
      availableMembers: availableUsers.filter(function (user) {
        return team.members.includes(user.id);
      })
    });
  });
});

var makeDefaultAvailabilityForTeam = function makeDefaultAvailabilityForTeam(teamName) {
  return function (state) {
    var timezone = Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_embed_selectors__["s" /* orgTimezone */])(state);
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
      name: teamName + ' Availability',
      timezone: timezone,
      openHours: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["a" /* AvailabilitySlot */])({
        dayOfWeek: 'WEEKDAYS',
        startTime: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["b" /* AvailabilitySlotTime */])({
          hour: 9,
          minutes: 0
        }),
        endTime: Object(__WEBPACK_IMPORTED_MODULE_5_app_modules_meetings_models__["b" /* AvailabilitySlotTime */])({
          hour: 17,
          minutes: 0
        })
      })])
    });
  };
};

/***/ }),

/***/ "wIyv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getGradient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors__ = __webpack_require__("NpTE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styles_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_styles_colors__);


function getGradient(time) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!time) {
    return [__WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-navy'], __WEBPACK_IMPORTED_MODULE_0_styles_colors___default.a['color-navy-dark']]; // default
  }
  var hour = time.hour();
  if (5 <= hour && hour < 8) {
    return ['rgba(255, 241, 101, ' + opacity + ')', 'rgba(60, 185, 240, ' + opacity + ')']; // 5am to 8am
  } else if (8 <= hour && hour < 19) {
    return ['rgba(169, 252, 224, ' + opacity + ')', 'rgba(21, 122, 251, ' + opacity + ')']; // 8am to 7pm
  } else if (19 <= hour && hour < 21) {
    return ['rgba(184, 66, 166, ' + opacity + ')', 'rgba(255, 157, 119, ' + opacity + ')']; // 7pm to 9pm
  } else {
    return ['rgba(21, 122, 251, ' + opacity + ')', 'rgba(5, 53, 111, ' + opacity + ')']; // 9pm to 5am
  }
}

/***/ }),

/***/ "wKHa":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.818 12L.658 3.84A2.25 2.25 0 0 1 3.842.66L12 8.817l8.16-8.16a2.25 2.25 0 0 1 3.18 3.183L15.183 12l8.16 8.16a2.25 2.25 0 0 1-3.183 3.18L12 15.183l-8.16 8.16a2.25 2.25 0 0 1-3.18-3.183L8.817 12z\" fill=\"#000\" opacity=\".2\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "wL4R":
/***/ (function(module, exports) {

module.exports = "<svg width=\"26\" height=\"17\" viewBox=\"0 0 55 34\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.403 26.03A4.508 4.508 0 0 0 5 26.008a5 5 0 0 1-1.734-9.69c.54-.2 26.505-12.064 26.505-12.064 1.514-.69 2.932.08 3.182 1.718l3.596 23.573c.25 1.64-.848 2.677-2.452 2.323 0 0-6.97-1.55-14.115-3.057C18.96 31.83 16.175 34 12.9 34c-4.142 0-7.5-3.47-7.5-7.75 0-.073 0-.146.003-.22zm11.438 2.09L9 26.6s.002.54.005.607a4 4 0 0 0 7.836.914zM40.965 9.253l10-5.5A2 2 0 1 0 49.036.248l-10 5.5a2 2 0 1 0 1.928 3.504zm.987 17.17l10.5 3a2 2 0 1 0 1.1-3.845l-10.5-3a2 2 0 1 0-1.1 3.846zm-.098-8.078l10.5-1.875a2 2 0 0 0-.704-3.94l-10.5 1.876a2 2 0 0 0 .704 3.938z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "wLCu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__ = __webpack_require__("lU3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SegmentSelectHelper__ = __webpack_require__("iKCO");
/* eslint-disable
    import/no-duplicates,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.





var SegmentQueries = Marty.createQueries({
  id: 'SegmentQueries',

  tryPushNotificationOnSegmentCreation: function tryPushNotificationOnSegmentCreation(segment) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_2_utils_SegmentSelectHelper__["b" /* isSegmentHidden */])(segment)) {
      return this.app.actions.NotificationActions.pushNotification({
        content: 'You\'ve created a new segment: ' + segment.name,
        viewLinkTo: {
          pathname: '/contacts/segments/' + segment.id,
          target: '_self'
        }
      });
    }
  },
  createSegment: function createSegment(requestId, body, endUserIds) {
    var _this = this;

    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_STARTING, requestId, body, endUserIds);

    var promise = this.app.sources.SegmentAPI.createSegment(body);

    promise.then(function (res) {
      if (res.status === 200) {
        if (endUserIds) {
          var addEndUserIdsPromise = _this.app.queries.SegmentQueries.addEndUserIdsToStaticSegment(res.body.id, endUserIds, false);

          addEndUserIdsPromise.then(function () {
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_DONE, requestId, res.body);
            var segment = res.body;
            return _this.tryPushNotificationOnSegmentCreation(segment);
          });

          return addEndUserIdsPromise.catch(function (error) {
            Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
            return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED, requestId, body, endUserIds, error);
          });
        } else {
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_DONE, requestId, res.body);
          return _this.tryPushNotificationOnSegmentCreation(res.body);
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED, requestId, body, endUserIds, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_CREATE_FAILED, body, endUserIds, error);
    });
  },
  addEndUserIdsToStaticSegment: function addEndUserIdsToStaticSegment(segmentId, endUserIds, notify) {
    var _this2 = this;

    if (notify == null) {
      notify = true;
    }
    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ADD_MEMBERS, segmentId, endUserIds);

    var promise = this.app.sources.SegmentAPI.addEndUserIdsToStaticSegment(segmentId, endUserIds);
    promise.then(function (res) {
      if (res.status === 200) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ADD_MEMBERS_DONE, segmentId);
        if (notify) {
          return _this2.app.actions.NotificationActions.pushNotification({
            content: 'Successfully added ' + endUserIds.length + ' users to segment',
            viewLinkTo: {
              pathname: '/contacts/segments/' + segmentId,
              target: '_self'
            }
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ADD_MEMBERS_FAILED, segmentId, endUserIds, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ADD_MEMBERS_FAILED, segmentId, endUserIds, error);
    });
  },
  deleteEndUserIdsFromStaticSegment: function deleteEndUserIdsFromStaticSegment(segmentId, endUserIds, notify) {
    var _this3 = this;

    if (notify == null) {
      notify = true;
    }
    this.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_DELETE_MEMBERS_STARTING, segmentId, endUserIds);

    var promise = this.app.sources.SegmentAPI.deleteEndUserIdsFromStaticSegment(segmentId, endUserIds);
    promise.then(function (res) {
      if (res.status === 200) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_DELETE_MEMBERS_DONE, segmentId);
        if (notify) {
          return _this3.app.actions.NotificationActions.pushNotification({
            content: 'Successfully removed ' + endUserIds.length + ' users from segment',
            viewLinkTo: {
              pathname: '/contacts/segments/' + segmentId,
              target: '_self'
            }
          });
        }
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_DELETE_MEMBERS_FAILED, segmentId, endUserIds, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this3.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_DELETE_MEMBERS_FAILED, segmentId, endUserIds, error);
    });
  },
  elasticSearchMembersOfSegment: function elasticSearchMembersOfSegment(segmentId, from, size) {
    var _this4 = this;

    var promise = this.app.sources.SegmentAPI.elasticSearchMembersOfSegment(segmentId, from, size);

    promise.then(function (res) {
      if (res.status === 200) {
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ELASTIC_SEARCH_MEMBERS_DONE, segmentId, from, size, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ELASTIC_SEARCH_MEMBERS_FAILED, segmentId, from, size, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this4.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_ELASTIC_SEARCH_MEMBERS_FAILED, segmentId, from, size, error);
    });
  },
  fetchSegments: function fetchSegments() {
    var _this5 = this;

    var promise = this.app.sources.SegmentAPI.fetchSegments();

    promise.then(function (res) {
      if (res.status === 200) {
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENTS_FETCH_DONE, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENTS_FETCH_FAILED, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this5.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENTS_FETCH_FAILED, error);
    });
  },
  fetchSegment: function fetchSegment(segmentId) {
    var _this6 = this;

    var promise = this.app.sources.SegmentAPI.fetchSegment(segmentId);
    promise.then(function (res) {
      // res.members = result[1]

      if (res.status === 200) {
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_FETCH_DONE, segmentId, res.body);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_FETCH_FAILED, segmentId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this6.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].SEGMENT_FETCH_FAILED, segmentId, error);
    });
  },
  deleteSegment: function deleteSegment(segmentId) {
    var _this7 = this;

    var promise = this.app.sources.SegmentAPI.updateSegment(segmentId, { status: 'ARCHIVED' });
    promise.then(function (res) {
      if (res.status === 200) {
        _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].DELETE_SEGMENT_DONE, segmentId, res.body);
        return _this7.app.actions.NotificationActions.pushNotification({
          content: 'Segment Deleted!',
          variant: 'red'
        });
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["c" /* captureResponseException */])(res);
        return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].DELETE_SEGMENT_FAILED, segmentId, res);
      }
    });

    return promise.catch(function (error) {
      Object(__WEBPACK_IMPORTED_MODULE_1_utils_SentryHelpers__["a" /* captureException */])(error);
      return _this7.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].DELETE_SEGMENT_FAILED, segmentId, error);
    });
  },
  getCampaignsForSegment: function getCampaignsForSegment(segmentId) {
    var _this8 = this;

    var promise = this.app.sources.CampaignAPI.getCampaignsForSegment(segmentId);
    return promise.then(function (res) {
      if (res.status === 200) {
        return _this8.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_SegmentConstants__["a" /* default */].GET_CAMPAIGNS_FOR_SEGMENT_DONE, segmentId, res.body);
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (SegmentQueries);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "wP5d":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.303655 1.2475665C5.978463.919727 5.451508.9171673 5.123189 1.2418322L1.4561 4.8681077c-.330229.3265533-.334962.860765-.010571 1.1931952.324391.3324302.855065.3371943 1.185293.010641L5.71752 3.0339626l2.996909 3.0322471c.327083.3297463.857778.3301378 1.18534.0008746.327563-.3292633.327952-.8634961.000869-1.1932424L6.303655 1.2475665z\" stroke=\"#B5D2E1\" stroke-width=\"2\" fill=\"#B5D2E1\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "wT/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_customer_EndUserAttributesCard__ = __webpack_require__("OnKl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_customer_TimeLine__ = __webpack_require__("OyGa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_customer_Inputs__ = __webpack_require__("1KjB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_nav_Header__ = __webpack_require__("fvhw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_nav_Header_HeaderBackButton__ = __webpack_require__("8zkG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_customer_TitleCard__ = __webpack_require__("ODkj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_customer_SegmentsCard__ = __webpack_require__("Joq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_components_customer_CustomerInfo_styl__ = __webpack_require__("REqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styles_components_customer_CustomerInfo_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_styles_components_customer_CustomerInfo_styl__);












var EndUserInfo = React.createClass({
  displayName: 'EndUserInfo',

  renderLeftNav: function renderLeftNav() {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_5_components_nav_Header_HeaderBackButton__["a" /* default */], {
      target: '_self',
      text: 'All Contacts',
      to: '/contacts'
    });
  },
  render: function render() {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_4_components_nav_Header__["a" /* default */],
      { title: 'All Contacts', leftNav: this.renderLeftNav(), showClose: true },
      React.createElement(
        'div',
        { className: 'Page' },
        React.createElement(
          'div',
          { className: 'CustomerInfo EndUserInfo' },
          React.createElement(
            'div',
            { className: 'left-section' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_6_components_customer_TitleCard__["a" /* default */], { endUser: this.props.endUser, showTooltip: true }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_1_components_customer_EndUserAttributesCard__["a" /* default */], { endUser: this.props.endUser }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_components_customer_SegmentsCard__["a" /* default */], { endUserId: this.props.endUser.id })
          ),
          React.createElement(
            'div',
            { className: 'right-section flex-column' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_3_components_customer_Inputs__["a" /* default */], { endUser: this.props.endUser }),
            React.createElement(
              'div',
              { className: 'profile-content-wrapper' },
              React.createElement(__WEBPACK_IMPORTED_MODULE_2_components_customer_TimeLine__["a" /* default */], { endUser: this.props.endUser })
            )
          )
        )
      )
    );
  }
});

var Wrapper = Object(__WEBPACK_IMPORTED_MODULE_0_components_container__["a" /* makeDefaultFailedContainer */])(EndUserInfo, {
  listenTo: ['stores.EndUserStore'],

  getEndUserId: function getEndUserId() {
    return this.props.endUserId || this.props.params.endUserId;
  },


  fetch: {
    endUser: function endUser() {
      return this.app.stores.EndUserStore.getOrFetchEndUser(this.getEndUserId());
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Wrapper);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "wV7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_DetectOS__ = __webpack_require__("YacT");


function makeCmdEnterHandler(callback) {
  return function (event) {
    if (event.key === 'Enter' && (Object(__WEBPACK_IMPORTED_MODULE_0_utils_DetectOS__["b" /* getOS */])() === __WEBPACK_IMPORTED_MODULE_0_utils_DetectOS__["a" /* OS */].MAC && event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      callback();
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (makeCmdEnterHandler);

/***/ }),

/***/ "wWX/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wWXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__ = __webpack_require__("Or1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_queries_EmbedQueries__ = __webpack_require__("ISL8");
/* eslint-disable
    import/default,
    import/namespace,
    import/no-duplicates,
    import/no-named-as-default,
    import/no-named-as-default-member,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var EmbedStore = Marty.createStore({
  id: 'EmbedStore',

  getInitialState: function getInitialState() {
    return {
      embedsById: {},
      lastCreatedEmbedId: undefined
    };
  },


  handlers: {
    fetchEmbedListDone: __WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_FETCH_DONE,
    createEmbedDone: __WEBPACK_IMPORTED_MODULE_0_constants_EmbedConstants__["a" /* default */].EMBED_CREATE_DONE
  },

  // Inbox List Handlers
  getOrFetchEmbedList: function getOrFetchEmbedList() {
    return this.fetch({
      id: 'fetchEmbedList',
      locally: function locally() {
        if (this.hasAlreadyFetched('fetchEmbedList')) {
          return this.state.embedsById;
        }
      },
      remotely: function remotely() {
        return this.app.queries.EmbedQueries.fetchEmbedList();
      }
    });
  },
  getLastCreatedEmbed: function getLastCreatedEmbed() {
    return this.state.embedsById[this.state.lastCreatedEmbedId];
  },
  fetchEmbedListDone: function fetchEmbedListDone(embeds) {
    var embedsById = _.keyBy(embeds, 'id');
    return this.setState({ embedsById: embedsById });
  },
  createEmbedDone: function createEmbedDone(inboxId, embed) {
    var embedsById = _.cloneDeep(this.state.embedsById) || {};
    embedsById[embed.id] = embed;
    return this.setState({ embedsById: embedsById, lastCreatedEmbedId: embed.id });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EmbedStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "wWmM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("XUxq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("+xIN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "waKz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Locales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALE_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum__ = __webpack_require__("rAp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_enum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_enum__);


var Locales = new __WEBPACK_IMPORTED_MODULE_0_enum___default.a({
  zh: "Chinese, Simplified (ZH_HANS)",
  hr: "Croatian (HR)",
  da: "Danish (DK)",
  nl: "Dutch (NL)",
  en: "English (EN)",
  et: "Estonian (ET)",
  fi: "Finnish (FI)",
  fr: "French (FR)",
  ka: "Georgian (KA)",
  de: "German (DE)",
  "de-DE-formal": "German (DE-formal)",
  hi: "Hindi (HI)",
  hu: "Hungarian (HU)",
  is: "Icelandic (IS)",
  it: "Italian (IT)",
  ja: "Japanese (JA)",
  ko: "Korean (KR)",
  nb: "Norwegian (NO)",
  pl: "Polish (PL)",
  pt: "Portuguese (PT)",
  "pt-BR": "Portuguese (BR)",
  ro: "Romanian (RO)",
  ru: "Russian (RU)",
  sr: "Serbian (SP)",
  sl: "Slovene (SI)",
  es: "Spanish (ES)",
  sv: "Swedish (SV)",
  th: "Thai (TH)",
  tr: "Turkish (TR)",
  vi: "Vietnamese (VN)"
});

var LOCALE_OPTIONS = _.map(Locales.enums, function (locale) {
  return {
    label: locale.value,
    value: locale.key
  };
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "waWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__ = __webpack_require__("mMZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_bolt_svg__ = __webpack_require__("Adja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_bolt_svg__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var UPGRADE_HEADER = 'You’re on the Free plan which includes basic live chat and Drift meetings.';

var StatusPopOver = function (_Component) {
  _inherits(StatusPopOver, _Component);

  function StatusPopOver() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StatusPopOver);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StatusPopOver.__proto__ || Object.getPrototypeOf(StatusPopOver)).call.apply(_ref, [this].concat(args))), _this), _this.navigateToBilling = function () {
      Object(__WEBPACK_IMPORTED_MODULE_3_app_modules_tracking_actions__["track"])('Upgrade CTA Clicked');
      window.location.replace('/settings/billing');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StatusPopOver, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'upgrade-pop-over' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'upgrade-message' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'Your plan'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            UPGRADE_HEADER
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
            { onClick: this.navigateToBilling, className: 'upgrade-button-cta' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_icons_bolt_svg___default.a, className: 'upgrade-icon' }),
            'Get more Drift'
          )
        )
      );
    }
  }]);

  return StatusPopOver;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_react_onclickoutside_decorator___default()(StatusPopOver));

/***/ }),

/***/ "wfBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wfRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("An2l");











var mapStateToProps = function mapStateToProps(state) {
  return {
    hasMeetings: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["l" /* hasMeetings */])(state),
    isVidyardEnabled: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_org_selectors__["getIsVidyardEnabled"])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      showTokenModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_240" /* showTokenModal */],
      showCalendarLinkModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_226" /* showCalendarLinkModal */],
      showCtaButtonModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_228" /* showCtaButtonModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('editorLibLoaded', 'setEditorLibLoaded', !!window.tinymce), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["j" /* withState */])('vidyardModalOpen', 'setVidyardModalOpen', false), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    if (!this.props.editorLibLoaded && !document.getElementById('tinyEditorInjection')) {
      var tinyScript = document.createElement('script');
      tinyScript.setAttribute('id', 'tinyEditorInjection');
      tinyScript.setAttribute('src', __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_2" /* TINY_EDITOR_SCRIPT_URL */]);
      tinyScript.setAttribute('referrerpolicy', 'origin');
      document.body.appendChild(tinyScript);
    }
    this.props.setEditorLibLoaded(!!window.tinymce);
  },
  componentWillReceiveProps: function componentWillReceiveProps() {
    var _props = this.props,
        editorLibLoaded = _props.editorLibLoaded,
        setEditorLibLoaded = _props.setEditorLibLoaded;

    if (!editorLibLoaded) {
      setTimeout(function () {
        setEditorLibLoaded(!!window.tinymce);
      }, 100);
    }
  }
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function () {
  return !window.tinymce;
}, __WEBPACK_IMPORTED_MODULE_2_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  showTokenPicker: function showTokenPicker(props) {
    return function () {
      props.actions.showTokenModal();
    };
  },
  showCalendarLinkPicker: function showCalendarLinkPicker(props) {
    return function () {
      props.actions.showCalendarLinkModal();
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "wgR7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"color-input":"color-input---Skwic"};

/***/ }),

/***/ "wjrm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl__ = __webpack_require__("udYA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var getHoverText = function getHoverText() {
  var wordsOfEncouragement = ['You’re almost there ⚡️', 'You got this 💪', 'Keep going 🚀', 'Doing great so far 👏', 'Getting closer 💫', 'Keep it up 🎉'];

  return wordsOfEncouragement[Math.floor(Math.random() * wordsOfEncouragement.length)];
};

var Onboarding = function (_Component) {
  _inherits(Onboarding, _Component);

  function Onboarding(props) {
    _classCallCheck(this, Onboarding);

    var _this = _possibleConstructorReturn(this, (Onboarding.__proto__ || Object.getPrototypeOf(Onboarding)).call(this, props));

    _this.state = {
      showTooltip: false,
      hoverText: getHoverText()
    };
    return _this;
  }

  _createClass(Onboarding, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["isEmpty"])(nextProps.orgProperties)) {
        this.setState({ showTooltip: !nextProps.orgProperties.has_seen_nav_onboarding_tooltip });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var orgProperties = this.props.orgProperties;
      var widgetInstalled = orgProperties.widgetInstalled;

      var onboardingCompleted = orgProperties.welcome_org_checklist_completed;
      var hoverText = this.state.hoverText;


      var onboardingProperties = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["pickBy"])(function (value, key) {
        return (/^welcome.*completed$/.test(key)
        );
      }, orgProperties);
      var values = Object.values(onboardingProperties);
      var amtCompleted = values.filter(Boolean).length;
      var percentComplete = amtCompleted / values.length * 100 || 0;

      var progressBarStyle = {
        width: percentComplete + '%' // Always show a little nub of progress
      };

      var tooltipProgressBar = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { className: 'nav-onboarding-tooltip-progressbar-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"], { style: progressBarStyle })
      );

      var tooltipContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { className: 'nav-onboarding-tooltip-content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["H5"],
          { className: 'nav-onboarding-tooltip-title' },
          'Continue setup'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["H5"],
          { className: 'nav-onboarding-tooltip-title' },
          percentComplete.toFixed(),
          '% complete'
        ),
        tooltipProgressBar,
        hoverText
      );

      if (__WEBPACK_IMPORTED_MODULE_2_utils_Access__["c" /* default */].hasGates('has_onboarding_experience')) {
        // If widget is installed but onboarding hasn't ever been visited, hide.
        if (widgetInstalled && Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["isNil"])(onboardingCompleted) || onboardingCompleted) {
          return null;
        }
      } else {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
        { className: 'nav-help-wrapper nav-status-item nav-status-item-onboarding' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
          { flow: 'right', render: function render() {
              return tooltipContent;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'nav-onboarding-link', href: __WEBPACK_IMPORTED_MODULE_4_constants_ResourcesConstants__["c" /* APP_URL */] + '/welcome' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
              { className: 'nav-onboarding-progressbar-container' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"], { style: progressBarStyle })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Div"],
              { className: 'nav-onboarding-percent-completed' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Span"],
                { className: 'nav-onboarding-percent-completed-number' },
                percentComplete.toFixed()
              ),
              '%'
            )
          )
        )
      );
    }
  }]);

  return Onboarding;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Onboarding);

/***/ }),

/***/ "wjvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectButton__ = __webpack_require__("sCN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__ = __webpack_require__("UKWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DisconnectConfirmModal__ = __webpack_require__("T45g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__("mKgd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var SUCCESS_MESSAGE = 'MadKudu was successfully connected!';
var ERROR_MESSAGE = 'Oops, there was an error. Please try again.';

var MadKudu = function (_Component) {
  _inherits(MadKudu, _Component);

  function MadKudu(props) {
    _classCallCheck(this, MadKudu);

    var _this = _possibleConstructorReturn(this, (MadKudu.__proto__ || Object.getPrototypeOf(MadKudu)).call(this, props));

    _this.onApiKeyChanged = function (event) {
      _this.setState({ apiKey: event.target.value });
    };

    _this.isApiKeyValid = function () {
      return _this.state.apiKey !== '';
    };

    _this.isConnectButtonDisabled = function () {
      return !_this.isApiKeyValid();
    };

    _this.connectIntegration = function () {
      var notifications = _this.props.notifications;
      var IntegrationsQueries = _this.context.app.queries.IntegrationsQueries;


      var connect = function connect() {
        Object(__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_api__["R" /* saveMadKuduApiKey */])(_this.state.apiKey).then(function () {
          return notifications.success(SUCCESS_MESSAGE);
        }).catch(function () {
          return notifications.error(ERROR_MESSAGE);
        }).then(function () {
          return _this.setState({ isConnecting: false, isConnected: true });
        }).then(function () {
          return IntegrationsQueries.fetchIntegrationStates();
        });
      };

      _this.setState({ isConnecting: true }, connect);
    };

    _this.state = {
      apiKey: '',
      isConnecting: false,
      isConnected: props.isConnected
    };
    return _this;
  }

  _createClass(MadKudu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ isConnected: props.isConnected });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isConnecting = _state.isConnecting,
          isConnected = _state.isConnected,
          showDisconnectModal = _state.showDisconnectModal;


      return React.createElement(
        'div',
        { className: 'madkudu-integration-page' },
        React.createElement(
          'p',
          { className: 'integration-page-description' },
          'Want to one-up your lead scoring in Drift? The MadKudu integration will use their standard model to score your leads so you can proactively target your best leads and know more about who you are talking to.'
        ),
        React.createElement(
          'p',
          { className: 'integration-page-description' },
          'If you are already a MadKudu customer, you can put in your API key and we will apply your MadKudu model for lead scoring, which will appear on the contact in the conversation view!',
          React.createElement(
            'a',
            { href: 'https://gethelp.drift.com/hc/en-us/articles/360019504334-How-to-Set-Up-the-MadKudu-Integration', target: '_blank' },
            'Learn more'
          )
        ),
        React.createElement(
          'div',
          { className: 'drift-form' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
            { condition: !isConnected },
            React.createElement(
              'span',
              { className: 'madkudu-key-label' },
              'API key'
            ),
            React.createElement('input', {
              className: 'madkudu-key-input',
              type: 'text',
              placeholder: 'e.g. 123456',
              onChange: this.onApiKeyChanged
            }),
            React.createElement(
              'p',
              { className: 'madkudu-key-description' },
              'Use your MadKudu API Key to connect MadKudu and Drift'
            )
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
          { condition: showDisconnectModal },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5__components_DisconnectConfirmModal__["a" /* default */], {
            integrationName: 'MadKudu',
            onDisconnect: this.disconnectIntegration,
            onClose: this.hideDisconnectModal })
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_4_components_shared_ConditionalRender__["a" /* default */],
          { condition: !isConnected },
          React.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ConnectButton__["a" /* default */], {
            disabled: this.isConnectButtonDisabled(),
            onClick: this.connectIntegration,
            isProcessing: isConnecting
          })
        )
      );
    }
  }]);

  return MadKudu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MadKudu.contextTypes = {
  app: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_components_shared_notifications__["a" /* default */])(MadKudu));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "wkqp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_constants__ = __webpack_require__("+ecq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("gHk3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);







var SALESFORCE_ACCOUNT_PAGE = "/settings/setup/salesforce";

var getErrorCopy = function getErrorCopy(error) {
  if (__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_constants__["L" /* LeanDataAuthStatuses */].SALESFORCE_AUTHENTICATION_ISSUE === error) {
    return React.createElement(
      'p',
      null,
      'Please ',
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
        { to: SALESFORCE_ACCOUNT_PAGE },
        'connect your Salesforce account '
      ),
      'and test the connection again.'
    );
  }
  if (__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_constants__["L" /* LeanDataAuthStatuses */].LEANDATA_ORGANIZATION_PERMISSIONS === error) {
    return React.createElement(
      'p',
      null,
      'It appears that your Salesforce account doesn\u2019t have access to LeanData.',
      React.createElement('br', null),
      'We recommend contacting your LeanData customer success manager.',
      React.createElement('br', null),
      React.createElement('br', null),
      'Once access has been granted, test your connection again.'
    );
  }
  if (__WEBPACK_IMPORTED_MODULE_2_app_modules_integrations_constants__["L" /* LeanDataAuthStatuses */].LEANDATA_USER_PERMISSIONS === error) {
    return React.createElement(
      'p',
      null,
      'The Salesforce account used to connect with Drift doesn\u2019t have access to LeanData. Please connect to Salesforce with a different account.',
      React.createElement('br', null),
      React.createElement('br', null),
      'Then, test your connection again.'
    );
  }
};

var LeanDataError = function LeanDataError(_ref) {
  var error = _ref.error,
      testConnection = _ref.testConnection;
  return React.createElement(
    'div',
    null,
    React.createElement(
      __WEBPACK_IMPORTED_MODULE_0__driftt_tide_core_legacy__["InlineWarning"],
      {
        title: 'Drift is unable to connect with LeanData',
        type: 'warning'
      },
      getErrorCopy(error)
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (LeanDataError);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "wpQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CardMeta */
/* unused harmony export Card */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CardAndStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CardState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return makeCard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);


var PRIMARY_RELS = ['player', 'thumbnail', 'app', 'image', 'reader', 'survey', 'summary', 'icon', 'logo'];

var getPrimaryRel = function getPrimaryRel(card) {
  return card.rel.filter(function (rel) {
    return PRIMARY_RELS.indexOf(rel) !== -1;
  }).first();
};

var getPreferreredIcon = function getPreferreredIcon(card) {
  return card.links.get('icon', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).filter(function (icon) {
    return icon.getIn(['media', 'width'], 0) >= 16;
  }).sortBy(function (icon) {
    return icon.getIn(['media', 'width'], 0);
  }).first();
};

var CardMeta = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  title: undefined,
  description: undefined,
  author_url: undefined,
  author: undefined,
  site: undefined,
  keywords: undefined,
  canonical: undefined
});

var Card = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  url: undefined,
  meta: new CardMeta(),
  links: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  rel: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  html: undefined,
  icon: undefined,
  primaryRel: undefined
});

var CardAndStatus = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  href: undefined,
  card: new Card(),
  status: 'pending'
});

var CardState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  hrefsByMessageId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),
  cardsByHref: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

var makeCard = function makeCard(data) {
  var card = new Card({
    url: data.url,
    meta: new CardMeta(data.meta),
    links: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(data.links),
    rel: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(data.rel),
    html: data.html
  });

  return card.set('primaryRel', getPrimaryRel(card)).set('icon', getPreferreredIcon(card));
};

/***/ }),

/***/ "wqO5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(228);

/***/ }),

/***/ "wrQY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wrj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SliderMessageBuilder__ = __webpack_require__("/giV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SliderMessageBuilder__["a"]; });


/***/ }),

/***/ "wrqW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__ = __webpack_require__("/POY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep__);
/* eslint-disable
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



var OrgPropertiesStore = Marty.createStore({
  id: 'OrgPropertiesStore',

  getInitialState: function getInitialState() {
    return {
      settingsByOrgId: {},
      // org logos grouped by ID
      orgLogoUploadsById: {},
      orgLogoUploadsStateById: {},

      // generic org images grouped by a string key
      orgImageUploadsByType: {},
      orgImageUploadsStateByType: {}
    };
  },


  handlers: {
    fetchSettingsDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].FETCH_ORG_PROPERTIES_DONE,
    updateSettingsDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPDATE_ORG_PROPERTIES_DONE,
    uploadOrgLogo: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_STARTING,
    uploadOrgLogoDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_DONE,
    uploadOrgImage: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_STARTING,
    uploadOrgImageDone: __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_DONE
  },

  setSettingForOrgId: function setSettingForOrgId(orgId, settings) {
    var settingsByOrgId = _.cloneDeep(this.state.settingsByOrgId);
    settingsByOrgId[orgId] = settings;
    return this.setState({ settingsByOrgId: settingsByOrgId });
  },
  fetchSettingsDone: function fetchSettingsDone(orgId, settings) {
    return this.setSettingForOrgId(orgId, settings);
  },
  updateSettingsDone: function updateSettingsDone(orgId, settings) {
    return this.setSettingForOrgId(orgId, settings);
  },
  fetchPropertiesForOrg: function fetchPropertiesForOrg(orgId) {
    return this.fetch({
      id: 'fetchPropertiesForOrg' + orgId,
      locally: function locally() {
        return this.state.settingsByOrgId[orgId];
      },
      remotely: function remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(orgId);
      }
    });
  },
  refetchPropertiesForCurrentOrg: function refetchPropertiesForCurrentOrg() {
    return this.fetch({
      id: 'refetchPropertiesForCurrentOrg',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        return null;
      },
      remotely: function remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(__guard__(this.app.stores.OrgStore.getCurrentOrg(), function (x) {
          return x.id;
        }));
      }
    });
  },
  fetchPropertiesForCurrentOrg: function fetchPropertiesForCurrentOrg() {
    return this.fetch({
      id: 'fetchPropertiesForCurrentOrg',
      dependsOn: this.app.stores.OrgStore.getOrFetchCurrentOrg(),
      locally: function locally() {
        return this.state.settingsByOrgId[__guard__(this.app.stores.OrgStore.getCurrentOrg(), function (x) {
          return x.id;
        })];
      },
      remotely: function remotely() {
        return this.app.queries.OrgPropertiesQueries.fetchProperties(__guard__(this.app.stores.OrgStore.getCurrentOrg(), function (x) {
          return x.id;
        }));
      }
    });
  },
  getOrgLogoUploadsStateById: function getOrgLogoUploadsStateById() {
    return this.state.orgLogoUploadsStateById;
  },
  getOrgLogoUploadsById: function getOrgLogoUploadsById() {
    return this.state.orgLogoUploadsById;
  },
  getOrgImageUploadsByType: function getOrgImageUploadsByType() {
    return this.state.orgImageUploadsByType;
  },
  getOrgImageUploadsStateByType: function getOrgImageUploadsStateByType() {
    return this.state.orgImageUploadsStateByType;
  },


  // TODO: treat orgLogo as just another OrgImage
  uploadOrgLogo: function uploadOrgLogo(orgId, file, fileId) {
    if (fileId != null) {
      var uploadsById = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(this.state.orgLogoUploadsById);
      uploadsById[fileId] = null;
      var uploadsStateById = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(this.state.orgLogoUploadsStateById);
      uploadsStateById[fileId] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_STARTING;
      return this.setState({ orgLogoUploadsById: uploadsById, orgLogoUploadsStateById: uploadsStateById });
    }
  },
  uploadOrgLogoDone: function uploadOrgLogoDone(orgId, url, fileId) {
    if (fileId != null) {
      var uploadsById = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(this.state.orgLogoUploadsById);
      uploadsById[fileId] = url;
      var uploadsStateById = __WEBPACK_IMPORTED_MODULE_1_lodash_cloneDeep___default()(this.state.orgLogoUploadsStateById);
      uploadsStateById[fileId] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_LOGO_DONE;
      return this.setState({ orgLogoUploadsById: uploadsById, orgLogoUploadsStateById: uploadsStateById });
    }
  },
  uploadOrgImage: function uploadOrgImage(orgId, file, imageType) {
    if (typeof fileId !== 'undefined' && fileId !== null) {
      var orgImageUploadsByType = _.cloneDeep(this.state.orgImageUploadsByType);
      orgImageUploadsByType[imageType] = null;
      var orgImageUploadsStateByType = _.cloneDeep(this.state.orgImageUploadsStateByType);
      orgImageUploadsStateByType[imageType] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_STARTING;
      return this.setState({ orgImageUploadsByType: orgImageUploadsByType, orgImageUploadsStateByType: orgImageUploadsStateByType });
    }
  },
  uploadOrgImageDone: function uploadOrgImageDone(orgId, imageUrl, imageType) {
    var orgImageUploadsByType = _.cloneDeep(this.state.orgImageUploadsByType);
    orgImageUploadsByType[imageType] = imageUrl;
    var orgImageUploadsStateByType = _.cloneDeep(this.state.orgImageUploadsStateByType);
    orgImageUploadsStateByType[imageType] = __WEBPACK_IMPORTED_MODULE_0_constants_OrgPropertiesConstants__["a" /* default */].UPLOAD_ORG_IMAGE_DONE;
    return this.setState({ orgImageUploadsByType: orgImageUploadsByType, orgImageUploadsStateByType: orgImageUploadsStateByType });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (OrgPropertiesStore);

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj"), __webpack_require__("M4fF")))

/***/ }),

/***/ "wvzT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_containers_app__ = __webpack_require__("AJef");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_api_TeamsAPI__ = __webpack_require__("cATl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__ = __webpack_require__("p9md");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__ = __webpack_require__("60ou");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TeamsActions = function (_Marty$ActionCreators) {
  _inherits(TeamsActions, _Marty$ActionCreators);

  function TeamsActions() {
    _classCallCheck(this, TeamsActions);

    return _possibleConstructorReturn(this, (TeamsActions.__proto__ || Object.getPrototypeOf(TeamsActions)).apply(this, arguments));
  }

  _createClass(TeamsActions, [{
    key: 'fetchTeamsForOrg',
    value: function fetchTeamsForOrg(orgId) {
      var _this2 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].FETCH_TEAMS_STARTED);
      return __WEBPACK_IMPORTED_MODULE_1_app_api_TeamsAPI__["a" /* default */].fetchTeamsForOrg(orgId).then(function (teams) {
        return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].FETCH_TEAMS_FINISHED, teams);
      }).catch(function (error) {
        _this2.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].FETCH_TEAMS_FAILED);
        Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
      });
    }
  }, {
    key: 'updateTeam',
    value: function updateTeam(teamId, properties, notification) {
      var _this3 = this;

      this.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].UPDATE_TEAM_STARTED);
      return __WEBPACK_IMPORTED_MODULE_1_app_api_TeamsAPI__["a" /* default */].updateTeam(teamId, properties).then(function (team) {
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].UPDATE_TEAM_FINISHED, teamId, team);

        if (!!notification) {
          __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({ content: notification });
        }
      }).catch(function (error) {
        Object(__WEBPACK_IMPORTED_MODULE_3_utils_SentryHelpers__["a" /* captureException */])(error);
        _this3.dispatch(__WEBPACK_IMPORTED_MODULE_2_constants_TeamsConstants__["e" /* default */].UPDATE_TEAM_FAILED);
        __WEBPACK_IMPORTED_MODULE_0_containers_app__["a" /* default */].actions.NotificationActions.pushNotification({
          content: error.message,
          variant: 'red',
          sticky: true
        });
      });
    }
  }]);

  return TeamsActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (TeamsActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "wwAV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus__ = __webpack_require__("kwbz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_humanize_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl__ = __webpack_require__("L9SV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_styl__);





var AudienceLabels = Object.freeze({
  SEGMENT: 'your segment(s)',
  VISITORS: 'anonymous visitors',
  USERS: 'known users',
  EVERYONE: 'everyone',
  NONE: 'nobody'
});

var FREQUENCY_COPY = {
  ONCE: React.createElement(
    'span',
    null,
    'it will be shown until people ',
    React.createElement(
      'strong',
      null,
      'open or dismiss it'
    ),
    '.'
  ),
  ONCE_PER_SESSION: React.createElement(
    'span',
    null,
    'it will be shown until someone opens or dismisses it. After',
    ' ',
    React.createElement(
      'strong',
      null,
      '30 minutes of visitor inactivity'
    ),
    ', it will be shown again.'
  ),
  ALWAYS: React.createElement(
    'span',
    null,
    'it will be shown ',
    React.createElement(
      'strong',
      null,
      'every time'
    ),
    ' the user visits the page.'
  )
};

var ReviewSummary = function ReviewSummary(_ref) {
  var audience = _ref.audience,
      playbookFrequency = _ref.playbookFrequency,
      numConditions = _ref.numConditions;

  if (!audience) {
    return React.createElement(
      'div',
      { className: 'playbook-targeting-advanced-frequency-info' },
      React.createElement(
        'p',
        null,
        'This playbook can only be shown by activating the #DriftLink.'
      )
    );
  }
  return React.createElement(
    'div',
    { className: 'playbook-targeting-advanced-frequency-info' },
    React.createElement(
      'p',
      null,
      'This playbook will be shown to ',
      React.createElement(
        'strong',
        null,
        AudienceLabels[audience]
      ),
      numConditions !== 0 && React.createElement(
        'span',
        null,
        ' ',
        'who meets',
        ' ',
        React.createElement(
          'strong',
          null,
          numConditions,
          ' targeting ',
          Object(__WEBPACK_IMPORTED_MODULE_0_humanize_plus__["pluralize"])(numConditions, 'condition')
        )
      ),
      ', and ',
      FREQUENCY_COPY[playbookFrequency]
    )
  );
};

var Review = function Review(_ref2) {
  var isOnce = _ref2.isOnce,
      isSession = _ref2.isSession,
      isAlways = _ref2.isAlways,
      handleSetFrequency = _ref2.handleSetFrequency,
      playbookFrequency = _ref2.playbookFrequency,
      audience = _ref2.audience,
      numConditions = _ref2.numConditions;
  return React.createElement(
    'div',
    { className: 'playbook-builder-targeting-advanced-wrapper' },
    React.createElement(
      'header',
      { className: 'playbook-title-header' },
      React.createElement(
        'h2',
        null,
        'Frequency'
      ),
      React.createElement(
        'p',
        null,
        'Need to fine tune the targeting behavior of your playbook? You can do that here.'
      )
    ),
    React.createElement(
      'div',
      { className: 'playbook-container playbook-targeting-advanced-toggle-summary' },
      React.createElement(
        'div',
        { className: 'playbook-targeting-advanced-label' },
        'How often should the audience see it? '
      ),
      React.createElement(
        'div',
        { className: 'playbook-targeting-advanced-frequency-wrapper drift-form' },
        React.createElement(
          'div',
          { className: 'playbook-targeting-advanced-frequency-options' },
          React.createElement(
            'div',
            { className: 'playbook-targeting-advanced-frequency-option' },
            React.createElement('input', {
              type: 'radio',
              onClick: handleSetFrequency,
              checked: isAlways,
              id: 'choiceAlways',
              name: 'playbookFrequency',
              value: __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].ALWAYS
            }),
            React.createElement(
              'label',
              { htmlFor: 'choiceAlways' },
              'On every page load'
            )
          ),
          React.createElement(
            'div',
            { className: 'playbook-targeting-advanced-frequency-option' },
            React.createElement('input', {
              type: 'radio',
              checked: isSession,
              id: 'choiceSession',
              onClick: handleSetFrequency,
              name: 'playbookFrequency',
              value: __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].SESSION
            }),
            React.createElement(
              'label',
              { htmlFor: 'choiceSession' },
              'Until they interact, once per session',
              ' '
            )
          ),
          React.createElement(
            'div',
            { className: 'playbook-targeting-advanced-frequency-option' },
            React.createElement('input', {
              type: 'radio',
              onClick: handleSetFrequency,
              checked: isOnce,
              id: 'choiceOnce',
              name: 'playbookFrequency',
              value: __WEBPACK_IMPORTED_MODULE_1_app_modules_playbook_constants__["_143" /* PlaybooksFrequency */].ONCE
            }),
            React.createElement(
              'label',
              { htmlFor: 'choiceOnce' },
              'Until they interact, then hide it'
            )
          ),
          React.createElement('hr', null),
          React.createElement(ReviewSummary, {
            numConditions: numConditions,
            playbookFrequency: playbookFrequency,
            audience: audience
          })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Review);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "wwd1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return client; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__splitsoftware_splitio__ = __webpack_require__("QJ2w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("kuIf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__("PnBG");









var client = void 0;

var receiveCurrentUser = function receiveCurrentUser(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_actions__["receiveCurrentUser"].toString()).pluck('payload').first(function (_ref) {
    var id = _ref.id,
        orgId = _ref.orgId;

    var logImpression = function logImpression(_ref2) {
      var _ref2$impression = _ref2.impression,
          feature = _ref2$impression.feature,
          treatment = _ref2$impression.treatment;

      analytics.track('Experiment Viewed', {
        experimentName: feature,
        variationName: treatment,
        source: 'split'
      });
    };

    var factory = Object(__WEBPACK_IMPORTED_MODULE_2__splitsoftware_splitio__["a" /* SplitFactory */])({
      core: {
        authorizationKey: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["_0" /* SPLIT_ID */],
        key: orgId,
        trafficType: 'organization'
      },
      impressionListener: {
        logImpression: logImpression
      }
    });

    client = factory.client();
    client.on(client.Event.SDK_READY, function () {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* setLoaded */]());
    });
    client.on(client.Event.SDK_READY_TIMED_OUT, function () {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* timedOut */]());
    });
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(receiveCurrentUser);

/***/ }),

/***/ "wxyM":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 126 143\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Simple-Text\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-888.000000, -419.000000)\"><g id=\"Group-4\" transform=\"translate(888.000000, 419.000000)\"><path d=\"M2,0 L124,0 C125.104569,-2.02906125e-16 126,0.8954305 126,2 L126,141 C126,142.104569 125.104569,143 124,143 L2,143 C0.8954305,143 1.3527075e-16,142.104569 0,141 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z\" id=\"Rectangle-7\" fill=\"#FFFFFF\"></path><path d=\"M2,1 C1.44771525,1 1,1.44771525 1,2 L1,141 C1,141.552285 1.44771525,142 2,142 L124,142 C124.552285,142 125,141.552285 125,141 L125,2 C125,1.44771525 124.552285,1 124,1 L2,1 Z M2,0 L124,0 C125.104569,0 126,0.8954305 126,2 L126,141 C126,142.104569 125.104569,143 124,143 L2,143 C0.8954305,143 0,142.104569 0,141 L0,2 C0,0.8954305 0.8954305,0 2,0 Z\" id=\"Rectangle-7\" fill=\"#B4D2E2\" fill-rule=\"nonzero\"></path><g id=\"Rectangle-7\"><use fill=\"#B3D2E3\" fill-rule=\"evenodd\" xlink:href=\"#path-1\"></use><path stroke=\"#B4D2E2\" stroke-width=\"1\" d=\"M0.5,41.5 L125.5,41.5 L125.5,2 C125.5,1.17157288 124.828427,0.5 124,0.5 L2,0.5 C1.17157288,0.5 0.5,1.17157288 0.5,2 L0.5,41.5 Z\"></path></g><path d=\"M8,60 L51,60 L51,64 L8,64 L8,60 Z M8,119 L34,119 L34,123 L8,123 L8,119 Z M8,76 L114,76 L114,80 L8,80 L8,76 Z M8,86 L105,86 L105,90 L8,90 L8,86 Z M8,96 L114,96 L114,100 L8,100 L8,96 Z M8,106 L105,106 L105,110 L8,110 L8,106 Z\" id=\"Combined-Shape\" fill=\"#B9D4E2\"></path></g></g></svg>"

/***/ }),

/***/ "wy6Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x/uU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CONVERSATION_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_FIRST_MESSAGES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_FIRST_MESSAGES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RECEIVE_FIRST_MESSAGES; });
/* unused harmony export FETCH_PAGINATED_CONVERRSATION_MESSAGES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return RECEIVE_PAGINATED_MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RECEIVE_NEXT_MESSAGE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_MESSAGE_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_MESSAGE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RECEIVE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return REMOVE_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MESSAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MESSAGE_READ_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MESSAGE_READ_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MESSAGE_READ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OPTIMISTIC_MESSAGE_READ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MARK_MESSAGE_READ_BY_CONVERSATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BULK_MESSAGE_READ_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MESSAGE_READ_UNTIL_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MESSAGE_READ_UNTIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return RECEIVE_MESSAGE_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NOTIFY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BROWSER_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SELECT_BOT_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_PLAYBOOK_CONTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LOAD_MORE_MESSAGES; });
/* unused harmony export CREATE_REFETCH_LISTENERS */
/* unused harmony export REFETCH_MESSAGES_COMPLETED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MessageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NotifiableMessageTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RECEIVE_BULK_UPDATE_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return TYPES_TO_PREVIEW; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('conversation/message');

var FETCH_CONVERSATION_MESSAGES = makeConstant('FETCH_CONVERSATION_MESSAGES');
var FETCH_FIRST_MESSAGES_PENDING = makeConstant('FETCH_FIRST_MESSAGES_PENDING');
var FETCH_FIRST_MESSAGES_FAILED = makeConstant('FETCH_FIRST_MESSAGES_FAILED');
var RECEIVE_FIRST_MESSAGES = makeConstant('RECEIVE_FIRST_MESSAGES');

var FETCH_PAGINATED_CONVERRSATION_MESSAGES = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES');
var FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_PENDING');
var FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_FAILED');
var FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED = makeConstant('FETCH_PAGINATED_CONVERRSATION_MESSAGES_CANCELLED');
var RECEIVE_PAGINATED_MESSAGE_LIST = makeConstant('RECEIVE_PAGINATED_MESSAGE_LIST');

var FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES');
var FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_PENDING');
var FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_FAILED');
var FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED = makeConstant('FETCH_NEXT_PAGINATED_CONVERSATION_MESSAGES_CANCELLED');
var RECEIVE_NEXT_MESSAGE_LIST = makeConstant('RECEIVE_NEXT_MESSAGE_LIST');

var CREATE_MESSAGE = makeConstant('CREATE_MESSAGE');
var CREATE_MESSAGE_PENDING = makeConstant('CREATE_MESSAGE_PENDING');
var CREATE_MESSAGE_FAILED = makeConstant('CREATE_MESSAGE_FAILED');
var RECEIVE_MESSAGE = makeConstant('RECEIVE_MESSAGE');

var REMOVE_MESSAGE = makeConstant('REMOVE_MESSAGE');

var MESSAGE_READ = makeConstant('MESSAGE_READ');
var MESSAGE_READ_PENDING = makeConstant('MESSAGE_READ_PENDING');
var MESSAGE_READ_FAILED = makeConstant('MESSAGE_READ_FAILED');
var MESSAGE_READ_SUCCESS = makeConstant('MESSAGE_READ_SUCCESS'); // dummy
var OPTIMISTIC_MESSAGE_READ_SUCCESS = makeConstant('OPTIMISTIC_MESSAGE_READ_SUCCESS');
var MARK_MESSAGE_READ_BY_CONVERSATION = makeConstant('MARK_MESSAGE_READ_BY_CONVERSATION');
var BULK_MESSAGE_READ_SUCCESS = makeConstant('BULK_MESSAGE_READ_SUCCESS');

var MESSAGE_READ_UNTIL_FAILED = makeConstant('MESSAGE_READ_UNTIL_FAILED');
var MESSAGE_READ_UNTIL_SUCCESS = makeConstant('MESSAGE_READ_UNTIL_SUCCESS');

var RECEIVE_MESSAGE_READ = makeConstant('RECEIVE_MESSAGE_READ');

var NOTIFY_USER = makeConstant('NOTIFY_USER');
var BROWSER_NOTIFICATION = makeConstant('BROWSER_NOTIFICATION');

var SELECT_BOT_ACTION = makeConstant('SELECT_BOT_ACTION');

var FETCH_PLAYBOOK_CONTEXT = makeConstant('FETCH_PLAYBOOK_CONTEXT');
var LOAD_MORE_MESSAGES = makeConstant('LOAD_MORE_MESSAGES');

var CREATE_REFETCH_LISTENERS = makeConstant('CREATE_REFETCH_LISTENERS');
var REFETCH_MESSAGES_COMPLETED = makeConstant('REFETCH_MESSAGES_COMPLETED');

var MessageStatus = Object.freeze({
  Sent: "Sent",
  Delivered: "Delivered",
  Read: "Read"
});

var NotifiableMessageTypes = Object.freeze({
  EMAIL: "EMAIL",
  CHAT: "CHAT"
});

var RECEIVE_BULK_UPDATE_MESSAGES = makeConstant('RECEIVE_BULK_UPDATE_MESSAGES');

var TYPES_TO_PREVIEW = ['EMAIL', 'SMS', 'CHAT', 'PHONE', 'TWITTER', 'PRIVATE_NOTE', 'PRIVATE_PROMPT'];

/***/ }),

/***/ "x1bR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EditableInfoCard__ = __webpack_require__("mura");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_utils_FormHelpers__ = __webpack_require__("eAP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Location__ = __webpack_require__("XB2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mixins_MakeInputChangeHandler__ = __webpack_require__("0HTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_web_src_helpers_CustomerHelpers__ = __webpack_require__("r0/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_web_src_helpers_CustomerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_web_src_helpers_CustomerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl__ = __webpack_require__("khqj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_styl__);

/* eslint-disable
    import/default,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.














var EndUserIdentity = React.createClass({
  displayName: 'EndUserIdentity',

  mixins: [__WEBPACK_IMPORTED_MODULE_7_mixins_MakeInputChangeHandler__["a" /* default */]],

  propTypes: {
    endUser: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    isEditMode: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  },

  getDataFromProps: function getDataFromProps(props) {
    if (props == null) {
      props = this.props;
    }return {
      name: Object(__WEBPACK_IMPORTED_MODULE_8_shared_web_src_helpers_CustomerHelpers__["getDisplayName"])(props.endUser),
      location: props.endUser.attributes.display_location
    };
  },
  getInitialState: function getInitialState() {
    return {
      data: this.getDataFromProps(),
      isEditMode: this.props.isEditMode,
      disableOnClickOutside: false
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    return this.setState({
      data: this.getDataFromProps(nextProps)
    });
  },
  createRenderEdit: function createRenderEdit(key, label, autoFocus, isValid) {
    var _this = this;

    if (isValid == null) {
      isValid = true;
    }
    return function () {
      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'edit-label' },
          label
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
          autoFocus: autoFocus,
          placeholder: label,
          isValid: isValid,
          valueLink: {
            value: _this.state.data[key],
            requestChange: _this.makeInputChangeHandler('data.' + key)
          } })
      );
    };
  },
  render: function render() {
    var _this2 = this;

    return React.createElement(
      'div',
      { className: 'EndUserIdentity' },
      React.createElement(__WEBPACK_IMPORTED_MODULE_4__EditableInfoCard__["a" /* default */], {
        isEditMode: this.state.isEditMode,
        canSave: this.hasValidName(),
        hasChanged: this.hasDataChanged(),
        save: this.save,
        reset: function reset() {
          return _this2.setState(_this2.getInitialState());
        },
        beforeDisplay: function beforeDisplay() {
          return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], { user: _this2.props.endUser, size: 'jumbo' });
        },
        beforeEdit: function beforeEdit() {
          return React.createElement(__WEBPACK_IMPORTED_MODULE_2_shared_web_src_components_Avatar__["a" /* default */], { user: _this2.props.endUser, size: 'large' });
        },
        sections: [{
          renderEdit: this.createRenderEdit('name', 'Name', true, this.hasValidName()),
          renderDisplay: function renderDisplay() {
            var name = _this2.state.data.name;

            if (!name) {
              return;
            }
            return React.createElement(
              __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
              { to: '/contacts/details/' + _this2.props.endUser.id, title: name, target: '_self' },
              React.createElement(
                'div',
                { className: 'name' },
                name
              )
            );
          }
        }] })
    );
  },
  hasValidName: function hasValidName() {
    return this.state.data.name == null || _.trim(this.state.data.name).length > 0;
  },
  hasDataChanged: function hasDataChanged() {
    var originalData = this.normalizeData(this.getDataFromProps());
    var newData = this.normalizeData(this.state.data);
    return !_.isEqual(newData, originalData);
  },
  normalizeData: function normalizeData(data) {
    return _.mapValues(data, function (value) {
      if (value === '') {
        return undefined;
      } else {
        return value;
      }
    });
  },
  save: function save() {
    if (!this.hasDataChanged()) {
      return;
    }

    var updateParams = _.pickBy(this.state.data, function (v, k) {
      return k && v;
    });
    this.props.actions.EndUserActions.updateEndUser(this.props.endUser.id, {
      name: updateParams.name,
      attributes: {
        display_location: updateParams.location
      }
    });
    return this.props.actions.NotificationActions.pushNotification({
      content: this.props.endUser.name + '\'s Identity card has been updated!'
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (EndUserIdentity);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "x1nw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_message_selectors__ = __webpack_require__("bWf9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style__ = __webpack_require__("k30Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_location_pin_svg__ = __webpack_require__("8BMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_location_pin_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__svg_inline_removeTags_true_images_svg_location_pin_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var TimeStamp = function (_Component) {
  _inherits(TimeStamp, _Component);

  function TimeStamp(props) {
    _classCallCheck(this, TimeStamp);

    var _this = _possibleConstructorReturn(this, (TimeStamp.__proto__ || Object.getPrototypeOf(TimeStamp)).call(this, props));

    _this.state = {
      minutes: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().minutes()
    };
    return _this;
  }

  _createClass(TimeStamp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        _this2.setState({ minutes: __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().minutes() });
      }, 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.minutes !== this.state.minutes || nextProps.timezone !== this.props.timezone;
    }
  }, {
    key: 'render',
    value: function render() {
      var timezone = this.props.timezone;

      var timestamp = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        timezone ? __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().tz(timezone).format('h:mm A') : __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().format('h:mm A')
      );
    }
  }]);

  return TimeStamp;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var LocalTime = function (_Component2) {
  _inherits(LocalTime, _Component2);

  function LocalTime() {
    var _ref;

    var _temp, _this3, _ret;

    _classCallCheck(this, LocalTime);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, (_ref = LocalTime.__proto__ || Object.getPrototypeOf(LocalTime)).call.apply(_ref, [this].concat(args))), _this3), _this3.formatGeolocation = function (_ref2) {
      var city = _ref2.city,
          region = _ref2.region,
          country = _ref2.country;

      return _.compact([city, region, country]).join(', ');
    }, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  _createClass(LocalTime, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          geolocation = _props.geolocation,
          timezone = _props.timezone;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_8__style__["localTime"], className, 'flex-row icon-row') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__driftt_tide_core_legacy__["Icon"], { width: 13, height: 13, name: 'location-2', className: 'icon' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'geolocation' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimeStamp, { timezone: timezone }),
          _.get(geolocation, 'country') && ' - ' + this.formatGeolocation(geolocation)
        )
      );
    }
  }]);

  return LocalTime;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var makeMapStateToProps = function makeMapStateToProps() {
  var lastEndUserMessageSelector = __WEBPACK_IMPORTED_MODULE_6_app_modules_message_selectors__["g" /* lastEndUserMessage */]();

  return function (state, props) {
    var conversationId = props.conversationId;


    return {
      lastEndUserMessage: lastEndUserMessageSelector(state, { conversationId: conversationId })
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(makeMapStateToProps), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* branch */])(function (props) {
  return !props.endUser;
}, __WEBPACK_IMPORTED_MODULE_4_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["a" /* branch */])(function (props) {
  return !props.lastEndUserMessage;
}, __WEBPACK_IMPORTED_MODULE_4_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_4_recompose__["e" /* mapProps */])(function (_ref3) {
  var lastEndUserMessage = _ref3.lastEndUserMessage,
      props = _objectWithoutProperties(_ref3, ['lastEndUserMessage']);

  var geolocation = lastEndUserMessage.getIn(['context', 'location']);
  var timezone = lastEndUserMessage.getIn(['context', 'timezone']);

  return _extends({
    geolocation: geolocation && geolocation.toJS(),
    timezone: timezone
  }, props);
}))(LocalTime));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "x4Zn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.


var _require$default = __webpack_require__("h6+o").default,
    FETCH_TARGET_CONDITIONS_DONE = _require$default.FETCH_TARGET_CONDITIONS_DONE,
    FETCH_TARGET_CONDITION_DONE = _require$default.FETCH_TARGET_CONDITION_DONE,
    CREATE_TARGET_CONDITION_DONE = _require$default.CREATE_TARGET_CONDITION_DONE,
    PATCH_TARGET_CONDITION_DONE = _require$default.PATCH_TARGET_CONDITION_DONE;

var TargetConditionStore = Marty.createStore({
  id: 'TargetConditionStore',

  getInitialState: function getInitialState() {
    return __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS({
      targetsById: {}
    });
  },
  rehydrate: function rehydrate(dehydratedState) {
    return this.state = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(dehydratedState);
  },


  handlers: {
    handleFetchTargetConditionsDone: FETCH_TARGET_CONDITIONS_DONE,
    handleTargetCreation: CREATE_TARGET_CONDITION_DONE,
    handlePatchTarget: PATCH_TARGET_CONDITION_DONE,
    handleFetchTargetConditionDone: FETCH_TARGET_CONDITION_DONE
  },

  setTarget: function setTarget(target) {
    return this.state = this.state.setIn(['targetsById', target.id], __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(target));
  },
  handleFetchTargetConditionsDone: function handleFetchTargetConditionsDone(targets) {
    var targetsById = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS(targets).reduce(function (targetsById, target) {
      return targetsById.set(target.get('id'), target);
    }, __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map());
    return this.state = this.state.mergeDeepIn(['targetsById'], targetsById);
  },
  handlePatchTarget: function handlePatchTarget(target) {
    return this.setTarget(target);
  },
  handleTargetCreation: function handleTargetCreation(target) {
    this.setTarget(target);
    return this.state = this.state.set('lastCreatedTargetId', target.id);
  },
  handleFetchTargetConditionDone: function handleFetchTargetConditionDone(target) {
    return this.setTarget(target);
  },
  fetchTargets: function fetchTargets() {
    var id = 'fetchTargets';
    return this.fetch({
      id: id,
      locally: function locally() {
        if (this.hasAlreadyFetched(id)) {
          return this.state.get('targetsById');
        }
      },
      remotely: function remotely() {
        return this.app.queries.TargetConditionQueries.fetchTargets();
      }
    });
  },
  getLastCreatedTargetId: function getLastCreatedTargetId() {
    return this.state.get('lastCreatedTargetId', -1);
  },
  fetchTarget: function fetchTarget(targetId) {
    var id = 'fetchTarget' + targetId;
    return this.fetch({
      id: id,
      locally: function locally() {
        return this.state.get('targetsById').get(targetId);
      },
      remotely: function remotely() {
        return this.app.queries.TargetConditionQueries.fetchTarget(targetId);
      }
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (TargetConditionStore);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "x8Uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSegmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSegmentListPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchSegmentListFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return receiveSegmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSegmentSetCardinality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchSegmentSetCardinalityPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchSegmentSetCardinalityFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return receiveSegmentSetCardinality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchEndUserMembership; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchEndUserMembershipPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchEndUserMembershipFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return receiveEndUserMembership; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("dlfT");



var fetchSegmentList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FETCH_SEGMENT_LIST */]);
var fetchSegmentListPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* FETCH_SEGMENT_LIST_PENDING */]);
var fetchSegmentListFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* FETCH_SEGMENT_LIST_FAILED */]);
var receiveSegmentList = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* RECEIVE_SEGMENT_LIST */]);

var fetchSegmentSetCardinality = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* FETCH_SEGMENT_SET_CARDINALITY */]);
var fetchSegmentSetCardinalityPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* FETCH_SEGMENT_SET_CARDINALITY_PENDING */]);
var fetchSegmentSetCardinalityFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* FETCH_SEGMENT_SET_CARDINALITY_FAILED */]);
var receiveSegmentSetCardinality = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* FETCH_SEGMENT_SET_CARDINALITY_SUCCESS */]);

var fetchEndUserMembership = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* FETCH_END_USER_MEMBERSHIP */]);
var fetchEndUserMembershipPending = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* FETCH_END_USER_MEMBERSHIP_PENDING */]);
var fetchEndUserMembershipFailed = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* FETCH_END_USER_MEMBERSHIP_FAILED */]);
var receiveEndUserMembership = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FETCH_END_USER_MEMBERSHIP_SUCCESS */]);

/***/ }),

/***/ "x8hE":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(537);

/***/ }),

/***/ "x8mI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("4pGK");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("a/+K");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "xBm8":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M47 .0853203c-25.9341955 0-46.9567073 21.023052-46.9567073 46.9579141C.0432927 72.976948 21.0658045 94 47 94c25.9330471 0 46.9567073-21.023052 46.9567073-46.9567656C93.9567073 21.1083723 72.9330471.0853203 47 .0853203zm-1.4676483 58.7476361c0 .7143198-.3778218 1.3746637-.9910646 1.7318236-.6086491.3537146-1.3539572.3548631-1.9637548.008039-.0057419-.0034453-.0126323-.0057421-.0183743-.0091874l-8.3327513-4.8566856v18.0371493c0 .7143198-.3766734 1.3758121-.9899161 1.732972-.3077698.1768573-.648843.2675828-.9910646.2675828-.3410732 0-.6832948-.0907255-.9910645-.2675828l-4.9805875-2.9032162c-.6132427-.3571599-.9910645-1.0175038-.9910645-1.7306752V50.4931004l-8.0502463-4.6913125c-.6132427-.3571599-.9910645-1.0175038-.9910645-1.7318236v-7.7759797c0-.7143198.3778218-1.3746637.9910645-1.7306752.6132428-.3583083 1.3688864-.3583083 1.9821291 0l25.3266948 14.7549532c.6132428.3583083.9910646 1.0198006.9910646 1.7341204v7.7805734zm.4283512-31.1624886c0 .99109-.5259648 1.906384-1.3815187 2.4059485l-7.6597921 4.4639246v5.8787831c0 .598329-.6408042.9750121-1.1575818.6752734-3.0857363-1.7961353-11.4850945-6.68268-14.5570501-8.4638858-.5144808-.2985903-.5052936-1.0347301.0091872-1.3344688L42.9875092 18.608253c.6132427-.3560115 1.367738-.3560115 1.9821291 0 .6132427.3583084.9910646 1.0186522.9910646 1.732972v7.3292428zm2.505797-7.3292428c0-.7143198.3778218-1.3746636.992213-1.732972.6120943-.3560115 1.3677379-.3560115 1.9809807 0l21.7620779 12.6808992c.5190743.303184.5282615 1.0473628.0080387 1.3482499-3.0754007 1.7835027-11.4207844 6.6390399-14.5214498 8.4432142-.5259648.3054808-1.1805497-.0769444-1.1805497-.6867576v-5.7754249c0-.0482339-.0252647-.0941708-.0677553-.1182877l-7.9813425-4.6522662c-.6143912-.3571599-.992213-1.0175037-.992213-1.7318235V20.341225zm29.290953 23.7287393c0 .7143198-.3778218 1.3746637-.9910645 1.7318236l-8.0502463 4.6913125v20.3500755c0 .7131714-.3778218 1.3735153-.9910645 1.7306752l-4.9805875 2.9032162c-.3077697.1768573-.6488429.2675828-.9910645.2675828s-.6832948-.0907255-.9899162-.2675828c-.6143911-.3571599-.9910645-1.0186522-.9910645-1.732972V55.706946l-8.3327513 4.8566856c-.005742.0034453-.0126324.0057421-.0172259.0091874-.610946.3468241-1.3562541.3456756-1.9637548-.008039-.6143912-.3571599-.992213-1.0175038-.992213-1.7318236V51.052383c0-.7143198.3778218-1.3758121.992213-1.7341204l25.3255464-14.7549532c.6132427-.3583083 1.3688863-.3583083 1.9821291 0 .6132427.3560115.9910645 1.0163554.9910645 1.7306752v7.7759797z\" fill=\"#333\"></path><ellipse stroke=\"#FFF\" stroke-width=\"4\" fill=\"#0075FF\" cx=\"79\" cy=\"79\" rx=\"19\" ry=\"19\"></ellipse><path d=\"M90.707 79.641l-5.001 4.978c-.195.194-.451.291-.707.291-.256 0-.512-.097-.707-.291-.391-.389-.391-1.019 0-1.407l4.294-4.275-4.294-4.269c-.391-.388-.391-1.019 0-1.408.391-.388 1.023-.388 1.414 0l5.001 4.974c.188.187.293.439.293.703 0 .264-.105.518-.293.704zm-13.749 9.534c-.13.431-.527.708-.958.708-.095 0-.191-.013-.287-.041-.529-.158-.829-.714-.671-1.239l6-19.902c.158-.526.713-.827 1.245-.667.529.158.829.712.671 1.238l-6 19.903zm-3.25-4.558c-.195.194-.451.291-.707.291-.256 0-.512-.097-.707-.291l-5.001-4.974c-.187-.186-.293-.439-.293-.703 0-.263.106-.517.293-.704l5.001-4.977c.391-.389 1.023-.389 1.414 0 .391.388.391 1.018 0 1.407l-4.294 4.274 4.294 4.269c.391.388.391 1.019 0 1.408z\" stroke=\"#FFF\" fill=\"#FFF\"></path></g></svg>"

/***/ }),

/***/ "xBok":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSItMjk2LjUgMjc2IDI0Ny41IDY3LjQiPjxzdHlsZT4uc3Qwe2ZpbGw6I0ZGRjtzdHJva2U6I0NDQztzdHJva2Utd2lkdGg6NH0uc3Qxe2ZpbGw6I0NDQ308L3N0eWxlPjx0aXRsZT5Hcm91cDwvdGl0bGU+PGcgaWQ9IlBBLUZsb3ciPjxnIGlkPSJXaXphcmQtLS1UeXBlIj48ZyBpZD0iR3JvdXAiPjxwYXRoIGlkPSJQYXRoLTE2OCIgY2xhc3M9InN0MCIgZD0iTS0xMDAuNiAyODAuNGMwLS4zLjItLjYuNS0uNmg0MmMuOSAwIDEuMy43LjkgMS41bC02LjYgMTIuOWMtLjIuNC0uMiAxLjEgMCAxLjVsNi43IDEzLjhjLjQuOCAwIDEuNS0xIDEuNWgtNDEuNGwtMS4xLTMwLjZ6Ii8+PHBhdGggaWQ9IlRyaWFuZ2xlLTEiIGNsYXNzPSJzdDEiIGQ9Ik0tMTAwLjMgMzAxLjl2LTIxLjdsMTQuOSA4LjEtMTQuOSAxMy42eiIvPjxwYXRoIGlkPSJQYXRoLTE2OF8xXyIgY2xhc3M9InN0MCIgZD0iTS0yNDQuMyAyODAuNGMwLS4zLS4yLS42LS41LS42aC00MmMtLjkgMC0xLjMuNy0uOSAxLjVsNi42IDEyLjljLjIuNC4yIDEuMSAwIDEuNWwtNi43IDEzLjhjLS40LjggMCAxLjUgMSAxLjVoNDEuNGwxLjEtMzAuNnoiLz48cGF0aCBpZD0iVHJpYW5nbGUtMS1Db3B5IiBjbGFzcz0ic3QxIiBkPSJNLTI0NC43IDMwMS45di0yMS43bC0xNC45IDguMiAxNC45IDEzLjV6Ii8+PHBhdGggaWQ9IlJlY3RhbmdsZS01OSIgY2xhc3M9InN0MCIgZD0iTS0yNTcuNSAyOTAuOWM1Mi45IDEzLjMgMTExLjMgMTUuNSAxNzAgMHYzNy44Yy00NC43IDE4LjEtMTM3LjYgMTMtMTcwIDB2LTM3Ljh6Ii8+PC9nPjwvZz48L2c+PC9zdmc+"

/***/ }),

/***/ "xHSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_enrichment_demandbase_selectors__ = __webpack_require__("OtCs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_enrichment_demandbase_actions__ = __webpack_require__("FFPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_enrichment_clearbit_selectors__ = __webpack_require__("znyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_utils_Integrations__ = __webpack_require__("CCiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component__ = __webpack_require__("sU8Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers__ = __webpack_require__("vozR");




















var mapStateToProps = function mapStateToProps(state) {
  var id = __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["L" /* getCurrentConditionId */](state);
  var revealContext = Object(__WEBPACK_IMPORTED_MODULE_10_app_modules_enrichment_clearbit_selectors__["a" /* getClearbitRevealContext */])(state);
  var hasDemandbase = Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__["l" /* isConnectedTo */])(state, 'demandbase');
  return {
    id: id,
    condition: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["F" /* getCondition */](state, { id: id }),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state),
    hasMarketingSequences: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["u" /* makeHasGate */])('has_marketing_sequences')(state),
    hasSegmentSelect: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_gates_selectors__["u" /* makeHasGate */])('has_segment_display_targeting')(state),
    hasDemandbase: hasDemandbase,
    showEnrichmentUpgrade: revealContext.isEligibleForTargetingUpgradeFlow && !hasDemandbase,
    externalData: {
      demandbaseIndustries: __WEBPACK_IMPORTED_MODULE_8_app_modules_enrichment_demandbase_selectors__["a" /* demandbaseTargetingIndustries */](state),
      demandbaseSubIndustries: __WEBPACK_IMPORTED_MODULE_8_app_modules_enrichment_demandbase_selectors__["b" /* demandbaseTargetingSubIndustries */](state)
    }
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setValue: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_143" /* setConditionValue */],
      setOperator: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_142" /* setConditionOperator */],
      setField: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_141" /* setConditionField */],
      hideConditionModal: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["_78" /* hideConditionModal */],
      deleteCondition: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_actions__["H" /* deleteCondition */],
      fetchDemandbaseIndustries: __WEBPACK_IMPORTED_MODULE_9_app_modules_enrichment_demandbase_actions__["f" /* fetchDemandbaseTargetingIndustries */],
      fetchDemandbaseSubIndustries: __WEBPACK_IMPORTED_MODULE_9_app_modules_enrichment_demandbase_actions__["j" /* fetchDemandbaseTargetingSubIndustries */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('testUrl', 'setTestUrl', ''), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('testUrlIsValid', 'setTestUrlIsValid', false), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["i" /* withProps */])(function (props) {
  return {
    checkTestUrlValidity: function checkTestUrlValidity(testUrl) {
      var newCondition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var testAgainstUrl = testUrl;
      if (!!testAgainstUrl && !testAgainstUrl.startsWith('http')) {
        testAgainstUrl = 'https://' + testAgainstUrl;
      }
      var condition = props.condition;

      var evaluateAgainst = condition.merge(newCondition);
      var value = evaluateAgainst.value,
          operator = evaluateAgainst.operator,
          field = evaluateAgainst.field;

      var anchor = document.createElement('a');
      anchor.href = testAgainstUrl;
      props.setTestUrlIsValid(Object(__WEBPACK_IMPORTED_MODULE_15__helpers__["a" /* checkUrlValidity */])(value, operator, field, anchor));
    }
  };
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedCategory', 'setCategory', function (props) {
  if (props.condition.field === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["R" /* ConditionType */].URL_QUERY && props.condition.value.some(function (v) {
    return v && v.startsWith && v.startsWith('d_campaign');
  })) {
    return __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["S" /* ConditionTypes */].get('email_playbook').category;
  } else {
    return __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["S" /* ConditionTypes */].get(props.condition.field).category;
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["j" /* withState */])('selectedCategoryOptions', 'setCategoryOptions', function (props) {
  return __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["T" /* ConditionTypesByCategory */].get(props.selectedCategory).filter(function (_ref) {
    var requiredGate = _ref.requiredGate;
    return requiredGate ? __WEBPACK_IMPORTED_MODULE_12_utils_Access__["c" /* default */].hasGates(requiredGate) : true;
  }).filter(function (_ref2) {
    var requiredIntegration = _ref2.requiredIntegration;
    return requiredIntegration ? Object(__WEBPACK_IMPORTED_MODULE_13_utils_Integrations__["b" /* isIntegrationConnected */])(requiredIntegration) : true;
  }).filter(function (_ref3) {
    var outboundOnly = _ref3.outboundOnly;
    return outboundOnly ? props.isOutboundPlaybook : true;
  }).map(function (_ref4, type) {
    var displayName = _ref4.displayName;
    return { value: type, label: displayName };
  }).toArray();
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["h" /* withHandlers */])({
  onOperatorChange: function onOperatorChange(_ref5) {
    var id = _ref5.id,
        setOperator = _ref5.actions.setOperator,
        testUrl = _ref5.testUrl,
        selectedCategory = _ref5.selectedCategory,
        checkTestUrlValidity = _ref5.checkTestUrlValidity;
    return function (_ref6) {
      var operator = _ref6.value;

      setOperator({ operator: operator, id: id });
      if (selectedCategory === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["P" /* ConditionCategory */].URL) {
        checkTestUrlValidity(testUrl, { operator: operator });
      }
    };
  },
  onTestUrlChange: function onTestUrlChange(props) {
    return function (event) {
      props.setTestUrl(event.currentTarget.value);
      props.checkTestUrlValidity(event.currentTarget.value || '');
    };
  },
  onCategoryClick: function onCategoryClick(_ref7) {
    var setCategory = _ref7.setCategory,
        setCategoryOptions = _ref7.setCategoryOptions,
        id = _ref7.id,
        setField = _ref7.actions.setField,
        isOutboundPlaybook = _ref7.isOutboundPlaybook;
    return function (category) {
      return function () {
        var categoryOptions = __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["T" /* ConditionTypesByCategory */].get(category).filter(function (_ref8) {
          var requiredGate = _ref8.requiredGate;
          return requiredGate ? __WEBPACK_IMPORTED_MODULE_12_utils_Access__["c" /* default */].hasGates(requiredGate) : true;
        }).filter(function (_ref9) {
          var requiredIntegration = _ref9.requiredIntegration;
          return requiredIntegration ? Object(__WEBPACK_IMPORTED_MODULE_13_utils_Integrations__["b" /* isIntegrationConnected */])(requiredIntegration) : true;
        }).filter(function (_ref10) {
          var outboundOnly = _ref10.outboundOnly;
          return outboundOnly ? isOutboundPlaybook : true;
        }).map(function (_ref11, type) {
          var displayName = _ref11.displayName;
          return { value: type, label: displayName };
        }).toArray();

        var field = categoryOptions[0].value;

        setCategory(category);
        setCategoryOptions(categoryOptions);
        setField({ field: field, id: id });
      };
    };
  },
  onValueChange: function onValueChange(_ref12) {
    var id = _ref12.id,
        setValue = _ref12.actions.setValue,
        selectedCategory = _ref12.selectedCategory,
        testUrl = _ref12.testUrl,
        checkTestUrlValidity = _ref12.checkTestUrlValidity;
    return function (value) {
      setValue({ value: value, id: id });
      if (selectedCategory === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["P" /* ConditionCategory */].URL) {
        checkTestUrlValidity(testUrl, { value: value });
      }
    };
  },
  onFieldChange: function onFieldChange(_ref13) {
    var id = _ref13.id,
        setField = _ref13.actions.setField,
        selectedCategory = _ref13.selectedCategory,
        testUrl = _ref13.testUrl,
        checkTestUrlValidity = _ref13.checkTestUrlValidity;
    return function (_ref14) {
      var field = _ref14.value;

      setField({ field: field, id: id });
      if (selectedCategory === __WEBPACK_IMPORTED_MODULE_7_app_modules_playbook_constants__["P" /* ConditionCategory */].URL) {
        checkTestUrlValidity(testUrl, { field: field });
      }
    };
  },
  onCloseClick: function onCloseClick(_ref15) {
    var _ref15$actions = _ref15.actions,
        hideConditionModal = _ref15$actions.hideConditionModal,
        deleteCondition = _ref15$actions.deleteCondition,
        setValue = _ref15$actions.setValue,
        id = _ref15.id,
        value = _ref15.condition.value;
    return function () {
      var emptyValues = ["", null, undefined];
      // We want to make sure the user doesn't shoot themselves in the foot
      // either by having one or more values be "empty" (when it's a List) or
      // having the singular value be an empty value
      if (__WEBPACK_IMPORTED_MODULE_3_immutable__["List"].isList(value)) {
        if (value.every(function (v) {
          return emptyValues.includes(v);
        })) {
          deleteCondition(id);
        } else {
          setValue({ id: id, value: value.filter(function (v) {
              return !emptyValues.includes(v);
            }) });
        }
      } else if (emptyValues.includes(value)) {
        deleteCondition(id);
      }

      hideConditionModal();
    };
  },
  onSegmentChange: function onSegmentChange(_ref16) {
    var id = _ref16.id,
        setValue = _ref16.actions.setValue;
    return function (value) {
      setValue({ value: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(value.map(function (option) {
          return option.value;
        })), id: id });
    };
  },
  onSegmentNext: function onSegmentNext(_ref17) {
    var id = _ref17.id,
        _ref17$actions = _ref17.actions,
        setValue = _ref17$actions.setValue,
        hideConditionModal = _ref17$actions.hideConditionModal;
    return function (userListIds) {
      setValue({ value: userListIds, id: id });
      hideConditionModal();
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        hasDemandbase = _props.hasDemandbase,
        actions = _props.actions;


    if (hasDemandbase) {
      actions.fetchDemandbaseIndustries();
      actions.fetchDemandbaseSubIndustries();
    }
  }
}))(__WEBPACK_IMPORTED_MODULE_14__component__["a" /* default */]));

/***/ }),

/***/ "xI2r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl__ = __webpack_require__("froD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_styl__);


var Template = function Template(_ref) {
  var title = _ref.title,
      copy = _ref.copy,
      button = _ref.button,
      image = _ref.image,
      _ref$skipLiveChatImag = _ref.skipLiveChatImage,
      skipLiveChatImage = _ref$skipLiveChatImag === undefined ? false : _ref$skipLiveChatImag;

  if (!image && !skipLiveChatImage) {
    image = React.createElement('img', { style: { width: "100%" }, src: __webpack_require__("z6IM") });
  }

  return React.createElement(
    'div',
    { style: { height: "100vh", width: "100vw" }, className: 'flex-column flex-space-between' },
    React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_0__style_styl___default.a.Content + ' flex-column flex-space-between' },
      React.createElement('img', { style: { width: 123, height: 50 }, src: __webpack_require__("0WTh") }),
      React.createElement(
        'div',
        { className: 'dsg-medium-weight dsg-h3' },
        title
      ),
      React.createElement(
        'div',
        null,
        copy
      ),
      React.createElement(
        'div',
        { className: 'flex-column', style: { minHeight: 80 } },
        button
      )
    ),
    image
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Template);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "xIgN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var InboxConstants = Marty.createConstants(['INBOX_LIST_FETCH', 'INBOX_FETCH', 'INBOX_UPDATE', 'INBOX_CREATE', 'INBOX_ARCHIVE', 'CHECK_INBOX_EXISTENCE_BY_EMAIL', 'WHITE_LIST_LABELS_CREATE', 'WHITE_LIST_LABELS_FETCH', 'WHITE_LIST_LABELS_VALIDATE']);

/* harmony default export */ __webpack_exports__["a"] = (InboxConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "xJoo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var GLOBAL_MODAL_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  MODAL_OPENED: null,
  MODAL_CLOSED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(GLOBAL_MODAL_CONSTANTS, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId));

/***/ }),

/***/ "xJzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MEETING_ICON_TO_DURATION; });
/* unused harmony export GATED_PROFILE_OPTIONS */
/* unused harmony export MEETING_LENGTH_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOM_MEETING_LENGTH_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUFFER_LENGTH_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTICE_TIME_OPTIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_meetings_calendar_duration_10m_svg__ = __webpack_require__("SFGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_meetings_calendar_duration_10m_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_images_meetings_calendar_duration_10m_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_meetings_calendar_duration_15m_svg__ = __webpack_require__("RXt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_meetings_calendar_duration_15m_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_meetings_calendar_duration_15m_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_meetings_calendar_duration_30m_svg__ = __webpack_require__("JltT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_meetings_calendar_duration_30m_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_meetings_calendar_duration_30m_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_meetings_calendar_duration_45m_svg__ = __webpack_require__("z7lp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_images_meetings_calendar_duration_45m_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_images_meetings_calendar_duration_45m_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_meetings_calendar_duration_60m_svg__ = __webpack_require__("6z1Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_images_meetings_calendar_duration_60m_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_images_meetings_calendar_duration_60m_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var MEETING_ICON_TO_DURATION = {
  '10': __WEBPACK_IMPORTED_MODULE_0_images_meetings_calendar_duration_10m_svg___default.a,
  '15': __WEBPACK_IMPORTED_MODULE_1_images_meetings_calendar_duration_15m_svg___default.a,
  '30': __WEBPACK_IMPORTED_MODULE_2_images_meetings_calendar_duration_30m_svg___default.a,
  '45': __WEBPACK_IMPORTED_MODULE_3_images_meetings_calendar_duration_45m_svg___default.a,
  '60': __WEBPACK_IMPORTED_MODULE_4_images_meetings_calendar_duration_60m_svg___default.a
};

var GATED_PROFILE_OPTIONS = {
  MEETING_LENGTH: { value: 60, label: '60 minutes' },
  BUFFER_LENGTH: { value: 0, label: 'No buffer time' },
  NOTICE_TIME: { value: 0, label: 'No minimum notice time' }
};

var MEETING_LENGTH_OPTIONS = [{ value: 15, label: '15 minutes' }, { value: 30, label: '30 minutes' }, _extends({}, GATED_PROFILE_OPTIONS.MEETING_LENGTH)];
var CUSTOM_MEETING_LENGTH_OPTIONS = [{ value: 10, label: '10 minutes' }, { value: 15, label: '15 minutes' }, { value: 30, label: '30 minutes' }, { value: 45, label: '45 minutes' }, _extends({}, GATED_PROFILE_OPTIONS.MEETING_LENGTH)];

var BUFFER_LENGTH_OPTIONS = [_extends({}, GATED_PROFILE_OPTIONS.BUFFER_LENGTH), { value: 15, label: '15 minutes' }, { value: 30, label: '30 minutes' }, { value: 60, label: '60 minutes' }];

var NOTICE_TIME_OPTIONS = [_extends({}, GATED_PROFILE_OPTIONS.NOTICE_TIME), { value: 15, label: '15 minutes' }, { value: 30, label: '30 minutes' }, { value: 60, label: '1 hour' }, { value: 120, label: '2 hours' }, { value: 180, label: '3 hours' }, { value: 240, label: '4 hours' }, { value: 1440, label: '1 day' }];

/***/ }),

/***/ "xKD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utils_OpenHoursHelper__ = __webpack_require__("4JBo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_EmbedConfigurationConstants__ = __webpack_require__("ZDyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_Access__ = __webpack_require__("6k1g");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var onlineIconSrc = __webpack_require__("gDdS");
var offlineIconSrc = __webpack_require__("cnY4");

var NOTIFICATION_TYPES = {
  ON: {
    type: 'attention',
    copy: 'Drift is online',
    icon: React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: onlineIconSrc })
  },
  AWAY: {
    type: 'general',
    copy: 'Drift is offline',
    icon: React.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: offlineIconSrc })
  },
  OFF: { type: null, icon: null }
};

var WidgetStatusTease = function (_Component) {
  _inherits(WidgetStatusTease, _Component);

  function WidgetStatusTease(props) {
    _classCallCheck(this, WidgetStatusTease);

    var _this = _possibleConstructorReturn(this, (WidgetStatusTease.__proto__ || Object.getPrototypeOf(WidgetStatusTease)).call(this, props));

    _this.seenWidgetStatus = function () {
      var widgetStatus = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["get"])(_this.props, 'embedConfiguration.widgetStatus', false);
      try {
        var hasSeenWidgetStatus = JSON.parse(window.localStorage.getItem('hasSeenWidgetStatus')) || {};
        return hasSeenWidgetStatus.lastAvailability === widgetStatus;
      } catch (e) {
        console.warn("Failed to fetch hasSeenWidgetStatus from local storage");
        return false;
      }
    };

    _this.handleDismiss = function () {
      var widgetStatus = _this.props.embedConfiguration.widgetStatus;

      _this.setState({ closed: true }, function () {
        setTimeout(function () {
          try {
            window.localStorage.setItem('hasSeenWidgetStatus', JSON.stringify({ lastAvailability: widgetStatus }));
          } catch (e) {
            console.warn('Failed to set local storage value hasSeenWidgetStatus');
          }
          _this.setState({ seenThisStatus: true });
        }, 3000);
      });
    };

    _this.state = {
      seenThisStatus: props.isEmbedLoaded ? _this.seenWidgetStatus() : false,
      firstLoad: true,
      closed: true,
      isOnline: props.isEmbedLoaded ? _this.currentDriftStatus() : false
    };
    return _this;
  }

  _createClass(WidgetStatusTease, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.isEmbedLoaded !== prevProps.isEmbedLoaded) {
        this.setState({
          seenThisStatus: this.seenWidgetStatus(),
          isOnline: this.currentDriftStatus()
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.firstLoad) {
        this.setState({ firstLoad: false, closed: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.AutoDismissOnline);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.seenWidgetStatus(nextProps) === this.state.seenThisStatus) return;
      this.setState({ seenThisStatus: false, closed: false });
    }
  }, {
    key: 'currentDriftStatus',
    value: function currentDriftStatus() {
      var _props$embedConfigura = this.props.embedConfiguration,
          _props$embedConfigura2 = _props$embedConfigura.theme,
          timezone = _props$embedConfigura2.timezone,
          openHours = _props$embedConfigura2.openHours,
          widgetStatus = _props$embedConfigura.widgetStatus,
          widgetMode = _props$embedConfigura.widgetMode;


      var isOpenForBusiness = Object(__WEBPACK_IMPORTED_MODULE_6_utils_OpenHoursHelper__["a" /* areWeOpenForBusiness */])(timezone, openHours);
      // widgetMode is MANUAL - use ON / AWAY state
      if (widgetMode === __WEBPACK_IMPORTED_MODULE_7_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].MANUAL) {
        return widgetStatus === __WEBPACK_IMPORTED_MODULE_7_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON;
      }

      // widgetMode is AUTO - use business hours + agent status
      if (widgetMode === __WEBPACK_IMPORTED_MODULE_7_constants_EmbedConfigurationConstants__["a" /* WidgetMode */].AUTO) {
        return openHours && openHours.length == 0 || Object(__WEBPACK_IMPORTED_MODULE_6_utils_OpenHoursHelper__["a" /* areWeOpenForBusiness */])(timezone, openHours);
      }

      // widgetMode is undefined - fall back to old behavior
      return widgetStatus === __WEBPACK_IMPORTED_MODULE_7_constants_EmbedConfigurationConstants__["b" /* WidgetStatus */].ON && isOpenForBusiness;
    }
  }, {
    key: 'render',
    value: function render() {
      var _NOTIFICATION_TYPES = NOTIFICATION_TYPES[this.state.isOnline ? 'ON' : 'AWAY'],
          type = _NOTIFICATION_TYPES.type,
          icon = _NOTIFICATION_TYPES.icon,
          copy = _NOTIFICATION_TYPES.copy;

      var isAdmin = __WEBPACK_IMPORTED_MODULE_9_utils_Access__["c" /* default */].isAdmin();
      var isShown = !this.state.isOnline && isAdmin && !this.state.closed ? 'show-bar' : '';

      if (!this.props.isEmbedLoaded) {
        return null;
      }

      return !this.state.isOnline && React.createElement(
        'div',
        { className: 'global-notification-tease ' + type + ' ' + isShown },
        React.createElement(
          'p',
          null,
          icon,
          ' ',
          copy
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router__["c" /* Link */],
          {
            to: '/settings/widget/hours-and-targeting'
          },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Button"],
            {
              size: 'small',
              type: 'tertiary',
              className: 'notification-button drift-button small'
            },
            'Update Drift\u2019s status'
          )
        ),
        React.createElement(
          'div',
          { className: 'dismiss-notification', onClick: this.handleDismiss },
          React.createElement(__WEBPACK_IMPORTED_MODULE_4__driftt_tide_core_legacy__["Icon"], { name: 'close' })
        )
      );
    }
  }]);

  return WidgetStatusTease;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    embedConfiguration: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["h" /* getEmbedConfig */])(state),
    isEmbedLoaded: Object(__WEBPACK_IMPORTED_MODULE_8_app_modules_embed_selectors__["e" /* embedLoaded */])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(WidgetStatusTease));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "xKXM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_, React, Marty) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GlobalSearch$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openGlobalSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_SEARCH_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hotkeys__ = __webpack_require__("S+6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__ = __webpack_require__("60ou");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__ = __webpack_require__("Df95");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_constants_MomentCalendarPresets__ = __webpack_require__("7+AP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Avatar__ = __webpack_require__("A6dG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Modal__ = __webpack_require__("3F5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ResultPreview__ = __webpack_require__("Pqey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style__ = __webpack_require__("8VAy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


















var TIME_DELAY = 250;
var TIMEOUT = null;

var GLOBAL_SEARCH_KEY = 'globalSearch';

var openGlobalSearch = function openGlobalSearch(_ref) {
  var location = _ref.location,
      router = _ref.router;

  var globalSearch = {};
  globalSearch[GLOBAL_SEARCH_KEY] = '';
  var query = _.assign(location.query, globalSearch);
  var pathname = location.pathname;

  return router.push({ pathname: pathname, query: query });
};

var GlobalSearch = React.createClass({
  displayName: 'GlobalSearch',

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  },

  propTypes: {
    onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
  },

  getInitialState: function getInitialState() {
    return {
      query: this.getSearchQuery(),
      selectedResult: {},
      selectedIndex: undefined
    };
  },
  getSearchQuery: function getSearchQuery() {
    var query = this.props.query != null ? this.props.query.globalSearch : undefined;
    if (query === '/') {
      query = '';
    }
    return query || '';
  },
  componentDidMount: function componentDidMount() {
    this.app.stores.ConversationStore.resetSearchResults();
    this.app.stores.EndUserStore.resetSearchResults();

    if (this.getSearchQuery()) {
      return this.handleInputChange(this.getSearchQuery());
    }
  },
  handleInputChange: function handleInputChange(newQuery) {
    var _this = this;

    if (newQuery === '/') {
      return;
    }

    if (!_.isEmpty(newQuery.trim())) {
      clearTimeout(TIMEOUT);

      TIMEOUT = _.delay(function () {
        _this.app.actions.ConversationActions.searchConversations(newQuery);
        return _this.app.actions.EndUserActions.searchEndUser(_this.props.currentOrg.id, newQuery);
      }, TIME_DELAY);
    }

    var query = this.props.query;

    query.globalSearch = newQuery;

    this.context.router.push({ pathname: this.context.location.pathname, query: query });

    return this.unselectResult();
  },
  unselectResult: function unselectResult() {
    return this.setState({
      selectedResult: {},
      selectedIndex: undefined
    });
  },
  flattenResultItems: function flattenResultItems(collection) {
    var results = collection || [];
    return _.map(results, function (item) {
      var newResult = item._source;
      newResult.type = item._type;
      return newResult;
    });
  },
  getConversationItems: function getConversationItems() {
    return this.flattenResultItems(this.props.conversationSearchResults[this.getSearchQuery()]);
  },
  getUserItems: function getUserItems() {
    return this.flattenResultItems(this.props.endUserSearchResults[this.getSearchQuery()]);
  },


  // If we merge all of the item types into a single list, it's easier to hot key move over them
  // Make sure to put them in the order in which they appear
  getCombinedItems: function getCombinedItems() {
    return this.getUserItems().concat(this.getConversationItems());
  },
  renderUserItem: function renderUserItem(user, i) {
    var _this2 = this;

    var key = 'result-item-' + i;
    return React.createElement(
      'div',
      {
        key: key,
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('result-item', { isSelected: this.isItemSelected(__WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].endUser.key, user) }),
        onMouseOver: this.hoverOverItem.bind(this, __WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].endUser.key, user, i),
        onClick: this.selectResult,
        ref: function ref(_ref2) {
          return _this2[key] = _ref2;
        } },
      React.createElement(
        'div',
        { className: 'main-data' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_web_src_components_Avatar__["a" /* default */], { user: user }),
        React.createElement(
          'div',
          { className: 'intro-text' },
          user.name || user.email
        )
      ),
      React.createElement(
        'div',
        { className: 'extra-data' },
        React.createElement(
          'div',
          { className: 'details-text' },
          user.attributes.lastActive ? 'Last active on ' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(user.attributes.lastActive).calendar(null, __WEBPACK_IMPORTED_MODULE_6_constants_MomentCalendarPresets__["a" /* default */].detailedSameDay) : undefined
        )
      )
    );
  },
  hoverOverItem: function hoverOverItem(type, item, i) {
    return this.setState({
      selectedResult: item,
      selectedIndex: i
    });
  },
  isItemSelected: function isItemSelected(type, item) {
    return (this.state.selectedResult != null ? this.state.selectedResult.type : undefined) === type && (this.state.selectedResult != null ? this.state.selectedResult.id : undefined) === item.id;
  },
  renderConversationItem: function renderConversationItem(conversation, i) {
    var _this3 = this;

    var key = 'result-item-' + i;
    return React.createElement(
      'div',
      {
        key: key,
        className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('result-item', { isSelected: this.isItemSelected(__WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].conversation.key, conversation) }),
        onMouseOver: this.hoverOverItem.bind(this, __WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].conversation.key, conversation, i),
        onClick: this.selectResult,
        ref: function ref(_ref3) {
          return _this3[key] = _ref3;
        } },
      React.createElement(
        'div',
        { className: 'content' },
        React.createElement(
          'div',
          { className: 'title' },
          '#' + conversation.displayId + ' ' + (conversation.subject || '')
        ),
        React.createElement(
          'div',
          { className: 'metadata' },
          React.createElement(
            'span',
            null,
            ((this.props.endUsersById[conversation.endUserId] != null ? this.props.endUsersById[conversation.endUserId].name : undefined) || (this.props.endUsersById[conversation.endUserId] != null ? this.props.endUsersById[conversation.endUserId].email : undefined)) + ' | '
          ),
          React.createElement(
            'span',
            null,
            __WEBPACK_IMPORTED_MODULE_3_moment___default()(conversation.updatedAt).calendar(null, __WEBPACK_IMPORTED_MODULE_6_constants_MomentCalendarPresets__["a" /* default */].detailedSameDay) + ' | '
          ),
          React.createElement(
            'span',
            null,
            (this.props.inboxesById[conversation.inboxId] != null ? this.props.inboxesById[conversation.inboxId].name : undefined) + ' | '
          ),
          React.createElement(
            'span',
            { className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('status', conversation.status) },
            conversation.status
          )
        )
      )
    );
  },
  renderCategory: function renderCategory(title, collection, renderMethod, indexOffset) {
    if (_.isEmpty(collection)) {
      return;
    }

    return React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        { className: 'result-category' },
        React.createElement(
          'div',
          { className: 'result-category-header' },
          React.createElement(
            'span',
            null,
            title
          )
        )
      ),
      _.map(collection, function (item, index) {
        return renderMethod(item, index + indexOffset);
      })
    );
  },
  renderCategoryResults: function renderCategoryResults() {
    var usersIndexOffset = 0;
    var conversationsIndexOffset = usersIndexOffset + this.getUserItems().length;

    return React.createElement(
      'div',
      null,
      this.renderCategory('Customers', this.getUserItems(), this.renderUserItem, usersIndexOffset),
      this.renderCategory('Conversations', this.getConversationItems(), this.renderConversationItem, conversationsIndexOffset)
    );
  },
  renderResults: function renderResults() {
    return React.createElement(
      'div',
      { className: 'results-container' },
      React.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('results', {
            'preview-visible': this.state.selectedResult != null ? this.state.selectedResult.id : undefined
          }) },
        this.renderCategoryResults()
      ),
      (this.state.selectedResult != null ? this.state.selectedResult.id : undefined) ? React.createElement(
        'div',
        { className: 'preview' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10__ResultPreview__["a" /* default */], { item: this.state.selectedResult })
      ) : undefined
    );
  },
  changeSelectedIndex: function changeSelectedIndex(direction) {
    var newIndex = void 0;
    var currentResult = this.state.selectedResult;
    var currentIndex = this.state.selectedIndex;
    var allItems = this.getCombinedItems();

    if (direction > 0 && currentIndex === allItems.length - 1) {
      return;
    }
    if (direction < 0 && (currentIndex === 0 || currentIndex === undefined)) {
      return this.unselectResult();
    }

    if (currentIndex === undefined) {
      newIndex = 0;
    } else {
      newIndex = currentIndex + direction;
    }

    var newItem = allItems[newIndex];

    this.setState({
      selectedResult: newItem,
      selectedIndex: newIndex
    });

    var element = this['result-item-' + newIndex];
    return element != null ? element.scrollIntoViewIfNeeded(false) : undefined;
  },
  selectResult: function selectResult() {
    var selectedResult = this.state.selectedResult;


    if (selectedResult.id !== undefined) {
      this.props.onClose();
      switch (selectedResult.type) {
        case __WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].conversation.key:
          return this.goToConversation(selectedResult.inboxId, selectedResult.id);
        case __WEBPACK_IMPORTED_MODULE_5_constants_SearchResultTypesEnum__["a" /* default */].endUser.key:
          return this.goToUser(selectedResult.id);
      }
    }
  },
  goToConversation: function goToConversation(inboxId, conversationId) {
    var path = '/inboxes/' + inboxId + '/conversations/' + conversationId;
    return this.context.router.push(path);
  },
  goToUser: function goToUser(userId) {
    var path = '/contacts/details/' + userId;
    window.location.pathname = path;
  },
  render: function render() {
    var _this4 = this;

    var combinedResults = this.getCombinedItems();

    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_9_components_Modal__["a" /* default */],
      { onClose: this.props.onClose, modalContentClassName: 'GlobalSearch' },
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_hotkeys__["HotKeys"],
        {
          keyMap: {
            moveDown: 'down',
            moveUp: 'up',
            selectResult: ['enter', 'return']
          },
          handlers: {
            moveDown: function moveDown() {
              return _this4.changeSelectedIndex(1);
            },
            moveUp: function moveUp() {
              return _this4.changeSelectedIndex(-1);
            },
            selectResult: this.selectResult
          } },
        React.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('search-container', { 'no-results': combinedResults.length !== 0 }) },
          React.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_web_src_components_Input___default.a, {
            autoFocus: true,
            placeholder: 'Search',
            valueLink: {
              value: this.getSearchQuery(),
              requestChange: this.handleInputChange
            },
            isValid: true }),
          React.createElement('img', {
            className: 'search-icon',
            src: __webpack_require__("xjUl") }),
          React.createElement(
            'div',
            { className: 'num-results' },
            combinedResults.length + ' Results'
          )
        ),
        !_.isEmpty(this.getSearchQuery()) && combinedResults.length !== 0 ? this.renderResults() : undefined
      )
    );
  }
});

var GlobalSearch$1 = Marty.createContainer(GlobalSearch, {
  listenTo: ['stores.EndUserStore', 'stores.ConversationStore', 'stores.InboxStore'],

  fetch: {
    endUserSearchResults: function endUserSearchResults() {
      return this.app.stores.EndUserStore.getSearchResults();
    },
    conversationSearchResults: function conversationSearchResults() {
      return this.app.stores.ConversationStore.getSearchResults();
    },
    currentOrg: function currentOrg() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg();
    },
    endUsersById: function endUsersById() {
      return this.app.stores.EndUserStore.getEndUsersById();
    },
    inboxesById: function inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList();
    }
  },

  failed: function failed(errors) {
    Object(__WEBPACK_IMPORTED_MODULE_4_utils_SentryHelpers__["b" /* captureExceptions */])(errors);
    return React.createElement('div', null);
  }
});





/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF"), __webpack_require__("U7vG"), __webpack_require__("y6Nj")))

/***/ }),

/***/ "xMS5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var NoteConstants = Marty.createConstants(['NOTE_LIST_FOR_END_USER_FETCH', 'NOTE_LIST_FOR_COMPANY_FETCH', 'NOTE_END_USER_CREATE', 'NOTE_COMPANY_CREATE']);

/* harmony default export */ __webpack_exports__["a"] = (NoteConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "xN9T":
/***/ (function(module, exports) {

module.exports = "<svg width=\"271px\" height=\"151px\" viewBox=\"0 0 271 151\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Artboard\" transform=\"translate(-427.000000, -39.000000)\"><g id=\"Group-4\" transform=\"translate(427.000000, 39.000000)\"><g id=\"Group-2\"><polygon id=\"Rectangle-10-Copy\" fill=\"#E2EEF4\" points=\"0 14 271 14 271 151 0 151\"></polygon><path d=\"M2.40476546,2.66491416e-15 C1.07665017,2.66183609e-15 1.17527515e-16,1.08557146 1.17527515e-16,2.40601936 L1.17527515e-16,13.5452966 L271,13.5452966 L271,2.40601936 C271,1.07721156 269.922251,3.28491831e-15 268.595235,3.28184279e-15 L2.40476546,2.66491416e-15 Z\" id=\"top\" fill=\"#FFFFFF\"></path><g id=\"Rectangle-16\"><use fill=\"#F2F6F8\" fill-rule=\"evenodd\" xlink:href=\"#path-1\"></use><use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-2)\" xlink:href=\"#path-1\"></use></g><rect id=\"Rectangle-3\" fill=\"#B5D2E1\" x=\"0\" y=\"13\" width=\"271\" height=\"1\"></rect><rect id=\"Rectangle-3-Copy\" fill=\"#B5D2E1\" x=\"0\" y=\"150\" width=\"271\" height=\"1\"></rect><g id=\"Group-5\" transform=\"translate(193.000000, 42.000000)\"><path d=\"M3.36263736,0.456043956 L66.7912088,0.456043956 C68.7242054,0.456043956 70.2912088,2.02304733 70.2912088,3.95604396 L70.2912088,98.8791209 C70.2912088,100.812118 68.7242054,102.379121 66.7912088,102.379121 L3.36263736,102.379121 C1.42964074,102.379121 -0.137362637,100.812118 -0.137362637,98.8791209 L-0.137362637,3.95604396 C-0.137362637,2.02304733 1.42964074,0.456043956 3.36263736,0.456043956 Z\" id=\"Rectangle-6-Copy\" stroke=\"#B5D2E1\" fill=\"#FFFFFF\"></path><path d=\"M3.36263736,0.956043956 L66.7912088,0.956043956 C68.448063,0.956043956 69.7912088,2.29918971 69.7912088,3.95604396 L69.7912088,17.8681319 L0.362637363,17.8681319 L0.362637363,3.95604396 C0.362637363,2.29918971 1.70578311,0.956043956 3.36263736,0.956043956 Z\" id=\"Rectangle-9-Copy\" fill=\"#F2F6F8\"></path><path d=\"M0.362637363,90.4175824 L69.7912088,90.4175824\" id=\"Line-2-Copy-3\" stroke=\"#B5D2E1\" stroke-linecap=\"square\"></path><path d=\"M34.1868132,48.4563548 C34.1868132,46.8023634 35.5262576,45.4615385 37.1853365,45.4615385 L61.4520261,45.4615385 C63.1080648,45.4615385 64.4505495,46.8000056 64.4505495,48.4563548 L64.4505495,58.4887001 C64.4505495,60.1426915 63.111105,61.4835165 61.4520261,61.4835165 L37.1853365,61.4835165 C35.5292978,61.4835165 34.1868132,60.1450494 34.1868132,58.4887001 L34.1868132,48.4563548 Z\" id=\"Rectangle-Copy-7\" fill=\"#E1EEF4\"></path><path d=\"M19.9450549,9.85714286 C19.9450549,8.3823605 21.1393783,7.18681319 22.6074541,7.18681319 L38.6452931,7.18681319 C40.1156956,7.18681319 41.3076923,8.38536139 41.3076923,9.85714286 L41.3076923,9.85714286 C41.3076923,11.3319252 40.113369,12.5274725 38.6452931,12.5274725 L22.6074541,12.5274725 C21.1370517,12.5274725 19.9450549,11.3289243 19.9450549,9.85714286 L19.9450549,9.85714286 Z\" id=\"Rectangle-Copy-8\" fill=\"#E1EEF4\"></path><rect id=\"Rectangle-Copy-10\" fill=\"#F2F6F8\" x=\"19.0549451\" y=\"28.5494505\" width=\"33.8241758\" height=\"9.79120879\" rx=\"4.8956044\"></rect><rect id=\"Rectangle-Copy-12\" fill=\"#F2F6F8\" x=\"19.0549451\" y=\"69.4945055\" width=\"33.8241758\" height=\"16.021978\" rx=\"3\"></rect><path d=\"M62.0827134,9.75238791 L65.0467908,12.7167365 C65.1593654,12.8291822 65.1593654,13.0115815 65.0467908,13.1240273 C64.9907936,13.1801056 64.9170979,13.2081448 64.8434021,13.2081448 C64.7697064,13.2081448 64.6960107,13.1801056 64.6397234,13.1240273 L61.6753559,10.1596787 L58.7112786,13.1240273 C58.6552814,13.1801056 58.5815857,13.2081448 58.5078899,13.2081448 C58.4341942,13.2081448 58.3604985,13.1801056 58.3042112,13.1240273 C58.1916366,13.0115815 58.1916366,12.8291822 58.3042112,12.7167365 L61.2682885,9.75238791 L58.3042112,6.78832843 C58.1916366,6.67588264 58.1916366,6.49348343 58.3042112,6.38103764 C58.4167858,6.26859185 58.5989941,6.26859185 58.7112786,6.38103764 L61.6753559,9.34509712 L64.6394332,6.38103764 C64.7520078,6.26859185 64.9342162,6.26859185 65.0467908,6.38103764 C65.1590752,6.49348343 65.1590752,6.67588264 65.0467908,6.78832843 L62.0827134,9.75238791 L62.0827134,9.75238791 Z\" id=\"Shape\" fill=\"#B5D2E1\"></path><circle id=\"Oval-3-Copy-4\" fill=\"url(#pattern-3)\" cx=\"11.043956\" cy=\"9.85714286\" r=\"5.34065934\"></circle><circle id=\"Oval-3-Copy-5\" fill=\"url(#pattern-5)\" cx=\"11.043956\" cy=\"33.8901099\" r=\"5.34065934\"></circle><circle id=\"Oval-3-Copy-7\" fill=\"url(#pattern-7)\" cx=\"11.043956\" cy=\"81.0659341\" r=\"5.34065934\"></circle></g></g></g></g></g></svg>"

/***/ }),

/***/ "xNwu":
/***/ (function(module, exports) {

module.exports = "<svg width=\"18\" height=\"17\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><circle stroke=\"#394F5A\" stroke-width=\"2\" cx=\"1222\" cy=\"896\" r=\"6\" fill=\"#F7D86B\" transform=\"translate(-1215 -886)\"></circle><g fill-rule=\"nonzero\"><path d=\"M17.533 7.571a2.925 2.925 0 0 1-2.922 2.929h-3.689a2.924 2.924 0 0 1-2.637-1.668 2.934 2.934 0 0 1 .352-3.085l.437-.55A2.927 2.927 0 0 1 8 2.929 2.926 2.926 0 0 1 10.922 0h3.69a2.92 2.92 0 0 1 2.634 1.661 2.936 2.936 0 0 1-.348 3.092l-.438.55a2.927 2.927 0 0 1 1.073 2.268z\" fill=\"#394F5A\"></path><path fill=\"#13CB6E\" d=\"M10 2.929c0 .512.413.928.922.928h1.77l-2.49 3.134a.934.934 0 0 0-.111.982.923.923 0 0 0 .831.527h3.69c.51 0 .921-.416.921-.929a.925.925 0 0 0-.922-.928h-1.77l2.49-3.134a.934.934 0 0 0 .111-.982.922.922 0 0 0-.83-.527h-3.69a.926.926 0 0 0-.922.929z\"></path></g></g></svg>"

/***/ }),

/***/ "xWyi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(38);

/***/ }),

/***/ "xZDm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MessagingInfo":"MessagingInfo---3GnSx"};

/***/ }),

/***/ "xcG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("froD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var title = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: '50%', margin: '1rem auto', display: 'block' }, src: __webpack_require__("2qzf") }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: 'dsg-h2 color-blue' },
  'Almost There'
)];

var copy = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: 'color-gray-dark' },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'We just sent you an email to help you finish setting Drift up on a computer.'
  ),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    'It only takes 2 minutes to put Drift\u2019s code snippet on your website and start talking to customers.'
  )
)];

var image = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundImage: 'url(' + __webpack_require__("UKWu") + ')',
    width: '100%',
    height: 150,
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    position: 'absolute',
    bottom: 0
  } });

var EmailPrompt = function (_Component) {
  _inherits(EmailPrompt, _Component);

  function EmailPrompt() {
    _classCallCheck(this, EmailPrompt);

    return _possibleConstructorReturn(this, (EmailPrompt.__proto__ || Object.getPrototypeOf(EmailPrompt)).apply(this, arguments));
  }

  _createClass(EmailPrompt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var timeThreshold = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(5, 'minutes');
      var deliveredTime = this.props.settings.mobileWelcomeDeliveryTime;

      // allow resend after five minutes
      if (!deliveredTime || __WEBPACK_IMPORTED_MODULE_1_moment___default()(deliveredTime).isBefore(timeThreshold)) {
        var userId = this.props.currentUser.id;
        var update = { mobileWelcomeDeliveryTime: __WEBPACK_IMPORTED_MODULE_1_moment___default()() };

        this.app.actions.UserActions.sendWelcomeEmail(true);
        this.app.actions.UserPropertiesActions.updateProperties(userId, update);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { height: "100vh", width: "100vw", position: "relative" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.Content + ' email-prompt' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { style: { width: 123, height: 50 }, src: __webpack_require__("0WTh") }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'dsg-medium-weight dsg-h3' },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            copy
          )
        ),
        image
      );
    }
  }]);

  return EmailPrompt;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

EmailPrompt.displayName = 'EmailPrompt';


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_components_container__["a" /* makeDefaultFailedContainer */])(EmailPrompt, {
  listenTo: ['stores.UserStore', 'stores.UserPropertiesStore'],
  fetch: {
    currentUser: function currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser();
    },
    settings: function settings() {
      return this.app.stores.UserPropertiesStore.fetchPropertiesForCurrentUser();
    }
  }
}));

/***/ }),

/***/ "xdQ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xdhv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_play_sequences_svg__ = __webpack_require__("bOpv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_play_sequences_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_play_sequences_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_email_sequences_svg__ = __webpack_require__("jYqW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_email_sequences_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_email_sequences_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_users_sequences_svg__ = __webpack_require__("5lNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_users_sequences_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_users_sequences_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_check_svg__ = __webpack_require__("A1a6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_browser_svg__ = __webpack_require__("p9DP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_browser_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_browser_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlaybookDraftToggle__ = __webpack_require__("vd8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl__ = __webpack_require__("qtEq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style_styl__);














var OutboundSequenceReview = function OutboundSequenceReview(_ref) {
  var isGmailConnected = _ref.isGmailConnected,
      onConnectGmailClick = _ref.onConnectGmailClick,
      isExtensionInstalled = _ref.isExtensionInstalled,
      onInstallExtensionClick = _ref.onInstallExtensionClick;
  return React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      { className: 'sequence-review-stacked sequence-review-item' },
      React.createElement(
        'div',
        { className: 'sequence-review-header' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeTags_true_images_svg_email_sequences_svg___default.a,
          element: 'div',
          className: 'sequence-icon-svg',
          style: {
            width: 25,
            height: 25
          } }),
        React.createElement(
          'h2',
          null,
          ' 1. Connect your Gmail account '
        ),
        isGmailConnected && React.createElement(
          'div',
          { className: 'sequence-review-gmail-connected' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_check_svg___default.a,
            element: 'div',
            style: {
              width: 15,
              height: 15,
              marginRight: 3
            } }),
          'Connected'
        )
      ),
      !isGmailConnected && React.createElement(
        'div',
        { className: 'sequence-review-content' },
        React.createElement(
          'span',
          null,
          'This is how we send your email! If the rest of your team hasn\u2019t already, encourage them to do the same. '
        ),
        React.createElement(
          'div',
          null,
          React.createElement(
            'button',
            { className: 'drift-button drift-button-secondary', onClick: onConnectGmailClick },
            'Connect'
          )
        )
      )
    ),
    React.createElement('hr', null),
    React.createElement(
      'div',
      { className: 'sequence-review-stacked sequence-review-item' },
      React.createElement(
        'div',
        { className: 'sequence-review-header' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_6__svg_inline_removeTags_true_images_svg_browser_svg___default.a,
          element: 'div',
          className: 'sequence-icon-svg',
          style: {
            width: 25,
            height: 25
          } }),
        React.createElement(
          'h2',
          null,
          ' 2. Install the Chrome extension '
        ),
        isExtensionInstalled && React.createElement(
          'div',
          { className: 'sequence-review-gmail-connected' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_5__svg_inline_removeTags_true_images_svg_check_svg___default.a,
            element: 'div',
            style: {
              width: 15,
              height: 15,
              marginRight: 3
            } }),
          'Installed'
        )
      ),
      !isExtensionInstalled && React.createElement(
        'div',
        { className: 'sequence-review-content' },
        React.createElement(
          'span',
          null,
          'The Drift Extension turns your email into a super-powered Sales Machine. Install it to start sending automated email sequences from within Salesforce and use it to track email activity (such as opens and clicks). Read more about it ',
          React.createElement(
            'a',
            { href: 'https://help.drift.com/article/using-the-drift-email-extension/', target: '_blank' },
            'here'
          ),
          '. '
        ),
        ',',
        React.createElement(
          'div',
          null,
          React.createElement(
            'button',
            { className: 'drift-button drift-button-secondary', onClick: onInstallExtensionClick },
            'Install'
          )
        )
      )
    ),
    React.createElement('hr', null),
    React.createElement(
      'div',
      { className: 'sequence-review-stacked sequence-review-item' },
      React.createElement(
        'div',
        { className: 'sequence-review-header' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_2__svg_inline_removeTags_true_images_svg_play_sequences_svg___default.a,
          element: 'div',
          className: 'sequence-icon-svg',
          style: {
            width: 25,
            height: 25
          } }),
        React.createElement(
          'h2',
          null,
          ' 3. Make this sequence available to send '
        )
      ),
      React.createElement(
        'div',
        { className: 'sequence-review-content' },
        React.createElement(
          'span',
          null,
          'Turning this on won\u2019t automatically send any emails - it just makes it so you can start enrolling leads to get this sequence. '
        ),
        React.createElement(
          'div',
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_8__PlaybookDraftToggle__["a" /* default */], null)
        )
      )
    ),
    React.createElement('hr', null),
    React.createElement(
      'div',
      { className: 'sequence-review-stacked sequence-review-item' },
      React.createElement(
        'div',
        { className: 'sequence-review-header' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_0_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_4__svg_inline_removeTags_true_images_svg_users_sequences_svg___default.a,
          element: 'div',
          className: 'sequence-icon-svg',
          style: {
            width: 25,
            height: 25
          } }),
        React.createElement(
          'h2',
          null,
          ' 4. Start sending! '
        )
      ),
      React.createElement(
        'div',
        { className: 'sequence-review-content--start-sending' },
        React.createElement(
          'span',
          null,
          'You can enroll contacts from Drift, or use our ',
          React.createElement(
            'a',
            { target: '_blank', href: __WEBPACK_IMPORTED_MODULE_7_constants_ResourcesConstants__["e" /* CHROME_EXTENSION_LINK */], rel: 'noopener noreffer' },
            ' Chrome extension '
          ),
          ' to enroll right from Salesforce or your Gmail inbox! '
        ),
        React.createElement(
          'div',
          { className: 'sequence-review-grid' },
          React.createElement(
            'div',
            null,
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
              {
                component: !isGmailConnected && React.createElement(
                  'div',
                  null,
                  'You need to connect your Gmail before ',
                  React.createElement('br', null),
                  ' you can enroll contacts in sequences'
                ) || React.createElement(
                  'div',
                  null,
                  'Select and enroll contacts right\u2028 ',
                  React.createElement('br', null),
                  ' from Drift\u2019s contact list'
                ),
                flow: 'up',
                className: 'outbound-sequence-tooltip'
              },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
                { type: 'tertiary', href: '/contacts', target: '_self', disabled: !isGmailConnected },
                'Enroll from Drift'
              )
            )
          ),
          React.createElement(
            'div',
            null,
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
              {
                component: !isGmailConnected && React.createElement(
                  'div',
                  null,
                  'You need to connect your Gmail before ',
                  React.createElement('br', null),
                  ' you can enroll contacts in sequences'
                ) || !isExtensionInstalled && React.createElement(
                  'div',
                  null,
                  'You need to install the Chrome extension before ',
                  React.createElement('br', null),
                  ' enrolling from Salesforce'
                ) || React.createElement(
                  'div',
                  null,
                  'Select and enroll contacts right ',
                  React.createElement('br', null),
                  '\u2028 from Salesforce'
                ),
                flow: 'up',
                className: 'outbound-sequence-tooltip'
              },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
                { type: 'tertiary', href: 'https://login.salesforce.com/', disabled: !isGmailConnected || !isExtensionInstalled },
                'Enroll from Salesforce'
              )
            )
          ),
          React.createElement(
            'div',
            null,
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["ToolTip"],
              {
                component: !isGmailConnected && React.createElement(
                  'div',
                  null,
                  'You need to connect your Gmail before ',
                  React.createElement('br', null),
                  ' you can enroll contacts in sequences'
                ) || !isExtensionInstalled && React.createElement(
                  'div',
                  null,
                  'You need to install the Chrome ',
                  React.createElement('br', null),
                  ' extension before enrolling from Gmail'
                ) || React.createElement(
                  'div',
                  null,
                  'Enroll prospects by their email address ',
                  React.createElement('br', null),
                  ' with the Chrome extension'
                ),
                flow: 'up',
                className: 'outbound-sequence-tooltip'
              },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_1__driftt_tide_core_legacy__["Button"],
                { type: 'tertiary', href: 'https://gmail.com', disabled: !isGmailConnected || !isExtensionInstalled },
                'Enroll from Gmail'
              )
            )
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OutboundSequenceReview);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "xfIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_keymirror__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_shared_UISelect__ = __webpack_require__("aLj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TargetConditionEditModal__ = __webpack_require__("3d7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CampaignWizards_MessageUsers_Compose_EditableArea_style__ = __webpack_require__("mHc7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_CampaignWizards_MessageUsers_Compose_EditableArea_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_CampaignWizards_MessageUsers_Compose_EditableArea_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_targeting_actions__ = __webpack_require__("hKIp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_targeting_selectors__ = __webpack_require__("bqmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style__ = __webpack_require__("aOkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__style__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ALWAYS_OPTION_ID = -1;
var defaultToAlwaysOptionId = function defaultToAlwaysOptionId(optionId) {
  return optionId || ALWAYS_OPTION_ID;
};
var defaultTargetOption = { label: 'Always', value: ALWAYS_OPTION_ID };
var targetToOption = function targetToOption(_ref) {
  var name = _ref.name,
      id = _ref.id;
  return { label: name, value: id };
};

var ModalState = new __WEBPACK_IMPORTED_MODULE_5_keymirror___default.a({
  HIDDEN: null,
  CREATE: null,
  EDIT: null
});

var TargetConditionInput = function (_Component) {
  _inherits(TargetConditionInput, _Component);

  function TargetConditionInput(props) {
    _classCallCheck(this, TargetConditionInput);

    var _this = _possibleConstructorReturn(this, (TargetConditionInput.__proto__ || Object.getPrototypeOf(TargetConditionInput)).call(this, props));

    _this.handleSaveTargetCondition = function (value) {
      _this.props.onSelection(value, true);
      _this.props.actions.fetchTargets();
    };

    _this.handleSelection = function (option) {
      _this.props.onSelection(option.value, false);
    };

    _this.setModalState = function (modalState) {
      return function () {
        _this.setState({ modalState: modalState });
      };
    };

    _this.renderSelectOption = function (_ref2) {
      var label = _ref2.label;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'span',
        { className: 'targeting-dropdown-option' },
        label
      );
    };

    _this.state = {
      plainTargets: props.plainTargets,
      modalState: ModalState.HIDDEN
    };
    return _this;
  }

  _createClass(TargetConditionInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchTargets();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var justCreatedTargetId = nextProps.lastCreatedTargetId;
      if (this.props.lastCreatedTargetId != justCreatedTargetId) {
        this.handleSelection({ value: justCreatedTargetId });
      }

      if (this.props.plainTargets !== nextProps.plainTargets) {
        this.setState({
          plainTargets: nextProps.plainTargets
        });
      }
    }
  }, {
    key: 'resolveTargetOptions',
    value: function resolveTargetOptions() {
      var plainTargets = this.state.plainTargets;
      var filterPlaybookTargets = this.props.filterPlaybookTargets;

      var options = _.map(plainTargets, targetToOption);
      if (filterPlaybookTargets) {
        var filteredOptions = options.filter(function (option) {
          return !!option.label && !(option.label.startsWith('playbook-') || option.label.startsWith('leadbot-playbook-'));
        });
        return [defaultTargetOption].concat(_toConsumableArray(filteredOptions));
      } else {
        return [defaultTargetOption].concat(_toConsumableArray(options));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedTargetId = _props.selectedTargetId,
          className = _props.className,
          style = _props.style;

      var targetOptions = this.resolveTargetOptions();

      var selectOptions = {
        multi: false,
        autoFocus: true,
        search: true,
        options: targetOptions,
        pageSize: 6,
        optionRenderer: this.renderSelectOption,
        onChange: this.handleSelection,
        value: defaultToAlwaysOptionId(selectedTargetId)
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          key: 'targetCondition',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_9_components_CampaignWizards_MessageUsers_Compose_EditableArea_style___default.a.InputWrapper, className),
          style: style },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'flex-space-between' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'label',
            { className: 'dsg-Label color-navy-dark' },
            'display when'
          ),
          this.renderActionLinks()
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'targeting-dropdown' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_shared_UISelect__["b" /* default */], selectOptions)
        ),
        this.renderModal()
      );
    }
  }, {
    key: 'renderActionLinks',
    value: function renderActionLinks() {
      var selectedTargetId = this.props.selectedTargetId;

      var editLink = void 0;

      if (!!selectedTargetId) {
        editLink = [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { style: { margin: "0 0.5rem" } },
          ' | '
        ), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            onClick: this.setModalState(ModalState.EDIT),
            className: 'link dsg-Regular'
          },
          'Edit'
        )];
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'flex', style: { alignItems: "center" } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          {
            onClick: this.setModalState(ModalState.CREATE),
            className: 'link dsg-Regular' },
          'Create New'
        ),
        editLink
      );
    }
  }, {
    key: 'renderModal',
    value: function renderModal() {
      var _this2 = this;

      var _props2 = this.props,
          org = _props2.org,
          plainTargets = _props2.plainTargets;
      var modalState = this.state.modalState;

      if (modalState === ModalState.HIDDEN) return;
      var editTarget = modalState === ModalState.EDIT ? Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["find"])(plainTargets, function (target) {
        return target.id === _this2.props.selectedTargetId;
      }) : undefined;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TargetConditionEditModal__["a" /* default */], {
        org: org,
        targets: plainTargets,
        onSave: this.handleSaveTargetCondition,
        onClose: this.setModalState(ModalState.HIDDEN),
        editTarget: editTarget
      });
    }
  }]);

  return TargetConditionInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TargetConditionInput.propTypes = {
  /*
   * This function should have the signature (value, edited) => ()
   * `value` is the target selected
   * `edited` is whether that target has been modified
   *
   * This allows notifying the parent component whether the campaign needs
   * to be republished due to changes to the targeting conditions
   */
  onSelection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchTargets: __WEBPACK_IMPORTED_MODULE_10_app_modules_targeting_actions__["e" /* fetchTargets */]
    }, dispatch)
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    plainTargets: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_targeting_selectors__["a" /* byId */])(state).toJS(),
    lastCreatedTargetId: Object(__WEBPACK_IMPORTED_MODULE_11_app_modules_targeting_selectors__["b" /* lastCreatedTargetId */])(state),
    org: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_org_selectors__["org"])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(TargetConditionInput));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("M4fF")))

/***/ }),

/***/ "xjUl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+U2VhcmNoPC90aXRsZT48cGF0aCBkPSJNMTguMTEgMTYuNDc2bC00LjI2My00LjI2NGMtLjEtLjEtLjIyNC0uMTYzLS4zNDUtLjIzYTcuMzkgNy4zOSAwIDEgMC0xLjk3MyAxLjk3M2MuMDY1LjEyMy4xMjYuMjQ2LjIzLjM0OGw0LjI2IDQuMjY0YTEuNDc4IDEuNDc4IDAgMCAwIDIuMDktMi4wOXpNNy4zODQgMTMuMjU4YTUuNDIgNS40MiAwIDEgMSAuMDAyLTEwLjg0IDUuNDIgNS40MiAwIDAgMS0uMDAyIDEwLjg0eiIgZmlsbD0iI0NDQyIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+"

/***/ }),

/***/ "xlyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("XLbe");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("Qj5x");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });




/***/ }),

/***/ "xmI2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xmq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("sb0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);



var EmailCaptureCloseButton = function EmailCaptureCloseButton() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'playbook-preview-email-capture-close' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      { width: 16, height: 16, viewBox: '0 0 23 23', fill: 'none' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: '#687882',
        d: 'M9.34583 11.2L0.384011 2.23818C-0.128004 1.72617 -0.128004 0.896026 0.384011 0.384011C0.896026 -0.128004 1.72617 -0.128004 2.23818 0.384011L11.2 9.34583L20.1618 0.384011C20.6738 -0.128004 21.504 -0.128004 22.016 0.384011C22.528 0.896026 22.528 1.72617 22.016 2.23818L13.0542 11.2L22.016 20.1618C22.528 20.6738 22.528 21.504 22.016 22.016C21.504 22.528 20.6738 22.528 20.1618 22.016L11.2 13.0542L2.23818 22.016C1.72617 22.528 0.896026 22.528 0.384011 22.016C-0.128003 21.504 -0.128003 20.6738 0.384011 20.1618L9.34583 11.2Z'
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (EmailCaptureCloseButton);

/***/ }),

/***/ "xoR/":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M29.642 29.725c-.177.183-.41.275-.64.275-.233 0-.465-.092-.642-.275l-8.018-8.293c-2.062 1.83-4.735 2.943-7.657 2.943C6.185 24.375.9 18.907.9 12.187.9 5.468 6.186 0 12.685 0c6.498 0 11.783 5.468 11.783 12.188 0 3.023-1.075 5.787-2.844 7.92l8.018 8.292c.354.366.354.96 0 1.325zm-6.987-17.538c0-5.685-4.472-10.312-9.97-10.312-5.5 0-9.972 4.627-9.972 10.313 0 5.685 4.473 10.312 9.972 10.312 5.498 0 9.97-4.627 9.97-10.313zm-5.44 5.618H8.153c-1 0-1.813-.84-1.813-1.875v-.938c0-.046.018-.088.025-.134.01-.066.015-.132.04-.196.02-.057.053-.105.085-.157.03-.05.055-.1.095-.145.045-.05.1-.087.158-.127.034-.025.06-.06.1-.08l2.718-1.395c-.504-1.073-.51-2.114-.498-2.42 0-.007-.004-.012-.004-.018l.002-2.813c0-.03.013-.05.015-.078.003-.034-.007-.065 0-.097.01-.063.038-.117.054-.177 0-.007.002-.013.005-.02.403-1.507 2.11-2.44 3.55-2.44h.005c1.438 0 3.14.932 3.544 2.44.002.007.003.014.006.02.015.06.043.115.055.177.005.033-.004.064-.002.096.002.026.015.05.015.077l.002 2.813c0 .006-.004.01-.004.018.012.305.006 1.34-.495 2.412l2.718 1.404c.04.02.067.057.103.083.055.038.11.074.155.124.04.046.065.096.095.148.03.05.065.098.085.156.023.063.03.13.04.196.005.045.025.086.025.133v.937c0 1.034-.814 1.875-1.814 1.875zm-3.007-3.787c-.04-.015-.074-.04-.112-.06h-.006c0-.002-.002-.003-.004-.004-.063-.034-.13-.064-.185-.115-.028-.027-.042-.063-.067-.092-.02-.023-.038-.05-.056-.075-.05-.07-.09-.14-.12-.217-.015-.043-.022-.086-.032-.13-.014-.067-.026-.13-.026-.197-.002-.067.01-.13.023-.194.01-.05.02-.095.036-.142.01-.032.01-.065.025-.096.025-.052.068-.088.1-.134.01-.015.015-.032.027-.046.755-.9.683-2.114.683-2.126 0-.018.006-.034.006-.05 0-.01-.003-.014-.003-.02l-.002-2.675c-.122-.493-.955-1.077-1.81-1.077-.857 0-1.69.585-1.812 1.078l-.002 2.673c0 .008-.002.012-.003.02 0 .018.008.033.007.052-.002.03-.068 1.234.68 2.126.028.03.037.07.06.103.02.034.05.058.07.095.01.022.008.044.016.066.025.062.037.122.048.186.01.058.02.113.02.17 0 .06-.01.118-.023.177-.01.06-.022.116-.044.17-.02.055-.05.102-.082.152-.033.054-.068.105-.113.15-.015.018-.022.04-.04.055-.034.03-.076.044-.113.07-.028.018-.047.047-.078.063l-3.122 1.6v.357h9.064v-.358l-3.008-1.554z\" fill=\"#7695A5\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "xpCh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xq94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking__ = __webpack_require__("ZL5f");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
    track: __WEBPACK_IMPORTED_MODULE_3_app_modules_tracking__["a" /* actions */].track
  }, dispatch));
};

var withTracking = function withTracking(WrappedComponent) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(null, mapDispatchToProps))(WrappedComponent);
};

/* harmony default export */ __webpack_exports__["a"] = (withTracking);

/***/ }),

/***/ "xv13":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("Cr9k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__("Bdop");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_org_actions__ = __webpack_require__("CR44");










var mapStateToProps = function mapStateToProps(state) {
  return {
    usersAndProperties: Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* usersAndProperties */])(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      sendExistingUsersInvitationsViaEmail: __WEBPACK_IMPORTED_MODULE_6_app_modules_org_actions__["sendExistingUsersInvitationsViaEmail"],
      sendInvitationsViaEmail: __WEBPACK_IMPORTED_MODULE_6_app_modules_org_actions__["sendInvitationsViaEmail"]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  sendExistingUsersInvitationsViaEmail: function sendExistingUsersInvitationsViaEmail(props) {
    return function (userId) {
      var sendExistingUsersInvitationsViaEmail = props.actions.sendExistingUsersInvitationsViaEmail;

      sendExistingUsersInvitationsViaEmail(userId);
    };
  },
  sendInvitationsViaEmail: function sendInvitationsViaEmail(props) {
    return function (email) {
      var sendInvitationsViaEmail = props.actions.sendInvitationsViaEmail;

      sendInvitationsViaEmail({ user: { email: email }, properties: { extensionInvited: true } });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),

/***/ "xwdT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__ = __webpack_require__("zMog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__ = __webpack_require__("waKz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__ = __webpack_require__("60ou");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TranslationActions = function (_Marty$ActionCreators) {
  _inherits(TranslationActions, _Marty$ActionCreators);

  function TranslationActions() {
    _classCallCheck(this, TranslationActions);

    return _possibleConstructorReturn(this, (TranslationActions.__proto__ || Object.getPrototypeOf(TranslationActions)).apply(this, arguments));
  }

  _createClass(TranslationActions, [{
    key: 'loadTranslations',
    value: function loadTranslations(locale) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        switch (locale) {
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].en.key:
            __webpack_require__.e/* require.ensure */(85).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("iQgp"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].es.key:
            __webpack_require__.e/* require.ensure */(84).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("bhOh"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].et.key:
            __webpack_require__.e/* require.ensure */(83).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("nqhX"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].de.key:
            __webpack_require__.e/* require.ensure */(86).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("U2v0"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case 'de-DE-formal':
            __webpack_require__.e/* require.ensure */(31).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("hQCP"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].hi.key:
            __webpack_require__.e/* require.ensure */(80).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("UrNP"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].nl.key:
            __webpack_require__.e/* require.ensure */(71).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("oLmp"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].pt.key:
            __webpack_require__.e/* require.ensure */(68).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("ysOz"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case 'pt-BR':
            __webpack_require__.e/* require.ensure */(69).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("6S42"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].sv.key:
            __webpack_require__.e/* require.ensure */(63).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("F7UP"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].zh.key:
            __webpack_require__.e/* require.ensure */(59).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("W42z"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].fr.key:
            __webpack_require__.e/* require.ensure */(81).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("tIbX"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].it.key:
            __webpack_require__.e/* require.ensure */(76).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("54X/"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].tr.key:
            __webpack_require__.e/* require.ensure */(61).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("mtQw"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].ru.key:
            __webpack_require__.e/* require.ensure */(66).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("73fc"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].pl.key:
            __webpack_require__.e/* require.ensure */(70).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("ILZc"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].sl.key:
            __webpack_require__.e/* require.ensure */(65).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("XqrM"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].da.key:
            __webpack_require__.e/* require.ensure */(87).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("jWch"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].fi.key:
            __webpack_require__.e/* require.ensure */(82).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("OfKc"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;

          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].hr.key:
            __webpack_require__.e/* require.ensure */(79).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("zzCf"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].ko.key:
            __webpack_require__.e/* require.ensure */(73).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("jTbj"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].nb.key:
            __webpack_require__.e/* require.ensure */(72).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("6at8"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].ro.key:
            __webpack_require__.e/* require.ensure */(67).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("ivCU"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].sr.key:
            __webpack_require__.e/* require.ensure */(64).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("bHjh"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].th.key:
            __webpack_require__.e/* require.ensure */(62).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("/rzV"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].vi.key:
            __webpack_require__.e/* require.ensure */(60).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("IGx1"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].hu.key:
            __webpack_require__.e/* require.ensure */(78).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("HnTA"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].is.key:
            __webpack_require__.e/* require.ensure */(77).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("2DMo"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].ja.key:
            __webpack_require__.e/* require.ensure */(75).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("E48A"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          case __WEBPACK_IMPORTED_MODULE_1_components_I18n_Constants__["b" /* Locales */].ka.key:
            __webpack_require__.e/* require.ensure */(74).then((function (require) {
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_0_constants_TranslationConstants__["a" /* default */].TRANSLATION_LOADED, locale, __webpack_require__("379Q"));
              resolve();
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            break;
          default:
            var error = new Error('Requested messages for invalid locale ' + locale);
            Object(__WEBPACK_IMPORTED_MODULE_2_utils_SentryHelpers__["a" /* captureException */])(error);
            reject(error);
        }
      });
    }
  }]);

  return TranslationActions;
}(Marty.ActionCreators);

/* harmony default export */ __webpack_exports__["default"] = (TranslationActions);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "xyK/":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 243 62\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#1F8DED\" fill-rule=\"evenodd\"><path d=\"M82.74 39.95v-17.9c0-1.12.912-2.03 2.04-2.03 1.128 0 2.042.91 2.042 2.03v17.9c0 1.12-.914 2.03-2.042 2.03-1.127 0-2.04-.91-2.04-2.03M105.76 40.74l-8.784-13.844v13.116c0 1.086-.886 1.967-1.98 1.967-1.092 0-1.978-.882-1.978-1.968V22.675c0-1.466 1.196-2.654 2.67-2.654h.127c.917 0 1.77.468 2.26 1.238l8.658 13.628v-12.9c0-1.085.886-1.965 1.98-1.965 1.092 0 1.978.88 1.978 1.967v17.338c0 1.465-1.195 2.654-2.67 2.654-.918 0-1.77-.47-2.26-1.24M124.812 23.737V40.12c0 1.027-.837 1.86-1.87 1.86h-.28c-1.033 0-1.87-.833-1.87-1.86V23.738h-4.677c-1.032 0-1.87-.832-1.87-1.858 0-1.027.838-1.86 1.87-1.86h13.373c1.033 0 1.87.833 1.87 1.86 0 1.025-.837 1.857-1.87 1.857h-4.676M134.593 40.183V21.817c0-.992.81-1.796 1.808-1.796h12.126c.998 0 1.808.805 1.808 1.797v.03c0 .993-.81 1.797-1.808 1.797h-9.913v5.11h8.51c.998 0 1.808.804 1.808 1.797 0 .993-.81 1.797-1.807 1.797h-8.51v6.008h9.913c.998 0 1.808.805 1.808 1.797v.03c0 .993-.81 1.797-1.808 1.797H136.4c-.998 0-1.807-.805-1.807-1.797M164.508 23.52h-5.3v6.566h5.362c2.276 0 3.585-1.176 3.585-3.252 0-1.765-1.372-3.314-3.647-3.314zm2.782 17.28l-3.156-7.12h-4.894v6.325c0 1.09-.89 1.974-1.987 1.974h-.078c-1.098 0-1.987-.885-1.987-1.975v-18.01c0-1.09.89-1.974 1.987-1.974h7.333c5.268 0 7.668 3.284 7.668 6.814 0 2.943-1.62 5.265-4.052 6.163l2.797 6.2c.59 1.307-.37 2.782-1.812 2.782-.788 0-1.5-.463-1.818-1.18zM191.267 39.78c-1.652 1.673-3.958 2.602-6.327 2.602-2.37 0-4.582-.775-6.265-2.447-2.4-2.385-2.743-5.327-2.743-8.92 0-3.592.342-6.534 2.743-8.92 1.683-1.672 3.896-2.477 6.265-2.477 2.37 0 4.675.867 6.327 2.54.577.586 1.026 1.26 1.363 1.984.606 1.3-.373 2.785-1.815 2.785h-.01c-.81 0-1.52-.496-1.843-1.236-.168-.386-.4-.736-.687-1.085-.717-.9-1.964-1.363-3.335-1.363-1.28 0-2.525.526-3.398 1.455-1.527 1.58-1.527 4.305-1.527 6.319 0 2.012 0 4.738 1.527 6.317.873.93 2.12 1.456 3.398 1.456 1.37 0 2.618-.496 3.335-1.395.29-.352.522-.73.69-1.143.31-.76 1.033-1.273 1.858-1.273 1.44 0 2.414 1.477 1.818 2.78-.337.737-.79 1.427-1.373 2.02M209.996 24.697c-.873-.93-2.213-1.455-3.49-1.455-1.28 0-2.62.526-3.493 1.455-1.527 1.58-1.59 4.305-1.59 6.319 0 2.012.063 4.707 1.59 6.286.873.93 2.214 1.456 3.492 1.456s2.618-.526 3.49-1.456c1.528-1.58 1.59-4.274 1.59-6.287s-.062-4.738-1.59-6.318zm2.868 15.207c-1.684 1.672-3.99 2.478-6.36 2.478-2.368 0-4.675-.806-6.358-2.478-2.4-2.385-2.805-5.296-2.805-8.89 0-3.59.406-6.533 2.806-8.918 1.683-1.673 3.99-2.478 6.358-2.478 2.37 0 4.676.805 6.36 2.478 2.4 2.385 2.805 5.327 2.805 8.92 0 3.592-.406 6.503-2.806 8.888zM238.96 40.043V26.308l-5.223 13.986c-.308.827-1.1 1.375-1.99 1.375-.89 0-1.688-.555-1.993-1.387l-5.195-14.16v13.92c0 1.07-.873 1.936-1.95 1.936-1.075 0-1.947-.868-1.947-1.937v-17.01c0-1.663 1.357-3.012 3.032-3.012h.276c1.272 0 2.408.788 2.847 1.972l5.067 13.67 5.096-13.674c.44-1.182 1.575-1.967 2.843-1.967 1.675 0 3.033 1.35 3.033 3.014v17.01c0 1.068-.872 1.935-1.948 1.935s-1.948-.868-1.948-1.937M54.08 34.088c0 1.14-.93 2.066-2.08 2.066s-2.08-.925-2.08-2.066V15.5c0-1.14.93-2.067 2.08-2.067s2.08.926 2.08 2.067v18.588zm-.726 12.935c-.32.274-8.027 6.698-22.154 6.698S9.368 47.298 9.046 47.024c-.872-.743-.973-2.047-.225-2.914.747-.866 2.056-.968 2.93-.23.12.102 7.002 5.708 19.45 5.708 12.605 0 19.38-5.646 19.446-5.703.87-.743 2.186-.643 2.933.224.747.866.647 2.17-.226 2.913zM8.32 15.5c0-1.14.93-2.067 2.08-2.067s2.08.926 2.08 2.067v18.588c0 1.14-.93 2.066-2.08 2.066s-2.08-.925-2.08-2.066V15.5zm10.4-4.133c0-1.142.93-2.067 2.08-2.067s2.08.925 2.08 2.067v27.61c0 1.14-.93 2.066-2.08 2.066s-2.08-.925-2.08-2.067v-27.61zm10.4-1.046c0-1.14.93-2.066 2.08-2.066s2.08.926 2.08 2.067V40.29c0 1.14-.93 2.066-2.08 2.066s-2.08-.925-2.08-2.066V10.32zm10.4 1.047c0-1.142.93-2.067 2.08-2.067s2.08.925 2.08 2.067v27.61c0 1.14-.93 2.066-2.08 2.066s-2.08-.925-2.08-2.067v-27.61zM54.6 0H7.8C3.492 0 0 3.47 0 7.75v46.5C0 58.53 3.492 62 7.8 62h46.8c4.308 0 7.8-3.47 7.8-7.75V7.75C62.4 3.47 58.908 0 54.6 0z\"></path></g></svg>"

/***/ }),

/***/ "xyae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__ = __webpack_require__("JSzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("aKBy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var DriftModal = function DriftModal(_ref) {
  var onRequestClose = _ref.onRequestClose,
      onSecondaryClick = _ref.onSecondaryClick,
      onPrimaryClick = _ref.onPrimaryClick,
      isDanger = _ref.isDanger,
      title = _ref.title,
      children = _ref.children,
      primaryCTA = _ref.primaryCTA,
      secondaryCTA = _ref.secondaryCTA,
      hidePrimary = _ref.hidePrimary,
      modalProps = _objectWithoutProperties(_ref, ['onRequestClose', 'onSecondaryClick', 'onPrimaryClick', 'isDanger', 'title', 'children', 'primaryCTA', 'secondaryCTA', 'hidePrimary']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_components_shared_Modal__["a" /* default */],
    _extends({
      style: {
        content: {
          padding: 0,
          backgroundColor: 'transparent',
          border: 'none'
        }
      },
      onRequestClose: onRequestClose
    }, modalProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__style_styl___default.a.DriftModal, 'dsg-card', { 'hide-primary': hidePrimary }) },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'content' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'dsg-h3' },
          title
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          { className: 'dsg-Body color-navy-extra-dark' },
          children
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: onSecondaryClick,
            className: 'drift-button large'
          },
          secondaryCTA
        ),
        !hidePrimary && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          {
            onClick: onPrimaryClick,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('drift-button', 'large', {
              'drift-button-danger': isDanger,
              'drift-button-primary': !isDanger
            })
          },
          primaryCTA
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (DriftModal);

/***/ }),

/***/ "xyiN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"WelcomeMessageCard":"WelcomeMessageCard---14_c_"};

/***/ }),

/***/ "y1me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y4Mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SingleParticipantAction__ = __webpack_require__("X3Bt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GroupParticipantAction__ = __webpack_require__("hkqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TeamParticipantAction__ = __webpack_require__("zaxl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_constants__ = __webpack_require__("T1OH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__("fi0M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_teams_hoc_withOrgTeams__ = __webpack_require__("SDtC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style__ = __webpack_require__("sWvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__style__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ParticipantActions = function (_PureComponent) {
  _inherits(ParticipantActions, _PureComponent);

  function ParticipantActions(props) {
    _classCallCheck(this, ParticipantActions);

    var _this = _possibleConstructorReturn(this, (ParticipantActions.__proto__ || Object.getPrototypeOf(ParticipantActions)).call(this, props));

    _this.getParticipantTypeFromAction = function () {
      var action = _this.props.rule.data.item.action;

      if (action.options.teamId) {
        return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].TEAM;
      } else if (action.options.userIds.length === 1) {
        return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].SINGLE;
      } else if (action.options.userIds.length > 1) {
        return __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].GROUP;
      }
    };

    _this.onParticipantTypeChanged = function (selectedOption) {
      _this.setState({ selectedValue: selectedOption.value });
    };

    _this.setActionParticipants = function (_ref) {
      var participants = _ref.participants,
          participantType = _ref.participantType;
      var _this$props = _this.props,
          setPageValidity = _this$props.setPageValidity,
          updateAction = _this$props.updateAction;
      var action = _this.props.rule.data.item.action;


      if (participantType === __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].SINGLE || participantType === __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].GROUP) {
        var isValid = action.options.addType && participants.length > 0;
        setPageValidity(isValid);

        if (isValid) {
          updateAction({
            type: __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_constants__["a" /* ACTION_TYPES */].PARTICIPANT,
            options: {
              isAccountOwner: true,
              addType: action.options.addType,
              userIds: participants
            }
          });
        }
      }

      if (participantType === __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].TEAM) {
        var _isValid = !!participantType && participants.length > 0;

        setPageValidity(_isValid);

        if (_isValid) {
          updateAction({
            type: __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_constants__["a" /* ACTION_TYPES */].PARTICIPANT,
            options: {
              isAccountOwner: true,
              addType: __WEBPACK_IMPORTED_MODULE_6_app_modules_rules_constants__["G" /* PARTICIPANT_ADD_TYPES */].ONE,
              teamId: participants[0]
            }
          });
        }
      }
    };

    _this.renderSelectOption = function (_ref2) {
      var label = _ref2.label,
          value = _ref2.value;

      var iconName = value === __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].SINGLE ? 'user-circle' : 'team-2';

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'participant-type-dropdown-option' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Icon"], { height: 14, width: 14, name: iconName }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          label
        )
      );
    };

    _this.renderParticipantActionType = function () {
      var selectedValue = _this.state.selectedValue;


      switch (selectedValue) {
        case __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].SINGLE:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SingleParticipantAction__["a" /* default */], _extends({}, _this.props, { setActionParticipants: _this.setActionParticipants }));
        case __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].GROUP:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__GroupParticipantAction__["a" /* default */], _extends({}, _this.props, { setActionParticipants: _this.setActionParticipants }));
        case __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].TEAM:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TeamParticipantAction__["a" /* default */], _extends({}, _this.props, { setActionParticipants: _this.setActionParticipants }));
        default:
          return null;
      }
    };

    _this.state = {
      selectedValue: _this.getParticipantTypeFromAction() || __WEBPACK_IMPORTED_MODULE_7__constants__["a" /* PARTICIPANT_TYPES */].SINGLE
    };
    return _this;
  }

  _createClass(ParticipantActions, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'participant-actions' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Choose participants to add'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Select which teammate(s) you want to add to a conversation as a participant.'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'participant-action-selector' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'participant-action-selector-description' },
            'How do you want to add participants?'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
            multi: false,
            options: __WEBPACK_IMPORTED_MODULE_7__constants__["b" /* PARTICIPANT_TYPE_OPTIONS */],
            optionRenderer: this.renderSelectOption,
            valueRenderer: this.renderSelectOption,
            onChange: this.onParticipantTypeChanged,
            autoFocus: true,
            clearable: false,
            value: this.state.selectedValue
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Automatically add one user or account owner to each new conversation. If you choose a team, one member from the team will automatically be added to each conversation. '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          this.renderParticipantActionType()
        )
      );
    }
  }]);

  return ParticipantActions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_8_app_modules_teams_hoc_withOrgTeams__["a" /* default */])(ParticipantActions));

/***/ }),

/***/ "y53j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__ = __webpack_require__("y8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__("jjhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__ = __webpack_require__("CpSP");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ShopifyInstaller = function (_Component) {
  _inherits(ShopifyInstaller, _Component);

  function ShopifyInstaller() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ShopifyInstaller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ShopifyInstaller.__proto__ || Object.getPrototypeOf(ShopifyInstaller)).call.apply(_ref, [this].concat(args))), _this), _this.handleConnect = function () {
      Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* popUp */])({ path: __WEBPACK_IMPORTED_MODULE_3_constants_ResourcesConstants__["X" /* SHOPIFY_INTEGRATION_URL */] });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ShopifyInstaller, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'Install Drift on your Shopify store with one click. Connect and authorize Shopify to embed Drift chat in your Shopify store.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_ConnectLink__["a" /* default */], { handleConnect: this.handleConnect, connectorType: 'button', buttonType: 'tertiary' })
      );
    }
  }]);

  return ShopifyInstaller;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ShopifyInstaller);

/***/ }),

/***/ "y5US":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GoalRoutingModalContent":"GoalRoutingModalContent---Tu48d","GoalRoutingModalHeader":"GoalRoutingModalHeader---2Psmr"};

/***/ }),

/***/ "y7VK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epic__ = __webpack_require__("H7KV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__epic__["a"]; });


/***/ }),

/***/ "y7ir":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---1qs36"};

/***/ }),

/***/ "y8q7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl__ = __webpack_require__("ndOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CARET_SRC = __webpack_require__("kUVr");

var ConnectLink = function (_Component) {
  _inherits(ConnectLink, _Component);

  function ConnectLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConnectLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectLink.__proto__ || Object.getPrototypeOf(ConnectLink)).call.apply(_ref, [this].concat(args))), _this), _this.renderButton = function () {
      var _this$props = _this.props,
          handleConnect = _this$props.handleConnect,
          label = _this$props.label,
          buttonType = _this$props.buttonType,
          tooltipText = _this$props.tooltipText,
          isDisabled = _this$props.isDisabled;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["ToolTip"],
        {
          flow: 'right',
          hover: !!tooltipText,
          component: tooltipText },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__driftt_tide_core_legacy__["Button"],
          {
            type: buttonType,
            onClick: handleConnect,
            disabled: isDisabled
          },
          label
        )
      );
    }, _this.renderLink = function () {
      var _this$props2 = _this.props,
          handleConnect = _this$props2.handleConnect,
          label = _this$props2.label;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'flex ' + __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.IntegrationLink + ' ' + __WEBPACK_IMPORTED_MODULE_1__style_styl___default.a.IntegrationControl + ' connect-account',
          onClick: handleConnect },
        label,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'i',
          { className: 'connect-caret' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: CARET_SRC })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConnectLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          connectorType = _props.connectorType,
          className = _props.className;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: className },
        connectorType == 'button' ? this.renderButton() : this.renderLink()
      );
    }
  }]);

  return ConnectLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectLink.defaultProps = {
  label: 'Connect Account',
  buttonType: ''
};
/* harmony default export */ __webpack_exports__["a"] = (ConnectLink);

/***/ }),

/***/ "yC2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_models__ = __webpack_require__("aCE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_user_properties_actions__ = __webpack_require__("+65o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_app_modules_user_properties_selectors__ = __webpack_require__("VZhT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component__ = __webpack_require__("2XIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_app_modules_access_api__ = __webpack_require__("T2nj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_api__ = __webpack_require__("a5br");


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




















var usersWithExtension = __WEBPACK_IMPORTED_MODULE_10_app_modules_user_properties_selectors__["f" /* makeUsersWithProperty */]('extensionInstalled');

var mapStateToProps = function mapStateToProps(state) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__["v" /* theme */](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["randomAndOrgUsersAlphabetical"](state),
    welcomeMessage: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_106" /* welcomeMessage */](state),
    isOutboundPlaybook: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_44" /* isOutboundPlaybook */](state),
    isABMPlaybook: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_selectors__["_28" /* isABMPlaybook */](state),
    usersWithExtension: usersWithExtension(state),
    isOutreachConnected: __WEBPACK_IMPORTED_MODULE_11_app_modules_integrations_selectors__["l" /* isConnectedTo */](state, 'outreach')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      setMessage: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_181" /* setMessage */],
      setVideoUrl: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_222" /* setVideoUrl */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_138" /* setAuthorId */],
      fetchUsersByPropertyName: __WEBPACK_IMPORTED_MODULE_9_app_modules_user_properties_actions__["e" /* fetchUsersByPropertyName */],
      showExtensionInviteModal: __WEBPACK_IMPORTED_MODULE_4_app_modules_playbook_actions__["_231" /* showExtensionInviteModal */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["a" /* branch */])(function (_ref) {
  var theme = _ref.theme,
      orgUsers = _ref.orgUsers;
  return !theme || !orgUsers.size;
}, __WEBPACK_IMPORTED_MODULE_3_recompose__["g" /* renderNothing */]), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["k" /* withStateHandlers */])(function (props) {
  return {
    videoUrlInput: !Object(__WEBPACK_IMPORTED_MODULE_13_ramda__["isNil"])(props.welcomeMessage.videoUrl) ? props.welcomeMessage.videoUrl : '',
    videoEmbed: null,
    videoCutoverStatus: null
  };
}, {
  setVideoUrlInput: function setVideoUrlInput() {
    return function (videoUrlInput) {
      return {
        videoUrlInput: videoUrlInput
      };
    };
  },
  setVideoEmbed: function setVideoEmbed() {
    return function (videoEmbed) {
      return {
        videoEmbed: videoEmbed
      };
    };
  },
  setVideoCutoverStatus: function setVideoCutoverStatus() {
    return function (videoCutoverStatus) {
      return {
        videoCutoverStatus: videoCutoverStatus
      };
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["d" /* lifecycle */])({
  componentDidMount: function componentDidMount() {
    var _this = this;

    return _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.isOutboundPlaybook) {
                _this.props.actions.fetchUsersByPropertyName(['extensionInvited', 'extensionInstalled']);
              }

              if (!Object(__WEBPACK_IMPORTED_MODULE_13_ramda__["isNil"])(_this.props.videoCutoverStatus)) {
                _context.next = 10;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_14_app_modules_access_api__["b" /* getVideoWelcomeMessageCutover */])().then(function (data) {
                _this.props.setVideoCutoverStatus(data.VIDEO_WELCOME_MESSAGE);
              });

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](2);

              console.warn('Failed to fetch cutover status');

            case 10:
              if (Object(__WEBPACK_IMPORTED_MODULE_13_ramda__["isNil"])(_this.props.welcomeMessage.videoUrl)) {
                _context.next = 19;
                break;
              }

              _context.prev = 11;
              _context.next = 14;
              return Object(__WEBPACK_IMPORTED_MODULE_15_app_modules_conversation_api__["e" /* getIframelyVideoEmbed */])(_this.props.welcomeMessage.videoUrl).then(function (data) {
                _this.props.setVideoEmbed(!Object(__WEBPACK_IMPORTED_MODULE_13_ramda__["isNil"])(data.embed) ? data.embed : null);
              });

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t1 = _context['catch'](11);

              console.warn('Failed to fetch embed for ' + _this.props.welcomeMessage.videoUrl);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 7], [11, 16]]);
    }))();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    userObjForAuthor: props.orgUsers.find(function (user) {
      return user.id === props.welcomeMessage.authorId;
    })
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["i" /* withProps */])(function (props) {
  return {
    foregroundColor: props.theme.get('foregroundColor'),
    backgroundColor: props.theme.get('backgroundColor'),
    message: props.welcomeMessage.message,
    videoUrl: props.welcomeMessage.videoUrl,
    cta: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_models__["d" /* Cta */](props.welcomeMessage.cta),
    selectedUser: props.userObjForAuthor
  };
}), Object(__WEBPACK_IMPORTED_MODULE_3_recompose__["h" /* withHandlers */])({
  onMessageChange: function onMessageChange(props) {
    return function (message) {
      props.actions.setMessage(message);
    };
  },
  onUserIdChange: function onUserIdChange(props) {
    return function (option) {
      option && props.actions.setAuthorId(option.value);
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_12__component__["a" /* default */]));

/***/ }),

/***/ "yCoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__("pYVT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__ = __webpack_require__("ORvj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps__ = __webpack_require__("nZky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_withProps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__("De0Z");











var mapStateToProps = function mapStateToProps(state) {
  var question = __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["N" /* getCurrentQuestionByAnswer */](state);
  return {
    questionIndex: question && __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_14" /* getQuestionIndex */](state, { id: question.id }),
    answer: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["J" /* getCurrentAnswer */](state),
    isEmailCaptureQuestion: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_36" /* isEmailCaptureQuestion */](state, question),
    isPhoneCaptureQuestion: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_45" /* isPhoneCaptureQuestion */](state, question)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      hideAnswerModal: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_76" /* hideAnswerModal */],
      setResponse: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_188" /* setResponse */],
      flagAnswer: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_66" /* flagAnswer */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), __WEBPACK_IMPORTED_MODULE_4_recompose_withProps___default()(function (props) {
  return {
    targetCopy: props.isEmailCaptureQuestion ? 'email address' : props.isPhoneCaptureQuestion ? 'phone number' : 'response',
    shortTargetCopy: props.isEmailCaptureQuestion ? 'email' : props.isPhoneCaptureQuestion ? 'phone number' : 'response'
  };
}), __WEBPACK_IMPORTED_MODULE_3_recompose_withHandlers___default()({
  onCloseClick: function onCloseClick(props) {
    return function () {
      var hideAnswerModal = props.actions.hideAnswerModal;

      hideAnswerModal();
    };
  },
  onResponseChange: function onResponseChange(props) {
    return function (value) {
      var setResponse = props.actions.setResponse,
          answerId = props.answer.id;

      setResponse({ answerId: answerId, response: value });
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),

/***/ "yLox":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cal-connect.1b13703a.png";

/***/ }),

/***/ "yOq8":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 124 120\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M38.919.404H14.155a2.246 2.246 0 0 0-2.24 2.238v12.27c0 1.229.997 2.227 2.228 2.227h22.463l3.291 3.36a.728.728 0 0 0 1.249-.509V2.631c0-1.23-.998-2.227-2.227-2.227M79.065 84.743a30.328 30.328 0 0 1-4.162 2.725l-.344.19c-.165.09-.318.166-.483.243a31.34 31.34 0 0 1-14.331 3.448 31.356 31.356 0 0 1-14.686-3.627c-.09-.051-.165-.088-.254-.14a19.755 19.755 0 0 1-.878-.483 16.441 16.441 0 0 1-1.005-.612c-.065-.038-.116-.077-.18-.114a32.509 32.509 0 0 1-2.531-1.794c-7.344-5.792-12.066-14.764-12.066-24.845 0-17.448 14.153-31.601 31.6-31.601 17.46 0 31.613 14.153 31.613 31.601 0 10.182-4.811 19.232-12.293 25.009zM8.064 41.115c.083.28.302.5.583.582l3.28.966c.824.242.824 1.41 0 1.652l-3.28.966a.86.86 0 0 0-.583.583l-.965 3.28c-.244.823-1.41.823-1.653 0l-.966-3.28a.858.858 0 0 0-.583-.583l-3.279-.966c-.823-.242-.823-1.41 0-1.652l3.28-.966a.86.86 0 0 0 .582-.582l.966-3.281c.243-.825 1.41-.825 1.653 0l.965 3.28zM119.738 47.556l.712 2.419a.636.636 0 0 0 .43.43l2.418.712c.608.178.608 1.04 0 1.219l-2.419.712a.632.632 0 0 0-.43.43l-.71 2.418c-.18.608-1.041.608-1.22 0l-.712-2.419a.63.63 0 0 0-.43-.429l-2.418-.712c-.608-.18-.608-1.04 0-1.219l2.418-.712a.634.634 0 0 0 .43-.43l.713-2.419c.178-.608 1.039-.608 1.218 0\" fill=\"#E1EEF4\"></path><path d=\"M73.545 9.353a2.565 2.565 0 1 1-5.13 0 2.565 2.565 0 0 1 5.13 0z\" stroke=\"#E1EEF4\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M85.825 111.955a1.85 1.85 0 1 1-3.698 0 1.85 1.85 0 0 1 3.698 0M108.476 14.582h-3.134v-1.578c0-.767.512-.946.873-.946h2.211v-3.38l-3.045-.016c-3.382 0-4.153 2.524-4.153 4.137v1.783h-1.955v3.942h1.972v9.658h3.945v-9.658h3.292l-.006-3.942z\" fill=\"#E1EEF4\"></path><path d=\"M106.56 80.543h4.952v-1.951h-4.952v1.951zm-2.4 0V78.57a2.378 2.378 0 0 1 2.379-2.378h4.995a2.378 2.378 0 0 1 2.378 2.378v1.973h3.52c1.123 0 2.034.91 2.034 2.034v10.78a2.035 2.035 0 0 1-2.033 2.033H100.64a2.035 2.035 0 0 1-2.033-2.033v-10.78c0-1.124.91-2.034 2.033-2.034h3.52z\" fill=\"#E1EEF4\" fill-rule=\"nonzero\"></path><path d=\"M46.55 119.727c7.049 0 10.905-5.99 10.905-11.183 0-.17-.004-.34-.012-.508a7.916 7.916 0 0 0 1.913-2.035 7.549 7.549 0 0 1-2.201.62 3.929 3.929 0 0 0 1.684-2.175c-.74.45-1.56.778-2.433.955a3.783 3.783 0 0 0-2.798-1.243c-2.116 0-3.833 1.76-3.833 3.93 0 .308.034.61.1.896-3.185-.164-6.01-1.728-7.9-4.106a3.988 3.988 0 0 0-.519 1.976c0 1.363.677 2.565 1.706 3.27a3.715 3.715 0 0 1-1.736-.491l-.001.05c0 1.904 1.32 3.493 3.075 3.853a3.74 3.74 0 0 1-1.731.067c.488 1.562 1.902 2.697 3.58 2.73a7.574 7.574 0 0 1-5.674 1.627 10.655 10.655 0 0 0 5.875 1.767\" fill=\"#E1EEF4\"></path><path d=\"M21.374 8.77a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M28.192 8.77a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M35.012 8.77a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0\" fill=\"#FFF\"></path><path d=\"M110.237 90.172v-1.645a1.2 1.2 0 1 0-2.4 0v1.645a1.2 1.2 0 1 0 2.4 0z\" fill=\"#FFF\" fill-rule=\"nonzero\"></path><path d=\"M11.219 87.017a1.978 1.978 0 0 1-2.404-2.405 1.962 1.962 0 0 1 1.424-1.422 1.978 1.978 0 0 1 2.402 2.404 1.96 1.96 0 0 1-1.422 1.423m-.491-9.13a7.635 7.635 0 0 0-7.634 7.635c0 3.307 4.696 9.466 6.721 11.969.47.581 1.354.581 1.825 0 2.025-2.503 6.721-8.662 6.721-11.969a7.634 7.634 0 0 0-7.633-7.634\" fill=\"#E1EEF4\"></path><path d=\"M76.595 86.474c-.025.013-.064.04-.089.051-.521.332-1.056.637-1.604.943l-.344.19c-.165.09-.318.166-.483.242a31.33 31.33 0 0 1-14.33 3.448 31.366 31.366 0 0 1-14.686-3.626c-.089-.05-.166-.089-.255-.14a18.597 18.597 0 0 1-.878-.484 15.32 15.32 0 0 1-1.005-.611c-.064-.037-.115-.076-.178-.113a32.224 32.224 0 0 1-2.533-1.795c3.933-6.593 11.136-11.01 19.37-11.01 8.31 0 15.564 4.493 19.484 11.175a30.107 30.107 0 0 1-2.469 1.73z\" fill=\"#B5D2E1\"></path><path d=\"M59.667 78.045a3.27 3.27 0 0 1-3.26-3.261v-4.97a3.27 3.27 0 0 1 3.26-3.26h.372a3.27 3.27 0 0 1 3.26 3.26v4.97a3.27 3.27 0 0 1-3.26 3.261h-.372z\" fill=\"#F7FAFE\"></path><path d=\"M70.463 48.556v12.179c0 5.957-4.869 10.827-10.827 10.827-5.944 0-10.825-4.87-10.825-10.827V48.556h21.652z\" fill=\"#FFF\"></path><path d=\"M48.811 47.306c0-3.59 2.809-6.495 6.275-6.495h20.313c0 4.123-1.306 6.43-3.254 7.531-1.02.577-2.218.825-3.502.825H48.81v-1.861z\" fill=\"#B5D2E1\"></path><path fill=\"#FFF\" d=\"M98.608 88.345h20.858v-1.62H98.608z\"></path></g></svg>"

/***/ }),

/***/ "ySI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var UserPropertiesConstants = Marty.createConstants(['FETCH_USER_PROPERTIES', 'UPDATE_USER_PROPERTIES']);

UserPropertiesConstants.ACKED_USER_IMPORT_TOOL = 'ackedUserImportTool';

/* harmony default export */ __webpack_exports__["a"] = (UserPropertiesConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "ySLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_api_OrgAPI__ = __webpack_require__("PFDe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_web_auth__ = __webpack_require__("jl+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__driftt_web_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__driftt_web_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("VmIC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_Access__ = __webpack_require__("6k1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css__ = __webpack_require__("qUe4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__styles_css__);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var MIN_LENGTH = 5;
var INCREMENT_LENGTH = 10;

var onSwitch = function () {
  var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(orgId, authClientId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Object(__WEBPACK_IMPORTED_MODULE_3_app_api_OrgAPI__["c" /* switchOrganization */])(orgId, authClientId).then(function (_ref2) {
              var accessToken = _ref2.accessToken,
                  expiresAt = _ref2.expiresAt;

              Object(__WEBPACK_IMPORTED_MODULE_4__driftt_web_auth__["setAccessToken"])({ token: accessToken, expirationInSeconds: expiresAt });
              window.location.replace('/');
            }).catch(function (err) {
              return console.error(err);
            });

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function onSwitch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var applyScopes = function applyScopes(scopes, organizatons) {
  return organizatons.map(function (organization) {
    return _extends({}, organization, {
      'scopes': scopes[organization.id]
    });
  });
};

var OrgSwitcher = function OrgSwitcher(_ref3) {
  var _ref3$organization = _ref3.organization,
      name = _ref3$organization.name,
      scopes = _ref3$organization.scopes,
      id = _ref3$organization.id,
      authClientId = _ref3.authClientId;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    { className: 'organization-info-container', onClick: function onClick() {
        return onSwitch(id, authClientId);
      } },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["Icon"], { className: 'organization-logo', name: 'drift-logo-round', height: '40' })
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["H4"],
        { className: 'organization-global-name' },
        ' ',
        name,
        ' '
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["P"],
        { className: 'organization-access-right' },
        ' ',
        Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getAuthorizationType */])(scopes),
        ' '
      )
    )
  );
};

var Organizations = function (_Component) {
  _inherits(Organizations, _Component);

  function Organizations() {
    var _ref4;

    var _temp, _this2, _ret;

    _classCallCheck(this, Organizations);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref4 = Organizations.__proto__ || Object.getPrototypeOf(Organizations)).call.apply(_ref4, [this].concat(args))), _this2), _this2.state = {
      organizations: [],
      maxLength: MIN_LENGTH
    }, _this2.getMaxLength = function () {
      var _this2$state = _this2.state,
          organizations = _this2$state.organizations,
          maxLength = _this2$state.maxLength;

      return Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["min"])(organizations.length, maxLength);
    }, _this2.incrementMaxLength = function () {
      _this2.setState({ maxLength: _this2.state.maxLength + INCREMENT_LENGTH });
    }, _this2.decrementMaxLength = function () {
      _this2.setState({ maxLength: _this2.state.maxLength - INCREMENT_LENGTH });
    }, _this2.canShowMore = function () {
      var _this2$state2 = _this2.state,
          organizations = _this2$state2.organizations,
          maxLength = _this2$state2.maxLength;

      return organizations.length - maxLength > 0;
    }, _this2.canShowLess = function () {
      var maxLength = _this2.state.maxLength;

      return maxLength > MIN_LENGTH;
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Organizations, [{
    key: 'componentDidMount',
    value: function () {
      var _ref5 = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref6, _ref7, organizations, scopes;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_7_utils_Access__["c" /* default */].isMultiOrg()) {
                  _context2.next = 14;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3_app_api_OrgAPI__["b" /* getOrganizations */])(), Object(__WEBPACK_IMPORTED_MODULE_3_app_api_OrgAPI__["a" /* getOrganizationScopes */])()]);

              case 4:
                _ref6 = _context2.sent;
                _ref7 = _slicedToArray(_ref6, 2);
                organizations = _ref7[0];
                scopes = _ref7[1];


                this.setState({ organizations: applyScopes(scopes, Object(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* sortByName */])(organizations)) });
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 11]]);
      }));

      function componentDidMount() {
        return _ref5.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var organizations = this.state.organizations;
      var _props = this.props,
          orgId = _props.orgId,
          authClientId = _props.authClientId;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: 'org-switcher' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["H4"],
          { className: 'org-switcher-header' },
          ' ORGANIZATIONS '
        ),
        organizations.slice(0, this.getMaxLength()).map(function (organization) {
          return orgId !== organization.id && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OrgSwitcher, { organization: organization, authClientId: authClientId });
        }),
        this.canShowMore() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["A"],
          { className: 'org-switcher-increment', href: '#', onClick: this.incrementMaxLength },
          ' Show more '
        ),
        this.canShowLess() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["A"],
          { className: 'org-switcher-increment', href: '#', onClick: this.decrementMaxLength },
          ' Show less '
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__driftt_tide_core_legacy__["A"],
          { className: 'org-switcher-increment', href: '#Q8ZtAkVfwr4abMm' },
          ' Add an organization... '
        )
      );
    }
  }]);

  return Organizations;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var mapStateToProps = function mapStateToProps(state) {
  return {
    orgId: Object(__WEBPACK_IMPORTED_MODULE_9_app_modules_org_selectors__["orgId"])(state)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Organizations));

/***/ }),

/***/ "yVUJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__ = __webpack_require__("/xdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl__ = __webpack_require__("IdOK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_styl__);







var toHex = function toHex(colorCode) {
  return '#' + colorCode;
};

var MessengerBuilder = function MessengerBuilder(_ref) {
  var themeColors = _ref.themeColors,
      avatarUrl = _ref.avatarUrl,
      name = _ref.name;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_4__style_styl___default.a.MessengerBuilder },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'message-header', style: { backgroundColor: toHex(themeColors.backgroundColor) } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'header-avatar' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'avatar', style: { backgroundImage: 'url(' + avatarUrl + ')' } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'avatar-name', style: { color: toHex(themeColors.foregroundColor) } },
          name
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'close-button', style: { fill: toHex(themeColors.foregroundColor) } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_3__svg_inline_removeSVGTagAttrs_false_removeTags_true_images_navigation_close_svg___default.a })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'messages-container', style: { backgroundColor: themeColors.widgetBackgroundColor } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'message is-end-user' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'message-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'message-item',
              style: {
                backgroundColor: toHex(themeColors.backgroundColor),
                color: toHex(themeColors.textColor)
              }
            },
            'Hey there! I have some questions.'
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'message' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'avatar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'avatar-image', style: { backgroundImage: 'url(' + avatarUrl + ')' } })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'message-chain' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'message-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'info-line flex' },
              name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'message-item',
                style: {
                  backgroundColor: toHex('f4f4f4'),
                  color: '#222222',
                  maxWidth: '228px'
                }
              },
              'Hey there! We\u2019re excited to help you out. Let us know your email address so that we can follow up in case we get disconnected.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'message-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                className: 'message-item email-item'
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'email-title' },
                'Email Address'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'email-input' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  {
                    className: 'email-submit',
                    style: {
                      backgroundColor: toHex(themeColors.backgroundColor)
                    }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { style: { color: toHex(themeColors.foregroundColor) } },
                    'SUBMIT'
                  )
                )
              )
            )
          )
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'message is-end-user' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'message-container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'message-item bot-button',
              style: {
                backgroundColor: toHex(themeColors.foregroundColor),
                color: toHex(themeColors.backgroundColor),
                borderColor: toHex(themeColors.backgroundColor)
              },
              onMouseEnter: function onMouseEnter(event) {
                event.target.style.backgroundColor = toHex(themeColors.backgroundColor);
                event.target.style.color = toHex(themeColors.foregroundColor);
              },
              onMouseLeave: function onMouseLeave(event) {
                event.target.style.backgroundColor = toHex(themeColors.foregroundColor);
                event.target.style.color = toHex(themeColors.backgroundColor);
              }
            },
            'I want to do something else'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              className: 'message-item bot-button',
              style: {
                backgroundColor: toHex(themeColors.foregroundColor),
                color: toHex(themeColors.backgroundColor),
                borderColor: toHex(themeColors.backgroundColor)
              },
              onMouseEnter: function onMouseEnter(event) {
                event.target.style.backgroundColor = toHex(themeColors.backgroundColor);
                event.target.style.color = toHex(themeColors.foregroundColor);
              },
              onMouseLeave: function onMouseLeave(event) {
                event.target.style.backgroundColor = toHex(themeColors.foregroundColor);
                event.target.style.color = toHex(themeColors.backgroundColor);
              }
            },
            'Support'
          )
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (MessengerBuilder);

/***/ }),

/***/ "yWAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ZapierContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_container__ = __webpack_require__("mKU3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_HelpDocConstants__ = __webpack_require__("fBam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__ = __webpack_require__("d8aW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_style_styl__ = __webpack_require__("ndOC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ZapierIntegrationLink = "https://zapier.com/developer/invite/37478/e0723233b58a75984fc47535684ff803/";

var Zapier = function (_Component) {
  _inherits(Zapier, _Component);

  function Zapier() {
    _classCallCheck(this, Zapier);

    return _possibleConstructorReturn(this, (Zapier.__proto__ || Object.getPrototypeOf(Zapier)).apply(this, arguments));
  }

  _createClass(Zapier, [{
    key: 'render',
    value: function render() {
      var accessToken = this.props.apiKey.accessToken;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'If you\u2019re already using Zapier, you know how powerful it can be.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'With Drift and Zapier, you\u2019ll be able to do things like sync contacts from the tools that you\u2019re already using like SalesForce or log a new event for a user based on something they\u2019ve done in Zendesk.',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { target: '_blank', href: __WEBPACK_IMPORTED_MODULE_2_constants_HelpDocConstants__["g" /* ZAPIER_HELPDOC_URL */] },
            ' Learn more'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'You can set up your Zapier integration using the Drift Access Token below.'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_web_src_components_Input___default.a, {
          placeholder: 'e.g. 123456',
          label: 'DRIFT ACCESS TOKEN',
          helperLabel: 'Use this Access Token in Zapier to connect it with your Drift account.',
          value: accessToken,
          readOnly: true
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: __WEBPACK_IMPORTED_MODULE_4__components_style_styl___default.a.IntegrationLink, target: '_blank', href: ZapierIntegrationLink },
            'Open integration page on Zapier >'
          )
        )
      );
    }
  }]);

  return Zapier;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ZapierContainer = Object(__WEBPACK_IMPORTED_MODULE_1_components_container__["a" /* makeDefaultFailedContainer */])(Zapier, {
  listenTo: ['stores.ApiKeyStore'],
  fetch: {
    apiKey: function apiKey() {
      return this.app.stores.ApiKeyStore.getApiKeyForCurrentOrg();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (ZapierContainer);

/***/ }),

/***/ "yfY0":
/***/ (function(module, exports) {

module.exports = "<svg width=\"27\" height=\"24\" viewBox=\"0 0 27 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.865 18.545H5.978L1.943 23.59c-.212.265-.527.41-.852.41-.12 0-.242-.02-.36-.06-.438-.155-.73-.567-.73-1.03V4.316C0 1.937 1.936 0 4.318 0h17.547c2.38 0 4.317 1.936 4.317 4.317v9.912c0 2.38-1.937 4.315-4.317 4.315z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "yhLl":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+RG93biBBcnJvdyBDaXJjbGUgKyBQYXRoICsgUGF0aCAxMjY8L3RpdGxlPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3Qgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjQiIHdpZHRoPSIzNCIgaGVpZ2h0PSIzNCIgcng9IjQwIi8+PHBhdGggZD0iTTguNTg2IDE1LjQxNGw3IDdhMiAyIDAgMCAwIDIuODI4LTIuODI4bC03LTdhMiAyIDAgMCAwLTIuODI4IDIuODI4IiBmaWxsPSIjRkZGIi8+PHBhdGggZD0iTTIyLjU4NiAxMi41ODZsLTcgN2EyIDIgMCAwIDAgMi44MjggMi44MjhsNy03YTIgMiAwIDAgMC0yLjgyOC0yLjgyOCIgZmlsbD0iI0ZGRiIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ "yk+7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/salesforce-video.93479715.png";

/***/ }),

/***/ "ykXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_selectors__ = __webpack_require__("Bqo0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_utils_containers__ = __webpack_require__("auMU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__ = __webpack_require__("TFJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__("Dvx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__("9Gfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_tracking__ = __webpack_require__("ZL5f");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var withProfile = function withProfile() {
  var selectors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_6__selectors__;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { blocking: false };
  return function (InnerComponent) {
    var ProfileContainer = function (_Component) {
      _inherits(ProfileContainer, _Component);

      function ProfileContainer() {
        _classCallCheck(this, ProfileContainer);

        return _possibleConstructorReturn(this, (ProfileContainer.__proto__ || Object.getPrototypeOf(ProfileContainer)).apply(this, arguments));
      }

      _createClass(ProfileContainer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.props.actions.fetchCurrentProfile();
        }
      }, {
        key: 'render',
        value: function render() {
          if (options.blocking && !this.props.isLoaded) return false;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerComponent, this.props);
        }
      }]);

      return ProfileContainer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    ProfileContainer.displayName = 'withProfile(' + Object(__WEBPACK_IMPORTED_MODULE_4_utils_containers__["a" /* getDisplayName */])(InnerComponent) + ')';

    function mapStateToProps(state) {
      var appliedSelectors = options.blocking ? _extends({ isLoaded: __WEBPACK_IMPORTED_MODULE_6__selectors__["isLoaded"] }, selectors, { orgHandle: __WEBPACK_IMPORTED_MODULE_5_app_modules_org_selectors__["orgHandle"] }) : selectors;

      return Object(__WEBPACK_IMPORTED_MODULE_3_utils_selectors__["a" /* applySelectors */])(appliedSelectors, state);
    }

    function mapDispatchToProps(dispatch) {
      return {
        actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])(_extends({}, __WEBPACK_IMPORTED_MODULE_7__actions__, { track: __WEBPACK_IMPORTED_MODULE_8_app_modules_tracking__["a" /* actions */].track }), dispatch)
      };
    }

    return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(ProfileContainer);
  };
};

/***/ }),

/***/ "ykk9":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "ynYZ":
/***/ (function(module, exports) {

module.exports = "<svg width=\"25\" height=\"25\" viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.295 24.412a.987.987 0 0 1-1.123-.43L19.9 20.358H9.527c-1.392 0-2.523-1.153-2.523-2.57V16.3c0-.563.448-1.02 1-1.02.553 0 1 .457 1 1.02v1.485c0 .295.235.533.523.533h10.92c.036 0 .067.018.103.022a.96.96 0 0 1 .527.224.984.984 0 0 1 .14.15c.023.026.054.043.073.075l.725 1.154V9.7a.528.528 0 0 0-.523-.532h-1.48c-.55 0-1-.457-1-1.02 0-.56.45-1.018 1-1.018h1.48c1.392 0 2.524 1.152 2.524 2.57V23.433c0 .452-.293.85-.72.978zM14.49 13.226H4.116L1.844 16.85a.997.997 0 0 1-1.124.43 1.017 1.017 0 0 1-.72-.978V2.57C0 1.152 1.132 0 2.523 0H14.49c1.39 0 2.52 1.152 2.52 2.57v8.085c0 1.418-1.13 2.57-2.52 2.57zm.52-10.656a.528.528 0 0 0-.52-.532H2.522c-.288 0-.522.24-.522.532v10.242l.726-1.153c.02-.032.05-.05.07-.076a.897.897 0 0 1 .296-.256.92.92 0 0 1 .372-.118c.037-.004.068-.022.104-.022h10.92c.288 0 .522-.238.522-.533V2.57z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "yote":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(429);

/***/ }),

/***/ "yv8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_actions__ = __webpack_require__("pE+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__ = __webpack_require__("mfMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__ = __webpack_require__("Ti9R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_modules_marketo_models__ = __webpack_require__("8Ziy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__ = __webpack_require__("w1VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl__ = __webpack_require__("52d9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__style_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var HELP_DOC_URL = "https://help.drift.com/integrations/marketo-attribute-mapping";
var integrationName = "Marketo";
var getSuccessMessage = function getSuccessMessage(integrationName) {
  return "You successfully updated your " + integrationName + " App!";
};

var MarketoAttributeMapping = function (_Component) {
  _inherits(MarketoAttributeMapping, _Component);

  function MarketoAttributeMapping(props) {
    _classCallCheck(this, MarketoAttributeMapping);

    var _this = _possibleConstructorReturn(this, (MarketoAttributeMapping.__proto__ || Object.getPrototypeOf(MarketoAttributeMapping)).call(this, props));

    _this.createDefaultMapping = function (mappings) {
      return mappings.map(function (mapping) {
        return mapping.driftAttribute && mapping.defaultValue ? _extends(mapping, { defaultValue: null }) : mapping;
      });
    };

    _this.onCountryUpdated = function () {
      var _this$state = _this.state,
          mappings = _this$state.mappings,
          allowAttributeDefaults = _this$state.allowAttributeDefaults,
          useStateAcronyms = _this$state.useStateAcronyms,
          useCountryAcronyms = _this$state.useCountryAcronyms;


      var payload = {
        mappings: mappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useStateAcronyms: useStateAcronyms,
        useCountryAcronyms: !useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.onStateUpdated = function () {
      var _this$state2 = _this.state,
          mappings = _this$state2.mappings,
          allowAttributeDefaults = _this$state2.allowAttributeDefaults,
          useStateAcronyms = _this$state2.useStateAcronyms,
          useCountryAcronyms = _this$state2.useCountryAcronyms;


      var payload = {
        mappings: mappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useStateAcronyms: !useStateAcronyms,
        useCountryAcronyms: useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.onDefaultUpdated = function () {
      var _this$state3 = _this.state,
          mappings = _this$state3.mappings,
          allowAttributeDefaults = _this$state3.allowAttributeDefaults,
          useStateAcronyms = _this$state3.useStateAcronyms,
          useCountryAcronyms = _this$state3.useCountryAcronyms;


      var payload = {
        mappings: _this.createDefaultMapping(mappings),
        allowAttributeDefaults: !allowAttributeDefaults,
        useStateAcronyms: useStateAcronyms,
        useCountryAcronyms: useCountryAcronyms
      };

      _this.updateMappings(payload);
    };

    _this.updateMappings = function (payload) {
      var notifications = _this.props.notifications;


      _this.props.actions.patchMarketoMappings(payload, function () {
        notifications.success(getSuccessMessage(integrationName));
        // Update UI with the new state after success.
        _this.setState(_extends({}, payload));
      });
    };

    _this.patchDecorator = function (strippedMappings, successCB) {
      var _this$state4 = _this.state,
          allowAttributeDefaults = _this$state4.allowAttributeDefaults,
          useCountryAcronyms = _this$state4.useCountryAcronyms,
          useStateAcronyms = _this$state4.useStateAcronyms;

      var payload = {
        mappings: strippedMappings,
        allowAttributeDefaults: allowAttributeDefaults,
        useCountryAcronyms: useCountryAcronyms,
        useStateAcronyms: useStateAcronyms
      };
      _this.props.actions.patchMarketoMappings(payload, successCB);
    };

    _this.state = {
      mappings: props.mappings,
      useCountryAcronyms: props.useCountryAcronyms,
      useStateAcronyms: props.useStateAcronyms,
      allowAttributeDefaults: props.allowAttributeDefaults
    };
    return _this;
  }

  _createClass(MarketoAttributeMapping, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.allowAttributeDefaults !== nextProps.allowAttributeDefaults) {
        this.setState({ allowAttributeDefaults: nextProps.allowAttributeDefaults });
      }
      if (this.state.mappings !== nextProps.mappings) {
        this.setState({ mappings: nextProps.mappings });
      }
      if (this.state.useCountryAcronyms !== nextProps.useCountryAcronyms) {
        this.setState({ useCountryAcronyms: nextProps.useCountryAcronyms });
      }
      if (this.state.useStateAcronyms !== nextProps.useStateAcronyms) {
        this.setState({ useStateAcronyms: nextProps.useStateAcronyms });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.actions.fetchDriftProperties();
      this.props.actions.fetchMarketoFields();
      this.props.actions.fetchMarketoMappings();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          patchLoading = _props.patchLoading,
          driftProperties = _props.driftProperties,
          marketoFields = _props.marketoFields;
      var _state = this.state,
          mappings = _state.mappings,
          allowAttributeDefaults = _state.allowAttributeDefaults,
          useCountryAcronyms = _state.useCountryAcronyms,
          useStateAcronyms = _state.useStateAcronyms;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { className: "marketo-mapping common-integration-page-layout" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: "Marketo Integration",
          backLinkUrl: "/settings/setup/marketo"
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "header",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h2",
            { className: "integration-header" },
            "Mapped Marketo Attributes"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "p",
            null,
            " ",
            "Map which fields you want to add to new Marketo Leads. These Drift attributes will be added to new Marketo Leads when they\u2019re created.",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "a",
              { href: HELP_DOC_URL },
              " Learn More"
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_AttributeMapper__["a" /* default */], {
          integrationName: "Marketo",
          mappings: mappings,
          driftAttributes: driftProperties,
          integrationAttributes: marketoFields,
          mappingModel: __WEBPACK_IMPORTED_MODULE_9_app_modules_marketo_models__["a" /* MarketoMapping */],
          patchMappings: this.patchDecorator,
          patchLoading: patchLoading,
          allowAttributeDefaults: allowAttributeDefaults
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "marketo-toggle-row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
            className: "marketo-default-checkbox",
            type: "checkbox",
            checked: allowAttributeDefaults,
            onChange: this.onDefaultUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            { className: "marketo-toggle-text" },
            "Set default values that will send when a Drift Attribute is empty"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "marketo-toggle-row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
            className: "marketo-default-checkbox",
            type: "checkbox",
            checked: useCountryAcronyms,
            onChange: this.onCountryUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            { className: "marketo-toggle-text" },
            "Send abbreviated country names to Marketo (i.e. US instead of United States)"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: "marketo-toggle-row" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Input"], {
            className: "marketo-default-checkbox",
            type: "checkbox",
            checked: useStateAcronyms,
            onChange: this.onStateUpdated
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "h1",
            { className: "marketo-toggle-text" },
            "Send abbreviated state names to Marketo (i.e. NY instead of New York)"
          )
        )
      );
    }
  }]);

  return MarketoAttributeMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

MarketoAttributeMapping.defaultProps = {
  allowAttributeDefaults: false,
  useStateAcronyms: false,
  useCountryAcronyms: false
};

function mapStateToProps(state) {
  return {
    driftProperties: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_endUser_attribute_selectors__["b" /* filteredProperties */])(state),
    mappings: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["c" /* getMappings */])(state),
    marketoFields: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["b" /* getFields */])(state),
    patchError: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["a" /* didPatchErr */])(state),
    patchLoading: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["e" /* isPatchLoading */])(state),
    allowAttributeDefaults: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["d" /* isAllowAttributeDefaults */])(state),
    useCountryAcronyms: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["f" /* isUseCountryAcronyms */])(state),
    useStateAcronyms: Object(__WEBPACK_IMPORTED_MODULE_7_app_modules_marketo_selectors__["g" /* isUseStateAcronyms */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchDriftProperties: __WEBPACK_IMPORTED_MODULE_5_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */],
      fetchMarketoMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_actions__["b" /* fetchMarketoMappings */],
      fetchMarketoFields: __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_actions__["a" /* fetchMarketoFields */],
      patchMarketoMappings: __WEBPACK_IMPORTED_MODULE_4_app_modules_marketo_actions__["c" /* patchMarketoMappings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_components_shared_notifications__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(MarketoAttributeMapping)));

/***/ }),

/***/ "yvKM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducers__ = __webpack_require__("ITIY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__epic__ = __webpack_require__("LDhr");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__epic__["a"]; });






/***/ }),

/***/ "yynn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reducer__ = __webpack_require__("fk1w");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__epic__ = __webpack_require__("eOUG");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__epic__["a"]; });





/***/ }),

/***/ "z1XD":
/***/ (function(module, exports) {

module.exports = "<svg width=\"17\" height=\"17\" viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.726 15.402c.365.366.365.96 0 1.324-.178.178-.416.274-.663.274-.246 0-.484-.096-.663-.274L8.323 9.648h.353L1.6 16.726c-.177.178-.416.274-.663.274-.246 0-.484-.096-.663-.274-.365-.365-.365-.958 0-1.324L7.35 8.324v.35L.275 1.6C-.09 1.233-.09.64.274.274c.367-.365.96-.365 1.326 0l7.076 7.078h-.353L15.4.274c.366-.365.96-.365 1.326 0 .365.366.365.958 0 1.324L9.65 8.675v-.35l7.076 7.077z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "z6IM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/live-chat.e7d92e58.gif";

/***/ }),

/***/ "z78L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_svg_dizzy_robot_svg__ = __webpack_require__("L3SV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_svg_dizzy_robot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_svg_dizzy_robot_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl__ = __webpack_require__("FRQE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_styl__);





var ErrorState = function ErrorState() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'sfdc-mapping-error' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_images_svg_dizzy_robot_svg___default.a }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h3',
      null,
      'Uh oh! Something went wrong.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Link */],
      { to: '/settings/salesforce/event-log' },
      'See the event log for more details'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ErrorState);

/***/ }),

/***/ "z7IT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7lp":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "z8rd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ATTRIBUTES_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ATTRIBUTES_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ATTRIBUTES_CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_ATTRIBUTES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__ = __webpack_require__("Ac9J");

var makeConstant = Object(__WEBPACK_IMPORTED_MODULE_0_utils_constantsHelper__["a" /* makeConstantFactory */])('endUser/attributes');

var FETCH_ATTRIBUTES = makeConstant('FETCH_ATTRIBUTES');
var FETCH_ATTRIBUTES_PENDING = makeConstant('FETCH_ATTRIBUTES_PENDING');
var FETCH_ATTRIBUTES_FAILED = makeConstant('FETCH_ATTRIBUTES_FAILED');
var FETCH_ATTRIBUTES_CANCELLED = makeConstant('FETCH_ATTRIBUTES_CANCELLED');
var RECEIVE_ATTRIBUTES = makeConstant('RECEIVE_ATTRIBUTES');

/***/ }),

/***/ "zH3L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__ = __webpack_require__("6y75");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_hubspot_actions__ = __webpack_require__("vCIQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__ = __webpack_require__("1eL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_models__ = __webpack_require__("kvsP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__ = __webpack_require__("JMAf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_OwnerMapper__ = __webpack_require__("JRbK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl__ = __webpack_require__("Atam");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__style_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var HubspotUserMapping = function (_Component) {
  _inherits(HubspotUserMapping, _Component);

  function HubspotUserMapping() {
    _classCallCheck(this, HubspotUserMapping);

    return _possibleConstructorReturn(this, (HubspotUserMapping.__proto__ || Object.getPrototypeOf(HubspotUserMapping)).apply(this, arguments));
  }

  _createClass(HubspotUserMapping, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.actions.fetchOrgUsers();
      if (!this.props.isMappingLoaded && !this.props.isMappingLoading) {
        this.props.actions.fetchHubspotUserMappings();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMappingLoaded = _props.isMappingLoaded,
          userMappings = _props.userMappings,
          driftUsers = _props.driftUsers,
          hubspotUsers = _props.hubspotUsers,
          actions = _props.actions,
          isSearching = _props.isSearching;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'integration-user-mapping common-integration-page-layout' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Integration_components_IntegrationBreadcrumb__["a" /* default */], {
          backLinkText: 'Hubspot Integration',
          backLinkUrl: '/settings/setup/hubspot'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'header',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h2',
            { className: 'integration-header' },
            'Mapped Hubspot Users'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'Map your Drift Teammates to your Hubspot Teammates or invite them to join the family!'
          )
        ),
        !isMappingLoaded ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__driftt_tide_core_legacy__["Loader"], { className: 'loader-position' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_OwnerMapper__["a" /* default */], {
          integrationName: 'Hubspot',
          mappings: userMappings,
          driftUsers: driftUsers,
          integrationUsers: hubspotUsers,
          isSearching: isSearching,
          userMappingModel: __WEBPACK_IMPORTED_MODULE_7_app_modules_hubspot_models__["b" /* HubspotUserMap */],
          patchMappings: actions.patchHubspotUserMappings,
          searchIntegrationUsers: actions.searchHubspotUsers,
          fetchOrgUsers: actions.fetchOrgUsers
        })
      );
    }
  }]);

  return HubspotUserMapping;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

function mapStateToProps(state) {
  return {
    driftUsers: Object(__WEBPACK_IMPORTED_MODULE_4_app_modules_user_selectors__["orgUsersById"])(state).toJS(),
    userMappings: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__["e" /* getUserMappings */])(state),
    hubspotUsers: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__["d" /* getHubspotUsers */])(state),
    isMappingLoading: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__["l" /* isUserMappingLoading */])(state),
    isMappingLoaded: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__["k" /* isUserMappingLoaded */])(state),
    isSearching: Object(__WEBPACK_IMPORTED_MODULE_6_app_modules_hubspot_selectors__["h" /* isHubspotUsersSearchLoading */])(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({
      fetchOrgUsers: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_actions__["fetchOrgUsers"],
      fetchHubspotUserMappings: __WEBPACK_IMPORTED_MODULE_5_app_modules_hubspot_actions__["d" /* fetchHubspotUserMappings */],
      searchHubspotUsers: __WEBPACK_IMPORTED_MODULE_5_app_modules_hubspot_actions__["g" /* searchHubspotUsers */],
      patchHubspotUserMappings: __WEBPACK_IMPORTED_MODULE_5_app_modules_hubspot_actions__["f" /* patchHubspotUserMappings */]
    }, dispatch)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(HubspotUserMapping));

/***/ }),

/***/ "zH4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__ = __webpack_require__("st9j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_object__ = __webpack_require__("1Rfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__ = __webpack_require__("hkeu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__ = __webpack_require__("m8XX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__ = __webpack_require__("hTEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__("0KWr");













var mapStateToProps = function mapStateToProps(state) {
  return {
    theme: __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__["v" /* theme */](state),
    defaultEmbed: __WEBPACK_IMPORTED_MODULE_7_app_modules_embed_selectors__["h" /* getEmbedConfig */](state),
    orgUsers: __WEBPACK_IMPORTED_MODULE_8_app_modules_user_selectors__["currentOrgUsersAlphabetical"](state),
    takeoverMessage: __WEBPACK_IMPORTED_MODULE_6_app_modules_playbook_selectors__["_100" /* takeoverMessage */](state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({
      setMessage: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_181" /* setMessage */],
      setHeadline: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_177" /* setHeadline */],
      setAuthorId: __WEBPACK_IMPORTED_MODULE_5_app_modules_playbook_actions__["_138" /* setAuthorId */]
    }, dispatch)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["a" /* branch */])(function (_ref) {
  var theme = _ref.theme,
      orgUsers = _ref.orgUsers,
      defaultEmbed = _ref.defaultEmbed;
  return !theme || !orgUsers.size || !defaultEmbed;
}, Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["f" /* renderComponent */])(function () {
  return React.createElement('div', null);
})), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    userObjForAuthor: props.takeoverMessage.authorId ? props.orgUsers.toJS().find(function (user) {
      return user.id === props.takeoverMessage.authorId;
    }) : null
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["i" /* withProps */])(function (props) {
  return {
    message: props.takeoverMessage.message,
    headline: props.takeoverMessage.title,
    hideCta: !props.takeoverMessage.cta || _.get(props.takeoverMessage, 'cta.type', __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__["V" /* CtaTypes */].CHAT) === __WEBPACK_IMPORTED_MODULE_3_app_modules_playbook_constants__["V" /* CtaTypes */].NONE,
    ctaCopy: _.get(props.takeoverMessage, 'cta.copy'),
    ctaLink: _.get(props.takeoverMessage, 'cta.url'),
    selectedUser: props.userObjForAuthor
  };
}), Object(__WEBPACK_IMPORTED_MODULE_2_recompose__["h" /* withHandlers */])({
  onMessageChange: function onMessageChange(props) {
    return function (message) {
      props.actions.setMessage(message);
    };
  },
  onHeadlineChange: function onHeadlineChange(props) {
    return function (event) {
      props.actions.setHeadline({ value: event.target.value });
    };
  },
  onAuthorChange: function onAuthorChange(props) {
    return function (option) {
      props.actions.setAuthorId(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_object__["get"])(option, 'value', 0));
    };
  }
}))(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG"), __webpack_require__("M4fF")))

/***/ }),

/***/ "zIDI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GenericEvent__ = __webpack_require__("8wCm");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CONVERSATION_ICON_SRC = __webpack_require__("WW4l");

function truncate(string, n) {
  if (!string) return '';
  return string.length > n ? string.substr(0, n - 1) + '...' : string;
}

var ConversationEvent = function ConversationEvent(props) {
  var conversation = props.event.body.conversation;

  var eventProps = _extends({
    iconSrc: CONVERSATION_ICON_SRC,
    eventLabel: 'started a conversation'
  }, props);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2__GenericEvent__["a" /* default */],
    eventProps,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: { margin: '0.25rem 0' } },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_router__["c" /* Link */],
        { to: '/inboxes/' + conversation.inboxId + '/conversations/' + conversation.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'dsg-medium-weight' },
          '#' + conversation.displayId
        )
      ),
      '\xA0',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'color-navy-dark' },
        '|'
      ),
      '\xA0 \u201C',
      truncate(conversation.preview, 100),
      '\u201D'
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (ConversationEvent);

/***/ }),

/***/ "zMog":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror__ = __webpack_require__("vMAF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keymirror__);



var TRANSLATION_CONSTANTS = __WEBPACK_IMPORTED_MODULE_1_keymirror___default()({
  TRANSLATION_LOADED: null
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.mapValues(TRANSLATION_CONSTANTS, __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId));

/***/ }),

/***/ "zNUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__("89VE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("9gNq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("a2hK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__("MujL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_app_modules_conversation_selectors__ = __webpack_require__("Kkvv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__("cnR9");








var setPresenceInterval = function setPresenceInterval(action$, _ref) {
  var getState = _ref.getState;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* GET_PRESENCE_STATE_ON_INTERVAL */]).switchMap(function (action) {
    var interval = action.payload;
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].timer(0, interval).takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* CANCEL_PRESENCE_INTERVAL */])).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* API */].getPresenceState(Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["getQuery"])(getState())).mergeMap(function (data) {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["setNewLiveUsers"](data));
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
      });
    });
  });
};

var bootstrapUserEpic = function bootstrapUserEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* BOOTSTRAP_USER */]).switchMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* API */].bootstrapUser(action.payload).map(__WEBPACK_IMPORTED_MODULE_2__actions__["bootstrapUserSuccess"]).catch(function () {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].of(__WEBPACK_IMPORTED_MODULE_2__actions__["bootstrapUserError"]);
    });
  });
};

var sendActiveStatusEpic = function sendActiveStatusEpic(action$, _ref2) {
  var getState = _ref2.getState;

  var isActive$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["n" /* SEND_ACTIVE_STATUS */]).pluck('payload').filter(function (_ref3) {
    var isActive = _ref3.isActive;
    return !!isActive;
  });

  var isIdle$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_3__constants__["n" /* SEND_ACTIVE_STATUS */]).pluck('payload').filter(function (_ref4) {
    var isActive = _ref4.isActive;
    return !isActive;
  });

  return isActive$.switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].timer(0, 20000).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* API */].sendActiveStatus(__WEBPACK_IMPORTED_MODULE_5_app_modules_conversation_selectors__["c" /* activeConversationId */](getState())).mergeMap(function () {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"].empty();
      });
    }).takeUntil(isIdle$);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(setPresenceInterval, bootstrapUserEpic, sendActiveStatusEpic));

/***/ }),

/***/ "zSQi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizedTimezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSupportedTimezones; });
/* unused harmony export getTimezoneMetadata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var TIMEZONE_ABBREVIATIONS = Object.freeze(["DST", "U", "HST", "AKDT", "PDT", "PST", "UMST", "MDT", "CAST", "CDT", "CCST", "SPST", "EDT", "UEDT", "VST", "PYT", "ADT", "CBST", "SWST", "PSST", "NDT", "ESAST", "AST", "SEST", "GDT", "MST", "BST", "CVST", "UTC", "GMT", "GST", "WEDT", "CEDT", "RDT", "WCAST", "NST", "MEDT", "EST", "SDT", "EEDT", "SAST", "FDT", "TDT", "JDT", "LST", "JST", "KST", "EAST", "MSK", "SAMT", "IDT", "CST", "WAST", "YEKT", "PKT", "IST", "SLST", "NCAST", "NAST", "MPST", "TST", "UST", "NAEST", "ACST", "AEST", "WPST", "YST", "CPST", "NZST", "FST", "KDT", "SST"]);

// https://stackoverflow.com/questions/23640227/how-does-gmt-ids-work-in-java-timezone/23643847#23643847
var POSIX_SIGN_TIMEZONE_REGEX = /^Etc\/GMT([+,-][^0][\d]{0,1})$/;

var normalizedTimezone = function normalizedTimezone(timezone) {
  var _ref = timezone.match(POSIX_SIGN_TIMEZONE_REGEX) || [],
      _ref2 = _slicedToArray(_ref, 2),
      isPosixSignTimezone = _ref2[0],
      offsetValue = _ref2[1];

  if (!isPosixSignTimezone) {
    return timezone;
  }

  var normalizedOffsetValue = -offsetValue;
  var normalizedOffsetLabel = normalizedOffsetValue > 0 ? "+" + normalizedOffsetValue : normalizedOffsetValue;

  return "UTC/GMT" + normalizedOffsetLabel;
};

var getSupportedTimezones = function getSupportedTimezones() {
  return __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"].names().filter(function (x) {
    return !TIMEZONE_ABBREVIATIONS.includes(x);
  });
};

var getTimezoneMetadata = function getTimezoneMetadata(timezone, date) {
  var timestamp = date.getTime();
  var zone = __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"].zone(timezone);
  var zonedDate = __WEBPACK_IMPORTED_MODULE_0_moment_timezone__["tz"](timestamp, timezone);
  var offsetAsString = zonedDate.format('Z');

  var abbrs = zone.abbr(timestamp);

  return {
    name: zone.name,
    abbreviations: abbrs,
    offset: offsetAsString
  };
};

/***/ }),

/***/ "zaxl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__ = __webpack_require__("4yb5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_settings_team_TeamAvatarList__ = __webpack_require__("0qK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("fi0M");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TeamParticipantAction = function (_PureComponent) {
  _inherits(TeamParticipantAction, _PureComponent);

  function TeamParticipantAction(props) {
    _classCallCheck(this, TeamParticipantAction);

    var _this = _possibleConstructorReturn(this, (TeamParticipantAction.__proto__ || Object.getPrototypeOf(TeamParticipantAction)).call(this, props));

    _this.onTeamSelected = function (selectedOption) {
      var setActionParticipants = _this.props.setActionParticipants;


      _this.setState({ selectedTeam: selectedOption }, function () {
        var participants = _this.state.selectedTeam ? [_this.state.selectedTeam.value.id] : [];
        setActionParticipants({ participants: participants, participantType: __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* PARTICIPANT_TYPES */].TEAM });
      });
    };

    var selectedTeamId = Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["get"])(props.rule, 'data.item.action.options.teamId', null);

    _this.state = {
      selectedTeam: !!selectedTeamId ? Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["find"])(props.teamsOptions, { value: { id: selectedTeamId } }) || null : null
    };
    return _this;
  }

  _createClass(TeamParticipantAction, [{
    key: 'render',
    value: function render() {
      var teamsOptions = this.props.teamsOptions;
      var selectedTeam = this.state.selectedTeam;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'participant-action team-participant' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'participant-action-selector-description' },
          'Who do you want to add to the group?'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__driftt_tide_core_legacy__["Select"], {
          autoFocus: true,
          options: teamsOptions,
          pageSize: 10,
          placeholder: 'Pick a Team...',
          onChange: this.onTeamSelected,
          value: selectedTeam
        }),
        !!selectedTeam && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_settings_team_TeamAvatarList__["a" /* default */], { teamId: selectedTeam.value.id })
      );
    }
  }]);

  return TeamParticipantAction;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (TeamParticipantAction);

/***/ }),

/***/ "zbqJ":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 5 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 1.207v7.586a.5.5 0 0 0 .854.353l3.792-3.792a.5.5 0 0 0 0-.708L.854.854A.5.5 0 0 0 0 1.207z\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "zgcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* unused harmony export PropertyNamespaces */
/* unused harmony export TokenButtonContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__("q2Me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_extend__ = __webpack_require__("Npzm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_extend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draft_extend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react__ = __webpack_require__("gayC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose__ = __webpack_require__("IRSK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fuse_js__ = __webpack_require__("z1nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fuse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fuse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tether__ = __webpack_require__("CnwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_onclickoutside_decorator__ = __webpack_require__("zyFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_onclickoutside_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_onclickoutside_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag__ = __webpack_require__("6bwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_app_modules_gates_selectors__ = __webpack_require__("OWv3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__ = __webpack_require__("gh/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_shared_ConditionalRender__ = __webpack_require__("tQfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_constants_ClearbitProperties__ = __webpack_require__("uwTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseProperties__ = __webpack_require__("rg4R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_app_modules_endUser_attribute_selectors__ = __webpack_require__("Kxpa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_app_modules_endUser_attribute_actions__ = __webpack_require__("nu3i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_models__ = __webpack_require__("tUpl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_app_modules_integrations_selectors__ = __webpack_require__("s6JI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_social_splash_svg__ = __webpack_require__("yOq8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_social_splash_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_social_splash_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_styl__ = __webpack_require__("RgxK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__style_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__style_styl__);





























var TokenPopoverSteps = {
  SELECT: 'select',
  CONFIRM: 'confirm'
};

var PropertyNamespaces = {
  USER: 'user',
  CLEARBIT: 'clearbit',
  ACCOUNT: 'account',
  DEMANDBASE: 'demandbase'

  /* TODO: remove this code once account attributes are pulled in from Account API */
};var ExtraProperty = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  name: null,
  displayName: null,
  displayNamespace: PropertyNamespaces.USER,
  requiresABM: false
});

var extraProperties = [new ExtraProperty({ 'name': 'account.name', 'displayName': 'Account Name', 'displayNamespace': PropertyNamespaces.USER, requiresABM: true })];
/* END TODO */

var tokenStringFromProperty = function tokenStringFromProperty(property, namespace) {
  var tokenString = '';
  if (!property.displayNamespace) {
    tokenString = namespace + '.';
  }
  return '' + tokenString + property.get('name');
};

var insertToken = function insertToken(property, editorState) {
  var pushChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

  var contentState = __WEBPACK_IMPORTED_MODULE_0_draft_js__["Modifier"].insertText(editorState.getCurrentContent(), editorState.getSelection(), property, null, __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].create(ENTITY_TYPE, 'IMMUTABLE', {
    value: property
  }));
  pushChange(__WEBPACK_IMPORTED_MODULE_0_draft_js__["EditorState"].push(editorState, contentState, 'insert-characters'));
};

var TokenPopoverSelect = function TokenPopoverSelect(_ref) {
  var userProperties = _ref.userProperties,
      clearbitProperties = _ref.clearbitProperties,
      search = _ref.search,
      onSearchChange = _ref.onSearchChange,
      onPropertySelect = _ref.onPropertySelect,
      selectedTab = _ref.selectedTab,
      onClearbitTabClick = _ref.onClearbitTabClick,
      onUserTabClick = _ref.onUserTabClick,
      noPropertiesShown = _ref.noPropertiesShown,
      hideClearbitTab = _ref.hideClearbitTab,
      hasClearbitEnabled = _ref.hasClearbitEnabled,
      onDemandbaseTabClick = _ref.onDemandbaseTabClick,
      hasDemandbase = _ref.hasDemandbase;
  return React.createElement(
    'div',
    { className: 'popover-selector-container' },
    React.createElement(
      'div',
      { className: 'popover-selector-section popover-selector-section-top drift-form' },
      React.createElement('input', {
        className: 'popover-selector-search-input',
        type: 'text',
        value: search,
        onChange: onSearchChange,
        placeholder: 'Search'
      })
    ),
    hasDemandbase && React.createElement(
      'div',
      { className: 'rich-editor-token-popover-selector-tab-container' },
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-popover-selector-tab-option', { active: selectedTab === PropertyNamespaces.USER }), onClick: onUserTabClick },
        'User'
      ),
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-popover-selector-tab-option', { active: selectedTab === PropertyNamespaces.DEMANDBASE }), onClick: onDemandbaseTabClick },
        'Demandbase'
      )
    ),
    !hideClearbitTab && hasClearbitEnabled && !hasDemandbase && React.createElement(
      'div',
      { className: 'rich-editor-token-popover-selector-tab-container' },
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-popover-selector-tab-option', { active: selectedTab === PropertyNamespaces.USER }), onClick: onUserTabClick },
        'User'
      ),
      React.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-popover-selector-tab-option', { active: selectedTab === PropertyNamespaces.CLEARBIT }), onClick: onClearbitTabClick },
        'Clearbit'
      )
    ),
    React.createElement(
      'div',
      { className: 'rich-editor-token-popover-options' },
      selectedTab === PropertyNamespaces.USER && userProperties.map(function (_ref2) {
        var displayName = _ref2.displayName,
            name = _ref2.name,
            namespaceOverride = _ref2.namespaceOverride;
        return React.createElement(
          'div',
          { key: name, className: 'rich-editor-token-popover-option', onClick: function onClick() {
              return onPropertySelect(name, namespaceOverride || PropertyNamespaces.USER);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag___default.a, { className: 'rich-editor-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'rich-editor-token-popover-option-name' },
            displayName
          )
        );
      }),
      selectedTab === PropertyNamespaces.CLEARBIT && clearbitProperties.map(function (_ref3) {
        var displayName = _ref3.displayName,
            name = _ref3.name;
        return React.createElement(
          'div',
          { key: name, className: 'rich-editor-token-popover-option', onClick: function onClick() {
              return onPropertySelect(name, PropertyNamespaces.CLEARBIT);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag___default.a, { className: 'rich-editor-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'rich-editor-token-popover-option-name' },
            displayName
          )
        );
      }),
      selectedTab == PropertyNamespaces.DEMANDBASE && __WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseProperties__["a" /* default */].map(function (_ref4) {
        var displayName = _ref4.displayName,
            name = _ref4.name;
        return React.createElement(
          'div',
          { key: name, className: 'rich-editor-token-popover-option', onClick: function onClick() {
              return onPropertySelect(name, PropertyNamespaces.DEMANDBASE);
            } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag___default.a, { className: 'rich-editor-token', tag: { name: name } }),
          React.createElement(
            'span',
            { className: 'rich-editor-token-popover-option-name' },
            displayName
          )
        );
      }),
      React.createElement(
        __WEBPACK_IMPORTED_MODULE_14_components_shared_ConditionalRender__["a" /* default */],
        { className: 'popover-selector-empty-options', condition: noPropertiesShown },
        React.createElement(__WEBPACK_IMPORTED_MODULE_4_svg_inline_react___default.a, { src: __WEBPACK_IMPORTED_MODULE_21__svg_inline_removeTags_true_images_svg_social_splash_svg___default.a }),
        React.createElement(
          'p',
          null,
          'There are no personalization attributes matching your search.'
        )
      )
    )
  );
};

var TokenPopoverConfirm = function TokenPopoverConfirm(_ref5) {
  var onDefaultCancel = _ref5.onDefaultCancel,
      onDefaultConfirm = _ref5.onDefaultConfirm,
      selectedProperty = _ref5.selectedProperty,
      onDefaultChange = _ref5.onDefaultChange;
  return React.createElement(
    'div',
    { className: 'popover-selector-container' },
    React.createElement(
      'div',
      { className: 'popover-selector-section popover-selector-section-top' },
      React.createElement(
        'div',
        { className: 'popover-selector-property-preview' },
        selectedProperty.name
      ),
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'link' },
        'Edit'
      )
    ),
    React.createElement(
      'div',
      { className: 'drift-form popover-token-confirm-form' },
      React.createElement(
        'label',
        { className: 'default-form-label' },
        'Default Value:'
      ),
      React.createElement('input', { type: 'text', placeholder: 'enter default...', onChange: onDefaultChange }),
      React.createElement(
        'p',
        { className: 'default-form-extra-details' },
        'Default values display when a contact doesn\u2018t have a value for this variable'
      )
    ),
    React.createElement(
      'div',
      { className: 'popover-selector-section' },
      React.createElement(
        'div',
        { onClick: onDefaultCancel, className: 'popover-selector-section-button drift-button drift-button-secondary' },
        'Cancel'
      ),
      React.createElement(
        'div',
        { onClick: onDefaultConfirm, className: 'popover-selector-section-button drift-button drift-button-primary' },
        'Insert'
      )
    )
  );
};

var TokenPopover = function TokenPopover(props) {
  return React.createElement(
    'div',
    {
      className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-popover', { 'rich-editor-popover-bottom-anchor': !!props.popoverAnchorBottom })
    },
    props.popoverStep === TokenPopoverSteps.SELECT && React.createElement(TokenPopoverSelect, props),
    props.popoverStep === TokenPopoverSteps.CONFIRM && React.createElement(TokenPopoverConfirm, props)
  );
};

var TokenButton = function TokenButton(props) {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_8_react_tether___default.a,
    {
      attachment: 'top left',
      targetAttachment: 'top right',
      targetOffset: '0 10px',
      constraints: [{ to: 'scrollParent', attachment: 'together' }]
    },
    React.createElement(
      'div',
      { className: 'rich-editor-token-button-container' },
      React.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('rich-editor-token-button', 'rich-editor-toolbar-button', { active: props.popoverOpen }),
          onClick: props.togglePopoverOpen
        },
        'Personalization'
      ),
      props.popoverOpen && React.createElement(TokenPopover, props)
    )
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userProperties: Object(__WEBPACK_IMPORTED_MODULE_17_app_modules_endUser_attribute_selectors__["c" /* properties */])(state).toArray(),
    hideClearbitTab: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_2" /* getIsEmailPlaybook */](state),
    hasClearbitEnabled: __WEBPACK_IMPORTED_MODULE_13_app_modules_playbook_selectors__["_26" /* hasEnterpriseActions */](state),
    hasDemandbase: Object(__WEBPACK_IMPORTED_MODULE_20_app_modules_integrations_selectors__["l" /* isConnectedTo */])(state, 'demandbase'),
    hasABM: Object(__WEBPACK_IMPORTED_MODULE_12_app_modules_gates_selectors__["u" /* makeHasGate */])('ABM')(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      fetchAttributes: __WEBPACK_IMPORTED_MODULE_18_app_modules_endUser_attribute_actions__["a" /* fetchAttributes */]
    }, dispatch)
  };
};

var TokenButtonContainer = Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["b" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["d" /* lifecycle */])({
  componentWillMount: function componentWillMount() {
    this.props.actions.fetchAttributes();
  }
}), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('selectedProperty', 'setSelectedProperty', undefined), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('selectedNamespace', 'setSelectedNamespace', undefined), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('selectedTab', 'setSelectedTab', PropertyNamespaces.USER), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('popoverStep', 'setPopoverStep', TokenPopoverSteps.SELECT), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('popoverOpen', 'setPopoverOpen', false), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('search', 'setSearch', ''), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["j" /* withState */])('defaultValue', 'setDefaultValue', undefined), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["h" /* withHandlers */])({
  onPropertySelect: function onPropertySelect(props) {
    return function (name, namespace) {
      var selectedProperty = extraProperties.filter(function (prop) {
        return prop.displayNamespace === PropertyNamespaces.USER;
      }).filter(function (prop) {
        return !prop.requiresABM || props.hasABM;
      }).concat(props.userProperties).find(function (property) {
        return property.get('name') === name;
      });
      if (namespace === PropertyNamespaces.CLEARBIT) {
        selectedProperty = new __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_models__["b" /* Property */](__WEBPACK_IMPORTED_MODULE_15_constants_ClearbitProperties__["a" /* default */].find(function (property) {
          return property.name === name;
        }));
      }
      if (namespace === PropertyNamespaces.DEMANDBASE) {
        selectedProperty = new __WEBPACK_IMPORTED_MODULE_19_app_modules_endUser_attribute_models__["b" /* Property */](__WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseProperties__["a" /* default */].find(function (property) {
          return property.name === name;
        }));
      }
      props.setSelectedNamespace(namespace);
      props.setSelectedProperty(selectedProperty);
      props.setPopoverStep(TokenPopoverSteps.CONFIRM);
    };
  },
  onDefaultConfirm: function onDefaultConfirm(props) {
    return function () {
      props.setPopoverStep(TokenPopoverSteps.SELECT);
      var defaultValue = props.defaultValue ? ' or "' + props.defaultValue + '"' : '';
      var insertVal = '{{ ' + tokenStringFromProperty(props.selectedProperty, props.selectedNamespace) + defaultValue + ' }}';
      insertToken(insertVal, props.editorState, props.onChange);
      props.setPopoverOpen(false);
    };
  },
  onClearbitTabClick: function onClearbitTabClick(props) {
    return function () {
      props.hasClearbitEnabled && props.setSelectedTab(PropertyNamespaces.CLEARBIT);
    };
  },
  onDemandbaseTabClick: function onDemandbaseTabClick(props) {
    return function () {
      props.hasDemandbase && props.setSelectedTab(PropertyNamespaces.DEMANDBASE);
    };
  },
  onUserTabClick: function onUserTabClick(props) {
    return function () {
      props.setSelectedTab(PropertyNamespaces.USER);
    };
  },
  onDefaultCancel: function onDefaultCancel(props) {
    return function () {
      props.setSelectedNamespace(undefined);
      props.setSelectedProperty(undefined);
      props.setDefaultValue(undefined);
      props.setPopoverStep(TokenPopoverSteps.SELECT);
    };
  },
  togglePopoverOpen: function togglePopoverOpen(props) {
    return function () {
      props.setPopoverOpen(!props.popoverOpen);
    };
  },
  onSearchChange: function onSearchChange(props) {
    return function (event) {
      props.setSearch(event.target.value);
    };
  },
  onDefaultChange: function onDefaultChange(props) {
    return function (event) {
      // make sure to escape double quotes
      props.setDefaultValue(event.target.value.replace('"', '\\"'));
    };
  },
  onClickOutside: function onClickOutside(props) {
    return function () {
      props.setPopoverOpen(false);
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["i" /* withProps */])(function (props) {
  var userProperties = extraProperties.filter(function (prop) {
    return prop.displayNamespace === PropertyNamespaces.USER;
  }).filter(function (prop) {
    return !prop.requiresABM || props.hasABM;
  }).concat(props.userProperties);
  if (!props.search) {
    return {
      clearbitProperties: __WEBPACK_IMPORTED_MODULE_15_constants_ClearbitProperties__["a" /* default */],
      userProperties: userProperties,
      demandbaseProperties: __WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseProperties__["a" /* default */]
    };
  } else {
    var fuseConfig = { keys: ['displayName', 'name'] };
    var userFuse = new __WEBPACK_IMPORTED_MODULE_7_fuse_js___default.a(userProperties, fuseConfig);
    var clearbitFuse = new __WEBPACK_IMPORTED_MODULE_7_fuse_js___default.a(__WEBPACK_IMPORTED_MODULE_15_constants_ClearbitProperties__["a" /* default */], fuseConfig);
    var demandbaseFuse = new __WEBPACK_IMPORTED_MODULE_7_fuse_js___default.a(__WEBPACK_IMPORTED_MODULE_16_constants_DemandbaseProperties__["a" /* default */], fuseConfig);
    return {
      userProperties: userFuse.search(props.search),
      clearbitProperties: clearbitFuse.search(props.search),
      demandbaseProperties: demandbaseFuse.search(props.search)
    };
  }
}), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["i" /* withProps */])(function (props) {
  return {
    noPropertiesShown: props.selectedTab === PropertyNamespaces.USER && props.userProperties.length === 0 || props.selectedTab === PropertyNamespaces.CLEARBIT && props.clearbitProperties.length === 0 || props.selectedTab === PropertyNamespaces.DEMANDBASE && props.demandbaseProperties.length === 0
  };
}), Object(__WEBPACK_IMPORTED_MODULE_6_recompose__["a" /* branch */])(function (_ref6) {
  var noPersonalization = _ref6.noPersonalization;
  return noPersonalization;
}, __WEBPACK_IMPORTED_MODULE_6_recompose__["g" /* renderNothing */]), __WEBPACK_IMPORTED_MODULE_10_react_onclickoutside_decorator___default.a)(TokenButton);

var ENTITY_TYPE = 'token';

var TokenDecorator = {
  strategy: __WEBPACK_IMPORTED_MODULE_2_draft_extend__["pluginUtils"].entityStrategy(ENTITY_TYPE),
  component: function component(props) {
    return React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_web_src_components_Tag___default.a, { className: 'rich-editor-token', tag: { name: props.children } });
  }
};

var entityToHTML = function entityToHTML(entity, originalText) {
  if (entity.type === ENTITY_TYPE) {
    return entity.data.value;
  }
  return originalText;
};

var textToEntity = function textToEntity(text) {
  var results = [];
  var pattern = /\{\{[\s\w\.\'\"\\\|\(\)]+\}\}/g;
  text.replace(pattern, function (match, offset) {
    results.push({
      offset: offset,
      length: match.length,
      entity: __WEBPACK_IMPORTED_MODULE_0_draft_js__["Entity"].create(ENTITY_TYPE, 'IMMUTABLE', { value: match }),
      result: match
    });
  });
  return results;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_draft_extend__["createPlugin"])({
  decorators: TokenDecorator,
  buttons: TokenButtonContainer,
  textToEntity: textToEntity,
  entityToHTML: entityToHTML
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "zjfJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"UISelect":"UISelect---1sL2F"};

/***/ }),

/***/ "zkCP":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "znuk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("BAeu"))(478);

/***/ }),

/***/ "znyU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClearbitRevealContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_app_modules_gates_selectors__ = __webpack_require__("OWv3");



var getClearbitRevealContext = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_app_modules_gates_selectors__["c" /* getGates */], function (gates) {
  return getClearbitRevealFromGates(gates);
});

var getClearbitRevealFromGates = function getClearbitRevealFromGates(gates) {
  var hasReveal = gates.has('has_reveal');
  var hasLiveReveal = gates.has('has_live_reveal');
  var hasProReveal = gates.has('has_pro_reveal');
  var hasConvoReveal = gates.has('has_conversations_reveal') && gates.get('has_conversations_reveal');
  var hasTargetingReveal = gates.has('has_targeting_reveal');
  var hasCrmReveal = gates.has('has_crm_reveal');

  return {
    hasRevealIntegration: hasReveal,
    hasProReveal: hasProReveal,
    liveReveal: hasLiveReveal,
    conversationsReveal: hasConvoReveal,
    targetingReveal: hasTargetingReveal,
    crmReveal: hasCrmReveal,
    leadRoutingReveal: gates.has('has_lead_routing_reveal'),
    abmReveal: gates.has('has_abm_routing_reveal'),
    isEligibleForLiveRevealUpgradeFlow: hasProReveal && hasLiveReveal === false,
    isEligibleForTargetingUpgradeFlow: hasProReveal && hasTargetingReveal === false
  };
};

/***/ }),

/***/ "zo08":
/***/ (function(module, exports) {

module.exports = "<svg width=\"26\" height=\"21\" viewBox=\"0 0 26 21\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.11 9.16a4.084 4.084 0 0 1-4.087 4.075v4.076a1.017 1.017 0 0 1-1.02 1.018 1.03 1.03 0 0 1-.508-.133l-6.915-3.94H6.722v5.092a1.02 1.02 0 0 1-1.02 1.02 1.02 1.02 0 0 1-1.023-1.02v-5.093H2.635a2.042 2.042 0 0 1-2.043-2.037V6.104c0-1.123.916-2.038 2.043-2.038h9.944l6.915-3.94a1.02 1.02 0 0 1 1.528.884v4.075A4.086 4.086 0 0 1 25.11 9.16zM4.68 6.104H2.635v6.113H4.68V6.104zm14.3-3.338L13.358 5.97a.984.984 0 0 1-.543.116c-.03.003-.058.018-.09.018H6.724v6.113h6.128c.022 0 .04.01.06.01.068.005.132.023.2.042.066.016.13.032.192.062.018.01.038.008.056.018l5.622 3.205V2.765zm2.043 4.357v4.075a2.044 2.044 0 0 0 2.043-2.038 2.043 2.043 0 0 0-2.043-2.037z\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg>"

/***/ }),

/***/ "zrFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return regions; });
var regions = {
  northeast: ["Connecticut", "Delaware", "Maine", "Maryland", "Massachusetts", "New Hampshire", "New Jersey", "New York", "Pennsylvania", "Rhode Island", "Vermont"],
  south: ["Alabama", "Arkansas", "Florida", "Georgia", "Kentucky", "Louisiana", "Mississippi", "North Carolina", "South Carolina", "Tennessee", "Texas", "Virginia", "West Virginia"],
  west: ["Alaska", "Arizona", "California", "Colorado", "Hawaii", "Idaho", "Montana", "Nevada", "New Mexico", "Oregon", "Utah", "Washington", "Wyoming"],
  midwest: ["Illinois", "Indiana", "Iowa", "Kansas", "Michigan", "Minnesota", "Missouri", "Nebraska", "North Dakota", "Ohio", "Oklahoma", "South Dakota", "Wisconsin"]
};

/***/ }),

/***/ "zu27":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Marty) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__ = __webpack_require__("CpSP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__ = __webpack_require__("qwEQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__driftt_dapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__driftt_dapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__ = __webpack_require__("nJx7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_DateHelpers__ = __webpack_require__("97t2");





var EndUserAPI = Marty.createStateSource({
  id: 'EndUserAPI',
  type: 'http',
  baseUrl: __WEBPACK_IMPORTED_MODULE_0_constants_ResourcesConstants__["j" /* CUSTOMER_API */],

  fetchEndUser: function fetchEndUser(endUserId) {
    return this.get({
      url: '/end_users/' + endUserId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchEndUserTimeLine: function fetchEndUserTimeLine(endUserId, query) {
    return this.get({
      url: '/end_users/' + endUserId + '/timeline?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])(query),
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchEndUsers: function fetchEndUsers(endUserIds) {
    return this.post({
      url: '/end_users/find',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify({
        endUserIds: endUserIds
      })
    });
  },
  fetchEndUserSegments: function fetchEndUserSegments(endUserId, orgId) {
    return this.get({
      url: '/end_users/' + endUserId + '/memberships?orgId=' + orgId,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  createEndUserForOrgId: function createEndUserForOrgId(endUser, orgId) {
    return this.post({
      url: '/organizations/' + orgId + '/end_users',
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(endUser)
    });
  },
  searchEndUser: function searchEndUser(orgId, query) {
    return this.get({
      url: '/organizations/' + orgId + '/end_users/search?q=' + encodeURI(query),
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchOrgEndUserCountHistory: function fetchOrgEndUserCountHistory(orgId, startDate, endDate) {
    var queryParams = Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["h" /* serializeObject */])({
      startDate: Object(__WEBPACK_IMPORTED_MODULE_3_utils_DateHelpers__["d" /* toISOLocalDateString */])(startDate),
      endDate: Object(__WEBPACK_IMPORTED_MODULE_3_utils_DateHelpers__["d" /* toISOLocalDateString */])(endDate)
    });
    return this.get({
      url: '/organizations/' + orgId + '/end_users/count/histogram?' + queryParams,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  fetchOrgEndUserCount: function fetchOrgEndUserCount(orgId, startDate) {
    var query = startDate ? '?startDate=' + startDate : '';
    return this.get({
      url: '/organizations/' + orgId + '/end_users/count' + query,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  elasticSearchEndUser: function elasticSearchEndUser(orgId, query, from, size, sortField, sortDirection) {
    var sizeQuery = {};
    if (from != null) {
      sizeQuery.from = from;
    }
    if (size != null) {
      sizeQuery.size = size;
    }
    var sortQuery = {};
    if (sortField != null) {
      sortQuery.sortField = sortField;
    }
    if (sortDirection != null) {
      sortQuery.sortDirection = sortDirection;
    }
    return this.post({
      url: '/organizations/' + orgId + '/end_users/search?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])(sizeQuery) + '&' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])(sortQuery),
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: query
    });
  },
  updateEndUser: function updateEndUser(endUserId, endUserParams, accessToken) {
    return this.patch({
      url: '/end_users/' + endUserId,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(accessToken),
      body: JSON.stringify(endUserParams)
    });
  },
  deleteBySegment: function deleteBySegment(orgId, segmentId) {
    return __WEBPACK_IMPORTED_MODULE_1__driftt_dapper__["CustomerAPI"].delete('/organizations/' + orgId + '/end_users/user_list/' + segmentId);
  },
  unsubscribeEndUser: function unsubscribeEndUser(endUserId, campaignId, reason) {
    if (campaignId) {
      return this.post({ url: '/unsubscribe/enduser/' + endUserId + '?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])({ campaignId: campaignId, reason: reason }) });
    } else {
      return this.post({ url: '/unsubscribe/enduser/' + endUserId + '?' + Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["d" /* encodeQueryData */])({ reason: reason }) });
    }
  },
  fetchEndUserAttributesForOrg: function fetchEndUserAttributesForOrg(orgId) {
    return this.get({
      url: '/organizations/' + orgId + '/end_users/attributes2',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  uploadFileToImportEndUsers: function uploadFileToImportEndUsers(file) {
    var data = new FormData();
    data.append('file', file);
    return this.post({
      url: '/csvimport',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].FORM_DATA,
      body: data
    });
  },
  getCSVImport: function getCSVImport(id) {
    return this.get({
      url: '/csvimport/' + id,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])()
    });
  },
  updateCSVImport: function updateCSVImport(id, params) {
    return this.patch({
      url: '/csvimport/' + id,
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      body: JSON.stringify(params)
    });
  },
  initiateCSVImport: function initiateCSVImport(id, mapping) {
    return this.post({
      url: '/csvimport/' + id + '/start',
      headers: Object(__WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["f" /* getAuthorizationHeader */])(),
      contentType: __WEBPACK_IMPORTED_MODULE_2_utils_Helpers__["b" /* RequestContentType */].JSON,
      body: JSON.stringify(mapping)
    });
  }
});

/* harmony default export */ __webpack_exports__["default"] = (EndUserAPI);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ }),

/***/ "zvkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(React) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_conversation_AssignDropdown__ = __webpack_require__("oD5e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_DropDown__ = __webpack_require__("OvX3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style__ = __webpack_require__("UQNy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style__);
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.







var SendFromEdit = React.createClass({
  displayName: 'SendFromEdit',

  mixins: [__webpack_require__("aCGJ")],

  getInitialState: function getInitialState() {
    return { showDropdown: false };
  },
  handleClickOutside: function handleClickOutside() {
    return this.setState({ showDropdown: false });
  },
  handleOnClick: function handleOnClick() {
    return this.setState({ showDropdown: !this.state.showDropdown });
  },
  renderDropDown: function renderDropDown() {
    return React.createElement(
      __WEBPACK_IMPORTED_MODULE_1_components_DropDown__["a" /* default */],
      { className: 'assign-dropdown', onClickOutside: this.handleClickOutside },
      React.createElement(__WEBPACK_IMPORTED_MODULE_0_components_conversation_AssignDropdown__["a" /* default */], {
        handleUserRowOnClick: this.onSenderSelect,
        assignee: this.props.user,
        calendarUsersOnly: this.props.calendarUsersOnly })
    );
  },
  onSenderSelect: function onSenderSelect(userId) {
    this.setState({ showDropdown: false });
    return this.props.onSenderSelect(userId);
  },
  clearSender: function clearSender(event) {
    return this.props.onSenderSelect(null);
  },
  render: function render() {
    return React.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_2__style___default.a.SendFromEdit },
      React.createElement(
        'div',
        { className: 'link', onClick: this.handleOnClick },
        this.props.user ? 'Edit' : 'Add'
      ),
      this.props.enableClear && this.props.user ? React.createElement(
        'div',
        { className: 'link', onClick: this.clearSender },
        'Clear'
      ) : undefined,
      this.state.showDropdown ? this.renderDropDown() : undefined
    );
  }
});

/* harmony default export */ __webpack_exports__["a"] = (SendFromEdit);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("U7vG")))

/***/ }),

/***/ "zvtT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__("BYKG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__("QFmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("qK29");
var _handleActions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var TypingState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  typingUsersByConversationId: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* TYPING */], function (state, action) {
  var _action$payload = action.payload,
      userId = _action$payload.userId,
      userType = _action$payload.userType,
      conversationId = _action$payload.conversationId;

  return state.updateIn(['typingUsersByConversationId', conversationId], function () {
    var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();

    return users.add(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([userType, userId]));
  });
}), _defineProperty(_handleActions, __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* TYPING_FINISHED */], function (state, action) {
  var _action$payload2 = action.payload,
      userId = _action$payload2.userId,
      userType = _action$payload2.userType,
      conversationId = _action$payload2.conversationId;

  return state.updateIn(['typingUsersByConversationId', conversationId], function () {
    var users = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();

    return users.remove(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([userType, userId]));
  });
}), _handleActions), TypingState()));

/***/ }),

/***/ "zyQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Marty) {// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
var CampaignConstants = Marty.createConstants(['CAMPAIGN_CREATE', 'CAMPAIGN_UPDATE', 'CAMPAIGN_FETCH', 'CAMPAIGNS_FETCH', 'CAMPAIGNS_FOR_END_USER_FETCH', 'CAMPAIGN_RESULTS_FETCH', 'CAMPAIGN_MEMBERS_FETCH', 'CAMPAIGN_RESPONSES_FETCH', 'SAVE_ANNOUNCEMENT_DRAFT', 'SAVE_NPS_DRAFT', 'CAMPAIGN_DELETE', 'SEND_TEST_CAMPAIGN']);

CampaignConstants.SELECTED_END_USER_IDS_FOR_CAMPAIGN_KEY = 'selectedEndUserIdsForCampaign';

/* harmony default export */ __webpack_exports__["a"] = (CampaignConstants);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("y6Nj")))

/***/ })

},[0]);


// WEBPACK FOOTER //
// main.911f4239c93f55fa6d45.js